// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
const $0d4b25392f45f74c$export$4add775dfee37121 = function(fs) {
    return function(xs) {
        var l = fs.length;
        var k = xs.length;
        var result = new Array(l * k);
        var n = 0;
        for(var i = 0; i < l; i++){
            var f = fs[i];
            for(var j = 0; j < k; j++)result[n++] = f(xs[j]);
        }
        return result;
    };
};


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
var $5807467a73465f3c$export$3af17640bddf7212 = {
    compose: function(f) {
        return function(g) {
            return function(x) {
                return f(g(x));
            };
        };
    }
};
var $5807467a73465f3c$export$f672e0b6f7222cd7 = function(dict) {
    return dict.compose;
};
var $5807467a73465f3c$export$b5a9558a7176e41b = function(dictSemigroupoid) {
    var compose1 = $5807467a73465f3c$export$f672e0b6f7222cd7(dictSemigroupoid);
    return function(f) {
        return function(g) {
            return compose1(g)(f);
        };
    };
};


var $5be483788e0e6f04$export$f0954fd7d5368655 = function(dict) {
    return dict.identity;
};
var $5be483788e0e6f04$export$7037e3b2ba3bd7aa = {
    identity: function(x) {
        return x;
    },
    Semigroupoid0: function() {
        return $5807467a73465f3c$export$3af17640bddf7212;
    }
};


// Generated by purs version 0.15.15

// Generated by purs version 0.15.15
var $5089f43af3d55e5d$export$4bed41887d8c5096 = true;


var $f57f4b701aa7b66e$export$af631764ddc44097 = function(f) {
    return function(g) {
        return function(x) {
            return function(y) {
                return f(g(x))(g(y));
            };
        };
    };
};
var $f57f4b701aa7b66e$export$8a83211c878a3f1f = function(f) {
    return function(b) {
        return function(a) {
            return f(a)(b);
        };
    };
};
var $f57f4b701aa7b66e$export$5b38a098e5a9e7ca = function(a) {
    return function(v) {
        return a;
    };
};
var $f57f4b701aa7b66e$export$32c25ff0a0410173 = function(f) {
    var go = function($copy_n) {
        return function($copy_acc) {
            var $tco_var_n = $copy_n;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(n, acc) {
                if (n <= 0) {
                    $tco_done = true;
                    return acc;
                }
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    $tco_var_n = n - 1 | 0;
                    $copy_acc = f(acc);
                    return;
                }
                throw new Error("Failed pattern match at Data.Function (line 107, column 3 - line 109, column 37): " + [
                    n.constructor.name,
                    acc.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_n, $copy_acc);
            return $tco_result;
        };
    };
    return go;
};
var $f57f4b701aa7b66e$export$5f9c390da86b6e49 = function(x) {
    return function(f) {
        return f(x);
    };
};
var $f57f4b701aa7b66e$export$5635d7ef4b8fee1c = function(f) {
    return function(x) {
        return f(x);
    };
};


// Generated by purs version 0.15.15
const $889a8f7c70c4a41c$export$dc30017ac4432edc = function(f) {
    return function(arr) {
        var l = arr.length;
        var result = new Array(l);
        for(var i = 0; i < l; i++)result[i] = f(arr[i]);
        return result;
    };
};




// Generated by purs version 0.15.15
const $05149ea687d6b460$export$523c0b569236b342 = undefined;




// Generated by purs version 0.15.15
var $c6a0478cbb9b5a21$export$accffb5fb4579e0d = /* #__PURE__ */ function() {
    function $$Proxy() {}
    $$Proxy.value = new $$Proxy();
    return $$Proxy;
}();


var $f4b2eb11fc32ed34$export$871de8747c9eaa88 = function(dict) {
    return dict.map;
};
var $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(fa) {
        return function(f) {
            return map1(f)(fa);
        };
    };
};
var $f4b2eb11fc32ed34$export$490e536ee7389aeb = function(dictFunctor) {
    return $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($05149ea687d6b460$export$523c0b569236b342));
};
var $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(x) {
            return map1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(x))(f);
        };
    };
};
var $f4b2eb11fc32ed34$export$b818c54ed8d3e90a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(x) {
        return map1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(x));
    };
};
var $f4b2eb11fc32ed34$export$816e5e05deb8955e = {
    map: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    }
};
var $f4b2eb11fc32ed34$export$11c8d16a3c15d11b = {
    map: /* #__PURE__ */ $5807467a73465f3c$export$f672e0b6f7222cd7($5807467a73465f3c$export$3af17640bddf7212)
};
var $f4b2eb11fc32ed34$export$2330f868b62ed546 = {
    map: $889a8f7c70c4a41c$export$dc30017ac4432edc
};
var $f4b2eb11fc32ed34$export$18c957606d8bdf09 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(ff) {
        return function(x) {
            return map1(function(f) {
                return f(x);
            })(ff);
        };
    };
};



var $7576d3a958d66ab0$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $7576d3a958d66ab0$export$e24166bf2f1a6c73 = {
    apply: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$816e5e05deb8955e;
    }
};
var $7576d3a958d66ab0$export$2f68caa5c730775d = {
    apply: function(f) {
        return function(g) {
            return function(x) {
                return f(x)(g(x));
            };
        };
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$11c8d16a3c15d11b;
    }
};
var $7576d3a958d66ab0$export$60d7bd9d686a5521 = {
    apply: $0d4b25392f45f74c$export$4add775dfee37121,
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $7576d3a958d66ab0$export$5635d7ef4b8fee1c = function(dict) {
    return dict.apply;
};
var $7576d3a958d66ab0$export$e48e2da4536c2eea = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(a) {
        return function(b) {
            return apply1(map($f57f4b701aa7b66e$export$5b38a098e5a9e7ca)(a))(b);
        };
    };
};
var $7576d3a958d66ab0$export$3d5d566a030a20fc = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(a) {
        return function(b) {
            return apply1(map($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($7576d3a958d66ab0$var$identity))(a))(b);
        };
    };
};
var $7576d3a958d66ab0$export$f016650e64b51e7d = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return apply1(map(f)(a))(b);
            };
        };
    };
};
var $7576d3a958d66ab0$export$30190e46300cc996 = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return apply1(apply1(map(f)(a))(b))(c);
                };
            };
        };
    };
};
var $7576d3a958d66ab0$export$6659660f0e855aea = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return apply1(apply1(apply1(map(f)(a))(b))(c))(d);
                    };
                };
            };
        };
    };
};
var $7576d3a958d66ab0$export$6c80f2f7f1ad8105 = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return function(e) {
                            return apply1(apply1(apply1(apply1(map(f)(a))(b))(c))(d))(e);
                        };
                    };
                };
            };
        };
    };
};





var $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557 = function(dict) {
    return dict.pure;
};
var $c50cfdb0b9e8fa31$export$6f0673371501d6b6 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return function(v1) {
            if (!v) return v1;
            if (v) return pure1($05149ea687d6b460$export$523c0b569236b342);
            throw new Error("Failed pattern match at Control.Applicative (line 68, column 1 - line 68, column 65): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $c50cfdb0b9e8fa31$export$a55877ca9db47377 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return function(v1) {
            if (v) return v1;
            if (!v) return pure1($05149ea687d6b460$export$523c0b569236b342);
            throw new Error("Failed pattern match at Control.Applicative (line 63, column 1 - line 63, column 63): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $c50cfdb0b9e8fa31$export$53544bd8de5a7427 = function(dictApplicative) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApplicative.Apply0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(f) {
        return function(a) {
            return apply(pure1(f))(a);
        };
    };
};
var $c50cfdb0b9e8fa31$export$598532d07e20ffc2 = {
    pure: function(v) {
        return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$e24166bf2f1a6c73;
    }
};
var $c50cfdb0b9e8fa31$export$e68c32b2a06f106c = {
    pure: function(x) {
        return function(v) {
            return x;
        };
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$2f68caa5c730775d;
    }
};
var $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e = {
    pure: function(x) {
        return [
            x
        ];
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$60d7bd9d686a5521;
    }
};


// Generated by purs version 0.15.15
const $e001a8e6e4264547$export$4d853d3353098e5a = typeof Array.prototype.flatMap === "function" ? function(arr) {
    return function(f) {
        return arr.flatMap(f);
    };
} : function(arr) {
    return function(f) {
        var result = [];
        var l = arr.length;
        for(var i = 0; i < l; i++){
            var xs = f(arr[i]);
            var k = xs.length;
            for(var j = 0; j < k; j++)result.push(xs[j]);
        }
        return result;
    };
};








var $70cd3177464e7915$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $70cd3177464e7915$export$584af591d945b55a = function(dict) {
    return dict.discard;
};
var $70cd3177464e7915$export$6dbdf4766af04452 = {
    bind: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$e24166bf2f1a6c73;
    }
};
var $70cd3177464e7915$export$2c348afe2becdb4f = {
    bind: function(m) {
        return function(f) {
            return function(x) {
                return f(m(x))(x);
            };
        };
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$2f68caa5c730775d;
    }
};
var $70cd3177464e7915$export$794f9574ca20b986 = {
    bind: $e001a8e6e4264547$export$4d853d3353098e5a,
    Apply0: function() {
        return $7576d3a958d66ab0$export$60d7bd9d686a5521;
    }
};
var $70cd3177464e7915$export$2385a24977818dd0 = function(dict) {
    return dict.bind;
};
var $70cd3177464e7915$export$f2077a1c19a006d9 = function(dictBind) {
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f($70cd3177464e7915$export$2385a24977818dd0(dictBind));
};
var $70cd3177464e7915$export$ea9fbbe247ef8e50 = function(dictBind) {
    var bindFlipped1 = $70cd3177464e7915$export$f2077a1c19a006d9(dictBind);
    return function(f) {
        return function(g) {
            return function(a) {
                return bindFlipped1(f)(g(a));
            };
        };
    };
};
var $70cd3177464e7915$export$61a2047e1b1e0d3e = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(f) {
        return function(g) {
            return function(a) {
                return bind1(f(a))(g);
            };
        };
    };
};
var $70cd3177464e7915$export$9a012077684d4c76 = {
    discard: function(dictBind) {
        return $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    }
};
var $70cd3177464e7915$export$f73711e565ded7e = {
    discard: function(dictBind) {
        return $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    }
};
var $70cd3177464e7915$export$2937bb6ffdfdda28 = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(cond) {
        return function(t) {
            return function(f) {
                return bind1(cond)(function(cond$prime) {
                    if (cond$prime) return t;
                    return f;
                });
            };
        };
    };
};
var $70cd3177464e7915$export$f7e2c8231c57a8bd = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(m) {
        return bind1(m)($70cd3177464e7915$var$identity);
    };
};



// Generated by purs version 0.15.15
// Generated by purs version 0.15.15


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15

// Generated by purs version 0.15.15
const $b693645c2c75f222$export$171e7edd26203a84 = function(s1) {
    return function(s2) {
        return s1 + s2;
    };
};
const $b693645c2c75f222$export$4fd8af2c48c43416 = function(xs) {
    return function(ys) {
        if (xs.length === 0) return ys;
        if (ys.length === 0) return xs;
        return xs.concat(ys);
    };
};


// Generated by purs version 0.15.15
// module Data.Symbol
const $bb08fe6cef393d6b$export$401372c57776dc = function(arg) {
    return arg;
};



var $1f7f00687c3959c5$export$340e995c37375b7a = function(s) {
    return function(f) {
        return $bb08fe6cef393d6b$export$401372c57776dc(function(dictIsSymbol) {
            return f(dictIsSymbol);
        })({
            reflectSymbol: function(v) {
                return s;
            }
        })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
    };
};
var $1f7f00687c3959c5$export$e5ed8a20a1c4d576 = function(dict) {
    return dict.reflectSymbol;
};



// Generated by purs version 0.15.15
var $58f3cdfbfe212d20$var$Void = function(x) {
    return x;
};
var $58f3cdfbfe212d20$export$f172309911142386 = function(a) {
    var spin = function($copy_v) {
        var $tco_result;
        function $tco_loop(v) {
            $copy_v = v;
            return;
        }
        while(true)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return spin(a);
};


// Generated by purs version 0.15.15
const $d2fadbdf02925823$export$12c1b2b255bc527d = function(label) {
    return function(rec) {
        return ({}).hasOwnProperty.call(rec, label);
    };
};
const $d2fadbdf02925823$export$1d94535d2cda4eda = function(label) {
    return function(rec) {
        return rec[label];
    };
};
const $d2fadbdf02925823$export$444262986932b766 = function(label) {
    return function(value) {
        return function(rec) {
            var copy = {};
            for(var key in rec)if (({}).hasOwnProperty.call(rec, key)) copy[key] = rec[key];
            copy[label] = value;
            return copy;
        };
    };
};
const $d2fadbdf02925823$export$14b6a75b3eb38458 = function(label) {
    return function(rec) {
        var copy = {};
        for(var key in rec)if (key !== label && ({}).hasOwnProperty.call(rec, key)) copy[key] = rec[key];
        return copy;
    };
};





var $d7bf9817a417d4ae$export$36aabcd6b6e45f3b = {
    append: function(v) {
        return $58f3cdfbfe212d20$export$f172309911142386;
    }
};
var $d7bf9817a417d4ae$export$824c37c4afd77b1 = {
    append: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    }
};
var $d7bf9817a417d4ae$export$d9b7100b101f2c5b = {
    append: $b693645c2c75f222$export$171e7edd26203a84
};
var $d7bf9817a417d4ae$export$955753116dc9242c = {
    appendRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    }
};
var $d7bf9817a417d4ae$export$af5ddea0c4d23f3c = {
    append: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    }
};
var $d7bf9817a417d4ae$export$d082f07d0a8e9909 = {
    append: $b693645c2c75f222$export$4fd8af2c48c43416
};
var $d7bf9817a417d4ae$export$1e8e5e81637c934d = function(dict) {
    return dict.appendRecord;
};
var $d7bf9817a417d4ae$export$dbfe6b321632d7c9 = function() {
    return function(dictSemigroupRecord) {
        return {
            append: $d7bf9817a417d4ae$export$1e8e5e81637c934d(dictSemigroupRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $d7bf9817a417d4ae$export$10d8903dec122b9d = function(dict) {
    return dict.append;
};
var $d7bf9817a417d4ae$export$49c9dc4575956c55 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(f) {
            return function(g) {
                return function(x) {
                    return append1(f(x))(g(x));
                };
            };
        }
    };
};
var $d7bf9817a417d4ae$export$74eae24c3d2a7535 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(dictSemigroupRecord) {
            var appendRecord1 = $d7bf9817a417d4ae$export$1e8e5e81637c934d(dictSemigroupRecord);
            return function(dictSemigroup) {
                var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
                return {
                    appendRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = appendRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(append1(get(ra))(get(rb)))(tail);
                            };
                        };
                    }
                };
            };
        };
    };
};


var $75e93a4111e80214$export$186d613bb872946c = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909),
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $75e93a4111e80214$export$228be17d80722ab = function(dict) {
    return dict.alt;
};



// Generated by purs version 0.15.15
const $cd1cb347a48b7ff0$export$afdd678689eb299 = 2147483647;
const $cd1cb347a48b7ff0$export$4a17ba08fd82d88b = -2147483648;
const $cd1cb347a48b7ff0$export$4ffd3705721c8b5b = String.fromCharCode(65535);
const $cd1cb347a48b7ff0$export$d6be889e229abd84 = String.fromCharCode(0);
const $cd1cb347a48b7ff0$export$ef55dfccfe3a15b = Number.POSITIVE_INFINITY;
const $cd1cb347a48b7ff0$export$d1edf35dfee544b5 = Number.NEGATIVE_INFINITY;


// Generated by purs version 0.15.15
var $e07f6ef164bf0728$var$unsafeCompareImpl = function(lt) {
    return function(eq) {
        return function(gt) {
            return function(x) {
                return function(y) {
                    return x < y ? lt : x === y ? eq : gt;
                };
            };
        };
    };
};
const $e07f6ef164bf0728$export$fcb09e9654c4896a = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$654933317498633e = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$a509696eaf723ed7 = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$bfcbb0304ffa620f = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$5a20025607cdef3f = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$6d083685ddc7682f = function(f) {
    return function(xs) {
        return function(ys) {
            var i = 0;
            var xlen = xs.length;
            var ylen = ys.length;
            while(i < xlen && i < ylen){
                var x = xs[i];
                var y = ys[i];
                var o = f(x)(y);
                if (o !== 0) return o;
                i++;
            }
            if (xlen === ylen) return 0;
            else if (xlen > ylen) return -1;
            else return 1;
        };
    };
};


// Generated by purs version 0.15.15
var $f4eec6a416d226bf$var$refEq = function(r1) {
    return function(r2) {
        return r1 === r2;
    };
};
const $f4eec6a416d226bf$export$373f9c52154d3177 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$123e3cb4a5e139f4 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$9fc9964c874ac58 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$b056fd0da0447ba9 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$bb9bce33bd088a97 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$e89e5efeb0be06bc = function(f) {
    return function(xs) {
        return function(ys) {
            if (xs.length !== ys.length) return false;
            for(var i = 0; i < xs.length; i++){
                if (!f(xs[i])(ys[i])) return false;
            }
            return true;
        };
    };
};





var $37b880af5f4991bd$export$2965418ef5ae9704 = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$671c8820f3b36bad = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$fa624555ca2acbc8 = {
    eq: $f4eec6a416d226bf$export$bb9bce33bd088a97
};
var $37b880af5f4991bd$export$d12253326f924cb1 = {
    eqRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return true;
            };
        };
    }
};
var $37b880af5f4991bd$export$14e60b8fdd01f41c = function(dict) {
    return dict.eqRecord;
};
var $37b880af5f4991bd$export$691c0e424728509e = function() {
    return function(dictEqRecord) {
        return {
            eq: $37b880af5f4991bd$export$14e60b8fdd01f41c(dictEqRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $37b880af5f4991bd$export$db5a78c472a81a32 = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$e24978670be1e4f3 = {
    eq: $f4eec6a416d226bf$export$9fc9964c874ac58
};
var $37b880af5f4991bd$export$e65788c6d4494539 = {
    eq: $f4eec6a416d226bf$export$123e3cb4a5e139f4
};
var $37b880af5f4991bd$export$bcd79f9321394c38 = {
    eq: $f4eec6a416d226bf$export$b056fd0da0447ba9
};
var $37b880af5f4991bd$export$d7927e8ffc1afb48 = {
    eq: $f4eec6a416d226bf$export$373f9c52154d3177
};
var $37b880af5f4991bd$export$96fd6c73d03c9dd2 = function(dict) {
    return dict.eq1;
};
var $37b880af5f4991bd$export$9663ddc1cf085b32 = function(dict) {
    return dict.eq;
};
var $37b880af5f4991bd$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($37b880af5f4991bd$export$d7927e8ffc1afb48);
var $37b880af5f4991bd$export$159e06dc5ec60b00 = function(dictEq) {
    return {
        eq: $f4eec6a416d226bf$export$e89e5efeb0be06bc($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq))
    };
};
var $37b880af5f4991bd$export$861eb926e0b8ea5b = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($37b880af5f4991bd$export$159e06dc5ec60b00(dictEq));
    }
};
var $37b880af5f4991bd$export$730b16b2c839caa0 = function(dictEqRecord) {
    var eqRecord1 = $37b880af5f4991bd$export$14e60b8fdd01f41c(dictEqRecord);
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            return function(dictEq) {
                var eq3 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
                return {
                    eqRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = eqRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return eq3(get(ra))(get(rb)) && tail;
                            };
                        };
                    }
                };
            };
        };
    };
};
var $37b880af5f4991bd$export$5475dfc31a65c2cd = function(dictEq) {
    var eq3 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return function(y) {
            return $37b880af5f4991bd$var$eq2(eq3(x)(y))(false);
        };
    };
};
var $37b880af5f4991bd$export$d0aa07ff560ecb = function(dictEq1) {
    var eq11 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq12 = eq11(dictEq);
        return function(x) {
            return function(y) {
                return $37b880af5f4991bd$var$eq2(eq12(x)(y))(false);
            };
        };
    };
};


// Generated by purs version 0.15.15
var $5026be88823ef1f4$export$7158f0ceb70f54c7 = /* #__PURE__ */ function() {
    function LT() {}
    LT.value = new LT();
    return LT;
}();
var $5026be88823ef1f4$export$b023c82b48e70453 = /* #__PURE__ */ function() {
    function GT() {}
    GT.value = new GT();
    return GT;
}();
var $5026be88823ef1f4$export$1c0a5d05eb3f6e18 = /* #__PURE__ */ function() {
    function EQ() {}
    EQ.value = new EQ();
    return EQ;
}();
var $5026be88823ef1f4$export$c1dd7b0030d4618e = {
    show: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return "LT";
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return "GT";
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return "EQ";
        throw new Error("Failed pattern match at Data.Ordering (line 26, column 1 - line 29, column 17): " + [
            v.constructor.name
        ]);
    }
};
var $5026be88823ef1f4$export$d04ea36c3e51a408 = {
    append: function(v) {
        return function(v1) {
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return v1;
            throw new Error("Failed pattern match at Data.Ordering (line 21, column 1 - line 24, column 18): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $5026be88823ef1f4$export$6897c284b6f9f4dc = function(v) {
    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
    if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
    throw new Error("Failed pattern match at Data.Ordering (line 33, column 1 - line 33, column 31): " + [
        v.constructor.name
    ]);
};
var $5026be88823ef1f4$export$82d306ead3b703cd = {
    eq: function(v) {
        return function(v1) {
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7 && v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return true;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453 && v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return true;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15
const $6997dff57b67dccd$export$8964faf538cd4472 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x - y | 0;
    };
};
const $6997dff57b67dccd$export$592dc8db1291fc5e = function(n1) {
    return function(n2) {
        return n1 - n2;
    };
};


// Generated by purs version 0.15.15
const $d134be8d1f9fbf5c$export$3493e4651621d0b = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x + y | 0;
    };
};
const $d134be8d1f9fbf5c$export$9961c9313a91a4c2 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x * y | 0;
    };
};
const $d134be8d1f9fbf5c$export$7851ca78a7fd68e5 = function(n1) {
    return function(n2) {
        return n1 + n2;
    };
};
const $d134be8d1f9fbf5c$export$3c84e2814d77f9f0 = function(n1) {
    return function(n2) {
        return n1 * n2;
    };
};






var $c0e822be92afc4df$export$2fbd183cf91e4d96 = function(dict) {
    return dict.zeroRecord;
};
var $c0e822be92afc4df$export$7f9972325ebfd559 = function(dict) {
    return dict.zero;
};
var $c0e822be92afc4df$export$348dab40c63d4f3e = {
    add: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    zero: $05149ea687d6b460$export$523c0b569236b342,
    mul: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    one: $05149ea687d6b460$export$523c0b569236b342
};
var $c0e822be92afc4df$export$5f825cdfc30c8d7a = {
    addRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    mulRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    oneRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    zeroRecord: function(v) {
        return function(v1) {
            return {};
        };
    }
};
var $c0e822be92afc4df$export$28b7adff71d7e2f2 = /* #__PURE__ */ function() {
    return {
        add: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        mul: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        one: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        zero: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value
    };
}();
var $c0e822be92afc4df$export$f48694d6539477b9 = {
    add: $d134be8d1f9fbf5c$export$7851ca78a7fd68e5,
    zero: 0.0,
    mul: $d134be8d1f9fbf5c$export$3c84e2814d77f9f0,
    one: 1.0
};
var $c0e822be92afc4df$export$7e80d6910c05bd77 = {
    add: $d134be8d1f9fbf5c$export$3493e4651621d0b,
    zero: 0,
    mul: $d134be8d1f9fbf5c$export$9961c9313a91a4c2,
    one: 1
};
var $c0e822be92afc4df$export$e9e5a13b3096dd62 = function(dict) {
    return dict.oneRecord;
};
var $c0e822be92afc4df$export$80bf7733f1207381 = function(dict) {
    return dict.one;
};
var $c0e822be92afc4df$export$ff4422e298afd4cc = function(dict) {
    return dict.mulRecord;
};
var $c0e822be92afc4df$export$6e3a27864ab166fe = function(dict) {
    return dict.mul;
};
var $c0e822be92afc4df$export$ab0ab92b3cb31c66 = function(dict) {
    return dict.addRecord;
};
var $c0e822be92afc4df$export$93af3fe715165fc8 = function() {
    return function(dictSemiringRecord) {
        return {
            add: $c0e822be92afc4df$export$ab0ab92b3cb31c66(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            mul: $c0e822be92afc4df$export$ff4422e298afd4cc(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            one: $c0e822be92afc4df$export$e9e5a13b3096dd62(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            zero: $c0e822be92afc4df$export$2fbd183cf91e4d96(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $c0e822be92afc4df$export$e16d8520af44a096 = function(dict) {
    return dict.add;
};
var $c0e822be92afc4df$export$4946f164d066bdc5 = function(dictSemiring) {
    var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var zero1 = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
    var mul1 = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    var one1 = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
    return {
        add: function(f) {
            return function(g) {
                return function(x) {
                    return add1(f(x))(g(x));
                };
            };
        },
        zero: function(v) {
            return zero1;
        },
        mul: function(f) {
            return function(g) {
                return function(x) {
                    return mul1(f(x))(g(x));
                };
            };
        },
        one: function(v) {
            return one1;
        }
    };
};
var $c0e822be92afc4df$export$8d7f5ae13d42a4f9 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(dictSemiringRecord) {
            var addRecord1 = $c0e822be92afc4df$export$ab0ab92b3cb31c66(dictSemiringRecord);
            var mulRecord1 = $c0e822be92afc4df$export$ff4422e298afd4cc(dictSemiringRecord);
            var oneRecord1 = $c0e822be92afc4df$export$e9e5a13b3096dd62(dictSemiringRecord);
            var zeroRecord1 = $c0e822be92afc4df$export$2fbd183cf91e4d96(dictSemiringRecord);
            return function(dictSemiring) {
                var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
                var mul1 = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
                var one1 = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
                var zero1 = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
                return {
                    addRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = addRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(add1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    mulRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = mulRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(mul1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    oneRecord: function(v) {
                        return function(v1) {
                            var tail = oneRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(one1)(tail);
                        };
                    },
                    zeroRecord: function(v) {
                        return function(v1) {
                            var tail = zeroRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(zero1)(tail);
                        };
                    }
                };
            };
        };
    };
};






var $d061555d3b2c84b2$var$semiringRecord = /* #__PURE__ */ $c0e822be92afc4df$export$93af3fe715165fc8();
var $d061555d3b2c84b2$export$11a6fe76b07a0 = function(dict) {
    return dict.subRecord;
};
var $d061555d3b2c84b2$export$f93b5905241a7cca = function(dict) {
    return dict.sub;
};
var $d061555d3b2c84b2$export$e2da189c845067f9 = {
    sub: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    Semiring0: function() {
        return $c0e822be92afc4df$export$348dab40c63d4f3e;
    }
};
var $d061555d3b2c84b2$export$38dc985ea1e564cd = {
    subRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    SemiringRecord0: function() {
        return $c0e822be92afc4df$export$5f825cdfc30c8d7a;
    }
};
var $d061555d3b2c84b2$export$857cf13a2f74264d = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    var semiringRecordCons = $c0e822be92afc4df$export$8d7f5ae13d42a4f9(dictIsSymbol)();
    return function() {
        return function(dictRingRecord) {
            var subRecord1 = $d061555d3b2c84b2$export$11a6fe76b07a0(dictRingRecord);
            var semiringRecordCons1 = semiringRecordCons(dictRingRecord.SemiringRecord0());
            return function(dictRing) {
                var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
                var semiringRecordCons2 = semiringRecordCons1(dictRing.Semiring0());
                return {
                    subRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = subRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(sub1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    SemiringRecord0: function() {
                        return semiringRecordCons2;
                    }
                };
            };
        };
    };
};
var $d061555d3b2c84b2$export$492fe4fa507ea6ad = function() {
    return function(dictRingRecord) {
        var semiringRecord1 = $d061555d3b2c84b2$var$semiringRecord(dictRingRecord.SemiringRecord0());
        return {
            sub: $d061555d3b2c84b2$export$11a6fe76b07a0(dictRingRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Semiring0: function() {
                return semiringRecord1;
            }
        };
    };
};
var $d061555d3b2c84b2$export$948aff48831eff14 = {
    sub: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    },
    Semiring0: function() {
        return $c0e822be92afc4df$export$28b7adff71d7e2f2;
    }
};
var $d061555d3b2c84b2$export$194f4464e73e7816 = {
    sub: $6997dff57b67dccd$export$592dc8db1291fc5e,
    Semiring0: function() {
        return $c0e822be92afc4df$export$f48694d6539477b9;
    }
};
var $d061555d3b2c84b2$export$d40e27c88e22a303 = {
    sub: $6997dff57b67dccd$export$8964faf538cd4472,
    Semiring0: function() {
        return $c0e822be92afc4df$export$7e80d6910c05bd77;
    }
};
var $d061555d3b2c84b2$export$9f43d8c61dde305d = function(dictRing) {
    var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var semiringFn = $c0e822be92afc4df$export$4946f164d066bdc5(dictRing.Semiring0());
    return {
        sub: function(f) {
            return function(g) {
                return function(x) {
                    return sub1(f(x))(g(x));
                };
            };
        },
        Semiring0: function() {
            return semiringFn;
        }
    };
};
var $d061555d3b2c84b2$export$aef51622e549b8b0 = function(dictRing) {
    var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictRing.Semiring0());
    return function(a) {
        return sub1(zero)(a);
    };
};






var $97937c29f879e68e$var$eqRec = /* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e();
var $97937c29f879e68e$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($5026be88823ef1f4$export$82d306ead3b703cd);
var $97937c29f879e68e$export$752cdd067643c910 = {
    compare: function(v) {
        return function(v1) {
            return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        };
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$2965418ef5ae9704;
    }
};
var $97937c29f879e68e$export$f6b429625e3530b0 = {
    compare: function(v) {
        return function(v1) {
            return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        };
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$671c8820f3b36bad;
    }
};
var $97937c29f879e68e$export$c5f2758e49b2b86a = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$bfcbb0304ffa620f($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$fa624555ca2acbc8;
        }
    };
}();
var $97937c29f879e68e$export$927f7db8ecc0069f = {
    compareRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            };
        };
    },
    EqRecord0: function() {
        return $37b880af5f4991bd$export$d12253326f924cb1;
    }
};
var $97937c29f879e68e$export$55c25d215527e8e8 = {
    compare: function(v) {
        return function(v1) {
            return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        };
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$db5a78c472a81a32;
    }
};
var $97937c29f879e68e$export$dcb5533042a37f3c = {
    compare: function(v) {
        return function(v1) {
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7 && v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453 && v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            throw new Error("Failed pattern match at Data.Ord (line 126, column 1 - line 133, column 20): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $5026be88823ef1f4$export$82d306ead3b703cd;
    }
};
var $97937c29f879e68e$export$5ed021ff2336715c = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$a509696eaf723ed7($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$e24978670be1e4f3;
        }
    };
}();
var $97937c29f879e68e$export$ff461bf68e7dd332 = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$654933317498633e($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$e65788c6d4494539;
        }
    };
}();
var $97937c29f879e68e$export$3abd12c96be3b09b = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$5a20025607cdef3f($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$bcd79f9321394c38;
        }
    };
}();
var $97937c29f879e68e$export$ef759d57a4e44836 = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$fcb09e9654c4896a($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$d7927e8ffc1afb48;
        }
    };
}();
var $97937c29f879e68e$export$f595b73424c1647a = function(dict) {
    return dict.compareRecord;
};
var $97937c29f879e68e$export$ebb7a7956d139174 = function() {
    return function(dictOrdRecord) {
        var eqRec1 = $97937c29f879e68e$var$eqRec(dictOrdRecord.EqRecord0());
        return {
            compare: $97937c29f879e68e$export$f595b73424c1647a(dictOrdRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Eq0: function() {
                return eqRec1;
            }
        };
    };
};
var $97937c29f879e68e$export$693feb0c3c484b70 = function(dict) {
    return dict.compare1;
};
var $97937c29f879e68e$export$398604a469f7de9a = function(dict) {
    return dict.compare;
};
var $97937c29f879e68e$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $97937c29f879e68e$export$e9509a298f6befc2 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(f) {
        return function(x) {
            return function(y) {
                return compare3(f(x))(f(y));
            };
        };
    };
};
var $97937c29f879e68e$export$f517ea36c68d4644 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return true;
            return false;
        };
    };
};
var $97937c29f879e68e$export$4be320a4fd1ac499 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return false;
            return true;
        };
    };
};
var $97937c29f879e68e$export$9b050841a3a1b328 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return true;
            return false;
        };
    };
};
var $97937c29f879e68e$export$23e3e2011c250f0f = function(dictOrd) {
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    return function(dictRing) {
        var Semiring0 = dictRing.Semiring0();
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(Semiring0);
        var negate1 = $d061555d3b2c84b2$export$aef51622e549b8b0(dictRing);
        var one = $c0e822be92afc4df$export$80bf7733f1207381(Semiring0);
        return function(x) {
            var $89 = lessThan1(x)(zero);
            if ($89) return negate1(one);
            var $90 = greaterThan1(x)(zero);
            if ($90) return one;
            return x;
        };
    };
};
var $97937c29f879e68e$export$f0c1dc893917aeba = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return false;
            return true;
        };
    };
};
var $97937c29f879e68e$export$8960430cfd85939f = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(x) {
        return function(y) {
            var v = compare3(x)(y);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return y;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return x;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return x;
            throw new Error("Failed pattern match at Data.Ord (line 181, column 3 - line 184, column 12): " + [
                v.constructor.name
            ]);
        };
    };
};
var $97937c29f879e68e$export$96ec731ed4dcb222 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(x) {
        return function(y) {
            var v = compare3(x)(y);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return x;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return x;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return y;
            throw new Error("Failed pattern match at Data.Ord (line 172, column 3 - line 175, column 12): " + [
                v.constructor.name
            ]);
        };
    };
};
var $97937c29f879e68e$export$6ace7ea8ac01a75e = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqArray = $37b880af5f4991bd$export$159e06dc5ec60b00(dictOrd.Eq0());
    return {
        compare: function() {
            var toDelta = function(x) {
                return function(y) {
                    var v = compare3(x)(y);
                    if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 0;
                    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return 1;
                    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return -1;
                    throw new Error("Failed pattern match at Data.Ord (line 79, column 7 - line 82, column 17): " + [
                        v.constructor.name
                    ]);
                };
            };
            return function(xs) {
                return function(ys) {
                    return $97937c29f879e68e$var$compare2(0)($e07f6ef164bf0728$export$6d083685ddc7682f(toDelta)(xs)(ys));
                };
            };
        }(),
        Eq0: function() {
            return eqArray;
        }
    };
};
var $97937c29f879e68e$export$8e34cc59438cf1bf = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$6ace7ea8ac01a75e(dictOrd));
    },
    Eq10: function() {
        return $37b880af5f4991bd$export$861eb926e0b8ea5b;
    }
};
var $97937c29f879e68e$export$a9b387b18fb85611 = function(dictOrdRecord) {
    var compareRecord1 = $97937c29f879e68e$export$f595b73424c1647a(dictOrdRecord);
    var eqRowCons = $37b880af5f4991bd$export$730b16b2c839caa0(dictOrdRecord.EqRecord0())();
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            var eqRowCons1 = eqRowCons(dictIsSymbol);
            return function(dictOrd) {
                var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
                var eqRowCons2 = eqRowCons1(dictOrd.Eq0());
                return {
                    compareRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var left = compare3($d2fadbdf02925823$export$1d94535d2cda4eda(key)(ra))($d2fadbdf02925823$export$1d94535d2cda4eda(key)(rb));
                                var $95 = $97937c29f879e68e$var$notEq(left)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
                                if ($95) return left;
                                return compareRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                            };
                        };
                    },
                    EqRecord0: function() {
                        return eqRowCons2;
                    }
                };
            };
        };
    };
};
var $97937c29f879e68e$export$7d15b64cf5a3a4c4 = function(dictOrd) {
    var min1 = $97937c29f879e68e$export$96ec731ed4dcb222(dictOrd);
    var max1 = $97937c29f879e68e$export$8960430cfd85939f(dictOrd);
    return function(low) {
        return function(hi) {
            return function(x) {
                return min1(hi)(max1(low)(x));
            };
        };
    };
};
var $97937c29f879e68e$export$cf95c51b03f10bae = function(dictOrd) {
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    return function(low) {
        return function(hi) {
            return function(x) {
                if (lessThan1(x)(low)) return false;
                if (greaterThan1(x)(hi)) return false;
                return true;
            };
        };
    };
};
var $97937c29f879e68e$export$2335f513bbd82c6d = function(dictOrd) {
    var greaterThanOrEq1 = $97937c29f879e68e$export$4be320a4fd1ac499(dictOrd);
    return function(dictRing) {
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictRing.Semiring0());
        var negate1 = $d061555d3b2c84b2$export$aef51622e549b8b0(dictRing);
        return function(x) {
            var $99 = greaterThanOrEq1(x)(zero);
            if ($99) return x;
            return negate1(x);
        };
    };
};







var $69d0e3dbb12088d2$var$ordRecord = /* #__PURE__ */ $97937c29f879e68e$export$ebb7a7956d139174();
var $69d0e3dbb12088d2$export$407dd25a598bb432 = function(dict) {
    return dict.topRecord;
};
var $69d0e3dbb12088d2$export$1e95b668f3b82d = function(dict) {
    return dict.top;
};
var $69d0e3dbb12088d2$export$48259b86288d7b58 = {
    top: $05149ea687d6b460$export$523c0b569236b342,
    bottom: $05149ea687d6b460$export$523c0b569236b342,
    Ord0: function() {
        return $97937c29f879e68e$export$f6b429625e3530b0;
    }
};
var $69d0e3dbb12088d2$export$8978fddf7d98bede = {
    topRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    bottomRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    OrdRecord0: function() {
        return $97937c29f879e68e$export$927f7db8ecc0069f;
    }
};
var $69d0e3dbb12088d2$export$6001ef8e188ae2f5 = /* #__PURE__ */ function() {
    return {
        bottom: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        top: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        Ord0: function() {
            return $97937c29f879e68e$export$55c25d215527e8e8;
        }
    };
}();
var $69d0e3dbb12088d2$export$2e0fd44408d4861 = /* #__PURE__ */ function() {
    return {
        top: $5026be88823ef1f4$export$b023c82b48e70453.value,
        bottom: $5026be88823ef1f4$export$7158f0ceb70f54c7.value,
        Ord0: function() {
            return $97937c29f879e68e$export$dcb5533042a37f3c;
        }
    };
}();
var $69d0e3dbb12088d2$export$5acaecf0b0cd5fa9 = {
    top: $cd1cb347a48b7ff0$export$ef55dfccfe3a15b,
    bottom: $cd1cb347a48b7ff0$export$d1edf35dfee544b5,
    Ord0: function() {
        return $97937c29f879e68e$export$5ed021ff2336715c;
    }
};
var $69d0e3dbb12088d2$export$c84fa7e5ca2385dd = {
    top: $cd1cb347a48b7ff0$export$afdd678689eb299,
    bottom: $cd1cb347a48b7ff0$export$4a17ba08fd82d88b,
    Ord0: function() {
        return $97937c29f879e68e$export$ff461bf68e7dd332;
    }
};
var $69d0e3dbb12088d2$export$7cd7c97ac7ec5b79 = {
    top: $cd1cb347a48b7ff0$export$4ffd3705721c8b5b,
    bottom: $cd1cb347a48b7ff0$export$d6be889e229abd84,
    Ord0: function() {
        return $97937c29f879e68e$export$3abd12c96be3b09b;
    }
};
var $69d0e3dbb12088d2$export$b6c012947af8ebbc = {
    top: true,
    bottom: false,
    Ord0: function() {
        return $97937c29f879e68e$export$ef759d57a4e44836;
    }
};
var $69d0e3dbb12088d2$export$72232990c70f5e82 = function(dict) {
    return dict.bottomRecord;
};
var $69d0e3dbb12088d2$export$8d7db335b27db939 = function() {
    return function(dictBoundedRecord) {
        var ordRecord1 = $69d0e3dbb12088d2$var$ordRecord(dictBoundedRecord.OrdRecord0());
        return {
            top: $69d0e3dbb12088d2$export$407dd25a598bb432(dictBoundedRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            bottom: $69d0e3dbb12088d2$export$72232990c70f5e82(dictBoundedRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Ord0: function() {
                return ordRecord1;
            }
        };
    };
};
var $69d0e3dbb12088d2$export$40e543e69a8b3fbb = function(dict) {
    return dict.bottom;
};
var $69d0e3dbb12088d2$export$53fc630a84ecc59b = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictBounded) {
        var top1 = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
        var bottom1 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
        var Ord0 = dictBounded.Ord0();
        return function() {
            return function() {
                return function(dictBoundedRecord) {
                    var topRecord1 = $69d0e3dbb12088d2$export$407dd25a598bb432(dictBoundedRecord);
                    var bottomRecord1 = $69d0e3dbb12088d2$export$72232990c70f5e82(dictBoundedRecord);
                    var ordRecordCons = $97937c29f879e68e$export$a9b387b18fb85611(dictBoundedRecord.OrdRecord0())()(dictIsSymbol)(Ord0);
                    return {
                        topRecord: function(v) {
                            return function(rowProxy) {
                                var tail = topRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rowProxy);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                return insert(top1)(tail);
                            };
                        },
                        bottomRecord: function(v) {
                            return function(rowProxy) {
                                var tail = bottomRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rowProxy);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                return insert(bottom1)(tail);
                            };
                        },
                        OrdRecord0: function() {
                            return ordRecordCons;
                        }
                    };
                };
            };
        };
    };
};





// Generated by purs version 0.15.15

var $3d82dffba933b011$export$e8c9127d2f50172d = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$8824a2bea4c1012c = {
    imap: function(ab) {
        return function(ba) {
            return function(v) {
                return function($42) {
                    return ab(v(ba($42)));
                };
            };
        };
    }
};
var $3d82dffba933b011$export$1c6d49d5878078c3 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$ef56ebe0e8112a3f = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$562bca5a8a46bf61 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$bf44d3d4196f3d53 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$eb38b1c8c5f72ca8 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            return map(f);
        };
    };
};
var $3d82dffba933b011$export$c469d4e9c6f65eae = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($f4b2eb11fc32ed34$export$2330f868b62ed546)
};
var $3d82dffba933b011$export$993789ec90a91854 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($f4b2eb11fc32ed34$export$11c8d16a3c15d11b)
};
var $3d82dffba933b011$export$b2517b0ab3a58435 = function(dict) {
    return dict.imap;
};
var $3d82dffba933b011$export$6e542772b026aecb = function(dictInvariant) {
    var imap1 = $3d82dffba933b011$export$b2517b0ab3a58435(dictInvariant);
    return {
        imap: function(f) {
            return function(g) {
                return function(v) {
                    return imap1(f)(g)(v);
                };
            };
        }
    };
};


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
const $41dd51408824a8aa$export$c7cd64a71178c531 = function(n) {
    return n.toString();
};
const $41dd51408824a8aa$export$e43176eac712254a = function(n) {
    var str = n.toString();
    return isNaN(str + ".0") ? str : str + ".0";
};
const $41dd51408824a8aa$export$91f9c7a21f1f86c8 = function(c) {
    var code = c.charCodeAt(0);
    if (code < 0x20 || code === 0x7F) {
        switch(c){
            case "\x07":
                return "'\\a'";
            case "\b":
                return "'\\b'";
            case "\f":
                return "'\\f'";
            case "\n":
                return "'\\n'";
            case "\r":
                return "'\\r'";
            case "	":
                return "'\\t'";
            case "\v":
                return "'\\v'";
        }
        return "'\\" + code.toString(10) + "'";
    }
    return c === "'" || c === "\\" ? "'\\" + c + "'" : "'" + c + "'";
};
const $41dd51408824a8aa$export$336c8e5b2153cec7 = function(s) {
    var l = s.length;
    return '"' + s.replace(/[\0-\x1F\x7F"\\]/g, function(c, i) {
        switch(c){
            case '"':
            case "\\":
                return "\\" + c;
            case "\x07":
                return "\\a";
            case "\b":
                return "\\b";
            case "\f":
                return "\\f";
            case "\n":
                return "\\n";
            case "\r":
                return "\\r";
            case "	":
                return "\\t";
            case "\v":
                return "\\v";
        }
        var k = i + 1;
        var empty = k < l && s[k] >= "0" && s[k] <= "9" ? "\\&" : "";
        return "\\" + c.charCodeAt(0).toString(10) + empty;
    }) + '"';
};
const $41dd51408824a8aa$export$a23154580f12ac67 = function(f) {
    return function(xs) {
        var ss = [];
        for(var i = 0, l = xs.length; i < l; i++)ss[i] = f(xs[i]);
        return "[" + ss.join(",") + "]";
    };
};






var $2c6b3d51d10471a7$export$2052789f27d4993d = {
    show: $58f3cdfbfe212d20$export$f172309911142386
};
var $2c6b3d51d10471a7$export$5a8c7efb782a6055 = {
    show: function(v) {
        return "unit";
    }
};
var $2c6b3d51d10471a7$export$e4b6cd05df3043f6 = {
    show: $41dd51408824a8aa$export$336c8e5b2153cec7
};
var $2c6b3d51d10471a7$export$a673323aec880979 = {
    showRecordFields: function(v) {
        return function(v1) {
            return "";
        };
    }
};
var $2c6b3d51d10471a7$export$2633f2b0f857f544 = function(dict) {
    return dict.showRecordFields;
};
var $2c6b3d51d10471a7$export$28b0be767d2bc2c2 = function() {
    return function() {
        return function(dictShowRecordFields) {
            var showRecordFields1 = $2c6b3d51d10471a7$export$2633f2b0f857f544(dictShowRecordFields);
            return {
                show: function(record) {
                    return "{" + (showRecordFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(record) + "}");
                }
            };
        };
    };
};
var $2c6b3d51d10471a7$export$3805d09d172f9aca = {
    show: function(v) {
        return "Proxy";
    }
};
var $2c6b3d51d10471a7$export$e5aa470f8f97c3fe = {
    show: $41dd51408824a8aa$export$e43176eac712254a
};
var $2c6b3d51d10471a7$export$3d7cf516d27998a0 = {
    show: $41dd51408824a8aa$export$c7cd64a71178c531
};
var $2c6b3d51d10471a7$export$def6059c21714f2a = {
    show: $41dd51408824a8aa$export$91f9c7a21f1f86c8
};
var $2c6b3d51d10471a7$export$ad55f318773e3cd5 = {
    show: function(v) {
        if (v) return "true";
        if (!v) return "false";
        throw new Error("Failed pattern match at Data.Show (line 29, column 1 - line 31, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $2c6b3d51d10471a7$export$57bf213be019eeb0 = function(dict) {
    return dict.show;
};
var $2c6b3d51d10471a7$export$5bda33a3389a7225 = function(dictShow) {
    return {
        show: $41dd51408824a8aa$export$a23154580f12ac67($2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow))
    };
};
var $2c6b3d51d10471a7$export$70f8f8693d114c9d = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictShowRecordFields) {
        var showRecordFields1 = $2c6b3d51d10471a7$export$2633f2b0f857f544(dictShowRecordFields);
        return function(dictShow) {
            var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
            return {
                showRecordFields: function(v) {
                    return function(record) {
                        var tail = showRecordFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(record);
                        var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        var focus = $d2fadbdf02925823$export$1d94535d2cda4eda(key)(record);
                        return " " + (key + (": " + (show1(focus) + ("," + tail))));
                    };
                }
            };
        };
    };
};
var $2c6b3d51d10471a7$export$d57593979a3bd7f3 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictShow) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
        return {
            showRecordFields: function(v) {
                return function(record) {
                    var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                    var focus = $d2fadbdf02925823$export$1d94535d2cda4eda(key)(record);
                    return " " + (key + (": " + (show1(focus) + " ")));
                };
            }
        };
    };
};




var $91c996e9c07e3b3f$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $91c996e9c07e3b3f$export$dd5fad028b7772cd = /* #__PURE__ */ function() {
    function Inl(value0) {
        this.value0 = value0;
    }
    Inl.create = function(value0) {
        return new Inl(value0);
    };
    return Inl;
}();
var $91c996e9c07e3b3f$export$df71ca4577dbdff6 = /* #__PURE__ */ function() {
    function Inr(value0) {
        this.value0 = value0;
    }
    Inr.create = function(value0) {
        return new Inr(value0);
    };
    return Inr;
}();
var $91c996e9c07e3b3f$export$264ad599d7cef668 = /* #__PURE__ */ function() {
    function Product(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Product.create = function(value0) {
        return function(value1) {
            return new Product(value0, value1);
        };
    };
    return Product;
}();
var $91c996e9c07e3b3f$var$NoConstructors = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$928c7f2d618c070b = /* #__PURE__ */ function() {
    function NoArguments() {}
    NoArguments.value = new NoArguments();
    return NoArguments;
}();
var $91c996e9c07e3b3f$export$8bfc33963ccbb2a = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$84637ea037d2e218 = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$2c618a4308a30424 = function(dict) {
    return dict.to;
};
var $91c996e9c07e3b3f$export$a76fa7ac9b018069 = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show2 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return "(Inl " + (show1(v.value0) + ")");
                if (v instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return "(Inr " + (show2(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Generic.Rep (line 32, column 1 - line 34, column 42): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $91c996e9c07e3b3f$export$821c121fea76e4f5 = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show2 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(Product " + (show1(v.value0) + (" " + (show2(v.value1) + ")")));
            }
        };
    };
};
var $91c996e9c07e3b3f$export$1275f813f7f7622c = {
    show: function(v) {
        return "NoArguments";
    }
};
var $91c996e9c07e3b3f$export$4133b31869b937df = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictShow) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
        return {
            show: function(v) {
                return "(Constructor @" + ($91c996e9c07e3b3f$var$show(reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)) + (" " + (show1(v) + ")")));
            }
        };
    };
};
var $91c996e9c07e3b3f$export$b1716375e6f06e2d = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Argument " + (show1(v) + ")");
        }
    };
};
var $91c996e9c07e3b3f$export$3d0c2c94453de4b8 = function(dictGeneric) {
    return function(v) {
        return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
    };
};
var $91c996e9c07e3b3f$export$6788812c4e6611e6 = function(dict) {
    return dict.from;
};


// Generated by purs version 0.15.15
















var $06733ae99ed4f534$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $06733ae99ed4f534$export$bebe9059409a0d04 = /* #__PURE__ */ function() {
    function Nothing() {}
    Nothing.value = new Nothing();
    return Nothing;
}();
var $06733ae99ed4f534$export$8a67b48435b5d073 = /* #__PURE__ */ function() {
    function Just(value0) {
        this.value0 = value0;
    }
    Just.create = function(value0) {
        return new Just(value0);
    };
    return Just;
}();
var $06733ae99ed4f534$export$9b814e760fdd264a = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return "(Just " + (show(v.value0) + ")");
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "Nothing";
            throw new Error("Failed pattern match at Data.Maybe (line 223, column 1 - line 225, column 28): " + [
                v.constructor.name
            ]);
        }
    };
};
var $06733ae99ed4f534$export$fb85b8a3a6158141 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(append1(v.value0)(v1.value0));
                throw new Error("Failed pattern match at Data.Maybe (line 182, column 1 - line 185, column 43): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        }
    };
};
var $06733ae99ed4f534$export$516e28dec6a4b6d4 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlt.Functor0());
    return function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(a) {
            return alt(map1($06733ae99ed4f534$export$8a67b48435b5d073.create)(a))(pure($06733ae99ed4f534$export$bebe9059409a0d04.value));
        };
    };
};
var $06733ae99ed4f534$export$89fc9eb1adf8ed28 = function(dictSemigroup) {
    var semigroupMaybe1 = $06733ae99ed4f534$export$fb85b8a3a6158141(dictSemigroup);
    return {
        mempty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Semigroup0: function() {
            return semigroupMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$76f250758a65e763 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v($05149ea687d6b460$export$523c0b569236b342);
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Maybe (line 250, column 1 - line 250, column 62): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $06733ae99ed4f534$export$f8b8b9ce72e9ccbf = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Maybe (line 237, column 1 - line 237, column 51): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $06733ae99ed4f534$export$4967676db1b89293 = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(true)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false));
var $06733ae99ed4f534$export$c15bd07a493e1236 = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $06733ae99ed4f534$export$a1265319b56c5090 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $06733ae99ed4f534$export$8a67b48435b5d073(x.value0);
        throw new Error("Failed pattern match at Data.Maybe (line 227, column 1 - line 227, column 52): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0);
        throw new Error("Failed pattern match at Data.Maybe (line 227, column 1 - line 227, column 52): " + [
            x.constructor.name
        ]);
    }
};
var $06733ae99ed4f534$export$fdd2427f0e60fd66 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v(v1.value0));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    }
};
var $06733ae99ed4f534$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $06733ae99ed4f534$export$62eda6ff839a0571 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($06733ae99ed4f534$export$fdd2427f0e60fd66)
};
var $06733ae99ed4f534$export$770f48d991b0f2a2 = function(a) {
    return $06733ae99ed4f534$export$76f250758a65e763(a)($06733ae99ed4f534$var$identity);
};
var $06733ae99ed4f534$export$43db023a260c5e9f = function(a) {
    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(a)($06733ae99ed4f534$var$identity);
};
var $06733ae99ed4f534$export$2506262575dd10a7 = function() {
    return function(v) {
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
        throw new Error("Failed pattern match at Data.Maybe (line 288, column 1 - line 288, column 46): " + [
            v.constructor.name
        ]);
    };
};
var $06733ae99ed4f534$export$cb6d304dbd10aa95 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v(v1));
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$export$8f45bb76abf9699e = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return true;
                if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && y instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return eq(x.value0)(y.value0);
                return false;
            };
        }
    };
};
var $06733ae99ed4f534$export$e35c29f98d259c46 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMaybe1 = $06733ae99ed4f534$export$8f45bb76abf9699e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && y instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return compare(x.value0)(y.value0);
                throw new Error("Failed pattern match at Data.Maybe (line 0, column 0 - line 0, column 0): " + [
                    x.constructor.name,
                    y.constructor.name
                ]);
            };
        },
        Eq0: function() {
            return eqMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$b59095d05faa8cf6 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($06733ae99ed4f534$export$8f45bb76abf9699e(dictEq));
    }
};
var $06733ae99ed4f534$export$c82772423d5de0b = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($06733ae99ed4f534$export$e35c29f98d259c46(dictOrd));
    },
    Eq10: function() {
        return $06733ae99ed4f534$export$b59095d05faa8cf6;
    }
};
var $06733ae99ed4f534$export$158982e65b249847 = function(dictBounded) {
    var ordMaybe1 = $06733ae99ed4f534$export$e35c29f98d259c46(dictBounded.Ord0());
    return {
        top: new $06733ae99ed4f534$export$8a67b48435b5d073($69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded)),
        bottom: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Ord0: function() {
            return ordMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$22d9917da16590e7 = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $06733ae99ed4f534$var$map(v.value0)(v1);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Maybe (line 67, column 1 - line 69, column 30): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $06733ae99ed4f534$export$e5fea5661dee377 = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v.value0);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Maybe (line 125, column 1 - line 127, column 28): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $06733ae99ed4f534$export$22d9917da16590e7;
    }
};
var $06733ae99ed4f534$export$9e0396ae96a86801 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    return {
        zero: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        one: new $06733ae99ed4f534$export$8a67b48435b5d073($c0e822be92afc4df$export$80bf7733f1207381(dictSemiring)),
        add: function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(add(v.value0)(v1.value0));
                throw new Error("Failed pattern match at Data.Maybe (line 190, column 1 - line 198, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        },
        mul: function(x) {
            return function(y) {
                return $06733ae99ed4f534$var$apply($06733ae99ed4f534$var$map(mul)(x))(y);
            };
        }
    };
};
var $06733ae99ed4f534$export$b203ef4465f15037 = /* #__PURE__ */ function() {
    return {
        pure: $06733ae99ed4f534$export$8a67b48435b5d073.create,
        Apply0: function() {
            return $06733ae99ed4f534$export$22d9917da16590e7;
        }
    };
}();
var $06733ae99ed4f534$export$f78a1c2d38efcc13 = {
    Applicative0: function() {
        return $06733ae99ed4f534$export$b203ef4465f15037;
    },
    Bind1: function() {
        return $06733ae99ed4f534$export$e5fea5661dee377;
    }
};
var $06733ae99ed4f534$export$a22c94fdeac581ff = {
    alt: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
            return v;
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$export$164e6bcbae9cfdd0 = /* #__PURE__ */ function() {
    return {
        empty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Alt0: function() {
            return $06733ae99ed4f534$export$a22c94fdeac581ff;
        }
    };
}();
var $06733ae99ed4f534$export$92d23d3d8fa78a80 = {
    Applicative0: function() {
        return $06733ae99ed4f534$export$b203ef4465f15037;
    },
    Plus1: function() {
        return $06733ae99ed4f534$export$164e6bcbae9cfdd0;
    }
};







var $7d4cccdf062a2261$export$37c4d04eafdc5515 = /* #__PURE__ */ function() {
    function Left(value0) {
        this.value0 = value0;
    }
    Left.create = function(value0) {
        return new Left(value0);
    };
    return Left;
}();
var $7d4cccdf062a2261$export$19db0165690c701a = /* #__PURE__ */ function() {
    function Right(value0) {
        this.value0 = value0;
    }
    Right.create = function(value0) {
        return new Right(value0);
    };
    return Right;
}();
var $7d4cccdf062a2261$export$37ab35e89b41eda = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return "(Left " + (show(v.value0) + ")");
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return "(Right " + (show1(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Either (line 173, column 1 - line 175, column 46): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $7d4cccdf062a2261$export$e29cdc8bc2cafc59 = function(f) {
    return $06733ae99ed4f534$export$76f250758a65e763(function($138) {
        return $7d4cccdf062a2261$export$37c4d04eafdc5515.create(f($138));
    })($7d4cccdf062a2261$export$19db0165690c701a.create);
};
var $7d4cccdf062a2261$export$a92e4c44d367d0af = function(a) {
    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515(a))($7d4cccdf062a2261$export$19db0165690c701a.create);
};
var $7d4cccdf062a2261$export$72a1c23d752d2155 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $7d4cccdf062a2261$export$19db0165690c701a(x.value0);
        throw new Error("Failed pattern match at Data.Either (line 33, column 1 - line 33, column 56): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0);
        throw new Error("Failed pattern match at Data.Either (line 33, column 1 - line 33, column 56): " + [
            x.constructor.name
        ]);
    }
};
var $7d4cccdf062a2261$export$f0a413d3d6075601 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(m.value0);
            if (m instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(f(m.value0));
            throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $7d4cccdf062a2261$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $7d4cccdf062a2261$export$26473b852950cc9f = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($7d4cccdf062a2261$export$f0a413d3d6075601)
};
var $7d4cccdf062a2261$export$f41f6e6ed5e42617 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1.value0;
        return v($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $7d4cccdf062a2261$export$27d3ca2b5d864fdd = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1.value0;
        return v;
    };
};
var $7d4cccdf062a2261$export$a6bf632a63e8a255 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1.value0;
        return v($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $7d4cccdf062a2261$export$ed20f362be8f8b52 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1.value0;
        return v;
    };
};
var $7d4cccdf062a2261$export$d6a44bcd37031227 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0);
            return new $7d4cccdf062a2261$export$19db0165690c701a(v(v1));
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};
var $7d4cccdf062a2261$export$bde8fea66b0f9f9a = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return eq(x.value0)(y.value0);
                    if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a && y instanceof $7d4cccdf062a2261$export$19db0165690c701a) return eq1(x.value0)(y.value0);
                    return false;
                };
            }
        };
    };
};
var $7d4cccdf062a2261$export$f105364bfbaa033b = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqEither1 = $7d4cccdf062a2261$export$bde8fea66b0f9f9a(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqEither2 = eqEither1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return compare(x.value0)(y.value0);
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a && y instanceof $7d4cccdf062a2261$export$19db0165690c701a) return compare1(x.value0)(y.value0);
                    throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                        x.constructor.name,
                        y.constructor.name
                    ]);
                };
            },
            Eq0: function() {
                return eqEither2;
            }
        };
    };
};
var $7d4cccdf062a2261$export$551ea40f4c230981 = function(dictEq) {
    var eqEither1 = $7d4cccdf062a2261$export$bde8fea66b0f9f9a(dictEq);
    return {
        eq1: function(dictEq1) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqEither1(dictEq1));
        }
    };
};
var $7d4cccdf062a2261$export$f4a01dc57c45522b = function(dictOrd) {
    var ordEither1 = $7d4cccdf062a2261$export$f105364bfbaa033b(dictOrd);
    var eq1Either1 = $7d4cccdf062a2261$export$551ea40f4c230981(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordEither1(dictOrd1));
        },
        Eq10: function() {
            return eq1Either1;
        }
    };
};
var $7d4cccdf062a2261$export$5f5be1bb6cd1fded = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v(v2.value0);
            if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Either (line 208, column 1 - line 208, column 64): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $7d4cccdf062a2261$export$3a6c138b8d0f3874 = /* #__PURE__ */ function() {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $7d4cccdf062a2261$export$d649b6842e09f2b = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true))(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false));
var $7d4cccdf062a2261$export$a9d71693f0c1a85d = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false))(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $7d4cccdf062a2261$export$7877a478dd30fd3d = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlt.Functor0());
    return function(a) {
        return function(b) {
            return alt(map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(a))(map1($7d4cccdf062a2261$export$19db0165690c701a.create)(b));
        };
    };
};
var $7d4cccdf062a2261$export$39ea3c8fac814734 = function(dictBounded) {
    var bottom = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    var ordEither1 = $7d4cccdf062a2261$export$f105364bfbaa033b(dictBounded.Ord0());
    return function(dictBounded1) {
        var ordEither2 = ordEither1(dictBounded1.Ord0());
        return {
            top: new $7d4cccdf062a2261$export$19db0165690c701a($69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded1)),
            bottom: new $7d4cccdf062a2261$export$37c4d04eafdc5515(bottom),
            Ord0: function() {
                return ordEither2;
            }
        };
    };
};
var $7d4cccdf062a2261$export$521d8864384143c6 = /* #__PURE__ */ function() {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($06733ae99ed4f534$export$8a67b48435b5d073.create)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value));
}();
var $7d4cccdf062a2261$export$d5df7cb019d08f04 = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $7d4cccdf062a2261$var$map(v.value0)(v1);
            throw new Error("Failed pattern match at Data.Either (line 70, column 1 - line 72, column 30): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};
var $7d4cccdf062a2261$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($7d4cccdf062a2261$export$d5df7cb019d08f04);
var $7d4cccdf062a2261$export$3806e10d0c441ac5 = {
    bind: /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function(e) {
        return function(v) {
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515(e);
        };
    })(function(a) {
        return function(f) {
            return f(a);
        };
    }),
    Apply0: function() {
        return $7d4cccdf062a2261$export$d5df7cb019d08f04;
    }
};
var $7d4cccdf062a2261$export$56cf4be43732c31d = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(x) {
            return function(y) {
                return $7d4cccdf062a2261$var$apply($7d4cccdf062a2261$var$map(append1)(x))(y);
            };
        }
    };
};
var $7d4cccdf062a2261$export$400f1ef3f3ec304d = /* #__PURE__ */ function() {
    return {
        pure: $7d4cccdf062a2261$export$19db0165690c701a.create,
        Apply0: function() {
            return $7d4cccdf062a2261$export$d5df7cb019d08f04;
        }
    };
}();
var $7d4cccdf062a2261$export$b3b4ecb28e3a8df3 = {
    Applicative0: function() {
        return $7d4cccdf062a2261$export$400f1ef3f3ec304d;
    },
    Bind1: function() {
        return $7d4cccdf062a2261$export$3806e10d0c441ac5;
    }
};
var $7d4cccdf062a2261$export$79ac44fe35dcf650 = {
    alt: function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
            return v;
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};






// Generated by purs version 0.15.15
const $01fd16aefb19fd56$export$f6d4f01ca39c2fe = function(a) {
    return function() {
        return a;
    };
};
const $01fd16aefb19fd56$export$b771a24b80e4c766 = function(a) {
    return function(f) {
        return function() {
            return f(a())();
        };
    };
};
const $01fd16aefb19fd56$export$161ebd47ed3ced60 = function(f) {
    return function() {
        while(!f());
    };
};
const $01fd16aefb19fd56$export$27334490557f84d2 = function(f) {
    return function(a) {
        return function() {
            while(f())a();
        };
    };
};
const $01fd16aefb19fd56$export$3dfbdd78bf0090db = function(lo) {
    return function(hi) {
        return function(f) {
            return function() {
                for(var i = lo; i < hi; i++)f(i)();
            };
        };
    };
};
const $01fd16aefb19fd56$export$eff012ca4e6ded0b = function(as) {
    return function(f) {
        return function() {
            for(var i = 0, l = as.length; i < l; i++)f(as[i])();
        };
    };
};




// Generated by purs version 0.15.15




var $d3d065da31679be1$export$7e7b1df9f5185791 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var when = $c50cfdb0b9e8fa31$export$a55877ca9db47377(dictMonad.Applicative0());
    return function(mb) {
        return function(m) {
            return bind(mb)(function(b) {
                return when(b)(m);
            });
        };
    };
};
var $d3d065da31679be1$export$551dd5524146e426 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var unless = $c50cfdb0b9e8fa31$export$6f0673371501d6b6(dictMonad.Applicative0());
    return function(mb) {
        return function(m) {
            return bind(mb)(function(b) {
                return unless(b)(m);
            });
        };
    };
};
var $d3d065da31679be1$export$d34b9ad93b1f095a = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$598532d07e20ffc2;
    },
    Bind1: function() {
        return $70cd3177464e7915$export$6dbdf4766af04452;
    }
};
var $d3d065da31679be1$export$513f938006a06509 = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$e68c32b2a06f106c;
    },
    Bind1: function() {
        return $70cd3177464e7915$export$2c348afe2becdb4f;
    }
};
var $d3d065da31679be1$export$68aea3a98a23c265 = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e;
    },
    Bind1: function() {
        return $70cd3177464e7915$export$794f9574ca20b986;
    }
};
var $d3d065da31679be1$export$167848c32e61a4d4 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(f) {
        return function(a) {
            return bind(a)(function(a$prime) {
                return pure(f(a$prime));
            });
        };
    };
};
var $d3d065da31679be1$export$2f6ca3d3b1f80bf5 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(f) {
        return function(a) {
            return bind(f)(function(f$prime) {
                return bind(a)(function(a$prime) {
                    return pure(f$prime(a$prime));
                });
            });
        };
    };
};


// Generated by purs version 0.15.15

// Generated by purs version 0.15.15
const $9f3b30719c815f93$export$748d824f642f540d = function(x) {
    return Math.min(Math.abs(x), 2147483647);
};
const $9f3b30719c815f93$export$baf7824ae32165f5 = function(x) {
    return function(y) {
        if (y === 0) return 0;
        return y > 0 ? Math.floor(x / y) : -Math.floor(x / -y);
    };
};
const $9f3b30719c815f93$export$faa51fbcd7b05d8f = function(x) {
    return function(y) {
        if (y === 0) return 0;
        var yy = Math.abs(y);
        return (x % yy + yy) % yy;
    };
};
const $9f3b30719c815f93$export$6db30f2997f70499 = function(n1) {
    return function(n2) {
        return n1 / n2;
    };
};


// Generated by purs version 0.15.15


var $a64f08f726dec5e9$var$ringRecord = /* #__PURE__ */ $d061555d3b2c84b2$export$492fe4fa507ea6ad();
var $a64f08f726dec5e9$export$4fcc4024c8011653 = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$e2da189c845067f9;
    }
};
var $a64f08f726dec5e9$export$a2ce2b4503316dcc = {
    RingRecord0: function() {
        return $d061555d3b2c84b2$export$38dc985ea1e564cd;
    }
};
var $a64f08f726dec5e9$export$dc394faf01ed3f4e = function(dictIsSymbol) {
    var ringRecordCons = $d061555d3b2c84b2$export$857cf13a2f74264d(dictIsSymbol)();
    return function() {
        return function(dictCommutativeRingRecord) {
            var ringRecordCons1 = ringRecordCons(dictCommutativeRingRecord.RingRecord0());
            return function(dictCommutativeRing) {
                var ringRecordCons2 = ringRecordCons1(dictCommutativeRing.Ring0());
                return {
                    RingRecord0: function() {
                        return ringRecordCons2;
                    }
                };
            };
        };
    };
};
var $a64f08f726dec5e9$export$d4bbb7afedb09bfd = function() {
    return function(dictCommutativeRingRecord) {
        var ringRecord1 = $a64f08f726dec5e9$var$ringRecord(dictCommutativeRingRecord.RingRecord0());
        return {
            Ring0: function() {
                return ringRecord1;
            }
        };
    };
};
var $a64f08f726dec5e9$export$7f39ee449b822938 = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$948aff48831eff14;
    }
};
var $a64f08f726dec5e9$export$ed11bb9ee1d36807 = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$194f4464e73e7816;
    }
};
var $a64f08f726dec5e9$export$5745e05f6b169cee = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$d40e27c88e22a303;
    }
};
var $a64f08f726dec5e9$export$bdad616b79aca10 = function(dictCommutativeRing) {
    var ringFn = $d061555d3b2c84b2$export$9f43d8c61dde305d(dictCommutativeRing.Ring0());
    return {
        Ring0: function() {
            return ringFn;
        }
    };
};





var $b0cd729514c2504e$export$842a2cf37af977e1 = function(dict) {
    return dict.mod;
};
var $b0cd729514c2504e$export$f81847884871263e = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEuclideanRing) {
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0());
        var mod1 = $b0cd729514c2504e$export$842a2cf37af977e1(dictEuclideanRing);
        return function(a) {
            return function(b) {
                var $24 = eq(b)(zero);
                if ($24) return a;
                return $b0cd729514c2504e$export$f81847884871263e(dictEq)(dictEuclideanRing)(b)(mod1(a)(b));
            };
        };
    };
};
var $b0cd729514c2504e$export$ea62662521882766 = {
    degree: function(v) {
        return 1;
    },
    div: $9f3b30719c815f93$export$6db30f2997f70499,
    mod: function(v) {
        return function(v1) {
            return 0.0;
        };
    },
    CommutativeRing0: function() {
        return $a64f08f726dec5e9$export$ed11bb9ee1d36807;
    }
};
var $b0cd729514c2504e$export$437776face1858ae = {
    degree: $9f3b30719c815f93$export$748d824f642f540d,
    div: $9f3b30719c815f93$export$baf7824ae32165f5,
    mod: $9f3b30719c815f93$export$faa51fbcd7b05d8f,
    CommutativeRing0: function() {
        return $a64f08f726dec5e9$export$5745e05f6b169cee;
    }
};
var $b0cd729514c2504e$export$159d9494db57879b = function(dict) {
    return dict.div;
};
var $b0cd729514c2504e$export$f686d97e407ec4ef = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    var gcd1 = $b0cd729514c2504e$export$f81847884871263e(dictEq);
    return function(dictEuclideanRing) {
        var Semiring0 = dictEuclideanRing.CommutativeRing0().Ring0().Semiring0();
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(Semiring0);
        var div1 = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
        var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(Semiring0);
        var gcd2 = gcd1(dictEuclideanRing);
        return function(a) {
            return function(b) {
                var $26 = eq(a)(zero) || eq(b)(zero);
                if ($26) return zero;
                return div1(mul(a)(b))(gcd2(a)(b));
            };
        };
    };
};
var $b0cd729514c2504e$export$a23b7da4bc008930 = function(dict) {
    return dict.degree;
};








var $784e1bd3d26d71da$var$semigroupRecord = /* #__PURE__ */ $d7bf9817a417d4ae$export$dbfe6b321632d7c9();
var $784e1bd3d26d71da$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $784e1bd3d26d71da$var$div = /* #__PURE__ */ $b0cd729514c2504e$export$159d9494db57879b($b0cd729514c2504e$export$437776face1858ae);
var $784e1bd3d26d71da$export$852b4040eee6c6ba = {
    mempty: $05149ea687d6b460$export$523c0b569236b342,
    Semigroup0: function() {
        return $d7bf9817a417d4ae$export$824c37c4afd77b1;
    }
};
var $784e1bd3d26d71da$export$fc39f3d77fa2e58a = {
    mempty: "",
    Semigroup0: function() {
        return $d7bf9817a417d4ae$export$d9b7100b101f2c5b;
    }
};
var $784e1bd3d26d71da$export$254fca207e30c208 = {
    memptyRecord: function(v) {
        return {};
    },
    SemigroupRecord0: function() {
        return $d7bf9817a417d4ae$export$955753116dc9242c;
    }
};
var $784e1bd3d26d71da$export$84dd8432d2bb1dc3 = /* #__PURE__ */ function() {
    return {
        mempty: $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value,
        Semigroup0: function() {
            return $5026be88823ef1f4$export$d04ea36c3e51a408;
        }
    };
}();
var $784e1bd3d26d71da$export$db307f59121ffcc4 = {
    mempty: [],
    Semigroup0: function() {
        return $d7bf9817a417d4ae$export$d082f07d0a8e9909;
    }
};
var $784e1bd3d26d71da$export$ae16212c99887b7f = function(dict) {
    return dict.memptyRecord;
};
var $784e1bd3d26d71da$export$b6526a2ab5064058 = function() {
    return function(dictMonoidRecord) {
        var semigroupRecord1 = $784e1bd3d26d71da$var$semigroupRecord(dictMonoidRecord.SemigroupRecord0());
        return {
            mempty: $784e1bd3d26d71da$export$ae16212c99887b7f(dictMonoidRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Semigroup0: function() {
                return semigroupRecord1;
            }
        };
    };
};
var $784e1bd3d26d71da$export$9a7d64bc1d75357 = function(dict) {
    return dict.mempty;
};
var $784e1bd3d26d71da$export$192e81b9fe7e4abe = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var semigroupFn = $d7bf9817a417d4ae$export$49c9dc4575956c55(dictMonoid.Semigroup0());
    return {
        mempty: function(v) {
            return mempty1;
        },
        Semigroup0: function() {
            return semigroupFn;
        }
    };
};
var $784e1bd3d26d71da$export$d672019c76a5af4a = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    var semigroupRecordCons = $d7bf9817a417d4ae$export$74eae24c3d2a7535(dictIsSymbol)();
    return function(dictMonoid) {
        var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var Semigroup0 = dictMonoid.Semigroup0();
        return function() {
            return function(dictMonoidRecord) {
                var memptyRecord1 = $784e1bd3d26d71da$export$ae16212c99887b7f(dictMonoidRecord);
                var semigroupRecordCons1 = semigroupRecordCons(dictMonoidRecord.SemigroupRecord0())(Semigroup0);
                return {
                    memptyRecord: function(v) {
                        var tail = memptyRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        var insert = $d2fadbdf02925823$export$444262986932b766(key);
                        return insert(mempty1)(tail);
                    },
                    SemigroupRecord0: function() {
                        return semigroupRecordCons1;
                    }
                };
            };
        };
    };
};
var $784e1bd3d26d71da$export$836601bcef5ff40 = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    return function(x) {
        var go = function(p) {
            if (p <= 0) return mempty1;
            if (p === 1) return x;
            if ($784e1bd3d26d71da$var$mod(p)(2) === 0) {
                var x$prime = go($784e1bd3d26d71da$var$div(p)(2));
                return append(x$prime)(x$prime);
            }
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                var x$prime = go($784e1bd3d26d71da$var$div(p)(2));
                return append(x$prime)(append(x$prime)(x));
            }
            throw new Error("Failed pattern match at Data.Monoid (line 88, column 3 - line 88, column 17): " + [
                p.constructor.name
            ]);
        };
        return go;
    };
};
var $784e1bd3d26d71da$export$864d727b48066337 = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return function(v) {
        return function(v1) {
            if (v) return v1;
            if (!v) return mempty1;
            throw new Error("Failed pattern match at Data.Monoid (line 96, column 1 - line 96, column 49): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};



var $6c2f8951ecf9531e$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $6c2f8951ecf9531e$export$7e900d895707a1af = {
    Applicative0: function() {
        return $6c2f8951ecf9531e$export$89bf999217d3022a;
    },
    Bind1: function() {
        return $6c2f8951ecf9531e$export$855330f8a2a9f2e8;
    }
};
var $6c2f8951ecf9531e$export$855330f8a2a9f2e8 = {
    bind: $01fd16aefb19fd56$export$b771a24b80e4c766,
    Apply0: function() {
        return $6c2f8951ecf9531e$var$$lazy_applyEffect(0);
    }
};
var $6c2f8951ecf9531e$export$89bf999217d3022a = {
    pure: $01fd16aefb19fd56$export$f6d4f01ca39c2fe,
    Apply0: function() {
        return $6c2f8951ecf9531e$var$$lazy_applyEffect(0);
    }
};
var $6c2f8951ecf9531e$var$$lazy_functorEffect = /* #__PURE__ */ $6c2f8951ecf9531e$var$$runtime_lazy("functorEffect", "Effect", function() {
    return {
        map: $c50cfdb0b9e8fa31$export$53544bd8de5a7427($6c2f8951ecf9531e$export$89bf999217d3022a)
    };
});
var $6c2f8951ecf9531e$var$$lazy_applyEffect = /* #__PURE__ */ $6c2f8951ecf9531e$var$$runtime_lazy("applyEffect", "Effect", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($6c2f8951ecf9531e$export$7e900d895707a1af),
        Functor0: function() {
            return $6c2f8951ecf9531e$var$$lazy_functorEffect(0);
        }
    };
});
var $6c2f8951ecf9531e$export$91fce01ecf0438e1 = /* #__PURE__ */ $6c2f8951ecf9531e$var$$lazy_functorEffect(20);
var $6c2f8951ecf9531e$export$59a7b217c53300d2 = /* #__PURE__ */ $6c2f8951ecf9531e$var$$lazy_applyEffect(23);
var $6c2f8951ecf9531e$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($6c2f8951ecf9531e$export$59a7b217c53300d2);
var $6c2f8951ecf9531e$export$58139e981c60cf43 = function(dictSemigroup) {
    return {
        append: $6c2f8951ecf9531e$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $6c2f8951ecf9531e$export$2d8226ee4b2722f7 = function(dictMonoid) {
    var semigroupEffect1 = $6c2f8951ecf9531e$export$58139e981c60cf43(dictMonoid.Semigroup0());
    return {
        mempty: $01fd16aefb19fd56$export$f6d4f01ca39c2fe($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupEffect1;
        }
    };
};


// Generated by purs version 0.15.15
function $ad2cf6904bca3ba1$export$e49cfe3e3ab3c67c(err) {
    return err.stack || err.toString();
}
function $ad2cf6904bca3ba1$export$a3bc9b8ed74fc(msg) {
    return new Error(msg);
}
function $ad2cf6904bca3ba1$export$d010f7d0d0793465(msg) {
    return function(cause) {
        return new Error(msg, {
            cause: cause
        });
    };
}
function $ad2cf6904bca3ba1$export$afd88dc4d34c0903(msg) {
    return function(name) {
        const e = new Error(msg);
        e.name = name;
        return e;
    };
}
function $ad2cf6904bca3ba1$export$a8ecead220dd38a6(e) {
    return e.message;
}
function $ad2cf6904bca3ba1$export$a8ff84c12d48cfa6(e) {
    return e.name || "Error";
}
function $ad2cf6904bca3ba1$export$c159e25936a96837(just) {
    return function(nothing) {
        return function(e) {
            return e.stack ? just(e.stack) : nothing;
        };
    };
}
function $ad2cf6904bca3ba1$export$de0c4a986b439e52(e) {
    return function() {
        throw e;
    };
}
function $ad2cf6904bca3ba1$export$d49c1c6bf2cedce5(c) {
    return function(t) {
        return function() {
            try {
                return t();
            } catch (e) {
                if (e instanceof Error || Object.prototype.toString.call(e) === "[object Error]") return c(e)();
                else return c(new Error(e.toString()))();
            }
        };
    };
}







var $4e52402d7134c8bb$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $4e52402d7134c8bb$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $4e52402d7134c8bb$export$410a452afcd48948 = function(action) {
    return $ad2cf6904bca3ba1$export$d49c1c6bf2cedce5(function($3) {
        return $4e52402d7134c8bb$var$pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($3));
    })($4e52402d7134c8bb$var$map($7d4cccdf062a2261$export$19db0165690c701a.create)(action));
};
var $4e52402d7134c8bb$export$7b1a37e4f0fe815 = function($4) {
    return $ad2cf6904bca3ba1$export$de0c4a986b439e52($ad2cf6904bca3ba1$export$a3bc9b8ed74fc($4));
};
var $4e52402d7134c8bb$export$a57ab32f40f83ea9 = /* #__PURE__ */ function() {
    return $ad2cf6904bca3ba1$export$c159e25936a96837($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $4e52402d7134c8bb$export$3879b24e8245693d = {
    show: $ad2cf6904bca3ba1$export$e49cfe3e3ab3c67c
};


var $5dfefa023749ded0$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $5dfefa023749ded0$export$8bf7aba4a9e09055 = function(dict) {
    return dict.throwError;
};
var $5dfefa023749ded0$export$fff877a725e9aba1 = /* #__PURE__ */ function() {
    return {
        throwError: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value),
        Monad0: function() {
            return $06733ae99ed4f534$export$f78a1c2d38efcc13;
        }
    };
}();
var $5dfefa023749ded0$export$390154ec55cffb04 = /* #__PURE__ */ function() {
    return {
        throwError: $7d4cccdf062a2261$export$37c4d04eafdc5515.create,
        Monad0: function() {
            return $7d4cccdf062a2261$export$b3b4ecb28e3a8df3;
        }
    };
}();
var $5dfefa023749ded0$export$e4992fc673e7b027 = {
    throwError: $ad2cf6904bca3ba1$export$de0c4a986b439e52,
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $5dfefa023749ded0$export$438e6a8af9a8a22d = {
    catchError: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1($05149ea687d6b460$export$523c0b569236b342);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
            throw new Error("Failed pattern match at Control.Monad.Error.Class (line 79, column 1 - line 81, column 33): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$fff877a725e9aba1;
    }
};
var $5dfefa023749ded0$export$abb16404f142771a = {
    catchError: function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1(v.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
            throw new Error("Failed pattern match at Control.Monad.Error.Class (line 72, column 1 - line 74, column 35): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$390154ec55cffb04;
    }
};
var $5dfefa023749ded0$export$434b8bb3cd954f77 = {
    catchError: /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($ad2cf6904bca3ba1$export$d49c1c6bf2cedce5),
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$e4992fc673e7b027;
    }
};
var $5dfefa023749ded0$export$1cf01ae67112be7b = function(dictMonadThrow) {
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadThrow.Monad0().Applicative0());
    return function(error) {
        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(throwError1(error))(pure);
    };
};
var $5dfefa023749ded0$export$bd6bd7bb5418f998 = function(dictMonadThrow) {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow))($c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadThrow.Monad0().Applicative0()));
};
var $5dfefa023749ded0$export$3dede90624df3ba9 = function(dict) {
    return dict.catchError;
};
var $5dfefa023749ded0$export$b726b0cdf642257a = function(dictMonadError) {
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadError.MonadThrow0());
    var catchError1 = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    return function(p) {
        return function(act) {
            return function(handler) {
                var handle = function(e) {
                    var v = p(e);
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return throwError1(e);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return handler(v.value0);
                    throw new Error("Failed pattern match at Control.Monad.Error.Class (line 57, column 5 - line 59, column 26): " + [
                        v.constructor.name
                    ]);
                };
                return catchError1(act)(handle);
            };
        };
    };
};
var $5dfefa023749ded0$export$410a452afcd48948 = function(dictMonadError) {
    var catchError1 = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var Monad0 = dictMonadError.MonadThrow0().Monad0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Monad0.Bind1().Apply0().Functor0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(a) {
        return catchError1(map($7d4cccdf062a2261$export$19db0165690c701a.create)(a))(function($52) {
            return pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($52));
        });
    };
};
var $5dfefa023749ded0$export$8f240c41514f3a3e = function(dictMonadError) {
    var MonadThrow0 = dictMonadError.MonadThrow0();
    var Monad0 = MonadThrow0.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var try1 = $5dfefa023749ded0$export$410a452afcd48948(dictMonadError);
    var discard1 = $5dfefa023749ded0$var$discard(Bind1);
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(MonadThrow0);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(acquire) {
        return function(release) {
            return function(kleisli) {
                return bind(acquire)(function(resource) {
                    return bind(try1(kleisli(resource)))(function(result) {
                        return discard1(release(resource))(function() {
                            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(throwError1)(pure)(result);
                        });
                    });
                });
            };
        };
    };
};


// Generated by purs version 0.15.15





// Generated by purs version 0.15.15
var $67e1952ff57566f7$export$bb801a161a3121f0 = function(dict) {
    return dict.callCC;
};



// Generated by purs version 0.15.15




var $74738728c27df511$export$97f42efbb325fef6 = {
    ask: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Monad0: function() {
        return $d3d065da31679be1$export$513f938006a06509;
    }
};
var $74738728c27df511$export$487d42cd354774ee = {
    local: /* #__PURE__ */ $5807467a73465f3c$export$b5a9558a7176e41b($5807467a73465f3c$export$3af17640bddf7212),
    MonadAsk0: function() {
        return $74738728c27df511$export$97f42efbb325fef6;
    }
};
var $74738728c27df511$export$3bf5078b16209b91 = function(dict) {
    return dict.local;
};
var $74738728c27df511$export$1b4aee0b51c3def8 = function(dict) {
    return dict.ask;
};
var $74738728c27df511$export$5551e829c4b2a916 = function(dictMonadAsk) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonadAsk.Monad0().Bind1().Apply0().Functor0());
    var ask1 = $74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk);
    return function(f) {
        return map(f)(ask1);
    };
};


// Generated by purs version 0.15.15




// Generated by purs version 0.15.15




var $50c50d1f444e5fa4$export$544bf02140fa9a77 = function(x) {
    return x;
};
var $50c50d1f444e5fa4$export$7af8a265c45f06a6 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Identity " + (show(v) + ")");
        }
    };
};
var $50c50d1f444e5fa4$export$de6e130f3067e173 = function(dictSemiring) {
    return dictSemiring;
};
var $50c50d1f444e5fa4$export$fbd9f08ec652d5d9 = function(dictSemigroup) {
    return dictSemigroup;
};
var $50c50d1f444e5fa4$export$7f1a4089c064b339 = function(dictRing) {
    return dictRing;
};
var $50c50d1f444e5fa4$export$af307155aba4d997 = function(dictOrd) {
    return dictOrd;
};
var $50c50d1f444e5fa4$export$4e4e6c89b10840f9 = {
    Coercible0: function() {
        return undefined;
    }
};
var $50c50d1f444e5fa4$export$2f07791950174d24 = function(dictMonoid) {
    return dictMonoid;
};
var $50c50d1f444e5fa4$export$c7656c1a42d43140 = function(dictLazy) {
    return dictLazy;
};
var $50c50d1f444e5fa4$export$7e3f9626786077f7 = function(dictHeytingAlgebra) {
    return dictHeytingAlgebra;
};
var $50c50d1f444e5fa4$export$dc85e8383eafbd81 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $50c50d1f444e5fa4$export$ace4d1c3770c9591 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($50c50d1f444e5fa4$export$dc85e8383eafbd81)
};
var $50c50d1f444e5fa4$export$a04fa6f5a41919d9 = {
    extend: function(f) {
        return function(m) {
            return f(m);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $50c50d1f444e5fa4$export$4d1b13d40da4cff7 = function(dictEuclideanRing) {
    return dictEuclideanRing;
};
var $50c50d1f444e5fa4$export$b3449ff235884fd4 = function(dictEq) {
    return dictEq;
};
var $50c50d1f444e5fa4$export$43b3c8db16b4e7b8 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($50c50d1f444e5fa4$export$b3449ff235884fd4(dictEq));
    }
};
var $50c50d1f444e5fa4$export$982c033a83dfd7d3 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($50c50d1f444e5fa4$export$af307155aba4d997(dictOrd));
    },
    Eq10: function() {
        return $50c50d1f444e5fa4$export$43b3c8db16b4e7b8;
    }
};
var $50c50d1f444e5fa4$export$aac6efd7b2eac4c4 = {
    extract: function(v) {
        return v;
    },
    Extend0: function() {
        return $50c50d1f444e5fa4$export$a04fa6f5a41919d9;
    }
};
var $50c50d1f444e5fa4$export$133f9093a008dc4d = function(dictCommutativeRing) {
    return dictCommutativeRing;
};
var $50c50d1f444e5fa4$export$5be407eed81cb759 = function(dictBounded) {
    return dictBounded;
};
var $50c50d1f444e5fa4$export$c3b024d9c40a32df = function(dictBooleanAlgebra) {
    return dictBooleanAlgebra;
};
var $50c50d1f444e5fa4$export$c7d2c62721e92954 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $50c50d1f444e5fa4$export$91e759983456b85e = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $50c50d1f444e5fa4$export$c7d2c62721e92954;
    }
};
var $50c50d1f444e5fa4$export$fd3b2458e55fc503 = {
    pure: $50c50d1f444e5fa4$export$544bf02140fa9a77,
    Apply0: function() {
        return $50c50d1f444e5fa4$export$c7d2c62721e92954;
    }
};
var $50c50d1f444e5fa4$export$9a2f2fd6148bc6d0 = {
    Applicative0: function() {
        return $50c50d1f444e5fa4$export$fd3b2458e55fc503;
    },
    Bind1: function() {
        return $50c50d1f444e5fa4$export$91e759983456b85e;
    }
};
var $50c50d1f444e5fa4$export$1cd7ff14f6a7fcef = {
    alt: function(x) {
        return function(v) {
            return x;
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};







// Generated by purs version 0.15.15
const $e521936ea118867a$export$339fb7f00efd6941 = function(val) {
    return function() {
        return {
            value: val
        };
    };
};
const $e521936ea118867a$export$d23276e97b1411ef = function(f) {
    return function() {
        var ref = {
            value: null
        };
        ref.value = f(ref);
        return ref;
    };
};
const $e521936ea118867a$export$aafa59e2e03f2942 = function(ref) {
    return function() {
        return ref.value;
    };
};
const $e521936ea118867a$export$cc2488c59b3f757 = function(f) {
    return function(ref) {
        return function() {
            var t = f(ref.value);
            ref.value = t.state;
            return t.value;
        };
    };
};
const $e521936ea118867a$export$68d8715fc104d294 = function(val) {
    return function(ref) {
        return function() {
            ref.value = val;
        };
    };
};




var $90327512d8280b8d$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $90327512d8280b8d$export$b8cb59497041ffe4 = $e521936ea118867a$export$339fb7f00efd6941;
var $90327512d8280b8d$export$4d5401161a900ce1 = $e521936ea118867a$export$cc2488c59b3f757;
var $90327512d8280b8d$export$3ff57735a52b8713 = function(f) {
    return $90327512d8280b8d$export$4d5401161a900ce1(function(s) {
        var s$prime = f(s);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var $90327512d8280b8d$export$45b91115a89d6020 = function(f) {
    return function(s) {
        return $90327512d8280b8d$var$$$void($90327512d8280b8d$export$3ff57735a52b8713(f)(s));
    };
};


var $f93520de2fa37b44$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $f93520de2fa37b44$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f93520de2fa37b44$export$550acbd06a1f5a6a = /* #__PURE__ */ function() {
    function Loop(value0) {
        this.value0 = value0;
    }
    Loop.create = function(value0) {
        return new Loop(value0);
    };
    return Loop;
}();
var $f93520de2fa37b44$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done(value0) {
        this.value0 = value0;
    }
    Done.create = function(value0) {
        return new Done(value0);
    };
    return Done;
}();
var $f93520de2fa37b44$export$c025cfd4cc93300b = function(dict) {
    return dict.tailRecM;
};
var $f93520de2fa37b44$export$9056a6bb308e8c79 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(f) {
        return function(a) {
            return function(b) {
                return tailRecM1(function(o) {
                    return f(o.a)(o.b);
                })({
                    a: a,
                    b: b
                });
            };
        };
    };
};
var $f93520de2fa37b44$export$db5fda1cbdfd94f2 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return tailRecM1(function(o) {
                        return f(o.a)(o.b)(o.c);
                    })({
                        a: a,
                        b: b,
                        c: c
                    });
                };
            };
        };
    };
};
var $f93520de2fa37b44$export$f216db41e265325c = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    return function(m) {
        return tailRecM1(function(v) {
            return mapFlipped(m)(function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$550acbd06a1f5a6a($05149ea687d6b460$export$523c0b569236b342);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v1.value0);
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 179, column 43 - line 181, column 19): " + [
                    v1.constructor.name
                ]);
            });
        })($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $f93520de2fa37b44$export$4f7c5e075dda46f7 = function(dictMonoid) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return function(dictMonadRec) {
        var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
        var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
        return function(m) {
            return tailRecM1(function(v) {
                return mapFlipped(m)(function(v1) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v);
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(append(v)(v1.value0));
                    throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 172, column 45 - line 174, column 26): " + [
                        v1.constructor.name
                    ]);
                });
            })(mempty);
        };
    };
};
var $f93520de2fa37b44$export$2e586eaa876dd2fd = function(f) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) {
                $copy_v = f(v.value0);
                return;
            }
            if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) {
                $tco_done = true;
                return v.value0;
            }
            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 103, column 3 - line 103, column 25): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($85) {
        return go(f($85));
    };
};
var $f93520de2fa37b44$export$1a33088d59e37d84 = function(f) {
    return function(a) {
        return function(b) {
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(o) {
                return f(o.a)(o.b);
            })({
                a: a,
                b: b
            });
        };
    };
};
var $f93520de2fa37b44$export$6866e5a95a71aa68 = function(f) {
    return function(a) {
        return function(b) {
            return function(c) {
                return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(o) {
                    return f(o.a)(o.b)(o.c);
                })({
                    a: a,
                    b: b,
                    c: c
                });
            };
        };
    };
};
var $f93520de2fa37b44$export$6a06149683d26749 = {
    tailRecM: function(f) {
        return function(a0) {
            var g = function(v) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$7fe28cb29e71bf10($06733ae99ed4f534$export$bebe9059409a0d04.value);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(f(v.value0.value0));
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 153, column 7 - line 153, column 31): " + [
                    v.constructor.name
                ]);
            };
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(g)(f(a0));
        };
    },
    Monad0: function() {
        return $06733ae99ed4f534$export$f78a1c2d38efcc13;
    }
};
var $f93520de2fa37b44$export$ef692454cdd8c2ba = {
    tailRecM: function(f) {
        var runIdentity = function(v) {
            return v;
        };
        var $86 = $f93520de2fa37b44$export$2e586eaa876dd2fd(function($88) {
            return runIdentity(f($88));
        });
        return function($87) {
            return $50c50d1f444e5fa4$export$544bf02140fa9a77($86($87));
        };
    },
    Monad0: function() {
        return $50c50d1f444e5fa4$export$9a2f2fd6148bc6d0;
    }
};
var $f93520de2fa37b44$export$6871d929a8e135b0 = {
    tailRecM: function(f) {
        return function(a0) {
            return function(e) {
                return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(a) {
                    return f(a)(e);
                })(a0);
            };
        };
    },
    Monad0: function() {
        return $d3d065da31679be1$export$513f938006a06509;
    }
};
var $f93520de2fa37b44$export$ddd28c989be5e46c = {
    tailRecM: function(f) {
        return function(a0) {
            var g = function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(f(v.value0.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$19db0165690c701a(v.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 145, column 7 - line 145, column 33): " + [
                    v.constructor.name
                ]);
            };
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(g)(f(a0));
        };
    },
    Monad0: function() {
        return $7d4cccdf062a2261$export$b3b4ecb28e3a8df3;
    }
};
var $f93520de2fa37b44$export$c2472dc015e90d28 = {
    tailRecM: function(f) {
        return function(a) {
            var fromDone = function(v) {
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return v.value0;
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 137, column 30 - line 137, column 44): " + [
                    v.constructor.name
                ]);
            };
            return function __do() {
                var r = $f93520de2fa37b44$var$bindFlipped($90327512d8280b8d$export$b8cb59497041ffe4)(f(a))();
                (function() {
                    while(!function __do() {
                        var v = $e521936ea118867a$export$aafa59e2e03f2942(r)();
                        if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) {
                            var e = f(v.value0)();
                            $e521936ea118867a$export$68d8715fc104d294(e)(r)();
                            return false;
                        }
                        if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return true;
                        throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 128, column 22 - line 133, column 28): " + [
                            v.constructor.name
                        ]);
                    }());
                    return {};
                })();
                return $f93520de2fa37b44$var$map(fromDone)($e521936ea118867a$export$aafa59e2e03f2942(r))();
            };
        };
    },
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $f93520de2fa37b44$export$432fdf8e79663288 = function(a) {
    return function(b) {
        return function(c) {
            return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                a: a,
                b: b,
                c: c
            });
        };
    };
};
var $f93520de2fa37b44$export$e10d15f285e25594 = function(a) {
    return function(b) {
        return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
            a: a,
            b: b
        });
    };
};
var $f93520de2fa37b44$export$ff1ade7cb067ac12 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(m.value0);
            if (m instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(f(m.value0));
            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $f93520de2fa37b44$export$116a0f7f2303acd8 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var voidRight = $f4b2eb11fc32ed34$export$b818c54ed8d3e90a(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    return function(ma) {
        return tailRecM1(function(u) {
            return voidRight(new $f93520de2fa37b44$export$550acbd06a1f5a6a(u))(ma);
        })($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $f93520de2fa37b44$export$61e43214bca7f031 = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(v(v2.value0));
                if (v2 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v1(v2.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 33, column 1 - line 35, column 34): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};


// Generated by purs version 0.15.15

// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
// module Unsafe.Coerce
const $ac8b3532514ac019$export$401372c57776dc = function(x) {
    return x;
};




var $2b857e558a2a0921$export$2bf63e57346d9602 = $ac8b3532514ac019$export$401372c57776dc;


// Generated by purs version 0.15.15
const $f11e5cd39add8df2$export$aca8cce159e578de = function(f) {
    return function(a) {
        return function() {
            return f(a());
        };
    };
};
const $f11e5cd39add8df2$export$3bbfc465dcacc7f4 = function(a) {
    return function() {
        return a;
    };
};
const $f11e5cd39add8df2$export$b25ab69b10c0d17b = function(a) {
    return function(f) {
        return function() {
            return f(a())();
        };
    };
};
const $f11e5cd39add8df2$export$889ea624f2cb2c57 = function(f) {
    return f();
};
function $f11e5cd39add8df2$export$f021a974ad8da35c(f) {
    return function(a) {
        return function() {
            while(f())a();
        };
    };
}
function $f11e5cd39add8df2$export$f89de2e5bf57e5e6(lo) {
    return function(hi) {
        return function(f) {
            return function() {
                for(var i = lo; i < hi; i++)f(i)();
            };
        };
    };
}
const $f11e5cd39add8df2$export$8802485f9deae94f = function(as) {
    return function(f) {
        return function() {
            for(var i = 0, l = as.length; i < l; i++)f(as[i])();
        };
    };
};
function $f11e5cd39add8df2$export$b8cb59497041ffe4(val) {
    return function() {
        return {
            value: val
        };
    };
}
const $f11e5cd39add8df2$export$aafa59e2e03f2942 = function(ref) {
    return function() {
        return ref.value;
    };
};
const $f11e5cd39add8df2$export$cc2488c59b3f757 = function(f) {
    return function(ref) {
        return function() {
            var t = f(ref.value);
            ref.value = t.state;
            return t.value;
        };
    };
};
const $f11e5cd39add8df2$export$68d8715fc104d294 = function(a) {
    return function(ref) {
        return function() {
            return ref.value = a; // eslint-disable-line no-return-assign
        };
    };
};











var $08944f7287e2704c$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $08944f7287e2704c$export$4d5401161a900ce1 = $f11e5cd39add8df2$export$cc2488c59b3f757;
var $08944f7287e2704c$export$3ff57735a52b8713 = function(f) {
    return $08944f7287e2704c$export$4d5401161a900ce1(function(s) {
        var s$prime = f(s);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var $08944f7287e2704c$export$a47991927f51461e = {
    map: $f11e5cd39add8df2$export$aca8cce159e578de
};
var $08944f7287e2704c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($08944f7287e2704c$export$a47991927f51461e);
var $08944f7287e2704c$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $08944f7287e2704c$export$962073314682c2c = {
    Applicative0: function() {
        return $08944f7287e2704c$export$603d84e49041d7b2;
    },
    Bind1: function() {
        return $08944f7287e2704c$export$14049c9ff5b55fb3;
    }
};
var $08944f7287e2704c$export$14049c9ff5b55fb3 = {
    bind: $f11e5cd39add8df2$export$b25ab69b10c0d17b,
    Apply0: function() {
        return $08944f7287e2704c$var$$lazy_applyST(0);
    }
};
var $08944f7287e2704c$export$603d84e49041d7b2 = {
    pure: $f11e5cd39add8df2$export$3bbfc465dcacc7f4,
    Apply0: function() {
        return $08944f7287e2704c$var$$lazy_applyST(0);
    }
};
var $08944f7287e2704c$var$$lazy_applyST = /* #__PURE__ */ $08944f7287e2704c$var$$runtime_lazy("applyST", "Control.Monad.ST.Internal", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($08944f7287e2704c$export$962073314682c2c),
        Functor0: function() {
            return $08944f7287e2704c$export$a47991927f51461e;
        }
    };
});
var $08944f7287e2704c$export$65915895b3a8faeb = /* #__PURE__ */ $08944f7287e2704c$var$$lazy_applyST(47);
var $08944f7287e2704c$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($08944f7287e2704c$export$65915895b3a8faeb);
var $08944f7287e2704c$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($08944f7287e2704c$export$603d84e49041d7b2);
var $08944f7287e2704c$export$56941e1c622ade00 = function(dictSemigroup) {
    return {
        append: $08944f7287e2704c$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $08944f7287e2704c$export$24025a1415d0847d = {
    tailRecM: function(f) {
        return function(a) {
            var isLooping = function(v) {
                if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return true;
                return false;
            };
            var fromDone = function(v) {
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return v.value0;
                throw new Error("Failed pattern match at Control.Monad.ST.Internal (line 70, column 32 - line 70, column 46): " + [
                    v.constructor.name
                ]);
            };
            return $08944f7287e2704c$var$bind($08944f7287e2704c$var$bindFlipped($f11e5cd39add8df2$export$b8cb59497041ffe4)(f(a)))(function(r) {
                return $08944f7287e2704c$var$discard($f11e5cd39add8df2$export$f021a974ad8da35c($08944f7287e2704c$var$map(isLooping)($f11e5cd39add8df2$export$aafa59e2e03f2942(r)))($08944f7287e2704c$var$bind($f11e5cd39add8df2$export$aafa59e2e03f2942(r))(function(v) {
                    if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return $08944f7287e2704c$var$bind(f(v.value0))(function(e) {
                        return $08944f7287e2704c$var$$$void($f11e5cd39add8df2$export$68d8715fc104d294(e)(r));
                    });
                    if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $08944f7287e2704c$var$pure($05149ea687d6b460$export$523c0b569236b342);
                    throw new Error("Failed pattern match at Control.Monad.ST.Internal (line 62, column 18 - line 66, column 28): " + [
                        v.constructor.name
                    ]);
                })))(function() {
                    return $08944f7287e2704c$var$map(fromDone)($f11e5cd39add8df2$export$aafa59e2e03f2942(r));
                });
            });
        };
    },
    Monad0: function() {
        return $08944f7287e2704c$export$962073314682c2c;
    }
};
var $08944f7287e2704c$export$85c55a7e282bbb67 = function(dictMonoid) {
    var semigroupST1 = $08944f7287e2704c$export$56941e1c622ade00(dictMonoid.Semigroup0());
    return {
        mempty: $08944f7287e2704c$var$pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupST1;
        }
    };
};



var $dd1bd2cc217b6a6d$export$162690b6fa074d8b = {
    liftST: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Monad0: function() {
        return $08944f7287e2704c$export$962073314682c2c;
    }
};
var $dd1bd2cc217b6a6d$export$d1b56b21630310a5 = {
    liftST: $2b857e558a2a0921$export$2bf63e57346d9602,
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $dd1bd2cc217b6a6d$export$90556654c9c47d5f = function(dict) {
    return dict.liftST;
};


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
// Generated by purs version 0.15.15

var $a1e0a82f0b162743$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $a1e0a82f0b162743$export$15718d19459d1753 = {
    defer: function(v) {
        return $05149ea687d6b460$export$523c0b569236b342;
    }
};
var $a1e0a82f0b162743$export$5dc1db391e531241 = {
    defer: function(f) {
        return function(x) {
            return f($05149ea687d6b460$export$523c0b569236b342)(x);
        };
    }
};
var $a1e0a82f0b162743$export$260e5c0943f31606 = function(dict) {
    return dict.defer;
};
var $a1e0a82f0b162743$export$d838837eb5b184e3 = function(dictLazy) {
    var defer1 = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
    return function(f) {
        var $lazy_go = $a1e0a82f0b162743$var$$runtime_lazy("go", "Control.Lazy", function() {
            return defer1(function(v) {
                return f($lazy_go(25));
            });
        });
        var go = $lazy_go(25);
        return go;
    };
};






// Generated by purs version 0.15.15
const $083bebfcbf303ad1$export$e5682d87e23bb875 = function(b1) {
    return function(b2) {
        return b1 && b2;
    };
};
const $083bebfcbf303ad1$export$4edd36328926db3d = function(b1) {
    return function(b2) {
        return b1 || b2;
    };
};
const $083bebfcbf303ad1$export$856531720ce57da6 = function(b) {
    return !b;
};






var $f8fc227945eb179e$export$4c5e47bb71c07b6a = function(dict) {
    return dict.ttRecord;
};
var $f8fc227945eb179e$export$80bf595f9d9a1157 = function(dict) {
    return dict.tt;
};
var $f8fc227945eb179e$export$242da53d3ad27a73 = function(dict) {
    return dict.notRecord;
};
var $f8fc227945eb179e$export$6003a5f097c73977 = function(dict) {
    return dict.not;
};
var $f8fc227945eb179e$export$30918bdfe7eba090 = function(dict) {
    return dict.impliesRecord;
};
var $f8fc227945eb179e$export$6c53455e54f455ef = function(dict) {
    return dict.implies;
};
var $f8fc227945eb179e$export$960158ea2ad21b8d = {
    ff: $05149ea687d6b460$export$523c0b569236b342,
    tt: $05149ea687d6b460$export$523c0b569236b342,
    implies: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    conj: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    disj: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    not: function(v) {
        return $05149ea687d6b460$export$523c0b569236b342;
    }
};
var $f8fc227945eb179e$export$456c60aba1aeaaa = {
    conjRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    disjRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    ffRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    impliesRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    notRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    ttRecord: function(v) {
        return function(v1) {
            return {};
        };
    }
};
var $f8fc227945eb179e$export$7347fefc6a9ef6b6 = /* #__PURE__ */ function() {
    return {
        conj: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        disj: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        implies: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        ff: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        not: function(v) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        },
        tt: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value
    };
}();
var $f8fc227945eb179e$export$1b03126bff237ceb = function(dict) {
    return dict.ffRecord;
};
var $f8fc227945eb179e$export$f59495b1b7502b33 = function(dict) {
    return dict.ff;
};
var $f8fc227945eb179e$export$84e5fab3d833d7a2 = function(dict) {
    return dict.disjRecord;
};
var $f8fc227945eb179e$export$9bd7ee00e37438db = function(dict) {
    return dict.disj;
};
var $f8fc227945eb179e$export$d7d9283ee84f4c3f = {
    ff: false,
    tt: true,
    implies: function(a) {
        return function(b) {
            return $f8fc227945eb179e$export$9bd7ee00e37438db($f8fc227945eb179e$export$d7d9283ee84f4c3f)($f8fc227945eb179e$export$6003a5f097c73977($f8fc227945eb179e$export$d7d9283ee84f4c3f)(a))(b);
        };
    },
    conj: $083bebfcbf303ad1$export$e5682d87e23bb875,
    disj: $083bebfcbf303ad1$export$4edd36328926db3d,
    not: $083bebfcbf303ad1$export$856531720ce57da6
};
var $f8fc227945eb179e$export$49ae8d06200d7fce = function(dict) {
    return dict.conjRecord;
};
var $f8fc227945eb179e$export$7f2b975cf624805f = function() {
    return function(dictHeytingAlgebraRecord) {
        return {
            ff: $f8fc227945eb179e$export$1b03126bff237ceb(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            tt: $f8fc227945eb179e$export$4c5e47bb71c07b6a(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            conj: $f8fc227945eb179e$export$49ae8d06200d7fce(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            disj: $f8fc227945eb179e$export$84e5fab3d833d7a2(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            implies: $f8fc227945eb179e$export$30918bdfe7eba090(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            not: $f8fc227945eb179e$export$242da53d3ad27a73(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $f8fc227945eb179e$export$fb254c661fe9c0db = function(dict) {
    return dict.conj;
};
var $f8fc227945eb179e$export$e9ae480d80dfc592 = function(dictHeytingAlgebra) {
    var ff1 = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
    var tt1 = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
    var implies1 = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
    var conj1 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj1 = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var not1 = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
    return {
        ff: function(v) {
            return ff1;
        },
        tt: function(v) {
            return tt1;
        },
        implies: function(f) {
            return function(g) {
                return function(a) {
                    return implies1(f(a))(g(a));
                };
            };
        },
        conj: function(f) {
            return function(g) {
                return function(a) {
                    return conj1(f(a))(g(a));
                };
            };
        },
        disj: function(f) {
            return function(g) {
                return function(a) {
                    return disj1(f(a))(g(a));
                };
            };
        },
        not: function(f) {
            return function(a) {
                return not1(f(a));
            };
        }
    };
};
var $f8fc227945eb179e$export$8b20a52b1d1213a4 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(dictHeytingAlgebraRecord) {
            var conjRecord1 = $f8fc227945eb179e$export$49ae8d06200d7fce(dictHeytingAlgebraRecord);
            var disjRecord1 = $f8fc227945eb179e$export$84e5fab3d833d7a2(dictHeytingAlgebraRecord);
            var impliesRecord1 = $f8fc227945eb179e$export$30918bdfe7eba090(dictHeytingAlgebraRecord);
            var ffRecord1 = $f8fc227945eb179e$export$1b03126bff237ceb(dictHeytingAlgebraRecord);
            var notRecord1 = $f8fc227945eb179e$export$242da53d3ad27a73(dictHeytingAlgebraRecord);
            var ttRecord1 = $f8fc227945eb179e$export$4c5e47bb71c07b6a(dictHeytingAlgebraRecord);
            return function(dictHeytingAlgebra) {
                var conj1 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
                var disj1 = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
                var implies1 = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
                var ff1 = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
                var not1 = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
                var tt1 = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
                return {
                    conjRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = conjRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(conj1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    disjRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = disjRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(disj1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    impliesRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = impliesRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(implies1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    ffRecord: function(v) {
                        return function(row) {
                            var tail = ffRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(row);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(ff1)(tail);
                        };
                    },
                    notRecord: function(v) {
                        return function(row) {
                            var tail = notRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(row);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                            return insert(not1(get(row)))(tail);
                        };
                    },
                    ttRecord: function(v) {
                        return function(row) {
                            var tail = ttRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(row);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(tt1)(tail);
                        };
                    }
                };
            };
        };
    };
};










var $71f2e2e9476163f8$export$1908877435b1d5e9 = /* #__PURE__ */ function() {
    function Tuple(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Tuple.create = function(value0) {
        return function(value1) {
            return new Tuple(value0, value1);
        };
    };
    return Tuple;
}();
var $71f2e2e9476163f8$export$7864d59d01b6d6bf = function(f) {
    return function(v) {
        return f(v.value0)(v.value1);
    };
};
var $71f2e2e9476163f8$export$b0e76d9850c64156 = function(v) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1, v.value0);
};
var $71f2e2e9476163f8$export$6f71268a1666ab58 = function(v) {
    return v.value1;
};
var $71f2e2e9476163f8$export$c29279d1dfdefb95 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(Tuple " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $71f2e2e9476163f8$export$a55548456e48767 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var one = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
    return function(dictSemiring1) {
        var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring1);
        var mul1 = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring1);
        return {
            add: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(add(v.value0)(v1.value0), add1(v.value1)(v1.value1));
                };
            },
            one: new $71f2e2e9476163f8$export$1908877435b1d5e9(one, $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring1)),
            mul: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(mul(v.value0)(v1.value0), mul1(v.value1)(v1.value1));
                };
            },
            zero: new $71f2e2e9476163f8$export$1908877435b1d5e9(zero, $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring1))
        };
    };
};
var $71f2e2e9476163f8$export$ab2b4b200e457b99 = {
    compose: function(v) {
        return function(v1) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v.value1);
        };
    }
};
var $71f2e2e9476163f8$export$1f8404c41aab4117 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(dictSemigroup1) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup1);
        return {
            append: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), append2(v.value1)(v1.value1));
                };
            }
        };
    };
};
var $71f2e2e9476163f8$export$9ba4b2debe474100 = function(dictRing) {
    var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var semiringTuple1 = $71f2e2e9476163f8$export$a55548456e48767(dictRing.Semiring0());
    return function(dictRing1) {
        var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing1);
        var semiringTuple2 = semiringTuple1(dictRing1.Semiring0());
        return {
            sub: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(sub(v.value0)(v1.value0), sub1(v.value1)(v1.value1));
                };
            },
            Semiring0: function() {
                return semiringTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$a9eaa17b3ab5a78d = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var semigroupTuple1 = $71f2e2e9476163f8$export$1f8404c41aab4117(dictMonoid.Semigroup0());
    return function(dictMonoid1) {
        var semigroupTuple2 = semigroupTuple1(dictMonoid1.Semigroup0());
        return {
            mempty: new $71f2e2e9476163f8$export$1908877435b1d5e9(mempty, $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid1)),
            Semigroup0: function() {
                return semigroupTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$47e10f15d8f6e8d8 = function(dictHeytingAlgebra) {
    var tt = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
    var ff = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
    var implies = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
    var conj1 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var not = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
    return function(dictHeytingAlgebra1) {
        var implies1 = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra1);
        var conj2 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra1);
        var disj1 = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra1);
        var not1 = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra1);
        return {
            tt: new $71f2e2e9476163f8$export$1908877435b1d5e9(tt, $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra1)),
            ff: new $71f2e2e9476163f8$export$1908877435b1d5e9(ff, $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra1)),
            implies: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(implies(v.value0)(v1.value0), implies1(v.value1)(v1.value1));
                };
            },
            conj: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(conj1(v.value0)(v1.value0), conj2(v.value1)(v1.value1));
                };
            },
            disj: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(disj(v.value0)(v1.value0), disj1(v.value1)(v1.value1));
                };
            },
            not: function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(not(v.value0), not1(v.value1));
            }
        };
    };
};
var $71f2e2e9476163f8$export$8b71b9e63ea20f7b = {
    to: function(x) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(x.value0, x.value1);
    },
    from: function(x) {
        return new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1);
    }
};
var $71f2e2e9476163f8$export$19ab04734dcb0ff0 = {
    map: function(f) {
        return function(m) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(m.value0, f(m.value1));
        };
    }
};
var $71f2e2e9476163f8$export$9801206bd382aee0 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($71f2e2e9476163f8$export$19ab04734dcb0ff0)
};
var $71f2e2e9476163f8$export$9e770fa6ce19a9d6 = function(v) {
    return v.value0;
};
var $71f2e2e9476163f8$export$28de2725b8db0d42 = function(dictLazy) {
    var defer = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
    return function(dictLazy1) {
        var defer1 = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy1);
        return {
            defer: function(f) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(defer(function(v) {
                    return $71f2e2e9476163f8$export$9e770fa6ce19a9d6(f($05149ea687d6b460$export$523c0b569236b342));
                }), defer1(function(v) {
                    return $71f2e2e9476163f8$export$6f71268a1666ab58(f($05149ea687d6b460$export$523c0b569236b342));
                }));
            }
        };
    };
};
var $71f2e2e9476163f8$export$1d78bbb1aca8569c = {
    extend: function(f) {
        return function(v) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, f(v));
        };
    },
    Functor0: function() {
        return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
    }
};
var $71f2e2e9476163f8$export$d625e8a97ba36bd6 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq1(x.value1)(y.value1);
                };
            }
        };
    };
};
var $71f2e2e9476163f8$export$8f11eb03746a66e2 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqTuple1 = $71f2e2e9476163f8$export$d625e8a97ba36bd6(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqTuple2 = eqTuple1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return compare1(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$11462014c11c050e = function(dictEq) {
    var eqTuple1 = $71f2e2e9476163f8$export$d625e8a97ba36bd6(dictEq);
    return {
        eq1: function(dictEq1) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqTuple1(dictEq1));
        }
    };
};
var $71f2e2e9476163f8$export$2c05c340f808b07c = function(dictOrd) {
    var ordTuple1 = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictOrd);
    var eq1Tuple1 = $71f2e2e9476163f8$export$11462014c11c050e(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordTuple1(dictOrd1));
        },
        Eq10: function() {
            return eq1Tuple1;
        }
    };
};
var $71f2e2e9476163f8$export$c3095a23b368d1f2 = function(f) {
    return function(a) {
        return function(b) {
            return f(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, b));
        };
    };
};
var $71f2e2e9476163f8$export$8e995acc5599767e = {
    extract: $71f2e2e9476163f8$export$6f71268a1666ab58,
    Extend0: function() {
        return $71f2e2e9476163f8$export$1d78bbb1aca8569c;
    }
};
var $71f2e2e9476163f8$export$4b53a8a87c01bf43 = function(dictCommutativeRing) {
    var ringTuple1 = $71f2e2e9476163f8$export$9ba4b2debe474100(dictCommutativeRing.Ring0());
    return function(dictCommutativeRing1) {
        var ringTuple2 = ringTuple1(dictCommutativeRing1.Ring0());
        return {
            Ring0: function() {
                return ringTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$f1ad4da5028a9f5f = function(dictBounded) {
    var top = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
    var bottom = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    var ordTuple1 = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictBounded.Ord0());
    return function(dictBounded1) {
        var ordTuple2 = ordTuple1(dictBounded1.Ord0());
        return {
            top: new $71f2e2e9476163f8$export$1908877435b1d5e9(top, $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded1)),
            bottom: new $71f2e2e9476163f8$export$1908877435b1d5e9(bottom, $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded1)),
            Ord0: function() {
                return ordTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$cc556dd69d46ad4 = function(dictBooleanAlgebra) {
    var heytingAlgebraTuple1 = $71f2e2e9476163f8$export$47e10f15d8f6e8d8(dictBooleanAlgebra.HeytingAlgebra0());
    return function(dictBooleanAlgebra1) {
        var heytingAlgebraTuple2 = heytingAlgebraTuple1(dictBooleanAlgebra1.HeytingAlgebra0());
        return {
            HeytingAlgebra0: function() {
                return heytingAlgebraTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$c87751c00e30fc9e = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        apply: function(v) {
            return function(v1) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), v.value1(v1.value1));
            };
        },
        Functor0: function() {
            return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
        }
    };
};
var $71f2e2e9476163f8$export$5266c91ec2409601 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    var applyTuple1 = $71f2e2e9476163f8$export$c87751c00e30fc9e(dictSemigroup);
    return {
        bind: function(v) {
            return function(f) {
                var v1 = f(v.value1);
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), v1.value1);
            };
        },
        Apply0: function() {
            return applyTuple1;
        }
    };
};
var $71f2e2e9476163f8$export$2f2c2cdaef7b685e = function(dictMonoid) {
    var applyTuple1 = $71f2e2e9476163f8$export$c87751c00e30fc9e(dictMonoid.Semigroup0());
    return {
        pure: $71f2e2e9476163f8$export$1908877435b1d5e9.create($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Apply0: function() {
            return applyTuple1;
        }
    };
};
var $71f2e2e9476163f8$export$d5a06b0f6aa5b11a = function(dictMonoid) {
    var applicativeTuple1 = $71f2e2e9476163f8$export$2f2c2cdaef7b685e(dictMonoid);
    var bindTuple1 = $71f2e2e9476163f8$export$5266c91ec2409601(dictMonoid.Semigroup0());
    return {
        Applicative0: function() {
            return applicativeTuple1;
        },
        Bind1: function() {
            return bindTuple1;
        }
    };
};



var $f2d5035ce6148af6$export$ca000e230c0caa3e = function(dict) {
    return dict.state;
};
var $f2d5035ce6148af6$export$327f7b26ebf455db = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(s) {
        return state1(function(v) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($05149ea687d6b460$export$523c0b569236b342, s);
        });
    };
};
var $f2d5035ce6148af6$export$45b91115a89d6020 = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($05149ea687d6b460$export$523c0b569236b342, f(s));
        });
    };
};
var $f2d5035ce6148af6$export$3ff57735a52b8713 = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            var s$prime = f(s);
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(s$prime, s$prime);
        });
    };
};
var $f2d5035ce6148af6$export$49487f6cbb79019d = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(s), s);
        });
    };
};
var $f2d5035ce6148af6$export$3988ae62b71be9a3 = function(dictMonadState) {
    return $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState)(function(s) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(s, s);
    });
};


// Generated by purs version 0.15.15
var $384c24655e07f36c$export$590e8b2c435046d9 = function(dict) {
    return dict.lift;
};


// Generated by purs version 0.15.15



var $2c4a247071255d7e$export$de3113ed932c61ab = function(dict) {
    return dict.tell;
};
var $2c4a247071255d7e$export$167b0ad523238611 = function(dict) {
    return dict.pass;
};
var $2c4a247071255d7e$export$63174c828edd6ff8 = function(dict) {
    return dict.listen;
};
var $2c4a247071255d7e$export$e63807bfd37abcc0 = function(dictMonadWriter) {
    var Monad1 = dictMonadWriter.MonadTell1().Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen1 = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    return function(f) {
        return function(m) {
            return bind(listen1(m))(function(v) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, f(v.value1)));
            });
        };
    };
};
var $2c4a247071255d7e$export$b0a417369eddf9f2 = function(dictMonadWriter) {
    var pass1 = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monad1 = dictMonadWriter.MonadTell1().Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    return function(f) {
        return function(m) {
            return pass1(bind(m)(function(a) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, f));
            }));
        };
    };
};







// Generated by purs version 0.15.15


var $f2c9b767d25cfbb9$export$86a2e24932ca2aa0 = {
    liftEffect: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $f2c9b767d25cfbb9$export$34255e15eb56d2b3 = function(dict) {
    return dict.liftEffect;
};


var $d2284b2d3e1b6f87$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $d2284b2d3e1b6f87$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $d2284b2d3e1b6f87$export$2e7afd25df37516b = function(x) {
    return x;
};
var $d2284b2d3e1b6f87$export$998a9a780731dd5b = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            var mapLeft = function(v1) {
                return function(v2) {
                    if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v2.value0);
                    if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1(v2.value0));
                    throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 43, column 3 - line 43, column 32): " + [
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
            return map1(mapLeft(f))(v);
        };
    };
};
var $d2284b2d3e1b6f87$export$8291c2122093ac93 = function(v) {
    return v;
};
var $d2284b2d3e1b6f87$export$779e60e46c1e0f8b = {
    Coercible0: function() {
        return undefined;
    }
};
var $d2284b2d3e1b6f87$export$fa93accd6d6dc1d2 = {
    lift: function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(m) {
            return bind(m)(function(a) {
                return pure(new $7d4cccdf062a2261$export$19db0165690c701a(a));
            });
        };
    }
};
var $d2284b2d3e1b6f87$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d2284b2d3e1b6f87$export$fa93accd6d6dc1d2);
var $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $d2284b2d3e1b6f87$export$d684c62fe584fcfa = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(map1($d2284b2d3e1b6f87$var$map(f)));
        }
    };
};
var $d2284b2d3e1b6f87$export$67aba9fb222c5e1d = function(dictApplicative) {
    var $191 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function($192) {
        return $d2284b2d3e1b6f87$export$2e7afd25df37516b($191($192));
    };
};
var $d2284b2d3e1b6f87$export$5a198347e9244c74 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad);
        },
        Bind1: function() {
            return $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return {
        bind: function(v) {
            return function(k) {
                return bind(v)($7d4cccdf062a2261$export$5f5be1bb6cd1fded(function($193) {
                    return pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($193));
                })(function(a) {
                    var v1 = k(a);
                    return v1;
                }));
            };
        },
        Apply0: function() {
            return $d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$581feac922061bf0 = function(dictMonad) {
    var functorExceptT1 = $d2284b2d3e1b6f87$export$d684c62fe584fcfa(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad)),
        Functor0: function() {
            return functorExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$963960a96c103d2f = function(dictMonad) {
    return {
        pure: function() {
            var $194 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function($195) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($194($7d4cccdf062a2261$export$19db0165690c701a.create($195)));
            };
        }(),
        Apply0: function() {
            return $d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$3539db811b3307bc = function(dictMonad) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $d2284b2d3e1b6f87$export$90c373eb83297b8e = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        ask: $d2284b2d3e1b6f87$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$fb6edd8453289893 = function(dictMonadReader) {
    var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
    var monadAskExceptT1 = $d2284b2d3e1b6f87$export$90c373eb83297b8e(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(local(f));
        },
        MonadAsk0: function() {
            return monadAskExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$aed911633663c3d8 = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return callCC(function(c) {
                var v = f(function(a) {
                    return c(new $7d4cccdf062a2261$export$19db0165690c701a(a));
                });
                return v;
            });
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$14ff7e4e497a86b1 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        liftEffect: function() {
            var $196 = $d2284b2d3e1b6f87$var$lift(Monad0);
            var $197 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($198) {
                return $196($197($198));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$fed8f4223a283613 = function(dictMonadRec) {
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        tailRecM: function(f) {
            var $199 = tailRecM(function(a) {
                var v = f(a);
                return bind(v)(function(m$prime) {
                    return pure(function() {
                        if (m$prime instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$37c4d04eafdc5515(m$prime.value0));
                        if (m$prime instanceof $7d4cccdf062a2261$export$19db0165690c701a && m$prime.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(m$prime.value0.value0);
                        if (m$prime instanceof $7d4cccdf062a2261$export$19db0165690c701a && m$prime.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$19db0165690c701a(m$prime.value0.value0));
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 75, column 14 - line 78, column 43): " + [
                            m$prime.constructor.name
                        ]);
                    }());
                });
            });
            return function($200) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($199($200));
            };
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$e8228b6b505171fd = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var lift1 = $d2284b2d3e1b6f87$var$lift(Monad0);
    var state = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        state: function(f) {
            return lift1(state(f));
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$7a7c2ab3eaa0a3e9 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad1);
    return {
        tell: function() {
            var $201 = $d2284b2d3e1b6f87$var$lift(Monad1);
            var $202 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($203) {
                return $201($202($203));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$a9c9aad9aca5566b = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    var pass = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellExceptT1 = $d2284b2d3e1b6f87$export$7a7c2ab3eaa0a3e9(MonadTell1);
    return {
        listen: $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(function(m) {
            return bind(listen(m))(function(v) {
                return pure($d2284b2d3e1b6f87$var$map(function(r) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(r, v.value1);
                })(v.value0));
            });
        }),
        pass: $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(function(m) {
            return pass(bind(m)(function(a) {
                return pure(function() {
                    if (a instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $7d4cccdf062a2261$export$37c4d04eafdc5515(a.value0), $d2284b2d3e1b6f87$var$identity);
                    if (a instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $7d4cccdf062a2261$export$19db0165690c701a(a.value0.value0), a.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 135, column 10 - line 137, column 45): " + [
                        a.constructor.name
                    ]);
                }());
            }));
        }),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$75f89ba5e7a712b0 = function(dictMonad) {
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad);
    return {
        throwError: function() {
            var $204 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function($205) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($204($7d4cccdf062a2261$export$37c4d04eafdc5515.create($205)));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$78c1353d784c47dd = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadThrowExceptT1 = $d2284b2d3e1b6f87$export$75f89ba5e7a712b0(dictMonad);
    return {
        catchError: function(v) {
            return function(k) {
                return bind(v)($7d4cccdf062a2261$export$5f5be1bb6cd1fded(function(a) {
                    var v1 = k(a);
                    return v1;
                })(function($206) {
                    return pure($7d4cccdf062a2261$export$19db0165690c701a.create($206));
                }));
            };
        },
        MonadThrow0: function() {
            return monadThrowExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$5b1239aace2566fd = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        liftST: function() {
            var $207 = $d2284b2d3e1b6f87$var$lift(Monad0);
            var $208 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($209) {
                return $207($208($209));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$9a16ccee20eb55ce = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    var semigroupExceptT1 = $d2284b2d3e1b6f87$export$3539db811b3307bc(dictMonad);
    return function(dictMonoid) {
        var semigroupExceptT2 = semigroupExceptT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        var functorExceptT1 = $d2284b2d3e1b6f87$export$d684c62fe584fcfa(Bind1.Apply0().Functor0());
        return {
            alt: function(v) {
                return function(v1) {
                    return bind(v)(function(rm) {
                        if (rm instanceof $7d4cccdf062a2261$export$19db0165690c701a) return pure(new $7d4cccdf062a2261$export$19db0165690c701a(rm.value0));
                        if (rm instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return bind(v1)(function(rn) {
                            if (rn instanceof $7d4cccdf062a2261$export$19db0165690c701a) return pure(new $7d4cccdf062a2261$export$19db0165690c701a(rn.value0));
                            if (rn instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(append(rm.value0)(rn.value0)));
                            throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 87, column 9 - line 89, column 49): " + [
                                rn.constructor.name
                            ]);
                        });
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 83, column 5 - line 89, column 49): " + [
                            rm.constructor.name
                        ]);
                    });
                };
            },
            Functor0: function() {
                return functorExceptT1;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$c5d1f65b4da4d62f = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var altExceptT1 = $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781(dictMonoid.Semigroup0());
    return function(dictMonad) {
        var altExceptT2 = altExceptT1(dictMonad);
        return {
            empty: $5dfefa023749ded0$export$8bf7aba4a9e09055($d2284b2d3e1b6f87$export$75f89ba5e7a712b0(dictMonad))(mempty),
            Alt0: function() {
                return altExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$bfd291e36e6170e5 = function(dictMonoid) {
    var plusExceptT1 = $d2284b2d3e1b6f87$export$c5d1f65b4da4d62f(dictMonoid);
    return function(dictMonad) {
        var applicativeExceptT1 = $d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad);
        var plusExceptT2 = plusExceptT1(dictMonad);
        return {
            Applicative0: function() {
                return applicativeExceptT1;
            },
            Plus1: function() {
                return plusExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$2b1e74d8588fcb7c = function(dictMonoid) {
    var alternativeExceptT1 = $d2284b2d3e1b6f87$export$bfd291e36e6170e5(dictMonoid);
    return function(dictMonad) {
        var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad);
        var alternativeExceptT2 = alternativeExceptT1(dictMonad);
        return {
            Monad0: function() {
                return monadExceptT1;
            },
            Alternative1: function() {
                return alternativeExceptT2;
            }
        };
    };
};



// Generated by purs version 0.15.15
// Generated by purs version 0.15.15

var $a4e6c090e9e673b6$export$8c14e57e778d3873 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};


var $4fa4836228a192cc$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $4fa4836228a192cc$export$4997ffc0176396a6 = function() {
    return $4fa4836228a192cc$var$coerce;
};
var $4fa4836228a192cc$var$wrap1 = /* #__PURE__ */ $4fa4836228a192cc$export$4997ffc0176396a6();
var $4fa4836228a192cc$export$debb760848ca95a = function() {
    return $4fa4836228a192cc$var$coerce;
};
var $4fa4836228a192cc$var$unwrap1 = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $4fa4836228a192cc$export$5ac000a3404ef088 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$18fe6ced65b9d3a7 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$9824f93a497ba98e = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$3b98aa7d576b2b80 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$a2a39c9747f0e54a = function() {
    return function(v) {
        return $4fa4836228a192cc$var$unwrap1;
    };
};
var $4fa4836228a192cc$export$df3f009e3d155b20 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$f2787354896befb9 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$d0d3897f12fa9d17 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$e8dd23d7349f1a08 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$fb4902fd9e525693 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$cbef643c6d6f42c2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$ccaccac244187f64 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$130c32806db3fdc8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$bae63404e9252557 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$940059b52273aa56 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$b77ba17f6321a9fb = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$59af3bbd6a00f6a9 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$78c87ff68dcb8da2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$3ff57735a52b8713 = function() {
    return function(fn) {
        return function(t) {
            return $4fa4836228a192cc$var$wrap1(fn($4fa4836228a192cc$var$unwrap1(t)));
        };
    };
};
var $4fa4836228a192cc$export$bb44f104e3c54dae = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$b533eaec53aab18a = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$7317c19c5df48291 = function() {
    return function() {
        return function() {
            return function(v) {
                return function(f) {
                    return $4fa4836228a192cc$var$coerce(f($4fa4836228a192cc$var$wrap1));
                };
            };
        };
    };
};


var $f9f243b94d1fc188$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $f9f243b94d1fc188$export$64f3cd24d850d401 = /* #__PURE__ */ $d2284b2d3e1b6f87$export$998a9a780731dd5b($50c50d1f444e5fa4$export$dc85e8383eafbd81);
var $f9f243b94d1fc188$export$a25b8a8a37f2d1cd = function($3) {
    return $f9f243b94d1fc188$var$unwrap($d2284b2d3e1b6f87$export$8291c2122093ac93($3));
};
var $f9f243b94d1fc188$export$8e638b2c22277c65 = function(f) {
    return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(function($4) {
        return $50c50d1f444e5fa4$export$544bf02140fa9a77(f($f9f243b94d1fc188$var$unwrap($4)));
    });
};



// Generated by purs version 0.15.15

// Generated by purs version 0.15.15













// Generated by purs version 0.15.15


var $7abe8fbe97ebda87$export$b7c99dd4fc96d90e = {
    empty: [],
    Alt0: function() {
        return $75e93a4111e80214$export$186d613bb872946c;
    }
};
var $7abe8fbe97ebda87$export$6e22c362a0406a2c = function(dict) {
    return dict.empty;
};








var $e9bda291f4ec10ec$export$73ce73bddfe2800a = function(x) {
    return x;
};
var $e9bda291f4ec10ec$export$72aea7109e8312dd = function(f) {
    return function(v) {
        return function($199) {
            return v(f($199));
        };
    };
};
var $e9bda291f4ec10ec$export$c5ba8a89d9140c32 = function(v) {
    return v;
};
var $e9bda291f4ec10ec$export$dce35699eedd4739 = {
    Coercible0: function() {
        return undefined;
    }
};
var $e9bda291f4ec10ec$export$5e0a9e9fea50cb88 = {
    lift: function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(m) {
            return function(s) {
                return bind(m)(function(x) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(x, s));
                });
            };
        };
    }
};
var $e9bda291f4ec10ec$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($e9bda291f4ec10ec$export$5e0a9e9fea50cb88);
var $e9bda291f4ec10ec$export$8342df5ddac360cd = function(f) {
    return function(v) {
        return function($200) {
            return f(v($200));
        };
    };
};
var $e9bda291f4ec10ec$export$dce43013fc3a5fe1 = {
    defer: function(f) {
        return function(s) {
            var v = f($05149ea687d6b460$export$523c0b569236b342);
            return v(s);
        };
    }
};
var $e9bda291f4ec10ec$export$d5449d946db19e3a = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return function(s) {
                    return map(function(v1) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v1.value0), v1.value1);
                    })(v(s));
                };
            };
        }
    };
};
var $e9bda291f4ec10ec$export$193956ba360b7728 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return function(s) {
            return map($71f2e2e9476163f8$export$6f71268a1666ab58)(v(s));
        };
    };
};
var $e9bda291f4ec10ec$export$99aa49a66d7c0535 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return function(s) {
            return map($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(v(s));
        };
    };
};
var $e9bda291f4ec10ec$export$345b4840c14ff10f = function(dictMonad) {
    return {
        Applicative0: function() {
            return $e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad);
        },
        Bind1: function() {
            return $e9bda291f4ec10ec$export$f28534bdc7259c7(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$f28534bdc7259c7 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return {
        bind: function(v) {
            return function(f) {
                return function(s) {
                    return bind(v(s))(function(v1) {
                        var v3 = f(v1.value0);
                        return v3(v1.value1);
                    });
                };
            };
        },
        Apply0: function() {
            return $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef = function(dictMonad) {
    var functorStateT1 = $e9bda291f4ec10ec$export$d5449d946db19e3a(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonad)),
        Functor0: function() {
            return functorStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$5cbc630d6fbe2e14 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return {
        pure: function(a) {
            return function(s) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, s));
            };
        },
        Apply0: function() {
            return $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$726f0b075e4f5d8b = function(dictMonad) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $e9bda291f4ec10ec$export$45bacc938270e8f5 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        ask: $e9bda291f4ec10ec$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$20f71c563c2e6d49 = function(dictMonadReader) {
    var monadAskStateT1 = $e9bda291f4ec10ec$export$45bacc938270e8f5(dictMonadReader.MonadAsk0());
    return {
        local: function() {
            var $201 = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
            return function($202) {
                return $e9bda291f4ec10ec$export$8342df5ddac360cd($201($202));
            };
        }(),
        MonadAsk0: function() {
            return monadAskStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$2e498a385f8c30f1 = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return function(s) {
                return callCC(function(c) {
                    var v = f(function(a) {
                        return function(s$prime) {
                            return c(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, s$prime));
                        };
                    });
                    return v(s);
                });
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$cba9856135198781 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        liftEffect: function() {
            var $203 = $e9bda291f4ec10ec$var$lift(Monad0);
            var $204 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($205) {
                return $203($204($205));
            };
        }(),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$ade5de830b656137 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        tailRecM: function(f) {
            return function(a) {
                var f$prime = function(v) {
                    var v1 = f(v.value0);
                    return bind(v1(v.value1))(function(v2) {
                        return pure(function() {
                            if (v2.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, v2.value1));
                            if (v2.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, v2.value1));
                            throw new Error("Failed pattern match at Control.Monad.State.Trans (line 88, column 16 - line 90, column 40): " + [
                                v2.value0.constructor.name
                            ]);
                        }());
                    });
                };
                return function(s) {
                    return tailRecM(f$prime)(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, s));
                };
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$fc3b89a546fa5c5c = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonad);
    return {
        state: function(f) {
            return function($206) {
                return pure(f($206));
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$7fdbbf63ca644aa6 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad1);
    return {
        tell: function() {
            var $207 = $e9bda291f4ec10ec$var$lift(Monad1);
            var $208 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($209) {
                return $207($208($209));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$f97520cd68688e2d = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    var pass = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellStateT1 = $e9bda291f4ec10ec$export$7fdbbf63ca644aa6(MonadTell1);
    return {
        listen: function(m) {
            return function(s) {
                return bind(listen(m(s)))(function(v) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0.value0, v.value1), v.value0.value1));
                });
            };
        },
        pass: function(m) {
            return function(s) {
                return pass(bind(m(s))(function(v) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0.value0, v.value1), v.value0.value1));
                }));
            };
        },
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$89cac97299cfdec2 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var lift1 = $e9bda291f4ec10ec$var$lift(Monad0);
    var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        throwError: function(e) {
            return lift1(throwError(e));
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$c2a2ecf63b1e47e2 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowStateT1 = $e9bda291f4ec10ec$export$89cac97299cfdec2(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return function(s) {
                    return catchError(v(s))(function(e) {
                        var v1 = h(e);
                        return v1(s);
                    });
                };
            };
        },
        MonadThrow0: function() {
            return monadThrowStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$e7c6f10a88f3ca17 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        liftST: function() {
            var $210 = $e9bda291f4ec10ec$var$lift(Monad0);
            var $211 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($212) {
                return $210($211($212));
            };
        }(),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$9d9b8c7bcee971bf = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad));
    var semigroupStateT1 = $e9bda291f4ec10ec$export$726f0b075e4f5d8b(dictMonad);
    return function(dictMonoid) {
        var semigroupStateT2 = semigroupStateT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$d5bde0fdc0bca75b = function(dictMonad) {
    return function(dictAlt) {
        var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
        var functorStateT1 = $e9bda291f4ec10ec$export$d5449d946db19e3a(dictAlt.Functor0());
        return {
            alt: function(v) {
                return function(v1) {
                    return function(s) {
                        return alt(v(s))(v1(s));
                    };
                };
            },
            Functor0: function() {
                return functorStateT1;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$300a7627bf7b0e65 = function(dictMonad) {
    var altStateT1 = $e9bda291f4ec10ec$export$d5bde0fdc0bca75b(dictMonad);
    return function(dictPlus) {
        var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
        var altStateT2 = altStateT1(dictPlus.Alt0());
        return {
            empty: function(v) {
                return empty;
            },
            Alt0: function() {
                return altStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$d31747194ff6662e = function(dictMonad) {
    var applicativeStateT1 = $e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad);
    var plusStateT1 = $e9bda291f4ec10ec$export$300a7627bf7b0e65(dictMonad);
    return function(dictAlternative) {
        var plusStateT2 = plusStateT1(dictAlternative.Plus1());
        return {
            Applicative0: function() {
                return applicativeStateT1;
            },
            Plus1: function() {
                return plusStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$b08eeaf68c7005d9 = function(dictMonadPlus) {
    var Monad0 = dictMonadPlus.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    var alternativeStateT1 = $e9bda291f4ec10ec$export$d31747194ff6662e(Monad0)(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadStateT1;
        },
        Alternative1: function() {
            return alternativeStateT1;
        }
    };
};




var $4a0611d0fc3e3eac$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $4a0611d0fc3e3eac$export$29d22fcef0a54f1b = $e9bda291f4ec10ec$export$72aea7109e8312dd;
var $4a0611d0fc3e3eac$export$4b65631072155b20 = function(v) {
    return function($18) {
        return $4a0611d0fc3e3eac$var$unwrap(v($18));
    };
};
var $4a0611d0fc3e3eac$export$a337c713bdba072 = function(f) {
    return $e9bda291f4ec10ec$export$8342df5ddac360cd(function($19) {
        return $50c50d1f444e5fa4$export$544bf02140fa9a77(f($4a0611d0fc3e3eac$var$unwrap($19)));
    });
};
var $4a0611d0fc3e3eac$export$6feb49085bba08e4 = function(v) {
    return function(s) {
        var v1 = v(s);
        return v1.value1;
    };
};
var $4a0611d0fc3e3eac$export$3f3c20f32c573065 = function(v) {
    return function(s) {
        var v1 = v(s);
        return v1.value0;
    };
};







// Generated by purs version 0.15.15





// Generated by purs version 0.15.15
const $44c597fdc38e7b03$export$6332150c6d01d807 = function(f) {
    return function(init) {
        return function(xs) {
            var acc = init;
            var len = xs.length;
            for(var i = len - 1; i >= 0; i--)acc = f(xs[i])(acc);
            return acc;
        };
    };
};
const $44c597fdc38e7b03$export$6b86e13802001a00 = function(f) {
    return function(init) {
        return function(xs) {
            var acc = init;
            var len = xs.length;
            for(var i = 0; i < len; i++)acc = f(acc)(xs[i]);
            return acc;
        };
    };
};











// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
const $87f783ef0843fa28$export$2ed6d41c398ed712 = function(f) {
    return function(xs) {
        return xs.map(function(_, i, xs) {
            return f(xs.slice(i));
        });
    };
};





var $c8f9cdd14046b503$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $c8f9cdd14046b503$export$cd01f0fbd2ca8bd6 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        extend: function(f) {
            return function(g) {
                return function(w) {
                    return f(function(w$prime) {
                        return g(append(w)(w$prime));
                    });
                };
            };
        },
        Functor0: function() {
            return $f4b2eb11fc32ed34$export$11c8d16a3c15d11b;
        }
    };
};
var $c8f9cdd14046b503$export$a321b0e45770af43 = {
    extend: $87f783ef0843fa28$export$2ed6d41c398ed712,
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $c8f9cdd14046b503$export$8b58be045bf06082 = function(dict) {
    return dict.extend;
};
var $c8f9cdd14046b503$export$285c6f9556cd75fc = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(w) {
        return function(f) {
            return extend1(f)(w);
        };
    };
};
var $c8f9cdd14046b503$export$ecd5e8ace626722c = function(dictExtend) {
    return $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend)($c8f9cdd14046b503$var$identity);
};
var $c8f9cdd14046b503$export$fbe89af2ce156300 = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(f) {
        return function(g) {
            return function(w) {
                return f(extend1(g)(w));
            };
        };
    };
};
var $c8f9cdd14046b503$export$a868f0c7fe15a03f = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(f) {
        return function(g) {
            return function(w) {
                return g(extend1(f)(w));
            };
        };
    };
};



var $b3e944c79ac8b935$export$f9380c9a627682d3 = function(dict) {
    return dict.extract;
};



// Generated by purs version 0.15.15



var $20615e99b278adf5$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $20615e99b278adf5$export$eb54baf0b342cb1d = function(dict) {
    return dict.bimap;
};
var $20615e99b278adf5$export$2ad466be2e2b0196 = function(dictBifunctor) {
    var bimap1 = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor);
    return function(f) {
        return bimap1(f)($20615e99b278adf5$var$identity);
    };
};
var $20615e99b278adf5$export$6630987c9d273301 = function(dictBifunctor) {
    return $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor)($20615e99b278adf5$var$identity);
};
var $20615e99b278adf5$export$34a2521cb7920188 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v.value0), g(v.value1));
            };
        };
    }
};
var $20615e99b278adf5$export$9b66d4861c364eff = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v(v2.value0));
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v1(v2.value0));
                throw new Error("Failed pattern match at Data.Bifunctor (line 32, column 1 - line 34, column 36): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};
var $20615e99b278adf5$export$52f77c2cc8ef8f31 = {
    bimap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};








var $490ec114b4138e6d$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$9b66d4861c364eff);
var $490ec114b4138e6d$export$a7f096464cca5f3a = function(x) {
    return x;
};
var $490ec114b4138e6d$export$593e0c14cbf7732e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return "(left " + (show(v.value0) + ")");
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return "(right " + (show1(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Functor.Coproduct (line 63, column 1 - line 65, column 60): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $490ec114b4138e6d$export$79ffe56a765070d2 = function(ga) {
    return new $7d4cccdf062a2261$export$19db0165690c701a(ga);
};
var $490ec114b4138e6d$export$7fc1e26c1ee5b3a4 = {
    Coercible0: function() {
        return undefined;
    }
};
var $490ec114b4138e6d$export$eabcd2c8791e7bf4 = function(fa) {
    return new $7d4cccdf062a2261$export$37c4d04eafdc5515(fa);
};
var $490ec114b4138e6d$export$e192c0fa89a291cb = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return $490ec114b4138e6d$var$bimap(map(f))(map1(f))(v);
                };
            }
        };
    };
};
var $490ec114b4138e6d$export$30aaa5110153edc1 = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq11) {
        var eq11 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq11);
        return {
            eq1: function(dictEq) {
                var eq12 = eq1(dictEq);
                var eq13 = eq11(dictEq);
                return function(v) {
                    return function(v1) {
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return eq12(v.value0)(v1.value0);
                        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return eq13(v.value0)(v1.value0);
                        return false;
                    };
                };
            }
        };
    };
};
var $490ec114b4138e6d$export$4f54a72d7417da7c = function(dictEq1) {
    var eq1Coproduct1 = $490ec114b4138e6d$export$30aaa5110153edc1(dictEq1);
    return function(dictEq11) {
        var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(eq1Coproduct1(dictEq11));
        return function(dictEq) {
            return {
                eq: eq1(dictEq)
            };
        };
    };
};
var $490ec114b4138e6d$export$ec3d1f0587fb15ed = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eq1Coproduct1 = $490ec114b4138e6d$export$30aaa5110153edc1(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare11 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd11);
        var eq1Coproduct2 = eq1Coproduct1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                var compare12 = compare1(dictOrd);
                var compare13 = compare11(dictOrd);
                return function(v) {
                    return function(v1) {
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return compare12(v.value0)(v1.value0);
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return compare13(v.value0)(v1.value0);
                        throw new Error("Failed pattern match at Data.Functor.Coproduct (line 57, column 5 - line 61, column 43): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    };
                };
            },
            Eq10: function() {
                return eq1Coproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$f437f5dfb3faee67 = function(dictOrd1) {
    var ord1Coproduct1 = $490ec114b4138e6d$export$ec3d1f0587fb15ed(dictOrd1);
    var eqCoproduct1 = $490ec114b4138e6d$export$4f54a72d7417da7c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(ord1Coproduct1(dictOrd11));
        var eqCoproduct2 = eqCoproduct1(dictOrd11.Eq10());
        return function(dictOrd) {
            var eqCoproduct3 = eqCoproduct2(dictOrd.Eq0());
            return {
                compare: compare1(dictOrd),
                Eq0: function() {
                    return eqCoproduct3;
                }
            };
        };
    };
};
var $490ec114b4138e6d$export$ab04af7daecb905f = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v(v2.value0);
            if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Functor.Coproduct (line 27, column 1 - line 27, column 78): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $490ec114b4138e6d$export$7ce1af5f45fd6777 = function(dictExtend) {
    var extend = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    var functorCoproduct1 = $490ec114b4138e6d$export$e192c0fa89a291cb(dictExtend.Functor0());
    return function(dictExtend1) {
        var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend1);
        var functorCoproduct2 = functorCoproduct1(dictExtend1.Functor0());
        return {
            extend: function(f) {
                var $106 = $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                    var $108 = extend(function($110) {
                        return f($490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($110)));
                    });
                    return function($109) {
                        return $7d4cccdf062a2261$export$37c4d04eafdc5515.create($108($109));
                    };
                }())(function() {
                    var $111 = extend1(function($113) {
                        return f($490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($113)));
                    });
                    return function($112) {
                        return $7d4cccdf062a2261$export$19db0165690c701a.create($111($112));
                    };
                }());
                return function($107) {
                    return $490ec114b4138e6d$export$a7f096464cca5f3a($106($107));
                };
            },
            Functor0: function() {
                return functorCoproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$2f16914668ceb808 = function(dictComonad) {
    var extract = $b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad);
    var extendCoproduct1 = $490ec114b4138e6d$export$7ce1af5f45fd6777(dictComonad.Extend0());
    return function(dictComonad1) {
        var extendCoproduct2 = extendCoproduct1(dictComonad1.Extend0());
        return {
            extract: $490ec114b4138e6d$export$ab04af7daecb905f(extract)($b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad1)),
            Extend0: function() {
                return extendCoproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$c1a518500c2ed5de = function(natF) {
    return function(natG) {
        return function(v) {
            return $490ec114b4138e6d$var$bimap(natF)(natG)(v);
        };
    };
};




// Generated by purs version 0.15.15




var $92016ca92c497156$export$b25abba66f7be210 = function(x) {
    return x;
};
var $92016ca92c497156$export$20f833961f1940c8 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($06733ae99ed4f534$export$9b814e760fdd264a(dictShow));
    return {
        show: function(v) {
            return "First (" + (show(v) + ")");
        }
    };
};
var $92016ca92c497156$export$53ff158b23f5d382 = {
    append: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v;
            return v1;
        };
    }
};
var $92016ca92c497156$export$4d7d8eedf770f0 = function(dictOrd) {
    return $06733ae99ed4f534$export$e35c29f98d259c46(dictOrd);
};
var $92016ca92c497156$export$f6a5e365037ccf9a = $06733ae99ed4f534$export$c82772423d5de0b;
var $92016ca92c497156$export$130c32806db3fdc8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $92016ca92c497156$export$db2423f7434b7a30 = /* #__PURE__ */ function() {
    return {
        mempty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Semigroup0: function() {
            return $92016ca92c497156$export$53ff158b23f5d382;
        }
    };
}();
var $92016ca92c497156$export$e17b0506de713d2e = $06733ae99ed4f534$export$f78a1c2d38efcc13;
var $92016ca92c497156$export$6f62e1511455cb87 = $06733ae99ed4f534$export$62eda6ff839a0571;
var $92016ca92c497156$export$98d9d13e8b5bfe4d = $06733ae99ed4f534$export$fdd2427f0e60fd66;
var $92016ca92c497156$export$590ee69b33ca98b4 = $06733ae99ed4f534$export$cb6d304dbd10aa95;
var $92016ca92c497156$export$8232f15b0b41395c = function(dictEq) {
    return $06733ae99ed4f534$export$8f45bb76abf9699e(dictEq);
};
var $92016ca92c497156$export$1a969f11cd8a353e = $06733ae99ed4f534$export$b59095d05faa8cf6;
var $92016ca92c497156$export$315f32b6f78e2785 = function(dictBounded) {
    return $06733ae99ed4f534$export$158982e65b249847(dictBounded);
};
var $92016ca92c497156$export$456f8570baa6024f = $06733ae99ed4f534$export$e5fea5661dee377;
var $92016ca92c497156$export$e48e2da4536c2eea = $06733ae99ed4f534$export$22d9917da16590e7;
var $92016ca92c497156$export$178f5831973b2ff8 = $06733ae99ed4f534$export$b203ef4465f15037;
var $92016ca92c497156$export$5cfe42f95bdf312b = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($92016ca92c497156$export$53ff158b23f5d382),
    Functor0: function() {
        return $92016ca92c497156$export$98d9d13e8b5bfe4d;
    }
};
var $92016ca92c497156$export$e3c1997b7c0ee480 = {
    empty: /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($92016ca92c497156$export$db2423f7434b7a30),
    Alt0: function() {
        return $92016ca92c497156$export$5cfe42f95bdf312b;
    }
};
var $92016ca92c497156$export$92398121afed1258 = {
    Applicative0: function() {
        return $92016ca92c497156$export$178f5831973b2ff8;
    },
    Plus1: function() {
        return $92016ca92c497156$export$e3c1997b7c0ee480;
    }
};



// Generated by purs version 0.15.15




var $65ae0a43a0950bac$export$c688766eb4789b8c = function(x) {
    return x;
};
var $65ae0a43a0950bac$export$3e00b8f10f0f4e39 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Conj " + (show(v) + ")");
        }
    };
};
var $65ae0a43a0950bac$export$b71164e0e6b84c70 = function(dictHeytingAlgebra) {
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    return {
        zero: $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra),
        one: $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra),
        add: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        },
        mul: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        }
    };
};
var $65ae0a43a0950bac$export$91e0ef53a9c72523 = function(dictHeytingAlgebra) {
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    return {
        append: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        }
    };
};
var $65ae0a43a0950bac$export$74eade9f2b920d02 = function(dictOrd) {
    return dictOrd;
};
var $65ae0a43a0950bac$export$4f2b093ea8408d89 = function(dictHeytingAlgebra) {
    var semigroupConj1 = $65ae0a43a0950bac$export$91e0ef53a9c72523(dictHeytingAlgebra);
    return {
        mempty: $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupConj1;
        }
    };
};
var $65ae0a43a0950bac$export$48b7cf0194537bca = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $65ae0a43a0950bac$export$2d4ce045d5165d6f = function(dictEq) {
    return dictEq;
};
var $65ae0a43a0950bac$export$43823c09e8843bf5 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($65ae0a43a0950bac$export$2d4ce045d5165d6f(dictEq));
    }
};
var $65ae0a43a0950bac$export$a6a01ce014de97e1 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($65ae0a43a0950bac$export$74eade9f2b920d02(dictOrd));
    },
    Eq10: function() {
        return $65ae0a43a0950bac$export$43823c09e8843bf5;
    }
};
var $65ae0a43a0950bac$export$a4102daba18ffc08 = function(dictBounded) {
    return dictBounded;
};
var $65ae0a43a0950bac$export$a163c218e9f2482b = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $65ae0a43a0950bac$export$48b7cf0194537bca;
    }
};
var $65ae0a43a0950bac$export$b79fdb9ffe29876e = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $65ae0a43a0950bac$export$a163c218e9f2482b;
    }
};
var $65ae0a43a0950bac$export$af9c11f53d676ebc = {
    pure: $65ae0a43a0950bac$export$c688766eb4789b8c,
    Apply0: function() {
        return $65ae0a43a0950bac$export$a163c218e9f2482b;
    }
};
var $65ae0a43a0950bac$export$7c7cf1e6ee225e25 = {
    Applicative0: function() {
        return $65ae0a43a0950bac$export$af9c11f53d676ebc;
    },
    Bind1: function() {
        return $65ae0a43a0950bac$export$b79fdb9ffe29876e;
    }
};


// Generated by purs version 0.15.15




var $1242d110ab1edcd9$export$286e7113895e33ef = function(x) {
    return x;
};
var $1242d110ab1edcd9$export$84ed1543fc941c9a = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Disj " + (show(v) + ")");
        }
    };
};
var $1242d110ab1edcd9$export$5b0a7c2f35d7a492 = function(dictHeytingAlgebra) {
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    return {
        zero: $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra),
        one: $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra),
        add: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        },
        mul: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        }
    };
};
var $1242d110ab1edcd9$export$f23e3b19aa9e04ea = function(dictHeytingAlgebra) {
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    return {
        append: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        }
    };
};
var $1242d110ab1edcd9$export$5f1629868b2a8f7a = function(dictOrd) {
    return dictOrd;
};
var $1242d110ab1edcd9$export$e1c73e5b30670500 = function(dictHeytingAlgebra) {
    var semigroupDisj1 = $1242d110ab1edcd9$export$f23e3b19aa9e04ea(dictHeytingAlgebra);
    return {
        mempty: $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupDisj1;
        }
    };
};
var $1242d110ab1edcd9$export$410cd7ab647069e5 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $1242d110ab1edcd9$export$3f2868cf248cd7c5 = function(dictEq) {
    return dictEq;
};
var $1242d110ab1edcd9$export$8ab894b15d39baff = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($1242d110ab1edcd9$export$3f2868cf248cd7c5(dictEq));
    }
};
var $1242d110ab1edcd9$export$b2df6a05be54d5b7 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($1242d110ab1edcd9$export$5f1629868b2a8f7a(dictOrd));
    },
    Eq10: function() {
        return $1242d110ab1edcd9$export$8ab894b15d39baff;
    }
};
var $1242d110ab1edcd9$export$fcd058ea94ebee31 = function(dictBounded) {
    return dictBounded;
};
var $1242d110ab1edcd9$export$6e64deb0714631e6 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $1242d110ab1edcd9$export$410cd7ab647069e5;
    }
};
var $1242d110ab1edcd9$export$997bc439fd07ce0b = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $1242d110ab1edcd9$export$6e64deb0714631e6;
    }
};
var $1242d110ab1edcd9$export$a5d698d68d7ba6f5 = {
    pure: $1242d110ab1edcd9$export$286e7113895e33ef,
    Apply0: function() {
        return $1242d110ab1edcd9$export$6e64deb0714631e6;
    }
};
var $1242d110ab1edcd9$export$15ab4d3c125d7ac0 = {
    Applicative0: function() {
        return $1242d110ab1edcd9$export$a5d698d68d7ba6f5;
    },
    Bind1: function() {
        return $1242d110ab1edcd9$export$997bc439fd07ce0b;
    }
};


// Generated by purs version 0.15.15





var $8257f7a36ab9f9cd$export$c26a72e8d91adeec = function(x) {
    return x;
};
var $8257f7a36ab9f9cd$export$367774d50e2e283e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Dual " + (show(v) + ")");
        }
    };
};
var $8257f7a36ab9f9cd$export$dc7d4cd4865fc48 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                return append1(v1)(v);
            };
        }
    };
};
var $8257f7a36ab9f9cd$export$baedc2c70a4ae2b1 = function(dictOrd) {
    return dictOrd;
};
var $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb = function(dictMonoid) {
    var semigroupDual1 = $8257f7a36ab9f9cd$export$dc7d4cd4865fc48(dictMonoid.Semigroup0());
    return {
        mempty: $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid),
        Semigroup0: function() {
            return semigroupDual1;
        }
    };
};
var $8257f7a36ab9f9cd$export$916a3957c09e9ed5 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $8257f7a36ab9f9cd$export$2b6bf0b2b79b7623 = function(dictEq) {
    return dictEq;
};
var $8257f7a36ab9f9cd$export$334c9b177d56941 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($8257f7a36ab9f9cd$export$2b6bf0b2b79b7623(dictEq));
    }
};
var $8257f7a36ab9f9cd$export$f00e1ac1e19e7381 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($8257f7a36ab9f9cd$export$baedc2c70a4ae2b1(dictOrd));
    },
    Eq10: function() {
        return $8257f7a36ab9f9cd$export$334c9b177d56941;
    }
};
var $8257f7a36ab9f9cd$export$5a3916bf05e599b0 = function(dictBounded) {
    return dictBounded;
};
var $8257f7a36ab9f9cd$export$9e642462d19ab815 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $8257f7a36ab9f9cd$export$916a3957c09e9ed5;
    }
};
var $8257f7a36ab9f9cd$export$307a1784edb0cbc9 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $8257f7a36ab9f9cd$export$9e642462d19ab815;
    }
};
var $8257f7a36ab9f9cd$export$f853c12137409deb = {
    pure: $8257f7a36ab9f9cd$export$c26a72e8d91adeec,
    Apply0: function() {
        return $8257f7a36ab9f9cd$export$9e642462d19ab815;
    }
};
var $8257f7a36ab9f9cd$export$965738b694a4882b = {
    Applicative0: function() {
        return $8257f7a36ab9f9cd$export$f853c12137409deb;
    },
    Bind1: function() {
        return $8257f7a36ab9f9cd$export$307a1784edb0cbc9;
    }
};


// Generated by purs version 0.15.15



var $57b8542ac3131c5d$export$6aef3ff797629bec = function(x) {
    return x;
};
var $57b8542ac3131c5d$export$e6887fe542fcbae3 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Endo " + (show(v) + ")");
        }
    };
};
var $57b8542ac3131c5d$export$5f7c224ff60452b9 = function(dictSemigroupoid) {
    var compose = $5807467a73465f3c$export$f672e0b6f7222cd7(dictSemigroupoid);
    return {
        append: function(v) {
            return function(v1) {
                return compose(v)(v1);
            };
        }
    };
};
var $57b8542ac3131c5d$export$5f95a5e6b940187f = function(dictOrd) {
    return dictOrd;
};
var $57b8542ac3131c5d$export$947ca1a8eed6111 = function(dictCategory) {
    var semigroupEndo1 = $57b8542ac3131c5d$export$5f7c224ff60452b9(dictCategory.Semigroupoid0());
    return {
        mempty: $5be483788e0e6f04$export$f0954fd7d5368655(dictCategory),
        Semigroup0: function() {
            return semigroupEndo1;
        }
    };
};
var $57b8542ac3131c5d$export$ee65626e0479baec = function(dictEq) {
    return dictEq;
};
var $57b8542ac3131c5d$export$35b120d2f621b3e2 = function(dictBounded) {
    return dictBounded;
};








var $4fe7b6acfba7f29f$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $4fe7b6acfba7f29f$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $4fe7b6acfba7f29f$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $4fe7b6acfba7f29f$var$monoidEndo = /* #__PURE__ */ $57b8542ac3131c5d$export$947ca1a8eed6111($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $4fe7b6acfba7f29f$var$monoidDual = /* #__PURE__ */ $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb($4fe7b6acfba7f29f$var$monoidEndo);
var $4fe7b6acfba7f29f$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf = function(dict) {
    return dict.foldr;
};
var $4fe7b6acfba7f29f$export$f14ab6cb4b8e359c = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(idx) {
        var go = function(a) {
            return function(cursor) {
                if (cursor.elem instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cursor;
                var $292 = cursor.pos === idx;
                if ($292) return {
                    elem: new $06733ae99ed4f534$export$8a67b48435b5d073(a),
                    pos: cursor.pos
                };
                return {
                    pos: cursor.pos + 1 | 0,
                    elem: cursor.elem
                };
            };
        };
        var $451 = foldr2(go)({
            elem: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            pos: 0
        });
        return function($452) {
            return function(v) {
                return v.elem;
            }($451($452));
        };
    };
};
var $4fe7b6acfba7f29f$export$7b1b591b262c240 = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable)(function(v) {
        return function(v1) {
            return false;
        };
    })(true);
};
var $4fe7b6acfba7f29f$export$a9a18ae5ba42aeab = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictPlus) {
        return foldr2($75e93a4111e80214$export$228be17d80722ab(dictPlus.Alt0()))($7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus));
    };
};
var $4fe7b6acfba7f29f$export$79f3cac53daaaae6 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictPlus) {
        var alt = $75e93a4111e80214$export$228be17d80722ab(dictPlus.Alt0());
        var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
        return function(f) {
            return foldr2(function($453) {
                return alt(f($453));
            })(empty);
        };
    };
};
var $4fe7b6acfba7f29f$export$33f63ccdb08d8723 = function(dictApplicative) {
    var applySecond = $7576d3a958d66ab0$export$3d5d566a030a20fc(dictApplicative.Apply0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(dictFoldable) {
        var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
        return function(f) {
            return foldr2(function($454) {
                return applySecond(f($454));
            })(pure($05149ea687d6b460$export$523c0b569236b342));
        };
    };
};
var $4fe7b6acfba7f29f$export$9747ee7caa0b40b1 = function(dictApplicative) {
    var traverse_1 = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative);
    return function(dictFoldable) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(traverse_1(dictFoldable));
    };
};
var $4fe7b6acfba7f29f$export$4426b9bff8b7b6fb = function(dictApplicative) {
    var traverse_1 = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative);
    return function(dictFoldable) {
        return traverse_1(dictFoldable)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$50ae948ca12cdcbc = function(dict) {
    return dict.foldl;
};
var $4fe7b6acfba7f29f$export$fe35754984712af1 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(idx) {
        var go = function(cursor) {
            return function(a) {
                if (cursor.elem instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cursor;
                var $296 = cursor.pos === idx;
                if ($296) return {
                    elem: new $06733ae99ed4f534$export$8a67b48435b5d073(a),
                    pos: cursor.pos
                };
                return {
                    pos: cursor.pos + 1 | 0,
                    elem: cursor.elem
                };
            };
        };
        var $455 = foldl2(go)({
            elem: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            pos: 0
        });
        return function($456) {
            return function(v) {
                return v.elem;
            }($455($456));
        };
    };
};
var $4fe7b6acfba7f29f$export$739ec22334c44788 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(sep) {
            return function(xs) {
                var go = function(v) {
                    return function(v1) {
                        if (v.init) return {
                            init: false,
                            acc: v1
                        };
                        return {
                            init: false,
                            acc: append(v.acc)(append(sep)(v1))
                        };
                    };
                };
                return foldl2(go)({
                    init: true,
                    acc: mempty
                })(xs).acc;
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$f24224f1c91d8156 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
        var one = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
        return foldl2(function(c) {
            return function(v) {
                return add1(one)(c);
            };
        })($c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$c42fa06aba2a552c = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(cmp) {
        var max$prime = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(function() {
                    var $303 = $4fe7b6acfba7f29f$var$eq1(cmp(v.value0)(v1))($5026be88823ef1f4$export$b023c82b48e70453.value);
                    if ($303) return v.value0;
                    return v1;
                }());
                throw new Error("Failed pattern match at Data.Foldable (line 441, column 3 - line 441, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return foldl2(max$prime)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$b25e0be55f42c9a = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$c42fa06aba2a552c(dictFoldable)(compare);
    };
};
var $4fe7b6acfba7f29f$export$b65392d958998255 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(cmp) {
        var min$prime = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(function() {
                    var $307 = $4fe7b6acfba7f29f$var$eq1(cmp(v.value0)(v1))($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
                    if ($307) return v.value0;
                    return v1;
                }());
                throw new Error("Failed pattern match at Data.Foldable (line 454, column 3 - line 454, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return foldl2(min$prime)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$916782c1f0ddb132 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$b65392d958998255(dictFoldable)(compare);
    };
};
var $4fe7b6acfba7f29f$export$dbd0f18357df1ddd = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        return foldl2($c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring))($c0e822be92afc4df$export$80bf7733f1207381(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$8a63f25cc62965f1 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        return foldl2($c0e822be92afc4df$export$e16d8520af44a096(dictSemiring))($c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v.value1)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v.value1);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v.value1);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$9519b6731ae6781c = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$ff97dbee91e727b6 = {
    foldr: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldl: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return mempty;
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v(v1.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    }
};
var $4fe7b6acfba7f29f$var$foldr1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$export$3c076fb5bbc5428f = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$6a194eaac00c1ff4 = {
    foldr: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldl: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return mempty;
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v(v1.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$fbf8f11f9a917de3 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$6857d056e9f0762d = {
    foldr: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldl: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                return mempty;
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$b0c90191a04a5815 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$a3b6f6613d3d5767 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$edac6f86a9ee0bec = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldr2(function(x) {
                return function(acc) {
                    return append(f(x))(acc);
                };
            })(mempty);
        };
    };
};
var $4fe7b6acfba7f29f$export$e97014618a7eb593 = {
    foldr: $44c597fdc38e7b03$export$6332150c6d01d807,
    foldl: $44c597fdc38e7b03$export$6b86e13802001a00,
    foldMap: function(dictMonoid) {
        return $4fe7b6acfba7f29f$export$edac6f86a9ee0bec($4fe7b6acfba7f29f$export$e97014618a7eb593)(dictMonoid);
    }
};
var $4fe7b6acfba7f29f$export$1131b47d09454899 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldl2(function(acc) {
                return function(x) {
                    return append(acc)(f(x));
                };
            })(mempty);
        };
    };
};
var $4fe7b6acfba7f29f$export$b66cdc0497d8a99a = function(dict) {
    return dict.foldMap;
};
var $4fe7b6acfba7f29f$var$foldMap1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$export$1e1b0f55a49f1dc6 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return {
        foldr: function(f) {
            return function(i) {
                return function(v) {
                    return foldr2(f)(i)(v);
                };
            };
        },
        foldl: function(f) {
            return function(i) {
                return function(v) {
                    return foldl2(f)(i)(v);
                };
            };
        },
        foldMap: function(dictMonoid) {
            var foldMap3 = foldMap2(dictMonoid);
            return function(f) {
                return function(v) {
                    return foldMap3(f)(v);
                };
            };
        }
    };
};
var $4fe7b6acfba7f29f$export$5677464b2ea4179d = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(i) {
                    return function(v) {
                        return foldr2($f57f4b701aa7b66e$export$8a83211c878a3f1f(foldr3(f)))(i)(v);
                    };
                };
            },
            foldl: function(f) {
                return function(i) {
                    return function(v) {
                        return foldl2(foldl3(f))(i)(v);
                    };
                };
            },
            foldMap: function(dictMonoid) {
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return function(v) {
                        return foldMap4(foldMap5(f))(v);
                    };
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$5c9c2b827ab84341 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldr2(f)(z))(foldr3(f)(z));
                };
            },
            foldl: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldl2(f)(z))(foldl3(f)(z));
                };
            },
            foldMap: function(dictMonoid) {
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldMap4(f))(foldMap5(f));
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldr1(f)(z)(v);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldl1(f)(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap2 = $4fe7b6acfba7f29f$var$foldMap1(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap2(f)(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$d127e049f7f9d81c = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldr1(f)(z)(v);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldl1(f)(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap2 = $4fe7b6acfba7f29f$var$foldMap1(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap2(f)(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$a013322ac1f6d3aa = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(z) {
                    return function(v) {
                        return foldr2(f)(foldr3(f)(z)(v.value1))(v.value0);
                    };
                };
            },
            foldl: function(f) {
                return function(z) {
                    return function(v) {
                        return foldl3(f)(foldl2(f)(z)(v.value0))(v.value1);
                    };
                };
            },
            foldMap: function(dictMonoid) {
                var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return function(v) {
                        return append(foldMap4(f)(v.value0))(foldMap5(f)(v.value1));
                    };
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$e623e8bf74059b22 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidDual);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $4fe7b6acfba7f29f$var$unwrap($4fe7b6acfba7f29f$var$unwrap(foldMap2(function() {
                    var $457 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(c);
                    return function($458) {
                        return $8257f7a36ab9f9cd$export$c26a72e8d91adeec($57b8542ac3131c5d$export$6aef3ff797629bec($457($458)));
                    };
                }())(xs)))(u);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$9b986141719153e = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidEndo);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $4fe7b6acfba7f29f$var$unwrap(foldMap2(function($459) {
                    return $57b8542ac3131c5d$export$6aef3ff797629bec(c($459));
                })(xs))(u);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$dfc7155ac0343b8 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($92016ca92c497156$export$db2423f7434b7a30);
    return function(dictEq) {
        var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function(a) {
            var $460 = foldMap2(function(v) {
                var $444 = eq2(a)(v.value0);
                if ($444) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value1);
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            });
            return function($461) {
                return $4fe7b6acfba7f29f$var$unwrap($460($461));
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$7606e2cbf4afaea2 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidEndo);
    return function(dictSemigroup) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return function(d) {
            return function(t) {
                return function(f) {
                    var joined = function(a) {
                        return function(m) {
                            return append(d)(append(t(a))(m));
                        };
                    };
                    return $4fe7b6acfba7f29f$var$unwrap(foldMap2(joined)(f))(d);
                };
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$5a27709e8737ce25 = function(dictFoldable) {
    var surroundMap1 = $4fe7b6acfba7f29f$export$7606e2cbf4afaea2(dictFoldable);
    return function(dictSemigroup) {
        var surroundMap2 = surroundMap1(dictSemigroup);
        return function(d) {
            return surroundMap2(d)($4fe7b6acfba7f29f$var$identity);
        };
    };
};
var $4fe7b6acfba7f29f$export$7a067f9280ad8af0 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(f) {
            return function(b0) {
                return foldl2(function(b) {
                    return function(a) {
                        return bind(b)($f57f4b701aa7b66e$export$8a83211c878a3f1f(f)(a));
                    };
                })(pure(b0));
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$93e2b83da34ff82a = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictMonoid) {
        return foldMap2(dictMonoid)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$23e5dcedfce4509c = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return p(v1);
                return v;
            };
        };
        return foldl2(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$71aa6c912b956294 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && p(v1)) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1);
                return v;
            };
        };
        return foldl2(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$4154a199d7d90455 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $4fe7b6acfba7f29f$var$alaF($1242d110ab1edcd9$export$286e7113895e33ef)(foldMap2($1242d110ab1edcd9$export$e1c73e5b30670500(dictHeytingAlgebra)));
    };
};
var $4fe7b6acfba7f29f$export$5bf96401662340b7 = function(dictFoldable) {
    var any1 = $4fe7b6acfba7f29f$export$4154a199d7d90455(dictFoldable)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
    return function(dictEq) {
        var $462 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function($463) {
            return any1($462($463));
        };
    };
};
var $4fe7b6acfba7f29f$export$63faa62a0284a4a6 = function(dictFoldable) {
    var elem1 = $4fe7b6acfba7f29f$export$5bf96401662340b7(dictFoldable);
    return function(dictEq) {
        var elem2 = elem1(dictEq);
        return function(x) {
            var $464 = elem2(x);
            return function($465) {
                return !$464($465);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$252bb8b3bbdf6749 = function(dictFoldable) {
    var any1 = $4fe7b6acfba7f29f$export$4154a199d7d90455(dictFoldable);
    return function(dictHeytingAlgebra) {
        return any1(dictHeytingAlgebra)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$84bf76cd7afc7469 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $4fe7b6acfba7f29f$var$alaF($65ae0a43a0950bac$export$c688766eb4789b8c)(foldMap2($65ae0a43a0950bac$export$4f2b093ea8408d89(dictHeytingAlgebra)));
    };
};
var $4fe7b6acfba7f29f$export$21c0ac7fe1cef1b8 = function(dictFoldable) {
    var all1 = $4fe7b6acfba7f29f$export$84bf76cd7afc7469(dictFoldable);
    return function(dictHeytingAlgebra) {
        return all1(dictHeytingAlgebra)($4fe7b6acfba7f29f$var$identity);
    };
};


// Generated by purs version 0.15.15








// Generated by purs version 0.15.15
const $63ebef0b12494a84$export$e1e714991b6c2aba = function(f) {
    return function(xs) {
        var l = xs.length;
        var result = Array(l);
        for(var i = 0; i < l; i++)result[i] = f(i)(xs[i]);
        return result;
    };
};



// Generated by purs version 0.15.15






var $10ae0394c8c3139a$export$8ad5d15375e29446 = function(x) {
    return x;
};
var $10ae0394c8c3139a$export$698fc26f8c8bb631 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Const " + (show(v) + ")");
        }
    };
};
var $10ae0394c8c3139a$export$8e644eba3b05046b = function(dictSemiring) {
    return dictSemiring;
};
var $10ae0394c8c3139a$export$8f2711bf2f3160c6 = {
    compose: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $10ae0394c8c3139a$export$6eaf1848e07ae857 = function(dictSemigroup) {
    return dictSemigroup;
};
var $10ae0394c8c3139a$export$e21edfc60fb6207c = function(dictRing) {
    return dictRing;
};
var $10ae0394c8c3139a$export$2dc639aba34e0026 = function(dictOrd) {
    return dictOrd;
};
var $10ae0394c8c3139a$export$ea93befd55cd9816 = {
    Coercible0: function() {
        return undefined;
    }
};
var $10ae0394c8c3139a$export$d484d0b1dc07b605 = function(dictMonoid) {
    return dictMonoid;
};
var $10ae0394c8c3139a$export$208a79db5ecd5bbf = function(dictHeytingAlgebra) {
    return dictHeytingAlgebra;
};
var $10ae0394c8c3139a$export$c03820c48bf31fc8 = {
    map: function(f) {
        return function(m) {
            return m;
        };
    }
};
var $10ae0394c8c3139a$export$30c2a66ea46ad17b = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($10ae0394c8c3139a$export$c03820c48bf31fc8)
};
var $10ae0394c8c3139a$export$aa81c0060845253 = function(dictEuclideanRing) {
    return dictEuclideanRing;
};
var $10ae0394c8c3139a$export$1688a037b5b692da = function(dictEq) {
    return dictEq;
};
var $10ae0394c8c3139a$export$bdb9acf61703c804 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32($10ae0394c8c3139a$export$1688a037b5b692da(dictEq));
    return {
        eq1: function(dictEq1) {
            return eq;
        }
    };
};
var $10ae0394c8c3139a$export$87702177ef8adff4 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($10ae0394c8c3139a$export$2dc639aba34e0026(dictOrd));
    var eq1Const1 = $10ae0394c8c3139a$export$bdb9acf61703c804(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return compare;
        },
        Eq10: function() {
            return eq1Const1;
        }
    };
};
var $10ae0394c8c3139a$export$c708f2c7ab030e40 = function(dictCommutativeRing) {
    return dictCommutativeRing;
};
var $10ae0394c8c3139a$export$9ca7ce64fd99d2e3 = function(dictBounded) {
    return dictBounded;
};
var $10ae0394c8c3139a$export$b7df7e3b07273a9c = function(dictBooleanAlgebra) {
    return dictBooleanAlgebra;
};
var $10ae0394c8c3139a$export$17ba89632b46bf87 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        apply: function(v) {
            return function(v1) {
                return append1(v)(v1);
            };
        },
        Functor0: function() {
            return $10ae0394c8c3139a$export$c03820c48bf31fc8;
        }
    };
};
var $10ae0394c8c3139a$export$38647a91a5af2717 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var applyConst1 = $10ae0394c8c3139a$export$17ba89632b46bf87(dictMonoid.Semigroup0());
    return {
        pure: function(v) {
            return mempty;
        },
        Apply0: function() {
            return applyConst1;
        }
    };
};





// Generated by purs version 0.15.15








var $60e028b2ef4ceb5f$export$86fbec116b87613f = function(x) {
    return x;
};
var $60e028b2ef4ceb5f$export$993a94e8f319ddca = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(App " + (show(v) + ")");
        }
    };
};
var $60e028b2ef4ceb5f$export$25412483a1d87cf9 = function(dictApply) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApply);
    return function(dictSemigroup) {
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return lift2(append1)(v)(v1);
                };
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$ca15fc0ee645d5ca = function(dictPlus) {
    return dictPlus;
};
var $60e028b2ef4ceb5f$export$d6896dcb1200915c = {
    Coercible0: function() {
        return undefined;
    }
};
var $60e028b2ef4ceb5f$export$4d0b678caa24727 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var semigroupApp1 = $60e028b2ef4ceb5f$export$25412483a1d87cf9(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupApp2 = semigroupApp1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupApp2;
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$5dee9c05ece04940 = function(dictMonadPlus) {
    return dictMonadPlus;
};
var $60e028b2ef4ceb5f$export$6a01a2292278ad36 = function(dictMonad) {
    return dictMonad;
};
var $60e028b2ef4ceb5f$export$aef3f1b3df1ccc91 = function(dictLazy) {
    return dictLazy;
};
var $60e028b2ef4ceb5f$export$74e988bb94b714ec = $ac8b3532514ac019$export$401372c57776dc;
var $60e028b2ef4ceb5f$export$d26bca0552b37bb6 = $ac8b3532514ac019$export$401372c57776dc;
var $60e028b2ef4ceb5f$export$e5247fd078351cb8 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $60e028b2ef4ceb5f$export$79ab389dc7ad1e04 = function(dictFunctor) {
    return dictFunctor;
};
var $60e028b2ef4ceb5f$export$4392ba23127b7f7e = function(dictExtend) {
    return dictExtend;
};
var $60e028b2ef4ceb5f$export$ca57ebaecdc7d318 = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq11 = eq1(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq11(x)(y);
                };
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$f5438903fac97fd7 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eqApp1 = $60e028b2ef4ceb5f$export$ca57ebaecdc7d318(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare11 = compare1(dictOrd);
        var eqApp2 = eqApp1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    return compare11(x)(y);
                };
            },
            Eq0: function() {
                return eqApp2;
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$878272f7ccf91d14 = function(dictEq1) {
    var eqApp1 = $60e028b2ef4ceb5f$export$ca57ebaecdc7d318(dictEq1);
    return {
        eq1: function(dictEq) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqApp1(dictEq));
        }
    };
};
var $60e028b2ef4ceb5f$export$594a740e645fec3d = function(dictOrd1) {
    var ordApp1 = $60e028b2ef4ceb5f$export$f5438903fac97fd7(dictOrd1);
    var eq1App1 = $60e028b2ef4ceb5f$export$878272f7ccf91d14(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordApp1(dictOrd));
        },
        Eq10: function() {
            return eq1App1;
        }
    };
};
var $60e028b2ef4ceb5f$export$7470af1a1433fe40 = function(dictComonad) {
    return dictComonad;
};
var $60e028b2ef4ceb5f$export$a9edb76092ee7d6f = function(dictBind) {
    return dictBind;
};
var $60e028b2ef4ceb5f$export$e73125860a07eff3 = function(dictApply) {
    return dictApply;
};
var $60e028b2ef4ceb5f$export$3550db4068efefdd = function(dictApplicative) {
    return dictApplicative;
};
var $60e028b2ef4ceb5f$export$afc0b729746e2971 = function(dictAlternative) {
    return dictAlternative;
};
var $60e028b2ef4ceb5f$export$69ee13496a90cde5 = function(dictAlt) {
    return dictAlt;
};


// Generated by purs version 0.15.15









var $6051f44ece6b7171$export$5a3a146e358e1bcf = function(x) {
    return x;
};
var $6051f44ece6b7171$export$48988665210796c9 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Compose " + (show(v) + ")");
        }
    };
};
var $6051f44ece6b7171$export$db82d32400573da6 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6051f44ece6b7171$export$4e14cb014c72d19c = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return map(map1(f))(v);
                };
            }
        };
    };
};
var $6051f44ece6b7171$export$861bef6ec455b19c = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq11) {
        var eqApp = $60e028b2ef4ceb5f$export$ca57ebaecdc7d318(dictEq11);
        return function(dictEq) {
            var eq11 = eq1(eqApp(dictEq));
            return {
                eq: function(v) {
                    return function(v1) {
                        return eq11($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v))($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v1));
                    };
                }
            };
        };
    };
};
var $6051f44ece6b7171$export$71b54a761b111692 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eqCompose1 = $6051f44ece6b7171$export$861bef6ec455b19c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var ordApp = $60e028b2ef4ceb5f$export$f5438903fac97fd7(dictOrd11);
        var eqCompose2 = eqCompose1(dictOrd11.Eq10());
        return function(dictOrd) {
            var compare11 = compare1(ordApp(dictOrd));
            var eqCompose3 = eqCompose2(dictOrd.Eq0());
            return {
                compare: function(v) {
                    return function(v1) {
                        return compare11($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v))($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v1));
                    };
                },
                Eq0: function() {
                    return eqCompose3;
                }
            };
        };
    };
};
var $6051f44ece6b7171$export$cbe2b7f63279884c = function(dictEq1) {
    var eqCompose1 = $6051f44ece6b7171$export$861bef6ec455b19c(dictEq1);
    return function(dictEq11) {
        var eqCompose2 = eqCompose1(dictEq11);
        return {
            eq1: function(dictEq) {
                return $37b880af5f4991bd$export$9663ddc1cf085b32(eqCompose2(dictEq));
            }
        };
    };
};
var $6051f44ece6b7171$export$d435219eb92d4b50 = function(dictOrd1) {
    var ordCompose1 = $6051f44ece6b7171$export$71b54a761b111692(dictOrd1);
    var eq1Compose1 = $6051f44ece6b7171$export$cbe2b7f63279884c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var ordCompose2 = ordCompose1(dictOrd11);
        var eq1Compose2 = eq1Compose1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                return $97937c29f879e68e$export$398604a469f7de9a(ordCompose2(dictOrd));
            },
            Eq10: function() {
                return eq1Compose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$6ac747c53920df53 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(natF) {
        return function(natG) {
            return function(v) {
                return natF(map(natG)(v));
            };
        };
    };
};
var $6051f44ece6b7171$export$6b631277dc31d20d = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var Functor0 = dictApply.Functor0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var functorCompose1 = $6051f44ece6b7171$export$4e14cb014c72d19c(Functor0);
    return function(dictApply1) {
        var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply1);
        var functorCompose2 = functorCompose1(dictApply1.Functor0());
        return {
            apply: function(v) {
                return function(v1) {
                    return apply(map(apply1)(v))(v1);
                };
            },
            Functor0: function() {
                return functorCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$ce6787b8eb4a9f48 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var applyCompose1 = $6051f44ece6b7171$export$6b631277dc31d20d(dictApplicative.Apply0());
    return function(dictApplicative1) {
        var applyCompose2 = applyCompose1(dictApplicative1.Apply0());
        return {
            pure: function() {
                var $112 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative1);
                return function($113) {
                    return $6051f44ece6b7171$export$5a3a146e358e1bcf(pure($112($113)));
                };
            }(),
            Apply0: function() {
                return applyCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$b9fb31044795461 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorCompose1 = $6051f44ece6b7171$export$4e14cb014c72d19c(dictAlt.Functor0());
    return function(dictFunctor) {
        var functorCompose2 = functorCompose1(dictFunctor);
        return {
            alt: function(v) {
                return function(v1) {
                    return alt(v)(v1);
                };
            },
            Functor0: function() {
                return functorCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$2f025d423e425357 = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    var altCompose1 = $6051f44ece6b7171$export$b9fb31044795461(dictPlus.Alt0());
    return function(dictFunctor) {
        var altCompose2 = altCompose1(dictFunctor);
        return {
            empty: empty,
            Alt0: function() {
                return altCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$3bf64fe887e680d3 = function(dictAlternative) {
    var applicativeCompose1 = $6051f44ece6b7171$export$ce6787b8eb4a9f48(dictAlternative.Applicative0());
    var plusCompose1 = $6051f44ece6b7171$export$2f025d423e425357(dictAlternative.Plus1());
    return function(dictApplicative) {
        var applicativeCompose2 = applicativeCompose1(dictApplicative);
        var plusCompose2 = plusCompose1(dictApplicative.Apply0().Functor0());
        return {
            Applicative0: function() {
                return applicativeCompose2;
            },
            Plus1: function() {
                return plusCompose2;
            }
        };
    };
};



// Generated by purs version 0.15.15











var $a2051f9edf3d1db6$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$34a2521cb7920188);
var $a2051f9edf3d1db6$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $a2051f9edf3d1db6$export$264ad599d7cef668 = function(x) {
    return x;
};
var $a2051f9edf3d1db6$export$821c121fea76e4f5 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(product " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $a2051f9edf3d1db6$export$dbd0f18357df1ddd = function(fa) {
    return function(ga) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(fa, ga);
    };
};
var $a2051f9edf3d1db6$export$7ea85e95f1a9febc = {
    Coercible0: function() {
        return undefined;
    }
};
var $a2051f9edf3d1db6$export$e5b52224642d1f48 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return $a2051f9edf3d1db6$var$bimap(map(f))(map1(f))(v);
                };
            }
        };
    };
};
var $a2051f9edf3d1db6$export$df541bd41566d1a7 = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq11) {
        var eq11 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq11);
        return {
            eq1: function(dictEq) {
                var eq12 = eq1(dictEq);
                var eq13 = eq11(dictEq);
                return function(v) {
                    return function(v1) {
                        return eq12(v.value0)(v1.value0) && eq13(v.value1)(v1.value1);
                    };
                };
            }
        };
    };
};
var $a2051f9edf3d1db6$export$e82658b20fc49a26 = function(dictEq1) {
    var eq1Product1 = $a2051f9edf3d1db6$export$df541bd41566d1a7(dictEq1);
    return function(dictEq11) {
        var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(eq1Product1(dictEq11));
        return function(dictEq) {
            return {
                eq: eq1(dictEq)
            };
        };
    };
};
var $a2051f9edf3d1db6$export$b9dd7b4b85c7c1b7 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eq1Product1 = $a2051f9edf3d1db6$export$df541bd41566d1a7(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare11 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd11);
        var eq1Product2 = eq1Product1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                var compare12 = compare1(dictOrd);
                var compare13 = compare11(dictOrd);
                return function(v) {
                    return function(v1) {
                        var v2 = compare12(v.value0)(v1.value0);
                        if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return compare13(v.value1)(v1.value1);
                        return v2;
                    };
                };
            },
            Eq10: function() {
                return eq1Product2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$96856f3fc4c91454 = function(dictOrd1) {
    var ord1Product1 = $a2051f9edf3d1db6$export$b9dd7b4b85c7c1b7(dictOrd1);
    var eqProduct1 = $a2051f9edf3d1db6$export$e82658b20fc49a26(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(ord1Product1(dictOrd11));
        var eqProduct2 = eqProduct1(dictOrd11.Eq10());
        return function(dictOrd) {
            var eqProduct3 = eqProduct2(dictOrd.Eq0());
            return {
                compare: compare1(dictOrd),
                Eq0: function() {
                    return eqProduct3;
                }
            };
        };
    };
};
var $a2051f9edf3d1db6$export$a3738445608c58d6 = function(natF) {
    return function(natG) {
        return function(v) {
            return $a2051f9edf3d1db6$var$bimap(natF)(natG)(v);
        };
    };
};
var $a2051f9edf3d1db6$export$893d0f454e6dfaee = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var functorProduct1 = $a2051f9edf3d1db6$export$e5b52224642d1f48(dictApply.Functor0());
    return function(dictApply1) {
        var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply1);
        var functorProduct2 = functorProduct1(dictApply1.Functor0());
        return {
            apply: function(v) {
                return function(v1) {
                    return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(apply(v.value0)(v1.value0))(apply1(v.value1)(v1.value1));
                };
            },
            Functor0: function() {
                return functorProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$5990c3ca6a566877 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var applyProduct1 = $a2051f9edf3d1db6$export$893d0f454e6dfaee(dictBind.Apply0());
    return function(dictBind1) {
        var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind1);
        var applyProduct2 = applyProduct1(dictBind1.Apply0());
        return {
            bind: function(v) {
                return function(f) {
                    return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(bind(v.value0)(function($128) {
                        return $71f2e2e9476163f8$export$9e770fa6ce19a9d6($a2051f9edf3d1db6$var$unwrap(f($128)));
                    }))(bind1(v.value1)(function($129) {
                        return $71f2e2e9476163f8$export$6f71268a1666ab58($a2051f9edf3d1db6$var$unwrap(f($129)));
                    }));
                };
            },
            Apply0: function() {
                return applyProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$2034ae3acf01a9af = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var applyProduct1 = $a2051f9edf3d1db6$export$893d0f454e6dfaee(dictApplicative.Apply0());
    return function(dictApplicative1) {
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative1);
        var applyProduct2 = applyProduct1(dictApplicative1.Apply0());
        return {
            pure: function(a) {
                return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(pure(a))(pure1(a));
            },
            Apply0: function() {
                return applyProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$2dfe129c60aea5cb = function(dictMonad) {
    var applicativeProduct1 = $a2051f9edf3d1db6$export$2034ae3acf01a9af(dictMonad.Applicative0());
    var bindProduct1 = $a2051f9edf3d1db6$export$5990c3ca6a566877(dictMonad.Bind1());
    return function(dictMonad1) {
        var applicativeProduct2 = applicativeProduct1(dictMonad1.Applicative0());
        var bindProduct2 = bindProduct1(dictMonad1.Bind1());
        return {
            Applicative0: function() {
                return applicativeProduct2;
            },
            Bind1: function() {
                return bindProduct2;
            }
        };
    };
};





// Generated by purs version 0.15.15




var $1b4bd570fcdcddf2$export$bed9238d8933c9a8 = function(x) {
    return x;
};
var $1b4bd570fcdcddf2$export$1e0d830d3054d46d = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($06733ae99ed4f534$export$9b814e760fdd264a(dictShow));
    return {
        show: function(v) {
            return "(Last " + (show(v) + ")");
        }
    };
};
var $1b4bd570fcdcddf2$export$6d3c4648150c5bae = {
    append: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1;
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
            throw new Error("Failed pattern match at Data.Maybe.Last (line 54, column 1 - line 56, column 36): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $1b4bd570fcdcddf2$export$4ded69d4b0c99b7b = function(dictOrd) {
    return $06733ae99ed4f534$export$e35c29f98d259c46(dictOrd);
};
var $1b4bd570fcdcddf2$export$64bd44ceff2f4638 = $06733ae99ed4f534$export$c82772423d5de0b;
var $1b4bd570fcdcddf2$export$ccaccac244187f64 = {
    Coercible0: function() {
        return undefined;
    }
};
var $1b4bd570fcdcddf2$export$862bb074dbe2690f = /* #__PURE__ */ function() {
    return {
        mempty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Semigroup0: function() {
            return $1b4bd570fcdcddf2$export$6d3c4648150c5bae;
        }
    };
}();
var $1b4bd570fcdcddf2$export$25d122cd3cbaf721 = $06733ae99ed4f534$export$f78a1c2d38efcc13;
var $1b4bd570fcdcddf2$export$21558e167578c47d = $06733ae99ed4f534$export$62eda6ff839a0571;
var $1b4bd570fcdcddf2$export$74aba74241121413 = $06733ae99ed4f534$export$fdd2427f0e60fd66;
var $1b4bd570fcdcddf2$export$7f096d1e61d1725f = $06733ae99ed4f534$export$cb6d304dbd10aa95;
var $1b4bd570fcdcddf2$export$4dd70ef4fbe4d1f3 = function(dictEq) {
    return $06733ae99ed4f534$export$8f45bb76abf9699e(dictEq);
};
var $1b4bd570fcdcddf2$export$634a54207b73ac14 = $06733ae99ed4f534$export$b59095d05faa8cf6;
var $1b4bd570fcdcddf2$export$835f68c2f339b021 = function(dictBounded) {
    return $06733ae99ed4f534$export$158982e65b249847(dictBounded);
};
var $1b4bd570fcdcddf2$export$f2b93d1f1ac78d51 = $06733ae99ed4f534$export$e5fea5661dee377;
var $1b4bd570fcdcddf2$export$dcd798c84777f95 = $06733ae99ed4f534$export$22d9917da16590e7;
var $1b4bd570fcdcddf2$export$5b4de68c5dd33934 = $06733ae99ed4f534$export$b203ef4465f15037;
var $1b4bd570fcdcddf2$export$a0374697fe7c8648 = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($1b4bd570fcdcddf2$export$6d3c4648150c5bae),
    Functor0: function() {
        return $1b4bd570fcdcddf2$export$74aba74241121413;
    }
};
var $1b4bd570fcdcddf2$export$1bb9770eb80691dd = {
    empty: /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($1b4bd570fcdcddf2$export$862bb074dbe2690f),
    Alt0: function() {
        return $1b4bd570fcdcddf2$export$a0374697fe7c8648;
    }
};
var $1b4bd570fcdcddf2$export$bc87013f8f3da20e = {
    Applicative0: function() {
        return $1b4bd570fcdcddf2$export$5b4de68c5dd33934;
    },
    Plus1: function() {
        return $1b4bd570fcdcddf2$export$1bb9770eb80691dd;
    }
};


// Generated by purs version 0.15.15




var $e48f2e41a907ae60$export$14f8ce08180a98e1 = function(x) {
    return x;
};
var $e48f2e41a907ae60$export$d0709814982cbf95 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Additive " + (show(v) + ")");
        }
    };
};
var $e48f2e41a907ae60$export$8adb2de2291fe34 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    return {
        append: function(v) {
            return function(v1) {
                return add(v)(v1);
            };
        }
    };
};
var $e48f2e41a907ae60$export$45e15fb7ca2189d8 = function(dictOrd) {
    return dictOrd;
};
var $e48f2e41a907ae60$export$c38b62d29991685f = function(dictSemiring) {
    var semigroupAdditive1 = $e48f2e41a907ae60$export$8adb2de2291fe34(dictSemiring);
    return {
        mempty: $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring),
        Semigroup0: function() {
            return semigroupAdditive1;
        }
    };
};
var $e48f2e41a907ae60$export$ba106ed6ee21ba26 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $e48f2e41a907ae60$export$7e0cae55dbdaa6a6 = function(dictEq) {
    return dictEq;
};
var $e48f2e41a907ae60$export$3bc4d3e676a5f3ba = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($e48f2e41a907ae60$export$7e0cae55dbdaa6a6(dictEq));
    }
};
var $e48f2e41a907ae60$export$bf0109c88461ccc9 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($e48f2e41a907ae60$export$45e15fb7ca2189d8(dictOrd));
    },
    Eq10: function() {
        return $e48f2e41a907ae60$export$3bc4d3e676a5f3ba;
    }
};
var $e48f2e41a907ae60$export$ac1ed4a2f2107898 = function(dictBounded) {
    return dictBounded;
};
var $e48f2e41a907ae60$export$9ed13d4e91f74d66 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $e48f2e41a907ae60$export$ba106ed6ee21ba26;
    }
};
var $e48f2e41a907ae60$export$3c0293aa90d839fe = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $e48f2e41a907ae60$export$9ed13d4e91f74d66;
    }
};
var $e48f2e41a907ae60$export$3f78fbeb96209a2 = {
    pure: $e48f2e41a907ae60$export$14f8ce08180a98e1,
    Apply0: function() {
        return $e48f2e41a907ae60$export$9ed13d4e91f74d66;
    }
};
var $e48f2e41a907ae60$export$50439d128d692efb = {
    Applicative0: function() {
        return $e48f2e41a907ae60$export$3f78fbeb96209a2;
    },
    Bind1: function() {
        return $e48f2e41a907ae60$export$3c0293aa90d839fe;
    }
};





// Generated by purs version 0.15.15




var $665413393090e9d0$export$d0198c9c86fc2be1 = function(x) {
    return x;
};
var $665413393090e9d0$export$27987c20bfe6da1c = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Multiplicative " + (show(v) + ")");
        }
    };
};
var $665413393090e9d0$export$879165283e0876da = function(dictSemiring) {
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    return {
        append: function(v) {
            return function(v1) {
                return mul(v)(v1);
            };
        }
    };
};
var $665413393090e9d0$export$a745aa1873a0c2a6 = function(dictOrd) {
    return dictOrd;
};
var $665413393090e9d0$export$b1fd47ce92821578 = function(dictSemiring) {
    var semigroupMultiplicative1 = $665413393090e9d0$export$879165283e0876da(dictSemiring);
    return {
        mempty: $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring),
        Semigroup0: function() {
            return semigroupMultiplicative1;
        }
    };
};
var $665413393090e9d0$export$fb489b392661d391 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $665413393090e9d0$export$d7079d8ae90b8bb4 = function(dictEq) {
    return dictEq;
};
var $665413393090e9d0$export$989c1e5544f0c166 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($665413393090e9d0$export$d7079d8ae90b8bb4(dictEq));
    }
};
var $665413393090e9d0$export$fecaa24314ae6d78 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($665413393090e9d0$export$a745aa1873a0c2a6(dictOrd));
    },
    Eq10: function() {
        return $665413393090e9d0$export$989c1e5544f0c166;
    }
};
var $665413393090e9d0$export$bbf6fde3198eeb4e = function(dictBounded) {
    return dictBounded;
};
var $665413393090e9d0$export$4270b48d12c8e2c9 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $665413393090e9d0$export$fb489b392661d391;
    }
};
var $665413393090e9d0$export$b787e2c352a5d886 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $665413393090e9d0$export$4270b48d12c8e2c9;
    }
};
var $665413393090e9d0$export$98fc700c14e70ff0 = {
    pure: $665413393090e9d0$export$d0198c9c86fc2be1,
    Apply0: function() {
        return $665413393090e9d0$export$4270b48d12c8e2c9;
    }
};
var $665413393090e9d0$export$8980d206f063bc12 = {
    Applicative0: function() {
        return $665413393090e9d0$export$98fc700c14e70ff0;
    },
    Bind1: function() {
        return $665413393090e9d0$export$b787e2c352a5d886;
    }
};




var $334541180b4ef18c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $334541180b4ef18c$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$34a2521cb7920188);
var $334541180b4ef18c$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($665413393090e9d0$export$fb489b392661d391);
var $334541180b4ef18c$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $334541180b4ef18c$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($1b4bd570fcdcddf2$export$74aba74241121413);
var $334541180b4ef18c$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($92016ca92c497156$export$98d9d13e8b5bfe4d);
var $334541180b4ef18c$var$map5 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $334541180b4ef18c$var$map6 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($8257f7a36ab9f9cd$export$916a3957c09e9ed5);
var $334541180b4ef18c$var$map7 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($1242d110ab1edcd9$export$410cd7ab647069e5);
var $334541180b4ef18c$var$bimap1 = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$9b66d4861c364eff);
var $334541180b4ef18c$var$map8 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($65ae0a43a0950bac$export$48b7cf0194537bca);
var $334541180b4ef18c$var$map9 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($e48f2e41a907ae60$export$ba106ed6ee21ba26);
var $334541180b4ef18c$export$8f07ddce13659f50 = function(dict) {
    return dict.mapWithIndex;
};
var $334541180b4ef18c$export$6942612de3ba9e09 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    return function(f) {
        return mapWithIndex1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
    };
};
var $334541180b4ef18c$export$98b99a3e5a5c2768 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
    }
};
var $334541180b4ef18c$export$341bcd9812b20e54 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorProduct = $a2051f9edf3d1db6$export$e5b52224642d1f48(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorProduct1 = functorProduct(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return $334541180b4ef18c$var$bimap(mapWithIndex1(function($63) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($63));
                    }))(mapWithIndex2(function($64) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($64));
                    }))(v);
                };
            },
            Functor0: function() {
                return functorProduct1;
            }
        };
    };
};
var $334541180b4ef18c$export$3f7256b7802d7d35 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map1(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $665413393090e9d0$export$fb489b392661d391;
    }
};
var $334541180b4ef18c$export$ff6e9b408c0f1d0a = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map2(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $334541180b4ef18c$export$67874b1834c6566b = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map3(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $1b4bd570fcdcddf2$export$74aba74241121413;
    }
};
var $334541180b4ef18c$export$26258e29c904633d = {
    mapWithIndex: function(f) {
        return function(v) {
            return f($05149ea687d6b460$export$523c0b569236b342)(v);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $334541180b4ef18c$export$707dfb58df7f6e4f = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map4(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $92016ca92c497156$export$98d9d13e8b5bfe4d;
    }
};
var $334541180b4ef18c$export$381e44b6c18f93d6 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map5(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};
var $334541180b4ef18c$export$50b3765d14980fc = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map6(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $8257f7a36ab9f9cd$export$916a3957c09e9ed5;
    }
};
var $334541180b4ef18c$export$b6070cf53db1d339 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map7(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $1242d110ab1edcd9$export$410cd7ab647069e5;
    }
};
var $334541180b4ef18c$export$6f7aa172554aa552 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorCoproduct = $490ec114b4138e6d$export$e192c0fa89a291cb(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorCoproduct1 = functorCoproduct(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return $334541180b4ef18c$var$bimap1(mapWithIndex1(function($65) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($65));
                    }))(mapWithIndex2(function($66) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($66));
                    }))(v);
                };
            },
            Functor0: function() {
                return functorCoproduct1;
            }
        };
    };
};
var $334541180b4ef18c$export$dba6a24121753c2b = {
    mapWithIndex: function(v) {
        return function(v1) {
            return v1;
        };
    },
    Functor0: function() {
        return $10ae0394c8c3139a$export$c03820c48bf31fc8;
    }
};
var $334541180b4ef18c$export$8ba1941ba7d99c6 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map8(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $65ae0a43a0950bac$export$48b7cf0194537bca;
    }
};
var $334541180b4ef18c$export$7935f2d7643e66ce = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorCompose = $6051f44ece6b7171$export$4e14cb014c72d19c(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorCompose1 = functorCompose(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return mapWithIndex1(function() {
                        var $67 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                        return function($68) {
                            return mapWithIndex2($67($68));
                        };
                    }())(v);
                };
            },
            Functor0: function() {
                return functorCompose1;
            }
        };
    };
};
var $334541180b4ef18c$export$f10d51ea0aa3da42 = {
    mapWithIndex: $63ebef0b12494a84$export$e1e714991b6c2aba,
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $334541180b4ef18c$export$ffe1008ccae78edc = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorApp = $60e028b2ef4ceb5f$export$79ab389dc7ad1e04(dictFunctorWithIndex.Functor0());
    return {
        mapWithIndex: function(f) {
            return function(v) {
                return mapWithIndex1(f)(v);
            };
        },
        Functor0: function() {
            return functorApp;
        }
    };
};
var $334541180b4ef18c$export$eee3f4036a1ebada = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map9(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $e48f2e41a907ae60$export$ba106ed6ee21ba26;
    }
};












var $519ef1967f17d101$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$9519b6731ae6781c);
var $519ef1967f17d101$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$9519b6731ae6781c);
var $519ef1967f17d101$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$9519b6731ae6781c);
var $519ef1967f17d101$var$foldr1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $519ef1967f17d101$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $519ef1967f17d101$var$foldMap1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $519ef1967f17d101$var$foldr2 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$d127e049f7f9d81c);
var $519ef1967f17d101$var$foldl2 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$d127e049f7f9d81c);
var $519ef1967f17d101$var$foldMap2 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$d127e049f7f9d81c);
var $519ef1967f17d101$var$foldr3 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e);
var $519ef1967f17d101$var$foldl3 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e);
var $519ef1967f17d101$var$foldMap3 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e);
var $519ef1967f17d101$var$foldr4 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$1f8d30ddb0a4c229);
var $519ef1967f17d101$var$foldl4 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$1f8d30ddb0a4c229);
var $519ef1967f17d101$var$foldMap4 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$1f8d30ddb0a4c229);
var $519ef1967f17d101$var$foldr5 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$fbf8f11f9a917de3);
var $519ef1967f17d101$var$foldl5 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$fbf8f11f9a917de3);
var $519ef1967f17d101$var$foldMap5 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$fbf8f11f9a917de3);
var $519ef1967f17d101$var$foldr6 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$b0c90191a04a5815);
var $519ef1967f17d101$var$foldl6 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$b0c90191a04a5815);
var $519ef1967f17d101$var$foldMap6 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$b0c90191a04a5815);
var $519ef1967f17d101$var$foldr7 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$a3b6f6613d3d5767);
var $519ef1967f17d101$var$foldl7 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$a3b6f6613d3d5767);
var $519ef1967f17d101$var$foldMap7 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$a3b6f6613d3d5767);
var $519ef1967f17d101$var$foldr8 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $519ef1967f17d101$var$mapWithIndex = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50($334541180b4ef18c$export$f10d51ea0aa3da42);
var $519ef1967f17d101$var$foldl8 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $519ef1967f17d101$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $519ef1967f17d101$var$monoidEndo = /* #__PURE__ */ $57b8542ac3131c5d$export$947ca1a8eed6111($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $519ef1967f17d101$var$monoidDual = /* #__PURE__ */ $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb($519ef1967f17d101$var$monoidEndo);
var $519ef1967f17d101$export$d859ed9adfa064ca = function(dict) {
    return dict.foldrWithIndex;
};
var $519ef1967f17d101$export$d13ff16378fefe83 = function(dictApplicative) {
    var applySecond = $7576d3a958d66ab0$export$3d5d566a030a20fc(dictApplicative.Apply0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(dictFoldableWithIndex) {
        var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
        return function(f) {
            return foldrWithIndex1(function(i) {
                var $289 = f(i);
                return function($290) {
                    return applySecond($289($290));
                };
            })(pure($05149ea687d6b460$export$523c0b569236b342));
        };
    };
};
var $519ef1967f17d101$export$f441c83f81b7710f = function(dictApplicative) {
    var traverseWithIndex_1 = $519ef1967f17d101$export$d13ff16378fefe83(dictApplicative);
    return function(dictFoldableWithIndex) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(traverseWithIndex_1(dictFoldableWithIndex));
    };
};
var $519ef1967f17d101$export$9b986141719153e = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    return function(f) {
        return foldrWithIndex1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
    };
};
var $519ef1967f17d101$export$2d70b9efb960f478 = function(dict) {
    return dict.foldlWithIndex;
};
var $519ef1967f17d101$export$e623e8bf74059b22 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(f) {
        return foldlWithIndex1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
    };
};
var $519ef1967f17d101$export$a0208fa03195d5a3 = {
    foldrWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v.value1)(z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(z)(v.value1);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v.value1);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6;
    }
};
var $519ef1967f17d101$export$e07746a44d4d0673 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$9519b6731ae6781c;
    }
};
var $519ef1967f17d101$export$db675654cef60b9a = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr1(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl1(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap1(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$ff97dbee91e727b6;
    }
};
var $519ef1967f17d101$export$3a92905df29453fa = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr2(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl2(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap2(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$d127e049f7f9d81c;
    }
};
var $519ef1967f17d101$export$92c42163dd2c46ce = {
    foldrWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v)(z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(z)(v);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$3c076fb5bbc5428f;
    }
};
var $519ef1967f17d101$export$328d1f7f0045c999 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr3(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl3(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap3(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e;
    }
};
var $519ef1967f17d101$export$617fc130b23797ca = {
    foldrWithIndex: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v($05149ea687d6b460$export$523c0b569236b342)(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldlWithIndex: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v($05149ea687d6b460$export$523c0b569236b342)(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return mempty;
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v($05149ea687d6b460$export$523c0b569236b342)(v1.value0);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$6a194eaac00c1ff4;
    }
};
var $519ef1967f17d101$export$dc8026a24f95d0a9 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr4(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl4(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap4(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229;
    }
};
var $519ef1967f17d101$export$a77c731c3b37cfd = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr5(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl5(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap5(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$fbf8f11f9a917de3;
    }
};
var $519ef1967f17d101$export$1add8b24fb58b747 = {
    foldrWithIndex: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldlWithIndex: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                return mempty;
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$6857d056e9f0762d;
    }
};
var $519ef1967f17d101$export$707470fe74326665 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr6(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl6(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap6(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$b0c90191a04a5815;
    }
};
var $519ef1967f17d101$export$f9ed9b5a8131479e = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr7(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl7(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap7(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$a3b6f6613d3d5767;
    }
};
var $519ef1967f17d101$export$ca16238ae0303ef0 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(f) {
            return function(a0) {
                return foldlWithIndex1(function(i) {
                    return function(ma) {
                        return function(b) {
                            return bind(ma)($f57f4b701aa7b66e$export$8a83211c878a3f1f(f(i))(b));
                        };
                    };
                })(pure(a0));
            };
        };
    };
};
var $519ef1967f17d101$export$998b3d14abdd8136 = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldrWithIndex1(function(i) {
                return function(x) {
                    return function(acc) {
                        return append(f(i)(x))(acc);
                    };
                };
            })(mempty);
        };
    };
};
var $519ef1967f17d101$export$e728f47f20b1eb28 = {
    foldrWithIndex: function(f) {
        return function(z) {
            var $291 = $519ef1967f17d101$var$foldr8(function(v) {
                return function(y) {
                    return f(v.value0)(v.value1)(y);
                };
            })(z);
            var $292 = $519ef1967f17d101$var$mapWithIndex($71f2e2e9476163f8$export$1908877435b1d5e9.create);
            return function($293) {
                return $291($292($293));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            var $294 = $519ef1967f17d101$var$foldl8(function(y) {
                return function(v) {
                    return f(v.value0)(y)(v.value1);
                };
            })(z);
            var $295 = $519ef1967f17d101$var$mapWithIndex($71f2e2e9476163f8$export$1908877435b1d5e9.create);
            return function($296) {
                return $294($295($296));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $519ef1967f17d101$export$998b3d14abdd8136($519ef1967f17d101$export$e728f47f20b1eb28)(dictMonoid);
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$e97014618a7eb593;
    }
};
var $519ef1967f17d101$export$d58f3ffea0efd404 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldlWithIndex1(function(i) {
                return function(acc) {
                    return function(x) {
                        return append(acc)(f(i)(x));
                    };
                };
            })(mempty);
        };
    };
};
var $519ef1967f17d101$export$18153bb1181268e5 = function(dict) {
    return dict.foldMapWithIndex;
};
var $519ef1967f17d101$export$ca1485f10f9ca9ee = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableApp = $4fe7b6acfba7f29f$export$1e1b0f55a49f1dc6(dictFoldableWithIndex.Foldable0());
    return {
        foldrWithIndex: function(f) {
            return function(z) {
                return function(v) {
                    return foldrWithIndex1(f)(z)(v);
                };
            };
        },
        foldlWithIndex: function(f) {
            return function(z) {
                return function(v) {
                    return foldlWithIndex1(f)(z)(v);
                };
            };
        },
        foldMapWithIndex: function(dictMonoid) {
            var foldMapWithIndex2 = foldMapWithIndex1(dictMonoid);
            return function(f) {
                return function(v) {
                    return foldMapWithIndex2(f)(v);
                };
            };
        },
        Foldable0: function() {
            return foldableApp;
        }
    };
};
var $519ef1967f17d101$export$ed9dddd4d2a66e4d = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableCompose = $4fe7b6acfba7f29f$export$5677464b2ea4179d(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableCompose1 = foldableCompose(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(i) {
                    return function(v) {
                        return foldrWithIndex1(function(a) {
                            return $f57f4b701aa7b66e$export$8a83211c878a3f1f(foldrWithIndex2($71f2e2e9476163f8$export$c3095a23b368d1f2(f)(a)));
                        })(i)(v);
                    };
                };
            },
            foldlWithIndex: function(f) {
                return function(i) {
                    return function(v) {
                        return foldlWithIndex1(function() {
                            var $297 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                            return function($298) {
                                return foldlWithIndex2($297($298));
                            };
                        }())(i)(v);
                    };
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return function(v) {
                        return foldMapWithIndex3(function() {
                            var $299 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                            return function($300) {
                                return foldMapWithIndex4($299($300));
                            };
                        }())(v);
                    };
                };
            },
            Foldable0: function() {
                return foldableCompose1;
            }
        };
    };
};
var $519ef1967f17d101$export$c8998bd70c04c75d = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableCoproduct = $4fe7b6acfba7f29f$export$5c9c2b827ab84341(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableCoproduct1 = foldableCoproduct(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldrWithIndex1(function($301) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($301));
                    })(z))(foldrWithIndex2(function($302) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($302));
                    })(z));
                };
            },
            foldlWithIndex: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldlWithIndex1(function($303) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($303));
                    })(z))(foldlWithIndex2(function($304) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($304));
                    })(z));
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldMapWithIndex3(function($305) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($305));
                    }))(foldMapWithIndex4(function($306) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($306));
                    }));
                };
            },
            Foldable0: function() {
                return foldableCoproduct1;
            }
        };
    };
};
var $519ef1967f17d101$export$e0fd1e7d0cab0fb2 = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableProduct = $4fe7b6acfba7f29f$export$a013322ac1f6d3aa(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableProduct1 = foldableProduct(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(z) {
                    return function(v) {
                        return foldrWithIndex1(function($307) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($307));
                        })(foldrWithIndex2(function($308) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($308));
                        })(z)(v.value1))(v.value0);
                    };
                };
            },
            foldlWithIndex: function(f) {
                return function(z) {
                    return function(v) {
                        return foldlWithIndex2(function($309) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($309));
                        })(foldlWithIndex1(function($310) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($310));
                        })(z)(v.value0))(v.value1);
                    };
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return function(v) {
                        return append(foldMapWithIndex3(function($311) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($311));
                        })(v.value0))(foldMapWithIndex4(function($312) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($312));
                        })(v.value1));
                    };
                };
            },
            Foldable0: function() {
                return foldableProduct1;
            }
        };
    };
};
var $519ef1967f17d101$export$a2a2be54aa786fa = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidDual);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $519ef1967f17d101$var$unwrap($519ef1967f17d101$var$unwrap(foldMapWithIndex1(function(i) {
                    var $313 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(c(i));
                    return function($314) {
                        return $8257f7a36ab9f9cd$export$c26a72e8d91adeec($57b8542ac3131c5d$export$6aef3ff797629bec($313($314)));
                    };
                })(xs)))(u);
            };
        };
    };
};
var $519ef1967f17d101$export$f48decfd8b6d8740 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidEndo);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $519ef1967f17d101$var$unwrap(foldMapWithIndex1(function(i) {
                    var $315 = c(i);
                    return function($316) {
                        return $57b8542ac3131c5d$export$6aef3ff797629bec($315($316));
                    };
                })(xs))(u);
            };
        };
    };
};
var $519ef1967f17d101$export$9f81331332e444a = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidEndo);
    return function(dictSemigroup) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return function(d) {
            return function(t) {
                return function(f) {
                    var joined = function(i) {
                        return function(a) {
                            return function(m) {
                                return append(d)(append(t(i)(a))(m));
                            };
                        };
                    };
                    return $519ef1967f17d101$var$unwrap(foldMapWithIndex1(joined)(f))(d);
                };
            };
        };
    };
};
var $519ef1967f17d101$export$222b6fd2bc53ca7a = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictMonoid) {
        var foldMapWithIndex2 = foldMapWithIndex1(dictMonoid);
        return function(f) {
            return foldMapWithIndex2($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
        };
    };
};
var $519ef1967f17d101$export$d803998e74b07aa8 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                return function(v2) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && p(v)(v2)) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        index: v,
                        value: v2
                    });
                    return v1;
                };
            };
        };
        return foldlWithIndex1(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $519ef1967f17d101$export$c34ce7d3b9a0e = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(f) {
        var go = function(v) {
            return function(v1) {
                return function(v2) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return f(v)(v2);
                    return v1;
                };
            };
        };
        return foldlWithIndex1(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $519ef1967f17d101$export$6d3978b14e304a71 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictHeytingAlgebra) {
        var foldMapWithIndex2 = foldMapWithIndex1($1242d110ab1edcd9$export$e1c73e5b30670500(dictHeytingAlgebra));
        return function(t) {
            var $317 = foldMapWithIndex2(function(i) {
                var $319 = t(i);
                return function($320) {
                    return $1242d110ab1edcd9$export$286e7113895e33ef($319($320));
                };
            });
            return function($318) {
                return $519ef1967f17d101$var$unwrap($317($318));
            };
        };
    };
};
var $519ef1967f17d101$export$5dc11e929c02e763 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictHeytingAlgebra) {
        var foldMapWithIndex2 = foldMapWithIndex1($65ae0a43a0950bac$export$4f2b093ea8408d89(dictHeytingAlgebra));
        return function(t) {
            var $321 = foldMapWithIndex2(function(i) {
                var $323 = t(i);
                return function($324) {
                    return $65ae0a43a0950bac$export$c688766eb4789b8c($323($324));
                };
            });
            return function($322) {
                return $519ef1967f17d101$var$unwrap($321($322));
            };
        };
    };
};




// Generated by purs version 0.15.15












// Generated by purs version 0.15.15













// Generated by purs version 0.15.15








// Generated by purs version 0.15.15



var $baee932cbcb11133$export$d36c09e5d02927e7 = function(x) {
    return x;
};
var $baee932cbcb11133$export$cbb92fe0a8d77a01 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Max " + (show(v) + ")");
        }
    };
};
var $baee932cbcb11133$export$a132d56c46b55689 = function(dictOrd) {
    var max = $97937c29f879e68e$export$8960430cfd85939f(dictOrd);
    return {
        append: function(v) {
            return function(v1) {
                return max(v)(v1);
            };
        }
    };
};
var $baee932cbcb11133$export$1c8bde74ed3994f3 = {
    Coercible0: function() {
        return undefined;
    }
};
var $baee932cbcb11133$export$1f74115b8967ed30 = function(dictBounded) {
    var semigroupMax1 = $baee932cbcb11133$export$a132d56c46b55689(dictBounded.Ord0());
    return {
        mempty: $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded),
        Semigroup0: function() {
            return semigroupMax1;
        }
    };
};
var $baee932cbcb11133$export$2d291ba9538dc344 = function(dictEq) {
    return dictEq;
};
var $baee932cbcb11133$export$9193f18dc6b98d96 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMax1 = $baee932cbcb11133$export$2d291ba9538dc344(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v)(v1);
            };
        },
        Eq0: function() {
            return eqMax1;
        }
    };
};


// Generated by purs version 0.15.15



var $78eaf69ebdcfa03a$export$dfed19fabc75a31d = function(x) {
    return x;
};
var $78eaf69ebdcfa03a$export$7b461170c443f592 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Min " + (show(v) + ")");
        }
    };
};
var $78eaf69ebdcfa03a$export$7a307765ab1cd61e = function(dictOrd) {
    var min = $97937c29f879e68e$export$96ec731ed4dcb222(dictOrd);
    return {
        append: function(v) {
            return function(v1) {
                return min(v)(v1);
            };
        }
    };
};
var $78eaf69ebdcfa03a$export$1aba8bd40545d1a0 = {
    Coercible0: function() {
        return undefined;
    }
};
var $78eaf69ebdcfa03a$export$6c7bc156e3eb9786 = function(dictBounded) {
    var semigroupMin1 = $78eaf69ebdcfa03a$export$7a307765ab1cd61e(dictBounded.Ord0());
    return {
        mempty: $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded),
        Semigroup0: function() {
            return semigroupMin1;
        }
    };
};
var $78eaf69ebdcfa03a$export$aa006854d430a332 = function(dictEq) {
    return dictEq;
};
var $78eaf69ebdcfa03a$export$ea9a45890a65660 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMin1 = $78eaf69ebdcfa03a$export$aa006854d430a332(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v)(v1);
            };
        },
        Eq0: function() {
            return eqMin1;
        }
    };
};





var $086486679aa806fa$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $086486679aa806fa$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $086486679aa806fa$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $086486679aa806fa$var$ala = /* #__PURE__ */ $4fa4836228a192cc$export$7317c19c5df48291()()();
var $086486679aa806fa$var$JoinWith = function(x) {
    return x;
};
var $086486679aa806fa$var$FoldRight1 = /* #__PURE__ */ function() {
    function FoldRight1(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    FoldRight1.create = function(value0) {
        return function(value1) {
            return new FoldRight1(value0, value1);
        };
    };
    return FoldRight1;
}();
var $086486679aa806fa$var$Act = function(x) {
    return x;
};
var $086486679aa806fa$var$semigroupJoinWith = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                return function(j) {
                    return append(v(j))(append(j)(v1(j)));
                };
            };
        }
    };
};
var $086486679aa806fa$var$semigroupAct = function(dictApply) {
    var applySecond = $7576d3a958d66ab0$export$3d5d566a030a20fc(dictApply);
    return {
        append: function(v) {
            return function(v1) {
                return applySecond(v)(v1);
            };
        }
    };
};
var $086486679aa806fa$var$runFoldRight1 = function(v) {
    return v.value0(v.value1);
};
var $086486679aa806fa$var$mkFoldRight1 = /* #__PURE__ */ function() {
    return $086486679aa806fa$var$FoldRight1.create($f57f4b701aa7b66e$export$5b38a098e5a9e7ca);
}();
var $086486679aa806fa$var$joinee = function(v) {
    return v;
};
var $086486679aa806fa$var$getAct = function(v) {
    return v;
};
var $086486679aa806fa$export$c8b99533c112636f = function(dict) {
    return dict.foldr1;
};
var $086486679aa806fa$export$eb5e1ef4ea2eca3d = function(dict) {
    return dict.foldl1;
};
var $086486679aa806fa$export$c42fa06aba2a552c = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(cmp) {
        return foldl11(function(x) {
            return function(y) {
                var $120 = $086486679aa806fa$var$eq(cmp(x)(y))($5026be88823ef1f4$export$b023c82b48e70453.value);
                if ($120) return x;
                return y;
            };
        });
    };
};
var $086486679aa806fa$export$b65392d958998255 = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(cmp) {
        return foldl11(function(x) {
            return function(y) {
                var $121 = $086486679aa806fa$var$eq(cmp(x)(y))($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
                if ($121) return x;
                return y;
            };
        });
    };
};
var $086486679aa806fa$export$ffb07d5442a5d6a6 = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v.value1);
            };
        };
    },
    foldr1: function(v) {
        return function(v1) {
            return v1.value1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1.value1;
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6;
    }
};
var $086486679aa806fa$export$9519b6731ae6781c = {
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$9519b6731ae6781c;
    }
};
var $086486679aa806fa$export$3c076fb5bbc5428f = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$3c076fb5bbc5428f;
    }
};
var $086486679aa806fa$export$1f8d30ddb0a4c229 = {
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229;
    }
};
var $086486679aa806fa$var$foldRight1Semigroup = {
    append: function(v) {
        return function(v1) {
            return new $086486679aa806fa$var$FoldRight1(function(a) {
                return function(f) {
                    return v.value0(f(v.value1)(v1.value0(a)(f)))(f);
                };
            }, v1.value1);
        };
    }
};
var $086486679aa806fa$var$semigroupDual = /* #__PURE__ */ $8257f7a36ab9f9cd$export$dc7d4cd4865fc48($086486679aa806fa$var$foldRight1Semigroup);
var $086486679aa806fa$export$4a5b2f24b03cc38b = function(dictFoldable1) {
    var foldr11 = $086486679aa806fa$export$c8b99533c112636f(dictFoldable1);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictSemigroup) {
            var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
            return function(f) {
                var $159 = foldr11(append);
                var $160 = map(f);
                return function($161) {
                    return $159($160($161));
                };
            };
        };
    };
};
var $086486679aa806fa$export$3341743d361f5644 = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictSemigroup) {
            var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
            return function(f) {
                var $162 = foldl11(append);
                var $163 = map(f);
                return function($164) {
                    return $162($163($164));
                };
            };
        };
    };
};
var $086486679aa806fa$export$b50c31bb8aebd2a7 = function(dict) {
    return dict.foldMap1;
};
var $086486679aa806fa$export$8dd52a2a23ae4dc4 = function(dictFoldable1) {
    var $165 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(function() {
        var $167 = $086486679aa806fa$var$alaF($8257f7a36ab9f9cd$export$c26a72e8d91adeec)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($086486679aa806fa$var$semigroupDual))($086486679aa806fa$var$mkFoldRight1);
        return function($168) {
            return $086486679aa806fa$var$runFoldRight1($167($168));
        };
    }());
    return function($166) {
        return $165($f57f4b701aa7b66e$export$8a83211c878a3f1f($166));
    };
};
var $086486679aa806fa$export$8af34898c082e678 = function(dictFoldable1) {
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f(function() {
        var $169 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($086486679aa806fa$var$foldRight1Semigroup)($086486679aa806fa$var$mkFoldRight1);
        return function($170) {
            return $086486679aa806fa$var$runFoldRight1($169($170));
        };
    }());
};
var $086486679aa806fa$export$a91e4d9c87e70eae = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictSemigroup) {
        var foldMap12 = foldMap11($086486679aa806fa$var$semigroupJoinWith(dictSemigroup));
        return function(j) {
            return function(f) {
                return function(foldable) {
                    return $086486679aa806fa$var$joinee(foldMap12(function($171) {
                        return $086486679aa806fa$var$JoinWith($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f($171)));
                    })(foldable))(j);
                };
            };
        };
    };
};
var $086486679aa806fa$export$739ec22334c44788 = function(dictFoldable1) {
    var intercalateMap1 = $086486679aa806fa$export$a91e4d9c87e70eae(dictFoldable1);
    return function(dictSemigroup) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(intercalateMap1(dictSemigroup))($086486679aa806fa$var$identity);
    };
};
var $086486679aa806fa$export$b25e0be55f42c9a = function(dictOrd) {
    var semigroupMax = $baee932cbcb11133$export$a132d56c46b55689(dictOrd);
    return function(dictFoldable1) {
        return $086486679aa806fa$var$ala($baee932cbcb11133$export$d36c09e5d02927e7)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)(semigroupMax));
    };
};
var $086486679aa806fa$export$916782c1f0ddb132 = function(dictOrd) {
    var semigroupMin = $78eaf69ebdcfa03a$export$7a307765ab1cd61e(dictOrd);
    return function(dictFoldable1) {
        return $086486679aa806fa$var$ala($78eaf69ebdcfa03a$export$dfed19fabc75a31d)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)(semigroupMin));
    };
};
var $086486679aa806fa$export$4d892265b7b103bf = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictApply) {
        var voidRight = $f4b2eb11fc32ed34$export$b818c54ed8d3e90a(dictApply.Functor0());
        var foldMap12 = foldMap11($086486679aa806fa$var$semigroupAct(dictApply));
        return function(f) {
            return function(t) {
                return voidRight($05149ea687d6b460$export$523c0b569236b342)($086486679aa806fa$var$getAct(foldMap12(function($172) {
                    return $086486679aa806fa$var$Act(f($172));
                })(t)));
            };
        };
    };
};
var $086486679aa806fa$export$f339179a581d1957 = function(dictFoldable1) {
    var traverse1_1 = $086486679aa806fa$export$4d892265b7b103bf(dictFoldable1);
    return function(dictApply) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(traverse1_1(dictApply));
    };
};
var $086486679aa806fa$export$1e2962bbf3c67125 = function(dictFoldable1) {
    var traverse1_1 = $086486679aa806fa$export$4d892265b7b103bf(dictFoldable1);
    return function(dictApply) {
        return traverse1_1(dictApply)($086486679aa806fa$var$identity);
    };
};
var $086486679aa806fa$export$2e430a6d03f6ee23 = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictSemigroup) {
        return foldMap11(dictSemigroup)($086486679aa806fa$var$identity);
    };
};



// Generated by purs version 0.15.15
// jshint maxparams: 3
const $e2e7171b55349aa8$export$778bf95e3da1fa51 = function() {
    function array1(a) {
        return [
            a
        ];
    }
    function array2(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    }
    function array3(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    }
    function concat2(xs) {
        return function(ys) {
            return xs.concat(ys);
        };
    }
    return function(apply) {
        return function(map) {
            return function(pure) {
                return function(f) {
                    return function(array) {
                        function go(bot, top) {
                            switch(top - bot){
                                case 0:
                                    return pure([]);
                                case 1:
                                    return map(array1)(f(array[bot]));
                                case 2:
                                    return apply(map(array2)(f(array[bot])))(f(array[bot + 1]));
                                case 3:
                                    return apply(apply(map(array3)(f(array[bot])))(f(array[bot + 1])))(f(array[bot + 2]));
                                default:
                                    // This slightly tricky pivot selection aims to produce two
                                    // even-length partitions where possible.
                                    var pivot = bot + Math.floor((top - bot) / 4) * 2;
                                    return apply(map(concat2)(go(bot, pivot)))(go(pivot, top));
                            }
                        }
                        return go(0, array.length);
                    };
                };
            };
        };
    };
}();






















// Generated by purs version 0.15.15


// Generated by purs version 0.15.15
var $b5a91a6cc4fccdbd$export$e55c55b7b44ad601 = function(x) {
    return x;
};
var $b5a91a6cc4fccdbd$export$28dda4bfb631a565 = function(x) {
    return x;
};
var $b5a91a6cc4fccdbd$export$8c9fed8401f25951 = function(v) {
    return v;
};
var $b5a91a6cc4fccdbd$export$25c41c6231a79e25 = function(v) {
    return v;
};
var $b5a91a6cc4fccdbd$export$c9b79b3c57c3d6cd = {
    map: function(f) {
        return function(k) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(k)(s);
                return {
                    accum: v.accum,
                    value: f(v.value)
                };
            };
        };
    }
};
var $b5a91a6cc4fccdbd$export$b9d5be898ea82056 = {
    map: function(f) {
        return function(k) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(k)(s);
                return {
                    accum: v.accum,
                    value: f(v.value)
                };
            };
        };
    }
};
var $b5a91a6cc4fccdbd$export$68347817ab3710ea = {
    apply: function(f) {
        return function(x) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(x)(s);
                var v1 = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(f)(v.accum);
                return {
                    accum: v1.accum,
                    value: v1.value(v.value)
                };
            };
        };
    },
    Functor0: function() {
        return $b5a91a6cc4fccdbd$export$c9b79b3c57c3d6cd;
    }
};
var $b5a91a6cc4fccdbd$export$d997dc0aadd0b300 = {
    apply: function(f) {
        return function(x) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(f)(s);
                var v1 = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(x)(v.accum);
                return {
                    accum: v1.accum,
                    value: v.value(v1.value)
                };
            };
        };
    },
    Functor0: function() {
        return $b5a91a6cc4fccdbd$export$b9d5be898ea82056;
    }
};
var $b5a91a6cc4fccdbd$export$c4ee441de2fba0d9 = {
    pure: function(a) {
        return function(s) {
            return {
                accum: s,
                value: a
            };
        };
    },
    Apply0: function() {
        return $b5a91a6cc4fccdbd$export$68347817ab3710ea;
    }
};
var $b5a91a6cc4fccdbd$export$9fd2229713491b84 = {
    pure: function(a) {
        return function(s) {
            return {
                accum: s,
                value: a
            };
        };
    },
    Apply0: function() {
        return $b5a91a6cc4fccdbd$export$d997dc0aadd0b300;
    }
};



var $11d1e86de605dfc6$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $11d1e86de605dfc6$export$df3f009e3d155b20 = function(dict) {
    return dict.traverse;
};
var $11d1e86de605dfc6$export$d35878ee42638401 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(f(v.value1));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(v.value1);
        };
    },
    Functor0: function() {
        return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6;
    }
};
var $11d1e86de605dfc6$export$b86a2d00788e21b6 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($665413393090e9d0$export$d0198c9c86fc2be1)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($665413393090e9d0$export$d0198c9c86fc2be1)(v);
        };
    },
    Functor0: function() {
        return $665413393090e9d0$export$fb489b392661d391;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$9519b6731ae6781c;
    }
};
var $11d1e86de605dfc6$export$80f6258c17467741 = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return map($06733ae99ed4f534$export$8a67b48435b5d073.create)(v(v1.value0));
                throw new Error("Failed pattern match at Data.Traversable (line 115, column 1 - line 119, column 33): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return map($06733ae99ed4f534$export$8a67b48435b5d073.create)(v.value0);
            throw new Error("Failed pattern match at Data.Traversable (line 115, column 1 - line 119, column 33): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$ff97dbee91e727b6;
    }
};
var $11d1e86de605dfc6$var$traverse1 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$80f6258c17467741);
var $11d1e86de605dfc6$export$63e84f34fb558532 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(v);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$3c076fb5bbc5428f;
    }
};
var $11d1e86de605dfc6$export$29eea1300519490d = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0));
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v(v1.value0));
                throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0));
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v.value0);
            throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$6a194eaac00c1ff4;
    }
};
var $11d1e86de605dfc6$export$54df524caf88dbea = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($8257f7a36ab9f9cd$export$c26a72e8d91adeec)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($8257f7a36ab9f9cd$export$c26a72e8d91adeec)(v);
        };
    },
    Functor0: function() {
        return $8257f7a36ab9f9cd$export$916a3957c09e9ed5;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229;
    }
};
var $11d1e86de605dfc6$export$a73c18000a1a08d7 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($1242d110ab1edcd9$export$286e7113895e33ef)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($1242d110ab1edcd9$export$286e7113895e33ef)(v);
        };
    },
    Functor0: function() {
        return $1242d110ab1edcd9$export$410cd7ab647069e5;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$fbf8f11f9a917de3;
    }
};
var $11d1e86de605dfc6$export$e6d8402c3fd7d14d = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(v) {
            return function(v1) {
                return pure(v1);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(v) {
            return pure(v);
        };
    },
    Functor0: function() {
        return $10ae0394c8c3139a$export$c03820c48bf31fc8;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$6857d056e9f0762d;
    }
};
var $11d1e86de605dfc6$export$ecbf0d941e1ac029 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($65ae0a43a0950bac$export$c688766eb4789b8c)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($65ae0a43a0950bac$export$c688766eb4789b8c)(v);
        };
    },
    Functor0: function() {
        return $65ae0a43a0950bac$export$48b7cf0194537bca;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$b0c90191a04a5815;
    }
};
var $11d1e86de605dfc6$export$8c91a5391205dbe = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var functorCompose = $6051f44ece6b7171$export$4e14cb014c72d19c(dictTraversable.Functor0());
    var foldableCompose = $4fe7b6acfba7f29f$export$5677464b2ea4179d(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var functorCompose1 = functorCompose(dictTraversable1.Functor0());
        var foldableCompose1 = foldableCompose(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return function(v) {
                        return map($6051f44ece6b7171$export$5a3a146e358e1bcf)(traverse4(traverse5(f))(v));
                    };
                };
            },
            sequence: function(dictApplicative) {
                return $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$8c91a5391205dbe(dictTraversable)(dictTraversable1))(dictApplicative)($11d1e86de605dfc6$var$identity);
            },
            Functor0: function() {
                return functorCompose1;
            },
            Foldable1: function() {
                return foldableCompose1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$617ac6e03fd9951c = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($e48f2e41a907ae60$export$14f8ce08180a98e1)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($e48f2e41a907ae60$export$14f8ce08180a98e1)(v);
        };
    },
    Functor0: function() {
        return $e48f2e41a907ae60$export$ba106ed6ee21ba26;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$a3b6f6613d3d5767;
    }
};
var $11d1e86de605dfc6$export$417d88f64c497aed = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    return function(dictApplicative) {
        return traverse2(dictApplicative)($11d1e86de605dfc6$var$identity);
    };
};
var $11d1e86de605dfc6$export$9e4a28683e28e26a = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        return $e2e7171b55349aa8$export$778bf95e3da1fa51($7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0))($f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0()))($c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative));
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$417d88f64c497aed($11d1e86de605dfc6$export$9e4a28683e28e26a)(dictApplicative);
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$e97014618a7eb593;
    }
};
var $11d1e86de605dfc6$export$49bb65c2ea163039 = function(dict) {
    return dict.sequence;
};
var $11d1e86de605dfc6$var$sequence1 = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$80f6258c17467741);
var $11d1e86de605dfc6$export$744e1c7707f1991f = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorApp = $60e028b2ef4ceb5f$export$79ab389dc7ad1e04(dictTraversable.Functor0());
    var foldableApp = $4fe7b6acfba7f29f$export$1e1b0f55a49f1dc6(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse3 = traverse2(dictApplicative);
            return function(f) {
                return function(v) {
                    return map($60e028b2ef4ceb5f$export$86fbec116b87613f)(traverse3(f)(v));
                };
            };
        },
        sequence: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var sequence3 = sequence2(dictApplicative);
            return function(v) {
                return map($60e028b2ef4ceb5f$export$86fbec116b87613f)(sequence3(v));
            };
        },
        Functor0: function() {
            return functorApp;
        },
        Foldable1: function() {
            return foldableApp;
        }
    };
};
var $11d1e86de605dfc6$export$78124b32135c203a = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorCoproduct = $490ec114b4138e6d$export$e192c0fa89a291cb(dictTraversable.Functor0());
    var foldableCoproduct = $4fe7b6acfba7f29f$export$5c9c2b827ab84341(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var sequence3 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable1);
        var functorCoproduct1 = functorCoproduct(dictTraversable1.Functor0());
        var foldableCoproduct1 = foldableCoproduct(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                        var $313 = map(function($316) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($316));
                        });
                        var $314 = traverse4(f);
                        return function($315) {
                            return $313($314($315));
                        };
                    }())(function() {
                        var $317 = map(function($320) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($320));
                        });
                        var $318 = traverse5(f);
                        return function($319) {
                            return $317($318($319));
                        };
                    }());
                };
            },
            sequence: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                return $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                    var $321 = map(function($324) {
                        return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($324));
                    });
                    var $322 = sequence2(dictApplicative);
                    return function($323) {
                        return $321($322($323));
                    };
                }())(function() {
                    var $325 = map(function($328) {
                        return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($328));
                    });
                    var $326 = sequence3(dictApplicative);
                    return function($327) {
                        return $325($326($327));
                    };
                }());
            },
            Functor0: function() {
                return functorCoproduct1;
            },
            Foldable1: function() {
                return foldableCoproduct1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$1cee23aad9b21cdc = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var traverse2 = $11d1e86de605dfc6$var$traverse1(dictApplicative);
        return function(f) {
            return function(v) {
                return map($92016ca92c497156$export$b25abba66f7be210)(traverse2(f)(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var sequence2 = $11d1e86de605dfc6$var$sequence1(dictApplicative);
        return function(v) {
            return map($92016ca92c497156$export$b25abba66f7be210)(sequence2(v));
        };
    },
    Functor0: function() {
        return $92016ca92c497156$export$98d9d13e8b5bfe4d;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e;
    }
};
var $11d1e86de605dfc6$export$f5923975fb28337f = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var traverse2 = $11d1e86de605dfc6$var$traverse1(dictApplicative);
        return function(f) {
            return function(v) {
                return map($1b4bd570fcdcddf2$export$bed9238d8933c9a8)(traverse2(f)(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var sequence2 = $11d1e86de605dfc6$var$sequence1(dictApplicative);
        return function(v) {
            return map($1b4bd570fcdcddf2$export$bed9238d8933c9a8)(sequence2(v));
        };
    },
    Functor0: function() {
        return $1b4bd570fcdcddf2$export$74aba74241121413;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$d127e049f7f9d81c;
    }
};
var $11d1e86de605dfc6$export$261d8d87b1749d17 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorProduct = $a2051f9edf3d1db6$export$e5b52224642d1f48(dictTraversable.Functor0());
    var foldableProduct = $4fe7b6acfba7f29f$export$a013322ac1f6d3aa(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var sequence3 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable1);
        var functorProduct1 = functorProduct(dictTraversable1.Functor0());
        var foldableProduct1 = foldableProduct(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApplicative.Apply0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return function(v) {
                        return lift2($a2051f9edf3d1db6$export$dbd0f18357df1ddd)(traverse4(f)(v.value0))(traverse5(f)(v.value1));
                    };
                };
            },
            sequence: function(dictApplicative) {
                var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApplicative.Apply0());
                var sequence4 = sequence2(dictApplicative);
                var sequence5 = sequence3(dictApplicative);
                return function(v) {
                    return lift2($a2051f9edf3d1db6$export$dbd0f18357df1ddd)(sequence4(v.value0))(sequence5(v.value1));
                };
            },
            Functor0: function() {
                return functorProduct1;
            },
            Foldable1: function() {
                return foldableProduct1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$d50a9c31d69ee13c = function(dictTraversable) {
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictTraversable.Functor0());
    return function(dictApplicative) {
        var sequence3 = sequence2(dictApplicative);
        return function(f) {
            return function(ta) {
                return sequence3(map(f)(ta));
            };
        };
    };
};
var $11d1e86de605dfc6$export$d54b12b778292b35 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)($b5a91a6cc4fccdbd$export$c4ee441de2fba0d9);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$8c9fed8401f25951(traverse2(function(a) {
                    return function(s) {
                        return f(s)(a);
                    };
                })(xs))(s0);
            };
        };
    };
};
var $11d1e86de605dfc6$export$64df51ac031d4ad2 = function(dictTraversable) {
    var mapAccumR1 = $11d1e86de605dfc6$export$d54b12b778292b35(dictTraversable);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumR1(function(b) {
                    return function(a) {
                        var b$prime = f(a)(b);
                        return {
                            accum: b$prime,
                            value: b$prime
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $11d1e86de605dfc6$export$d5f444bb5e0f233 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)($b5a91a6cc4fccdbd$export$9fd2229713491b84);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$25c41c6231a79e25(traverse2(function(a) {
                    return function(s) {
                        return f(s)(a);
                    };
                })(xs))(s0);
            };
        };
    };
};
var $11d1e86de605dfc6$export$65f513eaf3c582b8 = function(dictTraversable) {
    var mapAccumL1 = $11d1e86de605dfc6$export$d5f444bb5e0f233(dictTraversable);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumL1(function(b) {
                    return function(a) {
                        var b$prime = f(b)(a);
                        return {
                            accum: b$prime,
                            value: b$prime
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $11d1e86de605dfc6$export$f89de2e5bf57e5e6 = function(dictApplicative) {
    return function(dictTraversable) {
        var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)(dictApplicative);
        return function(x) {
            return function(f) {
                return traverse2(f)(x);
            };
        };
    };
};


// Generated by purs version 0.15.15

















var $2c7a64ff78781336$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$b86a2d00788e21b6);
var $2c7a64ff78781336$var$traverse1 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$80f6258c17467741);
var $2c7a64ff78781336$var$traverse2 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$f5923975fb28337f);
var $2c7a64ff78781336$var$traverse3 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$1cee23aad9b21cdc);
var $2c7a64ff78781336$var$traverse4 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$54df524caf88dbea);
var $2c7a64ff78781336$var$traverse5 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$a73c18000a1a08d7);
var $2c7a64ff78781336$var$traverse6 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$ecbf0d941e1ac029);
var $2c7a64ff78781336$var$traverse7 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$617ac6e03fd9951c);
var $2c7a64ff78781336$export$37034f8d74d84f8b = function(dictTraversableWithIndex) {
    var sequence = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversableWithIndex.Traversable2());
    var mapWithIndex = $334541180b4ef18c$export$8f07ddce13659f50(dictTraversableWithIndex.FunctorWithIndex0());
    return function(dictApplicative) {
        var sequence1 = sequence(dictApplicative);
        return function(f) {
            var $174 = mapWithIndex(f);
            return function($175) {
                return sequence1($174($175));
            };
        };
    };
};
var $2c7a64ff78781336$export$955fdc0d24efa249 = function(dict) {
    return dict.traverseWithIndex;
};
var $2c7a64ff78781336$export$d50a9c31d69ee13c = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    return function(dictApplicative) {
        var traverseWithIndex2 = traverseWithIndex1(dictApplicative);
        return function(f) {
            return traverseWithIndex2($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
        };
    };
};
var $2c7a64ff78781336$export$649571d878667376 = {
    traverseWithIndex: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(f($05149ea687d6b460$export$523c0b569236b342)(v.value1));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$98b99a3e5a5c2768;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$a0208fa03195d5a3;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$d35878ee42638401;
    }
};
var $2c7a64ff78781336$export$f5fab9ea43775499 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexProduct = $334541180b4ef18c$export$341bcd9812b20e54(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexProduct = $519ef1967f17d101$export$e0fd1e7d0cab0fb2(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableProduct = $11d1e86de605dfc6$export$261d8d87b1749d17(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexProduct1 = functorWithIndexProduct(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexProduct1 = foldableWithIndexProduct(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableProduct1 = traversableProduct(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApplicative.Apply0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return function(v) {
                        return lift2($a2051f9edf3d1db6$export$dbd0f18357df1ddd)(traverseWithIndex3(function($176) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($176));
                        })(v.value0))(traverseWithIndex4(function($177) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($177));
                        })(v.value1));
                    };
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexProduct1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexProduct1;
            },
            Traversable2: function() {
                return traversableProduct1;
            }
        };
    };
};
var $2c7a64ff78781336$export$340ca064331c9524 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$3f7256b7802d7d35;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$e07746a44d4d0673;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$b86a2d00788e21b6;
    }
};
var $2c7a64ff78781336$export$971c834447f08858 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse1(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$ff6e9b408c0f1d0a;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$db675654cef60b9a;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$80f6258c17467741;
    }
};
var $2c7a64ff78781336$export$82bf3aff27014955 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse2(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$67874b1834c6566b;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$3a92905df29453fa;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$f5923975fb28337f;
    }
};
var $2c7a64ff78781336$export$e4fe4683618a40ff = {
    traverseWithIndex: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(f($05149ea687d6b460$export$523c0b569236b342)(v));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$26258e29c904633d;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$92c42163dd2c46ce;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$63e84f34fb558532;
    }
};
var $2c7a64ff78781336$export$c0565467517236ee = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse3(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$707dfb58df7f6e4f;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$328d1f7f0045c999;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$1cee23aad9b21cdc;
    }
};
var $2c7a64ff78781336$export$c5842444d22f461a = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0));
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v($05149ea687d6b460$export$523c0b569236b342)(v1.value0));
                throw new Error("Failed pattern match at Data.TraversableWithIndex (line 95, column 1 - line 97, column 53): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$381e44b6c18f93d6;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$617fc130b23797ca;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$29eea1300519490d;
    }
};
var $2c7a64ff78781336$export$f81f0b3aaf5918a5 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse4(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$50b3765d14980fc;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$dc8026a24f95d0a9;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$54df524caf88dbea;
    }
};
var $2c7a64ff78781336$export$298c1e0a7ee97588 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse5(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$b6070cf53db1d339;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$a77c731c3b37cfd;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$a73c18000a1a08d7;
    }
};
var $2c7a64ff78781336$export$fad1c006f410e5e2 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexCoproduct = $334541180b4ef18c$export$6f7aa172554aa552(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexCoproduct = $519ef1967f17d101$export$c8998bd70c04c75d(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableCoproduct = $11d1e86de605dfc6$export$78124b32135c203a(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexCoproduct1 = functorWithIndexCoproduct(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexCoproduct1 = foldableWithIndexCoproduct(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableCoproduct1 = traversableCoproduct(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                        var $178 = map(function($181) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($181));
                        });
                        var $179 = traverseWithIndex3(function($182) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($182));
                        });
                        return function($180) {
                            return $178($179($180));
                        };
                    }())(function() {
                        var $183 = map(function($186) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($186));
                        });
                        var $184 = traverseWithIndex4(function($187) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($187));
                        });
                        return function($185) {
                            return $183($184($185));
                        };
                    }());
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexCoproduct1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexCoproduct1;
            },
            Traversable2: function() {
                return traversableCoproduct1;
            }
        };
    };
};
var $2c7a64ff78781336$export$8270215089848547 = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(v) {
            return function(v1) {
                return pure(v1);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$dba6a24121753c2b;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$1add8b24fb58b747;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$e6d8402c3fd7d14d;
    }
};
var $2c7a64ff78781336$export$b78ffb8a06781844 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse6(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$8ba1941ba7d99c6;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$707470fe74326665;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$ecbf0d941e1ac029;
    }
};
var $2c7a64ff78781336$export$e1331c7aac1da04e = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexCompose = $334541180b4ef18c$export$7935f2d7643e66ce(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexCompose = $519ef1967f17d101$export$ed9dddd4d2a66e4d(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableCompose = $11d1e86de605dfc6$export$8c91a5391205dbe(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexCompose1 = functorWithIndexCompose(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexCompose1 = foldableWithIndexCompose(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableCompose1 = traversableCompose(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return function(v) {
                        return map($6051f44ece6b7171$export$5a3a146e358e1bcf)(traverseWithIndex3(function() {
                            var $188 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                            return function($189) {
                                return traverseWithIndex4($188($189));
                            };
                        }())(v));
                    };
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexCompose1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexCompose1;
            },
            Traversable2: function() {
                return traversableCompose1;
            }
        };
    };
};
var $2c7a64ff78781336$export$96888504550934b5 = {
    traverseWithIndex: function(dictApplicative) {
        return $2c7a64ff78781336$export$37034f8d74d84f8b($2c7a64ff78781336$export$96888504550934b5)(dictApplicative);
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$f10d51ea0aa3da42;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$e728f47f20b1eb28;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$9e4a28683e28e26a;
    }
};
var $2c7a64ff78781336$export$fc84432b7fe0f34e = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexApp = $334541180b4ef18c$export$ffe1008ccae78edc(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexApp = $519ef1967f17d101$export$ca1485f10f9ca9ee(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableApp = $11d1e86de605dfc6$export$744e1c7707f1991f(dictTraversableWithIndex.Traversable2());
    return {
        traverseWithIndex: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverseWithIndex2 = traverseWithIndex1(dictApplicative);
            return function(f) {
                return function(v) {
                    return map($60e028b2ef4ceb5f$export$86fbec116b87613f)(traverseWithIndex2(f)(v));
                };
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndexApp;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexApp;
        },
        Traversable2: function() {
            return traversableApp;
        }
    };
};
var $2c7a64ff78781336$export$3d12857a1613dde6 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse7(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$eee3f4036a1ebada;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$f9ed9b5a8131479e;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$617ac6e03fd9951c;
    }
};
var $2c7a64ff78781336$export$34e92304ce7da557 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)($b5a91a6cc4fccdbd$export$c4ee441de2fba0d9);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$8c9fed8401f25951(traverseWithIndex1(function(i) {
                    return function(a) {
                        return function(s) {
                            return f(i)(s)(a);
                        };
                    };
                })(xs))(s0);
            };
        };
    };
};
var $2c7a64ff78781336$export$6062de19d97bcfe7 = function(dictTraversableWithIndex) {
    var mapAccumRWithIndex1 = $2c7a64ff78781336$export$34e92304ce7da557(dictTraversableWithIndex);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumRWithIndex1(function(i) {
                    return function(b) {
                        return function(a) {
                            var b$prime = f(i)(a)(b);
                            return {
                                accum: b$prime,
                                value: b$prime
                            };
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $2c7a64ff78781336$export$2594b6cb66070a = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)($b5a91a6cc4fccdbd$export$9fd2229713491b84);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$25c41c6231a79e25(traverseWithIndex1(function(i) {
                    return function(a) {
                        return function(s) {
                            return f(i)(s)(a);
                        };
                    };
                })(xs))(s0);
            };
        };
    };
};
var $2c7a64ff78781336$export$2aa973d5e57cdb6b = function(dictTraversableWithIndex) {
    var mapAccumLWithIndex1 = $2c7a64ff78781336$export$2594b6cb66070a(dictTraversableWithIndex);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumLWithIndex1(function(i) {
                    return function(b) {
                        return function(a) {
                            var b$prime = f(i)(b)(a);
                            return {
                                accum: b$prime,
                                value: b$prime
                            };
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $2c7a64ff78781336$export$363f6bf7e04ec632 = function(dictApplicative) {
    return function(dictTraversableWithIndex) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f($2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)(dictApplicative));
    };
};



// Generated by purs version 0.15.15
const $6c33ca7d98a534e5$export$6368c6d238d348f0 = function(isNothing) {
    return function(fromJust) {
        return function(fst) {
            return function(snd) {
                return function(f) {
                    return function(b) {
                        var result = [];
                        var value = b;
                        while(true){
                            var maybe = f(value);
                            if (isNothing(maybe)) return result;
                            var tuple = fromJust(maybe);
                            result.push(fst(tuple));
                            value = snd(tuple);
                        }
                    };
                };
            };
        };
    };
};







// Generated by purs version 0.15.15
const $b1275140774187c9$export$e3753a19e82ccedc = function(isNothing) {
    return function(fromJust) {
        return function(fst) {
            return function(snd) {
                return function(f) {
                    return function(b) {
                        var result = [];
                        var value = b;
                        while(true){
                            var tuple = f(value);
                            result.push(fst(tuple));
                            var maybe = snd(tuple);
                            if (isNothing(maybe)) return result;
                            value = fromJust(maybe);
                        }
                    };
                };
            };
        };
    };
};




// Generated by purs version 0.15.15








var $e4fb66202bb8a4f4$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $e4fb66202bb8a4f4$export$d2990bb35e0a3e00 = function(dict) {
    return dict.traverse1;
};
var $e4fb66202bb8a4f4$export$d35878ee42638401 = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(f(v.value1));
            };
        };
    },
    sequence1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(v) {
            return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(v.value1);
        };
    },
    Foldable10: function() {
        return $086486679aa806fa$export$ffb07d5442a5d6a6;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$d35878ee42638401;
    }
};
var $e4fb66202bb8a4f4$export$63e84f34fb558532 = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(v) {
            return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(v);
        };
    },
    Foldable10: function() {
        return $086486679aa806fa$export$3c076fb5bbc5428f;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$63e84f34fb558532;
    }
};
var $e4fb66202bb8a4f4$export$c8ca5446ba1698 = function(dictTraversable1) {
    var traverse11 = $e4fb66202bb8a4f4$export$d2990bb35e0a3e00(dictTraversable1);
    return function(dictApply) {
        return traverse11(dictApply)($e4fb66202bb8a4f4$var$identity);
    };
};
var $e4fb66202bb8a4f4$export$54df524caf88dbea = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($8257f7a36ab9f9cd$export$c26a72e8d91adeec)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$c8ca5446ba1698($e4fb66202bb8a4f4$export$54df524caf88dbea)(dictApply);
    },
    Foldable10: function() {
        return $086486679aa806fa$export$1f8d30ddb0a4c229;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$54df524caf88dbea;
    }
};
var $e4fb66202bb8a4f4$export$b86a2d00788e21b6 = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($665413393090e9d0$export$d0198c9c86fc2be1)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$c8ca5446ba1698($e4fb66202bb8a4f4$export$b86a2d00788e21b6)(dictApply);
    },
    Foldable10: function() {
        return $086486679aa806fa$export$9519b6731ae6781c;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$b86a2d00788e21b6;
    }
};
var $e4fb66202bb8a4f4$export$6deffb29affc84c6 = function(dict) {
    return dict.sequence1;
};
var $e4fb66202bb8a4f4$export$61888596d46ec879 = function(dictTraversable1) {
    var sequence11 = $e4fb66202bb8a4f4$export$6deffb29affc84c6(dictTraversable1);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictTraversable1.Traversable1().Functor0());
    return function(dictApply) {
        var sequence12 = sequence11(dictApply);
        return function(f) {
            return function(ta) {
                return sequence12(map(f)(ta));
            };
        };
    };
};



var $cf5af1199a495394$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $cf5af1199a495394$export$158c052536266a97 = function(dict) {
    return dict.unfoldr1;
};
var $cf5af1199a495394$export$b5ac0a9881e433c3 = {
    unfoldr1: function(f) {
        return function(b) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073($71f2e2e9476163f8$export$9e770fa6ce19a9d6(f(b)));
        };
    }
};
var $cf5af1199a495394$export$587ba9a9bf3cf8b4 = {
    unfoldr1: /* #__PURE__ */ $b1275140774187c9$export$e3753a19e82ccedc($06733ae99ed4f534$export$4967676db1b89293)($cf5af1199a495394$var$fromJust)($71f2e2e9476163f8$export$9e770fa6ce19a9d6)($71f2e2e9476163f8$export$6f71268a1666ab58)
};
var $cf5af1199a495394$export$dcb5d70039e504cd = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(n) {
        return function(v) {
            var step = function(i) {
                if (i <= 0) return new $71f2e2e9476163f8$export$1908877435b1d5e9(v, $06733ae99ed4f534$export$bebe9059409a0d04.value);
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $71f2e2e9476163f8$export$1908877435b1d5e9(v, new $06733ae99ed4f534$export$8a67b48435b5d073(i - 1 | 0));
                throw new Error("Failed pattern match at Data.Unfoldable1 (line 68, column 5 - line 68, column 39): " + [
                    i.constructor.name
                ]);
            };
            return unfoldr11(step)(n - 1 | 0);
        };
    };
};
var $cf5af1199a495394$export$d2a13fab7d8f2b56 = function(dictApply) {
    return function(dictUnfoldable1) {
        var replicate11 = $cf5af1199a495394$export$dcb5d70039e504cd(dictUnfoldable1);
        return function(dictTraversable1) {
            var sequence1 = $e4fb66202bb8a4f4$export$6deffb29affc84c6(dictTraversable1)(dictApply);
            return function(n) {
                return function(m) {
                    return sequence1(replicate11(n)(m));
                };
            };
        };
    };
};
var $cf5af1199a495394$export$439306a4dcaafbb9 = function(dictUnfoldable1) {
    return $cf5af1199a495394$export$dcb5d70039e504cd(dictUnfoldable1)(1);
};
var $cf5af1199a495394$export$d02631cccf789723 = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(start) {
        return function(end) {
            var go = function(delta) {
                return function(i) {
                    var i$prime = i + delta | 0;
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(i, function() {
                        var $25 = i === end;
                        if ($25) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        return new $06733ae99ed4f534$export$8a67b48435b5d073(i$prime);
                    }());
                };
            };
            var delta = function() {
                var $26 = end >= start;
                if ($26) return 1;
                return -1;
            }();
            return unfoldr11(go(delta))(start);
        };
    };
};
var $cf5af1199a495394$export$f1977d76a1a6e399 = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(n) {
        return function(f) {
            return function(s) {
                var go = function(v) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, function() {
                        var $28 = v.value1 > 0;
                        if ($28) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v.value0), v.value1 - 1 | 0));
                        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    }());
                };
                return unfoldr11(go)(new $71f2e2e9476163f8$export$1908877435b1d5e9(s, n - 1 | 0));
            };
        };
    };
};



var $cb5fedc2c4837e1c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $cb5fedc2c4837e1c$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $cb5fedc2c4837e1c$export$df2b8ee1690308ae = function(dict) {
    return dict.unfoldr;
};
var $cb5fedc2c4837e1c$export$b5169c61b27df85a = {
    unfoldr: function(f) {
        return function(b) {
            return $cb5fedc2c4837e1c$var$map($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(f(b));
        };
    },
    Unfoldable10: function() {
        return $cf5af1199a495394$export$b5ac0a9881e433c3;
    }
};
var $cb5fedc2c4837e1c$export$2b90ca20b4b58da5 = {
    unfoldr: /* #__PURE__ */ $6c33ca7d98a534e5$export$6368c6d238d348f0($06733ae99ed4f534$export$4967676db1b89293)($cb5fedc2c4837e1c$var$fromJust)($71f2e2e9476163f8$export$9e770fa6ce19a9d6)($71f2e2e9476163f8$export$6f71268a1666ab58),
    Unfoldable10: function() {
        return $cf5af1199a495394$export$587ba9a9bf3cf8b4;
    }
};
var $cb5fedc2c4837e1c$export$606959e7ccb797f0 = function(dictUnfoldable) {
    var unfoldr1 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(n) {
        return function(v) {
            var step = function(i) {
                var $17 = i <= 0;
                if ($17) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v, i - 1 | 0));
            };
            return unfoldr1(step)(n);
        };
    };
};
var $cb5fedc2c4837e1c$export$1e1bbcb33c108a24 = function(dictApplicative) {
    return function(dictUnfoldable) {
        var replicate1 = $cb5fedc2c4837e1c$export$606959e7ccb797f0(dictUnfoldable);
        return function(dictTraversable) {
            var sequence = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable)(dictApplicative);
            return function(n) {
                return function(m) {
                    return sequence(replicate1(n)(m));
                };
            };
        };
    };
};
var $cb5fedc2c4837e1c$export$f883a24d5edde77c = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($05149ea687d6b460$export$523c0b569236b342);
};
var $cb5fedc2c4837e1c$export$43db023a260c5e9f = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function(b) {
        return $cb5fedc2c4837e1c$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)($06733ae99ed4f534$export$bebe9059409a0d04.value))(b);
    });
};


var $1f1c3fb67e79b37f$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $1f1c3fb67e79b37f$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $1f1c3fb67e79b37f$export$d8deaab87a4e223a = /* #__PURE__ */ function() {
    function NonEmpty(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    NonEmpty.create = function(value0) {
        return function(value1) {
            return new NonEmpty(value0, value1);
        };
    };
    return NonEmpty;
}();
var $1f1c3fb67e79b37f$export$3d29df45c3f8cf54 = function(dictUnfoldable) {
    var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return {
        unfoldr1: function(f) {
            return function(b) {
                return $71f2e2e9476163f8$export$7864d59d01b6d6bf($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)($1f1c3fb67e79b37f$var$map(unfoldr($1f1c3fb67e79b37f$var$map1(f)))(f(b)));
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$c01875f616615628 = function(v) {
    return v.value1;
};
var $1f1c3fb67e79b37f$export$439306a4dcaafbb9 = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    return function(a) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, empty);
    };
};
var $1f1c3fb67e79b37f$export$ffafc93d2cc87798 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(NonEmpty " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$d0a7bd743ccb8d67 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(dictSemigroup) {
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, append1(v.value1)(append1(pure(v1.value0))(v1.value1)));
                };
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$a9a18ae5ba42aeab = function(dictAlternative) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlternative.Plus1().Alt0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    return function(v) {
        return alt(pure(v.value0))(v.value1);
    };
};
var $1f1c3fb67e79b37f$export$5fd5031fecdacec3 = function(v) {
    return v.value0;
};
var $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0 = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(m) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(m.value0), map2(f)(m.value1));
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$cdee60b0fe4303fd = function(dictFunctorWithIndex) {
    var mapWithIndex = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorNonEmpty1 = $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0(dictFunctorWithIndex.Functor0());
    return {
        mapWithIndex: function(f) {
            return function(v) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0), mapWithIndex(function($245) {
                    return f($06733ae99ed4f534$export$8a67b48435b5d073.create($245));
                })(v.value1));
            };
        },
        Functor0: function() {
            return functorNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$1d4c49925323035a = function(f) {
    return function(v) {
        return f(v.value0)(v.value1);
    };
};
var $1f1c3fb67e79b37f$export$20ebd08132411556 = function(dictFoldable) {
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return {
        foldMap: function(dictMonoid) {
            var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                return function(v) {
                    return append1(f(v.value0))(foldMap1(f)(v.value1));
                };
            };
        },
        foldl: function(f) {
            return function(b) {
                return function(v) {
                    return foldl(f)(f(b)(v.value0))(v.value1);
                };
            };
        },
        foldr: function(f) {
            return function(b) {
                return function(v) {
                    return f(v.value0)(foldr(f)(b)(v.value1));
                };
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$9a79a74e355c28b1 = function(dictFoldableWithIndex) {
    var foldMapWithIndex = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldlWithIndex = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldrWithIndex = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictFoldableWithIndex.Foldable0());
    return {
        foldMapWithIndex: function(dictMonoid) {
            var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
            var foldMapWithIndex1 = foldMapWithIndex(dictMonoid);
            return function(f) {
                return function(v) {
                    return append1(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0))(foldMapWithIndex1(function($246) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($246));
                    })(v.value1));
                };
            };
        },
        foldlWithIndex: function(f) {
            return function(b) {
                return function(v) {
                    return foldlWithIndex(function($247) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($247));
                    })(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(b)(v.value0))(v.value1);
                };
            };
        },
        foldrWithIndex: function(f) {
            return function(b) {
                return function(v) {
                    return f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0)(foldrWithIndex(function($248) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($248));
                    })(b)(v.value1));
                };
            };
        },
        Foldable0: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$dbb721137b3f0cf6 = function(dictTraversable) {
    var sequence = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var functorNonEmpty1 = $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0(dictTraversable.Functor0());
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictTraversable.Foldable1());
    return {
        sequence: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
            var sequence1 = sequence(dictApplicative);
            return function(v) {
                return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(v.value0))(sequence1(v.value1));
            };
        },
        traverse: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                return function(v) {
                    return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(f(v.value0)))(traverse1(f)(v.value1));
                };
            };
        },
        Functor0: function() {
            return functorNonEmpty1;
        },
        Foldable1: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$6e693a2e8188a772 = function(dictTraversableWithIndex) {
    var traverseWithIndex = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndex1 = $1f1c3fb67e79b37f$export$cdee60b0fe4303fd(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexNonEmpty1 = $1f1c3fb67e79b37f$export$9a79a74e355c28b1(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableNonEmpty1 = $1f1c3fb67e79b37f$export$dbb721137b3f0cf6(dictTraversableWithIndex.Traversable2());
    return {
        traverseWithIndex: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
            var traverseWithIndex1 = traverseWithIndex(dictApplicative);
            return function(f) {
                return function(v) {
                    return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0)))(traverseWithIndex1(function($249) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($249));
                    })(v.value1));
                };
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndex1;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexNonEmpty1;
        },
        Traversable2: function() {
            return traversableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$ca19152d833c8d01 = function(dictFoldable) {
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictFoldable);
    return {
        foldMap1: function(dictSemigroup) {
            var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
            return function(f) {
                return function(v) {
                    return foldl(function(s) {
                        return function(a1) {
                            return append1(s)(f(a1));
                        };
                    })(f(v.value0))(v.value1);
                };
            };
        },
        foldr1: function(f) {
            return function(v) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(v.value0)(f(v.value0))(foldr(function(a1) {
                    var $250 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(a1)(f(a1));
                    return function($251) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create($250($251));
                    };
                })($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value1));
            };
        },
        foldl1: function(f) {
            return function(v) {
                return foldl(f)(v.value0)(v.value1);
            };
        },
        Foldable0: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$eb5e1ef4ea2eca3d = function(dictFoldable) {
    return $086486679aa806fa$export$eb5e1ef4ea2eca3d($1f1c3fb67e79b37f$export$ca19152d833c8d01(dictFoldable));
};
var $1f1c3fb67e79b37f$export$460809894af54b0a = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        var eq11 = eq1(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq11(x.value1)(y.value1);
                };
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$ec32b9103f985218 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eqNonEmpty1 = $1f1c3fb67e79b37f$export$460809894af54b0a(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
        var compare11 = compare1(dictOrd);
        var eqNonEmpty2 = eqNonEmpty1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return compare11(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqNonEmpty2;
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$6a8b366193197b51 = function(dictEq1) {
    var eqNonEmpty1 = $1f1c3fb67e79b37f$export$460809894af54b0a(dictEq1);
    return {
        eq1: function(dictEq) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqNonEmpty1(dictEq));
        }
    };
};
var $1f1c3fb67e79b37f$export$de0dd6c052e29447 = function(dictOrd1) {
    var ordNonEmpty1 = $1f1c3fb67e79b37f$export$ec32b9103f985218(dictOrd1);
    var eq1NonEmpty1 = $1f1c3fb67e79b37f$export$6a8b366193197b51(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordNonEmpty1(dictOrd));
        },
        Eq10: function() {
            return eq1NonEmpty1;
        }
    };
};











var $78c799cba34fcb8d$var$add = /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($c0e822be92afc4df$export$7e80d6910c05bd77);
var $78c799cba34fcb8d$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $78c799cba34fcb8d$export$c1bed610ade55e1c = /* #__PURE__ */ function() {
    function Nil() {}
    Nil.value = new Nil();
    return Nil;
}();
var $78c799cba34fcb8d$export$74c44e616647f5c0 = /* #__PURE__ */ function() {
    function Cons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons.create = function(value0) {
        return function(value1) {
            return new Cons(value0, value1);
        };
    };
    return Cons;
}();
var $78c799cba34fcb8d$export$ab241a3582569781 = function(x) {
    return x;
};
var $78c799cba34fcb8d$export$effcdbd76139450 = function(v) {
    return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1);
};
var $78c799cba34fcb8d$export$e1330f0deced5836 = {
    Coercible0: function() {
        return undefined;
    }
};
var $78c799cba34fcb8d$export$4fa915e2865b1814 = function(a) {
    return function(v) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $78c799cba34fcb8d$var$listMap = function(f) {
    var chunkedRevMap = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v);
                    $copy_v1 = v1.value1.value1.value1;
                    return;
                }
                var unrolledMap = function(v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value1.value0), $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0), $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
                    return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
                };
                var reverseUnrolledMap = function($copy_v2) {
                    return function($copy_v3) {
                        var $tco_var_v2 = $copy_v2;
                        var $tco_done1 = false;
                        var $tco_result;
                        function $tco_loop(v2, v3) {
                            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v2 = v2.value1;
                                $copy_v3 = new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value1.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value1.value1.value0), v3)));
                                return;
                            }
                            $tco_done1 = true;
                            return v3;
                        }
                        while(!$tco_done1)$tco_result = $tco_loop($tco_var_v2, $copy_v3);
                        return $tco_result;
                    };
                };
                $tco_done = true;
                return reverseUnrolledMap(v)(unrolledMap(v1));
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return chunkedRevMap($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $78c799cba34fcb8d$export$40b9e4330ffd17e3 = {
    map: $78c799cba34fcb8d$var$listMap
};
var $78c799cba34fcb8d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $78c799cba34fcb8d$export$3c979cc7d75b024c = /* #__PURE__ */ $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $78c799cba34fcb8d$export$92659ee1fc91a075 = {
    foldr: function(f) {
        return function(b) {
            var rev = function() {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v;
                            }
                            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                                $copy_v1 = v1.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List.Types (line 107, column 7 - line 107, column 23): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            }();
            var $284 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075)($f57f4b701aa7b66e$export$8a83211c878a3f1f(f))(b);
            return function($285) {
                return $284(rev($285));
            };
        };
    },
    foldl: function(f) {
        var go = function($copy_b) {
            return function($copy_v) {
                var $tco_var_b = $copy_b;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(b, v) {
                    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done1 = true;
                        return b;
                    }
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        $tco_var_b = f(b)(v.value0);
                        $copy_v = v.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List.Types (line 111, column 12 - line 113, column 30): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_b, $copy_v);
                return $tco_result;
            };
        };
        return go;
    },
    foldMap: function(dictMonoid) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075)(function(acc) {
                var $286 = append2(acc);
                return function($287) {
                    return $286(f($287));
                };
            })(mempty);
        };
    }
};
var $78c799cba34fcb8d$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$var$intercalate = /* #__PURE__ */ $4fe7b6acfba7f29f$export$739ec22334c44788($78c799cba34fcb8d$export$92659ee1fc91a075)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $78c799cba34fcb8d$export$604c31769a93bbe0 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$20ebd08132411556($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$export$465bfc9894c20a50 = {
    foldrWithIndex: function(f) {
        return function(b) {
            return function(xs) {
                var v = function() {
                    var rev = $78c799cba34fcb8d$var$foldl(function(v1) {
                        return function(a) {
                            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0 + 1 | 0, new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v1.value1));
                        };
                    });
                    return rev(new $71f2e2e9476163f8$export$1908877435b1d5e9(0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value))(xs);
                }();
                return $71f2e2e9476163f8$export$6f71268a1666ab58($78c799cba34fcb8d$var$foldl(function(v1) {
                    return function(a) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0 - 1 | 0, f(v1.value0 - 1 | 0)(a)(v1.value1));
                    };
                })(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, b))(v.value1));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(acc) {
            var $288 = $78c799cba34fcb8d$var$foldl(function(v) {
                return function(a) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0 + 1 | 0, f(v.value0)(v.value1)(a));
                };
            })(new $71f2e2e9476163f8$export$1908877435b1d5e9(0, acc));
            return function($289) {
                return $71f2e2e9476163f8$export$6f71268a1666ab58($288($289));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return $519ef1967f17d101$export$2d70b9efb960f478($78c799cba34fcb8d$export$465bfc9894c20a50)(function(i) {
                return function(acc) {
                    var $290 = append2(acc);
                    var $291 = f(i);
                    return function($292) {
                        return $290($291($292));
                    };
                };
            })(mempty);
        };
    },
    Foldable0: function() {
        return $78c799cba34fcb8d$export$92659ee1fc91a075;
    }
};
var $78c799cba34fcb8d$var$foldableWithIndexNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$9a79a74e355c28b1($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$var$foldMapWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$18153bb1181268e5($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldlWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$2d70b9efb960f478($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldrWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$d859ed9adfa064ca($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldrWithIndex1 = /* #__PURE__ */ $519ef1967f17d101$export$d859ed9adfa064ca($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$var$foldlWithIndex1 = /* #__PURE__ */ $519ef1967f17d101$export$2d70b9efb960f478($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$export$181d5b43cf38a79a = {
    foldMapWithIndex: function(dictMonoid) {
        var foldMapWithIndex1 = $78c799cba34fcb8d$var$foldMapWithIndex(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMapWithIndex1(function() {
                    var $293 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($294) {
                        return f($293($294));
                    };
                }())(v);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $78c799cba34fcb8d$var$foldlWithIndex(function() {
                    var $295 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($296) {
                        return f($295($296));
                    };
                }())(b)(v);
            };
        };
    },
    foldrWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $78c799cba34fcb8d$var$foldrWithIndex(function() {
                    var $297 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($298) {
                        return f($297($298));
                    };
                }())(b)(v);
            };
        };
    },
    Foldable0: function() {
        return $78c799cba34fcb8d$export$604c31769a93bbe0;
    }
};
var $78c799cba34fcb8d$export$3951fb12c9649f2b = {
    mapWithIndex: function(f) {
        return $78c799cba34fcb8d$var$foldrWithIndex1(function(i) {
            return function(x) {
                return function(acc) {
                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(i)(x), acc);
                };
            };
        })($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$var$mapWithIndex = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50(/* #__PURE__ */ $1f1c3fb67e79b37f$export$cdee60b0fe4303fd($78c799cba34fcb8d$export$3951fb12c9649f2b));
var $78c799cba34fcb8d$export$116ff457f4ca2f6a = {
    mapWithIndex: function(fn) {
        return function(v) {
            return $78c799cba34fcb8d$var$mapWithIndex(function() {
                var $299 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                return function($300) {
                    return fn($299($300));
                };
            }())(v);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$11cb7909a85856b = {
    append: function(xs) {
        return function(ys) {
            return $78c799cba34fcb8d$var$foldr($78c799cba34fcb8d$export$74c44e616647f5c0.create)(ys)(xs);
        };
    }
};
var $78c799cba34fcb8d$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $78c799cba34fcb8d$export$14584e231e9c63ca = /* #__PURE__ */ function() {
    return {
        mempty: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        Semigroup0: function() {
            return $78c799cba34fcb8d$export$11cb7909a85856b;
        }
    };
}();
var $78c799cba34fcb8d$export$a8cfc3dfdfca72cf = {
    append: function(v) {
        return function(as$prime) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $78c799cba34fcb8d$var$append1(v.value1)($78c799cba34fcb8d$export$effcdbd76139450(as$prime)));
        };
    }
};
var $78c799cba34fcb8d$export$36831384a74c4427 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return "Nil";
            return "(" + ($78c799cba34fcb8d$var$intercalate(" : ")($78c799cba34fcb8d$var$map(show)(v)) + " : Nil)");
        }
    };
};
var $78c799cba34fcb8d$export$3a5290e21dfc0ad7 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($1f1c3fb67e79b37f$export$ffafc93d2cc87798(dictShow)($78c799cba34fcb8d$export$36831384a74c4427(dictShow)));
    return {
        show: function(v) {
            return "(NonEmptyList " + (show(v) + ")");
        }
    };
};
var $78c799cba34fcb8d$export$99c2ce29c0ead637 = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(Apply0);
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            var $301 = map1($78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            var $302 = $78c799cba34fcb8d$var$foldl(function(acc) {
                var $304 = lift2($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))(acc);
                return function($305) {
                    return $304(f($305));
                };
            })(pure1($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            return function($303) {
                return $301($302($303));
            };
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$df3f009e3d155b20($78c799cba34fcb8d$export$99c2ce29c0ead637)(dictApplicative)($78c799cba34fcb8d$var$identity);
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    },
    Foldable1: function() {
        return $78c799cba34fcb8d$export$92659ee1fc91a075;
    }
};
var $78c799cba34fcb8d$export$d0a0d45336d2d3e3 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$dbb721137b3f0cf6($78c799cba34fcb8d$export$99c2ce29c0ead637);
var $78c799cba34fcb8d$export$aed77e3b7bbfc02d = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(Apply0);
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            var rev = $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            var $306 = map1(rev);
            var $307 = $78c799cba34fcb8d$var$foldlWithIndex1(function(i) {
                return function(acc) {
                    var $309 = lift2($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))(acc);
                    var $310 = f(i);
                    return function($311) {
                        return $309($310($311));
                    };
                };
            })(pure1($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            return function($308) {
                return $306($307($308));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $78c799cba34fcb8d$export$3951fb12c9649f2b;
    },
    FoldableWithIndex1: function() {
        return $78c799cba34fcb8d$export$465bfc9894c20a50;
    },
    Traversable2: function() {
        return $78c799cba34fcb8d$export$99c2ce29c0ead637;
    }
};
var $78c799cba34fcb8d$var$traverseWithIndex = /* #__PURE__ */ $2c7a64ff78781336$export$955fdc0d24efa249(/* #__PURE__ */ $1f1c3fb67e79b37f$export$6e693a2e8188a772($78c799cba34fcb8d$export$aed77e3b7bbfc02d));
var $78c799cba34fcb8d$export$29974dc3d1d7196b = {
    traverseWithIndex: function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var traverseWithIndex1 = $78c799cba34fcb8d$var$traverseWithIndex(dictApplicative);
        return function(f) {
            return function(v) {
                return map1($78c799cba34fcb8d$export$ab241a3582569781)(traverseWithIndex1(function() {
                    var $312 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($313) {
                        return f($312($313));
                    };
                }())(v));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $78c799cba34fcb8d$export$116ff457f4ca2f6a;
    },
    FoldableWithIndex1: function() {
        return $78c799cba34fcb8d$export$181d5b43cf38a79a;
    },
    Traversable2: function() {
        return $78c799cba34fcb8d$export$d0a0d45336d2d3e3;
    }
};
var $78c799cba34fcb8d$export$c7fe2ca4bf0cb8df = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, memo);
                            return;
                        }
                        if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, memo));
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 135, column 22 - line 137, column 61): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    }
};
var $78c799cba34fcb8d$export$1d41caf0a0a6a680 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(memo);
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.value0, memo);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 142, column 22 - line 144, column 52): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    },
    Unfoldable10: function() {
        return $78c799cba34fcb8d$export$c7fe2ca4bf0cb8df;
    }
};
var $78c799cba34fcb8d$export$6907256bb4275b5b = /* #__PURE__ */ $1f1c3fb67e79b37f$export$3d29df45c3f8cf54($78c799cba34fcb8d$export$1d41caf0a0a6a680);
var $78c799cba34fcb8d$export$b16c60cd2a91c938 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$ca19152d833c8d01($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$export$44a6d15320cfc4c5 = {
    extend: function(f) {
        return function(v) {
            var go = function(a) {
                return function(v1) {
                    return {
                        val: new $78c799cba34fcb8d$export$74c44e616647f5c0(f(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, v1.acc)), v1.val),
                        acc: new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v1.acc)
                    };
                };
            };
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(v), $78c799cba34fcb8d$var$foldr(go)({
                val: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                acc: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
            })(v.value1).val);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$a2b02e086d468c06 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var go = function(a$prime) {
                    return function(v2) {
                        var acc$prime = new $78c799cba34fcb8d$export$74c44e616647f5c0(a$prime, v2.acc);
                        return {
                            val: new $78c799cba34fcb8d$export$74c44e616647f5c0(v(acc$prime), v2.val),
                            acc: acc$prime
                        };
                    };
                };
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v(v1), $78c799cba34fcb8d$var$foldr(go)({
                    val: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                    acc: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
                })(v1.value1).val);
            }
            throw new Error("Failed pattern match at Data.List.Types (line 180, column 1 - line 187, column 42): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$export$b7e705972f3b8317 = {
    eq1: function(dictEq) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        return function($copy_v2) {
                            var $tco_var_v = $copy_v;
                            var $tco_var_v1 = $copy_v1;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(v, v1, v2) {
                                if (!v2) {
                                    $tco_done = true;
                                    return false;
                                }
                                if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                    $tco_done = true;
                                    return v2;
                                }
                                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                    $tco_var_v = v.value1;
                                    $tco_var_v1 = v1.value1;
                                    $copy_v2 = v2 && eq(v1.value0)(v.value0);
                                    return;
                                }
                                $tco_done = true;
                                return false;
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                            return $tco_result;
                        };
                    };
                };
                return go(xs)(ys)(true);
            };
        };
    }
};
var $78c799cba34fcb8d$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$96fd6c73d03c9dd2($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$var$eqNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$460809894af54b0a($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$export$80901a10e94c964a = /* #__PURE__ */ $1f1c3fb67e79b37f$export$6a8b366193197b51($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$export$1ae88a7f3c5f59ef = function(dictEq) {
    return {
        eq: $78c799cba34fcb8d$var$eq1(dictEq)
    };
};
var $78c799cba34fcb8d$export$25985b0447eac39b = function(dictEq) {
    return $78c799cba34fcb8d$var$eqNonEmpty(dictEq);
};
var $78c799cba34fcb8d$export$a37dd417b96243af = {
    compare1: function(dictOrd) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                            }
                            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                            }
                            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$b023c82b48e70453.value;
                            }
                            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                var v2 = compare(v.value0)(v1.value0);
                                if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                    $tco_var_v = v.value1;
                                    $copy_v1 = v1.value1;
                                    return;
                                }
                                $tco_done = true;
                                return v2;
                            }
                            throw new Error("Failed pattern match at Data.List.Types (line 60, column 5 - line 60, column 20): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go(xs)(ys);
            };
        };
    },
    Eq10: function() {
        return $78c799cba34fcb8d$export$b7e705972f3b8317;
    }
};
var $78c799cba34fcb8d$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$693feb0c3c484b70($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$var$ordNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$ec32b9103f985218($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$export$bf20701e75931fe8 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$de0dd6c052e29447($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$export$86359cd4476084f8 = function(dictOrd) {
    var eqList1 = $78c799cba34fcb8d$export$1ae88a7f3c5f59ef(dictOrd.Eq0());
    return {
        compare: $78c799cba34fcb8d$var$compare1(dictOrd),
        Eq0: function() {
            return eqList1;
        }
    };
};
var $78c799cba34fcb8d$export$783a13ebf5a1203d = function(dictOrd) {
    return $78c799cba34fcb8d$var$ordNonEmpty(dictOrd);
};
var $78c799cba34fcb8d$export$7bc4d4de9c57db1f = {
    extract: function(v) {
        return v.value0;
    },
    Extend0: function() {
        return $78c799cba34fcb8d$export$44a6d15320cfc4c5;
    }
};
var $78c799cba34fcb8d$export$7e49f2fa1ca16fbc = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $78c799cba34fcb8d$var$append1($78c799cba34fcb8d$var$map(v.value0)(v1))($7576d3a958d66ab0$export$5635d7ef4b8fee1c($78c799cba34fcb8d$export$7e49f2fa1ca16fbc)(v.value1)(v1));
            throw new Error("Failed pattern match at Data.List.Types (line 157, column 1 - line 159, column 48): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($78c799cba34fcb8d$export$7e49f2fa1ca16fbc);
var $78c799cba34fcb8d$export$18f1a42667f2921e = {
    apply: function(v) {
        return function(v1) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0(v1.value0), $78c799cba34fcb8d$var$append1($78c799cba34fcb8d$var$apply(v.value1)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value)))($78c799cba34fcb8d$var$apply(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1))(v1.value1)));
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$497dcf96eb2383ec = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $78c799cba34fcb8d$var$append1(v1(v.value0))($70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$497dcf96eb2383ec)(v.value1)(v1));
            throw new Error("Failed pattern match at Data.List.Types (line 164, column 1 - line 166, column 37): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$7e49f2fa1ca16fbc;
    }
};
var $78c799cba34fcb8d$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$497dcf96eb2383ec);
var $78c799cba34fcb8d$export$12e3398ee6f4a417 = {
    bind: function(v) {
        return function(f) {
            var v1 = f(v.value0);
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v1.value0, $78c799cba34fcb8d$var$append1(v1.value1)($78c799cba34fcb8d$var$bind(v.value1)(function($314) {
                return $78c799cba34fcb8d$export$effcdbd76139450(f($314));
            })));
        };
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$18f1a42667f2921e;
    }
};
var $78c799cba34fcb8d$export$25cda6d3e08b28fe = {
    pure: function(a) {
        return new $78c799cba34fcb8d$export$74c44e616647f5c0(a, $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$7e49f2fa1ca16fbc;
    }
};
var $78c799cba34fcb8d$export$7c78e86b21f51881 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$25cda6d3e08b28fe;
    },
    Bind1: function() {
        return $78c799cba34fcb8d$export$497dcf96eb2383ec;
    }
};
var $78c799cba34fcb8d$export$852a754cd45a1ed = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$a8cfc3dfdfca72cf),
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$97980ce7ea95015b = {
    alt: $78c799cba34fcb8d$var$append1,
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$export$55d622505c452dcb = /* #__PURE__ */ function() {
    return {
        empty: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        Alt0: function() {
            return $78c799cba34fcb8d$export$97980ce7ea95015b;
        }
    };
}();
var $78c799cba34fcb8d$export$503ce72759d93980 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$25cda6d3e08b28fe;
    },
    Plus1: function() {
        return $78c799cba34fcb8d$export$55d622505c452dcb;
    }
};
var $78c799cba34fcb8d$export$9ea554ee3c75e458 = {
    Monad0: function() {
        return $78c799cba34fcb8d$export$7c78e86b21f51881;
    },
    Alternative1: function() {
        return $78c799cba34fcb8d$export$503ce72759d93980;
    }
};
var $78c799cba34fcb8d$export$e5d0ed5dac805e10 = {
    pure: /* #__PURE__ */ function() {
        var $315 = $1f1c3fb67e79b37f$export$439306a4dcaafbb9($78c799cba34fcb8d$export$55d622505c452dcb);
        return function($316) {
            return $78c799cba34fcb8d$export$ab241a3582569781($315($316));
        };
    }(),
    Apply0: function() {
        return $78c799cba34fcb8d$export$18f1a42667f2921e;
    }
};
var $78c799cba34fcb8d$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($78c799cba34fcb8d$export$e5d0ed5dac805e10);
var $78c799cba34fcb8d$export$f444cc7484072e62 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$e5d0ed5dac805e10;
    },
    Bind1: function() {
        return $78c799cba34fcb8d$export$12e3398ee6f4a417;
    }
};
var $78c799cba34fcb8d$export$fac1bbd0707bc766 = {
    traverse1: function(dictApply) {
        var Functor0 = dictApply.Functor0();
        var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(Functor0);
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApply);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
        return function(f) {
            return function(v) {
                return mapFlipped($78c799cba34fcb8d$var$foldl(function(acc) {
                    var $317 = lift2($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$4fa915e2865b1814))(acc);
                    return function($318) {
                        return $317(f($318));
                    };
                })(map1($78c799cba34fcb8d$var$pure)(f(v.value0)))(v.value1))(function(v1) {
                    return $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$4fa915e2865b1814))($78c799cba34fcb8d$var$pure(v1.value0))(v1.value1);
                });
            };
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$d2990bb35e0a3e00($78c799cba34fcb8d$export$fac1bbd0707bc766)(dictApply)($78c799cba34fcb8d$var$identity);
    },
    Foldable10: function() {
        return $78c799cba34fcb8d$export$b16c60cd2a91c938;
    },
    Traversable1: function() {
        return $78c799cba34fcb8d$export$d0a0d45336d2d3e3;
    }
};













var $ea3eb84de0acf574$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $ea3eb84de0acf574$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $ea3eb84de0acf574$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $ea3eb84de0acf574$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $ea3eb84de0acf574$var$abs = /* #__PURE__ */ $97937c29f879e68e$export$2335f513bbd82c6d($97937c29f879e68e$export$ff461bf68e7dd332)($d061555d3b2c84b2$export$d40e27c88e22a303);
var $ea3eb84de0acf574$export$3024f3bfb62054a3 = /* #__PURE__ */ function() {
    function Leaf() {}
    Leaf.value = new Leaf();
    return Leaf;
}();
var $ea3eb84de0acf574$export$85c928794f8d04d4 = /* #__PURE__ */ function() {
    function Node(value0, value1, value2, value3, value4, value5) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
    }
    Node.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return function(value5) {
                            return new Node(value0, value1, value2, value3, value4, value5);
                        };
                    };
                };
            };
        };
    };
    return Node;
}();
var $ea3eb84de0acf574$var$IterLeaf = /* #__PURE__ */ function() {
    function IterLeaf() {}
    IterLeaf.value = new IterLeaf();
    return IterLeaf;
}();
var $ea3eb84de0acf574$var$IterEmit = /* #__PURE__ */ function() {
    function IterEmit(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    IterEmit.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new IterEmit(value0, value1, value2);
            };
        };
    };
    return IterEmit;
}();
var $ea3eb84de0acf574$var$IterNode = /* #__PURE__ */ function() {
    function IterNode(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    IterNode.create = function(value0) {
        return function(value1) {
            return new IterNode(value0, value1);
        };
    };
    return IterNode;
}();
var $ea3eb84de0acf574$export$4546c67049b8e195 = /* #__PURE__ */ function() {
    function IterDone() {}
    IterDone.value = new IterDone();
    return IterDone;
}();
var $ea3eb84de0acf574$export$e512af67edd28ac0 = /* #__PURE__ */ function() {
    function IterNext(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    IterNext.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new IterNext(value0, value1, value2);
            };
        };
    };
    return IterNext;
}();
var $ea3eb84de0acf574$export$f836382419f64c98 = /* #__PURE__ */ function() {
    function Split(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Split.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Split(value0, value1, value2);
            };
        };
    };
    return Split;
}();
var $ea3eb84de0acf574$var$SplitLast = /* #__PURE__ */ function() {
    function SplitLast(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    SplitLast.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new SplitLast(value0, value1, value2);
            };
        };
    };
    return SplitLast;
}();
var $ea3eb84de0acf574$export$8cd737e72cfcb4cd = function(k, v, l, r) {
    if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1, 1, k, v, l, r);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + r.value0 | 0, 1 + r.value1 | 0, k, v, l, r);
        throw new Error("Failed pattern match at Data.Map.Internal (line 702, column 5 - line 706, column 39): " + [
            r.constructor.name
        ]);
    }
    if (l instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + l.value0 | 0, 1 + l.value1 | 0, k, v, l, r);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + function() {
            var $280 = l.value0 > r.value0;
            if ($280) return l.value0;
            return r.value0;
        }() | 0, (1 + l.value1 | 0) + r.value1 | 0, k, v, l, r);
        throw new Error("Failed pattern match at Data.Map.Internal (line 708, column 5 - line 712, column 68): " + [
            r.constructor.name
        ]);
    }
    throw new Error("Failed pattern match at Data.Map.Internal (line 700, column 32 - line 712, column 68): " + [
        l.constructor.name
    ]);
};
var $ea3eb84de0acf574$export$a07cd7d770cb0fb3 = /* #__PURE__ */ function() {
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f($ea3eb84de0acf574$var$IterNode.create)($ea3eb84de0acf574$var$IterLeaf.value);
}();
var $ea3eb84de0acf574$var$stepWith = function(f) {
    return function(next) {
        return function(done) {
            var go = function($copy_v) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v) {
                    if (v instanceof $ea3eb84de0acf574$var$IterLeaf) {
                        $tco_done = true;
                        return done($05149ea687d6b460$export$523c0b569236b342);
                    }
                    if (v instanceof $ea3eb84de0acf574$var$IterEmit) {
                        $tco_done = true;
                        return next(v.value0, v.value1, v.value2);
                    }
                    if (v instanceof $ea3eb84de0acf574$var$IterNode) {
                        $copy_v = f(v.value1)(v.value0);
                        return;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 940, column 8 - line 946, column 20): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_v);
                return $tco_result;
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$346677f925de839c = function(v) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return 0;
    if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value1;
    throw new Error("Failed pattern match at Data.Map.Internal (line 618, column 8 - line 620, column 24): " + [
        v.constructor.name
    ]);
};
var $ea3eb84de0acf574$export$439306a4dcaafbb9 = function(k) {
    return function(v) {
        return new $ea3eb84de0acf574$export$85c928794f8d04d4(1, 1, k, v, $ea3eb84de0acf574$export$3024f3bfb62054a3.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value);
    };
};
var $ea3eb84de0acf574$export$807b724170e609fd = /* #__PURE__ */ function() {
    var height = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return 0;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0;
        throw new Error("Failed pattern match at Data.Map.Internal (line 757, column 12 - line 759, column 26): " + [
            v.constructor.name
        ]);
    };
    var rotateLeft = function(k, v, l, rk, rv, rl, rr) {
        if (rl instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && rl.value0 > height(rr)) return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rl.value2, rl.value3, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, rl.value4), $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rk, rv, rl.value5, rr));
        return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rk, rv, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, rl), rr);
    };
    var rotateRight = function(k, v, lk, lv, ll, lr, r) {
        if (lr instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && height(ll) <= lr.value0) return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lr.value2, lr.value3, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lk, lv, ll, lr.value4), $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, lr.value5, r));
        return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lk, lv, ll, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, lr, r));
    };
    return function(k, v, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
            if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && r.value0 > 1) return rotateLeft(k, v, l, r.value2, r.value3, r.value4, r.value5);
            return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, r);
        }
        if (l instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (r.value0 > (l.value0 + 1 | 0)) return rotateLeft(k, v, l, r.value2, r.value3, r.value4, r.value5);
                if (l.value0 > (r.value0 + 1 | 0)) return rotateRight(k, v, l.value2, l.value3, l.value4, l.value5, r);
            }
            if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3 && l.value0 > 1) return rotateRight(k, v, l.value2, l.value3, l.value4, l.value5, r);
            return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, r);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 717, column 40 - line 738, column 34): " + [
            l.constructor.name
        ]);
    };
}();
var $ea3eb84de0acf574$var$$lazy_unsafeSplit = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeSplit", "Data.Map.Internal", function() {
    return function(comp, k, m) {
        if (m instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$f836382419f64c98($06733ae99ed4f534$export$bebe9059409a0d04.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value);
        if (m instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = comp(k)(m.value2);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplit(793)(comp, k, m.value4);
                return new $ea3eb84de0acf574$export$f836382419f64c98(v1.value0, v1.value1, $ea3eb84de0acf574$export$807b724170e609fd(m.value2, m.value3, v1.value2, m.value5));
            }
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplit(796)(comp, k, m.value5);
                return new $ea3eb84de0acf574$export$f836382419f64c98(v1.value0, $ea3eb84de0acf574$export$807b724170e609fd(m.value2, m.value3, m.value4, v1.value1), v1.value2);
            }
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $ea3eb84de0acf574$export$f836382419f64c98(new $06733ae99ed4f534$export$8a67b48435b5d073(m.value3), m.value4, m.value5);
            throw new Error("Failed pattern match at Data.Map.Internal (line 791, column 5 - line 799, column 30): " + [
                v.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 787, column 34 - line 799, column 30): " + [
            m.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$export$9827c6ff7b07c8a4 = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeSplit(786);
var $ea3eb84de0acf574$var$$lazy_unsafeSplitLast = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeSplitLast", "Data.Map.Internal", function() {
    return function(k, v, l, r) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$SplitLast(k, v, l);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplitLast(779)(r.value2, r.value3, r.value4, r.value5);
            return new $ea3eb84de0acf574$var$SplitLast(v1.value0, v1.value1, $ea3eb84de0acf574$export$807b724170e609fd(k, v, l, v1.value2));
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 776, column 37 - line 780, column 57): " + [
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeSplitLast = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeSplitLast(775);
var $ea3eb84de0acf574$export$76d750f4290aa12 = function(v, v1) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return v1;
    if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
        var v2 = $ea3eb84de0acf574$var$unsafeSplitLast(v.value2, v.value3, v.value4, v.value5);
        return $ea3eb84de0acf574$export$807b724170e609fd(v2.value0, v2.value1, v2.value2, v1);
    }
    throw new Error("Failed pattern match at Data.Map.Internal (line 764, column 25 - line 768, column 38): " + [
        v.constructor.name,
        v1.constructor.name
    ]);
};
var $ea3eb84de0acf574$var$$lazy_unsafeDifference = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeDifference", "Data.Map.Internal", function() {
    return function(comp, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return l;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeDifference(841)(comp, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeDifference(842)(comp, v.value2, r.value5);
            return $ea3eb84de0acf574$export$76d750f4290aa12(l$prime, r$prime);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 836, column 39 - line 843, column 33): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeDifference = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeDifference(835);
var $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeIntersectionWith", "Data.Map.Internal", function() {
    return function(comp, app, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(825)(comp, app, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(826)(comp, app, v.value2, r.value5);
            if (v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, app(v.value0.value0)(r.value3), l$prime, r$prime);
            if (v.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(l$prime, r$prime);
            throw new Error("Failed pattern match at Data.Map.Internal (line 827, column 5 - line 831, column 37): " + [
                v.value0.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 820, column 49 - line 831, column 37): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeIntersectionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(819);
var $ea3eb84de0acf574$var$$lazy_unsafeUnionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeUnionWith", "Data.Map.Internal", function() {
    return function(comp, app, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return r;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return l;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(809)(comp, app, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(810)(comp, app, v.value2, r.value5);
            if (v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, app(v.value0.value0)(r.value3), l$prime, r$prime);
            if (v.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, r.value3, l$prime, r$prime);
            throw new Error("Failed pattern match at Data.Map.Internal (line 811, column 5 - line 815, column 46): " + [
                v.value0.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 804, column 42 - line 815, column 46): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeUnionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(803);
var $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(app) {
        return function(m1) {
            return function(m2) {
                return $ea3eb84de0acf574$var$unsafeUnionWith(compare, app, m1, m2);
            };
        };
    };
};
var $ea3eb84de0acf574$export$971dd5b0dfd021b6 = function(dictOrd) {
    return $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc(dictOrd)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca);
};
var $ea3eb84de0acf574$export$722fbec263ad908a = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(f) {
        return function(k) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), v.value5);
                    if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, v.value4, go(v.value5));
                    if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        var v2 = f(v.value3);
                        if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value4, v.value5);
                        if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v2.value0, v.value4, v.value5);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 531, column 11 - line 535, column 38): " + [
                            v2.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 527, column 7 - line 535, column 38): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 524, column 8 - line 535, column 38): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$b072eafdc1d506c3 = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show2 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        var go = function(ind) {
            return function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return ind + "Leaf";
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return ind + ("[" + ($ea3eb84de0acf574$var$show(v.value0) + ("] " + (show1(v.value2) + (" => " + (show2(v.value3) + "\n")))))) + (go(ind + "    ")(v.value4) + "\n" + go(ind + "    ")(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 233, column 12 - line 238, column 34): " + [
                    v.constructor.name
                ]);
            };
        };
        return go("");
    };
};
var $ea3eb84de0acf574$export$12ebb66e272c23f3 = function() {
    return function(dictOrd) {
        var unionWith1 = $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc(dictOrd);
        return function(dictSemigroup) {
            return {
                append: unionWith1($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
            };
        };
    };
};
var $ea3eb84de0acf574$var$semigroupMap1 = /* #__PURE__ */ $ea3eb84de0acf574$export$12ebb66e272c23f3();
var $ea3eb84de0acf574$export$3e41007ebfff0e64 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        return function(m) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(compare, k, m);
            return $ea3eb84de0acf574$var$map(function(a) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, $ea3eb84de0acf574$export$76d750f4290aa12(v.value1, v.value2));
            })(v.value0);
        };
    };
};
var $ea3eb84de0acf574$export$6a0d13241802fe80 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return false;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                        $copy_v = v.value4;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                        $copy_v = v.value5;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        $tco_done = true;
                        return true;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 459, column 7 - line 462, column 19): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 456, column 8 - line 462, column 19): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$6be5ce76a5140a15 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v2 = f(v.value2)(v.value3);
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v2.value0, go(v.value4), go(v.value5));
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 661, column 7 - line 665, column 47): " + [
                    v2.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 658, column 8 - line 665, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$e70771d2e7e590a = function(dictOrd) {
    var $780 = $ea3eb84de0acf574$export$6be5ce76a5140a15(dictOrd);
    return function($781) {
        return $780($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($781));
    };
};
var $ea3eb84de0acf574$export$6c45e13560e32a55 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return go(v.value4);
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                    var v2 = go(v.value5);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
                throw new Error("Failed pattern match at Data.Map.Internal (line 295, column 7 - line 302, column 38): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 292, column 8 - line 302, column 38): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$7b26f9c4323be72 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                    var v2 = go(v.value4);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return go(v.value5);
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
                throw new Error("Failed pattern match at Data.Map.Internal (line 327, column 7 - line 333, column 42): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 324, column 8 - line 333, column 42): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$dfc7155ac0343b8 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                        $copy_v = v.value4;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                        $copy_v = v.value5;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        $tco_done = true;
                        return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value3);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 283, column 7 - line 286, column 22): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 280, column 8 - line 286, column 22): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return go;
    };
};
var $ea3eb84de0acf574$var$iterMapU = function(iter) {
    return function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return iter;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value5, iter));
            }
            if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, iter));
            return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, new $ea3eb84de0acf574$var$IterNode(v.value5, iter)));
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 973, column 17 - line 988, column 56): " + [
            v.constructor.name
        ]);
    };
};
var $ea3eb84de0acf574$export$882785ec79906152 = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapU);
var $ea3eb84de0acf574$var$stepUnfoldrUnordered = /* #__PURE__ */ function() {
    var step = function(k, v, next) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(k, v), next));
    };
    return $ea3eb84de0acf574$export$882785ec79906152(step)(function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    });
}();
var $ea3eb84de0acf574$export$4e1300b52a76ba3a = function(dictUnfoldable) {
    var $782 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)($ea3eb84de0acf574$var$stepUnfoldrUnordered);
    return function($783) {
        return $782($ea3eb84de0acf574$export$a07cd7d770cb0fb3($783));
    };
};
var $ea3eb84de0acf574$export$b60b523eeb066dbd = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$882785ec79906152(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$var$iterMapR = /* #__PURE__ */ function() {
    var go = function($copy_iter) {
        return function($copy_v) {
            var $tco_var_iter = $copy_iter;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(iter, v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return iter;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                        $copy_v = v.value4;
                        return;
                    }
                    $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, iter));
                    $copy_v = v.value5;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 963, column 13 - line 970, column 48): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_iter, $copy_v);
            return $tco_result;
        };
    };
    return go;
}();
var $ea3eb84de0acf574$export$dc5b2553d8583b72 = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapR);
var $ea3eb84de0acf574$export$cdc6b87d9fb979 = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$dc5b2553d8583b72(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$var$iterMapL = /* #__PURE__ */ function() {
    var go = function($copy_iter) {
        return function($copy_v) {
            var $tco_var_iter = $copy_iter;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(iter, v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return iter;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                        $copy_v = v.value4;
                        return;
                    }
                    $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value5, iter));
                    $copy_v = v.value4;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 951, column 13 - line 958, column 48): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_iter, $copy_v);
            return $tco_result;
        };
    };
    return go;
}();
var $ea3eb84de0acf574$export$273c44542cac8efe = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapL);
var $ea3eb84de0acf574$export$3b67892037786a5b = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$273c44542cac8efe(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$export$4719e5aa2706059f = function(dictEq) {
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEq1) {
        var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function() {
                var go = function($copy_a) {
                    return function($copy_b) {
                        var $tco_var_a = $copy_a;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(a, b) {
                            var v = $ea3eb84de0acf574$export$3b67892037786a5b(a);
                            if (v instanceof $ea3eb84de0acf574$export$e512af67edd28ac0) {
                                var v2 = $ea3eb84de0acf574$export$3b67892037786a5b(b);
                                if (v2 instanceof $ea3eb84de0acf574$export$e512af67edd28ac0 && eq1(v.value0)(v2.value0) && eq2(v.value1)(v2.value1)) {
                                    $tco_var_a = v.value2;
                                    $copy_b = v2.value2;
                                    return;
                                }
                                $tco_done = true;
                                return false;
                            }
                            if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                $tco_done = true;
                                return true;
                            }
                            throw new Error("Failed pattern match at Data.Map.Internal (line 859, column 14 - line 868, column 13): " + [
                                v.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_a, $copy_b);
                        return $tco_result;
                    };
                };
                return go;
            }()
        };
    };
};
var $ea3eb84de0acf574$export$2b627c4f0ac5579b = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMapIter1 = $ea3eb84de0acf574$export$4719e5aa2706059f(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqMapIter2 = eqMapIter1(dictOrd1.Eq0());
        return {
            compare: function() {
                var go = function($copy_a) {
                    return function($copy_b) {
                        var $tco_var_a = $copy_a;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(a, b) {
                            var v = $ea3eb84de0acf574$export$3b67892037786a5b(b);
                            var v1 = $ea3eb84de0acf574$export$3b67892037786a5b(a);
                            if (v1 instanceof $ea3eb84de0acf574$export$e512af67edd28ac0 && v instanceof $ea3eb84de0acf574$export$e512af67edd28ac0) {
                                var v3 = compare(v1.value0)(v.value0);
                                if (v3 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                    var v4 = compare1(v1.value1)(v.value1);
                                    if (v4 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                        $tco_var_a = v1.value2;
                                        $copy_b = v.value2;
                                        return;
                                    }
                                    $tco_done = true;
                                    return v4;
                                }
                                $tco_done = true;
                                return v3;
                            }
                            if (v1 instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                    $tco_done = true;
                                    return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                                }
                                $tco_done = true;
                                return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                            }
                            if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$b023c82b48e70453.value;
                            }
                            throw new Error("Failed pattern match at Data.Map.Internal (line 873, column 14 - line 891, column 11): " + [
                                v1.constructor.name,
                                v.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_a, $copy_b);
                        return $tco_result;
                    };
                };
                return go;
            }(),
            Eq0: function() {
                return eqMapIter2;
            }
        };
    };
};
var $ea3eb84de0acf574$var$stepUnfoldr = /* #__PURE__ */ function() {
    var step = function(k, v, next) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(k, v), next));
    };
    return $ea3eb84de0acf574$export$273c44542cac8efe(step)(function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    });
}();
var $ea3eb84de0acf574$export$823be24f8766da23 = function(dictUnfoldable) {
    var $784 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)($ea3eb84de0acf574$var$stepUnfoldr);
    return function($785) {
        return $784($ea3eb84de0acf574$export$a07cd7d770cb0fb3($785));
    };
};
var $ea3eb84de0acf574$var$toUnfoldable1 = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $ea3eb84de0acf574$export$c448526daa762015 = function(dictShow) {
    var showTuple = $71f2e2e9476163f8$export$c29279d1dfdefb95(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225(showTuple(dictShow1)));
        return {
            show: function(as) {
                return "(fromFoldable " + (show1($ea3eb84de0acf574$var$toUnfoldable1(as)) + ")");
            }
        };
    };
};
var $ea3eb84de0acf574$export$35d0420a84c5d3ae = function(dictOrd) {
    var lookup1 = $ea3eb84de0acf574$export$dfc7155ac0343b8(dictOrd);
    return function(dictEq) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        var go = function(m1) {
            return function(m2) {
                if (m1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                if (m1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = lookup1(m1.value2)(m2);
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return eq1(m1.value3)(v1.value0) && go(m1.value4)(m2) && go(m1.value5)(m2);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 611, column 7 - line 614, column 40): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 608, column 14 - line 614, column 40): " + [
                    m1.constructor.name
                ]);
            };
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$dd1bc94b04021eeb = function(v) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
    return false;
};
var $ea3eb84de0acf574$export$a6c74cde0675b326 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(app) {
        return function(m1) {
            return function(m2) {
                return $ea3eb84de0acf574$var$unsafeIntersectionWith(compare, app, m1, m2);
            };
        };
    };
};
var $ea3eb84de0acf574$export$bc86dfbf7795668c = function(dictOrd) {
    return $ea3eb84de0acf574$export$a6c74cde0675b326(dictOrd)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca);
};
var $ea3eb84de0acf574$export$435aa68287e449bf = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(app) {
        return function(k) {
            return function(v) {
                var go = function(v1) {
                    if (v1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
                    if (v1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                        var v2 = compare(k)(v1.value2);
                        if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, go(v1.value4), v1.value5);
                        if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, v1.value4, go(v1.value5));
                        if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v1.value0, v1.value1, k, app(v1.value3)(v), v1.value4, v1.value5);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 486, column 7 - line 489, column 44): " + [
                            v2.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 483, column 8 - line 489, column 44): " + [
                        v1.constructor.name
                    ]);
                };
                return go;
            };
        };
    };
};
var $ea3eb84de0acf574$export$21a5ca8aa77d35ff = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
                if (v1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v2 = compare(k)(v1.value2);
                    if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, go(v1.value4), v1.value5);
                    if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, v1.value4, go(v1.value5));
                    if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v1.value0, v1.value1, k, v, v1.value4, v1.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 471, column 7 - line 474, column 35): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 468, column 8 - line 474, column 35): " + [
                    v1.constructor.name
                ]);
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$3930f636962ed944 = {
    map: function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, f(v.value3), go(v.value4), go(v.value5));
            throw new Error("Failed pattern match at Data.Map.Internal (line 147, column 10 - line 150, column 39): " + [
                v.constructor.name
            ]);
        };
        return go;
    }
};
var $ea3eb84de0acf574$export$d7c684e0b3e84e77 = {
    mapWithIndex: function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, f(v.value2)(v.value3), go(v.value4), go(v.value5));
            throw new Error("Failed pattern match at Data.Map.Internal (line 155, column 10 - line 158, column 41): " + [
                v.constructor.name
            ]);
        };
        return go;
    },
    Functor0: function() {
        return $ea3eb84de0acf574$export$3930f636962ed944;
    }
};
var $ea3eb84de0acf574$export$4295a0c2ad7aa544 = {
    foldr: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(m$prime, z$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(172)(m$prime.value4, f(m$prime.value3)($lazy_go(172)(m$prime.value5, z$prime)));
                    throw new Error("Failed pattern match at Data.Map.Internal (line 169, column 26 - line 172, column 43): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(169);
            return function(m) {
                return go(m, z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(z$prime, m$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(178)(f($lazy_go(178)(z$prime, m$prime.value4))(m$prime.value3), m$prime.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 175, column 26 - line 178, column 43): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(175);
            return function(m) {
                return go(z, m);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return mempty;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return append1(go(v.value4))(append1(f(v.value3))(go(v.value5)));
                throw new Error("Failed pattern match at Data.Map.Internal (line 181, column 10 - line 184, column 28): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    }
};
var $ea3eb84de0acf574$export$91e1c50dfb7225a6 = {
    foldrWithIndex: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(m$prime, z$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(192)(m$prime.value4, f(m$prime.value2)(m$prime.value3)($lazy_go(192)(m$prime.value5, z$prime)));
                    throw new Error("Failed pattern match at Data.Map.Internal (line 189, column 26 - line 192, column 45): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(189);
            return function(m) {
                return go(m, z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(z$prime, m$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(198)(f(m$prime.value2)($lazy_go(198)(z$prime, m$prime.value4))(m$prime.value3), m$prime.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 195, column 26 - line 198, column 45): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(195);
            return function(m) {
                return go(z, m);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return mempty;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return append1(go(v.value4))(append1(f(v.value2)(v.value3))(go(v.value5)));
                throw new Error("Failed pattern match at Data.Map.Internal (line 201, column 10 - line 204, column 30): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    Foldable0: function() {
        return $ea3eb84de0acf574$export$4295a0c2ad7aa544;
    }
};
var $ea3eb84de0acf574$export$ed97f33186d4b816 = /* #__PURE__ */ function() {
    return $519ef1967f17d101$export$d859ed9adfa064ca($ea3eb84de0acf574$export$91e1c50dfb7225a6)(function(k) {
        return function(v) {
            return function(acc) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(k, acc);
            };
        };
    })($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $ea3eb84de0acf574$export$78146089411e393d = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return pure($ea3eb84de0acf574$export$3024f3bfb62054a3.value);
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return apply(apply(map1(function(l$prime) {
                    return function(v$prime) {
                        return function(r$prime) {
                            return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v$prime, l$prime, r$prime);
                        };
                    };
                })(go(v.value4)))(f(v.value3)))(go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 209, column 10 - line 215, column 19): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$df3f009e3d155b20($ea3eb84de0acf574$export$78146089411e393d)(dictApplicative)($ea3eb84de0acf574$var$identity);
    },
    Functor0: function() {
        return $ea3eb84de0acf574$export$3930f636962ed944;
    },
    Foldable1: function() {
        return $ea3eb84de0acf574$export$4295a0c2ad7aa544;
    }
};
var $ea3eb84de0acf574$export$8999febf5cd85b5c = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return pure($ea3eb84de0acf574$export$3024f3bfb62054a3.value);
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return apply(apply(map1(function(l$prime) {
                    return function(v$prime) {
                        return function(r$prime) {
                            return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v$prime, l$prime, r$prime);
                        };
                    };
                })(go(v.value4)))(f(v.value2)(v.value3)))(go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 221, column 10 - line 227, column 19): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    FunctorWithIndex0: function() {
        return $ea3eb84de0acf574$export$d7c684e0b3e84e77;
    },
    FoldableWithIndex1: function() {
        return $ea3eb84de0acf574$export$91e1c50dfb7225a6;
    },
    Traversable2: function() {
        return $ea3eb84de0acf574$export$78146089411e393d;
    }
};
var $ea3eb84de0acf574$export$68c286be0e7e55b7 = /* #__PURE__ */ function() {
    return $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($ea3eb84de0acf574$export$4295a0c2ad7aa544)($78c799cba34fcb8d$export$74c44e616647f5c0.create)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $ea3eb84de0acf574$var$foldSubmapBy = function(dictOrd) {
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    var lessThanOrEq1 = $97937c29f879e68e$export$f0c1dc893917aeba(dictOrd);
    return function(appendFn) {
        return function(memptyValue) {
            return function(kmin) {
                return function(kmax) {
                    return function(f) {
                        var tooSmall = function() {
                            if (kmin instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return lessThan1(k)(kmin.value0);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 389, column 7 - line 393, column 22): " + [
                                kmin.constructor.name
                            ]);
                        }();
                        var tooLarge = function() {
                            if (kmax instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return greaterThan1(k)(kmax.value0);
                            };
                            if (kmax instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 396, column 7 - line 400, column 22): " + [
                                kmax.constructor.name
                            ]);
                        }();
                        var inBounds = function() {
                            if (kmin instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && kmax instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return lessThanOrEq1(kmin.value0)(k) && lessThanOrEq1(k)(kmax.value0);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && kmax instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return function(k) {
                                return lessThanOrEq1(kmin.value0)(k);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && kmax instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return lessThanOrEq1(k)(kmax.value0);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && kmax instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 403, column 7 - line 411, column 21): " + [
                                kmin.constructor.name,
                                kmax.constructor.name
                            ]);
                        }();
                        var go = function(v) {
                            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return memptyValue;
                            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return appendFn(appendFn(function() {
                                var $643 = tooSmall(v.value2);
                                if ($643) return memptyValue;
                                return go(v.value4);
                            }())(function() {
                                var $644 = inBounds(v.value2);
                                if ($644) return f(v.value2)(v.value3);
                                return memptyValue;
                            }()))(function() {
                                var $645 = tooLarge(v.value2);
                                if ($645) return memptyValue;
                                return go(v.value5);
                            }());
                            throw new Error("Failed pattern match at Data.Map.Internal (line 413, column 10 - line 419, column 66): " + [
                                v.constructor.name
                            ]);
                        };
                        return go;
                    };
                };
            };
        };
    };
};
var $ea3eb84de0acf574$export$3f9a381f67a51fcd = function(dictOrd) {
    var foldSubmapBy1 = $ea3eb84de0acf574$var$foldSubmapBy(dictOrd);
    return function(dictMonoid) {
        return foldSubmapBy1($d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0()))($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid));
    };
};
var $ea3eb84de0acf574$export$3c39a95b7a4d5e28 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                $tco_done = true;
                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
            }
            $copy_v = v.value4;
            return;
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 361, column 11 - line 366, column 21): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $ea3eb84de0acf574$export$211c88c643c40f46 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                    var v2 = go(v.value4);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return go(v.value5);
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $ea3eb84de0acf574$export$3c39a95b7a4d5e28(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 342, column 7 - line 348, column 25): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 339, column 8 - line 348, column 25): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$35f577b3da447d17 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                $tco_done = true;
                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
            }
            $copy_v = v.value5;
            return;
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 352, column 11 - line 357, column 21): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $ea3eb84de0acf574$export$9318a1f920537b0d = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return go(v.value4);
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                    var v2 = go(v.value5);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $ea3eb84de0acf574$export$35f577b3da447d17(v.value4);
                throw new Error("Failed pattern match at Data.Map.Internal (line 311, column 7 - line 318, column 21): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 308, column 8 - line 318, column 21): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$d7a60370122a9ab0 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (f(v.value2)(v.value3)) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), go(v.value5));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 627, column 8 - line 633, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$151f9a87a7fd5652 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (f(v.value2)) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), go(v.value5));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 640, column 8 - line 646, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$3dea766d36a8935f = function(dictOrd) {
    var $786 = $ea3eb84de0acf574$export$d7a60370122a9ab0(dictOrd);
    return function($787) {
        return $786($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($787));
    };
};
var $ea3eb84de0acf574$export$85aac4508ff70b8 = function(dictEq) {
    var eqMapIter1 = $ea3eb84de0acf574$export$4719e5aa2706059f(dictEq);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(eqMapIter1(dictEq1));
        return {
            eq: function(xs) {
                return function(ys) {
                    if (xs instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                        return false;
                    }
                    if (xs instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                        if (ys instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && xs.value1 === ys.value1) return eq1($ea3eb84de0acf574$export$a07cd7d770cb0fb3(xs))($ea3eb84de0acf574$export$a07cd7d770cb0fb3(ys));
                        return false;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 94, column 14 - line 105, column 16): " + [
                        xs.constructor.name
                    ]);
                };
            }
        };
    };
};
var $ea3eb84de0acf574$export$3d0d4caf881d6855 = function(dictOrd) {
    var ordMapIter1 = $ea3eb84de0acf574$export$2b627c4f0ac5579b(dictOrd);
    var eqMap1 = $ea3eb84de0acf574$export$85aac4508ff70b8(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(ordMapIter1(dictOrd1));
        var eqMap2 = eqMap1(dictOrd1.Eq0());
        return {
            compare: function(xs) {
                return function(ys) {
                    if (xs instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                        return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    }
                    if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return compare($ea3eb84de0acf574$export$a07cd7d770cb0fb3(xs))($ea3eb84de0acf574$export$a07cd7d770cb0fb3(ys));
                };
            },
            Eq0: function() {
                return eqMap2;
            }
        };
    };
};
var $ea3eb84de0acf574$export$e321b34a2787dc8d = function(dictEq) {
    var eqMap1 = $ea3eb84de0acf574$export$85aac4508ff70b8(dictEq);
    return {
        eq1: function(dictEq1) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqMap1(dictEq1));
        }
    };
};
var $ea3eb84de0acf574$export$e2f3c1862bab1bff = function(dictOrd) {
    var ordMap1 = $ea3eb84de0acf574$export$3d0d4caf881d6855(dictOrd);
    var eq1Map1 = $ea3eb84de0acf574$export$e321b34a2787dc8d(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordMap1(dictOrd1));
        },
        Eq10: function() {
            return eq1Map1;
        }
    };
};
var $ea3eb84de0acf574$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
}();
var $ea3eb84de0acf574$export$b7d5d9bb9ff52072 = function(dictOrd) {
    var insert1 = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable)(function(m) {
            return function(v) {
                return insert1(v.value0)(v.value1)(m);
            };
        })($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$690be49d504fc7f = function(dictOrd) {
    var insertWith1 = $ea3eb84de0acf574$export$435aa68287e449bf(dictOrd);
    return function(dictFoldable) {
        var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
        return function(f) {
            var f$prime = insertWith1($f57f4b701aa7b66e$export$8a83211c878a3f1f(f));
            return foldl(function(m) {
                return function(v) {
                    return f$prime(v.value0)(v.value1)(m);
                };
            })($ea3eb84de0acf574$export$6e22c362a0406a2c);
        };
    };
};
var $ea3eb84de0acf574$export$78cfe3464e7eb77b = function(dictOrd) {
    var insert1 = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(dictFoldableWithIndex) {
        return $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex)(function(k) {
            return function(m) {
                return function(v) {
                    return insert1(k)(v)(m);
                };
            };
        })($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$546d2468bc9efbc6 = function() {
    return function(dictOrd) {
        var semigroupMap2 = $ea3eb84de0acf574$var$semigroupMap1(dictOrd);
        return function(dictSemigroup) {
            var semigroupMap3 = semigroupMap2(dictSemigroup);
            return {
                mempty: $ea3eb84de0acf574$export$6e22c362a0406a2c,
                Semigroup0: function() {
                    return semigroupMap3;
                }
            };
        };
    };
};
var $ea3eb84de0acf574$export$d6b4f308683e59db = function(dictOrd) {
    var foldSubmapBy1 = $ea3eb84de0acf574$var$foldSubmapBy(dictOrd);
    var union1 = $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd);
    return function(kmin) {
        return function(kmax) {
            return foldSubmapBy1(union1)($ea3eb84de0acf574$export$6e22c362a0406a2c)(kmin)(kmax)($ea3eb84de0acf574$export$439306a4dcaafbb9);
        };
    };
};
var $ea3eb84de0acf574$export$30b2db2f7030f6cf = function(dictOrd) {
    var union1 = $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable)(union1)($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$acaf96a27438246b = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(m1) {
        return function(m2) {
            return $ea3eb84de0acf574$var$unsafeDifference(compare, m1, m2);
        };
    };
};
var $ea3eb84de0acf574$export$1822828d790e23ee = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), v.value5);
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, v.value4, go(v.value5));
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value4, v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 498, column 7 - line 501, column 43): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 495, column 8 - line 501, column 43): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$6583e3e95cb5e9d1 = function(dictOrd) {
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                if (v.value5 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0 === 2 && v.value5.value0 === 1 && v.value1 > v.value5.value1 && greaterThan1(v.value5.value2)(v.value2) && go(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 264, column 11 - line 268, column 60): " + [
                    v.value5.constructor.name
                ]);
            }
            if (v.value4 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return v.value0 === 2 && v.value4.value0 === 1 && v.value1 > v.value4.value1 && lessThan1(v.value4.value2)(v.value2) && go(v.value4);
                if (v.value5 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0 > v.value5.value0 && greaterThan1(v.value5.value2)(v.value2) && v.value0 > v.value4.value0 && lessThan1(v.value4.value2)(v.value2) && $ea3eb84de0acf574$var$abs(v.value5.value0 - v.value4.value0 | 0) < 2 && ((v.value5.value1 + v.value4.value1 | 0) + 1 | 0) === v.value1 && go(v.value4) && go(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 270, column 11 - line 274, column 108): " + [
                    v.value5.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 262, column 7 - line 274, column 108): " + [
                v.value4.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 259, column 8 - line 274, column 108): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$986c2bbe7a34be0b = function(dictOrd) {
    return $ea3eb84de0acf574$export$e70771d2e7e590a(dictOrd)($ea3eb84de0acf574$var$identity);
};
var $ea3eb84de0acf574$export$8952a3dc6f3cd264 = function(dictOrd) {
    return {
        apply: $ea3eb84de0acf574$export$a6c74cde0675b326(dictOrd)($ea3eb84de0acf574$var$identity),
        Functor0: function() {
            return $ea3eb84de0acf574$export$3930f636962ed944;
        }
    };
};
var $ea3eb84de0acf574$export$886591aa0ffe34d5 = function(dictOrd) {
    var mapMaybeWithKey1 = $ea3eb84de0acf574$export$6be5ce76a5140a15(dictOrd);
    var lookup1 = $ea3eb84de0acf574$export$dfc7155ac0343b8(dictOrd);
    var applyMap1 = $ea3eb84de0acf574$export$8952a3dc6f3cd264(dictOrd);
    return {
        bind: function(m) {
            return function(f) {
                return mapMaybeWithKey1(function(k) {
                    var $788 = lookup1(k);
                    return function($789) {
                        return $788(f($789));
                    };
                })(m);
            };
        },
        Apply0: function() {
            return applyMap1;
        }
    };
};
var $ea3eb84de0acf574$export$2fa1dac9e337f670 = function(predicate) {
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return false;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return predicate(v.value2)(v.value3) || go(v.value4) || go(v.value5);
        throw new Error("Failed pattern match at Data.Map.Internal (line 693, column 8 - line 695, column 62): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$4154a199d7d90455 = function(predicate) {
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return false;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return predicate(v.value3) || go(v.value4) || go(v.value5);
        throw new Error("Failed pattern match at Data.Map.Internal (line 683, column 8 - line 685, column 58): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$22a7378e1d3307a4 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(f) {
        return function(k) {
            return function(m) {
                var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(compare, k, m);
                var v2 = f(v.value0);
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value1, v.value2);
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(k, v2.value0, v.value1, v.value2);
                throw new Error("Failed pattern match at Data.Map.Internal (line 514, column 3 - line 518, column 41): " + [
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $ea3eb84de0acf574$export$9030392ec4d635ff = function(dictOrd) {
    return {
        alt: $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd),
        Functor0: function() {
            return $ea3eb84de0acf574$export$3930f636962ed944;
        }
    };
};
var $ea3eb84de0acf574$export$4c085c510196daa3 = function(dictOrd) {
    var altMap1 = $ea3eb84de0acf574$export$9030392ec4d635ff(dictOrd);
    return {
        empty: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        Alt0: function() {
            return altMap1;
        }
    };
};




// Generated by purs version 0.15.15




// Generated by purs version 0.15.15






var $a182b6558031f5ad$export$4a45329c69499f95 = {
    ginverse: function(v) {
        return $05149ea687d6b460$export$523c0b569236b342;
    },
    Monoid0: function() {
        return $784e1bd3d26d71da$export$852b4040eee6c6ba;
    }
};
var $a182b6558031f5ad$export$1aa0e22b9fb124c = function(dictRing) {
    var negate1 = $d061555d3b2c84b2$export$aef51622e549b8b0(dictRing);
    var monoidAdditive = $e48f2e41a907ae60$export$c38b62d29991685f(dictRing.Semiring0());
    return {
        ginverse: function(v) {
            return negate1(v);
        },
        Monoid0: function() {
            return monoidAdditive;
        }
    };
};
var $a182b6558031f5ad$export$12149c92514829ba = function(dict) {
    return dict.ginverse;
};
var $a182b6558031f5ad$export$6dae20debcc1cd7b = function(dictGroup) {
    var ginverse1 = $a182b6558031f5ad$export$12149c92514829ba(dictGroup);
    var monoidDual = $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb(dictGroup.Monoid0());
    return {
        ginverse: function(v) {
            return ginverse1(v);
        },
        Monoid0: function() {
            return monoidDual;
        }
    };
};
var $a182b6558031f5ad$export$836601bcef5ff40 = function(dictGroup) {
    var power1 = $784e1bd3d26d71da$export$836601bcef5ff40(dictGroup.Monoid0());
    var ginverse1 = $a182b6558031f5ad$export$12149c92514829ba(dictGroup);
    return function(x) {
        return function(p) {
            if (p < 0) return power1(ginverse1(x))(-p | 0);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return power1(x)(p);
            throw new Error("Failed pattern match at Data.Group (line 32, column 1 - line 32, column 44): " + [
                x.constructor.name,
                p.constructor.name
            ]);
        };
    };
};






var $6416bd93bb20ed95$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $6416bd93bb20ed95$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $6416bd93bb20ed95$export$95336129f5fbe484 = function(x) {
    return x;
};
var $6416bd93bb20ed95$export$c1b2492af38232af = function(x) {
    return x;
};
var $6416bd93bb20ed95$export$cddf5df7d4d146c7 = function(dictOrd) {
    return dictOrd;
};
var $6416bd93bb20ed95$export$93c8686a38193a7e = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $6416bd93bb20ed95$export$c62767305c1e4ce1 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $6416bd93bb20ed95$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6416bd93bb20ed95$export$c62767305c1e4ce1);
var $6416bd93bb20ed95$export$5146a69d60451857 = function(dictEq) {
    return dictEq;
};
var $6416bd93bb20ed95$export$5e8a405a4cc62f32 = function(dictArbitrary) {
    return dictArbitrary;
};
var $6416bd93bb20ed95$export$e6712f693a3dc80a = function(dict) {
    return dict.writeImplPitch;
};
var $6416bd93bb20ed95$export$7bbb47c611731aa9 = function(dictWriteForeignPitch) {
    var writeImplPitch1 = $6416bd93bb20ed95$export$e6712f693a3dc80a(dictWriteForeignPitch);
    return {
        writeImpl: function(v) {
            return writeImplPitch1(v);
        }
    };
};
var $6416bd93bb20ed95$export$dcec75d6885620c1 = function(dictInterval) {
    return $784e1bd3d26d71da$export$9a7d64bc1d75357(dictInterval.Group0().Monoid0());
};
var $6416bd93bb20ed95$export$4511a00cc239a94f = function(dictInterval) {
    return $6416bd93bb20ed95$export$95336129f5fbe484;
};
var $6416bd93bb20ed95$export$ef3437da57babbe6 = function(dict) {
    return dict.toMidiPitch;
};
var $6416bd93bb20ed95$export$848eea871efc49c0 = function(dictToMidiPitch) {
    var toMidiPitch2 = $6416bd93bb20ed95$export$ef3437da57babbe6(dictToMidiPitch);
    return {
        toMidi: function(v) {
            return toMidiPitch2(v);
        }
    };
};
var $6416bd93bb20ed95$export$2a741832e0386ba = function(dict) {
    return dict.toMidi;
};
var $6416bd93bb20ed95$export$3e31139b4513adf3 = function(dictInterval) {
    return function(v) {
        return v;
    };
};
var $6416bd93bb20ed95$export$969c4443b8e8cfd7 = function(dict) {
    return dict.showPitchNotation;
};
var $6416bd93bb20ed95$export$26082705e1e7e214 = function(dictNotationPitch) {
    var showPitchNotation1 = $6416bd93bb20ed95$export$969c4443b8e8cfd7(dictNotationPitch);
    return {
        show: function(v) {
            return showPitchNotation1(v);
        }
    };
};
var $6416bd93bb20ed95$export$8331a0df97365f6e = function(dict) {
    return dict.showNotation;
};
var $6416bd93bb20ed95$export$215751f3d8d8c78b = function(dict) {
    return dict.readImplPitch;
};
var $6416bd93bb20ed95$export$ccd4e2e09b82875e = function(dictReadForeignPitch) {
    var readImplPitch1 = $6416bd93bb20ed95$export$215751f3d8d8c78b(dictReadForeignPitch);
    return {
        readImpl: function(f) {
            return readImplPitch1(f);
        }
    };
};
var $6416bd93bb20ed95$export$c82d2a67a8683548 = function(dictInterval) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictInterval.Group0().Monoid0().Semigroup0());
    return function(v) {
        return function(b) {
            return append(v)(b);
        };
    };
};
var $6416bd93bb20ed95$export$c43a5861e0a6873b = function(dict) {
    return dict.parsePitchNotation;
};
var $6416bd93bb20ed95$export$9856c32cde0cc9aa = function(dictNotationPitch) {
    var showPitchNotation1 = $6416bd93bb20ed95$export$969c4443b8e8cfd7(dictNotationPitch);
    return {
        parseNotation: function() {
            var $163 = $6416bd93bb20ed95$var$map($6416bd93bb20ed95$export$95336129f5fbe484);
            var $164 = $6416bd93bb20ed95$export$c43a5861e0a6873b(dictNotationPitch);
            return function($165) {
                return $163($164($165));
            };
        }(),
        showNotation: function(v) {
            return showPitchNotation1(v);
        }
    };
};
var $6416bd93bb20ed95$export$a1d30b4ebfb67400 = function(dict) {
    return dict.parseNotation;
};
var $6416bd93bb20ed95$export$b50136c97e7d5ebf = function(dict) {
    return dict.octave;
};
var $6416bd93bb20ed95$export$c7133ab33cb183d1 = function(dictInterval) {
    var unison1 = $6416bd93bb20ed95$export$dcec75d6885620c1(dictInterval);
    return function(v) {
        return v(unison1);
    };
};
var $6416bd93bb20ed95$export$8819cf204dded793 = function(dictInterval) {
    return $a182b6558031f5ad$export$836601bcef5ff40(dictInterval.Group0());
};
var $6416bd93bb20ed95$export$bf232e73a61825f9 = function(dictInterval) {
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f($6416bd93bb20ed95$export$8819cf204dded793(dictInterval));
};
var $6416bd93bb20ed95$export$21684750287da054 = function(dict) {
    return dict.isStep;
};
var $6416bd93bb20ed95$export$7048bac07e3baeab = function(dictInterval) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictInterval.Group0().Monoid0().Semigroup0());
    return function(a) {
        return function(v) {
            return append(a)(v);
        };
    };
};
var $6416bd93bb20ed95$export$cf1170e077367751 = function(dictInterval) {
    return $d7bf9817a417d4ae$export$10d8903dec122b9d(dictInterval.Group0().Monoid0().Semigroup0());
};
var $6416bd93bb20ed95$export$31770fd800a3b4bd = function(dict) {
    return dict.ic;
};
var $6416bd93bb20ed95$export$42889321af78fdd7 = function(dictHasIntervalClass) {
    return $6416bd93bb20ed95$var$map1($6416bd93bb20ed95$export$31770fd800a3b4bd(dictHasIntervalClass));
};
var $6416bd93bb20ed95$export$80fb9f4796c202a6 = function(dict) {
    return dict.emb;
};
var $6416bd93bb20ed95$export$8d9f5ae1af806929 = function(dictHasInterval) {
    var Interval0 = dictHasInterval.Interval0();
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(Interval0.Group0().Monoid0().Semigroup0());
    var emb1 = $6416bd93bb20ed95$export$80fb9f4796c202a6(dictHasInterval);
    var itimes1 = $6416bd93bb20ed95$export$8819cf204dded793(Interval0);
    var octave1 = $6416bd93bb20ed95$export$b50136c97e7d5ebf(Interval0);
    return function(octs) {
        return function(ic1) {
            return append(emb1(ic1))(itimes1(octave1)(octs));
        };
    };
};
var $6416bd93bb20ed95$export$5df884bdba3ad6a1 = function(dictInterval) {
    return $a182b6558031f5ad$export$12149c92514829ba(dictInterval.Group0());
};
var $6416bd93bb20ed95$export$21ada29389cb5cc6 = function(dictInterval) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictInterval.Group0().Monoid0().Semigroup0());
    var down1 = $6416bd93bb20ed95$export$5df884bdba3ad6a1(dictInterval);
    return function(a) {
        return function(b) {
            return append(a)(down1(b));
        };
    };
};
var $6416bd93bb20ed95$export$157960cc0d21b9c = function(dictInterval) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictInterval.Group0().Monoid0().Semigroup0());
    var down1 = $6416bd93bb20ed95$export$5df884bdba3ad6a1(dictInterval);
    return function(v) {
        return function(v1) {
            return append(v)(down1(v1));
        };
    };
};
var $6416bd93bb20ed95$export$acd26265934326d6 = function(dictInterval) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictInterval.Group0().Monoid0().Semigroup0());
    var down1 = $6416bd93bb20ed95$export$5df884bdba3ad6a1(dictInterval);
    return function(v) {
        return function(b) {
            return append(v)(down1(b));
        };
    };
};
var $6416bd93bb20ed95$export$fade3c794551cc08 = function(dictInterval) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictInterval.Group0().Monoid0().Semigroup0());
    var down1 = $6416bd93bb20ed95$export$5df884bdba3ad6a1(dictInterval);
    return function(v) {
        return function(v1) {
            return append(v1)(down1(v));
        };
    };
};
var $6416bd93bb20ed95$export$9fddb9d0dd7d8a54 = function(dict) {
    return dict.direction;
};
var $6416bd93bb20ed95$export$32d79d7074ad12f8 = function(dictInterval) {
    var direction1 = $6416bd93bb20ed95$export$9fddb9d0dd7d8a54(dictInterval);
    var down1 = $6416bd93bb20ed95$export$5df884bdba3ad6a1(dictInterval);
    return function(i) {
        if ($6416bd93bb20ed95$var$eq(direction1(i))($5026be88823ef1f4$export$7158f0ceb70f54c7.value)) return down1(i);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return i;
        throw new Error("Failed pattern match at Data.Pitches.Class (line 168, column 1 - line 168, column 39): " + [
            i.constructor.name
        ]);
    };
};
var $6416bd93bb20ed95$export$27ad0bd72d3a7fb = function(dict) {
    return dict.chromaticSemitone;
};
var $6416bd93bb20ed95$export$c96e90b4bcb7d4ca = function(dictChromatic) {
    var iminus1 = $6416bd93bb20ed95$export$21ada29389cb5cc6(dictChromatic.Interval0());
    var chromaticSemitone1 = $6416bd93bb20ed95$export$27ad0bd72d3a7fb(dictChromatic);
    return function(v) {
        return iminus1(v)(chromaticSemitone1);
    };
};
var $6416bd93bb20ed95$export$b65c007c1e3a96bd = function(dictChromatic) {
    var chromaticSemitone1 = $6416bd93bb20ed95$export$27ad0bd72d3a7fb(dictChromatic);
    return function(v) {
        return v(chromaticSemitone1);
    };
};
var $6416bd93bb20ed95$export$fa0afabb4c4452e5 = function(dictChromatic) {
    var iplus1 = $6416bd93bb20ed95$export$cf1170e077367751(dictChromatic.Interval0());
    var chromaticSemitone1 = $6416bd93bb20ed95$export$27ad0bd72d3a7fb(dictChromatic);
    return function(v) {
        return iplus1(v)(chromaticSemitone1);
    };
};


// Generated by purs version 0.15.15





// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
function $1cf1b1293ed20ecf$export$d90166409dd04e85(c) {
    return c.charCodeAt(0);
}
function $1cf1b1293ed20ecf$export$30216c0101da0ee0(c) {
    return String.fromCharCode(c);
}


// Generated by purs version 0.15.15






var $f1992c51575cdea6$export$864d727b48066337 = function(dictAlternative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictAlternative.Plus1());
    return function(v) {
        if (v) return pure($05149ea687d6b460$export$523c0b569236b342);
        if (!v) return empty;
        throw new Error("Failed pattern match at Control.Alternative (line 48, column 1 - line 48, column 54): " + [
            v.constructor.name
        ]);
    };
};
var $f1992c51575cdea6$export$5e87c78e215371ee = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e;
    },
    Plus1: function() {
        return $7abe8fbe97ebda87$export$b7c99dd4fc96d90e;
    }
};


















var $f935a9866e211c00$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($7576d3a958d66ab0$export$2f68caa5c730775d);
var $f935a9866e211c00$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $f935a9866e211c00$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $f935a9866e211c00$var$top = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $f935a9866e211c00$var$bottom = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $f935a9866e211c00$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $f935a9866e211c00$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $f935a9866e211c00$var$guard = /* #__PURE__ */ $f1992c51575cdea6$export$864d727b48066337($06733ae99ed4f534$export$92d23d3d8fa78a80);
var $f935a9866e211c00$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $f935a9866e211c00$var$bottom1 = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79);
var $f935a9866e211c00$var$top1 = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79);
var $f935a9866e211c00$export$a3fdfde49d86b899 = function(x) {
    return x;
};
var $f935a9866e211c00$export$45328c01562fb205 = function(dict) {
    return dict.toEnum;
};
var $f935a9866e211c00$export$61d85e1612867711 = function(dict) {
    return dict.succ;
};
var $f935a9866e211c00$export$f55455e25c350f35 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    return function(dictUnfoldable1) {
        return $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1)($f935a9866e211c00$var$apply($71f2e2e9476163f8$export$1908877435b1d5e9.create)(succ1));
    };
};
var $f935a9866e211c00$export$3d0bc2efe492e4f7 = {
    show: function(v) {
        return "(Cardinality " + ($f935a9866e211c00$var$show(v) + ")");
    }
};
var $f935a9866e211c00$export$c238ae40a8cccc17 = function(dict) {
    return dict.pred;
};
var $f935a9866e211c00$export$68d5f1a472f8251a = $97937c29f879e68e$export$ff461bf68e7dd332;
var $f935a9866e211c00$export$d3d8047a35329ac2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $f935a9866e211c00$export$b385cb642735011f = function(dict) {
    return dict.fromEnum;
};
var $f935a9866e211c00$export$1e2c188a485bdeae = function(dictBoundedEnum) {
    var toEnum1 = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
    var fromEnum1 = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBoundedEnum.Bounded0());
    return function(low) {
        return function(high) {
            return function(x) {
                var v = toEnum1(x);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    var $140 = x < fromEnum1(bottom2);
                    if ($140) return low;
                    return high;
                }
                throw new Error("Failed pattern match at Data.Enum (line 158, column 33 - line 160, column 62): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $f935a9866e211c00$export$63b732e1f89f043e = $37b880af5f4991bd$export$e65788c6d4494539;
var $f935a9866e211c00$export$c0a99362196d7617 = /* #__PURE__ */ function() {
    return {
        succ: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value),
        pred: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value),
        Ord0: function() {
            return $97937c29f879e68e$export$f6b429625e3530b0;
        }
    };
}();
var $f935a9866e211c00$export$51ea709069e9f759 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var ordTuple = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictEnum.Ord0());
    return function(dictBoundedEnum) {
        var Bounded0 = dictBoundedEnum.Bounded0();
        var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(Bounded0);
        var Enum1 = dictBoundedEnum.Enum1();
        var succ2 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
        var top2 = $69d0e3dbb12088d2$export$1e95b668f3b82d(Bounded0);
        var pred2 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
        var ordTuple1 = ordTuple(Enum1.Ord0());
        return {
            succ: function(v) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($f935a9866e211c00$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)(bottom2))(succ1(v.value0)))(function() {
                    var $183 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0);
                    return function($184) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create($183($184));
                    };
                }())(succ2(v.value1));
            },
            pred: function(v) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($f935a9866e211c00$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)(top2))(pred1(v.value0)))(function() {
                    var $185 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0);
                    return function($186) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create($185($186));
                    };
                }())(pred2(v.value1));
            },
            Ord0: function() {
                return ordTuple1;
            }
        };
    };
};
var $f935a9866e211c00$export$94be50e509bf721a = {
    succ: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$b023c82b48e70453.value);
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Enum (line 72, column 1 - line 78, column 20): " + [
            v.constructor.name
        ]);
    },
    pred: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        throw new Error("Failed pattern match at Data.Enum (line 72, column 1 - line 78, column 20): " + [
            v.constructor.name
        ]);
    },
    Ord0: function() {
        return $97937c29f879e68e$export$dcb5533042a37f3c;
    }
};
var $f935a9866e211c00$export$4d9047d2b06c2498 = function(dictBoundedEnum) {
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBoundedEnum.Bounded0());
    var Enum1 = dictBoundedEnum.Enum1();
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
    var ordMaybe = $06733ae99ed4f534$export$e35c29f98d259c46(Enum1.Ord0());
    return {
        succ: function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $06733ae99ed4f534$export$8a67b48435b5d073(bottom2));
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $f935a9866e211c00$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)(succ1(v.value0));
            throw new Error("Failed pattern match at Data.Enum (line 80, column 1 - line 84, column 32): " + [
                v.constructor.name
            ]);
        },
        pred: function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(pred1(v.value0));
            throw new Error("Failed pattern match at Data.Enum (line 80, column 1 - line 84, column 32): " + [
                v.constructor.name
            ]);
        },
        Ord0: function() {
            return ordMaybe;
        }
    };
};
var $f935a9866e211c00$export$f8cd1ff55b5d915b = {
    succ: function(n) {
        var $153 = n < $f935a9866e211c00$var$top;
        if ($153) return new $06733ae99ed4f534$export$8a67b48435b5d073(n + 1 | 0);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    pred: function(n) {
        var $154 = n > $f935a9866e211c00$var$bottom;
        if ($154) return new $06733ae99ed4f534$export$8a67b48435b5d073(n - 1 | 0);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    Ord0: function() {
        return $97937c29f879e68e$export$ff461bf68e7dd332;
    }
};
var $f935a9866e211c00$export$51bf4ec4e9fd2fba = function(dictEnum) {
    var Ord0 = dictEnum.Ord0();
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(Ord0.Eq0());
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(Ord0);
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    var lessThanOrEq1 = $97937c29f879e68e$export$f0c1dc893917aeba(Ord0);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var greaterThanOrEq1 = $97937c29f879e68e$export$4be320a4fd1ac499(Ord0);
    return function(dictUnfoldable1) {
        var singleton = $cf5af1199a495394$export$439306a4dcaafbb9(dictUnfoldable1);
        var unfoldr1 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
        var go = function(step) {
            return function(op) {
                return function(to) {
                    return function(a) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, $f935a9866e211c00$var$bind(step(a))(function(a$prime) {
                            return $f935a9866e211c00$var$voidLeft($f935a9866e211c00$var$guard(op(a$prime)(to)))(a$prime);
                        }));
                    };
                };
            };
        };
        return function(v) {
            return function(v1) {
                if (eq1(v)(v1)) return singleton(v);
                if (lessThan1(v)(v1)) return unfoldr1(go(succ1)(lessThanOrEq1)(v1))(v);
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return unfoldr1(go(pred1)(greaterThanOrEq1)(v1))(v);
                throw new Error("Failed pattern match at Data.Enum (line 186, column 14 - line 190, column 51): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    };
};
var $f935a9866e211c00$export$c023000aca534be0 = function(dictUnfoldable) {
    var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(dictFunctor) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictBoundedEnum) {
            var fromEnum1 = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
            var toEnum1 = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
            var go = function(step) {
                return function(to) {
                    return function(e) {
                        if (e <= to) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(e, e + step | 0));
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        throw new Error("Failed pattern match at Data.Enum (line 217, column 5 - line 219, column 28): " + [
                            step.constructor.name,
                            to.constructor.name,
                            e.constructor.name
                        ]);
                    };
                };
            };
            return function(a) {
                return function(b) {
                    return function(c) {
                        var c$prime = fromEnum1(c);
                        var b$prime = fromEnum1(b);
                        var a$prime = fromEnum1(a);
                        return map1(function($187) {
                            return $f935a9866e211c00$var$fromJust(toEnum1($187));
                        })(unfoldr(go(b$prime - a$prime | 0)(c$prime))(a$prime));
                    };
                };
            };
        };
    };
};
var $f935a9866e211c00$export$3733bec825dc17c = function(dictBoundedEnum) {
    var Enum1 = dictBoundedEnum.Enum1();
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
    var top2 = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBoundedEnum.Bounded0());
    var ordEither = $7d4cccdf062a2261$export$f105364bfbaa033b(Enum1.Ord0());
    return function(dictBoundedEnum1) {
        var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBoundedEnum1.Bounded0());
        var Enum11 = dictBoundedEnum1.Enum1();
        var succ2 = $f935a9866e211c00$export$61d85e1612867711(Enum11);
        var pred2 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum11);
        var ordEither1 = ordEither(Enum11.Ord0());
        return {
            succ: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $06733ae99ed4f534$export$8a67b48435b5d073(new $7d4cccdf062a2261$export$19db0165690c701a(bottom2)))(function($188) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$37c4d04eafdc5515.create($188));
                })(succ1(v.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(function($189) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$19db0165690c701a.create($189));
                })(succ2(v.value0));
                throw new Error("Failed pattern match at Data.Enum (line 86, column 1 - line 90, column 69): " + [
                    v.constructor.name
                ]);
            },
            pred: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(function($190) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$37c4d04eafdc5515.create($190));
                })(pred1(v.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $06733ae99ed4f534$export$8a67b48435b5d073(new $7d4cccdf062a2261$export$37c4d04eafdc5515(top2)))(function($191) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$19db0165690c701a.create($191));
                })(pred2(v.value0));
                throw new Error("Failed pattern match at Data.Enum (line 86, column 1 - line 90, column 69): " + [
                    v.constructor.name
                ]);
            },
            Ord0: function() {
                return ordEither1;
            }
        };
    };
};
var $f935a9866e211c00$export$6670eb63482acbe8 = {
    succ: function(v) {
        if (!v) return new $06733ae99ed4f534$export$8a67b48435b5d073(true);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    pred: function(v) {
        if (v) return new $06733ae99ed4f534$export$8a67b48435b5d073(false);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    Ord0: function() {
        return $97937c29f879e68e$export$ef759d57a4e44836;
    }
};
var $f935a9866e211c00$export$ab0f40ba1313e2bb = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    return function(dictUnfoldable1) {
        return $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1)($f935a9866e211c00$var$apply($71f2e2e9476163f8$export$1908877435b1d5e9.create)(pred1));
    };
};
var $f935a9866e211c00$var$diag = function(a) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, a);
};
var $f935a9866e211c00$export$c0c53cc9a0565905 = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    return function(dictUnfoldable) {
        return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function() {
            var $192 = $f935a9866e211c00$var$map($f935a9866e211c00$var$diag);
            return function($193) {
                return $192(pred1($193));
            };
        }());
    };
};
var $f935a9866e211c00$export$556edd6c9fb1e655 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    return function(dictUnfoldable) {
        return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function() {
            var $194 = $f935a9866e211c00$var$map($f935a9866e211c00$var$diag);
            return function($195) {
                return $194(succ1($195));
            };
        }());
    };
};
var $f935a9866e211c00$export$9263b51426343c61 = function(dictBounded) {
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    return function(dictEnum) {
        var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
        return function(i$prime) {
            var go = function($copy_i) {
                return function($copy_x) {
                    var $tco_var_i = $copy_i;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(i, x) {
                        var $168 = i === 0;
                        if ($168) {
                            $tco_done = true;
                            return new $06733ae99ed4f534$export$8a67b48435b5d073(x);
                        }
                        var v = succ1(x);
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_i = i - 1 | 0;
                            $copy_x = v.value0;
                            return;
                        }
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        }
                        throw new Error("Failed pattern match at Data.Enum (line 296, column 12 - line 298, column 33): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
                    return $tco_result;
                };
            };
            var $171 = i$prime < 0;
            if ($171) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return go(i$prime)(bottom2);
        };
    };
};
var $f935a9866e211c00$export$11e799785deb08e4 = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a) {
            return toEnum$prime(fromEnum$prime(a) + 1 | 0);
        };
    };
};
var $f935a9866e211c00$export$dc42af8461b24233 = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a) {
            return toEnum$prime(fromEnum$prime(a) - 1 | 0);
        };
    };
};
var $f935a9866e211c00$export$21fa49008ecbb00a = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var go = function($copy_i) {
        return function($copy_x) {
            var $tco_var_i = $copy_i;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i, x) {
                var v = pred1(x);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    $tco_var_i = i + 1 | 0;
                    $copy_x = v.value0;
                    return;
                }
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return i;
                }
                throw new Error("Failed pattern match at Data.Enum (line 309, column 5 - line 311, column 19): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
            return $tco_result;
        };
    };
    return go(0);
};
var $f935a9866e211c00$export$18eeb03d5b80a339 = function(dictBounded) {
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    return function(dictEnum) {
        var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
        var go = function($copy_i) {
            return function($copy_x) {
                var $tco_var_i = $copy_i;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(i, x) {
                    var v = succ1(x);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_i = i + 1 | 0;
                        $copy_x = v.value0;
                        return;
                    }
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_done = true;
                        return i;
                    }
                    throw new Error("Failed pattern match at Data.Enum (line 276, column 5 - line 278, column 19): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
                return $tco_result;
            };
        };
        return go(1)(bottom2);
    };
};
var $f935a9866e211c00$var$charToEnum = function(v) {
    if (v >= $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$bottom1) && v <= $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$top1)) return new $06733ae99ed4f534$export$8a67b48435b5d073($1cf1b1293ed20ecf$export$30216c0101da0ee0(v));
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $f935a9866e211c00$export$8ff57056df5ff58e = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($f935a9866e211c00$var$charToEnum)($1cf1b1293ed20ecf$export$d90166409dd04e85),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($f935a9866e211c00$var$charToEnum)($1cf1b1293ed20ecf$export$d90166409dd04e85),
    Ord0: function() {
        return $97937c29f879e68e$export$3abd12c96be3b09b;
    }
};
var $f935a9866e211c00$export$9e9949f96c411257 = function(dict) {
    return dict.cardinality;
};
var $f935a9866e211c00$export$670c12fc7b01c16 = {
    cardinality: 1,
    toEnum: function(v) {
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($05149ea687d6b460$export$523c0b569236b342);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: /* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(0),
    Bounded0: function() {
        return $69d0e3dbb12088d2$export$48259b86288d7b58;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$c0a99362196d7617;
    }
};
var $f935a9866e211c00$export$fe7add2041208ec9 = {
    cardinality: 3,
    toEnum: function(v) {
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
        if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$b023c82b48e70453.value);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return 0;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 1;
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return 2;
        throw new Error("Failed pattern match at Data.Enum (line 137, column 1 - line 145, column 18): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $69d0e3dbb12088d2$export$2e0fd44408d4861;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$94be50e509bf721a;
    }
};
var $f935a9866e211c00$export$be1f07c3580164c = /* #__PURE__ */ function() {
    return {
        cardinality: $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$top1) - $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$bottom1) | 0,
        toEnum: $f935a9866e211c00$var$charToEnum,
        fromEnum: $1cf1b1293ed20ecf$export$d90166409dd04e85,
        Bounded0: function() {
            return $69d0e3dbb12088d2$export$7cd7c97ac7ec5b79;
        },
        Enum1: function() {
            return $f935a9866e211c00$export$8ff57056df5ff58e;
        }
    };
}();
var $f935a9866e211c00$export$3d0fa7de09d15272 = {
    cardinality: 2,
    toEnum: function(v) {
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(false);
        if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073(true);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: function(v) {
        if (!v) return 0;
        if (v) return 1;
        throw new Error("Failed pattern match at Data.Enum (line 118, column 1 - line 124, column 20): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $69d0e3dbb12088d2$export$b6c012947af8ebbc;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$6670eb63482acbe8;
    }
};


var $50b5a2f2b28bbba4$export$d90166409dd04e85 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($f935a9866e211c00$export$be1f07c3580164c);
var $50b5a2f2b28bbba4$export$30216c0101da0ee0 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($f935a9866e211c00$export$be1f07c3580164c);







// Generated by purs version 0.15.15







// Generated by purs version 0.15.15














// Generated by purs version 0.15.15


var $5ce356b15dd97b57$var$Leaf = /* #__PURE__ */ function() {
    function Leaf() {}
    Leaf.value = new Leaf();
    return Leaf;
}();
var $5ce356b15dd97b57$var$Two = /* #__PURE__ */ function() {
    function Two(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Two.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Two(value0, value1, value2);
            };
        };
    };
    return Two;
}();
var $5ce356b15dd97b57$var$Three = /* #__PURE__ */ function() {
    function Three(value0, value1, value2, value3, value4) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
    }
    Three.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return new Three(value0, value1, value2, value3, value4);
                    };
                };
            };
        };
    };
    return Three;
}();
var $5ce356b15dd97b57$var$TwoLeft = /* #__PURE__ */ function() {
    function TwoLeft(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TwoLeft.create = function(value0) {
        return function(value1) {
            return new TwoLeft(value0, value1);
        };
    };
    return TwoLeft;
}();
var $5ce356b15dd97b57$var$TwoRight = /* #__PURE__ */ function() {
    function TwoRight(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TwoRight.create = function(value0) {
        return function(value1) {
            return new TwoRight(value0, value1);
        };
    };
    return TwoRight;
}();
var $5ce356b15dd97b57$var$ThreeLeft = /* #__PURE__ */ function() {
    function ThreeLeft(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeLeft.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeLeft(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeLeft;
}();
var $5ce356b15dd97b57$var$ThreeMiddle = /* #__PURE__ */ function() {
    function ThreeMiddle(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeMiddle.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeMiddle(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeMiddle;
}();
var $5ce356b15dd97b57$var$ThreeRight = /* #__PURE__ */ function() {
    function ThreeRight(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeRight.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeRight(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeRight;
}();
var $5ce356b15dd97b57$var$KickUp = /* #__PURE__ */ function() {
    function KickUp(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    KickUp.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new KickUp(value0, value1, value2);
            };
        };
    };
    return KickUp;
}();
var $5ce356b15dd97b57$var$fromZipper = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return v1;
            }
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                if (v.value0 instanceof $5ce356b15dd97b57$var$TwoLeft) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Two(v1, v.value0.value0, v.value0.value1);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$TwoRight) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v1);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeLeft) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v1, v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeMiddle) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v1, v.value0.value2, v.value0.value3);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeRight) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3, v1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List.Internal (line 25, column 3 - line 30, column 76): " + [
                    v.value0.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.List.Internal (line 22, column 1 - line 22, column 63): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $5ce356b15dd97b57$export$b5a179e49e0f2907 = function(comp) {
    return function(k) {
        return function(orig) {
            var up = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                            $tco_done = true;
                            return new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2);
                        }
                        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                            if (v.value0 instanceof $5ce356b15dd97b57$var$TwoLeft) {
                                $tco_done = true;
                                return $5ce356b15dd97b57$var$fromZipper(v.value1)(new $5ce356b15dd97b57$var$Three(v1.value0, v1.value1, v1.value2, v.value0.value0, v.value0.value1));
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$TwoRight) {
                                $tco_done = true;
                                return $5ce356b15dd97b57$var$fromZipper(v.value1)(new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v1.value0, v1.value1, v1.value2));
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeLeft) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2), v.value0.value0, new $5ce356b15dd97b57$var$Two(v.value0.value1, v.value0.value2, v.value0.value3));
                                return;
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeMiddle) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v1.value0), v1.value1, new $5ce356b15dd97b57$var$Two(v1.value2, v.value0.value2, v.value0.value3));
                                return;
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeRight) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v.value0.value2), v.value0.value3, new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2));
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List.Internal (line 58, column 5 - line 63, column 90): " + [
                                v.value0.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        throw new Error("Failed pattern match at Data.List.Internal (line 55, column 3 - line 55, column 50): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            var down = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v1 instanceof $5ce356b15dd97b57$var$Leaf) {
                            $tco_done1 = true;
                            return {
                                found: false,
                                result: up(v)(new $5ce356b15dd97b57$var$KickUp($5ce356b15dd97b57$var$Leaf.value, k, $5ce356b15dd97b57$var$Leaf.value))
                            };
                        }
                        if (v1 instanceof $5ce356b15dd97b57$var$Two) {
                            var v2 = comp(k)(v1.value1);
                            if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$TwoLeft(v1.value1, v1.value2), v);
                                $copy_v1 = v1.value0;
                                return;
                            }
                            $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$TwoRight(v1.value0, v1.value1), v);
                            $copy_v1 = v1.value2;
                            return;
                        }
                        if (v1 instanceof $5ce356b15dd97b57$var$Three) {
                            var v2 = comp(k)(v1.value1);
                            if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            var v3 = comp(k)(v1.value3);
                            if (v3 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$ThreeLeft(v1.value1, v1.value2, v1.value3, v1.value4), v);
                                $copy_v1 = v1.value0;
                                return;
                            }
                            if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453 && v3 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$ThreeMiddle(v1.value0, v1.value1, v1.value3, v1.value4), v);
                                $copy_v1 = v1.value2;
                                return;
                            }
                            $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$ThreeRight(v1.value0, v1.value1, v1.value2, v1.value3), v);
                            $copy_v1 = v1.value4;
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Internal (line 38, column 3 - line 38, column 81): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            return down($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(orig);
        };
    };
};
var $5ce356b15dd97b57$export$4e5bc754a9c955a = /* #__PURE__ */ function() {
    return $5ce356b15dd97b57$var$Leaf.value;
}();













var $3d4fd987da5242ff$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $3d4fd987da5242ff$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $3d4fd987da5242ff$var$tailRecM2 = /* #__PURE__ */ $f93520de2fa37b44$export$9056a6bb308e8c79($f93520de2fa37b44$export$6a06149683d26749);
var $3d4fd987da5242ff$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $3d4fd987da5242ff$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($5026be88823ef1f4$export$82d306ead3b703cd);
var $3d4fd987da5242ff$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($78c799cba34fcb8d$export$99c2ce29c0ead637);
var $3d4fd987da5242ff$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($f93520de2fa37b44$export$61e43214bca7f031);
var $3d4fd987da5242ff$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $3d4fd987da5242ff$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($78c799cba34fcb8d$export$92659ee1fc91a075)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $3d4fd987da5242ff$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $3d4fd987da5242ff$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$497dcf96eb2383ec);
var $3d4fd987da5242ff$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $3d4fd987da5242ff$export$47606a6ae3eaed8e = function(x) {
    return x;
};
var $3d4fd987da5242ff$export$b6d8713d53419d4c = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v2.value1));
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v3);
            })($3d4fd987da5242ff$export$b6d8713d53419d4c(v - 1 | 0)(v1)(v2.value1));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    };
};
var $3d4fd987da5242ff$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    return $3d4fd987da5242ff$var$foldr(function(v) {
        return function(v1) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value1, v1.value1));
        };
    })(new $71f2e2e9476163f8$export$1908877435b1d5e9($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
}();
var $3d4fd987da5242ff$export$b446f6baa3bb1430 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: v.value0,
        tail: v.value1
    });
    throw new Error("Failed pattern match at Data.List (line 259, column 1 - line 259, column 66): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$823be24f8766da23 = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function(xs) {
        return $3d4fd987da5242ff$var$map(function(rec) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(rec.head, rec.tail);
        })($3d4fd987da5242ff$export$b446f6baa3bb1430(xs));
    });
};
var $3d4fd987da5242ff$export$c01875f616615628 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value1);
    throw new Error("Failed pattern match at Data.List (line 245, column 1 - line 245, column 43): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$71c2a1babd78d286 = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(v) {
        return function(s) {
            var go = function(prefix) {
                return function(input) {
                    if (prefix instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && input instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && eq2(prefix.value0)(input.value0)) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                        a: prefix.value1,
                        b: input.value1
                    }));
                    if (prefix instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $f93520de2fa37b44$export$7fe28cb29e71bf10(input));
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                };
            };
            return $3d4fd987da5242ff$var$tailRecM2(go)(v)(s);
        };
    };
};
var $3d4fd987da5242ff$export$afc1bfabebaf28a2 = function(v) {
    return function(v1) {
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v(v1.value0)) {
            var v2 = $3d4fd987da5242ff$export$afc1bfabebaf28a2(v)(v1.value1);
            return {
                init: new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v2.init),
                rest: v2.rest
            };
        }
        return {
            init: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
            rest: v1
        };
    };
};
var $3d4fd987da5242ff$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $3d4fd987da5242ff$var$foldr($78c799cba34fcb8d$export$74c44e616647f5c0.create)(new $78c799cba34fcb8d$export$74c44e616647f5c0(x, $78c799cba34fcb8d$export$c1bed610ade55e1c.value))(xs);
    };
};
var $3d4fd987da5242ff$export$439306a4dcaafbb9 = function(a) {
    return new $78c799cba34fcb8d$export$74c44e616647f5c0(a, $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$b035e44d7bb4278f = function(cmp) {
    var merge = function(v) {
        return function(v1) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                if ($3d4fd987da5242ff$var$eq(cmp(v.value0)(v1.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, merge(v)(v1.value1));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, merge(v.value1)(v1));
            }
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return v1;
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return v;
            throw new Error("Failed pattern match at Data.List (line 466, column 3 - line 466, column 38): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var mergePairs = function(v) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(merge(v.value0)(v.value1.value0), mergePairs(v.value1.value1));
        return v;
    };
    var mergeAll = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return v.value0;
            }
            $copy_v = mergePairs(v);
            return;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    var sequences = function(v) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            if ($3d4fd987da5242ff$var$eq(cmp(v.value0)(v.value1.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) return descending(v.value1.value0)($3d4fd987da5242ff$export$439306a4dcaafbb9(v.value0))(v.value1.value1);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return ascending(v.value1.value0)(function(v1) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1);
            })(v.value1.value1);
        }
        return $3d4fd987da5242ff$export$439306a4dcaafbb9(v);
    };
    var descending = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && $3d4fd987da5242ff$var$eq(cmp(v)(v2.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) {
                        $tco_var_v = v2.value0;
                        $tco_var_v1 = new $78c799cba34fcb8d$export$74c44e616647f5c0(v, v1);
                        $copy_v2 = v2.value1;
                        return;
                    }
                    $tco_done1 = true;
                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(new $78c799cba34fcb8d$export$74c44e616647f5c0(v, v1), sequences(v2));
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    var ascending = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done2 = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && $3d4fd987da5242ff$var$notEq(cmp(v)(v2.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) {
                        $tco_var_v = v2.value0;
                        $tco_var_v1 = function(ys) {
                            return v1(new $78c799cba34fcb8d$export$74c44e616647f5c0(v, ys));
                        };
                        $copy_v2 = v2.value1;
                        return;
                    }
                    $tco_done2 = true;
                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1($3d4fd987da5242ff$export$439306a4dcaafbb9(v)), sequences(v2));
                }
                while(!$tco_done2)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return function($444) {
        return mergeAll(sequences($444));
    };
};
var $3d4fd987da5242ff$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(xs) {
        return $3d4fd987da5242ff$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $3d4fd987da5242ff$var$tails = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $3d4fd987da5242ff$export$439306a4dcaafbb9($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v, $3d4fd987da5242ff$var$tails(v.value1));
    throw new Error("Failed pattern match at Data.List (line 641, column 1 - line 641, column 43): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$b5c655b9d1f9203e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($78c799cba34fcb8d$export$36831384a74c4427(dictShow));
    return {
        show: function(v) {
            return "(Pattern " + (show(v) + ")");
        }
    };
};
var $3d4fd987da5242ff$export$66c1ae025e96b4bc = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return v;
                }
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                    $copy_v1 = v1.value1;
                    return;
                }
                throw new Error("Failed pattern match at Data.List (line 368, column 3 - line 368, column 19): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $3d4fd987da5242ff$export$b7df5d561049483a = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v1 < 1) {
                        $tco_done = true;
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                    }
                    if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done = true;
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                    }
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v);
                        $tco_var_v1 = v1 - 1 | 0;
                        $copy_v2 = v2.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 513, column 3 - line 513, column 35): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $3d4fd987da5242ff$export$9384c7afe4015e42 = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && p(v1.value0)) {
                    $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                    $copy_v1 = v1.value1;
                    return;
                }
                $tco_done = true;
                return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$712962e076096ed4 = function(lst) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        revInit: v1,
                        last: v.value0
                    });
                }
                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List (line 270, column 3 - line 270, column 21): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return $3d4fd987da5242ff$var$map(function(h) {
        return {
            init: $3d4fd987da5242ff$export$66c1ae025e96b4bc(h.revInit),
            last: h.last
        };
    })(go(lst)($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
};
var $3d4fd987da5242ff$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            var go = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1, v2) {
                            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v2;
                            }
                            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v2;
                            }
                            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v = v.value1;
                                $tco_var_v1 = v1.value1;
                                $copy_v2 = new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v.value0)(v1.value0), v2);
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List (line 779, column 3 - line 779, column 21): " + [
                                v.constructor.name,
                                v1.constructor.name,
                                v2.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            return $3d4fd987da5242ff$export$66c1ae025e96b4bc(go(xs)(ys)($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
        };
    };
};
var $3d4fd987da5242ff$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $3d4fd987da5242ff$export$b634740ce272acb5($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $3d4fd987da5242ff$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $3d4fd987da5242ff$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($3d4fd987da5242ff$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $3d4fd987da5242ff$export$d02631cccf789723 = function(start) {
    return function(end) {
        if (start === end) return $3d4fd987da5242ff$export$439306a4dcaafbb9(start);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
            var go = function($copy_s) {
                return function($copy_e) {
                    return function($copy_step) {
                        return function($copy_rest) {
                            var $tco_var_s = $copy_s;
                            var $tco_var_e = $copy_e;
                            var $tco_var_step = $copy_step;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(s, e, step, rest) {
                                if (s === e) {
                                    $tco_done = true;
                                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(s, rest);
                                }
                                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                                    $tco_var_s = s + step | 0;
                                    $tco_var_e = e;
                                    $tco_var_step = step;
                                    $copy_rest = new $78c799cba34fcb8d$export$74c44e616647f5c0(s, rest);
                                    return;
                                }
                                throw new Error("Failed pattern match at Data.List (line 148, column 3 - line 149, column 65): " + [
                                    s.constructor.name,
                                    e.constructor.name,
                                    step.constructor.name,
                                    rest.constructor.name
                                ]);
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_s, $tco_var_e, $tco_var_step, $copy_rest);
                            return $tco_result;
                        };
                    };
                };
            };
            return go(end)(start)(function() {
                var $325 = start > end;
                if ($325) return 1;
                return -1;
            }())($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        }
        throw new Error("Failed pattern match at Data.List (line 144, column 1 - line 144, column 32): " + [
            start.constructor.name,
            end.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$b29f828819edca8d = function(p) {
    return function(xs) {
        var select = function(x) {
            return function(v) {
                var $328 = p(x);
                if ($328) return {
                    no: v.no,
                    yes: new $78c799cba34fcb8d$export$74c44e616647f5c0(x, v.yes)
                };
                return {
                    no: new $78c799cba34fcb8d$export$74c44e616647f5c0(x, v.no),
                    yes: v.yes
                };
            };
        };
        return $3d4fd987da5242ff$var$foldr(select)({
            no: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
            yes: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
        })(xs);
    };
};
var $3d4fd987da5242ff$export$7b1b591b262c240 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return true;
    return false;
};
var $3d4fd987da5242ff$export$18f77a3bafa759b9 = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done = true;
                        return v1;
                    }
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        var v3 = $5ce356b15dd97b57$export$b5a179e49e0f2907(p)(v2.value0)(v);
                        if (v3.found) {
                            $tco_var_v = v3.result;
                            $tco_var_v1 = v1;
                            $copy_v2 = v2.value1;
                            return;
                        }
                        $tco_var_v = v3.result;
                        $tco_var_v1 = new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v1);
                        $copy_v2 = v2.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 673, column 5 - line 673, column 23): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    var $445 = go($5ce356b15dd97b57$export$4e5bc754a9c955a)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    return function($446) {
        return $3d4fd987da5242ff$export$66c1ae025e96b4bc($445($446));
    };
};
var $3d4fd987da5242ff$export$94f4066a75b10404 = function(dictOrd) {
    return $3d4fd987da5242ff$export$18f77a3bafa759b9($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $3d4fd987da5242ff$export$86c9b635481112b7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3d4fd987da5242ff$export$e70771d2e7e590a = function(f) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                }
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    var v2 = f(v1.value0);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_var_v = v;
                        $copy_v1 = v1.value1;
                        return;
                    }
                    if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v);
                        $copy_v1 = v1.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 419, column 5 - line 421, column 32): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.List (line 417, column 3 - line 417, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$17771a97d85ba7eb = function(dictMonadRec) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonadRec.Monad0().Bind1());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(dictAlternative) {
        var Alt0 = dictAlternative.Plus1().Alt0();
        var alt = $75e93a4111e80214$export$228be17d80722ab(Alt0);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Alt0.Functor0());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
        return function(p) {
            var go = function(acc) {
                return bind1(alt(map1($f93520de2fa37b44$export$550acbd06a1f5a6a.create)(p))(pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10($05149ea687d6b460$export$523c0b569236b342))))(function(aa) {
                    return pure($3d4fd987da5242ff$var$bimap(function(v) {
                        return new $78c799cba34fcb8d$export$74c44e616647f5c0(v, acc);
                    })(function(v) {
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(acc);
                    })(aa));
                });
            };
            return tailRecM(go)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    };
};
var $3d4fd987da5242ff$export$934820ddadec516f = function(dictMonadRec) {
    var manyRec1 = $3d4fd987da5242ff$export$17771a97d85ba7eb(dictMonadRec);
    return function(dictAlternative) {
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictAlternative.Applicative0().Apply0());
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlternative.Plus1().Alt0().Functor0());
        var manyRec2 = manyRec1(dictAlternative);
        return function(v) {
            return apply(map1($78c799cba34fcb8d$export$74c44e616647f5c0.create)(v))(manyRec2(v));
        };
    };
};
var $3d4fd987da5242ff$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictAlternative.Applicative0().Apply0());
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
        return function(v) {
            return apply(map1($78c799cba34fcb8d$export$74c44e616647f5c0.create)(v))(defer(function(v1) {
                return $3d4fd987da5242ff$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $3d4fd987da5242ff$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlternative.Plus1().Alt0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($3d4fd987da5242ff$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
        };
    };
};
var $3d4fd987da5242ff$export$f24224f1c91d8156 = /* #__PURE__ */ $3d4fd987da5242ff$var$foldl(function(acc) {
    return function(v) {
        return acc + 1 | 0;
    };
})(0);
var $3d4fd987da5242ff$export$4c7897fafd92b108 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $tco_done = true;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        }
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            $copy_v = v.value1;
            return;
        }
        $tco_done = true;
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $3d4fd987da5242ff$export$b8bc901090d2b1d4 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $3d4fd987da5242ff$export$439306a4dcaafbb9(v1);
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var v3 = v(v1)(v2.value0);
                if (v3 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, $3d4fd987da5242ff$export$b8bc901090d2b1d4(v)(v1)(v2.value1));
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v2);
            }
            throw new Error("Failed pattern match at Data.List (line 216, column 1 - line 216, column 68): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$9f200c4466975173 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v2));
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v3);
            })($3d4fd987da5242ff$export$9f200c4466975173(v - 1 | 0)(v1)(v2.value1));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    };
};
var $3d4fd987da5242ff$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $3d4fd987da5242ff$export$b8bc901090d2b1d4($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $3d4fd987da5242ff$export$2cd8252107eb640b = function(lst) {
    return $3d4fd987da5242ff$var$map(function(v) {
        return v.init;
    })($3d4fd987da5242ff$export$712962e076096ed4(lst));
};
var $3d4fd987da5242ff$export$b610b8812bbcded9 = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 === 0) {
                $tco_done = true;
                return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
            }
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                $tco_var_v = v.value1;
                $copy_v1 = v1 - 1 | 0;
                return;
            }
            throw new Error("Failed pattern match at Data.List (line 281, column 1 - line 281, column 44): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $3d4fd987da5242ff$export$5fd5031fecdacec3 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
    throw new Error("Failed pattern match at Data.List (line 230, column 1 - line 230, column 22): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$9cb09a71b7d66923 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $3d4fd987da5242ff$export$9cb09a71b7d66923(v.value1);
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value0 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.value0, $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$export$5fd5031fecdacec3)(v.value1)), $3d4fd987da5242ff$export$9cb09a71b7d66923(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.value1, $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$export$c01875f616615628)(v.value1))));
    throw new Error("Failed pattern match at Data.List (line 813, column 1 - line 813, column 54): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$3f063810d7bf01bd = function(v) {
    return function(v1) {
        if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            var v2 = $3d4fd987da5242ff$export$afc1bfabebaf28a2(v(v1.value0))(v1.value1);
            return new $78c799cba34fcb8d$export$74c44e616647f5c0(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v1.value0, v2.init), $3d4fd987da5242ff$export$3f063810d7bf01bd(v)(v2.rest));
        }
        throw new Error("Failed pattern match at Data.List (line 609, column 1 - line 609, column 80): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$1f7a5bf12caafbd = function(p) {
    var $447 = $3d4fd987da5242ff$export$3f063810d7bf01bd(function(x) {
        return function(y) {
            return $3d4fd987da5242ff$var$eq(p(x)(y))($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        };
    });
    var $448 = $3d4fd987da5242ff$export$b035e44d7bb4278f(p);
    return function($449) {
        return $447($448($449));
    };
};
var $3d4fd987da5242ff$export$e5e25fbcc1f7affe = function(dictEq) {
    return $3d4fd987da5242ff$export$3f063810d7bf01bd($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$361434b95a7d965 = function(dictOrd) {
    var $450 = $3d4fd987da5242ff$export$e5e25fbcc1f7affe(dictOrd.Eq0());
    var $451 = $3d4fd987da5242ff$export$97db5808d8f88186(dictOrd);
    return function($452) {
        return $450($451($452));
    };
};
var $3d4fd987da5242ff$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable)($78c799cba34fcb8d$export$74c44e616647f5c0.create)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return pure(v1);
                if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return bind1(v(v1)(v2.value0))(function(b$prime) {
                    return $3d4fd987da5242ff$export$7a067f9280ad8af0(dictMonad)(v)(b$prime)(v2.value1);
                });
                throw new Error("Failed pattern match at Data.List (line 824, column 1 - line 824, column 72): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $3d4fd987da5242ff$export$de3a4d4a0d731119 = function(fn) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    if (fn(v1.value0)) {
                        $tco_done = true;
                        return new $06733ae99ed4f534$export$8a67b48435b5d073(v);
                    }
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                        $tco_var_v = v + 1 | 0;
                        $copy_v1 = v1.value1;
                        return;
                    }
                }
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                throw new Error("Failed pattern match at Data.List (line 301, column 3 - line 301, column 35): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go(0);
};
var $3d4fd987da5242ff$export$8855a8be7bd3e9f8 = function(fn) {
    return function(xs) {
        return $3d4fd987da5242ff$var$map(function(v) {
            return ($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - 1 | 0) - v | 0;
        })($3d4fd987da5242ff$export$de3a4d4a0d731119(fn)($3d4fd987da5242ff$export$66c1ae025e96b4bc(xs)));
    };
};
var $3d4fd987da5242ff$export$20098ecb074a31e6 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(v) {
        return function(v1) {
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return bind1(v(v1.value0))(function(b) {
                return bind1($3d4fd987da5242ff$export$20098ecb074a31e6(dictMonad)(v)(v1.value1))(function(xs$prime) {
                    return pure(function() {
                        if (b) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, xs$prime);
                        return xs$prime;
                    }());
                });
            });
            throw new Error("Failed pattern match at Data.List (line 403, column 1 - line 403, column 75): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$3dea766d36a8935f = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                }
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    if (p(v1.value0)) {
                        $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                        $copy_v1 = v1.value1;
                        return;
                    }
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                        $tco_var_v = v;
                        $copy_v1 = v1.value1;
                        return;
                    }
                }
                throw new Error("Failed pattern match at Data.List (line 390, column 3 - line 390, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$f161f39e9c06ab2d = function(v) {
    return function(v1) {
        return function(v2) {
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            return $3d4fd987da5242ff$export$3dea766d36a8935f(function(x) {
                return $3d4fd987da5242ff$var$any(v(x))(v2);
            })(v1);
        };
    };
};
var $3d4fd987da5242ff$export$1f4807a235930d45 = function(dictEq) {
    return $3d4fd987da5242ff$export$f161f39e9c06ab2d($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$45273896c792ff3b = function(v) {
    return function(v1) {
        if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, $3d4fd987da5242ff$export$45273896c792ff3b(v)($3d4fd987da5242ff$export$3dea766d36a8935f(function(y) {
            return !v(v1.value0)(y);
        })(v1.value1)));
        throw new Error("Failed pattern match at Data.List (line 705, column 1 - line 705, column 61): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$edce5881c815871 = function(dictEq) {
    return $3d4fd987da5242ff$export$45273896c792ff3b($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$3c57592525e2b27e = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32($78c799cba34fcb8d$export$1ae88a7f3c5f59ef(dictEq));
    return {
        eq: function(x) {
            return function(y) {
                return eq2(x)(y);
            };
        }
    };
};
var $3d4fd987da5242ff$export$21c206d752eba296 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($78c799cba34fcb8d$export$86359cd4476084f8(dictOrd));
    var eqPattern1 = $3d4fd987da5242ff$export$3c57592525e2b27e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare(x)(y);
            };
        },
        Eq0: function() {
            return eqPattern1;
        }
    };
};
var $3d4fd987da5242ff$export$c19d79386f4ed99a = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $3d4fd987da5242ff$export$8855a8be7bd3e9f8(function(v) {
            return eq2(v)(x);
        });
    };
};
var $3d4fd987da5242ff$export$f444781b0adb7e4d = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $3d4fd987da5242ff$export$de3a4d4a0d731119(function(v) {
            return eq2(v)(x);
        });
    };
};
var $3d4fd987da5242ff$export$533af5c8cd6afa16 = function(p) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && p(v.value0)) {
                $copy_v = v.value1;
                return;
            }
            $tco_done = true;
            return v;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return go;
};
var $3d4fd987da5242ff$export$2b3b686e33c80c56 = function(n) {
    return function(xs) {
        return $3d4fd987da5242ff$export$b7df5d561049483a($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $3d4fd987da5242ff$export$663103110d94aac9 = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v < 1) {
                $tco_done = true;
                return v1;
            }
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            }
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                $tco_var_v = v - 1 | 0;
                $copy_v1 = v1.value1;
                return;
            }
            throw new Error("Failed pattern match at Data.List (line 536, column 1 - line 536, column 42): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $3d4fd987da5242ff$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return function(xs) {
            return $3d4fd987da5242ff$export$b7df5d561049483a(end - start | 0)($3d4fd987da5242ff$export$663103110d94aac9(start)(xs));
        };
    };
};
var $3d4fd987da5242ff$export$9100289823a975b0 = function(n) {
    return function(xs) {
        return $3d4fd987da5242ff$export$663103110d94aac9($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $3d4fd987da5242ff$export$9ea2b6c3fae093d8 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v(v1)(v2.value0)) return v2.value1;
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, $3d4fd987da5242ff$export$9ea2b6c3fae093d8(v)(v1)(v2.value1));
            throw new Error("Failed pattern match at Data.List (line 732, column 1 - line 732, column 67): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$ef1d06dc4d91d507 = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $3d4fd987da5242ff$var$append1(xs)($3d4fd987da5242ff$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($3d4fd987da5242ff$export$9ea2b6c3fae093d8(eq2)))($3d4fd987da5242ff$export$45273896c792ff3b(eq2)(ys))(xs));
        };
    };
};
var $3d4fd987da5242ff$export$971dd5b0dfd021b6 = function(dictEq) {
    return $3d4fd987da5242ff$export$ef1d06dc4d91d507($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$90f9093465da3136 = function(v) {
    return function(v1) {
        if (v === 0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.value1);
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v2) {
            return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v2);
        })($3d4fd987da5242ff$export$90f9093465da3136(v - 1 | 0)(v1.value1));
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
};
var $3d4fd987da5242ff$export$1822828d790e23ee = function(dictEq) {
    return $3d4fd987da5242ff$export$9ea2b6c3fae093d8($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$acaf96a27438246b = function(dictEq) {
    return $3d4fd987da5242ff$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($3d4fd987da5242ff$export$1822828d790e23ee(dictEq)));
};
var $3d4fd987da5242ff$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($3d4fd987da5242ff$var$bind);
var $3d4fd987da5242ff$export$ee1b3e54f0441b22 = function(v) {
    return $3d4fd987da5242ff$var$bind(v)($3d4fd987da5242ff$var$identity);
};
var $3d4fd987da5242ff$export$986c2bbe7a34be0b = /* #__PURE__ */ $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$var$identity);
var $3d4fd987da5242ff$export$2dd9d44f93be5e22 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(function() {
                var v3 = v1(v2.value0);
                if (v3 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v2.value1;
                if (v3 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.value0, v2.value1);
                throw new Error("Failed pattern match at Data.List (line 352, column 3 - line 354, column 23): " + [
                    v3.constructor.name
                ]);
            }());
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v3);
            })($3d4fd987da5242ff$export$2dd9d44f93be5e22(v - 1 | 0)(v1)(v2.value1));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    };
};
var $3d4fd987da5242ff$export$cba09f9e3d3e58eb = function(n) {
    return function(f) {
        return $3d4fd987da5242ff$export$2dd9d44f93be5e22(n)(function($453) {
            return $06733ae99ed4f534$export$8a67b48435b5d073.create(f($453));
        });
    };
};












// Generated by purs version 0.15.15
// module Partial.Unsafe
const $1ea5ae3d66e02fe1$export$3e8f060a4c73ba81 = function(f) {
    return f();
};


// Generated by purs version 0.15.15
// module Partial
const $d8f9d43a2c2b18d5$export$b479f9f69f916b6a = function(msg) {
    throw new Error(msg);
};


var $dcd3eefef707675c$export$ddf616d7646fcc8e = function() {
    return $d8f9d43a2c2b18d5$export$b479f9f69f916b6a;
};
var $dcd3eefef707675c$var$crashWith1 = /* #__PURE__ */ $dcd3eefef707675c$export$ddf616d7646fcc8e();
var $dcd3eefef707675c$export$dcc9d38dbc7992eb = function() {
    return $dcd3eefef707675c$var$crashWith1("Partial.crash: partial function");
};


var $8bcde8f642a64c7d$var$crashWith = /* #__PURE__ */ $dcd3eefef707675c$export$ddf616d7646fcc8e();
var $8bcde8f642a64c7d$export$cb50937af21de128 = $1ea5ae3d66e02fe1$export$3e8f060a4c73ba81;
var $8bcde8f642a64c7d$export$51b220bae4359b72 = function(msg) {
    return $8bcde8f642a64c7d$export$cb50937af21de128(function() {
        return $8bcde8f642a64c7d$var$crashWith(msg);
    });
};


var $ba51d599f79a6310$var$sequence1 = /* #__PURE__ */ $e4fb66202bb8a4f4$export$6deffb29affc84c6($78c799cba34fcb8d$export$fac1bbd0707bc766);
var $ba51d599f79a6310$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $ba51d599f79a6310$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$3c979cc7d75b024c);
var $ba51d599f79a6310$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$12e3398ee6f4a417);
var $ba51d599f79a6310$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $ba51d599f79a6310$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $ba51d599f79a6310$export$b634740ce272acb5 = function(f) {
    return function(v) {
        return function(v1) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(v.value0)(v1.value0), $3d4fd987da5242ff$export$b634740ce272acb5(f)(v.value1)(v1.value1));
        };
    };
};
var $ba51d599f79a6310$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence11 = $ba51d599f79a6310$var$sequence1(dictApplicative.Apply0());
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence11($ba51d599f79a6310$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $ba51d599f79a6310$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $ba51d599f79a6310$export$b634740ce272acb5($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $ba51d599f79a6310$var$wrappedOperation2 = function(name) {
    return function(f) {
        return function(v) {
            return function(v1) {
                var v2 = f(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1))(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v1.value1));
                if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v2.value0, v2.value1);
                if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $8bcde8f642a64c7d$export$51b220bae4359b72("Impossible: empty list in NonEmptyList " + name);
                throw new Error("Failed pattern match at Data.List.NonEmpty (line 105, column 3 - line 107, column 81): " + [
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $ba51d599f79a6310$var$wrappedOperation = function(name) {
    return function(f) {
        return function(v) {
            var v1 = f(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v1.value0, v1.value1);
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $8bcde8f642a64c7d$export$51b220bae4359b72("Impossible: empty list in NonEmptyList " + name);
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 92, column 3 - line 94, column 81): " + [
                v1.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$b6d8713d53419d4c = function(i) {
    return function(a) {
        return function(v) {
            if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, v.value1));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function($193) {
                return $78c799cba34fcb8d$export$ab241a3582569781(function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v1);
                }($193));
            })($3d4fd987da5242ff$export$b6d8713d53419d4c(i - 1 | 0)(a)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 198, column 1 - line 198, column 75): " + [
                i.constructor.name,
                a.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$23c8d3f8757cab88 = function(ts) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9($ba51d599f79a6310$var$map1($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(ts), $ba51d599f79a6310$var$map1($71f2e2e9476163f8$export$6f71268a1666ab58)(ts));
};
var $ba51d599f79a6310$export$712962e076096ed4 = function(v) {
    var v1 = $3d4fd987da5242ff$export$712962e076096ed4(v.value1);
    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
        init: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        last: v.value0
    };
    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
        init: new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1.value0.init),
        last: v1.value0.last
    };
    throw new Error("Failed pattern match at Data.List.NonEmpty (line 160, column 35 - line 162, column 50): " + [
        v1.constructor.name
    ]);
};
var $ba51d599f79a6310$export$ef1d06dc4d91d507 = /* #__PURE__ */ function() {
    var $194 = $ba51d599f79a6310$var$wrappedOperation2("unionBy");
    return function($195) {
        return $194($3d4fd987da5242ff$export$ef1d06dc4d91d507($195));
    };
}();
var $ba51d599f79a6310$export$971dd5b0dfd021b6 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation2("union")($3d4fd987da5242ff$export$971dd5b0dfd021b6(dictEq));
};
var $ba51d599f79a6310$export$b446f6baa3bb1430 = function(v) {
    return {
        head: v.value0,
        tail: v.value1
    };
};
var $ba51d599f79a6310$export$effcdbd76139450 = function(v) {
    return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1);
};
var $ba51d599f79a6310$export$823be24f8766da23 = function(dictUnfoldable) {
    var $196 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function(xs) {
        return $ba51d599f79a6310$var$map(function(rec) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(rec.head, rec.tail);
        })($3d4fd987da5242ff$export$b446f6baa3bb1430(xs));
    });
    return function($197) {
        return $196($ba51d599f79a6310$export$effcdbd76139450($197));
    };
};
var $ba51d599f79a6310$export$c01875f616615628 = function(v) {
    return v.value1;
};
var $ba51d599f79a6310$export$b035e44d7bb4278f = /* #__PURE__ */ function() {
    var $198 = $ba51d599f79a6310$var$wrappedOperation("sortBy");
    return function($199) {
        return $198($3d4fd987da5242ff$export$b035e44d7bb4278f($199));
    };
}();
var $ba51d599f79a6310$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(xs) {
        return $ba51d599f79a6310$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $ba51d599f79a6310$export$c40cf5aab899f397 = function(v) {
    return function(y) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $3d4fd987da5242ff$export$c40cf5aab899f397(v.value1)(y));
    };
};
var $ba51d599f79a6310$export$439306a4dcaafbb9 = /* #__PURE__ */ function() {
    var $200 = $1f1c3fb67e79b37f$export$439306a4dcaafbb9($78c799cba34fcb8d$export$55d622505c452dcb);
    return function($201) {
        return $78c799cba34fcb8d$export$ab241a3582569781($200($201));
    };
}();
var $ba51d599f79a6310$export$5b6d1d165591a48c = function(v) {
    return function(v1) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $3d4fd987da5242ff$export$c40cf5aab899f397(v.value1)(v1));
        if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $ba51d599f79a6310$export$439306a4dcaafbb9(v1);
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 140, column 1 - line 140, column 51): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$66c1ae025e96b4bc = /* #__PURE__ */ $ba51d599f79a6310$var$wrappedOperation("reverse")($3d4fd987da5242ff$export$66c1ae025e96b4bc);
var $ba51d599f79a6310$export$edce5881c815871 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation("nubEq")($3d4fd987da5242ff$export$edce5881c815871(dictEq));
};
var $ba51d599f79a6310$export$45273896c792ff3b = /* #__PURE__ */ function() {
    var $202 = $ba51d599f79a6310$var$wrappedOperation("nubByEq");
    return function($203) {
        return $202($3d4fd987da5242ff$export$45273896c792ff3b($203));
    };
}();
var $ba51d599f79a6310$export$18f77a3bafa759b9 = /* #__PURE__ */ function() {
    var $204 = $ba51d599f79a6310$var$wrappedOperation("nubBy");
    return function($205) {
        return $204($3d4fd987da5242ff$export$18f77a3bafa759b9($205));
    };
}();
var $ba51d599f79a6310$export$94f4066a75b10404 = function(dictOrd) {
    return $ba51d599f79a6310$var$wrappedOperation("nub")($3d4fd987da5242ff$export$94f4066a75b10404(dictOrd));
};
var $ba51d599f79a6310$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        return function(v) {
            if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(v.value0), v.value1));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function($206) {
                return $78c799cba34fcb8d$export$ab241a3582569781(function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v1);
                }($206));
            })($3d4fd987da5242ff$export$cba09f9e3d3e58eb(i - 1 | 0)(f)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 203, column 1 - line 203, column 82): " + [
                i.constructor.name,
                f.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$var$lift = function(f) {
    return function(v) {
        return f(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $ba51d599f79a6310$export$e70771d2e7e590a = function($207) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$e70771d2e7e590a($207));
};
var $ba51d599f79a6310$export$b29f828819edca8d = function($208) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$b29f828819edca8d($208));
};
var $ba51d599f79a6310$export$afc1bfabebaf28a2 = function($209) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$afc1bfabebaf28a2($209));
};
var $ba51d599f79a6310$export$b7df5d561049483a = function($210) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$b7df5d561049483a($210));
};
var $ba51d599f79a6310$export$9384c7afe4015e42 = function($211) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$9384c7afe4015e42($211));
};
var $ba51d599f79a6310$export$f24224f1c91d8156 = function(v) {
    return 1 + $3d4fd987da5242ff$export$f24224f1c91d8156(v.value1) | 0;
};
var $ba51d599f79a6310$export$4c7897fafd92b108 = function(v) {
    return $06733ae99ed4f534$export$43db023a260c5e9f(v.value0)($3d4fd987da5242ff$export$4c7897fafd92b108(v.value1));
};
var $ba51d599f79a6310$export$f161f39e9c06ab2d = /* #__PURE__ */ function() {
    var $212 = $ba51d599f79a6310$var$wrappedOperation2("intersectBy");
    return function($213) {
        return $212($3d4fd987da5242ff$export$f161f39e9c06ab2d($213));
    };
}();
var $ba51d599f79a6310$export$1f4807a235930d45 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation2("intersect")($3d4fd987da5242ff$export$1f4807a235930d45(dictEq));
};
var $ba51d599f79a6310$export$9f200c4466975173 = function(i) {
    return function(a) {
        return function(v) {
            if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1)));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function($214) {
                return $78c799cba34fcb8d$export$ab241a3582569781(function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v1);
                }($214));
            })($3d4fd987da5242ff$export$9f200c4466975173(i - 1 | 0)(a)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 193, column 1 - line 193, column 75): " + [
                i.constructor.name,
                a.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$2cd8252107eb640b = function(v) {
    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(function(v1) {
        return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1);
    })($3d4fd987da5242ff$export$2cd8252107eb640b(v.value1));
};
var $ba51d599f79a6310$export$b610b8812bbcded9 = function(v) {
    return function(i) {
        if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $3d4fd987da5242ff$export$b610b8812bbcded9(v.value1)(i - 1 | 0);
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 167, column 1 - line 167, column 52): " + [
            v.constructor.name,
            i.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$5fd5031fecdacec3 = function(v) {
    return v.value0;
};
var $ba51d599f79a6310$export$3f063810d7bf01bd = /* #__PURE__ */ function() {
    var $215 = $ba51d599f79a6310$var$wrappedOperation("groupBy");
    return function($216) {
        return $215($3d4fd987da5242ff$export$3f063810d7bf01bd($216));
    };
}();
var $ba51d599f79a6310$export$1f7a5bf12caafbd = /* #__PURE__ */ function() {
    var $217 = $ba51d599f79a6310$var$wrappedOperation("groupAllBy");
    return function($218) {
        return $217($3d4fd987da5242ff$export$1f7a5bf12caafbd($218));
    };
}();
var $ba51d599f79a6310$export$361434b95a7d965 = function(dictOrd) {
    return $ba51d599f79a6310$var$wrappedOperation("groupAll")($3d4fd987da5242ff$export$361434b95a7d965(dictOrd));
};
var $ba51d599f79a6310$export$e5e25fbcc1f7affe = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation("group")($3d4fd987da5242ff$export$e5e25fbcc1f7affe(dictEq));
};
var $ba51d599f79a6310$export$88e0dae599377b39 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v.value1));
    throw new Error("Failed pattern match at Data.List.NonEmpty (line 121, column 1 - line 121, column 57): " + [
        v.constructor.name
    ]);
};
var $ba51d599f79a6310$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var $219 = $3d4fd987da5242ff$export$b7d5d9bb9ff52072(dictFoldable);
    return function($220) {
        return $ba51d599f79a6310$export$88e0dae599377b39($219($220));
    };
};
var $ba51d599f79a6310$export$7a067f9280ad8af0 = function(dictMonad) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var foldM1 = $3d4fd987da5242ff$export$7a067f9280ad8af0(dictMonad);
    return function(f) {
        return function(b) {
            return function(v) {
                return bind1(f(b)(v.value0))(function(b$prime) {
                    return foldM1(f)(b$prime)(v.value1);
                });
            };
        };
    };
};
var $ba51d599f79a6310$export$8855a8be7bd3e9f8 = function(f) {
    return function(v) {
        var v1 = $3d4fd987da5242ff$export$8855a8be7bd3e9f8(f)(v.value1);
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.value0 + 1 | 0);
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
            if (f(v.value0)) return new $06733ae99ed4f534$export$8a67b48435b5d073(0);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 187, column 3 - line 191, column 29): " + [
            v1.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$de3a4d4a0d731119 = function(f) {
    return function(v) {
        if (f(v.value0)) return new $06733ae99ed4f534$export$8a67b48435b5d073(0);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function(v1) {
            return v1 + 1 | 0;
        })($3d4fd987da5242ff$export$de3a4d4a0d731119(f)(v.value1));
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 180, column 1 - line 180, column 69): " + [
            f.constructor.name,
            v.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$20098ecb074a31e6 = function(dictMonad) {
    var $221 = $3d4fd987da5242ff$export$20098ecb074a31e6(dictMonad);
    return function($222) {
        return $ba51d599f79a6310$var$lift($221($222));
    };
};
var $ba51d599f79a6310$export$3dea766d36a8935f = function($223) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$3dea766d36a8935f($223));
};
var $ba51d599f79a6310$export$c19d79386f4ed99a = function(dictEq) {
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $ba51d599f79a6310$export$8855a8be7bd3e9f8(function(v) {
            return eq1(v)(x);
        });
    };
};
var $ba51d599f79a6310$export$f444781b0adb7e4d = function(dictEq) {
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $ba51d599f79a6310$export$de3a4d4a0d731119(function(v) {
            return eq1(v)(x);
        });
    };
};
var $ba51d599f79a6310$export$533af5c8cd6afa16 = function($224) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$533af5c8cd6afa16($224));
};
var $ba51d599f79a6310$export$663103110d94aac9 = function($225) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$663103110d94aac9($225));
};
var $ba51d599f79a6310$export$cc3b5f3f66225fbe = function(x) {
    return function(xs) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(x, xs);
    };
};
var $ba51d599f79a6310$export$8327ebbef2a0ba76 = function(y) {
    return function(v) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(y, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $ba51d599f79a6310$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($ba51d599f79a6310$var$bind);
var $ba51d599f79a6310$export$ee1b3e54f0441b22 = function(v) {
    return $ba51d599f79a6310$var$bind(v)($ba51d599f79a6310$var$identity);
};
var $ba51d599f79a6310$export$986c2bbe7a34be0b = /* #__PURE__ */ $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$986c2bbe7a34be0b);
var $ba51d599f79a6310$export$89c5a0ebe497f8c7 = function(dictFoldable) {
    var fromFoldable1 = $3d4fd987da5242ff$export$b7d5d9bb9ff52072(dictFoldable);
    return function(v) {
        return function(ys) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $ba51d599f79a6310$var$append1(v.value1)(fromFoldable1(ys)));
        };
    };
};







// Generated by purs version 0.15.15









// Generated by purs version 0.15.15
function $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(value) {
    return typeof value;
}
function $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function $c2c5bfcfd98ddabb$export$630801d484da15df(value) {
    return value === null;
}
function $c2c5bfcfd98ddabb$export$fce6876652108ab(value) {
    return value === undefined;
}
const $c2c5bfcfd98ddabb$export$43bee75e5e14138e = Array.isArray || function(value) {
    return Object.prototype.toString.call(value) === "[object Array]";
};










// Generated by purs version 0.15.15
const $4ab74a20512cef04$export$5b3229f64c38e483 = function(just) {
    return function(nothing) {
        return function(n) {
            /* jshint bitwise: false */ return (n | 0) === n ? just(n) : nothing;
        };
    };
};
const $4ab74a20512cef04$export$a0a81dc3380ce7d3 = function(n) {
    return n;
};
const $4ab74a20512cef04$export$221b4f162df9878c = function(just) {
    return function(nothing) {
        return function(radix) {
            var digits;
            if (radix < 11) digits = "[0-" + (radix - 1).toString() + "]";
            else if (radix === 11) digits = "[0-9a]";
            else digits = "[0-9a-" + String.fromCharCode(86 + radix) + "]";
            var pattern = new RegExp("^[\\+\\-]?" + digits + "+$", "i");
            return function(s) {
                /* jshint bitwise: false */ if (pattern.test(s)) {
                    var i = parseInt(s, radix);
                    return (i | 0) === i ? just(i) : nothing;
                } else return nothing;
            };
        };
    };
};
const $4ab74a20512cef04$export$f601457c5ee3082f = function(radix) {
    return function(i) {
        return i.toString(radix);
    };
};
const $4ab74a20512cef04$export$dcbbe75d5a67af21 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x / y | 0;
    };
};
const $4ab74a20512cef04$export$fb1897a40d146f7f = function(x) {
    return function(y) {
        return x % y;
    };
};
const $4ab74a20512cef04$export$9c297f60e22e3389 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return Math.pow(x, y) | 0;
    };
};







// Generated by purs version 0.15.15
/* globals exports */ const $9a14cd925227149d$export$9e06de0973666692 = NaN;
const $9a14cd925227149d$export$c9f5652083b8129d = isNaN;
const $9a14cd925227149d$export$a0978488bc4efbee = Infinity;
const $9a14cd925227149d$export$65f0b13f2f82375a = isFinite;
function $9a14cd925227149d$export$3ffe08ccbe76f69e(str, isFinite1, just, nothing) {
    var num = parseFloat(str);
    if (isFinite1(num)) return just(num);
    else return nothing;
}
const $9a14cd925227149d$export$2335f513bbd82c6d = Math.abs;
const $9a14cd925227149d$export$fd6306be3fde5b04 = Math.acos;
const $9a14cd925227149d$export$41726bdb1fc63f = Math.asin;
const $9a14cd925227149d$export$628dc4eed22b0fbd = Math.atan;
const $9a14cd925227149d$export$b8b770ee6a0d9760 = function(y) {
    return function(x) {
        return Math.atan2(y, x);
    };
};
const $9a14cd925227149d$export$803ce6b71a0a94b2 = Math.ceil;
const $9a14cd925227149d$export$50d414a77b60d802 = Math.cos;
const $9a14cd925227149d$export$b310ec824aaee37f = Math.exp;
const $9a14cd925227149d$export$a3fe094919f356fd = Math.floor;
const $9a14cd925227149d$export$bef1f36f5486a6a3 = Math.log;
const $9a14cd925227149d$export$8960430cfd85939f = function(n1) {
    return function(n2) {
        return Math.max(n1, n2);
    };
};
const $9a14cd925227149d$export$96ec731ed4dcb222 = function(n1) {
    return function(n2) {
        return Math.min(n1, n2);
    };
};
const $9a14cd925227149d$export$9c297f60e22e3389 = function(n) {
    return function(p) {
        return Math.pow(n, p);
    };
};
const $9a14cd925227149d$export$159037f780d3415c = function(n) {
    return function(m) {
        return n % m;
    };
};
const $9a14cd925227149d$export$2077e0241d6afd3c = Math.round;
const $9a14cd925227149d$export$c5552dfdbc7cec71 = Math.sign ? Math.sign : function(x) {
    return x === 0 || x !== x ? x : x < 0 ? -1 : 1;
};
const $9a14cd925227149d$export$5de3937cb4b592ed = Math.sin;
const $9a14cd925227149d$export$eba8049fb5020b81 = Math.sqrt;
const $9a14cd925227149d$export$fcdd3b0b3246a325 = Math.tan;
const $9a14cd925227149d$export$1fe87bd59b089f0 = Math.trunc ? Math.trunc : function(x) {
    return x < 0 ? Math.ceil(x) : Math.floor(x);
};



var $052de1c85deb22bf$export$a4b4b4d4d776fe92 = 6.283185307179586;
var $052de1c85deb22bf$export$2fa35f36c870f3b7 = 1.4142135623730951;
var $052de1c85deb22bf$export$9eaf1e6179158e34 = 0.7071067811865476;
var $052de1c85deb22bf$export$18c7bea995a110f = 3.141592653589793;
var $052de1c85deb22bf$export$4d03748825f009b9 = 1.4426950408889634;
var $052de1c85deb22bf$export$4ca92b5d1d793bd5 = 0.4342944819032518;
var $052de1c85deb22bf$export$27692bafabcf0fdc = 0.6931471805599453;
var $052de1c85deb22bf$export$e1abf6863d05a89e = 2.302585092994046;
var $052de1c85deb22bf$export$3004f64547af360e = function(str) {
    return $9a14cd925227149d$export$3ffe08ccbe76f69e(str, $9a14cd925227149d$export$65f0b13f2f82375a, $06733ae99ed4f534$export$8a67b48435b5d073.create, $06733ae99ed4f534$export$bebe9059409a0d04.value);
};
var $052de1c85deb22bf$export$f1e1789686576879 = 2.718281828459045;




var $8d5664f12212b23e$var$top = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $8d5664f12212b23e$var$bottom = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $8d5664f12212b23e$var$Radix = function(x) {
    return x;
};
var $8d5664f12212b23e$export$33ca3b017f2e3089 = /* #__PURE__ */ function() {
    function Even() {}
    Even.value = new Even();
    return Even;
}();
var $8d5664f12212b23e$export$6bbc73627dceae86 = /* #__PURE__ */ function() {
    function Odd() {}
    Odd.value = new Odd();
    return Odd;
}();
var $8d5664f12212b23e$export$9f422d81718beff7 = {
    show: function(v) {
        if (v instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return "Even";
        if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return "Odd";
        throw new Error("Failed pattern match at Data.Int (line 117, column 1 - line 119, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $8d5664f12212b23e$export$1db3e511bfb04803 = function(n) {
    if (n >= 2 && n <= 36) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at Data.Int (line 198, column 1 - line 198, column 28): " + [
        n.constructor.name
    ]);
};
var $8d5664f12212b23e$export$74b48c691cc42eb1 = function(x) {
    return (x & 1) !== 0;
};
var $8d5664f12212b23e$export$90d8fbb029b06afc = 8;
var $8d5664f12212b23e$export$9c12a48020146abe = 16;
var $8d5664f12212b23e$export$d7a050b0311540b9 = /* #__PURE__ */ function() {
    return $4ab74a20512cef04$export$221b4f162df9878c($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $8d5664f12212b23e$export$3004f64547af360e = /* #__PURE__ */ $8d5664f12212b23e$export$d7a050b0311540b9(10);
var $8d5664f12212b23e$export$7bbb4164c9a77bc2 = /* #__PURE__ */ function() {
    return $4ab74a20512cef04$export$5b3229f64c38e483($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $8d5664f12212b23e$var$unsafeClamp = function(x) {
    if (!$9a14cd925227149d$export$65f0b13f2f82375a(x)) return 0;
    if (x >= $4ab74a20512cef04$export$a0a81dc3380ce7d3($8d5664f12212b23e$var$top)) return $8d5664f12212b23e$var$top;
    if (x <= $4ab74a20512cef04$export$a0a81dc3380ce7d3($8d5664f12212b23e$var$bottom)) return $8d5664f12212b23e$var$bottom;
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$43db023a260c5e9f(0)($8d5664f12212b23e$export$7bbb4164c9a77bc2(x));
    throw new Error("Failed pattern match at Data.Int (line 72, column 1 - line 72, column 29): " + [
        x.constructor.name
    ]);
};
var $8d5664f12212b23e$export$2077e0241d6afd3c = function($37) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$2077e0241d6afd3c($37));
};
var $8d5664f12212b23e$export$1fe87bd59b089f0 = function($38) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$1fe87bd59b089f0($38));
};
var $8d5664f12212b23e$export$a3fe094919f356fd = function($39) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$a3fe094919f356fd($39));
};
var $8d5664f12212b23e$export$df5fefc55a4eba3c = function(x) {
    return (x & 1) === 0;
};
var $8d5664f12212b23e$export$efe353078db02e10 = function(n) {
    var $28 = $8d5664f12212b23e$export$df5fefc55a4eba3c(n);
    if ($28) return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
    return $8d5664f12212b23e$export$6bbc73627dceae86.value;
};
var $8d5664f12212b23e$export$8424267183f54e9d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089 && y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return true;
            if (x instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && y instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return true;
            return false;
        };
    }
};
var $8d5664f12212b23e$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($8d5664f12212b23e$export$8424267183f54e9d);
var $8d5664f12212b23e$export$8b12bf30fdd3264f = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089 && y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && y instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.Int (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $8d5664f12212b23e$export$8424267183f54e9d;
    }
};
var $8d5664f12212b23e$export$39d55cbe74216cbe = /* #__PURE__ */ function() {
    return {
        zero: $8d5664f12212b23e$export$33ca3b017f2e3089.value,
        add: function(x) {
            return function(y) {
                var $33 = $8d5664f12212b23e$var$eq1(x)(y);
                if ($33) return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
                return $8d5664f12212b23e$export$6bbc73627dceae86.value;
            };
        },
        one: $8d5664f12212b23e$export$6bbc73627dceae86.value,
        mul: function(v) {
            return function(v1) {
                if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && v1 instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return $8d5664f12212b23e$export$6bbc73627dceae86.value;
                return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
            };
        }
    };
}();
var $8d5664f12212b23e$export$e741c28ebd8a3552 = {
    sub: /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($8d5664f12212b23e$export$39d55cbe74216cbe),
    Semiring0: function() {
        return $8d5664f12212b23e$export$39d55cbe74216cbe;
    }
};
var $8d5664f12212b23e$export$5bd06fe87b344eef = {
    recip: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Ring0: function() {
        return $8d5664f12212b23e$export$e741c28ebd8a3552;
    }
};
var $8d5664f12212b23e$export$78a48a3d1e5dbe89 = 10;
var $8d5664f12212b23e$export$cf50720682a32a87 = {
    Ring0: function() {
        return $8d5664f12212b23e$export$e741c28ebd8a3552;
    }
};
var $8d5664f12212b23e$export$965db879d0c14bc1 = {
    degree: function(v) {
        if (v instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return 0;
        if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return 1;
        throw new Error("Failed pattern match at Data.Int (line 137, column 1 - line 141, column 17): " + [
            v.constructor.name
        ]);
    },
    div: function(x) {
        return function(v) {
            return x;
        };
    },
    mod: function(v) {
        return function(v1) {
            return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
        };
    },
    CommutativeRing0: function() {
        return $8d5664f12212b23e$export$cf50720682a32a87;
    }
};
var $8d5664f12212b23e$export$803ce6b71a0a94b2 = function($40) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$803ce6b71a0a94b2($40));
};
var $8d5664f12212b23e$export$fc5d11f6ca2bf4fc = /* #__PURE__ */ function() {
    return {
        bottom: $8d5664f12212b23e$export$33ca3b017f2e3089.value,
        top: $8d5664f12212b23e$export$6bbc73627dceae86.value,
        Ord0: function() {
            return $8d5664f12212b23e$export$8b12bf30fdd3264f;
        }
    };
}();
var $8d5664f12212b23e$export$33902b7329277358 = 2;
var $8d5664f12212b23e$export$95b61e7c39ae893a = 36;







// Generated by purs version 0.15.15
const $092fe44bc0883be6$export$709e3b51bf2e2249 = function(a) {
    return a.join("");
};
const $092fe44bc0883be6$export$f718f38b069557c4 = function(s) {
    return s.split("");
};
const $092fe44bc0883be6$export$439306a4dcaafbb9 = function(c) {
    return c;
};
const $092fe44bc0883be6$export$f23b62aaf3f3dcce = function(just) {
    return function(nothing) {
        return function(i) {
            return function(s) {
                return i >= 0 && i < s.length ? just(s.charAt(i)) : nothing;
            };
        };
    };
};
const $092fe44bc0883be6$export$dc80a44c5e0495a = function(just) {
    return function(nothing) {
        return function(s) {
            return s.length === 1 ? just(s) : nothing;
        };
    };
};
const $092fe44bc0883be6$export$f24224f1c91d8156 = function(s) {
    return s.length;
};
const $092fe44bc0883be6$export$29a68f758c141c85 = function(p) {
    return function(s) {
        var i = 0;
        while(i < s.length && p(s.charAt(i)))i++;
        return i;
    };
};
const $092fe44bc0883be6$export$7e78e83ef6946ae3 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(s) {
                var i = s.indexOf(x);
                return i === -1 ? nothing : just(i);
            };
        };
    };
};
const $092fe44bc0883be6$export$dbaa25b6da818165 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(startAt) {
                return function(s) {
                    if (startAt < 0 || startAt > s.length) return nothing;
                    var i = s.indexOf(x, startAt);
                    return i === -1 ? nothing : just(i);
                };
            };
        };
    };
};
const $092fe44bc0883be6$export$a83518545dfc0fc1 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(s) {
                var i = s.lastIndexOf(x);
                return i === -1 ? nothing : just(i);
            };
        };
    };
};
const $092fe44bc0883be6$export$12738dfb878f3de0 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(startAt) {
                return function(s) {
                    var i = s.lastIndexOf(x, startAt);
                    return i === -1 ? nothing : just(i);
                };
            };
        };
    };
};
const $092fe44bc0883be6$export$b7df5d561049483a = function(n) {
    return function(s) {
        return s.substr(0, n);
    };
};
const $092fe44bc0883be6$export$663103110d94aac9 = function(n) {
    return function(s) {
        return s.substring(n);
    };
};
const $092fe44bc0883be6$export$58adb3bec8346d0f = function(b) {
    return function(e) {
        return function(s) {
            return s.slice(b, e);
        };
    };
};
const $092fe44bc0883be6$export$b0d75975ac0be0e1 = function(i) {
    return function(s) {
        return {
            before: s.substring(0, i),
            after: s.substring(i)
        };
    };
};



// Generated by purs version 0.15.15
const $3296d29fc7ea4822$export$bbcf894add1d392c = function(i) {
    return function(s) {
        if (i >= 0 && i < s.length) return s.charAt(i);
        throw new Error("Data.String.Unsafe.charAt: Invalid index.");
    };
};
const $3296d29fc7ea4822$export$eba6f6f03b0a92e7 = function(s) {
    if (s.length === 1) return s.charAt(0);
    throw new Error("Data.String.Unsafe.char: Expected string of length 1.");
};




var $1a77d6934b592676$export$b446f6baa3bb1430 = function(v) {
    if (v === "") return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: $3296d29fc7ea4822$export$bbcf894add1d392c(0)(v),
        tail: $092fe44bc0883be6$export$663103110d94aac9(1)(v)
    });
};
var $1a77d6934b592676$export$bafb3da1554990db = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$dc80a44c5e0495a($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$9384c7afe4015e42 = function(p) {
    return function(s) {
        return $092fe44bc0883be6$export$b7df5d561049483a($092fe44bc0883be6$export$29a68f758c141c85(p)(s))(s);
    };
};
var $1a77d6934b592676$export$1bbc425ddca7f2c6 = function(i) {
    return function(s) {
        return $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156(s) - i | 0)(s);
    };
};
var $1a77d6934b592676$export$cc5663efaab5bcf6 = function(v) {
    return function(str) {
        var v1 = $092fe44bc0883be6$export$b0d75975ac0be0e1($092fe44bc0883be6$export$f24224f1c91d8156(str) - $092fe44bc0883be6$export$f24224f1c91d8156(v) | 0)(str);
        var $14 = v1.after === v;
        if ($14) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.before);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
};
var $1a77d6934b592676$export$71c2a1babd78d286 = function(v) {
    return function(str) {
        var v1 = $092fe44bc0883be6$export$b0d75975ac0be0e1($092fe44bc0883be6$export$f24224f1c91d8156(v))(str);
        var $20 = v1.before === v;
        if ($20) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.after);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
};
var $1a77d6934b592676$export$9dc3eed83bb14216 = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$12738dfb878f3de0($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$557cfb7ed375eeb7 = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$a83518545dfc0fc1($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$7f0e23922170149a = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$dbaa25b6da818165($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$305f7d4e9d4624f2 = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$7e78e83ef6946ae3($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$533af5c8cd6afa16 = function(p) {
    return function(s) {
        return $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$29a68f758c141c85(p)(s))(s);
    };
};
var $1a77d6934b592676$export$6ba801e3e123536e = function(i) {
    return function(s) {
        return $092fe44bc0883be6$export$b7df5d561049483a($092fe44bc0883be6$export$f24224f1c91d8156(s) - i | 0)(s);
    };
};
var $1a77d6934b592676$export$2344b14b097df817 = function(pat) {
    var $23 = $1a77d6934b592676$export$305f7d4e9d4624f2(pat);
    return function($24) {
        return $06733ae99ed4f534$export$c15bd07a493e1236($23($24));
    };
};
var $1a77d6934b592676$export$bbcf894add1d392c = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$f23b62aaf3f3dcce($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();



var $c97d2d0f578f81ad$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $c97d2d0f578f81ad$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $c97d2d0f578f81ad$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $c97d2d0f578f81ad$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c97d2d0f578f81ad$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $c97d2d0f578f81ad$export$f6a37cc43a8b8898 = /* #__PURE__ */ function() {
    function ForeignError(value0) {
        this.value0 = value0;
    }
    ForeignError.create = function(value0) {
        return new ForeignError(value0);
    };
    return ForeignError;
}();
var $c97d2d0f578f81ad$export$168e2d3b16829a = /* #__PURE__ */ function() {
    function TypeMismatch(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TypeMismatch.create = function(value0) {
        return function(value1) {
            return new TypeMismatch(value0, value1);
        };
    };
    return TypeMismatch;
}();
var $c97d2d0f578f81ad$export$20d9a5af040a79f1 = /* #__PURE__ */ function() {
    function ErrorAtIndex(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtIndex.create = function(value0) {
        return function(value1) {
            return new ErrorAtIndex(value0, value1);
        };
    };
    return ErrorAtIndex;
}();
var $c97d2d0f578f81ad$export$92e5795aa905bd26 = /* #__PURE__ */ function() {
    function ErrorAtProperty(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtProperty.create = function(value0) {
        return function(value1) {
            return new ErrorAtProperty(value0, value1);
        };
    };
    return ErrorAtProperty;
}();
var $c97d2d0f578f81ad$export$9d82982d31d9d171 = $ac8b3532514ac019$export$401372c57776dc;
var $c97d2d0f578f81ad$export$19df04dfac508e15 = $ac8b3532514ac019$export$401372c57776dc;
var $c97d2d0f578f81ad$export$ca110433ecb89bbf = {
    show: function(v) {
        if (v instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return "(ForeignError " + ($c97d2d0f578f81ad$var$show(v.value0) + ")");
        if (v instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return "(ErrorAtIndex " + ($c97d2d0f578f81ad$var$show1(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($c97d2d0f578f81ad$export$ca110433ecb89bbf)(v.value1) + ")")));
        if (v instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return "(ErrorAtProperty " + ($c97d2d0f578f81ad$var$show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($c97d2d0f578f81ad$export$ca110433ecb89bbf)(v.value1) + ")")));
        if (v instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return "(TypeMismatch " + ($c97d2d0f578f81ad$var$show(v.value0) + (" " + ($c97d2d0f578f81ad$var$show(v.value1) + ")")));
        throw new Error("Failed pattern match at Foreign (line 69, column 1 - line 73, column 89): " + [
            v.constructor.name
        ]);
    }
};
var $c97d2d0f578f81ad$export$a2293656e769bd56 = function(v) {
    if (v instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return v.value0;
    if (v instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return "Error at array index " + ($c97d2d0f578f81ad$var$show1(v.value0) + (": " + $c97d2d0f578f81ad$export$a2293656e769bd56(v.value1)));
    if (v instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return "Error at property " + ($c97d2d0f578f81ad$var$show(v.value0) + (": " + $c97d2d0f578f81ad$export$a2293656e769bd56(v.value1)));
    if (v instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return "Type mismatch: expected " + (v.value0 + (", found " + v.value1));
    throw new Error("Failed pattern match at Foreign (line 78, column 1 - line 78, column 45): " + [
        v.constructor.name
    ]);
};
var $c97d2d0f578f81ad$export$4e0f52105ee4b19b = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$fce6876652108ab(value)) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(value));
        throw new Error("Failed pattern match at Foreign (line 174, column 1 - line 174, column 103): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$a540325489296c24 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$630801d484da15df(value) || $c2c5bfcfd98ddabb$export$fce6876652108ab(value)) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(value));
        throw new Error("Failed pattern match at Foreign (line 179, column 1 - line 179, column 109): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$62e87727fba30d8d = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$630801d484da15df(value)) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(value));
        throw new Error("Failed pattern match at Foreign (line 169, column 1 - line 169, column 98): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$2b62a06a9fee979c = function(dictMonad) {
    var $153 = $5dfefa023749ded0$export$8bf7aba4a9e09055($d2284b2d3e1b6f87$export$75f89ba5e7a712b0(dictMonad));
    return function($154) {
        return $153($ba51d599f79a6310$export$439306a4dcaafbb9($154));
    };
};
var $c97d2d0f578f81ad$export$d3f4ca0e55363719 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    var fail1 = $c97d2d0f578f81ad$export$2b62a06a9fee979c(dictMonad);
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$43bee75e5e14138e(value)) return pure1($c97d2d0f578f81ad$export$19df04dfac508e15(value));
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return fail1(new $c97d2d0f578f81ad$export$168e2d3b16829a("array", $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value)));
        throw new Error("Failed pattern match at Foreign (line 164, column 1 - line 164, column 99): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$6190f2182377b437 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    var fail1 = $c97d2d0f578f81ad$export$2b62a06a9fee979c(dictMonad);
    return function(tag) {
        return function(value) {
            if ($c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value) === tag) return pure1($c97d2d0f578f81ad$export$19df04dfac508e15(value));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return fail1(new $c97d2d0f578f81ad$export$168e2d3b16829a(tag, $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value)));
            throw new Error("Failed pattern match at Foreign (line 123, column 1 - line 123, column 104): " + [
                tag.constructor.name,
                value.constructor.name
            ]);
        };
    };
};
var $c97d2d0f578f81ad$export$f9a84177eae95ed5 = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("Boolean");
};
var $c97d2d0f578f81ad$export$347fd215c36b10be = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("Number");
};
var $c97d2d0f578f81ad$export$ac3747cb00139c63 = function(dictMonad) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var readNumber1 = $c97d2d0f578f81ad$export$347fd215c36b10be(dictMonad);
    return function(value) {
        var error = new $7d4cccdf062a2261$export$37c4d04eafdc5515($ba51d599f79a6310$export$439306a4dcaafbb9(new $c97d2d0f578f81ad$export$168e2d3b16829a("Int", $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value))));
        var fromNumber = function() {
            var $155 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(error)($c97d2d0f578f81ad$var$pure);
            return function($156) {
                return $155($8d5664f12212b23e$export$7bbb4164c9a77bc2($156));
            };
        }();
        return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(map($7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(error))(fromNumber)))(readNumber1(value));
    };
};
var $c97d2d0f578f81ad$export$dda73877cb166cd3 = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("String");
};
var $c97d2d0f578f81ad$export$85b98eeba3f0a3b4 = function(dictMonad) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var readString1 = $c97d2d0f578f81ad$export$dda73877cb166cd3(dictMonad);
    return function(value) {
        var error = new $7d4cccdf062a2261$export$37c4d04eafdc5515($ba51d599f79a6310$export$439306a4dcaafbb9(new $c97d2d0f578f81ad$export$168e2d3b16829a("Char", $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value))));
        var fromString = function() {
            var $157 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(error)($c97d2d0f578f81ad$var$pure);
            return function($158) {
                return $157($1a77d6934b592676$export$bafb3da1554990db($158));
            };
        }();
        return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(map($7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(error))(fromString)))(readString1(value));
    };
};
var $c97d2d0f578f81ad$export$29dc7ef345289543 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898 && y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return x.value0 === y.value0;
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a && y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return x.value0 === y.value0 && x.value1 === y.value1;
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1 && y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($c97d2d0f578f81ad$export$29dc7ef345289543)(x.value1)(y.value1);
            if (x instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26 && y instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($c97d2d0f578f81ad$export$29dc7ef345289543)(x.value1)(y.value1);
            return false;
        };
    }
};
var $c97d2d0f578f81ad$export$661e78eef4f027af = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898 && y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a && y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) {
                var v = $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $c97d2d0f578f81ad$var$compare(x.value1)(y.value1);
            }
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1 && y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) {
                var v = $c97d2d0f578f81ad$var$compare1(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($c97d2d0f578f81ad$export$661e78eef4f027af)(x.value1)(y.value1);
            }
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26 && y instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) {
                var v = $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($c97d2d0f578f81ad$export$661e78eef4f027af)(x.value1)(y.value1);
            }
            throw new Error("Failed pattern match at Foreign (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c97d2d0f578f81ad$export$29dc7ef345289543;
    }
};


// Generated by purs version 0.15.15
const $168314f2e0d9b3ad$export$b26131a6779b8150 = JSON.parse;
const $168314f2e0d9b3ad$export$60e4c9fe67803d40 = undefined;
const $168314f2e0d9b3ad$export$26ae6b8f971b1722 = JSON.stringify;










// Generated by purs version 0.15.15

// Generated by purs version 0.15.15
//------------------------------------------------------------------------------
// Array creation --------------------------------------------------------------
//------------------------------------------------------------------------------
const $fc8c1182ec2aefec$export$3561205b7dff20bf = function(start, end) {
    var step = start > end ? -1 : 1;
    var result = new Array(step * (end - start) + 1);
    var i = start, n = 0;
    while(i !== end){
        result[n++] = i;
        i += step;
    }
    result[n] = i;
    return result;
};
var $fc8c1182ec2aefec$var$replicateFill = function(count, value) {
    if (count < 1) return [];
    var result = new Array(count);
    return result.fill(value);
};
var $fc8c1182ec2aefec$var$replicatePolyfill = function(count, value) {
    var result = [];
    var n = 0;
    for(var i = 0; i < count; i++)result[n++] = value;
    return result;
};
const $fc8c1182ec2aefec$export$86a7d437bed76c03 = typeof Array.prototype.fill === "function" ? $fc8c1182ec2aefec$var$replicateFill : $fc8c1182ec2aefec$var$replicatePolyfill;
const $fc8c1182ec2aefec$export$7de5ece11b723a44 = function() {
    function Cons(head, tail) {
        this.head = head;
        this.tail = tail;
    }
    var emptyList = {};
    function curryCons(head) {
        return function(tail) {
            return new Cons(head, tail);
        };
    }
    function listToArray(list) {
        var result = [];
        var count = 0;
        var xs = list;
        while(xs !== emptyList){
            result[count++] = xs.head;
            xs = xs.tail;
        }
        return result;
    }
    return function(foldr, xs) {
        return listToArray(foldr(curryCons)(emptyList)(xs));
    };
}();
const $fc8c1182ec2aefec$export$f24224f1c91d8156 = function(xs) {
    return xs.length;
};
const $fc8c1182ec2aefec$export$99063656965a82f5 = function(empty, next, xs) {
    return xs.length === 0 ? empty({}) : next(xs[0])(xs.slice(1));
};
const $fc8c1182ec2aefec$export$fe8606c16d7ceed6 = function(just, nothing, xs, i) {
    return i < 0 || i >= xs.length ? nothing : just(xs[i]);
};
const $fc8c1182ec2aefec$export$7ad327e9a65b0147 = function(nothing, isJust, f, xs) {
    for(var i = 0; i < xs.length; i++){
        var result = f(xs[i]);
        if (isJust(result)) return result;
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$885b84ba169666c7 = function(just, nothing, f, xs) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (f(xs[i])) return just(i);
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$32bcb9f71841245e = function(just, nothing, f, xs) {
    for(var i = xs.length - 1; i >= 0; i--){
        if (f(xs[i])) return just(i);
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$d553b0efc2008003 = function(just, nothing, i, a, l) {
    if (i < 0 || i > l.length) return nothing;
    var l1 = l.slice();
    l1.splice(i, 0, a);
    return just(l1);
};
const $fc8c1182ec2aefec$export$e83371a4d1b4407c = function(just, nothing, i, l) {
    if (i < 0 || i >= l.length) return nothing;
    var l1 = l.slice();
    l1.splice(i, 1);
    return just(l1);
};
const $fc8c1182ec2aefec$export$4bc13c05b5f586d5 = function(just, nothing, i, a, l) {
    if (i < 0 || i >= l.length) return nothing;
    var l1 = l.slice();
    l1[i] = a;
    return just(l1);
};
const $fc8c1182ec2aefec$export$66c1ae025e96b4bc = function(l) {
    return l.slice().reverse();
};
const $fc8c1182ec2aefec$export$ee1b3e54f0441b22 = function(xss) {
    if (xss.length <= 10000) // This method is faster, but it crashes on big arrays.
    // So we use it when can and fallback to simple variant otherwise.
    return Array.prototype.concat.apply([], xss);
    var result = [];
    for(var i = 0, l = xss.length; i < l; i++){
        var xs = xss[i];
        for(var j = 0, m = xs.length; j < m; j++)result.push(xs[j]);
    }
    return result;
};
const $fc8c1182ec2aefec$export$e85b5b674fbfff84 = function(f, xs) {
    return xs.filter(f);
};
const $fc8c1182ec2aefec$export$25718970d830661a = function(f, xs) {
    var yes = [];
    var no = [];
    for(var i = 0; i < xs.length; i++){
        var x = xs[i];
        if (f(x)) yes.push(x);
        else no.push(x);
    }
    return {
        yes: yes,
        no: no
    };
};
const $fc8c1182ec2aefec$export$53974fb866918d71 = function(f, b, xs) {
    var len = xs.length;
    var acc = b;
    var out = new Array(len);
    for(var i = 0; i < len; i++){
        acc = f(acc)(xs[i]);
        out[i] = acc;
    }
    return out;
};
const $fc8c1182ec2aefec$export$771bbc3bb9be46c2 = function(f, b, xs) {
    var len = xs.length;
    var acc = b;
    var out = new Array(len);
    for(var i = len - 1; i >= 0; i--){
        acc = f(xs[i])(acc);
        out[i] = acc;
    }
    return out;
};
const $fc8c1182ec2aefec$export$ea0922e78a1b008a = function() {
    function mergeFromTo(compare, fromOrdering, xs1, xs2, from, to) {
        var mid;
        var i;
        var j;
        var k;
        var x;
        var y;
        var c;
        mid = from + (to - from >> 1);
        if (mid - from > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, from, mid);
        if (to - mid > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, mid, to);
        i = from;
        j = mid;
        k = from;
        while(i < mid && j < to){
            x = xs2[i];
            y = xs2[j];
            c = fromOrdering(compare(x)(y));
            if (c > 0) {
                xs1[k++] = y;
                ++j;
            } else {
                xs1[k++] = x;
                ++i;
            }
        }
        while(i < mid)xs1[k++] = xs2[i++];
        while(j < to)xs1[k++] = xs2[j++];
    }
    return function(compare, fromOrdering, xs) {
        var out;
        if (xs.length < 2) return xs;
        out = xs.slice(0);
        mergeFromTo(compare, fromOrdering, out, xs.slice(0), 0, xs.length);
        return out;
    };
}();
const $fc8c1182ec2aefec$export$4bdf1ac3fa5d3d6a = function(s, e, l) {
    return l.slice(s, e);
};
const $fc8c1182ec2aefec$export$67fd4cff6f1e6bc = function(f, xs, ys) {
    var l = xs.length < ys.length ? xs.length : ys.length;
    var result = new Array(l);
    for(var i = 0; i < l; i++)result[i] = f(xs[i])(ys[i]);
    return result;
};
const $fc8c1182ec2aefec$export$b98f41a67d1483f3 = function(p, xs) {
    var len = xs.length;
    for(var i = 0; i < len; i++){
        if (p(xs[i])) return true;
    }
    return false;
};
const $fc8c1182ec2aefec$export$739e1ef870df7d82 = function(p, xs) {
    var len = xs.length;
    for(var i = 0; i < len; i++){
        if (!p(xs[i])) return false;
    }
    return true;
};
const $fc8c1182ec2aefec$export$4459d383cf3fd31d = function(xs, n) {
    return xs[n];
};










// Generated by purs version 0.15.15
function $0dbe0c7353bd68b1$export$b8cb59497041ffe4() {
    return [];
}
const $0dbe0c7353bd68b1$export$6dc5f95d8548a16a = function(just, nothing, i, xs) {
    return i >= 0 && i < xs.length ? just(xs[i]) : nothing;
};
const $0dbe0c7353bd68b1$export$284bbde9874b0917 = function(i, a, xs) {
    var ret = i >= 0 && i < xs.length;
    if (ret) xs[i] = a;
    return ret;
};
const $0dbe0c7353bd68b1$export$b0d1de20d482ef7d = function(xs) {
    return xs.length;
};
const $0dbe0c7353bd68b1$export$636ddc1660dd1285 = function(just, nothing, xs) {
    return xs.length > 0 ? just(xs.pop()) : nothing;
};
const $0dbe0c7353bd68b1$export$f8b776ba78ff4419 = function(as, xs) {
    return xs.push.apply(xs, as);
};
const $0dbe0c7353bd68b1$export$8a1b3b221575bba8 = function(just, nothing, xs) {
    return xs.length > 0 ? just(xs.shift()) : nothing;
};
const $0dbe0c7353bd68b1$export$23e87bb70af50c39 = function(as, xs) {
    return xs.unshift.apply(xs, as);
};
const $0dbe0c7353bd68b1$export$b05cd45ffb08c41e = function(i, howMany, bs, xs) {
    return xs.splice.apply(xs, [
        i,
        howMany
    ].concat(bs));
};
function $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl(xs) {
    return xs;
}
const $0dbe0c7353bd68b1$export$f2963aff015afecf = $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl;
const $0dbe0c7353bd68b1$export$601e856cb1838137 = $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl;
function $0dbe0c7353bd68b1$var$copyImpl(xs) {
    return xs.slice();
}
const $0dbe0c7353bd68b1$export$2109af1090f5f6b7 = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$cd8ba9f9707c2718 = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$57a1a2542c1220dc = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$ea0922e78a1b008a = function() {
    function mergeFromTo(compare, fromOrdering, xs1, xs2, from, to) {
        var mid;
        var i;
        var j;
        var k;
        var x;
        var y;
        var c;
        mid = from + (to - from >> 1);
        if (mid - from > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, from, mid);
        if (to - mid > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, mid, to);
        i = from;
        j = mid;
        k = from;
        while(i < mid && j < to){
            x = xs2[i];
            y = xs2[j];
            c = fromOrdering(compare(x)(y));
            if (c > 0) {
                xs1[k++] = y;
                ++j;
            } else {
                xs1[k++] = x;
                ++i;
            }
        }
        while(i < mid)xs1[k++] = xs2[i++];
        while(j < to)xs1[k++] = xs2[j++];
    }
    return function(compare, fromOrdering, xs) {
        if (xs.length < 2) return xs;
        mergeFromTo(compare, fromOrdering, xs, xs.slice(0), 0, xs.length);
        return xs;
    };
}();
const $0dbe0c7353bd68b1$export$66323db02f2496b6 = function(xs) {
    var n = xs.length;
    var as = new Array(n);
    for(var i = 0; i < n; i++)as[i] = {
        value: xs[i],
        index: i
    };
    return as;
};
const $0dbe0c7353bd68b1$export$80f4edbb06ec8379 = function(a, xs) {
    return xs.push(a);
};




// Generated by purs version 0.15.15
const $cc20365e325869f4$export$d092af9ac17843bc = function mkSTFn1(fn) {
    return function(x) {
        return fn(x)();
    };
};
const $cc20365e325869f4$export$6a3a9c423c2be31e = function mkSTFn2(fn) {
    return function(a, b) {
        return fn(a)(b)();
    };
};
const $cc20365e325869f4$export$20b99d064a00c9ee = function mkSTFn3(fn) {
    return function(a, b, c) {
        return fn(a)(b)(c)();
    };
};
const $cc20365e325869f4$export$88b7720b4d616633 = function mkSTFn4(fn) {
    return function(a, b, c, d) {
        return fn(a)(b)(c)(d)();
    };
};
const $cc20365e325869f4$export$ff210326ba56123c = function mkSTFn5(fn) {
    return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e)();
    };
};
const $cc20365e325869f4$export$1df8279312f4490c = function mkSTFn6(fn) {
    return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f)();
    };
};
const $cc20365e325869f4$export$c438f7da82a827de = function mkSTFn7(fn) {
    return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g)();
    };
};
const $cc20365e325869f4$export$8016275d609fc2cf = function mkSTFn8(fn) {
    return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)();
    };
};
const $cc20365e325869f4$export$85672cd282a38b9f = function mkSTFn9(fn) {
    return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)();
    };
};
const $cc20365e325869f4$export$1e8732a765f7f6a9 = function mkSTFn10(fn) {
    return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)();
    };
};
const $cc20365e325869f4$export$16973cca6f004709 = function runSTFn1(fn) {
    return function(a) {
        return function() {
            return fn(a);
        };
    };
};
const $cc20365e325869f4$export$67ab494f009454e2 = function runSTFn2(fn) {
    return function(a) {
        return function(b) {
            return function() {
                return fn(a, b);
            };
        };
    };
};
const $cc20365e325869f4$export$d02c4697b083e08e = function runSTFn3(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function() {
                    return fn(a, b, c);
                };
            };
        };
    };
};
const $cc20365e325869f4$export$38a1b097838c69d7 = function runSTFn4(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function() {
                        return fn(a, b, c, d);
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$df815fcba9ace1f4 = function runSTFn5(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function() {
                            return fn(a, b, c, d, e);
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$18e87184adad44fe = function runSTFn6(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function() {
                                return fn(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$e282c4050f6499d3 = function runSTFn7(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function() {
                                    return fn(a, b, c, d, e, f, g);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$1d03302402d80b8a = function runSTFn8(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function() {
                                        return fn(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$9671bb34351fe15d = function runSTFn9(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function() {
                                            return fn(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$54118f4544b4eca2 = function runSTFn10(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return function() {
                                                return fn(a, b, c, d, e, f, g, h, i, j);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};







var $784e144d56146b5c$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($08944f7287e2704c$export$14049c9ff5b55fb3);
var $784e144d56146b5c$export$8ff712f7409e81c7 = /* #__PURE__ */ $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$23e87bb70af50c39);
var $784e144d56146b5c$export$37cdb546b806ae87 = function(a) {
    return $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$23e87bb70af50c39)([
        a
    ]);
};
var $784e144d56146b5c$export$cc9b8725eef9c137 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$601e856cb1838137);
var $784e144d56146b5c$export$7c850c5af9b9983e = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$f2963aff015afecf);
var $784e144d56146b5c$export$a8793e37025aca3d = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$66323db02f2496b6);
var $784e144d56146b5c$export$80340c06f76ce783 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$cd8ba9f9707c2718);
var $784e144d56146b5c$export$fd51609fe570ea92 = function(f) {
    return function(xs) {
        return function __do() {
            var result = $784e144d56146b5c$export$80340c06f76ce783(xs)();
            f(result)();
            return $784e144d56146b5c$export$7c850c5af9b9983e(result)();
        };
    };
};
var $784e144d56146b5c$export$869882364835d202 = /* #__PURE__ */ $cc20365e325869f4$export$38a1b097838c69d7($0dbe0c7353bd68b1$export$b05cd45ffb08c41e);
var $784e144d56146b5c$export$b035e44d7bb4278f = function(comp) {
    return $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$ea0922e78a1b008a)(comp)(function(v) {
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return 1;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 0;
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return -1;
        throw new Error("Failed pattern match at Data.Array.ST (line 129, column 40 - line 132, column 11): " + [
            v.constructor.name
        ]);
    });
};
var $784e144d56146b5c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var comparing = $97937c29f879e68e$export$e9509a298f6befc2(dictOrd);
    return function(f) {
        return $784e144d56146b5c$export$b035e44d7bb4278f(comparing(f));
    };
};
var $784e144d56146b5c$export$97db5808d8f88186 = function(dictOrd) {
    return $784e144d56146b5c$export$b035e44d7bb4278f($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $784e144d56146b5c$export$fba63a578e423eb = /* #__PURE__ */ function() {
    return $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$8a1b3b221575bba8)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $784e144d56146b5c$export$889ea624f2cb2c57 = function(st) {
    return $784e144d56146b5c$var$bind(st)($784e144d56146b5c$export$7c850c5af9b9983e)();
};
var $784e144d56146b5c$export$907644183e99da16 = /* #__PURE__ */ $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$f8b776ba78ff4419);
var $784e144d56146b5c$export$4cbf152802aa238 = /* #__PURE__ */ $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$80f4edbb06ec8379);
var $784e144d56146b5c$export$3e41007ebfff0e64 = /* #__PURE__ */ function() {
    return $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$636ddc1660dd1285)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $784e144d56146b5c$export$dc13bdd74c909d26 = /* #__PURE__ */ $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$284bbde9874b0917);
var $784e144d56146b5c$export$4d3fb11e950abb9e = /* #__PURE__ */ function() {
    return $cc20365e325869f4$export$38a1b097838c69d7($0dbe0c7353bd68b1$export$6dc5f95d8548a16a)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $784e144d56146b5c$export$3ff57735a52b8713 = function(i) {
    return function(f) {
        return function(xs) {
            return function __do() {
                var entry = $784e144d56146b5c$export$4d3fb11e950abb9e(i)(xs)();
                if (entry instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $784e144d56146b5c$export$dc13bdd74c909d26(i)(f(entry.value0))(xs)();
                if (entry instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
                throw new Error("Failed pattern match at Data.Array.ST (line 234, column 3 - line 236, column 26): " + [
                    entry.constructor.name
                ]);
            };
        };
    };
};
var $784e144d56146b5c$export$f24224f1c91d8156 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$b0d1de20d482ef7d);
var $784e144d56146b5c$export$792f3d81ea979f55 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$2109af1090f5f6b7);
var $784e144d56146b5c$export$9cd59f9826255e47 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$57a1a2542c1220dc);


// Generated by purs version 0.15.15






var $8dd172f1ebfb42af$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($08944f7287e2704c$export$a47991927f51461e);
var $8dd172f1ebfb42af$var$not = /* #__PURE__ */ $f8fc227945eb179e$export$6003a5f097c73977($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $8dd172f1ebfb42af$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $8dd172f1ebfb42af$var$Iterator = /* #__PURE__ */ function() {
    function Iterator(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Iterator.create = function(value0) {
        return function(value1) {
            return new Iterator(value0, value1);
        };
    };
    return Iterator;
}();
var $8dd172f1ebfb42af$export$4d3fb11e950abb9e = function(v) {
    return function __do() {
        var i = $f11e5cd39add8df2$export$aafa59e2e03f2942(v.value1)();
        return v.value0(i);
    };
};
var $8dd172f1ebfb42af$export$48cfd1e771a65c4f = function(v) {
    return function __do() {
        var i = $f11e5cd39add8df2$export$aafa59e2e03f2942(v.value1)();
        $08944f7287e2704c$export$3ff57735a52b8713(function(v1) {
            return v1 + 1 | 0;
        })(v.value1)();
        return v.value0(i);
    };
};
var $8dd172f1ebfb42af$export$f458d78453dee163 = function(p) {
    return function(iter) {
        return function(array) {
            return function __do() {
                var $$break = $f11e5cd39add8df2$export$b8cb59497041ffe4(false)();
                while($8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$not)($f11e5cd39add8df2$export$aafa59e2e03f2942($$break))())(function __do() {
                    var mx = $8dd172f1ebfb42af$export$4d3fb11e950abb9e(iter)();
                    if (mx instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && p(mx.value0)) {
                        $784e144d56146b5c$export$4cbf152802aa238(mx.value0)(array)();
                        return $8dd172f1ebfb42af$var$$$void($8dd172f1ebfb42af$export$48cfd1e771a65c4f(iter))();
                    }
                    return $8dd172f1ebfb42af$var$$$void($f11e5cd39add8df2$export$68d8715fc104d294(true)($$break))();
                })();
                return {};
            };
        };
    };
};
var $8dd172f1ebfb42af$export$907644183e99da16 = /* #__PURE__ */ $8dd172f1ebfb42af$export$f458d78453dee163(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $8dd172f1ebfb42af$export$6f58e2338da23f4d = function(f) {
    return $8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$Iterator.create(f))($f11e5cd39add8df2$export$b8cb59497041ffe4(0));
};
var $8dd172f1ebfb42af$export$c1a059043cc9c119 = function(iter) {
    return function(f) {
        return function __do() {
            var $$break = $f11e5cd39add8df2$export$b8cb59497041ffe4(false)();
            while($8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$not)($f11e5cd39add8df2$export$aafa59e2e03f2942($$break))())(function __do() {
                var mx = $8dd172f1ebfb42af$export$48cfd1e771a65c4f(iter)();
                if (mx instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return f(mx.value0)();
                if (mx instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $8dd172f1ebfb42af$var$$$void($f11e5cd39add8df2$export$68d8715fc104d294(true)($$break))();
                throw new Error("Failed pattern match at Data.Array.ST.Iterator (line 42, column 5 - line 44, column 47): " + [
                    mx.constructor.name
                ]);
            })();
            return {};
        };
    };
};
var $8dd172f1ebfb42af$export$dc4133c4d1844d49 = /* #__PURE__ */ function() {
    var $20 = $8dd172f1ebfb42af$var$map($06733ae99ed4f534$export$4967676db1b89293);
    return function($21) {
        return $20($8dd172f1ebfb42af$export$4d3fb11e950abb9e($21));
    };
}();






// Generated by purs version 0.15.15
// module Data.Function.Uncurried
const $8f2697950ee155e1$export$c12d67bac152a4ed = function(fn) {
    return function() {
        return fn();
    };
};
const $8f2697950ee155e1$export$b12d5f1f5e196716 = function(fn) {
    /* jshint maxparams: 2 */ return function(a, b) {
        return fn(a)(b);
    };
};
const $8f2697950ee155e1$export$7c6645ed044f896a = function(fn) {
    /* jshint maxparams: 3 */ return function(a, b, c) {
        return fn(a)(b)(c);
    };
};
const $8f2697950ee155e1$export$f9fcbfb8cc9a5d08 = function(fn) {
    /* jshint maxparams: 4 */ return function(a, b, c, d) {
        return fn(a)(b)(c)(d);
    };
};
const $8f2697950ee155e1$export$253781be9f84fbc = function(fn) {
    /* jshint maxparams: 5 */ return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e);
    };
};
const $8f2697950ee155e1$export$5a7e13c76f011743 = function(fn) {
    /* jshint maxparams: 6 */ return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f);
    };
};
const $8f2697950ee155e1$export$72dc4a47844c2067 = function(fn) {
    /* jshint maxparams: 7 */ return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g);
    };
};
const $8f2697950ee155e1$export$f3e23d6db0ceb902 = function(fn) {
    /* jshint maxparams: 8 */ return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h);
    };
};
const $8f2697950ee155e1$export$d6fc3733d257ba4b = function(fn) {
    /* jshint maxparams: 9 */ return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i);
    };
};
const $8f2697950ee155e1$export$55270393dfa2c83f = function(fn) {
    /* jshint maxparams: 10 */ return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j);
    };
};
const $8f2697950ee155e1$export$6114565cacc4a539 = function(fn) {
    return fn();
};
const $8f2697950ee155e1$export$b3f66664347b6e8d = function(fn) {
    return function(a) {
        return function(b) {
            return fn(a, b);
        };
    };
};
const $8f2697950ee155e1$export$dd8987cb9f63b77e = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return fn(a, b, c);
            };
        };
    };
};
const $8f2697950ee155e1$export$c4d34fab9eba1901 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return fn(a, b, c, d);
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$ce6386a175247406 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return fn(a, b, c, d, e);
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$6764cfc4c1bcc63e = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return fn(a, b, c, d, e, f);
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$27ec8d6a229d5fae = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return fn(a, b, c, d, e, f, g);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$8a7620e07ee87dd2 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return fn(a, b, c, d, e, f, g, h);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$a68eb29a6e51700a = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return fn(a, b, c, d, e, f, g, h, i);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$182286db78b54e73 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return fn(a, b, c, d, e, f, g, h, i, j);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};


var $d587cad88c02b1d0$export$44d12d4204be2f8c = function(f) {
    return f;
};
var $d587cad88c02b1d0$export$31aab8bc8543af98 = function(f) {
    return f;
};











var $396c4c3d9e7fae3c$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$9e4a28683e28e26a);
var $396c4c3d9e7fae3c$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($08944f7287e2704c$export$603d84e49041d7b2);
var $396c4c3d9e7fae3c$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $396c4c3d9e7fae3c$var$intercalate1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$739ec22334c44788($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $396c4c3d9e7fae3c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $396c4c3d9e7fae3c$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $396c4c3d9e7fae3c$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($08944f7287e2704c$export$a47991927f51461e);
var $396c4c3d9e7fae3c$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $396c4c3d9e7fae3c$var$when = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$a55877ca9db47377($08944f7287e2704c$export$603d84e49041d7b2);
var $396c4c3d9e7fae3c$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($5026be88823ef1f4$export$82d306ead3b703cd);
var $396c4c3d9e7fae3c$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $396c4c3d9e7fae3c$var$foldMap1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$var$fold1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$93e2b83da34ff82a($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $396c4c3d9e7fae3c$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a);
var $396c4c3d9e7fae3c$export$b634740ce272acb5 = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$67fd4cff6f1e6bc);
var $396c4c3d9e7fae3c$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $396c4c3d9e7fae3c$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($396c4c3d9e7fae3c$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $396c4c3d9e7fae3c$export$b634740ce272acb5($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $396c4c3d9e7fae3c$export$f2a09b3ef2c0e257 = function(dictFoldable) {
    var traverse_1 = $396c4c3d9e7fae3c$var$traverse_(dictFoldable);
    return function(us) {
        return function(xs) {
            return $784e144d56146b5c$export$fd51609fe570ea92(function(res) {
                return traverse_1(function(v) {
                    return $784e144d56146b5c$export$dc13bdd74c909d26(v.value0)(v.value1)(res);
                })(us);
            })(xs)();
        };
    };
};
var $396c4c3d9e7fae3c$export$b6d8713d53419d4c = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$ce6386a175247406($fc8c1182ec2aefec$export$4bc13c05b5f586d5)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$90bcd20c17ae578e = function() {
    return $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$4459d383cf3fd31d);
};
var $396c4c3d9e7fae3c$var$unsafeIndex1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$90bcd20c17ae578e();
var $396c4c3d9e7fae3c$export$b446f6baa3bb1430 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$99063656965a82f5)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))(function(x) {
        return function(xs) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073({
                head: x,
                tail: xs
            });
        };
    });
}();
var $396c4c3d9e7fae3c$export$823be24f8766da23 = function(dictUnfoldable) {
    var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(xs) {
        var len = $fc8c1182ec2aefec$export$f24224f1c91d8156(xs);
        var f = function(i) {
            if (i < len) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9($396c4c3d9e7fae3c$var$unsafeIndex1(xs)(i), i + 1 | 0));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Array (line 163, column 3 - line 165, column 26): " + [
                i.constructor.name
            ]);
        };
        return unfoldr(f)(0);
    };
};
var $396c4c3d9e7fae3c$export$c01875f616615628 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$99063656965a82f5)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))(function(v) {
        return function(xs) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073(xs);
        };
    });
}();
var $396c4c3d9e7fae3c$export$b035e44d7bb4278f = function(comp) {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$ea0922e78a1b008a)(comp)(function(v) {
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return 1;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 0;
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return -1;
        throw new Error("Failed pattern match at Data.Array (line 897, column 38 - line 900, column 11): " + [
            v.constructor.name
        ]);
    });
};
var $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var comparing = $97937c29f879e68e$export$e9509a298f6befc2(dictOrd);
    return function(f) {
        return $396c4c3d9e7fae3c$export$b035e44d7bb4278f(comparing(f));
    };
};
var $396c4c3d9e7fae3c$var$sortWith1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde($97937c29f879e68e$export$ff461bf68e7dd332);
var $396c4c3d9e7fae3c$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(xs) {
        return $396c4c3d9e7fae3c$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $396c4c3d9e7fae3c$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $784e144d56146b5c$export$fd51609fe570ea92($784e144d56146b5c$export$4cbf152802aa238(x))(xs)();
    };
};
var $396c4c3d9e7fae3c$export$58adb3bec8346d0f = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$4bdf1ac3fa5d3d6a);
var $396c4c3d9e7fae3c$export$b0d75975ac0be0e1 = function(v) {
    return function(v1) {
        if (v <= 0) return {
            before: [],
            after: v1
        };
        return {
            before: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(v)(v1),
            after: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(v)($fc8c1182ec2aefec$export$f24224f1c91d8156(v1))(v1)
        };
    };
};
var $396c4c3d9e7fae3c$export$b7df5d561049483a = function(n) {
    return function(xs) {
        var $152 = n < 1;
        if ($152) return [];
        return $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(n)(xs);
    };
};
var $396c4c3d9e7fae3c$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $396c4c3d9e7fae3c$export$64df51ac031d4ad2 = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$771bbc3bb9be46c2);
var $396c4c3d9e7fae3c$export$65f513eaf3c582b8 = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$53974fb866918d71);
var $396c4c3d9e7fae3c$export$606959e7ccb797f0 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$86a7d437bed76c03);
var $396c4c3d9e7fae3c$export$d02631cccf789723 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$3561205b7dff20bf);
var $396c4c3d9e7fae3c$export$b29f828819edca8d = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$25718970d830661a);
var $396c4c3d9e7fae3c$export$7b1b591b262c240 = function(xs) {
    return $fc8c1182ec2aefec$export$f24224f1c91d8156(xs) === 0;
};
var $396c4c3d9e7fae3c$export$7fd3d81fba5daa58 = function(dictFoldable) {
    var traverse_1 = $396c4c3d9e7fae3c$var$traverse_(dictFoldable);
    return function(is) {
        return function(f) {
            return function(xs) {
                return $784e144d56146b5c$export$fd51609fe570ea92(function(res) {
                    return traverse_1(function(i) {
                        return $784e144d56146b5c$export$3ff57735a52b8713(i)(f)(res);
                    })(is);
                })(xs)();
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$8f07ddce13659f50 = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50($334541180b4ef18c$export$f10d51ea0aa3da42);
var $396c4c3d9e7fae3c$export$af200dcf8b7cb5de = function(a) {
    return function(arr) {
        var v = $fc8c1182ec2aefec$export$f24224f1c91d8156(arr);
        if (v < 2) return arr;
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $784e144d56146b5c$export$889ea624f2cb2c57(function() {
            var unsafeGetElem = function(idx) {
                return $396c4c3d9e7fae3c$var$unsafeIndex1(arr)(idx);
            };
            return function __do() {
                var out = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
                $784e144d56146b5c$export$4cbf152802aa238(unsafeGetElem(0))(out)();
                $f11e5cd39add8df2$export$f89de2e5bf57e5e6(1)(v)(function(idx) {
                    return function __do() {
                        $784e144d56146b5c$export$4cbf152802aa238(a)(out)();
                        return $396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(unsafeGetElem(idx))(out))();
                    };
                })();
                return out;
            };
        }());
        throw new Error("Failed pattern match at Data.Array (line 623, column 21 - line 633, column 17): " + [
            v.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$739ec22334c44788 = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$intercalate1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$9f200c4466975173 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$ce6386a175247406($fc8c1182ec2aefec$export$d553b0efc2008003)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$2cd8252107eb640b = function(xs) {
    if ($396c4c3d9e7fae3c$export$7b1b591b262c240(xs)) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $06733ae99ed4f534$export$8a67b48435b5d073($396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - 1 | 0)(xs));
    throw new Error("Failed pattern match at Data.Array (line 351, column 1 - line 351, column 45): " + [
        xs.constructor.name
    ]);
};
var $396c4c3d9e7fae3c$export$b610b8812bbcded9 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$fe8606c16d7ceed6)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$4c7897fafd92b108 = function(xs) {
    return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - 1 | 0);
};
var $396c4c3d9e7fae3c$export$712962e076096ed4 = function(xs) {
    return $396c4c3d9e7fae3c$var$apply($396c4c3d9e7fae3c$var$map(function(v) {
        return function(v1) {
            return {
                init: v,
                last: v1
            };
        };
    })($396c4c3d9e7fae3c$export$2cd8252107eb640b(xs)))($396c4c3d9e7fae3c$export$4c7897fafd92b108(xs));
};
var $396c4c3d9e7fae3c$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        return function(xs) {
            var go = function(x) {
                return $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(f(x))(xs);
            };
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(go)($396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(i));
        };
    };
};
var $396c4c3d9e7fae3c$export$afc1bfabebaf28a2 = function(p) {
    return function(arr) {
        var go = function($copy_i) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i) {
                var v = $396c4c3d9e7fae3c$export$b610b8812bbcded9(arr)(i);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    var $156 = p(v.value0);
                    if ($156) {
                        $copy_i = i + 1 | 0;
                        return;
                    }
                    $tco_done = true;
                    return new $06733ae99ed4f534$export$8a67b48435b5d073(i);
                }
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                throw new Error("Failed pattern match at Data.Array (line 1035, column 5 - line 1037, column 25): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_i);
            return $tco_result;
        };
        var breakIndex = go(0);
        if (breakIndex instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && breakIndex.value0 === 0) return {
            init: [],
            rest: arr
        };
        if (breakIndex instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
            init: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(breakIndex.value0)(arr),
            rest: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(breakIndex.value0)($fc8c1182ec2aefec$export$f24224f1c91d8156(arr))(arr)
        };
        if (breakIndex instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
            init: arr,
            rest: []
        };
        throw new Error("Failed pattern match at Data.Array (line 1022, column 3 - line 1028, column 30): " + [
            breakIndex.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$9384c7afe4015e42 = function(p) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$afc1bfabebaf28a2(p)(xs).init;
    };
};
var $396c4c3d9e7fae3c$export$23c8d3f8757cab88 = function(xs) {
    return function __do() {
        var fsts = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
        var snds = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
        var iter = $8dd172f1ebfb42af$export$6f58e2338da23f4d(function(v) {
            return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(v);
        })();
        $8dd172f1ebfb42af$export$c1a059043cc9c119(iter)(function(v) {
            return function __do() {
                $396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(v.value0)(fsts))();
                return $396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(v.value1)(snds))();
            };
        })();
        var fsts$prime = $784e144d56146b5c$export$7c850c5af9b9983e(fsts)();
        var snds$prime = $784e144d56146b5c$export$7c850c5af9b9983e(snds)();
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(fsts$prime, snds$prime);
    }();
};
var $396c4c3d9e7fae3c$export$5fd5031fecdacec3 = function(xs) {
    return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(0);
};
var $396c4c3d9e7fae3c$export$18f77a3bafa759b9 = function(comp) {
    return function(xs) {
        var indexedAndSorted = $396c4c3d9e7fae3c$export$b035e44d7bb4278f(function(x) {
            return function(y) {
                return comp($71f2e2e9476163f8$export$6f71268a1666ab58(x))($71f2e2e9476163f8$export$6f71268a1666ab58(y));
            };
        })($396c4c3d9e7fae3c$export$8f07ddce13659f50($71f2e2e9476163f8$export$1908877435b1d5e9.create)(xs));
        var v = $396c4c3d9e7fae3c$export$5fd5031fecdacec3(indexedAndSorted);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $396c4c3d9e7fae3c$var$map1($71f2e2e9476163f8$export$6f71268a1666ab58)($396c4c3d9e7fae3c$var$sortWith1($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(function __do() {
            var result = $784e144d56146b5c$export$cc9b8725eef9c137($396c4c3d9e7fae3c$export$439306a4dcaafbb9(v.value0))();
            $f11e5cd39add8df2$export$8802485f9deae94f(indexedAndSorted)(function(v1) {
                return function __do() {
                    var lst = $396c4c3d9e7fae3c$var$map2(function() {
                        var $183 = function($185) {
                            return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$4c7897fafd92b108($185));
                        };
                        return function($184) {
                            return $71f2e2e9476163f8$export$6f71268a1666ab58($183($184));
                        };
                    }())($784e144d56146b5c$export$7c850c5af9b9983e(result))();
                    return $396c4c3d9e7fae3c$var$when($396c4c3d9e7fae3c$var$notEq(comp(lst)(v1.value1))($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value))($396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(v1)(result)))();
                };
            })();
            return $784e144d56146b5c$export$7c850c5af9b9983e(result)();
        }()));
        throw new Error("Failed pattern match at Data.Array (line 1115, column 17 - line 1123, column 28): " + [
            v.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$94f4066a75b10404 = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$18f77a3bafa759b9($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $396c4c3d9e7fae3c$export$3f063810d7bf01bd = function(op) {
    return function(xs) {
        return function __do() {
            var result = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
            var iter = $8dd172f1ebfb42af$export$6f58e2338da23f4d(function(v) {
                return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(v);
            })();
            $8dd172f1ebfb42af$export$c1a059043cc9c119(iter)(function(x) {
                return $396c4c3d9e7fae3c$var$$$void(function __do() {
                    var sub1 = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
                    $784e144d56146b5c$export$4cbf152802aa238(x)(sub1)();
                    $8dd172f1ebfb42af$export$f458d78453dee163(op(x))(iter)(sub1)();
                    var grp = $784e144d56146b5c$export$7c850c5af9b9983e(sub1)();
                    return $784e144d56146b5c$export$4cbf152802aa238(grp)(result)();
                });
            })();
            return $784e144d56146b5c$export$7c850c5af9b9983e(result)();
        }();
    };
};
var $396c4c3d9e7fae3c$export$1f7a5bf12caafbd = function(cmp) {
    var $186 = $396c4c3d9e7fae3c$export$3f063810d7bf01bd(function(x) {
        return function(y) {
            return $396c4c3d9e7fae3c$var$eq1(cmp(x)(y))($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        };
    });
    var $187 = $396c4c3d9e7fae3c$export$b035e44d7bb4278f(cmp);
    return function($188) {
        return $186($187($188));
    };
};
var $396c4c3d9e7fae3c$export$361434b95a7d965 = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$1f7a5bf12caafbd($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $396c4c3d9e7fae3c$export$e5e25fbcc1f7affe = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(xs) {
        return $396c4c3d9e7fae3c$export$3f063810d7bf01bd(eq2)(xs);
    };
};
var $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$7de5ece11b723a44)($4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable));
};
var $396c4c3d9e7fae3c$export$a11cb61c36c4a4cf = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$export$50ae948ca12cdcbc = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$export$9cb09a71b7d66923 = function(xs) {
    var buildNext = function(idx) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f($396c4c3d9e7fae3c$export$50ae948ca12cdcbc)($06733ae99ed4f534$export$bebe9059409a0d04.value)(function(acc) {
            return function(nextArr) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(acc)(function(el) {
                    return new $06733ae99ed4f534$export$8a67b48435b5d073($06733ae99ed4f534$export$f8b8b9ce72e9ccbf([
                        el
                    ])($f57f4b701aa7b66e$export$8a83211c878a3f1f($396c4c3d9e7fae3c$export$c40cf5aab899f397)(el))(acc));
                })($396c4c3d9e7fae3c$export$b610b8812bbcded9(nextArr)(idx));
            };
        })(xs);
    };
    var go = function($copy_idx) {
        return function($copy_allArrays) {
            var $tco_var_idx = $copy_idx;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(idx, allArrays) {
                var v = buildNext(idx);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return allArrays;
                }
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    $tco_var_idx = idx + 1 | 0;
                    $copy_allArrays = $396c4c3d9e7fae3c$export$c40cf5aab899f397(allArrays)(v.value0);
                    return;
                }
                throw new Error("Failed pattern match at Data.Array (line 837, column 22 - line 839, column 52): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_idx, $copy_allArrays);
            return $tco_result;
        };
    };
    return go(0)([]);
};
var $396c4c3d9e7fae3c$export$61b0588efceffce4 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var tailRecM2 = $f93520de2fa37b44$export$9056a6bb308e8c79(dictMonadRec);
    return function(f) {
        return function(b) {
            return function(array) {
                var go = function(res) {
                    return function(i) {
                        if (i >= $fc8c1182ec2aefec$export$f24224f1c91d8156(array)) return pure1(new $f93520de2fa37b44$export$7fe28cb29e71bf10(res));
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return bind1(f(res)($396c4c3d9e7fae3c$var$unsafeIndex1(array)(i)))(function(res$prime) {
                            return pure1(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                                a: res$prime,
                                b: i + 1 | 0
                            }));
                        });
                        throw new Error("Failed pattern match at Data.Array (line 1349, column 3 - line 1353, column 42): " + [
                            res.constructor.name,
                            i.constructor.name
                        ]);
                    };
                };
                return tailRecM2(go)(b)(0);
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$b66cdc0497d8a99a = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$foldMap1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(f) {
        return function(b) {
            return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$99063656965a82f5)(function(v) {
                return pure1(b);
            })(function(a) {
                return function(as) {
                    return bind1(f(b)(a))(function(b$prime) {
                        return $396c4c3d9e7fae3c$export$7a067f9280ad8af0(dictMonad)(f)(b$prime)(as);
                    });
                };
            });
        };
    };
};
var $396c4c3d9e7fae3c$export$93e2b83da34ff82a = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$fold1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$23e5dcedfce4509c = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$7ad327e9a65b0147)($06733ae99ed4f534$export$bebe9059409a0d04.value)($06733ae99ed4f534$export$c15bd07a493e1236);
}();
var $396c4c3d9e7fae3c$export$8855a8be7bd3e9f8 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$32bcb9f71841245e)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$b8bc901090d2b1d4 = function(cmp) {
    return function(x) {
        return function(ys) {
            var i = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)(function(v) {
                return v + 1 | 0;
            })($396c4c3d9e7fae3c$export$8855a8be7bd3e9f8(function(y) {
                return $396c4c3d9e7fae3c$var$eq1(cmp(x)(y))($5026be88823ef1f4$export$b023c82b48e70453.value);
            })(ys));
            return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$9f200c4466975173(i)(x)(ys));
        };
    };
};
var $396c4c3d9e7fae3c$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$b8bc901090d2b1d4($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $396c4c3d9e7fae3c$export$de3a4d4a0d731119 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$885b84ba169666c7)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$71aa6c912b956294 = function(f) {
    return function(xs) {
        return $396c4c3d9e7fae3c$var$map($396c4c3d9e7fae3c$var$unsafeIndex1(xs))($396c4c3d9e7fae3c$export$de3a4d4a0d731119(f)(xs));
    };
};
var $396c4c3d9e7fae3c$export$3dea766d36a8935f = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$e85b5b674fbfff84);
var $396c4c3d9e7fae3c$export$f161f39e9c06ab2d = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(x) {
                return $06733ae99ed4f534$export$c15bd07a493e1236($396c4c3d9e7fae3c$export$de3a4d4a0d731119(eq2(x))(ys));
            })(xs);
        };
    };
};
var $396c4c3d9e7fae3c$export$1f4807a235930d45 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$f161f39e9c06ab2d($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$c19d79386f4ed99a = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $396c4c3d9e7fae3c$export$8855a8be7bd3e9f8(function(v) {
            return eq2(v)(x);
        });
    };
};
var $396c4c3d9e7fae3c$export$f444781b0adb7e4d = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $396c4c3d9e7fae3c$export$de3a4d4a0d731119(function(v) {
            return eq2(v)(x);
        });
    };
};
var $396c4c3d9e7fae3c$export$63faa62a0284a4a6 = function(dictEq) {
    var elemIndex1 = $396c4c3d9e7fae3c$export$f444781b0adb7e4d(dictEq);
    return function(a) {
        return function(arr) {
            return $06733ae99ed4f534$export$4967676db1b89293(elemIndex1(a)(arr));
        };
    };
};
var $396c4c3d9e7fae3c$export$5bf96401662340b7 = function(dictEq) {
    var elemIndex1 = $396c4c3d9e7fae3c$export$f444781b0adb7e4d(dictEq);
    return function(a) {
        return function(arr) {
            return $06733ae99ed4f534$export$c15bd07a493e1236(elemIndex1(a)(arr));
        };
    };
};
var $396c4c3d9e7fae3c$export$533af5c8cd6afa16 = function(p) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$afc1bfabebaf28a2(p)(xs).rest;
    };
};
var $396c4c3d9e7fae3c$export$2b3b686e33c80c56 = function(n) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$b7df5d561049483a($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $396c4c3d9e7fae3c$export$663103110d94aac9 = function(n) {
    return function(xs) {
        var $173 = n < 1;
        if ($173) return xs;
        return $396c4c3d9e7fae3c$export$58adb3bec8346d0f(n)($fc8c1182ec2aefec$export$f24224f1c91d8156(xs))(xs);
    };
};
var $396c4c3d9e7fae3c$export$9100289823a975b0 = function(n) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$663103110d94aac9($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $396c4c3d9e7fae3c$export$90f9093465da3136 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$e83371a4d1b4407c)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$9ea2b6c3fae093d8 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2.length === 0) return [];
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(v2)(function(i) {
                return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$90f9093465da3136(i)(v2));
            })($396c4c3d9e7fae3c$export$de3a4d4a0d731119(v(v1))(v2));
        };
    };
};
var $396c4c3d9e7fae3c$export$1822828d790e23ee = function(dictEq) {
    return $396c4c3d9e7fae3c$export$9ea2b6c3fae093d8($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$acaf96a27438246b = function(dictEq) {
    return $396c4c3d9e7fae3c$export$a11cb61c36c4a4cf($396c4c3d9e7fae3c$export$1822828d790e23ee(dictEq));
};
var $396c4c3d9e7fae3c$export$8327ebbef2a0ba76 = function(x) {
    return function(xs) {
        return $396c4c3d9e7fae3c$var$append([
            x
        ])(xs);
    };
};
var $396c4c3d9e7fae3c$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictAlternative.Applicative0().Apply0());
    var map3 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
        return function(v) {
            return apply1(map3($396c4c3d9e7fae3c$export$8327ebbef2a0ba76)(v))(defer(function(v1) {
                return $396c4c3d9e7fae3c$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $396c4c3d9e7fae3c$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlternative.Plus1().Alt0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($396c4c3d9e7fae3c$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure1([]));
        };
    };
};
var $396c4c3d9e7fae3c$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($70cd3177464e7915$export$794f9574ca20b986));
var $396c4c3d9e7fae3c$export$e70771d2e7e590a = function(f) {
    return $396c4c3d9e7fae3c$export$c28c8388be0ab31a(function() {
        var $189 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf([])($396c4c3d9e7fae3c$export$439306a4dcaafbb9);
        return function($190) {
            return $189(f($190));
        };
    }());
};
var $396c4c3d9e7fae3c$export$e6e803076c284bc5 = function(dictApplicative) {
    var traverse1 = $396c4c3d9e7fae3c$var$traverse(dictApplicative);
    var map3 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
    return function(p) {
        var $191 = map3($396c4c3d9e7fae3c$export$e70771d2e7e590a(function(v) {
            if (v.value1) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }));
        var $192 = traverse1(function(x) {
            return map3($71f2e2e9476163f8$export$1908877435b1d5e9.create(x))(p(x));
        });
        return function($193) {
            return $191($192($193));
        };
    };
};
var $396c4c3d9e7fae3c$export$986c2bbe7a34be0b = /* #__PURE__ */ $396c4c3d9e7fae3c$export$e70771d2e7e590a(/* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa));
var $396c4c3d9e7fae3c$export$4154a199d7d90455 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$b98f41a67d1483f3);
var $396c4c3d9e7fae3c$export$45273896c792ff3b = function(eq2) {
    return function(xs) {
        return function __do() {
            var arr = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
            $f11e5cd39add8df2$export$8802485f9deae94f(xs)(function(x) {
                return function __do() {
                    var e = $396c4c3d9e7fae3c$var$map2(function() {
                        var $194 = $396c4c3d9e7fae3c$export$4154a199d7d90455(function(v) {
                            return eq2(v)(x);
                        });
                        return function($195) {
                            return !$194($195);
                        };
                    }())($784e144d56146b5c$export$7c850c5af9b9983e(arr))();
                    return $396c4c3d9e7fae3c$var$when(e)($396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(x)(arr)))();
                };
            })();
            return $784e144d56146b5c$export$7c850c5af9b9983e(arr)();
        }();
    };
};
var $396c4c3d9e7fae3c$export$edce5881c815871 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$45273896c792ff3b($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$ef1d06dc4d91d507 = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $396c4c3d9e7fae3c$var$append(xs)($396c4c3d9e7fae3c$export$50ae948ca12cdcbc($f57f4b701aa7b66e$export$8a83211c878a3f1f($396c4c3d9e7fae3c$export$9ea2b6c3fae093d8(eq2)))($396c4c3d9e7fae3c$export$45273896c792ff3b(eq2)(ys))(xs));
        };
    };
};
var $396c4c3d9e7fae3c$export$971dd5b0dfd021b6 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$ef1d06dc4d91d507($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$2dd9d44f93be5e22 = function(i) {
    return function(f) {
        return function(xs) {
            var go = function(x) {
                var v = f(x);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $396c4c3d9e7fae3c$export$90f9093465da3136(i)(xs);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(v.value0)(xs);
                throw new Error("Failed pattern match at Data.Array (line 601, column 10 - line 603, column 32): " + [
                    v.constructor.name
                ]);
            };
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(go)($396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(i));
        };
    };
};
var $396c4c3d9e7fae3c$export$84bf76cd7afc7469 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$739e1ef870df7d82);


// Generated by purs version 0.15.15
const $b54742048bb717e1$export$2e94f3cfb1cd0b3b = function(f, xs) {
    var acc = xs[xs.length - 1];
    for(var i = xs.length - 2; i >= 0; i--)acc = f(xs[i])(acc);
    return acc;
};
const $b54742048bb717e1$export$a723804e3f3d0e95 = function(f, xs) {
    var acc = xs[0];
    var len = xs.length;
    for(var i = 1; i < len; i++)acc = f(acc)(xs[i]);
    return acc;
};
const $b54742048bb717e1$export$c510f955a36e0bd4 = function() {
    function Cont(fn) {
        this.fn = fn;
    }
    var emptyList = {};
    var ConsCell = function(head, tail) {
        this.head = head;
        this.tail = tail;
    };
    function finalCell(head) {
        return new ConsCell(head, emptyList);
    }
    function consList(x) {
        return function(xs) {
            return new ConsCell(x, xs);
        };
    }
    function listToArray(list) {
        var arr = [];
        var xs = list;
        while(xs !== emptyList){
            arr.push(xs.head);
            xs = xs.tail;
        }
        return arr;
    }
    return function(apply, map, f) {
        var buildFrom = function(x, ys) {
            return apply(map(consList)(f(x)))(ys);
        };
        var go = function(acc, currentLen, xs) {
            if (currentLen === 0) return acc;
            else {
                var last = xs[currentLen - 1];
                return new Cont(function() {
                    var built = go(buildFrom(last, acc), currentLen - 1, xs);
                    return built;
                });
            }
        };
        return function(array) {
            var acc = map(finalCell)(f(array[array.length - 1]));
            var result = go(acc, array.length - 1, array);
            while(result instanceof Cont)result = result.fn();
            return map(listToArray)(result);
        };
    };
}();





















var $91ee3359f6bcea22$export$f2d78e4bd16a0737 = function(x) {
    return x;
};
var $91ee3359f6bcea22$export$5cc19ce746f40583 = $cf5af1199a495394$export$587ba9a9bf3cf8b4;
var $91ee3359f6bcea22$export$24956e78dc18af4a = $2c7a64ff78781336$export$96888504550934b5;
var $91ee3359f6bcea22$export$81b6a4240b5ed5ff = $11d1e86de605dfc6$export$9e4a28683e28e26a;
var $91ee3359f6bcea22$export$58eaac0549d62906 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225(dictShow));
    return {
        show: function(v) {
            return "(NonEmptyArray " + (show(v) + ")");
        }
    };
};
var $91ee3359f6bcea22$export$7e27c982686236c = $d7bf9817a417d4ae$export$d082f07d0a8e9909;
var $91ee3359f6bcea22$export$ba5ac798a83b9940 = function(dictOrd) {
    return $97937c29f879e68e$export$6ace7ea8ac01a75e(dictOrd);
};
var $91ee3359f6bcea22$export$576ea700d31dfbbe = $97937c29f879e68e$export$8e34cc59438cf1bf;
var $91ee3359f6bcea22$export$b6607029fd0e1ebc = $d3d065da31679be1$export$68aea3a98a23c265;
var $91ee3359f6bcea22$export$e1a7484e8d239345 = $334541180b4ef18c$export$f10d51ea0aa3da42;
var $91ee3359f6bcea22$export$cf42eb1af12f469e = $f4b2eb11fc32ed34$export$2330f868b62ed546;
var $91ee3359f6bcea22$export$277d8f0716691388 = $519ef1967f17d101$export$e728f47f20b1eb28;
var $91ee3359f6bcea22$export$7090c31be3a1e8ea = $4fe7b6acfba7f29f$export$e97014618a7eb593;
var $91ee3359f6bcea22$export$33591d20dac5147e = {
    foldMap1: function(dictSemigroup) {
        return $086486679aa806fa$export$3341743d361f5644($91ee3359f6bcea22$export$33591d20dac5147e)($91ee3359f6bcea22$export$cf42eb1af12f469e)(dictSemigroup);
    },
    foldr1: /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($b54742048bb717e1$export$2e94f3cfb1cd0b3b),
    foldl1: /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($b54742048bb717e1$export$a723804e3f3d0e95),
    Foldable0: function() {
        return $91ee3359f6bcea22$export$7090c31be3a1e8ea;
    }
};
var $91ee3359f6bcea22$export$a72b8d310e29f00f = {
    traverse1: function(dictApply) {
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return $b54742048bb717e1$export$c510f955a36e0bd4(apply, map, f);
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$c8ca5446ba1698($91ee3359f6bcea22$export$a72b8d310e29f00f)(dictApply);
    },
    Foldable10: function() {
        return $91ee3359f6bcea22$export$33591d20dac5147e;
    },
    Traversable1: function() {
        return $91ee3359f6bcea22$export$81b6a4240b5ed5ff;
    }
};
var $91ee3359f6bcea22$export$e2c877c9efbd93a4 = function(dictEq) {
    return $37b880af5f4991bd$export$159e06dc5ec60b00(dictEq);
};
var $91ee3359f6bcea22$export$5f4f90502fd988f7 = $37b880af5f4991bd$export$861eb926e0b8ea5b;
var $91ee3359f6bcea22$export$4b9e170bb3e49bd0 = $70cd3177464e7915$export$794f9574ca20b986;
var $91ee3359f6bcea22$export$8f8661c5387016c3 = $7576d3a958d66ab0$export$60d7bd9d686a5521;
var $91ee3359f6bcea22$export$df94f54a91732973 = $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e;
var $91ee3359f6bcea22$export$4d39f82ee37f3a51 = $75e93a4111e80214$export$186d613bb872946c;
















var $e39dfcf102cdca3c$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $e39dfcf102cdca3c$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$ff461bf68e7dd332);
var $e39dfcf102cdca3c$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $e39dfcf102cdca3c$var$intercalate1 = /* #__PURE__ */ $086486679aa806fa$export$739ec22334c44788($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$var$foldMap11 = /* #__PURE__ */ $086486679aa806fa$export$b50c31bb8aebd2a7($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$var$fold11 = /* #__PURE__ */ $086486679aa806fa$export$2e430a6d03f6ee23($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $e39dfcf102cdca3c$var$unsafeIndex1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$90bcd20c17ae578e();
var $e39dfcf102cdca3c$var$unsafeFromArrayF = $ac8b3532514ac019$export$401372c57776dc;
var $e39dfcf102cdca3c$var$unsafeFromArray = $91ee3359f6bcea22$export$f2d78e4bd16a0737;
var $e39dfcf102cdca3c$export$9cb09a71b7d66923 = function($99) {
    return $e39dfcf102cdca3c$var$coerce($396c4c3d9e7fae3c$export$9cb09a71b7d66923($e39dfcf102cdca3c$var$coerce($99)));
};
var $e39dfcf102cdca3c$export$45b10814cc054894 = function(v) {
    return v;
};
var $e39dfcf102cdca3c$export$c2d77a2584a0f97e = function(eq) {
    return function(xs) {
        var $100 = $396c4c3d9e7fae3c$export$ef1d06dc4d91d507(eq)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
        return function($101) {
            return $e39dfcf102cdca3c$var$unsafeFromArray($100($101));
        };
    };
};
var $e39dfcf102cdca3c$export$437026b4e0b5fcf6 = function(dictEq) {
    return $e39dfcf102cdca3c$export$c2d77a2584a0f97e($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$ef1d06dc4d91d507 = function(eq) {
    return function(xs) {
        var $102 = $e39dfcf102cdca3c$export$c2d77a2584a0f97e(eq)(xs);
        return function($103) {
            return $102($e39dfcf102cdca3c$export$45b10814cc054894($103));
        };
    };
};
var $e39dfcf102cdca3c$export$971dd5b0dfd021b6 = function(dictEq) {
    return $e39dfcf102cdca3c$export$ef1d06dc4d91d507($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    var $104 = $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$34a2521cb7920188)($e39dfcf102cdca3c$var$unsafeFromArray)($e39dfcf102cdca3c$var$unsafeFromArray);
    return function($105) {
        return $104($396c4c3d9e7fae3c$export$23c8d3f8757cab88($e39dfcf102cdca3c$export$45b10814cc054894($105)));
    };
}();
var $e39dfcf102cdca3c$export$b6d8713d53419d4c = function(i) {
    return function(x) {
        var $106 = $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(x);
        return function($107) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($106($e39dfcf102cdca3c$export$45b10814cc054894($107)));
        };
    };
};
var $e39dfcf102cdca3c$export$8901015135f2fb22 = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$8901015135f2fb22($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
    };
};
var $e39dfcf102cdca3c$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$b634740ce272acb5(f)($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
        };
    };
};
var $e39dfcf102cdca3c$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var zipWithA1 = $396c4c3d9e7fae3c$export$e00c1e5c5a2b1ad7(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return $e39dfcf102cdca3c$var$unsafeFromArrayF(zipWithA1(f)($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
            };
        };
    };
};
var $e39dfcf102cdca3c$export$b0d75975ac0be0e1 = function(i) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$b0d75975ac0be0e1(i)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$ad14ef4001db2bcd = function(dictAlternative) {
    var some1 = $396c4c3d9e7fae3c$export$ad14ef4001db2bcd(dictAlternative);
    return function(dictLazy) {
        var $108 = some1(dictLazy);
        return function($109) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($108($109));
        };
    };
};
var $e39dfcf102cdca3c$export$5b6d1d165591a48c = function(xs) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$c40cf5aab899f397(xs)(x));
    };
};
var $e39dfcf102cdca3c$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$c40cf5aab899f397($e39dfcf102cdca3c$export$45b10814cc054894(xs))(x));
    };
};
var $e39dfcf102cdca3c$export$439306a4dcaafbb9 = function($110) {
    return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$439306a4dcaafbb9($110));
};
var $e39dfcf102cdca3c$export$606959e7ccb797f0 = function(i) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$606959e7ccb797f0($e39dfcf102cdca3c$var$max(1)(i))(x));
    };
};
var $e39dfcf102cdca3c$export$d02631cccf789723 = function(x) {
    return function(y) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$d02631cccf789723(x)(y));
    };
};
var $e39dfcf102cdca3c$export$25b721c466a8ec4a = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($e39dfcf102cdca3c$var$append(xs)($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
    };
};
var $e39dfcf102cdca3c$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        var $111 = $396c4c3d9e7fae3c$export$cba09f9e3d3e58eb(i)(f);
        return function($112) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($111($e39dfcf102cdca3c$export$45b10814cc054894($112)));
        };
    };
};
var $e39dfcf102cdca3c$export$df22145cad61b1dc = function(eq) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$f161f39e9c06ab2d(eq)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$f161f39e9c06ab2d = function(eq) {
    return function(xs) {
        var $113 = $e39dfcf102cdca3c$export$df22145cad61b1dc(eq)(xs);
        return function($114) {
            return $113($e39dfcf102cdca3c$export$45b10814cc054894($114));
        };
    };
};
var $e39dfcf102cdca3c$export$5c3f7b482f544831 = function(dictEq) {
    return $e39dfcf102cdca3c$export$df22145cad61b1dc($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$1f4807a235930d45 = function(dictEq) {
    return $e39dfcf102cdca3c$export$f161f39e9c06ab2d($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$739ec22334c44788 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$intercalate1(dictSemigroup);
};
var $e39dfcf102cdca3c$export$9f200c4466975173 = function(i) {
    return function(x) {
        var $115 = $396c4c3d9e7fae3c$export$9f200c4466975173(i)(x);
        return function($116) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($115($e39dfcf102cdca3c$export$45b10814cc054894($116)));
        };
    };
};
var $e39dfcf102cdca3c$export$95b95426129653f6 = function(dictFoldable1) {
    var $117 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072(dictFoldable1.Foldable0());
    return function($118) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($117($118));
    };
};
var $e39dfcf102cdca3c$export$571d59b505e6bb4e = function(xs) {
    if ($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) > 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($e39dfcf102cdca3c$var$unsafeFromArray(xs));
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at Data.Array.NonEmpty (line 161, column 1 - line 161, column 58): " + [
        xs.constructor.name
    ]);
};
var $e39dfcf102cdca3c$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var $119 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072(dictFoldable);
    return function($120) {
        return $e39dfcf102cdca3c$export$571d59b505e6bb4e($119($120));
    };
};
var $e39dfcf102cdca3c$export$55f57584ad1f8cc9 = function($121) {
    return $e39dfcf102cdca3c$export$571d59b505e6bb4e($396c4c3d9e7fae3c$export$9cb09a71b7d66923($e39dfcf102cdca3c$var$coerce($121)));
};
var $e39dfcf102cdca3c$export$c8b99533c112636f = /* #__PURE__ */ $086486679aa806fa$export$c8b99533c112636f($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$export$eb5e1ef4ea2eca3d = /* #__PURE__ */ $086486679aa806fa$export$eb5e1ef4ea2eca3d($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$export$b50c31bb8aebd2a7 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$foldMap11(dictSemigroup);
};
var $e39dfcf102cdca3c$export$2e430a6d03f6ee23 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$fold11(dictSemigroup);
};
var $e39dfcf102cdca3c$export$244bb8babc536271 = function(dictEq) {
    var difference1 = $396c4c3d9e7fae3c$export$acaf96a27438246b(dictEq);
    return function(xs) {
        return difference1($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$cc3b5f3f66225fbe = function(x) {
    return function(xs) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(x)(xs));
    };
};
var $e39dfcf102cdca3c$export$1d4c49925323035a = function(v) {
    return $e39dfcf102cdca3c$export$cc3b5f3f66225fbe(v.value0)(v.value1);
};
var $e39dfcf102cdca3c$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($91ee3359f6bcea22$export$4b9e170bb3e49bd0));
var $e39dfcf102cdca3c$export$ee1b3e54f0441b22 = /* #__PURE__ */ function() {
    var $122 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($91ee3359f6bcea22$export$cf42eb1af12f469e)($e39dfcf102cdca3c$export$45b10814cc054894);
    return function($123) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($fc8c1182ec2aefec$export$ee1b3e54f0441b22($e39dfcf102cdca3c$export$45b10814cc054894($122($123))));
    };
}();
var $e39dfcf102cdca3c$export$caf8a2f37e9533e = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($e39dfcf102cdca3c$var$append($e39dfcf102cdca3c$export$45b10814cc054894(xs))(ys));
    };
};
var $e39dfcf102cdca3c$export$2dd9d44f93be5e22 = function(i) {
    return function(f) {
        var $124 = $396c4c3d9e7fae3c$export$2dd9d44f93be5e22(i)(f);
        return function($125) {
            return $124($e39dfcf102cdca3c$export$45b10814cc054894($125));
        };
    };
};
var $e39dfcf102cdca3c$var$adaptMaybe = function(f) {
    return function($126) {
        return $e39dfcf102cdca3c$var$fromJust(f($e39dfcf102cdca3c$export$45b10814cc054894($126)));
    };
};
var $e39dfcf102cdca3c$export$5fd5031fecdacec3 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$5fd5031fecdacec3);
var $e39dfcf102cdca3c$export$2cd8252107eb640b = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$2cd8252107eb640b);
var $e39dfcf102cdca3c$export$4c7897fafd92b108 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$4c7897fafd92b108);
var $e39dfcf102cdca3c$export$c01875f616615628 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$c01875f616615628);
var $e39dfcf102cdca3c$export$b446f6baa3bb1430 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$b446f6baa3bb1430);
var $e39dfcf102cdca3c$export$bdf81af0000aaf5a = function($127) {
    return function(v) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.head, v.tail);
    }($e39dfcf102cdca3c$export$b446f6baa3bb1430($127));
};
var $e39dfcf102cdca3c$export$712962e076096ed4 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$712962e076096ed4);
var $e39dfcf102cdca3c$var$adaptAny = function(f) {
    return function($128) {
        return f($e39dfcf102cdca3c$export$45b10814cc054894($128));
    };
};
var $e39dfcf102cdca3c$export$84bf76cd7afc7469 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$84bf76cd7afc7469(p));
};
var $e39dfcf102cdca3c$export$4154a199d7d90455 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$4154a199d7d90455(p));
};
var $e39dfcf102cdca3c$export$986c2bbe7a34be0b = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$986c2bbe7a34be0b);
var $e39dfcf102cdca3c$export$1822828d790e23ee = function(dictEq) {
    var delete1 = $396c4c3d9e7fae3c$export$1822828d790e23ee(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(delete1(x));
    };
};
var $e39dfcf102cdca3c$export$90f9093465da3136 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$90f9093465da3136(i));
};
var $e39dfcf102cdca3c$export$9ea2b6c3fae093d8 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$9ea2b6c3fae093d8(f)(x));
    };
};
var $e39dfcf102cdca3c$export$acaf96a27438246b = function(dictEq) {
    var difference$prime1 = $e39dfcf102cdca3c$export$244bb8babc536271(dictEq);
    return function(xs) {
        return $e39dfcf102cdca3c$var$adaptAny(difference$prime1(xs));
    };
};
var $e39dfcf102cdca3c$export$663103110d94aac9 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$663103110d94aac9(i));
};
var $e39dfcf102cdca3c$export$2b3b686e33c80c56 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$2b3b686e33c80c56(i));
};
var $e39dfcf102cdca3c$export$533af5c8cd6afa16 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$533af5c8cd6afa16(f));
};
var $e39dfcf102cdca3c$export$5bf96401662340b7 = function(dictEq) {
    var elem1 = $396c4c3d9e7fae3c$export$5bf96401662340b7(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elem1(x));
    };
};
var $e39dfcf102cdca3c$export$f444781b0adb7e4d = function(dictEq) {
    var elemIndex1 = $396c4c3d9e7fae3c$export$f444781b0adb7e4d(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elemIndex1(x));
    };
};
var $e39dfcf102cdca3c$export$c19d79386f4ed99a = function(dictEq) {
    var elemLastIndex1 = $396c4c3d9e7fae3c$export$c19d79386f4ed99a(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elemLastIndex1(x));
    };
};
var $e39dfcf102cdca3c$export$3dea766d36a8935f = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$3dea766d36a8935f(f));
};
var $e39dfcf102cdca3c$export$e6e803076c284bc5 = function(dictApplicative) {
    var filterA1 = $396c4c3d9e7fae3c$export$e6e803076c284bc5(dictApplicative);
    return function(f) {
        return $e39dfcf102cdca3c$var$adaptAny(filterA1(f));
    };
};
var $e39dfcf102cdca3c$export$71aa6c912b956294 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$71aa6c912b956294(p));
};
var $e39dfcf102cdca3c$export$de3a4d4a0d731119 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$de3a4d4a0d731119(p));
};
var $e39dfcf102cdca3c$export$8855a8be7bd3e9f8 = function(x) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$8855a8be7bd3e9f8(x));
};
var $e39dfcf102cdca3c$export$23e5dcedfce4509c = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$23e5dcedfce4509c(p));
};
var $e39dfcf102cdca3c$export$7a067f9280ad8af0 = function(dictMonad) {
    var foldM1 = $396c4c3d9e7fae3c$export$7a067f9280ad8af0(dictMonad);
    return function(f) {
        return function(acc) {
            return $e39dfcf102cdca3c$var$adaptAny(foldM1(f)(acc));
        };
    };
};
var $e39dfcf102cdca3c$export$61b0588efceffce4 = function(dictMonadRec) {
    var foldRecM1 = $396c4c3d9e7fae3c$export$61b0588efceffce4(dictMonadRec);
    return function(f) {
        return function(acc) {
            return $e39dfcf102cdca3c$var$adaptAny(foldRecM1(f)(acc));
        };
    };
};
var $e39dfcf102cdca3c$export$b610b8812bbcded9 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$b610b8812bbcded9);
var $e39dfcf102cdca3c$export$f24224f1c91d8156 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($fc8c1182ec2aefec$export$f24224f1c91d8156);
var $e39dfcf102cdca3c$export$e70771d2e7e590a = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$e70771d2e7e590a(f));
};
var $e39dfcf102cdca3c$export$63faa62a0284a4a6 = function(dictEq) {
    var notElem1 = $396c4c3d9e7fae3c$export$63faa62a0284a4a6(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(notElem1(x));
    };
};
var $e39dfcf102cdca3c$export$b29f828819edca8d = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$b29f828819edca8d(f));
};
var $e39dfcf102cdca3c$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$58adb3bec8346d0f(start)(end));
    };
};
var $e39dfcf102cdca3c$export$afc1bfabebaf28a2 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$afc1bfabebaf28a2(f));
};
var $e39dfcf102cdca3c$export$b7df5d561049483a = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$b7df5d561049483a(i));
};
var $e39dfcf102cdca3c$export$9100289823a975b0 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$9100289823a975b0(i));
};
var $e39dfcf102cdca3c$export$9384c7afe4015e42 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$9384c7afe4015e42(f));
};
var $e39dfcf102cdca3c$export$823be24f8766da23 = function(dictUnfoldable) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$823be24f8766da23(dictUnfoldable));
};
var $e39dfcf102cdca3c$var$unsafeAdapt = function(f) {
    var $129 = $e39dfcf102cdca3c$var$adaptAny(f);
    return function($130) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($129($130));
    };
};
var $e39dfcf102cdca3c$export$8327ebbef2a0ba76 = function(x) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(x));
};
var $e39dfcf102cdca3c$export$e5e25fbcc1f7affe = function(dictEq) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$e5e25fbcc1f7affe(dictEq));
};
var $e39dfcf102cdca3c$export$1f7a5bf12caafbd = function(op) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$1f7a5bf12caafbd(op));
};
var $e39dfcf102cdca3c$export$361434b95a7d965 = function(dictOrd) {
    return $e39dfcf102cdca3c$export$1f7a5bf12caafbd($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $e39dfcf102cdca3c$export$3f063810d7bf01bd = function(op) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$3f063810d7bf01bd(op));
};
var $e39dfcf102cdca3c$export$21a5ca8aa77d35ff = function(dictOrd) {
    var insert1 = $396c4c3d9e7fae3c$export$21a5ca8aa77d35ff(dictOrd);
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(insert1(x));
    };
};
var $e39dfcf102cdca3c$export$b8bc901090d2b1d4 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$b8bc901090d2b1d4(f)(x));
    };
};
var $e39dfcf102cdca3c$export$af200dcf8b7cb5de = function(x) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$af200dcf8b7cb5de(x));
};
var $e39dfcf102cdca3c$export$8f07ddce13659f50 = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$8f07ddce13659f50(f));
};
var $e39dfcf102cdca3c$export$7fd3d81fba5daa58 = function(dictFoldable) {
    var modifyAtIndices1 = $396c4c3d9e7fae3c$export$7fd3d81fba5daa58(dictFoldable);
    return function(is) {
        return function(f) {
            return $e39dfcf102cdca3c$var$unsafeAdapt(modifyAtIndices1(is)(f));
        };
    };
};
var $e39dfcf102cdca3c$export$94f4066a75b10404 = function(dictOrd) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$94f4066a75b10404(dictOrd));
};
var $e39dfcf102cdca3c$export$18f77a3bafa759b9 = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$18f77a3bafa759b9(f));
};
var $e39dfcf102cdca3c$export$45273896c792ff3b = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$45273896c792ff3b(f));
};
var $e39dfcf102cdca3c$export$edce5881c815871 = function(dictEq) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$edce5881c815871(dictEq));
};
var $e39dfcf102cdca3c$export$66c1ae025e96b4bc = /* #__PURE__ */ $e39dfcf102cdca3c$var$unsafeAdapt($fc8c1182ec2aefec$export$66c1ae025e96b4bc);
var $e39dfcf102cdca3c$export$65f513eaf3c582b8 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$65f513eaf3c582b8(f)(x));
    };
};
var $e39dfcf102cdca3c$export$64df51ac031d4ad2 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$64df51ac031d4ad2(f)(x));
    };
};
var $e39dfcf102cdca3c$export$97db5808d8f88186 = function(dictOrd) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$97db5808d8f88186(dictOrd));
};
var $e39dfcf102cdca3c$export$b035e44d7bb4278f = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$b035e44d7bb4278f(f));
};
var $e39dfcf102cdca3c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var sortWith1 = $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde(dictOrd);
    return function(f) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(sortWith1(f));
    };
};
var $e39dfcf102cdca3c$export$f2a09b3ef2c0e257 = function(dictFoldable) {
    var updateAtIndices1 = $396c4c3d9e7fae3c$export$f2a09b3ef2c0e257(dictFoldable);
    return function(pairs) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(updateAtIndices1(pairs));
    };
};
var $e39dfcf102cdca3c$export$90bcd20c17ae578e = function() {
    return $e39dfcf102cdca3c$var$adaptAny($e39dfcf102cdca3c$var$unsafeIndex1);
};
var $e39dfcf102cdca3c$var$unsafeIndex2 = /* #__PURE__ */ $e39dfcf102cdca3c$export$90bcd20c17ae578e();
var $e39dfcf102cdca3c$export$d1f81bca2a8c7b07 = function(dictUnfoldable1) {
    var unfoldr1 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(xs) {
        var len = $e39dfcf102cdca3c$export$f24224f1c91d8156(xs);
        var f = function(i) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($e39dfcf102cdca3c$var$unsafeIndex2(xs)(i), function() {
                var $98 = i < (len - 1 | 0);
                if ($98) return new $06733ae99ed4f534$export$8a67b48435b5d073(i + 1 | 0);
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }());
        };
        return unfoldr1(f)(0);
    };
};











// Generated by purs version 0.15.15
/* eslint-disable no-eq-null, eqeqeq */ const $305519516124a7ff$export$7b1b591b262c240 = null;
function $305519516124a7ff$export$133fc36489ac9add(a, r, f) {
    return a == null ? r : f(a);
}
function $305519516124a7ff$export$9b7835891cf7097a(x) {
    return x;
}







var $0a5aaf95f168428e$export$b187f57ee1822bc5 = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($305519516124a7ff$export$7b1b591b262c240)($305519516124a7ff$export$9b7835891cf7097a);
var $0a5aaf95f168428e$export$1ba013b88f4f21f3 = function(n) {
    return $305519516124a7ff$export$133fc36489ac9add(n, $06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create);
};
var $0a5aaf95f168428e$export$643760463fdd14c1 = function(dictShow) {
    return {
        show: function() {
            var $17 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf("null")($2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow));
            return function($18) {
                return $17($0a5aaf95f168428e$export$1ba013b88f4f21f3($18));
            };
        }()
    };
};
var $0a5aaf95f168428e$export$1d97b52fc2e07cdc = function(dictEq) {
    return {
        eq: $f57f4b701aa7b66e$export$af631764ddc44097($37b880af5f4991bd$export$9663ddc1cf085b32($06733ae99ed4f534$export$8f45bb76abf9699e(dictEq)))($0a5aaf95f168428e$export$1ba013b88f4f21f3)
    };
};
var $0a5aaf95f168428e$export$4fb7d8da662af215 = function(dictOrd) {
    var eqNullable1 = $0a5aaf95f168428e$export$1d97b52fc2e07cdc(dictOrd.Eq0());
    return {
        compare: $f57f4b701aa7b66e$export$af631764ddc44097($97937c29f879e68e$export$398604a469f7de9a($06733ae99ed4f534$export$e35c29f98d259c46(dictOrd)))($0a5aaf95f168428e$export$1ba013b88f4f21f3),
        Eq0: function() {
            return eqNullable1;
        }
    };
};
var $0a5aaf95f168428e$export$1b7ecac9aff49fbc = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($0a5aaf95f168428e$export$1d97b52fc2e07cdc(dictEq));
    }
};
var $0a5aaf95f168428e$export$46a371b99e80ea42 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($0a5aaf95f168428e$export$4fb7d8da662af215(dictOrd));
    },
    Eq10: function() {
        return $0a5aaf95f168428e$export$1b7ecac9aff49fbc;
    }
};






// Generated by purs version 0.15.15











// Generated by purs version 0.15.15











var $d347d4a6047cfbb7$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $d347d4a6047cfbb7$export$32182de66c0f2dc = function(x) {
    return x;
};
var $d347d4a6047cfbb7$export$6a4f2e5f31d3761c = {};
var $d347d4a6047cfbb7$export$4739cdc7a16124b7 = function() {
    return function() {
        return function() {
            return function(dictTypeEquals) {
                return {};
            };
        };
    };
};
var $d347d4a6047cfbb7$export$6fc9236c71f256a4 = {
    variantTags: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    }
};
var $d347d4a6047cfbb7$export$a263890827176f5b = function(dict) {
    return dict.variantTags;
};
var $d347d4a6047cfbb7$export$3e3102906739bb5 = function(dictVariantTags) {
    var variantTags1 = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return {
            variantTags: function(v) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value), variantTags1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $d347d4a6047cfbb7$export$d1aea78948817787 = {};
var $d347d4a6047cfbb7$export$1949f0d69e5abced = function() {
    return function() {
        return function(dictTypeEquals) {
            return {};
        };
    };
};
var $d347d4a6047cfbb7$export$6f0b08b36cbce25a = {};
var $d347d4a6047cfbb7$export$b5757a9808e9530a = function() {
    return function() {
        return function() {
            return function(dictTypeEquals) {
                return {};
            };
        };
    };
};
var $d347d4a6047cfbb7$export$741d3de26d29fa9f = {};
var $d347d4a6047cfbb7$export$45d721e92c315fa2 = function() {
    return function() {
        return function() {
            return function(dictTypeEquals) {
                return {};
            };
        };
    };
};
var $d347d4a6047cfbb7$export$2b06a6b70b94fb9b = {};
var $d347d4a6047cfbb7$export$a29149e68f9502c0 = function() {
    return function() {
        return function(dictTypeEquals) {
            return {};
        };
    };
};
var $d347d4a6047cfbb7$export$d751f4e16bdd3580 = {};
var $d347d4a6047cfbb7$export$51fd493d6e05a16 = function() {
    return function() {
        return function() {
            return function(dictTypeEquals) {
                return {};
            };
        };
    };
};
var $d347d4a6047cfbb7$export$8c9c13f4abebac02 = /* #__PURE__ */ function() {
    var go = function($copy_ix) {
        return function($copy_v) {
            return function($copy_v1) {
                var $tco_var_ix = $copy_ix;
                var $tco_var_v = $copy_v;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(ix, v, v1) {
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        if (v1.value0.cardinality > ix) {
                            var v2 = v1.value0.toEnum(ix);
                            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                $tco_done = true;
                                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                    type: v.value0,
                                    value: v2.value0
                                });
                            }
                            $tco_done = true;
                            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        }
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                            $tco_var_ix = ix - v1.value0.cardinality | 0;
                            $tco_var_v = v.value1;
                            $copy_v1 = v1.value1;
                            return;
                        }
                    }
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_ix, $tco_var_v, $copy_v1);
                return $tco_result;
            };
        };
    };
    return go;
}();
var $d347d4a6047cfbb7$export$9da7ea4590baa01b = function(tag) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                if (v.value0 === tag) {
                    $tco_done = true;
                    return true;
                }
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    $copy_v = v.value1;
                    return;
                }
            }
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return false;
            }
            throw new Error("Failed pattern match at Data.Variant.Internal (line 154, column 8 - line 158, column 18): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return go;
};
var $d347d4a6047cfbb7$export$75c8b177a15c9f3a = /* #__PURE__ */ function() {
    var go = function($copy_acc) {
        return function($copy_v) {
            var $tco_var_acc = $copy_acc;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(acc, v) {
                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_acc = acc + v.value0.cardinality | 0;
                    $copy_v = v.value1;
                    return;
                }
                if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return acc;
                }
                throw new Error("Failed pattern match at Data.Variant.Internal (line 276, column 12 - line 278, column 16): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_v);
            return $tco_result;
        };
    };
    return go(0);
}();
var $d347d4a6047cfbb7$export$9562f45d0aad2672 = function(str) {
    return $8bcde8f642a64c7d$export$51b220bae4359b72("Data.Variant: impossible `" + (str + "`"));
};
var $d347d4a6047cfbb7$export$dfc7155ac0343b8 = function(name) {
    return function(tag) {
        var go = function($copy_v) {
            return function($copy_v1) {
                var $tco_var_v = $copy_v;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1) {
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        if (v.value0 === tag) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                            $tco_var_v = v.value1;
                            $copy_v1 = v1.value1;
                            return;
                        }
                    }
                    $tco_done = true;
                    return $d347d4a6047cfbb7$export$9562f45d0aad2672(name);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                return $tco_result;
            };
        };
        return go;
    };
};
var $d347d4a6047cfbb7$export$f2569b7ebfd16005 = function(tags) {
    return function(eqs) {
        return function(v) {
            return function(v1) {
                if (v.type === v1.type) return $d347d4a6047cfbb7$export$dfc7155ac0343b8("eq")(v.type)(tags)(eqs)(v.value)(v1.value);
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return false;
                throw new Error("Failed pattern match at Data.Variant.Internal (line 160, column 1 - line 165, column 12): " + [
                    tags.constructor.name,
                    eqs.constructor.name,
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    };
};
var $d347d4a6047cfbb7$export$109702b9a7154017 = function(tags) {
    return function(ords) {
        return function(v) {
            return function(v1) {
                var v3 = $d347d4a6047cfbb7$var$compare(v.type)(v1.type);
                if (v3 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $d347d4a6047cfbb7$export$dfc7155ac0343b8("compare")(v.type)(tags)(ords)(v.value)(v1.value);
                return v3;
            };
        };
    };
};
var $d347d4a6047cfbb7$export$c21fa4428dbc447f = function(name) {
    return function(f) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return {
                    type: v.value0,
                    value: f(v1.value0)
                };
                return $d347d4a6047cfbb7$export$9562f45d0aad2672(name);
            };
        };
        return go;
    };
};
var $d347d4a6047cfbb7$export$3c34dd558a358bbc = function(v) {
    var go = function($copy_acc) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_acc = $copy_acc;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, v1, v2) {
                    if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        if (v1.value0 === v.type) {
                            $tco_done = true;
                            return acc + v2.value0.fromEnum(v.value) | 0;
                        }
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                            $tco_var_acc = acc + v2.value0.cardinality | 0;
                            $tco_var_v1 = v1.value1;
                            $copy_v2 = v2.value1;
                            return;
                        }
                    }
                    $tco_done = true;
                    return $d347d4a6047cfbb7$export$9562f45d0aad2672("fromEnum");
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return go(0);
};
var $d347d4a6047cfbb7$export$53ce69aede1374ee = function(name) {
    return function(f) {
        var go = function($copy_v) {
            return function($copy_v1) {
                var $tco_var_v = $copy_v;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1) {
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done = true;
                        return {
                            type: v.value0,
                            value: f(v1.value0)
                        };
                    }
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        $tco_var_v = v.value1;
                        $copy_v1 = v1.value1;
                        return;
                    }
                    $tco_done = true;
                    return $d347d4a6047cfbb7$export$9562f45d0aad2672(name);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                return $tco_result;
            };
        };
        return go;
    };
};
var $d347d4a6047cfbb7$export$5f7558b7e8dd3d2 = function(v) {
    var go2 = function($copy_t1) {
        return function($copy_b1) {
            return function($copy_v1) {
                return function($copy_v2) {
                    return function($copy_v3) {
                        return function($copy_v4) {
                            var $tco_var_t1 = $copy_t1;
                            var $tco_var_b1 = $copy_b1;
                            var $tco_var_v1 = $copy_v1;
                            var $tco_var_v2 = $copy_v2;
                            var $tco_var_v3 = $copy_v3;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(t1, b1, v1, v2, v3, v4) {
                                if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v3 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v4 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                    if (v2.value0 === v.type) {
                                        var v5 = v4.value0.pred(v.value);
                                        if (v5 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                                            $tco_done = true;
                                            return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                                type: t1,
                                                value: b1.top
                                            });
                                        }
                                        if (v5 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                            $tco_done = true;
                                            return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                                type: v.type,
                                                value: v5.value0
                                            });
                                        }
                                        throw new Error("Failed pattern match at Data.Variant.Internal (line 244, column 11 - line 246, column 69): " + [
                                            v5.constructor.name
                                        ]);
                                    }
                                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                                        $tco_var_t1 = v2.value0;
                                        $tco_var_b1 = v3.value0;
                                        $tco_var_v1 = v4.value0;
                                        $tco_var_v2 = v2.value1;
                                        $tco_var_v3 = v3.value1;
                                        $copy_v4 = v4.value1;
                                        return;
                                    }
                                }
                                $tco_done = true;
                                return $d347d4a6047cfbb7$export$9562f45d0aad2672("pred");
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_t1, $tco_var_b1, $tco_var_v1, $tco_var_v2, $tco_var_v3, $copy_v4);
                            return $tco_result;
                        };
                    };
                };
            };
        };
    };
    var go1 = function(v1) {
        return function(v2) {
            return function(v3) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v3 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    if (v1.value0 === v.type) {
                        var v4 = v3.value0.pred(v.value);
                        if (v4 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        if (v4 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                            type: v.type,
                            value: v4.value0
                        });
                        throw new Error("Failed pattern match at Data.Variant.Internal (line 235, column 11 - line 237, column 69): " + [
                            v4.constructor.name
                        ]);
                    }
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return go2(v1.value0)(v2.value0)(v3.value0)(v1.value1)(v2.value1)(v3.value1);
                }
                return $d347d4a6047cfbb7$export$9562f45d0aad2672("pred");
            };
        };
    };
    return go1;
};
var $d347d4a6047cfbb7$export$df26e2801d56dff3 = function(v) {
    var go = function($copy_v1) {
        return function($copy_v2) {
            return function($copy_v3) {
                var $tco_var_v1 = $copy_v1;
                var $tco_var_v2 = $copy_v2;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v1, v2, v3) {
                    if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v3 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        if (v1.value0 === v.type) {
                            var v4 = v3.value0.succ(v.value);
                            if (v4 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                $tco_done = true;
                                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                    type: v1.value0,
                                    value: v4.value0
                                });
                            }
                            if (v4 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                                if (v1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                    $tco_done = true;
                                    return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                        type: v1.value1.value0,
                                        value: v2.value1.value0.bottom
                                    });
                                }
                                $tco_done = true;
                                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                            }
                            throw new Error("Failed pattern match at Data.Variant.Internal (line 262, column 11 - line 266, column 29): " + [
                                v4.constructor.name
                            ]);
                        }
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                            $tco_var_v1 = v1.value1;
                            $tco_var_v2 = v2.value1;
                            $copy_v3 = v3.value1;
                            return;
                        }
                    }
                    $tco_done = true;
                    return $d347d4a6047cfbb7$export$9562f45d0aad2672("succ");
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v1, $tco_var_v2, $copy_v3);
                return $tco_result;
            };
        };
    };
    return go;
};
var $d347d4a6047cfbb7$export$e85cf2e1daa1e0a4 = function() {
    return function() {
        return function(dictVariantTags) {
            var variantTags1 = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
            return {
                contractWith: function(dictAlternative) {
                    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
                    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictAlternative.Plus1());
                    return function(v) {
                        return function(v1) {
                            return function(tag) {
                                return function(a) {
                                    if ($d347d4a6047cfbb7$export$9da7ea4590baa01b(tag)(variantTags1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))) return pure(a);
                                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return empty;
                                    throw new Error("Failed pattern match at Data.Variant.Internal (line 315, column 1 - line 324, column 24): " + [
                                        v.constructor.name,
                                        v1.constructor.name,
                                        tag.constructor.name,
                                        a.constructor.name
                                    ]);
                                };
                            };
                        };
                    };
                }
            };
        };
    };
};
var $d347d4a6047cfbb7$export$3f68b7f308cef1ff = function(dict) {
    return dict.contractWith;
};






var $a5ccce070b256bc7$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $a5ccce070b256bc7$export$23f56de7015da7e2 = function(x) {
    return x;
};
var $a5ccce070b256bc7$export$38e1d92de9476ba9 = function(dict) {
    return dict.variantShows;
};
var $a5ccce070b256bc7$export$d424ff163a450f59 = function(dict) {
    return dict.variantOrds;
};
var $a5ccce070b256bc7$export$e23cdac3d43a2502 = function(dict) {
    return dict.variantEqs;
};
var $a5ccce070b256bc7$export$ac5da622fbb79b7a = function(dict) {
    return dict.variantBoundedEnums;
};
var $a5ccce070b256bc7$export$4a2422da06e04a63 = function(dict) {
    return dict.variantBounded;
};
var $a5ccce070b256bc7$export$82222823f552eea3 = function(v) {
    return function(f) {
        return (function(dictIsSymbol) {
            var f1 = f(dictIsSymbol)();
            return function() {
                return f1;
            };
        })({
            reflectSymbol: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(v.type)
        })({})($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v.value);
    };
};
var $a5ccce070b256bc7$export$edaed73c040edf0e = function() {
    return function() {
        return function() {
            return function() {
                return function(dictFunctor) {
                    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictFunctor);
                    return function(r) {
                        return function(k) {
                            return function(v) {
                                if ($d2fadbdf02925823$export$12c1b2b255bc527d(v.type)(r)) return mapFlipped($d2fadbdf02925823$export$1d94535d2cda4eda(v.type)(r)(v.value))(function(value) {
                                    return {
                                        type: v.type,
                                        value: value
                                    };
                                });
                                return k(v);
                            };
                        };
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$traverseSome1 = /* #__PURE__ */ $a5ccce070b256bc7$export$edaed73c040edf0e()()()();
var $a5ccce070b256bc7$export$df3f009e3d155b20 = function() {
    return function() {
        return function() {
            return function() {
                return function(dictApplicative) {
                    var traverseSome2 = $a5ccce070b256bc7$var$traverseSome1(dictApplicative.Apply0().Functor0());
                    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
                    return function(r) {
                        return traverseSome2(r)(function($173) {
                            return pure($173);
                        });
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$export$ab9a97d5d556e541 = {
    variantShows: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    }
};
var $a5ccce070b256bc7$export$b0bcf256e53c8ada = function(dictVariantShows) {
    var variantShows1 = $a5ccce070b256bc7$export$38e1d92de9476ba9(dictVariantShows);
    return function(dictShow) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
        return {
            variantShows: function(v) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(show1, variantShows1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $a5ccce070b256bc7$export$e2d6a1adf0a4395e = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        return function(dictVariantShows) {
            var variantShows1 = $a5ccce070b256bc7$export$38e1d92de9476ba9(dictVariantShows);
            return {
                show: function(v1) {
                    var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                    var shows = variantShows1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                    var body = $d347d4a6047cfbb7$export$dfc7155ac0343b8("show")(v1.type)(tags)(shows)(v1.value);
                    return "(inj @" + ($a5ccce070b256bc7$var$show(v1.type) + (" " + (body + ")")));
                }
            };
        };
    };
};
var $a5ccce070b256bc7$export$87171bfc157a152b = function() {
    return function() {
        return function() {
            return function() {
                return function(r) {
                    return function(k) {
                        return function(v) {
                            if ($d2fadbdf02925823$export$12c1b2b255bc527d(v.type)(r)) return {
                                type: v.type,
                                value: $d2fadbdf02925823$export$1d94535d2cda4eda(v.type)(r)(v.value)
                            };
                            return k(v);
                        };
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$overSome1 = /* #__PURE__ */ $a5ccce070b256bc7$export$87171bfc157a152b()()()();
var $a5ccce070b256bc7$export$fb4902fd9e525693 = function() {
    return function() {
        return function() {
            return function() {
                return function(r) {
                    return $a5ccce070b256bc7$var$overSome1(r)($ac8b3532514ac019$export$401372c57776dc);
                };
            };
        };
    };
};
var $a5ccce070b256bc7$export$75fb33597d13f1b9 = {
    variantOrds: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    }
};
var $a5ccce070b256bc7$export$1c5384046479a778 = function(dictVariantOrds) {
    var variantOrds1 = $a5ccce070b256bc7$export$d424ff163a450f59(dictVariantOrds);
    return function(dictOrd) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
        return {
            variantOrds: function(v) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(compare, variantOrds1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $a5ccce070b256bc7$export$df0655ae5ee3c0a3 = function() {
    return function() {
        return function() {
            return function(r) {
                return function(k) {
                    return function(v) {
                        if ($d2fadbdf02925823$export$12c1b2b255bc527d(v.type)(r)) return $d2fadbdf02925823$export$1d94535d2cda4eda(v.type)(r)(v.value);
                        return k(v);
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$onMatch1 = /* #__PURE__ */ $a5ccce070b256bc7$export$df0655ae5ee3c0a3()()();
var $a5ccce070b256bc7$export$af631764ddc44097 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(p) {
            return function(f) {
                return function(g) {
                    return function(r) {
                        if (r.type === reflectSymbol(p)) return f(r.value);
                        return g(r);
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$on1 = /* #__PURE__ */ $a5ccce070b256bc7$export$af631764ddc44097();
var $a5ccce070b256bc7$export$275cc6de179498bd = function() {
    return function(dictIsSymbol) {
        var on2 = $a5ccce070b256bc7$var$on1(dictIsSymbol);
        return function(dictAlternative) {
            var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
            var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictAlternative.Plus1());
            return function(p) {
                return on2(p)(pure)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(empty));
            };
        };
    };
};
var $a5ccce070b256bc7$export$38d8e7a5e0c746a7 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(p) {
            return function(value) {
                return {
                    type: reflectSymbol(p),
                    value: value
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$inj1 = /* #__PURE__ */ $a5ccce070b256bc7$export$38d8e7a5e0c746a7();
var $a5ccce070b256bc7$export$1723983dbe3de839 = function(dictIsSymbol) {
    var on2 = $a5ccce070b256bc7$var$on1(dictIsSymbol);
    var inj2 = $a5ccce070b256bc7$var$inj1(dictIsSymbol);
    return function() {
        return function() {
            return function(p) {
                return function(f) {
                    return on2(p)(function() {
                        var $174 = inj2(p);
                        return function($175) {
                            return $174(f($175));
                        };
                    }());
                };
            };
        };
    };
};
var $a5ccce070b256bc7$export$a1d302ac1e9eaf3f = function(v) {
    return v(function(dictIsSymbol) {
        var inj2 = $a5ccce070b256bc7$var$inj1(dictIsSymbol);
        return function() {
            return inj2;
        };
    });
};
var $a5ccce070b256bc7$export$d5e4114ba15d04e1 = function(dictIsSymbol) {
    var on2 = $a5ccce070b256bc7$var$on1(dictIsSymbol);
    var inj2 = $a5ccce070b256bc7$var$inj1(dictIsSymbol);
    return function() {
        return function() {
            return function(dictFunctor) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
                return function(p) {
                    return function(f) {
                        return on2(p)(function() {
                            var $176 = map(inj2(p));
                            return function($177) {
                                return $176(f($177));
                            };
                        }());
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$export$9f77e0932fb78f72 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};
var $a5ccce070b256bc7$export$c2f7c2356dc086a8 = {
    variantEqs: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    }
};
var $a5ccce070b256bc7$export$335882e181da9bfc = function(dictVariantEqs) {
    var variantEqs1 = $a5ccce070b256bc7$export$e23cdac3d43a2502(dictVariantEqs);
    return function(dictEq) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return {
            variantEqs: function(v) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(eq1, variantEqs1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $a5ccce070b256bc7$export$24934809abce965 = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        return function(dictVariantEqs) {
            var variantEqs1 = $a5ccce070b256bc7$export$e23cdac3d43a2502(dictVariantEqs);
            return {
                eq: function(v1) {
                    return function(v2) {
                        var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        var eqs = variantEqs1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        return $d347d4a6047cfbb7$export$f2569b7ebfd16005(tags)(eqs)(v1)(v2);
                    };
                }
            };
        };
    };
};
var $a5ccce070b256bc7$var$eqVariant1 = /* #__PURE__ */ $a5ccce070b256bc7$export$24934809abce965();
var $a5ccce070b256bc7$export$15fe5b140c3b0d78 = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        var eqVariant2 = $a5ccce070b256bc7$var$eqVariant1(dictVariantTags);
        return function(dictVariantEqs) {
            var eqVariant3 = eqVariant2(dictVariantEqs);
            return function(dictVariantOrds) {
                var variantOrds1 = $a5ccce070b256bc7$export$d424ff163a450f59(dictVariantOrds);
                return {
                    compare: function(v1) {
                        return function(v2) {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var ords = variantOrds1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$109702b9a7154017(tags)(ords)(v1)(v2);
                        };
                    },
                    Eq0: function() {
                        return eqVariant3;
                    }
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$ordVariant1 = /* #__PURE__ */ $a5ccce070b256bc7$export$15fe5b140c3b0d78();
var $a5ccce070b256bc7$export$dc1f78402967431c = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        var ordVariant2 = $a5ccce070b256bc7$var$ordVariant1(dictVariantTags);
        return function(dictVariantEqs) {
            var ordVariant3 = ordVariant2(dictVariantEqs);
            return function(dictVariantOrds) {
                var ordVariant4 = ordVariant3(dictVariantOrds);
                return function(dictVariantBoundedEnums) {
                    var variantBoundedEnums1 = $a5ccce070b256bc7$export$ac5da622fbb79b7a(dictVariantBoundedEnums);
                    var variantBounded1 = $a5ccce070b256bc7$export$4a2422da06e04a63(dictVariantBoundedEnums.VariantBounded0());
                    return {
                        pred: function(a) {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var bounds = variantBounded1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$5f7558b7e8dd3d2(a)(tags)(bounds)(dicts);
                        },
                        succ: function(a) {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var bounds = variantBounded1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$df26e2801d56dff3(a)(tags)(bounds)(dicts);
                        },
                        Ord0: function() {
                            return ordVariant4;
                        }
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$enumVariant1 = /* #__PURE__ */ $a5ccce070b256bc7$export$dc1f78402967431c();
var $a5ccce070b256bc7$export$2e2bcd8739ae039 = function(a) {
    return function(v) {
        return a;
    };
};
var $a5ccce070b256bc7$export$85ad66dc59ec94d8 = function(dictAlternative) {
    return function(dictContractable) {
        var contractWith = $d347d4a6047cfbb7$export$3f68b7f308cef1ff(dictContractable)(dictAlternative);
        return function(v) {
            return contractWith($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v.type)(v);
        };
    };
};
var $a5ccce070b256bc7$export$637cc851f3ae4876 = function(r) {
    return $8bcde8f642a64c7d$export$51b220bae4359b72("Data.Variant: pattern match failure [" + (r.type + "]"));
};
var $a5ccce070b256bc7$export$4659b591c19bdf3d = function() {
    return function() {
        return function() {
            return function(r) {
                return $a5ccce070b256bc7$var$onMatch1(r)($a5ccce070b256bc7$export$637cc851f3ae4876);
            };
        };
    };
};
var $a5ccce070b256bc7$export$68f6414e72b9a165 = {
    variantBounded: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    }
};
var $a5ccce070b256bc7$export$494c99098dfcb7b = {
    variantBoundedEnums: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    },
    VariantBounded0: function() {
        return $a5ccce070b256bc7$export$68f6414e72b9a165;
    }
};
var $a5ccce070b256bc7$export$95aefd516ed26ef = function(dictVariantBounded) {
    var variantBounded1 = $a5ccce070b256bc7$export$4a2422da06e04a63(dictVariantBounded);
    return function(dictBounded) {
        var top = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
        var bottom = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
        return {
            variantBounded: function(v) {
                var dict = {
                    top: top,
                    bottom: bottom
                };
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(dict, variantBounded1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $a5ccce070b256bc7$export$f976999753dd7e2 = function(dictVariantBoundedEnums) {
    var variantBoundedEnums1 = $a5ccce070b256bc7$export$ac5da622fbb79b7a(dictVariantBoundedEnums);
    var boundedVariantCons1 = $a5ccce070b256bc7$export$95aefd516ed26ef(dictVariantBoundedEnums.VariantBounded0());
    return function(dictBoundedEnum) {
        var Enum1 = dictBoundedEnum.Enum1();
        var pred = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
        var succ = $f935a9866e211c00$export$61d85e1612867711(Enum1);
        var fromEnum = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
        var toEnum = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
        var cardinality = $f935a9866e211c00$export$9e9949f96c411257(dictBoundedEnum);
        var boundedVariantCons2 = boundedVariantCons1(dictBoundedEnum.Bounded0());
        return {
            variantBoundedEnums: function(v) {
                var dict = {
                    pred: pred,
                    succ: succ,
                    fromEnum: fromEnum,
                    toEnum: toEnum,
                    cardinality: cardinality
                };
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(dict, variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            },
            VariantBounded0: function() {
                return boundedVariantCons2;
            }
        };
    };
};
var $a5ccce070b256bc7$export$8b12c85aa9fcb36b = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        var ordVariant2 = $a5ccce070b256bc7$var$ordVariant1(dictVariantTags);
        return function(dictVariantEqs) {
            var ordVariant3 = ordVariant2(dictVariantEqs);
            return function(dictVariantOrds) {
                var ordVariant4 = ordVariant3(dictVariantOrds);
                return function(dictVariantBounded) {
                    var variantBounded1 = $a5ccce070b256bc7$export$4a2422da06e04a63(dictVariantBounded);
                    return {
                        top: function() {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBounded1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$53ce69aede1374ee("top")(function(v) {
                                return v.top;
                            })(tags)(dicts);
                        }(),
                        bottom: function() {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBounded1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$c21fa4428dbc447f("bottom")(function(v) {
                                return v.bottom;
                            })(tags)(dicts);
                        }(),
                        Ord0: function() {
                            return ordVariant4;
                        }
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$boundedVariant1 = /* #__PURE__ */ $a5ccce070b256bc7$export$8b12c85aa9fcb36b();
var $a5ccce070b256bc7$export$a1afb46b142304ae = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        var boundedVariant2 = $a5ccce070b256bc7$var$boundedVariant1(dictVariantTags);
        var enumVariant2 = $a5ccce070b256bc7$var$enumVariant1(dictVariantTags);
        return function(dictVariantEqs) {
            var boundedVariant3 = boundedVariant2(dictVariantEqs);
            var enumVariant3 = enumVariant2(dictVariantEqs);
            return function(dictVariantOrds) {
                var boundedVariant4 = boundedVariant3(dictVariantOrds);
                var enumVariant4 = enumVariant3(dictVariantOrds);
                return function(dictVariantBoundedEnums) {
                    var variantBoundedEnums1 = $a5ccce070b256bc7$export$ac5da622fbb79b7a(dictVariantBoundedEnums);
                    var boundedVariant5 = boundedVariant4(dictVariantBoundedEnums.VariantBounded0());
                    var enumVariant5 = enumVariant4(dictVariantBoundedEnums);
                    return {
                        cardinality: $d347d4a6047cfbb7$export$75c8b177a15c9f3a(variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)),
                        fromEnum: function(a) {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$3c34dd558a358bbc(a)(tags)(dicts);
                        },
                        toEnum: function(n) {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$8c9c13f4abebac02(n)(tags)(dicts);
                        },
                        Bounded0: function() {
                            return boundedVariant5;
                        },
                        Enum1: function() {
                            return enumVariant5;
                        }
                    };
                };
            };
        };
    };
};



// Generated by purs version 0.15.15
const $28d793bcad7b6401$export$33e695b1da6bf8ce = function mkEffectFn1(fn) {
    return function(x) {
        return fn(x)();
    };
};
const $28d793bcad7b6401$export$d349e7010d9e4f18 = function mkEffectFn2(fn) {
    return function(a, b) {
        return fn(a)(b)();
    };
};
const $28d793bcad7b6401$export$1329fa30c595aae1 = function mkEffectFn3(fn) {
    return function(a, b, c) {
        return fn(a)(b)(c)();
    };
};
const $28d793bcad7b6401$export$745d51d1abc5cd82 = function mkEffectFn4(fn) {
    return function(a, b, c, d) {
        return fn(a)(b)(c)(d)();
    };
};
const $28d793bcad7b6401$export$b3413456c3617180 = function mkEffectFn5(fn) {
    return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e)();
    };
};
const $28d793bcad7b6401$export$becea21a68009b07 = function mkEffectFn6(fn) {
    return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f)();
    };
};
const $28d793bcad7b6401$export$83674e2607660e0f = function mkEffectFn7(fn) {
    return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g)();
    };
};
const $28d793bcad7b6401$export$c7f26c65f1b8e3 = function mkEffectFn8(fn) {
    return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)();
    };
};
const $28d793bcad7b6401$export$5d4846e0dbe026fa = function mkEffectFn9(fn) {
    return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)();
    };
};
const $28d793bcad7b6401$export$ac08820aca1c1ebc = function mkEffectFn10(fn) {
    return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)();
    };
};
const $28d793bcad7b6401$export$84baa7a1ea5377fd = function runEffectFn1(fn) {
    return function(a) {
        return function() {
            return fn(a);
        };
    };
};
const $28d793bcad7b6401$export$6a301f847372dca1 = function runEffectFn2(fn) {
    return function(a) {
        return function(b) {
            return function() {
                return fn(a, b);
            };
        };
    };
};
const $28d793bcad7b6401$export$40df0ea470e346f0 = function runEffectFn3(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function() {
                    return fn(a, b, c);
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$ec3c5c8caae58867 = function runEffectFn4(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function() {
                        return fn(a, b, c, d);
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$5b882d1088aa8dc9 = function runEffectFn5(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function() {
                            return fn(a, b, c, d, e);
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$53e477d88d18e854 = function runEffectFn6(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function() {
                                return fn(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$2d0fb35e82261b8d = function runEffectFn7(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function() {
                                    return fn(a, b, c, d, e, f, g);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$801a85b4a2b405ac = function runEffectFn8(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function() {
                                        return fn(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$326863f2889caa23 = function runEffectFn9(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function() {
                                            return fn(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$8fc2053a354b81aa = function runEffectFn10(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return function() {
                                                return fn(a, b, c, d, e, f, g, h, i, j);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};





var $252b49eb63e60f04$export$6b33adf3a8e3f704 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$5d4846e0dbe026fa(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return function(i) {
                                                    return append($28d793bcad7b6401$export$326863f2889caa23(f1)(a)(b)(c)(d)(e)(f)(g)(h)(i))($28d793bcad7b6401$export$326863f2889caa23(f2)(a)(b)(c)(d)(e)(f)(g)(h)(i));
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$1b434506fc11421 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$c7f26c65f1b8e3(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return append($28d793bcad7b6401$export$801a85b4a2b405ac(f1)(a)(b)(c)(d)(e)(f)(g)(h))($28d793bcad7b6401$export$801a85b4a2b405ac(f2)(a)(b)(c)(d)(e)(f)(g)(h));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$f9d62e28920765a6 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$83674e2607660e0f(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return append($28d793bcad7b6401$export$2d0fb35e82261b8d(f1)(a)(b)(c)(d)(e)(f)(g))($28d793bcad7b6401$export$2d0fb35e82261b8d(f2)(a)(b)(c)(d)(e)(f)(g));
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$1cdb6e5a843aefe2 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$becea21a68009b07(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return append($28d793bcad7b6401$export$53e477d88d18e854(f1)(a)(b)(c)(d)(e)(f))($28d793bcad7b6401$export$53e477d88d18e854(f2)(a)(b)(c)(d)(e)(f));
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$99aa837ed31887aa = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$b3413456c3617180(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return append($28d793bcad7b6401$export$5b882d1088aa8dc9(f1)(a)(b)(c)(d)(e))($28d793bcad7b6401$export$5b882d1088aa8dc9(f2)(a)(b)(c)(d)(e));
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$8cb019b91258e3b9 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$745d51d1abc5cd82(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return append($28d793bcad7b6401$export$ec3c5c8caae58867(f1)(a)(b)(c)(d))($28d793bcad7b6401$export$ec3c5c8caae58867(f2)(a)(b)(c)(d));
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$fb0bdf58ff0a6426 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$1329fa30c595aae1(function(a) {
                    return function(b) {
                        return function(c) {
                            return append($28d793bcad7b6401$export$40df0ea470e346f0(f1)(a)(b)(c))($28d793bcad7b6401$export$40df0ea470e346f0(f2)(a)(b)(c));
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$9bf195cde6bca966 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$d349e7010d9e4f18(function(a) {
                    return function(b) {
                        return append($28d793bcad7b6401$export$6a301f847372dca1(f1)(a)(b))($28d793bcad7b6401$export$6a301f847372dca1(f2)(a)(b));
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$39f0bfa3de9c8ca1 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$ac08820aca1c1ebc(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return function(i) {
                                                    return function(j) {
                                                        return append($28d793bcad7b6401$export$8fc2053a354b81aa(f1)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j))($28d793bcad7b6401$export$8fc2053a354b81aa(f2)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j));
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$d15c5b9160f5bf5 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$33e695b1da6bf8ce(function(a) {
                    return append($28d793bcad7b6401$export$84baa7a1ea5377fd(f1)(a))($28d793bcad7b6401$export$84baa7a1ea5377fd(f2)(a));
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$951567719e338e25 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn91 = $252b49eb63e60f04$export$6b33adf3a8e3f704(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$5d4846e0dbe026fa(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return function(v8) {
                                            return mempty;
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn91;
        }
    };
};
var $252b49eb63e60f04$export$60b4106c40599be6 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn81 = $252b49eb63e60f04$export$1b434506fc11421(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$c7f26c65f1b8e3(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return mempty;
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn81;
        }
    };
};
var $252b49eb63e60f04$export$63d6254dd5b47db1 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn71 = $252b49eb63e60f04$export$f9d62e28920765a6(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$83674e2607660e0f(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return mempty;
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn71;
        }
    };
};
var $252b49eb63e60f04$export$80d58e93d1dd53e4 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn61 = $252b49eb63e60f04$export$1cdb6e5a843aefe2(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$becea21a68009b07(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return mempty;
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn61;
        }
    };
};
var $252b49eb63e60f04$export$c346a9c2957c12e8 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn51 = $252b49eb63e60f04$export$99aa837ed31887aa(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$b3413456c3617180(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return mempty;
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn51;
        }
    };
};
var $252b49eb63e60f04$export$fd6b07fef28d22de = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn41 = $252b49eb63e60f04$export$8cb019b91258e3b9(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$745d51d1abc5cd82(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return mempty;
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn41;
        }
    };
};
var $252b49eb63e60f04$export$f091af598ee150a6 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn31 = $252b49eb63e60f04$export$fb0bdf58ff0a6426(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$1329fa30c595aae1(function(v) {
            return function(v1) {
                return function(v2) {
                    return mempty;
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn31;
        }
    };
};
var $252b49eb63e60f04$export$6294c3a3ece87949 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn21 = $252b49eb63e60f04$export$9bf195cde6bca966(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$d349e7010d9e4f18(function(v) {
            return function(v1) {
                return mempty;
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn21;
        }
    };
};
var $252b49eb63e60f04$export$c62e1ced10b8c8b0 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn101 = $252b49eb63e60f04$export$39f0bfa3de9c8ca1(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$ac08820aca1c1ebc(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return function(v8) {
                                            return function(v9) {
                                                return mempty;
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn101;
        }
    };
};
var $252b49eb63e60f04$export$333b269eda63e7a7 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn11 = $252b49eb63e60f04$export$d15c5b9160f5bf5(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$33e695b1da6bf8ce(function(v) {
            return mempty;
        }),
        Semigroup0: function() {
            return semigroupEffectFn11;
        }
    };
};


// Generated by purs version 0.15.15
const $c02f07bc0f38e9e9$export$c62839628b30a695 = function(f) {
    return f();
};





// Generated by purs version 0.15.15
function $2d783a45bb716946$export$209a9e76e7f1bdd5(f, s, key, value) {
    return value == null ? f : s(value[key]);
}
function $2d783a45bb716946$export$2c522840c892e8a(prop, value) {
    return Object.prototype.hasOwnProperty.call(value, prop);
}
function $2d783a45bb716946$export$c3f84ec7467d28a0(prop, value) {
    return prop in value;
}







var $79efcffe70231542$var$unsafeReadProp = function(dictMonad) {
    var fail = $c97d2d0f578f81ad$export$2b62a06a9fee979c(dictMonad);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    return function(k) {
        return function(value) {
            return $2d783a45bb716946$export$209a9e76e7f1bdd5(fail(new $c97d2d0f578f81ad$export$168e2d3b16829a("object", $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(value))), pure, k, value);
        };
    };
};
var $79efcffe70231542$export$d133c026d013828b = function(dictMonad) {
    return $79efcffe70231542$var$unsafeReadProp(dictMonad);
};
var $79efcffe70231542$export$49ec5109fafd7888 = function(dictMonad) {
    return $79efcffe70231542$var$unsafeReadProp(dictMonad);
};
var $79efcffe70231542$export$bc3518d3f65cefd1 = function(dict) {
    return dict.ix;
};
var $79efcffe70231542$export$b610b8812bbcded9 = function(dict) {
    return dict.index;
};
var $79efcffe70231542$export$8e083630a1c429e2 = function(dictMonad) {
    var bindFlipped = $70cd3177464e7915$export$f2077a1c19a006d9($d2284b2d3e1b6f87$export$a8cbc0f84e8b069b(dictMonad));
    return {
        ix: function(dictIndex) {
            var index1 = $79efcffe70231542$export$b610b8812bbcded9(dictIndex);
            return function(f) {
                return function(i) {
                    return bindFlipped($f57f4b701aa7b66e$export$8a83211c878a3f1f(index1)(i))(f);
                };
            };
        }
    };
};
var $79efcffe70231542$export$5603d6456559ad27 = function(dictMonad) {
    return {
        ix: function(dictIndex) {
            return $79efcffe70231542$export$b610b8812bbcded9(dictIndex);
        }
    };
};
var $79efcffe70231542$var$hasPropertyImpl = function(v) {
    return function(v1) {
        if ($c2c5bfcfd98ddabb$export$630801d484da15df(v1)) return false;
        if ($c2c5bfcfd98ddabb$export$fce6876652108ab(v1)) return false;
        if ($c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(v1) === "object" || $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(v1) === "function") return $2d783a45bb716946$export$c3f84ec7467d28a0(v, v1);
        return false;
    };
};
var $79efcffe70231542$export$bf9617eaf5d2451 = function(dict) {
    return dict.hasProperty;
};
var $79efcffe70231542$var$hasOwnPropertyImpl = function(v) {
    return function(v1) {
        if ($c2c5bfcfd98ddabb$export$630801d484da15df(v1)) return false;
        if ($c2c5bfcfd98ddabb$export$fce6876652108ab(v1)) return false;
        if ($c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(v1) === "object" || $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(v1) === "function") return $2d783a45bb716946$export$2c522840c892e8a(v, v1);
        return false;
    };
};
var $79efcffe70231542$export$27e041b47b0d7594 = function(dictMonad) {
    return {
        index: $f57f4b701aa7b66e$export$8a83211c878a3f1f($79efcffe70231542$export$49ec5109fafd7888(dictMonad)),
        hasProperty: $79efcffe70231542$var$hasPropertyImpl,
        hasOwnProperty: $79efcffe70231542$var$hasOwnPropertyImpl,
        errorAt: $c97d2d0f578f81ad$export$20d9a5af040a79f1.create
    };
};
var $79efcffe70231542$export$d60c33947aba4299 = function(dictMonad) {
    return {
        index: $f57f4b701aa7b66e$export$8a83211c878a3f1f($79efcffe70231542$export$d133c026d013828b(dictMonad)),
        hasProperty: $79efcffe70231542$var$hasPropertyImpl,
        hasOwnProperty: $79efcffe70231542$var$hasOwnPropertyImpl,
        errorAt: $c97d2d0f578f81ad$export$92e5795aa905bd26.create
    };
};
var $79efcffe70231542$export$5a15a386532a5ea4 = function(dict) {
    return dict.hasOwnProperty;
};
var $79efcffe70231542$export$6917a1a7c5a9c9cc = function(dict) {
    return dict.errorAt;
};


// Generated by purs version 0.15.15
function $03b6b966974423fe$export$86b08f6436aa565c(m) {
    return function() {
        var r = {};
        for(var k in m)if (hasOwnProperty.call(m, k)) r[k] = m[k];
        return r;
    };
}
const $03b6b966974423fe$export$6e22c362a0406a2c = {};
function $03b6b966974423fe$export$c764c4f4747e1972(f) {
    return f();
}
function $03b6b966974423fe$export$7c3aa937ffdd4482(m0, f) {
    var m = {};
    for(var k in m0)if (hasOwnProperty.call(m0, k)) m[k] = f(m0[k]);
    return m;
}
function $03b6b966974423fe$export$b583322487d15176(m0, f) {
    var m = {};
    for(var k in m0)if (hasOwnProperty.call(m0, k)) m[k] = f(k)(m0[k]);
    return m;
}
function $03b6b966974423fe$export$882f367473bfeff9(bind) {
    return function(f) {
        return function(mz) {
            return function(m) {
                var acc = mz;
                function g(k) {
                    return function(z) {
                        return f(z)(k)(m[k]);
                    };
                }
                for(var k in m)if (hasOwnProperty.call(m, k)) acc = bind(acc)(g(k));
                return acc;
            };
        };
    };
}
function $03b6b966974423fe$export$b807e7b34437e8a6(m, z, f, fromMaybe) {
    var acc = z;
    for(var k in m)if (hasOwnProperty.call(m, k)) {
        var maybeR = f(acc)(k)(m[k]);
        var r = fromMaybe(null)(maybeR);
        if (r === null) return acc;
        else acc = r;
    }
    return acc;
}
function $03b6b966974423fe$export$84bf76cd7afc7469(f) {
    return function(m) {
        for(var k in m){
            if (hasOwnProperty.call(m, k) && !f(k)(m[k])) return false;
        }
        return true;
    };
}
function $03b6b966974423fe$export$346677f925de839c(m) {
    var s = 0;
    for(var k in m)if (hasOwnProperty.call(m, k)) ++s;
    return s;
}
function $03b6b966974423fe$export$75b750e7d0325364(no, yes, k, m) {
    return k in m ? yes(m[k]) : no;
}
function $03b6b966974423fe$export$d947399a194fcef2(no, yes, k, m) {
    return function() {
        return k in m ? yes(m[k]) : no;
    };
}
function $03b6b966974423fe$export$4b1360bff9337362(f) {
    return function(m) {
        var r = [];
        for(var k in m)if (hasOwnProperty.call(m, k)) r.push(f(k)(m[k]));
        return r;
    };
}
const $03b6b966974423fe$export$ed97f33186d4b816 = Object.keys || $03b6b966974423fe$export$4b1360bff9337362(function(k) {
    return function() {
        return k;
    };
});























// Generated by purs version 0.15.15
const $0061661dcaa2328e$export$b8cb59497041ffe4 = function() {
    return {};
};
function $0061661dcaa2328e$export$6dc5f95d8548a16a(just) {
    return function(nothing) {
        return function(k) {
            return function(m) {
                return function() {
                    return ({}).hasOwnProperty.call(m, k) ? just(m[k]) : nothing;
                };
            };
        };
    };
}
function $0061661dcaa2328e$export$dc13bdd74c909d26(k) {
    return function(v) {
        return function(m) {
            return function() {
                m[k] = v;
                return m;
            };
        };
    };
}
const $0061661dcaa2328e$export$1822828d790e23ee = function(k) {
    return function(m) {
        return function() {
            delete m[k];
            return m;
        };
    };
};



var $47b38aa8c72308f2$export$4d3fb11e950abb9e = /* #__PURE__ */ function() {
    return $0061661dcaa2328e$export$6dc5f95d8548a16a($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();



var $c045ea5df33bba60$var$sortWith = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c045ea5df33bba60$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($08944f7287e2704c$export$14049c9ff5b55fb3);
var $c045ea5df33bba60$var$showTuple = /* #__PURE__ */ $71f2e2e9476163f8$export$c29279d1dfdefb95($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $c045ea5df33bba60$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($08944f7287e2704c$export$603d84e49041d7b2);
var $c045ea5df33bba60$var$forWithIndex_ = /* #__PURE__ */ $519ef1967f17d101$export$f441c83f81b7710f($08944f7287e2704c$export$603d84e49041d7b2);
var $c045ea5df33bba60$var$for_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$9747ee7caa0b40b1($08944f7287e2704c$export$603d84e49041d7b2);
var $c045ea5df33bba60$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $c045ea5df33bba60$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $c045ea5df33bba60$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $c045ea5df33bba60$var$ordTuple = /* #__PURE__ */ $71f2e2e9476163f8$export$8f11eb03746a66e2($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c045ea5df33bba60$var$mapFlipped = /* #__PURE__ */ $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $c045ea5df33bba60$export$68c286be0e7e55b7 = /* #__PURE__ */ $03b6b966974423fe$export$4b1360bff9337362(function(v) {
    return function(v1) {
        return v1;
    };
});
var $c045ea5df33bba60$export$823be24f8766da23 = function(dictUnfoldable) {
    var $89 = $396c4c3d9e7fae3c$export$823be24f8766da23(dictUnfoldable);
    var $90 = $03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create);
    return function($91) {
        return $89($90($91));
    };
};
var $c045ea5df33bba60$export$930399be55d0753b = function(dictUnfoldable) {
    var $92 = $396c4c3d9e7fae3c$export$823be24f8766da23(dictUnfoldable);
    var $93 = $c045ea5df33bba60$var$sortWith($71f2e2e9476163f8$export$9e770fa6ce19a9d6);
    var $94 = $03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create);
    return function($95) {
        return $92($93($94($95)));
    };
};
var $c045ea5df33bba60$var$toAscArray = /* #__PURE__ */ $c045ea5df33bba60$export$930399be55d0753b($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $c045ea5df33bba60$var$toArray = /* #__PURE__ */ function() {
    return $03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $c045ea5df33bba60$export$170df9728335f27d = $03b6b966974423fe$export$86b08f6436aa565c;
var $c045ea5df33bba60$export$439306a4dcaafbb9 = function(k) {
    return function(v) {
        return $03b6b966974423fe$export$c764c4f4747e1972($c045ea5df33bba60$var$bindFlipped($0061661dcaa2328e$export$dc13bdd74c909d26(k)(v))($0061661dcaa2328e$export$b8cb59497041ffe4));
    };
};
var $c045ea5df33bba60$export$4cfa48b10b7cd72d = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225($c045ea5df33bba60$var$showTuple(dictShow)));
    return {
        show: function(m) {
            return "(fromFoldable " + (show($c045ea5df33bba60$var$toArray(m)) + ")");
        }
    };
};
var $c045ea5df33bba60$var$mutate = function(f) {
    return function(m) {
        return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
            var s = $c045ea5df33bba60$export$170df9728335f27d(m)();
            f(s)();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$6a0d13241802fe80 = /* #__PURE__ */ $8f2697950ee155e1$export$c4d34fab9eba1901($03b6b966974423fe$export$75b750e7d0325364)(false)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $c045ea5df33bba60$export$1292458786b96e98 = function(f) {
    return function(m) {
        return $03b6b966974423fe$export$b583322487d15176(m, f);
    };
};
var $c045ea5df33bba60$export$dfc7155ac0343b8 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($03b6b966974423fe$export$75b750e7d0325364)($06733ae99ed4f534$export$bebe9059409a0d04.value)($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $c045ea5df33bba60$export$35d0420a84c5d3ae = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(m1) {
        return function(m2) {
            var f = function(k) {
                return function(v) {
                    return $03b6b966974423fe$export$75b750e7d0325364(false, eq(v), k, m2);
                };
            };
            return $03b6b966974423fe$export$84bf76cd7afc7469(f)(m1);
        };
    };
};
var $c045ea5df33bba60$export$dd1bc94b04021eeb = /* #__PURE__ */ $03b6b966974423fe$export$84bf76cd7afc7469(function(v) {
    return function(v1) {
        return false;
    };
});
var $c045ea5df33bba60$export$21a5ca8aa77d35ff = function(k) {
    return function(v) {
        return $c045ea5df33bba60$var$mutate($0061661dcaa2328e$export$dc13bdd74c909d26(k)(v));
    };
};
var $c045ea5df33bba60$export$b7bb4265e2e489e0 = {
    map: function(f) {
        return function(m) {
            return $03b6b966974423fe$export$7c3aa937ffdd4482(m, f);
        };
    }
};
var $c045ea5df33bba60$export$9c938d99ebec5017 = {
    mapWithIndex: $c045ea5df33bba60$export$1292458786b96e98,
    Functor0: function() {
        return $c045ea5df33bba60$export$b7bb4265e2e489e0;
    }
};
var $c045ea5df33bba60$export$a47a4d0fc4d6b25 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};
var $c045ea5df33bba60$export$78cfe3464e7eb77b = function(dictFoldableWithIndex) {
    var forWithIndex_1 = $c045ea5df33bba60$var$forWithIndex_(dictFoldableWithIndex);
    return function(l) {
        return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
            var s = $0061661dcaa2328e$export$b8cb59497041ffe4();
            forWithIndex_1(l)(function(k) {
                return function(v) {
                    return $0061661dcaa2328e$export$dc13bdd74c909d26(k)(v)(s);
                };
            })();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$690be49d504fc7f = function(dictFoldable) {
    var for_1 = $c045ea5df33bba60$var$for_(dictFoldable);
    return function(f) {
        return function(l) {
            return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
                var s = $0061661dcaa2328e$export$b8cb59497041ffe4();
                for_1(l)(function(v) {
                    return function __do() {
                        var v$prime = $03b6b966974423fe$export$d947399a194fcef2(v.value1, f(v.value1), v.value0, s)();
                        return $0061661dcaa2328e$export$dc13bdd74c909d26(v.value0)(v$prime)(s)();
                    };
                })();
                return s;
            });
        };
    };
};
var $c045ea5df33bba60$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var fromFoldable1 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072(dictFoldable);
    return function(l) {
        return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
            var s = $0061661dcaa2328e$export$b8cb59497041ffe4();
            $f11e5cd39add8df2$export$8802485f9deae94f(fromFoldable1(l))(function(v) {
                return $c045ea5df33bba60$var$$$void($0061661dcaa2328e$export$dc13bdd74c909d26(v.value0)(v.value1)(s));
            })();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$a153ee4522d3545b = $03b6b966974423fe$export$86b08f6436aa565c;
var $c045ea5df33bba60$export$a769d86e5b325bcf = function(f) {
    return function(z) {
        return function(m) {
            return $03b6b966974423fe$export$b807e7b34437e8a6(m, z, f, $06733ae99ed4f534$export$43db023a260c5e9f);
        };
    };
};
var $c045ea5df33bba60$export$7a067f9280ad8af0 = function(dictMonad) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(f) {
        return function(z) {
            return $03b6b966974423fe$export$882f367473bfeff9(bind1)(f)(pure1(z));
        };
    };
};
var $c045ea5df33bba60$var$foldM1 = /* #__PURE__ */ $c045ea5df33bba60$export$7a067f9280ad8af0($08944f7287e2704c$export$962073314682c2c);
var $c045ea5df33bba60$export$971dd5b0dfd021b6 = function(m) {
    return $c045ea5df33bba60$var$mutate(function(s) {
        return $c045ea5df33bba60$var$foldM1(function(s$prime) {
            return function(k) {
                return function(v) {
                    return $0061661dcaa2328e$export$dc13bdd74c909d26(k)(v)(s$prime);
                };
            };
        })(s)(m);
    });
};
var $c045ea5df33bba60$export$30b2db2f7030f6cf = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable)($c045ea5df33bba60$export$971dd5b0dfd021b6)($03b6b966974423fe$export$6e22c362a0406a2c);
};
var $c045ea5df33bba60$export$ed1b4f34a0e8b0cc = function(f) {
    return function(m1) {
        return function(m2) {
            return $c045ea5df33bba60$var$mutate(function(s1) {
                return $c045ea5df33bba60$var$foldM1(function(s2) {
                    return function(k) {
                        return function(v1) {
                            return $0061661dcaa2328e$export$dc13bdd74c909d26(k)($03b6b966974423fe$export$75b750e7d0325364(v1, function(v2) {
                                return f(v1)(v2);
                            }, k, m2))(s2);
                        };
                    };
                })(s1)(m1);
            })(m2);
        };
    };
};
var $c045ea5df33bba60$export$7d0c6e9c5931d4de = function(dictSemigroup) {
    return {
        append: $c045ea5df33bba60$export$ed1b4f34a0e8b0cc($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $c045ea5df33bba60$export$cd8dd1e1b4d46833 = function(dictSemigroup) {
    var semigroupObject1 = $c045ea5df33bba60$export$7d0c6e9c5931d4de(dictSemigroup);
    return {
        mempty: $03b6b966974423fe$export$6e22c362a0406a2c,
        Semigroup0: function() {
            return semigroupObject1;
        }
    };
};
var $c045ea5df33bba60$export$93e2b83da34ff82a = /* #__PURE__ */ $03b6b966974423fe$export$882f367473bfeff9($f57f4b701aa7b66e$export$5f9c390da86b6e49);
var $c045ea5df33bba60$export$b66cdc0497d8a99a = function(dictMonoid) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a(function(acc) {
            return function(k) {
                return function(v) {
                    return append1(acc)(f(k)(v));
                };
            };
        })(mempty);
    };
};
var $c045ea5df33bba60$export$fb5657e12344d3bf = {
    foldl: function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a(function(z) {
            return function(v) {
                return f(z);
            };
        });
    },
    foldr: function(f) {
        return function(z) {
            return function(m) {
                return $c045ea5df33bba60$var$foldr(f)(z)($c045ea5df33bba60$export$68c286be0e7e55b7(m));
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap1 = $c045ea5df33bba60$export$b66cdc0497d8a99a(dictMonoid);
        return function(f) {
            return foldMap1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
        };
    }
};
var $c045ea5df33bba60$export$341deb6f42c48978 = {
    foldlWithIndex: function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a($f57f4b701aa7b66e$export$8a83211c878a3f1f(f));
    },
    foldrWithIndex: function(f) {
        return function(z) {
            return function(m) {
                return $c045ea5df33bba60$var$foldr($71f2e2e9476163f8$export$7864d59d01b6d6bf(f))(z)($03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create)(m));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $c045ea5df33bba60$export$b66cdc0497d8a99a(dictMonoid);
    },
    Foldable0: function() {
        return $c045ea5df33bba60$export$fb5657e12344d3bf;
    }
};
var $c045ea5df33bba60$export$cffdb9059fc42749 = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            return function(ms) {
                return $c045ea5df33bba60$export$93e2b83da34ff82a(function(acc) {
                    return function(k) {
                        return function(v) {
                            return apply(map($f57f4b701aa7b66e$export$8a83211c878a3f1f($c045ea5df33bba60$export$21a5ca8aa77d35ff(k)))(acc))(f(k)(v));
                        };
                    };
                })(pure1($03b6b966974423fe$export$6e22c362a0406a2c))(ms);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $c045ea5df33bba60$export$9c938d99ebec5017;
    },
    FoldableWithIndex1: function() {
        return $c045ea5df33bba60$export$341deb6f42c48978;
    },
    Traversable2: function() {
        return $c045ea5df33bba60$export$aeab5e284d2f12ed;
    }
};
var $c045ea5df33bba60$export$aeab5e284d2f12ed = {
    traverse: function(dictApplicative) {
        var $96 = $2c7a64ff78781336$export$955fdc0d24efa249($c045ea5df33bba60$export$cffdb9059fc42749)(dictApplicative);
        return function($97) {
            return $96($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($97));
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$df3f009e3d155b20($c045ea5df33bba60$export$aeab5e284d2f12ed)(dictApplicative)($c045ea5df33bba60$var$identity);
    },
    Functor0: function() {
        return $c045ea5df33bba60$export$b7bb4265e2e489e0;
    },
    Foldable1: function() {
        return $c045ea5df33bba60$export$fb5657e12344d3bf;
    }
};
var $c045ea5df33bba60$export$d7a60370122a9ab0 = function(predicate) {
    return function(m) {
        var go = function() {
            var step = function(acc) {
                return function(k) {
                    return function(v) {
                        var $86 = predicate(k)(v);
                        if ($86) return $0061661dcaa2328e$export$dc13bdd74c909d26(k)(v)(acc);
                        return $c045ea5df33bba60$var$pure(acc);
                    };
                };
            };
            return function __do() {
                var m$prime = $0061661dcaa2328e$export$b8cb59497041ffe4();
                return $c045ea5df33bba60$var$foldM1(step)(m$prime)(m)();
            };
        }();
        return $03b6b966974423fe$export$c764c4f4747e1972(go);
    };
};
var $c045ea5df33bba60$export$151f9a87a7fd5652 = function(predicate) {
    return $c045ea5df33bba60$export$d7a60370122a9ab0(function($98) {
        return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(predicate($98));
    });
};
var $c045ea5df33bba60$export$3dea766d36a8935f = function(predicate) {
    return $c045ea5df33bba60$export$d7a60370122a9ab0($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(predicate));
};
var $c045ea5df33bba60$export$fddc1e6ca29dc4b4 = function(dictEq) {
    var isSubmap1 = $c045ea5df33bba60$export$35d0420a84c5d3ae(dictEq);
    return {
        eq: function(m1) {
            return function(m2) {
                return isSubmap1(m1)(m2) && isSubmap1(m2)(m1);
            };
        }
    };
};
var $c045ea5df33bba60$export$6393680ec5f1a42e = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$6ace7ea8ac01a75e($c045ea5df33bba60$var$ordTuple(dictOrd)));
    var eqObject1 = $c045ea5df33bba60$export$fddc1e6ca29dc4b4(dictOrd.Eq0());
    return {
        compare: function(m1) {
            return function(m2) {
                return compare($c045ea5df33bba60$var$toAscArray(m1))($c045ea5df33bba60$var$toAscArray(m2));
            };
        },
        Eq0: function() {
            return eqObject1;
        }
    };
};
var $c045ea5df33bba60$export$11e732c5af6e2d9f = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($c045ea5df33bba60$export$fddc1e6ca29dc4b4(dictEq));
    }
};
var $c045ea5df33bba60$export$1822828d790e23ee = function(k) {
    return $c045ea5df33bba60$var$mutate($0061661dcaa2328e$export$1822828d790e23ee(k));
};
var $c045ea5df33bba60$export$3e41007ebfff0e64 = function(k) {
    return function(m) {
        return $c045ea5df33bba60$var$mapFlipped($c045ea5df33bba60$export$dfc7155ac0343b8(k)(m))(function(a) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, $c045ea5df33bba60$export$1822828d790e23ee(k)(m));
        });
    };
};
var $c045ea5df33bba60$export$22a7378e1d3307a4 = function(f) {
    return function(k) {
        return function(m) {
            var v = f($c045ea5df33bba60$export$dfc7155ac0343b8(k)(m));
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $c045ea5df33bba60$export$1822828d790e23ee(k)(m);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $c045ea5df33bba60$export$21a5ca8aa77d35ff(k)(v.value0)(m);
            throw new Error("Failed pattern match at Foreign.Object (line 210, column 15 - line 212, column 25): " + [
                v.constructor.name
            ]);
        };
    };
};
var $c045ea5df33bba60$export$722fbec263ad908a = function(f) {
    return function(k) {
        return function(m) {
            return $c045ea5df33bba60$export$22a7378e1d3307a4($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(f))(k)(m);
        };
    };
};



// Generated by purs version 0.15.15



// Generated by purs version 0.15.15
function $e624b6ee0b54010c$export$92a1542aa06c886(r1, r2) {
    var copy = {};
    for(var k1 in r2)if (({}).hasOwnProperty.call(r2, k1)) copy[k1] = r2[k1];
    for(var k2 in r1)if (({}).hasOwnProperty.call(r1, k2)) copy[k2] = r1[k2];
    return copy;
}



var $7839e24eedf166a9$export$b2a4c822ec4216bb = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($e624b6ee0b54010c$export$92a1542aa06c886);




var $15e8567e7c31ba30$export$971dd5b0dfd021b6 = function() {
    return function(l) {
        return function(r) {
            return $e624b6ee0b54010c$export$92a1542aa06c886(l, r);
        };
    };
};
var $15e8567e7c31ba30$export$adaa4cf7ef1b65be = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function() {
            return function(l) {
                return function(b) {
                    return function(r) {
                        return $d2fadbdf02925823$export$444262986932b766(reflectSymbol(l))(b)(r);
                    };
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$94f4066a75b10404 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};
var $15e8567e7c31ba30$export$4950aa0f605343fb = function() {
    return function() {
        return function(l) {
            return function(r) {
                return $e624b6ee0b54010c$export$92a1542aa06c886(l, r);
            };
        };
    };
};
var $15e8567e7c31ba30$export$21a5ca8aa77d35ff = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function() {
            return function(l) {
                return function(a) {
                    return function(r) {
                        return $d2fadbdf02925823$export$444262986932b766(reflectSymbol(l))(a)(r);
                    };
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$3988ae62b71be9a3 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(l) {
            return function(r) {
                return $d2fadbdf02925823$export$1d94535d2cda4eda(reflectSymbol(l))(r);
            };
        };
    };
};
var $15e8567e7c31ba30$export$3ff57735a52b8713 = function(dictIsSymbol) {
    var set1 = $15e8567e7c31ba30$export$adaa4cf7ef1b65be(dictIsSymbol)()();
    var get1 = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    return function() {
        return function() {
            return function(l) {
                return function(f) {
                    return function(r) {
                        return set1(l)(f(get1(l)(r)))(r);
                    };
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$db0231a0f4325b7b = {
    equalFields: function(v) {
        return function(v1) {
            return function(v2) {
                return true;
            };
        };
    }
};
var $15e8567e7c31ba30$export$91610c87b78a6ed5 = function(dict) {
    return dict.equalFields;
};
var $15e8567e7c31ba30$export$772630fbd62849b4 = function(dictIsSymbol) {
    var get1 = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    return function(dictEq) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function() {
            return function(dictEqualFields) {
                var equalFields1 = $15e8567e7c31ba30$export$91610c87b78a6ed5(dictEqualFields);
                return {
                    equalFields: function(v) {
                        return function(a) {
                            return function(b) {
                                var get$prime = get1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var equalRest = equalFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                return eq(get$prime(a))(get$prime(b)) && equalRest(a)(b);
                            };
                        };
                    }
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$411ce8e5a71e3069 = function() {
    return function(dictEqualFields) {
        var equalFields1 = $15e8567e7c31ba30$export$91610c87b78a6ed5(dictEqualFields);
        return function(a) {
            return function(b) {
                return equalFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(a)(b);
            };
        };
    };
};
var $15e8567e7c31ba30$export$812eab5d580a29df = function() {
    return function() {
        return function(l) {
            return function(r) {
                return $e624b6ee0b54010c$export$92a1542aa06c886(l, r);
            };
        };
    };
};
var $15e8567e7c31ba30$export$1822828d790e23ee = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function() {
            return function(l) {
                return function(r) {
                    return $d2fadbdf02925823$export$14b6a75b3eb38458(reflectSymbol(l))(r);
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$7ac989ec0c9c279 = function(dictIsSymbol) {
    var get1 = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    var delete1 = $15e8567e7c31ba30$export$1822828d790e23ee(dictIsSymbol)()();
    return function(dictIsSymbol1) {
        var insert1 = $15e8567e7c31ba30$export$21a5ca8aa77d35ff(dictIsSymbol1)()();
        return function() {
            return function() {
                return function() {
                    return function() {
                        return function(prev) {
                            return function(next) {
                                return function(record) {
                                    return insert1(next)(get1(prev)(record))(delete1(prev)(record));
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};


// Generated by purs version 0.15.15
function $bf939f6be0e180d1$export$e79ed0bba11ce003(rec) {
    var copy = {};
    for(var key in rec)if (({}).hasOwnProperty.call(rec, key)) copy[key] = rec[key];
    return copy;
}
function $bf939f6be0e180d1$export$71caa5b83defe711(l) {
    return function(a) {
        return function(rec) {
            rec[l] = a;
            return rec;
        };
    };
}
function $bf939f6be0e180d1$export$bf1c9b65d0cc88fc(l) {
    return function(f) {
        return function(rec) {
            rec[l] = f(rec[l]);
            return rec;
        };
    };
}
function $bf939f6be0e180d1$export$14b6a75b3eb38458(l) {
    return function(rec) {
        delete rec[l];
        return rec;
    };
}
function $bf939f6be0e180d1$export$fcfd746294de5f21(l1) {
    return function(l2) {
        return function(rec) {
            rec[l2] = rec[l1];
            delete rec[l1];
            return rec;
        };
    };
}








var $c01d1bd93cd469bc$var$Builder = function(x) {
    return x;
};
var $c01d1bd93cd469bc$export$971dd5b0dfd021b6 = function() {
    return function(r1) {
        return function(r2) {
            return $e624b6ee0b54010c$export$92a1542aa06c886(r1, r2);
        };
    };
};
var $c01d1bd93cd469bc$export$76e18363199b658c = $5807467a73465f3c$export$3af17640bddf7212;
var $c01d1bd93cd469bc$export$7ac989ec0c9c279 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictIsSymbol1) {
        var reflectSymbol1 = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol1);
        return function() {
            return function() {
                return function() {
                    return function() {
                        return function(l1) {
                            return function(l2) {
                                return function(r1) {
                                    return $bf939f6be0e180d1$export$fcfd746294de5f21(reflectSymbol(l1))(reflectSymbol1(l2))(r1);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var $c01d1bd93cd469bc$export$94f4066a75b10404 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};
var $c01d1bd93cd469bc$export$3ff57735a52b8713 = function() {
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            return function(l) {
                return function(f) {
                    return function(r1) {
                        return $bf939f6be0e180d1$export$bf1c9b65d0cc88fc(reflectSymbol(l))(f)(r1);
                    };
                };
            };
        };
    };
};
var $c01d1bd93cd469bc$export$4950aa0f605343fb = function() {
    return function() {
        return function(r1) {
            return function(r2) {
                return $e624b6ee0b54010c$export$92a1542aa06c886(r1, r2);
            };
        };
    };
};
var $c01d1bd93cd469bc$export$21a5ca8aa77d35ff = function() {
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            return function(l) {
                return function(a) {
                    return function(r1) {
                        return $bf939f6be0e180d1$export$71caa5b83defe711(reflectSymbol(l))(a)(r1);
                    };
                };
            };
        };
    };
};
var $c01d1bd93cd469bc$export$812eab5d580a29df = function() {
    return function() {
        return function(r1) {
            return function(r2) {
                return $e624b6ee0b54010c$export$92a1542aa06c886(r1, r2);
            };
        };
    };
};
var $c01d1bd93cd469bc$export$1822828d790e23ee = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function() {
            return function(l) {
                return function(r2) {
                    return $bf939f6be0e180d1$export$14b6a75b3eb38458(reflectSymbol(l))(r2);
                };
            };
        };
    };
};
var $c01d1bd93cd469bc$export$df25652d1ce0a5fa = $5be483788e0e6f04$export$7037e3b2ba3bd7aa;
var $c01d1bd93cd469bc$export$3f8fe6489e95757d = function(v) {
    return function(r1) {
        return v($bf939f6be0e180d1$export$e79ed0bba11ce003(r1));
    };
};
var $c01d1bd93cd469bc$export$6b1fce8f3a7cd6e3 = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($c01d1bd93cd469bc$export$3f8fe6489e95757d)({});
var $c01d1bd93cd469bc$export$8a83211c878a3f1f = function(f) {
    return function(b) {
        return function(a) {
            return $c01d1bd93cd469bc$export$3f8fe6489e95757d(f(a))(b);
        };
    };
};



var $f505976c723c2a85$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $f505976c723c2a85$var$fail = /* #__PURE__ */ $c97d2d0f578f81ad$export$2b62a06a9fee979c($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $f505976c723c2a85$var$applicativeExceptT = /* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $f505976c723c2a85$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($f505976c723c2a85$var$applicativeExceptT);
var $f505976c723c2a85$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88(/* #__PURE__ */ $d2284b2d3e1b6f87$export$d684c62fe584fcfa($50c50d1f444e5fa4$export$dc85e8383eafbd81));
var $f505976c723c2a85$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$3c979cc7d75b024c);
var $f505976c723c2a85$var$bindExceptT = /* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $f505976c723c2a85$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($f505976c723c2a85$var$bindExceptT);
var $f505976c723c2a85$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $f505976c723c2a85$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$80f6258c17467741)($f505976c723c2a85$var$applicativeExceptT);
var $f505976c723c2a85$var$readNull = /* #__PURE__ */ $c97d2d0f578f81ad$export$62e87727fba30d8d($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $f505976c723c2a85$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($f505976c723c2a85$var$bindExceptT);
var $f505976c723c2a85$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($c045ea5df33bba60$export$aeab5e284d2f12ed)($f505976c723c2a85$var$applicativeExceptT);
var $f505976c723c2a85$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($c01d1bd93cd469bc$export$df25652d1ce0a5fa);
var $f505976c723c2a85$var$traverseWithIndex = /* #__PURE__ */ $2c7a64ff78781336$export$955fdc0d24efa249($2c7a64ff78781336$export$96888504550934b5)($f505976c723c2a85$var$applicativeExceptT);
var $f505976c723c2a85$var$readArray1 = /* #__PURE__ */ $c97d2d0f578f81ad$export$d3f4ca0e55363719($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $f505976c723c2a85$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($f505976c723c2a85$var$bindExceptT);
var $f505976c723c2a85$var$except = /* #__PURE__ */ $d2284b2d3e1b6f87$export$67aba9fb222c5e1d($50c50d1f444e5fa4$export$fd3b2458e55fc503);
var $f505976c723c2a85$var$on = /* #__PURE__ */ $a5ccce070b256bc7$export$af631764ddc44097();
var $f505976c723c2a85$var$compose1 = /* #__PURE__ */ $5807467a73465f3c$export$f672e0b6f7222cd7($c01d1bd93cd469bc$export$76e18363199b658c);
var $f505976c723c2a85$var$insert = /* #__PURE__ */ $c01d1bd93cd469bc$export$21a5ca8aa77d35ff()();
var $f505976c723c2a85$var$readProp = /* #__PURE__ */ $79efcffe70231542$export$d133c026d013828b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $f505976c723c2a85$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781($78c799cba34fcb8d$export$a8cfc3dfdfca72cf)($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $f505976c723c2a85$var$inj = /* #__PURE__ */ $a5ccce070b256bc7$export$38d8e7a5e0c746a7();
var $f505976c723c2a85$export$e669bda29b01ed6c = function(dict) {
    return dict.writeVariantImpl;
};
var $f505976c723c2a85$export$ceb920a4c6219c61 = function(dict) {
    return dict.writeImplFields;
};
var $f505976c723c2a85$export$be94bcd43c4d1340 = function(dict) {
    return dict.writeImpl;
};
var $f505976c723c2a85$export$832cdf204000b2a9 = function(dictWriteForeign) {
    var $191 = $f505976c723c2a85$export$be94bcd43c4d1340(dictWriteForeign);
    return function($192) {
        return $168314f2e0d9b3ad$export$26ae6b8f971b1722($191($192));
    };
};
var $f505976c723c2a85$export$ae5c48b444bb189 = function() {
    return function(dictWriteForeignVariant) {
        var writeVariantImpl1 = $f505976c723c2a85$export$e669bda29b01ed6c(dictWriteForeignVariant);
        return {
            writeImpl: function(variant) {
                return writeVariantImpl1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(variant);
            }
        };
    };
};
var $f505976c723c2a85$export$deb1d11818e4b91c = {
    writeImpl: $c97d2d0f578f81ad$export$9d82982d31d9d171
};
var $f505976c723c2a85$export$465dd2b4c6981c1c = function(dictWriteForeign) {
    return {
        writeImpl: function() {
            var $193 = $c045ea5df33bba60$export$1292458786b96e98($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($f505976c723c2a85$export$be94bcd43c4d1340(dictWriteForeign)));
            return function($194) {
                return $c97d2d0f578f81ad$export$9d82982d31d9d171($193($194));
            };
        }()
    };
};
var $f505976c723c2a85$export$cef9acbddfbaa03 = {
    writeImpl: $c97d2d0f578f81ad$export$9d82982d31d9d171
};
var $f505976c723c2a85$export$3ff48be2ba596912 = function(dictWriteForeign) {
    return {
        writeImpl: function() {
            var $195 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($c97d2d0f578f81ad$export$9d82982d31d9d171($0a5aaf95f168428e$export$b187f57ee1822bc5($06733ae99ed4f534$export$bebe9059409a0d04.value)))($f505976c723c2a85$export$be94bcd43c4d1340(dictWriteForeign));
            return function($196) {
                return $195($0a5aaf95f168428e$export$1ba013b88f4f21f3($196));
            };
        }()
    };
};
var $f505976c723c2a85$export$b21473867608729b = {
    writeImpl: $c97d2d0f578f81ad$export$9d82982d31d9d171
};
var $f505976c723c2a85$export$a65ac144335c4f21 = {
    writeImpl: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa)
};
var $f505976c723c2a85$export$8ed8106896900191 = {
    writeImpl: $c97d2d0f578f81ad$export$9d82982d31d9d171
};
var $f505976c723c2a85$export$e44a0cd601839808 = {
    writeImpl: $c97d2d0f578f81ad$export$9d82982d31d9d171
};
var $f505976c723c2a85$export$91b2aededa8b9add = function(dictWriteForeign) {
    var writeImpl1 = $f505976c723c2a85$export$be94bcd43c4d1340(dictWriteForeign);
    return {
        writeImpl: function(xs) {
            return $c97d2d0f578f81ad$export$9d82982d31d9d171($f505976c723c2a85$var$map(writeImpl1)(xs));
        }
    };
};
var $f505976c723c2a85$export$5ea4799670c76908 = function(dictWriteForeign) {
    var writeImpl1 = $f505976c723c2a85$export$be94bcd43c4d1340($f505976c723c2a85$export$91b2aededa8b9add(dictWriteForeign));
    return {
        writeImpl: function(a) {
            return writeImpl1($e39dfcf102cdca3c$export$45b10814cc054894(a));
        }
    };
};
var $f505976c723c2a85$export$68d8715fc104d294 = function(dictWriteForeign) {
    return $f505976c723c2a85$export$be94bcd43c4d1340(dictWriteForeign);
};
var $f505976c723c2a85$export$8fb373d660548968 = $168314f2e0d9b3ad$export$26ae6b8f971b1722;
var $f505976c723c2a85$export$1db45310990710a5 = $168314f2e0d9b3ad$export$60e4c9fe67803d40;
var $f505976c723c2a85$export$9a20f6e83056883f = function(dictWriteForeign) {
    return {
        writeImpl: $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($f505976c723c2a85$export$1db45310990710a5)($f505976c723c2a85$export$be94bcd43c4d1340(dictWriteForeign))
    };
};
var $f505976c723c2a85$export$ddf0a8e9a8f64299 = function() {
    return function(dictWriteForeignFields) {
        var writeImplFields1 = $f505976c723c2a85$export$ceb920a4c6219c61(dictWriteForeignFields);
        return {
            writeImpl: function(rec) {
                var steps = writeImplFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec);
                return $c97d2d0f578f81ad$export$9d82982d31d9d171($c01d1bd93cd469bc$export$3f8fe6489e95757d(steps)({}));
            }
        };
    };
};
var $f505976c723c2a85$export$72b2f5ffdc95828a = {
    readVariantImpl: function(v) {
        return function(v1) {
            return $f505976c723c2a85$var$fail(new $c97d2d0f578f81ad$export$f6a37cc43a8b8898("Unable to match any variant member."));
        };
    }
};
var $f505976c723c2a85$export$8b5f7e2f61d5dd7b = function(dict) {
    return dict.readVariantImpl;
};
var $f505976c723c2a85$export$dda73877cb166cd3 = {
    readImpl: /* #__PURE__ */ $c97d2d0f578f81ad$export$dda73877cb166cd3($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0)
};
var $f505976c723c2a85$export$347fd215c36b10be = {
    readImpl: /* #__PURE__ */ $c97d2d0f578f81ad$export$347fd215c36b10be($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0)
};
var $f505976c723c2a85$export$ac3747cb00139c63 = {
    readImpl: /* #__PURE__ */ $c97d2d0f578f81ad$export$ac3747cb00139c63($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0)
};
var $f505976c723c2a85$export$f6103847fe734e8 = function(dict) {
    return dict.readImpl;
};
var $f505976c723c2a85$export$9e57c2acb5b1acde = function(dictReadForeign) {
    return {
        readImpl: function() {
            var readNullOrUndefined = function(v) {
                return function(v1) {
                    if ($c2c5bfcfd98ddabb$export$630801d484da15df(v1) || $c2c5bfcfd98ddabb$export$fce6876652108ab(v1)) return $f505976c723c2a85$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                    return $f505976c723c2a85$var$map1($06733ae99ed4f534$export$8a67b48435b5d073.create)(v(v1));
                };
            };
            return readNullOrUndefined($f505976c723c2a85$export$f6103847fe734e8(dictReadForeign));
        }()
    };
};
var $f505976c723c2a85$export$a57e7a55ff593f1b = function(dictReadForeign) {
    var readImpl2 = $f505976c723c2a85$export$f6103847fe734e8(dictReadForeign);
    return {
        readImpl: function(o) {
            var reformat = function(error) {
                if (error instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return new $c97d2d0f578f81ad$export$168e2d3b16829a("Nullable " + error.value0, error.value1);
                return error;
            };
            return $f9f243b94d1fc188$export$64f3cd24d850d401($f505976c723c2a85$var$map2(reformat))($f505976c723c2a85$var$bindFlipped($f505976c723c2a85$var$map3($f505976c723c2a85$var$map1($0a5aaf95f168428e$export$b187f57ee1822bc5))($f505976c723c2a85$var$traverse(readImpl2)))($f505976c723c2a85$var$readNull(o)));
        }
    };
};
var $f505976c723c2a85$export$a06d200e21d81178 = function(dictReadForeign) {
    return {
        readImpl: function() {
            var readObject$prime = function(value) {
                if ($c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value) === "Object") return $f505976c723c2a85$var$pure($c97d2d0f578f81ad$export$19df04dfac508e15(value));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $f505976c723c2a85$var$fail(new $c97d2d0f578f81ad$export$168e2d3b16829a("Object", $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value)));
                throw new Error("Failed pattern match at Simple.JSON (line 197, column 7 - line 197, column 51): " + [
                    value.constructor.name
                ]);
            };
            return $f505976c723c2a85$var$composeKleisliFlipped(function() {
                var $197 = $c045ea5df33bba60$export$1292458786b96e98($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($f505976c723c2a85$export$f6103847fe734e8(dictReadForeign)));
                return function($198) {
                    return $f505976c723c2a85$var$sequence($197($198));
                };
            }())(readObject$prime);
        }()
    };
};
var $f505976c723c2a85$export$1f150d367ccc617b = function() {
    return function(dictReadForeignVariant) {
        var readVariantImpl1 = $f505976c723c2a85$export$8b5f7e2f61d5dd7b(dictReadForeignVariant);
        return {
            readImpl: function(o) {
                return readVariantImpl1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(o);
            }
        };
    };
};
var $f505976c723c2a85$export$977d401f5646009f = {
    readImpl: $f505976c723c2a85$var$pure
};
var $f505976c723c2a85$export$d9e5338498903fce = {
    getFields: function(v) {
        return function(v1) {
            return $f505976c723c2a85$var$pure($f505976c723c2a85$var$identity);
        };
    }
};
var $f505976c723c2a85$export$85b98eeba3f0a3b4 = {
    readImpl: /* #__PURE__ */ $c97d2d0f578f81ad$export$85b98eeba3f0a3b4($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0)
};
var $f505976c723c2a85$export$f9a84177eae95ed5 = {
    readImpl: /* #__PURE__ */ $c97d2d0f578f81ad$export$f9a84177eae95ed5($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0)
};
var $f505976c723c2a85$export$d3f4ca0e55363719 = function(dictReadForeign) {
    var readImpl2 = $f505976c723c2a85$export$f6103847fe734e8(dictReadForeign);
    return {
        readImpl: function() {
            var readAtIdx = function(i) {
                return function(f) {
                    return $f9f243b94d1fc188$export$64f3cd24d850d401($f505976c723c2a85$var$map2($c97d2d0f578f81ad$export$20d9a5af040a79f1.create(i)))(readImpl2(f));
                };
            };
            return $f505976c723c2a85$var$composeKleisliFlipped($f505976c723c2a85$var$traverseWithIndex(readAtIdx))($f505976c723c2a85$var$readArray1);
        }()
    };
};
var $f505976c723c2a85$export$ed82ea4173294de1 = function(dictReadForeign) {
    var readImpl2 = $f505976c723c2a85$export$f6103847fe734e8($f505976c723c2a85$export$d3f4ca0e55363719(dictReadForeign));
    return {
        readImpl: function(f) {
            return $f505976c723c2a85$var$bind(readImpl2(f))(function(v) {
                return $f505976c723c2a85$var$except($7d4cccdf062a2261$export$a92e4c44d367d0af($ba51d599f79a6310$export$439306a4dcaafbb9(new $c97d2d0f578f81ad$export$f6a37cc43a8b8898("Nonempty array expected, got empty array")))($e39dfcf102cdca3c$export$571d59b505e6bb4e(v)));
            });
        }
    };
};
var $f505976c723c2a85$export$6de8f65c4e6d57ba = function(dictReadForeign) {
    return $f505976c723c2a85$export$f6103847fe734e8(dictReadForeign);
};
var $f505976c723c2a85$export$aafa59e2e03f2942 = function(dictReadForeign) {
    var $199 = $f505976c723c2a85$export$f6103847fe734e8(dictReadForeign);
    return function($200) {
        return $f9f243b94d1fc188$export$a25b8a8a37f2d1cd($199($200));
    };
};
var $f505976c723c2a85$export$a2982366827a6b9c = function(dictReadForeign) {
    var $201 = $f505976c723c2a85$export$aafa59e2e03f2942(dictReadForeign);
    return function($202) {
        return $201($c97d2d0f578f81ad$export$9d82982d31d9d171($202));
    };
};
var $f505976c723c2a85$export$fe8726939961c446 = function(dictReadForeign) {
    var $203 = $f505976c723c2a85$export$aafa59e2e03f2942(dictReadForeign);
    return function($204) {
        return $7d4cccdf062a2261$export$3a6c138b8d0f3874($203($204));
    };
};
var $f505976c723c2a85$export$27924e57e9afff7f = /* #__PURE__ */ function() {
    var $205 = $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff)(function() {
        var $208 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($78c799cba34fcb8d$export$e5d0ed5dac805e10);
        return function($209) {
            return $208($c97d2d0f578f81ad$export$f6a37cc43a8b8898.create($ad2cf6904bca3ba1$export$a8ecead220dd38a6($209)));
        };
    }());
    var $206 = $28d793bcad7b6401$export$84baa7a1ea5377fd($168314f2e0d9b3ad$export$b26131a6779b8150);
    return function($207) {
        return $d2284b2d3e1b6f87$export$2e7afd25df37516b($50c50d1f444e5fa4$export$544bf02140fa9a77($205($c02f07bc0f38e9e9$export$c62839628b30a695($4e52402d7134c8bb$export$410a452afcd48948($206($207))))));
    };
}();
var $f505976c723c2a85$export$ce30717759bc230c = function(dictReadForeign) {
    var $210 = $f505976c723c2a85$var$composeKleisliFlipped($f505976c723c2a85$export$f6103847fe734e8(dictReadForeign))($f505976c723c2a85$export$27924e57e9afff7f);
    return function($211) {
        return $f9f243b94d1fc188$export$a25b8a8a37f2d1cd($210($211));
    };
};
var $f505976c723c2a85$export$8c8a6588a70901dc = function(dictReadForeign) {
    var $212 = $f505976c723c2a85$export$ce30717759bc230c(dictReadForeign);
    return function($213) {
        return $7d4cccdf062a2261$export$3a6c138b8d0f3874($212($213));
    };
};
var $f505976c723c2a85$export$2ba6ce7d66e48d79 = function(dictReadForeign) {
    return $f505976c723c2a85$var$composeKleisliFlipped($f505976c723c2a85$export$f6103847fe734e8(dictReadForeign))($f505976c723c2a85$export$27924e57e9afff7f);
};
var $f505976c723c2a85$export$161653aac5b7197d = {
    writeVariantImpl: function(v) {
        return function(v1) {
            return $8bcde8f642a64c7d$export$51b220bae4359b72("Variant was not able to be writen row WriteForeign.");
        };
    }
};
var $f505976c723c2a85$export$b71d71b744cb31b1 = {
    writeImplFields: function(v) {
        return function(v1) {
            return $f505976c723c2a85$var$identity;
        };
    }
};
var $f505976c723c2a85$export$d5523731e7fe4ded = function(dict) {
    return dict.getFields;
};
var $f505976c723c2a85$export$b400c64e22f7eb4c = function() {
    return function(dictReadForeignFields) {
        var getFields1 = $f505976c723c2a85$export$d5523731e7fe4ded(dictReadForeignFields);
        return {
            readImpl: function(o) {
                return $f505976c723c2a85$var$map1($f57f4b701aa7b66e$export$8a83211c878a3f1f($c01d1bd93cd469bc$export$3f8fe6489e95757d)({}))(getFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(o));
            }
        };
    };
};
var $f505976c723c2a85$export$255533bf9f3b41f0 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    var on1 = $f505976c723c2a85$var$on(dictIsSymbol);
    return function(dictWriteForeign) {
        var writeImpl1 = $f505976c723c2a85$export$be94bcd43c4d1340(dictWriteForeign);
        return function() {
            return function(dictWriteForeignVariant) {
                var writeVariantImpl1 = $f505976c723c2a85$export$e669bda29b01ed6c(dictWriteForeignVariant);
                return {
                    writeVariantImpl: function(v) {
                        return function(variant) {
                            var writeVariant = function(value) {
                                return $c97d2d0f578f81ad$export$9d82982d31d9d171({
                                    type: reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
                                    value: writeImpl1(value)
                                });
                            };
                            return on1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(writeVariant)(writeVariantImpl1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))(variant);
                        };
                    }
                };
            };
        };
    };
};
var $f505976c723c2a85$export$f491da61fcb4367e = function(dictIsSymbol) {
    var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    var insert1 = $f505976c723c2a85$var$insert(dictIsSymbol);
    return function(dictWriteForeign) {
        var writeImpl1 = $f505976c723c2a85$export$be94bcd43c4d1340(dictWriteForeign);
        return function(dictWriteForeignFields) {
            var writeImplFields1 = $f505976c723c2a85$export$ceb920a4c6219c61(dictWriteForeignFields);
            return function() {
                return function() {
                    return function() {
                        return {
                            writeImplFields: function(v) {
                                return function(rec) {
                                    var rest = writeImplFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec);
                                    var value = writeImpl1(get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec));
                                    var result = $f505976c723c2a85$var$compose1(insert1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(value))(rest);
                                    return result;
                                };
                            }
                        };
                    };
                };
            };
        };
    };
};
var $f505976c723c2a85$var$applyEither = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(append1(v.value0)(v1.value0));
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0(v1.value0));
            throw new Error("Failed pattern match at Simple.JSON (line 241, column 1 - line 241, column 90): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $f505976c723c2a85$var$exceptTApply = function(dictSemigroup) {
    var applyEither1 = $f505976c723c2a85$var$applyEither(dictSemigroup);
    return function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map4 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(fun) {
            return function(a) {
                return apply(map4(applyEither1)($d2284b2d3e1b6f87$export$8291c2122093ac93(fun)))($d2284b2d3e1b6f87$export$8291c2122093ac93(a));
            };
        };
    };
};
var $f505976c723c2a85$var$exceptTApply1 = /* #__PURE__ */ $f505976c723c2a85$var$exceptTApply($78c799cba34fcb8d$export$a8cfc3dfdfca72cf)($50c50d1f444e5fa4$export$fd3b2458e55fc503);
var $f505976c723c2a85$export$5b101d49c7918908 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    var insert1 = $f505976c723c2a85$var$insert(dictIsSymbol);
    return function(dictReadForeign) {
        var readImpl2 = $f505976c723c2a85$export$f6103847fe734e8(dictReadForeign);
        return function(dictReadForeignFields) {
            var getFields1 = $f505976c723c2a85$export$d5523731e7fe4ded(dictReadForeignFields);
            return function() {
                return function() {
                    return {
                        getFields: function(v) {
                            return function(obj) {
                                var rest = getFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(obj);
                                var name = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var withExcept$prime = $f9f243b94d1fc188$export$64f3cd24d850d401($f505976c723c2a85$var$map2($c97d2d0f578f81ad$export$92e5795aa905bd26.create(name)));
                                var first = $f505976c723c2a85$var$bind(withExcept$prime($f505976c723c2a85$var$bindFlipped(readImpl2)($f505976c723c2a85$var$readProp(name)(obj))))(function(value) {
                                    return $f505976c723c2a85$var$pure(insert1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(value));
                                });
                                return $f505976c723c2a85$var$exceptTApply1($f505976c723c2a85$var$map1($f505976c723c2a85$var$compose1)(first))(rest);
                            };
                        }
                    };
                };
            };
        };
    };
};
var $f505976c723c2a85$var$readImpl1 = /* #__PURE__ */ $f505976c723c2a85$export$f6103847fe734e8(/* #__PURE__ */ $f505976c723c2a85$export$b400c64e22f7eb4c()(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "type";
    }
})($f505976c723c2a85$export$dda73877cb166cd3)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "value";
    }
})($f505976c723c2a85$export$977d401f5646009f)($f505976c723c2a85$export$d9e5338498903fce)()())()()));
var $f505976c723c2a85$export$e9afada173d3b0af = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    var inj1 = $f505976c723c2a85$var$inj(dictIsSymbol);
    return function(dictReadForeign) {
        var readImpl2 = $f505976c723c2a85$export$f6103847fe734e8(dictReadForeign);
        return function() {
            return function(dictReadForeignVariant) {
                var readVariantImpl1 = $f505976c723c2a85$export$8b5f7e2f61d5dd7b(dictReadForeignVariant);
                return {
                    readVariantImpl: function(v) {
                        return function(o) {
                            var name = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $f505976c723c2a85$var$alt($f505976c723c2a85$var$bind($f505976c723c2a85$var$readImpl1(o))(function(v1) {
                                var $189 = v1.type === name;
                                if ($189) return $f505976c723c2a85$var$bind(readImpl2(v1.value))(function(v2) {
                                    return $f505976c723c2a85$var$pure(inj1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v2));
                                });
                                return $f505976c723c2a85$var$fail($c97d2d0f578f81ad$export$f6a37cc43a8b8898.create("Did not match variant tag " + name));
                            }))(readVariantImpl1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(o));
                        };
                    }
                };
            };
        };
    };
};


// Generated by purs version 0.15.15
















// Generated by purs version 0.15.15
/* global Symbol */ var $bfc50dc5547207b7$var$hasArrayFrom = typeof Array.from === "function";
var $bfc50dc5547207b7$var$hasStringIterator = typeof Symbol !== "undefined" && Symbol != null && typeof Symbol.iterator !== "undefined" && typeof String.prototype[Symbol.iterator] === "function";
var $bfc50dc5547207b7$var$hasFromCodePoint = typeof String.prototype.fromCodePoint === "function";
var $bfc50dc5547207b7$var$hasCodePointAt = typeof String.prototype.codePointAt === "function";
const $bfc50dc5547207b7$export$81daff3801c9c982 = function(fallback) {
    return $bfc50dc5547207b7$var$hasCodePointAt ? function(str) {
        return str.codePointAt(0);
    } : fallback;
};
const $bfc50dc5547207b7$export$5f0398d7608003c3 = function(fallback) {
    return function(Just) {
        return function(Nothing) {
            return function(unsafeCodePointAt0) {
                return function(index) {
                    return function(str) {
                        var length = str.length;
                        if (index < 0 || index >= length) return Nothing;
                        if ($bfc50dc5547207b7$var$hasStringIterator) {
                            var iter = str[Symbol.iterator]();
                            for(var i = index;; --i){
                                var o = iter.next();
                                if (o.done) return Nothing;
                                if (i === 0) return Just(unsafeCodePointAt0(o.value));
                            }
                        }
                        return fallback(index)(str);
                    };
                };
            };
        };
    };
};
const $bfc50dc5547207b7$export$2964bc4d0a1ede06 = function(fallback) {
    return function(unsafeCodePointAt0) {
        if ($bfc50dc5547207b7$var$hasStringIterator) return function(pred) {
            return function(str) {
                var iter = str[Symbol.iterator]();
                for(var cpCount = 0;; ++cpCount){
                    var o = iter.next();
                    if (o.done) return cpCount;
                    var cp = unsafeCodePointAt0(o.value);
                    if (!pred(cp)) return cpCount;
                }
            };
        };
        return fallback;
    };
};
const $bfc50dc5547207b7$export$c41b441de25e3d55 = function(singleton) {
    return $bfc50dc5547207b7$var$hasFromCodePoint ? function(cps) {
        // Function.prototype.apply will fail for very large second parameters,
        // so we don't use it for arrays with 10,000 or more entries.
        if (cps.length < 10e3) return String.fromCodePoint.apply(String, cps);
        return cps.map(singleton).join("");
    } : function(cps) {
        return cps.map(singleton).join("");
    };
};
const $bfc50dc5547207b7$export$ecb7b38eca4fe9ff = function(fallback) {
    return $bfc50dc5547207b7$var$hasFromCodePoint ? String.fromCodePoint : fallback;
};
const $bfc50dc5547207b7$export$6d9af221d75dd06f = function(fallback) {
    return function(n) {
        if ($bfc50dc5547207b7$var$hasStringIterator) return function(str) {
            var accum = "";
            var iter = str[Symbol.iterator]();
            for(var i = 0; i < n; ++i){
                var o = iter.next();
                if (o.done) return accum;
                accum += o.value;
            }
            return accum;
        };
        return fallback(n);
    };
};
const $bfc50dc5547207b7$export$c61d72f8b05641be = function(fallback) {
    return function(unsafeCodePointAt0) {
        if ($bfc50dc5547207b7$var$hasArrayFrom) return function(str) {
            return Array.from(str, unsafeCodePointAt0);
        };
        return fallback;
    };
};












// Generated by purs version 0.15.15
const $5b07e36f812dd04b$export$3ece336175b57f19 = function(lt) {
    return function(eq) {
        return function(gt) {
            return function(s1) {
                return function(s2) {
                    var result = s1.localeCompare(s2);
                    return result < 0 ? lt : result > 0 ? gt : eq;
                };
            };
        };
    };
};
const $5b07e36f812dd04b$export$77ad94ebf1c2b9ed = function(s1) {
    return function(s2) {
        return function(s3) {
            return s3.replace(s1, s2);
        };
    };
};
const $5b07e36f812dd04b$export$b8b3234b4edfc4c2 = function(s1) {
    return function(s2) {
        return function(s3) {
            return s3.replace(new RegExp(s1.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "g"), s2); // eslint-disable-line no-useless-escape
        };
    };
};
const $5b07e36f812dd04b$export$65980d18b75784e2 = function(sep) {
    return function(s) {
        return s.split(sep);
    };
};
const $5b07e36f812dd04b$export$b1ceac3893cbda6b = function(s) {
    return s.toLowerCase();
};
const $5b07e36f812dd04b$export$43df7fc17cca38a4 = function(s) {
    return s.toUpperCase();
};
const $5b07e36f812dd04b$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
const $5b07e36f812dd04b$export$ec1dc8fbeea3467e = function(s) {
    return function(xs) {
        return xs.join(s);
    };
};



var $22d4f8ab6946d33a$export$7b1b591b262c240 = function(s) {
    return s === "";
};
var $22d4f8ab6946d33a$export$35652c12e6caefdf = /* #__PURE__ */ function() {
    return $5b07e36f812dd04b$export$3ece336175b57f19($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value);
}();





var $3ee2158c14339cc9$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $3ee2158c14339cc9$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($f935a9866e211c00$export$be1f07c3580164c);
var $3ee2158c14339cc9$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $3ee2158c14339cc9$var$unfoldr = /* #__PURE__ */ $cb5fedc2c4837e1c$export$df2b8ee1690308ae($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $3ee2158c14339cc9$var$div = /* #__PURE__ */ $b0cd729514c2504e$export$159d9494db57879b($b0cd729514c2504e$export$437776face1858ae);
var $3ee2158c14339cc9$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $3ee2158c14339cc9$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $3ee2158c14339cc9$var$CodePoint = function(x) {
    return x;
};
var $3ee2158c14339cc9$var$unsurrogate = function(lead) {
    return function(trail) {
        return (((lead - 55296 | 0) * 1024 | 0) + (trail - 56320 | 0) | 0) + 65536 | 0;
    };
};
var $3ee2158c14339cc9$export$1e278a1fb25ff338 = {
    show: function(v) {
        return "(CodePoint 0x" + ($5b07e36f812dd04b$export$43df7fc17cca38a4($4ab74a20512cef04$export$f601457c5ee3082f($8d5664f12212b23e$export$9c12a48020146abe)(v)) + ")");
    }
};
var $3ee2158c14339cc9$var$isTrail = function(cu) {
    return 56320 <= cu && cu <= 57343;
};
var $3ee2158c14339cc9$var$isLead = function(cu) {
    return 55296 <= cu && cu <= 56319;
};
var $3ee2158c14339cc9$export$b446f6baa3bb1430 = function(s) {
    var v = $092fe44bc0883be6$export$f24224f1c91d8156(s);
    if (v === 0) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(0)(s)),
        tail: ""
    });
    var cu1 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(1)(s));
    var cu0 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(0)(s));
    var $43 = $3ee2158c14339cc9$var$isLead(cu0) && $3ee2158c14339cc9$var$isTrail(cu1);
    if ($43) return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: $3ee2158c14339cc9$var$unsurrogate(cu0)(cu1),
        tail: $092fe44bc0883be6$export$663103110d94aac9(2)(s)
    });
    return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: cu0,
        tail: $092fe44bc0883be6$export$663103110d94aac9(1)(s)
    });
};
var $3ee2158c14339cc9$var$unconsButWithTuple = function(s) {
    return $3ee2158c14339cc9$var$map(function(v) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.head, v.tail);
    })($3ee2158c14339cc9$export$b446f6baa3bb1430(s));
};
var $3ee2158c14339cc9$var$toCodePointArrayFallback = function(s) {
    return $3ee2158c14339cc9$var$unfoldr($3ee2158c14339cc9$var$unconsButWithTuple)(s);
};
var $3ee2158c14339cc9$var$unsafeCodePointAt0Fallback = function(s) {
    var cu0 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(0)(s));
    var $47 = $3ee2158c14339cc9$var$isLead(cu0) && $092fe44bc0883be6$export$f24224f1c91d8156(s) > 1;
    if ($47) {
        var cu1 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(1)(s));
        var $48 = $3ee2158c14339cc9$var$isTrail(cu1);
        if ($48) return $3ee2158c14339cc9$var$unsurrogate(cu0)(cu1);
        return cu0;
    }
    return cu0;
};
var $3ee2158c14339cc9$var$unsafeCodePointAt0 = /* #__PURE__ */ $bfc50dc5547207b7$export$81daff3801c9c982($3ee2158c14339cc9$var$unsafeCodePointAt0Fallback);
var $3ee2158c14339cc9$export$50a427d3c041e0d2 = /* #__PURE__ */ $bfc50dc5547207b7$export$c61d72f8b05641be($3ee2158c14339cc9$var$toCodePointArrayFallback)($3ee2158c14339cc9$var$unsafeCodePointAt0);
var $3ee2158c14339cc9$export$f24224f1c91d8156 = function($74) {
    return $fc8c1182ec2aefec$export$f24224f1c91d8156($3ee2158c14339cc9$export$50a427d3c041e0d2($74));
};
var $3ee2158c14339cc9$export$557cfb7ed375eeb7 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$map(function(i) {
            return $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(i)(s));
        })($1a77d6934b592676$export$557cfb7ed375eeb7(p)(s));
    };
};
var $3ee2158c14339cc9$export$305f7d4e9d4624f2 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$map(function(i) {
            return $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(i)(s));
        })($1a77d6934b592676$export$305f7d4e9d4624f2(p)(s));
    };
};
var $3ee2158c14339cc9$var$fromCharCode = /* #__PURE__ */ function() {
    var $75 = $f935a9866e211c00$export$1e2c188a485bdeae($f935a9866e211c00$export$be1f07c3580164c)($69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79))($69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79));
    return function($76) {
        return $092fe44bc0883be6$export$439306a4dcaafbb9($75($76));
    };
}();
var $3ee2158c14339cc9$var$singletonFallback = function(v) {
    if (v <= 65535) return $3ee2158c14339cc9$var$fromCharCode(v);
    var lead = $3ee2158c14339cc9$var$div(v - 65536 | 0)(1024) + 55296 | 0;
    var trail = $3ee2158c14339cc9$var$mod(v - 65536 | 0)(1024) + 56320 | 0;
    return $3ee2158c14339cc9$var$fromCharCode(lead) + $3ee2158c14339cc9$var$fromCharCode(trail);
};
var $3ee2158c14339cc9$export$6fadda5ad927586c = /* #__PURE__ */ $bfc50dc5547207b7$export$c41b441de25e3d55($3ee2158c14339cc9$var$singletonFallback);
var $3ee2158c14339cc9$export$439306a4dcaafbb9 = /* #__PURE__ */ $bfc50dc5547207b7$export$ecb7b38eca4fe9ff($3ee2158c14339cc9$var$singletonFallback);
var $3ee2158c14339cc9$var$takeFallback = function(v) {
    return function(v1) {
        if (v < 1) return "";
        var v2 = $3ee2158c14339cc9$export$b446f6baa3bb1430(v1);
        if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $3ee2158c14339cc9$export$439306a4dcaafbb9(v2.value0.head) + $3ee2158c14339cc9$var$takeFallback(v - 1 | 0)(v2.value0.tail);
        return v1;
    };
};
var $3ee2158c14339cc9$export$b7df5d561049483a = /* #__PURE__ */ $bfc50dc5547207b7$export$6d9af221d75dd06f($3ee2158c14339cc9$var$takeFallback);
var $3ee2158c14339cc9$export$9dc3eed83bb14216 = function(p) {
    return function(i) {
        return function(s) {
            var i$prime = $092fe44bc0883be6$export$f24224f1c91d8156($3ee2158c14339cc9$export$b7df5d561049483a(i)(s));
            return $3ee2158c14339cc9$var$map(function(k) {
                return $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(k)(s));
            })($1a77d6934b592676$export$9dc3eed83bb14216(p)(i$prime)(s));
        };
    };
};
var $3ee2158c14339cc9$export$b0d75975ac0be0e1 = function(i) {
    return function(s) {
        var before = $3ee2158c14339cc9$export$b7df5d561049483a(i)(s);
        return {
            before: before,
            after: $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156(before))(s)
        };
    };
};
var $3ee2158c14339cc9$export$e200a5917becef04 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $3ee2158c14339cc9$export$b08a820ff2b5847d = {
    compare: function(x) {
        return function(y) {
            return $3ee2158c14339cc9$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $3ee2158c14339cc9$export$e200a5917becef04;
    }
};
var $3ee2158c14339cc9$export$663103110d94aac9 = function(n) {
    return function(s) {
        return $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156($3ee2158c14339cc9$export$b7df5d561049483a(n)(s)))(s);
    };
};
var $3ee2158c14339cc9$export$7f0e23922170149a = function(p) {
    return function(i) {
        return function(s) {
            var s$prime = $3ee2158c14339cc9$export$663103110d94aac9(i)(s);
            return $3ee2158c14339cc9$var$map(function(k) {
                return i + $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(k)(s$prime)) | 0;
            })($1a77d6934b592676$export$305f7d4e9d4624f2(p)(s$prime));
        };
    };
};
var $3ee2158c14339cc9$var$countTail = function($copy_p) {
    return function($copy_s) {
        return function($copy_accum) {
            var $tco_var_p = $copy_p;
            var $tco_var_s = $copy_s;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(p, s, accum) {
                var v = $3ee2158c14339cc9$export$b446f6baa3bb1430(s);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    var $61 = p(v.value0.head);
                    if ($61) {
                        $tco_var_p = p;
                        $tco_var_s = v.value0.tail;
                        $copy_accum = accum + 1 | 0;
                        return;
                    }
                    $tco_done = true;
                    return accum;
                }
                $tco_done = true;
                return accum;
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_p, $tco_var_s, $copy_accum);
            return $tco_result;
        };
    };
};
var $3ee2158c14339cc9$var$countFallback = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$countTail(p)(s)(0);
    };
};
var $3ee2158c14339cc9$export$29a68f758c141c85 = /* #__PURE__ */ $bfc50dc5547207b7$export$2964bc4d0a1ede06($3ee2158c14339cc9$var$countFallback)($3ee2158c14339cc9$var$unsafeCodePointAt0);
var $3ee2158c14339cc9$export$533af5c8cd6afa16 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$export$663103110d94aac9($3ee2158c14339cc9$export$29a68f758c141c85(p)(s))(s);
    };
};
var $3ee2158c14339cc9$export$9384c7afe4015e42 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$export$b7df5d561049483a($3ee2158c14339cc9$export$29a68f758c141c85(p)(s))(s);
    };
};
var $3ee2158c14339cc9$export$dd1029f96c3dd62a = function($77) {
    return $3ee2158c14339cc9$var$CodePoint($3ee2158c14339cc9$var$fromEnum($77));
};
var $3ee2158c14339cc9$var$codePointAtFallback = function($copy_n) {
    return function($copy_s) {
        var $tco_var_n = $copy_n;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(n, s) {
            var v = $3ee2158c14339cc9$export$b446f6baa3bb1430(s);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                var $66 = n === 0;
                if ($66) {
                    $tco_done = true;
                    return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.head);
                }
                $tco_var_n = n - 1 | 0;
                $copy_s = v.value0.tail;
                return;
            }
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_n, $copy_s);
        return $tco_result;
    };
};
var $3ee2158c14339cc9$export$42977f40461e1360 = function(v) {
    return function(v1) {
        if (v < 0) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (v === 0 && v1 === "") return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($3ee2158c14339cc9$var$unsafeCodePointAt0(v1));
        return $bfc50dc5547207b7$export$5f0398d7608003c3($3ee2158c14339cc9$var$codePointAtFallback)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value)($3ee2158c14339cc9$var$unsafeCodePointAt0)(v)(v1);
    };
};
var $3ee2158c14339cc9$export$1c2b30ab4636bf91 = {
    bottom: 0,
    top: 1114111,
    Ord0: function() {
        return $3ee2158c14339cc9$export$b08a820ff2b5847d;
    }
};
var $3ee2158c14339cc9$export$2a3400c6862992c1 = /* #__PURE__ */ function() {
    return {
        cardinality: 1114112,
        fromEnum: function(v) {
            return v;
        },
        toEnum: function(n) {
            if (n >= 0 && n <= 1114111) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.String.CodePoints (line 63, column 1 - line 68, column 26): " + [
                n.constructor.name
            ]);
        },
        Bounded0: function() {
            return $3ee2158c14339cc9$export$1c2b30ab4636bf91;
        },
        Enum1: function() {
            return $3ee2158c14339cc9$var$$lazy_enumCodePoint(0);
        }
    };
}();
var $3ee2158c14339cc9$var$$lazy_enumCodePoint = /* #__PURE__ */ $3ee2158c14339cc9$var$$runtime_lazy("enumCodePoint", "Data.String.CodePoints", function() {
    return {
        succ: $f935a9866e211c00$export$11e799785deb08e4($f935a9866e211c00$export$45328c01562fb205($3ee2158c14339cc9$export$2a3400c6862992c1))($f935a9866e211c00$export$b385cb642735011f($3ee2158c14339cc9$export$2a3400c6862992c1)),
        pred: $f935a9866e211c00$export$dc42af8461b24233($f935a9866e211c00$export$45328c01562fb205($3ee2158c14339cc9$export$2a3400c6862992c1))($f935a9866e211c00$export$b385cb642735011f($3ee2158c14339cc9$export$2a3400c6862992c1)),
        Ord0: function() {
            return $3ee2158c14339cc9$export$b08a820ff2b5847d;
        }
    };
});
var $3ee2158c14339cc9$export$4bc346dd2fb559f7 = /* #__PURE__ */ $3ee2158c14339cc9$var$$lazy_enumCodePoint(59);



// Generated by purs version 0.15.15
const $ed6295dbdc25761e$export$22dedfc55ca7a214 = function(r) {
    return "" + r;
};
const $ed6295dbdc25761e$export$f69e81cb42c99394 = function(left) {
    return function(right) {
        return function(s1) {
            return function(s2) {
                try {
                    return right(new RegExp(s1, s2));
                } catch (e) {
                    return left(e.message);
                }
            };
        };
    };
};
const $ed6295dbdc25761e$export$b4d5da5f34fb77ad = function(r) {
    return r.source;
};
const $ed6295dbdc25761e$export$a0f57c1eeb878eb7 = function(r) {
    return {
        multiline: r.multiline,
        ignoreCase: r.ignoreCase,
        global: r.global,
        dotAll: r.dotAll,
        sticky: !!r.sticky,
        unicode: !!r.unicode
    };
};
const $ed6295dbdc25761e$export$e0969da9b8fb378d = function(r) {
    return function(s) {
        var lastIndex = r.lastIndex;
        var result = r.test(s);
        r.lastIndex = lastIndex;
        return result;
    };
};
const $ed6295dbdc25761e$export$46506e5af176113c = function(just) {
    return function(nothing) {
        return function(r) {
            return function(s) {
                var m = s.match(r);
                if (m == null || m.length === 0) return nothing;
                else {
                    for(var i = 0; i < m.length; i++)m[i] = m[i] == null ? nothing : just(m[i]);
                    return just(m);
                }
            };
        };
    };
};
const $ed6295dbdc25761e$export$77ad94ebf1c2b9ed = function(r) {
    return function(s1) {
        return function(s2) {
            return s2.replace(r, s1);
        };
    };
};
const $ed6295dbdc25761e$export$bad08cfccf5cc7c3 = function(just) {
    return function(nothing) {
        return function(r) {
            return function(f) {
                return function(s) {
                    return s.replace(r, function(match) {
                        var groups = [];
                        var group, i = 1;
                        while(typeof (group = arguments[i++]) !== "number")groups.push(group == null ? nothing : just(group));
                        return f(match)(groups);
                    });
                };
            };
        };
    };
};
const $ed6295dbdc25761e$export$abe1cf074395fe09 = function(just) {
    return function(nothing) {
        return function(r) {
            return function(s) {
                var result = s.search(r);
                return result === -1 ? nothing : just(result);
            };
        };
    };
};
const $ed6295dbdc25761e$export$65980d18b75784e2 = function(r) {
    return function(s) {
        return s.split(r);
    };
};





// Generated by purs version 0.15.15





var $fb3071975af0bbe0$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $fb3071975af0bbe0$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $fb3071975af0bbe0$var$guard = /* #__PURE__ */ $f1992c51575cdea6$export$864d727b48066337($f1992c51575cdea6$export$5e87c78e215371ee);
var $fb3071975af0bbe0$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($37b880af5f4991bd$export$fa624555ca2acbc8));
var $fb3071975af0bbe0$export$8760a645d51315cb = function(x) {
    return x;
};
var $fb3071975af0bbe0$export$1aaf7eccd7f610ad = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: true
};
var $fb3071975af0bbe0$export$4bd4b47501432316 = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: true,
    unicode: false
};
var $fb3071975af0bbe0$export$ea09a2a1f3b28164 = {
    show: function(v) {
        var usedFlags = $fb3071975af0bbe0$var$append([])($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.global))("global"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.ignoreCase))("ignoreCase"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.multiline))("multiline"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.dotAll))("dotAll"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.sticky))("sticky"))($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.unicode))("unicode")))))));
        var $43 = $fb3071975af0bbe0$var$eq(usedFlags)([]);
        if ($43) return "noFlags";
        return "(" + ($5b07e36f812dd04b$export$ec1dc8fbeea3467e(" <> ")(usedFlags) + ")");
    }
};
var $fb3071975af0bbe0$export$69936738517d6e4e = {
    append: function(v) {
        return function(v1) {
            return {
                global: v.global || v1.global,
                ignoreCase: v.ignoreCase || v1.ignoreCase,
                multiline: v.multiline || v1.multiline,
                dotAll: v.dotAll || v1.dotAll,
                sticky: v.sticky || v1.sticky,
                unicode: v.unicode || v1.unicode
            };
        };
    }
};
var $fb3071975af0bbe0$export$77e76a4721f88dfa = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$726fd70d90b3a5b4 = {
    Coercible0: function() {
        return undefined;
    }
};
var $fb3071975af0bbe0$export$e086dccf8e77e85 = {
    global: false,
    ignoreCase: false,
    multiline: true,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$85aac2cdb4833912 = {
    mempty: $fb3071975af0bbe0$export$77e76a4721f88dfa,
    Semigroup0: function() {
        return $fb3071975af0bbe0$export$69936738517d6e4e;
    }
};
var $fb3071975af0bbe0$export$2afc0c80c8dff0e7 = {
    global: false,
    ignoreCase: true,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$90b4d2ff6acb88af = {
    global: true,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$36f4f1589a5fb413 = /* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e()(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0($37b880af5f4991bd$export$d12253326f924cb1)()({
    reflectSymbol: function() {
        return "unicode";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48))()({
    reflectSymbol: function() {
        return "sticky";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48))()({
    reflectSymbol: function() {
        return "multiline";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48))()({
    reflectSymbol: function() {
        return "ignoreCase";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48))()({
    reflectSymbol: function() {
        return "global";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48))()({
    reflectSymbol: function() {
        return "dotAll";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48));
var $fb3071975af0bbe0$export$6866eb06e0b66746 = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: true,
    sticky: false,
    unicode: false
};


var $03be6cc86948e3c6$export$a9b8f38109c4ed61 = {
    show: $ed6295dbdc25761e$export$22dedfc55ca7a214
};
var $03be6cc86948e3c6$export$d76128d007d19019 = /* #__PURE__ */ function() {
    return $ed6295dbdc25761e$export$abe1cf074395fe09($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $03be6cc86948e3c6$export$1b5e458140968481 = /* #__PURE__ */ function() {
    return $ed6295dbdc25761e$export$bad08cfccf5cc7c3($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $03be6cc86948e3c6$export$b6228dc14c5adf51 = function(v) {
    return function() {
        if (v.global) return "g";
        return "";
    }() + (function() {
        if (v.ignoreCase) return "i";
        return "";
    }() + (function() {
        if (v.multiline) return "m";
        return "";
    }() + (function() {
        if (v.dotAll) return "s";
        return "";
    }() + (function() {
        if (v.sticky) return "y";
        return "";
    }() + function() {
        if (v.unicode) return "u";
        return "";
    }()))));
};
var $03be6cc86948e3c6$export$17b0f4d84dbfeedf = function(s) {
    return function(f) {
        return $ed6295dbdc25761e$export$f69e81cb42c99394($7d4cccdf062a2261$export$37c4d04eafdc5515.create)($7d4cccdf062a2261$export$19db0165690c701a.create)(s)($03be6cc86948e3c6$export$b6228dc14c5adf51(f));
    };
};
var $03be6cc86948e3c6$export$909765d3c3e4d815 = function(s) {
    return {
        global: $1a77d6934b592676$export$2344b14b097df817("g")(s),
        ignoreCase: $1a77d6934b592676$export$2344b14b097df817("i")(s),
        multiline: $1a77d6934b592676$export$2344b14b097df817("m")(s),
        dotAll: $1a77d6934b592676$export$2344b14b097df817("s")(s),
        sticky: $1a77d6934b592676$export$2344b14b097df817("y")(s),
        unicode: $1a77d6934b592676$export$2344b14b097df817("u")(s)
    };
};
var $03be6cc86948e3c6$export$4659b591c19bdf3d = /* #__PURE__ */ function() {
    return $ed6295dbdc25761e$export$46506e5af176113c($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $03be6cc86948e3c6$export$ceac1d294cf61000 = function($10) {
    return $fb3071975af0bbe0$export$8760a645d51315cb($ed6295dbdc25761e$export$a0f57c1eeb878eb7($10));
};




// Generated by purs version 0.15.15



















// Generated by purs version 0.15.15















// Generated by purs version 0.15.15











var $05fb1b61396adfce$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $05fb1b61396adfce$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $05fb1b61396adfce$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $05fb1b61396adfce$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $05fb1b61396adfce$var$tailRecM = /* #__PURE__ */ $f93520de2fa37b44$export$c025cfd4cc93300b($f93520de2fa37b44$export$ddd28c989be5e46c);
var $05fb1b61396adfce$export$7acfa6ed01010e37 = function(x) {
    return x;
};
var $05fb1b61396adfce$export$61619fb136dbd525 = function(v) {
    return v;
};
var $05fb1b61396adfce$export$4ad9239eebc1597f = function(v) {
    return function(s) {
        return $05fb1b61396adfce$var$map(function(v1) {
            return v1.result;
        })(v({
            substring: s,
            position: 0
        }));
    };
};
var $05fb1b61396adfce$export$b2c4aa8ea22bcef8 = function(rec) {
    return rec.error + ("; pos = " + $05fb1b61396adfce$var$show(rec.pos));
};
var $05fb1b61396adfce$export$25597b62813a6c6d = {
    defer: function(f) {
        return function(str) {
            return $05fb1b61396adfce$export$61619fb136dbd525(f($05149ea687d6b460$export$523c0b569236b342))(str);
        };
    }
};
var $05fb1b61396adfce$export$3634602ee36f7fe6 = {
    map: function(f) {
        return function(v) {
            var $69 = $05fb1b61396adfce$var$map(function(v1) {
                return {
                    result: f(v1.result),
                    suffix: v1.suffix
                };
            });
            return function($70) {
                return $69(v($70));
            };
        };
    }
};
var $05fb1b61396adfce$export$2b62a06a9fee979c = function(error) {
    return function(v) {
        return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
            pos: v.position,
            error: error
        });
    };
};
var $05fb1b61396adfce$export$ccef557e816015a1 = {
    apply: function(v) {
        return function(v1) {
            return function(s) {
                return $05fb1b61396adfce$var$bind(v(s))(function(v2) {
                    return $05fb1b61396adfce$var$bind(v1(v2.suffix))(function(v3) {
                        return $05fb1b61396adfce$var$pure({
                            result: v2.result(v3.result),
                            suffix: v3.suffix
                        });
                    });
                });
            };
        };
    },
    Functor0: function() {
        return $05fb1b61396adfce$export$3634602ee36f7fe6;
    }
};
var $05fb1b61396adfce$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($05fb1b61396adfce$export$ccef557e816015a1);
var $05fb1b61396adfce$export$6a1d89187d209f74 = {
    bind: function(v) {
        return function(f) {
            return function(s) {
                return $05fb1b61396adfce$var$bind(v(s))(function(v1) {
                    return $05fb1b61396adfce$export$61619fb136dbd525(f(v1.result))(v1.suffix);
                });
            };
        };
    },
    Apply0: function() {
        return $05fb1b61396adfce$export$ccef557e816015a1;
    }
};
var $05fb1b61396adfce$export$4719e31b794cbea2 = function(dictSemigroup) {
    return {
        append: $05fb1b61396adfce$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $05fb1b61396adfce$export$45def89472122d0b = {
    pure: function(a) {
        return function(s) {
            return new $7d4cccdf062a2261$export$19db0165690c701a({
                result: a,
                suffix: s
            });
        };
    },
    Apply0: function() {
        return $05fb1b61396adfce$export$ccef557e816015a1;
    }
};
var $05fb1b61396adfce$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($05fb1b61396adfce$export$45def89472122d0b);
var $05fb1b61396adfce$export$43bf262accd661e9 = {
    Applicative0: function() {
        return $05fb1b61396adfce$export$45def89472122d0b;
    },
    Bind1: function() {
        return $05fb1b61396adfce$export$6a1d89187d209f74;
    }
};
var $05fb1b61396adfce$export$5d06481b113f8de9 = {
    tailRecM: function(f) {
        return function(a) {
            var split = function(v) {
                if (v.result instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                    state: v.result.value0,
                    str: v.suffix
                });
                if (v.result instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10({
                    result: v.result.value0,
                    suffix: v.suffix
                });
                throw new Error("Failed pattern match at StringParser.Parser (line 87, column 5 - line 87, column 68): " + [
                    v.constructor.name
                ]);
            };
            return function(str) {
                return $05fb1b61396adfce$var$tailRecM(function(st) {
                    return $05fb1b61396adfce$var$map(split)($05fb1b61396adfce$export$61619fb136dbd525(f(st.state))(st.str));
                })({
                    state: a,
                    str: str
                });
            };
        };
    },
    Monad0: function() {
        return $05fb1b61396adfce$export$43bf262accd661e9;
    }
};
var $05fb1b61396adfce$export$98d6f0d45f4cb79f = function(dictMonoid) {
    var semigroupParser1 = $05fb1b61396adfce$export$4719e31b794cbea2(dictMonoid.Semigroup0());
    return {
        mempty: $05fb1b61396adfce$var$pure1($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupParser1;
        }
    };
};
var $05fb1b61396adfce$export$6b86c7f1e16b91d2 = {
    alt: function(v) {
        return function(v1) {
            return function(s) {
                var v2 = v(s);
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) {
                    if (s.position === v2.value0.pos) return v1(s);
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
                        error: v2.value0.error,
                        pos: v2.value0.pos
                    });
                }
                return v2;
            };
        };
    },
    Functor0: function() {
        return $05fb1b61396adfce$export$3634602ee36f7fe6;
    }
};
var $05fb1b61396adfce$export$7fee2a9586c02cd9 = {
    empty: /* #__PURE__ */ $05fb1b61396adfce$export$2b62a06a9fee979c("No alternative"),
    Alt0: function() {
        return $05fb1b61396adfce$export$6b86c7f1e16b91d2;
    }
};
var $05fb1b61396adfce$export$b1f0061631f50ac9 = {
    Applicative0: function() {
        return $05fb1b61396adfce$export$45def89472122d0b;
    },
    Plus1: function() {
        return $05fb1b61396adfce$export$7fee2a9586c02cd9;
    }
};
var $05fb1b61396adfce$export$30c0f9792bafc5fe = {
    Monad0: function() {
        return $05fb1b61396adfce$export$43bf262accd661e9;
    },
    Alternative1: function() {
        return $05fb1b61396adfce$export$b1f0061631f50ac9;
    }
};


var $fb26133a5ec46bf7$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($05fb1b61396adfce$export$6b86c7f1e16b91d2);
var $fb26133a5ec46bf7$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($05fb1b61396adfce$export$6a1d89187d209f74);
var $fb26133a5ec46bf7$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($05fb1b61396adfce$export$45def89472122d0b);
var $fb26133a5ec46bf7$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($05fb1b61396adfce$export$3634602ee36f7fe6);
var $fb26133a5ec46bf7$var$mapFlipped = /* #__PURE__ */ $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a($05fb1b61396adfce$export$3634602ee36f7fe6);
var $fb26133a5ec46bf7$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($05fb1b61396adfce$export$3634602ee36f7fe6);
var $fb26133a5ec46bf7$var$applyFirst = /* #__PURE__ */ $7576d3a958d66ab0$export$e48e2da4536c2eea($05fb1b61396adfce$export$ccef557e816015a1);
var $fb26133a5ec46bf7$var$applySecond = /* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($05fb1b61396adfce$export$ccef557e816015a1);
var $fb26133a5ec46bf7$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($05fb1b61396adfce$export$ccef557e816015a1);
var $fb26133a5ec46bf7$var$tailRecM = /* #__PURE__ */ $f93520de2fa37b44$export$c025cfd4cc93300b($05fb1b61396adfce$export$5d06481b113f8de9);
var $fb26133a5ec46bf7$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($78c799cba34fcb8d$export$e5d0ed5dac805e10);
var $fb26133a5ec46bf7$export$60e9e0884ce12b55 = function(p) {
    return function(msg) {
        return $fb26133a5ec46bf7$var$alt(p)($05fb1b61396adfce$export$2b62a06a9fee979c(msg));
    };
};
var $fb26133a5ec46bf7$export$410a452afcd48948 = function(v) {
    return function(s) {
        var v1 = v(s);
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
            pos: s.position,
            error: v1.value0.error
        });
        return v1;
    };
};
var $fb26133a5ec46bf7$export$516e28dec6a4b6d4 = function(p) {
    return $fb26133a5ec46bf7$var$alt($fb26133a5ec46bf7$var$bind(p)(function(v) {
        return $fb26133a5ec46bf7$var$pure($05149ea687d6b460$export$523c0b569236b342);
    }))($fb26133a5ec46bf7$var$pure($05149ea687d6b460$export$523c0b569236b342));
};
var $fb26133a5ec46bf7$export$a75d1723e6bda2ec = function(a) {
    return function(p) {
        return $fb26133a5ec46bf7$var$alt(p)($fb26133a5ec46bf7$var$pure(a));
    };
};
var $fb26133a5ec46bf7$export$b9803a97967f594 = function(p) {
    return $fb26133a5ec46bf7$export$a75d1723e6bda2ec($06733ae99ed4f534$export$bebe9059409a0d04.value)($fb26133a5ec46bf7$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)(p));
};
var $fb26133a5ec46bf7$export$89c36ea49ad05bf3 = function(v) {
    return function(s) {
        var v1 = v(s);
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a({
            result: v1.value0.result,
            suffix: s
        });
        return v1;
    };
};
var $fb26133a5ec46bf7$export$f6dd04063e306e74 = function($36) {
    return $fb26133a5ec46bf7$export$410a452afcd48948($fb26133a5ec46bf7$export$89c36ea49ad05bf3($36));
};
var $fb26133a5ec46bf7$var$cons$prime = function(h) {
    return function(t) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(h, t);
    };
};
var $fb26133a5ec46bf7$export$d2ed8cc1d2e8029b = function(p) {
    return function(sep) {
        return $fb26133a5ec46bf7$var$bind(p)(function(a) {
            return $fb26133a5ec46bf7$var$alt($fb26133a5ec46bf7$var$bind(sep)(function() {
                return $fb26133a5ec46bf7$var$bind($fb26133a5ec46bf7$export$3f00b9d4810f7a39(p)(sep))(function(as) {
                    return $fb26133a5ec46bf7$var$pure($fb26133a5ec46bf7$var$cons$prime(a)(as));
                });
            }))($fb26133a5ec46bf7$var$pure($ba51d599f79a6310$export$439306a4dcaafbb9(a)));
        });
    };
};
var $fb26133a5ec46bf7$export$3f00b9d4810f7a39 = function(p) {
    return function(sep) {
        return $fb26133a5ec46bf7$var$alt($fb26133a5ec46bf7$var$mapFlipped($fb26133a5ec46bf7$export$d2ed8cc1d2e8029b(p)(sep))($ba51d599f79a6310$export$effcdbd76139450))($fb26133a5ec46bf7$var$alt($fb26133a5ec46bf7$var$voidLeft(sep)($78c799cba34fcb8d$export$c1bed610ade55e1c.value))($fb26133a5ec46bf7$var$pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value)));
    };
};
var $fb26133a5ec46bf7$export$7a5825874deea16a = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable)($fb26133a5ec46bf7$var$alt)($05fb1b61396adfce$export$2b62a06a9fee979c("Nothing to parse"));
};
var $fb26133a5ec46bf7$var$chainr1$prime = function(p) {
    return function(f) {
        return function(a) {
            return $fb26133a5ec46bf7$var$alt($fb26133a5ec46bf7$var$bind(f)(function(f$prime) {
                return $fb26133a5ec46bf7$var$bind($fb26133a5ec46bf7$export$38a115df1905c022(p)(f))(function(a$prime) {
                    return $fb26133a5ec46bf7$var$pure(f$prime(a)(a$prime));
                });
            }))($fb26133a5ec46bf7$var$pure(a));
        };
    };
};
var $fb26133a5ec46bf7$export$38a115df1905c022 = function(p) {
    return function(f) {
        return $fb26133a5ec46bf7$var$bind(p)(function(a) {
            return $fb26133a5ec46bf7$var$chainr1$prime(p)(f)(a);
        });
    };
};
var $fb26133a5ec46bf7$export$d2a0d5a23b042780 = function(p) {
    return function(f) {
        return function(a) {
            return $fb26133a5ec46bf7$var$alt($fb26133a5ec46bf7$export$38a115df1905c022(p)(f))($fb26133a5ec46bf7$var$pure(a));
        };
    };
};
var $fb26133a5ec46bf7$var$chainl1$prime = function(p) {
    return function(f) {
        return function(a) {
            return $fb26133a5ec46bf7$var$alt($fb26133a5ec46bf7$var$bind(f)(function(f$prime) {
                return $fb26133a5ec46bf7$var$bind(p)(function(a$prime) {
                    return $fb26133a5ec46bf7$var$chainl1$prime(p)(f)(f$prime(a)(a$prime));
                });
            }))($fb26133a5ec46bf7$var$pure(a));
        };
    };
};
var $fb26133a5ec46bf7$export$3acf224bcd43567a = function(p) {
    return function(f) {
        return $fb26133a5ec46bf7$var$bind(p)(function(a) {
            return $fb26133a5ec46bf7$var$chainl1$prime(p)(f)(a);
        });
    };
};
var $fb26133a5ec46bf7$export$6f5833edc27e1eaa = function(p) {
    return function(f) {
        return function(a) {
            return $fb26133a5ec46bf7$var$alt($fb26133a5ec46bf7$export$3acf224bcd43567a(p)(f))($fb26133a5ec46bf7$var$pure(a));
        };
    };
};
var $fb26133a5ec46bf7$export$cf95c51b03f10bae = function(open) {
    return function(close) {
        return function(p) {
            return $fb26133a5ec46bf7$var$applyFirst($fb26133a5ec46bf7$var$applySecond(open)(p))(close);
        };
    };
};
var $fb26133a5ec46bf7$export$cb5d7aa1f0b188a7 = function(v) {
    return function(s) {
        var v1 = v(s);
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
            var $34 = s.position < v1.value0.suffix.position;
            if ($34) return new $7d4cccdf062a2261$export$19db0165690c701a(v1.value0);
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
                pos: s.position,
                error: "Consumed no input."
            });
        }
        return v1;
    };
};
var $fb26133a5ec46bf7$export$14badfee79ea396f = /* #__PURE__ */ function() {
    var $37 = $3d4fd987da5242ff$export$17771a97d85ba7eb($05fb1b61396adfce$export$5d06481b113f8de9)($05fb1b61396adfce$export$b1f0061631f50ac9);
    return function($38) {
        return $37($fb26133a5ec46bf7$export$cb5d7aa1f0b188a7($38));
    };
}();
var $fb26133a5ec46bf7$export$a6482580fab70c30 = function(p) {
    return $fb26133a5ec46bf7$var$apply($fb26133a5ec46bf7$var$map($fb26133a5ec46bf7$var$cons$prime)(p))($fb26133a5ec46bf7$export$14badfee79ea396f(p));
};
var $fb26133a5ec46bf7$export$30acb68292ba53d0 = function(p) {
    return function(sep) {
        return $fb26133a5ec46bf7$export$a6482580fab70c30($fb26133a5ec46bf7$var$applyFirst(p)(sep));
    };
};
var $fb26133a5ec46bf7$export$62391786201b0e3b = function(p) {
    return function(sep) {
        return $fb26133a5ec46bf7$var$alt($fb26133a5ec46bf7$var$mapFlipped($fb26133a5ec46bf7$export$30acb68292ba53d0(p)(sep))($ba51d599f79a6310$export$effcdbd76139450))($fb26133a5ec46bf7$var$voidLeft(sep)($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
    };
};
var $fb26133a5ec46bf7$export$617220f394cba247 = function(p) {
    return function(sep) {
        return $fb26133a5ec46bf7$var$bind(p)(function(a) {
            return $fb26133a5ec46bf7$var$bind($fb26133a5ec46bf7$export$14badfee79ea396f($fb26133a5ec46bf7$var$applySecond(sep)(p)))(function(as) {
                return $fb26133a5ec46bf7$var$pure($fb26133a5ec46bf7$var$cons$prime(a)(as));
            });
        });
    };
};
var $fb26133a5ec46bf7$export$a0228d318ff1a462 = function(p) {
    return function(sep) {
        return $fb26133a5ec46bf7$var$alt($fb26133a5ec46bf7$var$map($ba51d599f79a6310$export$effcdbd76139450)($fb26133a5ec46bf7$export$617220f394cba247(p)(sep)))($fb26133a5ec46bf7$var$pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
    };
};
var $fb26133a5ec46bf7$export$eddf5dbe069fa672 = function(p) {
    return function(end) {
        var ending = function(acc) {
            return $fb26133a5ec46bf7$var$bind(end)(function() {
                return $fb26133a5ec46bf7$var$pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10($ba51d599f79a6310$export$66c1ae025e96b4bc(acc)));
            });
        };
        var $$continue = function(acc) {
            return $fb26133a5ec46bf7$var$bind($fb26133a5ec46bf7$export$cb5d7aa1f0b188a7(p))(function(c) {
                return $fb26133a5ec46bf7$var$pure(new $f93520de2fa37b44$export$550acbd06a1f5a6a($ba51d599f79a6310$export$8327ebbef2a0ba76(c)(acc)));
            });
        };
        var inner = function(acc) {
            return $fb26133a5ec46bf7$var$alt(ending(acc))($$continue(acc));
        };
        return $fb26133a5ec46bf7$var$bind(p)(function(x) {
            return $fb26133a5ec46bf7$var$tailRecM(inner)($fb26133a5ec46bf7$var$pure1(x));
        });
    };
};
var $fb26133a5ec46bf7$export$cf7e1b47032e4a7c = function(p) {
    return function(end) {
        return $fb26133a5ec46bf7$var$alt($fb26133a5ec46bf7$var$applySecond(end)($fb26133a5ec46bf7$var$pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value)))($fb26133a5ec46bf7$var$map($ba51d599f79a6310$export$effcdbd76139450)($fb26133a5ec46bf7$export$eddf5dbe069fa672(p)(end)));
    };
};



var $c61d959c6f59055e$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $c61d959c6f59055e$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($05fb1b61396adfce$export$6a1d89187d209f74);
var $c61d959c6f59055e$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($05fb1b61396adfce$export$45def89472122d0b);
var $c61d959c6f59055e$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$def6059c21714f2a);
var $c61d959c6f59055e$var$elem = /* #__PURE__ */ $4fe7b6acfba7f29f$export$5bf96401662340b7($4fe7b6acfba7f29f$export$e97014618a7eb593)($37b880af5f4991bd$export$e65788c6d4494539);
var $c61d959c6f59055e$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($78c799cba34fcb8d$export$92659ee1fc91a075)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $c61d959c6f59055e$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($05fb1b61396adfce$export$6b86c7f1e16b91d2);
var $c61d959c6f59055e$export$22b082955e083ec3 = function(pattern) {
    return function(v) {
        var length = $092fe44bc0883be6$export$f24224f1c91d8156(pattern);
        var v1 = $092fe44bc0883be6$export$b0d75975ac0be0e1(length)(v.substring);
        var $36 = v1.before === pattern;
        if ($36) return new $7d4cccdf062a2261$export$19db0165690c701a({
            result: pattern,
            suffix: {
                substring: v1.after,
                position: v.position + length | 0
            }
        });
        return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
            pos: v.position,
            error: "Expected '" + (pattern + "'.")
        });
    };
};
var $c61d959c6f59055e$export$17b0f4d84dbfeedf = function(pat) {
    var pattern = "^(" + (pat + ")");
    var matchRegex = function(r) {
        return function(v) {
            var v1 = $c61d959c6f59055e$var$map($e39dfcf102cdca3c$export$5fd5031fecdacec3)($03be6cc86948e3c6$export$4659b591c19bdf3d(r)(v.substring));
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a({
                result: v1.value0.value0,
                suffix: {
                    substring: $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156(v1.value0.value0))(v.substring),
                    position: v.position + $092fe44bc0883be6$export$f24224f1c91d8156(v1.value0.value0) | 0
                }
            });
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
                pos: v.position,
                error: "no match"
            });
        };
    };
    var v = $03be6cc86948e3c6$export$17b0f4d84dbfeedf(pattern)($fb3071975af0bbe0$export$77e76a4721f88dfa);
    if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $05fb1b61396adfce$export$2b62a06a9fee979c("StringParser.String.regex': illegal regex " + pat);
    if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return matchRegex(v.value0);
    throw new Error("Failed pattern match at StringParser.CodeUnits (line 125, column 3 - line 129, column 19): " + [
        v.constructor.name
    ]);
};
var $c61d959c6f59055e$export$d83becf4b42ec59 = function(s) {
    if (0 < $092fe44bc0883be6$export$f24224f1c91d8156(s.substring)) return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
        pos: s.position,
        error: "Expected EOF"
    });
    return new $7d4cccdf062a2261$export$19db0165690c701a({
        result: $05149ea687d6b460$export$523c0b569236b342,
        suffix: s
    });
};
var $c61d959c6f59055e$export$3df35137cff8cab7 = function(v) {
    var v1 = $1a77d6934b592676$export$bbcf894add1d392c(0)(v.substring);
    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a({
        result: v1.value0,
        suffix: {
            substring: $092fe44bc0883be6$export$663103110d94aac9(1)(v.substring),
            position: v.position + 1 | 0
        }
    });
    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
        pos: v.position,
        error: "Unexpected EOF"
    });
    throw new Error("Failed pattern match at StringParser.CodeUnits (line 50, column 3 - line 52, column 63): " + [
        v1.constructor.name
    ]);
};
var $c61d959c6f59055e$export$f5c52be128ae1598 = /* #__PURE__ */ $fb26133a5ec46bf7$export$410a452afcd48948(/* #__PURE__ */ $c61d959c6f59055e$var$bind($c61d959c6f59055e$export$3df35137cff8cab7)(function(c) {
    var $58 = c >= "0" && c <= "9";
    if ($58) return $c61d959c6f59055e$var$pure(c);
    return $05fb1b61396adfce$export$2b62a06a9fee979c("Character " + ($c61d959c6f59055e$var$show(c) + " is not a digit"));
}));
var $c61d959c6f59055e$export$78f7c89684592086 = /* #__PURE__ */ $fb26133a5ec46bf7$export$410a452afcd48948(/* #__PURE__ */ $c61d959c6f59055e$var$bind($c61d959c6f59055e$export$3df35137cff8cab7)(function(c) {
    var $59 = $c61d959c6f59055e$var$elem($50b5a2f2b28bbba4$export$d90166409dd04e85(c))($396c4c3d9e7fae3c$export$d02631cccf789723(97)(122));
    if ($59) return $c61d959c6f59055e$var$pure(c);
    return $05fb1b61396adfce$export$2b62a06a9fee979c("Expected a lower case character but found " + $c61d959c6f59055e$var$show(c));
}));
var $c61d959c6f59055e$export$ec0bab193bdafe1 = function(f) {
    return $fb26133a5ec46bf7$export$410a452afcd48948($c61d959c6f59055e$var$bind($c61d959c6f59055e$export$3df35137cff8cab7)(function(c) {
        var $60 = f(c);
        if ($60) return $c61d959c6f59055e$var$pure(c);
        return $05fb1b61396adfce$export$2b62a06a9fee979c("Character " + ($c61d959c6f59055e$var$show(c) + " did not satisfy predicate"));
    }));
};
var $c61d959c6f59055e$export$eba6f6f03b0a92e7 = function(c) {
    return $fb26133a5ec46bf7$export$60e9e0884ce12b55($c61d959c6f59055e$export$ec0bab193bdafe1(function(v) {
        return v === c;
    }))("Could not match character " + $c61d959c6f59055e$var$show(c));
};
var $c61d959c6f59055e$export$2a75fb877f753830 = function(dictFoldable) {
    var $62 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($4fe7b6acfba7f29f$export$63faa62a0284a4a6(dictFoldable)($37b880af5f4991bd$export$bcd79f9321394c38));
    return function($63) {
        return $c61d959c6f59055e$export$ec0bab193bdafe1($62($63));
    };
};
var $c61d959c6f59055e$export$a9a18ae5ba42aeab = function(dictFoldable) {
    var $64 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($4fe7b6acfba7f29f$export$5bf96401662340b7(dictFoldable)($37b880af5f4991bd$export$bcd79f9321394c38));
    return function($65) {
        return $c61d959c6f59055e$export$ec0bab193bdafe1($64($65));
    };
};
var $c61d959c6f59055e$export$9ef81298ca34ad41 = /* #__PURE__ */ $c61d959c6f59055e$var$bind(/* #__PURE__ */ $fb26133a5ec46bf7$export$14badfee79ea396f(/* #__PURE__ */ $c61d959c6f59055e$export$ec0bab193bdafe1(function(c) {
    return c === "\n" || c === "\r" || c === " " || c === "	";
})))(function(cs) {
    return $c61d959c6f59055e$var$pure($c61d959c6f59055e$var$foldMap($092fe44bc0883be6$export$439306a4dcaafbb9)(cs));
});
var $c61d959c6f59055e$export$c85b81cf4e701929 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($05fb1b61396adfce$export$3634602ee36f7fe6)($c61d959c6f59055e$export$9ef81298ca34ad41);
var $c61d959c6f59055e$export$323d5c74498f85fe = /* #__PURE__ */ $fb26133a5ec46bf7$export$410a452afcd48948(/* #__PURE__ */ $c61d959c6f59055e$var$bind($c61d959c6f59055e$export$3df35137cff8cab7)(function(c) {
    var $61 = $c61d959c6f59055e$var$elem($50b5a2f2b28bbba4$export$d90166409dd04e85(c))($396c4c3d9e7fae3c$export$d02631cccf789723(65)(90));
    if ($61) return $c61d959c6f59055e$var$pure(c);
    return $05fb1b61396adfce$export$2b62a06a9fee979c("Expected an upper case character but found " + $c61d959c6f59055e$var$show(c));
}));
var $c61d959c6f59055e$export$897f7f9ae42c30f5 = /* #__PURE__ */ $c61d959c6f59055e$var$alt($c61d959c6f59055e$export$78f7c89684592086)(/* #__PURE__ */ $fb26133a5ec46bf7$export$60e9e0884ce12b55($c61d959c6f59055e$export$323d5c74498f85fe)("Expected a letter"));
var $c61d959c6f59055e$export$2f9d0d831d496619 = /* #__PURE__ */ $c61d959c6f59055e$var$alt($c61d959c6f59055e$export$897f7f9ae42c30f5)(/* #__PURE__ */ $fb26133a5ec46bf7$export$60e9e0884ce12b55($c61d959c6f59055e$export$f5c52be128ae1598)("Expected a letter or a number"));




var $9da596880af1a1c5$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($05fb1b61396adfce$export$6a1d89187d209f74);
var $9da596880af1a1c5$var$elem = /* #__PURE__ */ $4fe7b6acfba7f29f$export$5bf96401662340b7($4fe7b6acfba7f29f$export$e97014618a7eb593)($37b880af5f4991bd$export$e65788c6d4494539);
var $9da596880af1a1c5$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($05fb1b61396adfce$export$45def89472122d0b);
var $9da596880af1a1c5$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$def6059c21714f2a);
var $9da596880af1a1c5$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $9da596880af1a1c5$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($05fb1b61396adfce$export$6b86c7f1e16b91d2);
var $9da596880af1a1c5$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($3ee2158c14339cc9$export$1e278a1fb25ff338);
var $9da596880af1a1c5$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($3ee2158c14339cc9$export$e200a5917becef04);
var $9da596880af1a1c5$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $9da596880af1a1c5$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($78c799cba34fcb8d$export$92659ee1fc91a075)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $9da596880af1a1c5$export$323d5c74498f85fe = /* #__PURE__ */ $fb26133a5ec46bf7$export$410a452afcd48948(/* #__PURE__ */ $9da596880af1a1c5$var$bind($c61d959c6f59055e$export$3df35137cff8cab7)(function(c) {
    var $42 = $9da596880af1a1c5$var$elem($50b5a2f2b28bbba4$export$d90166409dd04e85(c))($396c4c3d9e7fae3c$export$d02631cccf789723(65)(90));
    if ($42) return $9da596880af1a1c5$var$pure(c);
    return $05fb1b61396adfce$export$2b62a06a9fee979c("Expected an upper case character but found " + $9da596880af1a1c5$var$show(c));
}));
var $9da596880af1a1c5$export$22b082955e083ec3 = function(pattern) {
    return function(v) {
        var length = $3ee2158c14339cc9$export$f24224f1c91d8156(pattern);
        var v1 = $3ee2158c14339cc9$export$b0d75975ac0be0e1(length)(v.substring);
        var $45 = v1.before === pattern;
        if ($45) return new $7d4cccdf062a2261$export$19db0165690c701a({
            result: pattern,
            suffix: {
                substring: v1.after,
                position: v.position + length | 0
            }
        });
        return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
            pos: v.position,
            error: "Expected '" + (pattern + "'.")
        });
    };
};
var $9da596880af1a1c5$export$17b0f4d84dbfeedf = function(pat) {
    var pattern = "^(" + (pat + ")");
    var matchRegex = function(r) {
        return function(v) {
            var v1 = $9da596880af1a1c5$var$map($e39dfcf102cdca3c$export$5fd5031fecdacec3)($03be6cc86948e3c6$export$4659b591c19bdf3d(r)(v.substring));
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a({
                result: v1.value0.value0,
                suffix: {
                    substring: $3ee2158c14339cc9$export$663103110d94aac9($3ee2158c14339cc9$export$f24224f1c91d8156(v1.value0.value0))(v.substring),
                    position: v.position + $3ee2158c14339cc9$export$f24224f1c91d8156(v1.value0.value0) | 0
                }
            });
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
                pos: v.position,
                error: "no match"
            });
        };
    };
    var v = $03be6cc86948e3c6$export$17b0f4d84dbfeedf(pattern)($fb3071975af0bbe0$export$77e76a4721f88dfa);
    if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $05fb1b61396adfce$export$2b62a06a9fee979c("StringParser.String.regex': illegal regex " + pat);
    if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return matchRegex(v.value0);
    throw new Error("Failed pattern match at StringParser.CodePoints (line 158, column 3 - line 162, column 19): " + [
        v.constructor.name
    ]);
};
var $9da596880af1a1c5$export$78f7c89684592086 = /* #__PURE__ */ $fb26133a5ec46bf7$export$410a452afcd48948(/* #__PURE__ */ $9da596880af1a1c5$var$bind($c61d959c6f59055e$export$3df35137cff8cab7)(function(c) {
    var $59 = $9da596880af1a1c5$var$elem($50b5a2f2b28bbba4$export$d90166409dd04e85(c))($396c4c3d9e7fae3c$export$d02631cccf789723(97)(122));
    if ($59) return $9da596880af1a1c5$var$pure(c);
    return $05fb1b61396adfce$export$2b62a06a9fee979c("Expected a lower case character but found " + $9da596880af1a1c5$var$show(c));
}));
var $9da596880af1a1c5$export$d83becf4b42ec59 = function(s) {
    if (0 < $3ee2158c14339cc9$export$f24224f1c91d8156(s.substring)) return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
        pos: s.position,
        error: "Expected EOF"
    });
    return new $7d4cccdf062a2261$export$19db0165690c701a({
        result: $05149ea687d6b460$export$523c0b569236b342,
        suffix: s
    });
};
var $9da596880af1a1c5$export$897f7f9ae42c30f5 = /* #__PURE__ */ $9da596880af1a1c5$var$alt($9da596880af1a1c5$export$78f7c89684592086)(/* #__PURE__ */ $fb26133a5ec46bf7$export$60e9e0884ce12b55($9da596880af1a1c5$export$323d5c74498f85fe)("Expected a letter"));
var $9da596880af1a1c5$export$f5c52be128ae1598 = /* #__PURE__ */ $fb26133a5ec46bf7$export$410a452afcd48948(/* #__PURE__ */ $9da596880af1a1c5$var$bind($c61d959c6f59055e$export$3df35137cff8cab7)(function(c) {
    var $63 = c >= "0" && c <= "9";
    if ($63) return $9da596880af1a1c5$var$pure(c);
    return $05fb1b61396adfce$export$2b62a06a9fee979c("Character " + ($9da596880af1a1c5$var$show(c) + " is not a digit"));
}));
var $9da596880af1a1c5$export$3eeefabf9b38b449 = function(v) {
    var v1 = $3ee2158c14339cc9$export$b446f6baa3bb1430(v.substring);
    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
        pos: v.position,
        error: "Unexpected EOF"
    });
    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a({
        result: v1.value0.head,
        suffix: {
            substring: v1.value0.tail,
            position: v.position + 1 | 0
        }
    });
    throw new Error("Failed pattern match at StringParser.CodePoints (line 72, column 3 - line 74, column 103): " + [
        v1.constructor.name
    ]);
};
var $9da596880af1a1c5$export$566aa36e2fcdcfb9 = function(f) {
    return $fb26133a5ec46bf7$export$410a452afcd48948($9da596880af1a1c5$var$bind($9da596880af1a1c5$export$3eeefabf9b38b449)(function(cp) {
        var $71 = f(cp);
        if ($71) return $9da596880af1a1c5$var$pure(cp);
        return $05fb1b61396adfce$export$2b62a06a9fee979c("Code point " + ($9da596880af1a1c5$var$show1(cp) + " did not satisfy predicate"));
    }));
};
var $9da596880af1a1c5$export$b77dcf7160a1d98a = function(c) {
    return $fb26133a5ec46bf7$export$60e9e0884ce12b55($9da596880af1a1c5$export$566aa36e2fcdcfb9(function(v) {
        return $9da596880af1a1c5$var$eq1(v)(c);
    }))("Could not match code point " + $9da596880af1a1c5$var$show1(c));
};
var $9da596880af1a1c5$export$3df35137cff8cab7 = /* #__PURE__ */ function() {
    var notAChar = function(cc) {
        return $05fb1b61396adfce$export$2b62a06a9fee979c("Code point " + ($9da596880af1a1c5$var$show2(cc) + " is not a character"));
    };
    return $9da596880af1a1c5$var$bind($f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a($05fb1b61396adfce$export$3634602ee36f7fe6)($9da596880af1a1c5$export$3eeefabf9b38b449)($f935a9866e211c00$export$b385cb642735011f($3ee2158c14339cc9$export$2a3400c6862992c1)))(function(cc) {
        var v = $50b5a2f2b28bbba4$export$30216c0101da0ee0(cc);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
            var $73 = cc > 65535;
            if ($73) return notAChar(cc);
            return $9da596880af1a1c5$var$pure(v.value0);
        }
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return notAChar(cc);
        throw new Error("Failed pattern match at StringParser.CodePoints (line 57, column 3 - line 65, column 27): " + [
            v.constructor.name
        ]);
    });
}();
var $9da596880af1a1c5$export$ec0bab193bdafe1 = function(f) {
    return $fb26133a5ec46bf7$export$410a452afcd48948($9da596880af1a1c5$var$bind($9da596880af1a1c5$export$3df35137cff8cab7)(function(c) {
        var $75 = f(c);
        if ($75) return $9da596880af1a1c5$var$pure(c);
        return $05fb1b61396adfce$export$2b62a06a9fee979c("Character " + ($9da596880af1a1c5$var$show(c) + " did not satisfy predicate"));
    }));
};
var $9da596880af1a1c5$export$eba6f6f03b0a92e7 = function(c) {
    return $fb26133a5ec46bf7$export$60e9e0884ce12b55($9da596880af1a1c5$export$ec0bab193bdafe1(function(v) {
        return v === c;
    }))("Could not match character " + $9da596880af1a1c5$var$show(c));
};
var $9da596880af1a1c5$export$2a75fb877f753830 = function(dictFoldable) {
    var $76 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($4fe7b6acfba7f29f$export$63faa62a0284a4a6(dictFoldable)($37b880af5f4991bd$export$bcd79f9321394c38));
    return function($77) {
        return $9da596880af1a1c5$export$ec0bab193bdafe1($76($77));
    };
};
var $9da596880af1a1c5$export$a9a18ae5ba42aeab = function(dictFoldable) {
    var $78 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($4fe7b6acfba7f29f$export$5bf96401662340b7(dictFoldable)($37b880af5f4991bd$export$bcd79f9321394c38));
    return function($79) {
        return $9da596880af1a1c5$export$ec0bab193bdafe1($78($79));
    };
};
var $9da596880af1a1c5$export$9ef81298ca34ad41 = /* #__PURE__ */ $9da596880af1a1c5$var$bind(/* #__PURE__ */ $fb26133a5ec46bf7$export$14badfee79ea396f(/* #__PURE__ */ $9da596880af1a1c5$export$ec0bab193bdafe1(function(c) {
    return c === "\n" || c === "\r" || c === " " || c === "	";
})))(function(cs) {
    return $9da596880af1a1c5$var$pure($9da596880af1a1c5$var$foldMap($092fe44bc0883be6$export$439306a4dcaafbb9)(cs));
});
var $9da596880af1a1c5$export$c85b81cf4e701929 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($05fb1b61396adfce$export$3634602ee36f7fe6)($9da596880af1a1c5$export$9ef81298ca34ad41);
var $9da596880af1a1c5$export$2f9d0d831d496619 = /* #__PURE__ */ $9da596880af1a1c5$var$alt($9da596880af1a1c5$export$897f7f9ae42c30f5)(/* #__PURE__ */ $fb26133a5ec46bf7$export$60e9e0884ce12b55($9da596880af1a1c5$export$f5c52be128ae1598)("Expected a letter or a number"));




var $9c51fc614470d5ef$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $9c51fc614470d5ef$var$readImpl = /* #__PURE__ */ $f505976c723c2a85$export$f6103847fe734e8($f505976c723c2a85$export$dda73877cb166cd3);
var $9c51fc614470d5ef$var$fail = /* #__PURE__ */ $c97d2d0f578f81ad$export$2b62a06a9fee979c($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $9c51fc614470d5ef$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $9c51fc614470d5ef$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($05fb1b61396adfce$export$6a1d89187d209f74);
var $9c51fc614470d5ef$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($05fb1b61396adfce$export$45def89472122d0b);
var $9c51fc614470d5ef$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$604c31769a93bbe0);
var $9c51fc614470d5ef$export$4eeb8640e70bb459 = function(dictNotation) {
    var parseNotation = $6416bd93bb20ed95$export$a1d30b4ebfb67400(dictNotation);
    return function(typ) {
        return function(input) {
            return $9c51fc614470d5ef$var$bind($9c51fc614470d5ef$var$readImpl(input))(function(str) {
                var v = parseNotation(str);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $9c51fc614470d5ef$var$fail(new $c97d2d0f578f81ad$export$f6a37cc43a8b8898("Cannot parse " + (str + (" as " + (typ + "!")))));
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $9c51fc614470d5ef$var$pure(v.value0);
                throw new Error("Failed pattern match at Data.Pitches.Internal (line 36, column 3 - line 38, column 21): " + [
                    v.constructor.name
                ]);
            });
        };
    };
};
var $9c51fc614470d5ef$var$ascii0 = /* #__PURE__ */ $50b5a2f2b28bbba4$export$d90166409dd04e85("0");
var $9c51fc614470d5ef$var$digit = function(d) {
    return $50b5a2f2b28bbba4$export$d90166409dd04e85(d) - $9c51fc614470d5ef$var$ascii0 | 0;
};
var $9c51fc614470d5ef$export$174cdaddec9e0332 = /* #__PURE__ */ $9c51fc614470d5ef$var$bind1(/* #__PURE__ */ $fb26133a5ec46bf7$export$a75d1723e6bda2ec("+")(/* #__PURE__ */ $9da596880af1a1c5$export$eba6f6f03b0a92e7("-")))(function(signChar) {
    var sign = function() {
        var $20 = signChar === "-";
        if ($20) return -1;
        return 1;
    }();
    return $9c51fc614470d5ef$var$bind1($fb26133a5ec46bf7$export$a6482580fab70c30($9da596880af1a1c5$export$f5c52be128ae1598))(function(dgts) {
        return $9c51fc614470d5ef$var$pure1(sign * $9c51fc614470d5ef$var$foldl(function(acc) {
            return function(d) {
                return (10 * acc | 0) + $9c51fc614470d5ef$var$digit(d) | 0;
            };
        })(0)(dgts) | 0);
    });
});
var $9c51fc614470d5ef$export$5eb46e8ce08641d5 = /* #__PURE__ */ $9c51fc614470d5ef$var$bind1(/* #__PURE__ */ $fb26133a5ec46bf7$export$a6482580fab70c30($9da596880af1a1c5$export$f5c52be128ae1598))(function(dgts) {
    return $9c51fc614470d5ef$var$pure1($9c51fc614470d5ef$var$foldl(function(acc) {
        return function(d) {
            return (10 * acc | 0) + $9c51fc614470d5ef$var$digit(d) | 0;
        };
    })(0)(dgts));
});










// Generated by purs version 0.15.15




// Generated by purs version 0.15.15
var $f38acfbf15955b73$export$c1c8be52b85daeca = function(dict) {
    return dict.sized;
};
var $f38acfbf15955b73$export$4380c87abf28fdf = function(dict) {
    return dict.resize;
};
var $f38acfbf15955b73$export$24b3f9c3c8227daa = function(dict) {
    return dict.chooseInt;
};
var $f38acfbf15955b73$export$73d56bd430e66c0c = function(dict) {
    return dict.chooseFloat;
};
var $f38acfbf15955b73$export$ed1be54c7ccedf5b = function(dict) {
    return dict.chooseBool;
};


// Generated by purs version 0.15.15



// Generated by purs version 0.15.15











// Generated by purs version 0.15.15



var $19578e25953179c0$export$bed9238d8933c9a8 = function(x) {
    return x;
};
var $19578e25953179c0$export$1e0d830d3054d46d = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Last " + (show(v) + ")");
        }
    };
};
var $19578e25953179c0$export$6d3c4648150c5bae = {
    append: function(v) {
        return function(x) {
            return x;
        };
    }
};
var $19578e25953179c0$export$4ded69d4b0c99b7b = function(dictOrd) {
    return dictOrd;
};
var $19578e25953179c0$export$74aba74241121413 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $19578e25953179c0$export$4dd70ef4fbe4d1f3 = function(dictEq) {
    return dictEq;
};
var $19578e25953179c0$export$634a54207b73ac14 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($19578e25953179c0$export$4dd70ef4fbe4d1f3(dictEq));
    }
};
var $19578e25953179c0$export$64bd44ceff2f4638 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($19578e25953179c0$export$4ded69d4b0c99b7b(dictOrd));
    },
    Eq10: function() {
        return $19578e25953179c0$export$634a54207b73ac14;
    }
};
var $19578e25953179c0$export$835f68c2f339b021 = function(dictBounded) {
    return dictBounded;
};
var $19578e25953179c0$export$dcd798c84777f95 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $19578e25953179c0$export$74aba74241121413;
    }
};
var $19578e25953179c0$export$f2b93d1f1ac78d51 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $19578e25953179c0$export$dcd798c84777f95;
    }
};
var $19578e25953179c0$export$5b4de68c5dd33934 = {
    pure: $19578e25953179c0$export$bed9238d8933c9a8,
    Apply0: function() {
        return $19578e25953179c0$export$dcd798c84777f95;
    }
};
var $19578e25953179c0$export$25d122cd3cbaf721 = {
    Applicative0: function() {
        return $19578e25953179c0$export$5b4de68c5dd33934;
    },
    Bind1: function() {
        return $19578e25953179c0$export$f2b93d1f1ac78d51;
    }
};






var $6482d98559452a87$var$un = /* #__PURE__ */ $4fa4836228a192cc$export$a2a39c9747f0e54a();
var $6482d98559452a87$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $6482d98559452a87$var$monoidAdditive = /* #__PURE__ */ $e48f2e41a907ae60$export$c38b62d29991685f($c0e822be92afc4df$export$f48694d6539477b9);
var $6482d98559452a87$var$Cons = /* #__PURE__ */ function() {
    function Cons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons.create = function(value0) {
        return function(value1) {
            return new Cons(value0, value1);
        };
    };
    return Cons;
}();
var $6482d98559452a87$var$Nil = /* #__PURE__ */ function() {
    function Nil() {}
    Nil.value = new Nil();
    return Nil;
}();
var $6482d98559452a87$var$FreqSemigroup = function(x) {
    return x;
};
var $6482d98559452a87$export$62262501c20ccc48 = function(dictMonadRec) {
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(dictMonadGen) {
        var Monad0 = dictMonadGen.Monad0();
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
        var Bind1 = Monad0.Bind1();
        var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Bind1.Apply0().Functor0());
        var sized = $f38acfbf15955b73$export$c1c8be52b85daeca(dictMonadGen);
        return function(dictUnfoldable) {
            var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
            return function(gen) {
                var unfold = function(v) {
                    if (v instanceof $6482d98559452a87$var$Nil) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    if (v instanceof $6482d98559452a87$var$Cons) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, v.value1));
                    throw new Error("Failed pattern match at Control.Monad.Gen (line 102, column 12 - line 104, column 35): " + [
                        v.constructor.name
                    ]);
                };
                var loopGen = function(v) {
                    if (v.value1 <= 0) return pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10(v.value0));
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return bind(gen)(function(x) {
                        return pure(new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $6482d98559452a87$var$Cons(x, v.value0), v.value1 - 1 | 0)));
                    });
                    throw new Error("Failed pattern match at Control.Monad.Gen (line 94, column 3 - line 94, column 68): " + [
                        v.constructor.name
                    ]);
                };
                return map(unfoldr(unfold))(sized(function() {
                    var $126 = tailRecM(loopGen);
                    var $127 = $71f2e2e9476163f8$export$1908877435b1d5e9.create($6482d98559452a87$var$Nil.value);
                    return function($128) {
                        return $126($127($128));
                    };
                }()));
            };
        };
    };
};
var $6482d98559452a87$var$semigroupFreqSemigroup = {
    append: function(v) {
        return function(v1) {
            return function(pos) {
                var v2 = v(pos);
                if (v2.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v2.value0.value0);
                return v2;
            };
        };
    }
};
var $6482d98559452a87$var$getFreqVal = function(v) {
    return function($129) {
        return $71f2e2e9476163f8$export$6f71268a1666ab58(v($129));
    };
};
var $6482d98559452a87$var$fromIndex = function(dictFoldable1) {
    var foldMap1 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($19578e25953179c0$export$6d3c4648150c5bae);
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1.Foldable0());
    return function(i) {
        return function(xs) {
            var go = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v1 instanceof $6482d98559452a87$var$Cons && v1.value1 instanceof $6482d98559452a87$var$Nil) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $6482d98559452a87$var$Cons && v <= 0) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $6482d98559452a87$var$Cons) {
                            $tco_var_v = v - 1 | 0;
                            $copy_v1 = v1.value1;
                            return;
                        }
                        if (v1 instanceof $6482d98559452a87$var$Nil) {
                            $tco_done = true;
                            return $6482d98559452a87$var$un($19578e25953179c0$export$bed9238d8933c9a8)(foldMap1($19578e25953179c0$export$bed9238d8933c9a8)(xs));
                        }
                        throw new Error("Failed pattern match at Control.Monad.Gen (line 128, column 5 - line 128, column 26): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            return go(i)(foldr($6482d98559452a87$var$Cons.create)($6482d98559452a87$var$Nil.value)(xs));
        };
    };
};
var $6482d98559452a87$export$a9a18ae5ba42aeab = function(dictMonadGen) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonadGen.Monad0().Bind1());
    var chooseInt = $f38acfbf15955b73$export$24b3f9c3c8227daa(dictMonadGen);
    return function(dictFoldable1) {
        var length = $4fe7b6acfba7f29f$export$f24224f1c91d8156(dictFoldable1.Foldable0())($c0e822be92afc4df$export$7e80d6910c05bd77);
        var fromIndex1 = $6482d98559452a87$var$fromIndex(dictFoldable1);
        return function(xs) {
            return bind(chooseInt(0)(length(xs) - 1 | 0))(function(n) {
                return fromIndex1(n)(xs);
            });
        };
    };
};
var $6482d98559452a87$var$freqSemigroup = function(v) {
    return function(pos) {
        var $119 = pos >= v.value0;
        if ($119) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $06733ae99ed4f534$export$8a67b48435b5d073(pos - v.value0), v.value1);
        return new $71f2e2e9476163f8$export$1908877435b1d5e9($06733ae99ed4f534$export$bebe9059409a0d04.value, v.value1);
    };
};
var $6482d98559452a87$export$7ca27958f28e2974 = function(dictMonadGen) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonadGen.Monad0().Bind1());
    var chooseFloat = $f38acfbf15955b73$export$73d56bd430e66c0c(dictMonadGen);
    return function(dictFoldable1) {
        var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1.Foldable0())($6482d98559452a87$var$monoidAdditive);
        var foldMap1 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($6482d98559452a87$var$semigroupFreqSemigroup);
        return function(xs) {
            var total = $6482d98559452a87$var$alaF($e48f2e41a907ae60$export$14f8ce08180a98e1)(foldMap)($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(xs);
            return bind(chooseFloat(0.0)(total))($6482d98559452a87$var$getFreqVal(foldMap1($6482d98559452a87$var$freqSemigroup)(xs)));
        };
    };
};
var $6482d98559452a87$export$8082fa36f85e6b63 = function(dictMonadRec) {
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(dictMonadGen) {
        var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictMonadGen.Monad0().Bind1().Apply0().Functor0());
        return function(gen) {
            var go = function(v) {
                return mapFlipped(gen)(function(a) {
                    if (a instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$550acbd06a1f5a6a($05149ea687d6b460$export$523c0b569236b342);
                    if (a instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(a.value0);
                    throw new Error("Failed pattern match at Control.Monad.Gen (line 118, column 24 - line 120, column 23): " + [
                        a.constructor.name
                    ]);
                });
            };
            return tailRecM(go)($05149ea687d6b460$export$523c0b569236b342);
        };
    };
};
var $6482d98559452a87$export$a7e2a49ace6c34c5 = function(dictMonadRec) {
    var filtered1 = $6482d98559452a87$export$8082fa36f85e6b63(dictMonadRec);
    return function(dictMonadGen) {
        var filtered2 = filtered1(dictMonadGen);
        var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictMonadGen.Monad0().Bind1().Apply0().Functor0());
        return function(gen) {
            return function(pred) {
                return filtered2(mapFlipped(gen)(function(a) {
                    var $124 = pred(a);
                    if ($124) return new $06733ae99ed4f534$export$8a67b48435b5d073(a);
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }));
            };
        };
    };
};
var $6482d98559452a87$export$7a5d735b2ab6389d = function(dictMonadGen) {
    var Monad0 = dictMonadGen.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var chooseInt = $f38acfbf15955b73$export$24b3f9c3c8227daa(dictMonadGen);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(dictFoldable1) {
        var length = $4fe7b6acfba7f29f$export$f24224f1c91d8156(dictFoldable1.Foldable0())($c0e822be92afc4df$export$7e80d6910c05bd77);
        var fromIndex1 = $6482d98559452a87$var$fromIndex(dictFoldable1);
        return function(xs) {
            return bind(chooseInt(0)(length(xs) - 1 | 0))(function(n) {
                return pure(fromIndex1(n)(xs));
            });
        };
    };
};
var $6482d98559452a87$export$7877a478dd30fd3d = function(dictMonadGen) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonadGen.Monad0().Bind1());
    var chooseBool = $f38acfbf15955b73$export$ed1be54c7ccedf5b(dictMonadGen);
    return function(genA) {
        return function(genB) {
            return bind(chooseBool)(function(v) {
                if (v) return genA;
                return genB;
            });
        };
    };
};










var $26405903fe88aca2$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$ff461bf68e7dd332);
var $26405903fe88aca2$export$5da10dd25b2cdff0 = function(dictApply) {
    return $7576d3a958d66ab0$export$f016650e64b51e7d(dictApply)($71f2e2e9476163f8$export$1908877435b1d5e9.create);
};
var $26405903fe88aca2$export$732372634357300 = function(dictMonadRec) {
    var unfoldable = $6482d98559452a87$export$62262501c20ccc48(dictMonadRec);
    return function(dictMonadGen) {
        var Apply0 = dictMonadGen.Monad0().Bind1().Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var resize = $f38acfbf15955b73$export$4380c87abf28fdf(dictMonadGen);
        var unfoldable1 = unfoldable(dictMonadGen);
        return function(dictUnfoldable) {
            var unfoldable2 = unfoldable1(dictUnfoldable);
            return function(gen) {
                return apply(map($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(gen))(resize(function() {
                    var $46 = $26405903fe88aca2$var$max(0);
                    return function($47) {
                        return $46(function(v) {
                            return v - 1 | 0;
                        }($47));
                    };
                }())(unfoldable2(gen)));
            };
        };
    };
};
var $26405903fe88aca2$export$8066ddf427d75627 = function(dictMonadGen) {
    var Monad0 = dictMonadGen.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var chooseFloat = $f38acfbf15955b73$export$73d56bd430e66c0c(dictMonadGen);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Bind1.Apply0().Functor0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(bias) {
        return function(gen) {
            return bind(chooseFloat(0.0)(1.0))(function(n) {
                var $44 = n < bias;
                if ($44) return map($06733ae99ed4f534$export$8a67b48435b5d073.create)(gen);
                return pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
            });
        };
    };
};
var $26405903fe88aca2$export$814577261e602aa0 = function(dictMonadGen) {
    return $26405903fe88aca2$export$8066ddf427d75627(dictMonadGen)(0.75);
};
var $26405903fe88aca2$export$8f75a736eace88f7 = function(dictFunctor) {
    return $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($50c50d1f444e5fa4$export$544bf02140fa9a77);
};
var $26405903fe88aca2$export$37745582fe1e869a = function(dictMonadGen) {
    var Bind1 = dictMonadGen.Monad0().Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var chooseFloat = $f38acfbf15955b73$export$73d56bd430e66c0c(dictMonadGen);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Bind1.Apply0().Functor0());
    return function(bias) {
        return function(genA) {
            return function(genB) {
                return bind(chooseFloat(0.0)(1.0))(function(n) {
                    var $45 = n < bias;
                    if ($45) return map($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(genA);
                    return map($7d4cccdf062a2261$export$19db0165690c701a.create)(genB);
                });
            };
        };
    };
};
var $26405903fe88aca2$export$4c044f8c47b13786 = function(dictMonadGen) {
    return $26405903fe88aca2$export$37745582fe1e869a(dictMonadGen)(0.5);
};














// Generated by purs version 0.15.15
const $99af8ad7682e39c7$export$260e5c0943f31606 = function(thunk) {
    var v = null;
    return function() {
        if (thunk === undefined) return v;
        v = thunk();
        thunk = undefined; // eslint-disable-line no-param-reassign
        return v;
    };
};
const $99af8ad7682e39c7$export$4d82290515cd0ddb = function(l) {
    return l();
};



















var $73aa5dd1904ebcb7$export$bb0ce398898c1c48 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(x) {
            return "(defer \\_ -> " + (show($99af8ad7682e39c7$export$4d82290515cd0ddb(x)) + ")");
        }
    };
};
var $73aa5dd1904ebcb7$export$a23c81c7931f53a = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    var one = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
    return {
        add: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return add($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        zero: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return zero;
        }),
        mul: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return mul($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        one: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return one;
        })
    };
};
var $73aa5dd1904ebcb7$export$8400f884b0cf16b1 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return append1($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        }
    };
};
var $73aa5dd1904ebcb7$export$6dfc43186b725e5c = function(dictRing) {
    var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var semiringLazy1 = $73aa5dd1904ebcb7$export$a23c81c7931f53a(dictRing.Semiring0());
    return {
        sub: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return sub($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        Semiring0: function() {
            return semiringLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$fe3e07ed2de45f8f = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var semigroupLazy1 = $73aa5dd1904ebcb7$export$8400f884b0cf16b1(dictMonoid.Semigroup0());
    return {
        mempty: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return mempty;
        }),
        Semigroup0: function() {
            return semigroupLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$56fd27feb83d90f5 = {
    defer: function(f) {
        return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return $99af8ad7682e39c7$export$4d82290515cd0ddb(f($05149ea687d6b460$export$523c0b569236b342));
        });
    }
};
var $73aa5dd1904ebcb7$export$3780b8670d5f24f8 = {
    map: function(f) {
        return function(l) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            });
        };
    }
};
var $73aa5dd1904ebcb7$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($73aa5dd1904ebcb7$export$3780b8670d5f24f8);
var $73aa5dd1904ebcb7$export$8f588843775274ce = {
    mapWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$map(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$export$3bd0a60cfec06f1a = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($73aa5dd1904ebcb7$export$3780b8670d5f24f8)
};
var $73aa5dd1904ebcb7$export$6ad686e404b9cd02 = {
    foldr: function(f) {
        return function(z) {
            return function(l) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l))(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(l) {
                return f(z)($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(l) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            };
        };
    }
};
var $73aa5dd1904ebcb7$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$export$c99a011ac0d986c7 = {
    foldrWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$foldr(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$foldl(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap1 = $73aa5dd1904ebcb7$var$foldMap(dictMonoid);
        return function(f) {
            return foldMap1(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$export$d75b77350c4c9111 = {
    traverse: function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(l) {
                return map1(function($103) {
                    return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($103));
                })(f($99af8ad7682e39c7$export$4d82290515cd0ddb(l)));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(l) {
            return map1(function($104) {
                return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($104));
            })($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    },
    Foldable1: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($73aa5dd1904ebcb7$export$d75b77350c4c9111);
var $73aa5dd1904ebcb7$export$1c9f73288a97bff6 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse1 = $73aa5dd1904ebcb7$var$traverse(dictApplicative);
        return function(f) {
            return traverse1(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $73aa5dd1904ebcb7$export$8f588843775274ce;
    },
    FoldableWithIndex1: function() {
        return $73aa5dd1904ebcb7$export$c99a011ac0d986c7;
    },
    Traversable2: function() {
        return $73aa5dd1904ebcb7$export$d75b77350c4c9111;
    }
};
var $73aa5dd1904ebcb7$export$8d84e581926eaeba = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(l) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            };
        };
    },
    foldr1: function(v) {
        return function(l) {
            return $99af8ad7682e39c7$export$4d82290515cd0ddb(l);
        };
    },
    foldl1: function(v) {
        return function(l) {
            return $99af8ad7682e39c7$export$4d82290515cd0ddb(l);
        };
    },
    Foldable0: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$export$316fa2792966d831 = {
    traverse1: function(dictApply) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(l) {
                return map1(function($105) {
                    return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($105));
                })(f($99af8ad7682e39c7$export$4d82290515cd0ddb(l)));
            };
        };
    },
    sequence1: function(dictApply) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(l) {
            return map1(function($106) {
                return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($106));
            })($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
        };
    },
    Foldable10: function() {
        return $73aa5dd1904ebcb7$export$8d84e581926eaeba;
    },
    Traversable1: function() {
        return $73aa5dd1904ebcb7$export$d75b77350c4c9111;
    }
};
var $73aa5dd1904ebcb7$export$5db1a0137683eb80 = {
    extend: function(f) {
        return function(x) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return f(x);
            });
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$export$1c9d1a32b20e91d5 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                return eq($99af8ad7682e39c7$export$4d82290515cd0ddb(x))($99af8ad7682e39c7$export$4d82290515cd0ddb(y));
            };
        }
    };
};
var $73aa5dd1904ebcb7$export$cbabaf21b7e8b5db = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqLazy1 = $73aa5dd1904ebcb7$export$1c9d1a32b20e91d5(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare($99af8ad7682e39c7$export$4d82290515cd0ddb(x))($99af8ad7682e39c7$export$4d82290515cd0ddb(y));
            };
        },
        Eq0: function() {
            return eqLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$4fb3dc255b34fa12 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($73aa5dd1904ebcb7$export$1c9d1a32b20e91d5(dictEq));
    }
};
var $73aa5dd1904ebcb7$export$d65b504a31b57308 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($73aa5dd1904ebcb7$export$cbabaf21b7e8b5db(dictOrd));
    },
    Eq10: function() {
        return $73aa5dd1904ebcb7$export$4fb3dc255b34fa12;
    }
};
var $73aa5dd1904ebcb7$export$544fccaec3eca1d4 = {
    extract: $99af8ad7682e39c7$export$4d82290515cd0ddb,
    Extend0: function() {
        return $73aa5dd1904ebcb7$export$5db1a0137683eb80;
    }
};
var $73aa5dd1904ebcb7$export$b0aa908a8262dbd4 = function(dictCommutativeRing) {
    var ringLazy1 = $73aa5dd1904ebcb7$export$6dfc43186b725e5c(dictCommutativeRing.Ring0());
    return {
        Ring0: function() {
            return ringLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$d150da49d30e2076 = function(dictEuclideanRing) {
    var div = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
    var mod = $b0cd729514c2504e$export$842a2cf37af977e1(dictEuclideanRing);
    var commutativeRingLazy1 = $73aa5dd1904ebcb7$export$b0aa908a8262dbd4(dictEuclideanRing.CommutativeRing0());
    return {
        degree: function() {
            var $107 = $b0cd729514c2504e$export$a23b7da4bc008930(dictEuclideanRing);
            return function($108) {
                return $107($99af8ad7682e39c7$export$4d82290515cd0ddb($108));
            };
        }(),
        div: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return div($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        mod: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return mod($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        CommutativeRing0: function() {
            return commutativeRingLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$aabc837ad904b190 = function(dictBounded) {
    var top = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
    var bottom = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    var ordLazy1 = $73aa5dd1904ebcb7$export$cbabaf21b7e8b5db(dictBounded.Ord0());
    return {
        top: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return top;
        }),
        bottom: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return bottom;
        }),
        Ord0: function() {
            return ordLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$c3ec2aebe6109e81 = {
    apply: function(f) {
        return function(x) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return $99af8ad7682e39c7$export$4d82290515cd0ddb(f)($99af8ad7682e39c7$export$4d82290515cd0ddb(x));
            });
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($73aa5dd1904ebcb7$export$c3ec2aebe6109e81);
var $73aa5dd1904ebcb7$export$e1a4485e8a67faf2 = {
    bind: function(l) {
        return function(f) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return $99af8ad7682e39c7$export$4d82290515cd0ddb(f($99af8ad7682e39c7$export$4d82290515cd0ddb(l)));
            });
        };
    },
    Apply0: function() {
        return $73aa5dd1904ebcb7$export$c3ec2aebe6109e81;
    }
};
var $73aa5dd1904ebcb7$export$89956d4f263e939b = function(dictHeytingAlgebra) {
    var ff = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
    var tt = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
    var implies = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var not = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
    return {
        ff: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return ff;
        }),
        tt: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return tt;
        }),
        implies: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(implies)(a))(b);
            };
        },
        conj: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(conj)(a))(b);
            };
        },
        disj: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(disj)(a))(b);
            };
        },
        not: function(a) {
            return $73aa5dd1904ebcb7$var$map(not)(a);
        }
    };
};
var $73aa5dd1904ebcb7$export$27ff7cba27a505be = function(dictBooleanAlgebra) {
    var heytingAlgebraLazy1 = $73aa5dd1904ebcb7$export$89956d4f263e939b(dictBooleanAlgebra.HeytingAlgebra0());
    return {
        HeytingAlgebra0: function() {
            return heytingAlgebraLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$28587442a46d4141 = {
    pure: function(a) {
        return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return a;
        });
    },
    Apply0: function() {
        return $73aa5dd1904ebcb7$export$c3ec2aebe6109e81;
    }
};
var $73aa5dd1904ebcb7$export$cfa2e2b570f2d5d3 = {
    Applicative0: function() {
        return $73aa5dd1904ebcb7$export$28587442a46d4141;
    },
    Bind1: function() {
        return $73aa5dd1904ebcb7$export$e1a4485e8a67faf2;
    }
};













// Generated by purs version 0.15.15



var $6c6a555e6244fc9c$export$b25abba66f7be210 = function(x) {
    return x;
};
var $6c6a555e6244fc9c$export$20f833961f1940c8 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(First " + (show(v) + ")");
        }
    };
};
var $6c6a555e6244fc9c$export$53ff158b23f5d382 = {
    append: function(x) {
        return function(v) {
            return x;
        };
    }
};
var $6c6a555e6244fc9c$export$4d7d8eedf770f0 = function(dictOrd) {
    return dictOrd;
};
var $6c6a555e6244fc9c$export$98d9d13e8b5bfe4d = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $6c6a555e6244fc9c$export$8232f15b0b41395c = function(dictEq) {
    return dictEq;
};
var $6c6a555e6244fc9c$export$1a969f11cd8a353e = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($6c6a555e6244fc9c$export$8232f15b0b41395c(dictEq));
    }
};
var $6c6a555e6244fc9c$export$f6a5e365037ccf9a = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($6c6a555e6244fc9c$export$4d7d8eedf770f0(dictOrd));
    },
    Eq10: function() {
        return $6c6a555e6244fc9c$export$1a969f11cd8a353e;
    }
};
var $6c6a555e6244fc9c$export$315f32b6f78e2785 = function(dictBounded) {
    return dictBounded;
};
var $6c6a555e6244fc9c$export$e48e2da4536c2eea = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $6c6a555e6244fc9c$export$98d9d13e8b5bfe4d;
    }
};
var $6c6a555e6244fc9c$export$456f8570baa6024f = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $6c6a555e6244fc9c$export$e48e2da4536c2eea;
    }
};
var $6c6a555e6244fc9c$export$178f5831973b2ff8 = {
    pure: $6c6a555e6244fc9c$export$b25abba66f7be210,
    Apply0: function() {
        return $6c6a555e6244fc9c$export$e48e2da4536c2eea;
    }
};
var $6c6a555e6244fc9c$export$e17b0506de713d2e = {
    Applicative0: function() {
        return $6c6a555e6244fc9c$export$178f5831973b2ff8;
    },
    Bind1: function() {
        return $6c6a555e6244fc9c$export$456f8570baa6024f;
    }
};





// Generated by purs version 0.15.15




// Generated by purs version 0.15.15











var $5505a3400147efbd$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $5505a3400147efbd$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($06733ae99ed4f534$export$e5fea5661dee377);
var $5505a3400147efbd$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $5505a3400147efbd$export$5e0a9ee3d3833c14 = function(x) {
    return x;
};
var $5505a3400147efbd$export$b6a781e0c851762d = function(x) {
    return x;
};
var $5505a3400147efbd$export$43df7fc17cca38a4 = function(v) {
    return $5b07e36f812dd04b$export$43df7fc17cca38a4(v);
};
var $5505a3400147efbd$export$f84e8e69fd4488a5 = function(v) {
    return v;
};
var $5505a3400147efbd$export$b1ceac3893cbda6b = function(v) {
    return $5b07e36f812dd04b$export$b1ceac3893cbda6b(v);
};
var $5505a3400147efbd$export$9c23a244a4c30cab = {
    show: function(v) {
        return "(NonEmptyString.unsafeFromString " + ($5505a3400147efbd$var$show(v) + ")");
    }
};
var $5505a3400147efbd$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($5505a3400147efbd$export$9c23a244a4c30cab);
var $5505a3400147efbd$export$744c07e924c63a64 = {
    show: function(v) {
        return "(NonEmptyReplacement " + ($5505a3400147efbd$var$show1(v) + ")");
    }
};
var $5505a3400147efbd$export$d35c69c74cf52f2a = $d7bf9817a417d4ae$export$d9b7100b101f2c5b;
var $5505a3400147efbd$export$f2627aa412761e90 = $5505a3400147efbd$export$d35c69c74cf52f2a;
var $5505a3400147efbd$export$b8b3234b4edfc4c2 = function(pat) {
    return function(v) {
        return function(v1) {
            return $5b07e36f812dd04b$export$b8b3234b4edfc4c2(pat)(v)(v1);
        };
    };
};
var $5505a3400147efbd$export$77ad94ebf1c2b9ed = function(pat) {
    return function(v) {
        return function(v1) {
            return $5b07e36f812dd04b$export$77ad94ebf1c2b9ed(pat)(v)(v1);
        };
    };
};
var $5505a3400147efbd$export$8e478561c4b63c72 = function(s1) {
    return function(v) {
        return s1 + v;
    };
};
var $5505a3400147efbd$export$5dc47cd73bc6c69d = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $5505a3400147efbd$export$c5ad7bed4061c986 = $5505a3400147efbd$export$5dc47cd73bc6c69d;
var $5505a3400147efbd$export$17c9b383a1071b74 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return {
        nes: function(p) {
            return reflectSymbol(p);
        }
    };
};
var $5505a3400147efbd$export$1a8016356aadf775 = function(dict) {
    return dict.nes;
};
var $5505a3400147efbd$export$632efc9d6c44380 = function() {
    return {
        nes: function(v) {
            return "";
        }
    };
};
var $5505a3400147efbd$export$35652c12e6caefdf = function(v) {
    return function(v1) {
        return $22d4f8ab6946d33a$export$35652c12e6caefdf(v)(v1);
    };
};
var $5505a3400147efbd$export$d4df5207b384f835 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $5505a3400147efbd$export$9e6c3fdf667ac5ae = function(dictFoldable1) {
    var intercalate = $4fe7b6acfba7f29f$export$739ec22334c44788(dictFoldable1.Foldable0())($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
    return function(v) {
        var $59 = intercalate(v);
        return function($60) {
            return $5505a3400147efbd$export$5e0a9ee3d3833c14($59($60));
        };
    };
};
var $5505a3400147efbd$export$ec1dc8fbeea3467e = function(dictFoldable) {
    var intercalate = $4fe7b6acfba7f29f$export$739ec22334c44788(dictFoldable)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
    return function(splice) {
        var $61 = intercalate(splice);
        return function($62) {
            return $61($62);
        };
    };
};
var $5505a3400147efbd$export$f542ede54c0f0952 = function(dictFoldable1) {
    var joinWith2 = $5505a3400147efbd$export$ec1dc8fbeea3467e(dictFoldable1.Foldable0());
    return function(splice) {
        var $63 = joinWith2(splice);
        return function($64) {
            return $5505a3400147efbd$export$5e0a9ee3d3833c14($63($64));
        };
    };
};
var $5505a3400147efbd$export$3004f64547af360e = function(v) {
    if (v === "") return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    return new $06733ae99ed4f534$export$8a67b48435b5d073(v);
};
var $5505a3400147efbd$export$71c2a1babd78d286 = function(pat) {
    return $5505a3400147efbd$var$composeKleisliFlipped($5505a3400147efbd$export$3004f64547af360e)($5505a3400147efbd$export$d4df5207b384f835($1a77d6934b592676$export$71c2a1babd78d286(pat)));
};
var $5505a3400147efbd$export$cc5663efaab5bcf6 = function(pat) {
    return $5505a3400147efbd$var$composeKleisliFlipped($5505a3400147efbd$export$3004f64547af360e)($5505a3400147efbd$export$d4df5207b384f835($1a77d6934b592676$export$cc5663efaab5bcf6(pat)));
};
var $5505a3400147efbd$export$87c2784dc9fc4ab = function(v) {
    return $5505a3400147efbd$export$3004f64547af360e($5b07e36f812dd04b$export$87c2784dc9fc4ab(v));
};
var $5505a3400147efbd$export$6c65599023ae894b = function() {
    return function($65) {
        return $5505a3400147efbd$var$fromJust($5505a3400147efbd$export$3004f64547af360e($65));
    };
};
var $5505a3400147efbd$export$5982362881026796 = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $5505a3400147efbd$export$db52a218b305ccab = $5505a3400147efbd$export$5982362881026796;
var $5505a3400147efbd$export$2344b14b097df817 = function($66) {
    return $5505a3400147efbd$export$d4df5207b384f835($1a77d6934b592676$export$2344b14b097df817($66));
};
var $5505a3400147efbd$export$8c3d57ec79c4009e = function(v) {
    return function(s2) {
        return v + s2;
    };
};



var $be985434983c0a5f$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $be985434983c0a5f$var$toNonEmptyString = $5505a3400147efbd$export$5e0a9ee3d3833c14;
var $be985434983c0a5f$export$c40cf5aab899f397 = function(c) {
    return function(s) {
        return $be985434983c0a5f$var$toNonEmptyString(s + $092fe44bc0883be6$export$439306a4dcaafbb9(c));
    };
};
var $be985434983c0a5f$export$439306a4dcaafbb9 = function($23) {
    return $be985434983c0a5f$var$toNonEmptyString($092fe44bc0883be6$export$439306a4dcaafbb9($23));
};
var $be985434983c0a5f$var$liftS = function(f) {
    return function(v) {
        return f(v);
    };
};
var $be985434983c0a5f$export$9384c7afe4015e42 = function(f) {
    var $24 = $be985434983c0a5f$var$liftS($1a77d6934b592676$export$9384c7afe4015e42(f));
    return function($25) {
        return $5505a3400147efbd$export$3004f64547af360e($24($25));
    };
};
var $be985434983c0a5f$export$9dc3eed83bb14216 = function(pat) {
    var $26 = $1a77d6934b592676$export$9dc3eed83bb14216(pat);
    return function($27) {
        return $be985434983c0a5f$var$liftS($26($27));
    };
};
var $be985434983c0a5f$export$557cfb7ed375eeb7 = function($28) {
    return $be985434983c0a5f$var$liftS($1a77d6934b592676$export$557cfb7ed375eeb7($28));
};
var $be985434983c0a5f$export$7f0e23922170149a = function(pat) {
    var $29 = $1a77d6934b592676$export$7f0e23922170149a(pat);
    return function($30) {
        return $be985434983c0a5f$var$liftS($29($30));
    };
};
var $be985434983c0a5f$export$305f7d4e9d4624f2 = function($31) {
    return $be985434983c0a5f$var$liftS($1a77d6934b592676$export$305f7d4e9d4624f2($31));
};
var $be985434983c0a5f$var$fromNonEmptyString = function(v) {
    return v;
};
var $be985434983c0a5f$export$f24224f1c91d8156 = function($32) {
    return $092fe44bc0883be6$export$f24224f1c91d8156($be985434983c0a5f$var$fromNonEmptyString($32));
};
var $be985434983c0a5f$export$b0d75975ac0be0e1 = function(i) {
    return function(nes) {
        var v = $092fe44bc0883be6$export$b0d75975ac0be0e1(i)($be985434983c0a5f$var$fromNonEmptyString(nes));
        return {
            before: $5505a3400147efbd$export$3004f64547af360e(v.before),
            after: $5505a3400147efbd$export$3004f64547af360e(v.after)
        };
    };
};
var $be985434983c0a5f$export$b7df5d561049483a = function(i) {
    return function(nes) {
        var s = $be985434983c0a5f$var$fromNonEmptyString(nes);
        var $18 = i < 1;
        if ($18) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return new $06733ae99ed4f534$export$8a67b48435b5d073($be985434983c0a5f$var$toNonEmptyString($092fe44bc0883be6$export$b7df5d561049483a(i)(s)));
    };
};
var $be985434983c0a5f$export$1bbc425ddca7f2c6 = function(i) {
    return function(nes) {
        var s = $be985434983c0a5f$var$fromNonEmptyString(nes);
        var $19 = i < 1;
        if ($19) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return new $06733ae99ed4f534$export$8a67b48435b5d073($be985434983c0a5f$var$toNonEmptyString($1a77d6934b592676$export$1bbc425ddca7f2c6(i)(s)));
    };
};
var $be985434983c0a5f$export$bafb3da1554990db = function($33) {
    return $1a77d6934b592676$export$bafb3da1554990db($be985434983c0a5f$var$fromNonEmptyString($33));
};
var $be985434983c0a5f$export$f718f38b069557c4 = function($34) {
    return $092fe44bc0883be6$export$f718f38b069557c4($be985434983c0a5f$var$fromNonEmptyString($34));
};
var $be985434983c0a5f$export$12fb146e54f03cae = function($36) {
    return $be985434983c0a5f$var$fromJust($e39dfcf102cdca3c$export$571d59b505e6bb4e($be985434983c0a5f$export$f718f38b069557c4($36)));
};
var $be985434983c0a5f$export$b446f6baa3bb1430 = function(nes) {
    var s = $be985434983c0a5f$var$fromNonEmptyString(nes);
    return {
        head: $3296d29fc7ea4822$export$bbcf894add1d392c(0)(s),
        tail: $5505a3400147efbd$export$3004f64547af360e($092fe44bc0883be6$export$663103110d94aac9(1)(s))
    };
};
var $be985434983c0a5f$export$95b95426129653f6 = function(dictFoldable1) {
    var $37 = $086486679aa806fa$export$2e430a6d03f6ee23(dictFoldable1)($5505a3400147efbd$export$d35c69c74cf52f2a);
    return function($38) {
        return $37($38);
    };
};
var $be985434983c0a5f$export$709e3b51bf2e2249 = function(v) {
    if (v.length === 0) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    return new $06733ae99ed4f534$export$8a67b48435b5d073($be985434983c0a5f$var$toNonEmptyString($092fe44bc0883be6$export$709e3b51bf2e2249(v)));
};
var $be985434983c0a5f$export$a6233231f8d671d1 = function($40) {
    return $be985434983c0a5f$var$fromJust($be985434983c0a5f$export$709e3b51bf2e2249($e39dfcf102cdca3c$export$45b10814cc054894($40)));
};
var $be985434983c0a5f$export$533af5c8cd6afa16 = function(f) {
    var $41 = $be985434983c0a5f$var$liftS($1a77d6934b592676$export$533af5c8cd6afa16(f));
    return function($42) {
        return $5505a3400147efbd$export$3004f64547af360e($41($42));
    };
};
var $be985434983c0a5f$export$6ba801e3e123536e = function(i) {
    return function(nes) {
        var s = $be985434983c0a5f$var$fromNonEmptyString(nes);
        var $21 = i >= $092fe44bc0883be6$export$f24224f1c91d8156(s);
        if ($21) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return new $06733ae99ed4f534$export$8a67b48435b5d073($be985434983c0a5f$var$toNonEmptyString($1a77d6934b592676$export$6ba801e3e123536e(i)(s)));
    };
};
var $be985434983c0a5f$export$663103110d94aac9 = function(i) {
    return function(nes) {
        var s = $be985434983c0a5f$var$fromNonEmptyString(nes);
        var $22 = i >= $092fe44bc0883be6$export$f24224f1c91d8156(s);
        if ($22) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return new $06733ae99ed4f534$export$8a67b48435b5d073($be985434983c0a5f$var$toNonEmptyString($092fe44bc0883be6$export$663103110d94aac9(i)(s)));
    };
};
var $be985434983c0a5f$export$29a68f758c141c85 = function($43) {
    return $be985434983c0a5f$var$liftS($092fe44bc0883be6$export$29a68f758c141c85($43));
};
var $be985434983c0a5f$export$8327ebbef2a0ba76 = function(c) {
    return function(s) {
        return $be985434983c0a5f$var$toNonEmptyString($092fe44bc0883be6$export$439306a4dcaafbb9(c) + s);
    };
};
var $be985434983c0a5f$export$bbcf894add1d392c = function($44) {
    return $be985434983c0a5f$var$liftS($1a77d6934b592676$export$bbcf894add1d392c($44));
};






// Generated by purs version 0.15.15
/* global ArrayBuffer, Float32Array, Int32Array */ // module Test.QuickCheck.Gen
function $afe9bbfe2ce5003b$export$2d1ed1a7368a8bb7(n) {
    var arr = new ArrayBuffer(4);
    var fv = new Float32Array(arr);
    var iv = new Int32Array(arr);
    fv[0] = n;
    return iv[0];
}






























// Generated by purs version 0.15.15








// Generated by purs version 0.15.15
const $12b21e1b0d841cdb$export$4385e60b38654f68 = Math.random;





var $779c6109fa03e926$export$5c61011b8a176cb5 = function(min) {
    return function(max) {
        return function __do() {
            var n = $12b21e1b0d841cdb$export$4385e60b38654f68();
            return n * (max - min) + min;
        };
    };
};
var $779c6109fa03e926$export$3c5f89dae98e900b = function(low) {
    return function(high) {
        return function __do() {
            var n = $12b21e1b0d841cdb$export$4385e60b38654f68();
            var asNumber = ($4ab74a20512cef04$export$a0a81dc3380ce7d3(high) - $4ab74a20512cef04$export$a0a81dc3380ce7d3(low) + 1) * n + $4ab74a20512cef04$export$a0a81dc3380ce7d3(low);
            return $8d5664f12212b23e$export$a3fe094919f356fd(asNumber);
        };
    };
};
var $779c6109fa03e926$export$b3b584c8d6ffe165 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)(function(v) {
    return v < 0.5;
})($12b21e1b0d841cdb$export$4385e60b38654f68);


var $9559f84fe253e941$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $9559f84fe253e941$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $9559f84fe253e941$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $9559f84fe253e941$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $9559f84fe253e941$var$Seed = function(x) {
    return x;
};
var $9559f84fe253e941$export$7042ae9d28c01125 = function(v) {
    return v;
};
var $9559f84fe253e941$export$e65cb34e627289de = {
    show: function(v) {
        return "Seed " + $9559f84fe253e941$var$show(v);
    }
};
var $9559f84fe253e941$var$seedMin = 1;
var $9559f84fe253e941$export$d98c3c51a54fd85 = 2147483647;
var $9559f84fe253e941$var$seedMax = /* #__PURE__ */ function() {
    return $9559f84fe253e941$export$d98c3c51a54fd85 - 1 | 0;
}();
var $9559f84fe253e941$export$2735a0808990c853 = function(x) {
    var ensureBetween = function(min) {
        return function(max) {
            return function(n) {
                var rangeSize = max - min | 0;
                var n$prime = $9559f84fe253e941$var$mod(n)(rangeSize);
                var $25 = n$prime < min;
                if ($25) return n$prime + max | 0;
                return n$prime;
            };
        };
    };
    return ensureBetween($9559f84fe253e941$var$seedMin)($9559f84fe253e941$var$seedMax)(x);
};
var $9559f84fe253e941$export$7c185c3757807f6c = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($9559f84fe253e941$export$2735a0808990c853)(/* #__PURE__ */ $779c6109fa03e926$export$3c5f89dae98e900b($9559f84fe253e941$var$seedMin)($9559f84fe253e941$var$seedMax));
var $9559f84fe253e941$export$61f3493dfd88d63c = 0;
var $9559f84fe253e941$export$f17df8294784fc83 = 48271;
var $9559f84fe253e941$export$4adeeb01377a1217 = function(d) {
    return function(v) {
        return $9559f84fe253e941$var$fromJust($8d5664f12212b23e$export$7bbb4164c9a77bc2($9a14cd925227149d$export$159037f780d3415c($4ab74a20512cef04$export$a0a81dc3380ce7d3($9559f84fe253e941$export$f17df8294784fc83) * $4ab74a20512cef04$export$a0a81dc3380ce7d3(v) + $4ab74a20512cef04$export$a0a81dc3380ce7d3(d))($4ab74a20512cef04$export$a0a81dc3380ce7d3($9559f84fe253e941$export$d98c3c51a54fd85))));
    };
};
var $9559f84fe253e941$export$9b78b1302b1d14b9 = /* #__PURE__ */ $9559f84fe253e941$export$4adeeb01377a1217($9559f84fe253e941$export$61f3493dfd88d63c);
var $9559f84fe253e941$export$1bcc581bf56ac2e3 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $9559f84fe253e941$export$bcaddbba31d9e24 = {
    compare: function(x) {
        return function(y) {
            return $9559f84fe253e941$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $9559f84fe253e941$export$1bcc581bf56ac2e3;
    }
};


var $bc49024203989caa$var$monadStateStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$fc3b89a546fa5c5c($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $bc49024203989caa$var$state = /* #__PURE__ */ $f2d5035ce6148af6$export$ca000e230c0caa3e($bc49024203989caa$var$monadStateStateT);
var $bc49024203989caa$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $bc49024203989caa$var$bindStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$f28534bdc7259c7($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $bc49024203989caa$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($bc49024203989caa$var$bindStateT);
var $bc49024203989caa$var$functorStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$d5449d946db19e3a($50c50d1f444e5fa4$export$dc85e8383eafbd81);
var $bc49024203989caa$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($bc49024203989caa$var$functorStateT);
var $bc49024203989caa$var$modify = /* #__PURE__ */ $f2d5035ce6148af6$export$3ff57735a52b8713($bc49024203989caa$var$monadStateStateT);
var $bc49024203989caa$var$toUnfoldable = /* #__PURE__ */ $3d4fd987da5242ff$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $bc49024203989caa$var$mul = /* #__PURE__ */ $c0e822be92afc4df$export$6e3a27864ab166fe($c0e822be92afc4df$export$f48694d6539477b9);
var $bc49024203989caa$var$min = /* #__PURE__ */ $97937c29f879e68e$export$96ec731ed4dcb222($97937c29f879e68e$export$5ed021ff2336715c);
var $bc49024203989caa$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$5ed021ff2336715c);
var $bc49024203989caa$var$add = /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($c0e822be92afc4df$export$f48694d6539477b9);
var $bc49024203989caa$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $bc49024203989caa$var$foldMap1 = /* #__PURE__ */ $086486679aa806fa$export$b50c31bb8aebd2a7($91ee3359f6bcea22$export$33591d20dac5147e)(/* #__PURE__ */ $e48f2e41a907ae60$export$8adb2de2291fe34($c0e822be92afc4df$export$f48694d6539477b9));
var $bc49024203989caa$var$unsafeIndex = /* #__PURE__ */ $e39dfcf102cdca3c$export$90bcd20c17ae578e();
var $bc49024203989caa$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $bc49024203989caa$var$top = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $bc49024203989caa$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $bc49024203989caa$var$comparing = /* #__PURE__ */ $97937c29f879e68e$export$e9509a298f6befc2($97937c29f879e68e$export$ff461bf68e7dd332);
var $bc49024203989caa$var$Gen = function(x) {
    return x;
};
var $bc49024203989caa$export$501e8ddb7256577d = function(v) {
    return v;
};
var $bc49024203989caa$export$57b56d217c942094 = function($103) {
    return $4a0611d0fc3e3eac$export$4b65631072155b20($bc49024203989caa$export$501e8ddb7256577d($103));
};
var $bc49024203989caa$export$b9607df69539b8a5 = function(f) {
    return $bc49024203989caa$var$state(function(s) {
        return $bc49024203989caa$export$57b56d217c942094(f(s))(s);
    });
};
var $bc49024203989caa$export$c1c8be52b85daeca = function(f) {
    return $bc49024203989caa$export$b9607df69539b8a5(function(s) {
        return f(s.size);
    });
};
var $bc49024203989caa$export$8fdf71db98f19724 = function(n) {
    return function(g) {
        return $bc49024203989caa$var$state(function(s) {
            return $bc49024203989caa$export$57b56d217c942094(g)({
                size: s.size,
                newSeed: n
            });
        });
    };
};
var $bc49024203989caa$export$4380c87abf28fdf = function(sz) {
    return function(g) {
        return $bc49024203989caa$var$state(function(v) {
            return $bc49024203989caa$var$map(function(v1) {
                return {
                    newSeed: v1.newSeed,
                    size: v.size
                };
            })($bc49024203989caa$export$57b56d217c942094(g)({
                newSeed: v.newSeed,
                size: sz
            }));
        });
    };
};
var $bc49024203989caa$var$replicateMRec = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure2 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(Monad0.Bind1().Apply0().Functor0());
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(v) {
        return function(v1) {
            if (v <= 0) return pure2($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            var go = function(v2) {
                if (v2.value1 === 0) return pure2(new $f93520de2fa37b44$export$7fe28cb29e71bf10(v2.value0));
                return mapFlipped(v1)(function(x) {
                    return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0(x, v2.value0), v2.value1 - 1 | 0));
                });
            };
            return tailRecM1(go)(new $71f2e2e9476163f8$export$1908877435b1d5e9($78c799cba34fcb8d$export$c1bed610ade55e1c.value, v));
        };
    };
};
var $bc49024203989caa$export$a1767e9fa438fa19 = function(f) {
    return $bc49024203989caa$var$state(function(s) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(function(a) {
            return $71f2e2e9476163f8$export$9e770fa6ce19a9d6($bc49024203989caa$export$57b56d217c942094(f(a))(s));
        }, {
            size: s.size,
            newSeed: $9559f84fe253e941$export$9b78b1302b1d14b9(s.newSeed)
        });
    });
};
var $bc49024203989caa$export$1c0695923c609880 = function(n) {
    return function(gen) {
        return $bc49024203989caa$var$discard($bc49024203989caa$var$$$void($bc49024203989caa$var$modify(function(s) {
            var $91 = {};
            for(var $92 in s)if (({}).hasOwnProperty.call(s, $92)) $91[$92] = s[$92];
            $91.newSeed = $9559f84fe253e941$export$4adeeb01377a1217($afe9bbfe2ce5003b$export$2d1ed1a7368a8bb7(n))(s.newSeed);
            return $91;
        })))(function() {
            return $bc49024203989caa$export$501e8ddb7256577d(gen);
        });
    };
};
var $bc49024203989caa$export$b03367abac3ff7e8 = /* #__PURE__ */ $e9bda291f4ec10ec$export$ade5de830b656137($f93520de2fa37b44$export$ef692454cdd8c2ba);
var $bc49024203989caa$var$tailRecM = /* #__PURE__ */ $f93520de2fa37b44$export$c025cfd4cc93300b($bc49024203989caa$export$b03367abac3ff7e8);
var $bc49024203989caa$export$52ad81a118d95d95 = /* #__PURE__ */ $e9bda291f4ec10ec$export$345b4840c14ff10f($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $bc49024203989caa$export$2e12bfb3e89e4ebb = /* #__PURE__ */ $bc49024203989caa$var$replicateMRec($bc49024203989caa$export$b03367abac3ff7e8);
var $bc49024203989caa$var$lcgStep = /* #__PURE__ */ function() {
    var f = function(s) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9($9559f84fe253e941$export$7042ae9d28c01125(s.newSeed), function() {
            var $94 = {};
            for(var $95 in s)if (({}).hasOwnProperty.call(s, $95)) $94[$95] = s[$95];
            $94.newSeed = $9559f84fe253e941$export$9b78b1302b1d14b9(s.newSeed);
            return $94;
        }());
    };
    return $bc49024203989caa$var$state(f);
}();
var $bc49024203989caa$export$c1f7d6d1f306d098 = $e9bda291f4ec10ec$export$dce43013fc3a5fe1;
var $bc49024203989caa$export$5d116872cdd6398d = $bc49024203989caa$var$functorStateT;
var $bc49024203989caa$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($bc49024203989caa$export$5d116872cdd6398d);
var $bc49024203989caa$export$379455b567eff87d = /* #__PURE__ */ $bc49024203989caa$var$map2(function(n) {
    return $4ab74a20512cef04$export$a0a81dc3380ce7d3(n) / $4ab74a20512cef04$export$a0a81dc3380ce7d3($9559f84fe253e941$export$d98c3c51a54fd85);
})($bc49024203989caa$var$lcgStep);
var $bc49024203989caa$export$b81db5163bc14d3a = function(k) {
    return function(g) {
        return $bc49024203989caa$var$map2($bc49024203989caa$var$toUnfoldable)($bc49024203989caa$export$2e12bfb3e89e4ebb(k)(g));
    };
};
var $bc49024203989caa$export$15844f9800ba116b = function($104) {
    return $4a0611d0fc3e3eac$export$3f3c20f32c573065($bc49024203989caa$export$501e8ddb7256577d($104));
};
var $bc49024203989caa$export$277a6090301c27ce = function(gen) {
    return function __do() {
        var seed = $9559f84fe253e941$export$7c185c3757807f6c();
        return $bc49024203989caa$export$15844f9800ba116b(gen)({
            newSeed: seed,
            size: 10
        });
    };
};
var $bc49024203989caa$export$4812e460280c6ef2 = function(seed) {
    return function(sz) {
        return function(g) {
            return $bc49024203989caa$export$15844f9800ba116b($bc49024203989caa$export$b81db5163bc14d3a(sz)(g))({
                newSeed: seed,
                size: sz
            });
        };
    };
};
var $bc49024203989caa$export$e2ce9cb992b4de1d = function(n) {
    return function(g) {
        return function __do() {
            var seed = $9559f84fe253e941$export$7c185c3757807f6c();
            return $bc49024203989caa$export$4812e460280c6ef2(seed)(n)(g);
        };
    };
};
var $bc49024203989caa$export$cd4f956adf59bc3d = /* #__PURE__ */ $bc49024203989caa$export$e2ce9cb992b4de1d(10);
var $bc49024203989caa$export$7877a478dd30fd3d = function(a) {
    return function(b) {
        var unscale = function(v) {
            return v * 2.0;
        };
        var scale = function(v) {
            return v * 0.5;
        };
        var min$prime = scale($bc49024203989caa$var$min(a)(b));
        var max$prime = scale($bc49024203989caa$var$max(a)(b));
        return $bc49024203989caa$var$map2(function() {
            var $105 = $bc49024203989caa$var$add(min$prime);
            var $106 = $bc49024203989caa$var$mul(max$prime - min$prime);
            return function($107) {
                return unscale($105($106($107)));
            };
        }())($bc49024203989caa$export$379455b567eff87d);
    };
};
var $bc49024203989caa$export$6d788b9a2716f3a2 = $bc49024203989caa$var$bindStateT;
var $bc49024203989caa$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($bc49024203989caa$export$6d788b9a2716f3a2);
var $bc49024203989caa$export$7ca27958f28e2974 = function(xxs) {
    var total = $bc49024203989caa$var$unwrap($bc49024203989caa$var$foldMap1(function($108) {
        return $e48f2e41a907ae60$export$14f8ce08180a98e1($71f2e2e9476163f8$export$9e770fa6ce19a9d6($108));
    })(xxs));
    var $$default = $71f2e2e9476163f8$export$6f71268a1666ab58($e39dfcf102cdca3c$export$5fd5031fecdacec3(xxs));
    var pick = function($copy_i) {
        return function($copy_n) {
            var $tco_var_i = $copy_i;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i, n) {
                var v = $e39dfcf102cdca3c$export$b610b8812bbcded9(xxs)(i);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return $$default;
                }
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    if (n <= v.value0.value0) {
                        $tco_done = true;
                        return v.value0.value1;
                    }
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                        $tco_var_i = i + 1 | 0;
                        $copy_n = n - v.value0.value0;
                        return;
                    }
                }
                throw new Error("Failed pattern match at Test.QuickCheck.Gen (line 168, column 16 - line 172, column 44): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_n);
            return $tco_result;
        };
    };
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$7877a478dd30fd3d(0)(total))(function(n) {
        return pick(0)(n);
    });
};
var $bc49024203989caa$export$f24ec99cecd50fca = /* #__PURE__ */ $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $bc49024203989caa$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($bc49024203989caa$export$f24ec99cecd50fca);
var $bc49024203989caa$var$chooseInt$prime = function(a) {
    return function(b) {
        var numB = $4ab74a20512cef04$export$a0a81dc3380ce7d3(b);
        var numA = $4ab74a20512cef04$export$a0a81dc3380ce7d3(a);
        var clamp = function(x) {
            return numA + $9a14cd925227149d$export$159037f780d3415c(x)(numB - numA + 1);
        };
        var choose31BitPosNumber = $bc49024203989caa$var$map2($4ab74a20512cef04$export$a0a81dc3380ce7d3)($bc49024203989caa$var$lcgStep);
        var choose32BitPosNumber = $bc49024203989caa$var$apply($bc49024203989caa$var$map2($bc49024203989caa$var$add)(choose31BitPosNumber))($bc49024203989caa$var$map2($bc49024203989caa$var$mul(2.0))(choose31BitPosNumber));
        return $bc49024203989caa$var$map2(function($109) {
            return $8d5664f12212b23e$export$a3fe094919f356fd(clamp($109));
        })(choose32BitPosNumber);
    };
};
var $bc49024203989caa$export$24b3f9c3c8227daa = function(a) {
    return function(b) {
        var $101 = a <= b;
        if ($101) return $bc49024203989caa$var$chooseInt$prime(a)(b);
        return $bc49024203989caa$var$chooseInt$prime(b)(a);
    };
};
var $bc49024203989caa$export$e57ff0f701c44363 = function(g) {
    return $bc49024203989caa$export$c1c8be52b85daeca(function(n) {
        return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)(n))(function(k) {
            return $bc49024203989caa$export$b81db5163bc14d3a(k)(g);
        });
    });
};
var $bc49024203989caa$export$f103a64475a4fd0b = {
    chooseInt: $bc49024203989caa$export$24b3f9c3c8227daa,
    chooseFloat: $bc49024203989caa$export$7877a478dd30fd3d,
    chooseBool: /* #__PURE__ */ $bc49024203989caa$var$map2(function(v) {
        return v < 0.5;
    })($bc49024203989caa$export$379455b567eff87d),
    resize: function(f) {
        return function(g) {
            return $bc49024203989caa$export$c1c8be52b85daeca(function(s) {
                return $bc49024203989caa$export$4380c87abf28fdf(f(s))(g);
            });
        };
    },
    sized: $bc49024203989caa$export$c1c8be52b85daeca,
    Monad0: function() {
        return $bc49024203989caa$export$52ad81a118d95d95;
    }
};
var $bc49024203989caa$export$a9a18ae5ba42aeab = function(xs) {
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)($e39dfcf102cdca3c$export$f24224f1c91d8156(xs) - 1 | 0))(function(n) {
        return $bc49024203989caa$var$unsafeIndex(xs)(n);
    });
};
var $bc49024203989caa$export$69ada092a2da39c = /* #__PURE__ */ $e9bda291f4ec10ec$export$5cbc630d6fbe2e14($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $bc49024203989caa$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($bc49024203989caa$export$69ada092a2da39c);
var $bc49024203989caa$export$d809131b0d748327 = function(g) {
    return $bc49024203989caa$export$c1c8be52b85daeca(function(n) {
        return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)(n))(function(k) {
            return $bc49024203989caa$var$bind1(g)(function(x) {
                return $bc49024203989caa$var$bind1($bc49024203989caa$export$b81db5163bc14d3a(k - 1 | 0)(g))(function(xs) {
                    return $bc49024203989caa$var$pure1($bc49024203989caa$var$fromJust($e39dfcf102cdca3c$export$571d59b505e6bb4e($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(x)(xs))));
                });
            });
        });
    });
};
var $bc49024203989caa$export$7a5d735b2ab6389d = function(xs) {
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)($e39dfcf102cdca3c$export$f24224f1c91d8156(xs) - 1 | 0))(function(n) {
        return $bc49024203989caa$var$pure1($bc49024203989caa$var$unsafeIndex(xs)(n));
    });
};
var $bc49024203989caa$export$78a99c8d44d72635 = function(dictBoundedEnum) {
    var fromEnum = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
    var Bounded0 = dictBoundedEnum.Bounded0();
    var toEnum = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(fromEnum($69d0e3dbb12088d2$export$40e543e69a8b3fbb(Bounded0)))(fromEnum($69d0e3dbb12088d2$export$1e95b668f3b82d(Bounded0))))(function(i) {
        return $bc49024203989caa$var$pure1($bc49024203989caa$var$fromJust(toEnum(i)));
    });
};
var $bc49024203989caa$export$448332262467e042 = function(xs) {
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$b81db5163bc14d3a($fc8c1182ec2aefec$export$f24224f1c91d8156(xs))($bc49024203989caa$export$24b3f9c3c8227daa(0)($bc49024203989caa$var$top)))(function(ns) {
        return $bc49024203989caa$var$pure1($bc49024203989caa$var$map1($71f2e2e9476163f8$export$6f71268a1666ab58)($396c4c3d9e7fae3c$export$b035e44d7bb4278f($bc49024203989caa$var$comparing($71f2e2e9476163f8$export$9e770fa6ce19a9d6))($396c4c3d9e7fae3c$export$8901015135f2fb22(ns)(xs))));
    });
};
var $bc49024203989caa$export$a7e2a49ace6c34c5 = function(gen) {
    return function(pred) {
        var go = function(v) {
            return $bc49024203989caa$var$bind1(gen)(function(a) {
                return $bc49024203989caa$var$pure1(function() {
                    var $102 = pred(a);
                    if ($102) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(a);
                    return new $f93520de2fa37b44$export$550acbd06a1f5a6a($05149ea687d6b460$export$523c0b569236b342);
                }());
            });
        };
        return $bc49024203989caa$var$tailRecM(go)($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $bc49024203989caa$export$9a3b72d4f4d3c6b8 = /* #__PURE__ */ $e9bda291f4ec10ec$export$d5bde0fdc0bca75b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0)($50c50d1f444e5fa4$export$1cd7ff14f6a7fcef);



var $015c2f962b1b4ea6$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $015c2f962b1b4ea6$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $015c2f962b1b4ea6$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($f935a9866e211c00$export$be1f07c3580164c);
var $015c2f962b1b4ea6$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $015c2f962b1b4ea6$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $015c2f962b1b4ea6$var$wrap = /* #__PURE__ */ $4fa4836228a192cc$export$4997ffc0176396a6();
var $015c2f962b1b4ea6$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($bc49024203989caa$export$69ada092a2da39c);
var $015c2f962b1b4ea6$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($bc49024203989caa$export$5d116872cdd6398d);
var $015c2f962b1b4ea6$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($bc49024203989caa$export$6d788b9a2716f3a2);
var $015c2f962b1b4ea6$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($bc49024203989caa$export$f24ec99cecd50fca);
var $015c2f962b1b4ea6$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $015c2f962b1b4ea6$var$genMaybe = /* #__PURE__ */ $26405903fe88aca2$export$814577261e602aa0($bc49024203989caa$export$f103a64475a4fd0b);
var $015c2f962b1b4ea6$var$genEither = /* #__PURE__ */ $26405903fe88aca2$export$4c044f8c47b13786($bc49024203989caa$export$f103a64475a4fd0b);
var $015c2f962b1b4ea6$export$861a40465c22b816 = {
    coarbitrary: function(v) {
        return $015c2f962b1b4ea6$var$identity;
    }
};
var $015c2f962b1b4ea6$export$fa568a34e9057c95 = function(dict) {
    return dict.coarbitrary;
};
var $015c2f962b1b4ea6$export$133fabada3459bf2 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: function(v) {
            return coarbitrary3(v);
        }
    };
};
var $015c2f962b1b4ea6$export$5b13dccb935ebfc = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: function(v) {
            return coarbitrary3(v);
        }
    };
};
var $015c2f962b1b4ea6$export$c1fcdb426307b7f1 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictCoarbitrary1) {
        var coarbitrary4 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary1);
        return {
            coarbitrary: function(v) {
                var $211 = coarbitrary4(v.value1);
                var $212 = coarbitrary3(v.value0);
                return function($213) {
                    return $211($212($213));
                };
            }
        };
    };
};
var $015c2f962b1b4ea6$export$d57c6210617cde99 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictCoarbitrary1) {
        var coarbitrary4 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary1);
        return {
            coarbitrary: function(v) {
                if (v instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return coarbitrary3(v.value0);
                if (v instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return coarbitrary4(v.value0);
                throw new Error("Failed pattern match at Test.QuickCheck.Arbitrary (line 249, column 1 - line 251, column 38): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $015c2f962b1b4ea6$export$32b717d60d3a07f5 = function(dictGeneric) {
    var from = $91c996e9c07e3b3f$export$6788812c4e6611e6(dictGeneric);
    return function(dictCoarbitrary) {
        var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
        return function(x) {
            return coarbitrary3(from(x));
        };
    };
};
var $015c2f962b1b4ea6$export$842c7e46be26b8 = {
    coarbitrary: function(v) {
        return $bc49024203989caa$export$1c0695923c609880(1.0);
    }
};
var $015c2f962b1b4ea6$export$b84841b17616fb21 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictCoarbitrary1) {
        var coarbitrary4 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary1);
        return {
            coarbitrary: function(v) {
                var $214 = coarbitrary4(v.value1);
                var $215 = coarbitrary3(v.value0);
                return function($216) {
                    return $214($215($216));
                };
            }
        };
    };
};
var $015c2f962b1b4ea6$export$42da7c65c0c86615 = {
    coarbitrary: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $bc49024203989caa$export$1c0695923c609880(1.0);
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $bc49024203989caa$export$1c0695923c609880(2.0);
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $bc49024203989caa$export$1c0695923c609880(3.0);
        throw new Error("Failed pattern match at Test.QuickCheck.Arbitrary (line 123, column 1 - line 126, column 34): " + [
            v.constructor.name
        ]);
    }
};
var $015c2f962b1b4ea6$export$c955bf422d2842ab = {
    coarbitrary: $bc49024203989caa$export$1c0695923c609880
};
var $015c2f962b1b4ea6$export$3df6fd0aac33bc4d = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictCoarbitrary1) {
        var coarbitrary4 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary1);
        return {
            coarbitrary: function(v) {
                var $217 = coarbitrary3(v.value1);
                var $218 = coarbitrary4(v.value0);
                return function($219) {
                    return $217($218($219));
                };
            }
        };
    };
};
var $015c2f962b1b4ea6$export$78f80636858d77cf = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $bc49024203989caa$export$1c0695923c609880(1.0);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return coarbitrary3(v.value0);
            throw new Error("Failed pattern match at Test.QuickCheck.Arbitrary (line 187, column 1 - line 189, column 39): " + [
                v.constructor.name
            ]);
        }
    };
};
var $015c2f962b1b4ea6$export$1c88b540e53f1367 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: $015c2f962b1b4ea6$var$foldl(function(f) {
            return function(x) {
                var $220 = coarbitrary3(x);
                return function($221) {
                    return f($220($221));
                };
            };
        })($015c2f962b1b4ea6$var$identity)
    };
};
var $015c2f962b1b4ea6$export$45d23c89ee56081f = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95($015c2f962b1b4ea6$export$3df6fd0aac33bc4d($015c2f962b1b4ea6$export$1c88b540e53f1367(dictCoarbitrary))(dictCoarbitrary));
    return {
        coarbitrary: function(v) {
            return coarbitrary3(v);
        }
    };
};
var $015c2f962b1b4ea6$export$f6298d343c57762e = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: function(a) {
            return coarbitrary3($99af8ad7682e39c7$export$4d82290515cd0ddb(a));
        }
    };
};
var $015c2f962b1b4ea6$export$8d82884d164ab631 = {
    coarbitrary: function($222) {
        return $bc49024203989caa$export$1c0695923c609880($4ab74a20512cef04$export$a0a81dc3380ce7d3($222));
    }
};
var $015c2f962b1b4ea6$var$coarbitrary1 = /* #__PURE__ */ $015c2f962b1b4ea6$export$fa568a34e9057c95($015c2f962b1b4ea6$export$8d82884d164ab631);
var $015c2f962b1b4ea6$export$13af4cd5dc1ddde9 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: function(v) {
            return coarbitrary3(v);
        }
    };
};
var $015c2f962b1b4ea6$export$62394f742bc4ab7 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictCoarbitrary1) {
        var coarbitrary4 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary1);
        return {
            coarbitrary: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return coarbitrary3(v.value0);
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return coarbitrary4(v.value0);
                throw new Error("Failed pattern match at Test.QuickCheck.Arbitrary (line 194, column 1 - line 196, column 40): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $015c2f962b1b4ea6$export$da64647ab4f27ecb = {
    coarbitrary: function(c) {
        return $015c2f962b1b4ea6$var$coarbitrary1($015c2f962b1b4ea6$var$fromEnum(c));
    }
};
var $015c2f962b1b4ea6$export$95b1b165fefacaf6 = {
    coarbitrary: function(v) {
        if (v) return $bc49024203989caa$export$1c0695923c609880(1.0);
        if (!v) return $bc49024203989caa$export$1c0695923c609880(2.0);
        throw new Error("Failed pattern match at Test.QuickCheck.Arbitrary (line 80, column 1 - line 82, column 37): " + [
            v.constructor.name
        ]);
    }
};
var $015c2f962b1b4ea6$export$b1c4b6cc9f6e15d5 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: $015c2f962b1b4ea6$var$foldl1(function(f) {
            return function(x) {
                var $223 = coarbitrary3(x);
                return function($224) {
                    return f($223($224));
                };
            };
        })($015c2f962b1b4ea6$var$identity)
    };
};
var $015c2f962b1b4ea6$var$coarbitrary2 = /* #__PURE__ */ $015c2f962b1b4ea6$export$fa568a34e9057c95(/* #__PURE__ */ $015c2f962b1b4ea6$export$b1c4b6cc9f6e15d5(/* #__PURE__ */ $015c2f962b1b4ea6$export$78f80636858d77cf($015c2f962b1b4ea6$export$da64647ab4f27ecb)));
var $015c2f962b1b4ea6$export$16a20aeec0a3142c = function(dictCoarbitrary) {
    return {
        coarbitrary: function() {
            var $225 = $015c2f962b1b4ea6$export$fa568a34e9057c95($015c2f962b1b4ea6$export$b1c4b6cc9f6e15d5(dictCoarbitrary));
            return function($226) {
                return $225($e39dfcf102cdca3c$export$45b10814cc054894($226));
            };
        }()
    };
};
var $015c2f962b1b4ea6$export$d9f93714e8eaead1 = {
    coarbitrary: function(s) {
        return $015c2f962b1b4ea6$var$coarbitrary2($015c2f962b1b4ea6$var$map($1a77d6934b592676$export$bbcf894add1d392c(0))($5b07e36f812dd04b$export$65980d18b75784e2($015c2f962b1b4ea6$var$wrap(""))(s)));
    }
};
var $015c2f962b1b4ea6$export$892519f250c4be9 = {
    coarbitrary: /* #__PURE__ */ function() {
        var $227 = $015c2f962b1b4ea6$export$fa568a34e9057c95($015c2f962b1b4ea6$export$d9f93714e8eaead1);
        return function($228) {
            return $227($5505a3400147efbd$export$f84e8e69fd4488a5($228));
        };
    }()
};
var $015c2f962b1b4ea6$export$e2d53d3c92ca8e5f = {
    arbitraryRecord: function(v) {
        return $015c2f962b1b4ea6$var$pure({});
    }
};
var $015c2f962b1b4ea6$export$df70e74a961d9c9 = function(dict) {
    return dict.arbitraryRecord;
};
var $015c2f962b1b4ea6$export$f36b0b309ad6e0ca = function() {
    return function(dictArbitraryRowList) {
        return {
            arbitrary: $015c2f962b1b4ea6$export$df70e74a961d9c9(dictArbitraryRowList)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $015c2f962b1b4ea6$export$38522914432e39fd = /* #__PURE__ */ function() {
    return {
        arbitrary: $015c2f962b1b4ea6$var$pure($91c996e9c07e3b3f$export$928c7f2d618c070b.value)
    };
}();
var $015c2f962b1b4ea6$export$39644750a668e0b0 = function(dict) {
    return dict.arbitraryGenericSum;
};
var $015c2f962b1b4ea6$export$11be7c034231ec78 = function(dict) {
    return dict.arbitrary;
};
var $015c2f962b1b4ea6$export$a85aa5ff6696db10 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$84637ea037d2e218)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$dca64850086bd9e9 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$8bfc33963ccbb2a)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$88e1efb12b274102 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($50c50d1f444e5fa4$export$544bf02140fa9a77)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$1fa12060b5b0a611 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$bind($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))(function($229) {
            return $015c2f962b1b4ea6$var$pure($99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($229)));
        })
    };
};
var $015c2f962b1b4ea6$export$bab0bb9deb3e9d00 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return {
        arbitrary: $bc49024203989caa$export$c1c8be52b85daeca(function(n) {
            return $015c2f962b1b4ea6$var$bind($bc49024203989caa$export$24b3f9c3c8227daa(0)(n))($f57f4b701aa7b66e$export$8a83211c878a3f1f($bc49024203989caa$export$2e12bfb3e89e4ebb)(arbitrary1));
        })
    };
};
var $015c2f962b1b4ea6$export$c73be5e2553898b4 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitrary1) {
        return {
            arbitrary: $015c2f962b1b4ea6$var$apply($015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$264ad599d7cef668.create)(arbitrary1))($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary1))
        };
    };
};
var $015c2f962b1b4ea6$export$5f8951a9546a42f5 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitraryRowList) {
        var arbitraryRecord1 = $015c2f962b1b4ea6$export$df70e74a961d9c9(dictArbitraryRowList);
        return function() {
            return function() {
                return function() {
                    return function(dictIsSymbol) {
                        var insert = $15e8567e7c31ba30$export$21a5ca8aa77d35ff(dictIsSymbol)()();
                        return {
                            arbitraryRecord: function(v) {
                                return $015c2f962b1b4ea6$var$bind(arbitrary1)(function(value) {
                                    return $015c2f962b1b4ea6$var$bind(arbitraryRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))(function(previous) {
                                        return $015c2f962b1b4ea6$var$pure(insert($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(value)(previous));
                                    });
                                });
                            }
                        };
                    };
                };
            };
        };
    };
};
var $015c2f962b1b4ea6$export$cb90f6dcb5b2d3fc = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitraryGenericSum) {
        return {
            arbitrary: $bc49024203989caa$export$a9a18ae5ba42aeab($015c2f962b1b4ea6$var$fromJust($e39dfcf102cdca3c$export$571d59b505e6bb4e($396c4c3d9e7fae3c$export$8327ebbef2a0ba76($015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$dd5fad028b7772cd.create)(arbitrary1))($015c2f962b1b4ea6$var$map($015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$df71ca4577dbdff6.create))($015c2f962b1b4ea6$export$39644750a668e0b0(dictArbitraryGenericSum))))))
        };
    };
};
var $015c2f962b1b4ea6$export$f575d4062c2cc1a7 = function(dictGeneric) {
    var to = $91c996e9c07e3b3f$export$2c618a4308a30424(dictGeneric);
    return function(dictArbitrary) {
        return $015c2f962b1b4ea6$var$map1(to)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary));
    };
};
var $015c2f962b1b4ea6$export$bec194de819af8c7 = {
    arbitrary: /* #__PURE__ */ $015c2f962b1b4ea6$var$pure($05149ea687d6b460$export$523c0b569236b342)
};
var $015c2f962b1b4ea6$export$1a314bd0d9117271 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitrary1) {
        return {
            arbitrary: $015c2f962b1b4ea6$var$apply($015c2f962b1b4ea6$var$map1($71f2e2e9476163f8$export$1908877435b1d5e9.create)(arbitrary1))($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary1))
        };
    };
};
var $015c2f962b1b4ea6$export$a79945929bf98a5b = /* #__PURE__ */ function() {
    return {
        arbitrary: $bc49024203989caa$export$7a5d735b2ab6389d($015c2f962b1b4ea6$var$fromJust($e39dfcf102cdca3c$export$571d59b505e6bb4e([
            $5026be88823ef1f4$export$7158f0ceb70f54c7.value,
            $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value,
            $5026be88823ef1f4$export$b023c82b48e70453.value
        ])))
    };
}();
var $015c2f962b1b4ea6$export$b387f11d309e6775 = {
    arbitrary: $bc49024203989caa$export$379455b567eff87d
};
var $015c2f962b1b4ea6$export$295408394c3b9019 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitrary1) {
        return {
            arbitrary: $015c2f962b1b4ea6$var$apply($015c2f962b1b4ea6$var$map1($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary1)))(arbitrary1)
        };
    };
};
var $015c2f962b1b4ea6$export$30697c93cf332701 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($78c799cba34fcb8d$export$ab241a3582569781)($015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$295408394c3b9019($015c2f962b1b4ea6$export$bab0bb9deb3e9d00(dictArbitrary))(dictArbitrary)))
    };
};
var $015c2f962b1b4ea6$export$6a544b0a2ef23806 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($665413393090e9d0$export$d0198c9c86fc2be1)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$fdae917d8821d63f = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$genMaybe($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$17074bd582307253 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($19578e25953179c0$export$bed9238d8933c9a8)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$fb30076ef0cfa906 = /* #__PURE__ */ function() {
    return {
        arbitrary: $bc49024203989caa$export$24b3f9c3c8227daa(-1000000)(1000000)
    };
}();
var $015c2f962b1b4ea6$export$5fe62db8f5e41ef7 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitraryGenericSum) {
        return {
            arbitraryGenericSum: $396c4c3d9e7fae3c$export$8327ebbef2a0ba76($015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$dd5fad028b7772cd.create)(arbitrary1))($015c2f962b1b4ea6$var$map($015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$df71ca4577dbdff6.create))($015c2f962b1b4ea6$export$39644750a668e0b0(dictArbitraryGenericSum)))
        };
    };
};
var $015c2f962b1b4ea6$export$4842e4f68d486a6 = function(dictArbitrary) {
    return {
        arbitraryGenericSum: [
            $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$dca64850086bd9e9(dictArbitrary))
        ]
    };
};
var $015c2f962b1b4ea6$export$2a9d85b1c8520746 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictArbitrary) {
        var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
        return {
            arbitrary: $bc49024203989caa$export$a1767e9fa438fa19(function(a) {
                return coarbitrary3(a)(arbitrary1);
            })
        };
    };
};
var $015c2f962b1b4ea6$export$4fb4ffb23a5a31e4 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($6c6a555e6244fc9c$export$b25abba66f7be210)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$771b18865ddf6ea = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($57b8542ac3131c5d$export$6aef3ff797629bec)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$e2b294368e8fdc49 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitrary1) {
        return {
            arbitrary: $015c2f962b1b4ea6$var$genEither(arbitrary1)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary1))
        };
    };
};
var $015c2f962b1b4ea6$export$fc8e201052e462f4 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($8257f7a36ab9f9cd$export$c26a72e8d91adeec)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$1a8e34126024bfa9 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($1242d110ab1edcd9$export$286e7113895e33ef)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$783d1c888386f680 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($65ae0a43a0950bac$export$c688766eb4789b8c)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$c1be33fa5eb75494 = {
    arbitrary: /* #__PURE__ */ $015c2f962b1b4ea6$var$map1(/* #__PURE__ */ $f935a9866e211c00$export$1e2c188a485bdeae($f935a9866e211c00$export$be1f07c3580164c)(/* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79))(/* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79)))(/* #__PURE__ */ $bc49024203989caa$export$24b3f9c3c8227daa(0)(65536))
};
var $015c2f962b1b4ea6$export$bc46b00127c8a98c = {
    arbitrary: /* #__PURE__ */ $f38acfbf15955b73$export$ed1be54c7ccedf5b($bc49024203989caa$export$f103a64475a4fd0b)
};
var $015c2f962b1b4ea6$export$575cda352fa57683 = function(dictArbitrary) {
    return {
        arbitrary: $bc49024203989caa$export$e57ff0f701c44363($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$ed5d9d023af9ba05 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$575cda352fa57683(dictArbitrary));
    return {
        arbitrary: $015c2f962b1b4ea6$var$bind($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))(function(x) {
            return $015c2f962b1b4ea6$var$bind(arbitrary1)(function(xs) {
                return $015c2f962b1b4ea6$var$pure($015c2f962b1b4ea6$var$fromJust($e39dfcf102cdca3c$export$571d59b505e6bb4e(function __do() {
                    var mxs = $784e144d56146b5c$export$cc9b8725eef9c137(xs)();
                    $784e144d56146b5c$export$4cbf152802aa238(x)(mxs)();
                    return $784e144d56146b5c$export$7c850c5af9b9983e(mxs)();
                }())));
            });
        })
    };
};
var $015c2f962b1b4ea6$export$fb88443f408965ad = {
    arbitrary: /* #__PURE__ */ $015c2f962b1b4ea6$var$map1($092fe44bc0883be6$export$709e3b51bf2e2249)(/* #__PURE__ */ $015c2f962b1b4ea6$export$11be7c034231ec78(/* #__PURE__ */ $015c2f962b1b4ea6$export$575cda352fa57683($015c2f962b1b4ea6$export$c1be33fa5eb75494)))
};
var $015c2f962b1b4ea6$export$7e267739562d6412 = {
    arbitrary: /* #__PURE__ */ $015c2f962b1b4ea6$var$apply(/* #__PURE__ */ $015c2f962b1b4ea6$var$map1($be985434983c0a5f$export$8327ebbef2a0ba76)(/* #__PURE__ */ $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$c1be33fa5eb75494)))(/* #__PURE__ */ $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$fb88443f408965ad))
};
var $015c2f962b1b4ea6$export$236978e8a91250c5 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$575cda352fa57683(dictArbitrary));
    return function(dictCoarbitrary) {
        var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95($015c2f962b1b4ea6$export$b1c4b6cc9f6e15d5(dictCoarbitrary));
        return {
            coarbitrary: function(f) {
                return function(gen) {
                    return $015c2f962b1b4ea6$var$bind(arbitrary1)(function(xs) {
                        return coarbitrary3($015c2f962b1b4ea6$var$map(f)(xs))(gen);
                    });
                };
            }
        };
    };
};
var $015c2f962b1b4ea6$export$bad24e41c274ef0 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($e48f2e41a907ae60$export$14f8ce08180a98e1)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};



var $364547bd6bbe186e$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $364547bd6bbe186e$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $364547bd6bbe186e$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $364547bd6bbe186e$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($bc49024203989caa$export$5d116872cdd6398d);
var $364547bd6bbe186e$var$arbitrary = /* #__PURE__ */ $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$fb30076ef0cfa906);
var $364547bd6bbe186e$var$power = /* #__PURE__ */ $784e1bd3d26d71da$export$836601bcef5ff40($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $364547bd6bbe186e$var$abs = /* #__PURE__ */ $97937c29f879e68e$export$2335f513bbd82c6d($97937c29f879e68e$export$ff461bf68e7dd332)($d061555d3b2c84b2$export$d40e27c88e22a303);
var $364547bd6bbe186e$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($05fb1b61396adfce$export$3634602ee36f7fe6);
var $364547bd6bbe186e$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($05fb1b61396adfce$export$6b86c7f1e16b91d2);
var $364547bd6bbe186e$var$div = /* #__PURE__ */ $b0cd729514c2504e$export$159d9494db57879b($b0cd729514c2504e$export$437776face1858ae);
var $364547bd6bbe186e$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $364547bd6bbe186e$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($05fb1b61396adfce$export$6a1d89187d209f74);
var $364547bd6bbe186e$var$oneOf = /* #__PURE__ */ $9da596880af1a1c5$export$a9a18ae5ba42aeab($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $364547bd6bbe186e$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($05fb1b61396adfce$export$45def89472122d0b);
var $364547bd6bbe186e$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a(/* #__PURE__ */ $97937c29f879e68e$export$6ace7ea8ac01a75e($97937c29f879e68e$export$ff461bf68e7dd332));
var $364547bd6bbe186e$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$def6059c21714f2a);
var $364547bd6bbe186e$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($05fb1b61396adfce$export$6a1d89187d209f74);
var $364547bd6bbe186e$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $364547bd6bbe186e$var$writeImpl = /* #__PURE__ */ $f505976c723c2a85$export$be94bcd43c4d1340($f505976c723c2a85$export$deb1d11818e4b91c);
var $364547bd6bbe186e$export$26c3a13ae3fcd1 = function(x) {
    return x;
};
var $364547bd6bbe186e$export$58083ab6f55cb943 = function(x) {
    return x;
};
var $364547bd6bbe186e$var$Acc = function(x) {
    return x;
};
var $364547bd6bbe186e$export$c991146d930441a8 = {
    toMidi: function(v) {
        return (v.fifths * 7 | 0) + (v.octaves * 12 | 0) | 0;
    }
};
var $364547bd6bbe186e$var$toMidi = /* #__PURE__ */ $6416bd93bb20ed95$export$2a741832e0386ba($364547bd6bbe186e$export$c991146d930441a8);
var $364547bd6bbe186e$export$f905cb9c73a92ee4 = {
    toMidi: function(v) {
        return $364547bd6bbe186e$var$mod(v * 7 | 0)(12);
    }
};
var $364547bd6bbe186e$var$toMidi1 = /* #__PURE__ */ $6416bd93bb20ed95$export$2a741832e0386ba($364547bd6bbe186e$export$f905cb9c73a92ee4);
var $364547bd6bbe186e$export$5a55ea3dd25e3485 = {
    toMidiPitch: function(i) {
        return $364547bd6bbe186e$var$toMidi(i) + 12 | 0;
    }
};
var $364547bd6bbe186e$export$da153edbf8894df6 = {
    toMidiPitch: function(i) {
        return $364547bd6bbe186e$var$toMidi1(i) + 60 | 0;
    }
};
var $364547bd6bbe186e$export$66d6281a18f726a9 = {
    eq: function(x) {
        return function(y) {
            return x.fifths === y.fifths && x.octaves === y.octaves;
        };
    }
};
var $364547bd6bbe186e$export$176fc042e65ea01b = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $364547bd6bbe186e$export$f7480551b533384f = {
    compare: function(x) {
        return function(y) {
            return $364547bd6bbe186e$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $364547bd6bbe186e$export$176fc042e65ea01b;
    }
};
var $364547bd6bbe186e$export$90f24b93bfcc726 = {
    arbitrary: /* #__PURE__ */ $364547bd6bbe186e$var$map(function($264) {
        return $364547bd6bbe186e$export$58083ab6f55cb943(function(v) {
            return $364547bd6bbe186e$var$mod(v)(100);
        }($264));
    })($364547bd6bbe186e$var$arbitrary)
};
var $364547bd6bbe186e$export$3d2fd4bf335ca738 = function(fifths1) {
    return function(octaves3) {
        return {
            fifths: fifths1,
            octaves: octaves3
        };
    };
};
var $364547bd6bbe186e$export$64e237f64278e8d0 = function(fs) {
    return function(os) {
        return $364547bd6bbe186e$export$3d2fd4bf335ca738(fs)(os);
    };
};
var $364547bd6bbe186e$export$c8b72c7fa39a2f33 = /* #__PURE__ */ function() {
    return $364547bd6bbe186e$export$3d2fd4bf335ca738(2)(-1);
}();
var $364547bd6bbe186e$export$bb0d8c365277895 = {
    arbitrary: /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($bc49024203989caa$export$f24ec99cecd50fca)(/* #__PURE__ */ $364547bd6bbe186e$var$map($364547bd6bbe186e$export$3d2fd4bf335ca738)(/* #__PURE__ */ $364547bd6bbe186e$var$map(function(v) {
        return $364547bd6bbe186e$var$mod(v)(100);
    })($364547bd6bbe186e$var$arbitrary)))(/* #__PURE__ */ $364547bd6bbe186e$var$map(function(v) {
        return $364547bd6bbe186e$var$mod(v)(100);
    })($364547bd6bbe186e$var$arbitrary))
};
var $364547bd6bbe186e$export$caeccd6bc6363091 = {
    append: function(v) {
        return function(v1) {
            return $364547bd6bbe186e$export$3d2fd4bf335ca738(v.fifths + v1.fifths | 0)(v.octaves + v1.octaves | 0);
        };
    }
};
var $364547bd6bbe186e$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($364547bd6bbe186e$export$caeccd6bc6363091);
var $364547bd6bbe186e$export$a770f771efb8ffc9 = {
    mempty: /* #__PURE__ */ $364547bd6bbe186e$export$3d2fd4bf335ca738(0)(0),
    Semigroup0: function() {
        return $364547bd6bbe186e$export$caeccd6bc6363091;
    }
};
var $364547bd6bbe186e$export$b9652c203a758dfb = {
    ginverse: function(v) {
        return $364547bd6bbe186e$export$3d2fd4bf335ca738(-v.fifths | 0)(-v.octaves | 0);
    },
    Monoid0: function() {
        return $364547bd6bbe186e$export$a770f771efb8ffc9;
    }
};
var $364547bd6bbe186e$export$330de7f6cbc5669c = $364547bd6bbe186e$export$58083ab6f55cb943;
var $364547bd6bbe186e$export$2fef8ec835a7bac8 = function(fs) {
    return $364547bd6bbe186e$export$330de7f6cbc5669c(fs);
};
var $364547bd6bbe186e$export$5af90cbfb4310b74 = /* #__PURE__ */ $364547bd6bbe186e$export$330de7f6cbc5669c(6);
var $364547bd6bbe186e$export$4a967d9f7a24c2d4 = {
    append: function(v) {
        return function(v1) {
            return $364547bd6bbe186e$export$330de7f6cbc5669c(v + v1 | 0);
        };
    }
};
var $364547bd6bbe186e$export$47e33c7d05840957 = {
    mempty: /* #__PURE__ */ $364547bd6bbe186e$export$330de7f6cbc5669c(0),
    Semigroup0: function() {
        return $364547bd6bbe186e$export$4a967d9f7a24c2d4;
    }
};
var $364547bd6bbe186e$export$99a5747405ec185d = {
    ginverse: function(v) {
        return $364547bd6bbe186e$export$330de7f6cbc5669c(-v | 0);
    },
    Monoid0: function() {
        return $364547bd6bbe186e$export$47e33c7d05840957;
    }
};
var $364547bd6bbe186e$export$53b2ff46c1bc2ebc = 1;
var $364547bd6bbe186e$var$qualpf = function(n) {
    return function(la) {
        return function(lp) {
            return function(ld) {
                if (n > 0) return $364547bd6bbe186e$var$power(la)(n);
                if (n === 0) return lp;
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $364547bd6bbe186e$var$power(ld)($364547bd6bbe186e$var$abs(n));
                throw new Error("Failed pattern match at Data.Pitches.Spelled (line 218, column 1 - line 218, column 54): " + [
                    n.constructor.name,
                    la.constructor.name,
                    lp.constructor.name,
                    ld.constructor.name
                ]);
            };
        };
    };
};
var $364547bd6bbe186e$var$qualimpf = function(n) {
    return function(la) {
        return function(lmj) {
            return function(lmn) {
                return function(ld) {
                    if (n > 0) return $364547bd6bbe186e$var$power(la)(n);
                    if (n === 0) return lmj;
                    if (n === -1) return lmn;
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $364547bd6bbe186e$var$power(ld)((-n | 0) - 1 | 0);
                    throw new Error("Failed pattern match at Data.Pitches.Spelled (line 224, column 1 - line 224, column 66): " + [
                        n.constructor.name,
                        la.constructor.name,
                        lmj.constructor.name,
                        lmn.constructor.name,
                        ld.constructor.name
                    ]);
                };
            };
        };
    };
};
var $364547bd6bbe186e$var$parseAccs = /* #__PURE__ */ function() {
    var munch = function($265) {
        return $fb26133a5ec46bf7$export$a6482580fab70c30($9da596880af1a1c5$export$eba6f6f03b0a92e7($265));
    };
    var sharps = $364547bd6bbe186e$var$map1($ba51d599f79a6310$export$f24224f1c91d8156)($364547bd6bbe186e$var$alt(munch("\u266F"))(munch("#")));
    var flats = $364547bd6bbe186e$var$map1(function($266) {
        return -$ba51d599f79a6310$export$f24224f1c91d8156($266) | 0;
    })($364547bd6bbe186e$var$alt(munch("\u266D"))(munch("b")));
    return $fb26133a5ec46bf7$export$a75d1723e6bda2ec(0)($364547bd6bbe186e$var$alt(sharps)(flats));
}();
var $364547bd6bbe186e$export$e82039437d8924cc = function(dict) {
    return dict.octaves;
};
var $364547bd6bbe186e$export$f927a458389aff16 = 0;
var $364547bd6bbe186e$var$isPerfect = function(v) {
    if (v === 0) return true;
    if (v === 3) return true;
    if (v === 4) return true;
    return false;
};
var $364547bd6bbe186e$export$91da1962ebda3f48 = function(dict) {
    return dict.internalOctaves;
};
var $364547bd6bbe186e$export$bcb4acd77ce96da3 = function(dict) {
    return dict.generic;
};
var $364547bd6bbe186e$export$1e53641c7d477448 = /* #__PURE__ */ function() {
    return $364547bd6bbe186e$export$330de7f6cbc5669c(-1);
}();
var $364547bd6bbe186e$export$257a6a801936e2d8 = /* #__PURE__ */ function() {
    return $364547bd6bbe186e$export$3d2fd4bf335ca738(-1)(1);
}();
var $364547bd6bbe186e$export$5714e04682b095ec = /* #__PURE__ */ function() {
    return -1;
}();
var $364547bd6bbe186e$var$fifths2degree = function(fifths1) {
    return $364547bd6bbe186e$var$mod(fifths1 * 4 | 0)(7);
};
var $364547bd6bbe186e$export$698535b0a733192b = {
    fifths: function(v) {
        return v;
    },
    octaves: function(v) {
        return 0;
    },
    internalOctaves: function(v) {
        return 0;
    },
    degree: function(v) {
        return $364547bd6bbe186e$var$fifths2degree(v);
    },
    generic: function(v) {
        return $364547bd6bbe186e$var$fifths2degree(v);
    },
    diasteps: function(v) {
        return $364547bd6bbe186e$var$fifths2degree(v);
    },
    alteration: function(v) {
        return $364547bd6bbe186e$var$div(v + 1 | 0)(7);
    }
};
var $364547bd6bbe186e$export$1c8a38e812a2567d = function(dict) {
    return dict.fifths;
};
var $364547bd6bbe186e$export$460191f7bd848db2 = /* #__PURE__ */ $364547bd6bbe186e$export$330de7f6cbc5669c(1);
var $364547bd6bbe186e$export$60293e228193f614 = /* #__PURE__ */ $364547bd6bbe186e$export$3d2fd4bf335ca738(1)(0);
var $364547bd6bbe186e$export$7c9df1bfbd0f6782 = function(dict) {
    return dict.diasteps;
};
var $364547bd6bbe186e$var$diasteps1 = /* #__PURE__ */ $364547bd6bbe186e$export$7c9df1bfbd0f6782($364547bd6bbe186e$export$698535b0a733192b);
var $364547bd6bbe186e$export$333a3644c6deea4c = {
    octave: /* #__PURE__ */ $364547bd6bbe186e$export$330de7f6cbc5669c(0),
    direction: function(i) {
        var dia = $364547bd6bbe186e$var$diasteps1(i);
        var $226 = dia === 0;
        if ($226) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        var $227 = dia < 4;
        if ($227) return $5026be88823ef1f4$export$b023c82b48e70453.value;
        return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
    },
    Group0: function() {
        return $364547bd6bbe186e$export$99a5747405ec185d;
    }
};
var $364547bd6bbe186e$var$iminus = /* #__PURE__ */ $6416bd93bb20ed95$export$21ada29389cb5cc6($364547bd6bbe186e$export$333a3644c6deea4c);
var $364547bd6bbe186e$var$pplusi = /* #__PURE__ */ $6416bd93bb20ed95$export$c82d2a67a8683548($364547bd6bbe186e$export$333a3644c6deea4c);
var $364547bd6bbe186e$var$itimes = /* #__PURE__ */ $6416bd93bb20ed95$export$8819cf204dded793($364547bd6bbe186e$export$333a3644c6deea4c);
var $364547bd6bbe186e$var$down = /* #__PURE__ */ $6416bd93bb20ed95$export$5df884bdba3ad6a1($364547bd6bbe186e$export$333a3644c6deea4c);
var $364547bd6bbe186e$export$daf930124155dc7f = function(v) {
    return $364547bd6bbe186e$var$iminus($364547bd6bbe186e$export$330de7f6cbc5669c(2))(v);
};
var $364547bd6bbe186e$export$6213e489413b9363 = function(v) {
    return $364547bd6bbe186e$var$iminus($364547bd6bbe186e$export$330de7f6cbc5669c(5))(v);
};
var $364547bd6bbe186e$export$9da9113aff8e9a95 = function(v) {
    return $364547bd6bbe186e$var$iminus($364547bd6bbe186e$export$330de7f6cbc5669c(3))(v);
};
var $364547bd6bbe186e$export$955d979a278e4216 = function(v) {
    return $364547bd6bbe186e$var$iminus($364547bd6bbe186e$export$330de7f6cbc5669c(4))(v);
};
var $364547bd6bbe186e$export$c5322ba33f9d8e68 = {
    chromaticSemitone: /* #__PURE__ */ $364547bd6bbe186e$export$330de7f6cbc5669c(7),
    Interval0: function() {
        return $364547bd6bbe186e$export$333a3644c6deea4c;
    }
};
var $364547bd6bbe186e$var$chromaticSemitone = /* #__PURE__ */ $6416bd93bb20ed95$export$27ad0bd72d3a7fb($364547bd6bbe186e$export$c5322ba33f9d8e68);
var $364547bd6bbe186e$var$toSPC = function(fs) {
    return function(v) {
        return $364547bd6bbe186e$var$pplusi($364547bd6bbe186e$export$2fef8ec835a7bac8(fs))($364547bd6bbe186e$var$itimes($364547bd6bbe186e$var$chromaticSemitone)(v));
    };
};
var $364547bd6bbe186e$export$3dab08e878746cb5 = /* #__PURE__ */ $364547bd6bbe186e$var$toSPC(4);
var $364547bd6bbe186e$export$551e08109e8381df = /* #__PURE__ */ function() {
    return $364547bd6bbe186e$var$toSPC(-1);
}();
var $364547bd6bbe186e$export$2859fb6bd29cb0e0 = /* #__PURE__ */ $364547bd6bbe186e$var$toSPC(1);
var $364547bd6bbe186e$export$b9eb3b5b2e47d985 = {
    ic: function(i) {
        return i;
    },
    Interval0: function() {
        return $364547bd6bbe186e$export$333a3644c6deea4c;
    },
    Interval1: function() {
        return $364547bd6bbe186e$export$333a3644c6deea4c;
    }
};
var $364547bd6bbe186e$export$a23b7da4bc008930 = function(dict) {
    return dict.degree;
};
var $364547bd6bbe186e$var$degree1 = /* #__PURE__ */ $364547bd6bbe186e$export$a23b7da4bc008930($364547bd6bbe186e$export$698535b0a733192b);
var $364547bd6bbe186e$export$cb9ca4c76889c909 = {
    isStep: function(i) {
        var deg = $364547bd6bbe186e$var$degree1(i);
        return deg === 0 || deg === 1 || deg === 6;
    },
    Interval0: function() {
        return $364547bd6bbe186e$export$333a3644c6deea4c;
    }
};
var $364547bd6bbe186e$export$306e929625906797 = {
    fifths: function(v) {
        return v.fifths;
    },
    octaves: function(v) {
        return v.octaves + $364547bd6bbe186e$var$div(v.fifths * 4 | 0)(7) | 0;
    },
    internalOctaves: function(v) {
        return v.octaves;
    },
    degree: function(v) {
        return $364547bd6bbe186e$var$fifths2degree(v.fifths);
    },
    generic: function(i) {
        if ($364547bd6bbe186e$var$eq1($6416bd93bb20ed95$export$9fddb9d0dd7d8a54($364547bd6bbe186e$export$886b8a4150fa978e)(i))($5026be88823ef1f4$export$7158f0ceb70f54c7.value)) return -$364547bd6bbe186e$export$a23b7da4bc008930($364547bd6bbe186e$export$306e929625906797)($6416bd93bb20ed95$export$5df884bdba3ad6a1($364547bd6bbe186e$export$886b8a4150fa978e)(i)) | 0;
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $364547bd6bbe186e$export$a23b7da4bc008930($364547bd6bbe186e$export$306e929625906797)(i);
        throw new Error("Failed pattern match at Data.Pitches.Spelled (line 346, column 1 - line 355, column 47): " + [
            i.constructor.name
        ]);
    },
    diasteps: function(v) {
        return (v.fifths * 4 | 0) + (v.octaves * 7 | 0) | 0;
    },
    alteration: function(i) {
        return $364547bd6bbe186e$var$div($364547bd6bbe186e$export$1c8a38e812a2567d($364547bd6bbe186e$export$306e929625906797)($6416bd93bb20ed95$export$32d79d7074ad12f8($364547bd6bbe186e$export$886b8a4150fa978e)(i)) + 1 | 0)(7);
    }
};
var $364547bd6bbe186e$export$886b8a4150fa978e = {
    octave: /* #__PURE__ */ $364547bd6bbe186e$export$3d2fd4bf335ca738(0)(1),
    direction: function(i) {
        return $364547bd6bbe186e$var$compare($364547bd6bbe186e$export$7c9df1bfbd0f6782($364547bd6bbe186e$export$306e929625906797)(i))(0);
    },
    Group0: function() {
        return $364547bd6bbe186e$export$b9652c203a758dfb;
    }
};
var $364547bd6bbe186e$var$iminus1 = /* #__PURE__ */ $6416bd93bb20ed95$export$21ada29389cb5cc6($364547bd6bbe186e$export$886b8a4150fa978e);
var $364547bd6bbe186e$var$itimes1 = /* #__PURE__ */ $6416bd93bb20ed95$export$8819cf204dded793($364547bd6bbe186e$export$886b8a4150fa978e);
var $364547bd6bbe186e$var$pplusi1 = /* #__PURE__ */ $6416bd93bb20ed95$export$c82d2a67a8683548($364547bd6bbe186e$export$886b8a4150fa978e);
var $364547bd6bbe186e$var$diasteps2 = /* #__PURE__ */ $364547bd6bbe186e$export$7c9df1bfbd0f6782($364547bd6bbe186e$export$306e929625906797);
var $364547bd6bbe186e$var$down1 = /* #__PURE__ */ $6416bd93bb20ed95$export$5df884bdba3ad6a1($364547bd6bbe186e$export$886b8a4150fa978e);
var $364547bd6bbe186e$var$direction = /* #__PURE__ */ $6416bd93bb20ed95$export$9fddb9d0dd7d8a54($364547bd6bbe186e$export$886b8a4150fa978e);
var $364547bd6bbe186e$var$octaves1 = /* #__PURE__ */ $364547bd6bbe186e$export$e82039437d8924cc($364547bd6bbe186e$export$306e929625906797);
var $364547bd6bbe186e$var$degree2 = /* #__PURE__ */ $364547bd6bbe186e$export$a23b7da4bc008930($364547bd6bbe186e$export$306e929625906797);
var $364547bd6bbe186e$export$3d3c77ce7df7d30d = function(v) {
    return $364547bd6bbe186e$var$iminus1($364547bd6bbe186e$export$3d2fd4bf335ca738(2)(-1))(v);
};
var $364547bd6bbe186e$export$97cbe6b6894c3d90 = function(v) {
    return $364547bd6bbe186e$var$iminus1($364547bd6bbe186e$export$3d2fd4bf335ca738(5)(-2))(v);
};
var $364547bd6bbe186e$export$29303c35114bebb = function(v) {
    return $364547bd6bbe186e$var$iminus1($364547bd6bbe186e$export$3d2fd4bf335ca738(3)(-1))(v);
};
var $364547bd6bbe186e$export$1fa4a8860392dfdb = function(v) {
    return $364547bd6bbe186e$var$iminus1($364547bd6bbe186e$export$3d2fd4bf335ca738(4)(-2))(v);
};
var $364547bd6bbe186e$export$4aa48072f1bb973d = /* #__PURE__ */ function() {
    return {
        chromaticSemitone: $364547bd6bbe186e$export$3d2fd4bf335ca738(7)(-4),
        Interval0: function() {
            return $364547bd6bbe186e$export$886b8a4150fa978e;
        }
    };
}();
var $364547bd6bbe186e$var$chromaticSemitone1 = /* #__PURE__ */ $6416bd93bb20ed95$export$27ad0bd72d3a7fb($364547bd6bbe186e$export$4aa48072f1bb973d);
var $364547bd6bbe186e$export$8982dda425250557 = function(n) {
    return $364547bd6bbe186e$var$iminus1($364547bd6bbe186e$var$itimes1($364547bd6bbe186e$export$c8b72c7fa39a2f33)(n))($364547bd6bbe186e$var$itimes1($364547bd6bbe186e$var$chromaticSemitone1)(2 * n | 0));
};
var $364547bd6bbe186e$export$f11a862be6307a06 = function(dia) {
    return function(chrom) {
        var diaPart = $364547bd6bbe186e$var$itimes1($364547bd6bbe186e$export$c8b72c7fa39a2f33)(dia);
        var chromPart = $364547bd6bbe186e$var$itimes1($364547bd6bbe186e$var$chromaticSemitone1)(chrom - (2 * dia | 0) | 0);
        return $364547bd6bbe186e$var$append1(diaPart)(chromPart);
    };
};
var $364547bd6bbe186e$var$toSpelled = function(fs) {
    return function(os) {
        return function(v) {
            return function(oct) {
                return $364547bd6bbe186e$var$pplusi1($364547bd6bbe186e$export$64e237f64278e8d0(fs)(os + oct | 0))($364547bd6bbe186e$var$itimes1($364547bd6bbe186e$var$chromaticSemitone1)(v));
            };
        };
    };
};
var $364547bd6bbe186e$export$f1e1789686576879 = /* #__PURE__ */ function() {
    return $364547bd6bbe186e$var$toSpelled(4)(-2);
}();
var $364547bd6bbe186e$export$2d1720544b23b823 = /* #__PURE__ */ function() {
    return $364547bd6bbe186e$var$toSpelled(-1)(1);
}();
var $364547bd6bbe186e$export$39b482c5e57630a8 = /* #__PURE__ */ $364547bd6bbe186e$var$toSpelled(1)(0);
var $364547bd6bbe186e$export$4f21ae11f28cc69e = /* #__PURE__ */ $6416bd93bb20ed95$export$fa0afabb4c4452e5($364547bd6bbe186e$export$4aa48072f1bb973d)($364547bd6bbe186e$export$257a6a801936e2d8);
var $364547bd6bbe186e$export$d6c1f64478bbe186 = {
    isStep: function(i) {
        return $364547bd6bbe186e$var$abs($364547bd6bbe186e$var$diasteps2(i)) < 2;
    },
    Interval0: function() {
        return $364547bd6bbe186e$export$886b8a4150fa978e;
    }
};
var $364547bd6bbe186e$export$57bf37558439571a = {
    ic: function(v) {
        return $364547bd6bbe186e$export$330de7f6cbc5669c(v.fifths);
    },
    Interval0: function() {
        return $364547bd6bbe186e$export$886b8a4150fa978e;
    },
    Interval1: function() {
        return $364547bd6bbe186e$export$333a3644c6deea4c;
    }
};
var $364547bd6bbe186e$export$5e52029268498d83 = {
    emb: function(v) {
        return $364547bd6bbe186e$export$3d2fd4bf335ca738(v)(-$364547bd6bbe186e$var$div(v * 4 | 0)(7) | 0);
    },
    Interval0: function() {
        return $364547bd6bbe186e$export$886b8a4150fa978e;
    },
    Interval1: function() {
        return $364547bd6bbe186e$export$333a3644c6deea4c;
    }
};
var $364547bd6bbe186e$export$ee896b56322694 = {
    emb: function(i) {
        return i;
    },
    Interval0: function() {
        return $364547bd6bbe186e$export$886b8a4150fa978e;
    },
    Interval1: function() {
        return $364547bd6bbe186e$export$886b8a4150fa978e;
    }
};
var $364547bd6bbe186e$export$5e98bfc7ae3dacc = /* #__PURE__ */ $364547bd6bbe186e$var$toSPC(2);
var $364547bd6bbe186e$export$4368d992c4eafac0 = /* #__PURE__ */ function() {
    return $364547bd6bbe186e$var$toSpelled(2)(-1);
}();
var $364547bd6bbe186e$export$2c9c3a58672be3a8 = /* #__PURE__ */ $364547bd6bbe186e$var$toSPC(0);
var $364547bd6bbe186e$export$db3b6bfb95261072 = /* #__PURE__ */ $364547bd6bbe186e$var$toSpelled(0)(0);
var $364547bd6bbe186e$export$73045757eb41c970 = /* #__PURE__ */ $364547bd6bbe186e$var$toSPC(5);
var $364547bd6bbe186e$export$8b22cf2602fb60ce = /* #__PURE__ */ function() {
    return $364547bd6bbe186e$var$toSpelled(5)(-2);
}();
var $364547bd6bbe186e$var$asciiA = /* #__PURE__ */ $50b5a2f2b28bbba4$export$d90166409dd04e85("A");
var $364547bd6bbe186e$export$30780d0b6b610af8 = function(dictSpelled) {
    var degree3 = $364547bd6bbe186e$export$a23b7da4bc008930(dictSpelled);
    return function(i) {
        return $3ee2158c14339cc9$export$439306a4dcaafbb9($3ee2158c14339cc9$export$dd1029f96c3dd62a($06733ae99ed4f534$export$43db023a260c5e9f("X")($50b5a2f2b28bbba4$export$30216c0101da0ee0($364547bd6bbe186e$var$asciiA + $364547bd6bbe186e$var$mod(degree3(i) + 2 | 0)(7) | 0))));
    };
};
var $364547bd6bbe186e$var$parseName = /* #__PURE__ */ $364547bd6bbe186e$var$bind(/* #__PURE__ */ $364547bd6bbe186e$var$oneOf([
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G"
]))(function(name) {
    var dia = $364547bd6bbe186e$var$mod(($50b5a2f2b28bbba4$export$d90166409dd04e85(name) - $364547bd6bbe186e$var$asciiA | 0) - 2 | 0)(7);
    return $364547bd6bbe186e$var$bind($364547bd6bbe186e$var$parseAccs)(function(acc) {
        return $364547bd6bbe186e$var$pure(($364547bd6bbe186e$var$mod((dia * 2 | 0) + 1 | 0)(7) - 1 | 0) + (7 * acc | 0) | 0);
    });
});
var $364547bd6bbe186e$export$29900f3432fee46c = function(dict) {
    return dict.alteration;
};
var $364547bd6bbe186e$var$alteration1 = /* #__PURE__ */ $364547bd6bbe186e$export$29900f3432fee46c($364547bd6bbe186e$export$306e929625906797);
var $364547bd6bbe186e$var$alteration2 = /* #__PURE__ */ $364547bd6bbe186e$export$29900f3432fee46c($364547bd6bbe186e$export$698535b0a733192b);
var $364547bd6bbe186e$export$aa156b69905f503 = {
    compare: function(i1) {
        return function(i2) {
            return $364547bd6bbe186e$var$compare1([
                $364547bd6bbe186e$var$diasteps2(i1),
                $364547bd6bbe186e$var$alteration1(i1)
            ])([
                $364547bd6bbe186e$var$diasteps2(i2),
                $364547bd6bbe186e$var$alteration1(i2)
            ]);
        };
    },
    Eq0: function() {
        return $364547bd6bbe186e$export$66d6281a18f726a9;
    }
};
var $364547bd6bbe186e$export$c9a427c646d98c91 = function(dictSpelled) {
    var fifths1 = $364547bd6bbe186e$export$1c8a38e812a2567d(dictSpelled);
    var octaves3 = $364547bd6bbe186e$export$e82039437d8924cc(dictSpelled);
    var internalOctaves1 = $364547bd6bbe186e$export$91da1962ebda3f48(dictSpelled);
    var degree3 = $364547bd6bbe186e$export$a23b7da4bc008930(dictSpelled);
    return function(dictHasIntervalClass) {
        var ic = $6416bd93bb20ed95$export$31770fd800a3b4bd(dictHasIntervalClass);
        return function(dictSpelled1) {
            var alteration5 = $364547bd6bbe186e$export$29900f3432fee46c(dictSpelled1);
            return {
                fifths: function(v) {
                    return fifths1(v);
                },
                octaves: function(v) {
                    return octaves3(v);
                },
                internalOctaves: function(v) {
                    return internalOctaves1(v);
                },
                degree: function(v) {
                    return degree3(v);
                },
                generic: function(v) {
                    return degree3(v);
                },
                diasteps: function(v) {
                    return degree3(v);
                },
                alteration: function(v) {
                    return alteration5(ic(v));
                }
            };
        };
    };
};
var $364547bd6bbe186e$var$spelledPitch1 = /* #__PURE__ */ $364547bd6bbe186e$export$c9a427c646d98c91($364547bd6bbe186e$export$698535b0a733192b)($364547bd6bbe186e$export$b9eb3b5b2e47d985)($364547bd6bbe186e$export$698535b0a733192b);
var $364547bd6bbe186e$var$alteration3 = /* #__PURE__ */ $364547bd6bbe186e$export$29900f3432fee46c($364547bd6bbe186e$var$spelledPitch1);
var $364547bd6bbe186e$var$letter1 = /* #__PURE__ */ $364547bd6bbe186e$export$30780d0b6b610af8($364547bd6bbe186e$var$spelledPitch1);
var $364547bd6bbe186e$var$spelledPitch2 = /* #__PURE__ */ $364547bd6bbe186e$export$c9a427c646d98c91($364547bd6bbe186e$export$306e929625906797)($364547bd6bbe186e$export$57bf37558439571a)($364547bd6bbe186e$export$698535b0a733192b);
var $364547bd6bbe186e$var$alteration4 = /* #__PURE__ */ $364547bd6bbe186e$export$29900f3432fee46c($364547bd6bbe186e$var$spelledPitch2);
var $364547bd6bbe186e$var$letter2 = /* #__PURE__ */ $364547bd6bbe186e$export$30780d0b6b610af8($364547bd6bbe186e$var$spelledPitch2);
var $364547bd6bbe186e$var$octaves2 = /* #__PURE__ */ $364547bd6bbe186e$export$e82039437d8924cc($364547bd6bbe186e$var$spelledPitch2);
var $364547bd6bbe186e$var$altQual = /* #__PURE__ */ $364547bd6bbe186e$var$bind(/* #__PURE__ */ $364547bd6bbe186e$var$oneOf([
    "M",
    "P",
    "m"
]))(function(qual) {
    if (qual === "P") return $364547bd6bbe186e$var$pure(function(pf) {
        if (pf) return $364547bd6bbe186e$var$pure(0);
        return $05fb1b61396adfce$export$2b62a06a9fee979c("used P on an imperfect interval");
    });
    if (qual === "M") return $364547bd6bbe186e$var$pure(function(pf) {
        if (pf) return $05fb1b61396adfce$export$2b62a06a9fee979c("used M on a perfect interval");
        return $364547bd6bbe186e$var$pure(0);
    });
    if (qual === "m") return $364547bd6bbe186e$var$pure(function(pf) {
        if (pf) return $05fb1b61396adfce$export$2b62a06a9fee979c("used m on a perfect interval");
        return $364547bd6bbe186e$var$pure(-1);
    });
    return $05fb1b61396adfce$export$2b62a06a9fee979c("unknown qualifier " + $364547bd6bbe186e$var$show(qual));
});
var $364547bd6bbe186e$var$altDim = /* #__PURE__ */ $364547bd6bbe186e$var$bind(/* #__PURE__ */ $fb26133a5ec46bf7$export$a6482580fab70c30(/* #__PURE__ */ $9da596880af1a1c5$export$eba6f6f03b0a92e7("d")))(function(ds) {
    return $364547bd6bbe186e$var$pure(function(pf) {
        return $364547bd6bbe186e$var$pure((-$ba51d599f79a6310$export$f24224f1c91d8156(ds) | 0) - function() {
            if (pf) return 0;
            return 1;
        }() | 0);
    });
});
var $364547bd6bbe186e$var$altAug = /* #__PURE__ */ $364547bd6bbe186e$var$bind(/* #__PURE__ */ $fb26133a5ec46bf7$export$a6482580fab70c30(/* #__PURE__ */ $9da596880af1a1c5$export$eba6f6f03b0a92e7("a")))(function(as) {
    return $364547bd6bbe186e$var$pure(function(v) {
        return $364547bd6bbe186e$var$pure($ba51d599f79a6310$export$f24224f1c91d8156(as));
    });
});
var $364547bd6bbe186e$var$parseDia = /* #__PURE__ */ $364547bd6bbe186e$var$bind(/* #__PURE__ */ $364547bd6bbe186e$var$alt($364547bd6bbe186e$var$altAug)(/* #__PURE__ */ $364547bd6bbe186e$var$alt($364547bd6bbe186e$var$altDim)($364547bd6bbe186e$var$altQual)))(function(falt) {
    return $364547bd6bbe186e$var$bind($364547bd6bbe186e$var$map1(function(x) {
        return x - 1 | 0;
    })($9c51fc614470d5ef$export$5eb46e8ce08641d5))(function(dia) {
        return $364547bd6bbe186e$var$bind(falt($364547bd6bbe186e$var$isPerfect(dia)))(function(alt1) {
            return $364547bd6bbe186e$var$pure(($364547bd6bbe186e$var$mod((dia * 2 | 0) + 1 | 0)(7) - 1 | 0) + (7 * alt1 | 0) | 0);
        });
    });
});
var $364547bd6bbe186e$export$c599455d51841c5d = {
    parseNotation: function(str) {
        var parser = $364547bd6bbe186e$var$bind($fb26133a5ec46bf7$export$a75d1723e6bda2ec("+")($9da596880af1a1c5$export$eba6f6f03b0a92e7("-")))(function(sign) {
            return $364547bd6bbe186e$var$bind($364547bd6bbe186e$var$map1($364547bd6bbe186e$export$330de7f6cbc5669c)($364547bd6bbe186e$var$parseDia))(function(i) {
                return $364547bd6bbe186e$var$discard($9da596880af1a1c5$export$d83becf4b42ec59)(function() {
                    return $364547bd6bbe186e$var$pure(function() {
                        var $256 = sign === "-";
                        if ($256) return $364547bd6bbe186e$var$down(i);
                        return i;
                    }());
                });
            });
        });
        return $7d4cccdf062a2261$export$3a6c138b8d0f3874($05fb1b61396adfce$export$4ad9239eebc1597f(parser)(str));
    },
    showNotation: function(i) {
        var dia = $364547bd6bbe186e$var$diasteps1(i);
        var alt1 = $364547bd6bbe186e$var$alteration2(i);
        var qual = function() {
            var $257 = $364547bd6bbe186e$var$isPerfect(dia);
            if ($257) return $364547bd6bbe186e$var$qualpf(alt1)("a")("P")("d");
            return $364547bd6bbe186e$var$qualimpf(alt1)("a")("M")("m")("d");
        }();
        return qual + $364547bd6bbe186e$var$show1(dia + 1 | 0);
    }
};
var $364547bd6bbe186e$var$readJSONviaParse = /* #__PURE__ */ $9c51fc614470d5ef$export$4eeb8640e70bb459($364547bd6bbe186e$export$c599455d51841c5d);
var $364547bd6bbe186e$var$showNotation = /* #__PURE__ */ $6416bd93bb20ed95$export$8331a0df97365f6e($364547bd6bbe186e$export$c599455d51841c5d);
var $364547bd6bbe186e$export$3617dcd876305a78 = /* #__PURE__ */ $6416bd93bb20ed95$export$a1d30b4ebfb67400($364547bd6bbe186e$export$c599455d51841c5d);
var $364547bd6bbe186e$export$74cdfd5ac3584b46 = {
    readImpl: function(input) {
        return $364547bd6bbe186e$var$readJSONviaParse("spelled interval class")(input);
    }
};
var $364547bd6bbe186e$export$739a16604e2eea86 = {
    show: $364547bd6bbe186e$var$showNotation
};
var $364547bd6bbe186e$export$b80d058bde301e71 = {
    writeImpl: function($267) {
        return $364547bd6bbe186e$var$writeImpl($364547bd6bbe186e$var$showNotation($267));
    }
};
var $364547bd6bbe186e$export$507afa45b43dacb6 = {
    parseNotation: function(str) {
        var parser = $364547bd6bbe186e$var$bind($fb26133a5ec46bf7$export$a75d1723e6bda2ec("+")($9da596880af1a1c5$export$eba6f6f03b0a92e7("-")))(function(sign) {
            return $364547bd6bbe186e$var$bind($364547bd6bbe186e$var$parseDia)(function(fs) {
                return $364547bd6bbe186e$var$bind($9da596880af1a1c5$export$eba6f6f03b0a92e7(":"))(function() {
                    return $364547bd6bbe186e$var$bind($9c51fc614470d5ef$export$174cdaddec9e0332)(function(os) {
                        return $364547bd6bbe186e$var$discard($9da596880af1a1c5$export$d83becf4b42ec59)(function() {
                            var i = {
                                fifths: fs,
                                octaves: os - $364547bd6bbe186e$var$div(fs * 4 | 0)(7) | 0
                            };
                            return $364547bd6bbe186e$var$pure(function() {
                                var $258 = sign === "-";
                                if ($258) return $364547bd6bbe186e$var$down1(i);
                                return i;
                            }());
                        });
                    });
                });
            });
        });
        return $7d4cccdf062a2261$export$3a6c138b8d0f3874($05fb1b61396adfce$export$4ad9239eebc1597f(parser)(str));
    },
    showNotation: function(i) {
        if ($364547bd6bbe186e$var$eq1($364547bd6bbe186e$var$direction(i))($5026be88823ef1f4$export$7158f0ceb70f54c7.value)) return "-" + $2c6b3d51d10471a7$export$57bf213be019eeb0($364547bd6bbe186e$var$$lazy_showSInterval(0))($364547bd6bbe186e$var$down1(i));
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
            var octs = $364547bd6bbe186e$var$show1($364547bd6bbe186e$var$octaves1(i));
            var deg = $364547bd6bbe186e$var$degree2(i);
            var dia = $364547bd6bbe186e$var$show1(deg + 1 | 0);
            var alt1 = $364547bd6bbe186e$var$alteration1(i);
            var qual = function() {
                var $260 = $364547bd6bbe186e$var$isPerfect(deg);
                if ($260) return $364547bd6bbe186e$var$qualpf(alt1)("a")("P")("d");
                return $364547bd6bbe186e$var$qualimpf(alt1)("a")("M")("m")("d");
            }();
            return qual + (dia + (":" + octs));
        }
        throw new Error("Failed pattern match at Data.Pitches.Spelled (line 685, column 1 - line 713, column 32): " + [
            i.constructor.name
        ]);
    }
};
var $364547bd6bbe186e$var$$lazy_showSInterval = /* #__PURE__ */ $364547bd6bbe186e$var$$runtime_lazy("showSInterval", "Data.Pitches.Spelled", function() {
    return {
        show: $6416bd93bb20ed95$export$8331a0df97365f6e($364547bd6bbe186e$export$507afa45b43dacb6)
    };
});
var $364547bd6bbe186e$export$cd65b553bb0e1ad1 = /* #__PURE__ */ $364547bd6bbe186e$var$$lazy_showSInterval(388);
var $364547bd6bbe186e$export$a0ff226df4ab2533 = /* #__PURE__ */ $6416bd93bb20ed95$export$a1d30b4ebfb67400($364547bd6bbe186e$export$507afa45b43dacb6);
var $364547bd6bbe186e$export$2a6f53d24a97c824 = {
    readImpl: /* #__PURE__ */ $9c51fc614470d5ef$export$4eeb8640e70bb459($364547bd6bbe186e$export$507afa45b43dacb6)("spelled interval")
};
var $364547bd6bbe186e$export$c76e211df755d106 = {
    writeImpl: /* #__PURE__ */ function() {
        var $268 = $6416bd93bb20ed95$export$8331a0df97365f6e($364547bd6bbe186e$export$507afa45b43dacb6);
        return function($269) {
            return $364547bd6bbe186e$var$writeImpl($268($269));
        };
    }()
};
var $364547bd6bbe186e$var$accstr = function(n) {
    return function(lu) {
        return function(ld) {
            if (n === 0) return "";
            if (n > 0) return $364547bd6bbe186e$var$power(lu)(n);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $364547bd6bbe186e$var$power(ld)($364547bd6bbe186e$var$abs(n));
            throw new Error("Failed pattern match at Data.Pitches.Spelled (line 212, column 1 - line 212, column 44): " + [
                n.constructor.name,
                lu.constructor.name,
                ld.constructor.name
            ]);
        };
    };
};
var $364547bd6bbe186e$export$e56f383a98d490bd = {
    parsePitchNotation: function(str) {
        var parser = $364547bd6bbe186e$var$bind($364547bd6bbe186e$var$parseName)(function(fifths1) {
            return $364547bd6bbe186e$var$discard($9da596880af1a1c5$export$d83becf4b42ec59)(function() {
                return $364547bd6bbe186e$var$pure($364547bd6bbe186e$export$330de7f6cbc5669c(fifths1));
            });
        });
        return $7d4cccdf062a2261$export$3a6c138b8d0f3874($05fb1b61396adfce$export$4ad9239eebc1597f(parser)(str));
    },
    showPitchNotation: function(i) {
        var accs = $364547bd6bbe186e$var$accstr($364547bd6bbe186e$var$alteration3(i))("\u266F")("\u266D");
        return $364547bd6bbe186e$var$letter1(i) + accs;
    }
};
var $364547bd6bbe186e$var$notationPitch = /* #__PURE__ */ $6416bd93bb20ed95$export$9856c32cde0cc9aa($364547bd6bbe186e$export$e56f383a98d490bd);
var $364547bd6bbe186e$var$readJSONviaParse1 = /* #__PURE__ */ $9c51fc614470d5ef$export$4eeb8640e70bb459($364547bd6bbe186e$var$notationPitch);
var $364547bd6bbe186e$var$showNotation1 = /* #__PURE__ */ $6416bd93bb20ed95$export$8331a0df97365f6e($364547bd6bbe186e$var$notationPitch);
var $364547bd6bbe186e$export$17607cacb7433653 = /* #__PURE__ */ $6416bd93bb20ed95$export$a1d30b4ebfb67400($364547bd6bbe186e$var$notationPitch);
var $364547bd6bbe186e$export$9bc1d3c57c0ca117 = {
    readImplPitch: function(input) {
        return $364547bd6bbe186e$var$readJSONviaParse1("spelled pitch class")(input);
    }
};
var $364547bd6bbe186e$export$66314a246ad52432 = {
    writeImplPitch: function(i) {
        return $364547bd6bbe186e$var$writeImpl($364547bd6bbe186e$var$showNotation1(i));
    }
};
var $364547bd6bbe186e$export$6c410b696f956741 = {
    parsePitchNotation: function(str) {
        var parser = $364547bd6bbe186e$var$bind($364547bd6bbe186e$var$parseName)(function(fs) {
            return $364547bd6bbe186e$var$bind($9c51fc614470d5ef$export$174cdaddec9e0332)(function(os) {
                return $364547bd6bbe186e$var$discard($9da596880af1a1c5$export$d83becf4b42ec59)(function() {
                    return $364547bd6bbe186e$var$pure($364547bd6bbe186e$export$3d2fd4bf335ca738(fs)(os - $364547bd6bbe186e$var$div(fs * 4 | 0)(7) | 0));
                });
            });
        });
        return $7d4cccdf062a2261$export$3a6c138b8d0f3874($05fb1b61396adfce$export$4ad9239eebc1597f(parser)(str));
    },
    showPitchNotation: function(i) {
        var accs = $364547bd6bbe186e$var$accstr($364547bd6bbe186e$var$alteration4(i))("\u266F")("\u266D");
        return $364547bd6bbe186e$var$letter2(i) + (accs + $364547bd6bbe186e$var$show1($364547bd6bbe186e$var$octaves2(i)));
    }
};
var $364547bd6bbe186e$var$notationPitch1 = /* #__PURE__ */ $6416bd93bb20ed95$export$9856c32cde0cc9aa($364547bd6bbe186e$export$6c410b696f956741);
var $364547bd6bbe186e$var$readJSONviaParse2 = /* #__PURE__ */ $9c51fc614470d5ef$export$4eeb8640e70bb459($364547bd6bbe186e$var$notationPitch1);
var $364547bd6bbe186e$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $6416bd93bb20ed95$export$26082705e1e7e214($364547bd6bbe186e$export$6c410b696f956741));
var $364547bd6bbe186e$export$558aee998e5216dd = /* #__PURE__ */ $6416bd93bb20ed95$export$a1d30b4ebfb67400($364547bd6bbe186e$var$notationPitch1);
var $364547bd6bbe186e$export$8fa8fdf6603d008 = {
    readImplPitch: function(input) {
        return $364547bd6bbe186e$var$readJSONviaParse2("spelled pitch")(input);
    }
};
var $364547bd6bbe186e$export$3bd3ca022f264a51 = {
    writeImplPitch: function(i) {
        return $364547bd6bbe186e$var$writeImpl($364547bd6bbe186e$var$show2(i));
    }
};
var $364547bd6bbe186e$export$a8a690cfca4daa34 = /* #__PURE__ */ $364547bd6bbe186e$var$toSPC(3);
var $364547bd6bbe186e$export$407448d2b89b1813 = /* #__PURE__ */ function() {
    return $364547bd6bbe186e$var$toSpelled(3)(-1);
}();





// Generated by purs version 0.15.15

// Generated by purs version 0.15.15


// Generated by purs version 0.15.15

var $4d40d048175dacfe$export$7ba2b3d677b0db1c = /* #__PURE__ */ function() {
    function AutocompleteOff() {}
    AutocompleteOff.value = new AutocompleteOff();
    return AutocompleteOff;
}();
var $4d40d048175dacfe$export$1ef0df3f3e6a4dab = /* #__PURE__ */ function() {
    function AutocompleteOn() {}
    AutocompleteOn.value = new AutocompleteOn();
    return AutocompleteOn;
}();
var $4d40d048175dacfe$export$4da01cb598a0d97e = /* #__PURE__ */ function() {
    function AutocompleteName() {}
    AutocompleteName.value = new AutocompleteName();
    return AutocompleteName;
}();
var $4d40d048175dacfe$export$ccb63fd7a749a381 = /* #__PURE__ */ function() {
    function AutocompleteHonorificPrefix() {}
    AutocompleteHonorificPrefix.value = new AutocompleteHonorificPrefix();
    return AutocompleteHonorificPrefix;
}();
var $4d40d048175dacfe$export$a2e3a2bb787472eb = /* #__PURE__ */ function() {
    function AutocompleteGivenName() {}
    AutocompleteGivenName.value = new AutocompleteGivenName();
    return AutocompleteGivenName;
}();
var $4d40d048175dacfe$export$c2899da73c95f826 = /* #__PURE__ */ function() {
    function AutocompleteAdditionalName() {}
    AutocompleteAdditionalName.value = new AutocompleteAdditionalName();
    return AutocompleteAdditionalName;
}();
var $4d40d048175dacfe$export$b189863462ae27fe = /* #__PURE__ */ function() {
    function AutocompleteFamilyName() {}
    AutocompleteFamilyName.value = new AutocompleteFamilyName();
    return AutocompleteFamilyName;
}();
var $4d40d048175dacfe$export$5481c9b080fac1ad = /* #__PURE__ */ function() {
    function AutocompleteHonorificSuffix() {}
    AutocompleteHonorificSuffix.value = new AutocompleteHonorificSuffix();
    return AutocompleteHonorificSuffix;
}();
var $4d40d048175dacfe$export$ed6c67e3f00c02f7 = /* #__PURE__ */ function() {
    function AutocompleteNickname() {}
    AutocompleteNickname.value = new AutocompleteNickname();
    return AutocompleteNickname;
}();
var $4d40d048175dacfe$export$3f2abff6b2574d28 = /* #__PURE__ */ function() {
    function AutocompleteEmail() {}
    AutocompleteEmail.value = new AutocompleteEmail();
    return AutocompleteEmail;
}();
var $4d40d048175dacfe$export$8ef7db4a55783560 = /* #__PURE__ */ function() {
    function AutocompleteUsername() {}
    AutocompleteUsername.value = new AutocompleteUsername();
    return AutocompleteUsername;
}();
var $4d40d048175dacfe$export$2aec4081bfc982fb = /* #__PURE__ */ function() {
    function AutocompleteNewPassword() {}
    AutocompleteNewPassword.value = new AutocompleteNewPassword();
    return AutocompleteNewPassword;
}();
var $4d40d048175dacfe$export$8ee6fb6ac028afda = /* #__PURE__ */ function() {
    function AutocompleteCurrentPassword() {}
    AutocompleteCurrentPassword.value = new AutocompleteCurrentPassword();
    return AutocompleteCurrentPassword;
}();
var $4d40d048175dacfe$export$6f27218568808639 = /* #__PURE__ */ function() {
    function AutocompleteOneTimeCode() {}
    AutocompleteOneTimeCode.value = new AutocompleteOneTimeCode();
    return AutocompleteOneTimeCode;
}();
var $4d40d048175dacfe$export$9748581da6bbbe4e = /* #__PURE__ */ function() {
    function AutocompleteOrganizationTitle() {}
    AutocompleteOrganizationTitle.value = new AutocompleteOrganizationTitle();
    return AutocompleteOrganizationTitle;
}();
var $4d40d048175dacfe$export$5fd9f780846e028b = /* #__PURE__ */ function() {
    function AutocompleteOrganization() {}
    AutocompleteOrganization.value = new AutocompleteOrganization();
    return AutocompleteOrganization;
}();
var $4d40d048175dacfe$export$499720fb85152dfe = /* #__PURE__ */ function() {
    function AutocompleteStreetAddress() {}
    AutocompleteStreetAddress.value = new AutocompleteStreetAddress();
    return AutocompleteStreetAddress;
}();
var $4d40d048175dacfe$export$6b6488e90da63d6 = /* #__PURE__ */ function() {
    function AutocompleteAddressLine1() {}
    AutocompleteAddressLine1.value = new AutocompleteAddressLine1();
    return AutocompleteAddressLine1;
}();
var $4d40d048175dacfe$export$92dfe98bc9dbafde = /* #__PURE__ */ function() {
    function AutocompleteAddressLine2() {}
    AutocompleteAddressLine2.value = new AutocompleteAddressLine2();
    return AutocompleteAddressLine2;
}();
var $4d40d048175dacfe$export$ea74132c1bd19261 = /* #__PURE__ */ function() {
    function AutocompleteAddressLine3() {}
    AutocompleteAddressLine3.value = new AutocompleteAddressLine3();
    return AutocompleteAddressLine3;
}();
var $4d40d048175dacfe$export$e5454c7695ddbd5c = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel1() {}
    AutocompleteAddressLevel1.value = new AutocompleteAddressLevel1();
    return AutocompleteAddressLevel1;
}();
var $4d40d048175dacfe$export$af0e2cc0795570d9 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel2() {}
    AutocompleteAddressLevel2.value = new AutocompleteAddressLevel2();
    return AutocompleteAddressLevel2;
}();
var $4d40d048175dacfe$export$f76ce82784afe674 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel3() {}
    AutocompleteAddressLevel3.value = new AutocompleteAddressLevel3();
    return AutocompleteAddressLevel3;
}();
var $4d40d048175dacfe$export$5f9c079ff6708773 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel4() {}
    AutocompleteAddressLevel4.value = new AutocompleteAddressLevel4();
    return AutocompleteAddressLevel4;
}();
var $4d40d048175dacfe$export$44c5bb026cbe6e37 = /* #__PURE__ */ function() {
    function AutocompleteCountry() {}
    AutocompleteCountry.value = new AutocompleteCountry();
    return AutocompleteCountry;
}();
var $4d40d048175dacfe$export$e259ef3995a99fd4 = /* #__PURE__ */ function() {
    function AutocompleteCountryName() {}
    AutocompleteCountryName.value = new AutocompleteCountryName();
    return AutocompleteCountryName;
}();
var $4d40d048175dacfe$export$f95f909e01aa4cb3 = /* #__PURE__ */ function() {
    function AutocompletePostalCode() {}
    AutocompletePostalCode.value = new AutocompletePostalCode();
    return AutocompletePostalCode;
}();
var $4d40d048175dacfe$export$67ade628725afe90 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardName() {}
    AutocompleteCreditCardName.value = new AutocompleteCreditCardName();
    return AutocompleteCreditCardName;
}();
var $4d40d048175dacfe$export$f03ef3c27a8e4a4b = /* #__PURE__ */ function() {
    function AutocompleteCreditCardGivenName() {}
    AutocompleteCreditCardGivenName.value = new AutocompleteCreditCardGivenName();
    return AutocompleteCreditCardGivenName;
}();
var $4d40d048175dacfe$export$1b45801580e5182f = /* #__PURE__ */ function() {
    function AutocompleteCreditCardAdditionalName() {}
    AutocompleteCreditCardAdditionalName.value = new AutocompleteCreditCardAdditionalName();
    return AutocompleteCreditCardAdditionalName;
}();
var $4d40d048175dacfe$export$d906c17550f3b6f1 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardFamilyName() {}
    AutocompleteCreditCardFamilyName.value = new AutocompleteCreditCardFamilyName();
    return AutocompleteCreditCardFamilyName;
}();
var $4d40d048175dacfe$export$267a9616c09f33fa = /* #__PURE__ */ function() {
    function AutocompleteCreditCardNumber() {}
    AutocompleteCreditCardNumber.value = new AutocompleteCreditCardNumber();
    return AutocompleteCreditCardNumber;
}();
var $4d40d048175dacfe$export$4ac537c498251bbf = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpiration() {}
    AutocompleteCreditCardExpiration.value = new AutocompleteCreditCardExpiration();
    return AutocompleteCreditCardExpiration;
}();
var $4d40d048175dacfe$export$2e15cf96bd811454 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpirationMonth() {}
    AutocompleteCreditCardExpirationMonth.value = new AutocompleteCreditCardExpirationMonth();
    return AutocompleteCreditCardExpirationMonth;
}();
var $4d40d048175dacfe$export$7c4efb1d2d0a7d5d = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpirationYear() {}
    AutocompleteCreditCardExpirationYear.value = new AutocompleteCreditCardExpirationYear();
    return AutocompleteCreditCardExpirationYear;
}();
var $4d40d048175dacfe$export$42f27b71e570e84c = /* #__PURE__ */ function() {
    function AutocompleteCreditCardSecurityCode() {}
    AutocompleteCreditCardSecurityCode.value = new AutocompleteCreditCardSecurityCode();
    return AutocompleteCreditCardSecurityCode;
}();
var $4d40d048175dacfe$export$7dd055ac3e2d902c = /* #__PURE__ */ function() {
    function AutocompleteCreditCardType() {}
    AutocompleteCreditCardType.value = new AutocompleteCreditCardType();
    return AutocompleteCreditCardType;
}();
var $4d40d048175dacfe$export$918eb55efc9f2e5c = /* #__PURE__ */ function() {
    function AutocompleteTransactionCurrency() {}
    AutocompleteTransactionCurrency.value = new AutocompleteTransactionCurrency();
    return AutocompleteTransactionCurrency;
}();
var $4d40d048175dacfe$export$9d4a96b43ef247de = /* #__PURE__ */ function() {
    function AutocompleteTransactionAmount() {}
    AutocompleteTransactionAmount.value = new AutocompleteTransactionAmount();
    return AutocompleteTransactionAmount;
}();
var $4d40d048175dacfe$export$f69bc69473d6d1fa = /* #__PURE__ */ function() {
    function AutocompleteLanguage() {}
    AutocompleteLanguage.value = new AutocompleteLanguage();
    return AutocompleteLanguage;
}();
var $4d40d048175dacfe$export$db103677e4262f74 = /* #__PURE__ */ function() {
    function AutocompleteBirthday() {}
    AutocompleteBirthday.value = new AutocompleteBirthday();
    return AutocompleteBirthday;
}();
var $4d40d048175dacfe$export$976267f1375fd072 = /* #__PURE__ */ function() {
    function AutocompleteBirthdayDay() {}
    AutocompleteBirthdayDay.value = new AutocompleteBirthdayDay();
    return AutocompleteBirthdayDay;
}();
var $4d40d048175dacfe$export$345017daa9311763 = /* #__PURE__ */ function() {
    function AutocompleteBirthdayMonth() {}
    AutocompleteBirthdayMonth.value = new AutocompleteBirthdayMonth();
    return AutocompleteBirthdayMonth;
}();
var $4d40d048175dacfe$export$a58218c48fdc359f = /* #__PURE__ */ function() {
    function AutocompleteBirthdayYear() {}
    AutocompleteBirthdayYear.value = new AutocompleteBirthdayYear();
    return AutocompleteBirthdayYear;
}();
var $4d40d048175dacfe$export$41a3d5735ecfd56f = /* #__PURE__ */ function() {
    function AutocompleteSex() {}
    AutocompleteSex.value = new AutocompleteSex();
    return AutocompleteSex;
}();
var $4d40d048175dacfe$export$dc25bbd279bd7147 = /* #__PURE__ */ function() {
    function AutocompleteTelephone() {}
    AutocompleteTelephone.value = new AutocompleteTelephone();
    return AutocompleteTelephone;
}();
var $4d40d048175dacfe$export$f37489576ac4e3f5 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneCountryCode() {}
    AutocompleteTelephoneCountryCode.value = new AutocompleteTelephoneCountryCode();
    return AutocompleteTelephoneCountryCode;
}();
var $4d40d048175dacfe$export$85265d7dd09c0246 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneNational() {}
    AutocompleteTelephoneNational.value = new AutocompleteTelephoneNational();
    return AutocompleteTelephoneNational;
}();
var $4d40d048175dacfe$export$fb4e6d66ca842722 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneAreaCode() {}
    AutocompleteTelephoneAreaCode.value = new AutocompleteTelephoneAreaCode();
    return AutocompleteTelephoneAreaCode;
}();
var $4d40d048175dacfe$export$149dc202c94ba771 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocal() {}
    AutocompleteTelephoneLocal.value = new AutocompleteTelephoneLocal();
    return AutocompleteTelephoneLocal;
}();
var $4d40d048175dacfe$export$c3fb770456fc7a2e = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocalPrefix() {}
    AutocompleteTelephoneLocalPrefix.value = new AutocompleteTelephoneLocalPrefix();
    return AutocompleteTelephoneLocalPrefix;
}();
var $4d40d048175dacfe$export$97df2b5615a1b054 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocalSuffix() {}
    AutocompleteTelephoneLocalSuffix.value = new AutocompleteTelephoneLocalSuffix();
    return AutocompleteTelephoneLocalSuffix;
}();
var $4d40d048175dacfe$export$7aa0294a80b301d4 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneExtension() {}
    AutocompleteTelephoneExtension.value = new AutocompleteTelephoneExtension();
    return AutocompleteTelephoneExtension;
}();
var $4d40d048175dacfe$export$1294e96da410451d = /* #__PURE__ */ function() {
    function AutocompleteIMPP() {}
    AutocompleteIMPP.value = new AutocompleteIMPP();
    return AutocompleteIMPP;
}();
var $4d40d048175dacfe$export$acf71e1d98edce93 = /* #__PURE__ */ function() {
    function AutocompleteURL() {}
    AutocompleteURL.value = new AutocompleteURL();
    return AutocompleteURL;
}();
var $4d40d048175dacfe$export$7a4045fb80d6a5eb = /* #__PURE__ */ function() {
    function AutocompletePhoto() {}
    AutocompletePhoto.value = new AutocompletePhoto();
    return AutocompletePhoto;
}();
var $4d40d048175dacfe$export$9b8eae2964bb4cd5 = function(v) {
    if (v instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return "off";
    if (v instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return "on";
    if (v instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return "name";
    if (v instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return "honorific-prefix";
    if (v instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return "given-name";
    if (v instanceof $4d40d048175dacfe$export$c2899da73c95f826) return "additional-name";
    if (v instanceof $4d40d048175dacfe$export$b189863462ae27fe) return "family-name";
    if (v instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return "honorific-suffix";
    if (v instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return "nickname";
    if (v instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return "email";
    if (v instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return "username";
    if (v instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return "new-password";
    if (v instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return "current-password";
    if (v instanceof $4d40d048175dacfe$export$6f27218568808639) return "one-time-code";
    if (v instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return "organization-title";
    if (v instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return "organization";
    if (v instanceof $4d40d048175dacfe$export$499720fb85152dfe) return "street-address";
    if (v instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return "address-line1";
    if (v instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return "address-line2";
    if (v instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return "address-line3";
    if (v instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return "address-level1";
    if (v instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return "address-level2";
    if (v instanceof $4d40d048175dacfe$export$f76ce82784afe674) return "address-level3";
    if (v instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return "address-level4";
    if (v instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return "country";
    if (v instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return "country-name";
    if (v instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return "postal-code";
    if (v instanceof $4d40d048175dacfe$export$67ade628725afe90) return "cc-name";
    if (v instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return "cc-given-name";
    if (v instanceof $4d40d048175dacfe$export$1b45801580e5182f) return "cc-additional-name";
    if (v instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return "cc-family-name";
    if (v instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return "cc-number";
    if (v instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return "cc-exp";
    if (v instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return "cc-exp-month";
    if (v instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return "cc-exp-year";
    if (v instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return "cc-csc";
    if (v instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return "cc-type";
    if (v instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return "transaction-currency";
    if (v instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return "transaction-amount";
    if (v instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return "language";
    if (v instanceof $4d40d048175dacfe$export$db103677e4262f74) return "bday";
    if (v instanceof $4d40d048175dacfe$export$976267f1375fd072) return "bday-day";
    if (v instanceof $4d40d048175dacfe$export$345017daa9311763) return "bday-month";
    if (v instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return "bday-year";
    if (v instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return "sex";
    if (v instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return "tel";
    if (v instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return "tel-country-code";
    if (v instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return "tel-national";
    if (v instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return "telarea-code";
    if (v instanceof $4d40d048175dacfe$export$149dc202c94ba771) return "tel-local";
    if (v instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return "tel-local-prefix";
    if (v instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return "tel-local-suffix";
    if (v instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return "tel-extension";
    if (v instanceof $4d40d048175dacfe$export$1294e96da410451d) return "impp";
    if (v instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return "url";
    if (v instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb) return "photo";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.AutocompleteType (line 67, column 26 - line 123, column 31): " + [
        v.constructor.name
    ]);
};
var $4d40d048175dacfe$export$51a22934b9cdbac4 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c && y instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return true;
            if (x instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab && y instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return true;
            if (x instanceof $4d40d048175dacfe$export$4da01cb598a0d97e && y instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return true;
            if (x instanceof $4d40d048175dacfe$export$ccb63fd7a749a381 && y instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return true;
            if (x instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb && y instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return true;
            if (x instanceof $4d40d048175dacfe$export$c2899da73c95f826 && y instanceof $4d40d048175dacfe$export$c2899da73c95f826) return true;
            if (x instanceof $4d40d048175dacfe$export$b189863462ae27fe && y instanceof $4d40d048175dacfe$export$b189863462ae27fe) return true;
            if (x instanceof $4d40d048175dacfe$export$5481c9b080fac1ad && y instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return true;
            if (x instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7 && y instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return true;
            if (x instanceof $4d40d048175dacfe$export$3f2abff6b2574d28 && y instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return true;
            if (x instanceof $4d40d048175dacfe$export$8ef7db4a55783560 && y instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return true;
            if (x instanceof $4d40d048175dacfe$export$2aec4081bfc982fb && y instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return true;
            if (x instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda && y instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return true;
            if (x instanceof $4d40d048175dacfe$export$6f27218568808639 && y instanceof $4d40d048175dacfe$export$6f27218568808639) return true;
            if (x instanceof $4d40d048175dacfe$export$9748581da6bbbe4e && y instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return true;
            if (x instanceof $4d40d048175dacfe$export$5fd9f780846e028b && y instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return true;
            if (x instanceof $4d40d048175dacfe$export$499720fb85152dfe && y instanceof $4d40d048175dacfe$export$499720fb85152dfe) return true;
            if (x instanceof $4d40d048175dacfe$export$6b6488e90da63d6 && y instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return true;
            if (x instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde && y instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return true;
            if (x instanceof $4d40d048175dacfe$export$ea74132c1bd19261 && y instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return true;
            if (x instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c && y instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return true;
            if (x instanceof $4d40d048175dacfe$export$af0e2cc0795570d9 && y instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return true;
            if (x instanceof $4d40d048175dacfe$export$f76ce82784afe674 && y instanceof $4d40d048175dacfe$export$f76ce82784afe674) return true;
            if (x instanceof $4d40d048175dacfe$export$5f9c079ff6708773 && y instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return true;
            if (x instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37 && y instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return true;
            if (x instanceof $4d40d048175dacfe$export$e259ef3995a99fd4 && y instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return true;
            if (x instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3 && y instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return true;
            if (x instanceof $4d40d048175dacfe$export$67ade628725afe90 && y instanceof $4d40d048175dacfe$export$67ade628725afe90) return true;
            if (x instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b && y instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return true;
            if (x instanceof $4d40d048175dacfe$export$1b45801580e5182f && y instanceof $4d40d048175dacfe$export$1b45801580e5182f) return true;
            if (x instanceof $4d40d048175dacfe$export$d906c17550f3b6f1 && y instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return true;
            if (x instanceof $4d40d048175dacfe$export$267a9616c09f33fa && y instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return true;
            if (x instanceof $4d40d048175dacfe$export$4ac537c498251bbf && y instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return true;
            if (x instanceof $4d40d048175dacfe$export$2e15cf96bd811454 && y instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return true;
            if (x instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d && y instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return true;
            if (x instanceof $4d40d048175dacfe$export$42f27b71e570e84c && y instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return true;
            if (x instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c && y instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return true;
            if (x instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c && y instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return true;
            if (x instanceof $4d40d048175dacfe$export$9d4a96b43ef247de && y instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return true;
            if (x instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa && y instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return true;
            if (x instanceof $4d40d048175dacfe$export$db103677e4262f74 && y instanceof $4d40d048175dacfe$export$db103677e4262f74) return true;
            if (x instanceof $4d40d048175dacfe$export$976267f1375fd072 && y instanceof $4d40d048175dacfe$export$976267f1375fd072) return true;
            if (x instanceof $4d40d048175dacfe$export$345017daa9311763 && y instanceof $4d40d048175dacfe$export$345017daa9311763) return true;
            if (x instanceof $4d40d048175dacfe$export$a58218c48fdc359f && y instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return true;
            if (x instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f && y instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return true;
            if (x instanceof $4d40d048175dacfe$export$dc25bbd279bd7147 && y instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return true;
            if (x instanceof $4d40d048175dacfe$export$f37489576ac4e3f5 && y instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return true;
            if (x instanceof $4d40d048175dacfe$export$85265d7dd09c0246 && y instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return true;
            if (x instanceof $4d40d048175dacfe$export$fb4e6d66ca842722 && y instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return true;
            if (x instanceof $4d40d048175dacfe$export$149dc202c94ba771 && y instanceof $4d40d048175dacfe$export$149dc202c94ba771) return true;
            if (x instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e && y instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return true;
            if (x instanceof $4d40d048175dacfe$export$97df2b5615a1b054 && y instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return true;
            if (x instanceof $4d40d048175dacfe$export$7aa0294a80b301d4 && y instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return true;
            if (x instanceof $4d40d048175dacfe$export$1294e96da410451d && y instanceof $4d40d048175dacfe$export$1294e96da410451d) return true;
            if (x instanceof $4d40d048175dacfe$export$acf71e1d98edce93 && y instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return true;
            if (x instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb && y instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb) return true;
            return false;
        };
    }
};
var $4d40d048175dacfe$export$72232ffdb2635391 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c && y instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab && y instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$4da01cb598a0d97e && y instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$ccb63fd7a749a381 && y instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb && y instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$c2899da73c95f826 && y instanceof $4d40d048175dacfe$export$c2899da73c95f826) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$c2899da73c95f826) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$c2899da73c95f826) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$b189863462ae27fe && y instanceof $4d40d048175dacfe$export$b189863462ae27fe) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$b189863462ae27fe) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$b189863462ae27fe) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$5481c9b080fac1ad && y instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7 && y instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$3f2abff6b2574d28 && y instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$8ef7db4a55783560 && y instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$2aec4081bfc982fb && y instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda && y instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$6f27218568808639 && y instanceof $4d40d048175dacfe$export$6f27218568808639) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$6f27218568808639) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$6f27218568808639) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$9748581da6bbbe4e && y instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$5fd9f780846e028b && y instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$499720fb85152dfe && y instanceof $4d40d048175dacfe$export$499720fb85152dfe) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$499720fb85152dfe) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$499720fb85152dfe) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$6b6488e90da63d6 && y instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde && y instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$ea74132c1bd19261 && y instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c && y instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$af0e2cc0795570d9 && y instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$f76ce82784afe674 && y instanceof $4d40d048175dacfe$export$f76ce82784afe674) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$f76ce82784afe674) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$f76ce82784afe674) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$5f9c079ff6708773 && y instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37 && y instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$e259ef3995a99fd4 && y instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3 && y instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$67ade628725afe90 && y instanceof $4d40d048175dacfe$export$67ade628725afe90) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$67ade628725afe90) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$67ade628725afe90) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b && y instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$1b45801580e5182f && y instanceof $4d40d048175dacfe$export$1b45801580e5182f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$1b45801580e5182f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$1b45801580e5182f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$d906c17550f3b6f1 && y instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$267a9616c09f33fa && y instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$4ac537c498251bbf && y instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$2e15cf96bd811454 && y instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d && y instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$42f27b71e570e84c && y instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c && y instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c && y instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$9d4a96b43ef247de && y instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa && y instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$db103677e4262f74 && y instanceof $4d40d048175dacfe$export$db103677e4262f74) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$db103677e4262f74) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$db103677e4262f74) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$976267f1375fd072 && y instanceof $4d40d048175dacfe$export$976267f1375fd072) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$976267f1375fd072) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$976267f1375fd072) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$345017daa9311763 && y instanceof $4d40d048175dacfe$export$345017daa9311763) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$345017daa9311763) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$345017daa9311763) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$a58218c48fdc359f && y instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f && y instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$dc25bbd279bd7147 && y instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$f37489576ac4e3f5 && y instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$85265d7dd09c0246 && y instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$fb4e6d66ca842722 && y instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$149dc202c94ba771 && y instanceof $4d40d048175dacfe$export$149dc202c94ba771) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$149dc202c94ba771) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$149dc202c94ba771) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e && y instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$97df2b5615a1b054 && y instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$7aa0294a80b301d4 && y instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$1294e96da410451d && y instanceof $4d40d048175dacfe$export$1294e96da410451d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$1294e96da410451d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$1294e96da410451d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$acf71e1d98edce93 && y instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb && y instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.AutocompleteType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $4d40d048175dacfe$export$51a22934b9cdbac4;
    }
};


// Generated by purs version 0.15.15

var $c67b43ffea069cfb$export$f2f6344eac5a3091 = /* #__PURE__ */ function() {
    function ButtonButton() {}
    ButtonButton.value = new ButtonButton();
    return ButtonButton;
}();
var $c67b43ffea069cfb$export$883ac606d954afa4 = /* #__PURE__ */ function() {
    function ButtonSubmit() {}
    ButtonSubmit.value = new ButtonSubmit();
    return ButtonSubmit;
}();
var $c67b43ffea069cfb$export$7c5d4436120726a7 = /* #__PURE__ */ function() {
    function ButtonReset() {}
    ButtonReset.value = new ButtonReset();
    return ButtonReset;
}();
var $c67b43ffea069cfb$export$354e79e7f4fdf8f9 = function(v) {
    if (v instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return "button";
    if (v instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return "submit";
    if (v instanceof $c67b43ffea069cfb$export$7c5d4436120726a7) return "reset";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.ButtonType (line 14, column 20 - line 17, column 25): " + [
        v.constructor.name
    ]);
};
var $c67b43ffea069cfb$export$eedf6d78b7217aa7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091 && y instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return true;
            if (x instanceof $c67b43ffea069cfb$export$883ac606d954afa4 && y instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return true;
            if (x instanceof $c67b43ffea069cfb$export$7c5d4436120726a7 && y instanceof $c67b43ffea069cfb$export$7c5d4436120726a7) return true;
            return false;
        };
    }
};
var $c67b43ffea069cfb$export$d2ecbd2aa2e5439c = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091 && y instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c67b43ffea069cfb$export$883ac606d954afa4 && y instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c67b43ffea069cfb$export$7c5d4436120726a7 && y instanceof $c67b43ffea069cfb$export$7c5d4436120726a7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.ButtonType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c67b43ffea069cfb$export$eedf6d78b7217aa7;
    }
};


// Generated by purs version 0.15.15

var $d3d5c2135d61b9e7$export$484f3009c2ee32ad = /* #__PURE__ */ function() {
    function POST() {}
    POST.value = new POST();
    return POST;
}();
var $d3d5c2135d61b9e7$export$1bb358554aac31c1 = /* #__PURE__ */ function() {
    function GET() {}
    GET.value = new GET();
    return GET;
}();
var $d3d5c2135d61b9e7$export$ac1e6270deebeb79 = function(v) {
    if (v instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return "post";
    if (v instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1) return "get";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.FormMethod (line 13, column 20 - line 15, column 15): " + [
        v.constructor.name
    ]);
};
var $d3d5c2135d61b9e7$export$f6f118a39bdefe44 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad && y instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return true;
            if (x instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1 && y instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1) return true;
            return false;
        };
    }
};
var $d3d5c2135d61b9e7$export$5fa44f1be85134a1 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad && y instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1 && y instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.FormMethod (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $d3d5c2135d61b9e7$export$f6f118a39bdefe44;
    }
};


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15


var $25a73b5eff39e983$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $25a73b5eff39e983$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $25a73b5eff39e983$export$483c11740a902fcd = function(x) {
    return x;
};
var $25a73b5eff39e983$export$74c0afb45691d798 = {
    show: function(v) {
        return "(MediaType " + ($25a73b5eff39e983$var$show(v) + ")");
    }
};
var $25a73b5eff39e983$export$37246347bfd87552 = {
    Coercible0: function() {
        return undefined;
    }
};
var $25a73b5eff39e983$export$2fed9e13b0c7effc = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $25a73b5eff39e983$export$11071179e210ac75 = {
    compare: function(x) {
        return function(y) {
            return $25a73b5eff39e983$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $25a73b5eff39e983$export$2fed9e13b0c7effc;
    }
};






var $a54f870bf00314e8$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $a54f870bf00314e8$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $a54f870bf00314e8$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($25a73b5eff39e983$export$2fed9e13b0c7effc);
var $a54f870bf00314e8$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($25a73b5eff39e983$export$11071179e210ac75);
var $a54f870bf00314e8$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $a54f870bf00314e8$export$8e926b7ab266774b = /* #__PURE__ */ function() {
    function AcceptMediaType(value0) {
        this.value0 = value0;
    }
    AcceptMediaType.create = function(value0) {
        return new AcceptMediaType(value0);
    };
    return AcceptMediaType;
}();
var $a54f870bf00314e8$export$f7dfb125ffc1f9b2 = /* #__PURE__ */ function() {
    function AcceptFileExtension(value0) {
        this.value0 = value0;
    }
    AcceptFileExtension.create = function(value0) {
        return new AcceptFileExtension(value0);
    };
    return AcceptFileExtension;
}();
var $a54f870bf00314e8$export$cdbf5a093552f797 = function(x) {
    return x;
};
var $a54f870bf00314e8$export$335b3365a1f7dcb5 = {
    append: function(v) {
        return function(v1) {
            return $a54f870bf00314e8$var$append(v)(v1);
        };
    }
};
var $a54f870bf00314e8$export$ef578e44d5d087ca = function(v) {
    if (v instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return v.value0;
    if (v instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2) return v.value0;
    throw new Error("Failed pattern match at DOM.HTML.Indexed.InputAcceptType (line 34, column 29 - line 36, column 33): " + [
        v.constructor.name
    ]);
};
var $a54f870bf00314e8$export$67347a102a60396a = function(v) {
    return $5b07e36f812dd04b$export$ec1dc8fbeea3467e(",")($a54f870bf00314e8$var$map($a54f870bf00314e8$export$ef578e44d5d087ca)(v));
};
var $a54f870bf00314e8$export$48e9de57e04e82db = function(mt) {
    return [
        new $a54f870bf00314e8$export$8e926b7ab266774b(mt)
    ];
};
var $a54f870bf00314e8$export$1b45514b112dd749 = function(ext) {
    return [
        new $a54f870bf00314e8$export$f7dfb125ffc1f9b2(ext)
    ];
};
var $a54f870bf00314e8$export$d6146bb235b883d4 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a54f870bf00314e8$export$8e926b7ab266774b && y instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $a54f870bf00314e8$var$eq(x.value0)(y.value0);
            if (x instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2 && y instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2) return x.value0 === y.value0;
            return false;
        };
    }
};
var $a54f870bf00314e8$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($a54f870bf00314e8$export$d6146bb235b883d4));
var $a54f870bf00314e8$export$56a1e1f55aab9839 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $a54f870bf00314e8$export$8e926b7ab266774b && y instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $a54f870bf00314e8$var$compare(x.value0)(y.value0);
            if (x instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2 && y instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2) return $a54f870bf00314e8$var$compare1(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.InputAcceptType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $a54f870bf00314e8$export$d6146bb235b883d4;
    }
};
var $a54f870bf00314e8$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a(/* #__PURE__ */ $97937c29f879e68e$export$6ace7ea8ac01a75e($a54f870bf00314e8$export$56a1e1f55aab9839));
var $a54f870bf00314e8$export$6683b104f83faddd = {
    eq: function(x) {
        return function(y) {
            return $a54f870bf00314e8$var$eq2(x)(y);
        };
    }
};
var $a54f870bf00314e8$export$5822e39e3fdf7b = {
    compare: function(x) {
        return function(y) {
            return $a54f870bf00314e8$var$compare2(x)(y);
        };
    },
    Eq0: function() {
        return $a54f870bf00314e8$export$6683b104f83faddd;
    }
};


// Generated by purs version 0.15.15

var $cec7e3152401d818$export$80f44e7a00b6023f = /* #__PURE__ */ function() {
    function InputButton() {}
    InputButton.value = new InputButton();
    return InputButton;
}();
var $cec7e3152401d818$export$fa1253a65a9e747d = /* #__PURE__ */ function() {
    function InputCheckbox() {}
    InputCheckbox.value = new InputCheckbox();
    return InputCheckbox;
}();
var $cec7e3152401d818$export$c860ea55e361ded9 = /* #__PURE__ */ function() {
    function InputColor() {}
    InputColor.value = new InputColor();
    return InputColor;
}();
var $cec7e3152401d818$export$7ac9d04ce3f22c96 = /* #__PURE__ */ function() {
    function InputDate() {}
    InputDate.value = new InputDate();
    return InputDate;
}();
var $cec7e3152401d818$export$6a70bbf20f9e4d15 = /* #__PURE__ */ function() {
    function InputDatetimeLocal() {}
    InputDatetimeLocal.value = new InputDatetimeLocal();
    return InputDatetimeLocal;
}();
var $cec7e3152401d818$export$497a6aaf7dad75ee = /* #__PURE__ */ function() {
    function InputEmail() {}
    InputEmail.value = new InputEmail();
    return InputEmail;
}();
var $cec7e3152401d818$export$688bf7bc8f9a8891 = /* #__PURE__ */ function() {
    function InputFile() {}
    InputFile.value = new InputFile();
    return InputFile;
}();
var $cec7e3152401d818$export$f953fc739c1a72e8 = /* #__PURE__ */ function() {
    function InputHidden() {}
    InputHidden.value = new InputHidden();
    return InputHidden;
}();
var $cec7e3152401d818$export$94c7ee1e602c3016 = /* #__PURE__ */ function() {
    function InputImage() {}
    InputImage.value = new InputImage();
    return InputImage;
}();
var $cec7e3152401d818$export$e3f21b3e5e110727 = /* #__PURE__ */ function() {
    function InputMonth() {}
    InputMonth.value = new InputMonth();
    return InputMonth;
}();
var $cec7e3152401d818$export$cf9581d419a141cf = /* #__PURE__ */ function() {
    function InputNumber() {}
    InputNumber.value = new InputNumber();
    return InputNumber;
}();
var $cec7e3152401d818$export$66ebaee5e192c141 = /* #__PURE__ */ function() {
    function InputPassword() {}
    InputPassword.value = new InputPassword();
    return InputPassword;
}();
var $cec7e3152401d818$export$324f219e224c2ba4 = /* #__PURE__ */ function() {
    function InputRadio() {}
    InputRadio.value = new InputRadio();
    return InputRadio;
}();
var $cec7e3152401d818$export$7fd9b60c3e71d3cc = /* #__PURE__ */ function() {
    function InputRange() {}
    InputRange.value = new InputRange();
    return InputRange;
}();
var $cec7e3152401d818$export$e5f0f61dd2ad15f5 = /* #__PURE__ */ function() {
    function InputReset() {}
    InputReset.value = new InputReset();
    return InputReset;
}();
var $cec7e3152401d818$export$28044d9a5dbb104e = /* #__PURE__ */ function() {
    function InputSearch() {}
    InputSearch.value = new InputSearch();
    return InputSearch;
}();
var $cec7e3152401d818$export$41cafe4e2581754d = /* #__PURE__ */ function() {
    function InputSubmit() {}
    InputSubmit.value = new InputSubmit();
    return InputSubmit;
}();
var $cec7e3152401d818$export$5a51e0eecea5d8bd = /* #__PURE__ */ function() {
    function InputTel() {}
    InputTel.value = new InputTel();
    return InputTel;
}();
var $cec7e3152401d818$export$7034fcb7d6351061 = /* #__PURE__ */ function() {
    function InputText() {}
    InputText.value = new InputText();
    return InputText;
}();
var $cec7e3152401d818$export$d62c52bf2c44ba6f = /* #__PURE__ */ function() {
    function InputTime() {}
    InputTime.value = new InputTime();
    return InputTime;
}();
var $cec7e3152401d818$export$dfe56e1f58ed5cb2 = /* #__PURE__ */ function() {
    function InputUrl() {}
    InputUrl.value = new InputUrl();
    return InputUrl;
}();
var $cec7e3152401d818$export$8e8a9e74dfcf346a = /* #__PURE__ */ function() {
    function InputWeek() {}
    InputWeek.value = new InputWeek();
    return InputWeek;
}();
var $cec7e3152401d818$export$349063a07c8ae46b = function(v) {
    if (v instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return "button";
    if (v instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return "checkbox";
    if (v instanceof $cec7e3152401d818$export$c860ea55e361ded9) return "color";
    if (v instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return "date";
    if (v instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return "datetime-local";
    if (v instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return "email";
    if (v instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return "file";
    if (v instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return "hidden";
    if (v instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return "image";
    if (v instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return "month";
    if (v instanceof $cec7e3152401d818$export$cf9581d419a141cf) return "number";
    if (v instanceof $cec7e3152401d818$export$66ebaee5e192c141) return "password";
    if (v instanceof $cec7e3152401d818$export$324f219e224c2ba4) return "radio";
    if (v instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return "range";
    if (v instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return "reset";
    if (v instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return "search";
    if (v instanceof $cec7e3152401d818$export$41cafe4e2581754d) return "submit";
    if (v instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return "tel";
    if (v instanceof $cec7e3152401d818$export$7034fcb7d6351061) return "text";
    if (v instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return "time";
    if (v instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return "url";
    if (v instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a) return "week";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 33, column 19 - line 55, column 22): " + [
        v.constructor.name
    ]);
};
var $cec7e3152401d818$export$417491cbf879eb77 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $cec7e3152401d818$export$80f44e7a00b6023f && y instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return true;
            if (x instanceof $cec7e3152401d818$export$fa1253a65a9e747d && y instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return true;
            if (x instanceof $cec7e3152401d818$export$c860ea55e361ded9 && y instanceof $cec7e3152401d818$export$c860ea55e361ded9) return true;
            if (x instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96 && y instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return true;
            if (x instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15 && y instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return true;
            if (x instanceof $cec7e3152401d818$export$497a6aaf7dad75ee && y instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return true;
            if (x instanceof $cec7e3152401d818$export$688bf7bc8f9a8891 && y instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return true;
            if (x instanceof $cec7e3152401d818$export$f953fc739c1a72e8 && y instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return true;
            if (x instanceof $cec7e3152401d818$export$94c7ee1e602c3016 && y instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return true;
            if (x instanceof $cec7e3152401d818$export$e3f21b3e5e110727 && y instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return true;
            if (x instanceof $cec7e3152401d818$export$cf9581d419a141cf && y instanceof $cec7e3152401d818$export$cf9581d419a141cf) return true;
            if (x instanceof $cec7e3152401d818$export$66ebaee5e192c141 && y instanceof $cec7e3152401d818$export$66ebaee5e192c141) return true;
            if (x instanceof $cec7e3152401d818$export$324f219e224c2ba4 && y instanceof $cec7e3152401d818$export$324f219e224c2ba4) return true;
            if (x instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc && y instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return true;
            if (x instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5 && y instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return true;
            if (x instanceof $cec7e3152401d818$export$28044d9a5dbb104e && y instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return true;
            if (x instanceof $cec7e3152401d818$export$41cafe4e2581754d && y instanceof $cec7e3152401d818$export$41cafe4e2581754d) return true;
            if (x instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd && y instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return true;
            if (x instanceof $cec7e3152401d818$export$7034fcb7d6351061 && y instanceof $cec7e3152401d818$export$7034fcb7d6351061) return true;
            if (x instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f && y instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return true;
            if (x instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2 && y instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return true;
            if (x instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a && y instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a) return true;
            return false;
        };
    }
};
var $cec7e3152401d818$export$6dd7322953dee4dc = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $cec7e3152401d818$export$80f44e7a00b6023f && y instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$fa1253a65a9e747d && y instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$c860ea55e361ded9 && y instanceof $cec7e3152401d818$export$c860ea55e361ded9) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$c860ea55e361ded9) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$c860ea55e361ded9) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96 && y instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15 && y instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$497a6aaf7dad75ee && y instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$688bf7bc8f9a8891 && y instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$f953fc739c1a72e8 && y instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$94c7ee1e602c3016 && y instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$e3f21b3e5e110727 && y instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$cf9581d419a141cf && y instanceof $cec7e3152401d818$export$cf9581d419a141cf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$cf9581d419a141cf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$cf9581d419a141cf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$66ebaee5e192c141 && y instanceof $cec7e3152401d818$export$66ebaee5e192c141) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$66ebaee5e192c141) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$66ebaee5e192c141) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$324f219e224c2ba4 && y instanceof $cec7e3152401d818$export$324f219e224c2ba4) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$324f219e224c2ba4) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$324f219e224c2ba4) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc && y instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5 && y instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$28044d9a5dbb104e && y instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$41cafe4e2581754d && y instanceof $cec7e3152401d818$export$41cafe4e2581754d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$41cafe4e2581754d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$41cafe4e2581754d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd && y instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$7034fcb7d6351061 && y instanceof $cec7e3152401d818$export$7034fcb7d6351061) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$7034fcb7d6351061) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$7034fcb7d6351061) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f && y instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2 && y instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a && y instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $cec7e3152401d818$export$417491cbf879eb77;
    }
};


// Generated by purs version 0.15.15

var $01636ff1929ca3b5$export$d4c4e98c5044dc8 = /* #__PURE__ */ function() {
    function MenuList() {}
    MenuList.value = new MenuList();
    return MenuList;
}();
var $01636ff1929ca3b5$export$c7e742effb1c51e2 = /* #__PURE__ */ function() {
    function MenuContext() {}
    MenuContext.value = new MenuContext();
    return MenuContext;
}();
var $01636ff1929ca3b5$export$5ed3d899d0b4c46b = /* #__PURE__ */ function() {
    function MenuToolbar() {}
    MenuToolbar.value = new MenuToolbar();
    return MenuToolbar;
}();
var $01636ff1929ca3b5$export$1746677a19c76ca = function(v) {
    if (v instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return "list";
    if (v instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return "context";
    if (v instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b) return "toolbar";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuType (line 14, column 18 - line 17, column 27): " + [
        v.constructor.name
    ]);
};
var $01636ff1929ca3b5$export$fb82239a3dd454ef = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8 && y instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return true;
            if (x instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2 && y instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return true;
            if (x instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b && y instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b) return true;
            return false;
        };
    }
};
var $01636ff1929ca3b5$export$93b0f2b60788283e = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8 && y instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2 && y instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b && y instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $01636ff1929ca3b5$export$fb82239a3dd454ef;
    }
};


// Generated by purs version 0.15.15

var $16370a0f58f1c8c4$export$45504f2104ec46b9 = /* #__PURE__ */ function() {
    function MenuitemCommand() {}
    MenuitemCommand.value = new MenuitemCommand();
    return MenuitemCommand;
}();
var $16370a0f58f1c8c4$export$eea2e5b7a15a4e39 = /* #__PURE__ */ function() {
    function MenuitemCheckbox() {}
    MenuitemCheckbox.value = new MenuitemCheckbox();
    return MenuitemCheckbox;
}();
var $16370a0f58f1c8c4$export$d4d65a7e83785e4a = /* #__PURE__ */ function() {
    function MenuitemRadio() {}
    MenuitemRadio.value = new MenuitemRadio();
    return MenuitemRadio;
}();
var $16370a0f58f1c8c4$export$3e035bf7a26d866f = function(v) {
    if (v instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return "command";
    if (v instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return "checkbox";
    if (v instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a) return "radio";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuitemType (line 14, column 22 - line 17, column 27): " + [
        v.constructor.name
    ]);
};
var $16370a0f58f1c8c4$export$e73111b8eb7b1a2f = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9 && y instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return true;
            if (x instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39 && y instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return true;
            if (x instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a && y instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a) return true;
            return false;
        };
    }
};
var $16370a0f58f1c8c4$export$67edf3145dec517a = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9 && y instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39 && y instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a && y instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuitemType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $16370a0f58f1c8c4$export$e73111b8eb7b1a2f;
    }
};


// Generated by purs version 0.15.15



var $018a854b7e87c5c3$export$44ce537f0c9df246 = /* #__PURE__ */ function() {
    function Uppercase() {}
    Uppercase.value = new Uppercase();
    return Uppercase;
}();
var $018a854b7e87c5c3$export$83336b6c62a5a6d9 = /* #__PURE__ */ function() {
    function Lowercase() {}
    Lowercase.value = new Lowercase();
    return Lowercase;
}();
var $018a854b7e87c5c3$export$4ae8afa1ef3b3b36 = /* #__PURE__ */ function() {
    function NumeralDecimal() {}
    NumeralDecimal.value = new NumeralDecimal();
    return NumeralDecimal;
}();
var $018a854b7e87c5c3$export$d7365b08e0f1de3f = /* #__PURE__ */ function() {
    function NumeralRoman(value0) {
        this.value0 = value0;
    }
    NumeralRoman.create = function(value0) {
        return new NumeralRoman(value0);
    };
    return NumeralRoman;
}();
var $018a854b7e87c5c3$export$d3365947fb5d3bc = /* #__PURE__ */ function() {
    function OrderedListNumeric(value0) {
        this.value0 = value0;
    }
    OrderedListNumeric.create = function(value0) {
        return new OrderedListNumeric(value0);
    };
    return OrderedListNumeric;
}();
var $018a854b7e87c5c3$export$6f21557799b70c7b = /* #__PURE__ */ function() {
    function OrderedListAlphabetic(value0) {
        this.value0 = value0;
    }
    OrderedListAlphabetic.create = function(value0) {
        return new OrderedListAlphabetic(value0);
    };
    return OrderedListAlphabetic;
}();
var $018a854b7e87c5c3$export$a347b8fb4fdf4d6c = function(v) {
    if (v instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && v.value0 instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return "1";
    if (v instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && v.value0 instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && v.value0.value0 instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return "i";
    if (v instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && v.value0 instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && v.value0.value0 instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return "I";
    if (v instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && v.value0 instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return "a";
    if (v instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && v.value0 instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return "A";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 27, column 25 - line 32, column 41): " + [
        v.constructor.name
    ]);
};
var $018a854b7e87c5c3$export$9fb147ac07d57455 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$44ce537f0c9df246 && y instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return true;
            if (x instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9 && y instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return true;
            return false;
        };
    }
};
var $018a854b7e87c5c3$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($018a854b7e87c5c3$export$9fb147ac07d57455);
var $018a854b7e87c5c3$export$7549aa54c7bac647 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36 && y instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return true;
            if (x instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && y instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f) return $018a854b7e87c5c3$var$eq(x.value0)(y.value0);
            return false;
        };
    }
};
var $018a854b7e87c5c3$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($018a854b7e87c5c3$export$7549aa54c7bac647);
var $018a854b7e87c5c3$export$e819e2655e0fcc28 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && y instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $018a854b7e87c5c3$var$eq1(x.value0)(y.value0);
            if (x instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && y instanceof $018a854b7e87c5c3$export$6f21557799b70c7b) return $018a854b7e87c5c3$var$eq(x.value0)(y.value0);
            return false;
        };
    }
};
var $018a854b7e87c5c3$export$1bd622e0e5e4efb1 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$44ce537f0c9df246 && y instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9 && y instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $018a854b7e87c5c3$export$9fb147ac07d57455;
    }
};
var $018a854b7e87c5c3$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($018a854b7e87c5c3$export$1bd622e0e5e4efb1);
var $018a854b7e87c5c3$export$cd9389dd72b9960d = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36 && y instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && y instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f) return $018a854b7e87c5c3$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $018a854b7e87c5c3$export$7549aa54c7bac647;
    }
};
var $018a854b7e87c5c3$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($018a854b7e87c5c3$export$cd9389dd72b9960d);
var $018a854b7e87c5c3$export$8c507121dc4e4ea6 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && y instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $018a854b7e87c5c3$var$compare1(x.value0)(y.value0);
            if (x instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && y instanceof $018a854b7e87c5c3$export$6f21557799b70c7b) return $018a854b7e87c5c3$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $018a854b7e87c5c3$export$e819e2655e0fcc28;
    }
};


// Generated by purs version 0.15.15

var $5d22526bed7c1d63$export$c9ce58abf53417e5 = /* #__PURE__ */ function() {
    function PreloadNone() {}
    PreloadNone.value = new PreloadNone();
    return PreloadNone;
}();
var $5d22526bed7c1d63$export$5e05b189d974313d = /* #__PURE__ */ function() {
    function PreloadAuto() {}
    PreloadAuto.value = new PreloadAuto();
    return PreloadAuto;
}();
var $5d22526bed7c1d63$export$177dbf7da98d3f0a = /* #__PURE__ */ function() {
    function PreloadMetadata() {}
    PreloadMetadata.value = new PreloadMetadata();
    return PreloadMetadata;
}();
var $5d22526bed7c1d63$export$d6626656355d8e39 = function(v) {
    if (v instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return "none";
    if (v instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return "auto";
    if (v instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a) return "metadata";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.PreloadValue (line 14, column 22 - line 17, column 32): " + [
        v.constructor.name
    ]);
};
var $5d22526bed7c1d63$export$2dcc86def1e5568e = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5 && y instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return true;
            if (x instanceof $5d22526bed7c1d63$export$5e05b189d974313d && y instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return true;
            if (x instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a && y instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a) return true;
            return false;
        };
    }
};
var $5d22526bed7c1d63$export$c419e612a877bba3 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5 && y instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $5d22526bed7c1d63$export$5e05b189d974313d && y instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a && y instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.PreloadValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $5d22526bed7c1d63$export$2dcc86def1e5568e;
    }
};


// Generated by purs version 0.15.15

var $28290d8d8d6af995$export$85b4c654d12206aa = /* #__PURE__ */ function() {
    function ScopeRow() {}
    ScopeRow.value = new ScopeRow();
    return ScopeRow;
}();
var $28290d8d8d6af995$export$bf0d11cf8bd9f5de = /* #__PURE__ */ function() {
    function ScopeCol() {}
    ScopeCol.value = new ScopeCol();
    return ScopeCol;
}();
var $28290d8d8d6af995$export$5910a17af6f76381 = /* #__PURE__ */ function() {
    function ScopeRowGroup() {}
    ScopeRowGroup.value = new ScopeRowGroup();
    return ScopeRowGroup;
}();
var $28290d8d8d6af995$export$6ce944503089dadd = /* #__PURE__ */ function() {
    function ScopeColGroup() {}
    ScopeColGroup.value = new ScopeColGroup();
    return ScopeColGroup;
}();
var $28290d8d8d6af995$export$5663b51bd1c6c084 = /* #__PURE__ */ function() {
    function ScopeAuto() {}
    ScopeAuto.value = new ScopeAuto();
    return ScopeAuto;
}();
var $28290d8d8d6af995$export$ce228bdd501ce63 = function(v) {
    if (v instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return "row";
    if (v instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return "col";
    if (v instanceof $28290d8d8d6af995$export$5910a17af6f76381) return "rowgroup";
    if (v instanceof $28290d8d8d6af995$export$6ce944503089dadd) return "colgroup";
    if (v instanceof $28290d8d8d6af995$export$5663b51bd1c6c084) return "auto";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.ScopeValue (line 16, column 20 - line 21, column 22): " + [
        v.constructor.name
    ]);
};
var $28290d8d8d6af995$export$118ba639ca4f9d14 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $28290d8d8d6af995$export$85b4c654d12206aa && y instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return true;
            if (x instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de && y instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return true;
            if (x instanceof $28290d8d8d6af995$export$5910a17af6f76381 && y instanceof $28290d8d8d6af995$export$5910a17af6f76381) return true;
            if (x instanceof $28290d8d8d6af995$export$6ce944503089dadd && y instanceof $28290d8d8d6af995$export$6ce944503089dadd) return true;
            if (x instanceof $28290d8d8d6af995$export$5663b51bd1c6c084 && y instanceof $28290d8d8d6af995$export$5663b51bd1c6c084) return true;
            return false;
        };
    }
};
var $28290d8d8d6af995$export$4afeaf27b056d536 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $28290d8d8d6af995$export$85b4c654d12206aa && y instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de && y instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $28290d8d8d6af995$export$5910a17af6f76381 && y instanceof $28290d8d8d6af995$export$5910a17af6f76381) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $28290d8d8d6af995$export$5910a17af6f76381) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $28290d8d8d6af995$export$5910a17af6f76381) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $28290d8d8d6af995$export$6ce944503089dadd && y instanceof $28290d8d8d6af995$export$6ce944503089dadd) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $28290d8d8d6af995$export$6ce944503089dadd) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $28290d8d8d6af995$export$6ce944503089dadd) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $28290d8d8d6af995$export$5663b51bd1c6c084 && y instanceof $28290d8d8d6af995$export$5663b51bd1c6c084) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.ScopeValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $28290d8d8d6af995$export$118ba639ca4f9d14;
    }
};


// Generated by purs version 0.15.15



var $9c6cb90b338ac9f8$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $9c6cb90b338ac9f8$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$5ed021ff2336715c);
var $9c6cb90b338ac9f8$export$b24b633b1364b94b = /* #__PURE__ */ function() {
    function Any() {}
    Any.value = new Any();
    return Any;
}();
var $9c6cb90b338ac9f8$export$fd55ce593607084a = /* #__PURE__ */ function() {
    function Step(value0) {
        this.value0 = value0;
    }
    Step.create = function(value0) {
        return new Step(value0);
    };
    return Step;
}();
var $9c6cb90b338ac9f8$export$eb5efa61a2272b57 = function(v) {
    if (v instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return "any";
    if (v instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a) return $9c6cb90b338ac9f8$var$show(v.value0);
    throw new Error("Failed pattern match at DOM.HTML.Indexed.StepValue (line 13, column 19 - line 15, column 19): " + [
        v.constructor.name
    ]);
};
var $9c6cb90b338ac9f8$export$8db64ca9ca089cac = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b && y instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return true;
            if (x instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a && y instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a) return x.value0 === y.value0;
            return false;
        };
    }
};
var $9c6cb90b338ac9f8$export$848021523941663f = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b && y instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a && y instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a) return $9c6cb90b338ac9f8$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.StepValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $9c6cb90b338ac9f8$export$8db64ca9ca089cac;
    }
};







// Generated by purs version 0.15.15


// Generated by purs version 0.15.15

var $f2665e311d0e2c2e$export$e1bb774e9664e700 = /* #__PURE__ */ function() {
    function Anonymous() {}
    Anonymous.value = new Anonymous();
    return Anonymous;
}();
var $f2665e311d0e2c2e$export$bf6fef082af5a2d3 = /* #__PURE__ */ function() {
    function UseCredentials() {}
    UseCredentials.value = new UseCredentials();
    return UseCredentials;
}();
var $f2665e311d0e2c2e$export$8cede0459d8015c9 = function(v) {
    if (v instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return "anonymous";
    if (v instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3) return "use-credentials";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.CrossOriginValue (line 13, column 26 - line 15, column 38): " + [
        v.constructor.name
    ]);
};
var $f2665e311d0e2c2e$export$63add5f8c2317041 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700 && y instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return true;
            if (x instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3 && y instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3) return true;
            return false;
        };
    }
};
var $f2665e311d0e2c2e$export$8999465764c5da85 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700 && y instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3 && y instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.CrossOriginValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $f2665e311d0e2c2e$export$63add5f8c2317041;
    }
};


// Generated by purs version 0.15.15

var $0e909c93feacf06e$export$c75f22af8298685 = /* #__PURE__ */ function() {
    function DirLTR() {}
    DirLTR.value = new DirLTR();
    return DirLTR;
}();
var $0e909c93feacf06e$export$f3ecd00e2fcb9ec1 = /* #__PURE__ */ function() {
    function DirRTL() {}
    DirRTL.value = new DirRTL();
    return DirRTL;
}();
var $0e909c93feacf06e$export$db0b550dbafe50c7 = /* #__PURE__ */ function() {
    function DirAuto() {}
    DirAuto.value = new DirAuto();
    return DirAuto;
}();
var $0e909c93feacf06e$export$5f8a4393c9c60d1a = function(v) {
    if (v instanceof $0e909c93feacf06e$export$c75f22af8298685) return "ltr";
    if (v instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return "rtl";
    if (v instanceof $0e909c93feacf06e$export$db0b550dbafe50c7) return "auto";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.DirValue (line 14, column 18 - line 17, column 20): " + [
        v.constructor.name
    ]);
};
var $0e909c93feacf06e$export$c646568b5e94d926 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0e909c93feacf06e$export$c75f22af8298685 && y instanceof $0e909c93feacf06e$export$c75f22af8298685) return true;
            if (x instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1 && y instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return true;
            if (x instanceof $0e909c93feacf06e$export$db0b550dbafe50c7 && y instanceof $0e909c93feacf06e$export$db0b550dbafe50c7) return true;
            return false;
        };
    }
};
var $0e909c93feacf06e$export$e1551c9d6a26f7f3 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0e909c93feacf06e$export$c75f22af8298685 && y instanceof $0e909c93feacf06e$export$c75f22af8298685) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0e909c93feacf06e$export$c75f22af8298685) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0e909c93feacf06e$export$c75f22af8298685) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1 && y instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0e909c93feacf06e$export$db0b550dbafe50c7 && y instanceof $0e909c93feacf06e$export$db0b550dbafe50c7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.DirValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0e909c93feacf06e$export$c646568b5e94d926;
    }
};





// Generated by purs version 0.15.15

var $0d6d338ad81e2ec3$export$35c6296c72c0b98 = /* #__PURE__ */ function() {
    function KindSubtitles() {}
    KindSubtitles.value = new KindSubtitles();
    return KindSubtitles;
}();
var $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa = /* #__PURE__ */ function() {
    function KindCaptions() {}
    KindCaptions.value = new KindCaptions();
    return KindCaptions;
}();
var $0d6d338ad81e2ec3$export$ed9577fa4e97a113 = /* #__PURE__ */ function() {
    function KindDescriptions() {}
    KindDescriptions.value = new KindDescriptions();
    return KindDescriptions;
}();
var $0d6d338ad81e2ec3$export$6b7135087206d174 = /* #__PURE__ */ function() {
    function KindChapters() {}
    KindChapters.value = new KindChapters();
    return KindChapters;
}();
var $0d6d338ad81e2ec3$export$a2734ee0406012d8 = /* #__PURE__ */ function() {
    function KindMetadata() {}
    KindMetadata.value = new KindMetadata();
    return KindMetadata;
}();
var $0d6d338ad81e2ec3$export$8d81b1ec6c8c1d53 = function(v) {
    if (v instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return "subtitles";
    if (v instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return "captions";
    if (v instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return "descriptions";
    if (v instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return "chapters";
    if (v instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8) return "metadata";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.KindValue (line 16, column 19 - line 21, column 29): " + [
        v.constructor.name
    ]);
};
var $0d6d338ad81e2ec3$export$4037dad5bbd136 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98 && y instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa && y instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113 && y instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$6b7135087206d174 && y instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8 && y instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8) return true;
            return false;
        };
    }
};
var $0d6d338ad81e2ec3$export$70ddb214b8742e4 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98 && y instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa && y instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113 && y instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0d6d338ad81e2ec3$export$6b7135087206d174 && y instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8 && y instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.KindValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0d6d338ad81e2ec3$export$4037dad5bbd136;
    }
};








// Generated by purs version 0.15.15

var $545e4dccf243e400$export$a12ca0aab327cfc7 = /* #__PURE__ */ function() {
    function Hard() {}
    Hard.value = new Hard();
    return Hard;
}();
var $545e4dccf243e400$export$f8ab8e157e94ef80 = /* #__PURE__ */ function() {
    function Soft() {}
    Soft.value = new Soft();
    return Soft;
}();
var $545e4dccf243e400$export$a763fdfe677a0aa9 = function(v) {
    if (v instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return "hard";
    if (v instanceof $545e4dccf243e400$export$f8ab8e157e94ef80) return "soft";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.WrapValue (line 13, column 19 - line 15, column 17): " + [
        v.constructor.name
    ]);
};
var $545e4dccf243e400$export$2ca5a4c778c64452 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $545e4dccf243e400$export$a12ca0aab327cfc7 && y instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return true;
            if (x instanceof $545e4dccf243e400$export$f8ab8e157e94ef80 && y instanceof $545e4dccf243e400$export$f8ab8e157e94ef80) return true;
            return false;
        };
    }
};
var $545e4dccf243e400$export$7166197b77e6499a = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $545e4dccf243e400$export$a12ca0aab327cfc7 && y instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $545e4dccf243e400$export$f8ab8e157e94ef80 && y instanceof $545e4dccf243e400$export$f8ab8e157e94ef80) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.WrapValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $545e4dccf243e400$export$2ca5a4c778c64452;
    }
};






// Generated by purs version 0.15.15


var $969bbf7e7aa55092$export$37de0cf0f2f21d21 = function(x) {
    return x;
};
var $969bbf7e7aa55092$export$f4c20fd541e0bbe4 = /* #__PURE__ */ function() {
    function RefUpdate(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RefUpdate.create = function(value0) {
        return function(value1) {
            return new RefUpdate(value0, value1);
        };
    };
    return RefUpdate;
}();
var $969bbf7e7aa55092$export$e19cd5f9376f8cee = /* #__PURE__ */ function() {
    function Action(value0) {
        this.value0 = value0;
    }
    Action.create = function(value0) {
        return new Action(value0);
    };
    return Action;
}();
var $969bbf7e7aa55092$export$e4f50b41777b2135 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $969bbf7e7aa55092$export$f406a712694a6a92 = {
    Coercible0: function() {
        return undefined;
    }
};
var $969bbf7e7aa55092$export$5158bce98a089317 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $969bbf7e7aa55092$export$f4c20fd541e0bbe4) return new $969bbf7e7aa55092$export$f4c20fd541e0bbe4(m.value0, m.value1);
            if (m instanceof $969bbf7e7aa55092$export$e19cd5f9376f8cee) return new $969bbf7e7aa55092$export$e19cd5f9376f8cee(f(m.value0));
            throw new Error("Failed pattern match at Halogen.Query.Input (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $969bbf7e7aa55092$export$9947dab6e2c9dd9d = $37b880af5f4991bd$export$fa624555ca2acbc8;


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15





// Generated by purs version 0.15.15

var $47a0a3ebf66dcc6a$export$fd55ce593607084a = /* #__PURE__ */ function() {
    function Step(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Step.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Step(value0, value1, value2, value3);
                };
            };
        };
    };
    return Step;
}();
var $47a0a3ebf66dcc6a$export$4f45170fb98a7886 = $ac8b3532514ac019$export$401372c57776dc;
var $47a0a3ebf66dcc6a$export$35d34bc0ed591a92 = function(v, a) {
    return v.value2(v.value1, a);
};
var $47a0a3ebf66dcc6a$export$dc52c2e07163a142 = $ac8b3532514ac019$export$401372c57776dc;
var $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de = function(v) {
    return v.value3(v.value1);
};
var $47a0a3ebf66dcc6a$export$f9380c9a627682d3 = /* #__PURE__ */ $47a0a3ebf66dcc6a$export$4f45170fb98a7886(function(v) {
    return v.value0;
});


// Generated by purs version 0.15.15







var $bef4063d6d8fe507$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $bef4063d6d8fe507$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $bef4063d6d8fe507$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $bef4063d6d8fe507$export$f89ac22183df46e9 = function(x) {
    return x;
};
var $bef4063d6d8fe507$export$4d8ac795221d227 = function(x) {
    return x;
};
var $bef4063d6d8fe507$export$5f1af8db9871e1d6 = /* #__PURE__ */ function() {
    function Text(value0) {
        this.value0 = value0;
    }
    Text.create = function(value0) {
        return new Text(value0);
    };
    return Text;
}();
var $bef4063d6d8fe507$export$cc2832fafe367c5e = /* #__PURE__ */ function() {
    function Elem(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Elem.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Elem(value0, value1, value2, value3);
                };
            };
        };
    };
    return Elem;
}();
var $bef4063d6d8fe507$export$bade370ab89110b = /* #__PURE__ */ function() {
    function Keyed(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Keyed.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Keyed(value0, value1, value2, value3);
                };
            };
        };
    };
    return Keyed;
}();
var $bef4063d6d8fe507$export$a829527ff4e4114a = /* #__PURE__ */ function() {
    function Widget(value0) {
        this.value0 = value0;
    }
    Widget.create = function(value0) {
        return new Widget(value0);
    };
    return Widget;
}();
var $bef4063d6d8fe507$export$b73d5241bf90e3b6 = /* #__PURE__ */ function() {
    function Grafted(value0) {
        this.value0 = value0;
    }
    Grafted.create = function(value0) {
        return new Grafted(value0);
    };
    return Grafted;
}();
var $bef4063d6d8fe507$export$8ac9228c788aaa24 = /* #__PURE__ */ function() {
    function Graft(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Graft.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Graft(value0, value1, value2);
            };
        };
    };
    return Graft;
}();
var $bef4063d6d8fe507$export$c0694dcc5ceec5fe = function(f) {
    return function($61) {
        return f($61);
    };
};
var $bef4063d6d8fe507$export$1b27a95e780e7371 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $bef4063d6d8fe507$export$2de60fdae46e330f = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $bef4063d6d8fe507$export$15ad108a4eed29f5 = {
    Coercible0: function() {
        return undefined;
    }
};
var $bef4063d6d8fe507$export$79c9400ffffba296 = {
    Coercible0: function() {
        return undefined;
    }
};
var $bef4063d6d8fe507$export$9bae923d92949c2f = $ac8b3532514ac019$export$401372c57776dc;
var $bef4063d6d8fe507$export$d77f48fa96824602 = {
    map: function(g) {
        return $bef4063d6d8fe507$export$c0694dcc5ceec5fe(function(v) {
            return $bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24(v.value0, function($62) {
                return g(v.value1($62));
            }, v.value2));
        });
    }
};
var $bef4063d6d8fe507$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($bef4063d6d8fe507$export$d77f48fa96824602);
var $bef4063d6d8fe507$export$1654609171f4374f = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v1.value0);
            if (v1 instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$var$map2(v)(v1.value0));
            return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24($bef4063d6d8fe507$var$identity, v, v1)));
        };
    }
};
var $bef4063d6d8fe507$export$520c9b3bf6c7d33a = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $bef4063d6d8fe507$export$23ec092d74ce9fd = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $bef4063d6d8fe507$export$45ea1942547d2591 = {
    bimap: function(f) {
        return function(g) {
            return $bef4063d6d8fe507$export$c0694dcc5ceec5fe(function(v) {
                return $bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24(function($63) {
                    return f(v.value0($63));
                }, function($64) {
                    return g(v.value1($64));
                }, v.value2));
            });
        };
    }
};
var $bef4063d6d8fe507$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($bef4063d6d8fe507$export$45ea1942547d2591);
var $bef4063d6d8fe507$export$cb4b70c26113b373 = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v2.value0);
                if (v2 instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$var$bimap(v)(v1)(v2.value0));
                return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24(v, v1, v2)));
            };
        };
    }
};
var $bef4063d6d8fe507$export$355e219ccdea0aec = /* #__PURE__ */ $bef4063d6d8fe507$export$c0694dcc5ceec5fe(function(v) {
    var go = function(v2) {
        if (v2 instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v2.value0);
        if (v2 instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return new $bef4063d6d8fe507$export$cc2832fafe367c5e(v2.value0, v2.value1, v.value0(v2.value2), $bef4063d6d8fe507$var$map(go)(v2.value3));
        if (v2 instanceof $bef4063d6d8fe507$export$bade370ab89110b) return new $bef4063d6d8fe507$export$bade370ab89110b(v2.value0, v2.value1, v.value0(v2.value2), $bef4063d6d8fe507$var$map($bef4063d6d8fe507$var$map1(go))(v2.value3));
        if (v2 instanceof $bef4063d6d8fe507$export$a829527ff4e4114a) return new $bef4063d6d8fe507$export$a829527ff4e4114a(v.value1(v2.value0));
        if (v2 instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$var$bimap(v.value0)(v.value1)(v2.value0));
        throw new Error("Failed pattern match at Halogen.VDom.Types (line 86, column 7 - line 86, column 27): " + [
            v2.constructor.name
        ]);
    };
    return go(v.value2);
});
var $bef4063d6d8fe507$export$8b4d9aa5702dece6 = function(f) {
    return function(g) {
        return function(v) {
            if (v instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v.value0);
            if (v instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return new $bef4063d6d8fe507$export$cc2832fafe367c5e(v.value0, v.value1, f(v.value2), $bef4063d6d8fe507$var$map($bef4063d6d8fe507$export$8b4d9aa5702dece6(f)(g))(v.value3));
            if (v instanceof $bef4063d6d8fe507$export$bade370ab89110b) return new $bef4063d6d8fe507$export$bade370ab89110b(v.value0, v.value1, f(v.value2), $bef4063d6d8fe507$var$map($bef4063d6d8fe507$var$map1($bef4063d6d8fe507$export$8b4d9aa5702dece6(f)(g)))(v.value3));
            if (v instanceof $bef4063d6d8fe507$export$a829527ff4e4114a) return g(v.value0);
            if (v instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $bef4063d6d8fe507$export$8b4d9aa5702dece6(f)(g)($bef4063d6d8fe507$export$355e219ccdea0aec(v.value0));
            throw new Error("Failed pattern match at Halogen.VDom.Types (line 48, column 20 - line 53, column 48): " + [
                v.constructor.name
            ]);
        };
    };
};


// Generated by purs version 0.15.15
"use strict";
function $39e0beec4569345c$export$e21bd765865a4e96(key, obj) {
    return obj[key];
}
function $39e0beec4569345c$export$2d12e28667eef122(key, obj) {
    return obj.hasOwnProperty(key);
}
function $39e0beec4569345c$export$eecc4ddbfda9d798(key, val, obj) {
    obj[key] = val;
}
function $39e0beec4569345c$export$97784d9c47ea0c18(key, obj) {
    delete obj[key];
}
function $39e0beec4569345c$export$3dfbdd78bf0090db(a, f) {
    var b = [];
    for(var i = 0; i < a.length; i++)b.push(f(i, a[i]));
    return b;
}
function $39e0beec4569345c$export$b658ad92e4f7ae19(a, f) {
    for(var i = 0; i < a.length; i++)f(a[i]);
}
function $39e0beec4569345c$export$2da2a225d7cdb301(o, f) {
    var ks = Object.keys(o);
    for(var i = 0; i < ks.length; i++){
        var k = ks[i];
        f(k, o[k]);
    }
}
function $39e0beec4569345c$export$eb8acc503e07b694(n, f) {
    for(var i = 0; i < n; i++)f();
}
function $39e0beec4569345c$export$2422518e1f611f3f(a1, a2, f1, f2, f3) {
    var a3 = [];
    var l1 = a1.length;
    var l2 = a2.length;
    var i = 0;
    while(true){
        if (i < l1) {
            if (i < l2) a3.push(f1(i, a1[i], a2[i]));
            else f2(i, a1[i]);
        } else if (i < l2) a3.push(f3(i, a2[i]));
        else break;
        i++;
    }
    return a3;
}
function $39e0beec4569345c$export$e766566cf460084(as, fk, f) {
    var o = {};
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        var k = fk(a);
        o[k] = f(k, i, a);
    }
    return o;
}
function $39e0beec4569345c$export$ca7590ccd55f275f(o1, as, fk, f1, f2, f3) {
    var o2 = {};
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        var k = fk(a);
        if (o1.hasOwnProperty(k)) o2[k] = f1(k, i, o1[k], a);
        else o2[k] = f3(k, i, a);
    }
    for(var k in o1){
        if (k in o2) continue;
        f2(k, o1[k]);
    }
    return o2;
}
function $39e0beec4569345c$export$9bc2d847a861e3d8(a, b) {
    return a === b;
}
function $39e0beec4569345c$export$b2ce9ad90858ed7a(s, doc) {
    return doc.createTextNode(s);
}
function $39e0beec4569345c$export$94b0296cab6203e(s, n) {
    n.textContent = s;
}
function $39e0beec4569345c$export$c8a8987d4410bf2d(ns, name, doc) {
    if (ns != null) return doc.createElementNS(ns, name);
    else return doc.createElement(name);
}
function $39e0beec4569345c$export$11c1557a40268f0f(i, a, b) {
    var n = b.childNodes.item(i) || null;
    if (n !== a) b.insertBefore(a, n);
}
function $39e0beec4569345c$export$7ae609f7af59e4f7(a, b) {
    if (b && a.parentNode === b) b.removeChild(a);
}
function $39e0beec4569345c$export$b54be7ce267a037b(a) {
    return a.parentNode;
}
function $39e0beec4569345c$export$9fec4d97f1922e0b(ns, attr, val, el) {
    if (ns != null) el.setAttributeNS(ns, attr, val);
    else el.setAttribute(attr, val);
}
function $39e0beec4569345c$export$6399f3bb52316b2c(ns, attr, el) {
    if (ns != null) el.removeAttributeNS(ns, attr);
    else el.removeAttribute(attr);
}
function $39e0beec4569345c$export$7895096fcdde5712(ns, attr, el) {
    if (ns != null) return el.hasAttributeNS(ns, attr);
    else return el.hasAttribute(attr);
}
function $39e0beec4569345c$export$3f65cefe8380dbea(ev, listener, el) {
    el.addEventListener(ev, listener, false);
}
function $39e0beec4569345c$export$8ff9f68337b520c0(ev, listener, el) {
    el.removeEventListener(ev, listener, false);
}
var $39e0beec4569345c$export$1e4bb18162c9f619 = void 0;




var $ac7bed94ac89bf37$export$7ff190aa1ea44157 = $39e0beec4569345c$export$e21bd765865a4e96;
var $ac7bed94ac89bf37$export$7c850c5af9b9983e = $ac8b3532514ac019$export$401372c57776dc;
var $ac7bed94ac89bf37$export$fcec48ff7d1e433f = $39e0beec4569345c$export$eecc4ddbfda9d798;
var $ac7bed94ac89bf37$export$af208d62fa81d7e9 = $0061661dcaa2328e$export$b8cb59497041ffe4;
var $ac7bed94ac89bf37$export$60e478053f1f2ade = $39e0beec4569345c$export$97784d9c47ea0c18;


// Generated by purs version 0.15.15
var $875f34aecc7bf161$var$getProp = function(name) {
    return function(doctype) {
        return doctype[name];
    };
};
const $875f34aecc7bf161$export$3c44083a252eeb14 = $875f34aecc7bf161$var$getProp("namespaceURI");
const $875f34aecc7bf161$export$6ae22f6d74087c1a = $875f34aecc7bf161$var$getProp("prefix");
const $875f34aecc7bf161$export$cbef64f03c7768af = $875f34aecc7bf161$var$getProp("localName");
const $875f34aecc7bf161$export$45e0b80f1e500bd4 = $875f34aecc7bf161$var$getProp("tagName");
function $875f34aecc7bf161$export$d560c7e4a29451c2(node) {
    return function() {
        return node.id;
    };
}
function $875f34aecc7bf161$export$5fd54ffb744fa241(id) {
    return function(node) {
        return function() {
            node.id = id;
        };
    };
}
function $875f34aecc7bf161$export$2913c0c0b5623090(node) {
    return function() {
        return node.className;
    };
}
function $875f34aecc7bf161$export$11c615ce16f87241(element) {
    return function() {
        return element.classList;
    };
}
function $875f34aecc7bf161$export$826e926e0c74f2b8(className) {
    return function(node) {
        return function() {
            node.className = className;
        };
    };
}
function $875f34aecc7bf161$export$af941c3c7c3b40f5(localName) {
    return function(doc) {
        return function() {
            return doc.getElementsByTagName(localName);
        };
    };
}
function $875f34aecc7bf161$export$83374683e5723893(ns) {
    return function(localName) {
        return function(doc) {
            return function() {
                return doc.getElementsByTagNameNS(ns, localName);
            };
        };
    };
}
function $875f34aecc7bf161$export$764e2797d3aa1cff(classNames) {
    return function(doc) {
        return function() {
            return doc.getElementsByClassName(classNames);
        };
    };
}
function $875f34aecc7bf161$export$9fec4d97f1922e0b(name) {
    return function(value) {
        return function(element) {
            return function() {
                element.setAttribute(name, value);
            };
        };
    };
}
function $875f34aecc7bf161$export$2dc9d886be7724ad(name) {
    return function(element) {
        return function() {
            return element.getAttribute(name);
        };
    };
}
function $875f34aecc7bf161$export$7895096fcdde5712(name) {
    return function(element) {
        return function() {
            return element.hasAttribute(name);
        };
    };
}
function $875f34aecc7bf161$export$6399f3bb52316b2c(name) {
    return function(element) {
        return function() {
            element.removeAttribute(name);
        };
    };
}
function $875f34aecc7bf161$export$de994efd351b291c(selector) {
    return function(element) {
        return function() {
            return element.matches(selector);
        };
    };
}
function $875f34aecc7bf161$export$15ddd5fd0edb3555(selector) {
    return function(element) {
        return function() {
            return element.closest(selector);
        };
    };
}
function $875f34aecc7bf161$export$3e0c8fa3b5e4b3b9(node) {
    return function() {
        return node.scrollTop;
    };
}
function $875f34aecc7bf161$export$38a81aac5c9c320d(scrollTop) {
    return function(node) {
        return function() {
            node.scrollTop = scrollTop;
        };
    };
}
function $875f34aecc7bf161$export$6eddf9bc7f2b7d80(node) {
    return function() {
        return node.scrollLeft;
    };
}
function $875f34aecc7bf161$export$ed5fd5ffe5ab0ac(scrollLeft) {
    return function(node) {
        return function() {
            node.scrollLeft = scrollLeft;
        };
    };
}
function $875f34aecc7bf161$export$dc81048565b75a98(el) {
    return function() {
        return el.scrollWidth;
    };
}
function $875f34aecc7bf161$export$5a0845c0f7cb1511(el) {
    return function() {
        return el.scrollHeight;
    };
}
function $875f34aecc7bf161$export$b570871c7d022cff(el) {
    return function() {
        return el.clientTop;
    };
}
function $875f34aecc7bf161$export$6af8701396d90b51(el) {
    return function() {
        return el.clientLeft;
    };
}
function $875f34aecc7bf161$export$f451d61d633bfdbe(el) {
    return function() {
        return el.clientWidth;
    };
}
function $875f34aecc7bf161$export$1ceecc078aa19b72(el) {
    return function() {
        return el.clientHeight;
    };
}
function $875f34aecc7bf161$export$84fe60b31769e95f(el) {
    return function() {
        var rect = el.getBoundingClientRect();
        return {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.width,
            height: rect.height,
            x: rect.x,
            y: rect.y
        };
    };
}
function $875f34aecc7bf161$export$4afda0764643aba3(props) {
    return function(el) {
        return function() {
            return el.attachShadow(props);
        };
    };
}







// Generated by purs version 0.15.15


// Generated by purs version 0.15.15
var $17a55b211df71f15$var$getEffProp = function(name) {
    return function(node) {
        return function() {
            return node[name];
        };
    };
};
const $17a55b211df71f15$export$bacb5cc5a11aef16 = $17a55b211df71f15$var$getEffProp("children");
const $17a55b211df71f15$export$52f4bb9f897f1dda = $17a55b211df71f15$var$getEffProp("firstElementChild");
const $17a55b211df71f15$export$b58800d9b8f19191 = $17a55b211df71f15$var$getEffProp("lastElementChild");
const $17a55b211df71f15$export$f89766fb54dff747 = $17a55b211df71f15$var$getEffProp("childElementCount");
function $17a55b211df71f15$export$242934abc2863db9(selector) {
    return function(node) {
        return function() {
            return node.querySelector(selector);
        };
    };
}
function $17a55b211df71f15$export$2e83b5c43fb7af7b(selector) {
    return function(node) {
        return function() {
            return node.querySelectorAll(selector);
        };
    };
}







var $77e12228cc269e35$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $77e12228cc269e35$export$fe9de06a57e74a75 = function(x) {
    return x;
};
var $77e12228cc269e35$export$78fb49a702cc1f2 = function(qs) {
    var $2 = $77e12228cc269e35$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $3 = $17a55b211df71f15$export$242934abc2863db9(qs);
    return function($4) {
        return $2($3($4));
    };
};
var $77e12228cc269e35$export$52785ae9e93eaaf8 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $77e12228cc269e35$export$ed55255aef9f10db = {
    Coercible0: function() {
        return undefined;
    }
};
var $77e12228cc269e35$export$80cfcf47c97f2a3 = /* #__PURE__ */ function() {
    var $5 = $77e12228cc269e35$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($6) {
        return $5($17a55b211df71f15$export$b58800d9b8f19191($6));
    };
}();
var $77e12228cc269e35$export$ef511da7c0e45881 = /* #__PURE__ */ function() {
    var $7 = $77e12228cc269e35$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($8) {
        return $7($17a55b211df71f15$export$52f4bb9f897f1dda($8));
    };
}();
var $77e12228cc269e35$export$d5769763ca9e4d49 = $37b880af5f4991bd$export$fa624555ca2acbc8;


// Generated by purs version 0.15.15
function $d6be799e52b0a69c$export$fe54a26f58202d85(el) {
    return el.mode;
}
function $d6be799e52b0a69c$export$5e032988b71f6158(el) {
    return function() {
        return el.host;
    };
}




var $33beec599fea318b$export$779aeef03935e9f3 = /* #__PURE__ */ function() {
    function Open() {}
    Open.value = new Open();
    return Open;
}();
var $33beec599fea318b$export$b6448e3d47beddf0 = /* #__PURE__ */ function() {
    function Closed() {}
    Closed.value = new Closed();
    return Closed;
}();
var $33beec599fea318b$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $33beec599fea318b$export$2197b54dae41dfe4 = {
    show: function(v) {
        if (v instanceof $33beec599fea318b$export$779aeef03935e9f3) return "open";
        if (v instanceof $33beec599fea318b$export$b6448e3d47beddf0) return "closed";
        throw new Error("Failed pattern match at Web.DOM.ShadowRoot (line 22, column 1 - line 24, column 25): " + [
            v.constructor.name
        ]);
    }
};
var $33beec599fea318b$export$549ff81930776885 = /* #__PURE__ */ function() {
    var modeFromString = function(v) {
        if (v === "open") return new $06733ae99ed4f534$export$8a67b48435b5d073($33beec599fea318b$export$779aeef03935e9f3.value);
        if (v === "closed") return new $06733ae99ed4f534$export$8a67b48435b5d073($33beec599fea318b$export$b6448e3d47beddf0.value);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
    return function($5) {
        return modeFromString($d6be799e52b0a69c$export$fe54a26f58202d85($5));
    };
}();


// Generated by purs version 0.15.15
function $6d8c9719a60f7848$export$5235d6e581ca586e(nothing, just, name, value) {
    if (typeof window !== "undefined") {
        var ty = window[name];
        if (ty != null && value instanceof ty) return just(value);
    }
    var obj = value;
    while(obj != null){
        var proto = Object.getPrototypeOf(obj);
        var constructorName = proto.constructor.name;
        if (constructorName === name) return just(value);
        else if (constructorName === "Object") return nothing;
        obj = proto;
    }
    return nothing;
}



var $4d89ff275c04492e$export$e3dc45f84eae905c = function(name) {
    return function(value) {
        return $6d8c9719a60f7848$export$5235d6e581ca586e($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, name, value);
    };
};


var $6cbf6bdab8368bba$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($33beec599fea318b$export$2197b54dae41dfe4);
var $6cbf6bdab8368bba$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $6cbf6bdab8368bba$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $6cbf6bdab8368bba$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $6cbf6bdab8368bba$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $6cbf6bdab8368bba$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $6cbf6bdab8368bba$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $6cbf6bdab8368bba$export$82e9f45cca5ba907 = function($3) {
    return $0a5aaf95f168428e$export$1ba013b88f4f21f3($875f34aecc7bf161$export$6ae22f6d74087c1a($3));
};
var $6cbf6bdab8368bba$export$4bb31c815825375a = function($4) {
    return $0a5aaf95f168428e$export$1ba013b88f4f21f3($875f34aecc7bf161$export$3c44083a252eeb14($4));
};
var $6cbf6bdab8368bba$var$initToProps = function(init) {
    return {
        mode: $6cbf6bdab8368bba$var$show(init.mode),
        delegatesFocus: init.delegatesFocus
    };
};
var $6cbf6bdab8368bba$export$5c5bb02a2f64596a = function($5) {
    return $875f34aecc7bf161$export$83374683e5723893($0a5aaf95f168428e$export$b187f57ee1822bc5($5));
};
var $6cbf6bdab8368bba$export$735ee1799fd02602 = function(attr) {
    var $6 = $6cbf6bdab8368bba$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $7 = $875f34aecc7bf161$export$2dc9d886be7724ad(attr);
    return function($8) {
        return $6($7($8));
    };
};
var $6cbf6bdab8368bba$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Element");
var $6cbf6bdab8368bba$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Element");
var $6cbf6bdab8368bba$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Element");
var $6cbf6bdab8368bba$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Element");
var $6cbf6bdab8368bba$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Element");
var $6cbf6bdab8368bba$export$ff7f7c97cdce86e = function(qs) {
    var $9 = $6cbf6bdab8368bba$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $10 = $875f34aecc7bf161$export$15ddd5fd0edb3555(qs);
    return function($11) {
        return $9($10($11));
    };
};
var $6cbf6bdab8368bba$export$c9f3f5ba3dfbdf61 = function($12) {
    return $875f34aecc7bf161$export$4afda0764643aba3($6cbf6bdab8368bba$var$initToProps($12));
};


var $784c06f0344d34c4$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $784c06f0344d34c4$export$db317447723f2845 = function(x) {
    return x;
};
var $784c06f0344d34c4$var$haltWidget = function(v) {
    return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(v.widget);
};
var $784c06f0344d34c4$var$$lazy_patchWidget = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchWidget", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $784c06f0344d34c4$var$$lazy_patchWidget(291)(state, $bef4063d6d8fe507$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $bef4063d6d8fe507$export$a829527ff4e4114a) {
            var res = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.widget, vdom.value0);
            var res$prime = $47a0a3ebf66dcc6a$export$4f45170fb98a7886(function(v) {
                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(v.value0, {
                    build: state.build,
                    widget: res
                }, $784c06f0344d34c4$var$$lazy_patchWidget(296), $784c06f0344d34c4$var$haltWidget));
            })(res);
            return res$prime;
        }
        $784c06f0344d34c4$var$haltWidget(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchWidget = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchWidget(286);
var $784c06f0344d34c4$var$haltText = function(v) {
    var parent = $39e0beec4569345c$export$b54be7ce267a037b(v.node);
    return $39e0beec4569345c$export$7ae609f7af59e4f7(v.node, parent);
};
var $784c06f0344d34c4$var$$lazy_patchText = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchText", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $784c06f0344d34c4$var$$lazy_patchText(82)(state, $bef4063d6d8fe507$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) {
            if (state.value === vdom.value0) return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, state, $784c06f0344d34c4$var$$lazy_patchText(85), $784c06f0344d34c4$var$haltText));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                var nextState = {
                    build: state.build,
                    node: state.node,
                    value: vdom.value0
                };
                $39e0beec4569345c$export$94b0296cab6203e(vdom.value0, state.node);
                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchText(89), $784c06f0344d34c4$var$haltText));
            }
        }
        $784c06f0344d34c4$var$haltText(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchText = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchText(77);
var $784c06f0344d34c4$var$haltKeyed = function(v) {
    var parent = $39e0beec4569345c$export$b54be7ce267a037b(v.node);
    $39e0beec4569345c$export$7ae609f7af59e4f7(v.node, parent);
    $39e0beec4569345c$export$2da2a225d7cdb301(v.children, function(v1, s) {
        return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(s);
    });
    return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(v.attrs);
};
var $784c06f0344d34c4$var$haltElem = function(v) {
    var parent = $39e0beec4569345c$export$b54be7ce267a037b(v.node);
    $39e0beec4569345c$export$7ae609f7af59e4f7(v.node, parent);
    $39e0beec4569345c$export$b658ad92e4f7ae19(v.children, $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de);
    return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(v.attrs);
};
var $784c06f0344d34c4$var$eqElemSpec = function(ns1, v, ns2, v1) {
    var $63 = v === v1;
    if ($63) {
        if (ns1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && ns2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && ns1.value0 === ns2.value0) return true;
        if (ns1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && ns2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return true;
        return false;
    }
    return false;
};
var $784c06f0344d34c4$var$$lazy_patchElem = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchElem", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $784c06f0344d34c4$var$$lazy_patchElem(135)(state, $bef4063d6d8fe507$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e && $784c06f0344d34c4$var$eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
            var v = $fc8c1182ec2aefec$export$f24224f1c91d8156(vdom.value3);
            var v1 = $fc8c1182ec2aefec$export$f24224f1c91d8156(state.children);
            if (v1 === 0 && v === 0) {
                var attrs2 = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.attrs, vdom.value2);
                var nextState = {
                    build: state.build,
                    node: state.node,
                    attrs: attrs2,
                    ns: vdom.value0,
                    name: vdom.value1,
                    children: state.children
                };
                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchElem(149), $784c06f0344d34c4$var$haltElem));
            }
            var onThis = function(v2, s) {
                return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(s);
            };
            var onThese = function(ix, s, v2) {
                var res = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(s, v2);
                $39e0beec4569345c$export$11c1557a40268f0f(ix, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var onThat = function(ix, v2) {
                var res = state.build(v2);
                $39e0beec4569345c$export$11c1557a40268f0f(ix, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var children2 = $39e0beec4569345c$export$2422518e1f611f3f(state.children, vdom.value3, onThese, onThis, onThat);
            var attrs2 = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.attrs, vdom.value2);
            var nextState = {
                build: state.build,
                node: state.node,
                attrs: attrs2,
                ns: vdom.value0,
                name: vdom.value1,
                children: children2
            };
            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchElem(172), $784c06f0344d34c4$var$haltElem));
        }
        $784c06f0344d34c4$var$haltElem(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchElem = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchElem(130);
var $784c06f0344d34c4$var$$lazy_patchKeyed = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchKeyed", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $784c06f0344d34c4$var$$lazy_patchKeyed(222)(state, $bef4063d6d8fe507$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $bef4063d6d8fe507$export$bade370ab89110b && $784c06f0344d34c4$var$eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
            var v = $fc8c1182ec2aefec$export$f24224f1c91d8156(vdom.value3);
            if (state.length === 0 && v === 0) {
                var attrs2 = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.attrs, vdom.value2);
                var nextState = {
                    build: state.build,
                    node: state.node,
                    attrs: attrs2,
                    ns: vdom.value0,
                    name: vdom.value1,
                    children: state.children,
                    length: 0
                };
                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchKeyed(237), $784c06f0344d34c4$var$haltKeyed));
            }
            var onThis = function(v2, s) {
                return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(s);
            };
            var onThese = function(v2, ix$prime, s, v3) {
                var res = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(s, v3.value1);
                $39e0beec4569345c$export$11c1557a40268f0f(ix$prime, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var onThat = function(v2, ix, v3) {
                var res = state.build(v3.value1);
                $39e0beec4569345c$export$11c1557a40268f0f(ix, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var children2 = $39e0beec4569345c$export$ca7590ccd55f275f(state.children, vdom.value3, $71f2e2e9476163f8$export$9e770fa6ce19a9d6, onThese, onThis, onThat);
            var attrs2 = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.attrs, vdom.value2);
            var nextState = {
                build: state.build,
                node: state.node,
                attrs: attrs2,
                ns: vdom.value0,
                name: vdom.value1,
                children: children2,
                length: v
            };
            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchKeyed(261), $784c06f0344d34c4$var$haltKeyed));
        }
        $784c06f0344d34c4$var$haltKeyed(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchKeyed = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchKeyed(217);
var $784c06f0344d34c4$export$150cc32b4adaaae = function(v, build, w) {
    var res = v.buildWidget(v)(w);
    var res$prime = $47a0a3ebf66dcc6a$export$4f45170fb98a7886(function(v1) {
        return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(v1.value0, {
            build: build,
            widget: res
        }, $784c06f0344d34c4$var$patchWidget, $784c06f0344d34c4$var$haltWidget));
    })(res);
    return res$prime;
};
var $784c06f0344d34c4$export$97ed363902aee1ba = function(v, build, s) {
    var node = $39e0beec4569345c$export$b2ce9ad90858ed7a(s, v.document);
    var state = {
        build: build,
        node: node,
        value: s
    };
    return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(node, state, $784c06f0344d34c4$var$patchText, $784c06f0344d34c4$var$haltText));
};
var $784c06f0344d34c4$export$198573fdc68576c0 = function(v, build, ns1, name1, as1, ch1) {
    var el = $39e0beec4569345c$export$c8a8987d4410bf2d($0a5aaf95f168428e$export$b187f57ee1822bc5(ns1), name1, v.document);
    var node = $6cbf6bdab8368bba$export$83a0de4644f1fbc4(el);
    var onChild = function(v1, ix, v2) {
        var res = build(v2.value1);
        $39e0beec4569345c$export$11c1557a40268f0f(ix, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), node);
        return res;
    };
    var children = $39e0beec4569345c$export$e766566cf460084(ch1, $71f2e2e9476163f8$export$9e770fa6ce19a9d6, onChild);
    var attrs = v.buildAttributes(el)(as1);
    var state = {
        build: build,
        node: node,
        attrs: attrs,
        ns: ns1,
        name: name1,
        children: children,
        length: $fc8c1182ec2aefec$export$f24224f1c91d8156(ch1)
    };
    return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(node, state, $784c06f0344d34c4$var$patchKeyed, $784c06f0344d34c4$var$haltKeyed));
};
var $784c06f0344d34c4$export$88209766f38bf9bf = function(v, build, ns1, name1, as1, ch1) {
    var el = $39e0beec4569345c$export$c8a8987d4410bf2d($0a5aaf95f168428e$export$b187f57ee1822bc5(ns1), name1, v.document);
    var node = $6cbf6bdab8368bba$export$83a0de4644f1fbc4(el);
    var onChild = function(ix, child) {
        var res = build(child);
        $39e0beec4569345c$export$11c1557a40268f0f(ix, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), node);
        return res;
    };
    var children = $39e0beec4569345c$export$3dfbdd78bf0090db(ch1, onChild);
    var attrs = v.buildAttributes(el)(as1);
    var state = {
        build: build,
        node: node,
        attrs: attrs,
        ns: ns1,
        name: name1,
        children: children
    };
    return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(node, state, $784c06f0344d34c4$var$patchElem, $784c06f0344d34c4$var$haltElem));
};
var $784c06f0344d34c4$export$7d13c0f6790d0505 = function(spec) {
    var $lazy_build = $784c06f0344d34c4$var$$runtime_lazy("build", "Halogen.VDom.DOM", function() {
        return function(v) {
            if (v instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return $784c06f0344d34c4$export$97ed363902aee1ba(spec, $lazy_build(59), v.value0);
            if (v instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return $784c06f0344d34c4$export$88209766f38bf9bf(spec, $lazy_build(60), v.value0, v.value1, v.value2, v.value3);
            if (v instanceof $bef4063d6d8fe507$export$bade370ab89110b) return $784c06f0344d34c4$export$198573fdc68576c0(spec, $lazy_build(61), v.value0, v.value1, v.value2, v.value3);
            if (v instanceof $bef4063d6d8fe507$export$a829527ff4e4114a) return $784c06f0344d34c4$export$150cc32b4adaaae(spec, $lazy_build(62), v.value0);
            if (v instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $lazy_build(63)($bef4063d6d8fe507$export$355e219ccdea0aec(v.value0));
            throw new Error("Failed pattern match at Halogen.VDom.DOM (line 58, column 27 - line 63, column 52): " + [
                v.constructor.name
            ]);
        };
    });
    var build = $lazy_build(58);
    return build;
};






// Generated by purs version 0.15.15











// Generated by purs version 0.15.15
function $98db70b23aa8a6ea$export$f5cdf3809b4587f3(fn) {
    return function() {
        return function(event) {
            return fn(event)();
        };
    };
}
function $98db70b23aa8a6ea$export$d5d038f71f8391de(type) {
    return function(listener) {
        return function(options) {
            return function(target) {
                return function() {
                    return target.addEventListener(type, listener, options);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$3f65cefe8380dbea(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target) {
                return function() {
                    return target.addEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$8ff9f68337b520c0(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target) {
                return function() {
                    return target.removeEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$716a11175c03fb4e(event) {
    return function(target) {
        return function() {
            return target.dispatchEvent(event);
        };
    };
}


// Generated by purs version 0.15.15




var $f9cd20a8b77a6bf5$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $f9cd20a8b77a6bf5$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $f9cd20a8b77a6bf5$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $f9cd20a8b77a6bf5$export$f880a2f905254b02 = /* #__PURE__ */ function() {
    function Created(value0) {
        this.value0 = value0;
    }
    Created.create = function(value0) {
        return new Created(value0);
    };
    return Created;
}();
var $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3 = /* #__PURE__ */ function() {
    function Removed(value0) {
        this.value0 = value0;
    }
    Removed.create = function(value0) {
        return new Removed(value0);
    };
    return Removed;
}();
var $f9cd20a8b77a6bf5$export$ab9c25261cd8c720 = /* #__PURE__ */ function() {
    function Attribute(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Attribute.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Attribute(value0, value1, value2);
            };
        };
    };
    return Attribute;
}();
var $f9cd20a8b77a6bf5$export$41b04b3a73e7216d = /* #__PURE__ */ function() {
    function Property(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Property.create = function(value0) {
        return function(value1) {
            return new Property(value0, value1);
        };
    };
    return Property;
}();
var $f9cd20a8b77a6bf5$export$a428cd33b25d5283 = /* #__PURE__ */ function() {
    function Handler(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Handler.create = function(value0) {
        return function(value1) {
            return new Handler(value0, value1);
        };
    };
    return Handler;
}();
var $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa = /* #__PURE__ */ function() {
    function Ref(value0) {
        this.value0 = value0;
    }
    Ref.create = function(value0) {
        return new Ref(value0);
    };
    return Ref;
}();
var $f9cd20a8b77a6bf5$var$unsafeGetProperty = $39e0beec4569345c$export$e21bd765865a4e96;
var $f9cd20a8b77a6bf5$var$setProperty = $39e0beec4569345c$export$eecc4ddbfda9d798;
var $f9cd20a8b77a6bf5$var$removeProperty = function(key, el) {
    var v = $39e0beec4569345c$export$7895096fcdde5712($305519516124a7ff$export$7b1b591b262c240, key, el);
    if (v) return $39e0beec4569345c$export$6399f3bb52316b2c($305519516124a7ff$export$7b1b591b262c240, key, el);
    var v1 = $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f($39e0beec4569345c$export$e21bd765865a4e96(key, el));
    if (v1 === "string") return $39e0beec4569345c$export$eecc4ddbfda9d798(key, "", el);
    if (key === "rowSpan") return $39e0beec4569345c$export$eecc4ddbfda9d798(key, 1, el);
    if (key === "colSpan") return $39e0beec4569345c$export$eecc4ddbfda9d798(key, 1, el);
    return $39e0beec4569345c$export$eecc4ddbfda9d798(key, $39e0beec4569345c$export$1e4bb18162c9f619, el);
};
var $f9cd20a8b77a6bf5$var$propToStrKey = function(v) {
    if (v instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720 && v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return "attr/" + (v.value0.value0 + (":" + v.value1));
    if (v instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) return "attr/:" + v.value1;
    if (v instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) return "prop/" + v.value0;
    if (v instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) return "handler/" + v.value0;
    if (v instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return "ref";
    throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 182, column 16 - line 187, column 16): " + [
        v.constructor.name
    ]);
};
var $f9cd20a8b77a6bf5$export$681fbf510ccdea38 = $ac8b3532514ac019$export$401372c57776dc;
var $f9cd20a8b77a6bf5$export$c90971b081d8b87e = $ac8b3532514ac019$export$401372c57776dc;
var $f9cd20a8b77a6bf5$export$e6c76fe186213c01 = $ac8b3532514ac019$export$401372c57776dc;
var $f9cd20a8b77a6bf5$export$cb9950a5a4987d69 = $ac8b3532514ac019$export$401372c57776dc;
var $f9cd20a8b77a6bf5$export$537b40a6761b64a = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) return new $f9cd20a8b77a6bf5$export$a428cd33b25d5283(v1.value0, $f9cd20a8b77a6bf5$var$map($f9cd20a8b77a6bf5$var$map1(v))(v1.value1));
            if (v1 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return new $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa($f9cd20a8b77a6bf5$var$map($f9cd20a8b77a6bf5$var$map1(v))(v1.value0));
            return v1;
        };
    }
};
var $f9cd20a8b77a6bf5$export$14e000ba7a516325 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $f9cd20a8b77a6bf5$export$f880a2f905254b02) return new $f9cd20a8b77a6bf5$export$f880a2f905254b02(v(v1.value0));
            if (v1 instanceof $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3) return new $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3(v(v1.value0));
            throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 49, column 1 - line 51, column 36): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $f9cd20a8b77a6bf5$export$ff441cf2113a23d9 = function(emit) {
    return function(el) {
        var removeProp = function(prevEvents) {
            return function(v, v1) {
                if (v1 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) return $39e0beec4569345c$export$6399f3bb52316b2c($0a5aaf95f168428e$export$b187f57ee1822bc5(v1.value0), v1.value1, el);
                if (v1 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) return $f9cd20a8b77a6bf5$var$removeProperty(v1.value0, el);
                if (v1 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) {
                    var handler = $ac7bed94ac89bf37$export$7ff190aa1ea44157(v1.value0, prevEvents);
                    return $39e0beec4569345c$export$8ff9f68337b520c0(v1.value0, $71f2e2e9476163f8$export$9e770fa6ce19a9d6(handler), el);
                }
                if (v1 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return $05149ea687d6b460$export$523c0b569236b342;
                throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 169, column 5 - line 179, column 18): " + [
                    v1.constructor.name
                ]);
            };
        };
        var mbEmit = function(v) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return emit(v.value0)();
            return $05149ea687d6b460$export$523c0b569236b342;
        };
        var haltProp = function(state) {
            var v = $c045ea5df33bba60$export$dfc7155ac0343b8("ref")(state.props);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return mbEmit(v.value0.value0(new $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3(el)));
            return $05149ea687d6b460$export$523c0b569236b342;
        };
        var diffProp = function(prevEvents, events) {
            return function(v, v1, v11, v2) {
                if (v11 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720 && v2 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) {
                    var $66 = v11.value2 === v2.value2;
                    if ($66) return v2;
                    $39e0beec4569345c$export$9fec4d97f1922e0b($0a5aaf95f168428e$export$b187f57ee1822bc5(v2.value0), v2.value1, v2.value2, el);
                    return v2;
                }
                if (v11 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d && v2 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) {
                    var v4 = $39e0beec4569345c$export$9bc2d847a861e3d8(v11.value1, v2.value1);
                    if (v4) return v2;
                    if (v2.value0 === "value") {
                        var elVal = $f9cd20a8b77a6bf5$var$unsafeGetProperty("value", el);
                        var $75 = $39e0beec4569345c$export$9bc2d847a861e3d8(elVal, v2.value1);
                        if ($75) return v2;
                        $f9cd20a8b77a6bf5$var$setProperty(v2.value0, v2.value1, el);
                        return v2;
                    }
                    $f9cd20a8b77a6bf5$var$setProperty(v2.value0, v2.value1, el);
                    return v2;
                }
                if (v11 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283 && v2 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) {
                    var handler = $ac7bed94ac89bf37$export$7ff190aa1ea44157(v2.value0, prevEvents);
                    $e521936ea118867a$export$68d8715fc104d294(v2.value1)($71f2e2e9476163f8$export$6f71268a1666ab58(handler))();
                    $ac7bed94ac89bf37$export$fcec48ff7d1e433f(v2.value0, handler, events);
                    return v2;
                }
                return v2;
            };
        };
        var applyProp = function(events) {
            return function(v, v1, v2) {
                if (v2 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) {
                    $39e0beec4569345c$export$9fec4d97f1922e0b($0a5aaf95f168428e$export$b187f57ee1822bc5(v2.value0), v2.value1, v2.value2, el);
                    return v2;
                }
                if (v2 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) {
                    $f9cd20a8b77a6bf5$var$setProperty(v2.value0, v2.value1, el);
                    return v2;
                }
                if (v2 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) {
                    var v3 = $39e0beec4569345c$export$e21bd765865a4e96(v2.value0, events);
                    if ($39e0beec4569345c$export$2d12e28667eef122(v2.value0, events)) {
                        $e521936ea118867a$export$68d8715fc104d294(v2.value1)($71f2e2e9476163f8$export$6f71268a1666ab58(v3))();
                        return v2;
                    }
                    var ref = $90327512d8280b8d$export$b8cb59497041ffe4(v2.value1)();
                    var listener = $98db70b23aa8a6ea$export$f5cdf3809b4587f3(function(ev) {
                        return function __do() {
                            var f$prime = $e521936ea118867a$export$aafa59e2e03f2942(ref)();
                            return mbEmit(f$prime(ev));
                        };
                    })();
                    $ac7bed94ac89bf37$export$fcec48ff7d1e433f(v2.value0, new $71f2e2e9476163f8$export$1908877435b1d5e9(listener, ref), events);
                    $39e0beec4569345c$export$3f65cefe8380dbea(v2.value0, listener, el);
                    return v2;
                }
                if (v2 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) {
                    mbEmit(v2.value0(new $f9cd20a8b77a6bf5$export$f880a2f905254b02(el)));
                    return v2;
                }
                throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 113, column 5 - line 135, column 15): " + [
                    v2.constructor.name
                ]);
            };
        };
        var $lazy_patchProp = $f9cd20a8b77a6bf5$var$$runtime_lazy("patchProp", "Halogen.VDom.DOM.Prop", function() {
            return function(state, ps2) {
                var events = $ac7bed94ac89bf37$export$af208d62fa81d7e9();
                var onThis = removeProp(state.events);
                var onThese = diffProp(state.events, events);
                var onThat = applyProp(events);
                var props = $39e0beec4569345c$export$ca7590ccd55f275f(state.props, ps2, $f9cd20a8b77a6bf5$var$propToStrKey, onThese, onThis, onThat);
                var nextState = {
                    events: $ac7bed94ac89bf37$export$7c850c5af9b9983e(events),
                    props: props
                };
                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($05149ea687d6b460$export$523c0b569236b342, nextState, $lazy_patchProp(100), haltProp));
            };
        });
        var patchProp = $lazy_patchProp(87);
        var renderProp = function(ps1) {
            var events = $ac7bed94ac89bf37$export$af208d62fa81d7e9();
            var ps1$prime = $39e0beec4569345c$export$e766566cf460084(ps1, $f9cd20a8b77a6bf5$var$propToStrKey, applyProp(events));
            var state = {
                events: $ac7bed94ac89bf37$export$7c850c5af9b9983e(events),
                props: ps1$prime
            };
            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($05149ea687d6b460$export$523c0b569236b342, state, patchProp, haltProp));
        };
        return renderProp;
    };
};



// Generated by purs version 0.15.15


var $d8c91a2be15f75cb$export$212382f8c1a1154e = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$880a60b2adf28011 = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$ede06c734afe650b = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$95abab3275973ab6 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $d8c91a2be15f75cb$export$c58d7d69adf07268 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $d8c91a2be15f75cb$export$6d81548222f15a9a = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $d8c91a2be15f75cb$export$e2c5e238f46c1980 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$a0bcd3a016e5808d = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$7e4243c3c9480b2b = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$24a4aa0a132c9555 = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $d8c91a2be15f75cb$export$b50b66d86c8b8bf = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $d8c91a2be15f75cb$export$10c76280137f9306 = $37b880af5f4991bd$export$fa624555ca2acbc8;


var $c959b62ce0c19dfe$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $c959b62ce0c19dfe$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f9cd20a8b77a6bf5$export$537b40a6761b64a);
var $c959b62ce0c19dfe$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($969bbf7e7aa55092$export$5158bce98a089317);
var $c959b62ce0c19dfe$var$un = /* #__PURE__ */ $4fa4836228a192cc$export$a2a39c9747f0e54a();
var $c959b62ce0c19dfe$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($bef4063d6d8fe507$export$cb4b70c26113b373);
var $c959b62ce0c19dfe$export$9dcd2b1ca4768128 = function(x) {
    return x;
};
var $c959b62ce0c19dfe$export$f0c5cfb390964b78 = function($28) {
    return $c959b62ce0c19dfe$export$9dcd2b1ca4768128($bef4063d6d8fe507$export$a829527ff4e4114a.create($28));
};
var $c959b62ce0c19dfe$export$ccd8a7ec14afc6c9 = function(dict) {
    return dict.toPropValue;
};
var $c959b62ce0c19dfe$export$6f093cfa640b7166 = function($29) {
    return $c959b62ce0c19dfe$export$9dcd2b1ca4768128($bef4063d6d8fe507$export$5f1af8db9871e1d6.create($29));
};
var $c959b62ce0c19dfe$export$eff4d24c3ff7876e = function(f) {
    return new $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa(function($30) {
        return f(function(v) {
            if (v instanceof $f9cd20a8b77a6bf5$export$f880a2f905254b02) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
            if (v instanceof $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Halogen.HTML.Core (line 109, column 21 - line 111, column 23): " + [
                v.constructor.name
            ]);
        }($30));
    });
};
var $c959b62ce0c19dfe$export$977f3f6a9323c0f6 = function(dictIsProp) {
    var toPropValue1 = $c959b62ce0c19dfe$export$ccd8a7ec14afc6c9(dictIsProp);
    return function(v) {
        var $31 = $f9cd20a8b77a6bf5$export$41b04b3a73e7216d.create(v);
        return function($32) {
            return $31(toPropValue1($32));
        };
    };
};
var $c959b62ce0c19dfe$export$3313fed09a42a979 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c959b62ce0c19dfe$export$8b4d9aa5702dece6 = function(f) {
    return function(g) {
        return function(v) {
            return $bef4063d6d8fe507$export$8b4d9aa5702dece6($c959b62ce0c19dfe$var$map($c959b62ce0c19dfe$var$map1($c959b62ce0c19dfe$var$map2(f))))(function() {
                var $33 = $c959b62ce0c19dfe$var$un($c959b62ce0c19dfe$export$9dcd2b1ca4768128);
                return function($34) {
                    return $33(g($34));
                };
            }())(v);
        };
    };
};
var $c959b62ce0c19dfe$export$8dbf9c790527241e = function(ns) {
    return function(name) {
        return function(props) {
            return function(children) {
                return new $bef4063d6d8fe507$export$bade370ab89110b(ns, name, props, children);
            };
        };
    };
};
var $c959b62ce0c19dfe$export$78da172345adb805 = {
    toPropValue: function($35) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($545e4dccf243e400$export$a763fdfe677a0aa9($35));
    }
};
var $c959b62ce0c19dfe$export$32e0d8bef35d3088 = {
    toPropValue: $f9cd20a8b77a6bf5$export$681fbf510ccdea38
};
var $c959b62ce0c19dfe$export$a77e3c7f90d13c3c = {
    toPropValue: function($36) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($9c6cb90b338ac9f8$export$eb5efa61a2272b57($36));
    }
};
var $c959b62ce0c19dfe$export$cf79af8281015ccd = {
    toPropValue: function($37) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($28290d8d8d6af995$export$ce228bdd501ce63($37));
    }
};
var $c959b62ce0c19dfe$export$1cf8b1fb41618835 = {
    toPropValue: function($38) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($5d22526bed7c1d63$export$d6626656355d8e39($38));
    }
};
var $c959b62ce0c19dfe$export$93423863175829d3 = {
    toPropValue: function($39) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($018a854b7e87c5c3$export$a347b8fb4fdf4d6c($39));
    }
};
var $c959b62ce0c19dfe$export$6b61652c1897c1a = {
    toPropValue: $f9cd20a8b77a6bf5$export$c90971b081d8b87e
};
var $c959b62ce0c19dfe$export$4a37bd3810743b12 = {
    toPropValue: function($40) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($16370a0f58f1c8c4$export$3e035bf7a26d866f($40));
    }
};
var $c959b62ce0c19dfe$export$4111c2fa23eef626 = {
    toPropValue: function($41) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($01636ff1929ca3b5$export$1746677a19c76ca($41));
    }
};
var $c959b62ce0c19dfe$export$7bd1d02eb87275db = {
    toPropValue: /* #__PURE__ */ function() {
        var $42 = $4fa4836228a192cc$export$debb760848ca95a();
        return function($43) {
            return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($42($43));
        };
    }()
};
var $c959b62ce0c19dfe$export$f017ebe0bff0b5df = {
    toPropValue: function($44) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($0d6d338ad81e2ec3$export$8d81b1ec6c8c1d53($44));
    }
};
var $c959b62ce0c19dfe$export$4c390c75bcc39428 = {
    toPropValue: $f9cd20a8b77a6bf5$export$e6c76fe186213c01
};
var $c959b62ce0c19dfe$export$7333503111bf9adf = {
    toPropValue: function($45) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($cec7e3152401d818$export$349063a07c8ae46b($45));
    }
};
var $c959b62ce0c19dfe$export$27dc712f9cde9a29 = {
    toPropValue: function($46) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($a54f870bf00314e8$export$67347a102a60396a($46));
    }
};
var $c959b62ce0c19dfe$export$efe5d718899194d9 = {
    toPropValue: function($47) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($d3d5c2135d61b9e7$export$ac1e6270deebeb79($47));
    }
};
var $c959b62ce0c19dfe$export$60997a3274b6da18 = {
    toPropValue: function($48) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($0e909c93feacf06e$export$5f8a4393c9c60d1a($48));
    }
};
var $c959b62ce0c19dfe$export$56ccba9272e74ac2 = {
    toPropValue: function($49) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($f2665e311d0e2c2e$export$8cede0459d8015c9($49));
    }
};
var $c959b62ce0c19dfe$export$d48eb3d89026ef9 = {
    toPropValue: function($50) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($c67b43ffea069cfb$export$354e79e7f4fdf8f9($50));
    }
};
var $c959b62ce0c19dfe$export$4e3e21220a22c900 = {
    toPropValue: $f9cd20a8b77a6bf5$export$cb9950a5a4987d69
};
var $c959b62ce0c19dfe$export$a538daf4c6392dcf = {
    toPropValue: function($51) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($4d40d048175dacfe$export$9b8eae2964bb4cd5($51));
    }
};
var $c959b62ce0c19dfe$export$c3c52e219617878 = /* #__PURE__ */ function() {
    return $f9cd20a8b77a6bf5$export$a428cd33b25d5283.create;
}();
var $c959b62ce0c19dfe$export$8454457683f90105 = function(ns) {
    return function(name) {
        return function(props) {
            return function(children) {
                return new $bef4063d6d8fe507$export$cc2832fafe367c5e(ns, name, props, children);
            };
        };
    };
};
var $c959b62ce0c19dfe$export$a671de4661736606 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                return $c959b62ce0c19dfe$var$bimap($c959b62ce0c19dfe$var$map($c959b62ce0c19dfe$var$map1($c959b62ce0c19dfe$var$map2(g))))(f)(v);
            };
        };
    }
};
var $c959b62ce0c19dfe$export$a02e13c6b9f001c6 = {
    map: /* #__PURE__ */ $20615e99b278adf5$export$6630987c9d273301($c959b62ce0c19dfe$export$a671de4661736606)
};
var $c959b62ce0c19dfe$export$7aabe8b3a840d2fd = function(ns) {
    return function(v) {
        return $f9cd20a8b77a6bf5$export$ab9c25261cd8c720.create(ns)(v);
    };
};





var $94c2c7ff32ca5bd1$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f9cd20a8b77a6bf5$export$537b40a6761b64a);
var $94c2c7ff32ca5bd1$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($969bbf7e7aa55092$export$5158bce98a089317);
var $94c2c7ff32ca5bd1$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $94c2c7ff32ca5bd1$export$4a4574f653808a56 = function(x) {
    return x;
};
var $94c2c7ff32ca5bd1$export$eff4d24c3ff7876e = /* #__PURE__ */ function() {
    var go = function(p) {
        return function(mel) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $969bbf7e7aa55092$export$f4c20fd541e0bbe4(p, mel));
        };
    };
    return function($29) {
        return $c959b62ce0c19dfe$export$eff4d24c3ff7876e(go($29));
    };
}();
var $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6 = function(dictIsProp) {
    return $c959b62ce0c19dfe$export$977f3f6a9323c0f6(dictIsProp);
};
var $94c2c7ff32ca5bd1$var$prop1 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$4e3e21220a22c900);
var $94c2c7ff32ca5bd1$var$prop2 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$32e0d8bef35d3088);
var $94c2c7ff32ca5bd1$var$prop3 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$4c390c75bcc39428);
var $94c2c7ff32ca5bd1$var$prop4 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$6b61652c1897c1a);
var $94c2c7ff32ca5bd1$export$b2cbc93d4da94977 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("readOnly");
var $94c2c7ff32ca5bd1$export$bad408f43b005bc8 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("rel");
var $94c2c7ff32ca5bd1$export$a7a0278c004aac3f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("required");
var $94c2c7ff32ca5bd1$export$a5ce0649174d616e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("rowSpan");
var $94c2c7ff32ca5bd1$export$2dd197b55cf13440 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("rows");
var $94c2c7ff32ca5bd1$export$5cff813ca8e50db9 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$cf79af8281015ccd)("scope");
var $94c2c7ff32ca5bd1$export$d90250155de6d7e7 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("selected");
var $94c2c7ff32ca5bd1$export$9ea87e299ff6a368 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("selectedIndex");
var $94c2c7ff32ca5bd1$export$afbe3196582d9f14 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("spellcheck");
var $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("src");
var $94c2c7ff32ca5bd1$export$1c5fb2289a93dd05 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("srcdoc");
var $94c2c7ff32ca5bd1$export$35d34bc0ed591a92 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$a77e3c7f90d13c3c)("step");
var $94c2c7ff32ca5bd1$export$9a625f9de50bf0b7 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("tabIndex");
var $94c2c7ff32ca5bd1$export$44271b4f0c6a3563 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("target");
var $94c2c7ff32ca5bd1$export$fb184b623420d9be = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("title");
var $94c2c7ff32ca5bd1$export$d4a6a4db5b31e621 = function(dictIsProp) {
    return $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6(dictIsProp)("type");
};
var $94c2c7ff32ca5bd1$export$2ab9a8f9f1186f14 = function(dictIsProp) {
    return $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6(dictIsProp)("value");
};
var $94c2c7ff32ca5bd1$export$7e3df82ee760448c = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("width");
var $94c2c7ff32ca5bd1$export$513ccb98c53b8039 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$1cf8b1fb41618835)("preload");
var $94c2c7ff32ca5bd1$export$b840e55573b2d2e7 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("poster");
var $94c2c7ff32ca5bd1$export$c7187bbd1a7a9244 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("placeholder");
var $94c2c7ff32ca5bd1$export$24f82734ea047e6f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("pattern");
var $94c2c7ff32ca5bd1$export$f50297589147f25e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("noValidate");
var $94c2c7ff32ca5bd1$export$18bca78ee4b12477 = {
    Coercible0: function() {
        return undefined;
    }
};
var $94c2c7ff32ca5bd1$export$a8ff84c12d48cfa6 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("name");
var $94c2c7ff32ca5bd1$export$987a4e3838aef8c6 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("muted");
var $94c2c7ff32ca5bd1$export$939ddaa3205df08e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("multiple");
var $94c2c7ff32ca5bd1$export$96ec731ed4dcb222 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop4("min");
var $94c2c7ff32ca5bd1$export$26f73335cc2e7868 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$efe5d718899194d9)("method");
var $94c2c7ff32ca5bd1$export$8960430cfd85939f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop4("max");
var $94c2c7ff32ca5bd1$export$f9ef67375ddc185 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("loop");
var $94c2c7ff32ca5bd1$export$d560c7e4a29451c2 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("id");
var $94c2c7ff32ca5bd1$export$8f51af5840e0602a = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("href");
var $94c2c7ff32ca5bd1$export$ac607276a8fe9f0a = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("height");
var $94c2c7ff32ca5bd1$export$f268b02200c313cd = {
    map: function(f) {
        return function(m) {
            return $94c2c7ff32ca5bd1$var$map($94c2c7ff32ca5bd1$var$map1(f))(m);
        };
    }
};
var $94c2c7ff32ca5bd1$export$f89de2e5bf57e5e6 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("htmlFor");
var $94c2c7ff32ca5bd1$export$9f77e0932fb78f72 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};
var $94c2c7ff32ca5bd1$export$9fc5d082ec250407 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$7bd1d02eb87275db)("enctype");
var $94c2c7ff32ca5bd1$export$c746a5152d4ba26c = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("draggable");
var $94c2c7ff32ca5bd1$export$24422be91ad4011f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("download");
var $94c2c7ff32ca5bd1$export$683472f6198a076e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("disabled");
var $94c2c7ff32ca5bd1$export$25eaa035e2e3a214 = /* #__PURE__ */ function() {
    var $30 = $f8fc227945eb179e$export$6003a5f097c73977($f8fc227945eb179e$export$d7d9283ee84f4c3f);
    return function($31) {
        return $94c2c7ff32ca5bd1$export$683472f6198a076e($30($31));
    };
}();
var $94c2c7ff32ca5bd1$export$cc1adf6fb659c762 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("controls");
var $94c2c7ff32ca5bd1$export$1eebcb1e706ab348 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("cols");
var $94c2c7ff32ca5bd1$export$47be69ffacd0da98 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("colSpan");
var $94c2c7ff32ca5bd1$export$188d75d71883854a = /* #__PURE__ */ function() {
    var $32 = $94c2c7ff32ca5bd1$var$prop2("className");
    var $33 = $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ");
    var $34 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546)($94c2c7ff32ca5bd1$var$unwrap);
    return function($35) {
        return $32($33($34($35)));
    };
}();
var $94c2c7ff32ca5bd1$export$dbf49ecbc3d3d264 = /* #__PURE__ */ function() {
    var $36 = $94c2c7ff32ca5bd1$var$prop2("className");
    return function($37) {
        return $36($94c2c7ff32ca5bd1$var$unwrap($37));
    };
}();
var $94c2c7ff32ca5bd1$export$b96bb35bc88d6fa = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("checked");
var $94c2c7ff32ca5bd1$export$e4c823724462c3fd = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("charset");
var $94c2c7ff32ca5bd1$export$b243096046abd58 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("autoplay");
var $94c2c7ff32ca5bd1$export$4c47992fc278c9a0 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("autofocus");
var $94c2c7ff32ca5bd1$export$485ded5f26ebe08d = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$a538daf4c6392dcf)("autocomplete");
var $94c2c7ff32ca5bd1$export$3c95eba0a7ef85d = /* #__PURE__ */ function() {
    var $38 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
    return function($39) {
        return $c959b62ce0c19dfe$export$7aabe8b3a840d2fd($38($39));
    };
}();
var $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd = /* #__PURE__ */ function() {
    return $c959b62ce0c19dfe$export$7aabe8b3a840d2fd($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $94c2c7ff32ca5bd1$export$8837f4fc672e936d = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("list");
var $94c2c7ff32ca5bd1$export$1d567c320f4763bc = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("style");
var $94c2c7ff32ca5bd1$export$228be17d80722ab = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("alt");
var $94c2c7ff32ca5bd1$export$31eb53bd5b582a97 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("action");
var $94c2c7ff32ca5bd1$export$73f57eecff448cc8 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$27dc712f9cde9a29)("accept");


// Generated by purs version 0.15.15























// Generated by purs version 0.15.15













var $a393155e52307a24$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $a393155e52307a24$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($78c799cba34fcb8d$export$92659ee1fc91a075);
var $a393155e52307a24$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $a393155e52307a24$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $a393155e52307a24$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $a393155e52307a24$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $a393155e52307a24$var$$$Set = function(x) {
    return x;
};
var $a393155e52307a24$export$971dd5b0dfd021b6 = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd));
};
var $a393155e52307a24$export$e03c1c3201ee8bb7 = function(dictOrd) {
    var alter = $ea3eb84de0acf574$export$22a7378e1d3307a4(dictOrd);
    return function(a) {
        return function(v) {
            return alter($06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $06733ae99ed4f534$export$8a67b48435b5d073($05149ea687d6b460$export$523c0b569236b342))(function(v1) {
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }))(a)(v);
        };
    };
};
var $a393155e52307a24$export$e98af36a72b77685 = function(v) {
    return v;
};
var $a393155e52307a24$var$toList = function(v) {
    return $ea3eb84de0acf574$export$ed97f33186d4b816(v);
};
var $a393155e52307a24$export$823be24f8766da23 = function(dictUnfoldable) {
    var $96 = $3d4fd987da5242ff$export$823be24f8766da23(dictUnfoldable);
    return function($97) {
        return $96($a393155e52307a24$var$toList($97));
    };
};
var $a393155e52307a24$var$toUnfoldable1 = /* #__PURE__ */ $a393155e52307a24$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $a393155e52307a24$export$346677f925de839c = /* #__PURE__ */ $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$346677f925de839c);
var $a393155e52307a24$export$439306a4dcaafbb9 = function(a) {
    return $ea3eb84de0acf574$export$439306a4dcaafbb9(a)($05149ea687d6b460$export$523c0b569236b342);
};
var $a393155e52307a24$export$10430edbe04e7f5c = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225(dictShow));
    return {
        show: function(s) {
            return "(fromFoldable " + (show($a393155e52307a24$var$toUnfoldable1(s)) + ")");
        }
    };
};
var $a393155e52307a24$export$7c6a06df4f9b9fb3 = function(dictOrd) {
    return {
        append: $a393155e52307a24$export$971dd5b0dfd021b6(dictOrd)
    };
};
var $a393155e52307a24$export$6a0d13241802fe80 = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$6a0d13241802fe80(dictOrd));
};
var $a393155e52307a24$export$dd1bc94b04021eeb = /* #__PURE__ */ $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$dd1bc94b04021eeb);
var $a393155e52307a24$export$bc86dfbf7795668c = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$bc86dfbf7795668c(dictOrd));
};
var $a393155e52307a24$export$21a5ca8aa77d35ff = function(dictOrd) {
    var insert1 = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(a) {
        return function(v) {
            return insert1(a)($05149ea687d6b460$export$523c0b569236b342)(v);
        };
    };
};
var $a393155e52307a24$export$d81aa96f14f987cc = $a393155e52307a24$var$$$Set;
var $a393155e52307a24$export$fd19c21b7e75dff0 = {
    foldMap: function(dictMonoid) {
        var foldMap1 = $a393155e52307a24$var$foldMap(dictMonoid);
        return function(f) {
            var $98 = foldMap1(f);
            return function($99) {
                return $98($a393155e52307a24$var$toList($99));
            };
        };
    },
    foldl: function(f) {
        return function(x) {
            var $100 = $a393155e52307a24$var$foldl(f)(x);
            return function($101) {
                return $100($a393155e52307a24$var$toList($101));
            };
        };
    },
    foldr: function(f) {
        return function(x) {
            var $102 = $a393155e52307a24$var$foldr(f)(x);
            return function($103) {
                return $102($a393155e52307a24$var$toList($103));
            };
        };
    }
};
var $a393155e52307a24$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($a393155e52307a24$export$fd19c21b7e75dff0);
var $a393155e52307a24$var$foldr1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($a393155e52307a24$export$fd19c21b7e75dff0);
var $a393155e52307a24$export$3c39a95b7a4d5e28 = function(v) {
    return $a393155e52307a24$var$map1(function(v1) {
        return v1.key;
    })($ea3eb84de0acf574$export$3c39a95b7a4d5e28(v));
};
var $a393155e52307a24$export$35f577b3da447d17 = function(v) {
    return $a393155e52307a24$var$map1(function(v1) {
        return v1.key;
    })($ea3eb84de0acf574$export$35f577b3da447d17(v));
};
var $a393155e52307a24$export$3dea766d36a8935f = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$151f9a87a7fd5652(dictOrd));
};
var $a393155e52307a24$export$15038a5bf6277d57 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32($ea3eb84de0acf574$export$85aac4508ff70b8(dictEq)($37b880af5f4991bd$export$671c8820f3b36bad));
    return {
        eq: function(v) {
            return function(v1) {
                return eq(v)(v1);
            };
        }
    };
};
var $a393155e52307a24$export$273c875222ee923d = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($78c799cba34fcb8d$export$86359cd4476084f8(dictOrd));
    var eqSet1 = $a393155e52307a24$export$15038a5bf6277d57(dictOrd.Eq0());
    return {
        compare: function(s1) {
            return function(s2) {
                return compare($a393155e52307a24$var$toList(s1))($a393155e52307a24$var$toList(s2));
            };
        },
        Eq0: function() {
            return eqSet1;
        }
    };
};
var $a393155e52307a24$export$886f72205c1e73dc = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($a393155e52307a24$export$15038a5bf6277d57(dictEq));
    }
};
var $a393155e52307a24$export$3f209a28ab615424 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($a393155e52307a24$export$273c875222ee923d(dictOrd));
    },
    Eq10: function() {
        return $a393155e52307a24$export$886f72205c1e73dc;
    }
};
var $a393155e52307a24$export$6e22c362a0406a2c = $ea3eb84de0acf574$export$6e22c362a0406a2c;
var $a393155e52307a24$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictOrd) {
        var insert1 = $a393155e52307a24$export$21a5ca8aa77d35ff(dictOrd);
        return foldl2(function(m) {
            return function(a) {
                return insert1(a)(m);
            };
        })($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$871de8747c9eaa88 = function(dictOrd) {
    var insert1 = $a393155e52307a24$export$21a5ca8aa77d35ff(dictOrd);
    return function(f) {
        return $a393155e52307a24$var$foldl1(function(m) {
            return function(a) {
                return insert1(f(a))(m);
            };
        })($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$e70771d2e7e590a = function(dictOrd) {
    var insert1 = $a393155e52307a24$export$21a5ca8aa77d35ff(dictOrd);
    return function(f) {
        return $a393155e52307a24$var$foldr1(function(a) {
            return function(acc) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(acc)(function(b) {
                    return insert1(b)(acc);
                })(f(a));
            };
        })($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$30c0d87180d1a2c7 = function(dictOrd) {
    var semigroupSet1 = $a393155e52307a24$export$7c6a06df4f9b9fb3(dictOrd);
    return {
        mempty: $a393155e52307a24$export$6e22c362a0406a2c,
        Semigroup0: function() {
            return semigroupSet1;
        }
    };
};
var $a393155e52307a24$export$30b2db2f7030f6cf = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictOrd) {
        return foldl2($a393155e52307a24$export$971dd5b0dfd021b6(dictOrd))($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$acaf96a27438246b = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$acaf96a27438246b(dictOrd));
};
var $a393155e52307a24$export$e06bd7b1ab877a71 = function(dictOrd) {
    var difference1 = $a393155e52307a24$export$acaf96a27438246b(dictOrd);
    return function(s1) {
        return function(s2) {
            return $a393155e52307a24$export$dd1bc94b04021eeb(difference1(s1)(s2));
        };
    };
};
var $a393155e52307a24$export$fed8bbb04775a01f = function(dictOrd) {
    var subset1 = $a393155e52307a24$export$e06bd7b1ab877a71(dictOrd);
    return function(s1) {
        return function(s2) {
            return $a393155e52307a24$export$346677f925de839c(s1) !== $a393155e52307a24$export$346677f925de839c(s2) && subset1(s1)(s2);
        };
    };
};
var $a393155e52307a24$export$1822828d790e23ee = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$1822828d790e23ee(dictOrd));
};
var $a393155e52307a24$export$6583e3e95cb5e9d1 = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$6583e3e95cb5e9d1(dictOrd));
};
var $a393155e52307a24$export$986c2bbe7a34be0b = function(dictOrd) {
    return $a393155e52307a24$export$e70771d2e7e590a(dictOrd)($a393155e52307a24$var$identity);
};




// Generated by purs version 0.15.15













// Generated by purs version 0.15.15
const $80594d6a65468c7b$export$739ec22334c44788 = function(separator) {
    return function(xs) {
        return xs.join(separator);
    };
};







var $544b62a378cc0091$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $544b62a378cc0091$export$f7ad98836d6849e8 = {
    genericShowArgs: function(v) {
        return [];
    }
};
var $544b62a378cc0091$export$bc1180ef96fcb658 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        genericShowArgs: function(v) {
            return [
                show(v)
            ];
        }
    };
};
var $544b62a378cc0091$export$13bb3b5ea79b5fe6 = function(dict) {
    return dict.genericShowArgs;
};
var $544b62a378cc0091$export$b8b972500eedbc74 = function(dictGenericShowArgs) {
    var genericShowArgs1 = $544b62a378cc0091$export$13bb3b5ea79b5fe6(dictGenericShowArgs);
    return function(dictGenericShowArgs1) {
        var genericShowArgs2 = $544b62a378cc0091$export$13bb3b5ea79b5fe6(dictGenericShowArgs1);
        return {
            genericShowArgs: function(v) {
                return $544b62a378cc0091$var$append(genericShowArgs1(v.value0))(genericShowArgs2(v.value1));
            }
        };
    };
};
var $544b62a378cc0091$export$186afff91b813845 = function(dictGenericShowArgs) {
    var genericShowArgs1 = $544b62a378cc0091$export$13bb3b5ea79b5fe6(dictGenericShowArgs);
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return {
            "genericShow'": function(v) {
                var ctor = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                var v1 = genericShowArgs1(v);
                if (v1.length === 0) return ctor;
                return "(" + ($80594d6a65468c7b$export$739ec22334c44788(" ")($544b62a378cc0091$var$append([
                    ctor
                ])(v1)) + ")");
            }
        };
    };
};
var $544b62a378cc0091$export$c357439213aef314 = function(dict) {
    return dict["genericShow'"];
};
var $544b62a378cc0091$export$385ce500412a77a5 = {
    "genericShow'": function(a) {
        return $544b62a378cc0091$export$c357439213aef314($544b62a378cc0091$export$385ce500412a77a5)(a);
    }
};
var $544b62a378cc0091$export$29d77e0cd7b7a3b8 = function(dictGenericShow) {
    var genericShow$prime1 = $544b62a378cc0091$export$c357439213aef314(dictGenericShow);
    return function(dictGenericShow1) {
        var genericShow$prime2 = $544b62a378cc0091$export$c357439213aef314(dictGenericShow1);
        return {
            "genericShow'": function(v) {
                if (v instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return genericShow$prime1(v.value0);
                if (v instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return genericShow$prime2(v.value0);
                throw new Error("Failed pattern match at Data.Show.Generic (line 26, column 1 - line 28, column 40): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $544b62a378cc0091$export$dc29b8461849edae = function(dictGeneric) {
    var from = $91c996e9c07e3b3f$export$6788812c4e6611e6(dictGeneric);
    return function(dictGenericShow) {
        var genericShow$prime1 = $544b62a378cc0091$export$c357439213aef314(dictGenericShow);
        return function(x) {
            return genericShow$prime1(from(x));
        };
    };
};




// Generated by purs version 0.15.15











// Generated by purs version 0.15.15







var $4773a7d69b2a3dfa$var$Ratio = /* #__PURE__ */ function() {
    function Ratio(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Ratio.create = function(value0) {
        return function(value1) {
            return new Ratio(value0, value1);
        };
    };
    return Ratio;
}();
var $4773a7d69b2a3dfa$export$46b2b761681acea4 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return show(v.value0) + (" % " + show(v.value1));
        }
    };
};
var $4773a7d69b2a3dfa$export$533b26079ad0b4b = function(dictOrd) {
    var gcd = $b0cd729514c2504e$export$f81847884871263e(dictOrd.Eq0());
    var signum = $97937c29f879e68e$export$23e3e2011c250f0f(dictOrd);
    var abs = $97937c29f879e68e$export$2335f513bbd82c6d(dictOrd);
    return function(dictEuclideanRing) {
        var gcd1 = gcd(dictEuclideanRing);
        var div = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
        var Ring0 = dictEuclideanRing.CommutativeRing0().Ring0();
        var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(Ring0.Semiring0());
        var signum1 = signum(Ring0);
        var abs1 = abs(Ring0);
        return function(n) {
            return function(d) {
                var g = gcd1(n)(d);
                var d$prime = div(d)(g);
                return new $4773a7d69b2a3dfa$var$Ratio(mul(div(n)(g))(signum1(d$prime)), abs1(d$prime));
            };
        };
    };
};
var $4773a7d69b2a3dfa$export$b0a216647b29e763 = function(dictOrd) {
    var reduce1 = $4773a7d69b2a3dfa$export$533b26079ad0b4b(dictOrd);
    return function(dictEuclideanRing) {
        var Semiring0 = dictEuclideanRing.CommutativeRing0().Ring0().Semiring0();
        var one = $c0e822be92afc4df$export$80bf7733f1207381(Semiring0);
        var reduce2 = reduce1(dictEuclideanRing);
        var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(Semiring0);
        var add = $c0e822be92afc4df$export$e16d8520af44a096(Semiring0);
        return {
            one: new $4773a7d69b2a3dfa$var$Ratio(one, one),
            mul: function(v) {
                return function(v1) {
                    return reduce2(mul(v.value0)(v1.value0))(mul(v.value1)(v1.value1));
                };
            },
            zero: new $4773a7d69b2a3dfa$var$Ratio($c0e822be92afc4df$export$7f9972325ebfd559(Semiring0), one),
            add: function(v) {
                return function(v1) {
                    return reduce2(add(mul(v.value0)(v1.value1))(mul(v.value1)(v1.value0)))(mul(v.value1)(v1.value1));
                };
            }
        };
    };
};
var $4773a7d69b2a3dfa$export$6a580556093e5b78 = function(dictOrd) {
    var reduce1 = $4773a7d69b2a3dfa$export$533b26079ad0b4b(dictOrd);
    var semiringRatio1 = $4773a7d69b2a3dfa$export$b0a216647b29e763(dictOrd);
    return function(dictEuclideanRing) {
        var reduce2 = reduce1(dictEuclideanRing);
        var Ring0 = dictEuclideanRing.CommutativeRing0().Ring0();
        var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(Ring0);
        var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(Ring0.Semiring0());
        var semiringRatio2 = semiringRatio1(dictEuclideanRing);
        return {
            sub: function(v) {
                return function(v1) {
                    return reduce2(sub(mul(v.value0)(v1.value1))(mul(v.value1)(v1.value0)))(mul(v.value1)(v1.value1));
                };
            },
            Semiring0: function() {
                return semiringRatio2;
            }
        };
    };
};
var $4773a7d69b2a3dfa$export$2bc4f11f6cacaa80 = function(v) {
    return v.value0;
};
var $4773a7d69b2a3dfa$export$cd396f098c78c695 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(v) {
            return function(v1) {
                return eq(v.value0)(v1.value0) && eq(v.value1)(v1.value1);
            };
        }
    };
};
var $4773a7d69b2a3dfa$export$6edf50f41be9b8ed = function(dictOrd) {
    var ringRatio1 = $4773a7d69b2a3dfa$export$6a580556093e5b78(dictOrd);
    var Eq0 = dictOrd.Eq0();
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(Eq0);
    var greaterThan = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    var eqRatio1 = $4773a7d69b2a3dfa$export$cd396f098c78c695(Eq0);
    return function(dictEuclideanRing) {
        var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(ringRatio1(dictEuclideanRing));
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = sub(x)(y);
                    var $130 = eq(v.value0)(zero);
                    if ($130) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                    var v1 = greaterThan(v.value1)(zero);
                    var v2 = greaterThan(v.value0)(zero);
                    if (v2 && v1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    if (!v2 && !v1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                };
            },
            Eq0: function() {
                return eqRatio1;
            }
        };
    };
};
var $4773a7d69b2a3dfa$export$80b8e3eb9b1517b4 = function(dictOrd) {
    var ringRatio1 = $4773a7d69b2a3dfa$export$6a580556093e5b78(dictOrd);
    return function(dictEuclideanRing) {
        var ringRatio2 = ringRatio1(dictEuclideanRing);
        return {
            recip: function(v) {
                return new $4773a7d69b2a3dfa$var$Ratio(v.value1, v.value0);
            },
            Ring0: function() {
                return ringRatio2;
            }
        };
    };
};
var $4773a7d69b2a3dfa$export$1880de221d934f19 = function(v) {
    return v.value1;
};
var $4773a7d69b2a3dfa$export$a387e5f8e3f11c5e = function(dictOrd) {
    var ringRatio1 = $4773a7d69b2a3dfa$export$6a580556093e5b78(dictOrd);
    return function(dictEuclideanRing) {
        var ringRatio2 = ringRatio1(dictEuclideanRing);
        return {
            Ring0: function() {
                return ringRatio2;
            }
        };
    };
};
var $4773a7d69b2a3dfa$export$ed7618dc721bd207 = function(dictOrd) {
    var reduce1 = $4773a7d69b2a3dfa$export$533b26079ad0b4b(dictOrd);
    var semiringRatio1 = $4773a7d69b2a3dfa$export$b0a216647b29e763(dictOrd);
    var commutativeRingRatio1 = $4773a7d69b2a3dfa$export$a387e5f8e3f11c5e(dictOrd);
    return function(dictEuclideanRing) {
        var reduce2 = reduce1(dictEuclideanRing);
        var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0());
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(semiringRatio1(dictEuclideanRing));
        var commutativeRingRatio2 = commutativeRingRatio1(dictEuclideanRing);
        return {
            degree: function(v) {
                return 1;
            },
            div: function(v) {
                return function(v1) {
                    return reduce2(mul(v.value0)(v1.value1))(mul(v.value1)(v1.value0));
                };
            },
            mod: function(v) {
                return function(v1) {
                    return zero;
                };
            },
            CommutativeRing0: function() {
                return commutativeRingRatio2;
            }
        };
    };
};







var $f8662a4a41464b67$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $f8662a4a41464b67$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($05fb1b61396adfce$export$6a1d89187d209f74);
var $f8662a4a41464b67$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($05fb1b61396adfce$export$45def89472122d0b);
var $f8662a4a41464b67$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$604c31769a93bbe0);
var $f8662a4a41464b67$var$reduce = /* #__PURE__ */ $4773a7d69b2a3dfa$export$533b26079ad0b4b($97937c29f879e68e$export$ff461bf68e7dd332)($b0cd729514c2504e$export$437776face1858ae);
var $f8662a4a41464b67$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $f8662a4a41464b67$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $f8662a4a41464b67$export$40d01461b6e1c4fd = function(x) {
    return x;
};
var $f8662a4a41464b67$export$c936a351b926aade = {
    show: function(v) {
        return $f8662a4a41464b67$var$show(v.m) + ("." + ($f8662a4a41464b67$var$show(v.b) + ("." + ($f8662a4a41464b67$var$show($4773a7d69b2a3dfa$export$2bc4f11f6cacaa80(v.s)) + ("/" + $f8662a4a41464b67$var$show($4773a7d69b2a3dfa$export$1880de221d934f19(v.s)))))));
    }
};
var $f8662a4a41464b67$export$853b401c82d03be3 = /* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e()(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0($37b880af5f4991bd$export$d12253326f924cb1)()({
    reflectSymbol: function() {
        return "s";
    }
})(/* #__PURE__ */ $4773a7d69b2a3dfa$export$cd396f098c78c695($37b880af5f4991bd$export$e65788c6d4494539)))()({
    reflectSymbol: function() {
        return "m";
    }
})($37b880af5f4991bd$export$e65788c6d4494539))()({
    reflectSymbol: function() {
        return "b";
    }
})($37b880af5f4991bd$export$e65788c6d4494539));
var $f8662a4a41464b67$export$587da7685c8c8188 = /* #__PURE__ */ $50b5a2f2b28bbba4$export$d90166409dd04e85("0");
var $f8662a4a41464b67$export$8a40e5669d3698bc = function(d) {
    return $50b5a2f2b28bbba4$export$d90166409dd04e85(d) - $f8662a4a41464b67$export$587da7685c8c8188 | 0;
};
var $f8662a4a41464b67$export$5f87784a266e50a4 = /* #__PURE__ */ $f8662a4a41464b67$var$bind(/* #__PURE__ */ $fb26133a5ec46bf7$export$a75d1723e6bda2ec("+")(/* #__PURE__ */ $9da596880af1a1c5$export$eba6f6f03b0a92e7("-")))(function(signChar) {
    var sign = function() {
        var $39 = signChar === "-";
        if ($39) return -1;
        return 1;
    }();
    return $f8662a4a41464b67$var$bind($fb26133a5ec46bf7$export$a6482580fab70c30($9da596880af1a1c5$export$f5c52be128ae1598))(function(dgts) {
        return $f8662a4a41464b67$var$pure(sign * $f8662a4a41464b67$var$foldl(function(acc) {
            return function(d) {
                return (10 * acc | 0) + $f8662a4a41464b67$export$8a40e5669d3698bc(d) | 0;
            };
        })(0)(dgts) | 0);
    });
});
var $f8662a4a41464b67$export$b76370bfc0f26f5a = /* #__PURE__ */ $f8662a4a41464b67$var$bind($f8662a4a41464b67$export$5f87784a266e50a4)(function(num) {
    return $f8662a4a41464b67$var$bind($fb26133a5ec46bf7$export$a75d1723e6bda2ec(1)($f8662a4a41464b67$var$bind($9da596880af1a1c5$export$eba6f6f03b0a92e7("/"))(function() {
        return $f8662a4a41464b67$export$5f87784a266e50a4;
    })))(function(denom) {
        return $f8662a4a41464b67$var$pure($f8662a4a41464b67$var$reduce(num)(denom));
    });
});
var $f8662a4a41464b67$export$64c3f26010de5984 = function(str) {
    var v = function(v1) {
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at ProtoVoices.Common (line 53, column 1 - line 53, column 32): " + [
            str.constructor.name
        ]);
    };
    var $42 = $5b07e36f812dd04b$export$65980d18b75784e2(".")(str);
    if ($42.length === 3) return $f8662a4a41464b67$var$bind1($7d4cccdf062a2261$export$3a6c138b8d0f3874($05fb1b61396adfce$export$4ad9239eebc1597f($f8662a4a41464b67$export$5f87784a266e50a4)($42[0])))(function(m) {
        return $f8662a4a41464b67$var$bind1($7d4cccdf062a2261$export$3a6c138b8d0f3874($05fb1b61396adfce$export$4ad9239eebc1597f($f8662a4a41464b67$export$5f87784a266e50a4)($42[1])))(function(b) {
            return $f8662a4a41464b67$var$bind1($7d4cccdf062a2261$export$3a6c138b8d0f3874($05fb1b61396adfce$export$4ad9239eebc1597f($f8662a4a41464b67$export$b76370bfc0f26f5a)($42[2])))(function(s) {
                return $f8662a4a41464b67$var$pure1({
                    m: m,
                    b: b,
                    s: s
                });
            });
        });
    });
    return v(true);
};
var $f8662a4a41464b67$export$c9698ec7f05a07e1 = function(str) {
    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515(str))($7d4cccdf062a2261$export$19db0165690c701a.create)($f8662a4a41464b67$export$64c3f26010de5984(str));
};


// Generated by purs version 0.15.15


































// Generated by purs version 0.15.15
const $93c729927fdf3160$export$bef1f36f5486a6a3 = function(s) {
    return function() {
        console.log(s);
    };
};
const $93c729927fdf3160$export$c106dd0671a0fc2d = function(s) {
    return function() {
        console.warn(s);
    };
};
const $93c729927fdf3160$export$a3bc9b8ed74fc = function(s) {
    return function() {
        console.error(s);
    };
};
const $93c729927fdf3160$export$a80b3bd66acc52ff = function(s) {
    return function() {
        console.info(s);
    };
};
const $93c729927fdf3160$export$1c9f709888824e05 = function(s) {
    return function() {
        console.debug(s);
    };
};
const $93c729927fdf3160$export$2da9be4cfdb689b1 = function(s) {
    return function() {
        console.time(s);
    };
};
const $93c729927fdf3160$export$1694f226a9241aae = function(s) {
    return function() {
        console.timeLog(s);
    };
};
const $93c729927fdf3160$export$8f2977fb54cb3601 = function(s) {
    return function() {
        console.timeEnd(s);
    };
};
const $93c729927fdf3160$export$42ffd38884aecdac = function() {
    console.clear();
};
const $93c729927fdf3160$export$e5e25fbcc1f7affe = function(s) {
    return function() {
        console.group(s);
    };
};
const $93c729927fdf3160$export$488ef8fb3416a29f = function(s) {
    return function() {
        console.groupCollapsed(s);
    };
};
const $93c729927fdf3160$export$a57f3dfe595273e6 = function() {
    console.groupEnd();
};



var $78386b654cef599e$export$28709abf85ddce1d = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$c106dd0671a0fc2d(show(a));
    };
};
var $78386b654cef599e$export$9f43f5977f8d5609 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$bef1f36f5486a6a3(show(a));
    };
};
var $78386b654cef599e$export$fc9467e2ad369291 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$a80b3bd66acc52ff(show(a));
    };
};
var $78386b654cef599e$export$a188e271553f9211 = function(name) {
    return function(inner) {
        return function __do() {
            $93c729927fdf3160$export$e5e25fbcc1f7affe(name)();
            var result = inner();
            $93c729927fdf3160$export$a57f3dfe595273e6();
            return result;
        };
    };
};
var $78386b654cef599e$export$cbd229996ecd7704 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$a3bc9b8ed74fc(show(a));
    };
};
var $78386b654cef599e$export$18fab8ed91d044eb = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$1c9f709888824e05(show(a));
    };
};




var $97ffb09cc3d11a32$var$writeImpl = /* #__PURE__ */ $f505976c723c2a85$export$be94bcd43c4d1340($f505976c723c2a85$export$deb1d11818e4b91c);
var $97ffb09cc3d11a32$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $97ffb09cc3d11a32$var$toUnfoldable = /* #__PURE__ */ $a393155e52307a24$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $97ffb09cc3d11a32$var$alter = /* #__PURE__ */ $ea3eb84de0acf574$export$22a7378e1d3307a4($97937c29f879e68e$export$c5f2758e49b2b86a);
var $97ffb09cc3d11a32$var$ordTuple = /* #__PURE__ */ $71f2e2e9476163f8$export$8f11eb03746a66e2($97937c29f879e68e$export$c5f2758e49b2b86a)($97937c29f879e68e$export$c5f2758e49b2b86a);
var $97ffb09cc3d11a32$var$alter1 = /* #__PURE__ */ $ea3eb84de0acf574$export$22a7378e1d3307a4($97ffb09cc3d11a32$var$ordTuple);
var $97ffb09cc3d11a32$var$ordPitch = /* #__PURE__ */ $6416bd93bb20ed95$export$cddf5df7d4d146c7($364547bd6bbe186e$export$aa156b69905f503);
var $97ffb09cc3d11a32$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97ffb09cc3d11a32$var$ordPitch);
var $97ffb09cc3d11a32$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $97ffb09cc3d11a32$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $97ffb09cc3d11a32$var$insert = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($97937c29f879e68e$export$c5f2758e49b2b86a);
var $97ffb09cc3d11a32$var$insert1 = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($97ffb09cc3d11a32$var$ordTuple);
var $97ffb09cc3d11a32$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $97ffb09cc3d11a32$var$readImpl = /* #__PURE__ */ $f505976c723c2a85$export$f6103847fe734e8($f505976c723c2a85$export$dda73877cb166cd3);
var $97ffb09cc3d11a32$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $97ffb09cc3d11a32$var$fail = /* #__PURE__ */ $c97d2d0f578f81ad$export$2b62a06a9fee979c($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $97ffb09cc3d11a32$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781($78c799cba34fcb8d$export$a8cfc3dfdfca72cf)($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $97ffb09cc3d11a32$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88(/* #__PURE__ */ $d2284b2d3e1b6f87$export$d684c62fe584fcfa($50c50d1f444e5fa4$export$dc85e8383eafbd81));
var $97ffb09cc3d11a32$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $97ffb09cc3d11a32$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $6416bd93bb20ed95$export$5146a69d60451857($364547bd6bbe186e$export$176fc042e65ea01b));
var $97ffb09cc3d11a32$var$pc = /* #__PURE__ */ $6416bd93bb20ed95$export$42889321af78fdd7($364547bd6bbe186e$export$57bf37558439571a);
var $97ffb09cc3d11a32$var$add = /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($c0e822be92afc4df$export$7e80d6910c05bd77);
var $97ffb09cc3d11a32$var$genericShowConstructor = /* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$f7ad98836d6849e8);
var $97ffb09cc3d11a32$var$genericShowSum = /* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "NoParents";
    }
}));
var $97ffb09cc3d11a32$var$VertParentIsSymbol = {
    reflectSymbol: function() {
        return "VertParent";
    }
};
var $97ffb09cc3d11a32$var$showRecord = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()();
var $97ffb09cc3d11a32$var$leftIsSymbol = {
    reflectSymbol: function() {
        return "left";
    }
};
var $97ffb09cc3d11a32$var$showRecordFieldsCons = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($97ffb09cc3d11a32$var$leftIsSymbol);
var $97ffb09cc3d11a32$var$rightIsSymbol = {
    reflectSymbol: function() {
        return "right";
    }
};
var $97ffb09cc3d11a32$var$showRecordFieldsConsNil = /* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($97ffb09cc3d11a32$var$rightIsSymbol);
var $97ffb09cc3d11a32$var$MergeParentsIsSymbol = {
    reflectSymbol: function() {
        return "MergeParents";
    }
};
var $97ffb09cc3d11a32$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $97ffb09cc3d11a32$var$showRecordFieldsCons1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($97ffb09cc3d11a32$var$idIsSymbol);
var $97ffb09cc3d11a32$var$pitchIsSymbol = {
    reflectSymbol: function() {
        return "pitch";
    }
};
var $97ffb09cc3d11a32$var$showRecord1 = /* #__PURE__ */ $97ffb09cc3d11a32$var$showRecord(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecordFieldsCons1(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($97ffb09cc3d11a32$var$pitchIsSymbol)(/* #__PURE__ */ $6416bd93bb20ed95$export$26082705e1e7e214($364547bd6bbe186e$export$6c410b696f956741)))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $97ffb09cc3d11a32$var$showRecordFieldsCons2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "leftParent";
    }
});
var $97ffb09cc3d11a32$var$ornIsSymbol = {
    reflectSymbol: function() {
        return "orn";
    }
};
var $97ffb09cc3d11a32$var$showRecordFieldsCons3 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($97ffb09cc3d11a32$var$ornIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "rightParent";
    }
})($97ffb09cc3d11a32$var$showRecord1));
var $97ffb09cc3d11a32$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $97ffb09cc3d11a32$var$for_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$9747ee7caa0b40b1($6c2f8951ecf9531e$export$89bf999217d3022a)($78c799cba34fcb8d$export$92659ee1fc91a075);
var $97ffb09cc3d11a32$var$passingIsSymbol = {
    reflectSymbol: function() {
        return "passing";
    }
};
var $97ffb09cc3d11a32$var$regularIsSymbol = {
    reflectSymbol: function() {
        return "regular";
    }
};
var $97ffb09cc3d11a32$var$explIsSymbol = {
    reflectSymbol: function() {
        return "expl";
    }
};
var $97ffb09cc3d11a32$var$noteIsSymbol = {
    reflectSymbol: function() {
        return "note";
    }
};
var $97ffb09cc3d11a32$var$genericShowSum1 = /* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "Freeze";
    }
}));
var $97ffb09cc3d11a32$var$showRecordFieldsCons4 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "childl";
    }
});
var $97ffb09cc3d11a32$var$showRecordFieldsConsNil1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "childr";
    }
});
var $97ffb09cc3d11a32$var$showRecordFieldsCons5 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "op";
    }
});
var $97ffb09cc3d11a32$var$SplitIsSymbol = {
    reflectSymbol: function() {
        return "Split";
    }
};
var $97ffb09cc3d11a32$var$showRecordFieldsCons6 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "childm";
    }
});
var $97ffb09cc3d11a32$var$HoriIsSymbol = {
    reflectSymbol: function() {
        return "Hori";
    }
};
var $97ffb09cc3d11a32$var$power = /* #__PURE__ */ $784e1bd3d26d71da$export$836601bcef5ff40($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $97ffb09cc3d11a32$var$intercalate = /* #__PURE__ */ $4fe7b6acfba7f29f$export$739ec22334c44788($78c799cba34fcb8d$export$92659ee1fc91a075)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $97ffb09cc3d11a32$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $97ffb09cc3d11a32$var$isStep = /* #__PURE__ */ $6416bd93bb20ed95$export$21684750287da054($364547bd6bbe186e$export$cb9ca4c76889c909);
var $97ffb09cc3d11a32$var$ic = /* #__PURE__ */ $6416bd93bb20ed95$export$31770fd800a3b4bd($364547bd6bbe186e$export$57bf37558439571a);
var $97ffb09cc3d11a32$var$pto = /* #__PURE__ */ $6416bd93bb20ed95$export$fade3c794551cc08($364547bd6bbe186e$export$886b8a4150fa978e);
var $97ffb09cc3d11a32$var$degree = /* #__PURE__ */ $364547bd6bbe186e$export$a23b7da4bc008930(/* #__PURE__ */ $364547bd6bbe186e$export$c9a427c646d98c91($364547bd6bbe186e$export$698535b0a733192b)($364547bd6bbe186e$export$b9eb3b5b2e47d985)($364547bd6bbe186e$export$698535b0a733192b));
var $97ffb09cc3d11a32$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($5026be88823ef1f4$export$82d306ead3b703cd);
var $97ffb09cc3d11a32$var$direction = /* #__PURE__ */ $6416bd93bb20ed95$export$9fddb9d0dd7d8a54($364547bd6bbe186e$export$333a3644c6deea4c);
var $97ffb09cc3d11a32$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($364547bd6bbe186e$export$f7480551b533384f);
var $97ffb09cc3d11a32$var$unison = /* #__PURE__ */ $6416bd93bb20ed95$export$dcec75d6885620c1($364547bd6bbe186e$export$333a3644c6deea4c);
var $97ffb09cc3d11a32$var$ordRecord = /* #__PURE__ */ $97937c29f879e68e$export$ebb7a7956d139174();
var $97ffb09cc3d11a32$var$ordRecordCons = /* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611($97937c29f879e68e$export$927f7db8ecc0069f)();
var $97ffb09cc3d11a32$var$scanl = /* #__PURE__ */ $11d1e86de605dfc6$export$65f513eaf3c582b8($11d1e86de605dfc6$export$9e4a28683e28e26a);
var $97ffb09cc3d11a32$var$fromFoldable = /* #__PURE__ */ $3d4fd987da5242ff$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $97ffb09cc3d11a32$var$eqPitch = /* #__PURE__ */ $6416bd93bb20ed95$export$5146a69d60451857($364547bd6bbe186e$export$66d6281a18f726a9);
var $97ffb09cc3d11a32$var$eq4 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$var$eqPitch);
var $97ffb09cc3d11a32$var$eqRec = /* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e();
var $97ffb09cc3d11a32$var$eqRowCons = /* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0($37b880af5f4991bd$export$d12253326f924cb1)();
var $97ffb09cc3d11a32$var$eqRec1 = /* #__PURE__ */ $97ffb09cc3d11a32$var$eqRec(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $97ffb09cc3d11a32$var$eqRowCons($97ffb09cc3d11a32$var$pitchIsSymbol)($97ffb09cc3d11a32$var$eqPitch))()($97ffb09cc3d11a32$var$idIsSymbol)($37b880af5f4991bd$export$fa624555ca2acbc8));
var $97ffb09cc3d11a32$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($70cd3177464e7915$export$794f9574ca20b986);
var $97ffb09cc3d11a32$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($c50cfdb0b9e8fa31$export$8f0ac76856b1d87e);
var $97ffb09cc3d11a32$var$bind2 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $97ffb09cc3d11a32$var$pure2 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $97ffb09cc3d11a32$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $97ffb09cc3d11a32$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($97937c29f879e68e$export$c5f2758e49b2b86a);
var $97ffb09cc3d11a32$var$bind3 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $97ffb09cc3d11a32$var$pure3 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $97ffb09cc3d11a32$var$discard2 = /* #__PURE__ */ $97ffb09cc3d11a32$var$discard($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $97ffb09cc3d11a32$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $97ffb09cc3d11a32$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $97ffb09cc3d11a32$var$append2 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $97ffb09cc3d11a32$var$all = /* #__PURE__ */ $4fe7b6acfba7f29f$export$84bf76cd7afc7469($a393155e52307a24$export$fd19c21b7e75dff0)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $97ffb09cc3d11a32$var$toUnfoldable1 = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $97ffb09cc3d11a32$var$insertWith = /* #__PURE__ */ $ea3eb84de0acf574$export$435aa68287e449bf($97ffb09cc3d11a32$var$ordPitch);
var $97ffb09cc3d11a32$var$unionWith = /* #__PURE__ */ $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc($97ffb09cc3d11a32$var$ordPitch);
var $97ffb09cc3d11a32$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$ff461bf68e7dd332);
var $97ffb09cc3d11a32$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $97ffb09cc3d11a32$export$630321727b9ef04a = function(x) {
    return x;
};
var $97ffb09cc3d11a32$export$568b89e600fc77eb = /* #__PURE__ */ function() {
    function Start() {}
    Start.value = new Start();
    return Start;
}();
var $97ffb09cc3d11a32$export$f63ba74aa66682be = /* #__PURE__ */ function() {
    function Inner(value0) {
        this.value0 = value0;
    }
    Inner.create = function(value0) {
        return new Inner(value0);
    };
    return Inner;
}();
var $97ffb09cc3d11a32$export$ac4156b3386a7c70 = /* #__PURE__ */ function() {
    function Stop() {}
    Stop.value = new Stop();
    return Stop;
}();
var $97ffb09cc3d11a32$export$22537d7be8fe89a9 = /* #__PURE__ */ function() {
    function TrebleStaff() {}
    TrebleStaff.value = new TrebleStaff();
    return TrebleStaff;
}();
var $97ffb09cc3d11a32$export$657222a21023cba0 = /* #__PURE__ */ function() {
    function BassStaff() {}
    BassStaff.value = new BassStaff();
    return BassStaff;
}();
var $97ffb09cc3d11a32$export$725d191431df39a2 = /* #__PURE__ */ function() {
    function GrandStaff() {}
    GrandStaff.value = new GrandStaff();
    return GrandStaff;
}();
var $97ffb09cc3d11a32$export$9c29222029185c78 = function(x) {
    return x;
};
var $97ffb09cc3d11a32$export$ef0b5f914041d38a = /* #__PURE__ */ function() {
    function RightRepeat() {}
    RightRepeat.value = new RightRepeat();
    return RightRepeat;
}();
var $97ffb09cc3d11a32$export$fd951dac679282e1 = /* #__PURE__ */ function() {
    function RightNeighbor() {}
    RightNeighbor.value = new RightNeighbor();
    return RightNeighbor;
}();
var $97ffb09cc3d11a32$export$914e87441b58d7d9 = /* #__PURE__ */ function() {
    function NoParents() {}
    NoParents.value = new NoParents();
    return NoParents;
}();
var $97ffb09cc3d11a32$export$a94683cf162a309e = /* #__PURE__ */ function() {
    function VertParent(value0) {
        this.value0 = value0;
    }
    VertParent.create = function(value0) {
        return new VertParent(value0);
    };
    return VertParent;
}();
var $97ffb09cc3d11a32$export$a56b005ab5275675 = /* #__PURE__ */ function() {
    function MergeParents(value0) {
        this.value0 = value0;
    }
    MergeParents.create = function(value0) {
        return new MergeParents(value0);
    };
    return MergeParents;
}();
var $97ffb09cc3d11a32$export$e32a75e677fca455 = /* #__PURE__ */ function() {
    function LeftRepeat() {}
    LeftRepeat.value = new LeftRepeat();
    return LeftRepeat;
}();
var $97ffb09cc3d11a32$export$7bb038d575dcf9c9 = /* #__PURE__ */ function() {
    function LeftNeighbor() {}
    LeftNeighbor.value = new LeftNeighbor();
    return LeftNeighbor;
}();
var $97ffb09cc3d11a32$export$9ac4ca89af1eab6b = /* #__PURE__ */ function() {
    function FullNeighbor() {}
    FullNeighbor.value = new FullNeighbor();
    return FullNeighbor;
}();
var $97ffb09cc3d11a32$export$12a73def75ba91a = /* #__PURE__ */ function() {
    function FullRepeat() {}
    FullRepeat.value = new FullRepeat();
    return FullRepeat;
}();
var $97ffb09cc3d11a32$export$c33024bcf57ad853 = /* #__PURE__ */ function() {
    function LeftRepeatOfRight() {}
    LeftRepeatOfRight.value = new LeftRepeatOfRight();
    return LeftRepeatOfRight;
}();
var $97ffb09cc3d11a32$export$ad2c4a230ed49713 = /* #__PURE__ */ function() {
    function RightRepeatOfLeft() {}
    RightRepeatOfLeft.value = new RightRepeatOfLeft();
    return RightRepeatOfLeft;
}();
var $97ffb09cc3d11a32$export$b62f635e41790a80 = /* #__PURE__ */ function() {
    function PassingMid() {}
    PassingMid.value = new PassingMid();
    return PassingMid;
}();
var $97ffb09cc3d11a32$export$dab08a4db0f3867f = /* #__PURE__ */ function() {
    function PassingLeft() {}
    PassingLeft.value = new PassingLeft();
    return PassingLeft;
}();
var $97ffb09cc3d11a32$export$9cce9eb8c466c42b = /* #__PURE__ */ function() {
    function PassingRight() {}
    PassingRight.value = new PassingRight();
    return PassingRight;
}();
var $97ffb09cc3d11a32$export$7a00a90b2dd67bbb = /* #__PURE__ */ function() {
    function NoExpl() {}
    NoExpl.value = new NoExpl();
    return NoExpl;
}();
var $97ffb09cc3d11a32$export$2cf876164813516f = /* #__PURE__ */ function() {
    function RootExpl() {}
    RootExpl.value = new RootExpl();
    return RootExpl;
}();
var $97ffb09cc3d11a32$export$ae59325e7e640c51 = /* #__PURE__ */ function() {
    function HoriExpl(value0) {
        this.value0 = value0;
    }
    HoriExpl.create = function(value0) {
        return new HoriExpl(value0);
    };
    return HoriExpl;
}();
var $97ffb09cc3d11a32$export$a2bc3c1c57b6e07 = /* #__PURE__ */ function() {
    function RightExpl(value0) {
        this.value0 = value0;
    }
    RightExpl.create = function(value0) {
        return new RightExpl(value0);
    };
    return RightExpl;
}();
var $97ffb09cc3d11a32$export$a420550a5202c987 = /* #__PURE__ */ function() {
    function LeftExpl(value0) {
        this.value0 = value0;
    }
    LeftExpl.create = function(value0) {
        return new LeftExpl(value0);
    };
    return LeftExpl;
}();
var $97ffb09cc3d11a32$export$3301ca20023acaf7 = /* #__PURE__ */ function() {
    function DoubleExpl(value0) {
        this.value0 = value0;
    }
    DoubleExpl.create = function(value0) {
        return new DoubleExpl(value0);
    };
    return DoubleExpl;
}();
var $97ffb09cc3d11a32$export$f0826af67a39ec5d = /* #__PURE__ */ function() {
    function Freeze() {}
    Freeze.value = new Freeze();
    return Freeze;
}();
var $97ffb09cc3d11a32$export$f836382419f64c98 = /* #__PURE__ */ function() {
    function Split(value0) {
        this.value0 = value0;
    }
    Split.create = function(value0) {
        return new Split(value0);
    };
    return Split;
}();
var $97ffb09cc3d11a32$export$32baf76e6fd44656 = /* #__PURE__ */ function() {
    function Hori(value0) {
        this.value0 = value0;
    }
    Hori.create = function(value0) {
        return new Hori(value0);
    };
    return Hori;
}();
var $97ffb09cc3d11a32$export$19b98a801ae03b94 = $f505976c723c2a85$export$b21473867608729b;
var $97ffb09cc3d11a32$export$ec6372e832fca61 = function(dictWriteForeign) {
    var writeImpl1 = $f505976c723c2a85$export$be94bcd43c4d1340(dictWriteForeign);
    return {
        writeImpl: function(v) {
            if (v instanceof $97ffb09cc3d11a32$export$568b89e600fc77eb) return $97ffb09cc3d11a32$var$writeImpl("start");
            if (v instanceof $97ffb09cc3d11a32$export$ac4156b3386a7c70) return $97ffb09cc3d11a32$var$writeImpl("stop");
            if (v instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return writeImpl1(v.value0);
            throw new Error("Failed pattern match at ProtoVoices.Model (line 292, column 15 - line 295, column 27): " + [
                v.constructor.name
            ]);
        }
    };
};
var $97ffb09cc3d11a32$export$8446fc93dcb4e83 = $f505976c723c2a85$export$b21473867608729b;
var $97ffb09cc3d11a32$export$e53ad13ad01e4dc1 = function(trans) {
    return $97ffb09cc3d11a32$var$append($97ffb09cc3d11a32$var$toUnfoldable(trans.edges.regular))(trans.edges.passing);
};
var $97ffb09cc3d11a32$export$69fa464b623bcbaf = function(f) {
    return function(id) {
        return function(styles) {
            return {
                edges: styles.edges,
                slices: styles.slices,
                transitions: styles.transitions,
                css: styles.css,
                staff: styles.staff,
                notes: $97ffb09cc3d11a32$var$alter(f)(id)(styles.notes)
            };
        };
    };
};
var $97ffb09cc3d11a32$export$6d96ea7fb1c7d31b = function(f) {
    return function(id) {
        return function(styles) {
            return {
                notes: styles.notes,
                slices: styles.slices,
                transitions: styles.transitions,
                css: styles.css,
                staff: styles.staff,
                edges: $97ffb09cc3d11a32$var$alter1(f)(id)(styles.edges)
            };
        };
    };
};
var $97ffb09cc3d11a32$export$a9798ceb1fbb5dee = /* #__PURE__ */ function() {
    return {
        id: 0,
        notes: $97ffb09cc3d11a32$export$568b89e600fc77eb.value,
        x: 0.0,
        parents: $97ffb09cc3d11a32$export$914e87441b58d7d9.value
    };
}();
var $97ffb09cc3d11a32$export$e4b11f91485c291e = function(v) {
    if (v instanceof $97ffb09cc3d11a32$export$725d191431df39a2) return "grand";
    if (v instanceof $97ffb09cc3d11a32$export$22537d7be8fe89a9) return "treble";
    if (v instanceof $97ffb09cc3d11a32$export$657222a21023cba0) return "bass";
    throw new Error("Failed pattern match at ProtoVoices.Model (line 489, column 16 - line 492, column 22): " + [
        v.constructor.name
    ]);
};
var $97ffb09cc3d11a32$export$eb09cde4717acf6b = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b035e44d7bb4278f(function(a) {
    return function(b) {
        return $5026be88823ef1f4$export$6897c284b6f9f4dc($97ffb09cc3d11a32$var$compare(a.note.pitch)(b.note.pitch));
    };
});
var $97ffb09cc3d11a32$export$3bc6a27feb4afad9 = function(slice) {
    return function(id) {
        return {
            id: id,
            notes: new $97ffb09cc3d11a32$export$f63ba74aa66682be($97ffb09cc3d11a32$var$map(function(n) {
                return {
                    note: n.note,
                    expl: $97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value
                };
            })($97ffb09cc3d11a32$export$eb09cde4717acf6b(slice))),
            x: $4ab74a20512cef04$export$a0a81dc3380ce7d3(id),
            parents: $97ffb09cc3d11a32$export$914e87441b58d7d9.value
        };
    };
};
var $97ffb09cc3d11a32$export$d0eb33bf7c5b7bf5 = {
    show: function(v) {
        return "t" + $97ffb09cc3d11a32$var$show(v);
    }
};
var $97ffb09cc3d11a32$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($97ffb09cc3d11a32$export$d0eb33bf7c5b7bf5);
var $97ffb09cc3d11a32$export$69330288ca7d5e07 = function(dictShow) {
    var show7 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            if (v instanceof $97ffb09cc3d11a32$export$568b89e600fc77eb) return "\u22CA";
            if (v instanceof $97ffb09cc3d11a32$export$ac4156b3386a7c70) return "\u22C9";
            if (v instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return show7(v.value0);
            throw new Error("Failed pattern match at ProtoVoices.Model (line 286, column 1 - line 289, column 26): " + [
                v.constructor.name
            ]);
        }
    };
};
var $97ffb09cc3d11a32$var$showStartStop1 = /* #__PURE__ */ $97ffb09cc3d11a32$export$69330288ca7d5e07($97ffb09cc3d11a32$var$showRecord1);
var $97ffb09cc3d11a32$var$showRecord2 = /* #__PURE__ */ $97ffb09cc3d11a32$var$showRecord(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecordFieldsCons(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecordFieldsConsNil($97ffb09cc3d11a32$var$showStartStop1))($97ffb09cc3d11a32$var$showStartStop1));
var $97ffb09cc3d11a32$var$showRecord3 = /* #__PURE__ */ $97ffb09cc3d11a32$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "edges";
    }
})(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecordFieldsCons1(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "is2nd";
    }
})($2c6b3d51d10471a7$export$ad55f318773e3cd5))($97ffb09cc3d11a32$export$d0eb33bf7c5b7bf5))(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($97ffb09cc3d11a32$var$passingIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($97ffb09cc3d11a32$var$regularIsSymbol)(/* #__PURE__ */ $a393155e52307a24$export$10430edbe04e7f5c($97ffb09cc3d11a32$var$showRecord2)))(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($97ffb09cc3d11a32$var$showRecord2)))));
var $97ffb09cc3d11a32$var$logShow = /* #__PURE__ */ $78386b654cef599e$export$9f43f5977f8d5609($97ffb09cc3d11a32$var$showRecord3);
var $97ffb09cc3d11a32$var$showRecordFieldsConsNil2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "trans";
    }
})($97ffb09cc3d11a32$var$showRecord3);
var $97ffb09cc3d11a32$var$showRecordFieldsCons7 = /* #__PURE__ */ $97ffb09cc3d11a32$var$showRecordFieldsCons5($97ffb09cc3d11a32$var$showRecordFieldsConsNil2);
var $97ffb09cc3d11a32$var$show3 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($97ffb09cc3d11a32$var$showRecord3);
var $97ffb09cc3d11a32$var$show4 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($97ffb09cc3d11a32$var$showStartStop1);
var $97ffb09cc3d11a32$export$dbb383a7c8103542 = {
    show: function(v) {
        return "s" + $97ffb09cc3d11a32$var$show(v);
    }
};
var $97ffb09cc3d11a32$var$show5 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($97ffb09cc3d11a32$export$dbb383a7c8103542);
var $97ffb09cc3d11a32$export$5fbcf2fb8287c806 = function(id) {
    return function(style) {
        return function(model) {
            var notes$prime = $97ffb09cc3d11a32$var$insert(id)(style)(model.styles.notes);
            return {
                piece: model.piece,
                reduction: model.reduction,
                styles: {
                    edges: model.styles.edges,
                    slices: model.styles.slices,
                    transitions: model.styles.transitions,
                    css: model.styles.css,
                    staff: model.styles.staff,
                    notes: notes$prime
                }
            };
        };
    };
};
var $97ffb09cc3d11a32$export$2b86aefd33100264 = function(_child) {
    return function(parentMaybe) {
        return function(expl) {
            if (parentMaybe instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                if (expl instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$ae59325e7e640c51(parentMaybe.value0));
                if (expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$ae59325e7e640c51(parentMaybe.value0));
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }
            if (parentMaybe instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                if (expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value);
                if (expl instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value);
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }
            throw new Error("Failed pattern match at ProtoVoices.Model (line 242, column 45 - line 250, column 17): " + [
                parentMaybe.constructor.name
            ]);
        };
    };
};
var $97ffb09cc3d11a32$export$1b01816cd2426d03 = function(ids) {
    return function(style) {
        return function(model) {
            var edges$prime = $97ffb09cc3d11a32$var$insert1(ids)(style)(model.styles.edges);
            return {
                piece: model.piece,
                reduction: model.reduction,
                styles: {
                    notes: model.styles.notes,
                    slices: model.styles.slices,
                    transitions: model.styles.transitions,
                    css: model.styles.css,
                    staff: model.styles.staff,
                    edges: edges$prime
                }
            };
        };
    };
};
var $97ffb09cc3d11a32$export$d90eb951ab102d5b = $f505976c723c2a85$export$ac3747cb00139c63;
var $97ffb09cc3d11a32$export$7d8a38354856ffb1 = function(dictReadForeign) {
    var readImpl1 = $f505976c723c2a85$export$f6103847fe734e8(dictReadForeign);
    return {
        readImpl: function(frgn) {
            var tryOuter = $97ffb09cc3d11a32$var$bind($97ffb09cc3d11a32$var$readImpl(frgn))(function(str) {
                if (str === "start") return $97ffb09cc3d11a32$var$pure($97ffb09cc3d11a32$export$568b89e600fc77eb.value);
                if (str === "stop") return $97ffb09cc3d11a32$var$pure($97ffb09cc3d11a32$export$ac4156b3386a7c70.value);
                return $97ffb09cc3d11a32$var$fail(new $c97d2d0f578f81ad$export$f6a37cc43a8b8898("StartStop is neither Start nor Stop!"));
            });
            return $97ffb09cc3d11a32$var$alt(tryOuter)($97ffb09cc3d11a32$var$map1($97ffb09cc3d11a32$export$f63ba74aa66682be.create)(readImpl1(frgn)));
        }
    };
};
var $97ffb09cc3d11a32$export$9553db49b6c4bcae = $f505976c723c2a85$export$ac3747cb00139c63;
var $97ffb09cc3d11a32$export$f9e6cf1fd0a79590 = function(dictInterval) {
    var direction1 = $6416bd93bb20ed95$export$9fddb9d0dd7d8a54(dictInterval);
    var pto1 = $6416bd93bb20ed95$export$fade3c794551cc08(dictInterval);
    return function(dictEq) {
        var notEq1 = $37b880af5f4991bd$export$5475dfc31a65c2cd($6416bd93bb20ed95$export$5146a69d60451857(dictEq));
        return function(l) {
            return function(m) {
                return function(r) {
                    var odir = direction1(pto1(l)(r));
                    var dir2 = direction1(pto1(m)(r));
                    var dir1 = direction1(pto1(l)(m));
                    return notEq1(l)(m) && notEq1(m)(r) && notEq1(l)(r) && $97ffb09cc3d11a32$var$eq(dir1)(odir) && $97ffb09cc3d11a32$var$eq(dir2)(odir);
                };
            };
        };
    };
};
var $97ffb09cc3d11a32$export$566951113c2c5ddd = $97937c29f879e68e$export$ff461bf68e7dd332;
var $97ffb09cc3d11a32$var$insert2 = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($97ffb09cc3d11a32$export$566951113c2c5ddd);
var $97ffb09cc3d11a32$var$alter2 = /* #__PURE__ */ $ea3eb84de0acf574$export$22a7378e1d3307a4($97ffb09cc3d11a32$export$566951113c2c5ddd);
var $97ffb09cc3d11a32$export$206b5c1c37869e16 = function(id) {
    return function(style) {
        return function(model) {
            var transitions$prime = $97ffb09cc3d11a32$var$insert2(id)(style)(model.styles.transitions);
            return {
                piece: model.piece,
                reduction: model.reduction,
                styles: {
                    notes: model.styles.notes,
                    edges: model.styles.edges,
                    slices: model.styles.slices,
                    css: model.styles.css,
                    staff: model.styles.staff,
                    transitions: transitions$prime
                }
            };
        };
    };
};
var $97ffb09cc3d11a32$export$6f0d1bb2e765c911 = function(f) {
    return function(id) {
        return function(styles) {
            return {
                notes: styles.notes,
                edges: styles.edges,
                slices: styles.slices,
                css: styles.css,
                staff: styles.staff,
                transitions: $97ffb09cc3d11a32$var$alter2(f)(id)(styles.transitions)
            };
        };
    };
};
var $97ffb09cc3d11a32$export$b51fa3f60ce66bf3 = $97937c29f879e68e$export$ff461bf68e7dd332;
var $97ffb09cc3d11a32$var$insert3 = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($97ffb09cc3d11a32$export$b51fa3f60ce66bf3);
var $97ffb09cc3d11a32$var$alter3 = /* #__PURE__ */ $ea3eb84de0acf574$export$22a7378e1d3307a4($97ffb09cc3d11a32$export$b51fa3f60ce66bf3);
var $97ffb09cc3d11a32$export$d9463bc1f5cd5d56 = function(id) {
    return function(style) {
        return function(model) {
            var slices$prime = $97ffb09cc3d11a32$var$insert3(id)(style)(model.styles.slices);
            return {
                piece: model.piece,
                reduction: model.reduction,
                styles: {
                    notes: model.styles.notes,
                    edges: model.styles.edges,
                    transitions: model.styles.transitions,
                    css: model.styles.css,
                    staff: model.styles.staff,
                    slices: slices$prime
                }
            };
        };
    };
};
var $97ffb09cc3d11a32$export$c677a7979aeff2da = function(f) {
    return function(id) {
        return function(styles) {
            return {
                notes: styles.notes,
                edges: styles.edges,
                transitions: styles.transitions,
                css: styles.css,
                staff: styles.staff,
                slices: $97ffb09cc3d11a32$var$alter3(f)(id)(styles.slices)
            };
        };
    };
};
var $97ffb09cc3d11a32$export$d1444e2d33a2b556 = function(v) {
    if (v.left instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be && v.right instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return $97ffb09cc3d11a32$var$eq1($97ffb09cc3d11a32$var$pc(v.left.value0.pitch))($97ffb09cc3d11a32$var$pc(v.right.value0.pitch));
    return false;
};
var $97ffb09cc3d11a32$export$789865d9636612d2 = function(v) {
    return v + 1 | 0;
};
var $97ffb09cc3d11a32$export$3b674933b866e4e6 = function(v) {
    return v + 1 | 0;
};
var $97ffb09cc3d11a32$export$85488b7eb1e4976f = function(v) {
    if (v instanceof $97ffb09cc3d11a32$export$914e87441b58d7d9) return [];
    if (v instanceof $97ffb09cc3d11a32$export$a94683cf162a309e) return [
        v.value0
    ];
    if (v instanceof $97ffb09cc3d11a32$export$a56b005ab5275675) return [
        v.value0.left,
        v.value0.right
    ];
    throw new Error("Failed pattern match at ProtoVoices.Model (line 385, column 14 - line 388, column 50): " + [
        v.constructor.name
    ]);
};
var $97ffb09cc3d11a32$export$a45279548abf4fad = function(slice) {
    if (slice.notes instanceof $97ffb09cc3d11a32$export$568b89e600fc77eb) return [];
    if (slice.notes instanceof $97ffb09cc3d11a32$export$ac4156b3386a7c70) return [];
    if (slice.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return slice.notes.value0;
    throw new Error("Failed pattern match at ProtoVoices.Model (line 398, column 23 - line 401, column 23): " + [
        slice.notes.constructor.name
    ]);
};
var $97ffb09cc3d11a32$export$d262b423ef7122a5 = function(v) {
    if (v instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $97ffb09cc3d11a32$export$524194cb636e8766 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$22537d7be8fe89a9.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$657222a21023cba0.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return $97ffb09cc3d11a32$export$725d191431df39a2.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 482, column 1 - line 482, column 48): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $97ffb09cc3d11a32$export$22537d7be8fe89a9) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $97ffb09cc3d11a32$export$657222a21023cba0) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value));
        if (x instanceof $97ffb09cc3d11a32$export$725d191431df39a2) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6($91c996e9c07e3b3f$export$928c7f2d618c070b.value));
        throw new Error("Failed pattern match at ProtoVoices.Model (line 482, column 1 - line 482, column 48): " + [
            x.constructor.name
        ]);
    }
};
var $97ffb09cc3d11a32$export$ee119379426a03de = {
    show: /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($97ffb09cc3d11a32$export$524194cb636e8766)(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
        reflectSymbol: function() {
            return "TrebleStaff";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
        reflectSymbol: function() {
            return "BassStaff";
        }
    }))(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
        reflectSymbol: function() {
            return "GrandStaff";
        }
    }))))
};
var $97ffb09cc3d11a32$export$ac749acb292162a5 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$ef0b5f914041d38a.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return $97ffb09cc3d11a32$export$fd951dac679282e1.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 47, column 1 - line 47, column 64): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $97ffb09cc3d11a32$export$ef0b5f914041d38a) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $97ffb09cc3d11a32$export$fd951dac679282e1) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 47, column 1 - line 47, column 64): " + [
            x.constructor.name
        ]);
    }
};
var $97ffb09cc3d11a32$var$genericShow = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($97ffb09cc3d11a32$export$ac749acb292162a5)(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "RightRepeat";
    }
}))(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "RightNeighbor";
    }
})));
var $97ffb09cc3d11a32$export$1cd099438f719ac7 = {
    show: function(ro) {
        return $97ffb09cc3d11a32$var$genericShow(ro);
    }
};
var $97ffb09cc3d11a32$export$53b1fa8559af5203 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$914e87441b58d7d9.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $97ffb09cc3d11a32$export$a94683cf162a309e(x.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $97ffb09cc3d11a32$export$a56b005ab5275675(x.value0.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 379, column 1 - line 379, column 56): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $97ffb09cc3d11a32$export$914e87441b58d7d9) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $97ffb09cc3d11a32$export$a94683cf162a309e) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0));
        if (x instanceof $97ffb09cc3d11a32$export$a56b005ab5275675) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0));
        throw new Error("Failed pattern match at ProtoVoices.Model (line 379, column 1 - line 379, column 56): " + [
            x.constructor.name
        ]);
    }
};
var $97ffb09cc3d11a32$var$genericShow1 = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($97ffb09cc3d11a32$export$53b1fa8559af5203);
var $97ffb09cc3d11a32$export$c76357f64fff591f = function(dictShow) {
    var genericShow6 = $97ffb09cc3d11a32$var$genericShow1($97ffb09cc3d11a32$var$genericShowSum($544b62a378cc0091$export$29d77e0cd7b7a3b8($544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$bc1180ef96fcb658(dictShow))($97ffb09cc3d11a32$var$VertParentIsSymbol))($544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$bc1180ef96fcb658($97ffb09cc3d11a32$var$showRecord($97ffb09cc3d11a32$var$showRecordFieldsCons($97ffb09cc3d11a32$var$showRecordFieldsConsNil(dictShow))(dictShow))))($97ffb09cc3d11a32$var$MergeParentsIsSymbol))));
    return {
        show: function(p) {
            return genericShow6(p);
        }
    };
};
var $97ffb09cc3d11a32$export$d16b1070f480e43d = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$f0826af67a39ec5d.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $97ffb09cc3d11a32$export$f836382419f64c98(x.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $97ffb09cc3d11a32$export$32baf76e6fd44656(x.value0.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 422, column 1 - line 422, column 42): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0));
        if (x instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0));
        throw new Error("Failed pattern match at ProtoVoices.Model (line 422, column 1 - line 422, column 42): " + [
            x.constructor.name
        ]);
    }
};
var $97ffb09cc3d11a32$var$genericShow2 = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($97ffb09cc3d11a32$export$d16b1070f480e43d);
var $97ffb09cc3d11a32$export$e18958c2e937e925 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$2cf876164813516f.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $97ffb09cc3d11a32$export$ae59325e7e640c51(x.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $97ffb09cc3d11a32$export$a2bc3c1c57b6e07(x.value0.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $97ffb09cc3d11a32$export$a420550a5202c987(x.value0.value0.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $97ffb09cc3d11a32$export$3301ca20023acaf7(x.value0.value0.value0.value0.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 89, column 1 - line 89, column 68): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $97ffb09cc3d11a32$export$2cf876164813516f) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value));
        if (x instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0)));
        if (x instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0))));
        if (x instanceof $97ffb09cc3d11a32$export$a420550a5202c987) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0)))));
        if (x instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0)))));
        throw new Error("Failed pattern match at ProtoVoices.Model (line 89, column 1 - line 89, column 68): " + [
            x.constructor.name
        ]);
    }
};
var $97ffb09cc3d11a32$export$2b4c6bf55c3965e = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$e32a75e677fca455.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return $97ffb09cc3d11a32$export$7bb038d575dcf9c9.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 58, column 1 - line 58, column 62): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $97ffb09cc3d11a32$export$e32a75e677fca455) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $97ffb09cc3d11a32$export$7bb038d575dcf9c9) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 58, column 1 - line 58, column 62): " + [
            x.constructor.name
        ]);
    }
};
var $97ffb09cc3d11a32$var$genericShow3 = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($97ffb09cc3d11a32$export$2b4c6bf55c3965e)(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "LeftRepeat";
    }
}))(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "LeftNeighbor";
    }
})));
var $97ffb09cc3d11a32$export$e0728f9a6ccaeb32 = {
    show: function(lo) {
        return $97ffb09cc3d11a32$var$genericShow3(lo);
    }
};
var $97ffb09cc3d11a32$export$46643786c2c2a3be = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$9ac4ca89af1eab6b.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$12a73def75ba91a.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$c33024bcf57ad853.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$ad2c4a230ed49713.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$b62f635e41790a80.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $97ffb09cc3d11a32$export$dab08a4db0f3867f.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return $97ffb09cc3d11a32$export$9cce9eb8c466c42b.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 74, column 1 - line 74, column 66): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $97ffb09cc3d11a32$export$9ac4ca89af1eab6b) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $97ffb09cc3d11a32$export$12a73def75ba91a) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value));
        if (x instanceof $97ffb09cc3d11a32$export$c33024bcf57ad853) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value)));
        if (x instanceof $97ffb09cc3d11a32$export$ad2c4a230ed49713) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value))));
        if (x instanceof $97ffb09cc3d11a32$export$b62f635e41790a80) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value)))));
        if (x instanceof $97ffb09cc3d11a32$export$dab08a4db0f3867f) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value))))));
        if (x instanceof $97ffb09cc3d11a32$export$9cce9eb8c466c42b) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6($91c996e9c07e3b3f$export$928c7f2d618c070b.value))))));
        throw new Error("Failed pattern match at ProtoVoices.Model (line 74, column 1 - line 74, column 66): " + [
            x.constructor.name
        ]);
    }
};
var $97ffb09cc3d11a32$var$genericShow4 = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($97ffb09cc3d11a32$export$46643786c2c2a3be)(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "FullNeighbor";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "FullRepeat";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "LeftRepeatOfRight";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "RightRepeatOfLeft";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "PassingMid";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "PassingLeft";
    }
}))(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "PassingRight";
    }
}))))))));
var $97ffb09cc3d11a32$export$642f92ca6de37b54 = {
    show: function(o) {
        return $97ffb09cc3d11a32$var$genericShow4(o);
    }
};
var $97ffb09cc3d11a32$var$genericShow5 = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($97ffb09cc3d11a32$export$e18958c2e937e925)(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "NoExpl";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $97ffb09cc3d11a32$var$genericShowConstructor({
    reflectSymbol: function() {
        return "RootExpl";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658($97ffb09cc3d11a32$var$showRecord1))({
    reflectSymbol: function() {
        return "HoriExpl";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecord(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecordFieldsCons2(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($97ffb09cc3d11a32$var$ornIsSymbol)(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($97ffb09cc3d11a32$export$1cd099438f719ac7)))($97ffb09cc3d11a32$var$showRecord1))))({
    reflectSymbol: function() {
        return "RightExpl";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecord(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecordFieldsCons3(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($97ffb09cc3d11a32$export$e0728f9a6ccaeb32)))))({
    reflectSymbol: function() {
        return "LeftExpl";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecord(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecordFieldsCons2(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecordFieldsCons3(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($97ffb09cc3d11a32$export$642f92ca6de37b54)))($97ffb09cc3d11a32$var$showRecord1))))({
    reflectSymbol: function() {
        return "DoubleExpl";
    }
})))))));
var $97ffb09cc3d11a32$export$a12c6fb847c83c0b = {
    show: function(o) {
        return $97ffb09cc3d11a32$var$genericShow5(o);
    }
};
var $97ffb09cc3d11a32$var$showRecord4 = /* #__PURE__ */ $97ffb09cc3d11a32$var$showRecord(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecordFieldsCons1(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "notes";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "parents";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "x";
    }
})($2c6b3d51d10471a7$export$e5aa470f8f97c3fe))(/* #__PURE__ */ $97ffb09cc3d11a32$export$c76357f64fff591f($97ffb09cc3d11a32$export$dbb383a7c8103542)))(/* #__PURE__ */ $97ffb09cc3d11a32$export$69330288ca7d5e07(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225(/* #__PURE__ */ $97ffb09cc3d11a32$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($97ffb09cc3d11a32$var$explIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($97ffb09cc3d11a32$var$noteIsSymbol)($97ffb09cc3d11a32$var$showRecord1))($97ffb09cc3d11a32$export$a12c6fb847c83c0b))))))($97ffb09cc3d11a32$export$dbb383a7c8103542));
var $97ffb09cc3d11a32$var$logShow1 = /* #__PURE__ */ $78386b654cef599e$export$9f43f5977f8d5609($97ffb09cc3d11a32$var$showRecord4);
var $97ffb09cc3d11a32$var$showRecordFieldsCons8 = /* #__PURE__ */ $97ffb09cc3d11a32$var$showRecordFieldsCons5(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "rslice";
    }
})($97ffb09cc3d11a32$var$showRecordFieldsConsNil2)($97ffb09cc3d11a32$var$showRecord4));
var $97ffb09cc3d11a32$var$show6 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($97ffb09cc3d11a32$var$showRecord4);
var $97ffb09cc3d11a32$export$9843a673c888814a = function(model) {
    return function __do() {
        $93c729927fdf3160$export$bef1f36f5486a6a3("\u22CA")();
        return $97ffb09cc3d11a32$var$for_(model.reduction.segments)(function(seg) {
            return function __do() {
                $97ffb09cc3d11a32$var$logShow(seg.trans)();
                return $97ffb09cc3d11a32$var$logShow1(seg.rslice)();
            };
        })();
    };
};
var $97ffb09cc3d11a32$export$4ec95b820574dfd6 = {
    show: function(x) {
        return $97ffb09cc3d11a32$var$genericShow2($97ffb09cc3d11a32$var$genericShowSum1($544b62a378cc0091$export$29d77e0cd7b7a3b8($544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$bc1180ef96fcb658($97ffb09cc3d11a32$var$showRecord($97ffb09cc3d11a32$var$showRecordFieldsCons4($97ffb09cc3d11a32$var$showRecordFieldsConsNil1($97ffb09cc3d11a32$var$showRecord($97ffb09cc3d11a32$var$showRecordFieldsCons7($97ffb09cc3d11a32$export$4ec95b820574dfd6))))($97ffb09cc3d11a32$var$showRecord($97ffb09cc3d11a32$var$showRecordFieldsCons8($97ffb09cc3d11a32$export$4ec95b820574dfd6))))))($97ffb09cc3d11a32$var$SplitIsSymbol))($544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$bc1180ef96fcb658($97ffb09cc3d11a32$var$showRecord($97ffb09cc3d11a32$var$showRecordFieldsCons4($97ffb09cc3d11a32$var$showRecordFieldsCons6($97ffb09cc3d11a32$var$showRecordFieldsConsNil1($97ffb09cc3d11a32$var$showRecord($97ffb09cc3d11a32$var$showRecordFieldsCons7($97ffb09cc3d11a32$export$4ec95b820574dfd6))))($97ffb09cc3d11a32$var$showRecord($97ffb09cc3d11a32$var$showRecordFieldsCons8($97ffb09cc3d11a32$export$4ec95b820574dfd6))))($97ffb09cc3d11a32$var$showRecord($97ffb09cc3d11a32$var$showRecordFieldsCons8($97ffb09cc3d11a32$export$4ec95b820574dfd6))))))($97ffb09cc3d11a32$var$HoriIsSymbol))))(x);
    }
};
var $97ffb09cc3d11a32$export$e67d8a9d44232e9c = function(v) {
    var showSegment$prime = function(indent) {
        return function(v1) {
            return $97ffb09cc3d11a32$var$power(" ")(indent) + ("trans: " + ($97ffb09cc3d11a32$var$show3(v1.trans) + (", op:" + showChildren(indent)(v1.op))));
        };
    };
    var showSegment = function(indent) {
        return function(v1) {
            return $97ffb09cc3d11a32$var$power(" ")(indent) + ("trans: " + ($97ffb09cc3d11a32$var$show3(v1.trans) + (", rslice: " + ($97ffb09cc3d11a32$var$show6(v1.rslice) + (", op:" + showChildren(indent)(v1.op))))));
        };
    };
    var showChildren = function(indent) {
        return function(v1) {
            if (v1 instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return "Freeze";
            if (v1 instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return "Split\n" + (showSegment(indent + 1 | 0)(v1.value0.childl) + ("\n" + showSegment$prime(indent + 1 | 0)(v1.value0.childr)));
            if (v1 instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) return "Hori\n" + (showSegment(indent + 1 | 0)(v1.value0.childl) + ("\n" + (showSegment(indent + 1 | 0)(v1.value0.childm) + ("\n" + showSegment$prime(indent + 1 | 0)(v1.value0.childr)))));
            throw new Error("Failed pattern match at ProtoVoices.Model (line 545, column 25 - line 558, column 44): " + [
                v1.constructor.name
            ]);
        };
    };
    return $97ffb09cc3d11a32$var$intercalate("\n")($97ffb09cc3d11a32$var$map2(showSegment(0))(v.segments));
};
var $97ffb09cc3d11a32$export$2cda0bd0f22dfe3e = {
    map: function(f) {
        return function(m) {
            if (m instanceof $97ffb09cc3d11a32$export$568b89e600fc77eb) return $97ffb09cc3d11a32$export$568b89e600fc77eb.value;
            if (m instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return new $97ffb09cc3d11a32$export$f63ba74aa66682be(f(m.value0));
            if (m instanceof $97ffb09cc3d11a32$export$ac4156b3386a7c70) return $97ffb09cc3d11a32$export$ac4156b3386a7c70.value;
            throw new Error("Failed pattern match at ProtoVoices.Model (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $97ffb09cc3d11a32$var$map5 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($97ffb09cc3d11a32$export$2cda0bd0f22dfe3e);
var $97ffb09cc3d11a32$export$801746a44e6e4f07 = function(seg) {
    return {
        trans: seg.trans,
        op: seg.op,
        rslice: {
            id: seg.rslice.id,
            x: seg.rslice.x,
            parents: seg.rslice.parents,
            notes: $97ffb09cc3d11a32$var$map5($97ffb09cc3d11a32$var$map(function(note) {
                return {
                    note: note.note,
                    expl: $97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value
                };
            }))(seg.rslice.notes)
        }
    };
};
var $97ffb09cc3d11a32$export$74fa6e5e3f891025 = function(child) {
    return function(v) {
        if ($97ffb09cc3d11a32$var$eq1($97ffb09cc3d11a32$var$pc(child))($97ffb09cc3d11a32$var$pc(v.pitch))) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$ef0b5f914041d38a.value);
        if ($97ffb09cc3d11a32$var$isStep($97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(child)(v.pitch)))) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$fd951dac679282e1.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 152, column 1 - line 152, column 54): " + [
            child.constructor.name,
            v.constructor.name
        ]);
    };
};
var $97ffb09cc3d11a32$export$7131272324e67074 = function(child) {
    return function(v) {
        if ($97ffb09cc3d11a32$var$eq1($97ffb09cc3d11a32$var$pc(child))($97ffb09cc3d11a32$var$pc(v.pitch))) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$e32a75e677fca455.value);
        if ($97ffb09cc3d11a32$var$isStep($97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(child)(v.pitch)))) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$7bb038d575dcf9c9.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 146, column 1 - line 146, column 52): " + [
            child.constructor.name,
            v.constructor.name
        ]);
    };
};
var $97ffb09cc3d11a32$export$9ed0694e8e982932 = function(child) {
    return function(v) {
        return function(v1) {
            var v2 = function(v3) {
                var v4 = function(v5) {
                    var v6 = function(v7) {
                        var v8 = function(v9) {
                            var v10 = function(v11) {
                                var v12 = function(v13) {
                                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                                        var $826 = $97ffb09cc3d11a32$var$isStep($97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(child)(v.pitch)));
                                        if ($826) {
                                            var $827 = $97ffb09cc3d11a32$var$isStep($97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(child)(v1.pitch)));
                                            if ($827) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$b62f635e41790a80.value);
                                            return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$dab08a4db0f3867f.value);
                                        }
                                        var $828 = $97ffb09cc3d11a32$var$isStep($97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(child)(v1.pitch)));
                                        if ($828) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$9cce9eb8c466c42b.value);
                                        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                                    }
                                    throw new Error("Failed pattern match at ProtoVoices.Model (line 167, column 1 - line 167, column 64): " + [
                                        child.constructor.name,
                                        v.constructor.name,
                                        v1.constructor.name
                                    ]);
                                };
                                var $834 = $97ffb09cc3d11a32$var$degree($97ffb09cc3d11a32$var$pc(v.pitch)) === $97ffb09cc3d11a32$var$degree($97ffb09cc3d11a32$var$pc(v1.pitch));
                                if ($834) {
                                    var $835 = $97ffb09cc3d11a32$var$isStep($97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(child)(v.pitch)));
                                    if ($835) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$9ac4ca89af1eab6b.value);
                                    return v12(true);
                                }
                                return v12(true);
                            };
                            var $841 = $97ffb09cc3d11a32$var$degree($97ffb09cc3d11a32$var$pc(child)) === $97ffb09cc3d11a32$var$degree($97ffb09cc3d11a32$var$pc(v1.pitch));
                            if ($841) {
                                var $842 = $97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(v.pitch)(child));
                                var $843 = $97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(child)(v1.pitch));
                                var $844 = $97ffb09cc3d11a32$var$isStep($842);
                                if ($844) {
                                    var $845 = $97ffb09cc3d11a32$var$notEq($97ffb09cc3d11a32$var$direction($842))($97ffb09cc3d11a32$var$compare1($843)($97ffb09cc3d11a32$var$unison));
                                    if ($845) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$c33024bcf57ad853.value);
                                    return v10(true);
                                }
                                return v10(true);
                            }
                            return v10(true);
                        };
                        var $851 = $97ffb09cc3d11a32$var$degree($97ffb09cc3d11a32$var$pc(child)) === $97ffb09cc3d11a32$var$degree($97ffb09cc3d11a32$var$pc(v.pitch));
                        if ($851) {
                            var $852 = $97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(v.pitch)(child));
                            var $853 = $97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(child)(v1.pitch));
                            var $854 = $97ffb09cc3d11a32$var$isStep($853);
                            if ($854) {
                                var $855 = $97ffb09cc3d11a32$var$notEq($97ffb09cc3d11a32$var$compare1($852)($97ffb09cc3d11a32$var$unison))($97ffb09cc3d11a32$var$direction($853));
                                if ($855) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$ad2c4a230ed49713.value);
                                return v8(true);
                            }
                            return v8(true);
                        }
                        return v8(true);
                    };
                    var $861 = $97ffb09cc3d11a32$var$eq1($97ffb09cc3d11a32$var$pc(child))($97ffb09cc3d11a32$var$pc(v1.pitch));
                    if ($861) {
                        var $862 = $97ffb09cc3d11a32$var$isStep($97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(child)(v.pitch)));
                        if ($862) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$c33024bcf57ad853.value);
                        return v6(true);
                    }
                    return v6(true);
                };
                var $868 = $97ffb09cc3d11a32$var$eq1($97ffb09cc3d11a32$var$pc(child))($97ffb09cc3d11a32$var$pc(v.pitch));
                if ($868) {
                    var $869 = $97ffb09cc3d11a32$var$isStep($97ffb09cc3d11a32$var$ic($97ffb09cc3d11a32$var$pto(child)(v1.pitch)));
                    if ($869) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$ad2c4a230ed49713.value);
                    return v4(true);
                }
                return v4(true);
            };
            var $875 = $97ffb09cc3d11a32$var$eq1($97ffb09cc3d11a32$var$pc(child))($97ffb09cc3d11a32$var$pc(v.pitch));
            if ($875) {
                var $876 = $97ffb09cc3d11a32$var$eq1($97ffb09cc3d11a32$var$pc(child))($97ffb09cc3d11a32$var$pc(v1.pitch));
                if ($876) return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$12a73def75ba91a.value);
                return v2(true);
            }
            return v2(true);
        };
    };
};
var $97ffb09cc3d11a32$export$64f7534ed956f73 = function(child) {
    return function(leftParentMaybe) {
        return function(expl) {
            if (leftParentMaybe instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                if (expl instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$a2bc3c1c57b6e07({
                    orn: $97ffb09cc3d11a32$export$74fa6e5e3f891025(child)(leftParentMaybe.value0),
                    leftParent: leftParentMaybe.value0
                }));
                if (expl instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$a2bc3c1c57b6e07({
                    orn: $97ffb09cc3d11a32$export$74fa6e5e3f891025(child)(leftParentMaybe.value0),
                    leftParent: leftParentMaybe.value0
                }));
                if (expl instanceof $97ffb09cc3d11a32$export$a420550a5202c987) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$3301ca20023acaf7({
                    orn: $97ffb09cc3d11a32$export$9ed0694e8e982932(child)(leftParentMaybe.value0)(expl.value0.rightParent),
                    leftParent: leftParentMaybe.value0,
                    rightParent: expl.value0.rightParent
                }));
                if (expl instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$3301ca20023acaf7({
                    orn: $97ffb09cc3d11a32$export$9ed0694e8e982932(child)(leftParentMaybe.value0)(expl.value0.rightParent),
                    leftParent: leftParentMaybe.value0,
                    rightParent: expl.value0.rightParent
                }));
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }
            if (leftParentMaybe instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                if (expl instanceof $97ffb09cc3d11a32$export$a420550a5202c987) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$a420550a5202c987(expl.value0));
                if (expl instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$a420550a5202c987({
                    orn: $97ffb09cc3d11a32$export$7131272324e67074(child)(expl.value0.rightParent),
                    rightParent: expl.value0.rightParent
                }));
                if (expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value);
            }
            throw new Error("Failed pattern match at ProtoVoices.Model (line 190, column 48 - line 213, column 21): " + [
                leftParentMaybe.constructor.name
            ]);
        };
    };
};
var $97ffb09cc3d11a32$export$bcc5f0735f42d0c8 = function(child) {
    return function(rightParentMaybe) {
        return function(expl) {
            if (rightParentMaybe instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                if (expl instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$a420550a5202c987({
                    orn: $97ffb09cc3d11a32$export$7131272324e67074(child)(rightParentMaybe.value0),
                    rightParent: rightParentMaybe.value0
                }));
                if (expl instanceof $97ffb09cc3d11a32$export$a420550a5202c987) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$a420550a5202c987({
                    orn: $97ffb09cc3d11a32$export$7131272324e67074(child)(rightParentMaybe.value0),
                    rightParent: rightParentMaybe.value0
                }));
                if (expl instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$3301ca20023acaf7({
                    orn: $97ffb09cc3d11a32$export$9ed0694e8e982932(child)(expl.value0.leftParent)(rightParentMaybe.value0),
                    leftParent: expl.value0.leftParent,
                    rightParent: rightParentMaybe.value0
                }));
                if (expl instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$3301ca20023acaf7({
                    orn: $97ffb09cc3d11a32$export$9ed0694e8e982932(child)(expl.value0.leftParent)(rightParentMaybe.value0),
                    leftParent: expl.value0.leftParent,
                    rightParent: rightParentMaybe.value0
                }));
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }
            if (rightParentMaybe instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                if (expl instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$a2bc3c1c57b6e07(expl.value0));
                if (expl instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $97ffb09cc3d11a32$export$a2bc3c1c57b6e07({
                    orn: $97ffb09cc3d11a32$export$74fa6e5e3f891025(child)(expl.value0.leftParent),
                    leftParent: expl.value0.leftParent
                }));
                if (expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                return new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value);
            }
            throw new Error("Failed pattern match at ProtoVoices.Model (line 216, column 50 - line 239, column 21): " + [
                rightParentMaybe.constructor.name
            ]);
        };
    };
};
var $97ffb09cc3d11a32$export$2bc046a6c710c5ed = function(v) {
    if (v instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb) return [];
    if (v instanceof $97ffb09cc3d11a32$export$2cf876164813516f) return [];
    if (v instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return [
        v.value0
    ];
    if (v instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07) return [
        v.value0.leftParent
    ];
    if (v instanceof $97ffb09cc3d11a32$export$a420550a5202c987) return [
        v.value0.rightParent
    ];
    if (v instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) return [
        v.value0.leftParent,
        v.value0.rightParent
    ];
    throw new Error("Failed pattern match at ProtoVoices.Model (line 262, column 15 - line 268, column 72): " + [
        v.constructor.name
    ]);
};
var $97ffb09cc3d11a32$export$8ee52b0d5da145d3 = function(v) {
    if (v instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return false;
    return true;
};
var $97ffb09cc3d11a32$export$ad6ba54010aaff89 = function(v) {
    if (v instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb) return true;
    if (v instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return true;
    return false;
};
var $97ffb09cc3d11a32$export$af90f69b4c9ccc1a = function(id) {
    return function(v) {
        if (v instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb) return false;
        if (v instanceof $97ffb09cc3d11a32$export$2cf876164813516f) return false;
        if (v instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return v.value0.id === id;
        if (v instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07) return v.value0.leftParent.id === id;
        if (v instanceof $97ffb09cc3d11a32$export$a420550a5202c987) return v.value0.rightParent.id === id;
        if (v instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) return v.value0.leftParent.id === id || v.value0.rightParent.id === id;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 253, column 20 - line 259, column 88): " + [
            v.constructor.name
        ]);
    };
};
var $97ffb09cc3d11a32$export$1534e8493d5f481 = $37b880af5f4991bd$export$e65788c6d4494539;
var $97ffb09cc3d11a32$var$eq7 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$export$1534e8493d5f481);
var $97ffb09cc3d11a32$export$94c928892198f7f9 = function(dictEq) {
    var eq17 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                if (x instanceof $97ffb09cc3d11a32$export$568b89e600fc77eb && y instanceof $97ffb09cc3d11a32$export$568b89e600fc77eb) return true;
                if (x instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be && y instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return eq17(x.value0)(y.value0);
                if (x instanceof $97ffb09cc3d11a32$export$ac4156b3386a7c70 && y instanceof $97ffb09cc3d11a32$export$ac4156b3386a7c70) return true;
                return false;
            };
        }
    };
};
var $97ffb09cc3d11a32$var$eqStartStop1 = /* #__PURE__ */ $97ffb09cc3d11a32$export$94c928892198f7f9($97ffb09cc3d11a32$var$eqRec1);
var $97ffb09cc3d11a32$var$eqRec2 = /* #__PURE__ */ $97ffb09cc3d11a32$var$eqRec(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $97ffb09cc3d11a32$var$eqRowCons($97ffb09cc3d11a32$var$rightIsSymbol)($97ffb09cc3d11a32$var$eqStartStop1))()($97ffb09cc3d11a32$var$leftIsSymbol)($97ffb09cc3d11a32$var$eqStartStop1));
var $97ffb09cc3d11a32$var$eq8 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($97ffb09cc3d11a32$var$eqRec2));
var $97ffb09cc3d11a32$var$eq9 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $a393155e52307a24$export$15038a5bf6277d57($97ffb09cc3d11a32$var$eqRec2));
var $97ffb09cc3d11a32$export$51153a4951aa543e = function(dictOrd) {
    var compare2 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqStartStop2 = $97ffb09cc3d11a32$export$94c928892198f7f9(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                if (x instanceof $97ffb09cc3d11a32$export$568b89e600fc77eb && y instanceof $97ffb09cc3d11a32$export$568b89e600fc77eb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                if (x instanceof $97ffb09cc3d11a32$export$568b89e600fc77eb) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (y instanceof $97ffb09cc3d11a32$export$568b89e600fc77eb) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                if (x instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be && y instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return compare2(x.value0)(y.value0);
                if (x instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (y instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                if (x instanceof $97ffb09cc3d11a32$export$ac4156b3386a7c70 && y instanceof $97ffb09cc3d11a32$export$ac4156b3386a7c70) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                throw new Error("Failed pattern match at ProtoVoices.Model (line 0, column 0 - line 0, column 0): " + [
                    x.constructor.name,
                    y.constructor.name
                ]);
            };
        },
        Eq0: function() {
            return eqStartStop2;
        }
    };
};
var $97ffb09cc3d11a32$var$ordStartStop1 = /* #__PURE__ */ $97ffb09cc3d11a32$export$51153a4951aa543e(/* #__PURE__ */ $97ffb09cc3d11a32$var$ordRecord(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $97ffb09cc3d11a32$var$ordRecordCons($97ffb09cc3d11a32$var$pitchIsSymbol)($97ffb09cc3d11a32$var$ordPitch))()($97ffb09cc3d11a32$var$idIsSymbol)($97937c29f879e68e$export$c5f2758e49b2b86a)));
var $97ffb09cc3d11a32$var$ordRecord1 = /* #__PURE__ */ $97ffb09cc3d11a32$var$ordRecord(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $97ffb09cc3d11a32$var$ordRecordCons($97ffb09cc3d11a32$var$rightIsSymbol)($97ffb09cc3d11a32$var$ordStartStop1))()($97ffb09cc3d11a32$var$leftIsSymbol)($97ffb09cc3d11a32$var$ordStartStop1));
var $97ffb09cc3d11a32$var$catMaybes = /* #__PURE__ */ $a393155e52307a24$export$986c2bbe7a34be0b($97ffb09cc3d11a32$var$ordRecord1);
var $97ffb09cc3d11a32$var$map6 = /* #__PURE__ */ $a393155e52307a24$export$871de8747c9eaa88(/* #__PURE__ */ $06733ae99ed4f534$export$e35c29f98d259c46($97ffb09cc3d11a32$var$ordRecord1));
var $97ffb09cc3d11a32$var$fromFoldable1 = /* #__PURE__ */ $a393155e52307a24$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593)($97ffb09cc3d11a32$var$ordRecord1);
var $97ffb09cc3d11a32$var$monoidRecord = /* #__PURE__ */ $784e1bd3d26d71da$export$b6526a2ab5064058()(/* #__PURE__ */ $784e1bd3d26d71da$export$d672019c76a5af4a($97ffb09cc3d11a32$var$passingIsSymbol)($784e1bd3d26d71da$export$db307f59121ffcc4)()(/* #__PURE__ */ $784e1bd3d26d71da$export$d672019c76a5af4a($97ffb09cc3d11a32$var$regularIsSymbol)(/* #__PURE__ */ $a393155e52307a24$export$30c0d87180d1a2c7($97ffb09cc3d11a32$var$ordRecord1))()($784e1bd3d26d71da$export$254fca207e30c208)));
var $97ffb09cc3d11a32$var$insert4 = /* #__PURE__ */ $a393155e52307a24$export$21a5ca8aa77d35ff($97ffb09cc3d11a32$var$ordRecord1);
var $97ffb09cc3d11a32$var$append3 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d(/* #__PURE__ */ $d7bf9817a417d4ae$export$dbfe6b321632d7c9()(/* #__PURE__ */ $d7bf9817a417d4ae$export$74eae24c3d2a7535($97ffb09cc3d11a32$var$passingIsSymbol)()(/* #__PURE__ */ $d7bf9817a417d4ae$export$74eae24c3d2a7535($97ffb09cc3d11a32$var$regularIsSymbol)()($d7bf9817a417d4ae$export$955753116dc9242c)(/* #__PURE__ */ $a393155e52307a24$export$7c6a06df4f9b9fb3($97ffb09cc3d11a32$var$ordRecord1)))($d7bf9817a417d4ae$export$d082f07d0a8e9909)));
var $97ffb09cc3d11a32$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$e97014618a7eb593)($97ffb09cc3d11a32$var$monoidRecord);
var $97ffb09cc3d11a32$export$fb357a9288b70024 = function(edgesl) {
    return function(slicel) {
        var v = function(v1) {
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return edgesl;
            throw new Error("Failed pattern match at ProtoVoices.Model (line 777, column 1 - line 777, column 41): " + [
                edgesl.constructor.name,
                slicel.constructor.name
            ]);
        };
        if (slicel.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
            var replaceRight = function(v1) {
                var v2 = function(v3) {
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 777, column 1 - line 777, column 41): " + [
                        v1.constructor.name
                    ]);
                };
                if (v1.right instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
                    var $949 = $396c4c3d9e7fae3c$export$71aa6c912b956294(function(n) {
                        if (n.expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return n.expl.value0.id === v1.right.value0.id;
                        return false;
                    })(slicel.notes.value0);
                    if ($949 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        left: v1.left,
                        right: new $97ffb09cc3d11a32$export$f63ba74aa66682be($949.value0.note)
                    });
                    return v2(true);
                }
                return v2(true);
            };
            return {
                regular: $97ffb09cc3d11a32$var$catMaybes($97ffb09cc3d11a32$var$map6(replaceRight)(edgesl.regular)),
                passing: $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($97ffb09cc3d11a32$var$map(replaceRight)(edgesl.passing))
            };
        }
        return v(true);
    };
};
var $97ffb09cc3d11a32$export$2d73c5c06a3fd526 = function(slicer) {
    return function(edgesr) {
        var v = function(v1) {
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return edgesr;
            throw new Error("Failed pattern match at ProtoVoices.Model (line 798, column 1 - line 798, column 42): " + [
                slicer.constructor.name,
                edgesr.constructor.name
            ]);
        };
        if (slicer.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
            var replaceLeft = function(v1) {
                var v2 = function(v3) {
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 798, column 1 - line 798, column 42): " + [
                        v1.constructor.name
                    ]);
                };
                if (v1.left instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
                    var $967 = $396c4c3d9e7fae3c$export$71aa6c912b956294(function(n) {
                        if (n.expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return n.expl.value0.id === v1.left.value0.id;
                        return false;
                    })(slicer.notes.value0);
                    if ($967 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        left: new $97ffb09cc3d11a32$export$f63ba74aa66682be($967.value0.note),
                        right: v1.right
                    });
                    return v2(true);
                }
                return v2(true);
            };
            return {
                regular: $97ffb09cc3d11a32$var$catMaybes($97ffb09cc3d11a32$var$map6(replaceLeft)(edgesr.regular)),
                passing: $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($97ffb09cc3d11a32$var$map(replaceLeft)(edgesr.passing))
            };
        }
        return v(true);
    };
};
var $97ffb09cc3d11a32$export$f8c4778862b802eb = function(ties) {
    return function(id) {
        return function(slice) {
            return {
                id: id,
                is2nd: false,
                edges: {
                    regular: $97ffb09cc3d11a32$var$fromFoldable1(ties),
                    passing: []
                }
            };
        };
    };
};
var $97ffb09cc3d11a32$export$2f86c81c2b9ae87c = function(piece) {
    var thaw = function(st) {
        return function(v) {
            var seg = new $06733ae99ed4f534$export$8a67b48435b5d073({
                trans: $97ffb09cc3d11a32$export$f8c4778862b802eb(st.ties)(st.i)(v.notes),
                rslice: $97ffb09cc3d11a32$export$3bc6a27feb4afad9(v.notes)(st.i + 1 | 0),
                op: $97ffb09cc3d11a32$export$f0826af67a39ec5d.value
            });
            var mkTie = function(note) {
                if (note.hold instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                if (note.hold instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(note.note),
                    right: new $97ffb09cc3d11a32$export$f63ba74aa66682be({
                        pitch: note.note.pitch,
                        id: note.hold.value0
                    })
                });
                throw new Error("Failed pattern match at ProtoVoices.Model (line 624, column 18 - line 626, column 84): " + [
                    note.hold.constructor.name
                ]);
            };
            var tiesNext = $396c4c3d9e7fae3c$export$e70771d2e7e590a(mkTie)(v.notes);
            return {
                seg: seg,
                ties: tiesNext,
                i: st.i + 1 | 0
            };
        };
    };
    var init = {
        seg: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        ties: [],
        i: 0
    };
    var states = $97ffb09cc3d11a32$var$scanl(thaw)(init)(piece);
    var imax = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)(function(v) {
        return v.i;
    })($396c4c3d9e7fae3c$export$4c7897fafd92b108(states));
    var lastSeg = {
        trans: $97ffb09cc3d11a32$export$f8c4778862b802eb([])(imax)([]),
        rslice: {
            id: imax + 1 | 0,
            notes: $97ffb09cc3d11a32$export$ac4156b3386a7c70.value,
            x: $4ab74a20512cef04$export$a0a81dc3380ce7d3(imax + 1 | 0),
            parents: $97ffb09cc3d11a32$export$914e87441b58d7d9.value
        },
        op: $97ffb09cc3d11a32$export$f0826af67a39ec5d.value
    };
    var segs = $97ffb09cc3d11a32$var$append($396c4c3d9e7fae3c$export$986c2bbe7a34be0b($97ffb09cc3d11a32$var$map(function(v) {
        return v.seg;
    })(states)))([
        lastSeg
    ]);
    return {
        start: $97ffb09cc3d11a32$export$a9798ceb1fbb5dee,
        segments: $97ffb09cc3d11a32$var$fromFoldable(segs),
        nextSliceId: imax + 2 | 0,
        nextTransId: imax + 1 | 0
    };
};
var $97ffb09cc3d11a32$export$17c4d6d9c222c6dd = function(edges) {
    return function(slice) {
        var v = function(v1) {
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("The current reduction is invalid: Trying to vert a Start or Stop slice.");
            throw new Error("Failed pattern match at ProtoVoices.Model (line 741, column 1 - line 741, column 55): " + [
                edges.constructor.name,
                slice.constructor.name
            ]);
        };
        if (slice.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
            var replaceRight = function(v1) {
                var v2 = function(v3) {
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 741, column 1 - line 741, column 55): " + [
                        v1.constructor.name
                    ]);
                };
                if (v1.right instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
                    var $988 = $396c4c3d9e7fae3c$export$71aa6c912b956294(function(n) {
                        return n.note.id === v1.right.value0.id;
                    })(slice.notes.value0);
                    if ($988 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        if ($988.value0.expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                            left: v1.left,
                            right: new $97ffb09cc3d11a32$export$f63ba74aa66682be($988.value0.expl.value0)
                        });
                        return v2(true);
                    }
                    return v2(true);
                }
                return v2(true);
            };
            return new $7d4cccdf062a2261$export$19db0165690c701a({
                regular: $97ffb09cc3d11a32$var$catMaybes($97ffb09cc3d11a32$var$map6(replaceRight)(edges.regular)),
                passing: $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($97ffb09cc3d11a32$var$map(replaceRight)(edges.passing))
            });
        }
        return v(true);
    };
};
var $97ffb09cc3d11a32$export$a1caa2c4f72b5f4f = function(edges) {
    return function(slice) {
        var v = function(v1) {
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("The current reduction is invalid: Trying to vert a Start or Stop slice.");
            throw new Error("Failed pattern match at ProtoVoices.Model (line 759, column 1 - line 759, column 56): " + [
                edges.constructor.name,
                slice.constructor.name
            ]);
        };
        if (slice.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
            var replaceLeft = function(v1) {
                var v2 = function(v3) {
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 759, column 1 - line 759, column 56): " + [
                        v1.constructor.name
                    ]);
                };
                if (v1.left instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
                    var $1006 = $396c4c3d9e7fae3c$export$71aa6c912b956294(function(n) {
                        return n.note.id === v1.left.value0.id;
                    })(slice.notes.value0);
                    if ($1006 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        if ($1006.value0.expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                            left: new $97ffb09cc3d11a32$export$f63ba74aa66682be($1006.value0.expl.value0),
                            right: v1.right
                        });
                        return v2(true);
                    }
                    return v2(true);
                }
                return v2(true);
            };
            return new $7d4cccdf062a2261$export$19db0165690c701a({
                regular: $97ffb09cc3d11a32$var$catMaybes($97ffb09cc3d11a32$var$map6(replaceLeft)(edges.regular)),
                passing: $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($97ffb09cc3d11a32$var$map(replaceLeft)(edges.passing))
            });
        }
        return v(true);
    };
};
var $97ffb09cc3d11a32$export$6142f43eeaf47d03 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $97ffb09cc3d11a32$export$22537d7be8fe89a9 && y instanceof $97ffb09cc3d11a32$export$22537d7be8fe89a9) return true;
            if (x instanceof $97ffb09cc3d11a32$export$657222a21023cba0 && y instanceof $97ffb09cc3d11a32$export$657222a21023cba0) return true;
            if (x instanceof $97ffb09cc3d11a32$export$725d191431df39a2 && y instanceof $97ffb09cc3d11a32$export$725d191431df39a2) return true;
            return false;
        };
    }
};
var $97ffb09cc3d11a32$export$2c3209330e3b8c0b = $37b880af5f4991bd$export$e65788c6d4494539;
var $97ffb09cc3d11a32$var$eq10 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$export$2c3209330e3b8c0b);
var $97ffb09cc3d11a32$export$2ab3c27e935b9abc = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $97ffb09cc3d11a32$export$ef0b5f914041d38a && y instanceof $97ffb09cc3d11a32$export$ef0b5f914041d38a) return true;
            if (x instanceof $97ffb09cc3d11a32$export$fd951dac679282e1 && y instanceof $97ffb09cc3d11a32$export$fd951dac679282e1) return true;
            return false;
        };
    }
};
var $97ffb09cc3d11a32$var$eq11 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($97ffb09cc3d11a32$export$2ab3c27e935b9abc));
var $97ffb09cc3d11a32$export$de2782e6841c34a5 = function(dictEq) {
    var eq17 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                if (x instanceof $97ffb09cc3d11a32$export$914e87441b58d7d9 && y instanceof $97ffb09cc3d11a32$export$914e87441b58d7d9) return true;
                if (x instanceof $97ffb09cc3d11a32$export$a94683cf162a309e && y instanceof $97ffb09cc3d11a32$export$a94683cf162a309e) return eq17(x.value0)(y.value0);
                if (x instanceof $97ffb09cc3d11a32$export$a56b005ab5275675 && y instanceof $97ffb09cc3d11a32$export$a56b005ab5275675) return eq17(x.value0.left)(y.value0.left) && eq17(x.value0.right)(y.value0.right);
                return false;
            };
        }
    };
};
var $97ffb09cc3d11a32$var$eq12 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $97ffb09cc3d11a32$export$de2782e6841c34a5($97ffb09cc3d11a32$export$2c3209330e3b8c0b));
var $97ffb09cc3d11a32$export$df3df4ffb2baeed3 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $97ffb09cc3d11a32$export$e32a75e677fca455 && y instanceof $97ffb09cc3d11a32$export$e32a75e677fca455) return true;
            if (x instanceof $97ffb09cc3d11a32$export$7bb038d575dcf9c9 && y instanceof $97ffb09cc3d11a32$export$7bb038d575dcf9c9) return true;
            return false;
        };
    }
};
var $97ffb09cc3d11a32$var$eq13 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($97ffb09cc3d11a32$export$df3df4ffb2baeed3));
var $97ffb09cc3d11a32$export$b7b46b55fac1096f = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $97ffb09cc3d11a32$export$9ac4ca89af1eab6b && y instanceof $97ffb09cc3d11a32$export$9ac4ca89af1eab6b) return true;
            if (x instanceof $97ffb09cc3d11a32$export$12a73def75ba91a && y instanceof $97ffb09cc3d11a32$export$12a73def75ba91a) return true;
            if (x instanceof $97ffb09cc3d11a32$export$c33024bcf57ad853 && y instanceof $97ffb09cc3d11a32$export$c33024bcf57ad853) return true;
            if (x instanceof $97ffb09cc3d11a32$export$ad2c4a230ed49713 && y instanceof $97ffb09cc3d11a32$export$ad2c4a230ed49713) return true;
            if (x instanceof $97ffb09cc3d11a32$export$b62f635e41790a80 && y instanceof $97ffb09cc3d11a32$export$b62f635e41790a80) return true;
            if (x instanceof $97ffb09cc3d11a32$export$dab08a4db0f3867f && y instanceof $97ffb09cc3d11a32$export$dab08a4db0f3867f) return true;
            if (x instanceof $97ffb09cc3d11a32$export$9cce9eb8c466c42b && y instanceof $97ffb09cc3d11a32$export$9cce9eb8c466c42b) return true;
            return false;
        };
    }
};
var $97ffb09cc3d11a32$var$eq14 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($97ffb09cc3d11a32$export$b7b46b55fac1096f));
var $97ffb09cc3d11a32$export$d751c43805353ae1 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb && y instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb) return true;
            if (x instanceof $97ffb09cc3d11a32$export$2cf876164813516f && y instanceof $97ffb09cc3d11a32$export$2cf876164813516f) return true;
            if (x instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51 && y instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return x.value0.id === y.value0.id && $97ffb09cc3d11a32$var$eq4(x.value0.pitch)(y.value0.pitch);
            if (x instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07 && y instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07) return x.value0.leftParent.id === y.value0.leftParent.id && $97ffb09cc3d11a32$var$eq4(x.value0.leftParent.pitch)(y.value0.leftParent.pitch) && $97ffb09cc3d11a32$var$eq11(x.value0.orn)(y.value0.orn);
            if (x instanceof $97ffb09cc3d11a32$export$a420550a5202c987 && y instanceof $97ffb09cc3d11a32$export$a420550a5202c987) return $97ffb09cc3d11a32$var$eq13(x.value0.orn)(y.value0.orn) && x.value0.rightParent.id === y.value0.rightParent.id && $97ffb09cc3d11a32$var$eq4(x.value0.rightParent.pitch)(y.value0.rightParent.pitch);
            if (x instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7 && y instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) return x.value0.leftParent.id === y.value0.leftParent.id && $97ffb09cc3d11a32$var$eq4(x.value0.leftParent.pitch)(y.value0.leftParent.pitch) && $97ffb09cc3d11a32$var$eq14(x.value0.orn)(y.value0.orn) && x.value0.rightParent.id === y.value0.rightParent.id && $97ffb09cc3d11a32$var$eq4(x.value0.rightParent.pitch)(y.value0.rightParent.pitch);
            return false;
        };
    }
};
var $97ffb09cc3d11a32$var$eq15 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $97ffb09cc3d11a32$export$94c928892198f7f9(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00(/* #__PURE__ */ $97ffb09cc3d11a32$var$eqRec(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $97ffb09cc3d11a32$var$eqRowCons($97ffb09cc3d11a32$var$noteIsSymbol)($97ffb09cc3d11a32$var$eqRec1))()($97ffb09cc3d11a32$var$explIsSymbol)($97ffb09cc3d11a32$export$d751c43805353ae1)))));
var $97ffb09cc3d11a32$export$4b008a47cd173cea = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d && y instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return true;
            if (x instanceof $97ffb09cc3d11a32$export$f836382419f64c98 && y instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$export$4b008a47cd173cea)(x.value0.childl.op)(y.value0.childl.op) && $97ffb09cc3d11a32$var$eq10(x.value0.childl.rslice.id)(y.value0.childl.rslice.id) && $97ffb09cc3d11a32$var$eq15(x.value0.childl.rslice.notes)(y.value0.childl.rslice.notes) && $97ffb09cc3d11a32$var$eq12(x.value0.childl.rslice.parents)(y.value0.childl.rslice.parents) && x.value0.childl.rslice.x === y.value0.childl.rslice.x && $97ffb09cc3d11a32$var$eq8(x.value0.childl.trans.edges.passing)(y.value0.childl.trans.edges.passing) && $97ffb09cc3d11a32$var$eq9(x.value0.childl.trans.edges.regular)(y.value0.childl.trans.edges.regular) && $97ffb09cc3d11a32$var$eq7(x.value0.childl.trans.id)(y.value0.childl.trans.id) && x.value0.childl.trans.is2nd === y.value0.childl.trans.is2nd && $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$export$4b008a47cd173cea)(x.value0.childr.op)(y.value0.childr.op) && $97ffb09cc3d11a32$var$eq8(x.value0.childr.trans.edges.passing)(y.value0.childr.trans.edges.passing) && $97ffb09cc3d11a32$var$eq9(x.value0.childr.trans.edges.regular)(y.value0.childr.trans.edges.regular) && $97ffb09cc3d11a32$var$eq7(x.value0.childr.trans.id)(y.value0.childr.trans.id) && x.value0.childr.trans.is2nd === y.value0.childr.trans.is2nd;
            if (x instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656 && y instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) return $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$export$4b008a47cd173cea)(x.value0.childl.op)(y.value0.childl.op) && $97ffb09cc3d11a32$var$eq10(x.value0.childl.rslice.id)(y.value0.childl.rslice.id) && $97ffb09cc3d11a32$var$eq15(x.value0.childl.rslice.notes)(y.value0.childl.rslice.notes) && $97ffb09cc3d11a32$var$eq12(x.value0.childl.rslice.parents)(y.value0.childl.rslice.parents) && x.value0.childl.rslice.x === y.value0.childl.rslice.x && $97ffb09cc3d11a32$var$eq8(x.value0.childl.trans.edges.passing)(y.value0.childl.trans.edges.passing) && $97ffb09cc3d11a32$var$eq9(x.value0.childl.trans.edges.regular)(y.value0.childl.trans.edges.regular) && $97ffb09cc3d11a32$var$eq7(x.value0.childl.trans.id)(y.value0.childl.trans.id) && x.value0.childl.trans.is2nd === y.value0.childl.trans.is2nd && $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$export$4b008a47cd173cea)(x.value0.childm.op)(y.value0.childm.op) && $97ffb09cc3d11a32$var$eq10(x.value0.childm.rslice.id)(y.value0.childm.rslice.id) && $97ffb09cc3d11a32$var$eq15(x.value0.childm.rslice.notes)(y.value0.childm.rslice.notes) && $97ffb09cc3d11a32$var$eq12(x.value0.childm.rslice.parents)(y.value0.childm.rslice.parents) && x.value0.childm.rslice.x === y.value0.childm.rslice.x && $97ffb09cc3d11a32$var$eq8(x.value0.childm.trans.edges.passing)(y.value0.childm.trans.edges.passing) && $97ffb09cc3d11a32$var$eq9(x.value0.childm.trans.edges.regular)(y.value0.childm.trans.edges.regular) && $97ffb09cc3d11a32$var$eq7(x.value0.childm.trans.id)(y.value0.childm.trans.id) && x.value0.childm.trans.is2nd === y.value0.childm.trans.is2nd && $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$export$4b008a47cd173cea)(x.value0.childr.op)(y.value0.childr.op) && $97ffb09cc3d11a32$var$eq8(x.value0.childr.trans.edges.passing)(y.value0.childr.trans.edges.passing) && $97ffb09cc3d11a32$var$eq9(x.value0.childr.trans.edges.regular)(y.value0.childr.trans.edges.regular) && $97ffb09cc3d11a32$var$eq7(x.value0.childr.trans.id)(y.value0.childr.trans.id) && x.value0.childr.trans.is2nd === y.value0.childr.trans.is2nd;
            return false;
        };
    }
};
var $97ffb09cc3d11a32$var$eq16 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$export$4b008a47cd173cea);
var $97ffb09cc3d11a32$export$b3c4a65469f32a4d = function(p) {
    return function(seg) {
        var findUniqueVertExpl = function(parentSlice) {
            return function(child) {
                var v = $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(pnote) {
                    return $97ffb09cc3d11a32$var$eq4(pnote.note.pitch)(child.note.pitch);
                })($97ffb09cc3d11a32$export$a45279548abf4fad(parentSlice));
                if (v.length === 1) return {
                    note: child.note,
                    expl: new $97ffb09cc3d11a32$export$ae59325e7e640c51(v[0].note)
                };
                return child;
            };
        };
        var findUniqueMergeExpl = function(leftSlice) {
            return function(rightSlice) {
                return function(child) {
                    var v = function(v1) {
                        var v2 = function(v3) {
                            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return child;
                            throw new Error("Failed pattern match at ProtoVoices.Model (line 681, column 1 - line 681, column 50): " + [
                                leftSlice.constructor.name,
                                rightSlice.constructor.name,
                                child.constructor.name
                            ]);
                        };
                        if (leftSlice.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
                            if (rightSlice.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
                                var rightExpls = $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($97ffb09cc3d11a32$var$bind1(leftSlice.notes.value0)(function(v3) {
                                    return $97ffb09cc3d11a32$var$pure1($97ffb09cc3d11a32$var$bind2($97ffb09cc3d11a32$export$74fa6e5e3f891025(child.note.pitch)(v3.note))(function(orn) {
                                        return $97ffb09cc3d11a32$var$pure2(new $97ffb09cc3d11a32$export$a2bc3c1c57b6e07({
                                            orn: new $06733ae99ed4f534$export$8a67b48435b5d073(orn),
                                            leftParent: v3.note
                                        }));
                                    }));
                                }));
                                var leftExpls = $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($97ffb09cc3d11a32$var$bind1(rightSlice.notes.value0)(function(v3) {
                                    return $97ffb09cc3d11a32$var$pure1($97ffb09cc3d11a32$var$bind2($97ffb09cc3d11a32$export$7131272324e67074(child.note.pitch)(v3.note))(function(orn) {
                                        return $97ffb09cc3d11a32$var$pure2(new $97ffb09cc3d11a32$export$a420550a5202c987({
                                            orn: new $06733ae99ed4f534$export$8a67b48435b5d073(orn),
                                            rightParent: v3.note
                                        }));
                                    }));
                                }));
                                var doubleExpls = $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($97ffb09cc3d11a32$var$bind1(leftSlice.notes.value0)(function(v3) {
                                    return $97ffb09cc3d11a32$var$bind1(rightSlice.notes.value0)(function(v4) {
                                        return $97ffb09cc3d11a32$var$pure1($97ffb09cc3d11a32$var$bind2($97ffb09cc3d11a32$export$9ed0694e8e982932(child.note.pitch)(v3.note)(v4.note))(function(orn) {
                                            return $97ffb09cc3d11a32$var$pure2(new $97ffb09cc3d11a32$export$3301ca20023acaf7({
                                                orn: new $06733ae99ed4f534$export$8a67b48435b5d073(orn),
                                                leftParent: v3.note,
                                                rightParent: v4.note
                                            }));
                                        }));
                                    });
                                }));
                                if (doubleExpls.length === 1) return {
                                    note: child.note,
                                    expl: doubleExpls[0]
                                };
                                var v3 = $97ffb09cc3d11a32$var$append(leftExpls)(rightExpls);
                                if (v3.length === 1) return {
                                    note: child.note,
                                    expl: v3[0]
                                };
                                return child;
                            }
                            return v2(true);
                        }
                        return v2(true);
                    };
                    var $1071 = $97ffb09cc3d11a32$var$eq15(leftSlice.notes)($97ffb09cc3d11a32$export$568b89e600fc77eb.value);
                    if ($1071) {
                        var $1072 = $97ffb09cc3d11a32$var$eq15(rightSlice.notes)($97ffb09cc3d11a32$export$ac4156b3386a7c70.value);
                        if ($1072) return {
                            note: child.note,
                            expl: $97ffb09cc3d11a32$export$2cf876164813516f.value
                        };
                        return v(true);
                    }
                    return v(true);
                };
            };
        };
        if (p instanceof $97ffb09cc3d11a32$export$914e87441b58d7d9) return {
            trans: seg.trans,
            op: seg.op,
            rslice: {
                id: seg.rslice.id,
                notes: seg.rslice.notes,
                x: seg.rslice.x,
                parents: $97ffb09cc3d11a32$export$914e87441b58d7d9.value
            }
        };
        if (p instanceof $97ffb09cc3d11a32$export$a94683cf162a309e) return {
            trans: seg.trans,
            op: seg.op,
            rslice: {
                id: seg.rslice.id,
                x: seg.rslice.x,
                parents: new $97ffb09cc3d11a32$export$a94683cf162a309e(p.value0.id),
                notes: $97ffb09cc3d11a32$var$map5($97ffb09cc3d11a32$var$map(findUniqueVertExpl(p.value0)))(seg.rslice.notes)
            }
        };
        if (p instanceof $97ffb09cc3d11a32$export$a56b005ab5275675) return {
            trans: seg.trans,
            op: seg.op,
            rslice: {
                id: seg.rslice.id,
                x: seg.rslice.x,
                parents: new $97ffb09cc3d11a32$export$a56b005ab5275675({
                    left: p.value0.left.id,
                    right: p.value0.right.id
                }),
                notes: $97ffb09cc3d11a32$var$map5($97ffb09cc3d11a32$var$map(findUniqueMergeExpl(p.value0.left)(p.value0.right)))(seg.rslice.notes)
            }
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 682, column 20 - line 697, column 8): " + [
            p.constructor.name
        ]);
    };
};
var $97ffb09cc3d11a32$export$7e7e15c038f60dc5 = {
    classes: "",
    label: ""
};
var $97ffb09cc3d11a32$export$7e47ebea1ddf45a0 = function(classes) {
    return function(styleMaybe) {
        var style = $06733ae99ed4f534$export$43db023a260c5e9f($97ffb09cc3d11a32$export$7e7e15c038f60dc5)(styleMaybe);
        var $1078 = $22d4f8ab6946d33a$export$7b1b591b262c240(classes) && $22d4f8ab6946d33a$export$7b1b591b262c240(style.label);
        if ($1078) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return new $06733ae99ed4f534$export$8a67b48435b5d073({
            label: style.label,
            classes: classes
        });
    };
};
var $97ffb09cc3d11a32$export$7bf64051311b7a29 = function(label) {
    return function(styleMaybe) {
        var style = $06733ae99ed4f534$export$43db023a260c5e9f($97ffb09cc3d11a32$export$7e7e15c038f60dc5)(styleMaybe);
        var $1079 = $22d4f8ab6946d33a$export$7b1b591b262c240(label) && $22d4f8ab6946d33a$export$7b1b591b262c240(style.classes);
        if ($1079) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return new $06733ae99ed4f534$export$8a67b48435b5d073({
            classes: style.classes,
            label: label
        });
    };
};
var $97ffb09cc3d11a32$export$9600be31624de2dc = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($97ffb09cc3d11a32$var$monoidRecord);
var $97ffb09cc3d11a32$export$5b02897202256443 = function(id) {
    return function(is2nd) {
        return {
            id: id,
            is2nd: is2nd,
            edges: $97ffb09cc3d11a32$export$9600be31624de2dc
        };
    };
};
var $97ffb09cc3d11a32$export$ae35b1fbec78c70a = function(v) {
    var edge = function(l) {
        return $a393155e52307a24$export$439306a4dcaafbb9({
            left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(l),
            right: new $97ffb09cc3d11a32$export$f63ba74aa66682be(v.note)
        });
    };
    if (v.expl instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) {
        if (v.expl.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.expl.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$9cce9eb8c466c42b) return {
            regular: $97ffb09cc3d11a32$export$9600be31624de2dc.regular,
            passing: [
                {
                    left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(v.expl.value0.leftParent),
                    right: new $97ffb09cc3d11a32$export$f63ba74aa66682be(v.note)
                }
            ]
        };
        return {
            passing: $97ffb09cc3d11a32$export$9600be31624de2dc.passing,
            regular: edge(v.expl.value0.leftParent)
        };
    }
    if (v.expl instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07) return {
        passing: $97ffb09cc3d11a32$export$9600be31624de2dc.passing,
        regular: edge(v.expl.value0.leftParent)
    };
    if (v.expl instanceof $97ffb09cc3d11a32$export$2cf876164813516f) return {
        passing: $97ffb09cc3d11a32$export$9600be31624de2dc.passing,
        regular: $a393155e52307a24$export$439306a4dcaafbb9({
            left: $97ffb09cc3d11a32$export$568b89e600fc77eb.value,
            right: new $97ffb09cc3d11a32$export$f63ba74aa66682be(v.note)
        })
    };
    return $97ffb09cc3d11a32$export$9600be31624de2dc;
};
var $97ffb09cc3d11a32$export$58a9845a7ab015a = function(v) {
    if (v instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) {
        var parentEdge = {
            left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(v.value0.leftParent),
            right: new $97ffb09cc3d11a32$export$f63ba74aa66682be(v.value0.rightParent)
        };
        if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$b62f635e41790a80) return {
            regular: $97ffb09cc3d11a32$export$9600be31624de2dc.regular,
            passing: [
                parentEdge
            ]
        };
        if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$dab08a4db0f3867f) return {
            regular: $97ffb09cc3d11a32$export$9600be31624de2dc.regular,
            passing: [
                parentEdge
            ]
        };
        if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$9cce9eb8c466c42b) return {
            regular: $97ffb09cc3d11a32$export$9600be31624de2dc.regular,
            passing: [
                parentEdge
            ]
        };
        return {
            passing: $97ffb09cc3d11a32$export$9600be31624de2dc.passing,
            regular: $a393155e52307a24$export$439306a4dcaafbb9(parentEdge)
        };
    }
    if (v instanceof $97ffb09cc3d11a32$export$2cf876164813516f) return {
        passing: $97ffb09cc3d11a32$export$9600be31624de2dc.passing,
        regular: $a393155e52307a24$export$439306a4dcaafbb9({
            left: $97ffb09cc3d11a32$export$568b89e600fc77eb.value,
            right: $97ffb09cc3d11a32$export$ac4156b3386a7c70.value
        })
    };
    return $97ffb09cc3d11a32$export$9600be31624de2dc;
};
var $97ffb09cc3d11a32$export$dcfdd3e125058bb4 = function(v) {
    var edge = function(r) {
        return $a393155e52307a24$export$439306a4dcaafbb9({
            left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(v.note),
            right: new $97ffb09cc3d11a32$export$f63ba74aa66682be(r)
        });
    };
    if (v.expl instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) {
        if (v.expl.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.expl.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$dab08a4db0f3867f) return {
            regular: $97ffb09cc3d11a32$export$9600be31624de2dc.regular,
            passing: [
                {
                    left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(v.note),
                    right: new $97ffb09cc3d11a32$export$f63ba74aa66682be(v.expl.value0.rightParent)
                }
            ]
        };
        return {
            passing: $97ffb09cc3d11a32$export$9600be31624de2dc.passing,
            regular: edge(v.expl.value0.rightParent)
        };
    }
    if (v.expl instanceof $97ffb09cc3d11a32$export$a420550a5202c987) return {
        passing: $97ffb09cc3d11a32$export$9600be31624de2dc.passing,
        regular: edge(v.expl.value0.rightParent)
    };
    if (v.expl instanceof $97ffb09cc3d11a32$export$2cf876164813516f) return {
        passing: $97ffb09cc3d11a32$export$9600be31624de2dc.passing,
        regular: $a393155e52307a24$export$439306a4dcaafbb9({
            left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(v.note),
            right: $97ffb09cc3d11a32$export$ac4156b3386a7c70.value
        })
    };
    return $97ffb09cc3d11a32$export$9600be31624de2dc;
};
var $97ffb09cc3d11a32$export$60f9aa56b538dc84 = function(slicel) {
    return function(edges) {
        return function(slicer) {
            var toLeft = $97ffb09cc3d11a32$var$foldl(function(acc) {
                return function(left) {
                    if (left.expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return $97ffb09cc3d11a32$var$insert(left.expl.value0.id)(left.note)(acc);
                    return acc;
                };
            })($ea3eb84de0acf574$export$6e22c362a0406a2c)($97ffb09cc3d11a32$export$a45279548abf4fad(slicel));
            var toBoth = $97ffb09cc3d11a32$var$foldl(function(acc) {
                return function(right) {
                    if (right.expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) {
                        var v = $97ffb09cc3d11a32$var$lookup(right.expl.value0.id)(toLeft);
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $97ffb09cc3d11a32$var$insert4({
                            left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(v.value0),
                            right: new $97ffb09cc3d11a32$export$f63ba74aa66682be(right.note)
                        })(acc);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return acc;
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 833, column 30 - line 835, column 27): " + [
                            v.constructor.name
                        ]);
                    }
                    return acc;
                };
            })($a393155e52307a24$export$6e22c362a0406a2c)($97ffb09cc3d11a32$export$a45279548abf4fad(slicer));
            return $97ffb09cc3d11a32$var$append3(edges)({
                passing: $97ffb09cc3d11a32$export$9600be31624de2dc.passing,
                regular: toBoth
            });
        };
    };
};
var $97ffb09cc3d11a32$export$c70a271fb26a581d = function(v) {
    if (v.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return $97ffb09cc3d11a32$var$foldMap($97ffb09cc3d11a32$export$58a9845a7ab015a)($97ffb09cc3d11a32$var$map(function(v1) {
        return v1.expl;
    })(v.notes.value0));
    return $97ffb09cc3d11a32$export$9600be31624de2dc;
};
var $97ffb09cc3d11a32$export$a14eba21f8f99294 = function(noteId) {
    return function(expl) {
        return function(model) {
            var setNoteExplInSlice = function(slice) {
                return {
                    id: slice.id,
                    x: slice.x,
                    parents: slice.parents,
                    notes: $97ffb09cc3d11a32$var$map5($97ffb09cc3d11a32$var$map(function(n) {
                        var $1120 = n.note.id === noteId;
                        if ($1120) return {
                            note: n.note,
                            expl: expl
                        };
                        return n;
                    }))(slice.notes)
                };
            };
            var noteInSlice = function(slice) {
                return $396c4c3d9e7fae3c$export$4154a199d7d90455(function(n) {
                    return n.note.id === noteId;
                })($97ffb09cc3d11a32$export$a45279548abf4fad(slice));
            };
            var doSegment$prime = function(upFromLeft) {
                return function(seg) {
                    if (seg.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) {
                        if (upFromLeft instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$19db0165690c701a({
                            "seg'": seg,
                            rUp: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
                        });
                        if (upFromLeft instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $7d4cccdf062a2261$export$19db0165690c701a({
                            "seg'": function() {
                                var $1123 = {};
                                for(var $1124 in seg)if (({}).hasOwnProperty.call(seg, $1124)) $1123[$1124] = seg[$1124];
                                $1123.trans = {
                                    id: seg.trans.id,
                                    is2nd: seg.trans.is2nd,
                                    edges: upFromLeft.value0
                                };
                                return $1123;
                            }(),
                            rUp: upFromLeft.value1
                        });
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1286, column 15 - line 1288, column 86): " + [
                            upFromLeft.constructor.name
                        ]);
                    }
                    if (seg.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return $97ffb09cc3d11a32$var$bind3(doSegment(upFromLeft)(seg.op.value0.childl))(function(v) {
                        return $97ffb09cc3d11a32$var$bind3(doSegment$prime(v.rUp)(seg.op.value0.childr))(function(v1) {
                            var segNewOp = function() {
                                var $1130 = {};
                                for(var $1131 in seg)if (({}).hasOwnProperty.call(seg, $1131)) $1130[$1131] = seg[$1131];
                                $1130.op = new $97ffb09cc3d11a32$export$f836382419f64c98({
                                    childl: v["seg'"],
                                    childr: v1["seg'"]
                                });
                                return $1130;
                            }();
                            return $97ffb09cc3d11a32$var$bind3(function() {
                                var $1133 = noteInSlice(seg.op.value0.childl.rslice);
                                if ($1133) {
                                    var $1134 = $97ffb09cc3d11a32$export$8ee52b0d5da145d3(expl);
                                    if ($1134) return $97ffb09cc3d11a32$var$pure3(function() {
                                        var $1135 = {};
                                        for(var $1136 in segNewOp)if (({}).hasOwnProperty.call(segNewOp, $1136)) $1135[$1136] = segNewOp[$1136];
                                        $1135.trans = {
                                            id: segNewOp.trans.id,
                                            is2nd: segNewOp.trans.is2nd,
                                            edges: $97ffb09cc3d11a32$export$c70a271fb26a581d(v["seg'"].rslice)
                                        };
                                        return $1135;
                                    }());
                                    return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Cannot explain a split note with a hori.");
                                }
                                return $97ffb09cc3d11a32$var$pure3(segNewOp);
                            }())(function(seg$prime) {
                                return $97ffb09cc3d11a32$var$pure3({
                                    "seg'": seg$prime,
                                    rUp: v1.rUp
                                });
                            });
                        });
                    });
                    if (seg.op instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) return $97ffb09cc3d11a32$var$bind3(doSegment(upFromLeft)(seg.op.value0.childl))(function(v) {
                        return $97ffb09cc3d11a32$var$bind3(doSegment(v.rUp)(seg.op.value0.childm))(function(v1) {
                            return $97ffb09cc3d11a32$var$bind3(doSegment$prime(v1.rUp)(seg.op.value0.childr))(function(v2) {
                                return $97ffb09cc3d11a32$var$bind3($97ffb09cc3d11a32$export$17c4d6d9c222c6dd(v["seg'"].trans.edges)(v["seg'"].rslice))(function(leftParentEdges) {
                                    return $97ffb09cc3d11a32$var$bind3($97ffb09cc3d11a32$export$a1caa2c4f72b5f4f(v2["seg'"].trans.edges)(v1["seg'"].rslice))(function(rightParentEdges) {
                                        return $97ffb09cc3d11a32$var$discard2(function() {
                                            var $1148 = (noteInSlice(seg.op.value0.childl.rslice) || noteInSlice(seg.op.value0.childm.rslice)) && !$97ffb09cc3d11a32$export$ad6ba54010aaff89(expl);
                                            if ($1148) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Cannot explain a hori note with a split. noteId = " + ($97ffb09cc3d11a32$var$show1(noteId) + (", childl.rslice = " + ($97ffb09cc3d11a32$var$show6(seg.op.value0.childl.rslice) + (", childm.rslice = " + $97ffb09cc3d11a32$var$show6(seg.op.value0.childm.rslice))))));
                                            return $97ffb09cc3d11a32$var$pure3($05149ea687d6b460$export$523c0b569236b342);
                                        }())(function() {
                                            return $97ffb09cc3d11a32$var$pure3({
                                                "seg'": function() {
                                                    var $1149 = {};
                                                    for(var $1150 in seg)if (({}).hasOwnProperty.call(seg, $1150)) $1149[$1150] = seg[$1150];
                                                    $1149.op = new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                                        childl: v["seg'"],
                                                        childm: v1["seg'"],
                                                        childr: v2["seg'"]
                                                    });
                                                    $1149.trans = {
                                                        id: seg.trans.id,
                                                        is2nd: seg.trans.is2nd,
                                                        edges: leftParentEdges
                                                    };
                                                    return $1149;
                                                }(),
                                                rUp: new $78c799cba34fcb8d$export$74c44e616647f5c0(rightParentEdges, v2.rUp)
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1285, column 31 - line 1327, column 12): " + [
                        seg.op.constructor.name
                    ]);
                };
            };
            var doSegment = function(upFromLeft) {
                return function(seg) {
                    var rslice$prime = function() {
                        var $1162 = noteInSlice(seg.rslice);
                        if ($1162) return setNoteExplInSlice(seg.rslice);
                        return seg.rslice;
                    }();
                    return $97ffb09cc3d11a32$var$map3(function(v) {
                        return {
                            rUp: v.rUp,
                            "seg'": {
                                op: v["seg'"].op,
                                trans: v["seg'"].trans,
                                rslice: rslice$prime
                            }
                        };
                    })(doSegment$prime(upFromLeft)(seg));
                };
            };
            var traverseTop = function(upFromLeft) {
                return function(v) {
                    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$19db0165690c701a($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $97ffb09cc3d11a32$var$bind3(doSegment(upFromLeft)(v.value0))(function(v1) {
                        return $97ffb09cc3d11a32$var$bind3(traverseTop(v1.rUp)(v.value1))(function(rest$prime) {
                            return $97ffb09cc3d11a32$var$pure3(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1["seg'"], rest$prime));
                        });
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1272, column 28 - line 1277, column 29): " + [
                        v.constructor.name
                    ]);
                };
            };
            var v = traverseTop($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(model.reduction.segments);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a({
                piece: model.piece,
                styles: model.styles,
                reduction: {
                    nextSliceId: model.reduction.nextSliceId,
                    nextTransId: model.reduction.nextTransId,
                    start: model.reduction.start,
                    segments: v.value0
                }
            });
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
            throw new Error("Failed pattern match at ProtoVoices.Model (line 1261, column 40 - line 1263, column 23): " + [
                v.constructor.name
            ]);
        };
    };
};
var $97ffb09cc3d11a32$export$6934745986661450 = function(edge) {
    return {
        regular: $97ffb09cc3d11a32$export$9600be31624de2dc.regular,
        passing: [
            edge
        ]
    };
};
var $97ffb09cc3d11a32$export$3c0cda0053a84b48 = function(edge) {
    return {
        passing: $97ffb09cc3d11a32$export$9600be31624de2dc.passing,
        regular: $a393155e52307a24$export$439306a4dcaafbb9(edge)
    };
};
var $97ffb09cc3d11a32$export$b937cda2bd5d31ec = function(v) {
    var getId = function(v1) {
        if (v1 instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return v1.value0.id;
        return $97ffb09cc3d11a32$var$show4(v1);
    };
    return new $71f2e2e9476163f8$export$1908877435b1d5e9(getId(v.left), getId(v.right));
};
var $97ffb09cc3d11a32$export$c3ad2559deda5339 = function(match) {
    return function(f) {
        return function(red) {
            var go = function(v) {
                return function(v1) {
                    if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("not found");
                    if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        var v2 = match(v1);
                        if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $97ffb09cc3d11a32$var$map3(function(result) {
                            return $97ffb09cc3d11a32$var$append2(result)(v2.value0.value1);
                        })(f(v)(v2.value0.value0));
                        if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $97ffb09cc3d11a32$var$map3($78c799cba34fcb8d$export$74c44e616647f5c0.create(v1.value0))(go(v1.value0.rslice)(v1.value1));
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 677, column 39 - line 679, column 47): " + [
                            v2.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 674, column 3 - line 674, column 62): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return go(red.start)(red.segments);
        };
    };
};
var $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a = function(v) {
    return {
        trans: v.trans,
        op: v.op
    };
};
var $97ffb09cc3d11a32$export$840544043b22029e = function(tid) {
    return function(leftSlice) {
        return function(seg1) {
            return function(seg2) {
                var pars = new $97ffb09cc3d11a32$export$a56b005ab5275675({
                    left: leftSlice,
                    right: seg2.rslice
                });
                var seg1$prime = $97ffb09cc3d11a32$export$b3c4a65469f32a4d(pars)(seg1);
                var op = new $97ffb09cc3d11a32$export$f836382419f64c98({
                    childl: seg1$prime,
                    childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(seg2)
                });
                return {
                    trans: {
                        id: tid,
                        edges: $97ffb09cc3d11a32$export$c70a271fb26a581d(seg1$prime.rslice),
                        is2nd: seg1.trans.is2nd
                    },
                    rslice: seg2.rslice,
                    op: op
                };
            };
        };
    };
};
var $97ffb09cc3d11a32$export$f57570a283cf8ebc = function(sliceId) {
    return function(model) {
        var tryMerge = function(leftSlice) {
            return function(v) {
                return new $7d4cccdf062a2261$export$19db0165690c701a(new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$840544043b22029e(model.reduction.nextTransId)(leftSlice)(v.seg1)(v.seg2), $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            };
        };
        var matchSlice = function(v) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var $1193 = $97ffb09cc3d11a32$var$eq10(v.value0.rslice.id)(sliceId);
                if ($1193) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9({
                    seg1: v.value0,
                    seg2: v.value1.value0
                }, v.value1.value1));
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
        var v = $97ffb09cc3d11a32$export$c3ad2559deda5339(matchSlice)(tryMerge)(model.reduction);
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a({
            piece: model.piece,
            styles: model.styles,
            reduction: {
                nextSliceId: model.reduction.nextSliceId,
                start: model.reduction.start,
                segments: v.value0,
                nextTransId: $97ffb09cc3d11a32$export$789865d9636612d2(model.reduction.nextTransId)
            }
        });
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 857, column 30 - line 859, column 23): " + [
            v.constructor.name
        ]);
    };
};
var $97ffb09cc3d11a32$export$d6b3d5e568c524f0 = "";
var $97ffb09cc3d11a32$export$2a3d0b2fc2ae9e63 = /* #__PURE__ */ function() {
    return {
        notes: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        edges: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        transitions: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        slices: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        css: $97ffb09cc3d11a32$export$d6b3d5e568c524f0,
        staff: $97ffb09cc3d11a32$export$725d191431df39a2.value
    };
}();
var $97ffb09cc3d11a32$export$3a8d11757f7bbbbd = function(piece) {
    return {
        piece: piece,
        reduction: $97ffb09cc3d11a32$export$2f86c81c2b9ae87c(piece),
        styles: $97ffb09cc3d11a32$export$2a3d0b2fc2ae9e63
    };
};
var $97ffb09cc3d11a32$export$a70c9112c133085b = function(v) {
    return function(rslice) {
        return {
            trans: v.trans,
            op: v.op,
            rslice: rslice
        };
    };
};
var $97ffb09cc3d11a32$export$ff4b6b21f0ad6ea7 = function(v) {
    return function(v1) {
        return function(v2) {
            return function(v3) {
                return function(v4) {
                    if (v2.rslice.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be && v3.rslice.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
                        if (!$97ffb09cc3d11a32$var$all($97ffb09cc3d11a32$export$d1444e2d33a2b556)(v3.trans.edges.regular)) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Middle transition of a vert must only contain repetition and passing edges!");
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                            var newNotes = function(counts) {
                                var pitches = $fc8c1182ec2aefec$export$66c1ae025e96b4bc($396c4c3d9e7fae3c$export$c28c8388be0ab31a(function(v5) {
                                    return $396c4c3d9e7fae3c$export$606959e7ccb797f0(v5.value1)(v5.value0);
                                })($97ffb09cc3d11a32$var$toUnfoldable1(counts)));
                                var mkNote = function(i) {
                                    return function(p) {
                                        return {
                                            note: {
                                                pitch: p,
                                                id: "note" + ($97ffb09cc3d11a32$var$show5(v1) + ("." + $97ffb09cc3d11a32$var$show(i)))
                                            },
                                            expl: $97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value
                                        };
                                    };
                                };
                                return $396c4c3d9e7fae3c$export$8f07ddce13659f50(mkNote)(pitches);
                            };
                            var countPitches = function(notes) {
                                return $97ffb09cc3d11a32$var$foldl(function(counts) {
                                    return function(n) {
                                        return $97ffb09cc3d11a32$var$insertWith($97ffb09cc3d11a32$var$add)(n.note.pitch)(1)(counts);
                                    };
                                })($ea3eb84de0acf574$export$6e22c362a0406a2c)(notes);
                            };
                            var topSlice = {
                                notes: new $97ffb09cc3d11a32$export$f63ba74aa66682be(newNotes($97ffb09cc3d11a32$var$unionWith($97ffb09cc3d11a32$var$max)(countPitches(v2.rslice.notes.value0))(countPitches(v3.rslice.notes.value0)))),
                                id: v1,
                                x: (v2.rslice.x + v3.rslice.x) / 2.0,
                                parents: $97ffb09cc3d11a32$export$914e87441b58d7d9.value
                            };
                            var childm = $97ffb09cc3d11a32$export$b3c4a65469f32a4d(new $97ffb09cc3d11a32$export$a94683cf162a309e(topSlice))(v3);
                            var mkLeftParent = function(lfound) {
                                var childl = $97ffb09cc3d11a32$export$b3c4a65469f32a4d(new $97ffb09cc3d11a32$export$a94683cf162a309e(topSlice))($97ffb09cc3d11a32$export$a70c9112c133085b(lfound)(v2.rslice));
                                return $97ffb09cc3d11a32$var$bind3($97ffb09cc3d11a32$export$17c4d6d9c222c6dd(lfound.trans.edges)(childl.rslice))(function(leftEdges) {
                                    return $97ffb09cc3d11a32$var$pure3({
                                        trans: {
                                            id: v,
                                            is2nd: false,
                                            edges: leftEdges
                                        },
                                        op: new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                            childl: childl,
                                            childm: childm,
                                            childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(v4)
                                        })
                                    });
                                });
                            };
                            return $97ffb09cc3d11a32$var$bind3($97ffb09cc3d11a32$export$a1caa2c4f72b5f4f(v4.trans.edges)(childm.rslice))(function(rightEdges) {
                                var rightParent = {
                                    trans: {
                                        id: $97ffb09cc3d11a32$export$789865d9636612d2(v),
                                        is2nd: true,
                                        edges: rightEdges
                                    },
                                    rslice: v4.rslice,
                                    op: $97ffb09cc3d11a32$export$f0826af67a39ec5d.value
                                };
                                return $97ffb09cc3d11a32$var$pure3({
                                    mkLeftParent: mkLeftParent,
                                    rightParent: rightParent,
                                    topSlice: topSlice
                                });
                            });
                        }
                    }
                    return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Cannot vert an outer slice!");
                };
            };
        };
    };
};
var $97ffb09cc3d11a32$export$14b5654dac0dfaf3 = function(transId) {
    return function(model) {
        var tryUnmerge = function(v) {
            return function(seg) {
                if (seg.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return new $7d4cccdf062a2261$export$19db0165690c701a(new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$801746a44e6e4f07($97ffb09cc3d11a32$export$b3c4a65469f32a4d($97ffb09cc3d11a32$export$914e87441b58d7d9.value)(seg.op.value0.childl)), new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(seg.op.value0.childr)(seg.rslice), $78c799cba34fcb8d$export$c1bed610ade55e1c.value)));
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Operation is not a split!");
            };
        };
        var matchTrans = function(v) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var $1224 = $97ffb09cc3d11a32$var$eq7(v.value0.trans.id)(transId);
                if ($1224) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, v.value1));
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
        var v = $97ffb09cc3d11a32$export$c3ad2559deda5339(matchTrans)(tryUnmerge)(model.reduction);
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a({
            piece: model.piece,
            styles: model.styles,
            reduction: {
                nextSliceId: model.reduction.nextSliceId,
                nextTransId: model.reduction.nextTransId,
                start: model.reduction.start,
                segments: v.value0
            }
        });
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 1086, column 34 - line 1088, column 23): " + [
            v.constructor.name
        ]);
    };
};
var $97ffb09cc3d11a32$export$ff55f353459fccc3 = function(sliceId) {
    return function(model) {
        var tryReInsert = function(v) {
            return function(v1) {
                return function(v2) {
                    return new $7d4cccdf062a2261$export$19db0165690c701a(new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$801746a44e6e4f07($97ffb09cc3d11a32$export$b3c4a65469f32a4d($97ffb09cc3d11a32$export$914e87441b58d7d9.value)({
                        trans: v2.pl.trans,
                        op: v2.pl.op,
                        rslice: v.slicel
                    })), new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$801746a44e6e4f07($97ffb09cc3d11a32$export$b3c4a65469f32a4d($97ffb09cc3d11a32$export$914e87441b58d7d9.value)(v.childm)), new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(v.childr)(v2.pr.rslice), $78c799cba34fcb8d$export$c1bed610ade55e1c.value))));
                };
            };
        };
        var tryExtract = function(count) {
            return function(seg) {
                if (count <= 0) {
                    if (seg.op instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) return $97ffb09cc3d11a32$var$pure3(new $7d4cccdf062a2261$export$19db0165690c701a({
                        "seg'": $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(seg.op.value0.childl),
                        result: {
                            slicel: seg.op.value0.childl.rslice,
                            childm: seg.op.value0.childm,
                            childr: seg.op.value0.childr,
                            "pl'": seg.op.value0.childl.trans.edges
                        }
                    }));
                    if (seg.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return $97ffb09cc3d11a32$var$pure3(new $7d4cccdf062a2261$export$37c4d04eafdc5515(count));
                    return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Could not find left parent edge. This is a bug!");
                }
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    if (seg.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return $97ffb09cc3d11a32$var$pure3(new $7d4cccdf062a2261$export$37c4d04eafdc5515(count));
                    if (seg.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return $97ffb09cc3d11a32$var$bind3(tryExtract(count)(seg.op.value0.childr))(function(resR) {
                        if (resR instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $97ffb09cc3d11a32$var$pure3(new $7d4cccdf062a2261$export$19db0165690c701a({
                            "seg'": {
                                trans: seg.trans,
                                op: new $97ffb09cc3d11a32$export$f836382419f64c98({
                                    childl: seg.op.value0.childl,
                                    childr: resR["value0"]["seg'"]
                                })
                            },
                            result: resR.value0.result
                        }));
                        if (resR instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $97ffb09cc3d11a32$var$bind3(tryExtract(resR.value0 + 1 | 0)($97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(seg.op.value0.childl)))(function(resL) {
                            if (resL instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $97ffb09cc3d11a32$var$pure3(new $7d4cccdf062a2261$export$19db0165690c701a({
                                "seg'": {
                                    trans: seg.trans,
                                    op: new $97ffb09cc3d11a32$export$f836382419f64c98({
                                        childl: $97ffb09cc3d11a32$export$a70c9112c133085b(resL["value0"]["seg'"])(seg.op.value0.childl.rslice),
                                        childr: seg.op.value0.childr
                                    })
                                },
                                result: resL.value0.result
                            }));
                            if (resL instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $97ffb09cc3d11a32$var$pure3(new $7d4cccdf062a2261$export$37c4d04eafdc5515(resL.value0));
                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1176, column 15 - line 1178, column 50): " + [
                                resL.constructor.name
                            ]);
                        });
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1171, column 11 - line 1178, column 50): " + [
                            resR.constructor.name
                        ]);
                    });
                    if (seg.op instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) return $97ffb09cc3d11a32$var$bind3(tryExtract(count - 1 | 0)(seg.op.value0.childr))(function(resR) {
                        if (resR instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $97ffb09cc3d11a32$var$pure3(new $7d4cccdf062a2261$export$19db0165690c701a({
                            "seg'": {
                                trans: seg.trans,
                                op: new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                    childl: seg.op.value0.childl,
                                    childm: seg.op.value0.childm,
                                    childr: resR["value0"]["seg'"]
                                })
                            },
                            result: resR.value0.result
                        }));
                        if (resR instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $97ffb09cc3d11a32$var$bind3(tryExtract(resR.value0 + 1 | 0)($97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(seg.op.value0.childm)))(function(resM) {
                            if (resM instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $97ffb09cc3d11a32$var$pure3(new $7d4cccdf062a2261$export$19db0165690c701a({
                                "seg'": {
                                    trans: seg.trans,
                                    op: new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                        childl: seg.op.value0.childl,
                                        childm: $97ffb09cc3d11a32$export$a70c9112c133085b(resM["value0"]["seg'"])(seg.op.value0.childm.rslice),
                                        childr: seg.op.value0.childr
                                    })
                                },
                                result: resM.value0.result
                            }));
                            if (resM instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $97ffb09cc3d11a32$var$bind3(tryExtract(resM.value0 + 1 | 0)($97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(seg.op.value0.childl)))(function(resL) {
                                if (resL instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $97ffb09cc3d11a32$var$pure3(new $7d4cccdf062a2261$export$19db0165690c701a({
                                    "seg'": {
                                        trans: seg.trans,
                                        op: new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                            childl: $97ffb09cc3d11a32$export$a70c9112c133085b(resL["value0"]["seg'"])(seg.op.value0.childl.rslice),
                                            childm: seg.op.value0.childm,
                                            childr: seg.op.value0.childr
                                        })
                                    },
                                    result: resL.value0.result
                                }));
                                if (resL instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $97ffb09cc3d11a32$var$pure3(new $7d4cccdf062a2261$export$37c4d04eafdc5515(resL.value0));
                                throw new Error("Failed pattern match at ProtoVoices.Model (line 1192, column 19 - line 1194, column 54): " + [
                                    resL.constructor.name
                                ]);
                            });
                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1188, column 15 - line 1194, column 54): " + [
                                resM.constructor.name
                            ]);
                        });
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1182, column 11 - line 1194, column 54): " + [
                            resR.constructor.name
                        ]);
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1166, column 19 - line 1194, column 54): " + [
                        seg.op.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at ProtoVoices.Model (line 1152, column 3 - line 1155, column 143): " + [
                    count.constructor.name,
                    seg.constructor.name
                ]);
            };
        };
        var matchSlice = function(v) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var $1279 = $97ffb09cc3d11a32$var$eq10(v.value0.rslice.id)(sliceId);
                if ($1279) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9({
                    pl: v.value0,
                    pr: v.value1.value0
                }, v.value1.value1));
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
        var insertPl = function(count) {
            return function(pl) {
                return function(seg) {
                    if (count <= 0) {
                        if (seg.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return new $7d4cccdf062a2261$export$19db0165690c701a({
                            "seg'": {
                                op: seg.op,
                                trans: {
                                    id: seg.trans.id,
                                    is2nd: seg.trans.is2nd,
                                    edges: pl
                                }
                            },
                            "pl'": pl
                        });
                        return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Invalid structure. This is a bug!");
                    }
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                        if (seg.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return new $7d4cccdf062a2261$export$19db0165690c701a({
                            "seg'": seg,
                            "pl'": pl
                        });
                        if (seg.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return $97ffb09cc3d11a32$var$bind3(insertPl(count + 1 | 0)(pl)($97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(seg.op.value0.childl)))(function(resL) {
                            return $97ffb09cc3d11a32$var$bind3(insertPl(count)(resL["pl'"])(seg.op.value0.childr))(function(resR) {
                                return $97ffb09cc3d11a32$var$pure3({
                                    "seg'": {
                                        trans: seg.trans,
                                        op: new $97ffb09cc3d11a32$export$f836382419f64c98({
                                            childl: $97ffb09cc3d11a32$export$a70c9112c133085b(resL["seg'"])(seg.op.value0.childl.rslice),
                                            childr: resR["seg'"]
                                        })
                                    },
                                    "pl'": resR["pl'"]
                                });
                            });
                        });
                        if (seg.op instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) return $97ffb09cc3d11a32$var$bind3(insertPl(count + 1 | 0)(pl)($97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(seg.op.value0.childl)))(function(resL) {
                            return $97ffb09cc3d11a32$var$bind3(insertPl(count)(resL["pl'"])($97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(seg.op.value0.childm)))(function(resM) {
                                var $1292 = count === 1;
                                if ($1292) return $97ffb09cc3d11a32$var$bind3($97ffb09cc3d11a32$export$a1caa2c4f72b5f4f(resM["pl'"])(seg.op.value0.childm.rslice))(function(pl$prime) {
                                    return new $7d4cccdf062a2261$export$19db0165690c701a({
                                        "seg'": {
                                            trans: seg.trans,
                                            op: new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                                childl: $97ffb09cc3d11a32$export$a70c9112c133085b(resL["seg'"])(seg.op.value0.childl.rslice),
                                                childm: $97ffb09cc3d11a32$export$a70c9112c133085b(resM["seg'"])(seg.op.value0.childm.rslice),
                                                childr: {
                                                    op: seg.op.value0.childr.op,
                                                    trans: {
                                                        id: seg.op.value0.childr.trans.id,
                                                        is2nd: seg.op.value0.childr.trans.is2nd,
                                                        edges: resM["pl'"]
                                                    }
                                                }
                                            })
                                        },
                                        "pl'": pl$prime
                                    });
                                });
                                return $97ffb09cc3d11a32$var$bind3(insertPl(count - 1 | 0)(resM["pl'"])(seg.op.value0.childr))(function(resR) {
                                    return new $7d4cccdf062a2261$export$19db0165690c701a({
                                        "seg'": {
                                            trans: seg.trans,
                                            op: new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                                childl: $97ffb09cc3d11a32$export$a70c9112c133085b(resL["seg'"])(seg.op.value0.childl.rslice),
                                                childm: $97ffb09cc3d11a32$export$a70c9112c133085b(resM["seg'"])(seg.op.value0.childm.rslice),
                                                childr: resR["seg'"]
                                            })
                                        },
                                        "pl'": resR["pl'"]
                                    });
                                });
                            });
                        });
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1211, column 19 - line 1247, column 16): " + [
                            seg.op.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1206, column 3 - line 1206, column 95): " + [
                        count.constructor.name,
                        pl.constructor.name,
                        seg.constructor.name
                    ]);
                };
            };
        };
        var fixPl = function(count) {
            return function(pl) {
                if (count >= 0) return function(v) {
                    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $97ffb09cc3d11a32$var$pure3($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $97ffb09cc3d11a32$var$bind3(insertPl(count)(pl)($97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(v.value0)))(function(v1) {
                        return $97ffb09cc3d11a32$var$bind3(fixPl(count - 1 | 0)(v1["pl'"])(v.value1))(function(tail$prime) {
                            return $97ffb09cc3d11a32$var$pure3(new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(v1["seg'"])(v.value0.rslice), tail$prime));
                        });
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1198, column 20 - line 1203, column 55): " + [
                        v.constructor.name
                    ]);
                };
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $97ffb09cc3d11a32$var$pure3;
                throw new Error("Failed pattern match at ProtoVoices.Model (line 1196, column 3 - line 1196, column 72): " + [
                    count.constructor.name,
                    pl.constructor.name
                ]);
            };
        };
        var extractVert = function(v) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Could not find hori!");
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Could not find hori!");
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var $1308 = $97ffb09cc3d11a32$var$eq10(v.value0.rslice.id)(sliceId);
                if ($1308) {
                    var $1309 = $97ffb09cc3d11a32$var$eq16(v.value1.value0.op)($97ffb09cc3d11a32$export$f0826af67a39ec5d.value);
                    if ($1309) {
                        if (v.value0.op instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) return new $7d4cccdf062a2261$export$19db0165690c701a({
                            tail: new $78c799cba34fcb8d$export$74c44e616647f5c0({
                                op: v.value0.op.value0.childl.op,
                                trans: v.value0.op.value0.childl.trans,
                                rslice: v.value0.rslice
                            }, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value1.value0, v.value1.value1)),
                            result: new $7d4cccdf062a2261$export$19db0165690c701a({
                                slicel: v.value0.op.value0.childl.rslice,
                                childm: v.value0.op.value0.childm,
                                childr: v.value0.op.value0.childr,
                                "pl'": v.value0.op.value0.childl.trans.edges
                            }),
                            surfaceCount: 0
                        });
                        if (v.value0.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return new $7d4cccdf062a2261$export$19db0165690c701a({
                            tail: new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value1.value0, v.value1.value1)),
                            result: new $7d4cccdf062a2261$export$37c4d04eafdc5515(1),
                            surfaceCount: 1
                        });
                        return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Not a top-level hori!");
                    }
                    return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Not a top-level hori!");
                }
                return $97ffb09cc3d11a32$var$bind3(extractVert(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value1.value0, v.value1.value1)))(function(next) {
                    if (next.result instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $97ffb09cc3d11a32$var$pure3({
                        tail: new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, next.tail),
                        result: next.result,
                        surfaceCount: 0
                    });
                    if (next.result instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $97ffb09cc3d11a32$var$bind3(tryExtract(next.result.value0)($97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(v.value0)))(function(pl$primeMaybe) {
                        if (pl$primeMaybe instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $97ffb09cc3d11a32$var$pure3({
                            tail: new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, next.tail),
                            result: new $7d4cccdf062a2261$export$37c4d04eafdc5515(pl$primeMaybe.value0 + 1 | 0),
                            surfaceCount: next.surfaceCount + 1 | 0
                        });
                        if (pl$primeMaybe instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $97ffb09cc3d11a32$var$bind3(fixPl(next.surfaceCount)(pl$primeMaybe["value0"]["result"]["pl'"])(new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(pl$primeMaybe["value0"]["seg'"])(v.value0.rslice), next.tail)))(function(fixedTail) {
                            return $97ffb09cc3d11a32$var$pure3({
                                tail: fixedTail,
                                result: new $7d4cccdf062a2261$export$19db0165690c701a(pl$primeMaybe.value0.result),
                                surfaceCount: 0
                            });
                        });
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1146, column 13 - line 1150, column 80): " + [
                            pl$primeMaybe.constructor.name
                        ]);
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1142, column 9 - line 1150, column 80): " + [
                        next.result.constructor.name
                    ]);
                });
            }
            throw new Error("Failed pattern match at ProtoVoices.Model (line 1112, column 17 - line 1150, column 80): " + [
                v.constructor.name
            ]);
        };
        return $97ffb09cc3d11a32$var$bind3(extractVert(model.reduction.segments))(function(v) {
            if (v.result instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $97ffb09cc3d11a32$var$bind3($97ffb09cc3d11a32$export$c3ad2559deda5339(matchSlice)(tryReInsert(v.result.value0))({
                start: model.reduction.start,
                nextTransId: model.reduction.nextTransId,
                nextSliceId: model.reduction.nextSliceId,
                segments: v.tail
            }))(function(segments$prime$prime) {
                return $97ffb09cc3d11a32$var$pure3({
                    piece: model.piece,
                    styles: model.styles,
                    reduction: {
                        nextSliceId: model.reduction.nextSliceId,
                        nextTransId: model.reduction.nextTransId,
                        start: model.reduction.start,
                        segments: segments$prime$prime
                    }
                });
            });
            if (v.result instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Could not find left parent edge. This is a bug!");
            throw new Error("Failed pattern match at ProtoVoices.Model (line 1106, column 3 - line 1110, column 69): " + [
                v.result.constructor.name
            ]);
        });
    };
};
var $97ffb09cc3d11a32$export$57480ab821cf5298 = function(transId) {
    return function(model) {
        var insertDangling = function(dist) {
            return function(topSlice) {
                return function(mkLeftParent) {
                    return function(leftSlice) {
                        return function(segl) {
                            return function(segr) {
                                return function(tail) {
                                    var v = function(v1) {
                                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                                            var fixRight = function(childm) {
                                                return function(childr) {
                                                    return $97ffb09cc3d11a32$var$bind3($97ffb09cc3d11a32$export$a1caa2c4f72b5f4f(childr.trans.edges)(childm.rslice))(function(edges$prime) {
                                                        return $97ffb09cc3d11a32$var$pure3({
                                                            op: segr.op,
                                                            rslice: segr.rslice,
                                                            trans: {
                                                                id: segr.trans.id,
                                                                is2nd: segr.trans.is2nd,
                                                                edges: edges$prime
                                                            }
                                                        });
                                                    });
                                                };
                                            };
                                            if (segl.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return new $7d4cccdf062a2261$export$19db0165690c701a({
                                                "segl'": segl,
                                                "segr'": segr,
                                                "tail'": tail,
                                                leftover: new $06733ae99ed4f534$export$8a67b48435b5d073(0)
                                            });
                                            if (segl.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return $97ffb09cc3d11a32$var$bind3(insertDangling(dist)(topSlice)(mkLeftParent)(segl.op.value0.childl.rslice)($97ffb09cc3d11a32$export$a70c9112c133085b(segl.op.value0.childr)(segl.rslice))(segr)(tail))(function(v2) {
                                                return $97ffb09cc3d11a32$var$bind3(function() {
                                                    var $1342 = dist === 0;
                                                    if ($1342) {
                                                        if (segl.op.value0.childl.rslice.parents instanceof $97ffb09cc3d11a32$export$a56b005ab5275675) return new $7d4cccdf062a2261$export$19db0165690c701a($97ffb09cc3d11a32$export$b3c4a65469f32a4d(new $97ffb09cc3d11a32$export$a56b005ab5275675({
                                                            left: leftSlice,
                                                            right: topSlice
                                                        }))($97ffb09cc3d11a32$export$801746a44e6e4f07(segl.op.value0.childl)));
                                                        return new $7d4cccdf062a2261$export$37c4d04eafdc5515("invalid derivation structure: non-merge parents on merge slice");
                                                    }
                                                    return $97ffb09cc3d11a32$var$pure3(segl.op.value0.childl);
                                                }())(function(childlFixed) {
                                                    if (v2.leftover instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $97ffb09cc3d11a32$var$pure3({
                                                        "segl'": {
                                                            rslice: segl.rslice,
                                                            op: new $97ffb09cc3d11a32$export$f836382419f64c98({
                                                                childl: childlFixed,
                                                                childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(v2["segl'"])
                                                            }),
                                                            trans: {
                                                                id: segl.trans.id,
                                                                is2nd: segl.trans.is2nd,
                                                                edges: $97ffb09cc3d11a32$export$c70a271fb26a581d(childlFixed.rslice)
                                                            }
                                                        },
                                                        "segr'": v2["segr'"],
                                                        "tail'": v2["tail'"],
                                                        leftover: $06733ae99ed4f534$export$bebe9059409a0d04.value
                                                    });
                                                    if (v2.leftover instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $97ffb09cc3d11a32$var$bind3(insertDangling((dist + v2.leftover.value0 | 0) + 1 | 0)(topSlice)(mkLeftParent)(leftSlice)(childlFixed)(v2["segl'"])(new $78c799cba34fcb8d$export$74c44e616647f5c0(v2["segr'"], v2["tail'"])))(function(v3) {
                                                        if (v3["tail'"] instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                                            var segl$prime = {
                                                                rslice: segl.rslice,
                                                                op: new $97ffb09cc3d11a32$export$f836382419f64c98({
                                                                    childl: v3["segl'"],
                                                                    childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(v3["segr'"])
                                                                }),
                                                                trans: {
                                                                    id: segl.trans.id,
                                                                    is2nd: segl.trans.is2nd,
                                                                    edges: $97ffb09cc3d11a32$export$c70a271fb26a581d(v3["segl'"].rslice)
                                                                }
                                                            };
                                                            return $97ffb09cc3d11a32$var$pure3({
                                                                "segl'": segl$prime,
                                                                "segr'": v3["tail'"].value0,
                                                                "tail'": v3["tail'"].value1,
                                                                leftover: $97ffb09cc3d11a32$var$map4(function(v4) {
                                                                    return v4 + 1 | 0;
                                                                })(v3.leftover)
                                                            });
                                                        }
                                                        return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Returned tail too short (splitLeft). This is a bug!");
                                                    });
                                                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1003, column 13 - line 1029, column 82): " + [
                                                        v2.leftover.constructor.name
                                                    ]);
                                                });
                                            });
                                            if (segl.op instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) {
                                                if (segr.op instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Not a leftmost derivation (Hori right of Hori)!");
                                                if (segr.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return $97ffb09cc3d11a32$var$bind3(insertDangling(dist)(topSlice)(mkLeftParent)(leftSlice)(segl)(segr.op.value0.childl)(new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(segr.op.value0.childr)(segr.rslice), tail)))(function(v2) {
                                                    if (v2["tail'"] instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                                        var splitOp$prime = new $97ffb09cc3d11a32$export$f836382419f64c98({
                                                            childl: v2["segr'"],
                                                            childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(v2["tail'"].value0)
                                                        });
                                                        return $97ffb09cc3d11a32$var$pure3({
                                                            "segl'": v2["segl'"],
                                                            "segr'": {
                                                                rslice: segr.rslice,
                                                                op: splitOp$prime,
                                                                trans: {
                                                                    id: segr.trans.id,
                                                                    is2nd: segr.trans.is2nd,
                                                                    edges: $97ffb09cc3d11a32$export$c70a271fb26a581d(v2["segr'"].rslice)
                                                                }
                                                            },
                                                            "tail'": v2["tail'"].value1,
                                                            leftover: v2.leftover
                                                        });
                                                    }
                                                    return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Returned tail too short (splitRight). This is a bug!");
                                                });
                                                if (segr.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) {
                                                    if (tail instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Tail too short (hori). This is a bug!");
                                                    if (tail instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $97ffb09cc3d11a32$var$bind3(insertDangling(dist - 1 | 0)(topSlice)(mkLeftParent)(segl.op.value0.childm.rslice)($97ffb09cc3d11a32$export$a70c9112c133085b(segl.op.value0.childr)(segl.rslice))(tail.value0)(tail.value1))(function(v2) {
                                                        var tail$primer = new $78c799cba34fcb8d$export$74c44e616647f5c0(v2["segr'"], v2["tail'"]);
                                                        if (v2.leftover instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                                                            var op$prime = new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                                                childl: segl.op.value0.childl,
                                                                childm: segl.op.value0.childm,
                                                                childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(v2["segl'"])
                                                            });
                                                            return $97ffb09cc3d11a32$var$bind3(fixRight(segl.op.value0.childm)(v2["segl'"]))(function(segr$primer) {
                                                                return $97ffb09cc3d11a32$var$pure3({
                                                                    "segl'": {
                                                                        rslice: segl.rslice,
                                                                        trans: segl.trans,
                                                                        op: op$prime
                                                                    },
                                                                    "segr'": segr$primer,
                                                                    "tail'": tail$primer,
                                                                    leftover: $06733ae99ed4f534$export$bebe9059409a0d04.value
                                                                });
                                                            });
                                                        }
                                                        if (v2.leftover instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $97ffb09cc3d11a32$var$bind3(insertDangling(dist + v2.leftover.value0 | 0)(topSlice)(mkLeftParent)(segl.op.value0.childl.rslice)(segl.op.value0.childm)(v2["segl'"])(tail$primer))(function(v3) {
                                                            if (v3.leftover instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                                                                var op$prime = new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                                                    childl: segl.op.value0.childl,
                                                                    childm: v3["segl'"],
                                                                    childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(v3["segr'"])
                                                                });
                                                                return $97ffb09cc3d11a32$var$bind3(fixRight(v3["segl'"])(v3["segr'"]))(function(segr$primem) {
                                                                    return $97ffb09cc3d11a32$var$pure3({
                                                                        "segl'": {
                                                                            rslice: segl.rslice,
                                                                            trans: segl.trans,
                                                                            op: op$prime
                                                                        },
                                                                        "segr'": segr$primem,
                                                                        "tail'": v3["tail'"],
                                                                        leftover: $06733ae99ed4f534$export$bebe9059409a0d04.value
                                                                    });
                                                                });
                                                            }
                                                            if (v3.leftover instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $97ffb09cc3d11a32$var$bind3(insertDangling((dist + 1 | 0) + v3.leftover.value0 | 0)(topSlice)(mkLeftParent)(leftSlice)(segl.op.value0.childl)(v3["segl'"])(new $78c799cba34fcb8d$export$74c44e616647f5c0(v3["segr'"], v3["tail'"])))(function(v4) {
                                                                if (v4["tail'"] instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Returned tail too short (hori). This is a bug!");
                                                                if (v4["tail'"] instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                                                    var op$prime = new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                                                        childl: v4["segl'"],
                                                                        childm: v4["segr'"],
                                                                        childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(v4["tail'"].value0)
                                                                    });
                                                                    return $97ffb09cc3d11a32$var$bind3(fixRight(v4["segr'"])(v4["tail'"].value0))(function(segr$primel) {
                                                                        return $97ffb09cc3d11a32$var$pure3({
                                                                            "segl'": {
                                                                                rslice: segl.rslice,
                                                                                trans: segl.trans,
                                                                                op: op$prime
                                                                            },
                                                                            "segr'": segr$primel,
                                                                            "tail'": v4["tail'"].value1,
                                                                            leftover: $97ffb09cc3d11a32$var$map4(function(v5) {
                                                                                return v5 + 2 | 0;
                                                                            })(v4.leftover)
                                                                        });
                                                                    });
                                                                }
                                                                throw new Error("Failed pattern match at ProtoVoices.Model (line 1072, column 25 - line 1078, column 119): " + [
                                                                    v4["tail'"].constructor.name
                                                                ]);
                                                            });
                                                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1062, column 21 - line 1078, column 119): " + [
                                                                v3.leftover.constructor.name
                                                            ]);
                                                        });
                                                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1052, column 17 - line 1078, column 119): " + [
                                                            v2.leftover.constructor.name
                                                        ]);
                                                    });
                                                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1044, column 23 - line 1078, column 119): " + [
                                                        tail.constructor.name
                                                    ]);
                                                }
                                                throw new Error("Failed pattern match at ProtoVoices.Model (line 1031, column 46 - line 1078, column 119): " + [
                                                    segr.op.constructor.name
                                                ]);
                                            }
                                            throw new Error("Failed pattern match at ProtoVoices.Model (line 988, column 9 - line 1078, column 119): " + [
                                                segl.op.constructor.name
                                            ]);
                                        }
                                        throw new Error("Failed pattern match at ProtoVoices.Model (line 912, column 1 - line 912, column 53): " + [
                                            dist.constructor.name,
                                            topSlice.constructor.name,
                                            mkLeftParent.constructor.name,
                                            leftSlice.constructor.name,
                                            segl.constructor.name,
                                            segr.constructor.name,
                                            tail.constructor.name
                                        ]);
                                    };
                                    var $1409 = dist === 0;
                                    if ($1409) {
                                        var $1410 = !segl.trans.is2nd;
                                        if ($1410) return $97ffb09cc3d11a32$var$bind3(mkLeftParent($97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(segl)))(function(segl$prime) {
                                            return $97ffb09cc3d11a32$var$pure3({
                                                "segl'": $97ffb09cc3d11a32$export$a70c9112c133085b(segl$prime)(segl.rslice),
                                                "segr'": segr,
                                                "tail'": tail,
                                                leftover: $06733ae99ed4f534$export$bebe9059409a0d04.value
                                            });
                                        });
                                        return v(true);
                                    }
                                    return v(true);
                                };
                            };
                        };
                    };
                };
            };
        };
        var tryInsert = function(dist) {
            return function(topSlice) {
                return function(mkLeftParent) {
                    return function(leftSlice) {
                        return function(segl) {
                            return function(segr) {
                                return function(tail) {
                                    return $97ffb09cc3d11a32$var$bind3(insertDangling(dist)(topSlice)(mkLeftParent)(leftSlice)(segl)(segr)(tail))(function(v) {
                                        return $97ffb09cc3d11a32$var$pure3(function() {
                                            if (v.leftover instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
                                                "seg'": v["segl'"],
                                                "tail'": new $78c799cba34fcb8d$export$74c44e616647f5c0(v["segr'"], v["tail'"]),
                                                dangling: $06733ae99ed4f534$export$bebe9059409a0d04.value
                                            };
                                            if (v.leftover instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
                                                "seg'": v["segl'"],
                                                "tail'": new $78c799cba34fcb8d$export$74c44e616647f5c0(v["segr'"], v["tail'"]),
                                                dangling: new $06733ae99ed4f534$export$8a67b48435b5d073({
                                                    dist: (dist + 1 | 0) + v.leftover.value0 | 0,
                                                    mkLeftParent: mkLeftParent,
                                                    topSlice: topSlice
                                                })
                                            };
                                            throw new Error("Failed pattern match at ProtoVoices.Model (line 964, column 10 - line 966, column 120): " + [
                                                v.leftover.constructor.name
                                            ]);
                                        }());
                                    });
                                };
                            };
                        };
                    };
                };
            };
        };
        var doVert = function(v) {
            return function(v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    if ($97ffb09cc3d11a32$var$eq7(v1.value1.value0.trans.id)(transId)) return $97ffb09cc3d11a32$var$bind3($97ffb09cc3d11a32$export$ff4b6b21f0ad6ea7(model.reduction.nextTransId)(model.reduction.nextSliceId)(v1.value0)(v1.value1.value0)(v1.value1.value1.value0))(function(v2) {
                        return tryInsert(0)(v2.topSlice)(v2.mkLeftParent)(v)({
                            trans: v1.value0.trans,
                            op: v1.value0.op,
                            rslice: v2.topSlice
                        })(v2.rightParent)(v1.value1.value1.value1);
                    });
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $97ffb09cc3d11a32$var$bind3(doVert(v1.value0.rslice)(v1.value1))(function(v2) {
                        if (v2.dangling instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$19db0165690c701a({
                            "seg'": v1.value0,
                            "tail'": new $78c799cba34fcb8d$export$74c44e616647f5c0(v2["seg'"], v2["tail'"]),
                            dangling: $06733ae99ed4f534$export$bebe9059409a0d04.value
                        });
                        if (v2.dangling instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return tryInsert(v2.dangling.value0.dist)(v2.dangling.value0.topSlice)(v2.dangling.value0.mkLeftParent)(v)(v1.value0)(v2["seg'"])(v2["tail'"]);
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 944, column 9 - line 946, column 110): " + [
                            v2.dangling.constructor.name
                        ]);
                    });
                }
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Cannot hori at " + $97ffb09cc3d11a32$var$show2(transId));
            };
        };
        var v = doVert(model.reduction.start)(model.reduction.segments);
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
            if (v.value0.dangling instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$19db0165690c701a({
                piece: model.piece,
                styles: model.styles,
                reduction: {
                    start: model.reduction.start,
                    segments: new $78c799cba34fcb8d$export$74c44e616647f5c0(v["value0"]["seg'"], v["value0"]["tail'"]),
                    nextTransId: $97ffb09cc3d11a32$export$789865d9636612d2($97ffb09cc3d11a32$export$789865d9636612d2(model.reduction.nextTransId)),
                    nextSliceId: $97ffb09cc3d11a32$export$3b674933b866e4e6(model.reduction.nextSliceId)
                }
            });
            if (v.value0.dangling instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Failed to insert hori!");
            throw new Error("Failed pattern match at ProtoVoices.Model (line 914, column 38 - line 924, column 52): " + [
                v.value0.dangling.constructor.name
            ]);
        }
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 913, column 27 - line 925, column 23): " + [
            v.constructor.name
        ]);
    };
};


var $9f7acf93d681eed3$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $9f7acf93d681eed3$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($70cd3177464e7915$export$794f9574ca20b986);
var $9f7acf93d681eed3$var$toUnfoldable = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $9f7acf93d681eed3$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($c50cfdb0b9e8fa31$export$8f0ac76856b1d87e);
var $9f7acf93d681eed3$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $9f7acf93d681eed3$var$showRecord = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()();
var $9f7acf93d681eed3$var$showRecordFieldsCons = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "ids";
    }
});
var $9f7acf93d681eed3$var$showRecordFieldsCons1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "passing";
    }
});
var $9f7acf93d681eed3$var$regularIsSymbol = {
    reflectSymbol: function() {
        return "regular";
    }
};
var $9f7acf93d681eed3$var$showRecordFieldsConsNil = /* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "unexplained";
    }
});
var $9f7acf93d681eed3$var$showRecord1 = /* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "id";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "pitch";
    }
})(/* #__PURE__ */ $6416bd93bb20ed95$export$26082705e1e7e214($364547bd6bbe186e$export$6c410b696f956741)))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $9f7acf93d681eed3$var$showArray = /* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($9f7acf93d681eed3$var$showRecord1);
var $9f7acf93d681eed3$var$showRecordFieldsCons2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "left";
    }
});
var $9f7acf93d681eed3$var$rightIsSymbol = {
    reflectSymbol: function() {
        return "right";
    }
};
var $9f7acf93d681eed3$var$showRecordFieldsConsNil1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($9f7acf93d681eed3$var$rightIsSymbol);
var $9f7acf93d681eed3$var$showStartStop = /* #__PURE__ */ $97ffb09cc3d11a32$export$69330288ca7d5e07($9f7acf93d681eed3$var$showRecord1);
var $9f7acf93d681eed3$var$showRecord2 = /* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons2(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsConsNil1($9f7acf93d681eed3$var$showStartStop))($9f7acf93d681eed3$var$showStartStop));
var $9f7acf93d681eed3$var$showMap = /* #__PURE__ */ $ea3eb84de0acf574$export$c448526daa762015($9f7acf93d681eed3$var$showRecord2);
var $9f7acf93d681eed3$var$showRecordFieldsCons3 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "child";
    }
});
var $9f7acf93d681eed3$var$showRecordFieldsConsNil2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "orn";
    }
});
var $9f7acf93d681eed3$var$showMaybe = /* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($97ffb09cc3d11a32$export$642f92ca6de37b54);
var $9f7acf93d681eed3$var$showArray1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($9f7acf93d681eed3$var$showRecord2);
var $9f7acf93d681eed3$var$showRecordFieldsCons4 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($9f7acf93d681eed3$var$rightIsSymbol);
var $9f7acf93d681eed3$var$showMap1 = /* #__PURE__ */ $ea3eb84de0acf574$export$c448526daa762015($9f7acf93d681eed3$var$showRecord1);
var $9f7acf93d681eed3$var$LMSplitLeftIsSymbol = {
    reflectSymbol: function() {
        return "LMSplitLeft";
    }
};
var $9f7acf93d681eed3$var$LMFreezeLeftIsSymbol = {
    reflectSymbol: function() {
        return "LMFreezeLeft";
    }
};
var $9f7acf93d681eed3$var$LMSplitRightIsSymbol = {
    reflectSymbol: function() {
        return "LMSplitRight";
    }
};
var $9f7acf93d681eed3$var$LMHorizontalizeIsSymbol = {
    reflectSymbol: function() {
        return "LMHorizontalize";
    }
};
var $9f7acf93d681eed3$var$LMSplitOnlyIsSymbol = {
    reflectSymbol: function() {
        return "LMSplitOnly";
    }
};
var $9f7acf93d681eed3$var$LMFreezeOnlyIsSymbol = {
    reflectSymbol: function() {
        return "LMFreezeOnly";
    }
};
var $9f7acf93d681eed3$var$genericShowConstructor = /* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658($9f7acf93d681eed3$var$showRecord1));
var $9f7acf93d681eed3$var$showRecord3 = /* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons2(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsConsNil1($9f7acf93d681eed3$var$showArray))($9f7acf93d681eed3$var$showArray));
var $9f7acf93d681eed3$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$9e4a28683e28e26a)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $9f7acf93d681eed3$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $9f7acf93d681eed3$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $9f7acf93d681eed3$export$6df59be1acc9acf0 = /* #__PURE__ */ function() {
    function RootNote() {}
    RootNote.value = new RootNote();
    return RootNote;
}();
var $9f7acf93d681eed3$export$88d2c66b2781749d = function(x) {
    return x;
};
var $9f7acf93d681eed3$export$6d38f18d731c7d88 = /* #__PURE__ */ function() {
    function LMSplitLeft(value0) {
        this.value0 = value0;
    }
    LMSplitLeft.create = function(value0) {
        return new LMSplitLeft(value0);
    };
    return LMSplitLeft;
}();
var $9f7acf93d681eed3$export$9217dfcc08ac2e7d = /* #__PURE__ */ function() {
    function LMFreezeLeft(value0) {
        this.value0 = value0;
    }
    LMFreezeLeft.create = function(value0) {
        return new LMFreezeLeft(value0);
    };
    return LMFreezeLeft;
}();
var $9f7acf93d681eed3$export$c71f04b0722025ea = /* #__PURE__ */ function() {
    function LMSplitRight(value0) {
        this.value0 = value0;
    }
    LMSplitRight.create = function(value0) {
        return new LMSplitRight(value0);
    };
    return LMSplitRight;
}();
var $9f7acf93d681eed3$export$110679fb554a6348 = /* #__PURE__ */ function() {
    function LMHorizontalize(value0) {
        this.value0 = value0;
    }
    LMHorizontalize.create = function(value0) {
        return new LMHorizontalize(value0);
    };
    return LMHorizontalize;
}();
var $9f7acf93d681eed3$export$5b281e53a92c7796 = /* #__PURE__ */ function() {
    function LMSplitOnly(value0) {
        this.value0 = value0;
    }
    LMSplitOnly.create = function(value0) {
        return new LMSplitOnly(value0);
    };
    return LMSplitOnly;
}();
var $9f7acf93d681eed3$export$6c6c4036f610eb1a = /* #__PURE__ */ function() {
    function LMFreezeOnly(value0) {
        this.value0 = value0;
    }
    LMFreezeOnly.create = function(value0) {
        return new LMFreezeOnly(value0);
    };
    return LMFreezeOnly;
}();
var $9f7acf93d681eed3$export$ecb083e2cbcb5bfb = /* #__PURE__ */ function() {
    function LeftChild(value0) {
        this.value0 = value0;
    }
    LeftChild.create = function(value0) {
        return new LeftChild(value0);
    };
    return LeftChild;
}();
var $9f7acf93d681eed3$export$30956f4b4aafa87e = /* #__PURE__ */ function() {
    function RightChild(value0) {
        this.value0 = value0;
    }
    RightChild.create = function(value0) {
        return new RightChild(value0);
    };
    return RightChild;
}();
var $9f7acf93d681eed3$export$3c38c892f848c839 = /* #__PURE__ */ function() {
    function BothChildren(value0) {
        this.value0 = value0;
    }
    BothChildren.create = function(value0) {
        return new BothChildren(value0);
    };
    return BothChildren;
}();
var $9f7acf93d681eed3$export$f1b022af85bfacd = /* #__PURE__ */ function() {
    function TooManyChildren(value0) {
        this.value0 = value0;
    }
    TooManyChildren.create = function(value0) {
        return new TooManyChildren(value0);
    };
    return TooManyChildren;
}();
var $9f7acf93d681eed3$export$f7dff462e94c98e2 = function(x) {
    return x;
};
var $9f7acf93d681eed3$export$897b4bfcd277bbf7 = function(x) {
    return x;
};
var $9f7acf93d681eed3$export$239377e00bd1bdaa = {
    append: function(a) {
        return function(b) {
            if (a instanceof $9f7acf93d681eed3$export$ecb083e2cbcb5bfb) {
                if (b instanceof $9f7acf93d681eed3$export$ecb083e2cbcb5bfb) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: [
                        a.value0,
                        b.value0
                    ],
                    right: []
                });
                if (b instanceof $9f7acf93d681eed3$export$30956f4b4aafa87e) return new $9f7acf93d681eed3$export$3c38c892f848c839({
                    left: a.value0,
                    right: b.value0
                });
                if (b instanceof $9f7acf93d681eed3$export$3c38c892f848c839) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: [
                        a.value0,
                        b.value0.left
                    ],
                    right: [
                        b.value0.right
                    ]
                });
                if (b instanceof $9f7acf93d681eed3$export$f1b022af85bfacd) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(a.value0)(b.value0.left),
                    right: b.value0.right
                });
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 105, column 20 - line 109, column 88): " + [
                    b.constructor.name
                ]);
            }
            if (a instanceof $9f7acf93d681eed3$export$30956f4b4aafa87e) {
                if (b instanceof $9f7acf93d681eed3$export$ecb083e2cbcb5bfb) return new $9f7acf93d681eed3$export$3c38c892f848c839({
                    left: b.value0,
                    right: a.value0
                });
                if (b instanceof $9f7acf93d681eed3$export$30956f4b4aafa87e) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: [],
                    right: [
                        a.value0,
                        b.value0
                    ]
                });
                if (b instanceof $9f7acf93d681eed3$export$3c38c892f848c839) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: [
                        b.value0.left
                    ],
                    right: [
                        a.value0,
                        b.value0.right
                    ]
                });
                if (b instanceof $9f7acf93d681eed3$export$f1b022af85bfacd) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: b.value0.left,
                    right: $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(a.value0)(b.value0.right)
                });
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 110, column 21 - line 114, column 89): " + [
                    b.constructor.name
                ]);
            }
            if (a instanceof $9f7acf93d681eed3$export$3c38c892f848c839) {
                if (b instanceof $9f7acf93d681eed3$export$ecb083e2cbcb5bfb) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: [
                        a.value0.left,
                        b.value0
                    ],
                    right: [
                        a.value0.right
                    ]
                });
                if (b instanceof $9f7acf93d681eed3$export$30956f4b4aafa87e) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: [
                        a.value0.left
                    ],
                    right: [
                        a.value0.right,
                        b.value0
                    ]
                });
                if (b instanceof $9f7acf93d681eed3$export$3c38c892f848c839) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: [
                        a.value0.left,
                        b.value0.left
                    ],
                    right: [
                        a.value0.right,
                        b.value0.right
                    ]
                });
                if (b instanceof $9f7acf93d681eed3$export$f1b022af85bfacd) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(a.value0.left)(b.value0.left),
                    right: $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(a.value0.right)(b.value0.right)
                });
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 115, column 43 - line 119, column 104): " + [
                    b.constructor.name
                ]);
            }
            if (a instanceof $9f7acf93d681eed3$export$f1b022af85bfacd) {
                if (b instanceof $9f7acf93d681eed3$export$ecb083e2cbcb5bfb) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: $396c4c3d9e7fae3c$export$c40cf5aab899f397(a.value0.left)(b.value0),
                    right: a.value0.right
                });
                if (b instanceof $9f7acf93d681eed3$export$30956f4b4aafa87e) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: a.value0.left,
                    right: $396c4c3d9e7fae3c$export$c40cf5aab899f397(a.value0.right)(b.value0)
                });
                if (b instanceof $9f7acf93d681eed3$export$3c38c892f848c839) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: $396c4c3d9e7fae3c$export$c40cf5aab899f397(a.value0.left)(b.value0.left),
                    right: $396c4c3d9e7fae3c$export$c40cf5aab899f397(a.value0.right)(b.value0.right)
                });
                if (b instanceof $9f7acf93d681eed3$export$f1b022af85bfacd) return new $9f7acf93d681eed3$export$f1b022af85bfacd({
                    left: $9f7acf93d681eed3$var$append(a.value0.left)(b.value0.left),
                    right: $9f7acf93d681eed3$var$append(a.value0.right)(b.value0.right)
                });
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 120, column 46 - line 124, column 96): " + [
                    b.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 104, column 16 - line 124, column 96): " + [
                a.constructor.name
            ]);
        };
    }
};
var $9f7acf93d681eed3$export$2b17e987d18a5a6b = function(splits) {
    return $9f7acf93d681eed3$var$bind($9f7acf93d681eed3$var$toUnfoldable(splits))(function(v) {
        return $9f7acf93d681eed3$var$bind(v.value1)(function(child) {
            return $9f7acf93d681eed3$var$pure({
                left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(child.child),
                right: v.value0.right
            });
        });
    });
};
var $9f7acf93d681eed3$export$4368e6027abeb9e5 = function(splits) {
    return $9f7acf93d681eed3$var$bind($9f7acf93d681eed3$var$toUnfoldable(splits))(function(v) {
        return $9f7acf93d681eed3$var$bind(v.value1)(function(child) {
            return $9f7acf93d681eed3$var$pure({
                left: v.value0.left,
                right: new $97ffb09cc3d11a32$export$f63ba74aa66682be(child.child)
            });
        });
    });
};
var $9f7acf93d681eed3$export$eb7334032a0d7c45 = function(v) {
    var unexpl = $9f7acf93d681eed3$var$map(function(note) {
        return {
            note: note,
            expl: $97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value
        };
    })(v.unexplained.right);
    var getChild = function(v1) {
        if (v1.value1 instanceof $9f7acf93d681eed3$export$30956f4b4aafa87e) return [
            {
                note: v1.value1.value0,
                expl: new $97ffb09cc3d11a32$export$ae59325e7e640c51(v1.value0)
            }
        ];
        if (v1.value1 instanceof $9f7acf93d681eed3$export$ecb083e2cbcb5bfb) return [];
        if (v1.value1 instanceof $9f7acf93d681eed3$export$3c38c892f848c839) return [
            {
                note: v1.value1.value0.right,
                expl: new $97ffb09cc3d11a32$export$ae59325e7e640c51(v1.value0)
            }
        ];
        if (v1.value1 instanceof $9f7acf93d681eed3$export$f1b022af85bfacd) return $9f7acf93d681eed3$var$map(function(v2) {
            return {
                note: v2,
                expl: new $97ffb09cc3d11a32$export$ae59325e7e640c51(v1.value0)
            };
        })(v1.value1.value0.right);
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 154, column 34 - line 158, column 78): " + [
            v1.value1.constructor.name
        ]);
    };
    var explained = $396c4c3d9e7fae3c$export$c28c8388be0ab31a(getChild)($9f7acf93d681eed3$var$toUnfoldable(v.children));
    return $97ffb09cc3d11a32$export$eb09cde4717acf6b($9f7acf93d681eed3$var$append(unexpl)(explained));
};
var $9f7acf93d681eed3$export$f6cd62fbb5249983 = function(v) {
    var unexpl = $9f7acf93d681eed3$var$map(function(note) {
        return {
            note: note,
            expl: $97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value
        };
    })(v.unexplained.left);
    var getChild = function(v1) {
        if (v1.value1 instanceof $9f7acf93d681eed3$export$ecb083e2cbcb5bfb) return [
            {
                note: v1.value1.value0,
                expl: new $97ffb09cc3d11a32$export$ae59325e7e640c51(v1.value0)
            }
        ];
        if (v1.value1 instanceof $9f7acf93d681eed3$export$30956f4b4aafa87e) return [];
        if (v1.value1 instanceof $9f7acf93d681eed3$export$3c38c892f848c839) return [
            {
                note: v1.value1.value0.left,
                expl: new $97ffb09cc3d11a32$export$ae59325e7e640c51(v1.value0)
            }
        ];
        if (v1.value1 instanceof $9f7acf93d681eed3$export$f1b022af85bfacd) return $9f7acf93d681eed3$var$map(function(v2) {
            return {
                note: v2,
                expl: new $97ffb09cc3d11a32$export$ae59325e7e640c51(v1.value0)
            };
        })(v1.value1.value0.left);
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 141, column 34 - line 145, column 76): " + [
            v1.value1.constructor.name
        ]);
    };
    var explained = $396c4c3d9e7fae3c$export$c28c8388be0ab31a(getChild)($9f7acf93d681eed3$var$toUnfoldable(v.children));
    return $97ffb09cc3d11a32$export$eb09cde4717acf6b($9f7acf93d681eed3$var$append(unexpl)(explained));
};
var $9f7acf93d681eed3$export$c7a3de80f33d19a0 = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $9f7acf93d681eed3$export$49a7a4c90317a776 = {
    to: function(x) {
        return $9f7acf93d681eed3$export$6df59be1acc9acf0.value;
    },
    from: function(x) {
        return $91c996e9c07e3b3f$export$928c7f2d618c070b.value;
    }
};
var $9f7acf93d681eed3$var$genericShow = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($9f7acf93d681eed3$export$49a7a4c90317a776)(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$f7ad98836d6849e8)({
    reflectSymbol: function() {
        return "RootNote";
    }
}));
var $9f7acf93d681eed3$export$d2eabaaf7c9d6727 = {
    show: function(ro) {
        return $9f7acf93d681eed3$var$genericShow(ro);
    }
};
var $9f7acf93d681eed3$var$genericShow1 = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($9f7acf93d681eed3$export$c7a3de80f33d19a0)(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "fromLeft";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "fromRight";
    }
})(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "keepLeft";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "keepRight";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "passLeft";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "passRight";
    }
})(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons1(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($9f7acf93d681eed3$var$regularIsSymbol)(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsConsNil($9f7acf93d681eed3$var$showArray))(/* #__PURE__ */ $9f7acf93d681eed3$var$showMap(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons3(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsConsNil2(/* #__PURE__ */ $7d4cccdf062a2261$export$37ab35e89b41eda($9f7acf93d681eed3$export$d2eabaaf7c9d6727)($9f7acf93d681eed3$var$showMaybe)))($9f7acf93d681eed3$var$showRecord1))))))(/* #__PURE__ */ $9f7acf93d681eed3$var$showMap(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons3(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsConsNil2($9f7acf93d681eed3$var$showMaybe))($9f7acf93d681eed3$var$showRecord1))))))($9f7acf93d681eed3$var$showArray1))($9f7acf93d681eed3$var$showArray1))($9f7acf93d681eed3$var$showArray1))($9f7acf93d681eed3$var$showArray1))(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons2(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons4(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "slice";
    }
})($97ffb09cc3d11a32$export$dbb383a7c8103542))($97ffb09cc3d11a32$export$d0eb33bf7c5b7bf5))($97ffb09cc3d11a32$export$d0eb33bf7c5b7bf5))))(/* #__PURE__ */ $9f7acf93d681eed3$var$showMap1(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons3(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsConsNil2(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($97ffb09cc3d11a32$export$e0728f9a6ccaeb32)))($9f7acf93d681eed3$var$showRecord1))))))(/* #__PURE__ */ $9f7acf93d681eed3$var$showMap1(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons3(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsConsNil2(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($97ffb09cc3d11a32$export$1cd099438f719ac7)))($9f7acf93d681eed3$var$showRecord1))))))))({
    reflectSymbol: function() {
        return "SplitOp";
    }
}));
var $9f7acf93d681eed3$export$5e6d5eb5f6920ab6 = {
    show: function(so) {
        return $9f7acf93d681eed3$var$genericShow1(so);
    }
};
var $9f7acf93d681eed3$export$61255e1020fa2e71 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $9f7acf93d681eed3$export$6d38f18d731c7d88(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $9f7acf93d681eed3$export$9217dfcc08ac2e7d(x.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $9f7acf93d681eed3$export$c71f04b0722025ea(x.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $9f7acf93d681eed3$export$110679fb554a6348(x.value0.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $9f7acf93d681eed3$export$5b281e53a92c7796(x.value0.value0.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $9f7acf93d681eed3$export$6c6c4036f610eb1a(x.value0.value0.value0.value0.value0);
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 25, column 1 - line 25, column 62): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $9f7acf93d681eed3$export$6d38f18d731c7d88) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $9f7acf93d681eed3$export$9217dfcc08ac2e7d) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0));
        if (x instanceof $9f7acf93d681eed3$export$c71f04b0722025ea) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0)));
        if (x instanceof $9f7acf93d681eed3$export$110679fb554a6348) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0))));
        if (x instanceof $9f7acf93d681eed3$export$5b281e53a92c7796) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0)))));
        if (x instanceof $9f7acf93d681eed3$export$6c6c4036f610eb1a) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0)))));
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 25, column 1 - line 25, column 62): " + [
            x.constructor.name
        ]);
    }
};
var $9f7acf93d681eed3$var$genericShow2 = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($9f7acf93d681eed3$export$61255e1020fa2e71);
var $9f7acf93d681eed3$export$3475f20c61adaa2a = function(dictShow) {
    var genericShowConstructor1 = $544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$bc1180ef96fcb658(dictShow));
    var genericShowSum = $544b62a378cc0091$export$29d77e0cd7b7a3b8(genericShowConstructor1($9f7acf93d681eed3$var$LMSplitLeftIsSymbol));
    var genericShowSum1 = $544b62a378cc0091$export$29d77e0cd7b7a3b8(genericShowConstructor1($9f7acf93d681eed3$var$LMSplitRightIsSymbol));
    var genericShowSum2 = $544b62a378cc0091$export$29d77e0cd7b7a3b8(genericShowConstructor1($9f7acf93d681eed3$var$LMSplitOnlyIsSymbol));
    return function(dictShow1) {
        var genericShowConstructor2 = $544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$bc1180ef96fcb658(dictShow1));
        var genericShowSum3 = $544b62a378cc0091$export$29d77e0cd7b7a3b8(genericShowConstructor2($9f7acf93d681eed3$var$LMFreezeLeftIsSymbol));
        var genericShowSum4 = genericShowSum2(genericShowConstructor2($9f7acf93d681eed3$var$LMFreezeOnlyIsSymbol));
        return function(dictShow2) {
            var genericShow6 = $9f7acf93d681eed3$var$genericShow2(genericShowSum(genericShowSum3(genericShowSum1($544b62a378cc0091$export$29d77e0cd7b7a3b8($544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$bc1180ef96fcb658(dictShow2))($9f7acf93d681eed3$var$LMHorizontalizeIsSymbol))(genericShowSum4)))));
            return {
                show: function(lm) {
                    return genericShow6(lm);
                }
            };
        };
    };
};
var $9f7acf93d681eed3$export$993c67a87d48f4bd = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $9f7acf93d681eed3$export$b8ddfaa43fa175b8 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $9f7acf93d681eed3$export$ecb083e2cbcb5bfb(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $9f7acf93d681eed3$export$30956f4b4aafa87e(x.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $9f7acf93d681eed3$export$3c38c892f848c839(x.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $9f7acf93d681eed3$export$f1b022af85bfacd(x.value0.value0.value0);
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 177, column 1 - line 177, column 62): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $9f7acf93d681eed3$export$ecb083e2cbcb5bfb) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $9f7acf93d681eed3$export$30956f4b4aafa87e) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0));
        if (x instanceof $9f7acf93d681eed3$export$3c38c892f848c839) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0)));
        if (x instanceof $9f7acf93d681eed3$export$f1b022af85bfacd) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0)));
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 177, column 1 - line 177, column 62): " + [
            x.constructor.name
        ]);
    }
};
var $9f7acf93d681eed3$var$genericShow3 = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($9f7acf93d681eed3$export$b8ddfaa43fa175b8)(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $9f7acf93d681eed3$var$genericShowConstructor({
    reflectSymbol: function() {
        return "LeftChild";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $9f7acf93d681eed3$var$genericShowConstructor({
    reflectSymbol: function() {
        return "RightChild";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons2(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsConsNil1($9f7acf93d681eed3$var$showRecord1))($9f7acf93d681eed3$var$showRecord1))))({
    reflectSymbol: function() {
        return "BothChildren";
    }
}))(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658($9f7acf93d681eed3$var$showRecord3))({
    reflectSymbol: function() {
        return "TooManyChildren";
    }
})))));
var $9f7acf93d681eed3$export$be719ac53927db2a = {
    show: function(hc) {
        return $9f7acf93d681eed3$var$genericShow3(hc);
    }
};
var $9f7acf93d681eed3$var$genericShow4 = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($9f7acf93d681eed3$export$993c67a87d48f4bd)(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "children";
    }
})(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "midEdges";
    }
})(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsConsNil($9f7acf93d681eed3$var$showRecord3))(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons1(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($9f7acf93d681eed3$var$regularIsSymbol)(/* #__PURE__ */ $a393155e52307a24$export$10430edbe04e7f5c($9f7acf93d681eed3$var$showRecord2)))($9f7acf93d681eed3$var$showArray1))))(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons2(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "lslice";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "mid";
    }
})(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecordFieldsCons4(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "rslice";
    }
})($97ffb09cc3d11a32$export$dbb383a7c8103542))($97ffb09cc3d11a32$export$d0eb33bf7c5b7bf5))($97ffb09cc3d11a32$export$d0eb33bf7c5b7bf5))($97ffb09cc3d11a32$export$dbb383a7c8103542))($97ffb09cc3d11a32$export$d0eb33bf7c5b7bf5))))(/* #__PURE__ */ $9f7acf93d681eed3$var$showMap1($9f7acf93d681eed3$export$be719ac53927db2a)))))({
    reflectSymbol: function() {
        return "HoriOp";
    }
}));
var $9f7acf93d681eed3$export$4095d690307a36d0 = {
    show: function(ho) {
        return $9f7acf93d681eed3$var$genericShow4(ho);
    }
};
var $9f7acf93d681eed3$export$dcce5ab9152043ae = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $9f7acf93d681eed3$var$genericShow5 = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($9f7acf93d681eed3$export$dcce5ab9152043ae)(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $9f7acf93d681eed3$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "prevTime";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "ties";
    }
})($9f7acf93d681eed3$var$showArray1))(/* #__PURE__ */ $7d4cccdf062a2261$export$37ab35e89b41eda($2c6b3d51d10471a7$export$e4b6cd05df3043f6)($f8662a4a41464b67$export$c936a351b926aade)))))({
    reflectSymbol: function() {
        return "FreezeOp";
    }
}));
var $9f7acf93d681eed3$export$ddcfc5bd6183c873 = {
    show: function(fo) {
        return $9f7acf93d681eed3$var$genericShow5(fo);
    }
};
var $9f7acf93d681eed3$export$30e63cab3d0e49ae = function(splits) {
    return function(f) {
        return $9f7acf93d681eed3$var$sequence($9f7acf93d681eed3$var$bind($9f7acf93d681eed3$var$toUnfoldable(splits))(function(v) {
            return $9f7acf93d681eed3$var$bind(v.value1)(function(child) {
                return $9f7acf93d681eed3$var$pure(function() {
                    var v1 = f(v.value0)(child.orn);
                    if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0);
                    if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a({
                        note: child.child,
                        expl: v1.value0
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 68, column 10 - line 70, column 54): " + [
                        v1.constructor.name
                    ]);
                }());
            });
        }));
    };
};
var $9f7acf93d681eed3$export$71d66b563b92862f = function(v) {
    return $9f7acf93d681eed3$var$bind1($9f7acf93d681eed3$export$30e63cab3d0e49ae(v.regular)(function(p) {
        return function(o) {
            if (o instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$19db0165690c701a($97ffb09cc3d11a32$export$2cf876164813516f.value);
            if (o instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                if (p.left instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
                    if (p.right instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return new $7d4cccdf062a2261$export$19db0165690c701a(new $97ffb09cc3d11a32$export$3301ca20023acaf7({
                        leftParent: p.left.value0,
                        rightParent: p.right.value0,
                        orn: o.value0
                    }));
                    return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Parent note cannot be Start or Stop!");
                }
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Parent note cannot be Start or Stop!");
            }
            throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 75, column 41 - line 81, column 57): " + [
                o.constructor.name
            ]);
        };
    }))(function(regular) {
        return $9f7acf93d681eed3$var$bind1($9f7acf93d681eed3$export$30e63cab3d0e49ae(v.passing)(function(p) {
            return function(orn) {
                if (p.left instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
                    if (p.right instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return new $7d4cccdf062a2261$export$19db0165690c701a(new $97ffb09cc3d11a32$export$3301ca20023acaf7({
                        leftParent: p.left.value0,
                        rightParent: p.right.value0,
                        orn: orn
                    }));
                    return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Parent note cannot be Start or Stop!");
                }
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Parent note cannot be Start or Stop!");
            };
        }))(function(passing) {
            return $9f7acf93d681eed3$var$bind1($9f7acf93d681eed3$export$30e63cab3d0e49ae(v.fromLeft)(function(p) {
                return function(orn) {
                    return new $7d4cccdf062a2261$export$19db0165690c701a(new $97ffb09cc3d11a32$export$a2bc3c1c57b6e07({
                        leftParent: p,
                        orn: orn
                    }));
                };
            }))(function(fromLeft) {
                return $9f7acf93d681eed3$var$bind1($9f7acf93d681eed3$export$30e63cab3d0e49ae(v.fromRight)(function(p) {
                    return function(orn) {
                        return new $7d4cccdf062a2261$export$19db0165690c701a(new $97ffb09cc3d11a32$export$a420550a5202c987({
                            rightParent: p,
                            orn: orn
                        }));
                    };
                }))(function(fromRight) {
                    var unexplained = $9f7acf93d681eed3$var$map(function(note) {
                        return {
                            note: note,
                            expl: $97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value
                        };
                    })(v.unexplained);
                    return $9f7acf93d681eed3$var$pure1($97ffb09cc3d11a32$export$eb09cde4717acf6b($9f7acf93d681eed3$var$append(regular)($9f7acf93d681eed3$var$append(passing)($9f7acf93d681eed3$var$append(fromLeft)($9f7acf93d681eed3$var$append(fromRight)(unexplained))))));
                });
            });
        });
    });
};



var $2b7582913558f260$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($97ffb09cc3d11a32$export$2cda0bd0f22dfe3e);
var $2b7582913558f260$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $2b7582913558f260$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $2b7582913558f260$var$bindStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$f28534bdc7259c7($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $2b7582913558f260$var$discard1 = /* #__PURE__ */ $2b7582913558f260$var$discard($2b7582913558f260$var$bindStateT);
var $2b7582913558f260$var$monadStateStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$fc3b89a546fa5c5c($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $2b7582913558f260$var$modify_ = /* #__PURE__ */ $f2d5035ce6148af6$export$45b91115a89d6020($2b7582913558f260$var$monadStateStateT);
var $2b7582913558f260$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97ffb09cc3d11a32$export$566951113c2c5ddd);
var $2b7582913558f260$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b7582913558f260$var$bindStateT);
var $2b7582913558f260$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($e9bda291f4ec10ec$export$5e0a9e9fea50cb88)($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $2b7582913558f260$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $e9bda291f4ec10ec$export$5cbc630d6fbe2e14($7d4cccdf062a2261$export$b3b4ecb28e3a8df3));
var $2b7582913558f260$var$max1 = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97ffb09cc3d11a32$export$b51fa3f60ce66bf3);
var $2b7582913558f260$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $2b7582913558f260$var$eqRec = /* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e();
var $2b7582913558f260$var$eqRowCons = /* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0($37b880af5f4991bd$export$d12253326f924cb1)();
var $2b7582913558f260$var$pitchIsSymbol = {
    reflectSymbol: function() {
        return "pitch";
    }
};
var $2b7582913558f260$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $2b7582913558f260$var$eqStartStop = /* #__PURE__ */ $97ffb09cc3d11a32$export$94c928892198f7f9(/* #__PURE__ */ $2b7582913558f260$var$eqRec(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $2b7582913558f260$var$eqRowCons($2b7582913558f260$var$pitchIsSymbol)(/* #__PURE__ */ $6416bd93bb20ed95$export$5146a69d60451857($364547bd6bbe186e$export$66d6281a18f726a9)))()($2b7582913558f260$var$idIsSymbol)($37b880af5f4991bd$export$fa624555ca2acbc8)));
var $2b7582913558f260$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($2b7582913558f260$var$eqStartStop);
var $2b7582913558f260$var$modify = /* #__PURE__ */ $f2d5035ce6148af6$export$3ff57735a52b8713($2b7582913558f260$var$monadStateStateT);
var $2b7582913558f260$var$ordRecord = /* #__PURE__ */ $97937c29f879e68e$export$ebb7a7956d139174();
var $2b7582913558f260$var$ordRecordCons = /* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611($97937c29f879e68e$export$927f7db8ecc0069f)();
var $2b7582913558f260$var$rightIsSymbol = {
    reflectSymbol: function() {
        return "right";
    }
};
var $2b7582913558f260$var$ordRecord1 = /* #__PURE__ */ $2b7582913558f260$var$ordRecord(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $2b7582913558f260$var$ordRecordCons($2b7582913558f260$var$pitchIsSymbol)(/* #__PURE__ */ $6416bd93bb20ed95$export$cddf5df7d4d146c7($364547bd6bbe186e$export$aa156b69905f503)))()($2b7582913558f260$var$idIsSymbol)($97937c29f879e68e$export$c5f2758e49b2b86a));
var $2b7582913558f260$var$ordStartStop = /* #__PURE__ */ $97ffb09cc3d11a32$export$51153a4951aa543e($2b7582913558f260$var$ordRecord1);
var $2b7582913558f260$var$leftIsSymbol = {
    reflectSymbol: function() {
        return "left";
    }
};
var $2b7582913558f260$var$ordRecord2 = /* #__PURE__ */ $2b7582913558f260$var$ordRecord(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $2b7582913558f260$var$ordRecordCons($2b7582913558f260$var$rightIsSymbol)($2b7582913558f260$var$ordStartStop))()($2b7582913558f260$var$leftIsSymbol)($2b7582913558f260$var$ordStartStop));
var $2b7582913558f260$var$fromFoldable = /* #__PURE__ */ $a393155e52307a24$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593)($2b7582913558f260$var$ordRecord2);
var $2b7582913558f260$var$bind2 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $2b7582913558f260$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $2b7582913558f260$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88(/* #__PURE__ */ $e9bda291f4ec10ec$export$d5449d946db19e3a($7d4cccdf062a2261$export$f0a413d3d6075601));
var $2b7582913558f260$var$fromFoldable1 = /* #__PURE__ */ $3d4fd987da5242ff$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $2b7582913558f260$var$pure2 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $e9bda291f4ec10ec$export$5cbc630d6fbe2e14($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $2b7582913558f260$var$bindStateT1 = /* #__PURE__ */ $e9bda291f4ec10ec$export$f28534bdc7259c7($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $2b7582913558f260$var$bind3 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b7582913558f260$var$bindStateT1);
var $2b7582913558f260$var$discard2 = /* #__PURE__ */ $2b7582913558f260$var$discard($2b7582913558f260$var$bindStateT1);
var $2b7582913558f260$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $2b7582913558f260$var$monadStateStateT1 = /* #__PURE__ */ $e9bda291f4ec10ec$export$fc3b89a546fa5c5c($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $2b7582913558f260$var$modify_1 = /* #__PURE__ */ $f2d5035ce6148af6$export$45b91115a89d6020($2b7582913558f260$var$monadStateStateT1);
var $2b7582913558f260$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $2b7582913558f260$var$fromFoldable2 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($a393155e52307a24$export$fd19c21b7e75dff0);
var $2b7582913558f260$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$export$d751c43805353ae1);
var $2b7582913558f260$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $2b7582913558f260$var$fromFoldableWith = /* #__PURE__ */ $ea3eb84de0acf574$export$690be49d504fc7f($2b7582913558f260$var$ordRecord1);
var $2b7582913558f260$var$fromFoldableWith1 = /* #__PURE__ */ $2b7582913558f260$var$fromFoldableWith($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $2b7582913558f260$var$append2 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($9f7acf93d681eed3$export$239377e00bd1bdaa);
var $2b7582913558f260$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $2b7582913558f260$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($97ffb09cc3d11a32$export$b7b46b55fac1096f));
var $2b7582913558f260$var$bind4 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($70cd3177464e7915$export$794f9574ca20b986);
var $2b7582913558f260$var$fromFoldable3 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $2b7582913558f260$var$discard3 = /* #__PURE__ */ $2b7582913558f260$var$discard($70cd3177464e7915$export$794f9574ca20b986);
var $2b7582913558f260$var$guard = /* #__PURE__ */ $f1992c51575cdea6$export$864d727b48066337($f1992c51575cdea6$export$5e87c78e215371ee);
var $2b7582913558f260$var$pure3 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($c50cfdb0b9e8fa31$export$8f0ac76856b1d87e);
var $2b7582913558f260$var$fromFoldableWith2 = /* #__PURE__ */ $ea3eb84de0acf574$export$690be49d504fc7f($2b7582913558f260$var$ordRecord2)($78c799cba34fcb8d$export$92659ee1fc91a075);
var $2b7582913558f260$var$fromFoldableWith3 = /* #__PURE__ */ $2b7582913558f260$var$fromFoldableWith($78c799cba34fcb8d$export$92659ee1fc91a075);
var $2b7582913558f260$var$difference = /* #__PURE__ */ $396c4c3d9e7fae3c$export$acaf96a27438246b(/* #__PURE__ */ $2b7582913558f260$var$eqRec(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $2b7582913558f260$var$eqRowCons($2b7582913558f260$var$rightIsSymbol)($2b7582913558f260$var$eqStartStop))()($2b7582913558f260$var$leftIsSymbol)($2b7582913558f260$var$eqStartStop)));
var $2b7582913558f260$var$passingIsSymbol = {
    reflectSymbol: function() {
        return "passing";
    }
};
var $2b7582913558f260$var$regularIsSymbol = {
    reflectSymbol: function() {
        return "regular";
    }
};
var $2b7582913558f260$var$append3 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d(/* #__PURE__ */ $d7bf9817a417d4ae$export$dbfe6b321632d7c9()(/* #__PURE__ */ $d7bf9817a417d4ae$export$74eae24c3d2a7535($2b7582913558f260$var$passingIsSymbol)()(/* #__PURE__ */ $d7bf9817a417d4ae$export$74eae24c3d2a7535($2b7582913558f260$var$regularIsSymbol)()($d7bf9817a417d4ae$export$955753116dc9242c)(/* #__PURE__ */ $a393155e52307a24$export$7c6a06df4f9b9fb3($2b7582913558f260$var$ordRecord2)))($d7bf9817a417d4ae$export$d082f07d0a8e9909)));
var $2b7582913558f260$var$fold = /* #__PURE__ */ $4fe7b6acfba7f29f$export$93e2b83da34ff82a($4fe7b6acfba7f29f$export$e97014618a7eb593)(/* #__PURE__ */ $784e1bd3d26d71da$export$b6526a2ab5064058()(/* #__PURE__ */ $784e1bd3d26d71da$export$d672019c76a5af4a($2b7582913558f260$var$passingIsSymbol)($784e1bd3d26d71da$export$db307f59121ffcc4)()(/* #__PURE__ */ $784e1bd3d26d71da$export$d672019c76a5af4a($2b7582913558f260$var$regularIsSymbol)(/* #__PURE__ */ $a393155e52307a24$export$30c0d87180d1a2c7($2b7582913558f260$var$ordRecord2))()($784e1bd3d26d71da$export$254fca207e30c208))));
var $2b7582913558f260$var$insert = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($97ffb09cc3d11a32$export$566951113c2c5ddd);
var $2b7582913558f260$var$max2 = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$5ed021ff2336715c);
var $2b7582913558f260$var$insert1 = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($97ffb09cc3d11a32$export$b51fa3f60ce66bf3);
var $2b7582913558f260$var$gets = /* #__PURE__ */ $f2d5035ce6148af6$export$49487f6cbb79019d($2b7582913558f260$var$monadStateStateT1);
var $2b7582913558f260$export$404386694049c788 = /* #__PURE__ */ function() {
    function ET(value0) {
        this.value0 = value0;
    }
    ET.create = function(value0) {
        return new ET(value0);
    };
    return ET;
}();
var $2b7582913558f260$export$f3cd9e7086501418 = /* #__PURE__ */ function() {
    function EN(value0) {
        this.value0 = value0;
    }
    EN.create = function(value0) {
        return new EN(value0);
    };
    return EN;
}();
var $2b7582913558f260$export$20e28a5cfb7c13df = /* #__PURE__ */ function() {
    function ER(value0) {
        this.value0 = value0;
    }
    ER.create = function(value0) {
        return new ER(value0);
    };
    return ER;
}();
var $2b7582913558f260$export$7661074c4d5be256 = /* #__PURE__ */ function() {
    function EL(value0) {
        this.value0 = value0;
    }
    EL.create = function(value0) {
        return new EL(value0);
    };
    return EL;
}();
var $2b7582913558f260$export$6a1b29f3b092916b = function(dictFoldable) {
    var select = function(v) {
        return function(v1) {
            if (v1 instanceof $2b7582913558f260$export$404386694049c788) return {
                t: new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v.t),
                n: v.n,
                r: v.r,
                l: v.l
            };
            if (v1 instanceof $2b7582913558f260$export$f3cd9e7086501418) return {
                t: v.t,
                n: new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v.n),
                r: v.r,
                l: v.l
            };
            if (v1 instanceof $2b7582913558f260$export$20e28a5cfb7c13df) return {
                t: v.t,
                n: v.n,
                r: new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v.r),
                l: v.l
            };
            if (v1 instanceof $2b7582913558f260$export$7661074c4d5be256) return {
                t: v.t,
                n: v.n,
                r: v.r,
                l: new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v.l)
            };
            throw new Error("Failed pattern match at ProtoVoices.Folding (line 254, column 27 - line 258, column 36): " + [
                v1.constructor.name
            ]);
        };
    };
    return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable)(select)({
        t: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        n: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        r: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        l: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
    });
};
var $2b7582913558f260$var$partitionElaborations1 = /* #__PURE__ */ $2b7582913558f260$export$6a1b29f3b092916b($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $2b7582913558f260$export$e835df75c3914978 = function(seg) {
    return {
        seg: seg,
        more: $05149ea687d6b460$export$523c0b569236b342
    };
};
var $2b7582913558f260$export$a34f3c836110a57b = function(topSegments) {
    return function(deriv) {
        var startSlice = {
            id: 0,
            x: 0.0,
            notes: $97ffb09cc3d11a32$export$568b89e600fc77eb.value,
            parents: $97ffb09cc3d11a32$export$914e87441b58d7d9.value
        };
        var prepareTop = function(v) {
            return {
                transId: v.trans.id,
                rslice: {
                    id: v.rslice.id,
                    parents: $97ffb09cc3d11a32$export$914e87441b58d7d9.value,
                    notes: $2b7582913558f260$var$map($2b7582913558f260$var$map1(function(note) {
                        return {
                            note: note,
                            expl: $97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value
                        };
                    }))(v.rslice.notes)
                }
            };
        };
        var prepareSplit = function(leftSliceId) {
            return function(top) {
                return function(v) {
                    return $2b7582913558f260$var$discard1($2b7582913558f260$var$modify_(function(st) {
                        var $230 = {};
                        for(var $231 in st)if (({}).hasOwnProperty.call(st, $231)) $230[$231] = st[$231];
                        $230.maxT = $2b7582913558f260$var$max(st.maxT)(top.transId);
                        return $230;
                    }))(function() {
                        return $2b7582913558f260$var$bind($2b7582913558f260$var$lift($9f7acf93d681eed3$export$71d66b563b92862f(v)))(function(childNotes) {
                            var childrTop = {
                                transId: v.ids.right,
                                rslice: top.rslice
                            };
                            var childSlice = {
                                id: v.ids.slice,
                                notes: new $97ffb09cc3d11a32$export$f63ba74aa66682be(childNotes),
                                parents: new $97ffb09cc3d11a32$export$a56b005ab5275675({
                                    left: leftSliceId,
                                    right: top.rslice.id
                                })
                            };
                            var childlTop = {
                                transId: v.ids.left,
                                rslice: childSlice
                            };
                            return $2b7582913558f260$var$pure({
                                childlTop: childlTop,
                                childrTop: childrTop
                            });
                        });
                    });
                };
            };
        };
        var prepareHori = function(topl) {
            return function(topr) {
                return function(v) {
                    return $2b7582913558f260$var$discard1($2b7582913558f260$var$modify_(function(st) {
                        var $236 = {};
                        for(var $237 in st)if (({}).hasOwnProperty.call(st, $237)) $236[$237] = st[$237];
                        $236.maxT = $2b7582913558f260$var$max(st.maxT)($2b7582913558f260$var$max(topl.transId)(topr.transId));
                        $236.maxS = $2b7582913558f260$var$max1(st.maxS)(topl.rslice.id);
                        return $236;
                    }))(function() {
                        var childrTop = {
                            transId: v.ids.right,
                            rslice: topr.rslice
                        };
                        var childmTop = {
                            transId: v.ids.mid,
                            rslice: {
                                id: v.ids.rslice,
                                notes: new $97ffb09cc3d11a32$export$f63ba74aa66682be($9f7acf93d681eed3$export$eb7334032a0d7c45(v)),
                                parents: new $97ffb09cc3d11a32$export$a94683cf162a309e(topl.rslice.id)
                            }
                        };
                        var childlTop = {
                            transId: v.ids.left,
                            rslice: {
                                id: v.ids.lslice,
                                notes: new $97ffb09cc3d11a32$export$f63ba74aa66682be($9f7acf93d681eed3$export$f6cd62fbb5249983(v)),
                                parents: new $97ffb09cc3d11a32$export$a94683cf162a309e(topl.rslice.id)
                            }
                        };
                        return $2b7582913558f260$var$pure({
                            childlTop: childlTop,
                            childmTop: childmTop,
                            childrTop: childrTop
                        });
                    });
                };
            };
        };
        var freeze = function(lslice) {
            return function(v) {
                return function(v1) {
                    var holdNote = function(v2) {
                        var hold = $2b7582913558f260$var$bind1($396c4c3d9e7fae3c$export$71aa6c912b956294(function(v3) {
                            return $2b7582913558f260$var$eq(v3.left)(new $97ffb09cc3d11a32$export$f63ba74aa66682be(v2.note));
                        })(v.ties))(function(edge) {
                            return $2b7582913558f260$var$bind1($97ffb09cc3d11a32$export$d262b423ef7122a5(edge.right))(function(right) {
                                return new $06733ae99ed4f534$export$8a67b48435b5d073(right.id);
                            });
                        });
                        return {
                            note: v2.note,
                            hold: hold
                        };
                    };
                    var pieceNotes = $2b7582913558f260$var$map1(holdNote)($97ffb09cc3d11a32$export$eb09cde4717acf6b($97ffb09cc3d11a32$export$a45279548abf4fad(lslice)));
                    return $2b7582913558f260$var$bind($2b7582913558f260$var$modify(function(st) {
                        var $246 = {};
                        for(var $247 in st)if (({}).hasOwnProperty.call(st, $247)) $246[$247] = st[$247];
                        $246.x = st.x + 1.0;
                        $246.maxT = $2b7582913558f260$var$max(st.maxT)(v1.transId);
                        $246.maxS = $2b7582913558f260$var$max1(st.maxS)(v1.rslice.id);
                        $246.piece = $396c4c3d9e7fae3c$export$c40cf5aab899f397(st.piece)({
                            notes: pieceNotes,
                            time: v.prevTime
                        });
                        return $246;
                    }))(function(st) {
                        return $2b7582913558f260$var$pure({
                            trans: {
                                id: v1.transId,
                                edges: {
                                    passing: [],
                                    regular: $2b7582913558f260$var$fromFoldable(v.ties)
                                },
                                is2nd: false
                            },
                            rslice: {
                                id: v1.rslice.id,
                                notes: v1.rslice.notes,
                                parents: v1.rslice.parents,
                                x: st.x
                            },
                            op: $97ffb09cc3d11a32$export$f0826af67a39ec5d.value
                        });
                    });
                };
            };
        };
        var completeSplit = function(top) {
            return function(childl) {
                return function(childr) {
                    return {
                        trans: {
                            id: top.transId,
                            edges: $97ffb09cc3d11a32$export$c70a271fb26a581d(childl.rslice),
                            is2nd: childl.trans.is2nd
                        },
                        rslice: childr.rslice,
                        op: new $97ffb09cc3d11a32$export$f836382419f64c98({
                            childl: childl,
                            childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(childr)
                        })
                    };
                };
            };
        };
        var completeHori = function(topl) {
            return function(topr) {
                return function(childl) {
                    return function(childm) {
                        return function(childr) {
                            var topSlice = {
                                id: topl.rslice.id,
                                notes: topl.rslice.notes,
                                parents: topl.rslice.parents,
                                x: (childl.rslice.x + childm.rslice.x) / 2.0
                            };
                            return $2b7582913558f260$var$bind2($97ffb09cc3d11a32$export$17c4d6d9c222c6dd(childl.trans.edges)(childl.rslice))(function(edgesL) {
                                return $2b7582913558f260$var$bind2($97ffb09cc3d11a32$export$a1caa2c4f72b5f4f(childr.trans.edges)(childm.rslice))(function(edgesR) {
                                    var segr = {
                                        trans: {
                                            id: topr.transId,
                                            edges: edgesR,
                                            is2nd: true
                                        },
                                        rslice: childr.rslice,
                                        op: $97ffb09cc3d11a32$export$f0826af67a39ec5d.value
                                    };
                                    var segl = {
                                        trans: {
                                            id: topl.transId,
                                            edges: edgesL,
                                            is2nd: false
                                        },
                                        rslice: topSlice,
                                        op: new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                            childl: childl,
                                            childm: childm,
                                            childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(childr)
                                        })
                                    };
                                    return $2b7582913558f260$var$pure1({
                                        segl: segl,
                                        segr: segr
                                    });
                                });
                            });
                        };
                    };
                };
            };
        };
        var go = function(v) {
            return function(v1) {
                return function(v2) {
                    if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $2b7582913558f260$var$pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
                    if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        if (v1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                            if (v2.value0 instanceof $9f7acf93d681eed3$export$9217dfcc08ac2e7d) return $2b7582913558f260$var$bind(freeze(v)(v2.value0.value0)(v1.value0))(function(top$prime) {
                                return $2b7582913558f260$var$map2($78c799cba34fcb8d$export$74c44e616647f5c0.create(top$prime))(go(top$prime.rslice)(v1.value1)(v2.value1));
                            });
                            if (v2.value0 instanceof $9f7acf93d681eed3$export$6d38f18d731c7d88) return $2b7582913558f260$var$bind(prepareSplit(v.id)(v1.value0)(v2.value0.value0))(function(v3) {
                                return $2b7582913558f260$var$bind(go(v)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.childlTop, new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.childrTop, v1.value1)))(v2.value1))(function(segs) {
                                    if (segs instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && segs.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $2b7582913558f260$var$pure(new $78c799cba34fcb8d$export$74c44e616647f5c0(completeSplit(v1.value0)(segs.value0)(segs.value1.value0), segs.value1.value1));
                                    return $2b7582913558f260$var$lift(new $7d4cccdf062a2261$export$37c4d04eafdc5515("Operations after splitLeft do not fit!"));
                                });
                            });
                            if (v2.value0 instanceof $9f7acf93d681eed3$export$c71f04b0722025ea) return $2b7582913558f260$var$bind(prepareSplit(v1.value0.rslice.id)(v1.value1.value0)(v2.value0.value0))(function(v3) {
                                return $2b7582913558f260$var$bind(go(v)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.childlTop, new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.childrTop, v1.value1.value1))))(v2.value1))(function(segs) {
                                    if (segs instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && segs.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && segs.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $2b7582913558f260$var$pure(new $78c799cba34fcb8d$export$74c44e616647f5c0(segs.value0, new $78c799cba34fcb8d$export$74c44e616647f5c0(completeSplit(v1.value1.value0)(segs.value1.value0)(segs.value1.value1.value0), segs.value1.value1.value1)));
                                    return $2b7582913558f260$var$lift(new $7d4cccdf062a2261$export$37c4d04eafdc5515("Operations after splitRight do not fit!"));
                                });
                            });
                            if (v2.value0 instanceof $9f7acf93d681eed3$export$110679fb554a6348) return $2b7582913558f260$var$bind(prepareHori(v1.value0)(v1.value1.value0)(v2.value0.value0))(function(v3) {
                                return $2b7582913558f260$var$bind(go(v)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.childlTop, new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.childmTop, new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.childrTop, v1.value1.value1))))(v2.value1))(function(segs) {
                                    if (segs instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && segs.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && segs.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $2b7582913558f260$var$bind($2b7582913558f260$var$lift(completeHori(v1.value0)(v1.value1.value0)(segs.value0)(segs.value1.value0)(segs.value1.value1.value0)))(function(v4) {
                                        return $2b7582913558f260$var$pure(new $78c799cba34fcb8d$export$74c44e616647f5c0(v4.segl, new $78c799cba34fcb8d$export$74c44e616647f5c0(v4.segr, segs.value1.value1.value1)));
                                    });
                                    return $2b7582913558f260$var$lift(new $7d4cccdf062a2261$export$37c4d04eafdc5515("Operations after hori do not fit!"));
                                });
                            });
                            return $2b7582913558f260$var$lift(new $7d4cccdf062a2261$export$37c4d04eafdc5515("Applying a single-transition operation while several transitions are left!"));
                        }
                        if (v1.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                            if (v2.value0 instanceof $9f7acf93d681eed3$export$6c6c4036f610eb1a) return $2b7582913558f260$var$bind(freeze(v)(v2.value0.value0)(v1.value0))(function(seg) {
                                return $2b7582913558f260$var$pure(new $78c799cba34fcb8d$export$74c44e616647f5c0(seg, $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
                            });
                            if (v2.value0 instanceof $9f7acf93d681eed3$export$5b281e53a92c7796) return $2b7582913558f260$var$bind(prepareSplit(v.id)(v1.value0)(v2.value0.value0))(function(v3) {
                                return $2b7582913558f260$var$bind(go(v)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.childlTop, new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.childrTop, $78c799cba34fcb8d$export$c1bed610ade55e1c.value)))(v2.value1))(function(segs) {
                                    if (segs instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && segs.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && segs.value1.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $2b7582913558f260$var$pure(new $78c799cba34fcb8d$export$74c44e616647f5c0(completeSplit(v1.value0)(segs.value0)(segs.value1.value0), $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
                                    return $2b7582913558f260$var$lift(new $7d4cccdf062a2261$export$37c4d04eafdc5515("Operations after splitOnly do not fit!"));
                                });
                            });
                            return $2b7582913558f260$var$lift(new $7d4cccdf062a2261$export$37c4d04eafdc5515("Applying a non-single operation to a single transition!"));
                        }
                        throw new Error("Failed pattern match at ProtoVoices.Folding (line 420, column 48 - line 458, column 84): " + [
                            v1.value1.constructor.name
                        ]);
                    }
                    return $2b7582913558f260$var$lift(new $7d4cccdf062a2261$export$37c4d04eafdc5515("Lengths of top-level and derivation do not match!"));
                };
            };
        };
        return $2b7582913558f260$var$bind2($e9bda291f4ec10ec$export$c5ba8a89d9140c32(go(startSlice)($2b7582913558f260$var$fromFoldable1($2b7582913558f260$var$map1(prepareTop)(topSegments)))($2b7582913558f260$var$fromFoldable1(deriv)))({
            maxS: 0,
            maxT: 0,
            x: 0.0,
            piece: []
        }))(function(v) {
            return $2b7582913558f260$var$pure1({
                reduction: {
                    start: startSlice,
                    segments: v.value0,
                    nextSliceId: $97ffb09cc3d11a32$export$3b674933b866e4e6(v.value1.maxS),
                    nextTransId: $97ffb09cc3d11a32$export$789865d9636612d2(v.value1.maxT)
                },
                piece: $06733ae99ed4f534$export$43db023a260c5e9f([])($396c4c3d9e7fae3c$export$c01875f616615628(v.value1.piece))
            });
        });
    };
};
var $2b7582913558f260$export$54302a91ad4b95a6 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $2b7582913558f260$var$pure2($05149ea687d6b460$export$523c0b569236b342);
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                if (v2.value0.seg.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return v.freezeOnly(v1)(v2.value0);
                if (v2.value0.seg.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return $2b7582913558f260$var$bind3(v.splitOnly(v1)(v2.value0)(v2.value0.seg.op.value0))(function(children) {
                    return $2b7582913558f260$export$54302a91ad4b95a6(v)(v1)(children);
                });
                if (v2.value0.seg.op instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) return $2b7582913558f260$var$pure2($05149ea687d6b460$export$523c0b569236b342);
                throw new Error("Failed pattern match at ProtoVoices.Folding (line 59, column 3 - line 64, column 24): " + [
                    v2.value0.seg.op.constructor.name
                ]);
            }
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                if (v2.value0.seg.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return $2b7582913558f260$var$discard2(v.freezeLeft(v1)(v2.value0))(function() {
                    return $2b7582913558f260$export$54302a91ad4b95a6(v)(v2.value0.seg.rslice)(v2.value1);
                });
                if (v2.value0.seg.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return $2b7582913558f260$var$bind3(v.splitLeft(v1)(v2.value0)(v2.value0.seg.op.value0))(function(children) {
                    return $2b7582913558f260$export$54302a91ad4b95a6(v)(v1)($2b7582913558f260$var$append(children)(v2.value1));
                });
                if (v2.value0.seg.op instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) {
                    if (v2.value1.value0.seg.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return $2b7582913558f260$var$bind3(v.splitRight(v1)(v2.value0)(v2.value1.value0)(v2.value1.value0.seg.op.value0))(function(children) {
                        return $2b7582913558f260$export$54302a91ad4b95a6(v)(v1)($2b7582913558f260$var$append(new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, children))(v2.value1.value1));
                    });
                    return $2b7582913558f260$var$bind3(v.hori(v1)(v2.value0)(v2.value1.value0)(v2.value0.seg.op.value0))(function(children) {
                        return $2b7582913558f260$export$54302a91ad4b95a6(v)(v1)($2b7582913558f260$var$append(children)(v2.value1.value1));
                    });
                }
                throw new Error("Failed pattern match at ProtoVoices.Folding (line 69, column 3 - line 86, column 55): " + [
                    v2.value0.seg.op.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at ProtoVoices.Folding (line 48, column 1 - line 53, column 21): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $2b7582913558f260$export$7f8c26f2ad3722d6 = function(alg) {
    return function(start) {
        return function(agenda) {
            return $2b7582913558f260$var$discard2(alg.init(start))(function() {
                return $2b7582913558f260$export$54302a91ad4b95a6(alg)(start)(agenda);
            });
        };
    };
};
var $2b7582913558f260$export$d7a6cd6c2f9dff1 = function(v) {
    var lmAlg = function() {
        var modifyEither = function($483) {
            return $2b7582913558f260$var$modify_1($2b7582913558f260$var$bindFlipped($483));
        };
        var mkFreeze = function(seg) {
            return function(time) {
                return {
                    ties: $2b7582913558f260$var$fromFoldable2(seg.trans.edges.regular),
                    prevTime: time
                };
            };
        };
        var getUnexplained = function(slice) {
            return $2b7582913558f260$var$map1(function(v1) {
                return v1.note;
            })($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(v1) {
                return $2b7582913558f260$var$eq1(v1.expl)($97ffb09cc3d11a32$export$7a00a90b2dd67bbb.value);
            })($97ffb09cc3d11a32$export$a45279548abf4fad(slice)));
        };
        var mkHori = function(childl) {
            return function(childm) {
                return function(childr) {
                    var horiChild = function(wrapper) {
                        return function(v1) {
                            if (v1.expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.expl.value0, wrapper(v1.note)));
                            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        };
                    };
                    var children = $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($2b7582913558f260$var$append1($2b7582913558f260$var$map1(horiChild($9f7acf93d681eed3$export$ecb083e2cbcb5bfb.create))($97ffb09cc3d11a32$export$a45279548abf4fad(childl.rslice)))($2b7582913558f260$var$map1(horiChild($9f7acf93d681eed3$export$30956f4b4aafa87e.create))($97ffb09cc3d11a32$export$a45279548abf4fad(childm.rslice))));
                    return {
                        children: $2b7582913558f260$var$fromFoldableWith1($2b7582913558f260$var$append2)(children),
                        midEdges: childm.trans.edges,
                        ids: {
                            left: childl.trans.id,
                            lslice: childl.rslice.id,
                            mid: childm.trans.id,
                            rslice: childm.rslice.id,
                            right: childr.trans.id
                        },
                        unexplained: {
                            left: getUnexplained(childl.rslice),
                            right: getUnexplained(childm.rslice)
                        }
                    };
                };
            };
        };
        var hori = function(v1) {
            return function(v2) {
                return function(v3) {
                    return function(v4) {
                        return $2b7582913558f260$var$discard2(modifyEither(function(st) {
                            return new $7d4cccdf062a2261$export$19db0165690c701a(function() {
                                var $349 = {};
                                for(var $350 in st)if (({}).hasOwnProperty.call(st, $350)) $349[$350] = st[$350];
                                $349.lm = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $9f7acf93d681eed3$export$110679fb554a6348(mkHori(v4.childl)(v4.childm)(v4.childr)), st.lm);
                                return $349;
                            }());
                        }))(function() {
                            return $2b7582913558f260$var$pure2($2b7582913558f260$var$map3($2b7582913558f260$export$e835df75c3914978)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v4.childl, new $78c799cba34fcb8d$export$74c44e616647f5c0(v4.childm, new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(v4.childr)(v3.seg.rslice), $78c799cba34fcb8d$export$c1bed610ade55e1c.value)))));
                        });
                    };
                };
            };
        };
        var mkSplit = function(childl) {
            return function(childr) {
                var getElaboration = function(n) {
                    if (n.expl instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) {
                        var $357 = $2b7582913558f260$var$eq2(n.expl.value0.orn)(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$dab08a4db0f3867f.value)) || $2b7582913558f260$var$eq2(n.expl.value0.orn)(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$9cce9eb8c466c42b.value)) || $2b7582913558f260$var$eq2(n.expl.value0.orn)(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$b62f635e41790a80.value));
                        if ($357) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $2b7582913558f260$export$f3cd9e7086501418(new $71f2e2e9476163f8$export$1908877435b1d5e9({
                            left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(n.expl.value0.leftParent),
                            right: new $97ffb09cc3d11a32$export$f63ba74aa66682be(n.expl.value0.rightParent)
                        }, [
                            {
                                child: n.note,
                                orn: n.expl.value0.orn
                            }
                        ])));
                        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $2b7582913558f260$export$404386694049c788(new $71f2e2e9476163f8$export$1908877435b1d5e9({
                            left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(n.expl.value0.leftParent),
                            right: new $97ffb09cc3d11a32$export$f63ba74aa66682be(n.expl.value0.rightParent)
                        }, [
                            {
                                child: n.note,
                                orn: new $7d4cccdf062a2261$export$19db0165690c701a(n.expl.value0.orn)
                            }
                        ])));
                    }
                    if (n.expl instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $2b7582913558f260$export$20e28a5cfb7c13df(new $71f2e2e9476163f8$export$1908877435b1d5e9(n.expl.value0.leftParent, [
                        {
                            child: n.note,
                            orn: n.expl.value0.orn
                        }
                    ])));
                    if (n.expl instanceof $97ffb09cc3d11a32$export$a420550a5202c987) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $2b7582913558f260$export$7661074c4d5be256(new $71f2e2e9476163f8$export$1908877435b1d5e9(n.expl.value0.rightParent, [
                        {
                            child: n.note,
                            orn: n.expl.value0.orn
                        }
                    ])));
                    if (n.expl instanceof $97ffb09cc3d11a32$export$2cf876164813516f) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $2b7582913558f260$export$404386694049c788(new $71f2e2e9476163f8$export$1908877435b1d5e9({
                        left: $97ffb09cc3d11a32$export$568b89e600fc77eb.value,
                        right: $97ffb09cc3d11a32$export$ac4156b3386a7c70.value
                    }, [
                        {
                            child: n.note,
                            orn: new $7d4cccdf062a2261$export$37c4d04eafdc5515($9f7acf93d681eed3$export$6df59be1acc9acf0.value)
                        }
                    ])));
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                };
                var v1 = $2b7582913558f260$var$partitionElaborations1($396c4c3d9e7fae3c$export$986c2bbe7a34be0b($2b7582913558f260$var$map1(getElaboration)($97ffb09cc3d11a32$export$a45279548abf4fad(childl.rslice))));
                var prs = $2b7582913558f260$var$bind4($2b7582913558f260$var$fromFoldable3(v1.n))(function(v2) {
                    return $2b7582913558f260$var$bind4(v2.value1)(function(child) {
                        return $2b7582913558f260$var$discard3($2b7582913558f260$var$guard($2b7582913558f260$var$eq2(child.orn)(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$dab08a4db0f3867f.value))))(function() {
                            return $2b7582913558f260$var$pure3({
                                left: new $97ffb09cc3d11a32$export$f63ba74aa66682be(child.child),
                                right: v2.value0.right
                            });
                        });
                    });
                });
                var pls = $2b7582913558f260$var$bind4($2b7582913558f260$var$fromFoldable3(v1.n))(function(v2) {
                    return $2b7582913558f260$var$bind4(v2.value1)(function(child) {
                        return $2b7582913558f260$var$discard3($2b7582913558f260$var$guard($2b7582913558f260$var$eq2(child.orn)(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$9cce9eb8c466c42b.value))))(function() {
                            return $2b7582913558f260$var$pure3({
                                left: v2.value0.left,
                                right: new $97ffb09cc3d11a32$export$f63ba74aa66682be(child.child)
                            });
                        });
                    });
                });
                return {
                    regular: $2b7582913558f260$var$fromFoldableWith2($2b7582913558f260$var$append1)(v1.t),
                    passing: $2b7582913558f260$var$fromFoldableWith2($2b7582913558f260$var$append1)(v1.n),
                    fromLeft: $2b7582913558f260$var$fromFoldableWith3($2b7582913558f260$var$append1)(v1.r),
                    fromRight: $2b7582913558f260$var$fromFoldableWith3($2b7582913558f260$var$append1)(v1.l),
                    unexplained: getUnexplained(childl.rslice),
                    keepLeft: $2b7582913558f260$var$fromFoldable2(childl.trans.edges.regular),
                    keepRight: $2b7582913558f260$var$fromFoldable2(childr.trans.edges.regular),
                    passLeft: $2b7582913558f260$var$difference(childl.trans.edges.passing)(pls),
                    passRight: $2b7582913558f260$var$difference(childr.trans.edges.passing)(prs),
                    ids: {
                        left: childl.trans.id,
                        slice: childl.rslice.id,
                        right: childr.trans.id
                    }
                };
            };
        };
        var splitLeft = function(v1) {
            return function(v2) {
                return function(v3) {
                    return $2b7582913558f260$var$discard2(modifyEither(function(st) {
                        return new $7d4cccdf062a2261$export$19db0165690c701a(function() {
                            var $382 = {};
                            for(var $383 in st)if (({}).hasOwnProperty.call(st, $383)) $382[$383] = st[$383];
                            $382.lm = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $9f7acf93d681eed3$export$6d38f18d731c7d88(mkSplit(v3.childl)(v3.childr)), st.lm);
                            return $382;
                        }());
                    }))(function() {
                        return $2b7582913558f260$var$pure2($2b7582913558f260$var$map3($2b7582913558f260$export$e835df75c3914978)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.childl, new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(v3.childr)(v2.seg.rslice), $78c799cba34fcb8d$export$c1bed610ade55e1c.value))));
                    });
                };
            };
        };
        var splitOnly = function(v1) {
            return function(v2) {
                return function(v3) {
                    return $2b7582913558f260$var$discard2(modifyEither(function(st) {
                        return new $7d4cccdf062a2261$export$19db0165690c701a(function() {
                            var $391 = {};
                            for(var $392 in st)if (({}).hasOwnProperty.call(st, $392)) $391[$392] = st[$392];
                            $391.lm = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $9f7acf93d681eed3$export$5b281e53a92c7796(mkSplit(v3.childl)(v3.childr)), st.lm);
                            return $391;
                        }());
                    }))(function() {
                        return $2b7582913558f260$var$pure2($2b7582913558f260$var$map3($2b7582913558f260$export$e835df75c3914978)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.childl, new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(v3.childr)(v2.seg.rslice), $78c799cba34fcb8d$export$c1bed610ade55e1c.value))));
                    });
                };
            };
        };
        var splitRight = function(v1) {
            return function(v2) {
                return function(v3) {
                    return function(v4) {
                        return $2b7582913558f260$var$discard2(modifyEither(function(st) {
                            return new $7d4cccdf062a2261$export$19db0165690c701a(function() {
                                var $401 = {};
                                for(var $402 in st)if (({}).hasOwnProperty.call(st, $402)) $401[$402] = st[$402];
                                $401.lm = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $9f7acf93d681eed3$export$c71f04b0722025ea(mkSplit(v4.childl)(v4.childr)), st.lm);
                                return $401;
                            }());
                        }))(function() {
                            return $2b7582913558f260$var$pure2($2b7582913558f260$var$map3($2b7582913558f260$export$e835df75c3914978)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v4.childl, new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(v4.childr)(v3.seg.rslice), $78c799cba34fcb8d$export$c1bed610ade55e1c.value))));
                        });
                    };
                };
            };
        };
        var freezeOnly = function(_lSlice) {
            return function(v1) {
                return modifyEither(function(st) {
                    if (st.piece instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Piece and reduction do not fit together: piece is too short!");
                    if (st.piece instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $7d4cccdf062a2261$export$19db0165690c701a(function() {
                        var $410 = {};
                        for(var $411 in st)if (({}).hasOwnProperty.call(st, $411)) $410[$411] = st[$411];
                        $410.lm = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $9f7acf93d681eed3$export$6c6c4036f610eb1a(mkFreeze(v1.seg)(st.piece.value0.time)), st.lm);
                        $410.piece = st.piece.value1;
                        return $410;
                    }());
                    throw new Error("Failed pattern match at ProtoVoices.Folding (line 348, column 27 - line 350, column 123): " + [
                        st.piece.constructor.name
                    ]);
                });
            };
        };
        var freezeLeft = function(_lSlice) {
            return function(v1) {
                return modifyEither(function(st) {
                    if (st.piece instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Piece and reduction do not fit together: piece is too short!");
                    if (st.piece instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $7d4cccdf062a2261$export$19db0165690c701a(function() {
                        var $419 = {};
                        for(var $420 in st)if (({}).hasOwnProperty.call(st, $420)) $419[$420] = st[$420];
                        $419.lm = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $9f7acf93d681eed3$export$9217dfcc08ac2e7d(mkFreeze(v1.seg)(st.piece.value0.time)), st.lm);
                        $419.piece = st.piece.value1;
                        return $419;
                    }());
                    throw new Error("Failed pattern match at ProtoVoices.Folding (line 353, column 27 - line 355, column 123): " + [
                        st.piece.constructor.name
                    ]);
                });
            };
        };
        return {
            init: function(v1) {
                return $2b7582913558f260$var$pure2($05149ea687d6b460$export$523c0b569236b342);
            },
            freezeOnly: freezeOnly,
            freezeLeft: freezeLeft,
            splitOnly: splitOnly,
            splitLeft: splitLeft,
            splitRight: splitRight,
            hori: hori
        };
    }();
    var agenda = $2b7582913558f260$var$map3($2b7582913558f260$export$e835df75c3914978)(v.reduction.segments);
    return $2b7582913558f260$var$bind2($f57f4b701aa7b66e$export$8a83211c878a3f1f($4a0611d0fc3e3eac$export$6feb49085bba08e4)(new $7d4cccdf062a2261$export$19db0165690c701a({
        lm: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        piece: new $78c799cba34fcb8d$export$74c44e616647f5c0({
            time: new $7d4cccdf062a2261$export$37c4d04eafdc5515(""),
            notes: []
        }, $2b7582913558f260$var$fromFoldable1(v.piece))
    }))($2b7582913558f260$export$7f8c26f2ad3722d6(lmAlg)(v.reduction.start)(agenda)))(function(st$prime) {
        return $2b7582913558f260$var$pure1($fc8c1182ec2aefec$export$66c1ae025e96b4bc($2b7582913558f260$var$fromFoldable3(st$prime.lm)));
    });
};
var $2b7582913558f260$export$89c077b968fc8691 = /* #__PURE__ */ function() {
    return {
        slices: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        transitions: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        horis: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        maxd: 0.0,
        maxx: 0.0,
        currentDepth: 0.0
    };
}();
var $2b7582913558f260$export$91909249ef847c8 = function(lslice) {
    return function(segr) {
        var edges$prime = $2b7582913558f260$var$append3(segr.trans.edges)($2b7582913558f260$var$fold($2b7582913558f260$var$map1($97ffb09cc3d11a32$export$dcfdd3e125058bb4)($97ffb09cc3d11a32$export$a45279548abf4fad(lslice))));
        return {
            rslice: segr.rslice,
            op: segr.op,
            trans: {
                id: segr.trans.id,
                is2nd: segr.trans.is2nd,
                edges: edges$prime
            }
        };
    };
};
var $2b7582913558f260$export$855500c39d5564ed = function(segl) {
    var edges$prime = $2b7582913558f260$var$append3(segl.trans.edges)($2b7582913558f260$var$fold($2b7582913558f260$var$map1($97ffb09cc3d11a32$export$ae35b1fbec78c70a)($97ffb09cc3d11a32$export$a45279548abf4fad(segl.rslice))));
    return {
        rslice: segl.rslice,
        op: segl.op,
        trans: {
            id: segl.trans.id,
            is2nd: segl.trans.is2nd,
            edges: edges$prime
        }
    };
};
var $2b7582913558f260$export$c3213ee7169ceb28 = function(showAllEdges) {
    return function(red) {
        var split = function(ag) {
            return function(v) {
                var segLeft = function() {
                    if (showAllEdges) return $2b7582913558f260$export$855500c39d5564ed(v.childl);
                    return v.childl;
                }();
                var childr$prime = $97ffb09cc3d11a32$export$a70c9112c133085b(v.childr)(ag.seg.rslice);
                var segRight = function() {
                    if (showAllEdges) return $2b7582913558f260$export$91909249ef847c8(v.childl.rslice)(childr$prime);
                    return childr$prime;
                }();
                return $2b7582913558f260$var$pure2($2b7582913558f260$var$map3($2b7582913558f260$export$e835df75c3914978)(new $78c799cba34fcb8d$export$74c44e616647f5c0(segLeft, new $78c799cba34fcb8d$export$74c44e616647f5c0(segRight, $78c799cba34fcb8d$export$c1bed610ade55e1c.value))));
            };
        };
        var hori = function(v) {
            return function(ag1) {
                return function(ag2) {
                    return function(v1) {
                        var childr$prime = function() {
                            var v2 = $97ffb09cc3d11a32$export$a70c9112c133085b(v1.childr)(ag2.seg.rslice);
                            return {
                                op: v2.op,
                                rslice: v2.rslice,
                                trans: {
                                    id: v2.trans.id,
                                    is2nd: v2.trans.is2nd,
                                    edges: $97ffb09cc3d11a32$export$2d73c5c06a3fd526(v1.childm.rslice)(ag2.seg.trans.edges)
                                }
                            };
                        }();
                        var childl$prime = {
                            rslice: v1.childl.rslice,
                            op: v1.childl.op,
                            trans: {
                                id: v1.childl.trans.id,
                                is2nd: v1.childl.trans.is2nd,
                                edges: $97ffb09cc3d11a32$export$fb357a9288b70024(ag1.seg.trans.edges)(v1.childl.rslice)
                            }
                        };
                        return $2b7582913558f260$var$pure2($2b7582913558f260$var$map3($2b7582913558f260$export$e835df75c3914978)(new $78c799cba34fcb8d$export$74c44e616647f5c0(childl$prime, new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.childm, new $78c799cba34fcb8d$export$74c44e616647f5c0(childr$prime, $78c799cba34fcb8d$export$c1bed610ade55e1c.value)))));
                    };
                };
            };
        };
        var freeze = function(_lslice) {
            return function(ag) {
                return $2b7582913558f260$var$modify_1(function(st) {
                    return {
                        slices: $396c4c3d9e7fae3c$export$c40cf5aab899f397(st.slices)(ag.seg.rslice),
                        transs: $396c4c3d9e7fae3c$export$c40cf5aab899f397(st.transs)(ag.seg.trans)
                    };
                });
            };
        };
        var surfaceAlg = {
            init: function(s) {
                return $2b7582913558f260$var$modify_1(function(st) {
                    var $440 = {};
                    for(var $441 in st)if (({}).hasOwnProperty.call(st, $441)) $440[$441] = st[$441];
                    $440.slices = $396c4c3d9e7fae3c$export$c40cf5aab899f397(st.slices)(s);
                    return $440;
                });
            },
            freezeLeft: freeze,
            freezeOnly: freeze,
            splitLeft: function(v) {
                return split;
            },
            splitOnly: function(v) {
                return split;
            },
            splitRight: function(v) {
                return function(v1) {
                    return split;
                };
            },
            hori: hori
        };
        var agenda = $2b7582913558f260$var$map3($2b7582913558f260$export$e835df75c3914978)(red.segments);
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f($4a0611d0fc3e3eac$export$6feb49085bba08e4)({
            slices: [],
            transs: []
        })($2b7582913558f260$export$7f8c26f2ad3722d6(surfaceAlg)(red.start)(agenda));
    };
};
var $2b7582913558f260$export$3ad9e11b1ad9ef77 = function(v) {
    return function(v1) {
        return $2b7582913558f260$var$modify_1(function(st) {
            var $445 = {};
            for(var $446 in st)if (({}).hasOwnProperty.call(st, $446)) $445[$446] = st[$446];
            $445.horis = new $78c799cba34fcb8d$export$74c44e616647f5c0({
                child: v.id,
                parent: v1.id
            }, st.horis);
            return $445;
        });
    };
};
var $2b7582913558f260$export$1ba3cf49f5354ea9 = function(il) {
    return function(v) {
        return function(ir) {
            return $2b7582913558f260$var$modify_1(function(st) {
                var $453 = {};
                for(var $454 in st)if (({}).hasOwnProperty.call(st, $454)) $453[$454] = st[$454];
                $453.transitions = $2b7582913558f260$var$insert(v.id)({
                    left: il,
                    right: ir,
                    id: v.id,
                    edges: v.edges
                })(st.transitions);
                return $453;
            });
        };
    };
};
var $2b7582913558f260$export$893e8f2624c1009b = function(slice) {
    return function(depth) {
        var gslice = {
            depth: depth,
            slice: slice
        };
        var add1 = function(st) {
            var $458 = {};
            for(var $459 in st)if (({}).hasOwnProperty.call(st, $459)) $458[$459] = st[$459];
            $458.maxd = $2b7582913558f260$var$max2(depth)(st.maxd);
            $458.maxx = $2b7582913558f260$var$max2(slice.x)(st.maxx);
            $458.slices = $2b7582913558f260$var$insert1(slice.id)(gslice)(st.slices);
            return $458;
        };
        return $2b7582913558f260$var$modify_1(add1);
    };
};
var $2b7582913558f260$export$c6cddbdf4913ff3 = function(flatHori) {
    return function(showAllEdges) {
        var split = function(lSlice) {
            return function(lDepth) {
                return function(item) {
                    return function(v) {
                        return $2b7582913558f260$var$discard2($2b7582913558f260$export$1ba3cf49f5354ea9(lSlice.id)(item.seg.trans)(item.seg.rslice.id))(function() {
                            var childr$prime = $97ffb09cc3d11a32$export$a70c9112c133085b(v.childr)(item.seg.rslice);
                            return $2b7582913558f260$var$pure2(new $78c799cba34fcb8d$export$74c44e616647f5c0({
                                seg: function() {
                                    if (showAllEdges) return $2b7582913558f260$export$855500c39d5564ed(v.childl);
                                    return v.childl;
                                }(),
                                more: {
                                    rdepth: $2b7582913558f260$var$max2(lDepth)(item.more.rdepth) + 1.0
                                }
                            }, new $78c799cba34fcb8d$export$74c44e616647f5c0({
                                seg: function() {
                                    if (showAllEdges) return $2b7582913558f260$export$91909249ef847c8(v.childl.rslice)(childr$prime);
                                    return childr$prime;
                                }(),
                                more: {
                                    rdepth: item.more.rdepth
                                }
                            }, $78c799cba34fcb8d$export$c1bed610ade55e1c.value)));
                        });
                    };
                };
            };
        };
        var splitRight = function(v) {
            return function(left) {
                return function(right) {
                    return function(splitop) {
                        return split(left.seg.rslice)(left.more.rdepth)(right)(splitop);
                    };
                };
            };
        };
        var splitTrans = function(lSlice) {
            return function(item) {
                return function(splitop) {
                    return $2b7582913558f260$var$bind3($2b7582913558f260$var$gets(function(v) {
                        return v.currentDepth;
                    }))(function(lDepth) {
                        return split(lSlice)(lDepth)(item)(splitop);
                    });
                };
            };
        };
        var init = function(start) {
            return $2b7582913558f260$export$893e8f2624c1009b(start)(0.0);
        };
        var hori = function(lSlice) {
            return function(left) {
                return function(right) {
                    return function(v) {
                        return $2b7582913558f260$var$bind3($2b7582913558f260$var$gets(function(v1) {
                            return v1.currentDepth;
                        }))(function(currentDepth) {
                            return $2b7582913558f260$var$discard2($2b7582913558f260$export$1ba3cf49f5354ea9(lSlice.id)(left.seg.trans)(left.seg.rslice.id))(function() {
                                return $2b7582913558f260$var$discard2($2b7582913558f260$export$893e8f2624c1009b(left.seg.rslice)(left.more.rdepth))(function() {
                                    return $2b7582913558f260$var$discard2($2b7582913558f260$export$3ad9e11b1ad9ef77(v.childl.rslice)(left.seg.rslice))(function() {
                                        return $2b7582913558f260$var$discard2($2b7582913558f260$export$3ad9e11b1ad9ef77(v.childm.rslice)(left.seg.rslice))(function() {
                                            return $2b7582913558f260$var$discard2($2b7582913558f260$export$1ba3cf49f5354ea9(left.seg.rslice.id)(right.seg.trans)(right.seg.rslice.id))(function() {
                                                var dsub = function() {
                                                    if (flatHori) return left.more.rdepth + 1.0;
                                                    return $2b7582913558f260$var$max2(currentDepth)($2b7582913558f260$var$max2(left.more.rdepth)(right.more.rdepth)) + 1.0;
                                                }();
                                                var childr$prime = $97ffb09cc3d11a32$export$a70c9112c133085b(v.childr)(right.seg.rslice);
                                                return $2b7582913558f260$var$pure2(new $78c799cba34fcb8d$export$74c44e616647f5c0({
                                                    seg: function() {
                                                        if (showAllEdges) return {
                                                            rslice: v.childl.rslice,
                                                            op: v.childl.op,
                                                            trans: {
                                                                id: v.childl.trans.id,
                                                                is2nd: v.childl.trans.is2nd,
                                                                edges: $97ffb09cc3d11a32$export$fb357a9288b70024(left.seg.trans.edges)(v.childl.rslice)
                                                            }
                                                        };
                                                        return v.childl;
                                                    }(),
                                                    more: {
                                                        rdepth: dsub
                                                    }
                                                }, new $78c799cba34fcb8d$export$74c44e616647f5c0({
                                                    seg: function() {
                                                        if (showAllEdges) return {
                                                            rslice: v.childm.rslice,
                                                            op: v.childm.op,
                                                            trans: {
                                                                id: v.childm.trans.id,
                                                                is2nd: v.childm.trans.is2nd,
                                                                edges: $97ffb09cc3d11a32$export$60f9aa56b538dc84(v.childl.rslice)(v.childm.trans.edges)(v.childm.rslice)
                                                            }
                                                        };
                                                        return v.childm;
                                                    }(),
                                                    more: {
                                                        rdepth: dsub
                                                    }
                                                }, new $78c799cba34fcb8d$export$74c44e616647f5c0({
                                                    seg: function() {
                                                        if (showAllEdges) return {
                                                            op: childr$prime.op,
                                                            rslice: childr$prime.rslice,
                                                            trans: {
                                                                id: childr$prime.trans.id,
                                                                is2nd: childr$prime.trans.is2nd,
                                                                edges: $97ffb09cc3d11a32$export$2d73c5c06a3fd526(v.childm.rslice)(right.seg.trans.edges)
                                                            }
                                                        };
                                                        return childr$prime;
                                                    }(),
                                                    more: {
                                                        rdepth: right.more.rdepth
                                                    }
                                                }, $78c799cba34fcb8d$export$c1bed610ade55e1c.value))));
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    };
                };
            };
        };
        var freezeTrans = function(lSlice) {
            return function(item) {
                return $2b7582913558f260$var$discard2($2b7582913558f260$export$1ba3cf49f5354ea9(lSlice.id)(item.seg.trans)(item.seg.rslice.id))(function() {
                    return $2b7582913558f260$var$discard2($2b7582913558f260$export$893e8f2624c1009b(item.seg.rslice)(item.more.rdepth))(function() {
                        return $2b7582913558f260$var$modify_1(function(st) {
                            var $480 = {};
                            for(var $481 in st)if (({}).hasOwnProperty.call(st, $481)) $480[$481] = st[$481];
                            $480.currentDepth = item.more.rdepth;
                            return $480;
                        });
                    });
                });
            };
        };
        return {
            init: init,
            freezeOnly: freezeTrans,
            freezeLeft: freezeTrans,
            splitOnly: splitTrans,
            splitLeft: splitTrans,
            splitRight: splitRight,
            hori: hori
        };
    };
};
var $2b7582913558f260$export$7e58b623da568b74 = function(flatHori) {
    return function(showAllEdges) {
        return function(reduction) {
            var agenda = $2b7582913558f260$var$map3(function(seg) {
                return {
                    seg: seg,
                    more: {
                        rdepth: 0.0
                    }
                };
            })(reduction.segments);
            return $f57f4b701aa7b66e$export$8a83211c878a3f1f($4a0611d0fc3e3eac$export$6feb49085bba08e4)($2b7582913558f260$export$89c077b968fc8691)($2b7582913558f260$export$7f8c26f2ad3722d6($2b7582913558f260$export$c6cddbdf4913ff3(flatHori)(showAllEdges))(reduction.start)(agenda));
        };
    };
};



// Generated by purs version 0.15.15





















var $b1271574b14e8498$var$bindStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$f28534bdc7259c7($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $b1271574b14e8498$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($b1271574b14e8498$var$bindStateT);
var $b1271574b14e8498$var$monadStateStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$fc3b89a546fa5c5c($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $b1271574b14e8498$var$get = /* #__PURE__ */ $f2d5035ce6148af6$export$3988ae62b71be9a3($b1271574b14e8498$var$monadStateStateT);
var $b1271574b14e8498$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $b1271574b14e8498$var$discard1 = /* #__PURE__ */ $b1271574b14e8498$var$discard($b1271574b14e8498$var$bindStateT);
var $b1271574b14e8498$var$modify_ = /* #__PURE__ */ $f2d5035ce6148af6$export$45b91115a89d6020($b1271574b14e8498$var$monadStateStateT);
var $b1271574b14e8498$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $e9bda291f4ec10ec$export$5cbc630d6fbe2e14($7d4cccdf062a2261$export$b3b4ecb28e3a8df3));
var $b1271574b14e8498$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($e9bda291f4ec10ec$export$5e0a9e9fea50cb88)($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $b1271574b14e8498$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88(/* #__PURE__ */ $e9bda291f4ec10ec$export$d5449d946db19e3a($7d4cccdf062a2261$export$f0a413d3d6075601));
var $b1271574b14e8498$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $b1271574b14e8498$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $b1271574b14e8498$var$evalStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$99aa49a66d7c0535($7d4cccdf062a2261$export$f0a413d3d6075601);
var $b1271574b14e8498$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $b1271574b14e8498$var$ordRecord = /* #__PURE__ */ $97937c29f879e68e$export$ebb7a7956d139174();
var $b1271574b14e8498$var$ordRecordCons = /* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611($97937c29f879e68e$export$927f7db8ecc0069f)();
var $b1271574b14e8498$var$ordStartStop = /* #__PURE__ */ $97ffb09cc3d11a32$export$51153a4951aa543e(/* #__PURE__ */ $b1271574b14e8498$var$ordRecord(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $b1271574b14e8498$var$ordRecordCons({
    reflectSymbol: function() {
        return "pitch";
    }
})(/* #__PURE__ */ $6416bd93bb20ed95$export$cddf5df7d4d146c7($364547bd6bbe186e$export$aa156b69905f503)))()({
    reflectSymbol: function() {
        return "id";
    }
})($97937c29f879e68e$export$c5f2758e49b2b86a)));
var $b1271574b14e8498$var$ordRecord1 = /* #__PURE__ */ $b1271574b14e8498$var$ordRecord(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $b1271574b14e8498$var$ordRecordCons({
    reflectSymbol: function() {
        return "right";
    }
})($b1271574b14e8498$var$ordStartStop))()({
    reflectSymbol: function() {
        return "left";
    }
})($b1271574b14e8498$var$ordStartStop));
var $b1271574b14e8498$var$catMaybes = /* #__PURE__ */ $a393155e52307a24$export$986c2bbe7a34be0b($b1271574b14e8498$var$ordRecord1);
var $b1271574b14e8498$var$map2 = /* #__PURE__ */ $a393155e52307a24$export$871de8747c9eaa88(/* #__PURE__ */ $06733ae99ed4f534$export$e35c29f98d259c46($b1271574b14e8498$var$ordRecord1));
var $b1271574b14e8498$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $b1271574b14e8498$var$discard2 = /* #__PURE__ */ $b1271574b14e8498$var$discard(/* #__PURE__ */ $e9bda291f4ec10ec$export$f28534bdc7259c7($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $b1271574b14e8498$var$modify_1 = /* #__PURE__ */ $f2d5035ce6148af6$export$45b91115a89d6020(/* #__PURE__ */ $e9bda291f4ec10ec$export$fc3b89a546fa5c5c($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $b1271574b14e8498$var$pure2 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $e9bda291f4ec10ec$export$5cbc630d6fbe2e14($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $b1271574b14e8498$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $b1271574b14e8498$export$39402868f924e1b2 = function(nsteps) {
    return function(red) {
        var split = function(v) {
            return function(seg) {
                return function(rest) {
                    return $b1271574b14e8498$var$bind($b1271574b14e8498$var$get)(function(n) {
                        var $94 = n <= 0;
                        if ($94) return go(new $78c799cba34fcb8d$export$74c44e616647f5c0({
                            rslice: seg.rslice,
                            trans: seg.trans,
                            op: $97ffb09cc3d11a32$export$f0826af67a39ec5d.value
                        }, rest));
                        return $b1271574b14e8498$var$discard1($b1271574b14e8498$var$modify_(function(v1) {
                            return v1 - 1 | 0;
                        }))(function() {
                            return $b1271574b14e8498$var$bind(go(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.childl, new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(v.childr)(seg.rslice), rest))))(function(res) {
                                if (res instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && res.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $b1271574b14e8498$var$pure(new $78c799cba34fcb8d$export$74c44e616647f5c0({
                                    rslice: seg.rslice,
                                    trans: seg.trans,
                                    op: new $97ffb09cc3d11a32$export$f836382419f64c98({
                                        childl: res.value0,
                                        childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(res.value1.value0)
                                    })
                                }, res.value1.value1));
                                return $b1271574b14e8498$var$lift(new $7d4cccdf062a2261$export$37c4d04eafdc5515("invalid result of split"));
                            });
                        });
                    });
                };
            };
        };
        var go = function(v) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $b1271574b14e8498$var$pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                if (v.value0.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return $b1271574b14e8498$var$pure(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
                if (v.value0.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return split(v.value0.op.value0)(v.value0)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
                if (v.value0.op instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) return $b1271574b14e8498$var$pure(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
                throw new Error("Failed pattern match at Pruning (line 27, column 23 - line 30, column 34): " + [
                    v.value0.op.constructor.name
                ]);
            }
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                if (v.value0.op instanceof $97ffb09cc3d11a32$export$f0826af67a39ec5d) return $b1271574b14e8498$var$map($78c799cba34fcb8d$export$74c44e616647f5c0.create(v.value0))(go(v.value1));
                if (v.value0.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return split(v.value0.op.value0)(v.value0)(v.value1);
                if (v.value0.op instanceof $97ffb09cc3d11a32$export$32baf76e6fd44656) {
                    if (v.value1.value0.op instanceof $97ffb09cc3d11a32$export$f836382419f64c98) return $b1271574b14e8498$var$bind($b1271574b14e8498$var$get)(function(n) {
                        var $111 = n <= 0;
                        if ($111) return $b1271574b14e8498$var$map($b1271574b14e8498$var$map1($78c799cba34fcb8d$export$74c44e616647f5c0.create({
                            rslice: v.value0.rslice,
                            trans: v.value0.trans,
                            op: $97ffb09cc3d11a32$export$f0826af67a39ec5d.value
                        }))($78c799cba34fcb8d$export$74c44e616647f5c0.create({
                            rslice: v.value1.value0.rslice,
                            trans: v.value1.value0.trans,
                            op: $97ffb09cc3d11a32$export$f0826af67a39ec5d.value
                        })))(go(v.value1.value1));
                        return $b1271574b14e8498$var$discard1($b1271574b14e8498$var$modify_(function(v1) {
                            return v1 - 1 | 0;
                        }))(function() {
                            return $b1271574b14e8498$var$bind(go(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value1.value0.op.value0.childl, new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(v.value1.value0.op.value0.childr)(v.value1.value0.rslice), v.value1.value1)))))(function(res) {
                                if (res instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && res.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && res.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $b1271574b14e8498$var$pure(new $78c799cba34fcb8d$export$74c44e616647f5c0(res.value0, new $78c799cba34fcb8d$export$74c44e616647f5c0({
                                    rslice: v.value1.value0.rslice,
                                    trans: v.value1.value0.trans,
                                    op: new $97ffb09cc3d11a32$export$f836382419f64c98({
                                        childl: res.value1.value0,
                                        childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(res.value1.value1.value0)
                                    })
                                }, res.value1.value1.value1)));
                                return $b1271574b14e8498$var$lift(new $7d4cccdf062a2261$export$37c4d04eafdc5515("invalid result of right split"));
                            });
                        });
                    });
                    return $b1271574b14e8498$var$bind($b1271574b14e8498$var$get)(function(n) {
                        var $120 = n <= 0;
                        if ($120) return $b1271574b14e8498$var$map($78c799cba34fcb8d$export$74c44e616647f5c0.create({
                            rslice: v.value0.rslice,
                            trans: v.value0.trans,
                            op: $97ffb09cc3d11a32$export$f0826af67a39ec5d.value
                        }))(go(v.value1));
                        return $b1271574b14e8498$var$discard1($b1271574b14e8498$var$modify_(function(v1) {
                            return v1 - 1 | 0;
                        }))(function() {
                            return $b1271574b14e8498$var$bind(go(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.op.value0.childl, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.op.value0.childm, new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(v.value0.op.value0.childr)(v.value1.value0.rslice), v.value1.value1)))))(function(res) {
                                if (res instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && res.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && res.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $b1271574b14e8498$var$pure(new $78c799cba34fcb8d$export$74c44e616647f5c0({
                                    rslice: v.value0.rslice,
                                    trans: v.value0.trans,
                                    op: new $97ffb09cc3d11a32$export$32baf76e6fd44656({
                                        childl: res.value0,
                                        childm: res.value1.value0,
                                        childr: $97ffb09cc3d11a32$export$9c03f2ce2ddfef4a(res.value1.value1.value0)
                                    })
                                }, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value1.value0, res.value1.value1.value1)));
                                return $b1271574b14e8498$var$lift(new $7d4cccdf062a2261$export$37c4d04eafdc5515("invalid result of hori"));
                            });
                        });
                    });
                }
                throw new Error("Failed pattern match at Pruning (line 32, column 44 - line 56, column 59): " + [
                    v.value0.op.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Pruning (line 24, column 3 - line 24, column 69): " + [
                v.constructor.name
            ]);
        };
        return $b1271574b14e8498$var$bind1($b1271574b14e8498$var$evalStateT(go(red.segments))(nsteps))(function(segs$prime) {
            return $b1271574b14e8498$var$pure1({
                nextSliceId: red.nextSliceId,
                nextTransId: red.nextTransId,
                start: red.start,
                segments: segs$prime
            });
        });
    };
};
var $b1271574b14e8498$export$e874444897fcc328 = function(n) {
    return function(model) {
        return $b1271574b14e8498$var$bind1($b1271574b14e8498$export$39402868f924e1b2(n)(model.reduction))(function(red$prime) {
            return $b1271574b14e8498$var$pure1({
                piece: model.piece,
                styles: model.styles,
                reduction: red$prime
            });
        });
    };
};
var $b1271574b14e8498$export$2d73c5c06a3fd526 = function(slicer) {
    return function(edgesr) {
        var v = function(v1) {
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return edgesr;
            throw new Error("Failed pattern match at Pruning (line 114, column 1 - line 114, column 42): " + [
                slicer.constructor.name,
                edgesr.constructor.name
            ]);
        };
        if (slicer.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
            var replaceLeft = function(v1) {
                var v2 = function(v3) {
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    throw new Error("Failed pattern match at Pruning (line 114, column 1 - line 114, column 42): " + [
                        v1.constructor.name
                    ]);
                };
                if (v1.left instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
                    var $145 = $396c4c3d9e7fae3c$export$71aa6c912b956294(function(n) {
                        if (n.expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return n.expl.value0.id === v1.left.value0.id;
                        return false;
                    })(slicer.notes.value0);
                    if ($145 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        left: new $97ffb09cc3d11a32$export$f63ba74aa66682be($145.value0.note),
                        right: v1.right
                    });
                    return v2(true);
                }
                return v2(true);
            };
            return {
                regular: $b1271574b14e8498$var$catMaybes($b1271574b14e8498$var$map2(replaceLeft)(edgesr.regular)),
                passing: $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($b1271574b14e8498$var$map3(replaceLeft)(edgesr.passing))
            };
        }
        return v(true);
    };
};
var $b1271574b14e8498$export$fb357a9288b70024 = function(edgesl) {
    return function(slicel) {
        var v = function(v1) {
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return edgesl;
            throw new Error("Failed pattern match at Pruning (line 95, column 1 - line 95, column 41): " + [
                edgesl.constructor.name,
                slicel.constructor.name
            ]);
        };
        if (slicel.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
            var replaceRight = function(v1) {
                var v2 = function(v3) {
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    throw new Error("Failed pattern match at Pruning (line 95, column 1 - line 95, column 41): " + [
                        v1.constructor.name
                    ]);
                };
                if (v1.right instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) {
                    var $163 = $396c4c3d9e7fae3c$export$71aa6c912b956294(function(n) {
                        if (n.expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return n.expl.value0.id === v1.right.value0.id;
                        return false;
                    })(slicel.notes.value0);
                    if ($163 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        left: v1.left,
                        right: new $97ffb09cc3d11a32$export$f63ba74aa66682be($163.value0.note)
                    });
                    return v2(true);
                }
                return v2(true);
            };
            return {
                regular: $b1271574b14e8498$var$catMaybes($b1271574b14e8498$var$map2(replaceRight)(edgesl.regular)),
                passing: $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($b1271574b14e8498$var$map3(replaceRight)(edgesl.passing))
            };
        }
        return v(true);
    };
};
var $b1271574b14e8498$export$f85024a1fb7f2fed = function(red) {
    var split = function(v) {
        return function(ag) {
            return function(v1) {
                return $b1271574b14e8498$var$discard2($b1271574b14e8498$var$modify_1(function(v2) {
                    return v2 + 1 | 0;
                }))(function() {
                    return $b1271574b14e8498$var$pure2($b1271574b14e8498$var$map4($2b7582913558f260$export$e835df75c3914978)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.childl, new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(v1.childr)(ag.seg.rslice), $78c799cba34fcb8d$export$c1bed610ade55e1c.value))));
                });
            };
        };
    };
    var splitRight = function(s) {
        return function(_ag1) {
            return function(ag2) {
                return split(s)(ag2);
            };
        };
    };
    var hori = function(v) {
        return function(v1) {
            return function(ag2) {
                return function(v2) {
                    return $b1271574b14e8498$var$discard2($b1271574b14e8498$var$modify_1(function(v3) {
                        return v3 + 1 | 0;
                    }))(function() {
                        return $b1271574b14e8498$var$pure2($b1271574b14e8498$var$map4($2b7582913558f260$export$e835df75c3914978)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.childl, new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.childm, new $78c799cba34fcb8d$export$74c44e616647f5c0($97ffb09cc3d11a32$export$a70c9112c133085b(v2.childr)(ag2.seg.rslice), $78c799cba34fcb8d$export$c1bed610ade55e1c.value)))));
                    });
                };
            };
        };
    };
    var countingAlg = {
        init: function(v) {
            return $b1271574b14e8498$var$pure2($05149ea687d6b460$export$523c0b569236b342);
        },
        freezeLeft: function(v) {
            return function(v1) {
                return $b1271574b14e8498$var$pure2($05149ea687d6b460$export$523c0b569236b342);
            };
        },
        freezeOnly: function(v) {
            return function(v1) {
                return $b1271574b14e8498$var$pure2($05149ea687d6b460$export$523c0b569236b342);
            };
        },
        splitLeft: split,
        splitOnly: split,
        splitRight: splitRight,
        hori: hori
    };
    var agenda = $b1271574b14e8498$var$map4($2b7582913558f260$export$e835df75c3914978)(red.segments);
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f($4a0611d0fc3e3eac$export$6feb49085bba08e4)(0)($2b7582913558f260$export$7f8c26f2ad3722d6(countingAlg)(red.start)(agenda));
};


var $f1eb673e64bdc463$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $6416bd93bb20ed95$export$26082705e1e7e214($364547bd6bbe186e$export$6c410b696f956741));
var $f1eb673e64bdc463$var$member = /* #__PURE__ */ $ea3eb84de0acf574$export$6a0d13241802fe80($97937c29f879e68e$export$ff461bf68e7dd332);
var $f1eb673e64bdc463$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $e9bda291f4ec10ec$export$5cbc630d6fbe2e14($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $f1eb673e64bdc463$var$bindStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$f28534bdc7259c7($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $f1eb673e64bdc463$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($f1eb673e64bdc463$var$bindStateT);
var $f1eb673e64bdc463$var$monadStateStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$fc3b89a546fa5c5c($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $f1eb673e64bdc463$var$get = /* #__PURE__ */ $f2d5035ce6148af6$export$3988ae62b71be9a3($f1eb673e64bdc463$var$monadStateStateT);
var $f1eb673e64bdc463$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($f1eb673e64bdc463$var$bindStateT);
var $f1eb673e64bdc463$var$put = /* #__PURE__ */ $f2d5035ce6148af6$export$327f7b26ebf455db($f1eb673e64bdc463$var$monadStateStateT);
var $f1eb673e64bdc463$var$insert = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($97937c29f879e68e$export$ff461bf68e7dd332);
var $f1eb673e64bdc463$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $f1eb673e64bdc463$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $f1eb673e64bdc463$var$ix = /* #__PURE__ */ $79efcffe70231542$export$bc3518d3f65cefd1(/* #__PURE__ */ $79efcffe70231542$export$5603d6456559ad27($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0))(/* #__PURE__ */ $79efcffe70231542$export$d60c33947aba4299($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $f1eb673e64bdc463$var$readBoolean = /* #__PURE__ */ $c97d2d0f578f81ad$export$f9a84177eae95ed5($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $f1eb673e64bdc463$var$readNumber = /* #__PURE__ */ $c97d2d0f578f81ad$export$347fd215c36b10be($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $f1eb673e64bdc463$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($97937c29f879e68e$export$ff461bf68e7dd332);
var $f1eb673e64bdc463$export$d050db8f6426404e = /* #__PURE__ */ function() {
    function Init() {}
    Init.value = new Init();
    return Init;
}();
var $f1eb673e64bdc463$export$7fc4381d95dc76c8 = /* #__PURE__ */ function() {
    function NoOp() {}
    NoOp.value = new NoOp();
    return NoOp;
}();
var $f1eb673e64bdc463$export$ef9b1a59e592288f = /* #__PURE__ */ function() {
    function Select(value0) {
        this.value0 = value0;
    }
    Select.create = function(value0) {
        return new Select(value0);
    };
    return Select;
}();
var $f1eb673e64bdc463$export$7724b1686f1f8cff = /* #__PURE__ */ function() {
    function Forward() {}
    Forward.value = new Forward();
    return Forward;
}();
var $f1eb673e64bdc463$export$277588d017c813a = /* #__PURE__ */ function() {
    function Backward() {}
    Backward.value = new Backward();
    return Backward;
}();
var $f1eb673e64bdc463$export$b6aba7a5890f6a89 = /* #__PURE__ */ function() {
    function ToFirst() {}
    ToFirst.value = new ToFirst();
    return ToFirst;
}();
var $f1eb673e64bdc463$export$409dc52471920c77 = /* #__PURE__ */ function() {
    function ToLast() {}
    ToLast.value = new ToLast();
    return ToLast;
}();
var $f1eb673e64bdc463$export$bd730340253f3798 = /* #__PURE__ */ function() {
    function RegisterScoreElt(value0) {
        this.value0 = value0;
    }
    RegisterScoreElt.create = function(value0) {
        return new RegisterScoreElt(value0);
    };
    return RegisterScoreElt;
}();
var $f1eb673e64bdc463$export$fc8740e8b4ad5c9b = /* #__PURE__ */ function() {
    function ToggleSettings() {}
    ToggleSettings.value = new ToggleSettings();
    return ToggleSettings;
}();
var $f1eb673e64bdc463$export$6d97fde8de427947 = /* #__PURE__ */ function() {
    function ToggleInner() {}
    ToggleInner.value = new ToggleInner();
    return ToggleInner;
}();
var $f1eb673e64bdc463$export$5aa6d5fa95bc8563 = /* #__PURE__ */ function() {
    function ToggleOuter() {}
    ToggleOuter.value = new ToggleOuter();
    return ToggleOuter;
}();
var $f1eb673e64bdc463$export$3e466d3389bb1f1c = /* #__PURE__ */ function() {
    function ToggleScore() {}
    ToggleScore.value = new ToggleScore();
    return ToggleScore;
}();
var $f1eb673e64bdc463$export$8ca4a597184afb0b = /* #__PURE__ */ function() {
    function ToggleSurface() {}
    ToggleSurface.value = new ToggleSurface();
    return ToggleSurface;
}();
var $f1eb673e64bdc463$export$33b961eeb5124842 = /* #__PURE__ */ function() {
    function SetXScale(value0) {
        this.value0 = value0;
    }
    SetXScale.create = function(value0) {
        return new SetXScale(value0);
    };
    return SetXScale;
}();
var $f1eb673e64bdc463$export$8a710b6e46000772 = /* #__PURE__ */ function() {
    function SetYScale(value0) {
        this.value0 = value0;
    }
    SetYScale.create = function(value0) {
        return new SetYScale(value0);
    };
    return SetYScale;
}();
var $f1eb673e64bdc463$export$3b0bdf174ee79f95 = function(v) {
    if (v instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb) return "unexplained";
    if (v instanceof $97ffb09cc3d11a32$export$2cf876164813516f) return "root note";
    if (v instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) {
        var ornStr = function() {
            if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$9ac4ca89af1eab6b) return "full neighbor";
            if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$12a73def75ba91a) return "full repeat";
            if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$c33024bcf57ad853) return "left repeat";
            if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$ad2c4a230ed49713) return "right repeat";
            if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$b62f635e41790a80) return "middle passing note";
            if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$dab08a4db0f3867f) return "left passing note";
            if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$9cce9eb8c466c42b) return "right passing note";
            if (v.value0.orn instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "unexplained";
            throw new Error("Failed pattern match at Common (line 93, column 16 - line 101, column 33): " + [
                v.value0.orn.constructor.name
            ]);
        }();
        return ornStr + (" between " + ($f1eb673e64bdc463$var$show(v.value0.leftParent.pitch) + (" and " + $f1eb673e64bdc463$var$show(v.value0.rightParent.pitch))));
    }
    if (v instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07) {
        var ornStr = function() {
            if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$ef0b5f914041d38a) return "repeat";
            if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$fd951dac679282e1) return "neighbor";
            if (v.value0.orn instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "ornament (unexplained)";
            throw new Error("Failed pattern match at Common (line 106, column 16 - line 109, column 44): " + [
                v.value0.orn.constructor.name
            ]);
        }();
        return "right " + (ornStr + (" of " + $f1eb673e64bdc463$var$show(v.value0.leftParent.pitch)));
    }
    if (v instanceof $97ffb09cc3d11a32$export$a420550a5202c987) {
        var ornStr = function() {
            if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$e32a75e677fca455) return "repeat";
            if (v.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.orn.value0 instanceof $97ffb09cc3d11a32$export$7bb038d575dcf9c9) return "neighbor";
            if (v.value0.orn instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "ornament (unexplained)";
            throw new Error("Failed pattern match at Common (line 114, column 16 - line 117, column 44): " + [
                v.value0.orn.constructor.name
            ]);
        }();
        return "left " + (ornStr + (" of " + $f1eb673e64bdc463$var$show(v.value0.rightParent.pitch)));
    }
    if (v instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return "spread from " + $f1eb673e64bdc463$var$show(v.value0.pitch);
    throw new Error("Failed pattern match at Common (line 88, column 19 - line 120, column 57): " + [
        v.constructor.name
    ]);
};
var $f1eb673e64bdc463$export$293152351051e02c = function(v) {
    return function(v1) {
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return v.value0.note.id === v1.value0.id;
        return false;
    };
};
var $f1eb673e64bdc463$export$317576aef8adc076 = function(model) {
    return function(step) {
        return function(cache) {
            var insertItem = function(f) {
                return function(place) {
                    var $64 = $f1eb673e64bdc463$var$member(step)(place);
                    if ($64) return $f1eb673e64bdc463$var$pure(place);
                    return $f1eb673e64bdc463$var$bind($f1eb673e64bdc463$var$get)(function(savedMPruned) {
                        return $f1eb673e64bdc463$var$bind(function() {
                            if (savedMPruned instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                                var mp = $b1271574b14e8498$export$e874444897fcc328(step)(model);
                                return $f1eb673e64bdc463$var$discard($f1eb673e64bdc463$var$put(new $06733ae99ed4f534$export$8a67b48435b5d073(mp)))(function() {
                                    return $f1eb673e64bdc463$var$pure(mp);
                                });
                            }
                            if (savedMPruned instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $f1eb673e64bdc463$var$pure(savedMPruned.value0);
                            throw new Error("Failed pattern match at Common (line 139, column 18 - line 145, column 27): " + [
                                savedMPruned.constructor.name
                            ]);
                        }())(function(mpruned) {
                            if (mpruned instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $f1eb673e64bdc463$var$pure(place);
                            if (mpruned instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $f1eb673e64bdc463$var$pure($f1eb673e64bdc463$var$insert(step)(f(mpruned.value0))(place));
                            throw new Error("Failed pattern match at Common (line 146, column 7 - line 148, column 54): " + [
                                mpruned.constructor.name
                            ]);
                        });
                    });
                };
            };
            return $f57f4b701aa7b66e$export$8a83211c878a3f1f($4a0611d0fc3e3eac$export$3f3c20f32c573065)($06733ae99ed4f534$export$bebe9059409a0d04.value)($f1eb673e64bdc463$var$bind(insertItem($f1eb673e64bdc463$var$identity)(cache.modelPruned))(function(pruned$prime) {
                return $f1eb673e64bdc463$var$bind(insertItem(function() {
                    var $76 = $2b7582913558f260$export$7e58b623da568b74(true)(true);
                    return function($77) {
                        return $76(function(v) {
                            return v.reduction;
                        }($77));
                    };
                }())(cache.graph))(function(graph$prime) {
                    return $f1eb673e64bdc463$var$bind(insertItem(function() {
                        var $78 = $2b7582913558f260$export$c3213ee7169ceb28(false);
                        return function($79) {
                            return $78(function(v) {
                                return v.reduction;
                            }($79));
                        };
                    }())(cache.surface))(function(surface$prime) {
                        return $f1eb673e64bdc463$var$pure({
                            modelPruned: pruned$prime,
                            graph: graph$prime,
                            surface: surface$prime
                        });
                    });
                });
            }));
        };
    };
};
var $f1eb673e64bdc463$export$8dc30353b93985d6 = {
    modelPruned: $ea3eb84de0acf574$export$6e22c362a0406a2c,
    graph: $ea3eb84de0acf574$export$6e22c362a0406a2c,
    surface: $ea3eb84de0acf574$export$6e22c362a0406a2c
};
var $f1eb673e64bdc463$export$62680b65e63e14ec = {
    flatHori: true,
    xscale: 0.0,
    yscale: 0.0,
    showSettings: false,
    showInner: false,
    showOuter: false,
    showScore: true,
    showSurface: true
};
var $f1eb673e64bdc463$export$78af9b5fc65e58de = function(obj) {
    return {
        flatHori: $7d4cccdf062a2261$export$27d3ca2b5d864fdd($f1eb673e64bdc463$export$62680b65e63e14ec.flatHori)($f9f243b94d1fc188$export$a25b8a8a37f2d1cd($f1eb673e64bdc463$var$bind1($f1eb673e64bdc463$var$ix(obj)("flatHori"))($f1eb673e64bdc463$var$readBoolean))),
        xscale: $7d4cccdf062a2261$export$27d3ca2b5d864fdd($f1eb673e64bdc463$export$62680b65e63e14ec.xscale)($f9f243b94d1fc188$export$a25b8a8a37f2d1cd($f1eb673e64bdc463$var$bind1($f1eb673e64bdc463$var$ix(obj)("xscale"))($f1eb673e64bdc463$var$readNumber))),
        yscale: $7d4cccdf062a2261$export$27d3ca2b5d864fdd($f1eb673e64bdc463$export$62680b65e63e14ec.yscale)($f9f243b94d1fc188$export$a25b8a8a37f2d1cd($f1eb673e64bdc463$var$bind1($f1eb673e64bdc463$var$ix(obj)("yscale"))($f1eb673e64bdc463$var$readNumber))),
        showSettings: $7d4cccdf062a2261$export$27d3ca2b5d864fdd($f1eb673e64bdc463$export$62680b65e63e14ec.showSettings)($f9f243b94d1fc188$export$a25b8a8a37f2d1cd($f1eb673e64bdc463$var$bind1($f1eb673e64bdc463$var$ix(obj)("showSettings"))($f1eb673e64bdc463$var$readBoolean))),
        showInner: $7d4cccdf062a2261$export$27d3ca2b5d864fdd($f1eb673e64bdc463$export$62680b65e63e14ec.showInner)($f9f243b94d1fc188$export$a25b8a8a37f2d1cd($f1eb673e64bdc463$var$bind1($f1eb673e64bdc463$var$ix(obj)("showInner"))($f1eb673e64bdc463$var$readBoolean))),
        showOuter: $7d4cccdf062a2261$export$27d3ca2b5d864fdd($f1eb673e64bdc463$export$62680b65e63e14ec.showOuter)($f9f243b94d1fc188$export$a25b8a8a37f2d1cd($f1eb673e64bdc463$var$bind1($f1eb673e64bdc463$var$ix(obj)("showOuter"))($f1eb673e64bdc463$var$readBoolean))),
        showScore: $7d4cccdf062a2261$export$27d3ca2b5d864fdd($f1eb673e64bdc463$export$62680b65e63e14ec.showScore)($f9f243b94d1fc188$export$a25b8a8a37f2d1cd($f1eb673e64bdc463$var$bind1($f1eb673e64bdc463$var$ix(obj)("showScore"))($f1eb673e64bdc463$var$readBoolean))),
        showSurface: $7d4cccdf062a2261$export$27d3ca2b5d864fdd($f1eb673e64bdc463$export$62680b65e63e14ec.showSurface)($f9f243b94d1fc188$export$a25b8a8a37f2d1cd($f1eb673e64bdc463$var$bind1($f1eb673e64bdc463$var$ix(obj)("showSurface"))($f1eb673e64bdc463$var$readBoolean)))
    };
};
var $f1eb673e64bdc463$export$dbf49ecbc3d3d264 = function(str) {
    return $94c2c7ff32ca5bd1$export$dbf49ecbc3d3d264(str);
};
var $f1eb673e64bdc463$export$c90c001b7fe12473 = function(mpruned) {
    return function(step) {
        return function(cache) {
            var v = $f1eb673e64bdc463$var$lookup(step)(cache.surface);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $2b7582913558f260$export$c3213ee7169ceb28(false)(mpruned.reduction);
            throw new Error("Failed pattern match at Common (line 161, column 38 - line 163, column 49): " + [
                v.constructor.name
            ]);
        };
    };
};
var $f1eb673e64bdc463$export$ca03650e5de7965d = function(model) {
    return function(step) {
        return function(cache) {
            var v = $f1eb673e64bdc463$var$lookup(step)(cache.modelPruned);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $b1271574b14e8498$export$e874444897fcc328(step)(model);
            throw new Error("Failed pattern match at Common (line 151, column 35 - line 153, column 35): " + [
                v.constructor.name
            ]);
        };
    };
};
var $f1eb673e64bdc463$export$6164af773253b68d = function(mpruned) {
    return function(step) {
        return function(cache) {
            var v = $f1eb673e64bdc463$var$lookup(step)(cache.graph);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $2b7582913558f260$export$7e58b623da568b74(true)(true)(mpruned.reduction);
            throw new Error("Failed pattern match at Common (line 156, column 36 - line 158, column 51): " + [
                v.constructor.name
            ]);
        };
    };
};






















// Generated by purs version 0.15.15
/* globals setImmediate, clearImmediate, setTimeout, clearTimeout */ /* eslint-disable no-unused-vars, no-prototype-builtins, no-use-before-define, no-unused-labels, no-param-reassign */ var $b28443a27438717a$var$Aff = function() {
    // A unique value for empty.
    var EMPTY = {};
    /*

  An awkward approximation. We elide evidence we would otherwise need in PS for
  efficiency sake.

  data Aff eff a
    = Pure a
    | Throw Error
    | Catch (Aff eff a) (Error -> Aff eff a)
    | Sync (Eff eff a)
    | Async ((Either Error a -> Eff eff Unit) -> Eff eff (Canceler eff))
    | forall b. Bind (Aff eff b) (b -> Aff eff a)
    | forall b. Bracket (Aff eff b) (BracketConditions eff b) (b -> Aff eff a)
    | forall b. Fork Boolean (Aff eff b) ?(Fiber eff b -> a)
    | Sequential (ParAff aff a)

  */ var PURE = "Pure";
    var THROW = "Throw";
    var CATCH = "Catch";
    var SYNC = "Sync";
    var ASYNC = "Async";
    var BIND = "Bind";
    var BRACKET = "Bracket";
    var FORK = "Fork";
    var SEQ = "Sequential";
    /*

  data ParAff eff a
    = forall b. Map (b -> a) (ParAff eff b)
    | forall b. Apply (ParAff eff (b -> a)) (ParAff eff b)
    | Alt (ParAff eff a) (ParAff eff a)
    | ?Par (Aff eff a)

  */ var MAP = "Map";
    var APPLY = "Apply";
    var ALT = "Alt";
    // Various constructors used in interpretation
    var CONS = "Cons"; // Cons-list, for stacks
    var RESUME = "Resume"; // Continue indiscriminately
    var RELEASE = "Release"; // Continue with bracket finalizers
    var FINALIZER = "Finalizer"; // A non-interruptible effect
    var FINALIZED = "Finalized"; // Marker for finalization
    var FORKED = "Forked"; // Reference to a forked fiber, with resumption stack
    var FIBER = "Fiber"; // Actual fiber reference
    var THUNK = "Thunk"; // Primed effect, ready to invoke
    function Aff(tag, _1, _2, _3) {
        this.tag = tag;
        this._1 = _1;
        this._2 = _2;
        this._3 = _3;
    }
    function AffCtr(tag) {
        var fn = function(_1, _2, _3) {
            return new Aff(tag, _1, _2, _3);
        };
        fn.tag = tag;
        return fn;
    }
    function nonCanceler(error) {
        return new Aff(PURE, void 0);
    }
    function runEff(eff) {
        try {
            eff();
        } catch (error) {
            setTimeout(function() {
                throw error;
            }, 0);
        }
    }
    function runSync(left, right, eff) {
        try {
            return right(eff());
        } catch (error) {
            return left(error);
        }
    }
    function runAsync(left, eff, k) {
        try {
            return eff(k)();
        } catch (error) {
            k(left(error))();
            return nonCanceler;
        }
    }
    var Scheduler = function() {
        var limit = 1024;
        var size = 0;
        var ix = 0;
        var queue = new Array(limit);
        var draining = false;
        function drain() {
            var thunk;
            draining = true;
            while(size !== 0){
                size--;
                thunk = queue[ix];
                queue[ix] = void 0;
                ix = (ix + 1) % limit;
                thunk();
            }
            draining = false;
        }
        return {
            isDraining: function() {
                return draining;
            },
            enqueue: function(cb) {
                var i, tmp;
                if (size === limit) {
                    tmp = draining;
                    drain();
                    draining = tmp;
                }
                queue[(ix + size) % limit] = cb;
                size++;
                if (!draining) drain();
            }
        };
    }();
    function Supervisor(util) {
        var fibers = {};
        var fiberId = 0;
        var count = 0;
        return {
            register: function(fiber) {
                var fid = fiberId++;
                fiber.onComplete({
                    rethrow: true,
                    handler: function(result) {
                        return function() {
                            count--;
                            delete fibers[fid];
                        };
                    }
                })();
                fibers[fid] = fiber;
                count++;
            },
            isEmpty: function() {
                return count === 0;
            },
            killAll: function(killError, cb) {
                return function() {
                    if (count === 0) return cb();
                    var killCount = 0;
                    var kills = {};
                    function kill(fid) {
                        kills[fid] = fibers[fid].kill(killError, function(result) {
                            return function() {
                                delete kills[fid];
                                killCount--;
                                if (util.isLeft(result) && util.fromLeft(result)) setTimeout(function() {
                                    throw util.fromLeft(result);
                                }, 0);
                                if (killCount === 0) cb();
                            };
                        })();
                    }
                    for(var k in fibers)if (fibers.hasOwnProperty(k)) {
                        killCount++;
                        kill(k);
                    }
                    fibers = {};
                    fiberId = 0;
                    count = 0;
                    return function(error) {
                        return new Aff(SYNC, function() {
                            for(var k in kills)if (kills.hasOwnProperty(k)) kills[k]();
                        });
                    };
                };
            }
        };
    }
    // Fiber state machine
    var SUSPENDED = 0; // Suspended, pending a join.
    var CONTINUE = 1; // Interpret the next instruction.
    var STEP_BIND = 2; // Apply the next bind.
    var STEP_RESULT = 3; // Handle potential failure from a result.
    var PENDING = 4; // An async effect is running.
    var RETURN = 5; // The current stack has returned.
    var COMPLETED = 6; // The entire fiber has completed.
    function Fiber(util, supervisor, aff) {
        // Monotonically increasing tick, increased on each asynchronous turn.
        var runTick = 0;
        // The current branch of the state machine.
        var status = SUSPENDED;
        // The current point of interest for the state machine branch.
        var step = aff; // Successful step
        var fail = null; // Failure step
        var interrupt = null; // Asynchronous interrupt
        // Stack of continuations for the current fiber.
        var bhead = null;
        var btail = null;
        // Stack of attempts and finalizers for error recovery. Every `Cons` is also
        // tagged with current `interrupt` state. We use this to track which items
        // should be ignored or evaluated as a result of a kill.
        var attempts = null;
        // A special state is needed for Bracket, because it cannot be killed. When
        // we enter a bracket acquisition or finalizer, we increment the counter,
        // and then decrement once complete.
        var bracketCount = 0;
        // Each join gets a new id so they can be revoked.
        var joinId = 0;
        var joins = null;
        var rethrow = true;
        // Each invocation of `run` requires a tick. When an asynchronous effect is
        // resolved, we must check that the local tick coincides with the fiber
        // tick before resuming. This prevents multiple async continuations from
        // accidentally resuming the same fiber. A common example may be invoking
        // the provided callback in `makeAff` more than once, but it may also be an
        // async effect resuming after the fiber was already cancelled.
        function run(localRunTick) {
            var tmp, result, attempt;
            while(true){
                tmp = null;
                result = null;
                attempt = null;
                switch(status){
                    case STEP_BIND:
                        status = CONTINUE;
                        try {
                            step = bhead(step);
                            if (btail === null) bhead = null;
                            else {
                                bhead = btail._1;
                                btail = btail._2;
                            }
                        } catch (e) {
                            status = RETURN;
                            fail = util.left(e);
                            step = null;
                        }
                        break;
                    case STEP_RESULT:
                        if (util.isLeft(step)) {
                            status = RETURN;
                            fail = step;
                            step = null;
                        } else if (bhead === null) status = RETURN;
                        else {
                            status = STEP_BIND;
                            step = util.fromRight(step);
                        }
                        break;
                    case CONTINUE:
                        switch(step.tag){
                            case BIND:
                                if (bhead) btail = new Aff(CONS, bhead, btail);
                                bhead = step._2;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            case PURE:
                                if (bhead === null) {
                                    status = RETURN;
                                    step = util.right(step._1);
                                } else {
                                    status = STEP_BIND;
                                    step = step._1;
                                }
                                break;
                            case SYNC:
                                status = STEP_RESULT;
                                step = runSync(util.left, util.right, step._1);
                                break;
                            case ASYNC:
                                status = PENDING;
                                step = runAsync(util.left, step._1, function(result) {
                                    return function() {
                                        if (runTick !== localRunTick) return;
                                        runTick++;
                                        Scheduler.enqueue(function() {
                                            // It's possible to interrupt the fiber between enqueuing and
                                            // resuming, so we need to check that the runTick is still
                                            // valid.
                                            if (runTick !== localRunTick + 1) return;
                                            status = STEP_RESULT;
                                            step = result;
                                            run(runTick);
                                        });
                                    };
                                });
                                return;
                            case THROW:
                                status = RETURN;
                                fail = util.left(step._1);
                                step = null;
                                break;
                            // Enqueue the Catch so that we can call the error handler later on
                            // in case of an exception.
                            case CATCH:
                                if (bhead === null) attempts = new Aff(CONS, step, attempts, interrupt);
                                else attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            // Enqueue the Bracket so that we can call the appropriate handlers
                            // after resource acquisition.
                            case BRACKET:
                                bracketCount++;
                                if (bhead === null) attempts = new Aff(CONS, step, attempts, interrupt);
                                else attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            case FORK:
                                status = STEP_RESULT;
                                tmp = Fiber(util, supervisor, step._2);
                                if (supervisor) supervisor.register(tmp);
                                if (step._1) tmp.run();
                                step = util.right(tmp);
                                break;
                            case SEQ:
                                status = CONTINUE;
                                step = sequential(util, supervisor, step._1);
                                break;
                        }
                        break;
                    case RETURN:
                        bhead = null;
                        btail = null;
                        // If the current stack has returned, and we have no other stacks to
                        // resume or finalizers to run, the fiber has halted and we can
                        // invoke all join callbacks. Otherwise we need to resume.
                        if (attempts === null) {
                            status = COMPLETED;
                            step = interrupt || fail || step;
                        } else {
                            // The interrupt status for the enqueued item.
                            tmp = attempts._3;
                            attempt = attempts._1;
                            attempts = attempts._2;
                            switch(attempt.tag){
                                // We cannot recover from an unmasked interrupt. Otherwise we should
                                // continue stepping, or run the exception handler if an exception
                                // was raised.
                                case CATCH:
                                    // We should compare the interrupt status as well because we
                                    // only want it to apply if there has been an interrupt since
                                    // enqueuing the catch.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) status = RETURN;
                                    else if (fail) {
                                        status = CONTINUE;
                                        step = attempt._2(util.fromLeft(fail));
                                        fail = null;
                                    }
                                    break;
                                // We cannot resume from an unmasked interrupt or exception.
                                case RESUME:
                                    // As with Catch, we only want to ignore in the case of an
                                    // interrupt since enqueing the item.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0 || fail) status = RETURN;
                                    else {
                                        bhead = attempt._1;
                                        btail = attempt._2;
                                        status = STEP_BIND;
                                        step = util.fromRight(step);
                                    }
                                    break;
                                // If we have a bracket, we should enqueue the handlers,
                                // and continue with the success branch only if the fiber has
                                // not been interrupted. If the bracket acquisition failed, we
                                // should not run either.
                                case BRACKET:
                                    bracketCount--;
                                    if (fail === null) {
                                        result = util.fromRight(step);
                                        // We need to enqueue the Release with the same interrupt
                                        // status as the Bracket that is initiating it.
                                        attempts = new Aff(CONS, new Aff(RELEASE, attempt._2, result), attempts, tmp);
                                        // We should only coninue as long as the interrupt status has not changed or
                                        // we are currently within a non-interruptable finalizer.
                                        if (interrupt === tmp || bracketCount > 0) {
                                            status = CONTINUE;
                                            step = attempt._3(result);
                                        }
                                    }
                                    break;
                                // Enqueue the appropriate handler. We increase the bracket count
                                // because it should not be cancelled.
                                case RELEASE:
                                    attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                                    status = CONTINUE;
                                    // It has only been killed if the interrupt status has changed
                                    // since we enqueued the item, and the bracket count is 0. If the
                                    // bracket count is non-zero then we are in a masked state so it's
                                    // impossible to be killed.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) step = attempt._1.killed(util.fromLeft(interrupt))(attempt._2);
                                    else if (fail) step = attempt._1.failed(util.fromLeft(fail))(attempt._2);
                                    else step = attempt._1.completed(util.fromRight(step))(attempt._2);
                                    fail = null;
                                    bracketCount++;
                                    break;
                                case FINALIZER:
                                    bracketCount++;
                                    attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                                    status = CONTINUE;
                                    step = attempt._1;
                                    break;
                                case FINALIZED:
                                    bracketCount--;
                                    status = RETURN;
                                    step = attempt._1;
                                    fail = attempt._2;
                                    break;
                            }
                        }
                        break;
                    case COMPLETED:
                        for(var k in joins)if (joins.hasOwnProperty(k)) {
                            rethrow = rethrow && joins[k].rethrow;
                            runEff(joins[k].handler(step));
                        }
                        joins = null;
                        // If we have an interrupt and a fail, then the thread threw while
                        // running finalizers. This should always rethrow in a fresh stack.
                        if (interrupt && fail) setTimeout(function() {
                            throw util.fromLeft(fail);
                        }, 0);
                        else if (util.isLeft(step) && rethrow) setTimeout(function() {
                            // Guard on reathrow because a completely synchronous fiber can
                            // still have an observer which was added after-the-fact.
                            if (rethrow) throw util.fromLeft(step);
                        }, 0);
                        return;
                    case SUSPENDED:
                        status = CONTINUE;
                        break;
                    case PENDING:
                        return;
                }
            }
        }
        function onComplete(join) {
            return function() {
                if (status === COMPLETED) {
                    rethrow = rethrow && join.rethrow;
                    join.handler(step)();
                    return function() {};
                }
                var jid = joinId++;
                joins = joins || {};
                joins[jid] = join;
                return function() {
                    if (joins !== null) delete joins[jid];
                };
            };
        }
        function kill(error, cb) {
            return function() {
                if (status === COMPLETED) {
                    cb(util.right(void 0))();
                    return function() {};
                }
                var canceler = onComplete({
                    rethrow: false,
                    handler: function() {
                        return cb(util.right(void 0));
                    }
                })();
                switch(status){
                    case SUSPENDED:
                        interrupt = util.left(error);
                        status = COMPLETED;
                        step = interrupt;
                        run(runTick);
                        break;
                    case PENDING:
                        if (interrupt === null) interrupt = util.left(error);
                        if (bracketCount === 0) {
                            if (status === PENDING) attempts = new Aff(CONS, new Aff(FINALIZER, step(error)), attempts, interrupt);
                            status = RETURN;
                            step = null;
                            fail = null;
                            run(++runTick);
                        }
                        break;
                    default:
                        if (interrupt === null) interrupt = util.left(error);
                        if (bracketCount === 0) {
                            status = RETURN;
                            step = null;
                            fail = null;
                        }
                }
                return canceler;
            };
        }
        function join(cb) {
            return function() {
                var canceler = onComplete({
                    rethrow: false,
                    handler: cb
                })();
                if (status === SUSPENDED) run(runTick);
                return canceler;
            };
        }
        return {
            kill: kill,
            join: join,
            onComplete: onComplete,
            isSuspended: function() {
                return status === SUSPENDED;
            },
            run: function() {
                if (status === SUSPENDED) {
                    if (!Scheduler.isDraining()) Scheduler.enqueue(function() {
                        run(runTick);
                    });
                    else run(runTick);
                }
            }
        };
    }
    function runPar(util, supervisor, par, cb) {
        // Table of all forked fibers.
        var fiberId = 0;
        var fibers = {};
        // Table of currently running cancelers, as a product of `Alt` behavior.
        var killId = 0;
        var kills = {};
        // Error used for early cancelation on Alt branches.
        var early = new Error("[ParAff] Early exit");
        // Error used to kill the entire tree.
        var interrupt = null;
        // The root pointer of the tree.
        var root = EMPTY;
        // Walks a tree, invoking all the cancelers. Returns the table of pending
        // cancellation fibers.
        function kill(error, par, cb) {
            var step = par;
            var head = null;
            var tail = null;
            var count = 0;
            var kills = {};
            var tmp, kid;
            loop: while(true){
                tmp = null;
                switch(step.tag){
                    case FORKED:
                        if (step._3 === EMPTY) {
                            tmp = fibers[step._1];
                            kills[count++] = tmp.kill(error, function(result) {
                                return function() {
                                    count--;
                                    if (count === 0) cb(result)();
                                };
                            });
                        }
                        // Terminal case.
                        if (head === null) break loop;
                        // Go down the right side of the tree.
                        step = head._2;
                        if (tail === null) head = null;
                        else {
                            head = tail._1;
                            tail = tail._2;
                        }
                        break;
                    case MAP:
                        step = step._2;
                        break;
                    case APPLY:
                    case ALT:
                        if (head) tail = new Aff(CONS, head, tail);
                        head = step;
                        step = step._1;
                        break;
                }
            }
            if (count === 0) cb(util.right(void 0))();
            else {
                // Run the cancelation effects. We alias `count` because it's mutable.
                kid = 0;
                tmp = count;
                for(; kid < tmp; kid++)kills[kid] = kills[kid]();
            }
            return kills;
        }
        // When a fiber resolves, we need to bubble back up the tree with the
        // result, computing the applicative nodes.
        function join(result, head, tail) {
            var fail, step, lhs, rhs, tmp, kid;
            if (util.isLeft(result)) {
                fail = result;
                step = null;
            } else {
                step = result;
                fail = null;
            }
            loop: while(true){
                lhs = null;
                rhs = null;
                tmp = null;
                kid = null;
                // We should never continue if the entire tree has been interrupted.
                if (interrupt !== null) return;
                // We've made it all the way to the root of the tree, which means
                // the tree has fully evaluated.
                if (head === null) {
                    cb(fail || step)();
                    return;
                }
                // The tree has already been computed, so we shouldn't try to do it
                // again. This should never happen.
                // TODO: Remove this?
                if (head._3 !== EMPTY) return;
                switch(head.tag){
                    case MAP:
                        if (fail === null) {
                            head._3 = util.right(head._1(util.fromRight(step)));
                            step = head._3;
                        } else head._3 = fail;
                        break;
                    case APPLY:
                        lhs = head._1._3;
                        rhs = head._2._3;
                        // If we have a failure we should kill the other side because we
                        // can't possible yield a result anymore.
                        if (fail) {
                            head._3 = fail;
                            tmp = true;
                            kid = killId++;
                            kills[kid] = kill(early, fail === lhs ? head._2 : head._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail === null) join(fail, null, null);
                                    else join(fail, tail._1, tail._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        } else if (lhs === EMPTY || rhs === EMPTY) // We can only proceed if both sides have resolved.
                        return;
                        else {
                            step = util.right(util.fromRight(lhs)(util.fromRight(rhs)));
                            head._3 = step;
                        }
                        break;
                    case ALT:
                        lhs = head._1._3;
                        rhs = head._2._3;
                        // We can only proceed if both have resolved or we have a success
                        if (lhs === EMPTY && util.isLeft(rhs) || rhs === EMPTY && util.isLeft(lhs)) return;
                        // If both sides resolve with an error, we should continue with the
                        // first error
                        if (lhs !== EMPTY && util.isLeft(lhs) && rhs !== EMPTY && util.isLeft(rhs)) {
                            fail = step === lhs ? rhs : lhs;
                            step = null;
                            head._3 = fail;
                        } else {
                            head._3 = step;
                            tmp = true;
                            kid = killId++;
                            // Once a side has resolved, we need to cancel the side that is still
                            // pending before we can continue.
                            kills[kid] = kill(early, step === lhs ? head._2 : head._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail === null) join(step, null, null);
                                    else join(step, tail._1, tail._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        }
                        break;
                }
                if (tail === null) head = null;
                else {
                    head = tail._1;
                    tail = tail._2;
                }
            }
        }
        function resolve(fiber) {
            return function(result) {
                return function() {
                    delete fibers[fiber._1];
                    fiber._3 = result;
                    join(result, fiber._2._1, fiber._2._2);
                };
            };
        }
        // Walks the applicative tree, substituting non-applicative nodes with
        // `FORKED` nodes. In this tree, all applicative nodes use the `_3` slot
        // as a mutable slot for memoization. In an unresolved state, the `_3`
        // slot is `EMPTY`. In the cases of `ALT` and `APPLY`, we always walk
        // the left side first, because both operations are left-associative. As
        // we `RETURN` from those branches, we then walk the right side.
        function run() {
            var status = CONTINUE;
            var step = par;
            var head = null;
            var tail = null;
            var tmp, fid;
            loop: while(true){
                tmp = null;
                fid = null;
                switch(status){
                    case CONTINUE:
                        switch(step.tag){
                            case MAP:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(MAP, step._1, EMPTY, EMPTY);
                                step = step._2;
                                break;
                            case APPLY:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(APPLY, EMPTY, step._2, EMPTY);
                                step = step._1;
                                break;
                            case ALT:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(ALT, EMPTY, step._2, EMPTY);
                                step = step._1;
                                break;
                            default:
                                // When we hit a leaf value, we suspend the stack in the `FORKED`.
                                // When the fiber resolves, it can bubble back up the tree.
                                fid = fiberId++;
                                status = RETURN;
                                tmp = step;
                                step = new Aff(FORKED, fid, new Aff(CONS, head, tail), EMPTY);
                                tmp = Fiber(util, supervisor, tmp);
                                tmp.onComplete({
                                    rethrow: false,
                                    handler: resolve(step)
                                })();
                                fibers[fid] = tmp;
                                if (supervisor) supervisor.register(tmp);
                        }
                        break;
                    case RETURN:
                        // Terminal case, we are back at the root.
                        if (head === null) break loop;
                        // If we are done with the right side, we need to continue down the
                        // left. Otherwise we should continue up the stack.
                        if (head._1 === EMPTY) {
                            head._1 = step;
                            status = CONTINUE;
                            step = head._2;
                            head._2 = EMPTY;
                        } else {
                            head._2 = step;
                            step = head;
                            if (tail === null) head = null;
                            else {
                                head = tail._1;
                                tail = tail._2;
                            }
                        }
                }
            }
            // Keep a reference to the tree root so it can be cancelled.
            root = step;
            for(fid = 0; fid < fiberId; fid++)fibers[fid].run();
        }
        // Cancels the entire tree. If there are already subtrees being canceled,
        // we need to first cancel those joins. We will then add fresh joins for
        // all pending branches including those that were in the process of being
        // canceled.
        function cancel(error, cb) {
            interrupt = util.left(error);
            var innerKills;
            for(var kid in kills)if (kills.hasOwnProperty(kid)) {
                innerKills = kills[kid];
                for(kid in innerKills)if (innerKills.hasOwnProperty(kid)) innerKills[kid]();
            }
            kills = null;
            var newKills = kill(error, root, cb);
            return function(killError) {
                return new Aff(ASYNC, function(killCb) {
                    return function() {
                        for(var kid in newKills)if (newKills.hasOwnProperty(kid)) newKills[kid]();
                        return nonCanceler;
                    };
                });
            };
        }
        run();
        return function(killError) {
            return new Aff(ASYNC, function(killCb) {
                return function() {
                    return cancel(killError, killCb);
                };
            });
        };
    }
    function sequential(util, supervisor, par) {
        return new Aff(ASYNC, function(cb) {
            return function() {
                return runPar(util, supervisor, par, cb);
            };
        });
    }
    Aff.EMPTY = EMPTY;
    Aff.Pure = AffCtr(PURE);
    Aff.Throw = AffCtr(THROW);
    Aff.Catch = AffCtr(CATCH);
    Aff.Sync = AffCtr(SYNC);
    Aff.Async = AffCtr(ASYNC);
    Aff.Bind = AffCtr(BIND);
    Aff.Bracket = AffCtr(BRACKET);
    Aff.Fork = AffCtr(FORK);
    Aff.Seq = AffCtr(SEQ);
    Aff.ParMap = AffCtr(MAP);
    Aff.ParApply = AffCtr(APPLY);
    Aff.ParAlt = AffCtr(ALT);
    Aff.Fiber = Fiber;
    Aff.Supervisor = Supervisor;
    Aff.Scheduler = Scheduler;
    Aff.nonCanceler = nonCanceler;
    return Aff;
}();
const $b28443a27438717a$export$68c6660df485915b = $b28443a27438717a$var$Aff.Pure;
const $b28443a27438717a$export$520252a01094c36e = $b28443a27438717a$var$Aff.Throw;
function $b28443a27438717a$export$eb5e86cd5464556e(aff) {
    return function(k) {
        return $b28443a27438717a$var$Aff.Catch(aff, k);
    };
}
function $b28443a27438717a$export$a0135aecf4a782ab(f) {
    return function(aff) {
        if (aff.tag === $b28443a27438717a$var$Aff.Pure.tag) return $b28443a27438717a$var$Aff.Pure(f(aff._1));
        else return $b28443a27438717a$var$Aff.Bind(aff, function(value) {
            return $b28443a27438717a$var$Aff.Pure(f(value));
        });
    };
}
function $b28443a27438717a$export$8fe95d71d8c6b6f3(aff) {
    return function(k) {
        return $b28443a27438717a$var$Aff.Bind(aff, k);
    };
}
function $b28443a27438717a$export$f97e7884af471963(immediate) {
    return function(aff) {
        return $b28443a27438717a$var$Aff.Fork(immediate, aff);
    };
}
const $b28443a27438717a$export$3c6532f01a0290eb = $b28443a27438717a$var$Aff.Sync;
function $b28443a27438717a$export$68695d37eb163711(f) {
    return function(aff) {
        return $b28443a27438717a$var$Aff.ParMap(f, aff);
    };
}
function $b28443a27438717a$export$bce00526579b3344(aff1) {
    return function(aff2) {
        return $b28443a27438717a$var$Aff.ParApply(aff1, aff2);
    };
}
function $b28443a27438717a$export$6a44b66c7edadaa(aff1) {
    return function(aff2) {
        return $b28443a27438717a$var$Aff.ParAlt(aff1, aff2);
    };
}
const $b28443a27438717a$export$49d5975414e0a979 = $b28443a27438717a$var$Aff.Async;
function $b28443a27438717a$export$9ad792f02752f447(acquire) {
    return function(options) {
        return function(k) {
            return $b28443a27438717a$var$Aff.Bracket(acquire, options, k);
        };
    };
}
function $b28443a27438717a$export$f24188c8fd3f1234(util, aff) {
    return function() {
        return $b28443a27438717a$var$Aff.Fiber(util, null, aff);
    };
}
function $b28443a27438717a$export$7a3baea9562462c7(util, aff) {
    return function() {
        var supervisor = $b28443a27438717a$var$Aff.Supervisor(util);
        return {
            fiber: $b28443a27438717a$var$Aff.Fiber(util, supervisor, aff),
            supervisor: supervisor
        };
    };
}
function $b28443a27438717a$export$a494cc11bfc0c750(error, supervisor, cb) {
    return supervisor.killAll(error, cb);
}
const $b28443a27438717a$export$389c1406f5ae6ae7 = function() {
    function setDelay(n, k) {
        if (n === 0 && typeof setImmediate !== "undefined") return setImmediate(k);
        else return setTimeout(k, n);
    }
    function clearDelay(n, t) {
        if (n === 0 && typeof clearImmediate !== "undefined") return clearImmediate(t);
        else return clearTimeout(t);
    }
    return function(right, ms) {
        return $b28443a27438717a$var$Aff.Async(function(cb) {
            return function() {
                var timer = setDelay(ms, cb(right()));
                return function() {
                    return $b28443a27438717a$var$Aff.Sync(function() {
                        return right(clearDelay(ms, timer));
                    });
                };
            };
        });
    };
}();
const $b28443a27438717a$export$139486a45824a247 = $b28443a27438717a$var$Aff.Seq;









// Generated by purs version 0.15.15


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15












var $fca560e14229da4e$export$14010cd19909b6b = function(x) {
    return x;
};
var $fca560e14229da4e$export$2a106bc5b2e64dce = function(f) {
    return function(v) {
        return function(k) {
            return v(f(k));
        };
    };
};
var $fca560e14229da4e$export$358211fab263c66b = function(v) {
    return function(k) {
        return v(k);
    };
};
var $fca560e14229da4e$export$5419b7e78c76e565 = {
    Coercible0: function() {
        return undefined;
    }
};
var $fca560e14229da4e$export$6a2bb59a0c53ce17 = {
    lift: function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        return function(m) {
            return function(k) {
                return bind(m)(k);
            };
        };
    }
};
var $fca560e14229da4e$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($fca560e14229da4e$export$6a2bb59a0c53ce17);
var $fca560e14229da4e$export$604f139dbf56bccf = function(f) {
    return function(v) {
        return function(k) {
            return f(v(k));
        };
    };
};
var $fca560e14229da4e$export$232156ef715cfc9b = function(dictFunctor) {
    return {
        map: function(f) {
            return function(v) {
                return function(k) {
                    return v(function(a) {
                        return k(f(a));
                    });
                };
            };
        }
    };
};
var $fca560e14229da4e$export$6b05a2ec606a3559 = function(dictApply) {
    var functorContT1 = $fca560e14229da4e$export$232156ef715cfc9b(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(k) {
                    return v(function(g) {
                        return v1(function(a) {
                            return k(g(a));
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return functorContT1;
        }
    };
};
var $fca560e14229da4e$export$91905d227b995e9d = function(dictBind) {
    var applyContT1 = $fca560e14229da4e$export$6b05a2ec606a3559(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(k) {
                return function(k$prime) {
                    return v(function(a) {
                        var v1 = k(a);
                        return v1(k$prime);
                    });
                };
            };
        },
        Apply0: function() {
            return applyContT1;
        }
    };
};
var $fca560e14229da4e$export$ebd715a8b64afb39 = function(dictApply) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($fca560e14229da4e$export$6b05a2ec606a3559(dictApply));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $fca560e14229da4e$export$d73f0595e894296c = function(dictApplicative) {
    var applyContT1 = $fca560e14229da4e$export$6b05a2ec606a3559(dictApplicative.Apply0());
    return {
        pure: function(a) {
            return function(k) {
                return k(a);
            };
        },
        Apply0: function() {
            return applyContT1;
        }
    };
};
var $fca560e14229da4e$export$735f43b0215ad39 = function(dictMonad) {
    var applicativeContT1 = $fca560e14229da4e$export$d73f0595e894296c(dictMonad.Applicative0());
    var bindContT1 = $fca560e14229da4e$export$91905d227b995e9d(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeContT1;
        },
        Bind1: function() {
            return bindContT1;
        }
    };
};
var $fca560e14229da4e$export$6062b41302ddcd80 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        ask: $fca560e14229da4e$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$dbf903f187194ce5 = function(dictMonadReader) {
    var MonadAsk0 = dictMonadReader.MonadAsk0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(MonadAsk0.Monad0().Bind1());
    var ask = $74738728c27df511$export$1b4aee0b51c3def8(MonadAsk0);
    var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
    var monadAskContT1 = $fca560e14229da4e$export$6062b41302ddcd80(MonadAsk0);
    return {
        local: function(f) {
            return function(v) {
                return function(k) {
                    return bind(ask)(function(r) {
                        return local(f)(v(function() {
                            var $94 = local($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(r));
                            return function($95) {
                                return $94(k($95));
                            };
                        }()));
                    });
                };
            };
        },
        MonadAsk0: function() {
            return monadAskContT1;
        }
    };
};
var $fca560e14229da4e$export$fd982f3f83dedfc9 = function(dictMonad) {
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(dictMonad);
    return {
        callCC: function(f) {
            return function(k) {
                var v = f(function(a) {
                    return function(v1) {
                        return k(a);
                    };
                });
                return v(k);
            };
        },
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$35d988300b9091c9 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        liftEffect: function() {
            var $96 = $fca560e14229da4e$var$lift(Monad0);
            var $97 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($98) {
                return $96($97($98));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$1aa60909d07c5b2d = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        state: function() {
            var $99 = $fca560e14229da4e$var$lift(Monad0);
            var $100 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
            return function($101) {
                return $99($100($101));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$845d7a4c5796dca2 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        liftST: function() {
            var $102 = $fca560e14229da4e$var$lift(Monad0);
            var $103 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($104) {
                return $102($103($104));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$e824ef6fc9053d43 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fca560e14229da4e$export$d73f0595e894296c(dictApplicative));
    var semigroupContT1 = $fca560e14229da4e$export$ebd715a8b64afb39(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupContT2 = semigroupContT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupContT2;
            }
        };
    };
};



// Generated by purs version 0.15.15



















var $7038ccc2f7f5bbce$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $7038ccc2f7f5bbce$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $7038ccc2f7f5bbce$export$ad3c05b40854bc17 = function(x) {
    return x;
};
var $7038ccc2f7f5bbce$export$74b507a1130daad6 = function(v) {
    return v;
};
var $7038ccc2f7f5bbce$export$e423059046893ebc = {
    Coercible0: function() {
        return undefined;
    }
};
var $7038ccc2f7f5bbce$export$84eda9cb75492c36 = {
    lift: function(dictMonad) {
        var $163 = $d3d065da31679be1$export$167848c32e61a4d4(dictMonad)($06733ae99ed4f534$export$8a67b48435b5d073.create);
        return function($164) {
            return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($163($164));
        };
    }
};
var $7038ccc2f7f5bbce$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($7038ccc2f7f5bbce$export$84eda9cb75492c36);
var $7038ccc2f7f5bbce$export$d0ac118ccd5cda07 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $7038ccc2f7f5bbce$export$3bf77092340654e0 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return map1($7038ccc2f7f5bbce$var$map(f))(v);
            };
        }
    };
};
var $7038ccc2f7f5bbce$export$63cf87c0678a1d2c = function(dictMonad) {
    return {
        Applicative0: function() {
            return $7038ccc2f7f5bbce$export$4797150488333da1(dictMonad);
        },
        Bind1: function() {
            return $7038ccc2f7f5bbce$export$c4ec8f671a263573(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$c4ec8f671a263573 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return {
        bind: function(v) {
            return function(f) {
                return bind(v)(function(v1) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        var v2 = f(v1.value0);
                        return v2;
                    }
                    throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 55, column 11 - line 57, column 42): " + [
                        v1.constructor.name
                    ]);
                });
            };
        },
        Apply0: function() {
            return $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e = function(dictMonad) {
    var functorMaybeT1 = $7038ccc2f7f5bbce$export$3bf77092340654e0(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonad)),
        Functor0: function() {
            return functorMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$4797150488333da1 = function(dictMonad) {
    return {
        pure: function() {
            var $165 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function($166) {
                return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($165($06733ae99ed4f534$export$8a67b48435b5d073.create($166)));
            };
        }(),
        Apply0: function() {
            return $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$984e03b79d8c6656 = function(dictMonad) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $7038ccc2f7f5bbce$export$36c6624b0bef0761 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        ask: $7038ccc2f7f5bbce$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$d73769631c0edb39 = function(dictMonadReader) {
    var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
    var monadAskMaybeT1 = $7038ccc2f7f5bbce$export$36c6624b0bef0761(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(local(f));
        },
        MonadAsk0: function() {
            return monadAskMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$ec6a88a02083ed25 = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return callCC(function(c) {
                var v = f(function(a) {
                    return c(new $06733ae99ed4f534$export$8a67b48435b5d073(a));
                });
                return v;
            });
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$2f876a9cb1e407d9 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        liftEffect: function() {
            var $167 = $7038ccc2f7f5bbce$var$lift(Monad0);
            var $168 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($169) {
                return $167($168($169));
            };
        }(),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$7b9e3f37a9f7f6b2 = function(dictMonadRec) {
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        tailRecM: function(f) {
            var $170 = tailRecM(function(a) {
                var v = f(a);
                return bind(v)(function(m$prime) {
                    return pure(function() {
                        if (m$prime instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$7fe28cb29e71bf10($06733ae99ed4f534$export$bebe9059409a0d04.value);
                        if (m$prime instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && m$prime.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(m$prime.value0.value0);
                        if (m$prime instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && m$prime.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $06733ae99ed4f534$export$8a67b48435b5d073(m$prime.value0.value0));
                        throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 83, column 16 - line 86, column 43): " + [
                            m$prime.constructor.name
                        ]);
                    }());
                });
            });
            return function($171) {
                return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($170($171));
            };
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$99cfcc8edd025934 = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var lift1 = $7038ccc2f7f5bbce$var$lift(Monad0);
    var state = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        state: function(f) {
            return lift1(state(f));
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$907950ecc201e8fb = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad1);
    return {
        tell: function() {
            var $172 = $7038ccc2f7f5bbce$var$lift(Monad1);
            var $173 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($174) {
                return $172($173($174));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$5afebe755b331e96 = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    var pass = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellMaybeT1 = $7038ccc2f7f5bbce$export$907950ecc201e8fb(MonadTell1);
    return {
        listen: $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(function(m) {
            return bind(listen(m))(function(v) {
                return pure($7038ccc2f7f5bbce$var$map(function(r) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(r, v.value1);
                })(v.value0));
            });
        }),
        pass: $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(function(m) {
            return pass(bind(m)(function(a) {
                return pure(function() {
                    if (a instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $71f2e2e9476163f8$export$1908877435b1d5e9($06733ae99ed4f534$export$bebe9059409a0d04.value, $7038ccc2f7f5bbce$var$identity);
                    if (a instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $06733ae99ed4f534$export$8a67b48435b5d073(a.value0.value0), a.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 120, column 10 - line 122, column 43): " + [
                        a.constructor.name
                    ]);
                }());
            }));
        }),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$8908e8a28a021e1c = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var lift1 = $7038ccc2f7f5bbce$var$lift(Monad0);
    var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        throwError: function(e) {
            return lift1(throwError(e));
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$f77b055a7835b1d0 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowMaybeT1 = $7038ccc2f7f5bbce$export$8908e8a28a021e1c(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return catchError(v)(function(a) {
                    var v1 = h(a);
                    return v1;
                });
            };
        },
        MonadThrow0: function() {
            return monadThrowMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$4033508ee81d9e59 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        liftST: function() {
            var $175 = $7038ccc2f7f5bbce$var$lift(Monad0);
            var $176 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($177) {
                return $175($176($177));
            };
        }(),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$20ac3a2d3113d020 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7038ccc2f7f5bbce$export$4797150488333da1(dictMonad));
    var semigroupMaybeT1 = $7038ccc2f7f5bbce$export$984e03b79d8c6656(dictMonad);
    return function(dictMonoid) {
        var semigroupMaybeT2 = semigroupMaybeT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupMaybeT2;
            }
        };
    };
};
var $7038ccc2f7f5bbce$export$e14125e5a208a0c9 = function(dictMonad) {
    var Bind1 = dictMonad.Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var functorMaybeT1 = $7038ccc2f7f5bbce$export$3bf77092340654e0(Bind1.Apply0().Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return bind(v)(function(m) {
                    if (m instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                    return pure(m);
                });
            };
        },
        Functor0: function() {
            return functorMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$140a10b5716e1900 = function(dictMonad) {
    var altMaybeT1 = $7038ccc2f7f5bbce$export$e14125e5a208a0c9(dictMonad);
    return {
        empty: $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0())($06733ae99ed4f534$export$bebe9059409a0d04.value),
        Alt0: function() {
            return altMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$68df7d2debd59865 = function(dictMonad) {
    var applicativeMaybeT1 = $7038ccc2f7f5bbce$export$4797150488333da1(dictMonad);
    var plusMaybeT1 = $7038ccc2f7f5bbce$export$140a10b5716e1900(dictMonad);
    return {
        Applicative0: function() {
            return applicativeMaybeT1;
        },
        Plus1: function() {
            return plusMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$d4030eff1969644e = function(dictMonad) {
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonad);
    var alternativeMaybeT1 = $7038ccc2f7f5bbce$export$68df7d2debd59865(dictMonad);
    return {
        Monad0: function() {
            return monadMaybeT1;
        },
        Alternative1: function() {
            return alternativeMaybeT1;
        }
    };
};


// Generated by purs version 0.15.15













// Generated by purs version 0.15.15






// Generated by purs version 0.15.15
var $ae8714ffa2598cf8$var$To = function(x) {
    return x;
};
var $ae8714ffa2598cf8$var$From = function(x) {
    return x;
};
var $ae8714ffa2598cf8$export$9fc2f52ae8ba6578 = {
    proof: function(a) {
        return a;
    },
    Coercible0: function() {
        return undefined;
    }
};
var $ae8714ffa2598cf8$export$3d466392f5188420 = function(dict) {
    return dict.proof;
};
var $ae8714ffa2598cf8$export$2c618a4308a30424 = function(dictTypeEquals) {
    var v = $ae8714ffa2598cf8$export$3d466392f5188420(dictTypeEquals)(function(a) {
        return a;
    });
    return v;
};
var $ae8714ffa2598cf8$export$6788812c4e6611e6 = function(dictTypeEquals) {
    var v = $ae8714ffa2598cf8$export$3d466392f5188420(dictTypeEquals)(function(a) {
        return a;
    });
    return v;
};


var $3ce830dde03d3389$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $3ce830dde03d3389$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $3ce830dde03d3389$export$c2a69422949c6b5c = {
    distribute: function(dictFunctor) {
        var $34 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($3ce830dde03d3389$var$unwrap);
        return function($35) {
            return $50c50d1f444e5fa4$export$544bf02140fa9a77($34($35));
        };
    },
    collect: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $36 = map(function($38) {
                return $3ce830dde03d3389$var$unwrap(f($38));
            });
            return function($37) {
                return $50c50d1f444e5fa4$export$544bf02140fa9a77($36($37));
            };
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $3ce830dde03d3389$export$f02a9ddbe4480f19 = function(dict) {
    return dict.distribute;
};
var $3ce830dde03d3389$export$31ac6c2237b1bf1b = {
    distribute: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(a) {
            return function(e) {
                return map(function(v) {
                    return v(e);
                })(a);
            };
        };
    },
    collect: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $39 = $3ce830dde03d3389$export$f02a9ddbe4480f19($3ce830dde03d3389$export$31ac6c2237b1bf1b)(dictFunctor);
            var $40 = map(f);
            return function($41) {
                return $39($40($41));
            };
        };
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$11c8d16a3c15d11b;
    }
};
var $3ce830dde03d3389$export$e6005abdfe1aac80 = function(dictDistributive) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictDistributive.Functor0());
    var distribute1 = $3ce830dde03d3389$export$f02a9ddbe4480f19(dictDistributive);
    return function(dictFunctor) {
        var distribute2 = distribute1(dictFunctor);
        return function(f) {
            var $42 = map(f);
            return function($43) {
                return $42(distribute2($43));
            };
        };
    };
};
var $3ce830dde03d3389$export$2d5a930f1676b9b7 = function(dictDistributive) {
    var distribute1 = $3ce830dde03d3389$export$f02a9ddbe4480f19(dictDistributive);
    return function(dictFunctor) {
        var distribute2 = distribute1(dictFunctor);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $44 = map(f);
            return function($45) {
                return distribute2($44($45));
            };
        };
    };
};
var $3ce830dde03d3389$export$76df48f9f3fb8eb1 = function(dictTypeEquals) {
    var from = $ae8714ffa2598cf8$export$6788812c4e6611e6(dictTypeEquals);
    return {
        collect: function(dictFunctor) {
            return $3ce830dde03d3389$export$2d5a930f1676b9b7($3ce830dde03d3389$export$76df48f9f3fb8eb1(dictTypeEquals))(dictFunctor);
        },
        distribute: function(dictFunctor) {
            var $46 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(from($05149ea687d6b460$export$523c0b569236b342));
            var $47 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($71f2e2e9476163f8$export$6f71268a1666ab58);
            return function($48) {
                return $46($47($48));
            };
        },
        Functor0: function() {
            return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
        }
    };
};
var $3ce830dde03d3389$export$bb44f104e3c54dae = function(dict) {
    return dict.collect;
};
var $3ce830dde03d3389$export$f13cbf7f76d41467 = function(dictDistributive) {
    var collect1 = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    return function(dictFunctor) {
        return collect1(dictFunctor)($3ce830dde03d3389$var$identity);
    };
};







var $848780da1bf26d9d$export$ea3c61b219e01d1e = function(x) {
    return x;
};
var $848780da1bf26d9d$export$36ee99cc8d1d67c9 = function(f) {
    return function(v) {
        return function($152) {
            return v(f($152));
        };
    };
};
var $848780da1bf26d9d$export$f356de2c51baae29 = function(v) {
    return v;
};
var $848780da1bf26d9d$export$f52dceb6bbe9cc1f = {
    Coercible0: function() {
        return undefined;
    }
};
var $848780da1bf26d9d$export$95510d0cd7e6e7eb = {
    lift: function(dictMonad) {
        return function($153) {
            return $848780da1bf26d9d$export$ea3c61b219e01d1e($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($153));
        };
    }
};
var $848780da1bf26d9d$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($848780da1bf26d9d$export$95510d0cd7e6e7eb);
var $848780da1bf26d9d$export$1b8048a192a96779 = function(f) {
    return function(v) {
        return function($154) {
            return f(v($154));
        };
    };
};
var $848780da1bf26d9d$export$9ef8da126720992c = function(dictFunctor) {
    return {
        map: function() {
            var $155 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
            return function($156) {
                return $848780da1bf26d9d$export$1b8048a192a96779($155($156));
            };
        }()
    };
};
var $848780da1bf26d9d$export$4b73f9411376f1b4 = function(dictDistributive) {
    var collect = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictDistributive.Functor0());
    return {
        distribute: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(a) {
                return function(e) {
                    return collect1(function(r) {
                        return r(e);
                    })(a);
                };
            };
        },
        collect: function(dictFunctor) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
            return function(f) {
                var $157 = $3ce830dde03d3389$export$f02a9ddbe4480f19($848780da1bf26d9d$export$4b73f9411376f1b4(dictDistributive))(dictFunctor);
                var $158 = map(f);
                return function($159) {
                    return $157($158($159));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$fee188993a7996b7 = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(r) {
                    return apply(v(r))(v1(r));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$4255fb962d7d3c76 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var applyReaderT1 = $848780da1bf26d9d$export$fee188993a7996b7(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(k) {
                return function(r) {
                    return bind(v(r))(function(a) {
                        var v1 = k(a);
                        return v1(r);
                    });
                };
            };
        },
        Apply0: function() {
            return applyReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$12572275428491c2 = function(dictApply) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($848780da1bf26d9d$export$fee188993a7996b7(dictApply));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $848780da1bf26d9d$export$aef633589549fee0 = function(dictApplicative) {
    var applyReaderT1 = $848780da1bf26d9d$export$fee188993a7996b7(dictApplicative.Apply0());
    return {
        pure: function() {
            var $160 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
            return function($161) {
                return $848780da1bf26d9d$export$ea3c61b219e01d1e($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($160($161)));
            };
        }(),
        Apply0: function() {
            return applyReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$6f721f6865c71dd2 = function(dictMonad) {
    var applicativeReaderT1 = $848780da1bf26d9d$export$aef633589549fee0(dictMonad.Applicative0());
    var bindReaderT1 = $848780da1bf26d9d$export$4255fb962d7d3c76(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeReaderT1;
        },
        Bind1: function() {
            return bindReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$1fc6951fa9cc0730 = function(dictMonad) {
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonad);
    return {
        ask: $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0()),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$202df576a32d0b15 = function(dictMonad) {
    var monadAskReaderT1 = $848780da1bf26d9d$export$1fc6951fa9cc0730(dictMonad);
    return {
        local: $848780da1bf26d9d$export$36ee99cc8d1d67c9,
        MonadAsk0: function() {
            return monadAskReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$9f6c922afb6673fe = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return function(r) {
                return callCC(function(c) {
                    var v = f(function($162) {
                        return $848780da1bf26d9d$export$ea3c61b219e01d1e($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(c($162)));
                    });
                    return v(r);
                });
            };
        },
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$a554ebf369a3f56d = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        liftEffect: function() {
            var $163 = $848780da1bf26d9d$var$lift(Monad0);
            var $164 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($165) {
                return $163($164($165));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$b063aaccf75fba13 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bindFlipped = $70cd3177464e7915$export$f2077a1c19a006d9(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        tailRecM: function(k) {
            return function(a) {
                var k$prime = function(r) {
                    return function(a$prime) {
                        var v = k(a$prime);
                        return bindFlipped(pure)(v(r));
                    };
                };
                return function(r) {
                    return tailRecM(k$prime(r))(a);
                };
            };
        },
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$48d7aff14d826a4f = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        state: function() {
            var $166 = $848780da1bf26d9d$var$lift(Monad0);
            var $167 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
            return function($168) {
                return $166($167($168));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$ab1235cf7f047d07 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad1);
    return {
        tell: function() {
            var $169 = $848780da1bf26d9d$var$lift(Monad1);
            var $170 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($171) {
                return $169($170($171));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$662fa4b34fb6720c = function(dictMonadWriter) {
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellReaderT1 = $848780da1bf26d9d$export$ab1235cf7f047d07(dictMonadWriter.MonadTell1());
    return {
        listen: $848780da1bf26d9d$export$1b8048a192a96779($2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter)),
        pass: $848780da1bf26d9d$export$1b8048a192a96779($2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter)),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$1b067e2856bff729 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        throwError: function() {
            var $172 = $848780da1bf26d9d$var$lift(Monad0);
            var $173 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
            return function($174) {
                return $172($173($174));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$484cd3c856ffc7 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowReaderT1 = $848780da1bf26d9d$export$1b067e2856bff729(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return function(r) {
                    return catchError(v(r))(function(e) {
                        var v1 = h(e);
                        return v1(r);
                    });
                };
            };
        },
        MonadThrow0: function() {
            return monadThrowReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$162b6a611607bf69 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        liftST: function() {
            var $175 = $848780da1bf26d9d$var$lift(Monad0);
            var $176 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($177) {
                return $175($176($177));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$df55f2197442fd9 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($848780da1bf26d9d$export$aef633589549fee0(dictApplicative));
    var semigroupReaderT1 = $848780da1bf26d9d$export$12572275428491c2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupReaderT2 = semigroupReaderT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupReaderT2;
            }
        };
    };
};
var $848780da1bf26d9d$export$32cadcb66dd98ef3 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(r) {
                    return alt(v(r))(v1(r));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$97f8c30f9c69a13c = function(dictPlus) {
    var altReaderT1 = $848780da1bf26d9d$export$32cadcb66dd98ef3(dictPlus.Alt0());
    return {
        empty: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus)),
        Alt0: function() {
            return altReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$8bebb77f5bc043a9 = function(dictAlternative) {
    var applicativeReaderT1 = $848780da1bf26d9d$export$aef633589549fee0(dictAlternative.Applicative0());
    var plusReaderT1 = $848780da1bf26d9d$export$97f8c30f9c69a13c(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeReaderT1;
        },
        Plus1: function() {
            return plusReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$3772d6c9d5f8e735 = function(dictMonadPlus) {
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonadPlus.Monad0());
    var alternativeReaderT1 = $848780da1bf26d9d$export$8bebb77f5bc043a9(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadReaderT1;
        },
        Alternative1: function() {
            return alternativeReaderT1;
        }
    };
};


// Generated by purs version 0.15.15



















var $d9ef009191ddae40$export$6bef9d59f22e8880 = function(x) {
    return x;
};
var $d9ef009191ddae40$export$973e92d98e897dbf = function(v) {
    return v;
};
var $d9ef009191ddae40$export$d5b925da5ee69c31 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d9ef009191ddae40$export$6b749a3db2c2aac6 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return {
        lift: function(dictMonad) {
            var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
            var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function(m) {
                return bind(m)(function(a) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
                });
            };
        }
    };
};
var $d9ef009191ddae40$export$c950a71321ef1ffc = function(f) {
    return function(v) {
        return f(v);
    };
};
var $d9ef009191ddae40$export$502115c714790859 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return $d9ef009191ddae40$export$c950a71321ef1ffc(map(function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v.value0), v.value1);
            }));
        }
    };
};
var $d9ef009191ddae40$export$730fbe746bee115d = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return map($71f2e2e9476163f8$export$6f71268a1666ab58)(v);
    };
};
var $d9ef009191ddae40$export$2f46a8de9e2e0acc = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(dictApply) {
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
        var Functor0 = dictApply.Functor0();
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
        var functorWriterT1 = $d9ef009191ddae40$export$502115c714790859(Functor0);
        return {
            apply: function(v) {
                return function(v1) {
                    var k = function(v3) {
                        return function(v4) {
                            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v3.value0(v4.value0), append(v3.value1)(v4.value1));
                        };
                    };
                    return apply(map(k)(v))(v1);
                };
            },
            Functor0: function() {
                return functorWriterT1;
            }
        };
    };
};
var $d9ef009191ddae40$export$4483e5256f36d121 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    var applyWriterT1 = $d9ef009191ddae40$export$2f46a8de9e2e0acc(dictSemigroup);
    return function(dictBind) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
        var Apply0 = dictBind.Apply0();
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var applyWriterT2 = applyWriterT1(Apply0);
        return {
            bind: function(v) {
                return function(k) {
                    return bind(v)(function(v1) {
                        var v2 = k(v1.value0);
                        return map(function(v3) {
                            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v3.value0, append(v1.value1)(v3.value1));
                        })(v2);
                    });
                };
            },
            Apply0: function() {
                return applyWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8c475e05f959fff2 = function(dictApply) {
    return function(dictSemigroup) {
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($d9ef009191ddae40$export$2f46a8de9e2e0acc(dictSemigroup)(dictApply));
        return function(dictSemigroup1) {
            return {
                append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup1))
            };
        };
    };
};
var $d9ef009191ddae40$export$c3b0a193a5475c40 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var applyWriterT1 = $d9ef009191ddae40$export$2f46a8de9e2e0acc(dictMonoid.Semigroup0());
    return function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var applyWriterT2 = applyWriterT1(dictApplicative.Apply0());
        return {
            pure: function(a) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
            },
            Apply0: function() {
                return applyWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$a45df43c41b778a = function(dictMonoid) {
    var applicativeWriterT1 = $d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid);
    var bindWriterT1 = $d9ef009191ddae40$export$4483e5256f36d121(dictMonoid.Semigroup0());
    return function(dictMonad) {
        var applicativeWriterT2 = applicativeWriterT1(dictMonad.Applicative0());
        var bindWriterT2 = bindWriterT1(dictMonad.Bind1());
        return {
            Applicative0: function() {
                return applicativeWriterT2;
            },
            Bind1: function() {
                return bindWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$2b88d21fdbd23b84 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadAsk) {
        var Monad0 = dictMonadAsk.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            ask: lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$1e8e23b27bf4b6eb = function(dictMonoid) {
    var monadAskWriterT1 = $d9ef009191ddae40$export$2b88d21fdbd23b84(dictMonoid);
    return function(dictMonadReader) {
        var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
        var monadAskWriterT2 = monadAskWriterT1(dictMonadReader.MonadAsk0());
        return {
            local: function(f) {
                return $d9ef009191ddae40$export$c950a71321ef1ffc(local(f));
            },
            MonadAsk0: function() {
                return monadAskWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$7520b5391c6ad7c7 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadCont) {
        var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
        var monadWriterT2 = monadWriterT1(dictMonadCont.Monad0());
        return {
            callCC: function(f) {
                return callCC(function(c) {
                    var v = f(function(a) {
                        return c(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
                    });
                    return v;
                });
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$29fece65832b4369 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            liftEffect: function() {
                var $259 = lift(Monad0);
                var $260 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
                return function($261) {
                    return $259($260($261));
                };
            }(),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$36179168852a11d0 = function(dictMonoid) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadRec) {
        var Monad0 = dictMonadRec.Monad0();
        var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
        var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            tailRecM: function(f) {
                return function(a) {
                    var f$prime = function(v) {
                        var v1 = f(v.value0);
                        return bind(v1)(function(v2) {
                            return pure(function() {
                                if (v2.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, append(v.value1)(v2.value1)));
                                if (v2.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, append(v.value1)(v2.value1)));
                                throw new Error("Failed pattern match at Control.Monad.Writer.Trans (line 84, column 16 - line 86, column 47): " + [
                                    v2.value0.constructor.name
                                ]);
                            }());
                        });
                    };
                    return tailRecM(f$prime)(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
                };
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$6594c621b12bf0b9 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadState) {
        var Monad0 = dictMonadState.Monad0();
        var lift1 = lift(Monad0);
        var state = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            state: function(f) {
                return lift1(state(f));
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$b022f808a9791225 = function(dictMonoid) {
    var Semigroup0 = dictMonoid.Semigroup0();
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonad) {
        var monadWriterT2 = monadWriterT1(dictMonad);
        return {
            tell: function() {
                var $262 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
                var $263 = $71f2e2e9476163f8$export$1908877435b1d5e9.create($05149ea687d6b460$export$523c0b569236b342);
                return function($264) {
                    return $d9ef009191ddae40$export$6bef9d59f22e8880($262($263($264)));
                };
            }(),
            Semigroup0: function() {
                return Semigroup0;
            },
            Monad1: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$f2385bf9afd45c19 = function(dictMonoid) {
    var monadTellWriterT1 = $d9ef009191ddae40$export$b022f808a9791225(dictMonoid);
    return function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        var monadTellWriterT2 = monadTellWriterT1(dictMonad);
        return {
            listen: function(v) {
                return bind(v)(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v1.value1), v1.value1));
                });
            },
            pass: function(v) {
                return bind(v)(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0.value0, v1.value0.value1(v1.value1)));
                });
            },
            Monoid0: function() {
                return dictMonoid;
            },
            MonadTell1: function() {
                return monadTellWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8fbe11284b53cf18 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadThrow) {
        var Monad0 = dictMonadThrow.Monad0();
        var lift1 = lift(Monad0);
        var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            throwError: function(e) {
                return lift1(throwError(e));
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$f7d1d5bacfa0742c = function(dictMonoid) {
    var monadThrowWriterT1 = $d9ef009191ddae40$export$8fbe11284b53cf18(dictMonoid);
    return function(dictMonadError) {
        var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
        var monadThrowWriterT2 = monadThrowWriterT1(dictMonadError.MonadThrow0());
        return {
            catchError: function(v) {
                return function(h) {
                    return catchError(v)(function(e) {
                        var v1 = h(e);
                        return v1;
                    });
                };
            },
            MonadThrow0: function() {
                return monadThrowWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$3e5fc362694e79bf = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadST) {
        var Monad0 = dictMonadST.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            liftST: function() {
                var $265 = lift(Monad0);
                var $266 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
                return function($267) {
                    return $265($266($267));
                };
            }(),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8a353f8c5b798525 = function(dictApplicative) {
    var semigroupWriterT1 = $d9ef009191ddae40$export$8c475e05f959fff2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid)(dictApplicative));
        var semigroupWriterT2 = semigroupWriterT1(dictMonoid.Semigroup0());
        return function(dictMonoid1) {
            var semigroupWriterT3 = semigroupWriterT2(dictMonoid1.Semigroup0());
            return {
                mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid1)),
                Semigroup0: function() {
                    return semigroupWriterT3;
                }
            };
        };
    };
};
var $d9ef009191ddae40$export$6f6793d950011736 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorWriterT1 = $d9ef009191ddae40$export$502115c714790859(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return alt(v)(v1);
            };
        },
        Functor0: function() {
            return functorWriterT1;
        }
    };
};
var $d9ef009191ddae40$export$a57a36ca2cee11fb = function(dictPlus) {
    var altWriterT1 = $d9ef009191ddae40$export$6f6793d950011736(dictPlus.Alt0());
    return {
        empty: $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus),
        Alt0: function() {
            return altWriterT1;
        }
    };
};
var $d9ef009191ddae40$export$c91ecc30f23c76ec = function(dictMonoid) {
    var applicativeWriterT1 = $d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid);
    return function(dictAlternative) {
        var applicativeWriterT2 = applicativeWriterT1(dictAlternative.Applicative0());
        var plusWriterT1 = $d9ef009191ddae40$export$a57a36ca2cee11fb(dictAlternative.Plus1());
        return {
            Applicative0: function() {
                return applicativeWriterT2;
            },
            Plus1: function() {
                return plusWriterT1;
            }
        };
    };
};
var $d9ef009191ddae40$export$1c68552a87a434af = function(dictMonoid) {
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    var alternativeWriterT1 = $d9ef009191ddae40$export$c91ecc30f23c76ec(dictMonoid);
    return function(dictMonadPlus) {
        var monadWriterT2 = monadWriterT1(dictMonadPlus.Monad0());
        var alternativeWriterT2 = alternativeWriterT1(dictMonadPlus.Alternative1());
        return {
            Monad0: function() {
                return monadWriterT2;
            },
            Alternative1: function() {
                return alternativeWriterT2;
            }
        };
    };
};





// Generated by purs version 0.15.15




// Generated by purs version 0.15.15


var $d0c5be72120caeb7$export$578ae18717ba10de = {
    cmap: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $d0c5be72120caeb7$export$b186cb408b99d7fc = function(dict) {
    return dict.cmap;
};
var $d0c5be72120caeb7$export$d0a699a1379b7fb5 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(x) {
        return function(f) {
            return cmap1(f)(x);
        };
    };
};
var $d0c5be72120caeb7$export$8c14e57e778d3873 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(a) {
            return map($58f3cdfbfe212d20$export$f172309911142386)(cmap1($58f3cdfbfe212d20$export$f172309911142386)(a));
        };
    };
};
var $d0c5be72120caeb7$export$dc224e55acb863f5 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(v) {
        return function(f) {
            return cmap1(f);
        };
    };
};



// Generated by purs version 0.15.15


var $9be1c75e3223ee2e$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $9be1c75e3223ee2e$var$wrap = /* #__PURE__ */ $4fa4836228a192cc$export$4997ffc0176396a6();
var $9be1c75e3223ee2e$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $9be1c75e3223ee2e$export$e10497e40cde5fd3 = {
    dimap: function(a2b) {
        return function(c2d) {
            return function(b2c) {
                return function($18) {
                    return c2d(b2c(a2b($18)));
                };
            };
        };
    }
};
var $9be1c75e3223ee2e$export$7c344215185fc3ac = function(dict) {
    return dict.dimap;
};
var $9be1c75e3223ee2e$export$48f54268254cf7d0 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function(a2b) {
        return dimap1(a2b)($9be1c75e3223ee2e$var$identity);
    };
};
var $9be1c75e3223ee2e$export$6630987c9d273301 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function(b2c) {
        return dimap1($9be1c75e3223ee2e$var$identity)(b2c);
    };
};
var $9be1c75e3223ee2e$export$93b4506d26e3367 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function() {
        return dimap1($9be1c75e3223ee2e$var$wrap)($9be1c75e3223ee2e$var$unwrap);
    };
};
var $9be1c75e3223ee2e$export$d25bf6793fd4dfcb = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function() {
        return function(v) {
            return dimap1($9be1c75e3223ee2e$var$unwrap)($9be1c75e3223ee2e$var$wrap);
        };
    };
};
var $9be1c75e3223ee2e$export$29d5d0b2414dfc5c = function(dictCategory) {
    var identity1 = $5be483788e0e6f04$export$f0954fd7d5368655(dictCategory);
    return function(dictProfunctor) {
        var rmap1 = $9be1c75e3223ee2e$export$6630987c9d273301(dictProfunctor);
        return function(f) {
            return rmap1(f)(identity1);
        };
    };
};



var $b5fb63758051b147$var$lcmap = /* #__PURE__ */ $9be1c75e3223ee2e$export$48f54268254cf7d0($9be1c75e3223ee2e$export$e10497e40cde5fd3);
var $b5fb63758051b147$export$c8d61c7aefcd2eb9 = function(x) {
    return x;
};
var $b5fb63758051b147$export$4b8724da343f8670 = function(dictExtend) {
    var composeCoKleisliFlipped = $c8f9cdd14046b503$export$fbe89af2ce156300(dictExtend);
    return {
        compose: function(v) {
            return function(v1) {
                return composeCoKleisliFlipped(v)(v1);
            };
        }
    };
};
var $b5fb63758051b147$export$7c2608c347081d34 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $65 = map(f);
                    return function($66) {
                        return g(v($65($66)));
                    };
                };
            };
        }
    };
};
var $b5fb63758051b147$export$1b28cf6e14cef765 = function(dictComonad) {
    var Functor0 = dictComonad.Extend0().Functor0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var extract = $b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad);
    var profunctorCostar1 = $b5fb63758051b147$export$7c2608c347081d34(Functor0);
    return {
        first: function(v) {
            return function(x) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v(map($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(x)), $71f2e2e9476163f8$export$6f71268a1666ab58(extract(x)));
            };
        },
        second: function(v) {
            return function(x) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9($71f2e2e9476163f8$export$9e770fa6ce19a9d6(extract(x)), v(map($71f2e2e9476163f8$export$6f71268a1666ab58)(x)));
            };
        },
        Profunctor0: function() {
            return profunctorCostar1;
        }
    };
};
var $b5fb63758051b147$export$95b15c3b108c70f1 = {
    Coercible0: function() {
        return undefined;
    }
};
var $b5fb63758051b147$export$538b19297a2c28a0 = function(f) {
    return function(v) {
        return $b5fb63758051b147$var$lcmap(f)(v);
    };
};
var $b5fb63758051b147$export$85082d7f68510c56 = {
    map: function(f) {
        return function(v) {
            return function($67) {
                return f(v($67));
            };
        };
    }
};
var $b5fb63758051b147$export$c2eec9047e1c22f6 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($b5fb63758051b147$export$85082d7f68510c56)
};
var $b5fb63758051b147$export$6ca61216e8ebd2dc = {
    distribute: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            return function(a) {
                return map(function(v) {
                    return v(a);
                })(f);
            };
        };
    },
    collect: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $68 = $3ce830dde03d3389$export$f02a9ddbe4480f19($b5fb63758051b147$export$6ca61216e8ebd2dc)(dictFunctor);
            var $69 = map(f);
            return function($70) {
                return $68($69($70));
            };
        };
    },
    Functor0: function() {
        return $b5fb63758051b147$export$85082d7f68510c56;
    }
};
var $b5fb63758051b147$export$45296f90ce78a5aa = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    var profunctorCostar1 = $b5fb63758051b147$export$7c2608c347081d34(dictFunctor);
    return {
        closed: function(v) {
            return function(g) {
                return function(x) {
                    return v(map(function(v1) {
                        return v1(x);
                    })(g));
                };
            };
        },
        Profunctor0: function() {
            return profunctorCostar1;
        }
    };
};
var $b5fb63758051b147$export$1b18a904dcda2b6c = function(dictComonad) {
    var semigroupoidCostar1 = $b5fb63758051b147$export$4b8724da343f8670(dictComonad.Extend0());
    return {
        identity: $b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad),
        Semigroupoid0: function() {
            return semigroupoidCostar1;
        }
    };
};
var $b5fb63758051b147$export$12684125bae58283 = function(dictContravariant) {
    var cmap = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return {
        bimap: function(f) {
            return function(g) {
                return function(v) {
                    var $71 = cmap(f);
                    return function($72) {
                        return g(v($71($72)));
                    };
                };
            };
        }
    };
};
var $b5fb63758051b147$export$bee433edbc7aed34 = {
    apply: function(v) {
        return function(v1) {
            return function(a) {
                return v(a)(v1(a));
            };
        };
    },
    Functor0: function() {
        return $b5fb63758051b147$export$85082d7f68510c56;
    }
};
var $b5fb63758051b147$export$9af761d291db49ef = {
    bind: function(v) {
        return function(f) {
            return function(x) {
                var v1 = f(v(x));
                return v1(x);
            };
        };
    },
    Apply0: function() {
        return $b5fb63758051b147$export$bee433edbc7aed34;
    }
};
var $b5fb63758051b147$export$ddef3771953a3c3c = {
    pure: function(a) {
        return function(v) {
            return a;
        };
    },
    Apply0: function() {
        return $b5fb63758051b147$export$bee433edbc7aed34;
    }
};
var $b5fb63758051b147$export$88fc0f5d12a9e446 = {
    Applicative0: function() {
        return $b5fb63758051b147$export$ddef3771953a3c3c;
    },
    Bind1: function() {
        return $b5fb63758051b147$export$9af761d291db49ef;
    }
};



// Generated by purs version 0.15.15










var $6f71832c0f0d3a5b$export$1644ba17714857f1 = function(x) {
    return x;
};
var $6f71832c0f0d3a5b$export$5c32215407d0c561 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return {
        compose: function(v) {
            return function(v1) {
                return function(x) {
                    return bind(v1(x))(v);
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$a1c7b121a12f67f7 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $127 = map(g);
                    return function($128) {
                        return $127(v(f($128)));
                    };
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$1bd208d997e69566 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(dictFunctor);
    return {
        first: function(v) {
            return function(v1) {
                return map(function(v2) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v2, v1.value1);
                })(v(v1.value0));
            };
        },
        second: function(v) {
            return function(v1) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.value0))(v(v1.value1));
            };
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$5646bceeba0ed2e7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6f71832c0f0d3a5b$export$8ba4b27aef989a18 = function(dictInvariant) {
    var imap = $3d82dffba933b011$export$b2517b0ab3a58435(dictInvariant);
    return {
        imap: function(f) {
            return function(g) {
                return function(v) {
                    var $129 = imap(f)(g);
                    return function($130) {
                        return $129(v($130));
                    };
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$e7b43b239cd8e22a = function(f) {
    return function(v) {
        return function($131) {
            return f(v($131));
        };
    };
};
var $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                var $132 = map(f);
                return function($133) {
                    return $132(v($133));
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$8e00b62431cd4eb7 = function(dictDistributive) {
    var collect = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictDistributive.Functor0());
    return {
        distribute: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(f) {
                return function(a) {
                    return collect1(function(v) {
                        return v(a);
                    })(f);
                };
            };
        },
        collect: function(dictFunctor) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
            return function(f) {
                var $134 = $3ce830dde03d3389$export$f02a9ddbe4480f19($6f71832c0f0d3a5b$export$8e00b62431cd4eb7(dictDistributive))(dictFunctor);
                var $135 = map(f);
                return function($136) {
                    return $134($135($136));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$ee38dceaf1b0a7c1 = function(dictDistributive) {
    var distribute = $3ce830dde03d3389$export$f02a9ddbe4480f19(dictDistributive)($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(dictDistributive.Functor0());
    return {
        closed: function(v) {
            return function(g) {
                return distribute(function($137) {
                    return v(g($137));
                });
            };
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$9b633f3f90080760 = function(dictApplicative) {
    var Functor0 = dictApplicative.Apply0().Functor0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(Functor0);
    return {
        left: function(v) {
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function() {
                var $138 = map($7d4cccdf062a2261$export$37c4d04eafdc5515.create);
                return function($139) {
                    return $138(v($139));
                };
            }())(function($140) {
                return pure($7d4cccdf062a2261$export$19db0165690c701a.create($140));
            });
        },
        right: function(v) {
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function($141) {
                return pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($141));
            })(function() {
                var $142 = map($7d4cccdf062a2261$export$19db0165690c701a.create);
                return function($143) {
                    return $142(v($143));
                };
            }());
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$2315b5444b191e9f = function(dictMonad) {
    var semigroupoidStar1 = $6f71832c0f0d3a5b$export$5c32215407d0c561(dictMonad.Bind1());
    return {
        identity: $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0()),
        Semigroupoid0: function() {
            return semigroupoidStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$3a827cf342dc199f = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(a) {
                    return apply(v(a))(v1(a));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$a9fd453e55672cc4 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var applyStar1 = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(f) {
                return function(x) {
                    return bind(v(x))(function(a) {
                        var v1 = f(a);
                        return v1(x);
                    });
                };
            };
        },
        Apply0: function() {
            return applyStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$7a1642fc72453036 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var applyStar1 = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictApplicative.Apply0());
    return {
        pure: function(a) {
            return function(v) {
                return pure(a);
            };
        },
        Apply0: function() {
            return applyStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$be30334ea1d81019 = function(dictMonad) {
    var applicativeStar1 = $6f71832c0f0d3a5b$export$7a1642fc72453036(dictMonad.Applicative0());
    var bindStar1 = $6f71832c0f0d3a5b$export$a9fd453e55672cc4(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeStar1;
        },
        Bind1: function() {
            return bindStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$35f44c8ce889b889 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(a) {
                    return alt(v(a))(v1(a));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$a37a0eff981675fc = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    var altStar1 = $6f71832c0f0d3a5b$export$35f44c8ce889b889(dictPlus.Alt0());
    return {
        empty: function(v) {
            return empty;
        },
        Alt0: function() {
            return altStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$b508333aabf9ba3d = function(dictAlternative) {
    var applicativeStar1 = $6f71832c0f0d3a5b$export$7a1642fc72453036(dictAlternative.Applicative0());
    var plusStar1 = $6f71832c0f0d3a5b$export$a37a0eff981675fc(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeStar1;
        },
        Plus1: function() {
            return plusStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$7fe0d763dfe145d = function(dictMonadPlus) {
    var monadStar1 = $6f71832c0f0d3a5b$export$be30334ea1d81019(dictMonadPlus.Monad0());
    var alternativeStar1 = $6f71832c0f0d3a5b$export$b508333aabf9ba3d(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadStar1;
        },
        Alternative1: function() {
            return alternativeStar1;
        }
    };
};





var $86141680556a7436$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $86141680556a7436$export$e97768dcd3ffe6df = function(x) {
    return x;
};
var $86141680556a7436$export$3c7b24ce1c81e349 = function(dict) {
    return dict.sequential;
};
var $86141680556a7436$export$451942af9381149c = function(dict) {
    return dict.parallel;
};
var $86141680556a7436$export$ddc88912bc863338 = {
    Coercible0: function() {
        return undefined;
    }
};
var $86141680556a7436$export$76ad2e05fec13cc8 = function(dictMonoid) {
    var applyWriterT = $d9ef009191ddae40$export$2f46a8de9e2e0acc(dictMonoid.Semigroup0());
    return function(dictParallel) {
        var applyWriterT1 = applyWriterT(dictParallel.Apply0());
        var applyWriterT2 = applyWriterT(dictParallel.Apply1());
        return {
            parallel: $d9ef009191ddae40$export$c950a71321ef1ffc($86141680556a7436$export$451942af9381149c(dictParallel)),
            sequential: $d9ef009191ddae40$export$c950a71321ef1ffc($86141680556a7436$export$3c7b24ce1c81e349(dictParallel)),
            Apply0: function() {
                return applyWriterT1;
            },
            Apply1: function() {
                return applyWriterT2;
            }
        };
    };
};
var $86141680556a7436$export$48c6c5bbf7c98dc9 = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyStar = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictParallel.Apply0());
    var applyStar1 = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictParallel.Apply1());
    return {
        parallel: function(v) {
            return function($124) {
                return parallel1(v($124));
            };
        },
        sequential: function(v) {
            return function($125) {
                return sequential1(v($125));
            };
        },
        Apply0: function() {
            return applyStar;
        },
        Apply1: function() {
            return applyStar1;
        }
    };
};
var $86141680556a7436$export$cfbddc4e0911f419 = function(dictParallel) {
    var applyReaderT = $848780da1bf26d9d$export$fee188993a7996b7(dictParallel.Apply0());
    var applyReaderT1 = $848780da1bf26d9d$export$fee188993a7996b7(dictParallel.Apply1());
    return {
        parallel: $848780da1bf26d9d$export$1b8048a192a96779($86141680556a7436$export$451942af9381149c(dictParallel)),
        sequential: $848780da1bf26d9d$export$1b8048a192a96779($86141680556a7436$export$3c7b24ce1c81e349(dictParallel)),
        Apply0: function() {
            return applyReaderT;
        },
        Apply1: function() {
            return applyReaderT1;
        }
    };
};
var $86141680556a7436$export$31d7210ae04b04da = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyCompose = $6051f44ece6b7171$export$6b631277dc31d20d(dictParallel.Apply1())($06733ae99ed4f534$export$22d9917da16590e7);
    return function(dictMonad) {
        var applyMaybeT = $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad);
        return {
            parallel: function(v) {
                return parallel1(v);
            },
            sequential: function(v) {
                return sequential1(v);
            },
            Apply0: function() {
                return applyMaybeT;
            },
            Apply1: function() {
                return applyCompose;
            }
        };
    };
};
var $86141680556a7436$export$29ed81e6361e826b = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyCompose = $6051f44ece6b7171$export$6b631277dc31d20d(dictParallel.Apply1())($7d4cccdf062a2261$export$d5df7cb019d08f04);
    return function(dictMonad) {
        var applyExceptT = $d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad);
        return {
            parallel: function(v) {
                return parallel1(v);
            },
            sequential: function(v) {
                return sequential1(v);
            },
            Apply0: function() {
                return applyExceptT;
            },
            Apply1: function() {
                return applyCompose;
            }
        };
    };
};
var $86141680556a7436$export$36431f0cd2fca0df = function(dictParallel) {
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    return {
        parallel: function(v) {
            return function($126) {
                return v(sequential1($126));
            };
        },
        sequential: function(v) {
            return function($127) {
                return v(parallel1($127));
            };
        },
        Apply0: function() {
            return $b5fb63758051b147$export$bee433edbc7aed34;
        },
        Apply1: function() {
            return $b5fb63758051b147$export$bee433edbc7aed34;
        }
    };
};
var $86141680556a7436$export$aecfbd788a6caa47 = function(dictMonadEffect) {
    var applyContT = $fca560e14229da4e$export$6b05a2ec606a3559(dictMonadEffect.Monad0().Bind1().Apply0());
    return {
        parallel: $86141680556a7436$export$e97768dcd3ffe6df,
        sequential: function(v) {
            return v;
        },
        Apply0: function() {
            return applyContT;
        },
        Apply1: function() {
            return $86141680556a7436$export$803a06b7a7e59726(dictMonadEffect);
        }
    };
};
var $86141680556a7436$export$bf3675a1b3711367 = function(dictMonadEffect) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88($fca560e14229da4e$export$232156ef715cfc9b(dictMonadEffect.Monad0().Bind1().Apply0().Functor0()));
    return {
        map: function(f) {
            var $128 = $86141680556a7436$export$451942af9381149c($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            var $129 = map(f);
            var $130 = $86141680556a7436$export$3c7b24ce1c81e349($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            return function($131) {
                return $128($129($130($131)));
            };
        }
    };
};
var $86141680556a7436$export$803a06b7a7e59726 = function(dictMonadEffect) {
    var Bind1 = dictMonadEffect.Monad0().Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    var discard1 = $86141680556a7436$var$discard(Bind1);
    return {
        apply: function(v) {
            return function(v1) {
                return function(k) {
                    return bind(liftEffect($90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)))(function(ra) {
                        return bind(liftEffect($90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)))(function(rb) {
                            return discard1($fca560e14229da4e$export$358211fab263c66b(v)(function(a) {
                                return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(rb)))(function(mb) {
                                    if (mb instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return liftEffect($e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(a))(ra));
                                    if (mb instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return k(a(mb.value0));
                                    throw new Error("Failed pattern match at Control.Parallel.Class (line 83, column 7 - line 85, column 26): " + [
                                        mb.constructor.name
                                    ]);
                                });
                            }))(function() {
                                return $fca560e14229da4e$export$358211fab263c66b(v1)(function(b) {
                                    return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ra)))(function(ma) {
                                        if (ma instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return liftEffect($e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(b))(rb));
                                        if (ma instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return k(ma.value0(b));
                                        throw new Error("Failed pattern match at Control.Parallel.Class (line 89, column 7 - line 91, column 26): " + [
                                            ma.constructor.name
                                        ]);
                                    });
                                });
                            });
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return $86141680556a7436$export$bf3675a1b3711367(dictMonadEffect);
        }
    };
};
var $86141680556a7436$export$5823fd8d45c99450 = function(dictMonadEffect) {
    var applyParCont1 = $86141680556a7436$export$803a06b7a7e59726(dictMonadEffect);
    return {
        pure: function() {
            var $132 = $86141680556a7436$export$451942af9381149c($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            var $133 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fca560e14229da4e$export$d73f0595e894296c(dictMonadEffect.Monad0().Applicative0()));
            return function($134) {
                return $132($133($134));
            };
        }(),
        Apply0: function() {
            return applyParCont1;
        }
    };
};
var $86141680556a7436$export$e02ea57753bb8483 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    var discard1 = $86141680556a7436$var$discard(Bind1);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var functorParCont1 = $86141680556a7436$export$bf3675a1b3711367(dictMonadEffect);
    return {
        alt: function(v) {
            return function(v1) {
                return function(k) {
                    return bind(liftEffect($90327512d8280b8d$export$b8cb59497041ffe4(false)))(function(done) {
                        return discard1($fca560e14229da4e$export$358211fab263c66b(v)(function(a) {
                            return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(done)))(function(b) {
                                if (b) return pure($05149ea687d6b460$export$523c0b569236b342);
                                return discard1(liftEffect($e521936ea118867a$export$68d8715fc104d294(true)(done)))(function() {
                                    return k(a);
                                });
                            });
                        }))(function() {
                            return $fca560e14229da4e$export$358211fab263c66b(v1)(function(a) {
                                return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(done)))(function(b) {
                                    if (b) return pure($05149ea687d6b460$export$523c0b569236b342);
                                    return discard1(liftEffect($e521936ea118867a$export$68d8715fc104d294(true)(done)))(function() {
                                        return k(a);
                                    });
                                });
                            });
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return functorParCont1;
        }
    };
};
var $86141680556a7436$export$eed929a02bcaa239 = function(dictMonadEffect) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadEffect.Monad0().Applicative0());
    var altParCont1 = $86141680556a7436$export$e02ea57753bb8483(dictMonadEffect);
    return {
        empty: function(v) {
            return pure($05149ea687d6b460$export$523c0b569236b342);
        },
        Alt0: function() {
            return altParCont1;
        }
    };
};
var $86141680556a7436$export$2e55be12f6c16793 = function(dictMonadEffect) {
    var applicativeParCont1 = $86141680556a7436$export$5823fd8d45c99450(dictMonadEffect);
    var plusParCont1 = $86141680556a7436$export$eed929a02bcaa239(dictMonadEffect);
    return {
        Applicative0: function() {
            return applicativeParCont1;
        },
        Plus1: function() {
            return plusParCont1;
        }
    };
};




var $355d9520a1199e68$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $355d9520a1199e68$export$3b8cfe43eb195e1d = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictApplicative) {
        var traverse_ = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative);
        return function(dictFoldable) {
            var traverse_1 = traverse_(dictFoldable);
            return function(f) {
                var $51 = traverse_1(function($53) {
                    return parallel(f($53));
                });
                return function($52) {
                    return sequential($51($52));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$bb703a54931a70b6 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictApplicative) {
        return function(dictTraversable) {
            var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)(dictApplicative);
            return function(f) {
                var $54 = traverse(function($56) {
                    return parallel(f($56));
                });
                return function($55) {
                    return sequential($54($55));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$a907a2b4fd85b16b = function(dictParallel) {
    var parTraverse_1 = $355d9520a1199e68$export$3b8cfe43eb195e1d(dictParallel);
    return function(dictApplicative) {
        var parTraverse_2 = parTraverse_1(dictApplicative);
        return function(dictFoldable) {
            return parTraverse_2(dictFoldable)($355d9520a1199e68$var$identity);
        };
    };
};
var $355d9520a1199e68$export$b9becc45c388432c = function(dictParallel) {
    var parTraverse1 = $355d9520a1199e68$export$bb703a54931a70b6(dictParallel);
    return function(dictApplicative) {
        var parTraverse2 = parTraverse1(dictApplicative);
        return function(dictTraversable) {
            return parTraverse2(dictTraversable)($355d9520a1199e68$var$identity);
        };
    };
};
var $355d9520a1199e68$export$a82aaa9906cdb569 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictAlternative) {
        var Plus1 = dictAlternative.Plus1();
        return function(dictFoldable) {
            var oneOfMap = $4fe7b6acfba7f29f$export$79f3cac53daaaae6(dictFoldable)(Plus1);
            return function(dictFunctor) {
                return function(f) {
                    var $57 = oneOfMap(function($59) {
                        return parallel(f($59));
                    });
                    return function($58) {
                        return sequential($57($58));
                    };
                };
            };
        };
    };
};
var $355d9520a1199e68$export$70e1ad49970879b5 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictAlternative) {
        var Plus1 = dictAlternative.Plus1();
        return function(dictFoldable) {
            var oneOfMap = $4fe7b6acfba7f29f$export$79f3cac53daaaae6(dictFoldable)(Plus1);
            return function(dictFunctor) {
                var $60 = oneOfMap(parallel);
                return function($61) {
                    return sequential($60($61));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$3d88e33b68f7b8a5 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictParallel.Apply1());
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(mf) {
        return function(ma) {
            return sequential(apply(parallel(mf))(parallel(ma)));
        };
    };
};










// Generated by purs version 0.15.15






var $3c54b6e6d30cc3be$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $3c54b6e6d30cc3be$var$over = /* #__PURE__ */ $4fa4836228a192cc$export$fb4902fd9e525693()();
var $3c54b6e6d30cc3be$var$negate = /* #__PURE__ */ $d061555d3b2c84b2$export$aef51622e549b8b0($d061555d3b2c84b2$export$194f4464e73e7816);
var $3c54b6e6d30cc3be$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $3c54b6e6d30cc3be$export$f2a120b78af04023 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$760297a502ec68f7 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$e4eccef8f937a949 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$8c68c012e85c37f4 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$d3134eff2123aadb = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$9eabacebe6624782 = function(dict) {
    return dict.toDuration;
};
var $3c54b6e6d30cc3be$export$358ac052a84a2abd = {
    show: function(v) {
        return "(Seconds " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$f5f4de8badcbd545 = {
    show: function(v) {
        return "(Minutes " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$1d3b9b5391a72ae7 = {
    show: function(v) {
        return "(Milliseconds " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$c5d3ca6fc3468bcf = {
    show: function(v) {
        return "(Hours " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$de46f7d16350d367 = {
    show: function(v) {
        return "(Days " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$bccfb43682e4a5e4 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$d9bc7c6e66ddf272 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$def67087bd72fdb7 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$5f6754e19ae8b602 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$e8bb798e27d1673b = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$34e2a018de95f3d = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$d6d247637e7494c9 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$e0a5c04af6395341 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$4ccf8d6c1ebfa128 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$3ab38ab5accb6ec2 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$321d65ffd9e957ce = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$f5994f75b457cdcc = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$961a021281e4c248 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$5ca80b70b64299ae = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$a5ba0a6cacc34910 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$5b5983dc8ed41daa = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$bccfb43682e4a5e4;
    }
};
var $3c54b6e6d30cc3be$export$1857fd2af0af50be = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$d9bc7c6e66ddf272;
    }
};
var $3c54b6e6d30cc3be$export$70200b12758a7a61 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$def67087bd72fdb7;
    }
};
var $3c54b6e6d30cc3be$export$22829380fb9f2b93 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$5f6754e19ae8b602;
    }
};
var $3c54b6e6d30cc3be$export$9bd04d01a6c9ebc2 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$e8bb798e27d1673b;
    }
};
var $3c54b6e6d30cc3be$export$1a0a2c8fdf902748 = function(dict) {
    return dict.fromDuration;
};
var $3c54b6e6d30cc3be$export$28743521ea1cb8f9 = function(dictDuration) {
    var $57 = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    var $58 = $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)($3c54b6e6d30cc3be$var$negate);
    var $59 = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function($60) {
        return $57($58($59($60)));
    };
};
var $3c54b6e6d30cc3be$export$980dbec50a957fc7 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$4771a2ee9f50caac = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$699cb56941ecf990 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$fd6d5f49667130a4 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$c66ee96f983a5e21 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$1791f02d01a6ae8 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$f2a120b78af04023)(function(v) {
        return v * 1000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 1000.0;
    })
};
var $3c54b6e6d30cc3be$export$563c2be46809b74f = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$760297a502ec68f7)(function(v) {
        return v * 60000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 60000.0;
    })
};
var $3c54b6e6d30cc3be$export$44304cbc75c995e8 = {
    fromDuration: $3c54b6e6d30cc3be$var$identity,
    toDuration: $3c54b6e6d30cc3be$var$identity
};
var $3c54b6e6d30cc3be$export$117f08340b9f6c14 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$8c68c012e85c37f4)(function(v) {
        return v * 3600000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 3600000.0;
    })
};
var $3c54b6e6d30cc3be$export$93ad8ffd4576e464 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$d3134eff2123aadb)(function(v) {
        return v * 8.64e7;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 8.64e7;
    })
};
var $3c54b6e6d30cc3be$export$3082151037402ab5 = function(dictDuration) {
    var fromDuration1 = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function(dictDuration1) {
        var $61 = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration1);
        return function($62) {
            return $61(fromDuration1($62));
        };
    };
};









var $edf0339512807bee$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $edf0339512807bee$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $edf0339512807bee$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $edf0339512807bee$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $edf0339512807bee$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $edf0339512807bee$var$Fiber = function(x) {
    return x;
};
var $edf0339512807bee$var$FFIUtil = function(x) {
    return x;
};
var $edf0339512807bee$export$22f79b48f44c15eb = function(x) {
    return x;
};
var $edf0339512807bee$export$4de6f17bc3dfa03 = /* #__PURE__ */ $b28443a27438717a$export$f97e7884af471963(false);
var $edf0339512807bee$export$608d3e3a27b14320 = {
    Coercible0: function() {
        return undefined;
    }
};
var $edf0339512807bee$export$d7f9012ed771d686 = {
    map: $b28443a27438717a$export$68695d37eb163711
};
var $edf0339512807bee$export$e8a7d9b8d7dc616a = {
    map: $b28443a27438717a$export$a0135aecf4a782ab
};
var $edf0339512807bee$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $edf0339512807bee$export$469c8a16c186651e = /* #__PURE__ */ $b28443a27438717a$export$f97e7884af471963(true);
var $edf0339512807bee$var$ffiUtil = /* #__PURE__ */ function() {
    var unsafeFromRight = function(v) {
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v.value0;
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $8bcde8f642a64c7d$export$51b220bae4359b72("unsafeFromRight: Left");
        throw new Error("Failed pattern match at Effect.Aff (line 412, column 21 - line 414, column 54): " + [
            v.constructor.name
        ]);
    };
    var unsafeFromLeft = function(v) {
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v.value0;
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $8bcde8f642a64c7d$export$51b220bae4359b72("unsafeFromLeft: Right");
        throw new Error("Failed pattern match at Effect.Aff (line 407, column 20 - line 409, column 55): " + [
            v.constructor.name
        ]);
    };
    var isLeft = function(v) {
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return true;
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return false;
        throw new Error("Failed pattern match at Effect.Aff (line 402, column 12 - line 404, column 21): " + [
            v.constructor.name
        ]);
    };
    return {
        isLeft: isLeft,
        fromLeft: unsafeFromLeft,
        fromRight: unsafeFromRight,
        left: $7d4cccdf062a2261$export$37c4d04eafdc5515.create,
        right: $7d4cccdf062a2261$export$19db0165690c701a.create
    };
}();
var $edf0339512807bee$var$makeFiber = function(aff) {
    return $b28443a27438717a$export$f24188c8fd3f1234($edf0339512807bee$var$ffiUtil, aff);
};
var $edf0339512807bee$export$30b347ca11a80af4 = function(aff) {
    return function __do() {
        var fiber = $edf0339512807bee$var$makeFiber(aff)();
        fiber.run();
        return fiber;
    };
};
var $edf0339512807bee$export$c8704a1045ed544d = function($75) {
    return $edf0339512807bee$var$$$void($edf0339512807bee$export$30b347ca11a80af4($75));
};
var $edf0339512807bee$export$d133944c527f2403 = $edf0339512807bee$var$makeFiber;
var $edf0339512807bee$export$1391212d75b2ee65 = function(v) {
    return $b28443a27438717a$export$389c1406f5ae6ae7($7d4cccdf062a2261$export$19db0165690c701a.create, v);
};
var $edf0339512807bee$export$df5598cc12b9c8c = function(acquire) {
    return function(completed) {
        return $b28443a27438717a$export$9ad792f02752f447(acquire)({
            killed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(completed),
            failed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(completed),
            completed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(completed)
        });
    };
};
var $edf0339512807bee$export$83901714774e2edc = {
    apply: $b28443a27438717a$export$bce00526579b3344,
    Functor0: function() {
        return $edf0339512807bee$export$d7f9012ed771d686;
    }
};
var $edf0339512807bee$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($edf0339512807bee$export$83901714774e2edc);
var $edf0339512807bee$export$fc7e409bd1eae683 = function(dictSemigroup) {
    return {
        append: $edf0339512807bee$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $edf0339512807bee$export$b147a380fa8fdc0e = {
    Applicative0: function() {
        return $edf0339512807bee$export$9dc0454a98607988;
    },
    Bind1: function() {
        return $edf0339512807bee$export$f885f489dcf38a2d;
    }
};
var $edf0339512807bee$export$f885f489dcf38a2d = {
    bind: $b28443a27438717a$export$8fe95d71d8c6b6f3,
    Apply0: function() {
        return $edf0339512807bee$var$$lazy_applyAff(0);
    }
};
var $edf0339512807bee$export$9dc0454a98607988 = {
    pure: $b28443a27438717a$export$68c6660df485915b,
    Apply0: function() {
        return $edf0339512807bee$var$$lazy_applyAff(0);
    }
};
var $edf0339512807bee$var$$lazy_applyAff = /* #__PURE__ */ $edf0339512807bee$var$$runtime_lazy("applyAff", "Effect.Aff", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($edf0339512807bee$export$b147a380fa8fdc0e),
        Functor0: function() {
            return $edf0339512807bee$export$e8a7d9b8d7dc616a;
        }
    };
});
var $edf0339512807bee$export$114a07f1fb466c63 = /* #__PURE__ */ $edf0339512807bee$var$$lazy_applyAff(73);
var $edf0339512807bee$var$pure2 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $edf0339512807bee$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $edf0339512807bee$var$lift21 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($edf0339512807bee$export$114a07f1fb466c63);
var $edf0339512807bee$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($edf0339512807bee$export$114a07f1fb466c63);
var $edf0339512807bee$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($edf0339512807bee$export$f885f489dcf38a2d);
var $edf0339512807bee$export$d0776e69f204de29 = function(aff) {
    return function(v) {
        return $b28443a27438717a$export$9ad792f02752f447($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342))({
            killed: function(e) {
                return function(v1) {
                    return v(e);
                };
            },
            failed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure2),
            completed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure2)
        })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(aff));
    };
};
var $edf0339512807bee$export$7f8bd3bb7f01e042 = function(fin) {
    return function(a) {
        return $edf0339512807bee$export$df5598cc12b9c8c($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342))($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(fin))($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(a));
    };
};
var $edf0339512807bee$export$859f4dae848ac0ae = function(a) {
    return $edf0339512807bee$export$df5598cc12b9c8c(a)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342)))($edf0339512807bee$var$pure2);
};
var $edf0339512807bee$export$6c7682db87129472 = {
    defer: function(f) {
        return $edf0339512807bee$var$bind1($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342))(f);
    }
};
var $edf0339512807bee$export$cb4623454f96d5e0 = {
    parallel: $ac8b3532514ac019$export$401372c57776dc,
    sequential: $b28443a27438717a$export$139486a45824a247,
    Apply0: function() {
        return $edf0339512807bee$export$114a07f1fb466c63;
    },
    Apply1: function() {
        return $edf0339512807bee$export$83901714774e2edc;
    }
};
var $edf0339512807bee$var$parallel = /* #__PURE__ */ $86141680556a7436$export$451942af9381149c($edf0339512807bee$export$cb4623454f96d5e0);
var $edf0339512807bee$export$389e6cb252ce112f = {
    pure: function($76) {
        return $edf0339512807bee$var$parallel($edf0339512807bee$var$pure2($76));
    },
    Apply0: function() {
        return $edf0339512807bee$export$83901714774e2edc;
    }
};
var $edf0339512807bee$var$pure3 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$389e6cb252ce112f);
var $edf0339512807bee$var$parSequence_ = /* #__PURE__ */ $355d9520a1199e68$export$a907a2b4fd85b16b($edf0339512807bee$export$cb4623454f96d5e0)($edf0339512807bee$export$389e6cb252ce112f)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $edf0339512807bee$export$aa5306b4d3514fa0 = function(dictMonoid) {
    var semigroupParAff1 = $edf0339512807bee$export$fc7e409bd1eae683(dictMonoid.Semigroup0());
    return {
        mempty: $edf0339512807bee$var$pure3($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupParAff1;
        }
    };
};
var $edf0339512807bee$export$1cab8188db0c4c1f = {
    append: function(v) {
        return function(v1) {
            return function(err) {
                return $edf0339512807bee$var$parSequence_([
                    v(err),
                    v1(err)
                ]);
            };
        };
    }
};
var $edf0339512807bee$export$1dbf838572c25e01 = function(dictSemigroup) {
    return {
        append: $edf0339512807bee$var$lift21($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $edf0339512807bee$export$666a030cecdf96c = {
    liftEffect: $b28443a27438717a$export$3c6532f01a0290eb,
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $edf0339512807bee$export$952106a975f35ae2 = function($77) {
    return $edf0339512807bee$export$22f79b48f44c15eb($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$liftEffect($77)));
};
var $edf0339512807bee$export$f3d782c2b95165ad = function(v) {
    return $b28443a27438717a$export$49d5975414e0a979(function(k) {
        return $edf0339512807bee$var$map($edf0339512807bee$export$952106a975f35ae2)(v.join(k));
    });
};
var $edf0339512807bee$export$29466a041ff3b3e0 = {
    map: function(f) {
        return function(t) {
            return $c02f07bc0f38e9e9$export$c62839628b30a695($edf0339512807bee$var$makeFiber($edf0339512807bee$var$map1(f)($edf0339512807bee$export$f3d782c2b95165ad(t))));
        };
    }
};
var $edf0339512807bee$export$4d705d914d07c7a7 = {
    apply: function(t1) {
        return function(t2) {
            return $c02f07bc0f38e9e9$export$c62839628b30a695($edf0339512807bee$var$makeFiber($edf0339512807bee$var$apply($edf0339512807bee$export$f3d782c2b95165ad(t1))($edf0339512807bee$export$f3d782c2b95165ad(t2))));
        };
    },
    Functor0: function() {
        return $edf0339512807bee$export$29466a041ff3b3e0;
    }
};
var $edf0339512807bee$export$6db27cd2d1558d76 = {
    pure: function(a) {
        return $c02f07bc0f38e9e9$export$c62839628b30a695($edf0339512807bee$var$makeFiber($edf0339512807bee$var$pure2(a)));
    },
    Apply0: function() {
        return $edf0339512807bee$export$4d705d914d07c7a7;
    }
};
var $edf0339512807bee$export$c65b2010df1810d = function(e) {
    return function(v) {
        return $edf0339512807bee$var$bind1($edf0339512807bee$var$liftEffect(v.isSuspended))(function(suspended) {
            if (suspended) return $edf0339512807bee$var$liftEffect($edf0339512807bee$var$$$void(v.kill(e, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure($05149ea687d6b460$export$523c0b569236b342)))));
            return $b28443a27438717a$export$49d5975414e0a979(function(k) {
                return $edf0339512807bee$var$map($edf0339512807bee$export$952106a975f35ae2)(v.kill(e, k));
            });
        });
    };
};
var $edf0339512807bee$export$12fb9217a4d25158 = /* #__PURE__ */ function() {
    var $78 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($edf0339512807bee$export$c65b2010df1810d);
    return function($79) {
        return $edf0339512807bee$export$22f79b48f44c15eb($78($79));
    };
}();
var $edf0339512807bee$export$54b8dc42dcff4ab1 = function(aff) {
    var killError = $ad2cf6904bca3ba1$export$a3bc9b8ed74fc("[Aff] Child fiber outlived parent");
    var killAll = function(err) {
        return function(sup) {
            return $b28443a27438717a$export$49d5975414e0a979(function(k) {
                return $b28443a27438717a$export$a494cc11bfc0c750(err, sup.supervisor, k($edf0339512807bee$var$pure1($05149ea687d6b460$export$523c0b569236b342)));
            });
        };
    };
    var acquire = function __do() {
        var sup = $b28443a27438717a$export$7a3baea9562462c7($edf0339512807bee$var$ffiUtil, aff)();
        sup.fiber.run();
        return sup;
    };
    return $b28443a27438717a$export$9ad792f02752f447($edf0339512807bee$var$liftEffect(acquire))({
        killed: function(err) {
            return function(sup) {
                return $edf0339512807bee$var$parSequence_([
                    $edf0339512807bee$export$c65b2010df1810d(err)(sup.fiber),
                    killAll(err)(sup)
                ]);
            };
        },
        failed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(killAll(killError)),
        completed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(killAll(killError))
    })(function($80) {
        return $edf0339512807bee$export$f3d782c2b95165ad(function(v) {
            return v.fiber;
        }($80));
    });
};
var $edf0339512807bee$export$d9b2f32f45e29810 = {
    liftST: /* #__PURE__ */ function() {
        var $81 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f($dd1bd2cc217b6a6d$export$d1b56b21630310a5);
        return function($82) {
            return $edf0339512807bee$var$liftEffect($81($82));
        };
    }(),
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$37a9b80154c7d256 = {
    throwError: $b28443a27438717a$export$520252a01094c36e,
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$9efce1646e93cba4 = {
    catchError: $b28443a27438717a$export$eb5e86cd5464556e,
    MonadThrow0: function() {
        return $edf0339512807bee$export$37a9b80154c7d256;
    }
};
var $edf0339512807bee$var$$$try = /* #__PURE__ */ $5dfefa023749ded0$export$410a452afcd48948($edf0339512807bee$export$9efce1646e93cba4);
var $edf0339512807bee$var$catchError = /* #__PURE__ */ $5dfefa023749ded0$export$3dede90624df3ba9($edf0339512807bee$export$9efce1646e93cba4);
var $edf0339512807bee$export$77f9e426014f6edd = $edf0339512807bee$var$$$try;
var $edf0339512807bee$export$60f50bfed4143f9d = function(k) {
    return function(aff) {
        return $edf0339512807bee$export$30b347ca11a80af4($edf0339512807bee$var$bindFlipped(function($83) {
            return $edf0339512807bee$var$liftEffect(k($83));
        })($edf0339512807bee$var$$$try(aff)));
    };
};
var $edf0339512807bee$export$ef62257e6f8a5f8c = function(k) {
    return function(aff) {
        return $edf0339512807bee$var$$$void($edf0339512807bee$export$60f50bfed4143f9d(k)(aff));
    };
};
var $edf0339512807bee$export$52011fb9f1f7b7e2 = function(k) {
    return function(aff) {
        return $edf0339512807bee$export$d133944c527f2403($edf0339512807bee$var$bindFlipped(function($84) {
            return $edf0339512807bee$var$liftEffect(k($84));
        })($edf0339512807bee$var$$$try(aff)));
    };
};
var $edf0339512807bee$export$974f8db4a62dd716 = {
    tailRecM: function(k) {
        var go = function(a) {
            return $edf0339512807bee$var$bind1(k(a))(function(res) {
                if (res instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $edf0339512807bee$var$pure2(res.value0);
                if (res instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return go(res.value0);
                throw new Error("Failed pattern match at Effect.Aff (line 104, column 7 - line 106, column 23): " + [
                    res.constructor.name
                ]);
            });
        };
        return go;
    },
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$b59d1737970253ab = function(dictMonoid) {
    var semigroupAff1 = $edf0339512807bee$export$1dbf838572c25e01(dictMonoid.Semigroup0());
    return {
        mempty: $edf0339512807bee$var$pure2($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupAff1;
        }
    };
};
var $edf0339512807bee$export$8deb6e154ce67af6 = /* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(/* #__PURE__ */ $edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342));
var $edf0339512807bee$export$800a937b75981c0e = {
    mempty: $edf0339512807bee$export$8deb6e154ce67af6,
    Semigroup0: function() {
        return $edf0339512807bee$export$1cab8188db0c4c1f;
    }
};
var $edf0339512807bee$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($edf0339512807bee$export$800a937b75981c0e);
var $edf0339512807bee$export$b3e22bcfd64c1022 = /* #__PURE__ */ $b28443a27438717a$export$49d5975414e0a979(function(v) {
    return $edf0339512807bee$var$pure($edf0339512807bee$var$mempty);
});
var $edf0339512807bee$export$a19cb95a0294477 = /* #__PURE__ */ function() {
    var $85 = $edf0339512807bee$var$map1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($05149ea687d6b460$export$523c0b569236b342));
    return function($86) {
        return $85($edf0339512807bee$export$77f9e426014f6edd($86));
    };
}();
var $edf0339512807bee$export$371c34bc9954b4c6 = {
    alt: $b28443a27438717a$export$6a44b66c7edadaa,
    Functor0: function() {
        return $edf0339512807bee$export$d7f9012ed771d686;
    }
};
var $edf0339512807bee$export$75f84a0612e9fcac = {
    alt: function(a1) {
        return function(a2) {
            return $edf0339512807bee$var$catchError(a1)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(a2));
        };
    },
    Functor0: function() {
        return $edf0339512807bee$export$e8a7d9b8d7dc616a;
    }
};
var $edf0339512807bee$export$982abcb51ccf01ce = {
    empty: /* #__PURE__ */ $5dfefa023749ded0$export$8bf7aba4a9e09055($edf0339512807bee$export$37a9b80154c7d256)(/* #__PURE__ */ $ad2cf6904bca3ba1$export$a3bc9b8ed74fc("Always fails")),
    Alt0: function() {
        return $edf0339512807bee$export$75f84a0612e9fcac;
    }
};
var $edf0339512807bee$export$a77596dfa1aa0c51 = {
    empty: /* #__PURE__ */ $edf0339512807bee$var$parallel(/* #__PURE__ */ $7abe8fbe97ebda87$export$6e22c362a0406a2c($edf0339512807bee$export$982abcb51ccf01ce)),
    Alt0: function() {
        return $edf0339512807bee$export$371c34bc9954b4c6;
    }
};
var $edf0339512807bee$export$96ad65bdc35fd68a = {
    Applicative0: function() {
        return $edf0339512807bee$export$389e6cb252ce112f;
    },
    Plus1: function() {
        return $edf0339512807bee$export$a77596dfa1aa0c51;
    }
};


// Generated by purs version 0.15.15



// Generated by purs version 0.15.15















var $d30ea600cb89759b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $d30ea600cb89759b$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($73aa5dd1904ebcb7$export$3780b8670d5f24f8);
var $d30ea600cb89759b$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $d30ea600cb89759b$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($73aa5dd1904ebcb7$export$28587442a46d4141);
var $d30ea600cb89759b$export$1bffd077443cd981 = /* #__PURE__ */ function() {
    function Yield(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Yield.create = function(value0) {
        return function(value1) {
            return new Yield(value0, value1);
        };
    };
    return Yield;
}();
var $d30ea600cb89759b$export$38d24f5c1eb0e4c0 = /* #__PURE__ */ function() {
    function Skip(value0) {
        this.value0 = value0;
    }
    Skip.create = function(value0) {
        return new Skip(value0);
    };
    return Skip;
}();
var $d30ea600cb89759b$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done() {}
    Done.value = new Done();
    return Done;
}();
var $d30ea600cb89759b$export$4ae3cbbaa857dd72 = function(x) {
    return x;
};
var $d30ea600cb89759b$export$72a5dac3748973f0 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return pure1(new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(v));
    };
};
var $d30ea600cb89759b$export$860beaf0e87f1a9f = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return map2(function($338) {
            return $d30ea600cb89759b$export$38d24f5c1eb0e4c0.create($99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($338)));
        })(v);
    };
};
var $d30ea600cb89759b$export$c48e357c1a89b78d = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    return function(f) {
        return function(z) {
            var g = function(v) {
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0.value1, $99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                    return $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad)(f)(v.value0.value0);
                }));
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 130, column 3 - line 130, column 60): " + [
                    v.constructor.name
                ]);
            };
            return map2(g)(f(z));
        };
    };
};
var $d30ea600cb89759b$export$b446f6baa3bb1430 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(v) {
        var g = function(v1) {
            if (v1 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, $99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value1))));
            if (v1 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad)($99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value0));
            if (v1 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 195, column 3 - line 195, column 50): " + [
                v1.constructor.name
            ]);
        };
        return bind(v)(g);
    };
};
var $d30ea600cb89759b$export$c01875f616615628 = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(l) {
        return map2($d30ea600cb89759b$var$map($71f2e2e9476163f8$export$6f71268a1666ab58))(uncons1(l));
    };
};
var $d30ea600cb89759b$var$stepMap = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            return map2(f)(v);
        };
    };
};
var $d30ea600cb89759b$export$9384c7afe4015e42 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var $255 = f(v.value0);
                if ($255) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$9384c7afe4015e42(dictApplicative)(f))(v.value1));
                return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$9384c7afe4015e42(dictApplicative)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 154, column 3 - line 154, column 68): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$65f513eaf3c582b8 = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var unfold1 = $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad);
    return function(f) {
        return function(b) {
            return function(l) {
                var g = function(v) {
                    var h = function(v1) {
                        if (v1 instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                            var b$prime$prime = f(v.value0)(v1.value0);
                            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(b$prime$prime, $99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value1)), v.value0));
                        }
                        if (v1 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, $99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value0)), v.value0));
                        if (v1 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        throw new Error("Failed pattern match at Control.Monad.List.Trans (line 248, column 5 - line 248, column 78): " + [
                            v1.constructor.name
                        ]);
                    };
                    return map2(h)(v.value1);
                };
                return unfold1(g)(new $71f2e2e9476163f8$export$1908877435b1d5e9(b, l));
            };
        };
    };
};
var $d30ea600cb89759b$export$3466dae21163a3ee = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(h) {
        return function(t) {
            return pure1(new $d30ea600cb89759b$export$1bffd077443cd981(h, t));
        };
    };
};
var $d30ea600cb89759b$export$68159836694e22c1 = function(dictApplicative) {
    var prepend$prime1 = $d30ea600cb89759b$export$3466dae21163a3ee(dictApplicative);
    return function(h) {
        return function(t) {
            return prepend$prime1(h)($99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(t)));
        };
    };
};
var $d30ea600cb89759b$export$f2c4f74e8fe88e34 = function(dictApplicative) {
    return $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative)($d30ea600cb89759b$export$7fe28cb29e71bf10.value);
};
var $d30ea600cb89759b$export$439306a4dcaafbb9 = function(dictApplicative) {
    var prepend1 = $d30ea600cb89759b$export$68159836694e22c1(dictApplicative);
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    return function(a) {
        return prepend1(a)(nil1);
    };
};
var $d30ea600cb89759b$export$b7df5d561049483a = function(dictApplicative) {
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(v) {
        return function(v1) {
            if (v === 0) return nil1;
            var f = function(v2) {
                if (v2 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(v2.value0, $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$b7df5d561049483a(dictApplicative)(v - 1 | 0))(v2.value1));
                if (v2 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$b7df5d561049483a(dictApplicative)(v))(v2.value0));
                if (v2 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 147, column 3 - line 147, column 47): " + [
                    v2.constructor.name
                ]);
            };
            return stepMap1(f)(v1);
        };
    };
};
var $d30ea600cb89759b$export$e3b52f6f0a4bd72e = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Applicative0);
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0);
    var Bind1 = dictMonad.Bind1();
    var Functor0 = Bind1.Apply0().Functor0();
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var prepend$prime1 = $d30ea600cb89759b$export$3466dae21163a3ee(Applicative0);
    var wrapEffect1 = $d30ea600cb89759b$export$860beaf0e87f1a9f(Functor0);
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var g = function(v) {
            return function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(nil1);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(nil1);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return map2($f57f4b701aa7b66e$export$8a83211c878a3f1f(prepend$prime1)($99af8ad7682e39c7$export$260e5c0943f31606(function(v2) {
                    return $d30ea600cb89759b$export$e3b52f6f0a4bd72e(dictMonad)(f)(v.value0.value1)(v1.value0.value1);
                })))(f(v.value0.value0)(v1.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 260, column 3 - line 260, column 25): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        var loop = function(fa) {
            return function(fb) {
                return wrapEffect1(bind(uncons1(fa))(function(ua) {
                    return bind(uncons1(fb))(function(ub) {
                        return g(ua)(ub);
                    });
                }));
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$b634740ce272acb5 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var zipWith$prime1 = $d30ea600cb89759b$export$e3b52f6f0a4bd72e(dictMonad);
    return function(f) {
        var g = function(a) {
            return function(b) {
                return pure1(f(a)(b));
            };
        };
        return zipWith$prime1(g);
    };
};
var $d30ea600cb89759b$export$acf0795b499e2d1a = {
    Coercible0: function() {
        return undefined;
    }
};
var $d30ea600cb89759b$export$e70771d2e7e590a = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return $06733ae99ed4f534$export$43db023a260c5e9f($d30ea600cb89759b$export$38d24f5c1eb0e4c0.create)($d30ea600cb89759b$var$map($d30ea600cb89759b$export$1bffd077443cd981.create)(f(v.value0)))($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)(f))(v.value1));
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 183, column 3 - line 183, column 72): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$c1a059043cc9c119 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var unfold1 = $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad);
    return function(f) {
        return function(a) {
            var g = function(x) {
                return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(f(x), x)));
            };
            return unfold1(g)(a);
        };
    };
};
var $d30ea600cb89759b$export$76d90c956114f2c2 = function(dictMonad) {
    return $d30ea600cb89759b$export$c1a059043cc9c119(dictMonad)($d30ea600cb89759b$var$identity);
};
var $d30ea600cb89759b$export$5fd5031fecdacec3 = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(l) {
        return map2($d30ea600cb89759b$var$map($71f2e2e9476163f8$export$9e770fa6ce19a9d6))(uncons1(l));
    };
};
var $d30ea600cb89759b$export$5af6b427ff316359 = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return {
        map: function(f) {
            var g = function(v) {
                if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(f(v.value0), $d30ea600cb89759b$var$map1($f4b2eb11fc32ed34$export$871de8747c9eaa88($d30ea600cb89759b$export$5af6b427ff316359(dictFunctor))(f))(v.value1));
                if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($f4b2eb11fc32ed34$export$871de8747c9eaa88($d30ea600cb89759b$export$5af6b427ff316359(dictFunctor))(f))(v.value0));
                if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 280, column 5 - line 280, column 48): " + [
                    v.constructor.name
                ]);
            };
            return stepMap1(g);
        }
    };
};
var $d30ea600cb89759b$export$df62323340295157 = function(dictApplicative) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    return function(fa) {
        return map2($f57f4b701aa7b66e$export$8a83211c878a3f1f($d30ea600cb89759b$export$1bffd077443cd981.create)($99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return nil1;
        })))(fa);
    };
};
var $d30ea600cb89759b$export$619131e858bec5bb = {
    lift: function(dictMonad) {
        return $d30ea600cb89759b$export$df62323340295157(dictMonad.Applicative0());
    }
};
var $d30ea600cb89759b$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d30ea600cb89759b$export$619131e858bec5bb);
var $d30ea600cb89759b$export$5f62080e6ea5ad16 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(Monad0);
    var tailRecM2 = $f93520de2fa37b44$export$9056a6bb308e8c79(dictMonadRec);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(new $f93520de2fa37b44$export$7fe28cb29e71bf10(b));
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return bind(f(b)(v.value0.value0))(function(b$prime) {
                        return pure1(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                            a: b$prime,
                            b: v.value0.value1
                        }));
                    });
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 221, column 5 - line 221, column 45): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return tailRecM2(loop);
    };
};
var $d30ea600cb89759b$export$3120598051129cb3 = function(dictMonadRec) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadRec.Monad0().Applicative0());
    return $d30ea600cb89759b$export$5f62080e6ea5ad16(dictMonadRec)(function(v) {
        return function(v1) {
            return pure1($05149ea687d6b460$export$523c0b569236b342);
        };
    })($05149ea687d6b460$export$523c0b569236b342);
};
var $d30ea600cb89759b$export$48b115eebb7f3c53 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(Monad0);
    var tailRecM2 = $f93520de2fa37b44$export$9056a6bb308e8c79(dictMonadRec);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(new $f93520de2fa37b44$export$7fe28cb29e71bf10(b));
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return pure1(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                        a: f(b)(v.value0.value0),
                        b: v.value0.value1
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 239, column 7 - line 239, column 47): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return tailRecM2(loop);
    };
};
var $d30ea600cb89759b$export$fa87a49fad651048 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(b);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return bind(f(b)(v.value0.value0))($f57f4b701aa7b66e$export$8a83211c878a3f1f(loop)(v.value0.value1));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 212, column 5 - line 212, column 35): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$99ac321f734efd9b = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return $d30ea600cb89759b$export$fa87a49fad651048(dictMonad)(function(v) {
        return function(v1) {
            return pure1($05149ea687d6b460$export$523c0b569236b342);
        };
    })($05149ea687d6b460$export$523c0b569236b342);
};
var $d30ea600cb89759b$export$50ae948ca12cdcbc = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(b);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return loop(f(b)(v.value0.value0))(v.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 229, column 5 - line 229, column 35): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$3dea766d36a8935f = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var s$prime = $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$3dea766d36a8935f(dictFunctor)(f))(v.value1);
                var $305 = f(v.value0);
                if ($305) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, s$prime);
                return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(s$prime);
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) {
                var s$prime = $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$3dea766d36a8935f(dictFunctor)(f))(v.value0);
                return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(s$prime);
            }
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 176, column 3 - line 176, column 80): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$533af5c8cd6afa16 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var $310 = f(v.value0);
                if ($310) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$533af5c8cd6afa16(dictApplicative)(f))(v.value1));
                return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, v.value1);
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$533af5c8cd6afa16(dictApplicative)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 169, column 3 - line 169, column 70): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$663103110d94aac9 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(v) {
        return function(v1) {
            if (v === 0) return v1;
            var f = function(v2) {
                if (v2 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$663103110d94aac9(dictApplicative)(v - 1 | 0))(v2.value1));
                if (v2 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$663103110d94aac9(dictApplicative)(v))(v2.value0));
                if (v2 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 162, column 3 - line 162, column 44): " + [
                    v2.constructor.name
                ]);
            };
            return stepMap1(f)(v1);
        };
    };
};
var $d30ea600cb89759b$export$8327ebbef2a0ba76 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(lh) {
        return function(t) {
            return pure1(new $d30ea600cb89759b$export$1bffd077443cd981($99af8ad7682e39c7$export$4d82290515cd0ddb(lh), t));
        };
    };
};
var $d30ea600cb89759b$export$e5d91f6921d97963 = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var singleton1 = $d30ea600cb89759b$export$439306a4dcaafbb9(Applicative0);
    var cons1 = $d30ea600cb89759b$export$8327ebbef2a0ba76(Applicative0);
    return {
        unfoldr1: function(f) {
            return function(b) {
                var go = function(v) {
                    if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return singleton1(v.value0);
                    if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cons1($d30ea600cb89759b$var$pure(v.value0))($99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                        return go(f(v.value1.value0));
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 294, column 12 - line 296, column 67): " + [
                        v.constructor.name
                    ]);
                };
                return go(f(b));
            };
        }
    };
};
var $d30ea600cb89759b$export$bbfbcefbf94b996f = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0);
    var cons1 = $d30ea600cb89759b$export$8327ebbef2a0ba76(Applicative0);
    var unfoldable1ListT1 = $d30ea600cb89759b$export$e5d91f6921d97963(dictMonad);
    return {
        unfoldr: function(f) {
            return function(b) {
                var go = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return nil1;
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cons1($d30ea600cb89759b$var$pure(v.value0.value0))($99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                        return go(f(v.value0.value1));
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 287, column 12 - line 289, column 67): " + [
                        v.constructor.name
                    ]);
                };
                return go(f(b));
            };
        },
        Unfoldable10: function() {
            return unfoldable1ListT1;
        }
    };
};
var $d30ea600cb89759b$export$e65aba2be8e37f8a = function(dictApplicative) {
    return {
        append: $d30ea600cb89759b$var$concat(dictApplicative)
    };
};
var $d30ea600cb89759b$var$concat = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(x) {
        return function(y) {
            var f = function(v) {
                if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, $d30ea600cb89759b$var$map1(function(v1) {
                    return $d7bf9817a417d4ae$export$10d8903dec122b9d($d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative))(v1)(y);
                })(v.value1));
                if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(function(v1) {
                    return $d7bf9817a417d4ae$export$10d8903dec122b9d($d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative))(v1)(y);
                })(v.value0));
                if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(y)));
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 106, column 3 - line 106, column 43): " + [
                    v.constructor.name
                ]);
            };
            return stepMap1(f)(x);
        };
    };
};
var $d30ea600cb89759b$export$6b8d2264760710b = function(dictApplicative) {
    var semigroupListT1 = $d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative);
    return {
        mempty: $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative),
        Semigroup0: function() {
            return semigroupListT1;
        }
    };
};
var $d30ea600cb89759b$export$986c2bbe7a34be0b = function(dictFunctor) {
    return $d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)($d30ea600cb89759b$var$identity);
};
var $d30ea600cb89759b$export$204d5ba0706a4088 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $d30ea600cb89759b$export$cf70c952df59e46e(dictMonad);
        },
        Bind1: function() {
            return $d30ea600cb89759b$export$871b02513702e0(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$871b02513702e0 = function(dictMonad) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($d30ea600cb89759b$export$e65aba2be8e37f8a(dictMonad.Applicative0()));
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictMonad.Bind1().Apply0().Functor0());
    return {
        bind: function(fa) {
            return function(f) {
                var g = function(v) {
                    if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                        var h = function(s$prime) {
                            return append(f(v.value0))($70cd3177464e7915$export$2385a24977818dd0($d30ea600cb89759b$export$871b02513702e0(dictMonad))(s$prime)(f));
                        };
                        return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(h)(v.value1));
                    }
                    if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(function(v1) {
                        return $70cd3177464e7915$export$2385a24977818dd0($d30ea600cb89759b$export$871b02513702e0(dictMonad))(v1)(f);
                    })(v.value0));
                    if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 306, column 5 - line 308, column 31): " + [
                        v.constructor.name
                    ]);
                };
                return stepMap1(g)(fa);
            };
        },
        Apply0: function() {
            return $d30ea600cb89759b$export$fd7d3bacedac3347(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$fd7d3bacedac3347 = function(dictMonad) {
    var functorListT1 = $d30ea600cb89759b$export$5af6b427ff316359(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($d30ea600cb89759b$export$204d5ba0706a4088(dictMonad)),
        Functor0: function() {
            return functorListT1;
        }
    };
};
var $d30ea600cb89759b$export$cf70c952df59e46e = function(dictMonad) {
    return {
        pure: $d30ea600cb89759b$export$439306a4dcaafbb9(dictMonad.Applicative0()),
        Apply0: function() {
            return $d30ea600cb89759b$export$fd7d3bacedac3347(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$f00d8368ae31463f = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(Monad0);
    return {
        liftEffect: function() {
            var $339 = $d30ea600cb89759b$var$lift(Monad0);
            var $340 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($341) {
                return $339($340($341));
            };
        }(),
        Monad0: function() {
            return monadListT1;
        }
    };
};
var $d30ea600cb89759b$export$24d9325f26d68bae = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(Monad0);
    return {
        liftST: function() {
            var $342 = $d30ea600cb89759b$var$lift(Monad0);
            var $343 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($344) {
                return $342($343($344));
            };
        }(),
        Monad0: function() {
            return monadListT1;
        }
    };
};
var $d30ea600cb89759b$export$bf13ffdc6b7113ca = function(dictApplicative) {
    var functorListT1 = $d30ea600cb89759b$export$5af6b427ff316359(dictApplicative.Apply0().Functor0());
    return {
        alt: $d30ea600cb89759b$var$concat(dictApplicative),
        Functor0: function() {
            return functorListT1;
        }
    };
};
var $d30ea600cb89759b$export$82f742a0347e990a = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var altListT1 = $d30ea600cb89759b$export$bf13ffdc6b7113ca(Applicative0);
    return {
        empty: $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0),
        Alt0: function() {
            return altListT1;
        }
    };
};
var $d30ea600cb89759b$export$183e8a1c18c60fd3 = function(dictMonad) {
    var applicativeListT1 = $d30ea600cb89759b$export$cf70c952df59e46e(dictMonad);
    var plusListT1 = $d30ea600cb89759b$export$82f742a0347e990a(dictMonad);
    return {
        Applicative0: function() {
            return applicativeListT1;
        },
        Plus1: function() {
            return plusListT1;
        }
    };
};
var $d30ea600cb89759b$export$bb0af79e56ac53fe = function(dictMonad) {
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(dictMonad);
    var alternativeListT1 = $d30ea600cb89759b$export$183e8a1c18c60fd3(dictMonad);
    return {
        Monad0: function() {
            return monadListT1;
        },
        Alternative1: function() {
            return alternativeListT1;
        }
    };
};



// Generated by purs version 0.15.15















var $712b2df71ce372f8$export$6950f537d8cb5965 = /* #__PURE__ */ function() {
    function RWSResult(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RWSResult.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RWSResult(value0, value1, value2);
            };
        };
    };
    return RWSResult;
}();
var $712b2df71ce372f8$export$f3fc26d039f92fdf = function(x) {
    return x;
};
var $712b2df71ce372f8$export$82c3159babd6b403 = function(f) {
    return function(m) {
        return function(r) {
            return function(s) {
                return $71f2e2e9476163f8$export$7864d59d01b6d6bf(m)(f(r)(s));
            };
        };
    };
};
var $712b2df71ce372f8$export$4c8676657688a1cd = function(v) {
    return v;
};
var $712b2df71ce372f8$export$7bded133c80fee1b = {
    Coercible0: function() {
        return undefined;
    }
};
var $712b2df71ce372f8$export$1d2bc64ff0e647b4 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return {
        lift: function(dictMonad) {
            var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
            var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function(m) {
                return function(v) {
                    return function(s) {
                        return bind(m)(function(a) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                        });
                    };
                };
            };
        }
    };
};
var $712b2df71ce372f8$export$b3b7a52c4baabcad = function(f) {
    return function(v) {
        return function(r) {
            return function(s) {
                return f(v(r)(s));
            };
        };
    };
};
var $712b2df71ce372f8$export$ab4be9af97c7111d = {
    defer: function(f) {
        return function(r) {
            return function(s) {
                var v = f($05149ea687d6b460$export$523c0b569236b342);
                return v(r)(s);
            };
        };
    }
};
var $712b2df71ce372f8$export$799f7a47278c4ab2 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return function(r) {
                    return function(s) {
                        return map(function(v1) {
                            return new $712b2df71ce372f8$export$6950f537d8cb5965(v1.value0, f(v1.value1), v1.value2);
                        })(v(r)(s));
                    };
                };
            };
        }
    };
};
var $712b2df71ce372f8$export$8f895b27f6bea35a = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(v) {
        return function(r) {
            return function(s) {
                return bind(v(r)(s))(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v1.value2));
                });
            };
        };
    };
};
var $712b2df71ce372f8$export$9492f7142a7c6dda = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(v) {
        return function(r) {
            return function(s) {
                return bind(v(r)(s))(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value1, v1.value2));
                });
            };
        };
    };
};
var $712b2df71ce372f8$export$3f72b7b9b643060e = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var Functor0 = dictBind.Apply0().Functor0();
    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(Functor0);
    var functorRWST1 = $712b2df71ce372f8$export$799f7a47278c4ab2(Functor0);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        return {
            apply: function(v) {
                return function(v1) {
                    return function(r) {
                        return function(s) {
                            return bind(v(r)(s))(function(v2) {
                                return mapFlipped(v1(r)(v2.value0))(function(v3) {
                                    return new $712b2df71ce372f8$export$6950f537d8cb5965(v3.value0, v2.value1(v3.value1), append(v2.value2)(v3.value2));
                                });
                            });
                        };
                    };
                };
            },
            Functor0: function() {
                return functorRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$ecf0616f2cad1379 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictBind.Apply0().Functor0());
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictBind);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var applyRWST2 = applyRWST1(dictMonoid);
        return {
            bind: function(v) {
                return function(f) {
                    return function(r) {
                        return function(s) {
                            return bind(v(r)(s))(function(v1) {
                                var v2 = f(v1.value1);
                                return mapFlipped(v2(r)(v1.value0))(function(v3) {
                                    return new $712b2df71ce372f8$export$6950f537d8cb5965(v3.value0, v3.value1, append(v1.value2)(v3.value2));
                                });
                            });
                        };
                    };
                };
            },
            Apply0: function() {
                return applyRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$863b3ca33677d9b2 = function(dictBind) {
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictBind);
    return function(dictMonoid) {
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(applyRWST1(dictMonoid));
        return function(dictSemigroup) {
            return {
                append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
            };
        };
    };
};
var $712b2df71ce372f8$export$b7ffaf6687c91068 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictMonad.Bind1());
    return function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var applyRWST2 = applyRWST1(dictMonoid);
        return {
            pure: function(a) {
                return function(v) {
                    return function(s) {
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                    };
                };
            },
            Apply0: function() {
                return applyRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$3addf8bc39ac949f = function(dictMonad) {
    var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad);
    var bindRWST1 = $712b2df71ce372f8$export$ecf0616f2cad1379(dictMonad.Bind1());
    return function(dictMonoid) {
        var applicativeRWST2 = applicativeRWST1(dictMonoid);
        var bindRWST2 = bindRWST1(dictMonoid);
        return {
            Applicative0: function() {
                return applicativeRWST2;
            },
            Bind1: function() {
                return bindRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$b3a6ad9a80cd89aa = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            ask: function(r) {
                return function(s) {
                    return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, r, mempty));
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$149b7da9e90e1eac = function(dictMonad) {
    var monadAskRWST1 = $712b2df71ce372f8$export$b3a6ad9a80cd89aa(dictMonad);
    return function(dictMonoid) {
        var monadAskRWST2 = monadAskRWST1(dictMonoid);
        return {
            local: function(f) {
                return function(m) {
                    return function(r) {
                        return function(s) {
                            return m(f(r))(s);
                        };
                    };
                };
            },
            MonadAsk0: function() {
                return monadAskRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$1947b5c08efdf68f = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid));
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0)(dictMonoid);
        return {
            liftEffect: function() {
                var $284 = lift(Monad0);
                var $285 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
                return function($286) {
                    return $284($285($286));
                };
            }(),
            Monad0: function() {
                return monadRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$858b449733703d7f = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            tailRecM: function(k) {
                return function(a) {
                    var k$prime = function(r) {
                        return function(v) {
                            var v1 = k(v.value1);
                            return bind(v1(r)(v.value0))(function(v2) {
                                return pure(function() {
                                    if (v2.value1 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $712b2df71ce372f8$export$6950f537d8cb5965(v2.value0, v2.value1.value0, append(v.value2)(v2.value2)));
                                    if (v2.value1 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $712b2df71ce372f8$export$6950f537d8cb5965(v2.value0, v2.value1.value0, append(v.value2)(v2.value2)));
                                    throw new Error("Failed pattern match at Control.Monad.RWS.Trans (line 129, column 16 - line 131, column 68): " + [
                                        v2.value1.constructor.name
                                    ]);
                                }());
                            });
                        };
                    };
                    return function(r) {
                        return function(s) {
                            return tailRecM(k$prime(r))(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                        };
                    };
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$c835aca1626da706 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            state: function(f) {
                return function(v) {
                    return function(s) {
                        var v1 = f(s);
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v1.value1, v1.value0, mempty));
                    };
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$5538632dd3cd70cc = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var Semigroup0 = dictMonoid.Semigroup0();
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            tell: function(w) {
                return function(v) {
                    return function(s) {
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, $05149ea687d6b460$export$523c0b569236b342, w));
                    };
                };
            },
            Semigroup0: function() {
                return Semigroup0;
            },
            Monad1: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$d26d81ccbf9cc981 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadTellRWST1 = $712b2df71ce372f8$export$5538632dd3cd70cc(dictMonad);
    return function(dictMonoid) {
        var monadTellRWST2 = monadTellRWST1(dictMonoid);
        return {
            listen: function(m) {
                return function(r) {
                    return function(s) {
                        return bind(m(r)(s))(function(v) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v.value0, new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1, v.value2), v.value2));
                        });
                    };
                };
            },
            pass: function(m) {
                return function(r) {
                    return function(s) {
                        return bind(m(r)(s))(function(v) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v.value0, v.value1.value0, v.value1.value1(v.value2)));
                        });
                    };
                };
            },
            Monoid0: function() {
                return dictMonoid;
            },
            MonadTell1: function() {
                return monadTellRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$9d857fb7268a3f42 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0);
    return function(dictMonoid) {
        var lift = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid))(Monad0);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            throwError: function(e) {
                return lift(throwError(e));
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$f1aa4e7ce0e20856 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowRWST1 = $712b2df71ce372f8$export$9d857fb7268a3f42(dictMonadError.MonadThrow0());
    return function(dictMonoid) {
        var monadThrowRWST2 = monadThrowRWST1(dictMonoid);
        return {
            catchError: function(m) {
                return function(h) {
                    return function(r) {
                        return function(s) {
                            return catchError(m(r)(s))(function(e) {
                                var v = h(e);
                                return v(r)(s);
                            });
                        };
                    };
                };
            },
            MonadThrow0: function() {
                return monadThrowRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$fa98ca5d27201430 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid));
    return function(dictMonadST) {
        var Monad0 = dictMonadST.Monad0();
        var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0)(dictMonoid);
        return {
            liftST: function() {
                var $287 = lift(Monad0);
                var $288 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
                return function($289) {
                    return $287($288($289));
                };
            }(),
            Monad0: function() {
                return monadRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$83c8cfee0365f931 = function(dictMonad) {
    var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad);
    var semigroupRWST1 = $712b2df71ce372f8$export$863b3ca33677d9b2(dictMonad.Bind1());
    return function(dictMonoid) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(applicativeRWST1(dictMonoid));
        var semigroupRWST2 = semigroupRWST1(dictMonoid);
        return function(dictMonoid1) {
            var semigroupRWST3 = semigroupRWST2(dictMonoid1.Semigroup0());
            return {
                mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid1)),
                Semigroup0: function() {
                    return semigroupRWST3;
                }
            };
        };
    };
};
var $712b2df71ce372f8$export$cfb751420c588279 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorRWST1 = $712b2df71ce372f8$export$799f7a47278c4ab2(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(r) {
                    return function(s) {
                        return alt(v(r)(s))(v1(r)(s));
                    };
                };
            };
        },
        Functor0: function() {
            return functorRWST1;
        }
    };
};
var $712b2df71ce372f8$export$6179beba56f1d9b2 = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    var altRWST1 = $712b2df71ce372f8$export$cfb751420c588279(dictPlus.Alt0());
    return {
        empty: function(v) {
            return function(v1) {
                return empty;
            };
        },
        Alt0: function() {
            return altRWST1;
        }
    };
};
var $712b2df71ce372f8$export$26aad7e9ffabe87b = function(dictMonoid) {
    return function(dictAlternative) {
        var plusRWST1 = $712b2df71ce372f8$export$6179beba56f1d9b2(dictAlternative.Plus1());
        return function(dictMonad) {
            var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad)(dictMonoid);
            return {
                Applicative0: function() {
                    return applicativeRWST1;
                },
                Plus1: function() {
                    return plusRWST1;
                }
            };
        };
    };
};







var $b6d6cce78665f23d$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($fca560e14229da4e$export$6a2bb59a0c53ce17);
var $b6d6cce78665f23d$var$lift1 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d2284b2d3e1b6f87$export$fa93accd6d6dc1d2);
var $b6d6cce78665f23d$var$lift2 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d30ea600cb89759b$export$619131e858bec5bb);
var $b6d6cce78665f23d$var$lift3 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($7038ccc2f7f5bbce$export$84eda9cb75492c36);
var $b6d6cce78665f23d$var$lift4 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($848780da1bf26d9d$export$95510d0cd7e6e7eb);
var $b6d6cce78665f23d$var$lift5 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($e9bda291f4ec10ec$export$5e0a9e9fea50cb88);
var $b6d6cce78665f23d$export$bd75e69808ef8e57 = {
    liftAff: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    MonadEffect0: function() {
        return $edf0339512807bee$export$666a030cecdf96c;
    }
};
var $b6d6cce78665f23d$export$37f61af225938e0f = function(dict) {
    return dict.liftAff;
};
var $b6d6cce78665f23d$export$53acd6df2cbe3344 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectContT = $fca560e14229da4e$export$35d988300b9091c9(MonadEffect0);
    return {
        liftAff: function() {
            var $65 = $b6d6cce78665f23d$var$lift(MonadEffect0.Monad0());
            var $66 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($67) {
                return $65($66($67));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectContT;
        }
    };
};
var $b6d6cce78665f23d$export$87a4e9dc50af0c41 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectExceptT = $d2284b2d3e1b6f87$export$14ff7e4e497a86b1(MonadEffect0);
    return {
        liftAff: function() {
            var $68 = $b6d6cce78665f23d$var$lift1(MonadEffect0.Monad0());
            var $69 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($70) {
                return $68($69($70));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectExceptT;
        }
    };
};
var $b6d6cce78665f23d$export$72b48760d563ad73 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectListT = $d30ea600cb89759b$export$f00d8368ae31463f(MonadEffect0);
    return {
        liftAff: function() {
            var $71 = $b6d6cce78665f23d$var$lift2(MonadEffect0.Monad0());
            var $72 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($73) {
                return $71($72($73));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectListT;
        }
    };
};
var $b6d6cce78665f23d$export$7091efe953cca892 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectMaybe = $7038ccc2f7f5bbce$export$2f876a9cb1e407d9(MonadEffect0);
    return {
        liftAff: function() {
            var $74 = $b6d6cce78665f23d$var$lift3(MonadEffect0.Monad0());
            var $75 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($76) {
                return $74($75($76));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectMaybe;
        }
    };
};
var $b6d6cce78665f23d$export$5fd9f999a5266faf = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var Monad0 = MonadEffect0.Monad0();
    var liftAff1 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
    return function(dictMonoid) {
        var monadEffectRWS = $712b2df71ce372f8$export$1947b5c08efdf68f(dictMonoid)(MonadEffect0);
        return {
            liftAff: function() {
                var $77 = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid))(Monad0);
                return function($78) {
                    return $77(liftAff1($78));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectRWS;
            }
        };
    };
};
var $b6d6cce78665f23d$export$fa61c33f24d5bab = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectReader = $848780da1bf26d9d$export$a554ebf369a3f56d(MonadEffect0);
    return {
        liftAff: function() {
            var $79 = $b6d6cce78665f23d$var$lift4(MonadEffect0.Monad0());
            var $80 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($81) {
                return $79($80($81));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectReader;
        }
    };
};
var $b6d6cce78665f23d$export$1c14dadc45d4bfb9 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectState = $e9bda291f4ec10ec$export$cba9856135198781(MonadEffect0);
    return {
        liftAff: function() {
            var $82 = $b6d6cce78665f23d$var$lift5(MonadEffect0.Monad0());
            var $83 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($84) {
                return $82($83($84));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectState;
        }
    };
};
var $b6d6cce78665f23d$export$7ad7619eecdb33a9 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var Monad0 = MonadEffect0.Monad0();
    var liftAff1 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
    return function(dictMonoid) {
        var monadEffectWriter = $d9ef009191ddae40$export$29fece65832b4369(dictMonoid)(MonadEffect0);
        return {
            liftAff: function() {
                var $85 = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid))(Monad0);
                return function($86) {
                    return $85(liftAff1($86));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectWriter;
            }
        };
    };
};



// Generated by purs version 0.15.15




var $ec52a8164fabd1b2$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $ec52a8164fabd1b2$export$28709abf85ddce1d = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $55 = $78386b654cef599e$export$28709abf85ddce1d(dictShow);
        return function($56) {
            return liftEffect($55($56));
        };
    };
};
var $ec52a8164fabd1b2$export$c106dd0671a0fc2d = function(dictMonadEffect) {
    var $57 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($58) {
        return $57($93c729927fdf3160$export$c106dd0671a0fc2d($58));
    };
};
var $ec52a8164fabd1b2$export$1694f226a9241aae = function(dictMonadEffect) {
    var $59 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($60) {
        return $59($93c729927fdf3160$export$1694f226a9241aae($60));
    };
};
var $ec52a8164fabd1b2$export$8f2977fb54cb3601 = function(dictMonadEffect) {
    var $61 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($62) {
        return $61($93c729927fdf3160$export$8f2977fb54cb3601($62));
    };
};
var $ec52a8164fabd1b2$export$2da9be4cfdb689b1 = function(dictMonadEffect) {
    var $63 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($64) {
        return $63($93c729927fdf3160$export$2da9be4cfdb689b1($64));
    };
};
var $ec52a8164fabd1b2$export$9f43f5977f8d5609 = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $65 = $78386b654cef599e$export$9f43f5977f8d5609(dictShow);
        return function($66) {
            return liftEffect($65($66));
        };
    };
};
var $ec52a8164fabd1b2$export$bef1f36f5486a6a3 = function(dictMonadEffect) {
    var $67 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($68) {
        return $67($93c729927fdf3160$export$bef1f36f5486a6a3($68));
    };
};
var $ec52a8164fabd1b2$export$fc9467e2ad369291 = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $69 = $78386b654cef599e$export$fc9467e2ad369291(dictShow);
        return function($70) {
            return liftEffect($69($70));
        };
    };
};
var $ec52a8164fabd1b2$export$a80b3bd66acc52ff = function(dictMonadEffect) {
    var $71 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($72) {
        return $71($93c729927fdf3160$export$a80b3bd66acc52ff($72));
    };
};
var $ec52a8164fabd1b2$export$a57f3dfe595273e6 = function(dictMonadEffect) {
    return $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect)($93c729927fdf3160$export$a57f3dfe595273e6);
};
var $ec52a8164fabd1b2$export$488ef8fb3416a29f = function(dictMonadEffect) {
    var $73 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($74) {
        return $73($93c729927fdf3160$export$488ef8fb3416a29f($74));
    };
};
var $ec52a8164fabd1b2$export$e5e25fbcc1f7affe = function(dictMonadEffect) {
    var $75 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($76) {
        return $75($93c729927fdf3160$export$e5e25fbcc1f7affe($76));
    };
};
var $ec52a8164fabd1b2$export$a188e271553f9211 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var discard1 = $ec52a8164fabd1b2$var$discard(Bind1);
    var group1 = $ec52a8164fabd1b2$export$e5e25fbcc1f7affe(dictMonadEffect);
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var groupEnd1 = $ec52a8164fabd1b2$export$a57f3dfe595273e6(dictMonadEffect);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(name) {
        return function(inner) {
            return discard1(group1(name))(function() {
                return bind(inner)(function(result) {
                    return discard1(groupEnd1)(function() {
                        return pure(result);
                    });
                });
            });
        };
    };
};
var $ec52a8164fabd1b2$export$cbd229996ecd7704 = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $77 = $78386b654cef599e$export$cbd229996ecd7704(dictShow);
        return function($78) {
            return liftEffect($77($78));
        };
    };
};
var $ec52a8164fabd1b2$export$a3bc9b8ed74fc = function(dictMonadEffect) {
    var $79 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($80) {
        return $79($93c729927fdf3160$export$a3bc9b8ed74fc($80));
    };
};
var $ec52a8164fabd1b2$export$18fab8ed91d044eb = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $81 = $78386b654cef599e$export$18fab8ed91d044eb(dictShow);
        return function($82) {
            return liftEffect($81($82));
        };
    };
};
var $ec52a8164fabd1b2$export$1c9f709888824e05 = function(dictMonadEffect) {
    var $83 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($84) {
        return $83($93c729927fdf3160$export$1c9f709888824e05($84));
    };
};
var $ec52a8164fabd1b2$export$42ffd38884aecdac = function(dictMonadEffect) {
    return $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect)($93c729927fdf3160$export$42ffd38884aecdac);
};




// Generated by purs version 0.15.15














// Generated by purs version 0.15.15
const $2603425f82e959df$export$8291e5b88f90ce4 = function() {
    return window;
};



// Generated by purs version 0.15.15
function $50ae04148e431f75$export$44271b4f0c6a3563(a) {
    return function() {
        return a.target;
    };
}
function $50ae04148e431f75$export$1f61c53461aff4a5(target) {
    return function(a) {
        return function() {
            a.target = target;
        };
    };
}
function $50ae04148e431f75$export$24422be91ad4011f(a) {
    return function() {
        return a.download;
    };
}
function $50ae04148e431f75$export$4c9843daef742201(download) {
    return function(a) {
        return function() {
            a.download = download;
        };
    };
}
function $50ae04148e431f75$export$bad408f43b005bc8(a) {
    return function() {
        return a.rel;
    };
}
function $50ae04148e431f75$export$9e86d1af7d63c52c(rel) {
    return function(a) {
        return function() {
            a.rel = rel;
        };
    };
}
function $50ae04148e431f75$export$edb1c8e715f3944e(a) {
    return function() {
        return a.rev;
    };
}
function $50ae04148e431f75$export$671b41179a9f15fb(rev) {
    return function(a) {
        return function() {
            a.rev = rev;
        };
    };
}
function $50ae04148e431f75$export$5884a0b424dd5ef2(a) {
    return function() {
        return a.relList;
    };
}
function $50ae04148e431f75$export$4bf4138386d6b8cc(a) {
    return function() {
        return a.hreflang;
    };
}
function $50ae04148e431f75$export$17b5334c80252e15(hreflang) {
    return function(a) {
        return function() {
            a.hreflang = hreflang;
        };
    };
}
function $50ae04148e431f75$export$d4a6a4db5b31e621(a) {
    return function() {
        return a.type;
    };
}
function $50ae04148e431f75$export$1bf7f05044e9c5cb(type) {
    return function(a) {
        return function() {
            a.type = type;
        };
    };
}
function $50ae04148e431f75$export$6f093cfa640b7166(a) {
    return function() {
        return a.text;
    };
}
function $50ae04148e431f75$export$cbe0d99836e1498f(text) {
    return function(a) {
        return function() {
            a.text = text;
        };
    };
}




var $b2b4e127c7797d01$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$9da26c0441db8b03 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");


// Generated by purs version 0.15.15
function $63866c0466b6a770$export$228be17d80722ab(area) {
    return function() {
        return area.alt;
    };
}
function $63866c0466b6a770$export$14a0e7c2e6152665(alt) {
    return function(area) {
        return function() {
            area.alt = alt;
        };
    };
}
function $63866c0466b6a770$export$5bf93b4680474bd(area) {
    return function() {
        return area.coords;
    };
}
function $63866c0466b6a770$export$d03eafa2070fb6d7(coords) {
    return function(area) {
        return function() {
            area.coords = coords;
        };
    };
}
function $63866c0466b6a770$export$98bada23690e67eb(area) {
    return function() {
        return area.shape;
    };
}
function $63866c0466b6a770$export$89565ec41213f41c(shape) {
    return function(area) {
        return function() {
            area.shape = shape;
        };
    };
}
function $63866c0466b6a770$export$44271b4f0c6a3563(area) {
    return function() {
        return area.target;
    };
}
function $63866c0466b6a770$export$1f61c53461aff4a5(target) {
    return function(area) {
        return function() {
            area.target = target;
        };
    };
}
function $63866c0466b6a770$export$24422be91ad4011f(area) {
    return function() {
        return area.download;
    };
}
function $63866c0466b6a770$export$4c9843daef742201(download) {
    return function(area) {
        return function() {
            area.download = download;
        };
    };
}
function $63866c0466b6a770$export$bad408f43b005bc8(area) {
    return function() {
        return area.rel;
    };
}
function $63866c0466b6a770$export$9e86d1af7d63c52c(rel) {
    return function(area) {
        return function() {
            area.rel = rel;
        };
    };
}
function $63866c0466b6a770$export$5884a0b424dd5ef2(area) {
    return function() {
        return area.relList;
    };
}
function $63866c0466b6a770$export$4bf4138386d6b8cc(area) {
    return function() {
        return area.hreflang;
    };
}
function $63866c0466b6a770$export$17b5334c80252e15(hreflang) {
    return function(area) {
        return function() {
            area.hreflang = hreflang;
        };
    };
}
function $63866c0466b6a770$export$d4a6a4db5b31e621(area) {
    return function() {
        return area.type;
    };
}
function $63866c0466b6a770$export$1bf7f05044e9c5cb(type) {
    return function(area) {
        return function() {
            area.type = type;
        };
    };
}




var $c47d991e98d75165$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");


// Generated by purs version 0.15.15
function $bcd5a412110bec59$export$185802fd694ee1f5() {
    return new Audio();
}
function $bcd5a412110bec59$export$2faa2f53d87c7f7e(url) {
    return function() {
        return new Audio(url);
    };
}




var $9c48a3b1514e7e20$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$fd26055f9731f4b9 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$cdb626e247ef0ce5 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$20f9c2173df486a8 = $bcd5a412110bec59$export$2faa2f53d87c7f7e;


// Generated by purs version 0.15.15


var $28cc3aca3b37f8c1$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");


// Generated by purs version 0.15.15
function $9c737e057094c556$export$8f51af5840e0602a(base) {
    return function() {
        return base.href;
    };
}
function $9c737e057094c556$export$428f6e77b5a5a669(href) {
    return function(base) {
        return function() {
            base.href = href;
        };
    };
}
function $9c737e057094c556$export$44271b4f0c6a3563(base) {
    return function() {
        return base.target;
    };
}
function $9c737e057094c556$export$1f61c53461aff4a5(target) {
    return function(base) {
        return function() {
            base.target = target;
        };
    };
}




var $1f63464ba4e88016$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");


// Generated by purs version 0.15.15


var $9e295ac610849d32$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");


// Generated by purs version 0.15.15
function $20a948bbaa0c268a$export$4c47992fc278c9a0(button) {
    return function() {
        return button.autofocus;
    };
}
function $20a948bbaa0c268a$export$db2bbdcbda3d335e(autofocus) {
    return function(button) {
        return function() {
            button.autofocus = autofocus;
        };
    };
}
function $20a948bbaa0c268a$export$683472f6198a076e(button) {
    return function() {
        return button.disabled;
    };
}
function $20a948bbaa0c268a$export$4532d31cef66d703(disabled) {
    return function(button) {
        return function() {
            button.disabled = disabled;
        };
    };
}
function $20a948bbaa0c268a$export$242c63e9758836c2(button) {
    return function() {
        return button.form;
    };
}
function $20a948bbaa0c268a$export$7e4d70bab1b5c4a0(button) {
    return function() {
        return button.formAction;
    };
}
function $20a948bbaa0c268a$export$577bb1d64e4c83b9(formAction) {
    return function(button) {
        return function() {
            button.formAction = formAction;
        };
    };
}
function $20a948bbaa0c268a$export$21f1c8008acfa9c0(button) {
    return function() {
        return button.formEnctype;
    };
}
function $20a948bbaa0c268a$export$346989dcff4ba18b(formEnctype) {
    return function(button) {
        return function() {
            button.formEnctype = formEnctype;
        };
    };
}
function $20a948bbaa0c268a$export$3f1ffee261a00124(button) {
    return function() {
        return button.formMethod;
    };
}
function $20a948bbaa0c268a$export$c38a1a871bb0e145(formMethod) {
    return function(button) {
        return function() {
            button.formMethod = formMethod;
        };
    };
}
function $20a948bbaa0c268a$export$87c857905fcc4a84(button) {
    return function() {
        return button.formNoValidate;
    };
}
function $20a948bbaa0c268a$export$ad9ff32d0af51586(formNoValidate) {
    return function(button) {
        return function() {
            button.formNoValidate = formNoValidate;
        };
    };
}
function $20a948bbaa0c268a$export$497949a0ae76184f(button) {
    return function() {
        return button.formTarget;
    };
}
function $20a948bbaa0c268a$export$4c7e983548149eb5(formTarget) {
    return function(button) {
        return function() {
            button.formTarget = formTarget;
        };
    };
}
function $20a948bbaa0c268a$export$a8ff84c12d48cfa6(button) {
    return function() {
        return button.name;
    };
}
function $20a948bbaa0c268a$export$6cf3d710d3a367e5(name) {
    return function(button) {
        return function() {
            button.name = name;
        };
    };
}
function $20a948bbaa0c268a$export$d4a6a4db5b31e621(button) {
    return function() {
        return button.type;
    };
}
function $20a948bbaa0c268a$export$1bf7f05044e9c5cb(type) {
    return function(button) {
        return function() {
            button.type = type;
        };
    };
}
function $20a948bbaa0c268a$export$2ab9a8f9f1186f14(button) {
    return function() {
        return button.value;
    };
}
function $20a948bbaa0c268a$export$80746c6bc6142fc8(value) {
    return function(button) {
        return function() {
            button.value = value;
        };
    };
}
function $20a948bbaa0c268a$export$5e55a9e709e8e020(button) {
    return function() {
        return button.willValidate;
    };
}
function $20a948bbaa0c268a$export$1bdd3f9a89b22594(button) {
    return function() {
        return button.validity;
    };
}
function $20a948bbaa0c268a$export$6ee4201e37a931e2(button) {
    return function() {
        return button.validationMessage;
    };
}
function $20a948bbaa0c268a$export$50d70f8cedc54453(button) {
    return function() {
        return button.checkValidity();
    };
}
function $20a948bbaa0c268a$export$b962d864c477cc49(button) {
    return function() {
        return button.reportValidity();
    };
}
function $20a948bbaa0c268a$export$6f569cb704992105(value) {
    return function(button) {
        return function() {
            button.setCustomValidity(value);
        };
    };
}
function $20a948bbaa0c268a$export$a238cb463698c900(button) {
    return function() {
        return button.labels;
    };
}







var $c6219700cb28efb6$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($20a948bbaa0c268a$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $7d547317abc5459f$export$7e3df82ee760448c(canvas) {
    return function() {
        return canvas.width;
    };
}
function $7d547317abc5459f$export$67f48e0594af05d(width) {
    return function(canvas) {
        return function() {
            canvas.width = width;
        };
    };
}
function $7d547317abc5459f$export$ac607276a8fe9f0a(canvas) {
    return function() {
        return canvas.height;
    };
}
function $7d547317abc5459f$export$3f31360357be44e4(height) {
    return function(canvas) {
        return function() {
            canvas.height = height;
        };
    };
}




var $f8ac89c5dd24c0f2$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");


// Generated by purs version 0.15.15


var $6018dac1d12eb9e0$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");


// Generated by purs version 0.15.15
function $29e81da2666ff0a3$export$2ab9a8f9f1186f14(data) {
    return function() {
        return data.value;
    };
}
function $29e81da2666ff0a3$export$80746c6bc6142fc8(value) {
    return function(data) {
        return function() {
            data.value = value;
        };
    };
}




var $450df947978ac297$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");


// Generated by purs version 0.15.15
function $8cebdc995025043e$export$41c562ebe57d11e2(dle) {
    return function() {
        return dle.options;
    };
}




var $e6ed11a356105002$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");


// Generated by purs version 0.15.15


var $61286eb7c73211a7$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");


// Generated by purs version 0.15.15
function $0e1ad3264aa8b3c4$export$445a11d197c0312(doc) {
    return doc.documentElement;
}
function $0e1ad3264aa8b3c4$export$327008c45899d79e(doc) {
    return doc.head;
}
function $0e1ad3264aa8b3c4$export$773bb8dac55dfce8(doc) {
    return doc.body;
}
function $0e1ad3264aa8b3c4$export$4bf8a366db6a678b(doc) {
    return doc.readyState;
}
function $0e1ad3264aa8b3c4$export$5a15a2f945550a96(doc) {
    return doc.readyState;
}
function $0e1ad3264aa8b3c4$export$6282f43d08fc4121(doc) {
    return doc.activeElement;
}
function $0e1ad3264aa8b3c4$export$f0905ed0c7a5fd27(doc) {
    return doc.currentScript;
}
function $0e1ad3264aa8b3c4$export$6392ea9cea2135f3(doc) {
    return doc.referrer;
}
function $0e1ad3264aa8b3c4$export$a80dcad378414f77(doc) {
    return doc.title;
}
function $0e1ad3264aa8b3c4$export$485b6f1fe8b035f3(title, doc) {
    doc.title = title;
}







// Generated by purs version 0.15.15


var $99cfc603fe5cc0f7$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 = /* #__PURE__ */ function() {
    function Interactive() {}
    Interactive.value = new Interactive();
    return Interactive;
}();
var $99cfc603fe5cc0f7$export$37474717eef9e2a4 = /* #__PURE__ */ function() {
    function Complete() {}
    Complete.value = new Complete();
    return Complete;
}();
var $99cfc603fe5cc0f7$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return "Interactive";
        if (v instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return "Complete";
        throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 16, column 10 - line 19, column 27): " + [
            v.constructor.name
        ]);
    }
};
var $99cfc603fe5cc0f7$export$c2d084dc44961371 = function(v) {
    if (v instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return "loading";
    if (v instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return "interactive";
    if (v instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return "complete";
    throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 22, column 9 - line 25, column 25): " + [
        v.constructor.name
    ]);
};
var $99cfc603fe5cc0f7$export$98e6a39c04603d36 = function(v) {
    if (v === "loading") return new $06733ae99ed4f534$export$8a67b48435b5d073($99cfc603fe5cc0f7$export$669f6ea7d267feaf.value);
    if (v === "interactive") return new $06733ae99ed4f534$export$8a67b48435b5d073($99cfc603fe5cc0f7$export$43d8ad7b9c99dd97.value);
    if (v === "complete") return new $06733ae99ed4f534$export$8a67b48435b5d073($99cfc603fe5cc0f7$export$37474717eef9e2a4.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $99cfc603fe5cc0f7$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf && y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return true;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 && y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return true;
            if (x instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4 && y instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return true;
            return false;
        };
    }
};
var $99cfc603fe5cc0f7$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf && y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 && y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4 && y instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $99cfc603fe5cc0f7$export$c71e02dcc13f94a6;
    }
};


// Generated by purs version 0.15.15


var $ecd74bf9585b1551$export$3824c08153b44726 = /* #__PURE__ */ function() {
    function Visible() {}
    Visible.value = new Visible();
    return Visible;
}();
var $ecd74bf9585b1551$export$8dc98ba7eadeaa56 = /* #__PURE__ */ function() {
    function Hidden() {}
    Hidden.value = new Hidden();
    return Hidden;
}();
var $ecd74bf9585b1551$export$d2d17f8156d66f42 = {
    show: function(v) {
        if (v instanceof $ecd74bf9585b1551$export$3824c08153b44726) return "Visible";
        if (v instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return "Hidden";
        throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 15, column 10 - line 17, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $ecd74bf9585b1551$export$c2d084dc44961371 = function(v) {
    if (v instanceof $ecd74bf9585b1551$export$3824c08153b44726) return "visible";
    if (v instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return "hidden";
    throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 20, column 9 - line 22, column 21): " + [
        v.constructor.name
    ]);
};
var $ecd74bf9585b1551$export$98e6a39c04603d36 = function(v) {
    if (v === "visible") return new $06733ae99ed4f534$export$8a67b48435b5d073($ecd74bf9585b1551$export$3824c08153b44726.value);
    if (v === "hidden") return new $06733ae99ed4f534$export$8a67b48435b5d073($ecd74bf9585b1551$export$8dc98ba7eadeaa56.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $ecd74bf9585b1551$export$e4139843c5cdd239 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726 && y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return true;
            if (x instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56 && y instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return true;
            return false;
        };
    }
};
var $ecd74bf9585b1551$export$712b05ab3ead9d93 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726 && y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56 && y instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $ecd74bf9585b1551$export$e4139843c5cdd239;
    }
};



var $f6c9290a5db8f197$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f6c9290a5db8f197$export$3d0d3483832deb8e = function(doc) {
    return $f6c9290a5db8f197$var$map(function() {
        var $2 = $06733ae99ed4f534$export$43db023a260c5e9f($ecd74bf9585b1551$export$3824c08153b44726.value);
        return function($3) {
            return $2($ecd74bf9585b1551$export$98e6a39c04603d36($3));
        };
    }())(function() {
        return $0e1ad3264aa8b3c4$export$5a15a2f945550a96(doc);
    });
};
var $f6c9290a5db8f197$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$d8d5f203c133934 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$ce0e204f587740c3 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$fb184b623420d9be = function(doc) {
    return function() {
        return $0e1ad3264aa8b3c4$export$a80dcad378414f77(doc);
    };
};
var $f6c9290a5db8f197$export$420a7f2fd9cad6f6 = function(newTitle) {
    return function(doc) {
        return function() {
            return $0e1ad3264aa8b3c4$export$485b6f1fe8b035f3(newTitle, doc);
        };
    };
};
var $f6c9290a5db8f197$export$a0c6a011d8b20057 = function(doc) {
    return function() {
        return $0e1ad3264aa8b3c4$export$6392ea9cea2135f3(doc);
    };
};
var $f6c9290a5db8f197$export$1ae2b664eea77b7e = function(doc) {
    return $f6c9290a5db8f197$var$map(function() {
        var $4 = $06733ae99ed4f534$export$43db023a260c5e9f($99cfc603fe5cc0f7$export$669f6ea7d267feaf.value);
        return function($5) {
            return $4($99cfc603fe5cc0f7$export$98e6a39c04603d36($5));
        };
    }())(function() {
        return $0e1ad3264aa8b3c4$export$4bf8a366db6a678b(doc);
    });
};
var $f6c9290a5db8f197$export$5fd5031fecdacec3 = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$327008c45899d79e(doc);
    });
};
var $f6c9290a5db8f197$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$45b532d2a1c7642b = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$cb6b1c55e7404aef = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$170c446b87804fad = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$445a11d197c0312(doc);
    });
};
var $f6c9290a5db8f197$export$7aca2fdfd0625e3a = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$f0905ed0c7a5fd27(doc);
    });
};
var $f6c9290a5db8f197$export$32180ef41b15b513 = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$773bb8dac55dfce8(doc);
    });
};
var $f6c9290a5db8f197$export$da980962bd2147a4 = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$6282f43d08fc4121(doc);
    });
};


// Generated by purs version 0.15.15
function $ccf49930316caf57$export$b2a016fb14adc1e4(nothing, just, value) {
    var tag = Object.prototype.toString.call(value);
    if (tag.indexOf("[object HTML") === 0 && tag.indexOf("Element]") === tag.length - 8) return just(value);
    else return nothing;
}
function $ccf49930316caf57$export$fb184b623420d9be(elt) {
    return function() {
        return elt.title;
    };
}
function $ccf49930316caf57$export$420a7f2fd9cad6f6(title) {
    return function(elt) {
        return function() {
            elt.title = title;
        };
    };
}
function $ccf49930316caf57$export$9a771d6906431624(elt) {
    return function() {
        return elt.lang;
    };
}
function $ccf49930316caf57$export$a3665b844fbc095d(lang) {
    return function(elt) {
        return function() {
            elt.lang = lang;
        };
    };
}
function $ccf49930316caf57$export$147ec2801e896265(elt) {
    return function() {
        return elt.dir;
    };
}
function $ccf49930316caf57$export$5d00cbe77a0f4da4(dir) {
    return function(elt) {
        return function() {
            elt.dir = dir;
        };
    };
}
function $ccf49930316caf57$export$73920f18ca706874(elt) {
    return function() {
        return elt.hidden;
    };
}
function $ccf49930316caf57$export$306a681a1fc87013(hidden) {
    return function(elt) {
        return function() {
            elt.hidden = hidden;
        };
    };
}
function $ccf49930316caf57$export$9a625f9de50bf0b7(elt) {
    return function() {
        return elt.tabIndex;
    };
}
function $ccf49930316caf57$export$de72581b19a869cc(tabIndex) {
    return function(elt) {
        return function() {
            elt.tabIndex = tabIndex;
        };
    };
}
function $ccf49930316caf57$export$c746a5152d4ba26c(elt) {
    return function() {
        return elt.draggable;
    };
}
function $ccf49930316caf57$export$b681bd05c45bbdd7(draggable) {
    return function(elt) {
        return function() {
            elt.draggable = draggable;
        };
    };
}
function $ccf49930316caf57$export$d9d317b4285c34e7(elt) {
    return function() {
        return elt.contentEditable;
    };
}
function $ccf49930316caf57$export$91a56ab73e46c5d4(contentEditable) {
    return function(elt) {
        return function() {
            elt.contentEditable = contentEditable;
        };
    };
}
function $ccf49930316caf57$export$3453cc819780f652(elt) {
    return function() {
        return elt.isContentEditable;
    };
}
function $ccf49930316caf57$export$afbe3196582d9f14(elt) {
    return function() {
        return elt.spellcheck;
    };
}
function $ccf49930316caf57$export$f5c89d87509db2c2(spellcheck) {
    return function(elt) {
        return function() {
            elt.spellcheck = spellcheck;
        };
    };
}
function $ccf49930316caf57$export$64ef1bee2b9504c1(elt) {
    return function() {
        return elt.click();
    };
}
function $ccf49930316caf57$export$d7ddd398f22d79ef(elt) {
    return function() {
        return elt.focus();
    };
}
function $ccf49930316caf57$export$2cc7ff91bcacba5e(elt) {
    return function() {
        return elt.blur();
    };
}
function $ccf49930316caf57$export$351f7ed5e1f4cbfb(el) {
    return function() {
        return el.offsetParent;
    };
}
function $ccf49930316caf57$export$9051df5ff5b6ece8(el) {
    return function() {
        return el.offsetTop;
    };
}
function $ccf49930316caf57$export$4ad6bc00a859a01c(el) {
    return function() {
        return el.offsetLeft;
    };
}
function $ccf49930316caf57$export$abda199d6e675d54(el) {
    return function() {
        return el.offsetWidth;
    };
}
function $ccf49930316caf57$export$720e3813341eb9b(el) {
    return function() {
        return el.offsetHeight;
    };
}







var $5ae75883a0b7923c$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$759f2a42fd33dfde = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($ccf49930316caf57$export$351f7ed5e1f4cbfb($3));
    };
}();
var $5ae75883a0b7923c$export$7039ba397093f069 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$66db07be43ecb0c3 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$a7f097b65af8aa04 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$a0a0bf09b44710c9 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$c56654a6d0e3bd48 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$31942037104a4a20 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};


// Generated by purs version 0.15.15
function $1de55632ffb04144$export$2e40c9e35e9506f4(embed) {
    return function() {
        return embed.src;
    };
}
function $1de55632ffb04144$export$5771e3a4c80da7df(src) {
    return function(embed) {
        return function() {
            embed.src = src;
        };
    };
}
function $1de55632ffb04144$export$d4a6a4db5b31e621(embed) {
    return function() {
        return embed.type;
    };
}
function $1de55632ffb04144$export$1bf7f05044e9c5cb(type) {
    return function(embed) {
        return function() {
            embed.type = type;
        };
    };
}
function $1de55632ffb04144$export$7e3df82ee760448c(embed) {
    return function() {
        return embed.width;
    };
}
function $1de55632ffb04144$export$67f48e0594af05d(width) {
    return function(embed) {
        return function() {
            embed.width = width;
        };
    };
}
function $1de55632ffb04144$export$ac607276a8fe9f0a(embed) {
    return function() {
        return embed.height;
    };
}
function $1de55632ffb04144$export$3f31360357be44e4(height) {
    return function(embed) {
        return function() {
            embed.height = height;
        };
    };
}




var $6948c2c57b43dc19$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");


// Generated by purs version 0.15.15
function $f5ce06e2d4c9fafa$export$683472f6198a076e(fieldset) {
    return function() {
        return fieldset.disabled;
    };
}
function $f5ce06e2d4c9fafa$export$4532d31cef66d703(disabled) {
    return function(fieldset) {
        return function() {
            fieldset.disabled = disabled;
        };
    };
}
function $f5ce06e2d4c9fafa$export$242c63e9758836c2(fieldset) {
    return function() {
        return fieldset.form;
    };
}
function $f5ce06e2d4c9fafa$export$a8ff84c12d48cfa6(fieldset) {
    return function() {
        return fieldset.name;
    };
}
function $f5ce06e2d4c9fafa$export$6cf3d710d3a367e5(name) {
    return function(fieldset) {
        return function() {
            fieldset.name = name;
        };
    };
}
function $f5ce06e2d4c9fafa$export$d4a6a4db5b31e621(fieldset) {
    return function() {
        return fieldset.type;
    };
}
function $f5ce06e2d4c9fafa$export$1bf7f05044e9c5cb(type) {
    return function(fieldset) {
        return function() {
            fieldset.type = type;
        };
    };
}
function $f5ce06e2d4c9fafa$export$5e55a9e709e8e020(fieldset) {
    return function() {
        return fieldset.willValidate;
    };
}
function $f5ce06e2d4c9fafa$export$1bdd3f9a89b22594(fieldset) {
    return function() {
        return fieldset.validity;
    };
}
function $f5ce06e2d4c9fafa$export$6ee4201e37a931e2(fieldset) {
    return function() {
        return fieldset.validationMessage;
    };
}
function $f5ce06e2d4c9fafa$export$50d70f8cedc54453(fieldset) {
    return function() {
        return fieldset.checkValidity();
    };
}
function $f5ce06e2d4c9fafa$export$b962d864c477cc49(fieldset) {
    return function() {
        return fieldset.reportValidity();
    };
}
function $f5ce06e2d4c9fafa$export$6f569cb704992105(value) {
    return function(fieldset) {
        return function() {
            fieldset.setCustomValidity(value);
        };
    };
}







var $b837b4d3f419e563$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($f5ce06e2d4c9fafa$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $ea01f93abd44760a$export$7e2eca70ed294fb(form) {
    return function() {
        return form.acceptCharset;
    };
}
function $ea01f93abd44760a$export$9ec8703ca0dc2663(acceptCharset) {
    return function(form) {
        return function() {
            form.acceptCharset = acceptCharset;
        };
    };
}
function $ea01f93abd44760a$export$31eb53bd5b582a97(form) {
    return function() {
        return form.action;
    };
}
function $ea01f93abd44760a$export$a0c65badd8d09883(action) {
    return function(form) {
        return function() {
            form.action = action;
        };
    };
}
function $ea01f93abd44760a$export$485ded5f26ebe08d(form) {
    return function() {
        return form.autocomplete;
    };
}
function $ea01f93abd44760a$export$5fb7c729919301a5(autocomplete) {
    return function(form) {
        return function() {
            form.autocomplete = autocomplete;
        };
    };
}
function $ea01f93abd44760a$export$9fc5d082ec250407(form) {
    return function() {
        return form.enctype;
    };
}
function $ea01f93abd44760a$export$71f7bac871e6ce1b(enctype) {
    return function(form) {
        return function() {
            form.enctype = enctype;
        };
    };
}
function $ea01f93abd44760a$export$d8738670c721d955(form) {
    return function() {
        return form.encoding;
    };
}
function $ea01f93abd44760a$export$11699ce243a224fd(encoding) {
    return function(form) {
        return function() {
            form.encoding = encoding;
        };
    };
}
function $ea01f93abd44760a$export$26f73335cc2e7868(form) {
    return function() {
        return form.method;
    };
}
function $ea01f93abd44760a$export$8c6ecab5174b959(method) {
    return function(form) {
        return function() {
            form.method = method;
        };
    };
}
function $ea01f93abd44760a$export$a8ff84c12d48cfa6(form) {
    return function() {
        return form.name;
    };
}
function $ea01f93abd44760a$export$6cf3d710d3a367e5(name) {
    return function(form) {
        return function() {
            form.name = name;
        };
    };
}
function $ea01f93abd44760a$export$f50297589147f25e(form) {
    return function() {
        return form.noValidate;
    };
}
function $ea01f93abd44760a$export$2271539dcccd0a8a(noValidate) {
    return function(form) {
        return function() {
            form.noValidate = noValidate;
        };
    };
}
function $ea01f93abd44760a$export$44271b4f0c6a3563(form) {
    return function() {
        return form.target;
    };
}
function $ea01f93abd44760a$export$1f61c53461aff4a5(target) {
    return function(form) {
        return function() {
            form.target = target;
        };
    };
}
function $ea01f93abd44760a$export$f24224f1c91d8156(form) {
    return function() {
        return form.length;
    };
}
function $ea01f93abd44760a$export$853c27de4ce0f746(form) {
    return function() {
        form.submit();
    };
}
function $ea01f93abd44760a$export$aad8462122ac592b(form) {
    return function() {
        form.reset();
    };
}
function $ea01f93abd44760a$export$50d70f8cedc54453(form) {
    return function() {
        return form.checkValidity();
    };
}
function $ea01f93abd44760a$export$b962d864c477cc49(form) {
    return function() {
        return form.reportValidity();
    };
}




var $9f3b722473e4bf22$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");


// Generated by purs version 0.15.15


var $3f8a2c745615078e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");


// Generated by purs version 0.15.15


var $f437286c23d51fb9$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");


// Generated by purs version 0.15.15


var $a4ab4f8ed836a554$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");


// Generated by purs version 0.15.15
function $966466ed4b666020$export$2e40c9e35e9506f4(iframe) {
    return function() {
        return iframe.src;
    };
}
function $966466ed4b666020$export$5771e3a4c80da7df(src) {
    return function(iframe) {
        return function() {
            iframe.src = src;
        };
    };
}
function $966466ed4b666020$export$7be70892c9d4d10e(iframe) {
    return function() {
        return iframe.srcdoc;
    };
}
function $966466ed4b666020$export$8a11fa357d4cbbc0(srcdoc) {
    return function(iframe) {
        return function() {
            iframe.srcdoc = srcdoc;
        };
    };
}
function $966466ed4b666020$export$a8ff84c12d48cfa6(iframe) {
    return function() {
        return iframe.name;
    };
}
function $966466ed4b666020$export$6cf3d710d3a367e5(name) {
    return function(iframe) {
        return function() {
            iframe.name = name;
        };
    };
}
function $966466ed4b666020$export$7e3df82ee760448c(iframe) {
    return function() {
        return iframe.width;
    };
}
function $966466ed4b666020$export$67f48e0594af05d(width) {
    return function(iframe) {
        return function() {
            iframe.width = width;
        };
    };
}
function $966466ed4b666020$export$ac607276a8fe9f0a(iframe) {
    return function() {
        return iframe.height;
    };
}
function $966466ed4b666020$export$3f31360357be44e4(height) {
    return function(iframe) {
        return function() {
            iframe.height = height;
        };
    };
}
function $966466ed4b666020$export$a51825c89fe24f94(iframe) {
    return function() {
        return iframe.contentDocument;
    };
}
function $966466ed4b666020$export$688aae7b7ac35f92(iframe) {
    return function() {
        return iframe.contentWindow;
    };
}







var $bd620e99ccde661e$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $bd620e99ccde661e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$6677e9b58554b15d = /* #__PURE__ */ function() {
    var $2 = $bd620e99ccde661e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($966466ed4b666020$export$688aae7b7ac35f92($3));
    };
}();
var $bd620e99ccde661e$export$a186087d330c547b = /* #__PURE__ */ function() {
    var $4 = $bd620e99ccde661e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($966466ed4b666020$export$a51825c89fe24f94($5));
    };
}();


// Generated by purs version 0.15.15
function $4fb986a93dbcc125$export$185802fd694ee1f5() {
    return new Image();
}
function $4fb986a93dbcc125$export$11b6d15e47fb61cf(width) {
    return function(height) {
        return function() {
            return new Image(width, height);
        };
    };
}
function $4fb986a93dbcc125$export$228be17d80722ab(image) {
    return function() {
        return image.alt;
    };
}
function $4fb986a93dbcc125$export$14a0e7c2e6152665(alt) {
    return function(image) {
        return function() {
            image.alt = alt;
        };
    };
}
function $4fb986a93dbcc125$export$2e40c9e35e9506f4(image) {
    return function() {
        return image.src;
    };
}
function $4fb986a93dbcc125$export$5771e3a4c80da7df(src) {
    return function(image) {
        return function() {
            image.src = src;
        };
    };
}
function $4fb986a93dbcc125$export$c2507fd1cd56d483(image) {
    return function() {
        return image.srcset;
    };
}
function $4fb986a93dbcc125$export$c95fa5d268267aa4(srcset) {
    return function(image) {
        return function() {
            image.srcset = srcset;
        };
    };
}
function $4fb986a93dbcc125$export$c647cb0ee6e282fe(image) {
    return function() {
        return image.sizes;
    };
}
function $4fb986a93dbcc125$export$2652819f9fe6d59b(sizes) {
    return function(image) {
        return function() {
            image.sizes = sizes;
        };
    };
}
function $4fb986a93dbcc125$export$22e7408040d24cb8(image) {
    return function() {
        return image.currentSrc;
    };
}
function $4fb986a93dbcc125$export$2a95876eedf9defd(image) {
    return image.crossOrigin;
}
function $4fb986a93dbcc125$export$15671bab5b2a825c(crossOrigin, image) {
    image.crossOrigin = crossOrigin;
}
function $4fb986a93dbcc125$export$86f8f9f08863e403(image) {
    return function() {
        return image.useMap;
    };
}
function $4fb986a93dbcc125$export$ab416bdbb887640e(useMap) {
    return function(image) {
        return function() {
            image.useMap = useMap;
        };
    };
}
function $4fb986a93dbcc125$export$5c90113a285f2241(image) {
    return function() {
        return image.isMap;
    };
}
function $4fb986a93dbcc125$export$e634cf4c55ef6324(isMap) {
    return function(image) {
        return function() {
            image.isMap = isMap;
        };
    };
}
function $4fb986a93dbcc125$export$7e3df82ee760448c(image) {
    return function() {
        return image.width;
    };
}
function $4fb986a93dbcc125$export$67f48e0594af05d(width) {
    return function(image) {
        return function() {
            image.width = width;
        };
    };
}
function $4fb986a93dbcc125$export$ac607276a8fe9f0a(image) {
    return function() {
        return image.height;
    };
}
function $4fb986a93dbcc125$export$3f31360357be44e4(height) {
    return function(image) {
        return function() {
            image.height = height;
        };
    };
}
function $4fb986a93dbcc125$export$c32e50dfb9f4ec89(image) {
    return function() {
        return image.naturalWidth;
    };
}
function $4fb986a93dbcc125$export$6a4b566b54dc81c0(image) {
    return function() {
        return image.naturalHeight;
    };
}
function $4fb986a93dbcc125$export$8b29ef2611187a5f(image) {
    return function() {
        return image.referrerPolicy;
    };
}
function $4fb986a93dbcc125$export$c73d54db5b3c6ed4(referrerPolicy) {
    return function(image) {
        return function() {
            image.referrerPolicy = referrerPolicy;
        };
    };
}
function $4fb986a93dbcc125$export$8774eb0dcbbe3146(image) {
    return image.decoding;
}
function $4fb986a93dbcc125$export$533597f26ad51793(decoding, image) {
    image.decoding = decoding;
}
function $4fb986a93dbcc125$export$c1978f45d5c8c1fd(image) {
    return image.loading;
}
function $4fb986a93dbcc125$export$820843123ac3b9d(loading, image) {
    image.loading = loading;
}
function $4fb986a93dbcc125$export$b1bc8081da8c9e77(image) {
    return function() {
        return image.complete;
    };
}









// Generated by purs version 0.15.15


var $ff8d4f0527bf7f56$export$e1bb774e9664e700 = /* #__PURE__ */ function() {
    function Anonymous() {}
    Anonymous.value = new Anonymous();
    return Anonymous;
}();
var $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 = /* #__PURE__ */ function() {
    function UseCredentials() {}
    UseCredentials.value = new UseCredentials();
    return UseCredentials;
}();
var $ff8d4f0527bf7f56$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return "Anonymous";
        if (v instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return "UseCredentials";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 18, column 10 - line 20, column 39): " + [
            v.constructor.name
        ]);
    }
};
var $ff8d4f0527bf7f56$export$c2d084dc44961371 = function(v) {
    if (v instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return "anonymous";
    if (v instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return "use-credentials";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 30, column 9 - line 32, column 38): " + [
        v.constructor.name
    ]);
};
var $ff8d4f0527bf7f56$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($ff8d4f0527bf7f56$export$e1bb774e9664e700.value);
    if (v === "anonymous") return new $06733ae99ed4f534$export$8a67b48435b5d073($ff8d4f0527bf7f56$export$e1bb774e9664e700.value);
    if (v === "use-credentials") return new $06733ae99ed4f534$export$8a67b48435b5d073($ff8d4f0527bf7f56$export$bf6fef082af5a2d3.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $ff8d4f0527bf7f56$export$8a8a93ce7ed989f9 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700 && y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return true;
            if (x instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 && y instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return true;
            return false;
        };
    }
};
var $ff8d4f0527bf7f56$export$4877633354812171 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700 && y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 && y instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $ff8d4f0527bf7f56$export$8a8a93ce7ed989f9;
    }
};


// Generated by purs version 0.15.15


var $becf597acb9365c5$export$2ae15352e0a80063 = /* #__PURE__ */ function() {
    function Sync() {}
    Sync.value = new Sync();
    return Sync;
}();
var $becf597acb9365c5$export$4d3c597da532240f = /* #__PURE__ */ function() {
    function Async() {}
    Async.value = new Async();
    return Async;
}();
var $becf597acb9365c5$export$6cc2e70440926d44 = /* #__PURE__ */ function() {
    function Auto() {}
    Auto.value = new Auto();
    return Auto;
}();
var $becf597acb9365c5$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $becf597acb9365c5$export$2ae15352e0a80063) return "Sync";
        if (v instanceof $becf597acb9365c5$export$4d3c597da532240f) return "Async";
        if (v instanceof $becf597acb9365c5$export$6cc2e70440926d44) return "Auto";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 19, column 10 - line 22, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $becf597acb9365c5$export$c2d084dc44961371 = function(v) {
    if (v instanceof $becf597acb9365c5$export$2ae15352e0a80063) return "sync";
    if (v instanceof $becf597acb9365c5$export$4d3c597da532240f) return "async";
    if (v instanceof $becf597acb9365c5$export$6cc2e70440926d44) return "auto";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 33, column 9 - line 36, column 17): " + [
        v.constructor.name
    ]);
};
var $becf597acb9365c5$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$6cc2e70440926d44.value);
    if (v === "sync") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$2ae15352e0a80063.value);
    if (v === "async") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$4d3c597da532240f.value);
    if (v === "auto") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$6cc2e70440926d44.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $becf597acb9365c5$export$e32bcfaf2cb99de5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063 && y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return true;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f && y instanceof $becf597acb9365c5$export$4d3c597da532240f) return true;
            if (x instanceof $becf597acb9365c5$export$6cc2e70440926d44 && y instanceof $becf597acb9365c5$export$6cc2e70440926d44) return true;
            return false;
        };
    }
};
var $becf597acb9365c5$export$d32ec4886a1d7587 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063 && y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f && y instanceof $becf597acb9365c5$export$4d3c597da532240f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $becf597acb9365c5$export$4d3c597da532240f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $becf597acb9365c5$export$6cc2e70440926d44 && y instanceof $becf597acb9365c5$export$6cc2e70440926d44) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $becf597acb9365c5$export$e32bcfaf2cb99de5;
    }
};


// Generated by purs version 0.15.15


var $a591d06baacc8fdb$export$a4acc175556f6dbc = /* #__PURE__ */ function() {
    function Eager() {}
    Eager.value = new Eager();
    return Eager;
}();
var $a591d06baacc8fdb$export$b624eff549462981 = /* #__PURE__ */ function() {
    function Lazy() {}
    Lazy.value = new Lazy();
    return Lazy;
}();
var $a591d06baacc8fdb$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return "Eager";
        if (v instanceof $a591d06baacc8fdb$export$b624eff549462981) return "Lazy";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 18, column 10 - line 20, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $a591d06baacc8fdb$export$c2d084dc44961371 = function(v) {
    if (v instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return "eager";
    if (v instanceof $a591d06baacc8fdb$export$b624eff549462981) return "lazy";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 30, column 9 - line 32, column 17): " + [
        v.constructor.name
    ]);
};
var $a591d06baacc8fdb$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($a591d06baacc8fdb$export$a4acc175556f6dbc.value);
    if (v === "eager") return new $06733ae99ed4f534$export$8a67b48435b5d073($a591d06baacc8fdb$export$a4acc175556f6dbc.value);
    if (v === "lazy") return new $06733ae99ed4f534$export$8a67b48435b5d073($a591d06baacc8fdb$export$b624eff549462981.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $a591d06baacc8fdb$export$e32bcfaf2cb99de5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc && y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return true;
            if (x instanceof $a591d06baacc8fdb$export$b624eff549462981 && y instanceof $a591d06baacc8fdb$export$b624eff549462981) return true;
            return false;
        };
    }
};
var $a591d06baacc8fdb$export$d32ec4886a1d7587 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc && y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a591d06baacc8fdb$export$b624eff549462981 && y instanceof $a591d06baacc8fdb$export$b624eff549462981) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $a591d06baacc8fdb$export$e32bcfaf2cb99de5;
    }
};



var $29906668619f3a83$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $29906668619f3a83$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$3ac708362c1f96eb = function(laziness) {
    return $28d793bcad7b6401$export$6a301f847372dca1($4fb986a93dbcc125$export$820843123ac3b9d)($a591d06baacc8fdb$export$c2d084dc44961371(laziness));
};
var $29906668619f3a83$export$fe0b2eeb59b63d00 = function(hint) {
    return $28d793bcad7b6401$export$6a301f847372dca1($4fb986a93dbcc125$export$533597f26ad51793)($becf597acb9365c5$export$c2d084dc44961371(hint));
};
var $29906668619f3a83$export$e7fd69f64f92856 = function(mode) {
    return $28d793bcad7b6401$export$6a301f847372dca1($4fb986a93dbcc125$export$15671bab5b2a825c)($ff8d4f0527bf7f56$export$c2d084dc44961371(mode));
};
var $29906668619f3a83$export$46c1c92549715335 = /* #__PURE__ */ function() {
    var $3 = $29906668619f3a83$var$map(function() {
        var $6 = $06733ae99ed4f534$export$43db023a260c5e9f($a591d06baacc8fdb$export$a4acc175556f6dbc.value);
        return function($7) {
            return $6($a591d06baacc8fdb$export$98e6a39c04603d36($7));
        };
    }());
    var $4 = $28d793bcad7b6401$export$84baa7a1ea5377fd($4fb986a93dbcc125$export$c1978f45d5c8c1fd);
    return function($5) {
        return $3($4($5));
    };
}();
var $29906668619f3a83$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$7b9cc1601c0b9c78 = /* #__PURE__ */ function() {
    var $8 = $29906668619f3a83$var$map(function() {
        var $11 = $06733ae99ed4f534$export$43db023a260c5e9f($becf597acb9365c5$export$6cc2e70440926d44.value);
        return function($12) {
            return $11($becf597acb9365c5$export$98e6a39c04603d36($12));
        };
    }());
    var $9 = $28d793bcad7b6401$export$84baa7a1ea5377fd($4fb986a93dbcc125$export$8774eb0dcbbe3146);
    return function($10) {
        return $8($9($10));
    };
}();
var $29906668619f3a83$export$c47cb7c63271266e = /* #__PURE__ */ function() {
    var $13 = $29906668619f3a83$var$map($70cd3177464e7915$export$ea9fbbe247ef8e50($06733ae99ed4f534$export$e5fea5661dee377)($ff8d4f0527bf7f56$export$98e6a39c04603d36)($0a5aaf95f168428e$export$1ba013b88f4f21f3));
    var $14 = $28d793bcad7b6401$export$84baa7a1ea5377fd($4fb986a93dbcc125$export$2a95876eedf9defd);
    return function($15) {
        return $13($14($15));
    };
}();
var $29906668619f3a83$export$20f9c2173df486a8 = $4fb986a93dbcc125$export$11b6d15e47fb61cf;


// Generated by purs version 0.15.15
function $22cc4a9f2b8eb096$export$73f57eecff448cc8(input) {
    return function() {
        return input.accept;
    };
}
function $22cc4a9f2b8eb096$export$b20dfae471de8dc1(accept) {
    return function(input) {
        return function() {
            input.accept = accept;
        };
    };
}
function $22cc4a9f2b8eb096$export$228be17d80722ab(input) {
    return function() {
        return input.alt;
    };
}
function $22cc4a9f2b8eb096$export$14a0e7c2e6152665(alt) {
    return function(input) {
        return function() {
            input.alt = alt;
        };
    };
}
function $22cc4a9f2b8eb096$export$485ded5f26ebe08d(input) {
    return function() {
        return input.autocomplete;
    };
}
function $22cc4a9f2b8eb096$export$5fb7c729919301a5(autocomplete) {
    return function(input) {
        return function() {
            input.autocomplete = autocomplete;
        };
    };
}
function $22cc4a9f2b8eb096$export$4c47992fc278c9a0(input) {
    return function() {
        return input.autofocus;
    };
}
function $22cc4a9f2b8eb096$export$db2bbdcbda3d335e(autofocus) {
    return function(input) {
        return function() {
            input.autofocus = autofocus;
        };
    };
}
function $22cc4a9f2b8eb096$export$8f49a7e9e3141ccc(input) {
    return function() {
        return input.defaultChecked;
    };
}
function $22cc4a9f2b8eb096$export$63092561e9c9bec4(defaultChecked) {
    return function(input) {
        return function() {
            input.defaultChecked = defaultChecked;
        };
    };
}
function $22cc4a9f2b8eb096$export$b96bb35bc88d6fa(input) {
    return function() {
        return input.checked;
    };
}
function $22cc4a9f2b8eb096$export$d2270ed72c00a9b2(checked) {
    return function(input) {
        return function() {
            input.checked = checked;
        };
    };
}
function $22cc4a9f2b8eb096$export$9ebb36ddc946da55(input) {
    return function() {
        return input.dirName;
    };
}
function $22cc4a9f2b8eb096$export$e2460e55089b163d(dirName) {
    return function(input) {
        return function() {
            input.dirName = dirName;
        };
    };
}
function $22cc4a9f2b8eb096$export$683472f6198a076e(input) {
    return function() {
        return input.disabled;
    };
}
function $22cc4a9f2b8eb096$export$4532d31cef66d703(disabled) {
    return function(input) {
        return function() {
            input.disabled = disabled;
        };
    };
}
function $22cc4a9f2b8eb096$export$242c63e9758836c2(input) {
    return function() {
        return input.form;
    };
}
function $22cc4a9f2b8eb096$export$92d18e9db2d4e896(input) {
    return function() {
        return input.files;
    };
}
function $22cc4a9f2b8eb096$export$7e4d70bab1b5c4a0(input) {
    return function() {
        return input.formAction;
    };
}
function $22cc4a9f2b8eb096$export$577bb1d64e4c83b9(formAction) {
    return function(input) {
        return function() {
            input.formAction = formAction;
        };
    };
}
function $22cc4a9f2b8eb096$export$21f1c8008acfa9c0(input) {
    return function() {
        return input.formEnctype;
    };
}
function $22cc4a9f2b8eb096$export$346989dcff4ba18b(formEnctype) {
    return function(input) {
        return function() {
            input.formEnctype = formEnctype;
        };
    };
}
function $22cc4a9f2b8eb096$export$3f1ffee261a00124(input) {
    return function() {
        return input.formMethod;
    };
}
function $22cc4a9f2b8eb096$export$c38a1a871bb0e145(formMethod) {
    return function(input) {
        return function() {
            input.formMethod = formMethod;
        };
    };
}
function $22cc4a9f2b8eb096$export$87c857905fcc4a84(input) {
    return function() {
        return input.formNoValidate;
    };
}
function $22cc4a9f2b8eb096$export$ad9ff32d0af51586(formNoValidate) {
    return function(input) {
        return function() {
            input.formNoValidate = formNoValidate;
        };
    };
}
function $22cc4a9f2b8eb096$export$497949a0ae76184f(input) {
    return function() {
        return input.formTarget;
    };
}
function $22cc4a9f2b8eb096$export$4c7e983548149eb5(formTarget) {
    return function(input) {
        return function() {
            input.formTarget = formTarget;
        };
    };
}
function $22cc4a9f2b8eb096$export$ac607276a8fe9f0a(input) {
    return function() {
        return input.height;
    };
}
function $22cc4a9f2b8eb096$export$3f31360357be44e4(height) {
    return function(input) {
        return function() {
            input.height = height;
        };
    };
}
function $22cc4a9f2b8eb096$export$5a1fde3dfe3b3c2a(input) {
    return function() {
        return input.indeterminate;
    };
}
function $22cc4a9f2b8eb096$export$52735f1bbb810b6(indeterminate) {
    return function(input) {
        return function() {
            input.indeterminate = indeterminate;
        };
    };
}
function $22cc4a9f2b8eb096$export$8932efb87fe83757(input) {
    return function() {
        return input.list;
    };
}
function $22cc4a9f2b8eb096$export$8960430cfd85939f(input) {
    return function() {
        return input.max;
    };
}
function $22cc4a9f2b8eb096$export$b03015b7eb8a4a0d(max) {
    return function(input) {
        return function() {
            input.max = max;
        };
    };
}
function $22cc4a9f2b8eb096$export$c9f461152c658a8b(input) {
    return function() {
        return input.maxLength;
    };
}
function $22cc4a9f2b8eb096$export$45077a575ddd961f(maxLength) {
    return function(input) {
        return function() {
            input.maxLength = maxLength;
        };
    };
}
function $22cc4a9f2b8eb096$export$96ec731ed4dcb222(input) {
    return function() {
        return input.min;
    };
}
function $22cc4a9f2b8eb096$export$46d199234e678744(min) {
    return function(input) {
        return function() {
            input.min = min;
        };
    };
}
function $22cc4a9f2b8eb096$export$8fe860a115a1e636(input) {
    return function() {
        return input.minLength;
    };
}
function $22cc4a9f2b8eb096$export$2b867239766ba1e3(minLength) {
    return function(input) {
        return function() {
            input.minLength = minLength;
        };
    };
}
function $22cc4a9f2b8eb096$export$939ddaa3205df08e(input) {
    return function() {
        return input.multiple;
    };
}
function $22cc4a9f2b8eb096$export$be7c7381b31f2269(multiple) {
    return function(input) {
        return function() {
            input.multiple = multiple;
        };
    };
}
function $22cc4a9f2b8eb096$export$a8ff84c12d48cfa6(input) {
    return function() {
        return input.name;
    };
}
function $22cc4a9f2b8eb096$export$6cf3d710d3a367e5(name) {
    return function(input) {
        return function() {
            input.name = name;
        };
    };
}
function $22cc4a9f2b8eb096$export$24f82734ea047e6f(input) {
    return function() {
        return input.pattern;
    };
}
function $22cc4a9f2b8eb096$export$faed90dbedc3b6d5(pattern) {
    return function(input) {
        return function() {
            input.pattern = pattern;
        };
    };
}
function $22cc4a9f2b8eb096$export$c7187bbd1a7a9244(input) {
    return function() {
        return input.placeholder;
    };
}
function $22cc4a9f2b8eb096$export$645bf5697adfa088(placeholder) {
    return function(input) {
        return function() {
            input.placeholder = placeholder;
        };
    };
}
function $22cc4a9f2b8eb096$export$b2cbc93d4da94977(input) {
    return function() {
        return input.readOnly;
    };
}
function $22cc4a9f2b8eb096$export$62311ce54ddfc862(readOnly) {
    return function(input) {
        return function() {
            input.readOnly = readOnly;
        };
    };
}
function $22cc4a9f2b8eb096$export$a7a0278c004aac3f(input) {
    return function() {
        return input.required;
    };
}
function $22cc4a9f2b8eb096$export$47f9362469f346c4(required) {
    return function(input) {
        return function() {
            input.required = required;
        };
    };
}
function $22cc4a9f2b8eb096$export$346677f925de839c(input) {
    return function() {
        return input.size;
    };
}
function $22cc4a9f2b8eb096$export$1c70a6cc12bc0366(size) {
    return function(input) {
        return function() {
            input.size = size;
        };
    };
}
function $22cc4a9f2b8eb096$export$2e40c9e35e9506f4(input) {
    return function() {
        return input.src;
    };
}
function $22cc4a9f2b8eb096$export$5771e3a4c80da7df(src) {
    return function(input) {
        return function() {
            input.src = src;
        };
    };
}
function $22cc4a9f2b8eb096$export$35d34bc0ed591a92(input) {
    return function() {
        return input.step;
    };
}
function $22cc4a9f2b8eb096$export$5305615f76bbd5b5(step) {
    return function(input) {
        return function() {
            input.step = step;
        };
    };
}
function $22cc4a9f2b8eb096$export$d4a6a4db5b31e621(input) {
    return function() {
        return input.type;
    };
}
function $22cc4a9f2b8eb096$export$1bf7f05044e9c5cb(type) {
    return function(input) {
        return function() {
            input.type = type;
        };
    };
}
function $22cc4a9f2b8eb096$export$1a01ae0705bafd37(input) {
    return function() {
        return input.defaultValue;
    };
}
function $22cc4a9f2b8eb096$export$d8becbd7468e206f(defaultValue) {
    return function(input) {
        return function() {
            input.defaultValue = defaultValue;
        };
    };
}
function $22cc4a9f2b8eb096$export$2ab9a8f9f1186f14(input) {
    return function() {
        return input.value;
    };
}
function $22cc4a9f2b8eb096$export$80746c6bc6142fc8(value) {
    return function(input) {
        return function() {
            input.value = value;
        };
    };
}
function $22cc4a9f2b8eb096$export$f0d0381422fe3a76(input) {
    return function() {
        return input.valueAsDate;
    };
}
function $22cc4a9f2b8eb096$export$8dfa787857729211(valueAsDate) {
    return function(input) {
        return function() {
            input.valueAsDate = valueAsDate;
        };
    };
}
function $22cc4a9f2b8eb096$export$3e66e4a199ac841d(input) {
    return function() {
        return input.valueAsNumber;
    };
}
function $22cc4a9f2b8eb096$export$4f64bca7327fe0dc(valueAsNumber) {
    return function(input) {
        return function() {
            input.valueAsNumber = valueAsNumber;
        };
    };
}
function $22cc4a9f2b8eb096$export$7e3df82ee760448c(input) {
    return function() {
        return input.width;
    };
}
function $22cc4a9f2b8eb096$export$67f48e0594af05d(width) {
    return function(input) {
        return function() {
            input.width = width;
        };
    };
}
function $22cc4a9f2b8eb096$export$801b713d5ecf6e3f(n) {
    return function(input) {
        return function() {
            input.stepUp(n);
        };
    };
}
function $22cc4a9f2b8eb096$export$228be912dbc8075f(n) {
    return function(input) {
        return function() {
            input.stepDown(n);
        };
    };
}
function $22cc4a9f2b8eb096$export$5e55a9e709e8e020(input) {
    return function() {
        return input.willValidate;
    };
}
function $22cc4a9f2b8eb096$export$1bdd3f9a89b22594(input) {
    return function() {
        return input.validity;
    };
}
function $22cc4a9f2b8eb096$export$6ee4201e37a931e2(input) {
    return function() {
        return input.validationMessage;
    };
}
function $22cc4a9f2b8eb096$export$50d70f8cedc54453(input) {
    return function() {
        return input.checkValidity();
    };
}
function $22cc4a9f2b8eb096$export$b962d864c477cc49(input) {
    return function() {
        return input.reportValidity();
    };
}
function $22cc4a9f2b8eb096$export$6f569cb704992105(value) {
    return function(input) {
        return function() {
            input.setCustomValidity(value);
        };
    };
}
function $22cc4a9f2b8eb096$export$a238cb463698c900(input) {
    return function() {
        return input.labels;
    };
}
function $22cc4a9f2b8eb096$export$2e6c959c16ff56b8(input) {
    return function() {
        input.select();
    };
}
function $22cc4a9f2b8eb096$export$5e2f617ae845fb63(input) {
    return function() {
        return input.selectionStart;
    };
}
function $22cc4a9f2b8eb096$export$47b9c21811f199bd(selectionStart) {
    return function(input) {
        return function() {
            input.selectionStart = selectionStart;
        };
    };
}
function $22cc4a9f2b8eb096$export$1028be563f1155b2(input) {
    return function() {
        return input.selectionEnd;
    };
}
function $22cc4a9f2b8eb096$export$15d012c6be3c352(selectionEnd) {
    return function(input) {
        return function() {
            input.selectionEnd = selectionEnd;
        };
    };
}
function $22cc4a9f2b8eb096$export$b4e8aad052258154(input) {
    return function() {
        return input.selectionDirection;
    };
}
function $22cc4a9f2b8eb096$export$6ac306cb2c51a4e6(selectionDirection) {
    return function(input) {
        return function() {
            input.selectionDirection = selectionDirection;
        };
    };
}
function $22cc4a9f2b8eb096$export$2add2a46d1c1d557(replacement) {
    return function(input) {
        return function() {
            input.setRangeText(replacement);
        };
    };
}
function $22cc4a9f2b8eb096$export$309b5632e9b49193(replacement, start, end, selectionMode, textarea) {
    textarea.setRangeText(replacement, start, end, selectionMode);
}
function $22cc4a9f2b8eb096$export$3b045ac5f470d884(start) {
    return function(end) {
        return function(direction) {
            return function(input) {
                return function() {
                    input.setSelectionRange(start, end, direction, input);
                };
            };
        };
    };
}






// Generated by purs version 0.15.15


var $c09a3e7cfbb6a57f$export$8163af2a41fbee7 = /* #__PURE__ */ function() {
    function Preserve() {}
    Preserve.value = new Preserve();
    return Preserve;
}();
var $c09a3e7cfbb6a57f$export$ef9b1a59e592288f = /* #__PURE__ */ function() {
    function Select() {}
    Select.value = new Select();
    return Select;
}();
var $c09a3e7cfbb6a57f$export$568b89e600fc77eb = /* #__PURE__ */ function() {
    function Start() {}
    Start.value = new Start();
    return Start;
}();
var $c09a3e7cfbb6a57f$export$290d774e6bd35c9a = /* #__PURE__ */ function() {
    function End() {}
    End.value = new End();
    return End;
}();
var $c09a3e7cfbb6a57f$export$7e20bbef4bce8df9 = {
    show: function(v) {
        if (v instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return "Preserve";
        if (v instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return "Select";
        if (v instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return "Start";
        if (v instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return "End";
        throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 17, column 10 - line 21, column 17): " + [
            v.constructor.name
        ]);
    }
};
var $c09a3e7cfbb6a57f$export$c2d084dc44961371 = function(v) {
    if (v instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return "preserve";
    if (v instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return "select";
    if (v instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return "start";
    if (v instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return "end";
    throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 32, column 9 - line 36, column 15): " + [
        v.constructor.name
    ]);
};
var $c09a3e7cfbb6a57f$export$98e6a39c04603d36 = function(v) {
    if (v === "preserve") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$8163af2a41fbee7.value);
    if (v === "select") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$ef9b1a59e592288f.value);
    if (v === "start") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$568b89e600fc77eb.value);
    if (v === "end") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$290d774e6bd35c9a.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $c09a3e7cfbb6a57f$export$b299fa6c3cca1ee7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7 && y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f && y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb && y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a && y instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return true;
            return false;
        };
    }
};
var $c09a3e7cfbb6a57f$export$81b0e65721ff4cca = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7 && y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f && y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb && y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a && y instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c09a3e7cfbb6a57f$export$b299fa6c3cca1ee7;
    }
};



var $dbc3cf4ed216a106$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $dbc3cf4ed216a106$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$daa292563bc4c5ef = $22cc4a9f2b8eb096$export$801b713d5ecf6e3f;
var $dbc3cf4ed216a106$export$218b3ebffb5cc7e4 = /* #__PURE__ */ $dbc3cf4ed216a106$export$daa292563bc4c5ef(1);
var $dbc3cf4ed216a106$export$6dd86ef1ac84105c = $22cc4a9f2b8eb096$export$228be912dbc8075f;
var $dbc3cf4ed216a106$export$d45ac0df5909f3e5 = /* #__PURE__ */ $dbc3cf4ed216a106$export$6dd86ef1ac84105c(1);
var $dbc3cf4ed216a106$export$873e7fe8f20f100c = function(rpl) {
    return function(s) {
        return function(e) {
            return function(mode) {
                return function(area) {
                    return function() {
                        return $22cc4a9f2b8eb096$export$309b5632e9b49193(rpl, s, e, $c09a3e7cfbb6a57f$export$c2d084dc44961371(mode), area);
                    };
                };
            };
        };
    };
};
var $dbc3cf4ed216a106$export$8837f4fc672e936d = /* #__PURE__ */ function() {
    var $2 = $dbc3cf4ed216a106$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($22cc4a9f2b8eb096$export$8932efb87fe83757($3));
    };
}();
var $dbc3cf4ed216a106$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $4 = $dbc3cf4ed216a106$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($22cc4a9f2b8eb096$export$242c63e9758836c2($5));
    };
}();
var $dbc3cf4ed216a106$export$3a444357c5f65f65 = /* #__PURE__ */ function() {
    var $6 = $dbc3cf4ed216a106$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($7) {
        return $6($22cc4a9f2b8eb096$export$92d18e9db2d4e896($7));
    };
}();


// Generated by purs version 0.15.15
function $3aa32ab13deeb208$export$4c47992fc278c9a0(keygen) {
    return function() {
        return keygen.autofocus;
    };
}
function $3aa32ab13deeb208$export$db2bbdcbda3d335e(autofocus) {
    return function(keygen) {
        return function() {
            keygen.autofocus = autofocus;
        };
    };
}
function $3aa32ab13deeb208$export$1cb6aab4c63c6c51(keygen) {
    return function() {
        return keygen.challenge;
    };
}
function $3aa32ab13deeb208$export$e4ab94f6a56193a3(challenge) {
    return function(keygen) {
        return function() {
            keygen.challenge = challenge;
        };
    };
}
function $3aa32ab13deeb208$export$683472f6198a076e(keygen) {
    return function() {
        return keygen.disabled;
    };
}
function $3aa32ab13deeb208$export$4532d31cef66d703(disabled) {
    return function(keygen) {
        return function() {
            keygen.disabled = disabled;
        };
    };
}
function $3aa32ab13deeb208$export$242c63e9758836c2(keygen) {
    return function() {
        return keygen.form;
    };
}
function $3aa32ab13deeb208$export$63e1099bcd6b827d(keygen) {
    return function() {
        return keygen.keytype;
    };
}
function $3aa32ab13deeb208$export$d04d7126b9e1b9(keytype) {
    return function(keygen) {
        return function() {
            keygen.keytype = keytype;
        };
    };
}
function $3aa32ab13deeb208$export$a8ff84c12d48cfa6(keygen) {
    return function() {
        return keygen.name;
    };
}
function $3aa32ab13deeb208$export$6cf3d710d3a367e5(name) {
    return function(keygen) {
        return function() {
            keygen.name = name;
        };
    };
}
function $3aa32ab13deeb208$export$d4a6a4db5b31e621(keygen) {
    return function() {
        return keygen.type;
    };
}
function $3aa32ab13deeb208$export$5e55a9e709e8e020(keygen) {
    return function() {
        return keygen.willValidate;
    };
}
function $3aa32ab13deeb208$export$1bdd3f9a89b22594(keygen) {
    return function() {
        return keygen.validity;
    };
}
function $3aa32ab13deeb208$export$6ee4201e37a931e2(keygen) {
    return function() {
        return keygen.validationMessage;
    };
}
function $3aa32ab13deeb208$export$50d70f8cedc54453(keygen) {
    return function() {
        return keygen.checkValidity();
    };
}
function $3aa32ab13deeb208$export$b962d864c477cc49(keygen) {
    return function() {
        return keygen.reportValidity();
    };
}
function $3aa32ab13deeb208$export$6f569cb704992105(value) {
    return function(keygen) {
        return function() {
            keygen.setCustomValidity(value);
        };
    };
}
function $3aa32ab13deeb208$export$a238cb463698c900(keygen) {
    return function() {
        return keygen.labels;
    };
}







var $35aecd379c08dc0f$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($3aa32ab13deeb208$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $f247ebfc04032388$export$2ab9a8f9f1186f14(li) {
    return function() {
        return li.value;
    };
}
function $f247ebfc04032388$export$80746c6bc6142fc8(value) {
    return function(li) {
        return function() {
            li.value = value;
        };
    };
}




var $46bf88ea94d3504e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");


// Generated by purs version 0.15.15
function $8772cd4a9c558251$export$242c63e9758836c2(label) {
    return function() {
        return label.form;
    };
}
function $8772cd4a9c558251$export$35d9e1c947946090(label) {
    return function() {
        return label.htmlFor;
    };
}
function $8772cd4a9c558251$export$a6c638cfae205843(htmlFor) {
    return function(label) {
        return function() {
            label.htmlFor = htmlFor;
        };
    };
}
function $8772cd4a9c558251$export$317fb27ad464e186(label) {
    return function() {
        return label.control;
    };
}







var $ba933b3d44ed7c03$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $ba933b3d44ed7c03$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $ba933b3d44ed7c03$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($8772cd4a9c558251$export$242c63e9758836c2($3));
    };
}();
var $ba933b3d44ed7c03$export$b5cde1de278b4330 = /* #__PURE__ */ function() {
    var $4 = $ba933b3d44ed7c03$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($8772cd4a9c558251$export$317fb27ad464e186($5));
    };
}();


// Generated by purs version 0.15.15
function $5013c6f6daaea1f9$export$242c63e9758836c2(le) {
    return function() {
        return le.form;
    };
}







var $396c0721c94d9624$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($5013c6f6daaea1f9$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $00356bd5e80c6412$export$683472f6198a076e(link) {
    return function() {
        return link.disabled;
    };
}
function $00356bd5e80c6412$export$4532d31cef66d703(disabled) {
    return function(link) {
        return function() {
            link.disabled = disabled;
        };
    };
}
function $00356bd5e80c6412$export$8f51af5840e0602a(link) {
    return function() {
        return link.href;
    };
}
function $00356bd5e80c6412$export$428f6e77b5a5a669(href) {
    return function(link) {
        return function() {
            link.href = href;
        };
    };
}
function $00356bd5e80c6412$export$c47cb7c63271266e(link) {
    return function() {
        return link.crossOrigin;
    };
}
function $00356bd5e80c6412$export$e7fd69f64f92856(crossOrigin) {
    return function(link) {
        return function() {
            link.crossOrigin = crossOrigin;
        };
    };
}
function $00356bd5e80c6412$export$bad408f43b005bc8(link) {
    return function() {
        return link.rel;
    };
}
function $00356bd5e80c6412$export$9e86d1af7d63c52c(rel) {
    return function(link) {
        return function() {
            link.rel = rel;
        };
    };
}
function $00356bd5e80c6412$export$edb1c8e715f3944e(link) {
    return function() {
        return link.rev;
    };
}
function $00356bd5e80c6412$export$671b41179a9f15fb(rev) {
    return function(link) {
        return function() {
            link.rev = rev;
        };
    };
}
function $00356bd5e80c6412$export$5884a0b424dd5ef2(link) {
    return function() {
        return link.relList;
    };
}
function $00356bd5e80c6412$export$987d49ffe1b0900f(link) {
    return function() {
        return link.media;
    };
}
function $00356bd5e80c6412$export$5c1855deea651e41(media) {
    return function(link) {
        return function() {
            link.media = media;
        };
    };
}
function $00356bd5e80c6412$export$4bf4138386d6b8cc(link) {
    return function() {
        return link.hreflang;
    };
}
function $00356bd5e80c6412$export$17b5334c80252e15(hreflang) {
    return function(link) {
        return function() {
            link.hreflang = hreflang;
        };
    };
}
function $00356bd5e80c6412$export$d4a6a4db5b31e621(link) {
    return function() {
        return link.type;
    };
}
function $00356bd5e80c6412$export$1bf7f05044e9c5cb(type) {
    return function(link) {
        return function() {
            link.type = type;
        };
    };
}




var $66527c1ba968c066$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");


// Generated by purs version 0.15.15
function $5dbae6eb2b9d7a07$export$a8ff84c12d48cfa6(map) {
    return function() {
        return map.name;
    };
}
function $5dbae6eb2b9d7a07$export$6cf3d710d3a367e5(name) {
    return function(map) {
        return function() {
            map.name = name;
        };
    };
}
function $5dbae6eb2b9d7a07$export$4bdc600e2ccf60d6(map) {
    return function() {
        return map.areas;
    };
}
function $5dbae6eb2b9d7a07$export$6c746a5570b8b35c(map) {
    return function() {
        return map.images;
    };
}




var $55159de58cd7500d$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");


// Generated by purs version 0.15.15
function $67f0fc7db8c638cb$export$2e40c9e35e9506f4(media) {
    return function() {
        return media.src;
    };
}
function $67f0fc7db8c638cb$export$5771e3a4c80da7df(src) {
    return function(media) {
        return function() {
            media.src = src;
        };
    };
}
function $67f0fc7db8c638cb$export$22e7408040d24cb8(media) {
    return function() {
        return media.currentSrc;
    };
}
function $67f0fc7db8c638cb$export$c47cb7c63271266e(media) {
    return function() {
        return media.crossOrigin;
    };
}
function $67f0fc7db8c638cb$export$e7fd69f64f92856(crossOrigin) {
    return function(media) {
        return function() {
            media.crossOrigin = crossOrigin;
        };
    };
}
function $67f0fc7db8c638cb$export$145bdcc6d8d4a53d(media) {
    return media.networkState;
}
function $67f0fc7db8c638cb$export$513ccb98c53b8039(media) {
    return function() {
        return media.preload;
    };
}
function $67f0fc7db8c638cb$export$f6b3982121e869a(preload) {
    return function(media) {
        return function() {
            media.preload = preload;
        };
    };
}
function $67f0fc7db8c638cb$export$11e63f7b0f3d9900(media) {
    return function() {
        return media.load();
    };
}
function $67f0fc7db8c638cb$export$1a796126c2303a8(type, media) {
    return media.canPlayType(type);
}
function $67f0fc7db8c638cb$export$4bf8a366db6a678b(media) {
    return media.readyState;
}
function $67f0fc7db8c638cb$export$c8243f3943339030(media) {
    return function() {
        return media.seeking;
    };
}
function $67f0fc7db8c638cb$export$283f641d6ed1ac80(media) {
    return function() {
        return media.currentTime;
    };
}
function $67f0fc7db8c638cb$export$428d94eac67f5311(currentTime) {
    return function(media) {
        return function() {
            media.currentTime = currentTime;
        };
    };
}
function $67f0fc7db8c638cb$export$1f34108aa9eb96ab(media) {
    return function() {
        return media.duration;
    };
}
function $67f0fc7db8c638cb$export$3ee8fbdbeceaef0e(media) {
    return function() {
        return media.getStartDate();
    };
}
function $67f0fc7db8c638cb$export$cd215b91700bbebc(media) {
    return function() {
        return media.paused;
    };
}
function $67f0fc7db8c638cb$export$388da195c50bfd17(media) {
    return function() {
        return media.defaultPlaybackRate;
    };
}
function $67f0fc7db8c638cb$export$6fa34934a59a9a1(defaultPlaybackRate) {
    return function(media) {
        return function() {
            media.defaultPlaybackRate = defaultPlaybackRate;
        };
    };
}
function $67f0fc7db8c638cb$export$6d7f3930b8041bc4(media) {
    return function() {
        return media.playbackRate;
    };
}
function $67f0fc7db8c638cb$export$3f48445a0d32edb0(playbackRate) {
    return function(media) {
        return function() {
            media.playbackRate = playbackRate;
        };
    };
}
function $67f0fc7db8c638cb$export$999b7b72c79021f2(media) {
    return function() {
        return media.ended;
    };
}
function $67f0fc7db8c638cb$export$b243096046abd58(media) {
    return function() {
        return media.autoplay;
    };
}
function $67f0fc7db8c638cb$export$7a98ea7b6e6b2d36(autoplay) {
    return function(media) {
        return function() {
            media.autoplay = autoplay;
        };
    };
}
function $67f0fc7db8c638cb$export$f9ef67375ddc185(media) {
    return function() {
        return media.loop;
    };
}
function $67f0fc7db8c638cb$export$cf50c2db8dc11f8e(loop) {
    return function(media) {
        return function() {
            media.loop = loop;
        };
    };
}
function $67f0fc7db8c638cb$export$899fbdb5fa08b653(media) {
    return function() {
        media.play();
    };
}
function $67f0fc7db8c638cb$export$229c72e5fdee233b(media) {
    return function() {
        media.pause();
    };
}
function $67f0fc7db8c638cb$export$2855e964765eac9(media) {
    return function() {
        return media.mediaGroup;
    };
}
function $67f0fc7db8c638cb$export$2c8be4634a501ac1(mediaGroup) {
    return function(media) {
        return function() {
            media.mediaGroup = mediaGroup;
        };
    };
}
function $67f0fc7db8c638cb$export$cc1adf6fb659c762(media) {
    return function() {
        return media.controls;
    };
}
function $67f0fc7db8c638cb$export$891f55ce9f9e8605(controls) {
    return function(media) {
        return function() {
            media.controls = controls;
        };
    };
}
function $67f0fc7db8c638cb$export$7714b48ed08b13f2(media) {
    return function() {
        return media.volume;
    };
}
function $67f0fc7db8c638cb$export$246e658b67178cb0(volume) {
    return function(media) {
        return function() {
            media.volume = volume;
        };
    };
}
function $67f0fc7db8c638cb$export$987a4e3838aef8c6(media) {
    return function() {
        return media.muted;
    };
}
function $67f0fc7db8c638cb$export$a1680ba91cc9be33(muted) {
    return function(media) {
        return function() {
            media.muted = muted;
        };
    };
}
function $67f0fc7db8c638cb$export$4c9bd91015e50a76(media) {
    return function() {
        return media.defaultMuted;
    };
}
function $67f0fc7db8c638cb$export$a203b6be5128443d(defaultMuted) {
    return function(media) {
        return function() {
            media.defaultMuted = defaultMuted;
        };
    };
}







// Generated by purs version 0.15.15


var $0a45d905703115c9$export$fadaed88e803a5ce = /* #__PURE__ */ function() {
    function Unspecified() {}
    Unspecified.value = new Unspecified();
    return Unspecified;
}();
var $0a45d905703115c9$export$ad3bd6e4e1ec5d06 = /* #__PURE__ */ function() {
    function Maybe() {}
    Maybe.value = new Maybe();
    return Maybe;
}();
var $0a45d905703115c9$export$1fa2c133480c0d67 = /* #__PURE__ */ function() {
    function Probably() {}
    Probably.value = new Probably();
    return Probably;
}();
var $0a45d905703115c9$export$639d66421832ff11 = {
    show: function(v) {
        if (v instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return "Unspecified";
        if (v instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return "Maybe";
        if (v instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return "Probably";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 16, column 10 - line 19, column 27): " + [
            v.constructor.name
        ]);
    }
};
var $0a45d905703115c9$export$c2d084dc44961371 = function(v) {
    if (v instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return "";
    if (v instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return "maybe";
    if (v instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return "probably";
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 29, column 9 - line 32, column 25): " + [
        v.constructor.name
    ]);
};
var $0a45d905703115c9$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($0a45d905703115c9$export$fadaed88e803a5ce.value);
    if (v === "maybe") return new $06733ae99ed4f534$export$8a67b48435b5d073($0a45d905703115c9$export$ad3bd6e4e1ec5d06.value);
    if (v === "probably") return new $06733ae99ed4f534$export$8a67b48435b5d073($0a45d905703115c9$export$1fa2c133480c0d67.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $0a45d905703115c9$export$34fdecd70907479d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce && y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return true;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06 && y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return true;
            if (x instanceof $0a45d905703115c9$export$1fa2c133480c0d67 && y instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return true;
            return false;
        };
    }
};
var $0a45d905703115c9$export$dbc9bfdb74d43b21 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce && y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06 && y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0a45d905703115c9$export$1fa2c133480c0d67 && y instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0a45d905703115c9$export$34fdecd70907479d;
    }
};


// Generated by purs version 0.15.15



var $c7b3b04bec1e8e92$export$1f74963c34e8bfec = /* #__PURE__ */ function() {
    function Empty() {}
    Empty.value = new Empty();
    return Empty;
}();
var $c7b3b04bec1e8e92$export$5407f8fd4e62a93 = /* #__PURE__ */ function() {
    function Idle() {}
    Idle.value = new Idle();
    return Idle;
}();
var $c7b3b04bec1e8e92$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $c7b3b04bec1e8e92$export$9f99d34709abd9bc = /* #__PURE__ */ function() {
    function NoSource() {}
    NoSource.value = new NoSource();
    return NoSource;
}();
var $c7b3b04bec1e8e92$var$toEnumNetworkState = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$1f74963c34e8bfec.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$5407f8fd4e62a93.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$669f6ea7d267feaf.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$9f99d34709abd9bc.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $c7b3b04bec1e8e92$export$6dde42aa2c503bde = {
    show: function(v) {
        if (v instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return "Empty";
        if (v instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return "Idle";
        if (v instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return "NoSource";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 30, column 1 - line 34, column 29): " + [
            v.constructor.name
        ]);
    }
};
var $c7b3b04bec1e8e92$var$fromEnumNetworkState = function(v) {
    if (v instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return 0;
    if (v instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return 1;
    if (v instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return 2;
    if (v instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return 3;
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 47, column 3 - line 51, column 18): " + [
        v.constructor.name
    ]);
};
var $c7b3b04bec1e8e92$export$a2cfa34e78ccc2f5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec && y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93 && y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf && y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc && y instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return true;
            return false;
        };
    }
};
var $c7b3b04bec1e8e92$export$dd5f9f1c18c12839 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec && y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93 && y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf && y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc && y instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c7b3b04bec1e8e92$export$a2cfa34e78ccc2f5;
    }
};
var $c7b3b04bec1e8e92$export$e6f607f3cddfb3c1 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($c7b3b04bec1e8e92$var$toEnumNetworkState)($c7b3b04bec1e8e92$var$fromEnumNetworkState),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($c7b3b04bec1e8e92$var$toEnumNetworkState)($c7b3b04bec1e8e92$var$fromEnumNetworkState),
    Ord0: function() {
        return $c7b3b04bec1e8e92$export$dd5f9f1c18c12839;
    }
};
var $c7b3b04bec1e8e92$export$63a4f766ab578d95 = /* #__PURE__ */ function() {
    return {
        bottom: $c7b3b04bec1e8e92$export$1f74963c34e8bfec.value,
        top: $c7b3b04bec1e8e92$export$9f99d34709abd9bc.value,
        Ord0: function() {
            return $c7b3b04bec1e8e92$export$dd5f9f1c18c12839;
        }
    };
}();
var $c7b3b04bec1e8e92$export$19d342d9da2ba7a3 = {
    cardinality: 4,
    toEnum: $c7b3b04bec1e8e92$var$toEnumNetworkState,
    fromEnum: $c7b3b04bec1e8e92$var$fromEnumNetworkState,
    Bounded0: function() {
        return $c7b3b04bec1e8e92$export$63a4f766ab578d95;
    },
    Enum1: function() {
        return $c7b3b04bec1e8e92$export$e6f607f3cddfb3c1;
    }
};


// Generated by purs version 0.15.15



var $e0710ab4ffdb9869$export$aeb73cf127af2fad = /* #__PURE__ */ function() {
    function HaveNothing() {}
    HaveNothing.value = new HaveNothing();
    return HaveNothing;
}();
var $e0710ab4ffdb9869$export$e96d91cd125cf5ba = /* #__PURE__ */ function() {
    function HaveMetadata() {}
    HaveMetadata.value = new HaveMetadata();
    return HaveMetadata;
}();
var $e0710ab4ffdb9869$export$c416983dd5609b6e = /* #__PURE__ */ function() {
    function HaveCurrentData() {}
    HaveCurrentData.value = new HaveCurrentData();
    return HaveCurrentData;
}();
var $e0710ab4ffdb9869$export$3c862393aec03c72 = /* #__PURE__ */ function() {
    function HaveFutureData() {}
    HaveFutureData.value = new HaveFutureData();
    return HaveFutureData;
}();
var $e0710ab4ffdb9869$export$c0fee25792a80051 = /* #__PURE__ */ function() {
    function HaveEnoughData() {}
    HaveEnoughData.value = new HaveEnoughData();
    return HaveEnoughData;
}();
var $e0710ab4ffdb9869$var$toEnumReadyState = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$aeb73cf127af2fad.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$e96d91cd125cf5ba.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$c416983dd5609b6e.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$3c862393aec03c72.value);
    if (v === 4) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$c0fee25792a80051.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $e0710ab4ffdb9869$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return "HaveNothing";
        if (v instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return "HaveMetadata";
        if (v instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return "HaveCurrentData";
        if (v instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return "HaveFutureData";
        if (v instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return "HaveEnoughData";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 31, column 1 - line 36, column 41): " + [
            v.constructor.name
        ]);
    }
};
var $e0710ab4ffdb9869$var$fromEnumReadyState = function(v) {
    if (v instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return 0;
    if (v instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return 1;
    if (v instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return 2;
    if (v instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return 3;
    if (v instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return 4;
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 50, column 3 - line 55, column 24): " + [
        v.constructor.name
    ]);
};
var $e0710ab4ffdb9869$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad && y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return true;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba && y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return true;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e && y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return true;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72 && y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return true;
            if (x instanceof $e0710ab4ffdb9869$export$c0fee25792a80051 && y instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return true;
            return false;
        };
    }
};
var $e0710ab4ffdb9869$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad && y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba && y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e && y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72 && y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$c0fee25792a80051 && y instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $e0710ab4ffdb9869$export$c71e02dcc13f94a6;
    }
};
var $e0710ab4ffdb9869$export$f705a14e9e99c6f0 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($e0710ab4ffdb9869$var$toEnumReadyState)($e0710ab4ffdb9869$var$fromEnumReadyState),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($e0710ab4ffdb9869$var$toEnumReadyState)($e0710ab4ffdb9869$var$fromEnumReadyState),
    Ord0: function() {
        return $e0710ab4ffdb9869$export$6557947d538c3b81;
    }
};
var $e0710ab4ffdb9869$export$7b40514a91e8387e = /* #__PURE__ */ function() {
    return {
        bottom: $e0710ab4ffdb9869$export$aeb73cf127af2fad.value,
        top: $e0710ab4ffdb9869$export$c0fee25792a80051.value,
        Ord0: function() {
            return $e0710ab4ffdb9869$export$6557947d538c3b81;
        }
    };
}();
var $e0710ab4ffdb9869$export$94a641e970e969f9 = {
    cardinality: 5,
    toEnum: $e0710ab4ffdb9869$var$toEnumReadyState,
    fromEnum: $e0710ab4ffdb9869$var$fromEnumReadyState,
    Bounded0: function() {
        return $e0710ab4ffdb9869$export$7b40514a91e8387e;
    },
    Enum1: function() {
        return $e0710ab4ffdb9869$export$f705a14e9e99c6f0;
    }
};



var $01a0e25b259ac8ae$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $01a0e25b259ac8ae$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e0710ab4ffdb9869$export$94a641e970e969f9);
var $01a0e25b259ac8ae$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($c7b3b04bec1e8e92$export$19d342d9da2ba7a3);
var $01a0e25b259ac8ae$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$1ae2b664eea77b7e = function(el) {
    return $01a0e25b259ac8ae$var$map(function() {
        var $4 = $06733ae99ed4f534$export$43db023a260c5e9f($e0710ab4ffdb9869$export$aeb73cf127af2fad.value);
        return function($5) {
            return $4($01a0e25b259ac8ae$var$toEnum($5));
        };
    }())(function() {
        return $67f0fc7db8c638cb$export$4bf8a366db6a678b(el);
    });
};
var $01a0e25b259ac8ae$export$8ee3aa19592dce0d = function(el) {
    return $01a0e25b259ac8ae$var$map(function() {
        var $6 = $06733ae99ed4f534$export$43db023a260c5e9f($c7b3b04bec1e8e92$export$1f74963c34e8bfec.value);
        return function($7) {
            return $6($01a0e25b259ac8ae$var$toEnum1($7));
        };
    }())(function() {
        return $67f0fc7db8c638cb$export$145bdcc6d8d4a53d(el);
    });
};
var $01a0e25b259ac8ae$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$2b5874dc653b656c = function(ty) {
    return function(el) {
        return $01a0e25b259ac8ae$var$map(function() {
            var $8 = $06733ae99ed4f534$export$43db023a260c5e9f($0a45d905703115c9$export$fadaed88e803a5ce.value);
            return function($9) {
                return $8($0a45d905703115c9$export$98e6a39c04603d36($9));
            };
        }())(function() {
            return $67f0fc7db8c638cb$export$1a796126c2303a8(ty, el);
        });
    };
};


// Generated by purs version 0.15.15
function $d825508ebfe0ea30$export$a8ff84c12d48cfa6(meta) {
    return function() {
        return meta.name;
    };
}
function $d825508ebfe0ea30$export$6cf3d710d3a367e5(name) {
    return function(meta) {
        return function() {
            meta.name = name;
        };
    };
}
function $d825508ebfe0ea30$export$725a8790b31857c5(meta) {
    return function() {
        return meta.httpEquiv;
    };
}
function $d825508ebfe0ea30$export$253f18aa71ab8120(httpEquiv) {
    return function(meta) {
        return function() {
            meta.httpEquiv = httpEquiv;
        };
    };
}
function $d825508ebfe0ea30$export$a7db06668cad9adb(meta) {
    return function() {
        return meta.content;
    };
}
function $d825508ebfe0ea30$export$431313f2afd011e2(content) {
    return function(meta) {
        return function() {
            meta.content = content;
        };
    };
}




var $2f7018ceaced9755$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");


// Generated by purs version 0.15.15
function $4054571ff23c1117$export$2ab9a8f9f1186f14(meter) {
    return function() {
        return meter.value;
    };
}
function $4054571ff23c1117$export$80746c6bc6142fc8(value) {
    return function(meter) {
        return function() {
            meter.value = value;
        };
    };
}
function $4054571ff23c1117$export$96ec731ed4dcb222(meter) {
    return function() {
        return meter.min;
    };
}
function $4054571ff23c1117$export$46d199234e678744(min) {
    return function(meter) {
        return function() {
            meter.min = min;
        };
    };
}
function $4054571ff23c1117$export$8960430cfd85939f(meter) {
    return function() {
        return meter.max;
    };
}
function $4054571ff23c1117$export$b03015b7eb8a4a0d(max) {
    return function(meter) {
        return function() {
            meter.max = max;
        };
    };
}
function $4054571ff23c1117$export$e81601c80b4e876e(meter) {
    return function() {
        return meter.low;
    };
}
function $4054571ff23c1117$export$8b78ab0b9863288b(low) {
    return function(meter) {
        return function() {
            meter.low = low;
        };
    };
}
function $4054571ff23c1117$export$7cb505ef3217a5c4(meter) {
    return function() {
        return meter.high;
    };
}
function $4054571ff23c1117$export$f4a8cfe80ee4d275(high) {
    return function(meter) {
        return function() {
            meter.high = high;
        };
    };
}
function $4054571ff23c1117$export$49f2954c623150dd(meter) {
    return function() {
        return meter.optimum;
    };
}
function $4054571ff23c1117$export$47b0039e9987ccc5(optimum) {
    return function(meter) {
        return function() {
            meter.optimum = optimum;
        };
    };
}
function $4054571ff23c1117$export$a238cb463698c900(meter) {
    return function() {
        return meter.labels;
    };
}




var $82f5a476dc04f459$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");


// Generated by purs version 0.15.15
function $01bff2db061b962c$export$3035df57df42c31a(mod) {
    return function() {
        return mod.cite;
    };
}
function $01bff2db061b962c$export$86262a2b9f03fae3(cite) {
    return function(mod) {
        return function() {
            mod.cite = cite;
        };
    };
}
function $01bff2db061b962c$export$3a17bddce263fba0(mod) {
    return function() {
        return mod.dateTime;
    };
}
function $01bff2db061b962c$export$3a84b9eda98e95dc(dateTime) {
    return function(mod) {
        return function() {
            mod.dateTime = dateTime;
        };
    };
}




var $498acb025c9c8d86$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");


// Generated by purs version 0.15.15
function $d6916e47721f2e71$export$e2239770db970295(ol) {
    return function() {
        return ol.reversed;
    };
}
function $d6916e47721f2e71$export$9c908e987b6cb694(reversed) {
    return function(ol) {
        return function() {
            ol.reversed = reversed;
        };
    };
}
function $d6916e47721f2e71$export$b3571188c770cc5a(ol) {
    return function() {
        return ol.start;
    };
}
function $d6916e47721f2e71$export$b61b8b027b966010(start) {
    return function(ol) {
        return function() {
            ol.start = start;
        };
    };
}
function $d6916e47721f2e71$export$d4a6a4db5b31e621(ol) {
    return function() {
        return ol.type;
    };
}
function $d6916e47721f2e71$export$1bf7f05044e9c5cb(type) {
    return function(ol) {
        return function() {
            ol.type = type;
        };
    };
}




var $a24ac5c57b03a069$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");


// Generated by purs version 0.15.15
function $909c91e6774cc50c$export$70ac1efc5b13b551(object) {
    return function() {
        return object.data;
    };
}
function $909c91e6774cc50c$export$3a6802af14bf5fa6(data) {
    return function(object) {
        return function() {
            object.data = data;
        };
    };
}
function $909c91e6774cc50c$export$d4a6a4db5b31e621(object) {
    return function() {
        return object.type;
    };
}
function $909c91e6774cc50c$export$1bf7f05044e9c5cb(type) {
    return function(object) {
        return function() {
            object.type = type;
        };
    };
}
function $909c91e6774cc50c$export$dc0b74bdecf765a4(object) {
    return function() {
        return object.typeMustMatch;
    };
}
function $909c91e6774cc50c$export$a8ff84c12d48cfa6(object) {
    return function() {
        return object.name;
    };
}
function $909c91e6774cc50c$export$6cf3d710d3a367e5(name) {
    return function(object) {
        return function() {
            object.name = name;
        };
    };
}
function $909c91e6774cc50c$export$86f8f9f08863e403(object) {
    return function() {
        return object.useMap;
    };
}
function $909c91e6774cc50c$export$ab416bdbb887640e(useMap) {
    return function(object) {
        return function() {
            object.useMap = useMap;
        };
    };
}
function $909c91e6774cc50c$export$242c63e9758836c2(object) {
    return function() {
        return object.form;
    };
}
function $909c91e6774cc50c$export$7e3df82ee760448c(object) {
    return function() {
        return object.width;
    };
}
function $909c91e6774cc50c$export$67f48e0594af05d(width) {
    return function(object) {
        return function() {
            object.width = width;
        };
    };
}
function $909c91e6774cc50c$export$ac607276a8fe9f0a(object) {
    return function() {
        return object.height;
    };
}
function $909c91e6774cc50c$export$3f31360357be44e4(height) {
    return function(object) {
        return function() {
            object.height = height;
        };
    };
}
function $909c91e6774cc50c$export$a51825c89fe24f94(object) {
    return function() {
        return object.contentDocument;
    };
}
function $909c91e6774cc50c$export$5e55a9e709e8e020(object) {
    return function() {
        return object.willValidate;
    };
}
function $909c91e6774cc50c$export$1bdd3f9a89b22594(object) {
    return function() {
        return object.validity;
    };
}
function $909c91e6774cc50c$export$6ee4201e37a931e2(object) {
    return function() {
        return object.validationMessage;
    };
}
function $909c91e6774cc50c$export$50d70f8cedc54453(object) {
    return function() {
        return object.checkValidity();
    };
}
function $909c91e6774cc50c$export$b962d864c477cc49(object) {
    return function() {
        return object.reportValidity();
    };
}
function $909c91e6774cc50c$export$6f569cb704992105(value) {
    return function(object) {
        return function() {
            object.setCustomValidity(value);
        };
    };
}







var $c9b6ae535f32e637$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $c9b6ae535f32e637$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $c9b6ae535f32e637$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($909c91e6774cc50c$export$242c63e9758836c2($3));
    };
}();
var $c9b6ae535f32e637$export$a186087d330c547b = /* #__PURE__ */ function() {
    var $4 = $c9b6ae535f32e637$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($909c91e6774cc50c$export$a51825c89fe24f94($5));
    };
}();


// Generated by purs version 0.15.15
function $b75c0419f3dc5c84$export$683472f6198a076e(optgroup) {
    return function() {
        return optgroup.disabled;
    };
}
function $b75c0419f3dc5c84$export$4532d31cef66d703(disabled) {
    return function(optgroup) {
        return function() {
            optgroup.disabled = disabled;
        };
    };
}
function $b75c0419f3dc5c84$export$1237798dc640739a(optgroup) {
    return function() {
        return optgroup.label;
    };
}
function $b75c0419f3dc5c84$export$4f65e594f6031297(label) {
    return function(optgroup) {
        return function() {
            optgroup.label = label;
        };
    };
}




var $c89958870ff6a525$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");


// Generated by purs version 0.15.15
function $e580fc0cf2be85d0$export$683472f6198a076e(option) {
    return function() {
        return option.disabled;
    };
}
function $e580fc0cf2be85d0$export$4532d31cef66d703(disabled) {
    return function(option) {
        return function() {
            option.disabled = disabled;
        };
    };
}
function $e580fc0cf2be85d0$export$242c63e9758836c2(option) {
    return function() {
        return option.form;
    };
}
function $e580fc0cf2be85d0$export$1237798dc640739a(option) {
    return function() {
        return option.label;
    };
}
function $e580fc0cf2be85d0$export$4f65e594f6031297(label) {
    return function(option) {
        return function() {
            option.label = label;
        };
    };
}
function $e580fc0cf2be85d0$export$63db087985f790e3(option) {
    return function() {
        return option.defaultSelected;
    };
}
function $e580fc0cf2be85d0$export$83d19b461d3b2ee7(defaultSelected) {
    return function(option) {
        return function() {
            option.defaultSelected = defaultSelected;
        };
    };
}
function $e580fc0cf2be85d0$export$d90250155de6d7e7(option) {
    return function() {
        return option.selected;
    };
}
function $e580fc0cf2be85d0$export$5a4818cec1656a71(selected) {
    return function(option) {
        return function() {
            option.selected = selected;
        };
    };
}
function $e580fc0cf2be85d0$export$2ab9a8f9f1186f14(option) {
    return function() {
        return option.value;
    };
}
function $e580fc0cf2be85d0$export$80746c6bc6142fc8(value) {
    return function(option) {
        return function() {
            option.value = value;
        };
    };
}
function $e580fc0cf2be85d0$export$6f093cfa640b7166(option) {
    return function() {
        return option.text;
    };
}
function $e580fc0cf2be85d0$export$cbe0d99836e1498f(text) {
    return function(option) {
        return function() {
            option.text = text;
        };
    };
}
function $e580fc0cf2be85d0$export$b610b8812bbcded9(option) {
    return function() {
        return option.index;
    };
}







var $18ef343036740bd3$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($e580fc0cf2be85d0$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $9bed875784302b3c$export$242c63e9758836c2(output) {
    return function() {
        return output.form;
    };
}
function $9bed875784302b3c$export$a8ff84c12d48cfa6(output) {
    return function() {
        return output.name;
    };
}
function $9bed875784302b3c$export$6cf3d710d3a367e5(name) {
    return function(output) {
        return function() {
            output.name = name;
        };
    };
}
function $9bed875784302b3c$export$d4a6a4db5b31e621(output) {
    return function() {
        return output.type;
    };
}
function $9bed875784302b3c$export$1a01ae0705bafd37(output) {
    return function() {
        return output.defaultValue;
    };
}
function $9bed875784302b3c$export$d8becbd7468e206f(defaultValue) {
    return function(output) {
        return function() {
            output.defaultValue = defaultValue;
        };
    };
}
function $9bed875784302b3c$export$2ab9a8f9f1186f14(output) {
    return function() {
        return output.value;
    };
}
function $9bed875784302b3c$export$80746c6bc6142fc8(value) {
    return function(output) {
        return function() {
            output.value = value;
        };
    };
}
function $9bed875784302b3c$export$5e55a9e709e8e020(output) {
    return function() {
        return output.willValidate;
    };
}
function $9bed875784302b3c$export$1bdd3f9a89b22594(output) {
    return function() {
        return output.validity;
    };
}
function $9bed875784302b3c$export$6ee4201e37a931e2(output) {
    return function() {
        return output.validationMessage;
    };
}
function $9bed875784302b3c$export$50d70f8cedc54453(output) {
    return function() {
        return output.checkValidity();
    };
}
function $9bed875784302b3c$export$b962d864c477cc49(output) {
    return function() {
        return output.reportValidity();
    };
}
function $9bed875784302b3c$export$6f569cb704992105(value) {
    return function(output) {
        return function() {
            output.setCustomValidity(value);
        };
    };
}
function $9bed875784302b3c$export$a238cb463698c900(output) {
    return function() {
        return output.labels;
    };
}







var $77afbd0210834ce4$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($9bed875784302b3c$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15


var $caf6f82488ae8096$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");


// Generated by purs version 0.15.15
function $1c5afef61dd21eb4$export$a8ff84c12d48cfa6(param) {
    return function() {
        return param.name;
    };
}
function $1c5afef61dd21eb4$export$6cf3d710d3a367e5(name) {
    return function(param) {
        return function() {
            param.name = name;
        };
    };
}
function $1c5afef61dd21eb4$export$2ab9a8f9f1186f14(param) {
    return function() {
        return param.value;
    };
}
function $1c5afef61dd21eb4$export$80746c6bc6142fc8(value) {
    return function(param) {
        return function() {
            param.value = value;
        };
    };
}




var $f98a066659a15f53$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");


// Generated by purs version 0.15.15


var $84ac7e6146bd7613$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");


// Generated by purs version 0.15.15
function $c65b15421363cde9$export$2ab9a8f9f1186f14(progress) {
    return function() {
        return progress.value;
    };
}
function $c65b15421363cde9$export$80746c6bc6142fc8(value) {
    return function(progress) {
        return function() {
            progress.value = value;
        };
    };
}
function $c65b15421363cde9$export$8960430cfd85939f(progress) {
    return function() {
        return progress.max;
    };
}
function $c65b15421363cde9$export$b03015b7eb8a4a0d(max) {
    return function(progress) {
        return function() {
            progress.max = max;
        };
    };
}
function $c65b15421363cde9$export$5880b8b5730aff45(progress) {
    return function() {
        return progress.position;
    };
}
function $c65b15421363cde9$export$a238cb463698c900(progress) {
    return function() {
        return progress.labels;
    };
}




var $dabdbb18392010de$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");


// Generated by purs version 0.15.15
function $1e6d0af303f227ec$export$3035df57df42c31a(quote) {
    return function() {
        return quote.cite;
    };
}
function $1e6d0af303f227ec$export$86262a2b9f03fae3(cite) {
    return function(quote) {
        return function() {
            quote.cite = cite;
        };
    };
}




var $5d0c2c5071b861d1$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");


// Generated by purs version 0.15.15
function $4bf6127f0f22b047$export$2e40c9e35e9506f4(script) {
    return function() {
        return script.src;
    };
}
function $4bf6127f0f22b047$export$5771e3a4c80da7df(src) {
    return function(script) {
        return function() {
            script.src = src;
        };
    };
}
function $4bf6127f0f22b047$export$d4a6a4db5b31e621(script) {
    return function() {
        return script.type;
    };
}
function $4bf6127f0f22b047$export$1bf7f05044e9c5cb(type) {
    return function(script) {
        return function() {
            script.type = type;
        };
    };
}
function $4bf6127f0f22b047$export$e4c823724462c3fd(script) {
    return function() {
        return script.charset;
    };
}
function $4bf6127f0f22b047$export$61ed102e375c8bae(charset) {
    return function(script) {
        return function() {
            script.charset = charset;
        };
    };
}
function $4bf6127f0f22b047$export$12af436354f1a4f7(script) {
    return function() {
        return script.async;
    };
}
function $4bf6127f0f22b047$export$8ed1e1e4b75b53c6(async) {
    return function(script) {
        return function() {
            script.async = async;
        };
    };
}
function $4bf6127f0f22b047$export$260e5c0943f31606(script) {
    return function() {
        return script.defer;
    };
}
function $4bf6127f0f22b047$export$d440c7f1383ddd12(defer) {
    return function(script) {
        return function() {
            script.defer = defer;
        };
    };
}
function $4bf6127f0f22b047$export$c47cb7c63271266e(script) {
    return function() {
        return script.crossOrigin;
    };
}
function $4bf6127f0f22b047$export$e7fd69f64f92856(crossOrigin) {
    return function(script) {
        return function() {
            script.crossOrigin = crossOrigin;
        };
    };
}
function $4bf6127f0f22b047$export$6f093cfa640b7166(script) {
    return function() {
        return script.text;
    };
}
function $4bf6127f0f22b047$export$cbe0d99836e1498f(text) {
    return function(script) {
        return function() {
            script.text = text;
        };
    };
}




var $1143394fd0c1cb41$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");


// Generated by purs version 0.15.15
function $4f460bff72193069$export$4c47992fc278c9a0(select) {
    return function() {
        return select.autofocus;
    };
}
function $4f460bff72193069$export$db2bbdcbda3d335e(autofocus) {
    return function(select) {
        return function() {
            select.autofocus = autofocus;
        };
    };
}
function $4f460bff72193069$export$683472f6198a076e(select) {
    return function() {
        return select.disabled;
    };
}
function $4f460bff72193069$export$4532d31cef66d703(disabled) {
    return function(select) {
        return function() {
            select.disabled = disabled;
        };
    };
}
function $4f460bff72193069$export$939ddaa3205df08e(select) {
    return function() {
        return select.multiple;
    };
}
function $4f460bff72193069$export$be7c7381b31f2269(multiple) {
    return function(select) {
        return function() {
            select.multiple = multiple;
        };
    };
}
function $4f460bff72193069$export$242c63e9758836c2(select) {
    return function() {
        return select.form;
    };
}
function $4f460bff72193069$export$a8ff84c12d48cfa6(select) {
    return function() {
        return select.name;
    };
}
function $4f460bff72193069$export$6cf3d710d3a367e5(name) {
    return function(select) {
        return function() {
            select.name = name;
        };
    };
}
function $4f460bff72193069$export$a7a0278c004aac3f(select) {
    return function() {
        return select.required;
    };
}
function $4f460bff72193069$export$47f9362469f346c4(required) {
    return function(select) {
        return function() {
            select.required = required;
        };
    };
}
function $4f460bff72193069$export$346677f925de839c(select) {
    return function() {
        return select.size;
    };
}
function $4f460bff72193069$export$1c70a6cc12bc0366(size) {
    return function(select) {
        return function() {
            select.size = size;
        };
    };
}
function $4f460bff72193069$export$d4a6a4db5b31e621(select) {
    return function() {
        return select.type;
    };
}
function $4f460bff72193069$export$f24224f1c91d8156(select) {
    return function() {
        return select.length;
    };
}
function $4f460bff72193069$export$e37a2cb6f0a9cac9(length) {
    return function(select) {
        return function() {
            select.length = length;
        };
    };
}
function $4f460bff72193069$export$b0ea99e7ae5aed6c(select) {
    return function() {
        return select.selectedOptions;
    };
}
function $4f460bff72193069$export$9ea87e299ff6a368(select) {
    return function() {
        return select.selectedIndex;
    };
}
function $4f460bff72193069$export$940820044e1b4923(selectedIndex) {
    return function(select) {
        return function() {
            select.selectedIndex = selectedIndex;
        };
    };
}
function $4f460bff72193069$export$2ab9a8f9f1186f14(select) {
    return function() {
        return select.value;
    };
}
function $4f460bff72193069$export$80746c6bc6142fc8(value) {
    return function(select) {
        return function() {
            select.value = value;
        };
    };
}
function $4f460bff72193069$export$5e55a9e709e8e020(select) {
    return function() {
        return select.willValidate;
    };
}
function $4f460bff72193069$export$1bdd3f9a89b22594(select) {
    return function() {
        return select.validity;
    };
}
function $4f460bff72193069$export$6ee4201e37a931e2(select) {
    return function() {
        return select.validationMessage;
    };
}
function $4f460bff72193069$export$50d70f8cedc54453(select) {
    return function() {
        return select.checkValidity();
    };
}
function $4f460bff72193069$export$b962d864c477cc49(select) {
    return function() {
        return select.reportValidity();
    };
}
function $4f460bff72193069$export$6f569cb704992105(value) {
    return function(select) {
        return function() {
            select.setCustomValidity(value);
        };
    };
}
function $4f460bff72193069$export$a238cb463698c900(select) {
    return function() {
        return select.labels;
    };
}







var $a54214b82be35498$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($4f460bff72193069$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $30fdbf6c46de325a$export$2e40c9e35e9506f4(source) {
    return function() {
        return source.src;
    };
}
function $30fdbf6c46de325a$export$5771e3a4c80da7df(src) {
    return function(source) {
        return function() {
            source.src = src;
        };
    };
}
function $30fdbf6c46de325a$export$d4a6a4db5b31e621(source) {
    return function() {
        return source.type;
    };
}
function $30fdbf6c46de325a$export$1bf7f05044e9c5cb(type) {
    return function(source) {
        return function() {
            source.type = type;
        };
    };
}
function $30fdbf6c46de325a$export$987d49ffe1b0900f(source) {
    return function() {
        return source.media;
    };
}
function $30fdbf6c46de325a$export$5c1855deea651e41(media) {
    return function(source) {
        return function() {
            source.media = media;
        };
    };
}




var $e84e4cab6b69fa3a$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");


// Generated by purs version 0.15.15


var $1258819ad56163ca$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");


// Generated by purs version 0.15.15
function $3945cfcc1dd51d92$export$987d49ffe1b0900f(style) {
    return function() {
        return style.media;
    };
}
function $3945cfcc1dd51d92$export$5c1855deea651e41(media) {
    return function(style) {
        return function() {
            style.media = media;
        };
    };
}
function $3945cfcc1dd51d92$export$d4a6a4db5b31e621(style) {
    return function() {
        return style.type;
    };
}
function $3945cfcc1dd51d92$export$1bf7f05044e9c5cb(type) {
    return function(style) {
        return function() {
            style.type = type;
        };
    };
}




var $c2a5f1d09180ba9d$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");


// Generated by purs version 0.15.15


var $4d7ca2355751c293$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");


// Generated by purs version 0.15.15
function $dd45d132df79042b$export$47be69ffacd0da98(cell) {
    return function() {
        return cell.colSpan;
    };
}
function $dd45d132df79042b$export$41feea65f12f6ad6(colSpan) {
    return function(cell) {
        return function() {
            cell.colSpan = colSpan;
        };
    };
}
function $dd45d132df79042b$export$a5ce0649174d616e(cell) {
    return function() {
        return cell.rowSpan;
    };
}
function $dd45d132df79042b$export$1f37716400d14942(rowSpan) {
    return function(cell) {
        return function() {
            cell.rowSpan = rowSpan;
        };
    };
}
function $dd45d132df79042b$export$b507ffb2fd978043(cell) {
    return function() {
        return cell.cellIndex;
    };
}




var $ca40d224410598c5$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");


// Generated by purs version 0.15.15
function $34ac56698048b1d0$export$afc1bfabebaf28a2(col) {
    return function() {
        return col.span;
    };
}
function $34ac56698048b1d0$export$8ab2f2e6ee8ed0a8(span) {
    return function(col) {
        return function() {
            col.span = span;
        };
    };
}




var $298b737852233db7$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");


// Generated by purs version 0.15.15


var $90a91012d61f1bcd$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$619123619593c03d = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$7b01868159b235fe = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");


// Generated by purs version 0.15.15
function $48dd68dffe0e6e15$export$b815d8b2ae8b8a8f(table) {
    return function() {
        return table.caption;
    };
}
function $48dd68dffe0e6e15$export$c1cd099bccef98fe(caption) {
    return function(table) {
        return function() {
            table.caption = caption;
        };
    };
}
function $48dd68dffe0e6e15$export$690474d079e8aee0(table) {
    return function() {
        return table.createCaption();
    };
}
function $48dd68dffe0e6e15$export$2f169497140e8e8c(table) {
    return function() {
        table.deleteCaption();
    };
}
function $48dd68dffe0e6e15$export$75d2083daf0d4c8(table) {
    return function() {
        return table.tHead;
    };
}
function $48dd68dffe0e6e15$export$accedb93377ebcb2(tHead) {
    return function(table) {
        return function() {
            table.tHead = tHead;
        };
    };
}
function $48dd68dffe0e6e15$export$8e9dedfded1540ee(table) {
    return function() {
        return table.createTHead();
    };
}
function $48dd68dffe0e6e15$export$c28532ed8fc4a976(table) {
    return function() {
        table.deleteTHead();
    };
}
function $48dd68dffe0e6e15$export$6c9b4fbde50fbc0f(table) {
    return function() {
        return table.tFoot;
    };
}
function $48dd68dffe0e6e15$export$10a8938b95fbdb4(tFoot) {
    return function(table) {
        return function() {
            table.tFoot = tFoot;
        };
    };
}
function $48dd68dffe0e6e15$export$ab9f248e0049bb9d(table) {
    return function() {
        return table.createTFoot();
    };
}
function $48dd68dffe0e6e15$export$3c3cb2a6af70fe52(table) {
    return function() {
        table.deleteTFoot();
    };
}
function $48dd68dffe0e6e15$export$c63586cd99d53eee(table) {
    return function() {
        return table.tBodies;
    };
}
function $48dd68dffe0e6e15$export$76a5bd1e5d516e91(table) {
    return function() {
        return table.createTBody();
    };
}
function $48dd68dffe0e6e15$export$2dd197b55cf13440(table) {
    return function() {
        return table.rows;
    };
}
function $48dd68dffe0e6e15$export$281b3c86eeab738f(index) {
    return function(table) {
        return function() {
            return table.insertRow(index);
        };
    };
}
function $48dd68dffe0e6e15$export$2ef39e5ffdaff9ed(index) {
    return function(table) {
        return function() {
            table.deleteRow(index);
        };
    };
}
function $48dd68dffe0e6e15$export$1edee58a52776cd9(table) {
    return function() {
        return table.border;
    };
}
function $48dd68dffe0e6e15$export$df6de19f3e6baa52(border) {
    return function(table) {
        return function() {
            table.border = border;
        };
    };
}







var $00106f41ab48b85e$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $00106f41ab48b85e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$8ffb9307dee41683 = /* #__PURE__ */ function() {
    var $3 = $00106f41ab48b85e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($4) {
        return $3($48dd68dffe0e6e15$export$75d2083daf0d4c8($4));
    };
}();
var $00106f41ab48b85e$export$4ce044d081650b4 = /* #__PURE__ */ function() {
    var $5 = $00106f41ab48b85e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($6) {
        return $5($48dd68dffe0e6e15$export$6c9b4fbde50fbc0f($6));
    };
}();
var $00106f41ab48b85e$export$73c0abfa2c0e52e4 = function($7) {
    return $48dd68dffe0e6e15$export$accedb93377ebcb2($0a5aaf95f168428e$export$b187f57ee1822bc5($7));
};
var $00106f41ab48b85e$export$1350b3df0623f8d7 = function($8) {
    return $48dd68dffe0e6e15$export$10a8938b95fbdb4($0a5aaf95f168428e$export$b187f57ee1822bc5($8));
};
var $00106f41ab48b85e$export$c972b85f531b9f41 = function($9) {
    return $48dd68dffe0e6e15$export$c1cd099bccef98fe($0a5aaf95f168428e$export$b187f57ee1822bc5($9));
};
var $00106f41ab48b85e$export$6f91cb21ef21b608 = $48dd68dffe0e6e15$export$281b3c86eeab738f;
var $00106f41ab48b85e$export$5a4e94bbc04b5f2 = /* #__PURE__ */ function() {
    return $00106f41ab48b85e$export$6f91cb21ef21b608(-1);
}();
var $00106f41ab48b85e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$8e3c2dfdc4f0453d = /* #__PURE__ */ function() {
    var $10 = $00106f41ab48b85e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($11) {
        return $10($48dd68dffe0e6e15$export$b815d8b2ae8b8a8f($11));
    };
}();


// Generated by purs version 0.15.15
function $d0f5df104e75ba24$export$5cff813ca8e50db9(cell) {
    return function() {
        return cell.scope;
    };
}
function $d0f5df104e75ba24$export$d9e5239df8f952de(scope) {
    return function(cell) {
        return function() {
            cell.scope = scope;
        };
    };
}
function $d0f5df104e75ba24$export$2bcb785951133fe5(cell) {
    return function() {
        return cell.abbr;
    };
}
function $d0f5df104e75ba24$export$4b75111ed99261c8(abbr) {
    return function(cell) {
        return function() {
            cell.abbr = abbr;
        };
    };
}




var $51e7753cdccb5d79$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$619123619593c03d = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$7b01868159b235fe = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");


// Generated by purs version 0.15.15
function $e090f42f468fa271$export$f6e5b2c929a2f19d(row) {
    return function() {
        return row.rowIndex;
    };
}
function $e090f42f468fa271$export$11d8b50a98496a38(row) {
    return function() {
        return row.sectionRowIndex;
    };
}
function $e090f42f468fa271$export$57ba6370ea0e47f8(row) {
    return function() {
        return row.cells;
    };
}
function $e090f42f468fa271$export$96a7dd0d30a5e7fe(index) {
    return function(row) {
        return function() {
            return row.insertCell(index);
        };
    };
}
function $e090f42f468fa271$export$6e37d353cc5629c9(index) {
    return function(row) {
        return function() {
            row.deleteCell(index);
        };
    };
}




var $633aaa19d7d1d3a1$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$27b66c5ce67ee025 = $e090f42f468fa271$export$96a7dd0d30a5e7fe;
var $633aaa19d7d1d3a1$export$51965e0a3b80eb5c = /* #__PURE__ */ function() {
    return $633aaa19d7d1d3a1$export$27b66c5ce67ee025(-1);
}();
var $633aaa19d7d1d3a1$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");


// Generated by purs version 0.15.15
function $dba0680894fb8dd0$export$2dd197b55cf13440(section) {
    return function() {
        return section.rows;
    };
}
function $dba0680894fb8dd0$export$281b3c86eeab738f(index) {
    return function(section) {
        return function() {
            return section.insertRow(index);
        };
    };
}
function $dba0680894fb8dd0$export$2ef39e5ffdaff9ed(index) {
    return function(section) {
        return function() {
            section.deleteRow(index);
        };
    };
}




var $53881fd03908fa53$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$6f91cb21ef21b608 = $dba0680894fb8dd0$export$281b3c86eeab738f;
var $53881fd03908fa53$export$5a4e94bbc04b5f2 = /* #__PURE__ */ function() {
    return $53881fd03908fa53$export$6f91cb21ef21b608(-1);
}();
var $53881fd03908fa53$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");


// Generated by purs version 0.15.15
function $1b3a563b18f6151d$export$a7db06668cad9adb(template) {
    return function() {
        return template.content;
    };
}




var $fee13735939d9bee$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");


// Generated by purs version 0.15.15
function $28c3e08a1c48c9af$export$485ded5f26ebe08d(textarea) {
    return function() {
        return textarea.autocomplete;
    };
}
function $28c3e08a1c48c9af$export$5fb7c729919301a5(autocomplete) {
    return function(textarea) {
        return function() {
            textarea.autocomplete = autocomplete;
        };
    };
}
function $28c3e08a1c48c9af$export$4c47992fc278c9a0(textarea) {
    return function() {
        return textarea.autofocus;
    };
}
function $28c3e08a1c48c9af$export$db2bbdcbda3d335e(autofocus) {
    return function(textarea) {
        return function() {
            textarea.autofocus = autofocus;
        };
    };
}
function $28c3e08a1c48c9af$export$1eebcb1e706ab348(textarea) {
    return function() {
        return textarea.cols;
    };
}
function $28c3e08a1c48c9af$export$3df203352cd8517(cols) {
    return function(textarea) {
        return function() {
            textarea.cols = cols;
        };
    };
}
function $28c3e08a1c48c9af$export$9ebb36ddc946da55(textarea) {
    return function() {
        return textarea.dirName;
    };
}
function $28c3e08a1c48c9af$export$e2460e55089b163d(dirName) {
    return function(textarea) {
        return function() {
            textarea.dirName = dirName;
        };
    };
}
function $28c3e08a1c48c9af$export$683472f6198a076e(textarea) {
    return function() {
        return textarea.disabled;
    };
}
function $28c3e08a1c48c9af$export$4532d31cef66d703(disabled) {
    return function(textarea) {
        return function() {
            textarea.disabled = disabled;
        };
    };
}
function $28c3e08a1c48c9af$export$242c63e9758836c2(textarea) {
    return function() {
        return textarea.form;
    };
}
function $28c3e08a1c48c9af$export$c9f461152c658a8b(textarea) {
    return function() {
        return textarea.maxLength;
    };
}
function $28c3e08a1c48c9af$export$45077a575ddd961f(maxLength) {
    return function(textarea) {
        return function() {
            textarea.maxLength = maxLength;
        };
    };
}
function $28c3e08a1c48c9af$export$8fe860a115a1e636(textarea) {
    return function() {
        return textarea.minLength;
    };
}
function $28c3e08a1c48c9af$export$2b867239766ba1e3(minLength) {
    return function(textarea) {
        return function() {
            textarea.minLength = minLength;
        };
    };
}
function $28c3e08a1c48c9af$export$a8ff84c12d48cfa6(textarea) {
    return function() {
        return textarea.name;
    };
}
function $28c3e08a1c48c9af$export$6cf3d710d3a367e5(name) {
    return function(textarea) {
        return function() {
            textarea.name = name;
        };
    };
}
function $28c3e08a1c48c9af$export$c7187bbd1a7a9244(textarea) {
    return function() {
        return textarea.placeholder;
    };
}
function $28c3e08a1c48c9af$export$645bf5697adfa088(placeholder) {
    return function(textarea) {
        return function() {
            textarea.placeholder = placeholder;
        };
    };
}
function $28c3e08a1c48c9af$export$b2cbc93d4da94977(textarea) {
    return function() {
        return textarea.readOnly;
    };
}
function $28c3e08a1c48c9af$export$62311ce54ddfc862(readOnly) {
    return function(textarea) {
        return function() {
            textarea.readOnly = readOnly;
        };
    };
}
function $28c3e08a1c48c9af$export$a7a0278c004aac3f(textarea) {
    return function() {
        return textarea.required;
    };
}
function $28c3e08a1c48c9af$export$47f9362469f346c4(required) {
    return function(textarea) {
        return function() {
            textarea.required = required;
        };
    };
}
function $28c3e08a1c48c9af$export$2dd197b55cf13440(textarea) {
    return function() {
        return textarea.rows;
    };
}
function $28c3e08a1c48c9af$export$f2d998961118057a(rows) {
    return function(textarea) {
        return function() {
            textarea.rows = rows;
        };
    };
}
function $28c3e08a1c48c9af$export$4997ffc0176396a6(textarea) {
    return function() {
        return textarea.wrap;
    };
}
function $28c3e08a1c48c9af$export$696447b714acda6d(wrap) {
    return function(textarea) {
        return function() {
            textarea.wrap = wrap;
        };
    };
}
function $28c3e08a1c48c9af$export$d4a6a4db5b31e621(textarea) {
    return function() {
        return textarea.type;
    };
}
function $28c3e08a1c48c9af$export$1a01ae0705bafd37(textarea) {
    return function() {
        return textarea.defaultValue;
    };
}
function $28c3e08a1c48c9af$export$d8becbd7468e206f(defaultValue) {
    return function(textarea) {
        return function() {
            textarea.defaultValue = defaultValue;
        };
    };
}
function $28c3e08a1c48c9af$export$2ab9a8f9f1186f14(textarea) {
    return function() {
        return textarea.value;
    };
}
function $28c3e08a1c48c9af$export$80746c6bc6142fc8(value) {
    return function(textarea) {
        return function() {
            textarea.value = value;
        };
    };
}
function $28c3e08a1c48c9af$export$6f846043e306f02c(textarea) {
    return function() {
        return textarea.textLength;
    };
}
function $28c3e08a1c48c9af$export$5e55a9e709e8e020(textarea) {
    return function() {
        return textarea.willValidate;
    };
}
function $28c3e08a1c48c9af$export$1bdd3f9a89b22594(textarea) {
    return function() {
        return textarea.validity;
    };
}
function $28c3e08a1c48c9af$export$6ee4201e37a931e2(textarea) {
    return function() {
        return textarea.validationMessage;
    };
}
function $28c3e08a1c48c9af$export$50d70f8cedc54453(textarea) {
    return function() {
        return textarea.checkValidity();
    };
}
function $28c3e08a1c48c9af$export$b962d864c477cc49(textarea) {
    return function() {
        return textarea.reportValidity();
    };
}
function $28c3e08a1c48c9af$export$6f569cb704992105(value) {
    return function(textarea) {
        return function() {
            textarea.setCustomValidity(value);
        };
    };
}
function $28c3e08a1c48c9af$export$a238cb463698c900(textarea) {
    return function() {
        return textarea.labels;
    };
}
function $28c3e08a1c48c9af$export$2e6c959c16ff56b8(textarea) {
    return function() {
        textarea.select();
    };
}
function $28c3e08a1c48c9af$export$5e2f617ae845fb63(textarea) {
    return function() {
        return textarea.selectionStart;
    };
}
function $28c3e08a1c48c9af$export$47b9c21811f199bd(selectionStart) {
    return function(textarea) {
        return function() {
            textarea.selectionStart = selectionStart;
        };
    };
}
function $28c3e08a1c48c9af$export$1028be563f1155b2(textarea) {
    return function() {
        return textarea.selectionEnd;
    };
}
function $28c3e08a1c48c9af$export$15d012c6be3c352(selectionEnd) {
    return function(textarea) {
        return function() {
            textarea.selectionEnd = selectionEnd;
        };
    };
}
function $28c3e08a1c48c9af$export$b4e8aad052258154(textarea) {
    return function() {
        return textarea.selectionDirection;
    };
}
function $28c3e08a1c48c9af$export$6ac306cb2c51a4e6(selectionDirection) {
    return function(textarea) {
        return function() {
            textarea.selectionDirection = selectionDirection;
        };
    };
}
function $28c3e08a1c48c9af$export$2add2a46d1c1d557(replacement) {
    return function(textarea) {
        return function() {
            textarea.setRangeText(replacement);
        };
    };
}
function $28c3e08a1c48c9af$export$309b5632e9b49193(replacement, start, end, selectionMode, textarea) {
    textarea.setRangeText(replacement, start, end, selectionMode);
}
function $28c3e08a1c48c9af$export$3b045ac5f470d884(start) {
    return function(end) {
        return function(direction) {
            return function(textarea) {
                return function() {
                    textarea.setSelectionRange(start, end, direction);
                };
            };
        };
    };
}








var $514f398dc6a7828b$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$873e7fe8f20f100c = function(rpl) {
    return function(s) {
        return function(e) {
            return function(mode) {
                return function(area) {
                    return function() {
                        return $28c3e08a1c48c9af$export$309b5632e9b49193(rpl, s, e, $c09a3e7cfbb6a57f$export$c2d084dc44961371(mode), area);
                    };
                };
            };
        };
    };
};
var $514f398dc6a7828b$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($28c3e08a1c48c9af$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $68df52b2f5f30ba7$export$3a17bddce263fba0(time) {
    return function() {
        return time.dateTime;
    };
}
function $68df52b2f5f30ba7$export$3a84b9eda98e95dc(dateTime) {
    return function(time) {
        return function() {
            time.dateTime = dateTime;
        };
    };
}




var $f1291cf94838d52b$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");


// Generated by purs version 0.15.15
function $a7993cc78206c04b$export$6f093cfa640b7166(title) {
    return function() {
        return title.text;
    };
}
function $a7993cc78206c04b$export$cbe0d99836e1498f(text) {
    return function(title) {
        return function() {
            title.text = text;
        };
    };
}




var $71325cd3e1c1cf85$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");


// Generated by purs version 0.15.15
function $2f0649a862aa117b$export$78062f36b16ed2f8(track) {
    return function() {
        return track.kind;
    };
}
function $2f0649a862aa117b$export$8f76af250dd43cf6(kind) {
    return function(track) {
        return function() {
            track.kind = kind;
        };
    };
}
function $2f0649a862aa117b$export$2e40c9e35e9506f4(track) {
    return function() {
        return track.src;
    };
}
function $2f0649a862aa117b$export$5771e3a4c80da7df(src) {
    return function(track) {
        return function() {
            track.src = src;
        };
    };
}
function $2f0649a862aa117b$export$4be5a609db5ad788(track) {
    return function() {
        return track.srclang;
    };
}
function $2f0649a862aa117b$export$5406412834bff708(srclang) {
    return function(track) {
        return function() {
            track.srclang = srclang;
        };
    };
}
function $2f0649a862aa117b$export$1237798dc640739a(track) {
    return function() {
        return track.label;
    };
}
function $2f0649a862aa117b$export$4f65e594f6031297(label) {
    return function(track) {
        return function() {
            track.label = label;
        };
    };
}
// ----------------------------------------------------------------------------
const $2f0649a862aa117b$export$2e2bcd8739ae039 = function(track) {
    return function() {
        return track["default"];
    };
};
function $2f0649a862aa117b$export$d590af038dd015bd(def) {
    return function(track) {
        return function() {
            track["default"] = def;
        };
    };
}
function $2f0649a862aa117b$export$4bf8a366db6a678b(track) {
    return track.readyState;
}







// Generated by purs version 0.15.15



var $436d616104359630$export$57ca7e07b341709d = /* #__PURE__ */ function() {
    function None() {}
    None.value = new None();
    return None;
}();
var $436d616104359630$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $436d616104359630$export$b6517d5bdd20170e = /* #__PURE__ */ function() {
    function Loaded() {}
    Loaded.value = new Loaded();
    return Loaded;
}();
var $436d616104359630$export$edf27be85e5f6da0 = /* #__PURE__ */ function() {
    function $$Error() {}
    $$Error.value = new $$Error();
    return $$Error;
}();
var $436d616104359630$export$dc807b9f83d61e2e = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$57ca7e07b341709d.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$669f6ea7d267feaf.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$b6517d5bdd20170e.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$edf27be85e5f6da0.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $436d616104359630$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $436d616104359630$export$57ca7e07b341709d) return "None";
        if (v instanceof $436d616104359630$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $436d616104359630$export$b6517d5bdd20170e) return "Loaded";
        if (v instanceof $436d616104359630$export$edf27be85e5f6da0) return "Error";
        throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 30, column 1 - line 34, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $436d616104359630$export$9974ae2c28acb3c9 = function(v) {
    if (v instanceof $436d616104359630$export$57ca7e07b341709d) return 0;
    if (v instanceof $436d616104359630$export$669f6ea7d267feaf) return 1;
    if (v instanceof $436d616104359630$export$b6517d5bdd20170e) return 2;
    if (v instanceof $436d616104359630$export$edf27be85e5f6da0) return 3;
    throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 47, column 3 - line 51, column 15): " + [
        v.constructor.name
    ]);
};
var $436d616104359630$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $436d616104359630$export$57ca7e07b341709d && y instanceof $436d616104359630$export$57ca7e07b341709d) return true;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf && y instanceof $436d616104359630$export$669f6ea7d267feaf) return true;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e && y instanceof $436d616104359630$export$b6517d5bdd20170e) return true;
            if (x instanceof $436d616104359630$export$edf27be85e5f6da0 && y instanceof $436d616104359630$export$edf27be85e5f6da0) return true;
            return false;
        };
    }
};
var $436d616104359630$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $436d616104359630$export$57ca7e07b341709d && y instanceof $436d616104359630$export$57ca7e07b341709d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $436d616104359630$export$57ca7e07b341709d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $436d616104359630$export$57ca7e07b341709d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf && y instanceof $436d616104359630$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $436d616104359630$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e && y instanceof $436d616104359630$export$b6517d5bdd20170e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $436d616104359630$export$b6517d5bdd20170e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $436d616104359630$export$edf27be85e5f6da0 && y instanceof $436d616104359630$export$edf27be85e5f6da0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $436d616104359630$export$c71e02dcc13f94a6;
    }
};
var $436d616104359630$export$f705a14e9e99c6f0 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($436d616104359630$export$dc807b9f83d61e2e)($436d616104359630$export$9974ae2c28acb3c9),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($436d616104359630$export$dc807b9f83d61e2e)($436d616104359630$export$9974ae2c28acb3c9),
    Ord0: function() {
        return $436d616104359630$export$6557947d538c3b81;
    }
};
var $436d616104359630$export$7b40514a91e8387e = /* #__PURE__ */ function() {
    return {
        bottom: $436d616104359630$export$57ca7e07b341709d.value,
        top: $436d616104359630$export$edf27be85e5f6da0.value,
        Ord0: function() {
            return $436d616104359630$export$6557947d538c3b81;
        }
    };
}();
var $436d616104359630$export$94a641e970e969f9 = {
    cardinality: 4,
    toEnum: $436d616104359630$export$dc807b9f83d61e2e,
    fromEnum: $436d616104359630$export$9974ae2c28acb3c9,
    Bounded0: function() {
        return $436d616104359630$export$7b40514a91e8387e;
    },
    Enum1: function() {
        return $436d616104359630$export$f705a14e9e99c6f0;
    }
};



var $057c37bcb2e4f7d0$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $057c37bcb2e4f7d0$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($436d616104359630$export$94a641e970e969f9);
var $057c37bcb2e4f7d0$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$1ae2b664eea77b7e = function(el) {
    return $057c37bcb2e4f7d0$var$map(function() {
        var $3 = $06733ae99ed4f534$export$43db023a260c5e9f($436d616104359630$export$57ca7e07b341709d.value);
        return function($4) {
            return $3($057c37bcb2e4f7d0$var$toEnum($4));
        };
    }())(function() {
        return $2f0649a862aa117b$export$4bf8a366db6a678b(el);
    });
};
var $057c37bcb2e4f7d0$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");


// Generated by purs version 0.15.15


var $de5b01932d221096$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");


// Generated by purs version 0.15.15
// ----------------------------------------------------------------------------
function $61cfdbf50fc824d4$export$7e3df82ee760448c(video) {
    return function() {
        return video.width;
    };
}
function $61cfdbf50fc824d4$export$67f48e0594af05d(width) {
    return function(video) {
        return function() {
            video.width = width;
        };
    };
}
function $61cfdbf50fc824d4$export$ac607276a8fe9f0a(video) {
    return function() {
        return video.height;
    };
}
function $61cfdbf50fc824d4$export$3f31360357be44e4(height) {
    return function(video) {
        return function() {
            video.height = height;
        };
    };
}
function $61cfdbf50fc824d4$export$dbb4894ced044525(video) {
    return function() {
        return video.videoWidth;
    };
}
function $61cfdbf50fc824d4$export$848581bdb4a7943d(video) {
    return function() {
        return video.videoHeight;
    };
}
function $61cfdbf50fc824d4$export$b840e55573b2d2e7(video) {
    return function() {
        return video.poster;
    };
}
function $61cfdbf50fc824d4$export$2c8117e8f5cb8138(poster) {
    return function(video) {
        return function() {
            video.poster = poster;
        };
    };
}




var $7732702ec87f6f21$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$fd26055f9731f4b9 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$cdb626e247ef0ce5 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");


// Generated by purs version 0.15.15
function $75f6ec27f640501f$export$7c341cb16fc91138(history) {
    return function() {
        return history.back();
    };
}
function $75f6ec27f640501f$export$174bb771924e7eb1(history) {
    return function() {
        return history.forward();
    };
}
function $75f6ec27f640501f$export$93bb224d05b3906d(delta) {
    return function(history) {
        return function() {
            return history.go(delta);
        };
    };
}
function $75f6ec27f640501f$export$ba0fd82af7b4fe6e(a) {
    return function(docTitle) {
        return function(url) {
            return function(history) {
                return function() {
                    return history.pushState(a, docTitle, url);
                };
            };
        };
    };
}
function $75f6ec27f640501f$export$e68dd4d2e7e08394(a) {
    return function(docTitle) {
        return function(url) {
            return function(history) {
                return function() {
                    return history.replaceState(a, docTitle, url);
                };
            };
        };
    };
}
function $75f6ec27f640501f$export$ca000e230c0caa3e(history) {
    return function() {
        return history.state;
    };
}



var $c4fd6deeadc2e277$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c4fd6deeadc2e277$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $c4fd6deeadc2e277$export$61abde59b50deb8e = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$dd5ad0b65cf665da = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$1f333647865369bf = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$e587774857b65d31 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$2cdd79be0aa3bb07 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$3c3105bc6097b846 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$214a01057915d716 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$dbc0939544a3624 = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$214a01057915d716;
    }
};
var $c4fd6deeadc2e277$export$28be1498e824b653 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$7c3d39f0cf320c7b = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$28be1498e824b653;
    }
};
var $c4fd6deeadc2e277$export$3e1b8005eb6f3d68 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$4ef0c953a661f864 = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare1(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$3e1b8005eb6f3d68;
    }
};


// Generated by purs version 0.15.15
function $f8ebc5adafdca7e8$export$d6af199866bfb566(location) {
    return function() {
        return location.hash;
    };
}
function $f8ebc5adafdca7e8$export$42c3f3255a992e7(hash) {
    return function(location) {
        return function() {
            location.hash = hash;
        };
    };
}
function $f8ebc5adafdca7e8$export$5e032988b71f6158(location) {
    return function() {
        return location.host;
    };
}
function $f8ebc5adafdca7e8$export$db0724f89fd14c87(host) {
    return function(location) {
        return function() {
            location.host = host;
        };
    };
}
function $f8ebc5adafdca7e8$export$640106f6dc7d2706(location) {
    return function() {
        return location.hostname;
    };
}
function $f8ebc5adafdca7e8$export$d120c0a46ba2e633(hostname) {
    return function(location) {
        return function() {
            location.hostname = hostname;
        };
    };
}
function $f8ebc5adafdca7e8$export$8f51af5840e0602a(location) {
    return function() {
        return location.href;
    };
}
function $f8ebc5adafdca7e8$export$428f6e77b5a5a669(href) {
    return function(location) {
        return function() {
            location.href = href;
        };
    };
}
function $f8ebc5adafdca7e8$export$f710a83a91838a36(location) {
    return function() {
        return location.origin;
    };
}
function $f8ebc5adafdca7e8$export$717aaa4b4fe61ebd(origin) {
    return function(location) {
        return function() {
            location.origin = origin;
        };
    };
}
function $f8ebc5adafdca7e8$export$7333db99aa99d383(location) {
    return function() {
        return location.pathname;
    };
}
function $f8ebc5adafdca7e8$export$8c7da94d5c72705a(pathname) {
    return function(location) {
        return function() {
            location.pathname = pathname;
        };
    };
}
function $f8ebc5adafdca7e8$export$2433da7bd3cc7af7(location) {
    return function() {
        return location.port;
    };
}
function $f8ebc5adafdca7e8$export$b0effcd3879eb064(port) {
    return function(location) {
        return function() {
            location.port = port;
        };
    };
}
function $f8ebc5adafdca7e8$export$a51d6b395ff4c65a(location) {
    return function() {
        return location.protocol;
    };
}
function $f8ebc5adafdca7e8$export$caabdac475e4f216(protocol) {
    return function(location) {
        return function() {
            location.protocol = protocol;
        };
    };
}
function $f8ebc5adafdca7e8$export$d76128d007d19019(location) {
    return function() {
        return location.search;
    };
}
function $f8ebc5adafdca7e8$export$f96d8961b67fb6df(search) {
    return function(location) {
        return function() {
            location.search = search;
        };
    };
}
function $f8ebc5adafdca7e8$export$e6e34fd1f2686227(url) {
    return function(location) {
        return function() {
            location.assign(url);
        };
    };
}
function $f8ebc5adafdca7e8$export$77ad94ebf1c2b9ed(url) {
    return function(location) {
        return function() {
            location.replace(url);
        };
    };
}
function $f8ebc5adafdca7e8$export$32da5b5043dcd88c(location) {
    return function() {
        location.reload();
    };
}




// Generated by purs version 0.15.15
function $a62c4ef37c9a21b6$export$789c912f57fe164c(navigator) {
    return function() {
        return navigator.language;
    };
}
function $a62c4ef37c9a21b6$export$d0d68bb9ed2c643d(navigator) {
    return function() {
        return navigator.languages;
    };
}
function $a62c4ef37c9a21b6$export$c65ce66152f1cb9d(navigator) {
    return function() {
        return navigator.onLine;
    };
}
function $a62c4ef37c9a21b6$export$722a64dea1b767dc(navigator) {
    return function() {
        return navigator.platform;
    };
}
function $a62c4ef37c9a21b6$export$3dcce53a3755dc8c(navigator) {
    return function() {
        return navigator.userAgent;
    };
}




// Generated by purs version 0.15.15
function $aa35a24624ec08d2$export$5a7bfc01df82fcd1(window) {
    return function() {
        return window.document;
    };
}
function $aa35a24624ec08d2$export$ec7c8efa7f5790ae(window) {
    return function() {
        return window.navigator;
    };
}
function $aa35a24624ec08d2$export$17b07c660794dc13(window) {
    return function() {
        return window.location;
    };
}
function $aa35a24624ec08d2$export$55abd4691b317664(window) {
    return function() {
        return window.history;
    };
}
function $aa35a24624ec08d2$export$d23fbaf1a2e7133c(window) {
    return function() {
        return window.innerWidth;
    };
}
function $aa35a24624ec08d2$export$d3ad305c42af1069(window) {
    return function() {
        return window.innerHeight;
    };
}
function $aa35a24624ec08d2$export$5ea928c9faf85bd3(str) {
    return function(window) {
        return function() {
            window.alert(str);
        };
    };
}
function $aa35a24624ec08d2$export$715f9d76bb8c1fea(str) {
    return function(window) {
        return function() {
            return window.confirm(str);
        };
    };
}
function $aa35a24624ec08d2$export$7290db243fe4f181(xDelta) {
    return function(yDelta) {
        return function(window) {
            return function() {
                window.moveBy(xDelta, yDelta);
            };
        };
    };
}
function $aa35a24624ec08d2$export$75f1ccd6dc32e80a(width) {
    return function(height) {
        return function(window) {
            return function() {
                window.moveTo(width, height);
            };
        };
    };
}
function $aa35a24624ec08d2$export$f4b9acba9659afe8(url) {
    return function(name) {
        return function(features) {
            return function(window) {
                return function() {
                    return window.open(url, name, features);
                };
            };
        };
    };
}
function $aa35a24624ec08d2$export$8360e631d277ea4d(window) {
    return function() {
        return window.close();
    };
}
function $aa35a24624ec08d2$export$fc5b8aac72846d1e(window) {
    return function() {
        return window.outerHeight;
    };
}
function $aa35a24624ec08d2$export$e823f88e4111159a(window) {
    return function() {
        return window.outerWidth;
    };
}
function $aa35a24624ec08d2$export$c2d084dc44961371(window) {
    return function() {
        window.print();
    };
}
function $aa35a24624ec08d2$export$ce783d49a08713a7(str) {
    return function(defaultText) {
        return function(window) {
            return function() {
                return window.prompt(str, defaultText);
            };
        };
    };
}
function $aa35a24624ec08d2$export$5f72b7db69802ea0(xDelta) {
    return function(yDelta) {
        return function(window) {
            return function() {
                window.resizeBy(xDelta, yDelta);
            };
        };
    };
}
function $aa35a24624ec08d2$export$663d9c149a16f84d(width) {
    return function(height) {
        return function(window) {
            return function() {
                window.resizeTo(width, height);
            };
        };
    };
}
function $aa35a24624ec08d2$export$daeacaab2dbcebdc(window) {
    return function() {
        return window.screenX;
    };
}
function $aa35a24624ec08d2$export$51b695a8750464db(window) {
    return function() {
        return window.screenY;
    };
}
function $aa35a24624ec08d2$export$209876d7b1ac8f3(xCoord) {
    return function(yCoord) {
        return function(window) {
            return function() {
                window.scroll(xCoord, yCoord);
            };
        };
    };
}
function $aa35a24624ec08d2$export$19a39865fecdb343(xCoord) {
    return function(yCoord) {
        return function(window) {
            return function() {
                window.scrollBy(xCoord, yCoord);
            };
        };
    };
}
function $aa35a24624ec08d2$export$5320ec237fcf13b2(window) {
    return function() {
        return window.scrollX;
    };
}
function $aa35a24624ec08d2$export$2dd824eca41ca48d(window) {
    return function() {
        return window.scrollY;
    };
}
function $aa35a24624ec08d2$export$c2ed3351cac403d1(window) {
    return function() {
        return window.localStorage;
    };
}
function $aa35a24624ec08d2$export$f119d83aa936d634(window) {
    return function() {
        return window.sessionStorage;
    };
}
function $aa35a24624ec08d2$export$6cb2c4c0a22909c0(fn) {
    return function(window) {
        return function() {
            return window.requestAnimationFrame(fn);
        };
    };
}
function $aa35a24624ec08d2$export$e00521de187a817a(id) {
    return function(window) {
        return function() {
            return window.cancelAnimationFrame(id);
        };
    };
}
function $aa35a24624ec08d2$export$9288a5d956b3efbe(opts) {
    return function(fn) {
        return function(window) {
            return function() {
                return window.requestIdleCallback(fn, opts);
            };
        };
    };
}
function $aa35a24624ec08d2$export$bf0a62c3939e5933(id) {
    return function(window) {
        return function() {
            return window.cancelIdleCallback(id);
        };
    };
}
function $aa35a24624ec08d2$export$91124bb58bc04465(window) {
    return function() {
        return window.parent;
    };
}
function $aa35a24624ec08d2$export$b161e74f44e020b9(window) {
    return function() {
        return window.opener;
    };
}








var $6b26c9b0fa2d7b7a$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $6b26c9b0fa2d7b7a$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $6b26c9b0fa2d7b7a$var$RequestIdleCallbackId = function(x) {
    return x;
};
var $6b26c9b0fa2d7b7a$var$RequestAnimationFrameId = function(x) {
    return x;
};
var $6b26c9b0fa2d7b7a$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $6b26c9b0fa2d7b7a$export$20682ad686515a40 = function(msg) {
    return function(defaultText) {
        return function(window) {
            return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$ce783d49a08713a7(msg)(defaultText)(window));
        };
    };
};
var $6b26c9b0fa2d7b7a$export$195ba6d62321b933 = function(msg) {
    return function(window) {
        return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$ce783d49a08713a7(msg)("")(window));
    };
};
var $6b26c9b0fa2d7b7a$export$1828d3c48a8aa004 = function(window) {
    return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$b161e74f44e020b9(window));
};
var $6b26c9b0fa2d7b7a$export$3ce6949f20cea765 = function(url$prime) {
    return function(name) {
        return function(features) {
            return function(window) {
                return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$f4b9acba9659afe8(url$prime)(name)(features)(window));
            };
        };
    };
};
var $6b26c9b0fa2d7b7a$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Window");
var $6b26c9b0fa2d7b7a$export$5e61711963baf8b7 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $6b26c9b0fa2d7b7a$export$2a5c622a4a2ca36d = {
    compare: function(x) {
        return function(y) {
            return $6b26c9b0fa2d7b7a$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $6b26c9b0fa2d7b7a$export$5e61711963baf8b7;
    }
};
var $6b26c9b0fa2d7b7a$export$c27c49a6c01c4337 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $6b26c9b0fa2d7b7a$export$5ec63fa26beb11f3 = {
    compare: function(x) {
        return function(y) {
            return $6b26c9b0fa2d7b7a$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $6b26c9b0fa2d7b7a$export$c27c49a6c01c4337;
    }
};




// Generated by purs version 0.15.15
var $98632a8bc67f7e8c$export$117f7ddab482d006 = "unload";
var $98632a8bc67f7e8c$export$e03c1c3201ee8bb7 = "toggle";
var $98632a8bc67f7e8c$export$853c27de4ce0f746 = "submit";
var $98632a8bc67f7e8c$export$ddcffe0146c8f882 = "storage";
var $98632a8bc67f7e8c$export$2e6c959c16ff56b8 = "select";
var $98632a8bc67f7e8c$export$aad8462122ac592b = "reset";
var $98632a8bc67f7e8c$export$1427eba79b2ae340 = "readystatechange";
var $98632a8bc67f7e8c$export$504d7abb21fa8c9 = "progress";
var $98632a8bc67f7e8c$export$9b6706c8686cfc8e = "paste";
var $98632a8bc67f7e8c$export$6dd222fd9e8d7968 = "online";
var $98632a8bc67f7e8c$export$3b16d2a27b22a87a = "offline";
var $98632a8bc67f7e8c$export$a8ecead220dd38a6 = "message";
var $98632a8bc67f7e8c$export$dca0cefb631ec861 = "loadstart";
var $98632a8bc67f7e8c$export$ddc39cda6f909ee1 = "loadend";
var $98632a8bc67f7e8c$export$11e63f7b0f3d9900 = "load";
var $98632a8bc67f7e8c$export$8d5b9ac6cde54772 = "languagechange";
var $98632a8bc67f7e8c$export$9f85add0327f687e = "invalid";
var $98632a8bc67f7e8c$export$b7e3ae3d7c15e42e = "input";
var $98632a8bc67f7e8c$export$d7ddd398f22d79ef = "focus";
var $98632a8bc67f7e8c$export$a3bc9b8ed74fc = "error";
var $98632a8bc67f7e8c$export$ead50553077ff635 = "DOMContentLoaded";
var $98632a8bc67f7e8c$export$af2a99f971a346e6 = "cut";
var $98632a8bc67f7e8c$export$784d13d8ee351f07 = "copy";
var $98632a8bc67f7e8c$export$8360e631d277ea4d = "close";
var $98632a8bc67f7e8c$export$64ef1bee2b9504c1 = "click";
var $98632a8bc67f7e8c$export$d8a7b8f475ec0161 = "change";
var $98632a8bc67f7e8c$export$70b61ad426ddbe54 = "cancel";
var $98632a8bc67f7e8c$export$2cc7ff91bcacba5e = "blur";
var $98632a8bc67f7e8c$export$26ecb34e09d46df7 = "beforescriptexecute";
var $98632a8bc67f7e8c$export$ad2ab82a6fc787c7 = "beforeprint";
var $98632a8bc67f7e8c$export$7af6a91a06bd66bd = "afterscriptexecute";
var $98632a8bc67f7e8c$export$56890049c3283011 = "afterprint";
var $98632a8bc67f7e8c$export$5def58af4fd46132 = "abort";






var $deee5b6018c98796$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $deee5b6018c98796$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $deee5b6018c98796$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $deee5b6018c98796$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $deee5b6018c98796$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $deee5b6018c98796$var$bindFlipped1 = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $deee5b6018c98796$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $deee5b6018c98796$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $deee5b6018c98796$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $deee5b6018c98796$var$throwError = /* #__PURE__ */ $5dfefa023749ded0$export$8bf7aba4a9e09055($edf0339512807bee$export$37a9b80154c7d256);
var $deee5b6018c98796$export$895e5c0dd54cd456 = function(query) {
    return $deee5b6018c98796$var$bind($deee5b6018c98796$var$liftEffect($deee5b6018c98796$var$bindFlipped($deee5b6018c98796$var$composeKleisliFlipped(function() {
        var $16 = $77e12228cc269e35$export$78fb49a702cc1f2(query);
        return function($17) {
            return $16($f6c9290a5db8f197$export$c8b651b897da2de($17));
        };
    }())($aa35a24624ec08d2$export$5a7bfc01df82fcd1))($2603425f82e959df$export$8291e5b88f90ce4)))(function(mel) {
        return $deee5b6018c98796$var$pure($deee5b6018c98796$var$bindFlipped1($5ae75883a0b7923c$export$c56654a6d0e3bd48)(mel));
    });
};
var $deee5b6018c98796$export$1b79e4d7fc8e4817 = /* #__PURE__ */ $edf0339512807bee$export$ef62257e6f8a5f8c(/* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded($ad2cf6904bca3ba1$export$de0c4a986b439e52)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(/* #__PURE__ */ $deee5b6018c98796$var$pure1($05149ea687d6b460$export$523c0b569236b342))));
var $deee5b6018c98796$export$11dc33decdfc25c9 = /* #__PURE__ */ $b28443a27438717a$export$49d5975414e0a979(function(callback) {
    return function __do() {
        var rs = $deee5b6018c98796$var$bindFlipped($f6c9290a5db8f197$export$1ae2b664eea77b7e)($deee5b6018c98796$var$bindFlipped($aa35a24624ec08d2$export$5a7bfc01df82fcd1)($2603425f82e959df$export$8291e5b88f90ce4))();
        if (rs instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) {
            var et = $deee5b6018c98796$var$map($6b26c9b0fa2d7b7a$export$55c9526d22b9f8e6)($2603425f82e959df$export$8291e5b88f90ce4)();
            var listener = $98db70b23aa8a6ea$export$f5cdf3809b4587f3(function(v) {
                return callback(new $7d4cccdf062a2261$export$19db0165690c701a($05149ea687d6b460$export$523c0b569236b342));
            })();
            $98db70b23aa8a6ea$export$3f65cefe8380dbea($98632a8bc67f7e8c$export$ead50553077ff635)(listener)(false)(et)();
            return $edf0339512807bee$export$952106a975f35ae2($98db70b23aa8a6ea$export$8ff9f68337b520c0($98632a8bc67f7e8c$export$ead50553077ff635)(listener)(false)(et));
        }
        callback(new $7d4cccdf062a2261$export$19db0165690c701a($05149ea687d6b460$export$523c0b569236b342))();
        return $edf0339512807bee$export$8deb6e154ce67af6;
    };
});
var $deee5b6018c98796$export$f79c83a36c9670be = /* #__PURE__ */ $deee5b6018c98796$var$discard($edf0339512807bee$export$f885f489dcf38a2d)($deee5b6018c98796$export$11dc33decdfc25c9)(function() {
    return $deee5b6018c98796$var$bind($deee5b6018c98796$export$895e5c0dd54cd456("body"))(function(body) {
        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($deee5b6018c98796$var$throwError($ad2cf6904bca3ba1$export$a3bc9b8ed74fc("Could not find body")))($deee5b6018c98796$var$pure)(body);
    });
});


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15










// Generated by purs version 0.15.15

var $b890a9c9ccf92ae9$export$49a1dce2f81a97d6 = $ac8b3532514ac019$export$401372c57776dc;
var $b890a9c9ccf92ae9$export$7488c940d035302c = $ac8b3532514ac019$export$401372c57776dc;









var $026fde5446dd624a$var$CoyonedaF = /* #__PURE__ */ function() {
    function CoyonedaF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CoyonedaF.create = function(value0) {
        return function(value1) {
            return new CoyonedaF(value0, value1);
        };
    };
    return CoyonedaF;
}();
var $026fde5446dd624a$export$518a6adb5ee0288f = function(x) {
    return x;
};
var $026fde5446dd624a$export$1088317934ed5679 = function(f) {
    return function(v) {
        return $b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
            return f(v1.value0)(v1.value1);
        })(v);
    };
};
var $026fde5446dd624a$export$36cf4525d9d7ca3c = function(dictFunctor) {
    return $026fde5446dd624a$export$1088317934ed5679($f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor));
};
var $026fde5446dd624a$export$e10932df6e0657f1 = function(dictFoldable) {
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return {
        foldr: function(f) {
            return function(z) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldr(function($175) {
                        return f(k($175));
                    })(z);
                });
            };
        },
        foldl: function(f) {
            return function(z) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldl(function(x) {
                        var $176 = f(x);
                        return function($177) {
                            return $176(k($177));
                        };
                    })(z);
                });
            };
        },
        foldMap: function(dictMonoid) {
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldMap1(function($178) {
                        return f(k($178));
                    });
                });
            };
        }
    };
};
var $026fde5446dd624a$export$bd381ac72ce00e4e = function(dictFoldable1) {
    var foldMap1 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    var foldableCoyoneda1 = $026fde5446dd624a$export$e10932df6e0657f1(dictFoldable1.Foldable0());
    return {
        foldMap1: function(dictSemigroup) {
            var foldMap11 = foldMap1(dictSemigroup);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldMap11(function($179) {
                        return f(k($179));
                    });
                });
            };
        },
        foldr1: $086486679aa806fa$export$8af34898c082e678($026fde5446dd624a$export$bd381ac72ce00e4e(dictFoldable1)),
        foldl1: $086486679aa806fa$export$8dd52a2a23ae4dc4($026fde5446dd624a$export$bd381ac72ce00e4e(dictFoldable1)),
        Foldable0: function() {
            return foldableCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$4c17598ac057c221 = function(dictFunctor) {
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictFunctor);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
        return function(dictEq) {
            var eq11 = eq1(dictEq);
            return {
                eq: function(x) {
                    return function(y) {
                        return eq11(lowerCoyoneda1(x))(lowerCoyoneda1(y));
                    };
                }
            };
        };
    };
};
var $026fde5446dd624a$export$e3d23e83f1d891bb = function(dictFunctor) {
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictFunctor);
    var eqCoyoneda1 = $026fde5446dd624a$export$4c17598ac057c221(dictFunctor);
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
        var eqCoyoneda2 = eqCoyoneda1(dictOrd1.Eq10());
        return function(dictOrd) {
            var compare11 = compare1(dictOrd);
            var eqCoyoneda3 = eqCoyoneda2(dictOrd.Eq0());
            return {
                compare: function(x) {
                    return function(y) {
                        return compare11(lowerCoyoneda1(x))(lowerCoyoneda1(y));
                    };
                },
                Eq0: function() {
                    return eqCoyoneda3;
                }
            };
        };
    };
};
var $026fde5446dd624a$export$8fee22dc2f6f5e8 = function(dictFunctor) {
    var eqCoyoneda1 = $026fde5446dd624a$export$4c17598ac057c221(dictFunctor);
    return function(dictEq1) {
        var eqCoyoneda2 = eqCoyoneda1(dictEq1);
        return {
            eq1: function(dictEq) {
                return $37b880af5f4991bd$export$9663ddc1cf085b32(eqCoyoneda2(dictEq));
            }
        };
    };
};
var $026fde5446dd624a$export$72164df904554716 = function(dictFunctor) {
    var ordCoyoneda1 = $026fde5446dd624a$export$e3d23e83f1d891bb(dictFunctor);
    var eq1Coyoneda1 = $026fde5446dd624a$export$8fee22dc2f6f5e8(dictFunctor);
    return function(dictOrd1) {
        var ordCoyoneda2 = ordCoyoneda1(dictOrd1);
        var eq1Coyoneda2 = eq1Coyoneda1(dictOrd1.Eq10());
        return {
            compare1: function(dictOrd) {
                return $97937c29f879e68e$export$398604a469f7de9a(ordCoyoneda2(dictOrd));
            },
            Eq10: function() {
                return eq1Coyoneda2;
            }
        };
    };
};
var $026fde5446dd624a$export$cc61df270d10d232 = function(k) {
    return function(fi) {
        return $b890a9c9ccf92ae9$export$7488c940d035302c(new $026fde5446dd624a$var$CoyonedaF(k, fi));
    };
};
var $026fde5446dd624a$export$bd40aba71422b460 = {
    map: function(f) {
        return function(v) {
            return $b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
                return $026fde5446dd624a$export$cc61df270d10d232(function($180) {
                    return f(v1.value0($180));
                })(v1.value1);
            })(v);
        };
    }
};
var $026fde5446dd624a$export$4b21c9b3969f8a88 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($026fde5446dd624a$export$bd40aba71422b460)
};
var $026fde5446dd624a$export$782bd81bf3515665 = function(nat) {
    return function(v) {
        return $b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
            return $026fde5446dd624a$export$cc61df270d10d232(v1.value0)(nat(v1.value1));
        })(v);
    };
};
var $026fde5446dd624a$export$6320c031d6b6270f = /* #__PURE__ */ $026fde5446dd624a$export$cc61df270d10d232(/* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa));
var $026fde5446dd624a$export$215969f5aee12fc3 = function(dictDistributive) {
    var collect = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictDistributive.Functor0());
    return {
        collect: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(f) {
                var $181 = collect1(function($183) {
                    return lowerCoyoneda1(f($183));
                });
                return function($182) {
                    return $026fde5446dd624a$export$6320c031d6b6270f($181($182));
                };
            };
        },
        distribute: function(dictFunctor) {
            var $184 = collect(dictFunctor)(lowerCoyoneda1);
            return function($185) {
                return $026fde5446dd624a$export$6320c031d6b6270f($184($185));
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$946e5a80c258b6f7 = function(dictExtend) {
    var extend = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return {
        extend: function(f) {
            return function(v) {
                return $b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
                    return $026fde5446dd624a$export$6320c031d6b6270f(extend(function() {
                        var $186 = $026fde5446dd624a$export$cc61df270d10d232(v1.value0);
                        return function($187) {
                            return f($186($187));
                        };
                    }())(v1.value1));
                })(v);
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$1a78c49d463144db = {
    lift: function(dictMonad) {
        return $026fde5446dd624a$export$6320c031d6b6270f;
    }
};
var $026fde5446dd624a$export$d249e493735a3666 = function(dictTraversable) {
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var foldableCoyoneda1 = $026fde5446dd624a$export$e10932df6e0657f1(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    var $188 = map($026fde5446dd624a$export$6320c031d6b6270f);
                    var $189 = traverse1(function($191) {
                        return f(k($191));
                    });
                    return function($190) {
                        return $188($189($190));
                    };
                });
            };
        },
        sequence: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                var $192 = map($026fde5446dd624a$export$6320c031d6b6270f);
                var $193 = traverse1(k);
                return function($194) {
                    return $192($193($194));
                };
            });
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        },
        Foldable1: function() {
            return foldableCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$592beb634cc81a68 = function(dictTraversable1) {
    var traverse1 = $e4fb66202bb8a4f4$export$d2990bb35e0a3e00(dictTraversable1);
    var sequence1 = $e4fb66202bb8a4f4$export$6deffb29affc84c6(dictTraversable1);
    var Traversable1 = dictTraversable1.Traversable1();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Traversable1.Functor0());
    var foldable1Coyoneda1 = $026fde5446dd624a$export$bd381ac72ce00e4e(dictTraversable1.Foldable10());
    var traversableCoyoneda1 = $026fde5446dd624a$export$d249e493735a3666(Traversable1);
    return {
        traverse1: function(dictApply) {
            var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
            var traverse11 = traverse1(dictApply);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    var $195 = map1($026fde5446dd624a$export$6320c031d6b6270f);
                    var $196 = traverse11(function($198) {
                        return f(k($198));
                    });
                    return function($197) {
                        return $195($196($197));
                    };
                });
            };
        },
        sequence1: function(dictApply) {
            var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
            var sequence11 = sequence1(dictApply);
            return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                var $199 = map1($026fde5446dd624a$export$6320c031d6b6270f);
                var $200 = map(k);
                return function($201) {
                    return $199(sequence11($200($201)));
                };
            });
        },
        Foldable10: function() {
            return foldable1Coyoneda1;
        },
        Traversable1: function() {
            return traversableCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$3a5b6268908c7242 = function(dictComonad) {
    var extract = $b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad);
    var extendCoyoneda1 = $026fde5446dd624a$export$946e5a80c258b6f7(dictComonad.Extend0());
    return {
        extract: function(v) {
            return $b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
                return v1.value0(extract(v1.value1));
            })(v);
        },
        Extend0: function() {
            return extendCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$96fda80da8742a6b = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictApply.Functor0());
    return {
        apply: function(f) {
            return function(g) {
                return $026fde5446dd624a$export$6320c031d6b6270f(apply(lowerCoyoneda1(f))(lowerCoyoneda1(g)));
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$ef5b465291a6417e = function(dictBind) {
    var bindFlipped = $70cd3177464e7915$export$f2077a1c19a006d9(dictBind);
    var Apply0 = dictBind.Apply0();
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(Apply0.Functor0());
    var applyCoyoneda1 = $026fde5446dd624a$export$96fda80da8742a6b(Apply0);
    return {
        bind: function(v) {
            return function(f) {
                return $026fde5446dd624a$export$6320c031d6b6270f($b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
                    return bindFlipped(function($202) {
                        return lowerCoyoneda1(f(v1.value0($202)));
                    })(v1.value1);
                })(v));
            };
        },
        Apply0: function() {
            return applyCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$d337c8e043437698 = function(dictApplicative) {
    var applyCoyoneda1 = $026fde5446dd624a$export$96fda80da8742a6b(dictApplicative.Apply0());
    return {
        pure: function() {
            var $203 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
            return function($204) {
                return $026fde5446dd624a$export$6320c031d6b6270f($203($204));
            };
        }(),
        Apply0: function() {
            return applyCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$dfa10a61f5e8217c = function(dictMonad) {
    var applicativeCoyoneda1 = $026fde5446dd624a$export$d337c8e043437698(dictMonad.Applicative0());
    var bindCoyoneda1 = $026fde5446dd624a$export$ef5b465291a6417e(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeCoyoneda1;
        },
        Bind1: function() {
            return bindCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$daa4182a46d81e3 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictAlt.Functor0());
    return {
        alt: function(x) {
            return function(y) {
                return $026fde5446dd624a$export$6320c031d6b6270f(alt(lowerCoyoneda1(x))(lowerCoyoneda1(y)));
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$f434c65db07c2e04 = function(dictPlus) {
    var altCoyoneda1 = $026fde5446dd624a$export$daa4182a46d81e3(dictPlus.Alt0());
    return {
        empty: $026fde5446dd624a$export$6320c031d6b6270f($7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus)),
        Alt0: function() {
            return altCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$15bae6aadce01350 = function(dictAlternative) {
    var applicativeCoyoneda1 = $026fde5446dd624a$export$d337c8e043437698(dictAlternative.Applicative0());
    var plusCoyoneda1 = $026fde5446dd624a$export$f434c65db07c2e04(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeCoyoneda1;
        },
        Plus1: function() {
            return plusCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$e819965db94a810a = function(dictMonadPlus) {
    var monadCoyoneda1 = $026fde5446dd624a$export$dfa10a61f5e8217c(dictMonadPlus.Monad0());
    var alternativeCoyoneda1 = $026fde5446dd624a$export$15bae6aadce01350(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadCoyoneda1;
        },
        Alternative1: function() {
            return alternativeCoyoneda1;
        }
    };
};







// Generated by purs version 0.15.15




// Generated by purs version 0.15.15



var $d6e193625ed1395d$export$f120638069846a46 = function(x) {
    return x;
};
var $d6e193625ed1395d$export$f0a5727b2ca16d5e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Alternate " + (show(v) + ")");
        }
    };
};
var $d6e193625ed1395d$export$74ec47bea0d6428d = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    return {
        append: function(v) {
            return function(v1) {
                return alt(v)(v1);
            };
        }
    };
};
var $d6e193625ed1395d$export$aa34ebff6fae0aee = function(dictPlus) {
    return dictPlus;
};
var $d6e193625ed1395d$export$19a135ecc0f14c10 = function(dictOrd) {
    return dictOrd;
};
var $d6e193625ed1395d$export$48cb8ce12ac615c3 = function(dictOrd1) {
    return dictOrd1;
};
var $d6e193625ed1395d$export$bbb1334b7c1198d0 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d6e193625ed1395d$export$6e373ee97dbd5f68 = function(dictPlus) {
    var semigroupAlternate1 = $d6e193625ed1395d$export$74ec47bea0d6428d(dictPlus.Alt0());
    return {
        mempty: $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus),
        Semigroup0: function() {
            return semigroupAlternate1;
        }
    };
};
var $d6e193625ed1395d$export$748db8accd45ad60 = function(dictMonad) {
    return dictMonad;
};
var $d6e193625ed1395d$export$912ca5da2b71dd9f = function(dictFunctor) {
    return dictFunctor;
};
var $d6e193625ed1395d$export$45877b7cfa857b08 = function(dictExtend) {
    return dictExtend;
};
var $d6e193625ed1395d$export$744ff834b4c5965c = function(dictEq) {
    return dictEq;
};
var $d6e193625ed1395d$export$d92024b57d6b2a3c = function(dictEq1) {
    return dictEq1;
};
var $d6e193625ed1395d$export$eecf6e094270f0ca = function(dictComonad) {
    return dictComonad;
};
var $d6e193625ed1395d$export$d72d6cfff25c7246 = function(dictBounded) {
    return dictBounded;
};
var $d6e193625ed1395d$export$8c4b2dd7bc59a54a = function(dictBind) {
    return dictBind;
};
var $d6e193625ed1395d$export$cddaca6aae5306c4 = function(dictApply) {
    return dictApply;
};
var $d6e193625ed1395d$export$3655a3e6b92e2b2a = function(dictApplicative) {
    return dictApplicative;
};
var $d6e193625ed1395d$export$a428b63860a2744 = function(dictAlternative) {
    return dictAlternative;
};
var $d6e193625ed1395d$export$ca414a3aae651090 = function(dictAlt) {
    return dictAlt;
};






// Generated by purs version 0.15.15


var $f9a2039294f26822$var$OrdBox = /* #__PURE__ */ function() {
    function OrdBox(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    OrdBox.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new OrdBox(value0, value1, value2);
            };
        };
    };
    return OrdBox;
}();
var $f9a2039294f26822$export$6a3ff69c92a20cd2 = function(v) {
    return v.value2;
};
var $f9a2039294f26822$export$c2a88327b4ac50f8 = function(dictOrd) {
    return $f9a2039294f26822$var$OrdBox.create($37b880af5f4991bd$export$9663ddc1cf085b32(dictOrd.Eq0()))($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $f9a2039294f26822$export$1aabb6943cc59794 = {
    eq: function(v) {
        return function(v1) {
            return v.value0(v.value2)(v1.value2);
        };
    }
};
var $f9a2039294f26822$export$a4fa2470ead172bd = {
    compare: function(v) {
        return function(v1) {
            return v.value1(v.value2)(v1.value2);
        };
    },
    Eq0: function() {
        return $f9a2039294f26822$export$1aabb6943cc59794;
    }
};


var $0f3b7f18059106fc$var$un = /* #__PURE__ */ $4fa4836228a192cc$export$a2a39c9747f0e54a();
var $0f3b7f18059106fc$var$ordTuple = /* #__PURE__ */ $71f2e2e9476163f8$export$8f11eb03746a66e2($97937c29f879e68e$export$c5f2758e49b2b86a)($f9a2039294f26822$export$a4fa2470ead172bd);
var $0f3b7f18059106fc$var$foldSubmap = /* #__PURE__ */ $ea3eb84de0acf574$export$3f9a381f67a51fcd($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$pop1 = /* #__PURE__ */ $ea3eb84de0acf574$export$3e41007ebfff0e64($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$lookup1 = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$insert1 = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$SlotStorage = function(x) {
    return x;
};
var $0f3b7f18059106fc$export$bbd679b9fab4c947 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(dictOrd) {
            var foldSubmap1 = $0f3b7f18059106fc$var$foldSubmap($d6e193625ed1395d$export$6e373ee97dbd5f68($ea3eb84de0acf574$export$4c085c510196daa3(dictOrd)));
            return function(sym) {
                return function(v) {
                    var key = reflectSymbol(sym);
                    var go = function(v1) {
                        return function(val) {
                            if (key === v1.value0) return $ea3eb84de0acf574$export$439306a4dcaafbb9($f9a2039294f26822$export$6a3ff69c92a20cd2(v1.value1))(val);
                            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ea3eb84de0acf574$export$6e22c362a0406a2c;
                            throw new Error("Failed pattern match at Halogen.Data.Slot (line 121, column 3 - line 123, column 38): " + [
                                v1.constructor.name,
                                val.constructor.name
                            ]);
                        };
                    };
                    return $0f3b7f18059106fc$var$un($d6e193625ed1395d$export$f120638069846a46)(foldSubmap1($06733ae99ed4f534$export$bebe9059409a0d04.value)($06733ae99ed4f534$export$bebe9059409a0d04.value)(go)(v));
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$3e41007ebfff0e64 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $f9a2039294f26822$export$c2a88327b4ac50f8(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(v) {
                        return $0f3b7f18059106fc$var$pop1(new $71f2e2e9476163f8$export$1908877435b1d5e9(reflectSymbol(sym), mkOrdBox(key)))(v);
                    };
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$dfc7155ac0343b8 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $f9a2039294f26822$export$c2a88327b4ac50f8(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(v) {
                        return $0f3b7f18059106fc$var$lookup1(new $71f2e2e9476163f8$export$1908877435b1d5e9(reflectSymbol(sym), mkOrdBox(key)))(v);
                    };
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$21a5ca8aa77d35ff = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $f9a2039294f26822$export$c2a88327b4ac50f8(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(val) {
                        return function(v) {
                            return $0f3b7f18059106fc$var$insert1(new $71f2e2e9476163f8$export$1908877435b1d5e9(reflectSymbol(sym), mkOrdBox(key)))(val)(v);
                        };
                    };
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$91dbfdfb14db6990 = function(dictApplicative) {
    var traverse_ = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative)($ea3eb84de0acf574$export$4295a0c2ad7aa544);
    return function(v) {
        return function(k) {
            return traverse_(function($54) {
                return k($54);
            })(v);
        };
    };
};
var $0f3b7f18059106fc$export$6e22c362a0406a2c = $ea3eb84de0acf574$export$6e22c362a0406a2c;



// Generated by purs version 0.15.15

// Generated by purs version 0.15.15










var $dc7ffeabd143829e$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $dc7ffeabd143829e$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $dc7ffeabd143829e$var$Pure = /* #__PURE__ */ function() {
    function Pure(value0) {
        this.value0 = value0;
    }
    Pure.create = function(value0) {
        return new Pure(value0);
    };
    return Pure;
}();
var $dc7ffeabd143829e$var$Lift = /* #__PURE__ */ function() {
    function Lift(value0) {
        this.value0 = value0;
    }
    Lift.create = function(value0) {
        return new Lift(value0);
    };
    return Lift;
}();
var $dc7ffeabd143829e$var$Ap = /* #__PURE__ */ function() {
    function Ap(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Ap.create = function(value0) {
        return function(value1) {
            return new Ap(value0, value1);
        };
    };
    return Ap;
}();
var $dc7ffeabd143829e$var$mkAp = function(fba) {
    return function(fb) {
        return new $dc7ffeabd143829e$var$Ap(fba, fb);
    };
};
var $dc7ffeabd143829e$export$9f6cb61afbf051fa = /* #__PURE__ */ function() {
    return $dc7ffeabd143829e$var$Lift.create;
}();
var $dc7ffeabd143829e$var$goLeft = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(fStack) {
        return function(valStack) {
            return function(nat) {
                return function(func) {
                    return function(count) {
                        if (func instanceof $dc7ffeabd143829e$var$Pure) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0({
                            func: pure(func.value0),
                            count: count
                        }, fStack), valStack);
                        if (func instanceof $dc7ffeabd143829e$var$Lift) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0({
                            func: nat(func.value0),
                            count: count
                        }, fStack), valStack);
                        if (func instanceof $dc7ffeabd143829e$var$Ap) return $dc7ffeabd143829e$var$goLeft(dictApplicative)(fStack)($ba51d599f79a6310$export$8327ebbef2a0ba76(func.value1)(valStack))(nat)(func.value0)(count + 1 | 0);
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 102, column 41 - line 105, column 81): " + [
                            func.constructor.name
                        ]);
                    };
                };
            };
        };
    };
};
var $dc7ffeabd143829e$var$goApply = function(dictApplicative) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApplicative.Apply0());
    return function(fStack) {
        return function(vals) {
            return function(gVal) {
                if (fStack instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(gVal);
                if (fStack instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    var gRes = apply(fStack.value0.func)(gVal);
                    var $31 = fStack.value0.count === 1;
                    if ($31) {
                        if (fStack.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(gRes);
                        return $dc7ffeabd143829e$var$goApply(dictApplicative)(fStack.value1)(vals)(gRes);
                    }
                    if (vals instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(gRes);
                    if (vals instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $7d4cccdf062a2261$export$19db0165690c701a(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0({
                        func: gRes,
                        count: fStack.value0.count - 1 | 0
                    }, fStack.value1), new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(vals.value0, vals.value1)));
                    throw new Error("Failed pattern match at Control.Applicative.Free (line 83, column 11 - line 88, column 50): " + [
                        vals.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Control.Applicative.Free (line 72, column 3 - line 88, column 50): " + [
                    fStack.constructor.name
                ]);
            };
        };
    };
};
var $dc7ffeabd143829e$export$a37c0cfb408cb5d9 = {
    map: function(f) {
        return function(x) {
            return $dc7ffeabd143829e$var$mkAp(new $dc7ffeabd143829e$var$Pure(f))(x);
        };
    }
};
var $dc7ffeabd143829e$export$952b32e119338067 = function(dictApplicative) {
    var goApply1 = $dc7ffeabd143829e$var$goApply(dictApplicative);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var goLeft1 = $dc7ffeabd143829e$var$goLeft(dictApplicative);
    return function(nat) {
        return function(z) {
            var go = function($copy_v) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v) {
                    if (v.value1.value0 instanceof $dc7ffeabd143829e$var$Pure) {
                        var v1 = goApply1(v.value0)(v.value1.value1)(pure(v.value1.value0.value0));
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                            $copy_v = v1.value0;
                            return;
                        }
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 54, column 17 - line 56, column 24): " + [
                            v1.constructor.name
                        ]);
                    }
                    if (v.value1.value0 instanceof $dc7ffeabd143829e$var$Lift) {
                        var v1 = goApply1(v.value0)(v.value1.value1)(nat(v.value1.value0.value0));
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                            $copy_v = v1.value0;
                            return;
                        }
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 57, column 17 - line 59, column 24): " + [
                            v1.constructor.name
                        ]);
                    }
                    if (v.value1.value0 instanceof $dc7ffeabd143829e$var$Ap) {
                        var nextVals = new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value1.value0.value1, v.value1.value1);
                        $copy_v = goLeft1(v.value0)(nextVals)(nat)(v.value1.value0.value0)(1);
                        return;
                    }
                    throw new Error("Failed pattern match at Control.Applicative.Free (line 53, column 5 - line 62, column 47): " + [
                        v.value1.value0.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_v);
                return $tco_result;
            };
            return go(new $71f2e2e9476163f8$export$1908877435b1d5e9($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $ba51d599f79a6310$export$439306a4dcaafbb9(z)));
        };
    };
};
var $dc7ffeabd143829e$export$ab82a8987829bde0 = function(dictApplicative) {
    return $dc7ffeabd143829e$export$952b32e119338067(dictApplicative)($dc7ffeabd143829e$var$identity);
};
var $dc7ffeabd143829e$export$6b0545b2ed7e7da2 = {
    apply: function(fba) {
        return function(fb) {
            return $dc7ffeabd143829e$var$mkAp(fba)(fb);
        };
    },
    Functor0: function() {
        return $dc7ffeabd143829e$export$a37c0cfb408cb5d9;
    }
};
var $dc7ffeabd143829e$export$b8278c4ac41154ad = /* #__PURE__ */ function() {
    return {
        pure: $dc7ffeabd143829e$var$Pure.create,
        Apply0: function() {
            return $dc7ffeabd143829e$export$6b0545b2ed7e7da2;
        }
    };
}();
var $dc7ffeabd143829e$var$foldFreeAp1 = /* #__PURE__ */ $dc7ffeabd143829e$export$952b32e119338067($dc7ffeabd143829e$export$b8278c4ac41154ad);
var $dc7ffeabd143829e$export$2a17b194dc6daf5e = function(f) {
    return $dc7ffeabd143829e$var$foldFreeAp1(function($54) {
        return $dc7ffeabd143829e$export$9f6cb61afbf051fa(f($54));
    });
};
var $dc7ffeabd143829e$export$1d298f88ddccfbbf = function(dictMonoid) {
    var foldFreeAp2 = $dc7ffeabd143829e$export$952b32e119338067($10ae0394c8c3139a$export$38647a91a5af2717(dictMonoid));
    return function(k) {
        var $55 = foldFreeAp2(function($57) {
            return $10ae0394c8c3139a$export$8ad5d15375e29446(k($57));
        });
        return function($56) {
            return $dc7ffeabd143829e$var$unwrap($55($56));
        };
    };
};





// Generated by purs version 0.15.15






// Generated by purs version 0.15.15



// Generated by purs version 0.15.15
















var $8cad8efed8fc4b93$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $8cad8efed8fc4b93$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $8cad8efed8fc4b93$export$a9e3236c55b65445 = /* #__PURE__ */ function() {
    function CatQueue(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatQueue.create = function(value0) {
        return function(value1) {
            return new CatQueue(value0, value1);
        };
    };
    return CatQueue;
}();
var $8cad8efed8fc4b93$export$712962e076096ed4 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            $tco_done = true;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1.value0, new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0, v.value1.value1)));
        }
        if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $copy_v = new $8cad8efed8fc4b93$export$a9e3236c55b65445($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $3d4fd987da5242ff$export$66c1ae025e96b4bc(v.value0));
            return;
        }
        throw new Error("Failed pattern match at Data.CatQueue (line 92, column 1 - line 92, column 63): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $8cad8efed8fc4b93$export$b446f6baa3bb1430 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $copy_v = new $8cad8efed8fc4b93$export$a9e3236c55b65445($3d4fd987da5242ff$export$66c1ae025e96b4bc(v.value1), $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            return;
        }
        if (v.value0 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            $tco_done = true;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0.value0, new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0.value1, v.value1)));
        }
        throw new Error("Failed pattern match at Data.CatQueue (line 82, column 1 - line 82, column 63): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $8cad8efed8fc4b93$export$c40cf5aab899f397 = function(v) {
    return function(a) {
        return new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0, new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v.value1));
    };
};
var $8cad8efed8fc4b93$export$76888aafd695b76f = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($78c799cba34fcb8d$export$36831384a74c4427(dictShow));
    return {
        show: function(v) {
            return "(CatQueue " + (show(v.value0) + (" " + (show(v.value1) + ")")));
        }
    };
};
var $8cad8efed8fc4b93$export$7b1b591b262c240 = function(v) {
    if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return true;
    return false;
};
var $8cad8efed8fc4b93$export$f24224f1c91d8156 = function(v) {
    return $3d4fd987da5242ff$export$f24224f1c91d8156(v.value0) + $3d4fd987da5242ff$export$f24224f1c91d8156(v.value1) | 0;
};
var $8cad8efed8fc4b93$export$cd9df59029b2f7f5 = {
    map: function(f) {
        return function(v) {
            return new $8cad8efed8fc4b93$export$a9e3236c55b65445($8cad8efed8fc4b93$var$map(f)(v.value0), $8cad8efed8fc4b93$var$map(f)(v.value1));
        };
    }
};
var $8cad8efed8fc4b93$export$2411eb790d3ef577 = {
    foldMap: function(dictMonoid) {
        return $4fe7b6acfba7f29f$export$1131b47d09454899($8cad8efed8fc4b93$export$2411eb790d3ef577)(dictMonoid);
    },
    foldr: function(f) {
        return $4fe7b6acfba7f29f$export$9b986141719153e($8cad8efed8fc4b93$export$2411eb790d3ef577)(f);
    },
    foldl: function(f) {
        var go = function($copy_acc) {
            return function($copy_q) {
                var $tco_var_acc = $copy_acc;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, q) {
                    var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(q);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_acc = f(acc)(v.value0.value0);
                        $copy_q = v.value0.value1;
                        return;
                    }
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_done = true;
                        return acc;
                    }
                    throw new Error("Failed pattern match at Data.CatQueue (line 147, column 16 - line 149, column 22): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_q);
                return $tco_result;
            };
        };
        return go;
    }
};
var $8cad8efed8fc4b93$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($8cad8efed8fc4b93$export$2411eb790d3ef577);
var $8cad8efed8fc4b93$export$12a82fa16f3fa685 = {
    append: /* #__PURE__ */ $8cad8efed8fc4b93$var$foldl($8cad8efed8fc4b93$export$c40cf5aab899f397)
};
var $8cad8efed8fc4b93$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return new $8cad8efed8fc4b93$export$a9e3236c55b65445($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $8cad8efed8fc4b93$export$82bbee97f7dffc83 = {
    mempty: $8cad8efed8fc4b93$export$6e22c362a0406a2c,
    Semigroup0: function() {
        return $8cad8efed8fc4b93$export$12a82fa16f3fa685;
    }
};
var $8cad8efed8fc4b93$export$439306a4dcaafbb9 = /* #__PURE__ */ $8cad8efed8fc4b93$export$c40cf5aab899f397($8cad8efed8fc4b93$export$6e22c362a0406a2c);
var $8cad8efed8fc4b93$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($8cad8efed8fc4b93$export$82bbee97f7dffc83);
    return function(f) {
        return foldMap($8cad8efed8fc4b93$export$439306a4dcaafbb9)(f);
    };
};
var $8cad8efed8fc4b93$export$402e17453440564b = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(Apply0);
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            var $123 = map1($8cad8efed8fc4b93$var$foldl($8cad8efed8fc4b93$export$c40cf5aab899f397)($8cad8efed8fc4b93$export$6e22c362a0406a2c));
            var $124 = $8cad8efed8fc4b93$var$foldl(function(acc) {
                var $126 = lift2($8cad8efed8fc4b93$export$c40cf5aab899f397)(acc);
                return function($127) {
                    return $126(f($127));
                };
            })(pure($8cad8efed8fc4b93$export$6e22c362a0406a2c));
            return function($125) {
                return $123($124($125));
            };
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$417d88f64c497aed($8cad8efed8fc4b93$export$402e17453440564b)(dictApplicative);
    },
    Functor0: function() {
        return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
    },
    Foldable1: function() {
        return $8cad8efed8fc4b93$export$2411eb790d3ef577;
    }
};
var $8cad8efed8fc4b93$export$4d02617d29cfe99c = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0);
                        }
                        if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatQueue (line 154, column 24 - line 156, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($8cad8efed8fc4b93$export$6e22c362a0406a2c);
        };
    }
};
var $8cad8efed8fc4b93$export$7536d90e702d15a6 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return memo;
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatQueue (line 161, column 24 - line 163, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($8cad8efed8fc4b93$export$6e22c362a0406a2c);
        };
    },
    Unfoldable10: function() {
        return $8cad8efed8fc4b93$export$4d02617d29cfe99c;
    }
};
var $8cad8efed8fc4b93$var$cqEq = function(dictEq) {
    var elemEq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    var go = function($copy_xs) {
        return function($copy_ys) {
            var $tco_var_xs = $copy_xs;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(xs, ys) {
                var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(ys);
                var v1 = $8cad8efed8fc4b93$export$b446f6baa3bb1430(xs);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && elemEq(v1.value0.value0)(v.value0.value0)) {
                    $tco_var_xs = v1.value0.value1;
                    $copy_ys = v.value0.value1;
                    return;
                }
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return true;
                }
                $tco_done = true;
                return false;
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
            return $tco_result;
        };
    };
    return go;
};
var $8cad8efed8fc4b93$export$8d0b86d96cb644e8 = function(dictEq) {
    return {
        eq: $8cad8efed8fc4b93$var$cqEq(dictEq)
    };
};
var $8cad8efed8fc4b93$var$cqCompare = function(dictOrd) {
    var elemCompare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var go = function($copy_xs) {
        return function($copy_ys) {
            var $tco_var_xs = $copy_xs;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(xs, ys) {
                var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(ys);
                var v1 = $8cad8efed8fc4b93$export$b446f6baa3bb1430(xs);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    var v2 = elemCompare(v1.value0.value0)(v.value0.value0);
                    if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        $tco_var_xs = v1.value0.value1;
                        $copy_ys = v.value0.value1;
                        return;
                    }
                    $tco_done = true;
                    return v2;
                }
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return $5026be88823ef1f4$export$b023c82b48e70453.value;
                }
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    $tco_done = true;
                    return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                }
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                }
                throw new Error("Failed pattern match at Data.CatQueue (line 117, column 16 - line 124, column 30): " + [
                    v1.constructor.name,
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
            return $tco_result;
        };
    };
    return go;
};
var $8cad8efed8fc4b93$export$cce3b6ca8e6b304d = function(dictOrd) {
    var eqCatQueue1 = $8cad8efed8fc4b93$export$8d0b86d96cb644e8(dictOrd.Eq0());
    return {
        compare: $8cad8efed8fc4b93$var$cqCompare(dictOrd),
        Eq0: function() {
            return eqCatQueue1;
        }
    };
};
var $8cad8efed8fc4b93$export$8327ebbef2a0ba76 = function(a) {
    return function(v) {
        return new $8cad8efed8fc4b93$export$a9e3236c55b65445(new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v.value0), v.value1);
    };
};
var $8cad8efed8fc4b93$export$64857ab1e7904bd4 = {
    Applicative0: function() {
        return $8cad8efed8fc4b93$export$6d9d1867ada2692e;
    },
    Bind1: function() {
        return $8cad8efed8fc4b93$export$5f82bc311535f1fb;
    }
};
var $8cad8efed8fc4b93$export$5f82bc311535f1fb = {
    bind: /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($8cad8efed8fc4b93$export$2411eb790d3ef577)($8cad8efed8fc4b93$export$82bbee97f7dffc83)),
    Apply0: function() {
        return $8cad8efed8fc4b93$var$$lazy_applyCatQueue(0);
    }
};
var $8cad8efed8fc4b93$export$6d9d1867ada2692e = {
    pure: $8cad8efed8fc4b93$export$439306a4dcaafbb9,
    Apply0: function() {
        return $8cad8efed8fc4b93$var$$lazy_applyCatQueue(0);
    }
};
var $8cad8efed8fc4b93$var$$lazy_applyCatQueue = /* #__PURE__ */ $8cad8efed8fc4b93$var$$runtime_lazy("applyCatQueue", "Data.CatQueue", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($8cad8efed8fc4b93$export$64857ab1e7904bd4),
        Functor0: function() {
            return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
        }
    };
});
var $8cad8efed8fc4b93$export$b30f70c26a58b039 = /* #__PURE__ */ $8cad8efed8fc4b93$var$$lazy_applyCatQueue(174);
var $8cad8efed8fc4b93$export$ece98441a77a02d = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($8cad8efed8fc4b93$export$12a82fa16f3fa685),
    Functor0: function() {
        return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
    }
};
var $8cad8efed8fc4b93$export$f14c1a5864c2efe5 = {
    empty: $8cad8efed8fc4b93$export$6e22c362a0406a2c,
    Alt0: function() {
        return $8cad8efed8fc4b93$export$ece98441a77a02d;
    }
};
var $8cad8efed8fc4b93$export$6613cb99fa5f98f9 = {
    Applicative0: function() {
        return $8cad8efed8fc4b93$export$6d9d1867ada2692e;
    },
    Plus1: function() {
        return $8cad8efed8fc4b93$export$f14c1a5864c2efe5;
    }
};
var $8cad8efed8fc4b93$export$3e8f97b430646754 = {
    Monad0: function() {
        return $8cad8efed8fc4b93$export$64857ab1e7904bd4;
    },
    Alternative1: function() {
        return $8cad8efed8fc4b93$export$6613cb99fa5f98f9;
    }
};













var $2f87b4fe4d8f7a0f$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $2f87b4fe4d8f7a0f$export$7475bf8196f095ad = /* #__PURE__ */ function() {
    function CatNil() {}
    CatNil.value = new CatNil();
    return CatNil;
}();
var $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e = /* #__PURE__ */ function() {
    function CatCons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatCons.create = function(value0) {
        return function(value1) {
            return new CatCons(value0, value1);
        };
    };
    return CatCons;
}();
var $2f87b4fe4d8f7a0f$export$eb80e9167e4f6b99 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return "CatNil";
            if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return "(CatList " + (show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($8cad8efed8fc4b93$export$76888aafd695b76f($2f87b4fe4d8f7a0f$export$eb80e9167e4f6b99(dictShow)))(v.value1) + ")")));
            throw new Error("Failed pattern match at Data.CatList (line 147, column 1 - line 149, column 71): " + [
                v.constructor.name
            ]);
        }
    };
};
var $2f87b4fe4d8f7a0f$export$7b1b591b262c240 = function(v) {
    if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return true;
    return false;
};
var $2f87b4fe4d8f7a0f$var$link = function(v) {
    return function(v1) {
        if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return v1;
        if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return v;
        if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(v.value0, $8cad8efed8fc4b93$export$c40cf5aab899f397(v.value1)(v1));
        throw new Error("Failed pattern match at Data.CatList (line 108, column 1 - line 108, column 54): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $2f87b4fe4d8f7a0f$var$foldr = function(k) {
    return function(b) {
        return function(q) {
            var foldl = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1, v2) {
                            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v1;
                            }
                            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v = v;
                                $tco_var_v1 = v(v1)(v2.value0);
                                $copy_v2 = v2.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.CatList (line 124, column 3 - line 124, column 59): " + [
                                v.constructor.name,
                                v1.constructor.name,
                                v2.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            var go = function($copy_xs) {
                return function($copy_ys) {
                    var $tco_var_xs = $copy_xs;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(xs, ys) {
                        var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(xs);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done1 = true;
                            return foldl(function(x) {
                                return function(i) {
                                    return i(x);
                                };
                            })(b)(ys);
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_xs = v.value0.value1;
                            $copy_ys = new $78c799cba34fcb8d$export$74c44e616647f5c0(k(v.value0.value0), ys);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 120, column 14 - line 122, column 67): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
                    return $tco_result;
                };
            };
            return go(q)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    };
};
var $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430 = function(v) {
    if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, function() {
        var $66 = $8cad8efed8fc4b93$export$7b1b591b262c240(v.value1);
        if ($66) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
        return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v.value1);
    }()));
    throw new Error("Failed pattern match at Data.CatList (line 99, column 1 - line 99, column 61): " + [
        v.constructor.name
    ]);
};
var $2f87b4fe4d8f7a0f$export$9dc212839863b867 = {
    foldMap: function(dictMonoid) {
        return $4fe7b6acfba7f29f$export$1131b47d09454899($2f87b4fe4d8f7a0f$export$9dc212839863b867)(dictMonoid);
    },
    foldr: function(f) {
        return function(s) {
            return function(l) {
                return $4fe7b6acfba7f29f$export$9b986141719153e($2f87b4fe4d8f7a0f$export$9dc212839863b867)(f)(s)(l);
            };
        };
    },
    foldl: function(f) {
        var go = function($copy_acc) {
            return function($copy_q) {
                var $tco_var_acc = $copy_acc;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, q) {
                    var v = $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430(q);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_acc = f(acc)(v.value0.value0);
                        $copy_q = v.value0.value1;
                        return;
                    }
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_done = true;
                        return acc;
                    }
                    throw new Error("Failed pattern match at Data.CatList (line 156, column 16 - line 158, column 22): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_q);
                return $tco_result;
            };
        };
        return go;
    }
};
var $2f87b4fe4d8f7a0f$export$f24224f1c91d8156 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($2f87b4fe4d8f7a0f$export$9dc212839863b867)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $2f87b4fe4d8f7a0f$var$foldMap = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    return function(v) {
        return function(v1) {
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return mempty;
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $75 = $8cad8efed8fc4b93$export$7b1b591b262c240(v1.value1);
                    if ($75) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                }();
                return append2(v(v1.value0))($2f87b4fe4d8f7a0f$var$foldMap(dictMonoid)(v)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 134, column 1 - line 134, column 62): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
}();
var $2f87b4fe4d8f7a0f$export$10d8903dec122b9d = $2f87b4fe4d8f7a0f$var$link;
var $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76 = function(a) {
    return function(cat) {
        return $2f87b4fe4d8f7a0f$export$10d8903dec122b9d(new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(a, $8cad8efed8fc4b93$export$6e22c362a0406a2c))(cat);
    };
};
var $2f87b4fe4d8f7a0f$export$2fa88228892893e6 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $80 = $8cad8efed8fc4b93$export$7b1b591b262c240(v1.value1);
                    if ($80) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                }();
                return $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76(v(v1.value0))($f4b2eb11fc32ed34$export$871de8747c9eaa88($2f87b4fe4d8f7a0f$export$2fa88228892893e6)(v)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 184, column 1 - line 188, column 26): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $2f87b4fe4d8f7a0f$export$439306a4dcaafbb9 = function(a) {
    return $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76(a)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
};
var $2f87b4fe4d8f7a0f$export$e0c854626a3eddb8 = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return pure($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
                if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                    var d = function() {
                        var $85 = $8cad8efed8fc4b93$export$7b1b591b262c240(v1.value1);
                        if ($85) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                        return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                    }();
                    return apply(map($2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76)(v(v1.value0)))($11d1e86de605dfc6$export$df3f009e3d155b20($2f87b4fe4d8f7a0f$export$e0c854626a3eddb8)(dictApplicative)(v)(d));
                }
                throw new Error("Failed pattern match at Data.CatList (line 174, column 1 - line 182, column 33): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(v) {
            if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return pure($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
            if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $89 = $8cad8efed8fc4b93$export$7b1b591b262c240(v.value1);
                    if ($89) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v.value1);
                }();
                return apply(map($2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76)(v.value0))($11d1e86de605dfc6$export$49bb65c2ea163039($2f87b4fe4d8f7a0f$export$e0c854626a3eddb8)(dictApplicative)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 174, column 1 - line 182, column 33): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
    },
    Foldable1: function() {
        return $2f87b4fe4d8f7a0f$export$9dc212839863b867;
    }
};
var $2f87b4fe4d8f7a0f$export$da599a1924f5bf13 = {
    append: $2f87b4fe4d8f7a0f$export$10d8903dec122b9d
};
var $2f87b4fe4d8f7a0f$export$f4b77959e4023828 = /* #__PURE__ */ function() {
    return {
        mempty: $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value,
        Semigroup0: function() {
            return $2f87b4fe4d8f7a0f$export$da599a1924f5bf13;
        }
    };
}();
var $2f87b4fe4d8f7a0f$export$607c251688bb5f73 = {
    Applicative0: function() {
        return $2f87b4fe4d8f7a0f$export$360f55d5496233b2;
    },
    Bind1: function() {
        return $2f87b4fe4d8f7a0f$export$23e6c815e87cdf22;
    }
};
var $2f87b4fe4d8f7a0f$export$23e6c815e87cdf22 = {
    bind: /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $2f87b4fe4d8f7a0f$var$foldMap($2f87b4fe4d8f7a0f$export$f4b77959e4023828)),
    Apply0: function() {
        return $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(0);
    }
};
var $2f87b4fe4d8f7a0f$export$360f55d5496233b2 = {
    pure: $2f87b4fe4d8f7a0f$export$439306a4dcaafbb9,
    Apply0: function() {
        return $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(0);
    }
};
var $2f87b4fe4d8f7a0f$var$$lazy_applyCatList = /* #__PURE__ */ $2f87b4fe4d8f7a0f$var$$runtime_lazy("applyCatList", "Data.CatList", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($2f87b4fe4d8f7a0f$export$607c251688bb5f73),
        Functor0: function() {
            return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
        }
    };
});
var $2f87b4fe4d8f7a0f$export$6c3a453d31b3c12e = /* #__PURE__ */ $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(190);
var $2f87b4fe4d8f7a0f$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldMap1 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($2f87b4fe4d8f7a0f$export$f4b77959e4023828);
    return function(f) {
        return foldMap1($2f87b4fe4d8f7a0f$export$439306a4dcaafbb9)(f);
    };
};
var $2f87b4fe4d8f7a0f$export$c40cf5aab899f397 = function(cat) {
    return function(a) {
        return $2f87b4fe4d8f7a0f$export$10d8903dec122b9d(cat)(new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(a, $8cad8efed8fc4b93$export$6e22c362a0406a2c));
    };
};
var $2f87b4fe4d8f7a0f$export$bc32e6f55ceec345 = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0);
                        }
                        if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 170, column 24 - line 172, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
        };
    }
};
var $2f87b4fe4d8f7a0f$export$6cb6a5647a60bec3 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return memo;
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 163, column 24 - line 165, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
        };
    },
    Unfoldable10: function() {
        return $2f87b4fe4d8f7a0f$export$bc32e6f55ceec345;
    }
};
var $2f87b4fe4d8f7a0f$export$c5b7cf0f3fda96ad = {
    alt: $2f87b4fe4d8f7a0f$export$10d8903dec122b9d,
    Functor0: function() {
        return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
    }
};
var $2f87b4fe4d8f7a0f$export$7790c39ae1bfafa2 = {
    empty: $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c,
    Alt0: function() {
        return $2f87b4fe4d8f7a0f$export$c5b7cf0f3fda96ad;
    }
};
var $2f87b4fe4d8f7a0f$export$37a37f49d0feb489 = {
    Applicative0: function() {
        return $2f87b4fe4d8f7a0f$export$360f55d5496233b2;
    },
    Plus1: function() {
        return $2f87b4fe4d8f7a0f$export$7790c39ae1bfafa2;
    }
};
var $2f87b4fe4d8f7a0f$export$2074eaaf9933bfe1 = {
    Monad0: function() {
        return $2f87b4fe4d8f7a0f$export$607c251688bb5f73;
    },
    Alternative1: function() {
        return $2f87b4fe4d8f7a0f$export$37a37f49d0feb489;
    }
};














var $d0bd5a116d2d5f24$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $d0bd5a116d2d5f24$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($2f87b4fe4d8f7a0f$export$da599a1924f5bf13);
var $d0bd5a116d2d5f24$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $d0bd5a116d2d5f24$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $d0bd5a116d2d5f24$var$ExpF = function(x) {
    return x;
};
var $d0bd5a116d2d5f24$var$Free = /* #__PURE__ */ function() {
    function Free(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Free.create = function(value0) {
        return function(value1) {
            return new Free(value0, value1);
        };
    };
    return Free;
}();
var $d0bd5a116d2d5f24$var$Return = /* #__PURE__ */ function() {
    function Return(value0) {
        this.value0 = value0;
    }
    Return.create = function(value0) {
        return new Return(value0);
    };
    return Return;
}();
var $d0bd5a116d2d5f24$var$Bind = /* #__PURE__ */ function() {
    function Bind(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Bind.create = function(value0) {
        return function(value1) {
            return new Bind(value0, value1);
        };
    };
    return Bind;
}();
var $d0bd5a116d2d5f24$var$toView = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        var runExpF = function(v2) {
            return v2;
        };
        var concatF = function(v2) {
            return function(r) {
                return new $d0bd5a116d2d5f24$var$Free(v2.value0, $d0bd5a116d2d5f24$var$append(v2.value1)(r));
            };
        };
        if (v.value0 instanceof $d0bd5a116d2d5f24$var$Return) {
            var v2 = $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430(v.value1);
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                $tco_done = true;
                return new $d0bd5a116d2d5f24$var$Return(v.value0.value0);
            }
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                $copy_v = concatF(runExpF(v2.value0.value0)(v.value0.value0))(v2.value0.value1);
                return;
            }
            throw new Error("Failed pattern match at Control.Monad.Free (line 227, column 7 - line 231, column 64): " + [
                v2.constructor.name
            ]);
        }
        if (v.value0 instanceof $d0bd5a116d2d5f24$var$Bind) {
            $tco_done = true;
            return new $d0bd5a116d2d5f24$var$Bind(v.value0.value0, function(a) {
                return concatF(v.value0.value1(a))(v.value1);
            });
        }
        throw new Error("Failed pattern match at Control.Monad.Free (line 225, column 3 - line 233, column 56): " + [
            v.value0.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $d0bd5a116d2d5f24$export$2bd79f4d19aaa2f7 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictMonadRec) {
        var Monad0 = dictMonadRec.Monad0();
        var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Monad0.Bind1().Apply0().Functor0());
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
        var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
        return function(k) {
            var go = function(f) {
                var v = $d0bd5a116d2d5f24$var$toView(f);
                if (v instanceof $d0bd5a116d2d5f24$var$Return) return map2($f93520de2fa37b44$export$7fe28cb29e71bf10.create)(pure1(v.value0));
                if (v instanceof $d0bd5a116d2d5f24$var$Bind) return map2($f93520de2fa37b44$export$550acbd06a1f5a6a.create)(k(map1(v.value1)(v.value0)));
                throw new Error("Failed pattern match at Control.Monad.Free (line 194, column 10 - line 196, column 37): " + [
                    v.constructor.name
                ]);
            };
            return tailRecM(go);
        };
    };
};
var $d0bd5a116d2d5f24$export$39b8ebacf8133f4f = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(k) {
        var go = function($copy_f) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(f) {
                var v = $d0bd5a116d2d5f24$var$toView(f);
                if (v instanceof $d0bd5a116d2d5f24$var$Return) {
                    $tco_done = true;
                    return v.value0;
                }
                if (v instanceof $d0bd5a116d2d5f24$var$Bind) {
                    $copy_f = k(map1(v.value1)(v.value0));
                    return;
                }
                throw new Error("Failed pattern match at Control.Monad.Free (line 178, column 10 - line 180, column 33): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_f);
            return $tco_result;
        };
        return go;
    };
};
var $d0bd5a116d2d5f24$export$a7b5be099b56a644 = function(k) {
    return function(j) {
        return function(f) {
            var v = $d0bd5a116d2d5f24$var$toView(f);
            if (v instanceof $d0bd5a116d2d5f24$var$Return) return j(v.value0);
            if (v instanceof $d0bd5a116d2d5f24$var$Bind) return k(v.value0)(v.value1);
            throw new Error("Failed pattern match at Control.Monad.Free (line 213, column 17 - line 215, column 20): " + [
                v.constructor.name
            ]);
        };
    };
};
var $d0bd5a116d2d5f24$export$fbb4d68fe60c1629 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return $d0bd5a116d2d5f24$export$a7b5be099b56a644(function(g) {
        return function(i) {
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515(map1(i)(g));
        };
    })($7d4cccdf062a2261$export$19db0165690c701a.create);
};
var $d0bd5a116d2d5f24$var$fromView = function(f) {
    return new $d0bd5a116d2d5f24$var$Free(f, $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c);
};
var $d0bd5a116d2d5f24$export$4997ffc0176396a6 = function(f) {
    return $d0bd5a116d2d5f24$var$fromView(new $d0bd5a116d2d5f24$var$Bind(f, $ac8b3532514ac019$export$401372c57776dc));
};
var $d0bd5a116d2d5f24$export$7c20f42c1b2b8c79 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(f) {
        return $d0bd5a116d2d5f24$export$4997ffc0176396a6(pure1(f));
    };
};
var $d0bd5a116d2d5f24$export$25ad06f1eebea5a0 = {
    Applicative0: function() {
        return $d0bd5a116d2d5f24$export$b9ce46e7f510eb18;
    },
    Bind1: function() {
        return $d0bd5a116d2d5f24$export$39486fc5c75854c8;
    }
};
var $d0bd5a116d2d5f24$export$245cefec95375d9a = {
    map: function(k) {
        return function(f) {
            return $70cd3177464e7915$export$f2077a1c19a006d9($d0bd5a116d2d5f24$export$39486fc5c75854c8)(function() {
                var $189 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d0bd5a116d2d5f24$export$b9ce46e7f510eb18);
                return function($190) {
                    return $189(k($190));
                };
            }())(f);
        };
    }
};
var $d0bd5a116d2d5f24$export$39486fc5c75854c8 = {
    bind: function(v) {
        return function(k) {
            return new $d0bd5a116d2d5f24$var$Free(v.value0, $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(v.value1)(k));
        };
    },
    Apply0: function() {
        return $d0bd5a116d2d5f24$var$$lazy_freeApply(0);
    }
};
var $d0bd5a116d2d5f24$export$b9ce46e7f510eb18 = {
    pure: function($191) {
        return $d0bd5a116d2d5f24$var$fromView($d0bd5a116d2d5f24$var$Return.create($191));
    },
    Apply0: function() {
        return $d0bd5a116d2d5f24$var$$lazy_freeApply(0);
    }
};
var $d0bd5a116d2d5f24$var$$lazy_freeApply = /* #__PURE__ */ $d0bd5a116d2d5f24$var$$runtime_lazy("freeApply", "Control.Monad.Free", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($d0bd5a116d2d5f24$export$25ad06f1eebea5a0),
        Functor0: function() {
            return $d0bd5a116d2d5f24$export$245cefec95375d9a;
        }
    };
});
var $d0bd5a116d2d5f24$export$2d6a2fb8bce0f112 = /* #__PURE__ */ $d0bd5a116d2d5f24$var$$lazy_freeApply(77);
var $d0bd5a116d2d5f24$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($d0bd5a116d2d5f24$export$2d6a2fb8bce0f112);
var $d0bd5a116d2d5f24$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($d0bd5a116d2d5f24$export$39486fc5c75854c8);
var $d0bd5a116d2d5f24$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d0bd5a116d2d5f24$export$b9ce46e7f510eb18);
var $d0bd5a116d2d5f24$var$join = /* #__PURE__ */ $70cd3177464e7915$export$f7e2c8231c57a8bd($d0bd5a116d2d5f24$export$39486fc5c75854c8);
var $d0bd5a116d2d5f24$export$d68567ac4fd5624d = function(dictSemigroup) {
    return {
        append: $d0bd5a116d2d5f24$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $d0bd5a116d2d5f24$export$b3d357ba4a1dabd2 = {
    tailRecM: function(k) {
        return function(a) {
            return $d0bd5a116d2d5f24$var$bind(k(a))(function(v) {
                if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return $f93520de2fa37b44$export$c025cfd4cc93300b($d0bd5a116d2d5f24$export$b3d357ba4a1dabd2)(k)(v.value0);
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $d0bd5a116d2d5f24$var$pure(v.value0);
                throw new Error("Failed pattern match at Control.Monad.Free (line 86, column 26 - line 88, column 21): " + [
                    v.constructor.name
                ]);
            });
        };
    },
    Monad0: function() {
        return $d0bd5a116d2d5f24$export$25ad06f1eebea5a0;
    }
};
var $d0bd5a116d2d5f24$export$8040756fd4c77395 = function(f) {
    return $d0bd5a116d2d5f24$var$fromView(new $d0bd5a116d2d5f24$var$Bind(f, function($192) {
        return $d0bd5a116d2d5f24$var$pure($192);
    }));
};
var $d0bd5a116d2d5f24$export$5eeb2de8b5f5121f = {
    lift: function(dictMonad) {
        return $d0bd5a116d2d5f24$export$8040756fd4c77395;
    }
};
var $d0bd5a116d2d5f24$export$cb3638ab887278d6 = function(dictMonoid) {
    var semigroupFree1 = $d0bd5a116d2d5f24$export$d68567ac4fd5624d(dictMonoid.Semigroup0());
    return {
        mempty: $d0bd5a116d2d5f24$var$pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupFree1;
        }
    };
};
var $d0bd5a116d2d5f24$export$d6dbe5e3073f84e = function(k) {
    var go = function(f) {
        var v = $d0bd5a116d2d5f24$var$toView(f);
        if (v instanceof $d0bd5a116d2d5f24$var$Return) return $d0bd5a116d2d5f24$var$pure(v.value0);
        if (v instanceof $d0bd5a116d2d5f24$var$Bind) return $d0bd5a116d2d5f24$var$bind(k(v.value0))($d0bd5a116d2d5f24$var$map(go)(v.value1));
        throw new Error("Failed pattern match at Control.Monad.Free (line 168, column 10 - line 170, column 33): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $d0bd5a116d2d5f24$export$9624ed458578c422 = function(k) {
    return $d0bd5a116d2d5f24$export$d6dbe5e3073f84e(function($193) {
        return $d0bd5a116d2d5f24$export$8040756fd4c77395(k($193));
    });
};
var $d0bd5a116d2d5f24$export$7bf6537c73f09eab = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    return function(dictFoldable) {
        var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
        var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
        var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
        return {
            foldMap: function(dictMonoid) {
                var foldMap1 = foldMap(dictMonoid);
                return function(f) {
                    var $lazy_go = $d0bd5a116d2d5f24$var$$runtime_lazy("go", "Control.Monad.Free", function() {
                        return function($194) {
                            return function(v) {
                                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return foldMap1($lazy_go(94))(v.value0);
                                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return f(v.value0);
                                throw new Error("Failed pattern match at Control.Monad.Free (line 93, column 21 - line 95, column 21): " + [
                                    v.constructor.name
                                ]);
                            }(resume1($194));
                        };
                    });
                    var go = $lazy_go(93);
                    return go;
                };
            },
            foldl: function(f) {
                var go = function(r) {
                    return function($195) {
                        return function(v) {
                            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return foldl(go)(r)(v.value0);
                            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return f(r)(v.value0);
                            throw new Error("Failed pattern match at Control.Monad.Free (line 98, column 23 - line 100, column 23): " + [
                                v.constructor.name
                            ]);
                        }(resume1($195));
                    };
                };
                return go;
            },
            foldr: function(f) {
                var go = function(r) {
                    return function($196) {
                        return function(v) {
                            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return foldr($f57f4b701aa7b66e$export$8a83211c878a3f1f(go))(r)(v.value0);
                            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return f(v.value0)(r);
                            throw new Error("Failed pattern match at Control.Monad.Free (line 103, column 23 - line 105, column 23): " + [
                                v.constructor.name
                            ]);
                        }(resume1($196));
                    };
                };
                return go;
            }
        };
    };
};
var $d0bd5a116d2d5f24$export$816b93e586e4c75c = function(dictTraversable) {
    var Functor0 = dictTraversable.Functor0();
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(Functor0);
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var foldableFree1 = $d0bd5a116d2d5f24$export$7bf6537c73f09eab(Functor0)(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                var $lazy_go = $d0bd5a116d2d5f24$var$$runtime_lazy("go", "Control.Monad.Free", function() {
                    return function($197) {
                        return function(v) {
                            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return map1(function($198) {
                                return $d0bd5a116d2d5f24$var$join($d0bd5a116d2d5f24$export$8040756fd4c77395($198));
                            })(traverse1($lazy_go(111))(v.value0));
                            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map1($d0bd5a116d2d5f24$var$pure)(f(v.value0));
                            throw new Error("Failed pattern match at Control.Monad.Free (line 110, column 21 - line 112, column 30): " + [
                                v.constructor.name
                            ]);
                        }(resume1($197));
                    };
                });
                var go = $lazy_go(110);
                return go;
            };
        },
        sequence: function(dictApplicative) {
            return function(tma) {
                return $11d1e86de605dfc6$export$df3f009e3d155b20($d0bd5a116d2d5f24$export$816b93e586e4c75c(dictTraversable))(dictApplicative)($d0bd5a116d2d5f24$var$identity)(tma);
            };
        },
        Functor0: function() {
            return $d0bd5a116d2d5f24$export$245cefec95375d9a;
        },
        Foldable1: function() {
            return foldableFree1;
        }
    };
};
var $d0bd5a116d2d5f24$export$eb0e66a9104d4874 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Monad0.Bind1().Apply0().Functor0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(k) {
        var go = function(f) {
            var v = $d0bd5a116d2d5f24$var$toView(f);
            if (v instanceof $d0bd5a116d2d5f24$var$Return) return map1($f93520de2fa37b44$export$7fe28cb29e71bf10.create)(pure1(v.value0));
            if (v instanceof $d0bd5a116d2d5f24$var$Bind) return map1(function($199) {
                return $f93520de2fa37b44$export$550acbd06a1f5a6a.create(v.value1($199));
            })(k(v.value0));
            throw new Error("Failed pattern match at Control.Monad.Free (line 158, column 10 - line 160, column 37): " + [
                v.constructor.name
            ]);
        };
        return tailRecM(go);
    };
};
var $d0bd5a116d2d5f24$export$14742287b71545dd = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
        return function(dictEq) {
            var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
            return {
                eq: function(x) {
                    return function(y) {
                        var v = resume1(y);
                        var v1 = resume1(x);
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return eq1($d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor)(dictEq1)(dictEq))(v1.value0)(v.value0);
                        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a && v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return eq(v1.value0)(v.value0);
                        return false;
                    };
                }
            };
        };
    };
};
var $d0bd5a116d2d5f24$export$10be470239ca56c7 = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    var eqFree1 = $d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor);
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
        var eqFree2 = eqFree1(dictOrd1.Eq10());
        return function(dictOrd) {
            var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
            var eqFree3 = eqFree2(dictOrd.Eq0());
            return {
                compare: function(x) {
                    return function(y) {
                        var v = resume1(y);
                        var v1 = resume1(x);
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return compare1($d0bd5a116d2d5f24$export$10be470239ca56c7(dictFunctor)(dictOrd1)(dictOrd))(v1.value0)(v.value0);
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a && v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return compare(v1.value0)(v.value0);
                        throw new Error("Failed pattern match at Control.Monad.Free (line 56, column 17 - line 60, column 36): " + [
                            v1.constructor.name,
                            v.constructor.name
                        ]);
                    };
                },
                Eq0: function() {
                    return eqFree3;
                }
            };
        };
    };
};
var $d0bd5a116d2d5f24$export$269c49b8f4785316 = function(dictFunctor) {
    var eqFree1 = $d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor);
    return function(dictEq1) {
        var eqFree2 = eqFree1(dictEq1);
        return {
            eq1: function(dictEq) {
                return $37b880af5f4991bd$export$9663ddc1cf085b32(eqFree2(dictEq));
            }
        };
    };
};
var $d0bd5a116d2d5f24$export$915c63020dce06b2 = function(dictFunctor) {
    var ordFree1 = $d0bd5a116d2d5f24$export$10be470239ca56c7(dictFunctor);
    var eq1Free1 = $d0bd5a116d2d5f24$export$269c49b8f4785316(dictFunctor);
    return function(dictOrd1) {
        var ordFree2 = ordFree1(dictOrd1);
        var eq1Free2 = eq1Free1(dictOrd1.Eq10());
        return {
            compare1: function(dictOrd) {
                return $97937c29f879e68e$export$398604a469f7de9a(ordFree2(dictOrd));
            },
            Eq10: function() {
                return eq1Free2;
            }
        };
    };
};




















// Generated by purs version 0.15.15

var $100f96dc727fa3bb$export$c9e0c97aebb96176 = /* #__PURE__ */ function() {
    function ChildQuery(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    ChildQuery.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new ChildQuery(value0, value1, value2);
            };
        };
    };
    return ChildQuery;
}();
var $100f96dc727fa3bb$export$183d7a788d583d00 = $ac8b3532514ac019$export$401372c57776dc;
var $100f96dc727fa3bb$export$edf7909ca53834c6 = $ac8b3532514ac019$export$401372c57776dc;
var $100f96dc727fa3bb$export$22f9ac696d7058c1 = {
    map: function(f) {
        return $100f96dc727fa3bb$export$183d7a788d583d00(function(v) {
            return $100f96dc727fa3bb$export$edf7909ca53834c6(new $100f96dc727fa3bb$export$c9e0c97aebb96176(function(dictApplicative) {
                return v.value0(dictApplicative);
            }, v.value1, function($8) {
                return f(v.value2($8));
            }));
        });
    }
};


// Generated by purs version 0.15.15














// Generated by purs version 0.15.15
function $ef57d2bf6d374935$export$2230c7466f27d38a(a) {
    return function(b) {
        return a === b;
    };
}



var $871d3d7bcf6be72e$export$4fd25d6ead33df13 = function(x) {
    return x;
};
var $871d3d7bcf6be72e$export$50f4602e25613a3e = function(x) {
    return x;
};
var $871d3d7bcf6be72e$export$54d9901699893a6 = $ef57d2bf6d374935$export$2230c7466f27d38a;
var $871d3d7bcf6be72e$export$139829c37543f0b8 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(v) {
            return function(v1) {
                return $871d3d7bcf6be72e$export$54d9901699893a6(v)(v1) || eq(v)(v1);
            };
        }
    };
};
var $871d3d7bcf6be72e$export$32e537f465b3365f = {
    eq: function(v) {
        return function(v1) {
            return $871d3d7bcf6be72e$export$54d9901699893a6(v)(v1);
        };
    }
};


var $8360250a454b77aa$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $8360250a454b77aa$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $8360250a454b77aa$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $8360250a454b77aa$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $8360250a454b77aa$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $8360250a454b77aa$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($6c2f8951ecf9531e$export$89bf999217d3022a);
var $8360250a454b77aa$var$traverse_1 = /* #__PURE__ */ $8360250a454b77aa$var$traverse_($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8360250a454b77aa$var$applySecond = /* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($6c2f8951ecf9531e$export$59a7b217c53300d2);
var $8360250a454b77aa$var$traverse_2 = /* #__PURE__ */ $8360250a454b77aa$var$traverse_($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $8360250a454b77aa$var$Subscription = function(x) {
    return x;
};
var $8360250a454b77aa$var$Listener = function(x) {
    return x;
};
var $8360250a454b77aa$var$Emitter = function(x) {
    return x;
};
var $8360250a454b77aa$export$f500693cef883ffd = function(v) {
    return v;
};
var $8360250a454b77aa$export$ec068583843480e7 = function(v) {
    return function(k) {
        return v(function($76) {
            return $8360250a454b77aa$var$$$void(k($76));
        });
    };
};
var $8360250a454b77aa$export$7251a5ca64435ded = /* #__PURE__ */ $6c2f8951ecf9531e$export$58139e981c60cf43($d7bf9817a417d4ae$export$824c37c4afd77b1);
var $8360250a454b77aa$export$5e14cdade93d6f7b = function(v) {
    return function(a) {
        return v(a);
    };
};
var $8360250a454b77aa$export$f78eaf36ddcc5627 = /* #__PURE__ */ $6c2f8951ecf9531e$export$2d8226ee4b2722f7($784e1bd3d26d71da$export$852b4040eee6c6ba);
var $8360250a454b77aa$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357(/* #__PURE__ */ $784e1bd3d26d71da$export$192e81b9fe7e4abe(/* #__PURE__ */ $6c2f8951ecf9531e$export$2d8226ee4b2722f7($8360250a454b77aa$export$f78eaf36ddcc5627)));
var $8360250a454b77aa$export$59cc8049ccd39a18 = $8360250a454b77aa$var$coerce;
var $8360250a454b77aa$export$8fdc462d887e88b6 = {
    map: function(f) {
        return function(v) {
            return function(k) {
                return v(function($77) {
                    return k(f($77));
                });
            };
        };
    }
};
var $8360250a454b77aa$export$93e2b83da34ff82a = function(f) {
    return function(v) {
        return function(b) {
            return function(k) {
                return function __do() {
                    var result = $90327512d8280b8d$export$b8cb59497041ffe4(b)();
                    return v(function(a) {
                        return $8360250a454b77aa$var$bind($90327512d8280b8d$export$3ff57735a52b8713(f(a))(result))(k);
                    })();
                };
            };
        };
    };
};
var $8360250a454b77aa$export$3dea766d36a8935f = function(p) {
    return function(v) {
        return function(k) {
            return v(function(a) {
                var $57 = p(a);
                if ($57) return k(a);
                return $8360250a454b77aa$var$pure($05149ea687d6b460$export$523c0b569236b342);
            });
        };
    };
};
var $8360250a454b77aa$export$185802fd694ee1f5 = function __do() {
    var subscribers = $90327512d8280b8d$export$b8cb59497041ffe4([])();
    return {
        emitter: function(k) {
            return function __do() {
                $90327512d8280b8d$export$45b91115a89d6020(function(v) {
                    return $8360250a454b77aa$var$append(v)([
                        k
                    ]);
                })(subscribers)();
                return $90327512d8280b8d$export$45b91115a89d6020($396c4c3d9e7fae3c$export$9ea2b6c3fae093d8($871d3d7bcf6be72e$export$54d9901699893a6)(k))(subscribers);
            };
        },
        listener: function(a) {
            return $8360250a454b77aa$var$bind($e521936ea118867a$export$aafa59e2e03f2942(subscribers))($8360250a454b77aa$var$traverse_1(function(k) {
                return k(a);
            }));
        }
    };
};
var $8360250a454b77aa$export$d838837eb5b184e3 = function(f) {
    var v = $c02f07bc0f38e9e9$export$c62839628b30a695($8360250a454b77aa$export$185802fd694ee1f5);
    var v1 = f(v.emitter);
    return function(k) {
        return function __do() {
            var v2 = $8360250a454b77aa$export$ec068583843480e7(v1.input)($8360250a454b77aa$export$5e14cdade93d6f7b(v.listener))();
            var v3 = $8360250a454b77aa$export$ec068583843480e7(v1.output)(k)();
            return $8360250a454b77aa$var$applySecond(v2)(v3);
        };
    };
};
var $8360250a454b77aa$export$98d7d43cbbc38ca1 = {
    cmap: function(f) {
        return function(v) {
            return $8360250a454b77aa$var$coerce(function($78) {
                return v(f($78));
            });
        };
    }
};
var $8360250a454b77aa$export$641721d49e3b53db = {
    apply: function(v) {
        return function(v1) {
            return function(k) {
                return function __do() {
                    var latestA = $90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)();
                    var latestB = $90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)();
                    var v2 = v(function(a) {
                        return function __do() {
                            $e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(a))(latestA)();
                            return $8360250a454b77aa$var$bind($e521936ea118867a$export$aafa59e2e03f2942(latestB))($8360250a454b77aa$var$traverse_2(function($79) {
                                return k(a($79));
                            }))();
                        };
                    })();
                    var v3 = v1(function(b) {
                        return function __do() {
                            $e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(b))(latestB)();
                            return $8360250a454b77aa$var$bind($e521936ea118867a$export$aafa59e2e03f2942(latestA))($8360250a454b77aa$var$traverse_2(function($80) {
                                return k(function(v3) {
                                    return v3(b);
                                }($80));
                            }))();
                        };
                    })();
                    return $8360250a454b77aa$var$applySecond(v2)(v3);
                };
            };
        };
    },
    Functor0: function() {
        return $8360250a454b77aa$export$8fdc462d887e88b6;
    }
};
var $8360250a454b77aa$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($8360250a454b77aa$export$641721d49e3b53db);
var $8360250a454b77aa$export$1096768271b079ef = function(dictSemigroup) {
    return {
        append: $8360250a454b77aa$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $8360250a454b77aa$export$3b69707d5efd35bb = function(dictMonoid) {
    var semigroupEmitter1 = $8360250a454b77aa$export$1096768271b079ef(dictMonoid.Semigroup0());
    return {
        mempty: $8360250a454b77aa$var$mempty,
        Semigroup0: function() {
            return semigroupEmitter1;
        }
    };
};
var $8360250a454b77aa$export$b87fc96b41f99504 = {
    pure: function(a) {
        return function(k) {
            return function __do() {
                k(a)();
                return $8360250a454b77aa$var$pure($05149ea687d6b460$export$523c0b569236b342);
            };
        };
    },
    Apply0: function() {
        return $8360250a454b77aa$export$641721d49e3b53db;
    }
};
var $8360250a454b77aa$export$e54eec101f91650d = {
    alt: function(v) {
        return function(v1) {
            return function(k) {
                return function __do() {
                    var v2 = v(k)();
                    var v3 = v1(k)();
                    return $8360250a454b77aa$var$applySecond(v2)(v3);
                };
            };
        };
    },
    Functor0: function() {
        return $8360250a454b77aa$export$8fdc462d887e88b6;
    }
};
var $8360250a454b77aa$export$18c97e2c4a95b65b = {
    empty: function(v) {
        return $8360250a454b77aa$var$pure($8360250a454b77aa$var$pure($05149ea687d6b460$export$523c0b569236b342));
    },
    Alt0: function() {
        return $8360250a454b77aa$export$e54eec101f91650d;
    }
};
var $8360250a454b77aa$export$9afcd97a0eb7b5aa = {
    Applicative0: function() {
        return $8360250a454b77aa$export$b87fc96b41f99504;
    },
    Plus1: function() {
        return $8360250a454b77aa$export$18c97e2c4a95b65b;
    }
};


var $84222ab19bdc98bd$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $84222ab19bdc98bd$var$foldrWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$d859ed9adfa064ca($ea3eb84de0acf574$export$91e1c50dfb7225a6);
var $84222ab19bdc98bd$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($ea3eb84de0acf574$export$78146089411e393d);
var $84222ab19bdc98bd$var$slots = /* #__PURE__ */ $0f3b7f18059106fc$export$bbd679b9fab4c947();
var $84222ab19bdc98bd$var$lookup = /* #__PURE__ */ $0f3b7f18059106fc$export$dfc7155ac0343b8();
var $84222ab19bdc98bd$var$over = /* #__PURE__ */ $4fa4836228a192cc$export$fb4902fd9e525693()();
var $84222ab19bdc98bd$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($8360250a454b77aa$export$8fdc462d887e88b6);
var $84222ab19bdc98bd$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $84222ab19bdc98bd$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$34a2521cb7920188);
var $84222ab19bdc98bd$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($100f96dc727fa3bb$export$22f9ac696d7058c1);
var $84222ab19bdc98bd$export$f3ce0030ce21b322 = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$77e8fa738093aa8c = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$7254cc27399e90bd = /* #__PURE__ */ function() {
    function State(value0) {
        this.value0 = value0;
    }
    State.create = function(value0) {
        return new State(value0);
    };
    return State;
}();
var $84222ab19bdc98bd$export$b5b6bb8bb5273115 = /* #__PURE__ */ function() {
    function Subscribe(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Subscribe.create = function(value0) {
        return function(value1) {
            return new Subscribe(value0, value1);
        };
    };
    return Subscribe;
}();
var $84222ab19bdc98bd$export$cf424b9d16eab6b0 = /* #__PURE__ */ function() {
    function Unsubscribe(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Unsubscribe.create = function(value0) {
        return function(value1) {
            return new Unsubscribe(value0, value1);
        };
    };
    return Unsubscribe;
}();
var $84222ab19bdc98bd$export$5ba9ac88cb4a4c17 = /* #__PURE__ */ function() {
    function Lift(value0) {
        this.value0 = value0;
    }
    Lift.create = function(value0) {
        return new Lift(value0);
    };
    return Lift;
}();
var $84222ab19bdc98bd$export$c9e0c97aebb96176 = /* #__PURE__ */ function() {
    function ChildQuery(value0) {
        this.value0 = value0;
    }
    ChildQuery.create = function(value0) {
        return new ChildQuery(value0);
    };
    return ChildQuery;
}();
var $84222ab19bdc98bd$export$c97bcbb53b4e15e4 = /* #__PURE__ */ function() {
    function Raise(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Raise.create = function(value0) {
        return function(value1) {
            return new Raise(value0, value1);
        };
    };
    return Raise;
}();
var $84222ab19bdc98bd$export$6e7e621f508eff66 = /* #__PURE__ */ function() {
    function Par(value0) {
        this.value0 = value0;
    }
    Par.create = function(value0) {
        return new Par(value0);
    };
    return Par;
}();
var $84222ab19bdc98bd$export$8cdfc2927e464854 = /* #__PURE__ */ function() {
    function Fork(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Fork.create = function(value0) {
        return function(value1) {
            return new Fork(value0, value1);
        };
    };
    return Fork;
}();
var $84222ab19bdc98bd$export$26aa7833c998c5d3 = /* #__PURE__ */ function() {
    function Join(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Join.create = function(value0) {
        return function(value1) {
            return new Join(value0, value1);
        };
    };
    return Join;
}();
var $84222ab19bdc98bd$export$25e269b2a286b4be = /* #__PURE__ */ function() {
    function Kill(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Kill.create = function(value0) {
        return function(value1) {
            return new Kill(value0, value1);
        };
    };
    return Kill;
}();
var $84222ab19bdc98bd$export$c2ea277386f73da0 = /* #__PURE__ */ function() {
    function GetRef(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    GetRef.create = function(value0) {
        return function(value1) {
            return new GetRef(value0, value1);
        };
    };
    return GetRef;
}();
var $84222ab19bdc98bd$export$a719947860ecc9c1 = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$9599f158307d5f79 = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$f500693cef883ffd = function(sid) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$cf424b9d16eab6b0(sid, $05149ea687d6b460$export$523c0b569236b342));
};
var $84222ab19bdc98bd$export$614bd1e27186eef8 = function(esc) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$b5b6bb8bb5273115(esc, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($05149ea687d6b460$export$523c0b569236b342)));
};
var $84222ab19bdc98bd$export$ec068583843480e7 = function(es) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$b5b6bb8bb5273115(function(v) {
        return es;
    }, $84222ab19bdc98bd$var$identity));
};
var $84222ab19bdc98bd$export$24cfcc8b33bdb8e8 = function(dictSemigroup) {
    return $d0bd5a116d2d5f24$export$d68567ac4fd5624d(dictSemigroup);
};
var $84222ab19bdc98bd$export$66313c302b2ea154 = function(o) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(o, $05149ea687d6b460$export$523c0b569236b342));
};
var $84222ab19bdc98bd$export$dcd0d083aa86c355 = function() {
    return function(dictIsSymbol) {
        var slots1 = $84222ab19bdc98bd$var$slots(dictIsSymbol);
        return function(dictOrd) {
            var slots2 = slots1(dictOrd);
            return function(label) {
                return function(q) {
                    var catMapMaybes = function(dictOrd1) {
                        var insert = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd1);
                        return $84222ab19bdc98bd$var$foldrWithIndex(function(k) {
                            return function(v) {
                                return function(acc) {
                                    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(acc)($f57f4b701aa7b66e$export$8a83211c878a3f1f(insert(k))(acc))(v);
                                };
                            };
                        })($ea3eb84de0acf574$export$6e22c362a0406a2c);
                    };
                    var catMapMaybes1 = catMapMaybes(dictOrd);
                    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$c9e0c97aebb96176($100f96dc727fa3bb$export$edf7909ca53834c6(new $100f96dc727fa3bb$export$c9e0c97aebb96176(function(dictApplicative) {
                        var map4 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                        var traverse1 = $84222ab19bdc98bd$var$traverse(dictApplicative);
                        return function(k) {
                            var $173 = map4(catMapMaybes1);
                            var $174 = traverse1(k);
                            var $175 = slots2(label);
                            return function($176) {
                                return $173($174($175($176)));
                            };
                        };
                    }, q, $84222ab19bdc98bd$var$identity))));
                };
            };
        };
    };
};
var $84222ab19bdc98bd$export$2fa187e846a241c4 = function() {
    return function(dictIsSymbol) {
        var lookup1 = $84222ab19bdc98bd$var$lookup(dictIsSymbol);
        return function(dictOrd) {
            var lookup2 = lookup1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(q) {
                        return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$c9e0c97aebb96176($100f96dc727fa3bb$export$edf7909ca53834c6(new $100f96dc727fa3bb$export$c9e0c97aebb96176(function(dictApplicative) {
                            var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
                            return function(k) {
                                var $177 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(pure1($06733ae99ed4f534$export$bebe9059409a0d04.value))(k);
                                var $178 = lookup2(label)(p);
                                return function($179) {
                                    return $177($178($179));
                                };
                            };
                        }, q, $84222ab19bdc98bd$var$identity))));
                    };
                };
            };
        };
    };
};
var $84222ab19bdc98bd$export$2a9fc99fce80131a = $97937c29f879e68e$export$ff461bf68e7dd332;
var $84222ab19bdc98bd$export$7e953d51c2b3343e = $97937c29f879e68e$export$ff461bf68e7dd332;
var $84222ab19bdc98bd$export$e0bae42e641783be = {
    Coercible0: function() {
        return undefined;
    }
};
var $84222ab19bdc98bd$export$2b4680b78d507e0e = function(dictMonoid) {
    return $d0bd5a116d2d5f24$export$cb3638ab887278d6(dictMonoid);
};
var $84222ab19bdc98bd$export$a19097d0708c88b2 = {
    lift: function(dictMonad) {
        return function($180) {
            return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($180)));
        };
    }
};
var $84222ab19bdc98bd$export$a558113f6f2e3f2d = $d0bd5a116d2d5f24$export$25ad06f1eebea5a0;
var $84222ab19bdc98bd$export$87bf621137788b28 = {
    state: function($181) {
        return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$7254cc27399e90bd.create($181)));
    },
    Monad0: function() {
        return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
    }
};
var $84222ab19bdc98bd$export$cf461d6710b3adc = function(dictMonadTell) {
    var Semigroup0 = dictMonadTell.Semigroup0();
    return {
        tell: function() {
            var $182 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($183) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($182($183))));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$4671b1f72e4f4ad4 = function(dictMonadThrow) {
    return {
        throwError: function() {
            var $184 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
            return function($185) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($184($185))));
            };
        }(),
        Monad0: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$aecceb0bc1bf10d9 = function(dictMonadEffect) {
    return {
        liftEffect: function() {
            var $186 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($187) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($186($187))));
            };
        }(),
        Monad0: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$8feaa16df4090813 = function(dictMonadAsk) {
    return {
        ask: $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk))),
        Monad0: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$6f4dec227404555 = function(dictMonadAff) {
    var monadEffectHalogenM1 = $84222ab19bdc98bd$export$aecceb0bc1bf10d9(dictMonadAff.MonadEffect0());
    return {
        liftAff: function() {
            var $188 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($189) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($188($189))));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectHalogenM1;
        }
    };
};
var $84222ab19bdc98bd$export$88e5a30f85fcd860 = function(f) {
    return function(v) {
        var go = function(v1) {
            if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(v1.value0);
            if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(v1.value0);
            if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
            if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(f(v1.value0), v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($dc7ffeabd143829e$export$2a17b194dc6daf5e($84222ab19bdc98bd$export$88e5a30f85fcd860(f)))(v1.value0));
            if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$88e5a30f85fcd860(f)(v1.value0), v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
            throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 290, column 8 - line 301, column 29): " + [
                v1.constructor.name
            ]);
        };
        return $d0bd5a116d2d5f24$export$9624ed458578c422(go)(v);
    };
};
var $84222ab19bdc98bd$export$77c80fee367384a1 = function(dictFunctor) {
    return function(f) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(function() {
                    var $190 = $84222ab19bdc98bd$var$map(f);
                    return function($191) {
                        return $190(v1.value0($191));
                    };
                }(), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($dc7ffeabd143829e$export$2a17b194dc6daf5e($84222ab19bdc98bd$export$77c80fee367384a1(dictFunctor)(f)))(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$77c80fee367384a1(dictFunctor)(f)(v1.value0), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 269, column 8 - line 280, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $d0bd5a116d2d5f24$export$9624ed458578c422(go)(v);
        };
    };
};
var $84222ab19bdc98bd$export$dfdb508572caf3d7 = function(fid) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$25e269b2a286b4be(fid, $05149ea687d6b460$export$523c0b569236b342));
};
var $84222ab19bdc98bd$export$f7e2c8231c57a8bd = function(fid) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$26aa7833c998c5d3(fid, $05149ea687d6b460$export$523c0b569236b342));
};
var $84222ab19bdc98bd$export$d4721e7c31d91ccb = function(f) {
    return function(f$prime) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(function() {
                    var $192 = $84222ab19bdc98bd$var$map1(f);
                    return function($193) {
                        return $192(v1.value0(f$prime($193)));
                    };
                }());
                if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($dc7ffeabd143829e$export$2a17b194dc6daf5e($84222ab19bdc98bd$export$d4721e7c31d91ccb(f)(f$prime)))(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$d4721e7c31d91ccb(f)(f$prime)(v1.value0), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 247, column 8 - line 258, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $d0bd5a116d2d5f24$export$9624ed458578c422(go)(v);
        };
    };
};
var $84222ab19bdc98bd$export$b2cccb4e0928a3a6 = function(dictFunctor) {
    return function(nat) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(nat(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($dc7ffeabd143829e$export$2a17b194dc6daf5e($84222ab19bdc98bd$export$b2cccb4e0928a3a6(dictFunctor)(nat)))(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$b2cccb4e0928a3a6(dictFunctor)(nat)(v1.value0), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 312, column 8 - line 323, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $d0bd5a116d2d5f24$export$9624ed458578c422(go)(v);
        };
    };
};
var $84222ab19bdc98bd$export$f0c653cfd7dea798 = function(p) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$c2ea277386f73da0(p, $84222ab19bdc98bd$var$identity));
};
var $84222ab19bdc98bd$export$bf09f5de576f9cf1 = $d0bd5a116d2d5f24$export$245cefec95375d9a;
var $84222ab19bdc98bd$export$e670701c689a627c = $dc7ffeabd143829e$export$a37c0cfb408cb5d9;
var $84222ab19bdc98bd$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($84222ab19bdc98bd$export$e670701c689a627c);
var $84222ab19bdc98bd$export$12e8711db3d90a36 = function(dictFunctor) {
    var map4 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                if (v instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(function() {
                    var $194 = $84222ab19bdc98bd$var$lmap(f);
                    return function($195) {
                        return $194(v.value0($195));
                    };
                }());
                if (v instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v.value0, function($196) {
                    return f(v.value1($196));
                });
                if (v instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(map4(f)(v.value0));
                if (v instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176($84222ab19bdc98bd$var$map2(f)(v.value0));
                if (v instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$map3(f)(v.value0));
                if (v instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854(v.value0, function($197) {
                    return f(v.value1($197));
                });
                if (v instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v.value0, function($198) {
                    return f(v.value1($198));
                });
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 57, column 11 - line 68, column 37): " + [
                    v.constructor.name
                ]);
            };
        }
    };
};
var $84222ab19bdc98bd$export$7a5058c6b79333e0 = function(hmu) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$8cdfc2927e464854(hmu, $84222ab19bdc98bd$var$identity));
};
var $84222ab19bdc98bd$export$5e41ee1c67709c46 = $37b880af5f4991bd$export$e65788c6d4494539;
var $84222ab19bdc98bd$export$5d7b8e78e43e2e55 = $37b880af5f4991bd$export$e65788c6d4494539;
var $84222ab19bdc98bd$export$172cc2b2b4e6467a = $d0bd5a116d2d5f24$export$39486fc5c75854c8;
var $84222ab19bdc98bd$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($84222ab19bdc98bd$export$172cc2b2b4e6467a);
var $84222ab19bdc98bd$export$728fdd75cbe6b202 = $d0bd5a116d2d5f24$export$2d6a2fb8bce0f112;
var $84222ab19bdc98bd$export$86681bd6e5a32e67 = $dc7ffeabd143829e$export$6b0545b2ed7e7da2;
var $84222ab19bdc98bd$export$c43a5691f7e31126 = {
    parallel: function($199) {
        return $84222ab19bdc98bd$export$a719947860ecc9c1($dc7ffeabd143829e$export$9f6cb61afbf051fa($199));
    },
    sequential: function($200) {
        return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$6e7e621f508eff66.create($200)));
    },
    Apply0: function() {
        return $84222ab19bdc98bd$export$728fdd75cbe6b202;
    },
    Apply1: function() {
        return $84222ab19bdc98bd$export$86681bd6e5a32e67;
    }
};
var $84222ab19bdc98bd$export$be2318e898dcc68 = $d0bd5a116d2d5f24$export$b9ce46e7f510eb18;
var $84222ab19bdc98bd$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($84222ab19bdc98bd$export$be2318e898dcc68);
var $84222ab19bdc98bd$export$5cb2ea25322ba73e = {
    tailRecM: function(k) {
        return function(a) {
            return $84222ab19bdc98bd$var$bind(k(a))(function(v) {
                if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return $f93520de2fa37b44$export$c025cfd4cc93300b($84222ab19bdc98bd$export$5cb2ea25322ba73e)(k)(v.value0);
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $84222ab19bdc98bd$var$pure(v.value0);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 105, column 26 - line 107, column 21): " + [
                    v.constructor.name
                ]);
            });
        };
    },
    Monad0: function() {
        return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
    }
};
var $84222ab19bdc98bd$export$a8dcf11c663b5a8c = $dc7ffeabd143829e$export$b8278c4ac41154ad;


// Generated by purs version 0.15.15


var $43c0c9babefbb793$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($026fde5446dd624a$export$bd40aba71422b460);
var $43c0c9babefbb793$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $43c0c9babefbb793$export$b03b1c699c90a9b4 = /* #__PURE__ */ function() {
    function Initialize(value0) {
        this.value0 = value0;
    }
    Initialize.create = function(value0) {
        return new Initialize(value0);
    };
    return Initialize;
}();
var $43c0c9babefbb793$export$29defdae7b3f3a01 = /* #__PURE__ */ function() {
    function Finalize(value0) {
        this.value0 = value0;
    }
    Finalize.create = function(value0) {
        return new Finalize(value0);
    };
    return Finalize;
}();
var $43c0c9babefbb793$export$fc713a64b8ca1b7a = /* #__PURE__ */ function() {
    function Receive(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Receive.create = function(value0) {
        return function(value1) {
            return new Receive(value0, value1);
        };
    };
    return Receive;
}();
var $43c0c9babefbb793$export$e19cd5f9376f8cee = /* #__PURE__ */ function() {
    function Action(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Action.create = function(value0) {
        return function(value1) {
            return new Action(value0, value1);
        };
    };
    return Action;
}();
var $43c0c9babefbb793$export$62297b13309008b2 = /* #__PURE__ */ function() {
    function Query(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Query.create = function(value0) {
        return function(value1) {
            return new Query(value0, value1);
        };
    };
    return Query;
}();
var $43c0c9babefbb793$export$dc697e7b72225166 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $43c0c9babefbb793$export$b03b1c699c90a9b4) return new $43c0c9babefbb793$export$b03b1c699c90a9b4(f(m.value0));
            if (m instanceof $43c0c9babefbb793$export$29defdae7b3f3a01) return new $43c0c9babefbb793$export$29defdae7b3f3a01(f(m.value0));
            if (m instanceof $43c0c9babefbb793$export$fc713a64b8ca1b7a) return new $43c0c9babefbb793$export$fc713a64b8ca1b7a(m.value0, f(m.value1));
            if (m instanceof $43c0c9babefbb793$export$e19cd5f9376f8cee) return new $43c0c9babefbb793$export$e19cd5f9376f8cee(m.value0, f(m.value1));
            if (m instanceof $43c0c9babefbb793$export$62297b13309008b2) return new $43c0c9babefbb793$export$62297b13309008b2($43c0c9babefbb793$var$map(f)(m.value0), $43c0c9babefbb793$var$map1(f)(m.value1));
            throw new Error("Failed pattern match at Halogen.Query.HalogenQ (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $43c0c9babefbb793$export$211dae0362bd77c6 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                if (v instanceof $43c0c9babefbb793$export$b03b1c699c90a9b4) return new $43c0c9babefbb793$export$b03b1c699c90a9b4(g(v.value0));
                if (v instanceof $43c0c9babefbb793$export$29defdae7b3f3a01) return new $43c0c9babefbb793$export$29defdae7b3f3a01(g(v.value0));
                if (v instanceof $43c0c9babefbb793$export$fc713a64b8ca1b7a) return new $43c0c9babefbb793$export$fc713a64b8ca1b7a(f(v.value0), g(v.value1));
                if (v instanceof $43c0c9babefbb793$export$e19cd5f9376f8cee) return new $43c0c9babefbb793$export$e19cd5f9376f8cee(v.value0, g(v.value1));
                if (v instanceof $43c0c9babefbb793$export$62297b13309008b2) return new $43c0c9babefbb793$export$62297b13309008b2($43c0c9babefbb793$var$map(g)(v.value0), $43c0c9babefbb793$var$map1(g)(v.value1));
                throw new Error("Failed pattern match at Halogen.Query.HalogenQ (line 16, column 15 - line 21, column 45): " + [
                    v.constructor.name
                ]);
            };
        };
    }
};


// Generated by purs version 0.15.15






var $f1bf345cdb6c789d$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $f1bf345cdb6c789d$var$Thunk = /* #__PURE__ */ function() {
    function Thunk(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Thunk.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Thunk(value0, value1, value2, value3);
                };
            };
        };
    };
    return Thunk;
}();
var $f1bf345cdb6c789d$var$unsafeThunkId = $ac8b3532514ac019$export$401372c57776dc;
var $f1bf345cdb6c789d$var$unsafeEqThunk = function(v, v1) {
    return $39e0beec4569345c$export$9bc2d847a861e3d8(v.value0, v1.value0) && $39e0beec4569345c$export$9bc2d847a861e3d8(v.value1, v1.value1) && v.value1(v.value3, v1.value3);
};
var $f1bf345cdb6c789d$var$thunk = function(tid, eqFn, f, a) {
    return new $f1bf345cdb6c789d$var$Thunk(tid, eqFn, f, a);
};
var $f1bf345cdb6c789d$export$c6666e7f0d2efc62 = function(f, a) {
    return $f1bf345cdb6c789d$var$thunk($f1bf345cdb6c789d$var$unsafeThunkId(f), $39e0beec4569345c$export$9bc2d847a861e3d8, f, a);
};
var $f1bf345cdb6c789d$export$8a29159161b2b8a6 = /* #__PURE__ */ function() {
    var eqFn = function(a, b) {
        return $39e0beec4569345c$export$9bc2d847a861e3d8(a["_1"], b["_1"]) && $39e0beec4569345c$export$9bc2d847a861e3d8(a["_2"], b["_2"]);
    };
    return function(f, a, b) {
        return $f1bf345cdb6c789d$var$thunk($f1bf345cdb6c789d$var$unsafeThunkId(f), eqFn, function(v) {
            return f(v["_1"])(v["_2"]);
        }, {
            "_1": a,
            "_2": b
        });
    };
}();
var $f1bf345cdb6c789d$export$7f0ccf52046143dd = /* #__PURE__ */ function() {
    var eqFn = function(a, b) {
        return $39e0beec4569345c$export$9bc2d847a861e3d8(a["_1"], b["_1"]) && $39e0beec4569345c$export$9bc2d847a861e3d8(a["_2"], b["_2"]) && $39e0beec4569345c$export$9bc2d847a861e3d8(a["_3"], b["_3"]);
    };
    return function(f, a, b, c) {
        return $f1bf345cdb6c789d$var$thunk($f1bf345cdb6c789d$var$unsafeThunkId(f), eqFn, function(v) {
            return f(v["_1"])(v["_2"])(v["_3"]);
        }, {
            "_1": a,
            "_2": b,
            "_3": c
        });
    };
}();
var $f1bf345cdb6c789d$export$6fa757c467a343e = function(eqFn) {
    return function(f) {
        var tid = $f1bf345cdb6c789d$var$unsafeThunkId({
            f: f
        });
        var eqFn$prime = $8f2697950ee155e1$export$b12d5f1f5e196716(eqFn);
        return function(a) {
            return $f1bf345cdb6c789d$var$thunk(tid, eqFn$prime, f, a);
        };
    };
};
var $f1bf345cdb6c789d$export$1a6f8a190b47b840 = function(v) {
    return v.value2(v.value3);
};
var $f1bf345cdb6c789d$export$ad7ceecc341abc7e = function(k) {
    return function(v) {
        return new $f1bf345cdb6c789d$var$Thunk(v.value0, v.value1, function($51) {
            return k(v.value2($51));
        }, v.value3);
    };
};
var $f1bf345cdb6c789d$export$b2cccb4e0928a3a6 = $f1bf345cdb6c789d$export$ad7ceecc341abc7e;
var $f1bf345cdb6c789d$export$2d03ed83ba31f127 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return new $f1bf345cdb6c789d$var$Thunk(v.value0, v.value1, function() {
                    var $52 = map(f);
                    return function($53) {
                        return $52(v.value2($53));
                    };
                }(), v.value3);
            };
        }
    };
};
var $f1bf345cdb6c789d$export$d46b23c375182cf8 = function(toVDom) {
    var haltThunk = function(state) {
        return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(state.vdom);
    };
    var $lazy_patchThunk = $f1bf345cdb6c789d$var$$runtime_lazy("patchThunk", "Halogen.VDom.Thunk", function() {
        return function(state, t2) {
            var $48 = $f1bf345cdb6c789d$var$unsafeEqThunk(state.thunk, t2);
            if ($48) return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($47a0a3ebf66dcc6a$export$f9380c9a627682d3(state.vdom), state, $lazy_patchThunk(112), haltThunk));
            var vdom = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.vdom, toVDom($f1bf345cdb6c789d$export$1a6f8a190b47b840(t2)));
            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($47a0a3ebf66dcc6a$export$f9380c9a627682d3(vdom), {
                vdom: vdom,
                thunk: t2
            }, $lazy_patchThunk(115), haltThunk));
        };
    });
    var patchThunk = $lazy_patchThunk(108);
    var renderThunk = function(spec) {
        return function(t) {
            var vdom = $784c06f0344d34c4$export$7d13c0f6790d0505(spec)(toVDom($f1bf345cdb6c789d$export$1a6f8a190b47b840(t)));
            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($47a0a3ebf66dcc6a$export$f9380c9a627682d3(vdom), {
                thunk: t,
                vdom: vdom
            }, patchThunk, haltThunk));
        };
    };
    return renderThunk;
};



var $eea39ea934373596$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($84222ab19bdc98bd$export$bf09f5de576f9cf1);
var $eea39ea934373596$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($84222ab19bdc98bd$export$be2318e898dcc68)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $eea39ea934373596$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($84222ab19bdc98bd$export$bf09f5de576f9cf1);
var $eea39ea934373596$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($c959b62ce0c19dfe$export$a671de4661736606);
var $eea39ea934373596$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $eea39ea934373596$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $eea39ea934373596$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($c959b62ce0c19dfe$export$a671de4661736606);
var $eea39ea934373596$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($84222ab19bdc98bd$export$be2318e898dcc68);
var $eea39ea934373596$var$lookup = /* #__PURE__ */ $0f3b7f18059106fc$export$dfc7155ac0343b8();
var $eea39ea934373596$var$pop = /* #__PURE__ */ $0f3b7f18059106fc$export$3e41007ebfff0e64();
var $eea39ea934373596$var$insert = /* #__PURE__ */ $0f3b7f18059106fc$export$21a5ca8aa77d35ff();
var $eea39ea934373596$export$bbf8b056cc92e88d = /* #__PURE__ */ function() {
    function ComponentSlot(value0) {
        this.value0 = value0;
    }
    ComponentSlot.create = function(value0) {
        return new ComponentSlot(value0);
    };
    return ComponentSlot;
}();
var $eea39ea934373596$export$5e46cfa5e835a582 = /* #__PURE__ */ function() {
    function ThunkSlot(value0) {
        this.value0 = value0;
    }
    ThunkSlot.create = function(value0) {
        return new ThunkSlot(value0);
    };
    return ThunkSlot;
}();
var $eea39ea934373596$export$48f0293959eb16ec = $ac8b3532514ac019$export$401372c57776dc;
var $eea39ea934373596$export$802c6b8ce0f42195 = $ac8b3532514ac019$export$401372c57776dc;
var $eea39ea934373596$export$9eef9effff68b10a = function(args) {
    return function(v) {
        if (v instanceof $43c0c9babefbb793$export$b03b1c699c90a9b4) return $eea39ea934373596$var$voidLeft($eea39ea934373596$var$traverse_(args.handleAction)(args.initialize))(v.value0);
        if (v instanceof $43c0c9babefbb793$export$29defdae7b3f3a01) return $eea39ea934373596$var$voidLeft($eea39ea934373596$var$traverse_(args.handleAction)(args.finalize))(v.value0);
        if (v instanceof $43c0c9babefbb793$export$fc713a64b8ca1b7a) return $eea39ea934373596$var$voidLeft($eea39ea934373596$var$traverse_(args.handleAction)(args.receive(v.value0)))(v.value1);
        if (v instanceof $43c0c9babefbb793$export$e19cd5f9376f8cee) return $eea39ea934373596$var$voidLeft(args.handleAction(v.value0))(v.value1);
        if (v instanceof $43c0c9babefbb793$export$62297b13309008b2) return $026fde5446dd624a$export$1088317934ed5679(function(g) {
            var $45 = $eea39ea934373596$var$map($06733ae99ed4f534$export$f8b8b9ce72e9ccbf(v.value1($05149ea687d6b460$export$523c0b569236b342))(g));
            return function($46) {
                return $45(args.handleQuery($46));
            };
        })(v.value0);
        throw new Error("Failed pattern match at Halogen.Component (line 182, column 15 - line 192, column 71): " + [
            v.constructor.name
        ]);
    };
};
var $eea39ea934373596$export$89c807d7ece13702 = $ac8b3532514ac019$export$401372c57776dc;
var $eea39ea934373596$export$3bb93a8213d3ef21 = $ac8b3532514ac019$export$401372c57776dc;
var $eea39ea934373596$export$6294a7576a4b06c3 = function(dictFunctor) {
    return function(nat) {
        return function(v) {
            if (v instanceof $eea39ea934373596$export$bbf8b056cc92e88d) return $eea39ea934373596$export$48f0293959eb16ec(function(slot) {
                return new $eea39ea934373596$export$bbf8b056cc92e88d($eea39ea934373596$export$89c807d7ece13702({
                    get: slot.get,
                    pop: slot.pop,
                    set: slot.set,
                    input: slot.input,
                    output: slot.output,
                    component: $eea39ea934373596$export$b2cccb4e0928a3a6(dictFunctor)(nat)(slot.component)
                }));
            })(v.value0);
            if (v instanceof $eea39ea934373596$export$5e46cfa5e835a582) return new $eea39ea934373596$export$5e46cfa5e835a582($f1bf345cdb6c789d$export$b2cccb4e0928a3a6($eea39ea934373596$var$lmap($eea39ea934373596$export$6294a7576a4b06c3(dictFunctor)(nat)))(v.value0));
            throw new Error("Failed pattern match at Halogen.Component (line 279, column 17 - line 284, column 53): " + [
                v.constructor.name
            ]);
        };
    };
};
var $eea39ea934373596$export$b2cccb4e0928a3a6 = function(dictFunctor) {
    var hoist1 = $84222ab19bdc98bd$export$b2cccb4e0928a3a6(dictFunctor);
    return function(nat) {
        return $eea39ea934373596$export$802c6b8ce0f42195(function(c) {
            return $eea39ea934373596$export$3bb93a8213d3ef21({
                initialState: c.initialState,
                render: function() {
                    var $47 = $eea39ea934373596$var$lmap($eea39ea934373596$export$6294a7576a4b06c3(dictFunctor)(nat));
                    return function($48) {
                        return $47(c.render($48));
                    };
                }(),
                "eval": function() {
                    var $49 = hoist1(nat);
                    return function($50) {
                        return $49(c["eval"]($50));
                    };
                }()
            });
        });
    };
};
var $eea39ea934373596$export$ed5606d1e76f4b8b = {
    map: function(f) {
        return $eea39ea934373596$export$48f0293959eb16ec(function(slot) {
            return $eea39ea934373596$export$89c807d7ece13702({
                get: slot.get,
                pop: slot.pop,
                set: slot.set,
                component: slot.component,
                input: slot.input,
                output: $eea39ea934373596$var$map1($eea39ea934373596$var$map2(f))(slot.output)
            });
        });
    }
};
var $eea39ea934373596$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($eea39ea934373596$export$ed5606d1e76f4b8b);
var $eea39ea934373596$export$e299aa0f47209936 = {
    map: function(f) {
        return function(v) {
            if (v instanceof $eea39ea934373596$export$bbf8b056cc92e88d) return new $eea39ea934373596$export$bbf8b056cc92e88d($eea39ea934373596$var$map3(f)(v.value0));
            if (v instanceof $eea39ea934373596$export$5e46cfa5e835a582) return new $eea39ea934373596$export$5e46cfa5e835a582($f1bf345cdb6c789d$export$ad7ceecc341abc7e($eea39ea934373596$var$bimap($f4b2eb11fc32ed34$export$871de8747c9eaa88($eea39ea934373596$export$e299aa0f47209936)(f))(f))(v.value0));
            throw new Error("Failed pattern match at Halogen.Component (line 209, column 11 - line 211, column 74): " + [
                v.constructor.name
            ]);
        };
    }
};
var $eea39ea934373596$export$cb95887a94082d64 = /* #__PURE__ */ function() {
    return {
        handleAction: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($eea39ea934373596$var$pure($05149ea687d6b460$export$523c0b569236b342)),
        handleQuery: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($eea39ea934373596$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value)),
        receive: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value),
        initialize: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        finalize: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
}();
var $eea39ea934373596$export$f7e7e2efed606f4a = function() {
    return function(dictIsSymbol) {
        var lookup1 = $eea39ea934373596$var$lookup(dictIsSymbol);
        var pop1 = $eea39ea934373596$var$pop(dictIsSymbol);
        var insert1 = $eea39ea934373596$var$insert(dictIsSymbol);
        return function(dictOrd) {
            var lookup2 = lookup1(dictOrd);
            var pop2 = pop1(dictOrd);
            var insert2 = insert1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(comp) {
                        return function(input) {
                            return function(output) {
                                return $eea39ea934373596$export$89c807d7ece13702({
                                    get: lookup2(label)(p),
                                    pop: pop2(label)(p),
                                    set: insert2(label)(p),
                                    component: comp,
                                    input: input,
                                    output: output
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};



// Generated by purs version 0.15.15




var $e5b7e89a68d9c456$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $e5b7e89a68d9c456$export$f4752d802d3c730b = function(ctor) {
    return function(children) {
        var v = ctor([]);
        if (v instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return new $bef4063d6d8fe507$export$bade370ab89110b(v.value0, v.value1, v.value2, children);
        return v;
    };
};
var $e5b7e89a68d9c456$export$f691a8759658f782 = function(ctor) {
    return function(props) {
        return function(children) {
            var v = ctor(props)([]);
            if (v instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return new $bef4063d6d8fe507$export$bade370ab89110b(v.value0, v.value1, v.value2, children);
            return v;
        };
    };
};
var $e5b7e89a68d9c456$export$8a24d5472c669cc1 = function($14) {
    return $c959b62ce0c19dfe$export$8dbf9c790527241e($e5b7e89a68d9c456$var$pure($14));
};
var $e5b7e89a68d9c456$export$8dbf9c790527241e = /* #__PURE__ */ function() {
    return $c959b62ce0c19dfe$export$8dbf9c790527241e($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $e5b7e89a68d9c456$export$cba2bb7f1b8927c4 = function($15) {
    return $c959b62ce0c19dfe$export$8454457683f90105($e5b7e89a68d9c456$var$pure($15));
};
var $e5b7e89a68d9c456$export$8454457683f90105 = /* #__PURE__ */ function() {
    return $c959b62ce0c19dfe$export$8454457683f90105($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $e5b7e89a68d9c456$export$c63c6f932822f543 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("em");
var $e5b7e89a68d9c456$export$a5c38c2752f1223a = /* #__PURE__ */ $e5b7e89a68d9c456$export$c63c6f932822f543([]);
var $e5b7e89a68d9c456$export$2be46bb7e96db87f = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("embed");
var $e5b7e89a68d9c456$export$b53e7b77250f04f9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2be46bb7e96db87f([]);
var $e5b7e89a68d9c456$export$a38812d1aa1302d9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("fieldset");
var $e5b7e89a68d9c456$export$2dc1b8d0924efe56 = /* #__PURE__ */ $e5b7e89a68d9c456$export$a38812d1aa1302d9([]);
var $e5b7e89a68d9c456$export$b75acb72a9c69c26 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("figcaption");
var $e5b7e89a68d9c456$export$60dfbef68b872a19 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b75acb72a9c69c26([]);
var $e5b7e89a68d9c456$export$991dc94f816a1d48 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("figure");
var $e5b7e89a68d9c456$export$e3500458218031e0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$991dc94f816a1d48([]);
var $e5b7e89a68d9c456$export$adb608be33961c98 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("footer");
var $e5b7e89a68d9c456$export$70a8ff4564bfd029 = /* #__PURE__ */ $e5b7e89a68d9c456$export$adb608be33961c98([]);
var $e5b7e89a68d9c456$export$6210fa4921d2a466 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("form");
var $e5b7e89a68d9c456$export$1df82cba65ddbdc7 = /* #__PURE__ */ $e5b7e89a68d9c456$export$6210fa4921d2a466([]);
var $e5b7e89a68d9c456$export$448e4850cad7c7b0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h1");
var $e5b7e89a68d9c456$export$762b01c17cd5ef84 = /* #__PURE__ */ $e5b7e89a68d9c456$export$448e4850cad7c7b0([]);
var $e5b7e89a68d9c456$export$a943aa9a0fca3f0b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h2");
var $e5b7e89a68d9c456$export$fb9cd428790d91ac = /* #__PURE__ */ $e5b7e89a68d9c456$export$a943aa9a0fca3f0b([]);
var $e5b7e89a68d9c456$export$7edd4a21fac8ce55 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h3");
var $e5b7e89a68d9c456$export$d3f2bf86163ce5b1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$7edd4a21fac8ce55([]);
var $e5b7e89a68d9c456$export$51a85cc1b68f452c = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h4");
var $e5b7e89a68d9c456$export$44266b9d6c80e925 = /* #__PURE__ */ $e5b7e89a68d9c456$export$51a85cc1b68f452c([]);
var $e5b7e89a68d9c456$export$f44841a11990acb2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h5");
var $e5b7e89a68d9c456$export$29e7034271223ef2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f44841a11990acb2([]);
var $e5b7e89a68d9c456$export$c9ccd321d64f47e3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h6");
var $e5b7e89a68d9c456$export$454ef0c5c33a2870 = /* #__PURE__ */ $e5b7e89a68d9c456$export$c9ccd321d64f47e3([]);
var $e5b7e89a68d9c456$export$5fd5031fecdacec3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("head");
var $e5b7e89a68d9c456$export$1139b773e3687c26 = /* #__PURE__ */ $e5b7e89a68d9c456$export$5fd5031fecdacec3([]);
var $e5b7e89a68d9c456$export$38e42c68cf43b5d4 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("header");
var $e5b7e89a68d9c456$export$8bf7349458487350 = /* #__PURE__ */ $e5b7e89a68d9c456$export$38e42c68cf43b5d4([]);
var $e5b7e89a68d9c456$export$b4adb3f464574dcf = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("hr")(props)([]);
};
var $e5b7e89a68d9c456$export$d5ef68f9e25856a2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b4adb3f464574dcf([]);
var $e5b7e89a68d9c456$export$c0bb0b647f701bb5 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("html");
var $e5b7e89a68d9c456$export$435678c2016b20e2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$c0bb0b647f701bb5([]);
var $e5b7e89a68d9c456$export$23f2a1d2818174ef = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("i");
var $e5b7e89a68d9c456$export$3d4cba5f342e903e = /* #__PURE__ */ $e5b7e89a68d9c456$export$23f2a1d2818174ef([]);
var $e5b7e89a68d9c456$export$8cde213409fd6377 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("iframe")(props)([]);
};
var $e5b7e89a68d9c456$export$463b44d9bf3628be = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("img")(props)([]);
};
var $e5b7e89a68d9c456$export$b7e3ae3d7c15e42e = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("input")(props)([]);
};
var $e5b7e89a68d9c456$export$27a48efc044c200a = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ins");
var $e5b7e89a68d9c456$export$be13014404ffcf2b = /* #__PURE__ */ $e5b7e89a68d9c456$export$27a48efc044c200a([]);
var $e5b7e89a68d9c456$export$1ed45b69d23c052b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("kbd");
var $e5b7e89a68d9c456$export$4a6534c938817498 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1ed45b69d23c052b([]);
var $e5b7e89a68d9c456$export$1237798dc640739a = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("label");
var $e5b7e89a68d9c456$export$71f1ceb3290c95d7 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1237798dc640739a([]);
var $e5b7e89a68d9c456$export$9a9b59e08de24cef = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("legend");
var $e5b7e89a68d9c456$export$d57b7c1bdf9a3bfc = /* #__PURE__ */ $e5b7e89a68d9c456$export$9a9b59e08de24cef([]);
var $e5b7e89a68d9c456$export$19caeaf7d9d84644 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("li");
var $e5b7e89a68d9c456$export$867ad32b190d58af = /* #__PURE__ */ $e5b7e89a68d9c456$export$19caeaf7d9d84644([]);
var $e5b7e89a68d9c456$export$9c30223ca0a664fb = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("link")(props)([]);
};
var $e5b7e89a68d9c456$export$f22da7240b7add18 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("main");
var $e5b7e89a68d9c456$export$88d8d81b07aa78ac = /* #__PURE__ */ $e5b7e89a68d9c456$export$f22da7240b7add18([]);
var $e5b7e89a68d9c456$export$871de8747c9eaa88 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("map");
var $e5b7e89a68d9c456$export$aca8cce159e578de = /* #__PURE__ */ $e5b7e89a68d9c456$export$871de8747c9eaa88([]);
var $e5b7e89a68d9c456$export$bf7f2fce5c1cf636 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("mark");
var $e5b7e89a68d9c456$export$8e88f701cd5c1522 = /* #__PURE__ */ $e5b7e89a68d9c456$export$bf7f2fce5c1cf636([]);
var $e5b7e89a68d9c456$export$b1e5508a851be14d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("menu");
var $e5b7e89a68d9c456$export$d18229b57986002 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b1e5508a851be14d([]);
var $e5b7e89a68d9c456$export$f68e44d881264486 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("menuitem");
var $e5b7e89a68d9c456$export$e25e9f3e172962c6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f68e44d881264486([]);
var $e5b7e89a68d9c456$export$6990040ee07315 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("meta")(props)([]);
};
var $e5b7e89a68d9c456$export$82334bbdfcebb57 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("meter");
var $e5b7e89a68d9c456$export$86fa78168c2ac21a = /* #__PURE__ */ $e5b7e89a68d9c456$export$82334bbdfcebb57([]);
var $e5b7e89a68d9c456$export$80e4b313e5e6b30d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("nav");
var $e5b7e89a68d9c456$export$5c8b9c326353f574 = /* #__PURE__ */ $e5b7e89a68d9c456$export$80e4b313e5e6b30d([]);
var $e5b7e89a68d9c456$export$528ba0e6da49e146 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("noscript");
var $e5b7e89a68d9c456$export$6d2a3f75abf3cf2f = /* #__PURE__ */ $e5b7e89a68d9c456$export$528ba0e6da49e146([]);
var $e5b7e89a68d9c456$export$be5493f9613cbbe = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("object");
var $e5b7e89a68d9c456$export$5486b676036981c0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$be5493f9613cbbe([]);
var $e5b7e89a68d9c456$export$b2235297ee22a6fe = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ol");
var $e5b7e89a68d9c456$export$ccd58f56d982d30 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b2235297ee22a6fe([]);
var $e5b7e89a68d9c456$export$b9d336f245a516e8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("optgroup");
var $e5b7e89a68d9c456$export$5e41220970d85779 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b9d336f245a516e8([]);
var $e5b7e89a68d9c456$export$a75d1723e6bda2ec = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("option");
var $e5b7e89a68d9c456$export$32e31af4e5fb3144 = /* #__PURE__ */ $e5b7e89a68d9c456$export$a75d1723e6bda2ec([]);
var $e5b7e89a68d9c456$export$c789db2c85949867 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("output");
var $e5b7e89a68d9c456$export$8874a395de964196 = /* #__PURE__ */ $e5b7e89a68d9c456$export$c789db2c85949867([]);
var $e5b7e89a68d9c456$export$ffb5f4729a158638 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("p");
var $e5b7e89a68d9c456$export$3950a0ab4293f4c0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$ffb5f4729a158638([]);
var $e5b7e89a68d9c456$export$6f7d1d9d04558207 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("param")(props)([]);
};
var $e5b7e89a68d9c456$export$2af2ac64526e2aa9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("pre");
var $e5b7e89a68d9c456$export$40eb7481a9b1d565 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2af2ac64526e2aa9([]);
var $e5b7e89a68d9c456$export$504d7abb21fa8c9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("progress");
var $e5b7e89a68d9c456$export$c56c869b2fd24a27 = /* #__PURE__ */ $e5b7e89a68d9c456$export$504d7abb21fa8c9([]);
var $e5b7e89a68d9c456$export$9e5f44173e64f162 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("q");
var $e5b7e89a68d9c456$export$cfeebac18d15c854 = /* #__PURE__ */ $e5b7e89a68d9c456$export$9e5f44173e64f162([]);
var $e5b7e89a68d9c456$export$6d4c73e3ddf8818b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("rp");
var $e5b7e89a68d9c456$export$16adec6ab929083f = /* #__PURE__ */ $e5b7e89a68d9c456$export$6d4c73e3ddf8818b([]);
var $e5b7e89a68d9c456$export$f08282231bb71285 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("rt");
var $e5b7e89a68d9c456$export$512c1f41f1ce606b = /* #__PURE__ */ $e5b7e89a68d9c456$export$f08282231bb71285([]);
var $e5b7e89a68d9c456$export$f2b283820b448b35 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ruby");
var $e5b7e89a68d9c456$export$8e70c3d96e82daa8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f2b283820b448b35([]);
var $e5b7e89a68d9c456$export$8c1cb8fb6818c292 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("samp");
var $e5b7e89a68d9c456$export$6d135438f4b2f058 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8c1cb8fb6818c292([]);
var $e5b7e89a68d9c456$export$bc237d627614fc48 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("script");
var $e5b7e89a68d9c456$export$dc29c33250ef6a12 = /* #__PURE__ */ $e5b7e89a68d9c456$export$bc237d627614fc48([]);
var $e5b7e89a68d9c456$export$fe2e36411d703b3d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("section");
var $e5b7e89a68d9c456$export$23973f3de41ad862 = /* #__PURE__ */ $e5b7e89a68d9c456$export$fe2e36411d703b3d([]);
var $e5b7e89a68d9c456$export$2e6c959c16ff56b8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("select");
var $e5b7e89a68d9c456$export$626530082bbb6846 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2e6c959c16ff56b8([]);
var $e5b7e89a68d9c456$export$3c17b0e969a90510 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("small");
var $e5b7e89a68d9c456$export$7c956911267b1bca = /* #__PURE__ */ $e5b7e89a68d9c456$export$3c17b0e969a90510([]);
var $e5b7e89a68d9c456$export$b4d5da5f34fb77ad = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("source")(props)([]);
};
var $e5b7e89a68d9c456$export$afc1bfabebaf28a2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("span");
var $e5b7e89a68d9c456$export$727654ffe296bd78 = /* #__PURE__ */ $e5b7e89a68d9c456$export$afc1bfabebaf28a2([]);
var $e5b7e89a68d9c456$export$59ae2c325a998f89 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("strong");
var $e5b7e89a68d9c456$export$e4a9f9f4befb34d3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$59ae2c325a998f89([]);
var $e5b7e89a68d9c456$export$1d567c320f4763bc = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("style");
var $e5b7e89a68d9c456$export$91f114121fd8ef96 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1d567c320f4763bc([]);
var $e5b7e89a68d9c456$export$f93b5905241a7cca = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("sub");
var $e5b7e89a68d9c456$export$1b578d76e1a8b229 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f93b5905241a7cca([]);
var $e5b7e89a68d9c456$export$9a2dbef7a17e2e58 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("summary");
var $e5b7e89a68d9c456$export$2107ebccf1a0ff3d = /* #__PURE__ */ $e5b7e89a68d9c456$export$9a2dbef7a17e2e58([]);
var $e5b7e89a68d9c456$export$abe1cd54efe9b9cd = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("sup");
var $e5b7e89a68d9c456$export$2ed99a076908dcca = /* #__PURE__ */ $e5b7e89a68d9c456$export$abe1cd54efe9b9cd([]);
var $e5b7e89a68d9c456$export$9852986a3ec5f6a0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("table");
var $e5b7e89a68d9c456$export$67d0d859a50d84a3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$9852986a3ec5f6a0([]);
var $e5b7e89a68d9c456$export$7cdd536eaa8f163c = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("tbody");
var $e5b7e89a68d9c456$export$a78509387f11524c = /* #__PURE__ */ $e5b7e89a68d9c456$export$7cdd536eaa8f163c([]);
var $e5b7e89a68d9c456$export$2beef8af2014e5c6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("td");
var $e5b7e89a68d9c456$export$bf83c8517c04b4f6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2beef8af2014e5c6([]);
var $e5b7e89a68d9c456$export$a3574df893ffa88d = function(es) {
    return $e5b7e89a68d9c456$export$8454457683f90105("textarea")(es)([]);
};
var $e5b7e89a68d9c456$export$9396b2f97a03ad14 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("tfoot");
var $e5b7e89a68d9c456$export$7f741d66040a80c8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$9396b2f97a03ad14([]);
var $e5b7e89a68d9c456$export$d657bc098992a431 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("th");
var $e5b7e89a68d9c456$export$5e18a33d145a9a4c = /* #__PURE__ */ $e5b7e89a68d9c456$export$d657bc098992a431([]);
var $e5b7e89a68d9c456$export$e3f32a5920890b82 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("thead");
var $e5b7e89a68d9c456$export$e607565248beba15 = /* #__PURE__ */ $e5b7e89a68d9c456$export$e3f32a5920890b82([]);
var $e5b7e89a68d9c456$export$2da9be4cfdb689b1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("time");
var $e5b7e89a68d9c456$export$cf828072303f47a1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2da9be4cfdb689b1([]);
var $e5b7e89a68d9c456$export$fb184b623420d9be = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("title");
var $e5b7e89a68d9c456$export$913d7d8b8f172930 = /* #__PURE__ */ $e5b7e89a68d9c456$export$fb184b623420d9be([]);
var $e5b7e89a68d9c456$export$72451b88a72ad9c2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("tr");
var $e5b7e89a68d9c456$export$6645783692722b88 = /* #__PURE__ */ $e5b7e89a68d9c456$export$72451b88a72ad9c2([]);
var $e5b7e89a68d9c456$export$6b2a7d5132615086 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("track")(props)([]);
};
var $e5b7e89a68d9c456$export$3b14a55fb2447963 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("u");
var $e5b7e89a68d9c456$export$cea9ae7324478a0a = /* #__PURE__ */ $e5b7e89a68d9c456$export$3b14a55fb2447963([]);
var $e5b7e89a68d9c456$export$b5023c870cb34848 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ul");
var $e5b7e89a68d9c456$export$995bef5d59d32608 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b5023c870cb34848([]);
var $e5b7e89a68d9c456$export$4732baac96d948aa = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("var");
var $e5b7e89a68d9c456$export$f6567ad6eb928d58 = /* #__PURE__ */ $e5b7e89a68d9c456$export$4732baac96d948aa([]);
var $e5b7e89a68d9c456$export$5f8d3589eb8441ca = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("video");
var $e5b7e89a68d9c456$export$aeb4f4e4f36fb9d9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$5f8d3589eb8441ca([]);
var $e5b7e89a68d9c456$export$ee8f8f9447a35bdc = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("wbr")(props)([]);
};
var $e5b7e89a68d9c456$export$9198f9466fc833e = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dt");
var $e5b7e89a68d9c456$export$eaec8774df2ce75c = /* #__PURE__ */ $e5b7e89a68d9c456$export$9198f9466fc833e([]);
var $e5b7e89a68d9c456$export$53d26b7a9a23d594 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dl");
var $e5b7e89a68d9c456$export$e8817a08353617fb = /* #__PURE__ */ $e5b7e89a68d9c456$export$53d26b7a9a23d594([]);
var $e5b7e89a68d9c456$export$159d9494db57879b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("div");
var $e5b7e89a68d9c456$export$3327f90baeaa2cb3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$159d9494db57879b([]);
var $e5b7e89a68d9c456$export$518824cf31321346 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dialog");
var $e5b7e89a68d9c456$export$95cd7f04cb5b4aa5 = /* #__PURE__ */ $e5b7e89a68d9c456$export$518824cf31321346([]);
var $e5b7e89a68d9c456$export$771f54d1a902afc9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dfn");
var $e5b7e89a68d9c456$export$afe13c5e7d9b4a7 = /* #__PURE__ */ $e5b7e89a68d9c456$export$771f54d1a902afc9([]);
var $e5b7e89a68d9c456$export$41ee12f6f6f05843 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("details");
var $e5b7e89a68d9c456$export$a47bcbad56ffd401 = /* #__PURE__ */ $e5b7e89a68d9c456$export$41ee12f6f6f05843([]);
var $e5b7e89a68d9c456$export$1d2f21e549771e67 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("del");
var $e5b7e89a68d9c456$export$965d9e1c56547986 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1d2f21e549771e67([]);
var $e5b7e89a68d9c456$export$eaaeafa904fe3ddf = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dd");
var $e5b7e89a68d9c456$export$333318a39958213e = /* #__PURE__ */ $e5b7e89a68d9c456$export$eaaeafa904fe3ddf([]);
var $e5b7e89a68d9c456$export$d6956b5f6d5ee87d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("datalist");
var $e5b7e89a68d9c456$export$4479caebc8699400 = /* #__PURE__ */ $e5b7e89a68d9c456$export$d6956b5f6d5ee87d([]);
var $e5b7e89a68d9c456$export$ae50443ffc990749 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("command")(props)([]);
};
var $e5b7e89a68d9c456$export$3db318dd257cd653 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("colgroup");
var $e5b7e89a68d9c456$export$4d89c25fc3dc3ce6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$3db318dd257cd653([]);
var $e5b7e89a68d9c456$export$aba86695643891f5 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("col")(props)([]);
};
var $e5b7e89a68d9c456$export$6565f9f03506010b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("code");
var $e5b7e89a68d9c456$export$a82e8ec18d45f1e3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$6565f9f03506010b([]);
var $e5b7e89a68d9c456$export$3035df57df42c31a = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("cite");
var $e5b7e89a68d9c456$export$4371c8153c03edbd = /* #__PURE__ */ $e5b7e89a68d9c456$export$3035df57df42c31a([]);
var $e5b7e89a68d9c456$export$8e3c2dfdc4f0453d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("caption");
var $e5b7e89a68d9c456$export$63f9754c9b1fac36 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8e3c2dfdc4f0453d([]);
var $e5b7e89a68d9c456$export$67ea982130081db = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("canvas")(props)([]);
};
var $e5b7e89a68d9c456$export$2ba01fb71ed41cb6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("button");
var $e5b7e89a68d9c456$export$ff362f92cc25e36a = /* #__PURE__ */ $e5b7e89a68d9c456$export$2ba01fb71ed41cb6([]);
var $e5b7e89a68d9c456$export$479ac0420f53ed26 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("br")(props)([]);
};
var $e5b7e89a68d9c456$export$73cdcb65e5517a4b = /* #__PURE__ */ $e5b7e89a68d9c456$export$479ac0420f53ed26([]);
var $e5b7e89a68d9c456$export$32180ef41b15b513 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("body");
var $e5b7e89a68d9c456$export$72fbd758d159fe4b = /* #__PURE__ */ $e5b7e89a68d9c456$export$32180ef41b15b513([]);
var $e5b7e89a68d9c456$export$67dc04e652a298ca = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("blockquote");
var $e5b7e89a68d9c456$export$3b176ffafe2ecb0b = /* #__PURE__ */ $e5b7e89a68d9c456$export$67dc04e652a298ca([]);
var $e5b7e89a68d9c456$export$fae0db89ef70aab2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("bdo");
var $e5b7e89a68d9c456$export$e57ac2b1cb1a62e1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$fae0db89ef70aab2([]);
var $e5b7e89a68d9c456$export$2d20a4e9df674436 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("bdi");
var $e5b7e89a68d9c456$export$f5459c7588d93378 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2d20a4e9df674436([]);
var $e5b7e89a68d9c456$export$e2253033e6e1df16 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("base")(props)([]);
};
var $e5b7e89a68d9c456$export$8b22cf2602fb60ce = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("b");
var $e5b7e89a68d9c456$export$c69d65aa55814164 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8b22cf2602fb60ce([]);
var $e5b7e89a68d9c456$export$592b77e6034db746 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("audio");
var $e5b7e89a68d9c456$export$610b618347792e57 = /* #__PURE__ */ $e5b7e89a68d9c456$export$592b77e6034db746([]);
var $e5b7e89a68d9c456$export$64a02cd6422b91be = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("aside");
var $e5b7e89a68d9c456$export$a3ab01131aa7ecca = /* #__PURE__ */ $e5b7e89a68d9c456$export$64a02cd6422b91be([]);
var $e5b7e89a68d9c456$export$bba2aacf8566461b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("article");
var $e5b7e89a68d9c456$export$1cb8fa25968bee4e = /* #__PURE__ */ $e5b7e89a68d9c456$export$bba2aacf8566461b([]);
var $e5b7e89a68d9c456$export$bb3edc44842b5f2e = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("area")(props)([]);
};
var $e5b7e89a68d9c456$export$f7d3c097ceca6c15 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("address");
var $e5b7e89a68d9c456$export$acfbe12b190f4a67 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f7d3c097ceca6c15([]);
var $e5b7e89a68d9c456$export$2bcb785951133fe5 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("abbr");
var $e5b7e89a68d9c456$export$b4f279e367d2ba24 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2bcb785951133fe5([]);
var $e5b7e89a68d9c456$export$407448d2b89b1813 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("a");
var $e5b7e89a68d9c456$export$a17c37559e1db147 = /* #__PURE__ */ $e5b7e89a68d9c456$export$407448d2b89b1813([]);


// Generated by purs version 0.15.15















// Generated by purs version 0.15.15
var $5253348ec4f02e0c$export$9b6706c8686cfc8e = "paste";
var $5253348ec4f02e0c$export$af2a99f971a346e6 = "cut";
var $5253348ec4f02e0c$export$784d13d8ee351f07 = "copy";
var $5253348ec4f02e0c$export$82e583f9eee21106 = "clipboardchange";


// Generated by purs version 0.15.15
function $669be0b5ad323ff1$export$a0e54c3daa7db493(e) {
    return e.bubbles;
}
function $669be0b5ad323ff1$export$95ff25b64c2b7c9d(e) {
    return e.cancelable;
}
function $669be0b5ad323ff1$export$c2cb7a6607e209d9(e) {
    return e.currentTarget;
}
function $669be0b5ad323ff1$export$6add31d873bb7f97(e) {
    return function() {
        return e.defaultPrevented;
    };
}
function $669be0b5ad323ff1$export$751396ee394cb35f(e) {
    return e.eventPhase;
}
function $669be0b5ad323ff1$export$e2c9f5456eee864(e) {
    return e.target;
}
function $669be0b5ad323ff1$export$c0dbb1ea68a069d3(e) {
    return e.timeStamp;
}
function $669be0b5ad323ff1$export$d4a6a4db5b31e621(e) {
    return e.type;
}
function $669be0b5ad323ff1$export$fa3b29edae795ef4(e) {
    return function() {
        return e.preventDefault();
    };
}
function $669be0b5ad323ff1$export$d5cb5f1c8a62fdf1(e) {
    return function() {
        return e.stopImmediatePropagation();
    };
}
function $669be0b5ad323ff1$export$51134cce184326b9(e) {
    return function() {
        return e.stopPropagation();
    };
}







// Generated by purs version 0.15.15



var $4cea5a089b994203$export$57ca7e07b341709d = /* #__PURE__ */ function() {
    function None() {}
    None.value = new None();
    return None;
}();
var $4cea5a089b994203$export$7c1f271456e9da5c = /* #__PURE__ */ function() {
    function Capturing() {}
    Capturing.value = new Capturing();
    return Capturing;
}();
var $4cea5a089b994203$export$c9dfa296ffa718f3 = /* #__PURE__ */ function() {
    function AtTarget() {}
    AtTarget.value = new AtTarget();
    return AtTarget;
}();
var $4cea5a089b994203$export$afda6610fd3be704 = /* #__PURE__ */ function() {
    function Bubbling() {}
    Bubbling.value = new Bubbling();
    return Bubbling;
}();
var $4cea5a089b994203$export$87e393cb260cfe35 = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($4cea5a089b994203$export$57ca7e07b341709d.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($4cea5a089b994203$export$7c1f271456e9da5c.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($4cea5a089b994203$export$c9dfa296ffa718f3.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($4cea5a089b994203$export$afda6610fd3be704.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $4cea5a089b994203$export$bf52d9629dd54342 = function(v) {
    if (v instanceof $4cea5a089b994203$export$57ca7e07b341709d) return 0;
    if (v instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return 1;
    if (v instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return 2;
    if (v instanceof $4cea5a089b994203$export$afda6610fd3be704) return 3;
    throw new Error("Failed pattern match at Web.Event.EventPhase (line 40, column 3 - line 44, column 18): " + [
        v.constructor.name
    ]);
};
var $4cea5a089b994203$export$e7849b249d968c7d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $4cea5a089b994203$export$57ca7e07b341709d && y instanceof $4cea5a089b994203$export$57ca7e07b341709d) return true;
            if (x instanceof $4cea5a089b994203$export$7c1f271456e9da5c && y instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return true;
            if (x instanceof $4cea5a089b994203$export$c9dfa296ffa718f3 && y instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return true;
            if (x instanceof $4cea5a089b994203$export$afda6610fd3be704 && y instanceof $4cea5a089b994203$export$afda6610fd3be704) return true;
            return false;
        };
    }
};
var $4cea5a089b994203$export$2dff6326408f563 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $4cea5a089b994203$export$57ca7e07b341709d && y instanceof $4cea5a089b994203$export$57ca7e07b341709d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4cea5a089b994203$export$57ca7e07b341709d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4cea5a089b994203$export$57ca7e07b341709d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4cea5a089b994203$export$7c1f271456e9da5c && y instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4cea5a089b994203$export$c9dfa296ffa718f3 && y instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4cea5a089b994203$export$afda6610fd3be704 && y instanceof $4cea5a089b994203$export$afda6610fd3be704) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.Event.EventPhase (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $4cea5a089b994203$export$e7849b249d968c7d;
    }
};
var $4cea5a089b994203$export$1961ce3762a1f623 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($4cea5a089b994203$export$87e393cb260cfe35)($4cea5a089b994203$export$bf52d9629dd54342),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($4cea5a089b994203$export$87e393cb260cfe35)($4cea5a089b994203$export$bf52d9629dd54342),
    Ord0: function() {
        return $4cea5a089b994203$export$2dff6326408f563;
    }
};
var $4cea5a089b994203$export$2c5501f89051a84e = /* #__PURE__ */ function() {
    return {
        bottom: $4cea5a089b994203$export$57ca7e07b341709d.value,
        top: $4cea5a089b994203$export$afda6610fd3be704.value,
        Ord0: function() {
            return $4cea5a089b994203$export$2dff6326408f563;
        }
    };
}();
var $4cea5a089b994203$export$9171e0cf0644640e = {
    cardinality: 4,
    toEnum: $4cea5a089b994203$export$87e393cb260cfe35,
    fromEnum: $4cea5a089b994203$export$bf52d9629dd54342,
    Bounded0: function() {
        return $4cea5a089b994203$export$2c5501f89051a84e;
    },
    Enum1: function() {
        return $4cea5a089b994203$export$1961ce3762a1f623;
    }
};



var $2829090ac282514c$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $2829090ac282514c$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($4cea5a089b994203$export$9171e0cf0644640e);
var $2829090ac282514c$export$3d7865934588d77e = function(x) {
    return x;
};
var $2829090ac282514c$export$44271b4f0c6a3563 = function($3) {
    return $0a5aaf95f168428e$export$1ba013b88f4f21f3($669be0b5ad323ff1$export$e2c9f5456eee864($3));
};
var $2829090ac282514c$export$5c9c459b1e542b91 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $2829090ac282514c$export$bbde49cc37df068e = {
    Coercible0: function() {
        return undefined;
    }
};
var $2829090ac282514c$export$adaf9bfc2029072d = function() {
    return function($4) {
        return $2829090ac282514c$var$fromJust($2829090ac282514c$var$toEnum($669be0b5ad323ff1$export$751396ee394cb35f($4)));
    };
};
var $2829090ac282514c$export$521449dd33bc9b79 = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $2829090ac282514c$export$28b27b1605aa05ad = function($5) {
    return $0a5aaf95f168428e$export$1ba013b88f4f21f3($669be0b5ad323ff1$export$c2cb7a6607e209d9($5));
};


// Generated by purs version 0.15.15
function $837e6eb387618e21$export$f24224f1c91d8156(fileList) {
    return fileList.length;
}
function $837e6eb387618e21$export$613ce04884e90507(index) {
    return function(fileList) {
        return fileList.item(index);
    };
}








var $520c7508336e9c23$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $520c7508336e9c23$export$7061c75fc5af8b7e = function(i) {
    var $5 = $837e6eb387618e21$export$613ce04884e90507(i);
    return function($6) {
        return $0a5aaf95f168428e$export$1ba013b88f4f21f3($5($6));
    };
};
var $520c7508336e9c23$export$17a1664ed1fb5d6f = function(dictUnfoldable) {
    var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(fl) {
        return unfoldr(function(i) {
            return $520c7508336e9c23$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)(i + 1 | 0))($520c7508336e9c23$export$7061c75fc5af8b7e(i)(fl));
        })(0);
    };
};


// Generated by purs version 0.15.15
var $9ca8e76be04efe86$export$663103110d94aac9 = "drop";
var $9ca8e76be04efe86$export$dc0badfde684823c = "dragstart";
var $9ca8e76be04efe86$export$ced0a5bb82ba6aee = "dragover";
var $9ca8e76be04efe86$export$f58195b0ad38aa36 = "dragleave";
var $9ca8e76be04efe86$export$ddffa9b7b4c3e300 = "dragexit";
var $9ca8e76be04efe86$export$bf1ba5dda238dc20 = "dragenter";
var $9ca8e76be04efe86$export$26ae3c90d367ea9a = "dragend";
var $9ca8e76be04efe86$export$d7d5d435647ed5a0 = "drag";




// Generated by purs version 0.15.15
var $9285e421afbabad0$export$d0dc5134b51e78ad = "focusout";
var $9285e421afbabad0$export$e7fa4ea7f1bfcb53 = "focusin";
var $9285e421afbabad0$export$d7ddd398f22d79ef = "focus";
var $9285e421afbabad0$export$2cc7ff91bcacba5e = "blur";


// Generated by purs version 0.15.15
var $981a0c6551e76cf0$export$d26052c770f81a55 = "keyup";
var $981a0c6551e76cf0$export$e65a0c4970da3025 = "keydown";


// Generated by purs version 0.15.15
var $7868044d3d97cfc5$export$c367b5bd9b361db9 = "mouseup";
var $7868044d3d97cfc5$export$41b161f130dc7f9 = "mouseover";
var $7868044d3d97cfc5$export$c3a736a37c400eb8 = "mouseout";
var $7868044d3d97cfc5$export$6d0a9e0f4f73830a = "mousemove";
var $7868044d3d97cfc5$export$996a190879e3098b = "mouseleave";
var $7868044d3d97cfc5$export$474cd8abd87e2f89 = "mouseenter";
var $7868044d3d97cfc5$export$8b0cb8993e7a9391 = "mousedown";
var $7868044d3d97cfc5$export$efb8dd8d61939266 = "dblclick";
var $7868044d3d97cfc5$export$64ef1bee2b9504c1 = "click";
var $7868044d3d97cfc5$export$2991dd47f111a03b = "auxclick";


// Generated by purs version 0.15.15
var $64b79e1476c3e095$export$d3028820ea014224 = "wheel";


var $10ae9db6658426ac$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $10ae9db6658426ac$var$composeKleisli = /* #__PURE__ */ $70cd3177464e7915$export$61a2047e1b1e0d3e($06733ae99ed4f534$export$e5fea5661dee377);
var $10ae9db6658426ac$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $10ae9db6658426ac$var$readProp = /* #__PURE__ */ $79efcffe70231542$export$d133c026d013828b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $10ae9db6658426ac$var$readString = /* #__PURE__ */ $c97d2d0f578f81ad$export$dda73877cb166cd3($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $10ae9db6658426ac$var$wheelHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$var$touchHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$var$mouseHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$var$keyHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$export$6b8360dd6fa5f18d = function(et) {
    return function(f) {
        return $c959b62ce0c19dfe$export$c3c52e219617878(et)(function(ev) {
            return $10ae9db6658426ac$var$map($969bbf7e7aa55092$export$e19cd5f9376f8cee.create)(f(ev));
        });
    };
};
var $10ae9db6658426ac$export$c3c52e219617878 = function(et) {
    return function(f) {
        return $c959b62ce0c19dfe$export$c3c52e219617878(et)(function(ev) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $969bbf7e7aa55092$export$e19cd5f9376f8cee(f(ev)));
        });
    };
};
var $10ae9db6658426ac$export$d36091e57812e07 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("abort");
var $10ae9db6658426ac$export$81738f2b2c64902d = /* #__PURE__ */ function() {
    var $13 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$2991dd47f111a03b);
    return function($14) {
        return $13($10ae9db6658426ac$var$mouseHandler($14));
    };
}();
var $10ae9db6658426ac$export$bd913411069e59d3 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$d8a7b8f475ec0161);
var $10ae9db6658426ac$export$1d5a917feb871989 = /* #__PURE__ */ function() {
    var $15 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$64ef1bee2b9504c1);
    return function($16) {
        return $15($10ae9db6658426ac$var$mouseHandler($16));
    };
}();
var $10ae9db6658426ac$export$12204e800775a4e0 = /* #__PURE__ */ function() {
    var $17 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$efb8dd8d61939266);
    return function($18) {
        return $17($10ae9db6658426ac$var$mouseHandler($18));
    };
}();
var $10ae9db6658426ac$export$2288787135a8f66e = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$a3bc9b8ed74fc);
var $10ae9db6658426ac$export$83b89249c82cb32b = function(dictUnfoldable) {
    var none = $cb5fedc2c4837e1c$export$f883a24d5edde77c(dictUnfoldable);
    var items = $520c7508336e9c23$export$17a1664ed1fb5d6f(dictUnfoldable);
    return function(f) {
        return $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$d8a7b8f475ec0161)(function() {
            var $19 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(none)(items);
            var $20 = $10ae9db6658426ac$var$composeKleisli($2829090ac282514c$export$44271b4f0c6a3563)($10ae9db6658426ac$var$composeKleisli($dbc3cf4ed216a106$export$a0a0bf09b44710c9)(function($22) {
                return $c02f07bc0f38e9e9$export$c62839628b30a695($dbc3cf4ed216a106$export$3a444357c5f65f65($22));
            }));
            return function($21) {
                return f($19($20($21)));
            };
        }());
    };
};
var $10ae9db6658426ac$export$7fbc06d7c1beb512 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$b7e3ae3d7c15e42e);
var $10ae9db6658426ac$export$ea9576bc99d1b7dd = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$9f85add0327f687e);
var $10ae9db6658426ac$export$de8e1b1372cdb41b = /* #__PURE__ */ function() {
    var $23 = $10ae9db6658426ac$export$c3c52e219617878($981a0c6551e76cf0$export$e65a0c4970da3025);
    return function($24) {
        return $23($10ae9db6658426ac$var$keyHandler($24));
    };
}();
var $10ae9db6658426ac$export$f144bbb6e186b14b = /* #__PURE__ */ function() {
    var $25 = $10ae9db6658426ac$export$c3c52e219617878($981a0c6551e76cf0$export$d26052c770f81a55);
    return function($26) {
        return $25($10ae9db6658426ac$var$keyHandler($26));
    };
}();
var $10ae9db6658426ac$export$4e4d8b287d028b6b = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$11e63f7b0f3d9900);
var $10ae9db6658426ac$export$6b09a96aed3f5178 = /* #__PURE__ */ function() {
    var $27 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$8b0cb8993e7a9391);
    return function($28) {
        return $27($10ae9db6658426ac$var$mouseHandler($28));
    };
}();
var $10ae9db6658426ac$export$7c562fbb06b8dec3 = /* #__PURE__ */ function() {
    var $29 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$474cd8abd87e2f89);
    return function($30) {
        return $29($10ae9db6658426ac$var$mouseHandler($30));
    };
}();
var $10ae9db6658426ac$export$f06e70624327ed63 = /* #__PURE__ */ function() {
    var $31 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$996a190879e3098b);
    return function($32) {
        return $31($10ae9db6658426ac$var$mouseHandler($32));
    };
}();
var $10ae9db6658426ac$export$4e8e585ca96adf5d = /* #__PURE__ */ function() {
    var $33 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$6d0a9e0f4f73830a);
    return function($34) {
        return $33($10ae9db6658426ac$var$mouseHandler($34));
    };
}();
var $10ae9db6658426ac$export$65a11040da641544 = /* #__PURE__ */ function() {
    var $35 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$c3a736a37c400eb8);
    return function($36) {
        return $35($10ae9db6658426ac$var$mouseHandler($36));
    };
}();
var $10ae9db6658426ac$export$afc474fdab5e8a8e = /* #__PURE__ */ function() {
    var $37 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$41b161f130dc7f9);
    return function($38) {
        return $37($10ae9db6658426ac$var$mouseHandler($38));
    };
}();
var $10ae9db6658426ac$export$3df825bff4f0a835 = /* #__PURE__ */ function() {
    var $39 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$c367b5bd9b361db9);
    return function($40) {
        return $39($10ae9db6658426ac$var$mouseHandler($40));
    };
}();
var $10ae9db6658426ac$export$79fcb145cc53473e = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("reset");
var $10ae9db6658426ac$export$45b39e67d4ce4921 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("resize");
var $10ae9db6658426ac$export$d4d89fd61e5416ee = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("scroll");
var $10ae9db6658426ac$export$2cc8197d6ae5570 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$2e6c959c16ff56b8);
var $10ae9db6658426ac$export$307d29742c654737 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("submit");
var $10ae9db6658426ac$export$931f312019b226f2 = /* #__PURE__ */ function() {
    var $41 = $10ae9db6658426ac$export$c3c52e219617878("touchcancel");
    return function($42) {
        return $41($10ae9db6658426ac$var$touchHandler($42));
    };
}();
var $10ae9db6658426ac$export$79b4bc20f2630414 = /* #__PURE__ */ function() {
    var $43 = $10ae9db6658426ac$export$c3c52e219617878("touchend");
    return function($44) {
        return $43($10ae9db6658426ac$var$touchHandler($44));
    };
}();
var $10ae9db6658426ac$export$e1ee796ca0d1f5fd = /* #__PURE__ */ function() {
    var $45 = $10ae9db6658426ac$export$c3c52e219617878("touchenter");
    return function($46) {
        return $45($10ae9db6658426ac$var$touchHandler($46));
    };
}();
var $10ae9db6658426ac$export$a8fb1c034c732052 = /* #__PURE__ */ function() {
    var $47 = $10ae9db6658426ac$export$c3c52e219617878("touchleave");
    return function($48) {
        return $47($10ae9db6658426ac$var$touchHandler($48));
    };
}();
var $10ae9db6658426ac$export$42c53271760d4595 = /* #__PURE__ */ function() {
    var $49 = $10ae9db6658426ac$export$c3c52e219617878("touchmove");
    return function($50) {
        return $49($10ae9db6658426ac$var$touchHandler($50));
    };
}();
var $10ae9db6658426ac$export$37cbf11924865552 = /* #__PURE__ */ function() {
    var $51 = $10ae9db6658426ac$export$c3c52e219617878("touchstart");
    return function($52) {
        return $51($10ae9db6658426ac$var$touchHandler($52));
    };
}();
var $10ae9db6658426ac$export$e967ac7bdb3c237c = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("transitionend");
var $10ae9db6658426ac$export$65ea24ac132a9be9 = /* #__PURE__ */ function() {
    var $53 = $10ae9db6658426ac$export$c3c52e219617878($64b79e1476c3e095$export$d3028820ea014224);
    return function($54) {
        return $53($10ae9db6658426ac$var$wheelHandler($54));
    };
}();
var $10ae9db6658426ac$var$focusHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$export$5e446bc31724fca4 = /* #__PURE__ */ function() {
    var $55 = $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$2cc7ff91bcacba5e);
    return function($56) {
        return $55($10ae9db6658426ac$var$focusHandler($56));
    };
}();
var $10ae9db6658426ac$export$ecf9bf35ad97eb74 = /* #__PURE__ */ function() {
    var $57 = $10ae9db6658426ac$export$c3c52e219617878($9285e421afbabad0$export$d7ddd398f22d79ef);
    return function($58) {
        return $57($10ae9db6658426ac$var$focusHandler($58));
    };
}();
var $10ae9db6658426ac$export$e9c0af77f352888d = /* #__PURE__ */ function() {
    var $59 = $10ae9db6658426ac$export$c3c52e219617878($9285e421afbabad0$export$e7fa4ea7f1bfcb53);
    return function($60) {
        return $59($10ae9db6658426ac$var$focusHandler($60));
    };
}();
var $10ae9db6658426ac$export$299df4cb415b3de7 = /* #__PURE__ */ function() {
    var $61 = $10ae9db6658426ac$export$c3c52e219617878($9285e421afbabad0$export$d0dc5134b51e78ad);
    return function($62) {
        return $61($10ae9db6658426ac$var$focusHandler($62));
    };
}();
var $10ae9db6658426ac$var$dragHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$export$11a07b18d6f8f6d2 = /* #__PURE__ */ function() {
    var $63 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$d7d5d435647ed5a0);
    return function($64) {
        return $63($10ae9db6658426ac$var$dragHandler($64));
    };
}();
var $10ae9db6658426ac$export$8566066e92caa8a = /* #__PURE__ */ function() {
    var $65 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$26ae3c90d367ea9a);
    return function($66) {
        return $65($10ae9db6658426ac$var$dragHandler($66));
    };
}();
var $10ae9db6658426ac$export$e2ce2d097d95a991 = /* #__PURE__ */ function() {
    var $67 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$bf1ba5dda238dc20);
    return function($68) {
        return $67($10ae9db6658426ac$var$dragHandler($68));
    };
}();
var $10ae9db6658426ac$export$5d99689eba023667 = /* #__PURE__ */ function() {
    var $69 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$ddffa9b7b4c3e300);
    return function($70) {
        return $69($10ae9db6658426ac$var$dragHandler($70));
    };
}();
var $10ae9db6658426ac$export$5280b1a9a538737a = /* #__PURE__ */ function() {
    var $71 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$f58195b0ad38aa36);
    return function($72) {
        return $71($10ae9db6658426ac$var$dragHandler($72));
    };
}();
var $10ae9db6658426ac$export$caca362e3b7795bf = /* #__PURE__ */ function() {
    var $73 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$ced0a5bb82ba6aee);
    return function($74) {
        return $73($10ae9db6658426ac$var$dragHandler($74));
    };
}();
var $10ae9db6658426ac$export$b00174fdb6a6ab8f = /* #__PURE__ */ function() {
    var $75 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$dc0badfde684823c);
    return function($76) {
        return $75($10ae9db6658426ac$var$dragHandler($76));
    };
}();
var $10ae9db6658426ac$export$c052d596304c05ec = /* #__PURE__ */ function() {
    var $77 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$663103110d94aac9);
    return function($78) {
        return $77($10ae9db6658426ac$var$dragHandler($78));
    };
}();
var $10ae9db6658426ac$var$clipboardHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$export$f7fe233856e3c643 = /* #__PURE__ */ function() {
    var $79 = $10ae9db6658426ac$export$c3c52e219617878($5253348ec4f02e0c$export$784d13d8ee351f07);
    return function($80) {
        return $79($10ae9db6658426ac$var$clipboardHandler($80));
    };
}();
var $10ae9db6658426ac$export$330ca67a316b532c = /* #__PURE__ */ function() {
    var $81 = $10ae9db6658426ac$export$c3c52e219617878($5253348ec4f02e0c$export$af2a99f971a346e6);
    return function($82) {
        return $81($10ae9db6658426ac$var$clipboardHandler($82));
    };
}();
var $10ae9db6658426ac$export$48aae1120b60938a = /* #__PURE__ */ function() {
    var $83 = $10ae9db6658426ac$export$c3c52e219617878($5253348ec4f02e0c$export$9b6706c8686cfc8e);
    return function($84) {
        return $83($10ae9db6658426ac$var$clipboardHandler($84));
    };
}();
var $10ae9db6658426ac$var$addForeignPropHandler = function(key) {
    return function(prop) {
        return function(reader) {
            return function(f) {
                var go = function(a) {
                    return $10ae9db6658426ac$var$composeKleisliFlipped(reader)($10ae9db6658426ac$var$readProp(prop))($c97d2d0f578f81ad$export$9d82982d31d9d171(a));
                };
                return $10ae9db6658426ac$export$6b8360dd6fa5f18d(key)($10ae9db6658426ac$var$composeKleisli($2829090ac282514c$export$28b27b1605aa05ad)(function(e) {
                    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))(function($85) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create(f($85));
                    })($f9f243b94d1fc188$export$a25b8a8a37f2d1cd(go(e)));
                }));
            };
        };
    };
};
var $10ae9db6658426ac$export$1706e2dd89331370 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($98632a8bc67f7e8c$export$d8a7b8f475ec0161)("checked")(/* #__PURE__ */ $c97d2d0f578f81ad$export$f9a84177eae95ed5($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $10ae9db6658426ac$export$4a70483021db3500 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($98632a8bc67f7e8c$export$d8a7b8f475ec0161)("selectedIndex")(/* #__PURE__ */ $c97d2d0f578f81ad$export$ac3747cb00139c63($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $10ae9db6658426ac$export$faef864395e27f71 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($98632a8bc67f7e8c$export$d8a7b8f475ec0161)("value")($10ae9db6658426ac$var$readString);
var $10ae9db6658426ac$export$4b31b9659da30fc9 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($98632a8bc67f7e8c$export$b7e3ae3d7c15e42e)("value")($10ae9db6658426ac$var$readString);





// Generated by purs version 0.15.15













// Generated by purs version 0.15.15


// Generated by purs version 0.15.15



var $3cc7d978c1d7ea03$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($848780da1bf26d9d$export$95510d0cd7e6e7eb);
var $3cc7d978c1d7ea03$export$d2a72f000c4be67b = /* #__PURE__ */ function() {
    function Completed(value0) {
        this.value0 = value0;
    }
    Completed.create = function(value0) {
        return new Completed(value0);
    };
    return Completed;
}();
var $3cc7d978c1d7ea03$export$91ae1e982b7b05d4 = /* #__PURE__ */ function() {
    function Failed(value0) {
        this.value0 = value0;
    }
    Failed.create = function(value0) {
        return new Failed(value0);
    };
    return Failed;
}();
var $3cc7d978c1d7ea03$export$bc0dd2ad24d78194 = /* #__PURE__ */ function() {
    function Killed(value0) {
        this.value0 = value0;
    }
    Killed.create = function(value0) {
        return new Killed(value0);
    };
    return Killed;
}();
var $3cc7d978c1d7ea03$export$bb8edd1f55ec0e96 = function(dict) {
    return dict.uninterruptible;
};
var $3cc7d978c1d7ea03$export$a1428c8f7ba796e8 = function(dict) {
    return dict.suspend;
};
var $3cc7d978c1d7ea03$export$b3e22bcfd64c1022 = function(dict) {
    return dict.never;
};
var $3cc7d978c1d7ea03$export$353ec5b900391c5 = {
    suspend: $edf0339512807bee$export$4de6f17bc3dfa03,
    fork: $edf0339512807bee$export$469c8a16c186651e,
    join: $edf0339512807bee$export$f3d782c2b95165ad,
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    },
    Functor1: function() {
        return $edf0339512807bee$export$29466a041ff3b3e0;
    }
};
var $3cc7d978c1d7ea03$export$283d19abc99a5706 = {
    kill: $edf0339512807bee$export$c65b2010df1810d,
    MonadFork0: function() {
        return $3cc7d978c1d7ea03$export$353ec5b900391c5;
    },
    MonadThrow1: function() {
        return $edf0339512807bee$export$37a9b80154c7d256;
    }
};
var $3cc7d978c1d7ea03$export$f2e13c7c49fc01aa = {
    bracket: function(acquire) {
        return function(release) {
            return function(run) {
                return $b28443a27438717a$export$9ad792f02752f447(acquire)({
                    completed: function($44) {
                        return release($3cc7d978c1d7ea03$export$d2a72f000c4be67b.create($44));
                    },
                    failed: function($45) {
                        return release($3cc7d978c1d7ea03$export$91ae1e982b7b05d4.create($45));
                    },
                    killed: function($46) {
                        return release($3cc7d978c1d7ea03$export$bc0dd2ad24d78194.create($46));
                    }
                })(run);
            };
        };
    },
    uninterruptible: $edf0339512807bee$export$859f4dae848ac0ae,
    never: $edf0339512807bee$export$b3e22bcfd64c1022,
    MonadKill0: function() {
        return $3cc7d978c1d7ea03$export$283d19abc99a5706;
    },
    MonadError1: function() {
        return $edf0339512807bee$export$9efce1646e93cba4;
    }
};
var $3cc7d978c1d7ea03$export$dfdb508572caf3d7 = function(dict) {
    return dict.kill;
};
var $3cc7d978c1d7ea03$export$f7e2c8231c57a8bd = function(dict) {
    return dict.join;
};
var $3cc7d978c1d7ea03$export$7a5058c6b79333e0 = function(dict) {
    return dict.fork;
};
var $3cc7d978c1d7ea03$export$21277a949ab1c87a = function(dictMonadFork) {
    var suspend1 = $3cc7d978c1d7ea03$export$a1428c8f7ba796e8(dictMonadFork);
    var fork1 = $3cc7d978c1d7ea03$export$7a5058c6b79333e0(dictMonadFork);
    var Monad0 = dictMonadFork.Monad0();
    var monadReaderT = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    var Functor1 = dictMonadFork.Functor1();
    return {
        suspend: function(v) {
            return function($47) {
                return suspend1(v($47));
            };
        },
        fork: function(v) {
            return function($48) {
                return fork1(v($48));
            };
        },
        join: function() {
            var $49 = $3cc7d978c1d7ea03$var$lift(Monad0);
            var $50 = $3cc7d978c1d7ea03$export$f7e2c8231c57a8bd(dictMonadFork);
            return function($51) {
                return $49($50($51));
            };
        }(),
        Monad0: function() {
            return monadReaderT;
        },
        Functor1: function() {
            return Functor1;
        }
    };
};
var $3cc7d978c1d7ea03$export$b03c2ddf720364a4 = function(dictMonadKill) {
    var MonadThrow1 = dictMonadKill.MonadThrow1();
    var lift1 = $3cc7d978c1d7ea03$var$lift(MonadThrow1.Monad0());
    var kill1 = $3cc7d978c1d7ea03$export$dfdb508572caf3d7(dictMonadKill);
    var monadForkReaderT1 = $3cc7d978c1d7ea03$export$21277a949ab1c87a(dictMonadKill.MonadFork0());
    var monadThrowReaderT = $848780da1bf26d9d$export$1b067e2856bff729(MonadThrow1);
    return {
        kill: function(e) {
            var $52 = kill1(e);
            return function($53) {
                return lift1($52($53));
            };
        },
        MonadFork0: function() {
            return monadForkReaderT1;
        },
        MonadThrow1: function() {
            return monadThrowReaderT;
        }
    };
};
var $3cc7d978c1d7ea03$export$df5598cc12b9c8c = function(dict) {
    return dict.bracket;
};
var $3cc7d978c1d7ea03$export$746d58fd4800e2fa = function(dictMonadBracket) {
    var bracket1 = $3cc7d978c1d7ea03$export$df5598cc12b9c8c(dictMonadBracket);
    var uninterruptible1 = $3cc7d978c1d7ea03$export$bb8edd1f55ec0e96(dictMonadBracket);
    var MonadError1 = dictMonadBracket.MonadError1();
    var monadKillReaderT1 = $3cc7d978c1d7ea03$export$b03c2ddf720364a4(dictMonadBracket.MonadKill0());
    var monadErrorReaderT = $848780da1bf26d9d$export$484cd3c856ffc7(MonadError1);
    return {
        bracket: function(v) {
            return function(release) {
                return function(run) {
                    return function(r) {
                        return bracket1(v(r))(function(c) {
                            return function(a) {
                                return $848780da1bf26d9d$export$f356de2c51baae29(release(c)(a))(r);
                            };
                        })(function(a) {
                            return $848780da1bf26d9d$export$f356de2c51baae29(run(a))(r);
                        });
                    };
                };
            };
        },
        uninterruptible: function(k) {
            return function(r) {
                return uninterruptible1($848780da1bf26d9d$export$f356de2c51baae29(k)(r));
            };
        },
        never: $3cc7d978c1d7ea03$var$lift(MonadError1.MonadThrow0().Monad0())($3cc7d978c1d7ea03$export$b3e22bcfd64c1022(dictMonadBracket)),
        MonadKill0: function() {
            return monadKillReaderT1;
        },
        MonadError1: function() {
            return monadErrorReaderT;
        }
    };
};


















// Generated by purs version 0.15.15



// Generated by purs version 0.15.15









var $9913c23e14d7f752$var$componentSlot = /* #__PURE__ */ $eea39ea934373596$export$f7e7e2efed606f4a();
var $9913c23e14d7f752$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $9913c23e14d7f752$export$76bf64fc47d1f9ce = function() {
    return function(dictIsSymbol) {
        var componentSlot1 = $9913c23e14d7f752$var$componentSlot(dictIsSymbol);
        return function(dictOrd) {
            var componentSlot2 = componentSlot1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(component) {
                        return function(input) {
                            return $c959b62ce0c19dfe$export$f0c5cfb390964b78(new $eea39ea934373596$export$bbf8b056cc92e88d(componentSlot2(label)(p)(component)(input)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))));
                        };
                    };
                };
            };
        };
    };
};
var $9913c23e14d7f752$export$103b78750979eead = function() {
    return function(dictIsSymbol) {
        var componentSlot1 = $9913c23e14d7f752$var$componentSlot(dictIsSymbol);
        return function(dictOrd) {
            var componentSlot2 = componentSlot1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(component) {
                        return function(input) {
                            return function(outputQuery) {
                                return $c959b62ce0c19dfe$export$f0c5cfb390964b78(new $eea39ea934373596$export$bbf8b056cc92e88d(componentSlot2(label)(p)(component)(input)(function($11) {
                                    return $06733ae99ed4f534$export$8a67b48435b5d073.create(outputQuery($11));
                                })));
                            };
                        };
                    };
                };
            };
        };
    };
};
var $9913c23e14d7f752$export$9756366f7cb6f62b = function(eqFn) {
    return function(f) {
        return $9913c23e14d7f752$var$map(function($12) {
            return $c959b62ce0c19dfe$export$f0c5cfb390964b78($eea39ea934373596$export$5e46cfa5e835a582.create($12));
        })($f1bf345cdb6c789d$export$6fa757c467a343e(eqFn)(f));
    };
};
var $9913c23e14d7f752$export$1590e93dfc8f2cb5 = function(f) {
    return function(a) {
        return function(b) {
            return function(c) {
                return $c959b62ce0c19dfe$export$f0c5cfb390964b78(new $eea39ea934373596$export$5e46cfa5e835a582($f1bf345cdb6c789d$export$7f0ccf52046143dd(f, a, b, c)));
            };
        };
    };
};
var $9913c23e14d7f752$export$5a7f8ed0ed0de90f = function(f) {
    return function(a) {
        return function(b) {
            return $c959b62ce0c19dfe$export$f0c5cfb390964b78(new $eea39ea934373596$export$5e46cfa5e835a582($f1bf345cdb6c789d$export$8a29159161b2b8a6(f, a, b)));
        };
    };
};
var $9913c23e14d7f752$export$488013bae63b21da = function(f) {
    return function(a) {
        return $c959b62ce0c19dfe$export$f0c5cfb390964b78(new $eea39ea934373596$export$5e46cfa5e835a582($f1bf345cdb6c789d$export$c6666e7f0d2efc62(f, a)));
    };
};
var $9913c23e14d7f752$export$1fb0fe1b9ee1b1bf = $ac8b3532514ac019$export$401372c57776dc;



// Generated by purs version 0.15.15













var $2925bc950f7308d7$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($84222ab19bdc98bd$export$bf09f5de576f9cf1);
var $2925bc950f7308d7$var$queryAll = /* #__PURE__ */ $84222ab19bdc98bd$export$dcd0d083aa86c355();
var $2925bc950f7308d7$var$query = /* #__PURE__ */ $84222ab19bdc98bd$export$2fa187e846a241c4();
var $2925bc950f7308d7$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $2925bc950f7308d7$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $2925bc950f7308d7$export$786cec95229c2a31 = function() {
    return function(dictIsSymbol) {
        var queryAll1 = $2925bc950f7308d7$var$queryAll(dictIsSymbol);
        return function(dictOrd) {
            var queryAll2 = queryAll1(dictOrd);
            return function(label) {
                return function(req) {
                    return $2925bc950f7308d7$var$$$void(queryAll2(label)(req($05149ea687d6b460$export$523c0b569236b342)));
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$de3113ed932c61ab = function() {
    return function(dictIsSymbol) {
        var query1 = $2925bc950f7308d7$var$query(dictIsSymbol);
        return function(dictOrd) {
            var query2 = query1(dictOrd);
            return function(slot) {
                return function(label) {
                    return function(req) {
                        return $2925bc950f7308d7$var$$$void(query2(slot)(label)(req($05149ea687d6b460$export$523c0b569236b342)));
                    };
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$57331aaf6e3ff74d = function() {
    return function(dictIsSymbol) {
        var queryAll1 = $2925bc950f7308d7$var$queryAll(dictIsSymbol);
        return function(dictOrd) {
            var queryAll2 = queryAll1(dictOrd);
            return function(label) {
                return function(req) {
                    return queryAll2(label)(req($2925bc950f7308d7$var$identity));
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$b5fe3f66a567bec0 = function() {
    return function(dictIsSymbol) {
        var query1 = $2925bc950f7308d7$var$query(dictIsSymbol);
        return function(dictOrd) {
            var query2 = query1(dictOrd);
            return function(slot) {
                return function(label) {
                    return function(req) {
                        return query2(slot)(label)(req($2925bc950f7308d7$var$identity));
                    };
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$a39c6a18d03be90d = function(act) {
    return act($05149ea687d6b460$export$523c0b569236b342);
};
var $2925bc950f7308d7$export$377703b067ff01a = function(req) {
    return req($2925bc950f7308d7$var$identity);
};
var $2925bc950f7308d7$export$bd6cf4e30aa8da47 = /* #__PURE__ */ function() {
    var $24 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($84222ab19bdc98bd$export$bf09f5de576f9cf1)(function(v) {
        return $2925bc950f7308d7$var$bindFlipped($5ae75883a0b7923c$export$c56654a6d0e3bd48)(v);
    });
    return function($25) {
        return $24($84222ab19bdc98bd$export$f0c653cfd7dea798($25));
    };
}();




// Generated by purs version 0.15.15
























// Generated by purs version 0.15.15







var $ef932f98609e5673$export$57f9bfb98da0e5b8 = function(x) {
    return x;
};
var $ef932f98609e5673$export$74fd2e01b52646ce = function(x) {
    return x;
};
var $ef932f98609e5673$export$b29cd3b133bc0fa4 = $ac8b3532514ac019$export$401372c57776dc;
var $ef932f98609e5673$export$b325883598264040 = $ac8b3532514ac019$export$401372c57776dc;
var $ef932f98609e5673$export$dcc8908fea536646 = function(dictApplicative) {
    var traverse_ = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
    return function(f) {
        return $ef932f98609e5673$export$b325883598264040(function(st) {
            return traverse_(f)(st.rendering);
        });
    };
};
var $ef932f98609e5673$var$mkRenderStateX = $ac8b3532514ac019$export$401372c57776dc;
var $ef932f98609e5673$export$8a58ffe66c3bbb4d = function(dictFunctor) {
    return function(f) {
        return $ef932f98609e5673$export$b325883598264040(function(st) {
            return $ef932f98609e5673$var$mkRenderStateX(f(st.rendering));
        });
    };
};
var $ef932f98609e5673$export$52c65da2de355775 = $ac8b3532514ac019$export$401372c57776dc;
var $ef932f98609e5673$export$43ced40f2a8d1657 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $ef932f98609e5673$export$2999486de8d3a294 = function(component) {
    return function(input) {
        return function(handler) {
            return function(lchs) {
                return function __do() {
                    var selfRef = $90327512d8280b8d$export$b8cb59497041ffe4({})();
                    var childrenIn = $90327512d8280b8d$export$b8cb59497041ffe4($0f3b7f18059106fc$export$6e22c362a0406a2c)();
                    var childrenOut = $90327512d8280b8d$export$b8cb59497041ffe4($0f3b7f18059106fc$export$6e22c362a0406a2c)();
                    var handlerRef = $90327512d8280b8d$export$b8cb59497041ffe4(handler)();
                    var pendingQueries = $90327512d8280b8d$export$b8cb59497041ffe4(new $06733ae99ed4f534$export$8a67b48435b5d073($78c799cba34fcb8d$export$c1bed610ade55e1c.value))();
                    var pendingOuts = $90327512d8280b8d$export$b8cb59497041ffe4(new $06733ae99ed4f534$export$8a67b48435b5d073($78c799cba34fcb8d$export$c1bed610ade55e1c.value))();
                    var pendingHandlers = $90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)();
                    var fresh = $90327512d8280b8d$export$b8cb59497041ffe4(1)();
                    var subscriptions = $90327512d8280b8d$export$b8cb59497041ffe4(new $06733ae99ed4f534$export$8a67b48435b5d073($ea3eb84de0acf574$export$6e22c362a0406a2c))();
                    var forks = $90327512d8280b8d$export$b8cb59497041ffe4($ea3eb84de0acf574$export$6e22c362a0406a2c)();
                    var ds = {
                        component: component,
                        state: component.initialState(input),
                        refs: $ea3eb84de0acf574$export$6e22c362a0406a2c,
                        children: $0f3b7f18059106fc$export$6e22c362a0406a2c,
                        childrenIn: childrenIn,
                        childrenOut: childrenOut,
                        selfRef: selfRef,
                        handlerRef: handlerRef,
                        pendingQueries: pendingQueries,
                        pendingOuts: pendingOuts,
                        pendingHandlers: pendingHandlers,
                        rendering: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                        fresh: fresh,
                        subscriptions: subscriptions,
                        forks: forks,
                        lifecycleHandlers: lchs
                    };
                    $e521936ea118867a$export$68d8715fc104d294(ds)(selfRef)();
                    return $ef932f98609e5673$export$52c65da2de355775(selfRef);
                };
            };
        };
    };
};








var $6bfb10b11a80fc8b$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($6c2f8951ecf9531e$export$89bf999217d3022a)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $6bfb10b11a80fc8b$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $6bfb10b11a80fc8b$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($84222ab19bdc98bd$export$2a9fc99fce80131a);
var $6bfb10b11a80fc8b$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $6bfb10b11a80fc8b$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $6bfb10b11a80fc8b$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $6bfb10b11a80fc8b$var$discard1 = /* #__PURE__ */ $6bfb10b11a80fc8b$var$discard($edf0339512807bee$export$f885f489dcf38a2d);
var $6bfb10b11a80fc8b$var$traverse_1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($edf0339512807bee$export$9dc0454a98607988);
var $6bfb10b11a80fc8b$var$traverse_2 = /* #__PURE__ */ $6bfb10b11a80fc8b$var$traverse_1($78c799cba34fcb8d$export$92659ee1fc91a075);
var $6bfb10b11a80fc8b$var$fork = /* #__PURE__ */ $3cc7d978c1d7ea03$export$7a5058c6b79333e0($3cc7d978c1d7ea03$export$353ec5b900391c5);
var $6bfb10b11a80fc8b$var$parSequence_ = /* #__PURE__ */ $355d9520a1199e68$export$a907a2b4fd85b16b($edf0339512807bee$export$cb4623454f96d5e0)($edf0339512807bee$export$389e6cb252ce112f)($78c799cba34fcb8d$export$92659ee1fc91a075);
var $6bfb10b11a80fc8b$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $6bfb10b11a80fc8b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($026fde5446dd624a$export$bd40aba71422b460);
var $6bfb10b11a80fc8b$var$parallel = /* #__PURE__ */ $86141680556a7436$export$451942af9381149c($edf0339512807bee$export$cb4623454f96d5e0);
var $6bfb10b11a80fc8b$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $6bfb10b11a80fc8b$var$sequential = /* #__PURE__ */ $86141680556a7436$export$3c7b24ce1c81e349($edf0339512807bee$export$cb4623454f96d5e0);
var $6bfb10b11a80fc8b$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $6bfb10b11a80fc8b$var$insert = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($84222ab19bdc98bd$export$2a9fc99fce80131a);
var $6bfb10b11a80fc8b$var$retractFreeAp = /* #__PURE__ */ $dc7ffeabd143829e$export$ab82a8987829bde0($edf0339512807bee$export$389e6cb252ce112f);
var $6bfb10b11a80fc8b$var$$$delete = /* #__PURE__ */ $ea3eb84de0acf574$export$1822828d790e23ee($84222ab19bdc98bd$export$7e953d51c2b3343e);
var $6bfb10b11a80fc8b$var$unlessM = /* #__PURE__ */ $d3d065da31679be1$export$551dd5524146e426($6c2f8951ecf9531e$export$7e900d895707a1af);
var $6bfb10b11a80fc8b$var$insert1 = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($84222ab19bdc98bd$export$7e953d51c2b3343e);
var $6bfb10b11a80fc8b$var$traverse_3 = /* #__PURE__ */ $6bfb10b11a80fc8b$var$traverse_1($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $6bfb10b11a80fc8b$var$lookup1 = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($84222ab19bdc98bd$export$7e953d51c2b3343e);
var $6bfb10b11a80fc8b$var$lookup2 = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($97937c29f879e68e$export$c5f2758e49b2b86a);
var $6bfb10b11a80fc8b$var$foldFree = /* #__PURE__ */ $d0bd5a116d2d5f24$export$eb0e66a9104d4874($edf0339512807bee$export$974f8db4a62dd716);
var $6bfb10b11a80fc8b$var$alter = /* #__PURE__ */ $ea3eb84de0acf574$export$22a7378e1d3307a4($97937c29f879e68e$export$c5f2758e49b2b86a);
var $6bfb10b11a80fc8b$var$unsubscribe = function(sid) {
    return function(ref) {
        return function __do() {
            var v = $e521936ea118867a$export$aafa59e2e03f2942(ref)();
            var subs = $e521936ea118867a$export$aafa59e2e03f2942(v.subscriptions)();
            return $6bfb10b11a80fc8b$var$traverse_($8360250a454b77aa$export$f500693cef883ffd)($6bfb10b11a80fc8b$var$bindFlipped($6bfb10b11a80fc8b$var$lookup(sid))(subs))();
        };
    };
};
var $6bfb10b11a80fc8b$export$2d912d1764c6009b = function(ref) {
    return function(au) {
        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return au;
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(new $78c799cba34fcb8d$export$74c44e616647f5c0(au, v.value0)))(ref));
            throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 188, column 33 - line 190, column 57): " + [
                v.constructor.name
            ]);
        });
    };
};
var $6bfb10b11a80fc8b$export$b7a8cef929df0d3c = function(lchs) {
    return function(f) {
        return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$68d8715fc104d294({
            initializers: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
            finalizers: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
        })(lchs)))(function() {
            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect(f))(function(result) {
                return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(lchs)))(function(v) {
                    return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$traverse_2($6bfb10b11a80fc8b$var$fork)(v.finalizers))(function() {
                        return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$parSequence_(v.initializers))(function() {
                            return $6bfb10b11a80fc8b$var$pure(result);
                        });
                    });
                });
            });
        });
    };
};
var $6bfb10b11a80fc8b$export$c4c41c035efd1fb3 = /* #__PURE__ */ $edf0339512807bee$export$ef62257e6f8a5f8c(/* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded($ad2cf6904bca3ba1$export$de0c4a986b439e52)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(/* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a)($05149ea687d6b460$export$523c0b569236b342))));
var $6bfb10b11a80fc8b$var$fresh = function(f) {
    return function(ref) {
        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v) {
            return $6bfb10b11a80fc8b$var$liftEffect($90327512d8280b8d$export$4d5401161a900ce1(function(i) {
                return {
                    state: i + 1 | 0,
                    value: f(i)
                };
            })(v.fresh));
        });
    };
};
var $6bfb10b11a80fc8b$export$f960635a4c7f8a61 = function(render) {
    return function(ref) {
        return function(q) {
            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v) {
                return $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref)(v["component"]["eval"](new $43c0c9babefbb793$export$62297b13309008b2($6bfb10b11a80fc8b$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)($026fde5446dd624a$export$6320c031d6b6270f(q)), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))));
            });
        };
    };
};
var $6bfb10b11a80fc8b$export$b505393bc8c03d39 = function(render) {
    return function(initRef) {
        return function(v) {
            var evalChildQuery = function(ref) {
                return function(cqb) {
                    return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v1) {
                        return $100f96dc727fa3bb$export$183d7a788d583d00(function(v2) {
                            var evalChild = function(v3) {
                                return $6bfb10b11a80fc8b$var$parallel($6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(v3)))(function(dsx) {
                                    return $ef932f98609e5673$export$b325883598264040(function(ds) {
                                        return $6bfb10b11a80fc8b$export$f960635a4c7f8a61(render)(ds.selfRef)(v2.value1);
                                    })(dsx);
                                }));
                            };
                            return $6bfb10b11a80fc8b$var$map1(v2.value2)($6bfb10b11a80fc8b$var$sequential(v2.value0($edf0339512807bee$export$389e6cb252ce112f)(evalChild)(v1.children)));
                        })(cqb);
                    });
                };
            };
            var go = function(ref) {
                return function(v1) {
                    if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                        var v3 = v1.value0(v2.state);
                        if ($871d3d7bcf6be72e$export$54d9901699893a6(v2.state)(v3.value1)) return $6bfb10b11a80fc8b$var$pure(v3.value0);
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$68d8715fc104d294({
                            component: v2.component,
                            refs: v2.refs,
                            children: v2.children,
                            childrenIn: v2.childrenIn,
                            childrenOut: v2.childrenOut,
                            selfRef: v2.selfRef,
                            handlerRef: v2.handlerRef,
                            pendingQueries: v2.pendingQueries,
                            pendingOuts: v2.pendingOuts,
                            pendingHandlers: v2.pendingHandlers,
                            rendering: v2.rendering,
                            fresh: v2.fresh,
                            subscriptions: v2.subscriptions,
                            forks: v2.forks,
                            lifecycleHandlers: v2.lifecycleHandlers,
                            state: v3.value1
                        })(ref)))(function() {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$export$b7a8cef929df0d3c(v2.lifecycleHandlers)(render(v2.lifecycleHandlers)(ref)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v3.value0);
                            });
                        });
                        throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 86, column 7 - line 92, column 21): " + [
                            v3.constructor.name
                        ]);
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$fresh($84222ab19bdc98bd$export$f3ce0030ce21b322)(ref))(function(sid) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($8360250a454b77aa$export$ec068583843480e7(v1.value0(sid))(function(act) {
                            return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3($6bfb10b11a80fc8b$export$6533955444d826a5(render)(ref)(new $969bbf7e7aa55092$export$e19cd5f9376f8cee(act)));
                        })))(function(finalize) {
                            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                                return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($90327512d8280b8d$export$45b91115a89d6020($6bfb10b11a80fc8b$var$map2($6bfb10b11a80fc8b$var$insert(sid)(finalize)))(v2.subscriptions)))(function() {
                                    return $6bfb10b11a80fc8b$var$pure(v1.value1(sid));
                                });
                            });
                        });
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($6bfb10b11a80fc8b$var$unsubscribe(v1.value0)(ref)))(function() {
                        return $6bfb10b11a80fc8b$var$pure(v1.value1);
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return v1.value0;
                    if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return evalChildQuery(ref)(v1.value0);
                    if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(v2.handlerRef)))(function(handler) {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$export$2d912d1764c6009b(v2.pendingOuts)(handler(v1.value0)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return $6bfb10b11a80fc8b$var$sequential($6bfb10b11a80fc8b$var$retractFreeAp($dc7ffeabd143829e$export$2a17b194dc6daf5e(function() {
                        var $119 = $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref);
                        return function($120) {
                            return $6bfb10b11a80fc8b$var$parallel($119($120));
                        };
                    }())(v1.value0)));
                    if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$fresh($84222ab19bdc98bd$export$77e8fa738093aa8c)(ref))(function(fid) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($90327512d8280b8d$export$b8cb59497041ffe4(false)))(function(doneRef) {
                                return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$fork($edf0339512807bee$export$7f8bd3bb7f01e042($6bfb10b11a80fc8b$var$liftEffect(function __do() {
                                    $90327512d8280b8d$export$45b91115a89d6020($6bfb10b11a80fc8b$var$$$delete(fid))(v2.forks)();
                                    return $e521936ea118867a$export$68d8715fc104d294(true)(doneRef)();
                                }))($6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref)(v1.value0))))(function(fiber) {
                                    return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($6bfb10b11a80fc8b$var$unlessM($e521936ea118867a$export$aafa59e2e03f2942(doneRef))($90327512d8280b8d$export$45b91115a89d6020($6bfb10b11a80fc8b$var$insert1(fid)(fiber))(v2.forks))))(function() {
                                        return $6bfb10b11a80fc8b$var$pure(v1.value1(fid));
                                    });
                                });
                            });
                        });
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(v2.forks)))(function(forkMap) {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$traverse_3($edf0339512807bee$export$f3d782c2b95165ad)($6bfb10b11a80fc8b$var$lookup1(v1.value0)(forkMap)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(v2.forks)))(function(forkMap) {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$traverse_3($edf0339512807bee$export$c65b2010df1810d($ad2cf6904bca3ba1$export$a3bc9b8ed74fc("Cancelled")))($6bfb10b11a80fc8b$var$lookup1(v1.value0)(forkMap)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$pure(v1.value1($6bfb10b11a80fc8b$var$lookup2(v1.value0)(v2.refs)));
                    });
                    throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 83, column 12 - line 139, column 33): " + [
                        v1.constructor.name
                    ]);
                };
            };
            return $6bfb10b11a80fc8b$var$foldFree(go(initRef))(v);
        };
    };
};
var $6bfb10b11a80fc8b$export$6533955444d826a5 = function(render) {
    return function(ref) {
        return function(v) {
            if (v instanceof $969bbf7e7aa55092$export$f4c20fd541e0bbe4) return $6bfb10b11a80fc8b$var$liftEffect($f57f4b701aa7b66e$export$8a83211c878a3f1f($90327512d8280b8d$export$45b91115a89d6020)(ref)($ef932f98609e5673$export$43ced40f2a8d1657(function(st) {
                return {
                    component: st.component,
                    state: st.state,
                    children: st.children,
                    childrenIn: st.childrenIn,
                    childrenOut: st.childrenOut,
                    selfRef: st.selfRef,
                    handlerRef: st.handlerRef,
                    pendingQueries: st.pendingQueries,
                    pendingOuts: st.pendingOuts,
                    pendingHandlers: st.pendingHandlers,
                    rendering: st.rendering,
                    fresh: st.fresh,
                    subscriptions: st.subscriptions,
                    forks: st.forks,
                    lifecycleHandlers: st.lifecycleHandlers,
                    refs: $6bfb10b11a80fc8b$var$alter($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(v.value1))(v.value0)(st.refs)
                };
            })));
            if (v instanceof $969bbf7e7aa55092$export$e19cd5f9376f8cee) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v1) {
                return $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref)(v1["component"]["eval"](new $43c0c9babefbb793$export$e19cd5f9376f8cee(v.value0, $05149ea687d6b460$export$523c0b569236b342)));
            });
            throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 52, column 20 - line 58, column 62): " + [
                v.constructor.name
            ]);
        };
    };
};








var $f469b52d7c3c8200$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $f469b52d7c3c8200$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $f469b52d7c3c8200$var$for_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$9747ee7caa0b40b1($6c2f8951ecf9531e$export$89bf999217d3022a)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $f469b52d7c3c8200$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($edf0339512807bee$export$9dc0454a98607988)($78c799cba34fcb8d$export$92659ee1fc91a075);
var $f469b52d7c3c8200$var$fork = /* #__PURE__ */ $3cc7d978c1d7ea03$export$7a5058c6b79333e0($3cc7d978c1d7ea03$export$353ec5b900391c5);
var $f469b52d7c3c8200$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $f469b52d7c3c8200$var$traverse_1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($6c2f8951ecf9531e$export$89bf999217d3022a);
var $f469b52d7c3c8200$var$traverse_2 = /* #__PURE__ */ $f469b52d7c3c8200$var$traverse_1($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $f469b52d7c3c8200$var$traverse_3 = /* #__PURE__ */ $f469b52d7c3c8200$var$traverse_1($ea3eb84de0acf574$export$4295a0c2ad7aa544);
var $f469b52d7c3c8200$var$discard2 = /* #__PURE__ */ $f469b52d7c3c8200$var$discard($edf0339512807bee$export$f885f489dcf38a2d);
var $f469b52d7c3c8200$var$parSequence_ = /* #__PURE__ */ $355d9520a1199e68$export$a907a2b4fd85b16b($edf0339512807bee$export$cb4623454f96d5e0)($edf0339512807bee$export$389e6cb252ce112f)($78c799cba34fcb8d$export$92659ee1fc91a075);
var $f469b52d7c3c8200$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $f469b52d7c3c8200$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $f469b52d7c3c8200$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f469b52d7c3c8200$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $f469b52d7c3c8200$var$when = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$a55877ca9db47377($6c2f8951ecf9531e$export$89bf999217d3022a);
var $f469b52d7c3c8200$var$renderStateX = /* #__PURE__ */ $ef932f98609e5673$export$8a58ffe66c3bbb4d($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f469b52d7c3c8200$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $f469b52d7c3c8200$var$foreachSlot = /* #__PURE__ */ $0f3b7f18059106fc$export$91dbfdfb14db6990($6c2f8951ecf9531e$export$89bf999217d3022a);
var $f469b52d7c3c8200$var$renderStateX_ = /* #__PURE__ */ $ef932f98609e5673$export$dcc8908fea536646($6c2f8951ecf9531e$export$89bf999217d3022a);
var $f469b52d7c3c8200$var$tailRecM = /* #__PURE__ */ $f93520de2fa37b44$export$c025cfd4cc93300b($f93520de2fa37b44$export$c2472dc015e90d28);
var $f469b52d7c3c8200$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f469b52d7c3c8200$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $f469b52d7c3c8200$var$liftEffect1 = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($f2c9b767d25cfbb9$export$86a2e24932ca2aa0);
var $f469b52d7c3c8200$var$newLifecycleHandlers = /* #__PURE__ */ function() {
    return $90327512d8280b8d$export$b8cb59497041ffe4({
        initializers: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        finalizers: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
    });
}();
var $f469b52d7c3c8200$var$handlePending = function(ref) {
    return function __do() {
        var queue = $e521936ea118867a$export$aafa59e2e03f2942(ref)();
        $e521936ea118867a$export$68d8715fc104d294($06733ae99ed4f534$export$bebe9059409a0d04.value)(ref)();
        return $f469b52d7c3c8200$var$for_(queue)(function() {
            var $59 = $f469b52d7c3c8200$var$traverse_($f469b52d7c3c8200$var$fork);
            return function($60) {
                return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3($59($3d4fd987da5242ff$export$66c1ae025e96b4bc($60)));
            };
        }())();
    };
};
var $f469b52d7c3c8200$var$cleanupSubscriptionsAndForks = function(v) {
    return function __do() {
        $f469b52d7c3c8200$var$bindFlipped($f469b52d7c3c8200$var$traverse_2($f469b52d7c3c8200$var$traverse_3($8360250a454b77aa$export$f500693cef883ffd)))($e521936ea118867a$export$aafa59e2e03f2942(v.subscriptions))();
        $e521936ea118867a$export$68d8715fc104d294($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.subscriptions)();
        $f469b52d7c3c8200$var$bindFlipped($f469b52d7c3c8200$var$traverse_3(function() {
            var $61 = $edf0339512807bee$export$c65b2010df1810d($ad2cf6904bca3ba1$export$a3bc9b8ed74fc("finalized"));
            return function($62) {
                return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3($61($62));
            };
        }()))($e521936ea118867a$export$aafa59e2e03f2942(v.forks))();
        return $e521936ea118867a$export$68d8715fc104d294($ea3eb84de0acf574$export$6e22c362a0406a2c)(v.forks)();
    };
};
var $f469b52d7c3c8200$export$32d31a833a940d1c = function(renderSpec) {
    return function(component) {
        return function(i) {
            var squashChildInitializers = function(lchs) {
                return function(preInits) {
                    return $ef932f98609e5673$export$b325883598264040(function(st) {
                        var parentInitializer = $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(st.selfRef)(st["component"]["eval"](new $43c0c9babefbb793$export$b03b1c699c90a9b4($05149ea687d6b460$export$523c0b569236b342)));
                        return $90327512d8280b8d$export$45b91115a89d6020(function(handlers) {
                            return {
                                initializers: new $78c799cba34fcb8d$export$74c44e616647f5c0($f469b52d7c3c8200$var$discard2($f469b52d7c3c8200$var$parSequence_($3d4fd987da5242ff$export$66c1ae025e96b4bc(handlers.initializers)))(function() {
                                    return $f469b52d7c3c8200$var$discard2(parentInitializer)(function() {
                                        return $f469b52d7c3c8200$var$liftEffect(function __do() {
                                            $f469b52d7c3c8200$var$handlePending(st.pendingQueries)();
                                            return $f469b52d7c3c8200$var$handlePending(st.pendingOuts)();
                                        });
                                    });
                                }), preInits),
                                finalizers: handlers.finalizers
                            };
                        })(lchs);
                    });
                };
            };
            var runComponent = function(lchs) {
                return function(handler) {
                    return function(j) {
                        return $eea39ea934373596$export$802c6b8ce0f42195(function(c) {
                            return function __do() {
                                var lchs$prime = $f469b52d7c3c8200$var$newLifecycleHandlers();
                                var $$var = $ef932f98609e5673$export$2999486de8d3a294(c)(j)(handler)(lchs$prime)();
                                var pre = $e521936ea118867a$export$aafa59e2e03f2942(lchs)();
                                $e521936ea118867a$export$68d8715fc104d294({
                                    initializers: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                                    finalizers: pre.finalizers
                                })(lchs)();
                                $f469b52d7c3c8200$var$bindFlipped($ef932f98609e5673$export$b325883598264040(function() {
                                    var $63 = render(lchs);
                                    return function($64) {
                                        return $63(function(v) {
                                            return v.selfRef;
                                        }($64));
                                    };
                                }()))($e521936ea118867a$export$aafa59e2e03f2942($$var))();
                                $f469b52d7c3c8200$var$bindFlipped(squashChildInitializers(lchs)(pre.initializers))($e521936ea118867a$export$aafa59e2e03f2942($$var))();
                                return $$var;
                            };
                        });
                    };
                };
            };
            var renderChild = function(lchs) {
                return function(handler) {
                    return function(childrenInRef) {
                        return function(childrenOutRef) {
                            return $eea39ea934373596$export$48f0293959eb16ec(function(slot) {
                                return function __do() {
                                    var childrenIn = $f469b52d7c3c8200$var$map(slot.pop)($e521936ea118867a$export$aafa59e2e03f2942(childrenInRef))();
                                    var $$var = function() {
                                        if (childrenIn instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                            $e521936ea118867a$export$68d8715fc104d294(childrenIn.value0.value1)(childrenInRef)();
                                            var dsx = $e521936ea118867a$export$aafa59e2e03f2942(childrenIn.value0.value0)();
                                            $ef932f98609e5673$export$b325883598264040(function(st) {
                                                return function __do() {
                                                    $f57f4b701aa7b66e$export$8a83211c878a3f1f($e521936ea118867a$export$68d8715fc104d294)(st.handlerRef)(function() {
                                                        var $65 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($f469b52d7c3c8200$var$pure1($05149ea687d6b460$export$523c0b569236b342))(handler);
                                                        return function($66) {
                                                            return $65(slot.output($66));
                                                        };
                                                    }())();
                                                    return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3($6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(st.selfRef)(st["component"]["eval"](new $43c0c9babefbb793$export$fc713a64b8ca1b7a(slot.input, $05149ea687d6b460$export$523c0b569236b342))))();
                                                };
                                            })(dsx)();
                                            return childrenIn.value0.value0;
                                        }
                                        if (childrenIn instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return runComponent(lchs)(function() {
                                            var $67 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($f469b52d7c3c8200$var$pure1($05149ea687d6b460$export$523c0b569236b342))(handler);
                                            return function($68) {
                                                return $67(slot.output($68));
                                            };
                                        }())(slot.input)(slot.component)();
                                        throw new Error("Failed pattern match at Halogen.Aff.Driver (line 213, column 14 - line 222, column 98): " + [
                                            childrenIn.constructor.name
                                        ]);
                                    }();
                                    var isDuplicate = $f469b52d7c3c8200$var$map(function($69) {
                                        return $06733ae99ed4f534$export$c15bd07a493e1236(slot.get($69));
                                    })($e521936ea118867a$export$aafa59e2e03f2942(childrenOutRef))();
                                    $f469b52d7c3c8200$var$when(isDuplicate)($93c729927fdf3160$export$c106dd0671a0fc2d("Halogen: Duplicate slot address was detected during rendering, unexpected results may occur"))();
                                    $90327512d8280b8d$export$45b91115a89d6020(slot.set($$var))(childrenOutRef)();
                                    return $f469b52d7c3c8200$var$bind($e521936ea118867a$export$aafa59e2e03f2942($$var))($f469b52d7c3c8200$var$renderStateX(function(v) {
                                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $4e52402d7134c8bb$export$7b1a37e4f0fe815("Halogen internal error: child was not initialized in renderChild");
                                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $f469b52d7c3c8200$var$pure(renderSpec.renderChild(v.value0));
                                        throw new Error("Failed pattern match at Halogen.Aff.Driver (line 227, column 37 - line 229, column 50): " + [
                                            v.constructor.name
                                        ]);
                                    }))();
                                };
                            });
                        };
                    };
                };
            };
            var render = function(lchs) {
                return function($$var) {
                    return function __do() {
                        var v = $e521936ea118867a$export$aafa59e2e03f2942($$var)();
                        var shouldProcessHandlers = $f469b52d7c3c8200$var$map($06733ae99ed4f534$export$4967676db1b89293)($e521936ea118867a$export$aafa59e2e03f2942(v.pendingHandlers))();
                        $f469b52d7c3c8200$var$when(shouldProcessHandlers)($e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073($78c799cba34fcb8d$export$c1bed610ade55e1c.value))(v.pendingHandlers))();
                        $e521936ea118867a$export$68d8715fc104d294($0f3b7f18059106fc$export$6e22c362a0406a2c)(v.childrenOut)();
                        $e521936ea118867a$export$68d8715fc104d294(v.children)(v.childrenIn)();
                        var handler = function() {
                            var $70 = $6bfb10b11a80fc8b$export$2d912d1764c6009b(v.pendingHandlers);
                            var $71 = $6bfb10b11a80fc8b$export$6533955444d826a5(render)(v.selfRef);
                            return function($72) {
                                return $70($f469b52d7c3c8200$var$$$void($71($72)));
                            };
                        }();
                        var childHandler = function() {
                            var $73 = $6bfb10b11a80fc8b$export$2d912d1764c6009b(v.pendingQueries);
                            return function($74) {
                                return $73(handler($969bbf7e7aa55092$export$e19cd5f9376f8cee.create($74)));
                            };
                        }();
                        var rendering = renderSpec.render(function($75) {
                            return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3(handler($75));
                        })(renderChild(lchs)(childHandler)(v.childrenIn)(v.childrenOut))(v.component.render(v.state))(v.rendering)();
                        var children = $e521936ea118867a$export$aafa59e2e03f2942(v.childrenOut)();
                        var childrenIn = $e521936ea118867a$export$aafa59e2e03f2942(v.childrenIn)();
                        $f469b52d7c3c8200$var$foreachSlot(childrenIn)(function(v1) {
                            return function __do() {
                                var childDS = $e521936ea118867a$export$aafa59e2e03f2942(v1)();
                                $f469b52d7c3c8200$var$renderStateX_(renderSpec.removeChild)(childDS)();
                                return finalize(lchs)(childDS)();
                            };
                        })();
                        $f57f4b701aa7b66e$export$8a83211c878a3f1f($90327512d8280b8d$export$45b91115a89d6020)(v.selfRef)($ef932f98609e5673$export$43ced40f2a8d1657(function(ds$prime) {
                            return {
                                component: ds$prime.component,
                                state: ds$prime.state,
                                refs: ds$prime.refs,
                                childrenIn: ds$prime.childrenIn,
                                childrenOut: ds$prime.childrenOut,
                                selfRef: ds$prime.selfRef,
                                handlerRef: ds$prime.handlerRef,
                                pendingQueries: ds$prime.pendingQueries,
                                pendingOuts: ds$prime.pendingOuts,
                                pendingHandlers: ds$prime.pendingHandlers,
                                fresh: ds$prime.fresh,
                                subscriptions: ds$prime.subscriptions,
                                forks: ds$prime.forks,
                                lifecycleHandlers: ds$prime.lifecycleHandlers,
                                rendering: new $06733ae99ed4f534$export$8a67b48435b5d073(rendering),
                                children: children
                            };
                        }))();
                        return $f469b52d7c3c8200$var$when(shouldProcessHandlers)($f57f4b701aa7b66e$export$8a83211c878a3f1f($f469b52d7c3c8200$var$tailRecM)($05149ea687d6b460$export$523c0b569236b342)(function(v1) {
                            return function __do() {
                                var handlers = $e521936ea118867a$export$aafa59e2e03f2942(v.pendingHandlers)();
                                $e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073($78c799cba34fcb8d$export$c1bed610ade55e1c.value))(v.pendingHandlers)();
                                $f469b52d7c3c8200$var$traverse_2(function() {
                                    var $76 = $f469b52d7c3c8200$var$traverse_($f469b52d7c3c8200$var$fork);
                                    return function($77) {
                                        return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3($76($3d4fd987da5242ff$export$66c1ae025e96b4bc($77)));
                                    };
                                }())(handlers)();
                                var mmore = $e521936ea118867a$export$aafa59e2e03f2942(v.pendingHandlers)();
                                var $52 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)($3d4fd987da5242ff$export$7b1b591b262c240)(mmore);
                                if ($52) return $f469b52d7c3c8200$var$voidLeft($e521936ea118867a$export$68d8715fc104d294($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.pendingHandlers))(new $f93520de2fa37b44$export$7fe28cb29e71bf10($05149ea687d6b460$export$523c0b569236b342))();
                                return new $f93520de2fa37b44$export$550acbd06a1f5a6a($05149ea687d6b460$export$523c0b569236b342);
                            };
                        }))();
                    };
                };
            };
            var finalize = function(lchs) {
                return $ef932f98609e5673$export$b325883598264040(function(st) {
                    return function __do() {
                        $f469b52d7c3c8200$var$cleanupSubscriptionsAndForks(st)();
                        var f = $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(st.selfRef)(st["component"]["eval"](new $43c0c9babefbb793$export$29defdae7b3f3a01($05149ea687d6b460$export$523c0b569236b342)));
                        $90327512d8280b8d$export$45b91115a89d6020(function(handlers) {
                            return {
                                initializers: handlers.initializers,
                                finalizers: new $78c799cba34fcb8d$export$74c44e616647f5c0(f, handlers.finalizers)
                            };
                        })(lchs)();
                        return $f469b52d7c3c8200$var$foreachSlot(st.children)(function(v) {
                            return function __do() {
                                var dsx = $e521936ea118867a$export$aafa59e2e03f2942(v)();
                                return finalize(lchs)(dsx)();
                            };
                        })();
                    };
                });
            };
            var evalDriver = function(disposed) {
                return function(ref) {
                    return function(q) {
                        return $f469b52d7c3c8200$var$bind1($f469b52d7c3c8200$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(disposed)))(function(v) {
                            if (v) return $f469b52d7c3c8200$var$pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
                            return $6bfb10b11a80fc8b$export$f960635a4c7f8a61(render)(ref)(q);
                        });
                    };
                };
            };
            var dispose = function(disposed) {
                return function(lchs) {
                    return function(dsx) {
                        return $6bfb10b11a80fc8b$export$b7a8cef929df0d3c(lchs)(function __do() {
                            var v = $e521936ea118867a$export$aafa59e2e03f2942(disposed)();
                            if (v) return $05149ea687d6b460$export$523c0b569236b342;
                            $e521936ea118867a$export$68d8715fc104d294(true)(disposed)();
                            finalize(lchs)(dsx)();
                            return $ef932f98609e5673$export$b325883598264040(function(v1) {
                                return function __do() {
                                    var v2 = $f469b52d7c3c8200$var$liftEffect1($e521936ea118867a$export$aafa59e2e03f2942(v1.selfRef))();
                                    return $f469b52d7c3c8200$var$for_(v2.rendering)(renderSpec.dispose)();
                                };
                            })(dsx)();
                        });
                    };
                };
            };
            return $f469b52d7c3c8200$var$bind1($f469b52d7c3c8200$var$liftEffect($f469b52d7c3c8200$var$newLifecycleHandlers))(function(lchs) {
                return $f469b52d7c3c8200$var$bind1($f469b52d7c3c8200$var$liftEffect($90327512d8280b8d$export$b8cb59497041ffe4(false)))(function(disposed) {
                    return $6bfb10b11a80fc8b$export$b7a8cef929df0d3c(lchs)(function __do() {
                        var sio = $8360250a454b77aa$export$185802fd694ee1f5();
                        var dsx = $f469b52d7c3c8200$var$bindFlipped($e521936ea118867a$export$aafa59e2e03f2942)(runComponent(lchs)(function() {
                            var $78 = $8360250a454b77aa$export$5e14cdade93d6f7b(sio.listener);
                            return function($79) {
                                return $f469b52d7c3c8200$var$liftEffect($78($79));
                            };
                        }())(i)(component))();
                        return $ef932f98609e5673$export$b325883598264040(function(st) {
                            return $f469b52d7c3c8200$var$pure({
                                query: evalDriver(disposed)(st.selfRef),
                                messages: sio.emitter,
                                dispose: dispose(disposed)(lchs)(dsx)
                            });
                        })(dsx)();
                    });
                });
            });
        };
    };
};









// Generated by purs version 0.15.15
var $9c38b931c8b22574$var$getEffProp = function(name) {
    return function(node) {
        return function() {
            return node[name];
        };
    };
};
function $9c38b931c8b22574$export$c441300b2d51b958(node) {
    return node.nodeType;
}
function $9c38b931c8b22574$export$860bddf988a8498c(node) {
    return node.nodeName;
}
const $9c38b931c8b22574$export$74061d4f476da680 = $9c38b931c8b22574$var$getEffProp("baseURI");
const $9c38b931c8b22574$export$23cc1b2a9bb6c61a = $9c38b931c8b22574$var$getEffProp("ownerDocument");
const $9c38b931c8b22574$export$72030ded560177b6 = $9c38b931c8b22574$var$getEffProp("parentNode");
const $9c38b931c8b22574$export$e8e77848f4a9ad40 = $9c38b931c8b22574$var$getEffProp("parentElement");
function $9c38b931c8b22574$export$13782f450ac5e09a(node) {
    return function() {
        return node.hasChildNodes();
    };
}
const $9c38b931c8b22574$export$c9fa23d9ff60a2d1 = $9c38b931c8b22574$var$getEffProp("childNodes");
const $9c38b931c8b22574$export$274e0d97326033db = $9c38b931c8b22574$var$getEffProp("firstChild");
const $9c38b931c8b22574$export$951f870fb0fe03c3 = $9c38b931c8b22574$var$getEffProp("lastChild");
const $9c38b931c8b22574$export$e2e6c080f0f2a76d = $9c38b931c8b22574$var$getEffProp("previousSibling");
const $9c38b931c8b22574$export$2eda4366e9b7c29f = $9c38b931c8b22574$var$getEffProp("nextSibling");
const $9c38b931c8b22574$export$d6cd495109f5e655 = $9c38b931c8b22574$var$getEffProp("nodeValue");
function $9c38b931c8b22574$export$df6212ebae08b450(value) {
    return function(node) {
        return function() {
            node.nodeValue = value;
        };
    };
}
const $9c38b931c8b22574$export$e0e0794250e9118f = $9c38b931c8b22574$var$getEffProp("textContent");
function $9c38b931c8b22574$export$94b0296cab6203e(value) {
    return function(node) {
        return function() {
            node.textContent = value;
        };
    };
}
function $9c38b931c8b22574$export$a3295358bff77e(node) {
    return function() {
        node.normalize();
    };
}
function $9c38b931c8b22574$export$9cd59f9826255e47(node) {
    return function() {
        return node.cloneNode(false);
    };
}
function $9c38b931c8b22574$export$b7d58db314e0ac27(node) {
    return function() {
        return node.cloneNode(true);
    };
}
function $9c38b931c8b22574$export$55e9b4d3368d84dd(node1) {
    return function(node2) {
        return function() {
            return node1.isEqualNode(node2);
        };
    };
}
function $9c38b931c8b22574$export$aff35b31398d5fba(node1) {
    return function(node2) {
        return function() {
            return node1.compareDocumentPosition(node2);
        };
    };
}
function $9c38b931c8b22574$export$2344b14b097df817(node1) {
    return function(node2) {
        return function() {
            return node1.contains(node2);
        };
    };
}
function $9c38b931c8b22574$export$b9a4e863f082a036(prefix) {
    return function(node) {
        return function() {
            return node.lookupPrefix(prefix);
        };
    };
}
function $9c38b931c8b22574$export$a79c57bed1c08193(ns) {
    return function(node) {
        return function() {
            return node.lookupNamespaceURI(ns);
        };
    };
}
function $9c38b931c8b22574$export$61f41c073d810e4f(ns) {
    return function(node) {
        return function() {
            return node.isDefaultNamespace(ns);
        };
    };
}
function $9c38b931c8b22574$export$86b68c7dbeb53c22(node1) {
    return function(node2) {
        return function(parent) {
            return function() {
                parent.insertBefore(node1, node2);
            };
        };
    };
}
function $9c38b931c8b22574$export$1b8e57c9ea42f1d2(node) {
    return function(parent) {
        return function() {
            parent.appendChild(node);
        };
    };
}
function $9c38b931c8b22574$export$46f78da0e790aab7(newChild) {
    return function(oldChild) {
        return function(parent) {
            return function() {
                parent.replaceChild(newChild, oldChild);
            };
        };
    };
}
function $9c38b931c8b22574$export$7ae609f7af59e4f7(node) {
    return function(parent) {
        return function() {
            parent.removeChild(node);
        };
    };
}









// Generated by purs version 0.15.15



var $aa7bef674fe53e14$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $aa7bef674fe53e14$export$dc064fe9e59310fd = /* #__PURE__ */ function() {
    function ElementNode() {}
    ElementNode.value = new ElementNode();
    return ElementNode;
}();
var $aa7bef674fe53e14$export$dc88047a888cd46b = /* #__PURE__ */ function() {
    function AttributeNode() {}
    AttributeNode.value = new AttributeNode();
    return AttributeNode;
}();
var $aa7bef674fe53e14$export$f0a25ea3087686aa = /* #__PURE__ */ function() {
    function TextNode() {}
    TextNode.value = new TextNode();
    return TextNode;
}();
var $aa7bef674fe53e14$export$28835d60136fdd55 = /* #__PURE__ */ function() {
    function CDATASectionNode() {}
    CDATASectionNode.value = new CDATASectionNode();
    return CDATASectionNode;
}();
var $aa7bef674fe53e14$export$a4de1a63043e7a6d = /* #__PURE__ */ function() {
    function EntityReferenceNode() {}
    EntityReferenceNode.value = new EntityReferenceNode();
    return EntityReferenceNode;
}();
var $aa7bef674fe53e14$export$34dac3329b92804f = /* #__PURE__ */ function() {
    function EntityNode() {}
    EntityNode.value = new EntityNode();
    return EntityNode;
}();
var $aa7bef674fe53e14$export$2458c2a2a9d8a0a8 = /* #__PURE__ */ function() {
    function ProcessingInstructionNode() {}
    ProcessingInstructionNode.value = new ProcessingInstructionNode();
    return ProcessingInstructionNode;
}();
var $aa7bef674fe53e14$export$dd3132c03c97153e = /* #__PURE__ */ function() {
    function CommentNode() {}
    CommentNode.value = new CommentNode();
    return CommentNode;
}();
var $aa7bef674fe53e14$export$9da34d55490083d8 = /* #__PURE__ */ function() {
    function DocumentNode() {}
    DocumentNode.value = new DocumentNode();
    return DocumentNode;
}();
var $aa7bef674fe53e14$export$c4edab6ab3262a44 = /* #__PURE__ */ function() {
    function DocumentTypeNode() {}
    DocumentTypeNode.value = new DocumentTypeNode();
    return DocumentTypeNode;
}();
var $aa7bef674fe53e14$export$ed75c007fb9b19c0 = /* #__PURE__ */ function() {
    function DocumentFragmentNode() {}
    DocumentFragmentNode.value = new DocumentFragmentNode();
    return DocumentFragmentNode;
}();
var $aa7bef674fe53e14$export$71dc25271abd047 = /* #__PURE__ */ function() {
    function NotationNode() {}
    NotationNode.value = new NotationNode();
    return NotationNode;
}();
var $aa7bef674fe53e14$var$toEnumNodeType = function(v) {
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$dc064fe9e59310fd.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$dc88047a888cd46b.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$f0a25ea3087686aa.value);
    if (v === 4) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$28835d60136fdd55.value);
    if (v === 5) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$a4de1a63043e7a6d.value);
    if (v === 6) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$34dac3329b92804f.value);
    if (v === 7) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$2458c2a2a9d8a0a8.value);
    if (v === 8) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$dd3132c03c97153e.value);
    if (v === 9) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$9da34d55490083d8.value);
    if (v === 10) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$c4edab6ab3262a44.value);
    if (v === 11) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$ed75c007fb9b19c0.value);
    if (v === 12) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$71dc25271abd047.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $aa7bef674fe53e14$export$eb0d4895a3e15732 = {
    show: function(v) {
        if (v instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return "ElementNode";
        if (v instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return "AttributeNode";
        if (v instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return "TextNode";
        if (v instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return "CDATASectionNode";
        if (v instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return "EntityReferenceNode";
        if (v instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return "EntityNode";
        if (v instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return "ProcessingInstructionNode";
        if (v instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return "CommentNode";
        if (v instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return "DocumentNode";
        if (v instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return "DocumentTypeNode";
        if (v instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return "DocumentFragmentNode";
        if (v instanceof $aa7bef674fe53e14$export$71dc25271abd047) return "NotationNode";
        throw new Error("Failed pattern match at Web.DOM.NodeType (line 39, column 1 - line 51, column 37): " + [
            v.constructor.name
        ]);
    }
};
var $aa7bef674fe53e14$var$fromEnumNodeType = function(v) {
    if (v instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return 1;
    if (v instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return 2;
    if (v instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return 3;
    if (v instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return 4;
    if (v instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return 5;
    if (v instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return 6;
    if (v instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return 7;
    if (v instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return 8;
    if (v instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return 9;
    if (v instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return 10;
    if (v instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return 11;
    if (v instanceof $aa7bef674fe53e14$export$71dc25271abd047) return 12;
    throw new Error("Failed pattern match at Web.DOM.NodeType (line 68, column 1 - line 68, column 36): " + [
        v.constructor.name
    ]);
};
var $aa7bef674fe53e14$export$88377e09539feb78 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd && y instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return true;
            if (x instanceof $aa7bef674fe53e14$export$dc88047a888cd46b && y instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return true;
            if (x instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa && y instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return true;
            if (x instanceof $aa7bef674fe53e14$export$28835d60136fdd55 && y instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return true;
            if (x instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d && y instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return true;
            if (x instanceof $aa7bef674fe53e14$export$34dac3329b92804f && y instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return true;
            if (x instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8 && y instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return true;
            if (x instanceof $aa7bef674fe53e14$export$dd3132c03c97153e && y instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return true;
            if (x instanceof $aa7bef674fe53e14$export$9da34d55490083d8 && y instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return true;
            if (x instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44 && y instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return true;
            if (x instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0 && y instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return true;
            if (x instanceof $aa7bef674fe53e14$export$71dc25271abd047 && y instanceof $aa7bef674fe53e14$export$71dc25271abd047) return true;
            return false;
        };
    }
};
var $aa7bef674fe53e14$export$98741689c6e0b987 = {
    compare: function(x) {
        return function(y) {
            return $aa7bef674fe53e14$var$compare($aa7bef674fe53e14$var$fromEnumNodeType(x))($aa7bef674fe53e14$var$fromEnumNodeType(y));
        };
    },
    Eq0: function() {
        return $aa7bef674fe53e14$export$88377e09539feb78;
    }
};
var $aa7bef674fe53e14$export$61b56a5f9f6230cb = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($aa7bef674fe53e14$var$toEnumNodeType)($aa7bef674fe53e14$var$fromEnumNodeType),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($aa7bef674fe53e14$var$toEnumNodeType)($aa7bef674fe53e14$var$fromEnumNodeType),
    Ord0: function() {
        return $aa7bef674fe53e14$export$98741689c6e0b987;
    }
};
var $aa7bef674fe53e14$export$5879f3f4738185fd = /* #__PURE__ */ function() {
    return {
        bottom: $aa7bef674fe53e14$export$dc064fe9e59310fd.value,
        top: $aa7bef674fe53e14$export$71dc25271abd047.value,
        Ord0: function() {
            return $aa7bef674fe53e14$export$98741689c6e0b987;
        }
    };
}();
var $aa7bef674fe53e14$export$db18e9bcd7fea75b = {
    cardinality: 12,
    toEnum: $aa7bef674fe53e14$var$toEnumNodeType,
    fromEnum: $aa7bef674fe53e14$var$fromEnumNodeType,
    Bounded0: function() {
        return $aa7bef674fe53e14$export$5879f3f4738185fd;
    },
    Enum1: function() {
        return $aa7bef674fe53e14$export$61b56a5f9f6230cb;
    }
};



var $43db1f7c9150eb00$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $43db1f7c9150eb00$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $43db1f7c9150eb00$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($aa7bef674fe53e14$export$db18e9bcd7fea75b);
var $43db1f7c9150eb00$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $43db1f7c9150eb00$export$6c33a601ef71fce7 = /* #__PURE__ */ function() {
    var $4 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($9c38b931c8b22574$export$e2e6c080f0f2a76d($5));
    };
}();
var $43db1f7c9150eb00$export$b54be7ce267a037b = /* #__PURE__ */ function() {
    var $6 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($7) {
        return $6($9c38b931c8b22574$export$72030ded560177b6($7));
    };
}();
var $43db1f7c9150eb00$export$222ab8a52715b4f4 = /* #__PURE__ */ function() {
    var $8 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($9) {
        return $8($9c38b931c8b22574$export$e8e77848f4a9ad40($9));
    };
}();
var $43db1f7c9150eb00$export$512a1115db01100d = /* #__PURE__ */ function() {
    var $10 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($11) {
        return $10($9c38b931c8b22574$export$23cc1b2a9bb6c61a($11));
    };
}();
var $43db1f7c9150eb00$export$63bfedaececbd5f5 = /* #__PURE__ */ function() {
    var $12 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($13) {
        return $12($9c38b931c8b22574$export$d6cd495109f5e655($13));
    };
}();
var $43db1f7c9150eb00$export$4debbe1037afe35e = function() {
    return function($14) {
        return $43db1f7c9150eb00$var$fromJust($43db1f7c9150eb00$var$toEnum($9c38b931c8b22574$export$c441300b2d51b958($14)));
    };
};
var $43db1f7c9150eb00$export$335219007e689d29 = /* #__PURE__ */ function() {
    var $15 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($16) {
        return $15($9c38b931c8b22574$export$2eda4366e9b7c29f($16));
    };
}();
var $43db1f7c9150eb00$export$20ad2ac0440a470d = function(p) {
    var $17 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $18 = $9c38b931c8b22574$export$b9a4e863f082a036(p);
    return function($19) {
        return $17($18($19));
    };
};
var $43db1f7c9150eb00$export$eca9f13e904be86a = function(ns) {
    var $20 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $21 = $9c38b931c8b22574$export$a79c57bed1c08193(ns);
    return function($22) {
        return $20($21($22));
    };
};
var $43db1f7c9150eb00$export$86c2694e50e8251b = /* #__PURE__ */ function() {
    var $23 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($24) {
        return $23($9c38b931c8b22574$export$951f870fb0fe03c3($24));
    };
}();
var $43db1f7c9150eb00$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Node");
var $43db1f7c9150eb00$export$b212a48622cd6ee3 = /* #__PURE__ */ function() {
    var $25 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($26) {
        return $25($9c38b931c8b22574$export$274e0d97326033db($26));
    };
}();






var $80d0fbcfdca571e1$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $80d0fbcfdca571e1$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $80d0fbcfdca571e1$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $80d0fbcfdca571e1$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($6c2f8951ecf9531e$export$89bf999217d3022a)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $80d0fbcfdca571e1$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $80d0fbcfdca571e1$var$when = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$a55877ca9db47377($6c2f8951ecf9531e$export$89bf999217d3022a);
var $80d0fbcfdca571e1$var$not = /* #__PURE__ */ $f8fc227945eb179e$export$6003a5f097c73977(/* #__PURE__ */ $f8fc227945eb179e$export$e9ae480d80dfc592(/* #__PURE__ */ $f8fc227945eb179e$export$e9ae480d80dfc592($f8fc227945eb179e$export$d7d9283ee84f4c3f)));
var $80d0fbcfdca571e1$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $80d0fbcfdca571e1$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $80d0fbcfdca571e1$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $80d0fbcfdca571e1$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $80d0fbcfdca571e1$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $80d0fbcfdca571e1$var$RenderState = function(x) {
    return x;
};
var $80d0fbcfdca571e1$var$substInParent = function(v) {
    return function(v1) {
        return function(v2) {
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $80d0fbcfdca571e1$var$$$void($9c38b931c8b22574$export$86b68c7dbeb53c22(v)(v1.value0)(v2.value0));
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $80d0fbcfdca571e1$var$$$void($9c38b931c8b22574$export$1b8e57c9ea42f1d2(v)(v2.value0));
            return $80d0fbcfdca571e1$var$pure($05149ea687d6b460$export$523c0b569236b342);
        };
    };
};
var $80d0fbcfdca571e1$var$removeChild = function(v) {
    return function __do() {
        var npn = $43db1f7c9150eb00$export$b54be7ce267a037b(v.node)();
        return $80d0fbcfdca571e1$var$traverse_(function(pn) {
            return $9c38b931c8b22574$export$7ae609f7af59e4f7(v.node)(pn);
        })(npn)();
    };
};
var $80d0fbcfdca571e1$var$mkSpec = function(handler) {
    return function(renderChildRef) {
        return function(document) {
            var getNode = $ef932f98609e5673$export$b29cd3b133bc0fa4(function(v) {
                return v.node;
            });
            var done = function(st) {
                if (st instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(st.value0);
                return $05149ea687d6b460$export$523c0b569236b342;
            };
            var buildWidget = function(spec) {
                var buildThunk = $f1bf345cdb6c789d$export$d46b23c375182cf8($80d0fbcfdca571e1$var$unwrap)(spec);
                var $lazy_patch = $80d0fbcfdca571e1$var$$runtime_lazy("patch", "Halogen.VDom.Driver", function() {
                    return function(st, slot) {
                        if (st instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            if (slot instanceof $eea39ea934373596$export$bbf8b056cc92e88d) {
                                $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(st.value0);
                                return $lazy_renderComponentSlot(100)(slot.value0);
                            }
                            if (slot instanceof $eea39ea934373596$export$5e46cfa5e835a582) {
                                var step$prime = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(st.value0, slot.value0);
                                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($47a0a3ebf66dcc6a$export$f9380c9a627682d3(step$prime), new $06733ae99ed4f534$export$8a67b48435b5d073(step$prime), $lazy_patch(103), done));
                            }
                            throw new Error("Failed pattern match at Halogen.VDom.Driver (line 97, column 22 - line 103, column 79): " + [
                                slot.constructor.name
                            ]);
                        }
                        return $lazy_render(104)(slot);
                    };
                });
                var $lazy_render = $80d0fbcfdca571e1$var$$runtime_lazy("render", "Halogen.VDom.Driver", function() {
                    return function(slot) {
                        if (slot instanceof $eea39ea934373596$export$bbf8b056cc92e88d) return $lazy_renderComponentSlot(86)(slot.value0);
                        if (slot instanceof $eea39ea934373596$export$5e46cfa5e835a582) {
                            var step = buildThunk(slot.value0);
                            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($47a0a3ebf66dcc6a$export$f9380c9a627682d3(step), new $06733ae99ed4f534$export$8a67b48435b5d073(step), $lazy_patch(89), done));
                        }
                        throw new Error("Failed pattern match at Halogen.VDom.Driver (line 84, column 7 - line 89, column 75): " + [
                            slot.constructor.name
                        ]);
                    };
                });
                var $lazy_renderComponentSlot = $80d0fbcfdca571e1$var$$runtime_lazy("renderComponentSlot", "Halogen.VDom.Driver", function() {
                    return function(cs) {
                        var renderChild = $e521936ea118867a$export$aafa59e2e03f2942(renderChildRef)();
                        var rsx = renderChild(cs)();
                        var node = getNode(rsx);
                        return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(node, $06733ae99ed4f534$export$bebe9059409a0d04.value, $lazy_patch(117), done));
                    };
                });
                var patch = $lazy_patch(91);
                var render = $lazy_render(82);
                var renderComponentSlot = $lazy_renderComponentSlot(109);
                return render;
            };
            var buildAttributes = $f9cd20a8b77a6bf5$export$ff441cf2113a23d9(handler);
            return {
                buildWidget: buildWidget,
                buildAttributes: buildAttributes,
                document: document
            };
        };
    };
};
var $80d0fbcfdca571e1$var$renderSpec = function(document) {
    return function(container) {
        var render = function(handler) {
            return function(child) {
                return function(v) {
                    return function(v1) {
                        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return function __do() {
                            var renderChildRef = $90327512d8280b8d$export$b8cb59497041ffe4(child)();
                            var spec = $80d0fbcfdca571e1$var$mkSpec(handler)(renderChildRef)(document);
                            var machine = $784c06f0344d34c4$export$7d13c0f6790d0505(spec)(v);
                            var node = $47a0a3ebf66dcc6a$export$f9380c9a627682d3(machine);
                            $80d0fbcfdca571e1$var$$$void($9c38b931c8b22574$export$1b8e57c9ea42f1d2(node)($5ae75883a0b7923c$export$83a0de4644f1fbc4(container)))();
                            return {
                                machine: machine,
                                node: node,
                                renderChildRef: renderChildRef
                            };
                        };
                        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function __do() {
                            $e521936ea118867a$export$68d8715fc104d294(child)(v1.value0.renderChildRef)();
                            var parent = $43db1f7c9150eb00$export$b54be7ce267a037b(v1.value0.node)();
                            var nextSib = $43db1f7c9150eb00$export$335219007e689d29(v1.value0.node)();
                            var machine$prime = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(v1.value0.machine, v);
                            var newNode = $47a0a3ebf66dcc6a$export$f9380c9a627682d3(machine$prime);
                            $80d0fbcfdca571e1$var$when($80d0fbcfdca571e1$var$not($871d3d7bcf6be72e$export$54d9901699893a6)(v1.value0.node)(newNode))($80d0fbcfdca571e1$var$substInParent(newNode)(nextSib)(parent))();
                            return {
                                machine: machine$prime,
                                node: newNode,
                                renderChildRef: v1.value0.renderChildRef
                            };
                        };
                        throw new Error("Failed pattern match at Halogen.VDom.Driver (line 157, column 5 - line 173, column 80): " + [
                            v1.constructor.name
                        ]);
                    };
                };
            };
        };
        return {
            render: render,
            renderChild: $80d0fbcfdca571e1$var$identity,
            removeChild: $80d0fbcfdca571e1$var$removeChild,
            dispose: $80d0fbcfdca571e1$var$removeChild
        };
    };
};
var $80d0fbcfdca571e1$export$32d31a833a940d1c = function(component) {
    return function(i) {
        return function(element) {
            return $80d0fbcfdca571e1$var$bind1($80d0fbcfdca571e1$var$liftEffect($80d0fbcfdca571e1$var$map($f6c9290a5db8f197$export$ce0e204f587740c3)($80d0fbcfdca571e1$var$bindFlipped($aa35a24624ec08d2$export$5a7bfc01df82fcd1)($2603425f82e959df$export$8291e5b88f90ce4))))(function(document) {
                return $f469b52d7c3c8200$export$32d31a833a940d1c($80d0fbcfdca571e1$var$renderSpec(document)(element))(component)(i);
            });
        };
    };
};


// Generated by purs version 0.15.15
"use strict";
function $2b45368bab43c21e$export$537df99a1009ce4c(json) {
    return JSON.stringify(json, null, 2);
}


































var $8912ce2c57a5c27a$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $8912ce2c57a5c27a$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$34a2521cb7920188);
var $8912ce2c57a5c27a$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $8912ce2c57a5c27a$var$fromFoldableWithIndex = /* #__PURE__ */ $c045ea5df33bba60$export$78cfe3464e7eb77b($ea3eb84de0acf574$export$91e1c50dfb7225a6);
var $8912ce2c57a5c27a$var$toUnfoldable = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $8912ce2c57a5c27a$var$fromFoldable = /* #__PURE__ */ $c045ea5df33bba60$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8912ce2c57a5c27a$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $8912ce2c57a5c27a$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $8912ce2c57a5c27a$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $8912ce2c57a5c27a$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $8912ce2c57a5c27a$var$fromFoldable1 = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072($97ffb09cc3d11a32$export$b51fa3f60ce66bf3)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8912ce2c57a5c27a$var$toUnfoldable1 = /* #__PURE__ */ $c045ea5df33bba60$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $8912ce2c57a5c27a$var$fromFoldable2 = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072($97ffb09cc3d11a32$export$566951113c2c5ddd)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8912ce2c57a5c27a$var$fromFoldableWithIndex1 = /* #__PURE__ */ $ea3eb84de0acf574$export$78cfe3464e7eb77b($97937c29f879e68e$export$c5f2758e49b2b86a)($c045ea5df33bba60$export$341deb6f42c48978);
var $8912ce2c57a5c27a$var$fromFoldable3 = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072(/* #__PURE__ */ $71f2e2e9476163f8$export$8f11eb03746a66e2($97937c29f879e68e$export$c5f2758e49b2b86a)($97937c29f879e68e$export$c5f2758e49b2b86a))($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8912ce2c57a5c27a$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $8912ce2c57a5c27a$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($97ffb09cc3d11a32$export$642f92ca6de37b54);
var $8912ce2c57a5c27a$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($97ffb09cc3d11a32$export$1cd099438f719ac7);
var $8912ce2c57a5c27a$var$show3 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($97ffb09cc3d11a32$export$e0728f9a6ccaeb32);
var $8912ce2c57a5c27a$var$show4 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $6416bd93bb20ed95$export$26082705e1e7e214($364547bd6bbe186e$export$6c410b696f956741));
var $8912ce2c57a5c27a$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $8912ce2c57a5c27a$var$show5 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($f8662a4a41464b67$export$c936a351b926aade);
var $8912ce2c57a5c27a$var$$$for = /* #__PURE__ */ $11d1e86de605dfc6$export$f89de2e5bf57e5e6($06733ae99ed4f534$export$b203ef4465f15037)($11d1e86de605dfc6$export$9e4a28683e28e26a);
var $8912ce2c57a5c27a$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $8912ce2c57a5c27a$var$parseNotation = /* #__PURE__ */ $6416bd93bb20ed95$export$a1d30b4ebfb67400(/* #__PURE__ */ $6416bd93bb20ed95$export$9856c32cde0cc9aa($364547bd6bbe186e$export$6c410b696f956741));
var $8912ce2c57a5c27a$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $8912ce2c57a5c27a$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $8912ce2c57a5c27a$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$9e4a28683e28e26a);
var $8912ce2c57a5c27a$var$sequence1 = /* #__PURE__ */ $8912ce2c57a5c27a$var$sequence($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $8912ce2c57a5c27a$var$bind2 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $e9bda291f4ec10ec$export$f28534bdc7259c7($7d4cccdf062a2261$export$b3b4ecb28e3a8df3));
var $8912ce2c57a5c27a$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($e9bda291f4ec10ec$export$5e0a9e9fea50cb88)($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $8912ce2c57a5c27a$var$ordRecord = /* #__PURE__ */ $97937c29f879e68e$export$ebb7a7956d139174();
var $8912ce2c57a5c27a$var$ordRecordCons = /* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611($97937c29f879e68e$export$927f7db8ecc0069f)();
var $8912ce2c57a5c27a$var$ordRecord1 = /* #__PURE__ */ $8912ce2c57a5c27a$var$ordRecord(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $8912ce2c57a5c27a$var$ordRecordCons({
    reflectSymbol: function() {
        return "pitch";
    }
})(/* #__PURE__ */ $6416bd93bb20ed95$export$cddf5df7d4d146c7($364547bd6bbe186e$export$aa156b69905f503)))()({
    reflectSymbol: function() {
        return "id";
    }
})($97937c29f879e68e$export$c5f2758e49b2b86a));
var $8912ce2c57a5c27a$var$ordStartStop = /* #__PURE__ */ $97ffb09cc3d11a32$export$51153a4951aa543e($8912ce2c57a5c27a$var$ordRecord1);
var $8912ce2c57a5c27a$var$ordRecord2 = /* #__PURE__ */ $8912ce2c57a5c27a$var$ordRecord(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $8912ce2c57a5c27a$var$ordRecordCons({
    reflectSymbol: function() {
        return "right";
    }
})($8912ce2c57a5c27a$var$ordStartStop))()({
    reflectSymbol: function() {
        return "left";
    }
})($8912ce2c57a5c27a$var$ordStartStop));
var $8912ce2c57a5c27a$var$fromFoldable4 = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072($8912ce2c57a5c27a$var$ordRecord2)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8912ce2c57a5c27a$var$fromFoldable5 = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072($8912ce2c57a5c27a$var$ordRecord1)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8912ce2c57a5c27a$var$applicativeStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$5cbc630d6fbe2e14($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $8912ce2c57a5c27a$var$pure2 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($8912ce2c57a5c27a$var$applicativeStateT);
var $8912ce2c57a5c27a$var$on = /* #__PURE__ */ $a5ccce070b256bc7$export$af631764ddc44097();
var $8912ce2c57a5c27a$var$tooManyChildrenIsSymbol = {
    reflectSymbol: function() {
        return "tooManyChildren";
    }
};
var $8912ce2c57a5c27a$var$on1 = /* #__PURE__ */ $8912ce2c57a5c27a$var$on($8912ce2c57a5c27a$var$tooManyChildrenIsSymbol);
var $8912ce2c57a5c27a$var$bothChildrenIsSymbol = {
    reflectSymbol: function() {
        return "bothChildren";
    }
};
var $8912ce2c57a5c27a$var$on2 = /* #__PURE__ */ $8912ce2c57a5c27a$var$on($8912ce2c57a5c27a$var$bothChildrenIsSymbol);
var $8912ce2c57a5c27a$var$rightChildIsSymbol = {
    reflectSymbol: function() {
        return "rightChild";
    }
};
var $8912ce2c57a5c27a$var$on3 = /* #__PURE__ */ $8912ce2c57a5c27a$var$on($8912ce2c57a5c27a$var$rightChildIsSymbol);
var $8912ce2c57a5c27a$var$leftChildIsSymbol = {
    reflectSymbol: function() {
        return "leftChild";
    }
};
var $8912ce2c57a5c27a$var$on4 = /* #__PURE__ */ $8912ce2c57a5c27a$var$on($8912ce2c57a5c27a$var$leftChildIsSymbol);
var $8912ce2c57a5c27a$var$fromFoldable6 = /* #__PURE__ */ $a393155e52307a24$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593)($8912ce2c57a5c27a$var$ordRecord2);
var $8912ce2c57a5c27a$var$freezeOnlyIsSymbol = {
    reflectSymbol: function() {
        return "freezeOnly";
    }
};
var $8912ce2c57a5c27a$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88(/* #__PURE__ */ $e9bda291f4ec10ec$export$d5449d946db19e3a($7d4cccdf062a2261$export$f0a413d3d6075601));
var $8912ce2c57a5c27a$var$freezeLeftIsSymbol = {
    reflectSymbol: function() {
        return "freezeLeft";
    }
};
var $8912ce2c57a5c27a$var$horiIsSymbol = {
    reflectSymbol: function() {
        return "hori";
    }
};
var $8912ce2c57a5c27a$var$splitRightIsSymbol = {
    reflectSymbol: function() {
        return "splitRight";
    }
};
var $8912ce2c57a5c27a$var$splitOnlyIsSymbol = {
    reflectSymbol: function() {
        return "splitOnly";
    }
};
var $8912ce2c57a5c27a$var$splitLeftIsSymbol = {
    reflectSymbol: function() {
        return "splitLeft";
    }
};
var $8912ce2c57a5c27a$var$evalStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$99aa49a66d7c0535($7d4cccdf062a2261$export$f0a413d3d6075601);
var $8912ce2c57a5c27a$var$sequence2 = /* #__PURE__ */ $8912ce2c57a5c27a$var$sequence($8912ce2c57a5c27a$var$applicativeStateT);
var $8912ce2c57a5c27a$var$fromFoldable7 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($a393155e52307a24$export$fd19c21b7e75dff0);
var $8912ce2c57a5c27a$var$inj = /* #__PURE__ */ $a5ccce070b256bc7$export$38d8e7a5e0c746a7();
var $8912ce2c57a5c27a$var$inj1 = /* #__PURE__ */ $8912ce2c57a5c27a$var$inj($8912ce2c57a5c27a$var$leftChildIsSymbol);
var $8912ce2c57a5c27a$var$inj2 = /* #__PURE__ */ $8912ce2c57a5c27a$var$inj($8912ce2c57a5c27a$var$rightChildIsSymbol);
var $8912ce2c57a5c27a$var$inj3 = /* #__PURE__ */ $8912ce2c57a5c27a$var$inj($8912ce2c57a5c27a$var$bothChildrenIsSymbol);
var $8912ce2c57a5c27a$var$inj4 = /* #__PURE__ */ $8912ce2c57a5c27a$var$inj($8912ce2c57a5c27a$var$tooManyChildrenIsSymbol);
var $8912ce2c57a5c27a$var$inj5 = /* #__PURE__ */ $8912ce2c57a5c27a$var$inj($8912ce2c57a5c27a$var$freezeLeftIsSymbol);
var $8912ce2c57a5c27a$var$inj6 = /* #__PURE__ */ $8912ce2c57a5c27a$var$inj($8912ce2c57a5c27a$var$freezeOnlyIsSymbol);
var $8912ce2c57a5c27a$var$inj7 = /* #__PURE__ */ $8912ce2c57a5c27a$var$inj($8912ce2c57a5c27a$var$splitLeftIsSymbol);
var $8912ce2c57a5c27a$var$inj8 = /* #__PURE__ */ $8912ce2c57a5c27a$var$inj($8912ce2c57a5c27a$var$splitOnlyIsSymbol);
var $8912ce2c57a5c27a$var$inj9 = /* #__PURE__ */ $8912ce2c57a5c27a$var$inj($8912ce2c57a5c27a$var$splitRightIsSymbol);
var $8912ce2c57a5c27a$var$inj10 = /* #__PURE__ */ $8912ce2c57a5c27a$var$inj($8912ce2c57a5c27a$var$horiIsSymbol);
var $8912ce2c57a5c27a$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($97ffb09cc3d11a32$export$2cda0bd0f22dfe3e);
var $8912ce2c57a5c27a$var$fromFoldable8 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $8912ce2c57a5c27a$export$8abb76518727e4db = function(dictWriteForeign) {
    var $337 = $f505976c723c2a85$export$be94bcd43c4d1340(dictWriteForeign);
    return function($338) {
        return $2b45368bab43c21e$export$537df99a1009ce4c($337($338));
    };
};
var $8912ce2c57a5c27a$export$e5ef535447be5f00 = function(v) {
    var unwrapTransitions = $8912ce2c57a5c27a$var$map($8912ce2c57a5c27a$var$lmap(function(v1) {
        return $8912ce2c57a5c27a$var$show(v1);
    }));
    var unwrapSlices = $8912ce2c57a5c27a$var$map($8912ce2c57a5c27a$var$lmap(function(v1) {
        return $8912ce2c57a5c27a$var$show(v1);
    }));
    var unwrapEdge = function(v1) {
        return {
            edge: {
                left: v1.value0.value0,
                right: v1.value0.value1
            },
            style: v1.value1
        };
    };
    return {
        noteStyles: $8912ce2c57a5c27a$var$fromFoldableWithIndex(v.notes),
        edgeStyles: $8912ce2c57a5c27a$var$map(unwrapEdge)($8912ce2c57a5c27a$var$toUnfoldable(v.edges)),
        sliceStyles: $8912ce2c57a5c27a$var$fromFoldable(unwrapSlices($8912ce2c57a5c27a$var$toUnfoldable(v.slices))),
        transStyles: $8912ce2c57a5c27a$var$fromFoldable(unwrapTransitions($8912ce2c57a5c27a$var$toUnfoldable(v.transitions))),
        css: v.css,
        staffType: function() {
            if (v.staff instanceof $97ffb09cc3d11a32$export$22537d7be8fe89a9) return "treble";
            if (v.staff instanceof $97ffb09cc3d11a32$export$657222a21023cba0) return "bass";
            if (v.staff instanceof $97ffb09cc3d11a32$export$725d191431df39a2) return "grand";
            throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 148, column 16 - line 151, column 28): " + [
                v.staff.constructor.name
            ]);
        }()
    };
};
var $8912ce2c57a5c27a$export$b5b6a770010592f1 = function(v) {
    var wrapEdges = function(v1) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.edge.left, v1.edge.right), v1.style);
    };
    var readId = function(constructor) {
        var parse = function(v1) {
            return $8912ce2c57a5c27a$var$bind($06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515("cannot parse " + (v1.value0 + "as integer.")))($7d4cccdf062a2261$export$19db0165690c701a.create)($8d5664f12212b23e$export$3004f64547af360e(v1.value0)))(function(id$prime) {
                return $8912ce2c57a5c27a$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(constructor(id$prime), v1.value1));
            });
        };
        return $8912ce2c57a5c27a$var$traverse(parse);
    };
    return $8912ce2c57a5c27a$var$bind($8912ce2c57a5c27a$var$map1($8912ce2c57a5c27a$var$fromFoldable1)(readId($97ffb09cc3d11a32$export$9c29222029185c78)($8912ce2c57a5c27a$var$toUnfoldable1(v.sliceStyles))))(function(slices) {
        return $8912ce2c57a5c27a$var$bind($8912ce2c57a5c27a$var$map1($8912ce2c57a5c27a$var$fromFoldable2)(readId($97ffb09cc3d11a32$export$630321727b9ef04a)($8912ce2c57a5c27a$var$toUnfoldable1(v.transStyles))))(function(transitions) {
            return $8912ce2c57a5c27a$var$bind(function() {
                if (v.staffType === "treble") return $8912ce2c57a5c27a$var$pure($97ffb09cc3d11a32$export$22537d7be8fe89a9.value);
                if (v.staffType === "bass") return $8912ce2c57a5c27a$var$pure($97ffb09cc3d11a32$export$657222a21023cba0.value);
                if (v.staffType === "grand") return $8912ce2c57a5c27a$var$pure($97ffb09cc3d11a32$export$725d191431df39a2.value);
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Unexpected staff type: " + (v.staffType + " (expected treble, bass, or grand)."));
            }())(function(staff) {
                return $8912ce2c57a5c27a$var$pure({
                    notes: $8912ce2c57a5c27a$var$fromFoldableWithIndex1(v.noteStyles),
                    edges: $8912ce2c57a5c27a$var$fromFoldable3($8912ce2c57a5c27a$var$map(wrapEdges)(v.edgeStyles)),
                    slices: slices,
                    transitions: transitions,
                    css: v.css,
                    staff: staff
                });
            });
        });
    });
};
var $8912ce2c57a5c27a$export$cb4ad9d58b26f093 = /* #__PURE__ */ $8912ce2c57a5c27a$var$map(function(v) {
    return {
        time: v.time,
        notes: $8912ce2c57a5c27a$var$map(function(v1) {
            return {
                hold: v1.hold,
                pitch: v1.pitch
            };
        })(v.notes)
    };
});
var $8912ce2c57a5c27a$export$c62c30b861fbaae = function(v) {
    var unwrap = function(f) {
        return function(v1) {
            return {
                parent: v1.value0,
                children: $8912ce2c57a5c27a$var$map(function(v2) {
                    return {
                        child: v2.child,
                        orn: f(v2.orn)
                    };
                })(v1.value1)
            };
        };
    };
    var regToJSON = function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $06733ae99ed4f534$export$8a67b48435b5d073("RootNote");
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $8912ce2c57a5c27a$var$map2($8912ce2c57a5c27a$var$show1)(v1.value0);
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 199, column 15 - line 201, column 26): " + [
            v1.constructor.name
        ]);
    };
    return {
        regular: $8912ce2c57a5c27a$var$map(unwrap(regToJSON))($8912ce2c57a5c27a$var$toUnfoldable(v.regular)),
        passing: $8912ce2c57a5c27a$var$map(unwrap($8912ce2c57a5c27a$var$map2($8912ce2c57a5c27a$var$show1)))($8912ce2c57a5c27a$var$toUnfoldable(v.passing)),
        fromLeft: $8912ce2c57a5c27a$var$map(unwrap($8912ce2c57a5c27a$var$map2($8912ce2c57a5c27a$var$show2)))($8912ce2c57a5c27a$var$toUnfoldable(v.fromLeft)),
        fromRight: $8912ce2c57a5c27a$var$map(unwrap($8912ce2c57a5c27a$var$map2($8912ce2c57a5c27a$var$show3)))($8912ce2c57a5c27a$var$toUnfoldable(v.fromRight)),
        unexplained: new $06733ae99ed4f534$export$8a67b48435b5d073(v.unexplained),
        keepLeft: v.keepLeft,
        keepRight: v.keepRight,
        passLeft: v.passLeft,
        passRight: v.passRight,
        ids: new $06733ae99ed4f534$export$8a67b48435b5d073(v.ids)
    };
};
var $8912ce2c57a5c27a$export$a0e53ffd16d8e36a = /* #__PURE__ */ function() {
    var noteToJSON = function(v) {
        return {
            hold: v.hold,
            id: v.note.id,
            pitch: $8912ce2c57a5c27a$var$show4(v.note.pitch)
        };
    };
    return $8912ce2c57a5c27a$var$map(function(v) {
        return {
            time: $7d4cccdf062a2261$export$5f5be1bb6cd1fded($8912ce2c57a5c27a$var$identity)($8912ce2c57a5c27a$var$show5)(v.time),
            notes: $8912ce2c57a5c27a$var$map(noteToJSON)(v.notes)
        };
    });
}();
var $8912ce2c57a5c27a$export$8419a7734705a8ef = function(piece) {
    return $8912ce2c57a5c27a$var$$$for(piece)(function(slice) {
        return $8912ce2c57a5c27a$var$bind1($8912ce2c57a5c27a$var$$$for(slice.notes)(function(note) {
            return $8912ce2c57a5c27a$var$map2(function(p) {
                return {
                    hold: note.hold,
                    note: {
                        pitch: p,
                        id: note.id
                    }
                };
            })($8912ce2c57a5c27a$var$parseNotation(note.pitch));
        }))(function(notes) {
            return $8912ce2c57a5c27a$var$pure1({
                time: $f8662a4a41464b67$export$c9698ec7f05a07e1(slice.time),
                notes: $97ffb09cc3d11a32$export$eb09cde4717acf6b(notes)
            });
        });
    });
};
var $8912ce2c57a5c27a$export$cba583ef5f26c5a6 = function(dictMonad) {
    var bindStateT = $e9bda291f4ec10ec$export$f28534bdc7259c7(dictMonad);
    var monadStateStateT = $e9bda291f4ec10ec$export$fc3b89a546fa5c5c(dictMonad);
    var discard1 = $8912ce2c57a5c27a$var$discard(bindStateT);
    var put = $f2d5035ce6148af6$export$327f7b26ebf455db(monadStateStateT);
    var pure3 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad));
    return $70cd3177464e7915$export$2385a24977818dd0(bindStateT)($f2d5035ce6148af6$export$3988ae62b71be9a3(monadStateStateT))(function(v) {
        return discard1(put({
            nextT: v.nextT + 1 | 0,
            nextS: v.nextS
        }))(function() {
            return pure3(v.nextT);
        });
    });
};
var $8912ce2c57a5c27a$var$newTId1 = /* #__PURE__ */ $8912ce2c57a5c27a$export$cba583ef5f26c5a6($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $8912ce2c57a5c27a$export$34164289f5e8ce07 = function(dictMonad) {
    var bindStateT = $e9bda291f4ec10ec$export$f28534bdc7259c7(dictMonad);
    var monadStateStateT = $e9bda291f4ec10ec$export$fc3b89a546fa5c5c(dictMonad);
    var discard1 = $8912ce2c57a5c27a$var$discard(bindStateT);
    var put = $f2d5035ce6148af6$export$327f7b26ebf455db(monadStateStateT);
    var pure3 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad));
    return $70cd3177464e7915$export$2385a24977818dd0(bindStateT)($f2d5035ce6148af6$export$3988ae62b71be9a3(monadStateStateT))(function(v) {
        return discard1(put({
            nextT: v.nextT,
            nextS: v.nextS + 1 | 0
        }))(function() {
            return pure3(v.nextS);
        });
    });
};
var $8912ce2c57a5c27a$var$newSId1 = /* #__PURE__ */ $8912ce2c57a5c27a$export$34164289f5e8ce07($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $8912ce2c57a5c27a$export$495f457280e88f3a = function(v) {
    var wrap = function(read) {
        return function(v1) {
            var children$prime = $8912ce2c57a5c27a$var$sequence1($8912ce2c57a5c27a$var$map(function(v2) {
                return $8912ce2c57a5c27a$var$map1(function(v3) {
                    return {
                        child: v2.child,
                        orn: v3
                    };
                })(read(v2.orn));
            })(v1.children));
            return $8912ce2c57a5c27a$var$map1($71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.parent))(children$prime);
        };
    };
    var readRightOrnament = function(v1) {
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "RightNeighbor") return new $7d4cccdf062a2261$export$19db0165690c701a(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$fd951dac679282e1.value));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "RightRepeat") return new $7d4cccdf062a2261$export$19db0165690c701a(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$ef0b5f914041d38a.value));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Expected right ornament type but got " + v1.value0);
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$19db0165690c701a($06733ae99ed4f534$export$bebe9059409a0d04.value);
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 328, column 23 - line 332, column 29): " + [
            v1.constructor.name
        ]);
    };
    var readPassingOrnament = function(v1) {
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "PassingMid") return new $7d4cccdf062a2261$export$19db0165690c701a(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$b62f635e41790a80.value));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "PassingLeft") return new $7d4cccdf062a2261$export$19db0165690c701a(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$dab08a4db0f3867f.value));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "PassingRight") return new $7d4cccdf062a2261$export$19db0165690c701a(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$9cce9eb8c466c42b.value));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Expected passing ornament type but got " + v1.value0);
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$19db0165690c701a($06733ae99ed4f534$export$bebe9059409a0d04.value);
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 321, column 25 - line 326, column 29): " + [
            v1.constructor.name
        ]);
    };
    var readLeftOrnament = function(v1) {
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "LeftNeighbor") return new $7d4cccdf062a2261$export$19db0165690c701a(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$7bb038d575dcf9c9.value));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "LeftRepeat") return new $7d4cccdf062a2261$export$19db0165690c701a(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$e32a75e677fca455.value));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Expected left ornament type but got " + v1.value0);
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$19db0165690c701a($06733ae99ed4f534$export$bebe9059409a0d04.value);
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 334, column 22 - line 338, column 29): " + [
            v1.constructor.name
        ]);
    };
    var readDoubleOrnament = function(v1) {
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "RootNote") return new $7d4cccdf062a2261$export$19db0165690c701a(new $7d4cccdf062a2261$export$37c4d04eafdc5515($9f7acf93d681eed3$export$6df59be1acc9acf0.value));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "FullRepeat") return new $7d4cccdf062a2261$export$19db0165690c701a(new $7d4cccdf062a2261$export$19db0165690c701a(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$12a73def75ba91a.value)));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "FullNeighbor") return new $7d4cccdf062a2261$export$19db0165690c701a(new $7d4cccdf062a2261$export$19db0165690c701a(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$9ac4ca89af1eab6b.value)));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "LeftRepeatOfRight") return new $7d4cccdf062a2261$export$19db0165690c701a(new $7d4cccdf062a2261$export$19db0165690c701a(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$c33024bcf57ad853.value)));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1.value0 === "RightRepeatOfLeft") return new $7d4cccdf062a2261$export$19db0165690c701a(new $7d4cccdf062a2261$export$19db0165690c701a(new $06733ae99ed4f534$export$8a67b48435b5d073($97ffb09cc3d11a32$export$ad2c4a230ed49713.value)));
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Expected double ornament type but got " + v1.value0);
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$19db0165690c701a(new $7d4cccdf062a2261$export$19db0165690c701a($06733ae99ed4f534$export$bebe9059409a0d04.value));
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 312, column 24 - line 319, column 37): " + [
            v1.constructor.name
        ]);
    };
    return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$lift($8912ce2c57a5c27a$var$map1($8912ce2c57a5c27a$var$fromFoldable4)($8912ce2c57a5c27a$var$sequence1($8912ce2c57a5c27a$var$map(wrap(readDoubleOrnament))(v.regular)))))(function(regular) {
        return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$lift($8912ce2c57a5c27a$var$map1($8912ce2c57a5c27a$var$fromFoldable4)($8912ce2c57a5c27a$var$sequence1($8912ce2c57a5c27a$var$map(wrap(readPassingOrnament))(v.passing)))))(function(passing) {
            return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$lift($8912ce2c57a5c27a$var$map1($8912ce2c57a5c27a$var$fromFoldable5)($8912ce2c57a5c27a$var$sequence1($8912ce2c57a5c27a$var$map(wrap(readRightOrnament))(v.fromLeft)))))(function(fromLeft) {
                return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$lift($8912ce2c57a5c27a$var$map1($8912ce2c57a5c27a$var$fromFoldable5)($8912ce2c57a5c27a$var$sequence1($8912ce2c57a5c27a$var$map(wrap(readLeftOrnament))(v.fromRight)))))(function(fromRight) {
                    return $8912ce2c57a5c27a$var$bind2(function() {
                        if (v.ids instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $8912ce2c57a5c27a$var$pure2(v.ids.value0);
                        if (v.ids instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$newTId1)(function(left) {
                            return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$newSId1)(function(slice) {
                                return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$newTId1)(function(right) {
                                    return $8912ce2c57a5c27a$var$pure2({
                                        left: left,
                                        slice: slice,
                                        right: right
                                    });
                                });
                            });
                        });
                        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 280, column 10 - line 286, column 34): " + [
                            v.ids.constructor.name
                        ]);
                    }())(function(ids) {
                        return $8912ce2c57a5c27a$var$pure2({
                            regular: regular,
                            passing: passing,
                            fromLeft: fromLeft,
                            fromRight: fromRight,
                            unexplained: $06733ae99ed4f534$export$43db023a260c5e9f([])(v.unexplained),
                            keepLeft: v.keepLeft,
                            keepRight: v.keepRight,
                            passLeft: v.passLeft,
                            passRight: v.passRight,
                            ids: ids
                        });
                    });
                });
            });
        });
    });
};
var $8912ce2c57a5c27a$export$bace92549cee0446 = function(v) {
    var getDist = $8912ce2c57a5c27a$var$on1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($9f7acf93d681eed3$export$f1b022af85bfacd.create)($8912ce2c57a5c27a$var$on2($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($9f7acf93d681eed3$export$3c38c892f848c839.create)($8912ce2c57a5c27a$var$on3($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($9f7acf93d681eed3$export$30956f4b4aafa87e.create)($8912ce2c57a5c27a$var$on4($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($9f7acf93d681eed3$export$ecb083e2cbcb5bfb.create)($a5ccce070b256bc7$export$637cc851f3ae4876))));
    var childFromJSON = function(v1) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.parent, getDist(v1.child));
    };
    return $8912ce2c57a5c27a$var$bind2(function() {
        if (v.ids instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $8912ce2c57a5c27a$var$pure2(v.ids.value0);
        if (v.ids instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$newTId1)(function(left) {
            return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$newSId1)(function(lslice) {
                return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$newTId1)(function(mid) {
                    return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$newSId1)(function(rslice) {
                        return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$newTId1)(function(right) {
                            return $8912ce2c57a5c27a$var$pure2({
                                left: left,
                                lslice: lslice,
                                mid: mid,
                                rslice: rslice,
                                right: right
                            });
                        });
                    });
                });
            });
        });
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 342, column 10 - line 350, column 48): " + [
            v.ids.constructor.name
        ]);
    }())(function(ids) {
        return $8912ce2c57a5c27a$var$pure2({
            midEdges: {
                regular: $8912ce2c57a5c27a$var$fromFoldable6(v.midEdges.regular),
                passing: v.midEdges.passing
            },
            children: $8912ce2c57a5c27a$var$fromFoldable5($8912ce2c57a5c27a$var$map(childFromJSON)(v.children)),
            ids: ids,
            unexplained: $06733ae99ed4f534$export$43db023a260c5e9f({
                left: [],
                right: []
            })(v.unexplained)
        });
    });
};
var $8912ce2c57a5c27a$export$5de98ca9ea5c6ac0 = function(v) {
    return {
        ties: v.ties,
        prevTime: new $06733ae99ed4f534$export$8a67b48435b5d073($7d4cccdf062a2261$export$5f5be1bb6cd1fded($8912ce2c57a5c27a$var$identity)($8912ce2c57a5c27a$var$show5)(v.prevTime))
    };
};
var $8912ce2c57a5c27a$export$8bb7be95a2fcab52 = function(v) {
    return new $7d4cccdf062a2261$export$19db0165690c701a({
        ties: v.ties,
        prevTime: $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515(""))($f8662a4a41464b67$export$c9698ec7f05a07e1)(v.prevTime)
    });
};
var $8912ce2c57a5c27a$export$d69fe6e00d4dca = /* #__PURE__ */ function() {
    return $8912ce2c57a5c27a$var$on($8912ce2c57a5c27a$var$freezeOnlyIsSymbol)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(function() {
        var $339 = $8912ce2c57a5c27a$var$map3($9f7acf93d681eed3$export$6c6c4036f610eb1a.create);
        return function($340) {
            return $339($8912ce2c57a5c27a$var$lift($8912ce2c57a5c27a$export$8bb7be95a2fcab52($340)));
        };
    }())($8912ce2c57a5c27a$var$on($8912ce2c57a5c27a$var$freezeLeftIsSymbol)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(function() {
        var $341 = $8912ce2c57a5c27a$var$map3($9f7acf93d681eed3$export$9217dfcc08ac2e7d.create);
        return function($342) {
            return $341($8912ce2c57a5c27a$var$lift($8912ce2c57a5c27a$export$8bb7be95a2fcab52($342)));
        };
    }())($8912ce2c57a5c27a$var$on($8912ce2c57a5c27a$var$horiIsSymbol)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(function() {
        var $343 = $8912ce2c57a5c27a$var$map3($9f7acf93d681eed3$export$110679fb554a6348.create);
        return function($344) {
            return $343($8912ce2c57a5c27a$export$bace92549cee0446($344));
        };
    }())($8912ce2c57a5c27a$var$on($8912ce2c57a5c27a$var$splitRightIsSymbol)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(function() {
        var $345 = $8912ce2c57a5c27a$var$map3($9f7acf93d681eed3$export$c71f04b0722025ea.create);
        return function($346) {
            return $345($8912ce2c57a5c27a$export$495f457280e88f3a($346));
        };
    }())($8912ce2c57a5c27a$var$on($8912ce2c57a5c27a$var$splitOnlyIsSymbol)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(function() {
        var $347 = $8912ce2c57a5c27a$var$map3($9f7acf93d681eed3$export$5b281e53a92c7796.create);
        return function($348) {
            return $347($8912ce2c57a5c27a$export$495f457280e88f3a($348));
        };
    }())($8912ce2c57a5c27a$var$on($8912ce2c57a5c27a$var$splitLeftIsSymbol)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(function() {
        var $349 = $8912ce2c57a5c27a$var$map3($9f7acf93d681eed3$export$6d38f18d731c7d88.create);
        return function($350) {
            return $349($8912ce2c57a5c27a$export$495f457280e88f3a($350));
        };
    }())($a5ccce070b256bc7$export$637cc851f3ae4876))))));
}();
var $8912ce2c57a5c27a$export$6e76de3ed4e5bd6a = function(v) {
    var addSliceId = function(v1) {
        return $8912ce2c57a5c27a$var$bind2($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($8912ce2c57a5c27a$var$newSId1)($8912ce2c57a5c27a$var$pure2)(v1.rslice.id))(function(sid) {
            return $8912ce2c57a5c27a$var$bind2($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($8912ce2c57a5c27a$var$newTId1)($8912ce2c57a5c27a$var$pure2)(v1.trans.id))(function(tid) {
                return $8912ce2c57a5c27a$var$pure2({
                    trans: {
                        edges: v1.trans.edges,
                        id: tid
                    },
                    rslice: {
                        notes: v1.rslice.notes,
                        id: sid
                    }
                });
            });
        });
    };
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f($8912ce2c57a5c27a$var$evalStateT)({
        nextS: 1,
        nextT: 0
    })($8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$sequence2($8912ce2c57a5c27a$var$map($8912ce2c57a5c27a$export$d69fe6e00d4dca)(v.derivation)))(function(deriv) {
        return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$sequence2($8912ce2c57a5c27a$var$map(addSliceId)(v.topSegments)))(function(topSegments$prime) {
            return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$lift($2b7582913558f260$export$a34f3c836110a57b(topSegments$prime)(deriv)))(function(v1) {
                return $8912ce2c57a5c27a$var$bind2($8912ce2c57a5c27a$var$lift($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($8912ce2c57a5c27a$var$pure($97ffb09cc3d11a32$export$2a3d0b2fc2ae9e63))($8912ce2c57a5c27a$export$b5b6a770010592f1)(v.styles)))(function(parsedStyles) {
                    return $8912ce2c57a5c27a$var$pure2({
                        piece: v1.piece,
                        reduction: v1.reduction,
                        styles: parsedStyles
                    });
                });
            });
        });
    }));
};
var $8912ce2c57a5c27a$export$4f88b1d5d0822a4f = function(edges) {
    return {
        regular: $8912ce2c57a5c27a$var$fromFoldable7(edges.regular),
        passing: edges.passing
    };
};
var $8912ce2c57a5c27a$export$4f473d5bfc28d964 = function(v) {
    var childToJSON = function(v1) {
        var child = function() {
            if (v1.value1 instanceof $9f7acf93d681eed3$export$ecb083e2cbcb5bfb) return $8912ce2c57a5c27a$var$inj1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v1.value1.value0);
            if (v1.value1 instanceof $9f7acf93d681eed3$export$30956f4b4aafa87e) return $8912ce2c57a5c27a$var$inj2($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v1.value1.value0);
            if (v1.value1 instanceof $9f7acf93d681eed3$export$3c38c892f848c839) return $8912ce2c57a5c27a$var$inj3($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v1.value1.value0);
            if (v1.value1 instanceof $9f7acf93d681eed3$export$f1b022af85bfacd) return $8912ce2c57a5c27a$var$inj4($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v1.value1.value0);
            throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 213, column 15 - line 217, column 70): " + [
                v1.value1.constructor.name
            ]);
        }();
        return {
            parent: v1.value0,
            child: child
        };
    };
    return {
        midEdges: $8912ce2c57a5c27a$export$4f88b1d5d0822a4f(v.midEdges),
        children: $8912ce2c57a5c27a$var$map(childToJSON)($8912ce2c57a5c27a$var$toUnfoldable(v.children)),
        ids: new $06733ae99ed4f534$export$8a67b48435b5d073(v.ids),
        unexplained: new $06733ae99ed4f534$export$8a67b48435b5d073(v.unexplained)
    };
};
var $8912ce2c57a5c27a$export$91aa18319b9917e9 = function(v) {
    if (v instanceof $9f7acf93d681eed3$export$9217dfcc08ac2e7d) return $8912ce2c57a5c27a$var$inj5($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($8912ce2c57a5c27a$export$5de98ca9ea5c6ac0(v.value0));
    if (v instanceof $9f7acf93d681eed3$export$6c6c4036f610eb1a) return $8912ce2c57a5c27a$var$inj6($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($8912ce2c57a5c27a$export$5de98ca9ea5c6ac0(v.value0));
    if (v instanceof $9f7acf93d681eed3$export$6d38f18d731c7d88) return $8912ce2c57a5c27a$var$inj7($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($8912ce2c57a5c27a$export$c62c30b861fbaae(v.value0));
    if (v instanceof $9f7acf93d681eed3$export$5b281e53a92c7796) return $8912ce2c57a5c27a$var$inj8($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($8912ce2c57a5c27a$export$c62c30b861fbaae(v.value0));
    if (v instanceof $9f7acf93d681eed3$export$c71f04b0722025ea) return $8912ce2c57a5c27a$var$inj9($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($8912ce2c57a5c27a$export$c62c30b861fbaae(v.value0));
    if (v instanceof $9f7acf93d681eed3$export$110679fb554a6348) return $8912ce2c57a5c27a$var$inj10($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($8912ce2c57a5c27a$export$4f473d5bfc28d964(v.value0));
    throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 164, column 18 - line 170, column 66): " + [
        v.constructor.name
    ]);
};
var $8912ce2c57a5c27a$export$d3bdb395b8194de4 = function(model) {
    var transToJSON = function(v) {
        return {
            edges: $8912ce2c57a5c27a$export$4f88b1d5d0822a4f(v.edges),
            id: new $06733ae99ed4f534$export$8a67b48435b5d073(v.id)
        };
    };
    var sliceToJSON = function(v) {
        return {
            id: new $06733ae99ed4f534$export$8a67b48435b5d073(v.id),
            notes: $8912ce2c57a5c27a$var$map4($8912ce2c57a5c27a$var$map(function(v1) {
                return v1.note;
            }))(v.notes)
        };
    };
    return $8912ce2c57a5c27a$var$bind($2b7582913558f260$export$d7a6cd6c2f9dff1(model))(function(lm) {
        return $8912ce2c57a5c27a$var$pure({
            derivation: $8912ce2c57a5c27a$var$map($8912ce2c57a5c27a$export$91aa18319b9917e9)(lm),
            start: sliceToJSON(model.reduction.start),
            topSegments: $8912ce2c57a5c27a$var$map(function(v) {
                return {
                    trans: transToJSON(v.trans),
                    rslice: sliceToJSON(v.rslice)
                };
            })($8912ce2c57a5c27a$var$fromFoldable8(model.reduction.segments)),
            styles: new $06733ae99ed4f534$export$8a67b48435b5d073($8912ce2c57a5c27a$export$e5ef535447be5f00(model.styles))
        });
    });
};
var $8912ce2c57a5c27a$export$64e02d6a4ee3dfe7 = function(piece) {
    var addids = function(s) {
        return $396c4c3d9e7fae3c$export$8f07ddce13659f50(function(n) {
            return function(note) {
                return {
                    id: "note" + ($8912ce2c57a5c27a$var$show(s) + ("." + $8912ce2c57a5c27a$var$show(n))),
                    pitch: note.pitch,
                    hold: note.hold
                };
            };
        });
    };
    return $396c4c3d9e7fae3c$export$8f07ddce13659f50(function(s) {
        return function(slice) {
            return {
                time: slice.time,
                notes: addids(s)(slice.notes)
            };
        };
    })(piece);
};



// Generated by purs version 0.15.15
var $4d875ff260c22106$exports = {};
/*!
 * VexFlow 4.2.5   2024-05-12T08:56:23.690Z   5b5b43b18254cc5cf607a0977823900a375b48ed
 * Copyright (c) 2010 Mohit Muthanna Cheppudira <mohit@muthanna.com>
 * https://www.vexflow.com   https://github.com/0xfe/vexflow
 */ !function(t, e) {
    $4d875ff260c22106$exports = e();
}("undefined" != typeof window ? window : "undefined" != typeof globalThis ? globalThis : $4d875ff260c22106$exports, ()=>(()=>{
        "use strict";
        var t = {
            d: (e, i)=>{
                for(var b in i)t.o(i, b) && !t.o(e, b) && Object.defineProperty(e, b, {
                    enumerable: !0,
                    get: i[b]
                });
            }
        };
        t.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (t) {
                if ("object" == typeof window) return window;
            }
        }(), t.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), t.r = (t)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        };
        var e = {};
        t.d(e, {
            default: ()=>i
        });
        var i = {};
        function b(t, e, i = !0) {
            if ("object" != typeof t || null === t) return !1;
            let b = t.constructor;
            if (i) {
                for(; null !== t;){
                    if (b = t.constructor, "CATEGORY" in b && b.CATEGORY === e) return !0;
                    t = Object.getPrototypeOf(t);
                }
                return !1;
            }
            return "CATEGORY" in b && b.CATEGORY === e;
        }
        t.r(i), t.d(i, {
            Accidental: ()=>bt,
            Annotation: ()=>ct,
            AnnotationHorizontalJustify: ()=>ht,
            AnnotationVerticalJustify: ()=>mt,
            Articulation: ()=>ut,
            BEAM_BOTH: ()=>Oe,
            BEAM_LEFT: ()=>Fe,
            BEAM_RIGHT: ()=>Me,
            BarNote: ()=>At,
            Barline: ()=>kt,
            BarlineType: ()=>zt,
            Beam: ()=>Re,
            Bend: ()=>Nt,
            BoundingBox: ()=>D,
            BoundingBoxComputation: ()=>C,
            Builder: ()=>Ke,
            CanvasContext: ()=>Qt,
            Category: ()=>x,
            ChordSymbol: ()=>Mt,
            ChordSymbolHorizontalJustify: ()=>Bt,
            ChordSymbolVerticalJustify: ()=>Dt,
            Clef: ()=>de,
            ClefNote: ()=>Le,
            Crescendo: ()=>We,
            Curve: ()=>Ie,
            CurvePosition: ()=>Ue,
            Dot: ()=>Ot,
            EasyScore: ()=>Qe,
            EasyScoreGrammar: ()=>je,
            Element: ()=>R,
            Factory: ()=>vi,
            Flow: ()=>ki,
            Font: ()=>F,
            FontStyle: ()=>P,
            FontWeight: ()=>E,
            Formatter: ()=>Pe,
            Fraction: ()=>z,
            FretHandFinger: ()=>Rt,
            GhostNote: ()=>ti,
            Glyph: ()=>Z,
            GlyphNote: ()=>ei,
            GraceNote: ()=>ii,
            GraceNoteGroup: ()=>jt,
            GraceTabNote: ()=>wi,
            KeyManager: ()=>zi,
            KeySigNote: ()=>bi,
            KeySignature: ()=>_e,
            Modifier: ()=>tt,
            ModifierContext: ()=>ce,
            ModifierPosition: ()=>J,
            MultiMeasureRest: ()=>ni,
            Music: ()=>et,
            Note: ()=>vt,
            NoteHead: ()=>Lt,
            NoteSubGroup: ()=>Vt,
            Ornament: ()=>Kt,
            OutlineCode: ()=>$,
            Parenthesis: ()=>$t,
            Parser: ()=>Ye,
            PedalMarking: ()=>li,
            Piece: ()=>Ve,
            Registry: ()=>O,
            RenderContext: ()=>ft,
            Renderer: ()=>le,
            RendererBackends: ()=>be,
            RendererLineEndType: ()=>ae,
            RepeatNote: ()=>ri,
            Repetition: ()=>xe,
            RuntimeError: ()=>g,
            SVGContext: ()=>ie,
            Stave: ()=>ze,
            StaveConnector: ()=>De,
            StaveHairpin: ()=>Bi,
            StaveLine: ()=>mi,
            StaveModifier: ()=>Pt,
            StaveModifierPosition: ()=>wt,
            StaveNote: ()=>It,
            StaveSection: ()=>ge,
            StaveTempo: ()=>ye,
            StaveText: ()=>ue,
            StaveTie: ()=>Gt,
            Stem: ()=>at,
            StemmableNote: ()=>Wt,
            StringNumber: ()=>oe,
            Stroke: ()=>re,
            SymbolModifiers: ()=>Et,
            SymbolTypes: ()=>Ct,
            System: ()=>ci,
            TabNote: ()=>di,
            TabSlide: ()=>Di,
            TabStave: ()=>_i,
            TabTie: ()=>Ht,
            TextBracket: ()=>yi,
            TextBracketPosition: ()=>gi,
            TextDynamics: ()=>ui,
            TextFormatter: ()=>rt,
            TextJustification: ()=>ne,
            TextNote: ()=>pe,
            TickContext: ()=>Ce,
            Tickable: ()=>Tt,
            TimeSigNote: ()=>fi,
            TimeSignature: ()=>Te,
            TimeSignatureGlyph: ()=>Se,
            Tremolo: ()=>Ci,
            Tuning: ()=>Ei,
            Tuplet: ()=>Ae,
            TupletLocation: ()=>ke,
            Vex: ()=>Yi,
            Vibrato: ()=>he,
            VibratoBracket: ()=>Si,
            Voice: ()=>Xt,
            VoiceMode: ()=>Yt,
            Volta: ()=>fe,
            VoltaType: ()=>se,
            defined: ()=>p,
            drawDot: ()=>St,
            globalObject: ()=>y,
            isAccidental: ()=>a,
            isAnnotation: ()=>n,
            isBarline: ()=>s,
            isCategory: ()=>b,
            isDot: ()=>l,
            isGraceNote: ()=>o,
            isGraceNoteGroup: ()=>r,
            isHTMLCanvas: ()=>Jt,
            isHTMLDiv: ()=>qt,
            isNote: ()=>h,
            isRenderContext: ()=>m,
            isStaveNote: ()=>c,
            isStemmableNote: ()=>d,
            isTabNote: ()=>_,
            log: ()=>u,
            midLine: ()=>S,
            normalizeAngle: ()=>v,
            prefix: ()=>T,
            sumArray: ()=>w,
            warn: ()=>f
        });
        const a = (t)=>b(t, x.Accidental), n = (t)=>b(t, x.Annotation), s = (t)=>b(t, x.Barline), l = (t)=>b(t, x.Dot), o = (t)=>b(t, x.GraceNote), r = (t)=>b(t, x.GraceNoteGroup), h = (t)=>b(t, x.Note), m = (t)=>b(t, x.RenderContext), c = (t)=>b(t, x.StaveNote), d = (t)=>b(t, x.StemmableNote), _ = (t)=>b(t, x.TabNote);
        var x;
        !function(t) {
            t.Accidental = "Accidental", t.Annotation = "Annotation", t.Articulation = "Articulation", t.Barline = "Barline", t.BarNote = "BarNote", t.Beam = "Beam", t.Bend = "Bend", t.ChordSymbol = "ChordSymbol", t.Clef = "Clef", t.ClefNote = "ClefNote", t.Crescendo = "Crescendo", t.Curve = "Curve", t.Dot = "Dot", t.Element = "Element", t.Fraction = "Fraction", t.FretHandFinger = "FretHandFinger", t.GhostNote = "GhostNote", t.Glyph = "Glyph", t.GlyphNote = "GlyphNote", t.GraceNote = "GraceNote", t.GraceNoteGroup = "GraceNoteGroup", t.GraceTabNote = "GraceTabNote", t.KeySignature = "KeySignature", t.KeySigNote = "KeySigNote", t.Modifier = "Modifier", t.MultiMeasureRest = "MultiMeasureRest", t.Note = "Note", t.NoteHead = "NoteHead", t.NoteSubGroup = "NoteSubGroup", t.Ornament = "Ornament", t.Parenthesis = "Parenthesis", t.PedalMarking = "PedalMarking", t.RenderContext = "RenderContext", t.RepeatNote = "RepeatNote", t.Repetition = "Repetition", t.Stave = "Stave", t.StaveConnector = "StaveConnector", t.StaveHairpin = "StaveHairpin", t.StaveLine = "StaveLine", t.StaveModifier = "StaveModifier", t.StaveNote = "StaveNote", t.StaveSection = "StaveSection", t.StaveTempo = "StaveTempo", t.StaveText = "StaveText", t.StaveTie = "StaveTie", t.Stem = "Stem", t.StemmableNote = "StemmableNote", t.StringNumber = "StringNumber", t.Stroke = "Stroke", t.System = "System", t.TabNote = "TabNote", t.TabSlide = "TabSlide", t.TabStave = "TabStave", t.TabTie = "TabTie", t.TextBracket = "TextBracket", t.TextDynamics = "TextDynamics", t.TextNote = "TextNote", t.Tickable = "Tickable", t.TimeSignature = "TimeSignature", t.TimeSigNote = "TimeSigNote", t.Tremolo = "Tremolo", t.Tuplet = "Tuplet", t.Vibrato = "Vibrato", t.VibratoBracket = "VibratoBracket", t.Voice = "Voice", t.Volta = "Volta";
        }(x || (x = {}));
        class g extends Error {
            constructor(t, e = ""){
                super("[RuntimeError] " + t + ": " + e), this.code = t;
            }
        }
        function y() {
            return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== t.g ? t.g : Function("return this")();
        }
        function p(t, e = "undefined", i = "") {
            if (void 0 === t) throw new g(e, i);
            return t;
        }
        function u(t, ...e) {
            if (!e) return;
            const i = Array.prototype.slice.call(e).join(" ");
            y().console.log(t + ": " + i);
        }
        function f(...t) {
            const e = t.join(" "), i = new Error;
            y().console.log("Warning: ", e, i.stack);
        }
        function S(t, e) {
            let i = e + (t - e) / 2;
            var b, a;
            return i % 2 > 0 && (i = ((b = 10 * i) % (a = 5) >= a / 2 ? parseInt("" + b / a, 10) * a + a : parseInt("" + b / a, 10) * a) / 10), i;
        }
        function T(t) {
            return `vf-${t}`;
        }
        function v(t) {
            return (t %= 2 * Math.PI) < 0 && (t += 2 * Math.PI), t;
        }
        function w(t) {
            return t.reduce((t, e)=>t + e, 0);
        }
        class z {
            static get CATEGORY() {
                return x.Fraction;
            }
            static GCD(t, e) {
                if ("number" != typeof t || Number.isNaN(t) || "number" != typeof e || Number.isNaN(e)) throw new g("BadArgument", `Invalid numbers: ${t}, ${e}`);
                let i;
                for(; 0 !== e;)i = e, e = t % e, t = i;
                return t;
            }
            static LCM(t, e) {
                return t * e / z.GCD(t, e);
            }
            static LCMM(t) {
                return 0 === t.length ? 0 : 1 === t.length ? t[0] : 2 === t.length ? z.LCM(t[0], t[1]) : z.LCM(t.shift(), z.LCMM(t));
            }
            constructor(t, e){
                this.numerator = 1, this.denominator = 1, this.set(t, e);
            }
            set(t = 1, e = 1) {
                return this.numerator = t, this.denominator = e, this;
            }
            value() {
                return this.numerator / this.denominator;
            }
            simplify() {
                let t = this.numerator, e = this.denominator;
                const i = z.GCD(t, e);
                return t /= i, e /= i, e < 0 && (e = -e, t = -t), this.set(t, e);
            }
            add(t = 0, e = 1) {
                const [i, b] = B(t, e), a = z.LCM(this.denominator, b), n = a / this.denominator, s = a / b, l = this.numerator * n + i * s;
                return this.set(l, a);
            }
            subtract(t = 0, e = 1) {
                const [i, b] = B(t, e), a = z.LCM(this.denominator, b), n = a / this.denominator, s = a / b, l = this.numerator * n - i * s;
                return this.set(l, a);
            }
            multiply(t = 1, e = 1) {
                const [i, b] = B(t, e);
                return this.set(this.numerator * i, this.denominator * b);
            }
            divide(t = 1, e = 1) {
                const [i, b] = B(t, e);
                return this.set(this.numerator * b, this.denominator * i);
            }
            equals(t) {
                const e = z.__staticFractionA.copy(t).simplify(), i = z.__staticFractionB.copy(this).simplify();
                return e.numerator === i.numerator && e.denominator === i.denominator;
            }
            greaterThan(t) {
                const e = z.__staticFractionB.copy(this);
                return e.subtract(t), e.numerator > 0;
            }
            greaterThanEquals(t) {
                const e = z.__staticFractionB.copy(this);
                return e.subtract(t), e.numerator >= 0;
            }
            lessThan(t) {
                return !this.greaterThanEquals(t);
            }
            lessThanEquals(t) {
                return !this.greaterThan(t);
            }
            clone() {
                return new z(this.numerator, this.denominator);
            }
            copy(t) {
                return "number" == typeof t ? this.set(t, 1) : this.set(t.numerator, t.denominator);
            }
            quotient() {
                return Math.floor(this.numerator / this.denominator);
            }
            remainder() {
                return this.numerator % this.denominator;
            }
            makeAbs() {
                return this.denominator = Math.abs(this.denominator), this.numerator = Math.abs(this.numerator), this;
            }
            toString() {
                return `${this.numerator}/${this.denominator}`;
            }
            toSimplifiedString() {
                return z.__staticFractionTmp.copy(this).simplify().toString();
            }
            toMixedString() {
                let t = "";
                const e = this.quotient(), i = z.__staticFractionTmp.copy(this);
                return e < 0 && i.makeAbs(), 0 !== e ? (t += e, 0 !== i.numerator && (t += ` ${i.toSimplifiedString()}`)) : t = 0 === i.numerator ? "0" : i.toSimplifiedString(), t;
            }
            parse(t) {
                const e = t.split("/"), i = parseInt(e[0], 10), b = e[1] ? parseInt(e[1], 10) : 1;
                return this.set(i, b);
            }
        }
        function B(t, e = 1) {
            return "number" == typeof t ? [
                t,
                e
            ] : [
                t.numerator,
                t.denominator
            ];
        }
        z.__staticFractionA = new z, z.__staticFractionB = new z, z.__staticFractionTmp = new z;
        class D {
            static copy(t) {
                return new D(t.x, t.y, t.w, t.h);
            }
            constructor(t, e, i, b){
                this.x = t, this.y = e, this.w = i, this.h = b;
            }
            getX() {
                return this.x;
            }
            getY() {
                return this.y;
            }
            getW() {
                return this.w;
            }
            getH() {
                return this.h;
            }
            setX(t) {
                return this.x = t, this;
            }
            setY(t) {
                return this.y = t, this;
            }
            setW(t) {
                return this.w = t, this;
            }
            setH(t) {
                return this.h = t, this;
            }
            move(t, e) {
                return this.x += t, this.y += e, this;
            }
            clone() {
                return D.copy(this);
            }
            mergeWith(t) {
                const e = t, i = this.x < e.x ? this.x : e.x, b = this.y < e.y ? this.y : e.y, a = Math.max(this.x + this.w, e.x + e.w) - i, n = Math.max(this.y + this.h, e.y + e.h) - b;
                return this.x = i, this.y = b, this.w = a, this.h = n, this;
            }
        }
        class C {
            constructor(){
                this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN;
            }
            getX1() {
                return this.x1;
            }
            getY1() {
                return this.y1;
            }
            width() {
                return this.x2 - this.x1;
            }
            height() {
                return this.y2 - this.y1;
            }
            addPoint(t, e) {
                (isNaN(this.x1) || t < this.x1) && (this.x1 = t), (isNaN(this.x2) || t > this.x2) && (this.x2 = t), (isNaN(this.y1) || e < this.y1) && (this.y1 = e), (isNaN(this.y2) || e > this.y2) && (this.y2 = e);
            }
            addX(t) {
                this.addPoint(t, this.y1);
            }
            addY(t) {
                this.addPoint(this.x1, t);
            }
            addQuadraticCurve(t, e, i, b, a, n) {
                this.addPoint(t, e), this.addPoint(a, n);
                const s = i - t;
                let l = s - (a - i);
                if (0 != l) {
                    const e = s / l;
                    if (e > 0 && e < 1) {
                        const b = 1 - e;
                        this.addX(b * b * t + 2 * b * e * i + e * e * a);
                    }
                }
                const o = b - e;
                if (l = o - (n - b), 0 != l) {
                    const t = o / l;
                    if (t > 0 && t < 1) {
                        const i = 1 - t;
                        this.addY(i * i * e + 2 * i * t * b + t * t * n);
                    }
                }
            }
            addBezierCurve(t, e, i, b, a, n, s, l) {
                const o = [
                    t,
                    e
                ], r = [
                    i,
                    b
                ], h = [
                    a,
                    n
                ], m = [
                    s,
                    l
                ];
                let c;
                this.addPoint(o[0], o[1]), this.addPoint(m[0], m[1]);
                const d = (t, e)=>Math.pow(1 - t, 3) * o[e] + 3 * Math.pow(1 - t, 2) * t * r[e] + 3 * (1 - t) * Math.pow(t, 2) * h[e] + Math.pow(t, 3) * m[e];
                for(c = 0; c <= 1; c++){
                    const t = 6 * o[c] - 12 * r[c] + 6 * h[c], e = -3 * o[c] + 9 * r[c] - 9 * h[c] + 3 * m[c], i = 3 * r[c] - 3 * o[c];
                    if (0 === e) {
                        if (0 === t) continue;
                        const e = -i / t;
                        0 < e && e < 1 && (0 === c && this.addX(d(e, c)), 1 === c && this.addY(d(e, c)));
                        continue;
                    }
                    const b = Math.pow(t, 2) - 4 * i * e;
                    if (b < 0) continue;
                    const a = (-t + Math.sqrt(b)) / (2 * e);
                    0 < a && a < 1 && (0 === c && this.addX(d(a, c)), 1 === c && this.addY(d(a, c)));
                    const n = (-t - Math.sqrt(b)) / (2 * e);
                    0 < n && n < 1 && (0 === c && this.addX(d(n, c)), 1 === c && this.addY(d(n, c)));
                }
            }
        }
        var E, P, k = function(t, e, i, b) {
            return new (i || (i = Promise))(function(a, n) {
                function s(t) {
                    try {
                        o(b.next(t));
                    } catch (t) {
                        n(t);
                    }
                }
                function l(t) {
                    try {
                        o(b.throw(t));
                    } catch (t) {
                        n(t);
                    }
                }
                function o(t) {
                    var e;
                    t.done ? a(t.value) : (e = t.value, e instanceof i ? e : new i(function(t) {
                        t(e);
                    })).then(s, l);
                }
                o((b = b.apply(t, e || [])).next());
            });
        };
        let A;
        !function(t) {
            t.NORMAL = "normal", t.BOLD = "bold";
        }(E || (E = {})), function(t) {
            t.NORMAL = "normal", t.ITALIC = "italic";
        }(P || (P = {}));
        const N = {};
        class F {
            static convertSizeToPixelValue(t = F.SIZE) {
                var e;
                if ("number" == typeof t) return t * F.scaleToPxFrom.pt;
                {
                    const i = parseFloat(t);
                    if (isNaN(i)) return 0;
                    const b = t.replace(/[\d.\s]/g, "").toLowerCase();
                    return i * (null !== (e = F.scaleToPxFrom[b]) && void 0 !== e ? e : 1);
                }
            }
            static convertSizeToPointValue(t = F.SIZE) {
                var e;
                if ("number" == typeof t) return t;
                {
                    const i = parseFloat(t);
                    if (isNaN(i)) return 0;
                    const b = t.replace(/[\d.\s]/g, "").toLowerCase();
                    return i * ((null !== (e = F.scaleToPxFrom[b]) && void 0 !== e ? e : 1) / F.scaleToPxFrom.pt);
                }
            }
            static validate(t, e, i, b) {
                if ("string" == typeof t && void 0 === e && void 0 === i && void 0 === b) return F.fromCSSString(t);
                let a;
                return "object" == typeof t ? (a = t.family, e = t.size, i = t.weight, b = t.style) : a = t, a = null != a ? a : F.SANS_SERIF, e = null != e ? e : F.SIZE + "pt", i = null != i ? i : E.NORMAL, b = null != b ? b : P.NORMAL, "" === i && (i = E.NORMAL), "" === b && (b = P.NORMAL), "number" == typeof e && (e = `${e}pt`), "number" == typeof i && (i = i.toString()), {
                    family: a,
                    size: e,
                    weight: i,
                    style: b
                };
            }
            static fromCSSString(t) {
                A || (A = document.createElement("span")), A.style.font = t;
                const { fontFamily: e, fontSize: i, fontWeight: b, fontStyle: a } = A.style;
                return {
                    family: e,
                    size: i,
                    weight: b,
                    style: a
                };
            }
            static toCSSString(t) {
                var e;
                if (!t) return "";
                let i;
                const b = t.style;
                let a;
                i = b === P.NORMAL || "" === b || void 0 === b ? "" : b.trim() + " ";
                const n = t.weight;
                let s;
                a = n === E.NORMAL || "" === n || void 0 === n ? "" : "number" == typeof n ? n + " " : n.trim() + " ";
                const l = t.size;
                s = void 0 === l ? F.SIZE + "pt " : "number" == typeof l ? l + "pt " : l.trim() + " ";
                return `${i}${a}${s}${null !== (e = t.family) && void 0 !== e ? e : F.SANS_SERIF}`;
            }
            static scaleSize(t, e) {
                if ("number" == typeof t) return t * e;
                return `${parseFloat(t) * e}${t.replace(/[\d.\s]/g, "")}`;
            }
            static isBold(t) {
                if (t) {
                    if ("number" == typeof t) return t >= 600;
                    {
                        const e = parseInt(t, 10);
                        return isNaN(e) ? "bold" === t.toLowerCase() : e >= 600;
                    }
                }
                return !1;
            }
            static isItalic(t) {
                return !!t && t.toLowerCase() === P.ITALIC;
            }
            static loadWebFont(t, e, i = !0) {
                return k(this, void 0, void 0, function*() {
                    const b = new FontFace(t, (i ? `url(${e}2) format('woff2'), ` : "") + `url(${e}) format('woff')`);
                    return yield b.load(), document.fonts.add(b), b;
                });
            }
            static loadWebFonts() {
                return k(this, void 0, void 0, function*() {
                    const t = F.WEB_FONT_HOST, e = F.WEB_FONT_FILES;
                    for(const i in e){
                        const b = e[i];
                        F.loadWebFont(i, t + b);
                    }
                });
            }
            static load(t, e, i) {
                let b = N[t];
                return b || (b = new F(t), N[t] = b), e && b.setData(e), i && b.setMetrics(i), b;
            }
            constructor(t){
                this.name = t;
            }
            getName() {
                return this.name;
            }
            getData() {
                return p(this.data, "FontError", "Missing font data");
            }
            getMetrics() {
                return p(this.metrics, "FontError", "Missing metrics");
            }
            setData(t) {
                this.data = t;
            }
            setMetrics(t) {
                this.metrics = t;
            }
            hasData() {
                return void 0 !== this.data;
            }
            getResolution() {
                return this.getData().resolution;
            }
            getGlyphs() {
                return this.getData().glyphs;
            }
            lookupMetric(t, e) {
                const i = t.split(".");
                let b = this.getMetrics();
                for(let t = 0; t < i.length; t++){
                    const a = b[i[t]];
                    if (void 0 === a) return e;
                    b = a;
                }
                return b;
            }
            toString() {
                return "[" + this.name + " Font]";
            }
        }
        F.SANS_SERIF = "Arial, sans-serif", F.SERIF = "Times New Roman, serif", F.SIZE = 10, F.scaleToPxFrom = {
            pt: 4 / 3,
            px: 1,
            em: 16,
            "%": .16,
            in: 96,
            mm: 96 / 25.4,
            cm: 96 / 2.54
        }, F.WEB_FONT_HOST = "https://unpkg.com/vexflow-fonts@1.0.3/", F.WEB_FONT_FILES = {
            "Roboto Slab": "robotoslab/RobotoSlab-Medium_2.001.woff",
            PetalumaScript: "petaluma/PetalumaScript_1.10_FS.woff"
        };
        class M {
            constructor(){
                this.id = {}, this.type = {}, this.class = {};
            }
        }
        class O {
            static getDefaultRegistry() {
                return O.defaultRegistry;
            }
            static enableDefaultRegistry(t) {
                O.defaultRegistry = t;
            }
            static disableDefaultRegistry() {
                O.defaultRegistry = void 0;
            }
            constructor(){
                this.index = new M;
            }
            clear() {
                return this.index = new M, this;
            }
            setIndexValue(t, e, i, b) {
                const a = this.index;
                a[t][e] || (a[t][e] = {}), a[t][e][i] = b;
            }
            updateIndex({ id: t, name: e, value: i, oldValue: b }) {
                const a = this.getElementById(t);
                void 0 !== b && this.index[e][b] && delete this.index[e][b][t], i && a && this.setIndexValue(e, i, a.getAttribute("id"), a);
            }
            register(t, e) {
                if (!(e = e || t.getAttribute("id"))) throw new g("Can't add element without `id` attribute to registry");
                return t.setAttribute("id", e), this.setIndexValue("id", e, e, t), this.updateIndex({
                    id: e,
                    name: "type",
                    value: t.getAttribute("type"),
                    oldValue: void 0
                }), t.onRegister(this), this;
            }
            getElementById(t) {
                var e, i;
                return null === (i = null === (e = this.index.id) || void 0 === e ? void 0 : e[t]) || void 0 === i ? void 0 : i[t];
            }
            getElementsByAttribute(t, e) {
                const i = this.index[t];
                if (i) {
                    const t = i[e];
                    if (t) return Object.keys(t).map((e)=>t[e]);
                }
                return [];
            }
            getElementsByType(t) {
                return this.getElementsByAttribute("type", t);
            }
            getElementsByClass(t) {
                return this.getElementsByAttribute("class", t);
            }
            onUpdate(t) {
                return [
                    "id",
                    "type",
                    "class"
                ].includes(t.name) && this.updateIndex(t), this;
            }
        }
        class R {
            static get CATEGORY() {
                return x.Element;
            }
            static newID() {
                return "auto" + R.ID++;
            }
            constructor(){
                var t;
                this.children = [], this.attrs = {
                    id: R.newID(),
                    type: this.getCategory(),
                    class: ""
                }, this.rendered = !1, null === (t = O.getDefaultRegistry()) || void 0 === t || t.register(this);
            }
            addChildElement(t) {
                return this.children.push(t), this;
            }
            getCategory() {
                return this.constructor.CATEGORY;
            }
            setStyle(t) {
                return this.style = t, this;
            }
            setGroupStyle(t) {
                return this.style = t, this.children.forEach((e)=>e.setGroupStyle(t)), this;
            }
            getStyle() {
                return this.style;
            }
            applyStyle(t = this.context, e = this.getStyle()) {
                return e && t ? (t.save(), e.shadowColor && t.setShadowColor(e.shadowColor), e.shadowBlur && t.setShadowBlur(e.shadowBlur), e.fillStyle && t.setFillStyle(e.fillStyle), e.strokeStyle && t.setStrokeStyle(e.strokeStyle), e.lineWidth && t.setLineWidth(e.lineWidth), this) : this;
            }
            restoreStyle(t = this.context, e = this.getStyle()) {
                return e && t ? (t.restore(), this) : this;
            }
            drawWithStyle() {
                this.checkContext(), this.applyStyle(), this.draw(), this.restoreStyle();
            }
            hasClass(t) {
                var e;
                return !!this.attrs.class && -1 != (null === (e = this.attrs.class) || void 0 === e ? void 0 : e.split(" ").indexOf(t));
            }
            addClass(t) {
                var e;
                return this.hasClass(t) || (this.attrs.class ? this.attrs.class = `${this.attrs.class} ${t}` : this.attrs.class = `${t}`, null === (e = this.registry) || void 0 === e || e.onUpdate({
                    id: this.attrs.id,
                    name: "class",
                    value: t,
                    oldValue: void 0
                })), this;
            }
            removeClass(t) {
                var e, i;
                if (!this.hasClass(t)) return this;
                const b = null === (e = this.attrs.class) || void 0 === e ? void 0 : e.split(" ");
                return b && (b.splice(b.indexOf(t)), this.attrs.class = b.join(" ")), null === (i = this.registry) || void 0 === i || i.onUpdate({
                    id: this.attrs.id,
                    name: "class",
                    value: void 0,
                    oldValue: t
                }), this;
            }
            onRegister(t) {
                return this.registry = t, this;
            }
            isRendered() {
                return this.rendered;
            }
            setRendered(t = !0) {
                return this.rendered = t, this;
            }
            getAttributes() {
                return this.attrs;
            }
            getAttribute(t) {
                return this.attrs[t];
            }
            getSVGElement(t = "") {
                const e = T(this.attrs.id + t), i = document.getElementById(e);
                if (i) return i;
            }
            setAttribute(t, e) {
                var i;
                const b = this.attrs.id, a = this.attrs[t];
                return this.attrs[t] = e, null === (i = this.registry) || void 0 === i || i.onUpdate({
                    id: b,
                    name: t,
                    value: e,
                    oldValue: a
                }), this;
            }
            getBoundingBox() {
                return this.boundingBox;
            }
            getContext() {
                return this.context;
            }
            setContext(t) {
                return this.context = t, this;
            }
            checkContext() {
                return p(this.context, "NoContext", "No rendering context attached to instance.");
            }
            set font(t) {
                this.setFont(t);
            }
            get font() {
                return F.toCSSString(this.textFont);
            }
            setFont(t, e, i, b) {
                const a = this.constructor.TEXT_FONT, n = "object" == typeof t, s = "string" == typeof t, l = void 0 === t, o = void 0 === e && void 0 === i && void 0 === b;
                return this.textFont = n ? Object.assign(Object.assign({}, a), t) : s && o ? F.fromCSSString(t) : l && o ? Object.assign({}, a) : F.validate(null != t ? t : a.family, null != e ? e : a.size, null != i ? i : a.weight, null != b ? b : a.style), this;
            }
            getFont() {
                return this.textFont || this.resetFont(), F.toCSSString(this.textFont);
            }
            resetFont() {
                this.setFont();
            }
            get fontInfo() {
                return this.textFont || this.resetFont(), Object.assign({}, this.textFont);
            }
            set fontInfo(t) {
                this.setFont(t);
            }
            setFontSize(t) {
                const e = this.fontInfo;
                return this.setFont(e.family, t, e.weight, e.style), this;
            }
            getFontSize() {
                return this.fontSize;
            }
            set fontSize(t) {
                this.setFontSize(t);
            }
            get fontSize() {
                let t = this.fontInfo.size;
                return "number" == typeof t && (t = `${t}pt`), t;
            }
            get fontSizeInPoints() {
                return F.convertSizeToPointValue(this.fontSize);
            }
            get fontSizeInPixels() {
                return F.convertSizeToPixelValue(this.fontSize);
            }
            get fontStyle() {
                return this.fontInfo.style;
            }
            set fontStyle(t) {
                const e = this.fontInfo;
                this.setFont(e.family, e.size, e.weight, t);
            }
            get fontWeight() {
                return this.fontInfo.weight + "";
            }
            set fontWeight(t) {
                const e = this.fontInfo;
                this.setFont(e.family, e.size, t, e.style);
            }
        }
        R.ID = 1e3, R.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: F.SIZE,
            weight: E.NORMAL,
            style: P.NORMAL
        };
        const L = 16384, W = {
            "1/2": 32768,
            1: 16384,
            2: 8192,
            4: 4096,
            8: 2048,
            16: 1024,
            32: 512,
            64: 256,
            128: 128,
            256: 64
        }, U = {
            w: "1",
            h: "2",
            q: "4",
            b: "256"
        }, I = {
            C: {
                num: 0
            },
            Am: {
                num: 0
            },
            F: {
                acc: "b",
                num: 1
            },
            Dm: {
                acc: "b",
                num: 1
            },
            Bb: {
                acc: "b",
                num: 2
            },
            Gm: {
                acc: "b",
                num: 2
            },
            Eb: {
                acc: "b",
                num: 3
            },
            Cm: {
                acc: "b",
                num: 3
            },
            Ab: {
                acc: "b",
                num: 4
            },
            Fm: {
                acc: "b",
                num: 4
            },
            Db: {
                acc: "b",
                num: 5
            },
            Bbm: {
                acc: "b",
                num: 5
            },
            Gb: {
                acc: "b",
                num: 6
            },
            Ebm: {
                acc: "b",
                num: 6
            },
            Cb: {
                acc: "b",
                num: 7
            },
            Abm: {
                acc: "b",
                num: 7
            },
            G: {
                acc: "#",
                num: 1
            },
            Em: {
                acc: "#",
                num: 1
            },
            D: {
                acc: "#",
                num: 2
            },
            Bm: {
                acc: "#",
                num: 2
            },
            A: {
                acc: "#",
                num: 3
            },
            "F#m": {
                acc: "#",
                num: 3
            },
            E: {
                acc: "#",
                num: 4
            },
            "C#m": {
                acc: "#",
                num: 4
            },
            B: {
                acc: "#",
                num: 5
            },
            "G#m": {
                acc: "#",
                num: 5
            },
            "F#": {
                acc: "#",
                num: 6
            },
            "D#m": {
                acc: "#",
                num: 6
            },
            "C#": {
                acc: "#",
                num: 7
            },
            "A#m": {
                acc: "#",
                num: 7
            }
        }, G = {
            treble: {
                line_shift: 0
            },
            bass: {
                line_shift: 6
            },
            tenor: {
                line_shift: 4
            },
            alto: {
                line_shift: 3
            },
            soprano: {
                line_shift: 1
            },
            percussion: {
                line_shift: 0
            },
            "mezzo-soprano": {
                line_shift: 2
            },
            "baritone-c": {
                line_shift: 5
            },
            "baritone-f": {
                line_shift: 5
            },
            subbass: {
                line_shift: 7
            },
            french: {
                line_shift: -1
            }
        }, H = {
            C: {
                index: 0,
                int_val: 0
            },
            CN: {
                index: 0,
                int_val: 0,
                accidental: "n"
            },
            "C#": {
                index: 0,
                int_val: 1,
                accidental: "#"
            },
            "C##": {
                index: 0,
                int_val: 2,
                accidental: "##"
            },
            CB: {
                index: 0,
                int_val: 11,
                accidental: "b"
            },
            CBB: {
                index: 0,
                int_val: 10,
                accidental: "bb"
            },
            D: {
                index: 1,
                int_val: 2
            },
            DN: {
                index: 1,
                int_val: 2,
                accidental: "n"
            },
            "D#": {
                index: 1,
                int_val: 3,
                accidental: "#"
            },
            "D##": {
                index: 1,
                int_val: 4,
                accidental: "##"
            },
            DB: {
                index: 1,
                int_val: 1,
                accidental: "b"
            },
            DBB: {
                index: 1,
                int_val: 0,
                accidental: "bb"
            },
            E: {
                index: 2,
                int_val: 4
            },
            EN: {
                index: 2,
                int_val: 4,
                accidental: "n"
            },
            "E#": {
                index: 2,
                int_val: 5,
                accidental: "#"
            },
            "E##": {
                index: 2,
                int_val: 6,
                accidental: "##"
            },
            EB: {
                index: 2,
                int_val: 3,
                accidental: "b"
            },
            EBB: {
                index: 2,
                int_val: 2,
                accidental: "bb"
            },
            F: {
                index: 3,
                int_val: 5
            },
            FN: {
                index: 3,
                int_val: 5,
                accidental: "n"
            },
            "F#": {
                index: 3,
                int_val: 6,
                accidental: "#"
            },
            "F##": {
                index: 3,
                int_val: 7,
                accidental: "##"
            },
            FB: {
                index: 3,
                int_val: 4,
                accidental: "b"
            },
            FBB: {
                index: 3,
                int_val: 3,
                accidental: "bb"
            },
            G: {
                index: 4,
                int_val: 7
            },
            GN: {
                index: 4,
                int_val: 7,
                accidental: "n"
            },
            "G#": {
                index: 4,
                int_val: 8,
                accidental: "#"
            },
            "G##": {
                index: 4,
                int_val: 9,
                accidental: "##"
            },
            GB: {
                index: 4,
                int_val: 6,
                accidental: "b"
            },
            GBB: {
                index: 4,
                int_val: 5,
                accidental: "bb"
            },
            A: {
                index: 5,
                int_val: 9
            },
            AN: {
                index: 5,
                int_val: 9,
                accidental: "n"
            },
            "A#": {
                index: 5,
                int_val: 10,
                accidental: "#"
            },
            "A##": {
                index: 5,
                int_val: 11,
                accidental: "##"
            },
            AB: {
                index: 5,
                int_val: 8,
                accidental: "b"
            },
            ABB: {
                index: 5,
                int_val: 7,
                accidental: "bb"
            },
            B: {
                index: 6,
                int_val: 11
            },
            BN: {
                index: 6,
                int_val: 11,
                accidental: "n"
            },
            "B#": {
                index: 6,
                int_val: 12,
                accidental: "#"
            },
            "B##": {
                index: 6,
                int_val: 13,
                accidental: "##"
            },
            BB: {
                index: 6,
                int_val: 10,
                accidental: "b"
            },
            BBB: {
                index: 6,
                int_val: 9,
                accidental: "bb"
            },
            R: {
                index: 6,
                rest: !0
            },
            X: {
                index: 6,
                accidental: "",
                octave: 4,
                code: "noteheadXBlack",
                shift_right: 5.5
            }
        }, Y = {
            "#": {
                code: "accidentalSharp",
                parenRightPaddingAdjustment: -1
            },
            "##": {
                code: "accidentalDoubleSharp",
                parenRightPaddingAdjustment: -1
            },
            b: {
                code: "accidentalFlat",
                parenRightPaddingAdjustment: -2
            },
            bb: {
                code: "accidentalDoubleFlat",
                parenRightPaddingAdjustment: -2
            },
            n: {
                code: "accidentalNatural",
                parenRightPaddingAdjustment: -1
            },
            "{": {
                code: "accidentalParensLeft",
                parenRightPaddingAdjustment: -1
            },
            "}": {
                code: "accidentalParensRight",
                parenRightPaddingAdjustment: -1
            },
            db: {
                code: "accidentalThreeQuarterTonesFlatZimmermann",
                parenRightPaddingAdjustment: -1
            },
            d: {
                code: "accidentalQuarterToneFlatStein",
                parenRightPaddingAdjustment: 0
            },
            "++": {
                code: "accidentalThreeQuarterTonesSharpStein",
                parenRightPaddingAdjustment: -1
            },
            "+": {
                code: "accidentalQuarterToneSharpStein",
                parenRightPaddingAdjustment: -1
            },
            "+-": {
                code: "accidentalKucukMucennebSharp",
                parenRightPaddingAdjustment: -1
            },
            bs: {
                code: "accidentalBakiyeFlat",
                parenRightPaddingAdjustment: -1
            },
            bss: {
                code: "accidentalBuyukMucennebFlat",
                parenRightPaddingAdjustment: -1
            },
            o: {
                code: "accidentalSori",
                parenRightPaddingAdjustment: -1
            },
            k: {
                code: "accidentalKoron",
                parenRightPaddingAdjustment: -1
            },
            bbs: {
                code: "vexAccidentalMicrotonal1",
                parenRightPaddingAdjustment: -1
            },
            "++-": {
                code: "accidentalBuyukMucennebSharp",
                parenRightPaddingAdjustment: -1
            },
            ashs: {
                code: "vexAccidentalMicrotonal3",
                parenRightPaddingAdjustment: -1
            },
            afhf: {
                code: "vexAccidentalMicrotonal4",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v7KleismaUp: {
                code: "accSagittal5v7KleismaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v7KleismaDown: {
                code: "accSagittal5v7KleismaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5CommaUp: {
                code: "accSagittal5CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5CommaDown: {
                code: "accSagittal5CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7CommaUp: {
                code: "accSagittal7CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7CommaDown: {
                code: "accSagittal7CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal25SmallDiesisUp: {
                code: "accSagittal25SmallDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal25SmallDiesisDown: {
                code: "accSagittal25SmallDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal35MediumDiesisUp: {
                code: "accSagittal35MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal35MediumDiesisDown: {
                code: "accSagittal35MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11MediumDiesisUp: {
                code: "accSagittal11MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11MediumDiesisDown: {
                code: "accSagittal11MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11LargeDiesisUp: {
                code: "accSagittal11LargeDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11LargeDiesisDown: {
                code: "accSagittal11LargeDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal35LargeDiesisUp: {
                code: "accSagittal35LargeDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal35LargeDiesisDown: {
                code: "accSagittal35LargeDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp25SDown: {
                code: "accSagittalSharp25SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat25SUp: {
                code: "accSagittalFlat25SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7CDown: {
                code: "accSagittalSharp7CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7CUp: {
                code: "accSagittalFlat7CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5CDown: {
                code: "accSagittalSharp5CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5CUp: {
                code: "accSagittalFlat5CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v7kDown: {
                code: "accSagittalSharp5v7kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v7kUp: {
                code: "accSagittalFlat5v7kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp: {
                code: "accSagittalSharp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat: {
                code: "accSagittalFlat",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v7kUp: {
                code: "accSagittalSharp5v7kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v7kDown: {
                code: "accSagittalFlat5v7kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5CUp: {
                code: "accSagittalSharp5CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5CDown: {
                code: "accSagittalFlat5CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7CUp: {
                code: "accSagittalSharp7CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7CDown: {
                code: "accSagittalFlat7CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp25SUp: {
                code: "accSagittalSharp25SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat25SDown: {
                code: "accSagittalFlat25SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp35MUp: {
                code: "accSagittalSharp35MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat35MDown: {
                code: "accSagittalFlat35MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11MUp: {
                code: "accSagittalSharp11MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11MDown: {
                code: "accSagittalFlat11MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11LUp: {
                code: "accSagittalSharp11LUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11LDown: {
                code: "accSagittalFlat11LDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp35LUp: {
                code: "accSagittalSharp35LUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat35LDown: {
                code: "accSagittalFlat35LDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp25SDown: {
                code: "accSagittalDoubleSharp25SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat25SUp: {
                code: "accSagittalDoubleFlat25SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp7CDown: {
                code: "accSagittalDoubleSharp7CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat7CUp: {
                code: "accSagittalDoubleFlat7CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp5CDown: {
                code: "accSagittalDoubleSharp5CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat5CUp: {
                code: "accSagittalDoubleFlat5CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp5v7kDown: {
                code: "accSagittalDoubleSharp5v7kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat5v7kUp: {
                code: "accSagittalDoubleFlat5v7kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp: {
                code: "accSagittalDoubleSharp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat: {
                code: "accSagittalDoubleFlat",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v11KleismaUp: {
                code: "accSagittal7v11KleismaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v11KleismaDown: {
                code: "accSagittal7v11KleismaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal17CommaUp: {
                code: "accSagittal17CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal17CommaDown: {
                code: "accSagittal17CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal55CommaUp: {
                code: "accSagittal55CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal55CommaDown: {
                code: "accSagittal55CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v11CommaUp: {
                code: "accSagittal7v11CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v11CommaDown: {
                code: "accSagittal7v11CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v11SmallDiesisUp: {
                code: "accSagittal5v11SmallDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v11SmallDiesisDown: {
                code: "accSagittal5v11SmallDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v11SDown: {
                code: "accSagittalSharp5v11SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v11SUp: {
                code: "accSagittalFlat5v11SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v11CDown: {
                code: "accSagittalSharp7v11CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v11CUp: {
                code: "accSagittalFlat7v11CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp55CDown: {
                code: "accSagittalSharp55CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat55CUp: {
                code: "accSagittalFlat55CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp17CDown: {
                code: "accSagittalSharp17CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat17CUp: {
                code: "accSagittalFlat17CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v11kDown: {
                code: "accSagittalSharp7v11kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v11kUp: {
                code: "accSagittalFlat7v11kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v11kUp: {
                code: "accSagittalSharp7v11kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v11kDown: {
                code: "accSagittalFlat7v11kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp17CUp: {
                code: "accSagittalSharp17CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat17CDown: {
                code: "accSagittalFlat17CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp55CUp: {
                code: "accSagittalSharp55CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat55CDown: {
                code: "accSagittalFlat55CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v11CUp: {
                code: "accSagittalSharp7v11CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v11CDown: {
                code: "accSagittalFlat7v11CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v11SUp: {
                code: "accSagittalSharp5v11SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v11SDown: {
                code: "accSagittalFlat5v11SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp5v11SDown: {
                code: "accSagittalDoubleSharp5v11SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat5v11SUp: {
                code: "accSagittalDoubleFlat5v11SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp7v11CDown: {
                code: "accSagittalDoubleSharp7v11CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat7v11CUp: {
                code: "accSagittalDoubleFlat7v11CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp55CDown: {
                code: "accSagittalDoubleSharp55CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat55CUp: {
                code: "accSagittalDoubleFlat55CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp17CDown: {
                code: "accSagittalDoubleSharp17CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat17CUp: {
                code: "accSagittalDoubleFlat17CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp7v11kDown: {
                code: "accSagittalDoubleSharp7v11kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat7v11kUp: {
                code: "accSagittalDoubleFlat7v11kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal23CommaUp: {
                code: "accSagittal23CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal23CommaDown: {
                code: "accSagittal23CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v19CommaUp: {
                code: "accSagittal5v19CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v19CommaDown: {
                code: "accSagittal5v19CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v23SmallDiesisUp: {
                code: "accSagittal5v23SmallDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v23SmallDiesisDown: {
                code: "accSagittal5v23SmallDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v23SDown: {
                code: "accSagittalSharp5v23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v23SUp: {
                code: "accSagittalFlat5v23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v19CDown: {
                code: "accSagittalSharp5v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v19CUp: {
                code: "accSagittalFlat5v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp23CDown: {
                code: "accSagittalSharp23CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat23CUp: {
                code: "accSagittalFlat23CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp23CUp: {
                code: "accSagittalSharp23CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat23CDown: {
                code: "accSagittalFlat23CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v19CUp: {
                code: "accSagittalSharp5v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v19CDown: {
                code: "accSagittalFlat5v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v23SUp: {
                code: "accSagittalSharp5v23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v23SDown: {
                code: "accSagittalFlat5v23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp5v23SDown: {
                code: "accSagittalDoubleSharp5v23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat5v23SUp: {
                code: "accSagittalDoubleFlat5v23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp5v19CDown: {
                code: "accSagittalDoubleSharp5v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat5v19CUp: {
                code: "accSagittalDoubleFlat5v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp23CDown: {
                code: "accSagittalDoubleSharp23CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat23CUp: {
                code: "accSagittalDoubleFlat23CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal19SchismaUp: {
                code: "accSagittal19SchismaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal19SchismaDown: {
                code: "accSagittal19SchismaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal17KleismaUp: {
                code: "accSagittal17KleismaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal17KleismaDown: {
                code: "accSagittal17KleismaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal143CommaUp: {
                code: "accSagittal143CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal143CommaDown: {
                code: "accSagittal143CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v49CommaUp: {
                code: "accSagittal11v49CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v49CommaDown: {
                code: "accSagittal11v49CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal19CommaUp: {
                code: "accSagittal19CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal19CommaDown: {
                code: "accSagittal19CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v19CommaUp: {
                code: "accSagittal7v19CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v19CommaDown: {
                code: "accSagittal7v19CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49SmallDiesisUp: {
                code: "accSagittal49SmallDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49SmallDiesisDown: {
                code: "accSagittal49SmallDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal23SmallDiesisUp: {
                code: "accSagittal23SmallDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal23SmallDiesisDown: {
                code: "accSagittal23SmallDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v13MediumDiesisUp: {
                code: "accSagittal5v13MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v13MediumDiesisDown: {
                code: "accSagittal5v13MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v19MediumDiesisUp: {
                code: "accSagittal11v19MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v19MediumDiesisDown: {
                code: "accSagittal11v19MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49MediumDiesisUp: {
                code: "accSagittal49MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49MediumDiesisDown: {
                code: "accSagittal49MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v49MediumDiesisUp: {
                code: "accSagittal5v49MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v49MediumDiesisDown: {
                code: "accSagittal5v49MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49LargeDiesisUp: {
                code: "accSagittal49LargeDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49LargeDiesisDown: {
                code: "accSagittal49LargeDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v19LargeDiesisUp: {
                code: "accSagittal11v19LargeDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v19LargeDiesisDown: {
                code: "accSagittal11v19LargeDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v13LargeDiesisUp: {
                code: "accSagittal5v13LargeDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v13LargeDiesisDown: {
                code: "accSagittal5v13LargeDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp23SDown: {
                code: "accSagittalSharp23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat23SUp: {
                code: "accSagittalFlat23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp49SDown: {
                code: "accSagittalSharp49SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat49SUp: {
                code: "accSagittalFlat49SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v19CDown: {
                code: "accSagittalSharp7v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v19CUp: {
                code: "accSagittalFlat7v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp19CDown: {
                code: "accSagittalSharp19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat19CUp: {
                code: "accSagittalFlat19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11v49CDown: {
                code: "accSagittalSharp11v49CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11v49CUp: {
                code: "accSagittalFlat11v49CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp143CDown: {
                code: "accSagittalSharp143CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat143CUp: {
                code: "accSagittalFlat143CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp17kDown: {
                code: "accSagittalSharp17kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat17kUp: {
                code: "accSagittalFlat17kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp19sDown: {
                code: "accSagittalSharp19sDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat19sUp: {
                code: "accSagittalFlat19sUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp19sUp: {
                code: "accSagittalSharp19sUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat19sDown: {
                code: "accSagittalFlat19sDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp17kUp: {
                code: "accSagittalSharp17kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat17kDown: {
                code: "accSagittalFlat17kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp143CUp: {
                code: "accSagittalSharp143CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat143CDown: {
                code: "accSagittalFlat143CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11v49CUp: {
                code: "accSagittalSharp11v49CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11v49CDown: {
                code: "accSagittalFlat11v49CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp19CUp: {
                code: "accSagittalSharp19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat19CDown: {
                code: "accSagittalFlat19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v19CUp: {
                code: "accSagittalSharp7v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v19CDown: {
                code: "accSagittalFlat7v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp49SUp: {
                code: "accSagittalSharp49SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat49SDown: {
                code: "accSagittalFlat49SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp23SUp: {
                code: "accSagittalSharp23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat23SDown: {
                code: "accSagittalFlat23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v13MUp: {
                code: "accSagittalSharp5v13MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v13MDown: {
                code: "accSagittalFlat5v13MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11v19MUp: {
                code: "accSagittalSharp11v19MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11v19MDown: {
                code: "accSagittalFlat11v19MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp49MUp: {
                code: "accSagittalSharp49MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat49MDown: {
                code: "accSagittalFlat49MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v49MUp: {
                code: "accSagittalSharp5v49MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v49MDown: {
                code: "accSagittalFlat5v49MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp49LUp: {
                code: "accSagittalSharp49LUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat49LDown: {
                code: "accSagittalFlat49LDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11v19LUp: {
                code: "accSagittalSharp11v19LUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11v19LDown: {
                code: "accSagittalFlat11v19LDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v13LUp: {
                code: "accSagittalSharp5v13LUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v13LDown: {
                code: "accSagittalFlat5v13LDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp23SDown: {
                code: "accSagittalDoubleSharp23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat23SUp: {
                code: "accSagittalDoubleFlat23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp49SDown: {
                code: "accSagittalDoubleSharp49SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat49SUp: {
                code: "accSagittalDoubleFlat49SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp7v19CDown: {
                code: "accSagittalDoubleSharp7v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat7v19CUp: {
                code: "accSagittalDoubleFlat7v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp19CDown: {
                code: "accSagittalDoubleSharp19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat19CUp: {
                code: "accSagittalDoubleFlat19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp11v49CDown: {
                code: "accSagittalDoubleSharp11v49CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat11v49CUp: {
                code: "accSagittalDoubleFlat11v49CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp143CDown: {
                code: "accSagittalDoubleSharp143CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat143CUp: {
                code: "accSagittalDoubleFlat143CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp17kDown: {
                code: "accSagittalDoubleSharp17kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat17kUp: {
                code: "accSagittalDoubleFlat17kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp19sDown: {
                code: "accSagittalDoubleSharp19sDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat19sUp: {
                code: "accSagittalDoubleFlat19sUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalShaftUp: {
                code: "accSagittalShaftUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalShaftDown: {
                code: "accSagittalShaftDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalAcute: {
                code: "accSagittalAcute",
                parenRightPaddingAdjustment: -1
            },
            accSagittalGrave: {
                code: "accSagittalGrave",
                parenRightPaddingAdjustment: -1
            },
            accSagittal1MinaUp: {
                code: "accSagittal1MinaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal1MinaDown: {
                code: "accSagittal1MinaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal2MinasUp: {
                code: "accSagittal2MinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal2MinasDown: {
                code: "accSagittal2MinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal1TinaUp: {
                code: "accSagittal1TinaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal1TinaDown: {
                code: "accSagittal1TinaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal2TinasUp: {
                code: "accSagittal2TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal2TinasDown: {
                code: "accSagittal2TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal3TinasUp: {
                code: "accSagittal3TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal3TinasDown: {
                code: "accSagittal3TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal4TinasUp: {
                code: "accSagittal4TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal4TinasDown: {
                code: "accSagittal4TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5TinasUp: {
                code: "accSagittal5TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5TinasDown: {
                code: "accSagittal5TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal6TinasUp: {
                code: "accSagittal6TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal6TinasDown: {
                code: "accSagittal6TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7TinasUp: {
                code: "accSagittal7TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7TinasDown: {
                code: "accSagittal7TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal8TinasUp: {
                code: "accSagittal8TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal8TinasDown: {
                code: "accSagittal8TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal9TinasUp: {
                code: "accSagittal9TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal9TinasDown: {
                code: "accSagittal9TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFractionalTinaUp: {
                code: "accSagittalFractionalTinaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFractionalTinaDown: {
                code: "accSagittalFractionalTinaDown",
                parenRightPaddingAdjustment: -1
            },
            accidentalNarrowReversedFlat: {
                code: "accidentalNarrowReversedFlat",
                parenRightPaddingAdjustment: -1
            },
            accidentalNarrowReversedFlatAndFlat: {
                code: "accidentalNarrowReversedFlatAndFlat",
                parenRightPaddingAdjustment: -1
            },
            accidentalWilsonPlus: {
                code: "accidentalWilsonPlus",
                parenRightPaddingAdjustment: -1
            },
            accidentalWilsonMinus: {
                code: "accidentalWilsonMinus",
                parenRightPaddingAdjustment: -1
            }
        }, X = {
            "a.": {
                code: "augmentationDot",
                between_lines: !0
            },
            av: {
                aboveCode: "articStaccatissimoAbove",
                belowCode: "articStaccatissimoBelow",
                between_lines: !0
            },
            "a>": {
                aboveCode: "articAccentAbove",
                belowCode: "articAccentBelow",
                between_lines: !0
            },
            "a-": {
                aboveCode: "articTenutoAbove",
                belowCode: "articTenutoBelow",
                between_lines: !0
            },
            "a^": {
                aboveCode: "articMarcatoAbove",
                belowCode: "articMarcatoBelow",
                between_lines: !1
            },
            "a+": {
                code: "pluckedLeftHandPizzicato",
                between_lines: !1
            },
            ao: {
                aboveCode: "pluckedSnapPizzicatoAbove",
                belowCode: "pluckedSnapPizzicatoBelow",
                between_lines: !1
            },
            ah: {
                code: "stringsHarmonic",
                between_lines: !1
            },
            "a@": {
                aboveCode: "fermataAbove",
                belowCode: "fermataBelow",
                between_lines: !1
            },
            "a@a": {
                code: "fermataAbove",
                between_lines: !1
            },
            "a@u": {
                code: "fermataBelow",
                between_lines: !1
            },
            "a@s": {
                aboveCode: "fermataShortAbove",
                belowCode: "fermataShortBelow",
                between_lines: !1
            },
            "a@as": {
                code: "fermataShortAbove",
                between_lines: !1
            },
            "a@us": {
                code: "fermataShortBelow",
                between_lines: !1
            },
            "a@l": {
                aboveCode: "fermataLongAbove",
                belowCode: "fermataLongBelow",
                between_lines: !1
            },
            "a@al": {
                code: "fermataLongAbove",
                between_lines: !1
            },
            "a@ul": {
                code: "fermataLongBelow",
                between_lines: !1
            },
            "a@vl": {
                aboveCode: "fermataVeryLongAbove",
                belowCode: "fermataVeryLongBelow",
                between_lines: !1
            },
            "a@avl": {
                code: "fermataVeryLongAbove",
                between_lines: !1
            },
            "a@uvl": {
                code: "fermataVeryLongBelow",
                between_lines: !1
            },
            "a|": {
                code: "stringsUpBow",
                between_lines: !1
            },
            am: {
                code: "stringsDownBow",
                between_lines: !1
            },
            "a,": {
                code: "pictChokeCymbal",
                between_lines: !1
            }
        }, j = {
            mordent: {
                code: "ornamentShortTrill"
            },
            mordent_inverted: {
                code: "ornamentMordent"
            },
            turn: {
                code: "ornamentTurn"
            },
            turn_inverted: {
                code: "ornamentTurnSlash"
            },
            tr: {
                code: "ornamentTrill"
            },
            upprall: {
                code: "ornamentPrecompSlideTrillDAnglebert"
            },
            downprall: {
                code: "ornamentPrecompDoubleCadenceUpperPrefix"
            },
            prallup: {
                code: "ornamentPrecompTrillSuffixDandrieu"
            },
            pralldown: {
                code: "ornamentPrecompTrillLowerSuffix"
            },
            upmordent: {
                code: "ornamentPrecompSlideTrillBach"
            },
            downmordent: {
                code: "ornamentPrecompDoubleCadenceUpperPrefixTurn"
            },
            lineprall: {
                code: "ornamentPrecompAppoggTrill"
            },
            prallprall: {
                code: "ornamentTremblement"
            },
            scoop: {
                code: "brassScoop"
            },
            doit: {
                code: "brassDoitMedium"
            },
            fall: {
                code: "brassFallLipShort"
            },
            doitLong: {
                code: "brassLiftMedium"
            },
            fallLong: {
                code: "brassFallRoughMedium"
            },
            bend: {
                code: "brassBend"
            },
            plungerClosed: {
                code: "brassMuteClosed"
            },
            plungerOpen: {
                code: "brassMuteOpen"
            },
            flip: {
                code: "brassFlip"
            },
            jazzTurn: {
                code: "brassJazzTurn"
            },
            smear: {
                code: "brassSmear"
            }
        };
        class V {
            static currentMusicFont() {
                if (0 === V.MUSIC_FONT_STACK.length) throw new g("NoFonts", "The font stack is empty. See: await Flow.fetchMusicFont(...); Flow.setMusicFont(...).");
                return V.MUSIC_FONT_STACK[0];
            }
            static clefProperties(t) {
                if (!t || !(t in G)) throw new g("BadArgument", "Invalid clef: " + t);
                return G[t];
            }
            static keyProperties(t, e = "treble", i) {
                let b = {
                    octave_shift: 0,
                    duration: "4"
                };
                "object" == typeof i && (b = Object.assign(Object.assign({}, b), i));
                const a = V.sanitizeDuration(b.duration), n = t.split("/");
                if (n.length < 2) throw new g("BadArguments", `First argument must be note/octave or note/octave/glyph-code: ${t}`);
                const s = n[0].toUpperCase(), l = H[s];
                if (!l) throw new g("BadArguments", "Invalid key name: " + s);
                l.octave && (n[1] = l.octave.toString());
                let o = parseInt(n[1], 10);
                o -= b.octave_shift;
                let r = (7 * o - 28 + l.index) / 2;
                r += V.clefProperties(e).line_shift;
                let h = 0;
                r <= 0 && 2 * r % 2 == 0 && (h = 1), r >= 6 && 2 * r % 2 == 0 && (h = -1);
                const m = void 0 !== l.int_val ? 12 * o + l.int_val : void 0, c = l.code, d = l.shift_right;
                let _ = {};
                if (n.length > 2 && n[2]) {
                    const t = n[2].toUpperCase();
                    _ = {
                        code: this.codeNoteHead(t, a)
                    };
                }
                return Object.assign({
                    key: s,
                    octave: o,
                    line: r,
                    int_value: m,
                    accidental: l.accidental,
                    code: c,
                    stroke: h,
                    shift_right: d,
                    displaced: !1
                }, _);
            }
            static integerToNote(t) {
                if (void 0 === t || t < 0 || t > 11) throw new g("BadArguments", `integerToNote() requires an integer in the range [0, 11]: ${t}`);
                const e = {
                    0: "C",
                    1: "C#",
                    2: "D",
                    3: "D#",
                    4: "E",
                    5: "F",
                    6: "F#",
                    7: "G",
                    8: "G#",
                    9: "A",
                    10: "A#",
                    11: "B"
                }[t];
                if (!e) throw new g("BadArguments", `Unknown note value for integer: ${t}`);
                return e;
            }
            static tabToGlyphProps(t, e = 1) {
                let i, b = 0, a = 0;
                if ("X" === t.toUpperCase()) {
                    const t = new Z("accidentalDoubleSharp", V.TABLATURE_FONT_SCALE).getMetrics();
                    if (i = "accidentalDoubleSharp", null == t.width || null == t.height) throw new g("InvalidMetrics", "Width and height required");
                    b = t.width, a = -t.height / 2;
                } else b = V.textWidth(t);
                return {
                    text: t,
                    code: i,
                    getWidth: ()=>b * e,
                    shift_y: a
                };
            }
            static textWidth(t) {
                return 7 * t.toString().length;
            }
            static articulationCodes(t) {
                return X[t];
            }
            static accidentalCodes(t) {
                return Y[t];
            }
            static ornamentCodes(t) {
                return j[t];
            }
            static keySignature(t) {
                const e = I[t];
                if (!e) throw new g("BadKeySignature", `Bad key signature spec: '${t}'`);
                if (!e.acc) return [];
                const i = {
                    b: [
                        2,
                        .5,
                        2.5,
                        1,
                        3,
                        1.5,
                        3.5
                    ],
                    "#": [
                        0,
                        1.5,
                        -0.5,
                        1,
                        2.5,
                        .5,
                        2
                    ]
                }[e.acc], b = [];
                for(let t = 0; t < e.num; ++t){
                    const a = i[t];
                    b.push({
                        type: e.acc,
                        line: a
                    });
                }
                return b;
            }
            static getKeySignatures() {
                return I;
            }
            static hasKeySignature(t) {
                return t in I;
            }
            static sanitizeDuration(t) {
                const e = U[t];
                if (void 0 !== e && (t = e), void 0 === W[t]) throw new g("BadArguments", `The provided duration is not valid: ${t}`);
                return t;
            }
            static durationToFraction(t) {
                return (new z).parse(V.sanitizeDuration(t));
            }
            static durationToNumber(t) {
                return V.durationToFraction(t).value();
            }
            static durationToTicks(t) {
                t = V.sanitizeDuration(t);
                const e = W[t];
                if (void 0 === e) throw new g("InvalidDuration");
                return e;
            }
            static codeNoteHead(t, e) {
                let i = "";
                switch(t){
                    case "D0":
                        i = "noteheadDiamondWhole";
                        break;
                    case "D1":
                        i = "noteheadDiamondHalf";
                        break;
                    case "D2":
                    case "D3":
                    case "MI":
                        i = "noteheadDiamondBlack";
                        break;
                    case "T0":
                        i = "noteheadTriangleUpWhole";
                        break;
                    case "T1":
                        i = "noteheadTriangleUpHalf";
                        break;
                    case "T2":
                    case "T3":
                    case "DO":
                        i = "noteheadTriangleUpBlack";
                        break;
                    case "X0":
                        i = "noteheadXWhole";
                        break;
                    case "X1":
                        i = "noteheadXHalf";
                        break;
                    case "X2":
                        i = "noteheadXBlack";
                        break;
                    case "X3":
                        i = "noteheadCircleX";
                        break;
                    case "S1":
                        i = "noteheadSquareWhite";
                        break;
                    case "S2":
                    case "LA":
                        i = "noteheadSquareBlack";
                        break;
                    case "R1":
                        i = "vexNoteHeadRectWhite";
                        break;
                    case "R2":
                        i = "vexNoteHeadRectBlack";
                        break;
                    case "RE":
                        i = "noteheadMoonBlack";
                        break;
                    case "FA":
                        i = "noteheadTriangleLeftBlack";
                        break;
                    case "FAUP":
                        i = "noteheadTriangleRightBlack";
                        break;
                    case "SO":
                        i = "noteheadBlack";
                        break;
                    case "TI":
                        i = "noteheadTriangleRoundDownBlack";
                        break;
                    case "D":
                    case "H":
                        switch(e){
                            case "1/2":
                                i = "noteheadDiamondDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadDiamondWhole";
                                break;
                            case "2":
                                i = "noteheadDiamondHalf";
                                break;
                            default:
                                i = "noteheadDiamondBlack";
                        }
                        break;
                    case "N":
                    case "G":
                        switch(e){
                            case "1/2":
                                i = "noteheadDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadWhole";
                                break;
                            case "2":
                                i = "noteheadHalf";
                                break;
                            default:
                                i = "noteheadBlack";
                        }
                        break;
                    case "M":
                    case "X":
                        switch(e){
                            case "1/2":
                                i = "noteheadXDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadXWhole";
                                break;
                            case "2":
                                i = "noteheadXHalf";
                                break;
                            default:
                                i = "noteheadXBlack";
                        }
                        break;
                    case "CX":
                        switch(e){
                            case "1/2":
                                i = "noteheadCircleXDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadCircleXWhole";
                                break;
                            case "2":
                                i = "noteheadCircleXHalf";
                                break;
                            default:
                                i = "noteheadCircleX";
                        }
                        break;
                    case "CI":
                        switch(e){
                            case "1/2":
                                i = "noteheadCircledDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadCircledWhole";
                                break;
                            case "2":
                                i = "noteheadCircledHalf";
                                break;
                            default:
                                i = "noteheadCircledBlack";
                        }
                        break;
                    case "SQ":
                        switch(e){
                            case "1/2":
                                i = "noteheadDoubleWholeSquare";
                                break;
                            case "1":
                            case "2":
                                i = "noteheadSquareWhite";
                                break;
                            default:
                                i = "noteheadSquareBlack";
                        }
                        break;
                    case "TU":
                        switch(e){
                            case "1/2":
                                i = "noteheadTriangleUpDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadTriangleUpWhole";
                                break;
                            case "2":
                                i = "noteheadTriangleUpHalf";
                                break;
                            default:
                                i = "noteheadTriangleUpBlack";
                        }
                        break;
                    case "TD":
                        switch(e){
                            case "1/2":
                                i = "noteheadTriangleDownDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadTriangleDownWhole";
                                break;
                            case "2":
                                i = "noteheadTriangleDownHalf";
                                break;
                            default:
                                i = "noteheadTriangleDownBlack";
                        }
                        break;
                    case "SF":
                        switch(e){
                            case "1/2":
                                i = "noteheadSlashedDoubleWhole1";
                                break;
                            case "1":
                                i = "noteheadSlashedWhole1";
                                break;
                            case "2":
                                i = "noteheadSlashedHalf1";
                                break;
                            default:
                                i = "noteheadSlashedBlack1";
                        }
                        break;
                    case "SB":
                        switch(e){
                            case "1/2":
                                i = "noteheadSlashedDoubleWhole2";
                                break;
                            case "1":
                                i = "noteheadSlashedWhole2";
                                break;
                            case "2":
                                i = "noteheadSlashedHalf2";
                                break;
                            default:
                                i = "noteheadSlashedBlack2";
                        }
                }
                return i;
            }
            static getGlyphProps(t, e = "n") {
                t = V.sanitizeDuration(t);
                let i = K[t];
                void 0 === i && (i = K[4]);
                let b = i[e];
                const a = V.codeNoteHead(e.toUpperCase(), t);
                "" != a && (b = Object.assign(Object.assign({}, b), {
                    code_head: a,
                    code: a
                }));
                const n = b.code_head;
                return Object.assign(Object.assign(Object.assign({}, i.common), {
                    getWidth: (t = V.NOTATION_FONT_SCALE)=>Z.getWidth(n, t)
                }), b);
            }
        }
        V.UNISON = !0, V.SOFTMAX_FACTOR = 10, V.STEM_WIDTH = 1.5, V.STEM_HEIGHT = 35, V.STAVE_LINE_THICKNESS = 1, V.RENDER_PRECISION_PLACES = 3, V.RESOLUTION = L, V.MUSIC_FONT_STACK = [], V.NOTATION_FONT_SCALE = 39, V.TABLATURE_FONT_SCALE = 39, V.SLASH_NOTEHEAD_WIDTH = 15, V.STAVE_LINE_DISTANCE = 10, V.TEXT_HEIGHT_OFFSET_HACK = 1, V.accidentalMap = Y, V.accidentalColumnsTable = {
            1: {
                a: [
                    1
                ],
                b: [
                    1
                ]
            },
            2: {
                a: [
                    1,
                    2
                ]
            },
            3: {
                a: [
                    1,
                    3,
                    2
                ],
                b: [
                    1,
                    2,
                    1
                ],
                second_on_bottom: [
                    1,
                    2,
                    3
                ]
            },
            4: {
                a: [
                    1,
                    3,
                    4,
                    2
                ],
                b: [
                    1,
                    2,
                    3,
                    1
                ],
                spaced_out_tetrachord: [
                    1,
                    2,
                    1,
                    2
                ]
            },
            5: {
                a: [
                    1,
                    3,
                    5,
                    4,
                    2
                ],
                b: [
                    1,
                    2,
                    4,
                    3,
                    1
                ],
                spaced_out_pentachord: [
                    1,
                    2,
                    3,
                    2,
                    1
                ],
                very_spaced_out_pentachord: [
                    1,
                    2,
                    1,
                    2,
                    1
                ]
            },
            6: {
                a: [
                    1,
                    3,
                    5,
                    6,
                    4,
                    2
                ],
                b: [
                    1,
                    2,
                    4,
                    5,
                    3,
                    1
                ],
                spaced_out_hexachord: [
                    1,
                    3,
                    2,
                    1,
                    3,
                    2
                ],
                very_spaced_out_hexachord: [
                    1,
                    2,
                    1,
                    2,
                    1,
                    2
                ]
            }
        }, V.unicode = {
            sharp: String.fromCharCode(9839),
            flat: String.fromCharCode(9837),
            natural: String.fromCharCode(9838),
            triangle: String.fromCharCode(9651),
            "o-with-slash": String.fromCharCode(248),
            degrees: String.fromCharCode(176),
            circle: String.fromCharCode(9675)
        }, V.validTypes = {
            n: {
                name: "note"
            },
            r: {
                name: "rest"
            },
            h: {
                name: "harmonic"
            },
            m: {
                name: "muted"
            },
            s: {
                name: "slash"
            },
            g: {
                name: "ghost"
            },
            d: {
                name: "diamond"
            },
            x: {
                name: "x"
            },
            ci: {
                name: "circled"
            },
            cx: {
                name: "circle x"
            },
            sf: {
                name: "slashed"
            },
            sb: {
                name: "slashed backward"
            },
            sq: {
                name: "square"
            },
            tu: {
                name: "triangle up"
            },
            td: {
                name: "triangle down"
            }
        }, V.TIME4_4 = {
            num_beats: 4,
            beat_value: 4,
            resolution: L
        };
        const K = {
            "1/2": {
                common: {
                    code_head: "",
                    stem: !1,
                    flag: !1,
                    stem_up_extension: -V.STEM_HEIGHT,
                    stem_down_extension: -V.STEM_HEIGHT,
                    tabnote_stem_up_extension: -V.STEM_HEIGHT,
                    tabnote_stem_down_extension: -V.STEM_HEIGHT,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "restDoubleWhole",
                    rest: !0,
                    position: "B/5",
                    dot_shiftY: .5
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            1: {
                common: {
                    code_head: "",
                    stem: !1,
                    flag: !1,
                    stem_up_extension: -V.STEM_HEIGHT,
                    stem_down_extension: -V.STEM_HEIGHT,
                    tabnote_stem_up_extension: -V.STEM_HEIGHT,
                    tabnote_stem_down_extension: -V.STEM_HEIGHT,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "restWhole",
                    ledger_code_head: "restWholeLegerLine",
                    rest: !0,
                    position: "D/5",
                    dot_shiftY: .5
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            2: {
                common: {
                    code_head: "",
                    stem: !0,
                    flag: !1,
                    stem_up_extension: 0,
                    stem_down_extension: 0,
                    tabnote_stem_up_extension: 0,
                    tabnote_stem_down_extension: 0,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "restHalf",
                    ledger_code_head: "restHalfLegerLine",
                    stem: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -0.5
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            4: {
                common: {
                    code_head: "",
                    stem: !0,
                    flag: !1,
                    stem_up_extension: 0,
                    stem_down_extension: 0,
                    tabnote_stem_up_extension: 0,
                    tabnote_stem_down_extension: 0,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "restQuarter",
                    stem: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -0.5,
                    line_above: 1.5,
                    line_below: 1.5
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            8: {
                common: {
                    code_head: "",
                    stem: !0,
                    flag: !0,
                    beam_count: 1,
                    stem_beam_extension: 0,
                    code_flag_upstem: "flag8thUp",
                    code_flag_downstem: "flag8thDown",
                    stem_up_extension: 0,
                    stem_down_extension: 0,
                    tabnote_stem_up_extension: 0,
                    tabnote_stem_down_extension: 0,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "rest8th",
                    stem: !1,
                    flag: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -0.5,
                    line_above: 1,
                    line_below: 1
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            16: {
                common: {
                    code_head: "",
                    beam_count: 2,
                    stem_beam_extension: 0,
                    stem: !0,
                    flag: !0,
                    code_flag_upstem: "flag16thUp",
                    code_flag_downstem: "flag16thDown",
                    stem_up_extension: 0,
                    stem_down_extension: 0,
                    tabnote_stem_up_extension: 0,
                    tabnote_stem_down_extension: 0,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "rest16th",
                    stem: !1,
                    flag: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -0.5,
                    line_above: 1,
                    line_below: 2
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            32: {
                common: {
                    code_head: "",
                    beam_count: 3,
                    stem_beam_extension: 7.5,
                    stem: !0,
                    flag: !0,
                    code_flag_upstem: "flag32ndUp",
                    code_flag_downstem: "flag32ndDown",
                    stem_up_extension: 9,
                    stem_down_extension: 9,
                    tabnote_stem_up_extension: 9,
                    tabnote_stem_down_extension: 9,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "rest32nd",
                    stem: !1,
                    flag: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -1.5,
                    line_above: 2,
                    line_below: 2
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            64: {
                common: {
                    code_head: "",
                    beam_count: 4,
                    stem_beam_extension: 15,
                    stem: !0,
                    flag: !0,
                    code_flag_upstem: "flag64thUp",
                    code_flag_downstem: "flag64thDown",
                    stem_up_extension: 13,
                    stem_down_extension: 13,
                    tabnote_stem_up_extension: 13,
                    tabnote_stem_down_extension: 13,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "rest64th",
                    stem: !1,
                    flag: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -1.5,
                    line_above: 2,
                    line_below: 3
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            128: {
                common: {
                    code_head: "",
                    beam_count: 5,
                    stem_beam_extension: 22.5,
                    stem: !0,
                    flag: !0,
                    code_flag_upstem: "flag128thUp",
                    code_flag_downstem: "flag128thDown",
                    stem_up_extension: 22,
                    stem_down_extension: 22,
                    tabnote_stem_up_extension: 22,
                    tabnote_stem_down_extension: 22,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "rest128th",
                    stem: !1,
                    flag: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -2.5,
                    line_above: 3,
                    line_below: 3
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            }
        };
        var $, J;
        !function(t) {
            t[t.MOVE = 0] = "MOVE", t[t.LINE = 1] = "LINE", t[t.QUADRATIC = 2] = "QUADRATIC", t[t.BEZIER = 3] = "BEZIER";
        }($ || ($ = {}));
        class q {
            constructor(t, e, i){
                this.point = -1, this.metrics = Z.loadMetrics(t, e, i), this.bbox = Z.getOutlineBoundingBox(this.metrics.outline, this.metrics.scale, this.metrics.x_shift, this.metrics.y_shift), i && (this.point = Z.lookupFontMetric(this.metrics.font, i, e, "point", -1));
            }
        }
        class Q {
            constructor(t, e, i, b){
                this.outline = t, this.originX = e, this.originY = i, this.scale = b, this.i = 0, this.precision = 1, this.precision = Math.pow(10, V.RENDER_PRECISION_PLACES);
            }
            done() {
                return this.i >= this.outline.length;
            }
            next() {
                return Math.round(this.outline[this.i++] * this.precision / this.precision);
            }
            nextX() {
                return Math.round((this.originX + this.outline[this.i++] * this.scale) * this.precision) / this.precision;
            }
            nextY() {
                return Math.round((this.originY - this.outline[this.i++] * this.scale) * this.precision) / this.precision;
            }
            static parse(t) {
                const e = [], i = t.split(" ");
                let b = 0;
                for(; b < i.length;)switch(i[b++]){
                    case "m":
                        e.push($.MOVE, parseInt(i[b++]), parseInt(i[b++]));
                        break;
                    case "l":
                        e.push($.LINE, parseInt(i[b++]), parseInt(i[b++]));
                        break;
                    case "q":
                        e.push($.QUADRATIC, parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]));
                        break;
                    case "b":
                        e.push($.BEZIER, parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]));
                }
                return e;
            }
        }
        class Z extends R {
            static get CATEGORY() {
                return x.Glyph;
            }
            static lookupFontMetric(t, e, i, b, a) {
                let n = t.lookupMetric(`glyphs.${e}.${i}.${b}`, void 0);
                return void 0 === n && (n = t.lookupMetric(`glyphs.${e}.${b}`, a)), n;
            }
            static lookupGlyph(t, e) {
                let i, b;
                p(t, "BadFontStack", "Font stack is misconfigured");
                for(let a = 0; a < t.length; a++)if (b = t[a], i = b.getGlyphs()[e], i) return {
                    glyph: i,
                    font: b
                };
                throw new g("BadGlyph", `Glyph ${e} does not exist in font.`);
            }
            static loadMetrics(t, e, i) {
                const { glyph: b, font: a } = Z.lookupGlyph(t, e);
                if (!b.o) throw new g("BadGlyph", `Glyph ${e} has no outline defined.`);
                let n = 0, s = 0, l = 1;
                i && a && (n = Z.lookupFontMetric(a, i, e, "shiftX", 0), s = Z.lookupFontMetric(a, i, e, "shiftY", 0), l = Z.lookupFontMetric(a, i, e, "scale", 1));
                const o = b.x_min, r = b.x_max, h = b.ha;
                return b.cached_outline || (b.cached_outline = Q.parse(b.o)), {
                    x_min: o,
                    x_max: r,
                    x_shift: n,
                    y_shift: s,
                    scale: l,
                    ha: h,
                    outline: b.cached_outline,
                    font: a,
                    width: r - o,
                    height: h
                };
            }
            static renderGlyph(t, e, i, b, a, n) {
                var s;
                const l = Z.cache.lookup(a, null == n ? void 0 : n.category), o = l.metrics;
                -1 != l.point && (b = l.point);
                const r = null !== (s = null == n ? void 0 : n.scale) && void 0 !== s ? s : 1, h = 72 * b / (100 * o.font.getResolution()) * o.scale * r;
                return Z.renderOutline(t, o.outline, h, e + o.x_shift * r, i + o.y_shift * r), o;
            }
            static renderOutline(t, e, i, b, a) {
                const n = new Q(e, b, a, i);
                let s, l;
                for(t.beginPath(); !n.done();)switch(n.next()){
                    case $.MOVE:
                        t.moveTo(n.nextX(), n.nextY());
                        break;
                    case $.LINE:
                        t.lineTo(n.nextX(), n.nextY());
                        break;
                    case $.QUADRATIC:
                        s = n.nextX(), l = n.nextY(), t.quadraticCurveTo(n.nextX(), n.nextY(), s, l);
                        break;
                    case $.BEZIER:
                        s = n.nextX(), l = n.nextY(), t.bezierCurveTo(n.nextX(), n.nextY(), n.nextX(), n.nextY(), s, l);
                }
                t.fill();
            }
            static getOutlineBoundingBox(t, e, i, b) {
                const a = new Q(t, i, b, e), n = new C;
                let s, l, o = i, r = b;
                for(; !a.done();)switch(a.next()){
                    case $.MOVE:
                        o = a.nextX(), r = a.nextY();
                        break;
                    case $.LINE:
                        n.addPoint(o, r), o = a.nextX(), r = a.nextY(), n.addPoint(o, r);
                        break;
                    case $.QUADRATIC:
                        s = a.nextX(), l = a.nextY(), n.addQuadraticCurve(o, r, a.nextX(), a.nextY(), s, l), o = s, r = l;
                        break;
                    case $.BEZIER:
                        s = a.nextX(), l = a.nextY(), n.addBezierCurve(o, r, a.nextX(), a.nextY(), a.nextX(), a.nextY(), s, l), o = s, r = l;
                }
                return new D(n.getX1(), n.getY1(), n.width(), n.height());
            }
            static getWidth(t, e, i) {
                const b = Z.cache.lookup(t, i);
                -1 != b.point && (e = b.point);
                const a = 72 * e / (100 * b.metrics.font.getResolution());
                return b.bbox.getW() * a;
            }
            constructor(t, e, i){
                super(), this.bbox = new D(0, 0, 0, 0), this.topGlyphs = [], this.botGlyphs = [], this.options = {}, this.scale = 1, this.code = t, this.point = e, this.originShift = {
                    x: 0,
                    y: 0
                }, this.x_shift = 0, this.y_shift = 0, i ? this.setOptions(i) : this.reset();
            }
            draw(...t) {}
            getCode() {
                return this.code;
            }
            setOptions(t) {
                this.options = Object.assign(Object.assign({}, this.options), t), this.reset();
            }
            setPoint(t) {
                return this.point = t, this;
            }
            setStave(t) {
                return this.stave = t, this;
            }
            getXShift() {
                return this.x_shift;
            }
            setXShift(t) {
                return this.x_shift = t, this;
            }
            getYshift() {
                return this.y_shift;
            }
            setYShift(t) {
                return this.y_shift = t, this;
            }
            reset() {
                const t = Z.cache.lookup(this.code, this.options.category);
                this.metrics = t.metrics, -1 != t.point && (this.point = t.point), this.scale = 72 * this.point / (100 * this.metrics.font.getResolution()), this.bbox = new D(t.bbox.getX() * this.scale, t.bbox.getY() * this.scale, t.bbox.getW() * this.scale, t.bbox.getH() * this.scale);
            }
            checkMetrics() {
                return p(this.metrics, "BadGlyph", `Glyph ${this.code} is not initialized.`);
            }
            getMetrics() {
                const t = this.checkMetrics(), e = t.scale;
                return {
                    x_min: t.x_min * this.scale * e,
                    x_max: t.x_max * this.scale * e,
                    width: this.bbox.getW(),
                    height: this.bbox.getH(),
                    scale: this.scale * e,
                    x_shift: t.x_shift,
                    y_shift: t.y_shift,
                    outline: t.outline,
                    font: t.font,
                    ha: t.ha
                };
            }
            setOriginX(t) {
                const { bbox: e } = this, i = (t - Math.abs(e.getX() / e.getW())) * e.getW();
                this.originShift.x = -i;
            }
            setOriginY(t) {
                const { bbox: e } = this, i = (t - Math.abs(e.getY() / e.getH())) * e.getH();
                this.originShift.y = -i;
            }
            setOrigin(t, e) {
                this.setOriginX(t), this.setOriginY(e);
            }
            render(t, e, i) {
                const b = this.checkMetrics(), a = b.outline, n = this.scale * b.scale;
                this.setRendered(), this.applyStyle(t);
                const s = e + this.originShift.x + b.x_shift, l = i + this.originShift.y + b.y_shift;
                Z.renderOutline(t, a, n, s, l), this.restoreStyle(t);
            }
            checkStave() {
                return p(this.stave, "NoStave", "No stave attached to instance.");
            }
            renderToStave(t) {
                const e = this.checkContext(), i = this.checkMetrics(), b = this.checkStave(), a = i.outline, n = this.scale * i.scale;
                this.setRendered(), this.applyStyle();
                const s = t + this.x_shift + i.x_shift, l = b.getYForGlyphs() + this.y_shift + i.y_shift;
                Z.renderOutline(e, a, n, s, l), this.restoreStyle();
            }
        }
        Z.cache = new class {
            constructor(){
                this.cache = new Map;
            }
            lookup(t, e) {
                let i = this.cache.get(Z.CURRENT_CACHE_KEY);
                void 0 === i && (i = {}, this.cache.set(Z.CURRENT_CACHE_KEY, i));
                const b = e ? `${t}%${e}` : t;
                let a = i[b];
                return void 0 === a && (a = new q(Z.MUSIC_FONT_STACK, t, e), i[b] = a), a;
            }
        }, Z.CURRENT_CACHE_KEY = "", Z.MUSIC_FONT_STACK = [], function(t) {
            t[t.CENTER = 0] = "CENTER", t[t.LEFT = 1] = "LEFT", t[t.RIGHT = 2] = "RIGHT", t[t.ABOVE = 3] = "ABOVE", t[t.BELOW = 4] = "BELOW";
        }(J || (J = {}));
        class tt extends R {
            static get CATEGORY() {
                return x.Modifier;
            }
            static get Position() {
                return J;
            }
            static get PositionString() {
                return {
                    center: J.CENTER,
                    above: J.ABOVE,
                    below: J.BELOW,
                    left: J.LEFT,
                    right: J.RIGHT
                };
            }
            constructor(){
                super(), this.width = 0, this.text_line = 0, this.position = tt.Position.LEFT, this.x_shift = 0, this.y_shift = 0, this.spacingFromNextModifier = 0;
            }
            reset() {}
            getWidth() {
                return this.width;
            }
            setWidth(t) {
                return this.width = t, this;
            }
            getNote() {
                return p(this.note, "NoNote", "Modifier has no note.");
            }
            checkAttachedNote() {
                const t = this.getCategory();
                return p(this.index, "NoIndex", `Can't draw ${t} without an index.`), p(this.note, "NoNote", `Can't draw ${t} without a note.`);
            }
            setNote(t) {
                return this.note = t, this;
            }
            getIndex() {
                return this.index;
            }
            checkIndex() {
                return p(this.index, "NoIndex", "Modifier has an invalid index.");
            }
            setIndex(t) {
                return this.index = t, this;
            }
            getModifierContext() {
                return this.modifierContext;
            }
            checkModifierContext() {
                return p(this.modifierContext, "NoModifierContext", "Modifier Context Required");
            }
            setModifierContext(t) {
                return this.modifierContext = t, this;
            }
            getPosition() {
                return this.position;
            }
            setPosition(t) {
                return this.position = "string" == typeof t ? tt.PositionString[t] : t, this.reset(), this;
            }
            setTextLine(t) {
                return this.text_line = t, this;
            }
            setYShift(t) {
                return this.y_shift = t, this;
            }
            setSpacingFromNextModifier(t) {
                this.spacingFromNextModifier = t;
            }
            getSpacingFromNextModifier() {
                return this.spacingFromNextModifier;
            }
            setXShift(t) {
                return this.x_shift = 0, this.position === tt.Position.LEFT ? this.x_shift -= t : this.x_shift += t, this;
            }
            getXShift() {
                return this.x_shift;
            }
            draw() {
                throw this.checkContext(), new g("NotImplemented", "draw() not implemented for this modifier.");
            }
            alignSubNotesWithNote(t, e) {
                const i = e.getTickContext(), b = i.getMetrics(), a = e.getStave(), n = i.getX() - b.modLeftPx - b.modRightPx + this.getSpacingFromNextModifier();
                t.forEach((t)=>{
                    const e = t.getTickContext();
                    a && t.setStave(a), e.setXOffset(n);
                });
            }
        }
        class et {
            static get NUM_TONES() {
                return this.canonical_notes.length;
            }
            static get roots() {
                return [
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "a",
                    "b"
                ];
            }
            static get root_values() {
                return [
                    0,
                    2,
                    4,
                    5,
                    7,
                    9,
                    11
                ];
            }
            static get root_indices() {
                return {
                    c: 0,
                    d: 1,
                    e: 2,
                    f: 3,
                    g: 4,
                    a: 5,
                    b: 6
                };
            }
            static get canonical_notes() {
                return [
                    "c",
                    "c#",
                    "d",
                    "d#",
                    "e",
                    "f",
                    "f#",
                    "g",
                    "g#",
                    "a",
                    "a#",
                    "b"
                ];
            }
            static get diatonic_intervals() {
                return [
                    "unison",
                    "m2",
                    "M2",
                    "m3",
                    "M3",
                    "p4",
                    "dim5",
                    "p5",
                    "m6",
                    "M6",
                    "b7",
                    "M7",
                    "octave"
                ];
            }
            static get diatonic_accidentals() {
                return {
                    unison: {
                        note: 0,
                        accidental: 0
                    },
                    m2: {
                        note: 1,
                        accidental: -1
                    },
                    M2: {
                        note: 1,
                        accidental: 0
                    },
                    m3: {
                        note: 2,
                        accidental: -1
                    },
                    M3: {
                        note: 2,
                        accidental: 0
                    },
                    p4: {
                        note: 3,
                        accidental: 0
                    },
                    dim5: {
                        note: 4,
                        accidental: -1
                    },
                    p5: {
                        note: 4,
                        accidental: 0
                    },
                    m6: {
                        note: 5,
                        accidental: -1
                    },
                    M6: {
                        note: 5,
                        accidental: 0
                    },
                    b7: {
                        note: 6,
                        accidental: -1
                    },
                    M7: {
                        note: 6,
                        accidental: 0
                    },
                    octave: {
                        note: 7,
                        accidental: 0
                    }
                };
            }
            static get intervals() {
                return {
                    u: 0,
                    unison: 0,
                    m2: 1,
                    b2: 1,
                    min2: 1,
                    S: 1,
                    H: 1,
                    2: 2,
                    M2: 2,
                    maj2: 2,
                    T: 2,
                    W: 2,
                    m3: 3,
                    b3: 3,
                    min3: 3,
                    M3: 4,
                    3: 4,
                    maj3: 4,
                    4: 5,
                    p4: 5,
                    "#4": 6,
                    b5: 6,
                    aug4: 6,
                    dim5: 6,
                    5: 7,
                    p5: 7,
                    "#5": 8,
                    b6: 8,
                    aug5: 8,
                    6: 9,
                    M6: 9,
                    maj6: 9,
                    b7: 10,
                    m7: 10,
                    min7: 10,
                    dom7: 10,
                    M7: 11,
                    maj7: 11,
                    8: 12,
                    octave: 12
                };
            }
            static get scales() {
                return {
                    major: [
                        2,
                        2,
                        1,
                        2,
                        2,
                        2,
                        1
                    ],
                    minor: [
                        2,
                        1,
                        2,
                        2,
                        1,
                        2,
                        2
                    ],
                    ionian: [
                        2,
                        2,
                        1,
                        2,
                        2,
                        2,
                        1
                    ],
                    dorian: [
                        2,
                        1,
                        2,
                        2,
                        2,
                        1,
                        2
                    ],
                    phyrgian: [
                        1,
                        2,
                        2,
                        2,
                        1,
                        2,
                        2
                    ],
                    lydian: [
                        2,
                        2,
                        2,
                        1,
                        2,
                        2,
                        1
                    ],
                    mixolydian: [
                        2,
                        2,
                        1,
                        2,
                        2,
                        1,
                        2
                    ],
                    aeolian: [
                        2,
                        1,
                        2,
                        2,
                        1,
                        2,
                        2
                    ],
                    locrian: [
                        1,
                        2,
                        2,
                        1,
                        2,
                        2,
                        2
                    ]
                };
            }
            static get scaleTypes() {
                return {
                    M: et.scales.major,
                    m: et.scales.minor
                };
            }
            static get accidentals() {
                return [
                    "bb",
                    "b",
                    "n",
                    "#",
                    "##"
                ];
            }
            static get noteValues() {
                return {
                    c: {
                        root_index: 0,
                        int_val: 0
                    },
                    cn: {
                        root_index: 0,
                        int_val: 0
                    },
                    "c#": {
                        root_index: 0,
                        int_val: 1
                    },
                    "c##": {
                        root_index: 0,
                        int_val: 2
                    },
                    cb: {
                        root_index: 0,
                        int_val: 11
                    },
                    cbb: {
                        root_index: 0,
                        int_val: 10
                    },
                    d: {
                        root_index: 1,
                        int_val: 2
                    },
                    dn: {
                        root_index: 1,
                        int_val: 2
                    },
                    "d#": {
                        root_index: 1,
                        int_val: 3
                    },
                    "d##": {
                        root_index: 1,
                        int_val: 4
                    },
                    db: {
                        root_index: 1,
                        int_val: 1
                    },
                    dbb: {
                        root_index: 1,
                        int_val: 0
                    },
                    e: {
                        root_index: 2,
                        int_val: 4
                    },
                    en: {
                        root_index: 2,
                        int_val: 4
                    },
                    "e#": {
                        root_index: 2,
                        int_val: 5
                    },
                    "e##": {
                        root_index: 2,
                        int_val: 6
                    },
                    eb: {
                        root_index: 2,
                        int_val: 3
                    },
                    ebb: {
                        root_index: 2,
                        int_val: 2
                    },
                    f: {
                        root_index: 3,
                        int_val: 5
                    },
                    fn: {
                        root_index: 3,
                        int_val: 5
                    },
                    "f#": {
                        root_index: 3,
                        int_val: 6
                    },
                    "f##": {
                        root_index: 3,
                        int_val: 7
                    },
                    fb: {
                        root_index: 3,
                        int_val: 4
                    },
                    fbb: {
                        root_index: 3,
                        int_val: 3
                    },
                    g: {
                        root_index: 4,
                        int_val: 7
                    },
                    gn: {
                        root_index: 4,
                        int_val: 7
                    },
                    "g#": {
                        root_index: 4,
                        int_val: 8
                    },
                    "g##": {
                        root_index: 4,
                        int_val: 9
                    },
                    gb: {
                        root_index: 4,
                        int_val: 6
                    },
                    gbb: {
                        root_index: 4,
                        int_val: 5
                    },
                    a: {
                        root_index: 5,
                        int_val: 9
                    },
                    an: {
                        root_index: 5,
                        int_val: 9
                    },
                    "a#": {
                        root_index: 5,
                        int_val: 10
                    },
                    "a##": {
                        root_index: 5,
                        int_val: 11
                    },
                    ab: {
                        root_index: 5,
                        int_val: 8
                    },
                    abb: {
                        root_index: 5,
                        int_val: 7
                    },
                    b: {
                        root_index: 6,
                        int_val: 11
                    },
                    bn: {
                        root_index: 6,
                        int_val: 11
                    },
                    "b#": {
                        root_index: 6,
                        int_val: 0
                    },
                    "b##": {
                        root_index: 6,
                        int_val: 1
                    },
                    bb: {
                        root_index: 6,
                        int_val: 10
                    },
                    bbb: {
                        root_index: 6,
                        int_val: 9
                    }
                };
            }
            isValidNoteValue(t) {
                return t >= 0 && t < et.canonical_notes.length;
            }
            isValidIntervalValue(t) {
                return t >= 0 && t < et.diatonic_intervals.length;
            }
            getNoteParts(t) {
                if (!t || t.length < 1) throw new g("BadArguments", "Invalid note name: " + t);
                if (t.length > 3) throw new g("BadArguments", "Invalid note name: " + t);
                const e = t.toLowerCase(), i = /^([cdefgab])(b|bb|n|#|##)?$/.exec(e);
                if (null !== i) return {
                    root: i[1],
                    accidental: i[2]
                };
                throw new g("BadArguments", "Invalid note name: " + t);
            }
            getKeyParts(t) {
                if (!t || t.length < 1) throw new g("BadArguments", "Invalid key: " + t);
                const e = t.toLowerCase(), i = /^([cdefgab])(b|#)?(mel|harm|m|M)?$/.exec(e);
                if (null !== i) {
                    const t = i[1], e = i[2];
                    let b = i[3];
                    return b || (b = "M"), {
                        root: t,
                        accidental: e,
                        type: b
                    };
                }
                throw new g("BadArguments", `Invalid key: ${t}`);
            }
            getNoteValue(t) {
                const e = et.noteValues[t];
                if (void 0 === e) throw new g("BadArguments", `Invalid note name: ${t}`);
                return e.int_val;
            }
            getIntervalValue(t) {
                const e = et.intervals[t];
                if (void 0 === e) throw new g("BadArguments", `Invalid interval name: ${t}`);
                return e;
            }
            getCanonicalNoteName(t) {
                if (!this.isValidNoteValue(t)) throw new g("BadArguments", `Invalid note value: ${t}`);
                return et.canonical_notes[t];
            }
            getCanonicalIntervalName(t) {
                if (!this.isValidIntervalValue(t)) throw new g("BadArguments", `Invalid interval value: ${t}`);
                return et.diatonic_intervals[t];
            }
            getRelativeNoteValue(t, e, i = 1) {
                if (1 !== i && -1 !== i) throw new g("BadArguments", `Invalid direction: ${i}`);
                let b = (t + i * e) % et.NUM_TONES;
                return b < 0 && (b += et.NUM_TONES), b;
            }
            getRelativeNoteName(t, e) {
                const i = this.getNoteParts(t), b = this.getNoteValue(i.root);
                let a = e - b;
                if (Math.abs(a) > et.NUM_TONES - 3) {
                    let i = 1;
                    a > 0 && (i = -1);
                    const n = (e + 1 + (b + 1)) % et.NUM_TONES * i;
                    if (Math.abs(n) > 2) throw new g("BadArguments", `Notes not related: ${t}, ${e})`);
                    a = n;
                }
                if (Math.abs(a) > 2) throw new g("BadArguments", `Notes not related: ${t}, ${e})`);
                let n = i.root;
                if (a > 0) for(let t = 1; t <= a; ++t)n += "#";
                else if (a < 0) for(let t = -1; t >= a; --t)n += "b";
                return n;
            }
            getScaleTones(t, e) {
                const i = [
                    t
                ];
                let b = t;
                for(let a = 0; a < e.length; a++)b = this.getRelativeNoteValue(b, e[a]), b !== t && i.push(b);
                return i;
            }
            getIntervalBetween(t, e, i = 1) {
                if (1 !== i && -1 !== i) throw new g("BadArguments", `Invalid direction: ${i}`);
                if (!this.isValidNoteValue(t) || !this.isValidNoteValue(e)) throw new g("BadArguments", `Invalid notes: ${t}, ${e}`);
                let b = 1 === i ? e - t : t - e;
                return b < 0 && (b += et.NUM_TONES), b;
            }
            createScaleMap(t) {
                const e = this.getKeyParts(t);
                if (!e.type) throw new g("BadArguments", "Unsupported key type: undefined");
                const i = et.scaleTypes[e.type];
                let b = e.root;
                if (e.accidental && (b += e.accidental), !i) throw new g("BadArguments", "Unsupported key type: " + t);
                const a = this.getScaleTones(this.getNoteValue(b), i), n = et.root_indices[e.root], s = {};
                for(let t = 0; t < et.roots.length; ++t){
                    const e = (n + t) % et.roots.length, i = et.roots[e];
                    let b = this.getRelativeNoteName(i, a[t]);
                    1 === b.length && (b += "n"), s[i] = b;
                }
                return s;
            }
        }
        function it(...t) {
            bt.DEBUG && u("Vex.Flow.Accidental", t);
        }
        class bt extends tt {
            static get CATEGORY() {
                return x.Accidental;
            }
            static format(t, e) {
                if (!t || 0 === t.length) return;
                const i = V.currentMusicFont(), b = i.lookupMetric("accidental.noteheadAccidentalPadding"), a = e.left_shift + b, n = i.lookupMetric("accidental.accidentalSpacing"), s = i.lookupMetric("accidental.leftPadding"), l = [];
                let o, r = 0;
                for(let e = 0; e < t.length; ++e){
                    const i = t[e], b = i.getNote(), a = b.getStave(), n = i.checkIndex(), s = b.getKeyProps()[n];
                    if (b !== o) {
                        for(let t = 0; t < b.keys.length; ++t)r = Math.max(b.getLeftDisplacedHeadPx() - b.getXShift(), r);
                        o = b;
                    }
                    if (a) {
                        const t = a.getSpacingBetweenLines(), e = a.getYForLine(s.line), b = Math.round(e / t * 2) / 2;
                        l.push({
                            y: e,
                            line: b,
                            extraXSpaceNeeded: r,
                            acc: i,
                            spacingBetweenStaveLines: t
                        });
                    } else l.push({
                        line: s.line,
                        extraXSpaceNeeded: r,
                        acc: i
                    });
                }
                l.sort((t, e)=>e.line - t.line);
                const h = [];
                let m = 0;
                for(let t = 0; t < l.length; t++){
                    const e = l[t], i = h[h.length - 1];
                    let b;
                    i && (null == i ? void 0 : i.line) === e.line ? b = i : (b = {
                        line: e.line,
                        flatLine: !0,
                        dblSharpLine: !0,
                        numAcc: 0,
                        width: 0,
                        column: 0
                    }, h.push(b)), "b" !== e.acc.type && "bb" !== e.acc.type && (b.flatLine = !1), "##" !== e.acc.type && (b.dblSharpLine = !1), b.numAcc++, b.width += e.acc.getWidth() + n, m = Math.max(e.extraXSpaceNeeded, m);
                }
                let c = 0;
                for(let t = 0; t < h.length; t++){
                    let e = !1;
                    const i = t;
                    let b = t;
                    for(; b + 1 < h.length && !e;)this.checkCollision(h[b], h[b + 1]) ? b++ : e = !0;
                    const a = (t)=>h[i + t], n = (t)=>t.map(a), s = (t, e)=>{
                        const [i, b] = n([
                            t,
                            e
                        ]).map((t)=>t.line);
                        return i - b;
                    }, l = (...t)=>t.map(n).every(([t, e])=>!this.checkCollision(t, e)), o = b - i + 1;
                    let r, m, d = this.checkCollision(h[i], h[b]) ? "a" : "b";
                    switch(o){
                        case 3:
                            "a" === d && .5 === s(1, 2) && .5 !== s(0, 1) && (d = "second_on_bottom");
                            break;
                        case 4:
                            l([
                                0,
                                2
                            ], [
                                1,
                                3
                            ]) && (d = "spaced_out_tetrachord");
                            break;
                        case 5:
                            "b" === d && l([
                                1,
                                3
                            ]) && (d = "spaced_out_pentachord", l([
                                0,
                                2
                            ], [
                                2,
                                4
                            ]) && (d = "very_spaced_out_pentachord"));
                            break;
                        case 6:
                            l([
                                0,
                                3
                            ], [
                                1,
                                4
                            ], [
                                2,
                                5
                            ]) && (d = "spaced_out_hexachord"), l([
                                0,
                                2
                            ], [
                                2,
                                4
                            ], [
                                1,
                                3
                            ], [
                                3,
                                5
                            ]) && (d = "very_spaced_out_hexachord");
                    }
                    if (o >= 7) {
                        let e = 2, i = !0;
                        for(; !0 === i;){
                            i = !1;
                            for(let t = 0; t + e < h.length; t++)if (this.checkCollision(h[t], h[t + e])) {
                                i = !0, e++;
                                break;
                            }
                        }
                        for(r = t; r <= b; r++)m = (r - t) % e + 1, h[r].column = m, c = c > m ? c : m;
                    } else for(r = t; r <= b; r++)m = V.accidentalColumnsTable[o][d][r - t], h[r].column = m, c = c > m ? c : m;
                    t = b;
                }
                const d = [], _ = [];
                for(let t = 0; t <= c; t++)d[t] = 0, _[t] = 0;
                d[0] = a + m, _[0] = a, h.forEach((t)=>{
                    t.width > d[t.column] && (d[t.column] = t.width);
                });
                for(let t = 1; t < d.length; t++)_[t] = d[t] + _[t - 1];
                const x = _[_.length - 1];
                let g = 0;
                h.forEach((t)=>{
                    let e = 0;
                    const i = g + t.numAcc;
                    for(; g < i; g++){
                        const i = _[t.column - 1] + e + m;
                        l[g].acc.setXShift(i), e += l[g].acc.getWidth() + n, it("Line, accCount, shift: ", t.line, g, i);
                    }
                }), e.left_shift = x + s;
            }
            static checkCollision(t, e) {
                let i = e.line - t.line, b = 3;
                i > 0 ? (b = e.flatLine || e.dblSharpLine ? 2.5 : 3, t.dblSharpLine && (i -= .5)) : (b = t.flatLine || t.dblSharpLine ? 2.5 : 3, e.dblSharpLine && (i -= .5));
                const a = Math.abs(i) < b;
                return it("Line_1, Line_2, Collision: ", t.line, e.line, a), a;
            }
            static applyAccidentals(t, e) {
                const i = [], b = {};
                t.forEach((t)=>{
                    const e = new z(0, 1);
                    t.getTickables().forEach((t)=>{
                        if (t.shouldIgnoreTicks()) return;
                        const a = b[e.value()];
                        a ? a.push(t) : (i.push(e.value()), b[e.value()] = [
                            t
                        ]), e.add(t.getTicks());
                    });
                });
                const n = new et;
                e || (e = "C");
                const s = n.createScaleMap(e), l = {};
                i.forEach((t)=>{
                    const e = b[t], i = [], o = (t)=>{
                        if (!c(t) || t.isRest() || t.shouldIgnoreTicks()) return;
                        const e = t;
                        e.keys.forEach((t, b)=>{
                            const o = n.getNoteParts(t.split("/")[0]), r = t.split("/")[1], h = o.accidental || "n", m = o.root + h;
                            l[o.root + r] || (l[o.root + r] = s[o.root]);
                            const c = l[o.root + r] === m, d = i.indexOf(t) > -1;
                            if (e.getModifiers().forEach((t, i)=>{
                                a(t) && t.type == h && t.getIndex() == b && e.getModifiers().splice(i, 1);
                            }), !c || c && d) {
                                l[o.root + r] = m;
                                const a = new bt(h);
                                e.addModifier(a, b), i.push(t);
                            }
                        }), e.getModifiers().forEach((t)=>{
                            r(t) && t.getGraceNotes().forEach(o);
                        });
                    };
                    e.forEach(o);
                });
            }
            constructor(t){
                super(), it("New accidental: ", t), this.type = t, this.position = tt.Position.LEFT, this.render_options = {
                    font_scale: V.NOTATION_FONT_SCALE,
                    parenLeftPadding: 2,
                    parenRightPadding: 2
                }, this.accidental = V.accidentalCodes(this.type), p(this.accidental, "ArgumentError", `Unknown accidental type: ${t}`), this.cautionary = !1, this.reset();
            }
            reset() {
                const t = this.render_options.font_scale;
                this.glyph = new Z(this.accidental.code, t), this.glyph.setOriginX(1), this.cautionary && (this.parenLeft = new Z(V.accidentalCodes("{").code, t), this.parenRight = new Z(V.accidentalCodes("}").code, t), this.parenLeft.setOriginX(1), this.parenRight.setOriginX(1));
            }
            getWidth() {
                if (this.cautionary) {
                    const t = p(this.parenLeft), e = p(this.parenRight), i = t.getMetrics().width + e.getMetrics().width + this.render_options.parenLeftPadding + this.render_options.parenRightPadding;
                    return this.glyph.getMetrics().width + i;
                }
                return this.glyph.getMetrics().width;
            }
            setNote(t) {
                return p(t, "ArgumentError", `Bad note value: ${t}`), this.note = t, o(t) && (this.render_options.font_scale = 25, this.reset()), this;
            }
            setAsCautionary() {
                return this.cautionary = !0, this.render_options.font_scale = 28, this.reset(), this;
            }
            draw() {
                const { type: t, position: e, index: i, cautionary: b, x_shift: a, y_shift: n, glyph: s, render_options: { parenLeftPadding: l, parenRightPadding: o } } = this, r = this.checkContext(), h = this.checkAttachedNote();
                this.setRendered();
                const m = h.getModifierStartXY(e, i);
                let c = m.x + a;
                const d = m.y + n;
                if (it("Rendering: ", t, c, d), b) {
                    const t = p(this.parenLeft), e = p(this.parenRight);
                    e.render(r, c, d), c -= e.getMetrics().width, c -= o, c -= this.accidental.parenRightPaddingAdjustment, s.render(r, c, d), c -= s.getMetrics().width, c -= l, t.render(r, c, d);
                } else s.render(r, c, d);
            }
        }
        bt.DEBUG = !1;
        class at extends R {
            static get CATEGORY() {
                return x.Stem;
            }
            static get UP() {
                return 1;
            }
            static get DOWN() {
                return -1;
            }
            static get WIDTH() {
                return V.STEM_WIDTH;
            }
            static get HEIGHT() {
                return V.STEM_HEIGHT;
            }
            constructor(t){
                super(), this.stem_up_y_offset = 0, this.stem_down_y_offset = 0, this.stem_up_y_base_offset = 0, this.stem_down_y_base_offset = 0, this.x_begin = (null == t ? void 0 : t.x_begin) || 0, this.x_end = (null == t ? void 0 : t.x_end) || 0, this.y_top = (null == t ? void 0 : t.y_top) || 0, this.y_bottom = (null == t ? void 0 : t.y_bottom) || 0, this.stem_extension = (null == t ? void 0 : t.stem_extension) || 0, this.stem_direction = (null == t ? void 0 : t.stem_direction) || 0, this.hide = (null == t ? void 0 : t.hide) || !1, this.isStemlet = (null == t ? void 0 : t.isStemlet) || !1, this.stemletHeight = (null == t ? void 0 : t.stemletHeight) || 0, this.renderHeightAdjustment = 0, this.setOptions(t);
            }
            setOptions(t) {
                this.stem_up_y_offset = (null == t ? void 0 : t.stem_up_y_offset) || 0, this.stem_down_y_offset = (null == t ? void 0 : t.stem_down_y_offset) || 0, this.stem_up_y_base_offset = (null == t ? void 0 : t.stem_up_y_base_offset) || 0, this.stem_down_y_base_offset = (null == t ? void 0 : t.stem_down_y_base_offset) || 0;
            }
            setNoteHeadXBounds(t, e) {
                return this.x_begin = t, this.x_end = e, this;
            }
            setDirection(t) {
                this.stem_direction = t;
            }
            setExtension(t) {
                this.stem_extension = t;
            }
            getExtension() {
                return this.stem_extension;
            }
            setYBounds(t, e) {
                this.y_top = t, this.y_bottom = e;
            }
            getHeight() {
                const t = this.stem_direction === at.UP ? this.stem_up_y_offset : this.stem_down_y_offset;
                return (this.y_bottom - this.y_top + (at.HEIGHT - t + this.stem_extension)) * this.stem_direction;
            }
            getBoundingBox() {
                throw new g("NotImplemented", "getBoundingBox() not implemented.");
            }
            getExtents() {
                const t = this.stem_direction === at.UP, e = [
                    this.y_top,
                    this.y_bottom
                ], i = at.HEIGHT + this.stem_extension, b = (t ? Math.min : Math.max)(...e), a = (t ? Math.max : Math.min)(...e);
                return {
                    topY: b + i * -this.stem_direction,
                    baseY: a
                };
            }
            setVisibility(t) {
                return this.hide = !t, this;
            }
            setStemlet(t, e) {
                return this.isStemlet = t, this.stemletHeight = e, this;
            }
            adjustHeightForFlag() {
                this.renderHeightAdjustment = V.currentMusicFont().lookupMetric("stem.heightAdjustmentForFlag", -3);
            }
            adjustHeightForBeam() {
                this.renderHeightAdjustment = -at.WIDTH / 2;
            }
            draw() {
                if (this.setRendered(), this.hide) return;
                const t = this.checkContext();
                let e, i;
                const b = this.stem_direction;
                let a = 0;
                b === at.DOWN ? (e = this.x_begin, i = this.y_top + this.stem_down_y_offset, a = this.stem_down_y_base_offset) : (e = this.x_end, i = this.y_bottom - this.stem_up_y_offset, a = this.stem_up_y_base_offset);
                const n = this.getHeight();
                !function(...t) {
                    at.DEBUG && u("Vex.Flow.Stem", t);
                }("Rendering stem - ", "Top Y: ", this.y_top, "Bottom Y: ", this.y_bottom);
                const s = this.isStemlet ? n - this.stemletHeight * this.stem_direction : 0;
                t.save(), this.applyStyle(), t.openGroup("stem", this.getAttribute("id"), {
                    pointerBBox: !0
                }), t.beginPath(), t.setLineWidth(at.WIDTH), t.moveTo(e, i - s + a), t.lineTo(e, i - n - this.renderHeightAdjustment * b), t.stroke(), t.closeGroup(), this.restoreStyle(), t.restore();
            }
        }
        function nt(...t) {
            rt.DEBUG && u("Vex.Flow.TextFormatter", t);
        }
        at.DEBUG = !1;
        const st = {}, lt = {}, ot = {};
        class rt {
            static getFontFamilies() {
                const t = [];
                for(const e in ot){
                    const i = ot[e];
                    t.push(Object.assign({}, i));
                }
                return t;
            }
            static create(t = {}) {
                nt("create: ", t), t.family || (t.family = F.SANS_SERIF);
                const e = [], i = t.family.split(/\s*,\s*/);
                for (const t of i){
                    for(const i in ot)i.startsWith(t) && e.push(ot[i]);
                    if (e.length > 0) break;
                }
                let b;
                if (0 === e.length) b = new rt(Object.values(ot)[0]);
                else if (1 === e.length) b = new rt(e[0]);
                else {
                    const i = F.isBold(t.weight), a = F.isItalic(t.style), n = e.find((t)=>t.bold === i && t.italic === a);
                    if (n) b = new rt(n);
                    else {
                        const t = e.find((t)=>t.italic === a || t.bold === i);
                        b = new rt(t || e[0]);
                    }
                }
                const a = t.size;
                if (void 0 !== a) {
                    const t = F.convertSizeToPointValue(a);
                    b.setFontSize(t);
                }
                return b;
            }
            static getInfo(t) {
                return ot[t];
            }
            static registerInfo(t, e = !1) {
                nt("registerInfo: ", t, e);
                const i = t.family;
                (void 0 === ot[i] || e) && (ot[i] = t);
            }
            constructor(t){
                this.family = "", this.size = 14, this.resolution = 1e3, this.glyphs = {}, this.serifs = !1, this.monospaced = !1, this.italic = !1, this.bold = !1, this.superscriptOffset = 0, this.subscriptOffset = 0, this.maxSizeGlyph = "@", this.cacheKey = "", this.updateParams(t);
            }
            get localHeightCache() {
                var t;
                return void 0 === lt[this.cacheKey] && (lt[this.cacheKey] = {}), null !== (t = lt[this.cacheKey]) && void 0 !== t ? t : {};
            }
            updateParams(t) {
                t.family && (this.family = t.family), t.resolution && (this.resolution = t.resolution), t.glyphs && (this.glyphs = t.glyphs), t.serifs && (this.serifs = t.serifs), t.monospaced && (this.monospaced = t.monospaced), t.italic && (this.italic = t.italic), t.bold && (this.bold = t.bold), t.maxSizeGlyph && (this.maxSizeGlyph = t.maxSizeGlyph), t.superscriptOffset && (this.superscriptOffset = t.superscriptOffset), t.subscriptOffset && (this.subscriptOffset = t.subscriptOffset), this.updateCacheKey();
            }
            updateCacheKey() {
                const t = this.family.replace(/\s+/g, "_"), e = this.size, i = this.bold ? E.BOLD : E.NORMAL, b = this.italic ? P.ITALIC : P.NORMAL;
                this.cacheKey = `${t}%${e}%${i}%${b}`;
            }
            getGlyphMetrics(t) {
                return this.glyphs[t] ? this.glyphs[t] : this.glyphs[this.maxSizeGlyph];
            }
            get maxHeight() {
                return this.getGlyphMetrics(this.maxSizeGlyph).ha / this.resolution * this.fontSizeInPixels;
            }
            getWidthForCharacterInEm(t) {
                var e;
                const i = this.getGlyphMetrics(t);
                if (i) return (null !== (e = i.advanceWidth) && void 0 !== e ? e : 0) / this.resolution;
                return .65;
            }
            getYForCharacterInPx(t) {
                const e = this.getGlyphMetrics(t), i = {
                    yMin: 0,
                    yMax: this.maxHeight,
                    height: this.maxHeight
                };
                return e ? ("number" == typeof e.y_min && (i.yMin = e.y_min / this.resolution * this.fontSizeInPixels), "number" == typeof e.y_max && (i.yMax = e.y_max / this.resolution * this.fontSizeInPixels), i.height = i.yMax - i.yMin, i) : i;
            }
            getYForStringInPx(t) {
                const e = this.localHeightCache, i = {
                    yMin: 0,
                    yMax: this.maxHeight,
                    height: this.maxHeight
                }, b = e[t];
                if (void 0 !== b) return b;
                for(let e = 0; e < t.length; ++e){
                    const b = this.getYForCharacterInPx(t[e]);
                    i.yMin = Math.min(i.yMin, b.yMin), i.yMax = Math.max(i.yMax, b.yMax), i.height = i.yMax - i.yMin;
                }
                return e[t] = i, i;
            }
            getWidthForTextInEm(t) {
                const e = this.cacheKey;
                let i = st[e];
                void 0 === i && (i = {}, st[e] = i);
                let b = i[t];
                if (void 0 === b) {
                    b = 0;
                    for(let e = 0; e < t.length; ++e)b += this.getWidthForCharacterInEm(t[e]);
                    i[t] = b;
                }
                return b;
            }
            getWidthForTextInPx(t) {
                return this.getWidthForTextInEm(t) * this.fontSizeInPixels;
            }
            setFontSize(t) {
                return this.size = t, this.updateCacheKey(), this;
            }
            get fontSizeInPixels() {
                return this.size * F.scaleToPxFrom.pt;
            }
            getResolution() {
                return this.resolution;
            }
        }
        var ht, mt;
        rt.DEBUG = !1, function(t) {
            t[t.LEFT = 1] = "LEFT", t[t.CENTER = 2] = "CENTER", t[t.RIGHT = 3] = "RIGHT", t[t.CENTER_STEM = 4] = "CENTER_STEM";
        }(ht || (ht = {})), function(t) {
            t[t.TOP = 1] = "TOP", t[t.CENTER = 2] = "CENTER", t[t.BOTTOM = 3] = "BOTTOM", t[t.CENTER_STEM = 4] = "CENTER_STEM";
        }(mt || (mt = {}));
        class ct extends tt {
            static get CATEGORY() {
                return x.Annotation;
            }
            static get minAnnotationPadding() {
                return V.currentMusicFont().lookupMetric("noteHead.minPadding");
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0, b = 0, a = 0, n = 0;
                for(let s = 0; s < t.length; ++s){
                    const l = t[s], o = rt.create(l.textFont);
                    let r = (2 + o.getYForStringInPx(l.text).height) / V.STAVE_LINE_DISTANCE;
                    const h = l.checkAttachedNote(), m = h.getGlyphProps().getWidth(), c = o.getWidthForTextInPx(l.text);
                    l.horizontalJustification === ht.LEFT ? (a = Math.max(m, a), i = Math.max(i, c) + ct.minAnnotationPadding) : l.horizontalJustification === ht.RIGHT ? (n = Math.max(m, n), b = Math.max(b, c)) : (i = Math.max(i, c / 2) + ct.minAnnotationPadding, b = Math.max(b, c / 2), a = Math.max(m / 2, a), n = Math.max(m / 2, n));
                    const x = h.getStave(), g = h.hasStem() ? h.getStemDirection() : at.UP;
                    let y = 0, p = 5;
                    if (_(h)) {
                        if (h.render_options.draw_stem) {
                            const t = h.getStem();
                            t && (y = Math.abs(t.getHeight()) / V.STAVE_LINE_DISTANCE);
                        } else y = 0;
                    } else if (d(h)) {
                        const t = h.getStem();
                        t && "n" === h.getNoteType() && (y = Math.abs(t.getHeight()) / V.STAVE_LINE_DISTANCE);
                    }
                    if (x && (p = x.getNumLines()), l.verticalJustification === this.VerticalJustify.TOP) {
                        let t = h.getLineNumber(!0);
                        _(h) && (t = p - (h.leastString() - .5)), g === at.UP && (t += y);
                        t + e.top_text_line + .5 < p ? (l.setTextLine(p - t), r += p - t, e.top_text_line = r) : (l.setTextLine(e.top_text_line), e.top_text_line += r);
                    } else if (l.verticalJustification === this.VerticalJustify.BOTTOM) {
                        let t = p - h.getLineNumber();
                        _(h) && (t = h.greatestString() - 1), g === at.DOWN && (t += y);
                        const i = t + e.text_line + 1;
                        i < p ? (l.setTextLine(p - i), r += p - i, e.text_line = r) : (l.setTextLine(e.text_line), e.text_line += r);
                    } else l.setTextLine(e.text_line);
                }
                const s = Math.min(Math.max(b - n, 0), Math.max(b - e.right_shift, 0)), l = Math.min(Math.max(i - a, 0), Math.max(i - e.left_shift, 0));
                return e.left_shift += l, e.right_shift += s, !0;
            }
            constructor(t){
                super(), this.text = t, this.horizontalJustification = ht.CENTER, this.verticalJustification = mt.TOP, this.resetFont(), this.setWidth(V.textWidth(t));
            }
            setVerticalJustification(t) {
                return this.verticalJustification = "string" == typeof t ? ct.VerticalJustifyString[t] : t, this;
            }
            getJustification() {
                return this.horizontalJustification;
            }
            setJustification(t) {
                return this.horizontalJustification = "string" == typeof t ? ct.HorizontalJustifyString[t] : t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote(), i = e.hasStem() ? e.getStemDirection() : at.UP, b = rt.create(this.textFont), a = e.getModifierStartXY(J.ABOVE, this.index);
                this.setRendered(), t.save(), this.applyStyle(), t.openGroup("annotation", this.getAttribute("id")), t.setFont(this.textFont);
                const n = b.getWidthForTextInPx(this.text), s = b.getYForStringInPx(this.text).height;
                let l, o;
                l = this.horizontalJustification === ht.LEFT ? a.x : this.horizontalJustification === ht.RIGHT ? a.x - n : this.horizontalJustification === ht.CENTER ? a.x - n / 2 : e.getStemX() - n / 2;
                let r = {}, h = 0;
                const m = e.hasStem(), c = e.checkStave();
                if (m && (r = e.checkStem().getExtents(), h = c.getSpacingBetweenLines()), this.verticalJustification === mt.BOTTOM) o = e.getYs().reduce((t, e)=>t > e ? t : e), o += (this.text_line + 1) * V.STAVE_LINE_DISTANCE + s, m && i === at.DOWN && (o = Math.max(o, r.topY + s + h * this.text_line));
                else if (this.verticalJustification === mt.CENTER) {
                    const t = e.getYForTopText(this.text_line) - 1;
                    o = t + (c.getYForBottomText(this.text_line) - t) / 2 + s / 2;
                } else if (this.verticalJustification === mt.TOP) o = Math.min(...e.getYs()) - (this.text_line + 1) * V.STAVE_LINE_DISTANCE, m && i === at.UP && (h = r.topY < c.getTopLineTopY() ? V.STAVE_LINE_DISTANCE : h, o = Math.min(o, r.topY - h * (this.text_line + 1)));
                else {
                    const t = e.getStemExtents();
                    o = t.topY + (t.baseY - t.topY) / 2 + s / 2;
                }
                !function(...t) {
                    ct.DEBUG && u("Vex.Flow.Annotation", t);
                }("Rendering annotation: ", this.text, l, o), t.fillText(this.text, l, o), t.closeGroup(), this.restoreStyle(), t.restore();
            }
        }
        ct.DEBUG = !1, ct.TEXT_FONT = Object.assign({}, R.TEXT_FONT), ct.HorizontalJustify = ht, ct.HorizontalJustifyString = {
            left: ht.LEFT,
            right: ht.RIGHT,
            center: ht.CENTER,
            centerStem: ht.CENTER_STEM
        }, ct.VerticalJustify = mt, ct.VerticalJustifyString = {
            above: mt.TOP,
            top: mt.TOP,
            below: mt.BOTTOM,
            bottom: mt.BOTTOM,
            center: mt.CENTER,
            centerStem: mt.CENTER_STEM
        };
        const { ABOVE: dt, BELOW: _t } = tt.Position;
        function xt(t, e) {
            return .5 * t(e / .5);
        }
        function gt(t, e) {
            return e === dt ? t <= 5 : t >= 1;
        }
        function yt(t, e) {
            return gt(t, e) ? e === dt ? Math.ceil : Math.floor : Math.round;
        }
        const pt = (t)=>c(t) || o(t);
        class ut extends tt {
            static get CATEGORY() {
                return x.Articulation;
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0;
                const b = (t, e, i)=>xt(yt(e, i), p(t.glyph.getMetrics().height) / 10 + .5);
                t.forEach((t)=>{
                    const a = t.checkAttachedNote();
                    i = Math.max(a.getGlyphProps().getWidth(), i);
                    let n = 5;
                    const s = a.hasStem() ? a.getStemDirection() : at.UP;
                    let l = 0;
                    if (d(a)) {
                        const t = a.getStem();
                        t && (l = Math.abs(t.getHeight()) / V.STAVE_LINE_DISTANCE);
                    }
                    const o = a.getStave();
                    if (o && (n = o.getNumLines()), t.getPosition() === dt) {
                        let i = a.getLineNumber(!0);
                        s === at.UP && (i += l);
                        let o = b(t, e.top_text_line, dt);
                        const r = i + e.top_text_line + .5;
                        !t.articulation.between_lines && r < n && (o += n - r), t.setTextLine(e.top_text_line), e.top_text_line += o;
                    } else if (t.getPosition() === _t) {
                        let i = Math.max(n - a.getLineNumber(), 0);
                        s === at.DOWN && (i += l);
                        let o = b(t, e.text_line, _t);
                        const r = i + e.text_line + .5;
                        !t.articulation.between_lines && r < n && (o += n - r), t.setTextLine(e.text_line), e.text_line += o;
                    }
                });
                const a = t.map((t)=>t.getWidth()).reduce((t, e)=>Math.max(e, t)), n = Math.min(Math.max(a - i, 0), Math.max(a - (e.left_shift + e.right_shift), 0));
                return e.left_shift += n / 2, e.right_shift += n / 2, !0;
            }
            static easyScoreHook({ articulations: t }, e, i) {
                if (!t) return;
                const b = {
                    staccato: "a.",
                    tenuto: "a-",
                    accent: "a>"
                };
                t.split(",").map((t)=>t.trim().split(".")).map(([t, e])=>{
                    const a = {
                        type: b[t]
                    };
                    return e && (a.position = tt.PositionString[e]), i.getFactory().Articulation(a);
                }).map((t)=>e.addModifier(t, 0));
            }
            constructor(t){
                super(), this.type = t, this.position = dt, this.render_options = {
                    font_scale: V.NOTATION_FONT_SCALE
                }, this.reset();
            }
            reset() {
                this.articulation = V.articulationCodes(this.type), this.articulation || (this.articulation = {
                    code: this.type,
                    between_lines: !1
                }, this.type.endsWith("Above") && (this.position = dt), this.type.endsWith("Below") && (this.position = _t));
                const t = (this.position === dt ? this.articulation.aboveCode : this.articulation.belowCode) || this.articulation.code;
                this.glyph = new Z(null != t ? t : "", this.render_options.font_scale), p(this.glyph, "ArgumentError", `Articulation not found: ${this.type}`), this.setWidth(p(this.glyph.getMetrics().width));
            }
            setBetweenLines(t = !0) {
                return this.articulation.between_lines = t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = this.checkIndex(), { position: b, glyph: a, text_line: n } = this, s = this.articulation.between_lines, l = e.checkStave(), o = l.getSpacingBetweenLines(), r = _(e), { x: h } = e.getModifierStartXY(b, i), m = !s || r, c = function(t, e) {
                    const i = e === dt && t.getStemDirection() === at.UP || e === _t && t.getStemDirection() === at.DOWN;
                    return pt(t) ? t.hasStem() && i ? .5 : 1 : t.hasStem() && i ? 1 : 0;
                }(e, b), d = V.currentMusicFont().lookupMetric(`articulation.${a.getCode()}.padding`, 0);
                let x = ({
                    [dt]: ()=>{
                        a.setOrigin(.5, 1);
                        const t = function(t, e) {
                            const i = t.getStemDirection(), { topY: b, baseY: a } = t.getStemExtents();
                            if (pt(t)) return t.hasStem() ? i === at.UP ? b : a : Math.min(...t.getYs());
                            if (_(t)) return t.hasStem() && i === at.UP ? b : t.checkStave().getYForTopText(e);
                            throw new g("UnknownCategory", "Only can get the top and bottom ys of stavenotes and tabnotes");
                        }(e, n) - (n + c) * o;
                        return m ? Math.min(l.getYForTopText(ut.INITIAL_OFFSET), t) : t;
                    },
                    [_t]: ()=>{
                        a.setOrigin(.5, 0);
                        const t = function(t, e) {
                            const i = t.getStemDirection(), { topY: b, baseY: a } = t.getStemExtents();
                            if (pt(t)) return t.hasStem() ? i === at.UP ? a : b : Math.max(...t.getYs());
                            if (_(t)) return t.hasStem() ? i === at.UP ? t.checkStave().getYForBottomText(e) : b : t.checkStave().getYForBottomText(e);
                            throw new g("UnknownCategory", "Only can get the top and bottom ys of stavenotes and tabnotes");
                        }(e, n) + (n + c) * o;
                        return m ? Math.max(l.getYForBottomText(ut.INITIAL_OFFSET), t) : t;
                    }
                })[b]();
                if (!r) {
                    const t = b === dt ? -1 : 1, n = e.getKeyProps()[i].line, l = (e.getYs()[i] - x) / o + Number(n), r = function(t, e, i, b) {
                        const a = xt(yt(e, i), e);
                        if (t && gt(a, i) && a % 1 == 0) return a + .5 * -b;
                        return a;
                    }(s, l, b, t);
                    gt(r, b) && a.setOrigin(.5, .5), x += Math.abs(r - l) * o * t + d * t;
                }
                !function(...t) {
                    ut.DEBUG && u("Vex.Flow.Articulation", t);
                }(`Rendering articulation at (x: ${h}, y: ${x})`), a.render(t, h, x);
            }
        }
        ut.DEBUG = !1, ut.INITIAL_OFFSET = -0.5;
        class ft {
            static get CATEGORY() {
                return x.RenderContext;
            }
            set font(t) {
                this.setFont(t);
            }
            get font() {
                return this.getFont();
            }
            setRawFont(t) {
                return this.setFont(t), this;
            }
        }
        function St(t, e, i, b = "#F55") {
            t.save(), t.setFillStyle(b), t.beginPath(), t.arc(e, i, 3, 0, 2 * Math.PI, !1), t.closePath(), t.fill(), t.restore();
        }
        class Tt extends R {
            static get CATEGORY() {
                return x.Tickable;
            }
            constructor(){
                super(), this._preFormatted = !1, this._postFormatted = !1, this.ticks = new z(0, 1), this.intrinsicTicks = 0, this.tickMultiplier = new z(1, 1), this.width = 0, this.x_shift = 0, this.modifiers = [], this.tupletStack = [], this.align_center = !1, this.center_x_shift = 0, this.ignore_ticks = !1, this.formatterMetrics = {
                    freedom: {
                        left: 0,
                        right: 0
                    },
                    duration: "",
                    iterations: 0,
                    space: {
                        used: 0,
                        mean: 0,
                        deviation: 0
                    }
                };
            }
            reset() {
                return this;
            }
            getTicks() {
                return this.ticks;
            }
            shouldIgnoreTicks() {
                return this.ignore_ticks;
            }
            setIgnoreTicks(t) {
                return this.ignore_ticks = t, this;
            }
            setWidth(t) {
                this.width = t;
            }
            getWidth() {
                if (!this._preFormatted) throw new g("UnformattedNote", "Can't call GetWidth on an unformatted note.");
                return this.width + (this.modifierContext ? this.modifierContext.getWidth() : 0);
            }
            setXShift(t) {
                return this.x_shift = t, this;
            }
            getXShift() {
                return this.x_shift;
            }
            getX() {
                return this.checkTickContext("Can't getX() without a TickContext.").getX() + this.x_shift;
            }
            getFormatterMetrics() {
                return this.formatterMetrics;
            }
            getCenterXShift() {
                return this.isCenterAligned() ? this.center_x_shift : 0;
            }
            setCenterXShift(t) {
                return this.center_x_shift = t, this;
            }
            isCenterAligned() {
                return this.align_center;
            }
            setCenterAlignment(t) {
                return this.align_center = t, this;
            }
            getVoice() {
                return p(this.voice, "NoVoice", "Tickable has no voice.");
            }
            setVoice(t) {
                this.voice = t;
            }
            getTuplet() {
                return this.tuplet;
            }
            getTupletStack() {
                return this.tupletStack;
            }
            resetTuplet(t) {
                let e, i;
                if (t) {
                    const b = this.tupletStack.indexOf(t);
                    return -1 !== b && (this.tupletStack.splice(b, 1), e = t.getNoteCount(), i = t.getNotesOccupied(), this.applyTickMultiplier(e, i)), this;
                }
                for(; this.tupletStack.length;)e = (t = this.tupletStack.pop()).getNoteCount(), i = t.getNotesOccupied(), this.applyTickMultiplier(e, i);
                return this;
            }
            setTuplet(t) {
                if (t) {
                    this.tupletStack.push(t);
                    const e = t.getNoteCount(), i = t.getNotesOccupied();
                    this.applyTickMultiplier(i, e);
                }
                return this.tuplet = t, this;
            }
            addToModifierContext(t) {
                this.modifierContext = t;
                for(let t = 0; t < this.modifiers.length; ++t)this.modifierContext.addMember(this.modifiers[t]);
                return this.modifierContext.addMember(this), this._preFormatted = !1, this;
            }
            addModifier(t, e = 0) {
                return this.modifiers.push(t), this._preFormatted = !1, this;
            }
            getModifiers() {
                return this.modifiers;
            }
            setTickContext(t) {
                this.tickContext = t, this._preFormatted = !1;
            }
            checkTickContext(t = "Tickable has no tick context.") {
                return p(this.tickContext, "NoTickContext", t);
            }
            preFormat() {
                this._preFormatted || (this.width = 0, this.modifierContext && (this.modifierContext.preFormat(), this.width += this.modifierContext.getWidth()));
            }
            set preFormatted(t) {
                this._preFormatted = t;
            }
            get preFormatted() {
                return this._preFormatted;
            }
            postFormat() {
                return this._postFormatted || (this._postFormatted = !0), this;
            }
            set postFormatted(t) {
                this._postFormatted = t;
            }
            get postFormatted() {
                return this._postFormatted;
            }
            getIntrinsicTicks() {
                return this.intrinsicTicks;
            }
            setIntrinsicTicks(t) {
                this.intrinsicTicks = t, this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
            }
            getTickMultiplier() {
                return this.tickMultiplier;
            }
            applyTickMultiplier(t, e) {
                this.tickMultiplier.multiply(t, e), this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
            }
            setDuration(t) {
                const e = t.numerator * (V.RESOLUTION / t.denominator);
                this.ticks = this.tickMultiplier.clone().multiply(e), this.intrinsicTicks = this.ticks.value();
            }
            getAbsoluteX() {
                return this.checkTickContext("Can't getAbsoluteX() without a TickContext.").getX();
            }
            setModifierContext(t) {
                return this.modifierContext = t, this;
            }
            getModifierContext() {
                return this.modifierContext;
            }
            checkModifierContext() {
                return p(this.modifierContext, "NoModifierContext", "No modifier context attached to this tickable.");
            }
        }
        class vt extends Tt {
            static get CATEGORY() {
                return x.Note;
            }
            static plotMetrics(t, e, i) {
                const b = e.getMetrics(), a = e.getAbsoluteX() - b.modLeftPx - b.leftDisplacedHeadPx, n = e.getAbsoluteX() - b.leftDisplacedHeadPx, s = e.getAbsoluteX(), l = e.getAbsoluteX() + b.notePx, o = e.getAbsoluteX() + b.notePx + b.rightDisplacedHeadPx, r = e.getAbsoluteX() + b.notePx + b.rightDisplacedHeadPx + b.modRightPx, h = r + (e.getFormatterMetrics().freedom.right || 0), m = r - a;
                t.save(), t.setFont(F.SANS_SERIF, 8), t.fillText(Math.round(m) + "px", a + e.getXShift(), i);
                const c = i + 7;
                function d(i, b, a, n = c) {
                    t.beginPath(), t.setStrokeStyle(a), t.setFillStyle(a), t.setLineWidth(3), t.moveTo(i + e.getXShift(), n), t.lineTo(b + e.getXShift(), n), t.stroke();
                }
                d(a, n, "red"), d(n, s, "#999"), d(s, l, "green"), d(l, o, "#999"), d(o, r, "red"), d(r, h, "#DD0"), d(a - e.getXShift(), a, "#BBB"), St(t, s + e.getXShift(), c, "blue");
                const _ = e.getFormatterMetrics();
                if (_.iterations > 0) {
                    const b = _.space.deviation, a = b >= 0 ? "+" : "";
                    t.setFillStyle("red"), t.fillText(a + Math.round(b), s + e.getXShift(), i - 10);
                }
                t.restore();
            }
            static parseDuration(t) {
                if (!t) return;
                const e = /(\d*\/?\d+|[a-z])(d*)([nrhms]|$)/.exec(t);
                if (!e) return;
                return {
                    duration: e[1],
                    dots: e[2].length,
                    type: e[3] || "n"
                };
            }
            static parseNoteStruct(t) {
                const e = vt.parseDuration(t.duration);
                if (!e) return;
                let i = t.type;
                if (i && !V.validTypes[i]) return;
                const b = [];
                i || (i = e.type || "n", void 0 !== t.keys && t.keys.forEach((t, e)=>{
                    const a = t.split("/");
                    b[e] = a && 3 === a.length ? a[2] : i;
                }));
                let a = V.durationToTicks(e.duration);
                if (!a) return;
                const n = t.dots ? t.dots : e.dots;
                if ("number" != typeof n) return;
                let s = a;
                for(let t = 0; t < n; t++){
                    if (s <= 1) return;
                    s /= 2, a += s;
                }
                return {
                    duration: e.duration,
                    type: i,
                    customTypes: b,
                    dots: n,
                    ticks: a
                };
            }
            constructor(t){
                if (super(), !t) throw new g("BadArguments", "Note must have valid initialization data to identify duration and type.");
                const e = vt.parseNoteStruct(t);
                if (!e) throw new g("BadArguments", `Invalid note initialization object: ${JSON.stringify(t)}`);
                this.keys = t.keys || [], this.keyProps = [], this.duration = e.duration, this.noteType = e.type, this.customTypes = e.customTypes, t.duration_override ? this.setDuration(t.duration_override) : this.setIntrinsicTicks(e.ticks), this.modifiers = [], this.glyphProps = V.getGlyphProps(this.duration, this.noteType), this.customGlyphs = this.customTypes.map((t)=>V.getGlyphProps(this.duration, t)), this.playNote = void 0, this.ignore_ticks = !1, this.width = 0, this.leftDisplacedHeadPx = 0, this.rightDisplacedHeadPx = 0, this.x_shift = 0, this.ys = [], t.align_center && this.setCenterAlignment(t.align_center), this.render_options = {
                    annotation_spacing: 5,
                    glyph_font_scale: 1,
                    stroke_px: 1,
                    scale: 1,
                    font: "",
                    y_shift: 0
                };
            }
            getPlayNote() {
                return this.playNote;
            }
            setPlayNote(t) {
                return this.playNote = t, this;
            }
            isRest() {
                return !1;
            }
            addStroke(t, e) {
                return e.setNote(this), e.setIndex(t), this.modifiers.push(e), this.preFormatted = !1, this;
            }
            getStave() {
                return this.stave;
            }
            checkStave() {
                return p(this.stave, "NoStave", "No stave attached to instance.");
            }
            setStave(t) {
                return this.stave = t, this.setYs([
                    t.getYForLine(0)
                ]), this.setContext(this.stave.getContext()), this;
            }
            getLeftDisplacedHeadPx() {
                return this.leftDisplacedHeadPx;
            }
            getRightDisplacedHeadPx() {
                return this.rightDisplacedHeadPx;
            }
            setLeftDisplacedHeadPx(t) {
                return this.leftDisplacedHeadPx = t, this;
            }
            setRightDisplacedHeadPx(t) {
                return this.rightDisplacedHeadPx = t, this;
            }
            shouldIgnoreTicks() {
                return this.ignore_ticks;
            }
            getLineNumber(t) {
                return 0;
            }
            getLineForRest() {
                return 0;
            }
            getGlyph() {
                return this.glyphProps;
            }
            getGlyphProps() {
                return this.glyphProps;
            }
            getGlyphWidth() {
                return this.glyphProps.getWidth(this.render_options.glyph_font_scale);
            }
            setYs(t) {
                return this.ys = t, this;
            }
            getYs() {
                if (0 === this.ys.length) throw new g("NoYValues", "No Y-values calculated for this note.");
                return this.ys;
            }
            getYForTopText(t) {
                return this.checkStave().getYForTopText(t);
            }
            getVoice() {
                if (!this.voice) throw new g("NoVoice", "Note has no voice.");
                return this.voice;
            }
            setVoice(t) {
                return this.voice = t, this.preFormatted = !1, this;
            }
            getTickContext() {
                return this.checkTickContext();
            }
            setTickContext(t) {
                return this.tickContext = t, this.preFormatted = !1, this;
            }
            getDuration() {
                return this.duration;
            }
            isDotted() {
                return this.getModifiersByType(x.Dot).length > 0;
            }
            hasStem() {
                return !1;
            }
            getNoteType() {
                return this.noteType;
            }
            getBeam() {
                return this.beam;
            }
            checkBeam() {
                return p(this.beam, "NoBeam", "No beam attached to instance");
            }
            hasBeam() {
                return null != this.beam;
            }
            setBeam(t) {
                return this.beam = t, this;
            }
            addModifier(t, e = 0) {
                const i = "Note.addModifier(modifier: Modifier, index: number=0)";
                if ("string" == typeof e && (e = parseInt(e), console.warn(i + " expected a number for `index`, but received a string.")), "object" != typeof t || "number" != typeof e) throw new g("WrongParams", "Incorrect call signature. Use " + i + " instead.");
                return t.setNote(this), t.setIndex(e), super.addModifier(t), this;
            }
            getModifiersByType(t) {
                return this.modifiers.filter((e)=>e.getCategory() === t);
            }
            getModifierStartXY(t, e, i) {
                if (!this.preFormatted) throw new g("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
                return {
                    x: this.getAbsoluteX(),
                    y: this.ys[0]
                };
            }
            getRightParenthesisPx(t) {
                return this.getKeyProps()[t].displaced ? this.getRightDisplacedHeadPx() : 0;
            }
            getLeftParenthesisPx(t) {
                return this.getKeyProps()[t].displaced ? this.getLeftDisplacedHeadPx() - this.x_shift : -this.x_shift;
            }
            getFirstDotPx() {
                let t = this.getRightDisplacedHeadPx();
                return 0 !== this.checkModifierContext().getMembers("Parenthesis").length && (t += V.currentMusicFont().lookupMetric("parenthesis.default.width")), t;
            }
            getMetrics() {
                if (!this.preFormatted) throw new g("UnformattedNote", "Can't call getMetrics on an unformatted note.");
                const t = this.modifierContext ? this.modifierContext.getState().left_shift : 0, e = this.modifierContext ? this.modifierContext.getState().right_shift : 0, i = this.getWidth();
                return {
                    width: i,
                    glyphWidth: this.getGlyphWidth(),
                    notePx: i - t - e - this.leftDisplacedHeadPx - this.rightDisplacedHeadPx,
                    modLeftPx: t,
                    modRightPx: e,
                    leftDisplacedHeadPx: this.leftDisplacedHeadPx,
                    rightDisplacedHeadPx: this.rightDisplacedHeadPx,
                    glyphPx: 0
                };
            }
            getAbsoluteX() {
                let t = this.checkTickContext("Can't getAbsoluteX() without a TickContext.").getX();
                return this.stave && (t += this.stave.getNoteStartX() + V.currentMusicFont().lookupMetric("stave.padding")), this.isCenterAligned() && (t += this.getCenterXShift()), t;
            }
            static getPoint(t) {
                return "default" == t ? V.NOTATION_FONT_SCALE : V.NOTATION_FONT_SCALE / 5 * 3;
            }
            getStemDirection() {
                throw new g("NoStem", "No stem attached to this note.");
            }
            getStemExtents() {
                throw new g("NoStem", "No stem attached to this note.");
            }
            getTieRightX() {
                let t = this.getAbsoluteX();
                return t += this.glyphProps.getWidth() / 2, t += -this.width / 2 + this.width + 2, t;
            }
            getTieLeftX() {
                let t = this.getAbsoluteX();
                return t += this.glyphProps.getWidth() / 2, t -= this.width / 2 + 2, t;
            }
            getKeys() {
                return this.keys;
            }
            getKeyProps() {
                return this.keyProps;
            }
        }
        var wt, zt, Bt, Dt, Ct, Et;
        !function(t) {
            t[t.CENTER = 0] = "CENTER", t[t.LEFT = 1] = "LEFT", t[t.RIGHT = 2] = "RIGHT", t[t.ABOVE = 3] = "ABOVE", t[t.BELOW = 4] = "BELOW", t[t.BEGIN = 5] = "BEGIN", t[t.END = 6] = "END";
        }(wt || (wt = {}));
        class Pt extends R {
            static get CATEGORY() {
                return x.StaveModifier;
            }
            static get Position() {
                return wt;
            }
            constructor(){
                super(), this.width = 0, this.x = 0, this.padding = 10, this.position = wt.ABOVE;
            }
            getPosition() {
                return this.position;
            }
            setPosition(t) {
                return this.position = t, this;
            }
            getStave() {
                return this.stave;
            }
            checkStave() {
                return p(this.stave, "NoStave", "No stave attached to instance.");
            }
            setStave(t) {
                return this.stave = t, this;
            }
            getWidth() {
                return this.width;
            }
            setWidth(t) {
                return this.width = t, this;
            }
            getX() {
                return this.x;
            }
            setX(t) {
                return this.x = t, this;
            }
            placeGlyphOnLine(t, e, i, b = 0) {
                t.setYShift(e.getYForLine(null != i ? i : 0) - e.getYForGlyphs() + b);
            }
            getPadding(t) {
                return void 0 !== t && t < 2 ? 0 : this.padding;
            }
            setPadding(t) {
                return this.padding = t, this;
            }
            setLayoutMetrics(t) {
                return this.layoutMetrics = t, this;
            }
            getLayoutMetrics() {
                return this.layoutMetrics;
            }
            draw(...t) {}
        }
        !function(t) {
            t[t.SINGLE = 1] = "SINGLE", t[t.DOUBLE = 2] = "DOUBLE", t[t.END = 3] = "END", t[t.REPEAT_BEGIN = 4] = "REPEAT_BEGIN", t[t.REPEAT_END = 5] = "REPEAT_END", t[t.REPEAT_BOTH = 6] = "REPEAT_BOTH", t[t.NONE = 7] = "NONE";
        }(zt || (zt = {}));
        class kt extends Pt {
            static get CATEGORY() {
                return x.Barline;
            }
            static get type() {
                return zt;
            }
            static get typeString() {
                return {
                    single: zt.SINGLE,
                    double: zt.DOUBLE,
                    end: zt.END,
                    repeatBegin: zt.REPEAT_BEGIN,
                    repeatEnd: zt.REPEAT_END,
                    repeatBoth: zt.REPEAT_BOTH,
                    none: zt.NONE
                };
            }
            constructor(t){
                super(), this.thickness = V.STAVE_LINE_THICKNESS;
                const e = zt;
                this.widths = {}, this.widths[e.SINGLE] = 5, this.widths[e.DOUBLE] = 5, this.widths[e.END] = 5, this.widths[e.REPEAT_BEGIN] = 5, this.widths[e.REPEAT_END] = 5, this.widths[e.REPEAT_BOTH] = 5, this.widths[e.NONE] = 5, this.paddings = {}, this.paddings[e.SINGLE] = 0, this.paddings[e.DOUBLE] = 0, this.paddings[e.END] = 0, this.paddings[e.REPEAT_BEGIN] = 15, this.paddings[e.REPEAT_END] = 15, this.paddings[e.REPEAT_BOTH] = 15, this.paddings[e.NONE] = 0, this.layoutMetricsMap = {}, this.layoutMetricsMap[e.SINGLE] = {
                    xMin: 0,
                    xMax: 1,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.DOUBLE] = {
                    xMin: -3,
                    xMax: 1,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.END] = {
                    xMin: -5,
                    xMax: 1,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.REPEAT_END] = {
                    xMin: -10,
                    xMax: 1,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.REPEAT_BEGIN] = {
                    xMin: -2,
                    xMax: 10,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.REPEAT_BOTH] = {
                    xMin: -10,
                    xMax: 10,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.NONE] = {
                    xMin: 0,
                    xMax: 0,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.setPosition(wt.BEGIN), this.setType(t);
            }
            getType() {
                return this.type;
            }
            setType(t) {
                return this.type = "string" == typeof t ? kt.typeString[t] : t, this.setWidth(this.widths[this.type]), this.setPadding(this.paddings[this.type]), this.setLayoutMetrics(this.layoutMetricsMap[this.type]), this;
            }
            draw(t) {
                const e = t.checkContext();
                switch(this.setRendered(), this.applyStyle(e), e.openGroup("stavebarline", this.getAttribute("id")), this.type){
                    case zt.SINGLE:
                        this.drawVerticalBar(t, this.x, !1);
                        break;
                    case zt.DOUBLE:
                        this.drawVerticalBar(t, this.x, !0);
                        break;
                    case zt.END:
                        this.drawVerticalEndBar(t, this.x);
                        break;
                    case zt.REPEAT_BEGIN:
                        this.drawRepeatBar(t, this.x, !0), t.getX() !== this.x && this.drawVerticalBar(t, t.getX());
                        break;
                    case zt.REPEAT_END:
                        this.drawRepeatBar(t, this.x, !1);
                        break;
                    case zt.REPEAT_BOTH:
                        this.drawRepeatBar(t, this.x, !1), this.drawRepeatBar(t, this.x, !0);
                }
                e.closeGroup(), this.restoreStyle(e);
            }
            drawVerticalBar(t, e, i) {
                const b = t.checkContext(), a = t.getTopLineTopY(), n = t.getBottomLineBottomY();
                i && b.fillRect(e - 3, a, 1, n - a), b.fillRect(e, a, 1, n - a);
            }
            drawVerticalEndBar(t, e) {
                const i = t.checkContext(), b = t.getTopLineTopY(), a = t.getBottomLineBottomY();
                i.fillRect(e - 5, b, 1, a - b), i.fillRect(e - 2, b, 3, a - b);
            }
            drawRepeatBar(t, e, i) {
                const b = t.checkContext(), a = t.getTopLineTopY(), n = t.getBottomLineBottomY();
                let s = 3;
                i || (s = -5), b.fillRect(e + s, a, 1, n - a), b.fillRect(e - 2, a, 3, n - a);
                i ? s += 4 : s -= 4;
                const l = e + s + 1;
                let o = (t.getNumLines() - 1) * t.getSpacingBetweenLines();
                o = o / 2 - t.getSpacingBetweenLines() / 2;
                let r = a + o + 1;
                b.beginPath(), b.arc(l, r, 2, 0, 2 * Math.PI, !1), b.fill(), r += t.getSpacingBetweenLines(), b.beginPath(), b.arc(l, r, 2, 0, 2 * Math.PI, !1), b.fill();
            }
        }
        class At extends vt {
            static get CATEGORY() {
                return x.BarNote;
            }
            constructor(t = zt.SINGLE){
                super({
                    duration: "b"
                }), this.metrics = {
                    widths: {}
                };
                const e = zt;
                this.metrics.widths = {
                    [e.SINGLE]: 8,
                    [e.DOUBLE]: 12,
                    [e.END]: 15,
                    [e.REPEAT_BEGIN]: 14,
                    [e.REPEAT_END]: 14,
                    [e.REPEAT_BOTH]: 18,
                    [e.NONE]: 0
                }, this.ignore_ticks = !0, this.setType(t), this.barline = new kt(t);
            }
            getType() {
                return this.type;
            }
            setType(t) {
                return this.type = "string" == typeof t ? kt.typeString[t] : t, this.setWidth(this.metrics.widths[this.type]), this;
            }
            addToModifierContext(t) {
                return this;
            }
            preFormat() {
                return this.preFormatted = !0, this;
            }
            draw() {
                const t = this.checkContext();
                !function(...t) {
                    At.DEBUG && u("Vex.Flow.BarNote", t);
                }("Rendering bar line at: ", this.getAbsoluteX()), this.applyStyle(t), t.openGroup("barnote", this.getAttribute("id")), this.barline.setType(this.type), this.barline.setX(this.getAbsoluteX()), this.barline.draw(this.checkStave()), t.closeGroup(), this.restoreStyle(t), this.setRendered();
            }
        }
        At.DEBUG = !1;
        class Nt extends tt {
            static get CATEGORY() {
                return x.Bend;
            }
            static get UP() {
                return 0;
            }
            static get DOWN() {
                return 1;
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0;
                for(let b = 0; b < t.length; ++b){
                    const a = t[b], n = a.checkAttachedNote();
                    if (_(n)) {
                        const t = n.leastString() - 1;
                        e.top_text_line < t && (e.top_text_line = t);
                    }
                    a.setXShift(i), i = a.getWidth(), a.setTextLine(e.top_text_line);
                }
                return e.right_shift += i, e.top_text_line += 1, !0;
            }
            constructor(t, e = !1, i){
                super(), this.text = t, this.x_shift = 0, this.release = e, this.tap = "", this.resetFont(), this.render_options = {
                    line_width: 1.5,
                    line_style: "#777777",
                    bend_width: 8,
                    release_width: 8
                }, i ? this.phrase = i : (this.phrase = [
                    {
                        type: Nt.UP,
                        text: this.text
                    }
                ], this.release && this.phrase.push({
                    type: Nt.DOWN,
                    text: ""
                })), this.updateWidth();
            }
            setXShift(t) {
                return this.x_shift = t, this.updateWidth(), this;
            }
            setTap(t) {
                return this.tap = t, this;
            }
            getText() {
                return this.text;
            }
            getTextHeight() {
                return rt.create(this.textFont).maxHeight;
            }
            updateWidth() {
                const t = rt.create(this.textFont);
                let e = 0;
                for(let b = 0; b < this.phrase.length; ++b){
                    const a = this.phrase[b];
                    if (void 0 !== a.width) e += a.width;
                    else {
                        const b = a.type === Nt.UP ? this.render_options.bend_width : this.render_options.release_width;
                        a.width = Math.max(b, (i = a.text, t.getWidthForTextInPx(i))) + 3, a.draw_width = a.width / 2, e += a.width;
                    }
                }
                var i;
                return this.setWidth(e + this.x_shift), this;
            }
            draw() {
                var t;
                const e = this.checkContext(), i = this.checkAttachedNote();
                this.setRendered();
                const b = i.getModifierStartXY(tt.Position.RIGHT, this.index);
                b.x += 3, b.y += .5;
                const a = this.x_shift, n = i.checkStave().getSpacingBetweenLines(), s = i.getYs().reduce((t, e)=>t < e ? t : e), l = b.y - ((this.text_line + 1) * n + b.y - s) + 3, o = b.y - ((this.text_line + 1) * n + b.y - s) - 1, r = (t, i, b, a)=>{
                    const n = t + b, s = i;
                    e.save(), e.beginPath(), e.setLineWidth(this.render_options.line_width), e.setStrokeStyle(this.render_options.line_style), e.setFillStyle(this.render_options.line_style), e.moveTo(t, i), e.quadraticCurveTo(n, s, t + b, a), e.stroke(), e.restore();
                }, h = (t, i, b, a)=>{
                    e.save(), e.beginPath(), e.setLineWidth(this.render_options.line_width), e.setStrokeStyle(this.render_options.line_style), e.setFillStyle(this.render_options.line_style), e.moveTo(t, a), e.quadraticCurveTo(t + b, a, t + b, i), e.stroke(), e.restore();
                }, m = (t, i, b)=>{
                    const a = i + 4 * b;
                    e.beginPath(), e.moveTo(t, i), e.lineTo(t - 4, a), e.lineTo(t + 4, a), e.closePath(), e.fill();
                }, c = (t, i)=>{
                    e.save(), e.setFont(this.textFont);
                    const b = t - e.measureText(i).width / 2;
                    e.fillText(i, b, o), e.restore();
                };
                let d, _ = 0, x = 0;
                if (null === (t = this.tap) || void 0 === t ? void 0 : t.length) c(i.getModifierStartXY(tt.Position.CENTER, this.index).x, this.tap);
                for(let t = 0; t < this.phrase.length; ++t){
                    const e = this.phrase[t];
                    e.draw_width || (e.draw_width = 0), 0 === t && (e.draw_width += a), x = e.draw_width + _ - (1 === t ? a : 0), e.type === Nt.UP && (d && d.type === Nt.UP && m(b.x, l, 1), r(b.x, b.y, x, l)), e.type === Nt.DOWN && (d && d.type === Nt.UP && h(b.x, b.y, x, l), d && d.type === Nt.DOWN && (m(b.x, b.y, -1), h(b.x, b.y, x, l)), d || (x = e.draw_width, h(b.x, b.y, x, l))), c(b.x + x, e.text), d = e, _ = e.draw_width, d.x = b.x, b.x += x;
                }
                if (!d || null == d.x) throw new g("NoLastBendForBend", "Internal error.");
                d.type === Nt.UP ? m(d.x + x, l, 1) : d.type === Nt.DOWN && m(d.x + x, b.y, -1);
            }
        }
        function Ft(...t) {
            Mt.DEBUG && u("Vex.Flow.ChordSymbol", t);
        }
        Nt.TEXT_FONT = Object.assign({}, R.TEXT_FONT), function(t) {
            t[t.LEFT = 1] = "LEFT", t[t.CENTER = 2] = "CENTER", t[t.RIGHT = 3] = "RIGHT", t[t.CENTER_STEM = 4] = "CENTER_STEM";
        }(Bt || (Bt = {})), function(t) {
            t[t.TOP = 1] = "TOP", t[t.BOTTOM = 2] = "BOTTOM";
        }(Dt || (Dt = {})), function(t) {
            t[t.GLYPH = 1] = "GLYPH", t[t.TEXT = 2] = "TEXT", t[t.LINE = 3] = "LINE";
        }(Ct || (Ct = {})), function(t) {
            t[t.NONE = 1] = "NONE", t[t.SUBSCRIPT = 2] = "SUBSCRIPT", t[t.SUPERSCRIPT = 3] = "SUPERSCRIPT";
        }(Et || (Et = {}));
        class Mt extends tt {
            static get CATEGORY() {
                return x.ChordSymbol;
            }
            static get superSubRatio() {
                return Mt.metrics.global.superSubRatio;
            }
            static set NO_TEXT_FORMAT(t) {
                Mt.noFormat = t;
            }
            static get NO_TEXT_FORMAT() {
                return Mt.noFormat;
            }
            static getMetricForGlyph(t) {
                if (Mt.metrics.glyphs[t]) return Mt.metrics.glyphs[t];
            }
            static get engravingFontResolution() {
                return V.currentMusicFont().getResolution();
            }
            static get spacingBetweenBlocks() {
                return Mt.metrics.global.spacing / Mt.engravingFontResolution;
            }
            static getWidthForGlyph(t) {
                const e = Mt.getMetricForGlyph(t.code);
                return e ? e.advanceWidth / Mt.engravingFontResolution : .65;
            }
            static getYShiftForGlyph(t) {
                const e = Mt.getMetricForGlyph(t.code);
                return e ? e.yOffset / Mt.engravingFontResolution : 0;
            }
            static getXShiftForGlyph(t) {
                const e = Mt.getMetricForGlyph(t.code);
                return e ? -1 * e.leftSideBearing / Mt.engravingFontResolution : 0;
            }
            static get superscriptOffset() {
                return Mt.metrics.global.superscriptOffset / Mt.engravingFontResolution;
            }
            static get subscriptOffset() {
                return Mt.metrics.global.subscriptOffset / Mt.engravingFontResolution;
            }
            static get kerningOffset() {
                return Mt.metrics.global.kerningOffset / Mt.engravingFontResolution;
            }
            static get metrics() {
                const t = V.currentMusicFont().getMetrics().chordSymbol;
                if (!t) throw new g("BadMetrics", "chordSymbol missing");
                return t;
            }
            static get lowerKerningText() {
                return Mt.metrics.global.lowerKerningText;
            }
            static get upperKerningText() {
                return Mt.metrics.global.upperKerningText;
            }
            static isSuperscript(t) {
                return void 0 !== t.symbolModifier && t.symbolModifier === Et.SUPERSCRIPT;
            }
            static isSubscript(t) {
                return void 0 !== t.symbolModifier && t.symbolModifier === Et.SUBSCRIPT;
            }
            static get minPadding() {
                return V.currentMusicFont().lookupMetric("noteHead.minPadding");
            }
            static format(t, e) {
                var i;
                if (!t || 0 === t.length) return !1;
                let b = 0, a = 0, n = 0, s = 0, l = 0, o = 0;
                for (const r of t){
                    const t = F.convertSizeToPointValue(null === (i = r.textFont) || void 0 === i ? void 0 : i.size), h = F.scaleSize(t, .05), m = 2 * h, c = r.checkAttachedNote();
                    let _ = 0, x = 1, g = !1;
                    for(let t = 0; t < r.symbolBlocks.length; ++t){
                        const e = r.symbolBlocks[t], i = Mt.isSuperscript(e), n = Mt.isSubscript(e), s = i || n ? Mt.superSubRatio : 1, l = e.symbolType === Ct.GLYPH ? m * s : h * s;
                        (i || n) && (x = 2);
                        const o = r.textFormatter.fontSizeInPixels, c = o * s;
                        if (e.symbolType === Ct.GLYPH && void 0 !== e.glyph ? (e.width = Mt.getWidthForGlyph(e.glyph) * c, e.yShift += Mt.getYShiftForGlyph(e.glyph) * c, e.xShift += Mt.getXShiftForGlyph(e.glyph) * c, e.glyph.scale = e.glyph.scale * l) : e.symbolType === Ct.TEXT && (e.width = e.width * c, e.yShift += r.getYOffsetForText(e.text) * l), e.symbolType === Ct.GLYPH && void 0 !== e.glyph && e.glyph.code === Mt.glyphs.over.code && (x = 2), e.width += Mt.spacingBetweenBlocks * o * s, i && t > 0) {
                            const e = r.symbolBlocks[t - 1];
                            Mt.isSuperscript(e) || (a = b);
                        }
                        n && a > 0 && (g = !0, e.xShift = e.xShift + (a - b), b = a, a = 0, r.setEnableKerning(!1)), i || n || (a = 0), e.vAlign = g, b += e.width, _ = b;
                    }
                    if (r.updateKerningAdjustments(), r.updateOverBarAdjustments(), r.getVertical() === Dt.TOP ? (r.setTextLine(e.top_text_line), e.top_text_line += x) : (r.setTextLine(e.text_line + 1), e.text_line += x + 1), r.getReportWidth() && d(c)) {
                        const t = c.getGlyphProps().getWidth();
                        r.getHorizontal() === Bt.LEFT ? (l = Math.max(t, l), n = Math.max(n, _) + Mt.minPadding) : r.getHorizontal() === Bt.RIGHT ? (o = Math.max(t, o), s = Math.max(s, _)) : (n = Math.max(n, _ / 2) + Mt.minPadding, s = Math.max(s, _ / 2), l = Math.max(t / 2, l), o = Math.max(t / 2, o));
                    }
                    b = 0;
                }
                const r = Math.min(Math.max(s - o, 0), Math.max(s - e.right_shift, 0)), h = Math.min(Math.max(n - l, 0), Math.max(n - e.left_shift, 0));
                return e.left_shift += h, e.right_shift += r, !0;
            }
            constructor(){
                super(), this.symbolBlocks = [], this.horizontal = Bt.LEFT, this.vertical = Dt.TOP, this.useKerning = !0, this.reportWidth = !0, this.resetFont();
            }
            static get TEXT_FONT() {
                let t = "Roboto Slab, Times, serif";
                return "Petaluma" === V.currentMusicFont().getName() && (t = "PetalumaScript, Arial, sans-serif"), {
                    family: t,
                    size: 12,
                    weight: E.NORMAL,
                    style: P.NORMAL
                };
            }
            get superscriptOffset() {
                return Mt.superscriptOffset * this.textFormatter.fontSizeInPixels;
            }
            get subscriptOffset() {
                return Mt.subscriptOffset * this.textFormatter.fontSizeInPixels;
            }
            setReportWidth(t) {
                return this.reportWidth = t, this;
            }
            getReportWidth() {
                return this.reportWidth;
            }
            updateOverBarAdjustments() {
                const t = this.symbolBlocks.findIndex(({ symbolType: t, glyph: e })=>t === Ct.GLYPH && void 0 !== e && "csymDiagonalArrangementSlash" === e.code);
                if (t < 0) return;
                const e = this.symbolBlocks[t].width / 4, i = .25 * this.textFormatter.fontSizeInPixels;
                let b = 0;
                for(; b < t; ++b){
                    const t = this.symbolBlocks[b];
                    t.xShift = t.xShift + e, t.yShift = t.yShift - i;
                }
                for(b = t + 1; b < this.symbolBlocks.length; ++b){
                    const t = this.symbolBlocks[b];
                    t.xShift = t.xShift - e, t.yShift = t.yShift + i;
                }
            }
            updateKerningAdjustments() {
                let t = 0;
                for(let e = 0; e < this.symbolBlocks.length; ++e){
                    const i = this.symbolBlocks[e];
                    t += this.getKerningAdjustment(e), i.xShift += t;
                }
            }
            getKerningAdjustment(t) {
                if (!this.useKerning) return 0;
                const e = this.symbolBlocks[t], i = t > 0 ? this.symbolBlocks[t - 1] : void 0;
                let b = 0;
                e.symbolType === Ct.GLYPH && void 0 !== e.glyph && e.glyph.code === Mt.glyphs.over.code && (b += e.glyph.metrics.x_shift), void 0 !== i && i.symbolType === Ct.GLYPH && void 0 !== i.glyph && i.glyph.code === Mt.glyphs.over.code && (b += i.glyph.metrics.x_shift);
                let a = !1, n = !1;
                void 0 !== i && i.symbolType === Ct.TEXT && (a = Mt.upperKerningText.some((t)=>t === i.text[i.text.length - 1]), n = Mt.lowerKerningText.some((t)=>t === i.text[i.text.length - 1]));
                const s = Mt.kerningOffset * this.textFormatter.fontSizeInPixels;
                return a && e.symbolModifier === Et.SUPERSCRIPT && (b += s), n && e.symbolType === Ct.TEXT && (e.text[0] >= "a" && e.text[0] <= "z" && (b += s / 2), Mt.upperKerningText.some((t)=>t === (null == i ? void 0 : i.text[i.text.length - 1])) && (b += s / 2)), b;
            }
            getSymbolBlock(t = {}) {
                var e, i, b;
                const a = null !== (e = t.symbolType) && void 0 !== e ? e : Ct.TEXT, n = {
                    text: null !== (i = t.text) && void 0 !== i ? i : "",
                    symbolType: a,
                    symbolModifier: null !== (b = t.symbolModifier) && void 0 !== b ? b : Et.NONE,
                    xShift: 0,
                    yShift: 0,
                    vAlign: !1,
                    width: 0
                };
                if (a === Ct.GLYPH && "string" == typeof t.glyph) {
                    const e = Mt.glyphs[t.glyph], i = 20;
                    n.glyph = new Z(e.code, i, {
                        category: "chordSymbol"
                    });
                } else a === Ct.TEXT ? n.width = this.textFormatter.getWidthForTextInEm(n.text) : a === Ct.LINE && (n.width = t.width);
                return n;
            }
            addSymbolBlock(t) {
                return this.symbolBlocks.push(this.getSymbolBlock(t)), this;
            }
            addText(t, e = {}) {
                const i = Ct.TEXT;
                return this.addSymbolBlock(Object.assign(Object.assign({}, e), {
                    text: t,
                    symbolType: i
                }));
            }
            addTextSuperscript(t) {
                const e = Ct.TEXT, i = Et.SUPERSCRIPT;
                return this.addSymbolBlock({
                    text: t,
                    symbolType: e,
                    symbolModifier: i
                });
            }
            addTextSubscript(t) {
                const e = Ct.TEXT, i = Et.SUBSCRIPT;
                return this.addSymbolBlock({
                    text: t,
                    symbolType: e,
                    symbolModifier: i
                });
            }
            addGlyphSuperscript(t) {
                const e = Ct.GLYPH, i = Et.SUPERSCRIPT;
                return this.addSymbolBlock({
                    glyph: t,
                    symbolType: e,
                    symbolModifier: i
                });
            }
            addGlyph(t, e = {}) {
                const i = Ct.GLYPH;
                return this.addSymbolBlock(Object.assign(Object.assign({}, e), {
                    glyph: t,
                    symbolType: i
                }));
            }
            addGlyphOrText(t, e = {}) {
                let i = "";
                for(let b = 0; b < t.length; ++b){
                    const a = t[b];
                    Mt.glyphs[a] ? (i.length > 0 && (this.addText(i, e), i = ""), this.addGlyph(a, e)) : i += a;
                }
                return i.length > 0 && this.addText(i, e), this;
            }
            addLine(t, e = {}) {
                const i = Ct.LINE;
                return this.addSymbolBlock(Object.assign(Object.assign({}, e), {
                    symbolType: i,
                    width: t
                }));
            }
            setFont(t, e, i, b) {
                return super.setFont(t, e, i, b), this.textFormatter = rt.create(this.textFont), this;
            }
            setEnableKerning(t) {
                return this.useKerning = t, this;
            }
            setVertical(t) {
                return this.vertical = "string" == typeof t ? Mt.VerticalJustifyString[t] : t, this;
            }
            getVertical() {
                return this.vertical;
            }
            setHorizontal(t) {
                return this.horizontal = "string" == typeof t ? Mt.HorizontalJustifyString[t] : t, this;
            }
            getHorizontal() {
                return this.horizontal;
            }
            getWidth() {
                let t = 0;
                return this.symbolBlocks.forEach((e)=>{
                    t += e.vAlign ? 0 : e.width;
                }), t;
            }
            getYOffsetForText(t) {
                var e;
                let i = 0, b = 0;
                for(b = 0; b < t.length; ++b){
                    const a = this.textFormatter.getGlyphMetrics(t[b]);
                    if (a) {
                        const t = null !== (e = a.y_max) && void 0 !== e ? e : 0;
                        i = t < i ? t : i;
                    }
                }
                const a = this.textFormatter.getResolution();
                return b > 0 ? i / a * -1 : 0;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered(), t.save(), this.applyStyle(), t.openGroup("chordsymbol", this.getAttribute("id"));
                const i = e.getModifierStartXY(tt.Position.ABOVE, this.index);
                let b;
                t.setFont(this.textFont);
                const a = e.hasStem(), n = e.checkStave();
                if (this.vertical === Dt.BOTTOM) {
                    if (b = n.getYForBottomText(this.text_line + V.TEXT_HEIGHT_OFFSET_HACK), a) {
                        const t = e.checkStem().getExtents(), i = n.getSpacingBetweenLines(), a = 1 === e.getStemDirection() ? t.baseY : t.topY;
                        b = Math.max(b, a + i * (this.text_line + 2));
                    }
                } else {
                    const t = Math.min(...e.getYs());
                    if (b = Math.min(n.getYForTopText(this.text_line), t - 10), a) {
                        const t = e.checkStem().getExtents(), i = n.getSpacingBetweenLines();
                        b = Math.min(b, t.topY - 5 - i * this.text_line);
                    }
                }
                let s = i.x;
                s = this.horizontal === Bt.LEFT ? i.x : this.horizontal === Bt.RIGHT ? i.x + this.getWidth() : this.horizontal === Bt.CENTER ? i.x - this.getWidth() / 2 : e.getStemX() - this.getWidth() / 2, Ft("Rendering ChordSymbol: ", this.textFormatter, s, b), this.symbolBlocks.forEach((e)=>{
                    const i = Mt.isSuperscript(e), a = Mt.isSubscript(e);
                    let n = b;
                    if (Ft("shift was ", e.xShift, e.yShift), Ft("curY pre sub ", n), i && (n += this.superscriptOffset), a && (n += this.subscriptOffset), Ft("curY sup/sub ", n), e.symbolType === Ct.TEXT) {
                        if ((i || a) && (t.save(), this.textFont)) {
                            const { family: e, size: i, weight: b, style: a } = this.textFont, n = F.scaleSize(i, Mt.superSubRatio);
                            t.setFont(e, n, b, a);
                        }
                        Ft("Rendering Text: ", e.text, s + e.xShift, n + e.yShift), t.fillText(e.text, s + e.xShift, n + e.yShift), (i || a) && t.restore();
                    } else e.symbolType === Ct.GLYPH && e.glyph ? (n += e.yShift, Ft("Rendering Glyph: ", e.glyph.code, s + e.xShift, n), e.glyph.render(t, s + e.xShift, n)) : e.symbolType === Ct.LINE && (Ft("Rendering Line : ", e.width, s, n), t.beginPath(), t.setLineWidth(1), t.moveTo(s, b), t.lineTo(s + e.width, n), t.stroke());
                    s += e.width, e.vAlign && (s += e.xShift);
                }), t.closeGroup(), this.restoreStyle(), t.restore();
            }
        }
        Mt.DEBUG = !1, Mt.HorizontalJustify = Bt, Mt.HorizontalJustifyString = {
            left: Bt.LEFT,
            right: Bt.RIGHT,
            center: Bt.CENTER,
            centerStem: Bt.CENTER_STEM
        }, Mt.VerticalJustify = Dt, Mt.VerticalJustifyString = {
            top: Dt.TOP,
            above: Dt.TOP,
            below: Dt.BOTTOM,
            bottom: Dt.BOTTOM
        }, Mt.glyphs = {
            diminished: {
                code: "csymDiminished"
            },
            dim: {
                code: "csymDiminished"
            },
            halfDiminished: {
                code: "csymHalfDiminished"
            },
            "+": {
                code: "csymAugmented"
            },
            augmented: {
                code: "csymAugmented"
            },
            majorSeventh: {
                code: "csymMajorSeventh"
            },
            minor: {
                code: "csymMinor"
            },
            "-": {
                code: "csymMinor"
            },
            "(": {
                code: "csymParensLeftTall"
            },
            leftParen: {
                code: "csymParensLeftTall"
            },
            ")": {
                code: "csymParensRightTall"
            },
            rightParen: {
                code: "csymParensRightTall"
            },
            leftBracket: {
                code: "csymBracketLeftTall"
            },
            rightBracket: {
                code: "csymBracketRightTall"
            },
            leftParenTall: {
                code: "csymParensLeftVeryTall"
            },
            rightParenTall: {
                code: "csymParensRightVeryTall"
            },
            "/": {
                code: "csymDiagonalArrangementSlash"
            },
            over: {
                code: "csymDiagonalArrangementSlash"
            },
            "#": {
                code: "accidentalSharp"
            },
            b: {
                code: "accidentalFlat"
            }
        }, Mt.symbolTypes = Ct, Mt.symbolModifiers = Et, Mt.noFormat = !1;
        class Ot extends tt {
            static get CATEGORY() {
                return x.Dot;
            }
            static getDots(t) {
                return t.getModifiersByType(Ot.CATEGORY);
            }
            static buildAndAttach(t, e) {
                for (const i of t)if (null == e ? void 0 : e.all) for(let t = 0; t < i.keys.length; t++){
                    const e = new Ot;
                    e.setDotShiftY(i.glyphProps.dot_shiftY), i.addModifier(e, t);
                }
                else if (null != (null == e ? void 0 : e.index)) {
                    const t = new Ot;
                    t.setDotShiftY(i.glyphProps.dot_shiftY), i.addModifier(t, null == e ? void 0 : e.index);
                } else {
                    const t = new Ot;
                    t.setDotShiftY(i.glyphProps.dot_shiftY), i.addModifier(t, 0);
                }
            }
            static format(t, e) {
                const i = e.right_shift;
                if (!t || 0 === t.length) return !1;
                const b = [], a = {};
                for(let e = 0; e < t.length; ++e){
                    const n = t[e], s = n.getNote();
                    let l, o;
                    if (c(s)) {
                        const t = n.checkIndex();
                        l = s.getKeyProps()[t], o = s.getFirstDotPx();
                    } else {
                        if (!_(s)) throw new g("Internal", "Unexpected instance.");
                        l = {
                            line: .5
                        }, o = i;
                    }
                    const r = s.getAttribute("id");
                    b.push({
                        line: l.line,
                        note: s,
                        note_id: r,
                        dot: n
                    }), a[r] = Math.max(a[r] || o, o);
                }
                b.sort((t, e)=>e.line - t.line);
                let n = i, s = 0, l = null, o = null, r = null, h = 0;
                for(let t = 0; t < b.length; ++t){
                    const { dot: e, note: i, note_id: m, line: c } = b[t];
                    c === l && i === o || (n = a[m]), i.isRest() || c === l || (.5 === Math.abs(c % 1) ? h = 0 : (h = .5, null == o || o.isRest() || null == l || l - c != .5 ? c + h === r && (h = -0.5) : h = -0.5)), i.isRest() ? e.dot_shiftY += -h : e.dot_shiftY = -h, r = c + h, e.setXShift(n), n += e.getWidth() + 1, s = n > s ? n : s, l = c, o = i;
                }
                return e.right_shift += s, !0;
            }
            constructor(){
                super(), this.position = tt.Position.RIGHT, this.radius = 2, this.setWidth(5), this.dot_shiftY = 0;
            }
            setNote(t) {
                return this.note = t, o(t) && (this.radius *= .5, this.setWidth(3)), this;
            }
            setDotShiftY(t) {
                return this.dot_shiftY = t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.checkStave().getSpacingBetweenLines(), b = e.getModifierStartXY(this.position, this.index, {
                    forceFlagRight: !0
                });
                _(e) && (b.y = e.getStemExtents().baseY);
                const a = b.x + this.x_shift + this.width - this.radius, n = b.y + this.y_shift + this.dot_shiftY * i;
                t.beginPath(), t.arc(a, n, this.radius, 0, 2 * Math.PI, !1), t.fill();
            }
        }
        class Rt extends tt {
            static get CATEGORY() {
                return x.FretHandFinger;
            }
            static format(t, e) {
                const { left_shift: i, right_shift: b } = e;
                if (!t || 0 === t.length) return !1;
                const a = [];
                let n = null, s = 0, l = 0;
                for(let o = 0; o < t.length; ++o){
                    const r = t[o], h = r.getNote(), m = r.getPosition(), c = r.checkIndex(), d = h.getKeyProps()[c], _ = rt.create(r.textFont).maxHeight;
                    if (r.position === J.ABOVE && (e.top_text_line += _ / V.STAVE_LINE_DISTANCE + .5), r.position === J.BELOW && (e.text_line += _ / V.STAVE_LINE_DISTANCE + .5), h !== n) {
                        for(let t = 0; t < h.keys.length; ++t)0 === i && (s = Math.max(h.getLeftDisplacedHeadPx(), s)), 0 === b && (l = Math.max(h.getRightDisplacedHeadPx(), l));
                        n = h;
                    }
                    a.push({
                        note: h,
                        num: r,
                        pos: m,
                        line: d.line,
                        shiftL: s,
                        shiftR: l
                    });
                }
                a.sort((t, e)=>e.line - t.line);
                let o = 0, r = 0, h = 0, m = 0, c = null, d = null;
                for(let t = 0; t < a.length; ++t){
                    let e = 0;
                    const { note: n, pos: s, num: _, line: x, shiftL: g, shiftR: y } = a[t];
                    x === c && n === d || (o = i + g, r = b + y);
                    const p = _.getWidth() + 1;
                    s === tt.Position.LEFT ? (_.setXShift(i + o), e = i + p, h = e > h ? e : h) : s === tt.Position.RIGHT && (_.setXShift(r), e = l + p, m = e > m ? e : m), c = x, d = n;
                }
                return e.left_shift += h, e.right_shift += m, !0;
            }
            static easyScoreHook({ fingerings: t } = {}, e, i) {
                null == t || t.split(",").map((t)=>{
                    const e = t.trim().split("."), b = {
                        number: e[0]
                    };
                    return e[1] && (b.position = e[1]), i.getFactory().Fingering(b);
                }).map((t, i)=>e.addModifier(t, i));
            }
            constructor(t){
                super(), this.finger = t, this.width = 7, this.position = tt.Position.LEFT, this.x_shift = 0, this.y_shift = 0, this.x_offset = 0, this.y_offset = 0, this.resetFont();
            }
            setFretHandFinger(t) {
                return this.finger = t, this;
            }
            getFretHandFinger() {
                return this.finger;
            }
            setOffsetX(t) {
                return this.x_offset = t, this;
            }
            setOffsetY(t) {
                return this.y_offset = t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getModifierStartXY(this.position, this.index);
                let b = i.x + this.x_shift + this.x_offset, a = i.y + this.y_shift + this.y_offset + 5;
                switch(this.position){
                    case tt.Position.ABOVE:
                        b -= 4, a -= 12;
                        break;
                    case tt.Position.BELOW:
                        b -= 2, a += 10;
                        break;
                    case tt.Position.LEFT:
                        b -= this.width;
                        break;
                    case tt.Position.RIGHT:
                        b += 1;
                        break;
                    default:
                        throw new g("InvalidPosition", `The position ${this.position} does not exist`);
                }
                t.save(), t.setFont(this.textFont), t.fillText("" + this.finger, b, a), t.restore();
            }
        }
        Rt.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: 9,
            weight: E.BOLD,
            style: P.NORMAL
        };
        class Lt extends vt {
            static get CATEGORY() {
                return x.NoteHead;
            }
            constructor(t){
                super(t), this.custom_glyph = !1, this.stem_up_x_offset = 0, this.stem_down_x_offset = 0, this.index = t.index, this.x = t.x || 0, this.y = t.y || 0, t.note_type && (this.noteType = t.note_type), this.displaced = t.displaced || !1, this.stem_direction = t.stem_direction || at.UP, this.line = t.line || 0, this.glyphProps = V.getGlyphProps(this.duration, this.noteType), p(this.glyphProps, "BadArguments", `No glyph found for duration '${this.duration}' and type '${this.noteType}'`), (this.line > 5 || this.line < 0) && this.glyphProps.ledger_code_head && (this.glyphProps.code_head = this.glyphProps.ledger_code_head), this.glyph_code = this.glyphProps.code_head, this.x_shift = t.x_shift || 0, t.custom_glyph_code && (this.custom_glyph = !0, this.glyph_code = t.custom_glyph_code, this.stem_up_x_offset = t.stem_up_x_offset || 0, this.stem_down_x_offset = t.stem_down_x_offset || 0), this.setStyle(t.style), this.slashed = t.slashed || !1, this.render_options = Object.assign(Object.assign({}, this.render_options), {
                    glyph_font_scale: t.glyph_font_scale || V.NOTATION_FONT_SCALE
                }), this.setWidth(!this.custom_glyph || this.glyph_code.startsWith("noteheadSlashed") || this.glyph_code.startsWith("noteheadCircled") ? this.glyphProps.getWidth(this.render_options.glyph_font_scale) : Z.getWidth(this.glyph_code, this.render_options.glyph_font_scale));
            }
            getWidth() {
                return this.width;
            }
            isDisplaced() {
                return !0 === this.displaced;
            }
            setX(t) {
                return this.x = t, this;
            }
            getY() {
                return this.y;
            }
            setY(t) {
                return this.y = t, this;
            }
            getLine() {
                return this.line;
            }
            setLine(t) {
                return this.line = t, this;
            }
            getAbsoluteX() {
                const t = this.preFormatted ? super.getAbsoluteX() : this.x, e = at.WIDTH / 2, i = V.currentMusicFont(), b = i.lookupMetric("notehead.shiftX", 0) * this.stem_direction, a = i.lookupMetric("noteHead.displacedShiftX", 0) * this.stem_direction;
                return t + b + (this.displaced ? (this.width - e) * this.stem_direction + a : 0);
            }
            getBoundingBox() {
                const t = this.checkStave().getSpacingBetweenLines(), e = t / 2, i = this.y - e;
                return new D(this.getAbsoluteX(), i, this.width, t);
            }
            setStave(t) {
                const e = this.getLine();
                return this.stave = t, this.stave && (this.setY(this.stave.getYForNote(e)), this.setContext(this.stave.getContext())), this;
            }
            preFormat() {
                if (this.preFormatted) return this;
                const t = this.getWidth() + this.leftDisplacedHeadPx + this.rightDisplacedHeadPx;
                return this.setWidth(t), this.preFormatted = !0, this;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                let e = this.getAbsoluteX();
                this.custom_glyph && (e += this.stem_direction === at.UP ? this.stem_up_x_offset + (this.glyphProps.stem ? this.glyphProps.getWidth(this.render_options.glyph_font_scale) - this.width : 0) : this.stem_down_x_offset);
                const i = this.y;
                !function(...t) {
                    Lt.DEBUG && u("Vex.Flow.NoteHead", t);
                }("Drawing note head '", this.noteType, this.duration, "' at", e, i);
                const b = this.stem_direction, a = this.render_options.glyph_font_scale, n = `${this.glyph_code}Stem${b === at.UP ? "Up" : "Down"}`;
                if ("s" === this.noteType) {
                    const a = this.checkStave().getSpacingBetweenLines();
                    !function(t, e, i, b, a, n) {
                        const s = V.SLASH_NOTEHEAD_WIDTH;
                        t.save(), t.setLineWidth(V.STEM_WIDTH);
                        let l = !1;
                        if (V.durationToNumber(e) > 2 && (l = !0), l || (i -= V.STEM_WIDTH / 2 * a), t.beginPath(), t.moveTo(i, b + n), t.lineTo(i, b + 1), t.lineTo(i + s, b - n), t.lineTo(i + s, b), t.lineTo(i, b + n), t.closePath(), l ? t.fill() : t.stroke(), V.durationToFraction(e).equals(.5)) {
                            const e = [
                                -3,
                                -1,
                                s + 1,
                                s + 3
                            ];
                            for(let a = 0; a < e.length; a++)t.beginPath(), t.moveTo(i + e[a], b - 10), t.lineTo(i + e[a], b + 11), t.stroke();
                        }
                        t.restore();
                    }(t, this.duration, e, i, b, a);
                } else Z.renderGlyph(t, e, i, a, this.glyph_code, {
                    category: `noteHead.${n}`
                });
            }
        }
        Lt.DEBUG = !1;
        class Wt extends vt {
            static get CATEGORY() {
                return x.StemmableNote;
            }
            constructor(t){
                super(t);
            }
            getStem() {
                return this.stem;
            }
            checkStem() {
                if (!this.stem) throw new g("NoStem", "No stem attached to instance");
                return this.stem;
            }
            setStem(t) {
                return this.stem = t, this.addChildElement(t), this;
            }
            buildStem() {
                const t = new at;
                return this.setStem(t), this;
            }
            buildFlag(t = "flag") {
                const { glyphProps: e } = this;
                if (this.hasFlag()) {
                    const i = this.getStemDirection() === at.DOWN ? e.code_flag_downstem : e.code_flag_upstem;
                    i && (this.flag = new Z(i, this.render_options.glyph_font_scale, {
                        category: t
                    }));
                }
            }
            getBaseCustomNoteHeadGlyphProps() {
                return this.getStemDirection() === at.DOWN ? this.customGlyphs[this.customGlyphs.length - 1] : this.customGlyphs[0];
            }
            getStemLength() {
                return at.HEIGHT + this.getStemExtension();
            }
            getBeamCount() {
                const t = this.getGlyphProps();
                return t ? t.beam_count : 0;
            }
            getStemMinimumLength() {
                let t = V.durationToFraction(this.duration).value() <= 1 ? 0 : 20;
                switch(this.duration){
                    case "8":
                        null == this.beam && (t = 35);
                        break;
                    case "16":
                        t = null == this.beam ? 35 : 25;
                        break;
                    case "32":
                        t = null == this.beam ? 45 : 35;
                        break;
                    case "64":
                        t = null == this.beam ? 50 : 40;
                        break;
                    case "128":
                        t = null == this.beam ? 55 : 45;
                }
                return t;
            }
            getStemDirection() {
                if (!this.stem_direction) throw new g("NoStem", "No stem attached to this note.");
                return this.stem_direction;
            }
            setStemDirection(t) {
                if (t || (t = at.UP), t !== at.UP && t !== at.DOWN) throw new g("BadArgument", `Invalid stem direction: ${t}`);
                if (this.stem_direction = t, this.reset(), this.hasFlag() && this.buildFlag(), this.beam = void 0, this.stem) {
                    this.stem.setDirection(t), this.stem.setExtension(this.getStemExtension());
                    const e = this.getBaseCustomNoteHeadGlyphProps() || this.getGlyphProps(), i = V.currentMusicFont().lookupMetric(`stem.noteHead.${e.code_head}`, {
                        offsetYBaseStemUp: 0,
                        offsetYTopStemUp: 0,
                        offsetYBaseStemDown: 0,
                        offsetYTopStemDown: 0
                    });
                    this.stem.setOptions({
                        stem_up_y_offset: i.offsetYTopStemUp,
                        stem_down_y_offset: i.offsetYTopStemDown,
                        stem_up_y_base_offset: i.offsetYBaseStemUp,
                        stem_down_y_base_offset: i.offsetYBaseStemDown
                    });
                }
                return this.preFormatted && this.preFormat(), this;
            }
            getStemX() {
                const t = this.getAbsoluteX() + this.x_shift, e = this.getAbsoluteX() + this.x_shift + this.getGlyphWidth();
                return this.stem_direction === at.DOWN ? t : e;
            }
            getCenterGlyphX() {
                return this.getAbsoluteX() + this.x_shift + this.getGlyphWidth() / 2;
            }
            getStemExtension() {
                const t = this.getGlyphProps();
                return null != this.stem_extension_override ? this.stem_extension_override : this.beam ? t.stem_beam_extension : t ? this.getStemDirection() === at.UP ? t.stem_up_extension : t.stem_down_extension : 0;
            }
            setStemLength(t) {
                return this.stem_extension_override = t - at.HEIGHT, this;
            }
            getStemExtents() {
                if (!this.stem) throw new g("NoStem", "No stem attached to this note.");
                return this.stem.getExtents();
            }
            getYForTopText(t) {
                const e = this.checkStave();
                if (this.hasStem()) {
                    const i = this.getStemExtents();
                    if (!i) throw new g("InvalidState", "Stem does not have extents.");
                    return Math.min(e.getYForTopText(t), i.topY - this.render_options.annotation_spacing * (t + 1));
                }
                return e.getYForTopText(t);
            }
            getYForBottomText(t) {
                const e = this.checkStave();
                if (this.hasStem()) {
                    const i = this.getStemExtents();
                    if (!i) throw new g("InvalidState", "Stem does not have extents.");
                    return Math.max(e.getYForTopText(t), i.baseY + this.render_options.annotation_spacing * t);
                }
                return e.getYForBottomText(t);
            }
            hasFlag() {
                return 1 == V.getGlyphProps(this.duration).flag && !this.beam;
            }
            postFormat() {
                var t;
                return null === (t = this.beam) || void 0 === t || t.postFormat(), this.postFormatted = !0, this;
            }
            drawStem(t) {
                var e;
                this.checkContext(), this.setRendered(), this.setStem(new at(t)), null === (e = this.stem) || void 0 === e || e.setContext(this.getContext()).draw();
            }
        }
        function Ut(t, e, i) {
            const b = i;
            t.line += b, t.maxLine += b, t.minLine += b, t.note.setKeyLine(0, t.note.getKeyLine(0) + b);
        }
        class It extends Wt {
            static get CATEGORY() {
                return x.StaveNote;
            }
            static get STEM_UP() {
                return at.UP;
            }
            static get STEM_DOWN() {
                return at.DOWN;
            }
            static get LEDGER_LINE_OFFSET() {
                return 3;
            }
            static get minNoteheadPadding() {
                return V.currentMusicFont().lookupMetric("noteHead.minPadding");
            }
            static format(t, e) {
                var i, b;
                if (!t || t.length < 2) return !1;
                const a = [];
                for(let e = 0; e < t.length; e++){
                    const i = t[e].sortedKeyProps, b = i[0].keyProps.line;
                    let n = i[i.length - 1].keyProps.line;
                    const s = t[e].getStemDirection(), l = t[e].getStemLength() / 10, o = t[e].getStemMinimumLength() / 10;
                    let r;
                    t[e].isRest() ? (r = b + t[e].glyphProps.line_above, n = b - t[e].glyphProps.line_below) : (r = 1 === s ? i[i.length - 1].keyProps.line + l : i[i.length - 1].keyProps.line, n = 1 === s ? i[0].keyProps.line : i[0].keyProps.line - l), a.push({
                        line: i[0].keyProps.line,
                        maxLine: r,
                        minLine: n,
                        isrest: t[e].isRest(),
                        stemDirection: s,
                        stemMax: l,
                        stemMin: o,
                        voice_shift: t[e].getVoiceShiftWidth(),
                        is_displaced: t[e].isDisplaced(),
                        note: t[e]
                    });
                }
                let n, s, l, o = 0;
                const r = [
                    !1,
                    !1,
                    !1
                ];
                for(let t = 0; t < a.length; t++)r[t] = 0 != a[t].note.render_options.draw;
                if (r[0] && r[1] && r[2]) o = 3, n = a[0], s = a[1], l = a[2];
                else if (r[0] && r[1]) o = 2, n = a[0], l = a[1];
                else if (r[0] && r[2]) o = 2, n = a[0], l = a[2];
                else {
                    if (!r[1] || !r[2]) return !0;
                    o = 2, n = a[1], l = a[2];
                }
                2 === o && -1 === n.stemDirection && 1 === l.stemDirection && (n = a[1], l = a[0]);
                const h = Math.max(n.voice_shift, l.voice_shift);
                let m = 0;
                if (2 === o) {
                    const t = n.note.hasStem() && l.note.hasStem() && n.stemDirection === l.stemDirection ? 0 : .5;
                    if (l.isrest && n.isrest && n.note.duration === l.note.duration) l.note.render_options.draw = !1;
                    else if (n.minLine <= l.maxLine + t) {
                        if (n.isrest) Ut(n, 0, 1);
                        else if (l.isrest) Ut(l, 0, -1);
                        else {
                            const t = Math.abs(n.line - l.line);
                            if (n.note.hasStem() && l.note.hasStem()) {
                                const e = V.codeNoteHead(null !== (i = n.note.sortedKeyProps[0].keyProps.code) && void 0 !== i ? i : "N", n.note.duration), a = V.codeNoteHead(null !== (b = l.note.sortedKeyProps[l.note.sortedKeyProps.length - 1].keyProps.code) && void 0 !== b ? b : "N", l.note.duration);
                                !V.UNISON || e !== a || n.note.getModifiers().filter((t)=>t.getCategory() === x.Dot && 0 === t.getIndex()).length !== l.note.getModifiers().filter((t)=>t.getCategory() === x.Dot && 0 === t.getIndex()).length || t < 1 && t > 0 || JSON.stringify(n.note.getStyle()) !== JSON.stringify(l.note.getStyle()) ? (m = h + 2, n.stemDirection === l.stemDirection ? n.note.setXShift(m) : l.note.setXShift(m)) : n.note.voice !== l.note.voice && n.stemDirection === l.stemDirection && (n.line != l.line ? (m = h + 2, n.note.setXShift(m)) : 1 === l.stemDirection && (l.stemDirection = -1, l.note.setStemDirection(-1)));
                            } else t < 1 ? (m = h + 2, n.note.duration < l.note.duration ? n.note.setXShift(m) : l.note.setXShift(m)) : n.note.hasStem() ? (n.stemDirection = -n.note.getStemDirection(), n.note.setStemDirection(n.stemDirection)) : l.note.hasStem() && (l.stemDirection = -l.note.getStemDirection(), l.note.setStemDirection(l.stemDirection));
                        }
                    }
                    return e.right_shift += m, !0;
                }
                if (!s) throw new g("InvalidState", "noteM not defined.");
                if (s.isrest && !n.isrest && !l.isrest && (n.minLine <= s.maxLine || s.minLine <= l.maxLine)) return s.maxLine - s.minLine < n.minLine - l.maxLine ? function(t, e, i) {
                    const b = t.line - S(e.minLine, i.maxLine);
                    t.note.setKeyLine(0, t.note.getKeyLine(0) - b), t.line -= b, t.maxLine -= b, t.minLine -= b;
                }(s, n, l) : (m = h + 2, s.note.setXShift(m), !1 === l.note.hasBeam() && (l.stemDirection = -1, l.note.setStemDirection(-1)), n.minLine <= l.maxLine && !1 === n.note.hasBeam() && (n.stemDirection = 1, n.note.setStemDirection(1))), e.right_shift += m, !0;
                return n.isrest && s.isrest && l.isrest ? (n.note.render_options.draw = !1, l.note.render_options.draw = !1, e.right_shift += m, !0) : (s.isrest && n.isrest && s.minLine <= l.maxLine && (s.note.render_options.draw = !1), s.isrest && l.isrest && n.minLine <= s.maxLine && (s.note.render_options.draw = !1), n.isrest && n.minLine <= s.maxLine && Ut(n, 0, 1), l.isrest && s.minLine <= l.maxLine && Ut(l, 0, -1), (n.minLine <= s.maxLine + .5 || s.minLine <= l.maxLine) && (m = h + 2, s.note.setXShift(m), !1 === l.note.hasBeam() && (l.stemDirection = -1, l.note.setStemDirection(-1)), n.minLine <= l.maxLine && !1 === n.note.hasBeam() && (n.stemDirection = 1, n.note.setStemDirection(1))), e.right_shift += m, !0);
            }
            static postFormat(t) {
                return !!t && (t.forEach((t)=>t.postFormat()), !0);
            }
            constructor(t){
                var e, i, b;
                super(t), this.minLine = 0, this.maxLine = 0, this.sortedKeyProps = [], this.ledgerLineStyle = {}, this.clef = null !== (e = t.clef) && void 0 !== e ? e : "treble", this.octave_shift = null !== (i = t.octave_shift) && void 0 !== i ? i : 0, this.glyphProps = V.getGlyphProps(this.duration, this.noteType), p(this.glyphProps, "BadArguments", `No glyph found for duration '${this.duration}' and type '${this.noteType}'`), this.displaced = !1, this.dot_shiftY = 0, this.use_default_head_x = !1, this._noteHeads = [], this.modifiers = [], this.render_options = Object.assign(Object.assign({}, this.render_options), {
                    glyph_font_scale: t.glyph_font_scale || V.NOTATION_FONT_SCALE,
                    stroke_px: t.stroke_px || It.LEDGER_LINE_OFFSET
                }), this.calculateKeyProps(), this.buildStem(), t.auto_stem ? this.autoStem() : this.setStemDirection(null !== (b = t.stem_direction) && void 0 !== b ? b : at.UP), this.reset(), this.buildFlag();
            }
            reset() {
                super.reset();
                const t = this._noteHeads.map((t)=>t.getStyle());
                this.buildNoteHeads(), this._noteHeads.forEach((e, i)=>{
                    const b = t[i];
                    b && e.setStyle(b);
                });
                const e = this.stave;
                return e && this.setStave(e), this.calcNoteDisplacements(), this;
            }
            setBeam(t) {
                return this.beam = t, this.calcNoteDisplacements(), this.stem && this.stem.setExtension(this.getStemExtension()), this;
            }
            buildStem() {
                return this.setStem(new at({
                    hide: !!this.isRest()
                })), this;
            }
            buildNoteHeads() {
                this._noteHeads = [];
                const t = this.getStemDirection(), e = this.getKeys();
                let i, b, a, n, s, l = !1;
                t === at.UP ? (a = 0, n = e.length, s = 1) : (a = e.length - 1, n = -1, s = -1);
                for(let e = a; e !== n; e += s){
                    const a = this.sortedKeyProps[e].keyProps, n = a.line;
                    void 0 === i ? i = n : (b = Math.abs(i - n), 0 === b || .5 === b ? l = !l : (l = !1, this.use_default_head_x = !0)), i = n;
                    const s = new Lt({
                        duration: this.duration,
                        note_type: this.noteType,
                        displaced: l,
                        stem_direction: t,
                        custom_glyph_code: a.code,
                        glyph_font_scale: this.render_options.glyph_font_scale,
                        x_shift: a.shift_right,
                        stem_up_x_offset: a.stem_up_x_offset,
                        stem_down_x_offset: a.stem_down_x_offset,
                        line: a.line
                    });
                    this.addChildElement(s), this._noteHeads[this.sortedKeyProps[e].index] = s;
                }
                return this._noteHeads;
            }
            autoStem() {
                this.setStemDirection(this.calculateOptimalStemDirection());
            }
            calculateOptimalStemDirection() {
                this.minLine = this.sortedKeyProps[0].keyProps.line, this.maxLine = this.sortedKeyProps[this.keyProps.length - 1].keyProps.line;
                return (this.minLine + this.maxLine) / 2 < 3 ? at.UP : at.DOWN;
            }
            calculateKeyProps() {
                let t;
                for(let e = 0; e < this.keys.length; ++e){
                    const i = this.keys[e];
                    this.glyphProps.rest && (this.glyphProps.position = i);
                    const b = {
                        octave_shift: this.octave_shift || 0,
                        duration: this.duration
                    }, a = V.keyProperties(i, this.clef, b);
                    if (!a) throw new g("BadArguments", `Invalid key for note properties: ${i}`);
                    "R" === a.key && ("1" === this.duration || "w" === this.duration ? a.line = 4 : a.line = 3);
                    const n = a.line;
                    null == t ? t = n : .5 === Math.abs(t - n) && (this.displaced = !0, a.displaced = !0, this.keyProps.length > 0 && (this.keyProps[e - 1].displaced = !0)), t = n, this.keyProps.push(a);
                }
                this.keyProps.forEach((t, e)=>{
                    this.sortedKeyProps.push({
                        keyProps: t,
                        index: e
                    });
                }), this.sortedKeyProps.sort((t, e)=>t.keyProps.line - e.keyProps.line);
            }
            getBoundingBox() {
                var t, e;
                if (!this.preFormatted) throw new g("UnformattedNote", "Can't call getBoundingBox on an unformatted note.");
                const { width: i, modLeftPx: b, leftDisplacedHeadPx: a } = this.getMetrics(), n = this.getAbsoluteX() - b - a;
                let s = 0, l = 0;
                const o = (null !== (e = null === (t = this.getStave()) || void 0 === t ? void 0 : t.getSpacingBetweenLines()) && void 0 !== e ? e : 0) / 2, r = 2 * o;
                if (this.isRest()) {
                    const t = this.ys[0], e = V.durationToFraction(this.duration);
                    e.equals(1) || e.equals(2) ? (s = t - o, l = t + o) : (s = t - this.glyphProps.line_above * r, l = t + this.glyphProps.line_below * r);
                } else if (this.glyphProps.stem) {
                    const t = this.getStemExtents();
                    t.baseY += o * this.getStemDirection(), s = Math.min(t.topY, t.baseY), l = Math.max(t.topY, t.baseY);
                } else {
                    s = 0, l = 0;
                    for(let t = 0; t < this.ys.length; ++t){
                        const e = this.ys[t];
                        0 === t ? (s = e, l = e) : (s = Math.min(e, s), l = Math.max(e, l));
                    }
                    s -= o, l += o;
                }
                return new D(n, s, i, l - s);
            }
            getLineNumber(t) {
                if (!this.keyProps.length) throw new g("NoKeyProps", "Can't get bottom note line, because note is not initialized properly.");
                let e = this.keyProps[0].line;
                for(let i = 0; i < this.keyProps.length; i++){
                    const b = this.keyProps[i].line;
                    t ? b > e && (e = b) : b < e && (e = b);
                }
                return e;
            }
            isRest() {
                return this.glyphProps.rest;
            }
            isChord() {
                return !this.isRest() && this.keys.length > 1;
            }
            hasStem() {
                return this.glyphProps.stem;
            }
            hasFlag() {
                return super.hasFlag() && !this.isRest();
            }
            getStemX() {
                return "r" === this.noteType ? this.getCenterGlyphX() : super.getStemX() + (this.stem_direction ? at.WIDTH / (2 * -this.stem_direction) : 0);
            }
            getYForTopText(t) {
                const e = this.getStemExtents();
                return Math.min(this.checkStave().getYForTopText(t), e.topY - this.render_options.annotation_spacing * (t + 1));
            }
            getYForBottomText(t) {
                const e = this.getStemExtents();
                return Math.max(this.checkStave().getYForTopText(t), e.baseY + this.render_options.annotation_spacing * t);
            }
            setStave(t) {
                super.setStave(t);
                const e = this._noteHeads.map((e)=>(e.setStave(t), e.getY()));
                if (this.setYs(e), this.stem) {
                    const { y_top: t, y_bottom: e } = this.getNoteHeadBounds();
                    this.stem.setYBounds(t, e);
                }
                return this;
            }
            isDisplaced() {
                return this.displaced;
            }
            setNoteDisplaced(t) {
                return this.displaced = t, this;
            }
            getTieRightX() {
                let t = this.getAbsoluteX();
                return t += this.getGlyphWidth() + this.x_shift + this.rightDisplacedHeadPx, this.modifierContext && (t += this.modifierContext.getRightShift()), t;
            }
            getTieLeftX() {
                let t = this.getAbsoluteX();
                return t += this.x_shift - this.leftDisplacedHeadPx, t;
            }
            getLineForRest() {
                let t = this.keyProps[0].line;
                if (this.keyProps.length > 1) {
                    const e = this.keyProps[this.keyProps.length - 1].line;
                    t = S(Math.max(t, e), Math.min(t, e));
                }
                return t;
            }
            getModifierStartXY(t, e, i = {}) {
                var b, a;
                if (!this.preFormatted) throw new g("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
                if (0 === this.ys.length) throw new g("NoYValues", "No Y-Values calculated for this note.");
                const { ABOVE: n, BELOW: s, LEFT: l, RIGHT: o } = tt.Position;
                let r = 0;
                return t === l ? r = -2 : t === o ? (r = this.getGlyphWidth() + this.x_shift + 2, this.stem_direction === at.UP && this.hasFlag() && (i.forceFlagRight || ((t, e)=>e === (t.getStemDirection() === at.UP ? t.keyProps.length - 1 : 0))(this, e)) && (r += null !== (a = null === (b = null == this ? void 0 : this.flag) || void 0 === b ? void 0 : b.getMetrics().width) && void 0 !== a ? a : 0)) : t !== s && t !== n || (r = this.getGlyphWidth() / 2), {
                    x: this.getAbsoluteX() + r,
                    y: this.ys[e]
                };
            }
            setStyle(t) {
                return super.setGroupStyle(t);
            }
            setStemStyle(t) {
                const e = this.getStem();
                return e && e.setStyle(t), this;
            }
            getStemStyle() {
                var t;
                return null === (t = this.stem) || void 0 === t ? void 0 : t.getStyle();
            }
            setLedgerLineStyle(t) {
                this.ledgerLineStyle = t;
            }
            getLedgerLineStyle() {
                return this.ledgerLineStyle;
            }
            setFlagStyle(t) {
                var e;
                null === (e = this.flag) || void 0 === e || e.setStyle(t);
            }
            getFlagStyle() {
                var t;
                return null === (t = this.flag) || void 0 === t ? void 0 : t.getStyle();
            }
            setKeyStyle(t, e) {
                return this._noteHeads[t].setStyle(e), this;
            }
            setKeyLine(t, e) {
                return this.keyProps[t].line = e, this.reset(), this;
            }
            getKeyLine(t) {
                return this.keyProps[t].line;
            }
            getVoiceShiftWidth() {
                return this.getGlyphWidth() * (this.displaced ? 2 : 1);
            }
            calcNoteDisplacements() {
                this.setLeftDisplacedHeadPx(this.displaced && this.stem_direction === at.DOWN ? this.getGlyphWidth() : 0), this.setRightDisplacedHeadPx(!this.hasFlag() && this.displaced && this.stem_direction === at.UP ? this.getGlyphWidth() : 0);
            }
            preFormat() {
                if (this.preFormatted) return;
                let t = 0;
                this.modifierContext && (this.modifierContext.preFormat(), 0 === this.modifierContext.getWidth() && (t = It.minNoteheadPadding));
                let e = this.getGlyphWidth() + this.leftDisplacedHeadPx + this.rightDisplacedHeadPx + t;
                this.shouldDrawFlag() && this.stem_direction === at.UP && (e += this.getGlyphWidth()), this.setWidth(e), this.preFormatted = !0;
            }
            getNoteHeadBounds() {
                let t, e, i, b, a = 1 / 0, n = -1 / 0, s = this.checkStave().getNumLines(), l = 1, o = s, r = l;
                return this._noteHeads.forEach((h)=>{
                    const m = h.getLine(), c = h.getY();
                    a = Math.min(c, a), n = Math.max(c, n), void 0 === e && h.isDisplaced() && (e = h.getAbsoluteX()), void 0 !== t || h.isDisplaced() || (t = h.getAbsoluteX()), s = Math.max(m, s), l = Math.min(m, l), h.isDisplaced() ? (i = void 0 === i ? m : Math.max(m, i), b = void 0 === b ? m : Math.min(m, b)) : (o = Math.max(m, o), r = Math.min(m, r));
                }, this), {
                    y_top: a,
                    y_bottom: n,
                    displaced_x: e,
                    non_displaced_x: t,
                    highest_line: s,
                    lowest_line: l,
                    highest_displaced_line: i,
                    lowest_displaced_line: b,
                    highest_non_displaced_line: o,
                    lowest_non_displaced_line: r
                };
            }
            getNoteHeadBeginX() {
                return this.getAbsoluteX() + this.x_shift;
            }
            getNoteHeadEndX() {
                return this.getNoteHeadBeginX() + this.getGlyphWidth();
            }
            get noteHeads() {
                return this._noteHeads.slice();
            }
            get note_heads() {
                return console.warn("StaveNote.note_heads is deprecated. Use StaveNote.noteHeads instead.", "This accessor will be removed in VexFlow 5.0."), this.noteHeads;
            }
            drawLedgerLines() {
                const t = this.checkStave(), { glyphProps: e, render_options: { stroke_px: i } } = this, b = this.checkContext(), a = e.getWidth() + 2 * i, n = 2 * (e.getWidth() + i) - at.WIDTH / 2;
                if (this.isRest()) return;
                if (!b) throw new g("NoCanvasContext", "Can't draw without a canvas context.");
                const { highest_line: s, lowest_line: l, highest_displaced_line: o, highest_non_displaced_line: r, lowest_displaced_line: h, lowest_non_displaced_line: m, displaced_x: c, non_displaced_x: d } = this.getNoteHeadBounds();
                if (s < 6 && l > 0) return;
                const _ = Math.min(null != c ? c : 0, null != d ? d : 0), x = (t, e, s)=>{
                    let l;
                    l = s && e ? _ - i : e ? (null != d ? d : 0) - i : (null != c ? c : 0) - i;
                    const o = e && s ? n : a;
                    b.beginPath(), b.moveTo(l, t), b.lineTo(l + o, t), b.stroke();
                }, y = Object.assign(Object.assign({}, t.getDefaultLedgerLineStyle()), this.getLedgerLineStyle());
                this.applyStyle(b, y);
                for(let e = 6; e <= s; ++e){
                    const i = void 0 !== d && e <= r, b = void 0 !== o && e <= o;
                    x(t.getYForNote(e), i, b);
                }
                for(let e = 0; e >= l; --e){
                    const i = void 0 !== d && e >= m, b = void 0 !== h && e >= h;
                    x(t.getYForNote(e), i, b);
                }
                this.restoreStyle(b, y);
            }
            drawModifiers(t) {
                const e = this.checkContext();
                for(let i = 0; i < this.modifiers.length; i++){
                    const b = this.modifiers[i], a = b.checkIndex(), n = this._noteHeads[a];
                    if (n == t) {
                        const t = n.getStyle();
                        n.applyStyle(e, t), b.setContext(e), b.drawWithStyle(), n.restoreStyle(e, t);
                    }
                }
            }
            shouldDrawFlag() {
                const t = void 0 !== this.stem, e = 1 == this.glyphProps.flag, i = void 0 === this.beam;
                return t && e && i;
            }
            drawFlag() {
                var t, e, i, b, a;
                const n = this.checkContext();
                if (!n) throw new g("NoCanvasContext", "Can't draw without a canvas context.");
                if (this.shouldDrawFlag()) {
                    const { y_top: s, y_bottom: l } = this.getNoteHeadBounds(), o = this.stem.getHeight(), r = this.getStemX(), h = this.getStemDirection() === at.DOWN ? s - o + 2 - (this.glyphProps ? this.glyphProps.stem_down_extension : 0) * this.getStaveNoteScale() - (null !== (e = null === (t = this.flag) || void 0 === t ? void 0 : t.getMetrics().y_shift) && void 0 !== e ? e : 0) * (1 - this.getStaveNoteScale()) : l - o - 2 + (this.glyphProps ? this.glyphProps.stem_up_extension : 0) * this.getStaveNoteScale() - (null !== (b = null === (i = this.flag) || void 0 === i ? void 0 : i.getMetrics().y_shift) && void 0 !== b ? b : 0) * (1 - this.getStaveNoteScale());
                    null === (a = this.flag) || void 0 === a || a.render(n, r, h);
                }
            }
            drawNoteHeads() {
                const t = this.checkContext();
                this._noteHeads.forEach((e)=>{
                    e.applyStyle(t), t.openGroup("notehead", e.getAttribute("id"), {
                        pointerBBox: !0
                    }), e.setContext(t).draw(), this.drawModifiers(e), t.closeGroup(), e.restoreStyle(t);
                });
            }
            drawStem(t) {
                const e = this.checkContext();
                t && this.setStem(new at(t)), this.shouldDrawFlag() && this.stem && this.stem.adjustHeightForFlag(), this.stem && this.stem.setContext(e).draw();
            }
            getStaveNoteScale() {
                return 1;
            }
            getStemExtension() {
                const t = super.getStemExtension();
                if (!this.glyphProps.stem) return t;
                const e = this.getStemDirection();
                if (e !== this.calculateOptimalStemDirection()) return t;
                let i;
                i = e === at.UP ? 3 - this.maxLine : this.minLine - 3;
                const b = i - 3.5;
                if (b <= 0) return t;
                const a = this.getStave();
                let n = 10;
                return null != a && (n = a.getSpacingBetweenLines()), t + b * n;
            }
            draw() {
                if (!1 === this.render_options.draw) return;
                if (0 === this.ys.length) throw new g("NoYValues", "Can't draw note without Y values.");
                const t = this.checkContext(), e = this.getNoteHeadBeginX(), i = this.hasStem() && !this.beam;
                if (this._noteHeads.forEach((t)=>t.setX(e)), this.stem) {
                    const t = this.getStemX();
                    this.stem.setNoteHeadXBounds(t, t);
                }
                !function(...t) {
                    It.DEBUG && u("Vex.Flow.StaveNote", t);
                }("Rendering ", this.isChord() ? "chord :" : "note :", this.keys), this.applyStyle(), t.openGroup("stavenote", this.getAttribute("id")), this.drawLedgerLines(), i && this.drawStem(), this.drawNoteHeads(), this.drawFlag(), t.closeGroup(), this.restoreStyle(), this.setRendered();
            }
        }
        It.DEBUG = !1;
        class Gt extends R {
            static get CATEGORY() {
                return x.StaveTie;
            }
            constructor(t, e){
                super(), this.setNotes(t), this.text = e, this.render_options = {
                    cp1: 8,
                    cp2: 12,
                    text_shift_x: 0,
                    first_x_shift: 0,
                    last_x_shift: 0,
                    y_shift: 7,
                    tie_spacing: 0
                }, this.resetFont();
            }
            setDirection(t) {
                return this.direction = t, this;
            }
            setNotes(t) {
                if (!t.first_note && !t.last_note) throw new g("BadArguments", "Tie needs to have either first_note or last_note set.");
                if (t.first_indices || (t.first_indices = [
                    0
                ]), t.last_indices || (t.last_indices = [
                    0
                ]), t.first_indices.length !== t.last_indices.length) throw new g("BadArguments", "Tied notes must have same number of indices.");
                return this.notes = t, this;
            }
            isPartial() {
                return !this.notes.first_note || !this.notes.last_note;
            }
            renderTie(t) {
                if (0 === t.first_ys.length || 0 === t.last_ys.length) throw new g("BadArguments", "No Y-values to render");
                const e = this.checkContext();
                let i = this.render_options.cp1, b = this.render_options.cp2;
                Math.abs(t.last_x_px - t.first_x_px) < 10 && (i = 2, b = 8);
                const a = this.render_options.first_x_shift, n = this.render_options.last_x_shift, s = this.render_options.y_shift * t.direction, l = this.notes.first_indices, o = this.notes.last_indices;
                this.applyStyle(), e.openGroup("stavetie", this.getAttribute("id"));
                for(let r = 0; r < l.length; ++r){
                    const h = (t.last_x_px + n + (t.first_x_px + a)) / 2, m = t.first_ys[l[r]] + s, c = t.last_ys[o[r]] + s;
                    if (isNaN(m) || isNaN(c)) throw new g("BadArguments", "Bad indices for tie rendering.");
                    const d = (m + c) / 2 + i * t.direction, _ = (m + c) / 2 + b * t.direction;
                    e.beginPath(), e.moveTo(t.first_x_px + a, m), e.quadraticCurveTo(h, d, t.last_x_px + n, c), e.quadraticCurveTo(h, _, t.first_x_px + a, m), e.closePath(), e.fill();
                }
                e.closeGroup(), this.restoreStyle();
            }
            renderText(t, e) {
                var i, b, a;
                if (!this.text) return;
                const n = this.checkContext();
                let s = (t + e) / 2;
                s -= n.measureText(this.text).width / 2;
                const l = null !== (b = null === (i = this.notes.first_note) || void 0 === i ? void 0 : i.checkStave()) && void 0 !== b ? b : null === (a = this.notes.last_note) || void 0 === a ? void 0 : a.checkStave();
                l && (n.save(), n.setFont(this.textFont), n.fillText(this.text, s + this.render_options.text_shift_x, l.getYForTopText() - 1), n.restore());
            }
            getNotes() {
                return this.notes;
            }
            draw() {
                this.checkContext(), this.setRendered();
                const t = this.notes.first_note, e = this.notes.last_note;
                let i = 0, b = 0, a = [
                    0
                ], n = [
                    0
                ], s = 0;
                if (t) i = t.getTieRightX() + this.render_options.tie_spacing, s = t.getStemDirection(), a = t.getYs();
                else if (e) i = e.checkStave().getTieStartX(), a = e.getYs(), this.notes.first_indices = this.notes.last_indices;
                if (e) b = e.getTieLeftX() + this.render_options.tie_spacing, s = e.getStemDirection(), n = e.getYs();
                else if (t) b = t.checkStave().getTieEndX(), n = t.getYs(), this.notes.last_indices = this.notes.first_indices;
                return this.direction && (s = this.direction), this.renderTie({
                    first_x_px: i,
                    last_x_px: b,
                    first_ys: a,
                    last_ys: n,
                    direction: s
                }), this.renderText(i, b), !0;
            }
        }
        Gt.TEXT_FONT = Object.assign({}, R.TEXT_FONT);
        class Ht extends Gt {
            static get CATEGORY() {
                return x.TabTie;
            }
            static createHammeron(t) {
                return new Ht(t, "H");
            }
            static createPulloff(t) {
                return new Ht(t, "P");
            }
            constructor(t, e){
                super(t, e), this.render_options.cp1 = 9, this.render_options.cp2 = 11, this.render_options.y_shift = 3, this.direction = -1;
            }
        }
        var Yt;
        !function(t) {
            t[t.STRICT = 1] = "STRICT", t[t.SOFT = 2] = "SOFT", t[t.FULL = 3] = "FULL";
        }(Yt || (Yt = {}));
        class Xt extends R {
            static get CATEGORY() {
                return x.Voice;
            }
            static get Mode() {
                return Yt;
            }
            constructor(t){
                let e;
                if (super(), this.resolutionMultiplier = 1, this.mode = Yt.STRICT, this.preFormatted = !1, this.ticksUsed = new z(0, 1), this.largestTickWidth = 0, this.tickables = [], this.options = {
                    softmaxFactor: V.SOFTMAX_FACTOR
                }, "string" == typeof t) {
                    const i = t.match(/(\d+)\/(\d+)/);
                    i && (e = {
                        num_beats: parseInt(i[1]),
                        beat_value: parseInt(i[2])
                    });
                } else e = t;
                this.time = Object.assign({
                    num_beats: 4,
                    beat_value: 4,
                    resolution: V.RESOLUTION
                }, e), this.totalTicks = new z(this.time.num_beats * (this.time.resolution / this.time.beat_value), 1), this.smallestTickCount = this.totalTicks.clone();
            }
            getTotalTicks() {
                return this.totalTicks;
            }
            getTicksUsed() {
                return this.ticksUsed;
            }
            getLargestTickWidth() {
                return this.largestTickWidth;
            }
            getSmallestTickCount() {
                return this.smallestTickCount;
            }
            getTickables() {
                return this.tickables;
            }
            getMode() {
                return this.mode;
            }
            setMode(t) {
                return this.mode = t, this;
            }
            getResolutionMultiplier() {
                return this.resolutionMultiplier;
            }
            getActualResolution() {
                return this.resolutionMultiplier * this.time.resolution;
            }
            setStave(t) {
                return this.stave = t, this.boundingBox = void 0, this;
            }
            getStave() {
                return this.stave;
            }
            getBoundingBox() {
                if (!this.boundingBox) {
                    const t = this.checkStave();
                    let e;
                    for(let i = 0; i < this.tickables.length; ++i){
                        const b = this.tickables[i];
                        b.getStave() || b.setStave(t);
                        const a = b.getBoundingBox();
                        a && (e = e ? e.mergeWith(a) : a);
                    }
                    this.boundingBox = e;
                }
                return this.boundingBox;
            }
            setStrict(t) {
                return this.mode = t ? Yt.STRICT : Yt.SOFT, this;
            }
            isComplete() {
                return this.mode !== Yt.STRICT && this.mode !== Yt.FULL || this.ticksUsed.equals(this.totalTicks);
            }
            setSoftmaxFactor(t) {
                return this.options.softmaxFactor = t, this.expTicksUsed = 0, this;
            }
            reCalculateExpTicksUsed() {
                const t = this.ticksUsed.value();
                return this.expTicksUsed = w(this.tickables.map((e)=>Math.pow(this.options.softmaxFactor, e.getTicks().value() / t))), this.expTicksUsed;
            }
            softmax(t) {
                this.expTicksUsed || (this.expTicksUsed = this.reCalculateExpTicksUsed());
                const e = this.ticksUsed.value();
                return ((t)=>Math.pow(this.options.softmaxFactor, t / e))(t) / this.expTicksUsed;
            }
            addTickable(t) {
                if (!t.shouldIgnoreTicks()) {
                    const e = t.getTicks();
                    if (this.ticksUsed.add(e), this.expTicksUsed = 0, (this.mode === Yt.STRICT || this.mode === Yt.FULL) && this.ticksUsed.greaterThan(this.totalTicks)) throw this.ticksUsed.subtract(e), new g("BadArgument", "Too many ticks.");
                    e.lessThan(this.smallestTickCount) && (this.smallestTickCount = e.clone()), this.resolutionMultiplier = this.ticksUsed.denominator, this.totalTicks.add(0, this.ticksUsed.denominator);
                }
                return this.tickables.push(t), t.setVoice(this), this;
            }
            addTickables(t) {
                for(let e = 0; e < t.length; ++e)this.addTickable(t[e]);
                return this;
            }
            preFormat() {
                if (this.preFormatted) return this;
                const t = this.checkStave();
                return this.tickables.forEach((e)=>{
                    e.getStave() || e.setStave(t);
                }), this.preFormatted = !0, this;
            }
            checkStave() {
                return p(this.stave, "NoStave", "No stave attached to instance.");
            }
            draw(t = this.checkContext(), e) {
                let i;
                e = null != e ? e : this.stave, this.setRendered();
                for(let b = 0; b < this.tickables.length; ++b){
                    const a = this.tickables[b];
                    e && a.setStave(e), p(a.getStave(), "MissingStave", "The voice cannot draw tickables without staves.");
                    const n = a.getBoundingBox();
                    n && (i = i ? i.mergeWith(n) : n), a.setContext(t), a.drawWithStyle();
                }
                this.boundingBox = i;
            }
        }
        class jt extends tt {
            static get CATEGORY() {
                return x.GraceNoteGroup;
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                const i = [];
                let b = null, a = 0;
                for(let e = 0; e < t.length; ++e){
                    const n = t[e], s = n.getNote(), l = c(s), o = l ? 4 : 0;
                    if (l && s !== b) {
                        for(let t = 0; t < s.keys.length; ++t)a = Math.max(s.getLeftDisplacedHeadPx(), a);
                        b = s;
                    }
                    i.push({
                        shift: a,
                        gracenote_group: n,
                        spacing: o
                    });
                }
                let n, s = i[0].shift;
                for(let t = 0; t < i.length; ++t){
                    const e = i[t].gracenote_group;
                    e.preFormat(), n = e.getWidth() + i[t].spacing, s = Math.max(n, s);
                }
                for(let t = 0; t < i.length; ++t){
                    const e = i[t].gracenote_group;
                    n = e.getWidth() + i[t].spacing, e.setSpacingFromNextModifier(s - Math.min(n, s) + It.minNoteheadPadding);
                }
                return e.left_shift += s, !0;
            }
            constructor(t, e){
                return super(), this.preFormatted = !1, this.position = tt.Position.LEFT, this.grace_notes = t, this.width = 0, this.show_slur = e, this.slur = void 0, this.voice = new Xt({
                    num_beats: 4,
                    beat_value: 4,
                    resolution: V.RESOLUTION
                }).setStrict(!1), this.render_options = {
                    slur_y_shift: 0
                }, this.beams = [], this.voice.addTickables(this.grace_notes), this;
            }
            preFormat() {
                this.preFormatted || (this.formatter || (this.formatter = new Pe), this.formatter.joinVoices([
                    this.voice
                ]).format([
                    this.voice
                ], 0, {}), this.setWidth(this.formatter.getMinTotalWidth()), this.preFormatted = !0);
            }
            beamNotes(t) {
                if ((t = t || this.grace_notes).length > 1) {
                    const e = new Re(t);
                    e.render_options.beam_width = 3, e.render_options.partial_beam_length = 4, this.beams.push(e);
                }
                return this;
            }
            setWidth(t) {
                return this.width = t, this;
            }
            getWidth() {
                return this.width + It.minNoteheadPadding;
            }
            getGraceNotes() {
                return this.grace_notes;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                if (this.setRendered(), function(...t) {
                    jt.DEBUG && u("Vex.Flow.GraceNoteGroup", t);
                }("Drawing grace note group for:", e), this.alignSubNotesWithNote(this.getGraceNotes(), e), this.grace_notes.forEach((e)=>e.setContext(t).draw()), this.beams.forEach((e)=>e.setContext(t).draw()), this.show_slur) {
                    const i = c(e), b = i ? Gt : Ht;
                    this.slur = new b({
                        last_note: this.grace_notes[0],
                        first_note: e,
                        first_indices: [
                            0
                        ],
                        last_indices: [
                            0
                        ]
                    }), this.slur.render_options.cp2 = 12, this.slur.render_options.y_shift = (i ? 7 : 5) + this.render_options.slur_y_shift, this.slur.setContext(t).draw();
                }
            }
        }
        jt.DEBUG = !1;
        class Vt extends tt {
            static get CATEGORY() {
                return x.NoteSubGroup;
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0;
                for(let e = 0; e < t.length; ++e){
                    const b = t[e];
                    b.preFormat(), i += b.getWidth();
                }
                return e.left_shift += i, !0;
            }
            constructor(t){
                super(), this.preFormatted = !1, this.position = tt.Position.LEFT, this.subNotes = t, this.subNotes.forEach((t)=>{
                    t.setIgnoreTicks(!1);
                }), this.width = 0, this.formatter = new Pe, this.voice = new Xt({
                    num_beats: 4,
                    beat_value: 4,
                    resolution: V.RESOLUTION
                }).setStrict(!1), this.voice.addTickables(this.subNotes);
            }
            preFormat() {
                this.preFormatted || (this.formatter.joinVoices([
                    this.voice
                ]).format([
                    this.voice
                ], 0), this.setWidth(this.formatter.getMinTotalWidth()), this.preFormatted = !0);
            }
            setWidth(t) {
                return this.width = t, this;
            }
            getWidth() {
                return this.width;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered(), this.alignSubNotesWithNote(this.subNotes, e), this.subNotes.forEach((e)=>e.setContext(t).drawWithStyle());
            }
        }
        class Kt extends tt {
            static get CATEGORY() {
                return x.Ornament;
            }
            static get minPadding() {
                return V.currentMusicFont().lookupMetric("noteHead.minPadding");
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0, b = e.right_shift, a = e.left_shift, n = 0;
                for(let s = 0; s < t.length; ++s){
                    const l = t[s], o = 2;
                    if (Kt.ornamentRelease.indexOf(l.type) >= 0 && (l.x_shift += b + 2), Kt.ornamentAttack.indexOf(l.type) >= 0 && (l.x_shift -= a + 2), l.reportedWidth && l.x_shift < 0 ? a += l.reportedWidth : l.reportedWidth && l.x_shift >= 0 ? b += l.reportedWidth + Kt.minPadding : i = Math.max(l.getWidth(), i), Kt.ornamentArticulation.indexOf(l.type) >= 0) p(l.note, "NoAttachedNote").getLineNumber() >= 3 || l.getPosition() === tt.Position.ABOVE ? (e.top_text_line += o, l.y_shift += n, n -= l.glyph.bbox.getH()) : (e.text_line += o, l.y_shift += n, n += l.glyph.bbox.getH());
                    else l.getPosition() === tt.Position.ABOVE ? (l.setTextLine(e.top_text_line), e.top_text_line += o) : (l.setTextLine(e.text_line), e.text_line += o);
                }
                return e.left_shift = a + i / 2, e.right_shift = b + i / 2, !0;
            }
            static get ornamentNoteTransition() {
                return [
                    "flip",
                    "jazzTurn",
                    "smear"
                ];
            }
            static get ornamentAttack() {
                return [
                    "scoop"
                ];
            }
            static get ornamentAlignWithNoteHead() {
                return [
                    "doit",
                    "fall",
                    "fallLong",
                    "doitLong",
                    "bend",
                    "plungerClosed",
                    "plungerOpen",
                    "scoop"
                ];
            }
            static get ornamentRelease() {
                return [
                    "doit",
                    "fall",
                    "fallLong",
                    "doitLong",
                    "jazzTurn",
                    "smear",
                    "flip"
                ];
            }
            static get ornamentArticulation() {
                return [
                    "bend",
                    "plungerClosed",
                    "plungerOpen"
                ];
            }
            getMetrics() {
                const t = V.currentMusicFont().getMetrics().ornament;
                if (!t) throw new g("BadMetrics", "ornament missing");
                return t[this.ornament.code];
            }
            constructor(t){
                super(), this.type = t, this.delayed = !1, this.render_options = {
                    font_scale: V.NOTATION_FONT_SCALE,
                    accidentalLowerPadding: 3,
                    accidentalUpperPadding: 3
                }, this.ornament = V.ornamentCodes(this.type);
                const e = this.getMetrics();
                if (this.adjustForStemDirection = !1, this.reportedWidth = e && e.reportedWidth ? e.reportedWidth : 0, this.stemUpYOffset = e && e.stemUpYOffset ? e.stemUpYOffset : 0, this.ornamentAlignWithNoteHead = Kt.ornamentAlignWithNoteHead.indexOf(this.type) >= 0, !this.ornament) throw new g("ArgumentError", `Ornament not found: '${this.type}'`);
                this.x_shift = e ? e.xOffset : 0, this.y_shift = e ? e.yOffset : 0, this.glyph = new Z(this.ornament.code, this.render_options.font_scale, {
                    category: `ornament.${this.ornament.code}`
                }), Kt.ornamentNoteTransition.indexOf(this.type) >= 0 && (this.delayed = !0), e || this.glyph.setOrigin(.5, 1);
            }
            setDelayed(t) {
                return this.delayed = t, this;
            }
            setUpperAccidental(t) {
                const e = this.render_options.font_scale / 1.3;
                return this.accidentalUpper = new Z(V.accidentalCodes(t).code, e), this.accidentalUpper.setOrigin(.5, 1), this;
            }
            setLowerAccidental(t) {
                const e = this.render_options.font_scale / 1.3;
                return this.accidentalLower = new Z(V.accidentalCodes(t).code, e), this.accidentalLower.setOrigin(.5, 1), this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getStemDirection(), b = e.checkStave();
                this.applyStyle(), t.openGroup("ornament", this.getAttribute("id"));
                const a = e.checkStem().getExtents();
                let n = i === at.DOWN ? a.baseY : a.topY;
                _(e) && (e.hasStem() ? i === at.DOWN && (n = b.getYForTopText(this.text_line)) : n = b.getYForTopText(this.text_line));
                const s = i === at.DOWN, l = b.getSpacingBetweenLines();
                let o = 1;
                !s && e.hasBeam() && (o += .5);
                const r = n - l * (this.text_line + o), h = e.getModifierStartXY(this.position, this.index);
                let m = h.x, c = this.ornamentAlignWithNoteHead ? h.y : Math.min(b.getYForTopText(this.text_line), r);
                if (c += this.y_shift, this.delayed) {
                    let t = 0;
                    const i = m - b.getNoteStartX();
                    if (void 0 !== this.delayXShift) t = this.delayXShift;
                    else {
                        t += this.glyph.getMetrics().width / 2;
                        const a = e.getVoice().getTickables(), n = a.indexOf(e), s = n + 1 < a.length ? a[n + 1].checkTickContext() : void 0;
                        t += s ? .5 * (s.getX() - i) : .5 * (b.getX() + b.getWidth() - m), this.delayXShift = t;
                    }
                    m += t;
                }
                !function(...t) {
                    Kt.DEBUG && u("Vex.Flow.Ornament", t);
                }("Rendering ornament: ", this.ornament, m, c), this.accidentalLower && (this.accidentalLower.render(t, m, c), c -= this.accidentalLower.getMetrics().height, c -= this.render_options.accidentalLowerPadding), this.stemUpYOffset && e.hasStem() && 1 === e.getStemDirection() && (c += this.stemUpYOffset), e.getLineNumber() < 5 && Kt.ornamentNoteTransition.indexOf(this.type) >= 0 && (c = e.checkStave().getBoundingBox().getY() + 40), this.glyph.render(t, m + this.x_shift, c), this.accidentalUpper && (c -= this.glyph.getMetrics().height + this.render_options.accidentalUpperPadding, this.accidentalUpper.render(t, m, c)), t.closeGroup(), this.restoreStyle();
            }
        }
        Kt.DEBUG = !1;
        class $t extends tt {
            static get CATEGORY() {
                return x.Parenthesis;
            }
            static buildAndAttach(t) {
                for (const e of t)for(let t = 0; t < e.keys.length; t++)e.addModifier(new $t(J.LEFT), t), e.addModifier(new $t(J.RIGHT), t);
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0, b = 0;
                for(let e = 0; e < t.length; ++e){
                    const a = t[e], n = a.getNote(), s = a.getPosition(), l = a.checkIndex();
                    let o = 0;
                    s === J.RIGHT && (o = n.getRightParenthesisPx(l), b = b > o + a.width ? b : o + a.width), s === J.LEFT && (o = n.getLeftParenthesisPx(l), i = i > o + a.width ? i : o + a.width), a.setXShift(o);
                }
                return e.left_shift += i, e.right_shift += b, !0;
            }
            constructor(t){
                var e;
                super(), this.position = null != t ? t : tt.Position.LEFT, this.point = null !== (e = V.currentMusicFont().lookupMetric("parenthesis.default.point")) && void 0 !== e ? e : vt.getPoint("default"), this.setWidth(V.currentMusicFont().lookupMetric("parenthesis.default.width"));
            }
            setNote(t) {
                var e, i;
                return this.note = t, this.point = null !== (e = V.currentMusicFont().lookupMetric("parenthesis.default.point")) && void 0 !== e ? e : vt.getPoint("default"), this.setWidth(V.currentMusicFont().lookupMetric("parenthesis.default.width")), o(t) && (this.point = null !== (i = V.currentMusicFont().lookupMetric("parenthesis.gracenote.point")) && void 0 !== i ? i : vt.getPoint("gracenote"), this.setWidth(V.currentMusicFont().lookupMetric("parenthesis.gracenote.width"))), this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getModifierStartXY(this.position, this.index, {
                    forceFlagRight: !0
                }), b = i.x + this.x_shift, a = i.y + this.y_shift;
                this.position == tt.Position.RIGHT ? Z.renderGlyph(t, b + 1, a, this.point, "noteheadParenthesisRight", {
                    category: "noteHead.standard.noteheadParenthesisRight"
                }) : this.position == tt.Position.LEFT && Z.renderGlyph(t, b - 2, a, this.point, "noteheadParenthesisLeft", {
                    category: "noteHead.standard.noteheadParenthesisLeft"
                });
            }
        }
        function Jt(t) {
            if (!t) return !1;
            const e = y();
            return "function" == typeof e.HTMLCanvasElement && t instanceof e.HTMLCanvasElement || "function" == typeof t.getContext && "function" == typeof t.toDataURL;
        }
        function qt(t) {
            if (!t) return !1;
            const e = y();
            return "function" == typeof e.HTMLDivElement && t instanceof e.HTMLDivElement || "function" == typeof t.appendChild && "object" == typeof t.style;
        }
        class Qt extends ft {
            static get WIDTH() {
                return 600;
            }
            static get HEIGHT() {
                return 400;
            }
            static get CANVAS_BROWSER_SIZE_LIMIT() {
                return 32767;
            }
            static sanitizeCanvasDims(t, e) {
                const i = this.CANVAS_BROWSER_SIZE_LIMIT;
                return Math.max(t, e) > i && (f("Canvas dimensions exceed browser limit. Cropping to " + i), t > i && (t = i), e > i && (e = i)), [
                    t,
                    e
                ];
            }
            constructor(t){
                super(), this.textHeight = 0, this.context2D = t, t.canvas ? this.canvas = t.canvas : this.canvas = {
                    width: Qt.WIDTH,
                    height: Qt.HEIGHT
                };
            }
            clear() {
                this.context2D.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
            openGroup(t, e, i) {}
            closeGroup() {}
            add(t) {}
            setFillStyle(t) {
                return this.context2D.fillStyle = t, this;
            }
            setBackgroundFillStyle(t) {
                return this;
            }
            setStrokeStyle(t) {
                return this.context2D.strokeStyle = t, this;
            }
            setShadowColor(t) {
                return this.context2D.shadowColor = t, this;
            }
            setShadowBlur(t) {
                const e = this.context2D.getTransform(), i = Math.sqrt(e.a * e.a + e.b * e.b + e.c * e.c + e.d * e.d);
                return this.context2D.shadowBlur = i * t, this;
            }
            setLineWidth(t) {
                return this.context2D.lineWidth = t, this;
            }
            setLineCap(t) {
                return this.context2D.lineCap = t, this;
            }
            setLineDash(t) {
                return this.context2D.setLineDash(t), this;
            }
            scale(t, e) {
                return this.context2D.scale(t, e), this;
            }
            resize(t, e, i) {
                var b;
                const a = this.context2D.canvas, n = null !== (b = null != i ? i : y().devicePixelRatio) && void 0 !== b ? b : 1;
                return [t, e] = Qt.sanitizeCanvasDims(t * n, e * n), t = t / n | 0, e = e / n | 0, a.width = t * n, a.height = e * n, Jt(a) && (a.style.width = t + "px", a.style.height = e + "px"), this.scale(n, n);
            }
            rect(t, e, i, b) {
                return this.context2D.rect(t, e, i, b), this;
            }
            fillRect(t, e, i, b) {
                return this.context2D.fillRect(t, e, i, b), this;
            }
            clearRect(t, e, i, b) {
                return this.context2D.clearRect(t, e, i, b), this;
            }
            beginPath() {
                return this.context2D.beginPath(), this;
            }
            moveTo(t, e) {
                return this.context2D.moveTo(t, e), this;
            }
            lineTo(t, e) {
                return this.context2D.lineTo(t, e), this;
            }
            bezierCurveTo(t, e, i, b, a, n) {
                return this.context2D.bezierCurveTo(t, e, i, b, a, n), this;
            }
            quadraticCurveTo(t, e, i, b) {
                return this.context2D.quadraticCurveTo(t, e, i, b), this;
            }
            arc(t, e, i, b, a, n) {
                return this.context2D.arc(t, e, i, b, a, n), this;
            }
            fill() {
                return this.context2D.fill(), this;
            }
            stroke() {
                return this.context2D.stroke(), this;
            }
            closePath() {
                return this.context2D.closePath(), this;
            }
            measureText(t) {
                const e = this.context2D.measureText(t);
                let i = 0, b = 0;
                return e.fontBoundingBoxAscent ? (i = -e.fontBoundingBoxAscent, b = e.fontBoundingBoxDescent + e.fontBoundingBoxAscent) : (i = -e.actualBoundingBoxAscent, b = e.actualBoundingBoxDescent + e.actualBoundingBoxAscent), {
                    x: 0,
                    y: i,
                    width: e.width,
                    height: b
                };
            }
            fillText(t, e, i) {
                return this.context2D.fillText(t, e, i), this;
            }
            save() {
                return this.context2D.save(), this;
            }
            restore() {
                return this.context2D.restore(), this;
            }
            set fillStyle(t) {
                this.context2D.fillStyle = t;
            }
            get fillStyle() {
                return this.context2D.fillStyle;
            }
            set strokeStyle(t) {
                this.context2D.strokeStyle = t;
            }
            get strokeStyle() {
                return this.context2D.strokeStyle;
            }
            setFont(t, e, i, b) {
                const a = F.validate(t, e, i, b);
                return this.context2D.font = F.toCSSString(a), this.textHeight = F.convertSizeToPixelValue(a.size), this;
            }
            getFont() {
                return this.context2D.font;
            }
        }
        const Zt = {
            path: {
                x: !0,
                y: !0,
                width: !0,
                height: !0,
                "font-family": !0,
                "font-weight": !0,
                "font-style": !0,
                "font-size": !0
            },
            rect: {
                "font-family": !0,
                "font-weight": !0,
                "font-style": !0,
                "font-size": !0
            },
            text: {
                width: !0,
                height: !0
            }
        }, te = "http://www.w3.org/2000/svg", ee = 2 * Math.PI;
        class ie extends ft {
            constructor(t){
                super(), this.width = 0, this.height = 0, this.precision = 1, this.backgroundFillStyle = "white", this.fontCSSString = "", this.element = t, this.precision = Math.pow(10, V.RENDER_PRECISION_PLACES);
                const e = this.create("svg");
                this.element.appendChild(e), this.svg = e, this.parent = this.svg, this.groups = [
                    this.svg
                ], this.path = "", this.pen = {
                    x: NaN,
                    y: NaN
                }, this.lineWidth = 1;
                const i = {
                    "font-family": F.SANS_SERIF,
                    "font-size": F.SIZE + "pt",
                    "font-weight": E.NORMAL,
                    "font-style": P.NORMAL
                };
                this.state = Object.assign({
                    scaleX: 1,
                    scaleY: 1
                }, i), this.attributes = Object.assign({
                    "stroke-width": .3,
                    "stroke-dasharray": "none",
                    fill: "black",
                    stroke: "black"
                }, i), this.groupAttributes = [], this.applyAttributes(e, this.attributes), this.groupAttributes.push(Object.assign({}, this.attributes)), this.shadow_attributes = {
                    width: 0,
                    color: "black"
                }, this.state_stack = [];
            }
            round(t) {
                return Math.round(t * this.precision) / this.precision;
            }
            create(t) {
                return document.createElementNS(te, t);
            }
            openGroup(t, e, i) {
                const b = this.create("g");
                return this.groups.push(b), this.parent.appendChild(b), this.parent = b, t && b.setAttribute("class", T(t)), e && b.setAttribute("id", T(e)), i && i.pointerBBox && b.setAttribute("pointer-events", "bounding-box"), this.applyAttributes(b, this.attributes), this.groupAttributes.push(Object.assign(Object.assign({}, this.groupAttributes[this.groupAttributes.length - 1]), this.attributes)), b;
            }
            closeGroup() {
                this.groups.pop(), this.groupAttributes.pop(), this.parent = this.groups[this.groups.length - 1];
            }
            add(t) {
                this.parent.appendChild(t);
            }
            setFillStyle(t) {
                return this.attributes.fill = t, this;
            }
            setBackgroundFillStyle(t) {
                return this.backgroundFillStyle = t, this;
            }
            setStrokeStyle(t) {
                return this.attributes.stroke = t, this;
            }
            setShadowColor(t) {
                return this.shadow_attributes.color = t, this;
            }
            setShadowBlur(t) {
                return this.shadow_attributes.width = t, this;
            }
            setLineWidth(t) {
                return this.attributes["stroke-width"] = t, this.lineWidth = t, this;
            }
            setLineDash(t) {
                if ("[object Array]" === Object.prototype.toString.call(t)) return this.attributes["stroke-dasharray"] = t.join(","), this;
                throw new g("ArgumentError", "lineDash must be an array of integers.");
            }
            setLineCap(t) {
                return this.attributes["stroke-linecap"] = t, this;
            }
            resize(t, e) {
                this.width = t, this.height = e, this.element.style.width = t.toString(), this.svg.style.width = t.toString(), this.svg.style.height = e.toString();
                const i = {
                    width: t,
                    height: e
                };
                return this.applyAttributes(this.svg, i), this.scale(this.state.scaleX, this.state.scaleY), this;
            }
            scale(t, e) {
                this.state.scaleX = this.state.scaleX ? this.state.scaleX * t : t, this.state.scaleY = this.state.scaleY ? this.state.scaleY * e : e;
                const i = this.width / this.state.scaleX, b = this.height / this.state.scaleY;
                return this.setViewBox(0, 0, i, b), this;
            }
            setViewBox(t, e, i, b) {
                if ("string" == typeof t) this.svg.setAttribute("viewBox", t);
                else {
                    const a = t + " " + e + " " + i + " " + b;
                    this.svg.setAttribute("viewBox", a);
                }
            }
            applyAttributes(t, e) {
                const i = Zt[t.nodeName];
                for(const b in e)i && i[b] || !e[b] || 0 != this.groupAttributes.length && e[b] == this.groupAttributes[this.groupAttributes.length - 1][b] || t.setAttributeNS(null, b, e[b]);
                return t;
            }
            clear() {
                for(; this.svg.lastChild;)this.svg.removeChild(this.svg.lastChild);
                this.scale(this.state.scaleX, this.state.scaleY);
            }
            rect(t, e, i, b, a) {
                b < 0 && (e += b, b *= -1);
                const n = this.create("rect");
                return a = null != a ? a : {
                    fill: "none",
                    "stroke-width": this.lineWidth,
                    stroke: "black"
                }, t = this.round(t), e = this.round(e), i = this.round(i), b = this.round(b), this.applyAttributes(n, Object.assign({
                    x: t,
                    y: e,
                    width: i,
                    height: b
                }, a)), this.add(n), this;
            }
            fillRect(t, e, i, b) {
                const a = {
                    fill: this.attributes.fill,
                    stroke: "none"
                };
                return this.rect(t, e, i, b, a), this;
            }
            clearRect(t, e, i, b) {
                return this.rect(t, e, i, b, {
                    fill: this.backgroundFillStyle,
                    stroke: "none"
                }), this;
            }
            beginPath() {
                return this.path = "", this.pen.x = NaN, this.pen.y = NaN, this;
            }
            moveTo(t, e) {
                return t = this.round(t), e = this.round(e), this.path += "M" + t + " " + e, this.pen.x = t, this.pen.y = e, this;
            }
            lineTo(t, e) {
                return t = this.round(t), e = this.round(e), this.path += "L" + t + " " + e, this.pen.x = t, this.pen.y = e, this;
            }
            bezierCurveTo(t, e, i, b, a, n) {
                return a = this.round(a), n = this.round(n), t = this.round(t), e = this.round(e), i = this.round(i), b = this.round(b), this.path += "C" + t + " " + e + "," + i + " " + b + "," + a + " " + n, this.pen.x = a, this.pen.y = n, this;
            }
            quadraticCurveTo(t, e, i, b) {
                return i = this.round(i), b = this.round(b), t = this.round(t), e = this.round(e), this.path += "Q" + t + " " + e + "," + i + " " + b, this.pen.x = i, this.pen.y = b, this;
            }
            arc(t, e, i, b, a, n) {
                let s = t + i * Math.cos(b), l = e + i * Math.sin(b);
                s = this.round(s), l = this.round(l);
                const o = v(b), r = v(a);
                if (!n && a - b >= ee || n && b - a >= ee || o === r) {
                    let a = t + i * Math.cos(b + Math.PI), n = e + i * Math.sin(b + Math.PI);
                    a = this.round(a), n = this.round(n), i = this.round(i), this.path += `M${s} ${l} A${i} ${i} 0 0 0 ${a} ${n} `, this.path += `A${i} ${i} 0 0 0 ${s} ${l}`, this.pen.x = s, this.pen.y = l;
                } else {
                    let h, m = t + i * Math.cos(a), c = e + i * Math.sin(a);
                    b = o, a = r, h = Math.abs(a - b) < Math.PI ? n : !n, b > a && (h = !h);
                    const d = !n;
                    m = this.round(m), c = this.round(c), i = this.round(i), this.path += `M${s} ${l} A${i} ${i} 0 ${+h} ${+d} ${m} ${c}`, this.pen.x = m, this.pen.y = c;
                }
                return this;
            }
            closePath() {
                return this.path += "Z", this;
            }
            getShadowStyle() {
                const t = this.shadow_attributes;
                return `filter: drop-shadow(0 0 ${t.width / 1.5}px ${t.color})`;
            }
            fill(t) {
                const e = this.create("path");
                return void 0 === t && (t = Object.assign(Object.assign({}, this.attributes), {
                    stroke: "none"
                })), t.d = this.path, this.shadow_attributes.width > 0 && (t.style = this.getShadowStyle()), this.applyAttributes(e, t), this.add(e), this;
            }
            stroke() {
                const t = this.create("path"), e = Object.assign(Object.assign({}, this.attributes), {
                    fill: "none",
                    "stroke-width": this.lineWidth,
                    d: this.path
                });
                return this.shadow_attributes.width > 0 && (e.style = this.getShadowStyle()), this.applyAttributes(t, e), this.add(t), this;
            }
            measureText(t) {
                return ie.measureTextCache.lookup(t, this.svg, this.attributes);
            }
            fillText(t, e, i) {
                if (!t || t.length <= 0) return this;
                e = this.round(e), i = this.round(i);
                const b = Object.assign(Object.assign({}, this.attributes), {
                    stroke: "none",
                    x: e,
                    y: i
                }), a = this.create("text");
                return a.textContent = t, this.applyAttributes(a, b), this.add(a), this;
            }
            save() {
                return this.state_stack.push({
                    state: {
                        "font-family": this.state["font-family"],
                        "font-weight": this.state["font-weight"],
                        "font-style": this.state["font-style"],
                        "font-size": this.state["font-size"],
                        scale: this.state.scale
                    },
                    attributes: {
                        "font-family": this.attributes["font-family"],
                        "font-weight": this.attributes["font-weight"],
                        "font-style": this.attributes["font-style"],
                        "font-size": this.attributes["font-size"],
                        fill: this.attributes.fill,
                        stroke: this.attributes.stroke,
                        "stroke-width": this.attributes["stroke-width"],
                        "stroke-dasharray": this.attributes["stroke-dasharray"]
                    },
                    shadow_attributes: {
                        width: this.shadow_attributes.width,
                        color: this.shadow_attributes.color
                    },
                    lineWidth: this.lineWidth
                }), this;
            }
            restore() {
                const t = this.state_stack.pop();
                if (t) {
                    const e = t;
                    this.state["font-family"] = e.state["font-family"], this.state["font-weight"] = e.state["font-weight"], this.state["font-style"] = e.state["font-style"], this.state["font-size"] = e.state["font-size"], this.state.scale = e.state.scale, this.attributes["font-family"] = e.attributes["font-family"], this.attributes["font-weight"] = e.attributes["font-weight"], this.attributes["font-style"] = e.attributes["font-style"], this.attributes["font-size"] = e.attributes["font-size"], this.attributes.fill = e.attributes.fill, this.attributes.stroke = e.attributes.stroke, this.attributes["stroke-width"] = e.attributes["stroke-width"], this.attributes["stroke-dasharray"] = e.attributes["stroke-dasharray"], this.shadow_attributes.width = e.shadow_attributes.width, this.shadow_attributes.color = e.shadow_attributes.color, this.lineWidth = e.lineWidth;
                }
                return this;
            }
            set fillStyle(t) {
                this.setFillStyle(t);
            }
            get fillStyle() {
                return this.attributes.fill;
            }
            set strokeStyle(t) {
                this.setStrokeStyle(t);
            }
            get strokeStyle() {
                return this.attributes.stroke;
            }
            setFont(t, e, i, b) {
                const a = F.validate(t, e, i, b);
                this.fontCSSString = F.toCSSString(a);
                const n = {
                    "font-family": a.family,
                    "font-size": a.size,
                    "font-weight": a.weight,
                    "font-style": a.style
                };
                return this.attributes = Object.assign(Object.assign({}, this.attributes), n), this.state = Object.assign(Object.assign({}, this.state), n), this;
            }
            getFont() {
                return this.fontCSSString;
            }
        }
        var be, ae, ne, se;
        ie.measureTextCache = new class {
            constructor(){
                this.cache = {};
            }
            lookup(t, e, i) {
                let b = this.cache[t];
                void 0 === b && (b = {}, this.cache[t] = b);
                const a = `${i["font-family"]}%${i["font-size"]}%${i["font-weight"]}%${i["font-style"]}`;
                let n = b[a];
                return void 0 === n && (n = this.measureImpl(t, e, i), b[a] = n), n;
            }
            measureImpl(t, e, i) {
                let b = this.txt;
                b || (b = document.createElementNS(te, "text"), this.txt = b), b.textContent = t, i["font-family"] && b.setAttributeNS(null, "font-family", i["font-family"]), i["font-size"] && b.setAttributeNS(null, "font-size", `${i["font-size"]}`), i["font-style"] && b.setAttributeNS(null, "font-style", i["font-style"]), i["font-weight"] && b.setAttributeNS(null, "font-weight", `${i["font-weight"]}`), e.appendChild(b);
                const a = b.getBBox();
                return e.removeChild(b), {
                    x: a.x,
                    y: a.y,
                    width: a.width,
                    height: a.height
                };
            }
        }, function(t) {
            t[t.CANVAS = 1] = "CANVAS", t[t.SVG = 2] = "SVG";
        }(be || (be = {})), function(t) {
            t[t.NONE = 1] = "NONE", t[t.UP = 2] = "UP", t[t.DOWN = 3] = "DOWN";
        }(ae || (ae = {}));
        class le {
            static buildContext(t, e, i, b, a = "#FFF") {
                const n = new le(t, e);
                i && b && n.resize(i, b);
                const s = n.getContext();
                return s.setBackgroundFillStyle(a), le.lastContext = s, s;
            }
            static getCanvasContext(t, e, i, b) {
                return le.buildContext(t, le.Backends.CANVAS, e, i, b);
            }
            static getSVGContext(t, e, i, b) {
                return le.buildContext(t, le.Backends.SVG, e, i, b);
            }
            static drawDashedLine(t, e, i, b, a, n) {
                t.beginPath();
                const s = b - e, l = a - i, o = Math.atan2(l, s);
                let r = e, h = i;
                t.moveTo(e, i);
                let m = 0, c = !0;
                for(; !(s < 0 ? r <= b : r >= b) || !(l < 0 ? h <= a : h >= a);){
                    const e = n[m++ % n.length], i = r + Math.cos(o) * e;
                    r = s < 0 ? Math.max(b, i) : Math.min(b, i);
                    const d = h + Math.sin(o) * e;
                    h = l < 0 ? Math.max(a, d) : Math.min(a, d), c ? t.lineTo(r, h) : t.moveTo(r, h), c = !c;
                }
                t.closePath(), t.stroke();
            }
            constructor(t, e){
                if (m(t)) this.ctx = t;
                else {
                    if (void 0 === e) throw new g("InvalidArgument", "Missing backend argument");
                    const i = e;
                    let b;
                    if ("string" == typeof t) {
                        const e = document.getElementById(t);
                        if (!e) throw new g("BadElementId", `Can't find element with ID "${e}"`);
                        b = e;
                    } else b = t;
                    if (i === le.Backends.CANVAS) {
                        if (!Jt(b)) throw new g("BadElement", "CANVAS context requires an HTMLCanvasElement.");
                        const t = b.getContext("2d", {
                            willReadFrequently: !0
                        });
                        if (!t) throw new g("BadElement", "Can't get canvas context");
                        this.ctx = new Qt(t);
                    } else {
                        if (i !== le.Backends.SVG) throw new g("InvalidBackend", `No support for backend: ${i}`);
                        if (!qt(b)) throw new g("BadElement", "SVG context requires an HTMLDivElement.");
                        this.ctx = new ie(b);
                    }
                }
            }
            resize(t, e) {
                return this.ctx.resize(t, e), this;
            }
            getContext() {
                return this.ctx;
            }
        }
        le.Backends = be, le.LineEndType = ae, le.lastContext = void 0;
        class oe extends tt {
            static get CATEGORY() {
                return x.StringNumber;
            }
            static get metrics() {
                var t;
                return null !== (t = V.currentMusicFont().getMetrics().stringNumber) && void 0 !== t ? t : {
                    verticalPadding: 0,
                    stemPadding: 0,
                    leftPadding: 0,
                    rightPadding: 0
                };
            }
            static format(t, e) {
                const i = e.left_shift, b = e.right_shift;
                if (!t || 0 === t.length) return !1;
                const a = [];
                let n = null, s = 0, l = 0;
                for(let i = 0; i < t.length; ++i){
                    const o = t[i], r = o.getNote(), h = o.getPosition();
                    if (!c(r)) throw new g("NoStaveNote");
                    const m = o.checkIndex(), d = r.getKeyProps()[m], _ = r.getModifierContext(), x = 2 * o.radius / V.STAVE_LINE_DISTANCE + .5;
                    if (_ && (h === J.ABOVE ? (o.text_line = _.getState().top_text_line, e.top_text_line += x) : h === J.BELOW && (o.text_line = _.getState().text_line, e.text_line += x)), r !== n) {
                        for(let t = 0; t < r.keys.length; ++t)h === tt.Position.LEFT && (s = Math.max(r.getLeftDisplacedHeadPx(), s)), 0 === b && (l = Math.max(r.getRightDisplacedHeadPx(), l));
                        n = r;
                    }
                    const y = d.line;
                    a.push({
                        pos: h,
                        note: r,
                        num: o,
                        line: y,
                        shiftL: s,
                        shiftR: l
                    });
                }
                a.sort((t, e)=>e.line - t.line);
                let o = 0, r = 0, h = 0, m = null, d = null;
                for(let t = 0; t < a.length; ++t){
                    const e = a[t].note, n = a[t].pos, l = a[t].num, c = a[t].line, _ = a[t].shiftR;
                    c === m && e === d || (o = b + _);
                    const x = l.getWidth() + 1;
                    let g = 0;
                    n === tt.Position.LEFT ? (l.setXShift(i + s), g = x, r = Math.max(g, r)) : n === tt.Position.RIGHT && (l.setXShift(o), g += x, h = g > h ? g : h), m = c, d = e;
                }
                return e.left_shift += r, e.right_shift += h, !0;
            }
            constructor(t){
                super(), this.string_number = t, this.position = tt.Position.ABOVE, this.x_shift = 0, this.y_shift = 0, this.text_line = 0, this.stem_offset = 0, this.x_offset = 0, this.y_offset = 0, this.dashed = !0, this.leg = le.LineEndType.NONE, this.radius = 8, this.drawCircle = !0, this.setWidth(2 * this.radius + 4), this.resetFont();
            }
            setLineEndType(t) {
                return t >= le.LineEndType.NONE && t <= le.LineEndType.DOWN && (this.leg = t), this;
            }
            setStringNumber(t) {
                return this.string_number = t, this;
            }
            setOffsetX(t) {
                return this.x_offset = t, this;
            }
            setOffsetY(t) {
                return this.y_offset = t, this;
            }
            setLastNote(t) {
                return this.last_note = t, this;
            }
            setDashed(t) {
                return this.dashed = t, this;
            }
            setDrawCircle(t) {
                return this.drawCircle = t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getModifierStartXY(this.position, this.index), b = e.hasStem() ? e.getStemDirection() : at.UP;
                let a = i.x + this.x_shift + this.x_offset, n = {};
                e.hasStem() && (n = e.checkStem().getExtents());
                let s = i.y + this.y_shift + this.y_offset;
                switch(this.position){
                    case tt.Position.ABOVE:
                        s = e.getYs().reduce((t, e)=>t < e ? t : e), e.hasStem() && b == at.UP && (s = n.topY + oe.metrics.stemPadding), s -= this.radius + oe.metrics.verticalPadding + this.text_line * V.STAVE_LINE_DISTANCE;
                        break;
                    case tt.Position.BELOW:
                        s = e.getYs().reduce((t, e)=>t > e ? t : e), e.hasStem() && b == at.DOWN && (s = n.topY - oe.metrics.stemPadding), s += this.radius + oe.metrics.verticalPadding + this.text_line * V.STAVE_LINE_DISTANCE;
                        break;
                    case tt.Position.LEFT:
                        a -= this.radius / 2 + oe.metrics.leftPadding;
                        break;
                    case tt.Position.RIGHT:
                        a += this.radius / 2 + oe.metrics.rightPadding;
                        break;
                    default:
                        throw new g("InvalidPosition", `The position ${this.position} is invalid`);
                }
                t.save(), this.drawCircle && (t.beginPath(), t.arc(a, s, this.radius, 0, 2 * Math.PI, !1), t.setLineWidth(1.5), t.stroke()), t.setFont(this.textFont);
                const l = a - t.measureText(this.string_number).width / 2;
                t.fillText("" + this.string_number, l, s + 4.5);
                const o = this.last_note;
                if (d(o)) {
                    const i = o.getStemX() - e.getX() + 5;
                    let b, n;
                    switch(t.setStrokeStyle("#000000"), t.setLineCap("round"), t.setLineWidth(.6), this.dashed ? le.drawDashedLine(t, a + 10, s, a + i, s, [
                        3,
                        3
                    ]) : le.drawDashedLine(t, a + 10, s, a + i, s, [
                        3,
                        0
                    ]), this.leg){
                        case le.LineEndType.UP:
                            b = -10, n = this.dashed ? [
                                3,
                                3
                            ] : [
                                3,
                                0
                            ], le.drawDashedLine(t, a + i, s, a + i, s + b, n);
                            break;
                        case le.LineEndType.DOWN:
                            b = 10, n = this.dashed ? [
                                3,
                                3
                            ] : [
                                3,
                                0
                            ], le.drawDashedLine(t, a + i, s, a + i, s + b, n);
                    }
                }
                t.restore();
            }
        }
        oe.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: F.SIZE,
            weight: E.BOLD,
            style: P.NORMAL
        };
        class re extends tt {
            static get CATEGORY() {
                return x.Stroke;
            }
            static format(t, e) {
                const i = e.left_shift;
                if (!t || 0 === t.length) return !1;
                const b = t.map((t)=>{
                    const e = t.getNote(), i = t.checkIndex();
                    if (c(e)) {
                        const { line: b } = e.getKeyProps()[i];
                        return {
                            line: b,
                            shift: e.getLeftDisplacedHeadPx(),
                            stroke: t
                        };
                    }
                    if (_(e)) {
                        const { str: b } = e.getPositions()[i];
                        return {
                            line: b,
                            shift: 0,
                            stroke: t
                        };
                    }
                    throw new g("Internal", "Unexpected instance.");
                }), a = i, n = b.reduce((t, { stroke: e, shift: i })=>(e.setXShift(a + i), Math.max(e.getWidth() + 0, t)), 0);
                return e.left_shift += n, !0;
            }
            constructor(t, e){
                super(), this.options = Object.assign({
                    all_voices: !0
                }, e), this.all_voices = this.options.all_voices, this.type = t, this.position = tt.Position.LEFT, this.render_options = {
                    font_scale: V.NOTATION_FONT_SCALE
                }, this.resetFont(), this.setXShift(0), this.setWidth(10);
            }
            getPosition() {
                return this.position;
            }
            addEndNote(t) {
                return this.note_end = t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getModifierStartXY(this.position, this.index);
                let b = e.getYs(), a = i.y, n = i.y;
                const s = i.x - 5, l = e.checkStave().getSpacingBetweenLines(), o = this.checkModifierContext().getMembers(e.getCategory());
                for(let t = 0; t < o.length; t++){
                    const e = o[t];
                    if (h(e)) {
                        b = e.getYs();
                        for(let e = 0; e < b.length; e++)(this.note === o[t] || this.all_voices) && (a = Math.min(a, b[e]), n = Math.max(n, b[e]));
                    }
                }
                let r = "", m = 0, d = 0, _ = 0, x = 0;
                switch(this.type){
                    case re.Type.BRUSH_DOWN:
                        r = "arrowheadBlackUp", m = -3, d = a - l / 2 + 10, n += l / 2;
                        break;
                    case re.Type.BRUSH_UP:
                        r = "arrowheadBlackDown", m = .5, d = n + l / 2, a -= l / 2;
                        break;
                    case re.Type.ROLL_DOWN:
                    case re.Type.RASQUEDO_DOWN:
                        r = "arrowheadBlackUp", m = -3, _ = this.x_shift + m - 2, c(e) ? (a += 1.5 * l, n += (n - a) % 2 != 0 ? .5 * l : l, d = a - l, x = n + l + 2) : (a += 1.5 * l, n += l, d = a - .75 * l, x = n + .25 * l);
                        break;
                    case re.Type.ROLL_UP:
                    case re.Type.RASQUEDO_UP:
                        r = "arrowheadBlackDown", m = -4, _ = this.x_shift + m - 1, c(e) ? (d = l / 2, a += .5 * l, (n - a) % 2 == 0 && (n += l / 2), d = n + .5 * l, x = a - 1.25 * l) : (a += .25 * l, n += .5 * l, d = n + .25 * l, x = a - l);
                        break;
                    case re.Type.ARPEGGIO_DIRECTIONLESS:
                        a += .5 * l, n += l;
                        break;
                    default:
                        throw new g("InvalidType", `The stroke type ${this.type} does not exist`);
                }
                let y = "straight";
                if (this.type === re.Type.BRUSH_DOWN || this.type === re.Type.BRUSH_UP) t.fillRect(s + this.x_shift, a, 1, n - a);
                else if (y = "wiggly", c(e)) for(let e = a; e <= n; e += l)Z.renderGlyph(t, s + this.x_shift - 4, e, this.render_options.font_scale, "vexWiggleArpeggioUp");
                else {
                    let e;
                    for(e = a; e <= n; e += 10)Z.renderGlyph(t, s + this.x_shift - 4, e, this.render_options.font_scale, "vexWiggleArpeggioUp");
                    this.type === re.Type.RASQUEDO_DOWN && (x = e + .25 * l);
                }
                this.type !== re.Type.ARPEGGIO_DIRECTIONLESS && (Z.renderGlyph(t, s + this.x_shift + m, d, this.render_options.font_scale, r, {
                    category: `stroke_${y}.${r}`
                }), this.type !== re.Type.RASQUEDO_DOWN && this.type !== re.Type.RASQUEDO_UP || (t.save(), t.setFont(this.textFont), t.fillText("R", s + _, x), t.restore()));
            }
        }
        re.Type = {
            BRUSH_DOWN: 1,
            BRUSH_UP: 2,
            ROLL_DOWN: 3,
            ROLL_UP: 4,
            RASQUEDO_DOWN: 5,
            RASQUEDO_UP: 6,
            ARPEGGIO_DIRECTIONLESS: 7
        }, re.TEXT_FONT = {
            family: F.SERIF,
            size: F.SIZE,
            weight: E.BOLD,
            style: P.ITALIC
        };
        class he extends tt {
            static get CATEGORY() {
                return x.Vibrato;
            }
            static format(t, e, i) {
                if (!t || 0 === t.length) return !1;
                let b = e.top_text_line, a = 0, n = e.right_shift - 7;
                const s = i.getMembers(Nt.CATEGORY);
                if (s && s.length > 0) b -= s.map((t)=>t.getTextHeight()).reduce((t, e)=>t > e ? t : e) / V.STAVE_LINE_DISTANCE + 1;
                else e.top_text_line += 1;
                for(let e = 0; e < t.length; ++e){
                    const i = t[e];
                    i.setXShift(n), i.setTextLine(b), a += i.getWidth(), n += a;
                }
                return e.right_shift += a, !0;
            }
            constructor(){
                super(), this.position = tt.Position.RIGHT, this.render_options = {
                    harsh: !1,
                    vibrato_width: 20,
                    wave_height: 6,
                    wave_width: 4,
                    wave_girth: 2
                }, this.setVibratoWidth(this.render_options.vibrato_width);
            }
            setHarsh(t) {
                return this.render_options.harsh = t, this;
            }
            setVibratoWidth(t) {
                return this.render_options.vibrato_width = t, this.setWidth(t), this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getModifierStartXY(tt.Position.RIGHT, this.index).x + this.x_shift, b = e.getYForTopText(this.text_line) + 2;
                he.renderVibrato(t, i, b, this.render_options);
            }
            static renderVibrato(t, e, i, b) {
                const { harsh: a, vibrato_width: n, wave_width: s, wave_girth: l, wave_height: o } = b, r = n / s;
                let h;
                if (t.beginPath(), a) {
                    for(t.moveTo(e, i + l + 1), h = 0; h < r / 2; ++h)t.lineTo(e + s, i - o / 2), e += s, t.lineTo(e + s, i + o / 2), e += s;
                    for(h = 0; h < r / 2; ++h)t.lineTo(e - s, i - o / 2 + l + 1), e -= s, t.lineTo(e - s, i + o / 2 + l + 1), e -= s;
                    t.fill();
                } else {
                    for(t.moveTo(e, i + l), h = 0; h < r / 2; ++h)t.quadraticCurveTo(e + s / 2, i - o / 2, e + s, i), e += s, t.quadraticCurveTo(e + s / 2, i + o / 2, e + s, i), e += s;
                    for(h = 0; h < r / 2; ++h)t.quadraticCurveTo(e - s / 2, i + o / 2 + l, e - s, i + l), e -= s, t.quadraticCurveTo(e - s / 2, i - o / 2 + l, e - s, i + l), e -= s;
                    t.fill();
                }
            }
        }
        function me(...t) {
            ce.DEBUG && u("Vex.Flow.ModifierContext", t);
        }
        class ce {
            constructor(){
                this.state = {
                    left_shift: 0,
                    right_shift: 0,
                    text_line: 0,
                    top_text_line: 0
                }, this.members = {}, this.preFormatted = !1, this.postFormatted = !1, this.formatted = !1, this.width = 0, this.spacing = 0;
            }
            addModifier(t) {
                return me("addModifier is deprecated, use addMember instead."), this.addMember(t);
            }
            addMember(t) {
                const e = t.getCategory();
                return this.members[e] || (this.members[e] = []), this.members[e].push(t), t.setModifierContext(this), this.preFormatted = !1, this;
            }
            getModifiers(t) {
                return me("getModifiers is deprecated, use getMembers instead."), this.getMembers(t);
            }
            getMembers(t) {
                var e;
                return null !== (e = this.members[t]) && void 0 !== e ? e : [];
            }
            getWidth() {
                return this.width;
            }
            getLeftShift() {
                return this.state.left_shift;
            }
            getRightShift() {
                return this.state.right_shift;
            }
            getState() {
                return this.state;
            }
            getMetrics() {
                if (!this.formatted) throw new g("UnformattedMember", "Unformatted member has no metrics.");
                return {
                    width: this.state.left_shift + this.state.right_shift + this.spacing,
                    spacing: this.spacing
                };
            }
            preFormat() {
                if (this.preFormatted) return;
                me("Preformatting ModifierContext");
                const t = this.state, e = this.members;
                It.format(e[x.StaveNote], t), $t.format(e[x.Parenthesis], t), Ot.format(e[x.Dot], t), Rt.format(e[x.FretHandFinger], t), bt.format(e[x.Accidental], t), re.format(e[x.Stroke], t), jt.format(e[x.GraceNoteGroup], t), Vt.format(e[x.NoteSubGroup], t), oe.format(e[x.StringNumber], t), ut.format(e[x.Articulation], t), Kt.format(e[x.Ornament], t), ct.format(e[x.Annotation], t), Mt.format(e[x.ChordSymbol], t), Nt.format(e[x.Bend], t), he.format(e[x.Vibrato], t, this), this.width = t.left_shift + t.right_shift, this.preFormatted = !0;
            }
            postFormat() {
                this.postFormatted || (me("Postformatting ModifierContext"), It.postFormat(this.getMembers(x.StaveNote)));
            }
        }
        ce.DEBUG = !1;
        class de extends Pt {
            static get CATEGORY() {
                return x.Clef;
            }
            static get types() {
                return {
                    treble: {
                        code: "gClef",
                        line: 3
                    },
                    bass: {
                        code: "fClef",
                        line: 1
                    },
                    alto: {
                        code: "cClef",
                        line: 2
                    },
                    tenor: {
                        code: "cClef",
                        line: 1
                    },
                    percussion: {
                        code: "unpitchedPercussionClef1",
                        line: 2
                    },
                    soprano: {
                        code: "cClef",
                        line: 4
                    },
                    "mezzo-soprano": {
                        code: "cClef",
                        line: 3
                    },
                    "baritone-c": {
                        code: "cClef",
                        line: 0
                    },
                    "baritone-f": {
                        code: "fClef",
                        line: 2
                    },
                    subbass: {
                        code: "fClef",
                        line: 0
                    },
                    french: {
                        code: "gClef",
                        line: 4
                    },
                    tab: {
                        code: "6stringTabClef",
                        line: 2.5
                    }
                };
            }
            static get annotationSmufl() {
                return {
                    "8va": "timeSig8",
                    "8vb": "timeSig8"
                };
            }
            constructor(t, e, i){
                super(), this.clef = de.types.treble, this.setPosition(wt.BEGIN), this.setType(t, e, i), this.setWidth(Z.getWidth(this.clef.code, de.getPoint(this.size), `clef_${this.size}`)), function(...t) {
                    de.DEBUG && u("Vex.Flow.Clef", t);
                }("Creating clef:", t);
            }
            setType(t, e, i) {
                this.type = t, this.clef = de.types[t], this.size = void 0 === e ? "default" : e;
                const b = V.currentMusicFont();
                if (void 0 !== i) {
                    const t = de.annotationSmufl[i], e = de.getPoint(this.size) / 5 * 3, a = b.lookupMetric(`clef_${this.size}.annotations.${i}.${this.type}.line`), n = b.lookupMetric(`clef_${this.size}.annotations.${i}.${this.type}.shiftX`);
                    this.annotation = {
                        code: t,
                        point: e,
                        line: a,
                        x_shift: n
                    }, this.attachment = new Z(this.annotation.code, this.annotation.point), this.attachment.metrics.x_max = 0, this.attachment.setXShift(this.annotation.x_shift);
                } else this.annotation = void 0;
                return this;
            }
            getWidth() {
                return "tab" === this.type && p(this.stave, "ClefError", "Can't get width without stave."), this.width;
            }
            static getPoint(t) {
                return "default" == t ? V.NOTATION_FONT_SCALE : V.NOTATION_FONT_SCALE / 3 * 2;
            }
            setStave(t) {
                return this.stave = t, this;
            }
            draw() {
                const t = this.checkStave(), e = t.checkContext();
                this.setRendered(), this.applyStyle(e), e.openGroup("clef", this.getAttribute("id")), Z.renderGlyph(e, this.x, t.getYForLine(this.clef.line), de.getPoint(this.size), this.clef.code, {
                    category: `clef_${this.size}`
                }), void 0 !== this.annotation && void 0 !== this.attachment && (this.placeGlyphOnLine(this.attachment, t, this.annotation.line), this.attachment.setStave(t), this.attachment.setContext(e), this.attachment.renderToStave(this.x)), e.closeGroup(), this.restoreStyle(e);
            }
        }
        de.DEBUG = !1;
        class _e extends Pt {
            static get CATEGORY() {
                return x.KeySignature;
            }
            constructor(t, e, i){
                super(), this.accList = [], this.setKeySig(t, e, i), this.setPosition(wt.BEGIN), this.glyphFontScale = V.NOTATION_FONT_SCALE, this.glyphs = [], this.xPositions = [], this.paddingForced = !1;
            }
            convertToGlyph(t, e) {
                const i = V.accidentalCodes(t.type), b = new Z(i.code, this.glyphFontScale);
                let a = 1;
                if ("n" === t.type && e) {
                    const i = _e.accidentalSpacing[e.type];
                    if (i) a = e.line >= t.line ? i.above : i.below;
                }
                this.placeGlyphOnLine(b, this.checkStave(), t.line), this.glyphs.push(b);
                const n = this.xPositions[this.xPositions.length - 1], s = b.getMetrics().width + a;
                this.xPositions.push(n + s), this.width += s;
            }
            cancelKey(t) {
                return this.formatted = !1, this.cancelKeySpec = t, this;
            }
            convertToCancelAccList(t) {
                const e = V.keySignature(t), i = this.accList.length > 0 && e.length > 0 && e[0].type !== this.accList[0].type, b = i ? e.length : e.length - this.accList.length;
                if (b < 1) return;
                const a = [];
                for(let t = 0; t < b; t++){
                    let n = t;
                    i || (n = e.length - b + t);
                    const s = e[n];
                    a.push({
                        type: "n",
                        line: s.line
                    });
                }
                return this.accList = a.concat(this.accList), {
                    accList: a,
                    type: e[0].type
                };
            }
            addToStave(t) {
                return this.paddingForced = !0, t.addModifier(this), this;
            }
            convertAccLines(t, e, i = this.accList) {
                let b, a, n = 0;
                switch(t){
                    case "soprano":
                        "#" === e ? b = [
                            2.5,
                            .5,
                            2,
                            0,
                            1.5,
                            -0.5,
                            1
                        ] : n = -1;
                        break;
                    case "mezzo-soprano":
                        "b" === e ? b = [
                            0,
                            2,
                            .5,
                            2.5,
                            1,
                            3,
                            1.5
                        ] : n = 1.5;
                        break;
                    case "alto":
                        n = .5;
                        break;
                    case "tenor":
                        "#" === e ? b = [
                            3,
                            1,
                            2.5,
                            .5,
                            2,
                            0,
                            1.5
                        ] : n = -0.5;
                        break;
                    case "baritone-f":
                    case "baritone-c":
                        "b" === e ? b = [
                            .5,
                            2.5,
                            1,
                            3,
                            1.5,
                            3.5,
                            2
                        ] : n = 2;
                        break;
                    case "bass":
                    case "french":
                        n = 1;
                }
                if (void 0 !== b) for(a = 0; a < i.length; ++a)i[a].line = b[a];
                else if (0 !== n) for(a = 0; a < i.length; ++a)i[a].line += n;
            }
            getPadding(t) {
                return this.formatted || this.format(), 0 === this.glyphs.length || !this.paddingForced && t < 2 ? 0 : this.padding;
            }
            getWidth() {
                return this.formatted || this.format(), this.width;
            }
            setKeySig(t, e, i) {
                return this.formatted = !1, this.keySpec = t, this.cancelKeySpec = e, this.alterKeySpec = i, this;
            }
            alterKey(t) {
                return this.formatted = !1, this.alterKeySpec = t, this;
            }
            convertToAlterAccList(t) {
                const e = Math.min(t.length, this.accList.length);
                for(let i = 0; i < e; ++i)t[i] && (this.accList[i].type = t[i]);
            }
            format() {
                const t = this.checkStave();
                this.width = 0, this.glyphs = [], this.xPositions = [
                    0
                ], this.accList = V.keySignature(p(this.keySpec));
                const e = this.accList, i = e.length > 0 ? e[0].type : void 0;
                let b;
                if (this.cancelKeySpec && (b = this.convertToCancelAccList(this.cancelKeySpec)), this.alterKeySpec && this.convertToAlterAccList(this.alterKeySpec), this.accList.length > 0) {
                    const a = (this.position === wt.END ? t.getEndClef() : t.getClef()) || t.getClef();
                    b && this.convertAccLines(a, b.type, b.accList), this.convertAccLines(a, i, e);
                    for(let t = 0; t < this.accList.length; ++t)this.convertToGlyph(this.accList[t], this.accList[t + 1]);
                }
                this.formatted = !0;
            }
            getGlyphs() {
                return this.formatted || this.format(), this.glyphs;
            }
            draw() {
                const t = this.checkStave(), e = t.checkContext();
                this.formatted || this.format(), this.setRendered(), this.applyStyle(e), e.openGroup("keysignature", this.getAttribute("id"));
                for(let i = 0; i < this.glyphs.length; i++){
                    const b = this.glyphs[i], a = this.x + this.xPositions[i];
                    b.setStave(t), b.setContext(e), b.renderToStave(a);
                }
                e.closeGroup(), this.restoreStyle(e);
            }
        }
        _e.accidentalSpacing = {
            "#": {
                above: 6,
                below: 4
            },
            b: {
                above: 4,
                below: 7
            },
            n: {
                above: 4,
                below: 1
            },
            "##": {
                above: 6,
                below: 4
            },
            bb: {
                above: 4,
                below: 7
            },
            db: {
                above: 4,
                below: 7
            },
            d: {
                above: 4,
                below: 7
            },
            bbs: {
                above: 4,
                below: 7
            },
            "++": {
                above: 6,
                below: 4
            },
            "+": {
                above: 6,
                below: 4
            },
            "+-": {
                above: 6,
                below: 4
            },
            "++-": {
                above: 6,
                below: 4
            },
            bs: {
                above: 4,
                below: 10
            },
            bss: {
                above: 4,
                below: 10
            }
        };
        class xe extends Pt {
            static get CATEGORY() {
                return x.Repetition;
            }
            constructor(t, e, i){
                super(), this.symbol_type = t, this.x = e, this.x_shift = 0, this.y_shift = i, this.resetFont();
            }
            setShiftX(t) {
                return this.x_shift = t, this;
            }
            setShiftY(t) {
                return this.y_shift = t, this;
            }
            draw(t, e) {
                switch(this.setRendered(), this.symbol_type){
                    case xe.type.CODA_RIGHT:
                        this.drawCodaFixed(t, e + t.getWidth());
                        break;
                    case xe.type.CODA_LEFT:
                        this.drawSymbolText(t, e, "Coda", !0);
                        break;
                    case xe.type.SEGNO_LEFT:
                        this.drawSignoFixed(t, e);
                        break;
                    case xe.type.SEGNO_RIGHT:
                        this.drawSignoFixed(t, e + t.getWidth());
                        break;
                    case xe.type.DC:
                        this.drawSymbolText(t, e, "D.C.", !1);
                        break;
                    case xe.type.DC_AL_CODA:
                        this.drawSymbolText(t, e, "D.C. al", !0);
                        break;
                    case xe.type.DC_AL_FINE:
                        this.drawSymbolText(t, e, "D.C. al Fine", !1);
                        break;
                    case xe.type.DS:
                        this.drawSymbolText(t, e, "D.S.", !1);
                        break;
                    case xe.type.DS_AL_CODA:
                        this.drawSymbolText(t, e, "D.S. al", !0);
                        break;
                    case xe.type.DS_AL_FINE:
                        this.drawSymbolText(t, e, "D.S. al Fine", !1);
                        break;
                    case xe.type.FINE:
                        this.drawSymbolText(t, e, "Fine", !1);
                        break;
                    case xe.type.TO_CODA:
                        this.drawSymbolText(t, e, "To", !0);
                }
                return this;
            }
            drawCodaFixed(t, e) {
                const i = t.getYForTopText(t.getNumLines()) + this.y_shift;
                return Z.renderGlyph(t.checkContext(), this.x + e + this.x_shift, i + V.currentMusicFont().lookupMetric("staveRepetition.coda.offsetY"), 40, "coda", {
                    category: "coda"
                }), this;
            }
            drawSignoFixed(t, e) {
                const i = t.getYForTopText(t.getNumLines()) + this.y_shift;
                return Z.renderGlyph(t.checkContext(), this.x + e + this.x_shift, i + V.currentMusicFont().lookupMetric("staveRepetition.segno.offsetY"), 30, "segno", {
                    category: "segno"
                }), this;
            }
            drawSymbolText(t, e, i, b) {
                var a;
                const n = t.checkContext();
                n.save(), n.setFont(this.textFont);
                let s = 0, l = 0;
                const o = t.getNoteStartX() - this.x;
                switch(this.symbol_type){
                    case xe.type.CODA_LEFT:
                        s = this.x + t.getVerticalBarWidth(), l = s + n.measureText(i).width + V.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetX");
                        break;
                    case xe.type.DC:
                    case xe.type.DC_AL_FINE:
                    case xe.type.DS:
                    case xe.type.DS_AL_FINE:
                    case xe.type.FINE:
                        s = this.x + e + this.x_shift + t.getWidth() - V.currentMusicFont().lookupMetric("staveRepetition.symbolText.spacing") - o - n.measureText(i).width;
                        break;
                    default:
                        s = this.x + e + this.x_shift + t.getWidth() - V.currentMusicFont().lookupMetric("staveRepetition.symbolText.spacing") - o - n.measureText(i).width - V.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetX"), l = s + n.measureText(i).width + V.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetX");
                }
                const r = t.getYForTopText(t.getNumLines()) + this.y_shift + V.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetY");
                return b && Z.renderGlyph(n, l, r, 2 * F.convertSizeToPointValue(null === (a = this.textFont) || void 0 === a ? void 0 : a.size), "coda", {
                    category: "coda"
                }), n.fillText(i, s, r + 5), n.restore(), this;
            }
        }
        xe.TEXT_FONT = {
            family: F.SERIF,
            size: V.NOTATION_FONT_SCALE / 3,
            weight: E.BOLD,
            style: P.NORMAL
        }, xe.type = {
            NONE: 1,
            CODA_LEFT: 2,
            CODA_RIGHT: 3,
            SEGNO_LEFT: 4,
            SEGNO_RIGHT: 5,
            DC: 6,
            DC_AL_CODA: 7,
            DC_AL_FINE: 8,
            DS: 9,
            DS_AL_CODA: 10,
            DS_AL_FINE: 11,
            FINE: 12,
            TO_CODA: 13
        };
        class ge extends Pt {
            static get CATEGORY() {
                return x.StaveSection;
            }
            constructor(t, e, i, b = !0){
                super(), this.setWidth(16), this.section = t, this.x = e, this.shift_x = 0, this.shift_y = i, this.drawRect = b, this.resetFont();
            }
            setStaveSection(t) {
                return this.section = t, this;
            }
            setShiftX(t) {
                return this.shift_x = t, this;
            }
            setShiftY(t) {
                return this.shift_y = t, this;
            }
            draw(t, e) {
                const i = t.checkContext();
                this.setRendered(), i.save(), i.setLineWidth(2), i.setFont(this.textFont);
                const b = rt.create(this.textFont), a = b.getWidthForTextInPx(this.section), n = b.getYForStringInPx(this.section), s = n.height, l = -1 * n.yMin, o = a + 4, r = s + 4, h = t.getYForTopText(1.5) + this.shift_y, m = this.x + e;
                return this.drawRect && (i.beginPath(), i.rect(m, h - r + l, o, r), i.stroke()), i.fillText(this.section, m + 2, h - 2), i.restore(), this;
            }
        }
        ge.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: 10,
            weight: E.BOLD,
            style: P.NORMAL
        };
        class ye extends Pt {
            static get CATEGORY() {
                return x.StaveTempo;
            }
            constructor(t, e, i){
                super(), this.render_options = {
                    glyph_font_scale: 30
                }, this.tempo = t, this.position = wt.ABOVE, this.x = e, this.shift_x = 10, this.shift_y = i, this.resetFont();
            }
            setTempo(t) {
                return this.tempo = t, this;
            }
            setShiftX(t) {
                return this.shift_x = t, this;
            }
            setShiftY(t) {
                return this.shift_y = t, this;
            }
            draw(t, e) {
                const i = t.checkContext();
                this.setRendered();
                const b = this.render_options, a = b.glyph_font_scale / V.NOTATION_FONT_SCALE, n = this.tempo.name, s = this.tempo.duration, l = this.tempo.dots || 0, o = this.tempo.bpm;
                let r = this.x + this.shift_x + e;
                const h = t.getYForTopText(1) + this.shift_y;
                i.save();
                const m = rt.create(this.textFont);
                if (n && (i.setFont(this.textFont), i.fillText(n, r, h), r += m.getWidthForTextInPx(n)), s && o) {
                    const t = Object.assign(Object.assign({}, this.textFont), {
                        weight: "normal",
                        style: "normal"
                    });
                    i.setFont(t);
                    const e = rt.create(t);
                    n && (r += e.getWidthForTextInPx("|"), i.fillText("(", r, h), r += e.getWidthForTextInPx("("));
                    const m = V.getGlyphProps(s);
                    if (r += 3 * a, Z.renderGlyph(i, r, h, b.glyph_font_scale, m.code_head), r += Z.getWidth(m.code_head, b.glyph_font_scale), m.stem) {
                        let t = 30;
                        m.beam_count && (t += 3 * (m.beam_count - 1)), t *= a;
                        const e = h - t;
                        if (i.fillRect(r - a, e, a, t), m.code && m.code_flag_upstem) {
                            const t = Z.renderGlyph(i, r, e, b.glyph_font_scale, m.code_flag_upstem, {
                                category: "flag.staveTempo"
                            });
                            r += t.width * V.NOTATION_FONT_SCALE / t.font.getData().resolution;
                        }
                    }
                    for(let t = 0; t < l; t++)r += 6 * a, i.beginPath(), i.arc(r, h + 2 * a, 2 * a, 0, 2 * Math.PI, !1), i.fill();
                    i.fillText(" = " + o + (n ? ")" : ""), r + 3 * a, h);
                }
                return i.restore(), this;
            }
        }
        ye.TEXT_FONT = {
            family: F.SERIF,
            size: 14,
            weight: E.BOLD,
            style: P.NORMAL
        }, function(t) {
            t[t.LEFT = 1] = "LEFT", t[t.CENTER = 2] = "CENTER", t[t.RIGHT = 3] = "RIGHT";
        }(ne || (ne = {}));
        class pe extends vt {
            static get CATEGORY() {
                return x.TextNote;
            }
            static get GLYPHS() {
                return {
                    segno: {
                        code: "segno"
                    },
                    tr: {
                        code: "ornamentTrill"
                    },
                    mordent: {
                        code: "ornamentMordent"
                    },
                    mordent_upper: {
                        code: "ornamentShortTrill"
                    },
                    mordent_lower: {
                        code: "ornamentMordent"
                    },
                    f: {
                        code: "dynamicForte"
                    },
                    p: {
                        code: "dynamicPiano"
                    },
                    m: {
                        code: "dynamicMezzo"
                    },
                    s: {
                        code: "dynamicSforzando"
                    },
                    z: {
                        code: "dynamicZ"
                    },
                    coda: {
                        code: "coda"
                    },
                    pedal_open: {
                        code: "keyboardPedalPed"
                    },
                    pedal_close: {
                        code: "keyboardPedalUp"
                    },
                    caesura_straight: {
                        code: "caesura"
                    },
                    caesura_curved: {
                        code: "caesuraCurved"
                    },
                    breath: {
                        code: "breathMarkComma"
                    },
                    tick: {
                        code: "breathMarkTick"
                    },
                    turn: {
                        code: "ornamentTurn"
                    },
                    turn_inverted: {
                        code: "ornamentTurnSlash"
                    }
                };
            }
            constructor(t){
                if (super(t), this.text = t.text || "", this.superscript = t.superscript, this.subscript = t.subscript, this.setFont(t.font), this.line = t.line || 0, this.smooth = t.smooth || !1, this.ignore_ticks = t.ignore_ticks || !1, this.justification = ne.LEFT, t.glyph) {
                    const e = pe.GLYPHS[t.glyph];
                    if (!e) throw new g("Invalid glyph type: " + t.glyph);
                    this.glyph = new Z(e.code, V.NOTATION_FONT_SCALE, {
                        category: "textNote"
                    }), this.setWidth(this.glyph.getMetrics().width);
                } else this.glyph = void 0;
            }
            setJustification(t) {
                return this.justification = t, this;
            }
            setLine(t) {
                return this.line = t, this;
            }
            getLine() {
                return this.line;
            }
            getText() {
                return this.text;
            }
            preFormat() {
                if (this.preFormatted) return;
                const t = this.checkTickContext("Can't preformat without a TickContext.");
                if (this.smooth) this.setWidth(0);
                else if (this.glyph) ;
                else {
                    const t = this.checkContext();
                    t.setFont(this.textFont), this.setWidth(t.measureText(this.text).width);
                }
                this.justification === ne.CENTER ? this.leftDisplacedHeadPx = this.width / 2 : this.justification === ne.RIGHT && (this.leftDisplacedHeadPx = this.width), this.rightDisplacedHeadPx = t.getMetrics().glyphPx / 2, this.preFormatted = !0;
            }
            draw() {
                const t = this.checkContext(), e = this.checkStave(), i = this.checkTickContext("Can't draw without a TickContext.");
                this.setRendered();
                let b = this.getAbsoluteX() + i.getMetrics().glyphPx / 2;
                const a = this.getWidth();
                let n;
                if (this.justification === ne.CENTER ? b -= a / 2 : this.justification === ne.RIGHT && (b -= a), this.glyph) n = e.getYForLine(this.line + -3), this.glyph.render(t, b, n);
                else {
                    n = e.getYForLine(this.line + -3), this.applyStyle(t), t.setFont(this.textFont), t.fillText(this.text, b, n);
                    const i = t.measureText(this.text).height, { family: a, size: s, weight: l, style: o } = this.textFont, r = F.scaleSize(s, .769231);
                    this.superscript && (t.setFont(a, r, l, o), t.fillText(this.superscript, b + this.width + 2, n - i / 2.2)), this.subscript && (t.setFont(a, r, l, o), t.fillText(this.subscript, b + this.width + 2, n + i / 2.2 - 1)), this.restoreStyle(t);
                }
            }
        }
        pe.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: 12,
            weight: E.NORMAL,
            style: P.NORMAL
        }, pe.Justification = ne;
        class ue extends Pt {
            static get CATEGORY() {
                return x.StaveText;
            }
            constructor(t, e, i = {}){
                super(), this.setWidth(16), this.text = t, this.position = e, this.options = Object.assign({
                    shift_x: 0,
                    shift_y: 0,
                    justification: pe.Justification.CENTER
                }, i), this.resetFont();
            }
            setStaveText(t) {
                return this.text = t, this;
            }
            setShiftX(t) {
                return this.shift_x = t, this;
            }
            setShiftY(t) {
                return this.shift_y = t, this;
            }
            setText(t) {
                return this.text = t, this;
            }
            draw(t) {
                const e = t.checkContext();
                this.setRendered(), e.save(), e.setLineWidth(2), e.setFont(this.textFont);
                const i = e.measureText("" + this.text).width;
                let b, a;
                switch(this.position){
                    case wt.LEFT:
                    case wt.RIGHT:
                        a = (t.getYForLine(0) + t.getBottomLineY()) / 2 + this.options.shift_y, b = this.position === wt.LEFT ? t.getX() - i - 24 + this.options.shift_x : t.getX() + t.getWidth() + 24 + this.options.shift_x;
                        break;
                    case wt.ABOVE:
                    case wt.BELOW:
                        b = t.getX() + this.options.shift_x, this.options.justification === ne.CENTER ? b += t.getWidth() / 2 - i / 2 : this.options.justification === ne.RIGHT && (b += t.getWidth() - i), a = this.position === wt.ABOVE ? t.getYForTopText(2) + this.options.shift_y : t.getYForBottomText(2) + this.options.shift_y;
                        break;
                    default:
                        throw new g("InvalidPosition", "Value Must be in Modifier.Position.");
                }
                return e.fillText("" + this.text, b, a + 4), e.restore(), this;
            }
        }
        ue.TEXT_FONT = {
            family: F.SERIF,
            size: 16,
            weight: E.NORMAL,
            style: P.NORMAL
        }, function(t) {
            t[t.NONE = 1] = "NONE", t[t.BEGIN = 2] = "BEGIN", t[t.MID = 3] = "MID", t[t.END = 4] = "END", t[t.BEGIN_END = 5] = "BEGIN_END";
        }(se || (se = {}));
        class fe extends Pt {
            static get CATEGORY() {
                return x.Volta;
            }
            static get type() {
                return se;
            }
            constructor(t, e, i, b){
                super(), this.volta = t, this.x = i, this.y_shift = b, this.number = e, this.resetFont();
            }
            setShiftY(t) {
                return this.y_shift = t, this;
            }
            draw(t, e) {
                const i = t.checkContext();
                this.setRendered();
                let b = t.getWidth() - e;
                const a = t.getYForTopText(t.getNumLines()) + this.y_shift, n = 1.5 * t.getSpacingBetweenLines();
                switch(this.volta){
                    case se.BEGIN:
                        i.fillRect(this.x + e, a, 1, n);
                        break;
                    case se.END:
                        b -= 5, i.fillRect(this.x + e + b, a, 1, n);
                        break;
                    case se.BEGIN_END:
                        b -= 3, i.fillRect(this.x + e, a, 1, n), i.fillRect(this.x + e + b, a, 1, n);
                }
                return this.volta !== se.BEGIN && this.volta !== se.BEGIN_END || (i.save(), i.setFont(this.textFont), i.fillText(this.number, this.x + e + 5, a + 15), i.restore()), i.fillRect(this.x + e, a, b, 1), this;
            }
        }
        fe.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: 9,
            weight: E.BOLD,
            style: P.NORMAL
        };
        class Se extends Z {
            constructor(t, e, i, b, a, n){
                var s;
                super(b, a, n), this.timeSignature = t, this.topGlyphs = [], this.botGlyphs = [];
                let l = 0, o = 0;
                for(let t = 0; t < e.length; ++t){
                    let b = e[t];
                    switch(e[t]){
                        case "-":
                            b = "Minus";
                            break;
                        case "+":
                            b = i.length > 0 ? "PlusSmall" : "Plus";
                            break;
                        case "(":
                            b = i.length > 0 ? "ParensLeftSmall" : "ParensLeft";
                            break;
                        case ")":
                            b = i.length > 0 ? "ParensRightSmall" : "ParensRight";
                    }
                    const a = new Z("timeSig" + b, this.timeSignature.point);
                    this.topGlyphs.push(a), l += null !== (s = a.getMetrics().width) && void 0 !== s ? s : 0, o = Math.max(o, a.getMetrics().height);
                }
                let r = 0;
                for(let t = 0; t < i.length; ++t){
                    let e = i[t];
                    switch(i[t]){
                        case "+":
                            e = "PlusSmall";
                            break;
                        case "(":
                            e = "ParensLeftSmall";
                            break;
                        case ")":
                            e = "ParensRightSmall";
                    }
                    const b = new Z("timeSig" + e, this.timeSignature.point);
                    this.botGlyphs.push(b), r += p(b.getMetrics().width), o = Math.max(o, b.getMetrics().height);
                }
                this.lineShift = o > 22 ? 1 : 0, this.width = Math.max(l, r), this.xMin = this.getMetrics().x_min, this.topStartX = (this.width - l) / 2, this.botStartX = (this.width - r) / 2, this.reset();
            }
            getMetrics() {
                return {
                    x_min: this.xMin,
                    x_max: this.xMin + this.width,
                    width: this.width
                };
            }
            renderToStave(t) {
                const e = this.checkStave(), i = this.checkContext();
                let b = t + this.topStartX, a = 0;
                a = this.botGlyphs.length > 0 ? e.getYForLine(this.timeSignature.topLine - this.lineShift) : (e.getYForLine(this.timeSignature.topLine) + e.getYForLine(this.timeSignature.bottomLine)) / 2;
                for(let t = 0; t < this.topGlyphs.length; ++t){
                    const e = this.topGlyphs[t];
                    Z.renderOutline(i, e.getMetrics().outline, this.scale, b + this.x_shift, a), b += p(e.getMetrics().width);
                }
                b = t + this.botStartX, a = e.getYForLine(this.timeSignature.bottomLine + this.lineShift);
                for(let t = 0; t < this.botGlyphs.length; ++t){
                    const n = this.botGlyphs[t];
                    this.timeSignature.placeGlyphOnLine(n, e, this.timeSignature.getLine()), Z.renderOutline(i, n.getMetrics().outline, this.scale, b + n.getMetrics().x_shift, a), b += p(n.getMetrics().width);
                }
            }
        }
        class Te extends Pt {
            static get CATEGORY() {
                return x.TimeSignature;
            }
            static get glyphs() {
                return {
                    C: {
                        code: "timeSigCommon",
                        line: 2
                    },
                    "C|": {
                        code: "timeSigCutCommon",
                        line: 2
                    }
                };
            }
            constructor(t = "4/4", e = 15, i = !0){
                super(), this.timeSpec = "4/4", this.line = 0, this.is_numeric = !0, this.validate_args = i;
                const b = e, a = V.currentMusicFont();
                this.point = a.lookupMetric("digits.point") || V.NOTATION_FONT_SCALE;
                const n = a.lookupMetric("digits.shiftLine", 0);
                this.topLine = 2 + n, this.bottomLine = 4 + n, this.setPosition(wt.BEGIN), this.setTimeSig(t), this.setPadding(b);
            }
            parseTimeSpec(t) {
                var e, i;
                if ("C" === t || "C|" === t) {
                    const { line: e, code: i } = Te.glyphs[t];
                    return {
                        line: e,
                        num: !1,
                        glyph: new Z(i, V.NOTATION_FONT_SCALE)
                    };
                }
                this.validate_args && ((t)=>{
                    const e = t.split("/");
                    if (2 !== e.length && "+" !== e[0] && "-" !== e[0]) throw new g("BadTimeSignature", `Invalid time spec: ${t}. Must be in the form "<numerator>/<denominator>"`);
                    e.forEach((e)=>{
                        if (0 == /^[0-9+\-()]+$/.test(e)) throw new g("BadTimeSignature", `Invalid time spec: ${t}. Must contain valid signatures.`);
                    });
                })(t);
                const b = t.split("/");
                return {
                    line: 0,
                    num: !0,
                    glyph: this.makeTimeSignatureGlyph(null !== (e = b[0]) && void 0 !== e ? e : "", null !== (i = b[1]) && void 0 !== i ? i : "")
                };
            }
            makeTimeSignatureGlyph(t, e) {
                return new Se(this, t, e, "timeSig0", this.point);
            }
            getInfo() {
                const { line: t, is_numeric: e, glyph: i } = this;
                return {
                    line: t,
                    num: e,
                    glyph: i
                };
            }
            setTimeSig(t) {
                this.timeSpec = t;
                const e = this.parseTimeSpec(t);
                return this.setGlyph(e.glyph), this.is_numeric = e.num, this.line = e.line, this;
            }
            getTimeSpec() {
                return this.timeSpec;
            }
            getLine() {
                return this.line;
            }
            setLine(t) {
                this.line = t;
            }
            getGlyph() {
                return this.glyph;
            }
            setGlyph(t) {
                this.glyph = t, this.setWidth(p(this.glyph.getMetrics().width));
            }
            getIsNumeric() {
                return this.is_numeric;
            }
            setIsNumeric(t) {
                this.is_numeric = t;
            }
            draw() {
                const t = this.checkStave(), e = t.checkContext();
                this.setRendered(), this.applyStyle(e), e.openGroup("timesignature", this.getAttribute("id")), this.glyph.setStave(t), this.glyph.setContext(e), this.placeGlyphOnLine(this.glyph, t, this.line), this.glyph.renderToStave(this.x), e.closeGroup(), this.restoreStyle(e);
            }
        }
        const ve = {
            [kt.CATEGORY]: 0,
            [de.CATEGORY]: 1,
            [_e.CATEGORY]: 2,
            [Te.CATEGORY]: 3
        }, we = {
            [Te.CATEGORY]: 0,
            [_e.CATEGORY]: 1,
            [kt.CATEGORY]: 2,
            [de.CATEGORY]: 3
        };
        class ze extends R {
            static get CATEGORY() {
                return x.Stave;
            }
            static get defaultPadding() {
                const t = V.currentMusicFont();
                return t.lookupMetric("stave.padding") + t.lookupMetric("stave.endPaddingMax");
            }
            static get rightPadding() {
                return V.currentMusicFont().lookupMetric("stave.endPaddingMax");
            }
            constructor(t, e, i, b){
                super(), this.height = 0, this.x = t, this.y = e, this.width = i, this.formatted = !1, this.start_x = t + 5, this.end_x = t + i, this.modifiers = [], this.measure = 0, this.clef = "treble", this.endClef = void 0, this.resetFont(), this.options = Object.assign({
                    vertical_bar_width: 10,
                    num_lines: 5,
                    fill_style: "#999999",
                    left_bar: !0,
                    right_bar: !0,
                    spacing_between_lines_px: V.STAVE_LINE_DISTANCE,
                    space_above_staff_ln: 4,
                    space_below_staff_ln: 4,
                    top_text_position: 1,
                    bottom_text_position: 4,
                    line_config: []
                }, b), this.bounds = {
                    x: this.x,
                    y: this.y,
                    w: this.width,
                    h: 0
                }, this.defaultLedgerLineStyle = {
                    strokeStyle: "#444",
                    lineWidth: 1.4
                }, this.resetLines(), this.addModifier(new kt(this.options.left_bar ? zt.SINGLE : zt.NONE)), this.addEndModifier(new kt(this.options.right_bar ? zt.SINGLE : zt.NONE));
            }
            setDefaultLedgerLineStyle(t) {
                this.defaultLedgerLineStyle = t;
            }
            getDefaultLedgerLineStyle() {
                return Object.assign(Object.assign({}, this.getStyle()), this.defaultLedgerLineStyle);
            }
            space(t) {
                return this.options.spacing_between_lines_px * t;
            }
            resetLines() {
                this.options.line_config = [];
                for(let t = 0; t < this.options.num_lines; t++)this.options.line_config.push({
                    visible: !0
                });
                this.height = (this.options.num_lines + this.options.space_above_staff_ln) * this.options.spacing_between_lines_px, this.options.bottom_text_position = this.options.num_lines;
            }
            setNoteStartX(t) {
                return this.formatted || this.format(), this.start_x = t, this;
            }
            getNoteStartX() {
                return this.formatted || this.format(), this.start_x;
            }
            getNoteEndX() {
                return this.formatted || this.format(), this.end_x;
            }
            getTieStartX() {
                return this.start_x;
            }
            getTieEndX() {
                return this.end_x;
            }
            getX() {
                return this.x;
            }
            getNumLines() {
                return this.options.num_lines;
            }
            setNumLines(t) {
                return this.options.num_lines = t, this.resetLines(), this;
            }
            setY(t) {
                return this.y = t, this;
            }
            getY() {
                return this.y;
            }
            getTopLineTopY() {
                return this.getYForLine(0) - V.STAVE_LINE_THICKNESS / 2;
            }
            getBottomLineBottomY() {
                return this.getYForLine(this.getNumLines() - 1) + V.STAVE_LINE_THICKNESS / 2;
            }
            setX(t) {
                const e = t - this.x;
                this.formatted = !1, this.x = t, this.start_x += e, this.end_x += e;
                for(let t = 0; t < this.modifiers.length; t++){
                    const i = this.modifiers[t];
                    i.setX(i.getX() + e);
                }
                return this;
            }
            setWidth(t) {
                return this.formatted = !1, this.width = t, this.end_x = this.x + t, this;
            }
            getWidth() {
                return this.width;
            }
            getStyle() {
                return Object.assign({
                    fillStyle: this.options.fill_style,
                    strokeStyle: this.options.fill_style,
                    lineWidth: V.STAVE_LINE_THICKNESS
                }, super.getStyle());
            }
            setMeasure(t) {
                return this.measure = t, this;
            }
            getMeasure() {
                return this.measure;
            }
            getModifierXShift(t = 0) {
                if ("number" != typeof t) throw new g("InvalidIndex", "Must be of number type");
                if (this.formatted || this.format(), 1 === this.getModifiers(wt.BEGIN).length) return 0;
                if (this.modifiers[t].getPosition() === wt.RIGHT) return 0;
                let e = this.start_x - this.x;
                const i = this.modifiers[0];
                return i.getType() === zt.REPEAT_BEGIN && e > i.getWidth() && (e -= i.getWidth()), e;
            }
            setRepetitionType(t, e = 0) {
                return this.modifiers.push(new xe(t, this.x, e)), this;
            }
            setVoltaType(t, e, i) {
                return this.modifiers.push(new fe(t, e, this.x, i)), this;
            }
            setSection(t, e, i = 0, b, a = !0) {
                const n = new ge(t, this.x + i, e, a);
                return b && n.setFontSize(b), this.modifiers.push(n), this;
            }
            setTempo(t, e) {
                return this.modifiers.push(new ye(t, this.x, e)), this;
            }
            setText(t, e, i = {}) {
                return this.modifiers.push(new ue(t, e, i)), this;
            }
            getHeight() {
                return this.height;
            }
            getSpacingBetweenLines() {
                return this.options.spacing_between_lines_px;
            }
            getBoundingBox() {
                return new D(this.x, this.y, this.width, this.getBottomY() - this.y);
            }
            getBottomY() {
                const t = this.options, e = t.spacing_between_lines_px;
                return this.getYForLine(t.num_lines) + t.space_below_staff_ln * e;
            }
            getBottomLineY() {
                return this.getYForLine(this.options.num_lines);
            }
            getYForLine(t) {
                const e = this.options, i = e.spacing_between_lines_px, b = e.space_above_staff_ln;
                return this.y + t * i + b * i;
            }
            getLineForY(t) {
                const e = this.options, i = e.spacing_between_lines_px, b = e.space_above_staff_ln;
                return (t - this.y) / i - b;
            }
            getYForTopText(t = 0) {
                return this.getYForLine(-t - this.options.top_text_position);
            }
            getYForBottomText(t = 0) {
                return this.getYForLine(this.options.bottom_text_position + t);
            }
            getYForNote(t) {
                const e = this.options, i = e.spacing_between_lines_px, b = e.space_above_staff_ln;
                return this.y + b * i + 5 * i - t * i;
            }
            getYForGlyphs() {
                return this.getYForLine(3);
            }
            addModifier(t, e) {
                return void 0 !== e && t.setPosition(e), t.setStave(this), this.formatted = !1, this.modifiers.push(t), this;
            }
            addEndModifier(t) {
                return this.addModifier(t, wt.END), this;
            }
            setBegBarType(t) {
                const { SINGLE: e, REPEAT_BEGIN: i, NONE: b } = zt;
                return t !== e && t !== i && t !== b || (this.modifiers[0].setType(t), this.formatted = !1), this;
            }
            setEndBarType(t) {
                return t !== zt.REPEAT_BEGIN && (this.modifiers[1].setType(t), this.formatted = !1), this;
            }
            setClefLines(t) {
                return this.clef = t, this;
            }
            setClef(t, e, i, b) {
                void 0 === b && (b = wt.BEGIN), b === wt.END ? this.endClef = t : this.clef = t;
                const a = this.getModifiers(b, de.CATEGORY);
                return 0 === a.length ? this.addClef(t, e, i, b) : a[0].setType(t, e, i), this;
            }
            getClef() {
                return this.clef;
            }
            setEndClef(t, e, i) {
                return this.setClef(t, e, i, wt.END), this;
            }
            getEndClef() {
                return this.endClef;
            }
            setKeySignature(t, e, i) {
                void 0 === i && (i = wt.BEGIN);
                const b = this.getModifiers(i, _e.CATEGORY);
                return 0 === b.length ? this.addKeySignature(t, e, i) : b[0].setKeySig(t, e), this;
            }
            setEndKeySignature(t, e) {
                return this.setKeySignature(t, e, wt.END), this;
            }
            setTimeSignature(t, e, i) {
                void 0 === i && (i = wt.BEGIN);
                const b = this.getModifiers(i, Te.CATEGORY);
                return 0 === b.length ? this.addTimeSignature(t, e, i) : b[0].setTimeSig(t), this;
            }
            setEndTimeSignature(t, e) {
                return this.setTimeSignature(t, e, wt.END), this;
            }
            addKeySignature(t, e, i) {
                return void 0 === i && (i = wt.BEGIN), this.addModifier(new _e(t, e).setPosition(i), i), this;
            }
            addClef(t, e, i, b) {
                return void 0 === b || b === wt.BEGIN ? this.clef = t : b === wt.END && (this.endClef = t), this.addModifier(new de(t, e, i), b), this;
            }
            addEndClef(t, e, i) {
                return this.addClef(t, e, i, wt.END), this;
            }
            addTimeSignature(t, e, i) {
                return this.addModifier(new Te(t, e), i), this;
            }
            addEndTimeSignature(t, e) {
                return this.addTimeSignature(t, e, wt.END), this;
            }
            addTrebleGlyph() {
                return this.addClef("treble"), this;
            }
            getModifiers(t, e) {
                const i = void 0 === t, b = void 0 === e;
                return i && b ? this.modifiers : i ? this.modifiers.filter((t)=>e === t.getCategory()) : b ? this.modifiers.filter((e)=>t === e.getPosition()) : this.modifiers.filter((i)=>t === i.getPosition() && e === i.getCategory());
            }
            sortByCategory(t, e) {
                for(let i = t.length - 1; i >= 0; i--)for(let b = 0; b < i; b++)if (e[t[b].getCategory()] > e[t[b + 1].getCategory()]) {
                    const e = t[b];
                    t[b] = t[b + 1], t[b + 1] = e;
                }
            }
            format() {
                const t = this.modifiers[0], e = this.modifiers[1], i = this.getModifiers(wt.BEGIN), b = this.getModifiers(wt.END);
                let a, n, l;
                this.sortByCategory(i, ve), this.sortByCategory(b, we), i.length > 1 && t.getType() === zt.REPEAT_BEGIN && (i.push(i.splice(0, 1)[0]), i.splice(0, 0, new kt(zt.SINGLE))), b.indexOf(e) > 0 && b.splice(0, 0, new kt(zt.NONE));
                let o = 0, r = this.x;
                for(let t = 0; t < i.length; t++)l = i[t], n = l.getPadding(t + o), a = l.getWidth(), r += n, l.setX(r), r += a, n + a === 0 && o--;
                this.start_x = r, r = this.x + this.width;
                const h = {
                    left: 0,
                    right: 0,
                    paddingRight: 0,
                    paddingLeft: 0
                };
                let m = 0;
                for(let t = 0; t < b.length; t++){
                    l = b[t], m = s(l) ? t : m, h.right = 0, h.left = 0, h.paddingRight = 0, h.paddingLeft = 0;
                    const e = l.getLayoutMetrics();
                    e ? (0 !== t && (h.right = e.xMax || 0, h.paddingRight = e.paddingRight || 0), h.left = -e.xMin || 0, h.paddingLeft = e.paddingLeft || 0, t === b.length - 1 && (h.paddingLeft = 0)) : (h.paddingRight = l.getPadding(t - m), 0 !== t && (h.right = l.getWidth()), 0 === t && (h.left = l.getWidth())), r -= h.paddingRight, r -= h.right, l.setX(r), r -= h.left, r -= h.paddingLeft;
                }
                this.end_x = 1 === b.length ? this.x + this.width : r, this.formatted = !0;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered(), this.applyStyle(), t.openGroup("stave", this.getAttribute("id")), this.formatted || this.format();
                const e = this.options.num_lines, i = this.width, b = this.x;
                let a;
                for(let n = 0; n < e; n++)a = this.getYForLine(n), this.options.line_config[n].visible && (t.beginPath(), t.moveTo(b, a), t.lineTo(b + i, a), t.stroke());
                t.closeGroup(), this.restoreStyle();
                for(let e = 0; e < this.modifiers.length; e++){
                    const i = this.modifiers[e];
                    "function" == typeof i.draw && (i.applyStyle(t), i.draw(this, this.getModifierXShift(e)), i.restoreStyle(t));
                }
                if (this.measure > 0) {
                    t.save(), t.setFont(this.textFont);
                    const e = t.measureText("" + this.measure).width;
                    a = this.getYForTopText(0) + 3, t.fillText("" + this.measure, this.x - e / 2, a), t.restore();
                }
                return this;
            }
            getVerticalBarWidth() {
                return this.options.vertical_bar_width;
            }
            getConfigForLines() {
                return this.options.line_config;
            }
            setConfigForLine(t, e) {
                if (t >= this.options.num_lines || t < 0) throw new g("StaveConfigError", "The line number must be within the range of the number of lines in the Stave.");
                if (void 0 === e.visible) throw new g("StaveConfigError", "The line configuration object is missing the 'visible' property.");
                if ("boolean" != typeof e.visible) throw new g("StaveConfigError", "The line configuration objects 'visible' property must be true or false.");
                return this.options.line_config[t] = e, this;
            }
            setConfigForLines(t) {
                if (t.length !== this.options.num_lines) throw new g("StaveConfigError", "The length of the lines configuration array must match the number of lines in the Stave");
                for(const e in t)null == t[e].visible && (t[e] = this.options.line_config[e]), this.options.line_config[e] = Object.assign(Object.assign({}, this.options.line_config[e]), t[e]);
                return this.options.line_config = t, this;
            }
            static formatBegModifiers(t) {
                const e = (e)=>{
                    let i = 0;
                    t.forEach((t)=>{
                        const b = t.getModifiers(wt.BEGIN, e);
                        b.length > 0 && b[0].getX() > i && (i = b[0].getX());
                    });
                    let b = 0;
                    t.forEach((t)=>{
                        b = 0;
                        t.getModifiers(wt.BEGIN, e).forEach((t)=>{
                            i - t.getX() > b && (b = i - t.getX());
                        });
                        const a = t.getModifiers(wt.BEGIN);
                        let n = !1;
                        a.forEach((t)=>{
                            t.getCategory() === e && (n = !0), n && b > 0 && t.setX(t.getX() + b);
                        }), t.setNoteStartX(t.getNoteStartX() + b);
                    });
                };
                t.forEach((t)=>{
                    t.formatted || t.format();
                }), e(x.Clef), e(x.KeySignature), e(x.TimeSignature);
                let i = 0;
                t.forEach((t)=>{
                    t.getNoteStartX() > i && (i = t.getNoteStartX());
                }), t.forEach((t)=>{
                    t.setNoteStartX(i);
                }), i = 0, t.forEach((t)=>{
                    t.getModifiers(wt.BEGIN, x.Barline).forEach((t)=>{
                        t.getType() == zt.REPEAT_BEGIN && t.getX() > i && (i = t.getX());
                    });
                }), t.forEach((t)=>{
                    t.getModifiers(wt.BEGIN, x.Barline).forEach((t)=>{
                        t.getType() == zt.REPEAT_BEGIN && t.setX(i);
                    });
                });
            }
        }
        function Be(t, e, i, b, a) {
            if (e !== De.type.BOLD_DOUBLE_LEFT && e !== De.type.BOLD_DOUBLE_RIGHT) throw new g("InvalidConnector", "A REPEAT_BEGIN or REPEAT_END type must be provided.");
            let n = 3, s = 3.5;
            e === De.type.BOLD_DOUBLE_RIGHT && (n = -5, s = 3), t.fillRect(i + n, b, 1, a - b), t.fillRect(i - 2, b, s, a - b);
        }
        ze.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: 8,
            weight: E.NORMAL,
            style: P.NORMAL
        };
        class De extends R {
            static get CATEGORY() {
                return x.StaveConnector;
            }
            constructor(t, e){
                super(), this.thickness = V.STAVE_LINE_THICKNESS, this.width = 3, this.top_stave = t, this.bottom_stave = e, this.type = De.type.DOUBLE, this.resetFont(), this.x_shift = 0, this.texts = [];
            }
            setType(t) {
                const e = "string" == typeof t ? De.typeString[t] : t;
                return Object.values(De.type).includes(e) && (this.type = e), this;
            }
            getType() {
                return this.type;
            }
            setText(t, e = {}) {
                return this.texts.push({
                    content: t,
                    options: Object.assign({
                        shift_x: 0,
                        shift_y: 0
                    }, e)
                }), this;
            }
            setXShift(t) {
                if ("number" != typeof t) throw new g("InvalidType", "x_shift must be a Number");
                return this.x_shift = t, this;
            }
            getXShift() {
                return this.x_shift;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                let e = this.top_stave.getYForLine(0), i = this.bottom_stave.getYForLine(this.bottom_stave.getNumLines() - 1) + this.thickness, b = this.width, a = this.top_stave.getX();
                (this.type === De.type.SINGLE_RIGHT || this.type === De.type.BOLD_DOUBLE_RIGHT || this.type === De.type.THIN_DOUBLE) && (a = this.top_stave.getX() + this.top_stave.getWidth());
                let n = i - e;
                switch(this.type){
                    case De.type.SINGLE:
                    case De.type.SINGLE_LEFT:
                    case De.type.SINGLE_RIGHT:
                        b = 1;
                        break;
                    case De.type.DOUBLE:
                        a -= this.width + 2, e -= this.thickness, n += .5;
                        break;
                    case De.type.BRACE:
                        {
                            b = 12;
                            const a = this.top_stave.getX() - 2 + this.x_shift, s = e, l = a, o = i, r = a - b, h = s + n / 2, m = r - .9 * b, c = s + .2 * n, d = a + 1.1 * b, _ = h - .135 * n, x = d, g = h + .135 * n, y = m, p = o - .2 * n, u = r - b, f = p, S = a + .4 * b, T = h + .135 * n, v = S, w = h - .135 * n, z = u, B = c;
                            t.beginPath(), t.moveTo(a, s), t.bezierCurveTo(m, c, d, _, r, h), t.bezierCurveTo(x, g, y, p, l, o), t.bezierCurveTo(u, f, S, T, r, h), t.bezierCurveTo(v, w, z, B, a, s), t.fill(), t.stroke();
                            break;
                        }
                    case De.type.BRACKET:
                        e -= 6, i += 6, n = i - e, Z.renderGlyph(t, a - 5, e, 40, "bracketTop"), Z.renderGlyph(t, a - 5, i, 40, "bracketBottom"), a -= this.width + 2;
                        break;
                    case De.type.BOLD_DOUBLE_LEFT:
                        Be(t, this.type, a + this.x_shift, e, i - this.thickness);
                        break;
                    case De.type.BOLD_DOUBLE_RIGHT:
                        Be(t, this.type, a, e, i - this.thickness);
                        break;
                    case De.type.THIN_DOUBLE:
                        b = 1, n -= this.thickness;
                        break;
                    case De.type.NONE:
                        break;
                    default:
                        throw new g("InvalidType", `The provided StaveConnector.type (${this.type}) is invalid.`);
                }
                this.type !== De.type.BRACE && this.type !== De.type.BOLD_DOUBLE_LEFT && this.type !== De.type.BOLD_DOUBLE_RIGHT && this.type !== De.type.NONE && t.fillRect(a, e, b, n), this.type === De.type.THIN_DOUBLE && t.fillRect(a - 3, e, b, n), t.save(), t.setLineWidth(2), t.setFont(this.textFont);
                for(let e = 0; e < this.texts.length; e++){
                    const i = this.texts[e], b = t.measureText("" + i.content).width, a = this.top_stave.getX() - b - 24 + i.options.shift_x, n = (this.top_stave.getYForLine(0) + this.bottom_stave.getBottomLineY()) / 2 + i.options.shift_y;
                    t.fillText("" + i.content, a, n + 4);
                }
                t.restore();
            }
        }
        De.TEXT_FONT = {
            family: F.SERIF,
            size: 16,
            weight: E.NORMAL,
            style: P.NORMAL
        }, De.type = {
            SINGLE_RIGHT: 0,
            SINGLE_LEFT: 1,
            SINGLE: 1,
            DOUBLE: 2,
            BRACE: 3,
            BRACKET: 4,
            BOLD_DOUBLE_LEFT: 5,
            BOLD_DOUBLE_RIGHT: 6,
            THIN_DOUBLE: 7,
            NONE: 8
        }, De.typeString = {
            singleRight: De.type.SINGLE_RIGHT,
            singleLeft: De.type.SINGLE_LEFT,
            single: De.type.SINGLE,
            double: De.type.DOUBLE,
            brace: De.type.BRACE,
            bracket: De.type.BRACKET,
            boldDoubleLeft: De.type.BOLD_DOUBLE_LEFT,
            boldDoubleRight: De.type.BOLD_DOUBLE_RIGHT,
            thinDouble: De.type.THIN_DOUBLE,
            none: De.type.NONE
        };
        class Ce {
            static getNextContext(t) {
                const e = t.tContexts, i = e.indexOf(t);
                if (i + 1 < e.length) return e[i + 1];
            }
            constructor(t){
                this.preFormatted = !1, this.postFormatted = !1, this.tickID = t && t.tickID ? t.tickID : 0, this.currentTick = new z(0, 1), this.maxTicks = new z(0, 1), this.maxTickable = void 0, this.minTicks = void 0, this.minTickable = void 0, this.padding = 1, this.x = 0, this.xBase = 0, this.xOffset = 0, this.tickables = [], this.tickablesByVoice = {}, this.notePx = 0, this.glyphPx = 0, this.leftDisplacedHeadPx = 0, this.rightDisplacedHeadPx = 0, this.modLeftPx = 0, this.modRightPx = 0, this.totalLeftPx = 0, this.totalRightPx = 0, this.tContexts = [], this.width = 0, this.formatterMetrics = {
                    freedom: {
                        left: 0,
                        right: 0
                    }
                };
            }
            getTickID() {
                return this.tickID;
            }
            getX() {
                return this.x;
            }
            setX(t) {
                return this.x = t, this.xBase = t, this.xOffset = 0, this;
            }
            getXBase() {
                return this.xBase;
            }
            setXBase(t) {
                this.xBase = t, this.x = t + this.xOffset;
            }
            getXOffset() {
                return this.xOffset;
            }
            setXOffset(t) {
                this.xOffset = t, this.x = this.xBase + t;
            }
            getWidth() {
                return this.width + 2 * this.padding;
            }
            setPadding(t) {
                return this.padding = t, this;
            }
            getMaxTicks() {
                return this.maxTicks;
            }
            getMinTicks() {
                return this.minTicks;
            }
            getMaxTickable() {
                return this.maxTickable;
            }
            getMinTickable() {
                return this.minTickable;
            }
            getTickables() {
                return this.tickables;
            }
            getTickableForVoice(t) {
                return this.tickablesByVoice[t];
            }
            getTickablesByVoice() {
                return this.tickablesByVoice;
            }
            getCenterAlignedTickables() {
                return this.tickables.filter((t)=>t.isCenterAligned());
            }
            getMetrics() {
                const { width: t, glyphPx: e, notePx: i, leftDisplacedHeadPx: b, rightDisplacedHeadPx: a, modLeftPx: n, modRightPx: s, totalLeftPx: l, totalRightPx: o } = this;
                return {
                    width: t,
                    glyphPx: e,
                    notePx: i,
                    leftDisplacedHeadPx: b,
                    rightDisplacedHeadPx: a,
                    modLeftPx: n,
                    modRightPx: s,
                    totalLeftPx: l,
                    totalRightPx: o
                };
            }
            getCurrentTick() {
                return this.currentTick;
            }
            setCurrentTick(t) {
                this.currentTick = t, this.preFormatted = !1;
            }
            addTickable(t, e) {
                if (!t) throw new g("BadArgument", "Invalid tickable added.");
                if (!t.shouldIgnoreTicks()) {
                    const e = t.getTicks();
                    e.greaterThan(this.maxTicks) && (this.maxTicks = e.clone(), this.maxTickable = t), (null == this.minTicks || e.lessThan(this.minTicks)) && (this.minTicks = e.clone(), this.minTickable = t);
                }
                return t.setTickContext(this), this.tickables.push(t), this.tickablesByVoice[e || 0] = t, this.preFormatted = !1, this;
            }
            preFormat() {
                if (this.preFormatted) return this;
                for(let t = 0; t < this.tickables.length; ++t){
                    const e = this.tickables[t];
                    e.preFormat();
                    const i = e.getMetrics();
                    this.leftDisplacedHeadPx = Math.max(this.leftDisplacedHeadPx, i.leftDisplacedHeadPx), this.rightDisplacedHeadPx = Math.max(this.rightDisplacedHeadPx, i.rightDisplacedHeadPx), this.notePx = Math.max(this.notePx, i.notePx), this.glyphPx = Math.max(this.glyphPx, i.glyphWidth || 0), this.modLeftPx = Math.max(this.modLeftPx, i.modLeftPx), this.modRightPx = Math.max(this.modRightPx, i.modRightPx), this.totalLeftPx = Math.max(this.totalLeftPx, i.modLeftPx + i.leftDisplacedHeadPx), this.totalRightPx = Math.max(this.totalRightPx, i.modRightPx + i.rightDisplacedHeadPx), this.width = this.notePx + this.totalLeftPx + this.totalRightPx;
                }
                return this;
            }
            postFormat() {
                return this.postFormatted || (this.postFormatted = !0), this;
            }
            getFormatterMetrics() {
                return this.formatterMetrics;
            }
        }
        function Ee(t, e, i, b) {
            let a = e;
            for(let e = i + 1; e < t.length; e++){
                const i = t[e];
                if (h(i) && !i.isRest() && !i.shouldIgnoreTicks()) {
                    a = i.getLineForRest();
                    break;
                }
            }
            if (b && e !== a) a = S(Math.max(e, a), Math.min(e, a));
            return a;
        }
        class Pe {
            static SimpleFormat(t, e = 0, { paddingBetween: i = 10 } = {}) {
                t.reduce((t, e)=>{
                    e.addToModifierContext(new ce);
                    const b = (new Ce).addTickable(e).preFormat(), a = b.getMetrics();
                    return b.setX(t + a.totalLeftPx), t + b.getWidth() + a.totalRightPx + i;
                }, e);
            }
            static plotDebugging(t, e, i, b, a, n) {
                const s = i + (n = Object.assign({
                    stavePadding: V.currentMusicFont().lookupMetric("stave.padding")
                }, n)).stavePadding, l = e.contextGaps;
                t.save(), t.setFont(F.SANS_SERIF, 8), l.gaps.forEach((e)=>{
                    var i, n, l;
                    i = s + e.x1, n = s + e.x2, l = "rgba(100,200,100,0.4)", t.beginPath(), t.setStrokeStyle(l), t.setFillStyle(l), t.setLineWidth(1), t.fillRect(i, b, Math.max(n - i, 0), a - b), t.setFillStyle("green"), t.fillText(Math.round(e.x2 - e.x1).toString(), s + e.x1, a + 12);
                }), t.setFillStyle("red"), t.fillText(`Loss: ${(e.totalCost || 0).toFixed(2)} Shift: ${(e.totalShift || 0).toFixed(2)} Gap: ${l.total.toFixed(2)}`, s - 20, a + 27), t.restore();
            }
            static FormatAndDraw(t, e, i, b) {
                let a = {
                    auto_beam: !1,
                    align_rests: !1
                };
                "object" == typeof b ? a = Object.assign(Object.assign({}, a), b) : "boolean" == typeof b && (a.auto_beam = b);
                const n = new Xt(V.TIME4_4).setMode(Xt.Mode.SOFT).addTickables(i), s = a.auto_beam ? Re.applyAndGetBeams(n) : [];
                return (new Pe).joinVoices([
                    n
                ]).formatToStave([
                    n
                ], e, {
                    align_rests: a.align_rests,
                    stave: e
                }), n.setStave(e).draw(t, e), s.forEach((e)=>e.setContext(t).draw()), n.getBoundingBox();
            }
            static FormatAndDrawTab(t, e, i, b, a, n, s) {
                let l = {
                    auto_beam: n,
                    align_rests: !1
                };
                "object" == typeof s ? l = Object.assign(Object.assign({}, l), s) : "boolean" == typeof s && (l.auto_beam = s);
                const o = new Xt(V.TIME4_4).setMode(Xt.Mode.SOFT).addTickables(a), r = new Xt(V.TIME4_4).setMode(Xt.Mode.SOFT).addTickables(b), h = l.auto_beam ? Re.applyAndGetBeams(o) : [];
                (new Pe).joinVoices([
                    o
                ]).joinVoices([
                    r
                ]).formatToStave([
                    o,
                    r
                ], i, {
                    align_rests: l.align_rests
                }), o.draw(t, i), r.draw(t, e), h.forEach((e)=>e.setContext(t).draw()), new De(i, e).setContext(t).draw();
            }
            static AlignRestsToNotes(t, e, i) {
                t.forEach((b, a)=>{
                    if (c(b) && b.isRest()) {
                        if (b.getTuplet() && !i) return;
                        const n = b.getGlyphProps().position.toUpperCase();
                        if ("R/4" !== n && "B/4" !== n) return;
                        if (e || b.getBeam()) {
                            const e = b.getKeyProps()[0];
                            if (0 === a) e.line = Ee(t, e.line, a, !1);
                            else if (a > 0 && a < t.length) {
                                const i = t[a - 1];
                                if (c(i)) {
                                    if (i.isRest()) e.line = i.getKeyProps()[0].line;
                                    else {
                                        const b = i.getLineForRest();
                                        e.line = Ee(t, b, a, !0);
                                    }
                                }
                            }
                            b.setKeyLine(0, e.line);
                        }
                    }
                });
            }
            constructor(t){
                this.formatterOptions = Object.assign({
                    globalSoftmax: !1,
                    softmaxFactor: V.SOFTMAX_FACTOR,
                    maxIterations: 5
                }, t), this.justifyWidth = 0, this.totalCost = 0, this.totalShift = 0, this.durationStats = {}, this.minTotalWidth = 0, this.hasMinTotalWidth = !1, this.tickContexts = {
                    map: {},
                    array: [],
                    list: [],
                    resolutionMultiplier: 0
                }, this.modifierContexts = [], this.contextGaps = {
                    total: 0,
                    gaps: []
                }, this.voices = [], this.lossHistory = [];
            }
            alignRests(t, e) {
                if (!t || !t.length) throw new g("BadArgument", "No voices to format rests");
                t.forEach((t)=>Pe.AlignRestsToNotes(t.getTickables(), e));
            }
            preCalculateMinTotalWidth(t) {
                const e = V.currentMusicFont().lookupMetric("stave.unalignedNotePadding");
                let i = 0, b = 0, a = 0;
                const n = [], s = [];
                if (this.hasMinTotalWidth) return this.minTotalWidth;
                if (!t) throw new g("BadArgument", "'voices' required to run preCalculateMinTotalWidth");
                this.createTickContexts(t);
                const { list: l, map: o } = this.tickContexts;
                this.minTotalWidth = 0, l.forEach((e)=>{
                    const l = o[e];
                    l.preFormat(), l.getTickables().length < t.length && (i += 1), l.getTickables().forEach((t)=>{
                        b += t.getMetrics().width, a += t.getTicks().value(), n.push(t.getMetrics().width), s.push(t.getTicks().value());
                    });
                    const r = l.getWidth();
                    this.minTotalWidth += r;
                }), this.hasMinTotalWidth = !0;
                const r = b > 0 ? b / n.length : 1 / n.length, h = w(n.map((t)=>Math.pow(t - r, 2))), m = Math.pow(h / n.length, .5) / r, c = a / s.length, d = w(s.map((t)=>Math.pow(t - c, 2))), _ = Math.pow(d / s.length, .5) / c, x = Math.max(_, m) * l.length * e, y = e * i;
                return this.minTotalWidth + Math.max(y, x);
            }
            getMinTotalWidth() {
                if (!this.hasMinTotalWidth) throw new g("NoMinTotalWidth", "Call 'preCalculateMinTotalWidth' or 'preFormat' before calling 'getMinTotalWidth'");
                return this.minTotalWidth;
            }
            static getResolutionMultiplier(t) {
                if (!t || !t.length) throw new g("BadArgument", "No voices to format");
                const e = t[0].getTotalTicks();
                return t.reduce((t, i)=>{
                    if (!i.getTotalTicks().equals(e)) throw new g("TickMismatch", "Voices should have same total note duration in ticks.");
                    if (i.getMode() === Xt.Mode.STRICT && !i.isComplete()) throw new g("IncompleteVoice", "Voice does not have enough notes.");
                    return Math.max(t, z.LCM(t, i.getResolutionMultiplier()));
                }, 1);
            }
            createModifierContexts(t) {
                if (0 == t.length) return;
                const e = Pe.getResolutionMultiplier(t), i = new Map, b = [];
                t.forEach((t)=>{
                    const a = new z(0, e);
                    t.getTickables().forEach((t)=>{
                        const e = a.numerator;
                        let n = i.get(t.getStave());
                        if (n || (i.set(t.getStave(), {}), n = i.get(t.getStave())), !(n ? n[e] : void 0)) {
                            const t = new ce;
                            b.push(t), n[e] = t;
                        }
                        t.addToModifierContext(n[e]), a.add(t.getTicks());
                    });
                }), this.modifierContexts.push({
                    map: i,
                    array: b,
                    resolutionMultiplier: e
                });
            }
            createTickContexts(t) {
                const e = function(t, e, i) {
                    if (0 == t.length) return {
                        map: {},
                        array: [],
                        list: [],
                        resolutionMultiplier: 0
                    };
                    const b = {}, a = [], n = [], s = Pe.getResolutionMultiplier(t);
                    return t.forEach((t, l)=>{
                        const o = new z(0, s);
                        t.getTickables().forEach((t)=>{
                            const s = o.numerator;
                            if (!b[s]) {
                                const t = e({
                                    tickID: s
                                });
                                n.push(t), b[s] = t, a.push(s);
                            }
                            i(t, b[s], l), o.add(t.getTicks());
                        });
                    }), {
                        map: b,
                        array: n,
                        list: a.sort((t, e)=>t - e),
                        resolutionMultiplier: s
                    };
                }(t, (t)=>new Ce(t), (t, e, i)=>e.addTickable(t, i));
                this.tickContexts = e;
                const i = this.tickContexts.array;
                return i.forEach((t)=>{
                    t.tContexts = i;
                }), e;
            }
            getTickContexts() {
                return this.tickContexts;
            }
            preFormat(t = 0, e, i, b) {
                const a = this.tickContexts;
                if (!a) throw new g("NoTickContexts", "preFormat requires TickContexts");
                const { list: n, map: s } = a;
                this.lossHistory = [], i && b && i.forEach((t)=>t.setStave(b).preFormat());
                let l = 0, o = 0;
                this.minTotalWidth = 0;
                let r = 0;
                n.forEach((t)=>{
                    const e = s[t];
                    e.preFormat();
                    const i = e.getWidth();
                    this.minTotalWidth += i;
                    const b = e.getMaxTicks().value();
                    r += b;
                    const a = e.getMetrics();
                    l = l + o + a.totalLeftPx, e.setX(l), o = i - a.totalLeftPx;
                });
                const { globalSoftmax: h, softmaxFactor: m, maxIterations: c } = this.formatterOptions, d = w(n.map((t)=>Math.pow(m, s[t].getMaxTicks().value() / r)));
                if (this.minTotalWidth = l + o, this.hasMinTotalWidth = !0, t <= 0) return this.evaluate();
                const _ = s[n[0]], x = s[n[n.length - 1]];
                function y(t) {
                    return n.map((e, i)=>{
                        const b = s[e], a = b.getTickablesByVoice();
                        let l;
                        if (i > 0) {
                            const e = s[n[i - 1]];
                            for(let o = i - 1; o >= 0; o--){
                                const i = s[n[o]].getTickablesByVoice(), c = [];
                                if (Object.keys(a).forEach((t)=>{
                                    i[t] && c.push(t);
                                }), c.length > 0) {
                                    let n = 0, s = 1 / 0, o = 0;
                                    if (c.forEach((t)=>{
                                        const e = i[t].getTicks().value();
                                        e > n && (l = i[t], n = e);
                                        const b = a[t], o = b.getX() - (b.getMetrics().modLeftPx + b.getMetrics().leftDisplacedHeadPx), r = i[t].getMetrics(), h = i[t].getX() + r.notePx + r.modRightPx + r.rightDisplacedHeadPx;
                                        s = Math.min(s, o - h);
                                    }), s = Math.min(s, b.getX() - (e.getX() + .05 * t)), h) {
                                        const e = r;
                                        o = Math.pow(m, n / e) / d * t;
                                    } else void 0 !== l && (o = l.getVoice().softmax(n) * t);
                                    return {
                                        expectedDistance: o,
                                        maxNegativeShiftPx: s,
                                        fromTickable: l
                                    };
                                }
                            }
                        }
                        return {
                            expectedDistance: 0,
                            fromTickablePx: 0,
                            maxNegativeShiftPx: 0
                        };
                    });
                }
                function u(t) {
                    const e = f / 2;
                    let i = 0;
                    return n.forEach((b, a)=>{
                        const n = s[b];
                        if (a > 0) {
                            const e = n.getX(), b = t[a], s = p(b.fromTickable).getX() + b.expectedDistance - (e + i);
                            let l = 0;
                            s > 0 ? i += s : s < 0 && (l = Math.min(b.maxNegativeShiftPx, Math.abs(s)), i += -l), n.setX(e + i);
                        }
                        n.getCenterAlignedTickables().forEach((t)=>{
                            t.setCenterXShift(e - n.getX());
                        });
                    }), x.getX() - _.getX();
                }
                const f = t - x.getMetrics().notePx - x.getMetrics().totalRightPx - _.getMetrics().totalLeftPx, S = V.currentMusicFont(), T = S.lookupMetric("stave.endPaddingMin"), v = S.lookupMetric("stave.endPaddingMax"), z = S.lookupMetric("stave.padding");
                let B = f;
                const D = y(B);
                let C = u(D);
                if (1 === n.length) return 0;
                const E = ((t, e)=>{
                    let i = t / 2;
                    if (e.length > 1) for(let t = 1; t < e.length; ++t)i = Math.min(e[t].expectedDistance / 2, i);
                    return i;
                })(B, D), P = (t)=>{
                    let e = 0;
                    const i = x && x.getMaxTickable();
                    if (i) {
                        const b = i.getVoice();
                        if (b.getTicksUsed().value() > b.getTotalTicks().value()) return 2 * v < E ? E : v;
                        const a = i.getWidth();
                        e = b.softmax(x.getMaxTicks().value()) * t - (a + z);
                    }
                    return 2 * v < e ? e : v;
                };
                let k = P(B), A = k - (v - T);
                const N = f - A;
                let F = c;
                for(; C > N && F > 0 || C + k < N && F > 1;)B -= C - N, k = P(B), A = k - (v - T), C = u(y(B)), F--;
                return this.justifyWidth = t, this.evaluate();
            }
            evaluate() {
                const t = this.tickContexts, e = this.justifyWidth;
                this.contextGaps = {
                    total: 0,
                    gaps: []
                }, t.list.forEach((e, i)=>{
                    if (0 === i) return;
                    const b = t.list[i - 1], a = t.map[b], n = t.map[e], s = a.getMetrics(), l = n.getMetrics(), o = a.getX() + s.notePx + s.totalRightPx, r = n.getX() - l.totalLeftPx, h = r - o;
                    this.contextGaps.total += h, this.contextGaps.gaps.push({
                        x1: o,
                        x2: r
                    }), n.getFormatterMetrics().freedom.left = h, a.getFormatterMetrics().freedom.right = h;
                }), this.durationStats = {};
                const i = this.durationStats;
                this.voices.forEach((t)=>{
                    t.getTickables().forEach((t, b, a)=>{
                        const n = t.getTicks().clone().simplify().toString(), s = t.getMetrics(), l = t.getFormatterMetrics(), o = t.getX() + s.notePx + s.modRightPx + s.rightDisplacedHeadPx;
                        let r = 0;
                        if (b < a.length - 1) {
                            const e = a[b + 1], i = e.getMetrics();
                            r = e.getX() - i.modLeftPx - i.leftDisplacedHeadPx - o, l.space.used = e.getX() - t.getX(), e.getFormatterMetrics().freedom.left = r;
                        } else r = e - o, l.space.used = e - t.getX();
                        l.freedom.right = r, function(t, e) {
                            const b = i[t];
                            void 0 === b ? i[t] = {
                                mean: e,
                                count: 1
                            } : (b.count += 1, b.mean = (b.mean + e) / 2);
                        }(n, l.space.used);
                    });
                });
                let b = 0;
                return this.voices.forEach((t)=>{
                    t.getTickables().forEach((t)=>{
                        const e = t.getTicks().clone().simplify().toString(), a = t.getFormatterMetrics();
                        a.space.mean = i[e].mean, a.duration = e, a.iterations += 1, a.space.deviation = a.space.used - a.space.mean, b += Math.pow(a.space.deviation, 2);
                    });
                }), this.totalCost = Math.sqrt(b), this.lossHistory.push(this.totalCost), this.totalCost;
            }
            tune(t) {
                var e;
                const i = this.tickContexts;
                if (!i) return 0;
                const b = null !== (e = null == t ? void 0 : t.alpha) && void 0 !== e ? e : .5;
                let a = 0;
                return this.totalShift = 0, i.list.forEach((t, e, n)=>{
                    const s = i.map[t], l = e > 0 ? i.map[n[e - 1]] : void 0, o = e < n.length - 1 ? i.map[n[e + 1]] : void 0;
                    !function(t, e, i, b) {
                        t.setX(t.getX() + e), t.getFormatterMetrics().freedom.left += e, t.getFormatterMetrics().freedom.right -= e, i && (i.getFormatterMetrics().freedom.right += e), b && (b.getFormatterMetrics().freedom.left -= e);
                    }(s, a, l, o);
                    const r = -w(s.getTickables().map((t)=>t.getFormatterMetrics().space.deviation));
                    r > 0 ? a = -Math.min(s.getFormatterMetrics().freedom.right, Math.abs(r)) : r < 0 && (a = o ? Math.min(o.getFormatterMetrics().freedom.right, Math.abs(r)) : 0), a *= b, this.totalShift += a;
                }), this.evaluate();
            }
            postFormat() {
                return this.modifierContexts.forEach((t)=>{
                    t.array.forEach((t)=>t.postFormat());
                }), this.tickContexts.list.forEach((t)=>{
                    this.tickContexts.map[t].postFormat();
                }), this;
            }
            joinVoices(t) {
                return this.createModifierContexts(t), this.hasMinTotalWidth = !1, this;
            }
            format(t, e, i) {
                const b = Object.assign({
                    align_rests: !1
                }, i);
                this.voices = t;
                const a = this.formatterOptions.softmaxFactor;
                return a && this.voices.forEach((t)=>t.setSoftmaxFactor(a)), this.alignRests(t, b.align_rests), this.createTickContexts(t), this.preFormat(e, b.context, t, b.stave), b.stave && this.postFormat(), this;
            }
            formatToStave(t, e, i) {
                const b = Object.assign({
                    context: e.getContext()
                }, i), a = e.getNoteEndX() - e.getNoteStartX() - ze.defaultPadding;
                return function(...t) {
                    Pe.DEBUG && u("Vex.Flow.Formatter", t);
                }("Formatting voices to width: ", a), this.format(t, a, b);
            }
            getTickContext(t) {
                var e;
                return null === (e = this.tickContexts) || void 0 === e ? void 0 : e.map[t];
            }
        }
        var ke;
        Pe.DEBUG = !1, function(t) {
            t[t.BOTTOM = -1] = "BOTTOM", t[t.TOP = 1] = "TOP";
        }(ke || (ke = {}));
        class Ae extends R {
            static get CATEGORY() {
                return x.Tuplet;
            }
            static get LOCATION_TOP() {
                return ke.TOP;
            }
            static get LOCATION_BOTTOM() {
                return ke.BOTTOM;
            }
            static get NESTING_OFFSET() {
                return 15;
            }
            static get metrics() {
                const t = V.currentMusicFont().getMetrics().tuplet;
                if (!t) throw new g("BadMetrics", "tuplet missing");
                return t;
            }
            constructor(t, e = {}){
                if (super(), this.numerator_glyphs = [], this.denom_glyphs = [], !t || !t.length) throw new g("BadArguments", "No notes provided for tuplet.");
                this.options = e, this.notes = t, this.num_notes = null != this.options.num_notes ? this.options.num_notes : t.length, this.options.beats_occupied && this.beatsOccupiedDeprecationWarning(), this.notes_occupied = this.options.notes_occupied || this.options.beats_occupied || 2, null != this.options.bracketed ? this.bracketed = this.options.bracketed : this.bracketed = t.some((t)=>!t.hasBeam()), this.ratioed = null != this.options.ratioed ? this.options.ratioed : Math.abs(this.notes_occupied - this.num_notes) > 1, this.point = 3 * V.NOTATION_FONT_SCALE / 5, this.y_pos = 16, this.x_pos = 100, this.width = 200, this.setTupletLocation(this.options.location || Ae.LOCATION_TOP), Pe.AlignRestsToNotes(t, !0, !0), this.resolveGlyphs(), this.attach();
            }
            attach() {
                for(let t = 0; t < this.notes.length; t++)this.notes[t].setTuplet(this);
            }
            detach() {
                for(let t = 0; t < this.notes.length; t++)this.notes[t].resetTuplet(this);
            }
            setBracketed(t) {
                return this.bracketed = !!t, this;
            }
            setRatioed(t) {
                return this.ratioed = !!t, this;
            }
            setTupletLocation(t) {
                return t !== Ae.LOCATION_TOP && t !== Ae.LOCATION_BOTTOM && (console.warn(`Invalid tuplet location [${t}]. Using Tuplet.LOCATION_TOP.`), t = Ae.LOCATION_TOP), this.location = t, this;
            }
            getNotes() {
                return this.notes;
            }
            getNoteCount() {
                return this.num_notes;
            }
            beatsOccupiedDeprecationWarning() {
                console.warn("beats_occupied has been deprecated as an option for tuplets. Please use notes_occupied instead.", "Calls to getBeatsOccupied / setBeatsOccupied should now be routed to getNotesOccupied / setNotesOccupied.", "The old methods will be removed in VexFlow 5.0.");
            }
            getBeatsOccupied() {
                return this.beatsOccupiedDeprecationWarning(), this.getNotesOccupied();
            }
            setBeatsOccupied(t) {
                return this.beatsOccupiedDeprecationWarning(), this.setNotesOccupied(t);
            }
            getNotesOccupied() {
                return this.notes_occupied;
            }
            setNotesOccupied(t) {
                this.detach(), this.notes_occupied = t, this.resolveGlyphs(), this.attach();
            }
            resolveGlyphs() {
                this.numerator_glyphs = [];
                let t = this.num_notes;
                for(; t >= 1;)this.numerator_glyphs.unshift(new Z("timeSig" + t % 10, this.point)), t = parseInt((t / 10).toString(), 10);
                for(this.denom_glyphs = [], t = this.notes_occupied; t >= 1;)this.denom_glyphs.unshift(new Z("timeSig" + t % 10, this.point)), t = parseInt((t / 10).toString(), 10);
            }
            getNestedTupletCount() {
                const t = this.location, e = this.notes[0];
                let i = a(e, t), b = a(e, t);
                function a(t, e) {
                    return t.getTupletStack().filter((t)=>t.location === e).length;
                }
                return this.notes.forEach((e)=>{
                    const n = a(e, t);
                    i = n > i ? n : i, b = n < b ? n : b;
                }), i - b;
            }
            getYPosition() {
                const t = this.getNestedTupletCount() * Ae.NESTING_OFFSET * -this.location, e = this.options.y_offset || 0, i = this.notes[0];
                let b;
                if (this.location === Ae.LOCATION_TOP) {
                    b = i.checkStave().getYForLine(0) - Ae.metrics.topModifierOffset;
                    for(let t = 0; t < this.notes.length; ++t){
                        const e = this.notes[t];
                        let i = 0;
                        const a = e.getModifierContext();
                        a && (i = Math.max(i, a.getState().top_text_line));
                        const n = e.getYForTopText(i) - Ae.metrics.noteHeadOffset;
                        if (e.hasStem() || e.isRest()) {
                            const t = e.getStemDirection() === at.UP ? e.getStemExtents().topY - Ae.metrics.stemOffset : e.getStemExtents().baseY - Ae.metrics.noteHeadOffset;
                            b = Math.min(t, b), i > 0 && (b = Math.min(n, b));
                        }
                    }
                } else {
                    let t = Ae.metrics.bottomLine;
                    this.notes.forEach((e)=>{
                        const i = e.getModifierContext();
                        i && (t = Math.max(t, i.getState().text_line + 1));
                    }), b = i.checkStave().getYForLine(t) + Ae.metrics.noteHeadOffset;
                    for(let t = 0; t < this.notes.length; ++t)if (this.notes[t].hasStem() || this.notes[t].isRest()) {
                        const e = this.notes[t].getStemDirection() === at.UP ? this.notes[t].getStemExtents().baseY + Ae.metrics.noteHeadOffset : this.notes[t].getStemExtents().topY + Ae.metrics.stemOffset;
                        e > b && (b = e);
                    }
                }
                return b + t + e;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                const e = this.notes[0], i = this.notes[this.notes.length - 1];
                this.bracketed ? (this.x_pos = e.getTieLeftX() - 5, this.width = i.getTieRightX() - this.x_pos + 5) : (this.x_pos = e.getStemX(), this.width = i.getStemX() - this.x_pos), this.y_pos = this.getYPosition();
                const b = (t, e)=>t + p(e.getMetrics().width);
                let a = this.numerator_glyphs.reduce(b, 0);
                this.ratioed && (a = this.denom_glyphs.reduce(b, a), a += .32 * this.point);
                const n = this.x_pos + this.width / 2 - a / 2;
                if (this.bracketed) {
                    const e = this.width / 2 - a / 2 - 5;
                    e > 0 && (t.fillRect(this.x_pos, this.y_pos, e, 1), t.fillRect(this.x_pos + this.width / 2 + a / 2 + 5, this.y_pos, e, 1), t.fillRect(this.x_pos, this.y_pos + (this.location === Ae.LOCATION_BOTTOM ? 1 : 0), 1, 10 * this.location), t.fillRect(this.x_pos + this.width, this.y_pos + (this.location === Ae.LOCATION_BOTTOM ? 1 : 0), 1, 10 * this.location));
                }
                const s = V.currentMusicFont().lookupMetric("digits.shiftY", 0);
                let l = 0;
                if (this.numerator_glyphs.forEach((e)=>{
                    e.render(t, n + l, this.y_pos + this.point / 3 - 2 + s), l += p(e.getMetrics().width);
                }), this.ratioed) {
                    const e = n + l + .16 * this.point, i = .06 * this.point;
                    t.beginPath(), t.arc(e, this.y_pos - .08 * this.point, i, 0, 2 * Math.PI, !1), t.closePath(), t.fill(), t.beginPath(), t.arc(e, this.y_pos + .12 * this.point, i, 0, 2 * Math.PI, !1), t.closePath(), t.fill(), l += .32 * this.point, this.denom_glyphs.forEach((e)=>{
                        e.render(t, n + l, this.y_pos + this.point / 3 - 2 + s), l += p(e.getMetrics().width);
                    });
                }
            }
        }
        function Ne(t) {
            let e = 0;
            return t.forEach((t)=>{
                t.keyProps && t.keyProps.forEach((t)=>{
                    e += t.line - 3;
                });
            }), e >= 0 ? at.DOWN : at.UP;
        }
        const Fe = "L", Me = "R", Oe = "B";
        class Re extends R {
            static get CATEGORY() {
                return x.Beam;
            }
            getStemDirection() {
                return this.stem_direction;
            }
            static getDefaultBeamGroups(t) {
                t && "c" !== t || (t = "4/4");
                const e = {
                    "1/2": [
                        "1/2"
                    ],
                    "2/2": [
                        "1/2"
                    ],
                    "3/2": [
                        "1/2"
                    ],
                    "4/2": [
                        "1/2"
                    ],
                    "1/4": [
                        "1/4"
                    ],
                    "2/4": [
                        "1/4"
                    ],
                    "3/4": [
                        "1/4"
                    ],
                    "4/4": [
                        "1/4"
                    ],
                    "1/8": [
                        "1/8"
                    ],
                    "2/8": [
                        "2/8"
                    ],
                    "3/8": [
                        "3/8"
                    ],
                    "4/8": [
                        "2/8"
                    ],
                    "1/16": [
                        "1/16"
                    ],
                    "2/16": [
                        "2/16"
                    ],
                    "3/16": [
                        "3/16"
                    ],
                    "4/16": [
                        "2/16"
                    ]
                }[t];
                if (void 0 !== e) return e.map((t)=>(new z).parse(t));
                {
                    const e = parseInt(t.split("/")[0], 10), i = parseInt(t.split("/")[1], 10);
                    if (e % 3 == 0) return [
                        new z(3, i)
                    ];
                    if (i > 4) return [
                        new z(2, i)
                    ];
                    if (i <= 4) return [
                        new z(1, i)
                    ];
                }
                return [
                    new z(1, 4)
                ];
            }
            static applyAndGetBeams(t, e, i) {
                return Re.generateBeams(t.getTickables(), {
                    groups: i,
                    stem_direction: e
                });
            }
            static generateBeams(t, e = {}) {
                e.groups && e.groups.length || (e.groups = [
                    new z(2, 8)
                ]);
                const i = e.groups.map((t)=>{
                    if (!t.multiply) throw new g("InvalidBeamGroups", "The beam groups must be an array of Vex.Flow.Fractions");
                    return t.clone().multiply(V.RESOLUTION, 1);
                }), b = t;
                let a = 0, n = [], s = [];
                function l() {
                    i.length - 1 > a ? a += 1 : a = 0;
                }
                !function() {
                    let t = [], e = new z(0, 1);
                    b.forEach((b)=>{
                        if (t = [], b.shouldIgnoreTicks()) return n.push(s), void (s = t);
                        s.push(b);
                        const o = i[a].clone(), r = (h = s, h.reduce((t, e)=>e.getTicks().clone().add(t), new z(0, 1))).add(e);
                        var h;
                        const m = V.durationToNumber(b.getDuration()) < 8;
                        if (m && b.getTuplet() && (o.numerator *= 2), r.greaterThan(o)) {
                            if (!m) {
                                const e = s.pop();
                                e && t.push(e);
                            }
                            n.push(s);
                            do e = r.subtract(i[a]), l();
                            while (e.greaterThanEquals(i[a]));
                            s = t;
                        } else r.equals(o) && (n.push(s), e = new z(0, 1), s = t, l());
                    }), s.length > 0 && n.push(s);
                }(), function() {
                    const t = [];
                    n.forEach((i)=>{
                        let b = [];
                        i.forEach((i, a, n)=>{
                            const s = 0 === a || a === n.length - 1, l = n[a - 1], o = !e.beam_rests && i.isRest(), r = e.beam_rests && e.beam_middle_only && i.isRest() && s;
                            let h = !1;
                            if (e.maintain_stem_directions && l && !i.isRest() && !l.isRest()) {
                                const t = l.getStemDirection();
                                h = i.getStemDirection() !== t;
                            }
                            const m = parseInt(i.getDuration(), 10) < 8;
                            o || r || h || m ? (b.length > 0 && t.push(b), b = h ? [
                                i
                            ] : []) : b.push(i);
                        }), b.length > 0 && t.push(b);
                    }), n = t;
                }(), n.forEach((t)=>{
                    let i;
                    if (e.maintain_stem_directions) {
                        const e = function(t) {
                            for(let e = 0; e < t.length; e++){
                                const i = t[e];
                                if (!i.isRest()) return i;
                            }
                            return !1;
                        }(t);
                        i = e ? e.getStemDirection() : at.UP;
                    } else i = e.stem_direction ? e.stem_direction : Ne(t);
                    !function(t, e) {
                        t.forEach((t)=>{
                            t.setStemDirection(e);
                        });
                    }(t, i);
                });
                const o = n.filter((t)=>{
                    if (t.length > 1) {
                        let e = !0;
                        return t.forEach((t)=>{
                            t.getIntrinsicTicks() >= V.durationToTicks("4") && (e = !1);
                        }), e;
                    }
                    return !1;
                }), r = function() {
                    const t = [];
                    return n.forEach((e)=>{
                        let i;
                        e.forEach((e)=>{
                            const b = e.getTuplet();
                            b && i !== b && (i = b, t.push(i));
                        });
                    }), t;
                }(), h = [];
                return o.forEach((t)=>{
                    const i = new Re(t);
                    e.show_stemlets && (i.render_options.show_stemlets = !0), e.secondary_breaks && (i.render_options.secondary_break_ticks = V.durationToTicks(e.secondary_breaks)), !0 === e.flat_beams && (i.render_options.flat_beams = !0, i.render_options.flat_beam_offset = e.flat_beam_offset), h.push(i);
                }), r.forEach((t)=>{
                    const e = t.notes[0].stem_direction === at.DOWN ? ke.BOTTOM : ke.TOP;
                    t.setTupletLocation(e);
                    let i = !1;
                    for(let e = 0; e < t.notes.length; e++)if (!t.notes[e].hasBeam()) {
                        i = !0;
                        break;
                    }
                    t.setBracketed(i);
                }), h;
            }
            constructor(t, e = !1){
                if (super(), this.slope = 0, this.y_shift = 0, this.forcedPartialDirections = {}, !t || 0 === t.length) throw new g("BadArguments", "No notes provided for beam.");
                if (1 === t.length) throw new g("BadArguments", "Too few notes for beam.");
                if (this.ticks = t[0].getIntrinsicTicks(), this.ticks >= V.durationToTicks("4")) throw new g("BadArguments", "Beams can only be applied to notes shorter than a quarter note.");
                let i, b;
                this.stem_direction = t[0].getStemDirection();
                let a = this.stem_direction;
                if (e && c(t[0])) a = Ne(t);
                else if (e && _(t[0])) {
                    const e = t.reduce((t, e)=>t + e.getStemDirection(), 0);
                    a = e > -1 ? at.UP : at.DOWN;
                }
                for(i = 0; i < t.length; ++i)b = t[i], e && (b.setStemDirection(a), this.stem_direction = a), b.setBeam(this);
                this.postFormatted = !1, this.notes = t, this.beam_count = this.getBeamCount(), this.break_on_indices = [], this.render_options = {
                    beam_width: 5,
                    max_slope: .25,
                    min_slope: -0.25,
                    slope_iterations: 20,
                    slope_cost: 100,
                    show_stemlets: !1,
                    stemlet_extension: 7,
                    partial_beam_length: 10,
                    flat_beams: !1,
                    min_flat_beam_offset: 15
                };
            }
            getNotes() {
                return this.notes;
            }
            getBeamCount() {
                return this.notes.map((t)=>t.getGlyphProps().beam_count).reduce((t, e)=>e > t ? e : t);
            }
            breakSecondaryAt(t) {
                return this.break_on_indices = t, this;
            }
            setPartialBeamSideAt(t, e) {
                return this.forcedPartialDirections[t] = e, this;
            }
            unsetPartialBeamSideAt(t) {
                return delete this.forcedPartialDirections[t], this;
            }
            getSlopeY(t, e, i, b) {
                return i + (t - e) * b;
            }
            calculateSlope() {
                const { notes: t, stem_direction: e, render_options: { max_slope: i, min_slope: b, slope_iterations: a, slope_cost: n } } = this, s = t[0], l = function(t, e) {
                    const i = t.getStemExtents().topY, b = t.getStemX();
                    return (e.getStemExtents().topY - i) / (e.getStemX() - b);
                }(s, t[t.length - 1]), o = (i - b) / a;
                let r = Number.MAX_VALUE, h = 0, m = 0;
                for(let a = b; a <= i; a += o){
                    let i = 0, b = 0;
                    for(let n = 1; n < t.length; ++n){
                        const l = t[n];
                        if (l.hasStem() || l.isRest()) {
                            const t = this.getSlopeY(l.getStemX(), s.getStemX(), s.getStemExtents().topY, a) + b, o = l.getStemExtents().topY;
                            if (o * e < t * e) {
                                const a = Math.abs(o - t);
                                b += a * -e, i += a * n;
                            } else i += (o - t) * e;
                        }
                    }
                    const o = l / 2, c = n * Math.abs(o - a) + Math.abs(i);
                    c < r && (r = c, h = a, m = b);
                }
                this.slope = h, this.y_shift = m;
            }
            calculateFlatSlope() {
                const { notes: t, stem_direction: e, render_options: { beam_width: i, min_flat_beam_offset: b, flat_beam_offset: a } } = this;
                let n = 0, s = 0, l = 0, o = 0;
                for(let i = 0; i < t.length; i++){
                    const b = t[i], a = b.getStemExtents().topY;
                    n += a, e === at.DOWN && o < a ? (o = a, s = Math.max(...b.getYs()), l = b.getBeamCount()) : e === at.UP && (0 === o || o > a) && (o = a, s = Math.min(...b.getYs()), l = b.getBeamCount());
                }
                let r = n / t.length;
                const h = b + l * (1.5 * i), m = s + h * -e;
                e === at.DOWN && r < m ? r = s + h : e === at.UP && r > m && (r = s - h), a ? (e === at.DOWN && r > a || e === at.UP && r < a) && (this.render_options.flat_beam_offset = r) : this.render_options.flat_beam_offset = r, this.slope = 0, this.y_shift = 0;
            }
            getBeamYToDraw() {
                let t = this.notes[0].getStemExtents().topY;
                return this.render_options.flat_beams && this.render_options.flat_beam_offset && (t = this.render_options.flat_beam_offset), t;
            }
            applyStemExtensions() {
                const { notes: t, slope: e, y_shift: i, beam_count: b, render_options: { show_stemlets: a, stemlet_extension: n, beam_width: s } } = this, l = t[0], o = this.getBeamYToDraw(), r = l.getStemX();
                for(let l = 0; l < t.length; ++l){
                    const h = t[l], m = h.getStem();
                    if (m) {
                        const t = h.getStemX(), { topY: l } = h.getStemExtents(), c = this.getSlopeY(t, r, o, e) + i, d = m.getExtension(), _ = h.getStemDirection() === at.UP ? l - c : c - l;
                        let x = 0;
                        if (h.getStemDirection() !== this.stem_direction) x = (1 + 1.5 * (h.getGlyphProps().beam_count - 1)) * this.render_options.beam_width;
                        if (m.setExtension(d + _ + x), m.adjustHeightForBeam(), h.isRest() && a) {
                            const t = (b - 1) * s * 1.5 + s;
                            m.setVisibility(!0).setStemlet(!0, t + n);
                        }
                    }
                }
            }
            lookupBeamDirection(t, e, i, b, a) {
                if ("4" === t) return Fe;
                const n = this.forcedPartialDirections[a];
                if (n) return n;
                const s = "" + V.durationToNumber(t) / 2, l = e < V.durationToTicks(s), o = b < V.durationToTicks(s), r = i < V.durationToTicks(s);
                return l && o && r ? Oe : l && !o && r ? Fe : !l && o && r ? Me : this.lookupBeamDirection(s, e, i, b, a);
            }
            getBeamLines(t) {
                const e = V.durationToTicks(t);
                let i = !1;
                const b = [];
                let a;
                const n = this.render_options.partial_beam_length;
                let s = !1, l = 0;
                for(let o = 0; o < this.notes.length; ++o){
                    const r = this.notes[o];
                    l += r.getTicks().value();
                    let h = !1;
                    parseInt(t, 10) >= 8 && (h = -1 !== this.break_on_indices.indexOf(o), this.render_options.secondary_break_ticks && l >= this.render_options.secondary_break_ticks && (l = 0, h = !0));
                    const m = r.getIntrinsicTicks() < e, c = r.getStemX() - at.WIDTH / 2, d = this.notes[o - 1], _ = this.notes[o + 1], x = _ && _.getIntrinsicTicks() < e, g = d && d.getIntrinsicTicks() < e, y = d && _ && m && !g && !x;
                    if (m) {
                        if (i) a = b[b.length - 1], a.end = c, h && (i = !1, _ && !x && void 0 === a.end && (a.end = a.start - n));
                        else {
                            if (a = {
                                start: c,
                                end: void 0
                            }, i = !0, y) {
                                const e = d.getIntrinsicTicks(), i = _.getIntrinsicTicks(), b = r.getIntrinsicTicks(), s = this.lookupBeamDirection(t, e, b, i, o);
                                [
                                    Fe,
                                    Oe
                                ].includes(s) ? a.end = a.start - n : a.end = a.start + n;
                            } else x ? h && (a.end = a.start - n, i = !1) : a.end = (s || 0 === o) && _ ? a.start + n : a.start - n;
                            b.push(a);
                        }
                    } else i = !1;
                    s = h;
                }
                const o = b[b.length - 1];
                return o && void 0 === o.end && (o.end = o.start - n), b;
            }
            drawStems(t) {
                this.notes.forEach((e)=>{
                    const i = e.getStem();
                    if (i) {
                        const b = e.getStemX();
                        i.setNoteHeadXBounds(b, b), i.setContext(t).draw();
                    }
                }, this);
            }
            drawBeamLines(t) {
                const e = [
                    "4",
                    "8",
                    "16",
                    "32",
                    "64"
                ], i = this.notes[0];
                let b = this.getBeamYToDraw();
                const a = i.getStemX(), n = this.render_options.beam_width * this.stem_direction;
                for(let i = 0; i < e.length; ++i){
                    const s = e[i], l = this.getBeamLines(s);
                    for(let e = 0; e < l.length; ++e){
                        const i = l[e], s = i.start, o = this.getSlopeY(s, a, b, this.slope), r = i.end;
                        if (!r) throw new g("NoLastBeamX", "lastBeamX undefined.");
                        {
                            const e = this.getSlopeY(r, a, b, this.slope);
                            t.beginPath(), t.moveTo(s, o), t.lineTo(s, o + n), t.lineTo(r + 1, e + n), t.lineTo(r + 1, e), t.closePath(), t.fill();
                        }
                    }
                    b += 1.5 * n;
                }
            }
            preFormat() {
                return this;
            }
            postFormat() {
                this.postFormatted || (_(this.notes[0]) || this.render_options.flat_beams ? this.calculateFlatSlope() : this.calculateSlope(), this.applyStemExtensions(), this.postFormatted = !0);
            }
            draw() {
                const t = this.checkContext();
                this.setRendered(), this.unbeamable || (this.postFormatted || this.postFormat(), this.drawStems(t), this.applyStyle(), t.openGroup("beam", this.getAttribute("id")), this.drawBeamLines(t), t.closeGroup(), this.restoreStyle());
            }
        }
        class Le extends vt {
            static get CATEGORY() {
                return x.ClefNote;
            }
            constructor(t, e, i){
                super({
                    duration: "b"
                }), this.type = t;
                const b = new de(t, e, i);
                this.clef = b.clef, this.annotation = b.annotation, this.size = void 0 === e ? "default" : e, this.setWidth(Z.getWidth(this.clef.code, de.getPoint(this.size), `clefNote_${this.size}`)), this.ignore_ticks = !0;
            }
            setType(t, e, i) {
                this.type = t, this.size = e;
                const b = new de(t, e, i);
                return this.clef = b.clef, this.annotation = b.annotation, this.setWidth(Z.getWidth(this.clef.code, de.getPoint(this.size), `clefNote_${this.size}`)), this;
            }
            getClef() {
                return this.clef;
            }
            preFormat() {
                return this.preFormatted = !0, this;
            }
            draw() {
                const t = this.checkStave(), e = this.checkContext();
                this.setRendered();
                const i = this.getAbsoluteX();
                if (Z.renderGlyph(e, i, t.getYForLine(this.clef.line), de.getPoint(this.size), this.clef.code, {
                    category: `clefNote_${this.size}`
                }), void 0 !== this.annotation) {
                    const b = new Z(this.annotation.code, this.annotation.point);
                    b.setContext(e), b.setStave(t), b.setYShift(t.getYForLine(this.annotation.line) - t.getYForGlyphs()), b.setXShift(this.annotation.x_shift), b.renderToStave(i);
                }
            }
        }
        class We extends vt {
            static get CATEGORY() {
                return x.Crescendo;
            }
            constructor(t){
                super(t), this.options = {
                    extend_left: 0,
                    extend_right: 0,
                    y_shift: 0
                }, this.decrescendo = !1, this.line = t.line || 0, this.height = 15;
            }
            setLine(t) {
                return this.line = t, this;
            }
            setHeight(t) {
                return this.height = t, this;
            }
            setDecrescendo(t) {
                return this.decrescendo = t, this;
            }
            preFormat() {
                return this.preFormatted = !0, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkStave();
                this.setRendered();
                const i = this.getTickContext(), b = Ce.getNextContext(i), a = this.getAbsoluteX(), n = b ? b.getX() : e.getX() + e.getWidth(), s = e.getYForLine(this.line + -3) + 1;
                !function(...t) {
                    We.DEBUG && u("Vex.Flow.Crescendo", t);
                }("Drawing ", this.decrescendo ? "decrescendo " : "crescendo ", this.height, "x", a - n), function(t, e) {
                    const i = e.begin_x, b = e.end_x, a = e.y, n = e.height / 2;
                    t.beginPath(), e.reverse ? (t.moveTo(i, a - n), t.lineTo(b, a), t.lineTo(i, a + n)) : (t.moveTo(b, a - n), t.lineTo(i, a), t.lineTo(b, a + n)), t.stroke(), t.closePath();
                }(t, {
                    begin_x: a - this.options.extend_left,
                    end_x: n + this.options.extend_right,
                    y: s + this.options.y_shift,
                    height: this.height,
                    reverse: this.decrescendo
                });
            }
        }
        var Ue;
        We.DEBUG = !1, function(t) {
            t[t.NEAR_HEAD = 1] = "NEAR_HEAD", t[t.NEAR_TOP = 2] = "NEAR_TOP";
        }(Ue || (Ue = {}));
        class Ie extends R {
            static get CATEGORY() {
                return x.Curve;
            }
            static get Position() {
                return Ue;
            }
            static get PositionString() {
                return {
                    nearHead: Ue.NEAR_HEAD,
                    nearTop: Ue.NEAR_TOP
                };
            }
            constructor(t, e, i){
                super(), this.render_options = Object.assign({
                    thickness: 2,
                    x_shift: 0,
                    y_shift: 10,
                    position: Ue.NEAR_HEAD,
                    position_end: Ue.NEAR_HEAD,
                    invert: !1,
                    cps: [
                        {
                            x: 0,
                            y: 10
                        },
                        {
                            x: 0,
                            y: 10
                        }
                    ]
                }, i), this.from = t, this.to = e;
            }
            setNotes(t, e) {
                if (!t && !e) throw new g("BadArguments", "Curve needs to have either `from` or `to` set.");
                return this.from = t, this.to = e, this;
            }
            isPartial() {
                return !this.from || !this.to;
            }
            renderCurve(t) {
                const e = this.checkContext(), i = this.render_options.x_shift, b = this.render_options.y_shift * t.direction, a = t.first_x + i, n = t.first_y + b, s = t.last_x - i, l = t.last_y + b, o = this.render_options.thickness, r = this.render_options.cps, { x: h, y: m } = r[0], { x: c, y: d } = r[1], _ = (s - a) / (r.length + 2);
                e.beginPath(), e.moveTo(a, n), e.bezierCurveTo(a + _ + h, n + m * t.direction, s - _ + c, l + d * t.direction, s, l), e.bezierCurveTo(s - _ + c, l + (d + o) * t.direction, a + _ + h, n + (m + o) * t.direction, a, n), e.stroke(), e.closePath(), e.fill();
            }
            draw() {
                this.checkContext(), this.setRendered();
                const t = this.from, e = this.to;
                let i, b, a, n, s = 0, l = "baseY", o = "baseY";
                function r(t) {
                    return "string" == typeof t ? Ie.PositionString[t] : t;
                }
                const h = r(this.render_options.position), m = r(this.render_options.position_end);
                if (h === Ue.NEAR_TOP && (l = "topY", o = "topY"), m === Ue.NEAR_HEAD ? o = "baseY" : m === Ue.NEAR_TOP && (o = "topY"), t) i = t.getTieRightX(), s = t.getStemDirection(), a = t.getStemExtents()[l];
                else i = e.checkStave().getTieStartX(), a = e.getStemExtents()[l];
                if (e) b = e.getTieLeftX(), s = e.getStemDirection(), n = e.getStemExtents()[o];
                else b = t.checkStave().getTieEndX(), n = t.getStemExtents()[o];
                return this.renderCurve({
                    first_x: i,
                    last_x: b,
                    first_y: a,
                    last_y: n,
                    direction: s * (!0 === this.render_options.invert ? -1 : 1)
                }), !0;
            }
        }
        function Ge(...t) {
            Ye.DEBUG && u("Vex.Flow.Parser", t);
        }
        function He(t) {
            if ("matchedString" in t) return t.matchedString;
            if ("results" in t) return He(t.results);
            const e = t;
            return 1 === e.length ? He(e[0]) : 0 === e.length ? null : e.map(He);
        }
        class Ye {
            constructor(t){
                this.grammar = t, this.line = "", this.pos = 0, this.errorPos = -1;
            }
            parse(t) {
                this.line = t, this.pos = 0, this.errorPos = -1;
                const e = this.expect(this.grammar.begin());
                return e.errorPos = this.errorPos, e;
            }
            matchFail(t) {
                -1 === this.errorPos && (this.errorPos = this.pos), this.pos = t;
            }
            matchSuccess() {
                this.errorPos = -1;
            }
            matchToken(t, e = !1) {
                const i = e ? new RegExp("^((" + t + "))") : new RegExp("^((" + t + ")\\s*)"), b = this.line.slice(this.pos).match(i);
                return null !== b ? {
                    success: !0,
                    matchedString: b[2],
                    incrementPos: b[1].length,
                    pos: this.pos
                } : {
                    success: !1,
                    pos: this.pos
                };
            }
            expectOne(t, e = !1) {
                const i = [], b = this.pos;
                let a = !0, n = !1;
                if (e = !0 === e || !0 === t.maybe, t.expect) for (const e of t.expect){
                    const b = this.pos, s = this.expect(e);
                    if (s.success) {
                        if (i.push(s), n = !0, t.or) break;
                    } else if (a = !1, !t.or) {
                        this.pos = b;
                        break;
                    }
                }
                const s = t.or && n || a, l = s || !0 === e, o = s ? 1 : 0;
                return e && !s && (this.pos = b), l ? this.matchSuccess() : this.matchFail(b), {
                    success: l,
                    results: i,
                    numMatches: o
                };
            }
            expectOneOrMore(t, e = !1) {
                const i = [], b = this.pos;
                let a = 0, n = !0;
                do {
                    const e = this.expectOne(t);
                    e.success && e.results ? (a++, i.push(e.results)) : n = !1;
                }while (n);
                const s = a > 0 || !0 === e;
                return !e || a > 0 || (this.pos = b), s ? this.matchSuccess() : this.matchFail(b), {
                    success: s,
                    results: i,
                    numMatches: a
                };
            }
            expectZeroOrMore(t) {
                return this.expectOneOrMore(t, !0);
            }
            expect(t) {
                if (Ge("Evaluating rule function:", t), !t) throw new g("Invalid rule function");
                let e;
                const i = t.bind(this.grammar)();
                if (i.token) e = this.matchToken(i.token, !0 === i.noSpace), e.success && (this.pos += e.incrementPos);
                else {
                    if (!i.expect) throw Ge(i), new g("Bad grammar! No `token` or `expect` property " + i);
                    e = i.oneOrMore ? this.expectOneOrMore(i) : i.zeroOrMore ? this.expectZeroOrMore(i) : this.expectOne(i);
                }
                const b = [];
                return e.matches = b, e.results && e.results.forEach((t)=>b.push(He(t))), i.run && e.success && i.run({
                    matches: b
                }), e;
            }
        }
        function Xe(...t) {
            Qe.DEBUG && u("Vex.Flow.EasyScore", t);
        }
        Ye.DEBUG = !1;
        class je {
            constructor(t){
                this.builder = t;
            }
            begin() {
                return this.LINE;
            }
            LINE() {
                return {
                    expect: [
                        this.PIECE,
                        this.PIECES,
                        this.EOL
                    ]
                };
            }
            PIECE() {
                return {
                    expect: [
                        this.CHORDORNOTE,
                        this.PARAMS
                    ],
                    run: ()=>this.builder.commitPiece()
                };
            }
            PIECES() {
                return {
                    expect: [
                        this.COMMA,
                        this.PIECE
                    ],
                    zeroOrMore: !0
                };
            }
            PARAMS() {
                return {
                    expect: [
                        this.DURATION,
                        this.TYPE,
                        this.DOTS,
                        this.OPTS
                    ]
                };
            }
            CHORDORNOTE() {
                return {
                    expect: [
                        this.CHORD,
                        this.SINGLENOTE
                    ],
                    or: !0
                };
            }
            CHORD() {
                return {
                    expect: [
                        this.LPAREN,
                        this.NOTES,
                        this.RPAREN
                    ],
                    run: (t)=>this.builder.addChord(t.matches[1])
                };
            }
            NOTES() {
                return {
                    expect: [
                        this.NOTE
                    ],
                    oneOrMore: !0
                };
            }
            NOTE() {
                return {
                    expect: [
                        this.NOTENAME,
                        this.ACCIDENTAL,
                        this.OCTAVE
                    ]
                };
            }
            SINGLENOTE() {
                return {
                    expect: [
                        this.NOTENAME,
                        this.ACCIDENTAL,
                        this.OCTAVE
                    ],
                    run: (t)=>{
                        const e = t;
                        this.builder.addSingleNote(e.matches[0], e.matches[1], e.matches[2]);
                    }
                };
            }
            ACCIDENTAL() {
                return {
                    expect: [
                        this.MICROTONES,
                        this.ACCIDENTALS
                    ],
                    maybe: !0,
                    or: !0
                };
            }
            DOTS() {
                return {
                    expect: [
                        this.DOT
                    ],
                    zeroOrMore: !0,
                    run: (t)=>this.builder.setNoteDots(t.matches)
                };
            }
            TYPE() {
                return {
                    expect: [
                        this.SLASH,
                        this.MAYBESLASH,
                        this.TYPES
                    ],
                    maybe: !0,
                    run: (t)=>this.builder.setNoteType(t.matches[2])
                };
            }
            DURATION() {
                return {
                    expect: [
                        this.SLASH,
                        this.DURATIONS
                    ],
                    maybe: !0,
                    run: (t)=>this.builder.setNoteDuration(t.matches[1])
                };
            }
            OPTS() {
                return {
                    expect: [
                        this.LBRACKET,
                        this.KEYVAL,
                        this.KEYVALS,
                        this.RBRACKET
                    ],
                    maybe: !0
                };
            }
            KEYVALS() {
                return {
                    expect: [
                        this.COMMA,
                        this.KEYVAL
                    ],
                    zeroOrMore: !0
                };
            }
            KEYVAL() {
                return {
                    expect: [
                        this.KEY,
                        this.EQUALS,
                        this.VAL
                    ],
                    run: (t)=>this.builder.addNoteOption(t.matches[0], t.matches[2].slice(1, -1))
                };
            }
            VAL() {
                return {
                    expect: [
                        this.SVAL,
                        this.DVAL
                    ],
                    or: !0
                };
            }
            KEY() {
                return {
                    token: "[a-zA-Z][a-zA-Z0-9]*"
                };
            }
            DVAL() {
                return {
                    token: '["][^"]*["]'
                };
            }
            SVAL() {
                return {
                    token: "['][^']*[']"
                };
            }
            NOTENAME() {
                return {
                    token: "[a-gA-G]"
                };
            }
            OCTAVE() {
                return {
                    token: "[0-9]+"
                };
            }
            ACCIDENTALS() {
                return {
                    token: "bb|b|##|#|n"
                };
            }
            MICROTONES() {
                return {
                    token: "bbs|bss|bs|db|d|\\+\\+-|\\+-|\\+\\+|\\+|k|o"
                };
            }
            DURATIONS() {
                return {
                    token: "[0-9whq]+"
                };
            }
            TYPES() {
                return {
                    token: "[rRsSmMhHgG]"
                };
            }
            LPAREN() {
                return {
                    token: "[(]"
                };
            }
            RPAREN() {
                return {
                    token: "[)]"
                };
            }
            COMMA() {
                return {
                    token: "[,]"
                };
            }
            DOT() {
                return {
                    token: "[.]"
                };
            }
            SLASH() {
                return {
                    token: "[/]"
                };
            }
            MAYBESLASH() {
                return {
                    token: "[/]?"
                };
            }
            EQUALS() {
                return {
                    token: "[=]"
                };
            }
            LBRACKET() {
                return {
                    token: "\\["
                };
            }
            RBRACKET() {
                return {
                    token: "\\]"
                };
            }
            EOL() {
                return {
                    token: "$"
                };
            }
        }
        class Ve {
            constructor(t){
                this.chord = [], this.dots = 0, this.options = {}, this.duration = t;
            }
        }
        class Ke {
            constructor(t){
                this.commitHooks = [], this.factory = t, this.reset();
            }
            reset(t) {
                this.options = Object.assign({
                    stem: "auto",
                    clef: "treble"
                }, t), this.elements = {
                    notes: [],
                    accidentals: []
                }, this.rollingDuration = "8", this.resetPiece();
            }
            getFactory() {
                return this.factory;
            }
            getElements() {
                return this.elements;
            }
            addCommitHook(t) {
                this.commitHooks.push(t);
            }
            resetPiece() {
                Xe("resetPiece"), this.piece = new Ve(this.rollingDuration);
            }
            setNoteDots(t) {
                Xe("setNoteDots:", t), t && (this.piece.dots = t.length);
            }
            setNoteDuration(t) {
                Xe("setNoteDuration:", t), this.rollingDuration = this.piece.duration = t || this.rollingDuration;
            }
            setNoteType(t) {
                Xe("setNoteType:", t), t && (this.piece.type = t);
            }
            addNoteOption(t, e) {
                Xe("addNoteOption: key:", t, "value:", e), this.piece.options[t] = e;
            }
            addNote(t, e, i) {
                Xe("addNote:", t, e, i), this.piece.chord.push({
                    key: t,
                    accid: e,
                    octave: i
                });
            }
            addSingleNote(t, e, i) {
                Xe("addSingleNote:", t, e, i), this.addNote(t, e, i);
            }
            addChord(t) {
                Xe("startChord"), "object" != typeof t[0] ? this.addSingleNote(t[0]) : t.forEach((t)=>{
                    t && this.addNote(...t);
                }), Xe("endChord");
            }
            commitPiece() {
                Xe("commitPiece");
                const { factory: t } = this;
                if (!t) return;
                const e = Object.assign(Object.assign({}, this.options), this.piece.options), i = p(e.stem, "BadArguments", "options.stem is not defined").toLowerCase(), b = p(e.clef, "BadArguments", "options.clef is not defined").toLowerCase(), { chord: a, duration: n, dots: s, type: l } = this.piece, o = et.accidentals, r = a.map((t)=>{
                    var e;
                    return t.key + (o.includes(null !== (e = t.accid) && void 0 !== e ? e : "") ? t.accid : "") + "/" + t.octave;
                }), h = "auto" === i, m = "g" == (null == l ? void 0 : l.toLowerCase()) ? t.GhostNote({
                    duration: n,
                    dots: s
                }) : t.StaveNote({
                    keys: r,
                    duration: n,
                    dots: s,
                    type: l,
                    clef: b,
                    auto_stem: h
                });
                h || m.setStemDirection("up" === i ? at.UP : at.DOWN);
                const c = [];
                a.forEach((e, i)=>{
                    const b = e.accid;
                    if ("string" == typeof b) {
                        const e = t.Accidental({
                            type: b
                        });
                        m.addModifier(e, i), c.push(e);
                    } else c.push(void 0);
                });
                for(let t = 0; t < s; t++)Ot.buildAndAttach([
                    m
                ], {
                    all: !0
                });
                this.commitHooks.forEach((t)=>t(e, m, this)), this.elements.notes.push(m), this.elements.accidentals.push(c), this.resetPiece();
            }
        }
        function $e(t, e) {
            void 0 !== t.id && e.setAttribute("id", t.id);
        }
        const Je = /\s*,\s*/;
        function qe(t, e) {
            void 0 !== t.class && t.class.split(Je).forEach((t)=>e.addClass(t));
        }
        class Qe {
            constructor(t = {}){
                this.defaults = {
                    clef: "treble",
                    time: "4/4",
                    stem: "auto"
                }, this.setOptions(t);
            }
            set(t) {
                return this.defaults = Object.assign(Object.assign({}, this.defaults), t), this;
            }
            setOptions(t) {
                var e, i;
                const b = t.factory, a = null !== (e = t.builder) && void 0 !== e ? e : new Ke(b);
                return this.options = Object.assign(Object.assign({
                    commitHooks: [
                        $e,
                        qe,
                        ut.easyScoreHook,
                        Rt.easyScoreHook
                    ],
                    throwOnError: !1
                }, t), {
                    factory: b,
                    builder: a
                }), this.factory = b, this.builder = a, this.grammar = new je(this.builder), this.parser = new Ye(this.grammar), null === (i = this.options.commitHooks) || void 0 === i || i.forEach((t)=>this.addCommitHook(t)), this;
            }
            setContext(t) {
                return this.factory.setContext(t), this;
            }
            parse(t, e = {}) {
                this.builder.reset(e);
                const i = this.parser.parse(t);
                if (!i.success && this.options.throwOnError) throw Xe(i), new g("Error parsing line: " + t);
                return i;
            }
            beam(t, e) {
                return this.factory.Beam({
                    notes: t,
                    options: e
                }), t;
            }
            tuplet(t, e) {
                return this.factory.Tuplet({
                    notes: t,
                    options: e
                }), t;
            }
            notes(t, e = {}) {
                return e = Object.assign({
                    clef: this.defaults.clef,
                    stem: this.defaults.stem
                }, e), this.parse(t, e), this.builder.getElements().notes;
            }
            voice(t, e = {}) {
                return e = Object.assign({
                    time: this.defaults.time
                }, e), this.factory.Voice(e).addTickables(t);
            }
            addCommitHook(t) {
                this.builder.addCommitHook(t);
            }
        }
        Qe.DEBUG = !1;
        const Ze = "Ghost note must have valid initialization data to identify duration.";
        class ti extends Wt {
            static get CATEGORY() {
                return x.GhostNote;
            }
            constructor(t){
                if (!t) throw new g("BadArguments", Ze);
                let e;
                if ("string" == typeof t) e = {
                    duration: t
                };
                else {
                    if ("object" != typeof t) throw new g("BadArguments", Ze);
                    e = t;
                }
                super(e), this.setWidth(0);
            }
            isRest() {
                return !0;
            }
            setStave(t) {
                return super.setStave(t), this;
            }
            addToModifierContext(t) {
                return this;
            }
            preFormat() {
                return this.preFormatted = !0, this;
            }
            draw() {
                this.setRendered();
                for(let t = 0; t < this.modifiers.length; ++t){
                    const e = this.modifiers[t];
                    n(e) && (e.setContext(this.getContext()), e.drawWithStyle());
                }
            }
        }
        class ei extends vt {
            static get CATEGORY() {
                return x.GlyphNote;
            }
            constructor(t, e, i){
                super(e), this.options = Object.assign({
                    ignoreTicks: !1,
                    line: 2
                }, i), this.ignore_ticks = this.options.ignoreTicks, this.setGlyph(t);
            }
            setGlyph(t) {
                return this.glyph = t, this.setWidth(this.glyph.getMetrics().width), this;
            }
            getBoundingBox() {
                return this.glyph.getBoundingBox();
            }
            preFormat() {
                return !this.preFormatted && this.modifierContext && this.modifierContext.preFormat(), this.preFormatted = !0, this;
            }
            drawModifiers() {
                const t = this.checkContext();
                for(let e = 0; e < this.modifiers.length; e++){
                    const i = this.modifiers[e];
                    i.setContext(t), i.drawWithStyle();
                }
            }
            getGlyphWidth() {
                return this.glyph.getMetrics().width;
            }
            draw() {
                const t = this.checkStave(), e = t.checkContext();
                this.setRendered(), this.applyStyle(e), e.openGroup("glyphNote", this.getAttribute("id"));
                const i = this.glyph;
                i.getContext() || i.setContext(e), i.setStave(t), i.setYShift(t.getYForLine(this.options.line) - t.getYForGlyphs());
                const b = this.isCenterAligned() ? this.getAbsoluteX() - this.getWidth() / 2 : this.getAbsoluteX();
                i.renderToStave(b), this.drawModifiers(), e.closeGroup(), this.restoreStyle(e);
            }
        }
        class ii extends It {
            static get CATEGORY() {
                return x.GraceNote;
            }
            static get LEDGER_LINE_OFFSET() {
                return 2;
            }
            static get SCALE() {
                return .66;
            }
            constructor(t){
                super(Object.assign({
                    glyph_font_scale: V.NOTATION_FONT_SCALE * ii.SCALE,
                    stroke_px: ii.LEDGER_LINE_OFFSET
                }, t)), this.slash = t.slash || !1, this.slur = !0, this.buildNoteHeads(), this.width = 3;
            }
            getStemExtension() {
                if (this.stem_extension_override) return this.stem_extension_override;
                const t = this.getGlyphProps();
                if (t) {
                    let e = super.getStemExtension();
                    if (t.stem) {
                        const t = this.getStaveNoteScale();
                        e = (at.HEIGHT + e) * t - at.HEIGHT;
                    }
                    return e;
                }
                return 0;
            }
            getStaveNoteScale() {
                return this.render_options.glyph_font_scale / V.NOTATION_FONT_SCALE;
            }
            draw() {
                super.draw(), this.setRendered();
                const t = this.stem;
                if (this.slash && t) {
                    const e = this.getStaveNoteScale(), i = e / .66;
                    let b;
                    const a = this.beam;
                    if (a) a.postFormatted || a.postFormat(), b = this.calcBeamedNotesSlashBBox(8 * i, 8 * i, {
                        stem: 6 * i,
                        beam: 5 * i
                    });
                    else {
                        const a = this.getStemDirection(), n = this.getNoteHeadBounds(), s = t.getHeight();
                        let l = this.getAbsoluteX(), o = a === at.DOWN ? n.y_top - s : n.y_bottom - s;
                        const r = a === at.DOWN ? this.glyphProps.stem_down_extension : this.glyphProps.stem_up_extension;
                        let h = V.STEM_HEIGHT;
                        h -= h / 2.8, h += r, o += h * e * a;
                        const m = a === at.UP ? {
                            x1: 1,
                            y1: 0,
                            x2: 13,
                            y2: -9
                        } : {
                            x1: -4,
                            y1: 1,
                            x2: 13,
                            y2: 9
                        };
                        l += m.x1 * i, o += m.y1 * i, b = {
                            x1: l,
                            y1: o,
                            x2: l + m.x2 * i,
                            y2: o + m.y2 * i
                        };
                    }
                    const n = this.checkContext();
                    n.save(), n.setLineWidth(1 * i), n.beginPath(), n.moveTo(b.x1, b.y1), n.lineTo(b.x2, b.y2), n.closePath(), n.stroke(), n.restore();
                }
            }
            calcBeamedNotesSlashBBox(t, e, i) {
                const b = this.beam;
                if (!b) throw new g("NoBeam", "Can't calculate without a beam.");
                const a = b.slope, n = b.notes[b.notes.length - 1] === this ? -1 : 1, s = Math.atan(a * n), l = Math.cos(s) * e, o = Math.sin(s) * e;
                t *= this.getStemDirection();
                const r = Math.atan((o - t) / l), h = Math.cos(r) * i.stem * n, m = Math.sin(r) * i.stem, c = Math.cos(r) * i.beam * n, d = Math.sin(r) * i.beam, _ = this.getStemX(), x = b.notes[0].getStemX(), y = b.getBeamYToDraw() + (_ - x) * a;
                return {
                    x1: _ - h,
                    y1: y + t - m,
                    x2: _ + l * n + c,
                    y2: y + o + d
                };
            }
        }
        class bi extends vt {
            static get CATEGORY() {
                return x.KeySigNote;
            }
            constructor(t, e, i){
                super({
                    duration: "b"
                }), this.keySignature = new _e(t, e, i), this.ignore_ticks = !0;
            }
            addToModifierContext(t) {
                return this;
            }
            preFormat() {
                return this.preFormatted = !0, this.keySignature.setStave(this.checkStave()), this.setWidth(this.keySignature.getWidth()), this;
            }
            draw() {
                const t = this.checkStave().checkContext();
                this.setRendered(), this.keySignature.setX(this.getAbsoluteX()), this.keySignature.setContext(t), this.keySignature.draw();
            }
        }
        let ai;
        class ni extends R {
            static get CATEGORY() {
                return x.MultiMeasureRest;
            }
            constructor(t, e){
                var i;
                super(), this.xs = {
                    left: NaN,
                    right: NaN
                }, this.hasPaddingLeft = !1, this.hasPaddingRight = !1, this.hasLineThickness = !1, this.hasSymbolSpacing = !1, this.number_of_measures = t, this.hasPaddingLeft = "number" == typeof e.padding_left, this.hasPaddingRight = "number" == typeof e.padding_right, this.hasLineThickness = "number" == typeof e.line_thickness, this.hasSymbolSpacing = "number" == typeof e.symbol_spacing;
                const b = V.currentMusicFont();
                this.render_options = Object.assign({
                    use_symbols: !1,
                    show_number: !0,
                    number_line: -0.5,
                    number_glyph_point: null !== (i = b.lookupMetric("digits.point")) && void 0 !== i ? i : V.NOTATION_FONT_SCALE,
                    line: 2,
                    spacing_between_lines_px: V.STAVE_LINE_DISTANCE,
                    serif_thickness: 2,
                    semibreve_rest_glyph_scale: V.NOTATION_FONT_SCALE,
                    padding_left: 0,
                    padding_right: 0,
                    line_thickness: 5,
                    symbol_spacing: 0
                }, e);
                const a = b.lookupMetric("digits.shiftLine", 0);
                this.render_options.number_line += a;
            }
            getXs() {
                return this.xs;
            }
            setStave(t) {
                return this.stave = t, this;
            }
            getStave() {
                return this.stave;
            }
            checkStave() {
                return p(this.stave, "NoStave", "No stave attached to instance.");
            }
            drawLine(t, e, i, b, a) {
                const n = this.render_options, s = t.getYForLine(n.line), l = .1 * (b - i);
                let o;
                i += l, b -= l, o = this.hasLineThickness ? .5 * n.line_thickness : .25 * a;
                const r = n.serif_thickness, h = s - a, m = s + a, c = i + r, d = b - r, _ = s - o, x = s + o;
                e.save(), e.beginPath(), e.moveTo(i, h), e.lineTo(c, h), e.lineTo(c, _), e.lineTo(d, _), e.lineTo(d, h), e.lineTo(b, h), e.lineTo(b, m), e.lineTo(d, m), e.lineTo(d, x), e.lineTo(c, x), e.lineTo(c, m), e.lineTo(i, m), e.closePath(), e.fill();
            }
            drawSymbols(t, e, i, b, a) {
                const n = Math.floor(this.number_of_measures / 4), s = this.number_of_measures % 4, l = Math.floor(s / 2), o = s % 2, r = this.render_options;
                ai = void 0;
                const h = function() {
                    if (!ai) {
                        const t = new Lt({
                            duration: "w",
                            note_type: "r"
                        });
                        ai = {
                            glyph_font_scale: t.render_options.glyph_font_scale,
                            glyph_code: t.glyph_code,
                            width: t.getWidth()
                        };
                    }
                    return ai;
                }(), m = r.semibreve_rest_glyph_scale, c = h.width * (m / h.glyph_font_scale), d = {
                    2: {
                        width: .5 * c,
                        height: a
                    },
                    1: {
                        width: c
                    }
                }, _ = this.hasSymbolSpacing ? r.symbol_spacing : 10;
                let x = i + .5 * (b - i) - .5 * (n * d[2].width + l * d[2].width + o * d[1].width + (n + l + o - 1) * _);
                const g = r.line, y = t.getYForLine(g - 1), p = t.getYForLine(g), u = t.getYForLine(g + 1);
                e.save(), e.setStrokeStyle("none"), e.setLineWidth(0);
                for(let t = 0; t < n; ++t)e.fillRect(x, p - d[2].height, d[2].width, d[2].height), e.fillRect(x, u - d[2].height, d[2].width, d[2].height), x += d[2].width + _;
                for(let t = 0; t < l; ++t)e.fillRect(x, p - d[2].height, d[2].width, d[2].height), x += d[2].width + _;
                for(let t = 0; t < o; ++t)Z.renderGlyph(e, x, y, m, h.glyph_code), x += d[1].width + _;
                e.restore();
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                const e = this.checkStave();
                let i = e.getNoteStartX(), b = e.getNoteEndX();
                const a = e.getModifiers(wt.BEGIN);
                1 === a.length && s(a[0]) && (i -= a[0].getWidth());
                const n = this.render_options;
                this.hasPaddingLeft && (i = e.getX() + n.padding_left), this.hasPaddingRight && (b = e.getX() + e.getWidth() - n.padding_right), this.xs.left = i, this.xs.right = b;
                const l = n.spacing_between_lines_px;
                if (n.use_symbols ? this.drawSymbols(e, t, i, b, l) : this.drawLine(e, t, i, b, l), n.show_number) {
                    const a = "/" + this.number_of_measures, s = new Te(a, 0, !1);
                    s.point = n.number_glyph_point, s.setTimeSig(a), s.setStave(e), s.setX(i + .5 * (b - i) - .5 * s.getInfo().glyph.getMetrics().width), s.bottomLine = n.number_line, s.setContext(t).draw();
                }
            }
        }
        function si(t, e, i, b, a) {
            const n = li.GLYPHS[t], s = new Z(n.code, a, {
                category: "pedalMarking"
            });
            s.render(e, i - (s.getMetrics().width - V.STAVE_LINE_DISTANCE) / 2, b);
        }
        class li extends R {
            static get CATEGORY() {
                return x.PedalMarking;
            }
            static createSustain(t) {
                return new li(t);
            }
            static createSostenuto(t) {
                const e = new li(t);
                return e.setType(li.type.MIXED), e.setCustomText("Sost. Ped."), e;
            }
            static createUnaCorda(t) {
                const e = new li(t);
                return e.setType(li.type.TEXT), e.setCustomText("una corda", "tre corda"), e;
            }
            constructor(t){
                super(), this.notes = t, this.type = li.type.TEXT, this.line = 0, this.custom_depress_text = "", this.custom_release_text = "", this.resetFont(), this.render_options = {
                    bracket_height: 10,
                    text_margin_right: 6,
                    bracket_line_width: 1,
                    color: "black"
                };
            }
            setType(t) {
                return (t = "string" == typeof t ? li.typeString[t] : t) >= li.type.TEXT && t <= li.type.MIXED && (this.type = t), this;
            }
            setCustomText(t, e) {
                return this.custom_depress_text = t || "", this.custom_release_text = e || "", this;
            }
            setLine(t) {
                return this.line = t, this;
            }
            drawBracketed() {
                const t = this.checkContext();
                let e, i, b = !1;
                this.notes.forEach((a, n, s)=>{
                    var l;
                    b = !b;
                    const o = a.getAbsoluteX(), r = a.checkStave().getYForBottomText(this.line + 3);
                    if (o < e) throw new g("InvalidConfiguration", "The notes provided must be in order of ascending x positions");
                    const h = s[n + 1] === a, m = s[n - 1] === a;
                    let c = 0;
                    const d = null !== (l = V.currentMusicFont().lookupMetric(`pedalMarking.${b ? "down" : "up"}.point`)) && void 0 !== l ? l : V.NOTATION_FONT_SCALE;
                    if (b) {
                        if (c = m ? 5 : 0, this.type !== li.type.MIXED || m) t.beginPath(), t.moveTo(o, r - this.render_options.bracket_height), t.lineTo(o + c, r), t.stroke(), t.closePath();
                        else if (this.custom_depress_text) {
                            const e = t.measureText(this.custom_depress_text).width;
                            t.fillText(this.custom_depress_text, o - e / 2, r), c = e / 2 + this.render_options.text_margin_right;
                        } else si("pedal_depress", t, o, r, d), c = 20 + this.render_options.text_margin_right;
                    } else c = h ? -5 : 0, t.beginPath(), t.moveTo(e, i), t.lineTo(o + c, r), t.lineTo(o, r - this.render_options.bracket_height), t.stroke(), t.closePath();
                    e = o + c, i = r;
                });
            }
            drawText() {
                const t = this.checkContext();
                let e = !1;
                this.notes.forEach((i)=>{
                    var b;
                    e = !e;
                    const a = i.checkStave(), n = i.getAbsoluteX(), s = a.getYForBottomText(this.line + 3), l = null !== (b = V.currentMusicFont().lookupMetric(`pedalMarking.${e ? "down" : "up"}.point`)) && void 0 !== b ? b : V.NOTATION_FONT_SCALE;
                    let o = 0;
                    e ? this.custom_depress_text ? (o = t.measureText(this.custom_depress_text).width, t.fillText(this.custom_depress_text, n - o / 2, s)) : si("pedal_depress", t, n, s, l) : this.custom_release_text ? (o = t.measureText(this.custom_release_text).width, t.fillText(this.custom_release_text, n - o / 2, s)) : si("pedal_release", t, n, s, l);
                });
            }
            draw() {
                const t = this.checkContext();
                this.setRendered(), t.save(), t.setStrokeStyle(this.render_options.color), t.setFillStyle(this.render_options.color), t.setFont(this.textFont), function(...t) {
                    li.DEBUG && u("Vex.Flow.PedalMarking", t);
                }("Rendering Pedal Marking"), this.type === li.type.BRACKET || this.type === li.type.MIXED ? (t.setLineWidth(this.render_options.bracket_line_width), this.drawBracketed()) : this.type === li.type.TEXT && this.drawText(), t.restore();
            }
        }
        li.DEBUG = !1, li.TEXT_FONT = {
            family: F.SERIF,
            size: 12,
            weight: E.BOLD,
            style: P.ITALIC
        }, li.GLYPHS = {
            pedal_depress: {
                code: "keyboardPedalPed"
            },
            pedal_release: {
                code: "keyboardPedalUp"
            }
        }, li.type = {
            TEXT: 1,
            BRACKET: 2,
            MIXED: 3
        }, li.typeString = {
            text: li.type.TEXT,
            bracket: li.type.BRACKET,
            mixed: li.type.MIXED
        };
        const oi = {
            1: "repeat1Bar",
            2: "repeat2Bars",
            4: "repeat4Bars",
            slash: "repeatBarSlash"
        };
        class ri extends ei {
            static get CATEGORY() {
                return x.RepeatNote;
            }
            constructor(t, e, i){
                super(new Z(oi[t] || "repeat1Bar", V.currentMusicFont().lookupMetric("repeatNote.point", 40), {
                    category: "repeatNote"
                }), Object.assign({
                    duration: "q",
                    align_center: "slash" !== t
                }, e), i);
            }
        }
        function hi(t, e, i, b, a, n, s) {
            t.beginPath(), t.moveTo(e, i), t.lineTo(b, a), t.lineTo(n, s), t.lineTo(e, i), t.closePath(), t.fill();
        }
        class mi extends R {
            static get CATEGORY() {
                return x.StaveLine;
            }
            constructor(t){
                super(), this.setNotes(t), this.text = "", this.resetFont(), this.render_options = {
                    padding_left: 4,
                    padding_right: 3,
                    line_width: 1,
                    line_dash: void 0,
                    rounded_end: !0,
                    color: void 0,
                    draw_start_arrow: !1,
                    draw_end_arrow: !1,
                    arrowhead_length: 10,
                    arrowhead_angle: Math.PI / 8,
                    text_position_vertical: mi.TextVerticalPosition.TOP,
                    text_justification: mi.TextJustification.CENTER
                };
            }
            setText(t) {
                return this.text = t, this;
            }
            setNotes(t) {
                if (!t.first_note && !t.last_note) throw new g("BadArguments", "Notes needs to have either first_note or last_note set.");
                if (t.first_indices || (t.first_indices = [
                    0
                ]), t.last_indices || (t.last_indices = [
                    0
                ]), t.first_indices.length !== t.last_indices.length) throw new g("BadArguments", "Connected notes must have same number of indices.");
                return this.notes = t, this.first_note = t.first_note, this.first_indices = t.first_indices, this.last_note = t.last_note, this.last_indices = t.last_indices, this;
            }
            applyLineStyle() {
                const t = this.checkContext(), e = this.render_options;
                e.line_dash && t.setLineDash(e.line_dash), e.line_width && t.setLineWidth(e.line_width), e.rounded_end ? t.setLineCap("round") : t.setLineCap("square");
            }
            applyFontStyle() {
                const t = this.checkContext();
                t.setFont(this.textFont);
                const e = this.render_options.color;
                e && (t.setStrokeStyle(e), t.setFillStyle(e));
            }
            drawArrowLine(t, e, i) {
                const b = this.render_options.draw_start_arrow && this.render_options.draw_end_arrow, a = e.x, n = e.y, s = i.x, l = i.y, o = Math.sqrt((s - a) * (s - a) + (l - n) * (l - n)), r = (o - this.render_options.arrowhead_length / 3) / o;
                let h, m, c, d;
                this.render_options.draw_end_arrow || b ? (h = Math.round(a + (s - a) * r), m = Math.round(n + (l - n) * r)) : (h = s, m = l), this.render_options.draw_start_arrow || b ? (c = a + (s - a) * (1 - r), d = n + (l - n) * (1 - r)) : (c = a, d = n), this.render_options.color && (t.setStrokeStyle(this.render_options.color), t.setFillStyle(this.render_options.color)), t.beginPath(), t.moveTo(c, d), t.lineTo(h, m), t.stroke(), t.closePath();
                const _ = Math.atan2(l - n, s - a), x = Math.abs(this.render_options.arrowhead_length / Math.cos(this.render_options.arrowhead_angle));
                let g, y, p, u, f, S;
                (this.render_options.draw_end_arrow || b) && (g = _ + Math.PI + this.render_options.arrowhead_angle, p = s + Math.cos(g) * x, u = l + Math.sin(g) * x, y = _ + Math.PI - this.render_options.arrowhead_angle, f = s + Math.cos(y) * x, S = l + Math.sin(y) * x, hi(t, p, u, s, l, f, S)), (this.render_options.draw_start_arrow || b) && (g = _ + this.render_options.arrowhead_angle, p = a + Math.cos(g) * x, u = n + Math.sin(g) * x, y = _ - this.render_options.arrowhead_angle, f = a + Math.cos(y) * x, S = n + Math.sin(y) * x, hi(t, p, u, a, n, f, S));
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                const e = this.first_note, i = this.last_note, b = this.render_options;
                t.save(), this.applyLineStyle();
                let a = {
                    x: 0,
                    y: 0
                }, n = {
                    x: 0,
                    y: 0
                };
                this.first_indices.forEach((s, l)=>{
                    const o = this.last_indices[l];
                    a = e.getModifierStartXY(2, s), n = i.getModifierStartXY(1, o);
                    const r = a.y > n.y;
                    a.x += e.getMetrics().modRightPx + b.padding_left, n.x -= i.getMetrics().modLeftPx + b.padding_right;
                    const h = e.getGlyphProps().getWidth();
                    e.getKeyProps()[s].displaced && 1 === e.getStemDirection() && (a.x += h + b.padding_left);
                    i.getKeyProps()[o].displaced && -1 === i.getStemDirection() && (n.x -= h + b.padding_right), a.y += r ? -3 : 1, n.y += r ? 2 : 0, this.drawArrowLine(t, a, n);
                }), t.restore();
                const s = t.measureText(this.text).width, l = b.text_justification;
                let o = 0;
                if (l === mi.TextJustification.LEFT) o = a.x;
                else if (l === mi.TextJustification.CENTER) o = (n.x - a.x) / 2 + a.x - s / 2;
                else l === mi.TextJustification.RIGHT && (o = n.x - s);
                let r = 0;
                const h = b.text_position_vertical;
                return h === mi.TextVerticalPosition.TOP ? r = e.checkStave().getYForTopText() : h === mi.TextVerticalPosition.BOTTOM && (r = e.checkStave().getYForBottomText(V.TEXT_HEIGHT_OFFSET_HACK)), t.save(), this.applyFontStyle(), t.fillText(this.text, o, r), t.restore(), this;
            }
        }
        mi.TEXT_FONT = Object.assign({}, R.TEXT_FONT), mi.TextVerticalPosition = {
            TOP: 1,
            BOTTOM: 2
        }, mi.TextJustification = ne;
        class ci extends R {
            static get CATEGORY() {
                return x.System;
            }
            constructor(t = {}){
                super(), this.setOptions(t), this.partStaves = [], this.partStaveInfos = [], this.partVoices = [];
            }
            setOptions(t = {}) {
                if (!t.factory) throw new g("NoFactory", "System.setOptions(options) requires a factory.");
                this.factory = t.factory, this.options = Object.assign(Object.assign({
                    factory: this.factory,
                    x: 10,
                    y: 10,
                    width: 500,
                    spaceBetweenStaves: 12,
                    autoWidth: !1,
                    noJustification: !1,
                    debugFormatter: !1,
                    formatIterations: 0,
                    noPadding: !1
                }, t), {
                    details: Object.assign({
                        alpha: .5
                    }, t.details),
                    formatOptions: Object.assign({}, t.formatOptions)
                }), !1 === this.options.noJustification && void 0 === t.width && (this.options.autoWidth = !0);
            }
            getX() {
                return this.options.x;
            }
            setX(t) {
                this.options.x = t, this.partStaves.forEach((e)=>{
                    e.setX(t);
                });
            }
            getY() {
                return this.options.y;
            }
            setY(t) {
                this.options.y = t, this.partStaves.forEach((e)=>{
                    e.setY(t);
                });
            }
            getStaves() {
                return this.partStaves;
            }
            getVoices() {
                return this.partVoices;
            }
            setContext(t) {
                return super.setContext(t), this.factory.setContext(t), this;
            }
            addConnector(t = "double") {
                return this.connector = this.factory.StaveConnector({
                    top_stave: this.partStaves[0],
                    bottom_stave: this.partStaves[this.partStaves.length - 1],
                    type: t
                }), this.connector;
            }
            addStave(t) {
                var e;
                const i = Object.assign({
                    left_bar: !1
                }, t.options), b = null !== (e = t.stave) && void 0 !== e ? e : this.factory.Stave({
                    x: this.options.x,
                    y: this.options.y,
                    width: this.options.width,
                    options: i
                }), a = Object.assign(Object.assign({
                    spaceAbove: 0,
                    spaceBelow: 0,
                    debugNoteMetrics: !1,
                    noJustification: !1
                }, t), {
                    options: i
                }), n = this.getContext();
                return a.voices.forEach((t)=>{
                    t.setContext(n).setStave(b).getTickables().forEach((t)=>t.setStave(b)), this.partVoices.push(t);
                }), this.partStaves.push(b), this.partStaveInfos.push(a), b;
            }
            addVoices(t) {
                const e = this.getContext();
                t.forEach((t)=>{
                    t.setContext(e), this.partVoices.push(t);
                });
            }
            format() {
                const t = this.options.details;
                let e = 0;
                const i = new Pe(t);
                this.formatter = i;
                let b = this.options.y, a = 0;
                const n = [];
                this.partStaves.forEach((t, e)=>{
                    b += t.space(this.partStaveInfos[e].spaceAbove), t.setY(b), b += t.space(this.partStaveInfos[e].spaceBelow), b += t.space(this.options.spaceBetweenStaves), this.partStaveInfos[e].debugNoteMetrics && (n.push({
                        y: b,
                        stave: t
                    }), b += 15), a = Math.max(a, t.getNoteStartX());
                }), this.partVoices.forEach((t)=>{
                    t.getTickables().forEach((t)=>{
                        const e = t.getStave();
                        e && t.setStave(e);
                    });
                }), i.joinVoices(this.partVoices), this.partStaves.forEach((t)=>t.setNoteStartX(a)), this.options.autoWidth && this.partVoices.length > 0 ? (e = i.preCalculateMinTotalWidth(this.partVoices), this.options.width = e + ze.rightPadding + (a - this.options.x), this.partStaves.forEach((t)=>{
                    t.setWidth(this.options.width);
                })) : e = this.options.noPadding ? this.options.width - (a - this.options.x) : this.options.width - (a - this.options.x) - ze.defaultPadding, this.partVoices.length > 0 && i.format(this.partVoices, this.options.noJustification ? 0 : e, this.options.formatOptions), i.postFormat();
                for(let e = 0; e < this.options.formatIterations; e++)i.tune(t);
                this.startX = a, this.debugNoteMetricsYs = n, this.lastY = b, this.boundingBox = new D(this.options.x, this.options.y, this.options.width, this.lastY - this.options.y), ze.formatBegModifiers(this.partStaves);
            }
            draw() {
                const t = this.checkContext();
                if (!(this.formatter && this.startX && this.lastY && this.debugNoteMetricsYs)) throw new g("NoFormatter", "format() must be called before draw()");
                this.setRendered(), this.options.debugFormatter && Pe.plotDebugging(t, this.formatter, this.startX, this.options.y, this.lastY), this.debugNoteMetricsYs.forEach((e)=>{
                    this.partVoices.forEach((i)=>{
                        i.getTickables().forEach((i)=>{
                            i.getStave() === e.stave && vt.plotMetrics(t, i, e.y);
                        });
                    });
                });
            }
        }
        class di extends Wt {
            static get CATEGORY() {
                return x.TabNote;
            }
            constructor(t, e = !1){
                super(t), this.glyphPropsArr = [], this.greatestString = ()=>this.positions.map((t)=>t.str).reduce((t, e)=>t > e ? t : e), this.leastString = ()=>this.positions.map((t)=>t.str).reduce((t, e)=>t < e ? t : e), this.ghost = !1, this.positions = t.positions || [], this.render_options = Object.assign(Object.assign({}, this.render_options), {
                    glyph_font_scale: V.TABLATURE_FONT_SCALE,
                    draw_stem: e,
                    draw_dots: e,
                    draw_stem_through_stave: !1,
                    y_shift: 0,
                    scale: 1,
                    font: `${F.SIZE}pt ${F.SANS_SERIF}`
                }), this.glyphProps = V.getGlyphProps(this.duration, this.noteType), p(this.glyphProps, "BadArguments", `No glyph found for duration '${this.duration}' and type '${this.noteType}'`), this.buildStem(), t.stem_direction ? this.setStemDirection(t.stem_direction) : this.setStemDirection(at.UP), this.ghost = !1, this.updateWidth();
            }
            reset() {
                return super.reset(), this.stave && this.setStave(this.stave), this;
            }
            setGhost(t) {
                return this.ghost = t, this.updateWidth(), this;
            }
            hasStem() {
                return !!this.render_options.draw_stem;
            }
            getStemExtension() {
                const t = this.getGlyphProps();
                return null != this.stem_extension_override ? this.stem_extension_override : t ? this.getStemDirection() === at.UP ? t.tabnote_stem_up_extension : t.tabnote_stem_down_extension : 0;
            }
            updateWidth() {
                this.glyphPropsArr = [], this.width = 0;
                for(let t = 0; t < this.positions.length; ++t){
                    let e = this.positions[t].fret;
                    this.ghost && (e = "(" + e + ")");
                    const i = V.tabToGlyphProps(e.toString(), this.render_options.scale);
                    this.glyphPropsArr.push(i), this.width = Math.max(i.getWidth(), this.width);
                }
                this.glyphProps.getWidth = ()=>this.width;
            }
            setStave(t) {
                super.setStave(t);
                const e = t.getContext();
                if (this.setContext(e), e) {
                    this.width = 0;
                    for(let t = 0; t < this.glyphPropsArr.length; ++t){
                        const i = this.glyphPropsArr[t], b = "" + i.text;
                        "X" !== b.toUpperCase() && (e.save(), e.setFont(this.render_options.font), i.width = e.measureText(b).width, e.restore(), i.getWidth = ()=>i.width), this.width = Math.max(i.getWidth(), this.width);
                    }
                    this.glyphProps.getWidth = ()=>this.width;
                }
                const i = this.positions.map(({ str: e })=>t.getYForLine(Number(e) - 1));
                return this.setYs(i), this.stem && this.stem.setYBounds(this.getStemY(), this.getStemY()), this;
            }
            getPositions() {
                return this.positions;
            }
            getModifierStartXY(t, e) {
                if (!this.preFormatted) throw new g("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
                if (0 === this.ys.length) throw new g("NoYValues", "No Y-Values calculated for this note.");
                let i = 0;
                if (t === tt.Position.LEFT) i = -2;
                else if (t === tt.Position.RIGHT) i = this.width + 2;
                else if (t === tt.Position.BELOW || t === tt.Position.ABOVE) i = this.glyphProps.getWidth() / 2;
                return {
                    x: this.getAbsoluteX() + i,
                    y: this.ys[e]
                };
            }
            getLineForRest() {
                return Number(this.positions[0].str);
            }
            preFormat() {
                this.preFormatted || (this.modifierContext && this.modifierContext.preFormat(), this.preFormatted = !0);
            }
            getStemX() {
                return this.getCenterGlyphX();
            }
            getStemY() {
                const t = this.checkStave().getNumLines() - .5, e = at.UP === this.stem_direction ? -0.5 : t;
                return this.checkStave().getYForLine(e);
            }
            getStemExtents() {
                return this.checkStem().getExtents();
            }
            drawFlag() {
                var t;
                const { beam: e, glyphProps: i, render_options: { draw_stem: b } } = this, a = this.checkContext(), n = null == e && b;
                if (i.flag && n) {
                    const e = this.getStemX(), i = this.getStemDirection() === at.DOWN ? this.getStemY() - this.checkStem().getHeight() - (this.glyphProps ? this.glyphProps.stem_down_extension : 0) : this.getStemY() - this.checkStem().getHeight() + (this.glyphProps ? this.glyphProps.stem_up_extension : 0);
                    null === (t = this.flag) || void 0 === t || t.render(a, e, i);
                }
            }
            drawModifiers() {
                this.modifiers.forEach((t)=>{
                    l(t) && !this.render_options.draw_dots || (t.setContext(this.getContext()), t.drawWithStyle());
                });
            }
            drawStemThrough() {
                const t = this.getStemX(), e = this.getStemY(), i = this.checkContext(), b = this.render_options.draw_stem, a = this.render_options.draw_stem_through_stave;
                if (b && a) {
                    const b = function(t, e, i, b) {
                        const a = 1 !== b, n = -1 !== b, s = i.getSpacingBetweenLines(), l = i.getNumLines(), o = [];
                        return e.forEach((e)=>{
                            const r = e.indexOf(l) > -1, h = e.indexOf(1) > -1;
                            if (a && h || n && r) return;
                            1 === e.length && e.push(e[0]);
                            const m = [];
                            e.forEach((e, a, n)=>{
                                const o = 1 === e, r = e === l;
                                let h = i.getYForLine(e - 1);
                                0 !== a || o ? a !== n.length - 1 || r || (h += s / 2 - 1) : h -= s / 2 - 1, m.push(h), 1 === b && o ? m.push(t - 2) : -1 === b && r && m.push(t + 2);
                            }), o.push(m.sort((t, e)=>t - e));
                        }), o;
                    }(e, function(t, e) {
                        const i = [];
                        let b = [];
                        for(let a = 1; a <= t; a++)e.indexOf(a) > -1 ? (i.push(b), b = []) : b.push(a);
                        return b.length > 0 && i.push(b), i;
                    }(this.checkStave().getNumLines(), this.positions.map((t)=>Number(t.str))), this.checkStave(), this.getStemDirection());
                    i.save(), i.setLineWidth(at.WIDTH), b.forEach((e)=>{
                        0 !== e.length && (i.beginPath(), i.moveTo(t, e[0]), i.lineTo(t, e[e.length - 1]), i.stroke(), i.closePath());
                    }), i.restore();
                }
            }
            drawPositions() {
                var t;
                const e = this.checkContext(), i = this.getAbsoluteX(), b = this.ys;
                for(let a = 0; a < this.positions.length; ++a){
                    const n = b[a] + this.render_options.y_shift, s = this.glyphPropsArr[a], l = i + this.glyphProps.getWidth() / 2 - s.getWidth() / 2;
                    if (e.clearRect(l - 2, n - 3, s.getWidth() + 4, 6), s.code) Z.renderGlyph(e, l, n, this.render_options.glyph_font_scale * this.render_options.scale, s.code);
                    else {
                        e.save(), e.setFont(this.render_options.font);
                        const i = null !== (t = s.text) && void 0 !== t ? t : "";
                        e.fillText(i, l, n + 5 * this.render_options.scale), e.restore();
                    }
                }
            }
            draw() {
                const t = this.checkContext();
                if (0 === this.ys.length) throw new g("NoYValues", "Can't draw note without Y values.");
                this.setRendered();
                const e = null == this.beam && this.render_options.draw_stem;
                if (this.applyStyle(), t.openGroup("tabnote", this.getAttribute("id"), {
                    pointerBBox: !0
                }), this.drawPositions(), this.drawStemThrough(), this.stem && e) {
                    const e = this.getStemX();
                    this.stem.setNoteHeadXBounds(e, e), this.stem.setContext(t).draw();
                }
                this.drawFlag(), this.drawModifiers(), t.closeGroup(), this.restoreStyle();
            }
        }
        class _i extends ze {
            static get CATEGORY() {
                return x.TabStave;
            }
            constructor(t, e, i, b){
                super(t, e, i, Object.assign({
                    spacing_between_lines_px: 13,
                    num_lines: 6,
                    top_text_position: 1
                }, b));
            }
            getYForGlyphs() {
                return this.getYForLine(2.5);
            }
            addTabGlyph() {
                return this.addClef("tab"), this;
            }
        }
        function xi(...t) {
            yi.DEBUG && u("Vex.Flow.TextBracket", t);
        }
        var gi;
        !function(t) {
            t[t.TOP = 1] = "TOP", t[t.BOTTOM = -1] = "BOTTOM";
        }(gi || (gi = {}));
        class yi extends R {
            static get CATEGORY() {
                return x.TextBracket;
            }
            static get Position() {
                return gi;
            }
            static get PositionString() {
                return {
                    top: gi.TOP,
                    bottom: gi.BOTTOM
                };
            }
            static get Positions() {
                return xi("Positions is deprecated, use TextBracketPosition instead."), gi;
            }
            static get PositionsString() {
                return xi("PositionsString is deprecated, use PositionString instead."), yi.PositionString;
            }
            constructor({ start: t, stop: e, text: i = "", superscript: b = "", position: a = gi.TOP }){
                super(), this.start = t, this.stop = e, this.text = i, this.superscript = b, this.position = "string" == typeof a ? yi.PositionString[a] : a, this.line = 1, this.resetFont(), this.render_options = {
                    dashed: !0,
                    dash: [
                        5
                    ],
                    color: "black",
                    line_width: 1,
                    show_bracket: !0,
                    bracket_height: 8,
                    underline_superscript: !0
                };
            }
            applyStyle(t) {
                t.setFont(this.font);
                const e = this.render_options;
                return t.setStrokeStyle(e.color), t.setFillStyle(e.color), t.setLineWidth(e.line_width), this;
            }
            setDashed(t, e) {
                return this.render_options.dashed = t, e && (this.render_options.dash = e), this;
            }
            setLine(t) {
                return this.line = t, this;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                let e = 0;
                switch(this.position){
                    case gi.TOP:
                        e = this.start.checkStave().getYForTopText(this.line);
                        break;
                    case gi.BOTTOM:
                        e = this.start.checkStave().getYForBottomText(this.line + V.TEXT_HEIGHT_OFFSET_HACK);
                        break;
                    default:
                        throw new g("InvalidPosition", `The position ${this.position} is invalid.`);
                }
                const i = {
                    x: this.start.getAbsoluteX(),
                    y: e
                }, b = {
                    x: this.stop.getAbsoluteX(),
                    y: e
                };
                xi("Rendering TextBracket: start:", i, "stop:", b, "y:", e);
                const a = this.render_options.bracket_height * this.position;
                t.save(), this.applyStyle(t), t.fillText(this.text, i.x, i.y);
                const n = t.measureText(this.text), s = n.width, l = n.height, o = i.y - l / 2.5, { family: r, size: h, weight: m, style: c } = this.textFont, d = F.scaleSize(h, .714286);
                t.setFont(r, d, m, c), t.fillText(this.superscript, i.x + s + 1, o);
                const _ = t.measureText(this.superscript), x = _.width, y = _.height;
                let p = i.x, u = o;
                const f = b.x + this.stop.getGlyphProps().getWidth();
                this.position === gi.TOP ? (p += s + x + 5, u -= y / 2.7) : this.position === gi.BOTTOM && (u += y / 2.7, p += s + 2, this.render_options.underline_superscript || (p += x)), this.render_options.dashed ? (le.drawDashedLine(t, p, u, f, u, this.render_options.dash), this.render_options.show_bracket && le.drawDashedLine(t, f, u + 1 * this.position, f, u + a, this.render_options.dash)) : (t.beginPath(), t.moveTo(p, u), t.lineTo(f, u), this.render_options.show_bracket && t.lineTo(f, u + a), t.stroke(), t.closePath()), t.restore();
            }
        }
        function pi(...t) {
            ui.DEBUG && u("Vex.Flow.TextDynamics", t);
        }
        yi.DEBUG = !1, yi.TEXT_FONT = {
            family: F.SERIF,
            size: 15,
            weight: E.NORMAL,
            style: P.ITALIC
        };
        class ui extends vt {
            static get CATEGORY() {
                return x.TextDynamics;
            }
            static get GLYPHS() {
                return {
                    f: {
                        code: "dynamicForte",
                        width: 12
                    },
                    p: {
                        code: "dynamicPiano",
                        width: 14
                    },
                    m: {
                        code: "dynamicMezzo",
                        width: 17
                    },
                    s: {
                        code: "dynamicSforzando",
                        width: 10
                    },
                    z: {
                        code: "dynamicZ",
                        width: 12
                    },
                    r: {
                        code: "dynamicRinforzando",
                        width: 12
                    }
                };
            }
            constructor(t){
                super(t), this.sequence = (t.text || "").toLowerCase(), this.line = t.line || 0, this.glyphs = [], this.render_options = Object.assign(Object.assign({}, this.render_options), {
                    glyph_font_size: V.NOTATION_FONT_SCALE
                }), pi("New Dynamics Text: ", this.sequence);
            }
            setLine(t) {
                return this.line = t, this;
            }
            preFormat() {
                let t = 0;
                return this.glyphs = [], this.sequence.split("").forEach((e)=>{
                    const i = ui.GLYPHS[e];
                    if (!i) throw new g("Invalid dynamics character: " + e);
                    const b = p(this.render_options.glyph_font_size), a = new Z(i.code, b, {
                        category: "textNote"
                    });
                    this.glyphs.push(a), t += i.width;
                }), this.setWidth(t), this.preFormatted = !0, this;
            }
            draw() {
                this.setRendered();
                const t = this.getAbsoluteX(), e = this.checkStave().getYForLine(this.line + -3);
                pi("Rendering Dynamics: ", this.sequence);
                let i = t;
                this.glyphs.forEach((t, b)=>{
                    const a = this.sequence[b];
                    t.render(this.checkContext(), i, e), i += ui.GLYPHS[a].width;
                });
            }
        }
        ui.DEBUG = !1;
        class fi extends vt {
            static get CATEGORY() {
                return x.TimeSigNote;
            }
            constructor(t, e){
                super({
                    duration: "b"
                }), this.timeSig = new Te(t, e), this.setWidth(this.timeSig.getGlyph().getMetrics().width), this.ignore_ticks = !0;
            }
            addToModifierContext(t) {
                return this;
            }
            preFormat() {
                return this.preFormatted = !0, this;
            }
            draw() {
                const t = this.checkStave(), e = this.checkContext();
                this.setRendered();
                const i = this.timeSig.getGlyph();
                i.getContext() || i.setContext(e), i.setStave(t), i.setYShift(t.getYForLine(2) - t.getYForGlyphs()), i.renderToStave(this.getAbsoluteX());
            }
        }
        class Si extends R {
            static get CATEGORY() {
                return x.VibratoBracket;
            }
            constructor(t){
                super(), t.start && (this.start = t.start), t.stop && (this.stop = t.stop), this.line = 1, this.render_options = {
                    harsh: !1,
                    wave_height: 6,
                    wave_width: 4,
                    wave_girth: 2,
                    vibrato_width: 0
                };
            }
            setLine(t) {
                return this.line = t, this;
            }
            setHarsh(t) {
                return this.render_options.harsh = t, this;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                const e = this.start && this.start.checkStave().getYForTopText(this.line) || this.stop && this.stop.checkStave().getYForTopText(this.line) || 0, i = this.start && this.start.getAbsoluteX() || this.stop && this.stop.checkStave().getTieStartX() || 0, b = this.stop && this.stop.getAbsoluteX() - this.stop.getWidth() - 5 || this.start && this.start.checkStave().getTieEndX() - 10 || 0;
                this.render_options.vibrato_width = b - i, function(...t) {
                    Si.DEBUG && u("Vex.Flow.VibratoBracket", t);
                }("Rendering VibratoBracket: start_x:", i, "stop_x:", b, "y:", e), he.renderVibrato(t, i, e, this.render_options);
            }
        }
        function Ti(...t) {
            vi.DEBUG && u("Vex.Flow.Factory", t);
        }
        Si.DEBUG = !1;
        class vi {
            static newFromElementId(t, e = 500, i = 200) {
                return new vi({
                    renderer: {
                        elementId: t,
                        width: e,
                        height: i
                    }
                });
            }
            constructor(t = {}){
                Ti("New factory: ", t), this.options = {
                    stave: {
                        space: 10
                    },
                    renderer: {
                        elementId: "",
                        width: 500,
                        height: 200,
                        background: "#FFF"
                    },
                    font: vi.TEXT_FONT
                }, this.setOptions(t);
            }
            reset() {
                this.renderQ = [], this.systems = [], this.staves = [], this.voices = [], this.stave = void 0;
            }
            setOptions(t) {
                this.options = Object.assign(Object.assign({}, this.options), t), this.initRenderer(), this.reset();
            }
            initRenderer() {
                const { elementId: t, width: e, height: i, background: b } = this.options.renderer;
                if (null == t) return;
                if ("" == t) throw Ti(this), new g("renderer.elementId not set in FactoryOptions");
                let a = this.options.renderer.backend;
                if (void 0 === a) a = Jt(document.getElementById(t)) ? le.Backends.CANVAS : le.Backends.SVG;
                this.context = le.buildContext(t, a, e, i, b);
            }
            getContext() {
                return this.context;
            }
            setContext(t) {
                return this.context = t, this;
            }
            getStave() {
                return this.stave;
            }
            getVoices() {
                return this.voices;
            }
            Stave(t) {
                const e = this.options.stave.space, i = Object.assign({
                    x: 0,
                    y: 0,
                    width: this.options.renderer.width - 1 * e,
                    options: {
                        spacing_between_lines_px: 1 * e
                    }
                }, t), b = new ze(i.x, i.y, i.width, i.options);
                return this.staves.push(b), b.setContext(this.context), this.stave = b, b;
            }
            TabStave(t) {
                const e = this.options.stave.space, i = Object.assign({
                    x: 0,
                    y: 0,
                    width: this.options.renderer.width - 1 * e,
                    options: {
                        spacing_between_lines_px: 1.3 * e
                    }
                }, t), b = new _i(i.x, i.y, i.width, i.options);
                return this.staves.push(b), b.setContext(this.context), this.stave = b, b;
            }
            StaveNote(t) {
                const e = new It(t);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            GlyphNote(t, e, i) {
                const b = new ei(t, e, i);
                return this.stave && b.setStave(this.stave), b.setContext(this.context), this.renderQ.push(b), b;
            }
            RepeatNote(t, e, i) {
                const b = new ri(t, e, i);
                return this.stave && b.setStave(this.stave), b.setContext(this.context), this.renderQ.push(b), b;
            }
            GhostNote(t) {
                const e = new ti(t);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            TextNote(t) {
                const e = new pe(t);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            BarNote(t = {}) {
                const e = new At(t.type);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            ClefNote(t) {
                const e = Object.assign({
                    type: "treble",
                    options: {
                        size: "default",
                        annotation: void 0
                    }
                }, t), i = new Le(e.type, e.options.size, e.options.annotation);
                return this.stave && i.setStave(this.stave), i.setContext(this.context), this.renderQ.push(i), i;
            }
            TimeSigNote(t) {
                const e = Object.assign({
                    time: "4/4"
                }, t), i = new fi(e.time);
                return this.stave && i.setStave(this.stave), i.setContext(this.context), this.renderQ.push(i), i;
            }
            KeySigNote(t) {
                const e = new bi(t.key, t.cancelKey, t.alterKey);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            TabNote(t) {
                const e = new di(t);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            GraceNote(t) {
                const e = new ii(t);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), e;
            }
            GraceNoteGroup(t) {
                const e = new jt(t.notes, t.slur);
                return e.setContext(this.context), e;
            }
            Accidental(t) {
                const e = new bt(t.type);
                return e.setContext(this.context), e;
            }
            Annotation(t) {
                const e = Object.assign({
                    text: "p",
                    hJustify: ht.CENTER,
                    vJustify: mt.BOTTOM
                }, t), i = new ct(e.text);
                return i.setJustification(e.hJustify), i.setVerticalJustification(e.vJustify), i.setFont(e.font), i.setContext(this.context), i;
            }
            ChordSymbol(t) {
                const e = Object.assign({
                    vJustify: "top",
                    hJustify: "center",
                    kerning: !0,
                    reportWidth: !0
                }, t), i = new Mt;
                return i.setHorizontal(e.hJustify), i.setVertical(e.vJustify), i.setEnableKerning(e.kerning), i.setReportWidth(e.reportWidth), "string" == typeof e.fontFamily && "number" == typeof e.fontSize ? "string" == typeof e.fontWeight ? i.setFont(e.fontFamily, e.fontSize, e.fontWeight) : i.setFont(e.fontFamily, e.fontSize, "") : "number" == typeof e.fontSize && i.setFontSize(e.fontSize), i.setContext(this.context), i;
            }
            Articulation(t) {
                var e;
                const i = new ut(null !== (e = null == t ? void 0 : t.type) && void 0 !== e ? e : "a.");
                return null != (null == t ? void 0 : t.position) && i.setPosition(t.position), null != (null == t ? void 0 : t.betweenLines) && i.setBetweenLines(t.betweenLines), i.setContext(this.context), i;
            }
            Ornament(t, e) {
                const i = Object.assign({
                    type: t,
                    position: 0,
                    accidental: ""
                }, e), b = new Kt(t);
                return b.setPosition(i.position), i.upperAccidental && b.setUpperAccidental(i.upperAccidental), i.lowerAccidental && b.setLowerAccidental(i.lowerAccidental), void 0 !== i.delayed && b.setDelayed(i.delayed), b.setContext(this.context), b;
            }
            TextDynamics(t) {
                const e = Object.assign({
                    text: "p",
                    duration: "q",
                    dots: 0,
                    line: 0
                }, t), i = new ui({
                    text: e.text,
                    line: e.line,
                    duration: e.duration,
                    dots: e.dots
                });
                return this.stave && i.setStave(this.stave), i.setContext(this.context), this.renderQ.push(i), i;
            }
            Fingering(t) {
                const e = Object.assign({
                    number: "0",
                    position: "left"
                }, t), i = new Rt(e.number);
                return i.setPosition(e.position), i.setContext(this.context), i;
            }
            StringNumber(t, e = !0) {
                const i = new oe(t.number);
                return i.setPosition(t.position), i.setContext(this.context), i.setDrawCircle(e), i;
            }
            TickContext() {
                return new Ce;
            }
            ModifierContext() {
                return new ce;
            }
            MultiMeasureRest(t) {
                const e = p(t.number_of_measures, "NoNumberOfMeasures"), i = new ni(e, t);
                return i.setContext(this.context), this.renderQ.push(i), i;
            }
            Voice(t) {
                const e = Object.assign({
                    time: "4/4"
                }, t), i = new Xt(e.time);
                return this.voices.push(i), i;
            }
            StaveConnector(t) {
                const e = new De(t.top_stave, t.bottom_stave);
                return e.setType(t.type).setContext(this.context), this.renderQ.push(e), e;
            }
            Formatter(t) {
                return new Pe(t);
            }
            Tuplet(t) {
                const e = Object.assign({
                    notes: [],
                    options: {}
                }, t), i = new Ae(e.notes, e.options).setContext(this.context);
                return this.renderQ.push(i), i;
            }
            Beam(t) {
                var e, i, b, a, n;
                const s = new Re(t.notes, null === (e = t.options) || void 0 === e ? void 0 : e.autoStem).setContext(this.context);
                return s.breakSecondaryAt(null !== (b = null === (i = t.options) || void 0 === i ? void 0 : i.secondaryBeamBreaks) && void 0 !== b ? b : []), (null === (a = t.options) || void 0 === a ? void 0 : a.partialBeamDirections) && Object.entries(null === (n = t.options) || void 0 === n ? void 0 : n.partialBeamDirections).forEach(([t, e])=>{
                    s.setPartialBeamSideAt(Number(t), e);
                }), this.renderQ.push(s), s;
            }
            Curve(t) {
                const e = new Ie(t.from, t.to, t.options).setContext(this.context);
                return this.renderQ.push(e), e;
            }
            StaveTie(t) {
                var e;
                const i = new Gt({
                    first_note: t.from,
                    last_note: t.to,
                    first_indices: t.first_indices,
                    last_indices: t.last_indices
                }, t.text);
                return (null === (e = t.options) || void 0 === e ? void 0 : e.direction) && i.setDirection(t.options.direction), i.setContext(this.context), this.renderQ.push(i), i;
            }
            StaveLine(t) {
                var e, i;
                const b = new mi({
                    first_note: t.from,
                    last_note: t.to,
                    first_indices: t.first_indices,
                    last_indices: t.last_indices
                });
                return (null === (e = t.options) || void 0 === e ? void 0 : e.text) && b.setText(t.options.text), (null === (i = t.options) || void 0 === i ? void 0 : i.font) && b.setFont(t.options.font), b.setContext(this.context), this.renderQ.push(b), b;
            }
            VibratoBracket(t) {
                const e = new Si({
                    start: t.from,
                    stop: t.to
                });
                return t.options.line && e.setLine(t.options.line), t.options.harsh && e.setHarsh(t.options.harsh), e.setContext(this.context), this.renderQ.push(e), e;
            }
            TextBracket(t) {
                const e = new yi({
                    start: t.from,
                    stop: t.to,
                    text: t.text,
                    superscript: t.options.superscript,
                    position: t.options.position
                });
                return t.options.line && e.setLine(t.options.line), t.options.font && e.setFont(t.options.font), e.setContext(this.context), this.renderQ.push(e), e;
            }
            System(t = {}) {
                t.factory = this;
                const e = new ci(t).setContext(this.context);
                return this.systems.push(e), e;
            }
            EasyScore(t = {}) {
                return t.factory = this, new Qe(t);
            }
            PedalMarking(t) {
                const e = Object.assign({
                    notes: [],
                    options: {
                        style: "mixed"
                    }
                }, t), i = new li(e.notes);
                return i.setType(li.typeString[e.options.style]), i.setContext(this.context), this.renderQ.push(i), i;
            }
            NoteSubGroup(t) {
                const e = Object.assign({
                    notes: []
                }, t), i = new Vt(e.notes);
                return i.setContext(this.context), i;
            }
            draw() {
                const t = this.context;
                this.systems.forEach((e)=>e.setContext(t).format()), this.staves.forEach((e)=>e.setContext(t).draw()), this.voices.forEach((e)=>e.setContext(t).draw()), this.renderQ.forEach((e)=>{
                    e.isRendered() || e.setContext(t).draw();
                }), this.systems.forEach((e)=>e.setContext(t).draw()), this.reset();
            }
        }
        vi.DEBUG = !1, vi.TEXT_FONT = Object.assign({}, R.TEXT_FONT);
        class wi extends di {
            static get CATEGORY() {
                return x.GraceTabNote;
            }
            constructor(t){
                super(t, !1), this.render_options = Object.assign(Object.assign({}, this.render_options), {
                    y_shift: .3,
                    scale: .6,
                    font: `7.5pt ${F.SANS_SERIF}`
                }), this.updateWidth();
            }
        }
        class zi {
            constructor(t){
                this.music = new et, this.setKey(t);
            }
            setKey(t) {
                return this.key = t, this.reset(), this;
            }
            getKey() {
                return this.key;
            }
            reset() {
                this.keyParts = this.music.getKeyParts(this.key), this.keyString = this.keyParts.root, this.keyParts.accidental && (this.keyString += this.keyParts.accidental);
                if (!et.scaleTypes[this.keyParts.type]) throw new g("BadArguments", `Unsupported key type: ${this.key}`);
                this.scale = this.music.getScaleTones(this.music.getNoteValue(this.keyString), et.scaleTypes[this.keyParts.type]), this.scaleMap = {}, this.scaleMapByValue = {}, this.originalScaleMapByValue = {};
                const t = et.root_indices[this.keyParts.root];
                for(let e = 0; e < et.roots.length; ++e){
                    const i = (t + e) % et.roots.length, b = et.roots[i], a = this.music.getRelativeNoteName(b, this.scale[e]);
                    this.scaleMap[b] = a, this.scaleMapByValue[this.scale[e]] = a, this.originalScaleMapByValue[this.scale[e]] = a;
                }
                return this;
            }
            getAccidental(t) {
                const e = this.music.getKeyParts(t).root, i = this.music.getNoteParts(this.scaleMap[e]);
                return {
                    note: this.scaleMap[e],
                    accidental: i.accidental
                };
            }
            selectNote(t) {
                t = t.toLowerCase();
                const e = this.music.getNoteParts(t), i = this.scaleMap[e.root], b = this.music.getNoteParts(i);
                if (i === t) return {
                    note: i,
                    accidental: e.accidental,
                    change: !1
                };
                const a = this.scaleMapByValue[this.music.getNoteValue(t)];
                if (null != a) return {
                    note: a,
                    accidental: this.music.getNoteParts(a).accidental,
                    change: !1
                };
                const n = this.originalScaleMapByValue[this.music.getNoteValue(t)];
                return null != n ? (this.scaleMap[b.root] = n, delete this.scaleMapByValue[this.music.getNoteValue(i)], this.scaleMapByValue[this.music.getNoteValue(t)] = n, {
                    note: n,
                    accidental: this.music.getNoteParts(n).accidental,
                    change: !0
                }) : b.root === t ? (delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[e.root])], this.scaleMapByValue[this.music.getNoteValue(b.root)] = b.root, this.scaleMap[b.root] = b.root, {
                    note: b.root,
                    accidental: void 0,
                    change: !0
                }) : (delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[e.root])], this.scaleMapByValue[this.music.getNoteValue(t)] = t, delete this.scaleMap[b.root], this.scaleMap[b.root] = t, {
                    note: t,
                    accidental: e.accidental,
                    change: !0
                });
            }
        }
        class Bi extends R {
            static get CATEGORY() {
                return x.StaveHairpin;
            }
            static FormatByTicksAndDraw(t, e, i, b, a, n) {
                var s, l;
                const o = e.pixelsPerTick;
                if (null == o) throw new g("BadArguments", "A valid Formatter must be provide to draw offsets by ticks.");
                const r = o * (null !== (s = n.left_shift_ticks) && void 0 !== s ? s : 0), h = o * (null !== (l = n.right_shift_ticks) && void 0 !== l ? l : 0), m = {
                    height: n.height,
                    y_shift: n.y_shift,
                    left_shift_px: r,
                    right_shift_px: h,
                    right_shift_ticks: 0,
                    left_shift_ticks: 0
                };
                new Bi({
                    first_note: i.first_note,
                    last_note: i.last_note
                }, b).setContext(t).setRenderOptions(m).setPosition(a).draw();
            }
            constructor(t, e){
                super(), this.setNotes(t), this.hairpin = e, this.position = tt.Position.BELOW, this.render_options = {
                    height: 10,
                    y_shift: 0,
                    left_shift_px: 0,
                    right_shift_px: 0,
                    right_shift_ticks: 0,
                    left_shift_ticks: 0
                };
            }
            setPosition(t) {
                return t !== tt.Position.ABOVE && t !== tt.Position.BELOW || (this.position = t), this;
            }
            setRenderOptions(t) {
                return null != t.height && null != t.y_shift && null != t.left_shift_px && null != t.right_shift_px && (this.render_options = t), this;
            }
            setNotes(t) {
                if (!t.first_note && !t.last_note) throw new g("BadArguments", "Hairpin needs to have either first_note or last_note set.");
                return this.notes = t, this.first_note = t.first_note, this.last_note = t.last_note, this;
            }
            renderHairpin(t) {
                const e = this.checkContext();
                let i = this.render_options.y_shift + 20, b = t.first_y;
                this.position === tt.Position.ABOVE && (i = 30 - i, b = t.first_y - t.staff_height);
                const a = this.render_options.left_shift_px, n = this.render_options.right_shift_px;
                switch(e.beginPath(), this.hairpin){
                    case Bi.type.CRESC:
                        e.moveTo(t.last_x + n, b + i), e.lineTo(t.first_x + a, b + this.render_options.height / 2 + i), e.lineTo(t.last_x + n, b + this.render_options.height + i);
                        break;
                    case Bi.type.DECRESC:
                        e.moveTo(t.first_x + a, b + i), e.lineTo(t.last_x + n, b + this.render_options.height / 2 + i), e.lineTo(t.first_x + a, b + this.render_options.height + i);
                }
                e.stroke(), e.closePath();
            }
            draw() {
                this.checkContext(), this.setRendered();
                const t = this.first_note, e = this.last_note;
                if (!t || !e) throw new g("NoNote", "Notes required to draw");
                const i = t.getModifierStartXY(this.position, 0), b = e.getModifierStartXY(this.position, 0);
                this.renderHairpin({
                    first_x: i.x,
                    last_x: b.x,
                    first_y: t.checkStave().getY() + t.checkStave().getHeight(),
                    last_y: e.checkStave().getY() + e.checkStave().getHeight(),
                    staff_height: t.checkStave().getHeight()
                });
            }
        }
        Bi.type = {
            CRESC: 1,
            DECRESC: 2
        };
        class Di extends Ht {
            static get CATEGORY() {
                return x.TabSlide;
            }
            static get SLIDE_UP() {
                return 1;
            }
            static get SLIDE_DOWN() {
                return -1;
            }
            static createSlideUp(t) {
                return new Di(t, Di.SLIDE_UP);
            }
            static createSlideDown(t) {
                return new Di(t, Di.SLIDE_DOWN);
            }
            constructor(t, e){
                if (super(t, "sl."), !e) {
                    let i = t.first_note.getPositions()[0].fret;
                    "string" == typeof i && (i = parseInt(i, 10));
                    let b = t.last_note.getPositions()[0].fret;
                    "string" == typeof b && (b = parseInt(b, 10)), e = isNaN(i) || isNaN(b) ? Di.SLIDE_UP : i > b ? Di.SLIDE_DOWN : Di.SLIDE_UP;
                }
                this.direction = e, this.render_options.cp1 = 11, this.render_options.cp2 = 14, this.render_options.y_shift = .5, this.resetFont();
            }
            renderTie(t) {
                if (0 === t.first_ys.length || 0 === t.last_ys.length) throw new g("BadArguments", "No Y-values to render");
                const e = this.checkContext(), i = t.first_x_px, b = t.first_ys, a = t.last_x_px, n = t.direction;
                if (n !== Di.SLIDE_UP && n !== Di.SLIDE_DOWN) throw new g("BadSlide", "Invalid slide direction");
                const s = this.notes.first_indices;
                for(let t = 0; t < s.length; ++t){
                    const l = b[s[t]] + this.render_options.y_shift;
                    if (isNaN(l)) throw new g("BadArguments", "Bad indices for slide rendering.");
                    e.beginPath(), e.moveTo(i, l + 3 * n), e.lineTo(a, l - 3 * n), e.closePath(), e.stroke();
                }
                this.setRendered();
            }
        }
        Di.TEXT_FONT = {
            family: F.SERIF,
            size: 10,
            weight: E.BOLD,
            style: P.ITALIC
        };
        class Ci extends tt {
            static get CATEGORY() {
                return x.Tremolo;
            }
            constructor(t){
                super(), this.num = t, this.position = tt.Position.CENTER, this.code = "tremolo1", this.y_spacing_scale = 1, this.extra_stroke_scale = 1;
            }
            draw() {
                var t;
                const e = this.checkContext(), i = this.checkAttachedNote();
                this.setRendered();
                const b = i.getStemDirection();
                let a = i.getModifierStartXY(this.position, this.index).x;
                const n = o(i), s = n ? ii.SCALE : 1, l = "tremolo." + (n ? "grace" : "default"), r = V.currentMusicFont();
                let h = r.lookupMetric(`${l}.spacing`) * b;
                h *= this.y_spacing_scale;
                const m = this.num * h;
                let c = i.getStemExtents().baseY - m;
                c += b < 0 ? r.lookupMetric(`${l}.offsetYStemDown`) * s : r.lookupMetric(`${l}.offsetYStemUp`) * s;
                const d = null !== (t = r.lookupMetric(`${l}.point`)) && void 0 !== t ? t : vt.getPoint(n ? "grace" : "default");
                a += r.lookupMetric(`${l}.offsetXStem${b === at.UP ? "Up" : "Down"}`);
                for(let t = 0; t < this.num; ++t)Z.renderGlyph(e, a, c, d, this.code, {
                    category: l,
                    scale: this.extra_stroke_scale
                }), c += h;
            }
        }
        class Ei {
            static get names() {
                return {
                    standard: "E/5,B/4,G/4,D/4,A/3,E/3",
                    dagdad: "D/5,A/4,G/4,D/4,A/3,D/3",
                    dropd: "E/5,B/4,G/4,D/4,A/3,D/3",
                    eb: "Eb/5,Bb/4,Gb/4,Db/4,Ab/3,Db/3",
                    standardBanjo: "D/5,B/4,G/4,D/4,G/5"
                };
            }
            constructor(t = "E/5,B/4,G/4,D/4,A/3,E/3,B/2,E/2"){
                this.tuningValues = [], this.setTuning(t);
            }
            noteToInteger(t) {
                var e;
                return null !== (e = V.keyProperties(t).int_value) && void 0 !== e ? e : -1;
            }
            setTuning(t) {
                Ei.names[t] && (t = Ei.names[t]), this.tuningValues = [];
                const e = t.split(/\s*,\s*/);
                if (0 === e.length) throw new g("BadArguments", `Invalid tuning string: ${t}`);
                for(let t = 0; t < e.length; ++t)this.tuningValues[t] = this.noteToInteger(e[t]);
            }
            getValueForString(t) {
                const e = Number(t);
                if (e < 1 || e > this.tuningValues.length) throw new g("BadArguments", `String number must be between 1 and ${this.tuningValues.length}:${t}`);
                return this.tuningValues[e - 1];
            }
            getValueForFret(t, e) {
                const i = this.getValueForString(e), b = Number(t);
                if (b < 0) throw new g("BadArguments", `Fret number must be 0 or higher: ${t}`);
                return i + b;
            }
            getNoteForFret(t, e) {
                const i = this.getValueForFret(t, e), b = Math.floor(i / 12), a = i % 12;
                return `${V.integerToNote(a)}/${b}`;
            }
        }
        var Pi = function(t, e, i, b) {
            return new (i || (i = Promise))(function(a, n) {
                function s(t) {
                    try {
                        o(b.next(t));
                    } catch (t) {
                        n(t);
                    }
                }
                function l(t) {
                    try {
                        o(b.throw(t));
                    } catch (t) {
                        n(t);
                    }
                }
                function o(t) {
                    var e;
                    t.done ? a(t.value) : (e = t.value, e instanceof i ? e : new i(function(t) {
                        t(e);
                    })).then(s, l);
                }
                o((b = b.apply(t, e || [])).next());
            });
        };
        class ki {
            static get BUILD() {
                return {
                    VERSION: "4.2.5",
                    ID: "5b5b43b18254cc5cf607a0977823900a375b48ed",
                    DATE: "2024-05-12T08:56:23.690Z"
                };
            }
            static setMusicFont(...t) {
                const e = t.map((t)=>F.load(t));
                return V.MUSIC_FONT_STACK = e, Z.MUSIC_FONT_STACK = e.slice(), Z.CURRENT_CACHE_KEY = t.join(","), e;
            }
            static fetchMusicFont(t, e) {
                return Pi(this, void 0, void 0, function*() {});
            }
            static getMusicFont() {
                return V.MUSIC_FONT_STACK.map((t)=>t.getName());
            }
            static getMusicFontStack() {
                return V.MUSIC_FONT_STACK;
            }
            static get RENDER_PRECISION_PLACES() {
                return V.RENDER_PRECISION_PLACES;
            }
            static set RENDER_PRECISION_PLACES(t) {
                V.RENDER_PRECISION_PLACES = t;
            }
            static get SOFTMAX_FACTOR() {
                return V.SOFTMAX_FACTOR;
            }
            static set SOFTMAX_FACTOR(t) {
                V.SOFTMAX_FACTOR = t;
            }
            static get NOTATION_FONT_SCALE() {
                return V.NOTATION_FONT_SCALE;
            }
            static set NOTATION_FONT_SCALE(t) {
                V.NOTATION_FONT_SCALE = t;
            }
            static get TABLATURE_FONT_SCALE() {
                return V.TABLATURE_FONT_SCALE;
            }
            static set TABLATURE_FONT_SCALE(t) {
                V.TABLATURE_FONT_SCALE = t;
            }
            static get RESOLUTION() {
                return V.RESOLUTION;
            }
            static set RESOLUTION(t) {
                V.RESOLUTION = t;
            }
            static get SLASH_NOTEHEAD_WIDTH() {
                return V.SLASH_NOTEHEAD_WIDTH;
            }
            static set SLASH_NOTEHEAD_WIDTH(t) {
                V.SLASH_NOTEHEAD_WIDTH = t;
            }
            static get STAVE_LINE_DISTANCE() {
                return V.STAVE_LINE_DISTANCE;
            }
            static set STAVE_LINE_DISTANCE(t) {
                V.STAVE_LINE_DISTANCE = t;
            }
            static get STAVE_LINE_THICKNESS() {
                return V.STAVE_LINE_THICKNESS;
            }
            static set STAVE_LINE_THICKNESS(t) {
                V.STAVE_LINE_THICKNESS = t;
            }
            static get STEM_HEIGHT() {
                return V.STEM_HEIGHT;
            }
            static set STEM_HEIGHT(t) {
                V.STEM_HEIGHT = t;
            }
            static get STEM_WIDTH() {
                return V.STEM_WIDTH;
            }
            static set STEM_WIDTH(t) {
                V.STEM_WIDTH = t;
            }
            static get TIME4_4() {
                return V.TIME4_4;
            }
            static get accidentalMap() {
                return V.accidentalMap;
            }
            static get unicode() {
                return V.unicode;
            }
            static keySignature(t) {
                return V.keySignature(t);
            }
            static hasKeySignature(t) {
                return V.hasKeySignature(t);
            }
            static getKeySignatures() {
                return V.getKeySignatures();
            }
            static clefProperties(t) {
                return V.clefProperties(t);
            }
            static keyProperties(t, e, i) {
                return V.keyProperties(t, e, i);
            }
            static durationToTicks(t) {
                return V.durationToTicks(t);
            }
        }
        ki.Accidental = bt, ki.Annotation = ct, ki.Articulation = ut, ki.Barline = kt, ki.BarNote = At, ki.Beam = Re, ki.Bend = Nt, ki.BoundingBox = D, ki.BoundingBoxComputation = C, ki.CanvasContext = Qt, ki.ChordSymbol = Mt, ki.Clef = de, ki.ClefNote = Le, ki.Crescendo = We, ki.Curve = Ie, ki.Dot = Ot, ki.EasyScore = Qe, ki.Element = R, ki.Factory = vi, ki.Font = F, ki.Formatter = Pe, ki.Fraction = z, ki.FretHandFinger = Rt, ki.GhostNote = ti, ki.Glyph = Z, ki.GlyphNote = ei, ki.GraceNote = ii, ki.GraceNoteGroup = jt, ki.GraceTabNote = wi, ki.KeyManager = zi, ki.KeySignature = _e, ki.KeySigNote = bi, ki.Modifier = tt, ki.ModifierContext = ce, ki.MultiMeasureRest = ni, ki.Music = et, ki.Note = vt, ki.NoteHead = Lt, ki.NoteSubGroup = Vt, ki.Ornament = Kt, ki.Parenthesis = $t, ki.Parser = Ye, ki.PedalMarking = li, ki.Registry = O, ki.RenderContext = ft, ki.Renderer = le, ki.RepeatNote = ri, ki.Repetition = xe, ki.Stave = ze, ki.StaveConnector = De, ki.StaveHairpin = Bi, ki.StaveLine = mi, ki.StaveModifier = Pt, ki.StaveNote = It, ki.StaveTempo = ye, ki.StaveText = ue, ki.StaveTie = Gt, ki.Stem = at, ki.StringNumber = oe, ki.Stroke = re, ki.SVGContext = ie, ki.System = ci, ki.TabNote = di, ki.TabSlide = Di, ki.TabStave = _i, ki.TabTie = Ht, ki.TextBracket = yi, ki.TextDynamics = ui, ki.TextFormatter = rt, ki.TextNote = pe, ki.TickContext = Ce, ki.TimeSignature = Te, ki.TimeSigNote = fi, ki.Tremolo = Ci, ki.Tuning = Ei, ki.Tuplet = Ae, ki.Vibrato = he, ki.VibratoBracket = Si, ki.Voice = Xt, ki.Volta = fe, ki.AnnotationHorizontalJustify = ht, ki.AnnotationVerticalJustify = mt, ki.ChordSymbolHorizontalJustify = Bt, ki.ChordSymbolVerticalJustify = Dt, ki.SymbolTypes = Ct, ki.SymbolModifiers = Et, ki.CurvePosition = Ue, ki.FontWeight = E, ki.FontStyle = P, ki.ModifierPosition = J, ki.RendererBackends = be, ki.RendererLineEndType = ae, ki.BarlineType = zt, ki.StaveModifierPosition = wt, ki.VoltaType = se, ki.TextBracketPosition = gi, ki.TextJustification = ne, ki.VoiceMode = Yt;
        const Ai = {
            glyphs: {
                bracketTop: {
                    x_min: 0,
                    x_max: 469,
                    y_min: 0,
                    y_max: 295,
                    ha: 295,
                    o: "m 0 0 l 180 0 b 674 390 410 43 616 150 b 675 405 675 396 675 400 b 664 425 675 416 671 422 b 628 405 651 425 635 415 b 157 179 613 389 432 199 l 12 179 b 0 168 3 179 0 177 z"
                },
                bracketBottom: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -295,
                    y_max: 0,
                    ha: 295,
                    o: "m 0 -168 b 12 -179 0 -177 3 -179 l 157 -179 b 628 -405 432 -199 613 -389 b 664 -425 635 -415 651 -425 b 675 -405 671 -422 675 -416 b 674 -390 675 -400 675 -396 b 180 0 616 -150 410 -43 l 0 0 z"
                },
                barlineTick: {
                    x_min: 0,
                    x_max: 36,
                    y_min: 868,
                    y_max: 1120,
                    ha: 252,
                    o: "m 52 1250 l 52 1613 l 0 1613 l 0 1250 z"
                },
                breathMarkTick: {
                    x_min: 0,
                    x_max: 500,
                    y_min: 0,
                    y_max: 502,
                    ha: 502,
                    o: "m 9 367 b 0 374 6 372 3 374 b 9 334 0 367 0 343 b 179 19 40 312 164 121 b 192 0 179 3 186 0 b 210 19 197 0 207 6 b 698 701 245 197 507 658 b 720 714 714 704 720 711 b 698 723 720 720 711 723 b 197 186 455 714 210 202 b 186 176 194 179 189 176 b 176 186 179 176 176 186 b 9 367 143 266 27 359 z"
                },
                segno: {
                    x_min: 4,
                    x_max: 550,
                    y_min: -27,
                    y_max: 759,
                    ha: 786,
                    o: "m 194 958 b 217 939 203 958 213 955 l 220 929 b 325 805 230 890 252 805 b 425 901 384 805 425 840 b 413 969 425 923 420 946 b 220 1060 390 1035 294 1060 b 6 793 120 1060 6 936 b 29 687 6 759 13 723 b 295 449 75 582 284 454 b 304 438 301 446 304 444 b 295 415 304 432 301 425 b 78 22 285 395 78 22 b 73 3 75 16 73 9 b 114 -39 73 -20 91 -39 b 150 -17 128 -39 143 -30 b 377 395 150 -17 373 386 b 395 402 377 393 389 402 b 704 176 416 397 704 312 b 621 75 704 120 670 82 l 616 73 b 562 138 586 73 562 94 l 562 154 b 485 249 562 209 526 249 b 468 246 480 249 474 248 b 366 153 415 233 366 210 b 540 -12 366 65 455 -12 b 600 -1 559 -12 579 -9 b 792 251 716 37 792 131 b 789 292 792 264 791 278 b 523 588 768 451 540 579 b 498 611 505 598 498 603 b 501 619 498 613 500 616 b 732 1032 508 631 732 1032 b 737 1053 736 1040 737 1045 b 697 1093 737 1076 719 1093 b 661 1073 683 1093 668 1086 b 423 647 661 1073 432 660 b 410 635 419 639 416 635 b 396 639 406 635 402 636 b 128 792 383 644 166 727 b 108 868 120 808 108 838 b 186 958 108 907 125 948 z m 598 671 b 680 589 598 626 635 589 b 762 671 726 589 762 626 b 680 753 762 717 726 753 b 598 671 635 753 598 717 z m 202 380 b 120 462 202 425 166 462 b 37 380 75 462 37 425 b 120 298 37 334 75 298 b 202 380 166 298 202 334 z"
                },
                coda: {
                    x_min: -4,
                    x_max: 955,
                    y_min: -158,
                    y_max: 898,
                    ha: 1056,
                    o: "m 1349 576 l 1178 576 b 729 1083 1164 847 962 1064 l 729 1269 b 694 1293 729 1287 713 1293 b 660 1269 675 1293 660 1287 l 660 1083 b 210 576 426 1064 226 848 l 20 576 b -6 541 0 576 -6 560 b 20 507 -6 523 0 507 l 210 507 b 660 0 226 238 426 19 l 660 -202 b 694 -228 660 -222 675 -228 b 729 -202 713 -228 729 -222 l 729 0 b 1178 507 962 19 1164 238 l 1349 507 b 1375 541 1369 507 1375 523 b 1349 576 1375 560 1369 576 z m 940 576 l 729 576 l 729 1002 b 940 576 930 985 940 809 z m 660 1002 l 660 576 l 455 576 b 660 1002 455 809 455 985 z m 455 507 l 660 507 l 660 69 b 455 507 474 91 456 285 z m 729 69 l 729 507 l 940 507 b 729 69 936 287 909 91 z"
                },
                gClef: {
                    x_min: 0,
                    x_max: 671,
                    y_min: -658,
                    y_max: 1098,
                    ha: 1756,
                    o: "m 541 598 b 550 625 539 615 541 616 b 824 1174 706 770 824 953 b 730 1509 824 1299 789 1423 b 655 1581 708 1541 671 1581 b 562 1512 635 1581 590 1544 b 420 1064 455 1394 420 1214 b 441 828 420 981 431 887 b 428 793 444 811 445 808 b 0 125 220 622 0 416 b 524 -363 0 -125 171 -363 b 624 -354 557 -363 595 -360 b 645 -367 639 -351 642 -350 b 684 -657 662 -464 684 -589 b 455 -896 684 -870 540 -896 b 340 -854 377 -896 340 -873 b 386 -829 340 -844 353 -840 b 482 -694 431 -816 482 -778 b 344 -547 482 -615 432 -547 b 190 -713 248 -547 190 -624 b 464 -948 190 -806 246 -948 b 747 -660 560 -948 747 -904 b 706 -351 747 -577 721 -441 b 724 -327 703 -334 704 -336 b 966 16 870 -269 966 -147 b 619 363 966 200 831 363 b 577 389 582 363 582 363 z m 677 1358 b 763 1240 724 1358 763 1319 b 513 851 763 1080 626 950 b 494 863 503 842 497 844 b 485 995 488 900 485 949 b 677 1358 485 1220 589 1358 z m 520 377 b 498 343 524 350 524 351 b 289 63 372 300 289 186 b 455 -192 289 -66 357 -158 b 494 -200 467 -196 484 -200 b 511 -184 505 -200 511 -193 b 490 -166 511 -174 500 -170 b 386 -12 429 -140 386 -78 b 530 157 386 71 442 132 b 559 145 553 163 556 161 l 631 -284 b 611 -304 634 -300 632 -300 b 530 -311 588 -308 559 -311 b 115 29 278 -311 115 -171 b 249 363 115 114 130 228 b 469 567 336 459 402 513 b 490 562 484 579 487 577 z m 619 148 b 635 168 616 166 618 170 b 848 -66 752 158 848 60 b 713 -271 848 -157 793 -230 b 690 -262 696 -279 693 -279 z"
                },
                cClef: {
                    x_min: 0,
                    x_max: 699,
                    y_min: -506,
                    y_max: 506,
                    ha: 1012,
                    o: "m 331 694 b 301 724 331 714 321 724 l 300 724 b 269 694 279 724 269 714 l 269 -694 b 300 -724 269 -714 279 -724 l 301 -724 b 331 -694 321 -724 331 -714 l 331 -63 b 344 -55 331 -52 338 -53 b 472 -265 382 -65 442 -102 b 500 -301 477 -288 485 -301 b 530 -262 516 -301 523 -287 b 684 -128 549 -199 582 -128 b 804 -409 778 -128 804 -220 b 651 -683 804 -598 770 -683 b 528 -644 631 -683 528 -674 b 567 -622 528 -636 552 -628 b 625 -528 596 -612 625 -583 b 527 -429 625 -465 583 -429 b 416 -547 465 -429 416 -471 b 667 -729 416 -638 495 -729 b 1007 -413 903 -729 1007 -563 b 706 -76 1007 -215 897 -76 b 618 -89 664 -76 636 -84 b 576 -88 603 -94 589 -96 b 524 0 556 -75 524 -29 b 576 88 524 29 556 75 b 618 89 589 96 603 94 b 706 76 636 84 664 76 b 1007 413 897 76 1007 215 b 667 729 1007 563 903 729 b 416 547 495 729 416 638 b 527 429 416 471 465 429 b 625 528 583 429 625 465 b 567 622 625 583 596 612 b 528 644 552 628 528 636 b 651 683 528 674 631 683 b 804 409 770 683 804 598 b 684 128 804 220 778 128 b 530 262 582 128 549 199 b 500 301 523 287 516 301 b 472 265 485 301 477 288 b 344 55 442 102 382 65 b 331 63 338 53 331 52 z m 30 724 b 0 694 10 724 0 714 l 0 -694 b 30 -724 0 -714 10 -724 l 154 -724 b 184 -694 174 -724 184 -714 l 184 694 b 154 724 184 714 174 724 z"
                },
                fClef: {
                    x_min: -5,
                    x_max: 684,
                    y_min: -635,
                    y_max: 262,
                    ha: 897,
                    o: "m 363 377 b 0 56 112 377 0 194 b 177 -158 0 -59 60 -158 b 330 -6 268 -158 330 -95 b 192 144 330 86 262 144 b 120 134 153 144 138 134 b 96 160 101 134 96 145 b 330 323 96 217 183 323 b 549 -53 482 323 549 173 b 14 -871 549 -455 350 -680 b -7 -897 1 -878 -7 -886 b 12 -914 -7 -906 -1 -914 b 36 -907 19 -914 27 -912 b 765 -40 390 -734 765 -478 b 363 377 765 210 612 377 z m 906 259 b 827 180 861 259 827 225 b 906 101 827 135 861 101 b 985 180 950 101 985 135 b 906 259 985 225 950 259 z m 907 -102 b 829 -180 863 -102 829 -135 b 907 -258 829 -225 863 -258 b 985 -180 952 -258 985 -225 b 907 -102 985 -135 952 -102 z"
                },
                unpitchedPercussionClef1: {
                    x_min: 0,
                    x_max: 382,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 230 -338 l 230 338 b 210 360 230 350 222 360 l 20 360 b 0 338 9 360 0 350 l 0 -338 b 20 -360 0 -350 9 -360 l 210 -360 b 230 -338 222 -360 230 -350 z m 550 338 b 530 360 550 350 541 360 l 340 360 b 320 338 328 360 320 350 l 320 -338 b 340 -360 320 -350 328 -360 l 530 -360 b 550 -338 541 -360 550 -350 z"
                },
                "6stringTabClef": {
                    x_min: -3,
                    x_max: 408,
                    y_min: -748,
                    y_max: 764,
                    ha: 1512,
                    o: "m 557 1024 l 557 1100 l 26 1100 l 26 1024 l 249 1024 l 249 422 l 336 422 l 336 1024 z m 588 -328 l 350 348 l 238 348 l -4 -328 l 88 -328 l 160 -125 l 420 -125 l 491 -328 z m 397 -52 l 181 -52 l 292 256 z m 544 -883 b 420 -719 544 -802 507 -752 b 514 -572 482 -690 514 -639 b 314 -399 514 -472 442 -399 l 39 -399 l 39 -1077 l 344 -1077 b 544 -883 467 -1077 544 -995 z m 428 -583 b 292 -691 428 -652 389 -691 l 125 -691 l 125 -475 l 292 -475 b 428 -583 389 -475 428 -514 z m 458 -884 b 337 -1001 458 -949 418 -1001 l 125 -1001 l 125 -768 l 337 -768 b 458 -884 418 -768 458 -818 z"
                },
                timeSig0: {
                    x_min: 20,
                    x_max: 450,
                    y_min: -250,
                    y_max: 251,
                    ha: 501,
                    o: "m 648 0 b 338 361 648 200 510 361 b 29 0 167 361 29 200 b 338 -360 29 -199 167 -360 b 648 0 510 -360 648 -199 z m 338 317 b 446 10 397 317 446 180 b 338 -295 446 -158 397 -295 b 230 10 278 -295 230 -158 b 338 317 230 180 278 317 z"
                },
                timeSig1: {
                    x_min: 20,
                    x_max: 314,
                    y_min: -250,
                    y_max: 251,
                    ha: 501,
                    o: "m 35 19 b 29 0 35 19 29 10 b 45 -20 29 -7 33 -16 b 58 -23 50 -22 56 -23 b 78 -10 72 -23 78 -10 b 156 117 78 -10 140 89 b 170 131 161 127 167 131 b 179 111 176 131 179 120 l 179 -261 b 115 -315 179 -294 145 -315 b 91 -337 105 -315 91 -320 b 122 -360 91 -353 104 -360 l 429 -360 b 452 -337 452 -360 452 -337 b 431 -315 452 -337 452 -315 b 384 -265 410 -315 384 -289 l 384 328 b 356 361 384 351 376 360 b 281 356 336 361 300 356 b 206 360 253 356 228 357 b 199 361 203 360 200 361 b 173 334 184 361 179 347 z"
                },
                timeSig2: {
                    x_min: 20,
                    x_max: 426,
                    y_min: -257,
                    y_max: 254,
                    ha: 511,
                    o: "m 606 -131 b 589 -111 606 -114 599 -111 b 570 -127 577 -111 573 -117 l 569 -128 b 513 -192 554 -164 543 -192 b 488 -187 505 -192 498 -190 b 445 -171 469 -180 459 -179 b 289 -137 416 -160 348 -137 b 236 -145 271 -137 252 -140 b 422 -42 268 -94 390 -50 b 613 147 523 -14 613 27 b 330 366 613 300 464 366 b 69 275 229 366 140 357 b 29 170 45 245 29 209 b 42 108 29 150 33 130 b 160 29 63 63 108 29 b 261 156 248 29 261 120 b 161 275 261 242 161 246 b 275 330 164 295 190 330 b 405 192 403 330 405 233 b 193 -102 405 60 297 -39 b 33 -317 114 -153 58 -223 l 32 -321 b 69 -370 32 -340 48 -370 b 203 -282 101 -370 118 -282 b 410 -360 261 -282 282 -360 b 606 -131 472 -360 583 -354 z"
                },
                timeSig3: {
                    x_min: 20,
                    x_max: 401,
                    y_min: -251,
                    y_max: 249,
                    ha: 500,
                    o: "m 307 357 b 301 357 305 357 304 357 l 291 359 b 285 359 289 359 287 359 b 37 200 161 359 37 276 b 154 84 37 153 65 89 l 161 84 b 256 177 225 84 256 130 l 256 189 b 209 248 252 242 216 245 b 180 268 202 251 180 248 l 180 274 b 240 310 183 298 228 310 b 374 199 363 310 374 233 l 374 189 b 199 36 374 82 289 40 b 164 12 184 35 164 27 b 200 -6 164 -6 189 -6 b 379 -137 366 -6 379 -118 b 269 -307 379 -289 301 -307 b 256 -305 264 -307 258 -305 b 216 -282 245 -304 217 -304 l 216 -275 b 249 -180 216 -243 248 -222 b 145 -76 249 -120 207 -76 b 130 -78 140 -76 135 -76 b 60 -115 105 -82 78 -96 b 29 -203 36 -137 29 -171 b 275 -361 32 -315 134 -359 l 288 -361 b 577 -161 431 -361 577 -288 l 577 -151 b 537 -50 575 -109 564 -82 b 503 -20 528 -39 517 -29 l 472 -3 l 425 10 b 410 17 418 12 413 12 b 409 24 409 20 409 22 b 415 37 409 30 410 36 b 459 50 431 42 446 43 b 547 181 517 78 547 115 b 307 357 547 314 367 353 z"
                },
                timeSig4: {
                    x_min: 20,
                    x_max: 450,
                    y_min: -250,
                    y_max: 251,
                    ha: 501,
                    o: "m 521 -107 l 521 202 b 504 226 521 213 520 226 b 475 213 491 226 484 223 l 338 48 b 325 14 333 40 325 32 l 325 -107 l 131 -107 b 481 336 246 -9 477 318 l 482 340 b 461 361 482 353 472 361 b 363 359 448 361 389 359 b 261 361 337 359 272 361 b 228 334 248 361 228 357 b 43 -105 228 156 86 -45 l 35 -117 b 35 -118 35 -117 35 -118 l 33 -120 b 29 -137 30 -127 29 -132 b 58 -161 29 -151 40 -161 l 325 -161 l 325 -252 b 268 -302 325 -291 294 -302 b 235 -330 245 -302 235 -315 b 262 -360 235 -344 240 -360 l 569 -360 b 598 -330 583 -360 598 -350 b 566 -301 598 -310 580 -301 b 521 -246 552 -301 521 -292 l 521 -161 l 626 -161 b 648 -134 641 -161 648 -151 b 626 -107 648 -117 642 -107 z"
                },
                timeSig5: {
                    x_min: 20,
                    x_max: 383,
                    y_min: -251,
                    y_max: 246,
                    ha: 497,
                    o: "m 109 85 b 117 179 109 85 115 166 b 138 197 118 190 125 197 l 144 197 b 285 184 158 194 226 184 b 492 323 485 184 492 300 b 472 353 492 341 488 353 b 295 340 454 353 341 340 b 101 354 249 340 125 351 b 66 330 75 354 68 341 l 50 10 l 50 7 b 79 -14 50 -12 65 -14 b 111 14 94 -14 95 -1 b 209 62 125 29 160 62 b 357 -125 258 62 357 35 b 235 -304 357 -284 272 -304 b 202 -300 223 -304 212 -304 b 184 -279 194 -295 186 -289 b 202 -259 184 -269 194 -264 b 256 -163 235 -239 256 -203 b 144 -50 256 -99 206 -50 b 30 -157 66 -50 35 -107 b 29 -183 29 -166 29 -174 b 284 -361 29 -302 107 -361 b 552 -125 456 -361 552 -255 b 314 112 552 6 445 112 b 122 71 230 112 168 98 b 115 69 120 69 117 69 b 109 79 109 69 109 75 z"
                },
                timeSig6: {
                    x_min: 20,
                    x_max: 414,
                    y_min: -249,
                    y_max: 251,
                    ha: 500,
                    o: "m 439 120 b 554 229 500 120 554 167 b 553 245 554 235 554 239 b 348 361 539 337 426 361 b 85 209 239 360 137 307 b 29 4 53 148 29 72 l 29 -1 b 73 -200 30 -68 42 -143 b 324 -359 132 -307 203 -359 b 513 -307 389 -359 461 -348 b 596 -137 563 -266 596 -202 b 379 72 596 -24 490 72 b 248 22 333 72 285 55 b 239 19 245 19 242 19 b 226 53 230 19 226 30 b 346 327 230 320 315 327 b 393 305 374 327 393 320 b 357 251 393 285 366 268 b 347 209 350 238 347 223 b 369 150 347 187 354 166 b 439 120 379 131 420 120 z m 320 3 b 405 -158 366 3 405 -69 b 320 -320 405 -248 366 -320 b 236 -158 274 -320 236 -248 b 320 3 236 -69 274 3 z"
                },
                timeSig7: {
                    x_min: 20,
                    x_max: 421,
                    y_min: -250,
                    y_max: 249,
                    ha: 499,
                    o: "m 606 294 b 582 351 606 333 606 351 b 552 336 580 351 557 346 b 485 236 541 318 521 236 b 262 359 449 236 382 359 b 137 307 179 359 157 325 b 98 281 117 288 108 282 b 60 315 86 281 68 301 b 43 325 58 321 50 325 b 29 308 36 325 29 321 l 29 71 b 45 48 29 71 30 48 b 66 76 56 48 60 60 b 164 196 81 112 99 196 b 374 88 222 196 291 88 b 446 118 415 88 435 109 b 459 124 451 121 456 124 b 469 111 465 124 468 120 b 272 -112 469 71 359 -10 b 173 -315 217 -176 173 -259 b 200 -360 173 -346 173 -360 b 294 -347 226 -360 258 -347 b 412 -360 330 -347 397 -360 b 435 -307 426 -360 435 -348 b 606 288 435 -66 606 140 z"
                },
                timeSig8: {
                    x_min: 20,
                    x_max: 416,
                    y_min: -259,
                    y_max: 259,
                    ha: 518,
                    o: "m 481 52 b 567 204 533 85 567 132 b 317 373 567 351 356 373 b 36 176 150 373 36 297 b 161 -16 36 76 92 23 b 29 -190 86 -52 29 -99 b 301 -373 29 -315 158 -373 b 599 -117 445 -373 599 -311 b 481 52 599 -30 549 17 z m 406 85 b 168 240 291 125 168 150 b 314 331 168 301 251 331 b 482 207 360 331 482 308 b 406 85 482 150 454 112 z m 295 -325 b 111 -183 199 -325 111 -276 b 225 -48 111 -125 161 -72 b 436 -219 330 -94 436 -124 b 295 -325 436 -276 392 -325 z"
                },
                timeSig9: {
                    x_min: 20,
                    x_max: 414,
                    y_min: -249,
                    y_max: 251,
                    ha: 500,
                    o: "m 186 -117 b 71 -226 125 -117 71 -164 b 72 -242 71 -232 71 -236 b 276 -359 86 -334 199 -359 b 540 -206 386 -357 488 -304 b 596 -1 572 -145 596 -69 l 596 4 b 552 203 595 71 583 145 b 301 361 492 310 422 361 b 112 310 236 361 164 351 b 29 140 62 269 29 204 b 246 -69 29 27 135 -69 b 377 -19 292 -69 340 -52 b 386 -16 380 -16 383 -16 b 399 -50 395 -16 399 -27 b 279 -324 395 -317 310 -324 b 232 -302 251 -324 232 -317 b 268 -248 232 -282 259 -265 b 278 -206 275 -235 278 -220 b 256 -147 278 -184 271 -163 b 186 -117 246 -128 204 -117 z m 305 0 b 220 161 259 0 220 72 b 305 323 220 251 259 323 b 389 161 351 323 389 251 b 305 0 389 72 351 0 z"
                },
                timeSigCommon: {
                    x_min: 5,
                    x_max: 424,
                    y_min: -249,
                    y_max: 251,
                    ha: 500,
                    o: "m 336 361 b 7 -14 131 361 7 180 b 101 -262 7 -108 42 -190 b 321 -359 156 -328 235 -359 b 611 -88 573 -359 611 -130 b 589 -56 611 -56 595 -56 b 567 -82 577 -56 567 -58 b 363 -311 567 -268 409 -311 b 184 40 246 -311 184 -197 b 372 327 184 278 294 327 b 477 278 446 327 477 292 b 451 246 477 265 472 246 b 360 140 393 246 360 184 b 471 32 360 58 431 32 b 580 156 471 32 580 36 b 336 361 580 344 363 361 z"
                },
                timeSigCutCommon: {
                    x_min: 0,
                    x_max: 418,
                    y_min: -359,
                    y_max: 361,
                    ha: 720,
                    o: "m 573 -58 b 559 -82 567 -58 559 -60 b 354 -310 559 -266 400 -310 b 317 -305 340 -310 328 -308 b 302 -284 311 -304 302 -295 l 302 287 b 338 323 302 297 328 321 b 363 324 347 324 356 324 b 468 275 436 324 468 289 b 442 243 468 264 464 243 b 351 137 384 243 351 181 b 462 30 351 56 422 30 b 572 154 462 30 572 35 b 318 357 572 295 441 357 b 302 390 310 359 302 383 l 302 495 b 276 520 302 507 292 520 b 252 495 265 520 252 507 l 252 369 b 235 346 252 359 238 346 l 196 331 b 0 -14 66 275 0 122 b 225 -346 0 -150 86 -310 b 252 -382 235 -350 252 -369 l 252 -492 b 276 -517 252 -505 265 -517 b 302 -492 292 -517 302 -505 l 302 -379 b 318 -359 302 -370 308 -363 b 602 -85 563 -354 602 -130 b 579 -58 600 -58 586 -58 z m 252 -235 b 243 -252 252 -248 248 -252 b 236 -248 240 -252 238 -251 b 177 37 197 -193 177 -96 b 232 259 177 147 200 215 b 236 262 233 262 235 262 b 252 239 243 262 252 251 z"
                },
                timeSigPlus: {
                    x_min: -1,
                    x_max: 499,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 432 53 b 413 79 420 53 413 65 l 413 340 b 392 360 413 350 405 360 l 325 360 b 305 340 312 360 305 350 l 305 79 b 284 53 305 66 292 53 l 19 53 b -1 33 9 53 -1 46 l -1 -33 b 19 -55 -1 -46 9 -55 l 284 -55 b 305 -75 298 -55 305 -68 l 305 -340 b 325 -360 305 -350 312 -360 l 392 -360 b 413 -340 405 -360 413 -350 l 413 -78 b 433 -55 413 -63 423 -55 l 698 -55 b 719 -33 708 -55 719 -46 l 719 33 b 698 53 719 46 708 53 z"
                },
                timeSigPlusSmall: {
                    x_min: -1,
                    x_max: 255,
                    y_min: -133,
                    y_max: 123,
                    ha: 256,
                    o: "m 220 20 b 210 33 215 20 210 26 l 210 166 b 200 177 210 171 206 177 l 166 177 b 156 166 160 177 156 171 l 156 33 b 145 20 156 27 150 20 l 10 20 b -1 10 4 20 -1 16 l -1 -24 b 10 -35 -1 -30 4 -35 l 145 -35 b 156 -46 153 -35 156 -42 l 156 -180 b 166 -192 156 -186 160 -192 l 200 -192 b 210 -180 206 -192 210 -186 l 210 -48 b 222 -35 210 -39 216 -35 l 356 -35 b 367 -24 361 -35 367 -30 l 367 10 b 356 20 367 16 361 20 z"
                },
                timeSigMinus: {
                    x_min: 0,
                    x_max: 448,
                    y_min: -35,
                    y_max: 40,
                    ha: 75,
                    o: "m 645 39 b 619 58 645 49 634 58 l 27 58 b 0 39 12 58 0 49 l 0 -32 b 27 -50 0 -42 12 -50 l 619 -50 b 645 -32 634 -50 645 -42 z"
                },
                timeSigParensRight: {
                    x_min: 0,
                    x_max: 184,
                    y_min: -489,
                    y_max: 491,
                    ha: 980,
                    o: "m 0 -696 b 3 -704 0 -698 1 -704 b 7 -703 4 -704 6 -704 b 265 1 187 -530 265 -282 b 12 701 265 289 187 531 b 4 707 12 701 6 707 b 0 696 1 707 0 703 l 0 665 b 4 644 0 665 0 651 b 167 1 112 503 167 315 b 6 -641 167 -311 109 -497 b 0 -658 3 -644 0 -651 z"
                },
                timeSigParensRightSmall: {
                    x_min: 0,
                    x_max: 110,
                    y_min: -251,
                    y_max: 249,
                    ha: 500,
                    o: "m 0 -356 b 3 -361 0 -357 1 -361 b 158 0 112 -272 158 -145 b 4 359 158 147 109 272 b 0 353 3 359 0 357 l 0 338 b 3 327 0 338 0 330 b 91 0 60 246 91 160 b 4 -328 91 -160 62 -249 b 0 -337 3 -330 0 -333 z"
                },
                timeSigParensLeft: {
                    x_min: 0,
                    x_max: 184,
                    y_min: -489,
                    y_max: 491,
                    ha: 980,
                    o: "m 265 -658 b 259 -641 265 -651 262 -644 b 98 1 156 -497 98 -311 b 261 644 98 315 153 503 b 265 665 265 651 265 665 l 265 696 b 261 707 265 703 264 707 b 253 701 259 707 253 701 b 0 1 78 531 0 289 b 258 -703 0 -282 78 -530 b 262 -704 259 -704 261 -704 b 265 -696 264 -704 265 -698 z"
                },
                timeSigParensLeftSmall: {
                    x_min: 0,
                    x_max: 110,
                    y_min: -251,
                    y_max: 249,
                    ha: 500,
                    o: "m 158 -337 b 154 -328 158 -333 156 -330 b 68 0 96 -249 68 -160 b 156 327 68 160 98 246 b 158 338 158 330 158 338 l 158 353 b 154 359 158 357 156 359 b 0 0 49 272 0 147 b 156 -361 0 -145 46 -272 b 158 -356 157 -361 158 -357 z"
                },
                noteheadDoubleWhole: {
                    x_min: 0,
                    x_max: 599,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 13 223 b 0 212 4 223 0 217 l 0 -213 b 13 -223 0 -219 4 -223 l 32 -223 b 45 -213 39 -223 45 -219 l 45 212 b 32 223 45 217 39 223 z m 96 223 b 82 212 88 223 82 217 l 82 -213 b 96 -223 82 -219 88 -223 l 114 -223 b 128 -213 121 -223 128 -219 l 128 212 b 114 223 128 217 121 223 z m 747 223 b 733 212 740 223 733 217 l 733 -213 b 747 -223 733 -219 740 -223 l 766 -223 b 780 -213 773 -223 780 -219 l 780 212 b 766 223 780 217 773 223 z m 829 223 b 815 212 824 223 815 217 l 815 -213 b 829 -223 815 -219 824 -223 l 848 -223 b 863 -213 857 -223 863 -219 l 863 212 b 848 223 863 217 857 223 z m 438 180 b 130 1 248 180 130 101 b 423 -180 130 -92 210 -180 b 733 1 657 -180 733 -98 b 438 180 733 104 572 180 z m 469 -145 b 331 -71 409 -145 369 -112 b 284 58 305 -37 284 12 b 400 147 284 131 333 147 b 577 -45 498 147 577 42 b 469 -145 577 -115 533 -145 z"
                },
                noteheadWhole: {
                    x_min: 0,
                    x_max: 422,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 311 180 b 0 3 120 180 0 101 b 297 -180 0 -94 82 -180 b 608 3 533 -180 608 -98 b 311 180 608 105 445 180 z m 160 91 b 274 148 176 141 229 148 b 452 -45 373 148 452 42 b 386 -141 452 -89 433 -130 b 341 -147 372 -145 356 -147 b 206 -72 289 -147 236 -112 b 156 56 177 -39 156 10 b 160 91 156 68 157 79 z"
                },
                noteheadHalf: {
                    x_min: 0,
                    x_max: 295,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 140 -180 b 425 60 377 -180 425 13 b 282 180 425 134 366 180 b 0 -60 68 180 0 14 b 140 -180 0 -137 60 -180 z m 108 -125 b 50 -92 78 -125 60 -109 b 42 -63 46 -84 42 -73 b 318 121 42 7 251 121 b 372 91 346 121 361 108 b 380 63 376 82 380 73 b 108 -125 380 1 177 -125 z"
                },
                noteheadBlack: {
                    x_min: 0,
                    x_max: 295,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 140 -180 b 425 60 268 -180 425 -62 b 285 180 425 134 367 180 b 0 -60 127 180 0 63 b 140 -180 0 -135 62 -180 z"
                },
                noteheadXDoubleWhole: {
                    x_min: 0,
                    x_max: 546,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 43 213 b 30 223 43 217 39 223 l 13 223 b 0 213 6 223 0 217 l 0 -215 b 13 -223 0 -219 6 -223 l 30 -223 b 43 -215 39 -223 43 -219 z m 704 213 b 693 223 704 217 698 223 l 672 223 b 660 213 667 223 660 217 l 660 163 b 634 180 655 173 645 180 l 505 180 b 484 173 498 180 490 177 l 393 95 l 300 173 b 279 180 294 177 287 180 l 151 180 b 125 163 141 180 130 173 l 125 213 b 112 223 125 217 118 223 l 94 223 b 82 213 86 223 82 217 l 82 -215 b 94 -223 82 -219 86 -223 l 112 -223 b 125 -215 118 -223 125 -219 l 125 -163 b 151 -180 130 -173 140 -180 l 279 -180 b 300 -171 287 -180 294 -177 l 393 -95 l 485 -171 b 505 -180 491 -177 498 -180 l 632 -180 b 660 -163 645 -180 655 -173 l 660 -215 b 672 -223 660 -219 667 -223 l 693 -223 b 704 -215 698 -223 704 -219 z m 786 213 b 772 223 786 217 780 223 l 755 223 b 740 213 747 223 740 217 l 740 -215 b 755 -223 740 -219 747 -223 l 772 -223 b 786 -215 780 -223 786 -219 z m 507 -141 l 393 -45 l 276 -141 l 207 -141 l 364 0 l 207 141 l 276 141 l 393 45 l 507 141 l 577 141 l 420 0 l 577 -141 z m 660 -132 l 518 0 l 660 132 z m 125 131 l 266 0 l 125 -131 z"
                },
                noteheadXWhole: {
                    x_min: 0,
                    x_max: 377,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 272 -95 l 364 -171 b 384 -180 370 -177 377 -180 l 511 -180 b 543 -148 528 -180 543 -164 b 531 -124 543 -140 539 -131 l 412 0 l 531 124 b 541 148 539 131 541 140 b 513 180 541 164 528 180 l 384 180 b 364 171 377 180 370 177 l 272 94 l 179 171 b 158 180 173 177 166 180 l 30 180 b 0 148 16 180 0 164 b 12 124 0 140 4 131 l 132 0 l 12 -124 b 1 -148 4 -131 1 -140 b 32 -180 1 -164 14 -180 l 158 -180 b 179 -171 166 -180 173 -177 z m 386 -141 l 272 -45 l 157 -141 l 88 -141 l 245 0 l 88 141 l 157 141 l 272 45 l 386 141 l 456 141 l 300 0 l 456 -141 z"
                },
                noteheadXHalf: {
                    x_min: 0,
                    x_max: 334,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 295 180 b 271 170 287 180 278 177 l 209 98 l 115 171 b 95 180 109 177 104 180 l 36 180 b 4 148 19 180 4 164 b 14 124 4 140 7 132 l 140 22 l 7 -127 b 0 -148 3 -131 0 -138 b 32 -180 0 -166 14 -180 l 184 -180 b 209 -170 193 -180 203 -177 l 271 -99 l 363 -171 b 384 -180 370 -176 377 -180 l 445 -180 b 478 -147 461 -180 478 -163 b 465 -125 478 -138 474 -131 l 341 -22 l 474 127 b 481 148 480 131 481 138 b 448 180 481 166 468 180 z m 36 148 l 95 148 l 233 33 l 334 148 l 410 148 l 274 -6 l 445 -148 l 384 -148 l 248 -35 l 147 -148 l 71 -148 l 206 4 z"
                },
                noteheadXBlack: {
                    x_min: 0,
                    x_max: 290,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 410 -143 l 239 0 l 410 144 b 418 160 415 147 418 154 b 399 180 418 171 408 180 b 389 177 396 180 392 179 l 207 26 l 29 177 b 17 180 26 179 22 180 b 0 161 7 180 0 170 b 7 144 0 156 3 148 l 179 0 l 7 -143 b 0 -158 1 -147 0 -153 b 19 -180 0 -170 7 -180 b 29 -176 23 -180 26 -179 l 207 -24 l 389 -176 b 399 -180 392 -179 396 -180 b 418 -160 410 -180 418 -168 b 410 -143 418 -153 415 -147 z"
                },
                noteheadCircleXDoubleWhole: {
                    x_min: 0,
                    x_max: 422,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 576 223 b 563 213 570 223 563 219 l 563 -215 b 576 -223 563 -219 570 -223 l 595 -223 b 608 -215 602 -223 608 -219 l 608 213 b 595 223 608 219 602 223 z m 497 223 b 484 213 491 223 484 219 l 484 -215 b 497 -223 484 -219 491 -223 l 516 -223 b 528 -215 523 -223 528 -219 l 528 213 b 516 223 528 219 523 223 z m 94 223 b 81 213 86 223 81 219 l 81 -215 b 94 -223 81 -219 86 -223 l 111 -223 b 124 -215 118 -223 124 -219 l 124 213 b 111 223 124 219 118 223 z m 13 223 b 0 213 6 223 0 219 l 0 -215 b 13 -223 0 -219 6 -223 l 30 -223 b 45 -215 37 -223 45 -219 l 45 213 b 30 223 45 219 37 223 z m 304 180 b 127 0 206 180 127 101 b 304 -180 127 -99 206 -180 b 482 0 405 -180 482 -99 b 304 180 482 101 405 180 z m 305 32 l 225 112 b 304 140 248 130 275 140 b 387 112 336 140 364 130 z m 278 1 l 193 -82 b 216 0 199 -59 216 -30 b 194 85 216 33 203 50 z m 334 1 l 418 84 b 389 0 402 50 389 23 b 418 -81 389 -30 409 -60 z m 305 -27 l 389 -109 b 304 -138 364 -128 336 -138 b 222 -109 274 -138 246 -128 z"
                },
                noteheadCircleXWhole: {
                    x_min: 0,
                    x_max: 249,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 179 180 b 0 0 81 180 0 101 b 179 -180 0 -99 81 -180 b 359 0 278 -180 359 -99 b 179 180 359 101 278 180 z m 180 32 l 99 112 b 179 140 121 130 150 140 b 262 112 210 140 238 130 z m 151 1 l 68 -82 b 86 0 73 -59 86 -30 b 68 85 86 33 78 50 z m 209 1 l 291 84 b 269 0 276 50 269 32 b 291 -79 269 -26 282 -58 z m 180 -27 l 264 -111 b 179 -138 239 -128 210 -138 b 96 -111 148 -138 120 -128 z"
                },
                noteheadCircleXHalf: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 179 180 b 0 0 81 180 0 101 b 179 -180 0 -99 81 -180 b 360 0 278 -180 360 -99 b 179 180 360 101 278 180 z m 186 37 l 131 92 b 220 124 153 109 189 124 b 262 112 236 124 249 121 z m 215 7 l 291 84 b 304 42 300 71 304 58 b 271 -49 304 10 288 -26 z m 145 -6 l 68 -82 b 56 -42 59 -71 56 -58 b 89 52 56 -9 72 27 z m 174 -33 l 230 -89 b 140 -124 206 -108 171 -124 b 96 -111 122 -124 109 -121 z"
                },
                noteheadCircleX: {
                    x_min: 0,
                    x_max: 249,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 179 180 b 0 0 81 180 0 99 b 179 -180 0 -99 81 -180 b 359 0 278 -180 359 -99 b 179 180 359 99 278 180 z m 261 112 l 180 30 l 98 112 b 179 138 121 128 148 138 b 261 112 210 138 238 128 z m 317 0 b 292 -82 317 -30 308 -59 l 209 1 l 291 84 b 317 0 307 60 317 30 z m 40 0 b 69 84 40 32 50 60 l 151 1 l 68 -84 b 40 0 49 -60 40 -30 z m 95 -111 l 180 -27 l 262 -111 b 179 -138 239 -128 210 -138 b 95 -111 148 -138 120 -128 z"
                },
                noteheadCircledDoubleWhole: {
                    x_min: 0,
                    x_max: 603,
                    y_min: -218,
                    y_max: 213,
                    ha: 431,
                    o: "m 770 223 l 752 223 b 737 213 744 223 737 219 l 737 59 b 435 307 710 203 582 307 b 128 48 281 307 156 197 l 128 213 b 115 223 128 219 122 223 l 96 223 b 84 213 89 223 84 219 l 84 -215 b 96 -223 84 -220 89 -223 l 115 -223 b 128 -215 122 -223 128 -220 l 128 -56 b 435 -314 156 -206 282 -314 b 654 -223 517 -314 595 -282 b 737 -66 697 -180 726 -125 l 737 -215 b 752 -223 737 -220 744 -223 l 770 -223 b 785 -215 778 -223 785 -220 l 785 213 b 770 223 785 219 778 223 z m 435 274 b 698 85 556 274 661 194 b 439 180 641 143 534 180 b 176 99 320 180 228 148 b 435 274 217 203 318 274 z m 32 223 l 13 223 b 0 213 6 223 0 219 l 0 -215 b 13 -223 0 -220 6 -223 l 32 -223 b 45 -215 40 -223 45 -220 l 45 213 b 32 223 45 219 40 223 z m 852 223 l 835 223 b 819 213 828 223 819 219 l 819 -215 b 835 -223 819 -220 828 -223 l 852 -223 b 868 -215 861 -223 868 -220 l 868 213 b 852 223 868 219 861 223 z m 580 -46 b 514 -143 580 -91 562 -131 b 472 -148 501 -147 487 -148 b 364 -105 433 -148 395 -131 l 334 -73 b 285 58 307 -39 285 10 b 289 91 285 69 287 79 b 403 145 305 140 357 145 b 580 -46 501 145 580 42 z m 435 -282 b 176 -108 318 -282 217 -209 b 425 -180 222 -151 301 -180 b 691 -109 563 -180 647 -153 b 435 -282 651 -210 550 -282 z"
                },
                noteheadCircledWhole: {
                    x_min: 0,
                    x_max: 437,
                    y_min: -225,
                    y_max: 211,
                    ha: 436,
                    o: "m 314 304 b 0 -10 140 304 0 164 b 314 -324 0 -183 141 -324 b 629 -10 487 -324 629 -183 b 314 304 629 164 488 304 z m 314 275 b 588 73 441 275 549 193 b 321 180 536 137 420 180 b 48 88 190 180 95 143 b 314 275 85 199 199 275 z m 393 -141 b 350 -147 379 -145 364 -147 b 314 -141 337 -147 325 -145 b 167 55 235 -120 167 -26 b 173 91 167 66 168 79 b 284 145 187 138 239 145 b 459 -48 382 145 459 39 b 393 -141 459 -91 438 -131 z m 314 -294 b 40 -86 187 -294 75 -207 b 305 -180 81 -141 164 -180 b 588 -86 464 -180 550 -143 b 314 -294 554 -209 442 -294 z"
                },
                noteheadCircledHalf: {
                    x_min: -18,
                    x_max: 311,
                    y_min: -162,
                    y_max: 167,
                    ha: 329,
                    o: "m 212 240 b -26 3 81 240 -26 134 b 212 -233 -26 -127 81 -233 b 448 3 341 -233 448 -127 b 212 240 448 134 341 240 z m 212 220 b 363 160 271 220 324 197 b 281 180 341 173 312 180 b 0 -52 76 180 6 26 b -6 3 -4 -35 -6 -16 b 212 220 -6 122 92 220 z m 50 -92 b 42 -63 46 -84 42 -73 b 173 63 42 -33 73 7 b 317 120 243 105 288 120 b 369 89 344 120 359 107 b 377 62 374 81 377 72 b 248 -66 377 33 348 -1 b 108 -125 183 -109 138 -125 b 50 -92 78 -125 60 -109 z m 212 -215 b 84 -171 164 -215 120 -199 b 138 -180 101 -179 120 -180 b 422 56 372 -180 420 7 b 429 3 426 40 429 22 b 212 -215 429 -117 333 -215 z"
                },
                noteheadCircledBlack: {
                    x_min: -21,
                    x_max: 321,
                    y_min: -171,
                    y_max: 167,
                    ha: 338,
                    o: "m 216 240 b -30 -3 82 240 -30 131 b 216 -246 -30 -137 82 -246 b 462 -3 351 -246 462 -137 b 216 240 462 131 351 240 z m 216 220 b 372 160 276 220 331 197 b 284 180 348 174 317 180 b 0 -59 127 180 0 65 l 0 -66 b -10 -3 -6 -45 -10 -24 b 216 220 -10 120 92 220 z m 216 -226 b 56 -158 153 -226 96 -200 b 140 -180 79 -171 107 -180 b 425 60 268 -180 425 -60 b 422 88 425 71 425 79 b 442 -3 435 60 442 29 b 216 -226 442 -125 341 -226 z"
                },
                noteheadDoubleWholeSquare: {
                    x_min: 0,
                    x_max: 416,
                    y_min: -190,
                    y_max: 198,
                    ha: 388,
                    o: "m 563 217 b 528 180 563 192 544 180 l 62 180 b 36 215 52 180 36 192 l 36 268 b 17 285 36 278 27 285 b 0 268 7 285 0 278 l 0 -255 b 17 -274 0 -264 7 -274 b 36 -255 27 -274 36 -264 l 36 -213 b 66 -180 36 -197 53 -180 l 528 -180 b 563 -209 549 -180 563 -196 l 563 -255 b 580 -274 563 -264 570 -274 b 599 -255 590 -274 599 -264 l 599 268 b 580 285 599 278 590 285 b 563 268 570 285 563 278 z m 36 23 b 111 71 36 55 58 71 l 487 71 b 563 30 533 71 563 53 l 563 -22 b 487 -68 563 -53 533 -68 l 117 -68 b 36 -22 66 -68 36 -49 z"
                },
                noteheadSquareWhite: {
                    x_min: 0,
                    x_max: 313,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 451 -180 l 451 180 l 0 180 l 0 -180 z m 40 -138 l 40 140 l 410 140 l 410 -138 z"
                },
                noteheadSquareBlack: {
                    x_min: 0,
                    x_max: 313,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 451 -180 l 451 180 l 0 180 l 0 -180 z"
                },
                noteheadTriangleDownDoubleWhole: {
                    x_min: 0,
                    x_max: 483,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 696 213 b 681 223 696 219 690 223 l 662 223 b 648 213 655 223 648 219 l 648 -213 b 662 -223 648 -217 655 -223 l 681 -223 b 696 -213 690 -223 696 -217 z m 619 213 b 605 223 619 219 613 223 l 588 223 b 573 213 580 223 573 219 l 573 174 b 562 180 570 177 566 180 l 134 180 b 122 174 130 180 125 177 l 122 213 b 108 223 122 219 117 223 l 91 223 b 76 213 84 223 76 219 l 76 -213 b 91 -223 76 -217 84 -223 l 108 -223 b 122 -213 117 -223 122 -217 l 122 154 l 334 -173 b 346 -180 337 -177 341 -180 b 357 -173 351 -180 354 -177 l 573 154 l 573 -213 b 588 -223 573 -217 580 -223 l 605 -223 b 619 -213 613 -223 619 -217 z m 32 -223 b 46 -213 40 -223 46 -217 l 46 213 b 32 223 46 219 40 223 l 14 223 b 0 213 7 223 0 219 l 0 -213 b 14 -223 0 -217 7 -223 z m 428 98 b 346 -107 428 17 377 -53 b 265 96 315 -55 265 17 b 289 137 265 109 275 137 l 406 137 b 428 98 419 137 428 111 z"
                },
                noteheadTriangleDownWhole: {
                    x_min: 0,
                    x_max: 319,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 14 180 b 0 166 6 180 0 173 b 1 158 0 163 1 160 l 216 -173 b 228 -180 219 -177 225 -180 b 239 -173 233 -180 238 -177 l 458 158 b 459 166 458 160 459 163 b 445 180 459 173 454 180 z m 288 137 b 310 98 301 137 310 111 b 228 -108 310 17 259 -55 b 145 96 197 -56 145 17 b 170 137 145 109 157 137 z"
                },
                noteheadTriangleDownHalf: {
                    x_min: 0,
                    x_max: 285,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 196 -180 b 209 -173 200 -180 206 -177 l 408 157 b 410 166 409 160 410 163 b 396 180 410 173 403 180 l 14 180 b 0 166 4 180 0 173 b 1 158 0 163 0 161 l 183 -173 b 196 -180 184 -174 190 -180 z m 164 138 l 295 138 l 179 -76 l 114 37 z"
                },
                noteheadTriangleDownBlack: {
                    x_min: 0,
                    x_max: 292,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 207 -180 l 420 180 l 0 180 z"
                },
                noteheadTriangleUpDoubleWhole: {
                    x_min: 0,
                    x_max: 483,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 696 213 b 681 223 696 217 690 223 l 662 223 b 648 213 655 223 648 217 l 648 -213 b 662 -223 648 -219 655 -223 l 681 -223 b 696 -213 690 -223 696 -219 z m 619 213 b 605 223 619 217 613 223 l 588 223 b 573 213 580 223 573 217 l 573 -154 l 357 173 b 346 180 354 177 351 180 b 334 173 341 180 337 177 l 122 -154 l 122 213 b 108 223 122 217 117 223 l 91 223 b 76 213 84 223 76 217 l 76 -213 b 91 -223 76 -219 84 -223 l 108 -223 b 122 -213 117 -223 122 -219 l 122 -174 b 134 -180 125 -177 130 -180 l 562 -180 b 573 -174 566 -180 570 -177 l 573 -213 b 588 -223 573 -219 580 -223 l 605 -223 b 619 -213 613 -223 619 -219 z m 32 223 l 14 223 b 0 213 7 223 0 217 l 0 -213 b 14 -223 0 -219 7 -223 l 32 -223 b 46 -213 40 -223 46 -219 l 46 213 b 32 223 46 217 40 223 z m 428 -98 b 406 -137 428 -111 419 -137 l 289 -137 b 265 -96 275 -137 265 -109 b 346 107 265 -17 315 55 b 428 -98 377 53 428 -17 z"
                },
                noteheadTriangleUpWhole: {
                    x_min: 0,
                    x_max: 319,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 445 -180 b 459 -166 454 -180 459 -173 b 458 -158 459 -163 458 -160 l 239 173 b 228 180 238 177 233 180 b 216 173 225 180 219 177 l 1 -158 b 0 -166 1 -160 0 -163 b 14 -180 0 -173 6 -180 z m 170 -137 b 145 -96 157 -137 145 -109 b 228 108 145 -17 197 56 b 310 -98 259 55 310 -17 b 288 -137 310 -111 301 -137 z"
                },
                noteheadTriangleUpHalf: {
                    x_min: 0,
                    x_max: 285,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 215 180 b 202 173 210 180 204 177 l 3 -157 b 0 -166 1 -160 0 -163 b 14 -180 0 -173 7 -180 l 396 -180 b 410 -166 406 -180 410 -173 b 409 -158 410 -163 410 -161 l 228 173 b 215 180 226 174 220 180 z m 246 -138 l 115 -138 l 232 76 l 297 -37 z"
                },
                noteheadTriangleUpBlack: {
                    x_min: 0,
                    x_max: 293,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 422 -180 l 207 180 l 0 -180 z"
                },
                noteheadSlashedDoubleWhole1: {
                    x_min: 0,
                    x_max: 596,
                    y_min: -179,
                    y_max: 168,
                    ha: 347,
                    o: "m 618 135 l 697 206 b 704 222 703 210 704 216 b 698 236 704 226 703 232 b 683 242 694 239 688 242 b 670 238 677 242 674 240 l 575 153 b 435 180 531 168 481 180 b 128 0 246 180 128 98 b 236 -148 128 -58 160 -114 l 153 -222 b 145 -238 148 -226 145 -232 b 151 -252 145 -242 148 -248 b 167 -258 156 -256 161 -258 b 181 -253 171 -258 177 -256 l 282 -164 b 420 -180 320 -173 366 -180 b 729 0 654 -180 729 -98 b 618 135 729 55 681 104 z m 114 223 l 95 223 b 82 212 88 223 82 217 l 82 -215 b 95 -223 82 -219 88 -223 l 114 -223 b 127 -215 121 -223 127 -219 l 127 212 b 114 223 127 217 121 223 z m 32 223 l 13 223 b 0 212 6 223 0 217 l 0 -215 b 13 -223 0 -219 6 -223 l 32 -223 b 45 -215 39 -223 45 -219 l 45 212 b 32 223 45 217 39 223 z m 844 223 l 825 223 b 811 212 819 223 811 217 l 811 -215 b 825 -223 811 -219 819 -223 l 844 -223 b 858 -215 851 -223 858 -219 l 858 212 b 844 223 858 217 851 223 z m 763 223 l 743 223 b 730 212 736 223 730 217 l 730 -215 b 743 -223 730 -219 736 -223 l 763 -223 b 776 -215 769 -223 776 -219 l 776 212 b 763 223 776 217 769 223 z m 282 56 b 285 89 282 68 284 79 b 399 144 301 137 354 144 b 510 95 441 144 480 124 l 327 -68 b 282 56 301 -35 282 13 z m 572 -72 b 508 -141 564 -108 544 -132 b 467 -147 495 -145 481 -147 b 360 -104 428 -147 389 -128 l 356 -98 l 537 63 b 575 -46 560 30 575 -9 b 572 -72 575 -55 573 -65 z"
                },
                noteheadSlashedWhole1: {
                    x_min: -22,
                    x_max: 433,
                    y_min: -157,
                    y_max: 148,
                    ha: 305,
                    o: "m 484 140 b 308 180 431 166 367 180 b 0 1 118 180 0 99 b 73 -128 0 -48 22 -95 l -22 -190 b -32 -206 -27 -194 -32 -200 b -27 -217 -32 -210 -30 -215 b -12 -226 -23 -223 -17 -226 b 0 -223 -7 -226 -4 -225 l 112 -150 b 294 -180 157 -168 217 -180 b 602 1 526 -180 602 -98 b 523 118 602 48 570 86 l 613 177 b 624 193 619 181 624 187 b 619 204 624 197 622 200 b 603 213 615 209 609 213 b 592 209 599 213 596 212 z m 190 -52 b 154 56 170 -20 154 19 b 160 91 154 68 156 79 b 271 147 174 138 226 147 b 396 82 321 147 364 121 z m 419 50 b 446 -48 436 19 446 -14 b 337 -147 446 -120 402 -147 b 301 -141 327 -147 314 -144 b 235 -104 276 -134 253 -120 b 215 -84 226 -98 220 -91 z"
                },
                noteheadSlashedHalf1: {
                    x_min: -67,
                    x_max: 386,
                    y_min: -142,
                    y_max: 160,
                    ha: 302,
                    o: "m 552 222 b 536 230 549 228 543 230 b 524 228 533 230 528 230 l 389 140 b 281 180 364 164 327 180 b 0 -60 65 180 0 13 b 7 -105 0 -78 3 -92 l -88 -167 b -96 -184 -94 -171 -96 -177 b -94 -194 -96 -187 -95 -192 b -76 -204 -89 -202 -84 -204 b -66 -202 -73 -204 -69 -203 l 29 -140 b 137 -180 55 -167 92 -180 b 420 59 374 -180 420 13 b 412 107 420 76 419 92 l 546 194 b 556 210 552 197 556 204 b 552 222 556 213 554 217 z m 315 120 b 347 112 328 120 338 117 l 46 -82 b 42 -63 43 -76 42 -69 b 315 120 42 6 248 120 z m 108 -124 b 69 -114 91 -124 79 -120 l 372 81 b 376 63 374 75 376 69 b 108 -124 376 0 174 -124 z"
                },
                noteheadSlashedBlack1: {
                    x_min: -80,
                    x_max: 375,
                    y_min: -165,
                    y_max: 167,
                    ha: 332,
                    o: "m 518 240 b 507 236 514 240 510 239 l 384 148 b 284 180 359 168 324 180 b 0 -62 127 180 0 63 b 13 -115 0 -82 4 -99 l -107 -202 b -115 -217 -111 -204 -115 -212 b -111 -229 -115 -222 -114 -225 b -95 -238 -108 -235 -101 -238 b -84 -235 -91 -238 -86 -236 l 39 -148 b 140 -180 63 -170 99 -180 b 425 59 268 -180 425 -62 b 410 117 425 81 420 101 l 530 203 b 540 219 536 207 540 213 b 518 240 540 229 528 240 z"
                },
                noteheadSlashedDoubleWhole2: {
                    x_min: 0,
                    x_max: 596,
                    y_min: -178,
                    y_max: 169,
                    ha: 347,
                    o: "m 729 0 b 435 180 729 102 569 180 b 278 156 374 180 321 170 l 184 239 b 170 243 181 242 176 243 b 154 238 166 243 158 240 b 150 223 151 233 150 228 b 156 207 150 217 153 212 l 233 138 b 128 0 167 107 128 56 b 420 -180 128 -94 210 -180 b 575 -164 482 -180 533 -174 l 672 -252 b 687 -256 677 -255 681 -256 b 703 -251 691 -256 698 -255 b 707 -236 706 -246 707 -240 b 701 -220 707 -230 706 -225 l 619 -150 b 729 0 700 -117 729 -62 z m 114 223 l 95 223 b 82 213 88 223 82 217 l 82 -213 b 95 -223 82 -219 88 -223 l 114 -223 b 127 -213 121 -223 127 -219 l 127 213 b 114 223 127 217 121 223 z m 32 223 l 13 223 b 0 213 6 223 0 217 l 0 -213 b 13 -223 0 -219 6 -223 l 32 -223 b 45 -213 39 -223 45 -219 l 45 213 b 32 223 45 217 39 223 z m 844 223 l 825 223 b 811 213 819 223 811 217 l 811 -213 b 825 -223 811 -219 819 -223 l 844 -223 b 858 -213 851 -223 858 -219 l 858 213 b 844 223 858 217 851 223 z m 763 223 l 743 223 b 730 213 736 223 730 217 l 730 -213 b 743 -223 730 -219 736 -223 l 763 -223 b 776 -213 769 -223 776 -219 l 776 213 b 763 223 776 217 769 223 z m 312 124 b 399 144 336 141 369 144 b 575 -46 495 144 575 40 b 563 -98 575 -65 570 -81 z m 508 -141 b 467 -147 495 -145 481 -147 b 360 -104 428 -147 389 -128 b 330 -72 350 -95 340 -82 b 282 56 304 -37 282 10 b 285 89 282 68 284 79 b 536 -130 287 89 304 75 z"
                },
                noteheadSlashedWhole2: {
                    x_min: -18,
                    x_max: 436,
                    y_min: -154,
                    y_max: 151,
                    ha: 305,
                    o: "m 531 -128 b 602 1 582 -96 602 -49 b 308 180 602 104 441 180 b 114 144 230 180 164 166 l 4 215 b -6 217 1 217 -3 217 b -22 209 -13 217 -19 215 b -26 197 -24 204 -26 200 b -16 181 -26 192 -22 184 l 75 121 b 0 1 27 91 0 49 b 294 -180 0 -94 82 -180 b 491 -150 379 -180 444 -168 l 598 -219 b 608 -222 600 -222 605 -222 b 624 -213 615 -222 621 -219 b 628 -202 626 -209 628 -206 b 618 -186 628 -196 624 -189 z m 168 108 b 271 147 190 141 233 147 b 446 -48 369 147 446 40 b 445 -72 446 -56 446 -63 z m 154 69 l 429 -109 b 382 -141 419 -125 402 -135 b 337 -147 367 -144 351 -147 b 301 -141 327 -147 314 -144 b 235 -104 276 -134 253 -120 b 203 -72 223 -94 213 -82 b 154 58 177 -39 154 12 z"
                },
                noteheadSlashedHalf2: {
                    x_min: -73,
                    x_max: 380,
                    y_min: -134,
                    y_max: 168,
                    ha: 302,
                    o: "m 537 -156 l 383 -58 b 422 60 413 -9 422 39 b 281 180 422 134 364 180 b 101 127 203 180 144 157 l -75 239 b -85 242 -78 242 -82 242 b -102 233 -92 242 -98 239 b -105 222 -104 229 -105 225 b -95 206 -105 216 -102 209 l 69 99 b 0 -59 19 46 0 -20 b 138 -180 0 -135 60 -180 b 359 -88 248 -180 317 -138 l 516 -190 b 527 -193 520 -192 524 -193 b 543 -183 534 -193 540 -190 b 547 -173 546 -180 547 -176 b 537 -156 547 -166 543 -160 z m 367 92 b 377 63 374 82 377 73 b 318 -14 377 43 361 20 l 184 72 b 317 121 248 108 289 121 b 367 92 344 121 357 109 z m 248 -66 b 108 -124 181 -108 138 -124 b 50 -92 78 -124 60 -109 b 42 -63 46 -84 42 -73 b 145 49 42 -35 68 0 l 285 -40 b 248 -66 274 -49 261 -56 z"
                },
                noteheadSlashedBlack2: {
                    x_min: -79,
                    x_max: 376,
                    y_min: -164,
                    y_max: 168,
                    ha: 332,
                    o: "m 531 -200 l 363 -78 b 425 59 402 -37 425 10 b 285 180 425 132 367 180 b 92 114 210 180 144 154 l -81 238 b -94 242 -85 240 -89 242 b -111 232 -99 242 -107 238 b -114 220 -112 229 -114 225 b -105 204 -114 215 -111 207 l 62 85 b 0 -62 23 43 0 -9 b 140 -180 0 -137 62 -180 b 331 -108 204 -180 275 -153 l 507 -233 b 520 -236 511 -236 517 -236 b 537 -228 527 -236 533 -233 b 541 -216 540 -225 541 -220 b 531 -200 541 -210 537 -203 z"
                },
                noteheadDiamondDoubleWhole: {
                    x_min: 0,
                    x_max: 432,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 592 223 b 580 215 585 223 580 219 l 580 -215 b 592 -223 580 -219 585 -223 l 608 -223 b 622 -215 615 -223 622 -219 l 622 215 b 608 223 622 219 615 223 z m 517 223 b 504 215 510 223 504 219 l 504 -215 b 517 -223 504 -219 510 -223 l 533 -223 b 544 -215 540 -223 544 -219 l 544 215 b 533 223 544 219 540 223 z m 246 179 b 240 180 243 179 242 180 b 232 176 236 180 233 179 l 118 22 b 117 17 117 20 117 19 l 117 215 b 104 223 117 219 111 223 l 88 223 b 75 215 81 223 75 219 l 75 -215 b 88 -223 75 -219 81 -223 l 104 -223 b 117 -215 111 -223 117 -219 l 117 14 l 118 14 b 122 7 118 12 120 10 l 374 -179 b 382 -180 376 -180 379 -180 b 390 -177 384 -180 387 -180 l 503 -23 l 503 -17 b 500 -9 503 -13 503 -10 z m 12 223 b 0 215 4 223 0 219 l 0 -215 b 12 -223 0 -219 4 -223 l 29 -223 b 40 -215 36 -223 40 -219 l 40 215 b 29 223 40 219 36 223 z m 183 39 b 179 46 181 39 179 43 b 229 112 226 112 228 112 b 236 109 229 112 233 111 l 436 -39 b 439 -46 438 -39 439 -42 b 390 -112 393 -111 392 -112 b 383 -109 389 -112 386 -111 z"
                },
                noteheadDiamondWhole: {
                    x_min: 0,
                    x_max: 270,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 386 -23 b 389 -16 387 -20 389 -19 b 383 -7 389 -13 386 -9 l 130 179 b 122 180 128 180 125 180 b 115 177 120 180 117 180 l 3 23 b 0 17 1 20 0 19 b 4 7 0 16 3 10 l 258 -179 b 264 -180 261 -179 262 -180 b 272 -176 268 -180 271 -179 z m 66 40 b 62 48 65 42 62 45 l 109 111 b 112 112 109 112 111 112 b 118 111 115 112 117 111 l 320 -37 b 324 -46 323 -39 324 -42 b 275 -111 278 -111 276 -111 b 268 -108 272 -111 271 -109 z"
                },
                noteheadDiamondHalf: {
                    x_min: 0,
                    x_max: 251,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 359 -7 b 361 0 360 -6 361 -3 b 359 7 361 3 360 4 l 189 177 b 180 180 186 179 183 180 b 174 177 179 180 176 179 l 4 7 b 0 0 1 4 0 3 b 4 -7 0 -3 1 -6 l 174 -177 b 180 -180 176 -180 179 -180 b 189 -177 183 -180 186 -180 z m 266 26 b 138 -71 266 -12 176 -71 b 96 -50 121 -71 108 -63 b 88 -24 89 -43 88 -32 b 215 73 88 13 177 73 b 266 26 238 73 266 50 z"
                },
                noteheadDiamondBlack: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 357 -6 b 360 1 359 -4 360 -1 b 357 9 360 4 359 7 l 189 177 b 180 180 187 179 184 180 b 171 177 177 180 173 179 l 3 9 b 0 1 0 6 0 4 b 4 -7 0 -1 1 -4 l 173 -177 b 180 -180 176 -180 177 -180 b 187 -177 181 -180 184 -180 z"
                },
                noteheadParenthesis: {
                    x_min: -73,
                    x_max: 368,
                    y_min: -180,
                    y_max: 182,
                    ha: 362,
                    o: "m 52 -249 b -30 -144 3 -212 -14 -190 b -52 4 -45 -102 -52 -56 b 52 252 -52 118 -36 179 l 46 262 b -105 3 -49 197 -105 124 b 45 -259 -105 -109 -48 -200 z m 382 -259 b 530 3 474 -202 530 -108 b 379 262 530 122 474 200 l 373 252 b 478 4 462 180 478 118 b 456 -144 478 -56 471 -102 b 373 -249 439 -190 422 -212 z"
                },
                noteheadParenthesisRight: {
                    x_min: -36,
                    x_max: 73,
                    y_min: -181,
                    y_max: 181,
                    ha: 362,
                    o: "m -43 -261 b 105 1 49 -203 105 -109 b -46 261 105 121 49 199 l -52 251 b 53 3 37 179 53 117 b 32 -145 53 -58 46 -104 b -52 -251 14 -192 -3 -213 z"
                },
                noteheadParenthesisLeft: {
                    x_min: 0,
                    x_max: 109,
                    y_min: -181,
                    y_max: 181,
                    ha: 362,
                    o: "m 157 -251 b 75 -145 108 -213 91 -192 b 53 3 60 -104 53 -58 b 157 251 53 117 69 177 l 151 261 b 0 1 56 196 0 122 b 150 -261 0 -111 58 -202 z"
                },
                noteheadMoonBlack: {
                    x_min: 0,
                    x_max: 315,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 228 -180 b 454 0 343 -180 454 -130 l 454 180 l 0 180 l 0 0 b 228 -180 0 -131 112 -180 z"
                },
                noteheadTriangleLeftBlack: {
                    x_min: 0,
                    x_max: 339,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 488 -180 l 0 180 l 0 -180 z"
                },
                noteheadTriangleRightBlack: {
                    x_min: 0,
                    x_max: 339,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 488 180 l 0 -180 l 488 -180 z"
                },
                noteheadTriangleRoundDownBlack: {
                    x_min: 0,
                    x_max: 278,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 200 -180 l 400 112 l 383 124 b 199 180 327 161 264 180 b 16 124 135 180 73 161 l 0 112 z"
                },
                augmentationDot: {
                    x_min: 0,
                    x_max: 100,
                    y_min: -50,
                    y_max: 50,
                    ha: 100,
                    o: "m 144 0 b 72 72 144 40 112 72 b 0 0 32 72 0 40 b 72 -72 0 -40 32 -72 b 144 0 112 -72 144 -40 z"
                },
                tremolo1: {
                    x_min: -150,
                    x_max: 150,
                    y_min: -93,
                    y_max: 94,
                    ha: 187,
                    o: "m 216 -45 l 216 135 l -216 46 l -216 -134 z"
                },
                flag8thUp: {
                    x_min: 0,
                    x_max: 264,
                    y_min: -810,
                    y_max: 9,
                    ha: 819,
                    o: "m 343 -1138 b 380 -888 343 -1138 380 -1001 b 215 -395 380 -708 305 -539 b 58 -19 141 -281 81 -157 b 27 13 53 4 42 13 b 0 -9 12 13 0 9 l 0 -353 b 284 -688 95 -370 232 -566 b 318 -904 305 -737 318 -819 b 284 -1102 318 -969 308 -1037 b 279 -1123 281 -1110 279 -1117 b 302 -1165 279 -1146 294 -1159 b 343 -1138 311 -1171 336 -1162 z"
                },
                flag8thDown: {
                    x_min: 0,
                    x_max: 306,
                    y_min: -14,
                    y_max: 808,
                    ha: 822,
                    o: "m 346 1094 b 376 897 366 1034 376 962 b 318 642 376 812 340 691 b 0 340 265 521 193 405 l 0 1 b 23 -20 0 -13 12 -20 b 58 12 36 -20 55 -12 b 262 387 82 148 189 274 b 441 881 353 530 441 701 b 400 1142 441 994 412 1096 b 377 1164 396 1158 387 1164 b 346 1094 356 1164 331 1136 z"
                },
                flag16thUp: {
                    x_min: 0,
                    x_max: 279,
                    y_min: -813,
                    y_max: 2,
                    ha: 815,
                    o: "m 392 -1146 b 402 -988 397 -1139 402 -1057 l 402 -956 b 360 -783 402 -896 386 -837 b 359 -770 360 -779 359 -776 b 360 -760 359 -768 359 -765 b 396 -577 364 -752 396 -665 b 392 -526 396 -559 395 -543 b 236 -275 377 -428 340 -387 b 53 -16 158 -192 78 -168 b 24 3 50 0 33 3 b 0 -12 16 3 0 -1 l 0 -570 l 7 -570 b 298 -778 96 -573 199 -576 b 344 -992 331 -847 344 -917 b 333 -1120 344 -1034 340 -1077 b 331 -1133 331 -1126 331 -1129 b 363 -1171 331 -1152 343 -1171 b 392 -1146 373 -1171 383 -1165 z m 301 -661 b 223 -562 278 -625 253 -596 b 59 -331 156 -484 89 -449 b 58 -327 58 -330 58 -328 b 78 -312 58 -321 66 -312 l 89 -312 b 302 -464 177 -312 255 -393 b 341 -592 328 -501 341 -546 b 340 -621 341 -602 341 -611 b 330 -658 337 -632 337 -647 b 311 -667 328 -662 318 -667 b 301 -661 307 -667 304 -665 z"
                },
                flag16thDown: {
                    x_min: 0,
                    x_max: 291,
                    y_min: -9,
                    y_max: 812,
                    ha: 821,
                    o: "m 346 1132 b 312 768 367 1011 367 880 b 7 559 213 566 96 562 l 0 559 l 0 1 b 24 -13 0 -6 10 -13 b 53 6 35 -13 50 -10 b 406 516 88 228 372 289 b 410 567 409 531 410 549 b 374 750 410 655 379 742 b 373 760 373 753 373 756 b 374 773 373 766 374 769 b 405 1138 426 881 428 1022 b 370 1169 397 1171 387 1169 b 346 1132 353 1168 341 1156 z m 325 657 b 344 647 333 657 343 652 b 354 611 351 636 351 622 b 356 582 356 600 356 590 b 317 454 356 534 343 491 b 89 302 269 383 177 302 l 78 302 b 58 317 66 302 58 310 b 59 321 58 318 58 320 b 238 552 89 439 170 472 b 315 651 268 585 292 613 b 325 657 318 655 321 657 z"
                },
                flag32ndUp: {
                    x_min: 0,
                    x_max: 261,
                    y_min: -812,
                    y_max: 149,
                    ha: 961,
                    o: "m 374 -969 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 366 -289 369 -315 369 -302 b 220 -58 350 -202 317 -163 b 46 187 148 20 71 43 b 20 215 45 200 35 215 b 0 197 12 215 0 207 l 0 -609 l 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 315 -657 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 56 -390 147 -527 88 -495 b 73 -367 53 -380 60 -367 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 z"
                },
                flag32ndDown: {
                    x_min: 0,
                    x_max: 273,
                    y_min: -172,
                    y_max: 812,
                    ha: 984,
                    o: "m 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -229 b 20 -248 0 -242 9 -248 b 48 -219 35 -248 46 -232 b 229 36 72 -69 154 -46 b 380 278 330 145 364 186 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 356 783 356 782 356 783 l 351 791 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 z m 56 386 b 217 609 86 501 153 533 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 z m 330 350 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 b 229 331 81 226 154 249 b 310 423 264 369 289 397 b 330 350 318 396 325 366 z"
                },
                flag64thUp: {
                    x_min: 0,
                    x_max: 261,
                    y_min: -812,
                    y_max: 347,
                    ha: 1159,
                    o: "m 374 -969 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 337 -203 369 -287 359 -242 b 369 -43 350 -167 369 -104 b 366 -4 369 -30 367 -17 b 220 228 350 84 317 122 b 46 472 148 305 71 328 b 20 500 45 485 32 500 b 0 482 10 500 0 492 l 0 -609 l 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 z m 300 24 b 321 -45 315 -4 321 -26 b 317 -75 321 -56 318 -65 l 298 -145 b 220 -58 278 -121 253 -94 b 58 187 148 20 82 43 b 56 193 58 189 58 192 b 300 24 138 193 220 157 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 315 -657 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 55 -386 147 -527 84 -497 b 73 -367 52 -376 63 -367 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 z"
                },
                flag64thDown: {
                    x_min: 0,
                    x_max: 273,
                    y_min: -376,
                    y_max: 812,
                    ha: 1188,
                    o: "m 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -523 b 20 -541 0 -534 9 -541 b 48 -513 35 -541 46 -526 b 229 -258 72 -363 154 -340 b 380 -16 330 -148 364 -108 b 384 27 383 -1 384 13 b 351 189 384 88 366 151 b 380 278 366 216 374 243 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 356 783 356 782 356 783 l 351 791 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 z m 56 386 b 217 609 86 501 153 533 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 z m 330 350 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 b 229 331 81 226 154 249 b 310 423 264 369 289 397 b 330 350 318 396 325 366 z m 330 56 b 334 26 331 46 334 37 b 311 -46 334 7 328 -16 b 56 -222 229 -184 137 -222 b 229 36 75 -86 145 -55 b 311 128 264 73 289 102 z"
                },
                flag128thUp: {
                    x_min: 0,
                    x_max: 261,
                    y_min: -812,
                    y_max: 533,
                    ha: 1345,
                    o: "m 374 -969 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 337 -203 369 -287 359 -242 b 369 -43 350 -167 369 -104 b 366 -4 369 -30 367 -17 b 341 75 360 26 353 50 b 369 222 354 111 369 167 b 366 264 369 236 369 251 b 220 495 350 351 317 390 b 46 740 148 573 71 596 b 22 768 45 753 35 768 b 0 750 10 768 0 760 l 0 -609 l 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 z m 300 292 b 321 223 315 264 321 242 b 317 193 321 212 318 203 b 301 135 314 180 308 158 b 220 228 281 161 255 190 b 55 461 151 304 79 327 b 300 292 134 461 220 426 z m 300 24 b 321 -45 315 -4 321 -26 b 317 -75 321 -56 318 -65 l 298 -145 b 220 -58 278 -121 253 -94 b 56 187 148 20 81 43 b 55 193 56 189 56 192 b 300 24 137 193 220 157 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 315 -657 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 55 -386 147 -527 84 -497 b 73 -367 53 -376 62 -367 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 z"
                },
                flag128thDown: {
                    x_min: 0,
                    x_max: 273,
                    y_min: -580,
                    y_max: 812,
                    ha: 1392,
                    o: "m 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -816 b 20 -835 0 -828 7 -835 b 48 -806 33 -835 46 -819 b 229 -552 72 -657 154 -634 b 380 -310 330 -442 364 -402 b 384 -266 383 -295 384 -281 b 351 -105 384 -206 366 -143 b 384 27 372 -66 384 -16 b 351 189 384 88 366 151 b 380 278 366 216 374 243 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 356 783 356 782 356 783 l 351 791 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 z m 56 386 b 217 609 86 501 153 533 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 z m 330 350 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 b 229 331 81 226 154 249 b 310 423 264 369 289 397 b 330 350 318 396 325 366 z m 330 56 b 334 26 331 46 334 37 b 311 -46 334 7 328 -16 b 56 -222 229 -184 137 -222 b 229 36 75 -86 145 -55 b 311 128 264 73 289 102 z m 330 -238 b 334 -268 331 -248 334 -256 b 311 -340 334 -287 328 -310 b 56 -516 229 -478 137 -516 b 229 -258 75 -380 145 -348 b 311 -166 264 -220 289 -192 z"
                },
                accidentalFlat: {
                    x_min: 0,
                    x_max: 226,
                    y_min: -175,
                    y_max: 439,
                    ha: 614,
                    o: "m 17 -245 b 30 -252 22 -251 26 -252 b 39 -249 35 -252 39 -249 b 153 -161 82 -225 117 -186 b 325 82 281 -72 325 16 b 196 220 325 164 262 216 b 117 196 171 220 137 209 b 85 176 108 189 92 176 b 78 177 82 176 81 176 b 62 202 68 181 62 192 b 72 608 63 233 72 579 b 45 632 72 624 59 632 b 0 592 24 632 1 618 b 17 -245 0 592 6 -230 z m 68 -117 b 63 27 68 -117 63 -30 b 66 73 63 50 65 68 b 167 144 76 102 134 144 b 226 60 209 144 226 96 b 98 -134 226 -17 160 -95 b 84 -138 92 -137 88 -138 b 68 -117 71 -138 68 -124 z"
                },
                accidentalNatural: {
                    x_min: 0,
                    x_max: 168,
                    y_min: -335,
                    y_max: 341,
                    ha: 676,
                    o: "m 203 261 b 197 259 200 261 199 259 b 68 226 197 259 105 226 b 53 233 59 226 53 228 l 53 474 b 36 491 53 484 45 491 l 17 491 b 0 474 7 491 0 484 l 0 -268 b 13 -281 0 -276 4 -281 l 16 -279 b 22 -278 17 -279 20 -279 b 164 -235 42 -269 122 -235 b 189 -251 179 -235 189 -239 l 189 -465 b 206 -482 189 -475 196 -482 l 225 -482 b 242 -465 233 -482 242 -475 l 242 258 b 230 269 242 265 236 269 b 225 268 229 269 226 269 z m 53 56 b 176 114 53 76 141 114 b 189 107 184 114 189 112 l 189 -42 b 71 -101 189 -68 107 -101 b 53 -92 60 -101 53 -98 z"
                },
                accidentalSharp: {
                    x_min: 0,
                    x_max: 249,
                    y_min: -348,
                    y_max: 350,
                    ha: 698,
                    o: "m 341 170 b 359 194 351 174 359 186 l 359 297 b 348 308 359 304 354 308 b 341 307 346 308 344 308 b 305 294 341 307 312 295 b 285 312 295 294 285 301 l 285 488 b 265 504 285 497 276 504 b 242 488 251 504 242 497 l 242 301 b 223 259 240 287 236 268 b 132 223 206 249 157 229 b 115 252 120 223 115 240 l 115 425 b 95 441 115 433 105 441 b 72 425 81 441 72 433 l 72 230 b 55 192 72 210 63 196 b 17 176 46 187 17 176 b 0 153 7 173 0 161 l 0 50 b 13 37 0 42 4 37 l 16 39 b 50 53 17 39 39 48 l 52 55 b 72 29 63 55 72 40 l 72 -114 b 56 -147 72 -130 65 -143 b 17 -163 48 -150 17 -163 b 0 -186 7 -166 0 -177 l 0 -288 b 13 -301 0 -297 4 -301 l 16 -300 b 50 -287 17 -300 37 -291 b 55 -285 52 -285 53 -285 b 72 -308 65 -285 72 -301 l 72 -485 b 91 -501 72 -494 81 -501 b 115 -485 105 -501 115 -494 l 115 -285 b 130 -253 115 -266 122 -256 l 217 -217 b 219 -217 217 -217 219 -217 l 222 -216 b 242 -242 235 -216 242 -233 l 242 -422 b 261 -438 242 -431 251 -438 b 285 -422 276 -438 285 -431 l 285 -217 b 301 -184 285 -206 291 -189 b 341 -168 311 -180 341 -168 b 359 -144 351 -164 359 -153 l 359 -42 b 348 -30 359 -35 354 -30 b 341 -32 346 -30 344 -30 l 304 -46 b 285 -20 295 -46 285 -37 l 285 114 b 304 156 285 124 292 151 z m 242 -65 b 132 -122 233 -94 166 -122 b 115 -115 124 -122 117 -120 b 111 -43 112 -109 111 -78 b 115 63 111 1 112 52 b 220 118 118 88 184 118 b 242 109 230 118 239 115 b 248 27 245 102 248 66 b 242 -65 248 -12 245 -52 z"
                },
                accidentalDoubleSharp: {
                    x_min: 0,
                    x_max: 247,
                    y_min: -125,
                    y_max: 127,
                    ha: 252,
                    o: "m 274 -46 b 206 1 258 -37 206 -9 b 274 50 206 22 253 43 b 278 50 275 50 276 50 l 287 49 b 346 63 304 49 331 52 b 356 115 353 71 356 92 b 292 183 356 174 351 183 b 233 173 266 183 240 180 b 226 117 228 168 226 143 b 179 49 219 101 196 49 b 130 117 158 49 135 96 b 118 173 130 141 125 167 b 66 183 112 180 89 183 b 7 173 42 183 16 180 b 0 120 3 170 0 145 b 7 63 0 94 3 68 b 68 49 17 55 43 49 b 82 50 73 49 78 50 b 150 3 98 42 150 13 b 84 -46 150 -16 104 -39 l 69 -46 b 7 -56 43 -46 16 -49 b 0 -111 3 -60 0 -85 b 7 -166 0 -137 3 -163 b 65 -180 17 -174 40 -180 b 118 -166 86 -180 109 -176 b 130 -111 127 -158 130 -134 b 132 -105 130 -109 131 -107 b 177 -45 141 -85 158 -45 b 226 -111 196 -45 220 -91 b 233 -166 226 -137 228 -161 b 291 -180 243 -174 266 -180 b 356 -114 346 -180 356 -166 b 346 -56 356 -89 351 -63 b 288 -46 338 -49 312 -46 z"
                },
                accidentalDoubleFlat: {
                    x_min: 0,
                    x_max: 411,
                    y_min: -175,
                    y_max: 437,
                    ha: 612,
                    o: "m 452 217 b 384 194 426 217 408 207 b 350 176 374 189 363 176 b 343 177 347 176 344 176 b 328 202 333 180 328 190 b 337 606 328 232 337 579 b 310 629 337 622 324 629 b 265 592 291 629 268 616 b 269 194 265 592 266 395 b 196 217 248 209 223 217 l 187 217 b 120 194 160 217 143 207 b 85 176 108 189 98 176 b 78 177 82 176 81 176 b 62 202 68 180 62 190 b 72 606 62 232 72 579 b 45 629 72 622 59 629 b 0 592 24 629 1 616 b 17 -245 0 592 7 -232 b 30 -252 22 -251 26 -252 b 39 -249 35 -252 39 -249 b 153 -161 84 -226 120 -186 b 274 -50 206 -124 246 -85 b 284 -245 276 -158 279 -240 b 295 -252 288 -251 292 -252 b 304 -249 300 -252 304 -249 b 416 -163 348 -226 383 -186 b 592 82 546 -72 592 16 b 461 217 592 163 528 216 z m 96 -134 b 84 -138 92 -137 86 -138 b 68 -115 72 -138 68 -124 b 63 26 68 -115 63 -30 b 66 72 63 49 65 66 b 168 144 75 101 134 144 b 226 59 212 144 226 95 b 96 -134 226 -22 161 -94 z m 361 -134 b 348 -138 356 -137 351 -138 b 333 -115 337 -138 333 -124 b 328 39 333 -115 328 -16 b 330 72 328 55 328 68 b 433 144 338 101 399 144 b 468 130 448 144 459 140 b 490 59 481 112 490 88 b 361 -134 490 -22 426 -94 z"
                },
                accidentalParensLeft: {
                    x_min: 0,
                    x_max: 141,
                    y_min: -248,
                    y_max: 247,
                    ha: 495,
                    o: "m 203 331 l 203 351 b 202 356 203 354 203 356 b 0 0 60 281 0 140 b 199 -357 0 -144 60 -269 b 203 -354 200 -357 203 -356 l 203 -333 b 200 -327 203 -330 202 -328 b 86 0 118 -253 86 -160 b 200 324 86 158 120 251 b 203 331 202 325 203 327 z"
                },
                accidentalParensRight: {
                    x_min: 0,
                    x_max: 141,
                    y_min: -248,
                    y_max: 247,
                    ha: 495,
                    o: "m 0 331 b 3 324 0 327 1 325 b 117 0 84 251 117 158 b 3 -327 117 -160 85 -253 b 0 -333 1 -328 0 -330 l 0 -354 b 4 -357 0 -356 3 -357 b 203 0 143 -269 203 -144 b 1 356 203 140 143 281 b 0 351 0 356 0 354 z"
                },
                accidentalQuarterToneFlatStein: {
                    x_min: 1,
                    x_max: 227,
                    y_min: -175,
                    y_max: 439,
                    ha: 614,
                    o: "m 310 -245 b 327 592 321 -230 327 592 b 282 632 325 618 302 632 b 255 608 268 632 255 624 b 265 202 255 579 264 233 b 249 177 265 192 259 181 b 242 176 246 176 245 176 b 210 196 235 176 219 189 b 131 220 190 209 156 220 b 1 85 65 216 1 164 b 174 -161 1 16 46 -72 b 288 -249 210 -186 245 -225 b 297 -252 288 -249 292 -252 b 310 -245 301 -252 305 -251 z m 259 -117 b 243 -138 259 -124 256 -138 b 229 -134 239 -138 235 -137 b 101 60 167 -95 101 -17 b 160 144 101 96 118 144 b 261 73 193 144 251 102 b 264 27 262 68 264 50 b 259 -117 264 -30 259 -117 z"
                },
                accidentalThreeQuarterTonesFlatZimmermann: {
                    x_min: 1,
                    x_max: 466,
                    y_min: -175,
                    y_max: 439,
                    ha: 614,
                    o: "m 363 -245 b 376 -252 367 -251 372 -252 b 384 -249 380 -252 384 -249 b 497 -161 428 -226 464 -186 b 671 84 625 -72 671 16 b 541 220 671 164 606 217 b 513 217 531 220 523 219 b 464 196 495 212 480 206 b 431 176 452 189 442 176 b 423 177 428 176 426 176 b 408 202 413 180 408 190 l 419 608 b 392 632 419 625 406 632 b 346 592 372 632 347 618 b 363 -245 346 592 351 -230 z m 289 -249 b 297 -252 289 -249 292 -252 b 310 -245 300 -252 305 -251 b 328 592 321 -230 328 592 b 282 631 327 618 302 631 b 255 608 268 631 255 624 l 266 202 b 251 177 266 190 261 180 b 243 176 248 176 246 176 b 210 196 232 176 222 189 b 164 216 196 204 180 210 l 163 217 b 132 220 151 219 143 220 b 1 84 65 217 1 163 b 177 -163 1 16 48 -72 b 289 -249 210 -186 245 -226 z m 262 72 b 265 26 264 66 265 49 b 261 -115 265 -30 261 -115 b 245 -138 261 -124 258 -138 b 230 -134 240 -138 236 -137 b 102 60 166 -92 102 -20 b 124 128 102 88 111 112 b 161 144 134 138 147 144 b 199 134 173 144 184 141 b 262 72 219 122 256 92 z m 413 -115 b 409 26 413 -115 409 -30 b 412 72 409 49 410 66 b 514 144 420 102 480 144 b 570 60 557 144 570 96 b 442 -134 570 -23 508 -91 b 429 -138 436 -137 433 -138 b 413 -115 418 -138 413 -124 z"
                },
                accidentalQuarterToneSharpStein: {
                    x_min: 0,
                    x_max: 179,
                    y_min: -353,
                    y_max: 307,
                    ha: 660,
                    o: "m 258 240 b 246 252 258 248 252 252 b 240 251 245 252 242 252 b 168 225 240 251 171 225 b 150 253 156 225 150 240 l 150 426 b 130 442 150 435 141 442 b 105 418 108 442 105 429 l 105 230 b 91 193 105 219 101 202 b 17 161 65 183 42 171 b 0 138 9 158 0 147 l 0 36 b 13 23 0 27 4 23 l 16 24 b 86 53 17 24 73 49 l 88 55 b 107 30 98 55 107 42 l 107 -114 b 92 -145 107 -130 101 -143 l 17 -177 b 0 -200 9 -180 0 -192 l 0 -302 b 13 -315 0 -311 4 -315 l 16 -314 b 85 -285 17 -314 72 -291 b 105 -312 92 -282 105 -301 l 105 -492 b 125 -508 105 -501 114 -508 b 150 -484 147 -508 150 -498 l 150 -285 b 151 -274 150 -281 150 -278 b 164 -253 153 -265 158 -256 b 240 -225 176 -251 240 -225 b 258 -202 249 -222 258 -210 l 258 -99 b 245 -86 258 -91 253 -86 l 242 -88 b 240 -88 242 -88 240 -88 l 240 -86 b 168 -115 240 -86 174 -114 b 148 -91 158 -115 148 -107 l 148 43 b 167 85 148 55 156 81 b 240 114 180 91 240 114 b 258 138 249 118 258 128 z"
                },
                accidentalThreeQuarterTonesSharpStein: {
                    x_min: 3,
                    x_max: 317,
                    y_min: -347,
                    y_max: 369,
                    ha: 716,
                    o: "m 456 324 b 448 336 456 330 454 336 b 393 317 445 336 400 320 b 389 315 392 315 390 315 b 383 325 386 315 383 318 l 383 508 b 360 531 383 528 379 531 b 337 508 341 531 337 527 l 337 318 b 325 291 337 300 334 294 b 268 268 320 288 287 276 b 253 281 256 268 253 274 l 253 464 b 230 487 253 484 249 487 b 207 464 212 487 207 482 l 207 264 b 194 240 207 253 204 245 l 132 217 b 131 217 132 217 132 217 l 130 216 b 118 229 122 216 118 220 l 118 420 b 95 444 118 439 114 444 b 72 420 76 444 72 439 l 72 212 b 60 190 72 197 68 193 l 16 173 b 4 161 9 170 4 167 l 4 50 b 13 39 4 45 9 39 b 58 55 16 39 46 49 b 63 56 60 56 62 56 b 72 42 71 56 72 50 l 72 -125 b 58 -150 72 -137 65 -147 l 16 -166 b 4 -177 9 -168 4 -171 l 4 -289 b 14 -301 4 -295 9 -301 b 53 -287 16 -301 40 -291 b 62 -285 56 -285 59 -285 b 72 -298 69 -285 72 -289 l 72 -477 b 95 -500 72 -495 76 -500 b 118 -477 114 -500 118 -495 l 118 -278 b 127 -259 118 -269 121 -261 l 196 -232 b 207 -243 204 -232 207 -235 l 207 -432 b 230 -455 207 -452 212 -455 b 253 -432 249 -455 253 -451 l 253 -228 b 268 -204 253 -216 259 -207 l 320 -186 b 328 -183 323 -184 325 -183 b 337 -194 334 -183 337 -187 l 337 -387 b 360 -410 337 -408 341 -410 b 383 -387 379 -410 383 -406 l 383 -174 b 395 -157 383 -166 390 -158 l 445 -138 b 456 -127 452 -135 456 -132 l 456 -14 b 448 -3 456 -10 454 -3 b 397 -22 445 -3 408 -17 l 396 -23 b 383 -6 387 -23 383 -16 l 383 163 b 392 181 383 173 384 179 b 445 202 397 183 445 202 b 456 213 452 203 456 207 z m 337 -45 b 266 -78 333 -56 287 -78 b 258 -75 262 -78 259 -76 b 253 19 255 -71 253 -27 b 258 130 253 69 255 122 b 333 163 264 141 315 163 b 337 161 334 163 337 161 b 341 78 340 157 341 120 b 337 -45 341 24 340 -37 z m 118 -127 b 114 -48 114 -121 114 -86 b 118 78 114 6 115 68 b 200 114 122 91 180 114 b 207 111 204 114 206 112 b 212 22 210 107 212 66 b 207 -94 212 -29 210 -85 b 127 -130 203 -108 148 -130 b 118 -127 122 -130 120 -128 z"
                },
                accidentalBuyukMucennebFlat: {
                    x_min: 1,
                    x_max: 287,
                    y_min: -174,
                    y_max: 438,
                    ha: 612,
                    o: "m 379 452 b 370 464 379 458 377 464 b 164 389 366 464 170 392 b 156 396 163 389 156 393 b 157 436 157 409 157 428 b 167 452 157 445 161 449 b 366 526 173 455 366 526 b 379 540 374 528 379 534 l 379 611 b 370 622 379 616 377 622 b 170 550 366 622 174 552 b 160 557 163 550 160 554 b 161 608 160 585 161 602 b 134 631 161 624 148 631 b 89 590 114 631 91 616 l 89 528 b 81 517 89 526 88 518 b 16 491 76 514 16 491 b 1 480 6 490 1 485 l 1 406 b 13 395 1 400 4 395 l 14 396 b 79 419 16 396 72 415 b 89 412 86 419 89 415 b 91 376 89 399 89 386 b 82 359 91 364 89 361 b 16 331 76 356 16 331 b 1 321 6 331 1 328 l 1 248 b 13 236 1 242 4 236 b 79 262 16 236 71 258 b 92 251 89 262 92 256 b 107 -242 95 23 101 -236 b 120 -251 111 -249 115 -251 b 128 -248 124 -251 128 -248 b 240 -160 171 -225 207 -184 b 413 84 367 -71 413 16 b 284 220 413 166 350 216 b 207 196 259 220 229 209 b 170 176 196 190 184 176 l 168 177 b 151 203 157 181 151 192 b 153 269 151 210 151 236 b 163 292 153 275 153 289 b 366 367 173 297 366 367 b 379 383 374 370 379 376 z m 186 -132 b 173 -137 180 -135 176 -137 b 157 -114 161 -137 157 -122 b 153 35 157 -114 153 -22 b 154 73 153 53 153 68 b 219 135 160 92 197 124 b 255 144 232 141 243 144 b 292 130 269 144 282 140 b 314 62 305 114 314 91 b 186 -132 314 -17 251 -94 z"
                },
                accidentalBuyukMucennebSharp: {
                    x_min: 0,
                    x_max: 341,
                    y_min: -350,
                    y_max: 348,
                    ha: 698,
                    o: "m 403 167 b 420 192 413 171 420 183 l 420 294 b 410 305 420 301 416 305 b 403 304 408 305 406 305 b 367 291 403 304 374 292 b 347 310 357 291 347 298 l 347 485 b 327 501 347 494 338 501 b 304 485 312 501 304 494 l 304 298 b 285 256 302 284 298 265 b 194 220 268 246 219 226 b 177 249 181 220 177 238 l 177 422 b 157 438 177 431 167 438 b 134 422 143 438 134 431 l 134 228 b 117 189 134 207 125 193 b 79 173 108 184 79 173 b 62 150 69 170 62 158 l 62 48 b 75 35 62 39 66 35 l 78 36 b 111 50 79 36 101 45 b 127 55 117 52 122 55 b 132 50 130 55 132 53 l 132 29 b 128 22 132 26 132 23 b 17 -20 125 20 17 -20 b 0 -35 7 -23 0 -26 l 0 -130 b 13 -144 0 -137 4 -144 b 127 -104 17 -144 120 -107 l 128 -102 b 134 -109 134 -102 134 -107 l 134 -127 b 122 -147 134 -138 132 -143 b 79 -166 114 -151 79 -166 b 62 -189 69 -168 62 -180 l 62 -291 b 75 -304 62 -300 66 -304 l 78 -302 b 112 -289 79 -302 99 -294 b 117 -288 114 -288 115 -288 b 134 -311 127 -288 134 -304 l 134 -488 b 153 -504 134 -497 143 -504 b 177 -488 167 -504 177 -497 l 177 -288 b 192 -256 177 -269 184 -259 l 279 -220 b 281 -220 279 -220 281 -220 l 284 -219 b 304 -245 297 -219 304 -236 l 304 -425 b 323 -441 304 -433 312 -441 b 347 -425 338 -441 347 -433 l 347 -220 b 363 -187 347 -209 353 -192 b 403 -171 373 -183 403 -171 b 420 -147 413 -167 420 -156 l 420 -45 b 410 -33 420 -37 416 -33 b 403 -35 408 -33 406 -33 l 366 -49 b 353 -53 360 -52 356 -53 b 347 -40 348 -53 347 -49 l 347 -26 b 351 -19 347 -23 347 -20 l 474 27 b 491 46 485 30 491 37 l 491 137 b 478 153 491 143 488 153 l 475 150 b 474 150 475 150 474 150 l 474 151 b 351 105 474 151 354 107 b 347 109 348 105 347 107 b 346 128 347 117 346 127 b 366 153 346 143 348 145 z m 177 72 b 301 122 196 89 262 122 b 305 111 305 122 305 117 b 307 94 305 105 305 96 b 304 88 307 92 307 89 b 179 40 284 81 180 42 b 174 43 177 40 174 42 b 177 72 176 50 174 69 z m 305 -65 b 184 -121 301 -85 210 -121 b 177 -118 180 -121 179 -120 b 173 -92 174 -115 174 -105 b 179 -84 173 -86 174 -85 b 302 -37 180 -84 279 -46 b 307 -42 304 -37 307 -40 b 305 -65 307 -52 307 -59 z"
                },
                accidentalBakiyeFlat: {
                    x_min: -1,
                    x_max: 286,
                    y_min: -175,
                    y_max: 439,
                    ha: 614,
                    o: "m 377 454 b 369 467 377 458 376 467 b 363 465 367 467 364 467 b 161 390 363 465 167 393 b 153 399 154 390 153 395 b 157 608 154 494 157 593 b 130 632 157 624 144 632 b 86 592 111 632 88 618 b 88 377 86 592 86 501 b 76 356 88 373 88 360 l 12 331 b -1 320 3 330 -1 327 l -1 248 b 9 236 -1 242 1 236 b 81 264 12 236 78 261 b 89 258 86 264 89 261 b 104 -245 92 30 96 -236 b 115 -252 108 -251 112 -252 b 124 -249 120 -252 124 -249 b 239 -161 167 -226 203 -186 b 412 84 367 -72 412 17 b 282 220 412 166 348 216 b 255 216 274 220 264 219 b 203 196 238 212 222 206 b 171 177 193 189 177 177 b 163 179 168 177 166 177 b 147 202 153 181 147 192 b 147 216 147 204 147 209 l 150 262 b 150 276 150 269 150 275 b 158 291 150 287 154 289 b 363 370 163 292 363 370 b 377 384 373 373 377 379 z m 181 -134 b 167 -138 176 -137 171 -138 b 153 -117 156 -138 153 -125 b 148 27 153 -117 148 -30 b 151 73 148 50 150 68 b 255 144 161 105 219 144 b 312 62 298 144 312 99 b 181 -134 312 -19 249 -96 z"
                },
                accidentalKomaSharp: {
                    x_min: 0,
                    x_max: 229,
                    y_min: -337,
                    y_max: 322,
                    ha: 659,
                    o: "m 312 151 b 330 176 323 156 330 166 l 330 278 b 320 289 330 285 327 289 b 312 288 318 289 315 289 b 200 246 312 288 203 248 b 181 275 187 246 181 264 l 181 448 b 163 464 181 456 173 464 b 138 441 140 464 138 452 l 138 253 b 122 215 137 240 132 225 b 17 177 92 203 45 177 b 0 153 7 173 0 163 l 0 50 b 10 39 0 43 4 39 b 17 40 13 39 14 39 l 128 81 b 138 52 138 81 138 63 l 138 -91 b 124 -124 138 -107 132 -120 b 17 -167 115 -127 17 -167 b 0 -192 7 -171 0 -181 l 0 -294 b 10 -305 0 -301 4 -305 b 17 -304 13 -305 14 -305 b 128 -261 17 -304 117 -264 l 130 -259 b 138 -276 137 -259 138 -268 l 138 -469 b 157 -485 138 -478 147 -485 b 181 -462 179 -485 181 -475 l 181 -262 b 183 -252 181 -258 181 -255 b 197 -232 186 -243 190 -235 b 312 -187 207 -228 312 -187 b 330 -163 323 -183 330 -173 l 330 -60 b 320 -49 330 -53 327 -49 b 312 -50 318 -49 315 -49 l 200 -94 b 193 -95 197 -95 194 -95 b 181 -68 183 -95 181 -85 l 181 66 b 200 108 181 92 189 104 z"
                },
                accidentalKucukMucennebSharp: {
                    x_min: -1,
                    x_max: 339,
                    y_min: -338,
                    y_max: 321,
                    ha: 659,
                    o: "m 264 92 b 271 102 264 98 265 99 l 395 150 b 412 174 405 154 412 164 l 412 276 b 402 288 412 284 409 288 b 395 287 400 288 397 288 b 282 245 395 287 285 246 b 264 274 269 245 264 262 l 264 446 b 245 462 264 455 255 462 b 220 439 222 462 220 451 l 220 252 b 204 213 219 239 215 223 b 99 176 174 202 127 176 b 82 151 89 171 82 161 l 82 49 b 92 37 82 42 86 37 b 99 39 95 37 96 37 l 210 79 b 216 81 212 81 215 81 b 220 78 219 81 220 79 l 220 56 b 216 46 220 52 220 48 b 16 -29 210 45 16 -29 b -1 -45 4 -32 -1 -36 l -1 -138 b 12 -154 -1 -145 3 -154 l 215 -79 b 220 -84 219 -79 220 -81 l 220 -105 b 210 -122 220 -115 219 -120 b 99 -168 202 -127 99 -168 b 82 -193 89 -173 82 -183 l 82 -295 b 92 -307 82 -302 86 -307 b 99 -305 95 -307 96 -307 b 210 -262 99 -305 199 -265 l 212 -261 b 220 -278 219 -261 220 -269 l 220 -471 b 239 -487 220 -480 229 -487 b 264 -464 261 -487 264 -477 l 264 -264 b 265 -253 264 -259 264 -256 b 279 -233 268 -245 272 -236 b 395 -189 289 -229 395 -189 b 412 -164 405 -184 412 -174 l 412 -62 b 402 -50 412 -55 409 -50 b 395 -52 400 -50 397 -50 l 278 -96 b 264 -86 268 -96 264 -94 l 264 -68 b 269 -59 264 -62 265 -60 b 471 17 274 -58 471 17 b 488 36 484 22 488 27 l 488 127 b 475 144 488 134 487 144 l 472 141 b 471 141 472 141 471 141 l 471 143 b 272 68 471 143 282 71 l 269 66 b 264 71 264 66 264 69 z"
                },
                accidentalKoron: {
                    x_min: 0,
                    x_max: 300,
                    y_min: -472,
                    y_max: 157,
                    ha: 629,
                    o: "m 432 -4 b 415 10 432 1 418 9 l 4 226 b 0 223 1 226 0 225 l 0 -672 b 7 -680 0 -677 3 -680 l 45 -680 b 52 -672 49 -680 52 -677 l 52 -193 l 415 -22 b 432 -4 418 -20 432 -13 z m 52 -137 l 52 144 l 327 -7 z"
                },
                accidentalSori: {
                    x_min: 0,
                    x_max: 421,
                    y_min: -318,
                    y_max: 328,
                    ha: 646,
                    o: "m 606 10 b 589 23 606 16 592 22 l 382 109 l 382 465 b 374 472 382 469 379 472 l 337 472 b 330 465 333 472 330 469 l 330 132 l 183 194 l 183 425 b 176 432 183 429 180 432 l 138 432 b 131 425 134 432 131 429 l 131 216 l 3 269 b 0 265 0 269 0 266 l 0 223 b 3 213 0 216 0 215 l 131 160 l 131 -150 l 3 -203 b 0 -212 0 -204 0 -206 l 0 -255 b 3 -259 0 -258 1 -259 l 131 -204 l 131 -451 b 138 -458 131 -455 134 -458 l 176 -458 b 183 -451 180 -458 183 -455 l 183 -183 l 330 -120 l 330 -410 b 337 -418 330 -415 333 -418 l 374 -418 b 382 -410 379 -418 382 -415 l 382 -98 l 589 -9 b 606 10 592 -9 606 0 z m 183 -128 l 183 138 l 330 76 l 330 -66 z m 382 -45 l 382 55 l 501 6 z"
                },
                articAccentAbove: {
                    x_min: 0,
                    x_max: 339,
                    y_min: 1,
                    y_max: 245,
                    ha: 244,
                    o: "m 469 151 b 488 177 488 156 488 166 b 469 203 488 189 488 197 l 37 350 b 24 353 32 351 26 353 b 3 333 12 353 7 344 b 0 318 1 327 0 323 b 20 298 0 311 4 304 b 346 187 20 298 331 193 b 356 177 353 186 356 181 b 344 167 356 173 353 170 b 20 58 328 163 20 58 b 0 36 4 50 0 43 b 3 23 0 32 1 27 b 23 1 7 13 13 1 b 29 3 24 1 27 1 z"
                },
                articAccentBelow: {
                    x_min: 0,
                    x_max: 339,
                    y_min: -244,
                    y_max: 0,
                    ha: 244,
                    o: "m 469 -202 b 488 -176 488 -197 488 -187 b 469 -150 488 -164 488 -156 l 37 -3 b 24 0 32 -1 26 0 b 3 -20 12 0 7 -9 b 0 -35 1 -26 0 -30 b 20 -55 0 -42 4 -49 b 346 -166 20 -55 331 -160 b 356 -176 353 -167 356 -171 b 344 -186 356 -180 353 -183 b 20 -295 328 -190 20 -295 b 0 -317 4 -302 0 -310 b 3 -330 0 -321 1 -325 b 23 -351 7 -340 13 -351 b 29 -350 24 -351 27 -351 z"
                },
                articTenutoAbove: {
                    x_min: -1,
                    x_max: 338,
                    y_min: 0,
                    y_max: 48,
                    ha: 48,
                    o: "m 452 0 b 487 35 485 0 487 16 b 452 69 487 53 487 69 l 33 69 b -1 35 -1 69 -1 53 b 33 0 -1 16 -1 0 z"
                },
                articTenutoBelow: {
                    x_min: -1,
                    x_max: 338,
                    y_min: -48,
                    y_max: 0,
                    ha: 48,
                    o: "m 452 -69 b 487 -35 485 -69 487 -53 b 452 0 487 -16 487 0 l 33 0 b -1 -35 -1 0 -1 -16 b 33 -69 -1 -53 -1 -69 z"
                },
                articStaccatoAbove: {
                    x_min: 0,
                    x_max: 84,
                    y_min: 0,
                    y_max: 84,
                    ha: 84,
                    o: "m 121 60 b 60 121 121 94 94 121 b 0 60 27 121 0 94 b 60 0 0 27 27 0 b 121 60 94 0 121 27 z"
                },
                articStaccatoBelow: {
                    x_min: 0,
                    x_max: 84,
                    y_min: -84,
                    y_max: 0,
                    ha: 84,
                    o: "m 121 -60 b 60 0 121 -27 94 0 b 0 -60 27 0 0 -27 b 60 -121 0 -94 27 -121 b 121 -60 94 -121 121 -94 z"
                },
                articStaccatissimoAbove: {
                    x_min: 1,
                    x_max: 100,
                    y_min: -2,
                    y_max: 293,
                    ha: 295,
                    o: "m 72 422 b 1 390 35 422 3 409 b 72 -3 1 369 39 -3 b 144 389 108 -3 144 356 b 72 422 144 410 111 422 z"
                },
                articStaccatissimoBelow: {
                    x_min: 1,
                    x_max: 100,
                    y_min: -295,
                    y_max: 0,
                    ha: 295,
                    o: "m 72 -425 b 144 -392 111 -425 144 -413 b 72 0 144 -359 108 0 b 1 -393 39 0 1 -372 b 72 -425 3 -412 35 -425 z"
                },
                articMarcatoAbove: {
                    x_min: -1,
                    x_max: 235,
                    y_min: -1,
                    y_max: 253,
                    ha: 254,
                    o: "m 181 356 b 167 364 177 361 173 364 b 153 356 157 364 153 356 l 0 23 b -1 16 -1 20 -1 19 b 9 0 -1 9 1 1 b 16 -1 10 -1 14 -1 b 32 9 22 -1 29 1 b 112 186 32 9 109 180 b 118 190 114 189 115 190 b 127 186 121 190 124 189 b 209 9 128 180 209 9 b 225 0 213 3 219 0 l 323 0 b 338 16 333 1 338 7 b 337 23 338 19 338 22 z"
                },
                articMarcatoBelow: {
                    x_min: -1,
                    x_max: 235,
                    y_min: -254,
                    y_max: 0,
                    ha: 254,
                    o: "m 156 -357 b 170 -366 160 -363 164 -366 b 184 -357 180 -366 184 -357 l 337 -24 b 338 -17 338 -22 338 -20 b 328 -1 338 -10 336 -3 b 321 0 327 0 323 0 b 305 -10 315 0 308 -3 b 225 -187 305 -10 228 -181 b 219 -192 223 -190 222 -192 b 210 -187 216 -192 213 -190 b 128 -10 209 -181 128 -10 b 112 -1 124 -4 118 -1 l 14 -1 b -1 -17 4 -3 -1 -9 b 0 -24 -1 -20 -1 -23 z"
                },
                fermataAbove: {
                    x_min: 3,
                    x_max: 605,
                    y_min: -3,
                    y_max: 329,
                    ha: 332,
                    o: "m 435 318 b 818 36 742 318 804 91 b 821 26 819 32 819 27 b 851 -4 831 6 837 -4 b 871 16 864 -4 871 1 b 870 30 871 20 871 24 b 438 474 780 471 480 474 b 6 30 392 474 94 471 b 4 14 4 24 4 19 b 23 -4 4 0 12 -4 b 52 26 36 -4 43 6 b 56 39 53 27 55 33 b 435 318 73 98 138 318 z m 516 75 b 436 153 516 117 480 153 b 359 75 395 153 359 117 b 436 -4 359 32 395 -4 b 516 75 480 -4 516 32 z"
                },
                fermataBelow: {
                    x_min: 3,
                    x_max: 605,
                    y_min: -332,
                    y_max: 0,
                    ha: 332,
                    o: "m 435 -323 b 56 -43 138 -323 73 -102 b 52 -30 55 -37 53 -32 b 23 0 43 -10 36 0 b 4 -19 12 0 4 -4 b 6 -35 4 -23 4 -29 b 438 -478 94 -475 392 -478 b 870 -35 480 -478 780 -475 b 871 -20 871 -29 871 -24 b 851 0 871 -6 864 0 b 821 -30 837 0 831 -10 b 818 -40 819 -32 819 -36 b 435 -323 804 -95 742 -323 z m 516 -79 b 436 0 516 -36 480 0 b 359 -79 395 0 359 -36 b 436 -157 359 -121 395 -157 b 516 -79 480 -157 516 -121 z"
                },
                fermataLongAbove: {
                    x_min: 0,
                    x_max: 603,
                    y_min: -1,
                    y_max: 333,
                    ha: 334,
                    o: "m 72 480 b 0 441 32 480 0 462 l 0 19 b 35 0 0 9 16 0 b 71 19 55 0 71 9 l 71 289 b 433 315 71 307 252 315 b 798 289 615 315 798 307 l 798 19 b 832 0 798 9 814 0 b 868 19 852 0 868 9 l 868 441 b 796 480 868 462 837 480 z m 513 78 b 433 156 513 121 478 156 b 356 78 390 156 356 121 b 433 -1 356 35 390 -1 b 513 78 478 -1 513 35 z"
                },
                fermataLongBelow: {
                    x_min: 0,
                    x_max: 603,
                    y_min: -333,
                    y_max: 1,
                    ha: 334,
                    o: "m 513 -78 b 433 1 513 -35 478 1 b 356 -78 390 1 356 -35 b 433 -156 356 -121 390 -156 b 513 -78 478 -156 513 -121 z m 796 -480 b 868 -441 837 -480 868 -462 l 868 -19 b 832 0 868 -9 852 0 b 798 -19 814 0 798 -9 l 798 -289 b 433 -315 798 -307 615 -315 b 71 -289 252 -315 71 -307 l 71 -19 b 35 0 71 -9 55 0 b 0 -19 16 0 0 -9 l 0 -441 b 72 -480 0 -462 32 -480 z"
                },
                fermataVeryLongAbove: {
                    x_min: 0,
                    x_max: 715,
                    y_min: 0,
                    y_max: 408,
                    ha: 408,
                    o: "m 76 588 b 0 546 35 588 0 569 l 0 22 b 37 1 0 10 17 1 b 75 22 59 1 75 10 l 75 431 b 514 458 75 449 294 458 b 955 431 734 458 955 449 l 955 22 b 991 1 955 10 971 1 b 1030 22 1012 1 1030 10 l 1030 546 b 953 588 1030 569 995 588 z m 215 389 b 138 347 171 389 138 370 l 138 22 b 174 1 138 10 154 1 b 213 22 196 1 213 10 l 213 217 b 514 245 213 235 363 245 b 816 217 665 245 816 235 l 816 22 b 854 1 816 10 834 1 b 891 22 876 1 891 10 l 891 347 b 815 389 891 370 858 389 z m 606 84 b 521 167 606 130 569 167 b 439 84 475 167 439 130 b 521 0 439 39 475 0 b 606 84 569 0 606 39 z"
                },
                fermataVeryLongBelow: {
                    x_min: 0,
                    x_max: 715,
                    y_min: -408,
                    y_max: 0,
                    ha: 408,
                    o: "m 606 -84 b 521 0 606 -39 569 0 b 439 -84 475 0 439 -39 b 521 -167 439 -130 475 -167 b 606 -84 569 -167 606 -130 z m 815 -389 b 891 -347 858 -389 891 -370 l 891 -22 b 854 -1 891 -10 876 -1 b 816 -22 834 -1 816 -10 l 816 -217 b 514 -245 816 -235 665 -245 b 213 -217 363 -245 213 -235 l 213 -22 b 174 -1 213 -10 196 -1 b 138 -22 154 -1 138 -10 l 138 -347 b 215 -389 138 -370 171 -389 z m 953 -588 b 1030 -546 995 -588 1030 -569 l 1030 -22 b 991 -1 1030 -10 1012 -1 b 955 -22 971 -1 955 -10 l 955 -431 b 514 -458 955 -449 734 -458 b 75 -431 294 -458 75 -449 l 75 -22 b 37 -1 75 -10 59 -1 b 0 -22 17 -1 0 -10 l 0 -546 b 76 -588 0 -569 35 -588 z"
                },
                fermataVeryShortAbove: {
                    x_min: 0,
                    x_max: 726,
                    y_min: 0,
                    y_max: 449,
                    ha: 449,
                    o: "m 46 0 b 59 7 50 0 52 4 b 516 517 120 59 507 517 b 975 4 527 517 920 52 b 988 0 979 1 988 0 l 1041 0 b 1045 6 1041 0 1045 1 b 1043 13 1045 7 1045 10 b 516 647 962 91 536 647 b 3 13 504 647 91 98 b 0 7 0 10 0 9 b 6 0 0 3 6 0 z m 238 0 b 248 6 240 0 242 3 b 516 236 292 43 494 236 b 786 3 539 236 746 37 b 796 0 789 1 796 0 l 865 0 b 870 4 865 0 870 1 b 867 10 870 6 868 9 b 516 409 806 68 531 409 b 166 10 497 409 229 73 b 163 4 164 9 163 6 b 167 0 163 1 167 0 z m 592 91 b 516 167 592 132 557 167 b 438 91 472 167 438 132 b 516 13 438 48 472 13 b 592 91 557 13 592 48 z"
                },
                fermataVeryShortBelow: {
                    x_min: 0,
                    x_max: 726,
                    y_min: -449,
                    y_max: 0,
                    ha: 449,
                    o: "m 167 0 b 163 -4 167 0 163 -1 b 166 -10 163 -6 164 -9 b 516 -409 229 -73 497 -409 b 867 -10 531 -409 806 -68 b 870 -4 868 -9 870 -6 b 865 0 870 -1 865 0 l 796 0 b 786 -3 796 0 789 -1 b 516 -236 746 -37 539 -236 b 248 -6 494 -236 292 -43 b 238 0 242 -3 240 0 z m 6 0 b 0 -7 6 0 0 -3 b 3 -13 0 -9 0 -10 b 516 -647 91 -98 504 -647 b 1043 -13 536 -647 962 -91 b 1045 -6 1045 -10 1045 -7 b 1041 0 1045 -1 1041 0 l 988 0 b 975 -4 988 0 979 -1 b 516 -517 920 -52 527 -517 b 59 -7 507 -517 120 -59 b 46 0 52 -4 50 0 z m 592 -91 b 516 -13 592 -48 557 -13 b 438 -91 472 -13 438 -48 b 516 -167 438 -132 472 -167 b 592 -91 557 -167 592 -132 z"
                },
                fermataShortAbove: {
                    x_min: 0,
                    x_max: 604,
                    y_min: 0,
                    y_max: 341,
                    ha: 341,
                    o: "m 78 0 b 88 6 81 0 82 3 b 435 328 134 45 412 328 b 783 3 458 328 742 39 b 793 0 786 1 793 0 l 865 0 b 870 4 865 0 870 1 b 867 10 870 6 868 9 b 435 491 805 69 474 491 b 3 10 397 491 69 75 b 0 4 1 9 0 6 b 4 0 0 1 4 0 z m 513 94 b 433 171 513 135 477 171 b 354 94 390 171 354 135 b 433 13 354 49 390 13 b 513 94 477 13 513 49 z"
                },
                fermataShortBelow: {
                    x_min: 0,
                    x_max: 604,
                    y_min: -341,
                    y_max: 0,
                    ha: 341,
                    o: "m 4 0 b 0 -4 4 0 0 -1 b 3 -10 0 -6 1 -9 b 435 -491 69 -75 397 -491 b 867 -10 474 -491 805 -69 b 870 -4 868 -9 870 -6 b 865 0 870 -1 865 0 l 793 0 b 783 -3 793 0 786 -1 b 435 -328 742 -39 458 -328 b 88 -6 412 -328 134 -45 b 78 0 82 -3 81 0 z m 513 -94 b 433 -13 513 -49 477 -13 b 354 -94 390 -13 354 -49 b 433 -171 354 -135 390 -171 b 513 -94 477 -171 513 -135 z"
                },
                breathMarkComma: {
                    x_min: 1,
                    x_max: 152,
                    y_min: 2,
                    y_max: 251,
                    ha: 249,
                    o: "m 104 361 b 1 271 42 361 1 321 b 82 190 1 222 35 190 b 122 160 118 190 122 160 b 125 144 124 154 125 150 b 102 88 125 124 115 105 b 37 32 78 56 40 35 b 26 17 32 29 26 26 l 27 16 b 37 3 29 6 33 3 b 181 102 85 3 158 66 b 219 239 210 147 219 197 l 219 249 b 104 361 219 317 170 361 z"
                },
                breathMarkUpbow: {
                    x_min: 1,
                    x_max: 249,
                    y_min: 1,
                    y_max: 495,
                    ha: 494,
                    o: "m 181 1 b 206 22 193 1 203 10 l 359 683 l 359 688 b 338 713 359 700 351 710 l 333 713 b 308 694 321 713 311 706 l 180 140 l 53 694 b 27 713 49 706 39 713 l 22 713 b 1 690 10 710 1 700 b 3 683 1 687 1 685 l 154 22 b 181 1 157 10 167 1 z"
                },
                caesura: {
                    x_min: 0,
                    x_max: 384,
                    y_min: -1,
                    y_max: 532,
                    ha: 533,
                    o: "m 40 -1 b 78 26 58 -1 72 9 l 321 713 b 323 726 323 717 323 721 b 282 766 323 747 304 766 b 245 739 265 766 251 756 l 3 52 b 0 37 1 48 0 42 b 27 1 0 22 10 7 b 40 -1 32 -1 36 -1 z m 308 26 l 552 713 b 553 726 553 717 553 721 b 513 766 553 747 534 766 b 475 739 495 766 481 756 l 232 52 b 230 39 230 48 230 43 b 258 1 230 23 240 7 b 271 -1 262 -1 266 -1 b 308 26 287 -1 302 9 z"
                },
                caesuraCurved: {
                    x_min: 0,
                    x_max: 373,
                    y_min: 0,
                    y_max: 530,
                    ha: 530,
                    o: "m 491 763 b 445 719 468 763 446 744 b 252 98 432 507 340 295 l 226 39 b 223 27 225 35 223 32 b 252 0 223 13 233 0 b 276 16 262 0 272 6 b 537 716 386 230 537 478 b 491 763 537 742 518 763 z m 29 0 b 53 16 39 0 48 6 l 82 69 b 314 716 187 264 314 498 b 268 763 314 742 295 763 b 222 719 245 763 223 744 b 29 98 209 507 117 295 l 3 39 b 0 29 1 36 0 33 b 29 0 0 14 12 0 z"
                },
                restMaxima: {
                    x_min: 0,
                    x_max: 381,
                    y_min: -249,
                    y_max: 250,
                    ha: 499,
                    o: "m 180 -330 l 180 331 b 156 360 180 356 170 360 l 23 360 b 0 331 10 360 0 356 l 0 -330 b 23 -359 0 -354 10 -359 l 156 -359 b 180 -330 170 -359 180 -354 z m 549 -330 l 549 331 b 524 360 549 356 539 360 l 392 360 b 369 331 379 360 369 356 l 369 -330 b 392 -359 369 -354 379 -359 l 524 -359 b 549 -330 539 -359 549 -354 z"
                },
                restDoubleWhole: {
                    x_min: 0,
                    x_max: 125,
                    y_min: 0,
                    y_max: 250,
                    ha: 250,
                    o: "m 180 22 l 180 338 b 156 360 180 350 170 360 l 23 360 b 0 338 10 360 0 350 l 0 22 b 23 0 0 10 10 0 l 156 0 b 180 22 170 0 180 10 z"
                },
                restWhole: {
                    x_min: 0,
                    x_max: 282,
                    y_min: -135,
                    y_max: 9,
                    ha: 144,
                    o: "m 406 -157 l 406 -24 b 369 13 406 -3 389 13 l 37 13 b 0 -24 16 13 0 -3 l 0 -157 b 37 -194 0 -177 16 -194 l 369 -194 b 406 -157 389 -194 406 -177 z"
                },
                restWholeLegerLine: {
                    x_min: -117,
                    x_max: 399,
                    y_min: -135,
                    y_max: 20,
                    ha: 155,
                    o: "m -143 29 b -168 3 -157 29 -168 17 b -143 -23 -168 -12 -157 -23 l 0 -23 l 0 -157 b 37 -194 0 -177 16 -194 l 369 -194 b 406 -157 389 -194 406 -177 l 406 -24 b 549 -23 406 -23 406 -23 b 575 3 563 -23 575 -12 b 549 29 575 17 563 29 z"
                },
                restHalf: {
                    x_min: 0,
                    x_max: 282,
                    y_min: -2,
                    y_max: 142,
                    ha: 144,
                    o: "m 406 35 l 406 167 b 369 204 406 189 389 204 l 37 204 b 0 167 16 204 0 189 l 0 35 b 37 -3 0 14 16 -3 l 369 -3 b 406 35 389 -3 406 14 z"
                },
                restHalfLegerLine: {
                    x_min: -117,
                    x_max: 399,
                    y_min: -13,
                    y_max: 142,
                    ha: 155,
                    o: "m 549 -19 b 575 7 563 -19 575 -7 b 549 33 575 22 563 33 b 406 35 406 33 406 33 l 406 167 b 369 204 406 187 389 204 l 37 204 b 0 167 16 204 0 187 l 0 33 l -143 33 b -168 7 -157 33 -168 22 b -143 -19 -168 -7 -157 -19 z"
                },
                restQuarter: {
                    x_min: 1,
                    x_max: 270,
                    y_min: -375,
                    y_max: 373,
                    ha: 748,
                    o: "m 112 -55 b 174 -141 135 -84 156 -111 b 183 -161 177 -147 183 -158 b 181 -167 183 -163 183 -166 b 166 -174 179 -173 173 -174 b 143 -170 160 -174 148 -171 b 137 -170 141 -170 138 -170 l 125 -166 b 1 -304 50 -166 1 -233 b 168 -527 1 -376 63 -446 b 206 -540 180 -536 194 -540 b 228 -531 216 -540 226 -537 b 230 -521 229 -527 230 -524 b 207 -487 230 -508 219 -497 b 170 -435 189 -487 173 -448 b 164 -397 166 -423 164 -410 b 255 -292 164 -338 194 -292 b 369 -317 297 -292 344 -308 l 370 -318 b 382 -320 376 -320 379 -320 b 389 -314 386 -320 389 -318 b 336 -232 389 -297 351 -249 b 236 -32 281 -166 236 -112 b 236 -27 236 -30 236 -29 l 238 -17 b 238 -13 238 -16 238 -14 b 333 199 243 71 295 140 b 338 220 337 206 338 213 b 333 248 338 235 333 248 b 95 526 333 248 120 501 b 69 537 88 533 78 537 b 40 507 55 537 40 527 b 46 484 40 500 42 492 b 134 291 52 468 134 395 b 48 108 134 238 112 176 b 27 66 33 94 27 78 b 42 32 27 46 42 32 z"
                },
                rest8th: {
                    x_min: 0,
                    x_max: 247,
                    y_min: -251,
                    y_max: 174,
                    ha: 425,
                    o: "m 193 154 b 96 251 193 207 150 251 b 0 154 43 251 0 207 b 39 81 0 124 17 98 b 117 56 62 65 89 56 b 173 66 137 56 157 60 b 225 88 193 72 206 78 b 232 89 228 89 230 89 b 239 76 238 89 239 84 b 238 60 239 72 239 66 b 104 -343 233 39 130 -248 b 145 -361 104 -360 137 -361 b 196 -347 161 -361 181 -359 b 341 161 200 -344 341 161 b 356 217 347 187 354 210 b 338 240 356 232 341 239 b 323 235 336 240 331 240 b 193 140 312 226 240 140 z"
                },
                rest16th: {
                    x_min: 0,
                    x_max: 320,
                    y_min: -500,
                    y_max: 179,
                    ha: 679,
                    o: "m 300 160 b 202 258 300 215 256 258 b 104 160 148 258 104 215 b 219 62 104 101 164 62 b 331 94 258 62 298 75 b 341 96 336 95 338 96 b 348 86 346 96 348 94 b 265 -173 348 63 275 -151 b 194 -217 253 -200 215 -217 b 196 -203 196 -212 196 -207 b 98 -105 196 -148 151 -105 b 0 -203 43 -105 0 -148 b 115 -301 0 -262 60 -301 b 223 -271 153 -301 190 -288 b 229 -279 226 -271 229 -274 l 228 -281 b 228 -282 228 -282 228 -282 l 91 -690 b 91 -691 91 -690 91 -691 l 89 -693 b 134 -720 89 -706 102 -720 b 189 -687 176 -720 183 -703 l 356 -138 b 420 81 393 -16 420 81 b 459 226 420 81 456 207 b 461 232 459 229 461 230 b 446 248 461 240 449 246 b 431 242 439 248 435 245 b 300 145 420 233 348 147 z"
                },
                rest32nd: {
                    x_min: 0,
                    x_max: 363,
                    y_min: -500,
                    y_max: 426,
                    ha: 926,
                    o: "m 508 603 b 492 598 501 603 497 600 b 361 503 482 590 410 503 l 361 516 b 264 613 361 570 318 613 b 166 516 210 613 166 570 b 206 444 166 487 183 461 b 246 423 217 433 232 428 b 284 418 258 420 269 418 b 393 449 321 418 360 432 b 399 451 395 451 397 451 b 415 426 409 451 415 436 l 413 423 b 413 422 413 423 413 422 l 357 192 b 279 140 350 168 302 140 b 281 153 281 144 281 148 b 183 251 281 207 236 251 b 85 153 128 251 85 207 b 125 81 85 124 102 98 b 164 60 137 71 150 65 b 203 55 176 58 189 55 b 311 86 240 55 278 69 b 315 88 312 88 314 88 b 325 69 323 88 325 76 l 268 -167 b 194 -217 261 -197 216 -216 b 196 -203 196 -212 196 -207 b 98 -105 196 -148 153 -105 b 0 -203 45 -105 0 -148 b 115 -301 0 -262 60 -301 b 228 -269 154 -301 194 -288 b 232 -268 229 -268 230 -268 b 240 -276 236 -268 240 -272 b 138 -688 240 -282 141 -678 b 137 -697 137 -691 137 -694 b 176 -720 137 -708 145 -720 b 232 -690 222 -720 226 -706 b 484 436 236 -672 484 436 b 521 582 484 436 518 564 b 523 588 521 585 523 586 b 508 603 523 600 511 603 z"
                },
                rest64th: {
                    x_min: 0,
                    x_max: 423,
                    y_min: -753,
                    y_max: 430,
                    ha: 1183,
                    o: "m 596 609 b 580 603 589 609 585 606 b 448 507 569 595 497 507 b 449 521 449 511 449 516 b 351 619 449 575 405 619 b 253 521 297 619 253 575 b 372 422 253 461 317 422 b 481 454 410 422 446 438 b 491 456 484 455 488 456 b 504 441 498 456 504 451 b 501 426 504 436 503 432 b 445 202 500 422 451 217 b 359 144 435 174 383 144 l 359 158 b 261 256 359 212 315 256 b 163 158 207 256 163 212 b 243 65 163 112 202 78 b 279 60 255 62 266 60 b 397 91 320 60 360 73 b 403 92 400 92 402 92 b 412 79 409 92 412 86 b 410 72 412 76 412 75 b 351 -161 408 59 356 -150 b 281 -212 340 -199 301 -212 l 281 -197 b 183 -99 281 -144 238 -99 b 85 -197 130 -99 85 -144 b 125 -271 85 -228 102 -253 b 166 -291 138 -279 151 -287 b 204 -297 177 -294 192 -297 b 262 -287 225 -297 245 -292 b 305 -265 282 -279 287 -274 b 310 -264 307 -264 308 -264 b 318 -284 317 -264 318 -275 b 317 -295 318 -288 317 -294 b 259 -524 315 -302 265 -508 b 194 -567 251 -554 213 -567 b 196 -554 196 -563 196 -559 b 98 -456 196 -500 153 -456 b 0 -554 45 -456 0 -500 b 40 -626 0 -583 17 -609 b 118 -652 60 -644 92 -652 b 210 -629 145 -652 186 -642 b 216 -628 213 -628 215 -628 b 228 -647 226 -628 228 -639 l 226 -651 b 226 -652 226 -651 226 -652 l 122 -1054 b 121 -1064 121 -1058 121 -1061 b 167 -1084 121 -1077 134 -1084 b 215 -1060 202 -1084 209 -1076 b 402 -278 217 -1047 229 -1021 b 436 -135 403 -278 431 -161 l 570 441 b 609 588 570 441 605 569 b 596 609 609 603 602 608 z"
                },
                rest128th: {
                    x_min: 0,
                    x_max: 485,
                    y_min: -750,
                    y_max: 689,
                    ha: 1439,
                    o: "m 537 894 b 439 992 537 949 494 992 b 341 894 386 992 341 949 b 382 822 341 865 359 840 b 459 796 402 805 433 796 b 518 806 480 796 501 801 l 520 808 b 569 828 539 814 552 819 b 580 831 572 829 577 831 b 598 812 589 831 598 825 b 596 801 598 809 598 805 b 540 575 590 773 546 595 b 448 510 534 553 475 510 l 448 524 b 350 622 448 577 405 622 b 252 524 297 622 252 577 b 292 451 252 494 269 468 b 369 426 318 433 337 426 b 429 435 389 426 412 429 b 494 464 449 442 475 455 b 498 465 495 465 497 465 b 505 446 504 465 505 456 b 503 426 505 439 504 432 l 446 202 b 366 144 439 173 389 144 l 366 158 b 268 256 366 212 323 256 b 170 158 215 256 170 212 b 289 59 170 98 235 59 b 347 69 310 59 330 63 b 397 91 367 76 379 82 b 406 94 400 92 403 94 b 415 79 412 94 415 88 b 412 63 415 75 413 69 b 357 -157 408 42 364 -134 b 281 -212 346 -196 302 -212 b 282 -197 281 -207 282 -203 b 184 -99 282 -144 238 -99 b 86 -197 130 -99 86 -144 b 204 -297 86 -258 150 -297 b 262 -287 225 -297 245 -292 b 312 -265 282 -279 294 -274 b 318 -264 314 -264 317 -264 b 327 -275 324 -264 327 -269 b 266 -517 324 -287 278 -490 b 200 -569 248 -566 220 -567 l 196 -554 b 98 -456 196 -500 153 -456 b 0 -554 45 -456 0 -500 b 118 -652 0 -615 63 -652 b 177 -642 138 -652 160 -648 l 179 -641 b 229 -621 197 -635 210 -629 l 230 -619 b 239 -626 236 -619 239 -622 b 238 -632 239 -628 239 -631 b 131 -1057 235 -642 134 -1050 b 173 -1080 131 -1071 140 -1080 b 230 -1057 219 -1080 225 -1074 l 658 815 b 697 960 658 815 694 942 b 698 966 697 963 698 965 b 684 982 698 975 687 981 b 668 976 677 982 672 979 b 537 880 658 969 586 881 z"
                },
                dynamicPiano: {
                    x_min: -89,
                    x_max: 366,
                    y_min: -142,
                    y_max: 274,
                    ha: 416,
                    o: "m 395 395 b 292 357 350 395 318 380 b 262 328 272 340 268 328 b 246 363 255 328 259 338 b 177 393 236 380 215 393 b 1 251 92 393 46 333 b -9 223 -6 238 -9 230 b 7 207 -9 213 -1 207 b 30 229 17 207 23 216 b 127 338 72 301 101 338 b 143 321 138 338 143 331 b 134 285 143 310 138 295 l -43 -154 b -65 -168 -48 -166 -50 -168 l -109 -168 b -128 -187 -122 -168 -128 -174 b -111 -204 -128 -199 -122 -204 l 167 -204 b 186 -186 180 -204 186 -199 b 168 -168 186 -174 180 -168 l 111 -168 b 98 -164 102 -168 98 -168 b 101 -154 98 -163 99 -158 l 166 7 b 179 24 168 14 171 24 b 213 -1 186 24 190 10 b 276 -14 233 -12 252 -14 b 527 266 415 -14 527 130 b 395 395 527 350 475 395 z m 356 341 b 389 288 380 341 389 320 b 243 35 389 217 312 35 b 207 81 219 35 207 50 b 235 180 207 111 219 140 l 264 251 b 356 341 284 300 321 341 z"
                },
                dynamicMezzo: {
                    x_min: -20,
                    x_max: 446,
                    y_min: -10,
                    y_max: 274,
                    ha: 284,
                    o: "m 528 395 b 431 350 487 395 454 374 b 409 330 416 336 415 330 b 397 360 402 330 406 341 b 334 395 389 379 370 395 b 236 350 292 395 259 374 b 215 330 222 336 220 330 b 203 360 207 330 212 340 b 147 393 194 379 174 393 b -19 251 71 393 26 331 b -29 223 -26 238 -29 230 b -13 207 -29 213 -22 207 b 9 226 -3 207 1 215 b 107 338 52 300 81 338 b 122 321 118 338 122 331 b 114 285 122 310 118 295 l 9 24 b 4 9 6 17 4 13 b 20 0 4 3 9 0 l 91 0 b 114 17 104 0 108 3 l 207 251 b 287 323 225 292 255 323 b 308 302 304 323 308 314 b 294 249 308 285 302 269 b 203 24 294 248 292 248 b 199 9 200 17 199 13 b 215 0 199 3 203 0 l 285 0 b 308 17 298 0 302 3 l 402 251 b 481 323 419 292 449 323 b 503 302 498 323 503 314 b 413 43 503 252 413 104 b 478 -14 413 6 436 -14 b 629 102 533 -14 583 26 b 642 132 638 117 642 125 b 629 145 642 141 636 145 b 608 127 619 145 615 138 b 534 49 580 84 553 49 b 523 62 526 49 523 53 b 606 317 523 112 606 238 b 528 395 606 353 588 395 z"
                },
                dynamicForte: {
                    x_min: -141,
                    x_max: 364,
                    y_min: -152,
                    y_max: 444,
                    ha: 596,
                    o: "m 23 380 b 0 357 7 380 0 373 b 22 336 0 343 7 336 l 105 336 b 117 330 114 336 117 336 b 114 315 117 327 115 323 l 23 0 b -101 -187 -17 -141 -43 -187 b -127 -174 -120 -187 -127 -181 b -92 -156 -127 -163 -114 -170 b -63 -102 -75 -144 -63 -125 b -128 -43 -63 -65 -89 -43 b -203 -122 -171 -43 -203 -78 b -95 -219 -203 -186 -156 -219 b 161 17 14 -219 82 -145 b 269 317 203 105 235 194 l 271 318 b 289 336 271 323 282 336 l 383 336 b 406 359 399 336 406 343 b 384 380 406 373 399 380 l 298 380 b 284 387 288 380 284 380 b 287 405 284 392 285 396 b 419 606 315 530 347 606 b 442 595 431 606 442 603 b 419 580 442 586 435 588 b 389 526 400 572 389 552 b 454 465 389 485 418 465 b 524 543 491 465 524 490 b 400 639 524 596 491 639 b 135 402 261 639 183 540 b 107 380 128 380 127 380 z"
                },
                dynamicRinforzando: {
                    x_min: -20,
                    x_max: 277,
                    y_min: 0,
                    y_max: 274,
                    ha: 274,
                    o: "m 324 395 b 235 350 287 395 256 374 b 215 330 222 336 220 330 b 203 360 207 330 213 337 b 145 393 194 379 174 393 b -19 251 75 393 27 337 b -29 223 -26 238 -29 230 b -13 207 -29 213 -22 207 b 9 226 -3 207 3 215 b 107 338 52 301 81 338 b 122 321 118 338 122 331 b 114 285 122 310 118 295 l 9 24 b 4 9 6 17 4 13 b 20 0 4 3 9 0 l 91 0 b 114 17 104 0 108 3 l 207 251 b 304 351 226 298 272 351 b 318 343 312 351 318 348 b 287 285 318 330 287 325 b 338 239 287 256 308 239 b 399 318 373 239 399 268 b 324 395 399 360 377 395 z"
                },
                dynamicSforzando: {
                    x_min: 0,
                    x_max: 229,
                    y_min: -10,
                    y_max: 273,
                    ha: 283,
                    o: "m 212 393 b 68 274 127 393 68 350 b 145 161 68 223 95 196 b 200 85 187 132 200 114 b 127 20 200 53 173 20 b 66 42 91 20 66 32 b 91 56 66 49 75 46 b 111 98 104 65 111 79 b 59 145 111 127 86 145 b 0 78 24 145 0 117 b 125 -14 0 30 49 -14 b 291 120 219 -14 291 36 b 220 232 291 160 276 190 b 151 314 168 271 151 287 b 213 361 151 337 168 361 b 258 346 238 361 258 356 b 240 333 258 340 251 340 b 226 298 232 325 226 314 b 276 252 226 269 248 252 b 330 307 311 252 330 279 b 212 393 330 360 285 393 z"
                },
                dynamicZ: {
                    x_min: -30,
                    x_max: 244,
                    y_min: -10,
                    y_max: 268,
                    ha: 278,
                    o: "m 333 386 b 298 377 321 386 314 382 b 239 370 282 373 259 370 b 94 383 153 370 111 383 b 68 364 79 383 72 377 l 33 264 b 29 242 30 255 29 248 b 45 228 29 232 36 228 b 66 249 55 228 60 236 l 81 279 b 96 297 85 288 88 297 b 168 292 102 297 127 292 b 223 302 194 292 215 302 b 196 269 229 302 197 271 l -26 45 b -43 16 -37 33 -43 27 b -24 -1 -43 6 -36 -1 b 4 16 -12 -1 -3 10 b 39 30 16 24 27 30 b 179 -14 79 30 108 -14 b 297 102 259 -14 297 43 b 245 166 297 147 271 166 b 197 115 219 166 197 145 b 236 72 197 88 216 72 b 259 79 251 72 255 79 b 264 75 262 79 264 78 b 258 60 264 72 261 66 b 229 45 252 50 242 45 b 117 95 186 45 173 95 b 85 86 98 95 89 86 b 102 111 85 86 95 104 l 333 338 b 351 370 344 350 351 359 b 333 386 351 380 343 386 z"
                },
                ornamentTrill: {
                    x_min: 0,
                    x_max: 521,
                    y_min: -10,
                    y_max: 390,
                    ha: 400,
                    o: "m 383 562 b 364 557 377 562 369 559 l 294 534 b 269 511 281 530 275 526 l 217 384 b 206 367 212 370 210 367 b 179 380 200 367 192 374 b 118 393 158 389 140 393 b 0 292 50 393 0 353 b 95 210 0 248 30 210 b 140 213 112 210 131 213 b 144 209 143 213 144 212 b 140 194 144 206 143 202 l 124 156 b 96 58 108 117 96 88 b 179 -14 96 17 124 -14 b 325 153 253 -14 325 46 b 307 251 325 187 320 219 b 302 265 304 258 302 261 b 334 294 302 274 311 281 l 343 298 b 455 348 393 328 428 348 b 474 327 468 348 474 344 b 465 285 474 312 469 295 l 360 24 b 356 9 357 17 356 13 b 372 0 356 3 360 0 l 442 0 b 465 17 455 0 459 3 l 559 251 b 655 351 577 298 624 351 b 670 343 664 351 670 348 b 638 285 670 330 638 325 b 690 239 638 256 660 239 b 750 318 724 239 750 268 b 675 395 750 360 729 395 b 586 350 638 395 608 374 b 566 330 573 336 572 330 b 553 361 559 330 564 340 b 490 393 543 380 521 393 b 347 348 432 393 377 364 b 312 333 328 338 320 333 b 308 337 310 333 308 334 b 315 359 308 343 312 351 l 387 537 b 392 553 390 544 392 549 b 383 562 392 559 389 562 z m 118 360 b 192 325 134 360 192 347 b 186 307 192 321 189 314 l 180 292 b 148 265 173 274 167 269 b 98 258 130 261 112 258 b 39 301 50 258 39 281 b 118 360 39 327 60 360 z m 272 240 b 292 151 285 240 292 164 b 212 30 292 88 253 30 b 196 48 200 30 196 37 b 207 92 196 59 202 78 b 264 230 207 94 209 94 b 272 240 266 238 268 240 z"
                },
                ornamentTurn: {
                    x_min: 0,
                    x_max: 460,
                    y_min: 0,
                    y_max: 218,
                    ha: 218,
                    o: "m 534 314 b 454 251 490 314 454 294 b 505 199 454 219 475 199 b 579 232 547 199 549 232 b 626 164 603 232 626 202 b 533 72 626 102 583 72 b 377 180 487 72 439 111 b 150 312 307 258 243 312 b 0 148 55 312 0 240 b 128 0 0 45 66 0 b 209 63 173 0 209 20 b 157 115 209 95 187 115 b 84 82 115 115 114 82 b 36 150 59 82 36 112 b 130 242 36 212 79 242 b 285 134 176 242 223 203 b 513 1 356 56 419 1 b 662 166 608 1 662 73 b 534 314 662 269 596 314 z"
                },
                ornamentTurnSlash: {
                    x_min: 0,
                    x_max: 460,
                    y_min: -90,
                    y_max: 306,
                    ha: 396,
                    o: "m 333 441 b 310 418 315 441 310 433 l 310 274 b 302 252 310 258 308 252 b 261 278 294 252 287 262 b 150 311 228 298 192 311 b 0 147 55 311 0 239 b 128 -1 0 43 66 -1 b 209 62 173 -1 209 19 b 157 114 209 94 187 114 b 84 81 115 114 114 81 b 36 148 59 81 36 111 b 130 240 36 210 79 240 b 285 128 176 240 222 197 b 307 79 304 108 307 105 l 307 -107 b 330 -130 307 -122 312 -130 b 353 -107 347 -130 353 -122 l 353 37 b 360 59 353 53 353 59 b 402 33 369 59 376 49 b 513 0 435 13 471 0 b 662 164 608 0 662 72 b 534 312 662 268 596 312 b 454 249 490 312 454 292 b 505 197 454 217 475 197 b 579 230 547 197 549 230 b 626 163 603 230 626 200 b 533 71 626 101 583 71 b 377 183 487 71 441 114 b 356 232 359 203 356 206 l 356 418 b 333 441 356 433 350 441 z"
                },
                ornamentMordent: {
                    x_min: 1,
                    x_max: 729,
                    y_min: -73,
                    y_max: 319,
                    ha: 392,
                    o: "m 546 265 l 546 459 l 501 459 l 501 216 l 459 167 b 439 167 454 160 445 160 b 302 327 387 228 310 317 b 258 353 291 338 282 351 b 226 340 245 353 238 348 l 20 107 b 1 73 12 98 1 84 b 30 59 1 65 9 59 b 88 94 53 59 73 79 b 144 143 107 109 124 127 b 176 161 158 154 168 161 b 197 144 183 161 189 156 l 323 10 b 351 0 328 3 340 0 b 377 9 361 0 372 3 b 498 114 392 17 475 94 l 498 -105 l 544 -105 l 544 153 b 562 160 550 157 556 160 b 585 144 569 160 576 156 b 710 10 590 135 697 24 b 737 0 716 3 727 0 b 765 9 749 0 759 3 b 1030 295 776 17 1011 274 l 1032 300 b 1050 328 1041 308 1050 318 b 1012 353 1050 343 1024 353 b 986 343 1002 353 994 348 b 854 190 971 330 871 206 b 828 176 842 180 835 176 b 802 190 818 176 809 183 b 681 333 791 202 696 320 b 645 353 668 344 657 353 b 613 340 634 353 626 350 b 580 304 600 330 590 315 z"
                },
                ornamentShortTrill: {
                    x_min: 0,
                    x_max: 725,
                    y_min: 0,
                    y_max: 245,
                    ha: 245,
                    o: "m 429 167 l 301 325 b 256 353 291 338 282 350 b 225 340 246 353 238 350 b 16 105 158 268 88 186 b 0 72 9 96 0 86 b 29 58 0 63 7 58 b 71 76 42 58 55 62 l 158 154 b 174 160 163 158 168 160 b 197 143 181 160 187 154 b 321 10 203 135 310 24 b 350 0 327 3 338 0 b 377 7 361 0 372 3 l 533 148 b 554 160 543 158 550 160 b 577 143 562 160 566 156 b 703 10 585 135 690 24 b 732 0 708 3 720 0 b 759 7 743 0 753 3 b 1024 294 769 16 1005 272 b 1044 327 1032 305 1044 321 b 1005 353 1044 341 1018 353 b 979 343 996 353 988 348 b 848 189 963 330 864 204 b 821 174 837 179 828 174 b 796 189 811 174 804 181 b 674 331 783 202 688 318 b 641 351 662 343 651 351 b 606 340 628 351 619 350 b 573 304 593 328 583 315 b 444 167 533 259 491 213 b 429 167 439 161 433 161 z"
                },
                ornamentTremblement: {
                    x_min: 1,
                    x_max: 985,
                    y_min: 0,
                    y_max: 244,
                    ha: 244,
                    o: "m 678 325 b 634 351 667 338 657 350 b 602 338 621 351 613 348 l 448 167 b 439 167 446 164 441 164 l 302 325 b 258 351 291 338 281 350 b 228 338 245 351 238 348 b 193 304 215 328 204 315 l 19 107 b 1 72 13 96 1 76 b 30 58 1 63 9 58 b 89 92 52 58 73 78 l 144 141 b 148 144 145 143 147 143 b 176 160 160 153 170 160 b 199 143 183 160 189 154 b 324 10 204 134 311 23 b 351 0 330 3 340 0 b 379 7 363 0 373 3 l 530 148 b 552 160 536 154 546 160 b 575 143 559 160 564 154 b 698 10 580 134 687 23 b 727 0 704 3 716 0 b 755 7 739 0 749 3 l 907 147 b 930 160 922 158 923 160 b 952 143 937 160 943 154 l 1077 10 b 1107 0 1084 3 1096 0 b 1133 7 1117 0 1128 3 b 1398 294 1143 16 1380 272 b 1418 327 1407 305 1418 321 b 1381 351 1418 343 1394 351 b 1354 341 1371 351 1362 348 b 1223 189 1338 328 1238 204 b 1195 174 1211 179 1202 174 b 1171 189 1185 174 1178 181 b 1048 331 1158 200 1063 318 b 1012 351 1035 343 1024 351 b 981 338 1002 351 994 350 b 948 304 968 328 958 315 b 827 166 907 258 865 212 b 815 166 824 163 818 163 b 678 325 760 226 732 264 z"
                },
                ornamentPrecompAppoggTrill: {
                    x_min: 0,
                    x_max: 1119,
                    y_min: 0,
                    y_max: 481,
                    ha: 481,
                    o: "m 1015 163 b 873 328 963 223 880 318 b 828 354 860 344 847 353 b 796 341 816 354 809 351 b 763 305 783 331 773 317 b 642 168 721 261 681 215 b 636 163 641 167 639 164 b 494 328 585 223 501 318 b 449 354 481 344 468 353 b 418 341 438 354 431 351 b 384 305 405 331 395 317 b 264 168 343 261 302 215 l 242 144 b 144 88 232 124 171 88 b 79 197 81 88 79 189 l 79 648 b 60 693 79 683 71 693 b 52 691 58 693 55 693 b 0 616 3 672 0 625 l 0 207 b 121 0 0 40 68 0 b 249 68 168 0 232 53 b 279 94 262 75 271 86 b 336 144 298 111 315 128 b 367 163 350 156 360 163 b 389 145 374 163 380 157 b 514 12 395 137 501 26 b 543 1 520 4 531 1 b 569 9 553 1 563 4 b 636 73 576 14 605 43 l 658 94 b 714 144 677 111 694 128 b 746 163 729 156 739 163 b 768 145 753 163 759 157 b 893 12 773 137 880 26 b 922 1 899 4 910 1 b 948 9 932 1 942 4 l 1012 71 b 1037 94 1022 78 1030 86 b 1092 144 1054 111 1073 128 b 1123 161 1106 156 1115 161 b 1146 145 1130 161 1136 157 b 1270 12 1152 137 1259 26 b 1299 1 1276 4 1287 1 b 1326 9 1310 1 1320 4 b 1591 297 1336 19 1572 275 b 1611 328 1600 307 1611 320 b 1574 354 1611 343 1585 354 b 1548 344 1565 354 1555 350 b 1416 192 1532 331 1431 206 b 1388 177 1404 181 1395 177 b 1365 190 1380 177 1371 184 b 1243 333 1352 203 1256 321 b 1205 354 1228 346 1217 354 b 1174 341 1195 354 1187 351 b 1140 305 1161 330 1152 317 z"
                },
                ornamentPrecompSlideTrillDAnglebert: {
                    x_min: 2,
                    x_max: 1150,
                    y_min: -367,
                    y_max: 245,
                    ha: 612,
                    o: "m 1058 160 b 916 327 1007 220 923 317 b 871 353 903 343 890 351 b 840 340 860 353 852 350 b 806 304 827 330 816 315 b 685 167 765 259 724 213 l 680 160 l 615 235 b 419 344 582 275 523 344 b 3 -144 258 344 3 26 b 4 -168 3 -153 3 -160 b 246 -482 24 -315 99 -422 b 458 -528 340 -521 410 -528 b 514 -526 485 -528 504 -526 b 552 -508 531 -526 552 -517 b 514 -497 552 -503 541 -498 l 503 -497 b 194 -390 432 -494 298 -488 b 69 -151 194 -390 69 -279 b 184 96 69 -60 128 27 b 328 183 202 118 258 183 b 477 96 413 183 454 118 b 559 10 510 62 552 19 b 588 0 566 3 576 0 b 613 7 598 0 609 3 b 723 112 622 14 681 73 b 789 161 733 122 776 161 b 811 144 796 161 802 156 b 936 10 816 135 923 24 b 965 0 942 3 953 0 b 991 7 975 0 985 3 b 1051 66 996 12 1022 37 b 1081 92 1063 73 1073 84 b 1136 143 1099 109 1117 127 b 1168 160 1151 154 1159 160 b 1191 144 1175 160 1181 156 b 1315 10 1197 135 1303 24 b 1344 0 1320 3 1332 0 b 1371 7 1355 0 1365 3 b 1636 295 1381 17 1617 274 b 1656 327 1644 305 1656 318 b 1619 353 1656 341 1630 353 b 1593 343 1610 353 1600 348 b 1460 190 1577 330 1476 204 b 1433 176 1449 180 1440 176 b 1410 189 1424 176 1416 183 b 1287 331 1397 202 1300 320 b 1250 353 1273 344 1261 353 b 1218 340 1240 353 1231 350 b 1185 304 1205 328 1197 315 z"
                },
                ornamentPrecompSlideTrillBach: {
                    x_min: 0,
                    x_max: 1048,
                    y_min: -367,
                    y_max: 331,
                    ha: 698,
                    o: "m 1038 477 l 979 477 l 979 238 l 912 160 b 769 327 858 220 775 317 b 724 353 756 343 743 351 b 693 340 713 353 706 350 b 660 304 680 330 670 315 b 539 167 618 259 577 213 b 533 161 536 166 534 163 b 390 327 480 220 396 317 b 346 353 377 343 364 351 l 340 353 b 308 340 330 353 321 350 b 275 304 295 330 285 315 b 117 122 220 243 168 186 b 0 -144 68 62 0 -48 b 1 -168 0 -153 0 -160 b 243 -482 22 -315 96 -422 b 455 -528 337 -521 408 -528 b 511 -526 482 -528 501 -526 b 549 -508 528 -526 549 -517 b 511 -497 549 -503 539 -498 l 500 -497 b 192 -390 429 -494 295 -488 b 68 -177 192 -390 84 -298 b 66 -151 66 -168 66 -160 b 189 105 66 -58 127 35 b 232 143 203 118 216 131 b 264 161 246 154 256 161 b 285 144 271 161 276 156 b 410 10 291 135 397 24 b 439 0 416 3 428 0 b 465 7 449 0 459 3 l 531 72 b 554 92 540 78 547 86 b 611 143 573 109 590 127 b 642 161 625 154 635 161 b 664 144 649 161 655 156 b 789 10 670 135 776 24 b 818 0 795 3 806 0 b 844 7 828 0 838 3 b 904 66 850 12 876 37 b 935 92 916 73 924 84 b 979 134 949 107 963 121 l 979 -88 l 1037 -88 l 1037 151 l 1044 144 b 1168 10 1050 135 1156 24 b 1197 0 1174 3 1185 0 b 1224 7 1208 0 1218 3 b 1489 295 1234 17 1470 274 b 1509 327 1498 305 1509 318 b 1472 353 1509 341 1483 353 b 1446 343 1463 353 1453 348 b 1313 190 1430 330 1329 204 b 1286 176 1302 180 1293 176 b 1263 189 1277 176 1269 183 b 1140 331 1250 202 1153 320 b 1103 353 1126 344 1115 353 b 1071 340 1093 353 1084 350 b 1038 304 1058 328 1050 315 z"
                },
                ornamentPrecompTrillSuffixDandrieu: {
                    x_min: 0,
                    x_max: 949,
                    y_min: 0,
                    y_max: 381,
                    ha: 381,
                    o: "m 1367 314 b 1250 521 1367 419 1318 482 b 1107 549 1211 537 1145 549 b 1083 546 1096 549 1087 549 b 1066 528 1071 540 1066 534 b 1079 520 1066 524 1070 520 b 1323 351 1187 517 1323 487 b 1201 171 1323 269 1260 219 b 1194 166 1201 171 1198 168 b 1056 327 1142 226 1063 317 b 1011 353 1043 343 1030 351 b 979 340 999 353 992 350 b 946 304 966 330 956 315 b 825 167 904 259 864 213 l 821 161 b 678 327 768 222 685 317 b 634 353 665 343 652 351 b 602 340 622 353 615 350 b 569 304 589 330 579 315 b 448 167 527 259 487 213 l 444 161 b 301 327 390 222 308 317 b 256 353 288 343 275 351 b 225 340 245 353 238 350 b 192 304 212 330 202 315 b 71 167 150 259 109 213 b 17 105 52 147 36 127 b 0 73 10 98 0 84 b 29 58 0 65 7 58 b 86 92 56 59 72 79 b 143 143 105 109 122 127 b 174 161 157 154 167 161 b 196 144 181 161 187 156 b 321 10 202 135 308 24 b 350 0 327 3 338 0 b 376 7 360 0 370 3 b 485 112 384 14 444 73 b 552 161 495 122 539 161 b 573 144 559 161 564 156 b 698 10 579 135 685 24 b 727 0 704 3 716 0 b 753 7 737 0 747 3 b 863 112 762 14 821 73 b 929 161 873 122 916 161 b 950 144 936 161 942 156 b 1076 10 956 135 1063 24 b 1104 0 1081 3 1093 0 b 1130 7 1115 0 1125 3 b 1236 108 1139 14 1195 69 b 1367 314 1297 160 1367 233 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefix: {
                    x_min: 0,
                    x_max: 1278,
                    y_min: 0,
                    y_max: 247,
                    ha: 247,
                    o: "m 1801 356 b 1776 346 1793 356 1783 351 b 1642 192 1760 333 1659 206 b 1614 177 1630 181 1621 177 b 1591 190 1606 177 1597 184 b 1469 334 1578 203 1482 323 b 1430 356 1453 347 1441 356 b 1398 343 1420 356 1411 353 b 1365 307 1385 331 1377 318 l 1240 164 b 1097 330 1187 226 1104 320 b 1053 356 1084 346 1071 354 b 1021 343 1041 356 1034 353 b 988 307 1008 333 998 318 b 865 168 946 262 904 216 l 861 163 b 717 330 808 223 724 320 b 672 356 704 346 691 354 b 641 343 661 356 654 353 b 608 307 628 333 618 318 b 485 168 566 262 524 216 l 455 134 b 284 46 409 88 351 46 b 16 285 148 46 32 265 b 3 295 9 292 4 295 b 0 291 1 295 0 292 b 1 285 0 288 1 285 b 308 0 42 190 157 0 b 530 120 415 1 482 63 b 559 144 539 128 549 137 b 590 163 573 156 583 163 b 612 145 598 163 603 157 b 739 10 618 137 724 24 b 768 0 744 3 756 0 b 793 7 778 0 788 3 b 903 114 802 14 861 75 l 939 144 b 971 163 953 156 963 163 b 992 145 978 163 984 157 b 1119 10 998 137 1106 24 b 1148 0 1125 3 1136 0 b 1174 7 1158 0 1168 3 b 1284 114 1182 14 1241 75 b 1316 144 1282 115 1312 141 b 1348 161 1331 156 1339 161 b 1371 145 1355 161 1361 157 b 1496 10 1377 137 1485 24 b 1525 0 1502 3 1513 0 b 1552 7 1536 0 1547 3 b 1819 298 1562 17 1800 276 b 1840 330 1829 308 1840 320 b 1832 344 1840 334 1837 340 b 1801 356 1820 351 1810 356 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefixTurn: {
                    x_min: 0,
                    x_max: 1277,
                    y_min: -62,
                    y_max: 333,
                    ha: 395,
                    o: "m 1273 202 l 1273 480 l 1230 480 l 1230 174 l 1097 328 b 1053 354 1084 344 1071 353 b 1021 341 1041 354 1034 351 b 988 305 1008 331 998 317 b 865 167 945 261 904 215 l 861 161 b 717 328 808 222 724 318 b 672 354 704 344 691 353 b 641 341 661 354 654 351 b 608 305 628 331 618 317 b 485 167 564 261 524 215 b 455 132 474 156 465 144 b 284 45 410 88 350 45 b 14 284 148 45 30 264 b 3 294 9 291 4 294 b 0 289 1 294 0 291 b 1 284 0 287 1 284 b 308 -1 42 189 157 -1 b 530 118 415 0 481 62 b 557 143 539 127 547 135 b 590 161 572 154 582 161 b 612 144 598 161 603 156 b 737 9 618 135 724 24 b 768 -1 743 1 755 -1 b 793 6 778 -1 788 1 b 903 112 802 13 861 73 l 937 143 b 971 161 953 154 963 161 b 992 144 978 161 984 156 b 1117 9 998 135 1104 24 b 1148 -1 1123 1 1136 -1 b 1174 6 1158 -1 1168 1 l 1230 60 l 1230 -89 l 1273 -89 l 1273 102 l 1283 112 b 1348 160 1295 125 1332 160 b 1371 144 1355 160 1361 156 b 1496 9 1377 135 1483 24 b 1525 -1 1502 1 1513 -1 b 1552 6 1536 -1 1547 1 b 1819 297 1562 16 1800 275 b 1839 328 1827 307 1839 320 b 1801 354 1839 343 1813 354 b 1776 344 1793 354 1783 350 b 1642 190 1760 331 1657 206 b 1614 176 1630 180 1621 176 b 1591 189 1606 176 1597 183 b 1467 333 1578 203 1480 321 b 1430 354 1453 346 1441 354 b 1398 341 1420 354 1411 351 b 1365 305 1385 330 1377 317 z"
                },
                ornamentPrecompTrillLowerSuffix: {
                    x_min: 0,
                    x_max: 859,
                    y_min: -222,
                    y_max: 246,
                    ha: 468,
                    o: "m 1164 217 b 1031 351 1138 259 1063 351 b 1011 337 1020 351 1024 347 b 828 167 952 291 886 217 l 824 164 b 683 328 772 225 690 318 b 638 354 670 344 657 353 b 606 341 626 354 619 351 b 573 305 593 331 583 317 b 451 167 530 261 490 215 l 446 161 b 302 328 393 222 310 318 b 258 354 289 344 276 353 b 226 341 246 354 239 351 b 193 305 213 331 203 317 b 71 167 150 261 109 215 b 17 105 52 147 36 127 b 0 73 10 98 0 84 b 29 58 0 65 7 58 b 86 92 56 59 72 79 b 143 143 105 109 122 127 b 176 161 157 154 168 161 b 197 144 183 161 189 156 b 323 9 203 135 310 23 b 353 -1 328 1 340 -1 b 379 6 363 -1 373 1 b 488 112 387 13 446 73 l 523 143 b 556 161 539 154 549 161 b 577 144 563 161 569 156 b 703 9 583 135 690 23 b 733 -1 708 1 721 -1 b 759 6 743 -1 753 1 b 868 112 768 13 827 73 b 955 183 878 122 943 183 b 1081 107 965 183 1031 153 b 1156 -89 1128 63 1156 6 l 1156 -102 b 948 -297 1156 -204 1048 -297 b 806 -271 904 -297 850 -282 l 792 -266 b 801 -288 792 -268 795 -282 b 948 -320 809 -297 880 -320 b 1237 -50 1092 -320 1237 -199 b 1164 217 1237 75 1218 122 z"
                },
                brassScoop: {
                    x_min: 1,
                    x_max: 320,
                    y_min: -373,
                    y_max: 13,
                    ha: 386,
                    o: "m 35 -537 b 461 -12 194 -518 461 -289 b 438 19 461 13 451 19 b 410 -9 425 19 413 9 b 35 -425 357 -366 92 -403 b 1 -482 13 -433 1 -438 l 1 -505 b 26 -537 1 -526 3 -537 z"
                },
                brassDoitMedium: {
                    x_min: 0,
                    x_max: 489,
                    y_min: -40,
                    y_max: 346,
                    ha: 386,
                    o: "m 33 -58 b 704 468 255 -58 683 186 b 681 498 704 494 693 498 b 654 471 668 498 658 488 b 33 55 550 118 91 76 b 0 -3 12 46 0 42 l 0 -26 b 24 -58 0 -46 1 -58 z"
                },
                brassFallLipShort: {
                    x_min: 1,
                    x_max: 293,
                    y_min: -345,
                    y_max: 42,
                    ha: 387,
                    o: "m 22 60 b 1 35 4 60 1 52 l 1 6 b 26 -50 3 -40 10 -43 b 32 -52 27 -50 30 -50 b 376 -469 85 -73 327 -111 b 400 -497 379 -487 387 -497 b 422 -467 412 -497 422 -491 b 32 60 422 -187 177 40 z"
                },
                brassLiftMedium: {
                    x_min: 0,
                    x_max: 811,
                    y_min: 0,
                    y_max: 852,
                    ha: 852,
                    o: "m 1138 1220 b 1135 1225 1135 1223 1135 1224 b 1129 1227 1133 1227 1130 1227 b 1117 1207 1122 1227 1117 1212 l 1117 1201 b 1109 1164 1117 1187 1117 1172 b 1100 1156 1107 1161 1104 1158 b 959 1104 1058 1128 995 1140 b 929 1032 936 1081 929 1056 b 932 1007 929 1024 930 1015 b 923 976 932 995 930 985 l 914 971 b 773 919 873 942 809 955 b 743 847 750 896 743 870 b 746 821 743 838 744 829 b 737 791 746 809 744 799 l 729 783 b 588 733 687 756 624 769 b 557 661 564 710 557 684 b 560 635 557 652 559 644 b 552 605 560 624 559 612 l 543 598 b 402 547 501 570 438 583 b 372 475 379 524 372 498 b 374 449 372 467 373 458 b 366 419 374 438 373 426 l 357 412 b 216 361 315 384 252 397 b 186 289 193 338 186 312 b 189 264 186 281 187 272 b 180 233 189 252 187 240 b 171 226 177 232 174 229 b 30 176 130 199 66 212 b 0 104 7 153 0 128 b 33 0 0 88 14 0 b 49 17 40 0 49 10 b 71 63 52 35 56 49 b 212 115 102 95 154 59 b 239 186 230 134 239 160 b 236 210 239 194 238 202 b 256 249 239 225 243 236 b 397 301 288 281 340 245 b 425 372 416 320 425 346 b 422 396 425 380 423 387 b 442 435 425 410 429 422 b 583 487 474 467 526 431 b 611 557 602 505 611 531 b 608 582 611 566 609 573 b 628 621 611 596 615 608 b 769 672 660 652 711 618 b 796 743 788 691 796 717 b 793 768 796 752 795 759 b 814 806 796 782 801 793 b 955 858 845 838 897 804 b 982 929 973 877 982 903 b 979 953 982 937 981 945 b 999 992 982 968 986 979 b 1140 1045 1031 1024 1083 989 b 1168 1116 1161 1066 1168 1090 b 1138 1220 1168 1162 1145 1207 z"
                },
                brassFallRoughMedium: {
                    x_min: 0,
                    x_max: 811,
                    y_min: 0,
                    y_max: 852,
                    ha: 852,
                    o: "m 30 1220 b 0 1116 23 1207 0 1162 b 27 1045 0 1090 7 1066 b 168 992 85 989 137 1024 b 189 953 181 979 186 968 b 186 929 187 945 186 937 b 213 858 186 903 194 877 b 354 806 271 804 323 838 b 374 768 367 793 372 782 b 372 743 373 759 372 752 b 399 672 372 717 380 691 b 540 621 456 618 508 652 b 560 582 553 608 557 596 b 557 557 559 573 557 566 b 585 487 557 531 566 505 b 726 435 642 431 694 467 b 746 396 739 422 743 410 b 743 372 744 387 743 380 b 770 301 743 346 752 320 b 912 249 828 245 880 281 b 932 210 924 236 929 225 b 929 186 930 202 929 194 b 956 115 929 160 937 134 b 1097 63 1014 59 1066 95 b 1119 17 1112 49 1116 35 b 1135 0 1119 10 1128 0 b 1168 104 1153 0 1168 91 b 1138 176 1168 128 1161 153 b 996 226 1102 212 1038 199 b 988 233 994 229 991 232 b 979 264 981 240 979 252 b 982 289 981 272 982 281 b 952 361 982 312 975 338 b 811 412 916 397 852 384 l 802 419 b 793 449 795 426 793 438 b 796 475 795 458 796 467 b 766 547 796 498 789 524 b 625 598 730 583 667 570 l 616 605 b 608 635 609 612 608 624 b 611 661 609 644 611 652 b 580 733 611 684 603 710 b 439 783 544 769 481 756 l 431 791 b 422 821 423 799 422 809 b 425 847 423 829 425 838 b 395 919 425 870 418 896 b 253 971 359 955 295 942 l 245 976 b 236 1007 238 985 236 995 b 239 1032 238 1015 239 1024 b 209 1104 239 1056 232 1081 b 68 1156 173 1140 109 1128 b 59 1164 63 1158 60 1161 b 50 1201 50 1172 50 1187 l 50 1207 b 39 1227 50 1212 46 1227 b 33 1225 37 1227 35 1227 b 30 1220 33 1224 33 1223 z"
                },
                brassBend: {
                    x_min: 0,
                    x_max: 392,
                    y_min: 0,
                    y_max: 282,
                    ha: 282,
                    o: "m 282 0 b 552 72 369 0 456 23 b 564 92 560 75 564 84 l 564 383 b 541 406 564 395 554 406 b 518 383 528 406 518 395 l 518 107 b 282 46 435 65 357 46 b 46 107 207 46 130 65 l 46 383 b 23 406 46 395 36 406 b 0 383 10 406 0 395 l 0 92 b 13 72 0 84 4 75 b 282 0 108 23 196 0 z"
                },
                brassMuteClosed: {
                    x_min: 0,
                    x_max: 272,
                    y_min: 0,
                    y_max: 272,
                    ha: 272,
                    o: "m 392 219 l 219 219 l 219 392 l 173 392 l 173 219 l 0 219 l 0 173 l 173 173 l 173 0 l 219 0 l 219 173 l 392 173 z"
                },
                brassMuteOpen: {
                    x_min: 0,
                    x_max: 304,
                    y_min: 0,
                    y_max: 304,
                    ha: 304,
                    o: "m 219 0 b 438 219 340 0 438 98 b 219 438 438 340 340 438 b 0 219 98 438 0 340 b 219 0 0 98 98 0 z m 219 392 b 392 219 314 392 392 314 b 219 46 392 124 314 46 b 46 219 124 46 46 124 b 219 392 46 314 124 392 z"
                },
                brassFlip: {
                    x_min: 0,
                    x_max: 379,
                    y_min: 0,
                    y_max: 282,
                    ha: 282,
                    o: "m 523 0 b 541 9 530 0 536 3 b 546 22 544 13 546 17 b 536 42 546 29 541 36 l 36 402 b 23 406 33 405 27 406 b 0 383 12 406 0 395 l 0 23 b 23 0 0 10 10 0 b 46 23 36 0 46 10 l 46 337 l 508 4 b 523 0 513 1 517 0 z"
                },
                brassJazzTurn: {
                    x_min: 0,
                    x_max: 620,
                    y_min: 0,
                    y_max: 245,
                    ha: 245,
                    o: "m 792 190 b 765 176 780 179 772 176 b 740 190 755 176 747 183 b 629 325 727 202 644 312 b 593 347 616 338 605 347 b 562 334 583 346 575 344 b 528 298 549 323 539 310 l 406 176 b 389 168 406 176 399 168 b 374 176 384 168 379 170 b 245 325 360 192 245 325 b 200 353 232 343 219 351 b 168 340 190 353 181 350 l 17 156 b 0 121 10 147 0 132 b 16 107 0 114 4 108 b 84 143 26 107 76 137 b 118 160 92 150 108 160 b 141 143 125 160 131 154 b 265 10 147 135 253 24 b 294 0 271 3 282 0 b 321 7 305 0 315 3 b 498 160 321 7 478 158 b 521 143 505 160 513 154 b 647 10 528 135 635 24 b 675 0 652 3 664 0 b 703 7 687 0 697 3 b 874 186 713 16 855 164 b 893 220 881 196 893 212 b 873 245 890 235 883 243 b 796 194 847 245 815 213 z"
                },
                brassSmear: {
                    x_min: 1,
                    x_max: 306,
                    y_min: 0,
                    y_max: 170,
                    ha: 170,
                    o: "m 193 79 b 308 0 219 50 264 0 b 439 117 396 0 438 102 b 439 120 439 118 439 118 l 441 125 b 441 128 441 127 441 127 b 433 141 441 135 439 141 b 416 130 429 141 423 137 b 343 94 390 107 370 94 b 269 153 315 94 294 121 l 265 158 b 144 245 239 190 180 245 b 6 134 62 245 10 143 b 1 114 3 125 1 118 b 7 107 1 108 4 107 b 36 122 13 107 22 112 b 92 151 55 137 65 151 b 183 89 125 151 161 112 b 189 84 184 88 187 86 z"
                },
                stringsDownBow: {
                    x_min: 0,
                    x_max: 312,
                    y_min: 0,
                    y_max: 318,
                    ha: 318,
                    o: "m 37 458 b 0 420 17 458 0 441 l 0 17 b 17 0 0 7 9 0 l 37 0 b 55 17 46 0 55 7 l 55 253 b 225 278 55 269 140 278 b 395 253 310 278 395 269 l 395 17 b 413 0 395 7 403 0 l 432 0 b 449 17 441 0 449 7 l 449 420 b 412 458 449 441 432 458 z"
                },
                stringsUpBow: {
                    x_min: 1,
                    x_max: 249,
                    y_min: 1,
                    y_max: 495,
                    ha: 494,
                    o: "m 181 1 b 206 22 193 1 203 10 l 359 683 l 359 688 b 338 713 359 700 351 710 l 333 713 b 308 694 321 713 311 706 l 180 140 l 53 694 b 27 713 49 706 39 713 l 22 713 b 1 690 10 710 1 700 b 3 683 1 687 1 685 l 154 22 b 181 1 157 10 167 1 z"
                },
                stringsHarmonic: {
                    x_min: 0,
                    x_max: 200,
                    y_min: 0,
                    y_max: 200,
                    ha: 200,
                    o: "m 288 144 b 144 288 288 225 223 288 b 0 144 65 288 0 225 b 144 0 0 65 65 0 b 288 144 223 0 288 65 z m 144 249 b 249 144 203 249 249 203 b 144 39 249 86 203 39 b 39 144 86 39 39 86 b 144 249 39 203 86 249 z"
                },
                pluckedSnapPizzicatoAbove: {
                    x_min: 0,
                    x_max: 200,
                    y_min: 0,
                    y_max: 300,
                    ha: 300,
                    o: "m 0 144 b 144 0 0 63 65 0 b 288 144 223 0 288 63 b 167 285 288 215 235 275 l 167 432 l 121 432 l 121 285 b 0 144 52 275 0 215 z m 121 246 l 121 144 l 167 144 l 167 246 b 249 144 213 236 249 193 b 144 39 249 85 202 39 b 39 144 85 39 39 85 b 121 246 39 193 73 236 z"
                },
                pluckedSnapPizzicatoBelow: {
                    x_min: 0,
                    x_max: 200,
                    y_min: 0,
                    y_max: 300,
                    ha: 300,
                    o: "m 288 288 b 144 432 288 369 223 432 b 0 288 65 432 0 369 b 121 145 0 216 52 157 l 121 0 l 167 0 l 167 145 b 288 288 235 157 288 216 z m 167 186 l 167 288 l 121 288 l 121 186 b 39 288 75 196 39 238 b 144 393 39 347 86 393 b 249 288 203 393 249 347 b 167 186 249 238 215 196 z"
                },
                pluckedLeftHandPizzicato: {
                    x_min: 0,
                    x_max: 272,
                    y_min: 0,
                    y_max: 272,
                    ha: 272,
                    o: "m 392 219 l 219 219 l 219 392 l 173 392 l 173 219 l 0 219 l 0 173 l 173 173 l 173 0 l 219 0 l 219 173 l 392 173 z"
                },
                keyboardPedalPed: {
                    x_min: 0,
                    x_max: 1019,
                    y_min: -8,
                    y_max: 555,
                    ha: 563,
                    o: "m 413 799 b 179 749 327 798 261 789 b 0 517 107 713 0 632 b 122 376 0 454 37 376 b 240 540 189 376 240 452 b 225 586 240 579 233 586 b 204 549 213 586 212 573 b 138 480 199 527 181 480 b 85 549 96 480 85 517 l 85 554 b 353 762 89 690 230 762 b 373 752 364 762 373 760 b 351 708 373 740 360 723 b 274 546 330 675 274 585 b 353 416 274 508 333 444 b 412 304 372 390 412 351 b 382 228 412 275 403 256 b 334 190 363 202 361 200 b 147 29 271 167 147 88 b 196 -12 147 4 171 -12 b 343 108 239 -12 279 33 l 363 132 b 387 150 370 141 376 150 b 543 -4 445 150 467 -4 b 631 42 567 -4 586 0 l 668 78 b 685 89 674 84 680 89 b 696 75 688 89 690 86 b 809 -9 717 29 753 -9 b 946 66 854 -9 894 13 b 988 107 971 92 981 107 b 1002 89 994 107 996 99 b 1152 -4 1030 36 1077 -4 b 1329 248 1238 -4 1329 82 b 792 717 1329 556 1047 665 b 766 720 785 719 775 720 b 747 703 752 720 747 711 b 780 680 747 693 756 685 b 1223 222 1028 621 1223 504 b 1152 39 1223 122 1205 39 b 1073 229 1104 39 1073 132 b 1132 423 1073 314 1086 377 b 1142 442 1140 432 1142 436 b 1126 458 1142 451 1136 458 b 1093 446 1119 458 1109 455 b 975 216 1022 408 975 337 l 975 190 b 943 121 975 160 972 150 b 852 69 899 76 877 69 b 776 148 816 69 786 117 b 773 163 775 154 773 158 b 786 177 773 167 776 170 l 801 187 b 937 366 867 235 937 284 b 844 454 937 422 900 454 b 665 217 711 454 665 331 b 671 153 665 197 667 176 l 671 147 b 662 134 671 143 670 140 b 605 111 639 118 625 111 b 521 160 572 111 546 135 b 451 203 497 184 474 197 b 426 212 435 207 426 206 b 436 230 426 216 429 220 b 510 389 464 269 510 340 b 429 521 510 435 480 462 b 369 629 387 570 369 599 b 402 720 369 648 384 691 b 462 763 425 759 446 763 b 611 624 540 763 611 704 b 564 575 611 592 590 575 b 501 602 540 575 520 582 b 474 622 492 611 487 622 b 459 603 465 622 459 615 b 603 471 459 570 510 471 b 711 588 670 471 711 524 b 422 799 711 742 554 799 z m 815 403 b 848 343 838 403 848 383 b 780 226 848 295 824 261 b 765 217 773 220 768 217 b 759 228 762 217 759 220 b 756 282 757 245 756 262 b 815 403 756 346 772 403 z m 1405 124 b 1344 62 1369 124 1344 98 b 1405 0 1344 26 1369 0 b 1467 62 1441 0 1467 26 b 1405 124 1467 98 1441 124 z"
                },
                keyboardPedalUp: {
                    x_min: 0,
                    x_max: 450,
                    y_min: 0,
                    y_max: 450,
                    ha: 450,
                    o: "m 582 396 b 516 367 554 396 533 384 b 465 340 495 347 487 340 l 458 340 b 412 377 432 340 412 348 b 432 409 412 387 419 396 l 438 415 b 490 429 451 428 464 429 b 575 501 534 429 575 452 b 501 575 575 541 541 575 b 429 490 452 575 429 534 b 415 438 429 464 428 451 l 409 432 b 377 412 396 419 387 412 b 340 458 348 412 340 432 l 340 465 b 367 516 340 487 347 495 b 396 582 384 533 396 554 b 324 648 396 625 363 648 b 252 582 285 648 252 625 b 281 516 252 554 264 533 b 308 465 301 495 308 487 l 308 458 b 271 412 308 432 300 412 b 239 432 261 412 252 419 l 233 438 b 219 490 220 451 219 464 b 147 575 219 534 196 575 b 73 501 107 575 73 541 b 158 429 73 452 114 429 b 210 415 184 429 197 428 l 216 409 b 236 377 229 396 236 387 b 190 340 236 348 216 340 l 183 340 b 132 367 161 340 153 347 b 66 396 115 384 94 396 b 0 324 23 396 0 363 b 66 252 0 285 23 252 b 132 281 94 252 115 264 b 183 308 153 301 161 308 l 190 308 b 236 271 216 308 236 300 b 216 239 236 261 229 252 l 210 233 b 158 219 197 220 184 219 b 73 147 114 219 73 196 b 147 73 73 107 107 73 b 219 158 196 73 219 114 b 233 210 219 184 220 197 l 239 216 b 271 236 252 229 261 236 b 308 190 300 236 308 216 l 308 183 b 281 132 308 161 301 153 b 252 66 264 115 252 94 b 324 0 252 23 285 0 b 396 66 363 0 396 23 b 367 132 396 94 384 115 b 340 183 347 153 340 161 l 340 190 b 377 236 340 216 348 236 b 409 216 387 236 396 229 l 415 210 b 429 158 428 197 429 184 b 501 73 429 114 452 73 b 575 147 541 73 575 107 b 490 219 575 196 534 219 b 438 233 464 219 451 220 l 432 239 b 412 271 419 252 412 261 b 458 308 412 300 432 308 l 465 308 b 516 281 487 308 495 301 b 582 252 533 264 554 252 b 648 324 625 252 648 285 b 582 396 648 363 625 396 z m 324 271 b 271 324 291 271 271 291 b 324 377 271 357 291 377 b 377 324 357 377 377 357 b 324 271 377 291 357 271 z"
                },
                pictChokeCymbal: {
                    x_min: 1,
                    x_max: 152,
                    y_min: 2,
                    y_max: 251,
                    ha: 249,
                    o: "m 104 361 b 1 271 42 361 1 321 b 82 190 1 222 35 190 b 122 160 118 190 122 160 b 125 144 124 154 125 150 b 102 88 125 124 115 105 b 37 32 78 56 40 35 b 26 17 32 29 26 26 l 27 16 b 37 3 29 6 33 3 b 181 102 85 3 158 66 b 219 239 210 147 219 197 l 219 249 b 104 361 219 317 170 361 z"
                },
                wiggleArpeggiatoUp: {
                    x_min: -33,
                    x_max: 292,
                    y_min: 0,
                    y_max: 119,
                    ha: 119,
                    o: "m 130 171 b -39 68 16 171 -14 91 b -48 53 -45 62 -48 58 b -29 42 -48 46 -39 42 b -10 46 -23 42 -16 43 b 56 63 12 56 29 63 b 248 0 121 63 135 0 b 419 127 361 0 410 104 b 420 132 420 130 420 131 b 412 140 420 137 416 140 b 386 130 403 140 392 134 b 334 107 367 117 353 107 b 318 108 330 107 324 107 b 240 138 289 112 265 128 b 130 171 209 153 168 171 z"
                },
                arrowheadBlackUp: {
                    x_min: 0,
                    x_max: 228,
                    y_min: 0,
                    y_max: 299,
                    ha: 299,
                    o: "m 166 431 b 0 20 111 274 0 30 b 16 0 0 12 6 0 l 17 1 b 166 50 43 16 160 50 b 310 1 171 50 289 13 l 311 0 b 328 20 321 0 328 12 b 166 431 328 30 220 274 z"
                },
                arrowheadBlackDown: {
                    x_min: 0,
                    x_max: 228,
                    y_min: 0,
                    y_max: 299,
                    ha: 299,
                    o: "m 166 0 b 328 410 220 157 328 400 b 311 431 328 419 321 431 l 310 429 b 166 380 289 418 171 380 b 17 429 160 380 43 415 l 16 431 b 0 410 6 431 0 419 b 166 0 0 400 111 157 z"
                },
                arpeggiatoUp: {
                    x_min: 1,
                    x_max: 229,
                    y_min: 7,
                    y_max: 1511,
                    ha: 1504,
                    o: "m 219 1848 l 330 1848 l 164 2176 l 1 1848 l 121 1848 b 92 1778 115 1822 101 1800 l 89 1773 b 59 1668 75 1741 59 1702 b 96 1555 59 1614 76 1580 b 99 1551 98 1554 99 1551 l 102 1547 b 124 1496 115 1531 124 1515 b 122 1482 124 1492 124 1488 b 92 1404 118 1453 102 1428 b 59 1293 78 1372 59 1332 b 105 1172 59 1234 81 1198 b 124 1120 118 1155 124 1143 l 122 1113 b 122 1110 122 1113 122 1112 b 92 1032 118 1081 102 1057 b 59 922 78 1001 59 960 b 115 792 59 855 86 816 b 124 760 121 782 124 773 b 122 744 124 756 124 750 b 92 667 118 716 102 693 b 59 556 78 635 59 595 b 108 433 59 495 82 458 b 124 389 117 420 124 408 b 122 374 124 384 124 379 b 92 298 118 346 102 323 l 89 292 b 59 186 75 261 59 222 b 163 19 59 73 140 42 b 177 10 168 13 173 10 b 189 29 184 10 189 19 b 184 48 189 35 187 42 b 167 114 174 69 167 85 b 230 305 167 179 229 193 b 181 423 230 357 209 396 b 167 484 173 442 167 458 b 230 675 167 547 229 563 b 179 796 230 729 206 769 b 167 850 171 812 167 827 b 230 1040 167 913 229 929 b 183 1158 230 1092 209 1130 b 167 1220 173 1178 167 1194 b 230 1411 167 1284 229 1300 b 186 1526 230 1462 210 1499 b 167 1594 176 1529 167 1584 b 230 1786 167 1659 229 1673 b 219 1848 230 1809 226 1829 z"
                },
                arpeggiatoDown: {
                    x_min: 1,
                    x_max: 229,
                    y_min: -4,
                    y_max: 1500,
                    ha: 1504,
                    o: "m 219 323 b 230 384 226 341 230 361 b 167 576 229 497 167 511 b 186 644 167 586 176 641 b 230 759 210 671 230 708 b 167 950 229 870 167 886 b 183 1012 167 976 173 992 b 230 1130 209 1040 230 1079 b 167 1320 229 1241 167 1257 b 179 1374 167 1344 171 1358 b 230 1495 206 1401 230 1441 b 167 1686 229 1607 167 1623 b 181 1747 167 1712 173 1728 b 230 1865 209 1774 230 1813 b 167 2056 229 1977 167 1992 b 184 2123 167 2085 174 2101 b 189 2141 187 2128 189 2136 b 177 2160 189 2151 184 2160 b 163 2151 173 2160 168 2157 b 59 1984 140 2128 59 2097 b 89 1878 59 1948 75 1909 l 92 1872 b 122 1796 102 1848 118 1824 b 124 1781 124 1791 124 1786 b 108 1737 124 1763 117 1750 b 59 1614 82 1712 59 1675 b 92 1503 59 1575 78 1535 b 122 1426 102 1477 118 1454 b 124 1410 124 1420 124 1414 b 115 1378 124 1397 121 1388 b 59 1248 86 1354 59 1315 b 92 1138 59 1210 78 1169 b 122 1060 102 1113 118 1089 b 122 1057 122 1058 122 1058 l 124 1050 b 105 998 124 1027 118 1015 b 59 877 81 972 59 936 b 92 766 59 838 78 798 b 122 688 102 742 118 717 b 124 674 124 683 124 678 b 102 624 124 655 115 639 l 99 619 b 96 615 99 619 98 616 b 59 503 76 590 59 556 b 89 397 59 468 75 429 l 92 392 b 121 323 101 370 115 348 l 1 323 l 164 -6 l 330 323 z"
                },
                repeat1Bar: {
                    x_min: 0,
                    x_max: 532,
                    y_min: -250,
                    y_max: 279,
                    ha: 529,
                    o: "m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z m 89 288 b 0 197 40 288 0 248 b 89 108 0 148 40 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 z m 675 -71 b 586 -161 626 -71 586 -111 b 675 -251 586 -210 626 -251 b 766 -161 726 -251 766 -210 b 675 -71 766 -111 726 -71 z"
                },
                repeat2Bars: {
                    x_min: 0,
                    x_max: 762,
                    y_min: -250,
                    y_max: 279,
                    ha: 529,
                    o: "m 1090 380 b 1097 395 1094 386 1097 390 b 1089 402 1097 399 1094 402 l 936 402 b 910 380 927 402 920 393 l 336 -340 b 331 -350 333 -343 331 -347 b 343 -360 331 -356 336 -360 l 485 -360 b 516 -340 498 -360 508 -348 z m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z m 89 288 b 0 197 40 288 0 248 b 89 108 0 148 40 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 z m 1007 -71 b 917 -161 958 -71 917 -111 b 1007 -251 917 -210 958 -251 b 1097 -161 1057 -251 1097 -210 b 1007 -71 1097 -111 1057 -71 z"
                },
                repeat4Bars: {
                    x_min: 0,
                    x_max: 1232,
                    y_min: -250,
                    y_max: 279,
                    ha: 529,
                    o: "m 1767 380 b 1774 395 1771 386 1774 390 b 1765 402 1774 399 1771 402 l 1613 402 b 1587 380 1604 402 1597 393 l 1012 -340 b 1008 -350 1009 -343 1008 -347 b 1020 -360 1008 -356 1012 -360 l 1162 -360 b 1192 -340 1175 -360 1185 -348 z m 1436 380 b 1443 395 1440 386 1443 390 b 1434 402 1443 399 1440 402 l 1282 402 b 1256 380 1273 402 1266 393 l 681 -340 b 677 -350 678 -343 677 -347 b 688 -360 677 -356 681 -360 l 831 -360 b 861 -340 844 -360 854 -348 z m 1090 380 b 1097 395 1094 386 1097 390 b 1089 402 1097 399 1094 402 l 936 402 b 910 380 927 402 920 393 l 336 -340 b 331 -350 333 -343 331 -347 b 343 -360 331 -356 336 -360 l 485 -360 b 516 -340 498 -360 508 -348 z m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z m 89 288 b 0 197 40 288 0 248 b 89 108 0 148 40 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 z m 1683 -71 b 1594 -161 1634 -71 1594 -111 b 1683 -251 1594 -210 1634 -251 b 1774 -161 1734 -251 1774 -210 b 1683 -71 1774 -111 1734 -71 z"
                },
                repeatBarSlash: {
                    x_min: 0,
                    x_max: 532,
                    y_min: -250,
                    y_max: 279,
                    ha: 529,
                    o: "m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z"
                },
                csymDiminished: {
                    x_min: 0,
                    x_max: 473,
                    y_min: 0,
                    y_max: 473,
                    ha: 473,
                    o: "m 341 681 b 0 341 153 681 0 530 b 341 0 0 153 153 0 b 681 341 530 0 681 153 b 341 681 681 530 530 681 z m 341 618 b 618 341 495 618 618 495 b 341 63 618 189 494 63 b 63 341 187 63 63 187 b 341 618 63 494 189 618 z"
                },
                csymHalfDiminished: {
                    x_min: -16,
                    x_max: 488,
                    y_min: -15,
                    y_max: 489,
                    ha: 504,
                    o: "m 703 660 l 658 704 l 557 603 b 340 681 498 652 422 681 b -1 341 151 681 -1 530 b 78 124 -1 259 29 183 l -23 23 l 22 -22 l 122 79 b 340 0 181 30 258 0 b 680 341 528 0 680 153 b 602 559 680 423 651 500 z m 62 341 b 340 618 62 494 187 618 b 513 559 403 618 464 598 l 122 168 b 62 341 84 217 62 278 z m 616 341 b 340 63 616 189 492 63 b 167 124 276 63 216 85 l 557 514 b 616 341 596 465 616 405 z"
                },
                csymAugmented: {
                    x_min: 0,
                    x_max: 395,
                    y_min: 1,
                    y_max: 396,
                    ha: 395,
                    o: "m 569 318 l 317 318 l 317 570 l 253 570 l 253 318 l 0 318 l 0 255 l 253 255 l 253 1 l 317 1 l 317 255 l 569 255 z"
                },
                csymMajorSeventh: {
                    x_min: 0,
                    x_max: 558,
                    y_min: 1,
                    y_max: 477,
                    ha: 476,
                    o: "m 402 687 l 0 1 l 804 1 z m 402 562 l 693 65 l 111 65 z"
                },
                csymMinor: {
                    x_min: 0,
                    x_max: 325,
                    y_min: 216,
                    y_max: 260,
                    ha: 44,
                    o: "m 468 374 l 0 374 l 0 311 l 468 311 z"
                },
                csymParensLeftTall: {
                    x_min: 1,
                    x_max: 185,
                    y_min: 0,
                    y_max: 997,
                    ha: 997,
                    o: "m 266 48 b 261 65 266 55 264 62 b 92 719 157 212 92 400 b 262 1371 92 1037 154 1228 b 266 1394 266 1378 266 1394 l 266 1424 b 264 1436 266 1431 266 1436 b 259 1434 262 1436 259 1434 b 1 719 84 1261 1 1011 b 259 1 1 429 79 177 b 264 0 261 0 262 0 b 266 9 265 0 266 6 z"
                },
                csymParensRightTall: {
                    x_min: -20,
                    x_max: 164,
                    y_min: 0,
                    y_max: 997,
                    ha: 997,
                    o: "m -29 9 b -26 0 -29 6 -27 0 b -22 1 -24 0 -23 0 b 236 719 158 177 236 429 b -22 1434 236 1011 154 1261 b -26 1436 -22 1434 -24 1436 b -29 1424 -29 1436 -29 1431 l -29 1394 b -24 1371 -29 1394 -29 1378 b 145 719 84 1228 145 1037 b -23 65 145 400 81 212 b -29 48 -26 62 -29 55 z"
                },
                csymBracketLeftTall: {
                    x_min: 0,
                    x_max: 155,
                    y_min: 0,
                    y_max: 1e3,
                    ha: 1e3,
                    o: "m 217 0 b 223 9 220 0 223 4 l 223 37 b 217 46 223 42 220 46 l 92 46 l 92 1394 l 217 1394 b 223 1403 220 1394 223 1398 l 223 1431 b 217 1440 223 1436 220 1440 l 6 1440 b 0 1436 3 1440 0 1439 l 0 4 b 6 0 0 1 3 0 z"
                },
                csymBracketRightTall: {
                    x_min: 1,
                    x_max: 156,
                    y_min: 0,
                    y_max: 1e3,
                    ha: 1e3,
                    o: "m 219 0 b 225 4 222 0 225 1 l 225 1436 b 219 1440 225 1439 222 1440 l 7 1440 b 1 1431 4 1440 1 1436 l 1 1403 b 7 1394 1 1398 4 1394 l 132 1394 l 132 46 l 7 46 b 1 37 4 46 1 42 l 1 9 b 7 0 1 4 4 0 z"
                },
                csymParensLeftVeryTall: {
                    x_min: 0,
                    x_max: 122,
                    y_min: 0,
                    y_max: 993,
                    ha: 993,
                    o: "m 176 32 b 171 49 176 39 174 46 b 60 716 104 194 60 399 b 173 1382 60 1032 101 1241 b 176 1405 176 1390 176 1405 l 176 1427 b 173 1430 176 1428 174 1430 b 0 716 40 1297 0 978 b 170 3 0 428 50 179 b 171 0 170 1 170 0 b 176 6 173 0 176 4 z"
                },
                csymParensRightVeryTall: {
                    x_min: -15,
                    x_max: 107,
                    y_min: 0,
                    y_max: 993,
                    ha: 993,
                    o: "m -22 6 b -17 0 -22 4 -19 0 b -16 3 -16 0 -16 1 b 154 716 104 179 154 428 b -19 1430 154 978 114 1297 b -22 1427 -20 1430 -22 1428 l -22 1405 b -19 1382 -22 1405 -22 1390 b 94 716 53 1241 94 1032 b -17 49 94 399 50 194 b -22 32 -20 46 -22 39 z"
                },
                csymDiagonalArrangementSlash: {
                    x_min: 0,
                    x_max: 999,
                    y_min: 0,
                    y_max: 1e3,
                    ha: 1e3,
                    o: "m 1439 1380 l 1377 1440 l 0 60 l 62 0 z"
                },
                accSagittal5v7KleismaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -35 b 135 -112 68 -86 99 -112 b 225 68 194 -112 225 -53 l 180 68 b 144 -4 180 20 168 -4 b 122 0 138 -4 131 -3 b 23 248 86 14 52 96 l 0 248 z"
                },
                accSagittal5v7KleismaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 b 122 0 52 -96 86 -14 b 144 4 131 3 138 4 b 180 -68 168 4 180 -20 l 225 -68 b 135 112 225 53 194 112 b 45 35 99 112 68 86 l 45 517 l 0 517 z"
                },
                accSagittal5CommaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 225 -517 l 225 248 l 203 248 l 0 -112 l 0 -284 l 180 33 l 180 -517 z"
                },
                accSagittal5CommaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 180 517 l 180 -33 l 0 284 l 0 112 l 203 -248 l 225 -248 l 225 517 z"
                },
                accSagittal7CommaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 248 l 0 -517 l 45 -517 l 45 112 l 89 112 b 180 -68 150 112 180 53 l 180 -248 l 225 -248 l 225 68 b 135 248 225 187 194 248 z"
                },
                accSagittal7CommaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 135 -248 b 225 -68 194 -248 225 -187 l 225 248 l 180 248 l 180 68 b 89 -112 180 -53 150 -112 l 45 -112 l 45 517 l 0 517 l 0 -248 z"
                },
                accSagittal25SmallDiesisUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -157 l 0 -259 l 315 -89 l 315 -517 l 360 -517 l 360 248 l 337 248 l 0 68 l 0 -33 l 315 135 l 315 10 z"
                },
                accSagittal25SmallDiesisDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 315 -10 l 315 -135 l 0 33 l 0 -68 l 337 -248 l 360 -248 l 360 517 l 315 517 l 315 89 l 0 259 l 0 157 z"
                },
                accSagittal35MediumDiesisUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -68 330 112 360 53 l 360 -248 l 405 -248 l 405 68 b 315 248 405 187 374 248 l 203 248 l 0 -112 z"
                },
                accSagittal35MediumDiesisDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 203 -248 l 315 -248 b 405 -68 374 -248 405 -187 l 405 248 l 360 248 l 360 68 b 271 -112 360 -53 330 -112 l 225 -112 l 225 517 l 180 517 l 180 -33 l 0 284 z"
                },
                accSagittal11MediumDiesisUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 225 53 l 225 -517 l 271 -517 l 271 53 l 495 -248 l 495 -89 l 248 248 l 0 -89 l 0 -248 z"
                },
                accSagittal11MediumDiesisDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 248 l 0 89 l 248 -248 l 495 89 l 495 248 l 271 -53 l 271 517 l 225 517 l 225 -53 z"
                },
                accSagittal11LargeDiesisUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 112 l 315 112 b 449 -68 405 112 449 53 l 449 -248 l 495 -248 l 495 68 b 360 248 495 187 449 248 l 135 248 b 0 68 45 248 0 187 z"
                },
                accSagittal11LargeDiesisDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 135 -248 0 -187 45 -248 l 360 -248 b 495 -68 449 -248 495 -187 l 495 248 l 449 248 l 449 68 b 315 -112 449 -53 405 -112 l 271 -112 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittal35LargeDiesisUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 135 -248 0 -187 45 -248 l 248 -248 l 540 112 l 540 274 l 271 -58 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittal35LargeDiesisDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 135 -248 0 -187 45 -248 l 248 -248 l 540 112 l 540 274 l 269 -58 l 269 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittalSharp25SDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 112 -112 0 -53 36 -112 l 135 -112 l 135 -517 l 180 -517 l 180 -89 b 248 26 206 -65 229 -27 b 315 -89 264 -27 287 -65 l 315 -517 l 360 -517 l 360 -112 l 383 -112 b 495 68 458 -112 495 -53 l 449 68 b 399 -4 449 20 433 -4 b 248 248 297 -4 261 171 b 122 0 216 96 176 14 b 94 -4 112 -3 102 -4 b 45 68 60 -4 45 20 z"
                },
                accSagittalFlat25SUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 94 4 45 -20 60 4 b 122 0 102 4 112 3 b 248 -248 176 -14 216 -96 b 399 4 261 -171 297 4 b 449 -68 433 4 449 -20 l 495 -68 b 383 112 495 53 458 112 l 360 112 l 360 517 l 315 517 l 315 89 b 248 -26 287 65 264 27 b 180 89 229 27 206 65 l 180 517 l 135 517 l 135 112 l 112 112 b 0 -68 36 112 0 53 z"
                },
                accSagittalSharp7CDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 112 l 89 112 b 180 104 124 112 154 109 l 180 -517 l 225 -517 l 225 89 b 315 -68 285 60 315 9 l 315 -248 l 360 -248 l 360 68 b 135 248 360 187 285 248 l 0 248 z"
                },
                accSagittalFlat7CUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 135 -248 b 360 -68 285 -248 360 -187 l 360 248 l 315 248 l 315 68 b 225 -89 315 -9 285 -60 l 225 517 l 180 517 l 180 -104 b 89 -112 154 -109 124 -112 l 45 -112 l 45 517 l 0 517 z"
                },
                accSagittalSharp5CDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -517 l 45 71 l 180 -56 l 180 -517 l 225 -517 l 225 -98 l 405 -268 l 405 -112 l 23 248 l 0 248 l 0 -517 z"
                },
                accSagittalFlat5CUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 517 l 0 -248 l 23 -248 l 405 112 l 405 268 l 225 98 l 225 517 l 180 517 l 180 56 l 45 -71 l 45 517 z"
                },
                accSagittalSharp5v7kDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -276 l 135 -82 l 135 -517 l 180 -517 l 180 -17 l 271 112 l 315 112 l 315 -517 l 360 -517 l 360 107 b 449 -68 420 89 449 30 l 449 -248 l 495 -248 l 495 68 b 360 248 495 189 449 248 l 248 248 z"
                },
                accSagittalFlat5v7kUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 248 -248 l 360 -248 b 495 -68 449 -248 495 -189 l 495 248 l 449 248 l 449 68 b 360 -107 449 -30 420 -89 l 360 517 l 315 517 l 315 -112 l 271 -112 l 180 17 l 180 517 l 135 517 l 135 82 l 0 276 l 0 112 z"
                },
                accSagittalSharp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 180 -53 l 180 -517 l 225 -517 l 225 0 l 292 85 l 360 0 l 360 -517 l 405 -517 l 405 -53 l 585 -274 l 585 -112 l 292 248 l 0 -112 l 0 -274 z"
                },
                accSagittalFlat: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 274 l 0 112 l 292 -248 l 585 112 l 585 274 l 405 53 l 405 517 l 360 517 l 360 0 l 292 -85 l 225 0 l 225 517 l 180 517 l 180 53 z"
                },
                accSagittalSharp5v7kUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -361,
                    y_max: 172,
                    ha: 533,
                    o: "m 45 -517 l 45 -10 b 135 -92 68 -48 98 -75 l 135 -520 l 180 -520 l 180 -108 b 248 -115 203 -112 225 -115 b 271 -112 256 -115 264 -115 l 271 -517 l 315 -517 l 315 -107 b 449 68 405 -89 449 -30 l 405 68 b 297 -4 405 19 369 -4 b 23 248 131 -4 56 85 l 0 248 l 0 -517 z"
                },
                accSagittalFlat5v7kDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 361,
                    ha: 533,
                    o: "m 0 517 l 0 -248 l 23 -248 b 297 4 56 -85 131 4 b 405 -68 369 4 405 -19 l 449 -68 b 315 107 449 30 405 89 l 315 517 l 271 517 l 271 112 b 248 115 264 115 256 115 b 180 108 225 115 203 112 l 180 520 l 135 520 l 135 92 b 45 10 98 75 68 48 l 45 517 z"
                },
                accSagittalSharp5CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -266 l 135 -153 l 135 -517 l 180 -517 l 180 -115 l 271 -39 l 271 -517 l 315 -517 l 315 0 l 405 75 l 405 -517 l 449 -517 l 449 248 l 428 248 l 0 -112 z"
                },
                accSagittalFlat5CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 428 -248 l 449 -248 l 449 517 l 405 517 l 405 -75 l 315 0 l 315 517 l 271 517 l 271 39 l 180 115 l 180 517 l 135 517 l 135 153 l 0 266 z"
                },
                accSagittalSharp7CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 112 l 135 112 l 135 -517 l 180 -517 l 180 108 b 271 89 213 105 243 99 l 271 -517 l 315 -517 l 315 73 b 405 -68 374 45 405 -3 l 405 -248 l 449 -248 l 449 68 b 135 248 449 187 346 248 l 0 248 z"
                },
                accSagittalFlat7CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 135 -248 b 449 -68 346 -248 449 -187 l 449 248 l 405 248 l 405 68 b 315 -73 405 3 374 -45 l 315 517 l 271 517 l 271 -89 b 180 -108 243 -99 213 -105 l 180 517 l 135 517 l 135 -112 l 45 -112 l 45 517 l 0 517 z"
                },
                accSagittalSharp25SUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -30 l 495 143 l 495 14 l 0 -157 l 0 -255 l 225 -177 l 225 -517 l 271 -517 l 271 -161 l 360 -130 l 360 -517 l 405 -517 l 405 -115 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 517 248 l 0 68 z"
                },
                accSagittalFlat25SDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 l 517 -248 l 540 -248 l 540 517 l 495 517 l 495 84 l 405 115 l 405 517 l 360 517 l 360 130 l 271 161 l 271 517 l 225 517 l 225 177 l 0 255 l 0 157 l 495 -14 l 495 -143 l 0 30 z"
                },
                accSagittalSharp35MUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -274 l 135 -108 l 135 -517 l 180 -517 l 180 -53 l 271 58 l 271 -517 l 315 -517 l 315 112 l 360 112 b 405 109 376 112 390 112 l 405 -517 l 449 -517 l 449 96 b 540 -68 510 72 540 17 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 z"
                },
                accSagittalFlat35MDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 292 -248 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 449 -96 540 -17 510 -72 l 449 517 l 405 517 l 405 -109 b 360 -112 390 -112 376 -112 l 315 -112 l 315 517 l 271 517 l 271 -58 l 180 53 l 180 517 l 135 517 l 135 108 l 0 274 l 0 112 z"
                },
                accSagittalSharp11MUp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -271 l 180 -79 l 180 -517 l 225 -517 l 225 -30 l 315 65 l 315 -517 l 360 -517 l 360 65 l 449 -30 l 449 -517 l 495 -517 l 495 -79 l 675 -271 l 675 -112 l 337 248 z"
                },
                accSagittalFlat11MDown: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 337 -248 l 675 112 l 675 271 l 495 79 l 495 517 l 449 517 l 449 30 l 360 -65 l 360 517 l 315 517 l 315 -65 l 225 30 l 225 517 l 180 517 l 180 79 l 0 271 l 0 112 z"
                },
                accSagittalSharp11LUp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 112 l 449 112 l 449 -517 l 495 -517 l 495 104 b 631 -68 585 82 631 26 l 631 -248 l 675 -248 l 675 68 b 449 248 675 187 600 248 l 225 248 b 0 68 75 248 0 187 z"
                },
                accSagittalFlat11LDown: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 225 -248 0 -187 75 -248 l 449 -248 b 675 -68 600 -248 675 -187 l 675 248 l 631 248 l 631 68 b 495 -104 631 -26 585 -82 l 495 517 l 449 517 l 449 -112 l 360 -112 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
                },
                accSagittalSharp35LUp: {
                    x_min: 0,
                    x_max: 500,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 71 l 452 -17 l 452 -517 l 495 -517 l 495 -56 l 720 -268 l 720 -112 l 337 248 l 225 248 b 0 68 75 248 0 187 z"
                },
                accSagittalFlat35LDown: {
                    x_min: 0,
                    x_max: 500,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 225 -248 0 -187 75 -248 l 337 -248 l 720 112 l 720 268 l 495 56 l 495 517 l 452 517 l 452 17 l 360 -71 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
                },
                accSagittalDoubleSharp25SDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 135 -112 0 -53 45 -112 b 243 -62 180 -112 215 -95 l 89 -503 l 143 -517 l 292 -82 l 445 -517 l 495 -503 l 343 -62 b 449 -112 372 -95 408 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 315 148 b 112 -4 274 148 236 -4 b 45 68 68 -4 45 20 z"
                },
                accSagittalDoubleFlat25SUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 112 4 45 -20 68 4 b 292 -248 236 4 274 -148 b 475 4 315 -148 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 b 343 62 408 112 372 95 l 495 503 l 445 517 l 292 82 l 143 517 l 89 503 l 243 62 b 135 112 215 95 180 112 b 0 -68 45 112 0 53 z"
                },
                accSagittalDoubleSharp7CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -503 l 52 -517 l 203 -82 l 354 -517 l 405 -503 l 230 0 l 271 108 b 495 -68 420 92 495 35 l 495 -248 l 540 -248 l 540 68 b 225 248 540 187 435 248 l 89 248 l 89 112 l 135 112 l 174 0 z m 213 112 l 203 82 l 192 112 z"
                },
                accSagittalDoubleFlat7CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 174 0 l 135 -112 l 89 -112 l 89 -248 l 225 -248 b 540 -68 435 -248 540 -187 l 540 248 l 495 248 l 495 68 b 271 -108 495 -35 420 -92 l 230 0 l 405 503 l 354 517 l 203 82 l 52 517 l 0 503 z m 192 -112 l 203 -82 l 213 -112 z"
                },
                accSagittalDoubleSharp5CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 405 -503 l 230 0 l 232 4 l 585 -264 l 585 -112 l 112 248 l 89 248 l 89 112 l 151 68 l 174 0 l 0 -503 l 52 -517 l 203 -82 l 354 -517 z"
                },
                accSagittalDoubleFlat5CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 354 517 l 203 82 l 52 517 l 0 503 l 174 0 l 151 -68 l 89 -112 l 89 -248 l 112 -248 l 585 112 l 585 264 l 232 -4 l 230 0 l 405 503 z"
                },
                accSagittalDoubleSharp5v7kDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -274 l 252 35 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 360 112 b 540 -68 480 112 540 53 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 l 0 -112 z"
                },
                accSagittalDoubleFlat5v7kUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 292 -248 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 360 -112 540 -53 480 -112 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 252 -35 l 0 274 z"
                },
                accSagittalDoubleSharp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 540 -503 l 366 0 l 380 45 l 675 -271 l 675 -112 l 337 248 l 0 -112 l 0 -271 l 295 45 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 z"
                },
                accSagittalDoubleFlat: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 488 517 l 337 82 l 186 517 l 135 503 l 310 0 l 295 -45 l 0 271 l 0 112 l 337 -248 l 675 112 l 675 271 l 380 -45 l 366 0 l 540 503 z"
                },
                accSagittal7v11KleismaUp: {
                    x_min: 0,
                    x_max: 219,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 68 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 -45 b 248 -112 200 -89 225 -112 b 315 68 292 -112 315 -53 l 271 68 b 248 -4 271 20 264 -4 b 236 0 245 -4 240 -3 b 157 248 213 14 187 96 b 78 0 127 96 101 14 b 65 -4 73 -3 68 -4 b 45 68 50 -4 45 20 l 0 68 b 68 -112 0 -53 23 -112 z"
                },
                accSagittal7v11KleismaDown: {
                    x_min: 0,
                    x_max: 219,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 68 112 b 0 -68 23 112 0 53 l 45 -68 b 65 4 45 -20 50 4 b 78 0 68 4 73 3 b 157 -248 101 -14 127 -96 b 236 0 187 -96 213 -14 b 248 4 240 3 245 4 b 271 -68 264 4 271 -20 l 315 -68 b 248 112 315 53 292 112 b 180 45 225 112 200 89 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 z"
                },
                accSagittal17CommaUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 -40 b 315 -118 248 -92 279 -118 b 405 62 374 -118 405 -59 l 360 62 b 324 -10 360 14 348 -10 b 302 -6 318 -10 311 -9 b 206 217 268 9 235 84 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
                },
                accSagittal17CommaDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 206 -217 b 302 6 235 -84 268 -9 b 324 10 311 9 318 10 b 360 -62 348 10 360 -14 l 405 -62 b 315 118 405 59 374 118 b 225 40 279 118 248 92 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
                },
                accSagittal55CommaUp: {
                    x_min: 0,
                    x_max: 219,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 248 l 0 -517 l 45 -517 l 45 58 l 315 -274 l 315 -112 l 23 248 z"
                },
                accSagittal55CommaDown: {
                    x_min: 0,
                    x_max: 219,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 23 -248 l 315 112 l 315 274 l 45 -58 l 45 517 l 0 517 l 0 -248 z"
                },
                accSagittal7v11CommaUp: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 248 l 135 248 b 0 68 45 248 0 187 z"
                },
                accSagittal7v11CommaDown: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 135 -248 0 -187 45 -248 l 271 -248 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittal5v11SmallDiesisUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 73 l 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 -40 b 360 -118 295 -92 325 -118 b 449 62 420 -118 449 -59 l 405 62 b 369 -10 405 14 393 -10 b 348 -6 363 -10 356 -9 b 251 217 312 9 279 84 l 248 248 l 135 248 b 0 73 45 248 0 189 z"
                },
                accSagittal5v11SmallDiesisDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -73 b 135 -248 0 -189 45 -248 l 248 -248 l 251 -217 b 348 6 279 -84 312 -9 b 369 10 356 9 363 10 b 405 -62 393 10 405 -14 l 449 -62 b 360 118 449 59 420 118 b 271 40 325 118 295 92 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittalSharp5v11SDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 242 37 203 -23 225 -3 b 315 -89 262 -23 285 -63 l 315 -517 l 360 -517 l 360 -112 l 383 -112 b 495 68 458 -112 495 -53 l 449 68 b 399 -4 449 20 433 -4 b 248 248 297 -4 261 171 b 157 68 222 127 192 68 l 89 68 b 0 -203 30 68 0 -23 z"
                },
                accSagittalFlat5v11SUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 89 -68 0 23 30 -68 l 157 -68 b 248 -248 192 -68 222 -127 b 399 4 261 -171 297 4 b 449 -68 433 4 449 -20 l 495 -68 b 383 112 495 53 458 112 l 360 112 l 360 517 l 315 517 l 315 89 b 242 -37 285 63 262 23 b 180 23 225 3 203 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 84 z"
                },
                accSagittalSharp7v11CDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 89 -112 l 89 -517 l 135 -517 l 135 -95 b 206 37 163 -73 187 -30 b 271 -23 225 -3 248 -23 l 271 -517 l 315 -517 l 315 -23 l 383 -23 b 449 -203 428 -23 449 -84 l 495 -203 b 405 68 495 -23 465 68 l 292 68 b 203 248 258 68 228 127 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 20 l 0 68 b 89 -112 0 -52 30 -112 z"
                },
                accSagittalFlat7v11CUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 112 b 0 -68 30 112 0 52 l 45 -68 b 81 3 45 -20 56 3 b 101 0 86 3 94 0 b 203 -248 138 -16 173 -98 b 292 -68 228 -127 258 -68 l 405 -68 b 495 203 465 -68 495 23 l 449 203 b 383 23 449 84 428 23 l 315 23 l 315 517 l 271 517 l 271 23 b 206 -37 248 23 225 3 b 135 95 187 30 163 73 l 135 517 l 89 517 z"
                },
                accSagittalSharp55CDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -271 l 135 -125 l 135 -517 l 180 -517 l 180 -78 l 315 65 l 315 -517 l 360 -517 l 360 248 l 337 248 l 0 -112 z"
                },
                accSagittalFlat55CUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 337 -248 l 360 -248 l 360 517 l 315 517 l 315 -65 l 180 78 l 180 517 l 135 517 l 135 125 l 0 271 z"
                },
                accSagittalSharp17CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -248 l 45 -68 b 180 109 45 36 89 95 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -89 292 13 321 -55 l 360 -517 l 405 -517 l 405 -112 l 428 -112 b 540 68 504 -112 540 -53 l 495 68 b 445 -4 495 20 480 -4 b 292 248 343 -4 307 171 l 180 248 b 0 68 60 248 0 187 l 0 -248 z"
                },
                accSagittalFlat17CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 248 l 0 -68 b 180 -248 0 -187 60 -248 l 292 -248 b 445 4 307 -171 343 4 b 495 -68 480 4 495 -20 l 540 -68 b 428 112 540 53 504 112 l 405 112 l 405 517 l 360 517 l 360 89 b 271 -112 321 55 292 -13 l 225 -112 l 225 517 l 180 517 l 180 -109 b 45 68 89 -95 45 -36 l 45 248 z"
                },
                accSagittalSharp7v11kDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -32 l 405 138 l 405 13 l 0 -157 l 0 -256 l 225 -161 l 225 -517 l 271 -517 l 271 -144 l 405 -86 l 405 -517 l 449 -517 l 449 248 l 428 248 l 0 68 z"
                },
                accSagittalFlat7v11kUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 l 428 -248 l 449 -248 l 449 517 l 405 517 l 405 86 l 271 144 l 271 517 l 225 517 l 225 161 l 0 256 l 0 157 l 405 -13 l 405 -138 l 0 32 z"
                },
                accSagittalSharp7v11kUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 135 -112 l 135 -517 l 180 -517 l 180 -105 b 271 -23 217 -94 248 -65 l 271 -517 l 315 -517 l 315 -23 b 405 -105 337 -65 369 -94 l 405 -517 l 449 -517 l 449 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 315 148 b 112 -4 274 148 236 -4 b 45 68 68 -4 45 20 l 0 68 b 135 -112 0 -53 45 -112 z"
                },
                accSagittalFlat7v11kDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 135 112 b 0 -68 45 112 0 53 l 45 -68 b 112 4 45 -20 68 4 b 292 -248 236 4 274 -148 b 475 4 315 -148 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 l 449 517 l 405 517 l 405 105 b 315 23 369 94 337 65 l 315 517 l 271 517 l 271 23 b 180 105 248 65 217 94 l 180 517 l 135 517 z"
                },
                accSagittalSharp17CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 -23 b 405 -105 337 -65 369 -94 l 405 -517 l 449 -517 l 449 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 312 150 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalFlat17CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 b 475 4 312 -150 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 l 449 517 l 405 517 l 405 105 b 315 23 369 94 337 65 l 315 517 l 271 517 l 271 -14 b 203 23 251 10 229 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalSharp55CUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -517 l 45 78 l 135 10 l 135 -517 l 180 -517 l 180 -23 l 271 -92 l 271 -517 l 315 -517 l 315 -127 l 495 -264 l 495 -112 l 23 248 l 0 248 l 0 -517 z"
                },
                accSagittalFlat55CDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 517 l 0 -248 l 23 -248 l 495 112 l 495 264 l 315 127 l 315 517 l 271 517 l 271 92 l 180 23 l 180 517 l 135 517 l 135 -10 l 45 -78 l 45 517 z"
                },
                accSagittalSharp7v11CUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 86 45 6 89 58 l 180 -517 l 225 -517 l 225 98 b 315 109 252 104 282 108 l 315 -517 l 360 -517 l 360 112 l 449 112 l 449 -517 l 495 -517 l 495 248 l 360 248 b 0 68 121 248 0 189 z"
                },
                accSagittalFlat7v11CDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 360 -248 0 -189 121 -248 l 495 -248 l 495 517 l 449 517 l 449 -112 l 360 -112 l 360 517 l 315 517 l 315 -109 b 225 -98 282 -108 252 -104 l 225 517 l 180 517 l 180 -86 b 45 68 89 -58 45 -6 l 45 248 l 0 248 z"
                },
                accSagittalSharp5v11SUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 -23 b 449 -105 383 -65 415 -94 l 449 -517 l 495 -517 l 495 -112 b 631 68 585 -112 631 -53 l 585 68 b 520 -4 585 20 563 -4 b 337 248 396 -4 360 150 l 225 248 b 0 68 76 248 0 187 z"
                },
                accSagittalFlat5v11SDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 225 -248 0 -187 76 -248 l 337 -248 b 520 4 360 -150 396 4 b 585 -68 563 4 585 -20 l 631 -68 b 495 112 631 53 585 112 l 495 517 l 449 517 l 449 105 b 360 23 415 94 383 65 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
                },
                accSagittalDoubleSharp5v11SDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 341 -60 b 449 -112 370 -95 405 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 312 150 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalDoubleFlat5v11SUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 b 475 4 312 -150 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 b 341 60 405 112 370 95 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 262 -4 b 203 23 245 13 225 23 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalDoubleSharp7v11CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 112 -112 b 193 -73 143 -112 170 -99 l 45 -501 l 95 -517 l 248 -81 l 397 -517 l 449 -503 l 275 0 l 278 4 b 337 -23 295 -13 315 -23 l 405 -23 b 495 -203 465 -23 495 -84 l 540 -203 b 428 68 540 -23 503 68 l 360 68 b 248 248 310 68 271 127 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 112 -112 0 -52 36 -112 z"
                },
                accSagittalDoubleFlat7v11CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 112 112 b 0 -68 36 112 0 52 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 b 360 -68 271 -127 310 -68 l 428 -68 b 540 203 503 -68 540 23 l 495 203 b 405 23 495 84 465 23 l 337 23 b 278 -4 315 23 295 13 l 275 0 l 449 503 l 397 517 l 248 81 l 95 517 l 45 501 l 193 73 b 112 112 170 99 143 112 z"
                },
                accSagittalDoubleSharp55CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 428 248 l 0 -112 l 0 -266 l 307 -7 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 386 59 l 449 112 l 449 248 z"
                },
                accSagittalDoubleFlat55CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 449 -248 l 449 -112 l 386 -59 l 366 0 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 307 7 l 0 266 l 0 112 l 428 -248 z"
                },
                accSagittalDoubleSharp17CDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -248 l 45 -68 b 271 112 45 53 120 112 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 387 -62 b 495 -112 416 -95 452 -112 b 631 68 585 -112 631 -53 l 585 68 b 520 -4 585 20 563 -4 b 337 248 396 -4 360 150 l 225 248 b 0 68 76 248 0 187 l 0 -248 z"
                },
                accSagittalDoubleFlat17CUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 248 l 0 -68 b 225 -248 0 -187 76 -248 l 337 -248 b 520 4 360 -150 396 4 b 585 -68 563 4 585 -20 l 631 -68 b 495 112 631 53 585 112 b 387 62 452 112 416 95 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 310 0 l 271 -112 b 45 68 120 -112 45 -53 l 45 248 z"
                },
                accSagittalDoubleSharp7v11kDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -30 l 366 96 l 399 0 l 392 -23 l 0 -157 l 0 -255 l 353 -135 l 225 -503 l 276 -517 l 428 -82 l 579 -517 l 631 -503 l 455 0 l 507 145 l 540 157 l 540 248 l 517 248 z m 416 115 l 442 124 l 428 82 z"
                },
                accSagittalDoubleFlat7v11kUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 517 -248 l 540 -248 l 540 -157 l 507 -145 l 455 0 l 631 503 l 579 517 l 428 82 l 276 517 l 225 503 l 353 135 l 0 255 l 0 157 l 392 23 l 399 0 l 366 -96 l 0 30 l 0 -68 z m 428 -82 l 442 -124 l 416 -115 z"
                },
                accSagittal23CommaUp: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -4 b 68 -23 53 -17 60 -23 l 180 -23 b 225 -203 210 -23 225 -82 l 271 -203 b 206 68 271 -23 248 68 l 89 68 b 23 248 71 68 48 127 l 0 248 z"
                },
                accSagittal23CommaDown: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 b 89 -68 48 -127 71 -68 l 206 -68 b 271 203 248 -68 271 23 l 225 203 b 180 23 225 82 210 23 l 68 23 b 45 4 60 23 53 17 l 45 517 l 0 517 z"
                },
                accSagittal5v19CommaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 248 l 203 248 b 86 112 151 157 112 112 b 45 157 59 112 45 127 l 0 157 b 76 23 0 72 26 27 l 0 -112 z"
                },
                accSagittal5v19CommaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 76 -23 b 0 -157 26 -27 0 -72 l 45 -157 b 86 -112 45 -127 59 -112 b 203 -248 112 -112 151 -157 l 225 -248 l 225 517 l 180 517 l 180 -33 l 0 284 z"
                },
                accSagittal5v23SmallDiesisUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 -4 b 248 -23 233 -17 240 -23 l 360 -23 b 405 -203 390 -23 405 -82 l 449 -203 b 386 68 449 -23 428 68 l 271 68 b 203 248 251 68 228 127 l 0 -112 z"
                },
                accSagittal5v23SmallDiesisDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 203 -248 b 271 -68 228 -127 251 -68 l 386 -68 b 449 203 428 -68 449 23 l 405 203 b 360 23 405 82 390 23 l 248 23 b 225 4 240 23 233 17 l 225 517 l 180 517 l 180 -33 l 0 284 z"
                },
                accSagittalSharp5v23SDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 6 b 89 -23 59 -13 73 -23 l 180 -23 l 180 -517 l 225 -517 l 225 -23 l 292 -23 b 360 -203 337 -23 360 -84 l 405 -203 b 315 68 405 -23 374 68 l 112 68 b 23 248 78 68 48 127 l 0 248 z"
                },
                accSagittalFlat5v23SUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 b 112 -68 48 -127 78 -68 l 315 -68 b 405 203 374 -68 405 23 l 360 203 b 292 23 360 84 337 23 l 225 23 l 225 517 l 180 517 l 180 23 l 89 23 b 45 -6 73 23 59 13 l 45 517 l 0 517 z"
                },
                accSagittalSharp5v19CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 89 -112 0 -52 30 -112 l 89 -517 l 135 -517 l 135 -95 b 225 112 173 -65 203 4 l 271 112 l 271 -517 l 315 -517 l 315 107 b 405 -68 374 89 405 30 l 405 -248 l 449 -248 l 449 68 b 315 248 449 189 405 248 l 203 248 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 23 z"
                },
                accSagittalFlat5v19CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 81 3 45 -23 56 3 b 101 0 86 3 94 0 b 203 -248 138 -16 173 -98 l 315 -248 b 449 -68 405 -248 449 -189 l 449 248 l 405 248 l 405 68 b 315 -107 405 -30 374 -89 l 315 517 l 271 517 l 271 -112 l 225 -112 b 135 95 203 -4 173 65 l 135 517 l 89 517 l 89 112 b 0 -68 30 112 0 52 z"
                },
                accSagittalSharp23CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 135 -82 l 135 -517 l 180 -517 l 180 -17 l 239 68 b 315 -23 261 7 287 -23 l 315 -517 l 360 -517 l 360 -23 l 428 -23 b 495 -203 472 -23 495 -84 l 540 -203 b 449 68 540 -23 510 68 l 337 68 b 248 248 302 68 271 127 l 0 -112 l 0 -276 z"
                },
                accSagittalFlat23CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 276 l 0 112 l 248 -248 b 337 -68 271 -127 302 -68 l 449 -68 b 540 203 510 -68 540 23 l 495 203 b 428 23 495 84 472 23 l 360 23 l 360 517 l 315 517 l 315 23 b 239 -68 287 23 261 -7 l 180 17 l 180 517 l 135 517 l 135 82 z"
                },
                accSagittalSharp23CUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 14 b 112 -23 63 -10 86 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 360 -23 b 449 -203 420 -23 449 -84 l 495 -203 b 383 68 495 -23 458 68 l 135 68 b 23 248 85 68 48 127 l 0 248 z"
                },
                accSagittalFlat23CDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 b 135 -68 48 -127 85 -68 l 383 -68 b 495 203 458 -68 495 23 l 449 203 b 360 23 449 84 420 23 l 315 23 l 315 517 l 271 517 l 271 23 l 180 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 -14 86 23 63 10 l 45 517 l 0 517 z"
                },
                accSagittalSharp5v19CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -266 l 135 -153 l 135 -517 l 180 -517 l 180 -115 l 271 -39 l 271 -517 l 315 -517 l 315 0 l 405 75 l 405 -517 l 449 -517 l 449 248 l 428 248 b 130 68 285 127 186 68 b 45 157 73 68 45 98 l 0 157 b 112 -20 0 53 37 -6 z"
                },
                accSagittalFlat5v19CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 112 20 b 0 -157 37 6 0 -53 l 45 -157 b 130 -68 45 -98 73 -68 b 428 -248 186 -68 285 -127 l 449 -248 l 449 517 l 405 517 l 405 -75 l 315 0 l 315 517 l 271 517 l 271 39 l 180 115 l 180 517 l 135 517 l 135 153 l 0 266 l 0 112 z"
                },
                accSagittalSharp5v23SUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 135 -108 l 135 -517 l 180 -517 l 180 -53 l 271 58 l 271 -517 l 315 -517 l 315 14 b 383 -23 334 -10 357 -23 l 405 -23 l 405 -517 l 449 -517 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 405 68 b 292 248 356 68 318 127 l 0 -112 l 0 -274 z"
                },
                accSagittalFlat5v23SDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 274 l 0 112 l 292 -248 b 405 -68 318 -127 356 -68 l 472 -68 b 585 203 547 -68 585 23 l 540 203 b 449 23 540 84 510 23 l 449 517 l 405 517 l 405 23 l 383 23 b 315 -14 357 23 334 10 l 315 517 l 271 517 l 271 -58 l 180 53 l 180 517 l 135 517 l 135 108 z"
                },
                accSagittalDoubleSharp5v23SDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 52 -517 l 203 -81 l 354 -517 l 405 -503 l 239 -23 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 225 68 b 112 248 176 68 138 127 l 89 248 l 89 112 b 170 -14 109 45 135 0 l 0 -501 z"
                },
                accSagittalDoubleFlat5v23SUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 501 l 170 14 b 89 -112 135 0 109 -45 l 89 -248 l 112 -248 b 225 -68 138 -127 176 -68 l 472 -68 b 585 203 547 -68 585 23 l 540 203 b 449 23 540 84 510 23 l 239 23 l 405 503 l 354 517 l 203 81 l 52 517 z"
                },
                accSagittalDoubleSharp5v19CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 112 -112 0 -52 36 -112 b 193 -73 143 -112 170 -99 l 45 -501 l 95 -517 l 248 -81 l 397 -517 l 449 -501 l 275 0 l 315 112 b 495 -68 435 112 495 53 l 495 -248 l 540 -248 l 540 68 b 360 248 540 189 480 248 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 z"
                },
                accSagittalDoubleFlat5v19CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 l 360 -248 b 540 -68 480 -248 540 -189 l 540 248 l 495 248 l 495 68 b 315 -112 495 -53 435 -112 l 275 0 l 449 501 l 397 517 l 248 81 l 95 517 l 45 501 l 193 73 b 112 112 170 99 143 112 b 0 -68 36 112 0 52 z"
                },
                accSagittalDoubleSharp23CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 252 35 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 323 4 b 383 -23 340 -13 360 -23 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 405 68 b 292 248 356 68 318 127 l 0 -112 l 0 -274 z"
                },
                accSagittalDoubleFlat23CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 274 l 0 112 l 292 -248 b 405 -68 318 -127 356 -68 l 472 -68 b 585 203 547 -68 585 23 l 540 203 b 449 23 540 84 510 23 l 383 23 b 323 -4 360 23 340 13 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 252 -35 z"
                },
                accSagittal19SchismaUp: {
                    x_min: 0,
                    x_max: 125,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 68 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 248 l 157 248 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 l 0 68 b 68 -112 0 -52 23 -112 z"
                },
                accSagittal19SchismaDown: {
                    x_min: 0,
                    x_max: 125,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 68 112 b 0 -68 23 112 0 52 l 45 -68 b 68 3 45 -20 52 3 b 79 0 68 3 73 0 b 157 -248 101 -16 127 -98 l 180 -248 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 z"
                },
                accSagittal17KleismaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 248 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
                },
                accSagittal17KleismaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 225 -248 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
                },
                accSagittal143CommaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -203 l 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 248 l 203 248 b 135 68 177 127 154 68 l 105 68 b 45 157 65 68 45 98 l 0 157 b 23 20 0 95 7 50 b 0 -203 7 -23 0 -98 z"
                },
                accSagittal143CommaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 23 -20 0 98 7 23 b 0 -157 7 -50 0 -95 l 45 -157 b 105 -68 45 -98 65 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 225 -248 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
                },
                accSagittal11v49CommaUp: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -292 b 89 -157 45 -203 60 -157 l 203 -157 b 225 -143 210 -157 217 -153 l 225 -517 l 271 -517 l 271 248 l 248 248 b 180 157 233 187 210 157 l 68 157 b 0 -68 23 157 0 82 l 45 -68 b 89 68 45 23 60 68 l 203 68 b 225 84 209 68 216 72 l 225 -36 b 180 -68 213 -58 199 -68 l 68 -68 b 0 -292 23 -68 0 -143 z"
                },
                accSagittal11v49CommaDown: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 292 b 68 68 0 143 23 68 l 180 68 b 225 36 199 68 213 58 l 225 -84 b 203 -68 216 -72 209 -68 l 89 -68 b 45 68 60 -68 45 -23 l 0 68 b 68 -157 0 -82 23 -157 l 180 -157 b 248 -248 210 -157 233 -187 l 271 -248 l 271 517 l 225 517 l 225 143 b 203 157 217 153 210 157 l 89 157 b 45 292 60 157 45 203 z"
                },
                accSagittal19CommaUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 68 -112 0 -52 23 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 -4 b 203 -23 187 -17 196 -23 l 315 -23 b 360 -203 346 -23 360 -82 l 405 -203 b 341 68 405 -23 383 68 l 225 68 b 157 248 206 68 183 127 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 z"
                },
                accSagittal19CommaDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 68 3 45 -20 52 3 b 79 0 68 3 73 0 b 157 -248 101 -16 127 -98 b 225 -68 183 -127 206 -68 l 341 -68 b 405 203 383 -68 405 23 l 360 203 b 315 23 360 82 346 23 l 203 23 b 180 4 196 23 187 17 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 b 0 -68 23 112 0 52 z"
                },
                accSagittal7v19CommaUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 68 -112 0 -52 23 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 112 l 225 112 b 315 -68 285 112 315 53 l 315 -248 l 360 -248 l 360 68 b 271 248 360 187 330 248 l 157 248 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 z"
                },
                accSagittal7v19CommaDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 68 3 45 -20 52 3 b 79 0 68 3 73 0 b 157 -248 101 -16 127 -98 l 271 -248 b 360 -68 330 -248 360 -187 l 360 248 l 315 248 l 315 68 b 225 -112 315 -53 285 -112 l 180 -112 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 b 0 -68 23 112 0 52 z"
                },
                accSagittal49SmallDiesisUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -203 l 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -68 330 112 360 53 l 360 -248 l 405 -248 l 405 68 b 315 248 405 187 374 248 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
                },
                accSagittal49SmallDiesisDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 315 -248 b 405 -68 374 -248 405 -187 l 405 248 l 360 248 l 360 68 b 271 -112 360 -53 330 -112 l 225 -112 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
                },
                accSagittal23SmallDiesisUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 58 l 495 -274 l 495 -112 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
                },
                accSagittal23SmallDiesisDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 495 112 l 495 274 l 225 -58 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
                },
                accSagittal5v13MediumDiesisUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -259 l 315 -89 l 315 -517 l 360 -517 l 360 248 l 337 248 b 128 180 253 203 184 180 b 45 248 73 180 45 203 l 0 248 b 52 95 0 170 17 120 l 0 68 l 0 -33 l 315 135 l 315 10 l 0 -157 z"
                },
                accSagittal5v13MediumDiesisDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 157 l 315 -10 l 315 -135 l 0 33 l 0 -68 l 52 -95 b 0 -248 17 -120 0 -170 l 45 -248 b 128 -180 45 -203 73 -180 b 337 -248 184 -180 253 -203 l 360 -248 l 360 517 l 315 517 l 315 89 l 0 259 z"
                },
                accSagittal11v19MediumDiesisUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 -4 b 292 -23 278 -17 285 -23 l 405 -23 b 449 -203 435 -23 449 -82 l 495 -203 b 431 68 495 -23 472 68 l 315 68 b 248 248 295 68 271 127 l 135 248 b 0 68 45 248 0 187 l 0 -248 z"
                },
                accSagittal11v19MediumDiesisDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 248 l 0 -68 b 135 -248 0 -187 45 -248 l 248 -248 b 315 -68 271 -127 295 -68 l 431 -68 b 495 203 472 -68 495 23 l 449 203 b 405 23 449 82 435 23 l 292 23 b 271 4 285 23 278 17 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 z"
                },
                accSagittal49MediumDiesisUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -68 l 0 -248 l 45 -248 l 315 -94 l 315 -517 l 360 -517 l 360 248 l 225 248 b 0 -68 75 248 0 143 z m 45 -68 b 225 112 45 53 105 112 l 315 112 l 315 10 l 45 -145 z"
                },
                accSagittal49MediumDiesisDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 68 b 225 -248 0 -143 75 -248 l 360 -248 l 360 517 l 315 517 l 315 94 l 45 248 l 0 248 z m 45 145 l 315 -10 l 315 -112 l 225 -112 b 45 68 105 -112 45 -53 z"
                },
                accSagittal5v49MediumDiesisUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -89 l 0 -248 l 225 53 l 225 -517 l 271 -517 l 271 53 l 495 -248 l 495 -89 l 248 248 b 89 89 170 143 118 89 b 45 157 60 89 45 112 l 0 157 b 68 3 0 68 23 16 z"
                },
                accSagittal5v49MediumDiesisDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 68 -3 b 0 -157 23 -16 0 -68 l 45 -157 b 89 -89 45 -112 60 -89 b 248 -248 118 -89 170 -143 l 495 89 l 495 248 l 271 -53 l 271 517 l 225 517 l 225 -53 l 0 248 l 0 89 z"
                },
                accSagittal49LargeDiesisUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -89 l 360 -248 l 405 -248 l 405 -68 b 180 248 405 143 330 248 l 0 248 z m 45 12 l 45 112 l 180 112 b 360 -68 300 112 360 53 l 360 -147 z"
                },
                accSagittal49LargeDiesisDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 180 -248 b 405 68 330 -248 405 -143 l 405 248 l 360 248 l 45 89 l 45 517 l 0 517 z m 360 147 l 360 68 b 180 -112 360 -53 300 -112 l 45 -112 l 45 -12 z"
                },
                accSagittal11v19LargeDiesisUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -86 l 449 -256 l 449 -157 l 45 13 l 45 138 l 449 -30 l 449 68 l 23 248 l 0 248 z"
                },
                accSagittal11v19LargeDiesisDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 l 449 -68 l 449 30 l 45 -138 l 45 -13 l 449 157 l 449 256 l 45 86 l 45 517 l 0 517 z"
                },
                accSagittal5v13LargeDiesisUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 89 -112 0 -52 30 -112 b 180 -35 125 -112 157 -86 l 180 -517 l 225 -517 l 225 -86 l 631 -256 l 631 -157 l 225 13 l 225 138 l 631 -30 l 631 68 l 203 248 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 20 z"
                },
                accSagittal5v13LargeDiesisDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 81 3 45 -20 56 3 b 101 0 86 3 94 0 b 203 -248 138 -16 173 -98 l 631 -68 l 631 30 l 225 -138 l 225 -13 l 631 157 l 631 256 l 225 86 l 225 517 l 180 517 l 180 35 b 89 112 157 86 125 112 b 0 -68 30 112 0 52 z"
                },
                accSagittalSharp23SDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -203 l 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 b 315 6 287 -23 301 -13 l 315 -517 l 360 -517 l 360 248 l 337 248 b 248 68 312 127 282 68 l 194 68 b 89 157 125 68 89 98 l 45 157 b 60 59 45 118 50 85 b 0 -203 20 30 0 -56 z"
                },
                accSagittalFlat23SUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 60 -59 0 56 20 -30 b 45 -157 50 -85 45 -118 l 89 -157 b 194 -68 89 -98 125 -68 l 248 -68 b 337 -248 282 -68 312 -127 l 360 -248 l 360 517 l 315 517 l 315 -6 b 271 23 301 13 287 23 l 180 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 84 z"
                },
                accSagittalSharp49SDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -292 l 45 -292 b 112 -157 45 -203 68 -157 l 135 -157 l 135 -517 l 180 -517 l 180 -157 l 271 -157 b 315 -135 285 -157 300 -150 l 315 -517 l 360 -517 l 360 248 l 337 248 b 248 157 323 187 292 157 l 89 157 b 0 -68 30 157 0 82 l 45 -68 b 112 68 45 23 68 68 l 271 68 b 315 89 284 68 300 75 l 315 -32 b 248 -68 298 -56 275 -68 l 89 -68 b 0 -292 29 -68 0 -143 z"
                },
                accSagittalFlat49SUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 292 b 89 68 0 143 29 68 l 248 68 b 315 32 275 68 298 56 l 315 -89 b 271 -68 300 -75 284 -68 l 112 -68 b 45 68 68 -68 45 -23 l 0 68 b 89 -157 0 -82 30 -157 l 248 -157 b 337 -248 292 -157 323 -187 l 360 -248 l 360 517 l 315 517 l 315 135 b 271 157 300 150 285 157 l 180 157 l 180 517 l 135 517 l 135 157 l 112 157 b 45 292 68 157 45 203 z"
                },
                accSagittalSharp7v19CDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -271 l 135 -125 l 135 -517 l 180 -517 l 180 -78 l 315 65 l 315 -517 l 360 -517 l 360 248 l 337 248 b 118 89 239 143 166 89 b 45 157 68 89 45 112 l 0 157 b 89 -20 0 53 29 -6 z"
                },
                accSagittalFlat7v19CUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 20 b 0 -157 29 6 0 -53 l 45 -157 b 118 -89 45 -112 68 -89 b 337 -248 166 -89 239 -143 l 360 -248 l 360 517 l 315 517 l 315 -65 l 180 78 l 180 517 l 135 517 l 135 125 l 0 271 l 0 112 z"
                },
                accSagittalSharp19CDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 180 96 45 17 89 72 l 180 -517 l 225 -517 l 225 107 b 315 112 252 112 282 112 l 360 112 l 360 -517 l 405 -517 l 405 248 l 271 248 b 0 68 89 248 0 187 z"
                },
                accSagittalFlat19CUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 271 -248 0 -187 89 -248 l 405 -248 l 405 517 l 360 517 l 360 -112 l 315 -112 b 225 -107 282 -112 252 -112 l 225 517 l 180 517 l 180 -96 b 45 68 89 -72 45 -17 l 45 248 l 0 248 z"
                },
                accSagittalSharp11v49CDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 112 -23 45 -82 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 271 112 215 -23 245 23 l 315 112 l 315 -517 l 360 -517 l 360 107 b 449 -68 420 89 449 30 l 449 -248 l 495 -248 l 495 68 b 360 248 495 189 449 248 l 248 248 b 157 68 222 128 192 68 l 89 68 b 0 -203 30 68 0 -23 z"
                },
                accSagittalFlat11v49CUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 89 -68 0 23 30 -68 l 157 -68 b 248 -248 192 -68 222 -128 l 360 -248 b 495 -68 449 -248 495 -189 l 495 248 l 449 248 l 449 68 b 360 -107 449 -30 420 -89 l 360 517 l 315 517 l 315 -112 l 271 -112 b 180 23 245 -23 215 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 82 z"
                },
                accSagittalSharp143CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 259 76 210 -23 236 10 l 315 17 l 315 -517 l 360 -517 l 360 -30 l 585 -271 l 585 -112 l 248 248 b 157 68 222 127 192 68 l 89 68 b 0 -203 30 68 0 -23 z"
                },
                accSagittalFlat143CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 89 -68 0 23 30 -68 l 157 -68 b 248 -248 192 -68 222 -127 l 585 112 l 585 271 l 360 30 l 360 517 l 315 517 l 315 -17 l 259 -76 b 180 23 236 -10 210 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 84 z"
                },
                accSagittalSharp17kDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -157 l 0 -256 l 225 -161 l 225 -517 l 271 -517 l 271 -144 l 405 -86 l 405 -517 l 449 -517 l 449 248 l 428 248 b 145 171 305 196 210 171 b 45 248 78 171 45 196 l 0 248 b 79 101 0 170 26 121 l 0 68 l 0 -32 l 405 138 l 405 13 z"
                },
                accSagittalFlat17kUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 405 -13 l 405 -138 l 0 32 l 0 -68 l 79 -101 b 0 -248 26 -121 0 -170 l 45 -248 b 145 -171 45 -196 78 -171 b 428 -248 210 -171 305 -196 l 449 -248 l 449 517 l 405 517 l 405 86 l 271 144 l 271 517 l 225 517 l 225 161 l 0 256 l 0 157 z"
                },
                accSagittalSharp19sDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 180 109 45 36 89 95 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -23 295 23 325 -23 l 360 -517 l 405 -517 l 405 -23 l 472 -23 b 540 -203 517 -23 540 -84 l 585 -203 b 495 68 585 -23 554 68 l 383 68 b 292 248 348 68 318 127 l 180 248 b 0 68 60 248 0 187 z"
                },
                accSagittalFlat19sUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 180 -248 0 -187 60 -248 l 292 -248 b 383 -68 318 -127 348 -68 l 495 -68 b 585 203 554 -68 585 23 l 540 203 b 472 23 540 84 517 23 l 405 23 l 405 517 l 360 517 l 360 23 b 271 -112 325 23 295 -23 l 225 -112 l 225 517 l 180 517 l 180 -109 b 45 68 89 -95 45 -36 l 45 248 l 0 248 z"
                },
                accSagittalSharp19sUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 89 -96 l 89 -517 l 135 -517 l 135 -108 b 180 -112 148 -112 163 -112 b 225 -108 196 -112 210 -112 l 225 -517 l 271 -517 l 271 -94 b 360 -12 305 -78 337 -50 l 360 -517 l 405 -517 l 405 248 l 383 248 b 190 0 353 98 288 16 b 138 -3 171 0 153 -3 b 45 68 75 -3 45 20 l 0 68 b 89 -96 0 -17 30 -72 z"
                },
                accSagittalFlat19sDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 96 b 0 -68 30 72 0 17 l 45 -68 b 138 3 45 -20 75 3 b 190 0 153 3 171 0 b 383 -248 288 -16 353 -98 l 405 -248 l 405 517 l 360 517 l 360 12 b 271 94 337 50 305 78 l 271 517 l 225 517 l 225 108 b 180 112 210 112 196 112 b 135 108 163 112 148 112 l 135 517 l 89 517 z"
                },
                accSagittalSharp17kUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 337 -23 b 405 14 363 -23 386 -10 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 68 402 127 364 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalFlat17kDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 315 -68 b 428 -248 364 -68 402 -127 l 449 -248 l 449 517 l 405 517 l 405 -14 b 337 23 386 10 363 23 l 315 23 l 315 517 l 271 517 l 271 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalSharp143CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 337 -23 b 405 14 363 -23 386 -10 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 68 402 127 364 68 l 240 68 b 89 157 140 68 89 98 l 45 157 b 68 53 45 115 52 81 b 0 -203 23 23 0 -63 z"
                },
                accSagittalFlat143CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -53 0 63 23 -23 b 45 -157 52 -81 45 -115 l 89 -157 b 240 -68 89 -98 140 -68 l 315 -68 b 428 -248 364 -68 402 -127 l 449 -248 l 449 517 l 405 517 l 405 -14 b 337 23 386 10 363 23 l 315 23 l 315 517 l 271 517 l 271 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalSharp11v49CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -68 b 135 68 45 23 76 68 l 337 68 b 405 95 363 68 386 76 l 405 -27 b 315 -68 386 -55 356 -68 l 112 -68 b 0 -292 37 -68 0 -143 l 45 -292 b 135 -157 45 -203 75 -157 l 135 -517 l 180 -517 l 180 -157 l 271 -157 l 271 -517 l 315 -517 l 315 -157 l 337 -157 b 405 -130 360 -157 383 -148 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 157 413 187 376 157 l 112 157 b 0 -68 37 157 0 82 z"
                },
                accSagittalFlat11v49CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 68 b 112 -157 0 -82 37 -157 l 315 -157 b 428 -248 376 -157 413 -187 l 449 -248 l 449 517 l 405 517 l 405 130 b 337 157 383 148 360 157 l 315 157 l 315 517 l 271 517 l 271 157 l 180 157 l 180 517 l 135 517 l 135 157 b 45 292 75 157 45 203 l 0 292 b 112 68 0 143 37 68 l 315 68 b 405 27 356 68 386 55 l 405 -95 b 337 -68 386 -76 363 -68 l 135 -68 b 45 68 76 -68 45 -23 z"
                },
                accSagittalSharp19CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 14 b 337 -23 289 -10 311 -23 l 360 -23 l 360 -517 l 405 -517 l 405 -23 b 495 -203 465 -23 495 -82 l 540 -203 b 428 68 540 -23 503 68 l 360 68 b 248 248 310 68 271 128 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z"
                },
                accSagittalFlat19CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 109 b 0 -68 30 98 0 39 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 b 360 -68 271 -128 310 -68 l 428 -68 b 540 203 503 -68 540 23 l 495 203 b 405 23 495 82 465 23 l 405 517 l 360 517 l 360 23 l 337 23 b 271 -14 311 23 289 10 l 271 517 l 225 517 l 225 27 b 135 109 200 75 170 102 l 135 517 l 89 517 z"
                },
                accSagittalSharp7v19CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 112 l 315 112 b 360 109 331 112 346 112 l 360 -517 l 405 -517 l 405 98 b 495 -68 465 73 495 19 l 495 -248 l 540 -248 l 540 68 b 360 248 540 189 480 248 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z"
                },
                accSagittalFlat7v19CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 109 b 0 -68 30 98 0 39 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 l 360 -248 b 540 -68 480 -248 540 -189 l 540 248 l 495 248 l 495 68 b 405 -98 495 -19 465 -73 l 405 517 l 360 517 l 360 -109 b 315 -112 346 -112 331 -112 l 271 -112 l 271 517 l 225 517 l 225 27 b 135 109 200 75 170 102 l 135 517 l 89 517 z"
                },
                accSagittalSharp49SUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 112 l 360 112 b 405 109 376 112 390 112 l 405 -517 l 449 -517 l 449 96 b 540 -68 510 72 540 17 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalFlat49SDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 449 -96 540 -17 510 -72 l 449 517 l 405 517 l 405 -109 b 360 -112 390 -112 376 -112 l 315 -112 l 315 517 l 271 517 l 271 -14 b 203 23 251 10 229 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalSharp23SUp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 71 l 405 -14 l 405 -517 l 449 -517 l 449 -56 l 675 -268 l 675 -112 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalFlat23SDown: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 675 112 l 675 268 l 449 56 l 449 517 l 405 517 l 405 14 l 315 -71 l 315 517 l 271 517 l 271 -14 b 203 23 251 10 229 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalSharp5v13MUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 495 141 l 495 14 l 0 -157 l 0 -256 l 225 -180 l 225 -517 l 271 -517 l 271 -161 l 360 -130 l 360 -517 l 405 -517 l 405 -115 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 517 248 b 167 168 366 194 248 168 b 45 248 85 168 45 194 l 0 248 b 95 99 0 170 30 120 l 0 68 l 0 -30 z"
                },
                accSagittalFlat5v13MDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 30 l 0 -68 l 95 -99 b 0 -248 30 -120 0 -170 l 45 -248 b 167 -168 45 -194 85 -168 b 517 -248 248 -168 366 -194 l 540 -248 l 540 517 l 495 517 l 495 84 l 405 115 l 405 517 l 360 517 l 360 130 l 271 161 l 271 517 l 225 517 l 225 180 l 0 256 l 0 157 l 495 -14 l 495 -141 z"
                },
                accSagittalSharp11v19MUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 14 b 428 -23 379 -10 402 -23 l 449 -23 l 449 -517 l 495 -517 l 495 -23 b 585 -203 554 -23 585 -84 l 631 -203 b 517 68 631 -23 593 68 l 449 68 b 337 248 400 68 363 127 l 225 248 b 0 68 75 248 0 187 z"
                },
                accSagittalFlat11v19MDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 225 -248 0 -187 75 -248 l 337 -248 b 449 -68 363 -127 400 -68 l 517 -68 b 631 203 593 -68 631 23 l 585 203 b 495 23 585 84 554 23 l 495 517 l 449 517 l 449 23 l 428 23 b 360 -14 402 23 379 10 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
                },
                accSagittalSharp49MUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 225 -180 l 225 -517 l 271 -517 l 271 -166 l 360 -132 l 360 -517 l 405 -517 l 405 -117 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 360 248 b 0 -68 120 248 0 143 z m 45 -145 l 45 -68 b 360 112 45 53 150 112 l 495 112 l 495 14 z"
                },
                accSagittalFlat49MDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 68 b 360 -248 0 -143 120 -248 l 540 -248 l 540 517 l 495 517 l 495 84 l 405 117 l 405 517 l 360 517 l 360 132 l 271 166 l 271 517 l 225 517 l 225 180 l 45 248 l 0 248 z m 495 -14 l 495 -112 l 360 -112 b 45 68 150 -112 45 -53 l 45 145 z"
                },
                accSagittalSharp5v49MUp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -271 l 180 -79 l 180 -517 l 225 -517 l 225 -30 l 315 65 l 315 -517 l 360 -517 l 360 65 l 449 -30 l 449 -517 l 495 -517 l 495 -79 l 675 -271 l 675 -112 l 337 248 b 118 89 239 143 166 89 b 45 157 68 89 45 112 l 0 157 b 107 0 0 62 36 10 l 0 -112 z"
                },
                accSagittalFlat5v49MDown: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 107 0 b 0 -157 36 -10 0 -62 l 45 -157 b 118 -89 45 -112 68 -89 b 337 -248 166 -89 239 -143 l 675 112 l 675 271 l 495 79 l 495 517 l 449 517 l 449 30 l 360 -65 l 360 517 l 315 517 l 315 -65 l 225 30 l 225 517 l 180 517 l 180 79 l 0 271 z"
                },
                accSagittalSharp49LUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -82 l 135 -112 l 135 -517 l 180 -517 l 180 -127 l 271 -157 l 271 -517 l 315 -517 l 315 -173 l 540 -248 l 585 -248 l 585 -68 b 180 248 585 143 449 248 l 0 248 z m 45 112 l 180 112 b 540 -68 420 112 540 53 l 540 -145 l 45 16 z"
                },
                accSagittalFlat49LDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 180 -248 b 585 68 449 -248 585 -143 l 585 248 l 540 248 l 315 173 l 315 517 l 271 517 l 271 157 l 180 127 l 180 517 l 135 517 l 135 112 l 45 82 l 45 517 l 0 517 z m 45 -16 l 540 145 l 540 68 b 180 -112 540 -53 420 -112 l 45 -112 z"
                },
                accSagittalSharp11v19LUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -81 l 135 -108 l 135 -517 l 180 -517 l 180 -121 l 271 -148 l 271 -517 l 315 -517 l 315 -161 l 631 -255 l 631 -157 l 45 16 l 45 144 l 631 -30 l 631 68 l 23 248 l 0 248 z"
                },
                accSagittalFlat11v19LDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 l 631 -68 l 631 30 l 45 -144 l 45 -16 l 631 157 l 631 255 l 315 161 l 315 517 l 271 517 l 271 148 l 180 121 l 180 517 l 135 517 l 135 108 l 45 81 l 45 517 l 0 517 z"
                },
                accSagittalSharp5v13LUp: {
                    x_min: 0,
                    x_max: 500,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 -85 l 360 -120 l 360 -517 l 405 -517 l 405 -135 l 720 -256 l 720 -157 l 271 14 l 271 141 l 720 -30 l 720 68 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z"
                },
                accSagittalFlat5v13LDown: {
                    x_min: 0,
                    x_max: 500,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 109 b 0 -68 30 98 0 39 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 l 720 -68 l 720 30 l 271 -141 l 271 -14 l 720 157 l 720 256 l 405 135 l 405 517 l 360 517 l 360 120 l 271 85 l 271 517 l 225 517 l 225 27 b 135 109 200 75 170 102 l 135 517 l 89 517 z"
                },
                accSagittalDoubleSharp23SDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -203 l 45 -203 b 135 -23 45 -82 76 -23 l 301 -23 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 370 -14 b 449 112 423 10 449 53 l 449 248 l 428 248 b 315 68 402 127 364 68 l 240 68 b 89 157 140 68 89 98 l 45 157 b 68 53 45 115 52 81 b 0 -203 23 23 0 -63 z"
                },
                accSagittalDoubleFlat23SUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -53 0 63 23 -23 b 45 -157 52 -81 45 -115 l 89 -157 b 240 -68 89 -98 140 -68 l 315 -68 b 428 -248 364 -68 402 -127 l 449 -248 l 449 -112 b 370 14 449 -53 423 -10 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 301 23 l 135 23 b 45 203 76 23 45 82 z"
                },
                accSagittalDoubleSharp49SDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -292 l 45 -292 b 112 -157 45 -203 68 -157 l 256 -157 l 135 -503 l 187 -517 l 337 -82 l 490 -517 l 540 -503 l 366 0 l 396 89 b 449 157 416 102 435 125 l 449 248 l 428 248 b 315 157 413 187 376 157 l 112 157 b 0 -68 39 157 0 82 l 45 -68 b 135 68 45 23 76 68 l 287 68 l 311 0 l 288 -68 l 89 -68 b 0 -292 32 -68 0 -144 z"
                },
                accSagittalDoubleFlat49SUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 292 b 89 68 0 144 32 68 l 288 68 l 311 0 l 287 -68 l 135 -68 b 45 68 76 -68 45 -23 l 0 68 b 112 -157 0 -82 39 -157 l 315 -157 b 428 -248 376 -157 413 -187 l 449 -248 l 449 -157 b 396 -89 435 -125 416 -102 l 366 0 l 540 503 l 490 517 l 337 82 l 187 517 l 135 503 l 256 157 l 112 157 b 45 292 68 157 45 203 z"
                },
                accSagittalDoubleSharp7v19CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -266 l 307 -7 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 386 59 l 449 112 l 449 248 l 428 248 b 130 68 285 127 186 68 b 45 157 73 68 45 98 l 0 157 b 112 -20 0 53 37 -6 z"
                },
                accSagittalDoubleFlat7v19CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 112 20 b 0 -157 37 6 0 -53 l 45 -157 b 130 -68 45 -98 73 -68 b 428 -248 186 -68 285 -127 l 449 -248 l 449 -112 l 386 -59 l 366 0 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 307 7 l 0 266 l 0 112 z"
                },
                accSagittalDoubleSharp19CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 315 109 45 36 135 95 l 354 0 l 180 -503 l 232 -517 l 383 -82 l 534 -517 l 585 -503 l 410 0 l 449 112 l 495 112 l 495 248 l 360 248 b 0 68 120 248 0 187 z m 372 112 l 393 112 l 383 82 z"
                },
                accSagittalDoubleFlat19CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 360 -248 0 -187 120 -248 l 495 -248 l 495 -112 l 449 -112 l 410 0 l 585 503 l 534 517 l 383 82 l 232 517 l 180 503 l 354 0 l 315 -109 b 45 68 135 -95 45 -36 l 45 248 l 0 248 z m 383 -82 l 393 -112 l 372 -112 z"
                },
                accSagittalDoubleSharp11v49CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 360 112 b 540 -68 480 112 540 53 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalDoubleFlat11v49CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 360 -112 540 -53 480 -112 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 262 -4 b 203 23 245 13 225 23 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalDoubleSharp143CDown: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 337 49 l 675 -268 l 675 -112 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalDoubleFlat143CUp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 675 112 l 675 268 l 337 -49 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 262 -4 b 203 23 245 13 225 23 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalDoubleSharp17kDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 248 b 95 101 0 170 30 121 l 0 68 l 0 -30 l 364 96 l 399 0 l 390 -23 l 0 -157 l 0 -255 l 353 -135 l 225 -503 l 275 -517 l 428 -82 l 577 -517 l 631 -503 l 455 0 l 507 145 l 540 157 l 540 248 l 517 248 b 167 168 366 194 248 168 b 45 248 85 168 45 194 z m 416 115 l 442 124 l 428 82 z"
                },
                accSagittalDoubleFlat17kUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -248 b 167 -168 45 -194 85 -168 b 517 -248 248 -168 366 -194 l 540 -248 l 540 -157 l 507 -145 l 455 0 l 631 503 l 577 517 l 428 82 l 275 517 l 225 503 l 353 135 l 0 255 l 0 157 l 390 23 l 399 0 l 364 -96 l 0 30 l 0 -68 l 95 -101 b 0 -248 30 -121 0 -170 z m 428 -82 l 442 -124 l 416 -115 z"
                },
                accSagittalDoubleSharp19sDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 271 112 45 53 120 112 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 367 4 b 428 -23 386 -13 405 -23 l 495 -23 b 585 -203 554 -23 585 -84 l 631 -203 b 517 68 631 -23 593 68 l 449 68 b 337 248 400 68 363 127 l 225 248 b 0 68 75 248 0 187 z"
                },
                accSagittalDoubleFlat19sUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 225 -248 0 -187 75 -248 l 337 -248 b 449 -68 363 -127 400 -68 l 517 -68 b 631 203 593 -68 631 23 l 585 203 b 495 23 585 84 554 23 l 428 23 b 367 -4 405 23 386 13 l 366 0 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 310 0 l 271 -112 b 45 68 120 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittalShaftUp: {
                    x_min: 0,
                    x_max: 31,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 112 l 0 -517 l 45 -517 l 45 112 l 23 248 z"
                },
                accSagittalShaftDown: {
                    x_min: 0,
                    x_max: 31,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 23 -248 l 45 -112 l 45 517 l 0 517 l 0 -112 z"
                },
                accSagittalAcute: {
                    x_min: 0,
                    x_max: 125,
                    y_min: -62,
                    y_max: 125,
                    ha: 187,
                    o: "m 0 0 l 0 -89 l 180 89 l 180 180 z"
                },
                accSagittalGrave: {
                    x_min: 0,
                    x_max: 125,
                    y_min: -125,
                    y_max: 62,
                    ha: 187,
                    o: "m 180 -180 l 180 -89 l 0 89 l 0 0 z"
                },
                accSagittal1MinaUp: {
                    x_min: -7,
                    x_max: 124,
                    y_min: 16,
                    y_max: 106,
                    ha: 90,
                    o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 134 150 179 112 163 135 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
                },
                accSagittal1MinaDown: {
                    x_min: -7,
                    x_max: 124,
                    y_min: -106,
                    y_max: -16,
                    ha: 90,
                    o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 179 -23 163 -135 179 -112 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
                },
                accSagittal2MinasUp: {
                    x_min: -7,
                    x_max: 218,
                    y_min: 16,
                    y_max: 106,
                    ha: 90,
                    o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 207 65 179 23 200 55 b 252 107 223 86 240 107 b 271 23 264 107 272 86 l 314 23 b 269 150 314 112 298 135 b 203 130 252 158 220 150 b 173 92 190 115 181 104 b 134 150 167 127 154 140 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
                },
                accSagittal2MinasDown: {
                    x_min: -7,
                    x_max: 218,
                    y_min: -106,
                    y_max: -16,
                    ha: 90,
                    o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 173 -92 154 -140 167 -127 b 203 -130 181 -104 190 -115 b 269 -150 220 -150 252 -158 b 314 -23 298 -135 314 -112 l 271 -23 b 252 -107 272 -86 264 -107 b 207 -65 240 -107 223 -86 b 179 -23 200 -55 179 -23 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
                },
                accSagittal1TinaUp: {
                    x_min: 0,
                    x_max: 93,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 134 154 l 91 154 b 81 76 91 101 91 86 b 0 68 73 69 48 68 l 0 23 b 134 154 122 23 134 36 z"
                },
                accSagittal1TinaDown: {
                    x_min: 0,
                    x_max: 93,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 134 -154 b 0 -23 134 -36 122 -23 l 0 -68 b 81 -76 48 -68 73 -69 b 91 -154 91 -86 91 -101 z"
                },
                accSagittal2TinasUp: {
                    x_min: 0,
                    x_max: 94,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 135 68 b 89 154 94 68 89 124 l 46 154 b 36 92 45 131 42 105 b 0 68 32 82 23 68 l 0 23 b 68 63 29 23 53 40 b 135 23 84 39 104 23 z"
                },
                accSagittal2TinasDown: {
                    x_min: 0,
                    x_max: 94,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 135 -23 b 68 -63 104 -23 84 -39 b 0 -23 53 -40 29 -23 l 0 -68 b 36 -92 23 -68 32 -82 b 46 -154 42 -105 45 -131 l 89 -154 b 135 -68 89 -124 94 -68 z"
                },
                accSagittal3TinasUp: {
                    x_min: -7,
                    x_max: 124,
                    y_min: 16,
                    y_max: 106,
                    ha: 90,
                    o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 134 150 179 112 163 135 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
                },
                accSagittal3TinasDown: {
                    x_min: -7,
                    x_max: 124,
                    y_min: -106,
                    y_max: -16,
                    ha: 90,
                    o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 179 -23 163 -135 179 -112 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
                },
                accSagittal4TinasUp: {
                    x_min: 0,
                    x_max: 187,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 0 68 l 0 23 b 143 45 105 23 124 26 b 203 107 153 55 183 107 b 226 23 216 107 226 86 l 269 23 b 225 150 269 112 253 135 b 160 132 207 158 181 153 b 115 81 138 112 124 88 b 0 68 104 71 94 68 z"
                },
                accSagittal4TinasDown: {
                    x_min: 0,
                    x_max: 187,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 0 -68 b 115 -81 94 -68 104 -71 b 160 -132 124 -88 138 -112 b 225 -150 181 -153 207 -158 b 269 -23 253 -135 269 -112 l 226 -23 b 203 -107 226 -86 216 -107 b 143 -45 183 -107 153 -55 b 0 -23 124 -26 105 -23 z"
                },
                accSagittal5TinasUp: {
                    x_min: 0,
                    x_max: 218,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 135 23 b 187 45 156 23 168 26 b 249 107 197 55 228 107 b 271 23 262 107 271 86 l 314 23 b 269 150 314 112 298 135 b 204 132 252 158 226 153 b 160 81 183 112 168 88 b 135 68 148 71 147 68 b 89 154 94 68 89 124 l 46 154 b 36 92 45 131 42 105 b 0 68 32 82 23 68 l 0 23 b 68 63 29 23 53 40 b 135 23 84 39 104 23 z"
                },
                accSagittal5TinasDown: {
                    x_min: 0,
                    x_max: 218,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 135 -23 b 68 -63 104 -23 84 -39 b 0 -23 53 -40 29 -23 l 0 -68 b 36 -92 23 -68 32 -82 b 46 -154 42 -105 45 -131 l 89 -154 b 135 -68 89 -124 94 -68 b 160 -81 147 -68 148 -71 b 204 -132 168 -88 183 -112 b 269 -150 226 -153 252 -158 b 314 -23 298 -135 314 -112 l 271 -23 b 249 -107 271 -86 262 -107 b 187 -45 228 -107 197 -55 b 135 -23 168 -26 156 -23 z"
                },
                accSagittal6TinasUp: {
                    x_min: -7,
                    x_max: 218,
                    y_min: 16,
                    y_max: 106,
                    ha: 90,
                    o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 207 65 179 23 200 55 b 252 107 223 86 240 107 b 271 23 264 107 272 86 l 314 23 b 269 150 314 112 298 135 b 203 130 252 158 220 150 b 173 92 190 115 181 104 b 134 150 167 127 154 140 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
                },
                accSagittal6TinasDown: {
                    x_min: -7,
                    x_max: 218,
                    y_min: -106,
                    y_max: -16,
                    ha: 90,
                    o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 173 -92 154 -140 167 -127 b 203 -130 181 -104 190 -115 b 269 -150 220 -150 252 -158 b 314 -23 298 -135 314 -112 l 271 -23 b 252 -107 272 -86 264 -107 b 207 -65 240 -107 223 -86 b 179 -23 200 -55 179 -23 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
                },
                accSagittal7TinasUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 0 68 l 0 23 b 143 45 105 23 124 26 b 203 107 153 55 183 107 b 226 23 216 107 226 86 l 269 23 b 298 65 269 23 291 55 b 343 107 314 86 331 107 b 361 23 354 107 363 86 l 405 23 b 360 150 405 112 389 135 b 294 130 343 158 311 150 b 264 92 281 115 272 104 b 225 150 258 127 245 140 b 160 132 207 158 181 153 b 115 81 138 112 124 88 b 0 68 104 71 94 68 z"
                },
                accSagittal7TinasDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 0 -68 b 115 -81 94 -68 104 -71 b 160 -132 124 -88 138 -112 b 225 -150 181 -153 207 -158 b 264 -92 245 -140 258 -127 b 294 -130 272 -104 281 -115 b 360 -150 311 -150 343 -158 b 405 -23 389 -135 405 -112 l 361 -23 b 343 -107 363 -86 354 -107 b 298 -65 331 -107 314 -86 b 269 -23 291 -55 269 -23 l 226 -23 b 203 -107 226 -86 216 -107 b 143 -45 183 -107 153 -55 b 0 -23 124 -26 105 -23 z"
                },
                accSagittal8TinasUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 135 23 b 187 45 156 23 168 26 b 249 107 197 55 228 107 b 271 23 262 107 271 86 l 314 23 b 343 65 314 23 336 55 b 387 107 359 86 376 107 b 406 23 399 107 408 86 l 449 23 b 405 150 449 112 433 135 b 338 130 387 158 356 150 b 308 92 325 115 317 104 b 269 150 302 127 289 140 b 204 132 252 158 226 153 b 160 81 183 112 168 88 b 135 68 148 71 147 68 b 89 154 94 68 89 124 l 46 154 b 36 92 45 131 42 105 b 0 68 32 82 23 68 l 0 23 b 68 63 29 23 53 40 b 135 23 84 39 104 23 z"
                },
                accSagittal8TinasDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 135 -23 b 68 -63 104 -23 84 -39 b 0 -23 53 -40 29 -23 l 0 -68 b 36 -92 23 -68 32 -82 b 46 -154 42 -105 45 -131 l 89 -154 b 135 -68 89 -124 94 -68 b 160 -81 147 -68 148 -71 b 204 -132 168 -88 183 -112 b 269 -150 226 -153 252 -158 b 308 -92 289 -140 302 -127 b 338 -130 317 -104 325 -115 b 405 -150 356 -150 387 -158 b 449 -23 433 -135 449 -112 l 406 -23 b 387 -107 408 -86 399 -107 b 343 -65 376 -107 359 -86 b 314 -23 336 -55 314 -23 l 271 -23 b 249 -107 271 -86 262 -107 b 187 -45 228 -107 197 -55 b 135 -23 168 -26 156 -23 z"
                },
                accSagittal9TinasUp: {
                    x_min: -7,
                    x_max: 312,
                    y_min: 16,
                    y_max: 106,
                    ha: 90,
                    o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 207 65 179 23 200 55 b 252 107 223 86 240 107 b 271 23 264 107 272 86 l 314 23 b 343 65 314 23 336 55 b 387 107 359 86 376 107 b 406 23 399 107 408 86 l 449 23 b 405 150 449 112 433 135 b 338 130 387 158 356 150 b 308 92 325 115 317 104 b 269 150 302 127 289 140 b 203 130 252 158 220 150 b 173 92 190 115 181 104 b 134 150 167 127 154 140 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
                },
                accSagittal9TinasDown: {
                    x_min: -7,
                    x_max: 312,
                    y_min: -106,
                    y_max: -16,
                    ha: 90,
                    o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 173 -92 154 -140 167 -127 b 203 -130 181 -104 190 -115 b 269 -150 220 -150 252 -158 b 308 -92 289 -140 302 -127 b 338 -130 317 -104 325 -115 b 405 -150 356 -150 387 -158 b 449 -23 433 -135 449 -112 l 406 -23 b 387 -107 408 -86 399 -107 b 343 -65 376 -107 359 -86 b 314 -23 336 -55 314 -23 l 271 -23 b 252 -107 272 -86 264 -107 b 207 -65 240 -107 223 -86 b 179 -23 200 -55 179 -23 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
                },
                accSagittalFractionalTinaUp: {
                    x_min: -3,
                    x_max: 35,
                    y_min: 73,
                    y_max: 111,
                    ha: 38,
                    o: "m -4 132 b 23 105 -4 118 9 105 b 50 132 37 105 50 118 b 23 160 50 147 37 160 b -4 132 9 160 -4 147 z"
                },
                accSagittalFractionalTinaDown: {
                    x_min: -3,
                    x_max: 35,
                    y_min: -111,
                    y_max: -73,
                    ha: 38,
                    o: "m -4 -132 b 23 -160 -4 -147 9 -160 b 50 -132 37 -160 50 -147 b 23 -105 50 -118 37 -105 b -4 -132 9 -105 -4 -118 z"
                },
                accidentalNarrowReversedFlat: {
                    x_min: 0,
                    x_max: 164,
                    y_min: -194,
                    y_max: 421,
                    ha: 615,
                    o: "m 236 -279 l 236 606 l 192 606 l 192 179 b 85 243 150 222 114 243 b 0 84 23 243 0 134 b 112 -158 0 3 37 -78 z m 192 112 l 192 -163 l 135 -98 b 82 40 101 -50 82 -3 b 138 144 82 73 96 144 b 192 112 153 144 170 132 z"
                },
                accidentalNarrowReversedFlatAndFlat: {
                    x_min: 0,
                    x_max: 414,
                    y_min: -194,
                    y_max: 421,
                    ha: 615,
                    o: "m 281 606 l 281 -268 l 438 -158 b 596 84 547 -82 596 3 b 475 243 596 154 556 243 b 325 179 435 243 384 222 l 325 606 z m 235 -279 l 235 606 l 190 606 l 190 179 b 85 243 148 222 114 243 b 12 158 52 243 27 215 b 0 84 3 134 0 108 b 112 -158 0 3 37 -78 z m 325 111 b 410 144 359 132 386 144 b 498 36 462 144 498 84 b 413 -107 498 -9 469 -58 l 325 -173 z m 192 112 l 192 -163 l 135 -98 b 81 40 99 -50 81 -3 b 91 94 81 59 84 76 b 137 144 102 127 118 144 b 192 112 153 144 170 132 z"
                },
                accidentalWilsonPlus: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -203,
                    y_max: 203,
                    ha: 406,
                    o: "m 405 268 l 225 98 l 225 292 l 180 292 l 180 56 l 0 -112 l 0 -268 l 180 -98 l 180 -292 l 225 -292 l 225 -56 l 405 112 z"
                },
                accidentalWilsonMinus: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -186,
                    y_max: 186,
                    ha: 372,
                    o: "m 0 112 l 405 -268 l 405 -112 l 0 268 z"
                }
            },
            fontFamily: "Bravura",
            resolution: 1e3,
            generatedOn: "2022-12-18T09:06:51.407Z"
        }, Ni = {
            smufl: !0,
            stave: {
                padding: 12,
                endPaddingMax: 10,
                endPaddingMin: 5,
                unalignedNotePadding: 10
            },
            accidental: {
                noteheadAccidentalPadding: 1,
                leftPadding: 2,
                accidentalSpacing: 3
            },
            chordSymbol: {
                global: {
                    superscriptOffset: -400,
                    subscriptOffset: 300,
                    kerningOffset: -250,
                    lowerKerningText: [
                        "D",
                        "F",
                        "P",
                        "T",
                        "V",
                        "Y"
                    ],
                    upperKerningText: [
                        "A",
                        "L"
                    ],
                    spacing: 100,
                    superSubRatio: .66
                },
                glyphs: {
                    csymDiminished: {
                        leftSideBearing: -32,
                        advanceWidth: 506,
                        yOffset: 0
                    },
                    csymHalfDiminished: {
                        leftSideBearing: -32,
                        advanceWidth: 506,
                        yOffset: 0
                    },
                    csymAugmented: {
                        leftSideBearing: 0,
                        advanceWidth: 530,
                        yOffset: 0
                    },
                    csymParensLeftTall: {
                        leftSideBearing: -20,
                        advanceWidth: 184,
                        yOffset: 250
                    },
                    csymParensRightTall: {
                        leftSideBearing: 0,
                        advanceWidth: 189,
                        yOffset: 250
                    },
                    csymBracketLeftTall: {
                        leftSideBearing: 0,
                        advanceWidth: 328,
                        yOffset: 0
                    },
                    csymBracketRightTall: {
                        leftSideBearing: 1,
                        advanceWidth: 600,
                        yOffset: 0
                    },
                    csymParensLeftVeryTall: {
                        leftSideBearing: 50,
                        advanceWidth: 121,
                        yOffset: 350
                    },
                    csymParensRightVeryTall: {
                        leftSideBearing: 0,
                        advanceWidth: 111,
                        yOffset: 350
                    },
                    csymDiagonalArrangementSlash: {
                        leftSideBearing: 250,
                        advanceWidth: 990,
                        yOffset: 300
                    },
                    csymMinor: {
                        leftSideBearing: 0,
                        advanceWidth: 482,
                        yOffset: 0
                    },
                    csymMajorSeventh: {
                        leftSideBearing: 200,
                        yOffset: 0,
                        advanceWidth: 600
                    },
                    accidentalSharp: {
                        leftSideBearing: 20,
                        advanceWidth: 250,
                        yOffset: -302
                    },
                    accidentalFlat: {
                        leftSideBearing: -20,
                        advanceWidth: 226,
                        yOffset: -184
                    }
                }
            },
            clef_default: {
                width: 26,
                annotations: {
                    "8va": {
                        treble: {
                            line: -2,
                            shiftX: 12
                        }
                    },
                    "8vb": {
                        treble: {
                            line: 6.5,
                            shiftX: 10
                        },
                        bass: {
                            line: 4,
                            shiftX: 1
                        }
                    }
                }
            },
            clef_small: {
                width: 20,
                annotations: {
                    "8va": {
                        treble: {
                            line: -0.2,
                            shiftX: 8
                        }
                    },
                    "8vb": {
                        treble: {
                            line: 5.3,
                            shiftX: 6
                        },
                        bass: {
                            line: 3.1,
                            shiftX: .5
                        }
                    }
                }
            },
            ornament: {
                brassScoop: {
                    xOffset: -12,
                    yOffset: 0,
                    stemUpYOffset: 0,
                    reportedWidth: 20
                },
                brassDoitMedium: {
                    xOffset: 16,
                    yOffset: 0,
                    stemUpYOffset: 0,
                    reportedWidth: 22
                },
                brassFallLipShort: {
                    xOffset: 16,
                    yOffset: 0,
                    stemUpYOffset: 0,
                    reportedWidth: 15
                },
                brassLiftMedium: {
                    xOffset: 16,
                    yOffset: 5,
                    stemUpYOffset: 0,
                    reportedWidth: 5
                },
                brassFallRoughMedium: {
                    xOffset: 16,
                    yOffset: 28,
                    stemUpYOffset: 0,
                    reportedWidth: 5
                },
                brassBend: {
                    xOffset: 2,
                    yOffset: -8,
                    stemUpYOffset: 25,
                    reportedWidth: 5
                },
                brassMuteClosed: {
                    xOffset: 3,
                    yOffset: -8,
                    stemUpYOffset: 25,
                    reportedWidth: 5
                },
                brassMuteOpen: {
                    xOffset: 3,
                    yOffset: -7,
                    stemUpYOffset: 25,
                    reportedWidth: 5
                },
                brassFlip: {
                    xOffset: 10,
                    yOffset: 0,
                    stemUpYOffset: 7,
                    reportedWidth: 10
                },
                brassJazzTurn: {
                    xOffset: 0,
                    yOffset: 0,
                    stemUpYOffset: 8,
                    reportedWidth: 31
                },
                brassSmear: {
                    xOffset: 10,
                    yOffset: 0,
                    stemUpYOffset: 8,
                    reportedWidth: 5
                }
            },
            parenthesis: {
                default: {
                    width: 7
                },
                gracenote: {
                    width: 3
                }
            },
            pedalMarking: {},
            digits: {
                shiftLine: -1,
                shiftY: -6
            },
            articulation: {
                articStaccatissimoAbove: {
                    padding: 2
                },
                articStaccatissimoBelow: {
                    padding: 2
                }
            },
            tremolo: {
                default: {
                    spacing: 7,
                    offsetYStemUp: -8,
                    offsetYStemDown: 8,
                    offsetXStemUp: 11,
                    offsetXStemDown: 1
                },
                grace: {
                    spacing: 4.2,
                    offsetYStemUp: -4.8,
                    offsetYStemDown: 4.8,
                    offsetXStemUp: 7,
                    offsetXStemDown: 1
                }
            },
            staveRepetition: {
                symbolText: {
                    offsetX: 12,
                    offsetY: 25,
                    spacing: 5
                },
                coda: {
                    offsetY: 25
                },
                segno: {
                    offsetY: 10
                }
            },
            noteHead: {
                minPadding: 2
            },
            stem: {
                heightAdjustmentForFlag: -3,
                noteHead: {
                    noteheadTriangleUpHalf: {
                        offsetYBaseStemUp: 5,
                        offsetYBaseStemDown: 4
                    },
                    noteheadTriangleUpBlack: {
                        offsetYBaseStemUp: 5,
                        offsetYBaseStemDown: 4
                    },
                    noteheadTriangleUpWhole: {
                        offsetYBaseStemUp: 5,
                        offsetYBaseStemDown: 4
                    },
                    noteheadXHalf: {
                        offsetYBaseStemUp: -4,
                        offsetYBaseStemDown: 4
                    },
                    noteheadXBlack: {
                        offsetYBaseStemUp: -4,
                        offsetYBaseStemDown: 4
                    },
                    noteheadXWhole: {
                        offsetYBaseStemUp: -4,
                        offsetYBaseStemDown: 4
                    },
                    noteheadHalf: {
                        offsetYBaseStemUp: -2.55,
                        offsetYBaseStemDown: 2.65
                    },
                    noteheadBlack: {
                        offsetYBaseStemUp: -2,
                        offsetYBaseStemDown: 2
                    },
                    noteheadSquareWhite: {
                        offsetYBaseStemDown: -5,
                        offsetYBaseStemUp: 5
                    }
                }
            },
            stringNumber: {
                verticalPadding: 8,
                stemPadding: 2,
                leftPadding: 5,
                rightPadding: 6
            },
            tuplet: {
                noteHeadOffset: 20,
                stemOffset: 10,
                bottomLine: 4,
                topModifierOffset: 15
            },
            glyphs: {
                coda: {
                    shiftX: -7,
                    shiftY: 8
                },
                segno: {
                    shiftX: -7
                },
                flag: {
                    shiftX: -0.75,
                    staveTempo: {
                        shiftX: -1
                    }
                },
                clef_default: {},
                clef_small: {
                    gClef: {
                        shiftY: 1.5
                    }
                },
                clefNote_default: {},
                clefNote_small: {},
                stroke_straight: {
                    arrowheadBlackDown: {
                        shiftX: -4.5
                    },
                    arrowheadBlackUp: {
                        shiftX: -0.85
                    }
                },
                stroke_wiggly: {
                    arrowheadBlackDown: {
                        shiftX: -1,
                        shiftY: 1
                    },
                    arrowheadBlackUp: {
                        shiftX: -1,
                        shiftY: 1
                    }
                },
                textNote: {
                    breathMarkTick: {
                        shiftY: 9
                    },
                    breathMarkComma: {},
                    segno: {
                        shiftX: -7,
                        shiftY: 8
                    },
                    coda: {
                        shiftX: -7,
                        shiftY: 8
                    },
                    ornamentTrill: {
                        shiftX: -8,
                        shiftY: 8
                    },
                    ornamentTurn: {},
                    ornamentTurnSlash: {},
                    ornamentMordent: {
                        shiftX: -8
                    },
                    ornamentShortTrill: {
                        shiftX: -8
                    }
                },
                noteHead: {},
                chordSymbol: {
                    scale: .8
                }
            }
        };
        const Fi = {
            resolution: 1e3,
            fontFamily: "VexFlowCustom",
            glyphs: {
                vexAccidentalMicrotonal1: {
                    x_min: -171.5,
                    x_max: 483.1875,
                    ha: 493,
                    o: "m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 495 20 616 20 616 b 20 373 20 427 20 373 b 115 410 20 373 63 390 l 210 448 l 210 531 b 212 620 210 614 210 616 b 231 632 215 628 223 632 b 246 627 236 632 242 631 b 251 541 251 620 251 628 l 251 463 l 315 489 b 387 514 368 509 381 514 b 393 513 390 514 392 514 b 406 494 402 510 406 502 b 397 476 406 487 404 480 b 323 446 396 474 363 462 l 251 417 l 251 283 l 251 148 l 254 151 b 370 199 291 183 332 199 b 415 191 385 199 400 197 b 483 84 458 176 483 134 b 461 0 483 58 476 29 b 332 -142 439 -40 411 -72 l 255 -215 b 231 -229 240 -229 239 -229 b 216 -223 224 -229 220 -227 b 210 -158 210 -217 210 -223 b 210 -120 210 -148 210 -136 l 210 -29 l 205 -34 b 100 -142 182 -65 159 -88 l 23 -215 b -1 -229 9 -229 6 -229 b -19 -217 -9 -229 -16 -224 l -20 -215 l -21 48 l -21 310 l -83 287 b -152 262 -133 266 -145 262 b -157 263 -153 262 -155 262 b -171 283 -166 266 -171 274 b -161 301 -171 290 -167 297 b -91 328 -160 302 -129 315 l -21 356 l -21 487 l -20 617 l -19 621 b -8 631 -17 626 -12 630 m 210 288 b 210 401 210 351 210 401 b 114 365 209 401 167 384 l 20 327 l 20 238 l 20 148 l 21 151 b 140 199 59 183 102 199 b 206 180 164 199 187 192 l 209 177 b 209 177 209 177 209 177 b 210 288 210 177 210 199 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 m 341 131 b 328 133 337 133 332 133 b 322 133 326 133 323 133 b 257 87 296 129 273 113 l 251 80 l 251 -37 l 251 -156 l 255 -152 b 375 81 328 -72 375 20 l 375 83 b 341 131 375 113 367 126 "
                },
                vexAccidentalMicrotonal3: {
                    x_min: 0,
                    x_max: 430.75,
                    ha: 360,
                    o: "m -146 537 b -138 538 -143 538 -141 538 b -118 525 -129 538 -121 533 b -117 390 -117 522 -117 521 b -115 259 -117 268 -117 259 b -115 259 -115 259 -115 259 b -59 272 -104 263 -62 272 b -39 259 -50 272 -42 267 b -37 209 -38 257 -37 233 b -39 159 -37 185 -38 162 b -85 138 -43 149 -44 149 l -117 131 l -117 21 b -115 -88 -117 -80 -117 -88 b -115 -88 -115 -88 -115 -88 b -59 -75 -104 -84 -62 -75 b -44 -81 -52 -75 -48 -77 b -38 -124 -38 -87 -38 -85 b -38 -138 -38 -124 -38 -138 b -38 -152 -38 -138 -38 -152 b -44 -195 -38 -191 -38 -190 b -85 -209 -48 -200 -48 -200 l -117 -217 l -117 -349 b -118 -486 -117 -481 -117 -482 b -138 -499 -121 -494 -129 -499 b -153 -493 -143 -499 -149 -497 b -159 -415 -158 -487 -159 -496 b -159 -355 -159 -398 -159 -379 b -159 -227 -159 -284 -159 -227 b -205 -238 -159 -227 -180 -232 b -250 -249 -230 -244 -250 -249 b -251 -386 -251 -249 -251 -311 b -252 -525 -251 -521 -251 -522 b -272 -538 -255 -534 -264 -538 b -287 -532 -277 -538 -283 -536 b -293 -452 -292 -527 -293 -536 b -293 -391 -293 -436 -293 -415 b -294 -260 -293 -269 -293 -260 b -294 -260 -294 -260 -294 -260 b -348 -272 -306 -264 -345 -272 b -368 -259 -357 -272 -365 -267 b -369 -209 -369 -257 -369 -233 b -368 -159 -369 -185 -369 -162 b -323 -139 -364 -149 -362 -148 l -293 -131 l -293 -22 b -294 87 -293 80 -293 87 b -294 87 -294 87 -294 87 b -348 75 -306 84 -345 75 b -368 88 -357 75 -365 80 b -369 138 -369 91 -369 114 b -368 188 -369 162 -369 186 b -323 209 -364 198 -362 199 l -293 216 l -293 349 b -292 486 -293 481 -293 482 b -272 499 -288 494 -280 499 b -257 493 -266 499 -261 497 b -251 414 -251 487 -251 496 b -251 354 -251 398 -251 378 b -251 226 -251 284 -251 226 b -205 238 -250 226 -230 231 b -159 249 -180 244 -159 249 b -159 385 -159 249 -159 310 b -157 525 -159 521 -159 522 b -146 537 -156 530 -151 535 z m -159 11 b -159 120 -159 98 -159 120 l -159 120 b -175 116 -160 120 -167 119 b -221 105 -184 114 -204 109 l -251 98 l -251 -12 b -251 -121 -251 -72 -251 -121 b -205 -110 -250 -121 -230 -116 b -159 -99 -180 -104 -159 -99 b -159 11 -159 -99 -159 -49 z m 89 517 b 97 519 92 518 94 519 b 117 505 106 519 114 513 b 119 376 119 502 119 501 l 119 249 l 145 258 b 176 267 169 266 172 267 b 177 267 176 267 177 267 b 196 255 186 267 192 263 l 197 252 l 197 205 b 197 181 197 195 197 187 b 193 149 197 153 197 153 b 152 131 190 144 187 143 l 119 120 l 119 10 b 119 -100 119 -62 119 -100 b 145 -91 120 -100 131 -96 b 173 -82 159 -86 171 -82 b 176 -81 174 -81 175 -81 b 196 -94 185 -81 193 -87 b 198 -151 197 -97 198 -125 b 197 -194 198 -172 197 -192 b 153 -218 193 -203 192 -204 l 119 -230 l 119 -367 l 118 -504 l 117 -507 b 97 -519 113 -514 105 -519 b 82 -512 92 -519 87 -517 b 76 -434 77 -507 76 -516 b 76 -374 76 -418 76 -398 b 76 -245 76 -303 76 -245 b 52 -254 76 -245 65 -249 b 19 -263 34 -260 25 -263 b 6 -257 13 -263 10 -261 b 0 -214 0 -251 0 -253 b 0 -200 0 -210 0 -205 b 0 -188 0 -196 0 -192 b 6 -143 0 -147 0 -149 b 46 -126 10 -139 10 -139 l 76 -115 l 76 -5 b 76 106 76 56 76 106 b 51 98 76 106 64 102 b 18 89 34 92 25 89 b 6 95 13 89 10 91 b 0 139 0 101 0 99 b 0 153 0 143 0 148 b 0 179 0 163 0 172 b 44 225 0 215 3 211 l 76 236 l 76 369 b 78 505 76 501 76 502 b 89 517 80 510 85 515 z "
                },
                vexAccidentalMicrotonal4: {
                    x_min: 0,
                    x_max: 430.75,
                    ha: 360,
                    o: "m 283 633 b 291 634 286 634 289 634 b 311 621 300 634 308 629 b 313 505 313 618 313 617 b 313 393 313 443 313 393 b 378 425 313 393 343 407 l 443 458 l 448 458 b 449 458 449 458 449 458 b 471 437 462 458 471 448 b 469 429 471 434 470 432 b 387 382 466 421 469 423 l 313 344 l 313 247 l 313 150 l 315 152 b 433 201 353 184 394 201 b 479 193 448 201 464 198 b 549 86 524 177 549 135 b 526 1 549 59 541 29 b 395 -143 504 -39 475 -71 b 316 -214 351 -182 341 -191 b 292 -229 302 -228 300 -229 b 272 -216 283 -229 275 -224 b 271 55 271 -212 271 -212 b 270 323 271 203 270 323 b 205 291 270 323 241 308 l 140 258 l 135 258 b 134 258 135 258 134 258 b 112 279 121 258 112 267 b 114 287 112 281 113 284 b 196 334 117 295 114 293 l 271 371 l 271 495 b 272 621 271 617 271 618 b 283 633 274 626 279 631 z m 404 133 b 391 134 400 134 395 134 b 384 134 388 134 386 134 b 318 88 358 130 335 114 l 313 81 l 313 -37 l 313 -156 l 316 -152 b 439 83 391 -71 439 22 l 439 84 b 404 133 439 115 430 128 z m -8 633 l -8 633 b 0 634 -6 634 -3 634 b 20 621 8 634 17 629 b 21 384 21 618 21 617 l 21 150 l 24 152 b 141 201 62 184 102 201 b 187 193 157 201 172 198 b 257 86 232 177 257 135 b 234 1 257 59 250 29 b 103 -143 212 -39 183 -71 b 24 -214 60 -182 49 -191 b 0 -229 10 -228 8 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 203 l -21 618 l -20 621 b -8 633 -18 626 -13 631 z m 113 133 l 113 133 b 99 134 109 134 103 134 b 93 134 97 134 94 134 b 26 88 66 130 43 114 l 21 81 l 21 -37 l 21 -156 l 25 -152 b 148 83 99 -71 148 22 l 148 84 b 113 133 148 115 138 128 z "
                },
                vexNoteHeadRectBlack: {
                    x_min: 0,
                    x_max: 430.75,
                    ha: 360,
                    o: "m 0 150 l 0 -150 l 430 -150 l 430 150 l 0 150 "
                },
                vexNoteHeadRectWhite: {
                    x_min: 0,
                    x_max: 430.75,
                    ha: 360,
                    o: "m 0 150 l 0 -150 l 430 -150 l 430 150 l 0 150 l 50 100 l 380 100 l 380 -100 l 50 -100 l 50 100"
                },
                vexWiggleArpeggioUp: {
                    x_min: 58.53125,
                    x_max: 228.671875,
                    ha: 294,
                    o: "m 138 371 b 142 373 140 371 141 373 b 178 342 149 373 156 366 b 228 251 217 297 228 278 b 228 244 228 248 228 247 b 176 147 227 212 212 184 b 123 73 152 122 132 93 b 121 62 122 70 121 66 b 145 13 121 48 129 31 b 153 -2 151 6 153 1 b 149 -9 153 -5 152 -6 b 144 -11 148 -11 145 -11 b 129 -1 140 -11 136 -8 b 61 87 89 37 68 68 b 58 113 59 95 58 105 b 110 215 58 144 74 177 b 163 287 134 240 155 269 b 166 299 166 291 166 295 b 141 348 166 313 157 330 b 133 360 134 356 133 358 b 133 363 133 362 133 362 b 138 371 133 367 136 370 "
                }
            }
        };
        const Mi = {
            glyphs: {
                bracketTop: {
                    x_min: 0,
                    x_max: 412,
                    y_min: -18,
                    y_max: 223,
                    ha: 241,
                    o: "m 569 315 b 583 321 575 319 579 321 b 591 316 586 321 589 319 b 593 310 592 314 593 312 b 579 289 593 306 589 301 b 385 111 517 219 449 156 b 372 101 379 106 373 102 b 244 28 340 78 285 46 b 21 -26 168 -6 88 -26 b 2 -21 6 -26 5 -25 b 0 47 1 -19 0 14 b 2 114 0 79 1 112 b 29 120 5 119 6 119 b 569 315 209 124 395 191 z"
                },
                bracketBottom: {
                    x_min: 0,
                    x_max: 412,
                    y_min: -223,
                    y_max: 18,
                    ha: 241,
                    o: "m 5 24 b 21 26 7 25 12 26 b 63 23 32 26 47 25 b 342 -81 155 13 249 -22 b 388 -113 353 -89 382 -108 b 400 -122 389 -114 395 -118 b 578 -289 459 -166 522 -225 b 593 -310 589 -301 593 -306 b 591 -316 593 -312 592 -314 b 583 -321 588 -319 586 -321 b 568 -315 579 -321 575 -319 b 29 -120 395 -191 209 -124 b 1 -114 5 -119 5 -119 b 0 -47 0 -112 0 -111 b 0 -22 0 -37 0 -29 b 5 24 0 25 0 21 z"
                },
                barlineTick: {
                    x_min: -59,
                    x_max: 59,
                    y_min: -139,
                    y_max: 139,
                    ha: 279,
                    o: "m 24 200 b 34 201 26 200 30 201 b 51 198 40 201 47 200 b 84 152 72 191 84 174 b 84 149 84 151 84 150 b 68 103 84 139 83 137 b -64 -195 3 -44 -63 -194 b -74 -201 -66 -199 -70 -201 b -83 -195 -77 -201 -81 -199 b -84 -191 -84 -194 -84 -193 b -78 -155 -84 -186 -83 -177 b -25 104 -45 8 -35 53 b -11 167 -18 136 -12 164 b 24 200 -6 183 6 195 z"
                },
                breathMarkTick: {
                    x_min: -151,
                    x_max: 272,
                    y_min: 0,
                    y_max: 429,
                    ha: 429,
                    o: "m 367 613 b 382 618 373 616 378 618 b 392 607 388 618 392 614 b 376 592 392 601 390 599 b 309 546 354 580 331 565 b 46 47 185 439 88 256 b 0 0 39 14 26 0 b -44 39 -23 0 -36 12 b -203 270 -68 118 -125 202 b -217 288 -213 279 -217 284 b -215 294 -217 290 -217 292 b -208 299 -213 297 -211 299 b -193 293 -204 299 -199 297 b -19 144 -124 249 -66 199 b -14 138 -16 141 -14 138 b -9 149 -14 138 -11 143 b 367 613 72 359 220 541 z"
                },
                segno: {
                    x_min: 7,
                    x_max: 493,
                    y_min: -50,
                    y_max: 650,
                    ha: 699,
                    o: "m 218 934 b 237 935 224 935 231 935 b 394 820 306 935 371 889 b 398 794 397 811 398 802 b 333 730 398 758 372 730 b 269 777 302 730 280 746 b 183 851 254 823 219 851 b 158 846 175 851 166 849 b 120 786 133 835 120 815 b 122 766 120 780 121 773 b 347 511 138 672 227 570 b 368 500 356 506 366 501 l 371 499 l 372 501 b 485 672 373 502 404 550 b 560 786 506 704 540 755 b 617 873 581 818 607 857 b 645 910 639 906 640 907 b 660 915 650 914 655 915 b 687 888 674 915 687 904 b 687 886 687 887 687 887 b 665 844 687 878 687 878 b 610 761 655 830 631 792 b 462 537 551 672 501 595 b 425 480 443 508 426 482 l 422 476 l 431 472 b 628 269 521 423 591 352 b 658 136 649 225 658 179 b 518 -68 658 36 606 -48 b 484 -71 507 -70 495 -71 b 327 43 415 -71 351 -26 b 322 70 324 52 322 61 b 387 134 322 106 348 134 b 451 86 419 134 440 118 b 537 13 466 41 501 13 b 563 18 545 13 554 15 b 600 78 587 29 600 49 b 598 98 600 84 599 91 b 374 353 582 192 493 293 b 352 363 364 358 354 363 l 349 365 l 348 363 b 235 192 347 361 315 313 b 160 77 214 160 180 109 b 103 -9 139 46 113 7 b 75 -47 81 -42 80 -43 b 60 -51 70 -50 65 -51 b 33 -24 46 -51 33 -40 b 33 -22 33 -23 33 -23 b 55 19 33 -14 33 -14 b 259 329 84 63 162 181 b 297 386 279 360 296 385 l 298 388 l 290 392 b 92 594 200 441 130 512 b 62 728 71 639 62 685 b 218 934 62 834 121 922 z m 630 616 b 643 618 634 617 639 618 b 699 589 665 618 687 607 b 709 552 706 578 709 565 b 699 515 709 539 706 526 b 644 486 686 496 665 486 b 596 507 626 486 609 493 b 578 551 584 520 578 536 b 630 616 578 581 598 609 z m 62 376 b 75 378 67 377 71 378 b 124 357 93 378 112 370 b 142 312 136 344 142 328 b 131 275 142 299 138 286 b 76 246 118 256 97 246 b 28 267 59 246 41 253 b 11 311 16 280 11 296 b 62 376 11 341 30 369 z"
                },
                coda: {
                    x_min: 22,
                    x_max: 478,
                    y_min: -31,
                    y_max: 531,
                    ha: 563,
                    o: "m 350 764 b 359 765 352 765 355 765 b 367 764 362 765 365 765 b 381 753 373 762 378 758 b 386 706 386 746 386 747 b 387 670 386 672 386 670 b 448 647 396 670 430 657 b 597 395 532 601 587 507 l 598 386 l 632 386 b 677 382 670 386 670 386 b 689 359 685 376 689 367 b 677 336 689 350 685 341 b 632 331 670 331 670 331 l 598 331 l 597 322 b 396 50 585 186 504 77 b 387 48 392 49 388 48 b 386 12 386 48 386 46 l 386 8 b 380 -36 386 -29 386 -28 b 359 -45 375 -42 367 -45 b 338 -36 351 -45 342 -42 b 331 8 331 -28 331 -29 l 331 12 b 330 48 331 46 331 48 b 269 70 321 48 288 60 b 120 322 186 117 130 210 l 119 331 l 86 331 b 43 336 50 331 50 331 b 31 359 35 341 31 350 b 50 385 31 370 38 381 b 86 386 53 386 60 386 l 119 386 l 120 395 b 269 647 130 508 186 601 b 330 670 288 657 321 670 b 331 706 331 670 331 672 b 332 746 331 736 332 744 b 350 764 335 754 342 762 z m 331 502 b 331 617 331 565 331 617 b 310 599 329 617 317 607 b 229 393 266 555 235 477 l 229 386 l 280 386 l 331 386 z m 393 613 b 386 617 390 615 387 617 b 386 502 386 617 386 565 l 386 386 l 437 386 l 488 386 l 488 393 b 393 613 482 486 443 575 z m 331 216 l 331 331 l 280 331 l 229 331 l 229 324 b 310 118 235 241 266 162 b 331 100 317 111 329 100 b 331 216 331 100 331 152 z m 488 324 l 488 331 l 437 331 l 386 331 l 386 216 b 386 100 386 152 386 100 b 408 118 388 100 400 111 b 488 324 452 162 482 241 z"
                },
                gClef: {
                    x_min: 0,
                    x_max: 623,
                    y_min: -632,
                    y_max: 1082,
                    ha: 1713,
                    o: "m 521 1558 b 524 1558 522 1558 523 1558 b 579 1515 537 1558 556 1543 b 718 1118 662 1415 718 1254 b 717 1089 718 1108 718 1098 b 505 667 707 930 639 793 b 470 633 493 655 477 640 l 456 620 l 483 495 b 510 369 498 426 510 369 b 510 369 510 369 510 369 b 519 370 511 369 514 370 b 558 372 525 371 542 372 b 590 371 572 372 585 371 b 897 45 760 350 885 217 b 898 22 897 38 898 30 b 666 -316 898 -120 805 -256 b 657 -320 661 -318 657 -320 b 675 -403 657 -320 665 -357 b 695 -500 685 -448 694 -491 b 704 -596 701 -534 704 -566 b 642 -796 704 -677 683 -744 b 407 -909 582 -871 495 -909 b 176 -804 323 -909 238 -874 b 137 -704 150 -774 137 -739 b 168 -612 137 -672 147 -640 b 291 -550 198 -571 245 -550 b 405 -604 333 -550 376 -568 b 437 -694 427 -632 437 -663 b 305 -834 437 -764 384 -831 l 294 -835 l 298 -836 b 405 -861 330 -853 367 -861 b 539 -823 453 -861 501 -848 b 655 -596 617 -774 655 -699 b 644 -490 655 -564 651 -528 b 611 -336 640 -471 611 -336 b 611 -336 611 -336 611 -336 b 598 -339 610 -336 605 -337 b 536 -349 579 -343 558 -347 b 498 -350 529 -350 514 -350 b 449 -349 478 -350 457 -350 b 0 149 189 -320 0 -110 b 102 460 0 264 33 364 b 342 742 175 562 250 650 l 374 774 l 360 839 b 342 922 352 874 344 912 b 321 1024 329 983 323 1013 b 312 1124 315 1057 312 1091 b 477 1523 312 1275 371 1420 b 521 1558 501 1546 513 1556 z m 591 1349 b 574 1351 586 1350 580 1351 b 471 1297 542 1351 506 1332 b 376 1044 410 1236 376 1145 b 383 967 376 1019 378 993 b 415 814 385 956 414 814 b 415 814 415 814 415 814 b 460 860 416 814 450 848 b 644 1242 578 991 644 1132 b 639 1295 644 1261 643 1278 b 591 1349 632 1327 618 1342 z m 418 565 b 415 577 417 571 416 577 b 290 431 412 577 327 479 b 160 220 210 331 182 284 b 135 74 143 172 135 122 b 209 -162 135 -11 160 -94 b 495 -314 278 -259 385 -314 b 550 -310 514 -314 532 -313 b 602 -296 570 -306 602 -298 b 574 -164 602 -295 590 -236 b 522 81 559 -92 535 18 b 497 196 508 144 497 196 b 497 196 497 196 497 196 b 457 179 493 196 469 186 b 358 16 391 144 358 79 b 438 -128 358 -40 384 -95 b 455 -151 449 -135 455 -143 b 448 -165 455 -156 452 -160 b 434 -172 444 -169 440 -172 b 401 -159 427 -172 417 -168 b 256 82 305 -110 256 -15 b 386 322 256 172 299 264 b 462 358 408 337 453 358 b 462 359 462 358 462 358 b 462 360 462 359 462 359 b 418 565 462 362 422 547 z m 581 203 b 558 204 576 204 565 204 l 545 204 l 546 202 b 589 -1 546 201 565 109 b 634 -214 613 -112 633 -208 b 642 -251 636 -220 639 -237 l 648 -277 l 651 -275 b 776 -137 710 -241 752 -195 b 795 -42 789 -106 795 -73 b 581 203 795 78 707 188 z"
                },
                cClef: {
                    x_min: 0,
                    x_max: 643,
                    y_min: -508,
                    y_max: 508,
                    ha: 1016,
                    o: "m 0 0 l 0 731 l 87 731 l 175 731 l 175 0 l 175 -731 l 87 -731 l 0 -731 z m 240 0 l 240 731 l 262 731 l 284 731 l 284 382 l 284 32 l 291 38 b 374 145 318 61 351 104 b 439 314 402 196 423 251 b 458 341 444 338 447 341 b 475 319 470 341 474 335 b 647 120 483 206 560 120 b 665 122 653 120 659 121 b 771 330 741 132 766 181 b 772 404 772 357 772 381 b 707 662 772 557 753 630 b 615 687 684 679 651 687 b 517 666 582 687 548 680 b 504 660 509 663 504 660 b 504 660 504 660 504 660 b 578 578 545 658 578 621 b 578 575 578 577 578 576 b 492 494 576 524 534 494 b 419 534 465 494 437 506 b 403 584 408 550 403 567 b 434 651 403 608 413 632 b 616 721 485 698 550 721 b 884 565 720 721 826 665 b 925 406 912 515 925 460 b 719 99 925 272 846 140 b 648 87 694 91 671 87 b 543 122 610 87 576 99 b 536 126 540 124 536 126 b 535 126 535 126 535 126 b 497 63 535 126 518 98 l 459 0 l 497 -63 b 535 -126 518 -98 535 -126 b 536 -126 535 -126 535 -126 b 543 -122 536 -126 540 -124 b 648 -87 575 -99 610 -87 b 677 -89 657 -87 667 -88 b 924 -382 811 -110 913 -230 b 925 -407 925 -391 925 -399 b 639 -720 925 -570 803 -706 b 615 -721 631 -720 623 -721 b 430 -647 545 -721 478 -694 b 403 -585 412 -629 403 -607 b 492 -494 403 -538 439 -494 b 497 -494 493 -494 495 -494 b 578 -578 545 -496 578 -536 b 564 -625 578 -594 574 -610 b 504 -660 551 -644 525 -659 b 504 -660 504 -660 504 -660 b 517 -666 504 -660 509 -663 b 615 -687 548 -680 582 -687 b 707 -662 651 -687 684 -679 b 772 -404 753 -630 772 -557 b 771 -330 772 -381 772 -357 b 665 -122 766 -181 741 -132 b 647 -120 659 -121 653 -120 b 475 -319 560 -120 483 -206 b 458 -341 474 -335 470 -341 b 439 -314 447 -341 444 -338 b 374 -145 423 -251 402 -196 b 291 -38 351 -104 317 -61 l 284 -32 l 284 -382 l 284 -731 l 262 -731 l 240 -731 z"
                },
                fClef: {
                    x_min: 0,
                    x_max: 661,
                    y_min: -545,
                    y_max: 254,
                    ha: 798,
                    o: "m 326 364 b 356 365 336 365 346 365 b 647 278 464 365 575 332 b 788 -2 740 207 788 112 b 785 -51 788 -18 787 -34 b 161 -747 750 -356 500 -634 b 16 -784 110 -764 31 -784 b 0 -768 7 -784 0 -778 b 24 -747 0 -758 3 -755 b 601 -72 353 -625 575 -364 b 603 -10 602 -51 603 -30 b 469 298 603 133 556 243 b 346 332 432 321 389 332 b 100 185 248 332 146 277 b 89 161 97 178 89 162 b 89 161 89 161 89 161 b 95 164 90 161 92 162 b 169 185 118 179 144 185 b 308 74 232 185 293 142 b 311 42 310 63 311 53 b 167 -101 311 -36 248 -101 b 147 -99 161 -101 154 -100 b 9 79 65 -88 9 -15 l 9 79 b 326 364 9 228 148 353 z m 888 225 b 894 225 889 225 891 225 b 914 223 901 225 910 224 b 952 171 940 214 952 192 b 914 118 952 149 939 127 b 898 116 910 117 904 116 b 881 118 892 116 886 117 b 843 170 856 127 843 149 b 888 225 843 195 859 219 z m 888 -116 b 894 -116 889 -116 891 -116 b 914 -118 901 -116 910 -117 b 952 -170 940 -127 952 -149 b 914 -223 952 -192 939 -214 b 898 -225 910 -224 904 -225 b 881 -223 892 -225 886 -224 b 843 -171 856 -214 843 -193 b 888 -116 843 -146 859 -122 z"
                },
                unpitchedPercussionClef1: {
                    x_min: -4,
                    x_max: 337,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m -6 0 l -6 360 l 75 360 l 157 360 l 157 0 l 157 -360 l 75 -360 l -6 -360 z m 321 0 l 321 360 l 403 360 l 485 360 l 485 0 l 485 -360 l 403 -360 l 321 -360 z"
                },
                "6stringTabClef": {
                    x_min: 0,
                    x_max: 501,
                    y_min: -735,
                    y_max: 753,
                    ha: 1487,
                    o: "m 633 1083 b 639 1084 635 1084 637 1084 b 669 1072 650 1084 661 1079 b 681 1043 677 1063 681 1053 b 657 1004 681 1028 673 1013 b 467 964 609 980 535 964 l 452 964 l 452 959 b 456 874 455 932 456 903 b 418 611 456 781 443 686 b 245 415 380 495 327 435 b 195 409 228 411 214 409 b 147 412 182 409 167 410 b 110 453 124 414 110 433 b 122 482 110 464 114 474 b 151 494 130 490 141 494 b 184 478 163 494 175 489 b 194 475 186 476 190 475 b 224 486 202 475 213 479 b 283 575 246 500 263 527 b 335 871 317 657 335 760 b 331 967 335 903 334 935 l 330 980 l 321 982 b 260 992 301 989 280 992 b 139 927 206 992 160 968 b 90 895 128 906 109 895 b 42 933 70 895 49 908 b 40 947 40 937 40 942 b 105 1020 40 972 61 996 b 263 1058 150 1045 207 1058 b 350 1047 293 1058 323 1054 b 465 1030 389 1036 429 1030 b 612 1073 526 1030 579 1045 b 633 1083 618 1078 625 1082 z m 441 376 b 448 376 443 376 445 376 b 470 374 456 376 465 375 b 511 321 494 366 509 346 b 534 155 515 283 525 210 b 621 -190 556 21 589 -109 b 668 -253 632 -220 651 -245 l 672 -254 l 676 -253 b 687 -252 680 -252 683 -252 b 721 -287 707 -252 721 -269 b 705 -316 721 -298 716 -309 b 676 -321 699 -320 689 -321 b 650 -319 668 -321 659 -321 b 506 -206 588 -312 533 -269 b 444 0 487 -163 460 -72 b 441 8 443 4 441 8 b 441 8 441 8 441 8 b 436 -3 441 7 438 2 b 381 -99 422 -33 400 -72 b 375 -109 377 -105 375 -107 b 381 -114 375 -111 377 -112 b 435 -133 398 -126 415 -132 b 452 -138 446 -134 448 -134 b 457 -150 455 -141 457 -145 b 446 -166 457 -156 453 -163 b 406 -174 434 -171 420 -174 b 344 -160 385 -174 363 -169 l 337 -156 l 334 -159 b 49 -314 250 -255 145 -311 b 39 -315 45 -315 42 -315 b 10 -305 23 -315 18 -312 b 0 -281 3 -298 0 -290 b 34 -247 0 -264 14 -247 b 40 -248 36 -247 38 -247 b 46 -248 42 -248 44 -248 b 144 -208 69 -248 108 -233 b 390 306 283 -115 381 90 b 394 334 391 320 392 328 b 441 376 401 356 419 372 z m 376 -371 b 408 -371 383 -371 395 -371 b 451 -372 425 -371 444 -371 b 529 -388 482 -376 502 -380 b 689 -546 621 -417 689 -484 b 563 -696 689 -599 639 -658 l 552 -701 l 561 -705 b 700 -882 646 -748 700 -818 b 699 -896 700 -887 700 -892 b 503 -1054 689 -974 608 -1039 b 451 -1058 486 -1057 468 -1058 b 272 -1010 389 -1058 329 -1042 b 248 -972 257 -1001 248 -987 b 249 -963 248 -969 248 -966 l 250 -959 l 249 -960 b 241 -966 248 -961 244 -964 b 124 -1015 208 -992 168 -1009 b 90 -1017 118 -1016 104 -1017 b 48 -1015 72 -1017 52 -1016 b 19 -977 30 -1009 19 -993 b 31 -949 19 -967 23 -957 b 59 -937 39 -941 49 -937 b 85 -947 68 -937 77 -941 l 88 -951 l 94 -951 b 210 -845 134 -951 183 -906 b 220 -821 212 -840 216 -830 b 286 -526 264 -724 286 -623 b 283 -469 286 -507 285 -488 b 282 -459 283 -463 282 -459 b 282 -459 282 -459 282 -459 b 256 -469 281 -459 266 -464 b 141 -563 201 -491 160 -526 b 94 -592 130 -583 112 -592 b 43 -540 68 -592 43 -573 b 88 -476 43 -518 51 -505 b 376 -371 158 -418 261 -381 z m 432 -437 b 411 -437 427 -437 418 -437 l 399 -437 l 400 -440 b 406 -505 402 -448 405 -478 b 407 -527 407 -512 407 -520 b 334 -840 407 -628 382 -737 b 284 -925 315 -881 304 -901 b 280 -930 281 -928 280 -929 b 281 -930 280 -930 280 -930 b 284 -930 281 -930 282 -930 b 291 -929 286 -929 288 -929 b 320 -941 300 -929 310 -933 b 452 -991 362 -975 405 -991 l 452 -991 b 580 -883 531 -991 580 -941 b 538 -791 580 -852 566 -820 b 421 -733 508 -761 470 -742 b 392 -715 405 -730 397 -724 b 388 -698 389 -709 388 -703 b 420 -665 388 -681 401 -667 b 567 -563 490 -658 555 -613 b 569 -546 568 -557 569 -552 b 432 -437 569 -493 510 -444 z"
                },
                timeSig0: {
                    x_min: 0,
                    x_max: 380,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 249 313 b 272 314 256 314 264 314 b 428 259 325 314 385 293 b 547 0 505 196 547 105 b 544 -49 547 -16 546 -32 b 273 -314 526 -197 407 -314 b 32 -149 175 -314 81 -250 b 0 0 11 -105 0 -53 b 32 150 0 53 11 106 b 249 313 78 242 158 302 z m 293 279 b 273 281 286 280 280 281 b 203 251 242 281 216 270 b 170 -3 185 224 170 102 b 172 -59 170 -23 171 -42 b 203 -251 178 -163 189 -231 b 273 -281 216 -270 243 -281 b 306 -277 284 -281 295 -280 b 366 -160 344 -267 356 -243 b 376 0 373 -103 376 -51 b 366 160 376 51 373 103 b 293 279 355 250 341 272 z m 273 -360 l 275 -360 l 272 -360 z m 273 340 l 275 340 l 272 340 z"
                },
                timeSig1: {
                    x_min: 0,
                    x_max: 254,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 135 302 b 210 303 137 303 141 303 b 235 303 219 303 228 303 b 290 298 290 303 286 303 b 295 70 295 293 295 314 b 300 -219 295 -201 295 -202 b 352 -269 307 -239 324 -255 b 366 -287 361 -274 366 -280 b 361 -298 366 -291 364 -295 b 266 -303 357 -303 367 -303 b 210 -303 250 -303 232 -303 b 154 -303 188 -303 170 -303 b 59 -298 53 -303 63 -303 b 54 -287 55 -295 54 -291 b 68 -269 54 -280 59 -274 b 120 -219 96 -255 113 -239 b 125 -50 124 -205 125 -193 b 125 24 125 -29 125 -4 l 125 189 l 120 181 b 90 136 116 176 103 156 b 48 72 77 116 58 87 b 16 38 26 38 26 38 b 0 54 6 38 0 45 b 0 56 0 55 0 55 l 0 60 l 64 178 b 135 302 128 296 130 299 z m 183 -360 l 184 -360 l 182 -360 z m 183 340 l 184 340 l 182 340 z"
                },
                timeSig2: {
                    x_min: 0,
                    x_max: 337,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 210 313 b 232 314 217 314 224 314 b 317 303 261 314 293 310 b 459 147 407 277 459 217 b 441 77 459 124 453 101 b 258 -67 409 10 349 -37 b 76 -181 173 -95 117 -130 l 73 -185 l 77 -182 b 226 -128 121 -146 174 -128 b 322 -152 260 -128 293 -136 b 378 -173 346 -165 359 -170 b 395 -174 383 -174 389 -174 b 454 -149 421 -174 446 -164 b 470 -139 457 -142 464 -139 b 486 -155 478 -139 486 -145 b 462 -217 486 -165 474 -197 b 319 -313 428 -276 373 -313 l 318 -313 b 273 -300 296 -313 290 -311 b 133 -256 226 -271 178 -256 b 93 -260 119 -256 106 -257 b 32 -294 68 -265 41 -280 b 15 -303 28 -300 21 -303 b 1 -292 9 -303 3 -299 b 0 -284 0 -291 0 -288 b 6 -234 0 -271 3 -249 b 180 -36 28 -147 90 -75 b 303 122 246 -7 290 50 b 305 146 305 130 305 138 b 272 225 305 177 294 204 b 185 259 249 248 220 259 b 163 257 178 259 170 258 b 152 256 155 257 152 256 b 155 253 152 255 153 254 b 191 188 180 238 191 213 b 138 112 191 156 173 124 b 112 108 129 109 120 108 b 29 191 67 108 29 146 b 33 214 29 199 30 206 b 210 313 46 263 122 305 z m 243 -360 l 244 -360 l 241 -360 z m 243 340 l 244 340 l 241 340 z"
                },
                timeSig3: {
                    x_min: 0,
                    x_max: 302,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 179 313 b 209 314 189 314 199 314 b 429 163 327 314 429 247 b 282 29 429 110 369 56 l 272 26 l 275 25 b 430 -111 354 -1 413 -53 b 435 -147 433 -123 435 -136 b 268 -308 435 -222 369 -288 b 211 -314 249 -312 230 -314 b 24 -241 140 -314 72 -288 b 0 -185 7 -224 0 -204 b 82 -100 0 -142 35 -100 b 97 -101 87 -100 92 -100 b 162 -180 140 -109 162 -145 b 113 -251 162 -209 146 -239 b 110 -253 111 -252 110 -252 b 120 -256 110 -253 113 -254 b 164 -261 136 -260 150 -261 b 248 -228 197 -261 226 -250 b 281 -145 270 -206 281 -178 b 278 -112 281 -135 280 -123 b 157 10 264 -42 215 7 b 135 27 141 11 135 16 b 157 44 135 39 141 43 b 272 137 210 47 257 85 b 276 162 275 145 276 154 b 194 256 276 206 244 245 b 167 258 188 258 178 258 b 124 255 152 258 136 257 l 119 254 l 123 252 b 162 186 149 238 162 212 b 108 110 162 154 144 121 b 83 105 100 107 91 105 b 0 189 37 105 0 144 b 8 224 0 200 3 212 b 179 313 28 266 103 305 z m 217 -360 l 219 -360 l 216 -360 z m 217 340 l 219 340 l 216 340 z"
                },
                timeSig4: {
                    x_min: 0,
                    x_max: 345,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 184 302 b 304 303 186 303 247 303 b 403 302 354 303 401 303 b 412 286 409 299 412 294 b 392 256 412 280 411 278 b 260 108 374 236 318 173 b 222 67 243 89 226 71 b 165 3 218 62 193 34 b 90 -82 138 -28 104 -66 b 65 -111 77 -97 65 -110 b 64 -111 64 -111 64 -111 b 160 -112 64 -112 74 -112 l 257 -112 l 257 -43 b 259 27 257 24 257 25 b 307 82 259 28 281 53 b 373 156 332 110 362 144 b 409 188 402 189 401 188 b 425 179 416 188 422 185 b 426 32 426 176 426 171 l 426 -112 l 452 -112 b 481 -113 476 -112 477 -112 b 494 -134 489 -116 494 -125 b 488 -149 494 -139 492 -145 b 452 -156 482 -155 481 -156 l 426 -156 l 426 -162 b 427 -183 427 -165 427 -175 b 484 -269 428 -227 441 -248 b 497 -287 493 -274 497 -280 b 493 -298 497 -291 496 -295 b 397 -303 488 -303 499 -303 b 341 -303 382 -303 363 -303 b 285 -303 320 -303 301 -303 b 190 -298 184 -303 195 -303 b 185 -287 187 -295 185 -291 b 199 -269 185 -280 190 -274 b 256 -183 242 -248 255 -227 b 256 -162 256 -175 256 -165 l 257 -156 l 135 -156 b 90 -156 117 -156 102 -156 b 5 -151 2 -156 9 -155 b 0 -140 2 -148 0 -144 b 9 -122 0 -135 3 -129 b 174 272 110 -9 170 134 b 184 302 175 295 176 298 z m 249 -360 l 250 -360 l 247 -360 z m 249 340 l 250 340 l 247 340 z"
                },
                timeSig5: {
                    x_min: 0,
                    x_max: 302,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 51 302 b 57 303 53 302 55 303 b 71 300 61 303 65 302 b 224 275 117 283 170 275 b 391 300 279 275 336 283 b 406 303 398 302 402 303 b 417 298 411 303 414 301 b 421 288 420 295 421 292 b 411 260 421 282 418 274 b 278 157 378 194 340 165 b 226 154 262 155 244 154 b 78 175 177 154 124 161 b 66 179 72 177 66 179 b 56 64 66 178 56 68 b 56 64 56 64 56 64 b 56 64 56 64 56 64 b 63 67 57 64 60 65 b 159 96 89 81 124 92 b 201 98 168 97 185 98 b 227 97 212 98 222 98 b 434 -104 351 80 434 -1 l 434 -105 b 239 -312 434 -208 353 -294 b 212 -314 230 -313 221 -314 b 23 -229 148 -314 76 -282 b 0 -174 7 -213 0 -193 b 82 -89 0 -131 35 -89 b 97 -90 87 -89 92 -89 b 162 -168 140 -98 162 -133 b 108 -242 162 -199 145 -230 l 102 -244 l 109 -247 b 159 -259 127 -255 143 -259 b 215 -241 178 -259 197 -253 b 281 -99 258 -212 281 -161 b 277 -51 281 -84 280 -68 b 211 62 267 6 241 51 l 205 64 l 189 64 b 57 24 142 64 96 50 b 37 14 43 14 42 14 b 20 30 26 14 20 20 b 43 293 20 41 42 290 b 51 302 44 297 48 300 z m 222 -276 b 222 -276 222 -276 222 -276 b 218 -277 221 -276 221 -276 b 216 -279 217 -278 216 -279 b 216 -279 216 -279 216 -279 b 222 -276 217 -279 222 -276 z m 217 -360 l 219 -360 l 216 -360 z m 217 340 l 219 340 l 216 340 z"
                },
                timeSig6: {
                    x_min: 0,
                    x_max: 349,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 272 313 b 295 314 278 314 286 314 b 350 308 314 314 336 312 b 473 226 402 295 458 259 b 481 191 479 215 481 203 b 399 108 481 147 444 108 b 373 112 390 108 382 109 b 319 187 337 124 319 156 b 372 260 319 218 337 249 b 378 263 375 262 378 263 b 378 263 378 263 378 263 b 347 275 378 264 358 271 b 305 280 333 278 319 280 b 220 242 270 280 239 267 b 178 110 201 217 187 173 b 170 31 175 88 170 41 b 170 29 170 30 170 29 b 170 29 170 29 170 29 b 180 32 171 29 175 30 b 273 52 213 45 243 52 b 364 33 302 52 332 45 b 487 -64 422 11 466 -24 b 502 -128 497 -83 502 -105 b 479 -208 502 -156 494 -185 b 272 -314 439 -268 345 -314 b 239 -310 260 -314 249 -313 b 9 -77 129 -284 35 -188 b 0 6 3 -53 0 -23 b 5 65 0 26 2 47 b 272 313 27 193 137 296 z m 290 17 b 273 19 284 18 279 19 b 227 2 254 19 236 13 b 198 -122 209 -17 198 -69 b 201 -175 198 -140 199 -158 b 274 -280 214 -258 229 -280 l 274 -280 b 341 -193 315 -280 329 -262 b 349 -123 346 -166 349 -145 b 344 -66 349 -105 347 -87 b 290 17 334 -9 321 12 z m 251 -360 l 253 -360 l 250 -360 z m 251 340 l 253 340 l 250 340 z"
                },
                timeSig7: {
                    x_min: 0,
                    x_max: 326,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 162 314 b 179 315 168 315 174 315 b 333 260 232 315 290 294 b 361 249 343 252 350 249 b 370 250 364 249 367 249 b 435 291 395 253 417 267 b 453 303 442 299 447 303 b 460 302 455 303 457 303 b 469 288 466 299 469 296 b 456 233 469 279 465 263 b 369 16 433 146 396 56 b 290 -268 322 -53 293 -159 b 280 -302 289 -295 289 -298 b 192 -303 278 -303 235 -303 b 105 -302 150 -303 107 -303 b 96 -281 98 -298 96 -294 b 96 -280 96 -280 96 -280 b 178 -54 96 -212 128 -124 b 279 57 207 -12 235 18 b 399 198 335 107 368 146 b 404 207 402 204 404 206 b 403 207 404 207 404 207 b 400 205 403 207 402 206 b 258 155 357 172 306 155 b 132 201 212 155 167 171 b 90 222 117 215 103 222 b 58 201 78 222 67 215 b 33 141 49 187 41 168 b 16 128 30 133 23 128 b 1 138 10 128 4 131 b 0 216 0 140 0 178 b 1 293 0 253 0 291 b 15 303 4 300 9 303 b 30 298 20 303 25 301 b 52 289 37 292 43 289 b 96 300 62 289 75 293 b 162 314 124 309 140 312 z m 234 -360 l 236 -360 l 233 -360 z m 234 340 l 236 340 l 233 340 z"
                },
                timeSig8: {
                    x_min: 0,
                    x_max: 360,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 246 314 b 260 314 252 314 258 314 b 261 314 261 314 261 314 b 275 313 263 314 269 314 b 399 276 317 312 363 298 b 486 136 456 242 486 189 b 441 29 486 99 471 61 l 435 23 l 441 19 b 518 -119 492 -16 518 -67 b 483 -217 518 -153 507 -187 b 259 -314 435 -279 349 -314 b 138 -291 218 -314 176 -307 b 0 -118 48 -256 0 -187 b 76 18 0 -69 25 -20 l 83 23 l 77 30 b 32 137 48 61 32 99 b 42 189 32 155 36 172 b 246 314 70 260 152 310 z m 282 267 b 260 269 276 269 268 269 b 228 266 249 269 237 268 b 168 214 192 258 168 235 b 171 202 168 210 169 206 b 354 62 190 162 270 101 l 359 60 l 362 65 b 380 136 375 88 380 112 b 282 267 380 196 342 254 z m 148 -20 b 139 -16 144 -18 139 -16 b 139 -16 139 -16 139 -16 b 119 -36 137 -16 124 -29 b 91 -118 100 -62 91 -90 b 188 -255 91 -174 126 -229 b 257 -269 210 -265 234 -269 b 356 -229 298 -269 336 -255 b 368 -196 364 -218 368 -208 b 350 -151 368 -183 362 -168 b 166 -28 317 -101 256 -61 b 148 -20 161 -26 153 -23 z m 259 -360 l 261 -360 l 258 -360 z m 259 340 l 261 340 l 258 340 z"
                },
                timeSig9: {
                    x_min: 0,
                    x_max: 349,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 208 313 b 227 314 214 314 220 314 b 332 284 259 314 295 304 b 497 61 420 236 480 155 b 503 -4 501 42 503 19 b 498 -65 503 -26 501 -47 b 279 -303 479 -176 393 -269 b 204 -314 253 -310 228 -314 b 98 -287 166 -314 130 -305 b 25 -216 58 -265 33 -241 b 22 -191 23 -208 22 -199 b 104 -108 22 -146 59 -108 b 130 -112 112 -108 121 -109 b 184 -187 166 -124 184 -156 b 131 -260 184 -218 166 -249 b 125 -263 128 -262 125 -263 b 125 -263 125 -263 125 -263 b 156 -275 125 -264 144 -271 b 197 -280 170 -278 184 -280 b 279 -247 231 -280 260 -269 b 324 -117 300 -223 313 -182 b 333 -31 328 -93 333 -42 b 332 -29 333 -30 333 -29 b 332 -29 332 -29 332 -29 b 323 -32 332 -29 328 -30 b 230 -52 289 -45 260 -52 b 173 -44 211 -52 192 -49 b 23 50 108 -27 51 9 b 0 128 8 74 0 101 b 34 222 0 161 11 194 b 208 313 70 266 142 304 z m 248 278 b 231 281 243 280 237 281 b 195 272 217 281 203 277 b 156 156 176 259 163 221 b 154 124 154 146 154 135 b 183 -2 154 72 166 16 b 230 -19 194 -13 212 -19 b 276 -2 248 -19 266 -13 b 305 122 294 17 305 69 b 301 175 305 140 304 158 b 248 278 290 246 278 270 z m 251 -360 l 253 -360 l 250 -360 z m 251 340 l 253 340 l 250 340 z"
                },
                timeSigCommon: {
                    x_min: 0,
                    x_max: 409,
                    y_min: -233,
                    y_max: 233,
                    ha: 466,
                    o: "m 315 334 b 343 336 324 335 334 336 b 558 227 431 336 512 296 b 575 174 570 210 575 192 b 475 74 575 122 533 74 b 472 74 474 74 473 74 b 380 167 417 76 380 120 b 402 225 380 187 387 207 b 469 256 418 244 444 256 b 484 254 474 256 479 255 b 487 254 485 254 487 254 b 488 254 488 254 488 254 b 479 260 488 254 485 256 b 346 302 439 289 398 302 l 345 302 b 154 -3 205 302 154 220 b 154 -3 154 -3 154 -3 b 316 -302 154 -225 195 -300 b 321 -302 318 -302 320 -302 b 556 -108 438 -302 536 -221 b 573 -87 558 -92 562 -87 b 589 -105 584 -87 589 -93 b 582 -144 589 -114 587 -127 b 393 -327 556 -233 484 -302 b 321 -336 371 -333 346 -336 b 248 -327 296 -336 271 -333 b 7 -69 125 -296 32 -196 b 0 -1 2 -46 0 -24 b 315 334 0 170 131 317 z"
                },
                timeSigCutCommon: {
                    x_min: 0,
                    x_max: 409,
                    y_min: -394,
                    y_max: 394,
                    ha: 788,
                    o: "m 308 566 b 316 568 311 567 314 568 b 337 554 325 568 334 562 b 338 446 338 550 338 549 l 338 341 l 355 341 b 558 232 437 339 514 298 b 575 179 570 216 575 197 b 475 79 575 128 533 79 b 472 79 474 79 473 79 b 380 172 417 81 380 126 b 402 231 380 192 387 213 b 469 261 418 250 444 261 b 484 260 474 261 479 261 b 487 259 485 259 487 259 b 488 259 488 259 488 259 b 479 266 488 260 485 262 b 354 307 442 292 400 306 l 338 308 l 338 6 l 338 -297 l 340 -296 b 347 -296 341 -296 344 -296 b 555 -103 449 -288 538 -205 b 573 -82 558 -87 562 -82 b 589 -100 584 -82 589 -87 b 582 -138 589 -109 587 -121 b 374 -326 554 -234 473 -307 b 342 -330 366 -327 356 -328 l 338 -330 l 338 -440 b 339 -489 338 -460 339 -476 b 332 -561 339 -563 338 -555 b 317 -568 328 -566 322 -568 b 296 -554 308 -568 299 -563 b 295 -440 295 -550 295 -549 l 295 -330 l 293 -329 b 282 -328 291 -329 287 -328 b 7 -63 146 -310 35 -203 b 0 4 2 -41 0 -18 b 259 331 0 156 103 291 b 294 338 269 333 292 338 b 295 444 295 338 295 385 b 296 554 295 549 295 550 b 308 566 298 559 303 564 z m 295 4 b 294 303 295 288 295 303 b 284 301 293 303 288 302 b 154 3 190 276 154 192 l 154 2 b 291 -295 154 -204 190 -283 l 295 -295 z"
                },
                timeSigPlus: {
                    x_min: 0,
                    x_max: 235,
                    y_min: -118,
                    y_max: 118,
                    ha: 235,
                    o: "m 159 168 b 169 169 162 169 166 169 b 198 153 180 169 192 163 b 202 97 202 146 202 147 l 202 87 l 202 33 l 257 33 l 267 33 b 322 29 317 33 315 33 b 339 0 333 22 339 11 b 323 -28 339 -11 333 -22 b 266 -33 315 -33 317 -33 l 257 -33 l 202 -33 l 202 -87 l 202 -97 b 198 -153 202 -148 202 -146 b 169 -169 191 -164 180 -169 b 141 -153 158 -169 147 -164 b 137 -97 137 -146 137 -147 l 137 -87 l 137 -33 l 82 -33 l 72 -33 b 16 -28 22 -33 23 -33 b 0 0 5 -22 0 -11 b 16 28 0 11 5 22 b 72 33 23 33 22 33 l 82 33 l 137 33 l 137 87 l 137 97 b 141 153 137 148 137 146 b 159 168 145 160 151 165 z"
                },
                timeSigPlusSmall: {
                    x_min: 0,
                    x_max: 235,
                    y_min: -118,
                    y_max: 118,
                    ha: 235,
                    o: "m 159 168 b 169 169 162 169 166 169 b 198 153 180 169 192 163 b 202 97 202 146 202 147 l 202 87 l 202 33 l 257 33 l 267 33 b 322 29 317 33 315 33 b 339 0 333 22 339 11 b 323 -28 339 -11 333 -22 b 266 -33 315 -33 317 -33 l 257 -33 l 202 -33 l 202 -87 l 202 -97 b 198 -153 202 -148 202 -146 b 169 -169 191 -164 180 -169 b 141 -153 158 -169 147 -164 b 137 -97 137 -146 137 -147 l 137 -87 l 137 -33 l 82 -33 l 72 -33 b 16 -28 22 -33 23 -33 b 0 0 5 -22 0 -11 b 16 28 0 11 5 22 b 72 33 23 33 22 33 l 82 33 l 137 33 l 137 87 l 137 97 b 141 153 137 148 137 146 b 159 168 145 160 151 165 z"
                },
                timeSigMinus: {
                    x_min: 0,
                    x_max: 235,
                    y_min: -23,
                    y_max: 23,
                    ha: 46,
                    o: "m 23 32 b 177 33 26 32 103 33 b 315 32 246 33 312 32 b 338 0 331 27 338 14 b 315 -32 338 -14 331 -27 b 169 -33 312 -33 241 -33 b 23 -32 98 -33 26 -33 b 0 0 8 -27 0 -14 b 23 32 0 13 8 26 z"
                },
                timeSigParensRight: {
                    x_min: 19,
                    x_max: 122,
                    y_min: -267,
                    y_max: 267,
                    ha: 535,
                    o: "m 36 384 b 44 385 38 385 41 385 b 65 367 52 385 55 383 b 176 0 139 251 176 126 b 65 -367 176 -125 139 -250 b 44 -385 56 -380 51 -385 b 36 -383 42 -385 39 -384 b 27 -370 30 -380 27 -377 b 33 -349 27 -365 29 -359 b 99 0 77 -242 99 -121 b 33 350 99 122 77 243 b 27 371 29 359 27 366 b 36 384 27 377 30 381 z"
                },
                timeSigParensRightSmall: {
                    x_min: 19,
                    x_max: 122,
                    y_min: -267,
                    y_max: 267,
                    ha: 535,
                    o: "m 36 384 b 44 385 38 385 41 385 b 65 367 52 385 55 383 b 176 0 139 251 176 126 b 65 -367 176 -125 139 -250 b 44 -385 56 -380 51 -385 b 36 -383 42 -385 39 -384 b 27 -370 30 -380 27 -377 b 33 -349 27 -365 29 -359 b 99 0 77 -242 99 -121 b 33 350 99 122 77 243 b 27 371 29 359 27 366 b 36 384 27 377 30 381 z"
                },
                timeSigParensLeft: {
                    x_min: -122,
                    x_max: -19,
                    y_min: -267,
                    y_max: 267,
                    ha: 534,
                    o: "m -51 383 b -44 385 -49 384 -46 385 b -29 375 -38 385 -31 381 b -27 369 -28 373 -27 372 b -33 349 -27 365 -29 360 b -98 54 -71 259 -91 167 b -99 0 -98 44 -99 22 b -98 -54 -99 -22 -98 -45 b -33 -349 -91 -167 -71 -259 b -27 -368 -28 -363 -27 -365 b -44 -385 -27 -378 -34 -385 b -65 -367 -52 -385 -55 -383 b -176 0 -139 -251 -176 -125 b -65 367 -176 125 -139 251 b -51 383 -57 379 -55 381 z"
                },
                timeSigParensLeftSmall: {
                    x_min: -122,
                    x_max: -19,
                    y_min: -267,
                    y_max: 267,
                    ha: 534,
                    o: "m -51 383 b -44 385 -49 384 -46 385 b -29 375 -38 385 -31 381 b -27 369 -28 373 -27 372 b -33 349 -27 365 -29 360 b -98 54 -71 259 -91 167 b -99 0 -98 44 -99 22 b -98 -54 -99 -22 -98 -45 b -33 -349 -91 -167 -71 -259 b -27 -368 -28 -363 -27 -365 b -44 -385 -27 -378 -34 -385 b -65 -367 -52 -385 -55 -383 b -176 0 -139 -251 -176 -125 b -65 367 -176 125 -139 251 b -51 383 -57 379 -55 381 z"
                },
                noteheadDoubleWhole: {
                    x_min: 0,
                    x_max: 663,
                    y_min: -174,
                    y_max: 174,
                    ha: 349,
                    o: "m 19 250 b 27 251 21 251 24 251 b 36 250 31 251 34 251 b 50 239 41 248 47 244 b 55 93 54 233 55 247 b 55 0 55 67 55 37 b 55 -93 55 -37 55 -67 b 50 -239 55 -247 54 -233 b 28 -251 45 -247 36 -251 b 1 -232 16 -251 5 -244 b 0 4 0 -230 0 -112 b 1 232 0 117 0 230 b 19 250 4 240 11 247 z m 117 250 b 126 251 119 251 122 251 b 134 250 129 251 132 251 b 152 232 142 247 149 240 b 153 128 153 229 153 214 b 154 31 153 48 153 31 b 154 31 154 31 154 31 b 417 191 176 112 281 176 b 478 194 437 193 458 194 b 801 31 636 194 776 127 b 801 31 801 31 801 31 b 802 128 802 31 802 48 b 805 237 802 235 802 232 b 830 251 811 246 821 251 b 852 239 839 251 847 247 b 857 93 857 233 857 247 b 857 0 857 67 857 37 b 857 -93 857 -37 857 -67 b 852 -239 857 -247 857 -233 b 830 -251 847 -247 838 -251 b 807 -239 821 -251 812 -247 b 802 -128 802 -232 802 -239 b 801 -31 802 -48 802 -31 b 801 -31 801 -31 801 -31 b 539 -191 779 -112 675 -176 b 477 -194 518 -193 498 -194 b 154 -31 319 -194 180 -127 b 154 -31 154 -31 154 -31 b 153 -128 153 -31 153 -48 b 148 -239 153 -239 153 -232 b 126 -251 143 -247 134 -251 b 99 -232 114 -251 103 -244 b 98 4 99 -230 98 -112 b 99 232 98 117 99 230 b 117 250 102 240 109 247 z m 458 168 b 439 169 452 169 445 169 b 332 44 375 169 332 116 b 344 -25 332 22 336 -1 b 517 -169 377 -116 452 -169 b 613 -101 558 -169 595 -148 b 623 -44 620 -83 623 -64 b 458 168 623 50 549 154 z m 919 250 b 928 251 921 251 924 251 b 936 250 931 251 934 251 b 951 239 942 248 947 244 b 955 93 955 233 955 247 b 955 0 955 67 955 36 b 955 -93 955 -37 955 -67 b 951 -239 955 -247 955 -233 b 928 -251 945 -247 937 -251 b 902 -232 917 -251 905 -244 b 900 4 901 -230 900 -112 b 901 232 900 117 901 230 b 919 250 904 240 911 247 z"
                },
                noteheadWhole: {
                    x_min: 0,
                    x_max: 455,
                    y_min: -135,
                    y_max: 135,
                    ha: 269,
                    o: "m 291 193 b 326 194 303 194 315 194 b 649 38 482 194 619 129 b 655 0 653 25 655 12 b 327 -194 655 -106 513 -194 b 0 0 144 -194 0 -109 b 291 193 0 100 124 182 z m 308 168 b 289 169 301 169 295 169 b 181 44 224 169 181 116 b 194 -26 181 22 185 -1 b 366 -169 226 -116 302 -169 b 463 -101 408 -169 445 -148 b 473 -45 470 -83 473 -64 b 308 168 473 50 398 154 z"
                },
                noteheadHalf: {
                    x_min: 0,
                    x_max: 316,
                    y_min: -135,
                    y_max: 135,
                    ha: 269,
                    o: "m 270 193 b 281 194 272 194 276 194 b 322 192 294 194 315 193 b 455 53 411 178 455 120 b 307 -156 455 -20 405 -104 b 166 -194 260 -182 211 -194 b 3 -81 84 -194 17 -153 b 0 -52 1 -72 0 -62 b 270 193 0 62 123 178 z m 388 139 b 372 141 383 140 378 141 b 99 -26 307 141 174 61 b 50 -116 68 -62 50 -96 b 60 -136 50 -125 53 -132 b 83 -141 66 -139 74 -141 b 367 40 152 -141 296 -52 b 405 115 392 72 405 98 b 388 139 405 127 399 135 z"
                },
                noteheadBlack: {
                    x_min: 0,
                    x_max: 316,
                    y_min: -135,
                    y_max: 135,
                    ha: 269,
                    o: "m 270 193 b 281 194 272 194 276 194 b 322 192 294 194 315 193 b 455 53 411 178 455 120 b 307 -156 455 -20 405 -104 b 166 -194 260 -182 211 -194 b 3 -81 84 -194 17 -153 b 0 -52 1 -72 0 -62 b 270 193 0 62 123 178 z"
                },
                noteheadXWhole: {
                    x_min: 0,
                    x_max: 440,
                    y_min: -133,
                    y_max: 133,
                    ha: 265,
                    o: "m 67 190 b 82 191 71 191 76 191 b 97 190 88 191 94 191 b 216 138 108 188 116 184 l 317 91 l 417 138 b 548 191 529 190 532 191 b 551 191 549 191 550 191 b 634 109 601 191 634 151 b 611 52 634 89 627 69 b 549 17 601 41 597 39 b 513 0 529 8 513 0 b 549 -17 513 0 529 -8 b 611 -52 597 -39 601 -41 b 634 -109 627 -69 634 -89 b 551 -191 634 -151 601 -191 b 548 -191 550 -191 549 -191 b 417 -138 532 -191 529 -190 l 317 -91 l 216 -138 b 86 -191 105 -190 102 -191 b 83 -191 85 -191 84 -191 b 0 -109 33 -191 0 -151 b 23 -52 0 -89 7 -69 b 85 -17 33 -41 37 -39 b 121 0 105 -8 121 0 b 85 17 121 0 105 8 b 23 52 37 39 33 41 b 0 109 7 69 0 89 b 67 190 0 146 26 182 z m 91 141 b 82 142 88 142 85 142 b 49 109 63 142 49 126 b 59 86 49 101 52 92 b 159 37 64 81 55 85 b 238 0 202 17 238 0 b 159 -37 238 0 202 -17 b 59 -86 55 -85 64 -81 b 49 -109 52 -92 49 -101 b 82 -142 49 -126 62 -142 l 82 -142 b 206 -88 91 -142 91 -141 b 317 -37 267 -60 317 -37 b 428 -88 317 -37 367 -60 b 551 -142 542 -141 543 -142 l 552 -142 b 584 -109 572 -142 584 -126 b 574 -86 584 -101 581 -92 b 475 -37 569 -81 578 -85 b 396 0 431 -17 396 0 b 475 37 396 0 431 17 b 574 86 578 85 569 81 b 584 109 581 92 584 101 b 552 142 584 126 572 142 l 551 142 b 428 88 543 142 542 141 b 317 37 367 60 317 37 b 206 88 317 37 267 60 b 91 141 145 117 93 140 z"
                },
                noteheadXHalf: {
                    x_min: 0,
                    x_max: 300,
                    y_min: -133,
                    y_max: 133,
                    ha: 265,
                    o: "m 60 189 b 76 191 65 190 71 191 b 118 179 91 191 106 187 b 169 138 121 177 144 159 l 216 100 l 262 138 b 325 185 312 179 314 181 b 355 191 335 189 345 191 b 431 115 397 191 431 156 b 426 86 431 105 430 96 b 372 29 419 69 415 64 b 337 0 353 14 337 0 b 372 -29 337 0 353 -14 b 426 -86 415 -64 419 -69 b 431 -115 430 -96 431 -105 b 355 -191 431 -156 397 -191 b 325 -185 345 -191 335 -189 b 262 -138 314 -181 312 -179 l 216 -100 l 169 -138 b 106 -185 120 -179 117 -181 b 76 -191 96 -189 86 -191 b 0 -115 35 -191 0 -156 b 6 -86 0 -105 2 -96 b 59 -29 12 -69 17 -64 b 94 0 78 -14 94 0 b 59 29 94 0 78 14 b 20 63 40 45 22 61 b 0 114 6 78 0 97 b 60 189 0 148 23 181 z m 88 140 b 77 142 85 141 81 142 b 56 133 69 142 61 139 b 49 115 51 128 49 121 b 55 98 49 109 51 103 b 114 48 56 96 82 74 b 171 0 146 22 171 0 b 114 -48 171 0 146 -22 b 55 -98 82 -74 56 -96 b 49 -114 51 -103 49 -109 b 65 -140 49 -125 55 -135 b 77 -142 68 -141 72 -142 b 88 -140 81 -142 85 -141 b 154 -87 91 -138 114 -120 b 216 -36 188 -59 216 -36 b 278 -87 216 -36 244 -59 b 343 -140 318 -120 341 -138 b 355 -142 346 -141 350 -142 b 367 -140 359 -142 364 -141 b 382 -114 377 -135 382 -125 b 377 -98 382 -109 381 -103 b 317 -48 376 -96 349 -74 b 260 0 286 -22 260 0 b 317 48 260 0 286 22 b 377 98 349 74 376 96 b 382 114 381 103 382 109 b 367 140 382 125 377 135 b 355 142 364 141 359 142 b 343 140 350 142 346 141 b 278 87 341 138 318 120 b 216 36 244 59 216 36 b 154 87 216 36 188 59 b 88 140 112 121 91 138 z"
                },
                noteheadXBlack: {
                    x_min: 0,
                    x_max: 300,
                    y_min: -133,
                    y_max: 133,
                    ha: 265,
                    o: "m 24 190 b 32 191 26 191 29 191 b 46 189 37 191 43 190 b 135 114 52 186 50 187 b 216 44 179 76 216 44 b 296 114 216 44 252 76 b 396 191 392 197 384 190 b 398 191 397 191 398 191 b 432 158 418 191 432 175 b 422 135 432 150 429 142 b 343 66 420 133 384 102 b 267 0 301 30 267 0 b 343 -66 267 0 301 -30 b 422 -135 384 -102 420 -133 b 432 -158 429 -142 432 -150 b 398 -191 432 -175 418 -191 b 396 -191 398 -191 397 -191 b 296 -114 384 -190 392 -197 b 216 -44 252 -76 216 -44 b 135 -114 216 -44 179 -76 b 35 -191 40 -197 48 -190 b 33 -191 35 -191 34 -191 b 0 -158 13 -191 0 -175 b 10 -135 0 -150 3 -142 b 89 -66 12 -133 48 -102 b 164 0 131 -30 164 0 b 89 66 164 0 131 30 b 10 135 48 102 12 133 b 0 158 3 142 0 150 b 24 190 0 172 9 186 z"
                },
                noteheadCircleX: {
                    x_min: 0,
                    x_max: 357,
                    y_min: -178,
                    y_max: 178,
                    ha: 357,
                    o: "m 242 256 b 256 257 249 257 253 257 b 270 256 260 257 263 257 b 514 0 412 248 514 131 b 496 -95 514 -31 508 -63 b 255 -257 454 -200 355 -257 b 61 -166 184 -257 112 -228 b 0 -2 19 -117 0 -58 b 242 256 0 126 96 248 z m 267 190 b 257 191 262 190 259 191 b 245 190 254 191 251 190 b 153 159 212 188 179 177 l 147 156 l 202 101 l 257 46 l 311 101 l 366 156 l 361 159 b 267 190 334 177 302 188 z m 155 -55 l 210 0 l 155 54 l 101 109 l 97 104 b 66 0 77 74 66 37 b 71 -44 66 -15 68 -30 b 97 -105 77 -66 86 -87 l 101 -110 z m 416 104 b 413 109 414 107 413 109 b 358 54 413 109 388 84 l 304 0 l 358 -55 l 413 -110 l 416 -105 b 447 0 437 -74 447 -37 b 416 104 447 36 437 73 z m 312 -102 b 257 -47 282 -72 257 -47 b 202 -102 257 -47 232 -72 l 147 -156 l 153 -160 b 257 -191 183 -180 220 -191 b 361 -160 294 -191 330 -180 l 366 -156 z"
                },
                noteheadTriangleUpWhole: {
                    x_min: 0,
                    x_max: 462,
                    y_min: -149,
                    y_max: 149,
                    ha: 297,
                    o: "m 326 213 b 333 214 327 214 330 214 b 355 194 342 214 344 212 b 647 -174 447 44 562 -101 b 659 -184 652 -178 657 -182 b 666 -198 664 -188 666 -193 b 650 -214 666 -207 660 -214 b 598 -200 645 -214 641 -213 b 333 -161 514 -174 423 -161 b 68 -200 242 -161 152 -174 b 16 -214 25 -213 20 -214 b 0 -198 7 -214 0 -208 b 12 -179 0 -190 1 -189 b 311 194 100 -106 216 40 b 326 213 320 208 322 211 z m 338 141 b 333 153 336 147 333 153 b 327 141 333 153 330 147 b 190 -130 285 41 232 -63 b 185 -138 187 -134 185 -138 b 185 -138 185 -138 185 -138 b 185 -138 185 -138 185 -138 b 195 -137 187 -138 190 -138 b 224 -134 201 -136 214 -135 b 333 -128 260 -130 296 -128 b 410 -131 359 -128 384 -129 b 470 -137 425 -132 454 -135 b 480 -138 475 -138 479 -138 b 481 -138 481 -138 481 -138 b 481 -138 481 -138 481 -138 b 478 -133 481 -138 479 -135 b 338 141 436 -67 381 40 z"
                },
                noteheadTriangleUpHalf: {
                    x_min: 0,
                    x_max: 323,
                    y_min: -149,
                    y_max: 149,
                    ha: 298,
                    o: "m 225 213 b 232 214 227 214 230 214 b 253 191 242 214 245 212 b 447 -169 316 42 385 -85 b 465 -198 461 -187 465 -193 b 463 -204 465 -200 464 -202 b 450 -214 461 -211 457 -214 b 431 -208 446 -214 439 -212 b 233 -162 368 -178 300 -162 b 33 -208 165 -162 97 -178 b 15 -214 25 -212 19 -214 b 5 -209 11 -214 8 -213 b 0 -199 2 -206 0 -203 b 9 -181 0 -194 3 -188 b 213 194 67 -109 149 42 b 225 213 218 208 220 211 z m 280 51 b 264 85 274 62 267 78 l 258 98 l 248 83 b 93 -135 201 9 143 -73 b 87 -143 90 -139 87 -143 b 87 -144 87 -144 87 -144 b 87 -144 87 -144 87 -144 b 94 -141 87 -144 90 -142 b 297 -98 162 -113 233 -98 b 354 -102 317 -98 336 -99 b 363 -104 359 -103 363 -104 b 363 -104 363 -104 363 -104 b 360 -97 363 -103 361 -101 b 280 51 337 -60 304 2 z"
                },
                noteheadTriangleUpBlack: {
                    x_min: 0,
                    x_max: 322,
                    y_min: -149,
                    y_max: 149,
                    ha: 297,
                    o: "m 224 213 b 232 214 226 213 229 214 b 250 197 241 214 244 211 b 277 135 269 152 270 149 b 288 111 280 127 285 117 b 336 12 296 92 330 23 b 344 -3 336 12 340 5 b 376 -60 360 -32 363 -38 b 452 -177 406 -112 430 -148 b 463 -198 463 -191 463 -191 b 447 -214 463 -208 458 -214 l 447 -214 l 441 -214 l 430 -208 b 232 -163 368 -178 300 -163 b 33 -208 163 -163 95 -178 l 22 -214 l 16 -214 l 16 -214 b 0 -198 6 -214 0 -208 b 11 -177 0 -191 0 -191 b 75 -81 29 -154 52 -120 b 119 -3 93 -52 102 -36 b 127 12 123 5 127 12 b 176 111 133 23 167 92 b 186 135 178 117 183 127 b 213 197 193 149 194 152 b 224 213 218 207 220 210 z"
                },
                noteheadDiamondWhole: {
                    x_min: 0,
                    x_max: 462,
                    y_min: -138,
                    y_max: 138,
                    ha: 277,
                    o: "m 326 198 b 333 199 328 199 330 199 b 350 189 340 199 342 198 b 638 20 417 112 517 53 b 654 16 645 19 652 17 b 666 0 662 14 666 7 b 654 -16 666 -7 662 -14 b 638 -20 652 -17 645 -19 b 352 -186 518 -53 419 -110 b 333 -199 342 -198 340 -199 b 316 -189 326 -199 324 -198 b 28 -20 249 -112 149 -53 b 12 -16 21 -19 14 -17 b 0 0 4 -14 0 -7 b 12 16 0 7 4 14 b 28 20 14 17 21 19 b 316 189 149 53 249 112 b 326 198 321 194 324 197 z m 338 143 b 333 149 335 146 333 149 b 328 143 333 149 331 146 b 172 4 290 85 233 35 b 165 0 168 2 165 0 b 172 -4 165 0 168 -2 b 328 -143 233 -35 290 -85 b 333 -149 331 -147 332 -149 b 335 -146 334 -149 334 -148 b 494 -4 370 -91 432 -35 b 501 0 498 -2 501 0 b 494 4 501 0 498 2 b 338 143 433 35 376 85 z"
                },
                noteheadDiamondHalf: {
                    x_min: 0,
                    x_max: 322,
                    y_min: -138,
                    y_max: 138,
                    ha: 277,
                    o: "m 225 198 b 232 199 227 199 229 199 b 251 183 240 199 243 197 b 445 19 295 109 362 52 b 464 0 461 13 464 10 b 447 -18 464 -9 460 -13 b 251 -183 365 -49 294 -109 b 232 -199 243 -197 240 -199 b 213 -183 224 -199 221 -197 b 19 -19 169 -109 102 -52 b 0 0 3 -13 0 -10 b 17 18 0 9 3 13 b 213 183 99 50 169 109 b 225 198 218 193 221 196 z m 255 119 b 251 122 253 121 252 122 b 244 114 250 122 249 120 b 98 -17 208 61 151 10 l 95 -19 l 98 -21 b 211 -120 138 -44 176 -78 b 213 -123 212 -122 212 -123 b 213 -122 213 -123 213 -122 b 366 17 244 -72 311 -11 l 369 19 l 366 21 b 255 119 327 44 283 82 z"
                },
                noteheadDiamondBlack: {
                    x_min: 0,
                    x_max: 322,
                    y_min: -138,
                    y_max: 138,
                    ha: 277,
                    o: "m 225 198 b 232 199 227 199 229 199 b 253 180 241 199 243 197 b 444 19 297 107 363 52 b 464 0 461 13 464 10 b 444 -19 464 -10 461 -13 b 253 -180 363 -52 297 -107 b 232 -199 243 -197 241 -199 b 211 -180 223 -199 221 -197 b 19 -19 167 -107 101 -52 b 0 0 3 -13 0 -10 b 19 19 0 10 3 13 b 211 180 101 52 167 107 b 225 198 219 194 221 196 z"
                },
                augmentationDot: {
                    x_min: -63,
                    x_max: 63,
                    y_min: -63,
                    y_max: 63,
                    ha: 126,
                    o: "m -18 89 b 0 90 -12 90 -6 90 b 90 0 49 90 90 49 b 89 -18 90 -6 90 -12 b -1 -90 79 -64 39 -90 b -70 -57 -26 -90 -52 -80 b -90 -1 -84 -40 -90 -20 b -18 89 -90 40 -63 79 z"
                },
                tremolo1: {
                    x_min: -252,
                    x_max: 216,
                    y_min: -185,
                    y_max: 148,
                    ha: 333,
                    o: "m 265 211 b 275 213 269 212 272 213 b 311 175 295 213 311 194 b 301 151 311 166 308 158 b 243 110 297 147 295 145 b 175 64 224 97 194 77 b 107 18 156 52 126 31 b 40 -27 89 6 58 -15 b -28 -73 21 -40 -9 -60 b -95 -119 -46 -86 -77 -106 b -162 -164 -113 -131 -144 -152 b -230 -210 -181 -177 -211 -197 b -285 -247 -249 -223 -274 -240 b -310 -263 -297 -255 -308 -263 b -326 -267 -315 -266 -321 -267 b -363 -230 -346 -267 -363 -250 b -357 -212 -363 -224 -361 -218 b -309 -174 -353 -205 -350 -202 b -203 -103 -287 -160 -240 -128 b -68 -11 -167 -78 -106 -37 b 67 80 -30 14 31 55 b 194 166 104 105 161 143 b 265 211 255 207 259 210 z"
                },
                flag8thUp: {
                    x_min: -17,
                    x_max: 234,
                    y_min: -745,
                    y_max: -4,
                    ha: 741,
                    o: "m -25 -167 l -25 -5 l -21 -5 b 1 -29 -9 -5 -3 -12 b 183 -326 32 -144 91 -241 b 336 -686 285 -421 336 -551 b 219 -1028 336 -802 298 -923 b 172 -1072 191 -1065 183 -1072 b 150 -1052 158 -1072 150 -1063 b 158 -1032 150 -1046 153 -1039 b 284 -707 241 -935 284 -818 b 185 -446 284 -610 251 -517 b -24 -328 144 -402 72 -361 b -25 -167 -24 -328 -25 -295 z"
                },
                flag8thDown: {
                    x_min: -15,
                    x_max: 271,
                    y_min: 4,
                    y_max: 745,
                    ha: 741,
                    o: "m 242 1071 b 252 1073 246 1072 249 1073 b 277 1051 260 1073 267 1066 b 390 687 352 938 390 810 b 343 464 390 609 374 533 b 248 331 319 413 285 365 b 60 125 166 256 110 194 b 0 21 35 90 10 47 b -19 5 -4 11 -12 5 l -22 5 l -22 167 l -22 328 l -17 328 b 105 350 13 328 69 338 b 334 722 241 396 334 547 b 240 1027 334 826 301 934 b 229 1050 230 1041 229 1044 b 242 1071 229 1060 234 1068 z"
                },
                flag16thUp: {
                    x_min: -17,
                    x_max: 234,
                    y_min: -847,
                    y_max: -4,
                    ha: 843,
                    o: "m -25 -151 l -25 -5 l -21 -5 b 0 -23 -11 -5 -5 -11 b 208 -289 31 -96 103 -189 b 336 -592 292 -369 336 -477 b 311 -740 336 -641 328 -691 l 308 -751 l 312 -762 b 336 -906 328 -808 336 -857 b 241 -1185 336 -1004 304 -1103 b 202 -1220 218 -1215 213 -1220 b 180 -1198 188 -1220 180 -1210 b 187 -1181 180 -1193 182 -1187 b 286 -923 252 -1106 286 -1015 b 283 -873 286 -906 285 -890 b 278 -844 281 -861 279 -849 b 274 -830 277 -842 276 -836 b 152 -651 255 -758 210 -692 b -10 -612 119 -628 51 -612 b -22 -611 -16 -612 -21 -612 l -25 -611 l -25 -465 l -25 -319 l -21 -319 b 0 -336 -11 -319 -5 -325 b 207 -602 31 -410 105 -504 b 275 -685 235 -628 260 -658 b 277 -688 276 -687 277 -688 b 280 -680 278 -688 279 -685 b 286 -609 284 -657 286 -633 b 280 -541 286 -586 284 -563 b 278 -530 280 -537 279 -532 b 274 -516 277 -528 276 -522 b 152 -337 255 -444 210 -378 b -10 -298 119 -315 51 -298 b -22 -298 -16 -298 -21 -298 l -25 -297 z"
                },
                flag16thDown: {
                    x_min: -15,
                    x_max: 267,
                    y_min: 4,
                    y_max: 745,
                    ha: 741,
                    o: "m 319 1071 b 328 1073 322 1072 325 1073 b 350 1054 337 1073 344 1067 b 384 901 373 1008 384 955 b 360 766 384 856 376 810 l 356 756 l 360 745 b 384 615 376 703 384 659 b 273 336 384 516 346 416 b 217 282 258 319 241 302 b -1 19 125 204 42 104 b -19 5 -5 11 -13 5 l -22 5 l -22 146 l -22 287 l -12 288 b 212 369 90 304 162 330 b 339 620 294 433 339 524 b 330 691 339 644 336 668 l 329 699 l 323 690 b 217 569 296 645 265 610 b -1 305 125 491 42 390 b -19 292 -5 297 -13 292 l -22 292 l -22 433 l -22 573 l -12 575 b 194 643 78 589 147 611 b 339 908 286 704 339 806 b 313 1030 339 950 330 991 b 306 1050 306 1045 306 1045 b 319 1071 306 1060 311 1068 z"
                },
                flag32ndUp: {
                    x_min: -17,
                    x_max: 233,
                    y_min: -1005,
                    y_max: 96,
                    ha: 1101,
                    o: "m -25 -6 l -25 139 l -21 139 b 1 121 -11 139 -6 134 b 172 -93 31 61 97 -21 b 201 -121 182 -103 195 -115 b 328 -375 266 -184 311 -274 b 335 -464 333 -404 335 -434 b 317 -612 335 -513 329 -564 l 313 -626 l 315 -632 b 328 -689 320 -647 325 -670 b 335 -778 333 -717 335 -747 b 317 -926 335 -827 329 -878 l 313 -940 l 315 -946 b 328 -1002 320 -961 325 -984 b 335 -1092 333 -1032 335 -1062 b 280 -1346 335 -1177 316 -1264 b 228 -1441 265 -1380 236 -1432 b 213 -1447 224 -1445 218 -1447 b 191 -1425 202 -1447 191 -1438 b 198 -1406 191 -1419 192 -1416 b 284 -1118 254 -1317 284 -1215 b 281 -1072 284 -1103 283 -1087 b 118 -798 269 -948 207 -844 b 6 -778 93 -785 60 -779 l -25 -778 l -25 -634 l -25 -489 l -21 -489 b 1 -507 -11 -489 -6 -494 b 172 -720 31 -567 97 -649 b 275 -848 229 -774 249 -800 l 281 -858 l 282 -849 b 284 -806 283 -834 284 -820 b 118 -484 284 -663 220 -537 b 6 -465 93 -471 60 -465 l -25 -464 l -25 -320 l -25 -175 l -21 -175 b 1 -193 -11 -175 -6 -180 b 172 -406 31 -253 97 -335 b 275 -534 229 -460 249 -486 l 281 -544 l 282 -535 b 284 -492 283 -521 284 -506 b 118 -170 284 -349 220 -223 b 6 -151 93 -157 60 -151 l -25 -151 z"
                },
                flag32ndDown: {
                    x_min: -15,
                    x_max: 270,
                    y_min: -96,
                    y_max: 895,
                    ha: 991,
                    o: "m 292 1287 b 300 1288 294 1288 297 1288 b 309 1287 303 1288 306 1288 b 374 1151 324 1281 359 1209 b 388 1039 383 1115 388 1077 b 368 904 388 993 381 947 l 365 896 l 368 886 b 374 864 370 881 372 871 b 388 752 383 828 388 790 b 368 618 388 706 381 660 l 365 609 l 368 599 b 374 578 370 594 372 584 b 388 467 384 541 388 504 b 236 128 388 339 334 215 b 201 99 226 119 226 119 b 0 -122 110 27 36 -55 b -19 -139 -5 -133 -12 -139 l -22 -139 l -22 0 l -22 138 l -16 138 b 200 215 66 150 144 178 b 340 485 287 273 340 376 b 336 531 340 501 339 516 l 335 540 l 333 537 b 236 415 306 488 275 449 b 201 385 226 406 226 405 b 0 164 110 313 36 231 b -19 148 -5 153 -12 148 l -22 148 l -22 286 l -22 424 l -16 425 b 200 501 66 437 144 464 b 340 772 287 559 340 663 b 336 818 340 787 339 803 l 335 827 l 333 823 b 236 701 306 774 275 735 b 201 672 226 692 226 692 b 0 451 110 600 36 518 b -19 434 -5 440 -12 434 l -22 434 l -22 572 l -22 711 l -16 711 b 219 802 77 725 165 759 b 339 1058 298 865 339 959 b 286 1246 339 1122 322 1187 b 278 1267 279 1258 278 1260 b 292 1287 278 1276 284 1284 z"
                },
                flag64thUp: {
                    x_min: -17,
                    x_max: 233,
                    y_min: -933,
                    y_max: 296,
                    ha: 1230,
                    o: "m -25 282 l -25 427 l -21 427 b 2 404 -9 427 -4 421 b 148 203 25 333 72 268 b 313 -42 230 134 277 64 b 335 -182 328 -86 335 -134 b 309 -332 335 -233 327 -284 l 307 -339 l 312 -354 b 335 -496 328 -399 335 -447 b 309 -646 335 -547 327 -598 l 307 -653 l 312 -668 b 335 -809 328 -713 335 -761 b 309 -960 335 -860 327 -911 l 307 -966 l 312 -981 b 335 -1122 328 -1027 335 -1075 b 288 -1325 335 -1191 320 -1260 b 265 -1344 281 -1340 276 -1344 b 243 -1322 252 -1344 243 -1335 b 251 -1300 243 -1317 243 -1316 b 289 -1125 276 -1244 289 -1184 b 173 -854 289 -1018 248 -915 b 34 -798 127 -816 83 -798 b -9 -802 20 -798 5 -800 b -21 -804 -14 -803 -20 -804 l -25 -804 l -25 -659 l -25 -515 l -21 -515 b 2 -537 -9 -515 -4 -520 b 148 -738 25 -609 72 -673 b 274 -892 204 -785 247 -838 b 279 -900 277 -898 279 -900 b 280 -898 280 -900 280 -899 b 282 -886 280 -897 281 -892 b 289 -811 287 -861 289 -836 b 173 -540 289 -703 246 -600 b 34 -484 127 -502 83 -484 b -9 -489 20 -484 5 -486 b -21 -490 -14 -489 -20 -490 l -25 -490 l -25 -346 l -25 -201 l -21 -201 b 2 -224 -9 -201 -4 -207 b 148 -424 25 -295 72 -360 b 274 -578 204 -471 247 -524 b 279 -586 277 -584 279 -586 b 280 -584 280 -586 280 -585 b 282 -573 280 -583 281 -578 b 289 -497 287 -548 289 -522 b 173 -226 289 -389 246 -286 b 34 -171 127 -188 83 -171 b -9 -175 20 -171 5 -172 b -21 -176 -14 -176 -20 -176 l -25 -176 l -25 -32 l -25 113 l -21 113 b 2 90 -9 113 -4 107 b 148 -110 25 19 72 -46 b 274 -264 204 -158 247 -210 b 279 -272 277 -270 279 -272 b 280 -270 280 -272 280 -272 b 282 -259 280 -269 281 -264 b 289 -184 287 -234 289 -208 b 173 88 289 -75 246 28 b 34 143 127 125 83 143 b -9 139 20 143 5 142 b -21 137 -14 138 -20 137 l -25 137 z"
                },
                flag64thDown: {
                    x_min: -15,
                    x_max: 271,
                    y_min: -296,
                    y_max: 820,
                    ha: 1116,
                    o: "m 272 1179 b 281 1181 275 1180 278 1181 b 297 1174 286 1181 292 1178 b 359 1098 322 1154 344 1127 b 390 972 380 1059 390 1016 b 357 836 390 926 379 879 l 351 825 l 353 823 b 359 812 354 822 357 817 b 390 685 380 773 390 729 b 357 549 390 639 379 593 l 351 539 l 353 536 b 359 526 354 535 357 530 b 390 399 380 486 390 443 b 357 263 390 353 379 306 l 351 252 l 353 250 b 390 113 374 218 390 162 b 390 113 390 113 390 113 b 246 -148 390 9 339 -84 b -1 -411 129 -228 30 -334 b -18 -426 -4 -420 -11 -426 l -22 -427 l -22 -291 l -22 -156 l -13 -155 b 156 -124 51 -152 115 -140 b 338 126 266 -80 338 23 b 326 195 338 150 334 173 b 321 207 324 204 323 207 b 318 203 321 207 319 205 b 246 139 299 180 276 159 b -1 -125 129 59 30 -48 b -18 -140 -4 -134 -11 -139 l -22 -140 l -22 -5 l -22 131 l -13 131 b 156 163 51 134 115 146 b 338 413 266 206 338 310 b 326 482 338 436 334 459 b 321 493 324 490 323 493 b 318 489 321 493 319 492 b 246 425 299 466 276 446 b -1 162 129 345 30 239 b -18 147 -4 153 -11 147 l -22 146 l -22 282 l -22 417 l -13 418 b 156 449 51 421 115 433 b 338 699 266 493 338 596 b 326 768 338 723 334 746 b 321 780 324 777 323 780 b 318 776 320 780 319 778 b 246 712 299 753 276 732 b -1 448 129 632 30 525 b -19 433 -4 439 -11 434 l -22 433 l -22 568 l -22 704 l -13 704 b 156 736 51 707 115 719 b 338 985 264 778 337 879 l 338 985 b 272 1137 338 1045 313 1103 b 259 1159 262 1146 259 1150 b 272 1179 259 1168 265 1176 z"
                },
                flag128thUp: {
                    x_min: -17,
                    x_max: 231,
                    y_min: -987,
                    y_max: 496,
                    ha: 1484,
                    o: "m -25 582 l -25 715 l -21 715 b 3 693 -11 715 -6 710 b 150 501 30 639 82 570 b 237 396 191 459 212 434 b 333 93 300 302 333 195 b 311 -46 333 45 326 -2 b 307 -60 308 -54 307 -57 b 310 -72 307 -63 308 -65 b 332 -220 325 -121 332 -171 b 311 -359 332 -269 325 -316 b 307 -374 308 -368 307 -371 b 310 -386 307 -377 308 -379 b 332 -534 325 -434 332 -485 b 311 -673 332 -583 325 -630 b 307 -688 308 -682 307 -685 b 310 -700 307 -690 308 -693 b 332 -848 325 -748 332 -799 b 311 -987 332 -896 325 -944 b 307 -1001 308 -995 307 -998 b 310 -1013 307 -1004 308 -1007 b 333 -1161 325 -1062 333 -1113 b 268 -1391 333 -1246 311 -1326 b 235 -1422 251 -1417 246 -1422 b 213 -1402 221 -1422 213 -1413 b 220 -1382 213 -1396 215 -1389 b 286 -1176 265 -1322 286 -1250 b 163 -883 286 -1073 244 -966 b -16 -806 122 -841 54 -812 b -23 -805 -19 -806 -22 -806 l -25 -805 l -25 -673 l -25 -541 l -21 -541 b 3 -562 -11 -541 -6 -545 b 150 -754 30 -617 82 -685 b 273 -921 209 -814 242 -860 l 280 -933 l 281 -927 b 287 -861 285 -906 287 -884 b 163 -569 287 -756 243 -650 b -16 -492 122 -527 54 -498 b -23 -492 -19 -492 -22 -492 l -25 -491 l -25 -359 l -25 -227 l -21 -227 b 3 -248 -11 -227 -6 -231 b 150 -441 30 -303 82 -372 b 273 -608 209 -500 242 -546 l 280 -620 l 281 -614 b 287 -548 285 -592 287 -570 b 163 -255 287 -442 243 -336 b -16 -179 122 -213 54 -184 b -23 -178 -19 -178 -22 -178 l -25 -178 l -25 -45 l -25 87 l -21 87 b 3 66 -11 87 -6 83 b 150 -127 30 11 82 -58 b 273 -294 209 -186 242 -232 l 280 -306 l 281 -300 b 287 -234 285 -278 287 -256 b 163 59 287 -129 243 -23 b -16 135 122 100 54 129 b -23 136 -19 135 -22 136 l -25 136 l -25 268 l -25 401 l -21 401 b 3 379 -11 401 -6 397 b 150 187 30 325 82 256 b 273 20 209 127 242 82 l 280 8 l 281 14 b 287 80 285 36 287 58 b 163 372 287 185 243 291 b -16 449 122 414 54 443 b -23 450 -19 449 -22 449 l -25 450 z"
                },
                flag128thDown: {
                    x_min: -15,
                    x_max: 270,
                    y_min: -496,
                    y_max: 870,
                    ha: 1366,
                    o: "m 292 1251 b 301 1253 295 1252 298 1253 b 325 1235 309 1253 316 1247 b 389 1031 368 1174 389 1103 b 364 898 389 986 381 941 l 359 888 l 364 876 b 389 745 381 834 389 789 b 364 612 389 700 381 654 l 359 601 l 364 589 b 389 458 381 547 389 503 b 364 325 389 413 381 368 l 359 315 l 364 303 b 389 172 381 261 389 216 b 364 39 389 127 381 81 l 359 28 l 364 16 b 390 -115 381 -26 390 -71 b 260 -391 390 -219 344 -320 b 0 -698 135 -495 36 -613 b -19 -715 -5 -709 -11 -715 l -22 -715 l -22 -582 l -21 -449 l -14 -447 b 124 -400 25 -439 79 -420 b 213 -349 168 -379 189 -367 b 340 -101 294 -288 340 -196 b 332 -36 340 -79 337 -57 b 330 -27 331 -30 331 -27 b 326 -31 329 -27 328 -29 b 260 -104 309 -57 286 -82 b 0 -412 135 -209 36 -326 b -19 -428 -5 -422 -11 -428 l -22 -428 l -22 -295 l -21 -162 l -14 -161 b 124 -113 25 -153 79 -134 b 213 -63 168 -92 189 -81 b 340 186 294 -2 340 91 b 332 251 340 207 337 229 b 330 259 331 257 331 259 b 326 255 329 259 328 258 b 260 182 309 229 286 204 b 0 -125 135 78 36 -40 b -19 -142 -5 -136 -11 -142 l -22 -142 l -22 -9 l -21 124 l -14 126 b 124 173 25 134 79 152 b 213 224 168 194 189 206 b 340 472 294 285 340 377 b 332 537 340 494 337 516 b 330 546 331 543 331 546 b 326 542 329 546 328 544 b 255 465 307 514 286 491 b 0 161 135 364 35 245 b -19 145 -4 151 -11 145 l -22 145 l -22 278 l -21 411 l -14 412 b 124 460 25 420 79 439 b 213 510 168 481 189 492 b 340 759 294 571 340 664 b 332 824 340 780 337 802 b 330 832 331 830 331 832 b 326 828 329 832 328 831 b 255 751 308 801 286 777 b 0 448 135 650 35 532 b -19 431 -4 437 -11 431 l -22 431 l -22 564 l -21 697 l -14 699 b 124 746 25 707 79 725 b 213 797 168 767 189 779 b 340 1046 295 859 340 953 b 285 1213 340 1105 322 1163 b 278 1232 281 1220 278 1226 b 292 1251 278 1241 283 1248 z"
                },
                accidentalFlat: {
                    x_min: -15,
                    x_max: 185,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 398 22 640 22 640 l 22 155 l 24 158 b 146 208 64 191 106 208 b 194 200 163 208 179 205 b 267 89 241 183 267 140 b 243 1 267 61 259 30 b 107 -148 220 -41 190 -73 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 l -22 -220 l -22 210 l -22 640 l -20 644 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z"
                },
                accidentalNatural: {
                    x_min: 0,
                    x_max: 176,
                    y_min: -334,
                    y_max: 334,
                    ha: 667,
                    o: "m 13 479 b 21 480 16 480 19 480 b 42 467 30 480 39 475 b 44 339 44 463 44 462 b 44 214 44 250 44 214 b 136 237 45 214 86 224 b 234 259 209 255 227 259 b 240 258 237 259 238 259 b 252 246 245 256 251 251 l 254 242 l 254 -111 l 254 -463 l 252 -467 b 232 -480 249 -475 241 -480 b 216 -474 226 -480 221 -478 b 210 -392 211 -468 210 -477 b 210 -336 210 -377 210 -358 b 209 -209 210 -245 210 -209 b 117 -231 209 -209 168 -219 b 19 -254 45 -249 27 -254 b 13 -252 17 -254 15 -253 b 1 -240 8 -251 3 -245 l 0 -237 l 0 113 l 0 463 l 1 467 b 13 479 3 472 8 477 z m 210 23 b 210 74 210 44 210 61 b 209 121 210 118 210 121 l 209 121 b 126 101 208 121 171 112 l 44 81 l 44 -18 b 44 -62 44 -35 44 -50 b 44 -116 44 -104 44 -116 b 128 -96 45 -116 82 -107 l 210 -75 z"
                },
                accidentalSharp: {
                    x_min: 0,
                    x_max: 239,
                    y_min: -388,
                    y_max: 388,
                    ha: 775,
                    o: "m 232 557 b 240 558 234 558 237 558 b 261 545 249 558 258 553 b 262 405 262 541 262 540 b 263 269 262 278 262 269 b 263 269 263 269 263 269 b 322 282 275 273 319 282 b 343 269 331 282 340 277 b 344 217 344 266 344 241 b 343 165 344 192 344 168 b 295 144 339 155 337 154 l 262 136 l 262 22 b 263 -91 262 -83 262 -91 b 263 -91 263 -91 263 -91 b 322 -78 275 -88 319 -78 b 338 -84 329 -78 333 -80 b 344 -129 344 -90 344 -88 b 344 -143 344 -133 344 -138 b 344 -157 344 -148 344 -153 b 338 -203 344 -198 344 -197 b 295 -217 333 -207 333 -207 l 262 -225 l 262 -362 b 261 -504 262 -499 262 -500 b 240 -517 258 -512 249 -517 b 225 -511 235 -517 229 -515 b 218 -430 219 -505 218 -514 b 218 -368 218 -413 218 -393 b 218 -235 218 -295 218 -235 b 171 -247 218 -235 197 -241 b 123 -259 145 -253 123 -259 b 123 -400 123 -259 123 -322 b 122 -545 123 -540 123 -541 b 101 -558 118 -553 110 -558 b 86 -552 95 -558 90 -556 b 79 -469 80 -546 79 -556 b 79 -405 79 -452 79 -431 b 78 -270 79 -279 79 -270 b 78 -270 78 -270 78 -270 b 22 -282 65 -273 25 -282 b 2 -269 13 -282 5 -277 b 0 -217 1 -266 0 -242 b 2 -165 0 -192 1 -168 b 48 -144 5 -155 7 -154 l 79 -136 l 79 -23 b 78 90 79 83 79 90 b 78 90 78 90 78 90 b 22 78 65 87 25 78 b 2 91 13 78 5 83 b 0 143 1 94 0 119 b 2 195 0 168 1 192 b 48 216 5 205 7 206 l 79 224 l 79 362 b 81 504 79 499 79 500 b 101 517 84 512 93 517 b 117 511 107 517 112 515 b 123 430 123 505 123 515 b 123 367 123 413 123 392 b 123 235 123 294 123 235 b 171 246 123 235 145 240 b 218 258 197 253 218 258 b 218 399 218 258 218 322 b 220 545 218 540 218 541 b 232 557 222 549 227 555 z m 218 11 b 218 125 218 102 218 125 l 218 125 b 201 121 217 125 210 123 b 154 109 193 119 171 113 l 123 102 l 123 -12 b 123 -126 123 -74 123 -126 b 171 -114 123 -126 145 -120 b 218 -102 197 -107 218 -102 b 218 11 218 -102 218 -51 z"
                },
                accidentalDoubleSharp: {
                    x_min: 0,
                    x_max: 271,
                    y_min: -135,
                    y_max: 135,
                    ha: 271,
                    o: "m 0 130 l 0 195 l 65 195 l 131 195 l 131 145 l 131 96 l 163 64 l 195 32 l 227 64 l 259 96 l 259 145 l 259 195 l 325 195 l 390 195 l 390 130 l 390 64 l 341 64 l 291 64 l 259 32 l 227 0 l 259 -32 l 291 -64 l 341 -64 l 390 -64 l 390 -130 l 390 -195 l 325 -195 l 259 -195 l 259 -145 l 259 -96 l 227 -64 l 195 -32 l 163 -64 l 131 -96 l 131 -145 l 131 -195 l 65 -195 l 0 -195 l 0 -130 l 0 -64 l 50 -64 l 99 -64 l 131 -32 l 163 0 l 131 32 l 99 64 l 50 64 l 0 64 z"
                },
                accidentalDoubleFlat: {
                    x_min: -15,
                    x_max: 356,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 398 22 640 22 640 l 22 155 l 24 158 b 149 208 64 191 109 208 b 220 187 175 208 200 201 l 223 184 l 224 413 l 224 642 l 226 645 b 246 657 229 653 237 657 b 266 644 254 657 263 653 b 267 398 267 640 267 640 l 267 155 l 270 158 b 392 208 309 191 351 208 b 440 200 408 208 424 205 b 512 89 486 183 512 140 b 488 1 512 61 505 30 b 352 -148 466 -41 436 -73 b 271 -222 307 -188 297 -198 b 246 -237 256 -236 254 -237 b 230 -231 239 -237 234 -236 b 224 -164 224 -225 224 -232 b 224 -125 224 -153 224 -140 l 224 -29 l 218 -36 b 107 -148 194 -67 170 -91 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 l -22 -220 l -22 210 l -22 640 l -20 644 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z m 364 137 b 347 139 360 138 352 139 b 342 139 345 139 343 139 b 272 92 315 135 290 118 l 267 84 l 267 -39 l 267 -161 l 271 -157 b 399 88 349 -73 399 24 b 397 107 399 95 398 101 b 364 137 394 122 382 134 z"
                },
                accidentalParensLeft: {
                    x_min: -122,
                    x_max: -19,
                    y_min: -267,
                    y_max: 267,
                    ha: 534,
                    o: "m -51 383 b -44 385 -49 384 -46 385 b -29 375 -38 385 -31 381 b -27 369 -28 373 -27 372 b -33 349 -27 365 -29 360 b -98 54 -71 259 -91 167 b -99 0 -98 44 -99 22 b -98 -54 -99 -22 -98 -45 b -33 -349 -91 -167 -71 -259 b -27 -368 -28 -363 -27 -365 b -44 -385 -27 -378 -34 -385 b -65 -367 -52 -385 -55 -383 b -176 0 -139 -251 -176 -125 b -65 367 -176 125 -139 251 b -51 383 -57 379 -55 381 z"
                },
                accidentalParensRight: {
                    x_min: 19,
                    x_max: 122,
                    y_min: -267,
                    y_max: 267,
                    ha: 535,
                    o: "m 36 384 b 44 385 38 385 41 385 b 65 367 52 385 55 383 b 176 0 139 251 176 126 b 65 -367 176 -125 139 -250 b 44 -385 56 -380 51 -385 b 36 -383 42 -385 39 -384 b 27 -370 30 -380 27 -377 b 33 -349 27 -365 29 -359 b 99 0 77 -242 99 -121 b 33 350 99 122 77 243 b 27 371 29 359 27 366 b 36 384 27 377 30 381 z"
                },
                accidentalQuarterToneFlatStein: {
                    x_min: 0,
                    x_max: 200,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m 258 656 b 266 658 261 657 264 658 b 287 644 275 658 284 652 l 289 640 l 289 210 l 289 -220 l 287 -224 b 267 -237 284 -232 276 -237 b 241 -222 258 -237 256 -236 b 163 -151 216 -199 200 -183 b 24 2 78 -75 47 -41 b 0 88 8 31 0 61 b 73 200 0 140 26 183 b 120 208 88 205 104 208 b 242 158 161 208 203 191 l 245 155 l 245 398 b 246 644 245 640 245 640 b 258 656 248 649 253 654 z m 179 137 b 159 139 174 138 165 139 b 155 139 157 139 156 139 b 115 107 131 134 118 124 b 113 88 114 101 113 95 b 241 -157 113 24 163 -73 l 245 -161 l 245 -39 l 245 84 l 240 92 b 179 137 224 116 203 131 z"
                },
                accidentalThreeQuarterTonesFlatZimmermann: {
                    x_min: 0,
                    x_max: 446,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m 258 656 b 266 658 261 657 264 658 b 287 644 275 658 284 652 l 289 640 l 289 210 l 289 -220 l 287 -224 b 267 -237 284 -232 276 -237 b 241 -222 258 -237 256 -236 b 163 -151 216 -199 200 -183 b 24 2 78 -75 47 -41 b 0 88 8 31 0 61 b 73 200 0 140 26 183 b 120 208 88 205 104 208 b 242 158 161 208 203 191 l 245 155 l 245 398 b 246 644 245 640 245 640 b 258 656 248 649 253 654 z m 179 137 b 159 139 174 138 165 139 b 155 139 157 139 156 139 b 115 107 131 134 118 124 b 113 88 114 101 113 95 b 241 -157 113 24 163 -73 l 245 -161 l 245 -39 l 245 84 l 240 92 b 179 137 224 116 203 131 z m 367 656 b 375 658 370 657 373 658 b 396 644 384 658 393 652 b 398 398 398 640 398 640 l 398 155 l 400 158 b 522 208 440 191 482 208 b 570 200 538 208 554 205 b 643 89 617 183 643 140 b 619 1 643 61 635 30 b 483 -148 596 -41 566 -73 b 401 -222 438 -188 427 -198 b 376 -237 386 -236 384 -237 b 355 -224 366 -237 358 -232 l 354 -220 l 354 210 l 354 640 l 355 644 b 367 656 357 649 362 654 z m 495 137 b 477 139 491 138 482 139 b 472 139 475 139 473 139 b 403 92 445 135 420 118 l 398 84 l 398 -39 l 398 -161 l 401 -157 b 529 88 479 -73 529 24 b 528 107 529 95 529 101 b 495 137 525 122 512 134 z"
                },
                accidentalQuarterToneSharpStein: {
                    x_min: 0,
                    x_max: 142,
                    y_min: -373,
                    y_max: 373,
                    ha: 747,
                    o: "m 92 536 b 101 538 95 537 98 538 b 122 524 110 538 118 532 b 123 390 123 520 123 519 l 123 259 l 151 268 b 182 277 175 276 178 277 b 184 277 183 277 183 277 b 203 265 193 276 199 272 l 204 262 l 205 213 b 205 187 205 202 205 194 b 201 154 205 159 204 159 b 158 136 197 149 194 148 l 123 125 l 123 10 b 124 -104 123 -64 123 -104 b 150 -94 124 -104 136 -100 b 179 -85 164 -89 177 -85 b 183 -84 181 -84 182 -84 b 203 -98 192 -84 200 -90 b 205 -157 204 -101 205 -130 b 204 -201 205 -179 205 -199 b 158 -226 200 -211 199 -212 l 123 -239 l 123 -380 l 123 -522 l 121 -525 b 101 -538 117 -533 109 -538 b 85 -531 95 -538 90 -536 b 79 -450 80 -526 79 -535 b 79 -387 79 -433 79 -413 b 79 -254 79 -314 79 -254 b 54 -263 79 -254 67 -258 b 19 -273 36 -270 26 -273 b 6 -267 14 -273 10 -271 b 0 -222 0 -261 0 -263 b 0 -207 0 -217 0 -213 b 0 -195 0 -203 0 -199 b 6 -148 0 -152 0 -154 b 47 -131 10 -144 10 -144 l 79 -120 l 79 -5 b 79 110 79 58 79 110 b 53 101 79 110 67 106 b 19 93 35 95 25 93 b 6 99 14 93 10 95 b 0 144 0 105 0 103 b 0 158 0 148 0 153 b 0 185 0 169 0 178 b 45 233 0 222 3 219 l 79 244 l 79 382 b 81 524 79 519 79 520 b 92 536 82 529 88 534 z"
                },
                accidentalThreeQuarterTonesSharpStein: {
                    x_min: 0,
                    x_max: 335,
                    y_min: -391,
                    y_max: 391,
                    ha: 782,
                    o: "m 373 562 b 379 563 375 563 377 563 b 399 551 388 563 395 559 l 401 548 l 401 410 l 401 272 l 403 273 b 432 278 403 273 417 275 b 463 282 448 281 457 282 b 477 276 470 282 473 280 b 483 241 482 271 483 271 b 483 216 483 234 483 226 l 483 167 l 481 164 b 471 153 479 160 475 155 b 402 140 469 152 405 140 b 401 25 401 140 401 88 l 401 -91 l 403 -90 b 432 -85 403 -90 417 -88 b 463 -80 448 -82 457 -80 b 477 -87 470 -80 473 -83 b 483 -122 482 -92 483 -91 b 483 -147 483 -128 483 -137 l 483 -196 l 481 -199 b 471 -209 479 -203 475 -207 b 402 -223 469 -210 405 -223 b 401 -359 401 -223 401 -284 l 401 -496 l 399 -500 b 379 -512 395 -507 388 -512 b 359 -500 371 -512 363 -507 l 357 -496 l 357 -363 b 356 -231 357 -240 357 -231 b 356 -231 356 -231 356 -231 b 309 -240 356 -232 334 -235 l 262 -249 l 262 -384 b 262 -448 262 -410 262 -431 b 256 -531 262 -535 261 -526 b 240 -538 251 -536 246 -538 b 220 -525 232 -538 224 -533 l 219 -522 l 218 -389 l 218 -257 l 171 -265 b 123 -274 144 -270 123 -274 b 123 -411 123 -274 123 -336 l 122 -548 l 121 -551 b 101 -563 116 -559 109 -563 b 81 -551 93 -563 85 -559 l 79 -548 l 79 -415 b 79 -282 79 -342 79 -282 b 52 -287 78 -282 66 -285 b 20 -292 36 -290 26 -292 b 6 -286 13 -292 10 -290 b 0 -241 0 -280 0 -282 b 0 -226 0 -236 0 -232 b 0 -212 0 -221 0 -216 b 6 -167 0 -171 0 -173 b 48 -155 11 -162 13 -162 l 79 -150 l 79 -35 b 79 80 79 29 79 80 b 52 76 78 80 66 78 b 20 71 36 73 26 71 b 6 77 13 71 10 73 b 0 122 0 83 0 81 b 0 136 0 126 0 131 b 0 151 0 142 0 146 b 6 196 0 192 0 190 b 48 207 11 201 13 201 l 79 213 l 79 354 l 79 496 l 81 500 b 101 512 85 508 93 512 b 121 500 109 512 116 508 l 122 497 l 123 359 l 123 221 l 171 230 b 218 239 197 235 218 239 b 218 380 218 239 218 302 b 220 524 218 519 218 520 b 240 538 223 533 231 538 b 256 531 246 538 251 536 b 262 448 261 526 262 535 b 262 384 262 431 262 410 b 263 247 262 295 262 247 b 310 255 263 247 284 251 b 357 264 335 260 357 264 b 358 406 357 264 357 328 l 358 548 l 359 551 b 373 562 362 557 367 561 z m 357 16 b 357 132 357 108 357 132 l 357 132 b 309 123 356 132 335 128 l 262 114 l 262 -1 b 263 -116 262 -76 262 -116 b 310 -107 263 -116 284 -112 b 357 -99 335 -103 357 -99 b 357 16 357 -99 357 -48 z m 218 -124 b 218 -56 218 -124 218 -96 b 218 -9 218 -42 218 -26 l 218 106 l 171 97 b 123 88 145 93 123 89 b 123 21 123 88 123 61 b 123 -27 123 6 123 -10 l 123 -142 l 170 -133 b 218 -124 196 -128 218 -124 z"
                },
                accidentalBuyukMucennebFlat: {
                    x_min: -125,
                    x_max: 185,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 575 22 640 22 639 b 23 510 22 524 22 510 b 23 510 23 510 23 510 b 164 557 49 520 160 557 b 186 534 177 557 186 546 b 176 516 186 527 183 520 b 98 489 175 515 140 503 l 22 463 l 22 405 b 22 378 22 394 22 386 b 23 347 22 354 22 347 b 23 347 23 347 23 347 b 164 393 49 356 160 393 b 186 371 177 393 186 382 b 176 352 186 364 183 357 b 98 325 175 352 140 339 l 22 300 l 22 228 l 22 155 l 24 158 b 146 208 64 191 106 208 b 194 200 163 208 179 205 b 267 89 241 183 267 140 b 243 1 267 61 259 30 b 107 -148 220 -41 190 -73 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 b -22 32 -22 -220 -22 -220 b -22 284 -22 171 -22 284 b -88 262 -23 284 -52 274 b -160 240 -141 245 -154 240 b -167 241 -163 240 -164 241 b -180 262 -175 245 -180 254 b -169 281 -180 270 -176 278 b -30 329 -168 282 -92 308 l -22 332 l -22 390 b -22 448 -22 422 -22 448 b -88 426 -23 448 -52 438 b -160 404 -141 408 -154 404 b -167 405 -163 404 -164 404 b -180 426 -175 408 -180 417 b -169 445 -180 434 -176 441 b -30 493 -168 446 -92 472 l -22 495 l -22 568 b -20 644 -22 639 -22 641 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z"
                },
                accidentalBuyukMucennebSharp: {
                    x_min: 0,
                    x_max: 284,
                    y_min: -388,
                    y_max: 388,
                    ha: 775,
                    o: "m 264 557 b 272 558 267 558 269 558 b 293 545 281 558 290 553 b 294 435 294 541 294 540 b 295 329 294 337 294 329 b 296 329 296 329 296 329 b 355 342 308 333 351 342 b 375 329 364 342 372 337 b 376 277 376 326 376 302 b 375 225 376 252 376 228 b 327 204 371 215 369 214 l 294 196 l 294 142 b 295 89 294 94 294 89 b 296 89 295 89 296 89 b 389 110 314 94 384 110 b 389 110 389 110 389 110 b 407 98 397 110 403 105 l 409 95 l 409 45 b 409 25 409 37 409 30 b 404 -13 409 -11 408 -8 b 345 -32 400 -18 398 -19 b 295 -44 317 -39 295 -44 b 294 -98 294 -44 294 -68 b 295 -151 294 -147 294 -151 b 296 -151 295 -151 296 -151 b 355 -138 308 -148 351 -138 b 375 -151 364 -138 372 -143 b 376 -203 376 -154 376 -179 b 375 -255 376 -228 376 -252 b 327 -277 371 -265 369 -266 l 294 -285 l 294 -392 b 293 -504 294 -499 294 -500 b 272 -517 290 -512 281 -517 b 257 -511 267 -517 261 -515 b 251 -443 251 -505 251 -512 b 251 -398 251 -430 251 -416 b 250 -295 251 -341 251 -295 b 203 -307 250 -295 229 -301 b 156 -319 177 -313 156 -319 b 155 -430 155 -319 155 -369 b 154 -545 155 -540 155 -541 b 133 -558 151 -553 142 -558 b 118 -552 128 -558 122 -556 b 112 -482 112 -546 112 -553 b 112 -435 112 -469 112 -454 b 110 -330 112 -337 111 -330 b 110 -330 110 -330 110 -330 b 54 -342 98 -333 58 -342 b 34 -329 45 -342 37 -337 b 32 -277 33 -326 32 -302 b 34 -225 32 -252 33 -228 b 80 -204 38 -215 39 -214 l 112 -196 l 112 -143 b 111 -90 112 -94 111 -90 b 110 -90 110 -90 110 -90 b 20 -110 89 -96 25 -110 b 20 -110 20 -110 20 -110 b 2 -98 12 -110 5 -105 l 0 -95 l 0 -45 b 0 -25 0 -37 0 -30 b 5 13 0 11 0 8 b 62 32 9 18 10 19 b 111 44 89 38 111 44 b 112 97 111 44 112 68 b 111 150 112 146 111 150 b 110 150 110 150 110 150 b 54 138 98 147 58 138 b 34 151 45 138 37 143 b 32 203 33 154 32 179 b 34 255 32 228 33 252 b 80 276 38 265 39 266 l 112 284 l 112 392 b 113 504 112 499 112 500 b 133 517 116 512 125 517 b 149 511 139 517 145 515 b 155 443 155 505 155 512 b 155 397 155 430 155 415 b 155 295 155 341 155 295 b 203 306 156 295 177 300 b 250 318 229 313 250 318 b 251 429 251 318 251 368 b 252 545 251 540 251 541 b 264 557 254 549 259 555 z m 251 131 b 250 185 251 174 250 185 l 250 185 b 233 181 249 185 242 183 b 186 169 225 179 204 173 l 155 162 l 155 108 b 155 55 155 79 155 55 b 203 66 156 55 177 60 b 250 78 229 73 250 78 b 251 131 251 78 251 102 z m 251 -109 b 250 -55 251 -67 250 -55 l 250 -55 b 233 -59 249 -55 242 -57 b 186 -71 225 -62 204 -67 l 155 -79 l 155 -132 b 155 -186 155 -161 155 -186 b 203 -174 156 -186 177 -180 b 250 -162 229 -168 250 -162 b 251 -109 251 -162 251 -138 z"
                },
                accidentalBakiyeFlat: {
                    x_min: -129,
                    x_max: 185,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 524 22 640 22 639 b 22 407 22 460 22 407 b 90 441 22 407 53 422 l 157 474 l 163 475 b 164 475 163 475 163 475 b 186 453 177 475 186 465 b 184 445 186 450 185 447 b 99 396 181 436 184 438 l 22 357 l 22 256 l 22 155 l 24 158 b 146 208 64 191 106 208 b 194 200 163 208 179 205 b 267 89 241 183 267 140 b 243 1 267 61 259 30 b 107 -148 220 -41 190 -73 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 b -22 57 -22 -220 -22 -220 b -22 335 -22 210 -22 335 b -90 301 -22 335 -53 320 l -157 268 l -163 268 b -164 268 -163 268 -163 268 b -186 289 -177 268 -186 277 b -184 298 -186 292 -185 295 b -99 347 -181 306 -184 304 l -22 385 l -22 513 b -20 644 -22 639 -22 640 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z"
                },
                accidentalKomaSharp: {
                    x_min: 0,
                    x_max: 142,
                    y_min: -373,
                    y_max: 373,
                    ha: 747,
                    o: "m 92 536 b 101 538 95 537 98 538 b 122 524 110 538 118 532 b 123 390 123 520 123 519 l 123 259 l 151 268 b 182 277 175 276 178 277 b 184 277 183 277 183 277 b 203 265 193 276 199 272 l 204 262 l 205 213 b 205 187 205 202 205 194 b 201 154 205 159 204 159 b 158 136 197 149 194 148 l 123 125 l 123 10 b 124 -104 123 -64 123 -104 b 150 -94 124 -104 136 -100 b 179 -85 164 -89 177 -85 b 183 -84 181 -84 182 -84 b 203 -98 192 -84 200 -90 b 205 -157 204 -101 205 -130 b 204 -201 205 -179 205 -199 b 158 -226 200 -211 199 -212 l 123 -239 l 123 -380 l 123 -522 l 121 -525 b 101 -538 117 -533 109 -538 b 85 -531 95 -538 90 -536 b 79 -450 80 -526 79 -535 b 79 -387 79 -433 79 -413 b 79 -254 79 -314 79 -254 b 54 -263 79 -254 67 -258 b 19 -273 36 -270 26 -273 b 6 -267 14 -273 10 -271 b 0 -222 0 -261 0 -263 b 0 -207 0 -217 0 -213 b 0 -195 0 -203 0 -199 b 6 -148 0 -152 0 -154 b 47 -131 10 -144 10 -144 l 79 -120 l 79 -5 b 79 110 79 58 79 110 b 53 101 79 110 67 106 b 19 93 35 95 25 93 b 6 99 14 93 10 95 b 0 144 0 105 0 103 b 0 158 0 148 0 153 b 0 185 0 169 0 178 b 45 233 0 222 3 219 l 79 244 l 79 382 b 81 524 79 519 79 520 b 92 536 82 529 88 534 z"
                },
                accidentalKucukMucennebSharp: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -373,
                    y_max: 373,
                    ha: 747,
                    o: "m 127 536 b 135 538 129 537 132 538 b 156 524 144 538 153 532 b 157 420 157 520 157 519 l 157 319 l 185 328 b 216 337 209 336 212 337 b 218 337 217 337 217 337 b 237 325 227 336 233 332 l 239 322 l 239 273 b 239 247 239 262 239 254 b 235 214 239 219 238 219 b 192 196 231 209 229 208 l 157 185 l 157 129 b 158 75 157 86 157 75 b 158 75 158 75 158 75 b 202 89 158 75 178 81 l 245 103 l 250 103 b 268 91 258 102 265 98 l 270 88 l 270 39 b 270 13 270 28 270 20 b 266 -20 270 -15 270 -15 b 208 -43 262 -25 261 -25 l 157 -60 l 157 -112 b 157 -127 157 -117 157 -122 b 158 -164 157 -151 157 -164 b 184 -154 158 -164 170 -160 b 214 -145 198 -149 212 -145 b 217 -144 215 -144 216 -144 b 238 -158 226 -144 235 -150 b 239 -217 239 -161 239 -190 b 238 -261 239 -239 239 -259 b 192 -286 235 -271 233 -272 l 157 -299 l 157 -410 b 155 -525 157 -522 157 -522 b 135 -538 152 -533 143 -538 b 120 -531 130 -538 124 -536 b 113 -463 114 -525 113 -532 b 113 -417 113 -450 113 -435 b 113 -314 113 -361 113 -314 b 88 -323 113 -314 102 -318 b 53 -333 70 -330 60 -333 b 41 -327 48 -333 45 -331 b 34 -282 35 -321 34 -323 b 34 -267 34 -277 34 -273 b 34 -255 34 -263 34 -259 b 40 -208 34 -212 35 -214 b 81 -191 44 -204 44 -204 l 113 -180 l 113 -127 b 113 -75 113 -86 113 -75 b 113 -75 113 -75 113 -75 b 69 -89 112 -75 92 -81 l 26 -103 l 21 -103 b 1 -89 12 -102 4 -97 b 0 -43 0 -86 0 -65 b 2 15 0 -16 1 12 b 63 43 5 24 4 24 l 113 60 l 113 115 b 113 130 113 120 113 125 b 113 170 113 153 113 170 b 87 161 113 170 101 166 b 53 153 69 156 60 153 b 41 159 48 153 45 155 b 34 204 35 165 34 163 b 34 218 34 208 34 213 b 34 245 34 229 34 238 b 79 293 34 282 38 279 l 113 304 l 113 412 b 115 524 113 519 113 520 b 127 536 117 529 122 534 z"
                },
                articAccentAbove: {
                    x_min: -256,
                    x_max: 19,
                    y_min: -114,
                    y_max: 114,
                    ha: 227,
                    o: "m -350 163 b -341 164 -348 163 -344 164 b -333 163 -338 164 -335 163 b -312 151 -330 162 -327 160 b -9 30 -231 99 -122 56 b 13 24 8 27 11 26 b 28 0 23 18 28 9 b 3 -28 28 -12 19 -24 b -19 -33 -1 -29 -11 -31 b -315 -153 -129 -58 -238 -102 b -341 -164 -331 -163 -333 -164 b -369 -136 -357 -164 -369 -151 b -364 -121 -369 -131 -367 -126 b -346 -107 -361 -117 -358 -114 b -135 -8 -285 -67 -213 -34 b -111 0 -122 -4 -111 0 b -135 8 -111 0 -122 4 b -346 107 -213 34 -285 67 b -364 121 -358 114 -361 116 b -368 136 -367 126 -368 131 b -350 163 -368 148 -361 159 z"
                },
                articAccentBelow: {
                    x_min: -256,
                    x_max: 19,
                    y_min: -114,
                    y_max: 114,
                    ha: 227,
                    o: "m -350 163 b -341 164 -348 163 -344 164 b -333 163 -338 164 -335 163 b -312 151 -330 162 -327 160 b -9 30 -231 99 -122 56 b 13 24 8 27 11 26 b 28 0 23 18 28 9 b 3 -28 28 -12 19 -24 b -19 -33 -1 -29 -11 -31 b -315 -153 -129 -58 -238 -102 b -341 -164 -331 -163 -333 -164 b -369 -136 -357 -164 -369 -151 b -364 -121 -369 -131 -367 -126 b -346 -107 -361 -117 -358 -114 b -135 -8 -285 -67 -213 -34 b -111 0 -122 -4 -111 0 b -135 8 -111 0 -122 4 b -346 107 -213 34 -285 67 b -364 121 -358 114 -361 116 b -368 136 -367 126 -368 131 b -350 163 -368 148 -361 159 z"
                },
                articTenutoAbove: {
                    x_min: -154,
                    x_max: 154,
                    y_min: -15,
                    y_max: 15,
                    ha: 30,
                    o: "m -208 20 b 2 22 -205 21 -101 22 b 208 20 104 22 205 21 b 221 0 216 17 221 9 b 215 -16 221 -6 219 -11 b 101 -22 209 -21 225 -22 b 0 -22 75 -22 41 -22 b -101 -22 -41 -22 -75 -22 b -215 -16 -225 -22 -209 -21 b -221 0 -219 -11 -221 -6 b -208 20 -221 8 -216 17 z"
                },
                articTenutoBelow: {
                    x_min: -154,
                    x_max: 154,
                    y_min: -15,
                    y_max: 15,
                    ha: 30,
                    o: "m -208 20 b 2 22 -205 21 -101 22 b 208 20 104 22 205 21 b 221 0 216 17 221 9 b 215 -16 221 -6 219 -11 b 101 -22 209 -21 225 -22 b 0 -22 75 -22 41 -22 b -101 -22 -41 -22 -75 -22 b -215 -16 -225 -22 -209 -21 b -221 0 -219 -11 -221 -6 b -208 20 -221 8 -216 17 z"
                },
                articStaccatoAbove: {
                    x_min: -49,
                    x_max: 49,
                    y_min: -49,
                    y_max: 49,
                    ha: 99,
                    o: "m -13 70 b -1 71 -9 71 -5 71 b 59 40 23 71 46 59 b 71 0 67 28 71 14 b 40 -59 71 -23 60 -46 b 0 -71 28 -67 14 -71 b -59 -40 -23 -71 -46 -60 b -71 0 -67 -28 -71 -14 b -13 70 -71 32 -48 64 z"
                },
                articStaccatoBelow: {
                    x_min: -49,
                    x_max: 49,
                    y_min: -49,
                    y_max: 49,
                    ha: 99,
                    o: "m -13 70 b -1 71 -9 71 -5 71 b 59 40 23 71 46 59 b 71 0 67 28 71 14 b 40 -59 71 -23 60 -46 b 0 -71 28 -67 14 -71 b -59 -40 -23 -71 -46 -60 b -71 0 -67 -28 -71 -14 b -13 70 -71 32 -48 64 z"
                },
                articStaccatissimoAbove: {
                    x_min: -53,
                    x_max: 53,
                    y_min: 0,
                    y_max: 184,
                    ha: 184,
                    o: "m -76 263 l -77 265 l 0 265 l 77 265 l 76 263 b 0 0 75 259 0 0 b -76 263 0 0 -75 259 z"
                },
                articStaccatissimoBelow: {
                    x_min: -53,
                    x_max: 53,
                    y_min: -184,
                    y_max: 0,
                    ha: 184,
                    o: "m -38 -131 b 0 0 -17 -59 0 0 b 76 -263 0 0 75 -259 l 77 -265 l 0 -265 l -77 -265 l -76 -263 b -38 -131 -76 -262 -59 -203 z"
                },
                articMarcatoAbove: {
                    x_min: -114,
                    x_max: 114,
                    y_min: -256,
                    y_max: 19,
                    ha: 275,
                    o: "m -9 26 b 0 28 -6 27 -3 28 b 28 3 13 28 24 18 b 33 -19 29 -1 31 -11 b 153 -315 58 -129 102 -238 b 164 -341 163 -331 164 -333 b 136 -368 164 -357 152 -368 b 107 -346 124 -368 118 -364 b 8 -135 67 -285 34 -213 b 0 -111 4 -122 0 -111 b -8 -135 0 -111 -4 -122 b -107 -346 -34 -213 -67 -285 b -136 -368 -118 -364 -124 -368 b -164 -341 -152 -368 -164 -357 b -151 -312 -164 -333 -163 -332 b -30 -9 -99 -231 -56 -122 b -21 18 -26 11 -26 12 b -9 26 -19 21 -13 25 z"
                },
                articMarcatoBelow: {
                    x_min: -114,
                    x_max: 114,
                    y_min: -19,
                    y_max: 256,
                    ha: 275,
                    o: "m -145 367 b -136 369 -142 368 -139 369 b -107 346 -125 369 -117 362 b -8 135 -67 285 -34 213 b 0 111 -4 122 0 111 b 8 135 0 111 4 122 b 107 346 34 213 67 285 b 121 364 114 358 117 361 b 136 369 126 367 131 369 b 164 341 151 369 164 357 b 153 315 164 333 163 331 b 30 9 101 235 56 124 b 21 -18 26 -11 26 -12 b 0 -27 16 -24 8 -27 b -21 -18 -8 -27 -16 -24 b -30 9 -26 -12 -26 -11 b -151 312 -56 122 -99 231 b -164 341 -163 332 -164 333 b -145 367 -164 353 -156 364 z"
                },
                fermataAbove: {
                    x_min: -324,
                    x_max: 324,
                    y_min: 0,
                    y_max: 353,
                    ha: 353,
                    o: "m -33 507 b 0 508 -22 508 -11 508 b 459 112 228 508 419 345 b 467 31 464 85 467 51 b 465 14 467 22 466 16 b 445 0 462 5 453 0 b 429 7 439 0 433 2 b 422 32 424 12 423 15 b 0 365 414 221 231 365 b -63 362 -33 365 -39 365 b -422 32 -265 338 -415 200 b -429 7 -423 15 -424 12 b -445 0 -433 2 -439 0 b -465 14 -453 0 -462 5 b -467 31 -466 16 -467 22 b -459 112 -467 51 -464 85 b -33 507 -422 332 -249 492 z m -15 196 b 0 197 -10 197 -5 197 b 74 163 27 197 56 184 b 98 99 91 145 98 121 b 55 17 98 67 83 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -65 187 z"
                },
                fermataBelow: {
                    x_min: -324,
                    x_max: 324,
                    y_min: -353,
                    y_max: 0,
                    ha: 353,
                    o: "m -453 -2 b -445 0 -451 -1 -448 0 b -429 -7 -439 0 -433 -3 b -422 -33 -424 -12 -423 -15 b 0 -365 -414 -221 -231 -365 b 63 -362 33 -365 39 -365 b 422 -33 265 -338 415 -201 b 429 -7 423 -15 424 -12 b 445 0 433 -2 439 0 b 465 -14 453 0 462 -5 b 467 -31 466 -17 467 -23 b 463 -87 467 -46 465 -68 b 35 -507 434 -319 259 -490 b -1 -508 23 -508 11 -508 b -459 -112 -228 -508 -419 -345 b -467 -31 -464 -85 -467 -51 b -465 -14 -467 -23 -466 -17 b -453 -2 -463 -9 -458 -4 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
                },
                fermataLongAbove: {
                    x_min: -286,
                    x_max: 286,
                    y_min: 0,
                    y_max: 364,
                    ha: 364,
                    o: "m -399 523 b 0 524 -395 524 -392 524 l 395 524 l 399 523 b 411 511 404 521 409 516 b 412 262 412 507 412 507 b 412 141 412 213 412 173 b 406 7 412 -8 412 12 b 390 0 402 2 396 0 b 382 2 387 0 385 1 b 370 14 377 4 372 9 b 368 183 368 17 368 18 l 368 350 l 0 350 l -368 350 l -368 183 b -370 14 -368 18 -368 17 b -390 0 -373 5 -381 0 b -411 14 -399 0 -407 5 b -412 262 -412 17 -412 139 b -411 511 -412 385 -412 508 b -399 523 -409 516 -403 521 z m -15 196 b 0 197 -10 197 -5 197 b 75 163 27 197 56 184 b 98 99 91 145 98 121 b 56 17 98 67 84 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -64 187 z"
                },
                fermataLongBelow: {
                    x_min: -286,
                    x_max: 286,
                    y_min: -364,
                    y_max: 0,
                    ha: 364,
                    o: "m -399 -2 b -391 0 -396 -1 -393 0 b -370 -14 -382 0 -373 -6 b -368 -184 -368 -18 -368 -18 l -368 -350 l 0 -350 l 368 -350 l 368 -184 b 370 -14 368 -18 368 -18 b 390 0 373 -5 382 0 b 411 -14 399 0 407 -5 b 412 -262 412 -17 412 -140 b 411 -511 412 -385 412 -508 b 399 -523 409 -516 404 -521 l 395 -524 l 0 -524 l -395 -524 l -399 -523 b -411 -511 -404 -521 -409 -516 b -412 -262 -412 -508 -412 -385 b -411 -14 -412 -140 -412 -17 b -399 -2 -409 -9 -404 -4 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
                },
                fermataVeryLongAbove: {
                    x_min: -286,
                    x_max: 286,
                    y_min: 0,
                    y_max: 438,
                    ha: 438,
                    o: "m -399 629 b 0 631 -395 631 -392 631 l 395 631 l 399 629 b 411 617 404 627 409 622 b 412 315 412 614 412 465 b 411 14 412 166 412 17 b 390 0 407 5 399 0 b 370 14 382 0 373 5 b 368 237 368 17 368 18 l 368 456 l 0 456 l -368 456 l -368 237 b -370 14 -368 18 -368 17 b -390 0 -373 5 -382 0 b -411 14 -399 0 -407 5 b -412 315 -412 17 -412 166 b -411 617 -412 465 -412 614 b -399 629 -409 622 -404 627 z m -290 384 b 3 385 -287 385 -141 385 b 289 384 145 385 287 385 b 301 372 294 382 300 377 b 303 193 303 369 303 281 b 301 14 303 105 303 17 b 281 0 298 5 290 0 b 265 7 275 0 270 2 b 259 80 260 12 259 4 b 259 130 259 94 259 111 l 259 243 l 0 243 l -259 243 l -259 130 b -259 80 -259 111 -259 94 b -265 7 -259 4 -260 12 b -281 0 -270 2 -275 0 b -301 14 -290 0 -298 5 b -303 193 -303 17 -303 105 b -301 372 -303 281 -303 369 b -290 384 -300 376 -294 382 z m -15 196 b 0 197 -10 197 -5 197 b 74 163 27 197 56 184 b 98 99 91 145 98 121 b 55 17 98 67 83 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -65 187 z"
                },
                fermataVeryLongBelow: {
                    x_min: -286,
                    x_max: 286,
                    y_min: -438,
                    y_max: 0,
                    ha: 438,
                    o: "m -399 -2 b -391 0 -396 -1 -393 0 b -370 -14 -382 0 -373 -6 b -368 -237 -368 -18 -368 -18 l -368 -456 l 0 -456 l 368 -456 l 368 -237 b 370 -14 368 -18 368 -18 b 390 0 373 -5 382 0 b 411 -14 399 0 407 -5 b 412 -316 412 -17 412 -166 b 411 -617 412 -465 412 -614 b 399 -629 409 -622 404 -628 l 395 -631 l 0 -631 l -395 -631 l -399 -629 b -411 -617 -404 -628 -409 -622 b -412 -316 -412 -614 -412 -465 b -411 -14 -412 -166 -412 -17 b -399 -2 -409 -9 -404 -4 z m -290 -2 b -281 0 -287 -1 -284 0 b -261 -14 -272 0 -264 -6 b -259 -130 -259 -18 -259 -19 l -259 -243 l 0 -243 l 259 -243 l 259 -130 b 259 -81 259 -111 259 -94 b 265 -7 259 -5 260 -13 b 281 0 270 -2 275 0 b 301 -14 290 0 298 -5 b 303 -193 303 -17 303 -105 b 301 -372 303 -281 303 -369 b 289 -384 300 -377 294 -382 b 0 -385 287 -385 143 -385 b -289 -384 -143 -385 -287 -385 b -301 -372 -294 -382 -300 -377 b -303 -193 -303 -369 -303 -281 b -301 -14 -303 -105 -303 -17 b -290 -2 -300 -9 -294 -4 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
                },
                fermataVeryShortAbove: {
                    x_min: -351,
                    x_max: 351,
                    y_min: 0,
                    y_max: 571,
                    ha: 571,
                    o: "m -9 820 b 0 822 -6 821 -3 822 b 8 820 3 822 6 821 b 35 785 15 818 17 815 b 68 733 45 770 59 747 b 98 684 76 720 90 698 b 146 606 107 670 128 635 b 193 532 164 578 185 544 b 227 477 200 519 216 495 b 313 337 277 396 301 358 b 362 260 321 325 343 290 b 406 188 380 230 400 197 b 436 140 412 179 425 157 b 505 25 500 37 505 30 b 505 22 505 24 505 23 b 491 2 505 13 499 5 b 450 0 488 1 469 0 b 409 2 431 0 412 1 b 382 37 403 4 400 7 b 350 89 373 52 358 75 b 319 138 342 102 328 124 b 271 216 311 152 289 187 b 225 290 253 244 232 278 b 191 345 217 302 202 327 b 104 485 142 424 117 464 b 8 639 73 534 24 613 b -21 686 -2 655 -15 676 b -33 704 -27 696 -33 704 b -44 686 -33 704 -38 696 b -73 639 -51 676 -64 655 b -170 485 -89 614 -133 543 b -203 430 -177 472 -192 448 b -290 290 -253 351 -277 311 b -337 216 -298 278 -319 244 b -385 138 -355 187 -376 152 b -415 89 -393 124 -407 102 b -448 37 -424 75 -438 52 b -474 2 -466 7 -468 4 b -483 0 -477 1 -480 0 b -505 22 -495 0 -505 9 b -505 25 -505 23 -505 24 b -436 140 -505 30 -500 37 b -406 188 -425 157 -412 179 b -362 260 -400 197 -380 230 b -313 337 -343 290 -321 325 b -227 477 -301 358 -277 396 b -193 532 -216 495 -200 519 b -146 606 -185 544 -164 578 b -98 684 -128 635 -107 670 b -68 733 -90 697 -76 720 b -35 785 -59 747 -45 770 b -9 820 -17 814 -14 818 z m -36 506 b -28 508 -33 507 -30 508 b -12 502 -22 508 -16 506 b 280 30 -8 498 278 36 b 281 22 281 28 281 25 b 268 2 281 14 276 5 b 226 0 265 1 246 0 b 185 2 207 0 188 1 b 58 199 178 4 182 -1 b -60 389 -7 304 -60 389 b -178 199 -60 389 -114 304 b -305 2 -302 -1 -298 4 b -314 0 -308 1 -311 0 b -336 22 -326 0 -336 10 b -334 30 -336 25 -335 27 b -43 502 -332 36 -46 498 b -36 506 -41 504 -38 506 z m -56 196 b -41 197 -51 197 -46 197 b 33 163 -14 197 15 184 b 57 99 50 145 57 121 b 15 17 57 67 43 36 b -41 0 -3 5 -22 0 b -139 99 -92 0 -139 40 b -56 196 -139 148 -105 187 z"
                },
                fermataVeryShortBelow: {
                    x_min: -351,
                    x_max: 351,
                    y_min: -571,
                    y_max: 0,
                    ha: 571,
                    o: "m 9 -820 b 0 -822 6 -821 3 -822 b -8 -820 -3 -822 -6 -821 b -35 -785 -15 -818 -17 -815 b -68 -733 -45 -770 -59 -747 b -98 -684 -76 -720 -90 -698 b -146 -606 -107 -670 -128 -635 b -193 -532 -164 -578 -185 -544 b -227 -477 -200 -519 -216 -495 b -313 -337 -277 -396 -301 -358 b -362 -260 -321 -325 -343 -290 b -406 -188 -380 -230 -400 -197 b -436 -140 -412 -179 -425 -157 b -505 -25 -500 -37 -505 -30 b -505 -22 -505 -24 -505 -23 b -491 -2 -505 -13 -499 -5 b -450 0 -488 -1 -469 0 b -409 -2 -431 0 -412 -1 b -382 -37 -403 -4 -400 -7 b -350 -89 -373 -52 -358 -75 b -319 -138 -342 -102 -328 -124 b -271 -216 -311 -152 -289 -187 b -225 -290 -253 -244 -232 -278 b -191 -345 -217 -302 -202 -327 b -104 -485 -142 -424 -117 -464 b -8 -639 -73 -534 -24 -613 b 21 -686 2 -655 15 -676 b 33 -704 27 -696 33 -704 b 44 -686 33 -704 38 -696 b 73 -639 51 -676 64 -655 b 170 -485 89 -614 133 -543 b 203 -430 177 -472 192 -448 b 290 -290 253 -351 277 -311 b 337 -216 298 -278 319 -244 b 385 -138 355 -187 376 -152 b 415 -89 393 -124 407 -102 b 448 -37 424 -75 438 -52 b 474 -2 466 -7 468 -4 b 483 0 477 -1 480 0 b 505 -22 495 0 505 -9 b 505 -25 505 -23 505 -24 b 436 -140 505 -30 500 -37 b 406 -188 425 -157 412 -179 b 362 -260 400 -197 380 -230 b 313 -337 343 -290 321 -325 b 227 -477 301 -358 277 -396 b 193 -532 216 -495 200 -519 b 146 -606 185 -544 164 -578 b 98 -684 128 -635 107 -670 b 68 -733 90 -697 76 -720 b 35 -785 59 -747 45 -770 b 9 -820 17 -814 14 -818 z m 36 -506 b 28 -508 33 -507 30 -508 b 12 -502 22 -508 16 -506 b -280 -30 8 -498 -278 -36 b -281 -22 -281 -28 -281 -25 b -268 -2 -281 -14 -276 -5 b -226 0 -265 -1 -246 0 b -185 -2 -207 0 -188 -1 b -58 -199 -178 -4 -182 1 b 60 -389 7 -304 60 -389 b 178 -199 60 -389 114 -304 b 305 -2 302 1 298 -4 b 314 0 308 -1 311 0 b 336 -22 326 0 336 -10 b 334 -30 336 -25 335 -27 b 43 -502 332 -36 46 -498 b 36 -506 41 -504 38 -506 z m 56 -196 b 41 -197 51 -197 46 -197 b -33 -163 14 -197 -15 -184 b -57 -99 -50 -145 -57 -121 b -15 -17 -57 -67 -43 -36 b 41 0 3 -5 22 0 b 139 -99 92 0 139 -40 b 56 -196 139 -148 105 -187 z"
                },
                fermataShortAbove: {
                    x_min: -286,
                    x_max: 286,
                    y_min: 0,
                    y_max: 469,
                    ha: 469,
                    o: "m -9 674 b 0 676 -6 675 -3 676 b 15 670 6 676 11 674 b 74 576 17 667 37 637 b 233 319 105 526 176 410 b 373 92 290 227 353 125 b 411 30 393 59 410 31 b 412 23 412 27 412 25 b 398 2 412 14 407 5 b 357 0 396 1 376 0 b 316 2 338 0 319 1 b 250 100 309 4 309 4 b 91 357 220 150 148 266 b -22 541 35 449 -17 532 b -33 558 -28 550 -33 558 b -42 544 -33 558 -37 551 b -137 389 -47 536 -89 467 b -240 223 -185 312 -231 237 b -382 2 -387 -16 -374 4 b -390 0 -385 1 -387 0 b -412 22 -402 0 -412 9 l -412 22 b -375 90 -412 29 -412 29 b -253 286 -285 236 -269 261 b -182 402 -244 301 -212 354 b -34 641 -127 491 -64 593 b -9 674 -17 668 -15 672 z m -15 196 b -1 197 -10 197 -5 197 b 74 163 27 197 56 184 b 98 99 90 145 98 121 b 55 17 98 67 83 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -65 187 z"
                },
                fermataShortBelow: {
                    x_min: -286,
                    x_max: 286,
                    y_min: -469,
                    y_max: 0,
                    ha: 469,
                    o: "m -399 -2 b -390 0 -396 -1 -393 0 b -375 -6 -385 0 -379 -3 b -316 -100 -373 -9 -353 -39 b -157 -358 -285 -150 -214 -266 b -43 -541 -100 -449 -49 -532 b -33 -558 -38 -550 -33 -558 b -24 -544 -32 -558 -28 -552 b 20 -473 -19 -536 1 -505 b 72 -390 39 -442 62 -405 b 143 -274 81 -375 113 -322 b 291 -35 198 -185 261 -83 b 316 -2 308 -8 310 -4 b 357 0 319 -1 338 0 b 399 -2 377 0 396 -1 b 412 -23 407 -5 412 -14 b 411 -30 412 -25 412 -27 b 392 -62 410 -31 402 -46 b 355 -122 382 -78 365 -105 b 253 -287 345 -138 299 -212 b 152 -451 207 -361 162 -435 b 76 -573 142 -467 108 -522 b 4 -676 16 -671 13 -676 b 0 -676 3 -676 1 -676 b -4 -676 -1 -676 -3 -676 b -74 -576 -13 -676 -16 -671 b -233 -319 -105 -526 -176 -411 b -373 -92 -290 -227 -353 -125 b -411 -30 -393 -59 -410 -31 b -412 -23 -412 -27 -412 -25 b -399 -2 -412 -14 -407 -5 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
                },
                breathMarkComma: {
                    x_min: 0,
                    x_max: 168,
                    y_min: -155,
                    y_max: 155,
                    ha: 311,
                    o: "m 96 223 b 107 224 100 224 103 224 b 236 104 164 224 218 174 b 242 55 240 88 242 71 b 66 -209 242 -42 175 -144 b 33 -224 48 -219 39 -224 b 25 -219 30 -224 28 -222 b 23 -213 24 -216 23 -215 b 36 -199 23 -208 28 -204 b 130 -56 96 -166 130 -110 b 111 8 130 -34 124 -12 l 110 10 l 100 11 b 6 82 58 12 19 42 b 0 117 2 94 0 105 b 96 223 0 170 40 217 z"
                },
                breathMarkUpbow: {
                    x_min: -125,
                    x_max: 125,
                    y_min: 0,
                    y_max: 409,
                    ha: 409,
                    o: "m -171 588 b -130 589 -168 589 -166 589 l -123 589 b -83 585 -87 589 -88 589 b -23 385 -80 581 -84 594 b 34 193 8 280 34 193 b 91 385 34 193 60 280 b 149 580 122 491 148 579 b 164 590 151 586 157 590 b 179 580 170 590 176 586 b 180 577 179 579 180 579 b 99 292 180 569 169 533 b 13 6 18 16 15 6 b 13 6 13 6 13 6 b 12 5 13 6 13 6 b 0 0 9 2 5 0 b -16 11 -7 0 -13 4 b -180 573 -25 41 -180 570 b -171 588 -180 580 -177 586 z"
                },
                caesura: {
                    x_min: 0,
                    x_max: 457,
                    y_min: -202,
                    y_max: 303,
                    ha: 504,
                    o: "m 423 434 b 431 436 426 435 428 436 b 453 414 443 436 453 426 b 452 406 453 411 453 409 b 37 -284 450 401 41 -281 b 23 -290 33 -289 28 -290 b 0 -268 11 -290 0 -281 b 1 -261 0 -266 0 -263 b 416 430 3 -256 413 427 b 423 434 418 431 421 433 z m 627 434 b 636 436 630 435 633 436 b 658 414 648 436 658 426 b 657 406 658 411 658 409 b 242 -284 655 401 245 -281 b 227 -290 238 -289 232 -290 b 205 -268 216 -290 205 -281 b 206 -261 205 -266 205 -263 b 621 430 208 -256 618 427 b 627 434 623 431 625 433 z"
                },
                caesuraCurved: {
                    x_min: 0,
                    x_max: 370,
                    y_min: -207,
                    y_max: 310,
                    ha: 517,
                    o: "m 291 447 b 296 447 293 447 294 447 b 328 410 314 447 328 431 b 328 403 328 408 328 406 b 325 384 328 401 326 392 b 44 -284 299 206 196 -38 b 22 -298 38 -293 30 -298 b 7 -291 16 -298 11 -296 b 0 -278 2 -287 0 -283 b 11 -251 0 -272 3 -264 b 262 409 146 -12 245 246 b 291 447 264 433 273 444 z m 496 447 b 501 447 498 447 499 447 b 533 410 519 447 533 431 b 533 403 533 408 533 406 b 530 384 532 401 531 392 b 248 -284 504 206 401 -38 b 226 -298 242 -293 234 -298 b 211 -291 221 -298 216 -296 b 205 -278 207 -287 205 -283 b 215 -251 205 -272 208 -264 b 466 409 351 -12 449 246 b 496 447 469 433 477 444 z"
                },
                restMaxima: {
                    x_min: 0,
                    x_max: 853,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 0 0 l 0 360 l 205 360 l 409 360 l 409 0 l 409 -360 l 205 -360 l 0 -360 z m 819 0 l 819 360 l 1023 360 l 1228 360 l 1228 0 l 1228 -360 l 1023 -360 l 819 -360 z"
                },
                restDoubleWhole: {
                    x_min: 0,
                    x_max: 284,
                    y_min: 0,
                    y_max: 250,
                    ha: 250,
                    o: "m 0 180 l 0 360 l 205 360 l 409 360 l 409 180 l 409 0 l 205 0 l 0 0 z"
                },
                restWhole: {
                    x_min: 0,
                    x_max: 330,
                    y_min: -125,
                    y_max: 0,
                    ha: 125,
                    o: "m 0 -90 l 0 0 l 237 0 l 475 0 l 475 -90 l 475 -180 l 237 -180 l 0 -180 z"
                },
                restWholeLegerLine: {
                    x_min: 0,
                    x_max: 542,
                    y_min: -125,
                    y_max: 11,
                    ha: 137,
                    o: "m 9 15 b 427 17 11 16 226 17 b 771 15 603 17 769 16 b 780 0 777 13 780 6 b 771 -15 780 -6 777 -13 b 698 -16 768 -16 760 -16 l 628 -16 l 628 -98 l 628 -180 l 390 -180 l 153 -180 l 153 -98 l 153 -16 l 83 -16 b 10 -15 21 -16 12 -16 b 0 0 3 -13 0 -6 b 9 15 0 6 3 12 z"
                },
                restHalf: {
                    x_min: 0,
                    x_max: 330,
                    y_min: 0,
                    y_max: 125,
                    ha: 125,
                    o: "m 0 90 l 0 180 l 237 180 l 475 180 l 475 90 l 475 0 l 237 0 l 0 0 z"
                },
                restHalfLegerLine: {
                    x_min: 0,
                    x_max: 542,
                    y_min: -11,
                    y_max: 125,
                    ha: 137,
                    o: "m 153 98 l 153 180 l 390 180 l 628 180 l 628 98 l 628 16 l 698 16 b 771 15 760 16 769 16 b 781 0 777 13 781 6 b 771 -15 781 -6 777 -13 b 427 -17 769 -16 603 -17 b 9 -15 226 -17 11 -16 b 0 0 3 -12 0 -6 b 4 12 0 4 1 8 b 58 16 9 16 5 16 b 83 16 65 16 73 16 l 153 16 z"
                },
                restQuarter: {
                    x_min: 0,
                    x_max: 221,
                    y_min: -365,
                    y_max: 365,
                    ha: 730,
                    o: "m 50 524 b 56 526 52 525 54 526 b 74 516 62 526 67 523 b 96 497 78 513 88 504 b 118 478 105 489 115 481 b 181 423 143 456 154 447 b 311 305 302 317 311 310 b 310 302 311 304 310 303 b 310 299 310 301 310 300 b 298 278 310 295 310 294 b 234 132 268 233 245 181 b 222 39 226 100 222 69 b 306 -177 222 -46 251 -123 b 319 -198 318 -190 319 -191 b 303 -214 319 -208 313 -214 b 291 -212 299 -214 295 -213 b 260 -208 281 -209 270 -208 b 155 -260 221 -208 181 -227 b 122 -353 133 -287 122 -320 b 185 -490 122 -400 143 -450 b 197 -510 193 -498 197 -505 b 191 -521 197 -514 195 -517 b 181 -526 188 -524 185 -526 b 136 -495 173 -526 161 -517 b 0 -270 48 -420 0 -340 l 0 -270 l 0 -253 l 2 -243 b 157 -146 19 -182 78 -146 b 217 -152 176 -146 196 -148 l 228 -155 l 226 -152 b 124 -62 223 -150 168 -101 b 19 37 23 27 19 31 b 19 39 19 38 19 39 l 19 40 b 29 59 19 46 19 47 b 117 312 87 138 117 229 b 53 489 117 382 96 446 b 41 509 42 500 41 503 b 50 524 41 516 44 521 z"
                },
                rest8th: {
                    x_min: 0,
                    x_max: 258,
                    y_min: -197,
                    y_max: 219,
                    ha: 416,
                    o: "m 98 315 b 110 316 102 315 106 316 b 177 293 132 316 159 307 b 218 207 204 271 218 239 b 191 137 218 182 209 157 l 187 132 l 193 134 b 326 260 251 150 302 198 b 331 270 328 264 330 269 b 349 279 336 276 343 279 b 371 257 360 279 371 270 b 213 -273 371 253 216 -267 b 194 -283 209 -280 202 -283 b 173 -270 185 -283 176 -279 b 172 -265 172 -268 172 -268 b 230 -62 172 -257 180 -228 b 289 134 263 46 289 134 b 289 134 289 134 289 134 b 280 128 289 134 285 131 b 149 84 241 98 194 84 b 39 121 108 84 69 96 b 0 204 13 142 0 173 b 31 282 0 232 10 260 b 98 315 48 300 69 311 z"
                },
                rest16th: {
                    x_min: 0,
                    x_max: 331,
                    y_min: -443,
                    y_max: 219,
                    ha: 662,
                    o: "m 205 315 b 216 316 208 315 212 316 b 283 293 239 316 265 307 b 324 207 310 271 324 239 b 298 137 324 182 316 157 l 293 132 l 299 134 b 433 260 358 150 409 198 b 438 270 434 264 437 269 b 455 279 443 276 449 279 b 477 257 467 279 477 270 b 213 -627 477 253 216 -621 b 194 -638 209 -635 202 -638 b 173 -625 185 -638 176 -634 b 172 -620 172 -623 172 -622 b 230 -417 172 -612 180 -583 b 289 -221 263 -309 289 -221 b 289 -221 289 -221 289 -221 b 280 -227 289 -221 285 -223 b 149 -271 241 -256 194 -271 b 39 -234 108 -271 69 -259 b 0 -150 13 -213 0 -182 b 31 -73 0 -123 10 -95 b 110 -39 52 -50 81 -39 b 207 -100 149 -39 188 -60 b 218 -147 214 -114 218 -131 b 191 -218 218 -173 209 -199 l 187 -223 l 193 -221 b 326 -96 251 -205 302 -157 b 395 134 328 -91 395 133 b 395 134 395 134 395 134 b 387 128 395 134 391 131 b 256 84 347 98 301 84 b 145 121 215 84 175 96 b 106 204 119 142 106 173 b 137 282 106 232 116 260 b 205 315 155 300 176 311 z"
                },
                rest32nd: {
                    x_min: 0,
                    x_max: 405,
                    y_min: -443,
                    y_max: 466,
                    ha: 909,
                    o: "m 311 670 b 322 670 315 670 318 670 b 390 647 345 670 371 662 b 431 562 417 626 431 594 b 404 492 431 536 422 511 l 400 487 l 406 488 b 539 614 464 504 515 552 b 544 625 541 619 543 623 b 562 633 549 631 555 633 b 584 612 573 633 584 625 b 213 -627 584 607 216 -621 b 194 -638 209 -635 202 -638 b 173 -625 185 -638 176 -634 b 172 -620 172 -623 172 -622 b 230 -417 172 -612 180 -583 b 289 -221 263 -309 289 -221 b 289 -221 289 -221 289 -221 b 280 -227 289 -221 285 -223 b 149 -271 241 -256 194 -271 b 39 -234 108 -271 69 -259 b 0 -150 13 -213 0 -182 b 31 -73 0 -123 10 -95 b 110 -39 52 -50 81 -39 b 207 -100 149 -39 188 -60 b 218 -147 214 -114 218 -131 b 191 -218 218 -173 209 -199 l 187 -223 l 193 -221 b 326 -96 251 -205 302 -157 b 395 134 328 -91 395 133 b 395 134 395 134 395 134 b 387 128 395 134 391 131 b 256 84 347 98 301 84 b 145 121 215 84 175 96 b 106 204 119 142 106 173 b 137 282 106 232 116 260 b 216 315 159 304 187 315 b 314 255 255 315 295 294 b 324 208 321 240 324 224 b 298 137 324 182 315 156 l 293 132 l 299 134 b 432 258 357 149 409 198 b 502 489 434 264 502 487 b 502 489 502 489 502 489 b 493 483 502 489 498 486 b 362 438 454 453 407 438 b 251 475 321 438 282 451 b 213 559 226 496 213 528 b 243 636 213 587 223 615 b 311 670 261 655 282 665 z"
                },
                rest64th: {
                    x_min: 0,
                    x_max: 479,
                    y_min: -689,
                    y_max: 466,
                    ha: 1155,
                    o: "m 417 670 b 429 670 421 670 425 670 b 496 647 451 670 478 662 b 537 562 523 626 537 594 b 510 492 537 536 529 511 l 506 487 l 512 488 b 646 614 570 504 621 552 b 651 625 647 619 650 623 b 668 633 655 631 662 633 b 690 612 679 633 690 625 b 213 -982 690 607 216 -976 b 194 -993 209 -989 202 -993 b 173 -979 185 -993 176 -988 b 172 -974 172 -978 172 -977 b 230 -771 172 -966 180 -938 b 289 -575 263 -664 289 -575 b 289 -575 289 -575 289 -575 b 280 -582 289 -575 285 -578 b 149 -626 241 -611 194 -626 b 39 -589 108 -626 69 -613 b 0 -505 13 -568 0 -537 b 31 -428 0 -477 10 -449 b 110 -394 52 -405 81 -394 b 207 -454 149 -394 188 -415 b 218 -502 214 -469 218 -485 b 191 -572 218 -528 209 -553 l 187 -577 l 193 -576 b 326 -451 251 -560 302 -512 b 395 -221 328 -446 395 -222 b 395 -221 395 -221 395 -221 b 387 -227 395 -221 391 -223 b 256 -271 347 -256 301 -271 b 145 -234 215 -271 175 -259 b 106 -150 119 -213 106 -182 b 137 -73 106 -123 116 -95 b 216 -39 159 -50 187 -39 b 314 -100 255 -39 295 -60 b 324 -147 321 -114 324 -131 b 298 -218 324 -173 315 -199 l 293 -223 l 299 -221 b 432 -96 357 -205 409 -157 b 502 134 434 -91 502 133 b 502 134 502 134 502 134 b 493 128 502 134 498 131 b 362 84 454 98 407 84 b 251 121 321 84 282 96 b 213 204 226 142 213 173 b 243 282 213 232 223 260 b 322 315 265 304 294 315 b 420 255 362 315 401 294 b 431 208 427 240 431 224 b 404 137 431 182 422 156 l 400 132 l 406 134 b 539 258 463 149 515 198 b 608 489 541 264 608 487 b 608 489 608 489 608 489 b 599 483 608 489 604 486 b 468 438 560 453 513 438 b 358 475 428 438 388 451 b 319 559 332 496 319 528 b 350 636 319 587 329 615 b 417 670 368 655 388 665 z"
                },
                rest128th: {
                    x_min: 0,
                    x_max: 553,
                    y_min: -689,
                    y_max: 712,
                    ha: 1401,
                    o: "m 524 1024 b 535 1025 527 1025 531 1025 b 603 1002 558 1025 584 1016 b 644 916 630 981 644 949 b 617 846 644 891 635 866 l 612 841 l 619 843 b 752 969 677 859 728 907 b 757 979 754 973 756 978 b 775 988 762 985 768 988 b 797 966 786 988 797 980 b 213 -982 797 962 216 -976 b 194 -993 209 -989 202 -993 b 173 -979 185 -993 176 -988 b 172 -974 172 -978 172 -977 b 230 -771 172 -966 180 -938 b 289 -575 263 -664 289 -575 b 289 -575 289 -575 289 -575 b 280 -582 289 -575 285 -578 b 149 -626 241 -611 194 -626 b 39 -589 108 -626 69 -613 b 0 -505 13 -568 0 -537 b 31 -428 0 -477 10 -449 b 110 -394 52 -405 81 -394 b 207 -454 149 -394 188 -415 b 218 -502 214 -469 218 -485 b 191 -572 218 -528 209 -553 l 187 -577 l 193 -576 b 326 -451 251 -560 302 -512 b 395 -221 328 -446 395 -222 b 395 -221 395 -221 395 -221 b 387 -227 395 -221 391 -223 b 256 -271 347 -256 301 -271 b 145 -234 215 -271 175 -259 b 106 -150 119 -213 106 -182 b 137 -73 106 -123 116 -95 b 216 -39 159 -50 187 -39 b 314 -100 255 -39 295 -60 b 324 -147 321 -114 324 -131 b 298 -218 324 -173 315 -199 l 293 -223 l 299 -221 b 432 -96 357 -205 409 -157 b 502 134 434 -91 502 133 b 502 134 502 134 502 134 b 493 128 502 134 498 131 b 362 84 454 98 407 84 b 251 121 321 84 282 96 b 213 204 226 142 213 173 b 243 282 213 232 223 260 b 322 315 265 304 294 315 b 420 255 362 315 401 294 b 431 208 427 240 431 224 b 404 137 431 182 422 156 l 400 132 l 406 134 b 539 258 463 149 515 198 b 608 489 541 264 608 487 b 608 489 608 489 608 489 b 599 483 608 489 604 486 b 468 438 560 453 513 438 b 358 475 428 438 388 451 b 319 559 332 496 319 528 b 350 636 319 587 329 615 b 429 670 372 659 400 670 b 526 610 468 670 507 649 b 537 563 534 595 537 579 b 511 492 537 536 528 511 l 506 487 l 512 488 b 645 613 570 504 621 553 b 715 843 647 618 715 842 b 715 843 715 843 715 843 b 706 837 714 843 711 841 b 575 793 667 808 620 793 b 464 830 534 793 495 805 b 426 914 439 851 426 882 b 456 991 426 941 436 969 b 524 1024 474 1010 495 1020 z"
                },
                dynamicPiano: {
                    x_min: -39,
                    x_max: 378,
                    y_min: -178,
                    y_max: 277,
                    ha: 455,
                    o: "m 197 399 b 208 399 201 399 205 399 b 305 314 255 399 298 362 l 306 308 l 312 315 b 405 382 339 346 376 373 b 430 386 413 385 421 386 b 494 362 451 386 474 378 b 544 249 526 336 544 296 b 377 -30 544 116 475 1 b 334 -37 362 -34 347 -37 b 291 -25 316 -37 300 -33 b 281 -17 289 -23 285 -20 b 240 43 262 -1 248 20 b 237 52 238 47 237 52 b 237 53 237 52 237 53 b 198 -74 236 53 229 30 b 159 -207 166 -181 159 -202 b 160 -209 159 -208 160 -208 b 194 -221 165 -213 179 -218 b 206 -224 198 -222 204 -224 b 217 -240 213 -226 217 -233 b 208 -255 217 -246 214 -252 b 81 -257 206 -256 144 -257 b -46 -255 18 -257 -44 -256 b -56 -240 -52 -252 -56 -246 b -51 -229 -56 -236 -54 -232 b -33 -222 -48 -225 -46 -225 b 29 -191 9 -213 24 -206 b 174 291 34 -177 173 286 b 176 303 174 294 175 299 b 178 317 177 308 178 313 b 163 336 178 329 173 336 b 157 336 161 336 159 336 b 70 239 124 326 90 288 b 56 224 65 225 63 224 b 46 233 49 224 46 227 b 49 248 46 237 47 242 b 149 376 70 302 105 347 b 161 385 154 379 160 383 b 197 399 168 391 184 397 z m 399 318 b 389 320 396 320 393 320 b 318 285 370 320 340 306 b 302 263 306 273 304 270 b 297 253 301 260 299 256 b 273 176 296 250 288 226 l 251 104 l 252 97 b 266 51 253 81 258 64 b 296 29 274 39 288 29 b 298 29 297 29 297 29 b 309 34 299 30 304 32 b 429 230 370 62 420 144 b 431 256 430 240 431 249 b 399 318 431 289 421 307 z"
                },
                dynamicMezzo: {
                    x_min: 35,
                    x_max: 493,
                    y_min: -19,
                    y_max: 272,
                    ha: 291,
                    o: "m 191 390 b 206 392 196 391 201 392 b 282 350 235 392 265 376 b 291 331 285 345 291 333 b 292 330 291 330 292 330 b 297 337 292 330 294 331 b 329 371 306 350 317 362 b 339 380 332 374 336 377 b 376 392 347 388 361 392 b 434 372 395 392 418 385 b 463 331 447 362 461 341 b 464 330 463 330 463 330 b 469 337 464 330 466 331 b 501 371 478 350 489 362 b 511 380 504 374 508 377 b 548 392 519 388 533 392 b 606 372 567 392 589 385 b 641 295 628 354 641 323 b 633 260 641 282 639 270 b 576 69 631 256 576 72 b 574 59 576 68 575 63 b 573 47 573 55 573 51 b 585 25 573 35 577 25 b 586 26 585 25 585 25 b 684 127 621 30 664 74 b 699 145 690 143 692 145 b 709 135 706 145 709 142 b 696 98 709 128 705 116 b 595 -12 672 47 640 12 b 582 -20 590 -15 584 -19 b 552 -27 573 -25 563 -27 b 481 18 524 -27 495 -10 b 470 63 474 31 470 47 b 478 98 470 76 473 88 b 535 289 480 102 535 285 b 537 298 535 290 536 294 b 538 311 538 303 538 307 b 522 339 538 324 533 333 b 516 341 519 340 517 341 b 507 337 514 341 512 340 b 468 282 491 329 470 300 b 462 261 467 276 464 264 b 422 133 461 259 444 203 b 380 2 383 1 384 4 l 378 0 l 333 0 b 321 0 329 0 324 0 b 283 5 284 0 286 0 b 282 8 282 6 282 7 b 322 149 282 15 288 37 b 363 289 344 224 363 287 b 365 299 364 292 364 296 b 367 311 366 303 367 307 b 350 339 367 324 361 333 b 344 341 347 340 346 341 b 336 337 342 341 340 340 b 296 282 319 329 298 300 b 290 261 295 276 292 264 b 251 133 289 259 272 203 b 208 2 211 1 212 4 l 206 0 l 161 0 b 149 0 157 0 152 0 b 111 5 112 0 114 0 b 110 8 110 6 110 7 b 150 149 110 15 116 37 b 191 289 172 224 191 287 b 193 299 192 292 193 296 b 195 311 194 303 195 307 b 179 338 195 323 189 333 b 171 340 176 339 174 340 b 150 333 166 340 160 338 b 75 240 120 318 92 283 b 60 224 69 225 67 224 b 50 233 53 224 50 227 b 53 248 50 237 51 242 b 162 378 75 306 117 355 b 170 383 164 379 168 381 b 191 390 176 386 183 389 z"
                },
                dynamicForte: {
                    x_min: -87,
                    x_max: 440,
                    y_min: -182,
                    y_max: 415,
                    ha: 597,
                    o: "m 486 597 b 491 597 487 597 489 597 b 515 596 499 597 512 597 b 528 595 517 596 523 595 b 631 522 576 591 622 559 b 633 506 632 516 633 511 b 559 433 633 466 598 433 b 532 439 550 433 541 435 b 493 499 506 450 493 475 b 518 548 493 517 501 536 b 519 550 519 549 519 549 b 519 550 519 550 519 550 b 496 537 518 550 504 542 b 371 353 445 503 399 436 b 367 341 369 347 367 341 b 407 341 367 341 385 341 b 414 341 410 341 412 341 b 459 335 452 341 451 341 b 468 314 465 330 468 322 b 459 293 468 306 465 298 b 411 286 451 287 453 286 b 399 286 407 286 404 286 l 353 286 l 351 279 b 174 -146 320 120 253 -41 b -24 -262 120 -218 45 -262 b -28 -262 -25 -262 -26 -262 b -125 -165 -83 -260 -125 -217 b -122 -140 -125 -157 -124 -148 b -53 -89 -113 -106 -83 -89 b 17 -142 -23 -89 8 -107 b 19 -158 18 -147 19 -153 b -13 -214 19 -181 7 -202 b -16 -217 -15 -216 -16 -216 b -16 -217 -16 -217 -16 -217 b -10 -215 -15 -217 -13 -216 b 80 -130 25 -205 58 -173 b 102 -74 88 -115 93 -102 b 186 245 126 -3 146 72 b 196 285 191 267 196 285 b 196 285 196 285 196 285 b 151 286 196 286 192 286 b 98 290 103 286 102 287 b 83 314 88 296 83 305 b 98 338 83 323 88 332 b 157 341 102 341 102 341 l 211 341 l 215 353 b 486 597 264 491 372 588 z"
                },
                dynamicRinforzando: {
                    x_min: 58,
                    x_max: 357,
                    y_min: 0,
                    y_max: 275,
                    ha: 275,
                    o: "m 383 395 b 401 396 389 395 395 396 b 508 352 446 396 495 377 b 515 327 513 344 515 336 b 490 285 515 310 506 293 b 465 278 482 280 474 278 b 423 301 450 278 434 286 b 365 332 408 322 386 332 b 299 281 335 332 307 314 b 296 272 298 277 297 273 b 294 266 295 271 294 269 b 291 260 293 264 292 261 b 252 133 290 259 273 201 b 210 2 213 1 214 4 l 207 0 l 163 0 b 150 0 158 0 154 0 b 112 5 113 0 115 0 b 111 8 112 6 111 7 b 152 149 111 15 118 37 b 193 289 174 225 192 287 b 195 300 193 292 194 296 b 197 315 196 305 197 310 b 175 344 197 331 189 342 b 170 344 173 344 172 344 b 109 316 149 344 127 334 b 95 306 100 306 99 306 b 84 316 88 306 84 310 b 87 325 84 319 85 322 b 149 372 99 341 127 363 b 211 388 168 381 197 388 b 215 388 213 388 214 388 b 283 349 245 385 267 372 b 285 345 284 347 285 345 b 285 345 285 345 285 345 b 291 350 286 345 288 347 b 383 395 316 374 349 390 z"
                },
                dynamicSforzando: {
                    x_min: 52,
                    x_max: 278,
                    y_min: -22,
                    y_max: 270,
                    ha: 292,
                    o: "m 259 388 b 271 388 263 388 267 388 b 370 362 305 388 338 379 b 396 338 385 354 391 348 b 401 315 399 331 401 323 b 359 261 401 290 384 266 b 349 260 356 260 352 260 b 300 306 322 260 300 282 b 305 327 300 313 302 320 b 308 332 307 330 308 332 b 308 332 308 332 308 332 b 287 334 308 334 297 334 b 269 333 279 334 272 334 b 220 300 245 329 226 316 b 219 295 219 299 219 297 b 273 232 219 278 243 249 b 301 215 289 223 295 219 b 373 95 347 181 373 136 b 361 49 373 79 369 63 b 219 -32 332 -4 277 -32 b 101 7 179 -32 138 -19 b 75 51 84 19 75 34 b 85 82 75 61 78 71 b 129 106 94 98 112 106 b 164 92 142 106 154 102 b 178 59 173 83 178 71 b 170 34 178 50 175 42 l 166 29 l 168 28 b 203 22 178 24 190 22 b 226 25 211 22 219 23 b 275 68 253 31 275 52 b 274 75 275 70 274 73 b 217 132 264 98 249 114 b 122 262 161 163 127 210 b 122 270 122 265 122 267 b 259 388 122 329 184 384 z"
                },
                dynamicZ: {
                    x_min: 23,
                    x_max: 309,
                    y_min: 2,
                    y_max: 250,
                    ha: 248,
                    o: "m 124 360 b 222 360 125 360 168 360 b 435 359 312 360 434 360 b 445 344 442 356 445 350 b 440 331 445 339 444 335 b 314 227 438 330 382 283 b 190 124 247 172 191 125 l 188 123 l 201 123 b 205 123 202 123 204 123 b 268 101 231 123 249 117 b 320 79 284 88 305 79 b 326 80 322 79 324 79 b 340 93 330 81 334 84 b 342 97 341 96 342 97 b 342 98 342 98 342 98 b 340 97 342 98 341 97 b 330 96 336 96 333 96 b 294 134 311 96 294 113 b 295 142 294 136 294 139 b 340 176 299 163 320 176 b 371 163 351 176 363 172 b 383 124 380 154 383 139 b 359 60 383 100 375 74 b 322 30 350 51 329 35 b 239 3 295 12 266 3 b 179 21 218 3 197 9 b 117 39 161 33 138 39 b 86 35 106 39 95 38 b 67 23 79 32 76 31 b 49 14 58 15 55 14 b 33 30 39 14 33 21 b 38 42 33 34 34 38 b 73 72 41 46 60 62 b 303 262 80 77 299 258 b 303 262 303 262 303 262 b 246 263 303 262 277 263 b 146 261 203 263 150 262 b 102 239 131 259 117 252 b 88 231 94 232 92 231 b 85 230 87 230 86 230 b 69 246 76 230 69 237 l 69 247 l 69 252 l 92 302 b 116 355 104 330 115 354 b 124 360 118 357 122 359 z"
                },
                ornamentTrill: {
                    x_min: -249,
                    x_max: 249,
                    y_min: 0,
                    y_max: 376,
                    ha: 376,
                    o: "m -92 502 b -29 542 -33 541 -33 542 b -21 534 -25 542 -21 539 b -70 366 -21 532 -65 383 l -71 364 l -47 364 b 125 383 13 366 71 372 b 149 387 136 386 143 387 b 167 382 156 387 160 385 b 181 370 171 380 179 373 b 182 370 181 370 181 370 b 230 380 185 370 195 372 b 304 394 286 393 290 394 b 305 394 305 394 305 394 b 357 353 330 394 349 379 b 359 336 358 349 359 342 b 354 314 359 326 357 316 b 257 291 352 312 263 291 b 257 291 257 291 257 291 b 250 299 252 292 250 294 b 251 305 250 301 250 303 b 251 314 251 308 251 311 b 234 350 251 329 245 343 l 230 353 l 224 349 b 169 287 202 334 183 313 b 127 156 163 276 166 286 b 88 37 92 43 91 39 b -8 15 84 35 -4 15 b -8 15 -8 15 -8 15 b -14 22 -12 16 -14 17 b -8 47 -14 26 -12 33 b -2 69 -5 59 -2 69 b -2 69 -2 69 -2 69 b -45 44 -2 69 -22 58 b -122 4 -102 10 -105 9 b -151 0 -132 1 -142 0 b -256 105 -208 0 -256 46 b -255 119 -256 110 -256 114 b -223 231 -254 129 -256 121 b -195 325 -208 282 -195 325 b -195 325 -195 325 -195 325 b -198 325 -196 325 -196 325 b -274 324 -206 325 -237 325 b -340 324 -310 324 -329 324 b -354 325 -351 324 -353 324 b -359 332 -357 326 -359 329 b -356 338 -359 334 -358 336 b -308 351 -355 340 -353 340 l -261 361 l -222 362 l -182 363 l -168 411 b -152 461 -160 438 -153 460 b -92 502 -152 462 -125 480 z m 62 348 b 57 349 60 349 59 349 b 40 346 55 349 51 348 b -62 330 8 339 -30 333 b -83 321 -84 329 -82 330 b -115 211 -83 318 -93 283 b -148 88 -149 94 -148 99 b -148 87 -148 88 -148 88 b -123 53 -148 67 -137 53 b -113 55 -120 53 -117 54 b 18 133 -111 57 17 132 b 46 227 19 134 46 225 b 53 251 46 231 48 239 b 78 334 57 261 78 331 b 62 348 78 340 71 347 z"
                },
                ornamentTurn: {
                    x_min: -310,
                    x_max: 310,
                    y_min: -143,
                    y_max: 143,
                    ha: 286,
                    o: "m -272 205 b -264 206 -270 206 -267 206 b -202 198 -249 206 -221 202 b 44 48 -119 177 -37 127 b 261 -91 117 -24 191 -71 b 307 -100 285 -97 297 -100 b 318 -99 311 -100 314 -99 b 401 2 362 -92 396 -51 b 402 11 401 5 402 8 b 321 87 402 58 366 87 b 258 70 301 87 279 81 b 221 60 246 63 233 60 b 157 125 186 60 157 86 b 213 194 157 158 175 179 b 277 206 234 202 256 206 b 437 90 348 206 413 162 b 447 24 444 69 447 47 b 365 -163 447 -46 416 -120 b 257 -206 331 -192 297 -206 b 178 -192 233 -206 207 -201 b -47 -48 101 -168 28 -121 b -250 86 -116 20 -180 62 b -312 99 -275 94 -295 99 b -361 83 -331 99 -346 94 b -402 6 -388 65 -402 36 b -349 -77 -402 -28 -384 -62 b -314 -85 -337 -82 -326 -85 b -260 -70 -297 -85 -280 -80 b -224 -60 -247 -63 -235 -60 b -188 -71 -211 -60 -199 -64 b -160 -126 -169 -84 -160 -105 b -189 -181 -160 -147 -169 -168 b -272 -204 -211 -195 -242 -204 b -293 -202 -279 -204 -286 -203 b -447 -6 -385 -189 -447 -103 b -435 68 -447 18 -443 43 b -280 204 -411 141 -349 196 b -272 205 -277 205 -273 205 z"
                },
                ornamentTurnSlash: {
                    x_min: -310,
                    x_max: 310,
                    y_min: -201,
                    y_max: 201,
                    ha: 402,
                    o: "m -10 288 b -2 289 -7 289 -4 289 b 19 276 8 289 16 284 b 21 171 21 272 21 271 l 21 71 l 43 49 b 261 -90 120 -26 191 -71 b 307 -100 285 -97 297 -100 b 318 -99 311 -100 314 -99 b 401 2 362 -91 396 -50 b 402 12 402 5 402 8 b 321 87 402 58 367 87 b 258 70 301 87 280 82 b 221 60 246 63 233 60 b 157 125 187 60 157 86 b 214 194 157 158 175 180 b 277 206 235 202 256 206 b 431 106 342 206 402 169 b 447 24 442 82 447 54 b 443 -24 447 9 446 -7 b 258 -206 423 -127 344 -206 b 257 -206 258 -206 258 -206 b 23 -109 190 -205 102 -169 l 21 -107 l 21 -190 b 21 -223 21 -203 21 -214 b 14 -283 21 -282 20 -277 b -1 -289 10 -287 5 -289 b -22 -276 -10 -289 -18 -284 b -23 -171 -23 -272 -23 -271 l -23 -71 l -46 -49 b -250 86 -119 22 -179 62 b -312 99 -275 95 -295 99 b -360 84 -330 99 -345 94 b -401 7 -388 66 -401 36 b -349 -77 -401 -28 -383 -62 b -314 -85 -337 -82 -326 -85 b -260 -69 -297 -85 -279 -80 b -223 -60 -247 -63 -235 -60 b -177 -81 -206 -60 -190 -67 b -159 -125 -165 -93 -159 -109 b -188 -180 -159 -147 -169 -168 b -268 -203 -212 -196 -240 -203 b -376 -165 -306 -203 -345 -190 b -447 -7 -425 -124 -447 -65 b -293 202 -447 86 -390 180 b -260 206 -283 204 -272 206 b -25 109 -194 206 -105 170 l -23 107 l -23 189 b -22 276 -23 271 -23 272 b -10 288 -20 281 -15 286 z"
                },
                ornamentMordent: {
                    x_min: -296,
                    x_max: 296,
                    y_min: -215,
                    y_max: 198,
                    ha: 413,
                    o: "m -11 284 b -3 285 -9 285 -6 285 b 17 273 5 285 14 280 b 19 164 19 270 19 269 l 19 59 l 68 118 b 118 179 98 155 117 178 b 131 182 122 181 127 182 b 143 179 136 182 140 181 b 307 18 145 177 232 92 l 326 -1 l 356 36 b 404 81 393 81 393 81 l 404 81 b 426 59 417 81 426 71 b 424 50 426 56 426 53 b 236 -179 421 44 241 -176 b 224 -182 233 -181 228 -182 b 211 -178 219 -182 215 -181 b 119 -89 210 -178 169 -137 b 29 0 70 -40 30 0 b 29 0 29 0 29 0 b 24 -6 29 0 27 -3 l 19 -12 l 19 -152 b 19 -218 19 -179 19 -200 b 13 -303 19 -308 19 -298 b -3 -310 9 -308 3 -310 b -23 -297 -11 -310 -19 -305 b -25 -180 -24 -294 -24 -294 l -25 -66 l -70 -121 b -118 -178 -99 -156 -116 -177 b -131 -182 -122 -181 -127 -182 b -144 -178 -135 -182 -140 -181 b -307 -18 -145 -177 -233 -91 l -326 1 l -356 -36 b -404 -81 -393 -81 -393 -81 l -404 -81 b -426 -59 -417 -81 -426 -71 b -424 -50 -426 -56 -426 -53 b -236 179 -421 -44 -241 176 b -224 182 -233 181 -228 182 b -211 179 -219 182 -215 181 b -48 18 -209 177 -116 86 l -29 0 l -27 2 l -25 5 l -25 137 b -23 272 -25 267 -25 268 b -11 284 -21 277 -16 282 z"
                },
                ornamentShortTrill: {
                    x_min: -296,
                    x_max: 296,
                    y_min: -127,
                    y_max: 127,
                    ha: 253,
                    o: "m -231 181 b -225 182 -229 182 -227 182 b -211 179 -220 182 -215 181 b -119 89 -210 178 -169 137 b -29 0 -70 40 -30 0 b 44 88 -29 0 4 40 b 118 179 89 144 117 178 b 131 182 122 181 127 182 b 143 179 136 182 140 181 b 307 18 145 177 232 92 l 326 -1 l 356 36 b 404 81 393 81 393 81 l 404 81 b 426 59 417 81 426 71 b 424 50 426 56 426 53 b 236 -179 421 44 241 -176 b 224 -182 233 -181 228 -182 b 211 -178 219 -182 215 -181 b 119 -89 210 -178 169 -137 b 29 0 70 -40 30 0 b -44 -88 29 0 -4 -40 b -118 -179 -89 -144 -117 -178 b -131 -182 -122 -181 -127 -182 b -144 -178 -135 -182 -140 -181 b -307 -18 -145 -177 -233 -91 l -326 1 l -356 -36 b -404 -81 -393 -81 -393 -81 l -404 -81 b -426 -59 -417 -81 -426 -71 b -424 -50 -426 -56 -426 -53 b -236 179 -421 -44 -241 176 b -231 181 -235 179 -233 181 z"
                },
                ornamentTremblement: {
                    x_min: -419,
                    x_max: 419,
                    y_min: -127,
                    y_max: 127,
                    ha: 253,
                    o: "m -409 181 b -402 182 -407 182 -404 182 b -389 179 -397 182 -392 181 b -297 89 -387 178 -346 137 b -207 0 -248 40 -207 0 l -207 0 b -134 88 -206 0 -174 40 b -59 179 -88 144 -61 178 b -46 182 -55 181 -51 182 b -34 179 -42 182 -37 181 b 58 89 -33 178 9 137 b 148 0 107 40 148 0 l 148 0 b 221 88 148 0 181 40 b 296 179 267 144 294 178 b 308 182 300 181 304 182 b 321 179 313 182 317 181 b 485 18 323 177 409 92 l 503 -1 l 533 36 b 581 81 570 81 570 81 l 582 81 b 604 59 594 81 604 71 b 602 50 604 56 603 53 b 414 -179 599 44 418 -176 b 401 -182 410 -181 406 -182 b 388 -178 397 -182 392 -181 b 297 -89 387 -178 346 -137 b 207 0 248 -40 207 0 l 207 0 b 134 -88 206 0 174 -40 b 59 -179 88 -144 61 -178 b 46 -182 55 -181 51 -182 b 34 -178 42 -182 37 -181 b -58 -89 33 -178 -9 -137 b -148 0 -107 -40 -148 0 l -148 0 b -221 -88 -148 0 -181 -40 b -296 -179 -267 -144 -294 -178 b -308 -182 -300 -181 -304 -182 b -321 -178 -313 -182 -317 -181 b -485 -18 -323 -177 -411 -91 l -503 1 l -533 -36 b -581 -81 -570 -81 -570 -81 l -582 -81 b -604 -59 -594 -81 -604 -71 b -602 -50 -604 -56 -603 -53 b -414 179 -599 -44 -418 176 b -409 181 -412 179 -410 181 z"
                },
                ornamentPrecompAppoggTrill: {
                    x_min: -419,
                    x_max: 419,
                    y_min: -127,
                    y_max: 255,
                    ha: 381,
                    o: "m -591 365 b -582 367 -588 366 -585 367 b -561 352 -573 367 -564 361 b -560 176 -560 351 -560 303 l -559 2 l -527 41 b -456 128 -509 63 -477 102 b -414 177 -435 154 -416 176 b -400 182 -411 181 -405 182 b -388 179 -396 182 -392 181 b -296 89 -387 178 -346 137 b -206 0 -247 40 -207 0 b -133 88 -206 0 -173 40 b -59 179 -88 144 -60 178 b -46 182 -55 181 -50 182 b -33 179 -41 182 -37 181 b 58 89 -32 178 9 137 b 148 0 108 40 148 0 l 148 0 b 221 88 149 0 182 40 b 296 179 267 144 295 178 b 309 182 300 181 304 182 b 321 179 313 182 318 181 b 485 18 323 177 410 92 l 503 -1 l 533 36 b 581 81 570 81 571 81 l 582 81 b 604 59 595 81 604 71 b 602 50 604 56 603 53 b 414 -179 599 44 419 -176 b 402 -182 410 -181 406 -182 b 389 -178 397 -182 393 -181 b 297 -89 388 -178 346 -137 b 207 0 248 -40 207 0 l 207 0 b 134 -88 207 0 174 -40 b 59 -179 89 -144 61 -178 b 47 -182 56 -181 51 -182 b 34 -178 42 -182 38 -181 b -58 -89 33 -178 -8 -137 b -148 0 -107 -40 -147 0 b -220 -88 -148 0 -181 -40 b -295 -179 -266 -144 -294 -178 b -308 -182 -299 -181 -303 -182 b -321 -178 -312 -182 -317 -181 b -484 -18 -322 -177 -426 -76 l -503 1 l -535 -38 b -570 -79 -558 -67 -567 -77 b -582 -83 -573 -81 -578 -83 b -602 -70 -590 -83 -598 -78 l -604 -67 l -604 141 l -604 349 l -603 353 b -591 365 -601 358 -596 363 z"
                },
                ornamentPrecompSlideTrillDAnglebert: {
                    x_min: -433,
                    x_max: 433,
                    y_min: -243,
                    y_max: 127,
                    ha: 370,
                    o: "m -388 181 b -382 182 -386 182 -384 182 b -368 179 -377 182 -372 181 b -277 89 -367 178 -326 137 b -187 0 -227 40 -187 0 l -187 0 b -114 88 -186 0 -153 40 b -39 179 -68 144 -40 178 b -26 182 -35 181 -30 182 b -14 179 -22 182 -17 181 b 78 89 -12 178 29 137 b 168 0 127 40 168 0 b 241 88 169 0 201 40 b 316 179 287 144 314 178 b 329 182 320 181 324 182 b 341 179 333 182 337 181 b 505 18 343 177 430 92 l 523 -1 l 553 36 b 601 81 590 81 590 81 l 602 81 b 624 59 614 81 624 71 b 622 50 624 56 623 53 b 434 -179 619 44 439 -176 b 421 -182 430 -181 426 -182 b 409 -178 417 -182 412 -181 b 317 -89 407 -178 366 -137 b 227 0 268 -40 227 0 b 154 -88 227 0 194 -40 b 79 -179 108 -144 81 -178 b 67 -182 75 -181 71 -182 b 54 -178 62 -182 58 -181 b -38 -89 53 -178 12 -137 b -128 0 -87 -40 -127 0 b -201 -88 -128 0 -161 -40 b -276 -179 -246 -144 -274 -178 b -288 -182 -279 -181 -284 -182 b -301 -178 -293 -182 -297 -181 b -393 -88 -302 -178 -343 -137 b -483 0 -442 -40 -483 0 b -483 0 -483 0 -483 0 b -505 -27 -484 0 -497 -15 b -579 -235 -554 -92 -579 -166 b -567 -315 -579 -263 -575 -290 b -564 -330 -565 -320 -564 -325 b -585 -351 -564 -342 -572 -351 b -610 -326 -598 -351 -604 -345 b -624 -235 -619 -297 -624 -267 b -547 -8 -624 -159 -597 -79 b -492 60 -538 4 -533 10 b -426 140 -472 84 -443 120 b -388 181 -396 176 -394 179 z"
                },
                ornamentPrecompSlideTrillBach: {
                    x_min: -433,
                    x_max: 433,
                    y_min: -243,
                    y_max: 198,
                    ha: 442,
                    o: "m 186 284 b 194 285 189 285 192 285 b 215 273 203 285 211 280 b 217 164 216 270 216 269 l 217 59 l 265 118 b 316 179 295 155 314 178 b 329 182 320 181 324 182 b 341 179 333 182 337 181 b 505 18 343 177 430 92 l 523 -1 l 553 36 b 601 81 590 81 590 81 l 602 81 b 624 59 614 81 624 71 b 622 50 624 56 623 53 b 434 -179 619 44 439 -176 b 421 -182 430 -181 426 -182 b 409 -178 417 -182 412 -181 b 317 -89 407 -178 366 -137 b 227 0 268 -40 227 0 b 227 0 227 0 227 0 b 222 -6 227 0 224 -3 l 217 -12 l 217 -152 b 217 -218 217 -179 217 -200 b 210 -303 217 -308 216 -298 b 195 -310 206 -308 201 -310 b 175 -297 187 -310 178 -305 b 173 -180 173 -294 173 -294 l 173 -66 l 127 -121 b 79 -178 99 -156 81 -177 b 67 -182 76 -181 71 -182 b 54 -178 62 -182 58 -181 b -38 -89 53 -178 12 -137 b -128 0 -87 -40 -127 0 b -201 -88 -128 0 -161 -40 b -276 -179 -246 -144 -274 -178 b -288 -182 -279 -181 -284 -182 b -301 -178 -293 -182 -297 -181 b -393 -88 -302 -178 -343 -137 b -483 0 -442 -40 -483 0 b -483 0 -483 0 -483 0 b -505 -27 -484 0 -497 -15 b -579 -235 -554 -92 -579 -166 b -567 -315 -579 -263 -575 -290 b -564 -330 -565 -320 -564 -325 b -586 -351 -564 -342 -572 -351 b -610 -326 -598 -351 -604 -345 b -624 -235 -619 -297 -624 -267 b -547 -8 -624 -159 -597 -79 b -492 60 -538 4 -533 10 b -426 140 -472 84 -443 120 b -393 179 -408 162 -395 178 b -381 182 -390 181 -385 182 b -368 179 -376 182 -372 181 b -277 89 -367 178 -326 137 b -187 0 -227 40 -187 0 l -187 0 b -114 88 -186 0 -153 40 b -39 179 -68 144 -40 178 b -26 182 -35 181 -30 182 b -14 179 -22 182 -17 181 b 150 18 -12 177 81 86 l 168 0 l 171 2 l 173 5 l 173 137 b 174 272 173 267 173 268 b 186 284 176 277 181 282 z"
                },
                ornamentPrecompTrillSuffixDandrieu: {
                    x_min: -433,
                    x_max: 433,
                    y_min: -127,
                    y_max: 244,
                    ha: 370,
                    o: "m 577 349 b 585 351 580 350 582 351 b 601 345 591 351 597 349 b 624 229 613 332 624 275 b 622 204 624 220 623 211 b 559 27 615 139 595 83 b 492 -60 546 6 541 0 b 426 -140 472 -84 443 -120 b 393 -179 408 -162 395 -178 b 381 -182 390 -181 385 -182 b 368 -178 376 -182 372 -181 b 277 -89 367 -178 326 -137 b 187 0 227 -40 187 0 l 187 0 b 114 -88 186 0 153 -40 b 39 -179 68 -144 40 -178 b 26 -182 35 -181 31 -182 b 13 -178 22 -182 17 -181 b -78 -89 12 -178 -29 -137 b -168 0 -127 -40 -168 0 b -241 -88 -169 0 -201 -40 b -316 -179 -287 -144 -314 -178 b -329 -182 -320 -181 -324 -182 b -341 -178 -333 -182 -337 -181 b -505 -18 -343 -177 -431 -91 l -523 1 l -553 -36 b -601 -81 -590 -81 -590 -81 l -602 -81 b -624 -59 -614 -81 -624 -71 b -622 -50 -624 -56 -623 -53 b -434 179 -619 -44 -439 176 b -421 182 -430 181 -426 182 b -409 179 -417 182 -412 181 b -317 89 -408 178 -366 137 b -227 0 -268 40 -227 0 b -154 88 -227 0 -194 40 b -79 179 -108 144 -81 178 b -66 182 -75 181 -71 182 b -54 179 -62 182 -58 181 b 38 89 -53 178 -12 137 b 128 0 87 40 127 0 b 201 88 128 0 161 40 b 276 179 246 144 274 178 b 288 182 279 181 284 182 b 301 179 293 182 297 181 b 393 88 302 178 343 137 b 483 0 442 40 483 0 b 483 0 483 0 483 0 b 505 27 484 0 497 15 b 579 235 554 92 579 166 b 567 315 579 263 575 290 b 564 330 565 321 564 326 b 577 349 564 339 568 346 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefix: {
                    x_min: -439,
                    x_max: 439,
                    y_min: -127,
                    y_max: 236,
                    ha: 363,
                    o: "m -564 338 b -555 340 -561 339 -558 340 b -534 318 -544 340 -534 331 b -534 317 -534 318 -534 317 b -541 296 -534 311 -534 311 b -588 116 -572 236 -588 175 b -583 62 -588 98 -586 80 b -554 -21 -578 34 -566 -2 l -552 -24 l -511 26 b -430 126 -488 54 -452 99 b -386 177 -407 153 -388 176 b -372 182 -382 181 -377 182 b -360 179 -368 182 -364 181 b -268 89 -359 178 -318 137 b -178 0 -219 40 -179 0 b -105 88 -178 0 -145 40 b -30 179 -60 144 -32 178 b -18 182 -27 181 -22 182 b -5 179 -13 182 -9 181 b 86 89 -4 178 37 137 b 176 0 136 40 176 0 l 176 0 b 249 88 177 0 210 40 b 324 179 295 144 323 178 b 337 182 328 181 333 182 b 349 179 341 182 346 181 b 513 18 351 177 438 92 l 532 -1 l 562 36 b 610 81 599 81 599 81 l 610 81 b 632 59 623 81 632 71 b 630 50 632 56 631 53 b 442 -179 627 44 447 -176 b 430 -182 438 -181 434 -182 b 417 -178 425 -182 421 -181 b 325 -89 416 -178 375 -137 b 235 0 276 -40 236 0 l 235 0 b 162 -88 235 0 202 -40 b 87 -179 117 -144 89 -178 b 75 -182 84 -181 79 -182 b 62 -178 70 -182 66 -181 b -29 -89 61 -178 20 -137 b -119 0 -79 -40 -119 0 b -192 -88 -120 0 -153 -40 b -267 -179 -238 -144 -266 -178 b -280 -182 -271 -181 -275 -182 b -293 -178 -284 -182 -289 -181 b -456 -18 -294 -177 -398 -76 l -475 1 l -507 -38 b -554 -83 -543 -82 -543 -83 l -554 -83 b -576 -68 -562 -83 -568 -79 b -632 115 -613 -19 -632 46 b -593 292 -632 173 -619 233 b -564 338 -579 323 -571 335 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefixTurn: {
                    x_min: -439,
                    x_max: 439,
                    y_min: -215,
                    y_max: 236,
                    ha: 451,
                    o: "m -564 338 b -555 340 -561 339 -558 340 b -534 318 -544 340 -534 331 b -534 317 -534 318 -534 317 b -541 296 -534 311 -534 311 b -588 116 -572 236 -588 175 b -583 62 -588 98 -586 80 b -554 -21 -578 34 -566 -2 l -552 -24 l -511 26 b -430 126 -488 54 -452 99 b -386 177 -407 153 -388 176 b -372 182 -382 181 -377 182 b -360 179 -368 182 -364 181 b -268 89 -359 178 -318 137 b -178 0 -219 40 -179 0 b -105 88 -178 0 -145 40 b -30 179 -60 144 -32 178 b -18 182 -27 181 -22 182 b -5 179 -13 182 -9 181 b 158 18 -4 177 89 86 l 177 0 l 179 2 l 181 5 l 181 137 b 183 272 181 267 181 268 b 203 285 186 280 195 285 b 218 279 209 285 214 283 b 225 164 225 273 225 284 l 225 59 l 274 118 b 324 179 304 155 323 178 b 337 182 328 181 333 182 b 349 179 341 182 346 181 b 513 18 351 177 438 92 l 532 -1 l 562 36 b 610 81 599 81 599 81 l 610 81 b 632 59 623 81 632 71 b 630 50 632 56 631 53 b 442 -179 627 44 447 -176 b 430 -182 438 -181 434 -182 b 417 -178 425 -182 421 -181 b 325 -89 416 -178 375 -137 b 235 0 276 -40 236 0 b 235 0 235 0 235 0 b 230 -6 235 0 232 -3 l 225 -12 l 225 -152 b 225 -218 225 -179 225 -200 b 219 -303 225 -308 224 -298 b 203 -310 214 -308 209 -310 b 183 -297 195 -310 187 -305 b 181 -180 182 -294 182 -294 l 181 -66 l 136 -121 b 88 -178 107 -156 89 -177 b 75 -182 84 -181 79 -182 b 62 -178 70 -182 66 -181 b -29 -89 61 -178 20 -137 b -119 0 -79 -40 -119 0 b -192 -88 -120 0 -153 -40 b -267 -179 -238 -144 -266 -178 b -280 -182 -271 -181 -275 -182 b -293 -178 -284 -182 -289 -181 b -456 -18 -294 -177 -398 -76 l -475 1 l -507 -38 b -554 -83 -543 -82 -543 -83 l -554 -83 b -576 -68 -562 -83 -568 -79 b -632 115 -613 -19 -632 46 b -593 292 -632 173 -619 233 b -564 338 -579 323 -571 335 z"
                },
                ornamentPrecompTrillLowerSuffix: {
                    x_min: -439,
                    x_max: 439,
                    y_min: -236,
                    y_max: 127,
                    ha: 362,
                    o: "m -437 181 b -430 182 -435 182 -433 182 b -417 179 -426 182 -420 181 b -325 89 -416 178 -375 137 b -235 0 -276 40 -235 0 l -235 0 b -162 88 -235 0 -202 40 b -87 179 -117 144 -89 178 b -75 182 -84 181 -79 182 b -62 179 -70 182 -66 181 b 29 89 -61 178 -20 137 b 119 0 79 40 119 0 b 192 88 120 0 153 40 b 267 179 238 144 266 178 b 280 182 271 181 276 182 b 292 179 284 182 289 181 b 456 18 294 177 396 77 l 475 -1 l 507 38 b 554 83 543 82 543 83 l 554 83 b 576 68 563 83 568 79 b 632 -116 613 19 632 -46 b 607 -257 632 -162 624 -210 b 571 -334 596 -287 578 -327 b 556 -340 567 -338 561 -340 b 535 -326 547 -340 538 -335 b 533 -319 534 -323 533 -321 b 541 -296 533 -314 536 -308 b 588 -117 572 -236 588 -175 b 579 -40 588 -91 585 -65 b 554 21 573 -19 563 7 l 552 24 l 511 -26 b 430 -126 488 -54 452 -99 b 386 -177 407 -153 388 -176 b 373 -182 382 -181 377 -182 b 360 -178 368 -182 364 -181 b 268 -89 359 -178 318 -137 b 178 0 219 -40 179 0 l 178 0 b 105 -88 178 0 145 -40 b 30 -179 60 -144 32 -178 b 18 -182 27 -181 22 -182 b 5 -178 13 -182 9 -181 b -86 -89 4 -178 -37 -137 b -176 0 -136 -40 -176 0 l -176 0 b -249 -88 -177 0 -210 -40 b -324 -179 -295 -144 -323 -178 b -337 -182 -328 -181 -332 -182 b -349 -178 -341 -182 -346 -181 b -513 -18 -351 -177 -439 -91 l -532 1 l -562 -36 b -610 -81 -599 -81 -599 -81 l -610 -81 b -632 -59 -623 -81 -632 -71 b -630 -50 -632 -56 -631 -53 b -442 179 -627 -44 -447 176 b -437 181 -441 179 -438 181 z"
                },
                stringsDownBow: {
                    x_min: -168,
                    x_max: 168,
                    y_min: 0,
                    y_max: 353,
                    ha: 353,
                    o: "m -228 506 b 3 508 -225 507 -111 508 b 228 506 114 508 225 507 b 240 494 233 504 238 499 b 242 254 241 491 242 373 b 240 14 242 135 241 16 b 220 0 237 5 228 0 b 204 6 214 0 208 2 b 198 89 198 12 198 3 b 198 145 198 104 198 123 l 198 273 l 0 273 l -198 273 l -198 145 b -198 89 -198 123 -198 104 b -204 6 -198 3 -198 12 b -220 0 -208 2 -214 0 b -240 14 -228 0 -237 5 b -242 254 -241 16 -242 135 b -240 494 -242 373 -241 491 b -228 506 -238 499 -233 504 z"
                },
                stringsUpBow: {
                    x_min: -110,
                    x_max: 110,
                    y_min: 0,
                    y_max: 277,
                    ha: 277,
                    o: "m -144 397 b -137 398 -142 398 -140 398 b -117 387 -129 398 -120 394 b -58 234 -116 385 -90 317 b 0 84 -26 152 0 84 b 58 234 0 84 26 152 b 117 387 90 317 116 385 b 136 398 121 395 128 398 b 158 376 147 398 158 390 l 158 370 l 89 191 b 20 11 51 93 20 12 b 0 0 16 4 8 0 b -19 11 -8 0 -16 4 b -158 375 -25 21 -158 370 b -158 376 -158 375 -158 376 b -144 397 -158 386 -153 394 z"
                },
                stringsHarmonic: {
                    x_min: -82,
                    x_max: 82,
                    y_min: -82,
                    y_max: 82,
                    ha: 163,
                    o: "m -19 116 b 1 118 -12 117 -6 118 b 118 0 65 118 118 63 b 114 -30 118 -10 116 -20 b -1 -118 100 -85 50 -118 b -83 -83 -30 -118 -60 -107 b -118 -1 -107 -60 -118 -30 b -19 116 -118 53 -81 105 z m 14 99 b 0 100 9 100 4 100 b -101 0 -57 100 -101 53 b -90 -45 -101 -15 -97 -30 b 0 -100 -71 -82 -36 -100 b 90 -45 36 -100 71 -82 b 101 -1 97 -30 101 -15 b 14 99 101 47 65 92 z"
                },
                pluckedSnapPizzicatoAbove: {
                    x_min: -110,
                    x_max: 110,
                    y_min: -110,
                    y_max: 205,
                    ha: 315,
                    o: "m -9 293 b 0 295 -6 294 -3 295 b 20 281 9 295 17 290 b 22 217 22 278 22 276 l 22 157 l 25 157 b 153 40 85 148 138 100 b 158 0 157 26 158 13 b 40 -153 158 -71 111 -135 b 0 -158 26 -157 13 -158 b -154 -40 -71 -158 -136 -111 b -158 -1 -157 -27 -158 -14 b -25 157 -158 76 -102 146 l -22 157 l -22 217 b -21 281 -22 276 -22 278 b -9 293 -19 286 -13 291 z m -22 54 b -23 112 -22 108 -22 112 b -23 112 -23 112 -23 112 b -81 80 -37 111 -65 96 b -114 1 -104 57 -114 29 b 0 -114 -114 -58 -69 -114 b 114 1 68 -114 114 -58 b 80 80 114 29 104 57 b 22 112 65 96 35 112 b 22 54 22 112 22 92 b 20 -8 22 -3 22 -5 b 0 -22 17 -17 9 -22 b -16 -16 -6 -22 -11 -20 b -22 34 -22 -10 -22 -12 b -22 54 -22 40 -22 46 z"
                },
                pluckedSnapPizzicatoBelow: {
                    x_min: -110,
                    x_max: 110,
                    y_min: -205,
                    y_max: 110,
                    ha: 315,
                    o: "m 9 -293 b 0 -295 6 -294 3 -295 b -20 -281 -9 -295 -17 -290 b -22 -217 -22 -278 -22 -276 l -22 -157 l -25 -157 b -153 -40 -85 -148 -138 -100 b -158 0 -157 -26 -158 -13 b -40 153 -158 71 -111 135 b 0 158 -26 157 -13 158 b 154 40 71 158 136 111 b 158 1 157 27 158 14 b 25 -157 158 -76 102 -146 l 22 -157 l 22 -217 b 21 -281 22 -276 22 -278 b 9 -293 19 -286 13 -291 z m 22 -54 b 23 -112 22 -108 22 -112 b 23 -112 23 -112 23 -112 b 81 -80 37 -111 65 -96 b 114 -1 104 -57 114 -29 b 0 114 114 58 69 114 b -114 -1 -68 114 -114 58 b -80 -80 -114 -29 -104 -57 b -22 -112 -65 -96 -35 -112 b -22 -54 -22 -112 -22 -92 b -20 8 -22 3 -22 5 b 0 22 -17 17 -9 22 b 16 16 6 22 11 20 b 22 -34 22 10 22 12 b 22 -54 22 -40 22 -46 z"
                },
                pluckedLeftHandPizzicato: {
                    x_min: -155,
                    x_max: 155,
                    y_min: -157,
                    y_max: 157,
                    ha: 315,
                    o: "m -9 225 b 0 227 -6 226 -3 227 b 20 213 9 227 17 221 b 22 116 22 209 22 208 l 22 22 l 114 22 b 152 22 129 22 141 22 b 218 16 218 22 212 21 b 224 0 222 11 224 6 b 210 -20 224 -9 219 -17 b 114 -22 207 -22 205 -22 l 22 -22 l 22 -116 b 22 -154 22 -131 22 -143 b 16 -220 22 -221 21 -214 b 0 -227 11 -225 6 -227 b -20 -213 -9 -227 -17 -222 b -22 -116 -22 -209 -22 -208 l -22 -22 l -114 -22 b -210 -20 -205 -22 -207 -22 b -224 0 -219 -17 -224 -9 b -218 16 -224 6 -222 11 b -152 22 -212 21 -218 22 b -114 22 -141 22 -129 22 l -22 22 l -22 116 b -20 213 -22 208 -22 209 b -9 225 -19 218 -13 223 z"
                },
                keyboardPedalPed: {
                    x_min: 0,
                    x_max: 782,
                    y_min: -1,
                    y_max: 500,
                    ha: 501,
                    o: "m 309 719 b 335 720 318 720 327 720 b 521 650 409 720 473 696 b 582 517 561 610 582 560 b 528 423 582 476 564 441 b 483 411 513 415 498 411 b 392 480 443 411 406 437 b 384 516 386 496 384 508 b 400 535 384 529 389 535 b 417 520 409 535 414 530 b 458 494 421 503 438 494 b 498 507 472 494 486 498 b 520 552 513 517 520 533 b 469 645 520 582 502 619 b 349 687 437 670 389 687 l 344 687 l 335 671 b 286 544 299 609 286 577 b 286 543 286 544 286 543 b 341 449 286 511 298 491 b 371 411 359 430 364 424 b 385 358 380 394 385 377 b 378 317 385 345 383 331 b 302 165 365 271 336 212 b 298 159 300 162 298 159 b 298 159 298 159 298 159 b 305 160 299 159 302 159 b 336 162 315 161 326 162 b 486 106 392 162 445 143 l 492 101 l 512 117 b 533 134 523 126 532 133 b 534 136 534 135 534 135 b 533 144 534 138 534 140 b 530 188 531 159 530 174 b 571 320 530 238 544 283 b 657 390 587 342 634 380 b 686 397 666 395 676 397 b 763 335 721 397 755 372 b 766 315 765 328 766 321 b 740 251 766 291 756 267 b 699 219 736 247 702 221 b 636 172 697 218 662 192 b 614 153 618 158 614 154 b 614 153 614 153 614 153 b 645 91 621 129 636 100 b 694 73 657 78 675 73 b 797 123 728 73 769 91 l 800 127 l 799 134 b 795 176 796 148 795 162 b 947 403 795 266 851 351 b 950 405 949 404 950 405 b 944 414 950 407 948 409 b 659 583 875 496 774 556 b 636 603 641 587 636 591 b 654 620 636 614 642 620 b 666 619 658 620 662 620 b 1113 282 884 577 1062 442 b 1126 198 1122 253 1126 225 b 954 -1 1126 87 1054 -1 b 930 1 946 -1 938 0 b 817 83 883 7 841 37 b 815 87 816 85 815 87 b 808 79 814 87 812 84 b 664 0 772 29 717 0 b 620 7 649 0 634 2 b 546 92 584 19 565 40 l 544 99 l 540 97 b 480 49 539 95 512 74 b 414 1 419 0 420 1 l 414 1 b 396 17 404 1 399 5 b 284 110 381 72 333 110 b 266 108 278 110 272 110 l 258 107 l 247 94 b 164 2 213 53 169 4 b 156 0 161 0 159 0 b 139 17 147 0 139 8 b 140 23 139 19 140 21 b 144 34 141 24 142 29 b 234 137 158 79 189 114 b 260 164 244 143 244 142 b 319 290 300 217 319 259 b 281 349 319 312 313 322 b 223 453 250 376 229 414 b 222 472 223 459 222 466 b 296 673 222 522 246 587 l 303 685 l 300 685 b 290 684 299 685 294 684 b 60 496 171 668 77 591 b 59 477 59 490 59 483 b 76 426 59 453 66 431 b 100 420 84 422 92 420 b 162 487 131 420 160 448 b 179 507 163 502 168 507 b 196 479 192 507 196 501 b 196 478 196 478 196 478 b 88 335 195 397 151 338 b 83 335 86 335 84 335 b 0 443 31 335 0 375 l 0 443 b 309 719 0 583 138 706 z m 981 361 b 976 368 978 366 977 368 b 968 362 974 368 972 366 b 872 175 908 318 872 247 b 877 131 872 160 874 145 b 943 34 887 82 914 43 b 949 34 945 34 947 34 b 1018 127 973 34 1004 75 b 1027 198 1024 151 1027 174 b 981 361 1027 253 1011 309 z m 665 338 b 657 339 662 339 660 339 b 641 336 652 339 647 338 b 614 293 635 333 622 312 b 602 221 607 274 602 246 b 604 198 602 213 603 205 b 606 191 605 193 605 191 b 608 193 606 191 607 192 b 666 238 613 197 642 219 b 695 264 690 256 691 257 b 702 290 700 272 702 281 b 665 338 702 312 688 334 z"
                },
                keyboardPedalUp: {
                    x_min: 0,
                    x_max: 435,
                    y_min: 65,
                    y_max: 500,
                    ha: 435,
                    o: "m 300 719 b 311 720 303 720 307 720 b 332 718 319 720 327 719 b 379 654 361 709 379 685 b 354 601 379 632 374 620 b 331 558 338 585 331 572 b 336 536 331 551 333 544 b 374 512 344 521 358 512 b 389 514 379 512 384 513 b 422 575 414 523 422 538 b 474 646 422 614 441 639 b 489 648 479 647 484 648 b 555 581 527 648 555 615 b 535 535 555 565 549 549 b 479 515 520 520 508 516 b 450 512 462 515 458 514 b 418 468 429 505 418 487 b 438 433 418 455 425 441 b 464 424 447 427 455 424 b 509 449 477 424 491 432 b 557 473 526 466 538 472 b 561 473 558 473 560 473 b 627 407 599 473 627 442 b 620 378 627 397 625 387 b 561 341 609 354 588 341 l 560 341 b 508 365 538 341 527 346 b 465 390 491 383 478 390 b 457 389 462 390 460 390 b 418 347 433 384 418 367 b 424 325 418 340 420 332 b 479 299 433 306 446 300 b 535 279 509 298 520 294 b 555 233 549 266 555 249 b 489 166 555 199 527 166 b 474 167 484 166 480 166 b 422 239 441 175 422 200 b 393 298 422 273 414 289 b 374 302 386 301 380 302 b 332 266 354 302 337 288 b 331 255 331 262 331 258 b 355 213 331 242 338 230 b 379 160 374 193 379 182 l 379 160 b 313 93 379 120 348 93 b 272 108 299 93 285 98 b 247 160 256 121 247 140 b 259 198 247 173 251 187 b 272 213 260 200 266 206 b 296 255 289 230 296 242 b 295 266 296 258 296 262 b 253 302 290 288 273 302 b 234 298 247 302 241 301 b 205 239 213 289 205 273 b 153 167 205 200 186 175 b 138 166 148 166 143 166 b 73 232 101 166 73 197 b 82 267 73 244 76 256 b 148 299 95 289 113 298 b 182 304 168 299 171 300 b 197 315 189 307 192 309 b 209 346 205 325 209 336 b 179 386 209 364 198 379 b 162 390 173 389 167 390 b 119 365 148 390 136 382 b 104 352 113 360 107 354 b 67 341 92 344 79 341 b 2 390 38 341 10 359 b 0 407 1 396 0 401 b 66 473 0 443 30 473 b 83 471 72 473 77 473 b 118 449 96 468 104 463 b 161 424 136 432 149 424 b 163 424 161 424 162 424 b 209 467 191 427 209 445 b 203 489 209 474 207 482 b 148 515 193 509 180 515 b 92 535 119 516 107 520 b 72 581 78 549 72 565 b 138 648 72 615 100 648 b 153 646 143 648 148 647 b 205 575 186 639 205 614 b 238 514 205 538 213 523 b 253 512 243 513 248 512 b 291 536 269 512 283 521 b 296 558 294 544 296 551 b 273 601 296 572 289 584 b 254 624 261 612 258 616 b 247 654 249 634 247 644 b 300 719 247 684 268 712 z m 327 475 b 313 476 322 476 318 476 b 244 407 274 476 244 443 b 252 376 244 396 247 386 b 313 338 265 350 289 338 b 375 376 338 338 362 350 b 383 407 380 386 383 396 b 327 475 383 438 361 468 z"
                },
                pictChokeCymbal: {
                    x_min: 0,
                    x_max: 168,
                    y_min: -155,
                    y_max: 155,
                    ha: 311,
                    o: "m 96 223 b 107 224 100 224 103 224 b 236 104 164 224 218 174 b 242 55 240 88 242 71 b 66 -209 242 -42 175 -144 b 33 -224 48 -219 39 -224 b 25 -219 30 -224 28 -222 b 23 -213 24 -216 23 -215 b 36 -199 23 -208 28 -204 b 130 -56 96 -166 130 -110 b 111 8 130 -34 124 -12 l 110 10 l 100 11 b 6 82 58 12 19 42 b 0 117 2 94 0 105 b 96 223 0 170 40 217 z"
                },
                wiggleArpeggiatoUp: {
                    x_min: -8,
                    x_max: 269,
                    y_min: 0,
                    y_max: 126,
                    ha: 126,
                    o: "m 103 180 b 118 181 108 181 113 181 b 223 126 151 181 184 164 b 299 69 250 100 280 78 b 311 67 303 68 307 67 b 359 90 325 67 342 75 b 376 102 372 101 372 102 l 376 102 b 388 91 383 102 388 96 b 385 84 388 88 387 86 b 322 25 379 76 342 42 b 258 0 301 8 280 0 b 153 56 226 0 192 18 b 78 112 127 81 97 103 b 65 114 74 114 70 114 b 17 91 51 114 35 106 b 1 80 5 80 5 80 l 0 80 b -11 91 -7 80 -11 85 b -9 97 -11 93 -10 95 b 55 156 -3 105 34 140 b 103 180 71 170 88 178 z"
                },
                arrowheadBlackUp: {
                    x_min: 11,
                    x_max: 239,
                    y_min: -6,
                    y_max: 269,
                    ha: 275,
                    o: "m 171 386 b 179 387 174 387 176 387 b 201 378 187 387 196 384 b 212 345 206 372 206 372 b 333 45 237 235 282 123 b 344 19 343 29 344 27 b 317 -8 344 2 332 -8 b 299 -3 312 -8 305 -7 b 180 30 262 19 221 30 b 74 4 144 30 108 21 b 61 -3 70 2 64 -1 b 43 -8 55 -7 48 -8 b 16 19 28 -8 16 2 b 27 45 16 27 17 29 b 148 344 78 123 122 233 b 159 378 155 373 154 372 b 171 386 161 381 167 385 z"
                },
                arrowheadBlackDown: {
                    x_min: 11,
                    x_max: 239,
                    y_min: 6,
                    y_max: 281,
                    ha: 275,
                    o: "m 35 403 b 43 405 37 404 40 405 b 62 398 49 405 55 403 b 79 390 65 396 73 392 b 180 367 111 374 145 367 b 298 398 221 367 262 377 b 318 404 305 402 312 404 b 344 377 332 404 344 394 b 333 351 344 369 343 367 b 212 51 282 273 237 161 b 204 23 207 28 206 26 b 180 8 199 13 189 8 b 156 23 171 8 162 13 b 150 44 154 25 153 28 b 27 351 125 158 80 271 b 16 377 17 367 16 369 b 35 403 16 389 24 400 z"
                }
            },
            fontFamily: "GonvilleSmufl",
            resolution: 1e3,
            generatedOn: "2023-04-20T22:11:26.009Z"
        };
        const Oi = {
            glyphs: {
                bracketTop: {
                    x_min: 0,
                    x_max: 491,
                    y_min: 0,
                    y_max: 279,
                    ha: 279,
                    o: "m 697 399 b 687 402 694 400 690 402 b 671 395 681 402 674 400 b 249 168 668 390 524 168 l 20 168 b 0 150 9 168 0 161 l 0 20 l 0 0 l 176 0 b 706 374 619 0 704 370 b 707 382 706 376 707 379 b 697 399 707 389 703 395 z"
                },
                bracketBottom: {
                    x_min: 0,
                    x_max: 491,
                    y_min: -279,
                    y_max: 0,
                    ha: 279,
                    o: "m 697 -399 b 707 -382 703 -395 707 -389 b 706 -374 707 -379 706 -376 b 176 0 704 -370 619 0 l 0 0 l 0 -20 l 0 -150 b 20 -168 0 -161 9 -168 l 249 -168 b 671 -395 524 -168 668 -390 b 687 -402 674 -400 681 -402 b 697 -399 690 -402 694 -400 z"
                },
                segno: {
                    x_min: 0,
                    x_max: 654,
                    y_min: 0,
                    y_max: 869,
                    ha: 869,
                    o: "m 546 690 l 838 1207 b 841 1215 840 1210 841 1212 b 832 1233 841 1221 837 1230 l 809 1248 b 798 1251 806 1250 801 1251 b 780 1241 792 1251 783 1247 l 487 721 l 217 860 b 99 995 147 897 99 924 b 236 1165 99 1120 179 1165 b 343 1073 288 1165 325 1130 b 454 988 357 1022 405 988 b 477 991 461 988 469 989 b 541 1076 526 1002 541 1045 b 540 1089 541 1080 541 1084 b 294 1225 534 1116 514 1225 b 0 939 72 1225 0 1053 b 125 706 0 825 42 753 l 397 563 l 104 45 b 102 35 102 42 102 37 b 111 19 102 29 107 22 l 132 3 b 144 0 135 1 141 0 b 148 0 145 0 147 0 b 161 10 153 1 158 6 l 456 531 l 704 403 b 842 256 780 361 842 318 b 706 86 842 131 763 86 b 599 177 654 86 616 120 b 488 262 585 228 537 262 b 465 259 481 262 472 261 b 402 177 418 248 402 206 b 403 163 402 171 402 167 b 649 26 409 135 429 26 b 942 312 871 26 942 199 b 821 549 942 426 901 507 z m 52 444 b 118 416 69 426 95 416 b 183 444 141 416 166 426 b 210 508 200 461 210 485 b 183 573 210 531 200 556 b 118 600 166 590 141 600 b 52 573 95 600 69 590 b 24 508 35 556 24 531 b 52 444 24 485 35 461 z m 760 730 b 825 703 778 713 802 703 b 890 730 848 703 873 713 b 917 795 907 747 917 772 b 890 861 917 818 907 844 b 825 888 873 878 848 888 b 760 861 802 888 778 878 b 733 795 743 844 733 818 b 760 730 733 772 743 747 z"
                },
                coda: {
                    x_min: 0,
                    x_max: 745,
                    y_min: -113,
                    y_max: 735,
                    ha: 848,
                    o: "m 924 467 b 560 896 916 697 757 881 l 560 1038 b 540 1058 560 1050 552 1058 l 524 1058 b 505 1038 513 1058 505 1050 l 505 896 b 150 467 311 877 158 693 l 20 467 b 0 446 9 467 0 458 l 0 432 b 20 412 0 420 9 412 l 150 412 b 505 0 166 193 317 17 l 505 -143 b 524 -163 505 -154 513 -163 l 540 -163 b 560 -143 552 -163 560 -154 l 560 0 b 923 412 753 13 907 190 l 1054 412 b 1073 432 1066 412 1073 420 l 1073 446 b 1054 467 1073 458 1066 467 z m 560 467 l 560 852 b 773 467 716 837 773 671 z m 505 467 l 301 467 b 505 851 301 668 357 831 z m 505 412 l 505 45 b 301 412 366 65 301 219 z m 560 412 l 772 412 b 560 45 772 215 706 60 z"
                },
                gClef: {
                    x_min: 0,
                    x_max: 640,
                    y_min: -666,
                    y_max: 1112,
                    ha: 1778,
                    o: "m 809 -30 b 665 -279 809 -132 768 -238 b 586 186 635 -107 596 122 b 809 -30 716 186 809 98 z m 605 -297 b 521 -305 576 -302 549 -305 b 140 56 315 -305 140 -161 b 390 498 140 232 264 389 b 459 562 415 520 438 540 b 492 357 472 484 482 416 b 272 45 361 318 272 180 b 467 -194 272 -56 351 -194 b 491 -176 478 -194 491 -189 b 459 -144 491 -163 477 -156 b 372 -1 403 -109 372 -72 b 521 177 372 86 436 157 z m 478 1184 b 632 1392 491 1241 557 1392 b 688 1223 654 1392 688 1322 b 478 863 688 1073 577 960 b 462 1037 469 920 462 976 b 478 1184 462 1090 467 1139 z m 176 -739 b 444 -959 176 -834 249 -959 b 622 -910 511 -959 570 -942 b 720 -670 700 -855 720 -760 b 697 -467 720 -613 711 -549 b 675 -338 693 -438 684 -395 b 922 3 816 -292 922 -145 b 557 367 922 220 768 367 b 516 619 543 454 528 539 b 773 1188 668 779 773 959 b 710 1477 773 1319 733 1426 b 608 1601 675 1551 634 1601 b 505 1528 598 1601 553 1584 b 387 1113 413 1418 387 1234 b 419 804 387 1035 395 965 b 312 701 418 802 343 726 b 0 117 181 579 0 405 b 503 -364 0 -153 235 -364 b 616 -354 544 -364 583 -360 b 660 -670 644 -492 660 -593 b 438 -899 660 -819 583 -899 b 370 -891 403 -899 373 -891 b 366 -887 369 -890 366 -888 b 373 -881 366 -884 369 -883 b 508 -721 441 -871 508 -814 b 341 -562 508 -644 449 -562 b 176 -739 240 -562 176 -644 z"
                },
                cClef: {
                    x_min: 0,
                    x_max: 627,
                    y_min: -480,
                    y_max: 482,
                    ha: 962,
                    o: "m 19 675 b 0 657 9 675 0 667 l 0 -654 b 19 -672 0 -664 9 -672 l 122 -672 b 141 -654 132 -672 141 -664 l 141 657 b 122 675 141 667 132 675 z m 903 -376 b 619 -58 903 -197 808 -58 b 505 -95 586 -58 562 -60 b 426 1 503 -89 474 -32 b 505 98 474 35 503 92 b 641 60 560 65 579 60 b 903 379 816 60 903 223 b 580 694 903 580 755 694 b 318 517 472 694 318 649 b 438 400 318 446 367 400 b 546 510 501 400 546 446 b 425 615 546 589 494 615 b 547 651 458 638 503 651 b 723 400 698 651 723 530 b 593 128 723 289 720 128 b 438 279 467 128 441 265 b 418 300 438 281 438 300 b 396 279 397 300 396 281 b 264 29 383 200 344 62 l 264 657 b 246 675 264 667 256 675 b 228 657 236 675 228 667 l 228 -654 b 246 -672 228 -664 236 -672 b 264 -654 256 -672 264 -664 l 264 -26 b 396 -278 348 -60 380 -197 b 418 -297 396 -279 397 -297 b 438 -278 438 -297 438 -279 b 593 -125 441 -262 467 -125 b 723 -397 720 -125 723 -287 b 547 -648 723 -527 698 -648 b 425 -612 503 -648 458 -635 b 441 -613 426 -612 432 -613 b 546 -507 504 -613 546 -569 b 438 -397 546 -444 501 -397 b 318 -514 367 -397 318 -444 b 580 -691 318 -647 472 -691 b 903 -376 755 -691 903 -577 z"
                },
                fClef: {
                    x_min: 0,
                    x_max: 664,
                    y_min: -617,
                    y_max: 251,
                    ha: 868,
                    o: "m 366 361 b 167 298 256 361 168 298 b 37 112 84 236 50 163 b 27 36 30 86 27 60 b 46 -58 27 1 33 -30 b 140 -138 63 -96 96 -124 b 194 -147 157 -144 176 -147 b 287 -122 226 -147 259 -138 b 359 10 331 -98 359 -46 b 289 134 359 60 333 107 b 206 160 259 154 230 160 b 160 153 189 160 173 157 b 109 122 145 147 121 132 b 147 215 114 150 131 192 b 219 279 163 238 194 266 b 351 308 255 300 301 308 b 570 -52 498 308 570 190 b 477 -399 570 -186 520 -314 b 310 -635 429 -494 366 -585 b 17 -837 160 -772 19 -837 b 0 -864 17 -837 0 -847 b 1 -871 0 -867 1 -868 b 27 -888 6 -886 19 -888 b 35 -887 29 -888 33 -887 b 331 -717 36 -887 200 -819 b 528 -544 405 -664 471 -606 b 661 -367 580 -488 625 -428 b 760 -50 724 -259 760 -147 b 670 239 760 69 729 168 b 366 361 602 320 500 361 z m 818 179 b 887 107 818 138 850 107 b 956 179 924 107 956 138 b 887 252 956 219 924 252 b 818 179 850 252 818 219 z m 818 -177 b 887 -251 818 -217 850 -251 b 956 -177 924 -251 956 -217 b 887 -104 956 -137 924 -104 b 818 -177 850 -104 818 -137 z"
                },
                unpitchedPercussionClef1: {
                    x_min: 0,
                    x_max: 352,
                    y_min: -252,
                    y_max: 252,
                    ha: 504,
                    o: "m 19 363 b 0 344 9 363 0 354 l 0 -344 b 19 -363 0 -354 9 -363 l 177 -363 b 196 -344 187 -363 196 -354 l 196 344 b 177 363 196 354 187 363 z m 330 363 b 311 344 320 363 311 354 l 311 -344 b 330 -363 311 -354 320 -363 l 488 -363 b 507 -344 498 -363 507 -354 l 507 344 b 488 363 507 354 498 363 z"
                },
                "6stringTabClef": {
                    x_min: 0,
                    x_max: 439,
                    y_min: -743,
                    y_max: 746,
                    ha: 1489,
                    o: "m 52 1074 l 52 958 l 249 958 l 249 419 l 387 419 l 387 958 l 583 958 l 583 1074 z m 0 -333 l 145 -333 l 192 -196 l 436 -196 l 481 -333 l 632 -333 l 396 334 l 238 334 z m 315 181 l 400 -81 l 229 -81 z m 566 -474 b 393 -402 531 -428 475 -403 l 71 -402 l 71 -1070 l 372 -1070 b 374 -1070 373 -1070 373 -1070 b 465 -1061 405 -1070 435 -1067 b 541 -1027 494 -1056 520 -1043 b 588 -975 560 -1012 575 -995 b 618 -868 608 -943 618 -907 b 592 -770 618 -829 609 -798 b 514 -711 575 -743 549 -724 b 566 -674 537 -700 554 -688 b 596 -576 586 -649 596 -616 b 566 -474 596 -536 586 -503 z m 348 -518 b 428 -528 380 -518 408 -521 b 464 -590 452 -539 464 -559 b 436 -649 464 -619 455 -638 b 366 -665 418 -661 395 -665 l 203 -665 l 203 -518 z m 367 -776 b 435 -788 396 -776 419 -780 b 477 -858 464 -801 477 -824 b 433 -942 477 -900 462 -927 b 366 -953 418 -949 395 -953 l 203 -953 l 203 -776 z"
                },
                timeSig0: {
                    x_min: 15,
                    x_max: 389,
                    y_min: -254,
                    y_max: 255,
                    ha: 509,
                    o: "m 291 367 b 22 0 138 367 22 209 b 291 -366 22 -209 138 -366 b 560 0 444 -366 560 -209 b 291 367 560 209 444 367 z m 376 -200 b 291 -308 376 -252 353 -308 b 206 -200 229 -308 206 -252 l 206 200 b 291 308 206 252 229 308 b 376 200 353 308 376 252 z"
                },
                timeSig1: {
                    x_min: 15,
                    x_max: 336,
                    y_min: -243,
                    y_max: 245,
                    ha: 488,
                    o: "m 359 -284 l 359 336 b 341 353 359 346 351 353 l 199 353 b 190 350 196 353 193 351 b 184 344 189 348 186 346 l 23 65 b 22 56 22 62 22 59 b 30 42 22 50 26 45 l 58 26 b 66 23 60 24 63 23 b 81 32 72 23 78 27 l 183 207 l 183 -284 l 73 -284 b 56 -301 63 -284 56 -291 l 56 -333 b 73 -350 56 -343 63 -350 l 468 -350 b 484 -333 478 -350 484 -343 l 484 -301 b 468 -284 484 -291 478 -284 z"
                },
                timeSig2: {
                    x_min: 15,
                    x_max: 377,
                    y_min: -243,
                    y_max: 245,
                    ha: 488,
                    o: "m 492 -56 b 382 -192 481 -88 452 -192 b 190 -134 288 -192 268 -134 b 153 -138 179 -134 167 -135 b 341 -36 153 -138 189 -84 b 533 173 494 12 533 86 b 288 353 533 233 505 353 b 30 156 71 353 30 222 b 138 49 30 96 79 49 b 245 156 197 49 245 96 b 179 255 245 196 216 240 b 168 271 174 256 168 264 b 202 297 168 279 176 289 b 251 304 209 300 229 304 b 311 288 271 304 294 300 b 348 180 338 271 348 245 b 65 -150 348 12 148 -24 b 22 -278 65 -150 22 -210 b 73 -350 22 -346 56 -350 b 121 -305 96 -350 121 -331 b 117 -287 121 -300 120 -294 b 105 -239 108 -266 105 -251 b 107 -226 105 -235 105 -230 b 154 -203 108 -217 120 -203 b 238 -289 196 -203 212 -252 b 350 -350 264 -327 304 -350 b 484 -264 396 -350 458 -317 b 543 -63 510 -210 543 -102 b 518 -36 543 -45 531 -36 b 492 -56 508 -36 498 -42 z"
                },
                timeSig3: {
                    x_min: 15,
                    x_max: 364,
                    y_min: -244,
                    y_max: 244,
                    ha: 488,
                    o: "m 392 23 b 514 168 507 68 514 143 b 514 176 514 171 514 174 b 262 351 514 189 510 351 b 22 176 14 351 22 176 l 23 176 l 22 173 b 115 81 22 121 63 81 b 207 173 167 81 207 121 b 135 264 207 215 176 255 b 140 268 137 265 138 266 b 215 289 160 282 187 289 b 340 176 275 289 340 253 b 255 69 340 85 272 72 b 140 60 238 66 157 60 b 121 40 122 60 121 40 l 121 12 b 140 -6 121 12 124 -4 b 243 -14 164 -7 197 -7 b 340 -167 307 -23 340 -66 b 215 -289 340 -264 275 -289 b 121 -266 174 -289 137 -278 b 207 -174 168 -264 207 -222 b 115 -81 207 -122 167 -81 b 22 -174 63 -81 22 -122 b 22 -180 22 -174 22 -177 b 78 -298 22 -199 26 -251 b 236 -351 134 -350 204 -351 b 524 -147 374 -351 524 -304 b 389 23 524 -42 452 3 z"
                },
                timeSig4: {
                    x_min: 14,
                    x_max: 442,
                    y_min: -248,
                    y_max: 249,
                    ha: 497,
                    o: "m 300 -183 l 300 -289 l 180 -289 b 160 -310 170 -289 160 -298 l 160 -337 b 180 -357 160 -348 170 -357 l 616 -357 b 636 -337 628 -357 636 -348 l 636 -310 b 616 -289 636 -298 628 -289 l 487 -289 l 487 -183 l 616 -183 b 636 -161 628 -183 636 -173 l 636 -134 b 616 -114 636 -124 628 -114 l 487 -114 l 487 115 b 477 134 487 124 482 131 l 459 143 b 452 144 456 144 455 144 b 449 144 451 144 451 144 b 436 140 445 144 439 143 l 305 20 b 300 4 301 16 300 10 l 300 -114 l 132 -114 b 464 287 132 -114 294 59 b 471 307 469 294 471 301 b 467 321 471 314 468 320 l 435 353 b 420 359 431 356 426 359 b 206 359 412 359 217 359 b 187 341 196 359 189 350 b 143 118 187 341 180 235 b 24 -124 105 1 62 -71 b 20 -140 24 -124 20 -131 b 22 -148 20 -143 20 -145 b 36 -174 26 -158 36 -174 b 52 -183 36 -174 39 -183 z"
                },
                timeSig5: {
                    x_min: 15,
                    x_max: 362,
                    y_min: -244,
                    y_max: 246,
                    ha: 490,
                    o: "m 39 314 b 46 170 39 314 46 245 b 46 151 46 164 46 157 b 39 -24 45 71 39 -24 b 39 -29 39 -24 39 -26 b 49 -48 39 -35 40 -46 b 99 -59 62 -50 92 -58 b 107 -59 102 -59 104 -59 b 121 -49 112 -59 118 -58 b 235 45 128 -30 144 45 b 356 -112 337 45 356 -43 b 238 -292 356 -184 333 -288 b 226 -292 233 -292 230 -292 b 166 -282 193 -292 174 -288 b 158 -274 161 -281 158 -276 b 164 -264 158 -269 160 -266 b 222 -168 177 -255 222 -239 b 117 -71 222 -98 173 -71 b 22 -171 60 -71 22 -122 b 111 -318 22 -220 36 -275 b 252 -351 147 -338 199 -351 b 456 -275 325 -351 405 -328 b 521 -109 503 -228 521 -167 b 433 79 521 -32 487 43 b 271 124 397 104 336 124 b 131 84 223 124 173 112 b 125 82 130 82 127 82 b 115 92 120 82 115 86 l 115 183 b 131 199 115 192 122 199 l 132 199 b 252 192 154 197 202 192 b 372 209 295 192 340 196 b 474 320 439 236 462 289 b 477 334 475 324 477 330 b 451 354 477 346 469 354 b 431 351 445 354 439 353 b 252 328 360 334 305 328 b 88 343 200 328 150 334 b 71 344 88 343 81 344 b 39 320 56 344 39 340 b 39 314 39 317 39 315 z"
                },
                timeSig6: {
                    x_min: 15,
                    x_max: 387,
                    y_min: -244,
                    y_max: 245,
                    ha: 489,
                    o: "m 356 69 b 216 22 268 69 236 43 b 209 98 212 52 209 75 b 216 167 209 121 212 141 b 338 287 225 220 261 287 b 410 259 374 287 396 275 b 356 174 380 246 356 207 b 448 82 356 122 396 82 b 541 174 500 82 541 122 l 541 177 b 541 179 541 177 541 177 b 533 225 541 192 539 213 b 310 353 514 276 454 353 b 58 163 180 353 86 229 b 22 -23 43 128 22 58 b 131 -285 22 -111 46 -210 b 318 -351 215 -348 268 -351 b 557 -125 369 -351 557 -292 b 356 69 557 16 446 69 z m 302 -291 b 216 -145 255 -291 216 -226 b 302 1 216 -65 255 1 b 390 -145 350 1 390 -65 b 302 -291 390 -226 350 -291 z"
                },
                timeSig7: {
                    x_min: 15,
                    x_max: 366,
                    y_min: -250,
                    y_max: 251,
                    ha: 501,
                    o: "m 233 -177 b 160 -336 202 -225 160 -282 b 180 -360 160 -351 164 -360 b 264 -351 203 -360 217 -354 b 278 -350 268 -351 274 -350 b 369 -360 320 -350 359 -360 b 405 -331 382 -360 406 -344 b 405 -327 405 -330 405 -328 b 396 -226 405 -324 396 -279 b 408 -130 396 -196 399 -161 b 503 151 425 -62 471 60 b 527 308 518 196 527 275 b 526 341 527 321 527 327 b 510 361 524 356 518 361 b 484 361 503 361 491 361 b 467 341 477 361 467 356 b 406 228 467 327 464 228 b 235 351 346 228 328 351 b 86 252 145 351 91 261 l 86 321 b 71 337 86 330 79 337 l 37 337 b 22 321 29 337 22 330 l 22 55 b 37 39 22 46 29 39 l 71 39 b 86 55 79 39 86 46 l 86 101 b 158 179 86 134 108 179 b 328 124 209 179 213 124 b 425 143 357 124 410 128 b 233 -177 413 120 266 -130 z"
                },
                timeSig8: {
                    x_min: 15,
                    x_max: 393,
                    y_min: -248,
                    y_max: 246,
                    ha: 494,
                    o: "m 467 26 b 547 166 514 62 547 108 b 294 354 547 269 433 354 b 40 166 154 354 40 269 b 122 13 40 108 55 56 b 22 -147 58 -24 22 -78 b 294 -357 22 -264 144 -357 b 566 -147 444 -357 566 -264 b 467 26 566 -78 541 -13 z m 294 -276 b 122 -145 202 -276 122 -226 b 197 -26 122 -49 197 -26 b 435 -187 295 -59 435 -108 b 294 -276 435 -226 384 -276 z m 386 65 b 180 209 288 96 180 144 b 294 288 180 265 232 288 b 444 180 383 288 444 246 b 386 65 444 111 412 78 z"
                },
                timeSig9: {
                    x_min: 15,
                    x_max: 387,
                    y_min: -244,
                    y_max: 245,
                    ha: 489,
                    o: "m 223 -68 b 363 -20 311 -68 343 -42 b 370 -96 367 -50 370 -73 b 363 -166 370 -120 367 -140 b 240 -285 354 -219 318 -285 b 168 -258 204 -285 183 -274 b 223 -173 199 -245 223 -206 b 131 -81 223 -121 183 -81 b 37 -173 79 -81 37 -121 l 37 -176 b 37 -177 37 -176 37 -176 b 46 -223 37 -190 40 -212 b 269 -351 65 -275 125 -351 b 521 -161 399 -351 492 -228 b 557 24 536 -127 557 -56 b 448 287 557 112 533 212 b 261 353 364 350 311 353 b 22 127 210 353 22 294 b 223 -68 22 -14 132 -68 z m 276 294 b 363 147 324 294 363 228 b 276 1 363 66 324 1 b 189 147 229 1 189 66 b 276 294 189 228 229 294 z"
                },
                timeSigCommon: {
                    x_min: 0,
                    x_max: 463,
                    y_min: -256,
                    y_max: 258,
                    ha: 514,
                    o: "m 468 258 b 406 147 432 235 406 193 b 408 130 406 141 406 135 b 521 17 415 71 462 24 b 537 17 526 17 533 17 b 667 147 609 17 667 75 b 667 156 667 147 667 151 b 664 177 667 161 665 171 b 350 372 651 239 595 372 b 0 17 36 372 0 111 b 382 -369 0 -154 22 -369 b 641 -131 524 -369 635 -285 b 629 -120 641 -124 636 -120 l 611 -120 b 599 -131 605 -120 599 -125 b 382 -323 593 -251 508 -323 b 196 -128 256 -323 196 -255 l 196 147 b 356 320 196 228 228 320 b 469 271 423 320 454 295 b 471 264 471 268 471 266 b 468 258 471 262 471 259 z"
                },
                timeSigCutCommon: {
                    x_min: 0,
                    x_max: 463,
                    y_min: -376,
                    y_max: 388,
                    ha: 764,
                    o: "m 611 -120 b 599 -131 605 -120 599 -125 b 382 -323 593 -251 508 -323 b 369 -323 377 -323 373 -323 l 369 320 b 469 269 428 317 455 292 b 471 264 471 266 471 265 b 468 258 471 261 471 259 b 406 147 432 235 406 193 b 408 130 406 141 406 135 b 523 17 415 71 464 24 b 537 17 527 17 533 17 b 667 147 609 17 667 75 b 667 156 667 147 667 151 b 664 177 667 161 665 171 b 369 370 651 236 598 364 l 369 543 b 353 559 369 552 361 559 l 314 559 b 298 543 305 559 298 552 l 298 369 b 0 17 32 341 0 105 b 298 -364 0 -140 17 -334 l 298 -526 b 314 -541 298 -534 305 -541 l 353 -541 b 369 -526 361 -541 369 -534 l 369 -369 b 382 -369 373 -369 377 -369 b 641 -131 524 -369 635 -285 b 629 -120 641 -124 636 -120 z m 196 147 b 298 312 196 215 216 289 l 298 -310 b 196 -128 229 -285 196 -223 z"
                },
                timeSigPlus: {
                    x_min: 0,
                    x_max: 408,
                    y_min: -204,
                    y_max: 204,
                    ha: 408,
                    o: "m 327 33 l 327 275 b 308 294 327 285 318 294 l 279 294 b 261 275 269 294 261 285 l 261 33 l 19 33 b 0 14 9 33 0 24 l 0 -13 b 19 -33 0 -23 9 -33 l 261 -33 l 261 -274 b 279 -294 261 -284 269 -294 l 308 -294 b 327 -274 318 -294 327 -284 l 327 -33 l 567 -33 b 588 -13 577 -33 588 -23 l 588 14 b 567 33 588 24 577 33 z"
                },
                noteheadDoubleWhole: {
                    x_min: 0,
                    x_max: 538,
                    y_min: -178,
                    y_max: 179,
                    ha: 357,
                    o: "m 33 258 b 20 258 27 258 26 258 b 0 238 9 258 0 249 b 0 -236 0 226 0 -226 b 20 -256 0 -246 9 -256 b 33 -256 26 -256 27 -256 b 53 -236 43 -256 53 -245 b 53 238 53 -228 53 226 b 33 258 53 249 45 258 z m 649 258 b 636 258 644 258 642 258 b 616 238 625 258 616 249 b 616 125 616 235 616 187 b 389 196 573 167 500 196 b 160 125 276 196 203 167 b 160 238 160 187 160 235 b 140 258 160 249 151 258 b 127 258 134 258 132 258 b 107 238 115 258 107 249 b 107 -236 107 226 107 -226 b 127 -256 107 -246 115 -256 b 140 -256 132 -256 134 -256 b 160 -236 150 -256 160 -245 b 160 -122 160 -233 160 -186 b 389 -194 203 -166 276 -194 b 616 -122 500 -194 573 -166 b 616 -236 616 -186 616 -233 b 636 -256 616 -246 625 -256 b 649 -256 642 -256 644 -256 b 670 -236 660 -256 670 -245 b 670 238 670 -228 670 226 b 649 258 670 249 661 258 z m 462 -140 b 400 -148 445 -144 422 -148 b 314 -101 360 -148 333 -135 b 268 68 295 -65 269 29 b 268 76 268 71 268 73 b 314 141 268 109 282 130 b 377 150 331 145 354 150 b 462 102 416 150 442 140 b 510 -66 482 63 510 -29 b 462 -140 510 -104 497 -128 z m 755 258 b 742 258 749 258 747 258 b 721 238 730 258 721 249 b 721 -236 721 226 721 -226 b 742 -256 721 -246 730 -256 b 755 -256 747 -256 749 -256 b 775 -236 765 -256 775 -245 b 775 238 775 -228 775 226 b 755 258 775 249 766 258 z"
                },
                noteheadWhole: {
                    x_min: 0,
                    x_max: 373,
                    y_min: -134,
                    y_max: 136,
                    ha: 270,
                    o: "m 269 196 b 0 1 71 196 0 95 b 269 -193 0 -92 71 -193 b 537 1 468 -193 537 -92 b 269 196 537 95 468 196 z m 343 -138 b 281 -147 325 -144 302 -147 b 194 -99 240 -147 213 -135 b 148 68 176 -63 150 29 b 194 141 145 107 160 130 b 256 150 212 147 235 150 b 343 102 297 150 323 141 b 389 -65 363 63 389 -29 b 343 -138 389 -102 377 -128 z"
                },
                noteheadHalf: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -133,
                    y_max: 132,
                    ha: 265,
                    o: "m 307 190 b 0 -60 167 190 0 73 b 161 -192 0 -122 45 -192 b 468 58 311 -192 468 -69 b 307 190 468 143 396 190 z m 268 -63 b 108 -124 264 -66 158 -124 b 50 -72 60 -124 50 -85 b 200 62 50 -12 194 59 b 360 122 206 65 308 122 b 418 71 395 122 418 102 b 268 -63 418 9 272 -60 z"
                },
                noteheadBlack: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -133,
                    y_max: 132,
                    ha: 265,
                    o: "m 0 -60 b 161 -192 0 -122 45 -192 b 468 58 311 -192 468 -69 b 307 190 468 143 396 190 b 0 -60 167 190 0 72 z"
                },
                noteheadXBlack: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -132,
                    y_max: 132,
                    ha: 264,
                    o: "m 461 138 b 468 153 465 141 468 147 l 468 154 b 462 167 468 160 465 164 l 445 184 b 431 190 441 187 436 190 b 418 186 426 190 420 189 l 235 40 l 50 186 b 37 190 48 189 42 190 b 24 184 32 190 29 187 l 6 167 b 0 153 3 164 0 158 b 7 138 0 147 3 141 l 183 0 l 7 -138 b 0 -153 3 -141 0 -147 b 6 -166 0 -157 3 -163 l 23 -184 b 37 -190 26 -189 32 -190 b 50 -186 42 -190 48 -189 l 235 -40 l 418 -186 b 431 -190 420 -189 426 -190 b 445 -184 436 -190 442 -189 l 462 -166 b 468 -153 465 -163 468 -157 b 461 -138 468 -147 465 -141 l 285 0 z"
                },
                noteheadCircleX: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -162,
                    y_max: 163,
                    ha: 325,
                    o: "m 265 0 l 395 105 b 426 0 415 75 426 39 b 387 -115 426 -43 412 -84 z m 233 -27 l 360 -145 b 235 -192 327 -174 282 -192 b 99 -137 183 -192 134 -171 z m 202 1 l 73 -105 b 42 0 53 -75 42 -39 b 81 115 42 43 56 84 z m 235 29 l 108 145 b 233 193 141 174 186 193 b 369 138 285 193 334 173 z m 233 235 b 0 0 104 235 0 130 b 233 -233 0 -130 104 -233 b 468 0 363 -233 468 -130 b 233 235 468 130 363 235 z"
                },
                noteheadDoubleWholeSquare: {
                    x_min: 0,
                    x_max: 432,
                    y_min: -179,
                    y_max: 177,
                    ha: 356,
                    o: "m 590 255 b 570 235 579 255 570 246 l 570 203 l 53 203 l 53 235 b 33 255 53 246 45 255 l 20 255 b 0 235 9 255 0 246 l 0 -230 b 20 -251 0 -242 9 -251 l 33 -251 b 53 -230 45 -251 53 -242 l 53 -200 l 570 -200 l 570 -238 b 590 -258 570 -249 579 -258 l 603 -258 b 622 -238 615 -258 622 -249 l 622 235 b 603 255 622 246 615 255 z m 570 -101 l 53 -101 l 53 105 l 570 105 z"
                },
                noteheadSquareWhite: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 395 128 l 395 -128 l 52 -128 l 52 128 z m 446 180 l 0 180 l 0 -180 l 446 -180 z"
                },
                noteheadSquareBlack: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 446 180 l 0 180 l 0 -180 l 446 -180 z"
                },
                noteheadTriangleUpBlack: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -136,
                    y_max: 122,
                    ha: 258,
                    o: "m 223 176 l 0 -196 l 446 -196 z"
                },
                noteheadSlashedDoubleWhole1: {
                    x_min: -66,
                    x_max: 456,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 652 298 b 638 305 649 304 644 305 b 626 301 634 305 629 304 l 560 248 b 543 256 557 253 550 256 b 530 256 537 256 536 256 b 510 236 518 256 510 248 b 510 204 510 235 510 223 l 455 161 b 281 194 413 181 356 194 b 53 124 168 194 96 166 b 53 236 53 186 53 233 b 29 256 53 253 42 256 b 20 256 26 256 23 256 b 0 236 9 256 0 248 b 0 -204 0 228 0 -98 l -88 -272 b -95 -288 -92 -276 -95 -282 b -91 -300 -95 -291 -94 -295 b -76 -307 -86 -304 -82 -307 b -65 -302 -72 -307 -68 -305 l 3 -248 b 20 -258 6 -253 12 -258 b 53 -238 33 -258 52 -255 b 53 -206 53 -236 53 -225 l 107 -161 b 281 -196 148 -183 206 -196 b 510 -124 393 -196 465 -166 b 510 -238 510 -187 510 -235 b 530 -258 510 -248 518 -258 b 563 -238 543 -258 563 -255 b 563 204 563 -229 563 98 l 649 272 b 657 288 655 276 657 282 b 652 298 657 291 655 295 z m 160 75 b 269 148 160 138 219 148 b 356 101 310 148 334 140 b 363 85 357 96 360 91 l 189 -56 b 160 66 174 -14 161 40 b 160 75 160 69 160 72 z m 53 -163 b 53 -124 53 -151 53 -138 b 76 -144 60 -131 68 -138 z m 402 -68 b 292 -148 402 -138 351 -148 b 207 -101 252 -150 226 -137 b 199 -84 204 -96 202 -91 l 373 56 b 402 -68 389 13 402 -40 z m 510 124 b 485 144 503 131 494 137 l 510 163 b 510 124 510 151 510 137 z"
                },
                noteheadSlashedWhole1: {
                    x_min: -75,
                    x_max: 448,
                    y_min: -211,
                    y_max: 214,
                    ha: 425,
                    o: "m 641 301 b 625 308 636 305 631 308 b 613 304 621 307 618 307 l 439 160 b 269 196 399 181 343 196 b 0 1 71 196 0 95 b 69 -138 0 -49 20 -101 l -101 -271 b -108 -287 -105 -275 -108 -281 b -104 -298 -107 -291 -107 -294 b -88 -304 -99 -302 -94 -304 b -76 -301 -85 -304 -81 -304 l 98 -157 b 269 -193 138 -179 194 -193 b 537 1 468 -193 537 -92 b 468 141 537 52 517 104 l 638 274 b 645 289 642 278 645 284 b 641 301 644 292 644 297 z m 148 68 b 148 78 148 72 148 75 b 194 141 148 111 163 131 b 256 150 212 147 235 150 b 343 102 297 150 323 141 b 350 86 346 98 348 92 l 177 -55 b 148 68 163 -12 150 42 z m 389 -65 b 343 -138 389 -102 377 -128 b 281 -147 325 -144 302 -147 b 194 -99 240 -147 213 -135 b 187 -82 192 -95 190 -89 l 279 -6 l 361 58 b 389 -65 376 16 389 -39 z"
                },
                noteheadSlashedHalf1: {
                    x_min: -98,
                    x_max: 424,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 606 298 b 592 305 602 302 598 305 b 580 301 588 305 583 304 l 412 163 b 307 190 383 180 347 190 b 153 148 258 190 204 176 b 0 -60 58 98 0 13 b 14 -120 0 -81 4 -101 b 32 -143 20 -128 26 -135 l -134 -274 b -141 -288 -138 -276 -141 -282 b -137 -300 -141 -292 -140 -297 b -122 -307 -134 -304 -128 -307 b -111 -302 -118 -307 -114 -305 l 56 -164 b 161 -192 85 -181 121 -192 b 315 -151 210 -192 264 -179 b 468 58 410 -101 468 -16 b 454 117 468 78 464 98 b 436 141 449 125 444 134 l 603 272 b 611 287 608 275 611 281 b 606 298 611 291 609 295 z m 56 -98 b 49 -73 52 -91 49 -82 b 75 -23 49 -58 59 -39 b 199 60 99 1 147 32 b 337 118 251 89 302 111 b 359 121 344 120 351 121 b 361 121 360 121 360 121 l 225 9 l 69 -114 b 56 -98 65 -109 60 -104 z m 410 94 b 416 69 415 86 416 78 b 392 19 416 53 408 36 b 266 -65 367 -6 318 -36 b 128 -122 215 -94 163 -115 b 107 -125 121 -124 114 -125 b 104 -125 107 -125 105 -125 l 245 -9 l 396 111 b 410 94 402 107 408 101 z"
                },
                noteheadSlashedBlack1: {
                    x_min: -98,
                    x_max: 424,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 606 298 b 592 305 602 302 598 305 b 580 301 588 305 583 304 l 412 161 b 307 190 383 180 347 190 b 0 -60 167 190 0 72 b 32 -144 0 -89 10 -120 l -134 -274 b -141 -288 -138 -278 -141 -284 b -137 -301 -141 -292 -140 -297 b -122 -307 -134 -305 -128 -307 b -111 -304 -118 -307 -114 -307 l 56 -164 b 161 -192 82 -181 117 -192 b 468 58 311 -192 468 -71 b 436 141 468 91 456 120 l 603 271 b 611 285 608 275 611 281 b 606 298 611 289 609 294 z"
                },
                noteheadSlashedDoubleWhole2: {
                    x_min: -66,
                    x_max: 456,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 563 -204 b 563 236 563 -98 563 228 b 543 256 563 249 554 256 b 530 256 537 256 536 256 b 510 236 518 256 510 248 b 510 124 510 233 510 187 b 281 194 467 166 393 194 b 107 161 207 194 150 181 l 53 204 b 53 236 53 223 53 235 b 33 256 53 249 45 256 b 20 256 27 256 26 256 b 3 246 12 256 6 253 l -63 301 b -76 305 -68 304 -72 305 b -91 298 -81 305 -86 304 b -95 287 -94 295 -95 291 b -88 272 -95 281 -92 276 l 0 204 b 0 -238 0 98 0 -229 b 20 -258 0 -248 9 -258 b 33 -258 26 -258 27 -258 b 53 -238 43 -258 53 -246 b 53 -124 53 -235 53 -187 b 281 -196 96 -166 170 -196 b 456 -161 356 -196 413 -183 l 510 -206 b 510 -238 510 -225 510 -236 b 530 -258 510 -248 518 -258 b 543 -258 536 -258 537 -258 b 560 -246 549 -258 556 -252 l 626 -302 b 638 -307 631 -305 634 -307 b 654 -300 645 -307 649 -304 b 657 -288 655 -295 657 -292 b 651 -272 657 -282 655 -276 z m 207 140 b 269 148 225 144 248 148 b 356 101 310 148 336 140 b 402 -68 376 62 402 -30 b 402 -78 402 -71 402 -75 l 292 9 l 168 109 b 207 140 176 124 189 134 z m 78 144 b 53 124 69 137 60 131 b 53 163 53 137 53 150 z m 356 -141 b 294 -148 338 -145 315 -148 b 207 -101 253 -148 226 -137 b 161 66 189 -66 163 27 b 160 72 161 69 160 71 b 161 78 160 75 160 76 l 271 -9 l 395 -109 b 356 -141 387 -124 374 -134 z m 485 -144 b 510 -124 494 -138 503 -131 b 510 -163 510 -138 510 -151 z"
                },
                noteheadSlashedWhole2: {
                    x_min: -75,
                    x_max: 448,
                    y_min: -212,
                    y_max: 214,
                    ha: 426,
                    o: "m 468 -138 b 537 1 517 -101 537 -49 b 269 196 537 95 468 196 b 98 160 196 196 140 181 l -76 304 b -88 308 -81 307 -84 307 b -104 301 -94 308 -99 305 b -108 289 -107 297 -107 292 b -101 274 -108 284 -105 278 l 69 141 b 0 1 20 104 0 52 b 269 -193 0 -92 71 -193 b 441 -157 343 -193 399 -179 l 613 -301 b 625 -305 618 -304 622 -305 b 641 -298 631 -305 636 -302 b 645 -287 644 -294 644 -291 b 638 -271 645 -281 642 -275 z m 194 141 b 256 150 212 147 235 150 b 343 102 297 150 323 141 b 389 -65 363 63 389 -29 b 389 -76 389 -69 389 -73 l 279 10 l 156 112 b 194 141 163 125 176 135 z m 343 -138 b 281 -147 325 -144 302 -147 b 194 -99 240 -147 213 -135 b 148 68 176 -63 150 29 b 148 76 148 71 148 73 b 148 81 148 78 148 79 l 258 -6 l 382 -108 b 343 -138 374 -122 361 -132 z"
                },
                noteheadSlashedHalf2: {
                    x_min: -98,
                    x_max: 424,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 386 -102 b 468 58 438 -55 468 4 b 454 117 468 78 464 98 b 307 190 428 164 373 190 b 153 148 258 190 204 176 b 108 120 137 140 122 130 l -111 301 b -122 305 -114 304 -118 305 b -137 298 -128 305 -134 302 b -141 287 -140 295 -141 291 b -134 272 -141 281 -138 275 l 85 101 b 0 -60 32 53 0 -7 b 14 -120 0 -81 4 -101 b 161 -192 40 -167 95 -192 b 315 -151 210 -192 264 -179 b 361 -122 333 -143 347 -132 l 580 -302 b 592 -307 583 -305 588 -307 b 606 -300 598 -307 602 -304 b 611 -288 609 -297 611 -292 b 603 -274 611 -282 608 -276 z m 199 60 b 337 118 251 89 302 111 b 359 121 344 120 351 121 b 410 94 382 121 400 112 b 416 69 415 86 416 78 b 392 19 416 53 408 36 b 308 -42 374 0 343 -20 l 245 7 l 189 55 b 199 60 192 56 196 58 z m 266 -65 b 128 -122 215 -94 163 -115 b 107 -125 121 -124 114 -125 b 56 -98 84 -125 66 -117 b 49 -73 52 -91 49 -82 b 75 -23 49 -58 59 -39 b 163 39 94 -4 125 17 l 225 -9 l 282 -56 b 266 -65 276 -59 272 -62 z"
                },
                noteheadSlashedBlack2: {
                    x_min: -98,
                    x_max: 424,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 384 -102 b 468 58 435 -58 468 0 b 307 190 468 143 396 190 b 108 121 239 190 167 163 l -111 301 b -124 305 -115 304 -120 305 b -138 298 -128 305 -134 302 b -141 289 -140 295 -141 292 b -141 287 -141 288 -143 288 b -135 272 -141 281 -140 275 l 84 101 b 0 -60 35 56 0 0 b 161 -192 0 -122 45 -192 b 361 -122 232 -192 304 -164 l 579 -302 b 590 -307 583 -305 588 -307 b 606 -300 596 -307 602 -304 b 611 -288 609 -297 611 -292 b 603 -274 609 -282 608 -276 z"
                },
                noteheadDiamondDoubleWhole: {
                    x_min: 0,
                    x_max: 373,
                    y_min: -178,
                    y_max: 179,
                    ha: 357,
                    o: "m 504 258 b 484 238 494 258 484 248 l 484 46 b 282 187 415 95 285 186 b 268 192 279 190 275 192 b 255 187 262 192 258 190 l 52 45 l 52 238 b 33 258 52 248 43 258 l 20 258 b 0 238 9 258 0 248 l 0 -236 b 20 -256 0 -248 9 -256 l 33 -256 b 52 -236 43 -256 52 -248 l 52 -45 l 249 -181 b 268 -190 258 -189 264 -190 b 282 -186 274 -190 279 -189 b 484 -43 285 -184 413 -94 l 484 -236 b 504 -256 484 -248 494 -256 l 517 -256 b 537 -236 528 -256 537 -248 l 537 238 b 517 258 537 248 528 258 z m 220 -115 l 102 -33 l 317 117 l 435 35 z"
                },
                noteheadDiamondWhole: {
                    x_min: 0,
                    x_max: 373,
                    y_min: -133,
                    y_max: 132,
                    ha: 265,
                    o: "m 282 -187 b 530 -13 285 -186 530 -13 b 537 0 534 -10 537 -6 b 530 13 537 4 534 10 b 282 186 530 13 287 183 b 268 190 279 189 275 190 b 255 186 262 190 258 189 l 7 12 b 0 -1 3 9 0 4 b 4 -13 0 -6 1 -10 l 249 -183 b 268 -192 258 -190 264 -192 b 282 -187 274 -192 279 -190 z m 220 -117 l 102 -35 l 317 115 l 435 33 z"
                },
                noteheadDiamondHalf: {
                    x_min: 0,
                    x_max: 335,
                    y_min: -132,
                    y_max: 133,
                    ha: 265,
                    o: "m 475 -13 b 482 0 480 -10 482 -6 b 475 13 482 4 480 10 l 253 187 b 240 192 251 190 246 192 b 229 187 236 192 232 190 l 7 13 b 0 0 3 10 0 6 b 7 -13 0 -4 3 -10 l 229 -186 b 240 -190 232 -189 236 -190 b 253 -186 246 -190 251 -189 z m 284 -115 l 92 33 l 199 117 l 390 -33 z"
                },
                noteheadDiamondBlack: {
                    x_min: 0,
                    x_max: 335,
                    y_min: -132,
                    y_max: 133,
                    ha: 265,
                    o: "m 475 -14 b 482 -1 480 -10 482 -6 b 475 13 482 4 480 10 l 253 187 b 240 192 251 190 246 192 b 229 187 236 192 232 190 l 7 13 b 0 0 3 10 0 4 b 7 -14 0 -6 3 -10 l 229 -186 b 240 -190 232 -189 236 -190 b 253 -186 246 -190 251 -189 z"
                },
                noteheadParenthesisRight: {
                    x_min: 0,
                    x_max: 75,
                    y_min: -209,
                    y_max: 212,
                    ha: 421,
                    o: "m 10 305 b 4 302 7 304 6 304 b 0 295 1 301 0 298 b 1 289 0 294 0 292 b 68 -10 1 288 68 160 b 1 -288 68 -95 50 -192 b 0 -292 0 -289 0 -291 b 4 -300 0 -295 1 -298 b 12 -301 7 -301 9 -302 b 17 -298 14 -301 16 -300 b 108 0 22 -292 108 -174 b 17 301 108 174 22 295 b 10 305 16 304 13 305 z"
                },
                noteheadParenthesisLeft: {
                    x_min: 0,
                    x_max: 75,
                    y_min: -212,
                    y_max: 209,
                    ha: 421,
                    o: "m 98 -305 b 104 -302 101 -304 102 -304 b 108 -295 107 -301 108 -298 b 107 -289 108 -294 108 -292 b 40 10 107 -288 40 -160 b 107 288 40 95 58 192 b 108 292 108 289 108 291 b 104 300 108 295 107 298 b 96 301 101 301 99 302 b 91 298 94 301 92 300 b 0 0 86 292 0 174 b 91 -301 0 -174 86 -295 b 98 -305 92 -304 95 -305 z"
                },
                noteheadMoonBlack: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 0 180 l 0 0 b 223 -180 0 -99 99 -180 b 446 0 347 -180 446 -99 l 446 180 z"
                },
                noteheadTriangleLeftBlack: {
                    x_min: 0,
                    x_max: 339,
                    y_min: -136,
                    y_max: 122,
                    ha: 258,
                    o: "m 0 176 l 0 -196 l 488 -196 z"
                },
                noteheadTriangleRightBlack: {
                    x_min: 0,
                    x_max: 339,
                    y_min: -136,
                    y_max: 122,
                    ha: 258,
                    o: "m 488 176 l 0 -196 l 488 -196 z"
                },
                noteheadTriangleRoundDownBlack: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -136,
                    y_max: 122,
                    ha: 258,
                    o: "m 226 -196 l 446 63 b 226 176 446 63 384 176 b 0 63 68 176 0 63 z"
                },
                augmentationDot: {
                    x_min: 0,
                    x_max: 100,
                    y_min: -50,
                    y_max: 50,
                    ha: 100,
                    o: "m 0 0 b 72 -72 0 -40 32 -72 b 144 0 112 -72 144 -40 b 72 72 144 40 112 72 b 0 0 32 72 0 40 z"
                },
                tremolo1: {
                    x_min: 0,
                    x_max: 290,
                    y_min: -93,
                    y_max: 96,
                    ha: 189,
                    o: "m 0 48 l 0 -134 l 418 -43 l 418 138 z"
                },
                flag8thUp: {
                    x_min: 0,
                    x_max: 289,
                    y_min: -817,
                    y_max: 12,
                    ha: 829,
                    o: "m 0 -327 b 12 -343 0 -331 1 -338 b 291 -600 73 -363 197 -441 b 359 -827 317 -645 359 -707 b 294 -1140 359 -930 331 -1037 b 289 -1162 291 -1149 288 -1156 b 297 -1175 289 -1168 291 -1172 b 304 -1176 300 -1176 302 -1176 b 327 -1161 314 -1176 321 -1171 b 416 -798 395 -1041 418 -888 b 416 -780 416 -791 416 -786 b 302 -458 409 -595 302 -458 b 131 -220 307 -458 170 -281 b 50 -50 78 -138 53 -56 b 36 6 49 -46 36 6 b 19 17 35 12 27 17 b 0 -1 9 17 0 9 z"
                },
                flag8thDown: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -12,
                    y_max: 817,
                    ha: 829,
                    o: "m 0 1 b 19 -17 0 -9 9 -17 b 36 -6 26 -17 35 -12 b 50 50 36 -4 49 46 b 117 196 52 56 65 111 b 331 458 173 289 259 357 b 445 780 402 559 445 654 b 338 1161 445 912 415 1021 b 317 1176 334 1171 325 1176 b 310 1175 314 1176 311 1176 b 300 1158 302 1172 300 1166 b 304 1140 300 1153 301 1146 b 384 827 361 1007 384 930 b 317 600 384 707 343 645 b 12 343 223 441 72 363 b 0 327 1 338 0 331 z"
                },
                flag16thUp: {
                    x_min: 0,
                    x_max: 279,
                    y_min: -820,
                    y_max: 12,
                    ha: 832,
                    o: "m 301 -681 b 148 -514 262 -631 219 -585 b 56 -372 92 -458 66 -409 b 52 -343 55 -364 53 -354 b 271 -510 125 -343 219 -442 b 340 -696 327 -583 340 -641 b 337 -739 340 -710 338 -724 b 301 -681 325 -716 312 -697 z m 0 -549 b 22 -563 0 -553 12 -559 b 258 -776 59 -576 171 -648 b 318 -950 307 -850 318 -901 b 317 -975 318 -959 318 -966 b 285 -1140 317 -1009 307 -1083 b 279 -1164 284 -1148 279 -1156 b 289 -1179 279 -1169 282 -1175 b 297 -1181 292 -1181 294 -1181 b 318 -1161 307 -1181 312 -1169 b 382 -962 344 -1120 382 -1043 b 374 -855 382 -920 379 -886 b 402 -678 389 -802 402 -749 b 333 -471 402 -603 382 -536 b 137 -228 265 -382 192 -307 b 42 0 82 -148 42 0 b 22 17 39 10 37 17 b 0 0 4 17 0 10 z"
                },
                flag16thDown: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -26,
                    y_max: 803,
                    ha: 829,
                    o: "m 53 346 b 56 363 55 353 56 359 b 163 517 66 399 78 452 b 384 732 246 582 346 662 b 317 503 382 621 354 552 b 53 346 229 395 122 364 z m 0 -14 b 22 -37 0 -26 10 -37 b 43 -14 33 -37 40 -26 b 167 232 65 134 109 177 b 445 683 243 305 445 416 b 432 837 445 730 441 783 b 441 919 438 855 441 881 b 327 1149 441 1032 374 1112 b 304 1156 321 1153 312 1156 b 287 1152 298 1156 292 1155 b 279 1145 281 1149 279 1148 b 294 1129 279 1140 288 1135 b 382 930 344 1076 382 1027 b 374 876 382 912 380 893 l 373 871 b 373 871 373 871 373 871 b 327 789 366 842 350 815 b 22 598 226 672 86 612 b 0 559 12 593 0 562 z"
                },
                flag32ndUp: {
                    x_min: 0,
                    x_max: 279,
                    y_min: -821,
                    y_max: 186,
                    ha: 1007,
                    o: "m 301 -683 b 148 -516 262 -632 219 -588 b 56 -373 92 -459 66 -410 b 50 -343 55 -366 53 -354 b 271 -500 125 -343 219 -432 b 340 -687 327 -575 340 -632 b 337 -739 340 -704 338 -721 b 301 -683 325 -716 312 -698 z m 271 -259 b 340 -446 327 -333 340 -392 b 338 -469 340 -455 338 -462 b 333 -461 337 -467 334 -464 b 91 -192 265 -372 145 -271 b 50 -92 69 -160 58 -124 b 271 -259 124 -92 219 -192 z m 0 -550 b 22 -564 0 -554 12 -560 b 258 -778 59 -577 171 -649 b 318 -952 307 -851 318 -903 b 317 -976 318 -960 318 -968 b 285 -1142 317 -1011 307 -1084 b 279 -1165 284 -1149 279 -1158 b 289 -1181 279 -1171 282 -1176 b 297 -1182 292 -1182 294 -1182 b 318 -1162 307 -1182 312 -1171 b 382 -963 344 -1122 382 -1044 b 374 -857 382 -922 379 -887 b 402 -668 389 -802 402 -740 b 386 -563 402 -632 396 -596 b 402 -441 395 -526 402 -487 b 402 -428 402 -436 402 -432 b 333 -220 402 -353 382 -285 b 137 23 265 -131 192 -56 b 42 251 82 102 42 251 b 22 268 39 261 37 268 b 0 251 4 268 0 261 z"
                },
                flag32ndDown: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -216,
                    y_max: 803,
                    ha: 1019,
                    o: "m 50 73 b 91 171 58 105 71 141 b 347 402 145 251 272 317 b 384 454 361 418 374 435 b 324 239 384 347 361 287 b 50 73 235 130 122 94 z m 163 517 b 366 693 248 589 327 642 b 382 716 372 700 377 708 b 383 693 383 708 383 700 b 314 505 383 621 359 562 b 53 343 258 436 179 390 b 56 363 55 351 56 359 b 163 517 66 400 81 449 z m 0 -288 b 22 -311 0 -298 10 -311 b 43 -288 33 -311 40 -300 b 167 -40 65 -138 109 -95 b 445 409 243 32 445 143 b 431 577 445 462 439 520 b 441 651 435 602 439 626 b 441 675 441 658 441 667 b 441 687 441 680 441 684 b 425 808 441 730 433 772 b 441 919 435 840 441 876 b 327 1149 441 1032 374 1112 b 305 1156 321 1153 314 1156 b 287 1152 300 1156 292 1155 b 279 1145 281 1149 279 1148 b 294 1129 279 1140 288 1136 b 382 930 344 1076 382 1027 b 327 789 382 877 364 832 b 22 598 226 672 86 612 b 0 559 12 593 0 562 z"
                },
                flag64thUp: {
                    x_min: 0,
                    x_max: 279,
                    y_min: -822,
                    y_max: 373,
                    ha: 1195,
                    o: "m 333 -461 b 91 -192 265 -372 145 -271 b 50 -92 69 -161 58 -125 b 271 -251 125 -92 219 -183 b 340 -438 327 -324 340 -383 b 338 -469 340 -448 338 -459 b 333 -461 337 -467 334 -464 z m 301 -683 b 148 -517 262 -632 219 -588 b 56 -374 92 -461 66 -410 b 50 -343 55 -366 53 -356 b 271 -501 125 -343 219 -433 b 340 -688 327 -575 340 -634 b 337 -739 340 -706 338 -721 b 301 -683 325 -717 312 -698 z m 271 10 b 340 -176 327 -63 340 -121 b 337 -217 340 -190 338 -204 b 333 -212 336 -216 334 -213 b 91 65 265 -122 145 -16 b 48 177 66 101 53 143 l 50 177 b 271 10 124 177 217 78 z m 0 -552 b 22 -564 0 -554 12 -562 b 258 -778 59 -579 171 -649 b 318 -952 307 -851 317 -903 b 317 -976 318 -960 318 -968 b 285 -1142 317 -1012 307 -1084 b 279 -1165 284 -1149 279 -1158 b 289 -1181 279 -1172 282 -1178 b 297 -1184 292 -1182 295 -1184 b 318 -1164 307 -1182 312 -1172 b 382 -963 344 -1122 382 -1044 b 374 -857 382 -923 379 -887 b 402 -668 389 -804 402 -740 b 386 -563 402 -632 396 -596 b 402 -432 395 -523 402 -480 b 402 -418 402 -428 402 -423 b 383 -304 402 -379 396 -341 b 402 -170 393 -264 402 -222 b 402 -158 402 -166 402 -163 b 333 49 402 -84 382 -16 b 137 292 265 138 192 213 b 42 520 82 372 42 520 b 22 537 39 530 37 537 b 0 520 4 537 0 530 z"
                },
                flag64thDown: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -403,
                    y_max: 804,
                    ha: 1207,
                    o: "m 52 -196 b 91 -102 59 -166 71 -131 b 347 128 145 -23 272 45 b 384 180 361 145 374 163 b 324 -30 384 76 361 16 b 52 -196 235 -140 124 -176 z m 163 517 b 366 693 248 589 327 644 b 382 717 372 701 377 708 b 383 693 383 708 383 701 b 314 505 383 621 359 562 b 53 343 258 438 179 390 b 56 363 55 351 56 359 b 163 517 66 400 81 449 z m 314 232 b 50 69 258 163 179 117 b 91 171 56 102 69 140 b 347 402 145 251 272 318 b 382 449 360 416 372 432 b 383 420 383 439 383 429 b 314 232 383 348 359 288 z m 0 -557 b 22 -580 0 -567 10 -580 b 43 -557 33 -580 40 -567 b 167 -310 65 -408 109 -364 b 445 140 243 -238 445 -125 b 431 307 445 192 439 249 b 441 377 436 331 439 354 b 441 406 441 387 441 397 b 441 418 441 410 441 413 b 423 546 441 464 432 507 b 441 651 432 582 438 618 b 441 675 441 660 441 667 b 441 688 441 680 441 684 b 425 808 441 730 433 772 b 441 919 435 840 441 876 b 327 1149 441 1032 374 1112 b 305 1158 321 1153 314 1156 b 287 1152 300 1158 292 1156 b 279 1145 281 1151 279 1148 b 294 1129 279 1140 288 1136 b 382 930 344 1076 382 1027 b 327 789 382 877 364 832 b 22 598 226 672 86 612 b 0 559 12 593 0 563 z"
                },
                flag128thUp: {
                    x_min: 0,
                    x_max: 279,
                    y_min: -821,
                    y_max: 573,
                    ha: 1394,
                    o: "m 0 -550 b 22 -563 0 -553 12 -560 b 258 -776 59 -576 171 -648 b 318 -950 307 -850 318 -901 b 317 -975 318 -959 318 -966 b 285 -1140 317 -1011 307 -1083 b 279 -1164 284 -1148 279 -1156 b 289 -1179 279 -1171 282 -1176 b 297 -1182 292 -1181 294 -1181 b 318 -1162 307 -1182 312 -1169 b 382 -962 344 -1120 382 -1043 b 374 -857 382 -922 379 -887 b 402 -668 389 -802 402 -740 b 383 -554 402 -629 396 -590 b 402 -399 396 -503 402 -452 b 382 -284 402 -359 396 -321 b 402 -125 396 -230 402 -180 b 383 -14 402 -86 396 -49 b 402 130 396 35 402 81 b 333 348 402 204 382 284 b 137 592 265 438 192 513 b 42 808 82 671 46 793 b 22 825 39 818 37 825 b 0 808 4 825 0 818 z m 271 310 b 340 111 328 235 340 170 b 338 73 340 98 338 86 b 333 81 336 76 334 79 b 91 357 265 170 145 276 b 48 469 66 393 53 435 l 50 469 b 271 310 124 469 217 377 z m 301 -681 b 148 -523 262 -631 219 -593 b 56 -383 92 -465 66 -420 b 49 -343 55 -374 52 -359 l 50 -343 b 271 -500 124 -343 217 -432 b 340 -688 327 -575 340 -634 b 337 -737 340 -706 338 -721 b 301 -681 325 -716 312 -697 z m 333 -461 b 91 -192 265 -372 145 -271 b 48 -73 66 -154 53 -111 l 48 -73 l 50 -73 b 271 -232 124 -73 217 -163 b 340 -419 327 -305 340 -364 b 337 -468 340 -435 338 -452 b 333 -461 336 -465 334 -464 z m 333 -192 b 91 84 265 -102 145 4 b 48 200 65 121 53 164 l 48 200 l 50 200 b 271 42 124 200 217 109 b 340 -147 327 -32 340 -92 b 337 -197 340 -164 338 -181 b 333 -192 336 -196 334 -194 z"
                },
                flag128thDown: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -591,
                    y_max: 803,
                    ha: 1394,
                    o: "m 0 -828 b 22 -851 0 -838 10 -851 b 43 -828 33 -851 40 -840 b 167 -580 65 -678 109 -635 b 445 -131 243 -508 445 -397 b 431 36 445 -79 439 -22 b 441 108 436 60 439 85 b 441 137 441 117 441 127 b 441 147 441 140 441 144 b 423 275 441 193 432 236 b 441 377 433 310 438 344 b 441 406 441 387 441 396 b 441 418 441 410 441 413 b 423 546 441 464 432 507 b 441 649 432 582 438 616 b 441 675 441 658 441 667 b 441 687 441 680 441 684 b 425 808 441 730 433 772 b 441 919 435 840 441 876 b 327 1149 441 1032 374 1112 b 304 1156 321 1153 312 1156 b 287 1152 298 1156 292 1155 b 279 1145 281 1149 279 1148 b 294 1129 279 1140 288 1135 b 382 930 344 1076 382 1027 b 327 789 382 877 364 832 b 22 598 226 672 86 612 b 0 559 12 593 0 562 z m 314 -37 b 50 -200 258 -107 179 -153 b 91 -102 58 -168 71 -132 b 347 128 145 -23 272 45 b 382 176 360 143 372 160 b 383 151 383 167 383 160 b 314 -37 383 79 359 19 z m 314 232 b 50 69 258 163 179 117 b 91 171 56 101 69 138 b 347 402 145 251 272 317 b 382 449 360 416 372 432 b 383 420 383 439 383 429 b 314 232 383 347 359 288 z m 163 517 b 366 693 248 589 327 642 b 382 716 372 700 377 708 b 383 693 383 708 383 700 b 314 505 382 621 359 560 b 53 343 258 436 179 390 b 56 363 55 350 56 357 b 163 517 66 399 81 449 z m 52 -467 b 91 -372 59 -435 71 -402 b 347 -141 145 -292 272 -225 b 384 -89 361 -125 374 -108 b 324 -301 382 -194 361 -255 b 52 -467 235 -410 122 -446 z"
                },
                accidentalFlat: {
                    x_min: 0,
                    x_max: 203,
                    y_min: -176,
                    y_max: 453,
                    ha: 629,
                    o: "m 289 114 b 173 223 281 170 246 223 b 52 170 101 223 59 179 l 58 632 b 37 652 58 644 49 652 l 20 652 b 0 632 9 652 0 644 l 7 -233 b 27 -253 7 -245 16 -253 b 39 -251 30 -253 36 -252 b 216 -114 45 -248 138 -202 b 292 78 271 -52 292 19 b 289 114 292 91 291 102 z m 190 58 b 148 -85 190 36 184 -30 b 48 -183 124 -122 75 -161 l 52 98 b 134 153 55 111 76 153 b 190 73 186 153 190 104 b 190 58 190 66 190 62 z"
                },
                accidentalNatural: {
                    x_min: 0,
                    x_max: 171,
                    y_min: -323,
                    y_max: 325,
                    ha: 648,
                    o: "m 239 264 b 228 268 236 266 232 268 b 222 266 226 268 223 266 l 40 216 l 40 468 l 0 468 l 0 -245 b 20 -264 0 -256 9 -264 b 26 -264 22 -264 24 -264 l 207 -213 l 207 -465 l 246 -465 b 246 248 246 -226 246 1 b 239 264 246 253 243 261 z m 40 -140 l 40 96 l 207 144 l 207 -94 z"
                },
                accidentalSharp: {
                    x_min: 0,
                    x_max: 244,
                    y_min: -333,
                    y_max: 334,
                    ha: 667,
                    o: "m 336 151 b 351 171 344 153 351 163 l 351 256 b 331 276 351 268 343 276 b 328 276 330 276 330 276 l 281 266 l 281 481 l 240 481 l 240 258 l 112 232 l 112 435 l 72 435 l 72 223 l 16 212 b 0 192 7 210 0 200 l 0 189 l 0 105 l 0 108 b 20 88 0 96 9 88 b 24 88 22 88 23 88 l 72 98 l 72 -140 l 16 -151 b 0 -171 7 -153 0 -163 l 0 -255 b 20 -275 0 -266 9 -275 b 24 -275 22 -275 23 -275 l 72 -265 l 72 -480 l 112 -480 l 112 -256 l 240 -230 l 240 -433 l 281 -433 l 281 -222 l 336 -212 b 351 -192 344 -210 351 -200 l 351 -107 b 331 -86 351 -95 343 -86 b 328 -86 330 -86 330 -86 l 281 -96 l 281 141 z m 112 107 l 240 132 l 240 -105 l 112 -132 z"
                },
                accidentalDoubleSharp: {
                    x_min: 0,
                    x_max: 275,
                    y_min: -137,
                    y_max: 138,
                    ha: 275,
                    o: "m 360 73 l 376 73 b 396 94 387 73 396 82 l 396 179 b 376 199 396 190 387 199 l 291 199 b 271 179 279 199 271 190 l 271 161 l 271 102 l 200 30 l 196 30 l 124 102 l 124 179 b 105 199 124 190 117 199 l 20 199 b 0 179 9 199 0 190 l 0 94 b 20 73 0 82 9 73 l 35 73 l 36 73 l 96 73 l 167 3 l 167 -1 l 96 -73 l 36 -73 l 35 -73 l 20 -73 b 0 -92 9 -73 0 -81 l 0 -177 b 20 -197 0 -189 9 -197 l 105 -197 b 124 -177 117 -197 124 -189 l 124 -101 l 196 -32 l 200 -32 l 271 -101 l 271 -161 l 271 -163 l 271 -177 b 291 -197 271 -189 279 -197 l 376 -197 b 396 -177 387 -197 396 -189 l 396 -92 b 376 -73 396 -81 387 -73 l 361 -73 l 360 -73 l 300 -73 l 228 -1 l 228 1 l 300 73 z"
                },
                accidentalDoubleFlat: {
                    x_min: 0,
                    x_max: 371,
                    y_min: -176,
                    y_max: 453,
                    ha: 629,
                    o: "m 531 115 b 415 223 523 171 488 223 b 294 171 343 223 301 180 l 300 632 b 279 652 300 644 291 652 l 262 652 b 242 632 251 652 242 644 l 246 199 b 173 223 228 213 204 223 b 52 170 101 223 59 179 l 58 632 b 37 652 58 644 49 652 l 20 652 b 0 632 9 652 0 644 l 7 -233 b 27 -253 7 -245 16 -253 b 39 -249 30 -253 36 -251 b 216 -114 45 -246 138 -202 b 248 -69 226 -102 239 -82 l 249 -233 b 269 -253 249 -245 258 -253 b 281 -249 272 -253 278 -251 b 458 -112 287 -246 380 -200 b 534 79 513 -50 534 20 b 531 115 534 92 533 104 z m 190 58 b 148 -85 190 36 184 -30 b 48 -183 124 -122 75 -161 l 52 98 b 134 153 55 111 76 153 b 190 73 186 153 190 104 b 190 58 190 66 190 62 z m 432 58 b 390 -85 432 36 426 -30 b 289 -183 366 -122 317 -161 l 294 98 b 376 153 297 111 318 153 b 432 73 428 153 432 104 b 432 58 432 66 432 62 z"
                },
                accidentalParensLeft: {
                    x_min: 0,
                    x_max: 75,
                    y_min: -212,
                    y_max: 209,
                    ha: 421,
                    o: "m 98 -305 b 104 -302 101 -304 102 -304 b 108 -295 107 -301 108 -298 b 107 -289 108 -294 108 -292 b 40 10 107 -288 40 -160 b 107 288 40 95 58 192 b 108 292 108 289 108 291 b 104 300 108 295 107 298 b 96 301 101 301 99 302 b 91 298 94 301 92 300 b 0 0 86 292 0 174 b 91 -301 0 -174 86 -295 b 98 -305 92 -304 95 -305 z"
                },
                accidentalParensRight: {
                    x_min: 0,
                    x_max: 75,
                    y_min: -209,
                    y_max: 212,
                    ha: 421,
                    o: "m 10 305 b 4 302 7 304 6 304 b 0 295 1 301 0 298 b 1 289 0 294 0 292 b 68 -10 1 288 68 160 b 1 -288 68 -95 50 -192 b 0 -292 0 -289 0 -291 b 4 -300 0 -295 1 -298 b 12 -301 7 -301 9 -302 b 17 -298 14 -301 16 -300 b 108 0 22 -292 108 -174 b 17 301 108 174 22 295 b 10 305 16 304 13 305 z"
                },
                accidentalQuarterToneFlatStein: {
                    x_min: 0,
                    x_max: 193,
                    y_min: -176,
                    y_max: 452,
                    ha: 628,
                    o: "m 0 84 b 107 -145 0 -26 65 -105 b 245 -249 166 -202 245 -249 b 253 -253 248 -251 249 -253 b 272 -235 264 -253 272 -245 l 278 632 b 259 651 278 642 269 651 l 248 651 b 229 632 238 651 229 642 l 232 174 b 125 217 223 186 192 217 b 0 84 53 217 0 173 z m 148 154 b 232 102 212 154 232 115 b 233 107 232 99 233 102 l 235 -179 b 134 -72 207 -156 160 -111 b 92 58 98 -17 92 36 b 92 75 92 62 92 68 b 148 154 92 105 96 154 z"
                },
                accidentalThreeQuarterTonesFlatZimmermann: {
                    x_min: 0,
                    x_max: 422,
                    y_min: -176,
                    y_max: 452,
                    ha: 628,
                    o: "m 608 84 b 482 217 608 173 554 217 b 376 174 416 217 384 186 l 379 632 b 360 651 379 642 370 651 l 348 651 b 330 632 338 651 330 642 l 336 -235 b 354 -253 336 -245 344 -253 b 363 -249 359 -253 360 -251 b 501 -145 363 -249 442 -202 b 608 84 543 -105 608 -26 z m 459 154 b 516 75 511 154 516 105 b 516 58 516 68 516 62 b 474 -72 516 36 510 -17 b 373 -179 448 -111 400 -156 l 374 107 b 376 102 374 102 376 99 b 459 154 376 115 396 154 z m 0 84 b 107 -145 0 -26 65 -105 b 245 -249 166 -202 245 -249 b 253 -253 248 -251 249 -253 b 272 -235 264 -253 272 -245 l 278 632 b 259 651 278 642 269 651 l 248 651 b 229 632 238 651 229 642 l 232 174 b 125 217 223 186 192 217 b 0 84 53 217 0 173 z m 148 154 b 232 102 212 154 232 115 b 233 107 232 99 233 102 l 235 -179 b 134 -72 207 -156 160 -111 b 92 58 98 -17 92 36 b 92 75 92 62 92 68 b 148 154 92 105 96 154 z"
                },
                accidentalQuarterToneSharpStein: {
                    x_min: 0,
                    x_max: 180,
                    y_min: -316,
                    y_max: 320,
                    ha: 636,
                    o: "m 243 144 b 259 164 252 145 259 156 l 259 249 b 239 269 259 261 251 269 b 235 268 238 269 236 268 l 150 251 l 150 461 l 109 461 l 109 242 l 16 222 b 0 203 7 220 0 212 l 0 120 b 20 99 0 108 9 99 b 24 99 22 99 23 99 l 109 117 l 109 -121 l 16 -141 b 0 -160 7 -143 0 -151 l 0 -243 b 20 -264 0 -255 9 -264 b 24 -264 22 -264 23 -264 l 109 -246 l 109 -455 l 150 -455 l 150 -238 l 243 -219 b 259 -199 252 -217 259 -207 l 259 -114 b 239 -95 259 -102 251 -95 b 235 -95 238 -95 236 -95 l 150 -112 l 150 125 z"
                },
                accidentalThreeQuarterTonesSharpStein: {
                    x_min: 0,
                    x_max: 290,
                    y_min: -328,
                    y_max: 339,
                    ha: 667,
                    o: "m 400 158 b 416 179 409 160 416 170 l 416 264 b 397 284 416 275 409 284 b 393 284 396 284 395 284 l 348 274 l 348 488 l 308 488 l 308 265 l 223 248 l 223 465 l 184 465 l 184 240 l 108 225 l 108 442 l 69 442 l 69 216 l 16 204 b 0 186 7 203 0 194 l 0 102 b 20 82 0 91 9 82 b 24 82 22 82 23 82 l 69 92 l 69 -147 l 16 -158 b 0 -177 7 -160 0 -168 l 0 -261 b 20 -281 0 -272 9 -281 b 24 -281 22 -281 23 -281 l 69 -272 l 69 -472 l 108 -472 l 108 -264 l 184 -248 l 184 -451 l 223 -451 l 223 -240 l 308 -223 l 308 -426 l 348 -426 l 348 -215 l 400 -204 b 418 -184 409 -203 418 -193 l 418 -99 b 397 -79 418 -88 409 -79 b 393 -79 396 -79 395 -79 l 348 -89 l 348 148 z m 184 -122 l 108 -138 l 108 99 l 184 115 z m 223 122 l 308 140 l 308 -98 l 223 -115 z"
                },
                accidentalBuyukMucennebFlat: {
                    x_min: 0,
                    x_max: 277,
                    y_min: -176,
                    y_max: 454,
                    ha: 630,
                    o: "m 396 115 b 279 225 387 173 354 225 b 158 171 204 225 164 179 l 160 317 l 336 419 l 336 482 l 161 380 l 161 488 l 336 590 l 336 654 l 163 552 l 164 634 b 144 654 164 645 156 654 l 127 654 b 107 634 115 654 107 645 l 108 520 l 0 456 l 0 393 l 108 456 l 109 350 l 0 285 l 0 222 l 109 287 l 114 -235 b 134 -253 114 -246 122 -253 b 145 -251 138 -253 141 -252 b 323 -114 145 -251 242 -204 b 399 79 377 -52 399 20 b 396 115 399 92 397 104 z m 297 58 b 255 -85 297 36 291 -30 b 154 -184 230 -122 181 -163 l 158 96 b 240 153 161 109 181 153 b 297 73 292 153 297 104 b 297 58 297 66 297 62 z"
                },
                accidentalBuyukMucennebSharp: {
                    x_min: 0,
                    x_max: 348,
                    y_min: -332,
                    y_max: 334,
                    ha: 666,
                    o: "m 494 121 b 482 125 491 122 485 125 b 478 125 481 125 480 125 l 354 91 l 354 148 l 412 164 b 425 183 419 166 425 176 l 425 268 b 408 287 425 278 418 287 b 402 285 406 287 403 285 l 354 272 l 354 481 l 317 481 l 317 262 l 186 226 l 186 436 l 148 436 l 148 216 l 89 200 b 76 183 82 199 76 190 l 76 98 b 84 84 76 92 79 86 b 95 81 86 82 92 81 b 99 81 96 81 98 81 l 148 94 l 148 35 l 14 -1 b 0 -20 7 -3 0 -13 l 0 -104 b 7 -118 0 -109 3 -115 b 19 -122 10 -120 16 -122 b 23 -121 20 -122 22 -121 l 148 -88 l 148 -147 l 89 -163 b 76 -180 82 -164 76 -173 l 76 -181 l 76 -265 b 95 -282 76 -275 85 -282 b 99 -282 96 -282 98 -282 l 148 -269 l 148 -478 l 186 -478 l 186 -259 l 317 -225 l 317 -433 l 354 -433 l 354 -215 l 412 -199 b 425 -181 419 -197 425 -189 l 425 -95 b 418 -81 425 -89 422 -84 b 406 -76 415 -79 409 -76 b 402 -78 405 -76 403 -78 l 354 -91 l 354 -32 l 488 4 b 501 22 495 6 501 14 l 501 107 b 494 121 501 112 498 118 z m 317 138 l 317 81 l 186 45 l 186 104 z m 186 -137 l 186 -78 l 317 -42 l 317 -101 z"
                },
                accidentalBakiyeFlat: {
                    x_min: 0,
                    x_max: 277,
                    y_min: -176,
                    y_max: 454,
                    ha: 630,
                    o: "m 396 115 b 279 225 387 173 354 225 b 158 171 204 225 164 179 l 161 348 l 336 452 l 336 516 l 161 413 l 164 634 b 144 654 164 645 156 654 l 127 654 b 107 634 115 654 107 645 l 109 382 l 0 318 l 0 255 l 109 318 l 114 -235 b 134 -253 114 -246 122 -253 b 145 -251 138 -253 143 -252 b 323 -114 145 -251 242 -204 b 399 79 377 -52 399 20 b 396 115 399 92 397 104 z m 297 58 b 255 -85 297 36 291 -30 b 156 -184 230 -122 183 -163 l 158 96 b 240 153 161 109 181 153 b 297 73 292 153 297 104 b 297 58 297 66 297 62 z"
                },
                accidentalKucukMucennebSharp: {
                    x_min: 0,
                    x_max: 348,
                    y_min: -316,
                    y_max: 318,
                    ha: 634,
                    o: "m 494 121 b 482 125 491 124 487 125 b 478 124 481 125 480 124 l 269 68 l 269 127 l 412 164 b 425 181 420 167 425 173 l 425 266 b 418 282 425 272 422 279 b 406 285 415 285 410 285 b 402 285 405 285 403 285 l 269 249 l 269 458 l 232 458 l 232 239 l 89 200 b 76 181 81 197 76 190 l 76 98 b 84 84 76 92 79 86 b 95 79 86 81 91 79 b 99 81 96 79 98 81 l 232 115 l 232 58 l 14 -3 b 0 -20 6 -6 0 -12 l 0 -104 b 7 -118 0 -109 3 -115 b 19 -122 10 -121 14 -122 b 23 -122 20 -122 22 -122 l 232 -66 l 232 -124 l 89 -163 b 76 -180 81 -166 76 -171 l 76 -264 b 84 -279 76 -269 79 -276 b 95 -282 86 -282 91 -282 b 99 -282 96 -282 98 -282 l 232 -246 l 232 -455 l 269 -455 l 269 -236 l 412 -199 b 425 -180 420 -196 425 -189 l 425 -95 b 418 -81 425 -89 422 -84 b 406 -76 415 -78 410 -76 b 402 -78 405 -76 403 -78 l 269 -114 l 269 -55 l 487 4 b 501 22 495 7 501 13 l 501 107 b 494 121 501 112 498 118 z"
                },
                articAccentAbove: {
                    x_min: 0,
                    x_max: 361,
                    y_min: 0,
                    y_max: 235,
                    ha: 235,
                    o: "m 26 337 b 20 338 24 337 22 338 b 0 318 9 338 0 330 l 0 285 b 14 266 0 276 7 269 l 323 170 l 14 72 b 0 53 7 69 0 62 l 0 20 b 20 0 0 9 9 0 b 26 1 22 0 24 1 l 505 150 b 520 170 513 153 520 161 b 505 189 520 179 513 186 z"
                },
                articAccentBelow: {
                    x_min: 0,
                    x_max: 361,
                    y_min: -235,
                    y_max: 0,
                    ha: 235,
                    o: "m 26 -1 b 20 0 24 -1 22 0 b 0 -20 9 0 0 -9 l 0 -53 b 14 -72 0 -62 7 -69 l 323 -168 l 14 -266 b 0 -285 7 -269 0 -276 l 0 -318 b 20 -338 0 -330 9 -338 b 26 -337 22 -338 24 -337 l 505 -189 b 520 -168 513 -186 520 -177 b 505 -150 520 -160 513 -153 z"
                },
                articTenutoAbove: {
                    x_min: 0,
                    x_max: 316,
                    y_min: 0,
                    y_max: 46,
                    ha: 46,
                    o: "m 20 66 b 0 46 9 66 0 58 l 0 20 b 20 0 0 9 9 0 l 435 0 b 455 20 446 0 455 9 l 455 46 b 435 66 455 58 446 66 z"
                },
                articTenutoBelow: {
                    x_min: 0,
                    x_max: 316,
                    y_min: -46,
                    y_max: 0,
                    ha: 46,
                    o: "m 20 0 b 0 -20 9 0 0 -9 l 0 -46 b 20 -66 0 -58 9 -66 l 435 -66 b 455 -46 446 -66 455 -58 l 455 -20 b 435 0 455 -9 446 0 z"
                },
                articStaccatoAbove: {
                    x_min: 0,
                    x_max: 78,
                    y_min: 0,
                    y_max: 78,
                    ha: 78,
                    o: "m 16 16 b 96 16 39 -6 73 -6 b 96 95 118 39 118 73 b 16 95 73 118 39 118 b 16 16 -6 73 -6 39 z"
                },
                articStaccatoBelow: {
                    x_min: 0,
                    x_max: 78,
                    y_min: -78,
                    y_max: 0,
                    ha: 78,
                    o: "m 16 -96 b 96 -96 39 -118 73 -118 b 96 -17 118 -73 118 -39 b 16 -17 73 6 39 6 b 16 -96 -6 -39 -6 -73 z"
                },
                articStaccatissimoAbove: {
                    x_min: 0,
                    x_max: 127,
                    y_min: 0,
                    y_max: 248,
                    ha: 248,
                    o: "m 163 357 b 150 353 154 357 150 353 l 99 300 b 92 295 96 297 95 295 b 85 300 89 295 88 297 l 35 353 b 22 357 35 353 30 357 b 0 338 13 357 0 351 b 73 22 0 323 73 22 b 92 0 75 16 78 0 b 111 22 107 0 109 16 b 183 338 111 22 183 323 b 163 357 183 351 171 357 z"
                },
                articStaccatissimoBelow: {
                    x_min: 0,
                    x_max: 127,
                    y_min: -248,
                    y_max: 0,
                    ha: 248,
                    o: "m 20 -357 b 33 -353 29 -357 33 -353 l 84 -300 b 91 -295 86 -297 88 -295 b 98 -300 94 -295 95 -297 l 148 -353 b 161 -357 148 -353 153 -357 b 183 -338 170 -357 183 -351 b 109 -22 183 -323 109 -22 b 91 0 108 -16 105 0 b 72 -22 76 0 73 -16 b 0 -338 72 -22 0 -323 b 20 -357 0 -351 12 -357 z"
                },
                articMarcatoAbove: {
                    x_min: 1,
                    x_max: 296,
                    y_min: 0,
                    y_max: 253,
                    ha: 253,
                    o: "m 36 10 l 173 239 l 298 10 b 317 0 301 4 310 0 l 408 0 b 426 20 419 0 426 9 b 425 30 426 23 426 27 l 230 356 b 213 364 226 361 222 363 b 196 356 207 364 199 361 l 1 30 z"
                },
                articMarcatoBelow: {
                    x_min: 0,
                    x_max: 295,
                    y_min: -253,
                    y_max: 0,
                    ha: 253,
                    o: "m 390 -10 l 253 -239 l 128 -10 b 109 0 125 -4 117 0 l 19 0 b 0 -20 7 0 0 -9 b 1 -30 0 -23 0 -27 l 196 -356 b 213 -364 200 -361 204 -363 b 230 -356 219 -364 228 -361 l 425 -30 z"
                },
                fermataAbove: {
                    x_min: 0,
                    x_max: 622,
                    y_min: 0,
                    y_max: 368,
                    ha: 368,
                    o: "m 778 374 b 448 530 642 521 523 530 b 120 374 373 530 255 521 b 0 65 49 297 0 143 b 20 19 0 37 6 19 b 161 265 60 19 40 143 b 445 373 268 372 410 373 b 448 373 446 373 446 373 b 451 373 449 373 449 373 b 734 265 485 373 628 372 b 876 19 855 143 835 19 b 896 65 890 19 896 36 b 778 374 896 143 848 298 z m 348 99 b 448 0 348 45 393 0 b 547 99 503 0 547 45 b 448 199 547 154 503 199 b 348 99 393 199 348 154 z"
                },
                fermataBelow: {
                    x_min: 0,
                    x_max: 622,
                    y_min: -368,
                    y_max: 0,
                    ha: 368,
                    o: "m 778 -374 b 896 -65 848 -298 896 -143 b 876 -19 896 -36 890 -19 b 734 -265 835 -19 855 -143 b 451 -373 628 -372 485 -373 b 448 -373 449 -373 449 -373 b 445 -373 446 -373 446 -373 b 161 -265 410 -373 268 -372 b 20 -19 40 -143 60 -19 b 0 -65 6 -19 0 -37 b 120 -374 0 -143 49 -297 b 448 -530 255 -521 373 -530 b 778 -374 523 -530 642 -521 z m 348 -99 b 448 -199 348 -154 393 -199 b 547 -99 503 -199 547 -154 b 448 0 547 -45 503 0 b 348 -99 393 0 348 -45 z"
                },
                fermataLongAbove: {
                    x_min: 0,
                    x_max: 623,
                    y_min: 0,
                    y_max: 368,
                    ha: 368,
                    o: "m 40 0 l 40 399 l 858 399 l 858 0 l 897 0 l 897 510 b 877 530 897 521 888 530 l 20 530 b 0 510 9 530 0 521 l 0 0 z m 350 148 b 449 49 350 94 395 49 b 547 148 504 49 547 94 b 449 248 547 203 504 248 b 350 148 395 248 350 203 z"
                },
                fermataLongBelow: {
                    x_min: 0,
                    x_max: 623,
                    y_min: -368,
                    y_max: 0,
                    ha: 368,
                    o: "m 0 -510 b 20 -530 0 -521 9 -530 l 877 -530 b 897 -510 888 -530 897 -521 l 897 0 l 858 0 l 858 -399 l 40 -399 l 40 0 l 0 0 z m 350 -148 b 449 -248 350 -203 395 -248 b 547 -148 504 -248 547 -203 b 449 -49 547 -94 504 -49 b 350 -148 395 -49 350 -94 z"
                },
                fermataVeryLongAbove: {
                    x_min: 0,
                    x_max: 842,
                    y_min: 0,
                    y_max: 549,
                    ha: 549,
                    o: "m 276 0 l 276 399 l 936 399 l 936 0 l 976 0 l 976 510 b 956 530 976 521 968 530 l 256 530 b 236 510 245 530 236 521 l 236 0 z m 507 148 b 606 49 507 94 552 49 b 706 148 661 49 706 94 b 606 248 706 203 661 248 b 507 148 552 248 507 203 z m 40 0 l 40 661 l 1172 661 l 1172 0 l 1212 0 l 1212 772 b 1192 791 1212 783 1204 791 l 20 791 b 0 772 9 791 0 783 l 0 0 z"
                },
                fermataVeryLongBelow: {
                    x_min: 0,
                    x_max: 842,
                    y_min: -549,
                    y_max: 0,
                    ha: 549,
                    o: "m 236 -510 b 256 -530 236 -521 245 -530 l 956 -530 b 976 -510 968 -530 976 -521 l 976 0 l 936 0 l 936 -399 l 276 -399 l 276 0 l 236 0 z m 507 -148 b 606 -248 507 -203 552 -248 b 706 -148 661 -248 706 -203 b 606 -49 706 -94 661 -49 b 507 -148 552 -49 507 -94 z m 0 -772 b 20 -791 0 -783 9 -791 l 1192 -791 b 1212 -772 1204 -791 1212 -783 l 1212 0 l 1172 0 l 1172 -661 l 40 -661 l 40 0 l 0 0 z"
                },
                fermataShortAbove: {
                    x_min: 0,
                    x_max: 642,
                    y_min: 0,
                    y_max: 454,
                    ha: 454,
                    o: "m 363 148 b 462 49 363 94 408 49 b 562 148 517 49 562 94 b 462 248 562 203 517 248 b 363 148 408 248 363 203 z m 477 645 b 461 654 474 649 467 654 b 445 645 455 654 448 649 l 4 32 b 0 20 3 29 0 23 b 20 0 0 9 9 0 l 82 0 b 98 9 88 0 95 4 l 461 514 l 827 9 b 842 0 829 4 837 0 l 904 0 b 924 20 916 0 924 9 b 920 32 924 23 922 29 z"
                },
                fermataShortBelow: {
                    x_min: 0,
                    x_max: 642,
                    y_min: -454,
                    y_max: 0,
                    ha: 454,
                    o: "m 363 -148 b 462 -248 363 -203 408 -248 b 562 -148 517 -248 562 -203 b 462 -49 562 -94 517 -49 b 363 -148 408 -49 363 -94 z m 920 -32 b 924 -20 922 -29 924 -23 b 904 0 924 -9 916 0 l 842 0 b 827 -9 837 0 829 -4 l 461 -514 l 98 -9 b 82 0 95 -4 88 0 l 20 0 b 0 -20 9 0 0 -9 b 4 -32 0 -23 3 -29 l 445 -645 b 461 -654 448 -649 455 -654 b 477 -645 467 -654 474 -649 z"
                },
                breathMarkComma: {
                    x_min: 0,
                    x_max: 191,
                    y_min: 0,
                    y_max: 321,
                    ha: 321,
                    o: "m 82 0 b 275 285 215 92 275 183 b 115 462 275 396 212 462 b 0 356 46 462 0 413 b 115 246 0 294 53 246 b 181 258 157 246 177 256 b 192 261 184 259 189 261 b 199 259 194 261 196 261 b 203 245 202 258 203 253 b 48 43 203 183 147 112 z"
                },
                caesura: {
                    x_min: 0,
                    x_max: 380,
                    y_min: 0,
                    y_max: 490,
                    ha: 490,
                    o: "m 285 706 b 285 706 285 706 285 706 b 271 696 279 706 274 701 l 1 22 b 0 16 0 20 0 17 b 16 0 0 7 7 0 l 50 0 b 65 10 56 0 62 4 l 334 684 b 336 690 334 685 336 688 b 320 706 336 698 328 706 z m 213 22 b 212 16 213 20 212 17 b 228 0 212 7 219 0 l 262 0 b 276 10 268 0 274 4 l 546 684 b 547 690 547 685 547 688 b 531 706 547 698 540 706 l 497 706 b 482 696 491 706 485 701 z"
                },
                caesuraCurved: {
                    x_min: 0,
                    x_max: 368,
                    y_min: 0,
                    y_max: 491,
                    ha: 491,
                    o: "m 262 707 b 245 693 253 707 246 701 b 1 26 233 603 177 348 b 0 17 0 23 0 20 b 16 0 0 9 6 0 b 30 7 22 0 27 3 b 318 687 259 341 304 602 b 318 690 318 688 318 688 b 301 707 318 698 310 707 z m 474 707 b 458 693 465 707 459 701 b 213 26 446 603 389 348 b 212 19 212 23 212 20 b 229 0 212 9 219 0 b 243 7 235 0 240 3 b 530 687 472 341 516 602 b 530 690 530 688 530 688 b 514 707 530 698 523 707 z"
                },
                restMaxima: {
                    x_min: 0,
                    x_max: 450,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 158 -360 b 180 -338 170 -360 180 -350 l 180 338 b 158 360 180 350 170 360 l 22 360 b 0 338 9 360 0 350 l 0 -338 b 22 -360 0 -350 9 -360 z m 626 -360 b 648 -338 638 -360 648 -350 l 648 338 b 626 360 648 350 638 360 l 490 360 b 468 338 477 360 468 350 l 468 -338 b 490 -360 468 -350 477 -360 z"
                },
                restDoubleWhole: {
                    x_min: 0,
                    x_max: 125,
                    y_min: -11,
                    y_max: 262,
                    ha: 273,
                    o: "m 158 -16 b 180 6 171 -16 180 -6 l 180 356 b 158 377 180 367 171 377 l 22 377 b 0 356 10 377 0 367 l 0 6 b 22 -16 0 -6 10 -16 z"
                },
                restWhole: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -131,
                    y_max: 5,
                    ha: 136,
                    o: "m 20 7 b 0 -13 9 7 0 -1 l 0 -168 b 20 -189 0 -180 9 -189 l 448 -189 b 468 -168 459 -189 468 -180 l 468 -13 b 448 7 468 -1 459 7 z"
                },
                restWholeLegerLine: {
                    x_min: -139,
                    x_max: 464,
                    y_min: -122,
                    y_max: 14,
                    ha: 136,
                    o: "m 449 20 l 19 20 l -200 20 l -200 -20 l 0 -20 l 0 -156 b 19 -176 0 -167 7 -176 l 449 -176 b 468 -156 461 -176 468 -167 l 468 -20 l 668 -20 l 668 20 z"
                },
                restHalf: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -4,
                    y_max: 132,
                    ha: 136,
                    o: "m 0 14 b 20 -6 0 -6 0 -6 l 448 -6 b 468 14 468 -6 468 -6 l 468 170 b 448 190 468 190 468 190 l 20 190 b 0 170 0 190 0 190 z"
                },
                restHalfLegerLine: {
                    x_min: -139,
                    x_max: 464,
                    y_min: -14,
                    y_max: 122,
                    ha: 136,
                    o: "m 668 20 l 468 20 l 468 156 b 449 176 468 167 461 176 l 19 176 b 0 156 7 176 0 167 l 0 20 l -200 20 l -200 -20 l 19 -20 l 449 -20 l 668 -20 z"
                },
                restQuarter: {
                    x_min: 0,
                    x_max: 235,
                    y_min: -331,
                    y_max: 401,
                    ha: 732,
                    o: "m 331 -239 b 323 -229 330 -238 327 -235 l 157 -24 b 154 -16 156 -23 154 -19 b 157 -3 154 -12 156 -6 l 304 219 b 307 229 305 222 307 226 l 307 242 b 302 253 307 246 305 251 l 69 569 b 55 577 69 569 63 577 b 43 573 50 577 48 576 b 36 559 37 569 36 563 b 40 543 36 550 40 543 l 150 393 b 154 376 153 389 154 383 b 150 359 154 370 153 363 l 4 137 b 1 125 3 134 1 128 l 1 112 b 6 101 1 108 3 104 l 167 -99 b 131 -95 161 -98 148 -95 b 49 -124 107 -95 75 -101 b 0 -229 17 -153 0 -193 b 16 -285 0 -249 4 -269 b 154 -468 46 -331 154 -468 b 171 -477 154 -468 161 -477 b 180 -474 174 -477 177 -477 b 190 -456 187 -468 190 -462 b 186 -444 190 -451 187 -446 b 135 -353 181 -436 135 -353 b 125 -307 135 -353 125 -333 b 150 -246 125 -288 131 -265 b 206 -223 167 -229 187 -223 b 252 -236 225 -223 240 -229 l 308 -272 b 320 -275 308 -272 314 -275 b 334 -268 325 -275 330 -274 b 338 -255 337 -262 338 -259 b 334 -243 338 -251 337 -248 z"
                },
                rest8th: {
                    x_min: 0,
                    x_max: 276,
                    y_min: -255,
                    y_max: 204,
                    ha: 459,
                    o: "m 384 292 b 379 294 383 292 380 294 b 360 282 370 294 363 289 b 245 141 354 274 310 189 b 180 112 226 127 203 117 b 206 181 196 131 206 154 b 104 284 206 238 160 284 b 0 181 46 284 0 238 b 65 85 0 137 27 101 b 144 68 86 75 115 68 b 269 109 186 68 230 81 b 320 157 287 122 304 140 l 156 -356 l 194 -367 l 396 268 b 397 275 397 269 397 272 b 384 292 397 282 393 288 z"
                },
                rest16th: {
                    x_min: 1,
                    x_max: 344,
                    y_min: -507,
                    y_max: 204,
                    ha: 711,
                    o: "m 494 268 b 495 275 495 271 495 272 b 482 292 495 282 491 289 b 475 294 480 294 477 294 b 456 282 467 294 461 289 b 285 115 422 213 364 135 b 310 184 302 135 310 158 b 203 284 310 240 259 284 b 104 177 145 281 104 233 b 171 84 105 134 134 98 b 252 69 197 72 225 69 b 423 164 324 72 380 108 l 423 164 l 359 -65 b 183 -245 338 -132 256 -226 b 207 -176 199 -225 207 -200 b 102 -76 207 -118 158 -76 b 1 -183 45 -76 1 -125 b 69 -275 1 -226 32 -262 b 150 -289 96 -287 121 -289 b 321 -194 222 -287 278 -251 l 174 -720 l 213 -730 z"
                },
                rest32nd: {
                    x_min: 0,
                    x_max: 391,
                    y_min: -507,
                    y_max: 460,
                    ha: 967,
                    o: "m 217 71 b 408 171 348 71 402 161 l 354 -46 b 184 -240 323 -121 268 -217 b 204 -171 200 -220 204 -197 b 102 -76 204 -114 158 -76 b 0 -177 46 -76 0 -120 b 140 -288 0 -252 63 -288 b 320 -186 216 -288 276 -246 l 189 -721 l 228 -730 l 562 638 b 563 644 563 639 563 642 b 549 661 563 652 557 658 b 543 662 547 662 544 662 b 524 649 534 662 528 657 b 361 487 497 589 431 504 b 383 556 379 508 383 530 b 282 652 383 611 338 652 b 179 549 226 652 179 609 b 249 451 179 505 210 464 b 311 439 268 444 288 441 b 330 441 317 439 323 439 b 498 541 400 445 458 485 l 442 310 b 271 117 413 238 351 137 b 292 186 288 138 292 160 b 189 282 292 243 245 282 b 88 180 132 282 88 238 b 217 71 88 112 153 71 z"
                },
                rest64th: {
                    x_min: 0,
                    x_max: 423,
                    y_min: -758,
                    y_max: 464,
                    ha: 1222,
                    o: "m 207 -1083 l 246 -1092 b 608 644 282 -919 605 634 b 609 649 608 647 609 648 b 595 667 609 658 603 665 b 589 668 593 668 592 668 b 569 654 577 668 575 664 b 474 521 563 644 530 573 b 412 487 456 505 435 494 b 432 546 425 503 432 526 b 328 649 432 606 382 649 b 226 546 275 649 226 608 b 360 438 226 465 300 438 b 501 492 419 438 474 465 b 546 546 527 518 533 526 l 547 547 l 500 323 b 399 161 491 300 452 209 b 337 125 382 144 360 132 b 357 184 350 143 357 134 b 253 288 357 235 317 288 b 151 187 190 288 151 236 b 285 76 151 138 183 76 b 471 184 412 76 465 173 l 423 -45 b 324 -204 413 -69 374 -158 b 262 -240 305 -222 284 -233 b 281 -180 274 -223 281 -212 b 177 -78 281 -147 258 -78 b 75 -180 98 -78 75 -153 b 209 -289 75 -207 88 -289 b 395 -181 330 -289 389 -193 l 350 -397 b 248 -564 337 -449 285 -530 b 186 -599 229 -580 207 -592 b 204 -540 197 -583 204 -563 b 102 -438 204 -501 174 -438 b 0 -540 29 -438 0 -501 b 132 -648 0 -579 24 -648 b 320 -540 266 -648 315 -552 z"
                },
                rest128th: {
                    x_min: -1,
                    x_max: 475,
                    y_min: -759,
                    y_max: 717,
                    ha: 1476,
                    o: "m 677 1028 b 664 1032 672 1031 667 1032 b 644 1018 654 1032 649 1028 b 549 886 638 1008 605 937 b 487 851 531 870 510 858 b 507 910 500 868 507 890 b 403 1014 507 971 456 1014 b 301 910 350 1014 301 972 b 435 802 301 829 374 802 b 576 857 494 802 549 829 b 621 910 602 883 608 890 l 622 912 l 575 687 b 474 526 566 664 527 573 b 412 490 456 508 435 497 b 432 549 425 507 432 498 b 328 652 432 599 392 652 b 226 552 265 652 226 600 b 360 441 226 503 258 441 b 546 549 487 441 540 537 l 498 320 b 399 160 488 295 449 207 b 337 125 380 143 359 131 b 356 184 348 141 356 153 b 252 287 356 217 333 287 b 150 184 173 287 150 212 b 284 76 150 157 163 76 b 469 183 405 76 464 171 l 425 -33 b 323 -200 412 -85 360 -166 b 261 -235 304 -216 282 -228 b 279 -176 272 -219 279 -199 b 177 -72 279 -137 249 -72 b 75 -176 104 -72 75 -137 b 207 -284 75 -215 99 -284 b 395 -176 341 -284 390 -187 l 347 -409 b 248 -566 330 -461 282 -533 b 186 -600 229 -582 207 -593 b 204 -541 197 -583 204 -564 b 102 -438 204 -501 174 -438 b -1 -541 29 -438 -1 -503 b 132 -649 -1 -580 24 -649 b 318 -546 256 -649 307 -567 l 206 -1084 l 245 -1093 b 683 1008 281 -920 680 996 b 684 1015 683 1009 684 1014 b 677 1028 684 1020 683 1024 z"
                },
                dynamicPiano: {
                    x_min: -95,
                    x_max: 317,
                    y_min: -163,
                    y_max: 263,
                    ha: 426,
                    o: "m 186 -235 l 186 -206 l 78 -206 l 161 26 l 166 16 b 229 -29 166 16 180 -16 b 256 -32 238 -32 248 -32 b 445 166 336 -32 415 49 b 456 246 454 197 456 223 b 374 373 456 343 396 367 b 356 376 369 374 361 376 b 242 314 311 376 266 338 l 238 310 l 235 315 b 154 377 235 315 204 370 b 138 379 148 377 144 379 b 0 226 91 379 42 346 l 26 213 b 63 301 32 232 46 278 b 102 328 72 314 89 325 b 108 328 104 328 107 328 b 120 325 112 328 117 327 b 127 304 125 321 127 314 b 94 192 127 269 101 206 l -49 -206 l -137 -206 l -137 -235 z m 226 17 b 215 19 223 17 217 17 b 187 81 193 27 187 53 b 204 180 187 125 203 177 b 297 317 217 235 259 295 b 324 325 307 323 315 325 b 336 324 328 325 333 325 b 350 311 341 323 347 317 b 356 278 354 302 356 291 b 333 161 356 239 341 187 b 242 20 314 105 278 37 b 226 17 238 17 230 17 z"
                },
                dynamicMezzo: {
                    x_min: -7,
                    x_max: 374,
                    y_min: -2,
                    y_max: 251,
                    ha: 253,
                    o: "m 488 63 b 467 48 481 50 474 48 b 459 49 464 48 462 48 b 449 65 452 52 449 58 b 461 112 449 76 455 94 b 474 157 464 121 471 150 b 492 281 482 183 492 242 b 491 301 492 288 492 295 b 436 359 484 340 467 359 b 340 307 399 359 359 331 l 337 301 l 334 308 b 272 359 334 308 311 359 b 177 310 232 359 202 343 l 173 304 l 171 311 b 117 360 171 311 153 353 b 96 361 109 361 102 361 b 29 328 60 361 39 340 b -10 252 20 318 0 284 l 12 240 b 68 318 12 240 36 318 b 75 317 71 318 72 318 b 86 295 84 314 86 307 b 59 194 86 275 75 240 b 1 20 59 193 6 33 b 0 13 1 17 0 16 b 3 4 0 10 1 7 b 14 -1 6 1 9 -1 l 36 -1 b 91 -1 58 -1 86 -1 b 107 22 94 -1 101 -1 b 127 99 114 53 121 79 b 235 310 132 121 186 310 b 243 305 238 310 242 308 b 248 289 246 302 248 297 b 216 160 248 265 233 219 b 173 22 194 89 173 22 b 173 16 173 20 173 19 b 176 3 173 12 173 6 b 187 -1 179 0 183 -1 l 266 -1 b 282 16 272 -1 279 0 b 284 26 282 17 284 22 b 392 302 312 228 359 288 b 396 304 393 302 395 304 l 397 304 b 400 302 399 304 399 302 b 408 289 403 301 408 297 b 369 140 408 275 399 217 b 356 75 360 117 356 95 b 370 23 356 55 360 37 b 428 -3 382 6 408 -3 b 536 99 492 -3 517 49 b 539 108 537 102 537 105 l 514 120 b 488 63 514 120 498 81 z"
                },
                dynamicForte: {
                    x_min: -137,
                    x_max: 334,
                    y_min: -193,
                    y_max: 421,
                    ha: 614,
                    o: "m -122 -86 b -197 -161 -161 -86 -197 -122 b -81 -278 -197 -236 -147 -278 b 35 -228 -35 -278 -1 -264 b 202 173 98 -164 167 50 b 238 297 215 219 228 264 l 238 300 l 341 300 b 356 314 350 300 356 305 l 356 346 b 341 360 356 354 350 360 l 256 360 l 256 364 b 330 554 297 511 308 537 b 359 566 341 563 351 566 b 366 564 361 566 364 564 b 380 553 373 563 377 559 b 382 546 382 550 382 549 b 373 528 382 539 379 531 b 351 478 359 517 351 498 b 354 458 351 471 353 465 b 384 426 359 445 370 432 b 410 420 390 423 400 420 b 445 431 420 420 432 423 b 478 472 459 438 474 456 b 481 497 481 480 481 488 b 467 550 481 514 477 533 b 376 605 455 572 422 598 b 351 606 369 606 360 606 b 225 553 317 606 272 595 b 122 363 187 520 154 456 l 122 360 l 13 360 b -1 346 4 360 -1 354 l -1 314 b 13 300 -1 305 4 300 l 102 300 l 102 294 b 66 140 88 236 76 187 b 24 -35 55 86 42 32 l 20 -52 b -53 -235 -10 -170 -19 -212 b -78 -242 -60 -239 -69 -242 b -98 -235 -85 -242 -92 -239 b -105 -222 -102 -232 -105 -228 b -105 -219 -105 -220 -105 -220 b -94 -204 -104 -213 -101 -207 b -58 -144 -66 -193 -58 -167 b -122 -86 -58 -124 -71 -86 z"
                },
                dynamicRinforzando: {
                    x_min: -12,
                    x_max: 230,
                    y_min: 0,
                    y_max: 254,
                    ha: 254,
                    o: "m 272 364 b 200 341 239 364 212 348 b 168 310 187 333 177 321 l 164 304 b 109 363 164 304 151 353 b 88 366 102 364 95 366 b 22 331 52 366 32 343 b -17 255 13 321 -7 287 l 4 243 b 60 321 4 243 29 321 b 68 320 63 321 65 321 b 78 297 75 317 78 308 b 49 180 78 272 65 230 l 0 23 b 0 17 0 22 0 20 b 3 4 0 13 0 7 b 14 0 6 1 10 0 l 94 0 b 109 17 99 0 107 1 b 111 27 109 19 111 23 b 209 302 140 230 186 279 b 225 311 215 308 220 311 b 229 310 226 311 228 311 b 233 304 233 307 233 305 b 233 301 233 302 233 301 b 216 268 220 291 216 279 b 225 243 216 259 219 249 b 262 229 235 232 249 229 b 304 242 279 229 295 235 b 331 308 320 255 331 275 b 272 364 331 341 304 364 z"
                },
                dynamicSforzando: {
                    x_min: 0,
                    x_max: 208,
                    y_min: -5,
                    y_max: 263,
                    ha: 268,
                    o: "m 242 328 b 217 289 222 317 217 300 b 258 249 217 274 230 249 b 298 284 285 249 295 269 b 300 295 300 287 300 291 b 189 379 300 328 272 379 b 49 259 92 379 49 315 b 99 173 49 229 59 196 b 164 137 117 163 140 151 b 194 88 189 122 194 102 b 124 24 194 73 177 24 b 72 46 82 24 72 39 b 73 49 72 48 72 49 b 96 96 78 52 96 62 b 50 150 96 134 72 150 b 0 91 29 150 0 134 b 124 -7 0 26 49 -7 b 282 111 199 -7 282 24 b 171 239 282 197 207 219 b 128 292 135 259 128 268 b 193 347 128 317 156 347 b 242 328 230 347 242 328 z"
                },
                dynamicZ: {
                    x_min: -42,
                    x_max: 239,
                    y_min: -1,
                    y_max: 258,
                    ha: 259,
                    o: "m 229 292 b 235 288 232 292 233 291 b 236 284 236 285 236 285 b 233 278 236 281 235 279 b -42 55 232 276 -4 85 b -60 24 -56 43 -60 33 b -50 4 -60 12 -50 4 b -35 0 -45 1 -40 0 b 9 29 -14 0 1 19 b 50 69 17 43 26 69 b 89 35 75 69 81 50 b 170 -1 104 10 137 -1 b 243 22 197 -1 223 6 b 304 147 288 56 304 118 b 264 196 304 176 294 196 b 226 156 239 196 226 174 b 251 117 226 128 249 122 b 251 108 251 114 251 111 b 243 79 251 98 249 88 b 212 56 236 68 223 56 b 202 59 209 56 204 56 b 163 92 194 63 186 75 b 108 122 140 109 114 120 b 105 125 105 124 105 124 b 107 128 105 127 107 128 b 312 304 107 128 302 294 b 341 340 324 315 336 327 b 344 347 343 341 344 346 l 344 356 b 333 369 343 367 336 369 l 331 369 l 262 363 b 217 361 245 361 230 361 b 156 366 193 361 174 363 b 114 372 147 367 125 372 b 107 370 111 372 108 370 b 86 344 98 367 89 360 b 37 222 72 265 42 232 b 37 219 37 220 37 220 b 50 207 37 213 43 207 l 66 207 b 81 225 75 207 76 215 b 108 291 85 235 105 285 b 118 297 111 297 112 297 b 167 289 125 295 144 291 b 181 289 171 289 177 289 b 229 292 202 289 222 291 z"
                },
                ornamentTrill: {
                    x_min: -12,
                    x_max: 383,
                    y_min: 0,
                    y_max: 383,
                    ha: 383,
                    o: "m 464 396 b 376 359 408 396 376 359 l 364 370 b 346 377 357 377 346 377 l 197 377 l 246 528 b 246 531 246 530 246 531 b 226 552 246 541 236 552 l 213 552 b 199 544 209 552 202 547 b 124 482 196 541 130 487 b 117 471 118 478 117 471 b 84 377 117 471 102 431 l 3 377 b -17 360 -14 377 -17 360 l -17 341 b 3 324 -17 325 3 324 l 66 324 b 0 85 35 229 0 117 b 92 0 0 16 48 0 b 186 35 137 0 186 35 b 194 13 186 35 190 24 b 212 0 199 1 212 0 l 276 0 b 298 16 295 0 298 16 l 298 43 b 321 147 298 75 321 147 l 382 284 b 412 325 382 284 396 311 b 446 341 425 336 438 341 b 452 340 448 341 451 341 b 428 288 432 327 428 305 b 485 233 428 271 446 233 b 552 308 534 233 552 264 b 464 396 552 353 520 396 z m 222 143 b 147 78 210 104 171 78 b 137 79 143 78 140 78 b 121 115 125 85 121 99 b 137 190 121 148 137 190 l 180 324 l 275 324 b 279 320 279 324 279 320 b 222 143 279 320 235 187 z"
                },
                ornamentTurn: {
                    x_min: 0,
                    x_max: 456,
                    y_min: 0,
                    y_max: 232,
                    ha: 232,
                    o: "m 527 334 b 442 269 488 334 442 312 b 501 204 442 228 468 204 b 570 226 533 204 540 226 b 613 164 598 226 613 204 l 613 163 b 550 98 613 127 586 98 b 448 143 508 98 485 109 l 328 255 l 298 284 b 174 334 262 317 223 334 b 0 170 92 334 0 278 b 131 0 0 68 58 0 b 215 65 170 0 215 22 b 156 130 215 107 189 130 b 86 108 124 130 117 108 b 43 170 59 108 43 130 l 43 171 b 108 236 43 207 72 236 b 209 192 150 236 171 225 l 328 79 l 360 50 b 482 0 396 17 433 0 b 657 164 564 0 657 56 b 527 334 657 266 600 334 z"
                },
                ornamentTurnSlash: {
                    x_min: 0,
                    x_max: 456,
                    y_min: -80,
                    y_max: 313,
                    ha: 393,
                    o: "m 527 334 b 442 269 488 334 442 312 b 501 204 442 228 468 204 b 570 226 533 204 540 226 b 613 164 598 226 613 204 l 613 163 b 550 98 613 127 586 98 b 448 143 508 98 485 109 l 354 230 l 354 431 b 336 451 354 442 347 451 l 323 451 b 302 431 311 451 302 442 l 302 279 l 298 284 b 174 334 262 317 223 334 b 0 170 92 334 0 278 b 131 0 0 68 58 0 b 215 65 170 0 215 22 b 156 130 215 107 189 130 b 86 108 124 130 117 108 b 43 170 59 108 43 130 l 43 171 b 108 236 43 207 72 236 b 209 192 150 236 171 225 l 302 104 l 302 -96 b 323 -115 302 -108 311 -115 l 336 -115 b 354 -96 347 -115 354 -108 l 354 55 l 360 50 b 482 0 396 17 433 0 b 657 164 564 0 657 56 b 527 334 657 266 600 334 z"
                },
                ornamentMordent: {
                    x_min: 0,
                    x_max: 473,
                    y_min: -77,
                    y_max: 316,
                    ha: 393,
                    o: "m 647 302 l 562 166 l 446 347 b 429 357 444 353 435 357 b 413 347 423 357 416 353 l 363 262 l 363 435 b 343 455 363 446 354 455 l 331 455 b 311 435 320 455 311 446 l 311 173 l 310 171 l 203 347 b 186 357 200 353 192 357 b 168 347 180 357 171 353 l 0 69 l 35 48 l 120 189 l 226 10 b 243 0 229 4 238 0 b 261 10 249 0 258 4 l 311 95 l 311 -91 b 331 -111 311 -102 320 -111 l 343 -111 b 363 -91 354 -111 363 -102 l 363 184 l 366 189 l 478 10 b 495 0 481 4 490 0 b 513 10 501 0 510 4 l 681 281 z"
                },
                ornamentShortTrill: {
                    x_min: 0,
                    x_max: 473,
                    y_min: 0,
                    y_max: 248,
                    ha: 248,
                    o: "m 647 302 l 562 166 l 446 347 b 431 357 444 353 436 357 b 413 347 425 357 416 353 l 310 171 l 203 347 b 186 357 200 353 192 357 b 168 347 180 357 173 353 l 0 69 l 35 48 l 120 189 l 226 10 b 243 0 229 4 238 0 b 261 10 249 0 258 4 l 366 189 l 478 9 b 495 0 481 3 490 0 b 513 10 501 0 510 4 l 681 281 z"
                },
                ornamentTremblement: {
                    x_min: 0,
                    x_max: 654,
                    y_min: 0,
                    y_max: 248,
                    ha: 248,
                    o: "m 907 302 l 822 166 l 708 348 b 691 357 704 354 701 357 b 674 347 685 357 677 353 l 648 302 l 563 166 l 449 348 b 432 357 446 354 438 357 b 415 347 426 357 418 353 l 415 346 l 311 171 l 203 348 b 186 357 200 354 192 357 b 168 348 177 357 171 354 l 168 347 l 0 69 l 35 48 l 120 190 l 226 10 b 243 0 229 4 238 0 l 245 0 b 261 10 251 0 258 4 l 367 189 l 480 10 b 497 0 482 4 491 0 b 513 10 503 0 510 4 l 625 192 l 739 10 b 756 0 742 4 750 0 b 772 10 762 0 769 4 l 942 282 z"
                },
                ornamentPrecompAppoggTrill: {
                    x_min: 0,
                    x_max: 680,
                    y_min: 0,
                    y_max: 388,
                    ha: 388,
                    o: "m 860 170 l 746 353 b 729 361 743 359 737 361 b 713 351 723 361 716 357 l 685 307 l 600 170 l 487 353 b 481 359 485 356 484 357 b 469 361 478 360 472 361 b 452 351 464 361 455 357 l 348 176 l 240 353 b 223 361 238 359 229 361 b 206 353 215 361 209 359 l 40 76 l 40 541 b 20 559 39 552 30 559 b 0 541 10 559 1 552 l 0 26 b 19 1 0 16 9 4 b 26 0 20 1 24 0 b 48 13 35 0 43 6 l 72 52 l 157 194 l 265 14 b 282 4 268 9 276 4 b 298 14 288 4 295 9 l 405 193 l 517 14 b 534 4 520 9 528 4 b 550 14 540 4 547 9 l 664 196 l 776 14 b 793 4 779 9 788 4 b 811 14 799 4 808 9 l 979 287 l 945 307 z"
                },
                ornamentPrecompSlideTrillDAnglebert: {
                    x_min: 0,
                    x_max: 662,
                    y_min: -158,
                    y_max: 248,
                    ha: 406,
                    o: "m 834 166 l 720 348 b 704 357 717 354 713 357 b 687 348 697 357 690 353 l 661 302 l 660 302 l 575 166 l 461 348 b 455 354 459 350 456 353 b 444 357 452 356 448 357 b 428 347 438 357 431 353 l 323 171 l 215 347 b 213 350 215 348 215 350 b 213 350 213 350 213 350 l 213 351 l 212 351 l 212 353 l 210 353 l 210 353 l 209 354 b 207 354 209 354 207 354 b 197 357 206 356 200 357 b 197 357 197 357 197 357 b 194 357 196 357 196 357 b 180 347 187 357 183 353 l 180 346 l 69 164 b 0 -50 23 88 0 17 b 49 -219 0 -108 16 -163 b 66 -228 52 -223 59 -228 b 76 -225 69 -228 73 -226 b 86 -207 82 -222 86 -215 b 84 -197 86 -204 85 -200 b 40 -52 55 -150 40 -102 b 104 143 40 10 62 73 l 131 190 l 239 10 b 256 0 242 4 249 0 l 256 0 b 272 10 262 0 269 4 l 379 189 l 491 10 b 508 0 494 4 503 0 b 508 0 508 0 508 0 l 508 0 b 526 10 514 0 521 4 l 638 192 l 750 10 b 768 0 755 4 762 0 l 768 0 b 785 10 773 0 782 4 l 785 10 l 953 282 l 919 302 z"
                },
                ornamentPrecompSlideTrillBach: {
                    x_min: 0,
                    x_max: 662,
                    y_min: -158,
                    y_max: 321,
                    ha: 479,
                    o: "m 834 166 l 720 348 b 704 357 716 354 713 357 b 687 348 698 357 690 354 l 660 304 l 660 302 l 632 259 l 632 442 b 612 462 632 454 624 462 l 599 462 b 579 442 588 462 579 454 l 579 173 l 575 166 l 461 348 b 455 356 459 351 458 354 b 445 359 452 357 448 359 b 428 348 439 359 431 354 l 323 171 l 215 347 b 213 350 215 348 213 350 l 213 351 l 212 353 l 210 353 l 210 354 l 207 354 b 197 357 204 356 200 357 b 180 348 189 357 183 354 l 179 346 l 69 164 b 0 -49 23 88 0 19 b 49 -217 0 -107 17 -163 b 66 -228 52 -223 60 -228 b 76 -225 69 -228 73 -226 b 86 -207 82 -222 86 -213 b 84 -197 86 -204 85 -200 b 42 -50 56 -148 42 -101 b 104 144 42 12 62 75 l 131 190 l 239 10 b 256 0 242 4 251 0 b 274 10 262 0 271 4 l 379 190 l 491 10 b 508 0 494 4 503 0 b 526 10 514 0 523 4 l 579 98 l 579 -84 b 599 -104 579 -95 588 -104 l 612 -104 b 632 -84 624 -104 632 -95 l 632 183 l 638 192 l 750 10 b 768 0 753 4 762 0 b 785 10 773 0 782 4 l 953 282 l 919 302 z"
                },
                ornamentPrecompTrillSuffixDandrieu: {
                    x_min: 0,
                    x_max: 662,
                    y_min: 0,
                    y_max: 406,
                    ha: 406,
                    o: "m 904 575 b 887 585 901 580 893 585 b 877 582 884 585 880 583 b 867 564 871 579 867 570 b 870 554 867 562 868 557 b 912 408 897 505 912 458 b 850 213 912 346 891 282 l 822 167 l 714 348 b 697 357 711 354 703 357 b 680 348 691 357 683 354 l 575 168 l 462 348 b 445 357 459 354 451 357 b 428 348 439 357 431 354 l 315 167 l 203 348 b 186 357 200 354 192 357 b 168 348 180 357 171 354 l 0 76 l 35 55 l 120 192 l 233 10 b 249 0 238 4 240 0 b 266 10 255 0 264 4 l 294 55 l 379 192 l 492 9 b 498 3 494 6 495 4 b 508 0 501 1 505 0 b 526 10 514 0 523 4 l 631 186 l 737 13 b 746 3 739 10 743 4 b 756 0 749 1 753 0 b 773 9 762 0 770 3 l 884 193 b 953 406 930 269 953 338 b 904 575 953 464 936 520 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefix: {
                    x_min: 0,
                    x_max: 857,
                    y_min: 0,
                    y_max: 248,
                    ha: 248,
                    o: "m 383 140 b 413 189 399 166 412 187 b 520 10 423 171 516 16 b 537 0 523 4 530 0 b 554 10 543 0 550 4 b 660 189 557 16 649 171 b 772 10 671 173 766 19 b 791 0 778 1 785 0 b 806 10 796 0 802 4 b 919 192 809 16 907 174 l 1031 10 b 1048 0 1035 4 1043 0 l 1048 0 b 1066 10 1054 1 1063 4 l 1066 10 l 1234 282 l 1200 302 l 1115 166 l 1002 348 b 985 357 998 354 994 357 b 968 348 978 357 971 353 l 855 166 b 742 348 845 183 746 341 b 726 357 737 354 732 357 b 708 348 719 357 711 354 b 603 171 704 341 613 189 b 495 348 593 189 498 343 b 478 357 492 353 487 357 b 461 348 469 357 464 353 b 357 173 459 346 393 235 b 213 79 320 111 284 79 b 66 176 143 79 95 112 b 40 279 43 228 40 275 b 20 300 40 291 30 300 b 0 278 9 300 0 289 b 29 161 0 276 3 219 b 213 39 65 81 130 39 b 383 140 297 39 346 73 z"
                },
                ornamentPrecompTrillLowerSuffix: {
                    x_min: 0,
                    x_max: 565,
                    y_min: -171,
                    y_max: 249,
                    ha: 420,
                    o: "m 347 168 l 235 348 b 217 359 230 354 226 359 b 200 348 209 359 203 353 b 3 30 197 344 6 35 b 0 20 0 26 0 24 b 22 0 0 9 10 0 b 37 9 27 0 35 3 l 151 192 b 265 10 161 174 262 13 b 281 0 268 6 272 0 b 298 10 289 0 295 3 l 403 186 l 511 10 b 528 0 516 4 521 0 b 546 10 537 0 541 4 l 698 265 b 775 22 744 202 775 112 b 700 -215 775 -60 752 -144 b 696 -226 697 -219 696 -222 b 704 -243 696 -232 700 -239 b 717 -246 708 -246 713 -246 b 733 -239 723 -246 729 -243 b 814 20 789 -160 814 -69 b 711 312 814 132 773 242 b 696 320 707 317 700 320 b 680 310 691 320 684 318 b 595 168 671 297 602 181 l 488 348 b 471 359 484 354 478 359 b 454 348 464 359 456 353 b 347 168 449 343 357 186 z"
                },
                brassMuteClosed: {
                    x_min: 0,
                    x_max: 312,
                    y_min: 0,
                    y_max: 312,
                    ha: 312,
                    o: "m 22 256 b 0 225 7 256 0 240 b 22 193 0 209 7 193 l 193 193 l 193 22 b 225 0 193 7 209 0 b 256 22 240 0 256 7 l 256 193 l 428 193 b 449 225 442 193 449 209 b 428 256 449 240 442 256 l 256 256 l 256 428 b 225 449 256 442 240 449 b 193 428 209 449 193 442 l 193 256 z"
                },
                brassMuteOpen: {
                    x_min: 0,
                    x_max: 280,
                    y_min: 0,
                    y_max: 280,
                    ha: 280,
                    o: "m 202 403 b 0 202 91 403 0 312 b 202 0 0 91 91 0 b 403 202 312 0 403 91 b 202 403 403 312 312 403 z m 202 40 b 40 202 112 40 40 112 b 202 363 40 291 112 363 b 363 202 291 363 363 291 b 202 40 363 112 291 40 z"
                },
                stringsDownBow: {
                    x_min: 0,
                    x_max: 315,
                    y_min: 0,
                    y_max: 293,
                    ha: 293,
                    o: "m 40 0 l 40 291 l 413 291 l 413 0 l 454 0 l 454 402 b 433 422 454 413 445 422 l 20 422 b 0 402 9 422 0 402 l 0 0 z"
                },
                stringsUpBow: {
                    x_min: 0,
                    x_max: 262,
                    y_min: 0,
                    y_max: 343,
                    ha: 343,
                    o: "m 374 485 b 357 494 372 490 363 494 l 337 494 b 318 481 330 494 321 488 l 189 118 l 59 481 b 40 494 56 488 48 494 l 20 494 b 0 474 9 494 0 485 b 1 467 0 472 1 468 l 170 13 b 189 0 173 6 181 0 b 207 13 196 0 204 6 l 376 467 b 377 474 376 468 377 472 b 374 485 377 477 376 482 z"
                },
                stringsHarmonic: {
                    x_min: 0,
                    x_max: 181,
                    y_min: 0,
                    y_max: 181,
                    ha: 181,
                    o: "m 131 220 b 220 131 181 220 220 181 b 131 40 220 81 181 40 b 40 131 81 40 40 81 b 131 220 40 181 81 220 z m 131 261 b 0 131 59 261 0 203 b 131 0 0 59 59 0 b 261 131 203 0 261 59 b 131 261 261 203 203 261 z"
                },
                pluckedSnapPizzicatoAbove: {
                    x_min: 0,
                    x_max: 269,
                    y_min: 0,
                    y_max: 389,
                    ha: 389,
                    o: "m 213 540 b 194 560 213 552 204 560 b 174 540 183 560 174 552 l 174 386 b 0 193 76 376 0 294 b 194 0 0 86 86 0 b 387 193 301 0 387 86 b 213 386 387 294 311 376 z m 194 40 b 40 193 109 40 40 109 b 174 346 40 271 98 336 l 174 193 b 194 173 174 183 183 173 b 213 193 204 173 213 183 l 213 346 b 347 193 289 336 347 271 b 194 40 347 109 278 40 z"
                },
                pluckedSnapPizzicatoBelow: {
                    x_min: 0,
                    x_max: 269,
                    y_min: 0,
                    y_max: 389,
                    ha: 389,
                    o: "m 213 174 b 387 367 311 184 387 266 b 193 560 387 474 301 560 b 0 367 86 560 0 474 b 174 174 0 266 76 184 l 174 20 b 194 0 174 9 183 0 b 213 20 204 0 213 9 z m 194 520 b 347 367 278 520 347 452 b 213 215 347 289 289 225 l 213 367 b 194 387 213 377 204 387 b 174 367 183 387 174 377 l 174 215 b 40 367 98 225 40 289 b 194 520 40 452 109 520 z"
                },
                keyboardPedalPed: {
                    x_min: 0,
                    x_max: 981,
                    y_min: -10,
                    y_max: 545,
                    ha: 555,
                    o: "m 1354 12 b 1413 78 1385 12 1413 42 b 1354 145 1413 115 1385 145 b 1293 78 1320 145 1293 115 b 1354 12 1293 42 1320 12 z m 1092 88 b 1080 86 1089 86 1084 86 b 1004 203 1037 86 1004 137 b 1107 376 1004 360 1097 374 b 1149 209 1129 336 1149 287 b 1092 88 1149 117 1130 95 z m 752 393 b 795 344 779 393 795 372 b 770 285 795 325 788 304 b 693 203 737 249 697 207 b 688 264 690 225 688 245 b 752 393 688 347 714 393 z m 245 507 b 220 544 245 533 235 544 b 217 544 219 544 219 544 b 186 510 206 546 192 537 b 143 464 179 478 163 464 b 134 465 140 464 137 464 b 102 516 117 467 102 487 b 141 613 102 541 112 576 b 347 721 212 711 315 721 b 356 721 351 721 354 721 b 275 560 344 701 297 616 b 259 495 274 557 259 528 b 272 452 259 480 264 465 b 373 323 297 416 350 354 b 387 284 382 311 387 298 b 350 222 387 265 376 245 b 230 140 301 180 252 154 b 128 39 215 130 128 92 b 134 12 128 30 130 22 b 173 -14 144 -7 157 -14 b 264 40 204 -14 243 17 b 333 98 281 58 302 98 b 389 39 357 98 373 60 b 478 -10 416 1 435 -10 b 622 96 527 -10 559 43 b 740 -10 626 86 667 -10 b 929 95 827 -10 917 85 b 1086 -12 950 37 1018 -12 b 1120 -7 1097 -12 1109 -10 b 1264 213 1212 17 1264 111 b 1263 248 1264 225 1263 236 b 815 664 1228 544 907 647 b 785 668 805 665 795 668 b 779 668 783 668 782 668 b 757 654 769 668 760 665 b 757 649 757 652 757 651 b 786 618 759 629 783 619 b 818 606 796 613 808 611 b 1071 435 1007 534 1066 445 b 909 181 930 386 909 256 b 910 141 909 164 909 151 b 786 78 899 127 844 78 b 708 151 726 78 710 144 b 799 230 711 154 742 181 b 864 350 845 271 864 312 b 757 456 864 410 815 456 b 599 222 644 456 599 328 b 609 141 599 192 602 164 b 563 104 608 140 595 122 b 540 98 556 99 549 98 b 459 140 513 98 480 118 b 397 184 413 189 399 184 b 475 279 403 189 454 226 b 482 311 480 289 482 300 b 449 410 482 359 452 405 b 361 533 442 419 383 503 b 354 560 356 541 354 550 b 386 651 353 588 372 622 b 429 713 405 693 426 710 b 557 592 521 688 557 628 b 549 569 557 582 554 573 b 523 559 540 562 531 559 b 459 592 495 559 469 583 b 425 613 451 600 438 613 b 409 608 419 613 415 612 b 399 586 402 602 399 595 b 399 583 397 585 399 585 b 409 552 399 573 405 562 b 541 458 441 487 492 458 b 608 480 564 458 588 465 b 648 572 632 497 648 531 b 429 778 648 649 589 749 b 351 785 402 782 376 785 b 0 507 130 785 0 615 b 127 366 0 399 68 366 b 245 507 186 366 245 429 z"
                },
                keyboardPedalUp: {
                    x_min: 0,
                    x_max: 473,
                    y_min: 0,
                    y_max: 473,
                    ha: 473,
                    o: "m 99 99 b 164 69 120 79 143 69 b 199 82 177 69 190 73 b 210 114 206 89 210 102 b 206 137 210 122 209 130 b 200 160 203 145 200 154 b 210 179 200 166 203 171 l 245 215 b 285 213 255 225 272 219 l 287 213 l 288 212 b 318 183 301 206 318 196 l 318 134 b 291 102 318 112 308 112 b 258 58 274 92 258 76 b 340 0 258 26 294 0 b 423 58 386 0 423 26 b 390 102 423 76 408 92 b 361 134 373 112 361 112 l 361 183 b 392 212 361 196 379 206 b 395 213 393 212 393 213 b 436 215 408 219 426 225 l 471 179 b 480 161 478 171 480 167 b 474 137 480 154 477 147 b 471 115 472 130 471 122 b 482 82 471 102 474 91 b 517 69 491 73 504 69 b 582 99 539 69 562 79 b 612 164 602 120 612 143 b 599 199 612 177 608 190 b 567 210 592 206 579 210 b 544 206 559 210 552 209 b 521 200 536 203 528 200 b 501 210 514 200 508 203 l 467 245 b 468 285 456 255 462 272 l 468 287 b 469 288 468 287 469 287 b 498 318 475 301 485 318 l 547 318 b 579 291 569 318 569 308 b 624 258 589 274 605 258 b 681 340 655 258 681 294 b 624 423 681 386 655 423 b 579 390 605 423 589 408 b 547 361 569 373 569 361 l 498 361 b 469 392 485 361 475 379 b 468 395 469 393 468 393 b 467 436 462 408 456 426 l 501 471 b 520 480 508 478 514 480 b 544 474 527 480 534 477 b 566 471 552 472 559 471 b 599 482 579 471 590 474 b 612 516 608 491 612 503 b 582 580 612 536 602 560 b 516 612 562 600 537 612 b 482 599 503 612 491 608 b 471 566 474 590 471 579 b 474 544 471 559 472 552 b 480 520 477 534 480 527 b 471 501 480 514 478 508 l 436 467 b 395 468 426 456 408 462 b 392 469 393 468 393 469 b 361 498 379 475 361 485 l 361 547 b 390 579 361 569 373 569 b 423 624 408 589 423 605 b 340 681 423 655 386 681 b 258 624 294 681 258 655 b 291 579 258 605 274 589 b 318 547 308 569 318 569 l 318 498 b 288 469 318 485 301 475 l 287 468 l 285 468 b 245 467 272 462 255 456 l 210 501 b 200 521 203 508 200 514 b 206 544 200 528 203 536 b 210 567 209 552 210 559 b 199 599 210 579 206 592 b 164 612 190 608 177 612 b 99 582 143 612 120 602 b 69 517 79 562 69 539 b 82 482 69 504 73 491 b 115 471 91 474 102 471 b 137 474 122 471 130 472 b 161 480 147 477 154 480 b 180 471 167 480 173 478 l 215 436 b 213 395 225 426 219 408 b 212 392 213 393 212 393 b 183 361 206 379 196 361 l 134 361 b 102 390 112 361 112 373 b 58 423 92 408 76 423 b 0 340 26 423 0 386 b 58 258 0 294 26 258 b 102 291 76 258 92 274 b 134 318 112 308 112 318 l 183 318 b 212 288 196 318 206 301 b 213 287 212 287 213 288 l 213 285 b 215 245 219 272 225 255 l 179 210 b 160 200 171 203 166 200 b 137 206 154 200 145 203 b 114 210 130 209 122 210 b 82 199 102 210 89 206 b 69 164 73 190 69 177 b 99 99 69 143 79 120 z m 276 276 b 249 340 262 291 249 320 b 340 432 249 390 289 432 b 432 340 390 432 432 390 b 405 276 432 320 419 291 b 340 249 390 262 360 249 b 276 276 320 249 291 262 z"
                },
                wiggleArpeggiatoUp: {
                    x_min: -22,
                    x_max: 242,
                    y_min: 0,
                    y_max: 164,
                    ha: 164,
                    o: "m 343 122 b 323 143 343 122 334 132 b 308 148 318 147 312 148 b 298 144 304 148 301 147 b 282 128 295 141 291 137 b 274 124 279 125 276 124 b 265 128 268 124 265 128 b 158 220 265 128 173 207 b 112 236 143 232 127 236 b 43 206 82 236 55 219 l -26 137 b -32 125 -30 132 -32 130 b -26 112 -32 118 -26 112 b -6 92 -26 112 -17 102 b 7 86 -1 88 3 86 b 17 91 12 86 14 88 b 33 107 20 94 24 98 b 42 111 36 109 39 111 b 52 107 48 111 52 107 b 158 16 52 107 144 29 b 204 0 174 4 190 0 b 274 30 235 0 262 17 l 343 99 b 348 111 347 104 348 108 b 343 122 348 118 343 122 z"
                },
                repeat1Bar: {
                    x_min: 0,
                    x_max: 481,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 183 180 b 92 271 183 230 141 271 b 1 180 42 271 1 230 b 92 89 1 130 42 89 b 183 180 141 89 183 130 z m 693 360 l 511 360 l 0 -360 l 181 -360 z m 693 -181 b 602 -91 693 -131 651 -91 b 511 -181 552 -91 511 -131 b 602 -272 511 -232 552 -272 b 693 -181 651 -272 693 -232 z"
                },
                repeat2Bars: {
                    x_min: 0,
                    x_max: 735,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 1058 -181 b 968 -91 1058 -131 1017 -91 b 877 -181 917 -91 877 -131 b 968 -272 877 -232 917 -272 b 1058 -181 1017 -272 1058 -232 z m 183 180 b 92 271 183 230 141 271 b 1 180 42 271 1 230 b 92 89 1 130 42 89 b 183 180 141 89 183 130 z m 693 360 l 511 360 l 0 -360 l 181 -360 z m 1058 360 l 877 360 l 366 -360 l 547 -360 z"
                },
                repeat4Bars: {
                    x_min: 0,
                    x_max: 1243,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 183 180 b 92 271 183 230 141 271 b 1 180 42 271 1 230 b 92 89 1 130 42 89 b 183 180 141 89 183 130 z m 693 360 l 511 360 l 0 -360 l 181 -360 z m 1058 360 l 877 360 l 366 -360 l 547 -360 z m 1424 360 l 1243 360 l 732 -360 l 913 -360 z m 1790 360 l 1608 360 l 1097 -360 l 1279 -360 z m 1790 -181 b 1699 -91 1790 -131 1748 -91 b 1608 -181 1649 -91 1608 -131 b 1699 -272 1608 -232 1649 -272 b 1790 -181 1748 -272 1790 -232 z"
                },
                repeatBarSlash: {
                    x_min: 0,
                    x_max: 481,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 693 360 l 511 360 l 0 -360 l 181 -360 z"
                },
                csymDiminished: {
                    x_min: 0,
                    x_max: 501,
                    y_min: 0,
                    y_max: 501,
                    ha: 501,
                    o: "m 361 721 b 0 361 161 721 0 560 b 361 0 0 161 161 0 b 721 361 560 0 721 161 b 361 721 721 560 560 721 z m 557 164 b 361 82 505 111 435 82 b 164 164 287 82 216 111 b 82 361 111 216 82 287 b 164 557 82 436 111 505 b 361 639 216 611 287 639 b 557 557 436 639 505 611 b 639 361 611 505 639 436 b 557 164 639 287 609 216 z"
                },
                csymHalfDiminished: {
                    x_min: -1,
                    x_max: 502,
                    y_min: -1,
                    y_max: 502,
                    ha: 503,
                    o: "m 723 684 l 684 723 l 596 634 b 361 721 533 688 451 721 b 0 361 161 721 0 560 b 88 125 0 271 33 189 l -1 36 l 36 -1 l 125 88 b 361 0 189 33 271 0 b 721 361 560 0 721 161 b 634 596 721 451 688 533 z m 82 361 b 164 557 82 436 111 505 b 361 639 216 611 287 639 b 537 576 426 639 488 616 l 145 184 b 82 361 105 233 82 295 z m 639 361 b 557 164 639 287 609 216 b 361 82 505 111 435 82 b 184 145 295 82 233 105 l 576 537 b 639 361 616 488 639 426 z"
                },
                csymAugmented: {
                    x_min: 1,
                    x_max: 321,
                    y_min: 90,
                    y_max: 410,
                    ha: 320,
                    o: "m 462 400 l 272 400 l 272 590 l 192 590 l 192 400 l 1 400 l 1 320 l 192 320 l 192 130 l 272 130 l 272 320 l 462 320 z"
                },
                csymMajorSeventh: {
                    x_min: 0,
                    x_max: 500,
                    y_min: 10,
                    y_max: 490,
                    ha: 480,
                    o: "m 360 528 l 585 96 l 135 96 z m 360 706 l 0 14 l 720 14 z"
                },
                accidentalNarrowReversedFlat: {
                    x_min: 0,
                    x_max: 160,
                    y_min: -176,
                    y_max: 452,
                    ha: 628,
                    o: "m 0 84 b 101 -153 0 -26 65 -107 b 196 -249 153 -217 196 -249 b 206 -253 199 -251 202 -253 b 225 -235 216 -253 225 -245 l 230 632 b 212 651 230 642 222 651 l 199 651 b 180 632 189 651 180 642 l 184 204 b 125 217 184 204 171 217 b 0 84 53 217 0 173 z m 145 154 b 184 107 181 154 184 120 l 187 -179 b 114 -72 167 -158 132 -112 b 82 58 86 -13 82 36 b 145 154 82 79 82 154 z"
                },
                accidentalNarrowReversedFlatAndFlat: {
                    x_min: 0,
                    x_max: 416,
                    y_min: -176,
                    y_max: 452,
                    ha: 628,
                    o: "m 462 217 b 330 174 374 217 338 181 l 334 632 b 315 651 334 642 325 651 l 302 651 b 284 632 292 651 284 642 l 289 -235 b 308 -253 289 -245 298 -253 b 320 -249 312 -253 317 -251 b 492 -138 320 -249 433 -194 b 599 84 534 -98 599 -26 b 462 217 599 173 534 217 z m 501 58 b 459 -72 501 36 498 -19 b 327 -179 431 -111 359 -164 l 330 85 l 330 91 b 422 154 330 125 359 154 b 501 58 503 154 501 79 z m 0 84 b 101 -153 0 -26 65 -107 b 196 -249 153 -217 196 -249 b 206 -253 199 -251 202 -253 b 225 -235 216 -253 225 -245 l 230 632 b 212 651 230 642 222 651 l 199 651 b 180 632 189 651 180 642 l 184 204 b 125 217 184 204 171 217 b 0 84 53 217 0 173 z m 145 154 b 184 107 181 154 184 120 l 187 -179 b 114 -72 167 -158 132 -112 b 82 58 86 -13 82 36 b 145 154 82 79 82 154 z"
                }
            },
            fontFamily: "Leland",
            resolution: 1e3,
            generatedOn: "2022-12-19T23:52:37.756Z"
        };
        const Ri = {
            glyphs: {
                bracketTop: {
                    x_min: 0,
                    x_max: 508,
                    y_min: 0,
                    y_max: 370,
                    ha: 370,
                    o: "m 22 0 b 122 0 55 1 89 0 l 157 0 b 713 376 425 0 622 137 b 732 467 724 406 732 436 b 726 514 732 482 730 498 b 711 533 723 528 719 533 b 693 526 707 533 700 530 b 674 498 683 520 678 508 b 635 406 662 467 652 435 b 310 164 560 281 458 193 b 154 151 258 154 206 151 b 39 154 117 151 78 154 b 1 120 17 154 4 145 b 0 84 0 108 0 96 b 0 20 0 63 1 40 b 22 0 0 4 7 0 z"
                },
                bracketBottom: {
                    x_min: 0,
                    x_max: 496,
                    y_min: -393,
                    y_max: 0,
                    ha: 393,
                    o: "m 696 -566 b 711 -539 713 -566 708 -549 b 714 -521 713 -533 714 -527 b 713 -508 714 -517 713 -513 b 661 -327 706 -445 688 -384 b 392 -42 603 -203 513 -109 b 206 0 331 -7 266 0 b 160 -1 190 0 174 -1 b 26 -1 107 -1 66 -3 b 0 -19 12 -1 0 -4 l 0 -23 b 3 -50 1 -32 3 -42 b 1 -86 3 -62 1 -73 b 4 -118 1 -96 1 -108 b 45 -151 10 -145 23 -154 b 180 -143 89 -144 135 -145 b 621 -419 392 -135 523 -236 b 662 -539 641 -456 655 -497 b 696 -566 667 -557 680 -566 z"
                },
                barlineTick: {
                    x_min: 0,
                    x_max: 56,
                    y_min: 877,
                    y_max: 1122,
                    ha: 245,
                    o: "m 42 1263 b 66 1287 62 1261 66 1272 b 81 1583 65 1387 72 1485 b 35 1614 82 1610 53 1610 b 14 1591 17 1619 16 1604 b 0 1408 7 1525 0 1459 l 0 1292 b 42 1263 1 1263 23 1266 z"
                },
                breathMarkTick: {
                    x_min: 0,
                    x_max: 568,
                    y_min: 0,
                    y_max: 621,
                    ha: 621,
                    o: "m 258 0 b 278 39 276 0 274 24 b 279 56 279 45 279 50 l 279 73 b 278 117 279 88 278 102 b 281 148 278 127 279 138 b 536 600 312 330 387 487 b 744 719 600 651 670 690 b 815 779 775 730 808 740 b 818 824 818 793 818 808 b 815 868 818 838 818 852 b 796 894 814 881 808 894 b 779 888 791 894 786 893 b 719 864 760 878 739 871 b 372 602 580 806 459 724 b 229 252 298 498 251 383 b 220 268 225 262 222 264 b 209 302 217 279 213 291 b 75 527 181 387 143 467 b 16 563 58 543 39 573 b 0 539 3 557 0 549 b 12 492 0 524 9 507 b 56 400 19 459 22 425 b 163 269 104 367 138 323 b 238 36 197 194 216 115 b 258 0 242 22 243 0 z"
                },
                segno: {
                    x_min: 0,
                    x_max: 798,
                    y_min: -65,
                    y_max: 806,
                    ha: 871,
                    o: "m 16 -94 b 66 -69 39 -92 53 -85 b 177 59 102 -26 138 17 b 543 456 298 192 420 324 b 726 300 615 420 680 373 b 753 217 744 271 753 243 b 655 112 753 170 719 131 b 599 104 636 107 618 104 b 461 173 544 104 495 128 b 432 190 454 183 444 190 b 409 179 425 190 418 187 b 359 118 390 160 373 141 b 341 72 347 101 341 86 b 373 24 341 56 351 40 b 409 6 384 17 396 10 b 550 -13 454 -12 501 -14 b 599 -6 566 -12 583 -10 b 864 213 720 27 806 104 b 886 300 878 242 886 271 b 857 395 886 331 877 363 b 799 467 840 420 821 445 b 648 572 755 513 704 546 b 1110 1083 802 743 955 914 b 1140 1129 1123 1097 1136 1110 b 1149 1148 1142 1135 1149 1142 b 1145 1153 1149 1149 1148 1152 b 1123 1161 1139 1158 1130 1161 b 1109 1156 1119 1161 1113 1159 b 1089 1138 1102 1151 1094 1145 b 946 988 1040 1089 989 1041 b 595 602 834 855 711 732 l 590 598 l 549 615 b 432 793 462 647 432 723 b 534 888 432 851 474 888 b 671 834 588 888 631 864 b 710 818 684 824 696 818 b 724 821 714 818 719 819 b 809 883 757 834 788 852 b 816 901 814 890 816 896 b 802 923 816 910 812 916 b 706 984 770 945 742 971 b 593 1011 668 998 631 1011 b 516 991 567 1011 541 1005 b 333 799 433 949 380 876 b 302 693 312 765 302 729 b 330 589 302 658 311 624 b 469 488 360 533 415 511 b 485 482 475 487 480 485 b 266 249 412 405 338 327 b 121 88 217 196 170 141 b 9 -65 78 40 37 -7 b 0 -85 4 -72 0 -79 b 16 -94 0 -91 4 -94 z m 861 536 b 927 575 890 539 909 557 b 965 628 952 598 965 613 b 926 680 965 644 952 658 b 865 713 900 701 883 713 b 805 667 845 713 828 698 b 768 611 791 649 770 631 b 812 564 766 589 798 582 b 861 536 824 550 840 537 z m 251 350 b 363 436 285 348 353 403 b 354 456 366 448 360 452 b 271 518 327 477 298 497 b 243 528 261 526 252 528 b 210 513 232 528 222 523 b 157 454 190 494 176 472 b 141 428 147 444 141 436 b 158 406 141 420 147 413 b 216 361 180 393 197 376 b 245 350 225 356 235 350 z"
                },
                coda: {
                    x_min: 0,
                    x_max: 1380,
                    y_min: -196,
                    y_max: 1037,
                    ha: 1233,
                    o: "m 1028 -282 b 1057 -245 1045 -282 1053 -261 b 1060 -203 1060 -232 1060 -217 b 1063 9 1060 -132 1061 -62 b 1390 194 1192 22 1303 81 b 1531 543 1467 298 1512 415 b 1532 556 1531 547 1532 552 b 1904 559 1656 557 1780 559 b 1950 582 1920 559 1941 569 b 1987 674 1970 609 1987 638 b 1984 698 1987 681 1986 690 b 1950 700 1973 698 1961 700 l 1941 700 l 1545 696 b 1535 776 1545 723 1541 749 b 1103 1113 1477 996 1326 1107 b 1080 1115 1096 1115 1087 1115 b 1081 1322 1080 1184 1080 1253 b 1079 1467 1083 1371 1081 1418 b 1061 1493 1079 1476 1080 1493 l 1060 1493 b 1028 1467 1044 1490 1031 1485 b 1020 1403 1025 1446 1020 1424 b 1017 1110 1020 1305 1018 1208 l 962 1106 b 569 914 808 1087 671 1035 b 451 683 510 844 472 766 l 161 678 b 118 680 148 678 132 680 b 79 670 101 680 86 678 b 0 544 48 636 29 592 l 37 544 l 429 549 b 428 518 428 539 428 528 b 488 285 428 435 458 360 b 681 81 526 192 593 124 b 946 9 763 40 854 19 b 1008 6 966 7 988 6 b 1005 -137 1008 -42 1005 -89 b 1012 -243 1005 -173 1005 -209 b 1028 -282 1015 -258 1011 -282 z m 1074 690 b 1079 935 1077 772 1077 852 b 1326 855 1166 932 1250 909 b 1446 694 1385 814 1426 759 b 1269 693 1387 694 1328 693 b 1074 690 1204 693 1139 691 z m 577 684 b 766 874 618 763 678 828 b 989 932 837 912 913 923 b 1015 933 998 932 1007 933 b 1014 822 1015 896 1014 860 b 1011 688 1012 791 1012 743 z m 1067 184 b 1071 553 1070 307 1068 429 b 1439 556 1194 553 1316 554 b 1437 554 1439 554 1437 554 b 1341 337 1413 478 1387 402 b 1119 192 1286 261 1211 212 b 1067 184 1102 189 1084 186 z m 1008 180 b 660 264 886 181 770 212 b 524 471 570 305 524 374 b 528 524 524 488 526 505 l 533 549 b 792 552 619 550 706 550 b 1009 553 865 553 937 552 b 1008 180 1009 428 1008 288 z"
                },
                gClef: {
                    x_min: 0,
                    x_max: 664,
                    y_min: -559,
                    y_max: 1009,
                    ha: 1568,
                    o: "m 343 -805 b 366 -801 350 -805 357 -804 b 409 -773 383 -795 397 -786 b 582 -328 528 -648 577 -497 b 583 -294 582 -315 583 -294 b 612 -279 583 -294 603 -282 b 747 -197 660 -256 706 -230 b 949 143 857 -109 920 10 b 956 206 955 164 956 186 b 791 384 956 297 906 363 b 704 393 762 390 733 393 b 498 336 632 393 563 374 b 481 325 490 331 481 325 l 444 465 b 442 485 442 472 442 485 b 609 880 442 485 589 746 b 619 996 616 919 619 958 b 613 1084 619 1027 618 1056 b 534 1387 599 1188 560 1286 b 482 1453 527 1417 517 1453 b 422 1407 456 1453 438 1428 b 305 1063 348 1305 312 1188 b 304 1002 304 1043 304 1022 b 338 654 304 886 323 769 b 343 629 338 645 341 636 b 144 356 278 537 206 451 b 23 144 101 288 53 220 b 0 20 7 107 0 63 b 82 -210 0 -69 30 -160 b 207 -288 112 -239 160 -271 b 410 -328 274 -312 340 -328 b 474 -324 431 -328 452 -327 l 491 -321 b 491 -341 491 -321 492 -334 b 402 -585 475 -428 454 -513 b 294 -668 374 -622 348 -664 b 271 -693 278 -670 271 -680 b 274 -708 271 -698 272 -703 b 302 -775 282 -730 292 -753 b 343 -805 311 -795 325 -805 z m 400 717 b 382 922 389 786 382 854 b 481 1286 382 1047 408 1169 b 507 1125 498 1233 507 1179 b 500 1040 507 1097 504 1068 b 400 717 481 927 455 818 z m 252 -135 b 196 -121 232 -134 215 -127 b 117 -69 158 -108 127 -94 b 111 -32 112 -58 111 -45 b 117 19 111 -16 114 1 b 130 56 118 27 127 52 b 324 337 186 156 253 246 l 384 416 l 395 384 b 416 291 406 348 416 291 b 350 213 416 291 376 239 b 243 -42 278 143 243 55 b 251 -117 243 -66 246 -91 b 252 -135 252 -122 252 -127 z m 563 -91 b 510 168 552 3 530 78 b 513 192 508 179 508 186 b 624 202 550 199 586 202 b 730 192 660 202 694 199 b 850 141 773 183 816 176 b 858 134 852 138 855 135 b 595 -121 801 19 716 -68 l 569 -131 z m 410 -160 b 311 -147 360 -160 311 -147 b 307 -98 311 -147 307 -127 b 314 -33 307 -79 308 -56 b 429 131 328 36 377 85 b 441 138 433 135 438 138 b 449 122 446 138 448 132 b 490 -131 462 37 484 -46 b 490 -153 491 -140 490 -153 b 410 -160 490 -153 452 -163 z"
                },
                cClef: {
                    x_min: 0,
                    x_max: 731,
                    y_min: -543,
                    y_max: 543,
                    ha: 1086,
                    o: "m 131 -782 b 141 -755 138 -782 140 -773 b 147 -490 143 -667 145 -577 b 160 207 150 -258 153 -24 b 168 618 164 344 158 481 b 81 768 173 690 132 732 b 45 782 66 778 55 782 b 3 740 26 782 13 768 b 0 724 1 736 0 730 l 1 710 b 4 596 4 672 4 634 l 4 382 b 9 102 4 288 4 196 b 17 -301 13 -32 10 -166 l 17 -672 b 50 -736 17 -701 27 -720 b 109 -772 69 -749 91 -759 b 131 -782 120 -778 127 -782 z m 615 -770 b 881 -684 710 -770 801 -739 b 1020 -395 986 -612 1020 -510 b 1017 -334 1020 -374 1018 -354 b 769 -62 1007 -209 896 -75 b 746 -60 762 -60 755 -60 b 639 -73 710 -60 675 -69 b 524 -109 598 -79 560 -92 b 528 -36 526 -85 528 -60 b 527 -4 528 -26 528 -14 b 528 39 527 10 528 24 b 526 99 528 59 527 79 b 592 94 549 95 570 94 b 648 99 611 94 629 95 b 912 157 744 94 844 117 b 1053 377 1009 215 1053 284 b 1050 425 1053 393 1053 409 b 914 665 1037 521 986 602 b 717 753 855 717 791 753 b 626 734 688 753 658 747 l 462 665 b 347 500 374 628 347 580 b 350 449 347 484 348 468 b 392 419 353 428 367 416 b 492 438 425 425 459 428 b 541 498 524 448 541 468 b 540 514 541 503 541 508 b 537 546 537 524 537 536 b 573 639 537 580 550 611 b 606 657 582 649 593 657 l 609 657 b 716 622 647 652 684 647 b 834 372 801 556 834 469 b 831 323 834 356 832 338 b 743 187 825 266 795 217 b 710 176 732 180 720 176 b 694 179 704 176 700 177 b 527 223 638 193 582 206 b 495 229 516 228 505 229 b 454 220 481 229 468 225 b 395 189 432 213 415 200 b 363 180 384 186 374 181 b 348 168 356 179 348 176 b 340 161 343 167 340 164 b 347 150 340 157 343 154 b 356 147 348 148 353 147 b 364 92 361 130 363 111 b 369 -37 367 49 369 6 b 363 -154 369 -76 367 -115 b 357 -236 360 -183 357 -210 b 376 -264 357 -253 361 -259 b 456 -289 402 -284 429 -289 b 521 -282 478 -289 500 -285 b 549 -255 537 -279 546 -271 b 598 -177 556 -225 577 -202 b 622 -164 605 -168 613 -164 b 636 -167 626 -164 631 -166 b 749 -225 678 -177 714 -199 b 848 -405 814 -276 848 -337 b 824 -507 848 -436 840 -471 b 657 -657 792 -582 730 -625 b 608 -668 638 -664 622 -668 b 534 -602 572 -668 547 -645 b 513 -575 530 -589 523 -575 b 507 -576 510 -575 508 -575 b 478 -582 497 -580 488 -582 b 405 -570 454 -582 428 -570 b 389 -572 399 -570 395 -570 l 363 -572 b 321 -575 348 -572 333 -569 l 321 631 b 323 662 323 641 323 652 b 315 716 323 681 321 698 b 304 736 314 723 317 736 l 302 736 b 281 716 294 734 285 729 b 275 665 276 700 275 683 l 275 382 b 276 99 275 288 275 193 b 279 -170 278 10 276 -81 b 284 -399 282 -246 284 -323 b 282 -629 284 -475 282 -553 b 289 -721 282 -660 289 -690 b 300 -736 289 -727 291 -736 b 312 -724 307 -736 310 -730 b 321 -667 323 -706 321 -687 l 321 -632 l 328 -644 l 340 -657 b 510 -757 386 -707 445 -740 b 615 -770 546 -766 580 -770 z"
                },
                fClef: {
                    x_min: 0,
                    x_max: 776,
                    y_min: -496,
                    y_max: 216,
                    ha: 712,
                    o: "m 402 -706 b 804 -405 592 -678 716 -566 b 876 -53 861 -298 874 -183 b 868 33 876 -32 873 1 b 560 311 845 217 723 311 b 524 310 549 311 536 311 b 131 134 373 297 239 242 b 17 -29 84 86 37 39 b 9 -89 12 -50 9 -71 b 112 -238 9 -154 43 -206 b 124 -243 117 -239 120 -242 b 186 -261 145 -255 166 -261 b 268 -228 215 -261 242 -249 b 351 -59 325 -181 351 -124 b 343 10 351 -36 348 -13 b 340 36 341 19 340 27 b 409 105 340 75 363 102 b 441 107 420 107 431 107 b 624 36 510 107 573 86 b 744 -200 688 -27 724 -109 b 747 -230 747 -210 747 -222 b 717 -323 747 -264 736 -292 b 608 -445 688 -370 654 -410 b 307 -541 518 -513 415 -541 l 213 -541 b 39 -521 154 -541 96 -539 b 0 -552 17 -514 0 -531 b 1 -564 0 -556 0 -560 b 17 -611 6 -580 10 -596 b 101 -694 35 -648 50 -684 b 288 -714 164 -707 225 -714 b 402 -706 325 -714 363 -711 z m 1018 92 b 1080 118 1041 91 1068 96 b 1117 219 1099 150 1117 180 b 1113 252 1117 229 1116 240 b 1045 288 1102 297 1068 276 b 1017 262 1028 297 1024 274 b 984 124 989 220 996 170 b 1008 91 979 108 986 91 z m 972 -281 b 1070 -148 1024 -279 1070 -210 b 1025 -105 1070 -105 1045 -112 b 989 -127 1004 -96 998 -114 b 949 -249 963 -164 963 -209 b 969 -281 943 -265 949 -281 z"
                },
                unpitchedPercussionClef1: {
                    x_min: 0,
                    x_max: 379,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 481 -360 b 507 -357 491 -360 500 -360 b 546 -295 541 -346 547 -325 b 536 79 543 -170 540 -46 b 523 311 533 157 534 235 b 475 359 518 340 508 359 b 425 360 459 359 442 360 b 400 359 416 360 409 360 b 337 294 348 353 340 347 l 337 -73 b 336 -264 337 -137 337 -200 b 343 -294 336 -274 338 -284 b 481 -360 359 -330 431 -360 z m 144 -341 b 207 -320 167 -341 189 -331 b 217 -301 215 -315 217 -308 b 210 -262 217 -289 210 -275 b 228 187 212 -112 209 37 b 228 287 228 220 229 253 b 174 353 228 336 222 343 b 120 359 157 357 138 359 b 48 357 96 359 72 356 b 17 323 29 357 19 344 b 7 120 16 255 9 187 b 6 -109 6 43 6 -33 l 6 -204 b 0 -251 6 -220 0 -235 b 3 -269 0 -256 0 -262 b 127 -340 24 -330 79 -328 b 144 -341 132 -341 138 -341 z"
                },
                "6stringTabClef": {
                    x_min: 0,
                    x_max: 438,
                    y_min: -768,
                    y_max: 767,
                    ha: 1535,
                    o: "m 369 438 b 374 439 370 438 372 438 b 384 462 383 444 384 452 l 384 474 b 390 697 386 547 390 622 b 373 1002 390 799 390 901 l 533 1002 b 560 1001 541 1004 552 1001 b 573 1007 567 1001 572 1002 b 546 1050 579 1025 559 1038 b 536 1056 543 1053 539 1053 b 324 1104 472 1102 397 1104 b 72 1090 238 1104 154 1099 b 55 1093 66 1090 60 1092 b 37 1073 46 1093 37 1089 b 60 1045 37 1061 48 1051 b 203 1001 105 1022 151 1001 b 233 1004 213 1001 223 1002 b 246 1005 238 1004 243 1005 b 272 975 264 1005 272 996 l 272 965 b 258 596 264 842 265 719 b 315 474 253 540 272 504 l 343 455 b 369 438 351 448 357 438 z m 114 -320 b 127 -304 120 -320 124 -315 b 171 -174 141 -261 158 -219 b 222 -135 179 -147 196 -137 b 426 -122 289 -131 359 -128 b 498 -164 462 -120 482 -127 b 628 -301 521 -226 575 -264 b 631 -288 631 -295 631 -291 b 628 -269 631 -281 629 -276 b 569 -134 616 -220 589 -179 b 408 225 514 -14 462 107 b 314 357 384 274 351 318 b 278 380 298 372 288 379 b 251 351 268 380 261 372 b 4 -209 156 171 75 -17 b 0 -228 1 -215 0 -222 b 19 -258 0 -240 7 -249 b 102 -314 45 -279 75 -294 b 114 -320 107 -318 111 -320 z m 425 6 b 360 20 403 17 382 20 b 274 14 331 20 302 14 l 246 14 l 340 206 b 425 6 369 137 395 75 z m 245 -1106 b 281 -1104 256 -1106 269 -1106 b 511 -888 400 -1094 511 -1035 b 454 -688 511 -814 504 -744 b 448 -678 449 -685 448 -681 b 454 -667 448 -675 449 -671 b 504 -497 503 -619 507 -559 b 324 -288 500 -383 436 -308 b 295 -287 314 -287 304 -287 l 282 -287 b 115 -330 223 -287 168 -307 b 94 -366 102 -336 94 -348 l 94 -370 b 96 -435 96 -392 96 -413 b 73 -858 89 -576 71 -717 b 78 -919 73 -878 78 -899 b 72 -950 78 -930 76 -940 b 63 -992 66 -965 63 -978 b 66 -1015 63 -999 65 -1008 b 173 -1104 84 -1106 84 -1106 b 245 -1106 197 -1104 220 -1104 z m 161 -622 b 147 -618 156 -622 151 -621 b 140 -600 141 -612 140 -606 b 144 -564 140 -589 144 -575 b 143 -554 144 -560 144 -557 l 143 -546 b 220 -451 144 -467 143 -465 b 278 -445 239 -446 259 -444 b 418 -497 328 -445 376 -461 b 429 -516 426 -504 429 -510 b 415 -533 429 -521 423 -527 b 219 -608 357 -579 287 -590 b 215 -609 217 -608 216 -609 b 161 -622 197 -609 177 -622 z m 154 -953 b 130 -933 135 -953 130 -948 l 130 -865 l 128 -865 b 135 -788 130 -838 124 -808 b 203 -769 145 -769 180 -776 b 259 -762 223 -765 242 -762 b 441 -852 330 -762 386 -805 b 449 -867 446 -858 449 -863 b 436 -884 449 -874 444 -878 b 318 -942 402 -914 363 -935 b 154 -953 264 -950 209 -953 z"
                },
                timeSig0: {
                    x_min: 20,
                    x_max: 513,
                    y_min: -358,
                    y_max: 359,
                    ha: 717,
                    o: "m 341 -516 b 420 -510 367 -516 395 -514 b 675 -338 533 -494 622 -448 b 737 -92 716 -256 734 -171 b 739 -35 739 -73 739 -53 b 680 305 739 86 720 207 b 400 517 622 449 537 517 b 337 514 380 517 359 517 b 289 507 321 511 305 513 b 91 317 192 477 127 412 b 29 9 50 212 29 108 b 217 -458 29 -157 88 -312 b 341 -516 251 -494 291 -518 z m 412 -452 b 359 -425 393 -452 376 -444 b 187 14 242 -301 179 -158 b 268 334 193 127 212 235 b 387 448 295 383 330 428 b 406 452 395 451 400 452 b 428 444 413 452 420 449 b 517 324 471 413 497 372 b 586 -29 560 222 586 86 b 556 -271 586 -112 585 -193 b 468 -422 536 -327 508 -377 b 412 -452 449 -442 431 -452 z"
                },
                timeSig1: {
                    x_min: 20,
                    x_max: 283,
                    y_min: -364,
                    y_max: 366,
                    ha: 730,
                    o: "m 264 -524 b 357 -510 297 -524 325 -516 b 374 -490 369 -508 374 -501 b 380 -438 376 -472 380 -455 l 406 246 b 408 301 408 265 408 282 b 400 445 408 348 405 396 b 288 527 395 491 338 527 b 253 520 276 527 264 526 b 240 508 249 517 245 513 b 49 409 192 445 127 413 b 29 396 33 408 29 403 b 32 380 29 392 30 386 b 59 363 36 366 49 364 b 164 348 95 356 130 348 b 222 357 183 348 203 351 b 238 361 228 360 233 360 b 252 334 248 361 252 353 b 243 59 252 242 249 150 b 219 -490 229 -124 233 -307 b 264 -524 217 -516 232 -524 z"
                },
                timeSig2: {
                    x_min: 20,
                    x_max: 660,
                    y_min: -379,
                    y_max: 382,
                    ha: 761,
                    o: "m 99 -543 b 130 -533 111 -550 121 -540 b 255 -448 168 -501 213 -475 b 338 -425 282 -431 310 -425 b 392 -431 356 -425 374 -426 b 485 -462 423 -438 454 -451 b 648 -497 540 -482 595 -497 b 834 -441 711 -497 773 -480 b 950 -242 906 -395 958 -334 b 942 -210 950 -230 950 -215 b 912 -220 932 -204 920 -213 b 861 -264 894 -235 877 -248 b 775 -317 835 -289 808 -305 b 675 -334 742 -328 708 -334 b 510 -295 619 -334 563 -318 b 372 -264 465 -278 420 -264 b 305 -272 350 -264 328 -266 b 331 -242 318 -256 324 -249 b 490 -73 386 -187 438 -131 b 675 340 595 43 664 180 b 677 369 677 350 677 360 b 556 536 677 461 638 508 b 468 550 526 546 497 550 b 297 508 409 550 353 533 b 111 354 220 475 168 412 b 29 197 65 308 29 261 b 32 164 29 187 29 176 b 29 140 33 157 29 147 b 43 125 29 132 32 125 b 73 147 55 125 65 138 b 86 163 79 153 82 158 b 238 320 134 219 183 272 b 425 389 292 367 360 389 b 575 341 480 389 531 373 b 606 298 590 330 606 317 b 600 278 606 292 603 285 b 501 107 576 217 544 158 b 304 -104 439 33 372 -35 b 111 -356 230 -180 167 -265 b 84 -446 92 -386 84 -415 b 86 -481 84 -458 85 -469 b 88 -514 88 -491 88 -503 b 99 -543 89 -526 91 -537 z"
                },
                timeSig3: {
                    x_min: 20,
                    x_max: 540,
                    y_min: -392,
                    y_max: 392,
                    ha: 784,
                    o: "m 216 -540 b 354 -564 264 -556 310 -564 b 605 -465 445 -564 530 -530 b 729 -161 697 -383 729 -275 b 724 -82 729 -135 727 -108 b 589 95 716 -1 670 62 b 523 114 567 102 546 108 b 750 418 606 213 677 315 b 778 503 769 444 778 472 b 773 540 778 514 776 527 b 750 564 769 557 762 564 b 736 562 746 564 742 563 b 641 552 704 553 672 552 b 402 554 562 552 481 554 l 346 554 b 84 546 258 554 170 554 b 36 501 55 543 40 531 b 29 412 30 472 32 442 b 52 384 27 393 32 384 l 56 384 b 210 392 107 389 158 392 l 602 392 b 354 108 523 285 445 192 b 246 -65 300 58 246 12 b 252 -108 246 -78 248 -92 l 252 -111 b 264 -141 251 -122 251 -135 b 291 -132 274 -145 284 -140 b 425 -72 328 -95 377 -84 b 475 -65 442 -68 459 -65 b 592 -108 517 -65 557 -79 b 645 -179 615 -125 645 -147 b 642 -194 645 -184 644 -189 b 485 -376 616 -278 569 -344 b 361 -399 444 -392 402 -399 b 151 -340 289 -399 219 -376 b 88 -275 122 -323 98 -310 b 71 -249 86 -268 85 -249 b 63 -251 68 -249 66 -249 b 36 -288 48 -255 36 -266 b 55 -423 33 -336 45 -377 b 101 -482 60 -448 78 -468 b 216 -540 138 -504 174 -526 z"
                },
                timeSig4: {
                    x_min: 20,
                    x_max: 633,
                    y_min: -490,
                    y_max: 491,
                    ha: 981,
                    o: "m 608 -704 b 641 -684 622 -708 634 -696 b 667 -602 660 -660 662 -631 b 685 -190 683 -465 680 -327 l 685 -176 b 831 -127 736 -166 783 -148 b 912 0 901 -94 913 -76 b 886 53 912 36 904 52 b 848 40 877 53 864 49 l 838 36 b 687 -13 789 14 739 -3 b 681 177 687 50 684 114 b 672 338 678 230 677 285 b 654 373 671 350 672 373 b 622 340 636 373 624 361 b 615 262 621 314 613 288 b 619 -22 616 167 619 72 b 569 -22 602 -23 585 -23 b 305 -3 481 -16 395 -1 b 210 -9 274 -3 242 -4 b 301 163 242 52 268 108 b 513 552 377 288 459 412 b 536 652 526 585 536 618 b 533 683 536 662 534 672 b 520 707 531 691 531 707 b 487 693 508 708 494 704 b 474 668 482 684 477 677 b 384 490 454 603 418 547 b 253 281 343 419 295 351 b 73 -13 194 181 145 78 b 29 -108 50 -42 29 -72 b 37 -147 29 -121 32 -134 b 50 -186 43 -160 50 -173 b 68 -216 52 -207 56 -215 b 92 -207 73 -216 82 -213 b 288 -166 156 -180 220 -166 b 556 -186 377 -166 467 -180 b 586 -189 566 -187 576 -187 b 616 -186 596 -189 606 -189 b 606 -432 613 -268 612 -350 b 596 -625 603 -495 596 -559 b 598 -670 596 -641 596 -655 b 608 -704 598 -683 596 -700 z"
                },
                timeSig5: {
                    x_min: 20,
                    x_max: 583,
                    y_min: -389,
                    y_max: 389,
                    ha: 778,
                    o: "m 132 -536 b 249 -560 168 -553 209 -559 b 507 -462 351 -560 454 -514 b 677 -183 588 -384 642 -289 b 694 -85 688 -150 694 -117 b 540 138 694 12 642 94 b 422 173 501 154 462 167 b 400 187 408 174 400 177 b 405 202 400 190 402 196 b 428 284 416 228 426 255 b 469 312 431 307 442 312 b 757 372 569 312 662 343 b 840 490 821 392 840 432 b 812 560 840 540 834 560 b 763 546 801 560 785 556 b 757 543 762 546 759 544 b 465 484 665 505 570 484 b 396 484 452 484 425 487 b 353 454 377 482 366 474 b 281 300 323 405 304 351 b 245 164 262 255 245 212 b 246 144 245 158 246 151 b 233 63 249 115 243 89 b 225 35 228 50 225 40 b 264 14 225 22 236 19 b 445 -26 325 7 387 0 b 569 -151 501 -52 547 -89 b 575 -180 573 -161 575 -170 b 527 -275 575 -217 547 -245 b 347 -367 484 -334 419 -367 b 261 -351 318 -367 289 -363 b 95 -300 206 -333 154 -307 b 55 -321 73 -297 65 -302 b 29 -468 29 -367 40 -419 b 56 -505 26 -482 36 -500 b 132 -536 82 -514 108 -524 z"
                },
                timeSig6: {
                    x_min: 20,
                    x_max: 565,
                    y_min: -363,
                    y_max: 363,
                    ha: 726,
                    o: "m 390 -518 b 621 -458 469 -507 549 -494 b 814 -134 753 -390 814 -281 b 652 59 814 -16 750 58 b 580 48 629 59 606 55 b 233 -334 392 -9 276 -138 b 115 -228 181 -314 143 -278 b 98 -160 104 -206 98 -183 b 107 -109 98 -144 101 -127 b 167 37 124 -59 145 -12 b 508 340 236 189 347 292 b 575 353 530 347 553 353 b 648 327 600 353 625 346 b 665 320 654 321 661 320 b 687 336 674 320 681 325 b 703 405 697 359 703 382 b 684 472 703 429 697 451 b 593 523 664 504 631 521 b 576 521 588 523 582 523 b 297 403 472 508 380 465 b 115 177 217 344 164 264 b 29 -121 60 82 29 -17 b 53 -278 29 -173 36 -225 b 226 -497 82 -374 131 -454 b 347 -523 265 -514 305 -523 b 390 -518 361 -523 376 -521 z m 351 -357 b 312 -351 337 -356 320 -363 b 325 -315 304 -340 320 -327 b 543 -120 373 -222 448 -158 b 622 -104 570 -108 596 -102 b 717 -132 655 -104 687 -112 b 740 -167 732 -143 740 -153 b 730 -196 740 -176 737 -184 b 563 -321 690 -258 634 -300 b 359 -357 497 -341 428 -354 z"
                },
                timeSig7: {
                    x_min: 20,
                    x_max: 592,
                    y_min: -345,
                    y_max: 345,
                    ha: 690,
                    o: "m 253 -497 b 318 -485 276 -497 297 -487 b 366 -441 348 -482 360 -468 b 487 -104 390 -323 433 -210 b 835 403 580 82 701 246 b 852 436 847 416 852 428 b 815 467 852 451 840 461 b 762 474 798 471 779 474 b 674 445 732 474 701 465 b 603 410 652 431 628 420 b 383 360 533 379 459 360 b 200 435 315 360 249 382 b 88 494 168 469 131 485 b 66 497 81 495 73 497 b 33 484 52 497 39 492 b 50 436 22 469 39 451 b 295 310 114 360 199 324 b 406 301 331 304 369 301 b 593 324 468 301 530 308 b 585 307 589 314 588 310 b 265 -249 451 137 338 -46 b 207 -442 242 -312 223 -377 b 204 -462 206 -449 204 -456 b 253 -497 204 -487 220 -497 z"
                },
                timeSig8: {
                    x_min: 20,
                    x_max: 504,
                    y_min: -428,
                    y_max: 428,
                    ha: 856,
                    o: "m 265 -616 b 289 -615 274 -616 281 -616 b 710 -271 492 -592 657 -485 b 726 -148 721 -229 727 -187 b 585 108 726 -48 687 42 b 572 127 576 114 573 120 b 576 144 572 132 575 138 b 598 301 590 196 598 249 b 586 413 598 338 593 376 b 356 616 559 531 467 616 b 233 582 317 616 275 606 b 29 233 101 505 29 384 b 104 9 29 153 46 72 b 189 -48 127 -16 160 -27 b 92 -158 141 -73 114 -114 b 37 -343 63 -217 50 -279 b 33 -390 35 -359 33 -374 b 265 -616 33 -524 148 -616 z m 258 105 b 124 148 215 105 167 117 b 96 196 105 163 96 177 b 99 217 96 202 96 209 b 197 384 120 281 151 337 b 350 451 242 429 297 451 b 516 364 412 451 472 422 b 530 331 523 354 530 343 l 530 327 l 530 320 b 468 151 520 261 507 200 b 419 122 455 135 442 125 b 258 105 370 117 320 105 z m 328 -438 b 158 -276 233 -436 160 -359 b 166 -239 158 -264 161 -252 b 230 -157 176 -203 202 -179 b 367 -72 274 -125 320 -98 b 448 -49 396 -56 423 -49 b 562 -118 491 -49 528 -72 b 611 -251 590 -157 611 -199 b 569 -341 611 -288 595 -318 b 328 -438 500 -402 416 -432 z"
                },
                timeSig9: {
                    x_min: 20,
                    x_max: 494,
                    y_min: -421,
                    y_max: 421,
                    ha: 842,
                    o: "m 235 -606 b 361 -564 275 -606 318 -593 b 619 -229 487 -482 566 -366 b 706 127 664 -114 694 4 b 711 233 708 163 711 197 b 700 346 711 271 708 308 b 389 606 658 517 530 606 b 351 605 376 606 364 606 b 56 272 171 586 56 441 b 96 98 56 216 69 156 b 334 -53 144 -3 238 -53 b 544 36 408 -53 484 -24 b 652 176 586 78 622 124 b 631 71 645 141 639 105 b 467 -302 599 -63 562 -196 b 271 -442 412 -364 354 -422 b 225 -448 255 -446 239 -448 b 95 -305 148 -448 98 -395 b 89 -255 95 -288 94 -271 b 73 -233 86 -246 85 -233 b 52 -248 65 -233 56 -239 b 29 -317 42 -271 30 -291 b 49 -448 29 -361 40 -405 b 235 -606 69 -541 144 -606 z m 340 104 b 144 209 264 108 194 141 b 127 258 132 225 127 240 b 137 297 127 271 130 284 b 366 449 184 396 269 449 b 517 408 415 449 467 436 b 595 348 546 392 572 372 b 616 305 608 336 616 321 b 609 281 616 298 613 289 b 340 104 557 184 477 104 z"
                },
                timeSigCommon: {
                    x_min: 20,
                    x_max: 585,
                    y_min: -298,
                    y_max: 294,
                    ha: 592,
                    o: "m 444 -405 b 829 -45 626 -346 740 -207 b 842 26 842 -23 842 1 b 821 58 842 39 841 58 b 795 40 811 58 802 48 b 765 3 785 29 773 16 b 469 -223 690 -104 596 -183 b 354 -242 431 -235 392 -242 b 180 -177 292 -242 235 -223 b 135 -99 154 -157 140 -131 b 132 -59 134 -85 132 -72 b 141 7 132 -37 135 -16 b 449 274 189 160 297 243 b 477 278 459 276 468 276 b 546 203 517 278 539 253 b 517 157 550 177 533 166 b 485 143 507 153 497 143 l 482 143 b 467 148 478 143 472 144 b 374 183 438 170 406 181 b 264 118 333 183 292 161 b 238 48 246 92 238 69 b 261 -9 238 29 245 10 b 383 -73 287 -39 337 -73 b 412 -68 392 -73 402 -72 b 631 164 526 -27 586 59 b 649 252 644 193 649 222 b 636 328 649 278 645 304 b 504 423 615 400 579 429 b 242 318 408 415 317 387 b 29 -158 104 190 29 33 b 30 -176 29 -164 29 -170 b 115 -364 42 -246 52 -315 b 307 -429 177 -410 240 -429 b 444 -405 351 -429 397 -420 z"
                },
                timeSigCutCommon: {
                    x_min: 20,
                    x_max: 695,
                    y_min: -687,
                    y_max: 687,
                    ha: 1374,
                    o: "m 564 -989 b 595 -945 585 -991 589 -963 l 599 -922 b 605 -628 600 -824 603 -726 l 609 -399 b 878 -251 706 -363 798 -320 b 996 -85 932 -204 976 -153 b 1001 -63 998 -78 1001 -71 b 989 -46 1001 -56 998 -49 b 978 -43 985 -45 982 -43 b 950 -59 968 -43 959 -49 b 733 -216 894 -132 815 -177 b 611 -259 694 -235 652 -249 b 616 -20 612 -179 615 -99 b 680 29 642 -7 665 9 b 698 43 685 36 690 40 b 870 251 792 82 840 160 b 877 294 874 265 877 279 b 818 410 877 338 855 382 b 683 458 779 442 730 448 b 625 468 664 462 644 465 l 625 514 b 638 958 626 662 636 811 b 626 989 638 979 635 989 b 603 981 621 989 613 986 b 422 840 534 945 481 888 b 412 805 412 832 413 818 b 426 713 410 773 420 743 b 445 678 429 690 435 678 b 474 691 452 678 461 683 b 563 755 503 710 530 732 b 564 724 564 740 564 733 b 559 469 563 639 560 554 b 462 454 526 469 494 464 b 112 143 302 399 199 281 b 33 -94 66 71 45 -10 b 29 -148 30 -112 29 -131 b 105 -351 29 -223 52 -291 b 359 -455 171 -426 258 -451 b 517 -431 409 -451 464 -446 l 539 -422 l 539 -477 b 533 -739 536 -563 539 -651 b 530 -824 531 -768 530 -795 b 546 -948 530 -865 533 -907 b 564 -989 552 -962 543 -989 z m 410 -288 b 193 -197 328 -288 253 -264 b 141 -60 160 -161 141 -108 b 157 6 141 -35 147 -12 b 259 158 189 58 217 112 b 438 291 311 215 364 266 b 528 305 468 301 498 305 b 554 304 537 305 546 304 b 553 212 554 274 554 242 b 426 115 498 199 446 164 b 416 68 419 99 416 84 b 425 12 416 49 420 30 b 474 -39 432 -17 448 -32 b 513 -43 487 -42 498 -43 b 547 -40 524 -43 536 -42 l 543 -272 b 461 -285 516 -278 488 -281 b 410 -288 444 -287 426 -288 z m 694 197 b 668 203 685 197 677 199 b 621 216 654 210 638 215 b 622 294 622 242 622 268 b 706 268 651 287 678 278 b 746 235 721 261 734 249 b 752 222 749 230 752 226 b 743 213 752 219 749 215 b 694 197 727 206 711 197 z"
                },
                timeSigPlus: {
                    x_min: 0,
                    x_max: 661,
                    y_min: -358,
                    y_max: 358,
                    ha: 716,
                    o: "m 605 -516 b 629 -490 624 -516 629 -507 b 628 -475 629 -485 628 -481 b 613 -131 624 -405 616 -174 b 612 -96 612 -114 612 -96 l 647 -98 b 897 -115 730 -99 814 -109 b 940 -89 919 -117 935 -109 b 952 -24 946 -69 952 -46 b 948 9 952 -14 950 -3 b 912 39 942 26 933 37 b 609 60 822 48 609 60 b 616 392 609 60 608 291 b 567 488 619 436 605 467 b 511 516 550 498 531 514 b 498 511 507 516 503 514 b 478 446 475 501 480 469 b 467 150 474 348 469 249 b 465 59 465 121 465 59 l 372 49 b 73 14 272 36 173 24 b 49 13 65 13 56 13 b 0 -33 9 13 0 6 b 60 -141 0 -117 6 -140 b 112 -135 73 -141 91 -140 b 413 -102 213 -125 314 -112 b 464 -98 441 -99 464 -98 l 464 -145 b 477 -456 464 -249 468 -353 b 526 -510 478 -488 491 -507 b 589 -513 546 -511 569 -510 b 605 -516 595 -514 600 -516 z"
                },
                timeSigPlusSmall: {
                    x_min: 0,
                    x_max: 418,
                    y_min: -197,
                    y_max: 199,
                    ha: 396,
                    o: "m 301 -284 b 330 -238 320 -284 324 -255 b 348 -46 350 -176 341 -111 b 374 -20 351 -27 356 -23 b 481 -17 409 -16 445 -17 b 566 -9 510 -17 537 -16 b 602 3 579 -7 602 -16 b 566 29 602 19 582 24 b 526 33 553 32 539 33 b 384 39 478 36 432 39 b 356 62 363 39 356 42 l 356 68 b 359 177 359 104 359 141 l 359 251 b 341 287 359 264 361 285 b 311 255 324 287 314 272 b 310 228 311 246 310 236 l 301 69 b 275 39 301 49 295 39 l 271 39 b 210 40 251 40 230 40 b 167 39 196 40 181 40 b 89 40 141 37 115 40 b 24 30 68 40 46 37 b 0 17 17 27 0 30 l 0 13 b 27 -17 3 0 7 -13 b 91 -22 49 -22 71 -22 b 153 -22 115 -22 137 -20 l 275 -22 b 295 -40 289 -22 295 -27 l 295 -48 b 288 -235 288 -109 287 -171 b 287 -264 288 -243 287 -253 b 301 -284 287 -275 289 -284 z"
                },
                timeSigMinus: {
                    x_min: 0,
                    x_max: 662,
                    y_min: -54,
                    y_max: 55,
                    ha: 109,
                    o: "m 39 -78 b 49 -76 42 -78 45 -76 b 452 -75 94 -75 272 -75 b 861 -76 632 -75 814 -76 b 953 -20 927 -79 953 -66 b 948 27 953 -7 950 9 b 946 37 948 30 948 35 b 896 79 940 63 929 79 b 471 78 827 78 648 78 l 42 78 b 0 37 14 78 0 69 b 23 -66 0 0 17 -32 b 39 -78 24 -75 32 -76 z"
                },
                timeSigParensRight: {
                    x_min: 0,
                    x_max: 274,
                    y_min: -723,
                    y_max: 725,
                    ha: 1448,
                    o: "m 37 -1038 b 69 -1031 48 -1044 59 -1038 b 88 -1015 76 -1027 82 -1021 b 164 -886 120 -976 147 -933 b 333 -351 233 -711 292 -534 b 395 118 366 -204 399 -59 b 389 245 392 144 392 194 b 120 996 369 521 265 766 b 68 1044 99 1030 84 1044 b 19 988 50 1044 36 1024 b 0 922 7 965 0 945 b 20 858 0 901 6 881 b 259 215 141 660 236 449 b 271 -1 266 143 271 71 b 252 -239 271 -82 265 -161 b 148 -667 228 -384 183 -524 b 39 -1009 120 -785 66 -893 b 33 -1031 37 -1017 33 -1024 b 37 -1038 33 -1034 35 -1037 z"
                },
                timeSigParensRightSmall: {
                    x_min: 0,
                    x_max: 154,
                    y_min: -422,
                    y_max: 422,
                    ha: 844,
                    o: "m 43 -608 b 60 -598 48 -608 53 -605 b 117 -511 82 -572 102 -543 b 222 23 193 -350 219 -177 b 213 166 225 55 216 109 b 115 531 206 294 174 416 b 45 603 99 562 76 588 b 30 608 39 606 35 608 b 10 598 23 608 17 603 b 0 546 3 590 0 570 b 23 451 0 507 9 458 b 102 351 66 429 84 390 b 167 42 150 252 167 148 b 163 -49 167 12 166 -19 b 35 -449 151 -192 121 -330 b 14 -504 22 -467 14 -485 b 17 -527 14 -511 16 -520 l 30 -590 b 43 -608 33 -603 37 -608 z"
                },
                timeSigParensLeft: {
                    x_min: 1,
                    x_max: 400,
                    y_min: -728,
                    y_max: 728,
                    ha: 1456,
                    o: "m 562 -1048 b 573 -1043 566 -1048 570 -1047 b 553 -988 582 -1025 564 -1004 b 472 -884 527 -952 497 -920 b 210 -354 366 -717 275 -541 b 148 -6 170 -240 148 -124 b 160 148 148 45 153 96 b 315 678 189 331 242 508 b 431 901 350 755 380 834 b 459 950 451 926 461 939 b 435 995 459 962 451 972 b 364 1048 405 1034 383 1048 b 305 996 343 1048 325 1028 b 127 624 226 881 174 753 b 1 30 56 432 9 235 b 1 -32 1 9 0 -12 b 180 -629 13 -245 92 -438 b 363 -936 230 -739 298 -835 b 526 -1041 402 -995 448 -1041 b 562 -1048 537 -1040 552 -1048 z"
                },
                timeSigParensLeftSmall: {
                    x_min: 0,
                    x_max: 173,
                    y_min: -405,
                    y_max: 404,
                    ha: 809,
                    o: "m 197 -583 b 222 -553 212 -582 219 -566 b 229 -497 226 -534 229 -516 b 213 -425 229 -472 225 -448 b 102 -177 173 -344 132 -262 b 62 30 78 -111 58 -42 b 91 183 66 82 75 134 b 215 426 118 271 156 356 b 249 552 246 465 252 505 b 230 582 249 563 246 582 b 197 563 219 582 206 576 b 71 356 144 500 105 429 b 0 50 26 259 3 158 b 13 -112 4 -3 7 -58 b 176 -559 29 -275 105 -416 b 196 -583 180 -569 186 -583 z"
                },
                noteheadDoubleWhole: {
                    x_min: 0,
                    x_max: 614,
                    y_min: -223,
                    y_max: 223,
                    ha: 446,
                    o: "m 35 -321 b 62 -266 58 -318 58 -288 l 62 -194 b 63 50 62 -114 63 -32 b 60 189 63 96 63 143 b 43 300 59 226 60 265 b 29 321 40 308 39 321 l 26 321 b 0 292 13 318 0 310 b 0 248 0 278 -1 262 b 6 147 4 215 6 181 b 4 48 6 114 4 81 b 6 0 4 32 6 16 b 7 -36 7 -12 7 -24 l 7 -52 b 6 -156 7 -86 6 -121 b 19 -275 6 -196 9 -236 b 35 -321 23 -291 16 -323 z m 847 -314 b 871 -288 860 -315 867 -300 b 884 -187 881 -255 886 -222 b 876 115 878 -86 876 14 b 877 255 876 161 876 209 b 868 291 877 268 873 279 b 855 304 867 301 863 304 b 844 301 852 304 848 304 b 822 265 825 292 822 278 b 824 251 822 259 822 255 b 822 170 822 225 822 197 l 822 -20 b 835 -284 827 -86 825 -186 b 847 -314 837 -295 835 -311 z m 757 -291 b 793 -171 796 -255 792 -212 b 795 -49 795 -131 795 -91 b 786 207 795 36 791 121 b 779 240 786 217 783 229 b 766 258 776 246 776 258 b 762 256 765 258 763 256 b 739 236 752 253 740 252 b 733 177 737 216 732 197 b 737 20 737 125 739 73 l 737 -107 b 740 -202 737 -138 739 -170 b 757 -291 740 -230 743 -261 z m 128 -261 b 144 -251 135 -264 141 -256 b 158 -203 156 -236 157 -220 b 161 -137 161 -181 161 -158 b 157 30 161 -81 157 -26 b 158 76 157 45 157 60 l 158 101 b 156 225 158 141 158 183 b 137 253 156 235 154 253 l 134 253 b 109 222 120 251 109 242 b 104 91 108 179 104 134 b 108 -58 104 42 109 -9 b 107 -105 108 -73 108 -89 b 105 -127 107 -112 107 -120 b 118 -245 105 -167 114 -204 b 128 -261 118 -252 121 -259 z m 488 -242 b 693 -79 595 -249 685 -166 l 693 -55 b 690 0 693 -36 691 -17 b 540 187 684 84 621 164 b 449 200 508 196 480 200 b 210 104 363 200 282 163 b 186 56 196 92 186 76 b 207 -82 186 9 192 -37 b 300 -204 225 -132 248 -181 b 488 -242 356 -229 415 -240 z m 490 -88 b 449 -86 477 -88 464 -88 b 287 -56 399 -85 341 -78 b 258 -33 275 -52 258 -48 b 282 -7 258 -20 272 -13 b 458 43 340 23 399 43 b 580 14 497 43 537 35 b 618 -20 606 1 619 -9 b 592 -58 618 -30 609 -42 b 490 -88 562 -82 528 -88 z"
                },
                noteheadWhole: {
                    x_min: 0,
                    x_max: 380,
                    y_min: -186,
                    y_max: 165,
                    ha: 351,
                    o: "m 547 40 b 223 -268 543 -151 367 -259 b 102 -233 180 -271 143 -248 l 62 -216 b 0 -127 22 -197 0 -166 b 6 -91 0 -115 1 -104 b 122 141 33 -9 69 71 b 327 238 170 204 249 238 b 514 158 397 238 467 212 b 547 40 544 125 549 84 z m 248 -107 b 384 -63 295 -102 341 -88 b 426 -23 402 -53 415 -40 b 435 3 432 -14 435 -6 b 413 32 435 14 428 24 b 301 73 376 49 343 73 b 272 69 291 73 282 72 b 121 -35 207 53 157 20 b 111 -58 117 -42 111 -50 b 125 -75 111 -65 115 -71 b 248 -107 164 -89 202 -107 z"
                },
                noteheadHalf: {
                    x_min: 0,
                    x_max: 334,
                    y_min: -174,
                    y_max: 175,
                    ha: 349,
                    o: "m 480 56 b 167 -251 478 -115 331 -251 b 94 -242 143 -251 118 -248 b 9 -141 43 -229 20 -192 b 0 -68 3 -115 0 -91 b 284 249 0 95 127 200 b 304 252 289 251 297 252 b 481 78 374 252 481 170 b 480 56 481 71 481 63 z m 213 -102 b 399 6 274 -81 341 -48 b 402 17 400 7 402 13 b 399 27 402 22 400 26 b 311 94 373 53 353 88 b 292 95 305 95 300 95 b 130 27 230 95 181 55 b 69 -62 98 9 62 -29 b 161 -98 76 -98 128 -91 b 213 -102 174 -101 186 -101 z"
                },
                noteheadBlack: {
                    x_min: 0,
                    x_max: 334,
                    y_min: -164,
                    y_max: 164,
                    ha: 328,
                    o: "m 112 -233 b 141 -236 122 -235 131 -236 b 481 104 279 -236 485 -48 b 403 222 477 141 478 192 b 334 236 382 232 359 236 b 1 -59 180 236 13 59 b 0 -85 1 -68 0 -76 b 112 -233 0 -157 32 -215 z"
                },
                noteheadXDoubleWhole: {
                    x_min: 0,
                    x_max: 730,
                    y_min: -266,
                    y_max: 267,
                    ha: 533,
                    o: "m 1018 -373 b 1032 -361 1025 -376 1028 -367 b 1051 -287 1047 -338 1051 -314 b 1050 -252 1051 -276 1051 -264 b 1030 186 1031 -107 1037 40 b 1031 266 1028 213 1031 239 b 1018 363 1031 300 1028 331 b 1005 384 1015 373 1017 384 l 1004 384 b 984 363 992 384 986 373 b 982 343 982 356 982 348 b 981 235 982 307 981 271 b 996 -285 981 60 986 -112 b 1009 -360 998 -311 1005 -336 b 1018 -373 1011 -364 1014 -373 z m 16 -383 b 49 -328 39 -367 48 -350 b 69 56 58 -202 62 -73 b 75 212 72 107 72 160 b 78 278 76 233 78 255 b 59 382 78 312 73 347 b 29 328 33 372 29 350 b 13 -29 29 209 23 88 b 3 -222 7 -95 10 -157 b 0 -265 1 -236 0 -252 b 16 -383 0 -304 6 -343 z m 923 -314 b 955 -240 948 -289 952 -265 b 965 -65 962 -181 965 -125 b 963 0 965 -45 965 -22 b 962 111 960 37 962 73 b 953 240 962 154 960 197 b 939 275 952 253 952 275 b 913 239 924 274 913 258 b 913 173 914 217 913 194 b 914 135 913 160 913 147 b 920 27 919 98 920 63 b 909 -128 920 -26 917 -78 b 906 -179 906 -147 906 -163 b 923 -314 906 -223 913 -266 z m 121 -301 b 143 -272 134 -301 138 -284 b 147 -255 145 -268 145 -261 b 173 160 161 -117 166 22 b 173 233 173 184 174 209 b 157 264 171 243 171 264 b 137 235 143 264 138 249 b 132 207 135 226 132 216 b 121 43 128 153 124 96 b 105 -186 117 -36 105 -111 b 111 -269 105 -215 107 -242 b 121 -301 114 -281 104 -300 z m 210 -238 b 376 -193 274 -239 327 -226 b 471 -134 406 -173 439 -154 b 534 -94 491 -120 513 -107 b 671 -192 579 -127 624 -161 b 733 -226 691 -204 708 -228 b 746 -225 737 -228 742 -226 b 845 -204 782 -226 814 -213 b 868 -194 854 -203 865 -203 b 852 -173 871 -183 860 -179 b 661 -40 789 -128 724 -84 b 642 -27 654 -36 648 -32 b 861 114 716 17 791 63 b 886 132 870 120 886 121 l 886 137 b 852 164 883 151 867 161 b 776 176 827 170 801 176 b 685 145 744 176 714 168 b 530 45 638 107 583 76 b 403 132 487 73 444 101 b 279 176 364 161 324 171 b 223 160 259 176 229 176 b 258 115 215 141 242 127 b 431 -17 314 71 372 26 b 173 -196 341 -73 253 -130 b 157 -209 168 -200 157 -203 b 158 -215 157 -212 157 -215 b 183 -236 166 -223 168 -235 b 210 -238 194 -236 206 -239 z m 768 -207 b 533 -40 687 -150 609 -94 b 321 -173 462 -85 392 -130 b 261 -194 304 -184 287 -196 b 239 -193 253 -196 246 -194 b 387 -95 294 -157 340 -125 b 505 -20 426 -71 465 -45 l 484 -4 b 353 89 441 27 396 56 b 320 115 341 96 330 107 b 297 141 311 124 297 132 b 300 148 297 144 298 145 b 336 135 311 164 324 143 b 528 -4 400 89 464 42 l 723 121 b 770 140 737 131 753 138 b 792 132 779 140 789 141 b 778 115 795 122 783 120 b 586 -6 714 75 651 35 b 557 -24 576 -13 567 -19 b 726 -147 613 -66 670 -109 b 768 -207 744 -161 765 -173 z"
                },
                noteheadXWhole: {
                    x_min: 0,
                    x_max: 506,
                    y_min: -143,
                    y_max: 144,
                    ha: 287,
                    o: "m 53 -206 b 219 -163 117 -207 170 -196 b 314 -102 249 -141 282 -122 b 377 -63 334 -89 356 -76 b 514 -161 422 -96 468 -128 b 576 -196 534 -174 552 -196 b 589 -193 580 -196 585 -196 b 688 -174 625 -194 657 -181 b 711 -158 698 -171 711 -173 b 696 -143 711 -151 701 -147 b 503 -9 632 -98 567 -52 l 485 4 b 704 145 559 49 634 95 b 729 164 711 150 729 151 l 729 168 b 696 196 726 183 710 193 b 621 207 671 202 645 207 b 528 177 589 207 557 200 b 373 76 480 140 426 108 b 246 164 330 104 287 132 b 122 206 207 193 167 203 b 66 192 102 207 72 207 b 99 147 58 173 85 158 b 274 14 157 102 215 58 b 16 -164 184 -42 96 -98 b 0 -179 12 -168 0 -170 b 1 -183 0 -180 0 -183 b 26 -204 6 -193 12 -204 b 53 -206 37 -206 49 -206 z m 611 -177 b 376 -9 530 -118 452 -63 l 164 -143 b 104 -164 147 -154 130 -164 b 82 -161 96 -164 89 -164 b 230 -65 137 -125 183 -95 l 347 12 b 327 26 341 16 334 22 l 196 121 b 163 147 184 128 173 137 b 140 173 154 154 140 163 b 143 180 140 176 141 177 b 179 166 154 194 167 174 l 372 27 l 566 153 b 613 171 580 161 596 170 b 635 160 624 171 635 174 b 621 147 635 153 626 150 l 429 24 b 400 6 419 19 409 13 b 569 -117 456 -35 513 -75 b 611 -177 588 -130 608 -143 z"
                },
                noteheadXHalf: {
                    x_min: 0,
                    x_max: 421,
                    y_min: -146,
                    y_max: 151,
                    ha: 297,
                    o: "m 490 -209 b 539 -207 505 -207 521 -207 b 606 -209 560 -207 583 -209 b 598 -196 602 -203 600 -199 l 406 -19 l 540 130 b 547 144 546 135 547 140 b 536 156 547 148 543 153 b 488 192 518 166 503 176 b 416 217 471 209 444 217 b 323 180 380 217 344 204 l 264 115 b 239 138 256 122 248 131 b 33 197 180 196 108 200 b 3 186 23 197 6 193 b 19 154 -1 174 10 163 b 171 12 69 107 120 59 b 19 -157 120 -45 69 -101 b 0 -177 14 -163 0 -166 b 1 -181 0 -179 0 -180 b 39 -203 9 -197 22 -203 l 186 -203 b 197 -202 190 -202 193 -200 l 213 -202 b 262 -180 228 -202 246 -199 l 314 -122 b 490 -209 363 -170 412 -216 z m 435 -148 b 291 -30 379 -112 337 -69 l 213 -118 b 190 -137 207 -125 202 -137 b 145 -111 173 -130 154 -127 b 160 -79 137 -98 151 -88 b 238 16 184 -48 212 -16 b 141 99 204 43 173 72 l 124 117 b 115 132 121 121 115 127 b 118 137 115 134 117 137 b 141 132 127 147 135 138 l 253 36 b 347 150 285 75 315 112 b 370 164 354 160 363 163 b 403 145 382 164 393 156 b 416 127 412 140 416 132 b 405 102 416 118 412 111 l 307 -10 b 413 -105 343 -42 379 -73 b 435 -148 425 -115 436 -125 z"
                },
                noteheadXBlack: {
                    x_min: 0,
                    x_max: 289,
                    y_min: -156,
                    y_max: 157,
                    ha: 313,
                    o: "m 23 -225 b 69 -204 40 -223 56 -219 b 137 -131 92 -180 115 -157 l 209 -50 b 377 -197 264 -101 321 -148 b 403 -210 384 -203 393 -210 l 408 -210 b 416 -192 416 -207 416 -199 l 416 -186 b 403 -148 416 -171 413 -158 b 344 -81 384 -125 367 -101 b 252 -1 312 -55 282 -29 b 377 157 297 49 340 101 b 402 202 387 170 402 187 b 395 217 402 207 400 213 b 376 226 389 223 382 226 b 334 192 360 226 346 204 b 206 42 289 143 248 94 b 96 161 167 81 131 120 b 60 193 86 174 76 189 b 33 206 52 196 42 206 b 22 199 29 206 26 204 b 10 173 14 190 10 181 b 22 147 10 166 14 157 b 148 7 62 98 104 52 b 164 -7 154 1 158 -3 b 10 -189 111 -66 55 -122 b 0 -212 6 -197 0 -203 b 1 -217 0 -213 0 -216 b 23 -225 4 -226 14 -222 z"
                },
                noteheadCircleXDoubleWhole: {
                    x_min: 0,
                    x_max: 437,
                    y_min: -220,
                    y_max: 219,
                    ha: 439,
                    o: "m 10 -304 b 40 -206 43 -275 37 -239 b 55 168 48 -81 50 45 b 53 269 56 202 55 236 b 33 315 52 287 46 314 b 3 269 9 317 4 291 b 0 239 1 259 0 249 l 0 -196 b 10 -304 1 -232 7 -268 z m 592 -317 b 621 -220 619 -287 621 -253 b 622 -121 622 -187 622 -154 b 625 -20 622 -88 622 -55 b 629 101 628 20 629 60 b 628 220 629 141 628 181 b 618 253 628 232 625 243 b 608 275 613 259 616 274 b 602 272 606 275 603 275 b 575 249 590 269 575 266 l 575 246 b 573 222 575 239 573 230 l 573 -50 b 592 -317 575 -137 570 -225 z m 79 -285 b 114 -6 96 -261 109 -131 b 117 -63 114 -24 114 -45 b 249 -242 124 -151 166 -212 b 324 -256 275 -252 300 -256 b 504 -137 406 -256 478 -209 b 505 -265 504 -180 505 -222 b 513 -282 505 -269 510 -275 b 533 -248 526 -272 528 -261 b 540 -174 539 -223 540 -199 l 540 -127 b 553 207 546 -16 549 95 b 543 232 553 216 554 232 b 518 207 530 233 518 222 b 511 118 520 177 510 148 l 511 92 b 330 216 488 174 420 223 b 301 215 320 216 311 216 b 122 65 202 204 151 163 b 114 9 117 46 114 27 b 115 75 114 32 115 53 b 101 248 115 157 109 228 b 76 206 78 242 76 225 l 76 91 b 75 -26 76 52 76 13 b 69 -189 72 -81 66 -134 b 79 -285 71 -219 76 -249 z m 317 4 b 219 109 285 40 252 75 l 209 120 b 331 153 248 141 289 151 b 420 137 360 153 390 147 b 446 120 435 131 442 127 l 436 108 l 328 -7 z m 215 -131 b 216 -101 215 -122 215 -114 b 219 -45 217 -82 219 -63 b 197 94 219 3 213 49 l 197 95 b 199 94 199 95 199 94 l 310 -27 b 233 -108 285 -55 259 -81 z m 442 -141 b 432 -122 441 -134 436 -128 l 344 -26 l 426 58 l 445 81 b 444 75 445 78 444 76 b 428 -13 433 46 428 16 b 446 -104 428 -45 433 -75 b 452 -122 449 -111 452 -117 b 442 -141 452 -131 448 -137 z m 323 -190 b 272 -180 305 -187 288 -184 b 217 -158 239 -173 225 -168 l 327 -45 b 330 -48 328 -46 328 -48 b 432 -150 363 -82 393 -121 b 323 -190 400 -174 364 -189 z"
                },
                noteheadCircleXWhole: {
                    x_min: 0,
                    x_max: 323,
                    y_min: -190,
                    y_max: 184,
                    ha: 374,
                    o: "m 156 -258 b 240 -274 184 -268 213 -274 b 455 -101 347 -274 441 -202 b 465 19 462 -60 465 -22 b 464 71 465 36 465 52 b 246 265 455 194 370 274 b 216 264 236 265 226 264 b 12 94 102 251 45 203 b 0 13 3 66 1 40 b 4 -55 0 -10 3 -32 b 156 -258 14 -154 60 -222 z m 245 10 b 233 23 242 14 238 19 b 121 144 196 65 158 104 l 109 154 b 249 192 156 179 202 192 b 351 174 284 192 317 186 b 380 154 366 168 376 163 b 379 153 380 154 380 153 b 369 141 376 148 372 145 b 245 10 327 98 287 53 z m 115 -131 b 118 -96 117 -121 117 -111 b 121 -27 120 -73 121 -50 b 98 124 121 24 115 75 b 96 127 96 125 98 125 b 99 125 98 127 98 125 b 225 -12 140 79 181 33 l 138 -105 b 115 -131 131 -114 122 -121 z m 376 -143 b 363 -121 374 -134 369 -128 b 265 -12 331 -85 298 -48 l 357 85 b 379 111 364 94 372 101 b 377 102 379 108 377 105 b 359 4 364 71 359 37 b 382 -99 359 -32 366 -66 b 387 -121 384 -108 386 -115 b 376 -143 387 -130 382 -135 z m 239 -197 b 181 -187 220 -194 200 -192 b 121 -161 145 -177 128 -173 b 243 -33 161 -118 203 -75 l 248 -36 b 364 -153 285 -75 320 -118 b 239 -197 327 -180 287 -197 z"
                },
                noteheadCircleXHalf: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -179,
                    y_max: 179,
                    ha: 358,
                    o: "m 232 -258 b 435 -94 328 -258 412 -196 b 445 6 444 -60 445 -27 b 444 69 445 27 445 48 b 258 258 439 170 374 258 l 230 258 l 207 256 b 14 107 111 248 45 202 b 0 12 4 75 0 43 b 12 -82 0 -20 4 -50 b 144 -242 27 -160 69 -212 b 232 -258 174 -252 203 -258 z m 192 60 b 115 141 166 88 141 115 l 108 150 b 226 189 141 173 186 189 b 253 186 236 189 245 187 b 305 180 271 183 288 183 b 192 60 268 140 229 101 z m 56 -78 b 45 6 43 -56 45 -23 b 65 84 49 39 50 45 b 85 121 72 96 78 107 b 95 124 88 124 92 127 b 171 39 120 95 145 68 z m 360 -132 b 348 -112 359 -124 353 -118 l 300 -58 l 387 37 b 410 63 397 48 405 56 b 413 26 412 52 413 40 b 360 -132 413 -42 393 -95 z m 232 -183 b 184 -177 217 -183 202 -181 l 281 -78 b 348 -143 301 -101 323 -122 b 232 -183 318 -168 279 -183 z"
                },
                noteheadCircleX: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -179,
                    y_max: 175,
                    ha: 354,
                    o: "m 99 -210 b 236 -258 137 -242 186 -258 b 418 -183 305 -258 374 -230 b 495 33 475 -120 495 -48 b 494 66 495 45 494 55 b 302 252 487 183 405 256 b 181 243 262 249 222 248 b 46 171 128 236 79 219 b 0 19 14 127 0 73 b 99 -210 0 -68 35 -156 z m 245 42 l 124 156 b 200 176 145 166 170 173 b 337 183 245 181 291 184 b 377 176 351 183 364 180 b 245 42 333 131 288 86 z m 392 -99 l 285 3 l 400 121 b 418 154 409 131 418 140 b 465 50 448 130 465 94 b 405 -112 462 -17 439 -73 z m 89 -120 b 48 0 56 -82 48 -42 b 89 112 48 35 59 76 b 109 101 96 111 102 108 l 210 7 l 187 -17 b 89 -120 151 -53 125 -82 z m 176 -183 b 127 -163 158 -179 141 -171 l 252 -32 l 372 -144 b 233 -189 334 -173 285 -189 b 176 -183 215 -189 196 -187 z"
                },
                noteheadCircledDoubleWhole: {
                    x_min: 0,
                    x_max: 672,
                    y_min: -291,
                    y_max: 291,
                    ha: 582,
                    o: "m 27 -419 b 43 -369 37 -403 43 -387 b 49 -82 45 -272 49 -177 b 50 370 50 69 50 219 b 30 419 50 389 50 419 b 7 369 7 419 7 389 b 0 -284 4 151 1 -66 b 16 -418 0 -328 10 -373 z m 945 -374 b 968 -282 963 -343 968 -312 b 966 -245 968 -269 968 -258 b 958 -45 959 -179 962 -111 b 948 262 949 56 952 160 b 936 377 946 301 946 340 b 922 399 933 386 933 399 l 919 397 b 897 374 909 396 899 389 b 894 308 897 353 893 331 b 904 120 899 246 903 183 b 913 -111 907 43 909 -35 b 927 -297 916 -173 919 -235 b 945 -374 930 -320 927 -347 z m 95 -347 b 120 -292 115 -325 117 -310 b 124 -223 122 -269 124 -246 b 122 -141 124 -196 122 -168 b 121 -85 121 -122 121 -104 b 462 -297 170 -209 300 -297 b 727 -219 543 -294 639 -271 b 828 -118 773 -190 808 -157 b 842 -268 831 -168 834 -219 b 851 -288 844 -275 840 -287 b 865 -272 861 -289 863 -279 b 873 -225 871 -256 873 -240 b 873 -171 873 -207 871 -190 b 858 196 868 -48 863 75 b 848 295 857 229 854 262 b 840 315 848 301 850 315 l 837 315 b 816 295 827 314 816 307 b 809 216 815 268 808 243 b 815 102 812 179 814 140 b 672 295 780 176 733 240 b 500 370 621 340 566 370 b 436 361 480 370 459 367 b 120 95 288 321 183 233 l 120 256 b 115 287 120 266 118 276 b 104 305 112 292 115 305 l 101 305 b 82 284 91 304 82 297 b 76 216 81 262 76 239 b 84 -253 78 59 79 -96 b 95 -347 84 -282 89 -311 z m 780 -33 b 779 -24 780 -30 779 -27 b 704 92 766 22 743 62 b 544 173 655 128 599 147 b 400 206 497 194 448 204 b 307 193 369 206 338 202 b 202 118 264 181 226 153 b 235 168 212 135 222 151 b 505 337 302 262 396 312 b 523 338 511 337 517 338 b 611 288 559 338 586 312 b 763 62 678 225 733 151 b 780 -33 776 26 782 -4 z m 435 -88 b 337 -23 387 -88 354 -65 b 333 6 334 -14 333 -6 b 366 86 333 35 344 66 b 456 122 390 111 423 121 b 602 27 517 122 582 88 b 606 1 605 19 606 10 b 575 -49 606 -20 596 -36 b 435 -88 530 -76 481 -82 z m 441 -269 b 194 -96 327 -262 249 -194 b 167 1 176 -62 167 -30 b 177 59 167 22 171 42 b 174 39 176 52 174 46 b 266 -104 174 -27 210 -73 b 511 -151 346 -148 435 -144 l 552 -151 b 740 -104 616 -145 683 -141 b 776 -66 756 -94 769 -81 b 700 -174 766 -105 740 -140 b 441 -269 632 -232 533 -268 z"
                },
                noteheadCircledWhole: {
                    x_min: -50,
                    x_max: 472,
                    y_min: -231,
                    y_max: 232,
                    ha: 463,
                    o: "m 289 -333 b 553 -255 370 -330 465 -307 b 680 -62 635 -206 680 -138 b 662 22 680 -36 674 -7 b 500 259 626 112 573 193 b 327 334 448 304 393 334 b 264 325 307 334 287 331 b -59 49 111 284 4 193 b -72 -19 -68 26 -72 4 b 289 -333 -72 -192 84 -334 z m 608 -69 b 605 -60 606 -66 606 -63 b 530 56 592 -14 570 26 b 372 137 482 92 425 111 b 228 170 324 158 275 168 b 134 157 196 170 166 166 b 29 82 91 145 53 117 b 60 132 37 99 49 115 b 333 301 128 226 223 276 b 350 302 338 301 344 302 b 438 252 386 302 413 276 b 590 26 505 189 560 115 b 608 -69 603 -10 608 -40 z m 262 -124 b 164 -59 215 -124 180 -101 b 160 -32 161 -50 160 -42 b 193 50 160 -3 171 30 b 284 86 217 75 251 85 b 429 -9 344 86 409 52 b 433 -36 432 -17 433 -26 b 402 -85 433 -56 423 -72 b 262 -124 357 -112 307 -118 z m 268 -305 b 22 -132 154 -298 76 -230 b -6 -33 3 -98 -6 -65 b 3 23 -6 -14 -3 6 b 1 3 1 16 1 10 b 94 -140 1 -63 37 -109 b 338 -187 173 -184 261 -180 l 379 -187 b 566 -140 444 -181 510 -177 b 602 -102 582 -130 595 -117 b 526 -210 592 -141 567 -176 b 268 -305 459 -268 360 -304 z"
                },
                noteheadCircledHalf: {
                    x_min: -50,
                    x_max: 393,
                    y_min: -175,
                    y_max: 175,
                    ha: 350,
                    o: "m 540 39 b 408 187 503 94 464 148 b 259 252 356 223 301 252 b 35 192 160 252 95 229 b -68 50 -17 160 -53 112 b -72 13 -71 37 -72 24 b 69 -204 -72 -79 -1 -161 b 246 -252 125 -238 186 -252 b 500 -164 336 -252 426 -219 b 566 -42 543 -132 566 -88 b 540 39 566 -14 557 14 z m 9 -42 b 12 -68 10 -50 10 -59 b -7 6 3 -46 -4 -22 b 131 189 1 98 55 153 b 243 220 167 206 204 215 b 261 222 249 222 255 222 b 377 161 308 222 341 189 b 435 89 402 141 420 117 b 431 92 433 89 432 91 b 346 120 402 102 372 107 b 253 143 314 135 282 143 b 85 79 193 143 138 115 b 9 -42 45 52 10 13 z m 356 39 b 343 1 356 24 351 12 b 206 -111 304 -46 259 -84 b 181 -118 196 -115 189 -118 b 156 -71 163 -118 154 -102 b 238 35 164 -22 199 9 b 324 66 264 52 294 59 b 356 39 348 71 356 62 z m 488 -78 b 392 -176 471 -125 433 -154 b 246 -225 346 -200 297 -217 b 230 -226 240 -226 235 -226 b 157 -204 203 -226 180 -215 b 78 -154 128 -190 101 -174 b 232 -184 128 -171 180 -184 b 344 -161 269 -184 307 -179 b 491 -39 405 -135 455 -94 b 500 -23 495 -33 497 -29 b 488 -78 500 -40 494 -59 z"
                },
                noteheadCircledBlack: {
                    x_min: -70,
                    x_max: 326,
                    y_min: -168,
                    y_max: 192,
                    ha: 360,
                    o: "m 176 -239 b 190 -242 180 -240 186 -240 b 262 -232 213 -242 238 -235 b 469 -19 384 -225 469 -131 b 467 22 469 -6 468 9 b 383 194 455 86 436 151 b 183 276 315 249 251 275 b 32 236 134 276 85 264 b -94 88 -30 207 -75 160 b -101 30 -98 69 -101 49 b 176 -239 -101 -107 9 -251 z m 177 -212 b -30 -27 81 -213 -13 -131 b -33 17 -33 -13 -33 3 b 127 226 -33 111 14 187 b 194 239 151 233 173 238 b 301 203 232 239 266 226 b 364 134 330 184 350 160 b 233 181 341 160 279 180 b 192 171 216 181 202 179 b 13 1 117 131 46 86 b 3 -48 6 -17 3 -33 b 60 -115 3 -79 20 -101 b 203 -135 105 -131 151 -138 b 229 -138 212 -137 220 -137 b 295 -122 251 -138 274 -135 b 400 -33 337 -99 373 -71 b 228 -206 393 -125 330 -192 b 177 -212 209 -209 192 -213 z"
                },
                noteheadDoubleWholeSquare: {
                    x_min: 0,
                    x_max: 474,
                    y_min: -209,
                    y_max: 211,
                    ha: 420,
                    o: "m 648 -301 b 668 -287 658 -304 665 -295 b 683 -209 678 -262 683 -235 b 677 258 681 -55 678 102 b 672 284 677 266 677 276 b 661 304 670 291 672 304 l 658 304 b 635 279 647 301 635 297 b 629 240 635 266 629 252 l 629 236 b 631 225 629 232 631 228 b 583 194 631 197 611 194 l 528 194 b 125 207 393 194 259 202 b 89 207 114 209 101 206 b 63 210 79 207 71 207 b 52 229 55 213 52 220 b 55 258 52 238 55 248 b 53 266 55 261 55 264 b 36 298 48 276 53 298 l 35 298 b 4 264 14 298 7 284 b 0 187 0 238 0 213 b 4 50 0 143 3 96 b 6 -10 6 30 6 10 b 4 -130 6 -50 4 -91 b 12 -268 4 -176 6 -222 b 19 -287 13 -275 10 -284 b 35 -275 26 -288 30 -281 b 52 -220 50 -261 48 -239 b 75 -199 55 -206 58 -199 l 141 -197 l 274 -197 l 634 -197 b 639 -281 635 -219 636 -251 b 648 -301 641 -288 638 -300 z m 72 -66 b 55 -56 59 -69 55 -65 l 55 -50 b 53 53 55 -16 55 20 b 69 73 53 69 60 72 l 79 72 b 330 65 163 66 246 63 l 592 65 b 634 81 606 65 618 71 b 635 -30 634 39 635 6 b 605 -58 635 -49 628 -58 b 451 -60 553 -60 503 -60 b 219 -59 373 -60 295 -59 l 166 -59 b 72 -66 134 -59 104 -60 z"
                },
                noteheadSquareWhite: {
                    x_min: 0,
                    x_max: 350,
                    y_min: -131,
                    y_max: 131,
                    ha: 262,
                    o: "m 468 -189 b 485 -187 474 -189 480 -189 b 500 -176 495 -187 500 -183 b 498 -168 500 -174 498 -171 b 497 -166 498 -167 497 -167 l 498 -164 b 504 -154 503 -163 504 -158 b 503 -138 504 -150 503 -144 l 503 -135 l 503 -94 b 492 66 500 -45 494 10 b 488 135 492 89 488 112 b 484 150 488 141 485 145 b 482 154 482 151 482 153 b 429 189 472 177 456 189 b 53 184 304 186 179 186 l 39 184 b 33 181 36 183 35 183 b 12 160 20 181 12 177 b 0 -109 9 71 4 -19 b 19 -137 0 -125 7 -134 b 23 -151 19 -141 20 -145 b 85 -187 37 -173 55 -187 b 468 -189 212 -187 340 -187 z m 246 -125 l 63 -125 b 66 -111 65 -122 66 -117 b 73 72 69 -50 71 10 l 73 130 b 88 128 78 128 82 128 b 148 130 108 130 128 130 b 271 128 190 130 230 128 l 271 130 l 420 130 b 428 20 425 92 425 56 l 436 -127 l 246 -127 z"
                },
                noteheadSquareBlack: {
                    x_min: 0,
                    x_max: 342,
                    y_min: -130,
                    y_max: 132,
                    ha: 262,
                    o: "m 217 190 b 439 186 304 190 372 190 b 467 180 448 184 458 183 b 492 145 484 176 492 167 b 490 -124 490 56 490 -33 b 488 -141 490 -130 488 -135 b 456 -170 488 -163 478 -168 b 118 -183 344 -176 230 -181 b 29 -184 89 -183 60 -192 b 0 -148 4 -180 0 -168 b 1 29 1 -89 1 -30 l 1 156 b 36 190 3 187 4 190 b 217 190 102 192 168 190 z"
                },
                noteheadTriangleDownDoubleWhole: {
                    x_min: 0,
                    x_max: 510,
                    y_min: -213,
                    y_max: 213,
                    ha: 426,
                    o: "m 16 -307 b 30 -289 26 -307 29 -297 b 43 -236 36 -272 42 -253 l 65 219 b 59 285 62 240 69 264 b 46 307 55 294 58 307 l 43 307 b 19 279 30 304 20 295 b 13 184 17 248 14 216 b 1 -125 9 81 7 -23 b 0 -163 0 -138 0 -150 b 6 -287 0 -204 4 -245 b 16 -307 6 -295 7 -305 z m 707 -294 b 734 -213 733 -271 734 -242 b 729 245 733 -60 730 92 b 719 285 729 259 724 272 b 707 298 716 291 714 298 l 703 298 b 685 284 696 297 687 292 b 683 253 683 274 683 264 b 691 -181 685 108 685 -36 b 707 -294 693 -217 690 -256 z m 108 -238 b 125 -203 125 -238 121 -216 b 127 -190 127 -199 127 -194 b 120 -138 127 -173 120 -156 l 120 -66 b 114 167 120 12 118 89 l 118 161 b 314 -153 184 58 248 -48 b 350 -184 327 -173 338 -184 b 387 -154 361 -184 374 -174 b 567 108 449 -68 508 20 b 626 193 588 137 608 164 b 615 -132 622 85 619 -24 l 615 -166 b 619 -207 615 -180 615 -194 b 638 -226 622 -217 629 -225 b 651 -209 648 -226 649 -216 b 658 -177 655 -199 658 -187 l 658 -171 b 667 49 655 -98 667 -23 b 665 88 667 62 667 75 b 665 220 665 135 667 179 b 641 265 664 238 660 265 b 626 243 629 265 626 255 b 628 222 626 236 628 228 b 612 225 624 223 619 225 b 384 223 537 223 461 223 l 384 225 l 170 225 b 131 215 157 225 144 222 b 112 200 122 210 117 206 b 88 266 111 225 108 249 b 75 239 76 259 75 249 b 73 147 75 207 73 179 b 82 -189 73 35 79 -78 b 84 -203 82 -194 82 -199 b 108 -238 86 -219 91 -238 z m 361 -79 b 295 78 336 -26 314 26 b 284 151 287 101 284 125 b 310 177 284 171 291 177 b 419 176 346 176 383 174 l 423 176 b 445 153 441 176 445 168 l 445 147 b 361 -79 442 65 415 -10 z"
                },
                noteheadTriangleDownWhole: {
                    x_min: 0,
                    x_max: 366,
                    y_min: -145,
                    y_max: 138,
                    ha: 283,
                    o: "m 242 -209 b 279 -180 253 -209 266 -200 b 459 84 341 -92 400 -4 b 520 170 480 112 501 141 b 527 189 524 177 527 183 b 504 199 527 196 520 199 l 55 199 b 23 190 45 199 33 196 b 0 161 9 181 0 173 b 10 135 0 154 3 145 b 206 -177 76 32 140 -73 b 242 -209 219 -199 230 -209 z m 253 -105 b 187 52 228 -52 206 0 b 176 127 179 76 176 101 b 197 151 176 144 181 151 l 202 151 b 256 150 220 151 238 150 b 311 151 275 150 294 151 b 337 128 331 151 337 144 l 337 122 b 253 -105 334 39 307 -35 z"
                },
                noteheadTriangleDownHalf: {
                    x_min: 0,
                    x_max: 341,
                    y_min: -159,
                    y_max: 159,
                    ha: 318,
                    o: "m 266 -229 b 282 -215 274 -229 278 -225 b 487 153 350 -92 418 30 b 491 170 490 158 491 164 b 480 189 491 177 487 183 b 425 215 464 202 448 213 b 33 226 297 217 168 222 b 13 229 29 223 22 229 b 1 222 9 229 4 228 b 14 184 -4 207 7 196 b 210 -176 81 65 145 -56 b 253 -225 222 -194 230 -213 b 266 -229 259 -226 264 -228 z m 134 22 b 147 43 138 27 141 37 b 206 163 174 79 179 127 b 213 170 209 166 212 167 l 340 167 b 193 -75 287 89 251 1 b 190 -82 192 -76 190 -79 z"
                },
                noteheadTriangleDownBlack: {
                    x_min: 0,
                    x_max: 346,
                    y_min: -149,
                    y_max: 149,
                    ha: 298,
                    o: "m 229 -215 b 259 -202 238 -215 248 -210 b 284 -173 269 -194 278 -184 l 482 173 b 498 209 488 184 498 194 b 481 215 492 215 487 215 b 63 213 343 215 203 213 b 12 197 45 213 29 206 b 0 180 4 193 0 187 b 3 168 0 177 1 173 b 13 150 6 163 9 156 l 196 -189 b 229 -215 206 -206 216 -215 z"
                },
                noteheadTriangleUpDoubleWhole: {
                    x_min: 0,
                    x_max: 510,
                    y_min: -213,
                    y_max: 213,
                    ha: 426,
                    o: "m 16 -307 b 30 -289 26 -307 29 -297 b 43 -236 36 -272 42 -253 l 65 219 b 59 285 62 240 69 264 b 46 307 55 294 58 307 l 43 307 b 19 279 30 304 20 295 b 13 184 17 248 14 216 b 1 -125 9 81 7 -23 b 0 -163 0 -138 0 -150 b 6 -287 0 -204 4 -245 b 16 -307 6 -295 7 -305 z m 707 -298 b 734 -217 733 -275 734 -246 b 729 240 733 -65 730 88 b 719 281 729 255 724 268 b 707 294 716 287 714 294 l 703 294 b 685 279 696 292 687 288 b 683 249 683 269 683 259 b 691 -186 685 104 685 -40 b 707 -298 693 -222 690 -261 z m 88 -266 b 112 -200 108 -249 111 -225 b 131 -215 117 -206 122 -210 b 170 -225 144 -222 157 -225 l 384 -225 l 384 -223 b 612 -225 461 -223 537 -223 b 628 -222 619 -225 624 -223 b 641 -265 628 -238 622 -265 b 665 -220 660 -265 664 -238 b 665 -88 667 -179 665 -135 b 667 -49 667 -75 667 -62 b 658 171 667 23 655 98 b 651 209 660 184 655 197 b 638 226 649 216 648 226 b 619 207 629 225 622 217 b 615 166 615 194 615 180 l 615 132 b 626 -193 619 24 622 -85 b 567 -108 608 -164 588 -137 b 387 154 508 -20 449 68 b 350 184 374 174 361 184 b 314 153 338 184 327 173 b 118 -161 248 48 184 -58 l 114 -167 b 120 66 118 -89 120 -12 l 120 138 b 127 190 120 156 127 173 b 125 203 127 194 127 199 b 108 238 121 216 125 238 b 84 203 91 238 86 219 b 82 189 82 199 82 194 b 73 -147 79 78 73 -35 b 75 -239 73 -179 75 -207 b 88 -266 75 -249 76 -259 z m 310 -177 b 284 -151 291 -177 284 -171 b 295 -78 284 -125 287 -101 b 361 79 314 -26 336 26 b 445 -147 415 10 442 -65 b 423 -176 446 -166 442 -176 l 419 -176 b 310 -177 383 -174 346 -176 z"
                },
                noteheadTriangleUpWhole: {
                    x_min: 0,
                    x_max: 366,
                    y_min: -145,
                    y_max: 138,
                    ha: 283,
                    o: "m 504 -209 b 527 -199 520 -209 527 -206 b 520 -180 527 -193 524 -187 b 459 -94 501 -151 480 -122 b 279 170 400 -6 341 82 b 242 199 266 190 253 199 b 206 167 230 199 219 189 b 10 -145 140 63 76 -42 b 0 -171 3 -156 0 -164 b 23 -200 0 -183 9 -192 b 55 -209 33 -206 45 -209 z m 202 -161 b 176 -137 183 -163 176 -156 b 187 -62 176 -111 179 -86 b 253 95 206 -10 228 42 b 337 -132 307 24 334 -49 b 311 -161 338 -153 334 -161 b 256 -160 294 -161 275 -160 b 202 -161 238 -160 220 -161 z"
                },
                noteheadTriangleUpHalf: {
                    x_min: 0,
                    x_max: 341,
                    y_min: -159,
                    y_max: 159,
                    ha: 318,
                    o: "m 458 -226 b 478 -229 462 -223 469 -229 b 490 -222 482 -229 487 -228 b 477 -184 495 -207 484 -196 b 281 176 410 -65 346 56 b 238 225 269 194 261 213 b 225 229 232 226 228 228 b 209 215 217 229 213 225 b 4 -153 141 92 73 -30 b 0 -170 1 -158 0 -164 b 12 -189 0 -177 4 -183 b 66 -215 27 -202 43 -213 b 458 -226 194 -217 323 -222 z m 151 -167 b 298 75 204 -89 240 -1 b 301 82 300 76 301 79 l 357 -22 b 344 -43 353 -27 350 -37 b 285 -163 317 -79 312 -127 b 278 -170 282 -166 279 -167 z"
                },
                noteheadTriangleUpBlack: {
                    x_min: 0,
                    x_max: 346,
                    y_min: -149,
                    y_max: 149,
                    ha: 298,
                    o: "m 481 -215 b 498 -209 487 -215 492 -215 b 482 -173 498 -194 488 -184 l 284 173 b 259 202 278 184 269 194 b 229 215 248 210 238 215 b 196 189 216 215 206 206 l 13 -150 b 3 -168 9 -156 6 -163 b 0 -180 1 -173 0 -177 b 12 -197 0 -187 4 -193 b 63 -213 29 -206 45 -213 b 481 -215 203 -213 343 -215 z"
                },
                noteheadSlashedDoubleWhole1: {
                    x_min: 0,
                    x_max: 697,
                    y_min: -290,
                    y_max: 290,
                    ha: 580,
                    o: "m 20 -418 b 42 -376 40 -418 37 -392 b 43 -356 45 -370 43 -363 l 43 -348 b 50 -197 43 -298 49 -248 b 78 317 58 -24 69 147 b 72 387 75 343 82 366 b 52 418 68 397 69 418 l 49 416 b 24 380 33 413 24 399 b 19 235 23 333 20 284 b 7 -82 14 130 10 24 b 0 -264 6 -143 0 -203 b 10 -382 0 -302 1 -343 b 20 -418 13 -393 6 -418 z m 976 -344 b 991 -331 985 -346 988 -337 b 1004 -271 999 -312 1004 -292 l 1004 -194 b 996 184 1004 -68 1001 59 b 996 281 996 216 998 249 b 984 379 995 314 991 347 b 971 397 981 392 976 396 b 952 386 965 397 959 392 b 943 361 943 380 945 370 b 937 288 939 337 937 312 b 945 158 937 245 942 203 b 959 -248 950 23 953 -112 b 966 -325 960 -274 963 -300 b 976 -344 966 -334 968 -344 z m 102 -331 b 124 -272 120 -314 122 -294 b 135 -278 127 -276 131 -278 l 141 -278 b 320 -199 206 -262 272 -252 b 348 -171 328 -189 338 -180 b 482 -199 392 -190 436 -199 b 704 -173 576 -199 641 -187 b 847 -82 760 -158 809 -130 l 855 -69 l 855 -73 b 863 -229 857 -125 860 -177 b 876 -255 863 -239 863 -255 b 893 -233 886 -255 888 -242 b 900 -189 899 -219 900 -203 l 900 66 b 900 192 899 108 900 150 b 893 301 900 228 899 265 b 877 325 890 310 893 325 l 876 325 b 855 301 865 324 855 315 b 850 202 852 268 847 235 b 854 50 854 151 854 101 b 821 99 847 68 835 85 b 733 167 795 127 765 148 b 831 253 766 196 799 225 b 851 265 837 258 844 261 b 829 282 840 275 835 279 b 772 295 815 291 795 295 b 685 271 739 295 704 287 b 624 215 665 252 645 233 l 566 232 b 527 239 553 236 540 239 b 490 228 514 239 501 236 b 451 219 475 217 467 219 b 275 176 389 219 331 200 b 184 53 216 150 184 105 b 199 -14 184 32 189 10 b 262 -108 215 -52 236 -82 l 125 -230 b 134 225 130 -78 132 73 b 135 269 134 239 135 255 b 121 330 135 291 132 311 b 95 287 99 323 95 307 b 92 124 94 233 95 179 b 85 -143 88 36 85 -53 b 89 -300 85 -196 86 -248 b 102 -331 89 -311 89 -323 z m 367 -14 b 350 43 359 3 351 22 b 392 122 350 82 363 107 b 544 171 439 150 492 160 b 572 168 554 174 563 171 z m 564 -132 b 467 -105 528 -138 497 -121 b 442 -89 458 -101 449 -95 l 658 101 b 690 30 677 82 690 59 b 688 10 690 24 690 17 b 564 -132 678 -45 611 -127 z"
                },
                noteheadSlashedWhole1: {
                    x_min: -76,
                    x_max: 498,
                    y_min: -168,
                    y_max: 168,
                    ha: 336,
                    o: "m -79 -242 b 55 -202 -32 -236 14 -228 l 145 -143 b 333 -171 203 -166 265 -171 b 429 -164 361 -174 395 -168 b 582 -130 481 -158 534 -154 b 657 -20 631 -105 657 -65 b 619 68 657 9 644 40 b 552 120 599 89 577 107 b 582 138 562 127 572 132 b 717 226 625 167 668 194 b 638 242 688 236 662 242 b 543 213 603 242 573 232 b 455 154 514 194 484 174 b 325 199 412 167 367 179 b 233 215 298 210 265 215 b 75 156 173 215 124 186 b 0 27 24 122 0 76 b 66 -98 0 -17 22 -63 b 72 -102 69 -99 71 -101 b -89 -209 17 -137 -36 -173 b -109 -225 -95 -213 -109 -216 b -108 -229 -109 -226 -108 -228 b -85 -242 -104 -239 -95 -242 z m 181 -29 b 167 14 171 -13 167 1 b 187 62 167 30 173 46 b 301 137 217 99 258 118 b 312 138 304 138 308 138 l 317 138 b 389 109 340 125 364 118 l 383 105 z m 337 -109 b 239 -82 301 -107 268 -99 l 468 65 b 482 24 477 53 482 40 b 480 4 482 19 481 12 b 337 -109 467 -56 399 -111 z"
                },
                noteheadSlashedHalf1: {
                    x_min: -79,
                    x_max: 471,
                    y_min: -184,
                    y_max: 184,
                    ha: 368,
                    o: "m -112 -251 b -94 -265 -107 -261 -101 -264 b -52 -242 -79 -265 -63 -249 l 89 -148 b 212 -180 125 -170 167 -179 b 238 -177 220 -180 229 -179 l 262 -180 b 346 -171 289 -180 318 -176 b 576 -91 431 -166 507 -140 b 641 4 619 -60 641 -29 b 592 96 641 35 625 65 l 583 104 b 533 147 567 121 550 134 l 613 200 b 678 261 636 216 664 232 b 658 265 671 264 664 265 b 611 248 641 265 625 258 l 491 171 b 337 204 444 194 392 204 b 281 200 318 204 300 204 b 27 62 180 187 92 145 b -1 -19 9 37 -1 10 b 36 -107 -1 -50 12 -82 b 52 -121 42 -112 46 -117 l -72 -203 b -112 -251 -91 -216 -122 -233 z m 161 -49 b 158 -29 160 -42 158 -35 b 183 33 158 -7 167 16 b 395 137 239 95 311 122 b 420 125 405 134 413 130 z m 276 -128 b 261 -131 271 -130 266 -131 b 181 -86 233 -131 203 -114 l 454 94 l 468 72 b 481 36 477 60 481 49 b 469 1 481 26 477 14 b 276 -128 422 -66 354 -105 z"
                },
                noteheadSlashedBlack1: {
                    x_min: -110,
                    x_max: 452,
                    y_min: -190,
                    y_max: 190,
                    ha: 380,
                    o: "m -131 -274 b -102 -262 -121 -272 -111 -266 b 7 -186 -65 -239 -29 -212 b 50 -157 22 -176 36 -166 b 105 -176 65 -166 84 -173 b 207 -183 140 -181 173 -183 b 239 -184 219 -184 229 -184 b 428 -91 327 -184 377 -150 b 487 43 461 -52 487 -7 b 482 76 487 53 485 65 b 459 128 478 95 469 112 b 507 161 475 138 491 150 l 651 262 b 622 274 641 271 632 274 b 605 271 616 274 611 272 b 514 233 573 262 541 252 l 422 167 b 317 203 392 190 354 203 b 271 196 301 203 285 200 b 168 157 236 186 200 173 b 6 -16 94 120 33 68 b -1 -62 1 -32 -1 -48 b 17 -125 -1 -86 4 -108 b -81 -196 -16 -148 -48 -173 b -145 -242 -102 -212 -128 -219 b -158 -256 -150 -246 -158 -251 b -157 -261 -158 -258 -157 -259 b -131 -274 -153 -269 -141 -274 z"
                },
                noteheadSlashedDoubleWhole2: {
                    x_min: 0,
                    x_max: 697,
                    y_min: -295,
                    y_max: 295,
                    ha: 590,
                    o: "m 870 -338 b 891 -315 884 -341 887 -325 b 906 -183 907 -274 903 -228 b 914 186 912 -60 904 62 b 914 240 914 203 916 222 b 916 276 913 251 916 265 b 899 300 916 289 913 300 b 871 253 874 300 871 274 b 858 -168 871 111 858 -27 b 860 -235 858 -190 860 -213 l 736 -131 b 834 -20 799 -111 834 -69 b 789 85 834 13 819 49 b 683 160 760 118 723 140 b 383 216 589 209 487 215 b 330 213 364 217 347 216 b 228 300 295 242 261 271 b 86 347 184 337 138 348 b 58 343 76 347 63 350 l 58 360 b 35 425 58 384 53 423 b 6 382 9 425 6 403 l 6 131 b 0 -164 6 33 4 -66 b 24 -327 -1 -216 6 -271 b 50 -262 46 -305 50 -284 l 50 -154 b 52 -45 50 -118 50 -81 b 58 325 55 79 58 202 b 73 310 60 320 68 315 b 94 294 79 304 86 298 b 89 271 89 287 89 278 l 89 94 b 104 -194 101 -20 88 -108 b 118 -245 107 -213 104 -248 b 140 -190 140 -243 140 -212 l 140 -62 b 132 258 140 46 138 153 l 132 259 l 235 173 b 193 132 219 161 204 148 b 153 26 167 101 153 63 b 164 -35 153 7 157 -16 b 341 -170 196 -114 261 -158 b 433 -177 372 -174 403 -177 b 619 -157 497 -177 559 -170 l 706 -230 b 799 -276 736 -258 765 -276 b 818 -274 806 -276 812 -276 l 861 -274 b 863 -312 861 -287 863 -300 b 870 -338 864 -321 858 -337 z m 966 -425 b 986 -397 979 -425 982 -408 b 991 -373 989 -390 989 -382 b 995 -239 991 -328 995 -284 b 1004 334 1001 -49 1002 143 b 995 380 1005 350 1005 367 b 982 402 989 386 992 402 l 978 400 b 949 374 965 396 950 390 b 948 333 948 360 948 346 l 948 -37 b 949 -84 949 -52 949 -68 b 946 -248 949 -132 946 -189 b 953 -396 946 -297 948 -346 b 966 -425 955 -408 950 -425 z m 624 -36 b 416 140 554 22 485 81 b 482 156 439 150 461 154 b 625 81 537 156 588 124 b 647 27 639 63 647 46 b 624 -36 647 7 638 -14 z m 469 -117 b 320 14 386 -118 320 -60 b 343 81 320 37 327 60 l 547 -95 b 469 -117 521 -105 494 -111 z"
                },
                noteheadSlashedWhole2: {
                    x_min: -83,
                    x_max: 510,
                    y_min: -201,
                    y_max: 198,
                    ha: 399,
                    o: "m 734 -289 b 696 -245 726 -266 710 -256 b 586 -164 660 -217 622 -192 l 589 -161 b 654 -50 631 -135 654 -94 b 616 40 654 -19 641 13 b 305 174 536 127 420 174 b 171 151 261 174 215 167 b 166 150 170 151 168 150 b 86 209 140 170 112 189 b -94 284 32 249 -22 289 l -108 285 b -120 274 -114 285 -120 284 b -104 251 -120 266 -112 258 b 71 124 -46 209 12 166 l 85 114 b 36 72 66 102 50 89 b 0 -30 12 40 0 4 b 122 -186 0 -96 45 -160 b 343 -222 194 -210 268 -222 b 514 -197 410 -220 467 -213 l 554 -228 b 734 -289 609 -268 668 -275 z m 477 -82 b 268 73 408 -30 338 22 l 301 91 b 336 101 314 96 324 101 b 370 88 347 101 359 96 b 459 9 405 66 436 43 b 481 -56 474 -13 481 -35 b 477 -82 481 -65 480 -73 z m 310 -161 b 216 -143 276 -161 246 -156 b 166 -72 181 -128 166 -105 b 168 -46 166 -65 167 -55 b 206 26 176 -16 189 7 b 436 -140 282 -29 360 -84 b 382 -158 420 -150 402 -157 b 310 -161 357 -161 333 -161 z"
                },
                noteheadSlashedHalf2: {
                    x_min: -73,
                    x_max: 454,
                    y_min: -188,
                    y_max: 188,
                    ha: 376,
                    o: "m 654 -271 b 603 -202 649 -233 625 -217 b 481 -115 563 -173 523 -144 b 564 -60 510 -101 539 -82 b 615 40 596 -33 615 4 b 609 69 615 50 613 60 b 505 167 590 120 554 151 b 336 190 451 184 392 190 b 124 134 259 190 189 171 l -42 248 b -88 271 -56 256 -75 271 b -101 265 -94 271 -98 269 b -105 252 -104 259 -105 255 b -66 210 -105 235 -82 222 l 85 107 b 0 -24 42 73 0 35 b 183 -183 0 -118 75 -184 b 262 -176 206 -180 233 -177 b 438 -135 324 -171 383 -158 b 570 -228 482 -166 527 -197 b 654 -271 595 -243 621 -259 z m 393 -53 l 311 4 l 225 65 b 392 134 274 102 331 122 b 455 50 425 141 455 101 b 439 -3 455 35 451 14 b 393 -53 425 -22 409 -37 z m 287 -121 b 246 -130 272 -127 259 -130 b 171 -89 215 -130 189 -115 b 156 -40 161 -73 156 -58 b 186 29 156 -17 166 7 l 192 35 l 359 -82 b 287 -121 337 -98 312 -111 z"
                },
                noteheadSlashedBlack2: {
                    x_min: -84,
                    x_max: 405,
                    y_min: -189,
                    y_max: 189,
                    ha: 378,
                    o: "m 557 -265 b 573 -272 562 -268 567 -272 b 583 -261 577 -272 580 -269 b 575 -242 580 -253 579 -248 b 524 -190 563 -220 544 -204 b 405 -99 485 -160 445 -130 b 497 50 449 -60 482 -9 b 500 72 498 58 500 65 b 478 122 500 91 492 107 b 331 186 438 167 387 186 b 120 131 258 186 186 167 l 107 124 b -52 242 53 163 1 203 b -89 265 -63 251 -76 259 b -107 272 -95 268 -101 272 b -117 266 -109 272 -114 271 b -121 251 -120 262 -121 256 b -114 235 -121 245 -120 239 b -60 186 -96 217 -81 199 b 63 95 -20 156 22 125 b -1 -35 26 66 -1 27 b 137 -183 -1 -130 46 -183 b 174 -180 148 -183 161 -181 l 245 -171 b 366 -128 289 -166 331 -150 l 426 -171 b 557 -265 469 -203 514 -233 z"
                },
                noteheadDiamondDoubleWhole: {
                    x_min: 0,
                    x_max: 429,
                    y_min: -221,
                    y_max: 221,
                    ha: 442,
                    o: "m 22 -318 b 42 -294 33 -318 37 -302 b 46 -266 45 -285 45 -275 b 50 -219 49 -249 50 -233 b 48 -153 50 -197 49 -176 b 43 120 43 -62 43 29 l 43 253 b 37 298 43 269 45 284 b 26 318 35 305 35 318 l 24 318 b 1 295 13 317 3 308 b 0 268 0 285 0 276 l 0 -121 b 10 -291 0 -177 1 -235 b 22 -318 12 -301 10 -318 z m 593 -312 b 618 -256 611 -294 616 -276 l 618 -186 b 611 253 618 -40 612 108 b 605 276 611 261 608 268 b 589 295 600 284 600 297 b 567 272 577 294 569 285 l 567 251 b 575 -197 573 102 575 -48 b 593 -312 575 -233 579 -271 z m 99 -268 b 114 -256 107 -269 111 -262 b 127 -196 124 -238 125 -217 b 128 -144 128 -179 128 -161 b 122 -9 128 -99 125 -55 l 135 -19 b 344 -179 206 -71 276 -122 b 370 -190 354 -186 363 -190 b 395 -173 379 -190 386 -184 b 492 -33 426 -127 459 -79 b 491 -86 491 -50 491 -68 b 507 -251 491 -138 495 -193 b 534 -184 530 -228 533 -206 b 541 144 537 -75 539 35 b 530 204 541 164 539 186 b 520 220 528 210 528 220 b 500 203 511 219 503 213 b 498 192 498 200 498 194 l 498 176 b 494 7 497 120 497 63 l 490 12 l 287 176 b 258 190 279 181 274 190 b 212 153 239 186 225 168 l 127 40 b 121 32 124 37 122 35 b 118 114 120 59 118 86 b 102 249 117 158 122 206 b 75 219 85 246 79 236 b 72 187 72 209 72 197 b 76 117 72 164 75 141 b 85 -151 79 27 79 -62 b 91 -251 86 -184 91 -217 b 99 -268 91 -258 92 -266 z m 392 -128 b 374 -122 387 -134 380 -127 l 180 29 b 170 45 173 35 170 39 b 176 56 170 48 173 52 b 236 122 204 101 219 122 b 308 76 252 122 272 107 l 433 -26 b 449 -50 439 -32 449 -36 b 392 -128 432 -75 413 -102 z"
                },
                noteheadDiamondWhole: {
                    x_min: 0,
                    x_max: 271,
                    y_min: -132,
                    y_max: 132,
                    ha: 264,
                    o: "m 230 -177 b 256 -190 240 -186 249 -190 b 281 -173 265 -190 272 -184 b 382 -29 314 -124 347 -76 b 390 -10 387 -22 390 -14 b 376 12 390 -3 386 4 b 173 177 308 66 240 121 b 144 190 166 183 160 190 b 98 153 127 186 112 170 b 13 40 69 115 42 76 b 0 13 4 29 0 20 b 22 -19 0 3 7 -9 b 230 -177 92 -69 163 -122 z m 279 -128 b 261 -122 274 -134 266 -127 l 66 30 b 56 45 59 35 56 39 b 62 56 56 48 59 52 b 122 122 91 101 105 122 b 194 76 138 122 158 107 l 320 -26 b 336 -50 325 -32 336 -35 b 279 -128 318 -75 300 -102 z"
                },
                noteheadDiamondHalf: {
                    x_min: 0,
                    x_max: 295,
                    y_min: -148,
                    y_max: 148,
                    ha: 296,
                    o: "m 228 -207 b 245 -213 235 -210 240 -213 b 264 -203 252 -213 258 -210 b 415 -46 314 -150 364 -98 b 425 -27 420 -40 425 -35 b 416 -10 425 -22 422 -16 b 217 200 350 60 284 131 b 194 213 212 207 204 213 b 170 196 181 213 177 203 b 14 33 118 143 68 86 b 0 7 4 23 0 16 b 17 -20 0 -1 6 -10 b 118 -114 52 -50 82 -85 b 228 -207 156 -144 184 -184 z m 209 -157 b 134 -69 177 -138 141 -115 b 130 -26 131 -55 130 -40 b 215 148 130 42 160 99 b 225 156 217 151 220 156 b 230 153 226 156 228 156 b 323 -26 276 104 321 55 b 298 -75 324 -42 315 -59 b 265 -109 287 -86 276 -99 b 209 -157 245 -125 228 -167 z"
                },
                noteheadDiamondBlack: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -146,
                    y_max: 146,
                    ha: 292,
                    o: "m 266 -210 b 289 -194 278 -209 284 -200 b 406 -76 330 -156 367 -115 b 446 -23 433 -49 446 -36 b 412 29 446 -10 435 3 b 405 36 409 30 408 33 b 252 196 354 89 304 143 b 225 210 243 204 235 210 b 204 202 219 210 212 209 b 10 24 141 141 75 82 b 0 9 4 19 0 14 b 9 -6 0 4 3 0 l 232 -192 b 266 -210 242 -200 256 -204 z"
                },
                noteheadParenthesis: {
                    x_min: -70,
                    x_max: 329,
                    y_min: -196,
                    y_max: 201,
                    ha: 397,
                    o: "m 344 -279 b 382 -262 361 -288 370 -272 b 405 -233 390 -255 399 -245 b 474 9 455 -158 468 -73 b 416 228 474 78 448 174 b 364 282 403 249 387 271 b 344 289 359 285 350 288 b 331 279 338 289 333 287 b 325 248 328 269 325 258 b 338 225 325 238 328 229 b 412 138 379 207 396 174 b 445 1 433 92 445 45 b 346 -217 445 -81 410 -154 b 336 -252 340 -223 336 -238 b 344 -279 336 -265 338 -276 z m 19 -274 b 35 -282 24 -279 30 -281 b 49 -265 42 -282 46 -275 b 52 -243 50 -256 52 -249 b 36 -210 52 -230 49 -220 b -60 -59 -16 -173 -35 -114 b -73 9 -69 -39 -73 -16 b 33 223 -73 92 -24 189 b 50 265 43 229 50 249 b 33 288 50 278 46 289 b 4 272 23 288 14 275 b -9 261 0 269 -4 265 b -101 23 -58 193 -105 124 b -37 -206 -104 -52 -75 -130 b 19 -274 -23 -232 -6 -255 z"
                },
                noteheadParenthesisRight: {
                    x_min: -30,
                    x_max: 82,
                    y_min: -199,
                    y_max: 206,
                    ha: 405,
                    o: "m -17 -282 b 24 -264 -6 -297 12 -272 b 60 -219 40 -253 52 -236 b 117 1 96 -150 112 -75 b 118 16 118 6 118 12 b 109 73 118 36 112 55 b 4 279 99 154 68 226 b -23 297 -4 287 -13 297 b -37 289 -27 297 -32 294 b -43 266 -42 285 -43 276 b -32 225 -43 251 -37 229 b 84 -7 48 170 84 82 b 32 -184 84 -69 65 -132 b -10 -222 22 -200 4 -209 b -24 -258 -20 -232 -24 -245 b -17 -282 -24 -266 -22 -276 z"
                },
                noteheadParenthesisLeft: {
                    x_min: 0,
                    x_max: 106,
                    y_min: -197,
                    y_max: 197,
                    ha: 394,
                    o: "m 134 -284 b 138 -281 135 -284 137 -284 b 145 -268 144 -278 145 -274 l 144 -253 b 107 -180 138 -225 121 -204 b 42 13 71 -120 42 -56 b 49 73 42 32 43 52 b 137 210 62 128 95 171 b 153 255 147 219 153 239 b 145 278 153 265 151 274 b 130 284 140 281 135 284 b 98 259 117 284 108 268 b 0 37 35 203 1 131 b 118 -268 9 -69 53 -173 b 134 -284 121 -274 127 -284 z"
                },
                noteheadMoonBlack: {
                    x_min: 0,
                    x_max: 328,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 353 -160 b 465 -40 412 -140 451 -102 b 472 30 471 -17 472 6 b 469 124 472 60 469 92 b 406 179 469 170 459 177 l 128 179 b 37 180 98 179 68 179 b 0 141 7 180 0 170 b 3 -20 3 88 3 33 b 69 -134 3 -72 26 -109 b 240 -180 125 -164 181 -180 b 353 -160 278 -180 315 -174 z"
                },
                noteheadTriangleLeftBlack: {
                    x_min: 0,
                    x_max: 391,
                    y_min: -142,
                    y_max: 142,
                    ha: 284,
                    o: "m 138 -204 b 318 -197 197 -199 258 -197 l 431 -197 b 544 -192 469 -196 507 -193 b 563 -184 552 -190 560 -193 b 553 -167 564 -177 559 -171 l 540 -157 b 232 60 436 -85 334 -12 l 50 190 b 20 204 42 197 32 204 b 10 202 17 204 14 204 b 0 184 1 197 0 192 b 1 164 0 177 1 170 b 6 -150 3 59 6 -45 b 39 -193 7 -176 17 -186 b 138 -204 72 -204 105 -204 z"
                },
                noteheadTriangleRightBlack: {
                    x_min: 0,
                    x_max: 398,
                    y_min: -139,
                    y_max: 140,
                    ha: 279,
                    o: "m 543 -200 b 573 -176 566 -200 573 -194 l 573 -168 b 554 141 566 -66 560 37 b 520 197 553 167 546 187 b 495 202 511 200 504 202 b 454 184 481 202 467 196 l 35 -137 b 0 -171 22 -147 -4 -154 b 52 -199 6 -193 33 -193 b 69 -199 58 -200 63 -199 z"
                },
                noteheadTriangleRoundDownBlack: {
                    x_min: 0,
                    x_max: 334,
                    y_min: -134,
                    y_max: 136,
                    ha: 270,
                    o: "m 252 -192 b 285 -176 269 -196 276 -187 b 468 52 346 -99 406 -23 b 481 79 477 62 481 71 b 465 104 481 88 475 95 b 441 124 456 109 449 117 b 249 196 380 174 314 194 b 13 104 157 196 69 154 b 0 86 6 98 0 92 b 7 69 0 82 3 76 b 202 -164 73 -7 137 -85 b 252 -192 216 -181 235 -186 z"
                },
                augmentationDot: {
                    x_min: 0,
                    x_max: 96,
                    y_min: -57,
                    y_max: 57,
                    ha: 114,
                    o: "m 13 -82 b 16 -81 14 -82 14 -82 b 105 -73 46 -76 75 -76 b 131 -48 121 -72 131 -60 b 138 26 134 -24 138 0 b 137 48 138 33 138 40 b 108 82 134 71 125 82 b 95 81 104 82 99 82 b 33 71 75 78 53 75 b 4 46 20 68 6 62 b 0 -66 1 9 0 -29 b 13 -82 0 -73 1 -82 z"
                },
                tremolo1: {
                    x_min: -158,
                    x_max: 156,
                    y_min: -88,
                    y_max: 88,
                    ha: 176,
                    o: "m -206 -127 b -194 -125 -203 -127 -199 -127 b 173 -36 -72 -94 50 -65 b 220 16 202 -29 215 -12 b 225 50 223 30 225 45 b 216 107 226 76 222 91 b 194 127 210 120 204 127 b 183 124 192 127 189 127 l -192 33 b -226 -9 -213 27 -222 14 b -228 -32 -226 -16 -228 -23 b -222 -108 -228 -58 -222 -82 b -206 -127 -222 -120 -217 -127 z"
                },
                flag8thUp: {
                    x_min: 0,
                    x_max: 261,
                    y_min: -819,
                    y_max: 0,
                    ha: 819,
                    o: "m 265 -1171 b 351 -1035 301 -1130 336 -1087 b 376 -867 369 -979 376 -923 b 367 -755 376 -829 373 -792 b 233 -422 350 -632 311 -520 b 131 -291 199 -379 166 -334 b 65 -125 91 -239 66 -192 b 62 -75 65 -112 62 -91 b 42 0 62 -49 52 -24 l 35 0 b 0 -63 6 -13 0 -36 l 0 -144 b 96 -445 0 -255 29 -356 b 177 -547 124 -478 150 -514 b 308 -831 246 -629 298 -721 b 317 -890 310 -851 317 -871 b 311 -919 317 -900 315 -910 b 256 -1005 297 -950 282 -984 b 228 -1068 233 -1024 228 -1045 b 230 -1106 228 -1080 229 -1093 b 240 -1162 232 -1125 239 -1143 b 251 -1179 242 -1174 246 -1179 b 265 -1171 255 -1179 259 -1176 z"
                },
                flag8thDown: {
                    x_min: 0,
                    x_max: 261,
                    y_min: 0,
                    y_max: 819,
                    ha: 819,
                    o: "m 265 1171 b 251 1179 259 1176 255 1179 b 240 1162 246 1179 242 1174 b 230 1106 239 1143 232 1125 b 228 1068 229 1093 228 1080 b 256 1005 228 1045 233 1024 b 311 919 282 984 297 950 b 317 890 315 910 317 900 b 308 831 317 871 310 851 b 177 547 298 721 246 629 b 96 445 150 514 124 478 b 0 144 29 356 0 255 l 0 63 b 35 0 0 36 6 13 l 42 0 b 62 75 52 24 62 49 b 59 117 62 91 59 104 b 131 291 60 183 91 239 b 233 422 166 334 199 379 b 367 755 311 520 350 632 b 376 867 373 792 376 829 b 351 1035 376 923 369 979 b 265 1171 336 1087 301 1130 z"
                },
                flag16thUp: {
                    x_min: 0,
                    x_max: 327,
                    y_min: -819,
                    y_max: 0,
                    ha: 819,
                    o: "m 415 -1179 b 435 -1168 423 -1182 429 -1174 b 451 -1138 442 -1159 446 -1149 b 465 -1020 464 -1102 467 -1064 b 461 -962 464 -1004 464 -984 b 471 -821 467 -916 472 -870 b 465 -721 472 -791 467 -756 b 415 -520 459 -651 441 -585 b 200 -245 370 -408 284 -327 b 96 -114 160 -206 118 -168 b 75 -24 84 -85 85 -53 b 59 0 72 -16 72 0 b 53 -1 58 0 56 -1 b 27 -32 40 -6 27 -10 b 29 -68 27 -43 29 -55 b 10 -79 20 -69 13 -72 b 1 -109 6 -89 1 -99 b 0 -170 0 -130 0 -148 b 35 -410 0 -252 12 -333 b 258 -793 76 -557 156 -681 b 409 -1158 350 -896 410 -1014 b 415 -1179 409 -1165 405 -1175 z m 413 -816 b 331 -681 392 -769 364 -723 b 145 -420 266 -596 189 -521 b 86 -281 125 -374 102 -330 b 156 -370 105 -312 128 -343 b 318 -539 210 -425 269 -478 b 413 -816 383 -621 420 -713 z"
                },
                flag16thDown: {
                    x_min: 0,
                    x_max: 327,
                    y_min: 0,
                    y_max: 819,
                    ha: 819,
                    o: "m 59 0 b 75 24 72 0 72 16 b 96 114 85 53 84 85 b 200 245 118 168 160 206 b 415 520 284 327 370 408 b 465 721 441 585 459 651 b 471 821 467 756 472 791 b 461 962 472 870 467 916 b 465 1020 464 984 464 1004 b 451 1138 467 1064 464 1102 b 435 1168 446 1149 442 1159 b 418 1179 431 1172 425 1179 l 415 1179 b 408 1169 409 1176 408 1174 b 409 1158 408 1165 409 1161 b 258 793 410 1014 350 896 b 35 410 156 681 76 557 b 0 170 12 333 0 252 l 0 88 b 29 7 0 71 6 23 b 59 0 33 4 58 0 z m 86 281 b 145 420 102 330 125 374 b 331 681 189 521 266 596 b 413 816 364 723 392 769 b 415 791 413 808 415 799 b 318 539 415 698 377 613 b 156 370 269 478 210 425 b 86 281 128 343 105 312 z"
                },
                flag32ndUp: {
                    x_min: 0,
                    x_max: 268,
                    y_min: -849,
                    y_max: 149,
                    ha: 999,
                    o: "m 323 -1223 b 351 -1198 337 -1227 344 -1210 b 359 -1184 354 -1194 356 -1188 b 386 -999 377 -1122 387 -1060 b 341 -783 386 -927 372 -855 b 330 -736 334 -769 330 -753 b 333 -708 330 -727 330 -717 b 344 -621 340 -678 344 -649 b 341 -579 344 -608 343 -593 b 328 -500 338 -553 328 -526 b 331 -475 328 -491 328 -484 b 347 -370 343 -438 348 -402 b 151 27 348 -212 288 -56 b 53 176 98 59 50 102 b 45 197 53 183 48 192 b 33 215 40 203 40 216 l 30 215 b 6 194 22 212 9 209 b 0 120 3 170 -1 145 b 0 -43 4 65 0 13 b 0 -98 0 -60 1 -79 b 4 -276 0 -157 6 -216 b 7 -456 4 -337 7 -397 b 66 -638 7 -523 22 -585 b 158 -724 94 -671 127 -697 b 318 -1011 246 -801 295 -899 b 321 -1044 321 -1021 321 -1032 b 312 -1152 321 -1080 312 -1116 b 317 -1192 312 -1165 314 -1179 b 323 -1223 320 -1202 311 -1220 z m 285 -376 b 121 -180 249 -289 173 -245 b 91 -105 104 -158 92 -135 b 288 -354 181 -144 288 -269 b 285 -376 288 -363 287 -370 z m 275 -657 b 111 -492 226 -589 163 -547 b 65 -376 78 -456 66 -418 b 71 -323 65 -360 68 -341 b 275 -657 164 -418 265 -504 z"
                },
                flag32ndDown: {
                    x_min: -3,
                    x_max: 268,
                    y_min: -169,
                    y_max: 829,
                    ha: 999,
                    o: "m 323 1194 b 317 1164 311 1191 320 1174 b 312 1123 314 1151 312 1136 b 321 1015 312 1087 321 1051 b 318 982 321 1004 321 992 b 158 696 295 870 246 772 b 66 609 127 668 94 642 b 7 428 22 556 7 494 b 4 248 7 369 4 308 b -1 78 6 187 -10 137 b 0 14 0 59 0 32 l 0 -148 b 6 -223 0 -174 3 -199 b 30 -243 9 -238 22 -240 l 33 -243 b 45 -226 40 -245 40 -232 b 53 -204 48 -220 53 -212 b 151 -56 50 -131 98 -88 b 347 341 288 27 348 183 b 331 446 348 373 343 409 b 328 471 328 455 328 462 b 341 550 328 497 338 524 b 344 592 343 564 344 579 b 333 680 344 621 340 649 b 330 707 330 688 330 698 b 341 755 330 724 334 740 b 386 971 372 827 386 899 b 359 1155 387 1031 377 1093 b 351 1169 356 1159 354 1165 b 323 1194 344 1181 337 1198 z m 275 628 b 71 294 265 475 164 389 b 65 347 68 312 65 331 b 111 464 66 389 78 428 b 275 628 163 518 226 560 z m 285 347 b 288 325 287 341 288 334 b 91 76 288 240 181 115 b 121 151 92 107 104 130 b 285 347 173 216 249 261 z"
                },
                flag64thUp: {
                    x_min: -4,
                    x_max: 282,
                    y_min: -824,
                    y_max: 347,
                    ha: 1171,
                    o: "m 350 -1185 b 380 -1162 364 -1189 374 -1175 b 406 -1022 399 -1119 406 -1071 b 359 -798 406 -945 384 -871 b 348 -756 353 -785 348 -772 b 350 -744 348 -753 350 -749 b 363 -621 356 -704 363 -664 b 360 -580 363 -608 363 -593 b 359 -560 359 -573 359 -567 b 373 -490 359 -536 366 -513 b 393 -346 386 -444 393 -395 b 387 -269 393 -320 390 -294 b 348 -127 382 -219 348 -173 b 351 -104 348 -120 348 -111 b 353 -65 351 -91 353 -78 b 341 37 353 -26 348 6 b 226 215 323 108 278 164 b 86 336 181 258 127 288 b 62 395 72 353 62 370 b 42 481 62 423 55 454 b 27 500 37 488 36 500 b 24 498 26 500 26 500 b -1 480 14 497 1 492 b -6 444 -4 467 -6 455 l -6 435 b -1 341 -1 403 -1 372 l -1 266 b 6 156 -1 230 0 193 b 13 35 12 117 13 75 l 13 -35 b 14 -85 13 -52 14 -68 b 29 -276 19 -150 33 -213 b 20 -448 24 -334 20 -392 b 24 -534 20 -477 22 -505 b 114 -708 30 -605 59 -664 b 197 -780 143 -732 171 -755 b 344 -1153 301 -884 341 -1011 b 343 -1172 344 -1159 343 -1166 b 350 -1185 343 -1176 344 -1182 z m 287 -88 b 62 193 186 -17 79 48 b 229 52 121 144 174 98 b 289 -33 256 29 274 -3 b 295 -56 294 -42 295 -49 b 287 -88 295 -66 292 -76 z m 298 -410 b 118 -235 238 -351 176 -295 b 76 -88 82 -197 78 -147 b 268 -252 137 -153 203 -202 b 330 -360 304 -279 330 -315 b 323 -402 330 -373 327 -387 b 311 -418 318 -413 315 -418 b 298 -410 307 -418 302 -415 z m 300 -691 b 117 -508 243 -616 168 -575 b 82 -408 94 -480 82 -448 b 84 -379 82 -397 82 -387 b 259 -553 135 -451 206 -492 b 301 -667 287 -583 301 -619 b 300 -691 301 -674 301 -683 z"
                },
                flag64thDown: {
                    x_min: -5,
                    x_max: 281,
                    y_min: -375,
                    y_max: 796,
                    ha: 1171,
                    o: "m 348 1145 b 341 1132 343 1142 341 1136 b 343 1113 341 1126 343 1119 b 196 740 340 971 300 844 b 112 668 170 714 141 691 b 23 494 58 624 29 564 b 19 408 20 465 19 436 b 27 236 19 351 23 294 b 13 45 32 173 17 109 b 12 -6 13 27 12 12 l 12 -75 b 4 -196 12 -115 10 -157 b -3 -307 -1 -233 -3 -271 l -3 -382 b -7 -475 -3 -412 -3 -444 l -7 -484 b -3 -520 -7 -495 -6 -507 b 23 -539 0 -533 13 -537 b 26 -540 24 -540 24 -540 b 40 -521 35 -540 36 -528 b 60 -435 53 -494 60 -464 b 85 -376 60 -410 71 -393 b 225 -255 125 -328 180 -298 b 340 -78 276 -204 321 -148 b 351 24 347 -46 351 -14 b 350 63 351 37 350 50 b 347 86 347 71 347 79 b 386 229 347 132 380 179 b 392 305 389 253 392 279 b 372 449 392 354 384 403 b 357 520 364 472 357 495 b 359 540 357 527 357 533 b 361 580 361 553 361 567 b 348 704 361 624 354 664 b 347 716 348 708 347 713 b 357 757 347 732 351 744 b 405 982 383 831 405 904 b 379 1122 405 1031 397 1079 b 348 1145 373 1135 363 1149 z m 298 651 b 300 626 300 642 300 634 b 258 513 300 579 285 543 b 82 338 204 452 134 410 b 81 367 81 347 81 357 b 115 468 81 408 92 439 b 298 651 167 534 242 576 z m 297 370 b 310 377 301 374 305 377 b 321 361 314 377 317 373 b 328 320 325 347 328 333 b 266 212 328 275 302 239 b 75 48 202 161 135 112 b 117 194 76 107 81 157 b 297 370 174 255 236 311 z m 285 48 b 294 16 291 36 294 26 b 288 -7 294 9 292 1 b 228 -92 272 -37 255 -69 b 60 -233 173 -138 120 -184 b 285 48 78 -88 184 -23 z"
                },
                flag128thUp: {
                    x_min: 0,
                    x_max: 252,
                    y_min: -804,
                    y_max: 530,
                    ha: 1334,
                    o: "m 298 -1158 b 328 -1126 312 -1158 320 -1139 b 330 -1116 330 -1123 330 -1119 b 347 -996 343 -1076 347 -1037 b 328 -837 347 -943 338 -890 b 320 -778 324 -816 320 -798 b 330 -733 320 -763 323 -749 b 340 -665 338 -714 337 -688 b 341 -645 340 -660 341 -652 b 333 -534 341 -609 333 -572 b 343 -471 333 -513 334 -492 b 361 -366 356 -436 361 -402 b 331 -202 361 -311 348 -256 b 328 -187 330 -197 328 -193 b 331 -179 328 -184 328 -181 b 363 -55 353 -137 363 -96 b 337 79 363 -12 351 33 b 327 114 333 92 327 104 b 344 144 327 124 331 132 b 359 174 353 150 357 163 b 361 228 360 193 361 210 b 243 517 361 337 325 435 b 147 596 213 546 179 569 b 75 708 111 626 75 655 b 62 744 75 723 68 733 b 50 763 58 752 58 763 b 46 762 49 763 48 762 b 17 742 36 757 22 757 b 0 697 14 726 0 711 b 1 595 0 662 3 631 b 0 469 0 552 0 511 b 1 429 0 456 0 442 b 22 289 6 382 22 337 b 24 128 22 238 24 184 b 22 66 24 108 23 86 b 19 -19 20 37 19 10 b 20 -132 19 -56 20 -95 b 13 -276 20 -180 19 -229 b 9 -359 10 -304 9 -330 b 12 -487 9 -402 12 -445 b 56 -582 12 -526 29 -554 b 197 -742 107 -632 160 -681 b 288 -1100 265 -851 276 -976 b 288 -1122 288 -1107 287 -1115 b 287 -1145 289 -1129 287 -1138 b 298 -1158 287 -1153 288 -1158 z m 304 150 b 75 475 229 256 112 334 b 304 150 233 357 305 287 z m 271 -73 b 127 72 233 -14 179 26 b 81 167 96 98 81 127 b 84 194 81 176 82 184 b 271 -73 148 102 242 39 z m 279 -396 b 132 -223 233 -330 180 -279 b 81 -112 104 -192 81 -156 b 82 -91 81 -105 81 -98 b 279 -396 167 -125 269 -281 z m 249 -609 b 69 -357 197 -520 88 -471 b 249 -609 131 -441 229 -498 z"
                },
                flag128thDown: {
                    x_min: -1,
                    x_max: 252,
                    y_min: -580,
                    y_max: 754,
                    ha: 1334,
                    o: "m 298 1086 b 287 1073 288 1086 287 1081 b 288 1050 287 1066 289 1057 b 288 1028 287 1043 288 1035 b 197 670 276 904 265 779 b 56 510 160 609 107 560 b 12 415 29 482 12 454 b 9 287 12 373 9 330 b 13 204 9 258 10 232 b 20 60 19 157 20 108 b 19 -53 20 23 19 -16 b 22 -138 19 -82 20 -109 b 24 -200 23 -158 24 -180 b 22 -361 24 -256 22 -310 b 1 -501 22 -409 6 -454 b 0 -541 0 -514 0 -528 b 0 -667 0 -583 -3 -624 b 0 -809 0 -675 -3 -791 b 46 -834 4 -825 36 -829 b 50 -835 48 -834 49 -835 b 62 -816 58 -835 58 -824 b 75 -780 68 -805 75 -795 b 147 -668 75 -727 111 -698 b 243 -589 179 -641 213 -618 b 361 -300 325 -507 361 -409 b 359 -246 361 -282 360 -265 b 344 -216 357 -235 353 -222 b 327 -186 331 -204 327 -196 b 337 -151 327 -176 333 -164 b 363 -17 351 -105 363 -60 b 331 107 363 24 353 65 b 328 115 328 109 328 112 b 331 130 328 121 330 125 b 361 294 348 184 361 239 b 343 399 361 330 356 364 b 333 462 334 420 333 441 b 341 573 333 500 341 537 b 340 593 341 580 340 588 b 330 661 337 616 338 642 b 320 706 323 677 320 691 b 328 765 320 726 324 744 b 347 924 338 818 347 871 b 330 1044 347 965 343 1004 b 328 1054 330 1047 330 1051 b 298 1086 320 1067 312 1086 z m 249 537 b 69 285 229 426 131 369 b 249 537 88 399 197 448 z m 279 324 b 82 19 269 209 167 53 b 81 40 81 26 81 33 b 132 151 81 84 104 120 b 279 324 180 207 233 258 z m 271 1 b 84 -266 242 -111 148 -174 b 81 -239 82 -256 81 -248 b 127 -144 81 -199 96 -170 b 271 1 179 -98 233 -58 z m 304 -222 b 75 -547 305 -359 233 -429 b 304 -222 112 -406 229 -328 z"
                },
                accidentalFlat: {
                    x_min: 1,
                    x_max: 209,
                    y_min: -208,
                    y_max: 472,
                    ha: 680,
                    o: "m 29 -300 b 46 -289 33 -300 39 -297 b 107 -243 65 -274 86 -258 b 301 127 233 -153 301 -30 b 298 186 301 147 301 166 b 190 297 291 256 251 297 b 147 289 177 297 163 294 b 86 265 127 284 107 274 l 85 264 l 85 301 b 91 465 85 356 88 410 b 94 559 91 497 94 527 b 84 651 94 589 91 621 b 66 680 81 661 81 680 l 65 680 b 37 645 49 678 37 665 b 33 523 36 605 32 563 l 33 478 b 26 223 33 393 29 308 b 1 -141 22 101 1 -19 b 17 -287 1 -189 4 -239 b 29 -300 20 -295 23 -300 z m 68 -105 b 76 12 71 -68 72 -29 b 81 107 79 43 81 75 l 86 109 b 171 135 114 121 141 135 b 204 128 181 135 193 132 b 238 92 228 120 239 108 b 230 63 238 84 236 75 b 68 -105 193 -10 132 -59 z"
                },
                accidentalNatural: {
                    x_min: 0,
                    x_max: 214,
                    y_min: -456,
                    y_max: 462,
                    ha: 918,
                    o: "m 255 -657 b 281 -624 271 -657 275 -636 b 285 -599 282 -615 285 -608 b 292 -300 288 -500 289 -400 b 289 -161 292 -253 289 -207 b 300 128 292 -65 297 32 b 304 168 300 128 302 150 l 304 173 l 305 190 l 305 199 l 307 225 b 304 259 307 229 310 246 b 272 298 297 274 302 305 b 63 266 204 279 134 272 b 72 514 68 348 72 432 b 71 595 72 541 72 567 b 56 665 71 619 66 642 b 17 579 9 651 17 608 b 3 144 19 433 7 289 b 0 -7 1 94 0 43 b 3 -134 0 -50 1 -92 b 7 -219 3 -163 7 -192 b 35 -251 7 -243 17 -251 b 49 -249 39 -251 43 -251 l 223 -223 l 230 -222 l 230 -359 b 223 -516 230 -410 223 -464 b 236 -619 223 -550 226 -585 b 255 -657 240 -634 236 -657 z m 58 -63 b 55 81 56 -14 53 33 l 56 99 b 85 99 65 99 75 98 b 232 108 134 104 183 107 l 240 109 l 236 66 b 232 -48 235 29 232 -10 b 58 -81 174 -63 115 -73 z"
                },
                accidentalSharp: {
                    x_min: -22,
                    x_max: 390,
                    y_min: -384,
                    y_max: 383,
                    ha: 767,
                    o: "m 202 -553 b 219 -526 213 -552 216 -536 b 226 -471 225 -507 226 -488 b 225 -425 226 -455 225 -441 b 226 -392 225 -415 225 -402 b 233 -305 229 -363 232 -334 l 297 -292 b 331 -469 300 -353 311 -412 b 347 -485 333 -477 338 -485 b 363 -469 356 -487 359 -477 b 374 -418 373 -454 374 -435 b 376 -382 376 -405 376 -393 b 372 -276 376 -347 373 -311 l 455 -259 b 550 -156 534 -243 544 -232 b 550 -109 550 -137 552 -124 b 526 -78 549 -91 541 -78 l 523 -78 b 507 -79 517 -78 513 -78 b 403 -101 474 -88 438 -95 l 379 -105 b 382 -42 380 -85 380 -63 b 384 96 383 4 384 50 b 503 131 425 107 464 118 b 549 173 524 138 543 150 b 562 249 554 199 562 223 b 554 294 562 264 560 279 b 536 315 549 308 544 315 l 533 315 b 517 312 528 315 523 315 b 382 266 472 294 428 279 l 377 344 b 359 531 374 406 372 469 b 348 552 356 539 357 552 l 347 552 l 343 552 b 315 528 331 549 317 544 l 315 501 b 320 249 315 416 318 333 l 243 232 b 239 361 243 275 242 318 b 226 425 238 383 238 403 b 199 359 194 409 199 382 b 193 223 196 312 194 268 b 72 202 153 215 112 209 b 4 118 13 192 4 183 b 10 66 0 102 12 84 b 33 29 7 39 14 30 b 48 32 37 29 42 30 b 187 55 95 39 141 46 l 183 -75 b 176 -145 181 -99 179 -122 b 16 -179 122 -156 69 -166 b -32 -232 -14 -186 -32 -197 b -17 -331 -32 -266 -19 -298 b -1 -356 -17 -347 -13 -354 b 12 -353 1 -356 6 -354 b 167 -320 63 -341 115 -331 b 166 -377 166 -338 166 -357 b 189 -526 166 -428 171 -477 b 202 -553 192 -536 189 -553 z m 240 -132 b 243 -37 242 -101 242 -69 b 245 65 245 -3 245 30 b 315 79 269 69 292 73 b 301 -120 308 13 305 -53 z"
                },
                accidentalDoubleSharp: {
                    x_min: 0,
                    x_max: 287,
                    y_min: -159,
                    y_max: 159,
                    ha: 318,
                    o: "m 84 -229 b 107 -216 91 -229 98 -225 b 200 -125 138 -186 167 -154 b 232 -95 212 -115 222 -105 b 347 -189 271 -125 310 -157 b 370 -200 356 -196 363 -200 b 396 -179 380 -200 389 -192 b 412 -102 410 -154 406 -125 b 377 -27 410 -69 400 -46 l 325 14 b 402 91 350 42 374 68 b 413 127 410 96 413 107 b 382 200 409 148 397 176 b 350 229 370 220 360 229 b 314 210 340 229 328 223 b 274 174 300 199 285 187 b 212 104 252 151 232 128 b 92 187 173 132 132 161 b 78 193 86 192 82 193 b 68 190 75 193 72 193 b 48 179 62 186 53 187 b 40 137 43 168 40 154 b 81 16 40 92 56 32 b 107 -3 89 10 98 4 b 14 -94 76 -32 45 -62 b 0 -124 6 -102 0 -114 b 12 -154 0 -134 3 -144 b 62 -215 26 -176 48 -193 b 84 -229 69 -225 76 -229 z"
                },
                accidentalDoubleFlat: {
                    x_min: 0,
                    x_max: 359,
                    y_min: -220,
                    y_max: 446,
                    ha: 666,
                    o: "m 43 -317 b 72 -301 55 -317 63 -310 b 160 -186 108 -268 134 -226 b 236 -60 186 -145 212 -102 b 233 -131 235 -85 233 -108 b 239 -220 233 -161 235 -190 b 259 -246 240 -233 239 -240 b 301 -228 284 -252 291 -238 b 465 -7 369 -163 416 -85 b 517 173 500 48 517 108 b 451 307 517 229 505 284 b 409 315 436 312 422 315 b 331 287 382 315 356 305 b 311 274 324 282 320 274 l 310 274 l 310 566 b 305 621 310 585 312 603 b 294 642 301 628 305 642 l 292 642 b 264 622 282 641 266 636 b 253 575 259 606 256 590 b 246 418 248 523 246 471 b 248 243 246 360 248 302 l 248 187 b 164 238 220 225 193 238 b 85 213 140 238 112 226 b 84 229 85 220 84 225 b 86 315 85 258 86 287 b 81 528 86 386 82 458 b 71 582 81 547 78 566 b 56 603 66 590 68 603 l 53 603 b 23 580 40 600 26 598 b 19 537 20 566 19 552 b 20 514 19 530 19 521 b 26 390 24 472 26 432 b 14 66 26 282 16 174 b 0 -168 13 -12 0 -91 b 12 -279 0 -206 3 -242 b 30 -314 16 -294 14 -308 b 43 -317 35 -317 39 -317 z m 301 -72 b 302 7 302 -45 302 -19 l 302 86 b 351 158 304 121 321 145 b 383 166 361 163 373 166 b 435 143 402 166 419 157 b 445 127 441 138 445 132 b 441 114 445 122 444 118 b 301 -72 397 49 354 -14 z m 75 -147 b 73 30 75 -86 75 -29 b 118 82 73 62 92 76 b 132 84 124 84 128 84 b 190 52 156 84 174 69 b 193 40 192 49 193 45 b 192 33 193 37 193 35 b 75 -147 157 -30 125 -95 z"
                },
                accidentalParensLeft: {
                    x_min: 0,
                    x_max: 130,
                    y_min: -270,
                    y_max: 268,
                    ha: 538,
                    o: "m 107 -389 b 127 -374 114 -389 120 -384 b 141 -347 132 -367 137 -357 b 151 -294 148 -330 151 -311 b 122 -207 151 -265 141 -236 b 63 -65 94 -164 72 -117 b 59 -10 60 -46 59 -27 b 145 223 59 78 94 153 b 187 354 176 262 189 305 b 177 384 187 364 190 380 b 143 373 166 387 153 383 b 124 354 137 367 130 361 b 0 -35 33 240 0 108 l 0 -92 b 85 -372 4 -193 27 -287 b 107 -389 92 -383 99 -389 z"
                },
                accidentalParensRight: {
                    x_min: 0,
                    x_max: 139,
                    y_min: -275,
                    y_max: 277,
                    ha: 552,
                    o: "m 58 -396 b 96 -354 75 -396 85 -370 b 200 13 168 -238 200 -111 b 153 268 200 109 184 190 b 49 392 131 320 101 364 b 26 399 40 397 33 399 b 0 366 10 399 0 387 b 0 318 -1 350 0 334 l 0 291 b 27 238 -3 266 7 253 b 143 9 105 180 143 98 b 141 -20 143 -1 143 -10 b 63 -225 135 -92 108 -164 b 36 -307 45 -251 36 -278 b 40 -344 36 -320 37 -331 b 42 -356 42 -347 42 -351 b 58 -396 42 -374 37 -396 z"
                },
                accidentalQuarterToneFlatStein: {
                    x_min: 0,
                    x_max: 208,
                    y_min: -240,
                    y_max: 440,
                    ha: 680,
                    o: "m 272 -346 b 284 -333 278 -346 281 -341 b 300 -187 297 -285 300 -235 b 275 177 300 -65 279 55 b 268 432 272 262 268 347 l 268 477 b 264 599 269 517 265 559 b 236 634 264 619 252 632 l 235 634 b 217 605 220 634 220 615 b 207 513 210 575 207 543 b 210 419 207 481 210 451 b 216 255 213 364 216 310 l 216 217 l 215 219 b 154 243 194 228 174 238 b 111 251 138 248 124 251 b 3 140 50 251 10 210 b 0 81 0 120 0 101 b 194 -289 0 -76 68 -199 b 255 -336 215 -304 236 -320 b 272 -346 262 -343 268 -346 z m 233 -151 b 71 17 168 -105 108 -56 b 63 46 65 29 63 37 b 96 82 62 62 73 73 b 130 89 108 86 120 89 b 215 63 160 89 187 75 l 220 60 b 225 -35 220 29 222 -3 b 233 -151 229 -75 230 -114 z"
                },
                accidentalThreeQuarterTonesFlatZimmermann: {
                    x_min: 0,
                    x_max: 422,
                    y_min: -240,
                    y_max: 440,
                    ha: 680,
                    o: "m 272 -346 b 284 -333 278 -346 281 -341 b 300 -187 297 -285 300 -235 b 275 177 300 -65 279 55 b 268 432 272 262 268 347 l 268 477 b 264 599 269 517 265 559 b 236 634 264 619 252 632 l 235 634 b 217 605 220 634 220 615 b 207 513 210 575 207 543 b 210 419 207 481 210 451 b 216 255 213 364 216 310 l 216 217 l 215 219 b 154 243 194 228 174 238 b 111 251 138 248 124 251 b 3 140 50 251 10 210 b 0 81 0 120 0 101 b 194 -289 0 -76 68 -199 b 255 -336 215 -304 236 -320 b 272 -346 262 -343 268 -346 z m 336 -346 b 353 -336 340 -346 346 -343 b 413 -289 372 -320 393 -304 b 608 81 540 -199 608 -76 b 605 140 608 101 608 120 b 497 251 598 210 557 251 b 454 243 484 251 469 248 b 393 219 433 238 413 228 l 392 217 l 392 255 b 397 419 392 310 395 364 b 400 513 397 451 400 481 b 390 605 400 543 397 575 b 373 634 387 615 387 634 l 372 634 b 344 599 356 632 344 619 b 340 477 343 559 338 517 l 340 432 b 333 177 340 347 336 262 b 308 -187 328 55 308 -65 b 324 -333 308 -235 311 -285 b 336 -346 327 -341 330 -346 z m 233 -151 b 71 17 168 -105 108 -56 b 63 46 65 29 63 37 b 96 82 62 62 73 73 b 130 89 108 86 120 89 b 215 63 160 89 187 75 l 220 60 b 225 -35 220 29 222 -3 b 233 -151 229 -75 230 -114 z m 374 -151 b 383 -35 377 -114 379 -75 b 387 60 386 -3 387 29 l 393 63 b 478 89 420 75 448 89 b 511 82 488 89 500 86 b 544 46 534 73 546 62 b 537 17 544 37 543 29 b 374 -151 500 -56 439 -105 z"
                },
                accidentalQuarterToneSharpStein: {
                    x_min: 0,
                    x_max: 300,
                    y_min: -338,
                    y_max: 351,
                    ha: 689,
                    o: "m 194 -487 b 225 -432 215 -469 223 -452 b 238 -232 229 -366 236 -298 b 377 -199 285 -220 331 -209 b 418 -164 397 -193 410 -181 b 432 -88 428 -138 432 -114 b 412 -42 432 -55 428 -42 b 389 -46 406 -42 399 -43 l 235 -85 b 233 -20 235 -63 233 -42 b 233 105 232 22 233 63 b 312 121 259 111 285 117 b 406 226 390 134 400 145 b 373 284 409 268 402 284 b 344 281 364 284 356 282 b 232 258 307 276 269 266 b 230 308 232 275 232 291 b 210 505 229 374 232 441 b 183 471 189 501 184 490 b 180 406 181 449 180 428 b 184 246 180 353 184 300 b 48 222 140 236 94 228 b 0 168 6 216 0 209 b 7 86 1 141 4 114 b 27 66 9 73 13 66 l 35 66 b 184 94 85 66 135 84 b 187 -1 184 62 186 30 b 190 -96 189 -33 190 -65 l 112 -114 b 35 -213 27 -132 35 -132 b 33 -253 35 -226 35 -240 b 49 -276 33 -269 37 -276 b 62 -275 52 -276 56 -276 l 186 -245 l 186 -256 b 179 -387 180 -300 177 -343 b 194 -487 180 -419 179 -454 z"
                },
                accidentalThreeQuarterTonesSharpStein: {
                    x_min: -23,
                    x_max: 388,
                    y_min: -373,
                    y_max: 445,
                    ha: 818,
                    o: "m 114 -537 b 138 -475 137 -518 138 -495 b 147 -292 138 -413 144 -353 b 212 -278 168 -287 190 -282 b 243 -444 215 -333 225 -389 b 261 -467 248 -454 251 -465 b 281 -446 272 -469 276 -455 b 292 -347 292 -416 288 -384 b 288 -262 289 -320 288 -291 l 374 -245 b 376 -311 374 -266 374 -288 b 390 -456 379 -357 379 -405 b 416 -396 412 -436 415 -418 b 423 -287 420 -360 423 -323 b 422 -235 423 -269 423 -252 b 451 -229 432 -233 441 -232 b 547 -98 524 -215 547 -199 l 547 -89 b 521 -49 546 -59 540 -49 b 497 -52 516 -49 507 -49 b 418 -68 469 -56 444 -63 b 423 52 419 -29 422 12 b 426 140 425 81 425 109 b 495 160 449 145 472 153 b 552 219 526 170 546 189 b 559 279 557 240 553 262 b 530 341 559 324 552 341 b 490 331 520 341 507 338 b 432 311 471 324 452 318 b 449 552 436 392 442 471 b 452 588 451 563 452 575 b 446 622 452 599 451 611 b 436 641 444 629 448 641 b 418 628 428 641 420 636 b 409 602 413 621 410 611 b 386 297 396 501 390 399 b 297 274 356 288 327 281 b 291 403 295 317 294 360 b 274 550 288 452 284 501 b 259 569 271 564 265 569 b 240 559 253 569 248 563 b 230 537 232 554 230 546 l 230 488 b 233 369 230 448 232 409 b 236 261 236 333 238 297 b 156 245 210 255 183 251 b 154 396 154 295 154 346 b 150 416 154 403 153 410 b 140 438 145 423 150 438 l 138 438 b 118 413 128 436 118 428 b 112 354 118 393 114 374 b 109 238 109 315 109 276 b 49 226 89 233 69 230 b 3 163 16 222 3 202 b 7 91 3 138 9 114 b 29 62 7 69 13 62 b 39 63 32 62 35 63 b 104 73 60 66 82 71 b 101 -10 104 46 102 17 l 92 -132 l 10 -150 b -33 -204 -19 -157 -33 -170 b -19 -310 -32 -240 -19 -274 b -6 -324 -19 -321 -13 -324 b 6 -323 -1 -324 1 -324 b 82 -307 32 -317 58 -311 b 81 -376 82 -330 81 -353 b 114 -537 81 -431 94 -484 z m 294 -92 b 297 -37 295 -73 295 -56 b 300 49 300 -9 300 20 l 300 108 b 379 127 325 114 353 120 b 374 -76 376 59 374 -9 b 294 -92 347 -82 320 -86 z m 154 -120 b 157 20 154 -73 156 -26 b 158 82 158 40 158 62 b 230 95 183 86 206 89 b 225 0 229 63 226 32 b 217 -107 223 -35 220 -71 z"
                },
                accidentalBuyukMucennebFlat: {
                    x_min: 2,
                    x_max: 287,
                    y_min: -248,
                    y_max: 432,
                    ha: 680,
                    o: "m 410 128 b 302 239 403 199 363 239 b 259 232 289 239 275 236 b 199 207 239 226 219 216 l 197 206 l 197 243 l 197 251 b 347 317 248 272 298 295 b 376 347 360 324 372 334 b 389 435 387 376 393 405 b 348 454 384 462 377 465 b 202 387 300 432 251 409 b 203 408 203 395 203 402 l 203 431 b 347 490 252 451 300 469 b 376 517 360 495 372 505 b 389 599 387 546 393 572 b 348 616 384 625 377 628 l 203 556 b 196 593 202 569 199 582 b 179 622 193 603 193 622 l 177 622 b 150 588 161 621 150 608 b 147 533 150 570 148 552 b 29 488 108 517 69 503 b 3 455 12 482 3 472 b 12 353 1 422 9 389 b 145 408 56 372 101 389 b 145 363 145 392 145 377 l 29 315 b 3 281 12 310 3 298 b 12 170 1 245 9 209 l 141 226 b 138 166 140 206 138 186 b 114 -199 134 43 115 -76 b 130 -344 114 -246 117 -297 b 141 -357 132 -353 135 -357 b 158 -347 145 -357 151 -354 b 219 -301 177 -331 199 -315 b 413 69 346 -210 413 -88 b 410 128 413 89 413 108 z m 350 35 b 343 6 350 26 348 17 b 180 -163 308 -69 245 -117 b 189 -46 183 -125 184 -86 b 193 49 192 -14 193 17 l 199 52 b 284 78 226 63 253 78 b 317 71 294 78 305 75 b 350 35 340 62 351 50 z"
                },
                accidentalBuyukMucennebSharp: {
                    x_min: -1,
                    x_max: 467,
                    y_min: -460,
                    y_max: 350,
                    ha: 810,
                    o: "m 230 -662 b 256 -615 249 -647 255 -631 b 264 -495 261 -575 264 -534 b 261 -361 264 -451 262 -406 b 415 -324 312 -348 363 -336 b 416 -445 415 -364 416 -405 b 431 -593 416 -492 419 -541 b 458 -533 454 -573 456 -554 b 464 -418 462 -494 464 -455 b 459 -314 464 -383 462 -348 b 531 -298 484 -308 508 -304 b 570 -259 554 -292 566 -278 b 579 -192 575 -236 579 -215 b 576 -164 579 -183 577 -173 b 556 -143 573 -147 567 -143 b 543 -144 553 -143 549 -143 b 459 -164 516 -151 487 -157 b 462 -102 459 -144 461 -122 l 608 -76 b 667 -24 639 -71 660 -53 b 672 19 671 -9 671 9 l 672 46 b 641 108 668 94 662 108 b 605 101 632 108 621 105 l 580 96 b 469 72 544 88 507 79 b 471 131 469 91 471 111 b 521 141 488 135 504 138 b 573 197 550 148 570 167 b 577 271 576 222 577 246 b 553 300 577 291 567 300 b 537 297 549 300 543 298 b 480 285 517 292 498 288 b 491 410 482 327 485 369 b 494 445 492 422 494 433 b 488 482 494 458 492 469 b 477 504 487 490 491 504 b 455 484 467 504 458 495 b 451 464 452 478 452 471 b 433 275 442 402 438 338 b 282 246 383 265 333 255 l 291 346 b 294 382 292 359 294 370 b 287 418 294 395 292 406 b 276 435 284 423 289 435 b 259 423 269 435 264 429 b 251 397 255 416 252 406 b 235 239 242 346 239 292 b 166 228 212 235 189 232 b 118 170 134 223 112 207 b 120 140 120 160 120 150 b 120 84 120 121 118 102 b 131 69 120 75 122 69 b 138 71 132 69 135 71 b 226 85 168 75 197 81 b 223 30 226 66 225 49 l 223 17 l 45 -22 b -1 -92 13 -29 -1 -48 b 1 -171 -1 -118 3 -145 b 12 -187 0 -184 4 -187 b 22 -186 14 -187 17 -187 b 115 -164 53 -179 84 -170 b 217 -145 150 -158 183 -153 b 215 -225 216 -173 216 -199 l 203 -229 b 132 -275 141 -246 132 -249 b 134 -315 132 -285 134 -298 b 135 -382 134 -336 132 -359 b 144 -396 135 -386 134 -396 b 151 -395 145 -396 148 -396 b 215 -376 171 -387 193 -382 b 216 -516 215 -422 215 -468 b 230 -662 217 -563 219 -611 z m 271 27 b 274 94 272 50 274 72 b 425 122 324 102 374 112 l 425 101 b 422 62 423 88 423 75 z m 262 -177 b 264 -137 264 -164 264 -151 b 418 -109 315 -128 366 -120 b 415 -174 416 -131 416 -153 b 262 -213 364 -186 312 -199 z"
                },
                accidentalBakiyeFlat: {
                    x_min: 2,
                    x_max: 287,
                    y_min: -236,
                    y_max: 444,
                    ha: 680,
                    o: "m 141 -340 b 158 -330 145 -340 151 -337 b 219 -284 177 -314 199 -298 b 413 86 346 -193 413 -71 b 410 145 413 107 413 125 b 302 256 403 216 363 256 b 259 249 289 256 275 253 b 199 225 239 243 219 233 l 197 223 l 197 261 b 199 334 197 285 199 310 b 347 406 249 357 298 382 b 376 439 360 413 372 425 b 390 516 384 465 390 490 b 389 537 390 523 390 530 b 372 564 384 556 382 564 b 348 557 367 564 359 562 b 204 487 300 537 253 510 b 206 518 206 497 206 507 b 196 611 206 549 203 580 b 179 639 193 621 193 639 l 177 639 b 150 605 161 638 150 625 b 145 482 148 564 144 523 l 145 458 b 29 405 107 439 68 420 b 3 366 12 397 3 386 b 12 243 1 325 9 287 b 143 307 56 265 99 285 l 138 183 b 114 -181 134 60 114 -59 b 130 -327 114 -229 117 -279 b 141 -340 132 -336 135 -340 z m 180 -145 b 189 -29 183 -108 184 -69 b 193 66 192 3 193 35 l 199 69 b 284 95 226 81 253 95 b 317 88 294 95 305 92 b 350 52 340 79 351 68 b 343 23 350 43 348 35 b 180 -145 305 -50 245 -99 z"
                },
                accidentalKomaSharp: {
                    x_min: 0,
                    x_max: 300,
                    y_min: -338,
                    y_max: 351,
                    ha: 689,
                    o: "m 194 -487 b 225 -432 215 -469 223 -452 b 238 -232 229 -366 236 -298 b 377 -199 285 -220 331 -209 b 418 -164 397 -193 410 -181 b 432 -88 428 -138 432 -114 b 412 -42 432 -55 428 -42 b 389 -46 406 -42 399 -43 l 235 -85 b 233 -20 235 -63 233 -42 b 233 105 232 22 233 63 b 312 121 259 111 285 117 b 406 226 390 134 400 145 b 373 284 409 268 402 284 b 344 281 364 284 356 282 b 232 258 307 276 269 266 b 230 308 232 275 232 291 b 210 505 229 374 232 441 b 183 471 189 501 184 490 b 180 406 181 449 180 428 b 184 246 180 353 184 300 b 48 222 140 236 94 228 b 0 168 6 216 0 209 b 7 86 1 141 4 114 b 27 66 9 73 13 66 l 35 66 b 184 94 85 66 135 84 b 187 -1 184 62 186 30 b 190 -96 189 -33 190 -65 l 112 -114 b 35 -213 27 -132 35 -132 b 33 -253 35 -226 35 -240 b 49 -276 33 -269 37 -276 b 62 -275 52 -276 56 -276 l 186 -245 l 186 -256 b 179 -387 180 -300 177 -343 b 194 -487 180 -419 179 -454 z"
                },
                accidentalKucukMucennebSharp: {
                    x_min: 0,
                    x_max: 359,
                    y_min: -420,
                    y_max: 343,
                    ha: 763,
                    o: "m 236 -605 b 262 -543 256 -583 261 -564 b 269 -423 268 -503 269 -464 b 266 -340 269 -396 268 -367 l 361 -318 b 405 -276 384 -312 399 -298 b 413 -189 412 -248 416 -219 b 395 -164 412 -171 409 -164 b 382 -166 392 -164 387 -164 b 264 -193 343 -176 304 -184 b 269 -102 265 -163 268 -132 b 454 -62 331 -89 392 -78 b 501 -23 477 -58 494 -45 b 517 62 511 6 517 33 b 487 112 517 95 513 112 b 471 111 482 112 477 112 b 274 66 406 95 340 81 b 276 138 275 91 276 114 b 350 154 301 144 325 148 b 402 203 377 160 396 176 b 412 284 408 230 412 258 b 392 311 412 302 406 311 b 372 308 386 311 379 310 b 287 291 343 301 314 297 l 295 405 b 298 441 297 416 298 428 b 292 475 298 452 297 464 b 282 494 289 482 294 494 b 264 481 274 494 266 490 b 255 455 259 474 256 464 b 239 282 248 397 243 340 b 148 268 209 278 179 274 b 62 164 62 252 62 253 l 62 132 b 79 108 60 117 65 108 l 86 108 l 230 130 b 229 92 230 118 229 105 b 228 56 228 79 228 68 b 66 20 173 43 120 32 b 0 -59 6 7 3 1 l 0 -138 b 14 -160 -1 -156 4 -160 b 27 -158 19 -160 23 -160 b 222 -112 92 -141 157 -127 b 220 -203 220 -143 220 -173 b 147 -217 196 -207 171 -213 b 89 -288 92 -228 89 -229 b 95 -347 85 -305 96 -325 b 112 -374 92 -366 98 -374 b 125 -373 117 -374 121 -374 l 220 -351 b 222 -458 220 -386 220 -422 b 236 -605 223 -504 225 -552 z"
                },
                accidentalKoron: {
                    x_min: 0,
                    x_max: 303,
                    y_min: -462,
                    y_max: 180,
                    ha: 642,
                    o: "m 59 -665 b 72 -649 69 -662 72 -657 b 69 -626 72 -642 69 -634 b 69 -622 69 -625 69 -624 l 69 -600 b 55 -156 60 -456 68 -311 b 86 -170 66 -166 76 -170 b 112 -163 95 -170 104 -166 b 390 -35 204 -120 298 -78 b 436 -1 409 -27 436 -27 b 396 46 436 22 413 33 l 382 55 b 46 243 271 121 157 179 b 12 259 29 253 17 259 b 0 219 1 259 0 248 b 3 -372 0 22 3 -176 b 6 -616 3 -454 6 -536 b 59 -665 6 -638 40 -671 z m 55 199 b 363 24 156 141 258 84 b 55 -118 259 -24 160 -69 z"
                },
                accidentalSori: {
                    x_min: 0,
                    x_max: 434,
                    y_min: -295,
                    y_max: 325,
                    ha: 620,
                    o: "m 194 -425 b 196 -409 194 -418 196 -413 b 194 -194 196 -337 196 -266 b 364 -127 251 -171 308 -150 b 361 -321 363 -192 364 -256 b 410 -387 360 -357 373 -377 b 413 -373 412 -382 413 -377 b 418 -114 418 -287 418 -200 l 418 -105 b 595 -35 477 -82 536 -59 b 625 0 612 -27 625 -22 b 593 48 624 23 618 39 l 419 117 b 423 370 419 202 423 285 b 426 403 423 382 426 393 b 418 436 426 415 425 426 b 384 468 409 449 399 468 b 369 448 370 468 369 459 b 369 436 369 444 369 441 l 369 428 l 369 423 b 367 138 369 328 367 233 l 353 143 l 192 207 l 192 367 b 173 406 192 383 184 396 b 151 422 167 413 160 422 b 144 420 148 422 147 422 b 137 403 138 416 137 410 l 137 392 l 137 229 b 33 271 102 243 68 256 b 13 276 26 274 19 276 b 0 262 6 276 0 272 b 35 199 1 239 0 212 l 138 160 b 140 -148 138 58 138 -45 b 56 -181 111 -158 84 -170 b 24 -215 35 -189 24 -199 b 29 -235 24 -220 26 -228 b 49 -253 35 -249 42 -253 b 78 -240 59 -253 69 -243 b 140 -216 98 -233 120 -225 l 140 -356 b 194 -425 140 -406 141 -406 z m 194 -125 b 193 138 194 -37 193 50 b 315 89 233 122 275 107 b 366 71 333 84 350 76 b 364 -58 366 27 366 -16 b 194 -125 308 -81 251 -104 z m 419 49 l 526 7 l 485 -10 l 419 -36 z"
                },
                articAccentAbove: {
                    x_min: 0,
                    x_max: 425,
                    y_min: 0,
                    y_max: 326,
                    ha: 326,
                    o: "m 27 1 b 78 12 46 0 62 6 b 347 112 168 45 253 91 b 521 184 409 128 459 167 b 608 259 557 194 589 220 b 612 274 611 265 612 271 b 598 292 612 281 608 287 b 477 347 559 312 518 331 b 176 465 374 384 275 425 b 156 469 168 468 161 469 b 125 456 145 469 137 465 b 53 370 96 432 78 399 b 45 353 48 363 45 357 b 68 333 45 344 52 337 b 360 225 166 298 262 261 b 192 154 302 203 249 171 b 13 36 120 132 53 105 b 0 13 9 29 0 22 l 0 9 b 16 0 3 1 10 0 l 26 0 b 27 1 27 0 27 0 z"
                },
                articAccentBelow: {
                    x_min: 0,
                    x_max: 425,
                    y_min: -326,
                    y_max: 0,
                    ha: 326,
                    o: "m 26 -469 l 27 -469 b 78 -458 46 -469 62 -464 b 347 -357 168 -426 253 -380 b 521 -285 409 -341 459 -302 b 608 -210 557 -276 589 -249 b 612 -196 611 -204 612 -200 b 598 -179 612 -189 608 -183 b 477 -122 559 -157 518 -138 b 176 -4 374 -85 275 -45 b 156 0 168 -1 161 0 b 125 -13 145 0 137 -4 b 53 -99 96 -37 78 -71 b 45 -117 48 -107 45 -112 b 68 -137 45 -125 52 -132 b 360 -245 166 -171 262 -209 b 192 -315 302 -266 249 -300 b 13 -433 120 -337 53 -366 b 0 -456 9 -442 0 -448 l 0 -461 b 16 -469 3 -468 10 -469 z"
                },
                articTenutoAbove: {
                    x_min: 0,
                    x_max: 471,
                    y_min: 0,
                    y_max: 56,
                    ha: 56,
                    o: "m 137 0 b 197 1 156 0 179 1 b 409 6 268 1 338 6 b 482 4 432 6 459 6 b 556 0 508 3 534 0 b 651 10 588 0 621 3 b 678 27 662 12 678 10 b 654 59 680 45 672 53 b 511 75 606 73 560 73 b 255 81 426 78 341 81 b 160 79 222 81 193 79 l 36 79 b 1 71 24 78 7 85 b 19 32 -3 56 9 43 b 45 16 26 24 36 20 b 137 0 76 3 108 0 z"
                },
                articTenutoBelow: {
                    x_min: 0,
                    x_max: 471,
                    y_min: -59,
                    y_max: -3,
                    ha: 56,
                    o: "m 137 -85 b 197 -84 156 -85 179 -84 b 409 -79 268 -84 338 -79 b 482 -81 432 -79 459 -79 b 556 -85 508 -82 534 -85 b 651 -75 588 -85 621 -82 b 678 -58 662 -73 678 -75 b 654 -26 680 -40 672 -32 b 511 -10 606 -12 560 -12 b 255 -4 426 -7 341 -4 b 160 -6 222 -4 193 -6 l 36 -6 b 1 -14 24 -7 7 0 b 19 -53 -3 -29 9 -42 b 45 -69 26 -60 36 -65 b 137 -85 76 -82 108 -85 z"
                },
                articStaccatoAbove: {
                    x_min: 1,
                    x_max: 112,
                    y_min: 0,
                    y_max: 156,
                    ha: 156,
                    o: "m 98 0 b 132 23 109 0 122 7 b 161 112 150 50 161 79 b 158 148 161 124 161 137 b 125 186 154 167 131 167 b 63 225 117 215 85 216 b 23 197 45 222 30 219 b 3 91 12 163 12 127 b 19 66 0 79 4 69 b 65 27 40 62 53 46 b 98 0 76 9 88 0 z"
                },
                articStaccatoBelow: {
                    x_min: 1,
                    x_max: 112,
                    y_min: -156,
                    y_max: 0,
                    ha: 156,
                    o: "m 132 -202 b 161 -112 151 -174 163 -145 b 158 -76 161 -101 161 -88 b 125 -39 153 -58 131 -58 b 63 0 115 -10 85 -9 b 23 -27 45 -3 30 -6 b 3 -134 12 -62 10 -98 b 19 -158 0 -145 4 -156 b 65 -197 40 -164 53 -179 b 98 -225 75 -216 88 -225 b 132 -202 109 -225 122 -217 z"
                },
                articStaccatissimoAbove: {
                    x_min: 0,
                    x_max: 139,
                    y_min: 0,
                    y_max: 411,
                    ha: 411,
                    o: "m 104 0 b 144 115 143 29 138 75 b 197 423 158 217 180 320 b 200 454 199 433 200 444 b 181 540 200 482 193 513 b 112 592 167 573 141 592 b 55 567 92 592 72 585 b 0 490 32 546 3 527 l 0 484 b 27 279 14 416 14 347 b 84 20 43 193 52 104 b 96 0 86 13 92 6 z"
                },
                articStaccatissimoBelow: {
                    x_min: 0,
                    x_max: 139,
                    y_min: -411,
                    y_max: 0,
                    ha: 411,
                    o: "m 88 -592 b 145 -567 108 -592 128 -585 b 200 -490 168 -546 197 -527 l 200 -484 b 173 -279 186 -416 186 -347 b 117 -20 157 -193 148 -104 b 104 0 114 -13 108 -6 l 96 0 b 56 -115 58 -29 62 -75 b 3 -423 42 -217 20 -320 b 0 -454 1 -433 0 -444 b 19 -540 0 -482 7 -513 b 88 -592 33 -573 59 -592 z"
                },
                articMarcatoAbove: {
                    x_min: 0,
                    x_max: 396,
                    y_min: 0,
                    y_max: 328,
                    ha: 328,
                    o: "m 477 0 b 510 13 488 0 500 6 b 570 124 546 40 563 81 b 547 183 570 147 560 166 b 356 422 487 265 405 330 b 346 442 354 429 350 436 l 346 444 b 318 465 340 456 330 464 l 312 469 b 274 449 294 480 284 461 b 242 413 262 438 253 425 b 56 196 177 343 112 274 b 1 56 26 154 13 105 b 27 20 -4 35 9 20 b 42 23 32 20 37 20 b 84 53 59 29 72 39 b 255 269 141 125 193 200 b 275 229 262 255 266 242 b 448 14 324 151 390 86 b 477 0 456 4 467 0 z"
                },
                articMarcatoBelow: {
                    x_min: 0,
                    x_max: 396,
                    y_min: -328,
                    y_max: 0,
                    ha: 328,
                    o: "m 258 -469 b 297 -449 276 -480 287 -461 b 328 -413 308 -438 317 -425 b 514 -196 393 -343 458 -274 b 569 -56 544 -154 557 -105 b 543 -20 575 -35 562 -20 b 528 -23 539 -20 533 -20 b 487 -53 511 -29 498 -39 b 315 -269 429 -125 377 -200 b 295 -229 308 -255 304 -242 b 122 -14 246 -151 180 -86 b 94 0 114 -4 104 0 b 60 -13 82 0 71 -6 b 0 -124 24 -40 7 -81 b 23 -183 0 -147 10 -166 b 215 -422 84 -265 166 -330 b 225 -442 216 -429 220 -436 l 225 -444 b 252 -465 230 -456 240 -464 z"
                },
                fermataAbove: {
                    x_min: 0,
                    x_max: 472,
                    y_min: 2,
                    y_max: 454,
                    ha: 452,
                    o: "m 39 10 b 78 108 66 37 71 73 b 163 311 92 181 111 252 b 284 423 199 353 239 392 b 373 458 312 444 340 454 b 433 431 395 458 410 446 b 603 153 530 361 596 276 b 595 121 603 144 595 131 l 595 88 b 602 50 596 75 589 55 b 639 73 619 43 631 60 b 651 102 645 82 648 92 b 667 194 660 132 662 163 b 680 278 671 222 672 248 b 560 567 680 386 638 481 b 396 654 508 625 452 649 b 291 632 364 654 325 644 b 161 526 235 613 200 566 b 4 249 85 446 26 357 b 4 174 0 222 -3 196 b 10 19 4 124 4 69 b 29 4 12 6 16 0 b 39 10 35 4 33 4 z m 338 37 b 370 40 350 36 357 36 b 380 75 387 40 380 43 b 389 94 382 79 382 85 b 356 132 389 111 374 122 b 269 154 328 147 300 156 b 225 125 252 154 228 157 b 261 48 222 81 232 56 b 338 37 287 40 312 40 z"
                },
                fermataBelow: {
                    x_min: 0,
                    x_max: 519,
                    y_min: -430,
                    y_max: -1,
                    ha: 429,
                    o: "m 344 -615 b 500 -543 402 -602 452 -576 b 713 -253 605 -471 661 -364 b 746 -98 737 -204 750 -153 b 727 -59 744 -82 744 -59 b 688 -88 711 -59 694 -68 b 678 -109 687 -96 683 -102 b 562 -314 648 -183 611 -252 b 387 -439 516 -373 458 -416 b 328 -449 367 -446 347 -449 b 180 -386 274 -449 225 -423 b 69 -179 111 -330 69 -262 b 75 -121 69 -160 71 -141 b 84 -58 78 -101 84 -79 b 82 -39 84 -52 84 -45 b 68 -1 79 -26 82 -4 b 26 -32 49 0 33 -12 b 20 -52 24 -39 22 -45 b 0 -223 9 -107 -3 -161 b 141 -553 1 -348 27 -468 b 304 -619 192 -590 243 -619 b 344 -615 317 -619 330 -618 z m 415 -190 b 435 -157 429 -192 435 -184 b 308 -27 435 -86 379 -27 b 271 -46 287 -27 272 -35 b 269 -69 269 -55 269 -62 b 364 -183 269 -128 302 -170 z"
                },
                fermataLongAbove: {
                    x_min: 0,
                    x_max: 591,
                    y_min: -6,
                    y_max: 337,
                    ha: 343,
                    o: "m 20 -9 b 36 14 29 -9 35 3 b 49 109 45 45 49 78 b 48 143 49 121 49 131 b 42 312 40 200 45 256 b 63 338 42 331 46 338 b 68 340 65 338 66 338 b 279 333 138 336 209 334 b 760 317 439 330 599 323 b 783 298 775 317 782 315 l 796 161 b 814 17 801 115 802 68 b 851 144 840 45 855 102 b 824 396 842 228 834 312 b 760 468 816 459 812 467 l 55 485 b 1 433 12 487 1 478 l 1 387 b 0 203 1 325 0 264 b 9 17 0 141 3 79 b 20 -9 9 7 6 -9 z m 403 3 b 439 6 413 3 425 4 b 477 42 464 9 474 22 b 478 62 478 49 478 55 l 478 84 b 465 160 478 109 478 135 b 449 173 461 167 459 173 b 354 105 386 179 354 156 b 359 71 354 95 356 84 b 360 65 360 69 360 66 b 403 3 372 14 373 3 z"
                },
                fermataLongBelow: {
                    x_min: 0,
                    x_max: 602,
                    y_min: -335,
                    y_max: 7,
                    ha: 342,
                    o: "m 793 -482 b 851 -444 822 -482 842 -471 b 867 -357 860 -416 867 -387 b 865 -336 867 -350 867 -343 b 851 -189 858 -287 855 -238 b 832 -32 847 -135 840 -84 b 824 -17 832 -26 832 -17 l 822 -17 b 805 -30 816 -19 806 -20 b 798 -88 802 -50 798 -69 b 805 -292 798 -157 801 -225 b 772 -327 806 -318 801 -327 b 360 -324 635 -327 497 -325 b 78 -327 265 -323 171 -327 b 50 -304 59 -327 50 -320 l 50 -297 b 62 -187 55 -261 60 -225 b 71 -60 62 -144 71 -102 b 68 -20 71 -48 71 -33 b 53 10 66 -10 69 10 l 52 10 b 22 -22 37 9 24 -1 b 14 -121 17 -55 16 -89 b 0 -359 10 -200 0 -279 b 6 -452 0 -390 3 -420 b 42 -481 9 -478 20 -481 l 415 -481 l 415 -482 z m 409 -183 b 454 -179 420 -183 435 -181 b 505 -124 487 -176 504 -158 b 505 -89 507 -112 505 -101 b 507 -58 505 -79 507 -68 b 505 -42 507 -52 507 -48 b 485 -10 503 -29 501 -10 b 448 -9 472 -9 461 -9 b 380 -22 425 -9 402 -12 b 363 -46 372 -27 363 -35 l 363 -49 b 364 -114 363 -71 361 -94 b 409 -183 374 -168 377 -183 z"
                },
                fermataVeryLongAbove: {
                    x_min: 0,
                    x_max: 715,
                    y_min: -14,
                    y_max: 437,
                    ha: 451,
                    o: "m 26 -20 b 42 -4 36 -22 39 -12 b 49 53 49 14 49 33 l 49 448 b 69 478 49 467 52 478 l 72 478 b 81 480 75 478 78 478 b 144 477 102 477 122 477 l 207 477 b 943 471 452 477 698 471 b 978 442 966 471 976 467 b 989 99 985 327 985 213 b 999 -19 991 60 995 22 b 1030 62 1028 6 1030 35 b 1021 507 1028 210 1025 359 b 1012 596 1021 537 1017 567 b 976 624 1009 618 998 624 b 507 626 819 624 662 625 b 46 629 353 628 200 629 b 7 590 19 629 7 618 b 0 101 7 428 0 264 b 16 -4 0 65 13 32 b 26 -20 17 -10 22 -19 z m 187 -9 b 207 30 206 -7 204 14 b 207 55 209 37 207 46 b 200 240 210 117 197 179 b 219 262 200 256 203 262 l 223 262 b 456 252 301 258 379 255 l 772 239 b 804 209 792 238 802 235 b 818 69 806 163 809 115 b 834 -4 821 46 816 19 b 857 56 852 13 857 35 b 851 183 857 99 858 141 b 827 360 841 242 841 301 b 786 390 821 383 809 389 b 189 409 588 403 387 402 b 153 377 163 409 153 400 b 173 27 153 259 150 143 b 187 -9 176 13 177 -9 z m 478 3 b 536 10 491 3 510 6 b 582 60 569 14 580 32 l 582 89 l 580 89 b 580 117 580 98 582 107 b 540 171 577 158 572 171 b 521 171 534 171 528 170 b 459 166 500 170 480 168 b 423 132 436 164 423 154 b 428 88 423 118 425 102 b 478 3 438 22 439 4 z"
                },
                fermataVeryLongBelow: {
                    x_min: 0,
                    x_max: 686,
                    y_min: -427,
                    y_max: 30,
                    ha: 457,
                    o: "m 56 -615 b 282 -612 132 -612 207 -613 b 924 -606 497 -608 710 -606 b 973 -570 953 -606 968 -593 b 988 -455 984 -533 991 -494 b 982 -262 984 -390 982 -327 b 976 -69 982 -197 981 -134 b 976 -14 975 -50 976 -33 b 966 43 976 4 975 23 b 940 20 953 37 943 35 b 933 -76 936 -12 933 -45 b 935 -121 933 -91 933 -107 b 940 -307 940 -183 940 -245 l 940 -435 b 919 -458 940 -451 935 -458 b 894 -459 910 -458 903 -458 b 206 -467 665 -461 435 -467 b 88 -467 167 -467 127 -468 b 45 -425 45 -467 42 -465 b 46 -400 46 -416 46 -408 b 43 -325 46 -376 43 -350 b 42 -59 42 -236 42 -148 b 22 17 42 -32 36 -6 b 0 -27 -1 7 0 -10 b 7 -420 0 -158 7 -289 l 7 -474 b 16 -579 7 -510 7 -544 b 56 -615 22 -603 27 -615 z m 789 -390 b 835 -357 816 -392 829 -380 b 850 -256 844 -324 850 -291 b 848 -230 850 -248 850 -239 b 845 -135 845 -199 845 -167 l 845 -72 b 837 23 845 -40 848 -9 b 809 -27 809 14 809 -7 l 809 -222 b 788 -242 809 -238 805 -242 l 203 -229 b 180 -209 186 -229 180 -223 l 180 -160 b 179 -115 180 -145 180 -131 b 179 -50 177 -94 179 -72 b 163 24 179 -26 176 0 b 137 -6 145 19 140 10 b 134 -39 134 -17 134 -27 b 138 -105 134 -60 137 -82 l 138 -197 b 145 -343 138 -246 138 -294 b 179 -377 148 -364 151 -377 b 789 -390 383 -377 586 -380 z m 480 -164 b 566 -65 549 -164 566 -140 b 527 1 566 -10 564 1 b 436 -71 426 1 436 -9 l 436 -88 l 436 -143 b 454 -163 436 -153 439 -161 b 480 -164 464 -163 472 -164 z"
                },
                fermataVeryShortAbove: {
                    x_min: 0,
                    x_max: 711,
                    y_min: -31,
                    y_max: 496,
                    ha: 527,
                    o: "m 1018 -45 b 1024 -1 1021 -29 1024 -14 b 986 105 1024 40 1008 75 b 557 688 845 302 701 495 b 520 714 544 706 531 714 b 480 687 505 714 492 706 b 340 490 433 621 387 556 b 73 127 252 367 168 243 b 0 22 48 95 22 63 b 68 60 33 27 52 42 b 167 170 101 96 132 135 b 494 503 276 279 384 393 b 518 518 504 513 511 518 b 543 501 526 518 533 513 b 923 63 670 356 799 212 b 1018 -45 952 29 984 -4 z m 837 -16 b 838 1 838 -10 838 -4 b 799 82 838 37 818 60 b 560 369 721 179 639 274 b 541 396 553 377 546 386 b 518 422 533 413 527 422 b 491 400 511 422 503 415 b 347 229 445 341 396 285 b 203 45 297 170 239 117 b 184 17 199 36 184 26 b 189 9 184 14 186 12 b 226 26 200 -1 215 19 l 238 35 b 494 245 321 107 408 176 b 510 253 501 251 505 253 b 526 245 514 253 520 251 b 729 73 592 186 660 130 z m 495 0 b 511 6 500 0 505 1 b 556 32 526 16 540 30 b 586 68 583 35 586 50 b 579 115 586 86 582 101 b 533 190 566 168 553 190 b 459 154 516 190 494 177 b 442 122 448 145 442 135 b 445 105 442 117 442 111 b 477 17 456 76 465 46 b 495 0 481 7 487 0 z"
                },
                fermataVeryShortBelow: {
                    x_min: 0,
                    x_max: 697,
                    y_min: -475,
                    y_max: 13,
                    ha: 488,
                    o: "m 507 -383 b 530 -369 514 -383 521 -377 b 775 -130 611 -288 694 -210 b 824 3 811 -94 822 -48 b 789 -7 808 6 799 0 b 521 -212 698 -72 611 -143 b 488 -226 508 -222 498 -226 b 452 -209 477 -226 467 -220 b 202 7 370 -135 285 -65 b 187 19 197 10 193 19 b 179 14 184 19 181 17 b 171 -3 174 10 171 4 b 173 -13 171 -6 171 -9 b 235 -122 186 -53 206 -94 l 484 -370 b 507 -383 492 -379 500 -383 z m 503 -684 b 539 -647 517 -674 528 -661 b 917 -153 665 -482 793 -318 b 999 -24 948 -112 984 -73 b 1004 -10 1001 -20 1004 -16 b 999 -3 1004 -7 1002 -4 b 973 -10 991 1 981 -1 l 963 -23 b 552 -505 825 -184 688 -344 b 528 -521 543 -517 536 -521 b 505 -505 521 -521 514 -516 b 156 -128 393 -374 274 -253 b 27 6 114 -84 72 -39 b 16 17 24 9 22 17 b 9 13 13 17 12 16 b 0 -3 6 10 0 3 b 1 -9 0 -4 0 -7 b 14 -36 4 -17 9 -27 b 117 -179 45 -86 81 -132 b 482 -667 242 -338 360 -504 b 503 -684 487 -672 491 -683 z m 487 -164 b 552 -98 523 -164 552 -137 b 544 -30 550 -78 549 -55 b 521 -1 541 -19 537 -1 l 517 -1 b 446 -29 492 -9 462 0 b 445 -42 444 -32 445 -37 b 464 -145 451 -76 458 -111 b 487 -164 468 -157 467 -164 z"
                },
                fermataShortAbove: {
                    x_min: 0,
                    x_max: 545,
                    y_min: -18,
                    y_max: 348,
                    ha: 366,
                    o: "m 16 -26 b 36 -9 26 -27 30 -16 b 354 340 143 107 249 223 b 369 348 360 346 364 348 b 382 341 373 348 377 346 l 530 199 b 743 0 599 131 672 68 b 753 -7 747 -3 750 -7 b 762 -1 756 -7 759 -6 b 785 84 776 10 785 48 b 768 150 785 112 779 138 l 399 491 b 379 501 392 498 384 501 b 357 488 372 501 364 495 b 27 137 248 370 141 251 b 1 84 12 121 1 105 b 3 69 1 79 1 75 b 0 55 1 65 0 59 b 9 1 0 36 9 20 b 16 -26 10 -7 3 -22 z m 357 24 b 367 27 360 24 363 24 b 431 118 422 42 431 49 b 429 151 431 130 431 141 b 400 193 428 171 429 193 b 333 147 359 193 333 176 b 341 42 333 111 337 78 b 357 24 343 30 346 24 z"
                },
                fermataShortBelow: {
                    x_min: 0,
                    x_max: 565,
                    y_min: -335,
                    y_max: 10,
                    ha: 345,
                    o: "m 386 -482 b 422 -455 395 -482 405 -474 b 732 -117 526 -343 631 -232 b 814 12 765 -79 799 -42 b 752 -22 780 14 768 -7 b 436 -320 645 -120 540 -219 b 419 -328 429 -325 425 -328 b 400 -318 413 -328 408 -325 b 35 0 279 -212 157 -105 b 16 14 29 4 23 14 b 7 12 13 14 10 14 b 0 -3 1 7 0 1 b 7 -23 0 -10 3 -17 b 20 -48 12 -30 14 -39 b 167 -238 60 -117 115 -177 b 351 -455 229 -310 289 -383 b 386 -482 367 -474 377 -482 z m 382 -213 b 406 -207 389 -213 396 -210 b 452 -156 431 -199 446 -180 b 461 -85 456 -132 458 -108 b 448 -32 461 -66 454 -49 b 418 -6 442 -12 431 -6 b 397 -9 410 -6 405 -7 b 348 -50 376 -14 350 -14 b 356 -170 348 -91 354 -130 b 382 -213 357 -199 363 -213 z"
                },
                breathMarkComma: {
                    x_min: 0,
                    x_max: 148,
                    y_min: 0,
                    y_max: 275,
                    ha: 275,
                    o: "m 120 0 b 187 78 156 20 174 48 b 213 209 206 121 213 164 b 206 294 213 238 210 265 b 140 390 200 337 171 367 b 122 396 134 395 128 396 b 68 382 105 396 85 384 b 46 379 60 382 53 382 b 0 328 12 369 0 357 b 1 311 0 323 1 317 b 30 210 4 275 22 243 b 66 167 39 179 46 167 b 94 171 73 167 82 168 b 143 180 109 174 124 180 b 160 179 148 180 154 180 b 120 66 124 145 120 107 b 120 0 120 45 121 23 z"
                },
                breathMarkUpbow: {
                    x_min: 0,
                    x_max: 254,
                    y_min: 0,
                    y_max: 595,
                    ha: 595,
                    o: "m 233 0 b 256 48 251 14 253 30 b 272 183 264 92 265 138 b 311 455 289 274 295 364 b 350 716 327 541 341 628 b 366 815 354 749 366 782 b 359 857 366 829 363 842 b 327 815 334 852 330 832 b 302 674 315 769 310 721 b 248 357 288 567 269 462 b 225 226 240 314 242 268 b 210 251 212 232 213 243 b 69 721 163 408 117 564 b 32 835 58 760 53 801 b 20 851 29 841 27 851 b 14 850 19 851 16 851 b 0 828 6 847 0 838 l 0 825 b 12 765 1 804 7 785 b 194 125 73 552 132 338 b 233 0 206 84 213 42 z"
                },
                caesura: {
                    x_min: 0,
                    x_max: 566,
                    y_min: 0,
                    y_max: 562,
                    ha: 563,
                    o: "m 0 76 b 49 122 24 92 37 107 b 444 613 180 287 305 455 b 528 770 484 660 518 708 b 531 792 530 778 531 785 b 524 808 531 799 530 805 b 490 792 513 815 498 802 b 390 683 456 756 420 721 b 48 262 275 543 164 400 b 0 76 0 207 7 145 z m 226 1 b 248 13 238 -4 243 7 l 353 137 b 759 638 490 302 632 464 b 814 805 795 688 819 740 b 779 786 796 805 788 796 b 628 609 724 732 678 668 b 310 242 523 485 416 363 b 217 69 265 190 217 140 b 222 30 217 58 219 45 b 222 23 222 29 220 26 b 220 12 222 20 220 16 b 226 1 220 7 222 3 z"
                },
                caesuraCurved: {
                    x_min: 0,
                    x_max: 386,
                    y_min: -10,
                    y_max: 584,
                    ha: 594,
                    o: "m 180 -14 b 246 14 213 -13 230 0 b 347 144 288 52 315 99 b 526 471 420 246 488 350 b 556 671 546 537 556 603 b 543 798 556 713 553 756 b 504 837 537 822 521 828 b 490 841 500 840 494 841 b 472 832 482 841 477 838 b 406 678 436 785 406 737 b 410 638 406 665 408 652 b 425 511 419 595 425 553 b 315 186 425 395 387 287 b 180 -14 271 122 228 58 z m 14 24 b 49 39 29 24 40 32 b 120 114 76 60 99 85 b 216 276 156 166 184 223 b 317 626 281 384 317 501 b 315 664 317 639 317 651 b 301 773 314 701 311 737 b 262 808 295 795 278 808 b 245 799 256 808 249 805 b 170 641 209 750 170 706 b 171 621 170 634 170 628 b 177 511 176 585 177 549 b 114 229 177 415 160 320 b 0 26 79 161 42 95 b 14 24 6 24 10 24 z"
                },
                restMaxima: {
                    x_min: 0,
                    x_max: 366,
                    y_min: -255,
                    y_max: 255,
                    ha: 510,
                    o: "m 397 -367 b 504 -343 436 -367 468 -347 b 518 -318 516 -341 518 -330 b 527 -30 518 -217 527 -117 b 526 33 527 -7 527 13 l 526 301 b 501 350 526 323 520 341 b 428 367 477 361 452 367 b 374 359 410 367 393 364 b 357 333 361 354 357 347 b 356 91 357 252 356 171 l 356 30 b 340 -307 357 -82 346 -194 b 397 -367 337 -354 350 -367 z m 46 -357 b 58 -356 49 -357 53 -357 b 154 -333 91 -351 121 -338 b 173 -305 168 -330 173 -320 l 173 302 b 132 356 173 330 157 348 b 68 364 112 363 89 364 b 3 304 19 363 1 348 l 3 4 l 0 4 b 1 -302 0 -98 0 -200 b 46 -357 1 -331 16 -357 z"
                },
                restDoubleWhole: {
                    x_min: 0,
                    x_max: 122,
                    y_min: 0,
                    y_max: 249,
                    ha: 249,
                    o: "m 43 0 b 58 1 48 0 52 0 b 124 20 81 6 102 17 b 176 96 173 27 176 58 b 173 220 174 138 173 179 b 176 304 173 248 176 276 b 140 353 176 331 163 346 b 95 359 125 356 111 359 b 32 346 73 359 52 354 b 0 315 20 340 0 337 b 1 243 0 291 1 268 l 1 174 l 4 174 l 4 48 b 43 0 4 16 17 0 z"
                },
                restWhole: {
                    x_min: 1,
                    x_max: 500,
                    y_min: -120,
                    y_max: 14,
                    ha: 134,
                    o: "m 356 -173 l 356 -171 l 642 -171 b 719 -115 680 -171 717 -145 b 720 -82 719 -104 720 -92 b 711 -20 720 -60 719 -40 b 672 17 704 0 694 10 b 649 20 664 20 657 20 b 605 17 634 20 621 17 b 92 19 433 17 262 17 b 29 7 69 20 49 12 b 9 -17 12 4 9 -6 b 10 -43 9 -26 10 -35 b 1 -84 10 -58 3 -72 b 76 -173 0 -147 7 -173 z"
                },
                restWholeLegerLine: {
                    x_min: -197,
                    x_max: 685,
                    y_min: -157,
                    y_max: 29,
                    ha: 186,
                    o: "m 96 -226 b 167 -223 121 -226 144 -225 b 300 -222 207 -222 252 -222 l 444 -222 b 660 -217 520 -222 595 -222 b 746 -131 703 -216 746 -200 b 744 -62 746 -108 747 -85 b 743 -39 743 -53 743 -46 b 789 -14 743 -16 752 -17 b 883 -16 821 -13 851 -16 b 965 -9 910 -16 937 -14 b 986 3 972 -7 986 -10 l 986 6 b 963 35 984 17 982 32 b 887 42 937 39 913 42 b 39 27 605 42 321 33 l -76 27 b -261 20 -138 27 -200 26 b -282 14 -269 20 -279 23 b -271 -7 -287 4 -276 -1 b -209 -27 -253 -23 -230 -24 b -153 -30 -190 -30 -173 -30 b -48 -29 -118 -30 -82 -27 b 6 -32 -22 -29 -6 -27 b 1 -72 3 -43 1 -58 b 4 -167 1 -105 7 -140 b 53 -223 3 -207 14 -217 b 96 -226 68 -226 82 -226 z"
                },
                restHalf: {
                    x_min: 0,
                    x_max: 518,
                    y_min: 0,
                    y_max: 162,
                    ha: 162,
                    o: "m 98 0 l 556 0 b 665 1 592 0 629 0 b 746 82 720 3 743 29 b 736 174 749 114 740 144 b 670 232 729 215 708 232 b 570 229 636 232 603 229 b 356 233 498 229 426 233 l 73 233 b 0 179 19 233 0 220 b 1 154 0 171 0 164 b 6 95 4 135 6 115 b 98 0 3 27 29 0 z"
                },
                restHalfLegerLine: {
                    x_min: -120,
                    x_max: 448,
                    y_min: -20,
                    y_max: 143,
                    ha: 163,
                    o: "m 397 -29 b 482 -23 426 -29 455 -27 b 526 -24 497 -24 511 -24 b 608 -17 554 -24 582 -23 b 645 -1 622 -14 644 -17 b 615 26 648 13 629 20 b 595 32 608 29 602 30 b 526 37 572 35 549 37 b 498 36 517 37 507 37 b 471 35 487 35 478 35 b 445 53 451 35 445 39 b 449 89 445 60 446 73 l 454 117 b 373 206 456 173 428 206 b 324 204 356 206 340 206 b 209 203 287 203 248 203 b 46 193 156 203 101 202 b 16 170 32 190 19 187 b 9 112 13 151 9 131 b 14 78 9 101 10 89 b 19 59 17 71 19 63 b -4 45 19 49 12 45 l -10 45 b -150 33 -58 45 -104 46 b -173 22 -158 32 -173 33 l -173 19 b -151 -13 -170 6 -168 -10 b -117 -17 -140 -16 -128 -17 b 118 -13 -37 -17 39 -13 b 397 -29 213 -13 308 -29 z"
                },
                restQuarter: {
                    x_min: 0,
                    x_max: 263,
                    y_min: -415,
                    y_max: 415,
                    ha: 830,
                    o: "m 151 -596 b 164 -563 163 -589 161 -575 b 160 -546 164 -557 161 -552 b 124 -396 148 -495 135 -446 b 122 -380 122 -390 122 -384 b 199 -255 122 -331 158 -272 b 228 -256 209 -249 217 -253 b 324 -346 274 -271 298 -310 b 353 -369 331 -356 341 -369 b 360 -367 356 -369 357 -369 b 379 -336 373 -361 379 -348 l 377 -325 b 344 -232 372 -292 366 -258 b 249 -58 301 -180 278 -117 b 242 -36 245 -49 242 -42 b 258 -7 242 -26 248 -17 b 328 78 284 20 311 45 b 354 158 344 104 354 131 b 337 216 354 177 350 196 b 213 435 294 288 249 359 b 115 575 189 487 158 536 b 78 598 105 585 92 598 b 59 592 72 598 66 596 b 39 562 45 583 39 572 b 53 527 39 550 45 539 b 168 344 98 469 125 402 b 187 307 181 328 187 317 b 153 269 187 294 176 284 b 62 213 122 252 91 235 b 40 180 48 203 40 192 b 46 158 40 173 43 166 b 99 65 60 125 79 95 b 183 -79 131 20 160 -29 b 156 -86 173 -88 164 -85 b 0 -261 58 -99 -7 -173 b 96 -557 10 -366 49 -464 b 124 -585 102 -569 109 -580 b 145 -598 132 -588 138 -598 b 151 -596 147 -598 150 -598 z"
                },
                rest8th: {
                    x_min: 0,
                    x_max: 289,
                    y_min: -260,
                    y_max: 261,
                    ha: 521,
                    o: "m 164 -374 b 212 -340 190 -373 203 -357 b 276 -190 238 -292 258 -242 b 410 285 333 -36 359 128 b 416 314 413 294 416 304 l 416 321 b 393 354 415 341 410 354 b 382 353 389 354 386 354 b 292 311 347 347 315 333 b 174 225 256 276 216 251 b 157 219 168 222 163 219 b 140 228 151 219 145 222 b 131 246 134 233 131 240 b 135 262 131 252 132 256 b 147 298 141 272 147 285 b 127 367 147 323 154 354 b 94 376 114 373 102 376 b 48 336 75 376 63 363 b 3 181 20 288 12 235 b 0 150 1 170 0 160 b 109 24 0 84 35 24 b 171 36 127 24 148 27 b 289 101 213 52 248 75 b 164 -374 256 -62 193 -213 z"
                },
                rest16th: {
                    x_min: 0,
                    x_max: 333,
                    y_min: -328,
                    y_max: 244,
                    ha: 572,
                    o: "m 209 -471 b 246 -458 222 -477 236 -468 b 307 -338 279 -425 300 -384 b 324 -226 312 -301 317 -262 b 428 161 350 -94 386 35 b 480 318 445 215 480 259 b 467 347 480 331 477 341 b 445 351 461 350 454 351 b 408 337 432 351 419 347 b 402 333 405 336 403 334 b 223 215 344 294 294 245 b 236 259 229 233 235 246 b 238 276 238 265 238 271 b 212 338 238 302 226 334 b 193 341 206 340 199 341 b 86 289 156 341 104 317 b 59 180 66 255 59 217 b 156 27 59 76 92 27 b 236 46 179 27 204 35 b 338 101 271 59 298 82 b 289 -49 312 49 302 0 b 196 -122 276 -99 235 -107 b 176 -114 187 -127 176 -127 l 176 -111 b 157 -53 177 -88 164 -72 b 69 -9 141 -7 101 -16 b 17 -48 43 -3 29 -27 b 0 -127 4 -73 0 -99 b 6 -186 0 -147 1 -167 b 82 -294 17 -262 37 -294 b 160 -276 102 -294 128 -289 b 219 -242 181 -268 203 -259 b 236 -230 223 -236 229 -230 b 243 -232 239 -230 240 -230 b 235 -275 248 -246 239 -261 b 202 -456 220 -334 202 -395 b 209 -471 202 -462 203 -468 z"
                },
                rest32nd: {
                    x_min: 0,
                    x_max: 347,
                    y_min: -498,
                    y_max: 483,
                    ha: 981,
                    o: "m 177 -716 b 217 -690 194 -720 209 -704 b 233 -655 225 -680 230 -668 b 292 -390 253 -567 275 -480 b 361 -48 312 -275 336 -161 b 452 400 393 102 422 252 b 497 629 467 477 482 553 b 500 647 498 635 500 641 b 480 691 500 665 492 684 b 464 696 475 694 469 696 b 418 674 448 696 431 685 l 361 626 b 333 611 353 618 343 612 b 308 629 325 611 317 616 b 239 667 292 651 265 661 b 204 670 228 668 216 670 b 86 559 141 670 95 628 b 85 537 86 552 85 544 b 107 416 85 495 95 455 b 161 372 114 389 134 372 b 174 373 166 372 170 372 b 226 383 192 374 209 377 b 387 478 285 402 330 444 b 364 386 379 444 364 415 b 276 271 364 323 320 298 b 265 266 272 268 268 266 b 252 276 261 266 256 269 b 143 333 229 311 186 333 b 107 327 130 333 118 330 b 43 243 62 314 46 291 b 58 145 43 210 52 179 b 150 63 68 92 99 63 b 315 132 213 63 259 98 b 266 -58 297 63 281 4 b 207 -101 259 -91 230 -96 b 186 -66 186 -107 199 -75 b 180 -50 181 -63 183 -55 b 101 -3 160 -23 135 -3 b 9 -66 59 -3 20 -32 b 0 -118 3 -84 0 -101 b 10 -196 0 -144 6 -170 b 104 -287 20 -256 52 -287 b 137 -282 114 -287 125 -287 b 184 -269 151 -281 171 -269 b 196 -275 190 -269 193 -271 b 199 -287 197 -278 199 -282 b 184 -343 199 -304 189 -325 b 181 -348 184 -346 183 -347 b 134 -595 158 -429 131 -508 b 156 -677 134 -624 150 -648 b 177 -716 158 -693 160 -713 z"
                },
                rest64th: {
                    x_min: 0,
                    x_max: 428,
                    y_min: -720,
                    y_max: 474,
                    ha: 1194,
                    o: "m 200 -1037 b 229 -1012 215 -1037 222 -1025 b 238 -984 233 -1004 236 -994 b 282 -780 248 -914 265 -848 b 386 -369 317 -644 354 -507 b 491 104 422 -212 451 -53 b 600 541 528 249 550 399 b 616 629 611 570 616 599 b 600 680 616 648 615 671 b 550 665 586 687 566 677 b 480 618 527 649 501 635 b 464 611 474 613 468 611 b 448 622 458 611 454 615 b 366 662 425 651 397 662 b 331 658 354 662 343 661 b 242 572 285 647 253 619 b 236 528 239 557 236 543 b 266 400 236 484 251 442 b 325 373 274 377 301 373 b 436 409 366 373 403 383 l 494 452 b 474 360 485 416 474 389 b 383 248 474 297 435 269 b 320 328 377 288 351 310 b 276 341 305 337 291 341 b 186 269 235 341 194 311 b 181 230 183 256 181 243 b 187 153 181 204 186 179 b 279 63 192 86 233 63 b 304 65 288 63 295 63 b 416 115 344 72 379 92 b 387 -14 406 69 397 27 b 320 -95 380 -52 369 -86 b 318 -79 320 -89 320 -84 b 223 0 305 -29 271 0 b 122 -81 171 0 135 -30 b 118 -127 120 -96 118 -112 l 118 -196 b 137 -242 118 -215 125 -229 b 209 -275 157 -266 181 -275 b 249 -269 222 -275 235 -274 b 318 -248 272 -264 294 -255 b 281 -390 315 -301 292 -344 b 276 -400 279 -393 279 -397 b 259 -420 272 -408 266 -416 b 246 -429 255 -425 251 -429 b 233 -415 242 -429 238 -426 b 176 -359 225 -389 200 -372 b 121 -346 158 -348 140 -346 b 14 -408 73 -346 27 -370 b 0 -498 4 -438 0 -468 b 6 -564 0 -520 3 -543 b 91 -635 12 -611 45 -635 b 131 -629 104 -635 117 -634 b 223 -590 163 -622 190 -603 b 166 -824 203 -671 189 -747 b 148 -912 157 -852 148 -881 b 156 -955 148 -926 150 -940 b 177 -1008 161 -972 170 -991 b 200 -1037 181 -1020 183 -1037 z"
                },
                rest128th: {
                    x_min: 1,
                    x_max: 491,
                    y_min: -711,
                    y_max: 719,
                    ha: 1430,
                    o: "m 233 -1015 b 271 -956 256 -1002 266 -981 l 314 -723 b 393 -350 337 -598 366 -474 b 543 312 442 -128 492 91 b 687 841 583 490 635 665 b 707 958 698 880 707 919 b 706 986 707 968 707 976 b 688 1025 704 999 704 1024 b 670 1027 683 1025 677 1027 b 629 1007 655 1027 639 1022 b 559 945 613 981 586 968 b 541 1004 553 968 559 991 b 456 1035 516 1024 488 1035 b 419 1030 444 1035 431 1034 b 344 953 379 1018 353 995 b 340 900 341 936 340 917 b 341 847 340 881 341 864 b 380 779 340 815 354 793 b 464 763 406 765 435 762 b 592 814 510 763 549 786 b 546 660 575 757 556 710 b 480 585 537 619 517 598 b 478 599 480 590 478 595 b 386 678 472 641 428 678 b 294 612 343 678 304 651 b 279 477 282 567 278 521 b 363 395 281 428 317 395 b 380 396 369 395 374 395 b 488 436 416 403 449 419 b 384 233 469 357 468 275 b 359 291 373 252 377 276 b 282 318 337 310 310 318 b 181 264 243 318 203 298 b 154 107 153 216 154 161 b 242 6 154 42 187 6 b 278 10 253 6 265 7 b 408 88 330 22 366 55 b 387 -1 400 56 393 27 b 301 -112 379 -55 354 -94 b 289 -65 297 -95 302 -79 b 219 -32 269 -42 245 -32 b 183 -37 207 -32 196 -35 b 112 -109 144 -46 121 -71 b 105 -219 104 -145 108 -183 b 186 -315 101 -276 134 -315 b 230 -307 199 -315 215 -312 b 324 -256 264 -295 292 -275 b 180 -491 323 -383 266 -471 b 183 -459 180 -480 180 -469 b 184 -442 184 -454 184 -448 l 184 -436 b 135 -369 184 -403 170 -383 b 102 -363 125 -364 114 -363 b 29 -399 73 -363 45 -376 b 1 -556 -4 -448 6 -503 b 109 -670 -4 -625 43 -670 b 140 -667 118 -670 130 -668 b 253 -616 180 -658 213 -638 b 238 -688 248 -644 242 -665 b 192 -959 220 -779 192 -867 b 193 -992 192 -971 192 -981 b 210 -1024 194 -1014 199 -1024 b 233 -1015 216 -1024 223 -1021 z"
                },
                dynamicPiano: {
                    x_min: -49,
                    x_max: 327,
                    y_min: -142,
                    y_max: 515,
                    ha: 657,
                    o: "m -56 -204 b -42 -202 -52 -204 -46 -203 b -19 -194 -35 -202 -26 -197 b 147 -138 35 -170 91 -151 b 249 -58 194 -127 223 -95 b 262 -29 255 -50 262 -39 b 258 -17 262 -24 261 -20 b 232 -7 252 -10 242 -7 b 210 -12 225 -7 217 -9 b 125 -40 184 -23 157 -30 b 183 140 153 19 171 79 b 251 167 207 144 230 153 b 469 518 383 262 480 382 b 357 687 472 626 420 687 b 315 678 344 687 330 684 b 204 600 279 664 240 634 b 210 704 206 635 209 670 b 215 721 212 710 215 716 b 206 733 215 727 212 730 b 180 742 197 736 189 742 b 164 734 176 742 170 740 b 1 575 108 684 36 645 b -7 557 -1 569 -7 563 b -6 553 -7 556 -7 554 b 7 547 -3 547 3 547 l 17 547 b 82 575 43 547 59 567 l 82 452 b 56 46 82 317 81 180 b 17 -66 49 7 46 -36 b -62 -173 -13 -99 -37 -135 b -71 -192 -66 -179 -71 -184 b -68 -199 -71 -193 -69 -196 b -56 -204 -65 -203 -60 -204 z m 196 258 b 197 266 197 261 197 264 b 200 510 200 347 199 429 b 233 543 210 521 222 533 b 281 560 249 554 266 560 b 340 503 310 560 333 540 b 344 461 343 488 344 474 b 321 323 344 413 333 369 b 268 272 315 300 295 281 b 196 258 245 265 220 261 z"
                },
                dynamicMezzo: {
                    x_min: -18,
                    x_max: 559,
                    y_min: -50,
                    y_max: 365,
                    ha: 415,
                    o: "m 43 -71 b 160 19 86 -71 143 -26 b 230 264 189 99 200 184 b 282 363 243 297 259 327 b 287 320 285 347 287 333 b 284 279 287 305 285 292 l 249 -12 b 275 -43 248 -29 245 -43 b 395 45 321 -43 389 3 b 462 271 406 124 436 197 b 523 387 475 310 490 348 l 523 346 b 504 130 521 274 513 202 b 501 81 501 114 501 98 b 510 3 501 55 504 29 b 580 -72 521 -48 543 -72 b 625 -63 593 -72 608 -69 b 789 50 690 -43 744 -3 b 805 72 795 56 805 63 b 798 85 805 76 802 81 b 778 94 792 91 785 94 b 755 85 770 94 763 91 l 693 40 b 675 33 685 36 680 33 b 658 52 668 33 662 39 b 645 144 651 82 645 112 b 658 448 641 246 660 346 b 606 507 658 485 638 507 b 583 504 599 507 592 505 b 495 446 547 497 521 471 b 420 373 471 423 448 399 b 413 458 418 406 418 432 b 361 507 408 490 386 507 b 320 491 347 507 333 501 b 160 307 256 444 207 382 l 160 337 b 174 488 160 387 174 438 b 156 521 174 501 173 513 b 137 526 148 524 143 526 b 109 513 127 526 118 520 b -16 399 66 477 23 439 b -26 383 -20 395 -26 389 l -26 379 b -14 370 -24 372 -20 370 b -6 372 -12 370 -9 372 b 19 376 4 374 12 376 b 36 359 32 376 36 370 b 30 330 36 350 35 341 l 30 323 b 9 -35 23 203 17 85 b 43 -71 6 -65 19 -71 z"
                },
                dynamicForte: {
                    x_min: -144,
                    x_max: 311,
                    y_min: -115,
                    y_max: 504,
                    ha: 619,
                    o: "m -101 -166 b 173 76 7 -153 150 -30 b 206 344 192 164 202 253 b 268 338 226 343 246 341 b 384 395 317 333 353 361 b 397 419 393 405 397 412 b 367 442 397 429 387 436 b 350 444 361 444 356 444 b 206 455 302 449 255 454 l 206 474 b 202 540 204 495 202 518 b 209 593 202 557 203 576 b 236 624 215 613 225 624 b 265 612 245 624 253 619 b 308 552 287 596 302 577 b 336 533 312 534 323 533 b 448 611 366 533 444 583 b 399 696 452 648 423 671 b 382 706 395 700 387 703 b 308 726 357 720 333 726 b 207 684 272 726 239 711 b 60 455 135 622 60 560 l 10 455 b -23 448 -1 455 -13 454 b -102 372 -55 426 -76 397 b -109 357 -108 367 -109 361 b -95 347 -109 353 -105 348 b -63 346 -84 346 -73 346 b 0 344 -43 344 -22 344 l 63 344 b 53 186 63 291 59 239 b 23 0 46 124 42 60 b -35 -60 10 -42 -6 -60 b -73 -52 -45 -60 -58 -58 b -91 -48 -79 -49 -85 -48 b -109 -53 -96 -48 -102 -49 b -199 -124 -143 -72 -168 -99 b -207 -137 -203 -128 -207 -132 b -194 -148 -207 -141 -203 -145 b -101 -166 -164 -160 -132 -168 z"
                },
                dynamicRinforzando: {
                    x_min: -75,
                    x_max: 322,
                    y_min: -90,
                    y_max: 325,
                    ha: 415,
                    o: "m 23 -130 b 40 -125 27 -130 33 -128 b 128 -9 81 -114 125 -53 b 145 200 132 62 141 130 b 148 238 147 212 148 225 b 308 321 184 291 245 321 b 363 314 325 321 344 318 b 377 310 369 312 373 310 b 384 311 380 310 382 310 b 464 415 410 317 464 389 b 446 433 465 429 455 429 b 390 445 428 441 409 445 b 305 429 361 445 334 438 b 167 346 252 413 202 393 b 153 325 163 338 158 333 b 148 438 154 363 151 399 b 121 468 147 456 134 468 b 101 458 115 468 108 465 b -63 310 46 409 -16 367 b -108 240 -78 289 -98 271 b 32 330 -50 256 -13 297 b 37 304 37 320 37 312 l 37 292 b 10 -101 27 161 20 30 b 23 -130 9 -120 12 -130 z"
                },
                dynamicSforzando: {
                    x_min: 0,
                    x_max: 296,
                    y_min: 0,
                    y_max: 379,
                    ha: 379,
                    o: "m 151 0 b 174 1 160 0 166 0 b 392 158 272 14 346 71 b 405 207 400 174 405 190 b 359 287 405 236 389 265 b 261 325 328 308 294 315 b 168 413 216 340 181 366 b 166 426 167 418 166 423 b 176 438 166 432 167 436 b 199 441 183 441 190 441 b 310 393 238 441 295 422 b 334 370 317 376 325 370 b 363 386 343 370 353 379 b 422 445 386 402 408 420 b 426 458 425 449 426 454 b 422 469 426 462 425 465 b 274 546 395 518 333 546 b 161 503 232 546 190 531 b 86 405 132 472 108 439 b 71 347 75 387 71 367 b 112 256 71 312 85 279 b 209 215 141 232 176 226 b 284 168 238 206 266 197 b 300 131 291 157 300 144 b 298 120 300 127 298 122 b 278 107 294 109 285 108 b 262 108 271 107 266 108 l 259 108 b 114 157 200 107 156 125 b 96 181 104 163 96 170 l 96 184 b 102 202 96 190 102 196 b 96 209 102 204 101 207 b 63 194 82 215 72 204 b 7 109 42 168 26 138 b 0 86 3 101 0 94 b 13 60 0 78 4 68 b 151 0 53 23 101 0 z"
                },
                dynamicZ: {
                    x_min: -43,
                    x_max: 331,
                    y_min: 0,
                    y_max: 328,
                    ha: 328,
                    o: "m -45 0 b -6 16 -32 0 -17 10 b 3 20 -3 16 0 19 b 144 60 49 48 96 60 b 284 22 190 60 238 46 b 348 4 305 10 327 4 b 461 75 393 4 435 30 b 468 91 464 81 467 86 b 456 104 468 95 465 99 b 287 173 402 131 348 167 b 239 176 271 174 255 176 b 168 174 217 176 194 174 b 367 340 236 236 298 294 b 459 423 402 363 432 392 b 477 454 467 431 475 442 b 474 462 477 456 475 459 b 454 472 469 469 462 472 b 432 468 446 472 439 469 b 356 448 406 461 380 455 b 210 422 307 433 258 422 b 109 442 177 422 144 428 b 94 445 104 444 99 445 b 69 433 85 445 76 442 b 27 390 56 419 39 406 b -9 343 16 373 -17 357 b 63 311 3 320 36 314 l 78 311 b 132 307 95 308 114 307 b 240 314 168 307 203 311 l 193 271 b -37 50 117 196 19 145 b -59 7 -46 36 -69 20 b -45 0 -55 3 -50 0 z"
                },
                ornamentTrill: {
                    x_min: 1,
                    x_max: 551,
                    y_min: -18,
                    y_max: 539,
                    ha: 557,
                    o: "m 321 612 b 190 602 278 605 235 605 l 190 638 b 187 693 190 652 190 667 b 161 776 184 717 193 776 b 137 747 150 776 137 766 b 130 654 135 716 131 685 l 130 596 l 52 588 b 4 539 23 585 7 570 b 1 477 3 530 1 500 b 3 448 1 461 3 448 l 3 452 b 53 432 6 436 23 432 b 134 435 75 432 102 433 b 151 117 138 328 147 223 b 170 13 153 82 157 46 b 209 -26 179 -10 193 -26 b 222 -22 213 -26 217 -24 b 269 -17 233 -16 253 -27 b 343 135 325 19 346 66 b 343 158 343 147 344 147 b 323 192 341 171 337 187 b 291 176 311 194 300 184 l 264 148 b 229 131 261 145 238 131 b 212 170 209 131 213 154 b 194 438 203 259 199 348 l 272 442 b 284 452 276 441 279 441 b 305 462 287 461 295 462 l 312 462 b 346 477 325 462 340 464 b 366 560 357 503 366 531 b 321 612 366 598 356 618 z m 759 588 b 711 560 749 592 733 570 b 588 500 671 541 631 521 b 583 533 586 514 586 524 b 560 576 577 549 577 572 b 517 550 541 582 528 564 b 416 423 482 508 452 462 b 382 353 392 397 384 370 b 387 305 380 341 386 318 b 392 275 389 295 392 285 b 409 243 393 262 393 243 b 431 262 419 243 425 255 b 521 373 459 298 488 333 b 523 354 521 366 523 360 b 520 337 523 346 521 340 b 508 295 513 323 508 310 b 530 102 508 279 524 122 b 549 66 533 88 530 66 b 577 99 563 66 572 84 b 580 131 580 109 580 121 l 580 302 b 600 347 580 318 582 337 b 701 392 632 364 665 384 b 793 518 785 409 793 435 b 759 588 793 559 785 576 z"
                },
                ornamentTurn: {
                    x_min: 0,
                    x_max: 574,
                    y_min: 0,
                    y_max: 312,
                    ha: 312,
                    o: "m 651 0 b 816 132 727 0 796 46 b 827 223 822 163 827 193 b 808 340 827 262 821 301 b 665 449 785 408 729 449 b 636 446 655 449 647 448 b 589 384 600 441 586 422 l 602 300 b 611 285 603 291 605 285 b 621 288 613 285 616 287 b 655 295 632 294 644 295 b 711 284 674 295 693 289 b 773 209 740 275 773 232 b 697 156 773 184 734 160 b 664 154 685 154 675 154 b 579 168 635 154 608 158 b 455 242 533 186 495 213 b 261 400 387 291 331 354 b 160 432 225 422 190 432 b 20 328 98 432 49 392 b 0 229 6 295 0 262 b 30 71 0 176 14 122 b 144 3 43 29 96 3 b 168 6 153 3 160 4 b 248 122 233 20 248 39 b 246 147 248 124 248 135 b 226 177 243 164 239 177 b 206 170 220 177 215 174 b 144 154 186 158 166 154 b 79 170 122 154 101 160 b 53 202 62 179 53 189 b 60 228 53 209 55 217 b 161 281 81 261 120 281 b 183 279 168 281 176 281 b 325 190 243 269 284 229 b 572 16 402 124 475 53 b 651 0 598 6 625 0 z"
                },
                ornamentTurnSlash: {
                    x_min: 0,
                    x_max: 574,
                    y_min: -106,
                    y_max: 405,
                    ha: 511,
                    o: "m 441 -153 b 456 -60 455 -118 456 -89 b 455 81 455 -14 455 33 b 572 14 491 55 530 30 b 651 -1 598 4 625 -1 b 816 131 727 -1 796 45 b 827 222 822 161 827 192 b 808 338 827 261 821 300 b 665 448 785 406 729 448 b 636 445 655 448 647 446 b 589 383 600 439 586 420 l 602 298 b 611 284 603 289 605 284 b 621 287 613 284 616 285 b 655 294 632 292 644 294 b 711 282 674 294 693 288 b 773 207 740 274 773 230 b 697 154 773 183 734 158 b 664 153 685 153 675 153 b 579 167 635 153 608 157 b 455 240 533 183 495 212 b 454 242 455 240 455 242 l 454 337 b 452 488 454 386 452 439 b 433 570 452 517 451 546 b 425 583 431 575 431 583 l 422 583 b 403 566 415 582 408 573 b 402 546 400 560 402 553 l 397 287 b 261 399 353 325 310 366 b 160 431 225 420 190 431 b 20 327 98 431 48 390 b 0 228 6 294 0 261 b 30 69 0 174 14 121 b 144 1 43 27 96 1 b 168 4 153 1 160 3 b 248 121 233 19 248 37 b 246 145 248 122 248 134 b 226 176 243 163 239 176 b 206 168 220 176 215 173 b 144 153 186 157 166 153 b 79 168 122 153 101 158 b 53 200 62 177 53 187 b 60 226 53 207 55 216 b 161 279 79 259 120 279 b 183 278 168 279 176 279 b 325 189 243 266 282 226 b 395 130 348 168 372 148 b 393 71 393 109 393 89 b 441 -153 390 -6 402 -78 z"
                },
                ornamentMordent: {
                    x_min: 0,
                    x_max: 700,
                    y_min: 0,
                    y_max: 497,
                    ha: 497,
                    o: "m 513 0 b 528 39 526 14 527 27 b 531 72 531 50 531 60 b 528 138 531 94 528 117 l 528 347 b 552 359 537 354 544 359 b 579 338 560 359 569 353 b 674 217 609 297 639 255 b 719 190 690 200 704 190 b 759 215 732 190 744 197 b 940 395 815 279 877 337 b 1001 490 968 422 986 455 b 1008 513 1004 495 1008 505 b 1002 524 1008 517 1007 521 b 968 516 994 530 978 524 b 960 508 965 513 963 510 b 798 356 900 464 848 410 b 778 341 791 347 783 341 b 757 354 772 341 765 346 b 661 475 720 392 690 432 b 611 517 644 504 629 517 b 563 498 598 517 583 511 b 527 471 550 490 539 481 l 527 570 b 492 716 526 619 523 671 b 472 677 480 704 472 694 b 465 399 474 585 468 491 b 439 366 456 387 448 376 b 384 320 415 336 399 320 b 330 367 369 320 354 336 b 325 376 328 369 327 373 b 226 490 291 413 265 456 b 189 505 213 500 202 505 b 157 491 177 505 167 500 b 0 229 75 420 0 346 b 1 202 0 220 0 212 b 22 215 12 203 16 209 b 124 327 55 252 89 289 b 147 343 132 337 140 343 b 171 323 156 343 164 336 b 266 197 196 276 232 236 b 337 157 291 170 314 157 b 410 207 361 157 386 174 b 461 274 428 229 444 252 b 462 166 461 238 461 202 b 513 0 465 108 487 55 z"
                },
                ornamentShortTrill: {
                    x_min: 0,
                    x_max: 747,
                    y_min: 0,
                    y_max: 243,
                    ha: 243,
                    o: "m 379 0 b 428 14 395 0 410 4 b 474 56 445 26 461 39 b 552 157 500 89 526 122 b 566 168 556 163 560 168 b 575 157 569 168 572 166 b 664 36 592 107 628 72 b 733 1 685 13 710 1 b 802 35 757 1 780 13 b 1007 249 871 105 940 177 b 1067 324 1028 272 1054 295 b 1076 340 1068 330 1076 334 b 1073 346 1076 341 1076 343 b 1057 350 1068 348 1063 350 b 1047 347 1053 350 1050 350 b 1001 310 1031 336 1015 324 l 857 157 b 844 143 852 153 848 143 b 835 150 841 143 838 144 b 757 242 815 186 780 209 b 685 298 739 268 713 284 b 641 310 670 305 655 310 b 590 288 625 310 608 304 b 497 179 554 256 527 215 b 480 164 490 170 485 164 b 462 179 474 164 469 168 b 372 295 436 220 405 258 b 278 344 346 324 312 344 b 199 310 252 344 226 334 b 92 196 161 274 128 233 b 0 24 46 148 23 89 b 42 48 22 27 32 37 b 156 168 84 85 114 132 b 196 192 174 184 186 192 b 228 158 206 192 215 181 b 312 36 252 114 282 75 b 379 0 331 12 354 0 z"
                },
                ornamentTremblement: {
                    x_min: 0,
                    x_max: 982,
                    y_min: 0,
                    y_max: 224,
                    ha: 224,
                    o: "m 0 0 b 63 36 30 12 48 23 b 157 124 94 66 125 94 b 177 135 164 131 170 135 b 196 122 183 135 189 131 b 268 40 217 94 245 68 b 323 6 288 16 304 6 b 369 20 336 6 350 10 b 412 53 384 29 399 40 b 501 145 442 84 472 114 b 523 158 508 154 516 158 b 543 145 528 158 536 154 b 641 45 576 112 608 78 b 698 17 658 27 677 17 b 729 23 708 17 719 20 b 804 65 756 32 780 46 b 904 154 837 95 871 124 b 920 163 910 160 916 163 b 936 153 924 163 930 160 b 1024 60 965 121 996 92 b 1112 13 1053 29 1080 13 b 1184 39 1135 13 1158 22 b 1359 194 1248 84 1305 138 b 1413 301 1388 223 1403 261 b 1404 323 1417 315 1413 323 b 1391 320 1400 323 1395 321 b 1344 294 1375 314 1358 307 b 1224 186 1305 258 1269 216 b 1194 173 1212 179 1202 173 b 1165 193 1184 173 1175 179 b 1096 271 1145 222 1122 248 b 1001 318 1061 302 1031 318 b 903 268 969 318 937 301 b 806 186 871 239 841 210 b 782 174 796 179 789 174 b 756 193 773 174 765 180 b 652 291 729 232 693 266 b 596 308 634 302 615 308 b 530 278 573 308 552 298 l 415 168 b 393 157 408 161 400 157 b 373 171 387 157 380 161 b 305 245 353 197 330 222 b 248 276 285 266 266 278 b 189 245 229 276 210 266 b 81 144 156 209 120 174 b 0 0 33 109 26 56 z"
                },
                ornamentPrecompAppoggTrill: {
                    x_min: 0,
                    x_max: 1066,
                    y_min: -50,
                    y_max: 533,
                    ha: 583,
                    o: "m 187 -46 b 213 -14 197 -37 204 -26 b 285 151 251 36 266 94 b 304 189 294 177 297 189 b 337 168 311 189 320 181 b 458 33 386 131 415 76 b 495 12 472 19 484 12 b 531 40 508 12 518 22 b 580 168 557 79 569 124 b 622 235 592 213 603 235 b 683 194 636 235 655 222 b 838 26 737 140 791 86 b 919 -33 860 -1 881 -39 b 984 53 960 -27 971 19 b 1022 156 998 86 1008 122 b 1054 190 1032 179 1041 190 b 1089 167 1063 190 1074 183 b 1208 32 1129 122 1171 78 b 1244 10 1221 17 1231 10 b 1273 22 1253 10 1263 14 b 1496 206 1352 78 1427 137 b 1535 310 1526 236 1535 272 b 1531 359 1535 325 1534 343 b 1496 343 1515 360 1506 351 l 1309 192 b 1269 167 1289 176 1279 167 b 1234 199 1260 167 1251 177 b 1122 324 1200 243 1168 289 b 1074 344 1106 337 1089 344 b 1014 301 1051 344 1030 328 b 952 144 985 252 971 197 b 933 121 946 128 940 121 b 910 137 927 121 920 125 b 850 210 888 161 870 186 b 687 369 799 266 750 325 b 631 390 665 383 647 390 b 567 327 602 390 580 369 b 527 199 554 284 543 242 b 508 168 520 179 514 168 b 482 192 503 168 495 177 b 353 328 444 240 405 292 b 312 343 338 338 324 343 b 266 297 292 343 276 327 b 204 125 248 239 232 180 b 143 79 193 102 173 79 b 92 122 117 79 105 102 b 81 154 86 131 84 143 b 48 423 59 242 50 333 b 45 544 46 464 45 504 b 53 730 45 606 48 668 b 40 768 55 744 52 766 b 13 730 19 770 14 747 b 0 514 7 658 -1 586 b 26 122 3 383 6 252 b 75 -36 35 66 40 10 b 134 -72 92 -59 112 -72 b 187 -46 151 -72 170 -63 z"
                },
                ornamentPrecompSlideTrillDAnglebert: {
                    x_min: 0,
                    x_max: 1088,
                    y_min: -380,
                    y_max: 252,
                    ha: 632,
                    o: "m 560 -539 b 439 -481 527 -497 484 -485 b 354 -461 409 -478 380 -477 b 131 -154 236 -389 161 -285 b 124 -98 127 -135 124 -117 b 196 55 124 -40 148 10 b 308 99 230 86 268 99 b 399 81 337 99 367 92 b 514 22 441 66 477 43 b 619 -30 567 -9 590 -30 b 719 17 642 -30 670 -16 b 861 131 769 52 818 88 b 899 150 874 144 887 150 b 936 117 913 150 926 138 b 965 43 948 94 956 68 b 1007 -1 973 24 978 -1 b 1048 30 1025 -1 1037 16 b 1070 65 1057 40 1064 52 b 1110 148 1084 92 1096 121 b 1145 190 1120 164 1120 190 b 1191 153 1169 192 1179 168 b 1256 29 1218 115 1231 68 b 1292 1 1267 10 1277 1 b 1320 10 1300 1 1309 4 b 1369 48 1339 19 1355 33 b 1515 196 1418 96 1464 148 b 1567 343 1558 238 1567 287 b 1555 363 1565 357 1562 363 b 1539 356 1551 363 1547 360 b 1433 268 1502 330 1466 301 b 1335 171 1401 236 1374 199 b 1310 163 1325 166 1318 163 b 1286 183 1302 163 1293 168 b 1218 311 1264 226 1247 272 b 1164 351 1200 337 1182 351 b 1110 308 1146 351 1128 337 b 1031 176 1084 265 1058 219 b 1015 161 1025 166 1021 161 b 999 179 1009 161 1005 167 b 955 279 985 213 973 248 b 913 307 943 300 930 307 b 887 302 904 307 896 305 b 852 281 874 298 863 291 b 693 167 804 236 747 204 b 612 140 667 150 639 140 b 549 157 592 140 570 145 b 403 220 503 181 452 202 b 271 248 360 236 315 248 b 179 229 239 248 209 242 b 0 -29 65 180 0 85 b 9 -104 0 -53 3 -78 b 397 -526 56 -317 183 -464 b 505 -547 432 -536 468 -547 b 560 -539 524 -547 541 -544 z"
                },
                ornamentPrecompSlideTrillBach: {
                    x_min: 0,
                    x_max: 1185,
                    y_min: -380,
                    y_max: 465,
                    ha: 845,
                    o: "m 624 -544 b 642 -528 638 -543 642 -537 b 639 -514 642 -524 642 -520 b 590 -444 629 -487 609 -467 b 523 -413 573 -422 553 -410 b 498 -415 514 -415 507 -415 b 399 -389 464 -415 431 -405 b 89 -157 281 -330 176 -255 b 72 -117 78 -144 72 -131 b 73 -101 72 -111 72 -107 b 187 186 91 3 147 91 b 246 230 200 216 222 230 b 300 209 262 230 281 223 b 456 48 359 163 403 101 b 540 -10 494 10 518 -10 b 625 59 566 -10 589 13 b 690 148 648 88 668 118 b 711 167 697 160 704 167 b 733 153 719 167 724 163 b 844 14 769 105 808 60 b 903 -42 873 -23 886 -42 b 973 -1 919 -42 937 -27 b 1008 33 986 7 996 20 b 1048 81 1021 48 1035 65 b 1050 37 1048 66 1050 52 b 1047 -24 1050 17 1048 -3 b 1038 -275 1038 -108 1040 -192 l 1037 -289 b 1045 -302 1037 -295 1038 -301 b 1068 -284 1056 -304 1064 -292 b 1084 -242 1076 -271 1081 -256 b 1099 -109 1096 -199 1099 -154 b 1106 158 1099 -19 1106 71 b 1128 187 1113 167 1120 177 b 1168 223 1143 212 1155 223 b 1210 193 1179 223 1191 213 b 1220 183 1214 190 1215 186 b 1329 36 1261 138 1292 84 b 1374 7 1345 16 1358 7 b 1411 20 1384 7 1395 12 b 1479 84 1437 37 1459 59 b 1610 235 1521 135 1564 186 b 1706 403 1655 282 1695 334 b 1614 346 1663 400 1637 373 b 1464 170 1564 287 1515 228 b 1440 150 1453 156 1447 150 b 1414 173 1433 150 1426 158 b 1283 336 1371 228 1333 288 b 1220 366 1261 356 1240 366 b 1148 318 1194 366 1169 350 b 1103 255 1133 297 1119 275 b 1097 301 1102 271 1100 285 b 1099 334 1099 312 1099 324 b 1092 428 1099 367 1094 397 b 1071 647 1087 501 1079 575 b 1058 670 1071 657 1071 670 b 1035 648 1047 670 1038 661 b 1018 516 1024 605 1015 560 b 1041 203 1025 412 1037 307 b 1043 180 1041 196 1043 187 b 992 127 1027 161 1009 143 b 965 111 981 117 972 111 b 936 132 955 111 946 120 b 829 268 900 179 867 225 b 760 317 801 301 780 317 b 691 258 739 317 719 297 b 605 147 664 219 641 177 b 589 138 599 141 593 138 b 572 148 583 138 579 141 b 415 317 520 206 467 261 b 327 372 390 343 366 366 b 300 373 317 373 308 373 b 154 295 239 373 190 348 b 55 138 120 243 85 192 b 0 -53 22 79 0 13 b 160 -317 0 -156 49 -252 b 209 -354 177 -327 192 -343 b 510 -531 305 -419 397 -495 b 593 -547 537 -540 564 -547 b 624 -544 603 -547 613 -546 z"
                },
                ornamentPrecompTrillSuffixDandrieu: {
                    x_min: 0,
                    x_max: 1003,
                    y_min: -20,
                    y_max: 521,
                    ha: 541,
                    o: "m 791 -16 b 844 33 812 -3 829 14 b 981 271 900 107 937 190 b 994 288 984 278 985 288 b 1009 269 1004 288 1007 278 b 1077 112 1034 217 1051 163 b 1158 43 1103 62 1129 43 b 1231 69 1179 43 1204 55 b 1348 189 1280 98 1315 143 b 1444 451 1407 271 1444 357 b 1431 547 1444 482 1440 514 b 1188 750 1401 665 1299 750 b 1158 747 1178 750 1168 749 b 1079 684 1119 742 1089 727 b 1063 632 1076 665 1071 648 b 1056 609 1058 622 1056 615 b 1071 599 1056 602 1060 599 b 1086 600 1076 599 1080 600 b 1130 605 1102 603 1116 605 b 1244 569 1171 605 1210 595 b 1349 346 1322 511 1349 433 b 1348 312 1349 334 1349 324 b 1289 197 1345 266 1325 228 b 1238 174 1270 181 1253 174 b 1188 215 1220 174 1202 187 b 1145 308 1172 245 1159 276 b 1096 413 1129 343 1120 382 b 1053 438 1084 431 1068 438 b 1011 413 1038 438 1022 431 b 955 324 989 384 971 354 b 850 127 920 258 886 192 b 838 112 847 121 842 112 b 824 128 828 109 825 121 b 802 193 815 150 809 171 b 730 400 779 264 766 337 b 688 431 719 420 703 431 b 647 403 674 431 660 422 b 606 338 632 383 619 361 b 513 167 575 282 546 223 b 480 122 503 150 498 122 b 452 171 459 122 459 153 b 420 255 442 199 432 228 b 337 408 399 308 380 364 b 276 436 317 428 297 436 b 215 397 253 436 230 423 b 23 72 148 289 81 184 b 0 29 17 59 0 40 b 7 17 0 23 1 20 b 59 58 26 7 46 39 b 190 276 111 127 143 206 b 216 301 202 292 207 301 b 245 279 223 301 232 294 b 311 166 278 248 292 206 b 367 16 331 117 346 65 b 402 -19 377 -7 387 -19 b 438 -4 412 -19 423 -13 b 518 88 474 17 495 55 b 628 284 562 150 592 216 b 657 223 648 266 651 243 b 717 13 677 154 696 84 b 755 -29 726 -16 737 -29 b 791 -16 765 -29 776 -24 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefix: {
                    x_min: 0,
                    x_max: 1246,
                    y_min: -30,
                    y_max: 296,
                    ha: 326,
                    o: "m 360 -43 b 559 59 445 -43 503 7 b 698 236 615 111 652 179 b 714 248 704 243 710 248 b 727 235 719 248 721 243 l 848 42 b 883 12 860 22 870 12 b 917 32 891 12 903 19 b 946 62 927 42 939 50 b 1037 192 972 108 1009 147 b 1057 210 1044 204 1051 210 b 1076 190 1063 210 1068 203 l 1176 12 b 1215 -19 1188 -9 1201 -19 b 1250 -6 1225 -19 1237 -14 b 1284 27 1264 3 1274 16 b 1380 190 1323 78 1351 135 b 1395 210 1384 197 1385 210 b 1413 190 1405 210 1410 197 b 1508 40 1436 134 1467 85 b 1564 3 1529 14 1547 3 b 1617 32 1580 3 1597 12 b 1767 238 1678 92 1719 167 b 1794 310 1781 259 1791 282 b 1752 294 1776 317 1764 304 b 1656 164 1711 258 1689 206 b 1629 144 1646 151 1637 144 b 1603 161 1620 144 1613 150 b 1502 315 1562 207 1525 258 b 1452 357 1490 344 1470 357 b 1397 320 1431 357 1411 344 b 1316 170 1368 271 1345 219 b 1280 127 1306 154 1303 127 b 1244 171 1256 127 1254 154 b 1145 337 1210 226 1179 282 b 1110 363 1135 354 1122 363 b 1070 338 1097 363 1084 354 b 1050 311 1063 330 1057 320 b 959 181 1017 271 992 223 b 939 167 950 173 945 167 b 920 184 933 167 927 173 b 818 343 887 238 852 291 b 759 395 795 377 778 395 b 701 344 742 395 724 377 b 698 338 700 341 700 340 b 544 154 652 272 605 207 b 412 98 501 117 458 98 b 304 130 377 98 341 108 b 95 373 204 187 144 275 b 58 426 85 393 82 428 b 19 366 26 426 26 389 b 0 307 13 346 0 327 b 4 287 0 300 1 294 b 174 36 49 194 91 102 b 360 -43 230 -9 289 -43 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefixTurn: {
                    x_min: 0,
                    x_max: 1226,
                    y_min: -237,
                    y_max: 436,
                    ha: 673,
                    o: "m 1279 -341 b 1293 -252 1293 -307 1295 -278 b 1277 36 1287 -156 1282 -59 l 1273 118 b 1318 176 1289 137 1303 157 b 1349 203 1332 193 1342 203 b 1378 168 1359 203 1367 192 b 1456 35 1401 122 1428 78 b 1511 -12 1476 3 1493 -12 b 1568 23 1526 -12 1544 0 b 1597 53 1578 32 1588 42 b 1705 186 1629 101 1669 143 b 1761 284 1728 216 1751 246 b 1765 300 1763 288 1765 295 b 1763 307 1765 302 1765 305 b 1737 302 1754 311 1744 308 b 1718 287 1729 298 1725 292 b 1598 145 1673 245 1637 194 b 1578 130 1590 135 1584 130 b 1557 147 1571 130 1565 135 b 1447 321 1516 202 1488 265 b 1403 351 1433 341 1417 351 b 1358 323 1388 351 1372 341 b 1269 209 1329 285 1299 248 b 1254 521 1264 314 1259 418 b 1228 616 1253 554 1247 588 b 1218 628 1224 621 1223 628 l 1215 628 b 1201 613 1210 626 1202 619 b 1200 600 1200 609 1200 605 l 1200 586 b 1211 348 1204 507 1207 428 b 1217 166 1214 288 1215 226 b 1202 181 1212 168 1208 174 b 1094 334 1168 233 1130 284 b 1048 366 1079 356 1064 366 b 1004 331 1034 366 1018 354 b 904 154 969 275 930 220 b 873 202 887 171 880 187 b 778 356 845 256 819 311 b 737 379 763 372 750 379 b 698 353 724 379 711 370 l 621 232 b 415 114 570 154 495 114 b 302 138 377 114 340 121 b 73 400 187 192 117 284 b 55 420 69 415 62 420 b 42 410 50 420 45 416 b 0 292 23 373 0 334 b 4 262 0 282 1 272 b 168 39 32 168 92 99 b 359 -26 225 -6 292 -26 b 585 76 446 -26 530 10 b 668 202 616 115 641 160 b 693 228 680 219 687 228 b 720 203 700 228 707 219 b 801 63 752 160 775 111 b 844 7 812 42 818 7 b 910 66 877 6 894 39 b 923 94 916 75 919 85 b 995 219 945 137 968 179 b 1025 184 1009 210 1017 197 b 1119 56 1054 141 1087 98 b 1166 20 1138 32 1152 20 b 1215 50 1181 20 1195 30 b 1221 56 1217 52 1218 55 b 1228 -163 1223 -17 1225 -89 b 1279 -341 1231 -223 1251 -278 z"
                },
                ornamentPrecompTrillLowerSuffix: {
                    x_min: 0,
                    x_max: 833,
                    y_min: -309,
                    y_max: 319,
                    ha: 628,
                    o: "m 778 -444 b 801 -445 785 -444 793 -445 b 1037 -338 894 -445 969 -397 b 1200 37 1149 -240 1200 -109 b 1084 406 1200 171 1172 300 b 1024 444 1064 431 1043 444 b 960 390 999 444 978 426 b 841 163 923 314 886 236 b 812 128 832 150 827 128 b 786 167 796 130 793 153 b 660 418 744 251 716 341 b 599 459 639 445 619 459 b 541 410 577 459 557 444 b 439 197 507 340 474 269 b 422 179 435 190 435 179 b 338 393 392 251 379 328 b 275 439 320 423 298 439 b 212 396 253 439 230 425 b 71 219 170 333 128 268 b 0 45 17 173 16 112 b 68 98 32 62 50 78 b 194 264 112 150 153 209 b 230 292 209 282 219 292 b 264 261 240 292 251 282 b 274 242 268 255 269 248 b 346 46 304 179 325 112 b 376 10 351 32 354 10 b 412 35 392 10 403 22 b 452 107 429 56 441 82 b 541 291 481 168 511 230 b 556 307 547 302 552 307 b 573 295 562 307 567 302 b 624 217 595 272 611 246 b 721 1 657 145 685 72 b 755 -27 732 -19 742 -27 b 786 -16 765 -27 775 -24 b 857 73 819 7 840 39 b 952 256 887 134 920 194 b 978 289 963 279 969 289 b 1009 262 985 289 994 281 b 1030 235 1017 253 1024 245 b 1110 -4 1071 161 1099 81 b 1116 -68 1113 -26 1116 -48 b 1009 -243 1116 -140 1090 -200 b 848 -291 956 -272 901 -291 b 730 -261 809 -291 770 -282 b 696 -248 714 -252 703 -248 b 671 -284 684 -248 678 -258 l 662 -312 b 657 -357 658 -330 657 -344 b 744 -439 657 -403 683 -425 z"
                },
                brassScoop: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -390,
                    y_max: 28,
                    ha: 418,
                    o: "m 0 -562 b 393 -256 171 -504 307 -412 b 449 -39 431 -189 449 -115 b 448 -1 449 -26 449 -14 b 433 40 446 14 448 40 b 408 -3 410 40 412 14 b 396 -66 403 -23 402 -46 b 45 -397 346 -243 209 -337 b 0 -451 13 -409 1 -423 b 0 -562 -1 -485 0 -520 z"
                },
                brassDoitMedium: {
                    x_min: 0,
                    x_max: 476,
                    y_min: -50,
                    y_max: 333,
                    ha: 383,
                    o: "m 16 -72 b 27 -71 19 -72 23 -72 b 215 -33 89 -56 153 -48 b 521 114 327 -7 435 35 b 685 432 615 199 691 295 b 670 480 684 449 688 475 b 642 441 654 482 648 456 b 403 183 599 321 513 240 b 79 89 301 130 192 105 b 0 -1 -12 76 0 76 b 0 -50 0 -17 1 -33 b 16 -72 0 -65 3 -72 z"
                },
                brassFallLipShort: {
                    x_min: 0,
                    x_max: 298,
                    y_min: -344,
                    y_max: 65,
                    ha: 409,
                    o: "m 396 -495 b 420 -461 412 -487 418 -474 b 429 -382 428 -435 429 -409 b 426 -330 429 -364 428 -347 b 285 -6 410 -209 356 -104 b 98 94 239 59 173 94 b 39 86 79 94 58 92 b 0 49 20 81 0 73 l 0 -52 b 10 -69 0 -62 1 -69 b 20 -68 13 -69 16 -69 b 88 -56 45 -59 66 -56 b 261 -160 156 -56 213 -95 b 396 -495 333 -259 382 -369 z"
                },
                brassLiftMedium: {
                    x_min: 0,
                    x_max: 807,
                    y_min: 0,
                    y_max: 838,
                    ha: 838,
                    o: "m 50 0 b 55 1 52 0 53 0 b 58 23 65 7 59 16 b 55 58 56 36 55 48 b 130 117 55 99 75 112 b 220 213 202 121 220 141 b 315 308 220 289 238 308 l 336 308 b 408 380 393 310 406 321 b 461 452 409 438 416 452 b 485 451 468 452 477 451 b 569 510 531 448 556 464 b 573 543 572 520 572 531 b 657 619 580 605 595 618 b 698 621 670 619 684 619 b 788 700 749 625 778 649 b 798 778 792 726 793 752 b 873 857 806 841 809 845 b 985 950 927 867 973 887 b 1084 1047 1002 1035 1004 1034 b 1162 1128 1133 1056 1162 1087 b 1146 1182 1162 1145 1158 1164 b 1125 1207 1140 1191 1136 1207 l 1122 1207 b 1110 1191 1113 1205 1110 1198 b 1112 1174 1110 1185 1112 1178 b 1048 1110 1109 1126 1096 1113 b 1028 1109 1043 1110 1035 1109 b 939 1022 969 1102 948 1081 b 845 922 929 949 917 936 b 746 812 773 909 753 886 b 744 780 744 802 744 791 b 635 681 737 700 717 683 b 524 583 553 680 536 665 b 439 510 514 520 503 510 b 357 431 377 510 360 492 l 357 406 b 314 364 356 379 343 364 b 238 361 288 364 264 364 b 173 300 202 357 180 334 b 167 245 168 281 167 262 b 105 174 166 192 157 180 b 75 171 95 173 85 171 b 6 112 30 166 14 153 b 0 73 1 98 0 85 b 37 10 0 45 13 26 b 50 0 42 7 46 0 z"
                },
                brassFallRoughMedium: {
                    x_min: 0,
                    x_max: 791,
                    y_min: 0,
                    y_max: 819,
                    ha: 819,
                    o: "m 1117 0 b 1139 101 1129 26 1139 71 b 1138 121 1139 109 1139 115 b 1084 193 1125 171 1110 193 b 1044 183 1073 193 1060 189 b 1022 177 1035 179 1028 177 b 1007 209 1012 177 1008 186 b 876 324 1004 292 959 330 b 799 317 850 321 825 320 b 759 354 772 314 755 320 b 760 373 760 360 760 366 b 759 392 760 379 760 384 b 681 477 753 451 730 477 b 654 474 672 477 664 475 b 606 467 638 471 622 468 b 586 465 599 465 592 465 b 564 481 570 465 564 469 b 569 505 564 487 566 495 b 575 553 572 521 575 537 b 572 585 575 564 573 575 b 481 665 560 657 539 668 b 412 665 458 664 435 665 b 382 690 392 667 382 672 b 383 700 382 693 383 696 b 386 773 387 724 387 749 b 297 858 382 828 351 857 b 229 861 274 858 251 858 b 190 897 207 863 193 871 b 163 1012 186 936 180 976 b 79 1084 145 1050 124 1084 b 66 1083 75 1084 71 1083 b 43 1096 49 1081 43 1087 b 48 1112 43 1100 45 1106 b 53 1130 52 1119 53 1125 b 39 1169 53 1145 45 1158 b 26 1179 36 1175 30 1179 b 16 1171 22 1179 17 1176 b 0 1103 10 1149 0 1126 b 9 1067 0 1092 1 1079 b 91 1021 26 1031 52 1018 b 145 978 122 1024 141 1011 b 156 913 147 956 151 935 b 291 795 170 831 210 795 b 346 768 337 795 346 796 b 344 743 346 760 344 753 b 343 716 344 733 343 724 b 455 600 343 651 390 602 b 505 605 471 599 490 605 b 528 598 514 605 523 603 b 536 579 534 592 536 586 b 524 523 536 562 526 541 b 523 505 524 517 523 511 b 621 405 523 442 560 405 b 639 406 626 405 634 406 b 677 413 652 408 664 410 b 701 416 687 415 696 416 b 721 392 716 416 721 410 b 720 373 721 386 720 380 b 831 255 714 301 759 252 b 897 261 854 255 876 261 b 926 262 909 261 919 262 b 969 197 963 262 965 252 b 971 184 969 193 971 189 b 1031 115 979 137 998 115 b 1071 122 1043 115 1056 118 b 1096 130 1079 125 1086 127 b 1087 59 1094 107 1087 82 b 1117 0 1087 37 1094 17 z"
                },
                brassBend: {
                    x_min: 0,
                    x_max: 381,
                    y_min: 0,
                    y_max: 367,
                    ha: 367,
                    o: "m 298 0 b 472 50 359 0 418 14 b 537 135 501 71 530 92 b 543 216 543 163 543 190 l 543 266 b 544 308 543 281 543 295 b 549 433 546 354 549 395 b 543 507 549 459 547 482 b 533 528 541 516 544 528 b 511 508 524 528 514 520 b 508 478 510 498 508 488 b 504 318 507 425 504 372 b 505 264 504 300 505 282 b 446 181 505 220 484 199 b 294 150 396 160 344 150 b 92 194 226 150 158 167 b 45 269 62 207 45 230 b 46 359 46 300 46 328 b 37 497 46 405 45 451 b 27 523 36 507 37 523 b 4 498 14 524 6 513 b 3 481 3 492 3 487 b 0 409 1 456 0 433 b 4 228 0 348 4 288 b 3 177 4 210 4 194 b 68 53 1 125 20 84 b 200 10 108 27 154 17 b 298 0 233 4 266 0 z"
                },
                brassMuteClosed: {
                    x_min: 0,
                    x_max: 274,
                    y_min: 0,
                    y_max: 260,
                    ha: 260,
                    o: "m 203 0 b 209 1 206 0 207 0 b 216 13 215 4 216 9 l 215 27 l 215 153 b 216 161 216 156 216 158 b 372 164 268 163 318 164 b 395 184 383 164 395 166 l 395 189 b 357 229 392 209 386 229 b 219 228 311 229 265 228 l 223 310 b 209 357 225 328 219 344 b 189 374 203 364 197 374 b 184 373 187 374 186 373 b 177 359 179 372 177 366 l 177 348 l 173 222 l 39 222 b 0 206 12 222 0 219 b 10 174 0 199 3 189 b 46 157 19 157 30 157 b 108 160 68 158 88 160 b 171 161 130 161 150 161 l 167 58 b 184 16 167 40 171 26 b 203 0 192 12 196 0 z"
                },
                brassMuteOpen: {
                    x_min: 1,
                    x_max: 313,
                    y_min: 0,
                    y_max: 309,
                    ha: 309,
                    o: "m 265 0 b 451 189 363 7 452 88 l 451 215 b 348 383 441 285 405 343 b 209 445 288 426 248 445 b 84 379 168 445 132 420 b 69 364 79 373 73 369 b 1 213 30 323 1 275 b 230 0 1 88 94 0 z m 210 62 b 128 73 181 62 154 66 b 40 171 71 91 42 125 b 52 226 40 187 45 206 b 197 374 79 295 130 344 b 228 382 207 380 217 382 b 300 361 252 382 276 370 b 374 308 328 350 353 331 b 410 223 397 284 410 253 b 393 163 410 202 405 181 b 210 62 354 91 288 63 z"
                },
                brassFlip: {
                    x_min: 0,
                    x_max: 402,
                    y_min: 0,
                    y_max: 361,
                    ha: 361,
                    o: "m 579 0 b 511 153 579 68 557 117 b 52 504 359 271 206 387 b 29 520 45 510 39 520 b 20 517 26 520 23 518 b 0 477 3 510 0 494 l 0 125 b 17 20 1 92 1 56 b 40 84 37 40 40 60 b 42 287 40 151 42 219 l 42 363 z"
                },
                brassJazzTurn: {
                    x_min: 0,
                    x_max: 646,
                    y_min: 0,
                    y_max: 212,
                    ha: 212,
                    o: "m 310 0 b 367 33 327 0 344 10 b 389 55 374 40 382 49 b 490 145 423 85 456 114 b 507 154 495 151 501 154 b 524 144 513 154 517 151 b 598 72 547 120 575 98 b 700 24 625 42 662 24 b 765 43 721 24 744 30 b 893 147 812 72 855 105 b 930 212 910 166 923 186 b 912 215 923 213 917 215 b 871 199 896 215 883 209 b 812 153 852 183 832 167 b 789 144 805 148 796 144 b 773 156 782 144 776 147 b 691 251 757 199 720 222 b 603 301 658 282 631 301 b 527 258 580 301 556 288 b 420 156 494 222 455 190 b 399 143 412 147 405 143 b 377 157 392 143 386 147 b 259 282 340 200 300 242 b 219 305 245 298 232 305 b 177 279 204 305 192 297 b 55 127 137 228 95 177 b 0 52 36 104 20 79 b 14 50 6 50 10 50 b 53 66 32 50 45 58 b 115 131 75 88 98 108 b 135 148 124 143 130 148 b 157 132 141 148 148 143 b 252 33 186 96 219 65 b 310 0 275 12 292 0 z"
                },
                brassSmear: {
                    x_min: 0,
                    x_max: 334,
                    y_min: 0,
                    y_max: 151,
                    ha: 151,
                    o: "m 321 0 b 475 125 390 0 436 43 b 481 143 478 131 481 137 b 475 154 481 147 480 151 b 449 148 468 158 458 154 b 395 132 432 137 413 132 b 343 140 377 132 360 137 b 229 194 301 148 266 173 b 168 217 206 209 186 217 b 109 192 148 217 130 209 b 0 26 59 148 32 89 b 59 63 32 29 45 48 b 98 84 72 78 84 84 b 130 73 108 84 118 81 b 213 26 157 58 183 37 b 321 0 255 9 289 0 z"
                },
                stringsDownBow: {
                    x_min: 0,
                    x_max: 306,
                    y_min: 0,
                    y_max: 366,
                    ha: 366,
                    o: "m 405 0 b 425 17 413 -1 420 9 b 439 66 435 32 439 48 b 441 268 439 137 441 202 b 436 412 441 314 439 361 l 435 413 b 423 469 435 436 431 456 b 344 508 406 501 373 501 b 204 527 298 520 251 527 b 60 498 156 527 108 518 b 7 438 32 485 10 468 l 7 426 b 4 337 7 396 7 367 b 0 140 0 272 0 206 b 1 42 0 107 0 73 b 13 3 1 27 -3 4 b 40 39 29 3 35 24 b 42 53 42 43 40 49 b 49 141 48 84 49 112 b 48 215 49 167 48 192 b 49 252 48 228 48 240 l 49 312 b 130 343 72 331 99 340 b 206 347 156 346 180 347 b 372 314 262 347 318 338 l 390 307 l 390 245 b 390 138 392 212 390 176 b 397 23 390 101 392 62 b 405 0 399 14 393 1 z"
                },
                stringsUpBow: {
                    x_min: 0,
                    x_max: 219,
                    y_min: 0,
                    y_max: 489,
                    ha: 489,
                    o: "m 151 0 b 184 42 170 12 180 26 b 297 554 223 212 261 382 b 315 690 305 598 318 645 b 304 704 315 697 311 704 b 276 670 288 704 282 697 b 157 131 236 490 196 311 l 157 144 b 73 526 134 276 104 396 b 30 677 60 576 52 638 b 13 694 26 684 22 694 b 0 674 9 694 0 691 l 0 671 b 10 603 3 649 6 626 b 105 174 42 461 72 317 b 150 0 117 117 128 58 z"
                },
                stringsHarmonic: {
                    x_min: 0,
                    x_max: 191,
                    y_min: 0,
                    y_max: 202,
                    ha: 202,
                    o: "m 143 0 b 275 122 217 0 275 53 b 127 291 275 206 202 291 b 0 154 63 291 0 222 b 143 0 0 76 71 0 z m 122 68 b 43 105 89 66 59 75 b 39 124 40 111 39 117 b 79 199 39 148 56 180 b 145 226 101 216 122 226 b 199 210 163 226 180 220 b 235 150 223 196 235 173 b 203 92 235 128 225 107 b 122 68 181 76 150 68 z"
                },
                pluckedSnapPizzicatoAbove: {
                    x_min: 0,
                    x_max: 201,
                    y_min: 0,
                    y_max: 325,
                    ha: 325,
                    o: "m 171 0 b 289 99 240 0 289 45 b 258 183 289 130 274 156 b 174 269 236 217 203 240 l 174 408 b 174 429 174 415 176 422 b 131 468 168 451 153 468 b 117 451 120 468 117 461 b 118 429 117 444 118 435 b 115 307 117 389 115 347 b 0 166 59 295 0 223 b 171 0 0 85 89 0 z m 134 55 b 52 131 84 55 52 85 b 115 233 52 179 81 209 b 114 192 114 220 114 206 b 174 120 114 137 114 137 l 174 228 b 233 148 200 207 223 183 b 236 130 235 143 236 135 b 197 72 236 105 223 85 b 134 55 177 60 157 55 z"
                },
                pluckedSnapPizzicatoBelow: {
                    x_min: 0,
                    x_max: 211,
                    y_min: 0,
                    y_max: 307,
                    ha: 307,
                    o: "m 145 7 b 163 0 153 3 158 0 b 173 23 170 0 173 7 l 173 140 l 170 140 l 170 163 l 171 163 b 206 170 179 164 193 166 b 304 287 264 186 304 233 b 281 354 304 308 297 333 b 118 442 240 412 186 439 b 0 324 69 442 0 370 b 115 176 0 266 55 202 l 115 56 b 145 7 114 33 125 19 z m 115 220 b 62 256 92 223 73 230 b 53 292 56 269 53 281 b 78 344 53 311 60 328 b 168 384 105 372 135 384 b 213 376 183 384 199 382 b 253 321 239 366 253 346 b 246 291 253 311 251 301 b 170 226 230 256 203 236 l 170 258 b 148 305 171 278 163 292 b 128 315 143 310 135 315 l 124 315 b 115 301 117 314 115 308 z"
                },
                pluckedLeftHandPizzicato: {
                    x_min: 0,
                    x_max: 271,
                    y_min: 0,
                    y_max: 284,
                    ha: 284,
                    o: "m 213 0 b 223 14 222 0 223 7 b 222 35 223 22 222 29 l 222 176 b 373 170 272 174 323 170 b 390 180 382 170 390 171 l 390 184 b 347 232 386 207 382 232 b 219 238 307 233 266 235 l 219 364 b 171 409 219 395 193 409 b 156 393 160 409 156 402 b 158 370 156 384 158 376 l 158 240 b 16 239 115 240 66 239 b 0 226 7 239 0 238 l 0 223 b 50 179 1 203 29 179 b 158 177 86 179 122 179 l 158 63 b 161 29 158 52 158 40 b 213 0 166 -1 194 1 z"
                },
                keyboardPedalPed: {
                    x_min: 0,
                    x_max: 944,
                    y_min: -13,
                    y_max: 550,
                    ha: 563,
                    o: "m 22 0 b 109 78 53 0 105 46 l 144 333 b 163 376 147 347 140 372 b 364 465 238 390 301 426 b 454 599 416 497 454 540 b 452 618 454 605 454 612 b 320 770 442 694 396 747 b 248 779 295 778 272 779 b 193 778 229 779 212 779 b 160 780 181 778 167 775 b 137 792 153 789 144 791 b 109 789 128 792 118 789 b 7 719 59 789 48 737 b 23 708 16 714 20 708 b 36 710 29 710 33 710 b 53 684 52 710 53 698 l 53 674 b 43 386 53 577 53 482 b 20 164 36 312 30 238 b 1 30 14 120 7 75 b 0 19 0 26 0 22 b 22 0 0 9 4 0 z m 171 425 b 156 442 160 425 156 429 b 157 475 157 452 157 464 b 164 602 161 517 164 560 b 161 698 164 635 163 667 b 184 729 161 720 167 729 l 193 729 b 348 563 278 719 348 641 b 346 539 348 554 347 547 b 171 425 328 459 229 422 z m 979 6 b 1008 13 986 6 995 9 b 1081 101 1047 29 1079 46 b 1116 449 1087 217 1104 333 b 1143 654 1123 518 1133 586 b 1148 685 1145 664 1148 675 b 1140 704 1148 693 1146 700 b 1107 716 1130 713 1119 716 b 1056 706 1092 716 1073 710 b 1037 671 1035 703 1038 685 b 1004 439 1025 595 1014 517 b 986 419 1001 428 999 419 b 979 419 985 419 982 420 b 935 426 965 423 949 425 b 795 376 884 426 838 405 b 664 153 714 323 664 249 b 665 130 664 145 665 138 b 753 29 671 65 704 29 b 815 40 773 29 792 33 b 975 147 873 65 923 101 b 965 45 971 108 968 76 b 979 6 963 17 966 6 z m 393 -17 b 634 145 494 16 579 52 b 638 160 636 151 638 156 b 625 168 638 166 634 168 b 621 167 624 168 622 168 b 524 118 582 164 544 160 b 495 79 517 104 505 92 b 435 33 471 49 452 33 b 380 96 416 33 397 55 b 369 145 373 114 369 131 b 442 225 369 186 395 213 b 468 232 451 228 459 229 b 654 344 539 255 606 285 b 677 395 667 360 677 376 b 672 415 677 402 675 408 b 612 459 661 442 639 455 b 589 461 602 461 592 461 b 348 328 500 461 409 408 b 269 120 302 268 269 199 b 379 -19 269 45 318 -19 b 393 -17 383 -19 389 -19 z m 395 240 b 494 383 418 300 452 344 l 521 405 b 544 419 528 409 536 418 b 554 415 547 419 550 418 b 570 383 564 406 570 396 l 570 379 b 552 331 570 360 562 344 b 395 240 511 285 462 253 z m 827 89 b 792 111 815 89 804 96 b 766 204 775 131 766 158 b 845 360 772 256 799 314 b 871 372 854 369 863 372 b 897 366 880 372 888 369 b 978 279 942 353 963 320 b 976 259 981 272 981 265 b 858 104 942 203 909 147 b 827 89 847 94 837 89 z m 1282 12 b 1336 35 1303 14 1320 23 b 1359 71 1351 45 1359 58 b 1338 102 1359 82 1352 95 b 1254 130 1312 118 1284 130 b 1187 88 1223 130 1202 109 b 1178 65 1182 81 1178 72 b 1195 37 1178 55 1182 45 b 1282 12 1223 23 1253 19 z"
                },
                keyboardPedalUp: {
                    x_min: 0,
                    x_max: 437,
                    y_min: 0,
                    y_max: 461,
                    ha: 461,
                    o: "m 330 0 b 334 1 331 0 333 0 b 340 12 338 4 340 7 l 338 26 b 340 264 338 105 338 184 b 526 95 400 206 461 148 b 559 71 536 88 547 71 b 564 72 560 71 563 71 b 580 121 580 79 580 102 l 580 127 b 543 203 585 158 573 184 b 472 259 518 219 495 238 l 445 285 b 590 292 494 288 541 291 b 622 318 609 294 618 302 b 628 359 625 331 626 346 b 586 402 632 393 621 405 b 464 395 546 399 504 396 l 559 491 b 567 524 567 500 567 510 b 564 543 567 527 567 536 b 539 596 559 563 560 590 b 494 564 521 600 508 577 b 340 413 442 514 390 464 l 340 560 b 287 664 340 600 321 632 b 271 518 274 612 272 566 b 268 445 269 494 269 469 b 117 569 219 488 168 530 b 96 579 109 575 102 579 b 85 560 89 579 85 573 b 124 446 85 518 82 477 b 209 380 153 426 181 403 b 45 374 154 377 99 376 b 0 324 9 374 0 359 b 63 266 0 265 1 265 b 144 272 89 269 117 272 l 196 272 b 108 193 167 246 138 219 b 60 135 76 164 60 151 b 99 73 60 121 73 105 b 104 68 101 72 102 71 b 114 58 107 60 111 58 b 130 66 120 58 124 62 b 259 186 173 107 217 145 b 256 117 259 163 256 140 b 311 13 256 72 271 37 b 330 0 317 10 323 0 z"
                },
                pictChokeCymbal: {
                    x_min: 1,
                    x_max: 147,
                    y_min: 0,
                    y_max: 242,
                    ha: 242,
                    o: "m 79 4 b 207 158 153 32 192 88 b 212 200 210 173 212 187 b 143 336 212 253 187 298 b 98 348 131 344 115 348 b 4 295 60 348 16 327 b 1 276 1 289 1 282 b 9 249 1 266 3 258 b 121 183 35 206 72 183 b 156 186 132 183 144 183 b 26 53 134 115 91 73 b 7 39 13 49 7 45 b 19 20 7 33 12 27 b 59 0 30 9 43 0 b 79 4 65 0 72 1 z"
                },
                wiggleArpeggiatoUp: {
                    x_min: -22,
                    x_max: 300,
                    y_min: 0,
                    y_max: 176,
                    ha: 176,
                    o: "m 173 4 b 196 0 180 1 189 0 b 246 26 215 0 230 9 b 301 117 271 53 285 85 b 312 131 305 125 307 131 b 327 124 315 131 321 128 b 373 86 341 112 353 101 b 412 69 389 75 402 69 b 432 94 425 69 432 79 b 373 181 432 117 413 154 b 235 252 323 216 285 245 b 220 253 229 253 225 253 b 168 215 196 253 181 240 b 111 112 151 180 140 141 b 94 102 105 105 99 102 b 78 111 89 102 84 105 b 0 181 55 135 35 160 b -32 153 -20 194 -32 168 b 0 86 -32 124 -32 109 b 94 36 22 71 73 46 b 173 4 134 16 131 17 z"
                },
                arpeggiatoUp: {
                    x_min: 0,
                    x_max: 262,
                    y_min: 0,
                    y_max: 1459,
                    ha: 1459,
                    o: "m 190 0 b 160 63 187 29 170 45 b 145 108 150 81 145 95 b 183 163 145 128 157 145 b 300 246 222 190 262 216 b 347 318 333 272 347 295 b 301 393 347 341 331 364 b 258 413 289 403 272 408 b 145 449 220 425 183 436 b 117 464 135 452 120 452 b 140 491 115 477 128 484 b 294 593 192 526 243 557 b 330 647 318 611 330 626 b 314 693 330 660 324 675 b 262 736 302 714 285 729 b 170 763 230 744 200 753 b 122 783 153 768 125 768 b 160 831 120 804 143 818 b 288 922 202 861 246 890 b 333 999 318 945 333 972 b 266 1083 333 1032 310 1064 b 189 1115 240 1094 215 1103 b 122 1178 145 1133 122 1153 b 168 1250 122 1200 138 1223 l 180 1257 b 269 1333 210 1283 240 1306 b 305 1405 294 1356 305 1381 b 284 1469 305 1426 298 1447 b 228 1525 269 1492 251 1511 b 183 1600 197 1545 183 1571 b 190 1640 183 1613 184 1626 b 197 1670 193 1650 194 1660 b 272 1735 213 1719 230 1735 b 295 1734 279 1735 287 1735 b 323 1732 305 1732 314 1732 b 350 1731 333 1732 341 1732 b 377 1742 369 1729 377 1732 b 370 1761 377 1747 374 1754 l 301 1898 b 217 2066 274 1954 248 2012 b 186 2101 204 2089 196 2101 b 154 2069 177 2101 167 2091 b 12 1824 105 1987 59 1907 b 0 1787 4 1810 0 1797 b 59 1744 0 1761 20 1745 b 160 1738 92 1744 125 1740 b 145 1692 156 1721 151 1706 b 135 1633 138 1672 135 1652 b 184 1518 135 1591 151 1552 b 229 1475 199 1503 213 1488 b 259 1431 249 1456 259 1444 b 229 1388 259 1420 249 1407 b 151 1325 203 1365 177 1345 b 105 1279 134 1310 118 1296 b 73 1202 84 1251 73 1227 b 108 1123 73 1176 85 1152 b 255 1031 148 1077 199 1051 b 282 1014 274 1025 282 1021 b 262 991 282 1008 275 1001 b 151 914 226 963 189 939 b 79 851 125 896 99 877 b 63 809 69 837 63 824 b 79 769 63 796 68 783 b 202 697 111 729 154 710 b 266 670 225 690 266 688 b 210 622 266 648 232 635 b 82 534 167 593 120 570 b 55 491 63 518 55 505 b 79 448 55 478 63 465 b 255 361 127 395 192 380 b 288 343 269 359 288 357 b 266 312 288 331 275 320 b 144 223 229 278 184 253 b 85 134 104 193 85 166 b 118 53 85 111 96 85 b 190 0 135 29 160 14 z"
                },
                arpeggiatoDown: {
                    x_min: 0,
                    x_max: 218,
                    y_min: 0,
                    y_max: 1440,
                    ha: 1440,
                    o: "m 161 16 b 310 261 210 98 259 180 b 314 275 312 266 314 271 b 302 295 314 282 310 289 b 252 311 287 308 269 311 b 217 310 240 311 229 310 b 190 333 202 310 194 315 b 151 412 186 363 171 389 b 102 501 120 452 102 477 b 150 588 102 524 118 547 b 161 603 154 592 158 598 b 181 661 176 622 181 641 b 173 704 181 675 179 690 b 86 795 156 746 121 770 b 53 829 63 811 53 819 b 78 868 53 840 62 851 b 102 888 85 876 94 883 b 180 956 128 912 156 933 b 216 1028 204 979 216 1002 b 203 1081 216 1044 212 1061 b 115 1171 186 1123 148 1145 b 75 1221 88 1191 75 1207 b 114 1272 75 1237 88 1251 b 173 1308 132 1284 154 1296 b 226 1339 190 1318 209 1328 b 265 1405 253 1359 265 1380 b 258 1447 265 1418 264 1431 b 154 1541 242 1499 199 1521 b 109 1581 124 1555 109 1567 b 141 1627 109 1594 121 1608 b 204 1680 163 1646 184 1662 b 233 1742 223 1699 233 1719 b 226 1777 233 1752 230 1764 b 135 1862 210 1822 173 1840 b 104 1895 114 1875 104 1884 b 118 1930 104 1904 109 1914 b 192 2006 135 1961 161 1986 b 206 2029 203 2013 206 2022 b 192 2064 206 2040 197 2052 b 180 2074 187 2071 184 2074 b 156 2061 171 2074 163 2065 b 84 1983 125 2040 102 2013 b 65 1921 71 1961 65 1941 b 88 1853 65 1899 72 1876 b 171 1784 108 1820 138 1801 b 190 1764 184 1777 190 1770 b 174 1741 190 1757 184 1750 b 107 1683 153 1722 128 1704 b 68 1610 81 1659 68 1636 b 88 1548 68 1591 75 1571 b 177 1470 109 1512 141 1489 b 223 1431 209 1453 223 1443 b 179 1390 223 1420 209 1408 b 128 1361 163 1380 145 1371 b 71 1322 108 1348 88 1338 b 32 1253 45 1300 32 1277 b 48 1198 32 1236 37 1218 b 147 1090 71 1152 108 1120 b 174 1057 166 1076 174 1067 b 153 1022 174 1047 167 1037 b 109 982 140 1008 124 995 b 37 919 85 962 59 942 b 9 860 17 899 9 880 b 26 806 9 844 14 827 b 120 717 50 769 84 740 b 138 691 132 708 138 700 b 130 668 138 684 135 677 b 92 618 118 651 105 635 b 59 531 71 589 59 560 b 84 455 59 507 68 481 b 132 386 98 431 115 408 b 148 341 144 372 148 357 b 144 317 148 333 147 324 b 121 305 140 307 131 305 l 98 305 b 82 304 94 304 88 304 l 32 304 b 0 292 10 304 0 302 b 12 266 0 287 4 279 b 60 164 32 233 46 199 b 127 20 84 117 105 68 b 144 0 132 9 137 0 b 161 16 150 0 154 4 z"
                },
                repeat1Bar: {
                    x_min: 0,
                    x_max: 599,
                    y_min: -250,
                    y_max: 175,
                    ha: 425,
                    o: "m 216 98 b 255 75 236 84 246 75 b 291 104 265 75 274 85 b 323 147 304 117 327 125 b 289 215 323 168 314 184 b 238 252 269 239 253 252 b 187 222 222 252 207 242 b 173 206 183 216 177 212 b 157 170 163 194 157 183 b 174 138 157 160 161 150 b 216 98 189 127 200 109 z m 76 -334 b 181 -285 111 -315 148 -302 b 831 52 396 -168 613 -58 b 863 114 855 63 864 82 b 828 202 855 140 855 176 b 808 213 821 209 815 213 b 793 209 804 213 799 212 l 422 19 b 26 -179 291 -48 164 -124 b 0 -213 10 -186 0 -196 b 3 -232 0 -219 0 -225 b 52 -325 14 -265 37 -294 b 66 -337 55 -331 59 -337 b 76 -334 69 -337 72 -336 z m 769 -360 b 829 -264 779 -360 829 -284 b 769 -176 822 -232 799 -200 b 742 -163 760 -167 750 -163 b 716 -184 733 -163 723 -168 b 683 -228 708 -202 693 -213 b 672 -253 675 -236 672 -245 b 683 -281 672 -262 675 -271 b 752 -353 703 -308 732 -327 b 769 -360 756 -357 763 -360 z"
                },
                repeat2Bars: {
                    x_min: 0,
                    x_max: 775,
                    y_min: -247,
                    y_max: 363,
                    ha: 610,
                    o: "m 909 412 b 873 351 906 384 893 367 b 436 50 729 249 585 147 l 91 -179 b 62 -174 76 -189 68 -183 b 12 -96 48 -147 24 -125 b 36 -16 -7 -53 -6 -43 b 220 104 96 24 158 65 b 819 507 425 232 624 369 b 881 495 852 530 861 528 b 909 412 899 469 900 439 z m 333 338 b 302 240 330 307 317 274 b 276 235 297 225 287 228 l 233 269 b 203 376 186 307 183 318 b 225 441 212 397 217 419 b 246 454 228 452 232 458 b 333 338 284 441 333 380 z m 1116 228 b 1067 158 1115 192 1092 174 b 910 59 1015 125 963 92 b 478 -240 762 -33 622 -140 b 311 -350 423 -279 366 -314 b 285 -344 298 -360 289 -356 b 239 -258 272 -314 251 -288 b 261 -196 228 -228 235 -210 b 517 -29 348 -144 436 -91 b 1030 321 681 98 861 202 b 1093 307 1060 343 1076 340 b 1116 228 1107 281 1109 252 z m 1070 -105 b 1020 -210 1057 -143 1038 -176 b 998 -210 1014 -219 1004 -215 l 924 -153 b 913 -88 899 -135 897 -112 b 949 -22 926 -66 939 -45 b 998 -7 960 6 976 9 b 1070 -105 1032 -32 1058 -63 z"
                },
                repeat4Bars: {
                    x_min: 0,
                    x_max: 1374,
                    y_min: -304,
                    y_max: 304,
                    ha: 608,
                    o: "m 78 -266 b 92 -258 82 -266 88 -264 b 114 -240 98 -251 107 -246 b 638 107 289 -125 467 -14 b 873 271 716 161 793 216 b 907 337 894 285 906 305 b 887 400 901 354 897 379 b 852 438 877 426 867 438 b 814 420 842 438 829 432 b 135 -33 592 262 366 111 b 12 -121 92 -60 48 -84 b 0 -144 4 -128 0 -135 b 4 -160 0 -148 1 -154 b 63 -255 17 -196 45 -223 b 78 -266 68 -262 72 -266 z m 291 148 b 325 223 302 148 308 170 b 333 256 328 235 330 246 b 264 363 330 305 298 336 b 242 373 255 369 248 373 b 220 347 232 373 225 364 b 202 288 216 327 213 305 b 190 252 193 275 190 262 b 222 200 190 232 202 215 b 291 148 264 170 279 148 z m 815 -367 b 829 -359 819 -367 824 -364 b 851 -343 835 -353 844 -347 b 1375 6 1027 -228 1205 -117 l 1610 170 b 1644 235 1632 184 1643 203 b 1626 300 1639 253 1634 276 b 1590 337 1614 325 1604 337 b 1551 320 1580 337 1567 330 b 873 -135 1329 161 1103 10 b 749 -222 829 -161 785 -184 b 737 -245 742 -230 737 -238 b 742 -261 737 -249 739 -255 b 802 -357 755 -297 782 -325 b 815 -367 805 -363 809 -367 z m 396 -360 b 408 -356 400 -360 403 -359 b 609 -223 471 -307 543 -269 b 896 -19 706 -156 795 -81 b 1164 154 985 37 1074 96 b 1214 223 1189 170 1211 187 b 1176 321 1204 253 1205 292 b 1159 330 1169 327 1165 330 b 1145 324 1155 330 1151 328 b 1048 258 1113 302 1081 278 b 357 -202 809 117 598 -65 b 333 -238 341 -212 333 -223 b 338 -262 333 -245 334 -253 b 384 -350 350 -294 372 -318 b 396 -360 386 -354 390 -360 z m 1162 -438 b 1174 -433 1166 -438 1169 -436 b 1374 -300 1237 -384 1309 -346 b 1660 -96 1470 -233 1561 -158 b 1930 76 1751 -39 1840 19 b 1979 147 1954 92 1977 109 b 1943 243 1968 177 1971 216 b 1924 253 1935 251 1930 253 b 1911 248 1920 253 1915 252 b 1814 181 1878 225 1848 202 b 1123 -279 1575 40 1364 -141 b 1099 -315 1106 -289 1099 -300 b 1103 -338 1099 -321 1100 -330 b 1149 -426 1115 -370 1138 -396 b 1162 -438 1151 -432 1156 -438 z m 1875 -295 b 1882 -291 1878 -295 1879 -294 b 1934 -189 1904 -258 1921 -223 b 1872 -96 1925 -147 1901 -120 b 1840 -78 1858 -84 1848 -78 b 1812 -109 1830 -78 1823 -88 l 1777 -173 b 1770 -199 1773 -181 1770 -190 b 1786 -230 1770 -210 1774 -220 b 1862 -289 1809 -253 1837 -269 b 1875 -295 1865 -292 1871 -295 z"
                },
                repeatBarSlash: {
                    x_min: 0,
                    x_max: 630,
                    y_min: -225,
                    y_max: 265,
                    ha: 490,
                    o: "m 78 -324 b 92 -314 82 -325 88 -321 b 114 -298 96 -307 107 -302 b 638 49 289 -183 467 -72 b 873 215 716 104 792 161 b 907 279 894 229 906 248 b 887 344 901 298 897 321 b 852 382 877 369 867 380 b 814 363 842 383 829 376 b 135 -91 603 192 364 55 b 12 -177 92 -118 45 -137 b 0 -202 4 -186 0 -192 b 4 -217 0 -206 1 -212 b 63 -312 17 -253 42 -284 b 78 -324 68 -318 72 -323 z"
                },
                csymDiminished: {
                    x_min: 0,
                    x_max: 506,
                    y_min: 0,
                    y_max: 500,
                    ha: 500,
                    o: "m 397 0 b 729 265 576 -1 729 95 b 711 367 729 297 723 331 b 472 670 668 498 586 595 b 315 720 423 701 372 720 b 253 713 295 720 275 719 b 32 514 144 687 75 615 b 0 374 12 468 0 420 b 27 251 0 333 9 292 b 140 117 52 196 92 153 b 397 0 223 52 317 4 z m 340 95 b 132 314 233 84 122 216 b 324 589 145 438 200 539 b 415 611 360 603 389 611 b 544 505 469 611 505 576 b 590 392 564 471 583 432 b 596 343 593 374 596 359 b 340 95 596 210 485 96 z"
                },
                csymHalfDiminished: {
                    x_min: -32,
                    x_max: 496,
                    y_min: -33,
                    y_max: 492,
                    ha: 525,
                    o: "m -29 -48 b 0 -36 -19 -48 -9 -40 b 17 -20 7 -32 12 -24 b 134 94 56 19 95 56 b 372 0 207 43 282 0 b 455 13 397 0 426 4 b 677 258 556 45 671 141 b 678 289 677 268 678 278 b 593 539 678 380 654 467 b 592 541 593 540 592 540 l 684 632 b 713 678 700 647 711 665 b 714 691 714 684 714 688 b 707 704 714 698 711 701 b 691 708 701 707 696 708 b 660 691 680 708 670 701 l 552 585 b 478 634 530 606 507 624 b 361 684 438 648 397 661 b 301 703 341 697 320 703 b 226 677 275 703 251 693 b 27 449 140 618 72 543 b 0 324 9 410 -4 370 b 88 128 -1 243 30 177 b -30 -7 43 86 0 46 b -46 -33 -35 -16 -46 -24 b -42 -42 -46 -36 -45 -39 b -29 -48 -37 -46 -33 -48 z m 141 179 b 121 251 128 200 121 225 b 128 297 121 265 124 281 b 351 575 163 420 248 505 b 377 582 359 579 369 580 b 501 536 422 586 468 567 b 141 179 382 416 261 298 z m 281 105 b 179 137 240 105 206 117 b 210 168 189 147 200 157 l 537 487 b 547 455 541 477 544 467 b 556 370 552 426 556 397 b 429 154 556 274 503 207 b 281 105 384 122 336 105 z"
                },
                csymAugmented: {
                    x_min: 0,
                    x_max: 530,
                    y_min: 0,
                    y_max: 539,
                    ha: 539,
                    o: "m 380 0 b 393 14 384 4 390 9 b 397 46 397 24 397 36 l 397 333 b 736 327 511 331 624 330 b 763 343 755 327 763 333 b 755 361 763 348 760 354 b 635 431 726 402 688 431 l 390 431 l 390 485 b 386 606 392 526 386 566 b 392 664 386 625 387 645 b 395 690 393 672 395 681 b 376 753 395 711 389 734 b 357 776 372 762 369 776 b 350 775 354 776 353 776 b 327 740 337 769 327 759 b 327 621 328 700 327 661 b 330 438 328 559 328 498 l 29 438 b 4 431 20 438 7 442 b 0 413 3 425 0 419 b 7 399 0 408 1 403 b 131 338 45 369 85 340 b 331 334 199 336 265 334 b 333 163 333 276 333 220 b 366 13 333 109 348 63 b 380 0 367 7 374 4 z"
                },
                csymMajorSeventh: {
                    x_min: 0,
                    x_max: 593,
                    y_min: 0,
                    y_max: 569,
                    ha: 569,
                    o: "m 124 1 l 497 27 b 819 50 605 35 711 43 b 854 98 847 52 855 63 b 812 200 845 128 835 166 b 564 585 730 328 648 456 b 435 786 521 652 480 720 b 397 819 419 809 408 819 b 369 792 387 819 379 811 b 7 173 248 585 128 379 b 0 150 3 166 0 158 b 7 128 0 143 3 135 b 89 10 30 86 65 50 b 109 0 95 1 102 0 z m 163 147 b 153 153 158 147 156 148 b 164 179 147 163 158 170 b 426 644 251 334 338 488 b 442 660 432 655 436 660 b 458 645 446 660 452 655 b 727 220 547 503 636 361 b 736 202 732 213 736 206 b 714 190 736 196 730 192 b 179 148 537 177 359 163 b 163 147 174 150 168 147 z"
                },
                csymMinor: {
                    x_min: 0,
                    x_max: 482,
                    y_min: 193,
                    y_max: 265,
                    ha: 72,
                    o: "m 168 278 b 197 279 177 278 187 278 b 431 292 275 287 353 288 l 431 291 b 661 302 508 295 585 300 b 693 311 672 304 688 300 b 674 346 697 324 685 338 b 564 382 641 366 606 384 l 27 360 b 0 347 17 360 1 366 b 19 314 0 333 3 321 b 168 278 66 291 115 278 z"
                },
                csymParensLeftTall: {
                    x_min: 0,
                    x_max: 185,
                    y_min: 0,
                    y_max: 1034,
                    ha: 1034,
                    o: "m 215 0 b 226 17 223 1 223 10 b 229 37 229 24 229 32 b 220 81 229 52 225 66 b 167 203 206 124 181 160 b 86 616 124 338 89 474 b 82 765 85 665 82 716 b 91 886 82 805 84 845 b 245 1319 120 1038 171 1184 b 266 1397 259 1346 266 1371 b 259 1443 266 1411 264 1427 b 226 1489 253 1463 248 1489 b 193 1454 212 1489 203 1467 b 114 1292 158 1404 140 1346 b 0 806 40 1138 0 978 b 3 721 0 779 0 750 b 1 677 1 707 1 693 b 36 418 1 593 16 504 b 144 96 62 307 95 199 b 196 12 158 66 179 39 b 212 0 200 7 204 0 z"
                },
                csymParensRightTall: {
                    x_min: -40,
                    x_max: 189,
                    y_min: 0,
                    y_max: 1058,
                    ha: 1058,
                    o: "m 30 1 b 63 14 42 -3 55 6 b 122 99 86 40 108 68 b 189 258 145 153 166 204 b 271 667 239 379 268 503 b 246 852 275 708 261 780 b 10 1495 197 1077 128 1295 b -14 1524 4 1505 1 1524 b -16 1522 -14 1524 -16 1524 b -46 1489 -33 1521 -43 1503 b -58 1417 -53 1464 -58 1440 b -36 1335 -58 1390 -52 1364 b 68 1138 0 1270 35 1204 b 163 883 108 1056 137 969 b 206 668 184 814 200 742 b 207 631 207 655 207 642 b 166 426 207 560 192 492 b 46 143 130 330 111 228 b 19 29 19 109 17 69 b 30 1 20 19 24 3 z"
                },
                csymBracketLeftTall: {
                    x_min: 0,
                    x_max: 328,
                    y_min: 2,
                    y_max: 807,
                    ha: 805,
                    o: "m 68 3 b 76 4 71 3 73 3 b 186 13 112 12 150 13 b 240 13 204 13 222 13 l 287 13 b 379 17 317 13 348 13 b 472 121 435 24 472 69 b 467 156 472 132 469 144 b 446 174 462 168 456 174 l 439 174 b 327 166 402 167 364 166 b 265 167 307 166 285 167 l 209 167 b 187 475 199 269 189 372 b 166 985 186 645 187 815 l 377 1002 b 415 1001 389 1002 402 1001 b 456 1027 432 1001 448 1005 b 472 1096 467 1048 472 1073 b 464 1146 472 1113 469 1130 b 439 1162 459 1161 452 1162 b 40 1129 305 1151 173 1139 b 1 1093 17 1128 1 1120 b 0 1009 0 1064 0 1037 b 13 975 0 991 3 981 b 30 670 23 873 30 772 b 29 608 30 649 29 628 l 29 563 b 56 88 29 405 49 246 b 53 22 55 66 55 43 b 68 3 53 12 56 3 z"
                },
                csymBracketRightTall: {
                    x_min: 1,
                    x_max: 306,
                    y_min: 0,
                    y_max: 829,
                    ha: 829,
                    o: "m 117 0 b 372 29 203 -3 287 20 l 373 29 b 406 32 383 30 395 30 b 436 60 428 33 432 43 b 441 109 439 76 441 92 b 433 200 441 140 436 170 b 409 696 422 366 409 530 b 416 887 409 763 416 831 b 415 920 416 899 415 910 l 415 1106 b 412 1135 415 1116 415 1126 l 412 1145 b 373 1189 413 1171 408 1192 b 321 1189 356 1189 338 1189 l 215 1189 l 215 1194 l 56 1194 b 6 1153 27 1195 10 1187 b 1 1064 3 1123 4 1093 b 22 1043 0 1050 6 1043 b 84 1044 42 1044 63 1044 b 264 1038 144 1044 203 1040 b 265 958 264 1011 265 985 b 262 845 265 920 264 883 b 259 710 259 801 259 755 b 279 243 259 554 271 399 b 285 170 281 219 284 194 b 95 151 222 161 158 156 b 29 81 27 147 27 147 l 29 73 b 105 0 33 0 33 0 z"
                },
                csymParensLeftVeryTall: {
                    x_min: 0,
                    x_max: 116,
                    y_min: 0,
                    y_max: 934,
                    ha: 934,
                    o: "m 128 0 b 147 17 137 0 144 9 b 167 102 160 45 167 73 b 158 154 167 120 164 137 b 117 307 141 204 130 256 b 63 698 84 435 71 567 b 62 788 62 729 62 757 b 69 916 62 829 63 873 b 109 1172 81 1001 94 1087 b 132 1320 118 1221 137 1269 b 124 1345 131 1329 134 1342 b 96 1332 114 1346 102 1341 b 71 1269 82 1313 75 1292 b 39 1104 59 1214 48 1159 b 0 742 19 988 0 871 b 10 559 3 688 6 624 b 58 226 16 446 33 336 b 112 20 73 157 94 89 b 128 0 115 13 118 0 z"
                },
                csymParensRightVeryTall: {
                    x_min: -20,
                    x_max: 111,
                    y_min: 0,
                    y_max: 1009,
                    ha: 1009,
                    o: "m -3 0 b 20 22 9 -1 14 12 b 36 56 26 33 32 45 b 99 274 58 128 84 199 b 160 788 135 439 163 605 b 122 1181 164 912 145 1047 b 50 1431 108 1267 86 1351 b 36 1453 48 1439 46 1453 l 35 1453 l 30 1453 b 7 1423 17 1449 7 1440 b 27 1287 9 1377 10 1331 b 96 963 71 1184 85 1074 b 105 818 102 914 105 867 b 91 624 105 753 99 688 b -4 213 72 484 48 344 b -29 101 -19 174 -29 138 b -16 27 -29 76 -24 52 b -3 0 -13 17 -14 3 z"
                },
                csymDiagonalArrangementSlash: {
                    x_min: 0,
                    x_max: 990,
                    y_min: -27,
                    y_max: 1028,
                    ha: 1054,
                    o: "m 14 -37 b 58 -9 35 -45 46 -22 b 392 333 170 105 279 217 l 765 711 b 1372 1329 968 916 1168 1125 b 1424 1439 1403 1359 1417 1397 b 1426 1457 1424 1444 1426 1450 b 1416 1477 1426 1466 1423 1475 b 1374 1462 1400 1485 1385 1473 b 1181 1269 1309 1397 1246 1331 b 736 831 1031 1122 884 979 b 356 452 609 704 485 576 b 32 132 246 347 143 236 b 0 50 7 109 1 84 b 6 9 -1 37 3 23 b 14 -37 10 -9 0 -32 z"
                },
                accidentalNarrowReversedFlat: {
                    x_min: 0,
                    x_max: 208,
                    y_min: -231,
                    y_max: 449,
                    ha: 680,
                    o: "m 272 -333 b 284 -320 278 -333 281 -328 b 300 -174 297 -272 300 -222 b 275 190 298 -52 279 68 b 268 445 272 275 268 360 l 268 490 b 264 612 269 530 265 572 b 236 647 264 632 252 645 l 235 647 b 217 618 220 647 220 628 b 207 526 210 588 207 556 b 210 432 207 494 210 464 b 216 268 213 377 215 323 l 216 230 l 215 232 b 154 256 194 240 174 251 b 111 264 138 261 124 264 b 3 153 50 264 10 223 b 0 94 0 132 0 114 b 194 -276 0 -63 68 -186 b 255 -323 215 -291 236 -307 b 272 -333 262 -330 268 -333 z m 233 -138 b 71 30 168 -92 105 -45 b 63 59 65 42 63 50 b 96 95 62 75 73 86 b 130 102 108 99 120 102 b 215 76 160 102 187 88 l 220 73 b 225 -22 220 42 222 10 b 233 -138 229 -62 230 -101 z"
                },
                accidentalNarrowReversedFlatAndFlat: {
                    x_min: 0,
                    x_max: 335,
                    y_min: -231,
                    y_max: 449,
                    ha: 680,
                    o: "m 151 490 b 148 612 151 530 150 572 b 132 647 148 632 141 645 b 122 618 124 647 124 628 b 117 526 118 588 117 556 b 118 432 117 494 118 464 b 121 268 120 377 121 323 l 121 232 b 86 256 109 240 98 251 b 62 264 78 261 69 264 b 1 153 29 264 6 223 b 0 94 0 132 0 114 b 109 -276 0 -63 37 -186 b 144 -323 121 -291 132 -307 b 153 -333 147 -330 151 -333 b 160 -320 157 -333 158 -328 b 168 -174 167 -272 168 -222 b 154 190 168 -52 157 68 b 151 445 153 275 151 360 z m 480 153 b 372 264 472 223 432 264 b 328 256 359 264 344 261 b 268 232 308 251 288 240 l 266 230 l 266 268 b 272 432 266 323 269 377 b 275 526 272 464 275 494 b 265 618 275 556 272 588 b 248 647 262 628 262 647 l 246 647 b 219 612 230 645 219 632 b 215 490 217 572 213 530 l 215 445 b 207 190 215 360 210 275 b 183 -174 203 68 183 -52 b 199 -320 183 -222 186 -272 b 210 -333 202 -328 204 -333 b 228 -323 215 -333 220 -330 b 288 -276 246 -307 268 -291 b 482 94 415 -186 482 -63 b 480 153 482 114 482 132 z m 40 30 b 36 59 36 42 36 50 b 55 95 35 75 42 86 b 73 102 60 99 68 102 b 121 76 89 102 105 88 l 124 73 b 127 -22 124 42 125 10 l 131 -138 b 40 30 95 -92 60 -43 z m 419 59 b 412 30 419 50 418 42 b 249 -138 374 -43 314 -92 b 258 -22 252 -101 253 -62 b 262 73 261 10 262 42 l 268 76 b 353 102 295 88 323 102 b 386 95 363 102 374 99 b 419 59 409 86 420 75 z"
                },
                accidentalWilsonPlus: {
                    x_min: 0,
                    x_max: 298,
                    y_min: -218,
                    y_max: 218,
                    ha: 436,
                    o: "m 232 -314 b 236 -301 236 -310 236 -305 l 236 -295 b 243 -52 239 -213 242 -132 l 369 62 b 429 200 413 101 425 147 b 416 243 429 216 428 236 b 383 225 406 251 393 232 l 377 220 b 246 98 336 177 291 138 b 249 242 248 145 246 193 b 225 304 251 265 242 287 b 209 314 220 308 215 314 b 204 312 207 314 206 312 b 196 292 196 310 196 300 b 193 184 194 256 194 220 b 187 48 192 140 190 94 b 46 -72 141 7 94 -32 b 0 -163 13 -98 0 -127 b 1 -187 0 -170 0 -179 b 10 -235 4 -203 6 -219 b 20 -255 12 -242 14 -251 b 36 -245 26 -259 30 -249 b 181 -109 85 -200 132 -154 b 176 -258 180 -158 176 -209 b 232 -314 176 -298 186 -307 z"
                },
                accidentalWilsonMinus: {
                    x_min: 0,
                    x_max: 284,
                    y_min: -163,
                    y_max: 163,
                    ha: 326,
                    o: "m 386 -232 b 409 -163 415 -222 408 -180 b 382 -69 410 -120 408 -89 b 32 228 264 30 141 118 b 17 235 26 233 22 235 b 3 219 9 235 3 228 b 0 157 3 199 0 179 b 29 69 0 125 6 95 b 323 -194 115 -29 222 -111 b 374 -235 338 -206 353 -235 b 386 -232 377 -235 382 -233 z"
                }
            },
            fontFamily: "Petaluma",
            resolution: 1e3,
            generatedOn: "2022-12-18T09:07:50.817Z"
        }, Li = {
            csymDiminished: {
                leftSideBearing: -95,
                advanceWidth: 506,
                yOffset: 0
            },
            csymHalfDiminished: {
                leftSideBearing: -32,
                advanceWidth: 506,
                yOffset: 0
            },
            csymAugmented: {
                leftSideBearing: -25,
                advanceWidth: 530,
                yOffset: 0
            },
            csymParensLeftTall: {
                leftSideBearing: 0,
                advanceWidth: 155,
                yOffset: 150
            },
            csymParensRightTall: {
                leftSideBearing: 40,
                advanceWidth: 189,
                yOffset: 150
            },
            csymBracketLeftTall: {
                leftSideBearing: 0,
                advanceWidth: 328,
                yOffset: 0
            },
            csymBracketRightTall: {
                leftSideBearing: 1,
                advanceWidth: 600,
                yOffset: 0
            },
            csymParensLeftVeryTall: {
                leftSideBearing: 0,
                advanceWidth: 210,
                yOffset: 250
            },
            csymParensRightVeryTall: {
                leftSideBearing: -100,
                advanceWidth: 111,
                yOffset: 250
            },
            csymDiagonalArrangementSlash: {
                leftSideBearing: -1,
                advanceWidth: 990,
                yOffset: 0
            },
            csymMinor: {
                leftSideBearing: 0,
                advanceWidth: 482,
                yOffset: 0
            },
            csymMajorSeventh: {
                leftSideBearing: 100,
                yOffset: 0,
                advanceWidth: 600
            },
            accidentalSharp: {
                leftSideBearing: 0,
                advanceWidth: 425,
                yOffset: -422
            },
            accidentalFlat: {
                leftSideBearing: -10,
                advanceWidth: 228,
                yOffset: -284
            }
        };
        const Wi = {
            spacing: 50,
            glyphs: {
                " ": {
                    x_min: 0,
                    x_max: 250,
                    y_min: 0,
                    y_max: 500,
                    ha: 500,
                    leftSideBearing: 0,
                    advanceWidth: 250
                },
                0: {
                    x_min: 33,
                    x_max: 534,
                    y_min: -13,
                    y_max: 751,
                    ha: 764,
                    leftSideBearing: 33,
                    advanceWidth: 570
                },
                1: {
                    x_min: 48,
                    x_max: 235,
                    y_min: -17,
                    y_max: 734,
                    ha: 751,
                    leftSideBearing: 48,
                    advanceWidth: 286
                },
                2: {
                    x_min: 56,
                    x_max: 571,
                    y_min: -19,
                    y_max: 741,
                    ha: 760,
                    leftSideBearing: 56,
                    advanceWidth: 626
                },
                3: {
                    x_min: 50,
                    x_max: 528,
                    y_min: -7,
                    y_max: 731,
                    ha: 738,
                    leftSideBearing: 50,
                    advanceWidth: 589
                },
                4: {
                    x_min: 38,
                    x_max: 564,
                    y_min: -13,
                    y_max: 743,
                    ha: 756,
                    leftSideBearing: 38,
                    advanceWidth: 614
                },
                5: {
                    x_min: 42,
                    x_max: 601,
                    y_min: -34,
                    y_max: 743,
                    ha: 777,
                    leftSideBearing: 42,
                    advanceWidth: 648
                },
                6: {
                    x_min: 47,
                    x_max: 606,
                    y_min: -16,
                    y_max: 743,
                    ha: 759,
                    leftSideBearing: 47,
                    advanceWidth: 667
                },
                7: {
                    x_min: 47,
                    x_max: 567,
                    y_min: 5,
                    y_max: 739,
                    ha: 734,
                    leftSideBearing: 0,
                    advanceWidth: 615
                },
                8: {
                    x_min: 40,
                    x_max: 541,
                    y_min: -15,
                    y_max: 752,
                    ha: 767,
                    leftSideBearing: 40,
                    advanceWidth: 585
                },
                9: {
                    x_min: 40,
                    x_max: 537,
                    y_min: -52,
                    y_max: 736,
                    ha: 788,
                    leftSideBearing: 40,
                    advanceWidth: 592
                },
                "!": {
                    x_min: 49,
                    x_max: 180,
                    y_min: -7,
                    y_max: 761,
                    ha: 768,
                    leftSideBearing: 49,
                    advanceWidth: 230
                },
                '"': {
                    x_min: 39,
                    x_max: 304,
                    y_min: 596,
                    y_max: 804,
                    ha: 208,
                    leftSideBearing: 39,
                    advanceWidth: 353
                },
                "#": {
                    x_min: 33,
                    x_max: 599,
                    y_min: -8,
                    y_max: 765,
                    ha: 773,
                    leftSideBearing: 33,
                    advanceWidth: 648
                },
                $: {
                    x_min: 53,
                    x_max: 495,
                    y_min: -111,
                    y_max: 823,
                    ha: 934,
                    leftSideBearing: 53,
                    advanceWidth: 560
                },
                "%": {
                    x_min: 35,
                    x_max: 656,
                    y_min: -128,
                    y_max: 808,
                    ha: 936,
                    leftSideBearing: 35,
                    advanceWidth: 711
                },
                "&": {
                    x_min: 53,
                    x_max: 441,
                    y_min: -3,
                    y_max: 753,
                    ha: 756,
                    leftSideBearing: 53,
                    advanceWidth: 500
                },
                "'": {
                    x_min: 43,
                    x_max: 161,
                    y_min: 590,
                    y_max: 811,
                    ha: 221,
                    leftSideBearing: 43,
                    advanceWidth: 217
                },
                "(": {
                    x_min: 41,
                    x_max: 311,
                    y_min: -36,
                    y_max: 845,
                    ha: 881,
                    leftSideBearing: 41,
                    advanceWidth: 308
                },
                ")": {
                    x_min: -8,
                    x_max: 257,
                    y_min: -21,
                    y_max: 852,
                    ha: 873,
                    leftSideBearing: -8,
                    advanceWidth: 280
                },
                "*": {
                    x_min: 59,
                    x_max: 539,
                    y_min: 175,
                    y_max: 589,
                    ha: 414,
                    leftSideBearing: 59,
                    advanceWidth: 601
                },
                "+": {
                    x_min: 33,
                    x_max: 361,
                    y_min: 180,
                    y_max: 587,
                    ha: 407,
                    leftSideBearing: 33,
                    advanceWidth: 400
                },
                ",": {
                    x_min: 15,
                    x_max: 176,
                    y_min: -129,
                    y_max: 92,
                    ha: 221,
                    leftSideBearing: 15,
                    advanceWidth: 205
                },
                "-": {
                    x_min: 40,
                    x_max: 380,
                    y_min: 317,
                    y_max: 452,
                    ha: 135,
                    leftSideBearing: 40,
                    advanceWidth: 422
                },
                ".": {
                    x_min: 48,
                    x_max: 185,
                    y_min: -56,
                    y_max: 84,
                    ha: 140,
                    leftSideBearing: 48,
                    advanceWidth: 227
                },
                "/": {
                    x_min: -58,
                    x_max: 654,
                    y_min: -122,
                    y_max: 844,
                    ha: 966,
                    leftSideBearing: -58,
                    advanceWidth: 626
                },
                ":": {
                    x_min: 65,
                    x_max: 225,
                    y_min: 97,
                    y_max: 536,
                    ha: 439,
                    leftSideBearing: 65,
                    advanceWidth: 302
                },
                ";": {
                    x_min: 13,
                    x_max: 295,
                    y_min: -139,
                    y_max: 536,
                    ha: 675,
                    leftSideBearing: 13,
                    advanceWidth: 334
                },
                "<": {
                    x_min: 28,
                    x_max: 438,
                    y_min: -1,
                    y_max: 607,
                    ha: 608,
                    leftSideBearing: 28,
                    advanceWidth: 475
                },
                "=": {
                    x_min: 40,
                    x_max: 383,
                    y_min: 199.9598640852289,
                    y_max: 541,
                    ha: 341.0401359147711,
                    leftSideBearing: 40,
                    advanceWidth: 422
                },
                ">": {
                    x_min: 35,
                    x_max: 421,
                    y_min: 28,
                    y_max: 632,
                    ha: 604,
                    leftSideBearing: 35,
                    advanceWidth: 466
                },
                "?": {
                    x_min: 45,
                    x_max: 548,
                    y_min: -17,
                    y_max: 767,
                    ha: 784,
                    leftSideBearing: 45,
                    advanceWidth: 592
                },
                "@": {
                    x_min: 51,
                    x_max: 730,
                    y_min: -78,
                    y_max: 753,
                    ha: 831,
                    leftSideBearing: 51,
                    advanceWidth: 781
                },
                A: {
                    x_min: 37,
                    x_max: 554,
                    y_min: -4,
                    y_max: 746,
                    ha: 750,
                    leftSideBearing: 37,
                    advanceWidth: 617
                },
                B: {
                    x_min: 37,
                    x_max: 532,
                    y_min: 3,
                    y_max: 783,
                    ha: 780,
                    leftSideBearing: 37,
                    advanceWidth: 579
                },
                C: {
                    x_min: 37,
                    x_max: 583,
                    y_min: -3,
                    y_max: 775,
                    ha: 778,
                    leftSideBearing: 37,
                    advanceWidth: 623
                },
                D: {
                    x_min: 50,
                    x_max: 530,
                    y_min: -15,
                    y_max: 749,
                    ha: 764,
                    leftSideBearing: 50,
                    advanceWidth: 579
                },
                E: {
                    x_min: 45,
                    x_max: 531,
                    y_min: -1,
                    y_max: 743,
                    ha: 744,
                    leftSideBearing: 45,
                    advanceWidth: 585
                },
                F: {
                    x_min: 45,
                    x_max: 459,
                    y_min: 23,
                    y_max: 727,
                    ha: 704,
                    leftSideBearing: 45,
                    advanceWidth: 510
                },
                G: {
                    x_min: 31,
                    x_max: 577,
                    y_min: -8,
                    y_max: 733,
                    ha: 741,
                    leftSideBearing: 31,
                    advanceWidth: 611
                },
                H: {
                    x_min: 37,
                    x_max: 493,
                    y_min: -22,
                    y_max: 758,
                    ha: 780,
                    leftSideBearing: 37,
                    advanceWidth: 535
                },
                I: {
                    x_min: 47,
                    x_max: 501,
                    y_min: -3,
                    y_max: 731,
                    ha: 734,
                    leftSideBearing: 47,
                    advanceWidth: 541
                },
                J: {
                    x_min: 33,
                    x_max: 531,
                    y_min: -23,
                    y_max: 725,
                    ha: 748,
                    leftSideBearing: 33,
                    advanceWidth: 573
                },
                K: {
                    x_min: 43,
                    x_max: 505,
                    y_min: -10,
                    y_max: 740,
                    ha: 750,
                    leftSideBearing: 43,
                    advanceWidth: 560
                },
                L: {
                    x_min: 49,
                    x_max: 457,
                    y_min: -2,
                    y_max: 746,
                    ha: 748,
                    leftSideBearing: 49,
                    advanceWidth: 510
                },
                M: {
                    x_min: 35,
                    x_max: 699,
                    y_min: 1,
                    y_max: 744,
                    ha: 743,
                    leftSideBearing: 35,
                    advanceWidth: 743
                },
                N: {
                    x_min: 34,
                    x_max: 533,
                    y_min: -17,
                    y_max: 761,
                    ha: 778,
                    leftSideBearing: 34,
                    advanceWidth: 579
                },
                O: {
                    x_min: 41,
                    x_max: 608,
                    y_min: -5,
                    y_max: 735,
                    ha: 740,
                    leftSideBearing: 41,
                    advanceWidth: 667
                },
                P: {
                    x_min: 53,
                    x_max: 451,
                    y_min: -18,
                    y_max: 735,
                    ha: 753,
                    leftSideBearing: 53,
                    advanceWidth: 497
                },
                Q: {
                    x_min: 40,
                    x_max: 599,
                    y_min: -67,
                    y_max: 744,
                    ha: 811,
                    leftSideBearing: 40,
                    advanceWidth: 648
                },
                R: {
                    x_min: 39,
                    x_max: 487,
                    y_min: 16,
                    y_max: 735,
                    ha: 719,
                    leftSideBearing: 39,
                    advanceWidth: 535
                },
                S: {
                    x_min: 35,
                    x_max: 552,
                    y_min: -47,
                    y_max: 708,
                    ha: 755,
                    leftSideBearing: 35,
                    advanceWidth: 604
                },
                T: {
                    x_min: 26,
                    x_max: 656,
                    y_min: -13,
                    y_max: 718,
                    ha: 731,
                    leftSideBearing: 26,
                    advanceWidth: 705
                },
                U: {
                    x_min: 41,
                    x_max: 518,
                    y_min: -20,
                    y_max: 748,
                    ha: 768,
                    leftSideBearing: 41,
                    advanceWidth: 567
                },
                V: {
                    x_min: 47,
                    x_max: 509,
                    y_min: -26,
                    y_max: 744,
                    ha: 770,
                    leftSideBearing: 47,
                    advanceWidth: 567
                },
                W: {
                    x_min: 44,
                    x_max: 789,
                    y_min: -35,
                    y_max: 720,
                    ha: 755,
                    leftSideBearing: 44,
                    advanceWidth: 833
                },
                X: {
                    x_min: 63,
                    x_max: 635,
                    y_min: -10,
                    y_max: 745,
                    ha: 755,
                    leftSideBearing: 63,
                    advanceWidth: 680
                },
                Y: {
                    x_min: 43,
                    x_max: 503,
                    y_min: -21,
                    y_max: 734,
                    ha: 755,
                    leftSideBearing: 43,
                    advanceWidth: 541
                },
                Z: {
                    x_min: 42,
                    x_max: 584,
                    y_min: -10,
                    y_max: 739,
                    ha: 749,
                    leftSideBearing: 42,
                    advanceWidth: 629
                },
                "[": {
                    x_min: 46,
                    x_max: 346,
                    y_min: -150,
                    y_max: 884,
                    ha: 1034,
                    leftSideBearing: 46,
                    advanceWidth: 291
                },
                "\\": {
                    x_min: 20,
                    x_max: 616,
                    y_min: -100,
                    y_max: 797,
                    ha: 897,
                    leftSideBearing: 20,
                    advanceWidth: 645
                },
                "]": {
                    x_min: -76,
                    x_max: 226,
                    y_min: -150,
                    y_max: 881,
                    ha: 1031,
                    leftSideBearing: -76,
                    advanceWidth: 297
                },
                "^": {
                    x_min: 43,
                    x_max: 437,
                    y_min: 517,
                    y_max: 812,
                    ha: 295,
                    leftSideBearing: 43,
                    advanceWidth: 478
                },
                _: {
                    x_min: 29,
                    x_max: 563,
                    y_min: -110,
                    y_max: -1,
                    ha: 109,
                    leftSideBearing: 29,
                    advanceWidth: 598
                },
                "`": {
                    x_min: 54,
                    x_max: 321,
                    y_min: 540,
                    y_max: 747,
                    ha: 207,
                    leftSideBearing: 54,
                    advanceWidth: 368
                },
                a: {
                    x_min: 20,
                    x_max: 447,
                    y_min: -17,
                    y_max: 495,
                    ha: 512,
                    leftSideBearing: 20,
                    advanceWidth: 494
                },
                b: {
                    x_min: 37,
                    x_max: 466,
                    y_min: -27,
                    y_max: 770,
                    ha: 797,
                    leftSideBearing: 37,
                    advanceWidth: 510
                },
                c: {
                    x_min: 35,
                    x_max: 456,
                    y_min: -9,
                    y_max: 507,
                    ha: 516,
                    leftSideBearing: 35,
                    advanceWidth: 460
                },
                d: {
                    x_min: 45,
                    x_max: 520,
                    y_min: -15,
                    y_max: 764,
                    ha: 779,
                    leftSideBearing: 45,
                    advanceWidth: 560
                },
                e: {
                    x_min: 33,
                    x_max: 370,
                    y_min: -5,
                    y_max: 501,
                    ha: 506,
                    leftSideBearing: 33,
                    advanceWidth: 397
                },
                f: {
                    x_min: 35,
                    x_max: 411,
                    y_min: -13,
                    y_max: 695,
                    ha: 708,
                    leftSideBearing: 35,
                    advanceWidth: 453
                },
                g: {
                    x_min: 33,
                    x_max: 551,
                    y_min: -257,
                    y_max: 505,
                    ha: 762,
                    leftSideBearing: 33,
                    advanceWidth: 611
                },
                h: {
                    x_min: 32,
                    x_max: 458,
                    y_min: -29,
                    y_max: 743,
                    ha: 772,
                    leftSideBearing: 32,
                    advanceWidth: 491
                },
                i: {
                    x_min: 45,
                    x_max: 167,
                    y_min: -13,
                    y_max: 631,
                    ha: 644,
                    leftSideBearing: 45,
                    advanceWidth: 220
                },
                j: {
                    x_min: -127,
                    x_max: 261,
                    y_min: -231,
                    y_max: 601,
                    ha: 832,
                    leftSideBearing: -127,
                    advanceWidth: 308
                },
                k: {
                    x_min: 39,
                    x_max: 443,
                    y_min: -3,
                    y_max: 700,
                    ha: 703,
                    leftSideBearing: 39,
                    advanceWidth: 497
                },
                l: {
                    x_min: 58,
                    x_max: 168,
                    y_min: -8,
                    y_max: 686,
                    ha: 694,
                    leftSideBearing: 58,
                    advanceWidth: 227
                },
                m: {
                    x_min: 39,
                    x_max: 688,
                    y_min: -14,
                    y_max: 501,
                    ha: 515,
                    leftSideBearing: 39,
                    advanceWidth: 718
                },
                n: {
                    x_min: 45,
                    x_max: 491,
                    y_min: -32,
                    y_max: 512,
                    ha: 544,
                    leftSideBearing: 45,
                    advanceWidth: 541
                },
                o: {
                    x_min: 41,
                    x_max: 424,
                    y_min: -12,
                    y_max: 493,
                    ha: 505,
                    leftSideBearing: 41,
                    advanceWidth: 447
                },
                p: {
                    x_min: 25,
                    x_max: 529,
                    y_min: -260,
                    y_max: 500,
                    ha: 760,
                    leftSideBearing: 25,
                    advanceWidth: 573
                },
                q: {
                    x_min: 53,
                    x_max: 603,
                    y_min: -235,
                    y_max: 514,
                    ha: 749,
                    leftSideBearing: 53,
                    advanceWidth: 623
                },
                r: {
                    x_min: 32,
                    x_max: 407,
                    y_min: -7,
                    y_max: 492,
                    ha: 499,
                    leftSideBearing: 32,
                    advanceWidth: 460
                },
                s: {
                    x_min: 49,
                    x_max: 416,
                    y_min: -12,
                    y_max: 519,
                    ha: 531,
                    leftSideBearing: 49,
                    advanceWidth: 460
                },
                t: {
                    x_min: 32,
                    x_max: 442,
                    y_min: -5,
                    y_max: 684,
                    ha: 689,
                    leftSideBearing: 32,
                    advanceWidth: 469
                },
                u: {
                    x_min: 41,
                    x_max: 487,
                    y_min: -5,
                    y_max: 507,
                    ha: 512,
                    leftSideBearing: 41,
                    advanceWidth: 510
                },
                v: {
                    x_min: 16,
                    x_max: 441,
                    y_min: -20,
                    y_max: 542,
                    ha: 562,
                    leftSideBearing: 16,
                    advanceWidth: 456
                },
                w: {
                    x_min: 39,
                    x_max: 639,
                    y_min: -22,
                    y_max: 505,
                    ha: 527,
                    leftSideBearing: 39,
                    advanceWidth: 661
                },
                x: {
                    x_min: 15,
                    x_max: 505,
                    y_min: -39,
                    y_max: 539,
                    ha: 578,
                    leftSideBearing: 15,
                    advanceWidth: 541
                },
                y: {
                    x_min: -98,
                    x_max: 501,
                    y_min: -242,
                    y_max: 511,
                    ha: 753,
                    leftSideBearing: -98,
                    advanceWidth: 548
                },
                z: {
                    x_min: 27,
                    x_max: 479,
                    y_min: -3,
                    y_max: 494,
                    ha: 497,
                    leftSideBearing: 27,
                    advanceWidth: 494
                },
                "{": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 308
                },
                "|": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 308
                },
                "}": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 308
                },
                "~": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 308
                }
            },
            fontFamily: "PetalumaScript",
            resolution: 1e3,
            generatedOn: "2020-06-14T18:33:25.407Z"
        }, Ui = {
            spacing: 50,
            glyphs: {
                " ": {
                    x_min: 0,
                    x_max: 509,
                    y_min: 0,
                    y_max: 2e3,
                    ha: 2e3,
                    leftSideBearing: 0,
                    advanceWidth: 509
                },
                0: {
                    x_min: 121,
                    x_max: 1048,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 121,
                    advanceWidth: 1168
                },
                1: {
                    x_min: 117,
                    x_max: 767,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 117,
                    advanceWidth: 844
                },
                2: {
                    x_min: 75.8474576645637,
                    x_max: 1040,
                    y_min: 0,
                    y_max: 1477,
                    ha: 1477,
                    leftSideBearing: 75,
                    advanceWidth: 1131
                },
                3: {
                    x_min: 74.85365853658536,
                    x_max: 994,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 74,
                    advanceWidth: 1106
                },
                4: {
                    x_min: 63,
                    x_max: 1114,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 63,
                    advanceWidth: 1187
                },
                5: {
                    x_min: 96.8448275474953,
                    x_max: 982,
                    y_min: -21,
                    y_max: 1456,
                    ha: 1477,
                    leftSideBearing: 96,
                    advanceWidth: 1081
                },
                6: {
                    x_min: 121,
                    x_max: 1067,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 121,
                    advanceWidth: 1144
                },
                7: {
                    x_min: 76,
                    x_max: 1060,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: -30,
                    advanceWidth: 1128
                },
                8: {
                    x_min: 92,
                    x_max: 1039,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 92,
                    advanceWidth: 1131
                },
                9: {
                    x_min: 84,
                    x_max: 1026,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 84,
                    advanceWidth: 1154
                },
                "!": {
                    x_min: 143,
                    x_max: 340,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 143,
                    advanceWidth: 483
                },
                '"': {
                    x_min: 166,
                    x_max: 634,
                    y_min: 1055,
                    y_max: 1560,
                    ha: 505,
                    leftSideBearing: 166,
                    advanceWidth: 770
                },
                "#": {
                    x_min: 63,
                    x_max: 1179,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 63,
                    advanceWidth: 1246
                },
                $: {
                    x_min: 81.92156915727656,
                    x_max: 1012,
                    y_min: -208,
                    y_max: 1693,
                    ha: 1901,
                    leftSideBearing: 81,
                    advanceWidth: 1110
                },
                "%": {
                    x_min: 77,
                    x_max: 1384,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 77,
                    advanceWidth: 1460
                },
                "&": {
                    x_min: 74,
                    x_max: 1242,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 74,
                    advanceWidth: 1289
                },
                "'": {
                    x_min: 166,
                    x_max: 324,
                    y_min: 1055,
                    y_max: 1560,
                    ha: 505,
                    leftSideBearing: 166,
                    advanceWidth: 460
                },
                "(": {
                    x_min: 114,
                    x_max: 650,
                    y_min: -463,
                    y_max: 1636,
                    ha: 2099,
                    leftSideBearing: 114,
                    advanceWidth: 662
                },
                ")": {
                    x_min: 11,
                    x_max: 547,
                    y_min: -463,
                    y_max: 1636,
                    ha: 2099,
                    leftSideBearing: 11,
                    advanceWidth: 654
                },
                "*": {
                    x_min: 66,
                    x_max: 893,
                    y_min: 607,
                    y_max: 1456,
                    ha: 849,
                    leftSideBearing: 66,
                    advanceWidth: 958
                },
                "+": {
                    x_min: 73,
                    x_max: 1071,
                    y_min: 146,
                    y_max: 1206,
                    ha: 1060,
                    leftSideBearing: 73,
                    advanceWidth: 1145
                },
                ",": {
                    x_min: 23,
                    x_max: 315,
                    y_min: -311,
                    y_max: 221,
                    ha: 532,
                    leftSideBearing: 23,
                    advanceWidth: 404
                },
                "-": {
                    x_min: 154,
                    x_max: 643,
                    y_min: 538,
                    y_max: 692,
                    ha: 154,
                    leftSideBearing: 154,
                    advanceWidth: 797
                },
                ".": {
                    x_min: 145,
                    x_max: 342,
                    y_min: 0,
                    y_max: 202,
                    ha: 202,
                    leftSideBearing: 145,
                    advanceWidth: 493
                },
                "/": {
                    x_min: 0,
                    x_max: 774,
                    y_min: -125,
                    y_max: 1456,
                    ha: 1581,
                    leftSideBearing: 0,
                    advanceWidth: 824
                },
                ":": {
                    x_min: 145,
                    x_max: 342,
                    y_min: 0,
                    y_max: 1082,
                    ha: 1082,
                    leftSideBearing: 145,
                    advanceWidth: 419
                },
                ";": {
                    x_min: 53,
                    x_max: 345,
                    y_min: -311,
                    y_max: 1082,
                    ha: 1393,
                    leftSideBearing: 53,
                    advanceWidth: 424
                },
                "<": {
                    x_min: 76,
                    x_max: 892,
                    y_min: 107,
                    y_max: 1013,
                    ha: 906,
                    leftSideBearing: 76,
                    advanceWidth: 1017
                },
                "=": {
                    x_min: 147,
                    x_max: 981,
                    y_min: 407,
                    y_max: 987,
                    ha: 580,
                    leftSideBearing: 147,
                    advanceWidth: 1127
                },
                ">": {
                    x_min: 125,
                    x_max: 980,
                    y_min: 87,
                    y_max: 993,
                    ha: 906,
                    leftSideBearing: 125,
                    advanceWidth: 1060
                },
                "?": {
                    x_min: 65.92660602419838,
                    x_max: 890,
                    y_min: 0,
                    y_max: 1477,
                    ha: 1477,
                    leftSideBearing: 65,
                    advanceWidth: 953
                },
                "@": {
                    x_min: 84.3592218305664,
                    x_max: 1705.2346925277395,
                    y_min: -453,
                    y_max: 1431,
                    ha: 1884,
                    leftSideBearing: 84,
                    advanceWidth: 1821
                },
                A: {
                    x_min: 70,
                    x_max: 1463,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 70,
                    advanceWidth: 1533
                },
                B: {
                    x_min: 81,
                    x_max: 1253,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1322
                },
                C: {
                    x_min: 80,
                    x_max: 1174,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 80,
                    advanceWidth: 1290
                },
                D: {
                    x_min: 81,
                    x_max: 1291,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1356
                },
                E: {
                    x_min: 81,
                    x_max: 1190,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1306
                },
                F: {
                    x_min: 81,
                    x_max: 1176,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1256
                },
                G: {
                    x_min: 80,
                    x_max: 1226,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 80,
                    advanceWidth: 1346
                },
                H: {
                    x_min: 81,
                    x_max: 1497,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1578
                },
                I: {
                    x_min: 81,
                    x_max: 604,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 685
                },
                J: {
                    x_min: 60,
                    x_max: 1100,
                    y_min: -21,
                    y_max: 1456,
                    ha: 1477,
                    leftSideBearing: 60,
                    advanceWidth: 1169
                },
                K: {
                    x_min: 81,
                    x_max: 1427,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1501
                },
                L: {
                    x_min: 81,
                    x_max: 1130,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1210
                },
                M: {
                    x_min: 94,
                    x_max: 1888,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 94,
                    advanceWidth: 1982
                },
                N: {
                    x_min: 83,
                    x_max: 1509,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 83,
                    advanceWidth: 1592
                },
                O: {
                    x_min: 70,
                    x_max: 1281,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 70,
                    advanceWidth: 1351
                },
                P: {
                    x_min: 81,
                    x_max: 1242,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1297
                },
                Q: {
                    x_min: 70,
                    x_max: 1348,
                    y_min: -245,
                    y_max: 1477,
                    ha: 1722,
                    leftSideBearing: 70,
                    advanceWidth: 1376
                },
                R: {
                    x_min: 81,
                    x_max: 1285,
                    y_min: 0,
                    y_max: 1455,
                    ha: 1455,
                    leftSideBearing: 81,
                    advanceWidth: 1385
                },
                S: {
                    x_min: 115,
                    x_max: 1116,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 115,
                    advanceWidth: 1206
                },
                T: {
                    x_min: 96,
                    x_max: 1306,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 96,
                    advanceWidth: 1406
                },
                U: {
                    x_min: 70,
                    x_max: 1452,
                    y_min: -21,
                    y_max: 1456,
                    ha: 1477,
                    leftSideBearing: 70,
                    advanceWidth: 1522
                },
                V: {
                    x_min: 65,
                    x_max: 1443,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 65,
                    advanceWidth: 1508
                },
                W: {
                    x_min: 72,
                    x_max: 2057,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 72,
                    advanceWidth: 2129
                },
                X: {
                    x_min: 80,
                    x_max: 1449,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 80,
                    advanceWidth: 1529
                },
                Y: {
                    x_min: 65,
                    x_max: 1396,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 65,
                    advanceWidth: 1461
                },
                Z: {
                    x_min: 90,
                    x_max: 1107,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 90,
                    advanceWidth: 1197
                },
                "[": {
                    x_min: 157,
                    x_max: 541,
                    y_min: -312,
                    y_max: 1664,
                    ha: 1976,
                    leftSideBearing: 157,
                    advanceWidth: 573
                },
                "\\": {
                    x_min: 36,
                    x_max: 830,
                    y_min: -125,
                    y_max: 1456,
                    ha: 1581,
                    leftSideBearing: 36,
                    advanceWidth: 841
                },
                "]": {
                    x_min: 23,
                    x_max: 408,
                    y_min: -312,
                    y_max: 1664,
                    ha: 1976,
                    leftSideBearing: 23,
                    advanceWidth: 552
                },
                "^": {
                    x_min: 71,
                    x_max: 802,
                    y_min: 729,
                    y_max: 1456,
                    ha: 727,
                    leftSideBearing: 71,
                    advanceWidth: 864
                },
                _: {
                    x_min: 119,
                    x_max: 1041,
                    y_min: -154,
                    y_max: 0,
                    ha: 154,
                    leftSideBearing: 119,
                    advanceWidth: 1168
                },
                "`": {
                    x_min: 40,
                    x_max: 456,
                    y_min: 1288,
                    y_max: 1560,
                    ha: 272,
                    leftSideBearing: 40,
                    advanceWidth: 496
                },
                a: {
                    x_min: 79,
                    x_max: 1053,
                    y_min: -21,
                    y_max: 1102,
                    ha: 1123,
                    leftSideBearing: 79,
                    advanceWidth: 1132
                },
                b: {
                    x_min: -16,
                    x_max: 1071,
                    y_min: -21,
                    y_max: 1560,
                    ha: 1581,
                    leftSideBearing: -16,
                    advanceWidth: 1145
                },
                c: {
                    x_min: 78,
                    x_max: 988,
                    y_min: -21,
                    y_max: 1102,
                    ha: 1123,
                    leftSideBearing: 78,
                    advanceWidth: 1067
                },
                d: {
                    x_min: 78,
                    x_max: 1156,
                    y_min: -21,
                    y_max: 1560,
                    ha: 1581,
                    leftSideBearing: 78,
                    advanceWidth: 1218
                },
                e: {
                    x_min: 74,
                    x_max: 980,
                    y_min: -21,
                    y_max: 1102,
                    ha: 1123,
                    leftSideBearing: 74,
                    advanceWidth: 1059
                },
                f: {
                    x_min: 64,
                    x_max: 731,
                    y_min: 0,
                    y_max: 1581,
                    ha: 1581,
                    leftSideBearing: 64,
                    advanceWidth: 725
                },
                g: {
                    x_min: 78,
                    x_max: 1133,
                    y_min: -437,
                    y_max: 1102,
                    ha: 1539,
                    leftSideBearing: 78,
                    advanceWidth: 1157
                },
                h: {
                    x_min: 49,
                    x_max: 1255,
                    y_min: 0,
                    y_max: 1560,
                    ha: 1560,
                    leftSideBearing: 49,
                    advanceWidth: 1315
                },
                i: {
                    x_min: 67,
                    x_max: 590,
                    y_min: 0,
                    y_max: 1560,
                    ha: 1560,
                    leftSideBearing: 67,
                    advanceWidth: 652
                },
                j: {
                    x_min: -56,
                    x_max: 381,
                    y_min: -437,
                    y_max: 1560,
                    ha: 1997,
                    leftSideBearing: -56,
                    advanceWidth: 525
                },
                k: {
                    x_min: 64,
                    x_max: 1248,
                    y_min: 0,
                    y_max: 1560,
                    ha: 1560,
                    leftSideBearing: 64,
                    advanceWidth: 1287
                },
                l: {
                    x_min: 64,
                    x_max: 587,
                    y_min: 0,
                    y_max: 1560,
                    ha: 1560,
                    leftSideBearing: 64,
                    advanceWidth: 653
                },
                m: {
                    x_min: 74,
                    x_max: 1905,
                    y_min: 0,
                    y_max: 1102,
                    ha: 1102,
                    leftSideBearing: 74,
                    advanceWidth: 1977
                },
                n: {
                    x_min: 74,
                    x_max: 1278,
                    y_min: 0,
                    y_max: 1102,
                    ha: 1102,
                    leftSideBearing: 74,
                    advanceWidth: 1343
                },
                o: {
                    x_min: 78,
                    x_max: 1046,
                    y_min: -21,
                    y_max: 1102,
                    ha: 1123,
                    leftSideBearing: 78,
                    advanceWidth: 1124
                },
                p: {
                    x_min: 34,
                    x_max: 1119,
                    y_min: -416,
                    y_max: 1102,
                    ha: 1518,
                    leftSideBearing: 34,
                    advanceWidth: 1197
                },
                q: {
                    x_min: 78,
                    x_max: 1135,
                    y_min: -416,
                    y_max: 1102,
                    ha: 1518,
                    leftSideBearing: 78,
                    advanceWidth: 1139
                },
                r: {
                    x_min: 72,
                    x_max: 808,
                    y_min: 0,
                    y_max: 1102,
                    ha: 1102,
                    leftSideBearing: 72,
                    advanceWidth: 854
                },
                s: {
                    x_min: 104,
                    x_max: 933,
                    y_min: -21,
                    y_max: 1102,
                    ha: 1123,
                    leftSideBearing: 104,
                    advanceWidth: 1022
                },
                t: {
                    x_min: 24,
                    x_max: 678,
                    y_min: -17,
                    y_max: 1343,
                    ha: 1360,
                    leftSideBearing: 24,
                    advanceWidth: 730
                },
                u: {
                    x_min: 52,
                    x_max: 1181,
                    y_min: -21,
                    y_max: 1082,
                    ha: 1103,
                    leftSideBearing: 52,
                    advanceWidth: 1245
                },
                v: {
                    x_min: 26,
                    x_max: 1176,
                    y_min: 0,
                    y_max: 1082,
                    ha: 1082,
                    leftSideBearing: 26,
                    advanceWidth: 1206
                },
                w: {
                    x_min: 52,
                    x_max: 1777,
                    y_min: 0,
                    y_max: 1082,
                    ha: 1082,
                    leftSideBearing: 52,
                    advanceWidth: 1823
                },
                x: {
                    x_min: 42,
                    x_max: 1163,
                    y_min: 0,
                    y_max: 1082,
                    ha: 1082,
                    leftSideBearing: 42,
                    advanceWidth: 1203
                },
                y: {
                    x_min: 24,
                    x_max: 1172,
                    y_min: -437,
                    y_max: 1082,
                    ha: 1519,
                    leftSideBearing: 24,
                    advanceWidth: 1192
                },
                z: {
                    x_min: 88,
                    x_max: 960,
                    y_min: 0,
                    y_max: 1082,
                    ha: 1082,
                    leftSideBearing: 88,
                    advanceWidth: 1032
                },
                "{": {
                    x_min: 63,
                    x_max: 671,
                    y_min: -364,
                    y_max: 1597,
                    ha: 1961,
                    leftSideBearing: 63,
                    advanceWidth: 701
                },
                "|": {
                    x_min: 150,
                    x_max: 307,
                    y_min: -270,
                    y_max: 1456,
                    ha: 1726,
                    leftSideBearing: 150,
                    advanceWidth: 451
                },
                "}": {
                    x_min: 27,
                    x_max: 635,
                    y_min: -364,
                    y_max: 1597,
                    ha: 1961,
                    leftSideBearing: 27,
                    advanceWidth: 701
                },
                "~": {
                    x_min: 121,
                    x_max: 1257,
                    y_min: 401,
                    y_max: 803,
                    ha: 402,
                    leftSideBearing: 121,
                    advanceWidth: 1386
                }
            },
            fontFamily: "Roboto Slab",
            resolution: 2048,
            generatedOn: "2020-06-15T19:12:58.120Z"
        }, Ii = {
            glyphs: {
                0: {
                    x_min: 86,
                    x_max: 1038,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 86,
                    advanceWidth: 1139
                },
                1: {
                    x_min: 162,
                    x_max: 806,
                    y_min: 0,
                    y_max: 1472,
                    ha: 1472,
                    leftSideBearing: 162,
                    advanceWidth: 1139
                },
                2: {
                    x_min: 51,
                    x_max: 1036,
                    y_min: 0,
                    y_max: 1472,
                    ha: 1472,
                    leftSideBearing: 51,
                    advanceWidth: 1139
                },
                3: {
                    x_min: 77,
                    x_max: 1051,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 77,
                    advanceWidth: 1139
                },
                4: {
                    x_min: 38,
                    x_max: 1092,
                    y_min: 0,
                    y_max: 1472,
                    ha: 1472,
                    leftSideBearing: 38,
                    advanceWidth: 1139
                },
                5: {
                    x_min: 91,
                    x_max: 1077,
                    y_min: -25,
                    y_max: 1446,
                    ha: 1471,
                    leftSideBearing: 91,
                    advanceWidth: 1139
                },
                6: {
                    x_min: 87,
                    x_max: 1066,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 87,
                    advanceWidth: 1139
                },
                7: {
                    x_min: 87,
                    x_max: 1048,
                    y_min: 0,
                    y_max: 1446,
                    ha: 1446,
                    leftSideBearing: 87,
                    advanceWidth: 1139
                },
                8: {
                    x_min: 83,
                    x_max: 1047,
                    y_min: -26,
                    y_max: 1472,
                    ha: 1498,
                    leftSideBearing: 83,
                    advanceWidth: 1139
                },
                9: {
                    x_min: 65,
                    x_max: 1044,
                    y_min: -26,
                    y_max: 1472,
                    ha: 1498,
                    leftSideBearing: 65,
                    advanceWidth: 1139
                },
                " ": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 569
                },
                "!": {
                    x_min: 184,
                    x_max: 488,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 184,
                    advanceWidth: 682
                },
                '"': {
                    x_min: 112,
                    x_max: 869,
                    y_min: 945,
                    y_max: 1466,
                    ha: 521,
                    leftSideBearing: 112,
                    advanceWidth: 971
                },
                "#": {
                    x_min: 18,
                    x_max: 1115,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 18,
                    advanceWidth: 1139
                },
                $: {
                    x_min: 70,
                    x_max: 1048,
                    y_min: -205,
                    y_max: 1584,
                    ha: 1789,
                    leftSideBearing: 70,
                    advanceWidth: 1139
                },
                "%": {
                    x_min: 89,
                    x_max: 1725,
                    y_min: -59,
                    y_max: 1491,
                    ha: 1550,
                    leftSideBearing: 89,
                    advanceWidth: 1821
                },
                "&": {
                    x_min: 90,
                    x_max: 1446,
                    y_min: -38,
                    y_max: 1491,
                    ha: 1529,
                    leftSideBearing: 90,
                    advanceWidth: 1479
                },
                "'": {
                    x_min: 92,
                    x_max: 398,
                    y_min: 945,
                    y_max: 1466,
                    ha: 521,
                    leftSideBearing: 92,
                    advanceWidth: 487
                },
                "(": {
                    x_min: 107,
                    x_max: 616,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 107,
                    advanceWidth: 682
                },
                ")": {
                    x_min: 67,
                    x_max: 576,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 67,
                    advanceWidth: 682
                },
                "*": {
                    x_min: 28,
                    x_max: 753,
                    y_min: 792,
                    y_max: 1491,
                    ha: 699,
                    leftSideBearing: 28,
                    advanceWidth: 797
                },
                "+": {
                    x_min: 85,
                    x_max: 1110,
                    y_min: 211,
                    y_max: 1236,
                    ha: 1025,
                    leftSideBearing: 85,
                    advanceWidth: 1196
                },
                ",": {
                    x_min: 117,
                    x_max: 421,
                    y_min: -327,
                    y_max: 281,
                    ha: 608,
                    leftSideBearing: 117,
                    advanceWidth: 569
                },
                "-": {
                    x_min: 115,
                    x_max: 667,
                    y_min: 391,
                    y_max: 672,
                    ha: 281,
                    leftSideBearing: 115,
                    advanceWidth: 682
                },
                ".": {
                    x_min: 147,
                    x_max: 428,
                    y_min: 0,
                    y_max: 281,
                    ha: 281,
                    leftSideBearing: 147,
                    advanceWidth: 569
                },
                "/": {
                    x_min: -3,
                    x_max: 571,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: -3,
                    advanceWidth: 569
                },
                ":": {
                    x_min: 201,
                    x_max: 482,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 201,
                    advanceWidth: 682
                },
                ";": {
                    x_min: 170,
                    x_max: 474,
                    y_min: -327,
                    y_max: 1062,
                    ha: 1389,
                    leftSideBearing: 170,
                    advanceWidth: 682
                },
                "<": {
                    x_min: 95,
                    x_max: 1100,
                    y_min: 167,
                    y_max: 1281,
                    ha: 1114,
                    leftSideBearing: 95,
                    advanceWidth: 1196
                },
                "=": {
                    x_min: 85,
                    x_max: 1110,
                    y_min: 372,
                    y_max: 1074,
                    ha: 702,
                    leftSideBearing: 85,
                    advanceWidth: 1196
                },
                ">": {
                    x_min: 95,
                    x_max: 1101,
                    y_min: 166,
                    y_max: 1279,
                    ha: 1113,
                    leftSideBearing: 95,
                    advanceWidth: 1196
                },
                "?": {
                    x_min: 106,
                    x_max: 1158,
                    y_min: 0,
                    y_max: 1481,
                    ha: 1481,
                    leftSideBearing: 106,
                    advanceWidth: 1251
                },
                "@": {
                    x_min: 61,
                    x_max: 1990,
                    y_min: -431,
                    y_max: 1492,
                    ha: 1923,
                    leftSideBearing: 61,
                    advanceWidth: 1997
                },
                A: {
                    x_min: 0,
                    x_max: 1471,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 0,
                    advanceWidth: 1479
                },
                B: {
                    x_min: 150,
                    x_max: 1378,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1479
                },
                C: {
                    x_min: 97,
                    x_max: 1374,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 97,
                    advanceWidth: 1479
                },
                D: {
                    x_min: 148,
                    x_max: 1377,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 148,
                    advanceWidth: 1479
                },
                E: {
                    x_min: 149,
                    x_max: 1264,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 149,
                    advanceWidth: 1366
                },
                F: {
                    x_min: 151,
                    x_max: 1156,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 151,
                    advanceWidth: 1251
                },
                G: {
                    x_min: 98,
                    x_max: 1469,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 98,
                    advanceWidth: 1593
                },
                H: {
                    x_min: 150,
                    x_max: 1322,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1479
                },
                I: {
                    x_min: 140,
                    x_max: 436,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 140,
                    advanceWidth: 569
                },
                J: {
                    x_min: 35,
                    x_max: 973,
                    y_min: -25,
                    y_max: 1466,
                    ha: 1491,
                    leftSideBearing: 35,
                    advanceWidth: 1139
                },
                K: {
                    x_min: 153,
                    x_max: 1475,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 153,
                    advanceWidth: 1479
                },
                L: {
                    x_min: 157,
                    x_max: 1189,
                    y_min: 0,
                    y_max: 1454,
                    ha: 1454,
                    leftSideBearing: 157,
                    advanceWidth: 1251
                },
                M: {
                    x_min: 145,
                    x_max: 1561,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 145,
                    advanceWidth: 1706
                },
                N: {
                    x_min: 152,
                    x_max: 1315,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 152,
                    advanceWidth: 1479
                },
                O: {
                    x_min: 89,
                    x_max: 1511,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 89,
                    advanceWidth: 1593
                },
                P: {
                    x_min: 149,
                    x_max: 1272,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 149,
                    advanceWidth: 1366
                },
                Q: {
                    x_min: 89,
                    x_max: 1566,
                    y_min: -147,
                    y_max: 1491,
                    ha: 1638,
                    leftSideBearing: 89,
                    advanceWidth: 1593
                },
                R: {
                    x_min: 150,
                    x_max: 1468,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1479
                },
                S: {
                    x_min: 74,
                    x_max: 1266,
                    y_min: -26,
                    y_max: 1491,
                    ha: 1517,
                    leftSideBearing: 74,
                    advanceWidth: 1366
                },
                T: {
                    x_min: 44,
                    x_max: 1209,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 44,
                    advanceWidth: 1251
                },
                U: {
                    x_min: 147,
                    x_max: 1316,
                    y_min: -25,
                    y_max: 1466,
                    ha: 1491,
                    leftSideBearing: 147,
                    advanceWidth: 1479
                },
                V: {
                    x_min: -1,
                    x_max: 1364,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: -1,
                    advanceWidth: 1366
                },
                W: {
                    x_min: 7,
                    x_max: 1931,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 7,
                    advanceWidth: 1933
                },
                X: {
                    x_min: 0,
                    x_max: 1363,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 0,
                    advanceWidth: 1366
                },
                Y: {
                    x_min: -3,
                    x_max: 1368,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: -3,
                    advanceWidth: 1366
                },
                Z: {
                    x_min: 22,
                    x_max: 1213,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 22,
                    advanceWidth: 1251
                },
                "[": {
                    x_min: 146,
                    x_max: 644,
                    y_min: -413,
                    y_max: 1466,
                    ha: 1879,
                    leftSideBearing: 146,
                    advanceWidth: 682
                },
                "\\": {
                    x_min: -3,
                    x_max: 571,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: -3,
                    advanceWidth: 569
                },
                "]": {
                    x_min: 38,
                    x_max: 536,
                    y_min: -413,
                    y_max: 1466,
                    ha: 1879,
                    leftSideBearing: 38,
                    advanceWidth: 682
                },
                "^": {
                    x_min: 115,
                    x_max: 1080,
                    y_min: 692,
                    y_max: 1491,
                    ha: 799,
                    leftSideBearing: 115,
                    advanceWidth: 1196
                },
                _: {
                    x_min: -19,
                    x_max: 1149,
                    y_min: -405,
                    y_max: -223,
                    ha: 182,
                    leftSideBearing: -19,
                    advanceWidth: 1139
                },
                "`": {
                    x_min: 42,
                    x_max: 495,
                    y_min: 1192,
                    y_max: 1491,
                    ha: 299,
                    leftSideBearing: 42,
                    advanceWidth: 682
                },
                a: {
                    x_min: 73,
                    x_max: 1070,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 73,
                    advanceWidth: 1139
                },
                b: {
                    x_min: 135,
                    x_max: 1172,
                    y_min: -24,
                    y_max: 1466,
                    ha: 1490,
                    leftSideBearing: 135,
                    advanceWidth: 1251
                },
                c: {
                    x_min: 85,
                    x_max: 1087,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 85,
                    advanceWidth: 1139
                },
                d: {
                    x_min: 84,
                    x_max: 1121,
                    y_min: -24,
                    y_max: 1466,
                    ha: 1490,
                    leftSideBearing: 84,
                    advanceWidth: 1251
                },
                e: {
                    x_min: 65,
                    x_max: 1057.2517482517483,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 65,
                    advanceWidth: 1139
                },
                f: {
                    x_min: 24,
                    x_max: 742,
                    y_min: 0,
                    y_max: 1491,
                    ha: 1491,
                    leftSideBearing: 24,
                    advanceWidth: 682
                },
                g: {
                    x_min: 84,
                    x_max: 1120,
                    y_min: -431,
                    y_max: 1086,
                    ha: 1517,
                    leftSideBearing: 84,
                    advanceWidth: 1251
                },
                h: {
                    x_min: 146,
                    x_max: 1113,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 146,
                    advanceWidth: 1251
                },
                i: {
                    x_min: 147,
                    x_max: 428,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 147,
                    advanceWidth: 569
                },
                j: {
                    x_min: -94,
                    x_max: 422,
                    y_min: -431,
                    y_max: 1466,
                    ha: 1897,
                    leftSideBearing: -94,
                    advanceWidth: 569
                },
                k: {
                    x_min: 137,
                    x_max: 1119,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 137,
                    advanceWidth: 1139
                },
                l: {
                    x_min: 147,
                    x_max: 428,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 147,
                    advanceWidth: 569
                },
                m: {
                    x_min: 126,
                    x_max: 1688,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 126,
                    advanceWidth: 1821
                },
                n: {
                    x_min: 145,
                    x_max: 1113,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 145,
                    advanceWidth: 1251
                },
                o: {
                    x_min: 82,
                    x_max: 1178,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 82,
                    advanceWidth: 1251
                },
                p: {
                    x_min: 139,
                    x_max: 1175,
                    y_min: -404,
                    y_max: 1086,
                    ha: 1490,
                    leftSideBearing: 139,
                    advanceWidth: 1251
                },
                q: {
                    x_min: 91,
                    x_max: 1122,
                    y_min: -404,
                    y_max: 1086,
                    ha: 1490,
                    leftSideBearing: 91,
                    advanceWidth: 1251
                },
                r: {
                    x_min: 135,
                    x_max: 823,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 135,
                    advanceWidth: 797
                },
                s: {
                    x_min: 48,
                    x_max: 1040,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 48,
                    advanceWidth: 1139
                },
                t: {
                    x_min: 31,
                    x_max: 657,
                    y_min: -24,
                    y_max: 1437,
                    ha: 1461,
                    leftSideBearing: 31,
                    advanceWidth: 682
                },
                u: {
                    x_min: 141,
                    x_max: 1107,
                    y_min: -24,
                    y_max: 1062,
                    ha: 1086,
                    leftSideBearing: 141,
                    advanceWidth: 1251
                },
                v: {
                    x_min: 11,
                    x_max: 1114,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 11,
                    advanceWidth: 1139
                },
                w: {
                    x_min: 9,
                    x_max: 1592,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 9,
                    advanceWidth: 1593
                },
                x: {
                    x_min: 12,
                    x_max: 1120,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 12,
                    advanceWidth: 1139
                },
                y: {
                    x_min: 14,
                    x_max: 1106,
                    y_min: -431,
                    y_max: 1062,
                    ha: 1493,
                    leftSideBearing: 14,
                    advanceWidth: 1139
                },
                z: {
                    x_min: 34,
                    x_max: 982,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 34,
                    advanceWidth: 1024
                },
                "{": {
                    x_min: 60,
                    x_max: 744,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 60,
                    advanceWidth: 797
                },
                "|": {
                    x_min: 176,
                    x_max: 399,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 176,
                    advanceWidth: 573
                },
                "}": {
                    x_min: 45,
                    x_max: 729,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 45,
                    advanceWidth: 797
                },
                "~": {
                    x_min: 67,
                    x_max: 1129,
                    y_min: 519,
                    y_max: 924,
                    ha: 405,
                    leftSideBearing: 67,
                    advanceWidth: 1196
                }
            },
            fontFamily: "Arial",
            resolution: 2048,
            generatedOn: "2022-11-04T20:05:21.000Z"
        }, Gi = {
            smufl: !1,
            name: "SANS",
            spacing: 50,
            Description: "Built-in sans-serif font",
            bold: !0,
            italic: !0,
            monospaced: !1,
            serifs: !1,
            glyphs: {
                0: {
                    x_min: 85,
                    x_max: 1041,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 85,
                    advanceWidth: 1139
                },
                1: {
                    x_min: 223,
                    x_max: 763,
                    y_min: 0,
                    y_max: 1472,
                    ha: 1472,
                    leftSideBearing: 223,
                    advanceWidth: 1139
                },
                2: {
                    x_min: 61.840001123045234,
                    x_max: 1031,
                    y_min: 0,
                    y_max: 1472,
                    ha: 1472,
                    leftSideBearing: 61,
                    advanceWidth: 1139
                },
                3: {
                    x_min: 86,
                    x_max: 1046,
                    y_min: -26,
                    y_max: 1472,
                    ha: 1498,
                    leftSideBearing: 86,
                    advanceWidth: 1139
                },
                4: {
                    x_min: 26,
                    x_max: 1040,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 26,
                    advanceWidth: 1139
                },
                5: {
                    x_min: 85,
                    x_max: 1057,
                    y_min: -25,
                    y_max: 1446,
                    ha: 1471,
                    leftSideBearing: 85,
                    advanceWidth: 1139
                },
                6: {
                    x_min: 77,
                    x_max: 1045,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 77,
                    advanceWidth: 1139
                },
                7: {
                    x_min: 97,
                    x_max: 1046,
                    y_min: 0,
                    y_max: 1447,
                    ha: 1447,
                    leftSideBearing: 97,
                    advanceWidth: 1139
                },
                8: {
                    x_min: 83,
                    x_max: 1049,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 83,
                    advanceWidth: 1139
                },
                9: {
                    x_min: 85,
                    x_max: 1049,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 85,
                    advanceWidth: 1139
                },
                " ": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 569
                },
                "!": {
                    x_min: 176,
                    x_max: 399,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 176,
                    advanceWidth: 569
                },
                '"': {
                    x_min: 94,
                    x_max: 631,
                    y_min: 947,
                    y_max: 1466,
                    ha: 519,
                    leftSideBearing: 94,
                    advanceWidth: 727
                },
                "#": {
                    x_min: 21,
                    x_max: 1113,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 21,
                    advanceWidth: 1139
                },
                $: {
                    x_min: 73,
                    x_max: 1043,
                    y_min: -211,
                    y_max: 1601,
                    ha: 1812,
                    leftSideBearing: 73,
                    advanceWidth: 1139
                },
                "%": {
                    x_min: 119,
                    x_max: 1695,
                    y_min: -54,
                    y_max: 1491,
                    ha: 1545,
                    leftSideBearing: 119,
                    advanceWidth: 1821
                },
                "&": {
                    x_min: 88,
                    x_max: 1319,
                    y_min: -34,
                    y_max: 1491,
                    ha: 1525,
                    leftSideBearing: 88,
                    advanceWidth: 1366
                },
                "'": {
                    x_min: 90,
                    x_max: 295,
                    y_min: 947,
                    y_max: 1466,
                    ha: 519,
                    leftSideBearing: 90,
                    advanceWidth: 391
                },
                "(": {
                    x_min: 124,
                    x_max: 608,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 124,
                    advanceWidth: 682
                },
                ")": {
                    x_min: 124,
                    x_max: 608,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 124,
                    advanceWidth: 682
                },
                "*": {
                    x_min: 64,
                    x_max: 725,
                    y_min: 867,
                    y_max: 1491,
                    ha: 624,
                    leftSideBearing: 64,
                    advanceWidth: 797
                },
                "+": {
                    x_min: 114,
                    x_max: 1082,
                    y_min: 237,
                    y_max: 1206,
                    ha: 969,
                    leftSideBearing: 114,
                    advanceWidth: 1196
                },
                ",": {
                    x_min: 170,
                    x_max: 387,
                    y_min: -290,
                    y_max: 205,
                    ha: 495,
                    leftSideBearing: 170,
                    advanceWidth: 569
                },
                "-": {
                    x_min: 65,
                    x_max: 618,
                    y_min: 440,
                    y_max: 621,
                    ha: 181,
                    leftSideBearing: 65,
                    advanceWidth: 682
                },
                ".": {
                    x_min: 186,
                    x_max: 391,
                    y_min: 0,
                    y_max: 205,
                    ha: 205,
                    leftSideBearing: 186,
                    advanceWidth: 569
                },
                "/": {
                    x_min: 0,
                    x_max: 569,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 0,
                    advanceWidth: 569
                },
                ":": {
                    x_min: 185,
                    x_max: 390,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 185,
                    advanceWidth: 569
                },
                ";": {
                    x_min: 170,
                    x_max: 387,
                    y_min: -290,
                    y_max: 1062,
                    ha: 1352,
                    leftSideBearing: 170,
                    advanceWidth: 569
                },
                "<": {
                    x_min: 112,
                    x_max: 1083,
                    y_min: 226,
                    y_max: 1219,
                    ha: 993,
                    leftSideBearing: 112,
                    advanceWidth: 1196
                },
                "=": {
                    x_min: 114,
                    x_max: 1082,
                    y_min: 417,
                    y_max: 1030,
                    ha: 613,
                    leftSideBearing: 114,
                    advanceWidth: 1196
                },
                ">": {
                    x_min: 112,
                    x_max: 1083,
                    y_min: 226,
                    y_max: 1219,
                    ha: 993,
                    leftSideBearing: 112,
                    advanceWidth: 1196
                },
                "?": {
                    x_min: 90,
                    x_max: 1036,
                    y_min: 0,
                    y_max: 1491,
                    ha: 1491,
                    leftSideBearing: 90,
                    advanceWidth: 1139
                },
                "@": {
                    x_min: 111,
                    x_max: 2005,
                    y_min: -431,
                    y_max: 1493,
                    ha: 1924,
                    leftSideBearing: 111,
                    advanceWidth: 2079
                },
                A: {
                    x_min: -3,
                    x_max: 1369,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: -3,
                    advanceWidth: 1366
                },
                B: {
                    x_min: 150,
                    x_max: 1257,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1366
                },
                C: {
                    x_min: 102,
                    x_max: 1398,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 102,
                    advanceWidth: 1479
                },
                D: {
                    x_min: 158,
                    x_max: 1370,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 158,
                    advanceWidth: 1479
                },
                E: {
                    x_min: 162,
                    x_max: 1256,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 162,
                    advanceWidth: 1366
                },
                F: {
                    x_min: 168,
                    x_max: 1157,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 168,
                    advanceWidth: 1251
                },
                G: {
                    x_min: 109,
                    x_max: 1465,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 109,
                    advanceWidth: 1593
                },
                H: {
                    x_min: 164,
                    x_max: 1314,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 164,
                    advanceWidth: 1479
                },
                I: {
                    x_min: 191,
                    x_max: 385,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 191,
                    advanceWidth: 569
                },
                J: {
                    x_min: 58.84976474807333,
                    x_max: 865,
                    y_min: -25,
                    y_max: 1466,
                    ha: 1491,
                    leftSideBearing: 58,
                    advanceWidth: 1024
                },
                K: {
                    x_min: 150,
                    x_max: 1362,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1366
                },
                L: {
                    x_min: 150,
                    x_max: 1066,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1139
                },
                M: {
                    x_min: 152,
                    x_max: 1551,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 152,
                    advanceWidth: 1706
                },
                N: {
                    x_min: 156,
                    x_max: 1311,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 156,
                    advanceWidth: 1479
                },
                O: {
                    x_min: 99,
                    x_max: 1501,
                    y_min: -25,
                    y_max: 1492,
                    ha: 1517,
                    leftSideBearing: 99,
                    advanceWidth: 1593
                },
                P: {
                    x_min: 158,
                    x_max: 1277,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 158,
                    advanceWidth: 1366
                },
                Q: {
                    x_min: 88,
                    x_max: 1518,
                    y_min: -114,
                    y_max: 1492,
                    ha: 1606,
                    leftSideBearing: 88,
                    advanceWidth: 1593
                },
                R: {
                    x_min: 161,
                    x_max: 1453,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 161,
                    advanceWidth: 1479
                },
                S: {
                    x_min: 92,
                    x_max: 1259,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 92,
                    advanceWidth: 1366
                },
                T: {
                    x_min: 48,
                    x_max: 1210,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 48,
                    advanceWidth: 1251
                },
                U: {
                    x_min: 161,
                    x_max: 1314,
                    y_min: -25,
                    y_max: 1466,
                    ha: 1491,
                    leftSideBearing: 161,
                    advanceWidth: 1479
                },
                V: {
                    x_min: 9,
                    x_max: 1350,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 9,
                    advanceWidth: 1366
                },
                W: {
                    x_min: 25,
                    x_max: 1910,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 25,
                    advanceWidth: 1933
                },
                X: {
                    x_min: 9,
                    x_max: 1353,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 9,
                    advanceWidth: 1366
                },
                Y: {
                    x_min: 6,
                    x_max: 1350,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 6,
                    advanceWidth: 1366
                },
                Z: {
                    x_min: 41,
                    x_max: 1200,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 41,
                    advanceWidth: 1251
                },
                "[": {
                    x_min: 139,
                    x_max: 536,
                    y_min: -407,
                    y_max: 1466,
                    ha: 1873,
                    leftSideBearing: 139,
                    advanceWidth: 569
                },
                "\\": {
                    x_min: 0,
                    x_max: 569,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 0,
                    advanceWidth: 569
                },
                "]": {
                    x_min: 39,
                    x_max: 436,
                    y_min: -407,
                    y_max: 1466,
                    ha: 1873,
                    leftSideBearing: 39,
                    advanceWidth: 569
                },
                "^": {
                    x_min: 54,
                    x_max: 907,
                    y_min: 690,
                    y_max: 1491,
                    ha: 801,
                    leftSideBearing: 54,
                    advanceWidth: 961
                },
                _: {
                    x_min: -31,
                    x_max: 1162,
                    y_min: -407,
                    y_max: -277,
                    ha: 130,
                    leftSideBearing: -31,
                    advanceWidth: 1139
                },
                "`": {
                    x_min: 89,
                    x_max: 465,
                    y_min: 1194,
                    y_max: 1474,
                    ha: 280,
                    leftSideBearing: 89,
                    advanceWidth: 682
                },
                a: {
                    x_min: 74,
                    x_max: 1052,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 74,
                    advanceWidth: 1139
                },
                b: {
                    x_min: 134,
                    x_max: 1055,
                    y_min: -24,
                    y_max: 1466,
                    ha: 1490,
                    leftSideBearing: 134,
                    advanceWidth: 1139
                },
                c: {
                    x_min: 80,
                    x_max: 1005,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 80,
                    advanceWidth: 1024
                },
                d: {
                    x_min: 70,
                    x_max: 991,
                    y_min: -24,
                    y_max: 1466,
                    ha: 1490,
                    leftSideBearing: 70,
                    advanceWidth: 1139
                },
                e: {
                    x_min: 75,
                    x_max: 1054,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 75,
                    advanceWidth: 1139
                },
                f: {
                    x_min: 19,
                    x_max: 640,
                    y_min: 0,
                    y_max: 1491,
                    ha: 1491,
                    leftSideBearing: 19,
                    advanceWidth: 569
                },
                g: {
                    x_min: 66,
                    x_max: 1002,
                    y_min: -431,
                    y_max: 1086,
                    ha: 1517,
                    leftSideBearing: 66,
                    advanceWidth: 1139
                },
                h: {
                    x_min: 135,
                    x_max: 1e3,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 135,
                    advanceWidth: 1139
                },
                i: {
                    x_min: 136,
                    x_max: 316,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 136,
                    advanceWidth: 455
                },
                j: {
                    x_min: -94,
                    x_max: 314,
                    y_min: -431,
                    y_max: 1466,
                    ha: 1897,
                    leftSideBearing: -94,
                    advanceWidth: 455
                },
                k: {
                    x_min: 136,
                    x_max: 1016,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 136,
                    advanceWidth: 1024
                },
                l: {
                    x_min: 131,
                    x_max: 311,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 131,
                    advanceWidth: 455
                },
                m: {
                    x_min: 135,
                    x_max: 1574,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 135,
                    advanceWidth: 1706
                },
                n: {
                    x_min: 135,
                    x_max: 998,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 135,
                    advanceWidth: 1139
                },
                o: {
                    x_min: 68,
                    x_max: 1063,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 68,
                    advanceWidth: 1139
                },
                p: {
                    x_min: 135,
                    x_max: 1057,
                    y_min: -407,
                    y_max: 1086,
                    ha: 1493,
                    leftSideBearing: 135,
                    advanceWidth: 1139
                },
                q: {
                    x_min: 72,
                    x_max: 992,
                    y_min: -407,
                    y_max: 1086,
                    ha: 1493,
                    leftSideBearing: 72,
                    advanceWidth: 1139
                },
                r: {
                    x_min: 133,
                    x_max: 710,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 133,
                    advanceWidth: 682
                },
                s: {
                    x_min: 63,
                    x_max: 945,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 63,
                    advanceWidth: 1024
                },
                t: {
                    x_min: 36,
                    x_max: 554,
                    y_min: -14,
                    y_max: 1433,
                    ha: 1447,
                    leftSideBearing: 36,
                    advanceWidth: 569
                },
                u: {
                    x_min: 131,
                    x_max: 992,
                    y_min: -24,
                    y_max: 1062,
                    ha: 1086,
                    leftSideBearing: 131,
                    advanceWidth: 1139
                },
                v: {
                    x_min: 26,
                    x_max: 1e3,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 26,
                    advanceWidth: 1024
                },
                w: {
                    x_min: 6,
                    x_max: 1463,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 6,
                    advanceWidth: 1479
                },
                x: {
                    x_min: 15,
                    x_max: 1009,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 15,
                    advanceWidth: 1024
                },
                y: {
                    x_min: 33,
                    x_max: 1006,
                    y_min: -431,
                    y_max: 1062,
                    ha: 1493,
                    leftSideBearing: 33,
                    advanceWidth: 1024
                },
                z: {
                    x_min: 40,
                    x_max: 980,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 40,
                    advanceWidth: 1024
                },
                "{": {
                    x_min: 57,
                    x_max: 636,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 57,
                    advanceWidth: 684
                },
                "|": {
                    x_min: 188,
                    x_max: 345,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 188,
                    advanceWidth: 532
                },
                "}": {
                    x_min: 47,
                    x_max: 626,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 47,
                    advanceWidth: 684
                },
                "~": {
                    x_min: 87,
                    x_max: 1110,
                    y_min: 557,
                    y_max: 885,
                    ha: 328,
                    leftSideBearing: 87,
                    advanceWidth: 1196
                }
            },
            fontFamily: "sans-serif",
            resolution: 2048,
            generatedOn: "2020-10-18T18:48:11.823Z"
        }, Hi = {
            smufl: !1,
            name: "SERIF",
            spacing: 50,
            Description: "Built-in serif font",
            bold: !0,
            italic: !0,
            monospaced: !1,
            serifs: !0,
            glyphs: {
                0: {
                    x_min: 49,
                    x_max: 975,
                    y_min: -27,
                    y_max: 1383,
                    ha: 1410,
                    leftSideBearing: 49,
                    advanceWidth: 1024
                },
                1: {
                    x_min: 227,
                    x_max: 811,
                    y_min: 0,
                    y_max: 1383,
                    ha: 1383,
                    leftSideBearing: 227,
                    advanceWidth: 1024
                },
                2: {
                    x_min: 61,
                    x_max: 965,
                    y_min: 0,
                    y_max: 1383,
                    ha: 1383,
                    leftSideBearing: 61,
                    advanceWidth: 1024
                },
                3: {
                    x_min: 88,
                    x_max: 883,
                    y_min: -27,
                    y_max: 1383,
                    ha: 1410,
                    leftSideBearing: 88,
                    advanceWidth: 1024
                },
                4: {
                    x_min: 25,
                    x_max: 967,
                    y_min: 0,
                    y_max: 1384,
                    ha: 1384,
                    leftSideBearing: 25,
                    advanceWidth: 1024
                },
                5: {
                    x_min: 66,
                    x_max: 898,
                    y_min: -27,
                    y_max: 1409,
                    ha: 1436,
                    leftSideBearing: 66,
                    advanceWidth: 1024
                },
                6: {
                    x_min: 70,
                    x_max: 958,
                    y_min: -27,
                    y_max: 1401,
                    ha: 1428,
                    leftSideBearing: 70,
                    advanceWidth: 1024
                },
                7: {
                    x_min: 41,
                    x_max: 920,
                    y_min: -16,
                    y_max: 1356,
                    ha: 1372,
                    leftSideBearing: 41,
                    advanceWidth: 1024
                },
                8: {
                    x_min: 115,
                    x_max: 911,
                    y_min: -27,
                    y_max: 1383,
                    ha: 1410,
                    leftSideBearing: 115,
                    advanceWidth: 1024
                },
                9: {
                    x_min: 61,
                    x_max: 940,
                    y_min: -41,
                    y_max: 1383,
                    ha: 1424,
                    leftSideBearing: 61,
                    advanceWidth: 1024
                },
                " ": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 512
                },
                "!": {
                    x_min: 266,
                    x_max: 488,
                    y_min: -22,
                    y_max: 1383,
                    ha: 1405,
                    leftSideBearing: 266,
                    advanceWidth: 682
                },
                '"': {
                    x_min: 157.2000021972655,
                    x_max: 678.2500021457677,
                    y_min: 881,
                    y_max: 1385,
                    ha: 504,
                    leftSideBearing: 157,
                    advanceWidth: 836
                },
                "#": {
                    x_min: 10,
                    x_max: 1016,
                    y_min: -1,
                    y_max: 1356,
                    ha: 1357,
                    leftSideBearing: 10,
                    advanceWidth: 1024
                },
                $: {
                    x_min: 90,
                    x_max: 936,
                    y_min: -180,
                    y_max: 1492,
                    ha: 1672,
                    leftSideBearing: 90,
                    advanceWidth: 1024
                },
                "%": {
                    x_min: 125,
                    x_max: 1581,
                    y_min: -30,
                    y_max: 1388,
                    ha: 1418,
                    leftSideBearing: 125,
                    advanceWidth: 1706
                },
                "&": {
                    x_min: 86,
                    x_max: 1536,
                    y_min: -28,
                    y_max: 1383,
                    ha: 1411,
                    leftSideBearing: 86,
                    advanceWidth: 1593
                },
                "'": {
                    x_min: 97.20000219726548,
                    x_max: 273.2500021457677,
                    y_min: 881,
                    y_max: 1385,
                    ha: 504,
                    leftSideBearing: 97,
                    advanceWidth: 369
                },
                "(": {
                    x_min: 98,
                    x_max: 623,
                    y_min: -363,
                    y_max: 1383,
                    ha: 1746,
                    leftSideBearing: 98,
                    advanceWidth: 682
                },
                ")": {
                    x_min: 59,
                    x_max: 584,
                    y_min: -363,
                    y_max: 1383,
                    ha: 1746,
                    leftSideBearing: 59,
                    advanceWidth: 682
                },
                "*": {
                    x_min: 137.96078522291893,
                    x_max: 886.039214777081,
                    y_min: 543,
                    y_max: 1383,
                    ha: 840,
                    leftSideBearing: 137,
                    advanceWidth: 1024
                },
                "+": {
                    x_min: 61,
                    x_max: 1093,
                    y_min: 2,
                    y_max: 1034,
                    ha: 1032,
                    leftSideBearing: 61,
                    advanceWidth: 1155
                },
                ",": {
                    x_min: 115,
                    x_max: 399,
                    y_min: -291,
                    y_max: 208,
                    ha: 499,
                    leftSideBearing: 115,
                    advanceWidth: 512
                },
                "-": {
                    x_min: 80,
                    x_max: 584,
                    y_min: 396,
                    y_max: 525,
                    ha: 129,
                    leftSideBearing: 80,
                    advanceWidth: 682
                },
                ".": {
                    x_min: 143,
                    x_max: 371,
                    y_min: -22,
                    y_max: 205,
                    ha: 227,
                    leftSideBearing: 143,
                    advanceWidth: 512
                },
                "/": {
                    x_min: -17,
                    x_max: 586,
                    y_min: -27,
                    y_max: 1383,
                    ha: 1410,
                    leftSideBearing: -17,
                    advanceWidth: 569
                },
                ":": {
                    x_min: 166,
                    x_max: 394,
                    y_min: -22,
                    y_max: 943,
                    ha: 965,
                    leftSideBearing: 166,
                    advanceWidth: 569
                },
                ";": {
                    x_min: 164,
                    x_max: 448,
                    y_min: -290,
                    y_max: 943,
                    ha: 1233,
                    leftSideBearing: 164,
                    advanceWidth: 569
                },
                "<": {
                    x_min: 57,
                    x_max: 1098,
                    y_min: -15,
                    y_max: 1051,
                    ha: 1066,
                    leftSideBearing: 57,
                    advanceWidth: 1155
                },
                "=": {
                    x_min: 61,
                    x_max: 1093,
                    y_min: 246,
                    y_max: 791,
                    ha: 545,
                    leftSideBearing: 61,
                    advanceWidth: 1155
                },
                ">": {
                    x_min: 57,
                    x_max: 1098,
                    y_min: -15,
                    y_max: 1051,
                    ha: 1066,
                    leftSideBearing: 57,
                    advanceWidth: 1155
                },
                "?": {
                    x_min: 139,
                    x_max: 848,
                    y_min: -15,
                    y_max: 1383,
                    ha: 1398,
                    leftSideBearing: 139,
                    advanceWidth: 909
                },
                "@": {
                    x_min: 238,
                    x_max: 1657,
                    y_min: -29,
                    y_max: 1386,
                    ha: 1415,
                    leftSideBearing: 238,
                    advanceWidth: 1886
                },
                A: {
                    x_min: 31,
                    x_max: 1445,
                    y_min: 0,
                    y_max: 1380,
                    ha: 1380,
                    leftSideBearing: 31,
                    advanceWidth: 1479
                },
                B: {
                    x_min: 35,
                    x_max: 1214,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 35,
                    advanceWidth: 1366
                },
                C: {
                    x_min: 57,
                    x_max: 1296,
                    y_min: -28,
                    y_max: 1383,
                    ha: 1411,
                    leftSideBearing: 57,
                    advanceWidth: 1366
                },
                D: {
                    x_min: 33,
                    x_max: 1403,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 33,
                    advanceWidth: 1479
                },
                E: {
                    x_min: 25,
                    x_max: 1222,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 25,
                    advanceWidth: 1251
                },
                F: {
                    x_min: 25,
                    x_max: 1119,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 25,
                    advanceWidth: 1139
                },
                G: {
                    x_min: 66,
                    x_max: 1452,
                    y_min: -28,
                    y_max: 1383,
                    ha: 1411,
                    leftSideBearing: 66,
                    advanceWidth: 1479
                },
                H: {
                    x_min: 39,
                    x_max: 1438,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 39,
                    advanceWidth: 1479
                },
                I: {
                    x_min: 37,
                    x_max: 642,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 37,
                    advanceWidth: 682
                },
                J: {
                    x_min: 20,
                    x_max: 758,
                    y_min: -28,
                    y_max: 1356,
                    ha: 1384,
                    leftSideBearing: 20,
                    advanceWidth: 797
                },
                K: {
                    x_min: 70,
                    x_max: 1479,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 70,
                    advanceWidth: 1479
                },
                L: {
                    x_min: 25,
                    x_max: 1224,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 25,
                    advanceWidth: 1251
                },
                M: {
                    x_min: 25,
                    x_max: 1768,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 25,
                    advanceWidth: 1821
                },
                N: {
                    x_min: 25,
                    x_max: 1450,
                    y_min: -22,
                    y_max: 1356,
                    ha: 1378,
                    leftSideBearing: 25,
                    advanceWidth: 1479
                },
                O: {
                    x_min: 70,
                    x_max: 1409,
                    y_min: -28,
                    y_max: 1383,
                    ha: 1411,
                    leftSideBearing: 70,
                    advanceWidth: 1479
                },
                P: {
                    x_min: 33,
                    x_max: 1110,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 33,
                    advanceWidth: 1139
                },
                Q: {
                    x_min: 70,
                    x_max: 1435,
                    y_min: -364.28571588721996,
                    y_max: 1383,
                    ha: 1747.28571588722,
                    leftSideBearing: 70,
                    advanceWidth: 1479
                },
                R: {
                    x_min: 35,
                    x_max: 1347,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 35,
                    advanceWidth: 1366
                },
                S: {
                    x_min: 86,
                    x_max: 1006,
                    y_min: -28,
                    y_max: 1383,
                    ha: 1411,
                    leftSideBearing: 86,
                    advanceWidth: 1139
                },
                T: {
                    x_min: 35,
                    x_max: 1214,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 35,
                    advanceWidth: 1251
                },
                U: {
                    x_min: 29,
                    x_max: 1444,
                    y_min: -28,
                    y_max: 1356,
                    ha: 1384,
                    leftSideBearing: 29,
                    advanceWidth: 1479
                },
                V: {
                    x_min: 33,
                    x_max: 1428,
                    y_min: -22,
                    y_max: 1356,
                    ha: 1378,
                    leftSideBearing: 33,
                    advanceWidth: 1479
                },
                W: {
                    x_min: 10,
                    x_max: 1906,
                    y_min: -22,
                    y_max: 1356,
                    ha: 1378,
                    leftSideBearing: 10,
                    advanceWidth: 1933
                },
                X: {
                    x_min: 20,
                    x_max: 1449,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 20,
                    advanceWidth: 1479
                },
                Y: {
                    x_min: 45,
                    x_max: 1441,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 45,
                    advanceWidth: 1479
                },
                Z: {
                    x_min: 18,
                    x_max: 1222,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 18,
                    advanceWidth: 1251
                },
                "[": {
                    x_min: 180,
                    x_max: 612,
                    y_min: -319,
                    y_max: 1355,
                    ha: 1674,
                    leftSideBearing: 180,
                    advanceWidth: 682
                },
                "\\": {
                    x_min: -17,
                    x_max: 586,
                    y_min: -27,
                    y_max: 1383,
                    ha: 1410,
                    leftSideBearing: -17,
                    advanceWidth: 569
                },
                "]": {
                    x_min: 70,
                    x_max: 502,
                    y_min: -319,
                    y_max: 1355,
                    ha: 1674,
                    leftSideBearing: 70,
                    advanceWidth: 682
                },
                "^": {
                    x_min: 49,
                    x_max: 914,
                    y_min: 608,
                    y_max: 1355,
                    ha: 747,
                    leftSideBearing: 49,
                    advanceWidth: 961
                },
                _: {
                    x_min: 0,
                    x_max: 1024,
                    y_min: -255,
                    y_max: -153,
                    ha: 102,
                    leftSideBearing: 0,
                    advanceWidth: 1024
                },
                "`": {
                    x_min: 39,
                    x_max: 499,
                    y_min: 1037,
                    y_max: 1392.509803639748,
                    ha: 355.50980363974804,
                    leftSideBearing: 39,
                    advanceWidth: 682
                },
                a: {
                    x_min: 76,
                    x_max: 905,
                    y_min: -20,
                    y_max: 942,
                    ha: 962,
                    leftSideBearing: 76,
                    advanceWidth: 909
                },
                b: {
                    x_min: 6,
                    x_max: 958,
                    y_min: -20,
                    y_max: 1399,
                    ha: 1419,
                    leftSideBearing: 6,
                    advanceWidth: 1024
                },
                c: {
                    x_min: 51,
                    x_max: 843,
                    y_min: -20,
                    y_max: 942,
                    ha: 962,
                    leftSideBearing: 51,
                    advanceWidth: 909
                },
                d: {
                    x_min: 55,
                    x_max: 1006,
                    y_min: -20,
                    y_max: 1399,
                    ha: 1419,
                    leftSideBearing: 55,
                    advanceWidth: 1024
                },
                e: {
                    x_min: 51,
                    x_max: 868,
                    y_min: -20,
                    y_max: 942,
                    ha: 962,
                    leftSideBearing: 51,
                    advanceWidth: 909
                },
                f: {
                    x_min: 41,
                    x_max: 783,
                    y_min: 0,
                    y_max: 1399,
                    ha: 1399,
                    leftSideBearing: 41,
                    advanceWidth: 682
                },
                g: {
                    x_min: 57,
                    x_max: 963,
                    y_min: -446,
                    y_max: 942,
                    ha: 1388,
                    leftSideBearing: 57,
                    advanceWidth: 1024
                },
                h: {
                    x_min: 18,
                    x_max: 997,
                    y_min: 0,
                    y_max: 1399,
                    ha: 1399,
                    leftSideBearing: 18,
                    advanceWidth: 1024
                },
                i: {
                    x_min: 33,
                    x_max: 516,
                    y_min: 0,
                    y_max: 1399,
                    ha: 1399,
                    leftSideBearing: 33,
                    advanceWidth: 569
                },
                j: {
                    x_min: -142,
                    x_max: 397,
                    y_min: -446,
                    y_max: 1399,
                    ha: 1845,
                    leftSideBearing: -142,
                    advanceWidth: 569
                },
                k: {
                    x_min: 14,
                    x_max: 1029,
                    y_min: 0,
                    y_max: 1399,
                    ha: 1399,
                    leftSideBearing: 14,
                    advanceWidth: 1024
                },
                l: {
                    x_min: 39,
                    x_max: 523,
                    y_min: 0,
                    y_max: 1399,
                    ha: 1399,
                    leftSideBearing: 39,
                    advanceWidth: 569
                },
                m: {
                    x_min: 33,
                    x_max: 1587,
                    y_min: 0,
                    y_max: 944,
                    ha: 944,
                    leftSideBearing: 33,
                    advanceWidth: 1593
                },
                n: {
                    x_min: 33,
                    x_max: 993,
                    y_min: 0,
                    y_max: 944,
                    ha: 944,
                    leftSideBearing: 33,
                    advanceWidth: 1024
                },
                o: {
                    x_min: 59,
                    x_max: 963,
                    y_min: -20,
                    y_max: 942,
                    ha: 962,
                    leftSideBearing: 59,
                    advanceWidth: 1024
                },
                p: {
                    x_min: 10,
                    x_max: 964,
                    y_min: -443,
                    y_max: 944,
                    ha: 1387,
                    leftSideBearing: 10,
                    advanceWidth: 1024
                },
                q: {
                    x_min: 49,
                    x_max: 999,
                    y_min: -443,
                    y_max: 942.0135137169275,
                    ha: 1385.0135137169275,
                    leftSideBearing: 49,
                    advanceWidth: 1024
                },
                r: {
                    x_min: 10,
                    x_max: 685,
                    y_min: 0,
                    y_max: 944,
                    ha: 944,
                    leftSideBearing: 10,
                    advanceWidth: 682
                },
                s: {
                    x_min: 104,
                    x_max: 713,
                    y_min: -20,
                    y_max: 942.0263161804552,
                    ha: 962.0263161804552,
                    leftSideBearing: 104,
                    advanceWidth: 797
                },
                t: {
                    x_min: 27,
                    x_max: 572,
                    y_min: -18,
                    y_max: 1186,
                    ha: 1204,
                    leftSideBearing: 27,
                    advanceWidth: 569
                },
                u: {
                    x_min: 18,
                    x_max: 981,
                    y_min: -21,
                    y_max: 921,
                    ha: 942,
                    leftSideBearing: 18,
                    advanceWidth: 1024
                },
                v: {
                    x_min: 39,
                    x_max: 976,
                    y_min: -28,
                    y_max: 921,
                    ha: 949,
                    leftSideBearing: 39,
                    advanceWidth: 1024
                },
                w: {
                    x_min: 43,
                    x_max: 1423,
                    y_min: -28,
                    y_max: 921,
                    ha: 949,
                    leftSideBearing: 43,
                    advanceWidth: 1479
                },
                x: {
                    x_min: 35,
                    x_max: 989,
                    y_min: 0,
                    y_max: 921,
                    ha: 921,
                    leftSideBearing: 35,
                    advanceWidth: 1024
                },
                y: {
                    x_min: 29,
                    x_max: 976,
                    y_min: -445,
                    y_max: 921,
                    ha: 1366,
                    leftSideBearing: 29,
                    advanceWidth: 1024
                },
                z: {
                    x_min: 55,
                    x_max: 855,
                    y_min: 0,
                    y_max: 921,
                    ha: 921,
                    leftSideBearing: 55,
                    advanceWidth: 909
                },
                "{": {
                    x_min: 205,
                    x_max: 717,
                    y_min: -377,
                    y_max: 1397,
                    ha: 1774,
                    leftSideBearing: 205,
                    advanceWidth: 983
                },
                "|": {
                    x_min: 137,
                    x_max: 273,
                    y_min: -512,
                    y_max: 1535,
                    ha: 2047,
                    leftSideBearing: 137,
                    advanceWidth: 410
                },
                "}": {
                    x_min: 266,
                    x_max: 778,
                    y_min: -377,
                    y_max: 1397,
                    ha: 1774,
                    leftSideBearing: 266,
                    advanceWidth: 983
                },
                "~": {
                    x_min: 82,
                    x_max: 1028,
                    y_min: 380,
                    y_max: 666,
                    ha: 286,
                    leftSideBearing: 82,
                    advanceWidth: 1108
                }
            },
            fontFamily: "serif",
            resolution: 2048,
            generatedOn: "2020-10-18T19:03:12.514Z"
        };
        class Yi {
            static sortAndUnique(t, e, i) {
                if (t.length > 1) {
                    const b = [];
                    let a;
                    t.sort(e);
                    for(let e = 0; e < t.length; ++e)0 !== e && i(t[e], a) || b.push(t[e]), a = t[e];
                    return b;
                }
                return t;
            }
            static contains(t, e) {
                let i = t.length;
                for(; i--;)if (t[i] === e) return !0;
                return !1;
            }
            static getCanvasContext(t) {
                if (!t) throw new g("BadArgument", "Invalid canvas selector: " + t);
                const e = document.getElementById(t);
                if (!e || !e.getContext) throw new g("UnsupportedBrowserError", "This browser does not support HTML5 Canvas");
                return e.getContext("2d");
            }
            static benchmark(t, e) {
                const i = (new Date).getTime();
                e();
                u(t, (new Date).getTime() - i + "ms");
            }
            static stackTrace() {
                return (new Error).stack;
            }
        }
        return Yi.Flow = ki, F.load("Bravura", Ai, Ni), F.load("Gonville", Mi, Ni), function() {
            const t = JSON.parse(JSON.stringify(Ni)), e = t.chordSymbol;
            e && (e.glyphs = Li), F.load("Petaluma", Ri, t);
        }(), F.load("Custom", Fi, Ni), F.load("Leland", Oi, Ni), ki.setMusicFont("Bravura", "Gonville", "Custom"), function() {
            {
                const t = Ii, { fontFamily: e, resolution: i, glyphs: b } = t;
                F.load(e, t);
                const a = "@";
                rt.registerInfo({
                    family: e,
                    resolution: i,
                    glyphs: b,
                    maxSizeGlyph: a,
                    monospaced: !1,
                    bold: !0,
                    italic: !1,
                    superscriptOffset: .66,
                    subscriptOffset: .66,
                    serifs: !1,
                    description: "Generic SANS font"
                });
            }
            {
                const t = Gi, { fontFamily: e, resolution: i, glyphs: b } = t;
                F.load(e, t);
                const a = "@";
                rt.registerInfo({
                    family: e,
                    resolution: i,
                    glyphs: b,
                    maxSizeGlyph: a,
                    monospaced: !1,
                    bold: !1,
                    italic: !1,
                    superscriptOffset: .66,
                    subscriptOffset: .66,
                    serifs: !1,
                    description: "Generic SANS font"
                });
            }
            {
                const t = Hi, { fontFamily: e, resolution: i, glyphs: b } = t;
                F.load(e, t);
                const a = "@";
                rt.registerInfo({
                    family: e,
                    resolution: i,
                    glyphs: b,
                    maxSizeGlyph: a,
                    monospaced: !1,
                    bold: !1,
                    italic: !1,
                    superscriptOffset: .66,
                    subscriptOffset: .66,
                    serifs: !0,
                    description: "Generic SERIF font"
                });
            }
            {
                const t = Ui, { fontFamily: e, resolution: i, glyphs: b } = t;
                F.load(e, t);
                const a = "b";
                rt.registerInfo({
                    family: e,
                    resolution: i,
                    glyphs: b,
                    maxSizeGlyph: a,
                    monospaced: !1,
                    bold: !1,
                    italic: !1,
                    superscriptOffset: .66,
                    subscriptOffset: .66,
                    serifs: !0,
                    description: "Text font to pair with the Bravura / Gonville music fonts."
                });
            }
            {
                const t = Wi, { fontFamily: e, resolution: i, glyphs: b } = t;
                F.load(e, t);
                const a = "b";
                rt.registerInfo({
                    family: e,
                    resolution: i,
                    glyphs: b,
                    maxSizeGlyph: a,
                    monospaced: !1,
                    bold: !1,
                    italic: !1,
                    superscriptOffset: .66,
                    subscriptOffset: .66,
                    serifs: !1,
                    description: "Text font to pair with the Petaluma music font."
                });
            }
        }(), e = e.default;
    })());


"use strict";
const $35bc4e367cd5ccd9$var$VF = $4d875ff260c22106$exports.Flow;
// Drawing basic score elements
// ============================
function $35bc4e367cd5ccd9$var$drawSlice(slice, staffType, scale, id_pfx, styles) {
    let div = $35bc4e367cd5ccd9$var$createSvgElt("g");
    let renderer = new $35bc4e367cd5ccd9$var$VF.Renderer(div, $35bc4e367cd5ccd9$var$VF.Renderer.Backends.SVG);
    //renderer.resize(500, 500);
    let ctx = renderer.getContext();
    let voices = [];
    let formatter = new $35bc4e367cd5ccd9$var$VF.Formatter();
    // renders the notes on one staff
    function renderNotes(notes, clef) {
        let voice = new $35bc4e367cd5ccd9$var$VF.Voice({
            num_beats: 1,
            beat_value: 4
        });
        if (notes.length > 0) {
            // generate notes using Vexflow
            let chord = new $35bc4e367cd5ccd9$var$VF.StaveNote({
                clef: clef,
                keys: notes.map($35bc4e367cd5ccd9$var$noteToVex),
                duration: "q"
            });
            // add IDs
            for(let i = 0; i < notes.length; i++)chord._noteHeads[i].attrs.id = notes[i].id;
            chord.attrs.id = `${id_pfx}slice${slice.id}-${clef}`;
            // add style attributes
            if (styles) for(let i = 0; i < notes.length; i++){
                let style = styles.noteStyles[notes[i].id];
                if (style) chord._noteHeads[i].attrs.class = style.classes;
            }
            chord.getStem().setVisibility(false);
            notes.forEach((n, i)=>$35bc4e367cd5ccd9$var$addAcc(i, chord, n.accs));
            voice.addTickables([
                chord
            ]);
            formatter.joinVoices([
                voice
            ]);
            voices.push({
                v: voice,
                c: clef
            });
        }
    }
    if (staffType == "grand") {
        let notesT = slice.notes.filter((n)=>n.oct >= 4);
        renderNotes(notesT, "treble");
        let notesB = slice.notes.filter((n)=>n.oct < 4);
        renderNotes(notesB, "bass");
    } else renderNotes(slice.notes, staffType);
    formatter.format(voices.map((v)=>v.v));
    let width = formatter.getMinTotalWidth();
    if (staffType == "grand") {
        let staveT = new $35bc4e367cd5ccd9$var$VF.Stave(0, 0, width);
        let staveB = new $35bc4e367cd5ccd9$var$VF.Stave(0, 70, width);
        voices.forEach((voice)=>voice.v.draw(ctx, voice.c == "treble" ? staveT : staveB));
    } else {
        let staff = new $35bc4e367cd5ccd9$var$VF.Stave(0, 0, width);
        voices.forEach((voice)=>voice.v.draw(ctx, staff));
    }
    // Vexflow draws notes with 17px x-offset, so to place the slice at the correct position,
    // its x coordinate must be corrected for this offset plus half of the width of the slice.
    let xcorrection = (width / 2 + 17 * scale).toFixed(3);
    div.setAttribute("transform", `translate(${-xcorrection} 0)`);
    return div;
}
function $35bc4e367cd5ccd9$var$drawStaff(width, staffType) {
    let div = document.createElement("div");
    let renderer = new $35bc4e367cd5ccd9$var$VF.Renderer(div, $35bc4e367cd5ccd9$var$VF.Renderer.Backends.SVG);
    let ctx = renderer.getContext();
    if (staffType == "grand") {
        let staveT = new $35bc4e367cd5ccd9$var$VF.Stave(0, 0, width).addClef("treble");
        staveT.setContext(ctx).draw();
        let staveB = new $35bc4e367cd5ccd9$var$VF.Stave(0, 70, width).addClef("bass");
        staveB.setContext(ctx).draw();
    } else {
        let stave = new $35bc4e367cd5ccd9$var$VF.Stave(0, 0, width).addClef(staffType);
        stave.setContext(ctx).draw();
    }
    let elt = div.children[0];
    elt.setAttribute("style", "overflow: visible;");
    return elt;
}
function $35bc4e367cd5ccd9$var$drawSystem(slices, totalWidth, scale, staffType, id_pfx, styles = null) {
    let container = $35bc4e367cd5ccd9$var$createSvgElt("g");
    // draw staff
    let staff = $35bc4e367cd5ccd9$var$createSvgElt("g");
    staff.setAttribute("transform", "scale(" + scale + " " + scale + ")");
    staff.appendChild($35bc4e367cd5ccd9$var$drawStaff(totalWidth / scale, staffType));
    // container.appendChild(staffG);
    // draw slices
    slices.forEach((slice)=>{
        if (slice.notes.length === 0) return;
        let sliceG = $35bc4e367cd5ccd9$var$createSvgElt("g");
        sliceG.setAttribute("transform", "translate(" + slice.x + " 0) scale(" + scale + " " + scale + ")");
        sliceG.setAttribute("id", "slice-" + slice.id);
        sliceG.appendChild($35bc4e367cd5ccd9$var$drawSlice(slice, staffType, scale, id_pfx, styles));
        // apply slice styles
        if (styles !== null) {
            let sliceStyle = styles.sliceStyles[slice.id];
            if (sliceStyle) {
                // console.log(sliceStyle);
                // console.log(sliceStyle.classes);
                // console.log(sliceStyle.label);
                // add classes:
                sliceG.setAttribute("class", "pv-slice " + sliceStyle.classes);
                // add label
                let label = $35bc4e367cd5ccd9$var$createSvgElt("text");
                label.setAttribute("y", 20);
                label.textContent = sliceStyle.label;
                label.setAttribute("text-anchor", "middle");
                label.setAttribute("dominant-baseline", "middle");
                label.setAttribute("class", "pv-label");
                sliceG.appendChild(label);
            }
        }
        container.appendChild(sliceG);
    });
    return {
        notes: container,
        staff: staff
    };
}
// Drawing a score
// ===============
function $35bc4e367cd5ccd9$var$drawScoreEdge(container, edge, passing) {
    // compute coordinates
    const bbleft = $35bc4e367cd5ccd9$var$getNoteBBox(edge.left.id, container);
    const bbright = $35bc4e367cd5ccd9$var$getNoteBBox(edge.right.id, container);
    let x1 = bbleft.x + bbleft.width + $35bc4e367cd5ccd9$var$markerWidth + 2;
    let y1 = bbleft.y + bbleft.height / 2;
    let x2 = bbright.x - $35bc4e367cd5ccd9$var$markerWidth - 2;
    let y2 = bbright.y + bbright.height / 2;
    // compute
    let line = $35bc4e367cd5ccd9$var$createSvgElt("line");
    line.setAttribute("x1", x1);
    line.setAttribute("y1", y1);
    line.setAttribute("x2", x2);
    line.setAttribute("y2", y2);
    let classes = "pv-score-edge";
    if (passing) {
        line.setAttribute("stroke-dasharray", "6,3");
        classes += " pv-passing";
    } else classes += " pv-regular";
    line.setAttribute("class", classes);
    return line;
}
const $35bc4e367cd5ccd9$export$6ede9d2876b0bad6 = (slices)=>(transitions)=>(staffType)=>(totalWidth)=>(scale)=>{
                    // draw system and notes
                    let system = $35bc4e367cd5ccd9$var$drawSystem(slices, totalWidth, scale, staffType, "score-");
                    let container = $35bc4e367cd5ccd9$var$createSvgElt("g");
                    container.appendChild(system.staff);
                    container.appendChild(system.notes);
                    // make sure that the container is attached to the DOM (required for computing bboxes)
                    let fakesvg = $35bc4e367cd5ccd9$var$createSvgElt("svg");
                    fakesvg.appendChild(container);
                    document.body.appendChild(fakesvg);
                    // draw edges
                    transitions.forEach((transition)=>{
                        let transElt = $35bc4e367cd5ccd9$var$createSvgElt("g");
                        transElt.setAttribute("id", `score-transition-${transition.id}`);
                        transElt.setAttribute("class", "pv-score-transition");
                        transition.regular.forEach((edge)=>{
                            transElt.appendChild($35bc4e367cd5ccd9$var$drawScoreEdge(container, edge, false));
                        });
                        transition.passing.forEach((edge)=>{
                            transElt.appendChild($35bc4e367cd5ccd9$var$drawScoreEdge(container, edge, true));
                        });
                        container.appendChild(transElt);
                    });
                    // remove container from DOM
                    fakesvg.remove();
                    container.remove();
                    return container;
                };
const $35bc4e367cd5ccd9$export$6bb651de1912795c = (el)=>(score)=>()=>el.replaceChildren(score);
// Drawing Derivations
// ===================
function $35bc4e367cd5ccd9$var$drawEdge(container, edge, selection, passing, edgeStyles, looseness = 1) {
    let line = $35bc4e367cd5ccd9$var$createSvgElt("path");
    line.setAttribute("fill", "none");
    // compute path
    const bbleft = $35bc4e367cd5ccd9$var$getNoteBBox(edge.left.id, container);
    const bbright = $35bc4e367cd5ccd9$var$getNoteBBox(edge.right.id, container);
    let x1 = bbleft.x + bbleft.width + $35bc4e367cd5ccd9$var$markerWidth + 2;
    let y1 = bbleft.y + bbleft.height / 2;
    let x2 = bbright.x - $35bc4e367cd5ccd9$var$markerWidth - 2;
    let y2 = bbright.y + bbright.height / 2;
    let dist = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    let d = dist * looseness * 0.3915; // from TikZ source
    // let line = createSvgElt("line");
    // line.setAttribute("x1", x1);
    // line.setAttribute("y1", y1);
    // line.setAttribute("x2", x2);
    // line.setAttribute("y2", y2);
    line.setAttribute("d", `M ${x1} ${y1} C ${x1 + d} ${y1}, ${x2 - d} ${y2}, ${x2} ${y2}`);
    // style edge
    let classes = "pv-edge";
    if (passing) {
        line.setAttribute("stroke-dasharray", "6,3");
        classes += " pv-passing";
    } else classes += " pv-regular";
    if (selection && (selection.note.id == edge.left.id || selection.note.id == edge.right.id)) classes += " pv-selected";
    let styleKey = JSON.stringify({
        left: edge.left.id,
        right: edge.right.id
    });
    let style = edgeStyles.get(styleKey);
    if (style) {
        classes += " " + style.classes;
        let label = $35bc4e367cd5ccd9$var$createSvgElt("title");
        label.setAttribute("class", "pv-label");
        label.textContent = style.label;
        line.appendChild(label);
    }
    line.setAttribute("class", classes);
    return line;
}
function $35bc4e367cd5ccd9$var$drawHori(hori, container) {
    let bbparent = $35bc4e367cd5ccd9$var$getBBox(container.querySelector("#vf-slice" + hori.parent + "-bass") || container.querySelector("#vf-slice" + hori.parent + "-treble"), false, container);
    let bbchild = $35bc4e367cd5ccd9$var$getBBox(container.querySelector("#vf-slice" + hori.child + "-treble") || container.querySelector("#vf-slice" + hori.child + "-bass"), false, container);
    let line = $35bc4e367cd5ccd9$var$createSvgElt("line");
    line.setAttribute("x1", bbparent.x + bbparent.width / 2);
    line.setAttribute("y1", bbparent.y + bbparent.height + 5);
    line.setAttribute("x2", bbchild.x + bbparent.width / 2);
    line.setAttribute("y2", bbchild.y - 5);
    line.setAttribute("stroke", "lightgray");
    // line.setAttribute("stroke-dasharray", "10,5");
    line.setAttribute("stroke-width", "5");
    return line;
}
function $35bc4e367cd5ccd9$var$drawMarker(noteid, expl, container, notemap) {
    const bbox = $35bc4e367cd5ccd9$var$getNoteBBox(noteid, container);
    const y = bbox.y + bbox.height / 2;
    let marker = $35bc4e367cd5ccd9$var$createSvgElt("g");
    marker.setAttribute("id", "marker-" + noteid);
    marker.setAttribute("class", "pv-op-marker");
    container.appendChild(marker);
    // const noteG = container.querySelector("#vf-" + CSS.escape(noteid));
    // noteG.appendChild(marker);
    // select markers based on ornament type (TODO)
    let left = "none";
    let right = "none";
    switch(expl.typ){
        case "Root":
            left = "root-left";
            right = "root-right";
            break;
        case "Hori":
            if (expl.parent) {
                if (notemap[expl.parent] > notemap[noteid]) right = "spread-right";
                else left = "spread-left";
            }
            break;
        case "RightRepeat":
            left = "repeat";
            break;
        case "RightNeighbor":
            left = "neighbor-left";
            break;
        case "LeftRepeat":
            right = "repeat";
            break;
        case "LeftNeighbor":
            right = "neighbor-right";
            break;
        case "FullNeighbor":
            left = "neighbor-left";
            right = "neighbor-right";
            break;
        case "FullRepeat":
            left = "repeat";
            right = "repeat";
            break;
        case "LeftRepeatOfRight":
            left = "neighbor-left";
            right = "repeat";
            break;
        case "RightRepeatOfLeft":
            left = "repeat";
            right = "neighbor-right";
            break;
        case "PassingMid":
            left = "pass";
            right = "pass";
            break;
        case "PassingLeft":
            left = "pass";
            break;
        case "PassingRight":
            right = "pass";
            break;
    }
    marker.innerHTML = `
    <use href="#marker-${left}" x="${bbox.x - $35bc4e367cd5ccd9$var$markerWidth - 1}" y="${y}"/>
    <use href="#marker-${right}" x="${bbox.x + bbox.width + 1}" y="${y}"/>
  `;
}
function $35bc4e367cd5ccd9$var$drawTimeLabel(time, y) {
    let label = $35bc4e367cd5ccd9$var$createSvgElt("text");
    label.setAttribute("x", time.x);
    label.setAttribute("y", y);
    label.setAttribute("text-anchor", "middle");
    label.setAttribute("dominant-baseline", "middle");
    label.textContent = time.label;
    return label;
}
const $35bc4e367cd5ccd9$export$37216315ed12ca69 = (graph)=>(totalWidth)=>(scale)=>(showScore)=>{
                // The graph is drawn in several steps:
                // - create a container element, add marker defs and CSS
                // - add a separator element to be able to sort element into foreground and background
                // - draw the staves and notes for each level
                // - add styles and optional callbacks to the notes
                // - draw the score at the bottom of the graph
                // - add horis, edges, and transitions
                // - add markers
                // - highlight selected notes
                // The last few steps compute bounding boxes so they require the previous
                // elements to be attached to the DOM, which is done temporarily.
                // initialize container
                let graphContainer = document.createElementNS("http://www.w3.org/2000/svg", "g");
                // add marker defs
                graphContainer.innerHTML = $35bc4e367cd5ccd9$var$markers;
                // add CSS
                let styleElt = $35bc4e367cd5ccd9$var$createSvgElt("style");
                let combinedStyles = $35bc4e367cd5ccd9$export$214b055320e0bf32 + "\n" + graph.styles.css + "\n" + $35bc4e367cd5ccd9$var$uiStyles;
                styleElt.innerHTML = combinedStyles;
                graphContainer.appendChild(styleElt);
                // add a foreground separator.
                // this later allows us to place obects in the foreground or background.
                let fg_sep = $35bc4e367cd5ccd9$var$createSvgElt("g");
                graphContainer.appendChild(fg_sep);
                // draw levels with slices
                // if top-level is only ⋊-⋉: start at level 1
                let minLevel = graph.slices.filter((s)=>s.depth == 0).length == 2 ? 1 : 0;
                let levelOffset = graph.styles.staffType == "grand" ? 150 : 80;
                for(let level = minLevel; level <= graph.maxd; level++){
                    let levelSlices = graph.slices.filter((s)=>s.depth == level);
                    let levelG = $35bc4e367cd5ccd9$var$drawSystem(levelSlices, totalWidth, scale, graph.styles.staffType, "", graph.styles);
                    let transform = `translate(0 ${(level - minLevel) * levelOffset})`;
                    levelG.notes.setAttribute("transform", transform);
                    levelG.staff.setAttribute("transform", transform + " " + levelG.staff.getAttribute("transform"));
                    graphContainer.appendChild(levelG.notes);
                    graphContainer.insertBefore(levelG.staff, fg_sep);
                }
                // add note callbacks and styles
                graph.slices.forEach((slice)=>{
                    slice.notes.forEach((note)=>{
                        let elt = graphContainer.querySelector("#vf-" + CSS.escape(note.id));
                        let classes = elt.getAttribute("class") + " pv-note";
                        if (graph.styles) {
                            let noteStyle = graph.styles.noteStyles[note.id];
                            if (noteStyle) {
                                classes += " " + noteStyle.classes;
                                let label = $35bc4e367cd5ccd9$var$createSvgElt("title");
                                label.setAttribute("class", "pv-label");
                                label.textContent = noteStyle.label;
                                elt.insertBefore(label, elt.firstChild);
                            }
                        }
                        if (graph.select) {
                            classes += " pv-selectable";
                            // this note already selected?
                            if (graph.selection && graph.selection.note.id == note.id) // yes -> deselect
                            elt.addEventListener("click", graph.select(null));
                            else // no -> select
                            elt.addEventListener("click", graph.select(note.sel));
                        }
                        elt.setAttribute("class", classes);
                    });
                });
                // draw score
                if (showScore) {
                    let score = $35bc4e367cd5ccd9$export$6ede9d2876b0bad6(graph.surfaceSlices)(graph.surfaceTransitions)(graph.styles.staffType)(totalWidth)(scale);
                    score.setAttribute("transform", `translate(0 ${(graph.maxd - minLevel + 1) * levelOffset})`);
                    graphContainer.appendChild(score);
                }
                // draw time labels
                let yoff = (graph.maxd - minLevel + (showScore ? 2 : 1)) * levelOffset + 20;
                graph.times.forEach((time)=>{
                    graphContainer.appendChild($35bc4e367cd5ccd9$var$drawTimeLabel(time, yoff));
                });
                // draw connections
                // prepare edge style dictionary
                let edgeStyles = new Map();
                graph.styles.edgeStyles.forEach(function(es) {
                    edgeStyles.set(JSON.stringify(es.edge), es.style);
                });
                // make sure that the container is attached to the DOM (required for computing bboxes)
                let fakesvg = $35bc4e367cd5ccd9$var$createSvgElt("svg");
                fakesvg.appendChild(graphContainer);
                document.body.appendChild(fakesvg);
                // render horis
                graph.horis.forEach((hori)=>{
                    graphContainer.insertBefore($35bc4e367cd5ccd9$var$drawHori(hori, graphContainer), fg_sep);
                });
                // render transitions and edges
                graph.transitions.forEach((transition)=>{
                    let transElt = $35bc4e367cd5ccd9$var$createSvgElt("g");
                    transElt.setAttribute("id", `transition-${transition.id}`);
                    let transStyle = graph.styles.transStyles[transition.id];
                    if (transStyle) {
                        transElt.setAttribute("class", "pv-trans " + transStyle.classes);
                        let label = $35bc4e367cd5ccd9$var$createSvgElt("title");
                        label.setAttribute("class", "pv-label");
                        label.textContent = transStyle.label;
                        transElt.appendChild(label);
                    }
                    transition.regular.forEach((edge)=>{
                        transElt.appendChild($35bc4e367cd5ccd9$var$drawEdge(graphContainer, edge, graph.selection, false, edgeStyles));
                    });
                    transition.passing.forEach((edge)=>{
                        transElt.appendChild($35bc4e367cd5ccd9$var$drawEdge(graphContainer, edge, graph.selection, true, edgeStyles));
                    });
                    graphContainer.insertBefore(transElt, fg_sep);
                });
                // collect all notes (needed for markers)
                let notemap = {};
                graph.slices.forEach((slice)=>{
                    slice.notes.forEach((note)=>{
                        notemap[note.id] = slice.x;
                    });
                });
                // render markers
                graph.slices.forEach((slice)=>{
                    slice.notes.forEach((note)=>{
                        $35bc4e367cd5ccd9$var$drawMarker(note.id, note.expl, graphContainer, notemap);
                    });
                });
                // mark seleted notes
                if (graph.selection) {
                    let note = graphContainer.querySelector("#vf-" + CSS.escape(graph.selection.note.id));
                    note.setAttribute("class", note.getAttribute("class") + " pv-selected");
                    graphContainer.querySelector("#marker-" + CSS.escape(graph.selection.note.id)).setAttribute("class", "pv-op-marker pv-selected");
                    graph.selection.parents.forEach((parent)=>{
                        let parentNode = graphContainer.querySelector("#vf-" + CSS.escape(parent.id));
                        parentNode.setAttribute("class", parentNode.getAttribute("class") + " pv-parent");
                    });
                }
                // remove container from DOM
                fakesvg.remove();
                graphContainer.remove();
                return graphContainer;
            };
// Constant definitions (markers, CSS, ...)
// ========================================
// size of a note-function marker
const $35bc4e367cd5ccd9$var$markerWidth = 5;
// const markerStroke = "black";
// symbols for markers
const $35bc4e367cd5ccd9$var$markers = `<defs>
  <symbol id="marker-repeat" width="${$35bc4e367cd5ccd9$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <line x1="0" y1="1.5" x2="${$35bc4e367cd5ccd9$var$markerWidth}" y2="1.5"/>
    <line x1="0" y1="-1.5" x2="${$35bc4e367cd5ccd9$var$markerWidth}" y2="-1.5"/>
  </symbol>
  <symbol id="marker-neighbor-left" width="${$35bc4e367cd5ccd9$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <line x1="0" y1="1.5" x2="${$35bc4e367cd5ccd9$var$markerWidth}" y2="-1.5"/>
  </symbol>
  <symbol id="marker-neighbor-right" width="${$35bc4e367cd5ccd9$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <line x1="0" y1="-1.5" x2="${$35bc4e367cd5ccd9$var$markerWidth}" y2="1.5"/>
  </symbol>
  <symbol id="marker-pass" width="${$35bc4e367cd5ccd9$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <line x1="0" y1="-1.5" x2="${$35bc4e367cd5ccd9$var$markerWidth}" y2="0"/>
    <line x1="0" y1="1.5" x2="${$35bc4e367cd5ccd9$var$markerWidth}" y2="0"/>
  </symbol>
  <symbol id="marker-spread-left" width="${$35bc4e367cd5ccd9$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <polyline points="1,-1.5 1,1.5 ${$35bc4e367cd5ccd9$var$markerWidth},1.5"/>
  </symbol>
  <symbol id="marker-spread-right" width="${$35bc4e367cd5ccd9$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <polyline points="0,1.5 ${$35bc4e367cd5ccd9$var$markerWidth - 1},1.5 ${$35bc4e367cd5ccd9$var$markerWidth - 1},-1.5"/>
  </symbol>
  <symbol id="marker-root-left" width="${$35bc4e367cd5ccd9$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <polygon points="1,0 ${$35bc4e367cd5ccd9$var$markerWidth},-1.5 ${$35bc4e367cd5ccd9$var$markerWidth},1.5 0,0"/>
  </symbol>
  <symbol id="marker-root-right" width="${$35bc4e367cd5ccd9$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <polygon points="0,1.5 0,-1.5 ${$35bc4e367cd5ccd9$var$markerWidth - 1},0 0,1.5"/>
  </symbol>
</defs>
<!--rect width="100%" height="100%" fill="white"/-->`;
const $35bc4e367cd5ccd9$export$214b055320e0bf32 = `
:root {
  stroke: black;
}
text {
  font-size: 16px;
  fill: black;
  stroke: none;
}
.pv-op-marker {
  stroke-width: 1.5;
  fill: none;
}

.visible { display: inline; }
.hidden { display: none; }
.strong { font-weight: bold; }
.emph { font-style: italic; }

:root {
  --cat1: #4C72B0;
  --cat2: #DD8452;
  --cat3: #55A868;
  --cat4: #C44E52;
  --cat5: #8172B3;
  --cat6: #937860;
  --cat7: #DA8BC3;
  --cat8: #8C8C8C;
  --cat9: #CCB974;
  --cat10: #64B5CD;
  --cat1b: #aec7e8;
  --cat2b: #ffbb78;
  --cat3b: #98df8a;
  --cat4b: #ff9896;
  --cat5b: #c5b0d5;
  --cat6b: #c49c94;
  --cat7b: #f7b6d2;
  --cat8b: #c7c7c7;
  --cat9b: #dbdb8d;
  --cat10b: #9edae5;
  --cat1c: #001C7F;
  --cat2c: #B1400D;
  --cat3c: #12711C;
  --cat4c: #8C0800;
  --cat5c: #591E71;
  --cat6c: #592F0D;
  --cat7c: #A23582;
  --cat8c: #3C3C3C;
  --cat9c: #B8850A;
  --cat10c: #006374;
}

.cat1, .cat1 svg { fill: #4C72B0; stroke: #4C72B0; }
.cat2, .cat2 svg { fill: #DD8452; stroke: #DD8452; }
.cat3, .cat3 svg { fill: #55A868; stroke: #55A868; }
.cat4, .cat4 svg { fill: #C44E52; stroke: #C44E52; }
.cat5, .cat5 svg { fill: #8172B3; stroke: #8172B3; }
.cat6, .cat6 svg { fill: #937860; stroke: #937860; }
.cat7, .cat7 svg { fill: #DA8BC3; stroke: #DA8BC3; }
.cat8, .cat8 svg { fill: #8C8C8C; stroke: #8C8C8C; }
.cat9, .cat9 svg { fill: #CCB974; stroke: #CCB974; }
.cat10, .cat10 svg { fill: #64B5CD; stroke: #64B5CD; }
.cat1b, .cat1b svg { fill: #aec7e8; stroke: #aec7e8; }
.cat2b, .cat2b svg { fill: #ffbb78; stroke: #ffbb78; }
.cat3b, .cat3b svg { fill: #98df8a; stroke: #98df8a; }
.cat4b, .cat4b svg { fill: #ff9896; stroke: #ff9896; }
.cat5b, .cat5b svg { fill: #c5b0d5; stroke: #c5b0d5; }
.cat6b, .cat6b svg { fill: #c49c94; stroke: #c49c94; }
.cat7b, .cat7b svg { fill: #f7b6d2; stroke: #f7b6d2; }
.cat8b, .cat8b svg { fill: #c7c7c7; stroke: #c7c7c7; }
.cat9b, .cat9b svg { fill: #dbdb8d; stroke: #dbdb8d; }
.cat10b, .cat10b svg { fill: #9edae5; stroke: #9edae5; }
.cat1c, .cat1c svg { fill: #001C7F; stroke: #001C7F; }
.cat2c, .cat2c svg { fill: #B1400D; stroke: #B1400D; }
.cat3c, .cat3c svg { fill: #12711C; stroke: #12711C; }
.cat4c, .cat4c svg { fill: #8C0800; stroke: #8C0800; }
.cat5c, .cat5c svg { fill: #591E71; stroke: #591E71; }
.cat6c, .cat6c svg { fill: #592F0D; stroke: #592F0D; }
.cat7c, .cat7c svg { fill: #A23582; stroke: #A23582; }
.cat8c, .cat8c svg { fill: #3C3C3C; stroke: #3C3C3C; }
.cat9c, .cat9c svg { fill: #B8850A; stroke: #B8850A; }
.cat10c, .cat10c svg { fill: #006374; stroke: #006374; }
`;
const $35bc4e367cd5ccd9$var$uiStyles = `
  .pv-edge.pv-selected, .pv-op-marker.pv-selected {
    stroke: rgb(30, 144, 255);
  }
  .vf-notehead.pv-selected {
    fill: rgb(30, 144, 255);
  }
  .vf-notehead.pv-parent {
    fill: rgb(135, 206, 250);
  }
  .pv-selectable {
    cursor: pointer;
  }
`;
// Helper Functions
// ================
let $35bc4e367cd5ccd9$var$createSvgElt = (name)=>document.createElementNS("http://www.w3.org/2000/svg", name);
// TODO: replace this with Accidental.applyAccidentals
function $35bc4e367cd5ccd9$var$addAcc(i, chord, n) {
    if (n > 0) chord.addModifier(new $35bc4e367cd5ccd9$var$VF.Accidental("#".repeat(n)), i);
    if (n < 0) chord.addModifier(new $35bc4e367cd5ccd9$var$VF.Accidental("b".repeat(-n)), i);
}
function $35bc4e367cd5ccd9$var$noteToVex(n) {
    return n.name + "/" + n.oct;
}
// gets the bounding box of a note relative to container
function $35bc4e367cd5ccd9$var$getNoteBBox(noteid, container) {
    let note = container.querySelector("#vf-" + CSS.escape(noteid));
    let notebb = $35bc4e367cd5ccd9$var$getBBox(note, false, container);
    let slicebb = $35bc4e367cd5ccd9$var$getBBox(note.parentElement, false, container);
    return {
        x: slicebb.x,
        y: notebb.y,
        width: slicebb.width,
        height: notebb.height
    };
}
/**
 * From https://gsap.com/community/forums/topic/13681-svg-gotchas/page/2/#comment-72060
 *
 * @param {SVGElement} element - Element to get the bounding box for
 * @param {boolean} [withoutTransforms=false] - If true, transforms will not be calculated
 * @param {SVGElement} [toElement] - Element to calculate bounding box relative to
 * @returns {SVGRect} Coordinates and dimensions of the real bounding box
 */ function $35bc4e367cd5ccd9$var$getBBox(element, withoutTransforms, toElement) {
    let svg = element.ownerSVGElement;
    if (!svg) return {
        x: 0,
        y: 0,
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    };
    let r = element.getBBox();
    if (withoutTransforms) return {
        x: r.x,
        y: r.y,
        width: r.width,
        height: r.height,
        cx: r.x + r.width / 2,
        cy: r.y + r.height / 2
    };
    let p = svg.createSVGPoint();
    let matrix = (toElement || svg).getScreenCTM().inverse().multiply(element.getScreenCTM());
    p.x = r.x;
    p.y = r.y;
    let a = p.matrixTransform(matrix);
    p.x = r.x + r.width;
    p.y = r.y;
    let b = p.matrixTransform(matrix);
    p.x = r.x + r.width;
    p.y = r.y + r.height;
    let c = p.matrixTransform(matrix);
    p.x = r.x;
    p.y = r.y + r.height;
    let d = p.matrixTransform(matrix);
    let minX = Math.min(a.x, b.x, c.x, d.x);
    let maxX = Math.max(a.x, b.x, c.x, d.x);
    let minY = Math.min(a.y, b.y, c.y, d.y);
    let maxY = Math.max(a.y, b.y, c.y, d.y);
    let width = maxX - minX;
    let height = maxY - minY;
    return {
        x: minX,
        y: minY,
        width: width,
        height: height,
        cx: minX + width / 2,
        cy: minY + height / 2
    };
}




















var $8b937fc9e68d0c00$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $8b937fc9e68d0c00$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($a393155e52307a24$export$fd19c21b7e75dff0);
var $8b937fc9e68d0c00$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($97ffb09cc3d11a32$export$1cd099438f719ac7);
var $8b937fc9e68d0c00$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($97ffb09cc3d11a32$export$e0728f9a6ccaeb32);
var $8b937fc9e68d0c00$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($97ffb09cc3d11a32$export$642f92ca6de37b54);
var $8b937fc9e68d0c00$var$spelledPitch = /* #__PURE__ */ $364547bd6bbe186e$export$c9a427c646d98c91($364547bd6bbe186e$export$306e929625906797)($364547bd6bbe186e$export$57bf37558439571a)($364547bd6bbe186e$export$698535b0a733192b);
var $8b937fc9e68d0c00$var$letter = /* #__PURE__ */ $364547bd6bbe186e$export$30780d0b6b610af8($8b937fc9e68d0c00$var$spelledPitch);
var $8b937fc9e68d0c00$var$octaves = /* #__PURE__ */ $364547bd6bbe186e$export$e82039437d8924cc($8b937fc9e68d0c00$var$spelledPitch);
var $8b937fc9e68d0c00$var$alteration = /* #__PURE__ */ $364547bd6bbe186e$export$29900f3432fee46c($8b937fc9e68d0c00$var$spelledPitch);
var $8b937fc9e68d0c00$var$sortWith = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde(/* #__PURE__ */ $6416bd93bb20ed95$export$cddf5df7d4d146c7($364547bd6bbe186e$export$aa156b69905f503));
var $8b937fc9e68d0c00$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $4773a7d69b2a3dfa$export$cd396f098c78c695($37b880af5f4991bd$export$e65788c6d4494539));
var $8b937fc9e68d0c00$var$reduce = /* #__PURE__ */ $4773a7d69b2a3dfa$export$533b26079ad0b4b($97937c29f879e68e$export$ff461bf68e7dd332)($b0cd729514c2504e$export$437776face1858ae);
var $8b937fc9e68d0c00$var$show3 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $8b937fc9e68d0c00$var$fromFoldable1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $8b937fc9e68d0c00$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $8b937fc9e68d0c00$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $8b937fc9e68d0c00$export$4b53bd9742c62456 = function(t) {
    var innerEdges = function(edges) {
        return $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($8b937fc9e68d0c00$var$map(function(edge) {
            if (edge.left instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be && edge.right instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                left: edge.left.value0,
                right: edge.right.value0
            });
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        })(edges));
    };
    return {
        regular: innerEdges($8b937fc9e68d0c00$var$fromFoldable(t.edges.regular)),
        passing: innerEdges(t.edges.passing),
        id: t.id
    };
};
var $8b937fc9e68d0c00$export$cceccdd693b130a7 = function(expl) {
    if (expl instanceof $97ffb09cc3d11a32$export$7a00a90b2dd67bbb) return {
        typ: "None",
        parent: $305519516124a7ff$export$7b1b591b262c240
    };
    if (expl instanceof $97ffb09cc3d11a32$export$2cf876164813516f) return {
        typ: "Root",
        parent: $305519516124a7ff$export$7b1b591b262c240
    };
    if (expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return {
        typ: "Hori",
        parent: $305519516124a7ff$export$9b7835891cf7097a(expl.value0.id)
    };
    if (expl instanceof $97ffb09cc3d11a32$export$a2bc3c1c57b6e07) return {
        typ: function() {
            if (expl.value0.orn instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "RightNone";
            if (expl.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $8b937fc9e68d0c00$var$show(expl.value0.orn.value0);
            throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 165, column 12 - line 167, column 25): " + [
                expl.value0.orn.constructor.name
            ]);
        }(),
        parent: $305519516124a7ff$export$7b1b591b262c240
    };
    if (expl instanceof $97ffb09cc3d11a32$export$a420550a5202c987) return {
        typ: function() {
            if (expl.value0.orn instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "LeftNone";
            if (expl.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $8b937fc9e68d0c00$var$show1(expl.value0.orn.value0);
            throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 171, column 12 - line 173, column 25): " + [
                expl.value0.orn.constructor.name
            ]);
        }(),
        parent: $305519516124a7ff$export$7b1b591b262c240
    };
    if (expl instanceof $97ffb09cc3d11a32$export$3301ca20023acaf7) return {
        typ: function() {
            if (expl.value0.orn instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "DoubleNone";
            if (expl.value0.orn instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $8b937fc9e68d0c00$var$show2(expl.value0.orn.value0);
            throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 177, column 12 - line 179, column 25): " + [
                expl.value0.orn.constructor.name
            ]);
        }(),
        parent: $305519516124a7ff$export$7b1b591b262c240
    };
    throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 160, column 26 - line 181, column 6): " + [
        expl.constructor.name
    ]);
};
var $8b937fc9e68d0c00$export$11e7f45e770eee85 = function(toX) {
    return function(slice) {
        var noteToVex = function(n) {
            return {
                id: n.note.id,
                name: $8b937fc9e68d0c00$var$letter(n.note.pitch),
                oct: $8b937fc9e68d0c00$var$octaves(n.note.pitch),
                accs: $8b937fc9e68d0c00$var$alteration(n.note.pitch),
                sel: n,
                expl: $8b937fc9e68d0c00$export$cceccdd693b130a7(n.expl)
            };
        };
        return {
            x: toX(slice.x),
            id: slice.id,
            notes: $8b937fc9e68d0c00$var$map(noteToVex)($8b937fc9e68d0c00$var$sortWith(function(v) {
                return v.note.pitch;
            })($97ffb09cc3d11a32$export$a45279548abf4fad(slice)))
        };
    };
};
var $8b937fc9e68d0c00$export$82663a99a7d2fb99 = function(graph) {
    return function(piece) {
        return function(surface) {
            return function(styles) {
                return function(selection) {
                    return function(selectCallback) {
                        return function(toX) {
                            var mkTime = function(i) {
                                return function(time) {
                                    var label = function() {
                                        if (time instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                                            var $47 = $8b937fc9e68d0c00$var$eq(time.value0.s)($8b937fc9e68d0c00$var$reduce(0)(1));
                                            if ($47) return $8b937fc9e68d0c00$var$show3(time.value0.m) + ("." + $8b937fc9e68d0c00$var$show3(time.value0.b));
                                            return "";
                                        }
                                        if (time instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return time.value0;
                                        throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 126, column 13 - line 128, column 22): " + [
                                            time.constructor.name
                                        ]);
                                    }();
                                    return {
                                        x: toX($4ab74a20512cef04$export$a0a81dc3380ce7d3(i + 1 | 0)),
                                        label: label
                                    };
                                };
                            };
                            var mkGraphSlice = function(s) {
                                var rs = $8b937fc9e68d0c00$export$11e7f45e770eee85(toX)(s.slice);
                                return {
                                    depth: s.depth,
                                    x: rs.x,
                                    id: rs.id,
                                    notes: rs.notes
                                };
                            };
                            return $35bc4e367cd5ccd9$export$37216315ed12ca69({
                                slices: $8b937fc9e68d0c00$var$fromFoldable1($8b937fc9e68d0c00$var$map1(mkGraphSlice)($ea3eb84de0acf574$export$68c286be0e7e55b7(graph.slices))),
                                surfaceSlices: $8b937fc9e68d0c00$var$map($8b937fc9e68d0c00$export$11e7f45e770eee85(toX))(surface.slices),
                                transitions: $8b937fc9e68d0c00$var$fromFoldable1($8b937fc9e68d0c00$var$map1($8b937fc9e68d0c00$export$4b53bd9742c62456)($ea3eb84de0acf574$export$68c286be0e7e55b7(graph.transitions))),
                                surfaceTransitions: $8b937fc9e68d0c00$var$map($8b937fc9e68d0c00$export$4b53bd9742c62456)(surface.transs),
                                horis: $8b937fc9e68d0c00$var$fromFoldable1(graph.horis),
                                times: $396c4c3d9e7fae3c$export$8f07ddce13659f50(mkTime)($8b937fc9e68d0c00$var$map(function(v) {
                                    return v.time;
                                })(piece)),
                                maxd: graph.maxd,
                                selection: function() {
                                    if (selection instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $305519516124a7ff$export$7b1b591b262c240;
                                    if (selection instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $305519516124a7ff$export$9b7835891cf7097a({
                                        note: selection.value0.note,
                                        parents: $97ffb09cc3d11a32$export$2bc046a6c710c5ed(selection.value0.expl)
                                    });
                                    throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 107, column 16 - line 109, column 75): " + [
                                        selection.constructor.name
                                    ]);
                                }(),
                                select: $0a5aaf95f168428e$export$b187f57ee1822bc5($8b937fc9e68d0c00$var$map2(function(v) {
                                    return function($57) {
                                        return v($0a5aaf95f168428e$export$1ba013b88f4f21f3($57));
                                    };
                                })(selectCallback)),
                                styles: $8912ce2c57a5c27a$export$e5ef535447be5f00(styles)
                            });
                        };
                    };
                };
            };
        };
    };
};
var $8b937fc9e68d0c00$export$b4230127bde29607 = function(slices) {
    return function(transitions) {
        return function(toX) {
            return function(staffType) {
                return $35bc4e367cd5ccd9$export$6ede9d2876b0bad6($8b937fc9e68d0c00$var$map($8b937fc9e68d0c00$export$11e7f45e770eee85(toX))(slices))($8b937fc9e68d0c00$var$map($8b937fc9e68d0c00$export$4b53bd9742c62456)(transitions))($97ffb09cc3d11a32$export$e4b11f91485c291e(staffType));
            };
        };
    };
};



// Generated by purs version 0.15.15


























// Generated by purs version 0.15.15









// Generated by purs version 0.15.15
var $08683fb67edb9127$export$dfed19fabc75a31d = /* #__PURE__ */ function() {
    function Min() {}
    Min.value = new Min();
    return Min;
}();
var $08683fb67edb9127$export$24938d6ce97fc9c5 = /* #__PURE__ */ function() {
    function Mid() {}
    Mid.value = new Mid();
    return Mid;
}();
var $08683fb67edb9127$export$d36c09e5d02927e7 = /* #__PURE__ */ function() {
    function Max() {}
    Max.value = new Max();
    return Max;
}();
var $08683fb67edb9127$export$b592e0ddebc089e0 = {
    show: function(v) {
        if (v instanceof $08683fb67edb9127$export$dfed19fabc75a31d) return "Min";
        if (v instanceof $08683fb67edb9127$export$24938d6ce97fc9c5) return "Mid";
        if (v instanceof $08683fb67edb9127$export$d36c09e5d02927e7) return "Max";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Align (line 16, column 10 - line 19, column 17): " + [
            v.constructor.name
        ]);
    }
};
var $08683fb67edb9127$export$bc7de53ed6c0db91 = function(v) {
    if (v instanceof $08683fb67edb9127$export$dfed19fabc75a31d) return "Min";
    if (v instanceof $08683fb67edb9127$export$24938d6ce97fc9c5) return "Mid";
    if (v instanceof $08683fb67edb9127$export$d36c09e5d02927e7) return "Max";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Align (line 22, column 14 - line 25, column 15): " + [
        v.constructor.name
    ]);
};
var $08683fb67edb9127$export$3a381f5380abf6d8 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $08683fb67edb9127$export$dfed19fabc75a31d && y instanceof $08683fb67edb9127$export$dfed19fabc75a31d) return true;
            if (x instanceof $08683fb67edb9127$export$24938d6ce97fc9c5 && y instanceof $08683fb67edb9127$export$24938d6ce97fc9c5) return true;
            if (x instanceof $08683fb67edb9127$export$d36c09e5d02927e7 && y instanceof $08683fb67edb9127$export$d36c09e5d02927e7) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15
var $08a5ce4820861c18$export$6cc2e70440926d44 = /* #__PURE__ */ function() {
    function Auto() {}
    Auto.value = new Auto();
    return Auto;
}();
var $08a5ce4820861c18$export$ad4c8226279aa283 = /* #__PURE__ */ function() {
    function UseScript() {}
    UseScript.value = new UseScript();
    return UseScript;
}();
var $08a5ce4820861c18$export$8be07216cfdd8a58 = /* #__PURE__ */ function() {
    function NoChange() {}
    NoChange.value = new NoChange();
    return NoChange;
}();
var $08a5ce4820861c18$export$236f0bb741e08c7a = /* #__PURE__ */ function() {
    function ResetSize() {}
    ResetSize.value = new ResetSize();
    return ResetSize;
}();
var $08a5ce4820861c18$export$f79e9ed37ee7d496 = /* #__PURE__ */ function() {
    function Ideographic() {}
    Ideographic.value = new Ideographic();
    return Ideographic;
}();
var $08a5ce4820861c18$export$9ec4347827b36f1b = /* #__PURE__ */ function() {
    function Alphabetic() {}
    Alphabetic.value = new Alphabetic();
    return Alphabetic;
}();
var $08a5ce4820861c18$export$41f4fc24efd41fb1 = /* #__PURE__ */ function() {
    function Hanging() {}
    Hanging.value = new Hanging();
    return Hanging;
}();
var $08a5ce4820861c18$export$50c061641fc82c12 = /* #__PURE__ */ function() {
    function Mathematical() {}
    Mathematical.value = new Mathematical();
    return Mathematical;
}();
var $08a5ce4820861c18$export$a5e5204595a00ea8 = /* #__PURE__ */ function() {
    function Central() {}
    Central.value = new Central();
    return Central;
}();
var $08a5ce4820861c18$export$89343b787b0d22af = /* #__PURE__ */ function() {
    function BaselineMiddle() {}
    BaselineMiddle.value = new BaselineMiddle();
    return BaselineMiddle;
}();
var $08a5ce4820861c18$export$5024efecc4b1d798 = /* #__PURE__ */ function() {
    function TextAfterEdge() {}
    TextAfterEdge.value = new TextAfterEdge();
    return TextAfterEdge;
}();
var $08a5ce4820861c18$export$6ced81462b173f09 = /* #__PURE__ */ function() {
    function TextBeforeEdge() {}
    TextBeforeEdge.value = new TextBeforeEdge();
    return TextBeforeEdge;
}();
var $08a5ce4820861c18$export$80ddac607b1d07d0 = {
    show: function(v) {
        if (v instanceof $08a5ce4820861c18$export$6cc2e70440926d44) return "Auto";
        if (v instanceof $08a5ce4820861c18$export$ad4c8226279aa283) return "UseScript";
        if (v instanceof $08a5ce4820861c18$export$8be07216cfdd8a58) return "NoChange";
        if (v instanceof $08a5ce4820861c18$export$236f0bb741e08c7a) return "ResetSize";
        if (v instanceof $08a5ce4820861c18$export$f79e9ed37ee7d496) return "Ideographic";
        if (v instanceof $08a5ce4820861c18$export$9ec4347827b36f1b) return "Alphabetic";
        if (v instanceof $08a5ce4820861c18$export$41f4fc24efd41fb1) return "Hanging";
        if (v instanceof $08a5ce4820861c18$export$50c061641fc82c12) return "Mathematical";
        if (v instanceof $08a5ce4820861c18$export$a5e5204595a00ea8) return "Central";
        if (v instanceof $08a5ce4820861c18$export$89343b787b0d22af) return "BaselineMiddle";
        if (v instanceof $08a5ce4820861c18$export$5024efecc4b1d798) return "TextAfterEdge";
        if (v instanceof $08a5ce4820861c18$export$6ced81462b173f09) return "TextBeforeEdge";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Baseline (line 25, column 10 - line 37, column 39): " + [
            v.constructor.name
        ]);
    }
};
var $08a5ce4820861c18$export$403c3905f8677763 = function(v) {
    if (v instanceof $08a5ce4820861c18$export$6cc2e70440926d44) return "auto";
    if (v instanceof $08a5ce4820861c18$export$ad4c8226279aa283) return "use-script";
    if (v instanceof $08a5ce4820861c18$export$8be07216cfdd8a58) return "no-change";
    if (v instanceof $08a5ce4820861c18$export$236f0bb741e08c7a) return "reset-size";
    if (v instanceof $08a5ce4820861c18$export$f79e9ed37ee7d496) return "ideographic";
    if (v instanceof $08a5ce4820861c18$export$9ec4347827b36f1b) return "alphabetic";
    if (v instanceof $08a5ce4820861c18$export$41f4fc24efd41fb1) return "hanging";
    if (v instanceof $08a5ce4820861c18$export$50c061641fc82c12) return "mathematical";
    if (v instanceof $08a5ce4820861c18$export$a5e5204595a00ea8) return "central";
    if (v instanceof $08a5ce4820861c18$export$89343b787b0d22af) return "middle";
    if (v instanceof $08a5ce4820861c18$export$5024efecc4b1d798) return "text-after-edge";
    if (v instanceof $08a5ce4820861c18$export$6ced81462b173f09) return "text-before-edge";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Baseline (line 40, column 17 - line 52, column 39): " + [
        v.constructor.name
    ]);
};
var $08a5ce4820861c18$export$31197bcbee8702af = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $08a5ce4820861c18$export$6cc2e70440926d44 && y instanceof $08a5ce4820861c18$export$6cc2e70440926d44) return true;
            if (x instanceof $08a5ce4820861c18$export$ad4c8226279aa283 && y instanceof $08a5ce4820861c18$export$ad4c8226279aa283) return true;
            if (x instanceof $08a5ce4820861c18$export$8be07216cfdd8a58 && y instanceof $08a5ce4820861c18$export$8be07216cfdd8a58) return true;
            if (x instanceof $08a5ce4820861c18$export$236f0bb741e08c7a && y instanceof $08a5ce4820861c18$export$236f0bb741e08c7a) return true;
            if (x instanceof $08a5ce4820861c18$export$f79e9ed37ee7d496 && y instanceof $08a5ce4820861c18$export$f79e9ed37ee7d496) return true;
            if (x instanceof $08a5ce4820861c18$export$9ec4347827b36f1b && y instanceof $08a5ce4820861c18$export$9ec4347827b36f1b) return true;
            if (x instanceof $08a5ce4820861c18$export$41f4fc24efd41fb1 && y instanceof $08a5ce4820861c18$export$41f4fc24efd41fb1) return true;
            if (x instanceof $08a5ce4820861c18$export$50c061641fc82c12 && y instanceof $08a5ce4820861c18$export$50c061641fc82c12) return true;
            if (x instanceof $08a5ce4820861c18$export$a5e5204595a00ea8 && y instanceof $08a5ce4820861c18$export$a5e5204595a00ea8) return true;
            if (x instanceof $08a5ce4820861c18$export$89343b787b0d22af && y instanceof $08a5ce4820861c18$export$89343b787b0d22af) return true;
            if (x instanceof $08a5ce4820861c18$export$5024efecc4b1d798 && y instanceof $08a5ce4820861c18$export$5024efecc4b1d798) return true;
            if (x instanceof $08a5ce4820861c18$export$6ced81462b173f09 && y instanceof $08a5ce4820861c18$export$6ced81462b173f09) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15

var $f787d43f06ed5daa$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $f787d43f06ed5daa$export$540c29b953fd57b = /* #__PURE__ */ function() {
    function Cm(value0) {
        this.value0 = value0;
    }
    Cm.create = function(value0) {
        return new Cm(value0);
    };
    return Cm;
}();
var $f787d43f06ed5daa$export$591dfb93dc8c3436 = /* #__PURE__ */ function() {
    function Mm(value0) {
        this.value0 = value0;
    }
    Mm.create = function(value0) {
        return new Mm(value0);
    };
    return Mm;
}();
var $f787d43f06ed5daa$export$3654020ca42101 = /* #__PURE__ */ function() {
    function Inches(value0) {
        this.value0 = value0;
    }
    Inches.create = function(value0) {
        return new Inches(value0);
    };
    return Inches;
}();
var $f787d43f06ed5daa$export$f1c8ff7305c3a8b7 = /* #__PURE__ */ function() {
    function Px(value0) {
        this.value0 = value0;
    }
    Px.create = function(value0) {
        return new Px(value0);
    };
    return Px;
}();
var $f787d43f06ed5daa$export$87c2e215ad25c73d = /* #__PURE__ */ function() {
    function Pt(value0) {
        this.value0 = value0;
    }
    Pt.create = function(value0) {
        return new Pt(value0);
    };
    return Pt;
}();
var $f787d43f06ed5daa$export$cbeae159249b884e = /* #__PURE__ */ function() {
    function Pc(value0) {
        this.value0 = value0;
    }
    Pc.create = function(value0) {
        return new Pc(value0);
    };
    return Pc;
}();
var $f787d43f06ed5daa$export$e7bdca014c19fc5c = /* #__PURE__ */ function() {
    function Em(value0) {
        this.value0 = value0;
    }
    Em.create = function(value0) {
        return new Em(value0);
    };
    return Em;
}();
var $f787d43f06ed5daa$export$85112072770fc0ce = /* #__PURE__ */ function() {
    function Ex(value0) {
        this.value0 = value0;
    }
    Ex.create = function(value0) {
        return new Ex(value0);
    };
    return Ex;
}();
var $f787d43f06ed5daa$export$2399fd2ca7fdcd8e = /* #__PURE__ */ function() {
    function Rem(value0) {
        this.value0 = value0;
    }
    Rem.create = function(value0) {
        return new Rem(value0);
    };
    return Rem;
}();
var $f787d43f06ed5daa$export$661281f9d6ac3c03 = /* #__PURE__ */ function() {
    function Vw(value0) {
        this.value0 = value0;
    }
    Vw.create = function(value0) {
        return new Vw(value0);
    };
    return Vw;
}();
var $f787d43f06ed5daa$export$81eb3b81d17ebff1 = /* #__PURE__ */ function() {
    function Vh(value0) {
        this.value0 = value0;
    }
    Vh.create = function(value0) {
        return new Vh(value0);
    };
    return Vh;
}();
var $f787d43f06ed5daa$export$e5c94c2c1710ed87 = /* #__PURE__ */ function() {
    function Vmin(value0) {
        this.value0 = value0;
    }
    Vmin.create = function(value0) {
        return new Vmin(value0);
    };
    return Vmin;
}();
var $f787d43f06ed5daa$export$e6e92a3ac54f8130 = /* #__PURE__ */ function() {
    function Vmax(value0) {
        this.value0 = value0;
    }
    Vmax.create = function(value0) {
        return new Vmax(value0);
    };
    return Vmax;
}();
var $f787d43f06ed5daa$export$4d6f616347311885 = /* #__PURE__ */ function() {
    function Pct(value0) {
        this.value0 = value0;
    }
    Pct.create = function(value0) {
        return new Pct(value0);
    };
    return Pct;
}();
var $f787d43f06ed5daa$export$170c5965b6d52d5a = /* #__PURE__ */ function() {
    function NoCSSLength() {}
    NoCSSLength.value = new NoCSSLength();
    return NoCSSLength;
}();
var $f787d43f06ed5daa$export$6cac7543b70ef10 = {
    show: function(v) {
        if (v instanceof $f787d43f06ed5daa$export$540c29b953fd57b) return "(Cm " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$591dfb93dc8c3436) return "(Mm " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$3654020ca42101) return "(Inches " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$f1c8ff7305c3a8b7) return "(Px " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$87c2e215ad25c73d) return "(Pt " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$cbeae159249b884e) return "(Pc " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$e7bdca014c19fc5c) return "(Em " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$85112072770fc0ce) return "(Ex " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$2399fd2ca7fdcd8e) return "(Rem " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$661281f9d6ac3c03) return "(Vw " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$81eb3b81d17ebff1) return "(Vh " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$e5c94c2c1710ed87) return "(Vmin " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$e6e92a3ac54f8130) return "(Vmax " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$4d6f616347311885) return "(Pct " + ($f787d43f06ed5daa$var$show(v.value0) + ")");
        if (v instanceof $f787d43f06ed5daa$export$170c5965b6d52d5a) return "NoCSSLength";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.CSSLength (line 28, column 10 - line 43, column 33): " + [
            v.constructor.name
        ]);
    }
};
var $f787d43f06ed5daa$export$dd042b7bf607f9c8 = function(v) {
    if (v instanceof $f787d43f06ed5daa$export$540c29b953fd57b) return $f787d43f06ed5daa$var$show(v.value0) + "cm";
    if (v instanceof $f787d43f06ed5daa$export$591dfb93dc8c3436) return $f787d43f06ed5daa$var$show(v.value0) + "mm";
    if (v instanceof $f787d43f06ed5daa$export$3654020ca42101) return $f787d43f06ed5daa$var$show(v.value0) + "in";
    if (v instanceof $f787d43f06ed5daa$export$f1c8ff7305c3a8b7) return $f787d43f06ed5daa$var$show(v.value0) + "px";
    if (v instanceof $f787d43f06ed5daa$export$87c2e215ad25c73d) return $f787d43f06ed5daa$var$show(v.value0) + "pt";
    if (v instanceof $f787d43f06ed5daa$export$cbeae159249b884e) return $f787d43f06ed5daa$var$show(v.value0) + "pc";
    if (v instanceof $f787d43f06ed5daa$export$e7bdca014c19fc5c) return $f787d43f06ed5daa$var$show(v.value0) + "em";
    if (v instanceof $f787d43f06ed5daa$export$85112072770fc0ce) return $f787d43f06ed5daa$var$show(v.value0) + "ex";
    if (v instanceof $f787d43f06ed5daa$export$2399fd2ca7fdcd8e) return $f787d43f06ed5daa$var$show(v.value0) + "rem";
    if (v instanceof $f787d43f06ed5daa$export$661281f9d6ac3c03) return $f787d43f06ed5daa$var$show(v.value0) + "vw";
    if (v instanceof $f787d43f06ed5daa$export$81eb3b81d17ebff1) return $f787d43f06ed5daa$var$show(v.value0) + "vh";
    if (v instanceof $f787d43f06ed5daa$export$e5c94c2c1710ed87) return $f787d43f06ed5daa$var$show(v.value0) + "vmin";
    if (v instanceof $f787d43f06ed5daa$export$e6e92a3ac54f8130) return $f787d43f06ed5daa$var$show(v.value0) + "vmax";
    if (v instanceof $f787d43f06ed5daa$export$4d6f616347311885) return $f787d43f06ed5daa$var$show(v.value0) + "%";
    if (v instanceof $f787d43f06ed5daa$export$170c5965b6d52d5a) return "0";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.CSSLength (line 46, column 18 - line 61, column 21): " + [
        v.constructor.name
    ]);
};
var $f787d43f06ed5daa$export$2916cc7a54e17b61 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $f787d43f06ed5daa$export$540c29b953fd57b && y instanceof $f787d43f06ed5daa$export$540c29b953fd57b) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$591dfb93dc8c3436 && y instanceof $f787d43f06ed5daa$export$591dfb93dc8c3436) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$3654020ca42101 && y instanceof $f787d43f06ed5daa$export$3654020ca42101) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$f1c8ff7305c3a8b7 && y instanceof $f787d43f06ed5daa$export$f1c8ff7305c3a8b7) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$87c2e215ad25c73d && y instanceof $f787d43f06ed5daa$export$87c2e215ad25c73d) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$cbeae159249b884e && y instanceof $f787d43f06ed5daa$export$cbeae159249b884e) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$e7bdca014c19fc5c && y instanceof $f787d43f06ed5daa$export$e7bdca014c19fc5c) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$85112072770fc0ce && y instanceof $f787d43f06ed5daa$export$85112072770fc0ce) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$2399fd2ca7fdcd8e && y instanceof $f787d43f06ed5daa$export$2399fd2ca7fdcd8e) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$661281f9d6ac3c03 && y instanceof $f787d43f06ed5daa$export$661281f9d6ac3c03) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$81eb3b81d17ebff1 && y instanceof $f787d43f06ed5daa$export$81eb3b81d17ebff1) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$e5c94c2c1710ed87 && y instanceof $f787d43f06ed5daa$export$e5c94c2c1710ed87) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$e6e92a3ac54f8130 && y instanceof $f787d43f06ed5daa$export$e6e92a3ac54f8130) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$4d6f616347311885 && y instanceof $f787d43f06ed5daa$export$4d6f616347311885) return x.value0 === y.value0;
            if (x instanceof $f787d43f06ed5daa$export$170c5965b6d52d5a && y instanceof $f787d43f06ed5daa$export$170c5965b6d52d5a) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15

var $ac780a544b82ad4e$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $ac780a544b82ad4e$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $ac780a544b82ad4e$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $ac780a544b82ad4e$export$8f9ece5a47764b93 = /* #__PURE__ */ function() {
    function RGB(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RGB.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RGB(value0, value1, value2);
            };
        };
    };
    return RGB;
}();
var $ac780a544b82ad4e$export$f50470518fe8f14a = /* #__PURE__ */ function() {
    function RGBA(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    RGBA.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new RGBA(value0, value1, value2, value3);
                };
            };
        };
    };
    return RGBA;
}();
var $ac780a544b82ad4e$export$4e021928efe6b6bd = /* #__PURE__ */ function() {
    function Named(value0) {
        this.value0 = value0;
    }
    Named.create = function(value0) {
        return new Named(value0);
    };
    return Named;
}();
var $ac780a544b82ad4e$export$63f9a2e080cecd54 = /* #__PURE__ */ function() {
    function NoColor() {}
    NoColor.value = new NoColor();
    return NoColor;
}();
var $ac780a544b82ad4e$export$7a8e91222b78fe67 = {
    show: function(v) {
        if (v instanceof $ac780a544b82ad4e$export$8f9ece5a47764b93) return "(RGB " + ($ac780a544b82ad4e$var$show(v.value0) + (" " + ($ac780a544b82ad4e$var$show(v.value1) + (" " + ($ac780a544b82ad4e$var$show(v.value2) + ")")))));
        if (v instanceof $ac780a544b82ad4e$export$f50470518fe8f14a) return "(RGBA " + ($ac780a544b82ad4e$var$show(v.value0) + (" " + ($ac780a544b82ad4e$var$show(v.value1) + (" " + ($ac780a544b82ad4e$var$show(v.value2) + (" " + ($ac780a544b82ad4e$var$show1(v.value3) + ")")))))));
        if (v instanceof $ac780a544b82ad4e$export$4e021928efe6b6bd) return "(Named " + ($ac780a544b82ad4e$var$show2(v.value0) + ")");
        if (v instanceof $ac780a544b82ad4e$export$63f9a2e080cecd54) return "NoColor";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Color (line 17, column 10 - line 21, column 25): " + [
            v.constructor.name
        ]);
    }
};
var $ac780a544b82ad4e$export$a0e068db0973e7c3 = function(v) {
    if (v instanceof $ac780a544b82ad4e$export$8f9ece5a47764b93) return "rgb(" + ($ac780a544b82ad4e$var$show(v.value0) + ("," + ($ac780a544b82ad4e$var$show(v.value1) + ("," + ($ac780a544b82ad4e$var$show(v.value2) + ")")))));
    if (v instanceof $ac780a544b82ad4e$export$f50470518fe8f14a) return "rgba(" + ($ac780a544b82ad4e$var$show(v.value0) + ("," + ($ac780a544b82ad4e$var$show(v.value1) + ("," + ($ac780a544b82ad4e$var$show(v.value2) + ("," + ($ac780a544b82ad4e$var$show1(v.value3) + ")")))))));
    if (v instanceof $ac780a544b82ad4e$export$4e021928efe6b6bd) return v.value0;
    if (v instanceof $ac780a544b82ad4e$export$63f9a2e080cecd54) return "None";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Color (line 24, column 14 - line 28, column 20): " + [
        v.constructor.name
    ]);
};
var $ac780a544b82ad4e$export$ff79c16fae3768cd = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ac780a544b82ad4e$export$8f9ece5a47764b93 && y instanceof $ac780a544b82ad4e$export$8f9ece5a47764b93) return x.value0 === y.value0 && x.value1 === y.value1 && x.value2 === y.value2;
            if (x instanceof $ac780a544b82ad4e$export$f50470518fe8f14a && y instanceof $ac780a544b82ad4e$export$f50470518fe8f14a) return x.value0 === y.value0 && x.value1 === y.value1 && x.value2 === y.value2 && x.value3 === y.value3;
            if (x instanceof $ac780a544b82ad4e$export$4e021928efe6b6bd && y instanceof $ac780a544b82ad4e$export$4e021928efe6b6bd) return x.value0 === y.value0;
            if (x instanceof $ac780a544b82ad4e$export$63f9a2e080cecd54 && y instanceof $ac780a544b82ad4e$export$63f9a2e080cecd54) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15

var $1bec9d9a38450a4f$export$1ea66e9af4dd7af2 = /* #__PURE__ */ function() {
    return {
        hours: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        minutes: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        seconds: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        milliseconds: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
}();


// Generated by purs version 0.15.15
var $6d1e2287b2811d4e$export$f0826af67a39ec5d = /* #__PURE__ */ function() {
    function Freeze() {}
    Freeze.value = new Freeze();
    return Freeze;
}();
var $6d1e2287b2811d4e$export$6072865765515195 = /* #__PURE__ */ function() {
    function Remove() {}
    Remove.value = new Remove();
    return Remove;
}();
var $6d1e2287b2811d4e$export$5bc6b076ab2569bf = {
    show: function(v) {
        if (v instanceof $6d1e2287b2811d4e$export$f0826af67a39ec5d) return "Freeze";
        if (v instanceof $6d1e2287b2811d4e$export$6072865765515195) return "Remove";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.FillState (line 15, column 10 - line 17, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $6d1e2287b2811d4e$export$c3ff95b0c9f9a151 = function(v) {
    if (v instanceof $6d1e2287b2811d4e$export$f0826af67a39ec5d) return "freeze";
    if (v instanceof $6d1e2287b2811d4e$export$6072865765515195) return "remove";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.FillState (line 20, column 18 - line 22, column 21): " + [
        v.constructor.name
    ]);
};
var $6d1e2287b2811d4e$export$b8d96fd14d199618 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $6d1e2287b2811d4e$export$f0826af67a39ec5d && y instanceof $6d1e2287b2811d4e$export$f0826af67a39ec5d) return true;
            if (x instanceof $6d1e2287b2811d4e$export$6072865765515195 && y instanceof $6d1e2287b2811d4e$export$6072865765515195) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15


var $ae4a437c7407126d$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($f787d43f06ed5daa$export$2916cc7a54e17b61);
var $ae4a437c7407126d$export$8f9be94a7b1bfdd4 = /* #__PURE__ */ function() {
    function XXSmall() {}
    XXSmall.value = new XXSmall();
    return XXSmall;
}();
var $ae4a437c7407126d$export$5c1d76d31fc7fde2 = /* #__PURE__ */ function() {
    function XSmall() {}
    XSmall.value = new XSmall();
    return XSmall;
}();
var $ae4a437c7407126d$export$148e312beb132853 = /* #__PURE__ */ function() {
    function Small() {}
    Small.value = new Small();
    return Small;
}();
var $ae4a437c7407126d$export$c7835fd8b8ca1d68 = /* #__PURE__ */ function() {
    function Medium() {}
    Medium.value = new Medium();
    return Medium;
}();
var $ae4a437c7407126d$export$be4ab1d2d0958286 = /* #__PURE__ */ function() {
    function Large() {}
    Large.value = new Large();
    return Large;
}();
var $ae4a437c7407126d$export$df695a6f438a83ad = /* #__PURE__ */ function() {
    function XLarge() {}
    XLarge.value = new XLarge();
    return XLarge;
}();
var $ae4a437c7407126d$export$c02abbd7ca479fdf = /* #__PURE__ */ function() {
    function XXLarge() {}
    XXLarge.value = new XXLarge();
    return XXLarge;
}();
var $ae4a437c7407126d$export$965df4d3fd4d5de4 = /* #__PURE__ */ function() {
    function Smaller() {}
    Smaller.value = new Smaller();
    return Smaller;
}();
var $ae4a437c7407126d$export$b48f8a23286adea = /* #__PURE__ */ function() {
    function Larger() {}
    Larger.value = new Larger();
    return Larger;
}();
var $ae4a437c7407126d$export$a721ad7a4ed038c4 = /* #__PURE__ */ function() {
    function FontSizeLength(value0) {
        this.value0 = value0;
    }
    FontSizeLength.create = function(value0) {
        return new FontSizeLength(value0);
    };
    return FontSizeLength;
}();
var $ae4a437c7407126d$export$36c4475b32acb765 = {
    show: function(v) {
        if (v instanceof $ae4a437c7407126d$export$8f9be94a7b1bfdd4) return "XXSmall";
        if (v instanceof $ae4a437c7407126d$export$5c1d76d31fc7fde2) return "XSmall";
        if (v instanceof $ae4a437c7407126d$export$148e312beb132853) return "Small";
        if (v instanceof $ae4a437c7407126d$export$c7835fd8b8ca1d68) return "Medium";
        if (v instanceof $ae4a437c7407126d$export$be4ab1d2d0958286) return "Large";
        if (v instanceof $ae4a437c7407126d$export$df695a6f438a83ad) return "XLarge";
        if (v instanceof $ae4a437c7407126d$export$c02abbd7ca479fdf) return "XXLarge";
        if (v instanceof $ae4a437c7407126d$export$965df4d3fd4d5de4) return "Smaller";
        if (v instanceof $ae4a437c7407126d$export$b48f8a23286adea) return "Larger";
        if (v instanceof $ae4a437c7407126d$export$a721ad7a4ed038c4) return "(FontSizeLength " + ($f787d43f06ed5daa$export$dd042b7bf607f9c8(v.value0) + ")");
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontSize (line 24, column 10 - line 34, column 70): " + [
            v.constructor.name
        ]);
    }
};
var $ae4a437c7407126d$export$8d4b901b5d5c20e9 = function(v) {
    if (v instanceof $ae4a437c7407126d$export$8f9be94a7b1bfdd4) return "xx-small";
    if (v instanceof $ae4a437c7407126d$export$5c1d76d31fc7fde2) return "x-small";
    if (v instanceof $ae4a437c7407126d$export$148e312beb132853) return "small";
    if (v instanceof $ae4a437c7407126d$export$c7835fd8b8ca1d68) return "medium";
    if (v instanceof $ae4a437c7407126d$export$be4ab1d2d0958286) return "large";
    if (v instanceof $ae4a437c7407126d$export$df695a6f438a83ad) return "x-large";
    if (v instanceof $ae4a437c7407126d$export$c02abbd7ca479fdf) return "xx-large";
    if (v instanceof $ae4a437c7407126d$export$965df4d3fd4d5de4) return "smaller";
    if (v instanceof $ae4a437c7407126d$export$b48f8a23286adea) return "larger";
    if (v instanceof $ae4a437c7407126d$export$a721ad7a4ed038c4) return $f787d43f06ed5daa$export$dd042b7bf607f9c8(v.value0);
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontSize (line 37, column 17 - line 47, column 39): " + [
        v.constructor.name
    ]);
};
var $ae4a437c7407126d$export$5f976d747c6c8294 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ae4a437c7407126d$export$8f9be94a7b1bfdd4 && y instanceof $ae4a437c7407126d$export$8f9be94a7b1bfdd4) return true;
            if (x instanceof $ae4a437c7407126d$export$5c1d76d31fc7fde2 && y instanceof $ae4a437c7407126d$export$5c1d76d31fc7fde2) return true;
            if (x instanceof $ae4a437c7407126d$export$148e312beb132853 && y instanceof $ae4a437c7407126d$export$148e312beb132853) return true;
            if (x instanceof $ae4a437c7407126d$export$c7835fd8b8ca1d68 && y instanceof $ae4a437c7407126d$export$c7835fd8b8ca1d68) return true;
            if (x instanceof $ae4a437c7407126d$export$be4ab1d2d0958286 && y instanceof $ae4a437c7407126d$export$be4ab1d2d0958286) return true;
            if (x instanceof $ae4a437c7407126d$export$df695a6f438a83ad && y instanceof $ae4a437c7407126d$export$df695a6f438a83ad) return true;
            if (x instanceof $ae4a437c7407126d$export$c02abbd7ca479fdf && y instanceof $ae4a437c7407126d$export$c02abbd7ca479fdf) return true;
            if (x instanceof $ae4a437c7407126d$export$965df4d3fd4d5de4 && y instanceof $ae4a437c7407126d$export$965df4d3fd4d5de4) return true;
            if (x instanceof $ae4a437c7407126d$export$b48f8a23286adea && y instanceof $ae4a437c7407126d$export$b48f8a23286adea) return true;
            if (x instanceof $ae4a437c7407126d$export$a721ad7a4ed038c4 && y instanceof $ae4a437c7407126d$export$a721ad7a4ed038c4) return $ae4a437c7407126d$var$eq(x.value0)(y.value0);
            return false;
        };
    }
};


// Generated by purs version 0.15.15

var $2c364a591bf2eb0c$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $2c364a591bf2eb0c$export$653cd7d022bac561 = /* #__PURE__ */ function() {
    function StretchNormal() {}
    StretchNormal.value = new StretchNormal();
    return StretchNormal;
}();
var $2c364a591bf2eb0c$export$f8ba3d887f8e479c = /* #__PURE__ */ function() {
    function StretchUltraCondensed() {}
    StretchUltraCondensed.value = new StretchUltraCondensed();
    return StretchUltraCondensed;
}();
var $2c364a591bf2eb0c$export$682f83c1ed3dd38f = /* #__PURE__ */ function() {
    function StretchExtraCondensed() {}
    StretchExtraCondensed.value = new StretchExtraCondensed();
    return StretchExtraCondensed;
}();
var $2c364a591bf2eb0c$export$d242576776a98f48 = /* #__PURE__ */ function() {
    function StretchCondensed() {}
    StretchCondensed.value = new StretchCondensed();
    return StretchCondensed;
}();
var $2c364a591bf2eb0c$export$28eb5f1a86fa202c = /* #__PURE__ */ function() {
    function StretchSemiCondensed() {}
    StretchSemiCondensed.value = new StretchSemiCondensed();
    return StretchSemiCondensed;
}();
var $2c364a591bf2eb0c$export$cc7e14c73620ff89 = /* #__PURE__ */ function() {
    function StretchSemiExpanded() {}
    StretchSemiExpanded.value = new StretchSemiExpanded();
    return StretchSemiExpanded;
}();
var $2c364a591bf2eb0c$export$4b0bade633ccbd2c = /* #__PURE__ */ function() {
    function StretchExpanded() {}
    StretchExpanded.value = new StretchExpanded();
    return StretchExpanded;
}();
var $2c364a591bf2eb0c$export$a7968e1ecfd40d32 = /* #__PURE__ */ function() {
    function StretchExtraExpanded() {}
    StretchExtraExpanded.value = new StretchExtraExpanded();
    return StretchExtraExpanded;
}();
var $2c364a591bf2eb0c$export$16a6ce887682d532 = /* #__PURE__ */ function() {
    function StretchUltraExpanded() {}
    StretchUltraExpanded.value = new StretchUltraExpanded();
    return StretchUltraExpanded;
}();
var $2c364a591bf2eb0c$export$ce2ec178f30f3ee6 = /* #__PURE__ */ function() {
    function StretchPercent(value0) {
        this.value0 = value0;
    }
    StretchPercent.create = function(value0) {
        return new StretchPercent(value0);
    };
    return StretchPercent;
}();
var $2c364a591bf2eb0c$export$96bfd154fc0a52d7 = {
    show: function(v) {
        if (v instanceof $2c364a591bf2eb0c$export$653cd7d022bac561) return "StretchNormal";
        if (v instanceof $2c364a591bf2eb0c$export$f8ba3d887f8e479c) return "StretchUltraCondensed";
        if (v instanceof $2c364a591bf2eb0c$export$682f83c1ed3dd38f) return "StretchExtraCondensed";
        if (v instanceof $2c364a591bf2eb0c$export$d242576776a98f48) return "StretchCondensed";
        if (v instanceof $2c364a591bf2eb0c$export$28eb5f1a86fa202c) return "StretchSemiCondensed";
        if (v instanceof $2c364a591bf2eb0c$export$cc7e14c73620ff89) return "StretchSemiExpanded";
        if (v instanceof $2c364a591bf2eb0c$export$4b0bade633ccbd2c) return "StretchExpanded";
        if (v instanceof $2c364a591bf2eb0c$export$a7968e1ecfd40d32) return "StretchExtraExpanded";
        if (v instanceof $2c364a591bf2eb0c$export$16a6ce887682d532) return "StretchUltraExpanded";
        if (v instanceof $2c364a591bf2eb0c$export$ce2ec178f30f3ee6) return "(StretchPercent " + ($2c364a591bf2eb0c$var$show(v.value0) + ")");
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontStretch (line 23, column 10 - line 33, column 60): " + [
            v.constructor.name
        ]);
    }
};
var $2c364a591bf2eb0c$export$1bd26894bd10dfdb = function(v) {
    if (v instanceof $2c364a591bf2eb0c$export$653cd7d022bac561) return "normal";
    if (v instanceof $2c364a591bf2eb0c$export$f8ba3d887f8e479c) return "ultra-condensed";
    if (v instanceof $2c364a591bf2eb0c$export$682f83c1ed3dd38f) return "extra-condensed";
    if (v instanceof $2c364a591bf2eb0c$export$d242576776a98f48) return "condensed";
    if (v instanceof $2c364a591bf2eb0c$export$28eb5f1a86fa202c) return "semi-condensed";
    if (v instanceof $2c364a591bf2eb0c$export$cc7e14c73620ff89) return "semi-expanded";
    if (v instanceof $2c364a591bf2eb0c$export$4b0bade633ccbd2c) return "expanded";
    if (v instanceof $2c364a591bf2eb0c$export$a7968e1ecfd40d32) return "extra-expanded";
    if (v instanceof $2c364a591bf2eb0c$export$16a6ce887682d532) return "ultra-expanded";
    if (v instanceof $2c364a591bf2eb0c$export$ce2ec178f30f3ee6) return $2c364a591bf2eb0c$var$show(v.value0) + "%";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontStretch (line 36, column 20 - line 46, column 36): " + [
        v.constructor.name
    ]);
};
var $2c364a591bf2eb0c$export$48e9c4e6f044b85b = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $2c364a591bf2eb0c$export$653cd7d022bac561 && y instanceof $2c364a591bf2eb0c$export$653cd7d022bac561) return true;
            if (x instanceof $2c364a591bf2eb0c$export$f8ba3d887f8e479c && y instanceof $2c364a591bf2eb0c$export$f8ba3d887f8e479c) return true;
            if (x instanceof $2c364a591bf2eb0c$export$682f83c1ed3dd38f && y instanceof $2c364a591bf2eb0c$export$682f83c1ed3dd38f) return true;
            if (x instanceof $2c364a591bf2eb0c$export$d242576776a98f48 && y instanceof $2c364a591bf2eb0c$export$d242576776a98f48) return true;
            if (x instanceof $2c364a591bf2eb0c$export$28eb5f1a86fa202c && y instanceof $2c364a591bf2eb0c$export$28eb5f1a86fa202c) return true;
            if (x instanceof $2c364a591bf2eb0c$export$cc7e14c73620ff89 && y instanceof $2c364a591bf2eb0c$export$cc7e14c73620ff89) return true;
            if (x instanceof $2c364a591bf2eb0c$export$4b0bade633ccbd2c && y instanceof $2c364a591bf2eb0c$export$4b0bade633ccbd2c) return true;
            if (x instanceof $2c364a591bf2eb0c$export$a7968e1ecfd40d32 && y instanceof $2c364a591bf2eb0c$export$a7968e1ecfd40d32) return true;
            if (x instanceof $2c364a591bf2eb0c$export$16a6ce887682d532 && y instanceof $2c364a591bf2eb0c$export$16a6ce887682d532) return true;
            if (x instanceof $2c364a591bf2eb0c$export$ce2ec178f30f3ee6 && y instanceof $2c364a591bf2eb0c$export$ce2ec178f30f3ee6) return x.value0 === y.value0;
            return false;
        };
    }
};


// Generated by purs version 0.15.15
var $f8b72ddcbbb416ae$export$e0d70f3b9ee8dd39 = /* #__PURE__ */ function() {
    function FStyleNormal() {}
    FStyleNormal.value = new FStyleNormal();
    return FStyleNormal;
}();
var $f8b72ddcbbb416ae$export$3ea2ef0035c4facd = /* #__PURE__ */ function() {
    function FStyleItalic() {}
    FStyleItalic.value = new FStyleItalic();
    return FStyleItalic;
}();
var $f8b72ddcbbb416ae$export$f2457514e2777ba4 = /* #__PURE__ */ function() {
    function FStyleOblique() {}
    FStyleOblique.value = new FStyleOblique();
    return FStyleOblique;
}();
var $f8b72ddcbbb416ae$export$9049b0c8676a7813 = {
    show: function(v) {
        if (v instanceof $f8b72ddcbbb416ae$export$e0d70f3b9ee8dd39) return "FStyleNormal";
        if (v instanceof $f8b72ddcbbb416ae$export$3ea2ef0035c4facd) return "FStyleItalic";
        if (v instanceof $f8b72ddcbbb416ae$export$f2457514e2777ba4) return "FStyleOblique";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontStyle (line 16, column 10 - line 19, column 37): " + [
            v.constructor.name
        ]);
    }
};
var $f8b72ddcbbb416ae$export$ee9d65378e77e759 = function(v) {
    if (v instanceof $f8b72ddcbbb416ae$export$e0d70f3b9ee8dd39) return "normal";
    if (v instanceof $f8b72ddcbbb416ae$export$3ea2ef0035c4facd) return "italic";
    if (v instanceof $f8b72ddcbbb416ae$export$f2457514e2777ba4) return "oblique";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontStyle (line 22, column 18 - line 25, column 29): " + [
        v.constructor.name
    ]);
};
var $f8b72ddcbbb416ae$export$7172c7927c94999f = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $f8b72ddcbbb416ae$export$e0d70f3b9ee8dd39 && y instanceof $f8b72ddcbbb416ae$export$e0d70f3b9ee8dd39) return true;
            if (x instanceof $f8b72ddcbbb416ae$export$3ea2ef0035c4facd && y instanceof $f8b72ddcbbb416ae$export$3ea2ef0035c4facd) return true;
            if (x instanceof $f8b72ddcbbb416ae$export$f2457514e2777ba4 && y instanceof $f8b72ddcbbb416ae$export$f2457514e2777ba4) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15

var $265642f670a655ce$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $265642f670a655ce$export$638579ce35b5c07b = /* #__PURE__ */ function() {
    function FWeightNormal() {}
    FWeightNormal.value = new FWeightNormal();
    return FWeightNormal;
}();
var $265642f670a655ce$export$981462b2343c0e03 = /* #__PURE__ */ function() {
    function FWeightBold() {}
    FWeightBold.value = new FWeightBold();
    return FWeightBold;
}();
var $265642f670a655ce$export$fa135d37fd3fe649 = /* #__PURE__ */ function() {
    function FWeightBolder() {}
    FWeightBolder.value = new FWeightBolder();
    return FWeightBolder;
}();
var $265642f670a655ce$export$f43ea67db752a534 = /* #__PURE__ */ function() {
    function FWeightNumber(value0) {
        this.value0 = value0;
    }
    FWeightNumber.create = function(value0) {
        return new FWeightNumber(value0);
    };
    return FWeightNumber;
}();
var $265642f670a655ce$export$f0addd9b86db1a49 = {
    show: function(v) {
        if (v instanceof $265642f670a655ce$export$638579ce35b5c07b) return "FWeightNormal";
        if (v instanceof $265642f670a655ce$export$981462b2343c0e03) return "FWeightBold";
        if (v instanceof $265642f670a655ce$export$fa135d37fd3fe649) return "FWeightBolder";
        if (v instanceof $265642f670a655ce$export$f43ea67db752a534) return "(FWeightNumber " + ($265642f670a655ce$var$show(v.value0) + ")");
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontWeight (line 17, column 10 - line 21, column 58): " + [
            v.constructor.name
        ]);
    }
};
var $265642f670a655ce$export$a0a37ae65db395d4 = function(v) {
    if (v instanceof $265642f670a655ce$export$638579ce35b5c07b) return "normal";
    if (v instanceof $265642f670a655ce$export$981462b2343c0e03) return "bold";
    if (v instanceof $265642f670a655ce$export$fa135d37fd3fe649) return "bolder";
    if (v instanceof $265642f670a655ce$export$f43ea67db752a534) return $265642f670a655ce$var$show(v.value0);
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontWeight (line 24, column 19 - line 28, column 28): " + [
        v.constructor.name
    ]);
};
var $265642f670a655ce$export$4dae59cbe5d626ad = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $265642f670a655ce$export$638579ce35b5c07b && y instanceof $265642f670a655ce$export$638579ce35b5c07b) return true;
            if (x instanceof $265642f670a655ce$export$981462b2343c0e03 && y instanceof $265642f670a655ce$export$981462b2343c0e03) return true;
            if (x instanceof $265642f670a655ce$export$fa135d37fd3fe649 && y instanceof $265642f670a655ce$export$fa135d37fd3fe649) return true;
            if (x instanceof $265642f670a655ce$export$f43ea67db752a534 && y instanceof $265642f670a655ce$export$f43ea67db752a534) return x.value0 === y.value0;
            return false;
        };
    }
};


// Generated by purs version 0.15.15
var $2eb82300e262fccc$export$be224df9be361377 = /* #__PURE__ */ function() {
    function UserSpaceOnUse() {}
    UserSpaceOnUse.value = new UserSpaceOnUse();
    return UserSpaceOnUse;
}();
var $2eb82300e262fccc$export$b2751793592afc4f = /* #__PURE__ */ function() {
    function StrokeWidth() {}
    StrokeWidth.value = new StrokeWidth();
    return StrokeWidth;
}();
var $2eb82300e262fccc$export$5fe80bb6c51a1489 = {
    show: function(v) {
        if (v instanceof $2eb82300e262fccc$export$be224df9be361377) return "UserSpaceOnUse";
        if (v instanceof $2eb82300e262fccc$export$b2751793592afc4f) return "StrokeWidth";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.MarkerUnit (line 15, column 10 - line 17, column 33): " + [
            v.constructor.name
        ]);
    }
};
var $2eb82300e262fccc$export$cc9f81adb4c47af2 = function(v) {
    if (v instanceof $2eb82300e262fccc$export$be224df9be361377) return "userSpaceOnUse";
    if (v instanceof $2eb82300e262fccc$export$b2751793592afc4f) return "strokeWidth";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.MarkerUnit (line 20, column 19 - line 22, column 31): " + [
        v.constructor.name
    ]);
};
var $2eb82300e262fccc$export$9978f0f1aa1670a7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $2eb82300e262fccc$export$be224df9be361377 && y instanceof $2eb82300e262fccc$export$be224df9be361377) return true;
            if (x instanceof $2eb82300e262fccc$export$b2751793592afc4f && y instanceof $2eb82300e262fccc$export$b2751793592afc4f) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15
var $5208e6dd3c0d7b07$export$6a1bc23b142a3e6c = /* #__PURE__ */ function() {
    function UserSpaceOnUse_() {}
    UserSpaceOnUse_.value = new UserSpaceOnUse_();
    return UserSpaceOnUse_;
}();
var $5208e6dd3c0d7b07$export$d5057a10cc24656c = /* #__PURE__ */ function() {
    function ObjectBoundingBox() {}
    ObjectBoundingBox.value = new ObjectBoundingBox();
    return ObjectBoundingBox;
}();
var $5208e6dd3c0d7b07$export$55fbfaa0659c9746 = {
    show: function(v) {
        if (v instanceof $5208e6dd3c0d7b07$export$6a1bc23b142a3e6c) return "userSpaceOnUse";
        if (v instanceof $5208e6dd3c0d7b07$export$d5057a10cc24656c) return "objectBoundingBox";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.MaskUnit (line 15, column 10 - line 17, column 45): " + [
            v.constructor.name
        ]);
    }
};
var $5208e6dd3c0d7b07$export$5b7da54bb6081be2 = function(v) {
    if (v instanceof $5208e6dd3c0d7b07$export$6a1bc23b142a3e6c) return "userSpaceOnUse";
    if (v instanceof $5208e6dd3c0d7b07$export$d5057a10cc24656c) return "objectBoundingBox";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.MaskUnit (line 23, column 17 - line 25, column 43): " + [
        v.constructor.name
    ]);
};
var $5208e6dd3c0d7b07$export$57ca9579b40bd59c = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $5208e6dd3c0d7b07$export$6a1bc23b142a3e6c && y instanceof $5208e6dd3c0d7b07$export$6a1bc23b142a3e6c) return true;
            if (x instanceof $5208e6dd3c0d7b07$export$d5057a10cc24656c && y instanceof $5208e6dd3c0d7b07$export$d5057a10cc24656c) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15
var $60cb0dbe97eee8f0$export$35624b13e79b24a9 = /* #__PURE__ */ function() {
    function Meet() {}
    Meet.value = new Meet();
    return Meet;
}();
var $60cb0dbe97eee8f0$export$b3f2e2de3a8baa1e = /* #__PURE__ */ function() {
    function Slice() {}
    Slice.value = new Slice();
    return Slice;
}();
var $60cb0dbe97eee8f0$export$e7d9ab2e8eea38d2 = {
    show: function(v) {
        if (v instanceof $60cb0dbe97eee8f0$export$35624b13e79b24a9) return "Meet";
        if (v instanceof $60cb0dbe97eee8f0$export$b3f2e2de3a8baa1e) return "Slice";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.MeetOrSlice (line 15, column 10 - line 17, column 21): " + [
            v.constructor.name
        ]);
    }
};
var $60cb0dbe97eee8f0$export$2d9ce1451040dcf1 = function(v) {
    if (v instanceof $60cb0dbe97eee8f0$export$35624b13e79b24a9) return "meet";
    if (v instanceof $60cb0dbe97eee8f0$export$b3f2e2de3a8baa1e) return "slice";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.MeetOrSlice (line 20, column 20 - line 22, column 19): " + [
        v.constructor.name
    ]);
};
var $60cb0dbe97eee8f0$export$8c39c79634cb17ef = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $60cb0dbe97eee8f0$export$35624b13e79b24a9 && y instanceof $60cb0dbe97eee8f0$export$35624b13e79b24a9) return true;
            if (x instanceof $60cb0dbe97eee8f0$export$b3f2e2de3a8baa1e && y instanceof $60cb0dbe97eee8f0$export$b3f2e2de3a8baa1e) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15
var $60bf79c462eabc72$export$f553f083f98f5ccf = /* #__PURE__ */ function() {
    function AutoOrient() {}
    AutoOrient.value = new AutoOrient();
    return AutoOrient;
}();
var $60bf79c462eabc72$export$8ef7e1d65d8fc5b8 = /* #__PURE__ */ function() {
    function AutoStartReverse() {}
    AutoStartReverse.value = new AutoStartReverse();
    return AutoStartReverse;
}();
var $60bf79c462eabc72$export$6c1ec4c44e6729f5 = {
    show: function(v) {
        if (v instanceof $60bf79c462eabc72$export$f553f083f98f5ccf) return "AutoOrient";
        if (v instanceof $60bf79c462eabc72$export$8ef7e1d65d8fc5b8) return "AutoStartReverse";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Orient (line 15, column 10 - line 17, column 43): " + [
            v.constructor.name
        ]);
    }
};
var $60bf79c462eabc72$export$e2aa5f0b64f695f7 = function(v) {
    if (v instanceof $60bf79c462eabc72$export$f553f083f98f5ccf) return "auto";
    if (v instanceof $60bf79c462eabc72$export$8ef7e1d65d8fc5b8) return "auto-start-reverse";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Orient (line 20, column 15 - line 22, column 43): " + [
        v.constructor.name
    ]);
};
var $60bf79c462eabc72$export$24316547385984b4 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $60bf79c462eabc72$export$f553f083f98f5ccf && y instanceof $60bf79c462eabc72$export$f553f083f98f5ccf) return true;
            if (x instanceof $60bf79c462eabc72$export$8ef7e1d65d8fc5b8 && y instanceof $60bf79c462eabc72$export$8ef7e1d65d8fc5b8) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15



var $a8515260329650a2$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $a8515260329650a2$var$PathCommand = function(x) {
    return x;
};
var $a8515260329650a2$export$7cdc55ff372dcc4f = /* #__PURE__ */ function() {
    function Sweep0() {}
    Sweep0.value = new Sweep0();
    return Sweep0;
}();
var $a8515260329650a2$export$d438c262bf619d85 = /* #__PURE__ */ function() {
    function Sweep1() {}
    Sweep1.value = new Sweep1();
    return Sweep1;
}();
var $a8515260329650a2$export$6c332d11ee277259 = /* #__PURE__ */ function() {
    function Rel() {}
    Rel.value = new Rel();
    return Rel;
}();
var $a8515260329650a2$export$b73c596ee8758a66 = /* #__PURE__ */ function() {
    function Abs() {}
    Abs.value = new Abs();
    return Abs;
}();
var $a8515260329650a2$export$114f35ff201c8979 = /* #__PURE__ */ function() {
    function Arc0() {}
    Arc0.value = new Arc0();
    return Arc0;
}();
var $a8515260329650a2$export$959e88f7d2e9ed77 = /* #__PURE__ */ function() {
    function Arc1() {}
    Arc1.value = new Arc1();
    return Arc1;
}();
var $a8515260329650a2$export$df995fae86a55f06 = "z";
var $a8515260329650a2$export$8d444ba029691140 = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $a8515260329650a2$export$362044608b96ea6c = {
    show: function(v1) {
        if (v1 instanceof $a8515260329650a2$export$7cdc55ff372dcc4f) return "Sweep0";
        if (v1 instanceof $a8515260329650a2$export$d438c262bf619d85) return "Sweep1";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 70, column 10 - line 72, column 23): " + [
            v1.constructor.name
        ]);
    }
};
var $a8515260329650a2$export$9dbffb78b02776e2 = {
    show: function(v1) {
        if (v1 instanceof $a8515260329650a2$export$b73c596ee8758a66) return "Abs";
        if (v1 instanceof $a8515260329650a2$export$6c332d11ee277259) return "Rel";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 43, column 10 - line 45, column 17): " + [
            v1.constructor.name
        ]);
    }
};
var $a8515260329650a2$export$9f7bcdb74b1aa6f3 = {
    show: function(v1) {
        if (v1 instanceof $a8515260329650a2$export$114f35ff201c8979) return "Arc0";
        if (v1 instanceof $a8515260329650a2$export$959e88f7d2e9ed77) return "Arc1";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 54, column 10 - line 56, column 19): " + [
            v1.constructor.name
        ]);
    }
};
var $a8515260329650a2$var$renderCommand = function(cmd) {
    return function(s_) {
        if (cmd instanceof $a8515260329650a2$export$6c332d11ee277259) return s_;
        if (cmd instanceof $a8515260329650a2$export$b73c596ee8758a66) return $5b07e36f812dd04b$export$43df7fc17cca38a4(s_);
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 81, column 24 - line 83, column 20): " + [
            cmd.constructor.name
        ]);
    };
};
var $a8515260329650a2$var$renderCommand1Arg = function(s_) {
    return function(ref) {
        return function(a_) {
            return $a8515260329650a2$var$renderCommand(ref)(s_) + $a8515260329650a2$var$show(a_);
        };
    };
};
var $a8515260329650a2$export$90a7f3efeed30595 = /* #__PURE__ */ $a8515260329650a2$var$renderCommand1Arg("v");
var $a8515260329650a2$var$renderCommand2Args = function(s_) {
    return function(ref) {
        return function(a_) {
            return function(b) {
                return $a8515260329650a2$var$renderCommand(ref)(s_) + ($a8515260329650a2$var$show(a_) + (", " + $a8515260329650a2$var$show(b)));
            };
        };
    };
};
var $a8515260329650a2$export$625550452a3fa3ec = /* #__PURE__ */ $a8515260329650a2$var$renderCommand2Args("t");
var $a8515260329650a2$var$renderCommand4Args = function(s_) {
    return function(ref) {
        return function(a_) {
            return function(b) {
                return function(c_) {
                    return function(d_) {
                        return $a8515260329650a2$var$renderCommand(ref)(s_) + ($a8515260329650a2$var$show(a_) + (", " + ($a8515260329650a2$var$show(b) + (", " + ($a8515260329650a2$var$show(c_) + (", " + $a8515260329650a2$var$show(d_)))))));
                    };
                };
            };
        };
    };
};
var $a8515260329650a2$export$2408f22a0fab9ae5 = /* #__PURE__ */ $a8515260329650a2$var$renderCommand4Args("s");
var $a8515260329650a2$export$9e5f44173e64f162 = /* #__PURE__ */ $a8515260329650a2$var$renderCommand4Args("q");
var $a8515260329650a2$var$printPathCommand = function(v1) {
    return v1;
};
var $a8515260329650a2$export$be1ace7eb2b2775e = {
    show: function(val) {
        return $a8515260329650a2$var$printPathCommand(val);
    }
};
var $a8515260329650a2$var$printCommandSweepChoice = function(v1) {
    if (v1 instanceof $a8515260329650a2$export$7cdc55ff372dcc4f) return "0";
    if (v1 instanceof $a8515260329650a2$export$d438c262bf619d85) return "1";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 75, column 27 - line 77, column 16): " + [
        v1.constructor.name
    ]);
};
var $a8515260329650a2$var$printCommandArcChoice = function(v1) {
    if (v1 instanceof $a8515260329650a2$export$114f35ff201c8979) return "0";
    if (v1 instanceof $a8515260329650a2$export$959e88f7d2e9ed77) return "1";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 59, column 25 - line 61, column 14): " + [
        v1.constructor.name
    ]);
};
var $a8515260329650a2$export$953cecd6e717a553 = /* #__PURE__ */ $a8515260329650a2$var$renderCommand2Args("m");
var $a8515260329650a2$export$882b5998b3b9117c = /* #__PURE__ */ $a8515260329650a2$var$renderCommand2Args("l");
var $a8515260329650a2$export$dda1d9f60106f0e9 = /* #__PURE__ */ $a8515260329650a2$var$renderCommand1Arg("h");
var $a8515260329650a2$export$621341f4592ddb0c = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $a8515260329650a2$export$53af18f90105c5b3 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a8515260329650a2$export$7cdc55ff372dcc4f && y instanceof $a8515260329650a2$export$7cdc55ff372dcc4f) return true;
            if (x instanceof $a8515260329650a2$export$d438c262bf619d85 && y instanceof $a8515260329650a2$export$d438c262bf619d85) return true;
            return false;
        };
    }
};
var $a8515260329650a2$export$4313bab830f7b89c = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a8515260329650a2$export$6c332d11ee277259 && y instanceof $a8515260329650a2$export$6c332d11ee277259) return true;
            if (x instanceof $a8515260329650a2$export$b73c596ee8758a66 && y instanceof $a8515260329650a2$export$b73c596ee8758a66) return true;
            return false;
        };
    }
};
var $a8515260329650a2$export$612865522f5be171 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a8515260329650a2$export$114f35ff201c8979 && y instanceof $a8515260329650a2$export$114f35ff201c8979) return true;
            if (x instanceof $a8515260329650a2$export$959e88f7d2e9ed77 && y instanceof $a8515260329650a2$export$959e88f7d2e9ed77) return true;
            return false;
        };
    }
};
var $a8515260329650a2$export$db3b6bfb95261072 = function(ref) {
    return function(x1_) {
        return function(y1_) {
            return function(x2_) {
                return function(y2_) {
                    return function(x_) {
                        return function(y_) {
                            return $a8515260329650a2$var$renderCommand(ref)("c") + ($a8515260329650a2$var$show(x1_) + ("," + ($a8515260329650a2$var$show(y1_) + (" " + ($a8515260329650a2$var$show(x2_) + ("," + ($a8515260329650a2$var$show(y2_) + (" " + ($a8515260329650a2$var$show(x_) + ("," + $a8515260329650a2$var$show(y_)))))))))));
                        };
                    };
                };
            };
        };
    };
};
var $a8515260329650a2$export$407448d2b89b1813 = function(ref) {
    return function(rx_) {
        return function(ry_) {
            return function(rot) {
                return function(arc) {
                    return function(sweep) {
                        return function(x_) {
                            return function(y_) {
                                return $a8515260329650a2$var$renderCommand(ref)("a") + ($a8515260329650a2$var$show(rx_) + (", " + ($a8515260329650a2$var$show(ry_) + (", " + ($a8515260329650a2$var$show(rot) + (" " + ($a8515260329650a2$var$printCommandArcChoice(arc) + (" " + ($a8515260329650a2$var$printCommandSweepChoice(sweep) + (" " + ($a8515260329650a2$var$show(x_) + (" " + $a8515260329650a2$var$show(y_)))))))))))));
                            };
                        };
                    };
                };
            };
        };
    };
};


// Generated by purs version 0.15.15
var $2a54b9fbde402033$export$f0001182351cdd36 = /* #__PURE__ */ function() {
    function LineCapButt() {}
    LineCapButt.value = new LineCapButt();
    return LineCapButt;
}();
var $2a54b9fbde402033$export$c461fadbd001683a = /* #__PURE__ */ function() {
    function LineCapSquare() {}
    LineCapSquare.value = new LineCapSquare();
    return LineCapSquare;
}();
var $2a54b9fbde402033$export$191560db16102aae = /* #__PURE__ */ function() {
    function LineCapRound() {}
    LineCapRound.value = new LineCapRound();
    return LineCapRound;
}();
var $2a54b9fbde402033$export$f262ba84a1cb015f = {
    show: function(v) {
        if (v instanceof $2a54b9fbde402033$export$f0001182351cdd36) return "LineCapButt";
        if (v instanceof $2a54b9fbde402033$export$c461fadbd001683a) return "LineCapSquare";
        if (v instanceof $2a54b9fbde402033$export$191560db16102aae) return "LineCapRound";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.StrokeLineCap (line 16, column 10 - line 19, column 35): " + [
            v.constructor.name
        ]);
    }
};
var $2a54b9fbde402033$export$d1e252c9fc943ffc = function(v) {
    if (v instanceof $2a54b9fbde402033$export$f0001182351cdd36) return "butt";
    if (v instanceof $2a54b9fbde402033$export$c461fadbd001683a) return "square";
    if (v instanceof $2a54b9fbde402033$export$191560db16102aae) return "round";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.StrokeLineCap (line 22, column 22 - line 25, column 26): " + [
        v.constructor.name
    ]);
};
var $2a54b9fbde402033$export$834ba4b624091d37 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $2a54b9fbde402033$export$f0001182351cdd36 && y instanceof $2a54b9fbde402033$export$f0001182351cdd36) return true;
            if (x instanceof $2a54b9fbde402033$export$c461fadbd001683a && y instanceof $2a54b9fbde402033$export$c461fadbd001683a) return true;
            if (x instanceof $2a54b9fbde402033$export$191560db16102aae && y instanceof $2a54b9fbde402033$export$191560db16102aae) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15
var $0ad2cdf6f3d10a36$export$cba20f9f30bf9bb4 = /* #__PURE__ */ function() {
    function LineJoinArcs() {}
    LineJoinArcs.value = new LineJoinArcs();
    return LineJoinArcs;
}();
var $0ad2cdf6f3d10a36$export$51eea3ffb993885b = /* #__PURE__ */ function() {
    function LineJoinBevel() {}
    LineJoinBevel.value = new LineJoinBevel();
    return LineJoinBevel;
}();
var $0ad2cdf6f3d10a36$export$4e30607392604f68 = /* #__PURE__ */ function() {
    function LineJoinMiter() {}
    LineJoinMiter.value = new LineJoinMiter();
    return LineJoinMiter;
}();
var $0ad2cdf6f3d10a36$export$15d0b1c676a6f28e = /* #__PURE__ */ function() {
    function LineJoinMiterClip() {}
    LineJoinMiterClip.value = new LineJoinMiterClip();
    return LineJoinMiterClip;
}();
var $0ad2cdf6f3d10a36$export$1d4fe0989d335ee7 = /* #__PURE__ */ function() {
    function LineJoinRound() {}
    LineJoinRound.value = new LineJoinRound();
    return LineJoinRound;
}();
var $0ad2cdf6f3d10a36$export$721cfd1228b08056 = {
    show: function(v) {
        if (v instanceof $0ad2cdf6f3d10a36$export$cba20f9f30bf9bb4) return "LineJoinArcs";
        if (v instanceof $0ad2cdf6f3d10a36$export$51eea3ffb993885b) return "LineJoinBevel";
        if (v instanceof $0ad2cdf6f3d10a36$export$4e30607392604f68) return "LineJoinMiter";
        if (v instanceof $0ad2cdf6f3d10a36$export$15d0b1c676a6f28e) return "LineJoinMiterClip";
        if (v instanceof $0ad2cdf6f3d10a36$export$1d4fe0989d335ee7) return "LineJoinRound";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.StrokeLineJoin (line 18, column 10 - line 23, column 37): " + [
            v.constructor.name
        ]);
    }
};
var $0ad2cdf6f3d10a36$export$fe15dfdeb0601ae7 = function(v) {
    if (v instanceof $0ad2cdf6f3d10a36$export$cba20f9f30bf9bb4) return "arcs";
    if (v instanceof $0ad2cdf6f3d10a36$export$51eea3ffb993885b) return "bevel";
    if (v instanceof $0ad2cdf6f3d10a36$export$4e30607392604f68) return "miter";
    if (v instanceof $0ad2cdf6f3d10a36$export$15d0b1c676a6f28e) return "miter-clip";
    if (v instanceof $0ad2cdf6f3d10a36$export$1d4fe0989d335ee7) return "round";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.StrokeLineJoin (line 26, column 23 - line 31, column 27): " + [
        v.constructor.name
    ]);
};
var $0ad2cdf6f3d10a36$export$c35431f7af742a03 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0ad2cdf6f3d10a36$export$cba20f9f30bf9bb4 && y instanceof $0ad2cdf6f3d10a36$export$cba20f9f30bf9bb4) return true;
            if (x instanceof $0ad2cdf6f3d10a36$export$51eea3ffb993885b && y instanceof $0ad2cdf6f3d10a36$export$51eea3ffb993885b) return true;
            if (x instanceof $0ad2cdf6f3d10a36$export$4e30607392604f68 && y instanceof $0ad2cdf6f3d10a36$export$4e30607392604f68) return true;
            if (x instanceof $0ad2cdf6f3d10a36$export$15d0b1c676a6f28e && y instanceof $0ad2cdf6f3d10a36$export$15d0b1c676a6f28e) return true;
            if (x instanceof $0ad2cdf6f3d10a36$export$1d4fe0989d335ee7 && y instanceof $0ad2cdf6f3d10a36$export$1d4fe0989d335ee7) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15
var $390761f4b9dc47e9$export$cc14364c8a18572b = /* #__PURE__ */ function() {
    function AnchorStart() {}
    AnchorStart.value = new AnchorStart();
    return AnchorStart;
}();
var $390761f4b9dc47e9$export$c3bf81a7e3e250df = /* #__PURE__ */ function() {
    function AnchorMiddle() {}
    AnchorMiddle.value = new AnchorMiddle();
    return AnchorMiddle;
}();
var $390761f4b9dc47e9$export$81a7ac5c46218add = /* #__PURE__ */ function() {
    function AnchorEnd() {}
    AnchorEnd.value = new AnchorEnd();
    return AnchorEnd;
}();
var $390761f4b9dc47e9$export$d964ac7878f6cac9 = {
    show: function(v) {
        if (v instanceof $390761f4b9dc47e9$export$cc14364c8a18572b) return "Start";
        if (v instanceof $390761f4b9dc47e9$export$c3bf81a7e3e250df) return "AnchorMiddle";
        if (v instanceof $390761f4b9dc47e9$export$81a7ac5c46218add) return "End";
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.TextAnchor (line 16, column 10 - line 19, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $390761f4b9dc47e9$export$22a352d4a31f5155 = function(v) {
    if (v instanceof $390761f4b9dc47e9$export$cc14364c8a18572b) return "start";
    if (v instanceof $390761f4b9dc47e9$export$c3bf81a7e3e250df) return "middle";
    if (v instanceof $390761f4b9dc47e9$export$81a7ac5c46218add) return "end";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.TextAnchor (line 22, column 19 - line 25, column 21): " + [
        v.constructor.name
    ]);
};
var $390761f4b9dc47e9$export$9bf559044105255a = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $390761f4b9dc47e9$export$cc14364c8a18572b && y instanceof $390761f4b9dc47e9$export$cc14364c8a18572b) return true;
            if (x instanceof $390761f4b9dc47e9$export$c3bf81a7e3e250df && y instanceof $390761f4b9dc47e9$export$c3bf81a7e3e250df) return true;
            if (x instanceof $390761f4b9dc47e9$export$81a7ac5c46218add && y instanceof $390761f4b9dc47e9$export$81a7ac5c46218add) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15

var $86bb271feb5181d4$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $86bb271feb5181d4$export$5b12bf1653c0dd85 = /* #__PURE__ */ function() {
    function Matrix(value0, value1, value2, value3, value4, value5) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
    }
    Matrix.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return function(value5) {
                            return new Matrix(value0, value1, value2, value3, value4, value5);
                        };
                    };
                };
            };
        };
    };
    return Matrix;
}();
var $86bb271feb5181d4$export$9db2ba50894db2b9 = /* #__PURE__ */ function() {
    function Translate(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Translate.create = function(value0) {
        return function(value1) {
            return new Translate(value0, value1);
        };
    };
    return Translate;
}();
var $86bb271feb5181d4$export$d60cfc58d3c358b6 = /* #__PURE__ */ function() {
    function Scale(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Scale.create = function(value0) {
        return function(value1) {
            return new Scale(value0, value1);
        };
    };
    return Scale;
}();
var $86bb271feb5181d4$export$152db69a76b6b79e = /* #__PURE__ */ function() {
    function Rotate(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Rotate.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Rotate(value0, value1, value2);
            };
        };
    };
    return Rotate;
}();
var $86bb271feb5181d4$export$80e6f3ff66bb89e7 = /* #__PURE__ */ function() {
    function SkewX(value0) {
        this.value0 = value0;
    }
    SkewX.create = function(value0) {
        return new SkewX(value0);
    };
    return SkewX;
}();
var $86bb271feb5181d4$export$64b480ceb2d2b00 = /* #__PURE__ */ function() {
    function SkewY(value0) {
        this.value0 = value0;
    }
    SkewY.create = function(value0) {
        return new SkewY(value0);
    };
    return SkewY;
}();
var $86bb271feb5181d4$export$2ac7dd5d7edc82d4 = {
    show: function(v) {
        if (v instanceof $86bb271feb5181d4$export$5b12bf1653c0dd85) return "(Matrix " + ($86bb271feb5181d4$var$show(v.value0) + (" " + ($86bb271feb5181d4$var$show(v.value1) + (" " + ($86bb271feb5181d4$var$show(v.value2) + (" " + ($86bb271feb5181d4$var$show(v.value3) + (" " + ($86bb271feb5181d4$var$show(v.value4) + (" " + ($86bb271feb5181d4$var$show(v.value5) + ")")))))))))));
        if (v instanceof $86bb271feb5181d4$export$9db2ba50894db2b9) return "(Translate " + ($86bb271feb5181d4$var$show(v.value0) + (" " + ($86bb271feb5181d4$var$show(v.value1) + ")")));
        if (v instanceof $86bb271feb5181d4$export$d60cfc58d3c358b6) return "(Scale " + ($86bb271feb5181d4$var$show(v.value0) + (" " + ($86bb271feb5181d4$var$show(v.value1) + ")")));
        if (v instanceof $86bb271feb5181d4$export$152db69a76b6b79e) return "(Rotate " + ($86bb271feb5181d4$var$show(v.value0) + (" " + ($86bb271feb5181d4$var$show(v.value1) + (" " + ($86bb271feb5181d4$var$show(v.value2) + ")")))));
        if (v instanceof $86bb271feb5181d4$export$80e6f3ff66bb89e7) return "(SkewX " + ($86bb271feb5181d4$var$show(v.value0) + ")");
        if (v instanceof $86bb271feb5181d4$export$64b480ceb2d2b00) return "(SkewY " + ($86bb271feb5181d4$var$show(v.value0) + ")");
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Transform (line 19, column 10 - line 25, column 42): " + [
            v.constructor.name
        ]);
    }
};
var $86bb271feb5181d4$export$641f39f88372b3f = function(v) {
    if (v instanceof $86bb271feb5181d4$export$5b12bf1653c0dd85) return "matrix(" + ($86bb271feb5181d4$var$show(v.value0) + ("," + ($86bb271feb5181d4$var$show(v.value1) + ("," + ($86bb271feb5181d4$var$show(v.value2) + ("," + ($86bb271feb5181d4$var$show(v.value3) + ("," + ($86bb271feb5181d4$var$show(v.value4) + ("," + ($86bb271feb5181d4$var$show(v.value5) + ")")))))))))));
    if (v instanceof $86bb271feb5181d4$export$9db2ba50894db2b9) return "translate(" + ($86bb271feb5181d4$var$show(v.value0) + ("," + ($86bb271feb5181d4$var$show(v.value1) + ")")));
    if (v instanceof $86bb271feb5181d4$export$d60cfc58d3c358b6) return "scale(" + ($86bb271feb5181d4$var$show(v.value0) + ("," + ($86bb271feb5181d4$var$show(v.value1) + ")")));
    if (v instanceof $86bb271feb5181d4$export$152db69a76b6b79e) return "rotate(" + ($86bb271feb5181d4$var$show(v.value0) + ("," + ($86bb271feb5181d4$var$show(v.value1) + ("," + ($86bb271feb5181d4$var$show(v.value2) + ")")))));
    if (v instanceof $86bb271feb5181d4$export$80e6f3ff66bb89e7) return "skewX(" + ($86bb271feb5181d4$var$show(v.value0) + ")");
    if (v instanceof $86bb271feb5181d4$export$64b480ceb2d2b00) return "skewY(" + ($86bb271feb5181d4$var$show(v.value0) + ")");
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Transform (line 28, column 18 - line 34, column 39): " + [
        v.constructor.name
    ]);
};
var $86bb271feb5181d4$export$b67b4b1463c29639 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $86bb271feb5181d4$export$5b12bf1653c0dd85 && y instanceof $86bb271feb5181d4$export$5b12bf1653c0dd85) return x.value0 === y.value0 && x.value1 === y.value1 && x.value2 === y.value2 && x.value3 === y.value3 && x.value4 === y.value4 && x.value5 === y.value5;
            if (x instanceof $86bb271feb5181d4$export$9db2ba50894db2b9 && y instanceof $86bb271feb5181d4$export$9db2ba50894db2b9) return x.value0 === y.value0 && x.value1 === y.value1;
            if (x instanceof $86bb271feb5181d4$export$d60cfc58d3c358b6 && y instanceof $86bb271feb5181d4$export$d60cfc58d3c358b6) return x.value0 === y.value0 && x.value1 === y.value1;
            if (x instanceof $86bb271feb5181d4$export$152db69a76b6b79e && y instanceof $86bb271feb5181d4$export$152db69a76b6b79e) return x.value0 === y.value0 && x.value1 === y.value1 && x.value2 === y.value2;
            if (x instanceof $86bb271feb5181d4$export$80e6f3ff66bb89e7 && y instanceof $86bb271feb5181d4$export$80e6f3ff66bb89e7) return x.value0 === y.value0;
            if (x instanceof $86bb271feb5181d4$export$64b480ceb2d2b00 && y instanceof $86bb271feb5181d4$export$64b480ceb2d2b00) return x.value0 === y.value0;
            return false;
        };
    }
};




var $87132ca783c0bc07$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $87132ca783c0bc07$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $87132ca783c0bc07$export$bfb0cc6882fbf1fb = /* #__PURE__ */ function() {
    var $23 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("y2");
    return function($24) {
        return $23($87132ca783c0bc07$var$show($24));
    };
}();
var $87132ca783c0bc07$export$f07ceed34b807c99 = /* #__PURE__ */ function() {
    var $25 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("y1");
    return function($26) {
        return $25($87132ca783c0bc07$var$show($26));
    };
}();
var $87132ca783c0bc07$export$4a5767248b18ef41 = /* #__PURE__ */ function() {
    var $27 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("y");
    return function($28) {
        return $27($87132ca783c0bc07$var$show($28));
    };
}();
var $87132ca783c0bc07$export$9c0f64e3a9471a66 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$3c95eba0a7ef85d("xlink")("xlink:href");
var $87132ca783c0bc07$export$8b7d42aa892c205b = /* #__PURE__ */ function() {
    var $29 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("x2");
    return function($30) {
        return $29($87132ca783c0bc07$var$show($30));
    };
}();
var $87132ca783c0bc07$export$cdb484d3c68e5374 = /* #__PURE__ */ function() {
    var $31 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("x1");
    return function($32) {
        return $31($87132ca783c0bc07$var$show($32));
    };
}();
var $87132ca783c0bc07$export$d141bba7fdc215a3 = /* #__PURE__ */ function() {
    var $33 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("x");
    return function($34) {
        return $33($87132ca783c0bc07$var$show($34));
    };
}();
var $87132ca783c0bc07$export$7e3df82ee760448c = /* #__PURE__ */ function() {
    var $35 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("width");
    return function($36) {
        return $35($87132ca783c0bc07$var$show($36));
    };
}();
var $87132ca783c0bc07$export$a179c88182cb9d56 = function(x_) {
    return function(y_) {
        return function(w) {
            return function(h_) {
                return $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("viewBox")($5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ")($87132ca783c0bc07$var$map($87132ca783c0bc07$var$show)([
                    x_,
                    y_,
                    w,
                    h_
                ])));
            };
        };
    };
};
var $87132ca783c0bc07$export$51186ad6e864892a = /* #__PURE__ */ function() {
    var $37 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("transform");
    var $38 = $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ");
    var $39 = $87132ca783c0bc07$var$map($86bb271feb5181d4$export$641f39f88372b3f);
    return function($40) {
        return $37($38($39($40)));
    };
}();
var $87132ca783c0bc07$export$2c618a4308a30424 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("to");
var $87132ca783c0bc07$export$647fe8829717b652 = /* #__PURE__ */ function() {
    var $41 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("text-anchor");
    return function($42) {
        return $41($390761f4b9dc47e9$export$22a352d4a31f5155($42));
    };
}();
var $87132ca783c0bc07$export$579295bc0236e309 = /* #__PURE__ */ function() {
    var $43 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("stroke-width");
    return function($44) {
        return $43($87132ca783c0bc07$var$show($44));
    };
}();
var $87132ca783c0bc07$export$bf6b007d5842ef00 = /* #__PURE__ */ function() {
    var $45 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("stroke-opacity");
    return function($46) {
        return $45($87132ca783c0bc07$var$show($46));
    };
}();
var $87132ca783c0bc07$export$ab8ca1d410ab85d4 = /* #__PURE__ */ function() {
    var $47 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("stroke-miterlimit");
    var $48 = $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$5ed021ff2336715c)(1.0);
    return function($49) {
        return $47($87132ca783c0bc07$var$show($48($49)));
    };
}();
var $87132ca783c0bc07$export$7f238b667ea0497d = /* #__PURE__ */ function() {
    var $50 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("stroke-linejoin");
    return function($51) {
        return $50($0ad2cdf6f3d10a36$export$fe15dfdeb0601ae7($51));
    };
}();
var $87132ca783c0bc07$export$a5275823ee0c56c8 = /* #__PURE__ */ function() {
    var $52 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("stroke-linecap");
    return function($53) {
        return $52($2a54b9fbde402033$export$d1e252c9fc943ffc($53));
    };
}();
var $87132ca783c0bc07$export$bb6cdcf444798a8a = /* #__PURE__ */ function() {
    var $54 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("stroke-dashoffset");
    return function($55) {
        return $54($87132ca783c0bc07$var$show($55));
    };
}();
var $87132ca783c0bc07$export$fa64d65467a79c5f = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("stroke-dasharray");
var $87132ca783c0bc07$export$d9b706f8d0a70aef = /* #__PURE__ */ function() {
    var $56 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("stroke");
    return function($57) {
        return $56($ac780a544b82ad4e$export$a0e068db0973e7c3($57));
    };
}();
var $87132ca783c0bc07$export$ca60ec8735b3eb59 = /* #__PURE__ */ function() {
    var $58 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("ry");
    return function($59) {
        return $58($87132ca783c0bc07$var$show($59));
    };
}();
var $87132ca783c0bc07$export$723a0c7037372ed6 = /* #__PURE__ */ function() {
    var $60 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("rx");
    return function($61) {
        return $60($87132ca783c0bc07$var$show($61));
    };
}();
var $87132ca783c0bc07$export$4ebd8d166bc4d41c = /* #__PURE__ */ function() {
    var $62 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("repeatCount");
    var $63 = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
    return function($64) {
        return $62($63($64));
    };
}();
var $87132ca783c0bc07$export$bea20940f2ab408d = /* #__PURE__ */ function() {
    var $65 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("refY");
    return function($66) {
        return $65($87132ca783c0bc07$var$show($66));
    };
}();
var $87132ca783c0bc07$export$f8ea6418a93b1766 = /* #__PURE__ */ function() {
    var $67 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("refX");
    return function($68) {
        return $67($87132ca783c0bc07$var$show($68));
    };
}();
var $87132ca783c0bc07$export$43caf9889c228507 = /* #__PURE__ */ function() {
    var $69 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("r");
    return function($70) {
        return $69($87132ca783c0bc07$var$show($70));
    };
}();
var $87132ca783c0bc07$export$2cdd29748c601977 = function(align) {
    return function(slice) {
        var align_str = function() {
            if (align instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "none";
            if (align instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $5b07e36f812dd04b$export$ec1dc8fbeea3467e("")([
                "x",
                $08683fb67edb9127$export$bc7de53ed6c0db91(align.value0.x_),
                "Y",
                $08683fb67edb9127$export$bc7de53ed6c0db91(align.value0.y_)
            ]);
            throw new Error("Failed pattern match at Halogen.Svg.Attributes (line 249, column 15 - line 251, column 80): " + [
                align.constructor.name
            ]);
        }();
        return $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("preserveAspectRatio")($5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ")([
            align_str,
            $60cb0dbe97eee8f0$export$2d9ce1451040dcf1(slice)
        ]));
    };
};
var $87132ca783c0bc07$export$9f048bf86ee2e9d2 = /* #__PURE__ */ function() {
    var $71 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("points");
    var $72 = $396c4c3d9e7fae3c$export$739ec22334c44788($784e1bd3d26d71da$export$fc39f3d77fa2e58a)(" ");
    var $73 = $87132ca783c0bc07$var$map(function(v) {
        return $87132ca783c0bc07$var$show(v.value0) + ("," + $87132ca783c0bc07$var$show(v.value1));
    });
    return function($74) {
        return $71($72($73($74)));
    };
}();
var $87132ca783c0bc07$export$2d949ea0af312bcc = /* #__PURE__ */ function() {
    var $75 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("pathLength");
    return function($76) {
        return $75($87132ca783c0bc07$var$show($76));
    };
}();
var $87132ca783c0bc07$export$bb654e07daaf8c3a = /* #__PURE__ */ function() {
    var $77 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("path");
    var $78 = $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ");
    return function($79) {
        return $77($78($a8515260329650a2$export$8d444ba029691140($79)));
    };
}();
var $87132ca783c0bc07$export$f3eec17ee6065eee = /* #__PURE__ */ function() {
    var $80 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("orient");
    return function($81) {
        return $80($60bf79c462eabc72$export$e2aa5f0b64f695f7($81));
    };
}();
var $87132ca783c0bc07$export$d7d6c8e209c718dd = /* #__PURE__ */ function() {
    var $82 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("maskUnits");
    return function($83) {
        return $82($5208e6dd3c0d7b07$export$5b7da54bb6081be2($83));
    };
}();
var $87132ca783c0bc07$export$d8ca4674d0cabe81 = /* #__PURE__ */ function() {
    var $84 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("maskContentUnits");
    return function($85) {
        return $84($5208e6dd3c0d7b07$export$5b7da54bb6081be2($85));
    };
}();
var $87132ca783c0bc07$export$d99f0801a68bbcf1 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("mask");
var $87132ca783c0bc07$export$365fc137c57b820 = /* #__PURE__ */ function() {
    var $86 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("markerWidth");
    return function($87) {
        return $86($87132ca783c0bc07$var$show($87));
    };
}();
var $87132ca783c0bc07$export$29ed369710e4e3ee = /* #__PURE__ */ function() {
    var $88 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("markerUnits");
    return function($89) {
        return $88($2eb82300e262fccc$export$cc9f81adb4c47af2($89));
    };
}();
var $87132ca783c0bc07$export$77e806cf03f86bb8 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("marker-start");
var $87132ca783c0bc07$export$8300cb314ad112b1 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("marker-mid");
var $87132ca783c0bc07$export$791533ea8a6adb36 = /* #__PURE__ */ function() {
    var $90 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("markerHeight");
    return function($91) {
        return $90($87132ca783c0bc07$var$show($91));
    };
}();
var $87132ca783c0bc07$export$805bded4e96b35bb = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("marker-end");
var $87132ca783c0bc07$export$d560c7e4a29451c2 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("id");
var $87132ca783c0bc07$export$8f51af5840e0602a = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("href");
var $87132ca783c0bc07$export$ac607276a8fe9f0a = /* #__PURE__ */ function() {
    var $92 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("height");
    return function($93) {
        return $92($87132ca783c0bc07$var$show($93));
    };
}();
var $87132ca783c0bc07$export$6788812c4e6611e6 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("from");
var $87132ca783c0bc07$export$bc0b29e67df3229e = /* #__PURE__ */ function() {
    var $94 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("font-weight");
    return function($95) {
        return $94($265642f670a655ce$export$a0a37ae65db395d4($95));
    };
}();
var $87132ca783c0bc07$export$d563692519c52ffa = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("font-variant");
var $87132ca783c0bc07$export$a827189a08c5a3a3 = /* #__PURE__ */ function() {
    var $96 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("font-style");
    return function($97) {
        return $96($f8b72ddcbbb416ae$export$ee9d65378e77e759($97));
    };
}();
var $87132ca783c0bc07$export$ba586073a5833b8b = /* #__PURE__ */ function() {
    var $98 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("font-stretch");
    return function($99) {
        return $98($2c364a591bf2eb0c$export$1bd26894bd10dfdb($99));
    };
}();
var $87132ca783c0bc07$export$f33d97f3fe80eea8 = /* #__PURE__ */ function() {
    var $100 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("font-size-adjust");
    return function($101) {
        return $100($87132ca783c0bc07$var$show($101));
    };
}();
var $87132ca783c0bc07$export$85e3c3ca0c6fb93 = /* #__PURE__ */ function() {
    var $102 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("font-size");
    return function($103) {
        return $102($ae4a437c7407126d$export$8d4b901b5d5c20e9($103));
    };
}();
var $87132ca783c0bc07$export$a5975749f0374264 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("font-family");
var $87132ca783c0bc07$export$7854e733f445decb = /* #__PURE__ */ function() {
    var $104 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("fill-opacity");
    return function($105) {
        return $104($87132ca783c0bc07$var$show($105));
    };
}();
var $87132ca783c0bc07$export$bde197a328c1b6fc = /* #__PURE__ */ function() {
    var $106 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("fill");
    return function($107) {
        return $106($6d1e2287b2811d4e$export$c3ff95b0c9f9a151($107));
    };
}();
var $87132ca783c0bc07$export$9563e054e6f787fb = /* #__PURE__ */ function() {
    var $108 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("fill");
    return function($109) {
        return $108($ac780a544b82ad4e$export$a0e068db0973e7c3($109));
    };
}();
var $87132ca783c0bc07$export$2f27a63b163e96bf = /* #__PURE__ */ function() {
    var f = function(unit_) {
        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf("")(function(val) {
            return $87132ca783c0bc07$var$show(val) + unit_;
        });
    };
    var printDuration = function(v) {
        return f("h")(v.hours) + (f("m")(v.minutes) + (f("s")(v.seconds) + f("i")(v.milliseconds)));
    };
    var $110 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("dur");
    return function($111) {
        return $110(printDuration($111));
    };
}();
var $87132ca783c0bc07$export$d6448337778b2cd4 = /* #__PURE__ */ function() {
    var $112 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("dominant-baseline");
    return function($113) {
        return $112($08a5ce4820861c18$export$403c3905f8677763($113));
    };
}();
var $87132ca783c0bc07$export$4368d992c4eafac0 = /* #__PURE__ */ function() {
    var $114 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("d");
    var $115 = $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ");
    return function($116) {
        return $114($115($a8515260329650a2$export$8d444ba029691140($116)));
    };
}();
var $87132ca783c0bc07$export$aea64bc1b6f8f415 = /* #__PURE__ */ function() {
    var $117 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("cy");
    return function($118) {
        return $117($87132ca783c0bc07$var$show($118));
    };
}();
var $87132ca783c0bc07$export$a274e22fb40f762e = /* #__PURE__ */ function() {
    var $119 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("cx");
    return function($120) {
        return $119($87132ca783c0bc07$var$show($120));
    };
}();
var $87132ca783c0bc07$export$188d75d71883854a = /* #__PURE__ */ function() {
    var $121 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("class");
    var $122 = $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ");
    var $123 = $a4e6c090e9e673b6$export$8c14e57e778d3873();
    return function($124) {
        return $121($122($123($124)));
    };
}();
var $87132ca783c0bc07$export$dbf49ecbc3d3d264 = /* #__PURE__ */ function() {
    var $125 = $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("class");
    var $126 = $4fa4836228a192cc$export$a2a39c9747f0e54a()($d8c91a2be15f75cb$export$880a60b2adf28011);
    return function($127) {
        return $125($126($127));
    };
}();
var $87132ca783c0bc07$export$8a40ef51394ea6d2 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("begin");
var $87132ca783c0bc07$export$8e830b0a8238aa08 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("attributeName");





// Generated by purs version 0.15.15

var $2d993a5e75b8b38a$export$8454457683f90105 = /* #__PURE__ */ $e5b7e89a68d9c456$export$cba2bb7f1b8927c4("http://www.w3.org/2000/svg");
var $2d993a5e75b8b38a$export$35eec893e28a8a34 = function(props) {
    return $2d993a5e75b8b38a$export$8454457683f90105("ellipse")(props)([]);
};
var $2d993a5e75b8b38a$export$25ef286fa535664a = /* #__PURE__ */ $2d993a5e75b8b38a$export$8454457683f90105("foreignObject");
var $2d993a5e75b8b38a$export$39b482c5e57630a8 = /* #__PURE__ */ $2d993a5e75b8b38a$export$8454457683f90105("g");
var $2d993a5e75b8b38a$export$5c452ff88e35e47d = function(props) {
    return $2d993a5e75b8b38a$export$8454457683f90105("image")(props)([]);
};
var $2d993a5e75b8b38a$export$53f1d5ea8de3d7c = function(props) {
    return $2d993a5e75b8b38a$export$8454457683f90105("line")(props)([]);
};
var $2d993a5e75b8b38a$export$ffc4d0086f1a4c9 = /* #__PURE__ */ $2d993a5e75b8b38a$export$8454457683f90105("marker");
var $2d993a5e75b8b38a$export$d99f0801a68bbcf1 = /* #__PURE__ */ $2d993a5e75b8b38a$export$8454457683f90105("mask");
var $2d993a5e75b8b38a$export$d455c2d7dc3122e5 = function(props) {
    return $2d993a5e75b8b38a$export$8454457683f90105("mpath")(props)([]);
};
var $2d993a5e75b8b38a$export$bb654e07daaf8c3a = function(props) {
    return $2d993a5e75b8b38a$export$8454457683f90105("path")(props)([]);
};
var $2d993a5e75b8b38a$export$b7b19aa0ee06c73 = function(props) {
    return $2d993a5e75b8b38a$export$8454457683f90105("polygon")(props)([]);
};
var $2d993a5e75b8b38a$export$8d69707c7074d5c0 = function(props) {
    return $2d993a5e75b8b38a$export$8454457683f90105("polyline")(props)([]);
};
var $2d993a5e75b8b38a$export$4b409e53cf4df6e6 = function(props) {
    return $2d993a5e75b8b38a$export$8454457683f90105("rect")(props)([]);
};
var $2d993a5e75b8b38a$export$7ed1367e7fa1ad68 = /* #__PURE__ */ $2d993a5e75b8b38a$export$8454457683f90105("svg");
var $2d993a5e75b8b38a$export$6f093cfa640b7166 = /* #__PURE__ */ $2d993a5e75b8b38a$export$8454457683f90105("text");
var $2d993a5e75b8b38a$export$fb184b623420d9be = /* #__PURE__ */ $2d993a5e75b8b38a$export$8454457683f90105("title");
var $2d993a5e75b8b38a$export$1f96ae73734a86cc = function(props) {
    return $2d993a5e75b8b38a$export$8454457683f90105("use")(props)([]);
};
var $2d993a5e75b8b38a$export$868461b1c6870d10 = /* #__PURE__ */ $2d993a5e75b8b38a$export$8454457683f90105("defs");
var $2d993a5e75b8b38a$export$41e7d3c5897978a0 = /* #__PURE__ */ $2d993a5e75b8b38a$export$8454457683f90105("circle");
var $2d993a5e75b8b38a$export$e1d786d2f707b414 = function(props) {
    return $2d993a5e75b8b38a$export$8454457683f90105("circle")(props)([]);
};
var $2d993a5e75b8b38a$export$5e588c605a4a78b2 = /* #__PURE__ */ $2d993a5e75b8b38a$export$8454457683f90105("animateMotion");
var $2d993a5e75b8b38a$export$e3607ec2d7a891c4 = function(props) {
    return $2d993a5e75b8b38a$export$8454457683f90105("animate")(props)([]);
};



var $8995339af5b6d1de$var$pitchIsSymbol = {
    reflectSymbol: function() {
        return "pitch";
    }
};
var $8995339af5b6d1de$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $8995339af5b6d1de$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e()(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0($37b880af5f4991bd$export$d12253326f924cb1)()($8995339af5b6d1de$var$pitchIsSymbol)(/* #__PURE__ */ $6416bd93bb20ed95$export$5146a69d60451857($364547bd6bbe186e$export$66d6281a18f726a9)))()($8995339af5b6d1de$var$idIsSymbol)($37b880af5f4991bd$export$fa624555ca2acbc8)));
var $8995339af5b6d1de$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $8995339af5b6d1de$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($97ffb09cc3d11a32$export$b51fa3f60ce66bf3);
var $8995339af5b6d1de$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $8995339af5b6d1de$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $8995339af5b6d1de$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $8995339af5b6d1de$var$ordRecord = /* #__PURE__ */ $97937c29f879e68e$export$ebb7a7956d139174();
var $8995339af5b6d1de$var$ordRecordCons = /* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611($97937c29f879e68e$export$927f7db8ecc0069f)();
var $8995339af5b6d1de$var$ordStartStop = /* #__PURE__ */ $97ffb09cc3d11a32$export$51153a4951aa543e(/* #__PURE__ */ $8995339af5b6d1de$var$ordRecord(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $8995339af5b6d1de$var$ordRecordCons($8995339af5b6d1de$var$pitchIsSymbol)(/* #__PURE__ */ $6416bd93bb20ed95$export$cddf5df7d4d146c7($364547bd6bbe186e$export$aa156b69905f503)))()($8995339af5b6d1de$var$idIsSymbol)($97937c29f879e68e$export$c5f2758e49b2b86a)));
var $8995339af5b6d1de$var$ordRecord1 = /* #__PURE__ */ $8995339af5b6d1de$var$ordRecord(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $8995339af5b6d1de$var$ordRecordCons({
    reflectSymbol: function() {
        return "right";
    }
})($8995339af5b6d1de$var$ordStartStop))()({
    reflectSymbol: function() {
        return "left";
    }
})($8995339af5b6d1de$var$ordStartStop));
var $8995339af5b6d1de$var$fromFoldable = /* #__PURE__ */ $a393155e52307a24$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593)($8995339af5b6d1de$var$ordRecord1);
var $8995339af5b6d1de$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($70cd3177464e7915$export$794f9574ca20b986);
var $8995339af5b6d1de$var$fromFoldable1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($a393155e52307a24$export$fd19c21b7e75dff0);
var $8995339af5b6d1de$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$export$d751c43805353ae1);
var $8995339af5b6d1de$var$fromFoldable2 = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072($97937c29f879e68e$export$c5f2758e49b2b86a)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8995339af5b6d1de$var$unions = /* #__PURE__ */ $ea3eb84de0acf574$export$30b2db2f7030f6cf($97937c29f879e68e$export$c5f2758e49b2b86a)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8995339af5b6d1de$var$maximum = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b25e0be55f42c9a($97937c29f879e68e$export$ff461bf68e7dd332)($78c799cba34fcb8d$export$92659ee1fc91a075);
var $8995339af5b6d1de$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $8995339af5b6d1de$var$diasteps = /* #__PURE__ */ $364547bd6bbe186e$export$7c9df1bfbd0f6782(/* #__PURE__ */ $364547bd6bbe186e$export$c9a427c646d98c91($364547bd6bbe186e$export$306e929625906797)($364547bd6bbe186e$export$57bf37558439571a)($364547bd6bbe186e$export$698535b0a733192b));
var $8995339af5b6d1de$var$minimum = /* #__PURE__ */ $4fe7b6acfba7f29f$export$916782c1f0ddb132($97937c29f879e68e$export$ff461bf68e7dd332)($78c799cba34fcb8d$export$92659ee1fc91a075);
var $8995339af5b6d1de$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $8995339af5b6d1de$var$lookup1 = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($97937c29f879e68e$export$c5f2758e49b2b86a);
var $8995339af5b6d1de$var$showPitch = /* #__PURE__ */ $6416bd93bb20ed95$export$26082705e1e7e214($364547bd6bbe186e$export$6c410b696f956741);
var $8995339af5b6d1de$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($8995339af5b6d1de$var$showPitch);
var $8995339af5b6d1de$var$showRecord = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()();
var $8995339af5b6d1de$var$showRecord1 = /* #__PURE__ */ $8995339af5b6d1de$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($8995339af5b6d1de$var$idIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($8995339af5b6d1de$var$pitchIsSymbol)($8995339af5b6d1de$var$showPitch))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $8995339af5b6d1de$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $97ffb09cc3d11a32$export$69330288ca7d5e07($8995339af5b6d1de$var$showRecord1));
var $8995339af5b6d1de$var$member = /* #__PURE__ */ $ea3eb84de0acf574$export$6a0d13241802fe80($97937c29f879e68e$export$c5f2758e49b2b86a);
var $8995339af5b6d1de$var$member1 = /* #__PURE__ */ $a393155e52307a24$export$6a0d13241802fe80($8995339af5b6d1de$var$ordRecord1);
var $8995339af5b6d1de$var$fromFoldable3 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $8995339af5b6d1de$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $97ffb09cc3d11a32$export$69330288ca7d5e07(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225(/* #__PURE__ */ $8995339af5b6d1de$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "expl";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "note";
    }
})($8995339af5b6d1de$var$showRecord1))($97ffb09cc3d11a32$export$a12c6fb847c83c0b)))));
var $8995339af5b6d1de$var$fromFoldable4 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8995339af5b6d1de$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$ff461bf68e7dd332);
var $8995339af5b6d1de$var$eq3 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($97ffb09cc3d11a32$export$6142f43eeaf47d03);
var $8995339af5b6d1de$export$92306b89b10453de = /* #__PURE__ */ function() {
    function NotSelected() {}
    NotSelected.value = new NotSelected();
    return NotSelected;
}();
var $8995339af5b6d1de$export$168cec28b141e51c = /* #__PURE__ */ function() {
    function Selected() {}
    Selected.value = new Selected();
    return Selected;
}();
var $8995339af5b6d1de$export$31c1a2b1ce36b3b5 = /* #__PURE__ */ function() {
    function Related() {}
    Related.value = new Related();
    return Related;
}();
var $8995339af5b6d1de$export$8fa4e5556fd77a60 = /* #__PURE__ */ function() {
    return new $ac780a544b82ad4e$export$8f9ece5a47764b93(255, 255, 255);
}();
var $8995339af5b6d1de$export$e7eed98b4a1bde06 = /* #__PURE__ */ function() {
    return new $ac780a544b82ad4e$export$8f9ece5a47764b93(255, 165, 0);
}();
var $8995339af5b6d1de$export$79063f2f83f17896 = /* #__PURE__ */ $2d993a5e75b8b38a$export$8454457683f90105("tspan");
var $8995339af5b6d1de$export$b534f9432dd79469 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("filter");
var $8995339af5b6d1de$export$722402e53108e136 = 70.0;
var $8995339af5b6d1de$export$47bb7adff9d62863 = /* #__PURE__ */ function() {
    return new $ac780a544b82ad4e$export$8f9ece5a47764b93(135, 206, 250);
}();
var $8995339af5b6d1de$export$a596602b4f047117 = /* #__PURE__ */ function() {
    return new $ac780a544b82ad4e$export$8f9ece5a47764b93(30, 144, 255);
}();
var $8995339af5b6d1de$export$66475eda6a631e9b = $8995339af5b6d1de$export$47bb7adff9d62863;
var $8995339af5b6d1de$export$1d56ad1bcc816a96 = $8995339af5b6d1de$export$a596602b4f047117;
var $8995339af5b6d1de$export$f466435ed7b4eeb7 = 0.9;
var $8995339af5b6d1de$export$636f7f6567de9e47 = 80.0;
var $8995339af5b6d1de$export$47168f636f18638d = 150.0;
var $8995339af5b6d1de$export$6a90eb2e05b7382b = function(v) {
    return function(y) {
        return y * 100.0 * $9a14cd925227149d$export$b310ec824aaee37f(v.yscale);
    };
};
var $8995339af5b6d1de$export$2a1216b12a959364 = function(v) {
    return function(x) {
        return x * $8995339af5b6d1de$export$722402e53108e136 * $9a14cd925227149d$export$b310ec824aaee37f(v.xscale);
    };
};
var $8995339af5b6d1de$export$7988864bce530533 = $8995339af5b6d1de$export$66475eda6a631e9b;
var $8995339af5b6d1de$export$cc800923e997bb8 = function(i) {
    return $4ab74a20512cef04$export$a0a81dc3380ce7d3(i) * 20.0;
};
var $8995339af5b6d1de$export$6ffc8145ac98b432 = 29.0;
var $8995339af5b6d1de$export$7820e6d10dd0161c = function(sel) {
    return function(note) {
        var selected = $f1eb673e64bdc463$export$293152351051e02c(sel)(new $97ffb09cc3d11a32$export$f63ba74aa66682be(note));
        var parentSelected = function() {
            if (sel instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $97ffb09cc3d11a32$export$af90f69b4c9ccc1a(note.id)(sel.value0.expl);
            if (sel instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
            throw new Error("Failed pattern match at Render (line 121, column 20 - line 123, column 21): " + [
                sel.constructor.name
            ]);
        }();
        if (selected) return $8995339af5b6d1de$export$168cec28b141e51c.value;
        if (parentSelected) return $8995339af5b6d1de$export$31c1a2b1ce36b3b5.value;
        return $8995339af5b6d1de$export$92306b89b10453de.value;
    };
};
var $8995339af5b6d1de$export$3b88854f8dcaece2 = /* #__PURE__ */ function() {
    return new $ac780a544b82ad4e$export$8f9ece5a47764b93(211, 211, 211);
}();
var $8995339af5b6d1de$export$fdccaed7ccde8eb3 = 1.6;
var $8995339af5b6d1de$export$a2a8b8d2f4b4a8f6 = function(v) {
    return function(v1) {
        if (v instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be && v1 instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return $06733ae99ed4f534$export$43db023a260c5e9f(-1)($396c4c3d9e7fae3c$export$de3a4d4a0d731119(function(n) {
            return $8995339af5b6d1de$var$eq(n.note)(v.value0);
        })(v1.value0));
        return 0;
    };
};
var $8995339af5b6d1de$export$bd00eebab82ecb50 = /* #__PURE__ */ function() {
    return new $ac780a544b82ad4e$export$8f9ece5a47764b93(255, 0, 0);
}();
var $8995339af5b6d1de$export$ace0ae29ef67e82b = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $8995339af5b6d1de$export$92306b89b10453de && y instanceof $8995339af5b6d1de$export$92306b89b10453de) return true;
            if (x instanceof $8995339af5b6d1de$export$168cec28b141e51c && y instanceof $8995339af5b6d1de$export$168cec28b141e51c) return true;
            if (x instanceof $8995339af5b6d1de$export$31c1a2b1ce36b3b5 && y instanceof $8995339af5b6d1de$export$31c1a2b1ce36b3b5) return true;
            return false;
        };
    }
};
var $8995339af5b6d1de$var$eq4 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($8995339af5b6d1de$export$ace0ae29ef67e82b);
var $8995339af5b6d1de$export$df8cac1947751fe2 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("dy");
var $8995339af5b6d1de$export$58734539bbfa41a2 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("cursor");
var $8995339af5b6d1de$export$c073df10e766abfa = /* #__PURE__ */ function() {
    return new $ac780a544b82ad4e$export$8f9ece5a47764b93(0, 0, 0);
}();
var $8995339af5b6d1de$export$1a632dc3f58b7346 = function(sett) {
    return function(selection) {
        return function(slices) {
            return function(v) {
                var explToHori = function(note) {
                    if (note.expl instanceof $97ffb09cc3d11a32$export$ae59325e7e640c51) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        childNote: note.note,
                        parentNote: note.expl.value0
                    });
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                };
                return $06733ae99ed4f534$export$43db023a260c5e9f($c959b62ce0c19dfe$export$6f093cfa640b7166(""))($8995339af5b6d1de$var$bind($8995339af5b6d1de$var$lookup(v.child)(slices))(function(v1) {
                    return $8995339af5b6d1de$var$bind($8995339af5b6d1de$var$lookup(v.parent)(slices))(function(v2) {
                        var mkedge = function(v3) {
                            var offp = $8995339af5b6d1de$export$a2a8b8d2f4b4a8f6(new $97ffb09cc3d11a32$export$f63ba74aa66682be(v3.parentNote))(v2.slice.notes);
                            var offc = $8995339af5b6d1de$export$a2a8b8d2f4b4a8f6(new $97ffb09cc3d11a32$export$f63ba74aa66682be(v3.childNote))(v1.slice.notes);
                            var edgeSelected = $f1eb673e64bdc463$export$293152351051e02c(selection)(new $97ffb09cc3d11a32$export$f63ba74aa66682be(v3.parentNote)) || $f1eb673e64bdc463$export$293152351051e02c(selection)(new $97ffb09cc3d11a32$export$f63ba74aa66682be(v3.childNote));
                            return $2d993a5e75b8b38a$export$53f1d5ea8de3d7c([
                                $87132ca783c0bc07$export$cdb484d3c68e5374($8995339af5b6d1de$export$2a1216b12a959364(sett)(v2.slice.x)),
                                $87132ca783c0bc07$export$f07ceed34b807c99($8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(v2.depth) + $8995339af5b6d1de$export$cc800923e997bb8(offp)),
                                $87132ca783c0bc07$export$8b7d42aa892c205b($8995339af5b6d1de$export$2a1216b12a959364(sett)(v1.slice.x)),
                                $87132ca783c0bc07$export$bfb0cc6882fbf1fb($8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(v1.depth) + $8995339af5b6d1de$export$cc800923e997bb8(offc)),
                                $87132ca783c0bc07$export$d9b706f8d0a70aef(function() {
                                    if (edgeSelected) return $8995339af5b6d1de$export$1d56ad1bcc816a96;
                                    return $8995339af5b6d1de$export$c073df10e766abfa;
                                }()),
                                $87132ca783c0bc07$export$579295bc0236e309(1.0)
                            ]);
                        };
                        var edges = $8995339af5b6d1de$var$map(mkedge)($396c4c3d9e7fae3c$export$986c2bbe7a34be0b($8995339af5b6d1de$var$map(explToHori)($97ffb09cc3d11a32$export$a45279548abf4fad(v1.slice))));
                        var bar = [
                            $2d993a5e75b8b38a$export$53f1d5ea8de3d7c([
                                $87132ca783c0bc07$export$cdb484d3c68e5374($8995339af5b6d1de$export$2a1216b12a959364(sett)(v2.slice.x)),
                                $87132ca783c0bc07$export$f07ceed34b807c99($8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(v2.depth)),
                                $87132ca783c0bc07$export$8b7d42aa892c205b($8995339af5b6d1de$export$2a1216b12a959364(sett)(v1.slice.x)),
                                $87132ca783c0bc07$export$bfb0cc6882fbf1fb($8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(v1.depth)),
                                $87132ca783c0bc07$export$d9b706f8d0a70aef($8995339af5b6d1de$export$3b88854f8dcaece2),
                                $87132ca783c0bc07$export$579295bc0236e309(5.0),
                                $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("stroke-dasharray")("10,5")
                            ])
                        ];
                        return $8995339af5b6d1de$var$pure($2d993a5e75b8b38a$export$39b482c5e57630a8([])($8995339af5b6d1de$var$append(bar)(edges)));
                    });
                }));
            };
        };
    };
};
var $8995339af5b6d1de$export$c10510da686dd2c5 = function(sett) {
    return function(sel) {
        return function(v) {
            return function(graph) {
                var width = $8995339af5b6d1de$export$2a1216b12a959364(sett)(graph.maxx + 2.0);
                var surfaceEdges = $8995339af5b6d1de$var$fromFoldable($8995339af5b6d1de$var$bind1(v.transs)(function(trans) {
                    return $8995339af5b6d1de$var$append($8995339af5b6d1de$var$fromFoldable1(trans.edges.regular))(trans.edges.passing);
                }));
                var selIsRoot = function() {
                    if (sel instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $8995339af5b6d1de$var$eq1(sel.value0.expl)($97ffb09cc3d11a32$export$2cf876164813516f.value);
                    if (sel instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
                    throw new Error("Failed pattern match at Render (line 323, column 15 - line 325, column 21): " + [
                        sel.constructor.name
                    ]);
                }();
                var mkNode = function(v1) {
                    return function(label) {
                        return function(title) {
                            return function(selected) {
                                return function(selAttr) {
                                    return $2d993a5e75b8b38a$export$39b482c5e57630a8([])([
                                        $2d993a5e75b8b38a$export$e1d786d2f707b414($8995339af5b6d1de$var$append([
                                            $87132ca783c0bc07$export$a274e22fb40f762e(v1.x),
                                            $87132ca783c0bc07$export$aea64bc1b6f8f415(v1.y),
                                            $87132ca783c0bc07$export$43caf9889c228507(15.0),
                                            $87132ca783c0bc07$export$d9b706f8d0a70aef($8995339af5b6d1de$export$c073df10e766abfa),
                                            $87132ca783c0bc07$export$9563e054e6f787fb(function() {
                                                if (selected instanceof $8995339af5b6d1de$export$92306b89b10453de) return $8995339af5b6d1de$export$8fa4e5556fd77a60;
                                                if (selected instanceof $8995339af5b6d1de$export$168cec28b141e51c) return $8995339af5b6d1de$export$1d56ad1bcc816a96;
                                                if (selected instanceof $8995339af5b6d1de$export$31c1a2b1ce36b3b5) return $8995339af5b6d1de$export$66475eda6a631e9b;
                                                throw new Error("Failed pattern match at Render (line 349, column 23 - line 352, column 42): " + [
                                                    selected.constructor.name
                                                ]);
                                            }()),
                                            $8995339af5b6d1de$export$58734539bbfa41a2("pointer")
                                        ])(selAttr)),
                                        $2d993a5e75b8b38a$export$8454457683f90105("text")([
                                            $87132ca783c0bc07$export$d141bba7fdc215a3(v1.x),
                                            $87132ca783c0bc07$export$4a5767248b18ef41(v1.y),
                                            $87132ca783c0bc07$export$647fe8829717b652($390761f4b9dc47e9$export$c3bf81a7e3e250df.value),
                                            $87132ca783c0bc07$export$d6448337778b2cd4($08a5ce4820861c18$export$89343b787b0d22af.value),
                                            $94c2c7ff32ca5bd1$export$1d567c320f4763bc("pointer-events: none;"),
                                            $87132ca783c0bc07$export$9563e054e6f787fb(function() {
                                                var $184 = $8995339af5b6d1de$var$eq4(selected)($8995339af5b6d1de$export$92306b89b10453de.value);
                                                if ($184) return $8995339af5b6d1de$export$c073df10e766abfa;
                                                return $8995339af5b6d1de$export$8fa4e5556fd77a60;
                                            }())
                                        ])([
                                            $c959b62ce0c19dfe$export$6f093cfa640b7166(label)
                                        ]),
                                        $2d993a5e75b8b38a$export$fb184b623420d9be([])([
                                            $c959b62ce0c19dfe$export$6f093cfa640b7166(title)
                                        ])
                                    ]);
                                };
                            };
                        };
                    };
                };
                var extractNotes = function(slice) {
                    return $8995339af5b6d1de$var$fromFoldable2($8995339af5b6d1de$var$map(function(n) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(n.note.id, {
                            note: n,
                            x: slice.x
                        });
                    })($97ffb09cc3d11a32$export$a45279548abf4fad(slice)));
                };
                var notes = $8995339af5b6d1de$var$unions($8995339af5b6d1de$var$map(extractNotes)(v.slices));
                var maxy = $06733ae99ed4f534$export$43db023a260c5e9f(0)($8995339af5b6d1de$var$maximum($8995339af5b6d1de$var$map1(function($267) {
                    return $8995339af5b6d1de$var$diasteps(function(v1) {
                        return v1.note.note.pitch;
                    }($267));
                })($ea3eb84de0acf574$export$68c286be0e7e55b7(notes))));
                var miny = $06733ae99ed4f534$export$43db023a260c5e9f(0)($8995339af5b6d1de$var$minimum($8995339af5b6d1de$var$map1(function($268) {
                    return $8995339af5b6d1de$var$diasteps(function(v1) {
                        return v1.note.note.pitch;
                    }($268));
                })($ea3eb84de0acf574$export$68c286be0e7e55b7(notes))));
                var height = $8995339af5b6d1de$export$fdccaed7ccde8eb3 * $8995339af5b6d1de$export$cc800923e997bb8((maxy - miny | 0) + 2 | 0);
                var notePosition = function(v1) {
                    if (v1 instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return {
                        x: $8995339af5b6d1de$export$2a1216b12a959364(sett)($06733ae99ed4f534$export$43db023a260c5e9f(0.0)($8995339af5b6d1de$var$map2(function(v2) {
                            return v2.x;
                        })($8995339af5b6d1de$var$lookup1(v1.value0.id)(notes)))),
                        y: $8995339af5b6d1de$export$fdccaed7ccde8eb3 * $8995339af5b6d1de$export$cc800923e997bb8(maxy - $8995339af5b6d1de$var$diasteps(v1.value0.pitch) | 0)
                    };
                    if (v1 instanceof $97ffb09cc3d11a32$export$568b89e600fc77eb) return {
                        x: 0.0,
                        y: $8995339af5b6d1de$export$cc800923e997bb8(maxy - miny | 0) * $8995339af5b6d1de$export$fdccaed7ccde8eb3 / 2.0
                    };
                    if (v1 instanceof $97ffb09cc3d11a32$export$ac4156b3386a7c70) return {
                        x: $8995339af5b6d1de$export$2a1216b12a959364(sett)(graph.maxx),
                        y: $8995339af5b6d1de$export$cc800923e997bb8(maxy - miny | 0) * $8995339af5b6d1de$export$fdccaed7ccde8eb3 / 2.0
                    };
                    throw new Error("Failed pattern match at Render (line 328, column 18 - line 334, column 89): " + [
                        v1.constructor.name
                    ]);
                };
                var mkNote = function(v1) {
                    var selected = $8995339af5b6d1de$export$7820e6d10dd0161c(sel)(v1.note.note);
                    var selAttr = [
                        $10ae9db6658426ac$export$1d5a917feb871989(function(_ev) {
                            return new $f1eb673e64bdc463$export$ef9b1a59e592288f(function() {
                                var $190 = $8995339af5b6d1de$var$eq4(selected)($8995339af5b6d1de$export$168cec28b141e51c.value);
                                if ($190) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                    note: v1.note.note,
                                    expl: v1.note.expl
                                });
                            }());
                        })
                    ];
                    return mkNode(notePosition(new $97ffb09cc3d11a32$export$f63ba74aa66682be(v1.note.note)))($8995339af5b6d1de$var$show(v1.note.note.pitch))($f1eb673e64bdc463$export$3b0bdf174ee79f95(v1.note.expl))(selected)(selAttr);
                };
                var mkStartStop = function(s) {
                    return mkNode(notePosition(s))($8995339af5b6d1de$var$show1(s))($8995339af5b6d1de$var$show1(s))(function() {
                        if (selIsRoot) return $8995339af5b6d1de$export$31c1a2b1ce36b3b5.value;
                        return $8995339af5b6d1de$export$92306b89b10453de.value;
                    }())([]);
                };
                var surfaceNote = function(v1) {
                    if (v1 instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return $8995339af5b6d1de$var$member(v1.value0.id)(notes);
                    return true;
                };
                var mkEdge = function(isRegular) {
                    return function(v1) {
                        if (surfaceNote(v1.left) && surfaceNote(v1.right)) {
                            var v2 = notePosition(v1.left);
                            var v3 = notePosition(v1.right);
                            var edgeSelected = $f1eb673e64bdc463$export$293152351051e02c(sel)(v1.left) || $f1eb673e64bdc463$export$293152351051e02c(sel)(v1.right);
                            return $2d993a5e75b8b38a$export$53f1d5ea8de3d7c($8995339af5b6d1de$var$append([
                                $87132ca783c0bc07$export$cdb484d3c68e5374(v2.x),
                                $87132ca783c0bc07$export$8b7d42aa892c205b(v3.x),
                                $87132ca783c0bc07$export$f07ceed34b807c99(v2.y),
                                $87132ca783c0bc07$export$bfb0cc6882fbf1fb(v3.y),
                                $87132ca783c0bc07$export$d9b706f8d0a70aef(function() {
                                    if (edgeSelected) return $8995339af5b6d1de$export$1d56ad1bcc816a96;
                                    var $202 = $8995339af5b6d1de$var$member1({
                                        left: v1.left,
                                        right: v1.right
                                    })(surfaceEdges);
                                    if ($202) return $8995339af5b6d1de$export$c073df10e766abfa;
                                    return $8995339af5b6d1de$export$3b88854f8dcaece2;
                                }())
                            ])(function() {
                                if (isRegular) return [];
                                return [
                                    $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("stroke-dasharray")("6,3")
                                ];
                            }()));
                        }
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $c959b62ce0c19dfe$export$6f093cfa640b7166("");
                        throw new Error("Failed pattern match at Render (line 379, column 3 - line 400, column 29): " + [
                            isRegular.constructor.name,
                            v1.constructor.name
                        ]);
                    };
                };
                var svgArrows = $8995339af5b6d1de$var$bind1($8995339af5b6d1de$var$fromFoldable3($ea3eb84de0acf574$export$68c286be0e7e55b7(graph.transitions)))(function(trans) {
                    return $8995339af5b6d1de$var$append($8995339af5b6d1de$var$map(mkEdge(true))($8995339af5b6d1de$var$fromFoldable1(trans.edges.regular)))($8995339af5b6d1de$var$map(mkEdge(false))(trans.edges.passing));
                });
                var svgNotes = $8995339af5b6d1de$var$fromFoldable3($8995339af5b6d1de$var$map1(mkNote)($ea3eb84de0acf574$export$68c286be0e7e55b7(notes)));
                var svg = $e5b7e89a68d9c456$export$3327f90baeaa2cb3([
                    $2d993a5e75b8b38a$export$7ed1367e7fa1ad68([
                        $87132ca783c0bc07$export$7e3df82ee760448c(width),
                        $87132ca783c0bc07$export$ac607276a8fe9f0a(height),
                        $87132ca783c0bc07$export$a179c88182cb9d56(-$8995339af5b6d1de$export$2a1216b12a959364(sett)(1.0))(-($8995339af5b6d1de$export$fdccaed7ccde8eb3 * $8995339af5b6d1de$export$cc800923e997bb8(1)))(width)(height)
                    ])($8995339af5b6d1de$var$append(svgArrows)($8995339af5b6d1de$var$append(svgNotes)([
                        mkStartStop($97ffb09cc3d11a32$export$568b89e600fc77eb.value),
                        mkStartStop($97ffb09cc3d11a32$export$ac4156b3386a7c70.value)
                    ])))
                ]);
                return svg;
            };
        };
    };
};
var $8995339af5b6d1de$export$df83866f4f2b1b91 = function(sett) {
    return function(selection) {
        return function(v) {
            var svgx = $8995339af5b6d1de$export$2a1216b12a959364(sett)(v.slice.x) - $8995339af5b6d1de$export$6ffc8145ac98b432 / 2.0;
            var selIsRoot = function() {
                if (selection instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $8995339af5b6d1de$var$eq1(selection.value0.expl)($97ffb09cc3d11a32$export$2cf876164813516f.value);
                if (selection instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
                throw new Error("Failed pattern match at Render (line 147, column 15 - line 149, column 21): " + [
                    selection.constructor.name
                ]);
            }();
            var mknode = function(text) {
                return function(title) {
                    return function(xcoord) {
                        return function(ycoord) {
                            return function(selStatus) {
                                return function(attr) {
                                    var label = $2d993a5e75b8b38a$export$8454457683f90105("text")([
                                        $87132ca783c0bc07$export$d141bba7fdc215a3(xcoord),
                                        $87132ca783c0bc07$export$4a5767248b18ef41(ycoord),
                                        $87132ca783c0bc07$export$647fe8829717b652($390761f4b9dc47e9$export$c3bf81a7e3e250df.value),
                                        $87132ca783c0bc07$export$d6448337778b2cd4($08a5ce4820861c18$export$89343b787b0d22af.value),
                                        $94c2c7ff32ca5bd1$export$1d567c320f4763bc("pointer-events: none;"),
                                        $87132ca783c0bc07$export$9563e054e6f787fb(function() {
                                            var $218 = $8995339af5b6d1de$var$eq4(selStatus)($8995339af5b6d1de$export$92306b89b10453de.value);
                                            if ($218) return $8995339af5b6d1de$export$c073df10e766abfa;
                                            return $8995339af5b6d1de$export$8fa4e5556fd77a60;
                                        }())
                                    ])([
                                        $c959b62ce0c19dfe$export$6f093cfa640b7166(text)
                                    ]);
                                    var bg = $2d993a5e75b8b38a$export$4b409e53cf4df6e6([
                                        $87132ca783c0bc07$export$d141bba7fdc215a3(xcoord - $8995339af5b6d1de$export$6ffc8145ac98b432 / 2.0),
                                        $87132ca783c0bc07$export$4a5767248b18ef41(ycoord - $8995339af5b6d1de$export$cc800923e997bb8(1) / 2.0),
                                        $87132ca783c0bc07$export$7e3df82ee760448c($8995339af5b6d1de$export$6ffc8145ac98b432),
                                        $87132ca783c0bc07$export$ac607276a8fe9f0a($8995339af5b6d1de$export$cc800923e997bb8(1)),
                                        $87132ca783c0bc07$export$9563e054e6f787fb(function() {
                                            if (selStatus instanceof $8995339af5b6d1de$export$92306b89b10453de) return $8995339af5b6d1de$export$8fa4e5556fd77a60;
                                            if (selStatus instanceof $8995339af5b6d1de$export$168cec28b141e51c) return $8995339af5b6d1de$export$1d56ad1bcc816a96;
                                            if (selStatus instanceof $8995339af5b6d1de$export$31c1a2b1ce36b3b5) return $8995339af5b6d1de$export$66475eda6a631e9b;
                                            throw new Error("Failed pattern match at Render (line 162, column 15 - line 165, column 42): " + [
                                                selStatus.constructor.name
                                            ]);
                                        }()),
                                        $87132ca783c0bc07$export$dbf49ecbc3d3d264("node")
                                    ]);
                                    return $2d993a5e75b8b38a$export$39b482c5e57630a8(attr)([
                                        bg,
                                        label,
                                        $2d993a5e75b8b38a$export$fb184b623420d9be([])([
                                            $c959b62ce0c19dfe$export$6f093cfa640b7166(title)
                                        ])
                                    ]);
                                };
                            };
                        };
                    };
                };
            };
            var mknote = function(i) {
                return function(v1) {
                    var nselectable = v.depth !== 0.0;
                    var nodeselected = $8995339af5b6d1de$export$7820e6d10dd0161c(selection)(v1.note);
                    var attrsSel = [
                        $8995339af5b6d1de$export$58734539bbfa41a2("pointer"),
                        $10ae9db6658426ac$export$1d5a917feb871989(function(_ev) {
                            if (nselectable) return new $f1eb673e64bdc463$export$ef9b1a59e592288f(function() {
                                var $223 = $8995339af5b6d1de$var$eq4(nodeselected)($8995339af5b6d1de$export$168cec28b141e51c.value);
                                if ($223) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                    note: v1.note,
                                    expl: v1.expl
                                });
                            }());
                            return $f1eb673e64bdc463$export$7fc4381d95dc76c8.value;
                        })
                    ];
                    return mknode($8995339af5b6d1de$var$show(v1.note.pitch))($f1eb673e64bdc463$export$3b0bdf174ee79f95(v1.expl))($8995339af5b6d1de$export$2a1216b12a959364(sett)(v.slice.x))($8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(v.depth) + $8995339af5b6d1de$export$cc800923e997bb8(i))(nodeselected)(function() {
                        if (nselectable) return attrsSel;
                        return [];
                    }());
                };
            };
            if (v.slice.notes instanceof $97ffb09cc3d11a32$export$f63ba74aa66682be) return $2d993a5e75b8b38a$export$39b482c5e57630a8([])([
                $2d993a5e75b8b38a$export$39b482c5e57630a8([])($8995339af5b6d1de$var$append([
                    $2d993a5e75b8b38a$export$4b409e53cf4df6e6([
                        $87132ca783c0bc07$export$d141bba7fdc215a3(svgx),
                        $87132ca783c0bc07$export$4a5767248b18ef41($8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(v.depth) - $8995339af5b6d1de$export$6ffc8145ac98b432 / 2.0),
                        $87132ca783c0bc07$export$7e3df82ee760448c($8995339af5b6d1de$export$6ffc8145ac98b432),
                        $87132ca783c0bc07$export$ac607276a8fe9f0a($8995339af5b6d1de$export$cc800923e997bb8($fc8c1182ec2aefec$export$f24224f1c91d8156(v.slice.notes.value0) - 1 | 0) + $8995339af5b6d1de$export$6ffc8145ac98b432),
                        $87132ca783c0bc07$export$9563e054e6f787fb($8995339af5b6d1de$export$8fa4e5556fd77a60),
                        $87132ca783c0bc07$export$dbf49ecbc3d3d264("slice")
                    ])
                ])($396c4c3d9e7fae3c$export$8f07ddce13659f50(mknote)(v.slice.notes.value0)))
            ]);
            return mknode($8995339af5b6d1de$var$show2(v.slice.notes))($8995339af5b6d1de$var$show2(v.slice.notes))($8995339af5b6d1de$export$2a1216b12a959364(sett)(v.slice.x))($8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(v.depth))(function() {
                if (selIsRoot) return $8995339af5b6d1de$export$31c1a2b1ce36b3b5.value;
                return $8995339af5b6d1de$export$92306b89b10453de.value;
            }())([]);
        };
    };
};
var $8995339af5b6d1de$export$b5ef0fc53ffb2a8a = function(sett) {
    return function(selection) {
        return function(slices) {
            return function(v) {
                return $06733ae99ed4f534$export$43db023a260c5e9f($c959b62ce0c19dfe$export$6f093cfa640b7166(""))($8995339af5b6d1de$var$bind($8995339af5b6d1de$var$lookup(v.left)(slices))(function(v1) {
                    return $8995339af5b6d1de$var$bind($8995339af5b6d1de$var$lookup(v.right)(slices))(function(v2) {
                        var selectable = v1.depth === 0.0 && v2.depth === 0.0;
                        var mkedge = function(isPassing) {
                            return function(v3) {
                                var offr = $8995339af5b6d1de$export$a2a8b8d2f4b4a8f6(v3.right)(v2.slice.notes);
                                var offl = $8995339af5b6d1de$export$a2a8b8d2f4b4a8f6(v3.left)(v1.slice.notes);
                                var edgeSelected = $f1eb673e64bdc463$export$293152351051e02c(selection)(v3.left) || $f1eb673e64bdc463$export$293152351051e02c(selection)(v3.right);
                                return $2d993a5e75b8b38a$export$53f1d5ea8de3d7c([
                                    $87132ca783c0bc07$export$cdb484d3c68e5374($8995339af5b6d1de$export$2a1216b12a959364(sett)(v1.slice.x)),
                                    $87132ca783c0bc07$export$f07ceed34b807c99($8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(v1.depth) + $8995339af5b6d1de$export$cc800923e997bb8(offl)),
                                    $87132ca783c0bc07$export$8b7d42aa892c205b($8995339af5b6d1de$export$2a1216b12a959364(sett)(v2.slice.x)),
                                    $87132ca783c0bc07$export$bfb0cc6882fbf1fb($8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(v2.depth) + $8995339af5b6d1de$export$cc800923e997bb8(offr)),
                                    $87132ca783c0bc07$export$d9b706f8d0a70aef(function() {
                                        if (edgeSelected) return $8995339af5b6d1de$export$1d56ad1bcc816a96;
                                        return $8995339af5b6d1de$export$c073df10e766abfa;
                                    }()),
                                    $87132ca783c0bc07$export$579295bc0236e309(1.0),
                                    $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("stroke-dasharray")(function() {
                                        if (isPassing) return "6,3";
                                        return "";
                                    }())
                                ]);
                            };
                        };
                        var edgeLines = $8995339af5b6d1de$var$append($8995339af5b6d1de$var$map(mkedge(false))($8995339af5b6d1de$var$fromFoldable1(v.edges.regular)))($8995339af5b6d1de$var$map(mkedge(true))($8995339af5b6d1de$var$fromFoldable4(v.edges.passing)));
                        var bar = [
                            $2d993a5e75b8b38a$export$53f1d5ea8de3d7c([
                                $87132ca783c0bc07$export$cdb484d3c68e5374($8995339af5b6d1de$export$2a1216b12a959364(sett)(v1.slice.x)),
                                $87132ca783c0bc07$export$f07ceed34b807c99($8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(v1.depth)),
                                $87132ca783c0bc07$export$8b7d42aa892c205b($8995339af5b6d1de$export$2a1216b12a959364(sett)(v2.slice.x)),
                                $87132ca783c0bc07$export$bfb0cc6882fbf1fb($8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(v2.depth)),
                                $87132ca783c0bc07$export$d9b706f8d0a70aef($8995339af5b6d1de$export$3b88854f8dcaece2),
                                $87132ca783c0bc07$export$579295bc0236e309(function() {
                                    if (selectable) return $8995339af5b6d1de$export$6ffc8145ac98b432 / 2.0;
                                    return 5.0;
                                }())
                            ])
                        ];
                        return $8995339af5b6d1de$var$pure($2d993a5e75b8b38a$export$39b482c5e57630a8([])($8995339af5b6d1de$var$append(bar)(edgeLines)));
                    });
                }));
            };
        };
    };
};
var $8995339af5b6d1de$export$d39e8cb8559fcf21 = function(sett) {
    return function(graph) {
        return function(selection) {
            var width = $8995339af5b6d1de$export$2a1216b12a959364(sett)(graph.maxx + 2.0);
            var svgTranss = $8995339af5b6d1de$var$map($8995339af5b6d1de$export$b5ef0fc53ffb2a8a(sett)(selection)(graph.slices))($8995339af5b6d1de$var$fromFoldable3($ea3eb84de0acf574$export$68c286be0e7e55b7(graph.transitions)));
            var svgSlices = $8995339af5b6d1de$var$map($8995339af5b6d1de$export$df83866f4f2b1b91(sett)(selection))($8995339af5b6d1de$var$fromFoldable3($ea3eb84de0acf574$export$68c286be0e7e55b7(graph.slices)));
            var svgHoris = $8995339af5b6d1de$var$map($8995339af5b6d1de$export$1a632dc3f58b7346(sett)(selection)(graph.slices))($8995339af5b6d1de$var$fromFoldable3(graph.horis));
            var deepestSize = $06733ae99ed4f534$export$43db023a260c5e9f(1)($8995339af5b6d1de$var$maximum($8995339af5b6d1de$var$map1(function($269) {
                return function(ns) {
                    return $8995339af5b6d1de$var$max($fc8c1182ec2aefec$export$f24224f1c91d8156(ns))(1);
                }($97ffb09cc3d11a32$export$a45279548abf4fad(function(v) {
                    return v.slice;
                }($269)));
            })($3d4fd987da5242ff$export$3dea766d36a8935f(function(s) {
                return s.depth === graph.maxd;
            })($ea3eb84de0acf574$export$68c286be0e7e55b7(graph.slices)))));
            var height = $8995339af5b6d1de$export$6a90eb2e05b7382b(sett)(graph.maxd) + $8995339af5b6d1de$export$cc800923e997bb8(deepestSize + 1 | 0);
            var css = $2d993a5e75b8b38a$export$868461b1c6870d10([])([
                $e5b7e89a68d9c456$export$91f114121fd8ef96([
                    $c959b62ce0c19dfe$export$6f093cfa640b7166(".node, .slice { stroke: none; }")
                ])
            ]);
            return $e5b7e89a68d9c456$export$3327f90baeaa2cb3([
                $2d993a5e75b8b38a$export$7ed1367e7fa1ad68([
                    $87132ca783c0bc07$export$7e3df82ee760448c(width),
                    $87132ca783c0bc07$export$ac607276a8fe9f0a(height),
                    $87132ca783c0bc07$export$a179c88182cb9d56(-$8995339af5b6d1de$export$2a1216b12a959364(sett)(1.0))(-$8995339af5b6d1de$export$cc800923e997bb8(1))(width)(height)
                ])($8995339af5b6d1de$var$append([
                    css
                ])($8995339af5b6d1de$var$append(svgTranss)($8995339af5b6d1de$var$append(svgHoris)(svgSlices))))
            ]);
        };
    };
};
var $8995339af5b6d1de$export$996ee6506200d7e8 = /* #__PURE__ */ $8995339af5b6d1de$export$cc800923e997bb8(2);
var $8995339af5b6d1de$export$ab14d305127e641a = function(sett) {
    return function(graph) {
        return function(isComplete) {
            return function(staffType) {
                var width = $8995339af5b6d1de$export$2a1216b12a959364(sett)(graph.maxx + 1.0) + $8995339af5b6d1de$export$722402e53108e136 / 2.0;
                var systemHeight = function() {
                    var $264 = $8995339af5b6d1de$var$eq3(staffType)($97ffb09cc3d11a32$export$725d191431df39a2.value);
                    if ($264) return $8995339af5b6d1de$export$47168f636f18638d;
                    return $8995339af5b6d1de$export$636f7f6567de9e47;
                }();
                var surfaceRows = function() {
                    if (sett.showSurface) return 1.0;
                    return 0.0;
                }();
                var extraRows = function() {
                    if (isComplete) return 0.0;
                    return 1.0;
                }();
                var height = systemHeight * (graph.maxd + surfaceRows + extraRows) + $8995339af5b6d1de$export$996ee6506200d7e8;
                return $e5b7e89a68d9c456$export$3327f90baeaa2cb3([
                    $2d993a5e75b8b38a$export$7ed1367e7fa1ad68([
                        $87132ca783c0bc07$export$7e3df82ee760448c(width),
                        $87132ca783c0bc07$export$ac607276a8fe9f0a(height),
                        $87132ca783c0bc07$export$a179c88182cb9d56(-$8995339af5b6d1de$export$2a1216b12a959364(sett)(1.0))(0.0)(width)(height),
                        $c959b62ce0c19dfe$export$eff4d24c3ff7876e($8995339af5b6d1de$var$map2(function($270) {
                            return $969bbf7e7aa55092$export$e19cd5f9376f8cee.create($f1eb673e64bdc463$export$bd730340253f3798.create($270));
                        })),
                        $94c2c7ff32ca5bd1$export$1d567c320f4763bc("overflow: visible;")
                    ])([
                        $2d993a5e75b8b38a$export$8454457683f90105("svg")([
                            $94c2c7ff32ca5bd1$export$1d567c320f4763bc("overflow: visible;"),
                            $94c2c7ff32ca5bd1$export$eff4d24c3ff7876e("scoreStaff")
                        ])([])
                    ])
                ]);
            };
        };
    };
};



var $0c07a74dd7e350c8$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $0c07a74dd7e350c8$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $0c07a74dd7e350c8$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($84222ab19bdc98bd$export$172cc2b2b4e6467a);
var $0c07a74dd7e350c8$var$get = /* #__PURE__ */ $f2d5035ce6148af6$export$3988ae62b71be9a3($84222ab19bdc98bd$export$87bf621137788b28);
var $0c07a74dd7e350c8$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($84222ab19bdc98bd$export$be2318e898dcc68);
var $0c07a74dd7e350c8$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$ff461bf68e7dd332);
var $0c07a74dd7e350c8$var$min = /* #__PURE__ */ $97937c29f879e68e$export$96ec731ed4dcb222($97937c29f879e68e$export$ff461bf68e7dd332);
var $0c07a74dd7e350c8$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $0c07a74dd7e350c8$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $6416bd93bb20ed95$export$26082705e1e7e214($364547bd6bbe186e$export$6c410b696f956741));
var $0c07a74dd7e350c8$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $0c07a74dd7e350c8$var$type_ = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$d4a6a4db5b31e621($c959b62ce0c19dfe$export$7333503111bf9adf);
var $0c07a74dd7e350c8$var$value = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$2ab9a8f9f1186f14($c959b62ce0c19dfe$export$32e0d8bef35d3088);
var $0c07a74dd7e350c8$var$readRecord = /* #__PURE__ */ $f505976c723c2a85$export$b400c64e22f7eb4c();
var $0c07a74dd7e350c8$var$readForeignVariant = /* #__PURE__ */ $f505976c723c2a85$export$1f150d367ccc617b();
var $0c07a74dd7e350c8$var$readMaybe = /* #__PURE__ */ $f505976c723c2a85$export$9e57c2acb5b1acde($f505976c723c2a85$export$dda73877cb166cd3);
var $0c07a74dd7e350c8$var$readFieldsCons = /* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "left";
    }
});
var $0c07a74dd7e350c8$var$readFieldsCons1 = /* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "id";
    }
});
var $0c07a74dd7e350c8$var$readRecord1 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons1($f505976c723c2a85$export$dda73877cb166cd3)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "pitch";
    }
})(/* #__PURE__ */ $6416bd93bb20ed95$export$ccd4e2e09b82875e($364547bd6bbe186e$export$8fa8fdf6603d008))($f505976c723c2a85$export$d9e5338498903fce)()())()());
var $0c07a74dd7e350c8$var$readForeignStartStop = /* #__PURE__ */ $97ffb09cc3d11a32$export$7d8a38354856ffb1($0c07a74dd7e350c8$var$readRecord1);
var $0c07a74dd7e350c8$var$readFieldsCons2 = /* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "right";
    }
});
var $0c07a74dd7e350c8$var$readRecord2 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons($0c07a74dd7e350c8$var$readForeignStartStop)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons2($0c07a74dd7e350c8$var$readForeignStartStop)($f505976c723c2a85$export$d9e5338498903fce)()())()());
var $0c07a74dd7e350c8$var$readArray = /* #__PURE__ */ $f505976c723c2a85$export$d3f4ca0e55363719($0c07a74dd7e350c8$var$readRecord2);
var $0c07a74dd7e350c8$var$readRecord3 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "prevTime";
    }
})($0c07a74dd7e350c8$var$readMaybe)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "ties";
    }
})($0c07a74dd7e350c8$var$readArray)($f505976c723c2a85$export$d9e5338498903fce)()())()());
var $0c07a74dd7e350c8$var$readFieldsCons3 = /* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "children";
    }
});
var $0c07a74dd7e350c8$var$readFieldsCons4 = /* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "child";
    }
});
var $0c07a74dd7e350c8$var$readArray1 = /* #__PURE__ */ $f505976c723c2a85$export$d3f4ca0e55363719($0c07a74dd7e350c8$var$readRecord1);
var $0c07a74dd7e350c8$var$readRecord4 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons($0c07a74dd7e350c8$var$readArray1)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons2($0c07a74dd7e350c8$var$readArray1)($f505976c723c2a85$export$d9e5338498903fce)()())()());
var $0c07a74dd7e350c8$var$readFieldsCons5 = /* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "parent";
    }
});
var $0c07a74dd7e350c8$var$readFieldsCons6 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons5($0c07a74dd7e350c8$var$readRecord1)($f505976c723c2a85$export$d9e5338498903fce)()();
var $0c07a74dd7e350c8$var$readFieldsCons7 = /* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "ids";
    }
});
var $0c07a74dd7e350c8$var$readFieldsCons8 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons($97ffb09cc3d11a32$export$d90eb951ab102d5b);
var $0c07a74dd7e350c8$var$readFieldsCons9 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons2($97ffb09cc3d11a32$export$d90eb951ab102d5b);
var $0c07a74dd7e350c8$var$readFieldsCons10 = /* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "rslice";
    }
});
var $0c07a74dd7e350c8$var$readFieldsCons11 = /* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "passing";
    }
});
var $0c07a74dd7e350c8$var$readFieldsCons12 = /* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "regular";
    }
});
var $0c07a74dd7e350c8$var$readRecord5 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons11($0c07a74dd7e350c8$var$readArray)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons12($0c07a74dd7e350c8$var$readArray)($f505976c723c2a85$export$d9e5338498903fce)()())()());
var $0c07a74dd7e350c8$var$readFieldsCons13 = /* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "unexplained";
    }
});
var $0c07a74dd7e350c8$var$readFieldsCons14 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons3(/* #__PURE__ */ $f505976c723c2a85$export$d3f4ca0e55363719(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons4($0c07a74dd7e350c8$var$readRecord1)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "orn";
    }
})($0c07a74dd7e350c8$var$readMaybe)($f505976c723c2a85$export$d9e5338498903fce)()())()())));
var $0c07a74dd7e350c8$var$readArray2 = /* #__PURE__ */ $f505976c723c2a85$export$d3f4ca0e55363719(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons14($0c07a74dd7e350c8$var$readFieldsCons6)()()));
var $0c07a74dd7e350c8$var$readArray3 = /* #__PURE__ */ $f505976c723c2a85$export$d3f4ca0e55363719(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons14(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons5($0c07a74dd7e350c8$var$readRecord2)($f505976c723c2a85$export$d9e5338498903fce)()())()()));
var $0c07a74dd7e350c8$var$readRecord6 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "fromLeft";
    }
})($0c07a74dd7e350c8$var$readArray2)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "fromRight";
    }
})($0c07a74dd7e350c8$var$readArray2)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons7(/* #__PURE__ */ $f505976c723c2a85$export$9e57c2acb5b1acde(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons8(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons9(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "slice";
    }
})($97ffb09cc3d11a32$export$9553db49b6c4bcae)($f505976c723c2a85$export$d9e5338498903fce)()())()())()())))(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "keepLeft";
    }
})($0c07a74dd7e350c8$var$readArray)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "keepRight";
    }
})($0c07a74dd7e350c8$var$readArray)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "passLeft";
    }
})($0c07a74dd7e350c8$var$readArray)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "passRight";
    }
})($0c07a74dd7e350c8$var$readArray)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons11($0c07a74dd7e350c8$var$readArray3)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons12($0c07a74dd7e350c8$var$readArray3)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons13(/* #__PURE__ */ $f505976c723c2a85$export$9e57c2acb5b1acde($0c07a74dd7e350c8$var$readArray1))($f505976c723c2a85$export$d9e5338498903fce)()())()())()())()())()())()())()())()())()())()());
var $0c07a74dd7e350c8$var$readRecord7 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons1(/* #__PURE__ */ $f505976c723c2a85$export$9e57c2acb5b1acde($97ffb09cc3d11a32$export$9553db49b6c4bcae))(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "notes";
    }
})(/* #__PURE__ */ $97ffb09cc3d11a32$export$7d8a38354856ffb1($0c07a74dd7e350c8$var$readArray1))($f505976c723c2a85$export$d9e5338498903fce)()())()());
var $0c07a74dd7e350c8$var$readRecord8 = /* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "classes";
    }
})($f505976c723c2a85$export$dda73877cb166cd3)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "label";
    }
})($f505976c723c2a85$export$dda73877cb166cd3)($f505976c723c2a85$export$d9e5338498903fce)()())()());
var $0c07a74dd7e350c8$var$readObject = /* #__PURE__ */ $f505976c723c2a85$export$a06d200e21d81178($0c07a74dd7e350c8$var$readRecord8);
var $0c07a74dd7e350c8$var$readJSON = /* #__PURE__ */ $f505976c723c2a85$export$ce30717759bc230c(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "derivation";
    }
})(/* #__PURE__ */ $f505976c723c2a85$export$d3f4ca0e55363719(/* #__PURE__ */ $0c07a74dd7e350c8$var$readForeignVariant(/* #__PURE__ */ $f505976c723c2a85$export$e9afada173d3b0af({
    reflectSymbol: function() {
        return "freezeLeft";
    }
})($0c07a74dd7e350c8$var$readRecord3)()(/* #__PURE__ */ $f505976c723c2a85$export$e9afada173d3b0af({
    reflectSymbol: function() {
        return "freezeOnly";
    }
})($0c07a74dd7e350c8$var$readRecord3)()(/* #__PURE__ */ $f505976c723c2a85$export$e9afada173d3b0af({
    reflectSymbol: function() {
        return "hori";
    }
})(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons3(/* #__PURE__ */ $f505976c723c2a85$export$d3f4ca0e55363719(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons4(/* #__PURE__ */ $0c07a74dd7e350c8$var$readForeignVariant(/* #__PURE__ */ $f505976c723c2a85$export$e9afada173d3b0af({
    reflectSymbol: function() {
        return "bothChildren";
    }
})(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons($0c07a74dd7e350c8$var$readRecord1)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons2($0c07a74dd7e350c8$var$readRecord1)($f505976c723c2a85$export$d9e5338498903fce)()())()()))()(/* #__PURE__ */ $f505976c723c2a85$export$e9afada173d3b0af({
    reflectSymbol: function() {
        return "leftChild";
    }
})($0c07a74dd7e350c8$var$readRecord1)()(/* #__PURE__ */ $f505976c723c2a85$export$e9afada173d3b0af({
    reflectSymbol: function() {
        return "rightChild";
    }
})($0c07a74dd7e350c8$var$readRecord1)()(/* #__PURE__ */ $f505976c723c2a85$export$e9afada173d3b0af({
    reflectSymbol: function() {
        return "tooManyChildren";
    }
})($0c07a74dd7e350c8$var$readRecord4)()($f505976c723c2a85$export$72b2f5ffdc95828a))))))($0c07a74dd7e350c8$var$readFieldsCons6)()())))(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons7(/* #__PURE__ */ $f505976c723c2a85$export$9e57c2acb5b1acde(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons8(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "lslice";
    }
})($97ffb09cc3d11a32$export$9553db49b6c4bcae)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "mid";
    }
})($97ffb09cc3d11a32$export$d90eb951ab102d5b)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons9(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons10($97ffb09cc3d11a32$export$9553db49b6c4bcae)($f505976c723c2a85$export$d9e5338498903fce)()())()())()())()())()())))(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "midEdges";
    }
})($0c07a74dd7e350c8$var$readRecord5)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons13(/* #__PURE__ */ $f505976c723c2a85$export$9e57c2acb5b1acde($0c07a74dd7e350c8$var$readRecord4))($f505976c723c2a85$export$d9e5338498903fce)()())()())()())()()))()(/* #__PURE__ */ $f505976c723c2a85$export$e9afada173d3b0af({
    reflectSymbol: function() {
        return "splitLeft";
    }
})($0c07a74dd7e350c8$var$readRecord6)()(/* #__PURE__ */ $f505976c723c2a85$export$e9afada173d3b0af({
    reflectSymbol: function() {
        return "splitOnly";
    }
})($0c07a74dd7e350c8$var$readRecord6)()(/* #__PURE__ */ $f505976c723c2a85$export$e9afada173d3b0af({
    reflectSymbol: function() {
        return "splitRight";
    }
})($0c07a74dd7e350c8$var$readRecord6)()($f505976c723c2a85$export$72b2f5ffdc95828a)))))))))(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "start";
    }
})($0c07a74dd7e350c8$var$readRecord7)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "styles";
    }
})(/* #__PURE__ */ $f505976c723c2a85$export$9e57c2acb5b1acde(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "css";
    }
})($f505976c723c2a85$export$dda73877cb166cd3)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "edgeStyles";
    }
})(/* #__PURE__ */ $f505976c723c2a85$export$d3f4ca0e55363719(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "edge";
    }
})(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons($f505976c723c2a85$export$dda73877cb166cd3)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons2($f505976c723c2a85$export$dda73877cb166cd3)($f505976c723c2a85$export$d9e5338498903fce)()())()()))(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "style";
    }
})($0c07a74dd7e350c8$var$readRecord8)($f505976c723c2a85$export$d9e5338498903fce)()())()())))(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "noteStyles";
    }
})($0c07a74dd7e350c8$var$readObject)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "sliceStyles";
    }
})($0c07a74dd7e350c8$var$readObject)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "staffType";
    }
})($f505976c723c2a85$export$dda73877cb166cd3)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "transStyles";
    }
})($0c07a74dd7e350c8$var$readObject)($f505976c723c2a85$export$d9e5338498903fce)()())()())()())()())()())()())))(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "topSegments";
    }
})(/* #__PURE__ */ $f505976c723c2a85$export$d3f4ca0e55363719(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons10($0c07a74dd7e350c8$var$readRecord7)(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "trans";
    }
})(/* #__PURE__ */ $0c07a74dd7e350c8$var$readRecord(/* #__PURE__ */ $f505976c723c2a85$export$5b101d49c7918908({
    reflectSymbol: function() {
        return "edges";
    }
})($0c07a74dd7e350c8$var$readRecord5)(/* #__PURE__ */ $0c07a74dd7e350c8$var$readFieldsCons1(/* #__PURE__ */ $f505976c723c2a85$export$9e57c2acb5b1acde($97ffb09cc3d11a32$export$d90eb951ab102d5b))($f505976c723c2a85$export$d9e5338498903fce)()())()()))($f505976c723c2a85$export$d9e5338498903fce)()())()())))($f505976c723c2a85$export$d9e5338498903fce)()())()())()())()()));
var $0c07a74dd7e350c8$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $0c07a74dd7e350c8$var$discard1 = /* #__PURE__ */ $0c07a74dd7e350c8$var$discard($84222ab19bdc98bd$export$172cc2b2b4e6467a);
var $0c07a74dd7e350c8$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($84222ab19bdc98bd$export$bf09f5de576f9cf1);
var $0c07a74dd7e350c8$var$modify_ = /* #__PURE__ */ $f2d5035ce6148af6$export$45b91115a89d6020($84222ab19bdc98bd$export$87bf621137788b28);
var $0c07a74dd7e350c8$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $0c07a74dd7e350c8$var$discard2 = /* #__PURE__ */ $0c07a74dd7e350c8$var$discard($edf0339512807bee$export$f885f489dcf38a2d);
var $0c07a74dd7e350c8$var$bind3 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $0c07a74dd7e350c8$var$for_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$9747ee7caa0b40b1($edf0339512807bee$export$9dc0454a98607988)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $0c07a74dd7e350c8$export$ca8ad3bf2e5ecb64 = function(step) {
    return function(max1) {
        return function(model) {
            return function(cache) {
                return $0c07a74dd7e350c8$var$bind($7d4cccdf062a2261$export$3a6c138b8d0f3874($f1eb673e64bdc463$export$ca03650e5de7965d(model)(step)(cache)))(function(modelPruned) {
                    var surface = $f1eb673e64bdc463$export$c90c001b7fe12473(modelPruned)(step)(cache);
                    var graph = $f1eb673e64bdc463$export$6164af773253b68d(modelPruned)(step)(cache);
                    return $0c07a74dd7e350c8$var$pure({
                        model: model,
                        step: step,
                        max: max1,
                        modelPruned: modelPruned,
                        graph: graph,
                        surface: surface
                    });
                });
            };
        };
    };
};
var $0c07a74dd7e350c8$export$431f15567ee500d1 = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3($84222ab19bdc98bd$export$aecceb0bc1bf10d9(dictMonadEffect));
    return $0c07a74dd7e350c8$var$bind1($0c07a74dd7e350c8$var$get)(function(st) {
        var update = $0c07a74dd7e350c8$var$bind(st.model)(function(v) {
            return $0c07a74dd7e350c8$var$bind(st.scoreElt)(function(scoreElt) {
                var totalWidth = $8995339af5b6d1de$export$2a1216b12a959364(st.settings)($4ab74a20512cef04$export$a0a81dc3380ce7d3($fc8c1182ec2aefec$export$f24224f1c91d8156(v.model.piece))) + $8995339af5b6d1de$export$722402e53108e136 / 2.0;
                var toX = function(x) {
                    return $8995339af5b6d1de$export$2a1216b12a959364(st.settings)(x);
                };
                var select = function(sel) {
                    return $8360250a454b77aa$export$5e14cdade93d6f7b(st.eventListener)(new $f1eb673e64bdc463$export$ef9b1a59e592288f(sel));
                };
                return $0c07a74dd7e350c8$var$pure(liftEffect($35bc4e367cd5ccd9$export$6bb651de1912795c(scoreElt)($8b937fc9e68d0c00$export$82663a99a7d2fb99(v.graph)(v.model.piece)(v.surface)(v.model.styles)(st.selected)(new $06733ae99ed4f534$export$8a67b48435b5d073(select))(toX)(totalWidth)($8995339af5b6d1de$export$f466435ed7b4eeb7)(st.settings.showSurface))));
            });
        });
        return $06733ae99ed4f534$export$43db023a260c5e9f($0c07a74dd7e350c8$var$pure1($05149ea687d6b460$export$523c0b569236b342))(update);
    });
};
var $0c07a74dd7e350c8$export$b3a8ec9ca4dfb8f7 = function(dictMonadEffect) {
    return function(dictMonadAff) {
        var MonadEffect0 = dictMonadAff.MonadEffect0();
        var log = $ec52a8164fabd1b2$export$bef1f36f5486a6a3($84222ab19bdc98bd$export$aecceb0bc1bf10d9(MonadEffect0));
        var redrawScore1 = $0c07a74dd7e350c8$export$431f15567ee500d1(MonadEffect0);
        return function(prefix) {
            return function(v) {
                var setStep = function(f) {
                    return function(st) {
                        return $06733ae99ed4f534$export$43db023a260c5e9f(st)($0c07a74dd7e350c8$var$bind(st.model)(function(v1) {
                            var step$prime = $0c07a74dd7e350c8$var$max(0)($0c07a74dd7e350c8$var$min(v1.max)(f(v1.step)));
                            return $0c07a74dd7e350c8$var$bind($0c07a74dd7e350c8$export$ca8ad3bf2e5ecb64(step$prime)(v1.max)(v1.model)(st.cache))(function(model$prime) {
                                return $0c07a74dd7e350c8$var$pure(function() {
                                    var $512 = {};
                                    for(var $513 in st)if (({}).hasOwnProperty.call(st, $513)) $512[$513] = st[$513];
                                    $512.model = new $06733ae99ed4f534$export$8a67b48435b5d073(model$prime);
                                    return $512;
                                }());
                            });
                        }));
                    };
                };
                var render = function(st) {
                    if (st.model instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $e5b7e89a68d9c456$export$159d9494db57879b([
                        $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-content")
                    ])([
                        $c959b62ce0c19dfe$export$6f093cfa640b7166("No analysis loaded.")
                    ]);
                    if (st.model instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $e5b7e89a68d9c456$export$159d9494db57879b([
                        $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-widget")
                    ])([
                        $e5b7e89a68d9c456$export$38e42c68cf43b5d4([
                            $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-content pv-controls")
                        ])([
                            $e5b7e89a68d9c456$export$159d9494db57879b([
                                $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-toolbar")
                            ])([
                                $e5b7e89a68d9c456$export$2ba01fb71ed41cb6([
                                    $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-button pure-button"),
                                    $10ae9db6658426ac$export$1d5a917feb871989(function(v1) {
                                        return $f1eb673e64bdc463$export$b6aba7a5890f6a89.value;
                                    }),
                                    $94c2c7ff32ca5bd1$export$683472f6198a076e(st.model.value0.step <= 0),
                                    $94c2c7ff32ca5bd1$export$fb184b623420d9be("Move to first step")
                                ])([
                                    $c959b62ce0c19dfe$export$6f093cfa640b7166("<< First")
                                ]),
                                $e5b7e89a68d9c456$export$2ba01fb71ed41cb6([
                                    $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-button pure-button"),
                                    $10ae9db6658426ac$export$1d5a917feb871989(function(v1) {
                                        return $f1eb673e64bdc463$export$277588d017c813a.value;
                                    }),
                                    $94c2c7ff32ca5bd1$export$683472f6198a076e(st.model.value0.step <= 0),
                                    $94c2c7ff32ca5bd1$export$fb184b623420d9be("Move one step back")
                                ])([
                                    $c959b62ce0c19dfe$export$6f093cfa640b7166("< Previous")
                                ]),
                                $e5b7e89a68d9c456$export$2ba01fb71ed41cb6([
                                    $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-button pure-button"),
                                    $10ae9db6658426ac$export$1d5a917feb871989(function(v1) {
                                        return $f1eb673e64bdc463$export$7724b1686f1f8cff.value;
                                    }),
                                    $94c2c7ff32ca5bd1$export$683472f6198a076e(st.model.value0.step >= st.model.value0.max),
                                    $94c2c7ff32ca5bd1$export$fb184b623420d9be("Move one step forward")
                                ])([
                                    $c959b62ce0c19dfe$export$6f093cfa640b7166("Next >")
                                ]),
                                $e5b7e89a68d9c456$export$2ba01fb71ed41cb6([
                                    $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-button pure-button"),
                                    $10ae9db6658426ac$export$1d5a917feb871989(function(v1) {
                                        return $f1eb673e64bdc463$export$409dc52471920c77.value;
                                    }),
                                    $94c2c7ff32ca5bd1$export$683472f6198a076e(st.model.value0.step >= st.model.value0.max),
                                    $94c2c7ff32ca5bd1$export$fb184b623420d9be("Move to last step")
                                ])([
                                    $c959b62ce0c19dfe$export$6f093cfa640b7166("Last >>")
                                ]),
                                $e5b7e89a68d9c456$export$afc1bfabebaf28a2([
                                    $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-step")
                                ])([
                                    $c959b62ce0c19dfe$export$6f093cfa640b7166(" Step " + ($0c07a74dd7e350c8$var$show(st.model.value0.step) + (" of " + ($0c07a74dd7e350c8$var$show(st.model.value0.max) + "."))))
                                ]),
                                $e5b7e89a68d9c456$export$afc1bfabebaf28a2([
                                    $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-step")
                                ])([
                                    function() {
                                        if (st.selected instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $c959b62ce0c19dfe$export$6f093cfa640b7166("Note selected: " + ($0c07a74dd7e350c8$var$show1(st.selected.value0.note.pitch) + (", " + ($f1eb673e64bdc463$export$3b0bdf174ee79f95(st.selected.value0.expl) + "."))));
                                        if (st.selected instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $c959b62ce0c19dfe$export$6f093cfa640b7166("No note selected.");
                                        throw new Error("Failed pattern match at Main (line 156, column 23 - line 158, column 63): " + [
                                            st.selected.constructor.name
                                        ]);
                                    }()
                                ]),
                                $e5b7e89a68d9c456$export$159d9494db57879b([
                                    $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-spacer")
                                ])([]),
                                $e5b7e89a68d9c456$export$2ba01fb71ed41cb6([
                                    $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-button pure-button" + function() {
                                        if (st.settings.showSettings) return " pv-button-pressed pure-button-active";
                                        return "";
                                    }()),
                                    $10ae9db6658426ac$export$1d5a917feb871989(function(v1) {
                                        return $f1eb673e64bdc463$export$fc8740e8b4ad5c9b.value;
                                    }),
                                    $94c2c7ff32ca5bd1$export$fb184b623420d9be("Show or hide settings")
                                ])([
                                    $c959b62ce0c19dfe$export$6f093cfa640b7166("Settings")
                                ])
                            ]),
                            function() {
                                if (st.settings.showSettings) return $e5b7e89a68d9c456$export$3327f90baeaa2cb3([
                                    $e5b7e89a68d9c456$export$159d9494db57879b([
                                        $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-control-box")
                                    ])([
                                        $e5b7e89a68d9c456$export$1237798dc640739a([
                                            $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-control-label"),
                                            $94c2c7ff32ca5bd1$export$f89de2e5bf57e5e6("xscale")
                                        ])([
                                            $c959b62ce0c19dfe$export$6f093cfa640b7166("horizontal zoom: " + $0c07a74dd7e350c8$var$show2(st.settings.xscale))
                                        ]),
                                        $e5b7e89a68d9c456$export$b7e3ae3d7c15e42e([
                                            $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-control-range"),
                                            $0c07a74dd7e350c8$var$type_($cec7e3152401d818$export$7fd9b60c3e71d3cc.value),
                                            $94c2c7ff32ca5bd1$export$96ec731ed4dcb222(-5),
                                            $94c2c7ff32ca5bd1$export$8960430cfd85939f(0.0),
                                            $94c2c7ff32ca5bd1$export$35d34bc0ed591a92(new $9c6cb90b338ac9f8$export$fd55ce593607084a(1.0e-2)),
                                            $0c07a74dd7e350c8$var$value($0c07a74dd7e350c8$var$show2(st.settings.xscale)),
                                            $10ae9db6658426ac$export$faef864395e27f71($f1eb673e64bdc463$export$33b961eeb5124842.create),
                                            $94c2c7ff32ca5bd1$export$a8ff84c12d48cfa6("xscale")
                                        ])
                                    ]),
                                    $e5b7e89a68d9c456$export$159d9494db57879b([
                                        $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-control-box")
                                    ])([
                                        $e5b7e89a68d9c456$export$1237798dc640739a([
                                            $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-control-label"),
                                            $94c2c7ff32ca5bd1$export$f89de2e5bf57e5e6("yscale")
                                        ])([
                                            $c959b62ce0c19dfe$export$6f093cfa640b7166("vertical zoom: " + $0c07a74dd7e350c8$var$show2(st.settings.yscale))
                                        ]),
                                        $e5b7e89a68d9c456$export$b7e3ae3d7c15e42e([
                                            $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-control-range"),
                                            $0c07a74dd7e350c8$var$type_($cec7e3152401d818$export$7fd9b60c3e71d3cc.value),
                                            $94c2c7ff32ca5bd1$export$96ec731ed4dcb222(-2),
                                            $94c2c7ff32ca5bd1$export$8960430cfd85939f(2.0),
                                            $94c2c7ff32ca5bd1$export$35d34bc0ed591a92(new $9c6cb90b338ac9f8$export$fd55ce593607084a(1.0e-2)),
                                            $0c07a74dd7e350c8$var$value($0c07a74dd7e350c8$var$show2(st.settings.yscale)),
                                            $10ae9db6658426ac$export$faef864395e27f71($f1eb673e64bdc463$export$8a710b6e46000772.create),
                                            $94c2c7ff32ca5bd1$export$a8ff84c12d48cfa6("yscale")
                                        ])
                                    ]),
                                    $e5b7e89a68d9c456$export$159d9494db57879b([
                                        $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-control-box")
                                    ])([
                                        $e5b7e89a68d9c456$export$b7e3ae3d7c15e42e([
                                            $0c07a74dd7e350c8$var$type_($cec7e3152401d818$export$fa1253a65a9e747d.value),
                                            $94c2c7ff32ca5bd1$export$b96bb35bc88d6fa(st.settings.showInner),
                                            $10ae9db6658426ac$export$bd913411069e59d3(function(v1) {
                                                return $f1eb673e64bdc463$export$6d97fde8de427947.value;
                                            }),
                                            $94c2c7ff32ca5bd1$export$d560c7e4a29451c2(prefix + "showInnerGraph")
                                        ]),
                                        $e5b7e89a68d9c456$export$1237798dc640739a([
                                            $94c2c7ff32ca5bd1$export$f89de2e5bf57e5e6(prefix + "showInnerGraph")
                                        ])([
                                            $c959b62ce0c19dfe$export$6f093cfa640b7166("show inner graph")
                                        ])
                                    ]),
                                    $e5b7e89a68d9c456$export$159d9494db57879b([
                                        $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pure-g")
                                    ])([
                                        $e5b7e89a68d9c456$export$159d9494db57879b([
                                            $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pure-u-1-2 pv-control-box")
                                        ])([
                                            $e5b7e89a68d9c456$export$b7e3ae3d7c15e42e([
                                                $0c07a74dd7e350c8$var$type_($cec7e3152401d818$export$fa1253a65a9e747d.value),
                                                $94c2c7ff32ca5bd1$export$b96bb35bc88d6fa(st.settings.showScore),
                                                $10ae9db6658426ac$export$bd913411069e59d3(function(v1) {
                                                    return $f1eb673e64bdc463$export$3e466d3389bb1f1c.value;
                                                }),
                                                $94c2c7ff32ca5bd1$export$d560c7e4a29451c2(prefix + "showScore")
                                            ]),
                                            $e5b7e89a68d9c456$export$1237798dc640739a([
                                                $94c2c7ff32ca5bd1$export$f89de2e5bf57e5e6(prefix + "showScore")
                                            ])([
                                                $c959b62ce0c19dfe$export$6f093cfa640b7166("show score")
                                            ])
                                        ]),
                                        $e5b7e89a68d9c456$export$159d9494db57879b([
                                            $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pure-u-1-2 pv-control-box")
                                        ])([
                                            $e5b7e89a68d9c456$export$b7e3ae3d7c15e42e([
                                                $0c07a74dd7e350c8$var$type_($cec7e3152401d818$export$fa1253a65a9e747d.value),
                                                $94c2c7ff32ca5bd1$export$b96bb35bc88d6fa(st.settings.showSurface),
                                                $94c2c7ff32ca5bd1$export$25eaa035e2e3a214(st.settings.showScore),
                                                $10ae9db6658426ac$export$bd913411069e59d3(function(v1) {
                                                    return $f1eb673e64bdc463$export$8ca4a597184afb0b.value;
                                                }),
                                                $94c2c7ff32ca5bd1$export$d560c7e4a29451c2(prefix + "showSurface")
                                            ]),
                                            $e5b7e89a68d9c456$export$1237798dc640739a([
                                                $94c2c7ff32ca5bd1$export$f89de2e5bf57e5e6(prefix + "showSurface")
                                            ])([
                                                $c959b62ce0c19dfe$export$6f093cfa640b7166("show surface below graph")
                                            ])
                                        ])
                                    ]),
                                    $e5b7e89a68d9c456$export$159d9494db57879b([
                                        $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-control-box")
                                    ])([
                                        $e5b7e89a68d9c456$export$b7e3ae3d7c15e42e([
                                            $0c07a74dd7e350c8$var$type_($cec7e3152401d818$export$fa1253a65a9e747d.value),
                                            $94c2c7ff32ca5bd1$export$b96bb35bc88d6fa(st.settings.showOuter),
                                            $10ae9db6658426ac$export$bd913411069e59d3(function(v1) {
                                                return $f1eb673e64bdc463$export$5aa6d5fa95bc8563.value;
                                            }),
                                            $94c2c7ff32ca5bd1$export$d560c7e4a29451c2(prefix + "showOuterGraph")
                                        ]),
                                        $e5b7e89a68d9c456$export$1237798dc640739a([
                                            $94c2c7ff32ca5bd1$export$f89de2e5bf57e5e6(prefix + "showOuterGraph")
                                        ])([
                                            $c959b62ce0c19dfe$export$6f093cfa640b7166("show outer graph")
                                        ])
                                    ])
                                ]);
                                return $c959b62ce0c19dfe$export$6f093cfa640b7166("");
                            }()
                        ]),
                        $e5b7e89a68d9c456$export$159d9494db57879b([
                            $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-wide")
                        ])([
                            $e5b7e89a68d9c456$export$159d9494db57879b([
                                $f1eb673e64bdc463$export$dbf49ecbc3d3d264("pv-graph")
                            ])([
                                function() {
                                    if (st.settings.showInner) return $8995339af5b6d1de$export$c10510da686dd2c5(st.settings)(st.selected)(st.model.value0.surface)(st.model.value0.graph);
                                    return $c959b62ce0c19dfe$export$6f093cfa640b7166("");
                                }(),
                                function() {
                                    if (st.settings.showScore) return $8995339af5b6d1de$export$ab14d305127e641a(st.settings)(st.model.value0.graph)($3d4fd987da5242ff$export$f24224f1c91d8156(st.model.value0.model.reduction.segments) === 1)(st.model.value0.model.styles.staff);
                                    return $c959b62ce0c19dfe$export$6f093cfa640b7166("");
                                }(),
                                function() {
                                    if (st.settings.showOuter) return $8995339af5b6d1de$export$d39e8cb8559fcf21(st.settings)(st.model.value0.graph)(st.selected);
                                    return $c959b62ce0c19dfe$export$6f093cfa640b7166("");
                                }()
                            ])
                        ])
                    ]);
                    throw new Error("Failed pattern match at Main (line 118, column 15 - line 256, column 10): " + [
                        st.model.constructor.name
                    ]);
                };
                var initialState = function(v1) {
                    var model = $0c07a74dd7e350c8$var$bind($7d4cccdf062a2261$export$3a6c138b8d0f3874($0c07a74dd7e350c8$var$readJSON(v1.json)))(function(v2) {
                        return $0c07a74dd7e350c8$var$bind($7d4cccdf062a2261$export$3a6c138b8d0f3874($8912ce2c57a5c27a$export$6e76de3ed4e5bd6a(v2)))(function(m) {
                            var max1 = $b1271574b14e8498$export$f85024a1fb7f2fed(m.reduction);
                            return $0c07a74dd7e350c8$var$pure({
                                model: m,
                                modelPruned: m,
                                step: max1,
                                max: max1
                            });
                        });
                    });
                    var cache = function() {
                        if (model instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $f1eb673e64bdc463$export$317576aef8adc076(model.value0.model)(model.value0.step)($f1eb673e64bdc463$export$8dc30353b93985d6);
                        if (model instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f1eb673e64bdc463$export$8dc30353b93985d6;
                        throw new Error("Failed pattern match at Main (line 113, column 13 - line 115, column 28): " + [
                            model.constructor.name
                        ]);
                    }();
                    return {
                        model: function() {
                            if (model instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $0c07a74dd7e350c8$export$ca8ad3bf2e5ecb64(model.value0.step)(model.value0.max)(model.value0.model)(cache);
                            if (model instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                            throw new Error("Failed pattern match at Main (line 96, column 9 - line 98, column 29): " + [
                                model.constructor.name
                            ]);
                        }(),
                        cache: cache,
                        settings: v1.settings,
                        selected: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                        scoreElt: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                        eventListener: v.listener
                    };
                };
                var handleAction = function(v1) {
                    if (v1 instanceof $f1eb673e64bdc463$export$7fc4381d95dc76c8) return $0c07a74dd7e350c8$var$pure1($05149ea687d6b460$export$523c0b569236b342);
                    if (v1 instanceof $f1eb673e64bdc463$export$d050db8f6426404e) return $0c07a74dd7e350c8$var$discard1(log("initializing."))(function() {
                        return $0c07a74dd7e350c8$var$$$void($84222ab19bdc98bd$export$ec068583843480e7(v.emitter));
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$ef9b1a59e592288f) return $0c07a74dd7e350c8$var$discard1($0c07a74dd7e350c8$var$modify_(function(st) {
                        var $541 = {};
                        for(var $542 in st)if (({}).hasOwnProperty.call(st, $542)) $541[$542] = st[$542];
                        $541.selected = v1.value0;
                        return $541;
                    }))(function() {
                        return redrawScore1;
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$7724b1686f1f8cff) return $0c07a74dd7e350c8$var$discard1($0c07a74dd7e350c8$var$modify_(setStep(function(v2) {
                        return v2 + 1 | 0;
                    })))(function() {
                        return redrawScore1;
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$277588d017c813a) return $0c07a74dd7e350c8$var$discard1($0c07a74dd7e350c8$var$modify_(setStep(function(v2) {
                        return v2 - 1 | 0;
                    })))(function() {
                        return redrawScore1;
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$b6aba7a5890f6a89) return $0c07a74dd7e350c8$var$discard1($0c07a74dd7e350c8$var$modify_(setStep($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(0))))(function() {
                        return redrawScore1;
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$409dc52471920c77) return $0c07a74dd7e350c8$var$discard1($0c07a74dd7e350c8$var$modify_(function(st) {
                        if (st.model instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return setStep($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(st.model.value0.max))(st);
                        if (st.model instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return st;
                        throw new Error("Failed pattern match at Main (line 284, column 24 - line 286, column 22): " + [
                            st.model.constructor.name
                        ]);
                    }))(function() {
                        return redrawScore1;
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$bd730340253f3798) return $0c07a74dd7e350c8$var$discard1($0c07a74dd7e350c8$var$modify_(function(st) {
                        var $548 = {};
                        for(var $549 in st)if (({}).hasOwnProperty.call(st, $549)) $548[$549] = st[$549];
                        $548.scoreElt = new $06733ae99ed4f534$export$8a67b48435b5d073(v1.value0);
                        return $548;
                    }))(function() {
                        return redrawScore1;
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$fc8740e8b4ad5c9b) return $0c07a74dd7e350c8$var$modify_(function(st) {
                        var $555 = {};
                        for(var $556 in st)if (({}).hasOwnProperty.call(st, $556)) $555[$556] = st[$556];
                        $555.settings = function() {
                            var $552 = {};
                            for(var $553 in st.settings)if (({}).hasOwnProperty.call(st.settings, $553)) $552[$553] = st["settings"][$553];
                            $552.showSettings = !st.settings.showSettings;
                            return $552;
                        }();
                        return $555;
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$6d97fde8de427947) return $0c07a74dd7e350c8$var$modify_(function(st) {
                        var $561 = {};
                        for(var $562 in st)if (({}).hasOwnProperty.call(st, $562)) $561[$562] = st[$562];
                        $561.settings = function() {
                            var $558 = {};
                            for(var $559 in st.settings)if (({}).hasOwnProperty.call(st.settings, $559)) $558[$559] = st["settings"][$559];
                            $558.showInner = !st.settings.showInner;
                            return $558;
                        }();
                        return $561;
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$5aa6d5fa95bc8563) return $0c07a74dd7e350c8$var$modify_(function(st) {
                        var $567 = {};
                        for(var $568 in st)if (({}).hasOwnProperty.call(st, $568)) $567[$568] = st[$568];
                        $567.settings = function() {
                            var $564 = {};
                            for(var $565 in st.settings)if (({}).hasOwnProperty.call(st.settings, $565)) $564[$565] = st["settings"][$565];
                            $564.showOuter = !st.settings.showOuter;
                            return $564;
                        }();
                        return $567;
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$3e466d3389bb1f1c) return $0c07a74dd7e350c8$var$modify_(function(st) {
                        var $573 = {};
                        for(var $574 in st)if (({}).hasOwnProperty.call(st, $574)) $573[$574] = st[$574];
                        $573.settings = function() {
                            var $570 = {};
                            for(var $571 in st.settings)if (({}).hasOwnProperty.call(st.settings, $571)) $570[$571] = st["settings"][$571];
                            $570.showScore = !st.settings.showScore;
                            return $570;
                        }();
                        return $573;
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$8ca4a597184afb0b) return $0c07a74dd7e350c8$var$discard1($0c07a74dd7e350c8$var$modify_(function(st) {
                        var $579 = {};
                        for(var $580 in st)if (({}).hasOwnProperty.call(st, $580)) $579[$580] = st[$580];
                        $579.settings = function() {
                            var $576 = {};
                            for(var $577 in st.settings)if (({}).hasOwnProperty.call(st.settings, $577)) $576[$577] = st["settings"][$577];
                            $576.showSurface = !st.settings.showSurface;
                            return $576;
                        }();
                        return $579;
                    }))(function() {
                        return redrawScore1;
                    });
                    if (v1 instanceof $f1eb673e64bdc463$export$33b961eeb5124842) {
                        var v2 = $052de1c85deb22bf$export$3004f64547af360e(v1.value0);
                        if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $0c07a74dd7e350c8$var$pure1($05149ea687d6b460$export$523c0b569236b342);
                        if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $0c07a74dd7e350c8$var$discard1($0c07a74dd7e350c8$var$modify_(function(st) {
                            var $586 = {};
                            for(var $587 in st)if (({}).hasOwnProperty.call(st, $587)) $586[$587] = st[$587];
                            $586.settings = function() {
                                var $583 = {};
                                for(var $584 in st.settings)if (({}).hasOwnProperty.call(st.settings, $584)) $583[$584] = st["settings"][$584];
                                $583.xscale = v2.value0;
                                return $583;
                            }();
                            return $586;
                        }))(function() {
                            return redrawScore1;
                        });
                        throw new Error("Failed pattern match at Main (line 298, column 20 - line 302, column 20): " + [
                            v2.constructor.name
                        ]);
                    }
                    if (v1 instanceof $f1eb673e64bdc463$export$8a710b6e46000772) {
                        var v2 = $052de1c85deb22bf$export$3004f64547af360e(v1.value0);
                        if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $0c07a74dd7e350c8$var$pure1($05149ea687d6b460$export$523c0b569236b342);
                        if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $0c07a74dd7e350c8$var$discard1($0c07a74dd7e350c8$var$modify_(function(st) {
                            var $595 = {};
                            for(var $596 in st)if (({}).hasOwnProperty.call(st, $596)) $595[$596] = st[$596];
                            $595.settings = function() {
                                var $592 = {};
                                for(var $593 in st.settings)if (({}).hasOwnProperty.call(st.settings, $593)) $592[$593] = st["settings"][$593];
                                $592.yscale = v2.value0;
                                return $592;
                            }();
                            return $595;
                        }))(function() {
                            return redrawScore1;
                        });
                        throw new Error("Failed pattern match at Main (line 303, column 20 - line 307, column 20): " + [
                            v2.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Main (line 266, column 18 - line 307, column 20): " + [
                        v1.constructor.name
                    ]);
                };
                return $eea39ea934373596$export$3bb93a8213d3ef21({
                    initialState: initialState,
                    render: render,
                    "eval": $eea39ea934373596$export$9eef9effff68b10a({
                        handleQuery: $eea39ea934373596$export$cb95887a94082d64.handleQuery,
                        receive: $eea39ea934373596$export$cb95887a94082d64.receive,
                        finalize: $eea39ea934373596$export$cb95887a94082d64.finalize,
                        handleAction: handleAction,
                        initialize: new $06733ae99ed4f534$export$8a67b48435b5d073($f1eb673e64bdc463$export$d050db8f6426404e.value)
                    })
                });
            };
        };
    };
};
var $0c07a74dd7e350c8$var$viewerComponent1 = /* #__PURE__ */ $0c07a74dd7e350c8$export$b3a8ec9ca4dfb8f7($edf0339512807bee$export$666a030cecdf96c)($b6d6cce78665f23d$export$bd75e69808ef8e57);
var $0c07a74dd7e350c8$export$bfb49978079b898d = function(eltSelector) {
    return function(json) {
        return function(opts) {
            return function __do() {
                var pfx = $0c07a74dd7e350c8$var$map($0c07a74dd7e350c8$var$show2)($12b21e1b0d841cdb$export$4385e60b38654f68)();
                var settings = $f1eb673e64bdc463$export$78af9b5fc65e58de(opts);
                var subscription = $8360250a454b77aa$export$185802fd694ee1f5();
                return $deee5b6018c98796$export$1b79e4d7fc8e4817($0c07a74dd7e350c8$var$discard2($deee5b6018c98796$export$11dc33decdfc25c9)(function() {
                    return $0c07a74dd7e350c8$var$bind3($deee5b6018c98796$export$895e5c0dd54cd456(eltSelector))(function(elt) {
                        return $0c07a74dd7e350c8$var$for_(elt)($80d0fbcfdca571e1$export$32d31a833a940d1c($0c07a74dd7e350c8$var$viewerComponent1(pfx)(subscription))({
                            json: json,
                            settings: settings
                        }));
                    });
                }))();
            };
        };
    };
};
var $0c07a74dd7e350c8$export$a7848d518678d667 = /* #__PURE__ */ $28d793bcad7b6401$export$1329fa30c595aae1($0c07a74dd7e350c8$export$bfb49978079b898d);


function $876941026dd0eeca$var$selectFile() {
    const file = this.files[0];
    // clear target div
    document.getElementById("widget").innerHTML = "";
    // load file and create viewer widget
    file.text().then((json)=>$0c07a74dd7e350c8$export$a7848d518678d667("#widget", json));
}
document.getElementById("file-upload").addEventListener("change", $876941026dd0eeca$var$selectFile, false);


//# sourceMappingURL=index.2e95a25b.js.map
